webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/**
 * @module zrender/core/util
 */
// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT = {
  '[object Function]': 1,
  '[object RegExp]': 1,
  '[object Date]': 1,
  '[object Error]': 1,
  '[object CanvasGradient]': 1,
  '[object CanvasPattern]': 1,
  // For node-canvas
  '[object Image]': 1,
  '[object Canvas]': 1
};
var TYPED_ARRAY = {
  '[object Int8Array]': 1,
  '[object Uint8Array]': 1,
  '[object Uint8ClampedArray]': 1,
  '[object Int16Array]': 1,
  '[object Uint16Array]': 1,
  '[object Int32Array]': 1,
  '[object Uint32Array]': 1,
  '[object Float32Array]': 1,
  '[object Float64Array]': 1
};
var objToString = Object.prototype.toString;
var arrayProto = Array.prototype;
var nativeForEach = arrayProto.forEach;
var nativeFilter = arrayProto.filter;
var nativeSlice = arrayProto.slice;
var nativeMap = arrayProto.map;
var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */


function clone(source) {
  if (source == null || typeof source != 'object') {
    return source;
  }

  var result = source;
  var typeStr = objToString.call(source);

  if (typeStr === '[object Array]') {
    result = [];

    for (var i = 0, len = source.length; i < len; i++) {
      result[i] = clone(source[i]);
    }
  } else if (TYPED_ARRAY[typeStr]) {
    var Ctor = source.constructor;

    if (source.constructor.from) {
      result = Ctor.from(source);
    } else {
      result = new Ctor(source.length);

      for (var i = 0, len = source.length; i < len; i++) {
        result[i] = clone(source[i]);
      }
    }
  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
    result = {};

    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = clone(source[key]);
      }
    }
  }

  return result;
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */


function merge(target, source, overwrite) {
  // We should escapse that source is string
  // and enter for ... in ...
  if (!isObject(source) || !isObject(target)) {
    return overwrite ? clone(source) : target;
  }

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      var targetProp = target[key];
      var sourceProp = source[key];

      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
        // 如果需要递归覆盖，就递归调用merge
        merge(targetProp, sourceProp, overwrite);
      } else if (overwrite || !(key in target)) {
        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = clone(source[key], true);
      }
    }
  }

  return target;
}
/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */


function mergeAll(targetAndSources, overwrite) {
  var result = targetAndSources[0];

  for (var i = 1, len = targetAndSources.length; i < len; i++) {
    result = merge(result, targetAndSources[i], overwrite);
  }

  return result;
}
/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */


function extend(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */


function defaults(target, source, overlay) {
  for (var key in source) {
    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
      target[key] = source[key];
    }
  }

  return target;
}

var createCanvas = function () {
  return methods.createCanvas();
};

methods.createCanvas = function () {
  return document.createElement('canvas');
}; // FIXME


var _ctx;

function getContext() {
  if (!_ctx) {
    // Use util.createCanvas instead of createCanvas
    // because createCanvas may be overwritten in different environment
    _ctx = createCanvas().getContext('2d');
  }

  return _ctx;
}
/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */


function indexOf(array, value) {
  if (array) {
    if (array.indexOf) {
      return array.indexOf(value);
    }

    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === value) {
        return i;
      }
    }
  }

  return -1;
}
/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */


function inherits(clazz, baseClazz) {
  var clazzPrototype = clazz.prototype;

  function F() {}

  F.prototype = baseClazz.prototype;
  clazz.prototype = new F();

  for (var prop in clazzPrototype) {
    clazz.prototype[prop] = clazzPrototype[prop];
  }

  clazz.prototype.constructor = clazz;
  clazz.superClass = baseClazz;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */


function mixin(target, source, overlay) {
  target = 'prototype' in target ? target.prototype : target;
  source = 'prototype' in source ? source.prototype : source;
  defaults(target, source, overlay);
}
/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */


function isArrayLike(data) {
  if (!data) {
    return;
  }

  if (typeof data == 'string') {
    return false;
  }

  return typeof data.length == 'number';
}
/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */


function each(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.forEach && obj.forEach === nativeForEach) {
    obj.forEach(cb, context);
  } else if (obj.length === +obj.length) {
    for (var i = 0, len = obj.length; i < len; i++) {
      cb.call(context, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        cb.call(context, obj[key], key, obj);
      }
    }
  }
}
/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function map(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.map && obj.map === nativeMap) {
    return obj.map(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      result.push(cb.call(context, obj[i], i, obj));
    }

    return result;
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */


function reduce(obj, cb, memo, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.reduce && obj.reduce === nativeReduce) {
    return obj.reduce(cb, memo, context);
  } else {
    for (var i = 0, len = obj.length; i < len; i++) {
      memo = cb.call(context, memo, obj[i], i, obj);
    }

    return memo;
  }
}
/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function filter(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.filter && obj.filter === nativeFilter) {
    return obj.filter(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      if (cb.call(context, obj[i], i, obj)) {
        result.push(obj[i]);
      }
    }

    return result;
  }
}
/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */


function find(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  for (var i = 0, len = obj.length; i < len; i++) {
    if (cb.call(context, obj[i], i, obj)) {
      return obj[i];
    }
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */


function bind(func, context) {
  var args = nativeSlice.call(arguments, 2);
  return function () {
    return func.apply(context, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */


function curry(func) {
  var args = nativeSlice.call(arguments, 1);
  return function () {
    return func.apply(this, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isArray(value) {
  return objToString.call(value) === '[object Array]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isString(value) {
  return objToString.call(value) === '[object String]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return type === 'function' || !!value && type == 'object';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isBuiltInObject(value) {
  return !!BUILTIN_OBJECT[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isDom(value) {
  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */


function eqNaN(value) {
  return value !== value;
}
/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */


function retrieve(values) {
  for (var i = 0, len = arguments.length; i < len; i++) {
    if (arguments[i] != null) {
      return arguments[i];
    }
  }
}

function retrieve2(value0, value1) {
  return value0 != null ? value0 : value1;
}

function retrieve3(value0, value1, value2) {
  return value0 != null ? value0 : value1 != null ? value1 : value2;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */


function slice() {
  return Function.call.apply(nativeSlice, arguments);
}
/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */


function normalizeCssArray(val) {
  if (typeof val === 'number') {
    return [val, val, val, val];
  }

  var len = val.length;

  if (len === 2) {
    // vertical | horizontal
    return [val[0], val[1], val[0], val[1]];
  } else if (len === 3) {
    // top | horizontal | bottom
    return [val[0], val[1], val[2], val[1]];
  }

  return val;
}
/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */


function assert(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var primitiveKey = '__ec_primitive__';
/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */

function setAsPrimitive(obj) {
  obj[primitiveKey] = true;
}

function isPrimitive(obj) {
  return obj[primitiveKey];
}
/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */


function HashMap(obj) {
  obj && each(obj, function (value, key) {
    this.set(key, value);
  }, this);
} // Add prefix to avoid conflict with Object.prototype.


var HASH_MAP_PREFIX = '_ec_';
var HASH_MAP_PREFIX_LENGTH = 4;
HashMap.prototype = {
  constructor: HashMap,
  // Do not provide `has` method to avoid defining what is `has`.
  // (We usually treat `null` and `undefined` as the same, different
  // from ES6 Map).
  get: function (key) {
    return this[HASH_MAP_PREFIX + key];
  },
  set: function (key, value) {
    this[HASH_MAP_PREFIX + key] = value; // Comparing with invocation chaining, `return value` is more commonly
    // used in this case: `var someVal = map.set('a', genVal());`

    return value;
  },
  // Although util.each can be performed on this hashMap directly, user
  // should not use the exposed keys, who are prefixed.
  each: function (cb, context) {
    context !== void 0 && (cb = bind(cb, context));

    for (var prefixedKey in this) {
      this.hasOwnProperty(prefixedKey) && cb(this[prefixedKey], prefixedKey.slice(HASH_MAP_PREFIX_LENGTH));
    }
  },
  // Do not use this method if performance sensitive.
  removeKey: function (key) {
    delete this[HASH_MAP_PREFIX + key];
  }
};

function createHashMap(obj) {
  return new HashMap(obj);
}

function noop() {}

exports.$override = $override;
exports.clone = clone;
exports.merge = merge;
exports.mergeAll = mergeAll;
exports.extend = extend;
exports.defaults = defaults;
exports.createCanvas = createCanvas;
exports.getContext = getContext;
exports.indexOf = indexOf;
exports.inherits = inherits;
exports.mixin = mixin;
exports.isArrayLike = isArrayLike;
exports.each = each;
exports.map = map;
exports.reduce = reduce;
exports.filter = filter;
exports.find = find;
exports.bind = bind;
exports.curry = curry;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports.isString = isString;
exports.isObject = isObject;
exports.isBuiltInObject = isBuiltInObject;
exports.isDom = isDom;
exports.eqNaN = eqNaN;
exports.retrieve = retrieve;
exports.retrieve2 = retrieve2;
exports.retrieve3 = retrieve3;
exports.slice = slice;
exports.normalizeCssArray = normalizeCssArray;
exports.assert = assert;
exports.setAsPrimitive = setAsPrimitive;
exports.isPrimitive = isPrimitive;
exports.createHashMap = createHashMap;
exports.noop = noop;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(61);
var hide = __webpack_require__(43);
var redefine = __webpack_require__(44);
var ctx = __webpack_require__(56);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1762)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The main AWS namespace
 */
var AWS = { util: __webpack_require__(28) };

/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */
var _hidden = {}; _hidden.toString(); // hack to parse macro

module.exports = AWS;

AWS.util.update(AWS, {

  /**
   * @constant
   */
  VERSION: '2.138.0',

  /**
   * @api private
   */
  Signers: {},

  /**
   * @api private
   */
  Protocol: {
    Json: __webpack_require__(223),
    Query: __webpack_require__(365),
    Rest: __webpack_require__(157),
    RestJson: __webpack_require__(366),
    RestXml: __webpack_require__(367)
  },

  /**
   * @api private
   */
  XML: {
    Builder: __webpack_require__(1030),
    Parser: null // conditionally set based on environment
  },

  /**
   * @api private
   */
  JSON: {
    Builder: __webpack_require__(221),
    Parser: __webpack_require__(222)
  },

  /**
   * @api private
   */
  Model: {
    Api: __webpack_require__(360),
    Operation: __webpack_require__(362),
    Shape: __webpack_require__(129),
    Paginator: __webpack_require__(363),
    ResourceWaiter: __webpack_require__(364)
  },

  /**
   * @api private
   */
  apiLoader: __webpack_require__(983)
});

__webpack_require__(1007);
__webpack_require__(986);

__webpack_require__(359);
__webpack_require__(368);
__webpack_require__(995);
__webpack_require__(1003);
__webpack_require__(1005);
__webpack_require__(1004);
__webpack_require__(1023);
__webpack_require__(997);

/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */
AWS.events = new AWS.SequentialExecutor();


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrender = __webpack_require__(215);

var zrUtil = __webpack_require__(0);

var colorTool = __webpack_require__(78);

var env = __webpack_require__(33);

var timsort = __webpack_require__(321);

var Eventful = __webpack_require__(108);

var GlobalModel = __webpack_require__(1602);

var ExtensionAPI = __webpack_require__(1366);

var CoordinateSystemManager = __webpack_require__(66);

var OptionManager = __webpack_require__(1603);

var backwardCompat = __webpack_require__(1610);

var ComponentModel = __webpack_require__(32);

var SeriesModel = __webpack_require__(35);

var ComponentView = __webpack_require__(286);

var ChartView = __webpack_require__(87);

var graphic = __webpack_require__(5);

var modelUtil = __webpack_require__(15);

var _throttle = __webpack_require__(104);

var throttle = _throttle.throttle;

var seriesColor = __webpack_require__(1617);

var loadingDefault = __webpack_require__(1601);

/*!
 * ECharts, a javascript interactive chart library.
 *
 * Copyright (c) 2015, Baidu Inc.
 * All rights reserved.
 *
 * LICENSE
 * https://github.com/ecomfe/echarts/blob/master/LICENSE.txt
 */
var each = zrUtil.each;
var parseClassType = ComponentModel.parseClassType;
var version = '3.8.5';
var dependencies = {
  zrender: '3.7.4'
};
var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
// necessary?

var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS = '__flagInMainProcess';
var HAS_GRADIENT_OR_PATTERN_BG = '__hasGradientOrPatternBg';
var OPTION_UPDATED = '__optionUpdated';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;

function createRegisterEventWithLowercaseName(method) {
  return function (eventName, handler, context) {
    // Event name is all lowercase
    eventName = eventName && eventName.toLowerCase();
    Eventful.prototype[method].call(this, eventName, handler, context);
  };
}
/**
 * @module echarts~MessageCenter
 */


function MessageCenter() {
  Eventful.call(this);
}

MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on');
MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off');
MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one');
zrUtil.mixin(MessageCenter, Eventful);
/**
 * @module echarts~ECharts
 */

function ECharts(dom, theme, opts) {
  opts = opts || {}; // Get theme by name

  if (typeof theme === 'string') {
    theme = themeStorage[theme];
  }
  /**
   * @type {string}
   */


  this.id;
  /**
   * Group id
   * @type {string}
   */

  this.group;
  /**
   * @type {HTMLElement}
   * @private
   */

  this._dom = dom;
  var defaultRenderer = 'canvas';

  /**
   * @type {module:zrender/ZRender}
   * @private
   */
  var zr = this._zr = zrender.init(dom, {
    renderer: opts.renderer || defaultRenderer,
    devicePixelRatio: opts.devicePixelRatio,
    width: opts.width,
    height: opts.height
  });
  /**
   * Expect 60 pfs.
   * @type {Function}
   * @private
   */

  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
  var theme = zrUtil.clone(theme);
  theme && backwardCompat(theme, true);
  /**
   * @type {Object}
   * @private
   */

  this._theme = theme;
  /**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */

  this._chartsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */

  this._chartsMap = {};
  /**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */

  this._componentsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */

  this._componentsMap = {};
  /**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */

  this._coordSysMgr = new CoordinateSystemManager();
  /**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */

  this._api = createExtensionAPI(this);
  Eventful.call(this);
  /**
   * @type {module:echarts~MessageCenter}
   * @private
   */

  this._messageCenter = new MessageCenter(); // Init mouse events

  this._initEvents(); // In case some people write `window.onresize = chart.resize`


  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure

  this._pendingActions = []; // Sort on demand

  function prioritySortFunc(a, b) {
    return a.prio - b.prio;
  }

  timsort(visualFuncs, prioritySortFunc);
  timsort(dataProcessorFuncs, prioritySortFunc);
  zr.animation.on('frame', this._onframe, this); // ECharts instance can be used as value.

  zrUtil.setAsPrimitive(this);
}

var echartsProto = ECharts.prototype;

echartsProto._onframe = function () {
  // Lazy update
  if (this[OPTION_UPDATED]) {
    var silent = this[OPTION_UPDATED].silent;
    this[IN_MAIN_PROCESS] = true;
    updateMethods.prepareAndUpdate.call(this);
    this[IN_MAIN_PROCESS] = false;
    this[OPTION_UPDATED] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @return {HTMLElement}
 */


echartsProto.getDom = function () {
  return this._dom;
};
/**
 * @return {module:zrender~ZRender}
 */


echartsProto.getZr = function () {
  return this._zr;
};
/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */


echartsProto.setOption = function (option, notMerge, lazyUpdate) {
  var silent;

  if (zrUtil.isObject(notMerge)) {
    lazyUpdate = notMerge.lazyUpdate;
    silent = notMerge.silent;
    notMerge = notMerge.notMerge;
  }

  this[IN_MAIN_PROCESS] = true;

  if (!this._model || notMerge) {
    var optionManager = new OptionManager(this._api);
    var theme = this._theme;
    var ecModel = this._model = new GlobalModel(null, null, theme, optionManager);
    ecModel.init(null, null, theme, optionManager);
  }

  this._model.setOption(option, optionPreprocessorFuncs);

  if (lazyUpdate) {
    this[OPTION_UPDATED] = {
      silent: silent
    };
    this[IN_MAIN_PROCESS] = false;
  } else {
    updateMethods.prepareAndUpdate.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
    // fetched after `setOption`.

    this._zr.flush();

    this[OPTION_UPDATED] = false;
    this[IN_MAIN_PROCESS] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @DEPRECATED
 */


echartsProto.setTheme = function () {
  console.log('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
};
/**
 * @return {module:echarts/model/Global}
 */


echartsProto.getModel = function () {
  return this._model;
};
/**
 * @return {Object}
 */


echartsProto.getOption = function () {
  return this._model && this._model.getOption();
};
/**
 * @return {number}
 */


echartsProto.getWidth = function () {
  return this._zr.getWidth();
};
/**
 * @return {number}
 */


echartsProto.getHeight = function () {
  return this._zr.getHeight();
};
/**
 * @return {number}
 */


echartsProto.getDevicePixelRatio = function () {
  return this._zr.painter.dpr || window.devicePixelRatio || 1;
};
/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */


echartsProto.getRenderedCanvas = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  opts = opts || {};
  opts.pixelRatio = opts.pixelRatio || 1;
  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.getRenderedCanvas(opts);
};
/**
 * Get svg data url
 * @return {string}
 */


echartsProto.getSvgDataUrl = function () {
  if (!env.svgSupported) {
    return;
  }

  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.pathToSvg();
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */


echartsProto.getDataURL = function (opts) {
  opts = opts || {};
  var excludeComponents = opts.excludeComponents;
  var ecModel = this._model;
  var excludesComponentViews = [];
  var self = this;
  each(excludeComponents, function (componentType) {
    ecModel.eachComponent({
      mainType: componentType
    }, function (component) {
      var view = self._componentsMap[component.__viewId];

      if (!view.group.ignore) {
        excludesComponentViews.push(view);
        view.group.ignore = true;
      }
    });
  });
  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataUrl() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
  each(excludesComponentViews, function (view) {
    view.group.ignore = false;
  });
  return url;
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */


echartsProto.getConnectedDataURL = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  var groupId = this.group;
  var mathMin = Math.min;
  var mathMax = Math.max;
  var MAX_NUMBER = Infinity;

  if (connectedGroups[groupId]) {
    var left = MAX_NUMBER;
    var top = MAX_NUMBER;
    var right = -MAX_NUMBER;
    var bottom = -MAX_NUMBER;
    var canvasList = [];
    var dpr = opts && opts.pixelRatio || 1;
    zrUtil.each(instances, function (chart, id) {
      if (chart.group === groupId) {
        var canvas = chart.getRenderedCanvas(zrUtil.clone(opts));
        var boundingRect = chart.getDom().getBoundingClientRect();
        left = mathMin(boundingRect.left, left);
        top = mathMin(boundingRect.top, top);
        right = mathMax(boundingRect.right, right);
        bottom = mathMax(boundingRect.bottom, bottom);
        canvasList.push({
          dom: canvas,
          left: boundingRect.left,
          top: boundingRect.top
        });
      }
    });
    left *= dpr;
    top *= dpr;
    right *= dpr;
    bottom *= dpr;
    var width = right - left;
    var height = bottom - top;
    var targetCanvas = zrUtil.createCanvas();
    targetCanvas.width = width;
    targetCanvas.height = height;
    var zr = zrender.init(targetCanvas);
    each(canvasList, function (item) {
      var img = new graphic.Image({
        style: {
          x: item.left * dpr - left,
          y: item.top * dpr - top,
          image: item.dom
        }
      });
      zr.add(img);
    });
    zr.refreshImmediately();
    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
  } else {
    return this.getDataURL(opts);
  }
};
/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */


echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */

echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');

function doConvertPixel(methodName, finder, value) {
  var ecModel = this._model;

  var coordSysList = this._coordSysMgr.getCoordinateSystems();

  var result;
  finder = modelUtil.parseFinder(ecModel, finder);

  for (var i = 0; i < coordSysList.length; i++) {
    var coordSys = coordSysList[i];

    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
      return result;
    }
  }
}
/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */


echartsProto.containPixel = function (finder, value) {
  var ecModel = this._model;
  var result;
  finder = modelUtil.parseFinder(ecModel, finder);
  zrUtil.each(finder, function (models, key) {
    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
      var coordSys = model.coordinateSystem;

      if (coordSys && coordSys.containPoint) {
        result |= !!coordSys.containPoint(value);
      } else if (key === 'seriesModels') {
        var view = this._chartsMap[model.__viewId];

        if (view && view.containPoint) {
          result |= view.containPoint(value, model);
        } else {}
      } else {}
    }, this);
  }, this);
  return !!result;
};
/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */


echartsProto.getVisual = function (finder, visualType) {
  var ecModel = this._model;
  finder = modelUtil.parseFinder(ecModel, finder, {
    defaultMainType: 'series'
  });
  var seriesModel = finder.seriesModel;
  var data = seriesModel.getData();
  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
};
/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */


echartsProto.getViewOfComponentModel = function (componentModel) {
  return this._componentsMap[componentModel.__viewId];
};
/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */


echartsProto.getViewOfSeriesModel = function (seriesModel) {
  return this._chartsMap[seriesModel.__viewId];
};

var updateMethods = {
  /**
   * @param {Object} payload
   * @private
   */
  update: function (payload) {
    // console.profile && console.profile('update');
    var ecModel = this._model;
    var api = this._api;
    var coordSysMgr = this._coordSysMgr;
    var zr = this._zr; // update before setOption

    if (!ecModel) {
      return;
    } // Fixme First time update ?


    ecModel.restoreData(); // TODO
    // Save total ecModel here for undo/redo (after restoring data and before processing data).
    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
    // Create new coordinate system each update
    // In LineView may save the old coordinate system and use it to get the orignal point

    coordSysMgr.create(this._model, this._api);
    processData.call(this, ecModel, api);
    stackSeriesData.call(this, ecModel);
    coordSysMgr.update(ecModel, api);
    doVisualEncoding.call(this, ecModel, payload);
    doRender.call(this, ecModel, payload); // Set background

    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
    var painter = zr.painter; // TODO all use clearColor ?

    if (painter.isSingleCanvas && painter.isSingleCanvas()) {
      zr.configLayer(0, {
        clearColor: backgroundColor
      });
    } else {
      // In IE8
      if (!env.canvasSupported) {
        var colorArr = colorTool.parse(backgroundColor);
        backgroundColor = colorTool.stringify(colorArr, 'rgb');

        if (colorArr[3] === 0) {
          backgroundColor = 'transparent';
        }
      }

      if (backgroundColor.colorStops || backgroundColor.image) {
        // Gradient background
        // FIXME Fixed layer？
        zr.configLayer(0, {
          clearColor: backgroundColor
        });
        this[HAS_GRADIENT_OR_PATTERN_BG] = true;
        this._dom.style.background = 'transparent';
      } else {
        if (this[HAS_GRADIENT_OR_PATTERN_BG]) {
          zr.configLayer(0, {
            clearColor: null
          });
        }

        this[HAS_GRADIENT_OR_PATTERN_BG] = false;
        this._dom.style.background = backgroundColor;
      }
    }

    each(postUpdateFuncs, function (func) {
      func(ecModel, api);
    }); // console.profile && console.profileEnd('update');
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateView: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ecModel.eachSeries(function (seriesModel) {
      seriesModel.getData().clearAllVisual();
    });
    doVisualEncoding.call(this, ecModel, payload);
    invokeUpdateMethod.call(this, 'updateView', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateVisual: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ecModel.eachSeries(function (seriesModel) {
      seriesModel.getData().clearAllVisual();
    });
    doVisualEncoding.call(this, ecModel, payload, true);
    invokeUpdateMethod.call(this, 'updateVisual', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateLayout: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    doLayout.call(this, ecModel, payload);
    invokeUpdateMethod.call(this, 'updateLayout', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  prepareAndUpdate: function (payload) {
    var ecModel = this._model;
    prepareView.call(this, 'component', ecModel);
    prepareView.call(this, 'chart', ecModel);
    updateMethods.update.call(this, payload);
  }
};
/**
 * @private
 */

function updateDirectly(ecIns, method, payload, mainType, subType) {
  var ecModel = ecIns._model; // broadcast

  if (!mainType) {
    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
    return;
  }

  var query = {};
  query[mainType + 'Id'] = payload[mainType + 'Id'];
  query[mainType + 'Index'] = payload[mainType + 'Index'];
  query[mainType + 'Name'] = payload[mainType + 'Name'];
  var condition = {
    mainType: mainType,
    query: query
  };
  subType && (condition.subType = subType); // subType may be '' by parseClassType;
  // If dispatchAction before setOption, do nothing.

  ecModel && ecModel.eachComponent(condition, function (model, index) {
    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
  }, ecIns);

  function callView(view) {
    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
  }
}
/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */


echartsProto.resize = function (opts) {
  this[IN_MAIN_PROCESS] = true;

  this._zr.resize(opts);

  var optionChanged = this._model && this._model.resetOption('media');

  var updateMethod = optionChanged ? 'prepareAndUpdate' : 'update';
  updateMethods[updateMethod].call(this); // Resize loading effect

  this._loadingFX && this._loadingFX.resize();
  this[IN_MAIN_PROCESS] = false;
  var silent = opts && opts.silent;
  flushPendingActions.call(this, silent);
  triggerUpdatedEvent.call(this, silent);
};
/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */


echartsProto.showLoading = function (name, cfg) {
  if (zrUtil.isObject(name)) {
    cfg = name;
    name = '';
  }

  name = name || 'default';
  this.hideLoading();

  if (!loadingEffects[name]) {
    return;
  }

  var el = loadingEffects[name](this._api, cfg);
  var zr = this._zr;
  this._loadingFX = el;
  zr.add(el);
};
/**
 * Hide loading effect
 */


echartsProto.hideLoading = function () {
  this._loadingFX && this._zr.remove(this._loadingFX);
  this._loadingFX = null;
};
/**
 * @param {Object} eventObj
 * @return {Object}
 */


echartsProto.makeActionFromEvent = function (eventObj) {
  var payload = zrUtil.extend({}, eventObj);
  payload.type = eventActionMap[eventObj.type];
  return payload;
};
/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not not flush.
 *                  undefined: Auto decide whether perform flush.
 */


echartsProto.dispatchAction = function (payload, opt) {
  if (!zrUtil.isObject(opt)) {
    opt = {
      silent: !!opt
    };
  }

  if (!actions[payload.type]) {
    return;
  } // Avoid dispatch action before setOption. Especially in `connect`.


  if (!this._model) {
    return;
  } // May dispatchAction in rendering procedure


  if (this[IN_MAIN_PROCESS]) {
    this._pendingActions.push(payload);

    return;
  }

  doDispatchAction.call(this, payload, opt.silent);

  if (opt.flush) {
    this._zr.flush(true);
  } else if (opt.flush !== false && env.browser.weChat) {
    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
    // hang when sliding page (on touch event), which cause that zr does not
    // refresh util user interaction finished, which is not expected.
    // But `dispatchAction` may be called too frequently when pan on touch
    // screen, which impacts performance if do not throttle them.
    this._throttledZrFlush();
  }

  flushPendingActions.call(this, opt.silent);
  triggerUpdatedEvent.call(this, opt.silent);
};

function doDispatchAction(payload, silent) {
  var payloadType = payload.type;
  var escapeConnect = payload.escapeConnect;
  var actionWrap = actions[payloadType];
  var actionInfo = actionWrap.actionInfo;
  var cptType = (actionInfo.update || 'update').split(':');
  var updateMethod = cptType.pop();
  cptType = cptType[0] != null && parseClassType(cptType[0]);
  this[IN_MAIN_PROCESS] = true;
  var payloads = [payload];
  var batched = false; // Batch action

  if (payload.batch) {
    batched = true;
    payloads = zrUtil.map(payload.batch, function (item) {
      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
      item.batch = null;
      return item;
    });
  }

  var eventObjBatch = [];
  var eventObj;
  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
  each(payloads, function (batchItem) {
    // Action can specify the event by return it.
    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside

    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType

    eventObj.type = actionInfo.event || eventObj.type;
    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

    if (isHighDown) {
      // method, payload, mainType, subType
      updateDirectly(this, updateMethod, batchItem, 'series');
    } else if (cptType) {
      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
    }
  }, this);

  if (updateMethod !== 'none' && !isHighDown && !cptType) {
    // Still dirty
    if (this[OPTION_UPDATED]) {
      // FIXME Pass payload ?
      updateMethods.prepareAndUpdate.call(this, payload);
      this[OPTION_UPDATED] = false;
    } else {
      updateMethods[updateMethod].call(this, payload);
    }
  } // Follow the rule of action batch


  if (batched) {
    eventObj = {
      type: actionInfo.event || payloadType,
      escapeConnect: escapeConnect,
      batch: eventObjBatch
    };
  } else {
    eventObj = eventObjBatch[0];
  }

  this[IN_MAIN_PROCESS] = false;
  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
}

function flushPendingActions(silent) {
  var pendingActions = this._pendingActions;

  while (pendingActions.length) {
    var payload = pendingActions.shift();
    doDispatchAction.call(this, payload, silent);
  }
}

function triggerUpdatedEvent(silent) {
  !silent && this.trigger('updated');
}
/**
 * Register event
 * @method
 */


echartsProto.on = createRegisterEventWithLowercaseName('on');
echartsProto.off = createRegisterEventWithLowercaseName('off');
echartsProto.one = createRegisterEventWithLowercaseName('one');
/**
 * @param {string} methodName
 * @private
 */

function invokeUpdateMethod(methodName, ecModel, payload) {
  var api = this._api; // Update all components

  each(this._componentsViews, function (component) {
    var componentModel = component.__model;
    component[methodName](componentModel, ecModel, api, payload);
    updateZ(componentModel, component);
  }, this); // Upate all charts

  ecModel.eachSeries(function (seriesModel, idx) {
    var chart = this._chartsMap[seriesModel.__viewId];
    chart[methodName](seriesModel, ecModel, api, payload);
    updateZ(seriesModel, chart);
    updateProgressiveAndBlend(seriesModel, chart);
  }, this); // If use hover layer

  updateHoverLayerStatus(this._zr, ecModel); // Post render

  each(postUpdateFuncs, function (func) {
    func(ecModel, api);
  });
}
/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */


function prepareView(type, ecModel) {
  var isComponent = type === 'component';
  var viewList = isComponent ? this._componentsViews : this._chartsViews;
  var viewMap = isComponent ? this._componentsMap : this._chartsMap;
  var zr = this._zr;

  for (var i = 0; i < viewList.length; i++) {
    viewList[i].__alive = false;
  }

  ecModel[isComponent ? 'eachComponent' : 'eachSeries'](function (componentType, model) {
    if (isComponent) {
      if (componentType === 'series') {
        return;
      }
    } else {
      model = componentType;
    } // Consider: id same and type changed.


    var viewId = '_ec_' + model.id + '_' + model.type;
    var view = viewMap[viewId];

    if (!view) {
      var classType = parseClassType(model.type);
      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);

      if (Clazz) {
        view = new Clazz();
        view.init(ecModel, this._api);
        viewMap[viewId] = view;
        viewList.push(view);
        zr.add(view.group);
      } else {
        // Error
        return;
      }
    }

    model.__viewId = view.__id = viewId;
    view.__alive = true;
    view.__model = model;
    view.group.__ecComponentInfo = {
      mainType: model.mainType,
      index: model.componentIndex
    };
  }, this);

  for (var i = 0; i < viewList.length;) {
    var view = viewList[i];

    if (!view.__alive) {
      zr.remove(view.group);
      view.dispose(ecModel, this._api);
      viewList.splice(i, 1);
      delete viewMap[view.__id];
      view.__id = view.group.__ecComponentInfo = null;
    } else {
      i++;
    }
  }
}
/**
 * Processor data in each series
 *
 * @param {module:echarts/model/Global} ecModel
 * @private
 */


function processData(ecModel, api) {
  each(dataProcessorFuncs, function (process) {
    process.func(ecModel, api);
  });
}
/**
 * @private
 */


function stackSeriesData(ecModel) {
  var stackedDataMap = {};
  ecModel.eachSeries(function (series) {
    var stack = series.get('stack');
    var data = series.getData();

    if (stack && data.type === 'list') {
      var previousStack = stackedDataMap[stack]; // Avoid conflict with Object.prototype

      if (stackedDataMap.hasOwnProperty(stack) && previousStack) {
        data.stackedOn = previousStack;
      }

      stackedDataMap[stack] = data;
    }
  });
}
/**
 * Layout before each chart render there series, special visual encoding stage
 *
 * @param {module:echarts/model/Global} ecModel
 * @private
 */


function doLayout(ecModel, payload) {
  var api = this._api;
  each(visualFuncs, function (visual) {
    if (visual.isLayout) {
      visual.func(ecModel, api, payload);
    }
  });
}
/**
 * Encode visual infomation from data after data processing
 *
 * @param {module:echarts/model/Global} ecModel
 * @param {object} layout
 * @param {boolean} [excludesLayout]
 * @private
 */


function doVisualEncoding(ecModel, payload, excludesLayout) {
  var api = this._api;
  ecModel.clearColorPalette();
  ecModel.eachSeries(function (seriesModel) {
    seriesModel.clearColorPalette();
  });
  each(visualFuncs, function (visual) {
    (!excludesLayout || !visual.isLayout) && visual.func(ecModel, api, payload);
  });
}
/**
 * Render each chart and component
 * @private
 */


function doRender(ecModel, payload) {
  var api = this._api; // Render all components

  each(this._componentsViews, function (componentView) {
    var componentModel = componentView.__model;
    componentView.render(componentModel, ecModel, api, payload);
    updateZ(componentModel, componentView);
  }, this);
  each(this._chartsViews, function (chart) {
    chart.__alive = false;
  }, this); // Render all charts

  ecModel.eachSeries(function (seriesModel, idx) {
    var chartView = this._chartsMap[seriesModel.__viewId];
    chartView.__alive = true;
    chartView.render(seriesModel, ecModel, api, payload);
    chartView.group.silent = !!seriesModel.get('silent');
    updateZ(seriesModel, chartView);
    updateProgressiveAndBlend(seriesModel, chartView);
  }, this); // If use hover layer

  updateHoverLayerStatus(this._zr, ecModel); // Remove groups of unrendered charts

  each(this._chartsViews, function (chart) {
    if (!chart.__alive) {
      chart.remove(ecModel, api);
    }
  }, this);
}

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
/**
 * @private
 */

echartsProto._initEvents = function () {
  each(MOUSE_EVENT_NAMES, function (eveName) {
    this._zr.on(eveName, function (e) {
      var ecModel = this.getModel();
      var el = e.target;
      var params; // no e.target when 'globalout'.

      if (eveName === 'globalout') {
        params = {};
      } else if (el && el.dataIndex != null) {
        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType) || {};
      } // If element has custom eventData of components
      else if (el && el.eventData) {
          params = zrUtil.extend({}, el.eventData);
        }

      if (params) {
        params.event = e;
        params.type = eveName;
        this.trigger(eveName, params);
      }
    }, this);
  }, this);
  each(eventActionMap, function (actionType, eventType) {
    this._messageCenter.on(eventType, function (event) {
      this.trigger(eventType, event);
    }, this);
  }, this);
};
/**
 * @return {boolean}
 */


echartsProto.isDisposed = function () {
  return this._disposed;
};
/**
 * Clear
 */


echartsProto.clear = function () {
  this.setOption({
    series: []
  }, true);
};
/**
 * Dispose instance
 */


echartsProto.dispose = function () {
  if (this._disposed) {
    return;
  }

  this._disposed = true;
  var api = this._api;
  var ecModel = this._model;
  each(this._componentsViews, function (component) {
    component.dispose(ecModel, api);
  });
  each(this._chartsViews, function (chart) {
    chart.dispose(ecModel, api);
  }); // Dispose after all views disposed

  this._zr.dispose();

  delete instances[this.id];
};

zrUtil.mixin(ECharts, Eventful);

function updateHoverLayerStatus(zr, ecModel) {
  var storage = zr.storage;
  var elCount = 0;
  storage.traverse(function (el) {
    if (!el.isGroup) {
      elCount++;
    }
  });

  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
    storage.traverse(function (el) {
      if (!el.isGroup) {
        el.useHoverLayer = true;
      }
    });
  }
}
/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateProgressiveAndBlend(seriesModel, chartView) {
  // Progressive configuration
  var elCount = 0;
  chartView.group.traverse(function (el) {
    if (el.type !== 'group' && !el.ignore) {
      elCount++;
    }
  });
  var frameDrawNum = +seriesModel.get('progressive');
  var needProgressive = elCount > seriesModel.get('progressiveThreshold') && frameDrawNum && !env.node;

  if (needProgressive) {
    chartView.group.traverse(function (el) {
      // FIXME marker and other components
      if (!el.isGroup) {
        el.progressive = needProgressive ? Math.floor(elCount++ / frameDrawNum) : -1;

        if (needProgressive) {
          el.stopAnimation(true);
        }
      }
    });
  } // Blend configration


  var blendMode = seriesModel.get('blendMode') || null;
  chartView.group.traverse(function (el) {
    // FIXME marker and other components
    if (!el.isGroup) {
      el.setStyle('blend', blendMode);
    }
  });
}
/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateZ(model, view) {
  var z = model.get('z');
  var zlevel = model.get('zlevel'); // Set z and zlevel

  view.group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
    }
  });
}

function createExtensionAPI(ecInstance) {
  var coordSysMgr = ecInstance._coordSysMgr;
  return zrUtil.extend(new ExtensionAPI(ecInstance), {
    // Inject methods
    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
    getComponentByElement: function (el) {
      while (el) {
        var modelInfo = el.__ecComponentInfo;

        if (modelInfo != null) {
          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
        }

        el = el.parent;
      }
    }
  });
}
/**
 * @type {Object} key: actionType.
 * @inner
 */


var actions = {};
/**
 * Map eventType to actionType
 * @type {Object}
 */

var eventActionMap = {};
/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var dataProcessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var optionPreprocessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var postUpdateFuncs = [];
/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var visualFuncs = [];
/**
 * Theme storage
 * @type {Object.<key, Object>}
 */

var themeStorage = {};
/**
 * Loading effects
 */

var loadingEffects = {};
var instances = {};
var connectedGroups = {};
var idBase = new Date() - 0;
var groupIdBase = new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
var mapDataStores = {};

function enableConnect(chart) {
  var STATUS_PENDING = 0;
  var STATUS_UPDATING = 1;
  var STATUS_UPDATED = 2;
  var STATUS_KEY = '__connectUpdateStatus';

  function updateConnectedChartsStatus(charts, status) {
    for (var i = 0; i < charts.length; i++) {
      var otherChart = charts[i];
      otherChart[STATUS_KEY] = status;
    }
  }

  zrUtil.each(eventActionMap, function (actionType, eventType) {
    chart._messageCenter.on(eventType, function (event) {
      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
        if (event && event.escapeConnect) {
          return;
        }

        var action = chart.makeActionFromEvent(event);
        var otherCharts = [];
        zrUtil.each(instances, function (otherChart) {
          if (otherChart !== chart && otherChart.group === chart.group) {
            otherCharts.push(otherChart);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
        each(otherCharts, function (otherChart) {
          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
            otherChart.dispatchAction(action);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
      }
    });
  });
}
/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Currently only 'canvas' is supported.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */


function init(dom, theme, opts) {
  var existInstance = getInstanceByDom(dom);

  if (existInstance) {
    return existInstance;
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances[chart.id] = chart;

  if (dom.setAttribute) {
    dom.setAttribute(DOM_ATTRIBUTE_KEY, chart.id);
  } else {
    dom[DOM_ATTRIBUTE_KEY] = chart.id;
  }

  enableConnect(chart);
  return chart;
}
/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */


function connect(groupId) {
  // Is array of charts
  if (zrUtil.isArray(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    zrUtil.each(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    zrUtil.each(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @DEPRECATED
 * @return {string} groupId
 */


function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * @return {string} groupId
 */


var disconnect = disConnect;
/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */

function dispose(chart) {
  if (typeof chart === 'string') {
    chart = instances[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */


function getInstanceByDom(dom) {
  var key;

  if (dom.getAttribute) {
    key = dom.getAttribute(DOM_ATTRIBUTE_KEY);
  } else {
    key = dom[DOM_ATTRIBUTE_KEY];
  }

  return instances[key];
}
/**
 * @param {string} key
 * @return {echarts~ECharts}
 */


function getInstanceById(key) {
  return instances[key];
}
/**
 * Register theme
 */


function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */


function registerPreprocessor(preprocessorFunc) {
  optionPreprocessorFuncs.push(preprocessorFunc);
}
/**
 * @param {number} [priority=1000]
 * @param {Function} processorFunc
 */


function registerProcessor(priority, processorFunc) {
  if (typeof priority === 'function') {
    processorFunc = priority;
    priority = PRIORITY_PROCESSOR_FILTER;
  }

  dataProcessorFuncs.push({
    prio: priority,
    func: processorFunc
  });
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */


function registerPostUpdate(postUpdateFunc) {
  postUpdateFuncs.push(postUpdateFunc);
}
/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */


function registerAction(actionInfo, eventName, action) {
  if (typeof eventName === 'function') {
    action = eventName;
    eventName = '';
  }

  var actionType = zrUtil.isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event; // Validate action type and event name.

  zrUtil.assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */


function registerCoordinateSystem(type, CoordinateSystem) {
  CoordinateSystemManager.register(type, CoordinateSystem);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */


function getCoordinateSystemDimensions(type) {
  var coordSysCreator = CoordinateSystemManager.get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}
/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutFunc
 */


function registerLayout(priority, layoutFunc) {
  if (typeof priority === 'function') {
    layoutFunc = priority;
    priority = PRIORITY_VISUAL_LAYOUT;
  }

  visualFuncs.push({
    prio: priority,
    func: layoutFunc,
    isLayout: true
  });
}
/**
 * @param {number} [priority=3000]
 * @param {Function} visualFunc
 */


function registerVisual(priority, visualFunc) {
  if (typeof priority === 'function') {
    visualFunc = priority;
    priority = PRIORITY_VISUAL_CHART;
  }

  visualFuncs.push({
    prio: priority,
    func: visualFunc
  });
}
/**
 * @param {string} name
 */


function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentModel(opts
/*, superClass*/
) {
  // var Clazz = ComponentModel;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return ComponentModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentView(opts
/*, superClass*/
) {
  // var Clazz = ComponentView;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
  // }
  return ComponentView.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendSeriesModel(opts
/*, superClass*/
) {
  // var Clazz = SeriesModel;
  // if (superClass) {
  //     superClass = 'series.' + superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return SeriesModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendChartView(opts
/*, superClass*/
) {
  // var Clazz = ChartView;
  // if (superClass) {
  //     superClass = superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ChartView.getClass(classType.main, true);
  // }
  return ChartView.extend(opts);
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */


function setCanvasCreator(creator) {
  zrUtil.$override('createCanvas', creator);
}
/**
 * @param {string} mapName
 * @param {Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 */


function registerMap(mapName, geoJson, specialAreas) {
  if (geoJson.geoJson && !geoJson.features) {
    specialAreas = geoJson.specialAreas;
    geoJson = geoJson.geoJson;
  }

  if (typeof geoJson === 'string') {
    geoJson = typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(geoJson) : new Function('return (' + geoJson + ');')();
  }

  mapDataStores[mapName] = {
    geoJson: geoJson,
    specialAreas: specialAreas
  };
}
/**
 * @param {string} mapName
 * @return {Object}
 */


function getMap(mapName) {
  return mapDataStores[mapName];
}

registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
registerPreprocessor(backwardCompat);
registerLoading('default', loadingDefault); // Default actions

registerAction({
  type: 'highlight',
  event: 'highlight',
  update: 'highlight'
}, zrUtil.noop);
registerAction({
  type: 'downplay',
  event: 'downplay',
  update: 'downplay'
}, zrUtil.noop); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};
exports.version = version;
exports.dependencies = dependencies;
exports.PRIORITY = PRIORITY;
exports.init = init;
exports.connect = connect;
exports.disConnect = disConnect;
exports.disconnect = disconnect;
exports.dispose = dispose;
exports.getInstanceByDom = getInstanceByDom;
exports.getInstanceById = getInstanceById;
exports.registerTheme = registerTheme;
exports.registerPreprocessor = registerPreprocessor;
exports.registerProcessor = registerProcessor;
exports.registerPostUpdate = registerPostUpdate;
exports.registerAction = registerAction;
exports.registerCoordinateSystem = registerCoordinateSystem;
exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
exports.registerLayout = registerLayout;
exports.registerVisual = registerVisual;
exports.registerLoading = registerLoading;
exports.extendComponentModel = extendComponentModel;
exports.extendComponentView = extendComponentView;
exports.extendSeriesModel = extendSeriesModel;
exports.extendChartView = extendChartView;
exports.setCanvasCreator = setCanvasCreator;
exports.registerMap = registerMap;
exports.getMap = getMap;
exports.dataTool = dataTool;
var ___ec_export = __webpack_require__(487);
(function () {
    for (var key in ___ec_export) {
        if (___ec_export.hasOwnProperty(key)) {
            exports[key] = ___ec_export[key];
        }
    }
})();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var pathTool = __webpack_require__(1995);

var colorTool = __webpack_require__(78);

var matrix = __webpack_require__(53);

var vector = __webpack_require__(19);

var Path = __webpack_require__(34);

var Transformable = __webpack_require__(323);

var Image = __webpack_require__(152);

exports.Image = Image;

var Group = __webpack_require__(211);

exports.Group = Group;

var Text = __webpack_require__(153);

exports.Text = Text;

var Circle = __webpack_require__(1982);

exports.Circle = Circle;

var Sector = __webpack_require__(1988);

exports.Sector = Sector;

var Ring = __webpack_require__(1987);

exports.Ring = Ring;

var Polygon = __webpack_require__(1984);

exports.Polygon = Polygon;

var Polyline = __webpack_require__(1985);

exports.Polyline = Polyline;

var Rect = __webpack_require__(1986);

exports.Rect = Rect;

var Line = __webpack_require__(1983);

exports.Line = Line;

var BezierCurve = __webpack_require__(1981);

exports.BezierCurve = BezierCurve;

var Arc = __webpack_require__(1980);

exports.Arc = Arc;

var CompoundPath = __webpack_require__(1976);

exports.CompoundPath = CompoundPath;

var LinearGradient = __webpack_require__(692);

exports.LinearGradient = LinearGradient;

var RadialGradient = __webpack_require__(1977);

exports.RadialGradient = RadialGradient;

var BoundingRect = __webpack_require__(26);

exports.BoundingRect = BoundingRect;
var round = Math.round;
var mathMax = Math.max;
var mathMin = Math.min;
var EMPTY_OBJ = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return Path.extend(opts);
}
/**
 * Extend path
 */


function extendPath(pathData, opts) {
  return pathTool.extendFromString(pathData, opts);
}
/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makePath(pathData, opts, rect, layout) {
  var path = pathTool.createFromString(pathData, opts);
  var boundingRect = path.getBoundingRect();

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, boundingRect);
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makeImage(imageUrl, rect, layout) {
  var path = new Image({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        path.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return path;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */


function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath = pathTool.mergePath;
/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeLine(param) {
  var shape = param.shape;
  var lineWidth = param.style.lineWidth;

  if (round(shape.x1 * 2) === round(shape.x2 * 2)) {
    shape.x1 = shape.x2 = subPixelOptimize(shape.x1, lineWidth, true);
  }

  if (round(shape.y1 * 2) === round(shape.y2 * 2)) {
    shape.y1 = shape.y2 = subPixelOptimize(shape.y1, lineWidth, true);
  }

  return param;
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeRect(param) {
  var shape = param.shape;
  var lineWidth = param.style.lineWidth;
  var originX = shape.x;
  var originY = shape.y;
  var originWidth = shape.width;
  var originHeight = shape.height;
  shape.x = subPixelOptimize(shape.x, lineWidth, true);
  shape.y = subPixelOptimize(shape.y, lineWidth, true);
  shape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - shape.x, originWidth === 0 ? 0 : 1);
  shape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - shape.y, originHeight === 0 ? 0 : 1);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


function subPixelOptimize(position, lineWidth, positiveOrNegative) {
  // Assure that (position + lineWidth / 2) is near integer edge,
  // otherwise line will be fuzzy in canvas.
  var doubledPosition = round(position * 2);
  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke != 'none';
}

function liftColor(color) {
  return typeof color === 'string' ? colorTool.lift(color, -0.1) : color;
}
/**
 * @private
 */


function cacheElementStl(el) {
  if (el.__hoverStlDirty) {
    var stroke = el.style.stroke;
    var fill = el.style.fill; // Create hoverStyle on mouseover

    var hoverStyle = el.__hoverStl;
    hoverStyle.fill = hoverStyle.fill || (hasFillOrStroke(fill) ? liftColor(fill) : null);
    hoverStyle.stroke = hoverStyle.stroke || (hasFillOrStroke(stroke) ? liftColor(stroke) : null);
    var normalStyle = {};

    for (var name in hoverStyle) {
      // See comment in `doSingleEnterHover`.
      if (hoverStyle[name] != null) {
        normalStyle[name] = el.style[name];
      }
    }

    el.__normalStl = normalStyle;
    el.__hoverStlDirty = false;
  }
}
/**
 * @private
 */


function doSingleEnterHover(el) {
  if (el.__isHover) {
    return;
  }

  cacheElementStl(el);

  if (el.useHoverLayer) {
    el.__zr && el.__zr.addHover(el, el.__hoverStl);
  } else {
    var style = el.style;
    var insideRollbackOpt = style.insideRollbackOpt; // Consider case: only `position: 'top'` is set on emphasis, then text
    // color should be returned to `autoColor`, rather than remain '#fff'.
    // So we should rollback then apply again after style merging.

    insideRollbackOpt && rollbackInsideStyle(style); // styles can be:
    // {
    //     label: {
    //         normal: {
    //             show: false,
    //             position: 'outside',
    //             fontSize: 18
    //         },
    //         emphasis: {
    //             show: true
    //         }
    //     }
    // },
    // where properties of `emphasis` may not appear in `normal`. We previously use
    // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
    // But consider rich text and setOption in merge mode, it is impossible to cover
    // all properties in merge. So we use merge mode when setting style here, where
    // only properties that is not `null/undefined` can be set. The disadventage:
    // null/undefined can not be used to remove style any more in `emphasis`.

    style.extendFrom(el.__hoverStl); // Do not save `insideRollback`.

    if (insideRollbackOpt) {
      applyInsideStyle(style, style.insideOriginalTextPosition, insideRollbackOpt); // textFill may be rollbacked to null.

      if (style.textFill == null) {
        style.textFill = insideRollbackOpt.autoColor;
      }
    }

    el.dirty(false);
    el.z2 += 1;
  }

  el.__isHover = true;
}
/**
 * @inner
 */


function doSingleLeaveHover(el) {
  if (!el.__isHover) {
    return;
  }

  var normalStl = el.__normalStl;

  if (el.useHoverLayer) {
    el.__zr && el.__zr.removeHover(el);
  } else {
    // Consider null/undefined value, should use
    // `setStyle` but not `extendFrom(stl, true)`.
    normalStl && el.setStyle(normalStl);
    el.z2 -= 1;
  }

  el.__isHover = false;
}
/**
 * @inner
 */


function doEnterHover(el) {
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      doSingleEnterHover(child);
    }
  }) : doSingleEnterHover(el);
}

function doLeaveHover(el) {
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      doSingleLeaveHover(child);
    }
  }) : doSingleLeaveHover(el);
}
/**
 * @inner
 */


function setElementHoverStl(el, hoverStl) {
  // If element has sepcified hoverStyle, then use it instead of given hoverStyle
  // Often used when item group has a label element and it's hoverStyle is different
  el.__hoverStl = el.hoverStyle || hoverStl || {};
  el.__hoverStlDirty = true;

  if (el.__isHover) {
    cacheElementStl(el);
  }
}
/**
 * @inner
 */


function onElementMouseOver(e) {
  if (this.__hoverSilentOnTouch && e.zrByTouch) {
    return;
  } // Only if element is not in emphasis status


  !this.__isEmphasis && doEnterHover(this);
}
/**
 * @inner
 */


function onElementMouseOut(e) {
  if (this.__hoverSilentOnTouch && e.zrByTouch) {
    return;
  } // Only if element is not in emphasis status


  !this.__isEmphasis && doLeaveHover(this);
}
/**
 * @inner
 */


function enterEmphasis() {
  this.__isEmphasis = true;
  doEnterHover(this);
}
/**
 * @inner
 */


function leaveEmphasis() {
  this.__isEmphasis = false;
  doLeaveHover(this);
}
/**
 * Set hover style of element.
 * This method can be called repeatly without side-effects.
 * @param {module:zrender/Element} el
 * @param {Object} [hoverStyle]
 * @param {Object} [opt]
 * @param {boolean} [opt.hoverSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conviniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, hoverSilentOnTouch should be used to disable hover-highlight
 *        on touch device.
 */


function setHoverStyle(el, hoverStyle, opt) {
  el.__hoverSilentOnTouch = opt && opt.hoverSilentOnTouch;
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      setElementHoverStl(child, hoverStyle);
    }
  }) : setElementHoverStl(el, hoverStyle); // Duplicated function will be auto-ignored, see Eventful.js.

  el.on('mouseover', onElementMouseOver).on('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually

  el.on('emphasis', enterEmphasis).on('normal', leaveEmphasis);
}
/**
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {Object} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */


function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
  opt = opt || EMPTY_OBJ;
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
  // is not supported util someone requests.

  var showNormal = normalModel.getShallow('show');
  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.

  var baseText = showNormal || showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex) : null, opt.defaultText) : null;
  var normalStyleText = showNormal ? baseText : null;
  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.

  if (normalStyleText != null || emphasisStyleText != null) {
    // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.
    // If we set default values on `emphasisStyle`, consider case:
    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
    // Then the 'red' will not work on emphasis.
    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
  }

  normalStyle.text = normalStyleText;
  emphasisStyle.text = emphasisStyleText;
}
/**
 * Set basic textStyle properties.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */


function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle);
  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
  return textStyle;
}
/**
 * Set text option in the style.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */


function setText(textStyle, labelModel, defaultColor) {
  var opt = {
    isRectText: true
  };
  var isEmphasis;

  if (defaultColor === false) {
    isEmphasis = true;
  } else {
    // Support setting color as 'auto' to get visual color.
    opt.autoColor = defaultColor;
  }

  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis);
  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
}
/**
 * {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */


function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;

  if (opt.isRectText) {
    var textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.

    textPosition === 'outside' && (textPosition = 'top');
    textStyle.textPosition = textPosition;
    textStyle.textOffset = textStyleModel.getShallow('offset');
    var labelRotate = textStyleModel.getShallow('rotate');
    labelRotate != null && (labelRotate *= Math.PI / 180);
    textStyle.textRotation = labelRotate;
    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
  }

  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             normal: {
  //                 rich: {
  //                     // no 'a' here but using parent 'a'.
  //                 }
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name in richItemNames) {
      if (richItemNames.hasOwnProperty(name)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.

        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
      }
    }
  }

  textStyle.rich = richResult;
  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);

  if (opt.forceRich && !opt.textStyle) {
    opt.textStyle = {};
  }

  return textStyle;
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             normal: {
//                 rich: {
//                     // no 'a' here but using parent 'a'.
//                 }
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};

      for (var name in rich) {
        if (rich.hasOwnProperty(name)) {
          richItemNameMap[name] = 1;
        }
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (!isEmphasis) {
    if (isBlock) {
      // Always set `insideRollback`, for clearing previous.
      var originalTextPosition = textStyle.textPosition;
      textStyle.insideRollback = applyInsideStyle(textStyle, originalTextPosition, opt); // Save original textPosition, because style.textPosition will be repalced by
      // real location (like [10, 30]) in zrender.

      textStyle.insideOriginalTextPosition = originalTextPosition;
      textStyle.insideRollbackOpt = opt;
    } // Set default finally.


    if (textStyle.textFill == null) {
      textStyle.textFill = opt.autoColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
  textStyle.textAlign = textStyleModel.getShallow('align');
  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
  textStyle.textWidth = textStyleModel.getShallow('width');
  textStyle.textHeight = textStyleModel.getShallow('height');
  textStyle.textTag = textStyleModel.getShallow('tag');

  if (!isBlock || !opt.disableBox) {
    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
    textStyle.textPadding = textStyleModel.getShallow('padding');
    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
  }

  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
}

function getAutoColor(color, opt) {
  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
}

function applyInsideStyle(textStyle, textPosition, opt) {
  var useInsideStyle = opt.useInsideStyle;
  var insideRollback;

  if (textStyle.textFill == null && useInsideStyle !== false && (useInsideStyle === true || opt.isRectText && textPosition // textPosition can be [10, 30]
  && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0)) {
    insideRollback = {
      textFill: null,
      textStroke: textStyle.textStroke,
      textStrokeWidth: textStyle.textStrokeWidth
    };
    textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.

    if (textStyle.textStroke == null) {
      textStyle.textStroke = opt.autoColor;
      textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
    }
  }

  return insideRollback;
}

function rollbackInsideStyle(style) {
  var insideRollback = style.insideRollback;

  if (insideRollback) {
    style.textFill = insideRollback.textFill;
    style.textStroke = insideRollback.textStroke;
    style.textStrokeWidth = insideRollback.textStrokeWidth;
  }
}

function getFont(opt, ecModel) {
  // ecModel or default text style model.
  var gTextStyleModel = ecModel || ecModel.getModel('textStyle');
  return [// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' ');
}

function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
  if (typeof dataIndex === 'function') {
    cb = dataIndex;
    dataIndex = null;
  } // Do not check 'animation' property directly here. Consider this case:
  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
  // but its parent model (`seriesModel`) does.


  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();

  if (animationEnabled) {
    var postfix = isUpdate ? 'Update' : '';
    var duration = animatableModel.getShallow('animationDuration' + postfix);
    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);

    if (typeof animationDelay === 'function') {
      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    }

    if (typeof duration === 'function') {
      duration = duration(dataIndex);
    }

    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
  } else {
    el.stopAnimation();
    el.attr(props);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */


function initProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
}
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */


function getTransform(target, ancestor) {
  var mat = matrix.identity([]);

  while (target && target !== ancestor) {
    matrix.mul(mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */


function applyTransform(target, transform, invert) {
  if (transform && !zrUtil.isArrayLike(transform)) {
    transform = Transformable.getLocalTransform(transform);
  }

  if (invert) {
    transform = matrix.invert([], transform);
  }

  return vector.applyTransform([], target, transform);
}
/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */


function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel, cb) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (!el.isGroup && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      position: vector.clone(el.position),
      rotation: el.rotation
    };

    if (el.shape) {
      obj.shape = zrUtil.extend({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (!el.isGroup && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        updateProps(el, newProp, animatableModel, el.dataIndex);
      } // else {
      //     if (el.previousProps) {
      //         graphic.updateProps
      //     }
      // }

    }
  });
}
/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */


function clipPointsByRect(points, rect) {
  return zrUtil.map(points, function (point) {
    var x = point[0];
    x = mathMax(x, rect.x);
    x = mathMin(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax(y, rect.y);
    y = mathMin(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */


function clipRectByRect(targetRect, rect) {
  var x = mathMax(targetRect.x, rect.x);
  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax(targetRect.y, rect.y);
  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height);

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */


function createIcon(iconStr, opt, rect) {
  opt = zrUtil.extend({
    rectHover: true
  }, opt);
  var style = opt.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new Image(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
  }
}

exports.extendShape = extendShape;
exports.extendPath = extendPath;
exports.makePath = makePath;
exports.makeImage = makeImage;
exports.mergePath = mergePath;
exports.resizePath = resizePath;
exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;
exports.setHoverStyle = setHoverStyle;
exports.setLabelStyle = setLabelStyle;
exports.setTextStyle = setTextStyle;
exports.setText = setText;
exports.getFont = getFont;
exports.updateProps = updateProps;
exports.initProps = initProps;
exports.getTransform = getTransform;
exports.applyTransform = applyTransform;
exports.transformDirection = transformDirection;
exports.groupTransition = groupTransition;
exports.clipPointsByRect = clipPointsByRect;
exports.clipRectByRect = clipRectByRect;
exports.createIcon = createIcon;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(28);

// browser specific modules
util.crypto.lib = __webpack_require__(438);
util.Buffer = __webpack_require__(109).Buffer;
util.url = __webpack_require__(629);
util.querystring = __webpack_require__(300);
util.environment = 'js';

var AWS = __webpack_require__(3);
module.exports = AWS;

__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(987);
__webpack_require__(988);

// Load the DOMParser XML parser
AWS.XML.Parser = __webpack_require__(1029);

// Load the XHR HttpClient
__webpack_require__(996);

if (typeof process === 'undefined') {
  process = {
    browser: true
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var RADIAN_EPSILON = 1e-4;

function _trim(str) {
  return str.replace(/^\s+/, '').replace(/\s+$/, '');
}
/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */


function linearMap(val, domain, range, clamp) {
  var subDomain = domain[1] - domain[0];
  var subRange = range[1] - range[0];

  if (subDomain === 0) {
    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= domain[0]) {
        return range[0];
      } else if (val >= domain[1]) {
        return range[1];
      }
    } else {
      if (val >= domain[0]) {
        return range[0];
      } else if (val <= domain[1]) {
        return range[1];
      }
    }
  } else {
    if (val === domain[0]) {
      return range[0];
    }

    if (val === domain[1]) {
      return range[1];
    }
  }

  return (val - domain[0]) / subDomain * subRange + range[0];
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */


function parsePercent(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (typeof percent === 'string') {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */


function round(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), 20);
  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}

function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision
 * @param {number} val
 */


function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      var tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low


  var e = 1;
  var count = 0;

  while (Math.round(val * e) / e !== val) {
    e *= 10;
    count++;
  }

  return count;
}
/**
 * @param {string|number} val
 * @return {number}
 */


function getPrecisionSafe(val) {
  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');

  if (eIndex > 0) {
    var precision = +str.slice(eIndex + 1);
    return precision < 0 ? -precision : 0;
  } else {
    var dotIndex = str.indexOf('.');
    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
  }
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */


function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */


function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var sum = zrUtil.reduce(valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return 0;
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = zrUtil.map(valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = zrUtil.map(votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = zrUtil.reduce(seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return seats[idx] / digits;
} // Number.MAX_SAFE_INTEGER, ie do not support.


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */


function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
}

var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (typeof value === 'string') {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset specifed.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */


function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}

function quantityExponent(val) {
  return Math.floor(Math.log(val) / Math.LN10);
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */


function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */


function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close[lg];
    }

    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */


function isNumeric(v) {
  return v - parseFloat(v) >= 0;
}

exports.linearMap = linearMap;
exports.parsePercent = parsePercent;
exports.round = round;
exports.asc = asc;
exports.getPrecision = getPrecision;
exports.getPrecisionSafe = getPrecisionSafe;
exports.getPixelPrecision = getPixelPrecision;
exports.getPercentWithPrecision = getPercentWithPrecision;
exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
exports.remRadian = remRadian;
exports.isRadianAroundZero = isRadianAroundZero;
exports.parseDate = parseDate;
exports.quantity = quantity;
exports.nice = nice;
exports.reformIntervals = reformIntervals;
exports.isNumeric = isNumeric;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The main AWS namespace
 */
var AWS = { util: __webpack_require__(27) };

/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */
var _hidden = {}; _hidden.toString(); // hack to parse macro

module.exports = AWS;

AWS.util.update(AWS, {

  /**
   * @constant
   */
  VERSION: '2.177.0',

  /**
   * @api private
   */
  Signers: {},

  /**
   * @api private
   */
  Protocol: {
    Json: __webpack_require__(220),
    Query: __webpack_require__(349),
    Rest: __webpack_require__(156),
    RestJson: __webpack_require__(350),
    RestXml: __webpack_require__(351)
  },

  /**
   * @api private
   */
  XML: {
    Builder: __webpack_require__(756),
    Parser: null // conditionally set based on environment
  },

  /**
   * @api private
   */
  JSON: {
    Builder: __webpack_require__(218),
    Parser: __webpack_require__(219)
  },

  /**
   * @api private
   */
  Model: {
    Api: __webpack_require__(344),
    Operation: __webpack_require__(346),
    Shape: __webpack_require__(127),
    Paginator: __webpack_require__(347),
    ResourceWaiter: __webpack_require__(348)
  },

  /**
   * @api private
   */
  apiLoader: __webpack_require__(729)
});

__webpack_require__(744);
__webpack_require__(730);

__webpack_require__(343);
__webpack_require__(352);
__webpack_require__(735);
__webpack_require__(741);
__webpack_require__(743);
__webpack_require__(742);
__webpack_require__(748);
__webpack_require__(737);

/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */
AWS.events = new AWS.SequentialExecutor();


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
var dev; // In browser

if (typeof window !== 'undefined') {
  dev = window.__DEV__;
} // In node
else if (typeof global !== 'undefined') {
    dev = global.__DEV__;
  }

if (typeof dev === 'undefined') {
  dev = true;
}

var __DEV__ = dev;
exports.__DEV__ = __DEV__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var formatUtil = __webpack_require__(21);

var nubmerUtil = __webpack_require__(8);

var Model = __webpack_require__(29);

var each = zrUtil.each;
var isObject = zrUtil.isObject;
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *         normal: {
 *             show: false,
 *             position: 'outside',
 *             fontSize: 18
 *         },
 *         emphasis: {
 *             show: true
 *         }
 *     }
 * @param {Object} opt
 * @param {Array.<string>} subOpts
 */


function defaultEmphasis(opt, subOpts) {
  if (opt) {
    var emphasisOpt = opt.emphasis = opt.emphasis || {};
    var normalOpt = opt.normal = opt.normal || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!emphasisOpt.hasOwnProperty(subOptName) && normalOpt.hasOwnProperty(subOptName)) {
        emphasisOpt[subOptName] = normalOpt[subOptName];
      }
    }
  }
}

var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */

function getDataItemValue(dataItem) {
  // Performance sensitive.
  return dataItem && (dataItem.value == null ? dataItem : dataItem.value);
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */


function isDataItemOption(dataItem) {
  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 */


function converDataValue(value, dimInfo) {
  // Performance sensitive.
  var dimType = dimInfo && dimInfo.type;

  if (dimType === 'ordinal') {
    return value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && typeof value !== 'number' && value != null && value !== '-') {
    value = +nubmerUtil.parseDate(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.


  return value == null || value === '' ? NaN : +value; // If string (like '-'), using '+' parse to NaN
}
/**
 * Create a model proxy to be used in tooltip for edge data, markLine data, markPoint data.
 * @param {module:echarts/data/List} data
 * @param {Object} opt
 * @param {string} [opt.seriesIndex]
 * @param {Object} [opt.name]
 * @param {Object} [opt.mainType]
 * @param {Object} [opt.subType]
 */


function createDataFormatModel(data, opt) {
  var model = new Model();
  zrUtil.mixin(model, dataFormatMixin);
  model.seriesIndex = opt.seriesIndex;
  model.name = opt.name || '';
  model.mainType = opt.mainType;
  model.subType = opt.subType;

  model.getData = function () {
    return data;
  };

  return model;
} // PENDING A little ugly


var dataFormatMixin = {
  /**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */
  getDataParams: function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex, true);
    var itemOpt = data.getRawDataItem(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');
    return {
      componentType: this.mainType,
      componentSubType: this.subType,
      seriesType: this.mainType === 'series' ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: this.id,
      seriesName: this.name,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      marker: formatUtil.getTooltipMarker(color),
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  },

  /**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex]
   * @param {string} [labelProp='label']
   * @return {string}
   */
  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var itemModel = data.getItemModel(dataIndex);
    var params = this.getDataParams(dataIndex, dataType);

    if (dimIndex != null && params.value instanceof Array) {
      params.value = params.value[dimIndex];
    }

    var formatter = itemModel.get([labelProp || 'label', status, 'formatter']);

    if (typeof formatter === 'function') {
      params.status = status;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      return formatUtil.formatTpl(formatter, params);
    }
  },

  /**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Object}
   */
  getRawValue: function (idx, dataType) {
    var data = this.getData(dataType);
    var dataItem = data.getRawDataItem(idx);

    if (dataItem != null) {
      return isObject(dataItem) && !(dataItem instanceof Array) ? dataItem.value : dataItem;
    }
  },

  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */
  formatTooltip: zrUtil.noop
};
/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */

function mappingToExists(exists, newCptOptions) {
  // Mapping by the order by original option (but not order of
  // new option) in merge mode. Because we should ensure
  // some specified index (like xAxisIndex) is consistent with
  // original option, which is easy to understand, espatially in
  // media query. And in most case, merge option is used to
  // update partial option but not be expected to change order.
  newCptOptions = (newCptOptions || []).slice();
  var result = zrUtil.map(exists || [], function (obj, index) {
    return {
      exist: obj
    };
  }); // Mapping by id or name if specified.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    } // id has highest priority.


    for (var i = 0; i < result.length; i++) {
      if (!result[i].option // Consider name: two map to one.
      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }

    for (var i = 0; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Consider name: two map to one.
      // Can not match when both ids exist but different.
      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }
  }); // Otherwise mapping by index.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    }

    var i = 0;

    for (; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Existing model that already has id should be able to
      // mapped to (because after mapping performed model may
      // be assigned with a id, whish should not affect next
      // mapping), except those has inner id.
      && !isIdInner(exist) // Caution:
      // Do not overwrite id. But name can be overwritten,
      // because axis use name as 'show label text'.
      // 'exist' always has id and name and we dont
      // need to check it.
      && cptOption.id == null) {
        result[i].option = cptOption;
        break;
      }
    }

    if (i >= result.length) {
      result.push({
        option: cptOption
      });
    }
  });
  return result;
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = zrUtil.createHashMap();
  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    existCpt && idMap.set(existCpt.id, item);
  });
  each(mapResult, function (item, index) {
    var opt = item.option;
    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    var opt = item.option;
    var keyInfo = item.keyInfo;

    if (!isObject(opt)) {
      return;
    } // name can be overwitten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name : '\0-'; // name may be displayed on screen, so use '-'.

    if (existCpt) {
      keyInfo.id = existCpt.id;
    } else if (opt.id != null) {
      keyInfo.id = opt.id + '';
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}
/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */


function isIdInner(cptOption) {
  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = sourceBatch[i].seriesId;
      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */


function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var get = modelUitl.makeGetter();
 *
 * function some(hostObj) {
 *      get(hostObj)._someProperty = 1212;
 *      ...
 * }
 *
 * @return {Function}
 */


var makeGetter = function () {
  var index = 0;
  return function () {
    var key = '\0__ec_prop_getter_' + index++;
    return function (hostObj) {
      return hostObj[key] || (hostObj[key] = {});
    };
  };
}();
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */


function parseFinder(ecModel, finder, opt) {
  if (zrUtil.isString(finder)) {
    var obj = {};
    obj[finder + 'Index'] = 0;
    finder = obj;
  }

  var defaultMainType = opt && opt.defaultMainType;

  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
    finder[defaultMainType + 'Index'] = 0;
  }

  var result = {};
  each(finder, function (value, key) {
    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.

    if (key === 'dataIndex' || key === 'dataIndexInside') {
      result[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    var queryParam = {
      mainType: mainType
    };

    if (queryType !== 'index' || value !== 'all') {
      queryParam[queryType] = value;
    }

    var models = ecModel.queryComponents(queryParam);
    result[mainType + 'Models'] = models;
    result[mainType + 'Model'] = models[0];
  });
  return result;
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string|number} dataDim
 * @return {string}
 */


function dataDimToCoordDim(data, dataDim) {
  var dimensions = data.dimensions;
  dataDim = data.getDimension(dataDim);

  for (var i = 0; i < dimensions.length; i++) {
    var dimItem = data.getDimensionInfo(dimensions[i]);

    if (dimItem.name === dataDim) {
      return dimItem.coordDim;
    }
  }
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string} coordDim
 * @return {Array.<string>} data dimensions on the coordDim.
 */


function coordDimToDataDim(data, coordDim) {
  var dataDim = [];
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);

    if (dimItem.coordDim === coordDim) {
      dataDim[dimItem.coordDimIndex] = dimItem.name;
    }
  });
  return dataDim;
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string} otherDim Can be `otherDims`
 *                        like 'label' or 'tooltip'.
 * @return {Array.<string>} data dimensions on the otherDim.
 */


function otherDimToDataDim(data, otherDim) {
  var dataDim = [];
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var otherDims = dimItem.otherDims;
    var dimIndex = otherDims[otherDim];

    if (dimIndex != null && dimIndex !== false) {
      dataDim[dimIndex] = dimItem.name;
    }
  });
  return dataDim;
}

function has(obj, prop) {
  return obj && obj.hasOwnProperty(prop);
}

exports.normalizeToArray = normalizeToArray;
exports.defaultEmphasis = defaultEmphasis;
exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
exports.getDataItemValue = getDataItemValue;
exports.isDataItemOption = isDataItemOption;
exports.converDataValue = converDataValue;
exports.createDataFormatModel = createDataFormatModel;
exports.dataFormatMixin = dataFormatMixin;
exports.mappingToExists = mappingToExists;
exports.makeIdAndName = makeIdAndName;
exports.isIdInner = isIdInner;
exports.compressBatches = compressBatches;
exports.queryDataIndex = queryDataIndex;
exports.makeGetter = makeGetter;
exports.parseFinder = parseFinder;
exports.dataDimToCoordDim = dataDimToCoordDim;
exports.coordDimToDataDim = coordDimToDataDim;
exports.otherDimToDataDim = otherDimToDataDim;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */
__webpack_require__(1365);




/* harmony default export */ __webpack_exports__["a"] = ({
  /*
  * フィルターの寿命を計算
  * @param Object
  * @return {flow:remainFlowPercent, time:elapsedTimePercent}
  */
  calcFilterLifePercent: function calcFilterLifePercent(filter) {
    // Flowによる残存洗浄可能量（パーセント）算出
    if (filter.maxLifeSpanFlow <= 0) return { flow: 0, time: 0 // フェールセーフ
    };var remainFlowPercent = (filter.maxLifeSpanFlow - (filter.flow < 0 ? 0 : filter.flow)) / filter.maxLifeSpanFlow * 100;

    // Timeによる経過時間（パーセント）算出
    var fromNow = Date.now() - filter.lastReplacementTime;
    var elapsedTimePercent = fromNow / filter.maxLifeSpanTime * 100;

    // 限界値を超えていたら限界値を返す
    return {
      flow: remainFlowPercent < 0 ? 0 : Math.round(remainFlowPercent),
      time: elapsedTimePercent > 100 ? 100 : Math.round(elapsedTimePercent)
    };
  },

  // ミリ秒をヶ月に変換
  convertSecondToMonth: function convertSecondToMonth(second) {
    var convData = second / 60 / 60 / 24 / 30 / 1000; // ヶ月
    var convDataRound = Math.round(convData);
    return convDataRound;
  },

  // 逆変換
  reverseSecondToMonth: function reverseSecondToMonth(month) {
    var convData = month * 60 * 60 * 24 * 30 * 1000; // ヶ月
    var convDataRound = Math.round(convData);
    return convDataRound;
  },
  convertUnit: function convertUnit(flow, unit) {
    if (unit === 'liter') {
      return this.customRound(flow / 1000, 3);
    } else if (unit === 'gal') {
      return this.customRound(flow / 1000 * 0.26417205235815, 3);
    }
    return this.customRound(flow, 3);
  },
  reverseUnit: function reverseUnit(flow, unit) {
    // DBは整数しか許容しないため四捨五入で変換する
    if (unit === 'liter') {
      return Math.round(flow * 1000);
    } else if (unit === 'gal') {
      return Math.round(flow * 1000 / 0.26417205235815);
    }
    return Math.round(flow);
  },
  convertPressureUnit: function convertPressureUnit(pressure, pressurUnit) {
    if (pressurUnit === 'MPa') {
      return this.customRound(pressure / 1000000, 2);
    } else if (pressurUnit === 'PSI') {
      return this.customRound(pressure * 0.000145, 2);
    }
    return this.customRound(pressure, 2);
  },
  reversePressureUnit: function reversePressureUnit(pressure, pressurUnit) {
    if (pressurUnit === 'MPa') {
      return this.customRound(pressure * 1000000, 2);
    } else if (pressurUnit === 'PSI') {
      return this.customRound(pressure / 0.000145, 2);
    }
    return this.customRound(pressure, 2);
  },
  convertTemperatureUnit: function convertTemperatureUnit(temperature, temperatureUnit) {
    if (temperatureUnit === '°F') {
      return this.customRound(temperature * 1.8 + 32, 2);
    } else if (temperatureUnit === '°C') {
      return this.customRound(temperature, 1);
    }
    return this.customRound(temperature, 1);
  },
  reverseTemperatureUnit: function reverseTemperatureUnit(temperature, temperatureUnit) {
    if (temperatureUnit === '°F') {
      return this.customRound((temperature - 32) / 1.8, 1);
    }
    return this.customRound(temperature, 1);
  },
  customRound: function customRound(val, precision) {
    // 小数点を移動させる為の数を10のべき乗で求める
    var digit = Math.pow(10, precision);
    // 四捨五入したい数字に digit を掛けて小数点を移動
    val = val * digit;
    // roundを使って四捨五入
    val = Math.round(val);
    // 移動させた小数点を digit で割ることでもとに戻す
    val = val / digit;
    return val;
  },
  generateUuid: function generateUuid() {
    // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
    // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    var chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('');
    for (var i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case 'x':
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case 'y':
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join('');
  },
  numberFormatter: function numberFormatter(num, locale) {
    return new Intl.NumberFormat(locale).format(num);
  },
  dateFormatter: function dateFormatter(locale, date, options) {
    // date は unixTimeStamp 単位はミリ秒
    try {
      return new Intl.DateTimeFormat(locale, options).format(date);
    } catch (error) {
      return null;
    }
  },
  dispServicesAdds: function dispServicesAdds(data) {
    for (var i = 0, dataLen = data.length; i < dataLen; i++) {
      // 要素を追加
      data[i].dispServices = this.dispServicesAdd(data[i]);
    }
    return data;
  },
  dispServicesAdd: function dispServicesAdd(data) {
    // サービスごとに1レコードにする(複数ポートのサービスは複数になってしまうため)
    var workServises = data.services;
    var workDispServises = [];
    var teatedServiceIds = [];
    for (var j = 0, servicesLen = workServises.length; j < servicesLen; j++) {
      if (!teatedServiceIds[workServises[j].serviceId]) {
        // 存在しない
        workDispServises[j] = workServises[j];
        if (workServises[j].serviceId === 5 || workServises[j].serviceId === 4 || workServises[j].serviceId === 3) {
          // サービス、ポートごとの情報をまとめる
          workDispServises[j].details = this.dispServicesAddPortNest(workServises, workServises[j].serviceId);
        }
      }
      // 処理したServiceIDを保持
      teatedServiceIds[workServises[j].serviceId] = true;
    }
    // 要素を追加
    return workDispServises;
  },
  dispServicesAddPortNest: function dispServicesAddPortNest(workServises, workServiceId) {
    // ポートごとのの情報を一レコードないにネストする
    var details = [];
    for (var i = 0, len = workServises.length; i < len; i++) {
      if (workServises[i].serviceId === workServiceId) {
        // ポートごとの情報をまとめる
        details.push(workServises[i]);
      }
    }
    return details;
  },
  getDateTimeUnixTimestamp: function getDateTimeUnixTimestamp(date, time) {
    var dateTimeString = (date + ' ' + time).replace(/-/g, '/');
    var unixTimeStamp = Math.floor(new Date(dateTimeString).getTime() / 1000);
    return unixTimeStamp - unixTimeStamp % (15 * 60);
  },
  formatDateForDatePickerAndTime: function formatDateForDatePickerAndTime(timestamp, locale, timezone, format) {
    var isMilliSeconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(locale);
    if (isMilliSeconds) {
      timestamp = Math.floor(timestamp / 1000);
    }
    return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(timestamp).tz(timezone).format(format);
  },
  getDateOptions: function getDateOptions(period) {
    var isXAxisLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (isXAxisLabel) {
      switch (period) {
        case '15m':
          return { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        case '1h':
          return { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        case '1d':
          return { year: 'numeric', month: 'numeric', day: 'numeric' };
        case '1w':
          return { year: 'numeric', month: 'numeric', day: 'numeric' };
        case '1M':
          return { year: 'numeric', month: 'long' };
      }
    } else {
      switch (period) {
        case '15m':
          return { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        case '1h':
          return { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        case '1d':
          return { month: 'numeric', day: 'numeric' };
        case '1w':
          return { month: 'numeric', day: 'numeric' };
        case '1M':
          return { year: 'numeric', month: 'long' };
      }
    }
    return { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  },

  /**
   * カレンダーの週の開始曜日を設定する
   * 0:日曜始まり
   * 1:月曜始まり
   */
  firstDayOfWeek: function firstDayOfWeek(locale) {
    switch (locale) {
      case 'ja-JP':
        return 0;
      case 'ja':
        return 0;
      case 'en-US':
        return 0;
      case 'en':
        return 0;
      case 'en-GB':
        return 1;
      case 'ru-RU':
        return 1;
      case 'ru':
        return 1;
      case 'uk-UA':
        return 1;
      case 'uk':
        return 1;
      case 'de-DE':
        return 1;
      case 'de':
        return 1;
      default:
        return 0;
    }
  },

  /**
   * ドメイン別設定値取得
   */
  getDomainConfig: function getDomainConfig() {
    var domain = document.domain;
    var whiteLabel = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].whitelabel;
    for (var key in whiteLabel) {
      if (domain.match(key)) {
        return whiteLabel[key];
      }
    }
    return whiteLabel['aqua.harps4.com'];
  },
  isHarps4: function isHarps4() {
    var hostname = location.hostname;
    if (hostname === 'aqua.harps4.com' || hostname === 'stage-1505758733-aqua.harps4.com' || hostname === 'localhost' || hostname === 'localhost.aqua.harps4.com') {
      console.log('harps4');
      return true;
    } else {
      return false;
    }
  },


  /**
   *  組織カテゴリのリストに名称をセット
   */
  setNameCustomerCategories: function setNameCustomerCategories($t, list) {
    for (var i = 0; i < list.length; i++) {
      // 言語ファイルからの値を上書きする
      list[i].name = this.setNameCustomerCategory($t, list[i].name, list[i].customerCategoryId);
    }
    return list;
  },

  /**
   *  組織カテゴリの名称をセット
   */
  setNameCustomerCategory: function setNameCustomerCategory($t, name, customerCategoryId) {
    var wkName = '';
    var keyName = '';
    // 言語ファイルのキーを設定
    keyName = 'aplix-use-only.customer-categories.' + customerCategoryId;
    // 文言取得
    wkName = $t(keyName);
    // キー名を出力する場合は存在しなかったと判定する
    if (wkName !== keyName) {
      // 言語ファイルからの文言を上書きする
      name = wkName;
    }
    return name;
  },

  /**
   *  ロールに対しての編集権限チェック
   */
  checkEditableRole: function checkEditableRole(targetRoleId, userRoleId) {
    // 存在確認
    if (__WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].accountEditableRoles[userRoleId]) {
      // 編集可能な権限のリストを取得
      var accountEditableRoles = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].accountEditableRoles[userRoleId];
      if (accountEditableRoles.indexOf(targetRoleId) >= 0) {
        // 権限あり
        return true;
      }
    }
    return false;
  },


  /**
   * ブラウザ種別判定
   */
  iOS: function iOS() {
    var ua = navigator.userAgent;
    var ret = ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0 || ua.indexOf('iPod') >= 0;
    return ret;
  },
  safari: function safari() {
    var ua = navigator.userAgent;
    var ret = ua.indexOf('Safari') >= 0 && ua.indexOf('Chrome') < 0; // Android Chrome には 'Safari' がある
    return ret;
  },
  android: function android() {
    var ua = navigator.userAgent;
    var ret = ua.indexOf('Android') >= 0;
    return ret;
  },
  ie11: function ie11() {
    var ua = navigator.userAgent;
    var ret = ua.indexOf("Trident/7") >= 0;
    return ret;
  },


  // ログインユーザがRootかどうか
  isRoot: function isRoot(roles) {
    // ロール名を取得
    var roleName = roles[0]['name'];
    // ルートかどうか
    if (roleName == __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root) {
      return true;
    }
    return false;
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

var formatUtil = __webpack_require__(21);

// Layout helpers for each component positioning
var each = zrUtil.each;
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var position = child.position;
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    position[0] = x;
    position[1] = y;
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = zrUtil.curry(boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = zrUtil.curry(boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = parsePercent(positionInfo.x, containerWidth);
  var y = parsePercent(positionInfo.y, containerHeight);
  var x2 = parsePercent(positionInfo.x2, containerWidth);
  var y2 = parsePercent(positionInfo.y2, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
  margin = formatUtil.normalizeCssArray(margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */


function getLayoutRect(positionInfo, containerRect, margin) {
  margin = formatUtil.normalizeCssArray(margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = parsePercent(positionInfo.left, containerWidth);
  var top = parsePercent(positionInfo.top, containerHeight);
  var right = parsePercent(positionInfo.right, containerWidth);
  var bottom = parsePercent(positionInfo.bottom, containerHeight);
  var width = parsePercent(positionInfo.width, containerWidth);
  var height = parsePercent(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */


function positionElement(el, positionInfo, containerRect, margin, opt) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';

  if (!h && !v) {
    return;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  positionInfo = getLayoutRect(zrUtil.defaults({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransfrom),
  // we can just only modify el.position to get final result.

  var elPos = el.position;
  var dx = h ? positionInfo.x - rect.x : 0;
  var dy = v ? positionInfo.y - rect.y : 0;
  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
}
/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 */


function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
/**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */


function mergeLayoutParam(targetOption, newOption, opt) {
  !zrUtil.isObject(opt) && (opt = {});
  var ignoreSize = opt.ignoreSize;
  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each(names, function (name) {
      merged[name] = targetOption[name];
    });
    each(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name = names[i];

          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
            newParams[name] = targetOption[name];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function copyLayoutParams(target, source) {
  source && target && each(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

exports.LOCATION_PARAMS = LOCATION_PARAMS;
exports.HV_NAMES = HV_NAMES;
exports.box = box;
exports.vbox = vbox;
exports.hbox = hbox;
exports.getAvailableSize = getAvailableSize;
exports.getLayoutRect = getLayoutRect;
exports.positionElement = positionElement;
exports.sizeCalculable = sizeCalculable;
exports.mergeLayoutParam = mergeLayoutParam;
exports.getLayoutParams = getLayoutParams;
exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: method, url: uri, data: data });
  }
});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */

function create(x, y) {
  var out = new ArrayCtor(2);

  if (x == null) {
    x = 0;
  }

  if (y == null) {
    y = 0;
  }

  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */


function copy(out, v) {
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */


function clone(v) {
  var out = new ArrayCtor(2);
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */


function set(out, a, b) {
  out[0] = a;
  out[1] = b;
  return out;
}
/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function add(out, v1, v2) {
  out[0] = v1[0] + v2[0];
  out[1] = v1[1] + v2[1];
  return out;
}
/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */


function scaleAndAdd(out, v1, v2, a) {
  out[0] = v1[0] + v2[0] * a;
  out[1] = v1[1] + v2[1] * a;
  return out;
}
/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function sub(out, v1, v2) {
  out[0] = v1[0] - v2[0];
  out[1] = v1[1] - v2[1];
  return out;
}
/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */


function len(v) {
  return Math.sqrt(lenSquare(v));
}

var length = len; // jshint ignore:line

/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */

function lenSquare(v) {
  return v[0] * v[0] + v[1] * v[1];
}

var lengthSquare = lenSquare;
/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */

function mul(out, v1, v2) {
  out[0] = v1[0] * v2[0];
  out[1] = v1[1] * v2[1];
  return out;
}
/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function div(out, v1, v2) {
  out[0] = v1[0] / v2[0];
  out[1] = v1[1] / v2[1];
  return out;
}
/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function dot(v1, v2) {
  return v1[0] * v2[0] + v1[1] * v2[1];
}
/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */


function scale(out, v, s) {
  out[0] = v[0] * s;
  out[1] = v[1] * s;
  return out;
}
/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */


function normalize(out, v) {
  var d = len(v);

  if (d === 0) {
    out[0] = 0;
    out[1] = 0;
  } else {
    out[0] = v[0] / d;
    out[1] = v[1] / d;
  }

  return out;
}
/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function distance(v1, v2) {
  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}

var dist = distance;
/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */

function distanceSquare(v1, v2) {
  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}

var distSquare = distanceSquare;
/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */

function negate(out, v) {
  out[0] = -v[0];
  out[1] = -v[1];
  return out;
}
/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */


function lerp(out, v1, v2, t) {
  out[0] = v1[0] + t * (v2[0] - v1[0]);
  out[1] = v1[1] + t * (v2[1] - v1[1]);
  return out;
}
/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */


function applyTransform(out, v, m) {
  var x = v[0];
  var y = v[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function min(out, v1, v2) {
  out[0] = Math.min(v1[0], v2[0]);
  out[1] = Math.min(v1[1], v2[1]);
  return out;
}
/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function max(out, v1, v2) {
  out[0] = Math.max(v1[0], v2[0]);
  out[1] = Math.max(v1[1], v2[1]);
  return out;
}

exports.create = create;
exports.copy = copy;
exports.clone = clone;
exports.set = set;
exports.add = add;
exports.scaleAndAdd = scaleAndAdd;
exports.sub = sub;
exports.len = len;
exports.length = length;
exports.lenSquare = lenSquare;
exports.lengthSquare = lengthSquare;
exports.mul = mul;
exports.div = div;
exports.dot = dot;
exports.scale = scale;
exports.normalize = normalize;
exports.distance = distance;
exports.dist = dist;
exports.distanceSquare = distanceSquare;
exports.distSquare = distSquare;
exports.negate = negate;
exports.lerp = lerp;
exports.applyTransform = applyTransform;
exports.min = min;
exports.max = max;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(183)('wks');
var uid = __webpack_require__(101);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var textContain = __webpack_require__(70);

var numberUtil = __webpack_require__(8);

/**
 * 每三位默认加,格式化
 * @param {string|number} x
 * @return {string}
 */
function addCommas(x) {
  if (isNaN(x)) {
    return '-';
  }

  x = (x + '').split('.');
  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
}
/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */


function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}

var normalizeCssArray = zrUtil.normalizeCssArray;

function encodeHTML(source) {
  return String(source).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTpl(tpl, paramsList, encode) {
  if (!zrUtil.isArray(paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    var val = wrapVar(alias, 0);
    tpl = tpl.replace(wrapVar(alias), encode ? encodeHTML(val) : val);
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTplSimple(tpl, param, encode) {
  zrUtil.each(param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
/**
 * @param {string} color
 * @param {string} [extraCssText]
 * @return {string}
 */


function getTooltipMarker(color, extraCssText) {
  return color ? '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:9px;height:9px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '';
}
/**
 * @param {string} str
 * @return {string}
 * @inner
 */


var s2d = function (str) {
  return str < 10 ? '0' + str : str;
};
/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */


function formatTime(tpl, value, isUTC) {
  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = numberUtil.parseDate(value);
  var utc = isUTC ? 'UTC' : '';
  var y = date['get' + utc + 'FullYear']();
  var M = date['get' + utc + 'Month']() + 1;
  var d = date['get' + utc + 'Date']();
  var h = date['get' + utc + 'Hours']();
  var m = date['get' + utc + 'Minutes']();
  var s = date['get' + utc + 'Seconds']();
  tpl = tpl.replace('MM', s2d(M)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', s2d(d)).replace('d', d).replace('hh', s2d(h)).replace('h', h).replace('mm', s2d(m)).replace('m', m).replace('ss', s2d(s)).replace('s', s);
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */


function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}

var truncateText = textContain.truncateText;
var getTextRect = textContain.getBoundingRect;
exports.addCommas = addCommas;
exports.toCamelCase = toCamelCase;
exports.normalizeCssArray = normalizeCssArray;
exports.encodeHTML = encodeHTML;
exports.formatTpl = formatTpl;
exports.formatTplSimple = formatTplSimple;
exports.getTooltipMarker = getTooltipMarker;
exports.formatTime = formatTime;
exports.capitalFirst = capitalFirst;
exports.truncateText = truncateText;
exports.getTextRect = getTextRect;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  role: {
    Root: 'Root',
    Administrator: 'Administrator',
    Manager: 'Manager',
    Staff: 'Staff',
    Viewer: 'Viewer'
  },
  // ユーザー情報を編集できる権限定義 RoleId: [編集可能なacountのRoleIDのリスト]
  accountEditableRoles: {
    2: [2, 3, 4, 7, 8],
    3: [3, 4, 7, 8]
  },
  defaultSettingParams: {
    unit: 'gal', // Unit [liter|gal]
    timezone: 'local', // [utc/local/location]
    pressureUnit: 'MPa', // [PSI/MPa]
    temperatureUnit: '°C', // [°C/°F]
    emailNotification: 'disable', // [enable/disable]
    emailLanguage: 'English' // [English/Japanese]
  },
  organizationConfig: {
    limitCreateHierarchy: {
      max: 2147483647,
      min: 0
    }
  },
  // サービスIDごとに定義
  serviceConfig: {
    1: {
      flow: {
        range: {
          max: 1000000000,
          min: 0
        }
      },
      time: {
        range: {
          max: 120,
          min: 0
        }
      }
    },
    2: {
      ro: {
        range: {
          max: 100,
          min: 0
        }
      }
    },
    3: {}, // 現状定義しておくことはないので器だけ作っておく
    4: {}, // 現状定義しておくことはないので器だけ作っておく
    5: {
      pressure: {
        range: {
          max: 30399000,
          min: 0
        }
      }
    }
  },
  whitelabel: {
    'aqua.harps4.com': {
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '1', // 1:text,2:img
        text: 'HARPS',
        class: 'blue--text text--darken-2'
      },
      domain: 'aqua.harps4.com',
      copyright: 'Copyright © 2018-2019 Aplix and/or its affiliates. All rights reserved.',
      title: ' | HARPS',
      path: 'aqua_harps4_com',
      translations: {
        home: {
          information: 'HARPS'
        }
      }
    },
    'connect.ecosoft.com': { // 本番環境用ECONNECT設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ru': 'Russian',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'ru': {
          disp: 'Russian',
          code: 'Russian'
        }
      },
      topnav: {
        flag: '2', // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'connect.ecosoft.com',
      copyright: '©︎2018-2019 Ecosoft water professionals.',
      title: ' | ECONNECT',
      path: 'connect_ecosoft_com',
      translations: {
        home: {
          information: 'ECONNECT'
        }
      }
    },
    'ecosoft-connect.harps4.com': { // 検証環境用ECONNECT設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ru': 'Russian',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'ru': {
          disp: 'Russian',
          code: 'Russian'
        }
      },
      topnav: {
        flag: '2', // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'connect.ecosoft.com',
      copyright: '©︎2018-2019 Ecosoft water professionals.',
      title: ' | ECONNECT',
      path: 'connect_ecosoft_com',
      translations: {
        home: {
          information: 'ECONNECT'
        }
      }
    },
    'titanium.britapro.harps4.com': { // 本番環境用Brita PRO設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '2', // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'titanium.britapro.harps4.com',
      copyright: 'Copyright © 2018-2019 Protect Plus PRO LLC. All Rights Reserved.',
      title: ' | Brita PRO',
      path: 'protectplus_britapro_com',
      translations: {
        home: {
          information: 'Brita PRO'
        }
      }
    },
    'britapro-titanium.harps4.com': { // 検証環境用Brita PRO設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '2', // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'titanium.britapro.harps4.com',
      copyright: 'Copyright © 2018-2019 Protect Plus PRO LLC. All Rights Reserved.',
      title: ' | Brita PRO',
      path: 'protectplus_britapro_com',
      translations: {
        home: {
          information: 'Brita PRO'
        }
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(413);
var toPrimitive = __webpack_require__(65);
var dP = Object.defineProperty;

exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(64);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(19);

var matrix = __webpack_require__(53);

/**
 * @module echarts/core/BoundingRect
 */
var v2ApplyTransform = vec2.applyTransform;
var mathMin = Math.min;
var mathMax = Math.max;
/**
 * @alias module:echarts/core/BoundingRect
 */

function BoundingRect(x, y, width, height) {
  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }
  /**
   * @type {number}
   */


  this.x = x;
  /**
   * @type {number}
   */

  this.y = y;
  /**
   * @type {number}
   */

  this.width = width;
  /**
   * @type {number}
   */

  this.height = height;
}

BoundingRect.prototype = {
  constructor: BoundingRect,

  /**
   * @param {module:echarts/core/BoundingRect} other
   */
  union: function (other) {
    var x = mathMin(other.x, this.x);
    var y = mathMin(other.y, this.y);
    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
    this.x = x;
    this.y = y;
  },

  /**
   * @param {Array.<number>} m
   * @methods
   */
  applyTransform: function () {
    var lt = [];
    var rb = [];
    var lb = [];
    var rt = [];
    return function (m) {
      // In case usage like this
      // el.getBoundingRect().applyTransform(el.transform)
      // And element has no transform
      if (!m) {
        return;
      }

      lt[0] = lb[0] = this.x;
      lt[1] = rt[1] = this.y;
      rb[0] = rt[0] = this.x + this.width;
      rb[1] = lb[1] = this.y + this.height;
      v2ApplyTransform(lt, lt, m);
      v2ApplyTransform(rb, rb, m);
      v2ApplyTransform(lb, lb, m);
      v2ApplyTransform(rt, rt, m);
      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
      this.width = maxX - this.x;
      this.height = maxY - this.y;
    };
  }(),

  /**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */
  calculateTransform: function (b) {
    var a = this;
    var sx = b.width / a.width;
    var sy = b.height / a.height;
    var m = matrix.create(); // 矩阵右乘

    matrix.translate(m, m, [-a.x, -a.y]);
    matrix.scale(m, m, [sx, sy]);
    matrix.translate(m, m, [b.x, b.y]);
    return m;
  },

  /**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */
  intersect: function (b) {
    if (!b) {
      return false;
    }

    if (!(b instanceof BoundingRect)) {
      // Normalize negative width/height.
      b = BoundingRect.create(b);
    }

    var a = this;
    var ax0 = a.x;
    var ax1 = a.x + a.width;
    var ay0 = a.y;
    var ay1 = a.y + a.height;
    var bx0 = b.x;
    var bx1 = b.x + b.width;
    var by0 = b.y;
    var by1 = b.y + b.height;
    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
  },
  contain: function (x, y) {
    var rect = this;
    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
  },

  /**
   * @return {module:echarts/core/BoundingRect}
   */
  clone: function () {
    return new BoundingRect(this.x, this.y, this.width, this.height);
  },

  /**
   * Copy from another rect
   */
  copy: function (other) {
    this.x = other.x;
    this.y = other.y;
    this.width = other.width;
    this.height = other.height;
  },
  plain: function () {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }
};
/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */

BoundingRect.create = function (rect) {
  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
};

var _default = BoundingRect;
module.exports = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
var AWS;

/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */
var util = {
  environment: 'nodejs',
  engine: function engine() {
    if (util.isBrowser() && typeof navigator !== 'undefined') {
      return navigator.userAgent;
    } else {
      var engine = process.platform + '/' + process.version;
      if (__webpack_require__.i({"NODE_ENV":"production","manualUrl":"https://www.harps4.com/help/basic_operations.html","termsUrl":"https://www.harps4.com/terms.html","privacyUrl":"https://www.harps4.com/privacy.html"}).AWS_EXECUTION_ENV) {
        engine += ' exec-env/' + __webpack_require__.i({"NODE_ENV":"production","manualUrl":"https://www.harps4.com/help/basic_operations.html","termsUrl":"https://www.harps4.com/terms.html","privacyUrl":"https://www.harps4.com/privacy.html"}).AWS_EXECUTION_ENV;
      }
      return engine;
    }
  },

  userAgent: function userAgent() {
    var name = util.environment;
    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(10).VERSION;
    if (name === 'nodejs') agent += ' ' + util.engine();
    return agent;
  },

  isBrowser: function isBrowser() { return process && process.browser; },
  isNode: function isNode() { return !util.isBrowser(); },
  uriEscape: function uriEscape(string) {
    var output = encodeURIComponent(string);
    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[*]/g, function(ch) {
      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
    });

    return output;
  },

  uriEscapePath: function uriEscapePath(string) {
    var parts = [];
    util.arrayEach(string.split('/'), function (part) {
      parts.push(util.uriEscape(part));
    });
    return parts.join('/');
  },

  urlParse: function urlParse(url) {
    return util.url.parse(url);
  },

  urlFormat: function urlFormat(url) {
    return util.url.format(url);
  },

  queryStringParse: function queryStringParse(qs) {
    return util.querystring.parse(qs);
  },

  queryParamsToString: function queryParamsToString(params) {
    var items = [];
    var escape = util.uriEscape;
    var sortedKeys = Object.keys(params).sort();

    util.arrayEach(sortedKeys, function(name) {
      var value = params[name];
      var ename = escape(name);
      var result = ename + '=';
      if (Array.isArray(value)) {
        var vals = [];
        util.arrayEach(value, function(item) { vals.push(escape(item)); });
        result = ename + '=' + vals.sort().join('&' + ename + '=');
      } else if (value !== undefined && value !== null) {
        result = ename + '=' + escape(value);
      }
      items.push(result);
    });

    return items.join('&');
  },

  readFileSync: function readFileSync(path) {
    if (util.isBrowser()) return null;
    return __webpack_require__(326).readFileSync(path, 'utf-8');
  },

  base64: {
    encode: function encode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 encode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      var buf = (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string) : new util.Buffer(string);
      return buf.toString('base64');
    },

    decode: function decode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 decode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string, 'base64') : new util.Buffer(string, 'base64');
    }

  },

  buffer: {
    toStream: function toStream(buffer) {
      if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);

      var readable = new (util.stream.Readable)();
      var pos = 0;
      readable._read = function(size) {
        if (pos >= buffer.length) return readable.push(null);

        var end = pos + size;
        if (end > buffer.length) end = buffer.length;
        readable.push(buffer.slice(pos, end));
        pos = end;
      };

      return readable;
    },

    /**
     * Concatenates a list of Buffer objects.
     */
    concat: function(buffers) {
      var length = 0,
          offset = 0,
          buffer = null, i;

      for (i = 0; i < buffers.length; i++) {
        length += buffers[i].length;
      }

      buffer = new util.Buffer(length);

      for (i = 0; i < buffers.length; i++) {
        buffers[i].copy(buffer, offset);
        offset += buffers[i].length;
      }

      return buffer;
    }
  },

  string: {
    byteLength: function byteLength(string) {
      if (string === null || string === undefined) return 0;
      if (typeof string === 'string') string = new util.Buffer(string);

      if (typeof string.byteLength === 'number') {
        return string.byteLength;
      } else if (typeof string.length === 'number') {
        return string.length;
      } else if (typeof string.size === 'number') {
        return string.size;
      } else if (typeof string.path === 'string') {
        return __webpack_require__(326).lstatSync(string.path).size;
      } else {
        throw util.error(new Error('Cannot determine length of ' + string),
          { object: string });
      }
    },

    upperFirst: function upperFirst(string) {
      return string[0].toUpperCase() + string.substr(1);
    },

    lowerFirst: function lowerFirst(string) {
      return string[0].toLowerCase() + string.substr(1);
    }
  },

  ini: {
    parse: function string(ini) {
      var currentSection, map = {};
      util.arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });

      return map;
    }
  },

  fn: {
    noop: function() {},

    /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */
    makeAsync: function makeAsync(fn, expectedArgs) {
      if (expectedArgs && expectedArgs <= fn.length) {
        return fn;
      }

      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        var callback = args.pop();
        var result = fn.apply(null, args);
        callback(result);
      };
    }
  },

  /**
   * Date and time utility functions.
   */
  date: {

    /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */
    getDate: function getDate() {
      if (!AWS) AWS = __webpack_require__(10);
      if (AWS.config.systemClockOffset) { // use offset when non-zero
        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
      } else {
        return new Date();
      }
    },

    /**
     * @return [String] the date in ISO-8601 format
     */
    iso8601: function iso8601(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
    },

    /**
     * @return [String] the date in RFC 822 format
     */
    rfc822: function rfc822(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toUTCString();
    },

    /**
     * @return [Integer] the UNIX timestamp value for the current time
     */
    unixTimestamp: function unixTimestamp(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.getTime() / 1000;
    },

    /**
     * @param [String,number,Date] date
     * @return [Date]
     */
    from: function format(date) {
      if (typeof date === 'number') {
        return new Date(date * 1000); // unix timestamp
      } else {
        return new Date(date);
      }
    },

    /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */
    format: function format(date, formatter) {
      if (!formatter) formatter = 'iso8601';
      return util.date[formatter](util.date.from(date));
    },

    parseTimestamp: function parseTimestamp(value) {
      if (typeof value === 'number') { // unix timestamp (number)
        return new Date(value * 1000);
      } else if (value.match(/^\d+$/)) { // unix timestamp
        return new Date(value * 1000);
      } else if (value.match(/^\d{4}/)) { // iso8601
        return new Date(value);
      } else if (value.match(/^\w{3},/)) { // rfc822
        return new Date(value);
      } else {
        throw util.error(
          new Error('unhandled timestamp format: ' + value),
          {code: 'TimestampParserError'});
      }
    }

  },

  crypto: {
    crc32Table: [
     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
     0x2D02EF8D],

    crc32: function crc32(data) {
      var tbl = util.crypto.crc32Table;
      var crc = 0 ^ -1;

      if (typeof data === 'string') {
        data = new util.Buffer(data);
      }

      for (var i = 0; i < data.length; i++) {
        var code = data.readUInt8(i);
        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
      }
      return (crc ^ -1) >>> 0;
    },

    hmac: function hmac(key, string, digest, fn) {
      if (!digest) digest = 'binary';
      if (digest === 'buffer') { digest = undefined; }
      if (!fn) fn = 'sha256';
      if (typeof string === 'string') string = new util.Buffer(string);
      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
    },

    md5: function md5(data, digest, callback) {
      return util.crypto.hash('md5', data, digest, callback);
    },

    sha256: function sha256(data, digest, callback) {
      return util.crypto.hash('sha256', data, digest, callback);
    },

    hash: function(algorithm, data, digest, callback) {
      var hash = util.crypto.createHash(algorithm);
      if (!digest) { digest = 'binary'; }
      if (digest === 'buffer') { digest = undefined; }
      if (typeof data === 'string') data = new util.Buffer(data);
      var sliceFn = util.arraySliceFn(data);
      var isBuffer = util.Buffer.isBuffer(data);
      //Identifying objects with an ArrayBuffer as buffers
      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

      if (callback && typeof data === 'object' &&
          typeof data.on === 'function' && !isBuffer) {
        data.on('data', function(chunk) { hash.update(chunk); });
        data.on('error', function(err) { callback(err); });
        data.on('end', function() { callback(null, hash.digest(digest)); });
      } else if (callback && sliceFn && !isBuffer &&
                 typeof FileReader !== 'undefined') {
        // this might be a File/Blob
        var index = 0, size = 1024 * 512;
        var reader = new FileReader();
        reader.onerror = function() {
          callback(new Error('Failed to read data.'));
        };
        reader.onload = function() {
          var buf = new util.Buffer(new Uint8Array(reader.result));
          hash.update(buf);
          index += buf.length;
          reader._continueReading();
        };
        reader._continueReading = function() {
          if (index >= data.size) {
            callback(null, hash.digest(digest));
            return;
          }

          var back = index + size;
          if (back > data.size) back = data.size;
          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
        };

        reader._continueReading();
      } else {
        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
          data = new util.Buffer(new Uint8Array(data));
        }
        var out = hash.update(data).digest(digest);
        if (callback) callback(null, out);
        return out;
      }
    },

    toHex: function toHex(data) {
      var out = [];
      for (var i = 0; i < data.length; i++) {
        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
      }
      return out.join('');
    },

    createHash: function createHash(algorithm) {
      return util.crypto.lib.createHash(algorithm);
    }

  },

  /** @!ignore */

  /* Abort constant */
  abort: {},

  each: function each(object, iterFunction) {
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        var ret = iterFunction.call(this, key, object[key]);
        if (ret === util.abort) break;
      }
    }
  },

  arrayEach: function arrayEach(array, iterFunction) {
    for (var idx in array) {
      if (Object.prototype.hasOwnProperty.call(array, idx)) {
        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
        if (ret === util.abort) break;
      }
    }
  },

  update: function update(obj1, obj2) {
    util.each(obj2, function iterator(key, item) {
      obj1[key] = item;
    });
    return obj1;
  },

  merge: function merge(obj1, obj2) {
    return util.update(util.copy(obj1), obj2);
  },

  copy: function copy(object) {
    if (object === null || object === undefined) return object;
    var dupe = {};
    // jshint forin:false
    for (var key in object) {
      dupe[key] = object[key];
    }
    return dupe;
  },

  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  arraySliceFn: function arraySliceFn(obj) {
    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
    return typeof fn === 'function' ? fn : null;
  },

  isType: function isType(obj, type) {
    // handle cross-"frame" objects
    if (typeof type === 'function') type = util.typeName(type);
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
  },

  typeName: function typeName(type) {
    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
    var str = type.toString();
    var match = str.match(/^\s*function (.+)\(/);
    return match ? match[1] : str;
  },

  error: function error(err, options) {
    var originalError = null;
    if (typeof err.message === 'string' && err.message !== '') {
      if (typeof options === 'string' || (options && options.message)) {
        originalError = util.copy(err);
        originalError.message = err.message;
      }
    }
    err.message = err.message || null;

    if (typeof options === 'string') {
      err.message = options;
    } else if (typeof options === 'object' && options !== null) {
      util.update(err, options);
      if (options.message)
        err.message = options.message;
      if (options.code || options.name)
        err.code = options.code || options.name;
      if (options.stack)
        err.stack = options.stack;
    }

    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
      Object.defineProperty(err, 'message', {enumerable: true});
    }

    err.name = options && options.name || err.name || err.code || 'Error';
    err.time = new Date();

    if (originalError) err.originalError = originalError;

    return err;
  },

  /**
   * @api private
   */
  inherit: function inherit(klass, features) {
    var newObject = null;
    if (features === undefined) {
      features = klass;
      klass = Object;
      newObject = {};
    } else {
      var ctor = function ConstructorWrapper() {};
      ctor.prototype = klass.prototype;
      newObject = new ctor();
    }

    // constructor not supplied, create pass-through ctor
    if (features.constructor === Object) {
      features.constructor = function() {
        if (klass !== Object) {
          return klass.apply(this, arguments);
        }
      };
    }

    features.constructor.prototype = newObject;
    util.update(features.constructor.prototype, features);
    features.constructor.__super__ = klass;
    return features.constructor;
  },

  /**
   * @api private
   */
  mixin: function mixin() {
    var klass = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      // jshint forin:false
      for (var prop in arguments[i].prototype) {
        var fn = arguments[i].prototype[prop];
        if (prop !== 'constructor') {
          klass.prototype[prop] = fn;
        }
      }
    }
    return klass;
  },

  /**
   * @api private
   */
  hideProperties: function hideProperties(obj, props) {
    if (typeof Object.defineProperty !== 'function') return;

    util.arrayEach(props, function (key) {
      Object.defineProperty(obj, key, {
        enumerable: false, writable: true, configurable: true });
    });
  },

  /**
   * @api private
   */
  property: function property(obj, name, value, enumerable, isValue) {
    var opts = {
      configurable: true,
      enumerable: enumerable !== undefined ? enumerable : true
    };
    if (typeof value === 'function' && !isValue) {
      opts.get = value;
    }
    else {
      opts.value = value; opts.writable = true;
    }

    Object.defineProperty(obj, name, opts);
  },

  /**
   * @api private
   */
  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
    var cachedValue = null;

    // build enumerable attribute for each value with lazy accessor.
    util.property(obj, name, function() {
      if (cachedValue === null) {
        cachedValue = get();
      }
      return cachedValue;
    }, enumerable);
  },

  /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */
  hoistPayloadMember: function hoistPayloadMember(resp) {
    var req = resp.request;
    var operation = req.operation;
    var output = req.service.api.operations[operation].output;
    if (output.payload) {
      var payloadMember = output.members[output.payload];
      var responsePayload = resp.data[output.payload];
      if (payloadMember.type === 'structure') {
        util.each(responsePayload, function(key, value) {
          util.property(resp.data, key, value, false);
        });
      }
    }
  },

  /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */
  computeSha256: function computeSha256(body, done) {
    if (util.isNode()) {
      var Stream = util.stream.Stream;
      var fs = __webpack_require__(326);
      if (body instanceof Stream) {
        if (typeof body.path === 'string') { // assume file object
          var settings = {};
          if (typeof body.start === 'number') {
            settings.start = body.start;
          }
          if (typeof body.end === 'number') {
            settings.end = body.end;
          }
          body = fs.createReadStream(body.path, settings);
        } else { // TODO support other stream types
          return done(new Error('Non-file stream objects are ' +
                                'not supported with SigV4'));
        }
      }
    }

    util.crypto.sha256(body, 'hex', function(err, sha) {
      if (err) done(err);
      else done(null, sha);
    });
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(serverTime) {
    if (serverTime) {
      util.property(AWS.config, 'isClockSkewed',
        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
      return AWS.config.isClockSkewed;
    }
  },

  applyClockOffset: function applyClockOffset(serverTime) {
    if (serverTime)
      AWS.config.systemClockOffset = serverTime - new Date().getTime();
  },

  /**
   * @api private
   */
  extractRequestId: function extractRequestId(resp) {
    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
                     resp.httpResponse.headers['x-amzn-requestid'];

    if (!requestId && resp.data && resp.data.ResponseMetadata) {
      requestId = resp.data.ResponseMetadata.RequestId;
    }

    if (requestId) {
      resp.requestId = requestId;
    }

    if (resp.error) {
      resp.error.requestId = requestId;
    }
  },

  /**
   * @api private
   */
  addPromises: function addPromises(constructors, PromiseDependency) {
    if (PromiseDependency === undefined && AWS && AWS.config) {
      PromiseDependency = AWS.config.getPromisesDependency();
    }
    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
      PromiseDependency = Promise;
    }
    if (typeof PromiseDependency !== 'function') var deletePromises = true;
    if (!Array.isArray(constructors)) constructors = [constructors];

    for (var ind = 0; ind < constructors.length; ind++) {
      var constructor = constructors[ind];
      if (deletePromises) {
        if (constructor.deletePromisesFromClass) {
          constructor.deletePromisesFromClass();
        }
      } else if (constructor.addPromisesToClass) {
        constructor.addPromisesToClass(PromiseDependency);
      }
    }
  },

  /**
   * @api private
   */
  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
    return function promise() {
      var self = this;
      return new PromiseDependency(function(resolve, reject) {
        self[methodName](function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };
  },

  /**
   * @api private
   */
  isDualstackAvailable: function isDualstackAvailable(service) {
    if (!service) return false;
    var metadata = __webpack_require__(724);
    if (typeof service !== 'string') service = service.serviceIdentifier;
    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
    return !!metadata[service].dualstackAvailable;
  },

  /**
   * @api private
   */
  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
    if (!retryDelayOptions) retryDelayOptions = {};
    var customBackoff = retryDelayOptions.customBackoff || null;
    if (typeof customBackoff === 'function') {
      return customBackoff(retryCount);
    }
    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
    var delay = Math.random() * (Math.pow(2, retryCount) * base);
    return delay;
  },

  /**
   * @api private
   */
  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
    if (!options) options = {};
    var http = AWS.HttpClient.getInstance();
    var httpOptions = options.httpOptions || {};
    var retryCount = 0;

    var errCallback = function(err) {
      var maxRetries = options.maxRetries || 0;
      if (err && err.code === 'TimeoutError') err.retryable = true;
      if (err && err.retryable && retryCount < maxRetries) {
        retryCount++;
        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
        setTimeout(sendRequest, delay + (err.retryAfter || 0));
      } else {
        cb(err);
      }
    };

    var sendRequest = function() {
      var data = '';
      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
        httpResponse.on('end', function() {
          var statusCode = httpResponse.statusCode;
          if (statusCode < 300) {
            cb(null, data);
          } else {
            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
            var err = util.error(new Error(),
              { retryable: statusCode >= 500 || statusCode === 429 }
            );
            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
            errCallback(err);
          }
        });
      }, errCallback);
    };

    AWS.util.defer(sendRequest);
  },

  /**
   * @api private
   */
  uuid: {
    v4: function uuidV4() {
      return __webpack_require__(667).v4();
    }
  },

  /**
   * @api private
   */
  convertPayloadToString: function convertPayloadToString(resp) {
    var req = resp.request;
    var operation = req.operation;
    var rules = req.service.api.operations[operation].output || {};
    if (rules.payload && resp.data[rules.payload]) {
      resp.data[rules.payload] = resp.data[rules.payload].toString();
    }
  },

  /**
   * @api private
   */
  defer: function defer(callback) {
    if (typeof process === 'object' && typeof process.nextTick === 'function') {
      process.nextTick(callback);
    } else if (typeof setImmediate === 'function') {
      setImmediate(callback);
    } else {
      setTimeout(callback, 0);
    }
  },

  /**
   * @api private
   */
  defaultProfile: 'default',

  /**
   * @api private
   */
  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

  /**
   * @api private
   */
  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

  /**
   * @api private
   */
  sharedConfigFileEnv: 'AWS_CONFIG_FILE'
};

module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69), __webpack_require__(301).setImmediate))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
var AWS;

/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */
var util = {
  environment: 'nodejs',
  engine: function engine() {
    if (util.isBrowser() && typeof navigator !== 'undefined') {
      return navigator.userAgent;
    } else {
      var engine = process.platform + '/' + process.version;
      if (__webpack_require__.i({"NODE_ENV":"production","manualUrl":"https://www.harps4.com/help/basic_operations.html","termsUrl":"https://www.harps4.com/terms.html","privacyUrl":"https://www.harps4.com/privacy.html"}).AWS_EXECUTION_ENV) {
        engine += ' exec-env/' + __webpack_require__.i({"NODE_ENV":"production","manualUrl":"https://www.harps4.com/help/basic_operations.html","termsUrl":"https://www.harps4.com/terms.html","privacyUrl":"https://www.harps4.com/privacy.html"}).AWS_EXECUTION_ENV;
      }
      return engine;
    }
  },

  userAgent: function userAgent() {
    var name = util.environment;
    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(3).VERSION;
    if (name === 'nodejs') agent += ' ' + util.engine();
    return agent;
  },

  isBrowser: function isBrowser() { return process && process.browser; },
  isNode: function isNode() { return !util.isBrowser(); },
  uriEscape: function uriEscape(string) {
    var output = encodeURIComponent(string);
    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[*]/g, function(ch) {
      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
    });

    return output;
  },

  uriEscapePath: function uriEscapePath(string) {
    var parts = [];
    util.arrayEach(string.split('/'), function (part) {
      parts.push(util.uriEscape(part));
    });
    return parts.join('/');
  },

  urlParse: function urlParse(url) {
    return util.url.parse(url);
  },

  urlFormat: function urlFormat(url) {
    return util.url.format(url);
  },

  queryStringParse: function queryStringParse(qs) {
    return util.querystring.parse(qs);
  },

  queryParamsToString: function queryParamsToString(params) {
    var items = [];
    var escape = util.uriEscape;
    var sortedKeys = Object.keys(params).sort();

    util.arrayEach(sortedKeys, function(name) {
      var value = params[name];
      var ename = escape(name);
      var result = ename + '=';
      if (Array.isArray(value)) {
        var vals = [];
        util.arrayEach(value, function(item) { vals.push(escape(item)); });
        result = ename + '=' + vals.sort().join('&' + ename + '=');
      } else if (value !== undefined && value !== null) {
        result = ename + '=' + escape(value);
      }
      items.push(result);
    });

    return items.join('&');
  },

  readFileSync: function readFileSync(path) {
    if (util.isBrowser()) return null;
    return __webpack_require__(327).readFileSync(path, 'utf-8');
  },

  base64: {
    encode: function encode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 encode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      var buf = (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string) : new util.Buffer(string);
      return buf.toString('base64');
    },

    decode: function decode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 decode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string, 'base64') : new util.Buffer(string, 'base64');
    }

  },

  buffer: {
    toStream: function toStream(buffer) {
      if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);

      var readable = new (util.stream.Readable)();
      var pos = 0;
      readable._read = function(size) {
        if (pos >= buffer.length) return readable.push(null);

        var end = pos + size;
        if (end > buffer.length) end = buffer.length;
        readable.push(buffer.slice(pos, end));
        pos = end;
      };

      return readable;
    },

    /**
     * Concatenates a list of Buffer objects.
     */
    concat: function(buffers) {
      var length = 0,
          offset = 0,
          buffer = null, i;

      for (i = 0; i < buffers.length; i++) {
        length += buffers[i].length;
      }

      buffer = new util.Buffer(length);

      for (i = 0; i < buffers.length; i++) {
        buffers[i].copy(buffer, offset);
        offset += buffers[i].length;
      }

      return buffer;
    }
  },

  string: {
    byteLength: function byteLength(string) {
      if (string === null || string === undefined) return 0;
      if (typeof string === 'string') string = new util.Buffer(string);

      if (typeof string.byteLength === 'number') {
        return string.byteLength;
      } else if (typeof string.length === 'number') {
        return string.length;
      } else if (typeof string.size === 'number') {
        return string.size;
      } else if (typeof string.path === 'string') {
        return __webpack_require__(327).lstatSync(string.path).size;
      } else {
        throw util.error(new Error('Cannot determine length of ' + string),
          { object: string });
      }
    },

    upperFirst: function upperFirst(string) {
      return string[0].toUpperCase() + string.substr(1);
    },

    lowerFirst: function lowerFirst(string) {
      return string[0].toLowerCase() + string.substr(1);
    }
  },

  ini: {
    parse: function string(ini) {
      var currentSection, map = {};
      util.arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });

      return map;
    }
  },

  fn: {
    noop: function() {},

    /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */
    makeAsync: function makeAsync(fn, expectedArgs) {
      if (expectedArgs && expectedArgs <= fn.length) {
        return fn;
      }

      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        var callback = args.pop();
        var result = fn.apply(null, args);
        callback(result);
      };
    }
  },

  /**
   * Date and time utility functions.
   */
  date: {

    /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */
    getDate: function getDate() {
      if (!AWS) AWS = __webpack_require__(3);
      if (AWS.config.systemClockOffset) { // use offset when non-zero
        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
      } else {
        return new Date();
      }
    },

    /**
     * @return [String] the date in ISO-8601 format
     */
    iso8601: function iso8601(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
    },

    /**
     * @return [String] the date in RFC 822 format
     */
    rfc822: function rfc822(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toUTCString();
    },

    /**
     * @return [Integer] the UNIX timestamp value for the current time
     */
    unixTimestamp: function unixTimestamp(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.getTime() / 1000;
    },

    /**
     * @param [String,number,Date] date
     * @return [Date]
     */
    from: function format(date) {
      if (typeof date === 'number') {
        return new Date(date * 1000); // unix timestamp
      } else {
        return new Date(date);
      }
    },

    /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */
    format: function format(date, formatter) {
      if (!formatter) formatter = 'iso8601';
      return util.date[formatter](util.date.from(date));
    },

    parseTimestamp: function parseTimestamp(value) {
      if (typeof value === 'number') { // unix timestamp (number)
        return new Date(value * 1000);
      } else if (value.match(/^\d+$/)) { // unix timestamp
        return new Date(value * 1000);
      } else if (value.match(/^\d{4}/)) { // iso8601
        return new Date(value);
      } else if (value.match(/^\w{3},/)) { // rfc822
        return new Date(value);
      } else {
        throw util.error(
          new Error('unhandled timestamp format: ' + value),
          {code: 'TimestampParserError'});
      }
    }

  },

  crypto: {
    crc32Table: [
     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
     0x2D02EF8D],

    crc32: function crc32(data) {
      var tbl = util.crypto.crc32Table;
      var crc = 0 ^ -1;

      if (typeof data === 'string') {
        data = new util.Buffer(data);
      }

      for (var i = 0; i < data.length; i++) {
        var code = data.readUInt8(i);
        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
      }
      return (crc ^ -1) >>> 0;
    },

    hmac: function hmac(key, string, digest, fn) {
      if (!digest) digest = 'binary';
      if (digest === 'buffer') { digest = undefined; }
      if (!fn) fn = 'sha256';
      if (typeof string === 'string') string = new util.Buffer(string);
      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
    },

    md5: function md5(data, digest, callback) {
      return util.crypto.hash('md5', data, digest, callback);
    },

    sha256: function sha256(data, digest, callback) {
      return util.crypto.hash('sha256', data, digest, callback);
    },

    hash: function(algorithm, data, digest, callback) {
      var hash = util.crypto.createHash(algorithm);
      if (!digest) { digest = 'binary'; }
      if (digest === 'buffer') { digest = undefined; }
      if (typeof data === 'string') data = new util.Buffer(data);
      var sliceFn = util.arraySliceFn(data);
      var isBuffer = util.Buffer.isBuffer(data);
      //Identifying objects with an ArrayBuffer as buffers
      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

      if (callback && typeof data === 'object' &&
          typeof data.on === 'function' && !isBuffer) {
        data.on('data', function(chunk) { hash.update(chunk); });
        data.on('error', function(err) { callback(err); });
        data.on('end', function() { callback(null, hash.digest(digest)); });
      } else if (callback && sliceFn && !isBuffer &&
                 typeof FileReader !== 'undefined') {
        // this might be a File/Blob
        var index = 0, size = 1024 * 512;
        var reader = new FileReader();
        reader.onerror = function() {
          callback(new Error('Failed to read data.'));
        };
        reader.onload = function() {
          var buf = new util.Buffer(new Uint8Array(reader.result));
          hash.update(buf);
          index += buf.length;
          reader._continueReading();
        };
        reader._continueReading = function() {
          if (index >= data.size) {
            callback(null, hash.digest(digest));
            return;
          }

          var back = index + size;
          if (back > data.size) back = data.size;
          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
        };

        reader._continueReading();
      } else {
        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
          data = new util.Buffer(new Uint8Array(data));
        }
        var out = hash.update(data).digest(digest);
        if (callback) callback(null, out);
        return out;
      }
    },

    toHex: function toHex(data) {
      var out = [];
      for (var i = 0; i < data.length; i++) {
        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
      }
      return out.join('');
    },

    createHash: function createHash(algorithm) {
      return util.crypto.lib.createHash(algorithm);
    }

  },

  /** @!ignore */

  /* Abort constant */
  abort: {},

  each: function each(object, iterFunction) {
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        var ret = iterFunction.call(this, key, object[key]);
        if (ret === util.abort) break;
      }
    }
  },

  arrayEach: function arrayEach(array, iterFunction) {
    for (var idx in array) {
      if (Object.prototype.hasOwnProperty.call(array, idx)) {
        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
        if (ret === util.abort) break;
      }
    }
  },

  update: function update(obj1, obj2) {
    util.each(obj2, function iterator(key, item) {
      obj1[key] = item;
    });
    return obj1;
  },

  merge: function merge(obj1, obj2) {
    return util.update(util.copy(obj1), obj2);
  },

  copy: function copy(object) {
    if (object === null || object === undefined) return object;
    var dupe = {};
    // jshint forin:false
    for (var key in object) {
      dupe[key] = object[key];
    }
    return dupe;
  },

  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  arraySliceFn: function arraySliceFn(obj) {
    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
    return typeof fn === 'function' ? fn : null;
  },

  isType: function isType(obj, type) {
    // handle cross-"frame" objects
    if (typeof type === 'function') type = util.typeName(type);
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
  },

  typeName: function typeName(type) {
    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
    var str = type.toString();
    var match = str.match(/^\s*function (.+)\(/);
    return match ? match[1] : str;
  },

  error: function error(err, options) {
    var originalError = null;
    if (typeof err.message === 'string' && err.message !== '') {
      if (typeof options === 'string' || (options && options.message)) {
        originalError = util.copy(err);
        originalError.message = err.message;
      }
    }
    err.message = err.message || null;

    if (typeof options === 'string') {
      err.message = options;
    } else if (typeof options === 'object' && options !== null) {
      util.update(err, options);
      if (options.message)
        err.message = options.message;
      if (options.code || options.name)
        err.code = options.code || options.name;
      if (options.stack)
        err.stack = options.stack;
    }

    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
      Object.defineProperty(err, 'message', {enumerable: true});
    }

    err.name = options && options.name || err.name || err.code || 'Error';
    err.time = new Date();

    if (originalError) err.originalError = originalError;

    return err;
  },

  /**
   * @api private
   */
  inherit: function inherit(klass, features) {
    var newObject = null;
    if (features === undefined) {
      features = klass;
      klass = Object;
      newObject = {};
    } else {
      var ctor = function ConstructorWrapper() {};
      ctor.prototype = klass.prototype;
      newObject = new ctor();
    }

    // constructor not supplied, create pass-through ctor
    if (features.constructor === Object) {
      features.constructor = function() {
        if (klass !== Object) {
          return klass.apply(this, arguments);
        }
      };
    }

    features.constructor.prototype = newObject;
    util.update(features.constructor.prototype, features);
    features.constructor.__super__ = klass;
    return features.constructor;
  },

  /**
   * @api private
   */
  mixin: function mixin() {
    var klass = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      // jshint forin:false
      for (var prop in arguments[i].prototype) {
        var fn = arguments[i].prototype[prop];
        if (prop !== 'constructor') {
          klass.prototype[prop] = fn;
        }
      }
    }
    return klass;
  },

  /**
   * @api private
   */
  hideProperties: function hideProperties(obj, props) {
    if (typeof Object.defineProperty !== 'function') return;

    util.arrayEach(props, function (key) {
      Object.defineProperty(obj, key, {
        enumerable: false, writable: true, configurable: true });
    });
  },

  /**
   * @api private
   */
  property: function property(obj, name, value, enumerable, isValue) {
    var opts = {
      configurable: true,
      enumerable: enumerable !== undefined ? enumerable : true
    };
    if (typeof value === 'function' && !isValue) {
      opts.get = value;
    }
    else {
      opts.value = value; opts.writable = true;
    }

    Object.defineProperty(obj, name, opts);
  },

  /**
   * @api private
   */
  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
    var cachedValue = null;

    // build enumerable attribute for each value with lazy accessor.
    util.property(obj, name, function() {
      if (cachedValue === null) {
        cachedValue = get();
      }
      return cachedValue;
    }, enumerable);
  },

  /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */
  hoistPayloadMember: function hoistPayloadMember(resp) {
    var req = resp.request;
    var operation = req.operation;
    var output = req.service.api.operations[operation].output;
    if (output.payload) {
      var payloadMember = output.members[output.payload];
      var responsePayload = resp.data[output.payload];
      if (payloadMember.type === 'structure') {
        util.each(responsePayload, function(key, value) {
          util.property(resp.data, key, value, false);
        });
      }
    }
  },

  /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */
  computeSha256: function computeSha256(body, done) {
    if (util.isNode()) {
      var Stream = util.stream.Stream;
      var fs = __webpack_require__(327);
      if (body instanceof Stream) {
        if (typeof body.path === 'string') { // assume file object
          var settings = {};
          if (typeof body.start === 'number') {
            settings.start = body.start;
          }
          if (typeof body.end === 'number') {
            settings.end = body.end;
          }
          body = fs.createReadStream(body.path, settings);
        } else { // TODO support other stream types
          return done(new Error('Non-file stream objects are ' +
                                'not supported with SigV4'));
        }
      }
    }

    util.crypto.sha256(body, 'hex', function(err, sha) {
      if (err) done(err);
      else done(null, sha);
    });
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(serverTime) {
    if (serverTime) {
      util.property(AWS.config, 'isClockSkewed',
        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
      return AWS.config.isClockSkewed;
    }
  },

  applyClockOffset: function applyClockOffset(serverTime) {
    if (serverTime)
      AWS.config.systemClockOffset = serverTime - new Date().getTime();
  },

  /**
   * @api private
   */
  extractRequestId: function extractRequestId(resp) {
    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
                     resp.httpResponse.headers['x-amzn-requestid'];

    if (!requestId && resp.data && resp.data.ResponseMetadata) {
      requestId = resp.data.ResponseMetadata.RequestId;
    }

    if (requestId) {
      resp.requestId = requestId;
    }

    if (resp.error) {
      resp.error.requestId = requestId;
    }
  },

  /**
   * @api private
   */
  addPromises: function addPromises(constructors, PromiseDependency) {
    if (PromiseDependency === undefined && AWS && AWS.config) {
      PromiseDependency = AWS.config.getPromisesDependency();
    }
    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
      PromiseDependency = Promise;
    }
    if (typeof PromiseDependency !== 'function') var deletePromises = true;
    if (!Array.isArray(constructors)) constructors = [constructors];

    for (var ind = 0; ind < constructors.length; ind++) {
      var constructor = constructors[ind];
      if (deletePromises) {
        if (constructor.deletePromisesFromClass) {
          constructor.deletePromisesFromClass();
        }
      } else if (constructor.addPromisesToClass) {
        constructor.addPromisesToClass(PromiseDependency);
      }
    }
  },

  /**
   * @api private
   */
  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
    return function promise() {
      var self = this;
      return new PromiseDependency(function(resolve, reject) {
        self[methodName](function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };
  },

  /**
   * @api private
   */
  isDualstackAvailable: function isDualstackAvailable(service) {
    if (!service) return false;
    var metadata = __webpack_require__(863);
    if (typeof service !== 'string') service = service.serviceIdentifier;
    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
    return !!metadata[service].dualstackAvailable;
  },

  /**
   * @api private
   */
  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
    if (!retryDelayOptions) retryDelayOptions = {};
    var customBackoff = retryDelayOptions.customBackoff || null;
    if (typeof customBackoff === 'function') {
      return customBackoff(retryCount);
    }
    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
    var delay = Math.random() * (Math.pow(2, retryCount) * base);
    return delay;
  },

  /**
   * @api private
   */
  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
    if (!options) options = {};
    var http = AWS.HttpClient.getInstance();
    var httpOptions = options.httpOptions || {};
    var retryCount = 0;

    var errCallback = function(err) {
      var maxRetries = options.maxRetries || 0;
      if (err && err.code === 'TimeoutError') err.retryable = true;
      if (err && err.retryable && retryCount < maxRetries) {
        retryCount++;
        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
        setTimeout(sendRequest, delay + (err.retryAfter || 0));
      } else {
        cb(err);
      }
    };

    var sendRequest = function() {
      var data = '';
      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
        httpResponse.on('end', function() {
          var statusCode = httpResponse.statusCode;
          if (statusCode < 300) {
            cb(null, data);
          } else {
            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
            var err = util.error(new Error(),
              { retryable: statusCode >= 500 || statusCode === 429 }
            );
            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
            errCallback(err);
          }
        });
      }, errCallback);
    };

    AWS.util.defer(sendRequest);
  },

  /**
   * @api private
   */
  uuid: {
    v4: function uuidV4() {
      return __webpack_require__(667).v4();
    }
  },

  /**
   * @api private
   */
  convertPayloadToString: function convertPayloadToString(resp) {
    var req = resp.request;
    var operation = req.operation;
    var rules = req.service.api.operations[operation].output || {};
    if (rules.payload && resp.data[rules.payload]) {
      resp.data[rules.payload] = resp.data[rules.payload].toString();
    }
  },

  /**
   * @api private
   */
  defer: function defer(callback) {
    if (typeof process === 'object' && typeof process.nextTick === 'function') {
      process.nextTick(callback);
    } else if (typeof setImmediate === 'function') {
      setImmediate(callback);
    } else {
      setTimeout(callback, 0);
    }
  },

  /**
   * @api private
   */
  defaultProfile: 'default',

  /**
   * @api private
   */
  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

  /**
   * @api private
   */
  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

  /**
   * @api private
   */
  sharedConfigFileEnv: 'AWS_CONFIG_FILE'
};

module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69), __webpack_require__(301).setImmediate))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var clazzUtil = __webpack_require__(75);

var lineStyleMixin = __webpack_require__(1608);

var areaStyleMixin = __webpack_require__(1605);

var textStyleMixin = __webpack_require__(1609);

var itemStyleMixin = __webpack_require__(1607);

/**
 * @module echarts/model/Model
 */
var mixin = zrUtil.mixin;
/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */

function Model(option, parentModel, ecModel) {
  /**
   * @type {module:echarts/model/Model}
   * @readOnly
   */
  this.parentModel = parentModel;
  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */

  this.ecModel = ecModel;
  /**
   * @type {Object}
   * @protected
   */

  this.option = option; // Simple optimization
  // if (this.init) {
  //     if (arguments.length <= 4) {
  //         this.init(option, parentModel, ecModel, extraOpt);
  //     }
  //     else {
  //         this.init.apply(this, arguments);
  //     }
  // }
}

Model.prototype = {
  constructor: Model,

  /**
   * Model 的初始化函数
   * @param {Object} option
   */
  init: null,

  /**
   * 从新的 Option merge
   */
  mergeOption: function (option) {
    zrUtil.merge(this.option, option, true);
  },

  /**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  get: function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
  },

  /**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  getShallow: function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];
    var parentModel = !ignoreParent && getParent(this, key);

    if (val == null && parentModel) {
      val = parentModel.getShallow(key);
    }

    return val;
  },

  /**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path, parentModel) {
    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
    var thisParentModel;
    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
    return new Model(obj, parentModel, this.ecModel);
  },

  /**
   * If model has option
   */
  isEmpty: function () {
    return this.option == null;
  },
  restoreData: function () {},
  // Pending
  clone: function () {
    var Ctor = this.constructor;
    return new Ctor(zrUtil.clone(this.option));
  },
  setReadOnly: function (properties) {
    clazzUtil.setReadOnly(this, properties);
  },
  // If path is null/undefined, return null/undefined.
  parsePath: function (path) {
    if (typeof path === 'string') {
      path = path.split('.');
    }

    return path;
  },

  /**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */
  customizeGetParent: function (getParentMethod) {
    clazzUtil.set(this, 'getParent', getParentMethod);
  },
  isAnimationEnabled: function () {
    if (!env.node) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  }
};

function doGet(obj, pathArr, parentModel) {
  for (var i = 0; i < pathArr.length; i++) {
    // Ignore empty
    if (!pathArr[i]) {
      continue;
    } // obj could be number/string/... (like 0)


    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

    if (obj == null) {
      break;
    }
  }

  if (obj == null && parentModel) {
    obj = parentModel.get(pathArr);
  }

  return obj;
} // `path` can be null/undefined


function getParent(model, path) {
  var getParentMethod = clazzUtil.get(model, 'getParent');
  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
} // Enable Model.extend.


clazzUtil.enableClassExtend(Model);
mixin(Model, lineStyleMixin);
mixin(Model, areaStyleMixin);
mixin(Model, textStyleMixin);
mixin(Model, itemStyleMixin);
var _default = Model;
module.exports = _default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(62);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var Model = __webpack_require__(29);

var DataDiffer = __webpack_require__(117);

var modelUtil = __webpack_require__(15);

/**
 * List for data storage
 * @module echarts/data/List
 */
var isObject = zrUtil.isObject;
var UNDEFINED = 'undefined';
var globalObj = typeof window === UNDEFINED ? global : window;
var dataCtors = {
  'float': typeof globalObj.Float64Array === UNDEFINED ? Array : globalObj.Float64Array,
  'int': typeof globalObj.Int32Array === UNDEFINED ? Array : globalObj.Int32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': Array
};
var TRANSFERABLE_PROPERTIES = ['stackedOn', 'hasItemOption', '_nameList', '_idList', '_rawData'];

function transferProperties(a, b) {
  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(b.__wrappedMethods || []), function (propName) {
    if (b.hasOwnProperty(propName)) {
      a[propName] = b[propName];
    }
  });
  a.__wrappedMethods = b.__wrappedMethods;
}

function DefaultDataProvider(dataArray) {
  this._array = dataArray || [];
}

DefaultDataProvider.prototype.pure = false;

DefaultDataProvider.prototype.count = function () {
  return this._array.length;
};

DefaultDataProvider.prototype.getItem = function (idx) {
  return this._array[idx];
};
/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 * @param {module:echarts/model/Model} hostModel
 */


var List = function (dimensions, hostModel) {
  dimensions = dimensions || ['x', 'y'];
  var dimensionInfos = {};
  var dimensionNames = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimensionName;
    var dimensionInfo = {};

    if (typeof dimensions[i] === 'string') {
      dimensionName = dimensions[i];
      dimensionInfo = {
        name: dimensionName,
        coordDim: dimensionName,
        coordDimIndex: 0,
        stackable: false,
        // Type can be 'float', 'int', 'number'
        // Default is number, Precision of float may not enough
        type: 'number'
      };
    } else {
      dimensionInfo = dimensions[i];
      dimensionName = dimensionInfo.name;
      dimensionInfo.type = dimensionInfo.type || 'number';

      if (!dimensionInfo.coordDim) {
        dimensionInfo.coordDim = dimensionName;
        dimensionInfo.coordDimIndex = 0;
      }
    }

    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
    dimensionNames.push(dimensionName);
    dimensionInfos[dimensionName] = dimensionInfo;
  }
  /**
   * @readOnly
   * @type {Array.<string>}
   */


  this.dimensions = dimensionNames;
  /**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */

  this._dimensionInfos = dimensionInfos;
  /**
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
  /**
   * @type {module:echarts/model/Model}
   */

  this.dataType;
  /**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */

  this.indices = [];
  /**
   * Data storage
   * @type {Object.<key, TypedArray|Array>}
   * @private
   */

  this._storage = {};
  /**
   * @type {Array.<string>}
   */

  this._nameList = [];
  /**
   * @type {Array.<string>}
   */

  this._idList = [];
  /**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */

  this._optionModels = [];
  /**
   * @param {module:echarts/data/List}
   */

  this.stackedOn = null;
  /**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */

  this._visual = {};
  /**
   * Globel layout properties.
   * @type {Object}
   * @private
   */

  this._layout = {};
  /**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */

  this._itemVisuals = [];
  /**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */

  this._itemLayouts = [];
  /**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */

  this._graphicEls = [];
  /**
   * @type {Array.<Array|Object>}
   * @private
   */

  this._rawData;
  /**
   * @type {Object}
   * @private
   */

  this._extent;
};

var listProto = List.prototype;
listProto.type = 'list';
/**
 * If each data item has it's own option
 * @type {boolean}
 */

listProto.hasItemOption = true;
/**
 * Get dimension name
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 * @return {string} Concrete dim name.
 */

listProto.getDimension = function (dim) {
  if (!isNaN(dim)) {
    dim = this.dimensions[dim] || dim;
  }

  return dim;
};
/**
 * Get type and stackable info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */


listProto.getDimensionInfo = function (dim) {
  return zrUtil.clone(this._dimensionInfos[this.getDimension(dim)]);
};
/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data
 * @param {Array.<string>} [nameList]
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */


listProto.initData = function (data, nameList, dimValueGetter) {
  data = data || [];
  var isDataArray = zrUtil.isArray(data);

  if (isDataArray) {
    data = new DefaultDataProvider(data);
  }

  this._rawData = data; // Clear

  var storage = this._storage = {};
  var indices = this.indices = [];
  var dimensions = this.dimensions;
  var dimensionInfoMap = this._dimensionInfos;
  var size = data.count();
  var idList = [];
  var nameRepeatCount = {};
  var nameDimIdx;
  nameList = nameList || []; // Init storage

  for (var i = 0; i < dimensions.length; i++) {
    var dimInfo = dimensionInfoMap[dimensions[i]];
    dimInfo.otherDims.itemName === 0 && (nameDimIdx = i);
    var DataCtor = dataCtors[dimInfo.type];
    storage[dimensions[i]] = new DataCtor(size);
  }

  var self = this;

  if (!dimValueGetter) {
    self.hasItemOption = false;
  } // Default dim value getter


  dimValueGetter = dimValueGetter || function (dataItem, dimName, dataIndex, dimIndex) {
    var value = modelUtil.getDataItemValue(dataItem); // If any dataItem is like { value: 10 }

    if (modelUtil.isDataItemOption(dataItem)) {
      self.hasItemOption = true;
    }

    return modelUtil.converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
    : value, dimensionInfoMap[dimName]);
  };

  for (var i = 0; i < size; i++) {
    // NOTICE: Try not to write things into dataItem
    var dataItem = data.getItem(i); // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of cateogry
    // Use a tempValue to normalize the value to be a (x, y) value
    // Store the data by dimensions

    for (var k = 0; k < dimensions.length; k++) {
      var dim = dimensions[k];
      var dimStorage = storage[dim]; // PENDING NULL is empty or zero

      dimStorage[i] = dimValueGetter(dataItem, dim, i, k);
    }

    indices.push(i);
  } // Use the name in option and create id


  for (var i = 0; i < size; i++) {
    var dataItem = data.getItem(i);

    if (!nameList[i] && dataItem) {
      if (dataItem.name != null) {
        nameList[i] = dataItem.name;
      } else if (nameDimIdx != null) {
        nameList[i] = storage[dimensions[nameDimIdx]][i];
      }
    }

    var name = nameList[i] || ''; // Try using the id in option

    var id = dataItem && dataItem.id;

    if (!id && name) {
      // Use name as id and add counter to avoid same name
      nameRepeatCount[name] = nameRepeatCount[name] || 0;
      id = name;

      if (nameRepeatCount[name] > 0) {
        id += '__ec__' + nameRepeatCount[name];
      }

      nameRepeatCount[name]++;
    }

    id && (idList[i] = id);
  }

  this._nameList = nameList;
  this._idList = idList;
};
/**
 * @return {number}
 */


listProto.count = function () {
  return this.indices.length;
};
/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.get = function (dim, idx, stack) {
  var storage = this._storage;
  var dataIndex = this.indices[idx]; // If value not exists

  if (dataIndex == null || !storage[dim]) {
    return NaN;
  }

  var value = storage[dim][dataIndex]; // FIXME ordinal data type is not stackable

  if (stack) {
    var dimensionInfo = this._dimensionInfos[dim];

    if (dimensionInfo && dimensionInfo.stackable) {
      var stackedOn = this.stackedOn;

      while (stackedOn) {
        // Get no stacked data of stacked on
        var stackedValue = stackedOn.get(dim, idx); // Considering positive stack, negative stack and empty data

        if (value >= 0 && stackedValue > 0 || // Positive stack
        value <= 0 && stackedValue < 0 // Negative stack
        ) {
            value += stackedValue;
          }

        stackedOn = stackedOn.stackedOn;
      }
    }
  }

  return value;
};
/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.getValues = function (dimensions, idx, stack) {
  var values = [];

  if (!zrUtil.isArray(dimensions)) {
    stack = idx;
    idx = dimensions;
    dimensions = this.dimensions;
  }

  for (var i = 0, len = dimensions.length; i < len; i++) {
    values.push(this.get(dimensions[i], idx, stack));
  }

  return values;
};
/**
 * If value is NaN. Inlcuding '-'
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */


listProto.hasValue = function (idx) {
  var dimensions = this.dimensions;
  var dimensionInfos = this._dimensionInfos;

  for (var i = 0, len = dimensions.length; i < len; i++) {
    if ( // Ordinal type can be string or number
    dimensionInfos[dimensions[i]].type !== 'ordinal' && isNaN(this.get(dimensions[i], idx))) {
      return false;
    }
  }

  return true;
};
/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 * @param {Function} filter
 */


listProto.getDataExtent = function (dim, stack, filter) {
  dim = this.getDimension(dim);
  var dimData = this._storage[dim];
  var dimInfo = this.getDimensionInfo(dim);
  stack = dimInfo && dimInfo.stackable && stack;
  var dimExtent = (this._extent || (this._extent = {}))[dim + !!stack];
  var value;

  if (dimExtent) {
    return dimExtent;
  } // var dimInfo = this._dimensionInfos[dim];


  if (dimData) {
    var min = Infinity;
    var max = -Infinity; // var isOrdinal = dimInfo.type === 'ordinal';

    for (var i = 0, len = this.count(); i < len; i++) {
      value = this.get(dim, i, stack); // FIXME
      // if (isOrdinal && typeof value === 'string') {
      //     value = zrUtil.indexOf(dimData, value);
      // }

      if (!filter || filter(value, dim, i)) {
        value < min && (min = value);
        value > max && (max = value);
      }
    }

    return this._extent[dim + !!stack] = [min, max];
  } else {
    return [Infinity, -Infinity];
  }
};
/**
 * Get sum of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */


listProto.getSum = function (dim, stack) {
  var dimData = this._storage[dim];
  var sum = 0;

  if (dimData) {
    for (var i = 0, len = this.count(); i < len; i++) {
      var value = this.get(dim, i, stack);

      if (!isNaN(value)) {
        sum += value;
      }
    }
  }

  return sum;
};
/**
 * Retreive the index with given value
 * @param {number} idx
 * @param {number} value
 * @return {number}
 */
// FIXME Precision of float value


listProto.indexOf = function (dim, value) {
  var storage = this._storage;
  var dimData = storage[dim];
  var indices = this.indices;

  if (dimData) {
    for (var i = 0, len = indices.length; i < len; i++) {
      var rawIndex = indices[i];

      if (dimData[rawIndex] === value) {
        return i;
      }
    }
  }

  return -1;
};
/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfName = function (name) {
  var indices = this.indices;
  var nameList = this._nameList;

  for (var i = 0, len = indices.length; i < len; i++) {
    var rawIndex = indices[i];

    if (nameList[rawIndex] === name) {
      return i;
    }
  }

  return -1;
};
/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfRawIndex = function (rawIndex) {
  // Indices are ascending
  var indices = this.indices; // If rawIndex === dataIndex

  var rawDataIndex = indices[rawIndex];

  if (rawDataIndex != null && rawDataIndex === rawIndex) {
    return rawIndex;
  }

  var left = 0;
  var right = indices.length - 1;

  while (left <= right) {
    var mid = (left + right) / 2 | 0;

    if (indices[mid] < rawIndex) {
      left = mid + 1;
    } else if (indices[mid] > rawIndex) {
      right = mid - 1;
    } else {
      return mid;
    }
  }

  return -1;
};
/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {boolean} stack If given value is after stacked
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} Considere multiple points has the same value.
 */


listProto.indicesOfNearest = function (dim, value, stack, maxDistance) {
  var storage = this._storage;
  var dimData = storage[dim];
  var nearestIndices = [];

  if (!dimData) {
    return nearestIndices;
  }

  if (maxDistance == null) {
    maxDistance = Infinity;
  }

  var minDist = Number.MAX_VALUE;
  var minDiff = -1;

  for (var i = 0, len = this.count(); i < len; i++) {
    var diff = value - this.get(dim, i, stack);
    var dist = Math.abs(diff);

    if (diff <= maxDistance && dist <= minDist) {
      // For the case of two data are same on xAxis, which has sequence data.
      // Show the nearest index
      // https://github.com/ecomfe/echarts/issues/2869
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        nearestIndices.length = 0;
      }

      nearestIndices.push(i);
    }
  }

  return nearestIndices;
};
/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */


listProto.getRawIndex = function (idx) {
  var rawIdx = this.indices[idx];
  return rawIdx == null ? -1 : rawIdx;
};
/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */


listProto.getRawDataItem = function (idx) {
  return this._rawData.getItem(this.getRawIndex(idx));
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getName = function (idx) {
  return this._nameList[this.indices[idx]] || '';
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getId = function (idx) {
  return this._idList[this.indices[idx]] || this.getRawIndex(idx) + '';
};

function normalizeDimensions(dimensions) {
  if (!zrUtil.isArray(dimensions)) {
    dimensions = [dimensions];
  }

  return dimensions;
}
/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */


listProto.each = function (dims, cb, stack, context) {
  if (typeof dims === 'function') {
    context = stack;
    stack = cb;
    cb = dims;
    dims = [];
  }

  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
  var value = [];
  var dimSize = dims.length;
  var indices = this.indices;
  context = context || this;

  for (var i = 0; i < indices.length; i++) {
    // Simple optimization
    switch (dimSize) {
      case 0:
        cb.call(context, i);
        break;

      case 1:
        cb.call(context, this.get(dims[0], i, stack), i);
        break;

      case 2:
        cb.call(context, this.get(dims[0], i, stack), this.get(dims[1], i, stack), i);
        break;

      default:
        for (var k = 0; k < dimSize; k++) {
          value[k] = this.get(dims[k], i, stack);
        } // Index


        value[k] = i;
        cb.apply(context, value);
    }
  }
};
/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 */


listProto.filterSelf = function (dimensions, cb, stack, context) {
  if (typeof dimensions === 'function') {
    context = stack;
    stack = cb;
    cb = dimensions;
    dimensions = [];
  }

  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var newIndices = [];
  var value = [];
  var dimSize = dimensions.length;
  var indices = this.indices;
  context = context || this;

  for (var i = 0; i < indices.length; i++) {
    var keep; // Simple optimization

    if (!dimSize) {
      keep = cb.call(context, i);
    } else if (dimSize === 1) {
      keep = cb.call(context, this.get(dimensions[0], i, stack), i);
    } else {
      for (var k = 0; k < dimSize; k++) {
        value[k] = this.get(dimensions[k], i, stack);
      }

      value[k] = i;
      keep = cb.apply(context, value);
    }

    if (keep) {
      newIndices.push(indices[i]);
    }
  }

  this.indices = newIndices; // Reset data extent

  this._extent = {};
  return this;
};
/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.mapArray = function (dimensions, cb, stack, context) {
  if (typeof dimensions === 'function') {
    context = stack;
    stack = cb;
    cb = dimensions;
    dimensions = [];
  }

  var result = [];
  this.each(dimensions, function () {
    result.push(cb && cb.apply(this, arguments));
  }, stack, context);
  return result;
};

function cloneListForMapAndSample(original, excludeDimensions) {
  var allDimensions = original.dimensions;
  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

  transferProperties(list, original);
  var storage = list._storage = {};
  var originalStorage = original._storage; // Init storage

  for (var i = 0; i < allDimensions.length; i++) {
    var dim = allDimensions[i];
    var dimStore = originalStorage[dim];

    if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
      storage[dim] = new dimStore.constructor(originalStorage[dim].length);
    } else {
      // Direct reference for other dimensions
      storage[dim] = originalStorage[dim];
    }
  }

  return list;
}
/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.map = function (dimensions, cb, stack, context) {
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
  // So we can reference to the same value

  var indices = list.indices = this.indices;
  var storage = list._storage;
  var tmpRetValue = [];
  this.each(dimensions, function () {
    var idx = arguments[arguments.length - 1];
    var retValue = cb && cb.apply(this, arguments);

    if (retValue != null) {
      // a number
      if (typeof retValue === 'number') {
        tmpRetValue[0] = retValue;
        retValue = tmpRetValue;
      }

      for (var i = 0; i < retValue.length; i++) {
        var dim = dimensions[i];
        var dimStore = storage[dim];
        var rawIdx = indices[idx];

        if (dimStore) {
          dimStore[rawIdx] = retValue[i];
        }
      }
    }
  }, stack, context);
  return list;
};
/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */


listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
  var list = cloneListForMapAndSample(this, [dimension]);
  var storage = this._storage;
  var targetStorage = list._storage;
  var originalIndices = this.indices;
  var indices = list.indices = [];
  var frameValues = [];
  var frameIndices = [];
  var frameSize = Math.floor(1 / rate);
  var dimStore = targetStorage[dimension];
  var len = this.count(); // Copy data from original data

  for (var i = 0; i < storage[dimension].length; i++) {
    targetStorage[dimension][i] = storage[dimension][i];
  }

  for (var i = 0; i < len; i += frameSize) {
    // Last frame
    if (frameSize > len - i) {
      frameSize = len - i;
      frameValues.length = frameSize;
    }

    for (var k = 0; k < frameSize; k++) {
      var idx = originalIndices[i + k];
      frameValues[k] = dimStore[idx];
      frameIndices[k] = idx;
    }

    var value = sampleValue(frameValues);
    var idx = frameIndices[sampleIndex(frameValues, value) || 0]; // Only write value on the filtered data

    dimStore[idx] = value;
    indices.push(idx);
  }

  return list;
};
/**
 * Get model of one data item.
 *
 * @param {number} idx
 */
// FIXME Model proxy ?


listProto.getItemModel = function (idx) {
  var hostModel = this.hostModel;
  idx = this.indices[idx];
  return new Model(this._rawData.getItem(idx), hostModel, hostModel && hostModel.ecModel);
};
/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */


listProto.diff = function (otherList) {
  var idList = this._idList;
  var otherIdList = otherList && otherList._idList;
  var val; // Use prefix to avoid index to be the same as otherIdList[idx],
  // which will cause weird udpate animation.

  var prefix = 'e\0\0';
  return new DataDiffer(otherList ? otherList.indices : [], this.indices, function (idx) {
    return (val = otherIdList[idx]) != null ? val : prefix + idx;
  }, function (idx) {
    return (val = idList[idx]) != null ? val : prefix + idx;
  });
};
/**
 * Get visual property.
 * @param {string} key
 */


listProto.getVisual = function (key) {
  var visual = this._visual;
  return visual && visual[key];
};
/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */


listProto.setVisual = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setVisual(name, key[name]);
      }
    }

    return;
  }

  this._visual = this._visual || {};
  this._visual[key] = val;
};
/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */


listProto.setLayout = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setLayout(name, key[name]);
      }
    }

    return;
  }

  this._layout[key] = val;
};
/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */


listProto.getLayout = function (key) {
  return this._layout[key];
};
/**
 * Get layout of single data item
 * @param {number} idx
 */


listProto.getItemLayout = function (idx) {
  return this._itemLayouts[idx];
};
/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */


listProto.setItemLayout = function (idx, layout, merge) {
  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
};
/**
 * Clear all layout of single data item
 */


listProto.clearItemLayouts = function () {
  this._itemLayouts.length = 0;
};
/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */


listProto.getItemVisual = function (idx, key, ignoreParent) {
  var itemVisual = this._itemVisuals[idx];
  var val = itemVisual && itemVisual[key];

  if (val == null && !ignoreParent) {
    // Use global visual property
    return this.getVisual(key);
  }

  return val;
};
/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */


listProto.setItemVisual = function (idx, key, value) {
  var itemVisual = this._itemVisuals[idx] || {};
  this._itemVisuals[idx] = itemVisual;

  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        itemVisual[name] = key[name];
      }
    }

    return;
  }

  itemVisual[key] = value;
};
/**
 * Clear itemVisuals and list visual.
 */


listProto.clearAllVisual = function () {
  this._visual = {};
  this._itemVisuals = [];
};

var setItemDataAndSeriesIndex = function (child) {
  child.seriesIndex = this.seriesIndex;
  child.dataIndex = this.dataIndex;
  child.dataType = this.dataType;
};
/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */


listProto.setItemGraphicEl = function (idx, el) {
  var hostModel = this.hostModel;

  if (el) {
    // Add data index and series index for indexing the data by element
    // Useful in tooltip
    el.dataIndex = idx;
    el.dataType = this.dataType;
    el.seriesIndex = hostModel && hostModel.seriesIndex;

    if (el.type === 'group') {
      el.traverse(setItemDataAndSeriesIndex, el);
    }
  }

  this._graphicEls[idx] = el;
};
/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */


listProto.getItemGraphicEl = function (idx) {
  return this._graphicEls[idx];
};
/**
 * @param {Function} cb
 * @param {*} context
 */


listProto.eachItemGraphicEl = function (cb, context) {
  zrUtil.each(this._graphicEls, function (el, idx) {
    if (el) {
      cb && cb.call(context, el, idx);
    }
  });
};
/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */


listProto.cloneShallow = function () {
  var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
  var list = new List(dimensionInfoList, this.hostModel); // FIXME

  list._storage = this._storage;
  transferProperties(list, this); // Clone will not change the data extent and indices

  list.indices = this.indices.slice();

  if (this._extent) {
    list._extent = zrUtil.extend({}, this._extent);
  }

  return list;
};
/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */


listProto.wrapMethod = function (methodName, injectFunction) {
  var originalMethod = this[methodName];

  if (typeof originalMethod !== 'function') {
    return;
  }

  this.__wrappedMethods = this.__wrappedMethods || [];

  this.__wrappedMethods.push(methodName);

  this[methodName] = function () {
    var res = originalMethod.apply(this, arguments);
    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
  };
}; // Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.


listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.

listProto.CHANGABLE_METHODS = ['filterSelf'];
var _default = List;
module.exports = _default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Model = __webpack_require__(29);

var componentUtil = __webpack_require__(285);

var clazzUtil = __webpack_require__(75);

var layout = __webpack_require__(17);

var boxLayoutMixin = __webpack_require__(1606);

/**
 * Component model
 *
 * @module echarts/model/Component
 */
var arrayPush = Array.prototype.push;
/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */

var ComponentModel = Model.extend({
  type: 'component',

  /**
   * @readOnly
   * @type {string}
   */
  id: '',

  /**
   * @readOnly
   */
  name: '',

  /**
   * @readOnly
   * @type {string}
   */
  mainType: '',

  /**
   * @readOnly
   * @type {string}
   */
  subType: '',

  /**
   * @readOnly
   * @type {number}
   */
  componentIndex: 0,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */
  ecModel: null,

  /**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */
  dependentModels: [],

  /**
   * @type {string}
   * @readOnly
   */
  uid: null,

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  $constructor: function (option, parentModel, ecModel, extraOpt) {
    Model.call(this, option, parentModel, ecModel, extraOpt);
    this.uid = componentUtil.getUID('componentModel');
  },
  init: function (option, parentModel, ecModel, extraOpt) {
    this.mergeDefaultAndTheme(option, ecModel);
  },
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
    var themeModel = ecModel.getTheme();
    zrUtil.merge(option, themeModel.get(this.mainType));
    zrUtil.merge(option, this.getDefaultOption());

    if (layoutMode) {
      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (option, extraOpt) {
    zrUtil.merge(this.option, option, true);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      layout.mergeLayoutParam(this.option, option, layoutMode);
    }
  },
  // Hooker after init or mergeOption
  optionUpdated: function (newCptOption, isInit) {},
  getDefaultOption: function () {
    if (!clazzUtil.hasOwn(this, '__defaultOption')) {
      var optList = [];
      var Class = this.constructor;

      while (Class) {
        var opt = Class.prototype.defaultOption;
        opt && optList.push(opt);
        Class = Class.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
      }

      clazzUtil.set(this, '__defaultOption', defaultOption);
    }

    return clazzUtil.get(this, '__defaultOption');
  },
  getReferringComponents: function (mainType) {
    return this.ecModel.queryComponents({
      mainType: mainType,
      index: this.get(mainType + 'Index', true),
      id: this.get(mainType + 'Id', true)
    });
  }
}); // Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(ComponentModel, {
  registerWhenExtend: true
});
componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.

componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
    arrayPush.apply(deps, Clazz.prototype.dependencies || []);
  }); // Ensure main type

  return zrUtil.map(deps, function (type) {
    return clazzUtil.parseClassType(type).main;
  });
}

zrUtil.mixin(ComponentModel, boxLayoutMixin);
var _default = ComponentModel;
module.exports = _default;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */
var env = {};

if (typeof navigator === 'undefined') {
  // In node
  env = {
    browser: {},
    os: {},
    node: true,
    // Assume canvas is supported
    canvasSupported: true,
    svgSupported: true
  };
} else {
  env = detect(navigator.userAgent);
}

var _default = env; // Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.

function detect(ua) {
  var os = {};
  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
  // var touchpad = webos && ua.match(/TouchPad/);
  // var kindle = ua.match(/Kindle\/([\d.]+)/);
  // var silk = ua.match(/Silk\/([\d._]+)/);
  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
  // var playbook = ua.match(/PlayBook/);
  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);

  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;

  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+

  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes
  // if (browser.webkit = !!webkit) browser.version = webkit[1];
  // if (android) os.android = true, os.version = android[2];
  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  // if (webos) os.webos = true, os.version = webos[2];
  // if (touchpad) os.touchpad = true;
  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
  // if (bb10) os.bb10 = true, os.version = bb10[2];
  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
  // if (playbook) browser.playbook = true;
  // if (kindle) os.kindle = true, os.version = kindle[1];
  // if (silk) browser.silk = true, browser.version = silk[1];
  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
  // if (chrome) browser.chrome = true, browser.version = chrome[1];

  if (firefox) {
    browser.firefox = true;
    browser.version = firefox[1];
  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
  // if (webview) browser.webview = true;


  if (ie) {
    browser.ie = true;
    browser.version = ie[1];
  }

  if (edge) {
    browser.edge = true;
    browser.version = edge[1];
  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
  // not be set on win phone. So we do not consider Win Phone.


  if (weChat) {
    browser.weChat = true;
  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));


  return {
    browser: browser,
    os: os,
    node: false,
    // 原生canvas支持，改极端点了
    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
    canvasSupported: !!document.createElement('canvas').getContext,
    svgSupported: typeof SVGRect !== 'undefined',
    // @see <http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript>
    // works on most browsers
    // IE10/11 does not support touch event, and MS Edge supports them but not by
    // default, so we dont check navigator.maxTouchPoints for them here.
    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
    // <http://caniuse.com/#search=pointer%20event>.
    pointerEventsSupported: 'onpointerdown' in window // Firefox supports pointer but not by default, only MS browsers are reliable on pointer
    // events currently. So we dont use that on other browsers unless tested sufficiently.
    // Although IE 10 supports pointer event, it use old style and is different from the
    // standard. So we exclude that. (IE 10 is hardly used on touch device)
    && (browser.edge || browser.ie && browser.version >= 11)
  };
}

module.exports = _default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(212);

var zrUtil = __webpack_require__(0);

var PathProxy = __webpack_require__(125);

var pathContain = __webpack_require__(1972);

var Pattern = __webpack_require__(693);

var getCanvasPattern = Pattern.prototype.getCanvasPattern;
var abs = Math.abs;
var pathProxyForDraw = new PathProxy(true);
/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */

function Path(opts) {
  Displayable.call(this, opts);
  /**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */

  this.path = null;
}

Path.prototype = {
  constructor: Path,
  type: 'path',
  __dirtyPath: true,
  strokeContainThreshold: 5,
  brush: function (ctx, prevEl) {
    var style = this.style;
    var path = this.path || pathProxyForDraw;
    var hasStroke = style.hasStroke();
    var hasFill = style.hasFill();
    var fill = style.fill;
    var stroke = style.stroke;
    var hasFillGradient = hasFill && !!fill.colorStops;
    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
    var hasFillPattern = hasFill && !!fill.image;
    var hasStrokePattern = hasStroke && !!stroke.image;
    style.bind(ctx, this, prevEl);
    this.setTransform(ctx);

    if (this.__dirty) {
      var rect; // Update gradient because bounding rect may changed

      if (hasFillGradient) {
        rect = rect || this.getBoundingRect();
        this._fillGradient = style.getGradient(ctx, fill, rect);
      }

      if (hasStrokeGradient) {
        rect = rect || this.getBoundingRect();
        this._strokeGradient = style.getGradient(ctx, stroke, rect);
      }
    } // Use the gradient or pattern


    if (hasFillGradient) {
      // PENDING If may have affect the state
      ctx.fillStyle = this._fillGradient;
    } else if (hasFillPattern) {
      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
    }

    if (hasStrokeGradient) {
      ctx.strokeStyle = this._strokeGradient;
    } else if (hasStrokePattern) {
      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
    }

    var lineDash = style.lineDash;
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy

    var scale = this.getGlobalScale();
    path.setScale(scale[0], scale[1]); // Proxy context
    // Rebuild path in following 2 cases
    // 1. Path is dirty
    // 2. Path needs javascript implemented lineDash stroking.
    //    In this case, lineDash information will not be saved in PathProxy

    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
      path.beginPath(ctx); // Setting line dash before build path

      if (lineDash && !ctxLineDash) {
        path.setLineDash(lineDash);
        path.setLineDashOffset(lineDashOffset);
      }

      this.buildPath(path, this.shape, false); // Clear path dirty flag

      if (this.path) {
        this.__dirtyPath = false;
      }
    } else {
      // Replay path building
      ctx.beginPath();
      this.path.rebuildPath(ctx);
    }

    hasFill && path.fill(ctx);

    if (lineDash && ctxLineDash) {
      ctx.setLineDash(lineDash);
      ctx.lineDashOffset = lineDashOffset;
    }

    hasStroke && path.stroke(ctx);

    if (lineDash && ctxLineDash) {
      // PENDING
      // Remove lineDash
      ctx.setLineDash([]);
    }

    this.restoreTransform(ctx); // Draw rect text

    if (style.text != null) {
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
  // Like in circle
  buildPath: function (ctx, shapeCfg, inBundle) {},
  createPathProxy: function () {
    this.path = new PathProxy();
  },
  getBoundingRect: function () {
    var rect = this._rect;
    var style = this.style;
    var needsUpdateRect = !rect;

    if (needsUpdateRect) {
      var path = this.path;

      if (!path) {
        // Create path on demand.
        path = this.path = new PathProxy();
      }

      if (this.__dirtyPath) {
        path.beginPath();
        this.buildPath(path, this.shape, false);
      }

      rect = path.getBoundingRect();
    }

    this._rect = rect;

    if (style.hasStroke()) {
      // Needs update rect with stroke lineWidth when
      // 1. Element changes scale or lineWidth
      // 2. Shape is changed
      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());

      if (this.__dirty || needsUpdateRect) {
        rectWithStroke.copy(rect); // FIXME Must after updateTransform

        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical

        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill

        if (!style.hasFill()) {
          w = Math.max(w, this.strokeContainThreshold || 4);
        } // Consider line width
        // Line scale can't be 0;


        if (lineScale > 1e-10) {
          rectWithStroke.width += w / lineScale;
          rectWithStroke.height += w / lineScale;
          rectWithStroke.x -= w / lineScale / 2;
          rectWithStroke.y -= w / lineScale / 2;
        }
      } // Return rect with stroke


      return rectWithStroke;
    }

    return rect;
  },
  contain: function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    var style = this.style;
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      var pathData = this.path.data;

      if (style.hasStroke()) {
        var lineWidth = style.lineWidth;
        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;

        if (lineScale > 1e-10) {
          // Only add extra hover lineWidth when there are no fill
          if (!style.hasFill()) {
            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
          }

          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
            return true;
          }
        }
      }

      if (style.hasFill()) {
        return pathContain.contain(pathData, x, y);
      }
    }

    return false;
  },

  /**
   * @param  {boolean} dirtyPath
   */
  dirty: function (dirtyPath) {
    if (dirtyPath == null) {
      dirtyPath = true;
    } // Only mark dirty, not mark clean


    if (dirtyPath) {
      this.__dirtyPath = dirtyPath;
      this._rect = null;
    }

    this.__dirty = true;
    this.__zr && this.__zr.refresh(); // Used as a clipping path

    if (this.__clipTarget) {
      this.__clipTarget.dirty();
    }
  },

  /**
   * Alias for animate('shape')
   * @param {boolean} loop
   */
  animateShape: function (loop) {
    return this.animate('shape', loop);
  },
  // Overwrite attrKV
  attrKV: function (key, value) {
    // FIXME
    if (key === 'shape') {
      this.setShape(value);
      this.__dirtyPath = true;
      this._rect = null;
    } else {
      Displayable.prototype.attrKV.call(this, key, value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setShape: function (key, value) {
    var shape = this.shape; // Path from string may not have shape

    if (shape) {
      if (zrUtil.isObject(key)) {
        for (var name in key) {
          if (key.hasOwnProperty(name)) {
            shape[name] = key[name];
          }
        }
      } else {
        shape[key] = value;
      }

      this.dirty(true);
    }

    return this;
  },
  getLineScale: function () {
    var m = this.transform; // Get the line scale.
    // Determinant of `m` means how much the area is enlarged by the
    // transformation. So its square root can be used as a scale factor
    // for width.

    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
  }
};
/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */

Path.extend = function (defaults) {
  var Sub = function (opts) {
    Path.call(this, opts);

    if (defaults.style) {
      // Extend default style
      this.style.extendFrom(defaults.style, false);
    } // Extend default shape


    var defaultShape = defaults.shape;

    if (defaultShape) {
      this.shape = this.shape || {};
      var thisShape = this.shape;

      for (var name in defaultShape) {
        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
          thisShape[name] = defaultShape[name];
        }
      }
    }

    defaults.init && defaults.init.call(this, opts);
  };

  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象

  for (var name in defaults) {
    // Extending prototype values and methods
    if (name !== 'style' && name !== 'shape') {
      Sub.prototype[name] = defaults[name];
    }
  }

  return Sub;
};

zrUtil.inherits(Path, Displayable);
var _default = Path;
module.exports = _default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var _format = __webpack_require__(21);

var formatTime = _format.formatTime;
var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;
var getTooltipMarker = _format.getTooltipMarker;

var _clazz = __webpack_require__(75);

var set = _clazz.set;
var get = _clazz.get;

var modelUtil = __webpack_require__(15);

var ComponentModel = __webpack_require__(32);

var colorPaletteMixin = __webpack_require__(488);

var _layout = __webpack_require__(17);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;
var SeriesModel = ComponentModel.extend({
  type: 'series.__base__',

  /**
   * @readOnly
   */
  seriesIndex: 0,
  // coodinateSystem will be injected in the echarts/CoordinateSystem
  coordinateSystem: null,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * Data provided for legend
   * @type {Function}
   */
  // PENDING
  legendDataProvider: null,

  /**
   * Access path of color for visual
   */
  visualColorAccessPath: 'itemStyle.normal.color',

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  init: function (option, parentModel, ecModel, extraOpt) {
    /**
     * @type {number}
     * @readOnly
     */
    this.seriesIndex = this.componentIndex;
    this.mergeDefaultAndTheme(option, ecModel);
    var data = this.getInitialData(option, ecModel);

    /**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */
    set(this, 'dataBeforeProcessed', data); // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkList

    this.restoreData();
  },

  /**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (ComponentModel.hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option.label, ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (newSeriesOption, ecModel) {
    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
    }

    var data = this.getInitialData(newSeriesOption, ecModel); // TODO Merge data?

    if (data) {
      set(this, 'data', data);
      set(this, 'dataBeforeProcessed', data.cloneShallow());
    }
  },
  fillDataTextStyle: function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          modelUtil.defaultEmphasis(data[i].label, props);
        }
      }
    }
  },

  /**
   * Init a data structure from data related option in series
   * Must be overwritten
   */
  getInitialData: function () {},

  /**
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */
  getData: function (dataType) {
    var data = get(this, 'data');
    return dataType == null ? data : data.getLinkedData(dataType);
  },

  /**
   * @param {module:echarts/data/List} data
   */
  setData: function (data) {
    set(this, 'data', data);
  },

  /**
   * Get data before processed
   * @return {module:echarts/data/List}
   */
  getRawData: function () {
    return get(this, 'dataBeforeProcessed');
  },

  /**
   * Coord dimension to data dimension.
   *
   * By default the result is the same as dimensions of series data.
   * But in some series data dimensions are different from coord dimensions (i.e.
   * candlestick and boxplot). Override this method to handle those cases.
   *
   * Coord dimension to data dimension can be one-to-many
   *
   * @param {string} coordDim
   * @return {Array.<string>} dimensions on the axis.
   */
  coordDimToDataDim: function (coordDim) {
    return modelUtil.coordDimToDataDim(this.getData(), coordDim);
  },

  /**
   * Convert data dimension to coord dimension.
   *
   * @param {string|number} dataDim
   * @return {string}
   */
  dataDimToCoordDim: function (dataDim) {
    return modelUtil.dataDimToCoordDim(this.getData(), dataDim);
  },

  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */
  getBaseAxis: function () {
    var coordSys = this.coordinateSystem;
    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  },
  // FIXME

  /**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    function formatArrayValue(value) {
      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.tooltipName != null;
      }, 0);
      var result = [];
      var tooltipDims = modelUtil.otherDimToDataDim(data, 'tooltip');
      tooltipDims.length ? zrUtil.each(tooltipDims, function (dimIdx) {
        setEachItem(data.get(dimIdx, dataIndex), dimIdx);
      }) // By default, all dims is used on tooltip.
      : zrUtil.each(value, setEachItem);

      function setEachItem(val, dimIdx) {
        var dimInfo = data.getDimensionInfo(dimIdx); // If `dimInfo.tooltip` is not set, show tooltip.

        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
          return;
        }

        var dimType = dimInfo.type;
        var valStr = (vertially ? '- ' + (dimInfo.tooltipName || dimInfo.name) + ': ' : '') + (dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
        valStr && result.push(encodeHTML(valStr));
      }

      return (vertially ? '<br/>' : '') + result.join(vertially ? '<br/>' : ', ');
    }

    var data = get(this, 'data');
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? formatArrayValue(value) : encodeHTML(addCommas(value));
    var name = data.getName(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');

    if (zrUtil.isObject(color) && color.colorStops) {
      color = (color.colorStops[0] || {}).color;
    }

    color = color || 'transparent';
    var colorEl = getTooltipMarker(color);
    var seriesName = this.name; // FIXME

    if (seriesName === '\0-') {
      // Not show '-'
      seriesName = '';
    }

    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? '<br/>' : ': ') : '';
    return !multipleSeries ? seriesName + colorEl + (name ? encodeHTML(name) + ': ' + formattedValue : formattedValue) : colorEl + seriesName + formattedValue;
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return animationEnabled;
  },
  restoreData: function () {
    set(this, 'data', get(this, 'dataBeforeProcessed').cloneShallow());
  },
  getColorFromPalette: function (name, scope) {
    var ecModel = this.ecModel; // PENDING

    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope);
    }

    return color;
  },

  /**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */
  getAxisTooltipData: null,

  /**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */
  getTooltipPosition: null
});
zrUtil.mixin(SeriesModel, modelUtil.dataFormatMixin);
zrUtil.mixin(SeriesModel, colorPaletteMixin);
var _default = SeriesModel;
module.exports = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1112), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(235)('wks');
var uid = __webpack_require__(170);
var Symbol = __webpack_require__(40).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(97);
module.exports = __webpack_require__(23) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(43);
var has = __webpack_require__(42);
var SRC = __webpack_require__(101)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(61).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(12);
var defined = __webpack_require__(62);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssign = __webpack_require__(1678),
    baseCreate = __webpack_require__(1679);

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

module.exports = create;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(375);
var isBuffer = __webpack_require__(1661);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(138);
var createDesc = __webpack_require__(97);
var toIObject = __webpack_require__(50);
var toPrimitive = __webpack_require__(65);
var has = __webpack_require__(42);
var IE8_DOM_DEFINE = __webpack_require__(413);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(23) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(42);
var toObject = __webpack_require__(30);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(137);
var defined = __webpack_require__(62);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var textContain = __webpack_require__(70);

var OrdinalScale = __webpack_require__(1614);

var IntervalScale = __webpack_require__(195);

var Scale = __webpack_require__(196);

var numberUtil = __webpack_require__(8);

__webpack_require__(1615);

__webpack_require__(1613);

/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */
function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var min = model.getMin();
  var max = model.getMax();
  var fixMin = min != null;
  var fixMax = max != null;
  var originalExtent = scale.getExtent();
  var axisDataLen;
  var boundaryGap;
  var span;

  if (scaleType === 'ordinal') {
    axisDataLen = (model.get('data') || []).length;
  } else {
    boundaryGap = model.get('boundaryGap');

    if (!zrUtil.isArray(boundaryGap)) {
      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
    }

    if (typeof boundaryGap[0] === 'boolean') {
      boundaryGap = [0, 0];
    }

    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
  } // Notice: When min/max is not set (that is, when there are null/undefined,
  // which is the most common case), these cases should be ensured:
  // (1) For 'ordinal', show all axis.data.
  // (2) For others:
  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
  //      disabled).
  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
  //      be the result that originalExtent enlarged by boundaryGap.
  // (3) If no data, it should be ensured that `scale.setBlank` is set.
  // FIXME
  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
  // that the results processed by boundaryGap are positive/negative?


  if (min == null) {
    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
  }

  if (max == null) {
    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
  }

  if (min === 'dataMin') {
    min = originalExtent[0];
  } else if (typeof min === 'function') {
    min = min({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  if (max === 'dataMax') {
    max = originalExtent[1];
  } else if (typeof max === 'function') {
    max = max({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  (min == null || !isFinite(min)) && (min = NaN);
  (max == null || !isFinite(max)) && (max = NaN);
  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max)); // Evaluate if axis needs cross zero

  if (model.getNeedCrossZero()) {
    // Axis is over zero and min is not set
    if (min > 0 && max > 0 && !fixMin) {
      min = 0;
    } // Axis is under zero and max is not set


    if (min < 0 && max < 0 && !fixMax) {
      max = 0;
    }
  }

  return [min, max];
}

function niceScaleExtent(scale, model) {
  var extent = getScaleExtent(scale, model);
  var fixMin = model.getMin() != null;
  var fixMax = model.getMax() != null;
  var splitNumber = model.get('splitNumber');

  if (scale.type === 'log') {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  scale.setExtent(extent[0], extent[1]);
  scale.niceExtent({
    splitNumber: splitNumber,
    fixMin: fixMin,
    fixMax: fixMax,
    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  var interval = model.get('interval');

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */


function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale(model.getCategories(), [Infinity, -Infinity]);

      case 'value':
        return new IntervalScale();
      // Extended scale, like time and log

      default:
        return (Scale.getClass(axisType) || IntervalScale).create(model);
    }
  }
}
/**
 * Check if the axis corss 0
 */


function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param {Array.<number>} tickCoords In axis self coordinate.
 * @param {Array.<string>} labels
 * @param {string} font
 * @param {number} axisRotate 0: towards right horizontally, clock-wise is negative.
 * @param {number} [labelRotate=0] 0: towards right horizontally, clock-wise is negative.
 * @return {number}
 */


function getAxisLabelInterval(tickCoords, labels, font, axisRotate, labelRotate) {
  var textSpaceTakenRect;
  var autoLabelInterval = 0;
  var accumulatedLabelInterval = 0;
  var rotation = (axisRotate - labelRotate) / 180 * Math.PI;
  var step = 1;

  if (labels.length > 40) {
    // Simple optimization for large amount of labels
    step = Math.floor(labels.length / 40);
  }

  for (var i = 0; i < tickCoords.length; i += step) {
    var tickCoord = tickCoords[i]; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = textContain.getBoundingRect(labels[i], font, 'center', 'top');
    rect.x += tickCoord * Math.cos(rotation);
    rect.y += tickCoord * Math.sin(rotation); // Magic number

    rect.width *= 1.3;
    rect.height *= 1.3;

    if (!textSpaceTakenRect) {
      textSpaceTakenRect = rect.clone();
    } // There is no space for current label;
    else if (textSpaceTakenRect.intersect(rect)) {
        accumulatedLabelInterval++;
        autoLabelInterval = Math.max(autoLabelInterval, accumulatedLabelInterval);
      } else {
        textSpaceTakenRect.union(rect); // Reset

        accumulatedLabelInterval = 0;
      }
  }

  if (autoLabelInterval === 0 && step > 1) {
    return step;
  }

  return (autoLabelInterval + 1) * step - 1;
}
/**
 * @param {Object} axis
 * @param {Function} labelFormatter
 * @return {Array.<string>}
 */


function getFormattedLabels(axis, labelFormatter) {
  var scale = axis.scale;
  var labels = scale.getTicksLabels();
  var ticks = scale.getTicks();

  if (typeof labelFormatter === 'string') {
    labelFormatter = function (tpl) {
      return function (val) {
        return tpl.replace('{value}', val != null ? val : '');
      };
    }(labelFormatter); // Consider empty array


    return zrUtil.map(labels, labelFormatter);
  } else if (typeof labelFormatter === 'function') {
    return zrUtil.map(ticks, function (tick, idx) {
      return labelFormatter(getAxisRawValue(axis, tick), idx);
    }, this);
  } else {
    return labels;
  }
}

function getAxisRawValue(axis, value) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
}

exports.getScaleExtent = getScaleExtent;
exports.niceScaleExtent = niceScaleExtent;
exports.createScaleByModel = createScaleByModel;
exports.ifAxisCrossZero = ifAxisCrossZero;
exports.getAxisLabelInterval = getAxisLabelInterval;
exports.getFormattedLabels = getFormattedLabels;
exports.getAxisRawValue = getAxisRawValue;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var BoundingRect = __webpack_require__(26);

// Symbol factory

/**
 * Triangle shape
 * @inner
 */
var Triangle = graphic.extendShape({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = graphic.extendShape({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin = graphic.extendShape({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow = graphic.extendShape({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */

var symbolCtors = {
  line: graphic.Line,
  rect: graphic.Rect,
  roundRect: graphic.Rect,
  square: graphic.Rect,
  circle: graphic.Circle,
  diamond: Diamond,
  pin: Pin,
  arrow: Arrow,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    // FIXME
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
zrUtil.each(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = graphic.extendShape({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  beforeBrush: function () {
    var style = this.style;
    var shape = this.shape; // FIXME

    if (shape.symbolType === 'pin' && style.textPosition === 'inside') {
      style.textPosition = ['50%', '40%'];
      style.textAlign = 'center';
      style.textVerticalAlign = 'middle';
    }
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;
    var proxySymbol = symbolBuildProxies[symbolType];

    if (shape.symbolType !== 'none') {
      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;
    var symbolShape = this.shape;

    if (symbolShape && symbolShape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff';
    } else {
      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
      symbolStyle.fill && (symbolStyle.fill = color);
      symbolStyle.stroke && (symbolStyle.stroke = color);
    }

    this.dirty(false);
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */


function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty;
  symbolPath.setColor = symbolPathSetColor;
  symbolPath.setColor(color);
  return symbolPath;
}

exports.createSymbol = createSymbol;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个单位矩阵
 * @return {Float32Array|Array.<number>}
 */

function create() {
  var out = new ArrayCtor(6);
  identity(out);
  return out;
}
/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */


function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */


function copy(out, m) {
  out[0] = m[0];
  out[1] = m[1];
  out[2] = m[2];
  out[3] = m[3];
  out[4] = m[4];
  out[5] = m[5];
  return out;
}
/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */


function mul(out, m1, m2) {
  // Consider matrix.mul(m, m2, m);
  // where out is the same as m2.
  // So use temp variable to escape error.
  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = out3;
  out[4] = out4;
  out[5] = out5;
  return out;
}
/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function translate(out, a, v) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4] + v[0];
  out[5] = a[5] + v[1];
  return out;
}
/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */


function rotate(out, a, rad) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var st = Math.sin(rad);
  var ct = Math.cos(rad);
  out[0] = aa * ct + ab * st;
  out[1] = -aa * st + ab * ct;
  out[2] = ac * ct + ad * st;
  out[3] = -ac * st + ct * ad;
  out[4] = ct * atx + st * aty;
  out[5] = ct * aty - st * atx;
  return out;
}
/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function scale(out, a, v) {
  var vx = v[0];
  var vy = v[1];
  out[0] = a[0] * vx;
  out[1] = a[1] * vy;
  out[2] = a[2] * vx;
  out[3] = a[3] * vy;
  out[4] = a[4] * vx;
  out[5] = a[5] * vy;
  return out;
}
/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */


function invert(out, a) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}

exports.create = create;
exports.identity = identity;
exports.copy = copy;
exports.mul = mul;
exports.translate = translate;
exports.rotate = rotate;
exports.scale = scale;
exports.invert = invert;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint semi: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint block-spacing: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */

/* harmony default export */ __webpack_exports__["a"] = ({
  emailFormat: function emailFormat(v) {
    return v.length === 0 || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)*$/.test(v);
  },
  phoneFormat: function phoneFormat(v) {
    return v.length === 0 || /^[0-9-+]*$/.test(v);
  },
  usernameRules: function usernameRules($t) {
    return [function (v) {
      return !!v || $t('login.vali-username-blank');
    }];
  },
  passwordRules: function passwordRules($t) {
    return [function (v) {
      return !!v || $t('login.vali-password-blank');
    }];
  },
  passwordReinputRules: function passwordReinputRules($t, password) {
    return [function (v) {
      return !!v || $t('login.vali-password-blank');
    }, function (v) {
      return password === v || $t('user-params.password_reinput_differs');
    }];
  },
  emailRules: function emailRules($t) {
    // eslint-disable-next-line
    var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return [function (v) {
      return !!v || $t('account.vali-email-must');
    }, function (v) {
      return emailRegEx.test(v) || $t('account.vali-email-format');
    }];
  }
});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(37);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _model = __webpack_require__(15);

var normalizeToArray = _model.normalizeToArray;

/**
 * Complete dimensions by data (guess dimension).
 */
var each = zrUtil.each;
var isString = zrUtil.isString;
var defaults = zrUtil.defaults;
var OTHER_DIMS = {
  tooltip: 1,
  label: 1,
  itemName: 1
};
/**
 * Complete the dimensions array, by user defined `dimension` and `encode`,
 * and guessing from the data structure.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: []}, ...] can be specified to give names.
 * @param {Array} data Data list. [[1, 2, 3], [2, 3, 4]].
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {string} [opt.extraPrefix] Prefix of name when filling the left dimensions.
 * @param {string} [opt.extraFromZero] If specified, extra dim names will be:
 *                      extraPrefix + 0, extraPrefix + extraBaseIndex + 1 ...
 *                      If not specified, extra dim names will be:
 *                      extraPrefix, extraPrefix + 0, extraPrefix + 1 ...
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @return {Array.<Object>} [{
 *      name: string mandatory,
 *      coordDim: string mandatory,
 *      coordDimIndex: number mandatory,
 *      type: string optional,
 *      tooltipName: string optional,
 *      otherDims: {
 *          tooltip: number optional,
 *          label: number optional
 *      },
 *      isExtraCoord: boolean true or undefined.
 *      other props ...
 * }]
 */

function completeDimensions(sysDims, data, opt) {
  data = data || [];
  opt = opt || {};
  sysDims = (sysDims || []).slice();
  var dimsDef = (opt.dimsDef || []).slice();
  var encodeDef = zrUtil.createHashMap(opt.encodeDef);
  var dataDimNameMap = zrUtil.createHashMap();
  var coordDimNameMap = zrUtil.createHashMap(); // var valueCandidate;

  var result = [];
  var dimCount = opt.dimCount;

  if (dimCount == null) {
    var value0 = retrieveValue(data[0]);
    dimCount = Math.max(zrUtil.isArray(value0) && value0.length || 1, sysDims.length, dimsDef.length);
    each(sysDims, function (sysDimItem) {
      var sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
    });
  } // Apply user defined dims (`name` and `type`) and init result.


  for (var i = 0; i < dimCount; i++) {
    var dimDefItem = isString(dimsDef[i]) ? {
      name: dimsDef[i]
    } : dimsDef[i] || {};
    var userDimName = dimDefItem.name;
    var resultItem = result[i] = {
      otherDims: {}
    }; // Name will be applied later for avoiding duplication.

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      // Only if `series.dimensions` is defined in option, tooltipName
      // will be set, and dimension will be diplayed vertically in
      // tooltip by default.
      resultItem.name = resultItem.tooltipName = userDimName;
      dataDimNameMap.set(userDimName, i);
    }

    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
  } // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.


  encodeDef.each(function (dataDims, coordDim) {
    dataDims = encodeDef.set(coordDim, normalizeToArray(dataDims).slice());
    each(dataDims, function (resultDimIdx, coordDimIndex) {
      // The input resultDimIdx can be dim name or index.
      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        dataDims[coordDimIndex] = resultDimIdx;
        applyDim(result[resultDimIdx], coordDim, coordDimIndex);
      }
    });
  }); // Apply templetes and default order from `sysDims`.

  var availDimIdx = 0;
  each(sysDims, function (sysDimItem, sysDimIndex) {
    var coordDim;
    var sysDimItem;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;

    if (isString(sysDimItem)) {
      coordDim = sysDimItem;
      sysDimItem = {};
    } else {
      coordDim = sysDimItem.name;
      sysDimItem = zrUtil.clone(sysDimItem); // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = normalizeToArray(encodeDef.get(coordDim)); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < result.length && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    each(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = result[resultDimIdx];
      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        resultItem.name = resultItem.tooltipName = sysDimItemDimsDef[coordDimIndex];
      }

      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
    });
  }); // Make sure the first extra dim is 'value'.

  var extra = opt.extraPrefix || 'value'; // Set dim `name` and other `coordDim` and other props.

  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
    var resultItem = result[resultDimIdx] = result[resultDimIdx] || {};
    var coordDim = resultItem.coordDim;
    coordDim == null && (resultItem.coordDim = genName(extra, coordDimNameMap, opt.extraFromZero), resultItem.coordDimIndex = 0, resultItem.isExtraCoord = true);
    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
    resultItem.type == null && guessOrdinal(data, resultDimIdx) && (resultItem.type = 'ordinal');
  }

  return result;

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (OTHER_DIMS[coordDim]) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  }

  function genName(name, map, fromZero) {
    if (fromZero || map.get(name) != null) {
      var i = 0;

      while (map.get(name + i) != null) {
        i++;
      }

      name += i;
    }

    map.set(name, true);
    return name;
  }
} // The rule should not be complex, otherwise user might not
// be able to known where the data is wrong.


var guessOrdinal = completeDimensions.guessOrdinal = function (data, dimIndex) {
  for (var i = 0, len = data.length; i < len; i++) {
    var value = retrieveValue(data[i]);

    if (!zrUtil.isArray(value)) {
      return false;
    }

    var value = value[dimIndex]; // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (value != null && isFinite(value) && value !== '') {
      return false;
    } else if (isString(value) && value !== '-') {
      return true;
    }
  }

  return false;
};

function retrieveValue(o) {
  return zrUtil.isArray(o) ? o : zrUtil.isObject(o) ? o.value : o;
}

var _default = completeDimensions;
module.exports = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(40);
var core = __webpack_require__(36);
var ctx = __webpack_require__(132);
var hide = __webpack_require__(90);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(56);
var IObject = __webpack_require__(137);
var toObject = __webpack_require__(30);
var toLength = __webpack_require__(25);
var asc = __webpack_require__(244);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(61);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var coordinateSystemCreators = {};

function CoordinateSystemManager() {
  this._coordinateSystems = [];
}

CoordinateSystemManager.prototype = {
  constructor: CoordinateSystemManager,
  create: function (ecModel, api) {
    var coordinateSystems = [];
    zrUtil.each(coordinateSystemCreators, function (creater, type) {
      var list = creater.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  },
  update: function (ecModel, api) {
    zrUtil.each(this._coordinateSystems, function (coordSys) {
      // FIXME MUST have
      coordSys.update && coordSys.update(ecModel, api);
    });
  },
  getCoordinateSystems: function () {
    return this._coordinateSystems.slice();
  }
};

CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
  coordinateSystemCreators[type] = coordinateSystemCreator;
};

CoordinateSystemManager.get = function (type) {
  return coordinateSystemCreators[type];
};

var _default = CoordinateSystemManager;
module.exports = _default;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(26);

var imageHelper = __webpack_require__(322);

var _util = __webpack_require__(0);

var getContext = _util.getContext;
var extend = _util.extend;
var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var textWidthCache = {};
var textWidthCacheCounter = 0;
var TEXT_CACHE_MAX = 5000;
var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */


function getWidth(text, font) {
  font = font || DEFAULT_FONT;
  var key = text + ':' + font;

  if (textWidthCache[key]) {
    return textWidthCache[key];
  }

  var textLines = (text + '').split('\n');
  var width = 0;

  for (var i = 0, l = textLines.length; i < l; i++) {
    // textContain.measureText may be overrided in SVG or VML
    width = Math.max(measureText(textLines[i], font).width, width);
  }

  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
    textWidthCacheCounter = 0;
    textWidthCache = {};
  }

  textWidthCacheCounter++;
  textWidthCache[key] = width;
  return width;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */


function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate);
}

function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate) {
  var contentBlock = parsePlainText(text, font, textPadding, truncate);
  var outerWidth = getWidth(text, font);

  if (textPadding) {
    outerWidth += textPadding[1] + textPadding[3];
  }

  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
  rect.lineHeight = contentBlock.lineHeight;
  return rect;
}

function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
  var contentBlock = parseRichText(text, {
    rich: rich,
    truncate: truncate,
    font: font,
    textAlign: textAlign,
    textPadding: textPadding
  });
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  return new BoundingRect(x, y, outerWidth, outerHeight);
}
/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */


function adjustTextX(x, width, textAlign) {
  // FIXME Right to left language
  if (textAlign === 'right') {
    x -= width;
  } else if (textAlign === 'center') {
    x -= width / 2;
  }

  return x;
}
/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */


function adjustTextY(y, height, textVerticalAlign) {
  if (textVerticalAlign === 'middle') {
    y -= height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y -= height;
  }

  return y;
}
/**
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */


function adjustTextPositionOnRect(textPosition, rect, distance) {
  var x = rect.x;
  var y = rect.y;
  var height = rect.height;
  var width = rect.width;
  var halfHeight = height / 2;
  var textAlign = 'left';
  var textVerticalAlign = 'top';

  switch (textPosition) {
    case 'left':
      x -= distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'right':
      x += distance + width;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'top':
      x += width / 2;
      y -= distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'bottom':
      x += width / 2;
      y += height + distance;
      textAlign = 'center';
      break;

    case 'inside':
      x += width / 2;
      y += halfHeight;
      textAlign = 'center';
      textVerticalAlign = 'middle';
      break;

    case 'insideLeft':
      x += distance;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'insideRight':
      x += width - distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'insideTop':
      x += width / 2;
      y += distance;
      textAlign = 'center';
      break;

    case 'insideBottom':
      x += width / 2;
      y += height - distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'insideTopLeft':
      x += distance;
      y += distance;
      break;

    case 'insideTopRight':
      x += width - distance;
      y += distance;
      textAlign = 'right';
      break;

    case 'insideBottomLeft':
      x += distance;
      y += height - distance;
      textVerticalAlign = 'bottom';
      break;

    case 'insideBottomRight':
      x += width - distance;
      y += height - distance;
      textAlign = 'right';
      textVerticalAlign = 'bottom';
      break;
  }

  return {
    x: x,
    y: y,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}
/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */


function truncateText(text, containerWidth, font, ellipsis, options) {
  if (!containerWidth) {
    return '';
  }

  var textLines = (text + '').split('\n');
  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
  // It is not appropriate that every line has '...' when truncate multiple lines.

  for (var i = 0, len = textLines.length; i < len; i++) {
    textLines[i] = truncateSingleLine(textLines[i], options);
  }

  return textLines.join('\n');
}

function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
  options = extend({}, options);
  options.font = font;
  var ellipsis = retrieve2(ellipsis, '...');
  options.maxIterations = retrieve2(options.maxIterations, 2);
  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
  // Other languages?

  options.cnCharWidth = getWidth('国', font); // FIXME
  // Consider proportional font?

  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.

  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.

  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
    contentWidth -= ascCharWidth;
  }

  var ellipsisWidth = getWidth(ellipsis);

  if (ellipsisWidth > contentWidth) {
    ellipsis = '';
    ellipsisWidth = 0;
  }

  contentWidth = containerWidth - ellipsisWidth;
  options.ellipsis = ellipsis;
  options.ellipsisWidth = ellipsisWidth;
  options.contentWidth = contentWidth;
  options.containerWidth = containerWidth;
  return options;
}

function truncateSingleLine(textLine, options) {
  var containerWidth = options.containerWidth;
  var font = options.font;
  var contentWidth = options.contentWidth;

  if (!containerWidth) {
    return '';
  }

  var lineWidth = getWidth(textLine, font);

  if (lineWidth <= containerWidth) {
    return textLine;
  }

  for (var j = 0;; j++) {
    if (lineWidth <= contentWidth || j >= options.maxIterations) {
      textLine += options.ellipsis;
      break;
    }

    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
    textLine = textLine.substr(0, subLength);
    lineWidth = getWidth(textLine, font);
  }

  if (textLine === '') {
    textLine = options.placeholder;
  }

  return textLine;
}

function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
  var width = 0;
  var i = 0;

  for (var len = text.length; i < len && width < contentWidth; i++) {
    var charCode = text.charCodeAt(i);
    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
  }

  return i;
}
/**
 * @public
 * @param {string} font
 * @return {number} line height
 */


function getLineHeight(font) {
  // FIXME A rough approach.
  return getWidth('国', font);
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */


function measureText(text, font) {
  return methods.measureText(text, font);
} // Avoid assign to an exported variable, for transforming to cjs.


methods.measureText = function (text, font) {
  var ctx = getContext();
  ctx.font = font || DEFAULT_FONT;
  return ctx.measureText(text);
};
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight}
 *  Notice: for performance, do not calculate outerWidth util needed.
 */


function parsePlainText(text, font, padding, truncate) {
  text != null && (text += '');
  var lineHeight = getLineHeight(font);
  var lines = text ? text.split('\n') : [];
  var height = lines.length * lineHeight;
  var outerHeight = height;

  if (padding) {
    outerHeight += padding[0] + padding[2];
  }

  if (text && truncate) {
    var truncOuterHeight = truncate.outerHeight;
    var truncOuterWidth = truncate.outerWidth;

    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
      text = '';
      lines = [];
    } else if (truncOuterWidth != null) {
      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
        minChar: truncate.minChar,
        placeholder: truncate.placeholder
      }); // FIXME
      // It is not appropriate that every line has '...' when truncate multiple lines.

      for (var i = 0, len = lines.length; i < len; i++) {
        lines[i] = truncateSingleLine(lines[i], options);
      }
    }
  }

  return {
    lines: lines,
    height: height,
    outerHeight: outerHeight,
    lineHeight: lineHeight
  };
}
/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */


function parseRichText(text, style) {
  var contentBlock = {
    lines: [],
    width: 0,
    height: 0
  };
  text != null && (text += '');

  if (!text) {
    return contentBlock;
  }

  var lastIndex = STYLE_REG.lastIndex = 0;
  var result;

  while ((result = STYLE_REG.exec(text)) != null) {
    var matchedIndex = result.index;

    if (matchedIndex > lastIndex) {
      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
    }

    pushTokens(contentBlock, result[2], result[1]);
    lastIndex = STYLE_REG.lastIndex;
  }

  if (lastIndex < text.length) {
    pushTokens(contentBlock, text.substring(lastIndex, text.length));
  }

  var lines = contentBlock.lines;
  var contentHeight = 0;
  var contentWidth = 0; // For `textWidth: 100%`

  var pendingList = [];
  var stlPadding = style.textPadding;
  var truncate = style.truncate;
  var truncateWidth = truncate && truncate.outerWidth;
  var truncateHeight = truncate && truncate.outerHeight;

  if (stlPadding) {
    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
  } // Calculate layout info of tokens.


  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var lineHeight = 0;
    var lineWidth = 0;

    for (var j = 0; j < line.tokens.length; j++) {
      var token = line.tokens[j];
      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.

      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.

      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.

      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
      // as box height of the block.
      tokenStyle.textHeight, getLineHeight(font));
      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
      token.height = tokenHeight;
      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';

      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
        return {
          lines: [],
          width: 0,
          height: 0
        };
      }

      token.textWidth = getWidth(token.text, font);
      var tokenWidth = tokenStyle.textWidth;
      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
      // line when box width is needed to be auto.

      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
        token.percentWidth = tokenWidth;
        pendingList.push(token);
        tokenWidth = 0; // Do not truncate in this case, because there is no user case
        // and it is too complicated.
      } else {
        if (tokenWidthNotSpecified) {
          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
          // `getBoundingRect()` will not get correct result.

          var textBackgroundColor = tokenStyle.textBackgroundColor;
          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
          // (1) If image is not loaded, it will be loaded at render phase and call
          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
          // image, and then the right size will be calculated here at the next tick.
          // See `graphic/helper/text.js`.
          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
          // use `imageHelper.findExistImage` to find cached image.
          // `imageHelper.findExistImage` will always be called here before
          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
          // which ensures that image will not be rendered before correct size calcualted.

          if (bgImg) {
            bgImg = imageHelper.findExistImage(bgImg);

            if (imageHelper.isImageReady(bgImg)) {
              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
            }
          }
        }

        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
        tokenWidth += paddingW;
        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;

        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
            token.text = '';
            token.textWidth = tokenWidth = 0;
          } else {
            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
              minChar: truncate.minChar
            });
            token.textWidth = getWidth(token.text, font);
            tokenWidth = token.textWidth + paddingW;
          }
        }
      }

      lineWidth += token.width = tokenWidth;
      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
    }

    line.width = lineWidth;
    line.lineHeight = lineHeight;
    contentHeight += lineHeight;
    contentWidth = Math.max(contentWidth, lineWidth);
  }

  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);

  if (stlPadding) {
    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
  }

  for (var i = 0; i < pendingList.length; i++) {
    var token = pendingList[i];
    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.

    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
  }

  return contentBlock;
}

function pushTokens(block, str, styleName) {
  var isEmptyStr = str === '';
  var strs = str.split('\n');
  var lines = block.lines;

  for (var i = 0; i < strs.length; i++) {
    var text = strs[i];
    var token = {
      styleName: styleName,
      text: text,
      isLineHolder: !text && !isEmptyStr
    }; // The first token should be appended to the last line.

    if (!i) {
      var tokens = (lines[lines.length - 1] || (lines[0] = {
        tokens: []
      })).tokens; // Consider cases:
      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
      // (which is a placeholder) should be replaced by new token.
      // (2) A image backage, where token likes {a|}.
      // (3) A redundant '' will affect textAlign in line.
      // (4) tokens with the same tplName should not be merged, because
      // they should be displayed in different box (with border and padding).

      var tokensLen = tokens.length;
      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
      (text || !tokensLen || isEmptyStr) && tokens.push(token);
    } // Other tokens always start a new line.
    else {
        // If there is '', insert it as a placeholder.
        lines.push({
          tokens: [token]
        });
      }
  }
}

function makeFont(style) {
  // FIXME in node-canvas fontWeight is before fontStyle
  // Use `fontSize` `fontFamily` to check whether font properties are defined.
  return (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
  style.fontFamily || 'sans-serif'].join(' ') || style.textFont || style.font;
}

exports.DEFAULT_FONT = DEFAULT_FONT;
exports.$override = $override;
exports.getWidth = getWidth;
exports.getBoundingRect = getBoundingRect;
exports.adjustTextX = adjustTextX;
exports.adjustTextY = adjustTextY;
exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
exports.truncateText = truncateText;
exports.getLineHeight = getLineHeight;
exports.measureText = measureText;
exports.parsePlainText = parsePlainText;
exports.parseRichText = parseRichText;
exports.makeFont = makeFont;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(81);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var IE8_DOM_DEFINE = __webpack_require__(389);
var toPrimitive = __webpack_require__(238);
var dP = Object.defineProperty;

exports.f = __webpack_require__(80) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(434);
var $export = __webpack_require__(1);
var shared = __webpack_require__(183)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(437))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(23)) {
  var LIBRARY = __webpack_require__(93);
  var global = __webpack_require__(11);
  var fails = __webpack_require__(12);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(185);
  var $buffer = __webpack_require__(265);
  var ctx = __webpack_require__(56);
  var anInstance = __webpack_require__(91);
  var propertyDesc = __webpack_require__(97);
  var hide = __webpack_require__(43);
  var redefineAll = __webpack_require__(98);
  var toInteger = __webpack_require__(64);
  var toLength = __webpack_require__(25);
  var toIndex = __webpack_require__(432);
  var toAbsoluteIndex = __webpack_require__(100);
  var toPrimitive = __webpack_require__(65);
  var has = __webpack_require__(42);
  var classof = __webpack_require__(136);
  var isObject = __webpack_require__(13);
  var toObject = __webpack_require__(30);
  var isArrayIter = __webpack_require__(251);
  var create = __webpack_require__(94);
  var getPrototypeOf = __webpack_require__(49);
  var gOPN = __webpack_require__(95).f;
  var getIterFn = __webpack_require__(268);
  var uid = __webpack_require__(101);
  var wks = __webpack_require__(20);
  var createArrayMethod = __webpack_require__(60);
  var createArrayIncludes = __webpack_require__(172);
  var speciesConstructor = __webpack_require__(184);
  var ArrayIterators = __webpack_require__(269);
  var Iterators = __webpack_require__(112);
  var $iterDetect = __webpack_require__(178);
  var setSpecies = __webpack_require__(99);
  var arrayFill = __webpack_require__(243);
  var arrayCopyWithin = __webpack_require__(405);
  var $DP = __webpack_require__(24);
  var $GOPD = __webpack_require__(48);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var MEMBER_PRIFIX = '\0ec_\0';
/**
 * Hide private class member.
 * The same behavior as `host[name] = value;` (can be right-value)
 * @public
 */

function set(host, name, value) {
  return host[MEMBER_PRIFIX + name] = value;
}
/**
 * Hide private class member.
 * The same behavior as `host[name];`
 * @public
 */


function get(host, name) {
  return host[MEMBER_PRIFIX + name];
}
/**
 * For hidden private class member.
 * The same behavior as `host.hasOwnProperty(name);`
 * @public
 */


function hasOwn(host, name) {
  return host.hasOwnProperty(MEMBER_PRIFIX + name);
}
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */


function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    componentType = componentType.split(TYPE_DELIMITER);
    ret.main = componentType[0] || '';
    ret.sub = componentType[1] || '';
  }

  return ret;
}
/**
 * @public
 */


function checkClassType(componentType) {
  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
/**
 * @public
 */


function enableClassExtend(RootClass, mandatoryMethods) {
  RootClass.$constructor = RootClass;

  RootClass.extend = function (proto) {
    var superClass = this;

    var ExtendedClass = function () {
      if (!proto.$constructor) {
        superClass.apply(this, arguments);
      } else {
        proto.$constructor.apply(this, arguments);
      }
    };

    zrUtil.extend(ExtendedClass.prototype, proto);
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    zrUtil.inherits(ExtendedClass, this);
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.


function superCall(context, methodName) {
  var args = zrUtil.slice(arguments, 2);
  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */


function enableClassManagement(entity, options) {
  options = options || {};
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */

  var storage = {};

  entity.registerClass = function (Clazz, componentType) {
    if (componentType) {
      checkClassType(componentType);
      componentType = parseClassType(componentType);

      if (!componentType.sub) {
        storage[componentType.main] = Clazz;
      } else if (componentType.sub !== IS_CONTAINER) {
        var container = makeContainer(componentType);
        container[componentType.sub] = Clazz;
      }
    }

    return Clazz;
  };

  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
    var Clazz = storage[componentMainType];

    if (Clazz && Clazz[IS_CONTAINER]) {
      Clazz = subType ? Clazz[subType] : null;
    }

    if (throwWhenNotFound && !Clazz) {
      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
    }

    return Clazz;
  };

  entity.getClassesByMainType = function (componentType) {
    componentType = parseClassType(componentType);
    var result = [];
    var obj = storage[componentType.main];

    if (obj && obj[IS_CONTAINER]) {
      zrUtil.each(obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  entity.hasClass = function (componentType) {
    // Just consider componentType.main.
    componentType = parseClassType(componentType);
    return !!storage[componentType.main];
  };
  /**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  entity.getAllClassMainTypes = function () {
    var types = [];
    zrUtil.each(storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */


  entity.hasSubTypes = function (componentType) {
    componentType = parseClassType(componentType);
    var obj = storage[componentType.main];
    return obj && obj[IS_CONTAINER];
  };

  entity.parseClassType = parseClassType;

  function makeContainer(componentType) {
    var container = storage[componentType.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentType.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }

  if (options.registerWhenExtend) {
    var originalExtend = entity.extend;

    if (originalExtend) {
      entity.extend = function (proto) {
        var ExtendedClass = originalExtend.call(this, proto);
        return entity.registerClass(ExtendedClass, proto.type);
      };
    }
  }

  return entity;
}
/**
 * @param {string|Array.<string>} properties
 */


function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
  // if (!zrUtil.isArray(properties)) {
  //     properties = properties != null ? [properties] : [];
  // }
  // zrUtil.each(properties, function (prop) {
  //     var value = obj[prop];
  //     Object.defineProperty
  //         && Object.defineProperty(obj, prop, {
  //             value: value, writable: false
  //         });
  //     zrUtil.isArray(obj[prop])
  //         && Object.freeze
  //         && Object.freeze(obj[prop]);
  // });
}

exports.set = set;
exports.get = get;
exports.hasOwn = hasOwn;
exports.parseClassType = parseClassType;
exports.enableClassExtend = enableClassExtend;
exports.enableClassManagement = enableClassManagement;
exports.setReadOnly = setReadOnly;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(504);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Eventful = __webpack_require__(108);

exports.Dispatcher = Eventful;

var env = __webpack_require__(33);

/**
 * 事件辅助类
 * @module zrender/core/event
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */
var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;

function getBoundingClientRect(el) {
  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect
  return el.getBoundingClientRect ? el.getBoundingClientRect() : {
    left: 0,
    top: 0
  };
} // `calculate` is optional, default false


function clientToLocal(el, e, out, calculate) {
  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
  // to the padding edge of the target element. The only browser using this convention
  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
  // not support the properties.
  // (see http://www.jacklmoore.com/notes/mouse-position/)
  // In zr painter.dom, padding edge equals to border edge.
  // FIXME
  // When mousemove event triggered on ec tooltip, target is not zr painter.dom, and
  // offsetX/Y is relative to e.target, where the calculation of zrX/Y via offsetX/Y
  // is too complex. So css-transfrom dont support in this case temporarily.

  if (calculate || !env.canvasSupported) {
    defaultGetZrXY(el, e, out);
  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
  // zoom-factor, overflow / opacity layers, transforms ...)
  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
  // <https://bugs.jquery.com/ticket/8523#comment:14>
  // BTW3, In ff, offsetX/offsetY is always 0.
  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
      out.zrX = e.layerX;
      out.zrY = e.layerY;
    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
      } // For some other device, e.g., IOS safari.
      else {
          defaultGetZrXY(el, e, out);
        }

  return out;
}

function defaultGetZrXY(el, e, out) {
  // This well-known method below does not support css transform.
  var box = getBoundingClientRect(el);
  out.zrX = e.clientX - box.left;
  out.zrY = e.clientY - box.top;
}
/**
 * 如果存在第三方嵌入的一些dom触发的事件，或touch事件，需要转换一下事件坐标.
 * `calculate` is optional, default false.
 */


function normalizeEvent(el, e, calculate) {
  e = e || window.event;

  if (e.zrX != null) {
    return e;
  }

  var eventType = e.type;
  var isTouch = eventType && eventType.indexOf('touch') >= 0;

  if (!isTouch) {
    clientToLocal(el, e, e, calculate);
    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
  } else {
    var touch = eventType != 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
    touch && clientToLocal(el, touch, e, calculate);
  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
  // If e.which has been defined, if may be readonly,
  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which


  var button = e.button;

  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
  }

  return e;
}

function addEventListener(el, name, handler) {
  if (isDomLevel2) {
    el.addEventListener(name, handler);
  } else {
    el.attachEvent('on' + name, handler);
  }
}

function removeEventListener(el, name, handler) {
  if (isDomLevel2) {
    el.removeEventListener(name, handler);
  } else {
    el.detachEvent('on' + name, handler);
  }
}
/**
 * preventDefault and stopPropagation.
 * Notice: do not do that in zrender. Upper application
 * do that if necessary.
 *
 * @memberOf module:zrender/core/event
 * @method
 * @param {Event} e : event对象
 */


var stop = isDomLevel2 ? function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.cancelBubble = true;
} : function (e) {
  e.returnValue = false;
  e.cancelBubble = true;
};

function notLeftMouse(e) {
  // If e.which is undefined, considered as left mouse event.
  return e.which > 1;
} // 做向上兼容


exports.clientToLocal = clientToLocal;
exports.normalizeEvent = normalizeEvent;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.stop = stop;
exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(690);

var kCSSColorTable = {
  'transparent': [0, 0, 0, 0],
  'aliceblue': [240, 248, 255, 1],
  'antiquewhite': [250, 235, 215, 1],
  'aqua': [0, 255, 255, 1],
  'aquamarine': [127, 255, 212, 1],
  'azure': [240, 255, 255, 1],
  'beige': [245, 245, 220, 1],
  'bisque': [255, 228, 196, 1],
  'black': [0, 0, 0, 1],
  'blanchedalmond': [255, 235, 205, 1],
  'blue': [0, 0, 255, 1],
  'blueviolet': [138, 43, 226, 1],
  'brown': [165, 42, 42, 1],
  'burlywood': [222, 184, 135, 1],
  'cadetblue': [95, 158, 160, 1],
  'chartreuse': [127, 255, 0, 1],
  'chocolate': [210, 105, 30, 1],
  'coral': [255, 127, 80, 1],
  'cornflowerblue': [100, 149, 237, 1],
  'cornsilk': [255, 248, 220, 1],
  'crimson': [220, 20, 60, 1],
  'cyan': [0, 255, 255, 1],
  'darkblue': [0, 0, 139, 1],
  'darkcyan': [0, 139, 139, 1],
  'darkgoldenrod': [184, 134, 11, 1],
  'darkgray': [169, 169, 169, 1],
  'darkgreen': [0, 100, 0, 1],
  'darkgrey': [169, 169, 169, 1],
  'darkkhaki': [189, 183, 107, 1],
  'darkmagenta': [139, 0, 139, 1],
  'darkolivegreen': [85, 107, 47, 1],
  'darkorange': [255, 140, 0, 1],
  'darkorchid': [153, 50, 204, 1],
  'darkred': [139, 0, 0, 1],
  'darksalmon': [233, 150, 122, 1],
  'darkseagreen': [143, 188, 143, 1],
  'darkslateblue': [72, 61, 139, 1],
  'darkslategray': [47, 79, 79, 1],
  'darkslategrey': [47, 79, 79, 1],
  'darkturquoise': [0, 206, 209, 1],
  'darkviolet': [148, 0, 211, 1],
  'deeppink': [255, 20, 147, 1],
  'deepskyblue': [0, 191, 255, 1],
  'dimgray': [105, 105, 105, 1],
  'dimgrey': [105, 105, 105, 1],
  'dodgerblue': [30, 144, 255, 1],
  'firebrick': [178, 34, 34, 1],
  'floralwhite': [255, 250, 240, 1],
  'forestgreen': [34, 139, 34, 1],
  'fuchsia': [255, 0, 255, 1],
  'gainsboro': [220, 220, 220, 1],
  'ghostwhite': [248, 248, 255, 1],
  'gold': [255, 215, 0, 1],
  'goldenrod': [218, 165, 32, 1],
  'gray': [128, 128, 128, 1],
  'green': [0, 128, 0, 1],
  'greenyellow': [173, 255, 47, 1],
  'grey': [128, 128, 128, 1],
  'honeydew': [240, 255, 240, 1],
  'hotpink': [255, 105, 180, 1],
  'indianred': [205, 92, 92, 1],
  'indigo': [75, 0, 130, 1],
  'ivory': [255, 255, 240, 1],
  'khaki': [240, 230, 140, 1],
  'lavender': [230, 230, 250, 1],
  'lavenderblush': [255, 240, 245, 1],
  'lawngreen': [124, 252, 0, 1],
  'lemonchiffon': [255, 250, 205, 1],
  'lightblue': [173, 216, 230, 1],
  'lightcoral': [240, 128, 128, 1],
  'lightcyan': [224, 255, 255, 1],
  'lightgoldenrodyellow': [250, 250, 210, 1],
  'lightgray': [211, 211, 211, 1],
  'lightgreen': [144, 238, 144, 1],
  'lightgrey': [211, 211, 211, 1],
  'lightpink': [255, 182, 193, 1],
  'lightsalmon': [255, 160, 122, 1],
  'lightseagreen': [32, 178, 170, 1],
  'lightskyblue': [135, 206, 250, 1],
  'lightslategray': [119, 136, 153, 1],
  'lightslategrey': [119, 136, 153, 1],
  'lightsteelblue': [176, 196, 222, 1],
  'lightyellow': [255, 255, 224, 1],
  'lime': [0, 255, 0, 1],
  'limegreen': [50, 205, 50, 1],
  'linen': [250, 240, 230, 1],
  'magenta': [255, 0, 255, 1],
  'maroon': [128, 0, 0, 1],
  'mediumaquamarine': [102, 205, 170, 1],
  'mediumblue': [0, 0, 205, 1],
  'mediumorchid': [186, 85, 211, 1],
  'mediumpurple': [147, 112, 219, 1],
  'mediumseagreen': [60, 179, 113, 1],
  'mediumslateblue': [123, 104, 238, 1],
  'mediumspringgreen': [0, 250, 154, 1],
  'mediumturquoise': [72, 209, 204, 1],
  'mediumvioletred': [199, 21, 133, 1],
  'midnightblue': [25, 25, 112, 1],
  'mintcream': [245, 255, 250, 1],
  'mistyrose': [255, 228, 225, 1],
  'moccasin': [255, 228, 181, 1],
  'navajowhite': [255, 222, 173, 1],
  'navy': [0, 0, 128, 1],
  'oldlace': [253, 245, 230, 1],
  'olive': [128, 128, 0, 1],
  'olivedrab': [107, 142, 35, 1],
  'orange': [255, 165, 0, 1],
  'orangered': [255, 69, 0, 1],
  'orchid': [218, 112, 214, 1],
  'palegoldenrod': [238, 232, 170, 1],
  'palegreen': [152, 251, 152, 1],
  'paleturquoise': [175, 238, 238, 1],
  'palevioletred': [219, 112, 147, 1],
  'papayawhip': [255, 239, 213, 1],
  'peachpuff': [255, 218, 185, 1],
  'peru': [205, 133, 63, 1],
  'pink': [255, 192, 203, 1],
  'plum': [221, 160, 221, 1],
  'powderblue': [176, 224, 230, 1],
  'purple': [128, 0, 128, 1],
  'red': [255, 0, 0, 1],
  'rosybrown': [188, 143, 143, 1],
  'royalblue': [65, 105, 225, 1],
  'saddlebrown': [139, 69, 19, 1],
  'salmon': [250, 128, 114, 1],
  'sandybrown': [244, 164, 96, 1],
  'seagreen': [46, 139, 87, 1],
  'seashell': [255, 245, 238, 1],
  'sienna': [160, 82, 45, 1],
  'silver': [192, 192, 192, 1],
  'skyblue': [135, 206, 235, 1],
  'slateblue': [106, 90, 205, 1],
  'slategray': [112, 128, 144, 1],
  'slategrey': [112, 128, 144, 1],
  'snow': [255, 250, 250, 1],
  'springgreen': [0, 255, 127, 1],
  'steelblue': [70, 130, 180, 1],
  'tan': [210, 180, 140, 1],
  'teal': [0, 128, 128, 1],
  'thistle': [216, 191, 216, 1],
  'tomato': [255, 99, 71, 1],
  'turquoise': [64, 224, 208, 1],
  'violet': [238, 130, 238, 1],
  'wheat': [245, 222, 179, 1],
  'white': [255, 255, 255, 1],
  'whitesmoke': [245, 245, 245, 1],
  'yellow': [255, 255, 0, 1],
  'yellowgreen': [154, 205, 50, 1]
};

function clampCssByte(i) {
  // Clamp to integer 0 .. 255.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 255 ? 255 : i;
}

function clampCssAngle(i) {
  // Clamp to integer 0 .. 360.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 360 ? 360 : i;
}

function clampCssFloat(f) {
  // Clamp to float 0.0 .. 1.0.
  return f < 0 ? 0 : f > 1 ? 1 : f;
}

function parseCssInt(str) {
  // int or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssByte(parseFloat(str) / 100 * 255);
  }

  return clampCssByte(parseInt(str, 10));
}

function parseCssFloat(str) {
  // float or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssFloat(parseFloat(str) / 100);
  }

  return clampCssFloat(parseFloat(str));
}

function cssHueToRgb(m1, m2, h) {
  if (h < 0) {
    h += 1;
  } else if (h > 1) {
    h -= 1;
  }

  if (h * 6 < 1) {
    return m1 + (m2 - m1) * h * 6;
  }

  if (h * 2 < 1) {
    return m2;
  }

  if (h * 3 < 2) {
    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
  }

  return m1;
}

function lerpNumber(a, b, p) {
  return a + (b - a) * p;
}

function setRgba(out, r, g, b, a) {
  out[0] = r;
  out[1] = g;
  out[2] = b;
  out[3] = a;
  return out;
}

function copyRgba(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

var colorCache = new LRU(20);
var lastRemovedArr = null;

function putToCache(colorStr, rgbaArr) {
  // Reuse removed array
  if (lastRemovedArr) {
    copyRgba(lastRemovedArr, rgbaArr);
  }

  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
}
/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */


function parse(colorStr, rgbaArr) {
  if (!colorStr) {
    return;
  }

  rgbaArr = rgbaArr || [];
  var cached = colorCache.get(colorStr);

  if (cached) {
    return copyRgba(rgbaArr, cached);
  } // colorStr may be not string


  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.

  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.

  if (str in kCSSColorTable) {
    copyRgba(rgbaArr, kCSSColorTable[str]);
    putToCache(colorStr, rgbaArr);
    return rgbaArr;
  } // #abc and #abc123 syntax.


  if (str.charAt(0) === '#') {
    if (str.length === 4) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xfff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    } else if (str.length === 7) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xffffff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    }

    return;
  }

  var op = str.indexOf('('),
      ep = str.indexOf(')');

  if (op !== -1 && ep + 1 === str.length) {
    var fname = str.substr(0, op);
    var params = str.substr(op + 1, ep - (op + 1)).split(',');
    var alpha = 1; // To allow case fallthrough.

    switch (fname) {
      case 'rgba':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        alpha = parseCssFloat(params.pop());
      // jshint ignore:line
      // Fall through.

      case 'rgb':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsla':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        params[3] = parseCssFloat(params[3]);
        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsl':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      default:
        return;
    }
  }

  setRgba(rgbaArr, 0, 0, 0, 1);
  return;
}
/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */


function hsla2rgba(hsla, rgba) {
  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
  // NOTE(deanm): According to the CSS spec s/l should only be
  // percentages, but we don't bother and let float or percentage.

  var s = parseCssFloat(hsla[1]);
  var l = parseCssFloat(hsla[2]);
  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
  var m1 = l * 2 - m2;
  rgba = rgba || [];
  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);

  if (hsla.length === 4) {
    rgba[3] = hsla[3];
  }

  return rgba;
}
/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */


function rgba2hsla(rgba) {
  if (!rgba) {
    return;
  } // RGB from 0 to 255


  var R = rgba[0] / 255;
  var G = rgba[1] / 255;
  var B = rgba[2] / 255;
  var vMin = Math.min(R, G, B); // Min. value of RGB

  var vMax = Math.max(R, G, B); // Max. value of RGB

  var delta = vMax - vMin; // Delta RGB value

  var L = (vMax + vMin) / 2;
  var H;
  var S; // HSL results from 0 to 1

  if (delta === 0) {
    H = 0;
    S = 0;
  } else {
    if (L < 0.5) {
      S = delta / (vMax + vMin);
    } else {
      S = delta / (2 - vMax - vMin);
    }

    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;

    if (R === vMax) {
      H = deltaB - deltaG;
    } else if (G === vMax) {
      H = 1 / 3 + deltaR - deltaB;
    } else if (B === vMax) {
      H = 2 / 3 + deltaG - deltaR;
    }

    if (H < 0) {
      H += 1;
    }

    if (H > 1) {
      H -= 1;
    }
  }

  var hsla = [H * 360, S, L];

  if (rgba[3] != null) {
    hsla.push(rgba[3]);
  }

  return hsla;
}
/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function lift(color, level) {
  var colorArr = parse(color);

  if (colorArr) {
    for (var i = 0; i < 3; i++) {
      if (level < 0) {
        colorArr[i] = colorArr[i] * (1 - level) | 0;
      } else {
        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
      }
    }

    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
  }
}
/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function toHex(color) {
  var colorArr = parse(color);

  if (colorArr) {
    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
  }
}
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */


function fastLerp(normalizedValue, colors, out) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  out = out || [];
  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = colors[leftIndex];
  var rightColor = colors[rightIndex];
  var dv = value - leftIndex;
  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
  return out;
}
/**
 * @deprecated
 */


var fastMapToColor = fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */

function lerp(normalizedValue, colors, fullOutput) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = parse(colors[leftIndex]);
  var rightColor = parse(colors[rightIndex]);
  var dv = value - leftIndex;
  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
  return fullOutput ? {
    color: color,
    leftIndex: leftIndex,
    rightIndex: rightIndex,
    value: value
  } : color;
}
/**
 * @deprecated
 */


var mapToColor = lerp;
/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */

function modifyHSL(color, h, s, l) {
  color = parse(color);

  if (color) {
    color = rgba2hsla(color);
    h != null && (color[0] = clampCssAngle(h));
    s != null && (color[1] = parseCssFloat(s));
    l != null && (color[2] = parseCssFloat(l));
    return stringify(hsla2rgba(color), 'rgba');
  }
}
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */


function modifyAlpha(color, alpha) {
  color = parse(color);

  if (color && alpha != null) {
    color[3] = clampCssFloat(alpha);
    return stringify(color, 'rgba');
  }
}
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */


function stringify(arrColor, type) {
  if (!arrColor || !arrColor.length) {
    return;
  }

  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];

  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
    colorStr += ',' + arrColor[3];
  }

  return type + '(' + colorStr + ')';
}

exports.parse = parse;
exports.lift = lift;
exports.toHex = toHex;
exports.fastLerp = fastLerp;
exports.fastMapToColor = fastMapToColor;
exports.lerp = lerp;
exports.mapToColor = mapToColor;
exports.modifyHSL = modifyHSL;
exports.modifyAlpha = modifyAlpha;
exports.stringify = stringify;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1117), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(110)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(20)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(43)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(101)('meta');
var isObject = __webpack_require__(13);
var has = __webpack_require__(42);
var setDesc = __webpack_require__(24).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var List = __webpack_require__(31);

var completeDimensions = __webpack_require__(58);

var _model = __webpack_require__(15);

var getDataItemValue = _model.getDataItemValue;
var converDataValue = _model.converDataValue;
var isDataItemOption = _model.isDataItemOption;

var CoordinateSystem = __webpack_require__(66);

function firstDataNotNull(data) {
  var i = 0;

  while (i < data.length && data[i] == null) {
    i++;
  }

  return data[i];
}

function ifNeedCompleteOrdinalData(data) {
  var sampleItem = firstDataNotNull(data);
  return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
}
/**
 * Helper function to create a list from option data
 */


function createListFromArray(data, seriesModel, ecModel) {
  // If data is undefined
  data = data || [];
  var coordSysName = seriesModel.get('coordinateSystem');
  var creator = creators[coordSysName];
  var registeredCoordSys = CoordinateSystem.get(coordSysName);
  var completeDimOpt = {
    encodeDef: seriesModel.get('encode'),
    dimsDef: seriesModel.get('dimensions')
  }; // FIXME

  var axesInfo = creator && creator(data, seriesModel, ecModel, completeDimOpt);
  var dimensions = axesInfo && axesInfo.dimensions;

  if (!dimensions) {
    // Get dimensions from registered coordinate system
    dimensions = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
  }

  var categoryIndex = axesInfo ? axesInfo.categoryIndex : -1;
  var list = new List(dimensions, seriesModel);
  var nameList = createNameList(axesInfo, data);
  var categories = {};
  var dimValueGetter = categoryIndex >= 0 && ifNeedCompleteOrdinalData(data) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // If any dataItem is like { value: 10 }
    if (isDataItemOption(itemOpt)) {
      list.hasItemOption = true;
    } // Use dataIndex as ordinal value in categoryAxis


    return dimIndex === categoryIndex ? dataIndex : converDataValue(getDataItemValue(itemOpt), dimensions[dimIndex]);
  } : function (itemOpt, dimName, dataIndex, dimIndex) {
    var value = getDataItemValue(itemOpt);
    var val = converDataValue(value && value[dimIndex], dimensions[dimIndex]); // If any dataItem is like { value: 10 }

    if (isDataItemOption(itemOpt)) {
      list.hasItemOption = true;
    }

    var categoryAxesModels = axesInfo && axesInfo.categoryAxesModels;

    if (categoryAxesModels && categoryAxesModels[dimName]) {
      // If given value is a category string
      if (typeof val === 'string') {
        // Lazy get categories
        categories[dimName] = categories[dimName] || categoryAxesModels[dimName].getCategories();
        val = zrUtil.indexOf(categories[dimName], val);

        if (val < 0 && !isNaN(val)) {
          // In case some one write '1', '2' istead of 1, 2
          val = +val;
        }
      }
    }

    return val;
  };
  list.hasItemOption = false;
  list.initData(data, nameList, dimValueGetter);
  return list;
}

function isStackable(axisType) {
  return axisType !== 'category' && axisType !== 'time';
}

function getDimTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
/**
 * Creaters for each coord system.
 */


var creators = {
  cartesian2d: function (data, seriesModel, ecModel, completeDimOpt) {
    var axesModels = zrUtil.map(['xAxis', 'yAxis'], function (name) {
      return ecModel.queryComponents({
        mainType: name,
        index: seriesModel.get(name + 'Index'),
        id: seriesModel.get(name + 'Id')
      })[0];
    });
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var dimensions = [{
      name: 'x',
      type: getDimTypeByAxis(xAxisType),
      stackable: isStackable(xAxisType)
    }, {
      name: 'y',
      // If two category axes
      type: getDimTypeByAxis(yAxisType),
      stackable: isStackable(yAxisType)
    }];
    var isXAxisCateogry = xAxisType === 'category';
    var isYAxisCategory = yAxisType === 'category';
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isXAxisCateogry) {
      categoryAxesModels.x = xAxisModel;
    }

    if (isYAxisCategory) {
      categoryAxesModels.y = yAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isXAxisCateogry ? 0 : isYAxisCategory ? 1 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  singleAxis: function (data, seriesModel, ecModel, completeDimOpt) {
    var singleAxisModel = ecModel.queryComponents({
      mainType: 'singleAxis',
      index: seriesModel.get('singleAxisIndex'),
      id: seriesModel.get('singleAxisId')
    })[0];
    var singleAxisType = singleAxisModel.get('type');
    var isCategory = singleAxisType === 'category';
    var dimensions = [{
      name: 'single',
      type: getDimTypeByAxis(singleAxisType),
      stackable: isStackable(singleAxisType)
    }];
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isCategory) {
      categoryAxesModels.single = singleAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isCategory ? 0 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  polar: function (data, seriesModel, ecModel, completeDimOpt) {
    var polarModel = ecModel.queryComponents({
      mainType: 'polar',
      index: seriesModel.get('polarIndex'),
      id: seriesModel.get('polarId')
    })[0];
    var angleAxisModel = polarModel.findAxisModel('angleAxis');
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var radiusAxisType = radiusAxisModel.get('type');
    var angleAxisType = angleAxisModel.get('type');
    var dimensions = [{
      name: 'radius',
      type: getDimTypeByAxis(radiusAxisType),
      stackable: isStackable(radiusAxisType)
    }, {
      name: 'angle',
      type: getDimTypeByAxis(angleAxisType),
      stackable: isStackable(angleAxisType)
    }];
    var isAngleAxisCateogry = angleAxisType === 'category';
    var isRadiusAxisCateogry = radiusAxisType === 'category';
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isRadiusAxisCateogry) {
      categoryAxesModels.radius = radiusAxisModel;
    }

    if (isAngleAxisCateogry) {
      categoryAxesModels.angle = angleAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isAngleAxisCateogry ? 1 : isRadiusAxisCateogry ? 0 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  geo: function (data, seriesModel, ecModel, completeDimOpt) {
    // TODO Region
    // 多个散点图系列在同一个地区的时候
    return {
      dimensions: completeDimensions([{
        name: 'lng'
      }, {
        name: 'lat'
      }], data, completeDimOpt)
    };
  }
};

function createNameList(result, data) {
  var nameList = [];
  var categoryDim = result && result.dimensions[result.categoryIndex];
  var categoryAxisModel;

  if (categoryDim) {
    categoryAxisModel = result.categoryAxesModels[categoryDim.name];
  }

  if (categoryAxisModel) {
    // FIXME Two category axis
    var categories = categoryAxisModel.getCategories();

    if (categories) {
      var dataLen = data.length; // Ordered data is given explicitly like
      // [[3, 0.2], [1, 0.3], [2, 0.15]]
      // or given scatter data,
      // pick the category

      if (zrUtil.isArray(data[0]) && data[0].length > 1) {
        nameList = [];

        for (var i = 0; i < dataLen; i++) {
          nameList[i] = categories[data[i][result.categoryIndex || 0]];
        }
      } else {
        nameList = categories.slice(0);
      }
    }
  }

  return nameList;
}

var _default = createListFromArray;
module.exports = _default;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

var features = {};

function register(name, ctor) {
  features[name] = ctor;
}

function get(name) {
  return features[name];
}

exports.register = register;
exports.get = get;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var numberUtil = __webpack_require__(8);

var axisHelper = __webpack_require__(51);

var linearMap = numberUtil.linearMap;

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
}

var normalizedExtent = [0, 1];
/**
 * @name module:echarts/coord/CartesianAxis
 * @constructor
 */

var Axis = function (dim, scale, extent) {
  /**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'
   * @type {string}
   */
  this.dim = dim;
  /**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */

  this.scale = scale;
  /**
   * @type {Array.<number>}
   * @private
   */

  this._extent = extent || [0, 0];
  /**
   * @type {boolean}
   */

  this.inverse = false;
  /**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */

  this.onBand = false;
  /**
   * @private
   * @type {number}
   */

  this._labelInterval;
};

Axis.prototype = {
  constructor: Axis,

  /**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  },

  /**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.contain(this.dataToCoord(data));
  },

  /**
   * Get coord extent.
   * @return {Array.<number>}
   */
  getExtent: function () {
    return this._extent.slice();
  },

  /**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */
  getPixelPrecision: function (dataExtent) {
    return numberUtil.getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
  },

  /**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  },

  /**
   * Convert data to coord. Data is the rank if it has a ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */
  dataToCoord: function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return linearMap(data, normalizedExtent, extent, clamp);
  },

  /**
   * Convert coord to data. Data is the rank if it has a ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */
  coordToData: function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = linearMap(coord, extent, normalizedExtent, clamp);
    return this.scale.scale(t);
  },

  /**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */
  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
  },

  /**
   * @return {Array.<number>}
   */
  getTicksCoords: function (alignWithLabel) {
    if (this.onBand && !alignWithLabel) {
      var bands = this.getBands();
      var coords = [];

      for (var i = 0; i < bands.length; i++) {
        coords.push(bands[i][0]);
      }

      if (bands[i - 1]) {
        coords.push(bands[i - 1][1]);
      }

      return coords;
    } else {
      return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
    }
  },

  /**
   * Coords of labels are on the ticks or on the middle of bands
   * @return {Array.<number>}
   */
  getLabelsCoords: function () {
    return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
  },

  /**
   * Get bands.
   *
   * If axis has labels [1, 2, 3, 4]. Bands on the axis are
   * |---1---|---2---|---3---|---4---|.
   *
   * @return {Array}
   */
  // FIXME Situation when labels is on ticks
  getBands: function () {
    var extent = this.getExtent();
    var bands = [];
    var len = this.scale.count();
    var start = extent[0];
    var end = extent[1];
    var span = end - start;

    for (var i = 0; i < len; i++) {
      bands.push([span * i / len + start, span * (i + 1) / len + start]);
    }

    return bands;
  },

  /**
   * Get width of band
   * @return {number}
   */
  getBandWidth: function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  },

  /**
   * @abstract
   * @return {boolean} Is horizontal
   */
  isHorizontal: null,

  /**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */
  getRotate: null,

  /**
   * Get interval of the axis label.
   * To get precise result, at least one of `getRotate` and `isHorizontal`
   * should be implemented.
   * @return {number}
   */
  getLabelInterval: function () {
    var labelInterval = this._labelInterval;

    if (!labelInterval) {
      var axisModel = this.model;
      var labelModel = axisModel.getModel('axisLabel');
      labelInterval = labelModel.get('interval');

      if (this.type === 'category' && (labelInterval == null || labelInterval === 'auto')) {
        labelInterval = axisHelper.getAxisLabelInterval(zrUtil.map(this.scale.getTicks(), this.dataToCoord, this), axisModel.getFormattedLabels(), labelModel.getFont(), this.getRotate ? this.getRotate() : this.isHorizontal && !this.isHorizontal() ? 90 : 0, labelModel.get('rotate'));
      }

      this._labelInterval = labelInterval;
    }

    return labelInterval;
  }
};
var _default = Axis;
module.exports = _default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Group = __webpack_require__(211);

var componentUtil = __webpack_require__(285);

var clazzUtil = __webpack_require__(75);

var modelUtil = __webpack_require__(15);

function Chart() {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewChart');
}

Chart.prototype = {
  type: 'chart',

  /**
   * Init the chart
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {},

  /**
   * Render the chart
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  render: function (seriesModel, ecModel, api, payload) {},

  /**
   * Highlight series or specified data item
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  highlight: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
  },

  /**
   * Downplay series or specified data item
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  downplay: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'normal');
  },

  /**
   * Remove self
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  remove: function (ecModel, api) {
    this.group.removeAll();
  },

  /**
   * Dispose self
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  dispose: function () {}
  /**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */
  // containPoint: function () {}

};
var chartProto = Chart.prototype;

chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
  this.render(seriesModel, ecModel, api, payload);
};
/**
 * Set state of single element
 * @param  {module:zrender/Element} el
 * @param  {string} state
 */


function elSetState(el, state) {
  if (el) {
    el.trigger(state);

    if (el.type === 'group') {
      for (var i = 0; i < el.childCount(); i++) {
        elSetState(el.childAt(i), state);
      }
    }
  }
}
/**
 * @param  {module:echarts/data/List} data
 * @param  {Object} payload
 * @param  {string} state 'normal'|'emphasis'
 * @inner
 */


function toggleHighlight(data, payload, state) {
  var dataIndex = modelUtil.queryDataIndex(data, payload);

  if (dataIndex != null) {
    zrUtil.each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state);
    });
  }
} // Enable Chart.extend.


clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Chart, {
  registerWhenExtend: true
});
var _default = Chart;
module.exports = _default;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(19);

var v2Create = _vector.create;
var v2DistSquare = _vector.distSquare;

/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */
var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3; // 临时变量

var _v0 = v2Create();

var _v1 = v2Create();

var _v2 = v2Create();

function isAroundZero(val) {
  return val > -EPSILON && val < EPSILON;
}

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicDerivativeAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function cubicRootAt(p0, p1, p2, p3, val, roots) {
  // Evaluate roots of cubic functions
  var a = p3 + 3 * (p1 - p2) - p0;
  var b = 3 * (p2 - p1 * 2 + p0);
  var c = 3 * (p1 - p0);
  var d = p0 - val;
  var A = b * b - 3 * a * c;
  var B = b * c - 9 * a * d;
  var C = c * c - 3 * b * d;
  var n = 0;

  if (isAroundZero(A) && isAroundZero(B)) {
    if (isAroundZero(b)) {
      roots[0] = 0;
    } else {
      var t1 = -c / b; //t1, t2, t3, b is not zero

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = B * B - 4 * A * C;

    if (isAroundZero(disc)) {
      var K = B / A;
      var t1 = -b / a + K; // t1, a is not zero

      var t2 = -K / 2; // t2, t3

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
      var Y2 = A * b + 1.5 * a * (-B - discSqrt);

      if (Y1 < 0) {
        Y1 = -mathPow(-Y1, ONE_THIRD);
      } else {
        Y1 = mathPow(Y1, ONE_THIRD);
      }

      if (Y2 < 0) {
        Y2 = -mathPow(-Y2, ONE_THIRD);
      } else {
        Y2 = mathPow(Y2, ONE_THIRD);
      }

      var t1 = (-b - (Y1 + Y2)) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else {
      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
      var theta = Math.acos(T) / 3;
      var ASqrt = mathSqrt(A);
      var tmp = Math.cos(theta);
      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }

      if (t3 >= 0 && t3 <= 1) {
        roots[n++] = t3;
      }
    }
  }

  return n;
}
/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */


function cubicExtrema(p0, p1, p2, p3, extrema) {
  var b = 6 * p2 - 12 * p1 + 6 * p0;
  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
  var c = 3 * p1 - 3 * p0;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      extrema[0] = -b / (2 * a);
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        extrema[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function cubicSubdivide(p0, p1, p2, p3, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p23 = (p3 - p2) * t + p2;
  var p012 = (p12 - p01) * t + p01;
  var p123 = (p23 - p12) * t + p12;
  var p0123 = (p123 - p012) * t + p012; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012;
  out[3] = p0123; // Seg1

  out[4] = p0123;
  out[5] = p123;
  out[6] = p23;
  out[7] = p3;
}
/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */


function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  var prev;
  var next;
  var d1;
  var d2;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
    d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    prev = t - interval;
    next = t + interval; // t - interval

    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
    d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = cubicAt(x0, x1, x2, x3, next);
      _v2[1] = cubicAt(y0, y1, y2, y3, next);
      d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = cubicAt(x0, x1, x2, x3, t);
    out[1] = cubicAt(y0, y1, y2, y3, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}
/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticAt(p0, p1, p2, t) {
  var onet = 1 - t;
  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticDerivativeAt(p0, p1, p2, t) {
  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function quadraticRootAt(p0, p1, p2, val, roots) {
  var a = p0 - 2 * p1 + p2;
  var b = 2 * (p1 - p0);
  var c = p0 - val;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      var t1 = -b / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */


function quadraticExtremum(p0, p1, p2) {
  var divider = p0 + p2 - 2 * p1;

  if (divider === 0) {
    // p1 is center of p0 and p2
    return 0.5;
  } else {
    return (p0 - p1) / divider;
  }
}
/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function quadraticSubdivide(p0, p1, p2, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p012 = (p12 - p01) * t + p01; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012; // Seg1

  out[3] = p012;
  out[4] = p12;
  out[5] = p2;
}
/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */


function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = quadraticAt(x0, x1, x2, _t);
    _v1[1] = quadraticAt(y0, y1, y2, _t);
    var d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    var prev = t - interval;
    var next = t + interval; // t - interval

    _v1[0] = quadraticAt(x0, x1, x2, prev);
    _v1[1] = quadraticAt(y0, y1, y2, prev);
    var d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = quadraticAt(x0, x1, x2, next);
      _v2[1] = quadraticAt(y0, y1, y2, next);
      var d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = quadraticAt(x0, x1, x2, t);
    out[1] = quadraticAt(y0, y1, y2, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}

exports.cubicAt = cubicAt;
exports.cubicDerivativeAt = cubicDerivativeAt;
exports.cubicRootAt = cubicRootAt;
exports.cubicExtrema = cubicExtrema;
exports.cubicSubdivide = cubicSubdivide;
exports.cubicProjectPoint = cubicProjectPoint;
exports.quadraticAt = quadraticAt;
exports.quadraticDerivativeAt = quadraticDerivativeAt;
exports.quadraticRootAt = quadraticRootAt;
exports.quadraticExtremum = quadraticExtremum;
exports.quadraticSubdivide = quadraticSubdivide;
exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(72);
var createDesc = __webpack_require__(135);
module.exports = __webpack_require__(80) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var call = __webpack_require__(416);
var isArrayIter = __webpack_require__(251);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(25);
var getIterFn = __webpack_require__(268);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(422);
var enumBugKeys = __webpack_require__(247);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(246)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(249).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(424);
var hiddenKeys = __webpack_require__(247).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(424);
var enumBugKeys = __webpack_require__(247);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(44);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var dP = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(23);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(64);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(0);

var retrieve = _util.retrieve;
var defaults = _util.defaults;
var extend = _util.extend;
var each = _util.each;

var formatUtil = __webpack_require__(21);

var graphic = __webpack_require__(5);

var Model = __webpack_require__(29);

var _number = __webpack_require__(8);

var isRadianAroundZero = _number.isRadianAroundZero;
var remRadian = _number.remRadian;

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var matrixUtil = __webpack_require__(53);

var _vector = __webpack_require__(19);

var v2ApplyTransform = _vector.applyTransform;
var PI = Math.PI;

function makeAxisEventDataBase(axisModel) {
  var eventData = {
    componentType: axisModel.mainType
  };
  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
  return eventData;
}
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.labelInterval] Default label interval when label
 *                                     interval from model is null or 'auto'.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */


var AxisBuilder = function (axisModel, opt) {
  /**
   * @readOnly
   */
  this.opt = opt;
  /**
   * @readOnly
   */

  this.axisModel = axisModel; // Default value

  defaults(opt, {
    labelOffset: 0,
    nameDirection: 1,
    tickDirection: 1,
    labelDirection: 1,
    silent: true
  });
  /**
   * @readOnly
   */

  this.group = new graphic.Group(); // FIXME Not use a seperate text group?

  var dumbGroup = new graphic.Group({
    position: opt.position.slice(),
    rotation: opt.rotation
  }); // this.group.add(dumbGroup);
  // this._dumbGroup = dumbGroup;

  dumbGroup.updateTransform();
  this._transform = dumbGroup.transform;
  this._dumbGroup = dumbGroup;
};

AxisBuilder.prototype = {
  constructor: AxisBuilder,
  hasBuilder: function (name) {
    return !!builders[name];
  },
  add: function (name) {
    builders[name].call(this);
  },
  getGroup: function () {
    return this.group;
  }
};
var builders = {
  /**
   * @private
   */
  axisLine: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;

    if (!axisModel.get('axisLine.show')) {
      return;
    }

    var extent = this.axisModel.axis.getExtent();
    var matrix = this._transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    }

    var lineStyle = extend({
      lineCap: 'round'
    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
    this.group.add(new graphic.Line(graphic.subPixelOptimizeLine({
      // Id for animation
      anid: 'line',
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    })));
    var arrows = axisModel.get('axisLine.symbol');
    var arrowSize = axisModel.get('axisLine.symbolSize');

    if (arrows != null) {
      if (typeof arrows === 'string') {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var symbolWidth = arrowSize[0];
      var symbolHeight = arrowSize[1];
      each([[opt.rotation + Math.PI / 2, pt1], [opt.rotation - Math.PI / 2, pt2]], function (item, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true);
          symbol.attr({
            rotation: item[0],
            position: item[1],
            silent: true
          });
          this.group.add(symbol);
        }
      }, this);
    }
  },

  /**
   * @private
   */
  axisTickLabel: function () {
    var axisModel = this.axisModel;
    var opt = this.opt;
    var tickEls = buildAxisTick(this, axisModel, opt);
    var labelEls = buildAxisLabel(this, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, tickEls);
  },

  /**
   * @private
   */
  axisName: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;
    var name = retrieve(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = this.axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
    // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
    // truncate rich text? (consider performance)

    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
      minChar: 2,
      placeholder: truncateOpt.placeholder
    }) : name;
    var tooltipOpt = axisModel.get('tooltip', true);
    var mainType = axisModel.mainType;
    var formatterParams = {
      componentType: mainType,
      name: name,
      $vars: ['name']
    };
    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'name',
      __fullText: name,
      __truncatedText: truncatedText,
      position: pos,
      rotation: labelLayout.rotation,
      silent: isSilent(axisModel),
      z2: 1,
      tooltip: tooltipOpt && tooltipOpt.show ? extend({
        content: name,
        formatter: function () {
          return name;
        },
        formatterParams: formatterParams
      }, tooltipOpt) : null
    });
    graphic.setTextStyle(textEl.style, textStyleModel, {
      text: truncatedText,
      textFont: textFont,
      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
      textAlign: labelLayout.textAlign,
      textVerticalAlign: labelLayout.textVerticalAlign
    });

    if (axisModel.get('triggerEvent')) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisName';
      textEl.eventData.name = name;
    } // FIXME


    this._dumbGroup.add(textEl);

    textEl.updateTransform();
    this.group.add(textEl);
    textEl.decomposeTransform();
  }
};
/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */

var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
  var rotationDiff = remRadian(textRotation - axisRotation);
  var textAlign;
  var textVerticalAlign;

  if (isRadianAroundZero(rotationDiff)) {
    // Label is parallel with axis line.
    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI)) {
    // Label is inverse parallel with axis line.
    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff > 0 && rotationDiff < PI) {
      textAlign = direction > 0 ? 'right' : 'left';
    } else {
      textAlign = direction > 0 ? 'left' : 'right';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
};

function endTextLayout(opt, textPosition, textRotate, extent) {
  var rotationDiff = remRadian(textRotate - opt.rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (isRadianAroundZero(rotationDiff - PI / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function isSilent(axisModel) {
  var tooltipOpt = axisModel.get('tooltip');
  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
}

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next, labelLayout) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = matrixUtil.identity([]);
  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}
/**
 * @static
 */


var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick = function (axis, i, interval, ticksCnt, showMinLabel, showMaxLabel) {
  if (i === 0 && showMinLabel || i === ticksCnt - 1 && showMaxLabel) {
    return false;
  } // FIXME
  // Have not consider label overlap (if label is too long) yet.


  var rawTick;
  var scale = axis.scale;
  return scale.type === 'ordinal' && (typeof interval === 'function' ? (rawTick = scale.getTicks()[i], !interval(rawTick, scale.getLabel(rawTick))) : i % (interval + 1));
};
/**
 * @static
 */


var getInterval = AxisBuilder.getInterval = function (model, labelInterval) {
  var interval = model.get('interval');

  if (interval == null || interval == 'auto') {
    interval = labelInterval;
  }

  return interval;
};

function buildAxisTick(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;

  if (!axisModel.get('axisTick.show') || axis.scale.isBlank()) {
    return;
  }

  var tickModel = axisModel.getModel('axisTick');
  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickLen = tickModel.get('length');
  var tickInterval = getInterval(tickModel, opt.labelInterval);
  var ticksCoords = axis.getTicksCoords(tickModel.get('alignWithLabel')); // FIXME
  // Corresponds to ticksCoords ?

  var ticks = axis.scale.getTicks();
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
  var pt1 = [];
  var pt2 = [];
  var matrix = axisBuilder._transform;
  var tickEls = [];
  var ticksCnt = ticksCoords.length;

  for (var i = 0; i < ticksCnt; i++) {
    // Only ordinal scale support tick interval
    if (ifIgnoreOnTick(axis, i, tickInterval, ticksCnt, showMinLabel, showMaxLabel)) {
      continue;
    }

    var tickCoord = ticksCoords[i];
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = opt.tickDirection * tickLen;

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new graphic.Line(graphic.subPixelOptimizeLine({
      // Id for animation
      anid: 'tick_' + ticks[i],
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: defaults(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get('axisLine.lineStyle.color')
      }),
      z2: 2,
      silent: true
    }));
    axisBuilder.group.add(tickEl);
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisLabel(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var ticks = axis.scale.getTicks();
  var labels = axisModel.getFormattedLabels(); // Special label rotate.

  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var categoryData = axisModel.get('data');
  var labelEls = [];
  var silent = isSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
  each(ticks, function (tickVal, index) {
    if (ifIgnoreOnTick(axis, index, opt.labelInterval, ticks.length, showMinLabel, showMaxLabel)) {
      return;
    }

    var itemLabelModel = labelModel;

    if (categoryData && categoryData[tickVal] && categoryData[tickVal].textStyle) {
      itemLabelModel = new Model(categoryData[tickVal].textStyle, labelModel, axisModel.ecModel);
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
    var tickCoord = axis.dataToCoord(tickVal);
    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
    var labelStr = axis.scale.getLabel(tickVal);
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'label_' + tickVal,
      position: pos,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10
    });
    graphic.setTextStyle(textEl.style, itemLabelModel, {
      text: labels[index],
      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
      // index of axis.data. So tick should not be exposed to user
      // in category axis.
      // (2) Compatible with previous version, which always returns labelStr.
      // But in interval scale labelStr is like '223,445', which maked
      // user repalce ','. So we modify it to return original val but remain
      // it as 'string' to avoid error in replacing.
      axis.type === 'category' ? labelStr : axis.type === 'value' ? tickVal + '' : tickVal, index) : textColor
    }); // Pack data for mouse event

    if (triggerEvent) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisLabel';
      textEl.eventData.value = labelStr;
    } // FIXME


    axisBuilder._dumbGroup.add(textEl);

    textEl.updateTransform();
    labelEls.push(textEl);
    axisBuilder.group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

var _default = AxisBuilder;
module.exports = _default;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var axisPointerModelHelper = __webpack_require__(189);

/**
 * Base class of AxisView.
 */
var AxisView = echarts.extendComponentView({
  type: 'axis',

  /**
   * @private
   */
  _axisPointer: null,

  /**
   * @protected
   * @type {string}
   */
  axisPointerClass: null,

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
    AxisView.superApply(this, 'render', arguments);
    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
  },

  /**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */
  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
    AxisView.superApply(this, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    disposeAxisPointer(this, api);
    AxisView.superApply(this, 'dispose', arguments);
  }
});

function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);

  if (!Clazz) {
    return;
  }

  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
}

function disposeAxisPointer(axisView, ecModel, api) {
  var axisPointer = axisView._axisPointer;
  axisPointer && axisPointer.dispose(ecModel, api);
  axisView._axisPointer = null;
}

var axisPointerClazz = [];

AxisView.registerAxisPointerClass = function (type, clazz) {
  axisPointerClazz[type] = clazz;
};

AxisView.getAxisPointerClass = function (type) {
  return type && axisPointerClazz[type];
};

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    currCall = new Date().getTime();
    scope = this;
    args = arguments;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer);

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */


function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */


function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

exports.throttle = throttle;
exports.createOrUpdate = createOrUpdate;
exports.clear = clear;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var zrColor = __webpack_require__(78);

var _number = __webpack_require__(8);

var linearMap = _number.linearMap;
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
/**
 * @param {Object} option
 * @param {string} [option.type] See visualHandlers.
 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
 *                                              required when mappingMethod is 'linear'
 * @param {Array.<Object>=} [option.pieceList] [
 *                                             {value: someValue},
 *                                             {interval: [min1, max1], visual: {...}},
 *                                             {interval: [min2, max2]}
 *                                             ],
 *                                            required when mappingMethod is 'piecewise'.
 *                                            Visual for only each piece can be specified.
 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
 *                                            required when mappingMethod is 'category'.
 *                                            If no option.categories, categories is set
 *                                            as [0, 1, 2, ...].
 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
 * @param {(Array|Object|*)} [option.visual]  Visual data.
 *                                            when mappingMethod is 'category',
 *                                            visual data can be array or object
 *                                            (like: {cate1: '#222', none: '#fff'})
 *                                            or primary types (which represents
 *                                            defualt category visual), otherwise visual
 *                                            can be array or primary (which will be
 *                                            normalized to array).
 *
 */

var VisualMapping = function (option) {
  var mappingMethod = option.mappingMethod;
  var visualType = option.type;
  /**
   * @readOnly
   * @type {Object}
   */

  var thisOption = this.option = zrUtil.clone(option);
  /**
   * @readOnly
   * @type {string}
   */

  this.type = visualType;
  /**
   * @readOnly
   * @type {string}
   */

  this.mappingMethod = mappingMethod;
  /**
   * @private
   * @type {Function}
   */

  this._normalizeData = normalizers[mappingMethod];
  var visualHandler = visualHandlers[visualType];
  /**
   * @public
   * @type {Function}
   */

  this.applyVisual = visualHandler.applyVisual;
  /**
   * @public
   * @type {Function}
   */

  this.getColorMapper = visualHandler.getColorMapper;
  /**
   * @private
   * @type {Function}
   */

  this._doMap = visualHandler._doMap[mappingMethod];

  if (mappingMethod === 'piecewise') {
    normalizeVisualRange(thisOption);
    preprocessForPiecewise(thisOption);
  } else if (mappingMethod === 'category') {
    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
    // which need no more preprocess except normalize visual.
    : normalizeVisualRange(thisOption, true);
  } else {
    // mappingMethod === 'linear' or 'fixed'
    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
    normalizeVisualRange(thisOption);
  }
};

VisualMapping.prototype = {
  constructor: VisualMapping,
  mapValueToVisual: function (value) {
    var normalized = this._normalizeData(value);

    return this._doMap(normalized, value);
  },
  getNormalizer: function () {
    return zrUtil.bind(this._normalizeData, this);
  }
};
var visualHandlers = VisualMapping.visualHandlers = {
  color: {
    applyVisual: makeApplyVisual('color'),

    /**
     * Create a mapper function
     * @return {Function}
     */
    getColorMapper: function () {
      var thisOption = this.option;
      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
        !isNormalized && (value = this._normalizeData(value));
        return doMapCategory.call(this, value);
      } : function (value, isNormalized, out) {
        // If output rgb array
        // which will be much faster and useful in pixel manipulation
        var returnRGBArray = !!out;
        !isNormalized && (value = this._normalizeData(value));
        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
      }, this);
    },
    _doMap: {
      linear: function (normalized) {
        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
      },
      category: doMapCategory,
      piecewise: function (normalized, value) {
        var result = getSpecifiedVisual.call(this, value);

        if (result == null) {
          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
        }

        return result;
      },
      fixed: doMapFixed
    }
  },
  colorHue: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, value);
  }),
  colorSaturation: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, null, value);
  }),
  colorLightness: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyHSL(color, null, null, value);
  }),
  colorAlpha: makePartialColorVisualHandler(function (color, value) {
    return zrColor.modifyAlpha(color, value);
  }),
  opacity: {
    applyVisual: makeApplyVisual('opacity'),
    _doMap: makeDoMap([0, 1])
  },
  symbol: {
    applyVisual: function (value, getter, setter) {
      var symbolCfg = this.mapValueToVisual(value);

      if (zrUtil.isString(symbolCfg)) {
        setter('symbol', symbolCfg);
      } else if (isObject(symbolCfg)) {
        for (var name in symbolCfg) {
          if (symbolCfg.hasOwnProperty(name)) {
            setter(name, symbolCfg[name]);
          }
        }
      }
    },
    _doMap: {
      linear: doMapToArray,
      category: doMapCategory,
      piecewise: function (normalized, value) {
        var result = getSpecifiedVisual.call(this, value);

        if (result == null) {
          result = doMapToArray.call(this, normalized);
        }

        return result;
      },
      fixed: doMapFixed
    }
  },
  symbolSize: {
    applyVisual: makeApplyVisual('symbolSize'),
    _doMap: makeDoMap([0, 1])
  }
};

function preprocessForPiecewise(thisOption) {
  var pieceList = thisOption.pieceList;
  thisOption.hasSpecialVisual = false;
  zrUtil.each(pieceList, function (piece, index) {
    piece.originIndex = index; // piece.visual is "result visual value" but not
    // a visual range, so it does not need to be normalized.

    if (piece.visual != null) {
      thisOption.hasSpecialVisual = true;
    }
  });
}

function preprocessForSpecifiedCategory(thisOption) {
  // Hash categories.
  var categories = thisOption.categories;
  var visual = thisOption.visual;
  var categoryMap = thisOption.categoryMap = {};
  each(categories, function (cate, index) {
    categoryMap[cate] = index;
  }); // Process visual map input.

  if (!zrUtil.isArray(visual)) {
    var visualArr = [];

    if (zrUtil.isObject(visual)) {
      each(visual, function (v, cate) {
        var index = categoryMap[cate];
        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
      });
    } else {
      // Is primary type, represents default visual.
      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
    }

    visual = setVisualToOption(thisOption, visualArr);
  } // Remove categories that has no visual,
  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.


  for (var i = categories.length - 1; i >= 0; i--) {
    if (visual[i] == null) {
      delete categoryMap[categories[i]];
      categories.pop();
    }
  }
}

function normalizeVisualRange(thisOption, isCategory) {
  var visual = thisOption.visual;
  var visualArr = [];

  if (zrUtil.isObject(visual)) {
    each(visual, function (v) {
      visualArr.push(v);
    });
  } else if (visual != null) {
    visualArr.push(visual);
  }

  var doNotNeedPair = {
    color: 1,
    symbol: 1
  };

  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
    // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
  }

  setVisualToOption(thisOption, visualArr);
}

function makePartialColorVisualHandler(applyValue) {
  return {
    applyVisual: function (value, getter, setter) {
      value = this.mapValueToVisual(value); // Must not be array value

      setter('color', applyValue(getter('color'), value));
    },
    _doMap: makeDoMap([0, 1])
  };
}

function doMapToArray(normalized) {
  var visual = this.option.visual;
  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
}

function makeApplyVisual(visualType) {
  return function (value, getter, setter) {
    setter(visualType, this.mapValueToVisual(value));
  };
}

function doMapCategory(normalized) {
  var visual = this.option.visual;
  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}

function doMapFixed() {
  return this.option.visual[0];
}

function makeDoMap(sourceExtent) {
  return {
    linear: function (normalized) {
      return linearMap(normalized, sourceExtent, this.option.visual, true);
    },
    category: doMapCategory,
    piecewise: function (normalized, value) {
      var result = getSpecifiedVisual.call(this, value);

      if (result == null) {
        result = linearMap(normalized, sourceExtent, this.option.visual, true);
      }

      return result;
    },
    fixed: doMapFixed
  };
}

function getSpecifiedVisual(value) {
  var thisOption = this.option;
  var pieceList = thisOption.pieceList;

  if (thisOption.hasSpecialVisual) {
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
    var piece = pieceList[pieceIndex];

    if (piece && piece.visual) {
      return piece.visual[this.type];
    }
  }
}

function setVisualToOption(thisOption, visualArr) {
  thisOption.visual = visualArr;

  if (thisOption.type === 'color') {
    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
      return zrColor.parse(item);
    });
  }

  return visualArr;
}
/**
 * Normalizers by mapping methods.
 */


var normalizers = {
  linear: function (value) {
    return linearMap(value, this.option.dataExtent, [0, 1], true);
  },
  piecewise: function (value) {
    var pieceList = this.option.pieceList;
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);

    if (pieceIndex != null) {
      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
    }
  },
  category: function (value) {
    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal

    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
  },
  fixed: zrUtil.noop
};
/**
 * List available visual types.
 *
 * @public
 * @return {Array.<string>}
 */

VisualMapping.listVisualTypes = function () {
  var visualTypes = [];
  zrUtil.each(visualHandlers, function (handler, key) {
    visualTypes.push(key);
  });
  return visualTypes;
};
/**
 * @public
 */


VisualMapping.addVisualHandler = function (name, handler) {
  visualHandlers[name] = handler;
};
/**
 * @public
 */


VisualMapping.isValidType = function (visualType) {
  return visualHandlers.hasOwnProperty(visualType);
};
/**
 * Convinent method.
 * Visual can be Object or Array or primary type.
 *
 * @public
 */


VisualMapping.eachVisual = function (visual, callback, context) {
  if (zrUtil.isObject(visual)) {
    zrUtil.each(visual, callback, context);
  } else {
    callback.call(context, visual);
  }
};

VisualMapping.mapVisual = function (visual, callback, context) {
  var isPrimary;
  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
  VisualMapping.eachVisual(visual, function (v, key) {
    var newVal = callback.call(context, v, key);
    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
  });
  return newVisual;
};
/**
 * @public
 * @param {Object} obj
 * @return {Object} new object containers visual values.
 *                 If no visuals, return null.
 */


VisualMapping.retrieveVisuals = function (obj) {
  var ret = {};
  var hasVisual;
  obj && each(visualHandlers, function (h, visualType) {
    if (obj.hasOwnProperty(visualType)) {
      ret[visualType] = obj[visualType];
      hasVisual = true;
    }
  });
  return hasVisual ? ret : null;
};
/**
 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
 *
 * @public
 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
 * @return {Array.<string>} Sorted visual types.
 */


VisualMapping.prepareVisualTypes = function (visualTypes) {
  if (isObject(visualTypes)) {
    var types = [];
    each(visualTypes, function (item, type) {
      types.push(type);
    });
    visualTypes = types;
  } else if (zrUtil.isArray(visualTypes)) {
    visualTypes = visualTypes.slice();
  } else {
    return [];
  }

  visualTypes.sort(function (type1, type2) {
    // color should be front of colorSaturation, colorAlpha, ...
    // symbol and symbolSize do not matter.
    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
  });
  return visualTypes;
};
/**
 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
 * Other visuals are only depends on themself.
 *
 * @public
 * @param {string} visualType1
 * @param {string} visualType2
 * @return {boolean}
 */


VisualMapping.dependsOn = function (visualType1, visualType2) {
  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
};
/**
 * @param {number} value
 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
 *                         Always from small to big.
 * @param {boolean} [findClosestWhenOutside=false]
 * @return {number} index
 */


VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
  var possibleI;
  var abs = Infinity; // value has the higher priority.

  for (var i = 0, len = pieceList.length; i < len; i++) {
    var pieceValue = pieceList[i].value;

    if (pieceValue != null) {
      if (pieceValue === value // FIXME
      // It is supposed to compare value according to value type of dimension,
      // but currently value type can exactly be string or number.
      // Compromise for numeric-like string (like '12'), especially
      // in the case that visualMap.categories is ['22', '33'].
      || typeof pieceValue === 'string' && pieceValue === value + '') {
        return i;
      }

      findClosestWhenOutside && updatePossible(pieceValue, i);
    }
  }

  for (var i = 0, len = pieceList.length; i < len; i++) {
    var piece = pieceList[i];
    var interval = piece.interval;
    var close = piece.close;

    if (interval) {
      if (interval[0] === -Infinity) {
        if (littleThan(close[1], value, interval[1])) {
          return i;
        }
      } else if (interval[1] === Infinity) {
        if (littleThan(close[0], interval[0], value)) {
          return i;
        }
      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
        return i;
      }

      findClosestWhenOutside && updatePossible(interval[0], i);
      findClosestWhenOutside && updatePossible(interval[1], i);
    }
  }

  if (findClosestWhenOutside) {
    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
  }

  function updatePossible(val, index) {
    var newAbs = Math.abs(val - value);

    if (newAbs < abs) {
      abs = newAbs;
      possibleI = index;
    }
  }
};

function littleThan(close, a, b) {
  return close ? a <= b : a < b;
}

var _default = VisualMapping;
module.exports = _default;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

function _default(seriesType, defaultSymbolType, legendSymbol, ecModel, api) {
  // Encoding visual for all series include which is filtered for legend drawing
  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var symbolType = seriesModel.get('symbol') || defaultSymbolType;
    var symbolSize = seriesModel.get('symbolSize');
    data.setVisual({
      legendSymbol: legendSymbol || symbolType,
      symbol: symbolType,
      symbolSize: symbolSize
    }); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (typeof symbolSize === 'function') {
        data.each(function (idx) {
          var rawValue = seriesModel.getRawValue(idx); // FIXME

          var params = seriesModel.getDataParams(idx);
          data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
        });
      }

      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var itemSymbolType = itemModel.getShallow('symbol', true);
        var itemSymbolSize = itemModel.getShallow('symbolSize', true); // If has item symbol

        if (itemSymbolType != null) {
          data.setItemVisual(idx, 'symbol', itemSymbolType);
        }

        if (itemSymbolSize != null) {
          // PENDING Transform symbolSize ?
          data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1689),
    getValue = __webpack_require__(1712);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/**
 * 事件扩展
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
var arrySlice = Array.prototype.slice;
/**
 * 事件分发器
 * @alias module:zrender/mixin/Eventful
 * @constructor
 */

var Eventful = function () {
  this._$handlers = {};
};

Eventful.prototype = {
  constructor: Eventful,

  /**
   * 单次触发绑定，trigger后销毁
   *
   * @param {string} event 事件名
   * @param {Function} handler 响应函数
   * @param {Object} context
   */
  one: function (event, handler, context) {
    var _h = this._$handlers;

    if (!handler || !event) {
      return this;
    }

    if (!_h[event]) {
      _h[event] = [];
    }

    for (var i = 0; i < _h[event].length; i++) {
      if (_h[event][i].h === handler) {
        return this;
      }
    }

    _h[event].push({
      h: handler,
      one: true,
      ctx: context || this
    });

    return this;
  },

  /**
   * 绑定事件
   * @param {string} event 事件名
   * @param {Function} handler 事件处理函数
   * @param {Object} [context]
   */
  on: function (event, handler, context) {
    var _h = this._$handlers;

    if (!handler || !event) {
      return this;
    }

    if (!_h[event]) {
      _h[event] = [];
    }

    for (var i = 0; i < _h[event].length; i++) {
      if (_h[event][i].h === handler) {
        return this;
      }
    }

    _h[event].push({
      h: handler,
      one: false,
      ctx: context || this
    });

    return this;
  },

  /**
   * 是否绑定了事件
   * @param  {string}  event
   * @return {boolean}
   */
  isSilent: function (event) {
    var _h = this._$handlers;
    return _h[event] && _h[event].length;
  },

  /**
   * 解绑事件
   * @param {string} event 事件名
   * @param {Function} [handler] 事件处理函数
   */
  off: function (event, handler) {
    var _h = this._$handlers;

    if (!event) {
      this._$handlers = {};
      return this;
    }

    if (handler) {
      if (_h[event]) {
        var newList = [];

        for (var i = 0, l = _h[event].length; i < l; i++) {
          if (_h[event][i]['h'] != handler) {
            newList.push(_h[event][i]);
          }
        }

        _h[event] = newList;
      }

      if (_h[event] && _h[event].length === 0) {
        delete _h[event];
      }
    } else {
      delete _h[event];
    }

    return this;
  },

  /**
   * 事件分发
   *
   * @param {string} type 事件类型
   */
  trigger: function (type) {
    if (this._$handlers[type]) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 3) {
        args = arrySlice.call(args, 1);
      }

      var _h = this._$handlers[type];
      var len = _h.length;

      for (var i = 0; i < len;) {
        // Optimize advise from backbone
        switch (argLen) {
          case 1:
            _h[i]['h'].call(_h[i]['ctx']);

            break;

          case 2:
            _h[i]['h'].call(_h[i]['ctx'], args[1]);

            break;

          case 3:
            _h[i]['h'].call(_h[i]['ctx'], args[1], args[2]);

            break;

          default:
            // have more than 2 given arguments
            _h[i]['h'].apply(_h[i]['ctx'], args);

            break;
        }

        if (_h[i]['one']) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    return this;
  },

  /**
   * 带有context的事件分发, 最后一个参数是事件回调的context
   * @param {string} type 事件类型
   */
  triggerWithContext: function (type) {
    if (this._$handlers[type]) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 4) {
        args = arrySlice.call(args, 1, args.length - 1);
      }

      var ctx = args[args.length - 1];
      var _h = this._$handlers[type];
      var len = _h.length;

      for (var i = 0; i < len;) {
        // Optimize advise from backbone
        switch (argLen) {
          case 1:
            _h[i]['h'].call(ctx);

            break;

          case 2:
            _h[i]['h'].call(ctx, args[1]);

            break;

          case 3:
            _h[i]['h'].call(ctx, args[1], args[2]);

            break;

          default:
            // have more than 2 given arguments
            _h[i]['h'].apply(ctx, args);

            break;
        }

        if (_h[i]['one']) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    return this;
  }
}; // 对象可以通过 onxxxx 绑定事件

/**
 * @event module:zrender/mixin/Eventful#onclick
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseout
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousemove
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousewheel
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousedown
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseup
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrag
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragstart
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragend
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragenter
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragleave
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrop
 * @type {Function}
 * @default null
 */

var _default = Eventful;
module.exports = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1108)
var ieee754 = __webpack_require__(1660)
var isArray = __webpack_require__(1662)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(390);
var defined = __webpack_require__(229);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(24).f;
var has = __webpack_require__(42);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(62);
var fails = __webpack_require__(12);
var spaces = __webpack_require__(263);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var axisHelper = __webpack_require__(51);

function getName(obj) {
  if (zrUtil.isObject(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

var _default = {
  /**
   * Format labels
   * @return {Array.<string>}
   */
  getFormattedLabels: function () {
    return axisHelper.getFormattedLabels(this.axis, this.get('axisLabel.formatter'));
  },

  /**
   * Get categories
   */
  getCategories: function () {
    return this.get('type') === 'category' && zrUtil.map(this.get('data'), getName);
  },

  /**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */
  getMin: function (origin) {
    var option = this.option;
    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;

    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
      min = this.axis.scale.parse(min);
    }

    return min;
  },

  /**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */
  getMax: function (origin) {
    var option = this.option;
    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;

    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
      max = this.axis.scale.parse(max);
    }

    return max;
  },

  /**
   * @return {boolean}
   */
  getNeedCrossZero: function () {
    var option = this.option;
    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
  },

  /**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */
  getCoordSysModel: zrUtil.noop,

  /**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */
  setRange: function (rangeStart, rangeEnd) {
    this.option.rangeStart = rangeStart;
    this.option.rangeEnd = rangeEnd;
  },

  /**
   * Reset range
   */
  resetRange: function () {
    // rangeStart and rangeEnd is readonly.
    this.option.rangeStart = this.option.rangeEnd = null;
  }
};
module.exports = _default;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

function defaultKeyGetter(item) {
  return item;
}
/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */


function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
  this._old = oldArr;
  this._new = newArr;
  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
  this.context = context;
}

DataDiffer.prototype = {
  constructor: DataDiffer,

  /**
   * Callback function when add a data
   */
  add: function (func) {
    this._add = func;
    return this;
  },

  /**
   * Callback function when update a data
   */
  update: function (func) {
    this._update = func;
    return this;
  },

  /**
   * Callback function when remove a data
   */
  remove: function (func) {
    this._remove = func;
    return this;
  },
  execute: function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];
    var i;
    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this); // Travel by inverted order to make sure order consistency
    // when duplicate keys exists (consider newDataIndex.pop() below).
    // For performance consideration, these code below do not look neat.

    for (i = 0; i < oldArr.length; i++) {
      var key = oldDataKeyArr[i];
      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.

      if (idx != null) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var len = idx.length;

        if (len) {
          len === 1 && (newDataIndexMap[key] = null);
          idx = idx.unshift();
        } else {
          newDataIndexMap[key] = null;
        }

        this._update && this._update(idx, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    for (var i = 0; i < newDataKeyArr.length; i++) {
      var key = newDataKeyArr[i];

      if (newDataIndexMap.hasOwnProperty(key)) {
        var idx = newDataIndexMap[key];

        if (idx == null) {
          continue;
        } // idx can never be empty array here. see 'set null' logic above.


        if (!idx.length) {
          this._add && this._add(idx);
        } else {
          for (var j = 0, len = idx.length; j < len; j++) {
            this._add && this._add(idx[j]);
          }
        }
      }
    }
  }
};

function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
  for (var i = 0; i < arr.length; i++) {
    // Add prefix to avoid conflict with Object.prototype.
    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
    var existence = map[key];

    if (existence == null) {
      keyArr.push(key);
      map[key] = i;
    } else {
      if (!existence.length) {
        map[key] = existence = [existence];
      }

      existence.push(i);
    }
  }
}

var _default = DataDiffer;
module.exports = _default;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

var _default = {
  toolbox: {
    brush: {
      title: {
        rect: '矩形选择',
        polygon: '圈选',
        lineX: '横向选择',
        lineY: '纵向选择',
        keep: '保持选择',
        clear: '清除选择'
      }
    },
    dataView: {
      title: '数据视图',
      lang: ['数据视图', '关闭', '刷新']
    },
    dataZoom: {
      title: {
        zoom: '区域缩放',
        back: '区域缩放还原'
      }
    },
    magicType: {
      title: {
        line: '切换为折线图',
        bar: '切换为柱状图',
        stack: '切换为堆叠',
        tiled: '切换为平铺'
      }
    },
    restore: {
      title: '还原'
    },
    saveAsImage: {
      title: '保存为图片',
      lang: ['右键另存为图片']
    }
  }
};
module.exports = _default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

// TODO Parse shadow style
// TODO Only shallow path support
function _default(properties) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    }

    return style;
  };
}

module.exports = _default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

(function(exports) {
  "use strict";

  function isArray(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    } else {
      return false;
    }
  }

  function isObject(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    } else {
      return false;
    }
  }

  function strictDeepEqual(first, second) {
    // Check the scalar case first.
    if (first === second) {
      return true;
    }

    // Check if they are the same type.
    var firstType = Object.prototype.toString.call(first);
    if (firstType !== Object.prototype.toString.call(second)) {
      return false;
    }
    // We know that first and second have the same type so we can just check the
    // first type from now on.
    if (isArray(first) === true) {
      // Short circuit if they're not the same length;
      if (first.length !== second.length) {
        return false;
      }
      for (var i = 0; i < first.length; i++) {
        if (strictDeepEqual(first[i], second[i]) === false) {
          return false;
        }
      }
      return true;
    }
    if (isObject(first) === true) {
      // An object is equal if it has the same key/value pairs.
      var keysSeen = {};
      for (var key in first) {
        if (hasOwnProperty.call(first, key)) {
          if (strictDeepEqual(first[key], second[key]) === false) {
            return false;
          }
          keysSeen[key] = true;
        }
      }
      // Now check that there aren't any keys in second that weren't
      // in first.
      for (var key2 in second) {
        if (hasOwnProperty.call(second, key2)) {
          if (keysSeen[key2] !== true) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  }

  function isFalse(obj) {
    // From the spec:
    // A false value corresponds to the following values:
    // Empty list
    // Empty object
    // Empty string
    // False boolean
    // null value

    // First check the scalar values.
    if (obj === "" || obj === false || obj === null) {
        return true;
    } else if (isArray(obj) && obj.length === 0) {
        // Check for an empty array.
        return true;
    } else if (isObject(obj)) {
        // Check for an empty object.
        for (var key in obj) {
            // If there are any keys, then
            // the object is not empty so the object
            // is not false.
            if (obj.hasOwnProperty(key)) {
              return false;
            }
        }
        return true;
    } else {
        return false;
    }
  }

  function objValues(obj) {
    var keys = Object.keys(obj);
    var values = [];
    for (var i = 0; i < keys.length; i++) {
      values.push(obj[keys[i]]);
    }
    return values;
  }

  function merge(a, b) {
      var merged = {};
      for (var key in a) {
          merged[key] = a[key];
      }
      for (var key2 in b) {
          merged[key2] = b[key2];
      }
      return merged;
  }

  var trimLeft;
  if (typeof String.prototype.trimLeft === "function") {
    trimLeft = function(str) {
      return str.trimLeft();
    };
  } else {
    trimLeft = function(str) {
      return str.match(/^\s*(.*)/)[1];
    };
  }

  // Type constants used to define functions.
  var TYPE_NUMBER = 0;
  var TYPE_ANY = 1;
  var TYPE_STRING = 2;
  var TYPE_ARRAY = 3;
  var TYPE_OBJECT = 4;
  var TYPE_BOOLEAN = 5;
  var TYPE_EXPREF = 6;
  var TYPE_NULL = 7;
  var TYPE_ARRAY_NUMBER = 8;
  var TYPE_ARRAY_STRING = 9;

  var TOK_EOF = "EOF";
  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
  var TOK_RBRACKET = "Rbracket";
  var TOK_RPAREN = "Rparen";
  var TOK_COMMA = "Comma";
  var TOK_COLON = "Colon";
  var TOK_RBRACE = "Rbrace";
  var TOK_NUMBER = "Number";
  var TOK_CURRENT = "Current";
  var TOK_EXPREF = "Expref";
  var TOK_PIPE = "Pipe";
  var TOK_OR = "Or";
  var TOK_AND = "And";
  var TOK_EQ = "EQ";
  var TOK_GT = "GT";
  var TOK_LT = "LT";
  var TOK_GTE = "GTE";
  var TOK_LTE = "LTE";
  var TOK_NE = "NE";
  var TOK_FLATTEN = "Flatten";
  var TOK_STAR = "Star";
  var TOK_FILTER = "Filter";
  var TOK_DOT = "Dot";
  var TOK_NOT = "Not";
  var TOK_LBRACE = "Lbrace";
  var TOK_LBRACKET = "Lbracket";
  var TOK_LPAREN= "Lparen";
  var TOK_LITERAL= "Literal";

  // The "&", "[", "<", ">" tokens
  // are not in basicToken because
  // there are two token variants
  // ("&&", "[?", "<=", ">=").  This is specially handled
  // below.

  var basicTokens = {
    ".": TOK_DOT,
    "*": TOK_STAR,
    ",": TOK_COMMA,
    ":": TOK_COLON,
    "{": TOK_LBRACE,
    "}": TOK_RBRACE,
    "]": TOK_RBRACKET,
    "(": TOK_LPAREN,
    ")": TOK_RPAREN,
    "@": TOK_CURRENT
  };

  var operatorStartToken = {
      "<": true,
      ">": true,
      "=": true,
      "!": true
  };

  var skipChars = {
      " ": true,
      "\t": true,
      "\n": true
  };


  function isAlpha(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             ch === "_";
  }

  function isNum(ch) {
      return (ch >= "0" && ch <= "9") ||
             ch === "-";
  }
  function isAlphaNum(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             (ch >= "0" && ch <= "9") ||
             ch === "_";
  }

  function Lexer() {
  }
  Lexer.prototype = {
      tokenize: function(stream) {
          var tokens = [];
          this._current = 0;
          var start;
          var identifier;
          var token;
          while (this._current < stream.length) {
              if (isAlpha(stream[this._current])) {
                  start = this._current;
                  identifier = this._consumeUnquotedIdentifier(stream);
                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (basicTokens[stream[this._current]] !== undefined) {
                  tokens.push({type: basicTokens[stream[this._current]],
                              value: stream[this._current],
                              start: this._current});
                  this._current++;
              } else if (isNum(stream[this._current])) {
                  token = this._consumeNumber(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "[") {
                  // No need to increment this._current.  This happens
                  // in _consumeLBracket
                  token = this._consumeLBracket(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "\"") {
                  start = this._current;
                  identifier = this._consumeQuotedIdentifier(stream);
                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "'") {
                  start = this._current;
                  identifier = this._consumeRawStringLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "`") {
                  start = this._current;
                  var literal = this._consumeLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: literal,
                               start: start});
              } else if (operatorStartToken[stream[this._current]] !== undefined) {
                  tokens.push(this._consumeOperator(stream));
              } else if (skipChars[stream[this._current]] !== undefined) {
                  // Ignore whitespace.
                  this._current++;
              } else if (stream[this._current] === "&") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "&") {
                      this._current++;
                      tokens.push({type: TOK_AND, value: "&&", start: start});
                  } else {
                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
                  }
              } else if (stream[this._current] === "|") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "|") {
                      this._current++;
                      tokens.push({type: TOK_OR, value: "||", start: start});
                  } else {
                      tokens.push({type: TOK_PIPE, value: "|", start: start});
                  }
              } else {
                  var error = new Error("Unknown character:" + stream[this._current]);
                  error.name = "LexerError";
                  throw error;
              }
          }
          return tokens;
      },

      _consumeUnquotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
              this._current++;
          }
          return stream.slice(start, this._current);
      },

      _consumeQuotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "\"" && this._current < maxLength) {
              // You can escape a double quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "\"")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          return JSON.parse(stream.slice(start, this._current));
      },

      _consumeRawStringLiteral: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "'" && this._current < maxLength) {
              // You can escape a single quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "'")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          var literal = stream.slice(start + 1, this._current - 1);
          return literal.replace("\\'", "'");
      },

      _consumeNumber: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (isNum(stream[this._current]) && this._current < maxLength) {
              this._current++;
          }
          var value = parseInt(stream.slice(start, this._current));
          return {type: TOK_NUMBER, value: value, start: start};
      },

      _consumeLBracket: function(stream) {
          var start = this._current;
          this._current++;
          if (stream[this._current] === "?") {
              this._current++;
              return {type: TOK_FILTER, value: "[?", start: start};
          } else if (stream[this._current] === "]") {
              this._current++;
              return {type: TOK_FLATTEN, value: "[]", start: start};
          } else {
              return {type: TOK_LBRACKET, value: "[", start: start};
          }
      },

      _consumeOperator: function(stream) {
          var start = this._current;
          var startingChar = stream[start];
          this._current++;
          if (startingChar === "!") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_NE, value: "!=", start: start};
              } else {
                return {type: TOK_NOT, value: "!", start: start};
              }
          } else if (startingChar === "<") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_LTE, value: "<=", start: start};
              } else {
                  return {type: TOK_LT, value: "<", start: start};
              }
          } else if (startingChar === ">") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_GTE, value: ">=", start: start};
              } else {
                  return {type: TOK_GT, value: ">", start: start};
              }
          } else if (startingChar === "=") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_EQ, value: "==", start: start};
              }
          }
      },

      _consumeLiteral: function(stream) {
          this._current++;
          var start = this._current;
          var maxLength = stream.length;
          var literal;
          while(stream[this._current] !== "`" && this._current < maxLength) {
              // You can escape a literal char or you can escape the escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "`")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          var literalString = trimLeft(stream.slice(start, this._current));
          literalString = literalString.replace("\\`", "`");
          if (this._looksLikeJSON(literalString)) {
              literal = JSON.parse(literalString);
          } else {
              // Try to JSON parse it as "<literal>"
              literal = JSON.parse("\"" + literalString + "\"");
          }
          // +1 gets us to the ending "`", +1 to move on to the next char.
          this._current++;
          return literal;
      },

      _looksLikeJSON: function(literalString) {
          var startingChars = "[{\"";
          var jsonLiterals = ["true", "false", "null"];
          var numberLooking = "-0123456789";

          if (literalString === "") {
              return false;
          } else if (startingChars.indexOf(literalString[0]) >= 0) {
              return true;
          } else if (jsonLiterals.indexOf(literalString) >= 0) {
              return true;
          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
              try {
                  JSON.parse(literalString);
                  return true;
              } catch (ex) {
                  return false;
              }
          } else {
              return false;
          }
      }
  };

      var bindingPower = {};
      bindingPower[TOK_EOF] = 0;
      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_RBRACKET] = 0;
      bindingPower[TOK_RPAREN] = 0;
      bindingPower[TOK_COMMA] = 0;
      bindingPower[TOK_RBRACE] = 0;
      bindingPower[TOK_NUMBER] = 0;
      bindingPower[TOK_CURRENT] = 0;
      bindingPower[TOK_EXPREF] = 0;
      bindingPower[TOK_PIPE] = 1;
      bindingPower[TOK_OR] = 2;
      bindingPower[TOK_AND] = 3;
      bindingPower[TOK_EQ] = 5;
      bindingPower[TOK_GT] = 5;
      bindingPower[TOK_LT] = 5;
      bindingPower[TOK_GTE] = 5;
      bindingPower[TOK_LTE] = 5;
      bindingPower[TOK_NE] = 5;
      bindingPower[TOK_FLATTEN] = 9;
      bindingPower[TOK_STAR] = 20;
      bindingPower[TOK_FILTER] = 21;
      bindingPower[TOK_DOT] = 40;
      bindingPower[TOK_NOT] = 45;
      bindingPower[TOK_LBRACE] = 50;
      bindingPower[TOK_LBRACKET] = 55;
      bindingPower[TOK_LPAREN] = 60;

  function Parser() {
  }

  Parser.prototype = {
      parse: function(expression) {
          this._loadTokens(expression);
          this.index = 0;
          var ast = this.expression(0);
          if (this._lookahead(0) !== TOK_EOF) {
              var t = this._lookaheadToken(0);
              var error = new Error(
                  "Unexpected token type: " + t.type + ", value: " + t.value);
              error.name = "ParserError";
              throw error;
          }
          return ast;
      },

      _loadTokens: function(expression) {
          var lexer = new Lexer();
          var tokens = lexer.tokenize(expression);
          tokens.push({type: TOK_EOF, value: "", start: expression.length});
          this.tokens = tokens;
      },

      expression: function(rbp) {
          var leftToken = this._lookaheadToken(0);
          this._advance();
          var left = this.nud(leftToken);
          var currentToken = this._lookahead(0);
          while (rbp < bindingPower[currentToken]) {
              this._advance();
              left = this.led(currentToken, left);
              currentToken = this._lookahead(0);
          }
          return left;
      },

      _lookahead: function(number) {
          return this.tokens[this.index + number].type;
      },

      _lookaheadToken: function(number) {
          return this.tokens[this.index + number];
      },

      _advance: function() {
          this.index++;
      },

      nud: function(token) {
        var left;
        var right;
        var expression;
        switch (token.type) {
          case TOK_LITERAL:
            return {type: "Literal", value: token.value};
          case TOK_UNQUOTEDIDENTIFIER:
            return {type: "Field", name: token.value};
          case TOK_QUOTEDIDENTIFIER:
            var node = {type: "Field", name: token.value};
            if (this._lookahead(0) === TOK_LPAREN) {
                throw new Error("Quoted identifier not allowed for function names.");
            } else {
                return node;
            }
            break;
          case TOK_NOT:
            right = this.expression(bindingPower.Not);
            return {type: "NotExpression", children: [right]};
          case TOK_STAR:
            left = {type: "Identity"};
            right = null;
            if (this._lookahead(0) === TOK_RBRACKET) {
                // This can happen in a multiselect,
                // [a, b, *]
                right = {type: "Identity"};
            } else {
                right = this._parseProjectionRHS(bindingPower.Star);
            }
            return {type: "ValueProjection", children: [left, right]};
          case TOK_FILTER:
            return this.led(token.type, {type: "Identity"});
          case TOK_LBRACE:
            return this._parseMultiselectHash();
          case TOK_FLATTEN:
            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
            right = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [left, right]};
          case TOK_LBRACKET:
            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice({type: "Identity"}, right);
            } else if (this._lookahead(0) === TOK_STAR &&
                       this._lookahead(1) === TOK_RBRACKET) {
                this._advance();
                this._advance();
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection",
                        children: [{type: "Identity"}, right]};
            } else {
                return this._parseMultiselectList();
            }
            break;
          case TOK_CURRENT:
            return {type: TOK_CURRENT};
          case TOK_EXPREF:
            expression = this.expression(bindingPower.Expref);
            return {type: "ExpressionReference", children: [expression]};
          case TOK_LPAREN:
            var args = [];
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            return args[0];
          default:
            this._errorToken(token);
        }
      },

      led: function(tokenName, left) {
        var right;
        switch(tokenName) {
          case TOK_DOT:
            var rbp = bindingPower.Dot;
            if (this._lookahead(0) !== TOK_STAR) {
                right = this._parseDotRHS(rbp);
                return {type: "Subexpression", children: [left, right]};
            } else {
                // Creating a projection.
                this._advance();
                right = this._parseProjectionRHS(rbp);
                return {type: "ValueProjection", children: [left, right]};
            }
            break;
          case TOK_PIPE:
            right = this.expression(bindingPower.Pipe);
            return {type: TOK_PIPE, children: [left, right]};
          case TOK_OR:
            right = this.expression(bindingPower.Or);
            return {type: "OrExpression", children: [left, right]};
          case TOK_AND:
            right = this.expression(bindingPower.And);
            return {type: "AndExpression", children: [left, right]};
          case TOK_LPAREN:
            var name = left.name;
            var args = [];
            var expression, node;
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              if (this._lookahead(0) === TOK_COMMA) {
                this._match(TOK_COMMA);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            node = {type: "Function", name: name, children: args};
            return node;
          case TOK_FILTER:
            var condition = this.expression(0);
            this._match(TOK_RBRACKET);
            if (this._lookahead(0) === TOK_FLATTEN) {
              right = {type: "Identity"};
            } else {
              right = this._parseProjectionRHS(bindingPower.Filter);
            }
            return {type: "FilterProjection", children: [left, right, condition]};
          case TOK_FLATTEN:
            var leftNode = {type: TOK_FLATTEN, children: [left]};
            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [leftNode, rightNode]};
          case TOK_EQ:
          case TOK_NE:
          case TOK_GT:
          case TOK_GTE:
          case TOK_LT:
          case TOK_LTE:
            return this._parseComparator(left, tokenName);
          case TOK_LBRACKET:
            var token = this._lookaheadToken(0);
            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice(left, right);
            } else {
                this._match(TOK_STAR);
                this._match(TOK_RBRACKET);
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection", children: [left, right]};
            }
            break;
          default:
            this._errorToken(this._lookaheadToken(0));
        }
      },

      _match: function(tokenType) {
          if (this._lookahead(0) === tokenType) {
              this._advance();
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Expected " + tokenType + ", got: " + t.type);
              error.name = "ParserError";
              throw error;
          }
      },

      _errorToken: function(token) {
          var error = new Error("Invalid token (" +
                                token.type + "): \"" +
                                token.value + "\"");
          error.name = "ParserError";
          throw error;
      },


      _parseIndexExpression: function() {
          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
              return this._parseSliceExpression();
          } else {
              var node = {
                  type: "Index",
                  value: this._lookaheadToken(0).value};
              this._advance();
              this._match(TOK_RBRACKET);
              return node;
          }
      },

      _projectIfSlice: function(left, right) {
          var indexExpr = {type: "IndexExpression", children: [left, right]};
          if (right.type === "Slice") {
              return {
                  type: "Projection",
                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
              };
          } else {
              return indexExpr;
          }
      },

      _parseSliceExpression: function() {
          // [start:end:step] where each part is optional, as well as the last
          // colon.
          var parts = [null, null, null];
          var index = 0;
          var currentToken = this._lookahead(0);
          while (currentToken !== TOK_RBRACKET && index < 3) {
              if (currentToken === TOK_COLON) {
                  index++;
                  this._advance();
              } else if (currentToken === TOK_NUMBER) {
                  parts[index] = this._lookaheadToken(0).value;
                  this._advance();
              } else {
                  var t = this._lookahead(0);
                  var error = new Error("Syntax error, unexpected token: " +
                                        t.value + "(" + t.type + ")");
                  error.name = "Parsererror";
                  throw error;
              }
              currentToken = this._lookahead(0);
          }
          this._match(TOK_RBRACKET);
          return {
              type: "Slice",
              children: parts
          };
      },

      _parseComparator: function(left, comparator) {
        var right = this.expression(bindingPower[comparator]);
        return {type: "Comparator", name: comparator, children: [left, right]};
      },

      _parseDotRHS: function(rbp) {
          var lookahead = this._lookahead(0);
          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
          if (exprTokens.indexOf(lookahead) >= 0) {
              return this.expression(rbp);
          } else if (lookahead === TOK_LBRACKET) {
              this._match(TOK_LBRACKET);
              return this._parseMultiselectList();
          } else if (lookahead === TOK_LBRACE) {
              this._match(TOK_LBRACE);
              return this._parseMultiselectHash();
          }
      },

      _parseProjectionRHS: function(rbp) {
          var right;
          if (bindingPower[this._lookahead(0)] < 10) {
              right = {type: "Identity"};
          } else if (this._lookahead(0) === TOK_LBRACKET) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_FILTER) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_DOT) {
              this._match(TOK_DOT);
              right = this._parseDotRHS(rbp);
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Sytanx error, unexpected token: " +
                                    t.value + "(" + t.type + ")");
              error.name = "ParserError";
              throw error;
          }
          return right;
      },

      _parseMultiselectList: function() {
          var expressions = [];
          while (this._lookahead(0) !== TOK_RBRACKET) {
              var expression = this.expression(0);
              expressions.push(expression);
              if (this._lookahead(0) === TOK_COMMA) {
                  this._match(TOK_COMMA);
                  if (this._lookahead(0) === TOK_RBRACKET) {
                    throw new Error("Unexpected token Rbracket");
                  }
              }
          }
          this._match(TOK_RBRACKET);
          return {type: "MultiSelectList", children: expressions};
      },

      _parseMultiselectHash: function() {
        var pairs = [];
        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
        var keyToken, keyName, value, node;
        for (;;) {
          keyToken = this._lookaheadToken(0);
          if (identifierTypes.indexOf(keyToken.type) < 0) {
            throw new Error("Expecting an identifier token, got: " +
                            keyToken.type);
          }
          keyName = keyToken.value;
          this._advance();
          this._match(TOK_COLON);
          value = this.expression(0);
          node = {type: "KeyValuePair", name: keyName, value: value};
          pairs.push(node);
          if (this._lookahead(0) === TOK_COMMA) {
            this._match(TOK_COMMA);
          } else if (this._lookahead(0) === TOK_RBRACE) {
            this._match(TOK_RBRACE);
            break;
          }
        }
        return {type: "MultiSelectHash", children: pairs};
      }
  };


  function TreeInterpreter(runtime) {
    this.runtime = runtime;
  }

  TreeInterpreter.prototype = {
      search: function(node, value) {
          return this.visit(node, value);
      },

      visit: function(node, value) {
          var matched, current, result, first, second, field, left, right, collected, i;
          switch (node.type) {
            case "Field":
              if (value === null ) {
                  return null;
              } else if (isObject(value)) {
                  field = value[node.name];
                  if (field === undefined) {
                      return null;
                  } else {
                      return field;
                  }
              } else {
                return null;
              }
              break;
            case "Subexpression":
              result = this.visit(node.children[0], value);
              for (i = 1; i < node.children.length; i++) {
                  result = this.visit(node.children[1], result);
                  if (result === null) {
                      return null;
                  }
              }
              return result;
            case "IndexExpression":
              left = this.visit(node.children[0], value);
              right = this.visit(node.children[1], left);
              return right;
            case "Index":
              if (!isArray(value)) {
                return null;
              }
              var index = node.value;
              if (index < 0) {
                index = value.length + index;
              }
              result = value[index];
              if (result === undefined) {
                result = null;
              }
              return result;
            case "Slice":
              if (!isArray(value)) {
                return null;
              }
              var sliceParams = node.children.slice(0);
              var computed = this.computeSliceParams(value.length, sliceParams);
              var start = computed[0];
              var stop = computed[1];
              var step = computed[2];
              result = [];
              if (step > 0) {
                  for (i = start; i < stop; i += step) {
                      result.push(value[i]);
                  }
              } else {
                  for (i = start; i > stop; i += step) {
                      result.push(value[i]);
                  }
              }
              return result;
            case "Projection":
              // Evaluate left child.
              var base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              collected = [];
              for (i = 0; i < base.length; i++) {
                current = this.visit(node.children[1], base[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "ValueProjection":
              // Evaluate left child.
              base = this.visit(node.children[0], value);
              if (!isObject(base)) {
                return null;
              }
              collected = [];
              var values = objValues(base);
              for (i = 0; i < values.length; i++) {
                current = this.visit(node.children[1], values[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "FilterProjection":
              base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              var filtered = [];
              var finalResults = [];
              for (i = 0; i < base.length; i++) {
                matched = this.visit(node.children[2], base[i]);
                if (!isFalse(matched)) {
                  filtered.push(base[i]);
                }
              }
              for (var j = 0; j < filtered.length; j++) {
                current = this.visit(node.children[1], filtered[j]);
                if (current !== null) {
                  finalResults.push(current);
                }
              }
              return finalResults;
            case "Comparator":
              first = this.visit(node.children[0], value);
              second = this.visit(node.children[1], value);
              switch(node.name) {
                case TOK_EQ:
                  result = strictDeepEqual(first, second);
                  break;
                case TOK_NE:
                  result = !strictDeepEqual(first, second);
                  break;
                case TOK_GT:
                  result = first > second;
                  break;
                case TOK_GTE:
                  result = first >= second;
                  break;
                case TOK_LT:
                  result = first < second;
                  break;
                case TOK_LTE:
                  result = first <= second;
                  break;
                default:
                  throw new Error("Unknown comparator: " + node.name);
              }
              return result;
            case TOK_FLATTEN:
              var original = this.visit(node.children[0], value);
              if (!isArray(original)) {
                return null;
              }
              var merged = [];
              for (i = 0; i < original.length; i++) {
                current = original[i];
                if (isArray(current)) {
                  merged.push.apply(merged, current);
                } else {
                  merged.push(current);
                }
              }
              return merged;
            case "Identity":
              return value;
            case "MultiSelectList":
              if (value === null) {
                return null;
              }
              collected = [];
              for (i = 0; i < node.children.length; i++) {
                  collected.push(this.visit(node.children[i], value));
              }
              return collected;
            case "MultiSelectHash":
              if (value === null) {
                return null;
              }
              collected = {};
              var child;
              for (i = 0; i < node.children.length; i++) {
                child = node.children[i];
                collected[child.name] = this.visit(child.value, value);
              }
              return collected;
            case "OrExpression":
              matched = this.visit(node.children[0], value);
              if (isFalse(matched)) {
                  matched = this.visit(node.children[1], value);
              }
              return matched;
            case "AndExpression":
              first = this.visit(node.children[0], value);

              if (isFalse(first) === true) {
                return first;
              }
              return this.visit(node.children[1], value);
            case "NotExpression":
              first = this.visit(node.children[0], value);
              return isFalse(first);
            case "Literal":
              return node.value;
            case TOK_PIPE:
              left = this.visit(node.children[0], value);
              return this.visit(node.children[1], left);
            case TOK_CURRENT:
              return value;
            case "Function":
              var resolvedArgs = [];
              for (i = 0; i < node.children.length; i++) {
                  resolvedArgs.push(this.visit(node.children[i], value));
              }
              return this.runtime.callFunction(node.name, resolvedArgs);
            case "ExpressionReference":
              var refNode = node.children[0];
              // Tag the node with a specific attribute so the type
              // checker verify the type.
              refNode.jmespathType = TOK_EXPREF;
              return refNode;
            default:
              throw new Error("Unknown node type: " + node.type);
          }
      },

      computeSliceParams: function(arrayLength, sliceParams) {
        var start = sliceParams[0];
        var stop = sliceParams[1];
        var step = sliceParams[2];
        var computed = [null, null, null];
        if (step === null) {
          step = 1;
        } else if (step === 0) {
          var error = new Error("Invalid slice, step cannot be 0");
          error.name = "RuntimeError";
          throw error;
        }
        var stepValueNegative = step < 0 ? true : false;

        if (start === null) {
            start = stepValueNegative ? arrayLength - 1 : 0;
        } else {
            start = this.capSliceRange(arrayLength, start, step);
        }

        if (stop === null) {
            stop = stepValueNegative ? -1 : arrayLength;
        } else {
            stop = this.capSliceRange(arrayLength, stop, step);
        }
        computed[0] = start;
        computed[1] = stop;
        computed[2] = step;
        return computed;
      },

      capSliceRange: function(arrayLength, actualValue, step) {
          if (actualValue < 0) {
              actualValue += arrayLength;
              if (actualValue < 0) {
                  actualValue = step < 0 ? -1 : 0;
              }
          } else if (actualValue >= arrayLength) {
              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
          }
          return actualValue;
      }

  };

  function Runtime(interpreter) {
    this._interpreter = interpreter;
    this.functionTable = {
        // name: [function, <signature>]
        // The <signature> can be:
        //
        // {
        //   args: [[type1, type2], [type1, type2]],
        //   variadic: true|false
        // }
        //
        // Each arg in the arg list is a list of valid types
        // (if the function is overloaded and supports multiple
        // types.  If the type is "any" then no type checking
        // occurs on the argument.  Variadic is optional
        // and if not provided is assumed to be false.
        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
        contains: {
            _func: this._functionContains,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
                        {types: [TYPE_ANY]}]},
        "ends_with": {
            _func: this._functionEndsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
        length: {
            _func: this._functionLength,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
        map: {
            _func: this._functionMap,
            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
        max: {
            _func: this._functionMax,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "merge": {
            _func: this._functionMerge,
            _signature: [{types: [TYPE_OBJECT], variadic: true}]
        },
        "max_by": {
          _func: this._functionMaxBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        "starts_with": {
            _func: this._functionStartsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        min: {
            _func: this._functionMin,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "min_by": {
          _func: this._functionMinBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
        "sort_by": {
          _func: this._functionSortBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        join: {
            _func: this._functionJoin,
            _signature: [
                {types: [TYPE_STRING]},
                {types: [TYPE_ARRAY_STRING]}
            ]
        },
        reverse: {
            _func: this._functionReverse,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
        "not_null": {
            _func: this._functionNotNull,
            _signature: [{types: [TYPE_ANY], variadic: true}]
        }
    };
  }

  Runtime.prototype = {
    callFunction: function(name, resolvedArgs) {
      var functionEntry = this.functionTable[name];
      if (functionEntry === undefined) {
          throw new Error("Unknown function: " + name + "()");
      }
      this._validateArgs(name, resolvedArgs, functionEntry._signature);
      return functionEntry._func.call(this, resolvedArgs);
    },

    _validateArgs: function(name, args, signature) {
        // Validating the args requires validating
        // the correct arity and the correct type of each arg.
        // If the last argument is declared as variadic, then we need
        // a minimum number of args to be required.  Otherwise it has to
        // be an exact amount.
        var pluralized;
        if (signature[signature.length - 1].variadic) {
            if (args.length < signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " +
                                "takes at least" + signature.length + pluralized +
                                " but received " + args.length);
            }
        } else if (args.length !== signature.length) {
            pluralized = signature.length === 1 ? " argument" : " arguments";
            throw new Error("ArgumentError: " + name + "() " +
                            "takes " + signature.length + pluralized +
                            " but received " + args.length);
        }
        var currentSpec;
        var actualType;
        var typeMatched;
        for (var i = 0; i < signature.length; i++) {
            typeMatched = false;
            currentSpec = signature[i].types;
            actualType = this._getTypeName(args[i]);
            for (var j = 0; j < currentSpec.length; j++) {
                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
            }
            if (!typeMatched) {
                throw new Error("TypeError: " + name + "() " +
                                "expected argument " + (i + 1) +
                                " to be type " + currentSpec +
                                " but received type " + actualType +
                                " instead.");
            }
        }
    },

    _typeMatches: function(actual, expected, argValue) {
        if (expected === TYPE_ANY) {
            return true;
        }
        if (expected === TYPE_ARRAY_STRING ||
            expected === TYPE_ARRAY_NUMBER ||
            expected === TYPE_ARRAY) {
            // The expected type can either just be array,
            // or it can require a specific subtype (array of numbers).
            //
            // The simplest case is if "array" with no subtype is specified.
            if (expected === TYPE_ARRAY) {
                return actual === TYPE_ARRAY;
            } else if (actual === TYPE_ARRAY) {
                // Otherwise we need to check subtypes.
                // I think this has potential to be improved.
                var subtype;
                if (expected === TYPE_ARRAY_NUMBER) {
                  subtype = TYPE_NUMBER;
                } else if (expected === TYPE_ARRAY_STRING) {
                  subtype = TYPE_STRING;
                }
                for (var i = 0; i < argValue.length; i++) {
                    if (!this._typeMatches(
                            this._getTypeName(argValue[i]), subtype,
                                             argValue[i])) {
                        return false;
                    }
                }
                return true;
            }
        } else {
            return actual === expected;
        }
    },
    _getTypeName: function(obj) {
        switch (Object.prototype.toString.call(obj)) {
            case "[object String]":
              return TYPE_STRING;
            case "[object Number]":
              return TYPE_NUMBER;
            case "[object Array]":
              return TYPE_ARRAY;
            case "[object Boolean]":
              return TYPE_BOOLEAN;
            case "[object Null]":
              return TYPE_NULL;
            case "[object Object]":
              // Check if it's an expref.  If it has, it's been
              // tagged with a jmespathType attr of 'Expref';
              if (obj.jmespathType === TOK_EXPREF) {
                return TYPE_EXPREF;
              } else {
                return TYPE_OBJECT;
              }
        }
    },

    _functionStartsWith: function(resolvedArgs) {
        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
    },

    _functionEndsWith: function(resolvedArgs) {
        var searchStr = resolvedArgs[0];
        var suffix = resolvedArgs[1];
        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
    },

    _functionReverse: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        if (typeName === TYPE_STRING) {
          var originalStr = resolvedArgs[0];
          var reversedStr = "";
          for (var i = originalStr.length - 1; i >= 0; i--) {
              reversedStr += originalStr[i];
          }
          return reversedStr;
        } else {
          var reversedArray = resolvedArgs[0].slice(0);
          reversedArray.reverse();
          return reversedArray;
        }
    },

    _functionAbs: function(resolvedArgs) {
      return Math.abs(resolvedArgs[0]);
    },

    _functionCeil: function(resolvedArgs) {
        return Math.ceil(resolvedArgs[0]);
    },

    _functionAvg: function(resolvedArgs) {
        var sum = 0;
        var inputArray = resolvedArgs[0];
        for (var i = 0; i < inputArray.length; i++) {
            sum += inputArray[i];
        }
        return sum / inputArray.length;
    },

    _functionContains: function(resolvedArgs) {
        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
    },

    _functionFloor: function(resolvedArgs) {
        return Math.floor(resolvedArgs[0]);
    },

    _functionLength: function(resolvedArgs) {
       if (!isObject(resolvedArgs[0])) {
         return resolvedArgs[0].length;
       } else {
         // As far as I can tell, there's no way to get the length
         // of an object without O(n) iteration through the object.
         return Object.keys(resolvedArgs[0]).length;
       }
    },

    _functionMap: function(resolvedArgs) {
      var mapped = [];
      var interpreter = this._interpreter;
      var exprefNode = resolvedArgs[0];
      var elements = resolvedArgs[1];
      for (var i = 0; i < elements.length; i++) {
          mapped.push(interpreter.visit(exprefNode, elements[i]));
      }
      return mapped;
    },

    _functionMerge: function(resolvedArgs) {
      var merged = {};
      for (var i = 0; i < resolvedArgs.length; i++) {
        var current = resolvedArgs[i];
        for (var key in current) {
          merged[key] = current[key];
        }
      }
      return merged;
    },

    _functionMax: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.max.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var maxElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (maxElement.localeCompare(elements[i]) < 0) {
                  maxElement = elements[i];
              }
          }
          return maxElement;
        }
      } else {
          return null;
      }
    },

    _functionMin: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.min.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var minElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (elements[i].localeCompare(minElement) < 0) {
                  minElement = elements[i];
              }
          }
          return minElement;
        }
      } else {
        return null;
      }
    },

    _functionSum: function(resolvedArgs) {
      var sum = 0;
      var listToSum = resolvedArgs[0];
      for (var i = 0; i < listToSum.length; i++) {
        sum += listToSum[i];
      }
      return sum;
    },

    _functionType: function(resolvedArgs) {
        switch (this._getTypeName(resolvedArgs[0])) {
          case TYPE_NUMBER:
            return "number";
          case TYPE_STRING:
            return "string";
          case TYPE_ARRAY:
            return "array";
          case TYPE_OBJECT:
            return "object";
          case TYPE_BOOLEAN:
            return "boolean";
          case TYPE_EXPREF:
            return "expref";
          case TYPE_NULL:
            return "null";
        }
    },

    _functionKeys: function(resolvedArgs) {
        return Object.keys(resolvedArgs[0]);
    },

    _functionValues: function(resolvedArgs) {
        var obj = resolvedArgs[0];
        var keys = Object.keys(obj);
        var values = [];
        for (var i = 0; i < keys.length; i++) {
            values.push(obj[keys[i]]);
        }
        return values;
    },

    _functionJoin: function(resolvedArgs) {
        var joinChar = resolvedArgs[0];
        var listJoin = resolvedArgs[1];
        return listJoin.join(joinChar);
    },

    _functionToArray: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
            return resolvedArgs[0];
        } else {
            return [resolvedArgs[0]];
        }
    },

    _functionToString: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
            return resolvedArgs[0];
        } else {
            return JSON.stringify(resolvedArgs[0]);
        }
    },

    _functionToNumber: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        var convertedValue;
        if (typeName === TYPE_NUMBER) {
            return resolvedArgs[0];
        } else if (typeName === TYPE_STRING) {
            convertedValue = +resolvedArgs[0];
            if (!isNaN(convertedValue)) {
                return convertedValue;
            }
        }
        return null;
    },

    _functionNotNull: function(resolvedArgs) {
        for (var i = 0; i < resolvedArgs.length; i++) {
            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
                return resolvedArgs[i];
            }
        }
        return null;
    },

    _functionSort: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        sortedArray.sort();
        return sortedArray;
    },

    _functionSortBy: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        if (sortedArray.length === 0) {
            return sortedArray;
        }
        var interpreter = this._interpreter;
        var exprefNode = resolvedArgs[1];
        var requiredType = this._getTypeName(
            interpreter.visit(exprefNode, sortedArray[0]));
        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
            throw new Error("TypeError");
        }
        var that = this;
        // In order to get a stable sort out of an unstable
        // sort algorithm, we decorate/sort/undecorate (DSU)
        // by creating a new list of [index, element] pairs.
        // In the cmp function, if the evaluated elements are
        // equal, then the index will be used as the tiebreaker.
        // After the decorated list has been sorted, it will be
        // undecorated to extract the original elements.
        var decorated = [];
        for (var i = 0; i < sortedArray.length; i++) {
          decorated.push([i, sortedArray[i]]);
        }
        decorated.sort(function(a, b) {
          var exprA = interpreter.visit(exprefNode, a[1]);
          var exprB = interpreter.visit(exprefNode, b[1]);
          if (that._getTypeName(exprA) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprA));
          } else if (that._getTypeName(exprB) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprB));
          }
          if (exprA > exprB) {
            return 1;
          } else if (exprA < exprB) {
            return -1;
          } else {
            // If they're equal compare the items by their
            // order to maintain relative order of equal keys
            // (i.e. to get a stable sort).
            return a[0] - b[0];
          }
        });
        // Undecorate: extract out the original list elements.
        for (var j = 0; j < decorated.length; j++) {
          sortedArray[j] = decorated[j][1];
        }
        return sortedArray;
    },

    _functionMaxBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var maxNumber = -Infinity;
      var maxRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current > maxNumber) {
          maxNumber = current;
          maxRecord = resolvedArray[i];
        }
      }
      return maxRecord;
    },

    _functionMinBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var minNumber = Infinity;
      var minRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current < minNumber) {
          minNumber = current;
          minRecord = resolvedArray[i];
        }
      }
      return minRecord;
    },

    createKeyFunction: function(exprefNode, allowedTypes) {
      var that = this;
      var interpreter = this._interpreter;
      var keyFunc = function(x) {
        var current = interpreter.visit(exprefNode, x);
        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
          var msg = "TypeError: expected one of " + allowedTypes +
                    ", received " + that._getTypeName(current);
          throw new Error(msg);
        }
        return current;
      };
      return keyFunc;
    }

  };

  function compile(stream) {
    var parser = new Parser();
    var ast = parser.parse(stream);
    return ast;
  }

  function tokenize(stream) {
      var lexer = new Lexer();
      return lexer.tokenize(stream);
  }

  function search(data, expression) {
      var parser = new Parser();
      // This needs to be improved.  Both the interpreter and runtime depend on
      // each other.  The runtime needs the interpreter to support exprefs.
      // There's likely a clean way to avoid the cyclic dependency.
      var runtime = new Runtime();
      var interpreter = new TreeInterpreter(runtime);
      runtime._interpreter = interpreter;
      var node = parser.parse(expression);
      return interpreter.search(node, data);
  }

  exports.tokenize = tokenize;
  exports.compile = compile;
  exports.search = search;
  exports.strictDeepEqual = strictDeepEqual;
})( false ? this.jmespath = {} : exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAfRJREFUSA1jPCIjf+Hvv/96DDQETIyMbxj//7Zl+fefQV9ano+GVjEwvH3xle3XLxZVJpragmY4SZYxcnAyiJbVMvD5BqEZQxyXJMuYBQQZ/v/+zcChb0Sc6WiqWND4OLnMgsIMwtmFDDxO7gz/f/1kYAL68mVrDcP/799x6kGXIM4yVlYGmVlLGFikZcD6Gdk5GLid3BhEf3xneNVSg24mTj5Rwcjr4gG3CNkkXlcvBgZGRmQhvGyiLGOVV8JuCNDHzCJi2OWwiBJlGSMTbmWM1PYZFkeSJYTbyWQZh18TQcsEkzIZeEAJAQcQb+5mYNfQxiGLKkzQMj4vPwYWcQlUXUg8Dl0DBnZ1TSQR3EyC+expdiIDq5Qs2ARQPhOramL4/eAew+vuFrDY////GH5cOo/bBiQZgpb9efmCAYTB4Pxphr8f3jP8+/KF4ceFM0jGEMckaBm6Md+OHEAXIprPAsz/r988/0ow7rh42Tm5eFi4kE3+/PHH55/f/v5CFsPG/vPv33/G/wwfgD77Y/P7N7MaNkXIYl/efUtjYOB04uJh5QaJf3z348OPH797//35fwFZHTY2yCKbZ4+OEF+wAU05KiO/mVeQw/HXzz+/fn7/M9X68cNabIZTTeyonPyiozJyZVQzEJ9BtxkY2PHJ45MDAA4Dgx0wJ4NUAAAAAElFTkSuQmCC"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAeRJREFUSA3Nlc9LG0EUx78zO0k2v1asUUvroQb0pkUhUihILz1VEBR6KfTSSy8FexMEr956qvQf6FVB/AOKIAhiITcPFTxZC9uSNYImm81MJ60JmwnjTiQBB5bM+773vh/ekpklh1u5IufkKfq4KBW/BcFzVq9jOj8W7yMKOHf9WNUXk7SvFMW8Oxi1kc1vIDn6RrExC7uCUTYIiACx7JyZu1LFlFgbEgnKPllHYmgB4FUQOWX55CMEv9L2qAkzGGF4MLUDy87/75egxNArZIWP8o8Pqqc2NnqNtpymBQpZ2blFgMRCyu1bI5iVnNC4UND4Q02uUzaCgZDOzhuFQJ9Tm8xgatcd4/sFSz16j2RuWTuLM/kZLDOjzYcTkZPZw0ugicfhnrZ9LDOLuFNo03RB5Dnzjt/Kv/34v34aH8HAxKY802e4OFm58RSoXX7X+bfpkTDu/0LjaS4v8OSVJQHlg6Zk/BsJU518b0+VjGNmWXB/ujUrqsNJk2QmxVLhulI5uLyuyjsrYslvphCCeIzUMe9zrrsiWjalAO+4IC+dtJVuiH8uglKlEnyqBaTYKtJsGqBnr9198+MvjY62c7uDDnshp6ldV/iXwrK7pvHvjSyBX4+2h1d74xbhcvoNdkSJNv0XY3J+T/EnVEIAAAAASUVORK5CYII="

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBljZM7b/p+BxoCJxuaDjR8+lgAAZp0CL3j6cqoAAAAASUVORK5CYII="

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLRaw, XMLText, isEmpty, isFunction, isObject,
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(68);

  isFunction = __webpack_require__(205);

  isEmpty = __webpack_require__(1754);

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      this.options = this.parent.options;
      this.stringify = this.parent.stringify;
      if (XMLElement === null) {
        XMLElement = __webpack_require__(679);
        XMLCData = __webpack_require__(675);
        XMLComment = __webpack_require__(676);
        XMLDeclaration = __webpack_require__(677);
        XMLDocType = __webpack_require__(678);
        XMLRaw = __webpack_require__(1960);
        XMLText = __webpack_require__(1962);
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && key.indexOf(this.stringify.convertPIKey) === 0) {
            lastChild = this.instruction(key.substr(this.stringify.convertPIKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name);
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element");
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref = [])), ref;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref;
      if (name != null) {
        name = name.valueOf();
      }
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      doc.xmldec = xmldec;
      return doc.root();
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var doc, doctype;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      doc.doctype = doctype;
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var child;
      if (this.isRoot) {
        return this;
      }
      child = this.parent;
      while (!child.isRoot) {
        child = child.parent;
      }
      return child;
    };

    XMLNode.prototype.document = function() {
      return this.root().documentObject;
    };

    XMLNode.prototype.end = function(options) {
      return this.document().toString(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node");
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node");
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importXMLBuilder = function(xmlbuilder) {
      var clonedRoot;
      clonedRoot = xmlbuilder.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    return XMLNode;

  })();

}).call(this);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(88);

var vec2 = __webpack_require__(19);

var bbox = __webpack_require__(320);

var BoundingRect = __webpack_require__(26);

var _config = __webpack_require__(210);

var dpr = _config.devicePixelRatio;

/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */
// TODO getTotalLength, getPointAtLength
var CMD = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  // Rect
  R: 7
}; // var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };

var min = [];
var max = [];
var min2 = [];
var max2 = [];
var mathMin = Math.min;
var mathMax = Math.max;
var mathCos = Math.cos;
var mathSin = Math.sin;
var mathSqrt = Math.sqrt;
var mathAbs = Math.abs;
var hasTypedArray = typeof Float32Array != 'undefined';
/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */

var PathProxy = function (notSaveData) {
  this._saveData = !(notSaveData || false);

  if (this._saveData) {
    /**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */
    this.data = [];
  }

  this._ctx = null;
};
/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */


PathProxy.prototype = {
  constructor: PathProxy,
  _xi: 0,
  _yi: 0,
  _x0: 0,
  _y0: 0,
  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
  _ux: 0,
  _uy: 0,
  _len: 0,
  _lineDash: null,
  _dashOffset: 0,
  _dashIdx: 0,
  _dashSum: 0,

  /**
   * @readOnly
   */
  setScale: function (sx, sy) {
    this._ux = mathAbs(1 / dpr / sx) || 0;
    this._uy = mathAbs(1 / dpr / sy) || 0;
  },
  getContext: function () {
    return this._ctx;
  },

  /**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  beginPath: function (ctx) {
    this._ctx = ctx;
    ctx && ctx.beginPath();
    ctx && (this.dpr = ctx.dpr); // Reset

    if (this._saveData) {
      this._len = 0;
    }

    if (this._lineDash) {
      this._lineDash = null;
      this._dashOffset = 0;
    }

    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  moveTo: function (x, y) {
    this.addData(CMD.M, x, y);
    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持

    this._x0 = x;
    this._y0 = y;
    this._xi = x;
    this._yi = y;
    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  lineTo: function (x, y) {
    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
    || this._len < 5;
    this.addData(CMD.L, x, y);

    if (this._ctx && exceedUnit) {
      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
    }

    if (exceedUnit) {
      this._xi = x;
      this._yi = y;
    }

    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */
  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);

    if (this._ctx) {
      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
    }

    this._xi = x3;
    this._yi = y3;
    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */
  quadraticCurveTo: function (x1, y1, x2, y2) {
    this.addData(CMD.Q, x1, y1, x2, y2);

    if (this._ctx) {
      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
    }

    this._xi = x2;
    this._yi = y2;
    return this;
  },

  /**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */
  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
    this._xi = mathCos(endAngle) * r + cx;
    this._yi = mathSin(endAngle) * r + cx;
    return this;
  },
  // TODO
  arcTo: function (x1, y1, x2, y2, radius) {
    if (this._ctx) {
      this._ctx.arcTo(x1, y1, x2, y2, radius);
    }

    return this;
  },
  // TODO
  rect: function (x, y, w, h) {
    this._ctx && this._ctx.rect(x, y, w, h);
    this.addData(CMD.R, x, y, w, h);
    return this;
  },

  /**
   * @return {module:zrender/core/PathProxy}
   */
  closePath: function () {
    this.addData(CMD.Z);
    var ctx = this._ctx;
    var x0 = this._x0;
    var y0 = this._y0;

    if (ctx) {
      this._needsDash() && this._dashedLineTo(x0, y0);
      ctx.closePath();
    }

    this._xi = x0;
    this._yi = y0;
    return this;
  },

  /**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  fill: function (ctx) {
    ctx && ctx.fill();
    this.toStatic();
  },

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  stroke: function (ctx) {
    ctx && ctx.stroke();
    this.toStatic();
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDash: function (lineDash) {
    if (lineDash instanceof Array) {
      this._lineDash = lineDash;
      this._dashIdx = 0;
      var lineDashSum = 0;

      for (var i = 0; i < lineDash.length; i++) {
        lineDashSum += lineDash[i];
      }

      this._dashSum = lineDashSum;
    }

    return this;
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDashOffset: function (offset) {
    this._dashOffset = offset;
    return this;
  },

  /**
   *
   * @return {boolean}
   */
  len: function () {
    return this._len;
  },

  /**
   * 直接设置 Path 数据
   */
  setData: function (data) {
    var len = data.length;

    if (!(this.data && this.data.length == len) && hasTypedArray) {
      this.data = new Float32Array(len);
    }

    for (var i = 0; i < len; i++) {
      this.data[i] = data[i];
    }

    this._len = len;
  },

  /**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */
  appendPath: function (path) {
    if (!(path instanceof Array)) {
      path = [path];
    }

    var len = path.length;
    var appendSize = 0;
    var offset = this._len;

    for (var i = 0; i < len; i++) {
      appendSize += path[i].len();
    }

    if (hasTypedArray && this.data instanceof Float32Array) {
      this.data = new Float32Array(offset + appendSize);
    }

    for (var i = 0; i < len; i++) {
      var appendPathData = path[i].data;

      for (var k = 0; k < appendPathData.length; k++) {
        this.data[offset++] = appendPathData[k];
      }
    }

    this._len = offset;
  },

  /**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */
  addData: function (cmd) {
    if (!this._saveData) {
      return;
    }

    var data = this.data;

    if (this._len + arguments.length > data.length) {
      // 因为之前的数组已经转换成静态的 Float32Array
      // 所以不够用时需要扩展一个新的动态数组
      this._expandData();

      data = this.data;
    }

    for (var i = 0; i < arguments.length; i++) {
      data[this._len++] = arguments[i];
    }

    this._prevCmd = cmd;
  },
  _expandData: function () {
    // Only if data is Float32Array
    if (!(this.data instanceof Array)) {
      var newData = [];

      for (var i = 0; i < this._len; i++) {
        newData[i] = this.data[i];
      }

      this.data = newData;
    }
  },

  /**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */
  _needsDash: function () {
    return this._lineDash;
  },
  _dashedLineTo: function (x1, y1) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var dx = x1 - x0;
    var dy = y1 - y0;
    var dist = mathSqrt(dx * dx + dy * dy);
    var x = x0;
    var y = y0;
    var dash;
    var nDash = lineDash.length;
    var idx;
    dx /= dist;
    dy /= dist;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum;
    x -= offset * dx;
    y -= offset * dy;

    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx == 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
      idx = this._dashIdx;
      dash = lineDash[idx];
      x += dx * dash;
      y += dy * dash;
      this._dashIdx = (idx + 1) % nDash; // Skip positive offset

      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
        continue;
      }

      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
    } // Offset for next lineTo


    dx = x - x1;
    dy = y - y1;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  // Not accurate dashed line to
  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var t;
    var dx;
    var dy;
    var cubicAt = curve.cubicAt;
    var bezierLen = 0;
    var idx = this._dashIdx;
    var nDash = lineDash.length;
    var x;
    var y;
    var tmpLen = 0;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum; // Bezier approx length

    for (t = 0; t < 1; t += 0.1) {
      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
      bezierLen += mathSqrt(dx * dx + dy * dy);
    } // Find idx after add offset


    for (; idx < nDash; idx++) {
      tmpLen += lineDash[idx];

      if (tmpLen > offset) {
        break;
      }
    }

    t = (tmpLen - offset) / bezierLen;

    while (t <= 1) {
      x = cubicAt(x0, x1, x2, x3, t);
      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
      // Bad result if dash is long

      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      t += lineDash[idx] / bezierLen;
      idx = (idx + 1) % nDash;
    } // Finish the last segment and calculate the new offset


    idx % 2 !== 0 && ctx.lineTo(x3, y3);
    dx = x3 - x;
    dy = y3 - y;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  _dashedQuadraticTo: function (x1, y1, x2, y2) {
    // Convert quadratic to cubic using degree elevation
    var x3 = x2;
    var y3 = y2;
    x2 = (x2 + 2 * x1) / 3;
    y2 = (y2 + 2 * y1) / 3;
    x1 = (this._xi + 2 * x1) / 3;
    y1 = (this._yi + 2 * y1) / 3;

    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
  },

  /**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */
  toStatic: function () {
    var data = this.data;

    if (data instanceof Array) {
      data.length = this._len;

      if (hasTypedArray) {
        this.data = new Float32Array(data);
      }
    }
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
    var data = this.data;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];

      if (i == 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = data[i];
        yi = data[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
          // 在 closePath 的时候使用
          x0 = data[i++];
          y0 = data[i++];
          xi = x0;
          yi = y0;
          min2[0] = x0;
          min2[1] = y0;
          max2[0] = x0;
          max2[1] = y0;
          break;

        case CMD.L:
          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.C:
          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.Q:
          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.A:
          // TODO Arc 判断的开销比较大
          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++];
          var endAngle = data[i++] + startAngle; // TODO Arc 旋转

          var psi = data[i++];
          var anticlockwise = 1 - data[i++];

          if (i == 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(startAngle) * rx + cx;
            y0 = mathSin(startAngle) * ry + cy;
          }

          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = data[i++];
          y0 = yi = data[i++];
          var width = data[i++];
          var height = data[i++]; // Use fromLine

          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
          break;

        case CMD.Z:
          xi = x0;
          yi = y0;
          break;
      } // Union


      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */
  rebuildPath: function (ctx) {
    var d = this.data;
    var x0, y0;
    var xi, yi;
    var x, y;
    var ux = this._ux;
    var uy = this._uy;
    var len = this._len;

    for (var i = 0; i < len;) {
      var cmd = d[i++];

      if (i == 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = d[i];
        yi = d[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          x0 = xi = d[i++];
          y0 = yi = d[i++];
          ctx.moveTo(xi, yi);
          break;

        case CMD.L:
          x = d[i++];
          y = d[i++]; // Not draw too small seg between

          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
            ctx.lineTo(x, y);
            xi = x;
            yi = y;
          }

          break;

        case CMD.C:
          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.Q:
          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.A:
          var cx = d[i++];
          var cy = d[i++];
          var rx = d[i++];
          var ry = d[i++];
          var theta = d[i++];
          var dTheta = d[i++];
          var psi = d[i++];
          var fs = d[i++];
          var r = rx > ry ? rx : ry;
          var scaleX = rx > ry ? 1 : rx / ry;
          var scaleY = rx > ry ? ry / rx : 1;
          var isEllipse = Math.abs(rx - ry) > 1e-3;
          var endAngle = theta + dTheta;

          if (isEllipse) {
            ctx.translate(cx, cy);
            ctx.rotate(psi);
            ctx.scale(scaleX, scaleY);
            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
            ctx.scale(1 / scaleX, 1 / scaleY);
            ctx.rotate(-psi);
            ctx.translate(-cx, -cy);
          } else {
            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
          }

          if (i == 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(theta) * rx + cx;
            y0 = mathSin(theta) * ry + cy;
          }

          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = d[i];
          y0 = yi = d[i + 1];
          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
          break;

        case CMD.Z:
          ctx.closePath();
          xi = x0;
          yi = y0;
      }
    }
  }
};
PathProxy.CMD = CMD;
var _default = PathProxy;
module.exports = _default;

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__ = __webpack_require__(719);






var Cognito = function () {
  function Cognito() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cognito);

    this.poolData = {
      UserPoolId: null,
      ClientId: null
    };
    this.userPool = null;
    this.initializeFlag = false;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cognito, [{
    key: 'initialize',
    value: function initialize(region, userPoolId, clientId) {
      __WEBPACK_IMPORTED_MODULE_3_aws_sdk___default.a.config.region = region;
      this.poolData = {
        UserPoolId: userPoolId,
        ClientId: clientId
      };
      this.userPool = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["a" /* CognitoUserPool */](this.poolData);
      this.initializeFlag = true;
      console.log('cognito initialize');
    }
  }, {
    key: 'login',
    value: function login(username, password) {
      // if (AWS.config.credentials) {
      //   AWS.config.credentials.clearCachedId()
      // }
      var authenticationDetails = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["b" /* AuthenticationDetails */]({
        Username: username,
        Password: password
      });
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */]({
        Username: username,
        Pool: this.userPool
      });

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: function onSuccess(result) {
            return resolve(result);
          },
          onFailure: function onFailure(err) {
            return reject(err);
          },
          // Force Change Password状態で、認証に成功した場合に呼ばれる。
          // この後、ユーザから新しいパスワードを受けとり更新する必要がある。
          newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
            reject({ code: 'NewPasswordRequired' });
          }
        });
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      // if (AWS.config.credentials) {
      //   AWS.config.credentials.clearCachedId()
      // }
      var currentUser = this.getCurrentUser();
      if (currentUser) {
        currentUser.signOut();
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
    }
  }, {
    key: 'getCurrentUser',
    value: function getCurrentUser() {
      return this.userPool.getCurrentUser();
    }
  }, {
    key: 'getSession',
    value: function getSession(user) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        user.getSession(function (err, result) {
          if (err) {
            reject(err);
          }
          resolve(result, user);
        });
      });
    }
  }, {
    key: 'getUserAttributes',
    value: function getUserAttributes() {
      var _this = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this.getSession(currentUser).then(function (result) {
          currentUser.getUserAttributes(function (err, result) {
            if (err) {
              reject(err);
            }
            var user = {};
            for (var i = 0; i < result.length; i += 1) {
              user[result[i].getName()] = result[i].getValue();
            }
            resolve(user);
          });
        });
      });
    }
  }, {
    key: 'signUp',
    value: function signUp(username, password, attributes) {
      console.log('signup');
      var self = this;
      var attributeList = [];
      for (var key in attributes) {
        var data = {
          Name: key,
          Value: attributes[key]
        };
        var attr = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["d" /* CognitoUserAttribute */](data);
        attributeList.push(attr);
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.userPool.signUp(username, password, attributeList, null, function (err, result) {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        });
      });
    }
  }, {
    key: 'confirmRegistration',
    value: function confirmRegistration(username, code) {
      var userData = {
        Username: username,
        Pool: this.userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */](userData);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.confirmRegistration(code, true, function (err, result) {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        });
      });
    }
  }, {
    key: 'resendConfirmationCode',
    value: function resendConfirmationCode(username) {
      var userData = {
        Username: username,
        Pool: this.userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */](userData);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.resendConfirmationCode(function (err, result) {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        });
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      var _this2 = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this2.getSession(currentUser).then(function (result) {
          currentUser.changePassword(oldPassword, newPassword, function (err, result) {
            if (err) {
              reject(err);
            }
            resolve(result);
          });
        });
      });
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(username) {
      var userData = {
        Username: username,
        Pool: this.userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */](userData);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.forgotPassword({
          onSuccess: function onSuccess(result) {
            return resolve(result);
          },
          onFailure: function onFailure(err) {
            return reject(err);
          }
        });
      });
    }
  }, {
    key: 'confirmResetPassword',
    value: function confirmResetPassword(username, code, newPassword) {
      var userData = {
        Username: username,
        Pool: this.userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */](userData);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.confirmPassword(code, newPassword, {
          onSuccess: function onSuccess(result) {
            return resolve(result);
          },
          onFailure: function onFailure(err) {
            return reject(err);
          }
        });
      });
    }
  }, {
    key: 'updateUsername',
    value: function updateUsername(newUsername) {
      var _this3 = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this3.getSession(currentUser).then(function (result) {
          var attributeList = [];
          var attr = {
            Name: 'preferred_username',
            Value: newUsername
          };
          attributeList.push(new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["d" /* CognitoUserAttribute */](attr));
          currentUser.updateAttributes(attributeList, function (err, result) {
            if (err) {
              console.log(err);
              reject(err);
            }
            console.log(result);
            resolve(result);
          });
        });
      });
    }
  }, {
    key: 'updateEmail',
    value: function updateEmail(newEmail) {
      var _this4 = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this4.getSession(currentUser).then(function (result) {
          var attributeList = [];
          var attr = {
            Name: 'email',
            Value: newEmail
          };
          attributeList.push(new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["d" /* CognitoUserAttribute */](attr));
          currentUser.updateAttributes(attributeList, function (err, result) {
            if (err) {
              console.log(err);
              reject(err);
            }
            console.log(result);
            resolve(result);
          });
        });
      });
    }
  }, {
    key: 'confirmEmail',
    value: function confirmEmail(code) {
      var _this5 = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this5.getSession(currentUser).then(function (result) {
          currentUser.verifyAttribute('email', code, {
            onSuccess: function onSuccess(result) {
              return resolve(result);
            },
            onFailure: function onFailure(err) {
              return reject(err);
            }
          });
        });
      });
    }
  }, {
    key: 'resendEmailConfirmationCode',
    value: function resendEmailConfirmationCode() {
      var _this6 = this;

      var currentUser = this.getCurrentUser();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!currentUser) {
          reject(new Error('not logged in'));
        }
        _this6.getSession(currentUser).then(function (result) {
          currentUser.getAttributeVerificationCode('email', {
            onSuccess: function onSuccess(result) {
              return resolve(result);
            },
            onFailure: function onFailure(err) {
              return reject(err);
            }
          });
        });
      });
    }
  }, {
    key: 'activate',
    value: function activate(username, password, newPassword) {
      var authenticationDetails = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["b" /* AuthenticationDetails */]({
        Username: username,
        Password: password
      });
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */]({
        Username: username,
        Pool: this.userPool
      });

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: function onSuccess(result) {
            reject({ message: 'This account is already activeated.' });
          },
          onFailure: function onFailure(err) {
            return reject(err);
          },
          // Force Change Password状態で、認証に成功した場合に呼ばれる。
          // この後、ユーザから新しいパスワードを受けとり更新する必要がある。
          newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
            cognitoUser.completeNewPasswordChallenge(newPassword, null, {
              onSuccess: function onSuccess(result) {
                return resolve(result);
              },
              onFailure: function onFailure(err) {
                return reject(err);
              }
            });
          }
        });
      });
    }
  }, {
    key: 'refreshSession',
    value: function refreshSession(username, refreshToken) {
      if (this.initializeFlag && username) {
        var cognitoUser = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["c" /* CognitoUser */]({
          Username: username,
          Pool: this.userPool
        });
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var cognitoRefreshToken = new __WEBPACK_IMPORTED_MODULE_4_amazon_cognito_identity_js__["e" /* CognitoRefreshToken */]({
            RefreshToken: refreshToken
          });
          cognitoUser.refreshSession(cognitoRefreshToken, function (err, result) {
            if (err) {
              reject(err);
            } else {
              resolve(result);
            }
          });
        });
      }
    }
  }]);

  return Cognito;
}();

var cognito = new Cognito();

/* harmony default export */ __webpack_exports__["a"] = (cognito);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(345);

var util = __webpack_require__(27);

function property(obj, name, value) {
  if (value !== null && value !== undefined) {
    util.property.apply(this, arguments);
  }
}

function memoizedProperty(obj, name) {
  if (!obj.constructor.prototype[name]) {
    util.memoizedProperty.apply(this, arguments);
  }
}

function Shape(shape, options, memberName) {
  options = options || {};

  property(this, 'shape', shape.shape);
  property(this, 'api', options.api, false);
  property(this, 'type', shape.type);
  property(this, 'enum', shape.enum);
  property(this, 'min', shape.min);
  property(this, 'max', shape.max);
  property(this, 'pattern', shape.pattern);
  property(this, 'location', shape.location || this.location || 'body');
  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
    shape.locationName || memberName);
  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
  property(this, 'isComposite', shape.isComposite || false);
  property(this, 'isShape', true, false);
  property(this, 'isQueryName', Boolean(shape.queryName), false);
  property(this, 'isLocationName', Boolean(shape.locationName), false);
  property(this, 'isIdempotent', shape.idempotencyToken === true);
  property(this, 'isJsonValue', shape.jsonvalue === true);
  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);

  if (options.documentation) {
    property(this, 'documentation', shape.documentation);
    property(this, 'documentationUrl', shape.documentationUrl);
  }

  if (shape.xmlAttribute) {
    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
  }

  // type conversion and parsing
  property(this, 'defaultValue', null);
  this.toWireFormat = function(value) {
    if (value === null || value === undefined) return '';
    return value;
  };
  this.toType = function(value) { return value; };
}

/**
 * @api private
 */
Shape.normalizedTypes = {
  character: 'string',
  double: 'float',
  long: 'integer',
  short: 'integer',
  biginteger: 'integer',
  bigdecimal: 'float',
  blob: 'binary'
};

/**
 * @api private
 */
Shape.types = {
  'structure': StructureShape,
  'list': ListShape,
  'map': MapShape,
  'boolean': BooleanShape,
  'timestamp': TimestampShape,
  'float': FloatShape,
  'integer': IntegerShape,
  'string': StringShape,
  'base64': Base64Shape,
  'binary': BinaryShape
};

Shape.resolve = function resolve(shape, options) {
  if (shape.shape) {
    var refShape = options.api.shapes[shape.shape];
    if (!refShape) {
      throw new Error('Cannot find shape reference: ' + shape.shape);
    }

    return refShape;
  } else {
    return null;
  }
};

Shape.create = function create(shape, options, memberName) {
  if (shape.isShape) return shape;

  var refShape = Shape.resolve(shape, options);
  if (refShape) {
    var filteredKeys = Object.keys(shape);
    if (!options.documentation) {
      filteredKeys = filteredKeys.filter(function(name) {
        return !name.match(/documentation/);
      });
    }

    // create an inline shape with extra members
    var InlineShape = function() {
      refShape.constructor.call(this, shape, options, memberName);
    };
    InlineShape.prototype = refShape;
    return new InlineShape();
  } else {
    // set type if not set
    if (!shape.type) {
      if (shape.members) shape.type = 'structure';
      else if (shape.member) shape.type = 'list';
      else if (shape.key) shape.type = 'map';
      else shape.type = 'string';
    }

    // normalize types
    var origType = shape.type;
    if (Shape.normalizedTypes[shape.type]) {
      shape.type = Shape.normalizedTypes[shape.type];
    }

    if (Shape.types[shape.type]) {
      return new Shape.types[shape.type](shape, options, memberName);
    } else {
      throw new Error('Unrecognized shape type: ' + origType);
    }
  }
};

function CompositeShape(shape) {
  Shape.apply(this, arguments);
  property(this, 'isComposite', true);

  if (shape.flattened) {
    property(this, 'flattened', shape.flattened || false);
  }
}

function StructureShape(shape, options) {
  var requiredMap = null, firstInit = !this.isShape;

  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'members', {});
    property(this, 'memberNames', []);
    property(this, 'required', []);
    property(this, 'isRequired', function() { return false; });
  }

  if (shape.members) {
    property(this, 'members', new Collection(shape.members, options, function(name, member) {
      return Shape.create(member, options, name);
    }));
    memoizedProperty(this, 'memberNames', function() {
      return shape.xmlOrder || Object.keys(shape.members);
    });
  }

  if (shape.required) {
    property(this, 'required', shape.required);
    property(this, 'isRequired', function(name) {
      if (!requiredMap) {
        requiredMap = {};
        for (var i = 0; i < shape.required.length; i++) {
          requiredMap[shape.required[i]] = true;
        }
      }

      return requiredMap[name];
    }, false, true);
  }

  property(this, 'resultWrapper', shape.resultWrapper || null);

  if (shape.payload) {
    property(this, 'payload', shape.payload);
  }

  if (typeof shape.xmlNamespace === 'string') {
    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
  } else if (typeof shape.xmlNamespace === 'object') {
    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
  }
}

function ListShape(shape, options) {
  var self = this, firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return []; });
  }

  if (shape.member) {
    memoizedProperty(this, 'member', function() {
      return Shape.create(shape.member, options);
    });
  }

  if (this.flattened) {
    var oldName = this.name;
    memoizedProperty(this, 'name', function() {
      return self.member.name || oldName;
    });
  }
}

function MapShape(shape, options) {
  var firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'key', Shape.create({type: 'string'}, options));
    property(this, 'value', Shape.create({type: 'string'}, options));
  }

  if (shape.key) {
    memoizedProperty(this, 'key', function() {
      return Shape.create(shape.key, options);
    });
  }
  if (shape.value) {
    memoizedProperty(this, 'value', function() {
      return Shape.create(shape.value, options);
    });
  }
}

function TimestampShape(shape) {
  var self = this;
  Shape.apply(this, arguments);

  if (this.location === 'header') {
    property(this, 'timestampFormat', 'rfc822');
  } else if (shape.timestampFormat) {
    property(this, 'timestampFormat', shape.timestampFormat);
  } else if (!this.timestampFormat && this.api) {
    if (this.api.timestampFormat) {
      property(this, 'timestampFormat', this.api.timestampFormat);
    } else {
      switch (this.api.protocol) {
        case 'json':
        case 'rest-json':
          property(this, 'timestampFormat', 'unixTimestamp');
          break;
        case 'rest-xml':
        case 'query':
        case 'ec2':
          property(this, 'timestampFormat', 'iso8601');
          break;
      }
    }
  }

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    if (typeof value.toUTCString === 'function') return value;
    return typeof value === 'string' || typeof value === 'number' ?
           util.date.parseTimestamp(value) : null;
  };

  this.toWireFormat = function(value) {
    return util.date.format(value, self.timestampFormat);
  };
}

function StringShape() {
  Shape.apply(this, arguments);

  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
  this.toType = function(value) {
    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
      value || '' : value;
    if (this.isJsonValue) {
      return JSON.parse(value);
    }

    return value && typeof value.toString === 'function' ?
      value.toString() : value;
  };

  this.toWireFormat = function(value) {
    return this.isJsonValue ? JSON.stringify(value) : value;
  };
}

function FloatShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  };
  this.toWireFormat = this.toType;
}

function IntegerShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseInt(value, 10);
  };
  this.toWireFormat = this.toType;
}

function BinaryShape() {
  Shape.apply(this, arguments);
  this.toType = util.base64.decode;
  this.toWireFormat = util.base64.encode;
}

function Base64Shape() {
  BinaryShape.apply(this, arguments);
}

function BooleanShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return null;
    return value === 'true';
  };
}

/**
 * @api private
 */
Shape.shapes = {
  StructureShape: StructureShape,
  ListShape: ListShape,
  MapShape: MapShape,
  StringShape: StringShape,
  BooleanShape: BooleanShape,
  Base64Shape: Base64Shape
};

module.exports = Shape;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sts'] = {};
AWS.STS = Service.defineService('sts', ['2011-06-15']);
__webpack_require__(1021);
Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
  get: function get() {
    var model = __webpack_require__(914);
    model.paginators = __webpack_require__(915).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.STS;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(361);

var util = __webpack_require__(28);

function property(obj, name, value) {
  if (value !== null && value !== undefined) {
    util.property.apply(this, arguments);
  }
}

function memoizedProperty(obj, name) {
  if (!obj.constructor.prototype[name]) {
    util.memoizedProperty.apply(this, arguments);
  }
}

function Shape(shape, options, memberName) {
  options = options || {};

  property(this, 'shape', shape.shape);
  property(this, 'api', options.api, false);
  property(this, 'type', shape.type);
  property(this, 'enum', shape.enum);
  property(this, 'min', shape.min);
  property(this, 'max', shape.max);
  property(this, 'pattern', shape.pattern);
  property(this, 'location', shape.location || this.location || 'body');
  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
    shape.locationName || memberName);
  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
  property(this, 'isComposite', shape.isComposite || false);
  property(this, 'isShape', true, false);
  property(this, 'isQueryName', Boolean(shape.queryName), false);
  property(this, 'isLocationName', Boolean(shape.locationName), false);
  property(this, 'isIdempotent', shape.idempotencyToken === true);
  property(this, 'isJsonValue', shape.jsonvalue === true);

  if (options.documentation) {
    property(this, 'documentation', shape.documentation);
    property(this, 'documentationUrl', shape.documentationUrl);
  }

  if (shape.xmlAttribute) {
    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
  }

  // type conversion and parsing
  property(this, 'defaultValue', null);
  this.toWireFormat = function(value) {
    if (value === null || value === undefined) return '';
    return value;
  };
  this.toType = function(value) { return value; };
}

/**
 * @api private
 */
Shape.normalizedTypes = {
  character: 'string',
  double: 'float',
  long: 'integer',
  short: 'integer',
  biginteger: 'integer',
  bigdecimal: 'float',
  blob: 'binary'
};

/**
 * @api private
 */
Shape.types = {
  'structure': StructureShape,
  'list': ListShape,
  'map': MapShape,
  'boolean': BooleanShape,
  'timestamp': TimestampShape,
  'float': FloatShape,
  'integer': IntegerShape,
  'string': StringShape,
  'base64': Base64Shape,
  'binary': BinaryShape
};

Shape.resolve = function resolve(shape, options) {
  if (shape.shape) {
    var refShape = options.api.shapes[shape.shape];
    if (!refShape) {
      throw new Error('Cannot find shape reference: ' + shape.shape);
    }

    return refShape;
  } else {
    return null;
  }
};

Shape.create = function create(shape, options, memberName) {
  if (shape.isShape) return shape;

  var refShape = Shape.resolve(shape, options);
  if (refShape) {
    var filteredKeys = Object.keys(shape);
    if (!options.documentation) {
      filteredKeys = filteredKeys.filter(function(name) {
        return !name.match(/documentation/);
      });
    }

    // create an inline shape with extra members
    var InlineShape = function() {
      refShape.constructor.call(this, shape, options, memberName);
    };
    InlineShape.prototype = refShape;
    return new InlineShape();
  } else {
    // set type if not set
    if (!shape.type) {
      if (shape.members) shape.type = 'structure';
      else if (shape.member) shape.type = 'list';
      else if (shape.key) shape.type = 'map';
      else shape.type = 'string';
    }

    // normalize types
    var origType = shape.type;
    if (Shape.normalizedTypes[shape.type]) {
      shape.type = Shape.normalizedTypes[shape.type];
    }

    if (Shape.types[shape.type]) {
      return new Shape.types[shape.type](shape, options, memberName);
    } else {
      throw new Error('Unrecognized shape type: ' + origType);
    }
  }
};

function CompositeShape(shape) {
  Shape.apply(this, arguments);
  property(this, 'isComposite', true);

  if (shape.flattened) {
    property(this, 'flattened', shape.flattened || false);
  }
}

function StructureShape(shape, options) {
  var requiredMap = null, firstInit = !this.isShape;

  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'members', {});
    property(this, 'memberNames', []);
    property(this, 'required', []);
    property(this, 'isRequired', function() { return false; });
  }

  if (shape.members) {
    property(this, 'members', new Collection(shape.members, options, function(name, member) {
      return Shape.create(member, options, name);
    }));
    memoizedProperty(this, 'memberNames', function() {
      return shape.xmlOrder || Object.keys(shape.members);
    });
  }

  if (shape.required) {
    property(this, 'required', shape.required);
    property(this, 'isRequired', function(name) {
      if (!requiredMap) {
        requiredMap = {};
        for (var i = 0; i < shape.required.length; i++) {
          requiredMap[shape.required[i]] = true;
        }
      }

      return requiredMap[name];
    }, false, true);
  }

  property(this, 'resultWrapper', shape.resultWrapper || null);

  if (shape.payload) {
    property(this, 'payload', shape.payload);
  }

  if (typeof shape.xmlNamespace === 'string') {
    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
  } else if (typeof shape.xmlNamespace === 'object') {
    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
  }
}

function ListShape(shape, options) {
  var self = this, firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return []; });
  }

  if (shape.member) {
    memoizedProperty(this, 'member', function() {
      return Shape.create(shape.member, options);
    });
  }

  if (this.flattened) {
    var oldName = this.name;
    memoizedProperty(this, 'name', function() {
      return self.member.name || oldName;
    });
  }
}

function MapShape(shape, options) {
  var firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'key', Shape.create({type: 'string'}, options));
    property(this, 'value', Shape.create({type: 'string'}, options));
  }

  if (shape.key) {
    memoizedProperty(this, 'key', function() {
      return Shape.create(shape.key, options);
    });
  }
  if (shape.value) {
    memoizedProperty(this, 'value', function() {
      return Shape.create(shape.value, options);
    });
  }
}

function TimestampShape(shape) {
  var self = this;
  Shape.apply(this, arguments);

  if (this.location === 'header') {
    property(this, 'timestampFormat', 'rfc822');
  } else if (shape.timestampFormat) {
    property(this, 'timestampFormat', shape.timestampFormat);
  } else if (!this.timestampFormat && this.api) {
    if (this.api.timestampFormat) {
      property(this, 'timestampFormat', this.api.timestampFormat);
    } else {
      switch (this.api.protocol) {
        case 'json':
        case 'rest-json':
          property(this, 'timestampFormat', 'unixTimestamp');
          break;
        case 'rest-xml':
        case 'query':
        case 'ec2':
          property(this, 'timestampFormat', 'iso8601');
          break;
      }
    }
  }

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    if (typeof value.toUTCString === 'function') return value;
    return typeof value === 'string' || typeof value === 'number' ?
           util.date.parseTimestamp(value) : null;
  };

  this.toWireFormat = function(value) {
    return util.date.format(value, self.timestampFormat);
  };
}

function StringShape() {
  Shape.apply(this, arguments);

  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
  this.toType = function(value) {
    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
      value || '' : value;
    if (this.isJsonValue) {
      return JSON.parse(value);
    }

    return value && typeof value.toString === 'function' ?
      value.toString() : value;
  };

  this.toWireFormat = function(value) {
    return this.isJsonValue ? JSON.stringify(value) : value;
  };
}

function FloatShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  };
  this.toWireFormat = this.toType;
}

function IntegerShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseInt(value, 10);
  };
  this.toWireFormat = this.toType;
}

function BinaryShape() {
  Shape.apply(this, arguments);
  this.toType = util.base64.decode;
  this.toWireFormat = util.base64.encode;
}

function Base64Shape() {
  BinaryShape.apply(this, arguments);
}

function BooleanShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return null;
    return value === 'true';
  };
}

/**
 * @api private
 */
Shape.shapes = {
  StructureShape: StructureShape,
  ListShape: ListShape,
  MapShape: MapShape,
  StringShape: StringShape,
  BooleanShape: BooleanShape,
  Base64Shape: Base64Shape
};

module.exports = Shape;


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http_js__ = __webpack_require__(18);





var Graph = function () {
  function Graph() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Graph);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Graph, [{
    key: 'flowLog',
    value: function flowLog(args) {
      var logType = 'getFlowLog';
      var params = {
        dataId: args.dataId,
        properties: args.properties,
        period: args.period,
        from: args.from,
        to: args.to,
        sort: args.sort,
        timezone: args.timezone,
        fill: false, // データが空の場合、直前のデータで埋めるかどうか
        fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
        firstDayOfWeek: args.firstDayOfWeek
      };
      return this._request(logType, params);
    }
  }, {
    key: 'roRateLog',
    value: function roRateLog(args) {
      var logType = 'getRoRateLog';
      var params = {
        dataId: args.dataId,
        period: args.period,
        from: args.from,
        to: args.to,
        sort: args.sort,
        timezone: args.timezone,
        fill: false, // データが空の場合、直前のデータで埋めるかどうか
        fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
        firstDayOfWeek: args.firstDayOfWeek
      };
      return this._request(logType, params);
    }
  }, {
    key: 'leakageLog',
    value: function leakageLog(args) {
      var logType = 'getLeakageLog';
      var params = {
        dataId: args.dataId,
        from: args.from,
        to: args.to,
        sort: args.sort,
        timezone: args.timezone,
        fill: false, // データが空の場合、直前のデータで埋めるかどうか
        fillOutOfRange: true // from、toの範囲外のデータを埋めるかどうか
      };
      return this._request(logType, params);
    }
  }, {
    key: 'waterPressureLog',
    value: function waterPressureLog(args) {
      var logType = 'getWaterPressureLog';
      var params = {
        dataId: args.dataId,
        properties: args.properties,
        period: args.period,
        from: args.from,
        to: args.to,
        sort: args.sort,
        timezone: args.timezone,
        fill: false, // データが空の場合、直前のデータで埋めるかどうか
        fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
        firstDayOfWeek: args.firstDayOfWeek
      };
      return this._request(logType, params);
    }
  }, {
    key: 'temperatureLog',
    value: function temperatureLog(args) {
      var logType = 'getTemperatureLog';
      var params = {
        dataId: args.dataId,
        properties: args.properties,
        period: args.period,
        from: args.from,
        to: args.to,
        sort: args.sort,
        timezone: args.timezone,
        fill: false, // データが空の場合、直前のデータで埋めるかどうか
        fillOutOfRange: true, // from、toの範囲外のデータを埋めるかどうか
        firstDayOfWeek: args.firstDayOfWeek
      };
      return this._request(logType, params);
    }
  }, {
    key: '_request',
    value: function _request(logType, args) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/graphs/' + logType, args).then(function (response) {
          if (response.data.result === 0) {
            resolve(response.data.data);
          } else {
            reject(response.data.result);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }]);

  return Graph;
}();

/* harmony default export */ __webpack_exports__["a"] = (Graph);

/***/ }),
/* 131 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(165);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(397);
var enumBugKeys = __webpack_require__(231);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(55);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(55);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var SymbolClz = __webpack_require__(187);

/**
 * @module echarts/chart/helper/SymbolDraw
 */

/**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */
function SymbolDraw(symbolCtor) {
  this.group = new graphic.Group();
  this._symbolCtor = symbolCtor || SymbolClz;
}

var symbolDrawProto = SymbolDraw.prototype;

function symbolNeedsDraw(data, idx, isIgnore) {
  var point = data.getItemLayout(idx); // Is an object
  // if (point && point.hasOwnProperty('point')) {
  //     point = point.point;
  // }

  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(isIgnore && isIgnore(idx)) && data.getItemVisual(idx, 'symbol') !== 'none';
}
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Array.<boolean>} [isIgnore]
 */


symbolDrawProto.updateData = function (data, isIgnore) {
  var group = this.group;
  var seriesModel = data.hostModel;
  var oldData = this._data;
  var SymbolCtor = this._symbolCtor;
  var seriesScope = {
    itemStyle: seriesModel.getModel('itemStyle.normal').getItemStyle(['color']),
    hoverItemStyle: seriesModel.getModel('itemStyle.emphasis').getItemStyle(),
    symbolRotate: seriesModel.get('symbolRotate'),
    symbolOffset: seriesModel.get('symbolOffset'),
    hoverAnimation: seriesModel.get('hoverAnimation'),
    labelModel: seriesModel.getModel('label.normal'),
    hoverLabelModel: seriesModel.getModel('label.emphasis'),
    cursorStyle: seriesModel.get('cursor')
  };
  data.diff(oldData).add(function (newIdx) {
    var point = data.getItemLayout(newIdx);

    if (symbolNeedsDraw(data, newIdx, isIgnore)) {
      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
      symbolEl.attr('position', point);
      data.setItemGraphicEl(newIdx, symbolEl);
      group.add(symbolEl);
    }
  }).update(function (newIdx, oldIdx) {
    var symbolEl = oldData.getItemGraphicEl(oldIdx);
    var point = data.getItemLayout(newIdx);

    if (!symbolNeedsDraw(data, newIdx, isIgnore)) {
      group.remove(symbolEl);
      return;
    }

    if (!symbolEl) {
      symbolEl = new SymbolCtor(data, newIdx);
      symbolEl.attr('position', point);
    } else {
      symbolEl.updateData(data, newIdx, seriesScope);
      graphic.updateProps(symbolEl, {
        position: point
      }, seriesModel);
    } // Add back


    group.add(symbolEl);
    data.setItemGraphicEl(newIdx, symbolEl);
  }).remove(function (oldIdx) {
    var el = oldData.getItemGraphicEl(oldIdx);
    el && el.fadeOut(function () {
      group.remove(el);
    });
  }).execute();
  this._data = data;
};

symbolDrawProto.updateLayout = function () {
  var data = this._data;

  if (data) {
    // Not use animation
    data.eachItemGraphicEl(function (el, idx) {
      var point = data.getItemLayout(idx);
      el.attr('position', point);
    });
  }
};

symbolDrawProto.remove = function (enableAnimation) {
  var group = this.group;
  var data = this._data;

  if (data) {
    if (enableAnimation) {
      data.eachItemGraphicEl(function (el) {
        el.fadeOut(function () {
          group.remove(el);
        });
      });
    } else {
      group.removeAll();
    }
  }
};

var _default = SymbolDraw;
module.exports = _default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function retrieveTargetInfo(payload, seriesModel) {
  if (payload && (payload.type === 'treemapZoomToNode' || payload.type === 'treemapRootToNode')) {
    var root = seriesModel.getData().tree.root;
    var targetNode = payload.targetNode;

    if (targetNode && root.contains(targetNode)) {
      return {
        node: targetNode
      };
    }

    var targetNodeId = payload.targetNodeId;

    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
      return {
        node: targetNode
      };
    }
  }
} // Not includes the given node at the last item.


function getPathToRoot(node) {
  var path = [];

  while (node) {
    node = node.parentNode;
    node && path.push(node);
  }

  return path.reverse();
}

function aboveViewRoot(viewRoot, node) {
  var viewPath = getPathToRoot(viewRoot);
  return zrUtil.indexOf(viewPath, node) >= 0;
} // From root to the input node (the input node will be included).


function wrapTreePathInfo(node, seriesModel) {
  var treePathInfo = [];

  while (node) {
    var nodeDataIndex = node.dataIndex;
    treePathInfo.push({
      name: node.name,
      dataIndex: nodeDataIndex,
      value: seriesModel.getRawValue(nodeDataIndex)
    });
    node = node.parentNode;
  }

  treePathInfo.reverse();
  return treePathInfo;
}

exports.retrieveTargetInfo = retrieveTargetInfo;
exports.getPathToRoot = getPathToRoot;
exports.aboveViewRoot = aboveViewRoot;
exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var axisPointerModelHelper = __webpack_require__(189);

var axisTrigger = __webpack_require__(1489);

__webpack_require__(1485);

__webpack_require__(1486);

__webpack_require__(455);

// CartesianAxisPointer is not supposed to be required here. But consider
// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
echarts.registerPreprocessor(function (option) {
  // Always has a global axisPointerModel for default setting.
  if (option) {
    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
    // is not set, remain null/undefined, otherwise it will
    // override existent link setting.

    if (link && !zrUtil.isArray(link)) {
      option.axisPointer.link = [link];
    }
  }
}); // This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
  // allAxesInfo should be updated when setOption performed.
  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
}); // Broadcast to all views.

echarts.registerAction({
  type: 'updateAxisPointer',
  event: 'updateAxisPointer',
  update: ':updateAxisPointer'
}, axisTrigger);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var modelUtil = __webpack_require__(15);

var helper = __webpack_require__(274);

var AxisProxy = __webpack_require__(1500);

var each = zrUtil.each;
var eachAxisDim = helper.eachAxisDim;
var DataZoomModel = echarts.extendComponentModel({
  type: 'dataZoom',
  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],

  /**
   * @protected
   */
  defaultOption: {
    zlevel: 0,
    z: 4,
    // Higher than normal component (z: 2).
    orient: null,
    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
    xAxisIndex: null,
    // Default the first horizontal category axis.
    yAxisIndex: null,
    // Default the first vertical category axis.
    filterMode: 'filter',
    // Possible values: 'filter' or 'empty' or 'weakFilter'.
    // 'filter': data items which are out of window will be removed. This option is
    //          applicable when filtering outliers. For each data item, it will be
    //          filtered if one of the relevant dimensions is out of the window.
    // 'weakFilter': data items which are out of window will be removed. This option
    //          is applicable when filtering outliers. For each data item, it will be
    //          filtered only if all  of the relevant dimensions are out of the same
    //          side of the window.
    // 'empty': data items which are out of window will be set to empty.
    //          This option is applicable when user should not neglect
    //          that there are some data items out of window.
    // 'none': Do not filter.
    // Taking line chart as an example, line will be broken in
    // the filtered points when filterModel is set to 'empty', but
    // be connected when set to 'filter'.
    throttle: null,
    // Dispatch action by the fixed rate, avoid frequency.
    // default 100. Do not throttle when use null/undefined.
    // If animation === true and animationDurationUpdate > 0,
    // default value is 100, otherwise 20.
    start: 0,
    // Start percent. 0 ~ 100
    end: 100,
    // End percent. 0 ~ 100
    startValue: null,
    // Start value. If startValue specified, start is ignored.
    endValue: null,
    // End value. If endValue specified, end is ignored.
    minSpan: null,
    // 0 ~ 100
    maxSpan: null,
    // 0 ~ 100
    minValueSpan: null,
    // The range of dataZoom can not be smaller than that.
    maxValueSpan: null,
    // The range of dataZoom can not be larger than that.
    rangeMode: null // Array, can be 'value' or 'percent'.

  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel) {
    /**
     * key like x_0, y_1
     * @private
     * @type {Object}
     */
    this._dataIntervalByAxis = {};
    /**
     * @private
     */

    this._dataInfo = {};
    /**
     * key like x_0, y_1
     * @private
     */

    this._axisProxies = {};
    /**
     * @readOnly
     */

    this.textStyleModel;
    /**
     * @private
     */

    this._autoThrottle = true;
    /**
     * 'percent' or 'value'
     * @private
     */

    this._rangePropMode = ['percent', 'percent'];
    var rawOption = retrieveRaw(option);
    this.mergeDefaultAndTheme(option, ecModel);
    this.doInit(rawOption);
  },

  /**
   * @override
   */
  mergeOption: function (newOption) {
    var rawOption = retrieveRaw(newOption); //FIX #2591

    zrUtil.merge(this.option, newOption, true);
    this.doInit(rawOption);
  },

  /**
   * @protected
   */
  doInit: function (rawOption) {
    var thisOption = this.option; // Disable realtime view update if canvas is not supported.

    if (!env.canvasSupported) {
      thisOption.realtime = false;
    }

    this._setDefaultThrottle(rawOption);

    updateRangeUse(this, rawOption);
    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      // start/end has higher priority over startValue/endValue if they
      // both set, but we should make chart.setOption({endValue: 1000})
      // effective, rather than chart.setOption({endValue: 1000, end: null}).
      if (this._rangePropMode[index] === 'value') {
        thisOption[names[0]] = null;
      } // Otherwise do nothing and use the merge result.

    }, this);
    this.textStyleModel = this.getModel('textStyle');

    this._resetTarget();

    this._giveAxisProxies();
  },

  /**
   * @private
   */
  _giveAxisProxies: function () {
    var axisProxies = this._axisProxies;
    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.

      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
      // dispose __dzAxisProxy

      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
    }, this);
  },

  /**
   * @private
   */
  _resetTarget: function () {
    var thisOption = this.option;

    var autoMode = this._judgeAutoMode();

    eachAxisDim(function (dimNames) {
      var axisIndexName = dimNames.axisIndex;
      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
    }, this);

    if (autoMode === 'axisIndex') {
      this._autoSetAxisIndex();
    } else if (autoMode === 'orient') {
      this._autoSetOrient();
    }
  },

  /**
   * @private
   */
  _judgeAutoMode: function () {
    // Auto set only works for setOption at the first time.
    // The following is user's reponsibility. So using merged
    // option is OK.
    var thisOption = this.option;
    var hasIndexSpecified = false;
    eachAxisDim(function (dimNames) {
      // When user set axisIndex as a empty array, we think that user specify axisIndex
      // but do not want use auto mode. Because empty array may be encountered when
      // some error occured.
      if (thisOption[dimNames.axisIndex] != null) {
        hasIndexSpecified = true;
      }
    }, this);
    var orient = thisOption.orient;

    if (orient == null && hasIndexSpecified) {
      return 'orient';
    } else if (!hasIndexSpecified) {
      if (orient == null) {
        thisOption.orient = 'horizontal';
      }

      return 'axisIndex';
    }
  },

  /**
   * @private
   */
  _autoSetAxisIndex: function () {
    var autoAxisIndex = true;
    var orient = this.get('orient', true);
    var thisOption = this.option;
    var dependentModels = this.dependentModels;

    if (autoAxisIndex) {
      // Find axis that parallel to dataZoom as default.
      var dimName = orient === 'vertical' ? 'y' : 'x';

      if (dependentModels[dimName + 'Axis'].length) {
        thisOption[dimName + 'AxisIndex'] = [0];
        autoAxisIndex = false;
      } else {
        each(dependentModels.singleAxis, function (singleAxisModel) {
          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
            autoAxisIndex = false;
          }
        });
      }
    }

    if (autoAxisIndex) {
      // Find the first category axis as default. (consider polar)
      eachAxisDim(function (dimNames) {
        if (!autoAxisIndex) {
          return;
        }

        var axisIndices = [];
        var axisModels = this.dependentModels[dimNames.axis];

        if (axisModels.length && !axisIndices.length) {
          for (var i = 0, len = axisModels.length; i < len; i++) {
            if (axisModels[i].get('type') === 'category') {
              axisIndices.push(i);
            }
          }
        }

        thisOption[dimNames.axisIndex] = axisIndices;

        if (axisIndices.length) {
          autoAxisIndex = false;
        }
      }, this);
    }

    if (autoAxisIndex) {
      // FIXME
      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
      // dataZoom component auto adopts series that reference to
      // both xAxis and yAxis which type is 'value'.
      this.ecModel.eachSeries(function (seriesModel) {
        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
          eachAxisDim(function (dimNames) {
            var axisIndices = thisOption[dimNames.axisIndex];
            var axisIndex = seriesModel.get(dimNames.axisIndex);
            var axisId = seriesModel.get(dimNames.axisId);
            var axisModel = seriesModel.ecModel.queryComponents({
              mainType: dimNames.axis,
              index: axisIndex,
              id: axisId
            })[0];
            axisIndex = axisModel.componentIndex;

            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
              axisIndices.push(axisIndex);
            }
          });
        }
      }, this);
    }
  },

  /**
   * @private
   */
  _autoSetOrient: function () {
    var dim; // Find the first axis

    this.eachTargetAxis(function (dimNames) {
      !dim && (dim = dimNames.name);
    }, this);
    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
  },

  /**
   * @private
   */
  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
    // FIXME
    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
    // 例如series.type === scatter时。
    var is = true;
    eachAxisDim(function (dimNames) {
      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];

      if (!axisModel || axisModel.get('type') !== axisType) {
        is = false;
      }
    }, this);
    return is;
  },

  /**
   * @private
   */
  _setDefaultThrottle: function (rawOption) {
    // When first time user set throttle, auto throttle ends.
    if (rawOption.hasOwnProperty('throttle')) {
      this._autoThrottle = false;
    }

    if (this._autoThrottle) {
      var globalOption = this.ecModel.option;
      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
    }
  },

  /**
   * @public
   */
  getFirstTargetAxisModel: function () {
    var firstAxisModel;
    eachAxisDim(function (dimNames) {
      if (firstAxisModel == null) {
        var indices = this.get(dimNames.axisIndex);

        if (indices.length) {
          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
        }
      }
    }, this);
    return firstAxisModel;
  },

  /**
   * @public
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */
  eachTargetAxis: function (callback, context) {
    var ecModel = this.ecModel;
    eachAxisDim(function (dimNames) {
      each(this.get(dimNames.axisIndex), function (axisIndex) {
        callback.call(context, dimNames, axisIndex, this, ecModel);
      }, this);
    }, this);
  },

  /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
   */
  getAxisProxy: function (dimName, axisIndex) {
    return this._axisProxies[dimName + '_' + axisIndex];
  },

  /**
   * @param {string} dimName
   * @param {number} axisIndex
   * @return {module:echarts/model/Model} If not found, return null/undefined.
   */
  getAxisModel: function (dimName, axisIndex) {
    var axisProxy = this.getAxisProxy(dimName, axisIndex);
    return axisProxy && axisProxy.getAxisModel();
  },

  /**
   * If not specified, set to undefined.
   *
   * @public
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   * @param {boolean} [ignoreUpdateRangeUsg=false]
   */
  setRawRange: function (opt, ignoreUpdateRangeUsg) {
    var option = this.option;
    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
      // If only one of 'start' and 'startValue' is not null/undefined, the other
      // should be cleared, which enable clear the option.
      // If both of them are not set, keep option with the original value, which
      // enable use only set start but not set end when calling `dispatchAction`.
      // The same as 'end' and 'endValue'.
      if (opt[names[0]] != null || opt[names[1]] != null) {
        option[names[0]] = opt[names[0]];
        option[names[1]] = opt[names[1]];
      }
    }, this);
    !ignoreUpdateRangeUsg && updateRangeUse(this, opt);
  },

  /**
   * @public
   * @return {Array.<number>} [startPercent, endPercent]
   */
  getPercentRange: function () {
    var axisProxy = this.findRepresentativeAxisProxy();

    if (axisProxy) {
      return axisProxy.getDataPercentWindow();
    }
  },

  /**
   * @public
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @param {string} [axisDimName]
   * @param {number} [axisIndex]
   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
   */
  getValueRange: function (axisDimName, axisIndex) {
    if (axisDimName == null && axisIndex == null) {
      var axisProxy = this.findRepresentativeAxisProxy();

      if (axisProxy) {
        return axisProxy.getDataValueWindow();
      }
    } else {
      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
    }
  },

  /**
   * @public
   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
   *      corresponding to the axisModel
   * @return {module:echarts/component/dataZoom/AxisProxy}
   */
  findRepresentativeAxisProxy: function (axisModel) {
    if (axisModel) {
      return axisModel.__dzAxisProxy;
    } // Find the first hosted axisProxy


    var axisProxies = this._axisProxies;

    for (var key in axisProxies) {
      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
        return axisProxies[key];
      }
    } // If no hosted axis find not hosted axisProxy.
    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
    // and the option.start or option.end settings are different. The percentRange
    // should follow axisProxy.
    // (We encounter this problem in toolbox data zoom.)


    for (var key in axisProxies) {
      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
        return axisProxies[key];
      }
    }
  },

  /**
   * @return {Array.<string>}
   */
  getRangePropMode: function () {
    return this._rangePropMode.slice();
  }
});

function retrieveRaw(option) {
  var ret = {};
  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
    option.hasOwnProperty(name) && (ret[name] = option[name]);
  });
  return ret;
}

function updateRangeUse(dataZoomModel, rawOption) {
  var rangePropMode = dataZoomModel._rangePropMode;
  var rangeModeInOption = dataZoomModel.get('rangeMode');
  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
    var percentSpecified = rawOption[names[0]] != null;
    var valueSpecified = rawOption[names[1]] != null;

    if (percentSpecified && !valueSpecified) {
      rangePropMode[index] = 'percent';
    } else if (!percentSpecified && valueSpecified) {
      rangePropMode[index] = 'value';
    } else if (rangeModeInOption) {
      rangePropMode[index] = rangeModeInOption[index];
    } else if (percentSpecified) {
      // percentSpecified && valueSpecified
      rangePropMode[index] = 'percent';
    } // else remain its original setting.

  });
}

var _default = DataZoomModel;
module.exports = _default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var ComponentView = __webpack_require__(286);

var _default = ComponentView.extend({
  type: 'dataZoom',
  render: function (dataZoomModel, ecModel, api, payload) {
    this.dataZoomModel = dataZoomModel;
    this.ecModel = ecModel;
    this.api = api;
  },

  /**
   * Find the first target coordinate system.
   *
   * @protected
   * @return {Object} {
   *                   grid: [
   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
   *                       ...
   *                   ],  // cartesians must not be null/undefined.
   *                   polar: [
   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
   *                       ...
   *                   ],  // polars must not be null/undefined.
   *                   singleAxis: [
   *                       {model: coord0, axisModels: [], coordIndex: 0}
   *                   ]
   */
  getTargetCoordInfo: function () {
    var dataZoomModel = this.dataZoomModel;
    var ecModel = this.ecModel;
    var coordSysLists = {};
    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);

      if (axisModel) {
        var coordModel = axisModel.getCoordSysModel();
        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
      }
    }, this);

    function save(coordModel, axisModel, store, coordIndex) {
      var item;

      for (var i = 0; i < store.length; i++) {
        if (store[i].model === coordModel) {
          item = store[i];
          break;
        }
      }

      if (!item) {
        store.push(item = {
          model: coordModel,
          axisModels: [],
          coordIndex: coordIndex
        });
      }

      item.axisModels.push(axisModel);
    }

    return coordSysLists;
  }
});

module.exports = _default;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

__webpack_require__(281);

__webpack_require__(1478);

// Grid view
echarts.extendComponentView({
  type: 'grid',
  render: function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new graphic.Rect({
        shape: gridModel.coordinateSystem.getRect(),
        style: zrUtil.defaults({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  }
});
echarts.registerPreprocessor(function (option) {
  // Only create grid when need
  if (option.xAxis && option.yAxis && !option.grid) {
    option.grid = {};
  }
});

/***/ }),
/* 145 */
/***/ (function(module, exports) {

/**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param {number} delta Move length.
 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param {Array.<number>} extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds,
 *              where the input minSpan and maxSpan will not work.
 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
 * @return {Array.<number>} The input handleEnds.
 */
function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
  // Normalize firstly.
  handleEnds[0] = restrict(handleEnds[0], extent);
  handleEnds[1] = restrict(handleEnds[1], extent);
  delta = delta || 0;
  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.

  if (minSpan != null) {
    minSpan = restrict(minSpan, [0, extentSpan]);
  }

  if (maxSpan != null) {
    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
  }

  if (handleIndex === 'all') {
    minSpan = maxSpan = Math.abs(handleEnds[1] - handleEnds[0]);
    handleIndex = 0;
  }

  var originalDistSign = getSpanSign(handleEnds, handleIndex);
  handleEnds[handleIndex] += delta; // Restrict in extent.

  var extentMinSpan = minSpan || 0;
  var realExtent = extent.slice();
  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.

  var currDistSign = getSpanSign(handleEnds, handleIndex);

  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
    // If minSpan exists, 'cross' is forbinden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
  } // Shrink span.


  var currDistSign = getSpanSign(handleEnds, handleIndex);

  if (maxSpan != null && currDistSign.span > maxSpan) {
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
  }

  return handleEnds;
}

function getSpanSign(handleEnds, handleIndex) {
  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
  // is at left of handleEnds[1] for non-cross case.

  return {
    span: Math.abs(dist),
    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
  };
}

function restrict(value, extend) {
  return Math.min(extend[1], Math.max(extend[0], value));
}

module.exports = _default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(199),
    getRawTag = __webpack_require__(1710),
    objectToString = __webpack_require__(1735);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(205),
    isLength = __webpack_require__(296);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1674),
    baseKeys = __webpack_require__(499),
    isArrayLike = __webpack_require__(147);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(210);

var debugMode = _config.debugMode;

var log = function () {};

if (debugMode === 1) {
  log = function () {
    for (var k in arguments) {
      throw new Error(arguments[k]);
    }
  };
} else if (debugMode > 1) {
  log = function () {
    for (var k in arguments) {
      console.log(arguments[k]);
    }
  };
}

var _default = log;
module.exports = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(212);

var BoundingRect = __webpack_require__(26);

var zrUtil = __webpack_require__(0);

var imageHelper = __webpack_require__(322);

/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
function ZImage(opts) {
  Displayable.call(this, opts);
}

ZImage.prototype = {
  constructor: ZImage,
  type: 'image',
  brush: function (ctx, prevEl) {
    var style = this.style;
    var src = style.image; // Must bind each time

    style.bind(ctx, this, prevEl);
    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);

    if (!image || !imageHelper.isImageReady(image)) {
      return;
    } // 图片已经加载完成
    // if (image.nodeName.toUpperCase() == 'IMG') {
    //     if (!image.complete) {
    //         return;
    //     }
    // }
    // Else is canvas


    var x = style.x || 0;
    var y = style.y || 0;
    var width = style.width;
    var height = style.height;
    var aspect = image.width / image.height;

    if (width == null && height != null) {
      // Keep image/height ratio
      width = height * aspect;
    } else if (height == null && width != null) {
      height = width / aspect;
    } else if (width == null && height == null) {
      width = image.width;
      height = image.height;
    } // 设置transform


    this.setTransform(ctx);

    if (style.sWidth && style.sHeight) {
      var sx = style.sx || 0;
      var sy = style.sy || 0;
      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
      var sx = style.sx;
      var sy = style.sy;
      var sWidth = width - sx;
      var sHeight = height - sy;
      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else {
      ctx.drawImage(image, x, y, width, height);
    }

    this.restoreTransform(ctx); // Draw rect text

    if (style.text != null) {
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  getBoundingRect: function () {
    var style = this.style;

    if (!this._rect) {
      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
    }

    return this._rect;
  }
};
zrUtil.inherits(ZImage, Displayable);
var _default = ZImage;
module.exports = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(212);

var zrUtil = __webpack_require__(0);

var textContain = __webpack_require__(70);

var textHelper = __webpack_require__(214);

/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
var Text = function (opts) {
  // jshint ignore:line
  Displayable.call(this, opts);
};

Text.prototype = {
  constructor: Text,
  type: 'text',
  brush: function (ctx, prevEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.

    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
    var text = style.text; // Convert to string

    text != null && (text += ''); // Always bind style

    style.bind(ctx, this, prevEl);

    if (!textHelper.needDrawText(text, style)) {
      return;
    }

    this.setTransform(ctx);
    textHelper.renderText(this, ctx, text, style);
    this.restoreTransform(ctx);
  },
  getBoundingRect: function () {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);

    if (!this._rect) {
      var text = style.text;
      text != null ? text += '' : text = '';
      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.rich);
      rect.x += style.x || 0;
      rect.y += style.y || 0;

      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
        var w = style.textStrokeWidth;
        rect.x -= w / 2;
        rect.y -= w / 2;
        rect.width += w;
        rect.height += w;
      }

      this._rect = rect;
    }

    return this._rect;
  }
};
zrUtil.inherits(Text, Displayable);
var _default = Text;
module.exports = _default;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
var AWS = __webpack_require__(10);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sts'] = {};
AWS.STS = Service.defineService('sts', ['2011-06-15']);
__webpack_require__(746);
Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
  get: function get() {
    var model = __webpack_require__(725);
    model.paginators = __webpack_require__(726).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.STS;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(27);

// browser specific modules
util.crypto.lib = __webpack_require__(438);
util.Buffer = __webpack_require__(109).Buffer;
util.url = __webpack_require__(629);
util.querystring = __webpack_require__(300);
util.environment = 'js';

var AWS = __webpack_require__(10);
module.exports = AWS;

__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(731);
__webpack_require__(732);

// Load the DOMParser XML parser
AWS.XML.Parser = __webpack_require__(755);

// Load the XHR HttpClient
__webpack_require__(736);

if (typeof process === 'undefined') {
  process = {
    browser: true
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);

function populateMethod(req) {
  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}

function generateURI(endpointPath, operationPath, input, params) {
  var uri = [endpointPath, operationPath].join('/');
  uri = uri.replace(/\/+/g, '/');

  var queryString = {}, queryStringSet = false;
  util.each(input.members, function (name, member) {
    var paramValue = params[name];
    if (paramValue === null || paramValue === undefined) return;
    if (member.location === 'uri') {
      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
      uri = uri.replace(regex, function(_, plus) {
        var fn = plus ? util.uriEscapePath : util.uriEscape;
        return fn(String(paramValue));
      });
    } else if (member.location === 'querystring') {
      queryStringSet = true;

      if (member.type === 'list') {
        queryString[member.name] = paramValue.map(function(val) {
          return util.uriEscape(String(val));
        });
      } else if (member.type === 'map') {
        util.each(paramValue, function(key, value) {
          if (Array.isArray(value)) {
            queryString[key] = value.map(function(val) {
              return util.uriEscape(String(val));
            });
          } else {
            queryString[key] = util.uriEscape(String(value));
          }
        });
      } else {
        queryString[member.name] = util.uriEscape(String(paramValue));
      }
    }
  });

  if (queryStringSet) {
    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
    var parts = [];
    util.arrayEach(Object.keys(queryString).sort(), function(key) {
      if (!Array.isArray(queryString[key])) {
        queryString[key] = [queryString[key]];
      }
      for (var i = 0; i < queryString[key].length; i++) {
        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
      }
    });
    uri += parts.join('&');
  }

  return uri;
}

function populateURI(req) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
  req.httpRequest.path = uri;
}

function populateHeaders(req) {
  var operation = req.service.api.operations[req.operation];
  util.each(operation.input.members, function (name, member) {
    var value = req.params[name];
    if (value === null || value === undefined) return;

    if (member.location === 'headers' && member.type === 'map') {
      util.each(value, function(key, memberValue) {
        req.httpRequest.headers[member.name + key] = memberValue;
      });
    } else if (member.location === 'header') {
      value = member.toWireFormat(value).toString();
      if (member.isJsonValue) {
        value = util.base64.encode(value);
      }
      req.httpRequest.headers[member.name] = value;
    }
  });
}

function buildRequest(req) {
  populateMethod(req);
  populateURI(req);
  populateHeaders(req);
}

function extractError() {
}

function extractData(resp) {
  var req = resp.request;
  var data = {};
  var r = resp.httpResponse;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  // normalize headers names to lower-cased keys for matching
  var headers = {};
  util.each(r.headers, function (k, v) {
    headers[k.toLowerCase()] = v;
  });

  util.each(output.members, function(name, member) {
    var header = (member.name || name).toLowerCase();
    if (member.location === 'headers' && member.type === 'map') {
      data[name] = {};
      var location = member.isLocationName ? member.name : '';
      var pattern = new RegExp('^' + location + '(.+)', 'i');
      util.each(r.headers, function (k, v) {
        var result = k.match(pattern);
        if (result !== null) {
          data[name][result[1]] = v;
        }
      });
    } else if (member.location === 'header') {
      if (headers[header] !== undefined) {
        var value = member.isJsonValue ?
          util.base64.decode(headers[header]) :
          headers[header];
        data[name] = member.toType(value);
      }
    } else if (member.location === 'statusCode') {
      data[name] = parseInt(r.statusCode, 10);
    }
  });

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData,
  generateURI: generateURI
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);

function populateMethod(req) {
  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}

function generateURI(endpointPath, operationPath, input, params) {
  var uri = [endpointPath, operationPath].join('/');
  uri = uri.replace(/\/+/g, '/');

  var queryString = {}, queryStringSet = false;
  util.each(input.members, function (name, member) {
    var paramValue = params[name];
    if (paramValue === null || paramValue === undefined) return;
    if (member.location === 'uri') {
      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
      uri = uri.replace(regex, function(_, plus) {
        var fn = plus ? util.uriEscapePath : util.uriEscape;
        return fn(String(paramValue));
      });
    } else if (member.location === 'querystring') {
      queryStringSet = true;

      if (member.type === 'list') {
        queryString[member.name] = paramValue.map(function(val) {
          return util.uriEscape(String(val));
        });
      } else if (member.type === 'map') {
        util.each(paramValue, function(key, value) {
          if (Array.isArray(value)) {
            queryString[key] = value.map(function(val) {
              return util.uriEscape(String(val));
            });
          } else {
            queryString[key] = util.uriEscape(String(value));
          }
        });
      } else {
        queryString[member.name] = util.uriEscape(String(paramValue));
      }
    }
  });

  if (queryStringSet) {
    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
    var parts = [];
    util.arrayEach(Object.keys(queryString).sort(), function(key) {
      if (!Array.isArray(queryString[key])) {
        queryString[key] = [queryString[key]];
      }
      for (var i = 0; i < queryString[key].length; i++) {
        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
      }
    });
    uri += parts.join('&');
  }

  return uri;
}

function populateURI(req) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
  req.httpRequest.path = uri;
}

function populateHeaders(req) {
  var operation = req.service.api.operations[req.operation];
  util.each(operation.input.members, function (name, member) {
    var value = req.params[name];
    if (value === null || value === undefined) return;

    if (member.location === 'headers' && member.type === 'map') {
      util.each(value, function(key, memberValue) {
        req.httpRequest.headers[member.name + key] = memberValue;
      });
    } else if (member.location === 'header') {
      value = member.toWireFormat(value).toString();
      if (member.isJsonValue) {
        value = util.base64.encode(value);
      }
      req.httpRequest.headers[member.name] = value;
    }
  });
}

function buildRequest(req) {
  populateMethod(req);
  populateURI(req);
  populateHeaders(req);
}

function extractError() {
}

function extractData(resp) {
  var req = resp.request;
  var data = {};
  var r = resp.httpResponse;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  // normalize headers names to lower-cased keys for matching
  var headers = {};
  util.each(r.headers, function (k, v) {
    headers[k.toLowerCase()] = v;
  });

  util.each(output.members, function(name, member) {
    var header = (member.name || name).toLowerCase();
    if (member.location === 'headers' && member.type === 'map') {
      data[name] = {};
      var location = member.isLocationName ? member.name : '';
      var pattern = new RegExp('^' + location + '(.+)', 'i');
      util.each(r.headers, function (k, v) {
        var result = k.match(pattern);
        if (result !== null) {
          data[name][result[1]] = v;
        }
      });
    } else if (member.location === 'header') {
      if (headers[header] !== undefined) {
        var value = member.isJsonValue ?
          util.base64.decode(headers[header]) :
          headers[header];
        data[name] = member.toType(value);
      }
    } else if (member.location === 'statusCode') {
      data[name] = parseInt(r.statusCode, 10);
    }
  });

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData,
  generateURI: generateURI
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1031);

/***/ }),
/* 159 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  'params': {
    'label': 'English'
  },
  'service': {
    'flow-and-time': 'Qty of Water Flow & Time',
    'ro-membrane': 'RO Membrane Efficiency',
    'temperature': 'Temperature',
    'leakage': 'Leakage Detection',
    'pressure': 'Water Pressure',
    'co2': 'CO2 Gas'
  },
  'service-short': {
    'flow-and-time': 'WaterFlow&Time',
    'ro-membrane': 'RO',
    'temperature': 'Temperature',
    'leakage': 'Leakage',
    'pressure': 'Pressure',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Flow sensor',
    'tds': 'TDS sensor',
    'temperature': 'Temperature sensor',
    'leakage': 'Leakage sensor',
    'pressure': 'Pressure sensor'
  },
  'user-params': {
    username: 'Username',
    email: 'E-mail',
    password: 'Password',
    password_reinput: 'Password (reinput)',
    password_reinput_differs: 'Password and Password (reinput) are differ.',
    role: 'Role'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Staff'
  },
  'btn': {
    'add': 'Add',
    'edit': 'Edit',
    'cancel': 'Cancel',
    'update': 'Update',
    'save': 'save',
    'ok': 'OK',
    'delete': 'Delete',
    'resend': 'Resend'
  },
  'validate': {
    'phone-format': 'Please enter only digits',
    'phone-length': 'Phone number must be within 128 digits',
    'select': 'Please select',
    'vali-required': 'This field is required.'
  },
  cognitoError: {
    UserNotFoundException: 'Username is not found.',
    UsernameExistsException: 'User already exists.',
    UserNotConfirmedException: 'User is not confirmed.',
    NotAuthorizedException: 'Incorrect username or password.',
    LimitExceededException: 'Attempt limit exceeded, please try after some time.',
    CodeMismatchException: 'Invalid verification code provided, please try again.',
    InvalidParameterException: 'Invalid parameter is designated.',
    UnknownError: 'Detected unknown error at this service.'
  },
  signup: {
    signup: 'New User Registration',
    register: 'Register New User',
    btn_check_email: 'Please check e-mail',
    buy_iotizr: 'Buy IoTIZR',
    signupConfirmDialogText: 'Will you proceed?',
    signupSuccessDialogText: 'We received your new registration request. You will receive ' + 'confirmation e-mail from no-reply@harps4.com at email address designated. Please click URL ' + 'in the e-mail, then you will be registered correctly.',
    agreement_msg: 'By registering with Aplix, opening a HARPS account or using HARPS, ' + 'you agree and consent to:' + '<ul>' + '<li>the <a href="http://www.aplix.co.jp/en/legal/terms_harps.php">HARPS Terms of Service</a>' + '<li>the collection and use of personal information as set forth in the ' + '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php">Privacy Policy for IoT Solution</a>' + '<li>individualized mandatory binding arbitration for any disputes between us' + '<li>emails sent to you for account management purposes, and other purposes w/opt-out' + '</ul>'
  },
  'login': {
    'login': 'Login',
    'lost': 'Forgot your password?',
    'link_to_signup': 'Sign up',
    'vali-username-blank': 'Username is required.',
    'vali-password-blank': 'Password is required.',
    'next': 'Next',
    'incorrect': 'Incorrect username or password.'
  },
  'resetpassword': {
    'title': 'Reset Password',
    'detail': 'Please enter your Username',
    'entercode': 'Please enter verify code.',
    'newpassword': 'New Password',
    'codedetail': 'An email with a confirmation code has been sent from "no-reply@verificationemail.com" to your registered email address. Check your email and enter the confirmation code below.',
    'resendcode': 'Resend code',
    'vali-code-blank': 'Verification code is required.',
    'vali-pass-blank': 'New password is needed.',
    'vali-pass-number': 'Password must have at least number (0-9) and one letters (a-z).',
    'vali-pass-length': 'Password must be more than 7 characters.',
    'vali-pass-whitespace': 'Passwords containing spaces can not be set.',
    'confirm': 'Confirm'
  },
  activate: {
    title: 'Activate your account',
    detail: 'Check your email and enter the username and temporary password. And you need to change temporary passowrd. Please enter new password.',
    temp_password: 'Temporary Password',
    newpassword: 'New Password',
    passwordreinput: 'New Password (reinput)',
    agreement: 'Agreement',
    agreement_msg: 'This service is brought to you by Aplix Corporation. By using this ' + 'service, you agree and consent to the HARPS USERS Terms of Service ( ' + '<a href="http://www.aplix.co.jp/en/legal/terms_harpsusers.php" target="_blank">' + 'HARPS USERS Terms of Service</a>, ' + '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank">' + 'Privacy Policy for IoT Solurion</a> ) ' + 'and arbitration before the International Chamber of Commerce for any ' + 'disputes between us.',
    agree: 'I have read and agree with these terms.',
    you_need_to_agree: 'You need to agree',
    submit: 'Submit',
    complete: 'Activate Complete'
  },
  'global-menu': {
    'dashboard': 'Home',
    'watersystem': 'Monitoring',
    'customer': 'Location Management',
    'setting': 'Settings',
    'pc': 'PC Management'
  },
  'home': {
    'notification': 'Notification',
    'information': 'From {0}',
    'mail-notification-top': 'Email notification is now available.',
    'mail-notification-under': 'please confirm your settings in <a href=\'{0}\'>here</a>',
    'quick-link': 'Quick Link',
    'calendar': 'Maintenance Calendar',
    'quick-link-settings': 'Quick Link Settings',
    'notification-alert': 'Alert value reached',
    'notification-warning': 'Warning value reached'
  },
  'watersystem': {
    'column-nexttime': 'Next replacement expectancy',
    'customer-name': 'Location name',
    'customer': 'Location',
    'organization-name': 'Organization',
    'device-name': 'Device name',
    'device': 'Device',
    'deviceinfo': 'Device Information',
    'filter-life-left': 'Filter life left',
    'filter': 'Filter',
    'flow-rate': 'Flow Rate',
    'flow': 'Flow',
    'history': 'History',
    'list': 'List by',
    'mapinfo': 'Map',
    'name': 'Name',
    'period-month': 'months',
    'purification-amount': 'amount of water purification',
    'RoMembrane': 'RO Membrane Removal Efficiency',
    'RoMembrane-short': 'RO Removal Rate',
    'RoMembrane-good': 'Good',
    'RoMembrane-caution': 'Warning',
    'RoMembrane-alert': 'Alert',
    'Pressure': 'Pressure sensor',
    'Pressure-short': 'Pressure sensor',
    'Pressure-good': 'Good',
    'Pressure-caution': 'Warning',
    'Pressure-alert': 'Alert',
    'service': 'Service',
    'status': 'Status',
    'delete-water-system': 'Delete {0}.\nAll history will be lost.',
    'delete-water-system-with-iotizr': 'Registered IoTIZR will continue to communicate but will not be able to read the data.\nIf you want to stop communication from IoTIZR, please unplug the power of IoTIZR or delete from HARPS Toolkit.',
    'delete-water-system-ask': 'Do you really want to delete this?',
    'error-delete': 'Failed to delete.',
    'succeed-delete': 'Delete Sucessfully',
    'filter-reset': 'Filter Reset',
    'please-select': 'Please select a device.',
    'elapsed-time': 'Elapsed Time',
    'total-flow': 'Qty of Water Flow',
    'customer-info': 'Location Info',
    'rest-flow': 'Remaining water flow Qty',
    'filter-reset-title': 'Warning!',
    'filter-reset-text': 'Are you sure you want to reset the Filter?',
    'filter-reset-do': 'Reset',
    'filter-reset-cancel': 'Cancel',
    'threshold': 'Threshold',
    'notification-threshold': 'Notification Threshold',
    'about-flow-and-time': 'About flow rate and time threshold',
    'about-ro-membrane': 'About RO Membrane Efficiency threshold',
    'about-temperature': 'About Temperature threshold',
    'about-pressure': 'About Water Pressure threshold',
    'custom': 'Custom',
    'use-preset': 'Use presets',
    'flow-life': 'Flow Life',
    'time-life': 'Time Life',
    'alert': 'Alert',
    'warning': 'Warning',
    'use-flow': 'Flow sensor to use',
    'need-sensor': 'Required sensors',
    'about-flow-and-time-text': 'Measure the amount of water flow in the pipe hose within a certain time. We will send a notice by passage of time, increase of flow rate.',
    'about-ro-membrane-text': 'At the inlet / outlet 2 inlets / outlets of the RO membrane, install a probe of the TDS sensor to measure impurity content and calculate the impurity removal rate of the RO membrane. We will send you a notice due to reduced impurity removal rate.',
    'about-pressure-text': 'Measure the pressure value at the sensor installation location. As far as the number of ports of IoTIZR is concerned, it is possible to install multiple. Send notification beyond specified pressure.',
    'about-temperature-text': 'Measure the temperature of the sensor installation location. As far as the number of ports of IoTIZR is concerned, it is possible to install multiple. Send notification beyond specified temperature.',
    'about-setting-flow-and-time-text': 'Set the threshold at which warning / warning notice is issued for flow rate ([UNIT]) and time (month) respectively.',
    'about-setting-ro-membrane-text': 'Set caution value / warning value with impurity removal rate (%).',
    'about-setting-temperature-text': 'Set caution value / warning value with the temperature value.',
    'about-setting-pressure-text': 'Set caution value / warning value with the pressure value.',
    'about-threshold-setting': 'About threshold setting',
    'headline-press-alert': 'The pressure value is lower than the warning value.',
    'headline-press-warning': 'The pressure value is lower than the caution value.',
    'headline-press-normal': 'At present, all pressure values are normal.',
    'headline-diff-press-alert': 'The differential pressure value is beyond the warning value.',
    'headline-diff-press-warning': 'The differential pressure value is beyond the caution value.',
    'headline-temperature-up-alert': 'The temperature value is higher than alert value.',
    'headline-temperature-up-warning': 'The temperature value is higher than warning value.',
    'headline-temperature-down-alert': 'The temperature value is lower than alert value.',
    'headline-temperature-down-warning': 'The temperature value is lower than warning value.',
    'now-pressure': 'Current pressure value',
    'vali-threshold-must': 'Required fields',
    'vali-threshold-num': 'Please enter with numeric value',
    'vali-threshold-min': 'It is below the measurable temperature.',
    'vali-threshold-max': 'It is above the measurable temperature.',
    'vali-threshold-min-comm': 'Please enter {0} or more.',
    'vali-threshold-max-comm': 'Please enter {0} or less.',
    'vali-threshold-integer': 'Please enter with integer value',
    'vali-threshold-limit100': 'Please enter a number up to 100',
    'vali-threshold-positive-integer': 'Please enter a number greater than or equal to 0',
    'impurities-removal-rate': 'Impurity removal rate',
    'entrance-impurity-content': 'The inlet-side impurity content',
    'exit-impurity-content': 'Outlet impurity content',
    'time-elapsed': 'Time Elapsed',
    'pressure': 'Water Pressure',
    'setting-link-text1': 'Please edit "Notification threshold" of ',
    'setting-link-text2': 'settings',
    'setting-link-text3': ' to change',
    'vali-threshold-alert-less-than': 'Please enter a value smaller than the alert value',
    'vali-threshold-greater-than-warning': 'Please enter a number larger than the warning value',
    'vali-threshold-warning-less-than': 'Please enter a value smaller than the warning value',
    'vali-threshold-greater-than-alert': 'Please enter a number larger than the alert value',
    'last-update': 'Last Update',
    'past-pressure': 'Pressure value at {0}',
    'last-update-for-chart': 'Last Update',
    'last-update-week-suffix-for-chart': 'the week of {0}',
    'last-impurities-removal-late': 'Current Impurity removal rate',
    'past-impurities-removal-late': 'Impurity removal rate at {0}',
    'differential-pressure': 'Differential pressure value(s)',
    'about-differential-pressure-text': 'Measure the pressure value of two points and calculate the difference (absolute value) of the pressure value. Send notification by increasing differential pressure.',
    'about-setting-differential-pressure-text': 'Set caution/alert threshold values of differential pressure.',
    'differential-pressure-need-sensor': 'Two pressure sensors',
    'differential-pressure-value': 'Differential pressure value',
    'leakage-all-normal': 'There is no water leakage right now',
    'return-to-normal': 'Return to no leak',
    'leakage-alert': 'Water leak',
    'detection-history': 'Water leak history',
    'no-water-leak-history': 'There is no water leak history.',
    'headline-leakage-alert': 'We are sensing water. Please check the location.',
    'leakage-normal': 'No leak',
    'leakage': 'Leakage sensor',
    'leakage-short': 'Leakage sensor',
    'temperature-short': 'Temperature sensor',
    'temperature-alert': 'Alert',
    'temperature-warning': 'Warning',
    'temperature-normal': 'No problem',
    'temperature-min': 'or more',
    'temperature-max': 'or less',
    'temperature-increase': 'Notification when a value is above threshold',
    'temperature-decrease': 'Notification when a value is below threshold',
    'temperature-content': 'Temperature',
    'temperature-select-label': 'Notification rule',
    'now-temperature': 'Current temperature value',
    'past-temperature': 'Current temperature at {0}'
  },
  'chart': {
    'dataZoom-zoom': 'Zoom',
    'dataZoom-back': 'Zoom Reset',
    'change-period': 'change period',
    'button-reload': 'Reload',
    'graph-label-fromlastchange': 'Total water purification since the last filter change',
    'graph-label-diff': 'Water purification during the period',
    'graph-label-sum': 'Total water purification',
    '15m': '15 minute',
    '1h': '1 hour',
    '1d': '1 day',
    '1w': '1 week',
    '1M': '1 month',
    'auto-reload': 'Auto Reload',
    'label-date': 'Date',
    'label-time': 'Time',
    'button-date-jump': 'Jump',
    'button-date-recent': 'Recent',
    'button-ok': 'Ok',
    'button-cancel': 'Cancel',
    'message-oldest': 'It\'s being indicated from the oldest data because data of designated date and time can\'t be shown to the center.',
    'message-latest': 'The latest data is being indicated because data of designated date and time can\'t be shown to the center.',
    'message-outbounds-oldest': 'It\'s being indicated from the oldest data because data of designated date and time doesn\'t exist.',
    'message-outbounds-latest': 'The latest data is being indicated because data of designated date and time doesn\'t exist.',
    'message-no-data': 'There is no data.'
  },
  'csv-download': {
    'button-csv-download': 'CSV Download',
    'button-download': 'Download',
    'start-datetime': 'Start Date Time',
    'end-datetime': 'End Date Time',
    'failed-download-no-data': 'Can\'t downlaad because no data',
    'failed-create-zip-file-fatal': 'It couldn\'t be downloaded because a fatal error occurred.',
    'failed-create-zip-file-busy': 'Server is busy. Please try again later.',
    'invalid-start-end-datetime': 'Invalid date. Start date time later than End date time.'
  },
  /* 英語統一のため使用しない2019/01/17R.Inoue
  'csv-header': {
    'datetime': 'Date time',
    'organization-name': 'Organization name',
    'location-name': 'Location name',
    'device-name': 'Devoce name',
    'flow-log-status': 'Water purification status',
    'flow-log-flow': 'Total water purification({0})',
    'flow-log-flow-diff': 'Water purification during the period({0})',
    'ro-rate-log-status': 'Impurity removal status',
    'ro-rate-log-rate': 'Impurity removal rate(%)',
    'temperature-log-status': '{0}:Temperature Status',
    'temperature-log-temperature': '{0}:Temperature({1})',
    'leakage-log-status': '{0}:Water leak status',
    'water-pressure-log-status': '{0}:Pressure Status',
    'water-pressure-log-pressure': '{0}:Pressure value({1})'
  },
  */
  'user': {
    'unselected': 'Please select organization.',
    'nodata': 'there is no user.',
    'username': 'Username',
    'email': 'Email',
    'role': 'Role',
    'edit-setting': 'Edit setting'
  },
  'organizations': {
    'title': 'organizations list',
    'button-add': 'Add organization',
    'button-add-pc': 'Add P/C Accounts',
    'vali-create-limit': 'Subordinate organization can not be created because it is restricted',
    'limit-settings': 'Organization creation limit',
    'no-limit': 'Unlimited'
  },
  'device': {
    'name': 'device name',
    'vali-device-name': 'device name is required.'
  },
  'settings': {
    'title': 'Settings',
    'unit': 'Unit of water quantity',
    'timezone': 'Timezone',
    'timezone-location': 'Local Timezone',
    'pressureUnit': 'Unit of pressure',
    'temperatureUnit': 'Unit of temperature',
    'display-setting': 'Display Setting',
    'available-sensor': 'Sensors',
    'life-and-notification': 'Life of consumables and Notification',
    'notification-presets': 'Notification presets',
    'notification-mail': 'Notification mail',
    'organization-user': 'Organization and user',
    'management-organization': 'Organization Management',
    'user-management': 'User Management',
    'user-invitation': 'Add User',
    'add-organization': 'Add Organization',
    'pc-management': 'P/C Management',
    'set-up': 'Update'
  },
  'account': {
    'delete-organization': 'Delete Organization',
    'basic-information': 'Basic information',
    'organization': 'Organization name',
    'parent-organization': 'Parent organization',
    'description': 'Description',
    'tel': 'Telephone',
    'email': 'Email',
    'contact': 'Contact',
    'incharge': 'the person in charge',
    'administrator': 'administrator',
    'name': 'Name(optional)',
    'username': 'Incharge username',
    'useremail': 'Incharge email',
    'company': 'Company Name',
    'address': 'Address',
    'created': 'Registered Date',
    'edit': 'Edit',
    'caution-title': 'Caution!',
    'caution-org-remove-text': 'Are you sure you want to delete the organization below?',
    'caution-user-remove-text': 'Are you sure you want to delete the user below?',
    'caution-location-remove-text': 'Are you sure you want to delete the location below?',
    'delete': 'Delete',
    'cancel': 'Cancel',
    'close': 'Close',
    'create': 'Create',
    'updated': 'Updated',
    'error-delete': 'Deletion failure.',
    'error-customer': 'There are related Location(s) remaing.',
    'error-user': 'There are some users under this.',
    'error-root': 'This is root organization.',
    'error-system': 'There are related systems remaing.',
    'header-title': 'Organization and User Management',
    'header-org': 'Organization Management',
    'header-user': 'User Management',
    'header-invite': 'Add User',
    'header-pc': 'P/C Management',
    'invite-btn': 'Send invitation email',
    'policy': 'Policy Statement',
    'agree': 'Agree',
    'csv-import': 'We are planning the CSV Import function',
    'label-role': 'Role',
    'label-parent': 'Parent Organization',
    'label-belongto': 'Organization',
    'label-organization': 'Organization',
    'label-account': 'Account',
    'label-username': 'Incharge username',
    'label-useremail': 'Incharge email',
    'success-dialog': 'Invite message was successfully sent.',
    'fail-dialog': 'Invite message was failed sent.',
    'vali-username-must': 'Username is required.',
    'vali-username-format': 'Must be alphabet, numeric and symbols (. - _ @)',
    'vali-username-char': 'Username must be 4-20 characters.',
    'vali-email-must': 'Email address is required.',
    'vali-email-format': 'Must be valid email',
    'vali-phone-format': 'only number is valid.',
    'vali-phone-length': 'phone must be within 128 numbers.',
    'vali-role': 'Please select',
    'vali-org-select': 'Please select',
    'vali-org-name': 'Organization name is required.',
    'vali-location-name': 'Location name is required',
    'fail-registration': 'Registration failed',
    'fail-username': 'The username entered can not be registered',
    'fail-master-name': 'The top level organization can not be changed',
    'fail-email-update': 'Failed to update email address.' + 'If you have sent a message please discard it.',
    'can-edit-message': 'you can edit role and organization.',
    'cant-edit-yourself': 'You can\'t edit yourself.',
    'update-succeed': 'Update Sucessfully',
    'delete-succeed': 'Delete Sucessfully',
    'function-limit': 'Some functions can not be used with the current account.',
    'cant-delete-yourself': 'You can\'t delete yourself.',
    'cant-delete-admin-user': 'At least one super administrator user at the top level organization is required.',
    'delete-completed-myself': 'Deletion of your account has been completed.',
    'already-account': 'It is an already registered account. Please refresh the screen.'
  },
  'viewable-locations': {
    'header-viewable-locations': 'Visible Locations Management',
    'button-add-viewable-locations': 'Add Visible Locations',
    'label-permit-viewing-locations': 'Permit Visible Locations',
    'select-is-not-limited-viewer': 'All locations',
    'select-is-limited-viewer': 'Only selected locations',
    'label-viewing-target-locations': 'Visible Locations',
    'hint-viewing-target-locations': 'Pleese select visible locations',
    'button-set': 'Set',
    'button-cancel': 'Cancel'
  },
  'customer': {
    'add': 'Add Location',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'info': 'Basic information',
    'situation': 'Usage Report',
    'active-device': 'Active Device',
    'others': 'Others',
    'geo-location': 'latitude/longitude',
    'defined': 'registered.',
    'undefined': 'undefined.',
    'situation-title': 'Summury',
    'print': 'Print',
    'target': 'Target',
    'sum': 'Sum',
    'history': 'History',
    'iotizr-situation': 'Situation of IoTIZR',
    'service-plan': 'Service plan',
    'device-customer': 'Device (Location)',
    'date': 'date',
    'name': 'Location name',
    'device': 'Device',
    'organization': 'Organization',
    'address': 'Address',
    'tel': 'Phone',
    'open-map': 'Get the numbers from map',
    'close-map': 'Close the map',
    'content': 'Content',
    'get-address': 'Get the address',
    'search': 'Search',
    'error-location': 'Can\'t get a Longitude and Latitude',
    'error-delete': 'Failed to delete.',
    'error-delete-connecting-device': 'Remove IoTIZR(s) of this location first with HARPS Toolkit and try again.',
    'success-delete': 'Delete Sucessfully.'
  },
  'notifications': {
    'header-title': 'Life of consumables and Notification',
    'header-preset': 'Notification presets',
    'header-mail': 'Notification mail',
    'title-mail': 'Notification mail',
    'title-langage': 'Language setting',
    'japanese': 'Japanese',
    'english': 'English',
    'russian': 'Russian',
    'enable': 'Receive',
    'disable': 'Not Receive'
  },
  'profile': {
    'profile': 'Your profile',
    'role': 'Role',
    'organization': 'Organization',
    'email': 'Email',
    'new-email': 'New Email',
    'change-email': 'Change Email',
    'change-password': 'Change Password',
    'old-password': 'Current Password',
    'new-password': 'New Password',
    'confirm-new-password': 'Confirm new Password',
    'cancel': 'Cancel',
    'change': 'Change',
    'submit': 'Submit',
    'confirm': 'Confirm',
    'resend': 'Resend email',
    'continue': 'Continue',
    'confirmation-code': 'Enter your confirmation code',
    'confirmation-code-input': 'Enter confirmation code',
    'change-password-error': 'Incorrect old password.',
    'not-verified': 'Your email is not verified',
    'verify': 'Verify',
    'verified': 'Your email is verified',
    'vali-blank-new-pass': 'Please enter the new password',
    'vali-blank-old-pass': 'Please enter the current password',
    'vali-blank-confirm-new-pass': 'Please enter the confirm new password',
    'vali-format': 'Must be at least 8 characters long and Must contain at least one number (0-9)',
    'vali-length': '2must be within 25 digits',
    'vali-same-password': 'Please enter the same password as above.',
    'vali-empty-code': 'Enter confirmation code',
    'vali-email-format': 'Please provide a valid email address',
    'vali-invalid-code': 'Confirmation code is wrong',
    'code-confirm-text1': 'An email with a confirmation code has been sent to your registered email address.',
    'code-confirm-text2': 'Check your email and enter the confirmation code below.',
    'code-confirm-title': 'Enter your confirmation code',
    'code-confirm-input': 'Confirmation code',
    'change-email-title': 'Change Email',
    'change-password-title': 'Change Password',
    'success-resend': 'An email with a confirmation code has been sent to your registered email address.\n In case the mail is not delivered, please try after some time.',
    'fail-resend': 'Resent failed',
    'fail-error': 'Attempt limit exceeded, please try after some time.',
    'changed-password': 'Your password is updated'
  },
  'aplix-use-only': {
    'customer-category': 'Customer category',
    'customer-categories': {
      '1': 'Unknown',
      '2': 'For testing',
      '3': 'Domestic customers',
      '4': 'Overseas customers'
    },
    'btn': {
      'can-not-execute': 'Can not execute',
      'can-not-save': 'Can not save',
      'can-not-delete': 'Can not delete'
    },
    'usage-report': {
      'pc-organization': 'P/C organization',
      'button-csv-download': 'CSV Download'
    }
  },
  'usage-report': {
    'organization-name': 'Organization',
    'target-date': 'Date',
    'date': 'Date',
    'print': 'Print',
    'total-device-count': 'Total',
    'units': ' IoTIZRs',
    'location-count-title': 'Organization/Location Classification',
    'location-count-list': {
      'organization-name': 'Organization',
      'location-name': 'Location',
      'device-count': 'Active IoTIZR'
    },
    'device-count-title': 'Individual Classification',
    'device-count-list': {
      'organization-name': 'Organization',
      'location-name': 'Location',
      'filtration-system-name': 'Device',
      'unique-id': 'IoTIZR ID'
    },
    'can-not-print-ios': 'iOS does not support printing',
    'no-data-text': 'Usage report will be updated around 2nd of the next month.',
    'failed-display-no-data': 'Can\'t display because no data',
    'failed-download-no-data': 'Can\'t downlaad because no data',
    'failed-create-zip-file-fatal': 'It couldn\'t be downloaded because a fatal error occurred.',
    'failed-create-zip-file-busy': 'Server is busy. Please try again later.'
  }
};

module.exports = messages;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  'params': {
    'label': 'Deutsch beta'
  },
  'service': {
    'flow-and-time': 'Menge und Wasserfluss & Zeit',
    'ro-membrane': 'RO Membran Effizienz',
    'temperature': 'Temperatur',
    'leakage': 'Leckerkennung',
    'pressure': 'Wasserdruck',
    'co2': 'CO2-Gas'
  },
  'service-short': {
    'flow-and-time': 'Wasserfluss&Zeit',
    'ro-membrane': 'RO',
    'temperature': 'Temperatur',
    'leakage': 'Leck',
    'pressure': 'Druck',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Durchflusssensor',
    'tds': 'TDS Sensor',
    'temperature': 'Temperatursensor',
    'leakage': 'Lecksensor',
    'pressure': 'Drucksensor'
  },
  'user-params': {
    username: 'Benutzername',
    email: 'E-mail',
    password: 'Passwort',
    password_reinput: 'Passwort (Neueingabe)',
    password_reinput_differs: 'Passwort und Passwort (Neueingabe) sind unterschiedlich.',
    role: 'Rolle'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Mitarbeiter'
  },
  'btn': {
    'add': 'Hinzufügen',
    'edit': 'Bearbeiten',
    'cancel': 'Abrechen',
    'update': 'Akutalisieren',
    'save': 'Sichern',
    'ok': 'OK',
    'delete': 'Löschen'
  },
  'validate': {
    'phone-format': 'Bitte nur Ziffern eingeben',
    'phone-length': 'Telefonnummer muss innerhalb von 128 Ziffern sein',
    'select': 'Bitte auswählen',
    'vali-required': 'Dieses Feld ist Pflicht.'
  },
  cognitoError: {
    UserNotFoundException: 'Benutzername wurde nicht gefunden.',
    UsernameExistsException: 'Benutzer existiert bereits.',
    UserNotConfirmedException: 'Benutzer wurde nicht bestätigt.',
    NotAuthorizedException: 'Falscher Benutzername oder falsches Passwort.',
    LimitExceededException: 'Die Anzahl der Anforderungen überschreitet die maximale Anzahl der Wiederholungen des Systems. Bitte machen Sie eine weitere Anfrage nach einer gewissen Zeit.',
    CodeMismatchException: 'Es stimmt nicht mit dem Bestätigungscode überein, der vom System ausgegeben wurde. Bitte geben Sie den korrekten Bestätigungscode ein.',
    InvalidParameterException: 'Ein ungültiger Wert wurde angegeben.',
    UnknownError: 'Ein unbekannter Fehler ist aufgetreten.'
  },
  signup: {
    signup: 'Benutzerregistrierung',
    register: 'Benutzerregistrierung',
    buy_iotizr: 'Kauf IoTIZR',
    signupConfirmDialogText: 'Möchten Sie sich mit diesem Inhalt registrieren?',
    signupSuccessDialogText: 'Wir haben eine Anmeldeanfrage erhalten. Sie erhalten eine Bestätigungs-E-Mail an die angegebene E-Mail-Adresse. Bitte klicken Sie auf URL in der E-Mail, dann werden Sie korrekt registriert.'
  },
  'login': {
    'login': 'Anmeldung',
    'lost': 'Haben Sie Ihr Passwort vergessen?',
    'link_to_signup': 'Benutzerregistrierung',
    'vali-username-blank': 'Benutzername wird benötigt.',
    'vali-password-blank': 'Passwort wird benötigt.',
    'next': 'Weiter',
    'incorrect': 'Falscher Benutzername oder Passwort.'
  },
  'resetpassword': {
    'title': 'Passwort zurücksetzen',
    'detail': 'Bitte geben Sie Ihren Benutzernamen ein',
    'entercode': 'Bitte geben Sie den Bestätigungscode ein.',
    'newpassword': 'Neues Passwort',
    'codedetail': 'Eine E-Mail mit einem Bestätigungscode wurde von "no-reply@verificationemail.com" an Ihre registrierte E-Mail-Adresse gesendet. Überprüfen Sie Ihr Postfach und geben Sie den Bestätigungscode ein.',
    'resendcode': 'Code erneut senden',
    'vali-code-blank': 'Verifizierungscode erforderlich.',
    'vali-pass-blank': 'Ein neues Passwort ist erforderlich.',
    'vali-pass-number': 'Das Passwort muss mindestens eine Zahl (0-9) und einen Buchstaben (a-z) beinhalten.',
    'vali-pass-length': 'Das Passwort muss aus mehr als 7 Zeichen bestehen.',
    'vali-pass-whitespace': 'Passwort, die Leerzeichen enthalten, können nicht festgelegt werden.',
    'confirm': 'Bestätigen'
  },
  activate: {
    title: 'Account aktivieren',
    detail: 'Überprüfen Sie Ihr Postfach und geben Sie den Benutzernamen und das vorläufige Passwort ein. Bitte ändern Sie das temporäre Passwort. Bitte neues Passwort eingeben.',
    temp_password: 'Temporäres Passwort',
    newpassword: 'Neues Passwort',
    passwordreinput: 'Neues Passwort (Neueingabe)',
    agreement: 'Nutzungsbedingungen',
    // https://aplix.backlog.com/view/HARPS-641#comment-12816718
    // agreement_msg: 'Dieser Service wird Ihnen von der Aplix Corporation angeboten. Durch die Nutzung dieses Dienstes stimmen Sie den Aplix HARPS-Nutzungsbedingungen zu ( <a href=\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target=\'_blank\'>HARPS Nutzungsbedingungen</a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'>Datenschutzrichtlinie für IoT Solurion</a> ) und Schiedsverfahren vor der Internationalen Handelskammer für Streitigkeiten zwischen uns.',
    agree: 'Ich habe diese Bedingungen gelesen und stimme ihnen zu.',
    you_need_to_agree: 'Sie müssen zustimmen',
    submit: 'Absenden',
    complete: 'Aktivierung abgeschlossen'
  },
  'global-menu': {
    'dashboard': 'Home',
    'watersystem': 'Überwachung',
    'customer': 'Standortverwaltung',
    'setting': 'Einstellungen',
    'pc': 'PC Verwaltung'
  },
  'home': {
    'notification': 'Benachrichtigungen',
    'information': 'Von {0}',
    'mail-notification-top': 'E-Mail-Benachrichtigungen sind jetzt verfügbar.',
    'mail-notification-under': 'Bitte bestätigen Sie Ihre Einstellungen <a href=\'{0}\'>hier</a>',
    'quick-link': 'Schnell Link',
    'calendar': 'Wartungskalender',
    'quick-link-settings': 'Schnell Link Einstellungen',
    'notification-alert': 'Alarm-Wert erreicht',
    'notification-warning': 'Warnungs-Wert erreicht'
  },
  'watersystem': {
    'column-nexttime': 'Nächste Ersatzerwartung',
    'customer-name': 'Standortnamen',
    'customer': 'Standort',
    'organization-name': 'Organisation',
    'device-name': 'Gerätename',
    'device': 'Gerät',
    'deviceinfo': 'Geräteinformation',
    'filter-life-left': 'Filterlebensdauer übrig',
    'filter': 'Filter',
    'flow-rate': 'Fließrate',
    'flow': 'Strömung',
    'history': 'Historie',
    'list': 'Auflistung nach',
    'mapinfo': 'Karteninfo',
    'name': 'Name',
    'period-month': 'Monate',
    'purification-amount': 'Menge der Wasserreinigung',
    'RoMembrane': 'RO-Membranentfernungseffizienz',
    'RoMembrane-short': 'RO-Entfernungsrate',
    'RoMembrane-good': 'Gut',
    'RoMembrane-caution': 'Vorsicht',
    'RoMembrane-alert': 'Alarm',
    'Pressure': 'Drucksensor',
    'Pressure-short': 'Drucksensor',
    'Pressure-good': 'Gut',
    'Pressure-caution': 'Vorsicht',
    'Pressure-alert': 'Alert',
    'service': 'Service',
    'status': 'Status',
    'filter-reset': 'Filter zurücksetzen',
    'please-select': 'Bitte wählen Sie ein Gerät aus.',
    'elapsed-time': 'Verstrichene Zeit',
    'total-flow': 'Menge des Wasserflusses',
    'customer-info': 'Ortsinformationen',
    'rest-flow': 'Restwassermengen Flussrate',
    'filter-reset-title': 'Achtung!',
    'filter-reset-text': 'Möchten Sie den Filter wirklich zurücksetzen?',
    'filter-reset-do': 'Zurücksetzen',
    'filter-reset-cancel': 'Abbrechen',
    'threshold': 'Schwellenwert',
    'notification-threshold': 'Benachrichtigungsschwellenwert',
    'about-flow-and-time': 'Über Durchfluss und Zeit Schwellenwert',
    'about-ro-membrane': 'Über RO Membraneffizienzschwellenwert',
    'about-pressure': 'Über Wasser Druckschwellenwert',
    'custom': 'Angepasst',
    'use-preset': 'Verwenden Sie Voreinstellungen',
    'flow-life': 'Strömung Lebensspanne',
    'time-life': 'Zeit Lebensspanne',
    'alert': 'Alarm',
    'warning': 'Warnung',
    'use-flow': 'zu verwendender Durchflusssensor',
    'need-sensor': 'Benötigte Sensoren',
    'about-flow-and-time-text': 'Messen Sie die Wassermenge im Schlauch innerhalb einer bestimmten Zeit. Wir werden eine Benachrichtigung im Laufe der Zeit senden bei Erhöhung der Durchflussrate.',
    'about-ro-membrane-text': 'Installieren Sie an den Einlass / Auslass-2-Ein- / Auslässen der RO-Membran eine Sonde des TDS-Sensors, um den Verunreinigungsgehalt zu messen und berechnen Sie die Verunreinigungs-Entfernungsrate der RO-Membran. Wir senden Ihnen eine Mitteilung bei reduzierter Verunreinigungsentfernungsrate.',
    'about-pressure-text': 'Messen Sie den Druckwert am Einbauort des Sensors. Soweit es die Anzahl der Ports von IoTIZR betrifft, ist es möglich, mehrere zu installieren. Benachrichtigungen über den angegebenen Druck hinaus senden.',
    'about-setting-flow-and-time-text': 'Stellen Sie den Schwellenwert ein, bei dem eine Warnmeldung für die Durchflussrate ([UNIT]) bzw. die Zeit (Monat) ausgegeben wird.',
    'about-setting-ro-membrane-text': 'Sicherheitshinweis / Warnwert mit Verunreinigungsentfernungsrate (%) einstellen.',
    'about-setting-pressure-text': 'Vorsichtswert / Warnwert mit dem Druckwert einstellen.',
    'about-threshold-setting': 'Über die Schwellenwerteinstellung',
    'headline-press-alert': 'Der Druckwert war niedriger als der Warnwert.',
    'headline-press-warning': 'Der Druckwert war niedriger als der Vorsichtswert.',
    'headline-press-normal': 'Zur Zeit sind alle Druckwerte normal.',
    'headline-diff-press-alert': 'Der Differenzdruckwert liegt über dem Warnwert.',
    'headline-diff-press-warning': 'Der Differenzdruckwert liegt außerhalb des Warnwertes.',
    'now-pressure': 'Aktueller Druckwert',
    'vali-threshold-must': 'Benötigte Felder',
    'vali-threshold-num': 'Bitte geben Sie einen numerischen Wert ein',
    'vali-threshold-integer': 'Bitte geben Sie einen Ganzzahlenwert ein',
    'vali-threshold-limit100': 'Bitte geben Sie eine Zahl bis zu 100 ein',
    'vali-threshold-positive-integer': 'Bitte geben Sie eine Zahl größer oder gleich 0 ein',
    'impurities-removal-rate': 'Verunreinigungsentfernungsrate',
    'entrance-impurity-content': 'Der einlaßseitige Verunreinigungsgehalt',
    'exit-impurity-content': 'Auslauf Verunreinigungsgehalt',
    'time-elapsed': 'Verstrichene Zeit',
    'pressure': 'Wasserdruck',
    'setting-link-text1': 'Bitte bearbeiten Sie "Benachrichtigungsschwelle" in den ',
    'setting-link-text2': 'Einstellungen',
    'setting-link-text3': ' zum ändern.',
    'vali-threshold-alert-less-than': 'Bitte geben Sie einen Wert ein, der kleiner als der Alarmwert ist',
    'vali-threshold-greater-than-warning': 'Bitte geben Sie eine Nummer ein, die größer als der Warnwert ist',
    'vali-threshold-warning-less-than': 'Bitte geben Sie einen Wert ein, der kleiner als der Warnwert ist',
    'vali-threshold-greater-than-alert': 'Bitte geben Sie eine Zahl ein, die größer ist als der Alarmwert',
    'last-update': 'Letztes Update',
    'past-pressure': 'Druckwert bei {0}',
    'last-update-for-chart': 'Letztes Update',
    'last-update-week-suffix-for-chart': 'die Woche im Jahr {0}',
    'last-impurities-removal-late': 'Aktueller Verunreinigungsentfernungsrate',
    'past-impurities-removal-late': 'Verunreinigungsentfernungsrate bei {0}',
    'differential-pressure': 'Differenzdruckwert(e)',
    'about-differential-pressure-text': 'Misst den Druckwert von zwei Punkten und berechnet die Differenz (Absolutwert) des Druckwerts. Sendet eine Benachrichtigung, wenn sich der Differenzdruck erhöht.',
    'about-setting-differential-pressure-text': 'Warnungs-/Alarmschwellenwerte des Differenzdruck einstellen.',
    'differential-pressure-need-sensor': 'Zwei Drucksensoren',
    'differential-pressure-value': 'Differenzdruckwert',
    'leakage-all-normal': 'Es gibt momentan kein Wasserleck',
    'return-to-normal': 'Zurück zu keinem Leck',
    'leakage-alert': 'Wasserleck',
    'detection-history': 'Wasserleckgeschichte',
    'no-water-leak-history': 'Es gibt keine Wasserleckgeschichte.',
    'headline-leakage-alert': 'Wir haben Wasser aufgespürt. Bitte überprüfen Sie den Standort.',
    'leakage-normal': 'Kein Leck',
    'leakage': 'Wasserleck sensor',
    'leakage-short': 'Wasserleck sensor'
  },
  'chart': {
    'dataZoom-zoom': 'Zoom',
    'dataZoom-back': 'Zoom zurücksetzen',
    'change-period': 'Änderungszeitraum',
    'button-reload': 'Neu laden',
    'graph-label-fromlastchange': 'Gesamtwasserreinigung seit dem letzten Filterwechsel',
    'graph-label-diff': 'Wasserreinigung während der Zeit',
    'graph-label-sum': 'Vollständige Wasserreinigung',
    '15m': '15 Minuten',
    '1h': '1 Stunde',
    '1d': '1 Tag',
    '1w': '1 Woche',
    '1M': '1 Monat',
    'auto-reload': 'Automatisches Neuladen',
    'label-date': 'Datum',
    'label-time': 'Zeit',
    'button-date-jump': 'Springen',
    'button-date-recent': 'Letzter',
    'button-ok': 'OK',
    'button-cancel': 'Abbrechen',
    'message-oldest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht angezeigt werden können, werden die ältesten Daten angezeigt.',
    'message-latest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht angezeigt werden können, werden die neuesten Daten angezeigt.',
    'message-outbounds-oldest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht vorhanden sind, werden die ältesten Daten angezeigt.',
    'message-outbounds-latest': 'Da die Daten des angegebenen Datums und der angegebenen Uhrzeit nicht vorhanden sind, werden die neuesten Daten angezeigt.',
    'message-no-data': 'Keine Daten vorhanden.'
  },
  'user': {
    'unselected': 'Bitte wählen Sie eine Organisation.',
    'nodata': 'Es gibt keinen Benutzer.',
    'username': 'Benutzername',
    'email': 'E-Mail',
    'role': 'Rolle',
    'edit-setting': 'Einstellungen bearbeiten'
  },
  'organizations': {
    'title': 'Organisationen Liste',
    'button-add': 'Organisation hinzufügen',
    'button-add-pc': 'Fügen Sie P/C hinzu'
  },
  'settings': {
    'title': 'Einstellungen',
    'unit': 'Einheit der Wassermenge',
    'timezone': 'Zeitzone',
    'timezone-location': 'Lokale Zeitzone',
    'pressureUnit': 'Einheit des Drucks',
    'display-setting': 'Darstellungseinstellung',
    'available-sensor': 'Sensoren',
    'life-and-notification': 'Lebensdauer und Benachrichtigungen',
    'notification-presets': 'Benachrichtigungsvoreinstellungen',
    'notification-mail': 'Benachrichtigungsmail',
    'organization-user': 'Organisation und Benutzer',
    'management-organization': 'Organisationsmanagement',
    'user-management': 'Benutzerverwaltung',
    'user-invitation': 'Benutzer hinzufügen',
    'add-organization': 'Organisation hinzufügen',
    'pc-management': 'P/C Management',
    'set-up': 'Aktualisieren'
  },
  'account': {
    'delete-organization': 'Organisation löschen',
    'basic-information': 'Grundinformationen',
    'organization': 'Name der Organisation',
    'parent-organization': 'Elternorganisation',
    'description': 'Beschreibung',
    'tel': 'Telefon',
    'email': 'E-Mail',
    'contact': 'Kontakt',
    'incharge': 'die verantwortliche Person',
    'administrator': 'Administrator',
    'name': 'Name(optional)',
    'username': 'Benutzername des Verantwortlichen',
    'useremail': 'E-Mailadresse des Verantwortlichen',
    'company': 'Firmenname',
    'address': 'Adresse',
    'created': 'Erstellungsdatum',
    'edit': 'Bearbeiten',
    'caution-title': 'Achtung!',
    'caution-org-remove-text': 'Möchten Sie die Organisation wirklich löschen?',
    'caution-user-remove-text': 'Möchten Sie den Benutzer wirklich löschen?',
    'caution-location-remove-text': 'Möchten Sie den Standort wirklich löschen?',
    'delete': 'Löschen',
    'cancel': 'Abbrechen',
    'close': 'Schließen',
    'create': 'Erstellen',
    'updated': 'Aktualisiert',
    'error-delete': 'Konnte nicht gelöscht werden.',
    'error-customer': 'Es sind noch verwandte Orte übrig.',
    'error-user': 'Es gibt einige Benutzer darunter.',
    'error-root': 'Dies ist die root-Organisation.',
    'error-system': 'Es sind noch verwandte Systeme übrig.',
    'header-title': 'Organisation und Benutzerverwaltung',
    'header-org': 'Organisationsmanagement',
    'header-user': 'Benutzerverwaltung',
    'header-invite': 'Benutzer hinzufügen',
    'header-pc': 'P/C Verwaltung',
    'invite-btn': 'Einladungs-E-Mail senden',
    'policy': 'Grundsatzerklärung',
    'agree': 'Akzeptieren',
    'csv-import': 'Die CSV-Importfunktion ist in Planung',
    'label-role': 'Rolle',
    'label-parent': 'Elternorganisation',
    'label-belongto': 'Organisation',
    'label-organization': 'Organisation',
    'label-account': 'Account',
    'label-username': 'Benutzername des Verantwortlichen',
    'label-useremail': 'E-Mail des Verantwortlichen',
    'success-dialog': 'Einladungsnachricht wurde erfolgreich gesendet.',
    'vali-username-must': 'Benutzername ist ein Pflichtfeld.',
    'vali-username-format': 'Kann aus Buchstaben, Zahlen und Symbolen bestehen (. - _ @)',
    'vali-username-char': 'Der Benutzername muss 4-20 Zeichen lang sein.',
    'vali-email-must': 'E-Mail ist ein Pflichtfeld.',
    'vali-email-format': 'Muss gültige E-Mail sein',
    'vali-phone-format': 'Nur Zahlen sind gültig.',
    'vali-phone-length': 'Die Telefonnummer muss aus 128 Ziffern bestehen.',
    'vali-role': 'Bitte auswählen',
    'vali-org-select': 'Bitte auswählen',
    'vali-org-name': 'Der Name der Organisation ist erforderlich.',
    'vali-location-name': 'Der Name des Ortes ist erforderlich.',
    'fail-registration': 'Registrierung fehlgeschlagen',
    'fail-username': 'Der eingegebene Benutzername kann nicht registriert werden'
  },
  'customer': {
    'add': 'Standort hinzufügen',
    'latitude': 'Breitengrad',
    'longitude': 'Längengrad',
    'info': 'Grundinformation',
    'situation': 'Nutzungsbericht',
    'active-device': 'Aktive Geräte',
    'others': 'Andere',
    'geo-location': 'Breitengrad / Längengrad',
    'defined': 'eingetragen.',
    'undefined': 'undefiniert.',
    'situation-title': 'Zusammenfassung',
    'print': 'Drucken',
    'target': 'Ziel',
    'sum': 'Summe',
    'history': 'Historie',
    'iotizr-situation': 'Situation des IoTIZR',
    'service-plan': 'Serviceplan',
    'device-customer': 'Gerät (Ort)',
    'date': 'Datum',
    'name': 'Standortnamen',
    'device': 'Gerät',
    'organization': 'Organisation',
    'address': 'Adresse',
    'tel': 'Telefon',
    'open-map': 'Zahlen von Karte holen',
    'close-map': 'Karte schließen',
    'content': 'Inhalt',
    'get-address': 'Adresse bekommen',
    'search': 'Suche',
    'error-location': 'Längengrad und Breitengrad konnte nicht identifiziert werden',
    'error-delete': 'Löschen fehlgeschlagen.',
    'error-delete-connecting-device': 'Entfernen Sie den/die IoTIZR von diesem Ort zuerst mit dem HARPS Toolkit und versuchen Sie es erneut.',
    'success-delete': 'Löschen erfolgreich.'
  },
  'notifications': {
    'header-title': 'Lebensdauer von Verbrauchsmaterialien und Benachrichtigungen',
    'header-preset': 'Benachrichtigungsvoreinstellungen',
    'header-mail': 'Benachrichtigungsmail',
    'title-mail': 'Benachrichtigungsmail',
    'title-langage': 'Landeseinstellung',
    'japanese': 'Japanisch',
    'english': 'Englisch',
    'enable': 'Bekommen',
    'disable': 'Nicht bekommen'
  },
  'profile': {
    'profile': 'Dein Profil',
    'role': 'Rolle',
    'organization': 'Organisation',
    'email': 'E-Mail',
    'new-email': 'Neue E-Mail',
    'change-email': 'E-Mail ändern',
    'change-password': 'Passwort ändern',
    'old-password': 'Aktuelles Passwort',
    'new-password': 'Neues Passwort',
    'confirm-new-password': 'Neues Passwort bestätigen',
    'cancel': 'Abbrechen',
    'change': 'Ändern',
    'submit': 'Absenden',
    'confirm': 'Bestätigen',
    'resend': 'E-Mail erneut senden',
    'continue': 'Weiter',
    'confirmation-code': 'Geben Sie Ihren Bestätigungscode ein',
    'confirmation-code-input': 'Geben Sie den Bestätigungscode ein',
    'change-password-error': 'Altes Passwort falsch.',
    'not-verified': 'Ihre E-Mail-Adresse wurde nicht bestätigt',
    'verify': 'Überprüfen',
    'verified': 'Ihre E-Mail-Adresse ist verifiziert',
    'vali-blank-new-pass': 'Bitte geben Sie das neue Passwort ein',
    'vali-blank-old-pass': 'Bitte geben Sie das aktuelle Passwort ein',
    'vali-blank-confirm-new-pass': 'Bitte bestätigen Sie das neue Passwort',
    'vali-format': 'Muss mindestens 8 Zeichen lang sein und mindestens eine Zahl (0-9) enthalten',
    'vali-length': 'Muss innerhalb von 25 Ziffern liegen',
    'vali-same-password': 'Bitte geben Sie das gleiche Passwort wie oben ein.',
    'vali-empty-code': 'Geben Sie den Bestätigungscode ein',
    'vali-email-format': 'bitte geben Sie eine gültige E-Mail Adresse an',
    'vali-invalid-code': 'Bestätigungscode ist falsch',
    'code-confirm-text1': 'Eine E-Mail mit einem Bestätigungscode wurde an Ihre registrierte E-Mail-Adresse gesendet.',
    'code-confirm-text2': 'Überprüfen Sie Ihr Postfach und geben Sie den Bestätigungscode ein.',
    'code-confirm-title': 'Geben Sie den Bestätigungscode ein',
    'code-confirm-input': 'Bestätigungscode',
    'change-email-title': 'E-Mail ändern',
    'change-password-title': 'Passwort ändern',
    'success-resend': 'Eine E-Mail mit einem Bestätigungscode wurde an Ihre registrierte E-Mail-Adresse gesendet.\n Falls die E-Mail nicht zugestellt wird, versuchen Sie es bitte nach ein wenig Zeit erneut.',
    'fail-resend': 'Erneut senden fehlgeschlagen',
    'fail-error': 'Versuch Limit überschritten, bitte versuchen Sie es nach einiger Zeit.',
    'changed-password': 'Ihr Passwort wurde aktualisiert'
  }
};

module.exports = messages;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  'params': {
    'label': '日本語'
  },
  'service': {
    'flow-and-time': '流量と時間',
    'ro-membrane': 'RO膜性能',
    'temperature': '温度検知',
    'leakage': '漏水検知',
    'pressure': '圧力値',
    'co2': 'CO2ガス残量'
  },
  'service-short': {
    'flow-and-time': '流量',
    'ro-membrane': 'RO',
    'temperature': '温度',
    'leakage': '漏水',
    'pressure': '圧力',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': '流量センサー',
    'tds': 'TDSセンサー',
    'temperature': '温度センサー',
    'leakage': '漏水センサー',
    'pressure': '圧力センサー'
  },
  'user-params': {
    username: 'ユーザー名',
    email: 'メールアドレス',
    password: 'パスワード',
    password_reinput: 'パスワード (再入力)',
    password_reinput_differs: 'パスワードとパスワード(再入力)が異なります。',
    role: 'ロール'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Staff'
  },
  'btn': {
    'add': '追加',
    'edit': '編集',
    'cancel': 'キャンセル',
    'update': '更新',
    'save': '保存',
    'ok': 'OK',
    'delete': '削除',
    'resend': '再送'
  },
  'validate': {
    'phone-format': '数字のみ有効です',
    'phone-length': '128文字までです',
    'select': '選択してください',
    'vali-required': '必須項目です'
  },
  cognitoError: {
    UserNotFoundException: 'ユーザー名が見つかりません。',
    UsernameExistsException: '既に存在するユーザーです。',
    UserNotConfirmedException: 'ユーザー登録がまだ完了していません。',
    NotAuthorizedException: 'ユーザー名、パスワードのいずれかが不正です。',
    LimitExceededException: 'リクエスト回数がシステムの上限回数を超えました。一定時間をおいて、再度リクエストを' + '実施してください。',
    CodeMismatchException: 'システムによって発行された検証コードと一致しません。正しい検証コードを入力してください。',
    InvalidParameterException: '不正な入力値が指定されました。',
    UnknownError: '本サービスにて未知のエラーを検知しました。'
  },
  signup: {
    signup: '新規ユーザー登録',
    register: '新規ユーザー登録',
    btn_check_email: 'メールをご確認ください',
    buy_iotizr: 'IoTIZR購入のご相談',
    signupConfirmDialogText: 'この内容でユーザー登録しますか?',
    signupSuccessDialogText: '新規ユーザー登録を受け付けました。ご指定のメールアドレスに no-reply@harps4.com より' + 'メールを送信いたします。登録を完了するためメール中のURLへのリンクのクリックを' + 'お願いします。',
    agreement_msg: 'HARPSをはじめてご利用になる方(注)は、上記のフォームに任意のユーザーネーム' + '（４文字以上20文字以内のアルファベット、数字又は一部記号(.,-,_,@)の組みあわせ）' + 'と任意のパスワードを入力し「ユーザー登録」ボタンをクリックしてください。' + '「ユーザー登録」を押すことにより、' + '<a href="http://www.aplix.co.jp/legal/terms_harps.php">HARPS利用規約</a>、' + '<a href="http://www.aplix.co.jp/privacypolicy/privacypolicy_iot.php">IoTソリューションに関する個人情報保護方針</a>' + 'に同意したものとみなします。利用者が日本に居住していない場合は、' + '<a href="http://www.aplix.co.jp/en/legal/terms_harps.php">HARPS Terms of Service</a>' + 'に同意したものとみなします。<br>' + '<br>' + '（注）既存のHARPS組織にユーザーアカウントを追加する場合は、管理者に紹介を依頼してください。'
  },
  'login': {
    'login': 'ログイン',
    'lost': 'パスワードをお忘れの方',
    'link_to_signup': 'ユーザー登録',
    'vali-username-blank': 'ユーザー名は必須です。',
    'vali-password-blank': 'パスワードを入力してください。',
    'next': '次へ',
    'incorrect': 'ユーザー名またはパスワードが間違っています。'
  },
  'resetpassword': {
    'title': 'パスワードの再設定',
    'detail': 'ご登録いただいたユーザー名を入力してください',
    'entercode': '認証コードの入力',
    'newpassword': '新しいパスワード',
    'codedetail': '"no-reply@verificationemail.com"から認証コードをお送りしました。メールをご確認の上、認証コードを入力してください',
    'resendcode': '認証コードの再送',
    'vali-code-blank': '認証コードは必須です。',
    'vali-pass-blank': 'パスワードは必須です。',
    'vali-pass-number': '数字と英小文字を含む必要があります。',
    'vali-pass-length': '8文字以上である必要があります。',
    'vali-pass-whitespace': '空白を含むパスワードは設定できません。',
    'confirm': '確認'
  },
  activate: {
    title: 'アクティベーション',
    detail: 'メールに記載されたUsernameとパスワードをご入力ください。パスワードの変更が必要ですので、ご希望の新しいパスワードもご記入ください',
    temp_password: '仮パスワード',
    newpassword: '新しいパスワード',
    passwordreinput: '新しいパスワード(再入力)',
    agreement: '同意',
    agreement_msg: '本サービスは株式会社アプリックスの提供によるものです。本サービスの利用者は、HARPSユーザー利用規約( ' + '<a href="http://www.aplix.co.jp/legal/terms_harpsusers.php" target="_blank">' + 'HARPSユーザー利用規約</a>, 及び' + '<a href="http://www.aplix.co.jp/privacypolicy/privacypolicy_iot.php" target="_blank">' + 'IoTソリューションに関する個人情報保護方針</a> )に同意したものとみなします。' + '日本に居住していない利用者の方は、' + '<a href="http://www.aplix.co.jp/en/legal/terms_harpsusers.php" target="_blank">' + 'HARPS USERS Terms of Service</a> に同意したものとみなします。',
    agree: '同意します。',
    you_need_to_agree: '同意していただく必要があります',
    submit: '送信',
    complete: 'アクティベートが完了しました。'
  },
  'global-menu': {
    'dashboard': 'ホーム',
    'watersystem': 'モニタリング',
    'customer': '設置拠点の管理',
    'setting': '設定',
    'pc': 'P/C 管理'
  },
  'home': {
    'notification': '通知',
    'information': '{0}からのお知らせ',
    'mail-notification-top': 'メール通知が利用可能になりました。',
    'mail-notification-under': '<a href=\'{0}\'>こちら</a>から設定してください。',
    'quick-link': 'クイックリンク',
    'calendar': 'メンテナンスカレンダー',
    'quick-link-settings': 'クイックリンクの設定',
    'notification-alert': '警告値に達しました',
    'notification-warning': '注意値に達しました'
  },
  'watersystem': {
    'column-nexttime': '次の交換予測時期',
    'customer-name': '設置拠点名',
    'customer': '設置拠点',
    'organization-name': '所有組織',
    'device-name': 'デバイス名',
    'device': 'デバイス',
    'deviceinfo': 'デバイス情報',
    'filter-life-left': 'フィルター寿命',
    'filter': 'フィルター',
    'flow-rate': '流量',
    'flow': '流量',
    'history': '履歴',
    'list': 'リスト表示',
    'mapinfo': '位置情報',
    'name': '名前',
    'period-month': 'ヶ月',
    'purification-amount': '浄水量',
    'RoMembrane': 'RO膜除去率',
    'RoMembrane-short': 'RO膜除去率',
    'RoMembrane-good': '良好',
    'RoMembrane-caution': '注意',
    'RoMembrane-alert': '警告',
    'Pressure': '圧力センサー',
    'Pressure-short': '圧力センサー',
    'Pressure-good': '良好',
    'Pressure-caution': '注意',
    'Pressure-alert': '警告',
    'service': 'サービス',
    'status': 'ステータス',
    'delete-water-system': '{0}を削除します。\n履歴はすべて失われます。',
    'delete-water-system-with-iotizr': '登録済みのIoTIZRは引き続き通信を行いますが、データを読むことはできなくなります。\nIoTIZRからの通信を止めたい場合には、IoTIZRの電源を抜いていただくか、アプリから削除してください。',
    'delete-water-system-ask': '本当に削除しますか？',
    'error-delete': '削除できませんでした。',
    'succeed-delete': '削除しました。',
    'filter-reset': 'フィルターリセット',
    'please-select': 'デバイスを選択してください',
    'elapsed-time': '経過時間',
    'total-flow': '総流量',
    'customer-info': '設置拠点情報',
    'rest-flow': '残り浄水可能量',
    'filter-reset-title': '注意',
    'filter-reset-text': '本当にフィルターリセットを行いますか？',
    'filter-reset-do': '実行',
    'filter-reset-cancel': 'キャンセル',
    'threshold': 'しきい値',
    'notification-threshold': '通知しきい値',
    'about-flow-and-time': '流量と時間のしきい値について',
    'about-ro-membrane': 'RO膜性能のしきい値について',
    'about-temperature': '温度のしきい値について',
    'about-pressure': '圧力値のしきい値について',
    'custom': 'カスタム',
    'use-preset': 'プリセットを使う',
    'flow-life': '流量寿命',
    'time-life': '時間寿命',
    'alert': '警告値',
    'warning': '注意値',
    'use-flow': '使用フローセンサー',
    'need-sensor': '必要なセンサー',
    'about-flow-and-time-text': 'ある時間内に、パイプ・ホース内で水の流れた量を測定します。時間の経過、流量の増加により通知を送信します。',
    'about-ro-membrane-text': 'RO膜の入口/出口 2箇所に、不純物含有率を測定するTDSセンサーのプローブを設置し、そのRO膜の不純物除去率を算出します。不純物除去率の低下により通知を送信します。',
    'about-pressure-text': 'センサー設置箇所の圧力値を測定します。IoTIZRのポート数の限り複数設置することができます。指定した圧力を超えると通知を送信します。',
    'about-temperature-text': 'センサー設置箇所の温度を測定します。IoTIZRのポート数の限り複数設置することができます。温度の変化により通知を送信します。',
    'about-setting-flow-and-time-text': '流量([UNIT])、時間(ヶ月)それぞれに注意・警告の通知が出るしきい値を設定します。',
    'about-setting-ro-membrane-text': '不純物除去率(%)で注意値・警告値を設定します。',
    'about-setting-temperature-text': '温度で注意値・警告値を設定します。',
    'about-setting-pressure-text': '圧力値で注意値・警告値を設定します。',
    'about-threshold-setting': 'しきい値の設定について',
    'headline-press-alert': '圧力値が警告値より低下しています。',
    'headline-press-warning': '圧力値が注意値より低下しています。',
    'headline-press-normal': '現在、圧力値は全て正常です。',
    'headline-diff-press-alert': '圧力値が警告値を超えています。',
    'headline-diff-press-warning': '圧力値が注意値を超えています。',
    'headline-temperature-up-alert': '温度が警告値より上昇しています。',
    'headline-temperature-up-warning': '温度が注意値より上昇しています。',
    'headline-temperature-down-alert': '温度が警告値より低下しています。',
    'headline-temperature-down-warning': '温度が注意値より低下しています。',
    'now-pressure': '現在の圧力値',
    'vali-threshold-must': '必須項目です',
    'vali-threshold-num': '数値で入力してください',
    'vali-threshold-min': '計測可能温度より下回っています。',
    'vali-threshold-max': '計測可能温度より上回っています。',
    'vali-threshold-min-comm': '{0} 以上で入力してください。',
    'vali-threshold-max-comm': '{0} 以下で入力してください。',
    'vali-threshold-integer': '整数で入力してください',
    'vali-threshold-limit100': '100までの数値で入力してください',
    'vali-threshold-positive-integer': '0以上の数値で入力してください',
    'impurities-removal-rate': '不純物除去率',
    'entrance-impurity-content': '入口側の不純物含有率',
    'exit-impurity-content': '出口側の不純物含有率',
    'time-elapsed': '時間経過',
    'pressure': '圧力値',
    'setting-link-text1': '変更するには',
    'setting-link-text2': '設定',
    'setting-link-text3': 'の「通知しきい値」を編集してください',
    'vali-threshold-alert-less-than': '警告値より小さい数値を入力してください',
    'vali-threshold-greater-than-warning': '注意値より大きい数値を入力してください',
    'vali-threshold-warning-less-than': '注意値より小さい数値を入力してください',
    'vali-threshold-greater-than-alert': '警告値より大きい数値を入力してください',
    'last-update': '最終更新日',
    'past-pressure': '{0}の圧力値',
    'last-update-for-chart': '最終更新',
    'last-update-week-suffix-for-chart': '{0}の週',
    'last-impurities-removal-late': '現在の不純物除去率',
    'past-impurities-removal-late': '{0}の不純物除去率',
    'differential-pressure': '差圧',
    'about-differential-pressure-text': '2点の圧力値を測定し、圧力値の差分(絶対値)を算出します。差圧の増加により通知を送信します。',
    'about-setting-differential-pressure-text': '差圧(絶対値)で注意値・警告値を設定します。',
    'differential-pressure-need-sensor': '圧力センサー×2',
    'differential-pressure-value': '圧力値',
    'leakage-all-normal': '現在、異常はありません。',
    'return-to-normal': '正常復帰',
    'leakage-alert': '水漏れを検知',
    'detection-history': '漏水履歴',
    'no-water-leak-history': '漏水履歴はありません。',
    'headline-leakage-alert': '水漏れを検知しています。現地を確認してください。',
    'leakage-normal': '異常なし',
    'leakage': '漏水センサー',
    'leakage-short': '漏水センサー',
    'temperature-short': '温度センサー',
    'temperature-alert': '警告を検知しました。',
    'temperature-warning': '注意を検知しました。',
    'temperature-normal': '現在、異常はありません。',
    'temperature-min': '以上',
    'temperature-max': '以下',
    'temperature-increase': 'しきい値よりも高くなると通知',
    'temperature-decrease': 'しきい値よりも低くなると通知',
    'temperature-content': '温度',
    'temperature-select-label': '通知ルール',
    'now-temperature': '現在の温度',
    'past-temperature': '{0}の温度'
  },
  'chart': {
    'dataZoom-zoom': 'ズーム',
    'dataZoom-back': 'ズーム解除',
    'change-period': '時間間隔の変更',
    'button-reload': '更新',
    'graph-label-fromlastchange': '前回のフィルター交換時からの総浄水量',
    'graph-label-diff': '時間間隔あたりの浄水量',
    'graph-label-sum': '総浄水量',
    '15m': '15分ごとのグラフ',
    '1h': '1時間ごとのグラフ',
    '1d': '1日ごとのグラフ',
    '1w': '1週間ごとのグラフ',
    '1M': '1ヶ月ごとのグラフ',
    'auto-reload': '自動更新',
    'label-date': '日付',
    'label-time': '時刻',
    'button-date-jump': '移動',
    'button-date-recent': '最新',
    'button-ok': 'Ok',
    'button-cancel': 'キャンセル',
    'message-oldest': '指定した日時のデータを中心に表示できないため、一番古いデータから表示しております。',
    'message-latest': '指定した日時のデータを中心に表示できないため、最新のデータを表示しております。',
    'message-outbounds-oldest': '指定した日時のデータが存在しないため、一番古いデータから表示しております。',
    'message-outbounds-latest': '指定した日時のデータが存在しないため、最新のデータを表示しております。',
    'message-no-data': 'データがありません。'
  },
  'csv-download': {
    'button-csv-download': 'CSVダウンロード',
    'button-download': 'ダウンロード',
    'start-datetime': '開始日時',
    'end-datetime': '終了日時',
    'failed-download-no-data': 'データがないため、ダウンロードできませんでした。',
    'failed-create-zip-file-fatal': '致命的なエラーが発生したため、ダウンロードできませんでした。',
    'failed-create-zip-file-busy': 'サーバが混雑しています。後ほどお試しください。',
    'invalid-start-end-datetime': '開始日時が終了日時より後になっています。'
  },
  /* 英語統一のため使用しない 2019/01/17 R.Inoue
  'csv-header': {
    'datetime': '日時',
    'organization-name': '組織名',
    'location-name': '設置拠点名',
    'device-name': 'デバイス名',
    'flow-log-status': '流量計の状態',
    'flow-log-flow': '総浄水量({0})',
    'flow-log-flow-diff': '時間間隔あたりの浄水量({0})',
    'ro-rate-log-status': 'RO膜の状態',
    'ro-rate-log-rate': '不純物除去率(%)',
    'temperature-log-status': '{0}:温度センサの状態',
    'temperature-log-temperature': '{0}:温度({1})',
    'leakage-log-status': '{0}:漏水センサの状態',
    'water-pressure-log-status': '{0}:圧力センサの状態',
    'water-pressure-log-pressure': '{0}:圧力値({1})'
  },
  */
  'user': {
    'unselected': '所属組織を選択してください',
    'nodata': 'ユーザーがいません',
    'username': 'ユーザー名',
    'email': 'メールアドレス',
    'role': 'ユーザーレベル',
    'edit-setting': '設定を変更する'
  },
  'organizations': {
    'title': '組織 一覧',
    'button-add': '組織追加',
    'button-add-pc': 'P/Cアカウントの追加',
    'vali-create-limit': '制限されているため下位組織が作れません',
    'limit-settings': '組織作成制限',
    'no-limit': '無制限'
  },
  'device': {
    'name': 'デバイス名',
    'vali-device-name': 'デバイス名は必須項目です。'
  },
  'settings': {
    'title': '設定',
    'unit': '水量の単位',
    'timezone': 'タイムゾーン',
    'timezone-location': '設置箇所のタイムゾーン',
    'pressureUnit': '圧力の単位',
    'temperatureUnit': '温度の単位',
    'display-setting': '表示設定',
    'available-sensor': '使用センサー',
    'life-and-notification': '消耗品寿命と通知',
    'notification-presets': '通知タイミングプリセット',
    'notification-mail': 'メール通知',
    'organization-user': '組織とユーザー',
    'management-organization': '組織の管理',
    'user-management': 'ユーザーの管理',
    'user-invitation': 'ユーザー招待',
    'add-organization': '組織を追加する',
    'pc-management': 'P/Cの管理',
    'set-up': '更新'
  },
  'account': {
    'delete-organization': '組織を削除',
    'basic-information': '基本情報',
    'organization': '組織名',
    'parent-organization': '親組織',
    'description': '説明',
    'tel': '電話番号',
    'email': 'メールアドレス',
    'contact': '連絡先',
    'incharge': '担当者',
    'administrator': '管理者',
    'name': '名前（任意）',
    'username': '管理者 ユーザー名（必須）',
    'useremail': '管理者 メールアドレス（必須）',
    'company': '会社名',
    'address': '住所',
    'created': '登録日',
    'edit': '編集',
    'caution-title': '注意',
    'caution-org-remove-text': '本当に下記の組織を削除しますか？',
    'caution-user-remove-text': '本当に下記のユーザーを削除しますか？',
    'caution-location-remove-text': '本当に下記の設置拠点を削除しますか？',
    'delete': '削除',
    'cancel': 'キャンセル',
    'close': '閉じる',
    'create': '作成',
    'updated': '更新しました',
    'error-delete': '削除できませんでした。',
    'error-customer': 'まだ関連する設置拠点が残っています。',
    'error-user': 'まだ配下にユーザーが残っています。',
    'error-root': 'この組織はルートのため消せません',
    'error-system': 'まだ関連するシステムが残っています。',
    'header-title': '組織とユーザー',
    'header-org': '組織の管理',
    'header-user': 'ユーザーの管理',
    'header-invite': 'ユーザーを招待',
    'header-pc': 'P/Cの管理',
    'invite-btn': '招待メールを送信',
    'policy': '運用方針',
    'agree': '同意する',
    'csv-import': 'CSVインポート機能を追加予定です',
    'label-role': '権限',
    'label-parent': '親組織',
    'label-belongto': '所属組織',
    'label-organization': '組織情報',
    'label-account': 'アカウント情報',
    'label-username': '管理者 ユーザー名',
    'label-useremail': '管理者 メールアドレス',
    'success-dialog': '招待メールを送信しました',
    'fail-dialog': '招待メールを送信できません',
    'vali-username-must': 'ユーザー名は必須です',
    'vali-username-format': 'ユーザー名は英数字と一部の記号(. - _ @)のみです',
    'vali-username-char': 'ユーザー名は4-20文字です',
    'vali-email-must': 'メールアドレスは必須です',
    'vali-email-format': 'メールアドレスが有効ではありません',
    'vali-phone-format': '数字のみ有効です',
    'vali-phone-length': '128文字までです',
    'vali-role': '選択してください',
    'vali-org-select': '選択してください',
    'vali-org-name': '組織名は必須です',
    'vali-location-name': '設置拠点名は必須です',
    'fail-registration': '登録に失敗しました',
    'fail-username': '入力されたユーザー名は登録できません',
    'fail-master-name': '最上位組織のため変更できません',
    'fail-email-update': 'メールアドレスの更新に失敗しました。' + '送信されたメールがございましたら廃棄願います。',
    'can-edit-message': '権限と組織を編集できます。',
    'cant-edit-yourself': '自身の設定は編集できません。',
    'update-succeed': '更新しました。',
    'delete-succeed': '削除しました。',
    'function-limit': '現在のアカウントでは、一部機能はご利用いただけません。',
    'cant-delete-yourself': '自身を削除することはできません。',
    'cant-delete-admin-user': '最上位組織の管理者ユーザーは最低一人は必要です。',
    'delete-completed-myself': '自身のアカウントの削除が完了しました。',
    'already-account': '既に登録済みのアカウントです。画面を更新してください。'
  },
  'viewable-locations': {
    'header-viewable-locations': '閲覧対象設置拠点の設定',
    'button-add-viewable-locations': '閲覧対象設置拠点の設定',
    'label-permit-viewing-locations': '閲覧許可する設置拠点',
    'select-is-not-limited-viewer': '全設置拠点',
    'select-is-limited-viewer': '選択拠点のみ',
    'label-viewing-target-locations': '閲覧対象設置拠点',
    'hint-viewing-target-locations': '閲覧対象設置拠点を選択してください',
    'button-set': '設定',
    'button-cancel': 'キャンセル'
  },
  'customer': {
    'add': '設置拠点を追加',
    'latitude': '緯度',
    'longitude': '経度',
    'info': '基本情報',
    'situation': '利用状況',
    'active-device': '設置デバイス数',
    'others': 'その他',
    'geo-location': '緯度経度',
    'defined': '設定済み',
    'undefined': '未設定',
    'situation-title': 'サービス利用状況レポート',
    'print': '印刷',
    'target': '対象',
    'sum': '合計',
    'history': '履歴',
    'iotizr-situation': 'IoTIZR 稼働状況',
    'service-plan': 'ご利用プラン',
    'device-customer': 'デバイス名(設置拠点名)',
    'date': '日付',
    'name': '設置拠点の名称',
    'device': 'デバイス名',
    'organization': 'この設置拠点を管理する組織',
    'address': '住所',
    'tel': '電話番号',
    'open-map': '地図から緯度経度を取得',
    'close-map': '地図を閉じる',
    'content': '内容',
    'get-address': '住所取得',
    'search': '検索',
    'error-location': '緯度経度取得できませんでした。',
    'error-delete': '削除できませんでした。',
    'error-delete-connecting-device': 'HARPS Toolkit でこの設置拠点のIoTIZRを削除してからもう一度お試しください。',
    'success-delete': '削除しました。'
  },
  'notifications': {
    'header-title': '消耗品寿命と通知',
    'header-preset': '通知タイミングプリセット',
    'header-mail': 'メール通知',
    'title-mail': 'メール通知',
    'title-langage': '言語設定',
    'japanese': '日本語',
    'english': '英語',
    'enable': '受け取る',
    'disable': '受け取らない'
  },
  'profile': {
    'profile': 'プロフィール',
    'role': '権限',
    'organization': '所属組織',
    'email': 'メールアドレス',
    'new-email': '新しいメールアドレス',
    'change-email': 'メールアドレス変更',
    'change-password': 'パスワード変更',
    'old-password': '現在のパスワード',
    'new-password': '新しいパスワード',
    'confirm-new-password': '新しいパスワード（確認）',
    'cancel': 'キャンセル',
    'change': '変更',
    'submit': '確定',
    'confirm': '確認',
    'resend': '確認コード再送信',
    'continue': '確認',
    'confirmation-code': '確認コードを入力してください。',
    'confirmation-code-input': '確認コード',
    'change-password-error': '現在のパスワードが違います',
    'not-verified': '未検証',
    'verify': '検証',
    'verified': 'メールアドレスの検証が完了しました',
    'vali-blank-new-pass': '新しいパスワードを入力してください',
    'vali-blank-old-pass': '現在のパスワードを入力してください',
    'vali-blank-confirm-new-pass': '新しいパスワード(確認)を入力してください',
    'vali-format': '英数字を含む8文字以上で入力してください',
    'vali-length': '25文字までです',
    'vali-same-password': '新しいパスワードと同じパスワードを入力してください',
    'vali-empty-code': 'コードを入力してください',
    'vali-email-format': 'メールアドレスが有効ではありません',
    'vali-invalid-code': '確認コードが違います',
    'code-confirm-text1': '確認コードが記載されたメールを送信しました。',
    'code-confirm-text2': 'メールを確認してコードを入力してください。',
    'code-confirm-title': '確認コード入力',
    'code-confirm-input': '確認コード',
    'change-email-title': 'メールアドレス変更',
    'change-password-title': 'パスワード変更',
    'success-resend': '確認コードをお送りしました。メールをご確認の上、認証コードを入力してください\nしばらく待っても届かない場合は、時間をおいて再度お試しください',
    'fail-resend': '確認コードの送信に失敗しました',
    'fail-error': '時間をおいて再度お試しください',
    'changed-password': 'パスワードを変更しました'
  },
  'aplix-use-only': {
    'customer-category': '顧客カテゴリ',
    'customer-categories': {
      '1': '不明',
      '2': '試験用',
      '3': '国内顧客',
      '4': '海外顧客'
    },
    'btn': {
      'can-not-execute': '実行不可',
      'can-not-save': '保存不可',
      'can-not-delete': '削除不可'
    },
    'usage-report': {
      'pc-organization': 'P/C 組織',
      'button-csv-download': 'CSVダウンロード'
    }
  },
  'usage-report': {
    'organization-name': '組織名',
    'target-date': '対象年月',
    'date': '対象年月',
    'print': '印刷',
    'total-device-count': '全組織合計',
    'units': '台',
    'location-count-title': '組織/設置拠点内訳',
    'location-count-list': {
      'organization-name': '組織名',
      'location-name': '設置拠点名',
      'device-count': 'IoTIZR台数'
    },
    'device-count-title': '個別内訳',
    'device-count-list': {
      'organization-name': '組織名',
      'location-name': '設置拠点名',
      'filtration-system-name': '浄水システム名',
      'unique-id': 'IoTIZR ID'
    },
    'can-not-print-ios': 'iOSでは印刷をサポートしていません',
    'no-data-text': '使用状況は翌月2日ころに更新されます。',
    'failed-display-no-data': 'データがないため、表示できませんでした。',
    'failed-download-no-data': 'データがないため、ダウンロードできませんでした。',
    'failed-create-zip-file-fatal': '致命的なエラーが発生したため、ダウンロードできませんでした。',
    'failed-create-zip-file-busy': 'サーバが混雑しています。後ほどお試しください。'
  }
};

module.exports = messages;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {};

module.exports = messages;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var GraphHelper = function () {
  function GraphHelper() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GraphHelper);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GraphHelper, [{
    key: 'jumpToRecent',
    value: function jumpToRecent(logChartVue) {
      var toDatetimeUnixTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (isNaN(toDatetimeUnixTime)) {
        toDatetimeUnixTime = Math.floor(Date.now() / 1000);
        toDatetimeUnixTime = toDatetimeUnixTime - toDatetimeUnixTime % (15 * 60);
      }
      // グラフ描画のレンジを設定しておく
      var now = toDatetimeUnixTime;
      var rangeOffsets = this.getRangePeriodOffsets(logChartVue, true);
      var rangeEnd = now - now % logChartVue.periodTime;
      logChartVue.range.start = rangeEnd - logChartVue.periodTime * rangeOffsets.toStart;
      logChartVue.range.end = rangeEnd;

      // 日付設定フォームにレンジのTOを設定
      logChartVue.toDatetimeUnixTime = toDatetimeUnixTime;
      this.resetDataZoomToolBox(logChartVue);
      logChartVue.reload();
    }
    // APIの引数from,toの範囲外のデータの切り詰め

  }, {
    key: 'omitOutOfRangeFromToData',
    value: function omitOutOfRangeFromToData(logChartVue, option) {
      // APIの引数fromより古い
      logChartVue.outOfFromTimestamp = option.xAxis.data[0] || null;
      if (logChartVue.outOfFromTimestamp && logChartVue.outOfFromTimestamp < logChartVue.from) {
        option.series.forEach(function (one, index) {
          logChartVue.outOfFromSeriesData[index] = one.data[0];
          one.data.splice(0, 1);
        });
        option.xAxis.data.splice(0, 1);
      }
      if (logChartVue.outOfFromSeriesData.length === 0) {
        logChartVue.outOfFromTimestamp = null;
      }
      // APIの引数toより新しい
      var lastTimestampIndex = option.xAxis.data.length - 1;
      logChartVue.outOfToTimestamp = option.xAxis.data[lastTimestampIndex] || null;
      if (logChartVue.outOfToTimestamp && logChartVue.outOfToTimestamp > logChartVue.to) {
        var isNotNullOutOfTo = false;
        option.series.forEach(function (one, index) {
          if (one.data[lastTimestampIndex] !== null) {
            isNotNullOutOfTo = true;
            return;
          }
        });
        option.series.forEach(function (one, index) {
          if (isNotNullOutOfTo) {
            logChartVue.outOfToSeriesData[index] = one.data[lastTimestampIndex];
          }
          one.data.splice(lastTimestampIndex, 1);
        });
        option.xAxis.data.splice(lastTimestampIndex);
      }
      if (logChartVue.outOfToSeriesData.length === 0) {
        logChartVue.outOfToTimestamp = null;
      }
      // この時点でデータを一旦退避
      logChartVue.xAxisDatas = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(option.xAxis.data));
      option.series.forEach(function (one, index) {
        logChartVue.seriesDatas[index] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(one));
      });

      return option;
    }
    // option.dataZoom[0]の切り詰め

  }, {
    key: 'fixOptionDataZoomRange',
    value: function fixOptionDataZoomRange(logChartVue, option) {
      var rangeStart = Number(option.dataZoom[0].startValue);
      var optionXAxisStart = option.xAxis.data[0];
      var rangeEnd = Number(option.dataZoom[0].endValue);
      var optionXAxisEnd = option.xAxis.data[option.xAxis.data.length - 1];
      var viewRangeStartIndex = -1;
      var viewRangeEndIndex = -1;
      // APIで受けた日時の先頭が範囲設定のstartのあとの場合はAPIで受けた日時の先頭を設定
      if (rangeStart >= optionXAxisStart) {
        viewRangeStartIndex = option.xAxis.data.indexOf(rangeStart);
      }
      if (viewRangeStartIndex === -1) {
        for (var index = 0; index < option.xAxis.data.length; index++) {
          var element = option.xAxis.data[index];
          if (element > rangeStart) {
            viewRangeStartIndex = index > 0 ? index - 1 : 0;
            break;
          }
        }
      }
      // APIで受けた日時の末尾が範囲設定のendの前の場合はAPIで受けた日時の末尾を設定
      if (rangeEnd <= optionXAxisEnd) {
        viewRangeEndIndex = option.xAxis.data.indexOf(rangeEnd);
      }
      if (viewRangeEndIndex === -1) {
        for (var _index = option.xAxis.data.length - 1; _index >= 0; _index--) {
          var _element = option.xAxis.data[_index];
          if (_element < rangeEnd) {
            viewRangeEndIndex = _index < option.xAxis.data.length - 1 ? _index + 1 : option.xAxis.data.length - 1;
            break;
          }
        }
      }
      // 範囲指定が12プロット分なら12プロット表示できるよう範囲を広げる
      if (rangeEnd - rangeStart >= logChartVue.periodTime * 12) {
        if (viewRangeEndIndex - viewRangeStartIndex < 12) {
          // endを広げる
          if (viewRangeStartIndex + 12 >= option.xAxis.data.length) {
            viewRangeEndIndex = option.xAxis.data.length - 1;
          } else {
            viewRangeEndIndex = viewRangeStartIndex + 12;
          }
        }
        if (viewRangeEndIndex - viewRangeStartIndex < 12) {
          // startを広げる
          if (viewRangeEndIndex - 12 < 0) {
            viewRangeStartIndex = 0;
          } else {
            viewRangeStartIndex = viewRangeEndIndex - 12;
          }
        } else if (!logChartVue.isChangeRangeBarWidth) {
          // レンジバーの幅を変えている場合はそのままのレンジで表示する
          viewRangeStartIndex = viewRangeEndIndex - 12;
        }
      }
      option.dataZoom[0].startValue = option.xAxis.data[viewRangeStartIndex].toString();
      option.dataZoom[0].endValue = option.xAxis.data[viewRangeEndIndex].toString();
      logChartVue.range = {
        start: option.xAxis.data[viewRangeStartIndex],
        end: option.xAxis.data[viewRangeEndIndex]
      };
      return option;
    }
    // タイムスタンプ値の丸め

  }, {
    key: 'roundTimestamp',
    value: function roundTimestamp(logChartVue, timestamp) {
      var dateObj = new Date(timestamp * 1000);

      switch (logChartVue.period) {
        case '15m':
        case '1h':
        case '1d':
          timestamp = timestamp - timestamp % logChartVue.periodTime;
          break;
        case '1w':
          dateObj.setDate(dateObj.getDate() - dateObj.getDay());
          var week = Math.floor(dateObj.getTime() / 1000);
          // 時間を00時になるよう1日の秒数で割、余りを引く
          timestamp = week - week % 86400;
          break;
        case '1M':
          dateObj.setDate(1);
          var month = Math.floor(dateObj.getTime() / 1000);
          // 時間を00時になるよう1日の秒数で割、余りを引く
          timestamp = month - month % 86400;
          break;
      }
      return timestamp;
    }
    // 描画範囲のプロットの中間点からのオフセットを取得する
    // 最新表示の場合はプロットの最新からのオフセットを取得する

  }, {
    key: 'getRangePeriodOffsets',
    value: function getRangePeriodOffsets(logChartVue) {
      var isRecent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var rangeOffsets = {
        toStart: isRecent ? 12 : 6,
        toEnd: isRecent ? 0 : 6
      };
      var rangePeriods = Math.floor((logChartVue.range.end - logChartVue.range.start) / logChartVue.periodTime);
      // 描画範囲のレンジバーが変更されている場合
      if (logChartVue.isChangeRangeBarWidth) {
        if (isRecent) {
          // 最新ボタン押下時
          rangeOffsets.toStart = rangePeriods;
        } else {
          // 移動ボタン押下時
          var rangePeriodMidPoint = Math.ceil(rangePeriods / 2);
          rangeOffsets.toEnd = rangePeriods - rangePeriodMidPoint;
          rangeOffsets.toStart = rangePeriods - rangeOffsets.toEnd;
        }
      }
      return rangeOffsets;
    }
  }, {
    key: 'getRangeByToDatetimePeriod',
    value: function getRangeByToDatetimePeriod(logChartVue, toDatetimeUnixTime) {
      var jumpToDate = this.roundTimestamp(logChartVue, toDatetimeUnixTime);
      // console.log(new Date(jumpToDate * 1000))
      var rangeOffsets = this.getRangePeriodOffsets(logChartVue);
      var range = {
        start: jumpToDate - logChartVue.periodTime * rangeOffsets.toStart,
        end: jumpToDate + logChartVue.periodTime * rangeOffsets.toEnd
        // 現在時刻
      };var now = Math.floor(Date.now() / 1000);
      now = now - now % (15 * 60);
      var rangeEnd = now - now % logChartVue.periodTime;
      // ジャンプ日時が最新の範囲に収まらない場合は中心を右にずらす
      if (jumpToDate > rangeEnd - logChartVue.periodTime * rangeOffsets.toEnd) {
        var offset = jumpToDate - (rangeEnd - logChartVue.periodTime * rangeOffsets.toEnd);
        range.start -= offset;
        range.end -= offset;
      } else {
        // ジャンプ日時が最古の範囲に収まらない場合は中心を左にずらす
        // 現在時刻
        var createdDateTime = logChartVue.createdDateTime - logChartVue.createdDateTime % logChartVue.periodTime;
        if (jumpToDate < createdDateTime + logChartVue.periodTime * rangeOffsets.toStart) {
          var _offset = createdDateTime + logChartVue.periodTime * rangeOffsets.toStart - jumpToDate;
          range.start += _offset;
          range.end += _offset;
        }
      }
      return range;
    }
  }, {
    key: 'setMessagePeriodJump',
    value: function setMessagePeriodJump(logChartVue, datazoomRange) {
      var jumpToDate = this.roundTimestamp(logChartVue, logChartVue.toDatetimeUnixTime);
      // console.log(new Date(jumpToDate * 1000))
      logChartVue.messagePeriodJump = '';
      // レンジバーを変更した場合はメッセージ表示はしない
      if (logChartVue.isChangedRangeBar) {
        logChartVue.isChangedPeriod = false;
        logChartVue.isChangedRangeBar = false;
        return;
      }
      // ジャンプ日時が最新の範囲に収まらない場合
      var rangeOffsets = this.getRangePeriodOffsets(logChartVue);
      if (jumpToDate > datazoomRange.end - logChartVue.periodTime * rangeOffsets.toEnd) {
        if (jumpToDate > datazoomRange.end) {
          // 日時が範囲外
          logChartVue.messagePeriodJump = logChartVue.$t('chart.message-outbounds-latest');
        } else if (jumpToDate < datazoomRange.end) {
          // 日時が最新6プロット分
          logChartVue.messagePeriodJump = logChartVue.$t('chart.message-latest');
        }
      } else {
        // ジャンプ日時が最古の範囲に収まらない場合
        // 現在時刻
        if (jumpToDate < datazoomRange.start + logChartVue.periodTime * rangeOffsets.toStart) {
          if (jumpToDate < datazoomRange.start) {
            // 日時が範囲外
            logChartVue.messagePeriodJump = logChartVue.$t('chart.message-outbounds-oldest');
          } else {
            // 日時が最新6プロット分
            logChartVue.messagePeriodJump = logChartVue.$t('chart.message-oldest');
          }
        }
      }
      if (logChartVue.isChangedPeriod && logChartVue.messagePeriodJump) {
        logChartVue.showPeriodMessagePeriodJump = true;
        setTimeout(function () {
          logChartVue.showPeriodMessagePeriodJump = false;
        }, 5000);
      } else if (logChartVue.messagePeriodJump) {
        logChartVue.showJumpMessagePeriodJump = true;
        setTimeout(function () {
          logChartVue.showJumpMessagePeriodJump = false;
        }, 5000);
      }
      logChartVue.isChangedPeriod = false;
    }
  }, {
    key: 'resetDataZoomToolBox',
    value: function resetDataZoomToolBox(logChartVue) {
      if (logChartVue.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        var ecToolBox = logChartVue.myChart.getModel()._componentsMap._ec_toolbox;
        var ecToolBoxModel = ecToolBox[0].ecModel;
        // ズーム履歴を全部戻す
        while (ecToolBoxModel['\0_ec_hist_store'].length > 1) {
          logChartVue.myChart._api.dispatchAction({
            type: 'datazoom',
            batch: ecToolBoxModel['\0_ec_hist_store'].pop()
          });
        }
        // データリストアも行っておく
        logChartVue.myChart._api.dispatchAction({
          type: 'restore'
        });
        // console.log(ecToolBoxModel)
      }
    }
    // 先頭と末尾のデータ補正のための描画範囲内、描画範囲外のプロット位置の取得

  }, {
    key: 'retrieveFillPlotsRangeDatasets',
    value: function retrieveFillPlotsRangeDatasets(logChartVue, option, seriesIndex) {
      // 退避したデータを戻す
      option.xAxis.data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logChartVue.xAxisDatas));
      option.series = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logChartVue.seriesDatas));
      var viewRangeStartIndex = option.xAxis.data.indexOf(Number(option.dataZoom[0].startValue));
      var viewRangeEndIndex = option.xAxis.data.indexOf(Number(option.dataZoom[0].endValue));
      // 1プロットまでズームした日時が、データがない場合は線を描画させるために1プロット分増やして表示する
      if (logChartVue.isChangeRangeBarWidth && viewRangeEndIndex - viewRangeStartIndex === 0 && option.series[0].data[viewRangeStartIndex] === null) {
        // 新しいデータがある場合は新しい方へ広げる
        if (viewRangeEndIndex < option.xAxis.data.length - 1) {
          viewRangeEndIndex++;
        } else if (viewRangeStartIndex > 0) {
          viewRangeStartIndex--;
        }
        logChartVue.range = {
          start: option.xAxis.data[viewRangeStartIndex],
          end: option.xAxis.data[viewRangeEndIndex]
        };
        option.dataZoom[0].startValue = option.xAxis.data[viewRangeStartIndex].toString();
        option.dataZoom[0].endValue = option.xAxis.data[viewRangeEndIndex].toString();
      }
      var rangeDatasets = {
        outOfFrom: { // Fromの範囲外
          timestamp: logChartVue.outOfFromTimestamp,
          seriesData: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logChartVue.outOfFromSeriesData))
        },
        outOfViewRangeStart: { // 描画範囲のStartの範囲外
          timestamp: null,
          seriesData: []
        },
        oldestViewRange: { // 描画範囲内の最古
          timestamp: null,
          seriesData: []
        },
        latestViewRange: { // 描画範囲内の最新
          timestamp: null,
          seriesData: []
        },
        outOfViewRangeEnd: { // 描画範囲のEndの範囲外
          timestamp: null,
          seriesData: []
        },
        outOfTo: { // toの範囲外
          timestamp: logChartVue.outOfToTimestamp,
          seriesData: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(logChartVue.outOfToSeriesData))
        }

        // 描画範囲より古いデータのうち、最新のデータ決定
      };
      var _loop = function _loop(dataIndex) {
        if (option.series[seriesIndex].data[dataIndex] !== null) {
          rangeDatasets.outOfViewRangeStart.timestamp = option.xAxis.data[dataIndex];
          option.series.forEach(function (one, index) {
            rangeDatasets.outOfViewRangeStart.seriesData[index] = option.series[index].data[dataIndex];
          });
          return 'break';
        }
      };

      for (var dataIndex = viewRangeStartIndex - 1; dataIndex >= 0; dataIndex--) {
        var _ret = _loop(dataIndex);

        if (_ret === 'break') break;
      }
      // 描画範囲内の最古のデータ決定

      var _loop2 = function _loop2(dataIndex) {
        if (option.series[seriesIndex].data[dataIndex] !== null) {
          rangeDatasets.oldestViewRange.timestamp = option.xAxis.data[dataIndex];
          option.series.forEach(function (one, index) {
            rangeDatasets.oldestViewRange.seriesData[index] = option.series[index].data[dataIndex];
          });
          return 'break';
        }
      };

      for (var dataIndex = viewRangeStartIndex; dataIndex <= viewRangeEndIndex; dataIndex++) {
        var _ret2 = _loop2(dataIndex);

        if (_ret2 === 'break') break;
      }
      // 描画範囲内の最新のデータ決定

      var _loop3 = function _loop3(dataIndex) {
        if (option.series[seriesIndex].data[dataIndex] !== null) {
          rangeDatasets.latestViewRange.timestamp = option.xAxis.data[dataIndex];
          option.series.forEach(function (one, index) {
            rangeDatasets.latestViewRange.seriesData[index] = option.series[index].data[dataIndex];
          });
          return 'break';
        }
      };

      for (var dataIndex = viewRangeEndIndex; dataIndex >= viewRangeStartIndex; dataIndex--) {
        var _ret3 = _loop3(dataIndex);

        if (_ret3 === 'break') break;
      }
      // 描画範囲より新しいデータのうち、最古のデータ決定

      var _loop4 = function _loop4(dataIndex) {
        if (option.series[seriesIndex].data[dataIndex] !== null) {
          rangeDatasets.outOfViewRangeEnd.timestamp = option.xAxis.data[dataIndex];
          option.series.forEach(function (one, index) {
            rangeDatasets.outOfViewRangeEnd.seriesData[index] = option.series[index].data[dataIndex];
          });
          return 'break';
        }
      };

      for (var dataIndex = viewRangeEndIndex + 1; dataIndex < option.xAxis.data.length; dataIndex++) {
        var _ret4 = _loop4(dataIndex);

        if (_ret4 === 'break') break;
      }
      // 描画範囲外データの決定
      // * 描画範囲のStartの前のデータ
      // ** fromより前のデータがあって、描画範囲のStartの前がなければ、fromより前のデータを利用
      if (rangeDatasets.outOfFrom.timestamp !== null && rangeDatasets.outOfViewRangeStart.timestamp === null) {
        rangeDatasets.outOfViewRangeStart = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfFrom));
      }
      // * 描画範囲のEndの後のデータ
      // ** toより後のデータがあって、描画範囲のToの後があれば、toより後のデータを利用
      if (rangeDatasets.outOfTo.timestamp !== null && rangeDatasets.outOfViewRangeEnd.timestamp === null) {
        rangeDatasets.outOfViewRangeEnd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfTo));
      }
      // 最終更新日時(現在時刻から算出)
      var rangeLast = this.roundTimestamp(logChartVue, Math.floor(new Date().getTime() / 1000));
      // 描画範囲のEndの後のデータ、描画範囲内のデータがなく、描画範囲のStartの前のデータがある場合は、
      // 描画範囲のStartの前のデータを描画範囲のEndの後のデータとして利用
      // ただし、タイムスタンプは現在時刻から算出した値を利用
      if (rangeDatasets.oldestViewRange.timestamp === null && rangeDatasets.latestViewRange.timestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        rangeDatasets.outOfViewRangeEnd.timestamp = rangeLast;
        rangeDatasets.outOfViewRangeEnd.seriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeStart.seriesData));
      }
      // 描画範囲のEndの後のデータがなく描画範囲内の最新のデータがある場合は
      // 描画範囲内の最新のデータを描画範囲のEndの後のデータとして利用
      // ただし、タイムスタンプは現在時刻から算出した値を利用
      if (rangeDatasets.outOfViewRangeEnd.timestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
        rangeDatasets.outOfViewRangeEnd.timestamp = rangeLast;
        rangeDatasets.outOfViewRangeEnd.seriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
      }

      // console.log(rangeDatasets)
      return { option: option, rangeDatasets: rangeDatasets, viewRangeStartIndex: viewRangeStartIndex, viewRangeEndIndex: viewRangeEndIndex };
    }
  }]);

  return GraphHelper;
}();

var graphHelper = new GraphHelper();
/* harmony default export */ __webpack_exports__["a"] = (graphHelper);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1111), __esModule: true };

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(72).f;
var has = __webpack_require__(89);
var TAG = __webpack_require__(41)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(229);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1141)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(393)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(50);
var toLength = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(100);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(44);
var redefineAll = __webpack_require__(98);
var meta = __webpack_require__(83);
var forOf = __webpack_require__(92);
var anInstance = __webpack_require__(91);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var $iterDetect = __webpack_require__(178);
var setToStringTag = __webpack_require__(113);
var inheritIfRequired = __webpack_require__(250);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(43);
var redefine = __webpack_require__(44);
var fails = __webpack_require__(12);
var defined = __webpack_require__(62);
var wks = __webpack_require__(20);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(55);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(13);
var cof = __webpack_require__(55);
var MATCH = __webpack_require__(20)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(93) || !__webpack_require__(12)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(11)[K];
});


/***/ }),
/* 180 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(37);
var ctx = __webpack_require__(56);
var forOf = __webpack_require__(92);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(37);
var SPECIES = __webpack_require__(20)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(43);
var uid = __webpack_require__(101);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var _echarts = __webpack_require__(4);

(function () {
  for (var key in _echarts) {
    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _echarts[key];
  }
})();

var _export = __webpack_require__(487);

(function () {
  for (var key in _export) {
    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
    exports[key] = _export[key];
  }
})();

__webpack_require__(1419);

__webpack_require__(1367);

__webpack_require__(1440);

__webpack_require__(1455);

__webpack_require__(1445);

__webpack_require__(1428);

__webpack_require__(1463);

__webpack_require__(1470);

__webpack_require__(1396);

__webpack_require__(1392);

__webpack_require__(1388);

__webpack_require__(1435);

__webpack_require__(1450);

__webpack_require__(1373);

__webpack_require__(1378);

__webpack_require__(1385);

__webpack_require__(1423);

__webpack_require__(1409);

__webpack_require__(1439);

__webpack_require__(1458);

__webpack_require__(1384);

__webpack_require__(1511);

__webpack_require__(1512);

__webpack_require__(1519);

__webpack_require__(1553);

__webpack_require__(141);

__webpack_require__(1530);

__webpack_require__(1509);

__webpack_require__(470);

__webpack_require__(471);

__webpack_require__(1490);

__webpack_require__(1497);

__webpack_require__(1543);

__webpack_require__(1499);

__webpack_require__(1557);

__webpack_require__(1522);

__webpack_require__(1521);

__webpack_require__(1520);

__webpack_require__(1534);

__webpack_require__(1544);

__webpack_require__(1999);

__webpack_require__(1994);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(5);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

var _labelHelper = __webpack_require__(449);

var findLabelValueDim = _labelHelper.findLabelValueDim;

/**
 * @module echarts/chart/helper/Symbol
 */
function getSymbolSize(data, idx) {
  var symbolSize = data.getItemVisual(idx, 'symbolSize');
  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
}

function getScale(symbolSize) {
  return [symbolSize[0] / 2, symbolSize[1] / 2];
}
/**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */


function SymbolClz(data, idx, seriesScope) {
  graphic.Group.call(this);
  this.updateData(data, idx, seriesScope);
}

var symbolProto = SymbolClz.prototype;

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

symbolProto._createSymbol = function (symbolType, data, idx, symbolSize) {
  // Remove paths created before
  this.removeAll();
  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
  //     symbolType, -0.5, -0.5, 1, 1, color
  // );
  // If width/height are set too small (e.g., set to 1) on ios10
  // and macOS Sierra, a circle stroke become a rect, no matter what
  // the scale is set. So we set width/height as 2. See #4150.

  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color);
  symbolPath.attr({
    z2: 100,
    culling: true,
    scale: getScale(symbolSize)
  }); // Rewrite drift method

  symbolPath.drift = driftSymbol;
  this._symbolType = symbolType;
  this.add(symbolPath);
};
/**
 * Stop animation
 * @param {boolean} toLastFrame
 */


symbolProto.stopSymbolAnimation = function (toLastFrame) {
  this.childAt(0).stopAnimation(toLastFrame);
};
/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */


symbolProto.getSymbolPath = function () {
  return this.childAt(0);
};
/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */


symbolProto.getScale = function () {
  return this.childAt(0).scale;
};
/**
 * Highlight symbol
 */


symbolProto.highlight = function () {
  this.childAt(0).trigger('emphasis');
};
/**
 * Downplay symbol
 */


symbolProto.downplay = function () {
  this.childAt(0).trigger('normal');
};
/**
 * @param {number} zlevel
 * @param {number} z
 */


symbolProto.setZ = function (zlevel, z) {
  var symbolPath = this.childAt(0);
  symbolPath.zlevel = zlevel;
  symbolPath.z = z;
};

symbolProto.setDraggable = function (draggable) {
  var symbolPath = this.childAt(0);
  symbolPath.draggable = draggable;
  symbolPath.cursor = draggable ? 'move' : 'pointer';
};
/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */


symbolProto.updateData = function (data, idx, seriesScope) {
  this.silent = false;
  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
  var seriesModel = data.hostModel;
  var symbolSize = getSymbolSize(data, idx);
  var isInit = symbolType !== this._symbolType;

  if (isInit) {
    this._createSymbol(symbolType, data, idx, symbolSize);
  } else {
    var symbolPath = this.childAt(0);
    symbolPath.silent = false;
    graphic.updateProps(symbolPath, {
      scale: getScale(symbolSize)
    }, seriesModel, idx);
  }

  this._updateCommon(data, idx, symbolSize, seriesScope);

  if (isInit) {
    var symbolPath = this.childAt(0);
    var fadeIn = seriesScope && seriesScope.fadeIn;
    var target = {
      scale: symbolPath.scale.slice()
    };
    fadeIn && (target.style = {
      opacity: symbolPath.style.opacity
    });
    symbolPath.scale = [0, 0];
    fadeIn && (symbolPath.style.opacity = 0);
    graphic.initProps(symbolPath, target, seriesModel, idx);
  }

  this._seriesModel = seriesModel;
}; // Update common properties


var normalStyleAccessPath = ['itemStyle', 'normal'];
var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];
var normalLabelAccessPath = ['label', 'normal'];
var emphasisLabelAccessPath = ['label', 'emphasis'];
/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */

symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
  var symbolPath = this.childAt(0);
  var seriesModel = data.hostModel;
  var color = data.getItemVisual(idx, 'color'); // Reset style

  if (symbolPath.type !== 'image') {
    symbolPath.useStyle({
      strokeNoScale: true
    });
  }

  var itemStyle = seriesScope && seriesScope.itemStyle;
  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
  var symbolRotate = seriesScope && seriesScope.symbolRotate;
  var symbolOffset = seriesScope && seriesScope.symbolOffset;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
  var cursorStyle = seriesScope && seriesScope.cursorStyle;

  if (!seriesScope || data.hasItemOption) {
    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke

    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
    symbolRotate = itemModel.getShallow('symbolRotate');
    symbolOffset = itemModel.getShallow('symbolOffset');
    labelModel = itemModel.getModel(normalLabelAccessPath);
    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
    hoverAnimation = itemModel.getShallow('hoverAnimation');
    cursorStyle = itemModel.getShallow('cursor');
  } else {
    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
  }

  var elStyle = symbolPath.style;
  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);

  if (symbolOffset) {
    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
  }

  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!

  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
  symbolPath.setStyle(itemStyle);
  var opacity = data.getItemVisual(idx, 'opacity');

  if (opacity != null) {
    elStyle.opacity = opacity;
  }

  var useNameLabel = seriesScope && seriesScope.useNameLabel;
  var valueDim = !useNameLabel && findLabelValueDim(data);

  if (useNameLabel || valueDim != null) {
    graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
      labelFetcher: seriesModel,
      labelDataIndex: idx,
      defaultText: useNameLabel ? data.getName(idx) : data.get(valueDim, idx),
      isRectText: true,
      autoColor: color
    });
  }

  symbolPath.off('mouseover').off('mouseout').off('emphasis').off('normal');
  symbolPath.hoverStyle = hoverItemStyle; // FIXME
  // Do not use symbol.trigger('emphasis'), but use symbol.highlight() instead.

  graphic.setHoverStyle(symbolPath);
  var scale = getScale(symbolSize);

  if (hoverAnimation && seriesModel.isAnimationEnabled()) {
    var onEmphasis = function () {
      var ratio = scale[1] / scale[0];
      this.animateTo({
        scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
      }, 400, 'elasticOut');
    };

    var onNormal = function () {
      this.animateTo({
        scale: scale
      }, 400, 'elasticOut');
    };

    symbolPath.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
  }
};
/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */


symbolProto.fadeOut = function (cb, opt) {
  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out

  this.silent = symbolPath.silent = true; // Not show text when animating

  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
  graphic.updateProps(symbolPath, {
    style: {
      opacity: 0
    },
    scale: [0, 0]
  }, this._seriesModel, this.dataIndex, cb);
};

zrUtil.inherits(SymbolClz, graphic.Group);
var _default = SymbolClz;
module.exports = _default;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var List = __webpack_require__(31);

var completeDimensions = __webpack_require__(58);

var WhiskerBoxDraw = __webpack_require__(1418);

var zrUtil = __webpack_require__(0);

var seriesModelMixin = {
  /**
   * @private
   * @type {string}
   */
  _baseAxisDim: null,

  /**
   * @override
   */
  getInitialData: function (option, ecModel) {
    // When both types of xAxis and yAxis are 'value', layout is
    // needed to be specified by user. Otherwise, layout can be
    // judged by which axis is category.
    var categories;
    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var addOrdinal; // FIXME
    // 考虑时间轴

    if (xAxisType === 'category') {
      option.layout = 'horizontal';
      categories = xAxisModel.getCategories();
      addOrdinal = true;
    } else if (yAxisType === 'category') {
      option.layout = 'vertical';
      categories = yAxisModel.getCategories();
      addOrdinal = true;
    } else {
      option.layout = option.layout || 'horizontal';
    }

    var coordDims = ['x', 'y'];
    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
    var data = option.data;
    addOrdinal && zrUtil.each(data, function (item, index) {
      if (item.value && zrUtil.isArray(item.value)) {
        item.value.unshift(index);
      } else {
        zrUtil.isArray(item) && item.unshift(index);
      }
    });
    var defaultValueDimensions = this.defaultValueDimensions;
    var dimensions = [{
      name: baseAxisDim,
      otherDims: {
        tooltip: false
      },
      dimsDef: ['base']
    }, {
      name: otherAxisDim,
      dimsDef: defaultValueDimensions.slice()
    }];
    dimensions = completeDimensions(dimensions, data, {
      encodeDef: this.get('encode'),
      dimsDef: this.get('dimensions'),
      // Consider empty data entry.
      dimCount: defaultValueDimensions.length + 1
    });
    var list = new List(dimensions, this);
    list.initData(data, categories ? categories.slice() : null);
    return list;
  },

  /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */
  getBaseAxis: function () {
    var dim = this._baseAxisDim;
    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
  }
};
var viewMixin = {
  init: function () {
    /**
     * Old data.
     * @private
     * @type {module:echarts/chart/helper/WhiskerBoxDraw}
     */
    var whiskerBoxDraw = this._whiskerBoxDraw = new WhiskerBoxDraw(this.getStyleUpdater());
    this.group.add(whiskerBoxDraw.group);
  },
  render: function (seriesModel, ecModel, api) {
    this._whiskerBoxDraw.updateData(seriesModel.getData());
  },
  remove: function (ecModel) {
    this._whiskerBoxDraw.remove();
  }
};
exports.seriesModelMixin = seriesModelMixin;
exports.viewMixin = viewMixin;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Model = __webpack_require__(29);

var each = zrUtil.each;
var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  each(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));

      if (triggerAxis || cross) {
        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var key = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[key] = {
        key: key,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: []
      };
      axesInfoInCoordSys[key] = axisInfo;
      result.seriesInvolved |= involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[key] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var volatileOption = {};
  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    labelOption.show = true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
    var seriesTooltipShow = seriesModel.get('tooltip.show', true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
      return;
    }

    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  }, this);
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}

function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}

function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get('handle.show');
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

exports.collect = collect;
exports.fixValue = fixValue;
exports.getAxisInfo = getAxisInfo;
exports.getAxisPointerModel = getAxisPointerModel;
exports.makeKey = makeKey;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var textContain = __webpack_require__(70);

var formatUtil = __webpack_require__(21);

var matrix = __webpack_require__(53);

var axisHelper = __webpack_require__(51);

var AxisBuilder = __webpack_require__(102);

/**
 * @param {module:echarts/model/Model} axisPointerModel
 */
function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */


function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get('label.precision'),
    formatter: axisPointerModel.get('label.formatter')
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = textContain.getBoundingRect(text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get('axisLine.lineStyle.color');
  }

  elOption.label = {
    shape: {
      x: 0,
      y: 0,
      width: width,
      height: height,
      r: labelModel.get('borderRadius')
    },
    position: position.slice(),
    // TODO: rich
    style: {
      text: text,
      textFont: font,
      textFill: labelModel.getTextColor(),
      textPosition: 'inside',
      fill: bgColor,
      stroke: labelModel.get('borderColor') || 'transparent',
      lineWidth: labelModel.get('borderWidth') || 0,
      shadowBlur: labelModel.get('shadowBlur'),
      shadowColor: labelModel.get('shadowColor'),
      shadowOffsetX: labelModel.get('shadowOffsetX'),
      shadowOffsetY: labelModel.get('shadowOffsetY')
    },
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container


function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}
/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */


function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
  // helps to debounce when when moving label.
  value, {
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params = {
      value: axisHelper.getAxisRawValue(axis, value),
      seriesData: []
    };
    zrUtil.each(seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params.seriesData.push(dataParams);
    });

    if (zrUtil.isString(formatter)) {
      text = formatter.replace('{value}', text);
    } else if (zrUtil.isFunction(formatter)) {
      text = formatter(params);
    }
  }

  return text;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */


function getTransformedPosition(axis, value, layoutInfo) {
  var transform = matrix.create();
  matrix.rotate(transform, transform, layoutInfo.rotation);
  matrix.translate(transform, transform, layoutInfo.position);
  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}

function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */


function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */


function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}

function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

exports.buildElStyle = buildElStyle;
exports.buildLabelElOption = buildLabelElOption;
exports.getValueLabel = getValueLabel;
exports.getTransformedPosition = getTransformedPosition;
exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
exports.makeLineShape = makeLineShape;
exports.makeRectShape = makeRectShape;
exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Eventful = __webpack_require__(108);

var eventTool = __webpack_require__(77);

var interactionMutex = __webpack_require__(465);

/**
 * @alias module:echarts/component/helper/RoamController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 *
 * @param {module:zrender/zrender~ZRender} zr
 */
function RoamController(zr) {
  /**
   * @type {Function}
   */
  this.pointerChecker;
  /**
   * @type {module:zrender}
   */

  this._zr = zr;
  /**
   * @type {Object}
   */

  this._opt = {}; // Avoid two roamController bind the same handler

  var bind = zrUtil.bind;
  var mousedownHandler = bind(mousedown, this);
  var mousemoveHandler = bind(mousemove, this);
  var mouseupHandler = bind(mouseup, this);
  var mousewheelHandler = bind(mousewheel, this);
  var pinchHandler = bind(pinch, this);
  Eventful.call(this);
  /**
   * @param {Function} pointerChecker
   *                   input: x, y
   *                   output: boolean
   */

  this.setPointerChecker = function (pointerChecker) {
    this.pointerChecker = pointerChecker;
  };
  /**
   * Notice: only enable needed types. For example, if 'zoom'
   * is not needed, 'zoom' should not be enabled, otherwise
   * default mousewheel behaviour (scroll page) will be disabled.
   *
   * @param  {boolean|string} [controlType=true] Specify the control type,
   *                          which can be null/undefined or true/false
   *                          or 'pan/move' or 'zoom'/'scale'
   * @param {Object} [opt]
   * @param {Object} [opt.zoomOnMouseWheel=true]
   * @param {Object} [opt.moveOnMouseMove=true]
   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
   */


  this.enable = function (controlType, opt) {
    // Disable previous first
    this.disable();
    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      preventDefaultMouseMove: true
    });

    if (controlType == null) {
      controlType = true;
    }

    if (controlType === true || controlType === 'move' || controlType === 'pan') {
      zr.on('mousedown', mousedownHandler);
      zr.on('mousemove', mousemoveHandler);
      zr.on('mouseup', mouseupHandler);
    }

    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
      zr.on('mousewheel', mousewheelHandler);
      zr.on('pinch', pinchHandler);
    }
  };

  this.disable = function () {
    zr.off('mousedown', mousedownHandler);
    zr.off('mousemove', mousemoveHandler);
    zr.off('mouseup', mouseupHandler);
    zr.off('mousewheel', mousewheelHandler);
    zr.off('pinch', pinchHandler);
  };

  this.dispose = this.disable;

  this.isDragging = function () {
    return this._dragging;
  };

  this.isPinching = function () {
    return this._pinching;
  };
}

zrUtil.mixin(RoamController, Eventful);

function mousedown(e) {
  if (eventTool.notLeftMouse(e) || e.target && e.target.draggable) {
    return;
  }

  var x = e.offsetX;
  var y = e.offsetY; // Only check on mosedown, but not mousemove.
  // Mouse can be out of target when mouse moving.

  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
    this._x = x;
    this._y = y;
    this._dragging = true;
  }
}

function mousemove(e) {
  if (eventTool.notLeftMouse(e) || !checkKeyBinding(this, 'moveOnMouseMove', e) || !this._dragging || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
    return;
  }

  var x = e.offsetX;
  var y = e.offsetY;
  var oldX = this._x;
  var oldY = this._y;
  var dx = x - oldX;
  var dy = y - oldY;
  this._x = x;
  this._y = y;
  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
  this.trigger('pan', dx, dy, oldX, oldY, x, y);
}

function mouseup(e) {
  if (!eventTool.notLeftMouse(e)) {
    this._dragging = false;
  }
}

function mousewheel(e) {
  // wheelDelta maybe -0 in chrome mac.
  if (!checkKeyBinding(this, 'zoomOnMouseWheel', e) || e.wheelDelta === 0) {
    return;
  } // Convenience:
  // Mac and VM Windows on Mac: scroll up: zoom out.
  // Windows: scroll up: zoom in.


  var zoomDelta = e.wheelDelta > 0 ? 1.1 : 1 / 1.1;
  zoom.call(this, e, zoomDelta, e.offsetX, e.offsetY);
}

function pinch(e) {
  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
    return;
  }

  var zoomDelta = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
  zoom.call(this, e, zoomDelta, e.pinchX, e.pinchY);
}

function zoom(e, zoomDelta, zoomX, zoomY) {
  if (this.pointerChecker && this.pointerChecker(e, zoomX, zoomY)) {
    // When mouse is out of roamController rect,
    // default befavoius should not be be disabled, otherwise
    // page sliding is disabled, contrary to expectation.
    eventTool.stop(e.event);
    this.trigger('zoom', zoomDelta, zoomX, zoomY);
  }
}

function checkKeyBinding(roamController, prop, e) {
  var setting = roamController._opt[prop];
  return setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
}

var _default = RoamController;
module.exports = _default;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var axisDefault = __webpack_require__(480);

var ComponentModel = __webpack_require__(32);

var _layout = __webpack_require__(17);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;
// FIXME axisType is fixed ?
var AXIS_TYPES = ['value', 'category', 'time', 'log'];
/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */

function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
  zrUtil.each(AXIS_TYPES, function (axisType) {
    BaseAxisModelClass.extend({
      type: axisName + 'Axis.' + axisType,
      mergeDefaultAndTheme: function (option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
        zrUtil.merge(option, this.getDefaultOption());
        option.type = axisTypeDefaulter(axisName, option);

        if (layoutMode) {
          mergeLayoutParam(option, inputPositionParams, layoutMode);
        }
      },
      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
    });
  });
  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
}

module.exports = _default;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var Geo = __webpack_require__(1572);

var layout = __webpack_require__(17);

var numberUtil = __webpack_require__(8);

/**
 * Resize method bound to the geo
 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
 * @param {module:echarts/ExtensionAPI} api
 */
function resizeGeo(geoModel, api) {
  var boundingCoords = geoModel.get('boundingCoords');

  if (boundingCoords != null) {
    var leftTop = boundingCoords[0];
    var rightBottom = boundingCoords[1];

    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
    }
  }

  var rect = this.getBoundingRect();
  var boxLayoutOption;
  var center = geoModel.get('layoutCenter');
  var size = geoModel.get('layoutSize');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var aspectScale = geoModel.get('aspectScale') || 0.75;
  var aspect = rect.width / rect.height * aspectScale;
  var useCenterAndSize = false;

  if (center && size) {
    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));

    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
      useCenterAndSize = true;
    } else {}
  }

  var viewRect;

  if (useCenterAndSize) {
    var viewRect = {};

    if (aspect > 1) {
      // Width is same with size
      viewRect.width = size;
      viewRect.height = size / aspect;
    } else {
      viewRect.height = size;
      viewRect.width = size * aspect;
    }

    viewRect.y = center[1] - viewRect.height / 2;
    viewRect.x = center[0] - viewRect.width / 2;
  } else {
    // Use left/top/width/height
    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate

    boxLayoutOption.aspect = aspect;
    viewRect = layout.getLayoutRect(boxLayoutOption, {
      width: viewWidth,
      height: viewHeight
    });
  }

  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
  this.setCenter(geoModel.get('center'));
  this.setZoom(geoModel.get('zoom'));
}
/**
 * @param {module:echarts/coord/Geo} geo
 * @param {module:echarts/model/Model} model
 * @inner
 */


function setGeoCoords(geo, model) {
  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
    geo.addGeoCoord(name, geoCoord);
  });
}

var geoCreator = {
  // For deciding which dimensions to use when creating list data
  dimensions: Geo.prototype.dimensions,
  create: function (ecModel, api) {
    var geoList = []; // FIXME Create each time may be slow

    ecModel.eachComponent('geo', function (geoModel, idx) {
      var name = geoModel.get('map');
      var mapData = echarts.getMap(name);
      var geo = new Geo(name + idx, name, mapData && mapData.geoJson, mapData && mapData.specialAreas, geoModel.get('nameMap'));
      geo.zoomLimit = geoModel.get('scaleLimit');
      geoList.push(geo);
      setGeoCoords(geo, geoModel);
      geoModel.coordinateSystem = geo;
      geo.model = geoModel; // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(geoModel, api);
    });
    ecModel.eachSeries(function (seriesModel) {
      var coordSys = seriesModel.get('coordinateSystem');

      if (coordSys === 'geo') {
        var geoIndex = seriesModel.get('geoIndex') || 0;
        seriesModel.coordinateSystem = geoList[geoIndex];
      }
    }); // If has map series

    var mapModelGroupBySeries = {};
    ecModel.eachSeriesByType('map', function (seriesModel) {
      if (!seriesModel.getHostGeoModel()) {
        var mapType = seriesModel.getMapType();
        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
        mapModelGroupBySeries[mapType].push(seriesModel);
      }
    });
    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
      var mapData = echarts.getMap(mapType);
      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('nameMap');
      });
      var geo = new Geo(mapType, mapType, mapData && mapData.geoJson, mapData && mapData.specialAreas, zrUtil.mergeAll(nameMapList));
      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('scaleLimit');
      }));
      geoList.push(geo); // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(mapSeries[0], api);
      zrUtil.each(mapSeries, function (singleMapSeries) {
        singleMapSeries.coordinateSystem = geo;
        setGeoCoords(geo, singleMapSeries);
      });
    });
    return geoList;
  },

  /**
   * Fill given regions array
   * @param  {Array.<Object>} originRegionArr
   * @param  {string} mapName
   * @param  {Object} [nameMap]
   * @return {Array}
   */
  getFilledRegions: function (originRegionArr, mapName, nameMap) {
    // Not use the original
    var regionsArr = (originRegionArr || []).slice();
    nameMap = nameMap || {};
    var map = echarts.getMap(mapName);
    var geoJson = map && map.geoJson;

    if (!geoJson) {
      return originRegionArr;
    }

    var dataNameMap = zrUtil.createHashMap();
    var features = geoJson.features;

    for (var i = 0; i < regionsArr.length; i++) {
      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
    }

    for (var i = 0; i < features.length; i++) {
      var name = features[i].properties.name;

      if (!dataNameMap.get(name)) {
        if (nameMap.hasOwnProperty(name)) {
          name = nameMap[name];
        }

        regionsArr.push({
          name: name
        });
      }
    }

    return regionsArr;
  }
};
echarts.registerCoordinateSystem('geo', geoCreator);
var _default = geoCreator;
module.exports = _default;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

function _default(seriesType, ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType(seriesType, function (series) {
    var data = series.getData();
    data.filterSelf(function (idx) {
      var name = data.getName(idx); // If in any legend component the status is not selected.

      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(name)) {
          return false;
        }
      }

      return true;
    }, this);
  }, this);
}

module.exports = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var numberUtil = __webpack_require__(8);

var formatUtil = __webpack_require__(21);

var Scale = __webpack_require__(196);

var helper = __webpack_require__(489);

/**
 * Interval scale
 * @module echarts/scale/Interval
 */
var roundNumber = numberUtil.round;
/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */

var IntervalScale = Scale.extend({
  type: 'interval',
  _interval: 0,
  _intervalPrecision: 2,
  setExtent: function (start, end) {
    var thisExtent = this._extent; //start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  },
  unionExtent: function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
  },

  /**
   * Get interval
   */
  getInterval: function () {
    return this._interval;
  },

  /**
   * Set interval
   */
  setInterval: function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
    // We assume user wan't to set both interval, min, max to get a better result

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = helper.getIntervalPrecision(interval);
  },

  /**
   * @return {Array.<number>}
   */
  getTicks: function () {
    return helper.intervalScaleGetTicks(this._interval, this._extent, this._niceExtent, this._intervalPrecision);
  },

  /**
   * @return {Array.<string>}
   */
  getTicksLabels: function () {
    var labels = [];
    var ticks = this.getTicks();

    for (var i = 0; i < ticks.length; i++) {
      labels.push(this.getLabel(ticks[i]));
    }

    return labels;
  },

  /**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */
  getLabel: function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = numberUtil.getPrecisionSafe(data) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    data = roundNumber(data, precision, true);
    return formatUtil.addCommas(data);
  },

  /**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */
  niceTicks: function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  },

  /**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        var expandSize = extent[0]; // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  }
});
/**
 * @return {module:echarts/scale/Time}
 */

IntervalScale.create = function () {
  return new IntervalScale();
};

var _default = IntervalScale;
module.exports = _default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var clazzUtil = __webpack_require__(75);

/**
 * // Scale class management
 * @module echarts/scale/Scale
 */

/**
 * @param {Object} [setting]
 */
function Scale(setting) {
  this._setting = setting || {};
  /**
   * Extent
   * @type {Array.<number>}
   * @protected
   */

  this._extent = [Infinity, -Infinity];
  /**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */

  this._interval = 0;
  this.init && this.init.apply(this, arguments);
}
/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */


Scale.prototype.parse = function (val) {
  // Notice: This would be a trap here, If the implementation
  // of this method depends on extent, and this method is used
  // before extent set (like in dataZoom), it would be wrong.
  // Nevertheless, parse does not depend on extent generally.
  return val;
};

Scale.prototype.getSetting = function (name) {
  return this._setting[name];
};

Scale.prototype.contain = function (val) {
  var extent = this._extent;
  return val >= extent[0] && val <= extent[1];
};
/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */


Scale.prototype.normalize = function (val) {
  var extent = this._extent;

  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
};
/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */


Scale.prototype.scale = function (val) {
  var extent = this._extent;
  return val * (extent[1] - extent[0]) + extent[0];
};
/**
 * Set extent from data
 * @param {Array.<number>} other
 */


Scale.prototype.unionExtent = function (other) {
  var extent = this._extent;
  other[0] < extent[0] && (extent[0] = other[0]);
  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
  // this.setExtent(extent[0], extent[1]);
};
/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */


Scale.prototype.unionExtentFromData = function (data, dim) {
  this.unionExtent(data.getDataExtent(dim, true));
};
/**
 * Get extent
 * @return {Array.<number>}
 */


Scale.prototype.getExtent = function () {
  return this._extent.slice();
};
/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */


Scale.prototype.setExtent = function (start, end) {
  var thisExtent = this._extent;

  if (!isNaN(start)) {
    thisExtent[0] = start;
  }

  if (!isNaN(end)) {
    thisExtent[1] = end;
  }
};
/**
 * @return {Array.<string>}
 */


Scale.prototype.getTicksLabels = function () {
  var labels = [];
  var ticks = this.getTicks();

  for (var i = 0; i < ticks.length; i++) {
    labels.push(this.getLabel(ticks[i]));
  }

  return labels;
};
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */


Scale.prototype.isBlank = function () {
  return this._isBlank;
},
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */
Scale.prototype.setBlank = function (isBlank) {
  this._isBlank = isBlank;
};
clazzUtil.enableClassExtend(Scale);
clazzUtil.enableClassManagement(Scale, {
  registerWhenExtend: true
});
var _default = Scale;
module.exports = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var VisualMapping = __webpack_require__(105);

/**
 * @file Visual solution, for consistent option specification.
 */
var each = zrUtil.each;

function hasKeys(obj) {
  if (obj) {
    for (var name in obj) {
      if (obj.hasOwnProperty(name)) {
        return true;
      }
    }
  }
}
/**
 * @param {Object} option
 * @param {Array.<string>} stateList
 * @param {Function} [supplementVisualOption]
 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
 */


function createVisualMappings(option, stateList, supplementVisualOption) {
  var visualMappings = {};
  each(stateList, function (state) {
    var mappings = visualMappings[state] = createMappings();
    each(option[state], function (visualData, visualType) {
      if (!VisualMapping.isValidType(visualType)) {
        return;
      }

      var mappingOption = {
        type: visualType,
        visual: visualData
      };
      supplementVisualOption && supplementVisualOption(mappingOption, state);
      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
      // is not supported, such as rendering using gradient color.

      if (visualType === 'opacity') {
        mappingOption = zrUtil.clone(mappingOption);
        mappingOption.type = 'colorAlpha';
        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
      }
    });
  });
  return visualMappings;

  function createMappings() {
    var Creater = function () {}; // Make sure hidden fields will not be visited by
    // object iteration (with hasOwnProperty checking).


    Creater.prototype.__hidden = Creater.prototype;
    var obj = new Creater();
    return obj;
  }
}
/**
 * @param {Object} thisOption
 * @param {Object} newOption
 * @param {Array.<string>} keys
 */


function replaceVisualOption(thisOption, newOption, keys) {
  // Visual attributes merge is not supported, otherwise it
  // brings overcomplicated merge logic. See #2853. So if
  // newOption has anyone of these keys, all of these keys
  // will be reset. Otherwise, all keys remain.
  var has;
  zrUtil.each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      has = true;
    }
  });
  has && zrUtil.each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      thisOption[key] = zrUtil.clone(newOption[key]);
    } else {
      delete thisOption[key];
    }
  });
}
/**
 * @param {Array.<string>} stateList
 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param {module:echarts/data/List} list
 * @param {Function} getValueState param: valueOrIndex, return: state.
 * @param {object} [scope] Scope for getValueState
 * @param {string} [dimension] Concrete dimension, if used.
 */


function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
  var visualTypesMap = {};
  zrUtil.each(stateList, function (state) {
    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  var dataIndex;

  function getVisual(key) {
    return data.getItemVisual(dataIndex, key);
  }

  function setVisual(key, value) {
    data.setItemVisual(dataIndex, key, value);
  }

  if (dimension == null) {
    data.each(eachItem, true);
  } else {
    data.each([dimension], eachItem, true);
  }

  function eachItem(valueOrIndex, index) {
    dataIndex = dimension == null ? valueOrIndex : index;
    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance

    if (rawDataItem && rawDataItem.visualMap === false) {
      return;
    }

    var valueState = getValueState.call(scope, valueOrIndex);
    var mappings = visualMappings[valueState];
    var visualTypes = visualTypesMap[valueState];

    for (var i = 0, len = visualTypes.length; i < len; i++) {
      var type = visualTypes[i];
      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
    }
  }
}

exports.createVisualMappings = createVisualMappings;
exports.replaceVisualOption = replaceVisualOption;
exports.applyVisual = applyVisual;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1721),
    listCacheDelete = __webpack_require__(1722),
    listCacheGet = __webpack_require__(1723),
    listCacheHas = __webpack_require__(1724),
    listCacheSet = __webpack_require__(1725);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(76);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(204);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1719);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(297);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(146),
    isObject = __webpack_require__(68);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1639)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1069),
  /* template */
  __webpack_require__(1926),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1096),
  /* template */
  __webpack_require__(1928),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var dpr = 1; // If in browser environment

if (typeof window !== 'undefined') {
  dpr = Math.max(window.devicePixelRatio || 1, 1);
}
/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */

/**
 * debug日志选项：catchBrushException为true下有效
 * 0 : 不生成debug数据，发布用
 * 1 : 异常抛出，调试用
 * 2 : 控制台输出，调试用
 */


var debugMode = 0; // retina 屏幕优化

var devicePixelRatio = dpr;
exports.debugMode = debugMode;
exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Element = __webpack_require__(682);

var BoundingRect = __webpack_require__(26);

/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 */

/**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */
var Group = function (opts) {
  opts = opts || {};
  Element.call(this, opts);

  for (var key in opts) {
    if (opts.hasOwnProperty(key)) {
      this[key] = opts[key];
    }
  }

  this._children = [];
  this.__storage = null;
  this.__dirty = true;
};

Group.prototype = {
  constructor: Group,
  isGroup: true,

  /**
   * @type {string}
   */
  type: 'group',

  /**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * @return {Array.<module:zrender/Element>}
   */
  children: function () {
    return this._children.slice();
  },

  /**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */
  childAt: function (idx) {
    return this._children[idx];
  },

  /**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */
  childOfName: function (name) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].name === name) {
        return children[i];
      }
    }
  },

  /**
   * @return {number}
   */
  childCount: function () {
    return this._children.length;
  },

  /**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */
  add: function (child) {
    if (child && child !== this && child.parent !== this) {
      this._children.push(child);

      this._doAdd(child);
    }

    return this;
  },

  /**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */
  addBefore: function (child, nextSibling) {
    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
      var children = this._children;
      var idx = children.indexOf(nextSibling);

      if (idx >= 0) {
        children.splice(idx, 0, child);

        this._doAdd(child);
      }
    }

    return this;
  },
  _doAdd: function (child) {
    if (child.parent) {
      child.parent.remove(child);
    }

    child.parent = this;
    var storage = this.__storage;
    var zr = this.__zr;

    if (storage && storage !== child.__storage) {
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }

    zr && zr.refresh();
  },

  /**
   * 移除子节点
   * @param {module:zrender/Element} child
   */
  remove: function (child) {
    var zr = this.__zr;
    var storage = this.__storage;
    var children = this._children;
    var idx = zrUtil.indexOf(children, child);

    if (idx < 0) {
      return this;
    }

    children.splice(idx, 1);
    child.parent = null;

    if (storage) {
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }

    zr && zr.refresh();
    return this;
  },

  /**
   * 移除所有子节点
   */
  removeAll: function () {
    var children = this._children;
    var storage = this.__storage;
    var child;
    var i;

    for (i = 0; i < children.length; i++) {
      child = children[i];

      if (storage) {
        storage.delFromStorage(child);

        if (child instanceof Group) {
          child.delChildrenFromStorage(storage);
        }
      }

      child.parent = null;
    }

    children.length = 0;
    return this;
  },

  /**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */
  eachChild: function (cb, context) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      cb.call(context, child, i);
    }

    return this;
  },

  /**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      cb.call(context, child);

      if (child.type === 'group') {
        child.traverse(cb, context);
      }
    }

    return this;
  },
  addChildrenToStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }
  },
  delChildrenFromStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }
  },
  dirty: function () {
    this.__dirty = true;
    this.__zr && this.__zr.refresh();
    return this;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function (includeChildren) {
    // TODO Caching
    var rect = null;
    var tmpRect = new BoundingRect(0, 0, 0, 0);
    var children = includeChildren || this._children;
    var tmpMat = [];

    for (var i = 0; i < children.length; i++) {
      var child = children[i];

      if (child.ignore || child.invisible) {
        continue;
      }

      var childRect = child.getBoundingRect();
      var transform = child.getLocalTransform(tmpMat); // TODO
      // The boundingRect cacluated by transforming original
      // rect may be bigger than the actual bundingRect when rotation
      // is used. (Consider a circle rotated aginst its center, where
      // the actual boundingRect should be the same as that not be
      // rotated.) But we can not find better approach to calculate
      // actual boundingRect yet, considering performance.

      if (transform) {
        tmpRect.copy(childRect);
        tmpRect.applyTransform(transform);
        rect = rect || tmpRect.clone();
        rect.union(tmpRect);
      } else {
        rect = rect || childRect.clone();
        rect.union(childRect);
      }
    }

    return rect || tmpRect;
  }
};
zrUtil.inherits(Group, Element);
var _default = Group;
module.exports = _default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Style = __webpack_require__(694);

var Element = __webpack_require__(682);

var RectText = __webpack_require__(698);

/**
 * 可绘制的图形基类
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 */

/**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */
function Displayable(opts) {
  opts = opts || {};
  Element.call(this, opts); // Extend properties

  for (var name in opts) {
    if (opts.hasOwnProperty(name) && name !== 'style') {
      this[name] = opts[name];
    }
  }
  /**
   * @type {module:zrender/graphic/Style}
   */


  this.style = new Style(opts.style, this);
  this._rect = null; // Shapes for cascade clipping.

  this.__clipPaths = []; // FIXME Stateful must be mixined after style is setted
  // Stateful.call(this, opts);
}

Displayable.prototype = {
  constructor: Displayable,
  type: 'displayable',

  /**
   * Displayable 是否为脏，Painter 中会根据该标记判断是否需要是否需要重新绘制
   * Dirty flag. From which painter will determine if this displayable object needs brush
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */
  __dirty: true,

  /**
   * 图形是否可见，为true时不绘制图形，但是仍能触发鼠标事件
   * If ignore drawing of the displayable object. Mouse event will still be triggered
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */
  invisible: false,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z: 0,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z2: 0,

  /**
   * z层level，决定绘画在哪层canvas中
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */
  zlevel: 0,

  /**
   * 是否可拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  draggable: false,

  /**
   * 是否正在拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  dragging: false,

  /**
   * 是否相应鼠标事件
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * If enable culling
   * @type {boolean}
   * @default false
   */
  culling: false,

  /**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */
  cursor: 'pointer',

  /**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */
  rectHover: false,

  /**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {number}
   */
  progressive: -1,
  beforeBrush: function (ctx) {},
  afterBrush: function (ctx) {},

  /**
   * 图形绘制方法
   * @param {CanvasRenderingContext2D} ctx
   */
  // Interface
  brush: function (ctx, prevEl) {},

  /**
   * 获取最小包围盒
   * @return {module:zrender/core/BoundingRect}
   */
  // Interface
  getBoundingRect: function () {},

  /**
   * 判断坐标 x, y 是否在图形上
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  contain: function (x, y) {
    return this.rectContain(x, y);
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    cb.call(context, this);
  },

  /**
   * 判断坐标 x, y 是否在图形的包围盒上
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  rectContain: function (x, y) {
    var coord = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    return rect.contain(coord[0], coord[1]);
  },

  /**
   * 标记图形元素为脏，并且在下一帧重绘
   * Mark displayable element dirty and refresh next frame
   */
  dirty: function () {
    this.__dirty = true;
    this._rect = null;
    this.__zr && this.__zr.refresh();
  },

  /**
   * 图形是否会触发事件
   * If displayable object binded any event
   * @return {boolean}
   */
  // TODO, 通过 bind 绑定的事件
  // isSilent: function () {
  //     return !(
  //         this.hoverable || this.draggable
  //         || this.onmousemove || this.onmouseover || this.onmouseout
  //         || this.onmousedown || this.onmouseup || this.onclick
  //         || this.ondragenter || this.ondragover || this.ondragleave
  //         || this.ondrop
  //     );
  // },

  /**
   * Alias for animate('style')
   * @param {boolean} loop
   */
  animateStyle: function (loop) {
    return this.animate('style', loop);
  },
  attrKV: function (key, value) {
    if (key !== 'style') {
      Element.prototype.attrKV.call(this, key, value);
    } else {
      this.style.set(value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setStyle: function (key, value) {
    this.style.set(key, value);
    this.dirty(false);
    return this;
  },

  /**
   * Use given style object
   * @param  {Object} obj
   */
  useStyle: function (obj) {
    this.style = new Style(obj, this);
    this.dirty(false);
    return this;
  }
};
zrUtil.inherits(Displayable, Element);
zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);

var _default = Displayable;
module.exports = _default;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * @param {Array.<Object>} colorStops
 */
var Gradient = function (colorStops) {
  this.colorStops = colorStops || [];
};

Gradient.prototype = {
  constructor: Gradient,
  addColorStop: function (offset, color) {
    this.colorStops.push({
      offset: offset,
      color: color
    });
  }
};
var _default = Gradient;
module.exports = _default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(0);

var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var each = _util.each;
var normalizeCssArray = _util.normalizeCssArray;
var isString = _util.isString;
var isObject = _util.isObject;

var textContain = __webpack_require__(70);

var roundRectHelper = __webpack_require__(697);

var imageHelper = __webpack_require__(322);

// TODO: Have not support 'start', 'end' yet.
var VALID_TEXT_ALIGN = {
  left: 1,
  right: 1,
  center: 1
};
var VALID_TEXT_VERTICAL_ALIGN = {
  top: 1,
  bottom: 1,
  middle: 1
};
/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */

function normalizeTextStyle(style) {
  normalizeStyle(style);
  each(style.rich, normalizeStyle);
  return style;
}

function normalizeStyle(style) {
  if (style) {
    style.font = textContain.makeFont(style);
    var textAlign = style.textAlign;
    textAlign === 'middle' && (textAlign = 'center');
    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.

    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
    var textPadding = style.textPadding;

    if (textPadding) {
      style.textPadding = normalizeCssArray(style.textPadding);
    }
  }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 */


function renderText(hostEl, ctx, text, style, rect) {
  style.rich ? renderRichText(hostEl, ctx, text, style, rect) : renderPlainText(hostEl, ctx, text, style, rect);
}

function renderPlainText(hostEl, ctx, text, style, rect) {
  var font = setCtx(ctx, 'font', style.font || textContain.DEFAULT_FONT);
  var textPadding = style.textPadding;
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirty) {
    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, font, textPadding, style.truncate);
  }

  var outerHeight = contentBlock.outerHeight;
  var textLines = contentBlock.lines;
  var lineHeight = contentBlock.lineHeight;
  var boxPos = getBoxPosition(outerHeight, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var textX = baseX;
  var textY = boxY;
  var needDrawBg = needDrawBackground(style);

  if (needDrawBg || textPadding) {
    // Consider performance, do not call getTextWidth util necessary.
    var textWidth = textContain.getWidth(text, font);
    var outerWidth = textWidth;
    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

    if (textPadding) {
      textX = getTextXForPadding(baseX, textAlign, textPadding);
      textY += textPadding[0];
    }
  }

  setCtx(ctx, 'textAlign', textAlign || 'left'); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle'); // Always set shadowBlur and shadowOffset to avoid leak from displayable.

  setCtx(ctx, 'shadowBlur', style.textShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textShadowOffsetY || 0); // `textBaseline` is set as 'middle'.

  textY += lineHeight / 2;
  var textStrokeWidth = style.textStrokeWidth;
  var textStroke = getStroke(style.textStroke, textStrokeWidth);
  var textFill = getFill(style.textFill);

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
  }

  for (var i = 0; i < textLines.length; i++) {
    // Fill after stroke so the outline will not cover the main part.
    textStroke && ctx.strokeText(textLines[i], textX, textY);
    textFill && ctx.fillText(textLines[i], textX, textY);
    textY += lineHeight;
  }
}

function renderRichText(hostEl, ctx, text, style, rect) {
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirty) {
    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
  }

  drawRichText(hostEl, ctx, contentBlock, style, rect);
}

function drawRichText(hostEl, ctx, contentBlock, style, rect) {
  var contentWidth = contentBlock.width;
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var textPadding = style.textPadding;
  var boxPos = getBoxPosition(outerHeight, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var xLeft = boxX;
  var lineTop = boxY;

  if (textPadding) {
    xLeft += textPadding[3];
    lineTop += textPadding[0];
  }

  var xRight = xLeft + contentWidth;
  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

  for (var i = 0; i < contentBlock.lines.length; i++) {
    var line = contentBlock.lines[i];
    var tokens = line.tokens;
    var tokenCount = tokens.length;
    var lineHeight = line.lineHeight;
    var usedWidth = line.width;
    var leftIndex = 0;
    var lineXLeft = xLeft;
    var lineXRight = xRight;
    var rightIndex = tokenCount - 1;
    var token;

    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
      usedWidth -= token.width;
      lineXLeft += token.width;
      leftIndex++;
    }

    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
      usedWidth -= token.width;
      lineXRight -= token.width;
      rightIndex--;
    } // The other tokens are placed as textAlign 'center' if there is enough space.


    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;

    while (leftIndex <= rightIndex) {
      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.

      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
      lineXLeft += token.width;
      leftIndex++;
    }

    lineTop += lineHeight;
  }
}

function applyTextRotation(ctx, style, rect, x, y) {
  // textRotation only apply in RectText.
  if (rect && style.textRotation) {
    var origin = style.textOrigin;

    if (origin === 'center') {
      x = rect.width / 2 + rect.x;
      y = rect.height / 2 + rect.y;
    } else if (origin) {
      x = origin[0] + rect.x;
      y = origin[1] + rect.y;
    }

    ctx.translate(x, y); // Positive: anticlockwise

    ctx.rotate(-style.textRotation);
    ctx.translate(-x, -y);
  }
}

function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
  var tokenStyle = style.rich[token.styleName] || {}; // 'ctx.textBaseline' is always set as 'middle', for sake of
  // the bias of "Microsoft YaHei".

  var textVerticalAlign = token.textVerticalAlign;
  var y = lineTop + lineHeight / 2;

  if (textVerticalAlign === 'top') {
    y = lineTop + token.height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y = lineTop + lineHeight - token.height / 2;
  }

  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
  var textPadding = token.textPadding;

  if (textPadding) {
    x = getTextXForPadding(x, textAlign, textPadding);
    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
  }

  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle');
  setCtx(ctx, 'font', token.font || textContain.DEFAULT_FONT);
  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
  var textFill = getFill(tokenStyle.textFill || style.textFill);
  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
    ctx.strokeText(token.text, x, y);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
    ctx.fillText(token.text, x, y);
  }
}

function needDrawBackground(style) {
  return style.textBackgroundColor || style.textBorderWidth && style.textBorderColor;
} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius}
// shape: {x, y, width, height}


function drawBackground(hostEl, ctx, style, x, y, width, height) {
  var textBackgroundColor = style.textBackgroundColor;
  var textBorderWidth = style.textBorderWidth;
  var textBorderColor = style.textBorderColor;
  var isPlainBg = isString(textBackgroundColor);
  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);

  if (isPlainBg || textBorderWidth && textBorderColor) {
    ctx.beginPath();
    var textBorderRadius = style.textBorderRadius;

    if (!textBorderRadius) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, {
        x: x,
        y: y,
        width: width,
        height: height,
        r: textBorderRadius
      });
    }

    ctx.closePath();
  }

  if (isPlainBg) {
    setCtx(ctx, 'fillStyle', textBackgroundColor);
    ctx.fill();
  } else if (isObject(textBackgroundColor)) {
    var image = textBackgroundColor.image;
    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);

    if (image && imageHelper.isImageReady(image)) {
      ctx.drawImage(image, x, y, width, height);
    }
  }

  if (textBorderWidth && textBorderColor) {
    setCtx(ctx, 'lineWidth', textBorderWidth);
    setCtx(ctx, 'strokeStyle', textBorderColor);
    ctx.stroke();
  }
}

function onBgImageLoaded(image, textBackgroundColor) {
  // Replace image, so that `contain/text.js#parseRichText`
  // will get correct result in next tick.
  textBackgroundColor.image = image;
}

function getBoxPosition(blockHeiht, style, rect) {
  var baseX = style.x || 0;
  var baseY = style.y || 0;
  var textAlign = style.textAlign;
  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord

  if (rect) {
    var textPosition = style.textPosition;

    if (textPosition instanceof Array) {
      // Percent
      baseX = rect.x + parsePercent(textPosition[0], rect.width);
      baseY = rect.y + parsePercent(textPosition[1], rect.height);
    } else {
      var res = textContain.adjustTextPositionOnRect(textPosition, rect, style.textDistance);
      baseX = res.x;
      baseY = res.y; // Default align and baseline when has textPosition

      textAlign = textAlign || res.textAlign;
      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
    } // textOffset is only support in RectText, otherwise
    // we have to adjust boundingRect for textOffset.


    var textOffset = style.textOffset;

    if (textOffset) {
      baseX += textOffset[0];
      baseY += textOffset[1];
    }
  }

  return {
    baseX: baseX,
    baseY: baseY,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function setCtx(ctx, prop, value) {
  // FIXME ??? performance try
  // if (ctx.__currentValues[prop] !== value) {
  // ctx[prop] = ctx.__currentValues[prop] = value;
  ctx[prop] = value; // }

  return ctx[prop];
}
/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */


function getStroke(stroke, lineWidth) {
  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
  : stroke.image || stroke.colorStops ? '#000' : stroke;
}

function getFill(fill) {
  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
  : fill.image || fill.colorStops ? '#000' : fill;
}

function parsePercent(value, maxValue) {
  if (typeof value === 'string') {
    if (value.lastIndexOf('%') >= 0) {
      return parseFloat(value) / 100 * maxValue;
    }

    return parseFloat(value);
  }

  return value;
}

function getTextXForPadding(x, textAlign, textPadding) {
  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */


function needDrawText(text, style) {
  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
}

exports.normalizeTextStyle = normalizeTextStyle;
exports.renderText = renderText;
exports.getStroke = getStroke;
exports.getFill = getFill;
exports.needDrawText = needDrawText;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(691);

var env = __webpack_require__(33);

var zrUtil = __webpack_require__(0);

var Handler = __webpack_require__(1963);

var Storage = __webpack_require__(1966);

var Painter = __webpack_require__(1965);

var Animation = __webpack_require__(1967);

var HandlerProxy = __webpack_require__(1975);

/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var useVML = !env.canvasSupported;
var painterCtors = {
  canvas: Painter
};
var instances = {}; // ZRender实例map索引

/**
 * @type {string}
 */

var version = '3.7.4';
/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */

function init(dom, opts) {
  var zr = new ZRender(guid(), dom, opts);
  instances[zr.id] = zr;
  return zr;
}
/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */


function dispose(zr) {
  if (zr) {
    zr.dispose();
  } else {
    for (var key in instances) {
      if (instances.hasOwnProperty(key)) {
        instances[key].dispose();
      }
    }

    instances = {};
  }

  return this;
}
/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */


function getInstance(id) {
  return instances[id];
}

function registerPainter(name, Ctor) {
  painterCtors[name] = Ctor;
}

function delInstance(id) {
  delete instances[id];
}
/**
 * @module zrender/ZRender
 */

/**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */


var ZRender = function (id, dom, opts) {
  opts = opts || {};
  /**
   * @type {HTMLDomElement}
   */

  this.dom = dom;
  /**
   * @type {string}
   */

  this.id = id;
  var self = this;
  var storage = new Storage();
  var rendererType = opts.renderer; // TODO WebGL

  if (useVML) {
    if (!painterCtors.vml) {
      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
    }

    rendererType = 'vml';
  } else if (!rendererType || !painterCtors[rendererType]) {
    rendererType = 'canvas';
  }

  var painter = new painterCtors[rendererType](dom, storage, opts);
  this.storage = storage;
  this.painter = painter;
  var handerProxy = !env.node ? new HandlerProxy(painter.getViewportRoot()) : null;
  this.handler = new Handler(storage, painter, handerProxy, painter.root);
  /**
   * @type {module:zrender/animation/Animation}
   */

  this.animation = new Animation({
    stage: {
      update: zrUtil.bind(this.flush, this)
    }
  });
  this.animation.start();
  /**
   * @type {boolean}
   * @private
   */

  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
  // FIXME 有点ugly

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);
    el && el.removeSelfFromZr(self);
  };

  storage.addToStorage = function (el) {
    oldAddToStorage.call(storage, el);
    el.addSelfToZr(self);
  };
};

ZRender.prototype = {
  constructor: ZRender,

  /**
   * 获取实例唯一标识
   * @return {string}
   */
  getId: function () {
    return this.id;
  },

  /**
   * 添加元素
   * @param  {module:zrender/Element} el
   */
  add: function (el) {
    this.storage.addRoot(el);
    this._needsRefresh = true;
  },

  /**
   * 删除元素
   * @param  {module:zrender/Element} el
   */
  remove: function (el) {
    this.storage.delRoot(el);
    this._needsRefresh = true;
  },

  /**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */
  configLayer: function (zLevel, config) {
    this.painter.configLayer(zLevel, config);
    this._needsRefresh = true;
  },

  /**
   * Repaint the canvas immediately
   */
  refreshImmediately: function () {
    // var start = new Date();
    // Clear needsRefresh ahead to avoid something wrong happens in refresh
    // Or it will cause zrender refreshes again and again.
    this._needsRefresh = false;
    this.painter.refresh();
    /**
     * Avoid trigger zr.refresh in Element#beforeUpdate hook
     */

    this._needsRefresh = false; // var end = new Date();
    // var log = document.getElementById('log');
    // if (log) {
    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
    // }
  },

  /**
   * Mark and repaint the canvas in the next frame of browser
   */
  refresh: function () {
    this._needsRefresh = true;
  },

  /**
   * Perform all refresh
   */
  flush: function () {
    if (this._needsRefresh) {
      this.refreshImmediately();
    }

    if (this._needsRefreshHover) {
      this.refreshHoverImmediately();
    }
  },

  /**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */
  addHover: function (el, style) {
    if (this.painter.addHover) {
      this.painter.addHover(el, style);
      this.refreshHover();
    }
  },

  /**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */
  removeHover: function (el) {
    if (this.painter.removeHover) {
      this.painter.removeHover(el);
      this.refreshHover();
    }
  },

  /**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */
  clearHover: function () {
    if (this.painter.clearHover) {
      this.painter.clearHover();
      this.refreshHover();
    }
  },

  /**
   * Refresh hover in next frame
   */
  refreshHover: function () {
    this._needsRefreshHover = true;
  },

  /**
   * Refresh hover immediately
   */
  refreshHoverImmediately: function () {
    this._needsRefreshHover = false;
    this.painter.refreshHover && this.painter.refreshHover();
  },

  /**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */
  resize: function (opts) {
    opts = opts || {};
    this.painter.resize(opts.width, opts.height);
    this.handler.resize();
  },

  /**
   * Stop and clear all animation immediately
   */
  clearAnimation: function () {
    this.animation.clear();
  },

  /**
   * Get container width
   */
  getWidth: function () {
    return this.painter.getWidth();
  },

  /**
   * Get container height
   */
  getHeight: function () {
    return this.painter.getHeight();
  },

  /**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */
  // toDataURL: function(type, backgroundColor) {
  //     return this.painter.getRenderedCanvas({
  //         backgroundColor: backgroundColor
  //     }).toDataURL(type);
  // },

  /**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */
  pathToImage: function (e, dpr) {
    return this.painter.pathToImage(e, dpr);
  },

  /**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    this.handler.setCursorStyle(cursorStyle);
  },

  /**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */
  findHover: function (x, y) {
    return this.handler.findHover(x, y);
  },

  /**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */
  on: function (eventName, eventHandler, context) {
    this.handler.on(eventName, eventHandler, context);
  },

  /**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */
  off: function (eventName, eventHandler) {
    this.handler.off(eventName, eventHandler);
  },

  /**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */
  trigger: function (eventName, event) {
    this.handler.trigger(eventName, event);
  },

  /**
   * Clear all objects and the canvas.
   */
  clear: function () {
    this.storage.delRoot();
    this.painter.clear();
  },

  /**
   * Dispose self.
   */
  dispose: function () {
    this.animation.stop();
    this.clear();
    this.storage.dispose();
    this.painter.dispose();
    this.handler.dispose();
    this.animation = this.storage = this.painter = this.handler = null;
    delInstance(this.id);
  }
};
exports.version = version;
exports.init = init;
exports.dispose = dispose;
exports.getInstance = getInstance;
exports.registerPainter = registerPainter;

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.13
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.13';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}

function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38), __webpack_require__(301).setImmediate))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);

var AWS = __webpack_require__(10);
if (typeof window !== 'undefined') window.AWS = AWS;
if (true) module.exports = AWS;
if (typeof self !== 'undefined') self.AWS = AWS;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);

function JsonBuilder() { }

JsonBuilder.prototype.build = function(value, shape) {
  return JSON.stringify(translate(value, shape));
};

function translate(value, shape) {
  if (!shape || value === undefined || value === null) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      if (memberShape.location !== 'body') return;
      var locationName = memberShape.isLocationName ? memberShape.name : name;
      var result = translate(value, memberShape);
      if (result !== undefined) struct[locationName] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result !== undefined) out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result !== undefined) out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toWireFormat(value);
}

module.exports = JsonBuilder;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);

function JsonParser() { }

JsonParser.prototype.parse = function(value, shape) {
  return translate(JSON.parse(value), shape);
};

function translate(value, shape) {
  if (!shape || value === undefined) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  if (structure == null) return undefined;

  var struct = {};
  var shapeMembers = shape.members;
  util.each(shapeMembers, function(name, memberShape) {
    var locationName = memberShape.isLocationName ? memberShape.name : name;
    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
      var value = structure[locationName];
      var result = translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toType(value);
}

module.exports = JsonParser;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var JsonBuilder = __webpack_require__(218);
var JsonParser = __webpack_require__(219);

function buildRequest(req) {
  var httpRequest = req.httpRequest;
  var api = req.service.api;
  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
  var version = api.jsonVersion || '1.0';
  var input = api.operations[req.operation].input;
  var builder = new JsonBuilder();

  if (version === 1) version = '1.0';
  httpRequest.body = builder.build(req.params || {}, input);
  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
  httpRequest.headers['X-Amz-Target'] = target;
}

function extractError(resp) {
  var error = {};
  var httpResponse = resp.httpResponse;

  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
  if (typeof error.code === 'string') {
    error.code = error.code.split(':')[0];
  }

  if (httpResponse.body.length > 0) {
    try {
      var e = JSON.parse(httpResponse.body.toString());
      if (e.__type || e.code) {
        error.code = (e.__type || e.code).split('#').pop();
      }
      if (error.code === 'RequestEntityTooLarge') {
        error.message = 'Request body must be less than 1 MB';
      } else {
        error.message = (e.message || e.Message || null);
      }
    } catch (e) {
      error.statusCode = httpResponse.statusCode;
      error.message = httpResponse.statusMessage;
    }
  } else {
    error.statusCode = httpResponse.statusCode;
    error.message = httpResponse.statusCode.toString();
  }

  resp.error = util.error(new Error(), error);
}

function extractData(resp) {
  var body = resp.httpResponse.body.toString() || '{}';
  if (resp.request.service.config.convertResponseTypes === false) {
    resp.data = JSON.parse(body);
  } else {
    var operation = resp.request.service.api.operations[resp.request.operation];
    var shape = operation.output || {};
    var parser = new JsonParser();
    resp.data = parser.parse(body, shape);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);

function JsonBuilder() { }

JsonBuilder.prototype.build = function(value, shape) {
  return JSON.stringify(translate(value, shape));
};

function translate(value, shape) {
  if (!shape || value === undefined || value === null) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      if (memberShape.location !== 'body') return;
      var locationName = memberShape.isLocationName ? memberShape.name : name;
      var result = translate(value, memberShape);
      if (result !== undefined) struct[locationName] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result !== undefined) out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result !== undefined) out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toWireFormat(value);
}

module.exports = JsonBuilder;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);

function JsonParser() { }

JsonParser.prototype.parse = function(value, shape) {
  return translate(JSON.parse(value), shape);
};

function translate(value, shape) {
  if (!shape || value === undefined) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  if (structure == null) return undefined;

  var struct = {};
  var shapeMembers = shape.members;
  util.each(shapeMembers, function(name, memberShape) {
    var locationName = memberShape.isLocationName ? memberShape.name : name;
    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
      var value = structure[locationName];
      var result = translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toType(value);
}

module.exports = JsonParser;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var JsonBuilder = __webpack_require__(221);
var JsonParser = __webpack_require__(222);

function buildRequest(req) {
  var httpRequest = req.httpRequest;
  var api = req.service.api;
  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
  var version = api.jsonVersion || '1.0';
  var input = api.operations[req.operation].input;
  var builder = new JsonBuilder();

  if (version === 1) version = '1.0';
  httpRequest.body = builder.build(req.params || {}, input);
  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
  httpRequest.headers['X-Amz-Target'] = target;
}

function extractError(resp) {
  var error = {};
  var httpResponse = resp.httpResponse;

  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
  if (typeof error.code === 'string') {
    error.code = error.code.split(':')[0];
  }

  if (httpResponse.body.length > 0) {
    try {
      var e = JSON.parse(httpResponse.body.toString());
      if (e.__type || e.code) {
        error.code = (e.__type || e.code).split('#').pop();
      }
      if (error.code === 'RequestEntityTooLarge') {
        error.message = 'Request body must be less than 1 MB';
      } else {
        error.message = (e.message || e.Message || null);
      }
    } catch (e) {
      error.statusCode = httpResponse.statusCode;
      error.message = httpResponse.statusMessage;
    }
  } else {
    error.statusCode = httpResponse.statusCode;
    error.message = httpResponse.statusCode.toString();
  }

  resp.error = util.error(new Error(), error);
}

function extractData(resp) {
  var body = resp.httpResponse.body.toString() || '{}';
  if (resp.request.service.config.convertResponseTypes === false) {
    resp.data = JSON.parse(body);
  } else {
    var operation = resp.request.service.api.operations[resp.request.operation];
    var shape = operation.output || {};
    var parser = new JsonParser();
    resp.data = parser.parse(body, shape);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(47);
var normalizeHeaderName = __webpack_require__(1045);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(371);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(371);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getPluginStatusValue: function getPluginStatusValue(service) {
    var status = 0;
    switch (service.serviceId) {
      case 1:
        // 流量サービスの場合
        var filter = service.filters[0]; // TODO フィルタが１個しか付いていない前提での実装になっている。複数フィルタに対応するには実装の変更が必要。
        if (filter.maxLifeSpanFlow > 0 && filter.flow > filter.maxLifeSpanFlow || filter.maxLifeSpanTime > 0 && filter.time > filter.maxLifeSpanTime) {
          status = 2;
        } else if (filter.warningLifeSpanFlow > 0 && filter.flow > filter.warningLifeSpanFlow || filter.warningLifeSpanTime > 0 && filter.time > filter.warningLifeSpanTime) {
          status = 1;
        }
        break;
      case 2: // ROサービスの場合
      case 3: // 温度サービスの場合
      case 4: // 漏水サービスの場合
      case 5:
        // 圧力値サービスの場合
        status = service.status;
        break;
      default:
    }
    return status;
  },
  getServiceStatusValue: function getServiceStatusValue(service) {
    var good = 0;
    var warning = 1;
    var alert = 2;
    switch (service.serviceId) {
      case 1:
      case 2:
        return this.getPluginStatusValue(service);
      case 3:
      case 4:
      case 5:
        var status = good;
        for (var portIndex = 0; portIndex < service.details.length; portIndex++) {
          var statusByPort = this.getPluginStatusValue(service.details[portIndex]);
          if (statusByPort === warning) {
            status = warning;
          }
          if (statusByPort === alert) {
            status = alert;
            return status;
          }
        }
        return status;
      default:
        return good;
    }
  },
  getFiltrationSystemStatusValue: function getFiltrationSystemStatusValue(filtrationSystem) {
    // サービス総じてのステータスのチェックを行う （本来はサーバでやったほうが良さそう）
    var good = 0;
    var warning = 1;
    var alert = 2;
    var status = good;
    if (filtrationSystem.services[0] == null) {
      return status;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(filtrationSystem.services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var service = _step.value;

        var statusByService = this.getPluginStatusValue(service);
        if (statusByService === warning) {
          status = warning;
        }
        if (statusByService === alert) {
          status = alert;
          return status;
        }
      }

      // filtrationSystemのプロパティに追加する（そうしないとDOMに反映されない）
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return status;
  },
  getCssClassForStatus: function getCssClassForStatus(status) {
    var classSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var alertClass = 'red';
    var warningClass = 'orange';
    var goodClass = 'blue';
    var statusClass = goodClass;
    switch (status) {
      case 1:
        statusClass = warningClass;
        break;
      case 2:
        statusClass = alertClass;
        break;
      case 0:
      default:
        statusClass = goodClass;
    }
    return statusClass + classSuffix;
  },
  getNotificationSettings: function getNotificationSettings(status) {
    var alertType = 'error';
    var warningType = 'warning';
    var alertMessageKey = 'home.notification-alert';
    var warningMessageKey = 'home.notification-warning';
    var notificationSettings = {
      type: '',
      messageKey: ''
    };
    switch (status) {
      case 1:
        notificationSettings = {
          type: warningType,
          messageKey: warningMessageKey
        };
        break;
      case 2:
        notificationSettings = {
          type: alertType,
          messageKey: alertMessageKey
        };
        break;
      case 0:
      default:
        notificationSettings = {
          type: '',
          messageKey: ''
        };
    }
    return notificationSettings;
  }
});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1113), __esModule: true };

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1104);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(81);
var document = __webpack_require__(40).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(165);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(235)('keys');
var uid = __webpack_require__(170);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(40);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(236);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(81);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(40);
var core = __webpack_require__(36);
var LIBRARY = __webpack_require__(166);
var wksExt = __webpack_require__(240);
var defineProperty = __webpack_require__(72).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(41);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(387);
var ITERATOR = __webpack_require__(41)('iterator');
var Iterators = __webpack_require__(133);
module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1145);
var global = __webpack_require__(40);
var hide = __webpack_require__(90);
var Iterators = __webpack_require__(133);
var TO_STRING_TAG = __webpack_require__(41)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(100);
var toLength = __webpack_require__(25);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1156);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(24);
var createDesc = __webpack_require__(97);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(20)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var setPrototypeOf = __webpack_require__(258).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(112);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(94);
var descriptor = __webpack_require__(97);
var setToStringTag = __webpack_require__(113);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(43)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(93);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(44);
var hide = __webpack_require__(43);
var has = __webpack_require__(42);
var Iterators = __webpack_require__(112);
var $iterCreate = __webpack_require__(252);
var setToStringTag = __webpack_require__(113);
var getPrototypeOf = __webpack_require__(49);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var macrotask = __webpack_require__(264).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(55)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(37);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(56)(Function.call, __webpack_require__(48).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(183)('keys');
var uid = __webpack_require__(101);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(64);
var defined = __webpack_require__(62);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(177);
var defined = __webpack_require__(62);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(64);
var defined = __webpack_require__(62);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var invoke = __webpack_require__(414);
var html = __webpack_require__(249);
var cel = __webpack_require__(246);
var global = __webpack_require__(11);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(55)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(23);
var LIBRARY = __webpack_require__(93);
var $typed = __webpack_require__(185);
var hide = __webpack_require__(43);
var redefineAll = __webpack_require__(98);
var fails = __webpack_require__(12);
var anInstance = __webpack_require__(91);
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(25);
var toIndex = __webpack_require__(432);
var gOPN = __webpack_require__(95).f;
var dP = __webpack_require__(24).f;
var arrayFill = __webpack_require__(243);
var setToStringTag = __webpack_require__(113);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(61);
var LIBRARY = __webpack_require__(93);
var wksExt = __webpack_require__(433);
var defineProperty = __webpack_require__(24).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(136);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(112);
module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(82);
var step = __webpack_require__(417);
var Iterators = __webpack_require__(112);
var toIObject = __webpack_require__(50);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(253)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(109).Buffer;
var intSize = 4;
var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
var chrsz = 8;

function toArray(buf, bigEndian) {
  if ((buf.length % intSize) !== 0) {
    var len = buf.length + (intSize - (buf.length % intSize));
    buf = Buffer.concat([buf, zeroBuffer], len);
  }

  var arr = [];
  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
  for (var i = 0; i < buf.length; i += intSize) {
    arr.push(fn.call(buf, i));
  }
  return arr;
}

function toBuffer(arr, size, bigEndian) {
  var buf = new Buffer(size);
  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
  for (var i = 0; i < arr.length; i++) {
    fn.call(buf, arr[i], i * 4, true);
  }
  return buf;
}

function hash(buf, fn, hashSize, bigEndian) {
  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
  return toBuffer(arr, hashSize, bigEndian);
}

module.exports = { hash: hash };


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var vector = __webpack_require__(19);

var symbolUtil = __webpack_require__(52);

var LinePath = __webpack_require__(1417);

var graphic = __webpack_require__(5);

var _number = __webpack_require__(8);

var round = _number.round;

/**
 * @module echarts/chart/helper/Line
 */
var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];

function makeSymbolTypeKey(symbolCategory) {
  return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */


function createSymbol(name, lineData, idx) {
  var color = lineData.getItemVisual(idx, 'color');
  var symbolType = lineData.getItemVisual(idx, name);
  var symbolSize = lineData.getItemVisual(idx, name + 'Size');

  if (!symbolType || symbolType === 'none') {
    return;
  }

  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [symbolSize, symbolSize];
  }

  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color);
  symbolPath.name = name;
  return symbolPath;
}

function createLine(points) {
  var line = new LinePath({
    name: 'line'
  });
  setLinePoints(line.shape, points);
  return line;
}

function setLinePoints(targetShape, points) {
  var p1 = points[0];
  var p2 = points[1];
  var cp1 = points[2];
  targetShape.x1 = p1[0];
  targetShape.y1 = p1[1];
  targetShape.x2 = p2[0];
  targetShape.y2 = p2[1];
  targetShape.percent = 1;

  if (cp1) {
    targetShape.cpx1 = cp1[0];
    targetShape.cpy1 = cp1[1];
  } else {
    targetShape.cpx1 = NaN;
    targetShape.cpy1 = NaN;
  }
}

function updateSymbolAndLabelBeforeLineUpdate() {
  var lineGroup = this;
  var symbolFrom = lineGroup.childOfName('fromSymbol');
  var symbolTo = lineGroup.childOfName('toSymbol');
  var label = lineGroup.childOfName('label'); // Quick reject

  if (!symbolFrom && !symbolTo && label.ignore) {
    return;
  }

  var invScale = 1;
  var parentNode = this.parent;

  while (parentNode) {
    if (parentNode.scale) {
      invScale /= parentNode.scale[0];
    }

    parentNode = parentNode.parent;
  }

  var line = lineGroup.childOfName('line'); // If line not changed
  // FIXME Parent scale changed

  if (!this.__dirty && !line.__dirty) {
    return;
  }

  var percent = line.shape.percent;
  var fromPos = line.pointAt(0);
  var toPos = line.pointAt(percent);
  var d = vector.sub([], toPos, fromPos);
  vector.normalize(d, d);

  if (symbolFrom) {
    symbolFrom.attr('position', fromPos);
    var tangent = line.tangentAt(0);
    symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
  }

  if (symbolTo) {
    symbolTo.attr('position', toPos);
    var tangent = line.tangentAt(1);
    symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
  }

  if (!label.ignore) {
    label.attr('position', toPos);
    var textPosition;
    var textAlign;
    var textVerticalAlign;
    var distance = 5 * invScale; // End

    if (label.__position === 'end') {
      textPosition = [d[0] * distance + toPos[0], d[1] * distance + toPos[1]];
      textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
      textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
    } // Middle
    else if (label.__position === 'middle') {
        var halfPercent = percent / 2;
        var tangent = line.tangentAt(halfPercent);
        var n = [tangent[1], -tangent[0]];
        var cp = line.pointAt(halfPercent);

        if (n[1] > 0) {
          n[0] = -n[0];
          n[1] = -n[1];
        }

        textPosition = [cp[0] + n[0] * distance, cp[1] + n[1] * distance];
        textAlign = 'center';
        textVerticalAlign = 'bottom';
        var rotation = -Math.atan2(tangent[1], tangent[0]);

        if (toPos[0] < fromPos[0]) {
          rotation = Math.PI + rotation;
        }

        label.attr('rotation', rotation);
      } // Start
      else {
          textPosition = [-d[0] * distance + fromPos[0], -d[1] * distance + fromPos[1]];
          textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
          textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
        }

    label.attr({
      style: {
        // Use the user specified text align and baseline first
        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
        textAlign: label.__textAlign || textAlign
      },
      position: textPosition,
      scale: [invScale, invScale]
    });
  }
}
/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */


function Line(lineData, idx, seriesScope) {
  graphic.Group.call(this);

  this._createLine(lineData, idx, seriesScope);
}

var lineProto = Line.prototype; // Update symbol position and rotation

lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;

lineProto._createLine = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var linePoints = lineData.getItemLayout(idx);
  var line = createLine(linePoints);
  line.shape.percent = 0;
  graphic.initProps(line, {
    shape: {
      percent: 1
    }
  }, seriesModel, idx);
  this.add(line);
  var label = new graphic.Text({
    name: 'label'
  });
  this.add(label);
  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
    // it will be updated after line#update.
    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow

    this.add(symbol);
    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
  }, this);

  this._updateCommonStl(lineData, idx, seriesScope);
};

lineProto.updateData = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childOfName('line');
  var linePoints = lineData.getItemLayout(idx);
  var target = {
    shape: {}
  };
  setLinePoints(target.shape, linePoints);
  graphic.updateProps(line, target, seriesModel, idx);
  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbolType = lineData.getItemVisual(idx, symbolCategory);
    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed

    if (this[key] !== symbolType) {
      this.remove(this.childOfName(symbolCategory));
      var symbol = createSymbol(symbolCategory, lineData, idx);
      this.add(symbol);
    }

    this[key] = symbolType;
  }, this);

  this._updateCommonStl(lineData, idx, seriesScope);
};

lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childOfName('line');
  var lineStyle = seriesScope && seriesScope.lineStyle;
  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset

  if (!seriesScope || lineData.hasItemOption) {
    var itemModel = lineData.getItemModel(idx);
    lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
    hoverLineStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
    labelModel = itemModel.getModel('label.normal');
    hoverLabelModel = itemModel.getModel('label.emphasis');
  }

  var visualColor = lineData.getItemVisual(idx, 'color');
  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
  line.useStyle(zrUtil.defaults({
    strokeNoScale: true,
    fill: 'none',
    stroke: visualColor,
    opacity: visualOpacity
  }, lineStyle));
  line.hoverStyle = hoverLineStyle; // Update symbol

  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
    var symbol = this.childOfName(symbolCategory);

    if (symbol) {
      symbol.setColor(visualColor);
      symbol.setStyle({
        opacity: visualOpacity
      });
    }
  }, this);
  var showLabel = labelModel.getShallow('show');
  var hoverShowLabel = hoverLabelModel.getShallow('show');
  var label = this.childOfName('label');
  var defaultLabelColor;
  var defaultText;
  var normalText;
  var emphasisText;

  if (showLabel || hoverShowLabel) {
    var rawVal = seriesModel.getRawValue(idx);
    defaultText = rawVal == null ? defaultText = lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
    defaultLabelColor = visualColor || '#000';
    normalText = zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType), defaultText);
    emphasisText = zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), normalText);
  } // label.afterUpdate = lineAfterUpdate;


  if (showLabel) {
    var labelStyle = graphic.setTextStyle(label.style, labelModel, {
      text: normalText
    }, {
      autoColor: defaultLabelColor
    });
    label.__textAlign = labelStyle.textAlign;
    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'

    label.__position = labelModel.get('position') || 'middle';
  } else {
    label.setStyle('text', null);
  }

  if (hoverShowLabel) {
    // Only these properties supported in this emphasis style here.
    label.hoverStyle = {
      text: emphasisText,
      textFill: hoverLabelModel.getTextColor(true),
      // For merging hover style to normal style, do not use
      // `hoverLabelModel.getFont()` here.
      fontStyle: hoverLabelModel.getShallow('fontStyle'),
      fontWeight: hoverLabelModel.getShallow('fontWeight'),
      fontSize: hoverLabelModel.getShallow('fontSize'),
      fontFamily: hoverLabelModel.getShallow('fontFamily')
    };
  } else {
    label.hoverStyle = {
      text: null
    };
  }

  label.ignore = !showLabel && !hoverShowLabel;
  graphic.setHoverStyle(this);
};

lineProto.highlight = function () {
  this.trigger('emphasis');
};

lineProto.downplay = function () {
  this.trigger('normal');
};

lineProto.updateLayout = function (lineData, idx) {
  this.setLinePoints(lineData.getItemLayout(idx));
};

lineProto.setLinePoints = function (points) {
  var linePath = this.childOfName('line');
  setLinePoints(linePath.shape, points);
  linePath.dirty();
};

zrUtil.inherits(Line, graphic.Group);
var _default = Line;
module.exports = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var LineGroup = __webpack_require__(271);

/**
 * @module echarts/chart/helper/LineDraw
 */
function isPointNaN(pt) {
  return isNaN(pt[0]) || isNaN(pt[1]);
}

function lineNeedsDraw(pts) {
  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
}
/**
 * @alias module:echarts/component/marker/LineDraw
 * @constructor
 */


function LineDraw(ctor) {
  this._ctor = ctor || LineGroup;
  this.group = new graphic.Group();
}

var lineDrawProto = LineDraw.prototype;
/**
 * @param {module:echarts/data/List} lineData
 */

lineDrawProto.updateData = function (lineData) {
  var oldLineData = this._lineData;
  var group = this.group;
  var LineCtor = this._ctor;
  var hostModel = lineData.hostModel;
  var seriesScope = {
    lineStyle: hostModel.getModel('lineStyle.normal').getLineStyle(),
    hoverLineStyle: hostModel.getModel('lineStyle.emphasis').getLineStyle(),
    labelModel: hostModel.getModel('label.normal'),
    hoverLabelModel: hostModel.getModel('label.emphasis')
  };
  lineData.diff(oldLineData).add(function (idx) {
    if (!lineNeedsDraw(lineData.getItemLayout(idx))) {
      return;
    }

    var lineGroup = new LineCtor(lineData, idx, seriesScope);
    lineData.setItemGraphicEl(idx, lineGroup);
    group.add(lineGroup);
  }).update(function (newIdx, oldIdx) {
    var lineGroup = oldLineData.getItemGraphicEl(oldIdx);

    if (!lineNeedsDraw(lineData.getItemLayout(newIdx))) {
      group.remove(lineGroup);
      return;
    }

    if (!lineGroup) {
      lineGroup = new LineCtor(lineData, newIdx, seriesScope);
    } else {
      lineGroup.updateData(lineData, newIdx, seriesScope);
    }

    lineData.setItemGraphicEl(newIdx, lineGroup);
    group.add(lineGroup);
  }).remove(function (idx) {
    group.remove(oldLineData.getItemGraphicEl(idx));
  }).execute();
  this._lineData = lineData;
};

lineDrawProto.updateLayout = function () {
  var lineData = this._lineData;
  lineData.eachItemGraphicEl(function (el, idx) {
    el.updateLayout(lineData, idx);
  }, this);
};

lineDrawProto.remove = function () {
  this.group.removeAll();
};

var _default = LineDraw;
module.exports = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var clazzUtil = __webpack_require__(75);

var graphic = __webpack_require__(5);

var axisPointerModelHelper = __webpack_require__(189);

var eventTool = __webpack_require__(77);

var throttleUtil = __webpack_require__(104);

var modelUtil = __webpack_require__(15);

var get = modelUtil.makeGetter();
var clone = zrUtil.clone;
var bind = zrUtil.bind;
/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */

function BaseAxisPointer() {}

BaseAxisPointer.prototype = {
  /**
   * @private
   */
  _group: null,

  /**
   * @private
   */
  _lastGraphicKey: null,

  /**
   * @private
   */
  _handle: null,

  /**
   * @private
   */
  _dragging: false,

  /**
   * @private
   */
  _lastValue: null,

  /**
   * @private
   */
  _lastStatus: null,

  /**
   * @private
   */
  _payloadInfo: null,

  /**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */
  animationThreshold: 15,

  /**
   * @implement
   */
  render: function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new graphic.Group();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  },

  /**
   * @implement
   */
  remove: function (api) {
    this.clear(api);
  },

  /**
   * @implement
   */
  dispose: function (api) {
    this.clear(api);
  },

  /**
   * @protected
   */
  determineAnimation: function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  },

  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  },

  /**
   * @protected
   */
  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = get(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
      group.add(pointerEl);
    }
  },

  /**
   * @protected
   */
  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = get(group).labelEl = new graphic.Rect(clone(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @protected
   */
  updatePointerEl: function (group, elOption, updateProps) {
    var pointerEl = get(group).pointerEl;

    if (pointerEl) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  },

  /**
   * @protected
   */
  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = get(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        shape: elOption.label.shape,
        position: elOption.label.position
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @private
   */
  _renderHandle: function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          eventTool.stop(e.event);
        },
        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
        drift: bind(this._onHandleDragMove, this),
        ondragend: bind(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position

    var handleSize = handleModel.get('size');

    if (!zrUtil.isArray(handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  },

  /**
   * @private
   */
  _moveHandleToValue: function (value, isInit) {
    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  },

  /**
   * @private
   */
  _onHandleDragMove: function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    get(handle).lastProp = null;

    this._doDispatchAxisPointer();
  },

  /**
   * Throttled method.
   * @private
   */
  _doDispatchAxisPointer: function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  },

  /**
   * @private
   */
  _onHandleDragEnd: function (moveAnimation) {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  },

  /**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */
  getHandleTransform: null,

  /**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */
  updateHandleTransform: null,

  /**
   * @private
   */
  clear: function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }
  },

  /**
   * @protected
   */
  doClear: function () {// Implemented by sub-class if necessary.
  },

  /**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */
  buildLabel: function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  }
};
BaseAxisPointer.prototype.constructor = BaseAxisPointer;

function updateProps(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(get(el).lastProp, props)) {
    get(el).lastProp = props;
    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
    var equals = true;
    zrUtil.each(newProps, function (item, key) {
      equals = equals && propsEqual(lastProps[key], item);
    });
    return !!equals;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    position: trans.position.slice(),
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

clazzUtil.enableClassExtend(BaseAxisPointer);
var _default = BaseAxisPointer;
module.exports = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var formatUtil = __webpack_require__(21);

var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.

var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
/**
 * @param {string} coordType
 * @return {boolean}
 */

function isCoordSupported(coordType) {
  return zrUtil.indexOf(COORDS, coordType) >= 0;
}
/**
 * Create "each" method to iterate names.
 *
 * @pubilc
 * @param  {Array.<string>} names
 * @param  {Array.<string>=} attrs
 * @return {Function}
 */


function createNameEach(names, attrs) {
  names = names.slice();
  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
  attrs = (attrs || []).slice();
  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
  return function (callback, context) {
    zrUtil.each(names, function (name, index) {
      var nameObj = {
        name: name,
        capital: capitalNames[index]
      };

      for (var j = 0; j < attrs.length; j++) {
        nameObj[attrs[j]] = name + capitalAttrs[j];
      }

      callback.call(context, nameObj);
    });
  };
}
/**
 * Iterate each dimension name.
 *
 * @public
 * @param {Function} callback The parameter is like:
 *                            {
 *                                name: 'angle',
 *                                capital: 'Angle',
 *                                axis: 'angleAxis',
 *                                axisIndex: 'angleAixs',
 *                                index: 'angleIndex'
 *                            }
 * @param {Object} context
 */


var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
/**
 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * dataZoomModels and 'links' make up one or more graphics.
 * This function finds the graphic where the source dataZoomModel is in.
 *
 * @public
 * @param {Function} forEachNode Node iterator.
 * @param {Function} forEachEdgeType edgeType iterator
 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
 */

function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
  return function (sourceNode) {
    var result = {
      nodes: [],
      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).

    };
    forEachEdgeType(function (edgeType) {
      result.records[edgeType.name] = {};
    });

    if (!sourceNode) {
      return result;
    }

    absorb(sourceNode, result);
    var existsLink;

    do {
      existsLink = false;
      forEachNode(processSingleNode);
    } while (existsLink);

    function processSingleNode(node) {
      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
        absorb(node, result);
        existsLink = true;
      }
    }

    return result;
  };

  function isNodeAbsorded(node, result) {
    return zrUtil.indexOf(result.nodes, node) >= 0;
  }

  function isLinked(node, result) {
    var hasLink = false;
    forEachEdgeType(function (edgeType) {
      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
        result.records[edgeType.name][edgeId] && (hasLink = true);
      });
    });
    return hasLink;
  }

  function absorb(node, result) {
    result.nodes.push(node);
    forEachEdgeType(function (edgeType) {
      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
        result.records[edgeType.name][edgeId] = true;
      });
    });
  }
}

exports.isCoordSupported = isCoordSupported;
exports.createNameEach = createNameEach;
exports.eachAxisDim = eachAxisDim;
exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var Eventful = __webpack_require__(108);

var graphic = __webpack_require__(5);

var interactionMutex = __webpack_require__(465);

var DataDiffer = __webpack_require__(117);

var curry = zrUtil.curry;
var each = zrUtil.each;
var map = zrUtil.map;
var mathMin = Math.min;
var mathMax = Math.max;
var mathPow = Math.pow;
var COVER_Z = 10000;
var UNSELECT_THRESHOLD = 6;
var MIN_RESIZE_LINE_WIDTH = 6;
var MUTEX_RESOURCE_KEY = 'globalPan';
var DIRECTION_MAP = {
  w: [0, 0],
  e: [0, 1],
  n: [1, 0],
  s: [1, 1]
};
var CURSOR_MAP = {
  w: 'ew',
  e: 'ew',
  n: 'ns',
  s: 'ns',
  ne: 'nesw',
  sw: 'nesw',
  nw: 'nwse',
  se: 'nwse'
};
var DEFAULT_BRUSH_OPT = {
  brushStyle: {
    lineWidth: 2,
    stroke: 'rgba(0,0,0,0.3)',
    fill: 'rgba(0,0,0,0.1)'
  },
  transformable: true,
  brushMode: 'single',
  removeOnClick: false
};
var baseUID = 0;
/**
 * @alias module:echarts/component/helper/BrushController
 * @constructor
 * @mixin {module:zrender/mixin/Eventful}
 * @event module:echarts/component/helper/BrushController#brush
 *        params:
 *            areas: Array.<Array>, coord relates to container group,
 *                                    If no container specified, to global.
 *            opt {
 *                isEnd: boolean,
 *                removeOnClick: boolean
 *            }
 *
 * @param {module:zrender/zrender~ZRender} zr
 */

function BrushController(zr) {
  Eventful.call(this);
  /**
   * @type {module:zrender/zrender~ZRender}
   * @private
   */

  this._zr = zr;
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */

  this.group = new graphic.Group();
  /**
   * Only for drawing (after enabledBrush).
   *     'line', 'rect', 'polygon' or false
   *     If passing false/null/undefined, disable brush.
   *     If passing 'auto', determined by panel.defaultBrushType
   * @private
   * @type {string}
   */

  this._brushType;
  /**
   * Only for drawing (after enabledBrush).
   *
   * @private
   * @type {Object}
   */

  this._brushOption;
  /**
   * @private
   * @type {Object}
   */

  this._panels;
  /**
   * @private
   * @type {Array.<nubmer>}
   */

  this._track = [];
  /**
   * @private
   * @type {boolean}
   */

  this._dragging;
  /**
   * @private
   * @type {Array}
   */

  this._covers = [];
  /**
   * @private
   * @type {moudule:zrender/container/Group}
   */

  this._creatingCover;
  /**
   * `true` means global panel
   * @private
   * @type {module:zrender/container/Group|boolean}
   */

  this._creatingPanel;
  /**
   * @private
   * @type {boolean}
   */

  this._enableGlobalPan;
  /**
   * @private
   * @type {boolean}
   */

  /**
   * @private
   * @type {string}
   */
  this._uid = 'brushController_' + baseUID++;
  /**
   * @private
   * @type {Object}
   */

  this._handlers = {};
  each(mouseHandlers, function (handler, eventName) {
    this._handlers[eventName] = zrUtil.bind(handler, this);
  }, this);
}

BrushController.prototype = {
  constructor: BrushController,

  /**
   * If set to null/undefined/false, select disabled.
   * @param {Object} brushOption
   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
   *                          If passing false/null/undefined, disable brush.
   *                          If passing 'auto', determined by panel.defaultBrushType.
   *                              ('auto' can not be used in global panel)
   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
   * @param {boolean} [brushOption.transformable=true]
   * @param {boolean} [brushOption.removeOnClick=false]
   * @param {Object} [brushOption.brushStyle]
   * @param {number} [brushOption.brushStyle.width]
   * @param {number} [brushOption.brushStyle.lineWidth]
   * @param {string} [brushOption.brushStyle.stroke]
   * @param {string} [brushOption.brushStyle.fill]
   * @param {number} [brushOption.z]
   */
  enableBrush: function (brushOption) {
    this._brushType && doDisableBrush(this);
    brushOption.brushType && doEnableBrush(this, brushOption);
    return this;
  },

  /**
   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
   *        Each items: {
   *            panelId, // mandatory.
   *            clipPath, // mandatory. function.
   *            isTargetByCursor, // mandatory. function.
   *            defaultBrushType, // optional, only used when brushType is 'auto'.
   *            getLinearBrushOtherExtent, // optional. function.
   *        }
   */
  setPanels: function (panelOpts) {
    if (panelOpts && panelOpts.length) {
      var panels = this._panels = {};
      zrUtil.each(panelOpts, function (panelOpts) {
        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
      });
    } else {
      this._panels = null;
    }

    return this;
  },

  /**
   * @param {Object} [opt]
   * @return {boolean} [opt.enableGlobalPan=false]
   */
  mount: function (opt) {
    opt = opt || {};
    this._enableGlobalPan = opt.enableGlobalPan;
    var thisGroup = this.group;

    this._zr.add(thisGroup);

    thisGroup.attr({
      position: opt.position || [0, 0],
      rotation: opt.rotation || 0,
      scale: opt.scale || [1, 1]
    });
    this._transform = thisGroup.getLocalTransform();
    return this;
  },
  eachCover: function (cb, context) {
    each(this._covers, cb, context);
  },

  /**
   * Update covers.
   * @param {Array.<Object>} brushOptionList Like:
   *        [
   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
   *            ...
   *        ]
   *        `brushType` is required in each cover info. (can not be 'auto')
   *        `id` is not mandatory.
   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
   *        If brushOptionList is null/undefined, all covers removed.
   */
  updateCovers: function (brushOptionList) {
    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
    });
    var tmpIdPrefix = '\0-brush-index-';
    var oldCovers = this._covers;
    var newCovers = this._covers = [];
    var controller = this;
    var creatingCover = this._creatingCover;
    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
    return this;

    function getKey(brushOption, index) {
      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
    }

    function oldGetKey(cover, index) {
      return getKey(cover.__brushOption, index);
    }

    function addOrUpdate(newIndex, oldIndex) {
      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
      // where updating cover when creating should be forbiden.

      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
        newCovers[newIndex] = oldCovers[oldIndex];
      } else {
        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
        updateCoverAfterCreation(controller, cover);
      }
    }

    function remove(oldIndex) {
      if (oldCovers[oldIndex] !== creatingCover) {
        controller.group.remove(oldCovers[oldIndex]);
      }
    }
  },
  unmount: function () {
    this.enableBrush(false); // container may 'removeAll' outside.

    clearCovers(this);

    this._zr.remove(this.group);

    return this;
  },
  dispose: function () {
    this.unmount();
    this.off();
  }
};
zrUtil.mixin(BrushController, Eventful);

function doEnableBrush(controller, brushOption) {
  var zr = controller._zr; // Consider roam, which takes globalPan too.

  if (!controller._enableGlobalPan) {
    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
  }

  each(controller._handlers, function (handler, eventName) {
    zr.on(eventName, handler);
  });
  controller._brushType = brushOption.brushType;
  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
}

function doDisableBrush(controller) {
  var zr = controller._zr;
  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
  each(controller._handlers, function (handler, eventName) {
    zr.off(eventName, handler);
  });
  controller._brushType = controller._brushOption = null;
}

function createCover(controller, brushOption) {
  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
  cover.__brushOption = brushOption;
  updateZ(cover, brushOption);
  controller.group.add(cover);
  return cover;
}

function endCreating(controller, creatingCover) {
  var coverRenderer = getCoverRenderer(creatingCover);

  if (coverRenderer.endCreating) {
    coverRenderer.endCreating(controller, creatingCover);
    updateZ(creatingCover, creatingCover.__brushOption);
  }

  return creatingCover;
}

function updateCoverShape(controller, cover) {
  var brushOption = cover.__brushOption;
  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}

function updateZ(cover, brushOption) {
  var z = brushOption.z;
  z == null && (z = COVER_Z);
  cover.traverse(function (el) {
    el.z = z;
    el.z2 = z; // Consider in given container.
  });
}

function updateCoverAfterCreation(controller, cover) {
  getCoverRenderer(cover).updateCommon(controller, cover);
  updateCoverShape(controller, cover);
}

function getCoverRenderer(cover) {
  return coverRenderers[cover.__brushOption.brushType];
} // return target panel or `true` (means global panel)


function getPanelByPoint(controller, e, localCursorPoint) {
  var panels = controller._panels;

  if (!panels) {
    return true; // Global panel
  }

  var panel;
  var transform = controller._transform;
  each(panels, function (pn) {
    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
  });
  return panel;
} // Return a panel or true


function getPanelByCover(controller, cover) {
  var panels = controller._panels;

  if (!panels) {
    return true; // Global panel
  }

  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
  // which is then treated as global panel.

  return panelId != null ? panels[panelId] : true;
}

function clearCovers(controller) {
  var covers = controller._covers;
  var originalLength = covers.length;
  each(covers, function (cover) {
    controller.group.remove(cover);
  }, controller);
  covers.length = 0;
  return !!originalLength;
}

function trigger(controller, opt) {
  var areas = map(controller._covers, function (cover) {
    var brushOption = cover.__brushOption;
    var range = zrUtil.clone(brushOption.range);
    return {
      brushType: brushOption.brushType,
      panelId: brushOption.panelId,
      range: range
    };
  });
  controller.trigger('brush', areas, {
    isEnd: !!opt.isEnd,
    removeOnClick: !!opt.removeOnClick
  });
}

function shouldShowCover(controller) {
  var track = controller._track;

  if (!track.length) {
    return false;
  }

  var p2 = track[track.length - 1];
  var p1 = track[0];
  var dx = p2[0] - p1[0];
  var dy = p2[1] - p1[1];
  var dist = mathPow(dx * dx + dy * dy, 0.5);
  return dist > UNSELECT_THRESHOLD;
}

function getTrackEnds(track) {
  var tail = track.length - 1;
  tail < 0 && (tail = 0);
  return [track[0], track[tail]];
}

function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
  var cover = new graphic.Group();
  cover.add(new graphic.Rect({
    name: 'main',
    style: makeStyle(brushOption),
    silent: true,
    draggable: true,
    cursor: 'move',
    drift: curry(doDrift, controller, cover, 'nswe'),
    ondragend: curry(trigger, controller, {
      isEnd: true
    })
  }));
  each(edgeNames, function (name) {
    cover.add(new graphic.Rect({
      name: name,
      style: {
        opacity: 0
      },
      draggable: true,
      silent: true,
      invisible: true,
      drift: curry(doDrift, controller, cover, name),
      ondragend: curry(trigger, controller, {
        isEnd: true
      })
    }));
  });
  return cover;
}

function updateBaseRect(controller, cover, localRange, brushOption) {
  var lineWidth = brushOption.brushStyle.lineWidth || 0;
  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
  var x = localRange[0][0];
  var y = localRange[1][0];
  var xa = x - lineWidth / 2;
  var ya = y - lineWidth / 2;
  var x2 = localRange[0][1];
  var y2 = localRange[1][1];
  var x2a = x2 - handleSize + lineWidth / 2;
  var y2a = y2 - handleSize + lineWidth / 2;
  var width = x2 - x;
  var height = y2 - y;
  var widtha = width + lineWidth;
  var heighta = height + lineWidth;
  updateRectShape(controller, cover, 'main', x, y, width, height);

  if (brushOption.transformable) {
    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
  }
}

function updateCommon(controller, cover) {
  var brushOption = cover.__brushOption;
  var transformable = brushOption.transformable;
  var mainEl = cover.childAt(0);
  mainEl.useStyle(makeStyle(brushOption));
  mainEl.attr({
    silent: !transformable,
    cursor: transformable ? 'move' : 'default'
  });
  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
    var el = cover.childOfName(name);
    var globalDir = getGlobalDirection(controller, name);
    el && el.attr({
      silent: !transformable,
      invisible: !transformable,
      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
    });
  });
}

function updateRectShape(controller, cover, name, x, y, w, h) {
  var el = cover.childOfName(name);
  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
}

function makeStyle(brushOption) {
  return zrUtil.defaults({
    strokeNoScale: true
  }, brushOption.brushStyle);
}

function formatRectRange(x, y, x2, y2) {
  var min = [mathMin(x, x2), mathMin(y, y2)];
  var max = [mathMax(x, x2), mathMax(y, y2)];
  return [[min[0], max[0]], // x range
  [min[1], max[1]] // y range
  ];
}

function getTransform(controller) {
  return graphic.getTransform(controller.group);
}

function getGlobalDirection(controller, localDirection) {
  if (localDirection.length > 1) {
    localDirection = localDirection.split('');
    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
    return globalDir.join('');
  } else {
    var map = {
      w: 'left',
      e: 'right',
      n: 'top',
      s: 'bottom'
    };
    var inverseMap = {
      left: 'w',
      right: 'e',
      top: 'n',
      bottom: 's'
    };
    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
    return inverseMap[globalDir];
  }
}

function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
  var brushOption = cover.__brushOption;
  var rectRange = toRectRange(brushOption.range);
  var localDelta = toLocalDelta(controller, dx, dy);
  each(name.split(''), function (namePart) {
    var ind = DIRECTION_MAP[namePart];
    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
  });
  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function driftPolygon(controller, cover, dx, dy, e) {
  var range = cover.__brushOption.range;
  var localDelta = toLocalDelta(controller, dx, dy);
  each(range, function (point) {
    point[0] += localDelta[0];
    point[1] += localDelta[1];
  });
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function toLocalDelta(controller, dx, dy) {
  var thisGroup = controller.group;
  var localD = thisGroup.transformCoordToLocal(dx, dy);
  var localZero = thisGroup.transformCoordToLocal(0, 0);
  return [localD[0] - localZero[0], localD[1] - localZero[1]];
}

function clipByPanel(controller, cover, data) {
  var panel = getPanelByCover(controller, cover);
  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
}

function pointsToRect(points) {
  var xmin = mathMin(points[0][0], points[1][0]);
  var ymin = mathMin(points[0][1], points[1][1]);
  var xmax = mathMax(points[0][0], points[1][0]);
  var ymax = mathMax(points[0][1], points[1][1]);
  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin
  };
}

function resetCursor(controller, e, localCursorPoint) {
  // Check active
  if (!controller._brushType) {
    return;
  }

  var zr = controller._zr;
  var covers = controller._covers;
  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.

  if (!controller._dragging) {
    for (var i = 0; i < covers.length; i++) {
      var brushOption = covers[i].__brushOption;

      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
        // Use cursor style set on cover.
        return;
      }
    }
  }

  currPanel && zr.setCursorStyle('crosshair');
}

function preventDefault(e) {
  var rawE = e.event;
  rawE.preventDefault && rawE.preventDefault();
}

function mainShapeContain(cover, x, y) {
  return cover.childOfName('main').contain(x, y);
}

function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
  var creatingCover = controller._creatingCover;
  var panel = controller._creatingPanel;
  var thisBrushOption = controller._brushOption;
  var eventParams;

  controller._track.push(localCursorPoint.slice());

  if (shouldShowCover(controller) || creatingCover) {
    if (panel && !creatingCover) {
      thisBrushOption.brushMode === 'single' && clearCovers(controller);
      var brushOption = zrUtil.clone(thisBrushOption);
      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
      brushOption.panelId = panel === true ? null : panel.panelId;
      creatingCover = controller._creatingCover = createCover(controller, brushOption);

      controller._covers.push(creatingCover);
    }

    if (creatingCover) {
      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
      var coverBrushOption = creatingCover.__brushOption;
      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));

      if (isEnd) {
        endCreating(controller, creatingCover);
        coverRenderer.updateCommon(controller, creatingCover);
      }

      updateCoverShape(controller, creatingCover);
      eventParams = {
        isEnd: isEnd
      };
    }
  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
      eventParams = {
        isEnd: isEnd,
        removeOnClick: true
      };
    }
  }

  return eventParams;
}

function determineBrushType(brushType, panel) {
  if (brushType === 'auto') {
    return panel.defaultBrushType;
  }

  return brushType;
}

var mouseHandlers = {
  mousedown: function (e) {
    if (this._dragging) {
      // In case some browser do not support globalOut,
      // and release mose out side the browser.
      handleDragEnd.call(this, e);
    } else if (!e.target || !e.target.draggable) {
      preventDefault(e);
      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
      this._creatingCover = null;
      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);

      if (panel) {
        this._dragging = true;
        this._track = [localCursorPoint.slice()];
      }
    }
  },
  mousemove: function (e) {
    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
    resetCursor(this, e, localCursorPoint);

    if (this._dragging) {
      preventDefault(e);
      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
      eventParams && trigger(this, eventParams);
    }
  },
  mouseup: handleDragEnd //,
  // FIXME
  // in tooltip, globalout should not be triggered.
  // globalout: handleDragEnd

};

function handleDragEnd(e) {
  if (this._dragging) {
    preventDefault(e);
    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
    var eventParams = updateCoverByMouse(this, e, localCursorPoint, true);
    this._dragging = false;
    this._track = [];
    this._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.

    eventParams && trigger(this, eventParams);
  }
}
/**
 * key: brushType
 * @type {Object}
 */


var coverRenderers = {
  lineX: getLineRenderer(0),
  lineY: getLineRenderer(1),
  rect: {
    createCover: function (controller, brushOption) {
      return createBaseRectCover(curry(driftRect, function (range) {
        return range;
      }, function (range) {
        return range;
      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      updateBaseRect(controller, cover, localRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  },
  polygon: {
    createCover: function (controller, brushOption) {
      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
      // border of the shape when drawing, which is a better experience for user.

      cover.add(new graphic.Polyline({
        name: 'main',
        style: makeStyle(brushOption),
        silent: true
      }));
      return cover;
    },
    getCreatingRange: function (localTrack) {
      return localTrack;
    },
    endCreating: function (controller, cover) {
      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.

      cover.add(new graphic.Polygon({
        name: 'main',
        draggable: true,
        drift: curry(driftPolygon, controller, cover),
        ondragend: curry(trigger, controller, {
          isEnd: true
        })
      }));
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      cover.childAt(0).setShape({
        points: clipByPanel(controller, cover, localRange)
      });
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  }
};

function getLineRenderer(xyIndex) {
  return {
    createCover: function (controller, brushOption) {
      return createBaseRectCover(curry(driftRect, function (range) {
        var rectRange = [range, [0, 100]];
        xyIndex && rectRange.reverse();
        return rectRange;
      }, function (rectRange) {
        return rectRange[xyIndex];
      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
      return [min, max];
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      var otherExtent; // If brushWidth not specified, fit the panel.

      var panel = getPanelByCover(controller, cover);

      if (panel !== true && panel.getLinearBrushOtherExtent) {
        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
      } else {
        var zr = controller._zr;
        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
      }

      var rectRange = [localRange, otherExtent];
      xyIndex && rectRange.reverse();
      updateBaseRect(controller, cover, rectRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  };
}

var _default = BrushController;
module.exports = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports) {

var IRRELEVANT_EXCLUDES = {
  'axisPointer': 1,
  'tooltip': 1,
  'brush': 1
};
/**
 * Avoid that: mouse click on a elements that is over geo or graph,
 * but roam is triggered.
 */

function onIrrelevantElement(e, api, targetCoordSysModel) {
  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.

  var coordSys = model && model.coordinateSystem;
  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
}

exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * Data selectable mixin for chart series.
 * To eanble data select, option of series must have `selectedMode`.
 * And each data item will use `selected` to toggle itself selected status
 */
var _default = {
  updateSelectedMap: function (targetList) {
    this._targetList = targetList.slice();
    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
      targetMap.set(target.name, target);
      return targetMap;
    }, zrUtil.createHashMap());
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  // PENGING If selectedMode is null ?
  select: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      this._selectTargetMap.each(function (target) {
        target.selected = false;
      });
    }

    target && (target.selected = true);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  unSelect: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
    // selectedMode !== 'single' && target && (target.selected = false);

    target && (target.selected = false);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  toggleSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);

    if (target != null) {
      this[target.selected ? 'unSelect' : 'select'](name, id);
      return target.selected;
    }
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  isSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    return target && target.selected;
  }
};
module.exports = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var modelUtil = __webpack_require__(15);

var formatUtil = __webpack_require__(21);

var addCommas = formatUtil.addCommas;
var encodeHTML = formatUtil.encodeHTML;

function fillLabel(opt) {
  modelUtil.defaultEmphasis(opt.label, ['show']);
}

var MarkerModel = echarts.extendComponentModel({
  type: 'marker',
  dependencies: ['series', 'grid', 'polar', 'geo'],

  /**
   * @overrite
   */
  init: function (option, parentModel, ecModel, extraOpt) {
    this.mergeDefaultAndTheme(option, ecModel);
    this.mergeOption(option, ecModel, extraOpt.createdBySelf, true);
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var hostSeries = this.__hostSeries;
    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
  },
  mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
    var MarkerModel = this.constructor;
    var modelPropName = this.mainType + 'Model';

    if (!createdBySelf) {
      ecModel.eachSeries(function (seriesModel) {
        var markerOpt = seriesModel.get(this.mainType);
        var markerModel = seriesModel[modelPropName];

        if (!markerOpt || !markerOpt.data) {
          seriesModel[modelPropName] = null;
          return;
        }

        if (!markerModel) {
          if (isInit) {
            // Default label emphasis `position` and `show`
            fillLabel(markerOpt);
          }

          zrUtil.each(markerOpt.data, function (item) {
            // FIXME Overwrite fillLabel method ?
            if (item instanceof Array) {
              fillLabel(item[0]);
              fillLabel(item[1]);
            } else {
              fillLabel(item);
            }
          });
          markerModel = new MarkerModel(markerOpt, this, ecModel);
          zrUtil.extend(markerModel, {
            mainType: this.mainType,
            // Use the same series index and name
            seriesIndex: seriesModel.seriesIndex,
            name: seriesModel.name,
            createdBySelf: true
          });
          markerModel.__hostSeries = seriesModel;
        } else {
          markerModel.mergeOption(markerOpt, ecModel, true);
        }

        seriesModel[modelPropName] = markerModel;
      }, this);
    }
  },
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
    var name = data.getName(dataIndex);
    var html = encodeHTML(this.name);

    if (value != null || name) {
      html += '<br />';
    }

    if (name) {
      html += encodeHTML(name);

      if (value != null) {
        html += ' : ';
      }
    }

    if (value != null) {
      html += encodeHTML(formattedValue);
    }

    return html;
  },
  getData: function () {
    return this._data;
  },
  setData: function (data) {
    this._data = data;
  }
});
zrUtil.mixin(MarkerModel, modelUtil.dataFormatMixin);
var _default = MarkerModel;
module.exports = _default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var _default = echarts.extendComponentView({
  type: 'marker',
  init: function () {
    /**
     * Markline grouped by series
     * @private
     * @type {module:zrender/core/util.HashMap}
     */
    this.markerGroupMap = zrUtil.createHashMap();
  },
  render: function (markerModel, ecModel, api) {
    var markerGroupMap = this.markerGroupMap;
    markerGroupMap.each(function (item) {
      item.__keep = false;
    });
    var markerModelKey = this.type + 'Model';
    ecModel.eachSeries(function (seriesModel) {
      var markerModel = seriesModel[markerModelKey];
      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
    }, this);
    markerGroupMap.each(function (item) {
      !item.__keep && this.group.remove(item.group);
    }, this);
  },
  renderSeries: function () {}
});

module.exports = _default;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var numberUtil = __webpack_require__(8);

var indexOf = zrUtil.indexOf;

function hasXOrY(item) {
  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}

function hasXAndY(item) {
  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}

function getPrecision(data, valueAxisDim, dataIndex) {
  var precision = -1;

  do {
    precision = Math.max(numberUtil.getPrecision(data.get(valueAxisDim, dataIndex)), precision);
    data = data.stackedOn;
  } while (data);

  return precision;
}

function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
  var coordArr = [];
  var value = numCalculate(data, targetDataDim, mlType);
  var dataIndex = data.indicesOfNearest(targetDataDim, value, true)[0];
  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex, true);
  coordArr[targetCoordIndex] = data.get(targetDataDim, dataIndex, true);
  var precision = getPrecision(data, targetDataDim, dataIndex);
  precision = Math.min(precision, 20);

  if (precision >= 0) {
    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
  }

  return coordArr;
}

var curry = zrUtil.curry; // TODO Specified percent

var markerTypeCalculator = {
  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  min: curry(markerTypeCalculatorWithExtent, 'min'),

  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  max: curry(markerTypeCalculatorWithExtent, 'max'),

  /**
   * @method
   * @param {module:echarts/data/List} data
   * @param {string} baseAxisDim
   * @param {string} valueAxisDim
   */
  average: curry(markerTypeCalculatorWithExtent, 'average')
};
/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 * @param  {module:echarts/model/Series} seriesModel
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {Object}
 */

function dataTransform(seriesModel, item) {
  var data = seriesModel.getData();
  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
  // 2. If `coord` is not a data array. Which uses `xAxis`,
  // `yAxis` to specify the coord on each dimension
  // parseFloat first because item.x and item.y can be percent string like '20%'

  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
    var dims = coordSys.dimensions;
    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value

    item = zrUtil.clone(item);

    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
      item.coord = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex); // Force to use the value of calculated value.

      item.value = item.coord[targetCoordIndex];
    } else {
      // FIXME Only has one of xAxis and yAxis.
      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average

      for (var i = 0; i < 2; i++) {
        if (markerTypeCalculator[coord[i]]) {
          var dataDim = seriesModel.coordDimToDataDim(dims[i])[0];
          coord[i] = numCalculate(data, dataDim, coord[i]);
        }
      }

      item.coord = coord;
    }
  }

  return item;
}

function getAxisInfo(item, data, coordSys, seriesModel) {
  var ret = {};

  if (item.valueIndex != null || item.valueDim != null) {
    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
    ret.valueAxis = coordSys.getAxis(seriesModel.dataDimToCoordDim(ret.valueDataDim));
    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
    ret.baseDataDim = seriesModel.coordDimToDataDim(ret.baseAxis.dim)[0];
  } else {
    ret.baseAxis = seriesModel.getBaseAxis();
    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
    ret.baseDataDim = seriesModel.coordDimToDataDim(ret.baseAxis.dim)[0];
    ret.valueDataDim = seriesModel.coordDimToDataDim(ret.valueAxis.dim)[0];
  }

  return ret;
}
/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 * @param  {module:echarts/coord/*} [coordSys]
 * @param  {Object} item
 * @return {boolean}
 */


function dataFilter(coordSys, item) {
  // Alwalys return true if there is no coordSys
  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
}

function dimValueGetter(item, dimName, dataIndex, dimIndex) {
  // x, y, radius, angle
  if (dimIndex < 2) {
    return item.coord && item.coord[dimIndex];
  }

  return item.value;
}

function numCalculate(data, valueDataDim, type) {
  if (type === 'average') {
    var sum = 0;
    var count = 0;
    data.each(valueDataDim, function (val, idx) {
      if (!isNaN(val)) {
        sum += val;
        count++;
      }
    }, true);
    return sum / count;
  } else {
    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
  }
}

exports.dataTransform = dataTransform;
exports.getAxisInfo = getAxisInfo;
exports.dataFilter = dataFilter;
exports.dimValueGetter = dimValueGetter;
exports.numCalculate = numCalculate;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;

var axisHelper = __webpack_require__(51);

var Cartesian2D = __webpack_require__(1569);

var Axis2D = __webpack_require__(1567);

var CoordinateSystem = __webpack_require__(66);

__webpack_require__(1570);

/**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */
// Depends on GridModel, AxisModel, which performs preprocess.
var each = zrUtil.each;
var ifAxisCrossZero = axisHelper.ifAxisCrossZero;
var niceScaleExtent = axisHelper.niceScaleExtent;
/**
 * Check if the axis is used in the specified grid
 * @inner
 */

function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var boundingBox = textRect.plain();
  var beforeWidth = boundingBox.width;
  var beforeHeight = boundingBox.height;
  var afterWidth = beforeWidth * Math.cos(rotateRadians) + beforeHeight * Math.sin(rotateRadians);
  var afterHeight = beforeWidth * Math.sin(rotateRadians) + beforeHeight * Math.cos(rotateRadians);
  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
  return rotatedRect;
}

function getLabelUnionRect(axis) {
  var axisModel = axis.model;
  var labels = axisModel.getFormattedLabels();
  var axisLabelModel = axisModel.getModel('axisLabel');
  var rect;
  var step = 1;
  var labelCount = labels.length;

  if (labelCount > 40) {
    // Simple optimization for large amount of labels
    step = Math.ceil(labelCount / 40);
  }

  for (var i = 0; i < labelCount; i += step) {
    if (!axis.isLabelIgnored(i)) {
      var unrotatedSingleRect = axisLabelModel.getTextRect(labels[i]);
      var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
      rect ? rect.union(singleRect) : rect = singleRect;
    }
  }

  return rect;
}

function Grid(gridModel, ecModel, api) {
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */
  this._coordsMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */

  this._coordsList = [];
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesList = [];

  this._initCartesian(gridModel, ecModel, api);

  this.model = gridModel;
}

var gridProto = Grid.prototype;
gridProto.type = 'grid';
gridProto.axisPointerEnabled = true;

gridProto.getRect = function () {
  return this._rect;
};

gridProto.update = function (ecModel, api) {
  var axesMap = this._axesMap;

  this._updateScale(ecModel, this.model);

  each(axesMap.x, function (xAxis) {
    niceScaleExtent(xAxis.scale, xAxis.model);
  });
  each(axesMap.y, function (yAxis) {
    niceScaleExtent(yAxis.scale, yAxis.model);
  });
  each(axesMap.x, function (xAxis) {
    fixAxisOnZero(axesMap, 'y', xAxis);
  });
  each(axesMap.y, function (yAxis) {
    fixAxisOnZero(axesMap, 'x', yAxis);
  }); // Resize again if containLabel is enabled
  // FIXME It may cause getting wrong grid size in data processing stage

  this.resize(this.model, api);
};

function fixAxisOnZero(axesMap, otherAxisDim, axis) {
  // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.
  var axes = axesMap[otherAxisDim];

  if (!axis.onZero) {
    return;
  }

  var onZeroAxisIndex = axis.onZeroAxisIndex; // If target axis is specified.

  if (onZeroAxisIndex != null) {
    var otherAxis = axes[onZeroAxisIndex];

    if (otherAxis && canNotOnZeroToAxis(otherAxis)) {
      axis.onZero = false;
    }

    return;
  }

  for (var idx in axes) {
    if (axes.hasOwnProperty(idx)) {
      var otherAxis = axes[idx];

      if (otherAxis && !canNotOnZeroToAxis(otherAxis)) {
        onZeroAxisIndex = +idx;
        break;
      }
    }
  }

  if (onZeroAxisIndex == null) {
    axis.onZero = false;
  }

  axis.onZeroAxisIndex = onZeroAxisIndex;
}

function canNotOnZeroToAxis(axis) {
  return axis.type === 'category' || axis.type === 'time' || !ifAxisCrossZero(axis);
}
/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */


gridProto.resize = function (gridModel, api, ignoreContainLabel) {
  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
  this._rect = gridRect;
  var axesList = this._axesList;
  adjustAxes(); // Minus label size

  if (!ignoreContainLabel && gridModel.get('containLabel')) {
    each(axesList, function (axis) {
      if (!axis.model.get('axisLabel.inside')) {
        var labelUnionRect = getLabelUnionRect(axis);

        if (labelUnionRect) {
          var dim = axis.isHorizontal() ? 'height' : 'width';
          var margin = axis.model.get('axisLabel.margin');
          gridRect[dim] -= labelUnionRect[dim] + margin;

          if (axis.position === 'top') {
            gridRect.y += labelUnionRect.height + margin;
          } else if (axis.position === 'left') {
            gridRect.x += labelUnionRect.width + margin;
          }
        }
      }
    });
    adjustAxes();
  }

  function adjustAxes() {
    each(axesList, function (axis) {
      var isHorizontal = axis.isHorizontal();
      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(extent[idx], extent[1 - idx]);
      updateAxisTransfrom(axis, isHorizontal ? gridRect.x : gridRect.y);
    });
  }
};
/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */


gridProto.getAxis = function (axisType, axisIndex) {
  var axesMapOnDim = this._axesMap[axisType];

  if (axesMapOnDim != null) {
    if (axisIndex == null) {
      // Find first axis
      for (var name in axesMapOnDim) {
        if (axesMapOnDim.hasOwnProperty(name)) {
          return axesMapOnDim[name];
        }
      }
    }

    return axesMapOnDim[axisIndex];
  }
};
/**
 * @return {Array.<module:echarts/coord/Axis>}
 */


gridProto.getAxes = function () {
  return this._axesList.slice();
};
/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */


gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
  if (xAxisIndex != null && yAxisIndex != null) {
    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
    return this._coordsMap[key];
  }

  if (zrUtil.isObject(xAxisIndex)) {
    yAxisIndex = xAxisIndex.yAxisIndex;
    xAxisIndex = xAxisIndex.xAxisIndex;
  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.


  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
      return coordList[i];
    }
  }
};

gridProto.getCartesians = function () {
  return this._coordsList.slice();
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertToPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertFromPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
};
/**
 * @inner
 */


gridProto._findConvertTarget = function (ecModel, finder) {
  var seriesModel = finder.seriesModel;
  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
  var gridModel = finder.gridModel;
  var coordsList = this._coordsList;
  var cartesian;
  var axis;

  if (seriesModel) {
    cartesian = seriesModel.coordinateSystem;
    zrUtil.indexOf(coordsList, cartesian) < 0 && (cartesian = null);
  } else if (xAxisModel && yAxisModel) {
    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  } else if (xAxisModel) {
    axis = this.getAxis('x', xAxisModel.componentIndex);
  } else if (yAxisModel) {
    axis = this.getAxis('y', yAxisModel.componentIndex);
  } // Lowest priority.
  else if (gridModel) {
      var grid = gridModel.coordinateSystem;

      if (grid === this) {
        cartesian = this._coordsList[0];
      }
    }

  return {
    cartesian: cartesian,
    axis: axis
  };
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.containPoint = function (point) {
  var coord = this._coordsList[0];

  if (coord) {
    return coord.containPoint(point);
  }
};
/**
 * Initialize cartesian coordinate systems
 * @private
 */


gridProto._initCartesian = function (gridModel, ecModel, api) {
  var axisPositionUsed = {
    left: false,
    right: false,
    top: false,
    bottom: false
  };
  var axesMap = {
    x: {},
    y: {}
  };
  var axesCount = {
    x: 0,
    y: 0
  }; /// Create axis

  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

  if (!axesCount.x || !axesCount.y) {
    // Roll back when there no either x or y axis
    this._axesMap = {};
    this._axesList = [];
    return;
  }

  this._axesMap = axesMap; /// Create cartesian2d

  each(axesMap.x, function (xAxis, xAxisIndex) {
    each(axesMap.y, function (yAxis, yAxisIndex) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      var cartesian = new Cartesian2D(key);
      cartesian.grid = this;
      cartesian.model = gridModel;
      this._coordsMap[key] = cartesian;

      this._coordsList.push(cartesian);

      cartesian.addAxis(xAxis);
      cartesian.addAxis(yAxis);
    }, this);
  }, this);

  function createAxisCreator(axisType) {
    return function (axisModel, idx) {
      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
        return;
      }

      var axisPosition = axisModel.get('position');

      if (axisType === 'x') {
        // Fix position
        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
          // Default bottom of X
          axisPosition = 'bottom';

          if (axisPositionUsed[axisPosition]) {
            axisPosition = axisPosition === 'top' ? 'bottom' : 'top';
          }
        }
      } else {
        // Fix position
        if (axisPosition !== 'left' && axisPosition !== 'right') {
          // Default left of Y
          axisPosition = 'left';

          if (axisPositionUsed[axisPosition]) {
            axisPosition = axisPosition === 'left' ? 'right' : 'left';
          }
        }
      }

      axisPositionUsed[axisPosition] = true;
      var axis = new Axis2D(axisType, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse');
      axis.onZero = axisModel.get('axisLine.onZero');
      axis.onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex'); // Inject axis into axisModel

      axisModel.axis = axis; // Inject axisModel into axis

      axis.model = axisModel; // Inject grid info axis

      axis.grid = this; // Index of axis, can be used as key

      axis.index = idx;

      this._axesList.push(axis);

      axesMap[axisType][idx] = axis;
      axesCount[axisType]++;
    };
  }
};
/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */


gridProto._updateScale = function (ecModel, gridModel) {
  // Reset scale
  zrUtil.each(this._axesList, function (axis) {
    axis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (isCartesian2D(seriesModel)) {
      var axesModels = findAxesModels(seriesModel, ecModel);
      var xAxisModel = axesModels[0];
      var yAxisModel = axesModels[1];

      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
        return;
      }

      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
      var data = seriesModel.getData();
      var xAxis = cartesian.getAxis('x');
      var yAxis = cartesian.getAxis('y');

      if (data.type === 'list') {
        unionExtent(data, xAxis, seriesModel);
        unionExtent(data, yAxis, seriesModel);
      }
    }
  }, this);

  function unionExtent(data, axis, seriesModel) {
    each(seriesModel.coordDimToDataDim(axis.dim), function (dim) {
      axis.scale.unionExtentFromData(data, dim);
    });
  }
};
/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */


gridProto.getTooltipAxes = function (dim) {
  var baseAxes = [];
  var otherAxes = [];
  each(this.getCartesians(), function (cartesian) {
    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
    var otherAxis = cartesian.getOtherAxis(baseAxis);
    zrUtil.indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
    zrUtil.indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
  });
  return {
    baseAxes: baseAxes,
    otherAxes: otherAxes
  };
};
/**
 * @inner
 */


function updateAxisTransfrom(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

var axesTypes = ['xAxis', 'yAxis'];
/**
 * @inner
 */

function findAxesModels(seriesModel, ecModel) {
  return zrUtil.map(axesTypes, function (axisType) {
    var axisModel = seriesModel.getReferringComponents(axisType)[0];
    return axisModel;
  });
}
/**
 * @inner
 */


function isCartesian2D(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}

Grid.create = function (ecModel, api) {
  var grids = [];
  ecModel.eachComponent('grid', function (gridModel, idx) {
    var grid = new Grid(gridModel, ecModel, api);
    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
    // should be performed in create stage.

    grid.resize(gridModel, api, true);
    gridModel.coordinateSystem = grid;
    grids.push(grid);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (!isCartesian2D(seriesModel)) {
      return;
    }

    var axesModels = findAxesModels(seriesModel, ecModel);
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var gridModel = xAxisModel.getCoordSysModel();
    var grid = gridModel.coordinateSystem;
    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  });
  return grids;
}; // For deciding which dimensions to use when creating list data


Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
CoordinateSystem.register('cartesian2d', Grid);
var _default = Grid;
module.exports = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var Polar = __webpack_require__(1586);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

var _axisHelper = __webpack_require__(51);

var createScaleByModel = _axisHelper.createScaleByModel;
var niceScaleExtent = _axisHelper.niceScaleExtent;

var CoordinateSystem = __webpack_require__(66);

__webpack_require__(1587);

// TODO Axis scale
// 依赖 PolarModel 做预处理

/**
 * Resize method bound to the polar
 * @param {module:echarts/coord/polar/PolarModel} polarModel
 * @param {module:echarts/ExtensionAPI} api
 */
function resizePolar(polar, polarModel, api) {
  var center = polarModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  polar.cx = parsePercent(center[0], width);
  polar.cy = parsePercent(center[1], height);
  var radiusAxis = polar.getRadiusAxis();
  var size = Math.min(width, height) / 2;
  var radius = parsePercent(polarModel.get('radius'), size);
  radiusAxis.inverse ? radiusAxis.setExtent(radius, 0) : radiusAxis.setExtent(0, radius);
}
/**
 * Update polar
 */


function updatePolarScale(ecModel, api) {
  var polar = this;
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis(); // Reset scale

  angleAxis.scale.setExtent(Infinity, -Infinity);
  radiusAxis.scale.setExtent(Infinity, -Infinity);
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.coordinateSystem === polar) {
      var data = seriesModel.getData();
      radiusAxis.scale.unionExtentFromData(data, 'radius');
      angleAxis.scale.unionExtentFromData(data, 'angle');
    }
  });
  niceScaleExtent(angleAxis.scale, angleAxis.model);
  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis

  if (angleAxis.type === 'category' && !angleAxis.onBand) {
    var extent = angleAxis.getExtent();
    var diff = 360 / angleAxis.scale.count();
    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
    angleAxis.setExtent(extent[0], extent[1]);
  }
}
/**
 * Set common axis properties
 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
 * @param {module:echarts/coord/polar/AxisModel}
 * @inner
 */


function setAxis(axis, axisModel) {
  axis.type = axisModel.get('type');
  axis.scale = createScaleByModel(axisModel);
  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
  axis.inverse = axisModel.get('inverse');

  if (axisModel.mainType === 'angleAxis') {
    axis.inverse ^= axisModel.get('clockwise');
    var startAngle = axisModel.get('startAngle');
    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
  } // Inject axis instance


  axisModel.axis = axis;
  axis.model = axisModel;
}

var polarCreator = {
  dimensions: Polar.prototype.dimensions,
  create: function (ecModel, api) {
    var polarList = [];
    ecModel.eachComponent('polar', function (polarModel, idx) {
      var polar = new Polar(idx); // Inject resize and update method

      polar.update = updatePolarScale;
      var radiusAxis = polar.getRadiusAxis();
      var angleAxis = polar.getAngleAxis();
      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
      var angleAxisModel = polarModel.findAxisModel('angleAxis');
      setAxis(radiusAxis, radiusAxisModel);
      setAxis(angleAxis, angleAxisModel);
      resizePolar(polar, polarModel, api);
      polarList.push(polar);
      polarModel.coordinateSystem = polar;
      polar.model = polarModel;
    }); // Inject coordinateSystem to series

    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.get('coordinateSystem') === 'polar') {
        var polarModel = ecModel.queryComponents({
          mainType: 'polar',
          index: seriesModel.get('polarIndex'),
          id: seriesModel.get('polarId')
        })[0];
        seriesModel.coordinateSystem = polarModel.coordinateSystem;
      }
    });
    return polarList;
  }
};
CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var STACK_PREFIX = '__ec_stack_';

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt, api) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(zrUtil.defaults({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params, api);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}

function calBarWidthAndOffset(barSeries, api) {
  var seriesInfoList = zrUtil.map(barSeries, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    return {
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    };
  });
  return doCalBarWidthAndOffset(seriesInfoList, api);
}

function doCalBarWidthAndOffset(seriesInfoList, api) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.
    // TODO

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */


function barLayoutGrid(seriesType, ecModel, api) {
  var barWidthAndOffset = calBarWidthAndOffset(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
  }));
  var lastStackCoords = {};
  var lastStackCoordsOrigin = {};
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (seriesModel.coordinateSystem.type !== 'cartesian2d') {
      return;
    }

    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var valueAxisStart = baseAxis.onZero ? valueAxis.toGlobalCoord(valueAxis.dataToCoord(0)) : valueAxis.getGlobalExtent()[0];
    var coordDims = [seriesModel.coordDimToDataDim('x')[0], seriesModel.coordDimToDataDim('y')[0]];
    var coords = data.mapArray(coordDims, function (x, y) {
      return cartesian.dataToPoint([x, y]);
    }, true);
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243

    data.setLayout({
      offset: columnOffset,
      size: columnWidth
    });
    data.each(seriesModel.coordDimToDataDim(valueAxis.dim)[0], function (value, idx) {
      if (isNaN(value)) {
        return;
      }

      if (!lastStackCoords[stackId][idx]) {
        lastStackCoords[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
        lastStackCoordsOrigin[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
      }

      var sign = value >= 0 ? 'p' : 'n';
      var coord = coords[idx];
      var lastCoord = lastStackCoords[stackId][idx][sign];
      var lastCoordOrigin = lastStackCoordsOrigin[stackId][idx][sign];
      var x;
      var y;
      var width;
      var height;

      if (valueAxis.isHorizontal()) {
        x = lastCoord;
        y = coord[1] + columnOffset;
        width = coord[0] - lastCoordOrigin;
        height = columnWidth;
        lastStackCoordsOrigin[stackId][idx][sign] += width;

        if (Math.abs(width) < barMinHeight) {
          width = (width < 0 ? -1 : 1) * barMinHeight;
        }

        lastStackCoords[stackId][idx][sign] += width;
      } else {
        x = coord[0] + columnOffset;
        y = lastCoord;
        width = columnWidth;
        height = coord[1] - lastCoordOrigin;
        lastStackCoordsOrigin[stackId][idx][sign] += height;

        if (Math.abs(height) < barMinHeight) {
          // Include zero to has a positive bar
          height = (height <= 0 ? -1 : 1) * barMinHeight;
        }

        lastStackCoords[stackId][idx][sign] += height;
      }

      data.setItemLayout(idx, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    }, true);
  }, this);
}

barLayoutGrid.getLayoutOnAxis = getLayoutOnAxis;
var _default = barLayoutGrid;
module.exports = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

function _default(seriesType, ecModel) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    var dims = [];
    var coordDims = coordSys.dimensions;

    for (var i = 0; i < coordDims.length; i++) {
      dims.push(seriesModel.coordDimToDataDim(coordSys.dimensions[i])[0]);
    }

    if (dims.length === 1) {
      data.each(dims[0], function (x, idx) {
        // Also {Array.<number>}, not undefined to avoid if...else... statement
        data.setItemLayout(idx, isNaN(x) ? [NaN, NaN] : coordSys.dataToPoint(x));
      });
    } else if (dims.length === 2) {
      data.each(dims, function (x, y, idx) {
        // Also {Array.<number>}, not undefined to avoid if...else... statement
        data.setItemLayout(idx, isNaN(x) || isNaN(y) ? [NaN, NaN] : coordSys.dataToPoint([x, y]));
      }, true);
    }
  });
}

module.exports = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _clazz = __webpack_require__(75);

var parseClassType = _clazz.parseClassType;
var base = 0;
var DELIMITER = '_';
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base++, Math.random()].join(DELIMITER);
}
/**
 * @inner
 */


function enableSubTypeDefaulter(entity) {
  var subTypeDefaulters = {};

  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
    componentType = parseClassType(componentType);
    subTypeDefaulters[componentType.main] = defaulter;
  };

  entity.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = parseClassType(componentType).main;

      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };

  return entity;
}
/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */


function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var stack = result.noEntryList;
    var targetNameSet = {};
    zrUtil.each(targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (stack.length) {
      var currComponentType = stack.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    zrUtil.each(targetNameSet, function () {
      throw new Error('Circle dependency may exists');
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        stack.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };
  /**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */


  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    zrUtil.each(fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      zrUtil.each(availableDeps, function (dependentName) {
        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    zrUtil.each(originalDeps, function (dep) {
      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}

exports.getUID = getUID;
exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Group = __webpack_require__(211);

var componentUtil = __webpack_require__(285);

var clazzUtil = __webpack_require__(75);

var Component = function () {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewComponent');
};

Component.prototype = {
  constructor: Component,
  init: function (ecModel, api) {},
  render: function (componentModel, ecModel, api, payload) {},
  dispose: function () {}
};
var componentProto = Component.prototype;

componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
}; // Enable Component.extend.


clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Component, {
  registerWhenExtend: true
});
var _default = Component;
module.exports = _default;

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// Pick color from palette for each data item.
// Applicable for charts that require applying color palette
// in data level (like pie, funnel, chord).
function _default(seriesType, ecModel) {
  // Pie and funnel may use diferrent scope
  var paletteScope = {};
  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
    var dataAll = seriesModel.getRawData();
    var idxMap = {};

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      var data = seriesModel.getData();
      data.each(function (idx) {
        var rawIdx = data.getRawIndex(idx);
        idxMap[rawIdx] = idx;
      });
      dataAll.each(function (rawIdx) {
        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded

        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);

        if (!singleDataColor) {
          // FIXME Performance
          var itemModel = dataAll.getItemModel(rawIdx);
          var color = itemModel.get('itemStyle.normal.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx), paletteScope); // Legend may use the visual info in data before processed

          dataAll.setItemVisual(rawIdx, 'color', color); // Data is not filtered

          if (filteredIdx != null) {
            data.setItemVisual(filteredIdx, 'color', color);
          }
        } else {
          // Set data all color for legend
          dataAll.setItemVisual(rawIdx, 'color', singleDataColor);
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107),
    root = __webpack_require__(76);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1726),
    mapCacheDelete = __webpack_require__(1727),
    mapCacheGet = __webpack_require__(1728),
    mapCacheHas = __webpack_require__(1729),
    mapCacheSet = __webpack_require__(1730);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(67),
    isSymbol = __webpack_require__(297);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1686),
    isObjectLike = __webpack_require__(148);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(76),
    stubFalse = __webpack_require__(1758);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module)))

/***/ }),
/* 296 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(146),
    isObjectLike = __webpack_require__(148);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1690),
    baseUnary = __webpack_require__(1700),
    nodeUtil = __webpack_require__(1734);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1761);
moment.tz.load(__webpack_require__(1760));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1765);
exports.encode = exports.stringify = __webpack_require__(1766);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1770);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA8UlEQVRIid2X0Q2CMBCGPxvfZQQ2cARxE0fQCcQN2MAZ3KBugJuwwe9DhRjCg6VNevFLLiGXcvmg10KRhKRKktfvDJKaz71ZYrw4R0h8c8ol4ghUrOMOaGX0QDMWcpRjD3QWRCDIAOVFJhxwAq4FHXqg2kgagF1BEYCLMyABUJnqERPkELkBTwsiLeBTi/zV1OTAO+BV2gLCGxkixh+BzSwg9Mk8H9XA25jBhM9BM8u1n9w8X0dVVtyf2RJIahNrNFaa1cyq6a2IDFvCrnhIKOKJbcwFYlfNEikPMWFlamyJ+MIOD2A66XWJG9Jaekm1JN64/BLAJMA3QQAAAABJRU5ErkJggg=="

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj1Fn24D8DjQETjc0HGz98LAEAP2ACuYjgnroAAAAASUVORK5CYII="

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj7D0k/5+BxoCJxuaDjR8+lgAA1asCdUTlWzEAAAAASUVORK5CYII="

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_dp@3x.78f453f.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_pr@3x.17e778f.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_ro@3x.adf8a1b.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_tm@3x.9fb3368.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_wt@3x.a1e780f.png";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAFSUlEQVR4nO2dMUwbVxjH/+85+OCCQaQmVYSEG2eJK0WpKitTgKEdmiUVytKFVumUKVL3MDlSNypFGZgqFWVsisrQdqBDTCdEK6VIdhZojIpQ6mstm3L12bFfh1LqOwtC4T3uM/5+Ez6j7332z/fuvXd+n4VSCkF+366f64tGPobA+wK43vYPzJFRwA9Q+PqvWuPz12I9fwSfF0Ehbq2ZAXBXAAMnlWQ3ooAKgAd2VE63Ht8T4nrNIQgs8BlxsuyeMTdtS5YAQALA5ExOsIxwEMB1CCxMzuQEsHuGuLVmRgD3wk6um1HAfTsqp8VOtZEUAmthJ8QASuGShMDtsBNhdhG4LVyv8TOAK2HnwgAAVoXrNdonIkxoyLATYPywEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKcMd1AbtNFwanC9ZqmmzJOIm4hEe/F8ECPsTaMCHG9BuaWfsPK+jbcWueLCJIasXHrWhxvjtjaY2u/H1Jwqsh8tXEqRQR57+oQPhx7XWtMrdeQbpIBAN89LWF2cUtrTK1d1uziVpuM1IiNicuDiBvsd08C12sgt+kimy/7XmP2WRnpZD/SyZiWdrR1Wdl8GbPf+z8td965gPHUoI7wZHC9BjLzGyg43t6xeKwHDz66pCW+ti7rybOy7/HU2PlTJwMAbCuC6clR2NH/3jpnu46CU9USX5uQ/Ka797cdlbhx9Zyu0OSwrQhuvOV/fbmW138cjEwME8O9JsKSIhUY8uqaZ/FMnRgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBhGNuwUilVk5jdMhCaD6zWMxDWzg6rW9H3Xlzk83GURw8gZYkflqf/Ctes1fHtEdGFESGK4F9OToyZCkyG36eK+geskd1nEYCHE0CakdYtXoVg1Niykwsr6tu+xbel5K7UJad1R5Naa+PZpSVdochQrdWTz/j2V6Yt6duFqEzIR2OD5eNnB42VHV3gyFJwqZr751bc1OjViayu3obWSQ2Z+o21CGI/1IJ3sx1kroquZ0HherOLHX/5sO35vclRbmQ2tQlyvgbtfrHVNJQdA/158raMs24rg0w8uIhG3dIYli4nCCMaK8WfzZXy57MDZrpsIHxp2VCKdjOHWtbiRMk3Gfx2hWKmjqEGKU6n7Snck4ham9qnEk82XkW2pLDE1dh6J+PGXcs5aUkucgzBewGx4oEfLJykH/2AhnYzteyF1KnWfENdrGqltZYKOmakHR2/Dsf0lBysP7XTQJLVjhBQr/m7voHJPbwQGFSZWZU3ROUIC16GDuiDbirQt5XQKHSMkWG3oVbTej3FrzY5ZW+sIIcE38zA3v4Jzoecd0m0ZH2Udldb6U8HiYHZUvrI+VbBcUnB1luqoi+SvtM0ubvmGrSYYvzyIO+9eMNrGUSDXZc0tvTAuA/ineOXc0gvj7fxfyAmZSA0e6qJ9XOyobLtlQAGSXVbBqWJlvX2ZWyfpZL/xZZCjQFJIN0Ouy+p2WAgxWAgxWAgxWAgxWAgxWAgxWAgxWAgxpBA43ZsBOwghsCEBLISdCLPHgtipNpJCYC3sTBhAKVyStiXXhcDDsJPpdoTAQ9uS60IpBddrDgmBJwCuhJ1Yl7KqFCZsS5YkANiWLCmFCQCrISfWjezJAFqGvbYlS31ROS4EHoWXW3chBB71ReX4vzIAQCjVfn/Ke9l8Wyl8AuCmUhg4ySRPO0KgAmBBCHxmnZE/BZ//GydsuCCCbJCsAAAAAElFTkSuQmCC"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAKHElEQVR4nO2cT2zb1h3Hv6QrMeEsC/aoBIaKyHYuloHCxZK6l1o+JIe4AzpkzsGXOmhP7iXDussCNKcUSC/JgKBAfRpQp4ccahQL0KoH9xB5lxrKEC2AlEvkKIhg1OJsSHI5yZrMHRQq4uMjRcmSSdnvc7P475Ff/t7vz/vRnKqqIPlPsTJ00tv3MTj8gQPeM+zAaBsV+CdU/OO/e9W//9bn2Sa3c6Qgyt7+TQDXOGDgsAZ5HFGBAoC7ope/0fh7XRClvD8IDg+YRRwuryzmA1HgdwCAB4DLd5IcE8MZOOA9cHhw+U6SA15ZiLK3f5MDPnN6cMcZFfhc9PI3uF9L1TGOwzOnB8QAVBVneXD4yOmBMF7B4SNOKVf/DeAtp8fCAAA84ZRy1ZiIMByDd3oADD1MEJfBBHEZTBCXwQRxGUwQl8EEcRlMEJfBBHEZTBCXwQRxGUwQl8EEcRlMEJfBBHEZTBCXwQRxGW84PYDDJFeoIFesIJVVqNvDQRG/EXiEpBOHPLLXHHlB4uki4uldxNNFKHv7to4RvTzCQRHvjPlwfqwfotDX5VG+5kiuqecKFUQT24il8rZFsCIy7sfs24OHYjlHShClXEU0sYOVdbkr54+M+zE3JSEw4OnK+YEjJEg8XcTS6qalRYSDIiaCIgI+DyTioSrlKjJyGcmsgkyuZHoe0ctj7l0Js5NDHR2/xpEQZHntF/yY2KFuCwdFzIz7W/YFmu+JPc1Tt58b7ccnF4c77l96WhClXMVXq5t4tLFr2BYOipibkjARFA90jVyhgpV1mSpMSBJw4/KZjorSs4Io5SpufvcCGbms+1308li8OIzzY76OXi8jl7C0ukm93q350Y75lZ4V5Pb3Lw2W0Y03lmRpddNgLZ28bk8KQvMZkXE/Fi8OWx6XK9SSwlyxYtimOXw7RBPbuLe2ZTj+xuUzto63oucEiaeLuPNDVveblRhKuYqHT/OIPt6BTBGCJDLuRyTsbypOLJXH0k+but/mpiTMTUlNr2FFTwmilKu49vUzXUgakgTcmh+l7h9NbGPlZ7mt5DAcFLF4YdjSN9Cmr1vzIwdKIF1TXMwVmr+90cSO7uGKXp46TWgO/97aVtuZeiqr4Pr9DcRS9LAXABYvDiMkCbrflomprFVcUctaWZcRfbyNwIDn1U0a3zAt/GxkkZIHmEVfACD5PDg/1o+JoKg7LiOXkHypGIIEZW+/Pi1Fwn7q2D99/038afn1B2iprIJkVmk73HZ8yiLnYjPnSDpy2n5mYkg+DxamTzUNha1KL4sXhk1FWVmXdcccxME7PmV9S9x8KqtQpy9y6qA5z+W1LYMYkXE/7l49aysvEYU+zE1JuDU/Asmn9x1LP20iI5eox81ODkL0vn6Uqaxium8zHBUklspTI59oQv8PDsjSeUgSDFNCMqsYHKydUJhGSDqBL+ZHDP5haXWTur8o9Bms56GF77HCUUFI69AgrSGe1s/ttMIe+bDOjfZbhsLRxHZ9qokmtg1WKQp9NR/V8OZn5LKpkyfHRI7ZLo45dTPrAGrONJbK19+6JLHCd36sX/d3MqvoziV6eXxiIoYWQJDR1721LVyaHMTC9On6byHpBObelXRJ4LfrMtWXBAY8CElCfcqUixXkCpWWSyqOCUJaR+PNALVpS7vxmYYHIAo8tUTR6FNCkkDdx6oqDAA/JnaglPd1ljU7OaRLKuViBRm5RI0Ew0FRdw8ZudQbgpDWoeUTjUlfRi7Xb7xZ9jtho+yRzCqWYtTH9jSPiaCos4KZsF8XRcXTu1RBJoKi7hoZudxykdMRQUjrmH17qO4YG29oeW3rwOVzjXi6aHvfRusEalNkoyDPc/QIirRKO8kuSVuCxFJ5PDRZuAFqU8aVKYk6bZDWIfk8dQuYnRzSCZLKKqYdIt2EDJ1JazDL/smXh1bEbEbLgiSziqGoRqI9SFqNibSOKw3TUWDAg3BQdEQEkoNk2weh5bBXtmmGmg9ohGYdZMSyMH3KkJQ5gRNiAG1YiPYAm1kJUEuOFqZfm7uVdWhoSdlzSi3qIKysy7Ytj0wID5O2fEgk7KfG4hm5hOv3n9f/jqd363G9HevQEIW+zr+hUxI+/+6FrV3JJI+09MZksZ39rOhoph6STuimGy1mB+xZRzeZCIq4NDnYdD9tgaoRMuseCdDXO8ioymw/KzpeOiGz6IepfEvW0U0Wpk/jw+lTpm/upclBarmFrEuR96hBRmeBNnxhx/OQGSKXqPXV6t+wVq3j9vcvdaEmWdpOZhXddCR6edy9epYads9ODmFm3I94ercelooCj/OjPmpWHU1sG14msxVBMtcJBVr3RR0XRJu2GksNjbRrHY0OOZ4u6jLgiaCou6ayt4+vVjfxl9+/ST0XrTpLIyOXsPKzvak2V6joLMRKOCu6Uu01M2mgPd/xDlF+oJW2yanm0cauabncDkq5amhNDUmCqZDxDb11tBuUdEWQGZNBt2sdpMCPNnYNDnQiKCIyrj937Gm+9lDL1Zaul5FLuPb1M4NPsFpbiT4m2pLa9JFdEYSMtjTajaxEoc/wsGnLrAvTpww5ROxpHn+9/9xWLUspV7GyLuP6/eeG8sjiBfpaP0AP6V23pk6WuiWfB3evnm37fLlCRddMAACfXT5juPFONjloWK2n01qTrPZvRtcEyRUquH5/oz7QT98PHrjfluyDknwefDE/Qu08MWvCbgXRy2Nh+rTlwyVbWg/64nW160Tr4oiM+zvSjEyKDFivm3e7UY7WvUiz2lZwvA2oVWh9tVYtnForaSyVp05jJHZbSWktredG+01Dbbv0nCAAvfP9w+lTTb9q6lSzNe1rrU51wPekIGaOu922n1agTVOil8eNP57pyEehPSkIYC5KSBJM21EPej1aoNBJMYAeFgSwDnHnpqRaR2EHPqKJpfJYXvvFEBx0WgygxwUBaqLc/iFLXXwSvTwiYT9mJ4dajvJyhQriG0XT70q6ZYk9L4gG2fBMQiaFpAPPyKV6gTCeLlpGZN36Ahc4QoIAtYe6vLbVtSYJyVf7XKKb6+1HShCNZFZpaQ29GZLPgytT0qEsqh1JQTS0/3kST+/a+r6wEa1AaCdJ7CRHWpBGav6hhIxcrv+bpkZEL4+RwAkEfB6EAoJj/6Lp2AjSKzj+BRVDDxPEZTBBXAYTxGUwQVwGE8RlMEFcBhPEZTBBXAYTxGUwQVwGE8RlMEFcBhPEZTBBXAYTxGUwQVwGz3Gw9/E2o+twHF7wAB44PRBGnQfcr6XqGMfhWfN9Gd1GVXGWFwU+zXH40unBHHc4Dl+KAp/mVFWFUt4f5Dg8BPCW0wM7pjxRVcyIAr/DA4Ao8DuqihkATxwe2HGkLgbQEPaKAr9z0stHOA7fODe24wXH4ZuTXj6iiQEAnKoa++TK/9v/narizwA+UFUMHOYgjzochwKABxyHvwlv8P8it/8fLz08H7TKDkYAAAAASUVORK5CYII="

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAHAElEQVR4nO2cT0wbRxTGv1kHL9niWNClUUSEA7lApAhUEL0kcGgOpZFSUedQVWqk9JReIjXncEoOvTSVqkjNqVJpjkFROZQc0gPQSxGqQiPhXEJjJCtKvI0FDlMWd9ke+BN21oCN7Z23YX4n73q9fvB53rz35s0y13Uh8k++0HQ4GvkSDJ8w4IzvAsW+cYHf4eKXf1edH9+N1b0S32eiIHx17QaAqww4EpSRBxEXWALwvRHVhref3xKE22uNYBhTIyJYNkbMBUPXcgCgAcDQrTmmxJADA86AYWzo1hwDNkYIX127wYDrso07yLjATSOqDbPlFaedMTyVbZACcF2c1MBwWbYhig0YLjNuO38BOC3bFgUA4DHjtuNPRBTS0GQboPCiBCGGEoQYShBiKEGIoQQhhhKEGEoQYihBiKEEIYYShBiHZBtQKWlrBdmlArL5AhJmPU61GLJNqojQCjIzn8fI1EtY+YLnvBHVMNjdhGSfKcmyyghltXd02sLotLXrNZ0tBoaHWgOyqHqEbg6Zmc/vKQYApDIcI1MvArCouoROkJGpl55jM1aHZJ+JL86+h05h/ngwm0N2yevSqBMqQdLWimfOMKIavvnsBJJ9Jga7mjA81OoTZebvfNBmVkSoBFm21zzHg91NMPSI55w4mXPhM9QJlSAHgVALMjPvd0fFzoWJUOUhp1oMGFENfHXdDaUtGzfuL2CwqxGGHsFkahGTTxY9n+ltb5Bh6r4JlSAAkPzAxM/bIq1UhiOV4UWv7WlrQMKsD8q0qhCaxJDbDsZncxh/9GprhJRCT1sDLp09iuYjdTW0rnqEQpC5DMedh899ZZJySPaZoSinkBdkMrWIO7893/F9Me9IZ1d2HEH9HXFcOXesqvZVG9JzyFyGFxWjvyOO3vYG9LbHin4uu1TA5JNFn3vbnPApi0J2hHDbwdWfnnr+oUZUw7Xzx0susXPbwbe/ZnyT/rWPW3YUUzZk85B705ZPjOFPW8ta7zD0CIaHWtHT5g19xXoYJUgKwm0HD2ZznnPXzh/fdwj71bljMGNvoiwrX8BkanGXT8iDpCATQnLX09ZQ0UqgoUdwUYiwxmd9G2BJQFIQ8dc72N1U8T37O+OeUZK2bJKleZKCpC1767UZq6vaOrlYRklbK1W5bzUhJ8icEBFVs2lBvNd24alAThBLcCPVLHmIQcGzrBohe5IVyiNiJl4Jorjl1MSCgpwgBx0lCDHICbJsOzW9vxF98yen1RyyN2Lkc8LUq3r/RPObiV3NISUgJmtiV0mlbB8hAL1chJQg3HY8i1DVjLA2OdHsDX3TWVq5CClBxKSwOVb9ZdeE4ALF75QNaUFqsbVAvKcSZBdm5l97jmvhsgw94hklVr5AqshIRhCxb9eM1dWsU0QUWuzlkgkZQcYfeRekatngNtAZ9xxPEFqsIiEItx1fC+hgV+VrIDuRMOt9K4hUWlBJCDI+m/MkaZ0tRs0b2wa7G302UEC6INmlAsYfeZdTg2hoG+iIe5LEVIaTGCXSBRmZeuEbHUHspDX0iG9peGTqJXiNa2l7IbUvay7DcfP+gudcLaMrEW47vtrZR12NuHT2aCDfXwxpnYvcdnDnob8r0coXKurhrZQHszkMdMaldc1Lc1njszmp//jdKPZDCQopgqStlZK2NssibdnS+rakuCzxF0hhk7/4MILRPyz0tsUC31cS+AgZnbZ8E+mVD+V3oyf7TE+Ni6+u7boNolYEKkgxV5XsM8nsbhK3KaQyPHDXFajLEl1VwtTLSgK57eDZPprbmksMpRNmPZJ9ps91nWoxAou6AstDSnlgDFWCnOMCc1mUKqrlksrwwNbepZdOFF4Cc1nrJfbXnlbRcpdPt29N23xQWTEmUosVNUskTB3vbHS7GLoWaPgb2KRu6BH0CwtDyTLv8fntJ1uvE831OwYEcxnuEUR2jlMOymURI1SCbF/lS2V40VI5tx2PazNr0EpUS0IliLhO8oOQ13Db8Z0L21NKye5TL8ZO6ycDnXEsbwQNYgX5+lB5W6llEypBgPVsv9S2nTA8SkMkVC4LWK839XfE97yup60hdGIAIRwhm0ymFnFv2vK5KDNWh4t9pi/EDguhFWSTzceMA6UXESkTekHeNkI3h7ztKEGIoQQhhhKEGEoQYihBiKEEIYYShBhKEGIoQYihBCGGxhgW9r5MEQSMYUEDMCbbEMUWY2x5xWlnDE9lW6IAXBcnNUPX5hnDbdnGHHQYw21D1+aZ67rg9lojY5gAcFq2YQeUx66LAUPXchoAGLqWc10MAHgs2bCDyJYYwLaw19C13OGo1s8Y7sqz7WDBGO4ejmr9m2IAAHNd/wqu/d/a+66LrwFccF0cCdLItx3GsARgjDF8px/S/hTf/x830bdctMahewAAAABJRU5ErkJggg=="

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(19);

var curve = __webpack_require__(88);

/**
 * @author Yi Shen(https://github.com/pissang)
 */
var mathMin = Math.min;
var mathMax = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start = vec2.create();
var end = vec2.create();
var extremity = vec2.create();
/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */

function fromPoints(points, min, max) {
  if (points.length === 0) {
    return;
  }

  var p = points[0];
  var left = p[0];
  var right = p[0];
  var top = p[1];
  var bottom = p[1];
  var i;

  for (i = 1; i < points.length; i++) {
    p = points[i];
    left = mathMin(left, p[0]);
    right = mathMax(right, p[0]);
    top = mathMin(top, p[1]);
    bottom = mathMax(bottom, p[1]);
  }

  min[0] = left;
  min[1] = top;
  max[0] = right;
  max[1] = bottom;
}
/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromLine(x0, y0, x1, y1, min, max) {
  min[0] = mathMin(x0, x1);
  min[1] = mathMin(y0, y1);
  max[0] = mathMax(x0, x1);
  max[1] = mathMax(y0, y1);
}

var xDim = [];
var yDim = [];
/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */

function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
  var cubicExtrema = curve.cubicExtrema;
  var cubicAt = curve.cubicAt;
  var i;
  var n = cubicExtrema(x0, x1, x2, x3, xDim);
  min[0] = Infinity;
  min[1] = Infinity;
  max[0] = -Infinity;
  max[1] = -Infinity;

  for (i = 0; i < n; i++) {
    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
    min[0] = mathMin(x, min[0]);
    max[0] = mathMax(x, max[0]);
  }

  n = cubicExtrema(y0, y1, y2, y3, yDim);

  for (i = 0; i < n; i++) {
    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
    min[1] = mathMin(y, min[1]);
    max[1] = mathMax(y, max[1]);
  }

  min[0] = mathMin(x0, min[0]);
  max[0] = mathMax(x0, max[0]);
  min[0] = mathMin(x3, min[0]);
  max[0] = mathMax(x3, max[0]);
  min[1] = mathMin(y0, min[1]);
  max[1] = mathMax(y0, max[1]);
  min[1] = mathMin(y3, min[1]);
  max[1] = mathMax(y3, max[1]);
}
/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
  var quadraticExtremum = curve.quadraticExtremum;
  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero

  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
  var x = quadraticAt(x0, x1, x2, tx);
  var y = quadraticAt(y0, y1, y2, ty);
  min[0] = mathMin(x0, x2, x);
  min[1] = mathMin(y0, y2, y);
  max[0] = mathMax(x0, x2, x);
  max[1] = mathMax(y0, y2, y);
}
/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
  var vec2Min = vec2.min;
  var vec2Max = vec2.max;
  var diff = Math.abs(startAngle - endAngle);

  if (diff % PI2 < 1e-4 && diff > 1e-4) {
    // Is a circle
    min[0] = x - rx;
    min[1] = y - ry;
    max[0] = x + rx;
    max[1] = y + ry;
    return;
  }

  start[0] = mathCos(startAngle) * rx + x;
  start[1] = mathSin(startAngle) * ry + y;
  end[0] = mathCos(endAngle) * rx + x;
  end[1] = mathSin(endAngle) * ry + y;
  vec2Min(min, start, end);
  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]

  startAngle = startAngle % PI2;

  if (startAngle < 0) {
    startAngle = startAngle + PI2;
  }

  endAngle = endAngle % PI2;

  if (endAngle < 0) {
    endAngle = endAngle + PI2;
  }

  if (startAngle > endAngle && !anticlockwise) {
    endAngle += PI2;
  } else if (startAngle < endAngle && anticlockwise) {
    startAngle += PI2;
  }

  if (anticlockwise) {
    var tmp = endAngle;
    endAngle = startAngle;
    startAngle = tmp;
  } // var number = 0;
  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;


  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
    if (angle > startAngle) {
      extremity[0] = mathCos(angle) * rx + x;
      extremity[1] = mathSin(angle) * ry + y;
      vec2Min(min, extremity, min);
      vec2Max(max, extremity, max);
    }
  }
}

exports.fromPoints = fromPoints;
exports.fromLine = fromLine;
exports.fromCubic = fromCubic;
exports.fromQuadratic = fromQuadratic;
exports.fromArc = fromArc;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// https://github.com/mziccard/node-timsort
var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
var DEFAULT_TMP_STORAGE_LENGTH = 256;

function minRunLength(n) {
  var r = 0;

  while (n >= DEFAULT_MIN_MERGE) {
    r |= n & 1;
    n >>= 1;
  }

  return n + r;
}

function makeAscendingRun(array, lo, hi, compare) {
  var runHi = lo + 1;

  if (runHi === hi) {
    return 1;
  }

  if (compare(array[runHi++], array[lo]) < 0) {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
      runHi++;
    }

    reverseRun(array, lo, runHi);
  } else {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
      runHi++;
    }
  }

  return runHi - lo;
}

function reverseRun(array, lo, hi) {
  hi--;

  while (lo < hi) {
    var t = array[lo];
    array[lo++] = array[hi];
    array[hi--] = t;
  }
}

function binaryInsertionSort(array, lo, hi, start, compare) {
  if (start === lo) {
    start++;
  }

  for (; start < hi; start++) {
    var pivot = array[start];
    var left = lo;
    var right = start;
    var mid;

    while (left < right) {
      mid = left + right >>> 1;

      if (compare(pivot, array[mid]) < 0) {
        right = mid;
      } else {
        left = mid + 1;
      }
    }

    var n = start - left;

    switch (n) {
      case 3:
        array[left + 3] = array[left + 2];

      case 2:
        array[left + 2] = array[left + 1];

      case 1:
        array[left + 1] = array[left];
        break;

      default:
        while (n > 0) {
          array[left + n] = array[left + n - 1];
          n--;
        }

    }

    array[left] = pivot;
  }
}

function gallopLeft(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) > 0) {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  } else {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) > 0) {
      lastOffset = m + 1;
    } else {
      offset = m;
    }
  }

  return offset;
}

function gallopRight(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) < 0) {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  } else {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) < 0) {
      offset = m;
    } else {
      lastOffset = m + 1;
    }
  }

  return offset;
}

function TimSort(array, compare) {
  var minGallop = DEFAULT_MIN_GALLOPING;
  var length = 0;
  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
  var stackLength = 0;
  var runStart;
  var runLength;
  var stackSize = 0;
  length = array.length;

  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
    tmpStorageLength = length >>> 1;
  }

  var tmp = [];
  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
  runStart = [];
  runLength = [];

  function pushRun(_runStart, _runLength) {
    runStart[stackSize] = _runStart;
    runLength[stackSize] = _runLength;
    stackSize += 1;
  }

  function mergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
        if (runLength[n - 1] < runLength[n + 1]) {
          n--;
        }
      } else if (runLength[n] > runLength[n + 1]) {
        break;
      }

      mergeAt(n);
    }
  }

  function forceMergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
        n--;
      }

      mergeAt(n);
    }
  }

  function mergeAt(i) {
    var start1 = runStart[i];
    var length1 = runLength[i];
    var start2 = runStart[i + 1];
    var length2 = runLength[i + 1];
    runLength[i] = length1 + length2;

    if (i === stackSize - 3) {
      runStart[i + 1] = runStart[i + 2];
      runLength[i + 1] = runLength[i + 2];
    }

    stackSize--;
    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
    start1 += k;
    length1 -= k;

    if (length1 === 0) {
      return;
    }

    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

    if (length2 === 0) {
      return;
    }

    if (length1 <= length2) {
      mergeLow(start1, length1, start2, length2);
    } else {
      mergeHigh(start1, length1, start2, length2);
    }
  }

  function mergeLow(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length1; i++) {
      tmp[i] = array[start1 + i];
    }

    var cursor1 = 0;
    var cursor2 = start2;
    var dest = start1;
    array[dest++] = array[cursor2++];

    if (--length2 === 0) {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }

      return;
    }

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
      return;
    }

    var _minGallop = minGallop;
    var count1, count2, exit;

    while (1) {
      count1 = 0;
      count2 = 0;
      exit = false;

      do {
        if (compare(array[cursor2], tmp[cursor1]) < 0) {
          array[dest++] = array[cursor2++];
          count2++;
          count1 = 0;

          if (--length2 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest++] = tmp[cursor1++];
          count1++;
          count2 = 0;

          if (--length1 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

        if (count1 !== 0) {
          for (i = 0; i < count1; i++) {
            array[dest + i] = tmp[cursor1 + i];
          }

          dest += count1;
          cursor1 += count1;
          length1 -= count1;

          if (length1 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest++] = array[cursor2++];

        if (--length2 === 0) {
          exit = true;
          break;
        }

        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

        if (count2 !== 0) {
          for (i = 0; i < count2; i++) {
            array[dest + i] = array[cursor2 + i];
          }

          dest += count2;
          cursor2 += count2;
          length2 -= count2;

          if (length2 === 0) {
            exit = true;
            break;
          }
        }

        array[dest++] = tmp[cursor1++];

        if (--length1 === 1) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;
    minGallop < 1 && (minGallop = 1);

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
    } else if (length1 === 0) {
      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
    } else {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }
    }
  }

  function mergeHigh(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length2; i++) {
      tmp[i] = array[start2 + i];
    }

    var cursor1 = start1 + length1 - 1;
    var cursor2 = length2 - 1;
    var dest = start2 + length2 - 1;
    var customCursor = 0;
    var customDest = 0;
    array[dest--] = array[cursor1--];

    if (--length1 === 0) {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }

      return;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
      return;
    }

    var _minGallop = minGallop;

    while (true) {
      var count1 = 0;
      var count2 = 0;
      var exit = false;

      do {
        if (compare(tmp[cursor2], array[cursor1]) < 0) {
          array[dest--] = array[cursor1--];
          count1++;
          count2 = 0;

          if (--length1 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest--] = tmp[cursor2--];
          count2++;
          count1 = 0;

          if (--length2 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

        if (count1 !== 0) {
          dest -= count1;
          cursor1 -= count1;
          length1 -= count1;
          customDest = dest + 1;
          customCursor = cursor1 + 1;

          for (i = count1 - 1; i >= 0; i--) {
            array[customDest + i] = array[customCursor + i];
          }

          if (length1 === 0) {
            exit = true;
            break;
          }
        }

        array[dest--] = tmp[cursor2--];

        if (--length2 === 1) {
          exit = true;
          break;
        }

        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

        if (count2 !== 0) {
          dest -= count2;
          cursor2 -= count2;
          length2 -= count2;
          customDest = dest + 1;
          customCursor = cursor2 + 1;

          for (i = 0; i < count2; i++) {
            array[customDest + i] = tmp[customCursor + i];
          }

          if (length2 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest--] = array[cursor1--];

        if (--length1 === 0) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;

    if (minGallop < 1) {
      minGallop = 1;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
    } else if (length2 === 0) {
      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
    } else {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }
    }
  }

  this.mergeRuns = mergeRuns;
  this.forceMergeRuns = forceMergeRuns;
  this.pushRun = pushRun;
}

function sort(array, compare, lo, hi) {
  if (!lo) {
    lo = 0;
  }

  if (!hi) {
    hi = array.length;
  }

  var remaining = hi - lo;

  if (remaining < 2) {
    return;
  }

  var runLength = 0;

  if (remaining < DEFAULT_MIN_MERGE) {
    runLength = makeAscendingRun(array, lo, hi, compare);
    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
    return;
  }

  var ts = new TimSort(array, compare);
  var minRun = minRunLength(remaining);

  do {
    runLength = makeAscendingRun(array, lo, hi, compare);

    if (runLength < minRun) {
      var force = remaining;

      if (force > minRun) {
        force = minRun;
      }

      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
      runLength = force;
    }

    ts.pushRun(lo, runLength);
    ts.mergeRuns();
    remaining -= runLength;
    lo += runLength;
  } while (remaining !== 0);

  ts.forceMergeRuns();
}

module.exports = sort;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(690);

var globalImageCache = new LRU(50);
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */

function findExistImage(newImageOrSrc) {
  if (typeof newImageOrSrc === 'string') {
    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    return cachedImgObj && cachedImgObj.image;
  } else {
    return newImageOrSrc;
  }
}
/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */


function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
  if (!newImageOrSrc) {
    return image;
  } else if (typeof newImageOrSrc === 'string') {
    // Image should not be loaded repeatly.
    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
      return image;
    } // Only when there is no existent image or existent image src
    // is different, this method is responsible for load.


    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    var pendingWrap = {
      hostEl: hostEl,
      cb: cb,
      cbPayload: cbPayload
    };

    if (cachedImgObj) {
      image = cachedImgObj.image;
      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
    } else {
      !image && (image = new Image());
      image.onload = imageOnLoad;
      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
        image: image,
        pending: [pendingWrap]
      });
      image.src = image.__zrImageSrc = newImageOrSrc;
    }

    return image;
  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
  else {
      return newImageOrSrc;
    }
}

function imageOnLoad() {
  var cachedImgObj = this.__cachedImgObj;
  this.onload = this.__cachedImgObj = null;

  for (var i = 0; i < cachedImgObj.pending.length; i++) {
    var pendingWrap = cachedImgObj.pending[i];
    var cb = pendingWrap.cb;
    cb && cb(this, pendingWrap.cbPayload);
    pendingWrap.hostEl.dirty();
  }

  cachedImgObj.pending.length = 0;
}

function isImageReady(image) {
  return image && image.width && image.height;
}

exports.findExistImage = findExistImage;
exports.createOrUpdateImage = createOrUpdateImage;
exports.isImageReady = isImageReady;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var matrix = __webpack_require__(53);

var vector = __webpack_require__(19);

/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */
var mIdentity = matrix.identity;
var EPSILON = 5e-5;

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */


var Transformable = function (opts) {
  opts = opts || {}; // If there are no given position, rotation, scale

  if (!opts.position) {
    /**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */
    this.position = [0, 0];
  }

  if (opts.rotation == null) {
    /**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */
    this.rotation = 0;
  }

  if (!opts.scale) {
    /**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */
    this.scale = [1, 1];
  }
  /**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */


  this.origin = this.origin || null;
};

var transformableProto = Transformable.prototype;
transformableProto.transform = null;
/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */

transformableProto.needLocalTransform = function () {
  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
};

transformableProto.updateTransform = function () {
  var parent = this.parent;
  var parentHasTransform = parent && parent.transform;
  var needLocalTransform = this.needLocalTransform();
  var m = this.transform;

  if (!(needLocalTransform || parentHasTransform)) {
    m && mIdentity(m);
    return;
  }

  m = m || matrix.create();

  if (needLocalTransform) {
    this.getLocalTransform(m);
  } else {
    mIdentity(m);
  } // 应用父节点变换


  if (parentHasTransform) {
    if (needLocalTransform) {
      matrix.mul(m, parent.transform, m);
    } else {
      matrix.copy(m, parent.transform);
    }
  } // 保存这个变换矩阵


  this.transform = m;
  this.invTransform = this.invTransform || matrix.create();
  matrix.invert(this.invTransform, m);
};

transformableProto.getLocalTransform = function (m) {
  return Transformable.getLocalTransform(this, m);
};
/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */


transformableProto.setTransform = function (ctx) {
  var m = this.transform;
  var dpr = ctx.dpr || 1;

  if (m) {
    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
  } else {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
};

transformableProto.restoreTransform = function (ctx) {
  var dpr = ctx.dpr || 1;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};

var tmpTransform = [];
/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */

transformableProto.decomposeTransform = function () {
  if (!this.transform) {
    return;
  }

  var parent = this.parent;
  var m = this.transform;

  if (parent && parent.transform) {
    // Get local transform and decompose them to position, scale, rotation
    matrix.mul(tmpTransform, parent.invTransform, m);
    m = tmpTransform;
  }

  var sx = m[0] * m[0] + m[1] * m[1];
  var sy = m[2] * m[2] + m[3] * m[3];
  var position = this.position;
  var scale = this.scale;

  if (isNotAroundZero(sx - 1)) {
    sx = Math.sqrt(sx);
  }

  if (isNotAroundZero(sy - 1)) {
    sy = Math.sqrt(sy);
  }

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  position[0] = m[4];
  position[1] = m[5];
  scale[0] = sx;
  scale[1] = sy;
  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
};
/**
 * Get global scale
 * @return {Array.<number>}
 */


transformableProto.getGlobalScale = function () {
  var m = this.transform;

  if (!m) {
    return [1, 1];
  }

  var sx = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
  var sy = Math.sqrt(m[2] * m[2] + m[3] * m[3]);

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  return [sx, sy];
};
/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToLocal = function (x, y) {
  var v2 = [x, y];
  var invTransform = this.invTransform;

  if (invTransform) {
    vector.applyTransform(v2, v2, invTransform);
  }

  return v2;
};
/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToGlobal = function (x, y) {
  var v2 = [x, y];
  var transform = this.transform;

  if (transform) {
    vector.applyTransform(v2, v2, transform);
  }

  return v2;
};
/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */


Transformable.getLocalTransform = function (target, m) {
  m = m || [];
  mIdentity(m);
  var origin = target.origin;
  var scale = target.scale || [1, 1];
  var rotation = target.rotation || 0;
  var position = target.position || [0, 0];

  if (origin) {
    // Translate to origin
    m[4] -= origin[0];
    m[5] -= origin[1];
  }

  matrix.scale(m, m, scale);

  if (rotation) {
    matrix.rotate(m, m, rotation);
  }

  if (origin) {
    // Translate back from origin
    m[4] += origin[0];
    m[5] += origin[1];
  }

  m[4] += position[0];
  m[5] += position[1];
  return m;
};

var _default = Transformable;
module.exports = _default;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

var svgURI = 'http://www.w3.org/2000/svg';

function createElement(name) {
  return document.createElementNS(svgURI, name);
}

exports.createElement = createElement;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(324);

var createElement = _core.createElement;

var PathProxy = __webpack_require__(125);

var BoundingRect = __webpack_require__(26);

var textContain = __webpack_require__(70);

var textHelper = __webpack_require__(214);

var Text = __webpack_require__(153);

// TODO
// 1. shadow
// 2. Image: sx, sy, sw, sh
var CMD = PathProxy.CMD;
var arrayJoin = Array.prototype.join;
var NONE = 'none';
var mathRound = Math.round;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;
var PI2 = Math.PI * 2;
var degree = 180 / PI;
var EPSILON = 1e-4;

function round4(val) {
  return mathRound(val * 1e4) / 1e4;
}

function isAroundZero(val) {
  return val < EPSILON && val > -EPSILON;
}

function pathHasFill(style, isText) {
  var fill = isText ? style.textFill : style.fill;
  return fill != null && fill !== NONE;
}

function pathHasStroke(style, isText) {
  var stroke = isText ? style.textStroke : style.stroke;
  return stroke != null && stroke !== NONE;
}

function setTransform(svgEl, m) {
  if (m) {
    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
  }
}

function attr(el, key, val) {
  if (!val || val.type !== 'linear' && val.type !== 'radial') {
    // Don't set attribute for gradient, since it need new dom nodes
    el.setAttribute(key, val);
  }
}

function attrXLink(el, key, val) {
  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
}

function bindStyle(svgEl, style, isText) {
  if (pathHasFill(style, isText)) {
    var fill = isText ? style.textFill : style.fill;
    fill = fill === 'transparent' ? NONE : fill;
    /**
     * FIXME:
     * This is a temporary fix for Chrome's clipping bug
     * that happens when a clip-path is referring another one.
     * This fix should be used before Chrome's bug is fixed.
     * For an element that has clip-path, and fill is none,
     * set it to be "rgba(0, 0, 0, 0.002)" will hide the element.
     * Otherwise, it will show black fill color.
     * 0.002 is used because this won't work for alpha values smaller
     * than 0.002.
     *
     * See
     * https://bugs.chromium.org/p/chromium/issues/detail?id=659790
     * for more information.
     */

    if (svgEl.getAttribute('clip-path') !== 'none' && fill === NONE) {
      fill = 'rgba(0, 0, 0, 0.002)';
    }

    attr(svgEl, 'fill', fill);
    attr(svgEl, 'fill-opacity', style.opacity);
  } else {
    attr(svgEl, 'fill', NONE);
  }

  if (pathHasStroke(style, isText)) {
    var stroke = isText ? style.textStroke : style.stroke;
    stroke = stroke === 'transparent' ? NONE : stroke;
    attr(svgEl, 'stroke', stroke);
    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
    var strokeScale = style.strokeNoScale ? style.host.getLineScale() : 1;
    attr(svgEl, 'stroke-width', strokeWidth / strokeScale);
    attr(svgEl, 'paint-order', 'stroke');
    attr(svgEl, 'stroke-opacity', style.opacity);
    var lineDash = style.lineDash;

    if (lineDash) {
      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
    } else {
      attr(svgEl, 'stroke-dasharray', '');
    } // PENDING


    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
  } else {
    attr(svgEl, 'stroke', NONE);
  }
}
/***************************************************
 * PATH
 **************************************************/


function pathDataToString(path) {
  var str = [];
  var data = path.data;
  var dataLength = path.len();

  for (var i = 0; i < dataLength;) {
    var cmd = data[i++];
    var cmdStr = '';
    var nData = 0;

    switch (cmd) {
      case CMD.M:
        cmdStr = 'M';
        nData = 2;
        break;

      case CMD.L:
        cmdStr = 'L';
        nData = 2;
        break;

      case CMD.Q:
        cmdStr = 'Q';
        nData = 4;
        break;

      case CMD.C:
        cmdStr = 'C';
        nData = 6;
        break;

      case CMD.A:
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++];
        var psi = data[i++];
        var clockwise = data[i++];
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = isAroundZero(dThetaPositive % PI2) && !isAroundZero(dThetaPositive);
        var large = false;

        if (dThetaPositive >= PI2) {
          large = true;
        } else if (isAroundZero(dThetaPositive)) {
          large = false;
        } else {
          large = (dTheta > -PI && dTheta < 0 || dTheta > PI) === !!clockwise;
        }

        var x0 = round4(cx + rx * mathCos(theta));
        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
        // We need to shift the end point with a small value
        // FIXME A better way to draw circle ?

        if (isCircle) {
          if (clockwise) {
            dTheta = PI2 - 1e-4;
          } else {
            dTheta = -PI2 + 1e-4;
          }

          large = true;

          if (i === 9) {
            // Move to (x0, y0) only when CMD.A comes at the
            // first position of a shape.
            // For instance, when drawing a ring, CMD.A comes
            // after CMD.M, so it's unnecessary to move to
            // (x0, y0).
            str.push('M', x0, y0);
          }
        }

        var x = round4(cx + rx * mathCos(theta + dTheta));
        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse

        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
        break;

      case CMD.Z:
        cmdStr = 'Z';
        break;

      case CMD.R:
        var x = round4(data[i++]);
        var y = round4(data[i++]);
        var w = round4(data[i++]);
        var h = round4(data[i++]);
        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
        break;
    }

    cmdStr && str.push(cmdStr);

    for (var j = 0; j < nData; j++) {
      // PENDING With scale
      str.push(round4(data[i++]));
    }
  }

  return str.join(' ');
}

var svgPath = {};

svgPath.brush = function (el) {
  var style = el.style;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('path');
    el.__svgEl = svgEl;
  }

  if (!el.path) {
    el.createPathProxy();
  }

  var path = el.path;

  if (el.__dirtyPath) {
    path.beginPath();
    el.buildPath(path, el.shape);
    el.__dirtyPath = false;
    var pathStr = pathDataToString(path);

    if (pathStr.indexOf('NaN') < 0) {
      // Ignore illegal path, which may happen such in out-of-range
      // data in Calendar series.
      attr(svgEl, 'd', pathStr);
    }
  }

  bindStyle(svgEl, style);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  }
};
/***************************************************
 * IMAGE
 **************************************************/


var svgImage = {};

svgImage.brush = function (el) {
  var style = el.style;
  var image = style.image;

  if (image instanceof HTMLImageElement) {
    var src = image.src;
    image = src;
  }

  if (!image) {
    return;
  }

  var x = style.x || 0;
  var y = style.y || 0;
  var dw = style.width;
  var dh = style.height;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('image');
    el.__svgEl = svgEl;
  }

  if (image !== el.__imageSrc) {
    attrXLink(svgEl, 'href', image); // Caching image src

    el.__imageSrc = image;
  }

  attr(svgEl, 'width', dw);
  attr(svgEl, 'height', dh);
  attr(svgEl, 'x', x);
  attr(svgEl, 'y', y);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  }
};
/***************************************************
 * TEXT
 **************************************************/


var svgText = {};
var tmpRect = new BoundingRect();

var svgTextDrawRectText = function (el, rect, textRect) {
  var style = el.style;
  el.__dirty && textHelper.normalizeTextStyle(style, true);
  var text = style.text; // Convert to string

  if (text == null) {
    // Draw no text only when text is set to null, but not ''
    return;
  } else {
    text += '';
  }

  var textSvgEl = el.__textSvgEl;

  if (!textSvgEl) {
    textSvgEl = createElement('text');
    el.__textSvgEl = textSvgEl;
  }

  bindStyle(textSvgEl, style, true);

  if (el instanceof Text || el.style.transformText) {
    // Transform text with element
    setTransform(textSvgEl, el.transform);
  } else {
    if (el.transform) {
      tmpRect.copy(rect);
      tmpRect.applyTransform(el.transform);
      rect = tmpRect;
    } else {
      var pos = el.transformCoordToGlobal(rect.x, rect.y);
      rect.x = pos[0];
      rect.y = pos[1];
    }
  }

  var x;
  var y;
  var textPosition = style.textPosition;
  var distance = style.textDistance;
  var align = style.textAlign || 'left';

  if (typeof style.fontSize === 'number') {
    style.fontSize += 'px';
  }

  var font = style.font || [style.fontStyle || '', style.fontWeight || '', style.fontSize || '', style.fontFamily || ''].join(' ') || textContain.DEFAULT_FONT;
  var verticalAlign = getVerticalAlignForSvg(style.textVerticalAlign);
  textRect = textContain.getBoundingRect(text, font, align, verticalAlign);
  var lineHeight = textRect.lineHeight; // Text position represented by coord

  if (textPosition instanceof Array) {
    x = rect.x + textPosition[0];
    y = rect.y + textPosition[1];
  } else {
    var newPos = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
    x = newPos.x;
    y = newPos.y;
    verticalAlign = getVerticalAlignForSvg(newPos.textVerticalAlign);
    align = newPos.textAlign;
  }

  attr(textSvgEl, 'alignment-baseline', verticalAlign);

  if (font) {
    textSvgEl.style.font = font;
  }

  var textPadding = style.textPadding; // Make baseline top

  attr(textSvgEl, 'x', x);
  attr(textSvgEl, 'y', y);
  var textLines = text.split('\n');
  var nTextLines = textLines.length;
  var textAnchor = align; // PENDING

  if (textAnchor === 'left') {
    textAnchor = 'start';
    textPadding && (x += textPadding[3]);
  } else if (textAnchor === 'right') {
    textAnchor = 'end';
    textPadding && (x -= textPadding[1]);
  } else if (textAnchor === 'center') {
    textAnchor = 'middle';
    textPadding && (x += (textPadding[3] - textPadding[1]) / 2);
  }

  var dy = 0;

  if (verticalAlign === 'baseline') {
    dy = -textRect.height + lineHeight;
    textPadding && (dy -= textPadding[2]);
  } else if (verticalAlign === 'middle') {
    dy = (-textRect.height + lineHeight) / 2;
    textPadding && (y += (textPadding[0] - textPadding[2]) / 2);
  } else {
    textPadding && (dy += textPadding[0]);
  } // Font may affect position of each tspan elements


  if (el.__text !== text || el.__textFont !== font) {
    var tspanList = el.__tspanList || [];
    el.__tspanList = tspanList;

    for (var i = 0; i < nTextLines; i++) {
      // Using cached tspan elements
      var tspan = tspanList[i];

      if (!tspan) {
        tspan = tspanList[i] = createElement('tspan');
        textSvgEl.appendChild(tspan);
        attr(tspan, 'alignment-baseline', verticalAlign);
        attr(tspan, 'text-anchor', textAnchor);
      } else {
        tspan.innerHTML = '';
      }

      attr(tspan, 'x', x);
      attr(tspan, 'y', y + i * lineHeight + dy);
      tspan.appendChild(document.createTextNode(textLines[i]));
    } // Remove unsed tspan elements


    for (; i < tspanList.length; i++) {
      textSvgEl.removeChild(tspanList[i]);
    }

    tspanList.length = nTextLines;
    el.__text = text;
    el.__textFont = font;
  } else if (el.__tspanList.length) {
    // Update span x and y
    var len = el.__tspanList.length;

    for (var i = 0; i < len; ++i) {
      var tspan = el.__tspanList[i];

      if (tspan) {
        attr(tspan, 'x', x);
        attr(tspan, 'y', y + i * lineHeight + dy);
      }
    }
  }
};

function getVerticalAlignForSvg(verticalAlign) {
  if (verticalAlign === 'middle') {
    return 'middle';
  } else if (verticalAlign === 'bottom') {
    return 'baseline';
  } else {
    return 'hanging';
  }
}

svgText.drawRectText = svgTextDrawRectText;

svgText.brush = function (el) {
  var style = el.style;

  if (style.text != null) {
    // 强制设置 textPosition
    style.textPosition = [0, 0];
    svgTextDrawRectText(el, {
      x: style.x || 0,
      y: style.y || 0,
      width: 0,
      height: 0
    }, el.getBoundingRect());
  }
};

exports.path = svgPath;
exports.image = svgImage;
exports.text = svgText;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 327 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_js__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_js__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_js__ = __webpack_require__(1051);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations_js__["a" /* default */]
}));

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1116), __esModule: true };

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BigInteger__ = __webpack_require__(331);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */





var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';

var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';

/** @class */

var AuthenticationHelper = function () {
  /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */
  function AuthenticationHelper(PoolName) {
    _classCallCheck(this, AuthenticationHelper);

    this.N = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](initN, 16);
    this.g = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */]('2', 16);
    this.k = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](this.hexHash('00' + this.N.toString(16) + '0' + this.g.toString(16)), 16);

    this.smallAValue = this.generateRandomSmallA();
    this.getLargeAValue(function () {});

    this.infoBits = new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer('Caldera Derived Key', 'utf8');

    this.poolName = PoolName;
  }

  /**
   * @returns {BigInteger} small A, a random number
   */


  AuthenticationHelper.prototype.getSmallAValue = function getSmallAValue() {
    return this.smallAValue;
  };

  /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */


  AuthenticationHelper.prototype.getLargeAValue = function getLargeAValue(callback) {
    var _this = this;

    if (this.largeAValue) {
      callback(null, this.largeAValue);
    } else {
      this.calculateA(this.smallAValue, function (err, largeAValue) {
        if (err) {
          callback(err, null);
        }

        _this.largeAValue = largeAValue;
        callback(null, _this.largeAValue);
      });
    }
  };

  /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */


  AuthenticationHelper.prototype.generateRandomSmallA = function generateRandomSmallA() {
    var hexRandom = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.lib.randomBytes(128).toString('hex');

    var randomBigInt = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](hexRandom, 16);
    var smallABigInt = randomBigInt.mod(this.N);

    return smallABigInt;
  };

  /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */


  AuthenticationHelper.prototype.generateRandomString = function generateRandomString() {
    return __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.lib.randomBytes(40).toString('base64');
  };

  /**
   * @returns {string} Generated random value included in password hash.
   */


  AuthenticationHelper.prototype.getRandomPassword = function getRandomPassword() {
    return this.randomPassword;
  };

  /**
   * @returns {string} Generated random value included in devices hash.
   */


  AuthenticationHelper.prototype.getSaltDevices = function getSaltDevices() {
    return this.SaltToHashDevices;
  };

  /**
   * @returns {string} Value used to verify devices.
   */


  AuthenticationHelper.prototype.getVerifierDevices = function getVerifierDevices() {
    return this.verifierDevices;
  };

  /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */


  AuthenticationHelper.prototype.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
    var _this2 = this;

    this.randomPassword = this.generateRandomString();
    var combinedString = '' + deviceGroupKey + username + ':' + this.randomPassword;
    var hashedString = this.hash(combinedString);

    var hexRandom = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.lib.randomBytes(16).toString('hex');
    this.SaltToHashDevices = this.padHex(new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](hexRandom, 16));

    this.g.modPow(new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function (err, verifierDevicesNotPadded) {
      if (err) {
        callback(err, null);
      }

      _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
      callback(null, null);
    });
  };

  /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */


  AuthenticationHelper.prototype.calculateA = function calculateA(a, callback) {
    var _this3 = this;

    this.g.modPow(a, this.N, function (err, A) {
      if (err) {
        callback(err, null);
      }

      if (A.mod(_this3.N).equals(__WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */].ZERO)) {
        callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
      }

      callback(null, A);
    });
  };

  /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */


  AuthenticationHelper.prototype.calculateU = function calculateU(A, B) {
    this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
    var finalU = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](this.UHexHash, 16);

    return finalU;
  };

  /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */


  AuthenticationHelper.prototype.hash = function hash(buf) {
    var hashHex = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.sha256(buf, 'hex');
    return new Array(64 - hashHex.length).join('0') + hashHex;
  };

  /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */


  AuthenticationHelper.prototype.hexHash = function hexHash(hexStr) {
    return this.hash(new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(hexStr, 'hex'));
  };

  /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */


  AuthenticationHelper.prototype.computehkdf = function computehkdf(ikm, salt) {
    var prk = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.hmac(salt, ikm, 'buffer', 'sha256');
    var infoBitsUpdate = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].buffer.concat([this.infoBits, new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(String.fromCharCode(1), 'utf8')]);
    var hmac = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.hmac(prk, infoBitsUpdate, 'buffer', 'sha256');
    return hmac.slice(0, 16);
  };

  /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */


  AuthenticationHelper.prototype.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
    var _this4 = this;

    if (serverBValue.mod(this.N).equals(__WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */].ZERO)) {
      throw new Error('B cannot be zero.');
    }

    this.UValue = this.calculateU(this.largeAValue, serverBValue);

    if (this.UValue.equals(__WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */].ZERO)) {
      throw new Error('U cannot be zero.');
    }

    var usernamePassword = '' + this.poolName + username + ':' + password;
    var usernamePasswordHash = this.hash(usernamePassword);

    var xValue = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
    this.calculateS(xValue, serverBValue, function (err, sValue) {
      if (err) {
        callback(err, null);
      }

      var hkdf = _this4.computehkdf(new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this4.padHex(sValue), 'hex'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this4.padHex(_this4.UValue.toString(16)), 'hex'));

      callback(null, hkdf);
    });
  };

  /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  AuthenticationHelper.prototype.calculateS = function calculateS(xValue, serverBValue, callback) {
    var _this5 = this;

    this.g.modPow(xValue, this.N, function (err, gModPowXN) {
      if (err) {
        callback(err, null);
      }

      var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
      intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function (err2, result) {
        if (err2) {
          callback(err2, null);
        }

        callback(null, result.mod(_this5.N));
      });
    });
  };

  /**
  * Return constant newPasswordRequiredChallengeUserAttributePrefix
  * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
  */


  AuthenticationHelper.prototype.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
    return newPasswordRequiredChallengeUserAttributePrefix;
  };

  /**
   * Converts a BigInteger (or hex string) to hex format padded with zeroes for hashing
   * @param {BigInteger|String} bigInt Number or string to pad.
   * @returns {String} Padded hex string.
   */


  AuthenticationHelper.prototype.padHex = function padHex(bigInt) {
    var hashStr = bigInt.toString(16);
    if (hashStr.length % 2 === 1) {
      hashStr = '0' + hashStr;
    } else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) {
      hashStr = '00' + hashStr;
    }
    return hashStr;
  };

  return AuthenticationHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthenticationHelper);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow

/* harmony default export */ __webpack_exports__["a"] = (BigInteger);

/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */

// (public) Constructor
function BigInteger(a, b) {
  if (a != null) this.fromString(a, b);
}

// return new, unset BigInteger
function nbi() {
  return new BigInteger(null);
}

// Bits per digit
var dbits;

// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
  while (--n >= 0) {
    var v = x * this[i++] + w[j] + c;
    c = Math.floor(v / 0x4000000);
    w[j++] = v & 0x3ffffff;
  }
  return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
  var xl = x & 0x7fff,
      xh = x >> 15;
  while (--n >= 0) {
    var l = this[i] & 0x7fff;
    var h = this[i++] >> 15;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
    w[j++] = l & 0x3fffffff;
  }
  return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
  var xl = x & 0x3fff,
      xh = x >> 14;
  while (--n >= 0) {
    var l = this[i] & 0x3fff;
    var h = this[i++] >> 14;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
    c = (l >> 28) + (m >> 14) + xh * h;
    w[j++] = l & 0xfffffff;
  }
  return c;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
  BigInteger.prototype.am = am2;
  dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
  BigInteger.prototype.am = am1;
  dbits = 26;
} else {
  // Mozilla/Netscape seems to prefer am3
  BigInteger.prototype.am = am3;
  dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;

var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;

// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
  BI_RC[rr++] = vv;
}rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}function int2char(n) {
  return BI_RM.charAt(n);
}
function intAt(s, i) {
  var c = BI_RC[s.charCodeAt(i)];
  return c == null ? -1 : c;
}

// (protected) copy this to r
function bnpCopyTo(r) {
  for (var i = this.t - 1; i >= 0; --i) {
    r[i] = this[i];
  }r.t = this.t;
  r.s = this.s;
}

// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
  this.t = 1;
  this.s = x < 0 ? -1 : 0;
  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
}

// return bigint initialized to value
function nbv(i) {
  var r = nbi();

  r.fromInt(i);

  return r;
}

// (protected) set from string and radix
function bnpFromString(s, b) {
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0;
  this.s = 0;
  var i = s.length,
      mi = false,
      sh = 0;
  while (--i >= 0) {
    var x = intAt(s, i);
    if (x < 0) {
      if (s.charAt(i) == "-") mi = true;
      continue;
    }
    mi = false;
    if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
      this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
      this[this.t++] = x >> this.DB - sh;
    } else this[this.t - 1] |= x << sh;
    sh += k;
    if (sh >= this.DB) sh -= this.DB;
  }
  this.clamp();
  if (mi) BigInteger.ZERO.subTo(this, this);
}

// (protected) clamp off excess high words
function bnpClamp() {
  var c = this.s & this.DM;
  while (this.t > 0 && this[this.t - 1] == c) {
    --this.t;
  }
}

// (public) return string representation in given radix
function bnToString(b) {
  if (this.s < 0) return "-" + this.negate().toString();
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var km = (1 << k) - 1,
      d,
      m = false,
      r = "",
      i = this.t;
  var p = this.DB - i * this.DB % k;
  if (i-- > 0) {
    if (p < this.DB && (d = this[i] >> p) > 0) {
      m = true;
      r = int2char(d);
    }
    while (i >= 0) {
      if (p < k) {
        d = (this[i] & (1 << p) - 1) << k - p;
        d |= this[--i] >> (p += this.DB - k);
      } else {
        d = this[i] >> (p -= k) & km;
        if (p <= 0) {
          p += this.DB;
          --i;
        }
      }
      if (d > 0) m = true;
      if (m) r += int2char(d);
    }
  }
  return m ? r : "0";
}

// (public) -this
function bnNegate() {
  var r = nbi();

  BigInteger.ZERO.subTo(this, r);

  return r;
}

// (public) |this|
function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}

// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
  var r = this.s - a.s;
  if (r != 0) return r;
  var i = this.t;
  r = i - a.t;
  if (r != 0) return this.s < 0 ? -r : r;
  while (--i >= 0) {
    if ((r = this[i] - a[i]) != 0) return r;
  }return 0;
}

// returns bit length of the integer x
function nbits(x) {
  var r = 1,
      t;
  if ((t = x >>> 16) != 0) {
    x = t;
    r += 16;
  }
  if ((t = x >> 8) != 0) {
    x = t;
    r += 8;
  }
  if ((t = x >> 4) != 0) {
    x = t;
    r += 4;
  }
  if ((t = x >> 2) != 0) {
    x = t;
    r += 2;
  }
  if ((t = x >> 1) != 0) {
    x = t;
    r += 1;
  }
  return r;
}

// (public) return the number of bits in "this"
function bnBitLength() {
  if (this.t <= 0) return 0;
  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}

// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
  var i;
  for (i = this.t - 1; i >= 0; --i) {
    r[i + n] = this[i];
  }for (i = n - 1; i >= 0; --i) {
    r[i] = 0;
  }r.t = this.t + n;
  r.s = this.s;
}

// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
  for (var i = n; i < this.t; ++i) {
    r[i - n] = this[i];
  }r.t = Math.max(this.t - n, 0);
  r.s = this.s;
}

// (protected) r = this << n
function bnpLShiftTo(n, r) {
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << cbs) - 1;
  var ds = Math.floor(n / this.DB),
      c = this.s << bs & this.DM,
      i;
  for (i = this.t - 1; i >= 0; --i) {
    r[i + ds + 1] = this[i] >> cbs | c;
    c = (this[i] & bm) << bs;
  }
  for (i = ds - 1; i >= 0; --i) {
    r[i] = 0;
  }r[ds] = c;
  r.t = this.t + ds + 1;
  r.s = this.s;
  r.clamp();
}

// (protected) r = this >> n
function bnpRShiftTo(n, r) {
  r.s = this.s;
  var ds = Math.floor(n / this.DB);
  if (ds >= this.t) {
    r.t = 0;
    return;
  }
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << bs) - 1;
  r[0] = this[ds] >> bs;
  for (var i = ds + 1; i < this.t; ++i) {
    r[i - ds - 1] |= (this[i] & bm) << cbs;
    r[i - ds] = this[i] >> bs;
  }
  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
  r.t = this.t - ds;
  r.clamp();
}

// (protected) r = this - a
function bnpSubTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] - a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c -= a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c -= a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c -= a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
  r.t = i;
  r.clamp();
}

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
  var x = this.abs(),
      y = a.abs();
  var i = x.t;
  r.t = i + y.t;
  while (--i >= 0) {
    r[i] = 0;
  }for (i = 0; i < y.t; ++i) {
    r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
  }r.s = 0;
  r.clamp();
  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}

// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
  var x = this.abs();
  var i = r.t = 2 * x.t;
  while (--i >= 0) {
    r[i] = 0;
  }for (i = 0; i < x.t - 1; ++i) {
    var c = x.am(i, x[i], r, 2 * i, 0, 1);
    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
      r[i + x.t] -= x.DV;
      r[i + x.t + 1] = 1;
    }
  }
  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
  r.s = 0;
  r.clamp();
}

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
  var pm = m.abs();
  if (pm.t <= 0) return;
  var pt = this.abs();
  if (pt.t < pm.t) {
    if (q != null) q.fromInt(0);
    if (r != null) this.copyTo(r);
    return;
  }
  if (r == null) r = nbi();
  var y = nbi(),
      ts = this.s,
      ms = m.s;
  var nsh = this.DB - nbits(pm[pm.t - 1]);
  // normalize modulus
  if (nsh > 0) {
    pm.lShiftTo(nsh, y);
    pt.lShiftTo(nsh, r);
  } else {
    pm.copyTo(y);
    pt.copyTo(r);
  }
  var ys = y.t;
  var y0 = y[ys - 1];
  if (y0 == 0) return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt,
      d2 = (1 << this.F1) / yt,
      e = 1 << this.F2;
  var i = r.t,
      j = i - ys,
      t = q == null ? nbi() : q;
  y.dlShiftTo(j, t);
  if (r.compareTo(t) >= 0) {
    r[r.t++] = 1;
    r.subTo(t, r);
  }
  BigInteger.ONE.dlShiftTo(ys, t);
  t.subTo(y, y);
  // "negative" y so we can replace sub with am later
  while (y.t < ys) {
    y[y.t++] = 0;
  }while (--j >= 0) {
    // Estimate quotient digit
    var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
      // Try it out
      y.dlShiftTo(j, t);
      r.subTo(t, r);
      while (r[i] < --qd) {
        r.subTo(t, r);
      }
    }
  }
  if (q != null) {
    r.drShiftTo(ys, q);
    if (ts != ms) BigInteger.ZERO.subTo(q, q);
  }
  r.t = ys;
  r.clamp();
  if (nsh > 0) r.rShiftTo(nsh, r);
  // Denormalize remainder
  if (ts < 0) BigInteger.ZERO.subTo(r, r);
}

// (public) this mod a
function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a, null, r);
  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
  return r;
}

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
  if (this.t < 1) return 0;
  var x = this[0];
  if ((x & 1) == 0) return 0;
  var y = x & 3;
  // y == 1/x mod 2^2
  y = y * (2 - (x & 0xf) * y) & 0xf;
  // y == 1/x mod 2^4
  y = y * (2 - (x & 0xff) * y) & 0xff;
  // y == 1/x mod 2^8
  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
  // y == 1/x mod 2^16
  // last step - calculate inverse mod DV directly;
  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
  y = y * (2 - x * y % this.DV) % this.DV;
  // y == 1/x mod 2^dbits
  // we really want the negative inverse, and -DV < y < DV
  return y > 0 ? this.DV - y : -y;
}

function bnEquals(a) {
  return this.compareTo(a) == 0;
}

// (protected) r = this + a
function bnpAddTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] + a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c += a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c += a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
  r.t = i;
  r.clamp();
}

// (public) this + a
function bnAdd(a) {
  var r = nbi();

  this.addTo(a, r);

  return r;
}

// (public) this - a
function bnSubtract(a) {
  var r = nbi();

  this.subTo(a, r);

  return r;
}

// (public) this * a
function bnMultiply(a) {
  var r = nbi();

  this.multiplyTo(a, r);

  return r;
}

// (public) this / a
function bnDivide(a) {
  var r = nbi();

  this.divRemTo(a, r, null);

  return r;
}

// Montgomery reduction
function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp & 0x7fff;
  this.mph = this.mp >> 15;
  this.um = (1 << m.DB - 15) - 1;
  this.mt2 = 2 * m.t;
}

// xR mod m
function montConvert(x) {
  var r = nbi();
  x.abs().dlShiftTo(this.m.t, r);
  r.divRemTo(this.m, null, r);
  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
  return r;
}

// x/R mod m
function montRevert(x) {
  var r = nbi();
  x.copyTo(r);
  this.reduce(r);
  return r;
}

// x = x/R mod m (HAC 14.32)
function montReduce(x) {
  while (x.t <= this.mt2) {
    // pad x so am has enough room later
    x[x.t++] = 0;
  }for (var i = 0; i < this.m.t; ++i) {
    // faster way of calculating u0 = x[i]*mp mod DV
    var j = x[i] & 0x7fff;
    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
    // use am to combine the multiply-shift-add into one call
    j = i + this.m.t;
    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
    // propagate carry
    while (x[j] >= x.DV) {
      x[j] -= x.DV;
      x[++j]++;
    }
  }
  x.clamp();
  x.drShiftTo(this.m.t, x);
  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
  x.squareTo(r);

  this.reduce(r);
}

// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
  x.multiplyTo(y, r);

  this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
  var i = e.bitLength(),
      k,
      r = nbv(1),
      z = new Montgomery(m);
  if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;

  // precomputation
  var g = new Array(),
      n = 3,
      k1 = k - 1,
      km = (1 << k) - 1;
  g[1] = z.convert(this);
  if (k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1], g2);
    while (n <= km) {
      g[n] = nbi();
      z.mulTo(g2, g[n - 2], g[n]);
      n += 2;
    }
  }

  var j = e.t - 1,
      w,
      is1 = true,
      r2 = nbi(),
      t;
  i = nbits(e[j]) - 1;
  while (j >= 0) {
    if (i >= k1) w = e[j] >> i - k1 & km;else {
      w = (e[j] & (1 << i + 1) - 1) << k1 - i;
      if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
    }

    n = k;
    while ((w & 1) == 0) {
      w >>= 1;
      --n;
    }
    if ((i -= n) < 0) {
      i += this.DB;
      --j;
    }
    if (is1) {
      // ret == 1, don't bother squaring or multiplying it
      g[w].copyTo(r);
      is1 = false;
    } else {
      while (n > 1) {
        z.sqrTo(r, r2);
        z.sqrTo(r2, r);
        n -= 2;
      }
      if (n > 0) z.sqrTo(r, r2);else {
        t = r;
        r = r2;
        r2 = t;
      }
      z.mulTo(r2, g[w], r);
    }

    while (j >= 0 && (e[j] & 1 << i) == 0) {
      z.sqrTo(r, r2);
      t = r;
      r = r2;
      r2 = t;
      if (--i < 0) {
        i = this.DB - 1;
        --j;
      }
    }
  }
  var result = z.revert(r);
  callback(null, result);
  return result;
}

// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;

// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;

// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(334);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoAccessToken = function (_CognitoJwtToken) {
  _inherits(CognitoAccessToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */
  function CognitoAccessToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        AccessToken = _ref.AccessToken;

    _classCallCheck(this, CognitoAccessToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, AccessToken || ''));
  }

  return CognitoAccessToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CognitoAccessToken);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(334);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoIdToken = function (_CognitoJwtToken) {
  _inherits(CognitoIdToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */
  function CognitoIdToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken;

    _classCallCheck(this, CognitoIdToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, IdToken || ''));
  }

  return CognitoIdToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CognitoIdToken);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoJwtToken = function () {
  /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */
  function CognitoJwtToken(token) {
    _classCallCheck(this, CognitoJwtToken);

    // Assign object
    this.jwtToken = token || '';
    this.payload = this.decodePayload();
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoJwtToken.prototype.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  };

  /**
   * @returns {int} the token's expiration (exp member).
   */


  CognitoJwtToken.prototype.getExpiration = function getExpiration() {
    return this.payload.exp;
  };

  /**
   * @returns {int} the token's "issued at" (iat member).
   */


  CognitoJwtToken.prototype.getIssuedAt = function getIssuedAt() {
    return this.payload.iat;
  };

  /**
   * @returns {object} the token's payload.
   */


  CognitoJwtToken.prototype.decodePayload = function decodePayload() {
    var payload = this.jwtToken.split('.')[1];
    try {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].base64.decode(payload).toString('utf8'));
    } catch (err) {
      return {};
    }
  };

  return CognitoJwtToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoJwtToken);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoRefreshToken = function () {
  /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */
  function CognitoRefreshToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        RefreshToken = _ref.RefreshToken;

    _classCallCheck(this, CognitoRefreshToken);

    // Assign object
    this.token = RefreshToken || '';
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoRefreshToken.prototype.getToken = function getToken() {
    return this.token;
  };

  return CognitoRefreshToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoRefreshToken);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BigInteger__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthenticationHelper__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoAccessToken__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoIdToken__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CognitoRefreshToken__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CognitoUserSession__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateHelper__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoUserAttribute__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StorageHelper__ = __webpack_require__(340);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */













/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */

/**
 * @callback onFailure
 * @param {*} err Failure reason.
 */

/**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */

/**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */

/**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */

/**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */

/**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */

/** @class */

var CognitoUser = function () {
  /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */
  function CognitoUser(data) {
    _classCallCheck(this, CognitoUser);

    if (data == null || data.Username == null || data.Pool == null) {
      throw new Error('Username and pool information are required.');
    }

    this.username = data.Username || '';
    this.pool = data.Pool;
    this.Session = null;

    this.client = data.Pool.client;

    this.signInUserSession = null;
    this.authenticationFlowType = 'USER_SRP_AUTH';

    this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_9__StorageHelper__["a" /* default */]().getStorage();
  }

  /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */


  CognitoUser.prototype.setSignInUserSession = function setSignInUserSession(signInUserSession) {
    this.clearCachedTokens();
    this.signInUserSession = signInUserSession;
    this.cacheTokens();
  };

  /**
   * @returns {CognitoUserSession} the current session for this user
   */


  CognitoUser.prototype.getSignInUserSession = function getSignInUserSession() {
    return this.signInUserSession;
  };

  /**
   * @returns {string} the user's username
   */


  CognitoUser.prototype.getUsername = function getUsername() {
    return this.username;
  };

  /**
   * @returns {String} the authentication flow type
   */


  CognitoUser.prototype.getAuthenticationFlowType = function getAuthenticationFlowType() {
    return this.authenticationFlowType;
  };

  /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */


  CognitoUser.prototype.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
    this.authenticationFlowType = authenticationFlowType;
  };

  /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.initiateAuth = function initiateAuth(authDetails, callback) {
    var _this = this;

    var authParameters = authDetails.getAuthParameters();
    authParameters.USERNAME = this.username;

    var jsonReq = {
      AuthFlow: 'CUSTOM_AUTH',
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: authDetails.getValidationData()
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      var challengeName = data.ChallengeName;
      var challengeParameters = data.ChallengeParameters;

      if (challengeName === 'CUSTOM_CHALLENGE') {
        _this.Session = data.Session;
        return callback.customChallenge(challengeParameters);
      }
      _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
      _this.cacheTokens();
      return callback.onSuccess(_this.signInUserSession);
    });
  };

  /**
   * This is used for authenticating the user. it calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.authenticateUser = function authenticateUser(authDetails, callback) {
    var _this2 = this;

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_2__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    var dateHelper = new __WEBPACK_IMPORTED_MODULE_7__DateHelper__["a" /* default */]();

    var serverBValue = void 0;
    var salt = void 0;
    var authParameters = {};

    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    authParameters.USERNAME = this.username;
    authenticationHelper.getLargeAValue(function (errOnAValue, aValue) {
      // getLargeAValue callback start
      if (errOnAValue) {
        callback.onFailure(errOnAValue);
      }

      authParameters.SRP_A = aValue.toString(16);

      if (_this2.authenticationFlowType === 'CUSTOM_AUTH') {
        authParameters.CHALLENGE_NAME = 'SRP_A';
      }

      var jsonReq = {
        AuthFlow: _this2.authenticationFlowType,
        ClientId: _this2.pool.getClientId(),
        AuthParameters: authParameters,
        ClientMetadata: authDetails.getValidationData()
      };
      if (_this2.getUserContextData(_this2.username)) {
        jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
      }

      _this2.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;

        _this2.username = challengeParameters.USER_ID_FOR_SRP;
        serverBValue = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
        salt = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](challengeParameters.SALT, 16);
        _this2.getCachedDeviceKeyAndPassword();

        authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function (errOnHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errOnHkdf) {
            callback.onFailure(errOnHkdf);
          }

          var dateNow = dateHelper.getNowString();

          var signatureString = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.hmac(hkdf, __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].buffer.concat([new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this2.pool.getUserPoolId().split('_')[1], 'utf8'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this2.username, 'utf8'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(challengeParameters.SECRET_BLOCK, 'base64'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(dateNow, 'utf8')]), 'base64', 'sha256');

          var challengeResponses = {};

          challengeResponses.USERNAME = _this2.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;

          if (_this2.deviceKey != null) {
            challengeResponses.DEVICE_KEY = _this2.deviceKey;
          }

          var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
            return _this2.client.makeUnauthenticatedRequest('respondToAuthChallenge', challenge, function (errChallenge, dataChallenge) {
              if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                challengeResponses.DEVICE_KEY = null;
                _this2.deviceKey = null;
                _this2.randomPassword = null;
                _this2.deviceGroupKey = null;
                _this2.clearCachedDeviceKeyAndPassword();
                return respondToAuthChallenge(challenge, challengeCallback);
              }
              return challengeCallback(errChallenge, dataChallenge);
            });
          };

          var jsonReqResp = {
            ChallengeName: 'PASSWORD_VERIFIER',
            ClientId: _this2.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };
          if (_this2.getUserContextData()) {
            jsonReqResp.UserContextData = _this2.getUserContextData();
          }
          respondToAuthChallenge(jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'NEW_PASSWORD_REQUIRED') {
              _this2.Session = dataAuthenticate.Session;
              var userAttributes = null;
              var rawRequiredAttributes = null;
              var requiredAttributes = [];
              var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

              if (dataAuthenticate.ChallengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
              }

              if (rawRequiredAttributes) {
                for (var i = 0; i < rawRequiredAttributes.length; i++) {
                  requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
                }
              }
              return callback.newPasswordRequired(userAttributes, requiredAttributes);
            }
            return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
          });
          return undefined;
          // getPasswordAuthenticationKey callback end
        });
        return undefined;
      });
      // getLargeAValue callback end
    });
  };

  /**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {object} dataAuthenticate authentication data
  * @param {object} authenticationHelper helper created
  * @param {callback} callback passed on from caller
  * @returns {void}
  */


  CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
    var _this3 = this;

    var challengeName = dataAuthenticate.ChallengeName;
    var challengeParameters = dataAuthenticate.ChallengeParameters;

    if (challengeName === 'SMS_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'SELECT_MFA_TYPE') {
      this.Session = dataAuthenticate.Session;
      return callback.selectMFAType(challengeName, challengeParameters);
    }

    if (challengeName === 'MFA_SETUP') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaSetup(challengeName, challengeParameters);
    }

    if (challengeName === 'SOFTWARE_TOKEN_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.totpRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'CUSTOM_CHALLENGE') {
      this.Session = dataAuthenticate.Session;
      return callback.customChallenge(challengeParameters);
    }

    if (challengeName === 'DEVICE_SRP_AUTH') {
      this.getDeviceResponse(callback);
      return undefined;
    }

    this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
    this.cacheTokens();

    var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
    if (newDeviceMetadata == null) {
      return callback.onSuccess(this.signInUserSession);
    }

    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
      if (errGenHash) {
        return callback.onFailure(errGenHash);
      }

      var deviceSecretVerifierConfig = {
        Salt: new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
        PasswordVerifier: new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
      };

      _this3.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
      _this3.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
      _this3.randomPassword = authenticationHelper.getRandomPassword();

      _this3.client.makeUnauthenticatedRequest('confirmDevice', {
        DeviceKey: newDeviceMetadata.DeviceKey,
        AccessToken: _this3.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
        DeviceName: navigator.userAgent
      }, function (errConfirm, dataConfirm) {
        if (errConfirm) {
          return callback.onFailure(errConfirm);
        }

        _this3.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
        _this3.cacheDeviceKeyAndPassword();
        if (dataConfirm.UserConfirmationNecessary === true) {
          return callback.onSuccess(_this3.signInUserSession, dataConfirm.UserConfirmationNecessary);
        }
        return callback.onSuccess(_this3.signInUserSession);
      });
      return undefined;
    });
    return undefined;
  };

  /**
  * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
  * Pass the new password with any new user attributes to be updated.
  * User attribute keys must be of format userAttributes.<attribute_name>.
  * @param {string} newPassword new password for this user
  * @param {object} requiredAttributeData map with values for all required attributes
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *         response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


  CognitoUser.prototype.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback) {
    var _this4 = this;

    if (!newPassword) {
      return callback.onFailure(new Error('New password is required.'));
    }
    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_2__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

    var finalUserAttributes = {};
    if (requiredAttributeData) {
      Object.keys(requiredAttributeData).forEach(function (key) {
        finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
      });
    }

    finalUserAttributes.NEW_PASSWORD = newPassword;
    finalUserAttributes.USERNAME = this.username;
    var jsonReq = {
      ChallengeName: 'NEW_PASSWORD_REQUIRED',
      ClientId: this.pool.getClientId(),
      ChallengeResponses: finalUserAttributes,
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (errAuthenticate, dataAuthenticate) {
      if (errAuthenticate) {
        return callback.onFailure(errAuthenticate);
      }
      return _this4.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
    });
    return undefined;
  };

  /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   * @private
   */


  CognitoUser.prototype.getDeviceResponse = function getDeviceResponse(callback) {
    var _this5 = this;

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_2__AuthenticationHelper__["a" /* default */](this.deviceGroupKey);
    var dateHelper = new __WEBPACK_IMPORTED_MODULE_7__DateHelper__["a" /* default */]();

    var authParameters = {};

    authParameters.USERNAME = this.username;
    authParameters.DEVICE_KEY = this.deviceKey;
    authenticationHelper.getLargeAValue(function (errAValue, aValue) {
      // getLargeAValue callback start
      if (errAValue) {
        callback.onFailure(errAValue);
      }

      authParameters.SRP_A = aValue.toString(16);

      var jsonReq = {
        ChallengeName: 'DEVICE_SRP_AUTH',
        ClientId: _this5.pool.getClientId(),
        ChallengeResponses: authParameters
      };
      if (_this5.getUserContextData()) {
        jsonReq.UserContextData = _this5.getUserContextData();
      }
      _this5.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;

        var serverBValue = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
        var salt = new __WEBPACK_IMPORTED_MODULE_1__BigInteger__["a" /* default */](challengeParameters.SALT, 16);

        authenticationHelper.getPasswordAuthenticationKey(_this5.deviceKey, _this5.randomPassword, serverBValue, salt, function (errHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errHkdf) {
            return callback.onFailure(errHkdf);
          }

          var dateNow = dateHelper.getNowString();

          var signatureString = __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].crypto.hmac(hkdf, __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].buffer.concat([new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this5.deviceGroupKey, 'utf8'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(_this5.deviceKey, 'utf8'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(challengeParameters.SECRET_BLOCK, 'base64'), new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(dateNow, 'utf8')]), 'base64', 'sha256');

          var challengeResponses = {};

          challengeResponses.USERNAME = _this5.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
          challengeResponses.DEVICE_KEY = _this5.deviceKey;

          var jsonReqResp = {
            ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
            ClientId: _this5.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };
          if (_this5.getUserContextData()) {
            jsonReqResp.UserContextData = _this5.getUserContextData();
          }

          _this5.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            _this5.signInUserSession = _this5.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this5.cacheTokens();

            return callback.onSuccess(_this5.signInUserSession);
          });
          return undefined;
          // getPasswordAuthenticationKey callback end
        });
        return undefined;
      });
      // getLargeAValue callback end
    });
  };

  /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: confirmationCode,
      Username: this.username,
      ForceAliasCreation: forceAliasCreation
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('confirmSignUp', jsonReq, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
  };

  /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challange answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback) {
    var _this6 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;
    var jsonReq = {
      ChallengeName: 'CUSTOM_CHALLENGE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      var challengeName = data.ChallengeName;

      if (challengeName === 'CUSTOM_CHALLENGE') {
        _this6.Session = data.Session;
        return callback.customChallenge(data.ChallengeParameters);
      }

      _this6.signInUserSession = _this6.getCognitoUserSession(data.AuthenticationResult);
      _this6.cacheTokens();
      return callback.onSuccess(_this6.signInUserSession);
    });
  };

  /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType) {
    var _this7 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.SMS_MFA_CODE = confirmationCode;
    var mfaTypeSelection = mfaType || 'SMS_MFA';
    if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
      challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
    }

    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ChallengeName: mfaTypeSelection,
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
      if (err) {
        return callback.onFailure(err);
      }

      var challengeName = dataAuthenticate.ChallengeName;

      if (challengeName === 'DEVICE_SRP_AUTH') {
        _this7.getDeviceResponse(callback);
        return undefined;
      }

      _this7.signInUserSession = _this7.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
      _this7.cacheTokens();

      if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
        return callback.onSuccess(_this7.signInUserSession);
      }

      var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_2__AuthenticationHelper__["a" /* default */](_this7.pool.getUserPoolId().split('_')[1]);
      authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
        if (errGenHash) {
          return callback.onFailure(errGenHash);
        }

        var deviceSecretVerifierConfig = {
          Salt: new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
          PasswordVerifier: new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__["util"].Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
        };

        _this7.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
        _this7.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
        _this7.randomPassword = authenticationHelper.getRandomPassword();

        _this7.client.makeUnauthenticatedRequest('confirmDevice', {
          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: _this7.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
          DeviceName: navigator.userAgent
        }, function (errConfirm, dataConfirm) {
          if (errConfirm) {
            return callback.onFailure(errConfirm);
          }

          _this7.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
          _this7.cacheDeviceKeyAndPassword();
          if (dataConfirm.UserConfirmationNecessary === true) {
            return callback.onSuccess(_this7.signInUserSession, dataConfirm.UserConfirmationNecessary);
          }
          return callback.onSuccess(_this7.signInUserSession);
        });
        return undefined;
      });
      return undefined;
    });
  };

  /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.changePassword = function changePassword(oldUserPassword, newUserPassword, callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('changePassword', {
      PreviousPassword: oldUserPassword,
      ProposedPassword: newUserPassword,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to enable MFA for himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.enableMFA = function enableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];
    var mfaEnabled = {
      DeliveryMedium: 'SMS',
      AttributeName: 'phone_number'
    };
    mfaOptions.push(mfaEnabled);

    this.client.makeUnauthenticatedRequest('setUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to enable MFA for himself
   * @param {string[]} smsMfaSettings the sms mfa settings
   * @param {string[]} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('setUserMFAPreference', {
      SMSMfaSettings: smsMfaSettings,
      SoftwareTokenMfaSettings: softwareTokenMfaSettings,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to disable MFA for himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.disableMFA = function disableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];

    this.client.makeUnauthenticatedRequest('setUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to delete himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.deleteUser = function deleteUser(callback) {
    var _this8 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('deleteUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      _this8.clearCachedTokens();
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
   */
  /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.updateAttributes = function updateAttributes(attributes, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('updateUserAttributes', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: attributes
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getUserAttributes = function getUserAttributes(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('getUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      var attributeList = [];

      for (var i = 0; i < userData.UserAttributes.length; i++) {
        var attribute = {
          Name: userData.UserAttributes[i].Name,
          Value: userData.UserAttributes[i].Value
        };
        var userAttribute = new __WEBPACK_IMPORTED_MODULE_8__CognitoUserAttribute__["a" /* default */](attribute);
        attributeList.push(userAttribute);
      }

      return callback(null, attributeList);
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to get the MFAOptions
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getMFAOptions = function getMFAOptions(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('getUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, userData.MFAOptions);
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.deleteAttributes = function deleteAttributes(attributeList, callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.makeUnauthenticatedRequest('deleteUserAttributes', {
      UserAttributeNames: attributeList,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.resendConfirmationCode = function resendConfirmationCode(callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username
    };

    this.client.makeUnauthenticatedRequest('resendConfirmationCode', jsonReq, function (err, result) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, result);
    });
  };

  /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getSession = function getSession(callback) {
    if (this.username == null) {
      return callback(new Error('Username is null. Cannot retrieve a new session'), null);
    }

    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
      return callback(null, this.signInUserSession);
    }

    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var idTokenKey = keyPrefix + '.idToken';
    var accessTokenKey = keyPrefix + '.accessToken';
    var refreshTokenKey = keyPrefix + '.refreshToken';
    var clockDriftKey = keyPrefix + '.clockDrift';

    if (this.storage.getItem(idTokenKey)) {
      var idToken = new __WEBPACK_IMPORTED_MODULE_4__CognitoIdToken__["a" /* default */]({
        IdToken: this.storage.getItem(idTokenKey)
      });
      var accessToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoAccessToken__["a" /* default */]({
        AccessToken: this.storage.getItem(accessTokenKey)
      });
      var refreshToken = new __WEBPACK_IMPORTED_MODULE_5__CognitoRefreshToken__["a" /* default */]({
        RefreshToken: this.storage.getItem(refreshTokenKey)
      });
      var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;

      var sessionData = {
        IdToken: idToken,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
        ClockDrift: clockDrift
      };
      var cachedSession = new __WEBPACK_IMPORTED_MODULE_6__CognitoUserSession__["a" /* default */](sessionData);
      if (cachedSession.isValid()) {
        this.signInUserSession = cachedSession;
        return callback(null, this.signInUserSession);
      }

      if (refreshToken.getToken() == null) {
        return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
      }

      this.refreshSession(refreshToken, callback);
    } else {
      callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
    }

    return undefined;
  };

  /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.refreshSession = function refreshSession(refreshToken, callback) {
    var _this9 = this;

    var authParameters = {};
    authParameters.REFRESH_TOKEN = refreshToken.getToken();
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var lastUserKey = keyPrefix + '.LastAuthUser';

    if (this.storage.getItem(lastUserKey)) {
      this.username = this.storage.getItem(lastUserKey);
      var deviceKeyKey = keyPrefix + '.' + this.username + '.deviceKey';
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ClientId: this.pool.getClientId(),
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: authParameters
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, authResult) {
      if (err) {
        if (err.code === 'NotAuthorizedException') {
          _this9.clearCachedTokens();
        }
        return callback(err, null);
      }
      if (authResult) {
        var authenticationResult = authResult.AuthenticationResult;
        if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
          authenticationResult.RefreshToken = refreshToken.getToken();
        }
        _this9.signInUserSession = _this9.getCognitoUserSession(authenticationResult);
        _this9.cacheTokens();
        return callback(null, _this9.signInUserSession);
      }
      return undefined;
    });
  };

  /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */


  CognitoUser.prototype.cacheTokens = function cacheTokens() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
    var clockDriftKey = keyPrefix + '.' + this.username + '.clockDrift';
    var lastUserKey = keyPrefix + '.LastAuthUser';

    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
    this.storage.setItem(clockDriftKey, '' + this.signInUserSession.getClockDrift());
    this.storage.setItem(lastUserKey, this.username);
  };

  /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */


  CognitoUser.prototype.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    this.storage.setItem(deviceKeyKey, this.deviceKey);
    this.storage.setItem(randomPasswordKey, this.randomPassword);
    this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
  };

  /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */


  CognitoUser.prototype.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    if (this.storage.getItem(deviceKeyKey)) {
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      this.randomPassword = this.storage.getItem(randomPasswordKey);
      this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
    }
  };

  /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */


  CognitoUser.prototype.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    this.storage.removeItem(deviceKeyKey);
    this.storage.removeItem(randomPasswordKey);
    this.storage.removeItem(deviceGroupKeyKey);
  };

  /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */


  CognitoUser.prototype.clearCachedTokens = function clearCachedTokens() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
    var lastUserKey = keyPrefix + '.LastAuthUser';

    this.storage.removeItem(idTokenKey);
    this.storage.removeItem(accessTokenKey);
    this.storage.removeItem(refreshTokenKey);
    this.storage.removeItem(lastUserKey);
  };

  /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */


  CognitoUser.prototype.getCognitoUserSession = function getCognitoUserSession(authResult) {
    var idToken = new __WEBPACK_IMPORTED_MODULE_4__CognitoIdToken__["a" /* default */](authResult);
    var accessToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoAccessToken__["a" /* default */](authResult);
    var refreshToken = new __WEBPACK_IMPORTED_MODULE_5__CognitoRefreshToken__["a" /* default */](authResult);

    var sessionData = {
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken
    };

    return new __WEBPACK_IMPORTED_MODULE_6__CognitoUserSession__["a" /* default */](sessionData);
  };

  /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgotPassword = function forgotPassword(callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('forgotPassword', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess(data);
    });
  };

  /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: confirmationCode,
      Password: newPassword
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('confirmForgotPassword', jsonReq, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess();
    });
  };

  /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('getUserAttributeVerificationCode', {
      AttributeName: attributeName,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess();
    });
    return undefined;
  };

  /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('verifyUserAttribute', {
      AttributeName: attributeName,
      Code: confirmationCode,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */


  CognitoUser.prototype.getDevice = function getDevice(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('getDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return undefined;
  };

  /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('forgetDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: deviceKey
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgetDevice = function forgetDevice(callback) {
    var _this10 = this;

    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: callback.onFailure,
      onSuccess: function onSuccess(result) {
        _this10.deviceKey = null;
        _this10.deviceGroupKey = null;
        _this10.randomPassword = null;
        _this10.clearCachedDeviceKeyAndPassword();
        return callback.onSuccess(result);
      }
    });
  };

  /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'not_remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */


  CognitoUser.prototype.listDevices = function listDevices(limit, paginationToken, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('listDevices', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: limit,
      PaginationToken: paginationToken
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return undefined;
  };

  /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.globalSignOut = function globalSignOut(callback) {
    var _this11 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.makeUnauthenticatedRequest('globalSignOut', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      _this11.clearCachedTokens();
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */


  CognitoUser.prototype.signOut = function signOut() {
    this.signInUserSession = null;
    this.clearCachedTokens();
  };

  /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
    var _this12 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;

    var jsonReq = {
      ChallengeName: 'SELECT_MFA_TYPE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      _this12.Session = data.Session;
      if (answerChallenge === 'SMS_MFA') {
        return callback.mfaRequired(data.challengeName, data.challengeParameters);
      }
      if (answerChallenge === 'SOFTWARE_TOKEN_MFA') {
        return callback.totpRequired(data.challengeName, data.challengeParameters);
      }
      return undefined;
    });
  };

  /**
   * This returns the user context data for advanced security feature.
   * @returns {void}
   */


  CognitoUser.prototype.getUserContextData = function getUserContextData() {
    var pool = this.pool;
    return pool.getUserContextData(this.username);
  };

  /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.associateSoftwareToken = function associateSoftwareToken(callback) {
    var _this13 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.makeUnauthenticatedRequest('associateSoftwareToken', {
        Session: this.Session
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this13.Session = data.Session;
        return callback.associateSecretCode(data.SecretCode);
      });
    } else {
      this.client.makeUnauthenticatedRequest('associateSoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback.associateSecretCode(data.SecretCode);
      });
    }
  };

  /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
    var _this14 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.makeUnauthenticatedRequest('verifySoftwareToken', {
        Session: this.Session,
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this14.Session = data.Session;
        var challengeResponses = {};
        challengeResponses.USERNAME = _this14.username;
        var jsonReq = {
          ChallengeName: 'MFA_SETUP',
          ClientId: _this14.pool.getClientId(),
          ChallengeResponses: challengeResponses,
          Session: _this14.Session
        };
        if (_this14.getUserContextData()) {
          jsonReq.UserContextData = _this14.getUserContextData();
        }
        _this14.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (errRespond, dataRespond) {
          if (errRespond) {
            return callback.onFailure(errRespond);
          }
          _this14.signInUserSession = _this14.getCognitoUserSession(dataRespond.AuthenticationResult);
          _this14.cacheTokens();
          return callback.onSuccess(_this14.signInUserSession);
        });
        return undefined;
      });
    } else {
      this.client.makeUnauthenticatedRequest('verifySoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback(null, data);
      });
    }
  };

  return CognitoUser;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUser);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserAttribute = function () {
  /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */
  function CognitoUserAttribute() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        Name = _ref.Name,
        Value = _ref.Value;

    _classCallCheck(this, CognitoUserAttribute);

    this.Name = Name || '';
    this.Value = Value || '';
  }

  /**
   * @returns {string} the record's value.
   */


  CognitoUserAttribute.prototype.getValue = function getValue() {
    return this.Value;
  };

  /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */


  CognitoUserAttribute.prototype.setValue = function setValue(value) {
    this.Value = value;
    return this;
  };

  /**
   * @returns {string} the record's name.
   */


  CognitoUserAttribute.prototype.getName = function getName() {
    return this.Name;
  };

  /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */


  CognitoUserAttribute.prototype.setName = function setName(name) {
    this.Name = name;
    return this;
  };

  /**
   * @returns {string} a string representation of the record.
   */


  CognitoUserAttribute.prototype.toString = function toString() {
    return JSON.stringify(this);
  };

  /**
   * @returns {object} a flat object representing the record.
   */


  CognitoUserAttribute.prototype.toJSON = function toJSON() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  };

  return CognitoUserAttribute;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserAttribute);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserSession = function () {
  /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */
  function CognitoUserSession() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken,
        RefreshToken = _ref.RefreshToken,
        AccessToken = _ref.AccessToken,
        ClockDrift = _ref.ClockDrift;

    _classCallCheck(this, CognitoUserSession);

    if (AccessToken == null || IdToken == null) {
      throw new Error('Id token and Access Token must be present.');
    }

    this.idToken = IdToken;
    this.refreshToken = RefreshToken;
    this.accessToken = AccessToken;
    this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
  }

  /**
   * @returns {CognitoIdToken} the session's Id token
   */


  CognitoUserSession.prototype.getIdToken = function getIdToken() {
    return this.idToken;
  };

  /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */


  CognitoUserSession.prototype.getRefreshToken = function getRefreshToken() {
    return this.refreshToken;
  };

  /**
   * @returns {CognitoAccessToken} the session's access token
   */


  CognitoUserSession.prototype.getAccessToken = function getAccessToken() {
    return this.accessToken;
  };

  /**
   * @returns {int} the session's clock drift
   */


  CognitoUserSession.prototype.getClockDrift = function getClockDrift() {
    return this.clockDrift;
  };

  /**
   * @returns {int} the computer's clock drift
   */


  CognitoUserSession.prototype.calculateClockDrift = function calculateClockDrift() {
    var now = Math.floor(new Date() / 1000);
    var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());

    return now - iat;
  };

  /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */


  CognitoUserSession.prototype.isValid = function isValid() {
    var now = Math.floor(new Date() / 1000);
    var adjusted = now - this.clockDrift;

    return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
  };

  return CognitoUserSession;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserSession);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** @class */

var DateHelper = function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }

  /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */
  DateHelper.prototype.getNowString = function getNowString() {
    var now = new Date();

    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();

    var hours = now.getUTCHours();
    if (hours < 10) {
      hours = '0' + hours;
    }

    var minutes = now.getUTCMinutes();
    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    var seconds = now.getUTCSeconds();
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    var year = now.getUTCFullYear();

    // ddd MMM D HH:mm:ss UTC YYYY
    var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;

    return dateNow;
  };

  return DateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (DateHelper);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var dataMemory = {};

/** @class */

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  MemoryStorage.setItem = function setItem(key, value) {
    dataMemory[key] = value;
    return dataMemory[key];
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  MemoryStorage.getItem = function getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  MemoryStorage.removeItem = function removeItem(key) {
    return delete dataMemory[key];
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  MemoryStorage.clear = function clear() {
    dataMemory = {};
    return dataMemory;
  };

  return MemoryStorage;
}();

/** @class */


var StorageHelper = function () {

  /**
   * This is used to get a storage object
   * @returns {object} the storage
   */
  function StorageHelper() {
    _classCallCheck(this, StorageHelper);

    try {
      this.storageWindow = window.localStorage;
      this.storageWindow.setItem('aws.cognito.test-ls', 1);
      this.storageWindow.removeItem('aws.cognito.test-ls');
    } catch (exception) {
      this.storageWindow = MemoryStorage;
    }
  }

  /**
   * This is used to return the storage
   * @returns {object} the storage
   */


  StorageHelper.prototype.getStorage = function getStorage() {
    return this.storageWindow;
  };

  return StorageHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (StorageHelper);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */
AWS.Credentials = AWS.util.inherit({
  /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */
  constructor: function Credentials() {
    // hide secretAccessKey from being displayed with util.inspect
    AWS.util.hideProperties(this, ['secretAccessKey']);

    this.expired = false;
    this.expireTime = null;
    if (arguments.length === 1 && typeof arguments[0] === 'object') {
      var creds = arguments[0].credentials || arguments[0];
      this.accessKeyId = creds.accessKeyId;
      this.secretAccessKey = creds.secretAccessKey;
      this.sessionToken = creds.sessionToken;
    } else {
      this.accessKeyId = arguments[0];
      this.secretAccessKey = arguments[1];
      this.sessionToken = arguments[2];
    }
  },

  /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */
  expiryWindow: 15,

  /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */
  needsRefresh: function needsRefresh() {
    var currentTime = AWS.util.date.getDate().getTime();
    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

    if (this.expireTime && adjustedTime > this.expireTime) {
      return true;
    } else {
      return this.expired || !this.accessKeyId || !this.secretAccessKey;
    }
  },

  /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */
  get: function get(callback) {
    var self = this;
    if (this.needsRefresh()) {
      this.refresh(function(err) {
        if (!err) self.expired = false; // reset expired flag
        if (callback) callback(err);
      });
    } else if (callback) {
      callback();
    }
  },

  /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */
  refresh: function refresh(callback) {
    this.expired = false;
    callback();
  }
});

/**
 * @api private
 */
AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
};

/**
 * @api private
 */
AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.getPromise;
  delete this.prototype.refreshPromise;
};

AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */
AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

  /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */
  constructor: function CredentialProviderChain(providers) {
    if (providers) {
      this.providers = providers;
    } else {
      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
    }
  },

  /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */

  /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */
  resolve: function resolve(callback) {
    if (this.providers.length === 0) {
      callback(new Error('No providers'));
      return this;
    }

    var index = 0;
    var providers = this.providers.slice(0);

    function resolveNext(err, creds) {
      if ((!err && creds) || index === providers.length) {
        callback(err, creds);
        return;
      }

      var provider = providers[index++];
      if (typeof provider === 'function') {
        creds = provider.call();
      } else {
        creds = provider;
      }

      if (creds.get) {
        creds.get(function(getErr) {
          resolveNext(getErr, getErr ? null : creds);
        });
      } else {
        resolveNext(null, creds);
      }
    }

    resolveNext();
    return this;
  }
});

/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () {
 *     // if AWS_CONTAINER_CREDENTIALS_RELATIVE_URI is set
 *       return new AWS.ECSCredentials();
 *     // else
 *       return new AWS.EC2MetadataCredentials();
 *   }
 * ]
 * ```
 */
AWS.CredentialProviderChain.defaultProviders = [];

/**
 * @api private
 */
AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
};

/**
 * @api private
 */
AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.resolvePromise;
};

AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */
AWS.Endpoint = inherit({

  /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */
  constructor: function Endpoint(endpoint, config) {
    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

    if (typeof endpoint === 'undefined' || endpoint === null) {
      throw new Error('Invalid endpoint: ' + endpoint);
    } else if (typeof endpoint !== 'string') {
      return AWS.util.copy(endpoint);
    }

    if (!endpoint.match(/^http/)) {
      var useSSL = config && config.sslEnabled !== undefined ?
        config.sslEnabled : AWS.config.sslEnabled;
      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
    }

    AWS.util.update(this, AWS.util.urlParse(endpoint));

    // Ensure the port property is set as an integer
    if (this.port) {
      this.port = parseInt(this.port, 10);
    } else {
      this.port = this.protocol === 'https:' ? 443 : 80;
    }
  }

});

/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */
AWS.HttpRequest = inherit({

  /**
   * @api private
   */
  constructor: function HttpRequest(endpoint, region) {
    endpoint = new AWS.Endpoint(endpoint);
    this.method = 'POST';
    this.path = endpoint.path || '/';
    this.headers = {};
    this.body = '';
    this.endpoint = endpoint;
    this.region = region;
    this._userAgent = '';
    this.setUserAgent();
  },

  /**
   * @api private
   */
  setUserAgent: function setUserAgent() {
    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
  },

  getUserAgentHeaderName: function getUserAgentHeaderName() {
    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
    return prefix + 'User-Agent';
  },

  /**
   * @api private
   */
  appendToUserAgent: function appendToUserAgent(agentPartial) {
    if (typeof agentPartial === 'string' && agentPartial) {
      this._userAgent += ' ' + agentPartial;
    }
    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
  },

  /**
   * @api private
   */
  getUserAgent: function getUserAgent() {
    return this._userAgent;
  },

  /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */
  pathname: function pathname() {
    return this.path.split('?', 1)[0];
  },

  /**
   * @return [String] the query string portion of the {path}
   */
  search: function search() {
    var query = this.path.split('?', 2)[1];
    if (query) {
      query = AWS.util.queryStringParse(query);
      return AWS.util.queryParamsToString(query);
    }
    return '';
  }

});

/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */
AWS.HttpResponse = inherit({

  /**
   * @api private
   */
  constructor: function HttpResponse() {
    this.statusCode = undefined;
    this.headers = {};
    this.body = undefined;
    this.streaming = false;
    this.stream = null;
  },

  /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */
  createUnbufferedStream: function createUnbufferedStream() {
    this.streaming = true;
    return this.stream;
  }
});


AWS.HttpClient = inherit({});

/**
 * @api private
 */
AWS.HttpClient.getInstance = function getInstance() {
  if (this.singleton === undefined) {
    this.singleton = new this();
  }
  return this.singleton;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(345);
var Operation = __webpack_require__(346);
var Shape = __webpack_require__(127);
var Paginator = __webpack_require__(347);
var ResourceWaiter = __webpack_require__(348);

var util = __webpack_require__(27);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Api(api, options) {
  api = api || {};
  options = options || {};
  options.api = this;

  api.metadata = api.metadata || {};

  property(this, 'isApi', true, false);
  property(this, 'apiVersion', api.metadata.apiVersion);
  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
  property(this, 'signingName', api.metadata.signingName);
  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
  property(this, 'signatureVersion', api.metadata.signatureVersion);
  property(this, 'jsonVersion', api.metadata.jsonVersion);
  property(this, 'targetPrefix', api.metadata.targetPrefix);
  property(this, 'protocol', api.metadata.protocol);
  property(this, 'timestampFormat', api.metadata.timestampFormat);
  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
  property(this, 'fullName', api.metadata.serviceFullName);

  memoizedProperty(this, 'className', function() {
    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
    if (!name) return null;

    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
    if (name === 'ElasticLoadBalancing') name = 'ELB';
    return name;
  });

  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
    return new Operation(name, operation, options);
  }, util.string.lowerFirst));

  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
    return Shape.create(shape, options);
  }));

  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
    return new Paginator(name, paginator, options);
  }));

  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
    return new ResourceWaiter(name, waiter, options);
  }, util.string.lowerFirst));

  if (options.documentation) {
    property(this, 'documentation', api.documentation);
    property(this, 'documentationUrl', api.documentationUrl);
  }
}

module.exports = Api;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var memoizedProperty = __webpack_require__(27).memoizedProperty;

function memoize(name, value, fn, nameTr) {
  memoizedProperty(this, nameTr(name), function() {
    return fn(name, value);
  });
}

function Collection(iterable, options, fn, nameTr) {
  nameTr = nameTr || String;
  var self = this;

  for (var id in iterable) {
    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
      memoize.call(self, id, iterable[id], fn, nameTr);
    }
  }
}

module.exports = Collection;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(127);

var util = __webpack_require__(27);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Operation(name, operation, options) {
  var self = this;
  options = options || {};

  property(this, 'name', operation.name || name);
  property(this, 'api', options.api, false);

  operation.http = operation.http || {};
  property(this, 'httpMethod', operation.http.method || 'POST');
  property(this, 'httpPath', operation.http.requestUri || '/');
  property(this, 'authtype', operation.authtype || '');

  memoizedProperty(this, 'input', function() {
    if (!operation.input) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.input, options);
  });

  memoizedProperty(this, 'output', function() {
    if (!operation.output) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.output, options);
  });

  memoizedProperty(this, 'errors', function() {
    var list = [];
    if (!operation.errors) return null;

    for (var i = 0; i < operation.errors.length; i++) {
      list.push(Shape.create(operation.errors[i], options));
    }

    return list;
  });

  memoizedProperty(this, 'paginator', function() {
    return options.api.paginators[name];
  });

  if (options.documentation) {
    property(this, 'documentation', operation.documentation);
    property(this, 'documentationUrl', operation.documentationUrl);
  }

  // idempotentMembers only tracks top-level input shapes
  memoizedProperty(this, 'idempotentMembers', function() {
    var idempotentMembers = [];
    var input = self.input;
    var members = input.members;
    if (!input.members) {
      return idempotentMembers;
    }
    for (var name in members) {
      if (!members.hasOwnProperty(name)) {
        continue;
      }
      if (members[name].isIdempotent === true) {
        idempotentMembers.push(name);
      }
    }
    return idempotentMembers;
  });

}

module.exports = Operation;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var property = __webpack_require__(27).property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

module.exports = Paginator;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var property = util.property;

function ResourceWaiter(name, waiter, options) {
  options = options || {};
  property(this, 'name', name);
  property(this, 'api', options.api, false);

  if (waiter.operation) {
    property(this, 'operation', util.string.lowerFirst(waiter.operation));
  }

  var self = this;
  var keys = [
    'type',
    'description',
    'delay',
    'maxAttempts',
    'acceptors'
  ];

  keys.forEach(function(key) {
    var value = waiter[key];
    if (value) {
      property(self, key, value);
    }
  });
}

module.exports = ResourceWaiter;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var util = __webpack_require__(27);
var QueryParamSerializer = __webpack_require__(738);
var Shape = __webpack_require__(127);

function buildRequest(req) {
  var operation = req.service.api.operations[req.operation];
  var httpRequest = req.httpRequest;
  httpRequest.headers['Content-Type'] =
    'application/x-www-form-urlencoded; charset=utf-8';
  httpRequest.params = {
    Version: req.service.api.apiVersion,
    Action: operation.name
  };

  // convert the request parameters into a list of query params,
  // e.g. Deeply.NestedParam.0.Name=value
  var builder = new QueryParamSerializer();
  builder.serialize(req.params, operation.input, function(name, value) {
    httpRequest.params[name] = value;
  });
  httpRequest.body = util.queryParamsToString(httpRequest.params);
}

function extractError(resp) {
  var data, body = resp.httpResponse.body.toString();
  if (body.match('<UnknownOperationException')) {
    data = {
      Code: 'UnknownOperation',
      Message: 'Unknown operation ' + resp.request.operation
    };
  } else {
    try {
      data = new AWS.XML.Parser().parse(body);
    } catch (e) {
      data = {
        Code: resp.httpResponse.statusCode,
        Message: resp.httpResponse.statusMessage
      };
    }
  }

  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var shape = operation.output || {};
  var origRules = shape;

  if (origRules.resultWrapper) {
    var tmp = Shape.create({type: 'structure'});
    tmp.members[origRules.resultWrapper] = shape;
    tmp.memberNames = [origRules.resultWrapper];
    util.property(shape, 'name', shape.resultWrapper);
    shape = tmp;
  }

  var parser = new AWS.XML.Parser();

  // TODO: Refactor XML Parser to parse RequestId from response.
  if (shape && shape.members && !shape.members._XAMZRequestId) {
    var requestIdShape = Shape.create(
      { type: 'string' },
      { api: { protocol: 'query' } },
      'requestId'
    );
    shape.members._XAMZRequestId = requestIdShape;
  }

  var data = parser.parse(resp.httpResponse.body.toString(), shape);
  resp.requestId = data._XAMZRequestId || data.requestId;

  if (data._XAMZRequestId) delete data._XAMZRequestId;

  if (origRules.resultWrapper) {
    if (data[origRules.resultWrapper]) {
      util.update(data, data[origRules.resultWrapper]);
      delete data[origRules.resultWrapper];
    }
  }

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var Rest = __webpack_require__(156);
var Json = __webpack_require__(220);
var JsonBuilder = __webpack_require__(218);
var JsonParser = __webpack_require__(219);

function populateBody(req) {
  var builder = new JsonBuilder();
  var input = req.service.api.operations[req.operation].input;

  if (input.payload) {
    var params = {};
    var payloadShape = input.members[input.payload];
    params = req.params[input.payload];
    if (params === undefined) return;

    if (payloadShape.type === 'structure') {
      req.httpRequest.body = builder.build(params, payloadShape);
      applyContentTypeHeader(req);
    } else { // non-JSON payload
      req.httpRequest.body = params;
      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
        applyContentTypeHeader(req, true);
      }
    }
  } else {
    req.httpRequest.body = builder.build(req.params, input);
    applyContentTypeHeader(req);
  }
}

function applyContentTypeHeader(req, isBinary) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  if (!req.httpRequest.headers['Content-Type']) {
    var type = isBinary ? 'binary/octet-stream' : 'application/json';
    req.httpRequest.headers['Content-Type'] = type;
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD/DELETE
  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Json.extractError(resp);
}

function extractData(resp) {
  Rest.extractData(resp);

  var req = resp.request;
  var rules = req.service.api.operations[req.operation].output || {};
  if (rules.payload) {
    var payloadMember = rules.members[rules.payload];
    var body = resp.httpResponse.body;
    if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
      var parser = new JsonParser();
      resp.data[rules.payload] = parser.parse(body, payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[rules.payload] = body;
    } else {
      resp.data[rules.payload] = payloadMember.toType(body);
    }
  } else {
    var data = resp.data;
    Json.extractData(resp);
    resp.data = util.merge(data, resp.data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var util = __webpack_require__(27);
var Rest = __webpack_require__(156);

function populateBody(req) {
  var input = req.service.api.operations[req.operation].input;
  var builder = new AWS.XML.Builder();
  var params = req.params;

  var payload = input.payload;
  if (payload) {
    var payloadMember = input.members[payload];
    params = params[payload];
    if (params === undefined) return;

    if (payloadMember.type === 'structure') {
      var rootElement = payloadMember.name;
      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
    } else { // non-xml payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.toXML(params, input, input.name ||
      input.shape || util.string.upperFirst(req.operation) + 'Request');
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD
  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Rest.extractError(resp);

  var data;
  try {
    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
  } catch (e) {
    data = {
      Code: resp.httpResponse.statusCode,
      Message: resp.httpResponse.statusMessage
    };
  }

  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  Rest.extractData(resp);

  var parser;
  var req = resp.request;
  var body = resp.httpResponse.body;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  var payload = output.payload;
  if (payload) {
    var payloadMember = output.members[payload];
    if (payloadMember.type === 'structure') {
      parser = new AWS.XML.Parser();
      resp.data[payload] = parser.parse(body.toString(), payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[payload] = body;
    } else {
      resp.data[payload] = payloadMember.toType(body);
    }
  } else if (body.length > 0) {
    parser = new AWS.XML.Parser();
    var data = parser.parse(body.toString(), output);
    util.update(resp.data, data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */
AWS.SequentialExecutor = AWS.util.inherit({

  constructor: function SequentialExecutor() {
    this._events = {};
  },

  /**
   * @api private
   */
  listeners: function listeners(eventName) {
    return this._events[eventName] ? this._events[eventName].slice(0) : [];
  },

  on: function on(eventName, listener) {
    if (this._events[eventName]) {
      this._events[eventName].push(listener);
    } else {
      this._events[eventName] = [listener];
    }
    return this;
  },

  /**
   * @api private
   */
  onAsync: function onAsync(eventName, listener) {
    listener._isAsync = true;
    return this.on(eventName, listener);
  },

  removeListener: function removeListener(eventName, listener) {
    var listeners = this._events[eventName];
    if (listeners) {
      var length = listeners.length;
      var position = -1;
      for (var i = 0; i < length; ++i) {
        if (listeners[i] === listener) {
          position = i;
        }
      }
      if (position > -1) {
        listeners.splice(position, 1);
      }
    }
    return this;
  },

  removeAllListeners: function removeAllListeners(eventName) {
    if (eventName) {
      delete this._events[eventName];
    } else {
      this._events = {};
    }
    return this;
  },

  /**
   * @api private
   */
  emit: function emit(eventName, eventArgs, doneCallback) {
    if (!doneCallback) doneCallback = function() { };
    var listeners = this.listeners(eventName);
    var count = listeners.length;
    this.callListeners(listeners, eventArgs, doneCallback);
    return count > 0;
  },

  /**
   * @api private
   */
  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
    var self = this;
    var error = prevError || null;

    function callNextListener(err) {
      if (err) {
        error = AWS.util.error(error || new Error(), err);
        if (self._haltHandlersOnError) {
          return doneCallback.call(self, error);
        }
      }
      self.callListeners(listeners, args, doneCallback, error);
    }

    while (listeners.length > 0) {
      var listener = listeners.shift();
      if (listener._isAsync) { // asynchronous listener
        listener.apply(self, args.concat([callNextListener]));
        return; // stop here, callNextListener will continue
      } else { // synchronous listener
        try {
          listener.apply(self, args);
        } catch (err) {
          error = AWS.util.error(error || new Error(), err);
        }
        if (error && self._haltHandlersOnError) {
          doneCallback.call(self, error);
          return;
        }
      }
    }
    doneCallback.call(self, error);
  },

  /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */
  addListeners: function addListeners(listeners) {
    var self = this;

    // extract listeners if parameter is an SequentialExecutor object
    if (listeners._events) listeners = listeners._events;

    AWS.util.each(listeners, function(event, callbacks) {
      if (typeof callbacks === 'function') callbacks = [callbacks];
      AWS.util.arrayEach(callbacks, function(callback) {
        self.on(event, callback);
      });
    });

    return self;
  },

  /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */
  addNamedListener: function addNamedListener(name, eventName, callback) {
    this[name] = callback;
    this.addListener(eventName, callback);
    return this;
  },

  /**
   * @api private
   */
  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
    callback._isAsync = true;
    return this.addNamedListener(name, eventName, callback);
  },

  /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */
  addNamedListeners: function addNamedListeners(callback) {
    var self = this;
    callback(
      function() {
        self.addNamedListener.apply(self, arguments);
      },
      function() {
        self.addNamedAsyncListener.apply(self, arguments);
      }
    );
    return this;
  }
});

/**
 * {on} is the prefered method.
 * @api private
 */
AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

module.exports = AWS.SequentialExecutor;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    var datetime = AWS.util.date.rfc822(date);

    this.request.headers['X-Amz-Date'] = datetime;

    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    this.request.headers['X-Amzn-Authorization'] =
      this.authorization(credentials, datetime);

  },

  authorization: function authorization(credentials) {
    return 'AWS3 ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'SignedHeaders=' + this.signedHeaders() + ',' +
      'Signature=' + this.signature(credentials);
  },

  signedHeaders: function signedHeaders() {
    var headers = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      headers.push(h.toLowerCase());
    });
    return headers.sort().join(';');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = this.request.headers;
    var parts = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
    });
    return parts.sort().join('\n') + '\n';
  },

  headersToSign: function headersToSign() {
    var headers = [];
    AWS.util.each(this.request.headers, function iterator(k) {
      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
        headers.push(k);
      }
    });
    return headers;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push('/');
    parts.push('');
    parts.push(this.canonicalHeaders());
    parts.push(this.request.body);
    return AWS.util.crypto.sha256(parts.join('\n'));
  }

});

module.exports = AWS.Signers.V3;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentity'] = {};
AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
__webpack_require__(1010);
Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(785);
    model.paginators = __webpack_require__(786).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentity;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */
AWS.Credentials = AWS.util.inherit({
  /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */
  constructor: function Credentials() {
    // hide secretAccessKey from being displayed with util.inspect
    AWS.util.hideProperties(this, ['secretAccessKey']);

    this.expired = false;
    this.expireTime = null;
    if (arguments.length === 1 && typeof arguments[0] === 'object') {
      var creds = arguments[0].credentials || arguments[0];
      this.accessKeyId = creds.accessKeyId;
      this.secretAccessKey = creds.secretAccessKey;
      this.sessionToken = creds.sessionToken;
    } else {
      this.accessKeyId = arguments[0];
      this.secretAccessKey = arguments[1];
      this.sessionToken = arguments[2];
    }
  },

  /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */
  expiryWindow: 15,

  /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */
  needsRefresh: function needsRefresh() {
    var currentTime = AWS.util.date.getDate().getTime();
    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

    if (this.expireTime && adjustedTime > this.expireTime) {
      return true;
    } else {
      return this.expired || !this.accessKeyId || !this.secretAccessKey;
    }
  },

  /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */
  get: function get(callback) {
    var self = this;
    if (this.needsRefresh()) {
      this.refresh(function(err) {
        if (!err) self.expired = false; // reset expired flag
        if (callback) callback(err);
      });
    } else if (callback) {
      callback();
    }
  },

  /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */
  refresh: function refresh(callback) {
    this.expired = false;
    callback();
  }
});

/**
 * @api private
 */
AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
};

/**
 * @api private
 */
AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.getPromise;
  delete this.prototype.refreshPromise;
};

AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */
AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

  /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */
  constructor: function CredentialProviderChain(providers) {
    if (providers) {
      this.providers = providers;
    } else {
      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
    }
  },

  /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */

  /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */
  resolve: function resolve(callback) {
    if (this.providers.length === 0) {
      callback(new Error('No providers'));
      return this;
    }

    var index = 0;
    var providers = this.providers.slice(0);

    function resolveNext(err, creds) {
      if ((!err && creds) || index === providers.length) {
        callback(err, creds);
        return;
      }

      var provider = providers[index++];
      if (typeof provider === 'function') {
        creds = provider.call();
      } else {
        creds = provider;
      }

      if (creds.get) {
        creds.get(function(getErr) {
          resolveNext(getErr, getErr ? null : creds);
        });
      } else {
        resolveNext(null, creds);
      }
    }

    resolveNext();
    return this;
  }
});

/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () {
 *     // if AWS_CONTAINER_CREDENTIALS_RELATIVE_URI is set
 *       return new AWS.ECSCredentials();
 *     // else
 *       return new AWS.EC2MetadataCredentials();
 *   }
 * ]
 * ```
 */
AWS.CredentialProviderChain.defaultProviders = [];

/**
 * @api private
 */
AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
};

/**
 * @api private
 */
AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.resolvePromise;
};

AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(3).util;
var typeOf = __webpack_require__(358).typeOf;

var memberTypeToSetType = {
  'String': 'String',
  'Number': 'Number',
  'NumberValue': 'Number',
  'Binary': 'Binary'
};

/**
 * @api private
 */
var DynamoDBSet = util.inherit({

  constructor: function Set(list, options) {
    options = options || {};
    this.initialize(list, options.validate);
  },

  initialize: function(list, validate) {
    var self = this;
    self.values = [].concat(list);
    self.detectType();
    if (validate) {
      self.validate();
    }
  },

  detectType: function() {
    this.type = memberTypeToSetType[typeOf(this.values[0])];
    if (!this.type) {
      throw util.error(new Error(), {
        code: 'InvalidSetType',
        message: 'Sets can contain string, number, or binary values'
      });
    }
  },

  validate: function() {
    var self = this;
    var length = self.values.length;
    var values = self.values;
    for (var i = 0; i < length; i++) {
      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
        throw util.error(new Error(), {
          code: 'InvalidType',
          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
        });
      }
    }
  }

});

module.exports = DynamoDBSet;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(3).util;

function typeOf(data) {
  if (data === null && typeof data === 'object') {
    return 'null';
  } else if (data !== undefined && isBinary(data)) {
    return 'Binary';
  } else if (data !== undefined && data.constructor) {
    return util.typeName(data.constructor);
  } else if (data !== undefined && typeof data === 'object') {
    // this object is the result of Object.create(null), hence the absence of a
    // defined constructor
    return 'Object';
  } else {
    return 'undefined';
  }
}

function isBinary(data) {
  var types = [
    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
    'Float32Array', 'Float64Array'
  ];
  if (util.isNode()) {
    var Stream = util.stream.Stream;
    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
      return true;
    }
  }

  for (var i = 0; i < types.length; i++) {
    if (data !== undefined && data.constructor) {
      if (util.isType(data, types[i])) return true;
      if (util.typeName(data.constructor) === types[i]) return true;
    }
  }

  return false;
}

module.exports = {
  typeOf: typeOf,
  isBinary: isBinary
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */
AWS.Endpoint = inherit({

  /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */
  constructor: function Endpoint(endpoint, config) {
    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

    if (typeof endpoint === 'undefined' || endpoint === null) {
      throw new Error('Invalid endpoint: ' + endpoint);
    } else if (typeof endpoint !== 'string') {
      return AWS.util.copy(endpoint);
    }

    if (!endpoint.match(/^http/)) {
      var useSSL = config && config.sslEnabled !== undefined ?
        config.sslEnabled : AWS.config.sslEnabled;
      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
    }

    AWS.util.update(this, AWS.util.urlParse(endpoint));

    // Ensure the port property is set as an integer
    if (this.port) {
      this.port = parseInt(this.port, 10);
    } else {
      this.port = this.protocol === 'https:' ? 443 : 80;
    }
  }

});

/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */
AWS.HttpRequest = inherit({

  /**
   * @api private
   */
  constructor: function HttpRequest(endpoint, region) {
    endpoint = new AWS.Endpoint(endpoint);
    this.method = 'POST';
    this.path = endpoint.path || '/';
    this.headers = {};
    this.body = '';
    this.endpoint = endpoint;
    this.region = region;
    this._userAgent = '';
    this.setUserAgent();
  },

  /**
   * @api private
   */
  setUserAgent: function setUserAgent() {
    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
  },

  getUserAgentHeaderName: function getUserAgentHeaderName() {
    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
    return prefix + 'User-Agent';
  },

  /**
   * @api private
   */
  appendToUserAgent: function appendToUserAgent(agentPartial) {
    if (typeof agentPartial === 'string' && agentPartial) {
      this._userAgent += ' ' + agentPartial;
    }
    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
  },

  /**
   * @api private
   */
  getUserAgent: function getUserAgent() {
    return this._userAgent;
  },

  /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */
  pathname: function pathname() {
    return this.path.split('?', 1)[0];
  },

  /**
   * @return [String] the query string portion of the {path}
   */
  search: function search() {
    var query = this.path.split('?', 2)[1];
    if (query) {
      query = AWS.util.queryStringParse(query);
      return AWS.util.queryParamsToString(query);
    }
    return '';
  }

});

/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */
AWS.HttpResponse = inherit({

  /**
   * @api private
   */
  constructor: function HttpResponse() {
    this.statusCode = undefined;
    this.headers = {};
    this.body = undefined;
    this.streaming = false;
    this.stream = null;
  },

  /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */
  createUnbufferedStream: function createUnbufferedStream() {
    this.streaming = true;
    return this.stream;
  }
});


AWS.HttpClient = inherit({});

/**
 * @api private
 */
AWS.HttpClient.getInstance = function getInstance() {
  if (this.singleton === undefined) {
    this.singleton = new this();
  }
  return this.singleton;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(361);
var Operation = __webpack_require__(362);
var Shape = __webpack_require__(129);
var Paginator = __webpack_require__(363);
var ResourceWaiter = __webpack_require__(364);

var util = __webpack_require__(28);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Api(api, options) {
  api = api || {};
  options = options || {};
  options.api = this;

  api.metadata = api.metadata || {};

  property(this, 'isApi', true, false);
  property(this, 'apiVersion', api.metadata.apiVersion);
  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
  property(this, 'signingName', api.metadata.signingName);
  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
  property(this, 'signatureVersion', api.metadata.signatureVersion);
  property(this, 'jsonVersion', api.metadata.jsonVersion);
  property(this, 'targetPrefix', api.metadata.targetPrefix);
  property(this, 'protocol', api.metadata.protocol);
  property(this, 'timestampFormat', api.metadata.timestampFormat);
  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
  property(this, 'fullName', api.metadata.serviceFullName);

  memoizedProperty(this, 'className', function() {
    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
    if (!name) return null;

    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
    if (name === 'ElasticLoadBalancing') name = 'ELB';
    return name;
  });

  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
    return new Operation(name, operation, options);
  }, util.string.lowerFirst));

  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
    return Shape.create(shape, options);
  }));

  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
    return new Paginator(name, paginator, options);
  }));

  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
    return new ResourceWaiter(name, waiter, options);
  }, util.string.lowerFirst));

  if (options.documentation) {
    property(this, 'documentation', api.documentation);
    property(this, 'documentationUrl', api.documentationUrl);
  }
}

module.exports = Api;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var memoizedProperty = __webpack_require__(28).memoizedProperty;

function memoize(name, value, fn, nameTr) {
  memoizedProperty(this, nameTr(name), function() {
    return fn(name, value);
  });
}

function Collection(iterable, options, fn, nameTr) {
  nameTr = nameTr || String;
  var self = this;

  for (var id in iterable) {
    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
      memoize.call(self, id, iterable[id], fn, nameTr);
    }
  }
}

module.exports = Collection;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(129);

var util = __webpack_require__(28);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Operation(name, operation, options) {
  var self = this;
  options = options || {};

  property(this, 'name', operation.name || name);
  property(this, 'api', options.api, false);

  operation.http = operation.http || {};
  property(this, 'httpMethod', operation.http.method || 'POST');
  property(this, 'httpPath', operation.http.requestUri || '/');
  property(this, 'authtype', operation.authtype || '');

  memoizedProperty(this, 'input', function() {
    if (!operation.input) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.input, options);
  });

  memoizedProperty(this, 'output', function() {
    if (!operation.output) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.output, options);
  });

  memoizedProperty(this, 'errors', function() {
    var list = [];
    if (!operation.errors) return null;

    for (var i = 0; i < operation.errors.length; i++) {
      list.push(Shape.create(operation.errors[i], options));
    }

    return list;
  });

  memoizedProperty(this, 'paginator', function() {
    return options.api.paginators[name];
  });

  if (options.documentation) {
    property(this, 'documentation', operation.documentation);
    property(this, 'documentationUrl', operation.documentationUrl);
  }

  // idempotentMembers only tracks top-level input shapes
  memoizedProperty(this, 'idempotentMembers', function() {
    var idempotentMembers = [];
    var input = self.input;
    var members = input.members;
    if (!input.members) {
      return idempotentMembers;
    }
    for (var name in members) {
      if (!members.hasOwnProperty(name)) {
        continue;
      }
      if (members[name].isIdempotent === true) {
        idempotentMembers.push(name);
      }
    }
    return idempotentMembers;
  });

}

module.exports = Operation;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var property = __webpack_require__(28).property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

module.exports = Paginator;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var property = util.property;

function ResourceWaiter(name, waiter, options) {
  options = options || {};
  property(this, 'name', name);
  property(this, 'api', options.api, false);

  if (waiter.operation) {
    property(this, 'operation', util.string.lowerFirst(waiter.operation));
  }

  var self = this;
  var keys = [
    'type',
    'description',
    'delay',
    'maxAttempts',
    'acceptors'
  ];

  keys.forEach(function(key) {
    var value = waiter[key];
    if (value) {
      property(self, key, value);
    }
  });
}

module.exports = ResourceWaiter;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var util = __webpack_require__(28);
var QueryParamSerializer = __webpack_require__(999);
var Shape = __webpack_require__(129);

function buildRequest(req) {
  var operation = req.service.api.operations[req.operation];
  var httpRequest = req.httpRequest;
  httpRequest.headers['Content-Type'] =
    'application/x-www-form-urlencoded; charset=utf-8';
  httpRequest.params = {
    Version: req.service.api.apiVersion,
    Action: operation.name
  };

  // convert the request parameters into a list of query params,
  // e.g. Deeply.NestedParam.0.Name=value
  var builder = new QueryParamSerializer();
  builder.serialize(req.params, operation.input, function(name, value) {
    httpRequest.params[name] = value;
  });
  httpRequest.body = util.queryParamsToString(httpRequest.params);
}

function extractError(resp) {
  var data, body = resp.httpResponse.body.toString();
  if (body.match('<UnknownOperationException')) {
    data = {
      Code: 'UnknownOperation',
      Message: 'Unknown operation ' + resp.request.operation
    };
  } else {
    try {
      data = new AWS.XML.Parser().parse(body);
    } catch (e) {
      data = {
        Code: resp.httpResponse.statusCode,
        Message: resp.httpResponse.statusMessage
      };
    }
  }

  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var shape = operation.output || {};
  var origRules = shape;

  if (origRules.resultWrapper) {
    var tmp = Shape.create({type: 'structure'});
    tmp.members[origRules.resultWrapper] = shape;
    tmp.memberNames = [origRules.resultWrapper];
    util.property(shape, 'name', shape.resultWrapper);
    shape = tmp;
  }

  var parser = new AWS.XML.Parser();

  // TODO: Refactor XML Parser to parse RequestId from response.
  if (shape && shape.members && !shape.members._XAMZRequestId) {
    var requestIdShape = Shape.create(
      { type: 'string' },
      { api: { protocol: 'query' } },
      'requestId'
    );
    shape.members._XAMZRequestId = requestIdShape;
  }

  var data = parser.parse(resp.httpResponse.body.toString(), shape);
  resp.requestId = data._XAMZRequestId || data.requestId;

  if (data._XAMZRequestId) delete data._XAMZRequestId;

  if (origRules.resultWrapper) {
    if (data[origRules.resultWrapper]) {
      util.update(data, data[origRules.resultWrapper]);
      delete data[origRules.resultWrapper];
    }
  }

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var Rest = __webpack_require__(157);
var Json = __webpack_require__(223);
var JsonBuilder = __webpack_require__(221);
var JsonParser = __webpack_require__(222);

function populateBody(req) {
  var builder = new JsonBuilder();
  var input = req.service.api.operations[req.operation].input;

  if (input.payload) {
    var params = {};
    var payloadShape = input.members[input.payload];
    params = req.params[input.payload];
    if (params === undefined) return;

    if (payloadShape.type === 'structure') {
      req.httpRequest.body = builder.build(params, payloadShape);
      applyContentTypeHeader(req);
    } else { // non-JSON payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.build(req.params, input);
    applyContentTypeHeader(req);
  }
}

function applyContentTypeHeader(req) {
  if (!req.httpRequest.headers['Content-Type']) {
    req.httpRequest.headers['Content-Type'] = 'application/json';
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD/DELETE
  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Json.extractError(resp);
}

function extractData(resp) {
  Rest.extractData(resp);

  var req = resp.request;
  var rules = req.service.api.operations[req.operation].output || {};
  if (rules.payload) {
    var payloadMember = rules.members[rules.payload];
    var body = resp.httpResponse.body;
    if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
      var parser = new JsonParser();
      resp.data[rules.payload] = parser.parse(body, payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[rules.payload] = body;
    } else {
      resp.data[rules.payload] = payloadMember.toType(body);
    }
  } else {
    var data = resp.data;
    Json.extractData(resp);
    resp.data = util.merge(data, resp.data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var util = __webpack_require__(28);
var Rest = __webpack_require__(157);

function populateBody(req) {
  var input = req.service.api.operations[req.operation].input;
  var builder = new AWS.XML.Builder();
  var params = req.params;

  var payload = input.payload;
  if (payload) {
    var payloadMember = input.members[payload];
    params = params[payload];
    if (params === undefined) return;

    if (payloadMember.type === 'structure') {
      var rootElement = payloadMember.name;
      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
    } else { // non-xml payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.toXML(params, input, input.name ||
      input.shape || util.string.upperFirst(req.operation) + 'Request');
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD
  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Rest.extractError(resp);

  var data;
  try {
    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
  } catch (e) {
    data = {
      Code: resp.httpResponse.statusCode,
      Message: resp.httpResponse.statusMessage
    };
  }

  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  Rest.extractData(resp);

  var parser;
  var req = resp.request;
  var body = resp.httpResponse.body;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  var payload = output.payload;
  if (payload) {
    var payloadMember = output.members[payload];
    if (payloadMember.type === 'structure') {
      parser = new AWS.XML.Parser();
      resp.data[payload] = parser.parse(body.toString(), payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[payload] = body;
    } else {
      resp.data[payload] = payloadMember.toType(body);
    }
  } else if (body.length > 0) {
    parser = new AWS.XML.Parser();
    var data = parser.parse(body.toString(), output);
    util.update(resp.data, data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */
AWS.SequentialExecutor = AWS.util.inherit({

  constructor: function SequentialExecutor() {
    this._events = {};
  },

  /**
   * @api private
   */
  listeners: function listeners(eventName) {
    return this._events[eventName] ? this._events[eventName].slice(0) : [];
  },

  on: function on(eventName, listener) {
    if (this._events[eventName]) {
      this._events[eventName].push(listener);
    } else {
      this._events[eventName] = [listener];
    }
    return this;
  },

  /**
   * @api private
   */
  onAsync: function onAsync(eventName, listener) {
    listener._isAsync = true;
    return this.on(eventName, listener);
  },

  removeListener: function removeListener(eventName, listener) {
    var listeners = this._events[eventName];
    if (listeners) {
      var length = listeners.length;
      var position = -1;
      for (var i = 0; i < length; ++i) {
        if (listeners[i] === listener) {
          position = i;
        }
      }
      if (position > -1) {
        listeners.splice(position, 1);
      }
    }
    return this;
  },

  removeAllListeners: function removeAllListeners(eventName) {
    if (eventName) {
      delete this._events[eventName];
    } else {
      this._events = {};
    }
    return this;
  },

  /**
   * @api private
   */
  emit: function emit(eventName, eventArgs, doneCallback) {
    if (!doneCallback) doneCallback = function() { };
    var listeners = this.listeners(eventName);
    var count = listeners.length;
    this.callListeners(listeners, eventArgs, doneCallback);
    return count > 0;
  },

  /**
   * @api private
   */
  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
    var self = this;
    var error = prevError || null;

    function callNextListener(err) {
      if (err) {
        error = AWS.util.error(error || new Error(), err);
        if (self._haltHandlersOnError) {
          return doneCallback.call(self, error);
        }
      }
      self.callListeners(listeners, args, doneCallback, error);
    }

    while (listeners.length > 0) {
      var listener = listeners.shift();
      if (listener._isAsync) { // asynchronous listener
        listener.apply(self, args.concat([callNextListener]));
        return; // stop here, callNextListener will continue
      } else { // synchronous listener
        try {
          listener.apply(self, args);
        } catch (err) {
          error = AWS.util.error(error || new Error(), err);
        }
        if (error && self._haltHandlersOnError) {
          doneCallback.call(self, error);
          return;
        }
      }
    }
    doneCallback.call(self, error);
  },

  /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */
  addListeners: function addListeners(listeners) {
    var self = this;

    // extract listeners if parameter is an SequentialExecutor object
    if (listeners._events) listeners = listeners._events;

    AWS.util.each(listeners, function(event, callbacks) {
      if (typeof callbacks === 'function') callbacks = [callbacks];
      AWS.util.arrayEach(callbacks, function(callback) {
        self.on(event, callback);
      });
    });

    return self;
  },

  /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */
  addNamedListener: function addNamedListener(name, eventName, callback) {
    this[name] = callback;
    this.addListener(eventName, callback);
    return this;
  },

  /**
   * @api private
   */
  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
    callback._isAsync = true;
    return this.addNamedListener(name, eventName, callback);
  },

  /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */
  addNamedListeners: function addNamedListeners(callback) {
    var self = this;
    callback(
      function() {
        self.addNamedListener.apply(self, arguments);
      },
      function() {
        self.addNamedAsyncListener.apply(self, arguments);
      }
    );
    return this;
  }
});

/**
 * {on} is the prefered method.
 * @api private
 */
AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

module.exports = AWS.SequentialExecutor;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    var datetime = AWS.util.date.rfc822(date);

    this.request.headers['X-Amz-Date'] = datetime;

    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    this.request.headers['X-Amzn-Authorization'] =
      this.authorization(credentials, datetime);

  },

  authorization: function authorization(credentials) {
    return 'AWS3 ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'SignedHeaders=' + this.signedHeaders() + ',' +
      'Signature=' + this.signature(credentials);
  },

  signedHeaders: function signedHeaders() {
    var headers = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      headers.push(h.toLowerCase());
    });
    return headers.sort().join(';');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = this.request.headers;
    var parts = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
    });
    return parts.sort().join('\n') + '\n';
  },

  headersToSign: function headersToSign() {
    var headers = [];
    AWS.util.each(this.request.headers, function iterator(k) {
      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
        headers.push(k);
      }
    });
    return headers;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push('/');
    parts.push('');
    parts.push(this.canonicalHeaders());
    parts.push(this.request.body);
    return AWS.util.crypto.sha256(parts.join('\n'));
  }

});

module.exports = AWS.Signers.V3;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * @api private
 */
var cachedSecret = {};

/**
 * @api private
 */
var cacheQueue = [];

/**
 * @api private
 */
var maxCacheEntries = 50;

/**
 * @api private
 */
var v4Identifier = 'aws4_request';

module.exports = {
  /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */
  createScope: function createScope(date, region, serviceName) {
    return [
      date.substr(0, 8),
      region,
      serviceName,
      v4Identifier
    ].join('/');
  },

  /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */
  getSigningKey: function getSigningKey(
    credentials,
    date,
    region,
    service,
    shouldCache
  ) {
    var credsIdentifier = AWS.util.crypto
      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
    var cacheKey = [credsIdentifier, date, region, service].join('_');
    shouldCache = shouldCache !== false;
    if (shouldCache && (cacheKey in cachedSecret)) {
      return cachedSecret[cacheKey];
    }

    var kDate = AWS.util.crypto.hmac(
      'AWS4' + credentials.secretAccessKey,
      date,
      'buffer'
    );
    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
    if (shouldCache) {
      cachedSecret[cacheKey] = signingKey;
      cacheQueue.push(cacheKey);
      if (cacheQueue.length > maxCacheEntries) {
        // remove the oldest entry (not the least recently used)
        delete cachedSecret[cacheQueue.shift()];
      }
    }

    return signingKey;
  },

  /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */
  emptyCache: function emptyCache() {
    cachedSecret = {};
    cacheQueue = [];
  }
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);
var settle = __webpack_require__(1037);
var buildURL = __webpack_require__(1040);
var parseHeaders = __webpack_require__(1046);
var isURLSameOrigin = __webpack_require__(1044);
var createError = __webpack_require__(374);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1039);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1042);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1036);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.'
  }
};

module.exports = messages;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.'
  }
};

module.exports = messages;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.'
  }
};

module.exports = messages;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  'params': {
    'label': 'Русский'
  },
  'service': {
    'flow-and-time': 'Расход воды и время работы',
    'ro-membrane': 'Эффективность работы ОО',
    'temperature': 'Температура',
    'leakage': 'Обнаружение протечки',
    'pressure': 'Давление воды',
    'co2': 'Углекислый газ'
  },
  'service-short': {
    'flow-and-time': 'Расход воды и время',
    'ro-membrane': 'ОО',
    'temperature': 'Температура',
    'leakage': 'Протечки',
    'pressure': 'Давление',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': 'Расходомер',
    'tds': 'Датчик TDS',
    'temperature': 'Датчик температуры',
    'leakage': 'Датчик протечки',
    'pressure': 'Датчик давления'
  },
  'user-params': {
    username: 'Имя пользователя',
    email: 'E-mail',
    password: 'Пароль',
    password_reinput: 'Повторите пароль',
    password_reinput_differs: 'Пароли не совпадают.',
    role: 'Роль'
  },
  'role': {
    'administrator': 'Администратор',
    'manager': 'Менеджер',
    'staff': 'Сервис-инженер'
  },
  'btn': {
    'add': 'Добавить',
    'edit': 'Изменить',
    'cancel': 'Отмена',
    'update': 'Обновить',
    'save': 'Сохранить',
    'ok': 'OK',
    'delete': 'Удалить'
  },
  'validate': {
    'phone-format': 'Пожалуйста, используйте только цифры!',
    'phone-length': 'Телефонный номер должен быть менее 128 цифр',
    'select': 'Пожалуйста, выберите',
    'vali-required': 'Обязательное поле.'
  },
  cognitoError: {
    UserNotFoundException: 'Имя пользователя не найдено.',
    UsernameExistsException: 'Такой пользователь уже создан.',
    UserNotConfirmedException: 'Регистрация пользователя не подтверждена.',
    NotAuthorizedException: 'Неправильные имя пользователя или пароль.',
    LimitExceededException: 'Превышено количество попыток входа, попробуйте позже.',
    CodeMismatchException: 'Неверный код верификации. Попробуйте еще раз.',
    InvalidParameterException: 'Задан неверный параметр.',
    UnknownError: 'Неизвестная ошибка.'
  },
  signup: {
    signup: 'Регистрация нового пользователя',
    register: 'Зарегистрировать нового пользователя',
    btn_check_email: 'Проверьте свою электронную почту',
    buy_iotizr: 'Купить контроллер',
    signupConfirmDialogText: 'Продолжить?',
    signupSuccessDialogText: 'Мы получили Ваш запрос на регистрацию. Вскоре вы получите письмо на указанный Вами адрес электронной почты. Пожалуйста, пройдите по ссылке из письма для подтверждения регистрации.'
  },
  'login': {
    'login': 'Логин',
    'lost': 'Забыли пароль?',
    'link_to_signup': '(en)Sign up',
    'vali-username-blank': 'Требуется имя пользователя.',
    'vali-password-blank': 'Требуется пароль.',
    'next': 'Далее',
    'incorrect': 'Неправильный пароль или имя пользователя.'
  },
  'resetpassword': {
    'title': 'Сброс пароля',
    'detail': 'Введите имя пользователя',
    'entercode': 'Введите код подтверждения.',
    'newpassword': 'Новый пароль',
    'codedetail': 'Письмо с кодом подтверждения было отправлено с адреса "no-reply@verificationemail.com" на указанный Вами при регистрации адрес. Проверьте вашу почту и введите код подтверждения.',
    'resendcode': 'Повторно отправить код',
    'vali-code-blank': 'Требуется код подтверждения.',
    'vali-pass-blank': 'Требуется новый пароль.',
    'vali-pass-number': 'Пароль должен состоять из цифр (0-9) и латинских букв (a-z).',
    'vali-pass-length': 'Пароль должен быть длиннее 7 символов.',
    'vali-pass-whitespace': 'Пароли, содержащие пробелы, не могут быть установлены.',
    'confirm': 'Подтвердить'
  },
  activate: {
    title: 'Активация учетной записи',
    detail: 'Проверьте свою электронную почту и введите имя пользователя и временный пароль. Измените временный пароль, введя новый пароль.',
    temp_password: 'Временный пароль',
    newpassword: 'Новый пароль',
    passwordreinput: 'Повторите новые пароль',
    agreement: 'Соглашение',
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.',
    agree: 'Я прочел соглашение и принимаю его положения.',
    you_need_to_agree: 'Необходимо согласиться.',
    submit: 'Подтвердить',
    complete: 'Активация выполнена'
  },
  'global-menu': {
    'dashboard': 'Главная',
    'watersystem': 'Мониторинг',
    'customer': 'Управление локациями',
    'setting': 'Настройки',
    'pc': '!!! PC Management'
  },
  'home': {
    'notification': 'Оповещения',
    'information': 'От {0}',
    'mail-notification-top': 'Теперь доступны оповещения по электронной почте.',
    'mail-notification-under': 'Пожалуйста, подтвердите свой адрес <a href=\'{0}\'>здесь</a>',
    'quick-link': 'Быстрый доступ',
    'calendar': 'Календарь обслуживания',
    'quick-link-settings': 'Настройки быстрого доступа',
    'notification-alert': 'Достигнут порог оповещения',
    'notification-warning': 'Достигнут порог напоминания'
  },
  'watersystem': {
    'column-nexttime': 'Ожидаемая дата следующего обслуживания',
    'customer-name': 'Название локации',
    'customer': 'Локации',
    'organization-name': 'Организация',
    'device-name': 'Название фильтра',
    'device': 'Фильтры',
    'deviceinfo': 'Информация о фильтре',
    'filter-life-left': 'Осталось ресурса картриджей',
    'filter': 'Картридж',
    'flow-rate': 'Расход воды',
    'flow': 'Поток воды',
    'history': 'История',
    'list': 'Показывать по',
    'mapinfo': 'Карта',
    'name': 'Название',
    'period-month': ', месяцы',
    'purification-amount': 'объем очищенной воды',
    'RoMembrane': 'Эффективность работы мембраны ОО',
    'RoMembrane-short': 'Состояние мембраны ОО',
    'RoMembrane-good': 'Хорошее',
    'RoMembrane-caution': 'Удовлетворительное',
    'RoMembrane-alert': 'Нужна замена',
    'Pressure': 'Датчик давления',
    'Pressure-short': 'Давление',
    'Pressure-good': ' Хорошее',
    'Pressure-caution': 'Удовлетворительное',
    'Pressure-alert': 'Проблема!',
    'service': 'Мониторинг',
    'status': 'Статус',
    'delete-water-system': 'Удалить {0}.\nВся история будет удалена.',
    'delete-water-system-with-iotizr': 'Привязанный контроллер будет продолжать передачу данных.\nЕсли Вы хотите прекратить связь с контроллером, отключите его от электропитания или отвяжите его с помощью приложения.',
    'delete-water-system-ask': 'Вы действительно хотите удалить?',
    'error-delete': 'Удаление не удалось',
    'succeed-delete': 'Успешно удалено',
    'filter-reset': 'Отметить замену картриджей',
    'please-select': 'Выберите фильтр.',
    'elapsed-time': 'Прошло времени',
    'total-flow': 'Очищено воды',
    'customer-info': 'Локация',
    'rest-flow': 'Осталось ресурса',
    'filter-reset-title': 'Внимание!',
    'filter-reset-text': 'Вы действительно хотите сделать отметку о замене картриджей? Счетчики времени и расхода воды будут сброшены.',
    'filter-reset-do': 'Выполнить',
    'filter-reset-cancel': 'Отмена',
    'threshold': 'Порог',
    'notification-threshold': 'Порог оповещения',
    'about-flow-and-time': 'О пороговых значениях расхода воды и времени',
    'about-ro-membrane': 'О пороговых значениях эффективности работы мембраны',
    'about-temperature': 'О пороге температуры',
    'about-pressure': 'О пороговых значениях давления',
    'custom': 'Свои значения',
    'use-preset': 'По умолчанию',
    'flow-life': 'Ресурс по объему воды',
    'time-life': 'Ресурс по времени',
    'alert': 'Оповещение',
    'warning': 'Напоминание',
    'use-flow': 'Тип расходомера',
    'need-sensor': 'Необходимые датчики',
    'about-flow-and-time-text': 'Измеряется расход и объем воды, очищаемой фильтром в течении некоторого времени. При превышении объема очищенной воды или времени мы отправим Вам оповещение.',
    'about-ro-membrane-text': 'Датчики измеряют содержание растворенных примесей о исходной воде и очищенной воде после мембраны ОО. По этим данным расчитывается эффективность удаления примесей мембраной. При снижении эффективности удаления мы пришлём Вам оповещение.',
    'about-pressure-text': 'Измеряется давление воды в точке установки датчика. Возможно подключение нескольких датчиков при наличии свободных портов. При отклонении давления от заданного мы пришлём Вам оповещение.',
    'about-temperature-text': 'Измеряется температура в месте установки датчика. Возможна установка нескольких датчиков. При изменении температуры мы отправим Вам оповещение.',
    'about-setting-flow-and-time-text': 'Задайте значения объема очищенной воды ([UNIT]) и времени (месяцы), при достижении которых будет создано напоминание и оповещение.',
    'about-setting-ro-membrane-text': 'Задайте значения эффективности работы мембраны (%), при достижении которых будет создано предупреждение и оповещение.',
    'about-setting-temperature-text': 'Задайте значения температуры, при достижении которых будет создано предупреждение и оповещение.',
    'about-setting-pressure-text': 'Задайте значения давления, при достижении которых будет создано предупреждение и оповещение.',
    'about-threshold-setting': 'О настройке пороговых значений',
    'headline-press-alert': 'Давление воды ниже, чем заданный порог оповещения.',
    'headline-press-warning': 'Давление воды ниже, чем заданный порог предупреждения.',
    'headline-press-normal': 'На данный момент все значения давления в норме.',
    'headline-diff-press-alert': 'Перепад давления за пределами порога оповещения.',
    'headline-diff-press-warning': 'Перепад давления за пределами порога напоминания.',
    'headline-temperature-up-alert': 'Значение температуры выше порога оповещения.',
    'headline-temperature-up-warning': 'Значение температуры выше порога напоминания.',
    'headline-temperature-down-alert': 'Значение температуры ниже порога оповещения.',
    'headline-temperature-down-warning': 'Значение температуры ниже порога напоминания.',
    'now-pressure': 'Текущее значение давления',
    'vali-threshold-must': 'Необходимые поля',
    'vali-threshold-num': 'Пожалуйста, введите число!',
    'vali-threshold-min': 'Значение ниже измеряемой температуры.',
    'vali-threshold-max': 'Значение выше измеряемой температуры.',
    'vali-threshold-min-comm': 'Пожалуйста, укажите {0} или больше.',
    'vali-threshold-max-comm': 'Пожалуйста, укажите {0} или меньше.',
    'vali-threshold-integer': 'Пожалуйста, введите целое число!',
    'vali-threshold-limit100': 'Пожалуйста, введите число менее 100',
    'vali-threshold-positive-integer': 'Пожалуйста, введите число больше или равное 0!',
    'impurities-removal-rate': 'Качество удаления примесей',
    'entrance-impurity-content': 'Содержание примесей на входе',
    'exit-impurity-content': 'Содержание примесей в очищенной воде',
    'time-elapsed': 'Времени прошло',
    'pressure': 'Давление воды',
    'setting-link-text1': 'Для изменения значений задайте "Порог оповещения" в',
    'setting-link-text2': 'настройках',
    'setting-link-text3': '',
    'vali-threshold-alert-less-than': 'Пожалуйста, задайте значение меньше порога оповещения',
    'vali-threshold-greater-than-warning': 'Пожалуйста, задайте значение больше порога напоминания',
    'vali-threshold-warning-less-than': 'Пожалуйста, задайте значение меньше порога напоминания',
    'vali-threshold-greater-than-alert': 'Пожалуйста, задайте значение больше порога оповещения',
    'last-update': 'Обновлено',
    'past-pressure': 'Значение давления в {0}',
    'last-update-for-chart': 'Последнее обновление',
    'last-update-week-suffix-for-chart': 'неделя {0}',
    'last-impurities-removal-late': 'Текущая эффективность очистки',
    'past-impurities-removal-late': 'эффективность очистки в {0}',
    'differential-pressure': 'Значения перепада давления',
    'about-differential-pressure-text': 'Перепад давления определяется путем измерения давления в двух точках и расчета разницы полученных значений. При превышении перепада давления мы отправим Вам оповещение.',
    'about-setting-differential-pressure-text': 'Задайте пороговые значения перепада давления для напоминания/оповещения.',
    'differential-pressure-need-sensor': '2 датчика давления',
    'differential-pressure-value': 'Значение перепада давления',
    'leakage-all-normal': 'На данный момент протечки отсутствуют',
    'return-to-normal': 'Протекание прекратилось',
    'leakage-alert': 'Обнаружена протечка',
    'detection-history': 'История протечек',
    'no-water-leak-history': 'История протечек отсутствует.',
    'headline-leakage-alert': 'Сработал датчик протечки! Проверьте место размещения фильтра.',
    'leakage-normal': 'Протечек нет',
    'leakage': 'Датчик протечки',
    'leakage-short': 'Датчик протечки',
    'temperature-short': 'Датчик температуры',
    'temperature-alert': 'Оповещение',
    'temperature-warning': 'Напоминание',
    'temperature-normal': 'Всё хорошо',
    'temperature-min': 'или больше',
    'temperature-max': 'или меньше',
    'temperature-increase': 'Сообщение при превышении порога',
    'temperature-decrease': 'Сообщение при снижении ниже порога',
    'temperature-content': 'Температура',
    'temperature-select-label': 'Правила оповещения',
    'now-temperature': 'Текущая температура',
    'past-temperature': 'Температура в {0}'
  },
  'chart': {
    'dataZoom-zoom': 'Масштаб',
    'dataZoom-back': 'Сброс масштаба',
    'change-period': 'Выбор периода',
    'button-reload': 'Обновить',
    'graph-label-fromlastchange': 'Объем очищенной воды с последней замены картриджей',
    'graph-label-diff': 'Объем очищенной воды за период',
    'graph-label-sum': 'Общий объем очищенной воды',
    '15m': '15 минут',
    '1h': '1 час',
    '1d': '1 день',
    '1w': '1 неделя',
    '1M': '1 месяц',
    'auto-reload': 'Автообновление',
    'label-date': 'Дата',
    'label-time': 'Время',
    'button-date-jump': 'Перейти',
    'button-date-recent': 'Недавние',
    'button-ok': 'ОК',
    'button-cancel': 'Отмена',
    'message-oldest': 'Отображение построено от самых старых значений, поскольку данные на выбранный момент времени невозможно показать по центру.',
    'message-latest': 'Отображенаются последне данные, поскольку данные на выбранный момент времени невозможно показать по центру.',
    'message-outbounds-oldest': 'Отображение построено от самых старых значений, поскольку данные на выбранный момент времени отсутствуют.',
    'message-outbounds-latest': 'Отображенаются последне данные, поскольку данные на выбранный момент времени отсутствуют.',
    'message-no-data': 'Нет данных.'
  },
  'csv-download': {
    'button-csv-download': 'Скачать отчет',
    'button-download': 'Скачать',
    'start-datetime': 'Начальная дата и время',
    'end-datetime': 'Конечная дата и время',
    'failed-download-no-data': 'Отсутствуют данные для скачивания',
    'failed-create-zip-file-fatal': 'Скачивание не удалось из-за возникшей ошибки.',
    'failed-create-zip-file-busy': 'Сервер занят. Повторите попытку позже.',
    'invalid-start-end-datetime': 'Некорректные даты: начальная дата раньше конечной даты.'
  },
  /* 英語統一のため使用しない 2019/01/17 R.Inoue
  'csv-header': {
    'datetime': 'Дата и время',
    'organization-name': 'Организация',
    'location-name': 'Локация',
    'device-name': 'Фильтр',
    'flow-log-status': 'Состояние',
    'flow-log-flow': 'Всего очищено воды({0})',
    'flow-log-flow-diff': 'Очищено воды за период({0})',
    'ro-rate-log-status': 'Качество удаления примесей',
    'ro-rate-log-rate': 'Степень удаления примесей(%)',
    'temperature-log-status': '{0}:Температура',
    'temperature-log-temperature': '{0}:Температура({1})',
    'leakage-log-status': '{0}:Протечки воды',
    'water-pressure-log-status': '{0}:Давление',
    'water-pressure-log-pressure': '{0}:Значение давления({1})'
  },
  */
  'user': {
    'unselected': 'Выберите организацию.',
    'nodata': 'Нет пользователей.',
    'username': 'Имя пользователя',
    'email': 'E-mail',
    'role': 'Роль',
    'edit-setting': 'Изменить'
  },
  'organizations': {
    'title': 'Список организаций',
    'button-add': 'Добавить организацию',
    'button-add-pc': 'Add P/C Accounts',
    'vali-create-limit': '(en)Subordinate organization can not be created because it is restricted',
    'limit-settings': '(en)Organization creation limit',
    'no-limit': '(en)Unlimited'
  },
  'device': {
    'name': '[en] device name',
    'vali-device-name': '[en] device name is required.'
  },
  'settings': {
    'title': 'Настройки',
    'unit': 'Единицы объема',
    'timezone': 'Часовой пояс',
    'timezone-location': 'Местный часовой пояс',
    'pressureUnit': 'Единицы давления',
    'temperatureUnit': 'Единицы температуры',
    'display-setting': 'Настройки отображения',
    'available-sensor': 'Датчики',
    'life-and-notification': 'Ресурс картриджей и оповещения',
    'notification-presets': 'Шаблоны оповещений',
    'notification-mail': 'E-mail для оповещений',
    'organization-user': 'Организации и пользователи',
    'management-organization': 'Управление организациями',
    'user-management': 'Управление пользователями',
    'user-invitation': 'Добавить пользователя',
    'add-organization': 'Добавить организацию',
    'pc-management': 'P/C Management',
    'set-up': 'Обновить'
  },
  'account': {
    'delete-organization': 'Удалить организацию',
    'basic-information': 'Основная информация',
    'organization': 'Название организации',
    'parent-organization': 'Родительская организация',
    'description': 'Описание',
    'tel': 'Телефон',
    'email': 'E-mail',
    'contact': 'Контакт',
    'incharge': 'Контактное лицо',
    'administrator': 'Администратор',
    'name': 'Имя (необязательно)',
    'username': 'Ответственный пользователь',
    'useremail': 'E-mail ответственного',
    'company': 'Имя компании',
    'address': 'Адрес',
    'created': 'Дата регистрации',
    'edit': 'Изменить',
    'caution-title': 'Внимание!',
    'caution-org-remove-text': 'Вы действительно хотите удалить указанную ниже организацию?',
    'caution-user-remove-text': 'Вы действительно хотите удалить указанного ниже пользователя?',
    'caution-location-remove-text': 'Вы действительно хотите удалить указанную ниже локацию?',
    'delete': 'Удалить',
    'cancel': 'Отмена',
    'close': 'Закрыть',
    'create': 'Создать',
    'updated': 'Обновлено',
    'error-delete': 'Ошибка удаления.',
    'error-customer': 'Имеются привязанные локации.',
    'error-user': 'Имеются привязанные пользователи.',
    'error-root': 'Это корневая организация.',
    'error-system': 'Имеются привязанные фильтры.',
    'header-title': 'Управление организациями и пользователями',
    'header-org': 'Управление организациями',
    'header-user': 'Управление пользователями',
    'header-invite': 'Добавить пользователя',
    'header-pc': 'P/C Management',
    'invite-btn': 'Отправить письмо с приглашением',
    'policy': 'Лицензионное положение',
    'agree': 'Согласен',
    'csv-import': 'Мы планируем добавить функцию импорта CSV',
    'label-role': 'Роль',
    'label-parent': 'Родительская организация',
    'label-belongto': 'Организация',
    'label-organization': 'Организация',
    'label-account': 'Учетная запись',
    'label-username': 'Ответственный пользователь',
    'label-useremail': 'E-mail ответственного',
    'success-dialog': 'Приглашение успешно отправлено.',
    'vali-username-must': 'Необходимо имя пользователя.',
    'vali-username-format': 'Должно состоять из букв, цифр и символов (. - _ @)',
    'vali-username-char': 'Имя пользователя должно содержать 4-20 символов.',
    'vali-email-must': 'Необходим адрес электронной почты.',
    'vali-email-format': 'Введите валидный адрес.',
    'vali-phone-format': 'Допустимы только цифры.',
    'vali-phone-length': 'Телефон должен быть короче 128 цифр.',
    'vali-role': 'Пожалуйста, выберите',
    'vali-org-select': 'Пожалуйста, выберите',
    'vali-org-name': 'Необходимо название организации.',
    'vali-location-name': 'Необходимо название локации.',
    'fail-registration': 'Регистрация не удалась',
    'fail-username': 'Указанное имя пользователя не может быть зарегистрировано',
    'fail-master-name': 'Нельзя сменить организацию верхнего уровня.',
    'can-edit-message': 'Вы можете редактировать роль и организацию.',
    'cant-edit-yourself': 'Нельзя редактировать себя.',
    'update-succeed': 'Успешно обновлено',
    'delete-succeed': 'Успешно удалено',
    'function-limit': 'Некоторые функции не могут быть использованы для текущей учетной записи',
    'cant-delete-yourself': 'Нельзя удалить себя.'
  },
  'viewable-locations': {
    'header-viewable-locations': 'Управление видимостью локаций',
    'button-add-viewable-locations': 'Добавить видимые локации',
    'label-permit-viewing-locations': 'Разрешить видимые локации',
    'select-is-not-limited-viewer': 'Все локации',
    'select-is-limited-viewer': 'Только выбранные локации',
    'label-viewing-target-locations': 'Видимые локации',
    'hint-viewing-target-locations': 'Пожалуйста, выберите видимые локации',
    'button-set': 'Установить',
    'button-cancel': 'Отмена'
  },
  'customer': {
    'add': 'Добавить локацию',
    'latitude': 'Широта',
    'longitude': 'Долгота',
    'info': 'Основная информация',
    'situation': 'Отчет об использовании',
    'active-device': 'Активный фильтр',
    'others': 'Другие',
    'geo-location': 'Широта/долгота',
    'defined': 'указаны.',
    'undefined': 'неизвестны.',
    'situation-title': 'Итоги',
    'print': 'Печать',
    'target': 'Цель',
    'sum': 'Сумма',
    'history': 'История',
    'iotizr-situation': 'Данные о контроллере',
    'service-plan': 'Сервисный план',
    'device-customer': 'Фильтр (локация)',
    'date': 'Дата',
    'name': 'Локация',
    'device': 'Фильтр',
    'organization': 'Организация',
    'address': 'Адрес',
    'tel': 'Телефон',
    'open-map': 'Найти место на карте',
    'close-map': 'Закрыть карту',
    'content': 'Содержание',
    'get-address': 'Получить адрес',
    'search': 'Поиск',
    'error-location': 'Не удается найти широту и долготу',
    'error-delete': 'Не удалось удалить.',
    'error-delete-connecting-device': 'Сначала отвяжите контроллер(ы) этой локации в приложении и попробуйте снова.',
    'success-delete': 'Успешно удалено.'
  },
  'notifications': {
    'header-title': 'Ресурс картриджей и уведомления',
    'header-preset': 'Шаблоны уведомлений',
    'header-mail': 'Адрес для уведомлений',
    'title-mail': 'Адрес для уведомлений',
    'title-langage': 'Выбор языка',
    'japanese': 'Japanese',
    'english': 'English',
    'russian': 'Русский',
    'enable': 'Получать',
    'disable': 'Не получать'
  },
  'profile': {
    'profile': 'Ваш профиль',
    'role': 'Роль',
    'organization': 'Организация',
    'email': 'E-mail',
    'new-email': 'Новый e-mail',
    'change-email': 'Изменить e-mail',
    'change-password': 'Изменить пароль',
    'old-password': 'Текущий пароль',
    'new-password': 'Новый пароль',
    'confirm-new-password': 'Повторите новый пароль',
    'cancel': 'Отмена',
    'change': 'Изменить',
    'submit': 'Сохранить',
    'confirm': 'Подтвердить',
    'resend': 'Повторить e-mail',
    'continue': 'Продолжить',
    'confirmation-code': 'Введите код подтверждения',
    'confirmation-code-input': 'Введите код подтверждения',
    'change-password-error': 'Неверный старый пароль.',
    'not-verified': 'Ваш e-mail не подтвержден!',
    'verify': 'Подтвердить',
    'verified': 'Ваш e-mail подтвержден',
    'vali-blank-new-pass': 'Пожалуйста, введите новый пароль',
    'vali-blank-old-pass': 'Пожалуйста, введите текущий пароль',
    'vali-blank-confirm-new-pass': 'Пожалуйста, подтвердите новый пароль',
    'vali-format': 'Пароль должен быть не меньше 8 символов и содержать минимум одну цифру (0-9)',
    'vali-length': 'Должен быть не более 25 символов',
    'vali-same-password': 'Пароли не совпадают!.',
    'vali-empty-code': 'Введите код подтверждения',
    'vali-email-format': 'Укажите действительный e-mail',
    'vali-invalid-code': 'Неверный код подтверждения',
    'code-confirm-text1': 'На ваш e-mail отправлено письмо с кодом подтверждения.',
    'code-confirm-text2': 'Проверьте свой e-mail и введите код подтверждения ниже.',
    'code-confirm-title': 'Введите код подтверждения',
    'code-confirm-input': 'Код подтверждения',
    'change-email-title': 'Сменить e-mail',
    'change-password-title': 'Сменить пароль',
    'success-resend': 'На ваш e-mail отправлено письмо с кодом подтверждения.\n Если Вы не получили письмо, пожалуйста, попробуйте еще раз позже.',
    'fail-resend': 'Повторная отправка не удалась',
    'fail-error': 'Превышено количество попыток, попробуйте еще раз позже.',
    'changed-password': 'Ваш пароль обновлен'
  }
};

module.exports = messages;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'This service is brought to you by Aplix Corporation. By using this service, you agree' + 'and consent to the Brita Pro USERS Terms of Service ( ' + '<a href="http://www.aplix.co.jp/en/legal/terms_britaprousers.php" target="_blank">Brita Pro USERS Terms of Service</a>,' + '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank"> Privacy Policy for IoT Solurion</a>' + ') and arbitration before the International Chamber of Commerce for any disputes between us.'
  }
};

module.exports = messages;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'This service is brought to you by Aplix Corporation. By using this service, you agree' + 'and consent to the Brita Pro USERS Terms of Service ( ' + '<a href="http://www.aplix.co.jp/en/legal/terms_britaprousers.php" target="_blank">Brita Pro USERS Terms of Service</a>,' + '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank"> Privacy Policy for IoT Solurion</a>' + ') and arbitration before the International Chamber of Commerce for any disputes between us.'
  }
};

module.exports = messages;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {
  activate: {
    agreement_msg: 'This service is brought to you by Aplix Corporation. By using this service, you agree' + 'and consent to the Brita Pro USERS Terms of Service ( ' + '<a href="http://www.aplix.co.jp/en/legal/terms_britaprousers.php" target="_blank">Brita Pro USERS Terms of Service</a>,' + '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank"> Privacy Policy for IoT Solurion</a>' + ') and arbitration before the International Chamber of Commerce for any disputes between us.'
  }
};

module.exports = messages;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

/* eslint no-trailing-spaces: 0 */

var messages = {};

module.exports = messages;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(79);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1106);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1105);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1767);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(131);
var TAG = __webpack_require__(41)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(40).document;
module.exports = document && document.documentElement;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(80) && !__webpack_require__(110)(function () {
  return Object.defineProperty(__webpack_require__(230)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(131);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(133);
var ITERATOR = __webpack_require__(41)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(71);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(166);
var $export = __webpack_require__(59);
var redefine = __webpack_require__(400);
var hide = __webpack_require__(90);
var has = __webpack_require__(89);
var Iterators = __webpack_require__(133);
var $iterCreate = __webpack_require__(1129);
var setToStringTag = __webpack_require__(168);
var getPrototypeOf = __webpack_require__(1137);
var ITERATOR = __webpack_require__(41)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(41)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(71);
var dPs = __webpack_require__(1134);
var enumBugKeys = __webpack_require__(231);
var IE_PROTO = __webpack_require__(234)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(230)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(388).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(397);
var hiddenKeys = __webpack_require__(231).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(89);
var toIObject = __webpack_require__(111);
var arrayIndexOf = __webpack_require__(1122)(false);
var IE_PROTO = __webpack_require__(234)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var isObject = __webpack_require__(81);
var newPromiseCapability = __webpack_require__(232);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(90);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(71);
var aFunction = __webpack_require__(165);
var SPECIES = __webpack_require__(41)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(132);
var invoke = __webpack_require__(1126);
var html = __webpack_require__(388);
var cel = __webpack_require__(230);
var global = __webpack_require__(40);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(131)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 403 */
/***/ (function(module, exports) {



/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(55);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(100);
var toLength = __webpack_require__(25);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(92);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(30);
var IObject = __webpack_require__(137);
var toLength = __webpack_require__(25);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(37);
var isObject = __webpack_require__(13);
var invoke = __webpack_require__(414);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(24).f;
var create = __webpack_require__(94);
var redefineAll = __webpack_require__(98);
var ctx = __webpack_require__(56);
var anInstance = __webpack_require__(91);
var forOf = __webpack_require__(92);
var $iterDefine = __webpack_require__(253);
var step = __webpack_require__(417);
var setSpecies = __webpack_require__(99);
var DESCRIPTORS = __webpack_require__(23);
var fastKey = __webpack_require__(83).fastKey;
var validate = __webpack_require__(115);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(136);
var from = __webpack_require__(406);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(98);
var getWeak = __webpack_require__(83).getWeak;
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var anInstance = __webpack_require__(91);
var forOf = __webpack_require__(92);
var createArrayMethod = __webpack_require__(60);
var $has = __webpack_require__(42);
var validate = __webpack_require__(115);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(176);
var isObject = __webpack_require__(13);
var toLength = __webpack_require__(25);
var ctx = __webpack_require__(56);
var IS_CONCAT_SPREADABLE = __webpack_require__(20)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(246)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(13);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(255);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(96);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(138);
var toObject = __webpack_require__(30);
var IObject = __webpack_require__(137);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(96);

module.exports = __webpack_require__(23) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(50);
var gOPN = __webpack_require__(95).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(42);
var toIObject = __webpack_require__(50);
var arrayIndexOf = __webpack_require__(172)(false);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(96);
var toIObject = __webpack_require__(50);
var isEnum = __webpack_require__(138).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(95);
var gOPS = __webpack_require__(180);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(11).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(11).parseFloat;
var $trim = __webpack_require__(114).trim;

module.exports = 1 / $parseFloat(__webpack_require__(263) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(11).parseInt;
var $trim = __webpack_require__(114).trim;
var ws = __webpack_require__(263);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(257);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(25);
var repeat = __webpack_require__(262);
var defined = __webpack_require__(62);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(25);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(409);
var validate = __webpack_require__(115);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(173)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(23) && /./g.flags != 'g') __webpack_require__(24).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(175)
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(409);
var validate = __webpack_require__(115);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(173)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(60)(0);
var redefine = __webpack_require__(44);
var meta = __webpack_require__(83);
var assign = __webpack_require__(421);
var weak = __webpack_require__(411);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var validate = __webpack_require__(115);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(173)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(109).Buffer
var sha = __webpack_require__(1357)
var sha256 = __webpack_require__(1358)
var rng = __webpack_require__(1356)
var md5 = __webpack_require__(1355)

var algorithms = {
  sha1: sha,
  sha256: sha256,
  md5: md5
}

var blocksize = 64
var zeroBuffer = new Buffer(blocksize); zeroBuffer.fill(0)
function hmac(fn, key, data) {
  if(!Buffer.isBuffer(key)) key = new Buffer(key)
  if(!Buffer.isBuffer(data)) data = new Buffer(data)

  if(key.length > blocksize) {
    key = fn(key)
  } else if(key.length < blocksize) {
    key = Buffer.concat([key, zeroBuffer], blocksize)
  }

  var ipad = new Buffer(blocksize), opad = new Buffer(blocksize)
  for(var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var hash = fn(Buffer.concat([ipad, data]))
  return fn(Buffer.concat([opad, hash]))
}

function hash(alg, key) {
  alg = alg || 'sha1'
  var fn = algorithms[alg]
  var bufs = []
  var length = 0
  if(!fn) error('algorithm:', alg, 'is not yet supported')
  return {
    update: function (data) {
      if(!Buffer.isBuffer(data)) data = new Buffer(data)
        
      bufs.push(data)
      length += data.length
      return this
    },
    digest: function (enc) {
      var buf = Buffer.concat(bufs)
      var r = key ? hmac(fn, key, buf) : fn(buf)
      bufs = null
      return enc ? r.toString(enc) : r
    }
  }
}

function error () {
  var m = [].slice.call(arguments).join(' ')
  throw new Error([
    m,
    'we accept pull requests',
    'http://github.com/dominictarr/crypto-browserify'
    ].join('\n'))
}

exports.createHash = function (alg) { return hash(alg) }
exports.createHmac = function (alg, key) { return hash(alg, key) }
exports.randomBytes = function(size, callback) {
  if (callback && callback.call) {
    try {
      callback.call(this, undefined, new Buffer(rng(size)))
    } catch (err) { callback(err) }
  } else {
    return new Buffer(rng(size))
  }
}

function each(a, f) {
  for(var i in a)
    f(a[i], i)
}

// the least I can do is make error messages for the rest of the node.js/crypto api.
each(['createCredentials'
, 'createCipher'
, 'createCipheriv'
, 'createDecipher'
, 'createDecipheriv'
, 'createSign'
, 'createVerify'
, 'createDiffieHellman'
, 'pbkdf2'], function (name) {
  exports[name] = function () {
    error('sorry,', name, 'is not implemented yet')
  }
})


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

function _default(seriesType, actionInfos) {
  zrUtil.each(actionInfos, function (actionInfo) {
    actionInfo.update = 'updateView';
    /**
     * @payload
     * @property {string} seriesName
     * @property {string} name
     */

    echarts.registerAction(actionInfo, function (payload, ecModel) {
      var selected = {};
      ecModel.eachComponent({
        mainType: 'series',
        subType: seriesType,
        query: payload
      }, function (seriesModel) {
        if (seriesModel[actionInfo.method]) {
          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
        }

        var data = seriesModel.getData(); // Create selected map

        data.each(function (idx) {
          var name = data.getName(idx);
          selected[name] = seriesModel.isSelected(name) || false;
        });
      });
      return {
        name: payload.name,
        selected: selected
      };
    });
  });
}

module.exports = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var _roamHelper = __webpack_require__(441);

var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;

/**
 * @payload
 * @property {string} [componentType=series]
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */
echarts.registerAction({
  type: 'geoRoam',
  event: 'geoRoam',
  update: 'updateLayout'
}, function (payload, ecModel) {
  var componentType = payload.componentType || 'series';
  ecModel.eachComponent({
    mainType: componentType,
    query: payload
  }, function (componentModel) {
    var geo = componentModel.coordinateSystem;

    if (geo.type !== 'geo') {
      return;
    }

    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
    componentModel.setCenter && componentModel.setCenter(res.center);
    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
    // So the center and zoom must be in sync. Include the series not selected by legend

    if (componentType === 'series') {
      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
        seriesModel.setCenter(res.center);
        seriesModel.setZoom(res.zoom);
      });
    }
  });
});

/***/ }),
/* 441 */
/***/ (function(module, exports) {

/**
 * @param {module:echarts/coord/View} view
 * @param {Object} payload
 * @param {Object} [zoomLimit]
 */
function updateCenterAndZoom(view, payload, zoomLimit) {
  var previousZoom = view.getZoom();
  var center = view.getCenter();
  var zoom = payload.zoom;
  var point = view.dataToPoint(center);

  if (payload.dx != null && payload.dy != null) {
    point[0] -= payload.dx;
    point[1] -= payload.dy;
    var center = view.pointToData(point);
    view.setCenter(center);
  }

  if (zoom != null) {
    if (zoomLimit) {
      var zoomMin = zoomLimit.min || 0;
      var zoomMax = zoomLimit.max || Infinity;
      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
    } // Zoom on given point(originX, originY)


    view.scale[0] *= zoom;
    view.scale[1] *= zoom;
    var position = view.position;
    var fixX = (payload.originX - position[0]) * (zoom - 1);
    var fixY = (payload.originY - position[1]) * (zoom - 1);
    position[0] -= fixX;
    position[1] -= fixY;
    view.updateTransform(); // Get the new center

    var center = view.pointToData(point);
    view.setCenter(center);
    view.setZoom(zoom * previousZoom);
  }

  return {
    center: view.getCenter(),
    zoom: view.getZoom()
  };
}

exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(35);

var createListFromArray = __webpack_require__(84);

var _default = SeriesModel.extend({
  type: 'series.__base_bar__',
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  getMarkerPosition: function (value) {
    var coordSys = this.coordinateSystem;

    if (coordSys) {
      // PENDING if clamp ?
      var pt = coordSys.dataToPoint(value, true);
      var data = this.getData();
      var offset = data.getLayout('offset');
      var size = data.getLayout('size');
      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
      pt[offsetIndex] += offset + size / 2;
      return pt;
    }

    return [NaN, NaN];
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // stack: null
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // 最小高度改为0
    barMinHeight: 0,
    // 最小角度为0，仅对极坐标系下的柱状图有效
    barMinAngle: 0,
    // cursor: null,
    // barMaxWidth: null,
    // 默认自适应
    // barWidth: null,
    // 柱间距离，默认为柱形宽度的30%，可设固定值
    // barGap: '30%',
    // 类目间柱形距离，默认为类目间距的20%，可设固定值
    // barCategoryGap: '20%',
    // label: {
    //     normal: {
    //         show: false
    //     }
    // },
    itemStyle: {// normal: {
      // color: '各异'
      // },
      // emphasis: {}
    }
  }
});

module.exports = _default;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
  var labelModel = itemModel.getModel('label.normal');
  var hoverLabelModel = itemModel.getModel('label.emphasis');
  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
    labelFetcher: seriesModel,
    labelDataIndex: dataIndex,
    defaultText: seriesModel.getRawValue(dataIndex),
    isRectText: true,
    autoColor: color
  });
  fixPosition(normalStyle);
  fixPosition(hoverStyle);
}

function fixPosition(style, labelPositionOutside) {
  if (style.textPosition === 'outside') {
    style.textPosition = labelPositionOutside;
  }
}

exports.setLabel = setLabel;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(19);

function circularLayout(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var rect = coordSys.getBoundingRect();
  var nodeData = seriesModel.getData();
  var graph = nodeData.graph;
  var angle = 0;
  var sum = nodeData.getSum('value');
  var unitAngle = Math.PI * 2 / (sum || nodeData.count());
  var cx = rect.width / 2 + rect.x;
  var cy = rect.height / 2 + rect.y;
  var r = Math.min(rect.width, rect.height) / 2;
  graph.eachNode(function (node) {
    var value = node.getValue('value');
    angle += unitAngle * (sum ? value : 1) / 2;
    node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
    angle += unitAngle * (sum ? value : 1) / 2;
  });
  nodeData.setLayout({
    cx: cx,
    cy: cy
  });
  graph.eachEdge(function (edge) {
    var curveness = edge.getModel().get('lineStyle.normal.curveness') || 0;
    var p1 = vec2.clone(edge.node1.getLayout());
    var p2 = vec2.clone(edge.node2.getLayout());
    var cp1;
    var x12 = (p1[0] + p2[0]) / 2;
    var y12 = (p1[1] + p2[1]) / 2;

    if (+curveness) {
      curveness *= 3;
      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
    }

    edge.setLayout([p1, p2, cp1]);
  });
}

exports.circularLayout = circularLayout;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(19);

function simpleLayout(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var graph = seriesModel.getGraph();
  graph.eachNode(function (node) {
    var model = node.getModel();
    node.setLayout([+model.get('x'), +model.get('y')]);
  });
  simpleLayoutEdge(graph);
}

function simpleLayoutEdge(graph) {
  graph.eachEdge(function (edge) {
    var curveness = edge.getModel().get('lineStyle.normal.curveness') || 0;
    var p1 = vec2.clone(edge.node1.getLayout());
    var p2 = vec2.clone(edge.node2.getLayout());
    var points = [p1, p2];

    if (+curveness) {
      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
    }

    edge.setLayout(points);
  });
}

exports.simpleLayout = simpleLayout;
exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var Line = __webpack_require__(271);

var zrUtil = __webpack_require__(0);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var vec2 = __webpack_require__(19);

var curveUtil = __webpack_require__(88);

/**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */

/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Line}
 */
function EffectLine(lineData, idx, seriesScope) {
  graphic.Group.call(this);
  this.add(this.createLine(lineData, idx, seriesScope));

  this._updateEffectSymbol(lineData, idx);
}

var effectLineProto = EffectLine.prototype;

effectLineProto.createLine = function (lineData, idx, seriesScope) {
  return new Line(lineData, idx, seriesScope);
};

effectLineProto._updateEffectSymbol = function (lineData, idx) {
  var itemModel = lineData.getItemModel(idx);
  var effectModel = itemModel.getModel('effect');
  var size = effectModel.get('symbolSize');
  var symbolType = effectModel.get('symbol');

  if (!zrUtil.isArray(size)) {
    size = [size, size];
  }

  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
  var symbol = this.childAt(1);

  if (this._symbolType !== symbolType) {
    // Remove previous
    this.remove(symbol);
    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
    symbol.z2 = 100;
    symbol.culling = true;
    this.add(symbol);
  } // Symbol may be removed if loop is false


  if (!symbol) {
    return;
  } // Shadow color is same with color in default


  symbol.setStyle('shadowColor', color);
  symbol.setStyle(effectModel.getItemStyle(['color']));
  symbol.attr('scale', size);
  symbol.setColor(color);
  symbol.attr('scale', size);
  this._symbolType = symbolType;

  this._updateEffectAnimation(lineData, effectModel, idx);
};

effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
  var symbol = this.childAt(1);

  if (!symbol) {
    return;
  }

  var self = this;
  var points = lineData.getItemLayout(idx);
  var period = effectModel.get('period') * 1000;
  var loop = effectModel.get('loop');
  var constantSpeed = effectModel.get('constantSpeed');
  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
    return idx / lineData.count() * period / 3;
  });
  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating

  symbol.ignore = true;
  this.updateAnimationPoints(symbol, points);

  if (constantSpeed > 0) {
    period = this.getLineLength(symbol) / constantSpeed * 1000;
  }

  if (period !== this._period || loop !== this._loop) {
    symbol.stopAnimation();
    var delay = delayExpr;

    if (isDelayFunc) {
      delay = delayExpr(idx);
    }

    if (symbol.__t > 0) {
      delay = -period * symbol.__t;
    }

    symbol.__t = 0;
    var animator = symbol.animate('', loop).when(period, {
      __t: 1
    }).delay(delay).during(function () {
      self.updateSymbolPosition(symbol);
    });

    if (!loop) {
      animator.done(function () {
        self.remove(symbol);
      });
    }

    animator.start();
  }

  this._period = period;
  this._loop = loop;
};

effectLineProto.getLineLength = function (symbol) {
  // Not so accurate
  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
};

effectLineProto.updateAnimationPoints = function (symbol, points) {
  symbol.__p1 = points[0];
  symbol.__p2 = points[1];
  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
};

effectLineProto.updateData = function (lineData, idx, seriesScope) {
  this.childAt(0).updateData(lineData, idx, seriesScope);

  this._updateEffectSymbol(lineData, idx);
};

effectLineProto.updateSymbolPosition = function (symbol) {
  var p1 = symbol.__p1;
  var p2 = symbol.__p2;
  var cp1 = symbol.__cp1;
  var t = symbol.__t;
  var pos = symbol.position;
  var quadraticAt = curveUtil.quadraticAt;
  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent

  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
  symbol.ignore = false;
};

effectLineProto.updateLayout = function (lineData, idx) {
  this.childAt(0).updateLayout(lineData, idx);
  var effectModel = lineData.getItemModel(idx).getModel('effect');

  this._updateEffectAnimation(lineData, effectModel, idx);
};

zrUtil.inherits(EffectLine, graphic.Group);
var _default = EffectLine;
module.exports = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var zrUtil = __webpack_require__(0);

/**
 * @module echarts/chart/helper/Line
 */

/**
 * @constructor
 * @extends {module:zrender/graphic/Group}
 * @alias {module:echarts/chart/helper/Polyline}
 */
function Polyline(lineData, idx, seriesScope) {
  graphic.Group.call(this);

  this._createPolyline(lineData, idx, seriesScope);
}

var polylineProto = Polyline.prototype;

polylineProto._createPolyline = function (lineData, idx, seriesScope) {
  // var seriesModel = lineData.hostModel;
  var points = lineData.getItemLayout(idx);
  var line = new graphic.Polyline({
    shape: {
      points: points
    }
  });
  this.add(line);

  this._updateCommonStl(lineData, idx, seriesScope);
};

polylineProto.updateData = function (lineData, idx, seriesScope) {
  var seriesModel = lineData.hostModel;
  var line = this.childAt(0);
  var target = {
    shape: {
      points: lineData.getItemLayout(idx)
    }
  };
  graphic.updateProps(line, target, seriesModel, idx);

  this._updateCommonStl(lineData, idx, seriesScope);
};

polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
  var line = this.childAt(0);
  var itemModel = lineData.getItemModel(idx);
  var visualColor = lineData.getItemVisual(idx, 'color');
  var lineStyle = seriesScope && seriesScope.lineStyle;
  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;

  if (!seriesScope || lineData.hasItemOption) {
    lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
    hoverLineStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
  }

  line.useStyle(zrUtil.defaults({
    strokeNoScale: true,
    fill: 'none',
    stroke: visualColor
  }, lineStyle));
  line.hoverStyle = hoverLineStyle;
  graphic.setHoverStyle(this);
};

polylineProto.updateLayout = function (lineData, idx) {
  var polyline = this.childAt(0);
  polyline.setShape('points', lineData.getItemLayout(idx));
};

zrUtil.inherits(Polyline, graphic.Group);
var _default = Polyline;
module.exports = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var List = __webpack_require__(31);

var Graph = __webpack_require__(1598);

var linkList = __webpack_require__(486);

var completeDimensions = __webpack_require__(58);

var CoordinateSystem = __webpack_require__(66);

var createListFromArray = __webpack_require__(84);

function _default(nodes, edges, hostModel, directed, beforeLink) {
  var graph = new Graph(directed);

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
  }

  var linkNameList = [];
  var validEdges = [];
  var linkCount = 0;

  for (var i = 0; i < edges.length; i++) {
    var link = edges[i];
    var source = link.source;
    var target = link.target; // addEdge may fail when source or target not exists

    if (graph.addEdge(source, target, linkCount)) {
      validEdges.push(link);
      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
      linkCount++;
    }
  }

  var coordSys = hostModel.get('coordinateSystem');
  var nodeData;

  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
    nodeData = createListFromArray(nodes, hostModel, hostModel.ecModel);
  } else {
    // FIXME
    var coordSysCtor = CoordinateSystem.get(coordSys); // FIXME

    var dimensionNames = completeDimensions((coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []).concat(['value']), nodes);
    nodeData = new List(dimensionNames, hostModel);
    nodeData.initData(nodes);
  }

  var edgeData = new List(['value'], hostModel);
  edgeData.initData(validEdges, linkNameList);
  beforeLink && beforeLink(nodeData, edgeData);
  linkList({
    mainData: nodeData,
    struct: graph,
    structAttr: 'graph',
    datas: {
      node: nodeData,
      edge: edgeData
    },
    datasAttr: {
      node: 'data',
      edge: 'edgeData'
    }
  }); // Update dataIndex of nodes and edges because invalid edge may be removed

  graph.update();
  return graph;
}

module.exports = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var _model = __webpack_require__(15);

var otherDimToDataDim = _model.otherDimToDataDim;

/**
 * @module echarts/chart/helper/Symbol
 */
function findLabelValueDim(data) {
  var valueDim;
  var labelDims = otherDimToDataDim(data, 'label');

  if (labelDims.length) {
    valueDim = labelDims[0];
  } else {
    // Get last value dim
    var dimensions = data.dimensions.slice();
    var dataType;

    while (dimensions.length && (valueDim = dimensions.pop(), dataType = data.getDimensionInfo(valueDim).type, dataType === 'ordinal' || dataType === 'time')) {} // jshint ignore:line

  }

  return valueDim;
}

exports.findLabelValueDim = findLabelValueDim;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var vec2 = __webpack_require__(19);

var fixClipWithShadow = __webpack_require__(695);

// Poly path support NaN point
var vec2Min = vec2.min;
var vec2Max = vec2.max;
var scaleAndAdd = vec2.scaleAndAdd;
var v2Copy = vec2.copy; // Temporary variable

var v = [];
var cp0 = [];
var cp1 = [];

function isPointNull(p) {
  return isNaN(p[0]) || isNaN(p[1]);
}

function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
      v2Copy(cp0, p);
    } else {
      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextP = points[nextIdx];

        if (connectNulls) {
          // Find next point not null
          while (nextP && isPointNull(points[nextIdx])) {
            nextIdx += dir;
            nextP = points[nextIdx];
          }
        }

        var ratioNextSeg = 0.5;
        var prevP = points[prevIdx];
        var nextP = points[nextIdx]; // Last point

        if (!nextP || isPointNull(nextP)) {
          v2Copy(cp1, p);
        } else {
          // If next data is null in not connect case
          if (isPointNull(nextP) && !connectNulls) {
            nextP = p;
          }

          vec2.sub(v, nextP, prevP);
          var lenPrevSeg;
          var lenNextSeg;

          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
            var dim = smoothMonotone === 'x' ? 0 : 1;
            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
          } else {
            lenPrevSeg = vec2.dist(p, prevP);
            lenNextSeg = vec2.dist(p, nextP);
          } // Use ratio of seg length


          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
        } // Smooth constraint


        vec2Min(cp0, cp0, smoothMax);
        vec2Max(cp0, cp0, smoothMin);
        vec2Min(cp1, cp1, smoothMax);
        vec2Max(cp1, cp1, smoothMin);
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment

        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}

function getBoundingBox(points, smoothConstraint) {
  var ptMin = [Infinity, Infinity];
  var ptMax = [-Infinity, -Infinity];

  if (smoothConstraint) {
    for (var i = 0; i < points.length; i++) {
      var pt = points[i];

      if (pt[0] < ptMin[0]) {
        ptMin[0] = pt[0];
      }

      if (pt[1] < ptMin[1]) {
        ptMin[1] = pt[1];
      }

      if (pt[0] > ptMax[0]) {
        ptMax[0] = pt[0];
      }

      if (pt[1] > ptMax[1]) {
        ptMax[1] = pt[1];
      }
    }
  }

  return {
    min: smoothConstraint ? ptMin : ptMax,
    max: smoothConstraint ? ptMax : ptMin
  };
}

var Polyline = Path.extend({
  type: 'ec-polyline',
  shape: {
    points: [],
    smooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  style: {
    fill: null,
    stroke: '#000'
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length;
    var result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  }
});
var Polygon = Path.extend({
  type: 'ec-polygon',
  shape: {
    points: [],
    // Offset between stacked base points and points
    stackedOnPoints: [],
    smooth: 0,
    stackedOnSmooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length;
    var smoothMonotone = shape.smoothMonotone;
    var bbox = getBoundingBox(points, shape.smoothConstraint);
    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  }
});
exports.Polyline = Polyline;
exports.Polygon = Polygon;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var _traversalHelper = __webpack_require__(1468);

var eachAfter = _traversalHelper.eachAfter;
var eachBefore = _traversalHelper.eachBefore;

var _layoutHelper = __webpack_require__(452);

var init = _layoutHelper.init;
var firstWalk = _layoutHelper.firstWalk;
var secondWalk = _layoutHelper.secondWalk;
var sep = _layoutHelper.separation;
var radialCoordinate = _layoutHelper.radialCoordinate;
var getViewRect = _layoutHelper.getViewRect;

function _default(seriesModel, api) {
  var layoutInfo = getViewRect(seriesModel, api);
  seriesModel.layoutInfo = layoutInfo;
  var layout = seriesModel.get('layout');
  var width = 0;
  var height = 0;
  var separation = null;

  if (layout === 'radial') {
    width = 2 * Math.PI;
    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
    separation = sep(function (node1, node2) {
      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
    });
  } else {
    width = layoutInfo.width;
    height = layoutInfo.height;
    separation = sep();
  }

  var virtualRoot = seriesModel.getData().tree.root;
  var realRoot = virtualRoot.children[0];
  init(virtualRoot);
  eachAfter(realRoot, firstWalk, separation);
  virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
  eachBefore(realRoot, secondWalk);
  var left = realRoot;
  var right = realRoot;
  var bottom = realRoot;
  eachBefore(realRoot, function (node) {
    var x = node.getLayout().x;

    if (x < left.getLayout().x) {
      left = node;
    }

    if (x > right.getLayout().x) {
      right = node;
    }

    if (node.depth > bottom.depth) {
      bottom = node;
    }
  });
  var delta = left === right ? 1 : separation(left, right) / 2;
  var tx = delta - left.getLayout().x;
  var kx = 0;
  var ky = 0;
  var coorX = 0;
  var coorY = 0;

  if (layout === 'radial') {
    kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1

    ky = height / (bottom.depth - 1 || 1);
    eachBefore(realRoot, function (node) {
      coorX = (node.getLayout().x + tx) * kx;
      coorY = (node.depth - 1) * ky;
      var finalCoor = radialCoordinate(coorX, coorY);
      node.setLayout({
        x: finalCoor.x,
        y: finalCoor.y,
        rawX: coorX,
        rawY: coorY
      }, true);
    });
  } else {
    if (seriesModel.get('orient') === 'horizontal') {
      ky = height / (right.getLayout().x + delta + tx);
      kx = width / (bottom.depth - 1 || 1);
      eachBefore(realRoot, function (node) {
        coorY = (node.getLayout().x + tx) * ky;
        coorX = (node.depth - 1) * kx;
        node.setLayout({
          x: coorX,
          y: coorY
        }, true);
      });
    } else {
      kx = width / (right.getLayout().x + delta + tx);
      ky = height / (bottom.depth - 1 || 1);
      eachBefore(realRoot, function (node) {
        coorX = (node.getLayout().x + tx) * kx;
        coorY = (node.depth - 1) * ky;
        node.setLayout({
          x: coorX,
          y: coorY
        }, true);
      });
    }
  }
}

module.exports = _default;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var layout = __webpack_require__(17);

/**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 * @see https://github.com/d3/d3-hierarchy
 */

/**
 * Initialize all computational message for following algorithm
 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree
 */
function init(root) {
  root.hierNode = {
    defaultAncestor: null,
    ancestor: root,
    prelim: 0,
    modifier: 0,
    change: 0,
    shift: 0,
    i: 0,
    thread: null
  };
  var nodes = [root];
  var node;
  var children;

  while (node = nodes.pop()) {
    // jshint ignore:line
    children = node.children;

    if (node.isExpand && children.length) {
      var n = children.length;

      for (var i = n - 1; i >= 0; i--) {
        var child = children[i];
        child.hierNode = {
          defaultAncestor: null,
          ancestor: child,
          prelim: 0,
          modifier: 0,
          change: 0,
          shift: 0,
          i: i,
          thread: null
        };
        nodes.push(child);
      }
    }
  }
}
/**
 * Computes a preliminary x coordinate for node. Before that, this function is
 * applied recursively to the children of node, as well as the function
 * apportion(). After spacing out the children by calling executeShifts(), the
 * node is placed to the midpoint of its outermost children.
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param {Function} separation
 */


function firstWalk(node, separation) {
  var children = node.isExpand ? node.children : [];
  var siblings = node.parentNode.children;
  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;

  if (children.length) {
    executeShifts(node);
    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;

    if (subtreeW) {
      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
      node.hierNode.modifier = node.hierNode.prelim - midPoint;
    } else {
      node.hierNode.prelim = midPoint;
    }
  } else if (subtreeW) {
    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
  }

  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
/**
 * Computes all real x-coordinates by summing up the modifiers recursively.
 * @param  {module:echarts/data/Tree~TreeNode} node
 */


function secondWalk(node) {
  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
  node.setLayout({
    x: nodeX
  }, true);
  node.hierNode.modifier += node.parentNode.hierNode.modifier;
}

function separation(cb) {
  return arguments.length ? cb : defaultSeparation;
}
/**
 * Transform the common coordinate to radial coordinate
 * @param  {number} x
 * @param  {number} y
 * @return {Object}
 */


function radialCoordinate(x, y) {
  var radialCoor = {};
  x -= Math.PI / 2;
  radialCoor.x = y * Math.cos(x);
  radialCoor.y = y * Math.sin(x);
  return radialCoor;
}
/**
 * Get the layout position of the whole view
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */


function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 * @param  {module:echarts/data/Tree~TreeNode} node
 */


function executeShifts(node) {
  var children = node.children;
  var n = children.length;
  var shift = 0;
  var change = 0;

  while (--n >= 0) {
    var child = children[n];
    child.hierNode.prelim += shift;
    child.hierNode.modifier += shift;
    change += child.hierNode.change;
    shift += child.hierNode.shift + change;
  }
}
/**
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @param  {Function} separation
 * @return {module:echarts/data/Tree~TreeNode}
 */


function apportion(subtreeV, subtreeW, ancestor, separation) {
  if (subtreeW) {
    var nodeOutRight = subtreeV;
    var nodeInRight = subtreeV;
    var nodeOutLeft = nodeInRight.parentNode.children[0];
    var nodeInLeft = subtreeW;
    var sumOutRight = nodeOutRight.hierNode.modifier;
    var sumInRight = nodeInRight.hierNode.modifier;
    var sumOutLeft = nodeOutLeft.hierNode.modifier;
    var sumInLeft = nodeInLeft.hierNode.modifier;

    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
      nodeOutRight = nextRight(nodeOutRight);
      nodeOutLeft = nextLeft(nodeOutLeft);
      nodeOutRight.hierNode.ancestor = subtreeV;
      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);

      if (shift > 0) {
        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
        sumInRight += shift;
        sumOutRight += shift;
      }

      sumInLeft += nodeInLeft.hierNode.modifier;
      sumInRight += nodeInRight.hierNode.modifier;
      sumOutRight += nodeOutRight.hierNode.modifier;
      sumOutLeft += nodeOutLeft.hierNode.modifier;
    }

    if (nodeInLeft && !nextRight(nodeOutRight)) {
      nodeOutRight.hierNode.thread = nodeInLeft;
      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
    }

    if (nodeInRight && !nextLeft(nodeOutLeft)) {
      nodeOutLeft.hierNode.thread = nodeInRight;
      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
      ancestor = subtreeV;
    }
  }

  return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextRight(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextLeft(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
 * @param  {module:echarts/data/Tree~TreeNode} node
 * @param  {module:echarts/data/Tree~TreeNode} ancestor
 * @return {module:echarts/data/Tree~TreeNode}
 */


function nextAncestor(nodeInLeft, node, ancestor) {
  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * Shifts the current subtree rooted at wr. This is done by increasing prelim(w+) and modifier(w+) by shift.
 * @param  {module:echarts/data/Tree~TreeNode} wl
 * @param  {module:echarts/data/Tree~TreeNode} wr
 * @param  {number} shift [description]
 */


function moveSubtree(wl, wr, shift) {
  var change = shift / (wr.hierNode.i - wl.hierNode.i);
  wr.hierNode.change -= change;
  wr.hierNode.shift += shift;
  wr.hierNode.modifier += shift;
  wr.hierNode.prelim += shift;
  wl.hierNode.change += change;
}

function defaultSeparation(node1, node2) {
  return node1.parentNode === node2.parentNode ? 1 : 2;
}

exports.init = init;
exports.firstWalk = firstWalk;
exports.secondWalk = secondWalk;
exports.separation = separation;
exports.radialCoordinate = radialCoordinate;
exports.getViewRect = getViewRect;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, labelInterval, z2
 * }
 */
function layout(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var rawAxisPosition = axis.position;
  var axisPosition = axis.onZero ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (axis.onZero) {
    var otherAxis = grid.getAxis(axisDim === 'x' ? 'y' : 'x', axis.onZeroAxisIndex);
    var onZeroCoord = otherAxis.toGlobalCoord(otherAxis.dataToCoord(0));
    posBound[idx['onZero']] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = axis.onZero ? posBound[idx[rawAxisPosition]] - posBound[idx['onZero']] : 0;

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get('axisLabel.rotate');
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // label interval when auto mode.

  layout.labelInterval = axis.getLabelInterval(); // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, labelInterval, z2
 * }
 */
function layout(axisModel, opt) {
  opt = opt || {};
  var single = axisModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var axisPosition = axis.position;
  var orient = axis.orient;
  var rect = single.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var positionMap = {
    horizontal: {
      top: rectBound[2],
      bottom: rectBound[3]
    },
    vertical: {
      left: rectBound[0],
      right: rectBound[1]
    }
  };
  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
  var r = {
    horizontal: 0,
    vertical: 1
  };
  layout.rotation = Math.PI / 2 * r[orient];
  var directionMap = {
    top: -1,
    bottom: 1,
    right: 1,
    left: -1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  }

  var labelRotation = opt.rotate;
  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
  layout.labelInterval = axis.getLabelInterval();
  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var BaseAxisPointer = __webpack_require__(273);

var viewHelper = __webpack_require__(190);

var cartesianAxisHelper = __webpack_require__(453);

var AxisView = __webpack_require__(103);

var CartesianAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  }
});

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent, elStyle) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    graphic.subPixelOptimizeLine({
      shape: targetShape,
      style: elStyle
    });
    return {
      type: 'Line',
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent, elStyle) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
var _default = CartesianAxisPointer;
module.exports = _default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

/**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */
function _default(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = modelUtil.queryDataIndex(data, finder);

  if (dataIndex == null || zrUtil.isArray(dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
      return seriesModel.coordDimToDataDim(dim)[0];
    }), dataIndex, true)) || [];
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

module.exports = _default;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var modelUtil = __webpack_require__(15);

var get = modelUtil.makeGetter();
var each = zrUtil.each;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  get(zr).records || (get(zr).records = {});
  initGlobalListeners(zr, api);
  var record = get(zr).records[key] || (get(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (get(zr).initialized) {
    return;
  }

  get(zr).initialized = true;
  useHandler('click', zrUtil.curry(doEnter, 'click'));
  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each(get(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */


function unregister(key, api) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  var record = (get(zr).records || {})[key];

  if (record) {
    get(zr).records[key] = null;
  }
}

exports.register = register;
exports.unregister = unregister;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var helper = __webpack_require__(274);

echarts.registerAction('dataZoom', function (payload, ecModel) {
  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
    return model.get(dimNames.axisIndex);
  });
  var effectedModels = [];
  ecModel.eachComponent({
    mainType: 'dataZoom',
    query: payload
  }, function (model, index) {
    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
  });
  zrUtil.each(effectedModels, function (dataZoomModel, index) {
    dataZoomModel.setRawRange({
      start: payload.start,
      end: payload.end,
      startValue: payload.startValue,
      endValue: payload.endValue
    });
  });
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

echarts.registerProcessor(function (ecModel, api) {
  ecModel.eachComponent('dataZoom', function (dataZoomModel) {
    // We calculate window and reset axis here but not in model
    // init stage and not after action dispatch handler, because
    // reset should be called after seriesData.restoreData.
    dataZoomModel.eachTargetAxis(resetSingleAxis); // Caution: data zoom filtering is order sensitive when using
    // percent range and no min/max/scale set on axis.
    // For example, we have dataZoom definition:
    // [
    //      {xAxisIndex: 0, start: 30, end: 70},
    //      {yAxisIndex: 0, start: 20, end: 80}
    // ]
    // In this case, [20, 80] of y-dataZoom should be based on data
    // that have filtered by x-dataZoom using range of [30, 70],
    // but should not be based on full raw data. Thus sliding
    // x-dataZoom will change both ranges of xAxis and yAxis,
    // while sliding y-dataZoom will only change the range of yAxis.
    // So we should filter x-axis after reset x-axis immediately,
    // and then reset y-axis and filter y-axis.

    dataZoomModel.eachTargetAxis(filterSingleAxis);
  });
  ecModel.eachComponent('dataZoom', function (dataZoomModel) {
    // Fullfill all of the range props so that user
    // is able to get them from chart.getOption().
    var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
    var percentRange = axisProxy.getDataPercentWindow();
    var valueRange = axisProxy.getDataValueWindow();
    dataZoomModel.setRawRange({
      start: percentRange[0],
      end: percentRange[1],
      startValue: valueRange[0],
      endValue: valueRange[1]
    }, true);
  });
});

function resetSingleAxis(dimNames, axisIndex, dataZoomModel) {
  dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel);
}

function filterSingleAxis(dimNames, axisIndex, dataZoomModel) {
  dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel);
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var each = zrUtil.each;
var ATTR = '\0_ec_hist_store';
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
 */

function push(ecModel, newSnapshot) {
  var store = giveStore(ecModel); // If previous dataZoom can not be found,
  // complete an range with current range.

  each(newSnapshot, function (batchItem, dataZoomId) {
    var i = store.length - 1;

    for (; i >= 0; i--) {
      var snapshot = store[i];

      if (snapshot[dataZoomId]) {
        break;
      }
    }

    if (i < 0) {
      // No origin range set, create one by current range.
      var dataZoomModel = ecModel.queryComponents({
        mainType: 'dataZoom',
        subType: 'select',
        id: dataZoomId
      })[0];

      if (dataZoomModel) {
        var percentRange = dataZoomModel.getPercentRange();
        store[0][dataZoomId] = {
          dataZoomId: dataZoomId,
          start: percentRange[0],
          end: percentRange[1]
        };
      }
    }
  });
  store.push(newSnapshot);
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} snapshot
 */


function pop(ecModel) {
  var store = giveStore(ecModel);
  var head = store[store.length - 1];
  store.length > 1 && store.pop(); // Find top for all dataZoom.

  var snapshot = {};
  each(head, function (batchItem, dataZoomId) {
    for (var i = store.length - 1; i >= 0; i--) {
      var batchItem = store[i][dataZoomId];

      if (batchItem) {
        snapshot[dataZoomId] = batchItem;
        break;
      }
    }
  });
  return snapshot;
}
/**
 * @param {module:echarts/model/Global} ecModel
 */


function clear(ecModel) {
  ecModel[ATTR] = null;
}
/**
 * @param {module:echarts/model/Global} ecModel
 * @return {number} records. always >= 1.
 */


function count(ecModel) {
  return giveStore(ecModel).length;
}
/**
 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 * @type {Array.<Object>}
 */


function giveStore(ecModel) {
  var store = ecModel[ATTR];

  if (!store) {
    store = ecModel[ATTR] = [{}];
  }

  return store;
}

exports.push = push;
exports.pop = pop;
exports.clear = clear;
exports.count = count;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32);

Component.registerSubTypeDefaulter('dataZoom', function () {
  // Default 'slider' when no type specified.
  return 'slider';
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var modelUtil = __webpack_require__(15);

var brushHelper = __webpack_require__(464);

var each = zrUtil.each;
var indexOf = zrUtil.indexOf;
var curry = zrUtil.curry;
var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
// how to genarialize to more coordinate systems.

var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
/**
 * [option in constructor]:
 * {
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 * }
 *
 *
 * [targetInfo]:
 *
 * There can be multiple axes in a single targetInfo. Consider the case
 * of `grid` component, a targetInfo represents a grid which contains one or more
 * cartesian and one or more axes. And consider the case of parallel system,
 * which has multiple axes in a coordinate system.
 * Can be {
 *     panelId: ...,
 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
 *     coordSyses: all cartesians.
 *     gridModel: <grid component>
 *     xAxes: correspond to coordSyses on index
 *     yAxes: correspond to coordSyses on index
 * }
 * or {
 *     panelId: ...,
 *     coordSys: <geo coord sys>
 *     coordSyses: [<geo coord sys>]
 *     geoModel: <geo component>
 * }
 *
 *
 * [panelOpt]:
 *
 * Make from targetInfo. Input to BrushController.
 * {
 *     panelId: ...,
 *     rect: ...
 * }
 *
 *
 * [area]:
 *
 * Generated by BrushController or user input.
 * {
 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
 *     range: pixel range.
 *     coordRange: representitive coord range (the first one of coordRanges).
 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
 * }
 */

/**
 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} [opt]
 * @param {Array.<string>} [opt.include] include coordinate system types.
 */

function BrushTargetManager(option, ecModel, opt) {
  /**
   * @private
   * @type {Array.<Object>}
   */
  var targetInfoList = this._targetInfoList = [];
  var info = {};
  var foundCpts = parseFinder(ecModel, option);
  each(targetInfoBuilders, function (builder, type) {
    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
      builder(foundCpts, targetInfoList, info);
    }
  });
}

var proto = BrushTargetManager.prototype;

proto.setOutputRanges = function (areas, ecModel) {
  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges

    if (!area.coordRange) {
      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
      // rebuild range by coordRange accrately, which may bring trouble when
      // brushing only one item. So we use __rangeOffset to rebuilding range
      // by coordRange. And this it only used in brush component so it is no
      // need to be adapted to coordRanges.

      var result = coordConvert[area.brushType](0, coordSys, coordRange);
      area.__rangeOffset = {
        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
        xyMinMax: result.xyMinMax
      };
    }
  });
};

proto.matchOutputRanges = function (areas, ecModel, cb) {
  each(areas, function (area) {
    var targetInfo = this.findTargetInfo(area, ecModel);

    if (targetInfo && targetInfo !== true) {
      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
        var result = coordConvert[area.brushType](1, coordSys, area.range);
        cb(area, result.values, coordSys, ecModel);
      });
    }
  }, this);
};

proto.setInputRanges = function (areas, ecModel) {
  each(areas, function (area) {
    var targetInfo = this.findTargetInfo(area, ecModel);
    area.range = area.range || []; // convert coordRange to global range and set panelId.

    if (targetInfo && targetInfo !== true) {
      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
      // not keep its original value, for the sake of the dataZoom scenario,
      // where area.coordRange remains unchanged but area.range may be changed.
      // (2) Only support converting one coordRange to pixel range in brush
      // component. So do not consider `coordRanges`.
      // (3) About __rangeOffset, see comment above.

      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
      var rangeOffset = area.__rangeOffset;
      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
    }
  }, this);
};

proto.makePanelOpts = function (api, getDefaultBrushType) {
  return zrUtil.map(this._targetInfoList, function (targetInfo) {
    var rect = targetInfo.getPanelRect();
    return {
      panelId: targetInfo.panelId,
      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
      clipPath: brushHelper.makeRectPanelClipPath(rect),
      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
    };
  });
};

proto.controlSeries = function (area, seriesModel, ecModel) {
  // Check whether area is bound in coord, and series do not belong to that coord.
  // If do not do this check, some brush (like lineX) will controll all axes.
  var targetInfo = this.findTargetInfo(area, ecModel);
  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
};
/**
 * If return Object, a coord found.
 * If reutrn true, global found.
 * Otherwise nothing found.
 *
 * @param {Object} area
 * @param {Array} targetInfoList
 * @return {Object|boolean}
 */


proto.findTargetInfo = function (area, ecModel) {
  var targetInfoList = this._targetInfoList;
  var foundCpts = parseFinder(ecModel, area);

  for (var i = 0; i < targetInfoList.length; i++) {
    var targetInfo = targetInfoList[i];
    var areaPanelId = area.panelId;

    if (areaPanelId) {
      if (targetInfo.panelId === areaPanelId) {
        return targetInfo;
      }
    } else {
      for (var i = 0; i < targetInfoMatchers.length; i++) {
        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
          return targetInfo;
        }
      }
    }
  }

  return true;
};

function formatMinMax(minMax) {
  minMax[0] > minMax[1] && minMax.reverse();
  return minMax;
}

function parseFinder(ecModel, option) {
  return modelUtil.parseFinder(ecModel, option, {
    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
  });
}

var targetInfoBuilders = {
  grid: function (foundCpts, targetInfoList) {
    var xAxisModels = foundCpts.xAxisModels;
    var yAxisModels = foundCpts.yAxisModels;
    var gridModels = foundCpts.gridModels; // Remove duplicated.

    var gridModelMap = zrUtil.createHashMap();
    var xAxesHas = {};
    var yAxesHas = {};

    if (!xAxisModels && !yAxisModels && !gridModels) {
      return;
    }

    each(xAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
    });
    each(yAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      yAxesHas[gridModel.id] = true;
    });
    each(gridModels, function (gridModel) {
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
      yAxesHas[gridModel.id] = true;
    });
    gridModelMap.each(function (gridModel) {
      var grid = gridModel.coordinateSystem;
      var cartesians = [];
      each(grid.getCartesians(), function (cartesian, index) {
        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
          cartesians.push(cartesian);
        }
      });
      targetInfoList.push({
        panelId: 'grid--' + gridModel.id,
        gridModel: gridModel,
        coordSysModel: gridModel,
        // Use the first one as the representitive coordSys.
        coordSys: cartesians[0],
        coordSyses: cartesians,
        getPanelRect: panelRectBuilder.grid,
        xAxisDeclared: xAxesHas[gridModel.id],
        yAxisDeclared: yAxesHas[gridModel.id]
      });
    });
  },
  geo: function (foundCpts, targetInfoList) {
    each(foundCpts.geoModels, function (geoModel) {
      var coordSys = geoModel.coordinateSystem;
      targetInfoList.push({
        panelId: 'geo--' + geoModel.id,
        geoModel: geoModel,
        coordSysModel: geoModel,
        coordSys: coordSys,
        coordSyses: [coordSys],
        getPanelRect: panelRectBuilder.geo
      });
    });
  }
};
var targetInfoMatchers = [// grid
function (foundCpts, targetInfo) {
  var xAxisModel = foundCpts.xAxisModel;
  var yAxisModel = foundCpts.yAxisModel;
  var gridModel = foundCpts.gridModel;
  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
  return gridModel && gridModel === targetInfo.gridModel;
}, // geo
function (foundCpts, targetInfo) {
  var geoModel = foundCpts.geoModel;
  return geoModel && geoModel === targetInfo.geoModel;
}];
var panelRectBuilder = {
  grid: function () {
    // grid is not Transformable.
    return this.coordSys.grid.getRect().clone();
  },
  geo: function () {
    var coordSys = this.coordSys;
    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform

    rect.applyTransform(graphic.getTransform(coordSys));
    return rect;
  }
};
var coordConvert = {
  lineX: curry(axisConvert, 0),
  lineY: curry(axisConvert, 1),
  rect: function (to, coordSys, rangeOrCoordRange) {
    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
    return {
      values: values,
      xyMinMax: values
    };
  },
  polygon: function (to, coordSys, rangeOrCoordRange) {
    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
    var values = zrUtil.map(rangeOrCoordRange, function (item) {
      var p = coordSys[COORD_CONVERTS[to]](item);
      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
      return p;
    });
    return {
      values: values,
      xyMinMax: xyMinMax
    };
  }
};

function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
  }));
  var xyMinMax = [];
  xyMinMax[axisNameIndex] = values;
  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
  return {
    values: values,
    xyMinMax: xyMinMax
  };
}

var diffProcessor = {
  lineX: curry(axisDiffProcessor, 0),
  lineY: curry(axisDiffProcessor, 1),
  rect: function (values, refer, scales) {
    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
  },
  polygon: function (values, refer, scales) {
    return zrUtil.map(values, function (item, idx) {
      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
    });
  }
};

function axisDiffProcessor(axisNameIndex, values, refer, scales) {
  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
} // We have to process scale caused by dataZoom manually,
// although it might be not accurate.


function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
  var sizeCurr = getSize(xyMinMaxCurr);
  var sizeOrigin = getSize(xyMinMaxOrigin);
  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
  isNaN(scales[0]) && (scales[0] = 1);
  isNaN(scales[1]) && (scales[1] = 1);
  return scales;
}

function getSize(xyMinMax) {
  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
}

var _default = BrushTargetManager;
module.exports = _default;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var RoamController = __webpack_require__(191);

var roamHelper = __webpack_require__(467);

var _cursorHelper = __webpack_require__(276);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphic = __webpack_require__(5);

function getFixedItemStyle(model, scale) {
  var itemStyle = model.getItemStyle();
  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
  // they should both set areaColor and color to be null.

  if (areaColor != null) {
    itemStyle.fill = areaColor;
  }

  return itemStyle;
}

function updateMapSelectHandler(mapDraw, mapOrGeoModel, group, api, fromView) {
  group.off('click');
  group.off('mousedown');

  if (mapOrGeoModel.get('selectedMode')) {
    group.on('mousedown', function () {
      mapDraw._mouseDownFlag = true;
    });
    group.on('click', function (e) {
      if (!mapDraw._mouseDownFlag) {
        return;
      }

      mapDraw._mouseDownFlag = false;
      var el = e.target;

      while (!el.__regions) {
        el = el.parent;
      }

      if (!el) {
        return;
      }

      var action = {
        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
        batch: zrUtil.map(el.__regions, function (region) {
          return {
            name: region.name,
            from: fromView.uid
          };
        })
      };
      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
      api.dispatchAction(action);
      updateMapSelected(mapOrGeoModel, group);
    });
  }
}

function updateMapSelected(mapOrGeoModel, group) {
  // FIXME
  group.eachChild(function (otherRegionEl) {
    zrUtil.each(otherRegionEl.__regions, function (region) {
      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
    });
  });
}
/**
 * @alias module:echarts/component/helper/MapDraw
 * @param {module:echarts/ExtensionAPI} api
 * @param {boolean} updateGroup
 */


function MapDraw(api, updateGroup) {
  var group = new graphic.Group();
  /**
   * @type {module:echarts/component/helper/RoamController}
   * @private
   */

  this._controller = new RoamController(api.getZr());
  /**
   * @type {Object} {target, zoom, zoomLimit}
   * @private
   */

  this._controllerHost = {
    target: updateGroup ? group : null
  };
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */

  this.group = group;
  /**
   * @type {boolean}
   * @private
   */

  this._updateGroup = updateGroup;
  /**
   * This flag is used to make sure that only one among
   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
   * action may be triggered when `pan`, which is unexpected.
   * @type {booelan}
   */

  this._mouseDownFlag;
}

MapDraw.prototype = {
  constructor: MapDraw,
  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
    // will be assigned with map data. Other GEO model has no data.

    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
    isGeo && ecModel.eachComponent({
      mainType: 'series',
      subType: 'map'
    }, function (mapSeries) {
      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
        data = mapSeries.getData();
      }
    });
    var geo = mapOrGeoModel.coordinateSystem;
    var group = this.group;
    var scale = geo.scale;
    var groupNewProp = {
      position: geo.position,
      scale: scale
    }; // No animation when first draw or in action

    if (!group.childAt(0) || payload) {
      group.attr(groupNewProp);
    } else {
      graphic.updateProps(group, groupNewProp, mapOrGeoModel);
    }

    group.removeAll();
    var itemStyleAccessPath = ['itemStyle', 'normal'];
    var hoverItemStyleAccessPath = ['itemStyle', 'emphasis'];
    var labelAccessPath = ['label', 'normal'];
    var hoverLabelAccessPath = ['label', 'emphasis'];
    var nameMap = zrUtil.createHashMap();
    zrUtil.each(geo.regions, function (region) {
      // Consider in GeoJson properties.name may be duplicated, for example,
      // there is multiple region named "United Kindom" or "France" (so many
      // colonies). And it is not appropriate to merge them in geo, which
      // will make them share the same label and bring trouble in label
      // location calculation.
      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
      var compoundPath = new graphic.CompoundPath({
        shape: {
          paths: []
        }
      });
      regionGroup.add(compoundPath);
      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
      var itemStyle = getFixedItemStyle(itemStyleModel, scale);
      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel, scale);
      var labelModel = regionModel.getModel(labelAccessPath);
      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
      var dataIdx; // Use the itemStyle in data if has data

      if (data) {
        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
        // But visual color of series is used in symbol drawing
        //
        // Visual color for each series is for the symbol draw

        var visualColor = data.getItemVisual(dataIdx, 'color', true);

        if (visualColor) {
          itemStyle.fill = visualColor;
        }
      }

      zrUtil.each(region.geometries, function (geometry) {
        if (geometry.type !== 'polygon') {
          return;
        }

        compoundPath.shape.paths.push(new graphic.Polygon({
          shape: {
            points: geometry.exterior
          }
        }));

        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); i++) {
          compoundPath.shape.paths.push(new graphic.Polygon({
            shape: {
              points: geometry.interiors[i]
            }
          }));
        }
      });
      compoundPath.setStyle(itemStyle);
      compoundPath.style.strokeNoScale = true;
      compoundPath.culling = true; // Label

      var showLabel = labelModel.get('show');
      var hoverShowLabel = hoverLabelModel.get('show');
      var isDataNaN = data && isNaN(data.get('value', dataIdx));
      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
      // 1. In map series and data value is NaN
      // 2. In geo component
      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout

      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : region.name;
        var labelFetcher; // Consider dataIdx not found.

        if (!data || dataIdx >= 0) {
          labelFetcher = mapOrGeoModel;
        }

        var textEl = new graphic.Text({
          position: region.center.slice(),
          scale: [1 / scale[0], 1 / scale[1]],
          z2: 10,
          silent: true
        });
        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
          labelFetcher: labelFetcher,
          labelDataIndex: query,
          defaultText: region.name,
          useInsideStyle: false
        }, {
          textAlign: 'center',
          textVerticalAlign: 'middle'
        });
        regionGroup.add(textEl);
      } // setItemGraphicEl, setHoverStyle after all polygons and labels
      // are added to the rigionGroup


      if (data) {
        data.setItemGraphicEl(dataIdx, regionGroup);
      } else {
        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component

        compoundPath.eventData = {
          componentType: 'geo',
          geoIndex: mapOrGeoModel.componentIndex,
          name: region.name,
          region: regionModel && regionModel.option || {}
        };
      }

      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
      groupRegions.push(region);
      graphic.setHoverStyle(regionGroup, hoverItemStyle, {
        hoverSilentOnTouch: !!mapOrGeoModel.get('selectedMode')
      });
      group.add(regionGroup);
    });

    this._updateController(mapOrGeoModel, ecModel, api);

    updateMapSelectHandler(this, mapOrGeoModel, group, api, fromView);
    updateMapSelected(mapOrGeoModel, group);
  },
  remove: function () {
    this.group.removeAll();

    this._controller.dispose();

    this._controllerHost = {};
  },
  _updateController: function (mapOrGeoModel, ecModel, api) {
    var geo = mapOrGeoModel.coordinateSystem;
    var controller = this._controller;
    var controllerHost = this._controllerHost;
    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null

    controller.enable(mapOrGeoModel.get('roam') || false);
    var mainType = mapOrGeoModel.mainType;

    function makeActionBase() {
      var action = {
        type: 'geoRoam',
        componentType: mainType
      };
      action[mainType + 'Id'] = mapOrGeoModel.id;
      return action;
    }

    controller.off('pan').on('pan', function (dx, dy) {
      this._mouseDownFlag = false;
      roamHelper.updateViewOnPan(controllerHost, dx, dy);
      api.dispatchAction(zrUtil.extend(makeActionBase(), {
        dx: dx,
        dy: dy
      }));
    }, this);
    controller.off('zoom').on('zoom', function (zoom, mouseX, mouseY) {
      this._mouseDownFlag = false;
      roamHelper.updateViewOnZoom(controllerHost, zoom, mouseX, mouseY);
      api.dispatchAction(zrUtil.extend(makeActionBase(), {
        zoom: zoom,
        originX: mouseX,
        originY: mouseY
      }));

      if (this._updateGroup) {
        var group = this.group;
        var scale = group.scale;
        group.traverse(function (el) {
          if (el.type === 'text') {
            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
          }
        });
      }
    }, this);
    controller.setPointerChecker(function (e, x, y) {
      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
    });
  }
};
var _default = MapDraw;
module.exports = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(26);

var _cursorHelper = __webpack_require__(276);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphicUtil = __webpack_require__(5);

function makeRectPanelClipPath(rect) {
  rect = normalizeRect(rect);
  return function (localPoints, transform) {
    return graphicUtil.clipPointsByRect(localPoints, rect);
  };
}

function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
  rect = normalizeRect(rect);
  return function (xyIndex) {
    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
    var brushWidth = idx ? rect.width : rect.height;
    var base = idx ? rect.x : rect.y;
    return [base, base + (brushWidth || 0)];
  };
}

function makeRectIsTargetByCursor(rect, api, targetModel) {
  rect = normalizeRect(rect);
  return function (e, localCursorPoint, transform) {
    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
  };
} // Consider width/height is negative.


function normalizeRect(rect) {
  return BoundingRect.create(rect);
}

exports.makeRectPanelClipPath = makeRectPanelClipPath;
exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var ATTR = '\0_ec_interaction_mutex';

function take(zr, resourceKey, userKey) {
  var store = getStore(zr);
  store[resourceKey] = userKey;
}

function release(zr, resourceKey, userKey) {
  var store = getStore(zr);
  var uKey = store[resourceKey];

  if (uKey === userKey) {
    store[resourceKey] = null;
  }
}

function isTaken(zr, resourceKey) {
  return !!getStore(zr)[resourceKey];
}

function getStore(zr) {
  return zr[ATTR] || (zr[ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */


echarts.registerAction({
  type: 'takeGlobalCursor',
  event: 'globalCursorTaken',
  update: 'update'
}, function () {});
exports.take = take;
exports.release = release;
exports.isTaken = isTaken;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;
var layoutBox = _layout.box;
var positionElement = _layout.positionElement;

var formatUtil = __webpack_require__(21);

var graphic = __webpack_require__(5);

/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */
function layout(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  positionElement(group, boxLayoutParams, viewportSize, padding);
}

function makeBackground(rect, componentModel) {
  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  var rect = new graphic.Rect({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

exports.layout = layout;
exports.makeBackground = makeBackground;

/***/ }),
/* 467 */
/***/ (function(module, exports) {

/**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 */
function updateViewOnPan(controllerHost, dx, dy) {
  var target = controllerHost.target;
  var pos = target.position;
  pos[0] += dx;
  pos[1] += dy;
  target.dirty();
}
/**
 * For geo and graph.
 *
 * @param {Object} controllerHost
 * @param {module:zrender/Element} controllerHost.target
 * @param {number} controllerHost.zoom
 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
 */


function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
  var target = controllerHost.target;
  var zoomLimit = controllerHost.zoomLimit;
  var pos = target.position;
  var scale = target.scale;
  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
  newZoom *= zoomDelta;

  if (zoomLimit) {
    var zoomMin = zoomLimit.min || 0;
    var zoomMax = zoomLimit.max || Infinity;
    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
  }

  var zoomScale = newZoom / controllerHost.zoom;
  controllerHost.zoom = newZoom; // Keep the mouse center when scaling

  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
  scale[0] *= zoomScale;
  scale[1] *= zoomScale;
  target.dirty();
}

exports.updateViewOnPan = updateViewOnPan;
exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var Model = __webpack_require__(29);

var LegendModel = echarts.extendComponentModel({
  type: 'legend.plain',
  dependencies: ['series'],
  layoutMode: {
    type: 'box',
    // legend.width/height are maxWidth/maxHeight actually,
    // whereas realy width/height is calculated by its content.
    // (Setting {left: 10, right: 10} does not make sense).
    // So consider the case:
    // `setOption({legend: {left: 10});`
    // then `setOption({legend: {right: 10});`
    // The previous `left` should be cleared by setting `ignoreSize`.
    ignoreSize: true
  },
  init: function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};
  },
  mergeOption: function (option) {
    LegendModel.superCall(this, 'mergeOption', option);
  },
  optionUpdated: function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name = legendData[i].get('name');

        if (this.isSelected(name)) {
          // Force to unselect others
          this.select(name);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  },
  _updateData: function (ecModel) {
    var legendData = zrUtil.map(this.get('data') || [], function (dataItem) {
      // Can be string or number
      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
        dataItem = {
          name: dataItem
        };
      }

      return new Model(dataItem, this, this.ecModel);
    }, this);
    this._data = legendData;
    var availableNames = zrUtil.map(ecModel.getSeries(), function (series) {
      return series.name;
    });
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.legendDataProvider) {
        var data = seriesModel.legendDataProvider();
        availableNames = availableNames.concat(data.mapArray(data.getName));
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames;
  },

  /**
   * @return {Array.<module:echarts/model/Model>}
   */
  getData: function () {
    return this._data;
  },

  /**
   * @param {string} name
   */
  select: function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      zrUtil.each(data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  },

  /**
   * @param {string} name
   */
  unSelect: function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  },

  /**
   * @param {string} name
   */
  toggleSelected: function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  },

  /**
   * @param {string} name
   */
  isSelected: function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 4,
    show: true,
    // 布局方式，默认为水平布局，可选为：
    // 'horizontal' | 'vertical'
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    // 水平对齐
    // 'auto' | 'left' | 'right'
    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    // 图例边框颜色
    borderColor: '#ccc',
    borderRadius: 0,
    // 图例边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 图例内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 各个item之间的间隔，单位px，默认为10，
    // 横向布局时为水平间隔，纵向布局时为纵向间隔
    itemGap: 10,
    // 图例图形宽度
    itemWidth: 25,
    // 图例图形高度
    itemHeight: 14,
    // 图例关闭时候的颜色
    inactiveColor: '#ccc',
    textStyle: {
      // 图例文字颜色
      color: '#333'
    },
    // formatter: '',
    // 选择模式，默认开启图例开关
    selectedMode: true,
    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
    // selected: null,
    // 图例内容（详见legend.data，数组中每一项代表一个item
    // data: [],
    // Tooltip 相关配置
    tooltip: {
      show: false
    }
  }
});
var _default = LegendModel;
module.exports = _default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(5);

var _listComponent = __webpack_require__(466);

var makeBackground = _listComponent.makeBackground;

var layoutUtil = __webpack_require__(17);

var curry = zrUtil.curry;
var each = zrUtil.each;
var Group = graphic.Group;

var _default = echarts.extendComponentView({
  type: 'legend.plain',
  newlineDisabled: false,

  /**
   * @override
   */
  init: function () {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this.group.add(this._contentGroup = new Group());
    /**
     * @private
     * @type {module:zrender/Element}
     */

    this._backgroundEl;
  },

  /**
   * @protected
   */
  getContentGroup: function () {
    return this._contentGroup;
  },

  /**
   * @override
   */
  render: function (legendModel, ecModel, api) {
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && legendModel.get('orient') === 'vertical' ? 'right' : 'left';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.

    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
  },

  /**
   * @protected
   */
  resetInner: function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
  },

  /**
   * @protected
   */
  renderInner: function (itemAlign, legendModel, ecModel, api) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = zrUtil.createHashMap();
    var selectMode = legendModel.get('selectedMode');
    each(legendModel.getData(), function (itemModel, dataIndex) {
      var name = itemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        contentGroup.add(new Group({
          newline: true
        }));
        return;
      }

      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawed
        return;
      } // Series legend


      if (seriesModel) {
        var data = seriesModel.getData();
        var color = data.getVisual('color'); // If color is a callback function

        if (typeof color === 'function') {
          // Use the first data
          color = color(seriesModel.getDataParams(0));
        } // Using rect symbol defaultly


        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
        var symbolType = data.getVisual('symbol');

        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode);

        itemGroup.on('click', curry(dispatchSelectAction, name, api)).on('mouseover', curry(dispatchHighlightAction, seriesModel, null, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, null, api));
        legendDrawnMap.set(name, true);
      } else {
        // Data legend of pie, funnel
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendDataProvider) {
            var data = seriesModel.legendDataProvider();
            var idx = data.indexOfName(name);

            if (idx < 0) {
              return;
            }

            var color = data.getItemVisual(idx, 'color');
            var legendSymbolType = 'roundRect';

            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, selectMode);

            itemGroup.on('click', curry(dispatchSelectAction, name, api)) // FIXME Should not specify the series name
            .on('mouseover', curry(dispatchHighlightAction, seriesModel, name, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, name, api));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }
    }, this);
  },
  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode) {
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var inactiveColor = legendModel.get('inactiveColor');
    var isSelected = legendModel.isSelected(name);
    var itemGroup = new Group();
    var textStyleModel = itemModel.getModel('textStyle');
    var itemIcon = itemModel.get('icon');
    var tooltipModel = itemModel.getModel('tooltip');
    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first

    legendSymbolType = itemIcon || legendSymbolType;
    itemGroup.add(createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, true)); // Compose symbols
    // PENDING

    if (!itemIcon && symbolType // At least show one symbol, can't be all none
    && (symbolType !== legendSymbolType || symbolType == 'none')) {
      var size = itemHeight * 0.8;

      if (symbolType === 'none') {
        symbolType = 'circle';
      } // Put symbol in the center


      itemGroup.add(createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (typeof formatter === 'string' && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (typeof formatter === 'function') {
      content = formatter(name);
    }

    itemGroup.add(new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        textAlign: textAlign,
        textVerticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new graphic.Rect({
      shape: itemGroup.getBoundingRect(),
      invisible: true,
      tooltip: tooltipModel.get('show') ? zrUtil.extend({
        content: name,
        // Defaul formatter
        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
          return name;
        },
        formatterParams: {
          componentType: 'legend',
          legendIndex: legendModel.componentIndex,
          name: name,
          $vars: ['name']
        }
      }, tooltipModel.option) : null
    });
    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    graphic.setHoverStyle(itemGroup);
    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  },

  /**
   * @protected
   */
  layoutInner: function (legendModel, itemAlign, maxSize) {
    var contentGroup = this.getContentGroup(); // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    contentGroup.attr('position', [-contentRect.x, -contentRect.y]);
    return this.group.getBoundingRect();
  }
});

function dispatchSelectAction(name, api) {
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: name
  });
}

function dispatchHighlightAction(seriesModel, dataName, api) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    seriesModel.get('legendHoverLink') && api.dispatchAction({
      type: 'highlight',
      seriesName: seriesModel.name,
      name: dataName
    });
  }
}

function dispatchDownplayAction(seriesModel, dataName, api) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    seriesModel.get('legendHoverLink') && api.dispatchAction({
      type: 'downplay',
      seriesName: seriesModel.name,
      name: dataName
    });
  }
}

module.exports = _default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var throttleUtil = __webpack_require__(104);

var parallelPreprocessor = __webpack_require__(1583);

__webpack_require__(484);

__webpack_require__(1582);

__webpack_require__(1529);

var CLICK_THRESHOLD = 5; // > 4
// Parallel view

echarts.extendComponentView({
  type: 'parallel',
  render: function (parallelModel, ecModel, api) {
    this._model = parallelModel;
    this._api = api;

    if (!this._handlers) {
      this._handlers = {};
      zrUtil.each(handlers, function (handler, eventName) {
        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
      }, this);
    }

    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
  },
  dispose: function (ecModel, api) {
    zrUtil.each(this._handlers, function (handler, eventName) {
      api.getZr().off(eventName, handler);
    });
    this._handlers = null;
  },

  /**
   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
   */
  _throttledDispatchExpand: function (opt) {
    this._dispatchExpand(opt);
  },
  _dispatchExpand: function (opt) {
    opt && this._api.dispatchAction(zrUtil.extend({
      type: 'parallelAxisExpand'
    }, opt));
  }
});
var handlers = {
  mousedown: function (e) {
    if (checkTrigger(this, 'click')) {
      this._mouseDownPoint = [e.offsetX, e.offsetY];
    }
  },
  mouseup: function (e) {
    var mouseDownPoint = this._mouseDownPoint;

    if (checkTrigger(this, 'click') && mouseDownPoint) {
      var point = [e.offsetX, e.offsetY];
      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);

      if (dist > CLICK_THRESHOLD) {
        return;
      }

      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);

      result.behavior !== 'none' && this._dispatchExpand({
        axisExpandWindow: result.axisExpandWindow
      });
    }

    this._mouseDownPoint = null;
  },
  mousemove: function (e) {
    // Should do nothing when brushing.
    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
      return;
    }

    var model = this._model;
    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
    var behavior = result.behavior;
    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));

    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
    : {
      axisExpandWindow: result.axisExpandWindow,
      // Jumping uses animation, and sliding suppresses animation.
      animation: behavior === 'jump' ? null : false
    });
  }
};

function checkTrigger(view, triggerOn) {
  var model = view._model;
  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}

echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1597);

__webpack_require__(1483);

__webpack_require__(1593);

__webpack_require__(141);

__webpack_require__(1488);

echarts.extendComponentView({
  type: 'single'
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var visualDefault = __webpack_require__(491);

var VisualMapping = __webpack_require__(105);

var visualSolution = __webpack_require__(197);

var modelUtil = __webpack_require__(15);

var numberUtil = __webpack_require__(8);

var mapVisual = VisualMapping.mapVisual;
var eachVisual = VisualMapping.eachVisual;
var isArray = zrUtil.isArray;
var each = zrUtil.each;
var asc = numberUtil.asc;
var linearMap = numberUtil.linearMap;
var noop = zrUtil.noop;
var DEFAULT_COLOR = ['#f6efa6', '#d88273', '#bf444c'];
var VisualMapModel = echarts.extendComponentModel({
  type: 'visualMap',
  dependencies: ['series'],

  /**
   * @readOnly
   * @type {Array.<string>}
   */
  stateList: ['inRange', 'outOfRange'],

  /**
   * @readOnly
   * @type {Array.<string>}
   */
  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],

  /**
   * [lowerBound, upperBound]
   *
   * @readOnly
   * @type {Array.<number>}
   */
  dataBound: [-Infinity, Infinity],

  /**
   * @readOnly
   * @type {string|Object}
   */
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },

  /**
   * @protected
   */
  defaultOption: {
    show: true,
    zlevel: 0,
    z: 4,
    seriesIndex: 'all',
    // 'all' or null/undefined: all series.
    // A number or an array of number: the specified series.
    // set min: 0, max: 200, only for campatible with ec2.
    // In fact min max should not have default value.
    min: 0,
    // min value, must specified if pieces is not specified.
    max: 200,
    // max value, must specified if pieces is not specified.
    dimension: null,
    inRange: null,
    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
    // 'symbol', 'symbolSize'
    outOfRange: null,
    // 'color', 'colorHue', 'colorSaturation',
    // 'colorLightness', 'colorAlpha',
    // 'symbol', 'symbolSize'
    left: 0,
    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
    right: null,
    // The same as left.
    top: null,
    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
    bottom: 0,
    // The same as top.
    itemWidth: null,
    itemHeight: null,
    inverse: false,
    orient: 'vertical',
    // 'horizontal' ¦ 'vertical'
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    // 值域边框颜色
    contentColor: '#5793f3',
    inactiveColor: '#aaa',
    borderWidth: 0,
    // 值域边框线宽，单位px，默认为0（无边框）
    padding: 5,
    // 值域内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    textGap: 10,
    //
    precision: 0,
    // 小数精度，默认为0，无小数点
    color: null,
    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
    formatter: null,
    text: null,
    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
    textStyle: {
      color: '#333' // 值域文字颜色

    }
  },

  /**
   * @protected
   */
  init: function (option, parentModel, ecModel) {
    /**
     * @private
     * @type {Array.<number>}
     */
    this._dataExtent;
    /**
     * @readOnly
     */

    this.targetVisuals = {};
    /**
     * @readOnly
     */

    this.controllerVisuals = {};
    /**
     * @readOnly
     */

    this.textStyleModel;
    /**
     * [width, height]
     * @readOnly
     * @type {Array.<number>}
     */

    this.itemSize;
    this.mergeDefaultAndTheme(option, ecModel);
  },

  /**
   * @protected
   */
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option; // FIXME
    // necessary?
    // Disable realtime view update if canvas is not supported.

    if (!env.canvasSupported) {
      thisOption.realtime = false;
    }

    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
    this.textStyleModel = this.getModel('textStyle');
    this.resetItemSize();
    this.completeVisualOption();
  },

  /**
   * @protected
   */
  resetVisual: function (supplementVisualOption) {
    var stateList = this.stateList;
    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
  },

  /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */
  getTargetSeriesIndices: function () {
    var optionSeriesIndex = this.option.seriesIndex;
    var seriesIndices = [];

    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
      this.ecModel.eachSeries(function (seriesModel, index) {
        seriesIndices.push(index);
      });
    } else {
      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
    }

    return seriesIndices;
  },

  /**
   * @public
   */
  eachTargetSeries: function (callback, context) {
    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
    }, this);
  },

  /**
   * @pubilc
   */
  isTargetSeries: function (seriesModel) {
    var is = false;
    this.eachTargetSeries(function (model) {
      model === seriesModel && (is = true);
    });
    return is;
  },

  /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
   * @param {boolean} [isCategory=false] Only available when value is number.
   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
   * @return {string}
   * @protected
   */
  formatValueText: function (value, isCategory, edgeSymbols) {
    var option = this.option;
    var precision = option.precision;
    var dataBound = this.dataBound;
    var formatter = option.formatter;
    var isMinMax;
    var textValue;
    edgeSymbols = edgeSymbols || ['<', '>'];

    if (zrUtil.isArray(value)) {
      value = value.slice();
      isMinMax = true;
    }

    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);

    if (zrUtil.isString(formatter)) {
      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
    } else if (zrUtil.isFunction(formatter)) {
      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
    }

    if (isMinMax) {
      if (value[0] === dataBound[0]) {
        return edgeSymbols[0] + ' ' + textValue[1];
      } else if (value[1] === dataBound[1]) {
        return edgeSymbols[1] + ' ' + textValue[0];
      } else {
        return textValue[0] + ' - ' + textValue[1];
      }
    } else {
      // Format single value (includes category case).
      return textValue;
    }

    function toFixed(val) {
      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
    }
  },

  /**
   * @protected
   */
  resetExtent: function () {
    var thisOption = this.option; // Can not calculate data extent by data here.
    // Because series and data may be modified in processing stage.
    // So we do not support the feature "auto min/max".

    var extent = asc([thisOption.min, thisOption.max]);
    this._dataExtent = extent;
  },

  /**
   * @public
   * @param {module:echarts/data/List} list
   * @return {string} Concrete dimention. If return null/undefined,
   *                  no dimension used.
   */
  getDataDimension: function (list) {
    var optDim = this.option.dimension;
    return optDim != null ? optDim : list.dimensions.length - 1;
  },

  /**
   * @public
   * @override
   */
  getExtent: function () {
    return this._dataExtent.slice();
  },

  /**
   * @protected
   */
  completeVisualOption: function () {
    var thisOption = this.option;
    var base = {
      inRange: thisOption.inRange,
      outOfRange: thisOption.outOfRange
    };
    var target = thisOption.target || (thisOption.target = {});
    var controller = thisOption.controller || (thisOption.controller = {});
    zrUtil.merge(target, base); // Do not override

    zrUtil.merge(controller, base); // Do not override

    var isCategory = this.isCategory();
    completeSingle.call(this, target);
    completeSingle.call(this, controller);
    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');

    completeController.call(this, controller);

    function completeSingle(base) {
      // Compatible with ec2 dataRange.color.
      // The mapping order of dataRange.color is: [high value, ..., low value]
      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
      // Notice: ec2 has no inverse.
      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
      // So adding color only when no inRange defined.
      && !base.inRange) {
        base.inRange = {
          color: thisOption.color.slice().reverse()
        };
      } // Compatible with previous logic, always give a defautl color, otherwise
      // simple config with no inRange and outOfRange will not work.
      // Originally we use visualMap.color as the default color, but setOption at
      // the second time the default color will be erased. So we change to use
      // constant DEFAULT_COLOR.
      // If user do not want the defualt color, set inRange: {color: null}.


      base.inRange = base.inRange || {
        color: DEFAULT_COLOR
      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.

      each(this.stateList, function (state) {
        var visualType = base[state];

        if (zrUtil.isString(visualType)) {
          var defa = visualDefault.get(visualType, 'active', isCategory);

          if (defa) {
            base[state] = {};
            base[state][visualType] = defa;
          } else {
            // Mark as not specified.
            delete base[state];
          }
        }
      }, this);
    }

    function completeInactive(base, stateExist, stateAbsent) {
      var optExist = base[stateExist];
      var optAbsent = base[stateAbsent];

      if (optExist && !optAbsent) {
        optAbsent = base[stateAbsent] = {};
        each(optExist, function (visualData, visualType) {
          if (!VisualMapping.isValidType(visualType)) {
            return;
          }

          var defa = visualDefault.get(visualType, 'inactive', isCategory);

          if (defa != null) {
            optAbsent[visualType] = defa; // Compatibable with ec2:
            // Only inactive color to rgba(0,0,0,0) can not
            // make label transparent, so use opacity also.

            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
              optAbsent.opacity = [0, 0];
            }
          }
        });
      }
    }

    function completeController(controller) {
      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
      var inactiveColor = this.get('inactiveColor');
      each(this.stateList, function (state) {
        var itemSize = this.itemSize;
        var visuals = controller[state]; // Set inactive color for controller if no other color
        // attr (like colorAlpha) specified.

        if (!visuals) {
          visuals = controller[state] = {
            color: isCategory ? inactiveColor : [inactiveColor]
          };
        } // Consistent symbol and symbolSize if not specified.


        if (visuals.symbol == null) {
          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
        }

        if (visuals.symbolSize == null) {
          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
        } // Filter square and none.


        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
        }); // Normalize symbolSize

        var symbolSize = visuals.symbolSize;

        if (symbolSize != null) {
          var max = -Infinity; // symbolSize can be object when categories defined.

          eachVisual(symbolSize, function (value) {
            value > max && (max = value);
          });
          visuals.symbolSize = mapVisual(symbolSize, function (value) {
            return linearMap(value, [0, max], [0, itemSize[0]], true);
          });
        }
      }, this);
    }
  },

  /**
   * @protected
   */
  resetItemSize: function () {
    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
  },

  /**
   * @public
   */
  isCategory: function () {
    return !!this.option.categories;
  },

  /**
   * @public
   * @abstract
   */
  setSelected: noop,

  /**
   * @public
   * @abstract
   * @param {*|module:echarts/data/List} valueOrData
   * @param {number} dataIndex
   * @return {string} state See this.stateList
   */
  getValueState: noop,

  /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param {Function} getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */
  getVisualMeta: noop
});
var _default = VisualMapModel;
module.exports = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var formatUtil = __webpack_require__(21);

var layout = __webpack_require__(17);

var VisualMapping = __webpack_require__(105);

var _default = echarts.extendComponentView({
  type: 'visualMap',

  /**
   * @readOnly
   * @type {Object}
   */
  autoPositionValues: {
    left: 1,
    right: 1,
    top: 1,
    bottom: 1
  },
  init: function (ecModel, api) {
    /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */
    this.ecModel = ecModel;
    /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */

    this.api = api;
    /**
     * @readOnly
     * @type {module:echarts/component/visualMap/visualMapModel}
     */

    this.visualMapModel;
  },

  /**
   * @protected
   */
  render: function (visualMapModel, ecModel, api, payload) {
    this.visualMapModel = visualMapModel;

    if (visualMapModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    this.doRender.apply(this, arguments);
  },

  /**
   * @protected
   */
  renderBackground: function (group) {
    var visualMapModel = this.visualMapModel;
    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
    var rect = group.getBoundingRect();
    group.add(new graphic.Rect({
      z2: -1,
      // Lay background rect on the lowest layer.
      silent: true,
      shape: {
        x: rect.x - padding[3],
        y: rect.y - padding[0],
        width: rect.width + padding[3] + padding[1],
        height: rect.height + padding[0] + padding[2]
      },
      style: {
        fill: visualMapModel.get('backgroundColor'),
        stroke: visualMapModel.get('borderColor'),
        lineWidth: visualMapModel.get('borderWidth')
      }
    }));
  },

  /**
   * @protected
   * @param {number} targetValue can be Infinity or -Infinity
   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param {Object} [opts]
   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
   * @return {*} Visual value.
   */
  getControllerVisual: function (targetValue, visualCluster, opts) {
    opts = opts || {};
    var forceState = opts.forceState;
    var visualMapModel = this.visualMapModel;
    var visualObj = {}; // Default values.

    if (visualCluster === 'symbol') {
      visualObj.symbol = visualMapModel.get('itemSymbol');
    }

    if (visualCluster === 'color') {
      var defaultColor = visualMapModel.get('contentColor');
      visualObj.color = defaultColor;
    }

    function getter(key) {
      return visualObj[key];
    }

    function setter(key, value) {
      visualObj[key] = value;
    }

    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
    zrUtil.each(visualTypes, function (type) {
      var visualMapping = mappings[type];

      if (opts.convertOpacityToAlpha && type === 'opacity') {
        type = 'colorAlpha';
        visualMapping = mappings.__alphaForOpacity;
      }

      if (VisualMapping.dependsOn(type, visualCluster)) {
        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
      }
    });
    return visualObj[visualCluster];
  },

  /**
   * @protected
   */
  positionGroup: function (group) {
    var model = this.visualMapModel;
    var api = this.api;
    layout.positionElement(group, model.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
  },

  /**
   * @protected
   * @abstract
   */
  doRender: zrUtil.noop
});

module.exports = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;

/**
 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
 * @param {module:echarts/ExtensionAPI} api
 * @param {Array.<number>} itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */
function getItemAlign(visualMapModel, api, itemSize) {
  var modelOption = visualMapModel.option;
  var itemAlign = modelOption.align;

  if (itemAlign != null && itemAlign !== 'auto') {
    return itemAlign;
  } // Auto decision align.


  var ecSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
  var reals = paramsSet[realIndex];
  var fakeValue = [0, null, 10];
  var layoutInput = {};

  for (var i = 0; i < 3; i++) {
    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
  }

  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */


function convertDataIndex(batch) {
  zrUtil.each(batch || [], function (batchItem) {
    if (batch.dataIndex != null) {
      batch.dataIndexInside = batch.dataIndex;
      batch.dataIndex = null;
    }
  });
  return batch;
}

exports.getItemAlign = getItemAlign;
exports.convertDataIndex = convertDataIndex;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var each = zrUtil.each;

function _default(option) {
  var visualMap = option && option.visualMap;

  if (!zrUtil.isArray(visualMap)) {
    visualMap = visualMap ? [visualMap] : [];
  }

  each(visualMap, function (opt) {
    if (!opt) {
      return;
    } // rename splitList to pieces


    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
      opt.pieces = opt.splitList;
      delete opt.splitList;
    }

    var pieces = opt.pieces;

    if (pieces && zrUtil.isArray(pieces)) {
      each(pieces, function (piece) {
        if (zrUtil.isObject(piece)) {
          if (has(piece, 'start') && !has(piece, 'min')) {
            piece.min = piece.start;
          }

          if (has(piece, 'end') && !has(piece, 'max')) {
            piece.max = piece.end;
          }
        }
      });
    }
  });
}

function has(obj, name) {
  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}

module.exports = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32);

Component.registerSubTypeDefaulter('visualMap', function (option) {
  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var visualSolution = __webpack_require__(197);

var VisualMapping = __webpack_require__(105);

echarts.registerVisual(echarts.PRIORITY.VISUAL.COMPONENT, function (ecModel) {
  ecModel.eachComponent('visualMap', function (visualMapModel) {
    processSingleVisualMap(visualMapModel, ecModel);
  });
  prepareVisualMeta(ecModel);
});

function processSingleVisualMap(visualMapModel, ecModel) {
  visualMapModel.eachTargetSeries(function (seriesModel) {
    var data = seriesModel.getData();
    visualSolution.applyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, data, visualMapModel.getValueState, visualMapModel, visualMapModel.getDataDimension(data));
  });
} // Only support color.


function prepareVisualMeta(ecModel) {
  ecModel.eachSeries(function (seriesModel) {
    var data = seriesModel.getData();
    var visualMetaList = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      if (visualMapModel.isTargetSeries(seriesModel)) {
        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
          stops: [],
          outerColors: []
        };
        visualMeta.dimension = visualMapModel.getDataDimension(data);
        visualMetaList.push(visualMeta);
      }
    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));

    seriesModel.getData().setVisual('visualMeta', visualMetaList);
  });
} // FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity


function getColorVisual(seriesModel, visualMapModel, value, valueState) {
  var mappings = visualMapModel.targetVisuals[valueState];
  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
  var resultVisual = {
    color: seriesModel.getData().getVisual('color') // default color.

  };

  for (var i = 0, len = visualTypes.length; i < len; i++) {
    var type = visualTypes[i];
    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
    mapping && mapping.applyVisual(value, getVisual, setVisual);
  }

  return resultVisual.color;

  function getVisual(key) {
    return resultVisual[key];
  }

  function setVisual(key, value) {
    resultVisual[key] = value;
  }
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var actionInfo = {
  type: 'selectDataRange',
  event: 'dataRangeSelected',
  // FIXME use updateView appears wrong
  update: 'update'
};
echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'visualMap',
    query: payload
  }, function (model) {
    model.setSelected(payload.selected);
  });
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var vector = __webpack_require__(19);

var matrix = __webpack_require__(53);

var BoundingRect = __webpack_require__(26);

var Transformable = __webpack_require__(323);

/**
 * Simple view coordinate system
 * Mapping given x, y to transformd view x, y
 */
var v2ApplyTransform = vector.applyTransform; // Dummy transform node

function TransformDummy() {
  Transformable.call(this);
}

zrUtil.mixin(TransformDummy, Transformable);

function View(name) {
  /**
   * @type {string}
   */
  this.name = name;
  /**
   * @type {Object}
   */

  this.zoomLimit;
  Transformable.call(this);
  this._roamTransform = new TransformDummy();
  this._viewTransform = new TransformDummy();
  this._center;
  this._zoom;
}

View.prototype = {
  constructor: View,
  type: 'view',

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Set bounding rect
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  // PENDING to getRect
  setBoundingRect: function (x, y, width, height) {
    this._rect = new BoundingRect(x, y, width, height);
    return this._rect;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  // PENDING to getRect
  getBoundingRect: function () {
    return this._rect;
  },

  /**
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  setViewRect: function (x, y, width, height) {
    this.transformTo(x, y, width, height);
    this._viewRect = new BoundingRect(x, y, width, height);
  },

  /**
   * Transformed to particular position and size
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var viewTransform = this._viewTransform;
    viewTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    viewTransform.decomposeTransform();

    this._updateTransform();
  },

  /**
   * Set center of view
   * @param {Array.<number>} [centerCoord]
   */
  setCenter: function (centerCoord) {
    if (!centerCoord) {
      return;
    }

    this._center = centerCoord;

    this._updateCenterAndZoom();
  },

  /**
   * @param {number} zoom
   */
  setZoom: function (zoom) {
    zoom = zoom || 1;
    var zoomLimit = this.zoomLimit;

    if (zoomLimit) {
      if (zoomLimit.max != null) {
        zoom = Math.min(zoomLimit.max, zoom);
      }

      if (zoomLimit.min != null) {
        zoom = Math.max(zoomLimit.min, zoom);
      }
    }

    this._zoom = zoom;

    this._updateCenterAndZoom();
  },

  /**
   * Get default center without roam
   */
  getDefaultCenter: function () {
    // Rect before any transform
    var rawRect = this.getBoundingRect();
    var cx = rawRect.x + rawRect.width / 2;
    var cy = rawRect.y + rawRect.height / 2;
    return [cx, cy];
  },
  getCenter: function () {
    return this._center || this.getDefaultCenter();
  },
  getZoom: function () {
    return this._zoom || 1;
  },

  /**
   * @return {Array.<number}
   */
  getRoamTransform: function () {
    return this._roamTransform;
  },
  _updateCenterAndZoom: function () {
    // Must update after view transform updated
    var viewTransformMatrix = this._viewTransform.getLocalTransform();

    var roamTransform = this._roamTransform;
    var defaultCenter = this.getDefaultCenter();
    var center = this.getCenter();
    var zoom = this.getZoom();
    center = vector.applyTransform([], center, viewTransformMatrix);
    defaultCenter = vector.applyTransform([], defaultCenter, viewTransformMatrix);
    roamTransform.origin = center;
    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
    roamTransform.scale = [zoom, zoom];

    this._updateTransform();
  },

  /**
   * Update transform from roam and mapLocation
   * @private
   */
  _updateTransform: function () {
    var roamTransform = this._roamTransform;
    var viewTransform = this._viewTransform;
    viewTransform.parent = roamTransform;
    roamTransform.updateTransform();
    viewTransform.updateTransform();
    viewTransform.transform && matrix.copy(this.transform || (this.transform = []), viewTransform.transform);

    if (this.transform) {
      this.invTransform = this.invTransform || [];
      matrix.invert(this.invTransform, this.transform);
    } else {
      this.invTransform = null;
    }

    this.decomposeTransform();
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getViewRect: function () {
    return this._viewRect;
  },

  /**
   * Get view rect after roam transform
   * @return {module:zrender/core/BoundingRect}
   */
  getViewRectAfterRoam: function () {
    var rect = this.getBoundingRect().clone();
    rect.applyTransform(this.transform);
    return rect;
  },

  /**
   * Convert a single (lon, lat) data item to (x, y) point.
   * @param {Array.<number>} data
   * @return {Array.<number>}
   */
  dataToPoint: function (data) {
    var transform = this.transform;
    return transform ? v2ApplyTransform([], data, transform) : [data[0], data[1]];
  },

  /**
   * Convert a (x, y) point to (lon, lat) data
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToData: function (point) {
    var invTransform = this.invTransform;
    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
  },

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),

  /**
   * @implements
   * see {module:echarts/CoodinateSystem}
   */
  containPoint: function (point) {
    return this.getViewRectAfterRoam().contain(point[0], point[1]);
  }
  /**
   * @return {number}
   */
  // getScalarScale: function () {
  //     // Use determinant square root of transform to mutiply scalar
  //     var m = this.transform;
  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
  //     return det;
  // }

};
zrUtil.mixin(View, Transformable);

function doConvert(methodName, ecModel, finder, value) {
  var seriesModel = finder.seriesModel;
  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.

  return coordSys === this ? coordSys[methodName](value) : null;
}

var _default = View;
module.exports = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var defaultOption = {
  show: true,
  zlevel: 0,
  // 一级层叠
  z: 0,
  // 二级层叠
  // 反向坐标轴
  inverse: false,
  // 坐标轴名字，默认为空
  name: '',
  // 坐标轴名字位置，支持'start' | 'middle' | 'end'
  nameLocation: 'end',
  // 坐标轴名字旋转，degree。
  nameRotate: null,
  // Adapt to axis rotate, when nameLocation is 'middle'.
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // 坐标轴文字样式，默认取全局样式
  nameTextStyle: {},
  // 文字与轴线距离
  nameGap: 15,
  silent: false,
  // Default false to support tooltip.
  triggerEvent: false,
  // Default false to avoid legacy user event listener fail.
  tooltip: {
    show: false
  },
  axisPointer: {},
  // 坐标轴线
  axisLine: {
    // 默认显示，属性show控制显示与否
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    // 属性lineStyle控制线条样式
    lineStyle: {
      color: '#333',
      width: 1,
      type: 'solid'
    },
    // 坐标轴两端的箭头
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  // 坐标轴小标记
  axisTick: {
    // 属性show控制显示与否，默认显示
    show: true,
    // 控制小标记是否在grid里
    inside: false,
    // 属性length控制线长
    length: 5,
    // 属性lineStyle控制线条样式
    lineStyle: {
      width: 1
    }
  },
  // 坐标轴文本标签，详见axis.axisLabel
  axisLabel: {
    show: true,
    // 控制文本标签是否在grid里
    inside: false,
    rotate: 0,
    showMinLabel: null,
    // true | false | null (auto)
    showMaxLabel: null,
    // true | false | null (auto)
    margin: 8,
    // formatter: null,
    // 其余属性默认使用全局文本样式，详见TEXTSTYLE
    fontSize: 12
  },
  // 分隔线
  splitLine: {
    // 默认显示，属性show控制显示与否
    show: true,
    // 属性lineStyle（详见lineStyle）控制线条样式
    lineStyle: {
      color: ['#ccc'],
      width: 1,
      type: 'solid'
    }
  },
  // 分隔区域
  splitArea: {
    // 默认不显示，属性show控制显示与否
    show: false,
    // 属性areaStyle（详见areaStyle）控制区域样式
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};
var axisDefault = {};
axisDefault.categoryAxis = zrUtil.merge({
  // 类目起始和结束两端空白策略
  boundaryGap: true,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  // 坐标轴小标记
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  // 坐标轴文本标签，详见axis.axisLabel
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
axisDefault.valueAxis = zrUtil.merge({
  // 数值起始和结束两端空白策略
  boundaryGap: [0, 0],
  // 最小值, 设置成 'dataMin' 则从数据中计算最小值
  // min: null,
  // 最大值，设置成 'dataMax' 则从数据中计算最大值
  // max: null,
  // Readonly prop, specifies start value of the range when using data zoom.
  // rangeStart: null
  // Readonly prop, specifies end value of the range when using data zoom.
  // rangeEnd: null
  // 脱离0值比例，放大聚焦到最终_min，_max区间
  // scale: false,
  // 分割段数，默认为5
  splitNumber: 5 // Minimum interval
  // minInterval: null
  // maxInterval: null

}, defaultOption); // FIXME

axisDefault.timeAxis = zrUtil.defaults({
  scale: true,
  min: 'dataMin',
  max: 'dataMax'
}, axisDefault.valueAxis);
axisDefault.logAxis = zrUtil.defaults({
  scale: true,
  logBase: 10
}, axisDefault.valueAxis);
var _default = axisDefault;
module.exports = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var axisModelCreator = __webpack_require__(192);

var axisModelCommonMixin = __webpack_require__(116);

var AxisModel = ComponentModel.extend({
  type: 'cartesian2dAxis',

  /**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */
  axis: null,

  /**
   * @override
   */
  init: function () {
    AxisModel.superApply(this, 'init', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  mergeOption: function () {
    AxisModel.superApply(this, 'mergeOption', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  restoreData: function () {
    AxisModel.superApply(this, 'restoreData', arguments);
    this.resetRange();
  },

  /**
   * @override
   * @return {module:echarts/model/Component}
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'grid',
      index: this.option.gridIndex,
      id: this.option.gridId
    })[0];
  }
});

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  // Offset is for multiple axis on the same position
  offset: 0
};
axisModelCreator('x', AxisModel, getAxisType, extraOption);
axisModelCreator('y', AxisModel, getAxisType, extraOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(26);

var bbox = __webpack_require__(320);

var vec2 = __webpack_require__(19);

var polygonContain = __webpack_require__(686);

/**
 * @module echarts/coord/geo/Region
 */

/**
 * @param {string} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */
function Region(name, geometries, cp) {
  /**
   * @type {string}
   * @readOnly
   */
  this.name = name;
  /**
   * @type {Array.<Array>}
   * @readOnly
   */

  this.geometries = geometries;

  if (!cp) {
    var rect = this.getBoundingRect();
    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  } else {
    cp = [cp[0], cp[1]];
  }
  /**
   * @type {Array.<number>}
   */


  this.center = cp;
}

Region.prototype = {
  constructor: Region,
  properties: null,

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    var rect = this._rect;

    if (rect) {
      return rect;
    }

    var MAX_NUMBER = Number.MAX_VALUE;
    var min = [MAX_NUMBER, MAX_NUMBER];
    var max = [-MAX_NUMBER, -MAX_NUMBER];
    var min2 = [];
    var max2 = [];
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon
      if (geometries[i].type !== 'polygon') {
        continue;
      } // Doesn't consider hole


      var exterior = geometries[i].exterior;
      bbox.fromPoints(exterior, min2, max2);
      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      if (polygonContain.contain(exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (polygonContain.contain(interiors[k])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  },
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new BoundingRect(x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      for (var p = 0; p < exterior.length; p++) {
        vec2.applyTransform(exterior[p], exterior[p], transform);
      }

      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
        for (var p = 0; p < interiors[h].length; p++) {
          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }
};
var _default = Region;
module.exports = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Region = __webpack_require__(482);

/**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */
function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var encodeScale = json.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = json.features;

  for (var f = 0; f < features.length; f++) {
    var feature = features[f];
    var geometry = feature.geometry;
    var coordinates = geometry.coordinates;
    var encodeOffsets = geometry.encodeOffsets;

    for (var c = 0; c < coordinates.length; c++) {
      var coordinate = coordinates[c];

      if (geometry.type === 'Polygon') {
        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
      } else if (geometry.type === 'MultiPolygon') {
        for (var c2 = 0; c2 < coordinate.length; c2++) {
          var polygon = coordinate[c2];
          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
        }
      }
    }
  } // Has been decoded


  json.UTF8Encoding = false;
  return json;
}

function decodePolygon(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}
/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @return {module:zrender/container/Group}
 */


function _default(geoJson) {
  decode(geoJson);
  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var coordinates = geo.coordinates;
    var geometries = [];

    if (geo.type === 'Polygon') {
      geometries.push({
        type: 'polygon',
        // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).
        exterior: coordinates[0],
        interiors: coordinates.slice(1)
      });
    }

    if (geo.type === 'MultiPolygon') {
      zrUtil.each(coordinates, function (item) {
        if (item[0]) {
          geometries.push({
            type: 'polygon',
            exterior: item[0],
            interiors: item.slice(1)
          });
        }
      });
    }

    var region = new Region(properties.name, geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

module.exports = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Parallel = __webpack_require__(1580);

var CoordinateSystem = __webpack_require__(66);

/**
 * Parallel coordinate system creater.
 */
function create(ecModel, api) {
  var coordSysList = [];
  ecModel.eachComponent('parallel', function (parallelModel, idx) {
    var coordSys = new Parallel(parallelModel, ecModel, api);
    coordSys.name = 'parallel_' + idx;
    coordSys.resize(parallelModel, api);
    parallelModel.coordinateSystem = coordSys;
    coordSys.model = parallelModel;
    coordSysList.push(coordSys);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'parallel') {
      var parallelModel = ecModel.queryComponents({
        mainType: 'parallel',
        index: seriesModel.get('parallelIndex'),
        id: seriesModel.get('parallelId')
      })[0];
      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
    }
  });
  return coordSysList;
}

CoordinateSystem.register('parallel', {
  create: create
});

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Model = __webpack_require__(29);

var List = __webpack_require__(31);

var linkList = __webpack_require__(486);

var completeDimensions = __webpack_require__(58);

/**
 * Tree data structure
 *
 * @module echarts/data/Tree
 */

/**
 * @constructor module:echarts/data/Tree~TreeNode
 * @param {string} name
 * @param {module:echarts/data/Tree} hostTree
 */
var TreeNode = function (name, hostTree) {
  /**
   * @type {string}
   */
  this.name = name || '';
  /**
   * Depth of node
   *
   * @type {number}
   * @readOnly
   */

  this.depth = 0;
  /**
   * Height of the subtree rooted at this node.
   * @type {number}
   * @readOnly
   */

  this.height = 0;
  /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */

  this.parentNode = null;
  /**
   * Reference to list item.
   * Do not persistent dataIndex outside,
   * besause it may be changed by list.
   * If dataIndex -1,
   * this node is logical deleted (filtered) in list.
   *
   * @type {Object}
   * @readOnly
   */

  this.dataIndex = -1;
  /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @readOnly
   */

  this.children = [];
  /**
   * @type {Array.<module:echarts/data/Tree~TreeNode>}
   * @pubilc
   */

  this.viewChildren = [];
  /**
   * @type {moduel:echarts/data/Tree}
   * @readOnly
   */

  this.hostTree = hostTree;
};

TreeNode.prototype = {
  constructor: TreeNode,

  /**
   * The node is removed.
   * @return {boolean} is removed.
   */
  isRemoved: function () {
    return this.dataIndex < 0;
  },

  /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb If in preorder and return false,
   *                      its subtree will not be visited.
   * @param {Object} [context]
   */
  eachNode: function (options, cb, context) {
    if (typeof options === 'function') {
      context = cb;
      cb = options;
      options = null;
    }

    options = options || {};

    if (zrUtil.isString(options)) {
      options = {
        order: options
      };
    }

    var order = options.order || 'preorder';
    var children = this[options.attr || 'children'];
    var suppressVisitSub;
    order === 'preorder' && (suppressVisitSub = cb.call(context, this));

    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
      children[i].eachNode(options, cb, context);
    }

    order === 'postorder' && cb.call(context, this);
  },

  /**
   * Update depth and height of this subtree.
   *
   * @param  {number} depth
   */
  updateDepthAndHeight: function (depth) {
    var height = 0;
    this.depth = depth;

    for (var i = 0; i < this.children.length; i++) {
      var child = this.children[i];
      child.updateDepthAndHeight(depth + 1);

      if (child.height > height) {
        height = child.height;
      }
    }

    this.height = height + 1;
  },

  /**
   * @param  {string} id
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeById: function (id) {
    if (this.getId() === id) {
      return this;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].getNodeById(id);

      if (res) {
        return res;
      }
    }
  },

  /**
   * @param {module:echarts/data/Tree~TreeNode} node
   * @return {boolean}
   */
  contains: function (node) {
    if (node === this) {
      return true;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].contains(node);

      if (res) {
        return res;
      }
    }
  },

  /**
   * @param {boolean} includeSelf Default false.
   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
   */
  getAncestors: function (includeSelf) {
    var ancestors = [];
    var node = includeSelf ? this : this.parentNode;

    while (node) {
      ancestors.push(node);
      node = node.parentNode;
    }

    ancestors.reverse();
    return ancestors;
  },

  /**
   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
   * @return {number} Value.
   */
  getValue: function (dimension) {
    var data = this.hostTree.data;
    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
  },

  /**
   * @param {Object} layout
   * @param {boolean=} [merge=false]
   */
  setLayout: function (layout, merge) {
    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
  },

  /**
   * @return {Object} layout
   */
  getLayout: function () {
    return this.hostTree.data.getItemLayout(this.dataIndex);
  },

  /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var hostTree = this.hostTree;
    var itemModel = hostTree.data.getItemModel(this.dataIndex);
    var levelModel = this.getLevelModel();
    var leavesModel;

    if (!levelModel && (this.children.length === 0 || this.children.length !== 0 && this.isExpand === false)) {
      leavesModel = this.getLeavesModel();
    }

    return itemModel.getModel(path, (levelModel || leavesModel || hostTree.hostModel).getModel(path));
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getLevelModel: function () {
    return (this.hostTree.levelModels || [])[this.depth];
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getLeavesModel: function () {
    return this.hostTree.leavesModel;
  },

  /**
   * @example
   *  setItemVisual('color', color);
   *  setItemVisual({
   *      'color': color
   *  });
   */
  setVisual: function (key, value) {
    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
  },

  /**
   * Get item visual
   */
  getVisual: function (key, ignoreParent) {
    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
  },

  /**
   * @public
   * @return {number}
   */
  getRawIndex: function () {
    return this.hostTree.data.getRawIndex(this.dataIndex);
  },

  /**
   * @public
   * @return {string}
   */
  getId: function () {
    return this.hostTree.data.getId(this.dataIndex);
  }
};
/**
 * @constructor
 * @alias module:echarts/data/Tree
 * @param {module:echarts/model/Model} hostModel
 * @param {Array.<Object>} levelOptions
 * @param {Object} leavesOption
 */

function Tree(hostModel, levelOptions, leavesOption) {
  /**
   * @type {module:echarts/data/Tree~TreeNode}
   * @readOnly
   */
  this.root;
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.data;
  /**
   * Index of each item is the same as the raw index of coresponding list item.
   * @private
   * @type {Array.<module:echarts/data/Tree~TreeNode}
   */

  this._nodes = [];
  /**
   * @private
   * @readOnly
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
  /**
   * @private
   * @readOnly
   * @type {Array.<module:echarts/model/Model}
   */

  this.levelModels = zrUtil.map(levelOptions || [], function (levelDefine) {
    return new Model(levelDefine, hostModel, hostModel.ecModel);
  });
  this.leavesModel = new Model(leavesOption || {}, hostModel, hostModel.ecModel);
}

Tree.prototype = {
  constructor: Tree,
  type: 'tree',

  /**
   * Travel this subtree (include this node).
   * Usage:
   *    node.eachNode(function () { ... }); // preorder
   *    node.eachNode('preorder', function () { ... }); // preorder
   *    node.eachNode('postorder', function () { ... }); // postorder
   *    node.eachNode(
   *        {order: 'postorder', attr: 'viewChildren'},
   *        function () { ... }
   *    ); // postorder
   *
   * @param {(Object|string)} options If string, means order.
   * @param {string=} options.order 'preorder' or 'postorder'
   * @param {string=} options.attr 'children' or 'viewChildren'
   * @param {Function} cb
   * @param {Object}   [context]
   */
  eachNode: function (options, cb, context) {
    this.root.eachNode(options, cb, context);
  },

  /**
   * @param {number} dataIndex
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeByDataIndex: function (dataIndex) {
    var rawIndex = this.data.getRawIndex(dataIndex);
    return this._nodes[rawIndex];
  },

  /**
   * @param {string} name
   * @return {module:echarts/data/Tree~TreeNode}
   */
  getNodeByName: function (name) {
    return this.root.getNodeByName(name);
  },

  /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */
  update: function () {
    var data = this.data;
    var nodes = this._nodes;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }
  },

  /**
   * Clear all layouts
   */
  clearLayouts: function () {
    this.data.clearItemLayouts();
  }
};
/**
 * data node format:
 * {
 *     name: ...
 *     value: ...
 *     children: [
 *         {
 *             name: ...
 *             value: ...
 *             children: ...
 *         },
 *         ...
 *     ]
 * }
 *
 * @static
 * @param {Object} dataRoot Root node.
 * @param {module:echarts/model/Model} hostModel
 * @param {Object} treeOptions
 * @param {Array.<Object>} treeOptions.levels
 * @param {Array.<Object>} treeOptions.leaves
 * @return module:echarts/data/Tree
 */

Tree.createTree = function (dataRoot, hostModel, treeOptions) {
  var tree = new Tree(hostModel, treeOptions.levels, treeOptions.leaves);
  var listData = [];
  var dimMax = 1;
  buildHierarchy(dataRoot);

  function buildHierarchy(dataNode, parentNode) {
    var value = dataNode.value;
    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
    listData.push(dataNode);
    var node = new TreeNode(dataNode.name, tree);
    parentNode ? addChild(node, parentNode) : tree.root = node;

    tree._nodes.push(node);

    var children = dataNode.children;

    if (children) {
      for (var i = 0; i < children.length; i++) {
        buildHierarchy(children[i], node);
      }
    }
  }

  tree.root.updateDepthAndHeight(0);
  var dimensions = completeDimensions([{
    name: 'value'
  }], listData, {
    dimCount: dimMax
  });
  var list = new List(dimensions, hostModel);
  list.initData(listData);
  linkList({
    mainData: list,
    struct: tree,
    structAttr: 'tree'
  });
  tree.update();
  return tree;
};
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 *
 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
 */


function addChild(child, node) {
  var children = node.children;

  if (child.parentNode === node) {
    return;
  }

  children.push(child);
  child.parentNode = node;
}

var _default = Tree;
module.exports = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * Link lists and struct (graph or tree)
 */
var each = zrUtil.each;
var DATAS = '\0__link_datas';
var MAIN_DATA = '\0__link_mainData'; // Caution:
// In most case, either list or its shallow clones (see list.cloneShallow)
// is active in echarts process. So considering heap memory consumption,
// we do not clone tree or graph, but share them among list and its shallow clones.
// But in some rare case, we have to keep old list (like do animation in chart). So
// please take care that both the old list and the new list share the same tree/graph.

/**
 * @param {Object} opt
 * @param {module:echarts/data/List} opt.mainData
 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
 * @param {Object} [opt.datas] {dataType: data},
 *                 like: {node: nodeList, edge: edgeList}.
 *                 Should contain mainData.
 * @param {Object} [opt.datasAttr] {dataType: attr},
 *                 designation: struct[datasAttr[dataType]] = list;
 */

function linkList(opt) {
  var mainData = opt.mainData;
  var datas = opt.datas;

  if (!datas) {
    datas = {
      main: mainData
    };
    opt.datasAttr = {
      main: 'data'
    };
  }

  opt.datas = opt.mainData = null;
  linkAll(mainData, datas, opt); // Porxy data original methods.

  each(datas, function (data) {
    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
    });
  }); // Beyond transfer, additional features should be added to `cloneShallow`.

  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
  // another changable methods, which may bring about dead lock.

  each(mainData.CHANGABLE_METHODS, function (methodName) {
    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
  }); // Make sure datas contains mainData.

  zrUtil.assert(datas[mainData.dataType] === mainData);
}

function transferInjection(opt, res) {
  if (isMainData(this)) {
    // Transfer datas to new main data.
    var datas = zrUtil.extend({}, this[DATAS]);
    datas[this.dataType] = res;
    linkAll(res, datas, opt);
  } else {
    // Modify the reference in main data to point newData.
    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
  }

  return res;
}

function changeInjection(opt, res) {
  opt.struct && opt.struct.update(this);
  return res;
}

function cloneShallowInjection(opt, res) {
  // cloneShallow, which brings about some fragilities, may be inappropriate
  // to be exposed as an API. So for implementation simplicity we can make
  // the restriction that cloneShallow of not-mainData should not be invoked
  // outside, but only be invoked here.
  each(res[DATAS], function (data, dataType) {
    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
  });
  return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param {string} [dataType] If not specified, return mainData.
 * @return {module:echarts/data/List}
 */


function getLinkedData(dataType) {
  var mainData = this[MAIN_DATA];
  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
}

function isMainData(data) {
  return data[MAIN_DATA] === data;
}

function linkAll(mainData, datas, opt) {
  mainData[DATAS] = {};
  each(datas, function (data, dataType) {
    linkSingle(data, dataType, mainData, opt);
  });
}

function linkSingle(data, dataType, mainData, opt) {
  mainData[DATAS][dataType] = data;
  data[MAIN_DATA] = mainData;
  data.dataType = dataType;

  if (opt.struct) {
    data[opt.structAttr] = opt.struct;
    opt.struct[opt.datasAttr[dataType]] = data;
  } // Supplement method.


  data.getLinkedData = getLinkedData;
}

var _default = linkList;
module.exports = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var zrender = __webpack_require__(215);

exports.zrender = zrender;

var matrix = __webpack_require__(53);

exports.matrix = matrix;

var vector = __webpack_require__(19);

exports.vector = vector;

var zrUtil = __webpack_require__(0);

var colorTool = __webpack_require__(78);

exports.color = colorTool;

var graphic = __webpack_require__(5);

exports.graphic = graphic;

var numberUtil = __webpack_require__(8);

exports.number = numberUtil;

var formatUtil = __webpack_require__(21);

exports.format = formatUtil;

var _throttle = __webpack_require__(104);

var throttle = _throttle.throttle;
exports.throttle = _throttle.throttle;

var ecHelper = __webpack_require__(1599);

exports.helper = ecHelper;

var _List = __webpack_require__(31);

exports.List = _List;

var _Model = __webpack_require__(29);

exports.Model = _Model;

var _Axis = __webpack_require__(86);

exports.Axis = _Axis;

var _env = __webpack_require__(33);

exports.env = _env;

var _parseGeoJson = __webpack_require__(483);

exports.parseGeoJson = _parseGeoJson;

/**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */
var ecUtil = {};
zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
  ecUtil[name] = zrUtil[name];
});
exports.util = ecUtil;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var _clazz = __webpack_require__(75);

var set = _clazz.set;
var get = _clazz.get;
var _default = {
  clearColorPalette: function () {
    set(this, 'colorIdx', 0);
    set(this, 'colorNameMap', {});
  },
  getColorFromPalette: function (name, scope) {
    scope = scope || this;
    var colorIdx = get(scope, 'colorIdx') || 0;
    var colorNameMap = get(scope, 'colorNameMap') || set(scope, 'colorNameMap', {}); // Use `hasOwnProperty` to avoid conflict with Object.prototype.

    if (colorNameMap.hasOwnProperty(name)) {
      return colorNameMap[name];
    }

    var colorPalette = this.get('color', true) || [];

    if (!colorPalette.length) {
      return;
    }

    var color = colorPalette[colorIdx];

    if (name) {
      colorNameMap[name] = color;
    }

    set(scope, 'colorIdx', (colorIdx + 1) % colorPalette.length);
    return color;
  }
};
module.exports = _default;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var numberUtil = __webpack_require__(8);

/**
 * For testable.
 */
var roundNumber = numberUtil.round;
/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = numberUtil.nice(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
/**
 * @param {number} interval
 * @return {number} interval precision
 */


function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return numberUtil.getPrecisionSafe(interval) + 2;
}

function clamp(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp(niceTickExtent, 0, extent);
  clamp(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}

function intervalScaleGetTicks(interval, extent, niceTickExtent, intervalPrecision) {
  var ticks = []; // If interval is 0, return [];

  if (!interval) {
    return ticks;
  } // Consider this case: using dataZoom toolbox, zoom and zoom.


  var safeLimit = 10000;

  if (extent[0] < niceTickExtent[0]) {
    ticks.push(extent[0]);
  }

  var tick = niceTickExtent[0];

  while (tick <= niceTickExtent[1]) {
    ticks.push(tick); // Avoid rounding error

    tick = roundNumber(tick + interval, intervalPrecision);

    if (tick === ticks[ticks.length - 1]) {
      // Consider out of safe float point, e.g.,
      // -3711126.9907707 + 2e-10 === -3711126.9907707
      break;
    }

    if (ticks.length > safeLimit) {
      return [];
    }
  } // Consider this case: the last item of ticks is smaller
  // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


  if (extent[1] > (ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1])) {
    ticks.push(extent[1]);
  }

  return ticks;
}

exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
exports.getIntervalPrecision = getIntervalPrecision;
exports.fixExtent = fixExtent;
exports.intervalScaleGetTicks = intervalScaleGetTicks;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * nest helper used to group by the array.
 * can specified the keys and sort the keys.
 */
function nest() {
  var keysFunction = [];
  var sortKeysFunction = [];
  /**
   * map an Array into the mapObject.
   * @param {Array} array
   * @param {number} depth
   */

  function map(array, depth) {
    if (depth >= keysFunction.length) {
      return array;
    }

    var i = -1;
    var n = array.length;
    var keyFunction = keysFunction[depth++];
    var mapObject = {};
    var valuesByKey = {};

    while (++i < n) {
      var keyValue = keyFunction(array[i]);
      var values = valuesByKey[keyValue];

      if (values) {
        values.push(array[i]);
      } else {
        valuesByKey[keyValue] = [array[i]];
      }
    }

    zrUtil.each(valuesByKey, function (value, key) {
      mapObject[key] = map(value, depth);
    });
    return mapObject;
  }
  /**
   * transform the Map Object to multidimensional Array
   * @param {Object} map
   * @param {number} depth
   */


  function entriesMap(mapObject, depth) {
    if (depth >= keysFunction.length) {
      return mapObject;
    }

    var array = [];
    var sortKeyFunction = sortKeysFunction[depth++];
    zrUtil.each(mapObject, function (value, key) {
      array.push({
        key: key,
        values: entriesMap(value, depth)
      });
    });

    if (sortKeyFunction) {
      return array.sort(function (a, b) {
        return sortKeyFunction(a.key, b.key);
      });
    } else {
      return array;
    }
  }

  return {
    /**
     * specified the key to groupby the arrays.
     * users can specified one more keys.
     * @param {Function} d
     */
    key: function (d) {
      keysFunction.push(d);
      return this;
    },

    /**
     * specified the comparator to sort the keys
     * @param {Function} order
     */
    sortKeys: function (order) {
      sortKeysFunction[keysFunction.length - 1] = order;
      return this;
    },

    /**
     * the array to be grouped by.
     * @param {Array} array
     */
    entries: function (array) {
      return entriesMap(map(array, 0), 0);
    }
  };
}

module.exports = nest;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * @file Visual mapping.
 */
var visualDefault = {
  /**
   * @public
   */
  get: function (visualType, key, isCategory) {
    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
  }
};
var defaultOption = {
  color: {
    active: ['#006edd', '#e0ffff'],
    inactive: ['rgba(0,0,0,0)']
  },
  colorHue: {
    active: [0, 360],
    inactive: [0, 0]
  },
  colorSaturation: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  colorLightness: {
    active: [0.9, 0.5],
    inactive: [0, 0]
  },
  colorAlpha: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  opacity: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  symbol: {
    active: ['circle', 'roundRect', 'diamond'],
    inactive: ['none']
  },
  symbolSize: {
    active: [10, 50],
    inactive: [0, 0]
  }
};
var _default = visualDefault;
module.exports = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(198),
    stackClear = __webpack_require__(1743),
    stackDelete = __webpack_require__(1744),
    stackGet = __webpack_require__(1745),
    stackHas = __webpack_require__(1746),
    stackSet = __webpack_require__(1747);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(496),
    eq = __webpack_require__(204);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(502);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(500),
    toKey = __webpack_require__(203);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1687),
    isObjectLike = __webpack_require__(148);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(292),
    nativeKeys = __webpack_require__(1733);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(67),
    isKey = __webpack_require__(291),
    stringToPath = __webpack_require__(1748),
    toString = __webpack_require__(1759);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(495),
    baseAssignValue = __webpack_require__(496);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1668),
    arraySome = __webpack_require__(1677),
    cacheHas = __webpack_require__(1701);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1664),
    Map = __webpack_require__(288),
    Promise = __webpack_require__(1666),
    Set = __webpack_require__(1667),
    WeakMap = __webpack_require__(1670),
    baseGetTag = __webpack_require__(146),
    toSource = __webpack_require__(509);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(204),
    isArrayLike = __webpack_require__(147),
    isIndex = __webpack_require__(290),
    isObject = __webpack_require__(68);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1764);
var util = __webpack_require__(1763);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(300);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtAAAAHRCAIAAADMgRnzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBFMEQ5RUYyQ0IzNTExRTdCRjIxRUFGNDA5RTcwMzczIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBFMEQ5RUYzQ0IzNTExRTdCRjIxRUFGNDA5RTcwMzczIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUVENEE5N0ZDQjM0MTFFN0JGMjFFQUY0MDlFNzAzNzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUVENEE5ODBDQjM0MTFFN0JGMjFFQUY0MDlFNzAzNzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Ej4/xAAAerklEQVR42uzdiXLa2OLgYYSEBF6zdHJvddW8yzzdPOdUTf3vku4s3hDa52ASQmzsAMY2Nt9X7pTbFiQlY/hxdHQU/e//8397AACPqW8XAACCAwAQHAAAggMAEBwAwOuX2AVPoG7bcVGve6ssibNBbO8BIDhYSdN0Z3m17q1ORz3BAcDr4JAKAPDojHA8hWwQ/693h/YDAIKDx/XpPC/qdq2baBQAXg2HVAAAwQEACA4AAMEBAAiOvTFKf87PTeN+FC3ZJkv6C9tbgQMAwcGaQmTMP39zkC7+79zHk9HS7QFAcAAACA4AQHDsobJZvgJY3bZ2DgCCg83F8c9pol3XLd2maX5+PVo6rRQABAf3SPrr7WqTRgEQHDxUmtzc84tDIAAgONjGfr91xCRxDAUAwQEAIDgAAMHBguqO02Lbzr4BQHDwMPMTT5o7yqJqmvnn5pAC8JokdsGTWWtW6Lqn0QLsmrbr/r6YFPUOLWkY3sv9cTS07sCzsNMBeBRfr4qdqo3e9fqK53npRyM4AHg9mp2cmNaaLvdMHFKBnXke7Lrqkd8OZoPYfgYEB+x1bfx1Prnrwn7bcpDG74+G9jbw9BxSeQZd1xvEN99o9vtOS9lrl5PqsWsjGJdNUTX2NvD0jHA8nTTpz+ZPhdeV23WRxv3Jj1cC58QCzJ4Mw3Pj/KSSqmnrpnuCNEdwvGz9lc+LdV2VPffuMDvMtvm7+flyMi4NbPBihKfAk+HgIEuWLhBQt+24qC/LumlM/xQcwKaOh8l2ayN4fzSsz3LvC3kpvwIno/Sed2ihQsIG4eM8L8/yyh4THMAm+o8zvmXUjGd4MK85NS08Sj8cDVc/lyo0xzBNPp3nnZGOF/F4sAsAeAwhCFYv3bDlx5PRumdup3H/zzcHa817Ox6mfjTPwggHAI9iVgN3rS7zeVwsTsIItbHZiuP9aLpa+eI4x2ykZOnGIU1cOEJwAPDahBpYOmhRVM1ibZyOBg+5vkm47fvD4d+Xk9n/hvKo227rc6F46IPBLngy8UJWF/WSUwbmc/qsyQG8bpfFL5M9J9WDVogJt72Y/HKFlMuJyaQ7RwA+4b7+XUbMxwNdyRB4xdquu3GedlG3ny4mcRydDtO1RiauivpsUt4+Pza8f6vb1tETwQHA/iqq5bM6Qjd8uSq+jouT4eBoOJifsTW7zNDi9IvwlctJdf9SHHnZHA8Fh+DYe9dLm/8y4hc5bRHYD1Xzc3gjS/pxP1oc8Oi63llenU+q0SA+vl5sI//x3bDxm8NsXFSXRX37VNiDdDpZZH5X5fTI9cDeFhz7bunS5nYLsA8W16AbDuKTUfr2esQiRMY8I8InIR3GZb54w6Ju/3uW37i32bKksxGRfHqT78HRuAy94ABgn7ULKZAl8fV7sGi2eOhdczKWms35mJ5N+2OEePG9nKV1Bcf+GiSrjmHEJjoBe+kwmy7tn5fTs06K+s5iyJL+YTa4Pb108RRcy48Kjv0VGjyU+Oxg5O30rn8kf2j2URrbXcDeCs+Bo3R016VSjofJm4Ns6Q1blbHLL4J2wVN6d5hl1+Mc3a3fiqZtZ7Xxx9GwbwIpsB/umWhxcMf5saPBnW+VF1c1NTFu1xjheNq+i6KPJ6P6ui1mRy7nQmoM08RvCPDqpUl/frikappRb/mYbtLvn44GNwY5DtL4nuut1Av94o2b4KA3O5U8kRbAXlqcppaXzcnozi1PRukgjudrlof+CF+5554nVT3/fDhwbHrH3nLbBQA8pcUhitmSoPdsvDin7cbA8A1t1+UL66NfL3eE4ABgX6Vxf/GC8uOi3srd5mWzeMFYs+93jUMqL0P4JYp+9xVeh8uynjzgKlZ3sSYBO+UoTeaTM84n1UGWPPC6J23XnS1cv23keIrgYDPRCl/hBQlPjl+uisXlj+YLNTdN1/Qe8dS+b+NycTJdmvTvOsMQHjE4hoP5uqLhz/Cw/ONo+JA7PM9/WS7s9CC1kwUHML12dl42z/JX3xjqKOpWcPD0pkuLDn+egRJ+HUIx3D8h9B5XRX0x+Xlc5iCNXSd2F3/odgEAT+9oOFhcCCDEx8Wk2qw2vlwV8/+Not7bQw0tOIDvz4mOibH3Lz9R9PYoW/xV+DYuP19O1lot9DwvF2sj+GDtxF3lkAo8g+Ph9KrZ3Q4sw+zUQZ5RGvffHmSLxTAum6LJT4fpYfabl6eiakKg3DhEOF3N2XRRwQHcbg7Yc7OwWGyOpplOqT6blAeDeDRIbgREKIyQGhfhv1tXlA218dtMQXAAsL/NMUj6n87zxSG/0BMXzS9TQYNPF5Ol9xBFvfeHQwtv7DhzOAB4Zmnc//PNwcFGxZAl/X+ejtTG7jPCAcAOvP2NovdHw6PrwyUrnjQeUuN0lJq0ITgAYD2hHsJH3bahOYq6KZv2xlyNKJpelS1L4pHFNgQHADzolanfPx72j3vfJ1a3XVfV7SB81fmuggMAHknoDMdNXsPP0S4AAAQHACA4AAAEBwAgOAAAwQEAIDgAAMEBACA4AADBAQAIDgAAwQEACA4AQHAAAAgOAEBwAAAIDgBAcAAAggMAQHAAAIIDABAcAACCAwAQHAAAggMAEBwAgOAAABAcAIDgAAAEBwCA4AAABAcAgOAAAAQHACA4AAAEBwAgOAAAwQEAIDgAAMEBACA4AADBAQAIDgAAwQEACA4AQHAAAAgOAEBwAAAIDgBAcAAAggMAQHAAAIIDABAcAACCAwAQHAAAggMAEBwAgOAAABAcAIDgAAAEBwCA4AAABAcAgOAAAAQHACA4AAAEBwAgOAAAwQEAIDgAAMEBACA4AADBAQAIDgAAwQEA7KDkCf6OtuuKqq2aZlI1N74V96M0ibNBnMbSBwAEx0bysrkqq/DnPduMr78bx9HBID4aDpK+8gAAwbFyanzNi6bpFr+Yxv0o6qWhKaKobNq27cKf3fUmYcuLpr6Y1Adp/PYwm24HAAiOu4SC+PtiUtTt7H9DOYwG8UE6GKXx0u3rtg11Mi7qEB+96wGPvBqfjtLj4cCPBwAExxJF1fx1OZkNWoTUOBkOjoaD+4crkn7/eBg+BuG2Z3kZSiXc/Nu4LOvGUAcACI6bror6y1Ux+3yUxu/WzIVsEH8cjPKy+Xw1TZZx2dTN5MPJUHMAwEu3tRmai7Xx5iD942jDUAil8me4/fVJK2XT/nU++T7LAwDY8+AIZfB1/L023h1mD5x+EUrlw8lw3hzzjgEA9jc4prNEf8zbCLVxmG3hMM1ic+RlczGp/KgAYK+D4zwUwfXpr6ejwVZqY7E5ZodlzvKybls/LQDY0+AIHXAxqXvXa2ycjNIt/+NCcxwNwydd1zsbl35aAPBCPXRAYt4Bbw6W10bZtJNyWiRxv790/KOomqL+vhTpQZbcWGk0G8SjNJ4u1FE2p21rHVKAFyS8BMye5Nv25/T/NOkP4ulzu5MQBceq6radLUweHjehDJZu8Ok8n03vyJLlwTFft2MWHLc3CCmTl/ksbt5fD3gAsOOuivpyUs1WdLz5PnO6MmTdu+odpPHxKHUtLcHxe/OLpBxny09LaZrut+e0Lm6wdAAjfDHESniA5lXjBwaw40JkfLsq5utN32M8Hb3Oj4fJySg12vHqPagr89mxkjhaOryxRYfXQRPSpNAcADvsqqg/neer1MbcxaS25JLg+I3ZQ+rgkWujd33I5sffKDgAdrc2vlwVG5SDZR4Fx7218WOwIUuSR/9XRtHsIN/ECAfATnrgOo2z5uhdr+00nWd6/WGvviZbaIU4XunAW5osiZvPl5M1/pamJ38BdtPfKz+f39Mc/zobzxZ2mhul8WiQbHGRJ15ecMyPbqw4wXhcNeV5vviVUA9LJzAv75W4n/ea1bcH4MnMV4B8oNt3Eu44fFwV1R/HruW5r8GxwcOo6RmgAHiNwfHIF6Ao6ukBF9cPf9F26Oxnp2IDvERXRf0Ex7vnkzx4oTYf4Yh+ZGbbdSsmZxxHya0t52dPyVaAl2hS1U/zF4XmCHFjPsfeBcd8QKKq21XW4Qi18efpwY0vhlj5n6/j1R7Q0ykjWWIUBGC31M3THS4/m5SC44Xa/PV7fnLKihM5k2UjGKsfjZsN2PX7hkEAdsVVUf/rbPyU0/mbpnO67Au1eScm/WktTM80mZ6uMnjcfG7b2dTlLIn9zACeXYiMr5fFs5w5+OliYjX0l+hBRyiG10dSnuASJ/OLtmQDwQHw/LXxaXoi7LOtU2A19L0LjtFgOkASfuJXxfIZQ+2WHgwXxfSEqziOnMkC8LwWLwP+vNGjOfYoOA6z7xMzzibl0g2uyu9nZofN3hxm99zVPRtMl5O5Pp5ylJooBPDMvlwWO/Iq/8DF1HliD30JPxkOzvIqBMHSU5VORulxNn1gTk+I7S+Pm4/Hw/s3+JoXsyI5Gg78wACe0fQSJ/UOrfgc3pGGf5Kj7S/CQ49QhAiYDXJ8HRe3h7bSuB8eB+HjrpjoXU/LuGeD+XK5oWzMDwJ4XpdF5Z/E8wRHiIC3B9NDISE2/r7Y8hpwoVvP8u+zNwxvADz/iMLunZI6Lp0lux/B0bueyTFKp8NZRd1+vtxac0wnBP24t/cHmeENgOdVtzs6R9PKHPsSHMG7w2x2/kgoza00x+ycq9kjO9y543MAz65pnBLCcwfH9MDKUTYbgwjN8fflg05VystmXhsHaWwVWwAQHN+lcf/jyWg2zhGK4V/fxvn6x9VCpny+nIRemdXG8TB5fzT0QwLYBfMrWsAGtjl4EGrjw8nw74tJUU8HOEI3ZEn/eJjOZnjcr27bcVGfT6pZakRR7+1BZmwDYIdeMH5c0UIJ8czB0bs+tvLxZHQxqc7yMjwoQ3kUl5PwUDgYxFmSDJKbi20UVVM2bVE3i8MhIVPeHWX3nEkLwLMYDeJdOyvknmWceM3BMXM8HBxmyderIq+akB1N01009UWv/u0N07h/MlppRASAp3eUDXYtOI4ziybscXD0roc63h8N267Ly+aqqO5fmS70aRb3w+PY2SgAu2y6VGPS353FRqOo5+D7vgfHPDvCQ2H2aJgdPel+Pfo3iOPbx1kA2FnvjrL/nOU7MpPj/eHQKk2CY1kXG8AAeOkvG/3pOYm7cMHYd4eZQ/AviKEFANazuA7Cs4iiaW04mPLCUtUuAGCD5vjH6fScxIuieuIVSA/S+PQgdSxecACwL46Hg/AxXd2gasq6adpHLI/hII77/em4ikkbggOAPRQa4PrwitNTuY8hKQBAcAAAggMAQHAAAIIDABAcAACCAwAQHAAAggMAEBwAgOAAABAcAIDgAAAEBwCA4AAABAcAgOAAAAQHACA4AAAEBwAgOAAAwQEAIDgAAMEBACA4AADBAQAIDgAAwQEACA4AQHAAAAgOAEBwAAAIDgBAcAAAggMAYGWJXcAuK5u2qtumbcMnbdvd3mA4iKMoSuN+NojtLgDBAauq2zYvm6JuJlXTdb/ZuKjb+edZ0g/9MUyT0B92I4DggOWuivqqqBYbYi3hhuHjLK/iODrOBochQKLIXgUQHPAzNc4mZdN0W7m3cD/fxuVZXp4MB0fDgewAEBzsu7xsvubFtlJjUdf1zvLqfFKF7DgZpXY1gOBgH9Vt++Wy2PgAylrZcVnW7w8yE0sBnou5dTyPvGz+c5Y/dm3MNU336WJynpf2PMCzMMLBM/g2Li4m9dP/vWd5NamaP46HZnUACA5euc+Xk3HZrHWTOI6SKBreOiBSNm3TdOHP1e+qqNu/zicfTjQHgOBAbfR6oQdGg3g4SEZp/Ns4KKomr+px1awy+TQEyr++jT+ejCzXASA4eIWuinqV2ojj6HSYrtIZc9kgDh9vrqeGXEzKJ5saAoDgYOccZsmkuq85QmC8PcjCZhv/FSFTRumoqJpv4/KuQy3hbzG8ASA4eM3eHw17dxxVCQnw7jC7MarRdl1eNiFTmra7PW4RoiGJo+EgyQb9pP8zILJB/I/T0XlenuXV7b/ow9FQbQAIDl5/c6ST6tv4lzNUQ2rcGNgoquayqO4/BFM2bfj+bJvQK8fZYHGljZNROkyTvy8nixM7wl9kNQ4AwcFeOL5ebvzLVdFbdoBjswXB8rIJH1nSPx2l86QId/vPk9Ff55PZ4ZXbWQPA0zCwzPMIL/zh5f92bZzn5b+/5Q+5ftuni8m3cdH+uM5sKJsPJ9NjKGoD4Bl5/uU5m2PxVJSQCF+uinzNJTqWupjURdXOF9sIf/7jdGSHAzwjIxw86+NvoTb+Op9spTZmyqb9z3m+1ppgAAgOXrnLSbX1OGiablxU9i2A4IDvTkbpQbrlk0fCHb45yOxbgF1gDge74p4lOnrXZ71mSfzrySxdXtV3HYUJtTG9QwAEB6zSHCEdTg/SxXW9ZrLraadt111OqhsLfKkNAMEBqzZHFE1XBb1/na5+FM0W+Pp6WcxmgagNAMEBqzZH3XS3LyIfkqJrpwtsRP1o8fBK+Dxs/Nf5JIkjtQEgOGDV5mi7brE2zvPysqwXFymP4+goTU5G6ex/LbYBIDhgbTeW6Lh90myIj7O8ysvm9kAIADv3rG4XsOO+XBX3LNERvvX1+posAAgO2NzJKL1n/CKN+28PLbYBIDjgYUJS/PnmYHGK6OK3HE8BEBywpYfpjyu+qg0AwQFP1xxqA0BwwOM2h9oAeHGcFsvLa47ewkmzAAgOeJTmsBMAXt6zt10AAAgOAEBwAAAIDgBAcAAAggMAQHAAAIIDAEBwAACCAwAQHAAAggMAEBwAwD5wtVgAeDE+X07GZfPw+4mi3seTURo/3biDEQ4AeBkuJtVWaiPout63q+Ip//GCAwBehi5kwovlkAoAvDx/HA370SY3/DwumuYZwkVwAMDLM0rjDV/4o6jpPUNwOKQCAAgOAEBwAAAIDgBAcAAAggMA4OGcFguwXNm053nZtpufQJgm/ZNR2o8iOxMEB8ASbdd9Os8fuK5jUbehNkJz2J8gOACWqOp2Vhtp3N9shaXzSRXuYVI1JyO7EwQHwN3iOPpwMtzsmMggjv++nNiHMGPSKMDd78miaOMZGH0zN0BwADyGsmntBBAcAI/o8+Xkv2f5VVHbFSA4ADbRdt3nHxMywiezCaXfxkXdfh/SuJhUedUcD5MvVz+/CAgOgHWeK6NoOPg+yz58MpvYkSXJfIbHYZYM+v3Lon4XPut7aoWbnKUCsJIQEjc+WTxdNpTHh5NhUbWbnUMLr7/a7QKA7TyfRpHaAMEBAAgOAEBwAOyhh1xLpe3sP/jJpFGAO5VN+/flJI03eW92PqnsQBAcACvJyybvNfYDPJBDKgCA4AAABAcAgOAAAAQHACA4AAAEBwDso3bTZem6Z1qSzjocAPDy/M/X8cv6BxvhAAAEBwCwjtPRIIoEBwDwmLVxMko/nowEBwDwWM4nVdm0F3m5a/8wk0YB4PXout5/z/Id/IcJju0LaVlUTVE3bfvz3KN+P8qSOBvEm13nGgCOhoO8bMKrzFbu7TAbCI6X6qqoL6/HspZ+NzxKwp8hOMIj5jCz5wFYTz+KPpwMq3oLwRH1oyd+A+xlbztCZHy9LFapzrDNl6sidMnbo8xoBwDrNkc2iF/kv9wP7+Guivq/Z/laY1xh43CTcEN7D4C9SCW74OG18eWq2Oy24YaaAwDBwW/kZbNxbcybYza3AwBeMXM4Nle37eerydJvRVHvZDgYpslslkbZtJOyPp9USy+ZE+7kn8ko6Ys/AAQHt5yNy6UBcZDGbw+z/sK6siE70lF6NBx8vSrGt8Yzwp2Eu3p/NLRLAXitvKveUN2242WHQkJthHToL1vFPnwxfCtscPtb4a7CHdqrAAgOfnE2XrJqbJb0fztQETYIm614hwAgOPZaXi0Z3jgdpavcdulmRWOEA3ZIHG/napv9fmRnguDYUNm0t2dvhKenFRdjCZvdfi5rmq7UHLAzkn7/ePjQWW7hN/1ktfch8Pp/p+yCDYQ4WLIrozXex4SNm1635G5jexd2xZuDLHzYD7AVRjg2UTVLjqcM11lrdunGS+8WAAQHP02q5pE2BgDBwXfrXkvFHgNAcHCfeNmqoF3XW/HCKGGzpSuGxRYbBUBwMJfccZ7b2aRsl6bEgrBB2GytuwUAwbGPskG89JSUpum+/u5abmGDpSe5hDvMBs5RAUBwsGB0RxyMy+a/Z/nSdcrDF8O3xndcG3akNgB4vazDsaGjbHBXOpRN++9v+UEaDwfJ7ChJ3XaTqh7fexn6cIf2KgCCg1/MVgtdenBkJuTF/YXxy70lfcdTAHjFHFLZ3OlwaysWHxreAEBwcEclJFu5vFO4k3BX9icAgoPltjLIscWREgAQHK/Qwwc5DG8AIDj4vQeOTxjeAEBw8HsPGeQwvAGA4GBVG49SGN4AQHCwqs0GOQxvACA4WM8GYxWGNwAQHKxn3UEOwxsACA42sdaIheENAAQHm1h9kMPwBgCCg80dpckWNwMAwcGykhgOot+NcYQNwmb2FQCCg033ZhSd/C4mwgb9KLKvABAcbO7+QQ7DGwAIDraxQ+8d5DC8AYDgYDvuGuQwvAGA4GB7+/SOQQ7DGwAIDrbp9iCH4Q0ABAfb3q23BjkMbwAgONi+k1F6kMazz7OkH/7XPgFgb1ny8hG9PxoeN23XdtkgtjcAEBw8ljTu98QGAHvPIRUAQHAAAIIDAEBwAACCAwAQHAAAggMAEBwAAIIDABAcAIDgAAAQHACA4AAABAcAgOAAAAQHAIDgAAAEBwAgOIDtOM/L//fl6qqo7QpAcACP4vPl5Cyvwidfropv48IOAQQHsP3aGJfN/H8vJnX4it0CCA7gsWpjJnxFcwCCA9iO87y8XRvz5jCfAxAcwEMVVTObt3GXL1dF2bR2FCA4gM19XmFy6LcrE0gBwQFs6qqom6b77WZF3RZVY3cBggPYLDiqFbe8XHlLAMEB/KKoV52cUZjGAQgO4LGtcuQFQHAADxLHkZ0ACA7g9+r25mGRNF719271LQEEB+yvb+Pi39/yG1dIOciSFW8+GiT2ISA4gDu1XffpPL+YTBcMDX+Gz8NXZt86zJJohUMlcRwdZoIDeCU8ncGj1MZf55PFpUKLug1feX+cJf1+P4o+HA0/Xdx3wZRQJH8cDe1JXrGmbSfrrzQzSGKHGgUHMBU649N53nVLvv6fs/zjySg8XWaD+OPx8PO4WHoeShxHoTY8q/LKg6NbY02auUNzmwQHcE9tzISvh+/Om+PP04Oros6r6cKj4YbhiyE1RoPEkRRAcAAb1sbt5uhdz+eQF+yn8Cvw8eTAfhAcwHpms0S7FVbqmjXHn28O+pFlNthrX6+KqllvGodGebkcCYPt1MZf55Nu5XVBw5Zh+7azkCggOIB13qiVa173JGz/1QXoAcEBrOhiUo3LTa4jH24VbmsHAoID+I26bc/ycuObh9veXvscQHAAv/hyWTxkJka4bbgHu5H9lA3i+efxdEm8JdOoB/HPbbIkttMEB+yjomqK+qHjE+EeiqqxM9lDycISXsejNOkveUl6e5gt3R7BAXvkIQdTHuN+AAQHvDZ12z58eGMm3I+ZHIDgAJbIy2Zn7w1eXsHfcWJ5o8UFB+y5ot5ucNR2KfsmXpgk2t0x+3rx+oaRxXkFB+yhpRd63fztnVVH2cPg6K/3GmTSqOCAfbTu0qJPmS/wEiXxzQEM1xsSHACw7RekW3mx7hAIggNeoXSro7upsWJAcAC3bXes18gxIDiAJYaDeGfvDV6cu5ai6cynFhyw78GRJjt7b/BSzGdp3LXcxuL6HLGBQMEBeyiN+/GWnv/C/ZjDwZ6+CK1zNNEcUsEBe+p0mO7U/QAIDniFDrMkSx76SxTuIdyPnQkIDuBO746yh5xgEm4b7sFuBAQHcJ+k3/94MtqsOcKtwm0Th6UBwQH8Vhr3/3k6WnfWZ9g+1Ia5ojDTdt3tS6X0nZYiOIBFSb//j9PR6WiwylBH2CZs+Y9TtQE/r5/StO3ti8GGBCnr9kd8qI8X/rO2C2BbTkbp0XCQl01e1ZOqubFeUXi2HA7i0SCZhoanTlgzI5wTKziAX549D7NkdtZJ23XVjzdnmYVEAcEBPFJ86AyA70+JdgEAIDgAAMEBACA4ANjdF6GFpTaqurm9wfyy9dbkEBwAsKHfnuza/Ti/PLFujeAAABAcALwAt8cwIkvkCQ4A2K6lS5vbLYIDAEBwALDzkpVPPuk7TUVwAMCGL0JRlCXfrwBQN+2N7zY/z4n9uRmCAwDWdjxKB/E0JrobV1ju9dq2m9XGm8PMNZZfOhdvA+BZ3/hG0dvDbDaYMfh1GCOOpldaTlyYXnAAwFbMVgBz1OQ1l6VdAAAIDgBAcAAACA4AQHAAAIIDAEBwAACCAwBAcAAAggMAEBwAAIIDABAcAIDgAAAQHACA4AAAEBwAgOAAAAQHAIDgAAAEBwAgOAAABAcAIDgAAAQHACA4AADBAQAgOAAAwQEACA4AgC35/wIMAIOX+2b4cIr8AAAAAElFTkSuQmCC"

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cs_bg.aea5ff0.png";

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAA9CAMAAADBPCTwAAABTVBMVEUAAADz8/Pk5OT////////CwsLMzMzDw8Pj4uLExMTExMSoqKjCwsLq7+/i4uLV1dXT09Pp6enz+vvj4+PY2Njg3t7u7u7m5ubT0tLZ2dnw+Pj7+/vExMTv+Pj0+fzw8PD////q6urj4uL09PT2+/zeJCXExMTp6Oj8/Pzh4eHn5+fk5OTT09PQ0ND+/v75+fnz8/Pb29v29vbu7u7i4uLZ2dnW1tbU1NR/f3///Pz39/f19fXw8PDf39/Ozs7Nzc2zs7OQkJB1dXXr6+v75OTd3d3Y2NjBwcH0tLSwsLDxoqN5eXnrdnfnXl7eKCn+9PT97u786er3yMjHx8f2wcG9vb25uLioqKijo6OUlJSLi4vthYbkUVLhPj/hOjv63d351tf40NH2xMTzra2rqqqfn5+enZ3wm5zujI2GhobpcXLpbGznY2TkT1DkTk+CNhXtAAAAIHRSTlMA8yaAQGD29vXAZUYhF/n49fTx6ubj1tO7ppuIem1ZVUUl4H0AAAIySURBVFjD7dRXU9tAEMBxmQQDAdJ79a1zqpYt23HFHRsXbCD0nt7L93/MOTY5ErTKSfeQmQz/55vf3K5upIx6dP2p/+4rp5uPRwIUf3zauBgJ1IVz4x8Zz9/0mpJG4YhSuilnNCnri5yxNjQ+S86ywowDyZ0eM+ODpPGdGR1J4ysz1iWNPjNeSBofmbEqZjzBTvUoXYmgPVB4l65ipzqUHuHG9OSJMDejxrBTryk9xI1n6szc6BJTKm68pHTgZahTDxlxT2WhRqHTa3oZrLvzSuh2GDcKh2ynm15G+BZMKKGoc2cDM15R1gA3Nm4C/DSi0dAN5ND60PiGGpenYWwMS+muh1aPmdFHhIQJwI1hxbjrv/Bg0F9zFfRFAG6clIj4qGTBWYO1oIsKRSa4G3wt3ukEADf4WvDiJQDEEF3LggWoIbaWhAbgZfBSyEB6GgA3hAZyLBAwsIH4sxQ3+HfWU2wy/iwxA63IFkBYiwk+hl/DLJNxORsCGemWRn5ltmP+jXQSyG9lakv+DMdIauTP2t2WuOFYWZO4ZOzUDEFDy5YJUqW+ZQgY6eySRtDM7r76N6OUtIF4lqnv2V6GY9h8l2hb+d0kapixnEkEMnbzXcPV0HKVFhEss5ffNs4Y6Ww1YxLx1PynNjdGq6zmLOIra6dRt7nhGBXbIL7L7TfeZ8eGZVfZkwiQVltefltmxrVYVeAS6GNp5LcnlHCFP4lAV2nMKldMIlX53ayiEdkm/yfjB4yc/1Ft/GhaAAAAAElFTkSuQmCC"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA1CAMAAADLRm3ZAAABGlBMVEUAAADxqz7wqj72rT/v6jnv6Tnx6jn08TftlCju6TnxsTzv6Tnu6Tr2tzz/tjf//zDuojTwqz7v6Trv6TrwoTPu6Tnv2zrwqj7ulyvxzjvxqz3v6jru6TnumS7v6jnwqz3xmi7v6jjxqzvx7Tfy6zv0lSDxqz7v6jpNTU0yMzM0NTXv5Trxujzw3DrxrT3xsTzw0jvw1jrwwjzxvzzxtjzwqTzwyDvw6DlTUEuEbEfHk0HNlT3xvDygeTzv4Do7OjbTmUDxxjyRcDzwzjvwyzvw4jnupTlgV0pnXEmgfEWlfkDCjz+6ij/ppj7Ymz7wsz3xrj3v2Trv0jpMRTnvnTB2ZEjlpD+LbT2tgDyFaTxrWDtpVjpRSDntjyUlFC0UAAAAJnRSTlMAgPMc4r5HF/iXjoFpKg4I9u/r6tvVz724saabmZaPeW9gSTgnGCsvjhcAAAH1SURBVEjH7dbXdoJAEAZgkpiY3nuvC4YiomiMJTG92DU9ef/XiLO4ICIsuLnIhf+V6x6+Mww7KMdxh8gl8ydcgKy5Mfp6AGUGuWY8ALPpzjR3fCsjyD13/suZ9GD0n32/zALySHN5iJ5ZYIYRa0YGzID510zp6aXxVWZlnu8F4TQS+ei5GZUkqeqHuTwTMBO5cmwpmsxD5DidSQtt5qJ7R8rzJOoMhdHPCBPJdCkp3koo7M2UBJN5t3dF5DszSrkpt2piPCRWyBYMb7qv3lTg0lQcd1qFz0tznkyZPKmc7eskXKp1VjbmfW4ycG4czxuuFMkiAcwU5RQ/AvON7JGhMeYK2jNBYdLAXPRgaubqtrXaojAP+KbukC0qdLhKHr6Pm9KNFj8jZ4tv2otrHy2+FHq1OIrPcMEiQ5QJLxrMJ1mbFUDyWjZpjNYBhXk0mEb3eOcDDQNKY8Y54AmxU5mjMQ+YsR6V1R7ZVK6p7xudzFTRsaUZxm1d8vH2I8ybYwuPZFzx9S5+PW/lKZfLZRxbIpTC9AMTzyrGQNZZGChEruF7YmESPInCVE1FU/GxkRFTNfDLgIeThVFSopq9AUZiYSTSGRGxMNFkew5iNmZvKHAmV4HZsP5e95kJYMIca0ItZYVZOYZidpmZ8PYivMX/IEfT9vUv3QG5hlYPd90AAAAASUVORK5CYII="

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAAaVBMVEVKqdNKqdIAAABJqNRGpdJJqdJJqdJJqdKCxOFJqdNJqNNJqNFJqNJJqNNIqdRKqNdHo9bl8/iaz+a13O3N6PNKq9OMyePG5PGm1eqZz+V8wd90vt5rudtftNhWsNZJqNO84O+Qy+T///+uru+6AAAAInRSTlP0zACZM8Dn4/fv69nWs1kmGf75+/xM+Pz6+ff29vX0jPv4OyDz4gAAAONJREFUKM+Fk9cagyAMhUMBce+92vr+D1kDbu2Xc0d+IBtem+KQc8kk52G8GzcuArYrEBcecXYWj45cSHaVFDsvjMlTLgC4yjPHYuVCH30HVjm+tgjDI/25BUdZ2kWkOV/w/QJHLjZ8vyBmHqBvuAtjCF4Q4z3ngTsIYggxMXgSphkCRqdW0zj0nV2mbWIDgJrJW3MsS9t/q2YyyjR3MQNAL/h0yvMpPXFEkuBs43WZJk/vjX+jYY6tzj5Vs/tf4r+oG9f4qfyp+hH1/98/pftH9J+aH2L+iPml5p/eH3r/qP39AZc/D5N7rMtrAAAAAElFTkSuQmCC"

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-app01.0439ab5.png";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAHMCAYAAAAj/1pKAAAAAXNSR0IArs4c6QAAJc9JREFUeAHt3fmzXUWBB/AwQgKBQCAhkLAYCLygEFmCC0iV6FiMjlAzymiVVjnjbzN/hv+G85OzaZWO+oM44zZuICgQRROWhC1ASFjyCCEQQlgy93uTDsfrzfKQbqXzuVXk3Hfuud2nP92e7zl9znset2/fvq/M8yJAgAABAgTe0QJ/9Y7eeztPgAABAgQIjAUEuoFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAAYFuDBAgQIAAgQ4EBHoHnagJBAgQIEBAoBsDBAgQIECgAwGB3kEnagIBAgQIEBDoxgABAgQIEOhAQKB30ImaQIAAAQIEBLoxQIAAAQIEOhAQ6B10oiYQIECAAAGBbgwQIECAAIEOBAR6B52oCQQIECBAQKAbAwQIECBAoAMBgd5BJ2oCAQIECBAQ6MYAAQIECBDoQECgd9CJmkCAAAECBAS6MUCAAAECBDoQEOgddKImECBAgAABgW4MECBAgACBDgQEegedqAkECBAgQECgGwMECBAgQKADAYHeQSdqAgECBAgQEOjGAAECBAgQ6EBAoHfQiZpAgAABAgQEujFAgAABAgQ6EBDoHXSiJhAgQIAAgeMREDiUwLYtW5a8/PLuBYtPP2PXGUuX7jrUdtYfGwJlPKS1K845d3uWW5/csjTLCy+e2ZqlFwECfz4Bgf7ns/+Lr/nH37vl5uzk+66++mcC/S++uw67g488uGlFNkgQn7hw4d7Dbjzx4Z7du+f/6JZbbnh+x3PjMvLxZ7/4j19df89vVz+wfv01J59yyuwo0L818TU/EiDQWECgNwZ/p1SXq7Gyr8vOOnu2vLd85wmkL3/5k5/cmD3/4j//y7/OtQW3/eQn1ybM33X88XvPOe/8jfNPOGFvTgp2PrdjPEZOPW2x8TFXVNsTqCAg0Cug9lDk8nPPnX0rB/8e2t5bG555+qlx8OZK+q20bcfs9uX53gUXrlp/zUc/uq6UUdafdsbpb6ncUo4lAQJvj4BAf3scuyul3C896aSFryTc08BMvQ7vmT63ffuihzdtXPnaK3vnn3XuOdvKfdRsl+nYrF946qJdl6+9etM0oGy38f77Vu5+Ydei4xfM37tqZvXmTO3/KdPDw31Kmeee/+6tZf+n7UPqenrLk+PAyr6e9+6V26bdXhjuU8oZ7veaK67cOJzGTrsO5XQkj82PPLxix7PbxwF8+plLZy+5bM3mafuddUdqa9mPZ7c9NZ4qP+GE+a+kHcM+PVTZWZ9t977yyvw9e/Ysys/xzLpy/7ysX3LmmX8U6Bk/Wx5/bEXGwKH6IWWl3MlnNNKu0YzAuM4yprJdXtO+M6wr2xzOLWU/8djm5Rlz2XblxRdvnjY+Sj2lrYfr75ST15+yH8P//ewvbf+/xaL0WerY/OCDKw83jobf9/7YEjhu3759Xzm2mqy1RyPw3W9848ZMs140s3pduSr73bq7Z35/993Xjw7AW89fdeGmvB+WlW1zoLn3nnuuff211+aXz7L9TZ/73C3l5yxT1uR2mdL96N984rvl3v2nbv6Hr08L12E55X3C69e33bb28UcfWVPWleXyc87d9PEbb/xZ+TnLHBhv+78f31BCafhZnhkYnoSk7G/+x79/KdtcsmbNHQ/ef//aYfuy35/5/Be+VkL9gQ3rV971y1/ekCviJWcu2zq5T9M88p3f/PrX1w/LTX0p428//ZnvlrKz7mjbetftv1yTe9z5zvA17NPh+uH7YZuH6/M+MzcJvGnT+Pne5P328v3Jfvj2f/3nzS+9+OKSyf355r999fOlX4azRGX8Fe+U+9Mf/OD67c88vbLUUZbT3O746U/XPrRp49qyTVlO7tew7UfT39l+Lvvx8x/+8JrJMZF9Odw+L1121uaFJ5+8q3xvcp9LWyyPbYF3ffnLX77p2CbQ+mkCd9526/VZv+qSSzaMDibP5/3GDRtmdj6/46xXX3t1wVNbtqzKQeXs5cs379y5c+m+N954V5ZZf9ppi58+9/zzN73xxr55e/a8vCj/LTv77M2LTj315ZRTDsz5zoknnrhr5YWrNpxy6mmzu17YuXTzww+tzvoctD9w3XV3Zvujef3vd77zyae3bb0o31tz1VW3XjTa7wUnzN+VfXph5/PL5h03b9fZK1bMpqyE+U9/8P2bXt27d2EOlJdeccWdF1x88f0vv7R7/u6XXlr89NatKxedduq205cs2ZXtH9/86FlPPProTN5vf+aZ80r7Fpx40osv7nphSfb3jX1vvDy6v/xMtnnw3vtWPTc7uyLlx6s4HcqjnACknPMvuHD9ZVddeddoXzfv3LFjcQJvx+zswgtnZjan7LyOtq2v7NlzfAyyL/le2Y/Va9ZsOukID8a9sHPnwn2vvz66QH9lQdpR+mnZihWPpZ0P/P73Myk3IfSe973v/pSfYPuf73z7plE/nnVg/Z2lH7JtrHbv2jXvvAsu2JbtH3rggVUZG2csWbqtrMuJwqMPPnjwpOzyq69el23zuvVHP7zhtddeW7DqoovvuWBmZstdt912xWgW4L3DPk+9O5577qxR2xcN3RKijz780BXZdvWll965+rLLfjfq362j/lwxOT7m2t9z2Y8f33LL9U8e2OfJ/cg+b33iiWWj9QdntO656661MTruuONez4lL6cPzLrzgsTI+9+v4l8BoFg0CgUmBBF5ZNwrbg7+O9MLzzx9c//FP3fit4VRlrnxydZkrmvdf++H1+f7wSie//lbW5co873NwGl45jw7mj5WrvtPPWHKw3mx7uFdOEMpDW7nCL/uV6dq9r746P1c1jz/8yEy56s6VefZ1sv5sX64aH9m4aaZM95Yp+ezD5NXkaPslCd1MLZd93P7ss+Mp/Pz84Y997JZSzqE8cmWebSdnBpadvXz2e9/6789ve3LLzOi7t+cqfS5tTb2Zzi5XpUPr1He4V2ZGMjMzmqkZt+X0UeiWmZp87/kDYyEzEKWcPDwXi8krzexH6YdRAM+Mth+H9KmLF8+m30pZKefe395zVZY5gShX6fk57c7PWX/lBz84Hl/FOff2S98W66e2PPnuE+bPfyXfzUlCxkDCfDg+8llemWl6+IEH1pQy3mp/H2k/0ob05bT9WLBgwd7M6sQj0+xlZmrXrhfGvxaYtk/+b27/3vuXwJsCAv1NC+8OCJSHqHLwHE715mCTTS5+z3vWldAcomX7EubD9Xm/4sDvLW8c3TNPmOagdt3HPnb7cLscjEeBPl61eHSwL59lqrS8Hy5LwGzasGH8eQ6ok/s1ulrfcN4FKx/LPch8twTDtPrz+fIV52weBeCSl3fvPiU/51UCJ1Plpc79n7z5b241lJ/KQTjhXwKmfFaWCdq8H3qMZjBeTPiUbYbL3JNPWXNpa76f+8VZZt+zLK+Exsb16xOuf/CavDdb+nzywbcXX9i5JF9cvOSMcT+lvIRV1l3xgQ/cMRw3WZc+SKgOQzpPy+ez10YnXVmm7akvJ1rxz7Yl3Eq7Zy67bF0pezTL8OJo+3mPPvLwmny/3A8/MAbXZ11eOTnLctGiU7fnxHJoPJqCGJ9o5kQk2+Q11/4+2v0obZg2TvOsxCjQ99c/en4ggZ62538rWTmaRbp9cmyPN/YPgYGAQB9geLtfoDxElWnwYjI8CObhtbI+y3KltGz5ij9YXx4MG54YlLJzBV4OzMOyyvs8JJT3uaotV5jlsyxzFTharMtBr4REDuj5bPjKgbFc7WT90dY/LKOE19nnnvPYcH32rQRB+dW+4UF4cn/ywFu+n5OJsk9lf3LgLrMTwzqG7+fa1nz3+dnnxkGVq+FhWc88tW3JNNdM+ZfthjM1ebiwrB/uR2l3OXFI2w51ElO+X5Z5eG3epo3lx9EtnXsvyw8Xrp7ZVK7UR4E9fogtfZxxVK6is11OCEf360/JSUDakv+yzch9w/DEsjyNn+1GxlNPmFJeec2lv/Odo9mPodnkuCj1Ti7TR1kX02G7J7fzM4EiINCLhOVBgdE9xfGBZHiVPPvss+N1OWCWMCpfKFekZ61YPg7hsr5MXQ5PDMqV77Dssn0OeuV9CYXR/dBFk1eX2WbpmWeO68oBv3znaK5gDld/yiknJyUAhwfiYahl23LCkvel7mGwlXX5PK/y9HquFPevmTfv4P6MrqBLm8pnw2Wu6Ofa1ny/3CYpV9KlzNG98fnTXId9WGZq8p1hW0rQDNeXp8aHbSt1ZVnGwoETsfFH80fTzHmT8RPn3CPOPqXvS6Dn89wuyTJX51mWV04I87BlTjw23XffzDPbtq5M8OdBwN0vvnTKR2644Y5sW074cuV/8ujBsvL9acu59nfKOJr9OFLfDU+Yy2zW01u3jWdXDmU6bf+tO7YFBPqx3f9TW1+uOstVcjYqf0RkGM5Zn4NpmRbMPd+sK68SjtPCO/dUy3ZlWaaAhwf9BMnkE/Jl+yMtc3AuZea+63BGYFr92T5XcSm3BNu08Cr1lpAaBmO5Ip52EC4e04I76yan82M7/NO7w1Ao+1CWh2praU9+Ha9sm2Wu+I501VfaMmxfvltOTCbX57NXX927IMvJ14F75/OG99xH3x+Ha8bPb371q7X5zqVXXvGbLMv99RinDZNX5yUAE34ZI6P/Et53lCfZDzwNPg70lJdXrvzLieL+NW/+GlwJ0bn291vZj8zsDMdi9qXcFsjYL5+Vk7Fp46XsvyWBoYD/c5ahhvcHf883FOUgl/fTrtqzvlzFDaeRsz6vg1fuB6bPs65MWz/5xOOrc2DLurxyb7tMAQ8P+vs/PfS/wwN0fk1ruGVCImUmTMpBshwcx1dzg/qzLz/7wfdvyPdzUC2//3248Cr3WsvVfL57uINw8RhPNWfj0at4lMDbv3b/rYY8vJdp+HLVP9e2lrBJmZOzKqWewy1LW4bty/blxGS4vpz85WQwJyLDcvNkd66SM0byTEP5bLhPuf+e0C5tLPfXy/3xNWvX/kE4/+oXvxjbbBw9k1HKy7I8y5C6yvr8JkPel9As67Of8c1/u3fvf2hzrv19tPtR2pW68zcayj5kWR6Wy/v3Xn75wVmIcjI2HC/ZxovAoQRcoR9K5hhdX6bWh1cKoZh21Z715Spu8qn0XDHmyivbDE8M8kdYyu9xf/vrX/tCrmT3vLx7fB88B/Qc+Cenh1PG4V6575srsky1ZiYh06oJnXJAXHvttT8v38+vbCUkUs93v/mNm0fT6JtytV6maxME13zk+p+V7aeFV/lsx3P7fx1suL+lzsmD8KFmMuIx+kMhl2V/8oR9Hsob7k/6YXglPZe2lv3MMmWftPDkXZ/89Kd/OFx/uPelLcP2ZftyYlJmMbIugXXPnXfOZpzkVwLLn4jdtvXJlWXs5MGuYYjne6XP835ySj3rMoYyE1BOsLIur5SfPs8T6nkOIX3+0ksvLRqdYK7M53nwLMu8rnj/+9eN/rbBypw0jH7lb35mjIbbxrTs11z7ey77Ma3vclJYfo8+twRKO4cnRZMzX/tb5V8Cfywg0P/Y5JheU6bWh3+fe3ilN7zSCNTss8+Mp6gnp9XLVWUO2OXqONvn/Sf+7u+/9etbb70mB7KERkIrv96VK6VsMzk9nHWHe+Ve6ej3jOflAF+etM72CYKrr732juH93xy486tLd99++zWpu8wKZPscUK/60IfWlYN71k0Lr6wfnrCU/R0ehIe/7pfty0xGPIblx+OvP3Vj2v6RA/tz8Oo2+zP5mwBzaWv6anQvemvKTagO+zT7dLjXsC2lfdl+2O7JoMkfwMmvrqUPDkx5j6tIP2QqfXLs5MMTT1o4PomLy/DEZfzFA/+Uafjhug9ed9260e/HL0hdwz7PCdnkrxam/zO+1t1++0cy5kqATtt2Lv2d/ZnLfqTvRrcE9uaEcrjPaXtOZobtP9R4GRp4T2BSwF+KmxTxczWBhMEoXBaVP2M5rKj8cZUc3D77T1/6+vCzo32fafPyoFruzw6Dc1oZZX/yWWYRhice07avvW64P9PCb1j/XNs6/G7t9633rZxwThtXk23NiUqeSziabSe/e6Sf57Ifc9n2SPX6nEAREOhFwrK6QO4VZoo0V0a5Si+BmwDIXxjLVeTk1VX1nVIBAQIEOhEQ6J105DuhGcPgzv5mKjbLTHPmXmmm3if/bnk+9yJAgACBIwsI9CMb2eJtFEio5z5r/thHHgRL0Zlmz58Wzf3iP/e099vYVEURIECgqYBAb8qtMgIECBAgUEfA76HXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BAR6HVelEiBAgACBpgICvSm3yggQIECAQB0BgV7HVakECBAgQKCpgEBvyq0yAgQIECBQR0Cg13FVKgECBAgQaCog0Jtyq4wAAQIECNQREOh1XJVKgAABAgSaCgj0ptwqI0CAAAECdQQEeh1XpRIgQIAAgaYCAr0pt8oIECBAgEAdAYFex1WpBAgQIECgqYBAb8qtMgIECBAgUEdAoNdxVSoBAgQIEGgqINCbcquMAAECBAjUERDodVyVSoAAAQIEmgoI9KbcKiNAgAABAnUEBHodV6USIECAAIGmAgK9KbfKCBAgQIBAHQGBXsdVqQQIECBAoKmAQG/KrTICBAgQIFBHQKDXcVUqAQIECBBoKiDQm3KrjAABAgQI1BEQ6HVclUqAAAECBJoKCPSm3CojQIAAAQJ1BP4fPFZjIJ6u89cAAAAASUVORK5CYII="

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-flowsensor.a3013fa.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-guide-character.121101a.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-guide-character@2x.5b409d5.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-iotizr.68ba21b.png";

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ng1.b3eadd2.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ng2.1a327e9.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ok1.d26810a.png";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production","manualUrl":"https://www.harps4.com/help/basic_operations.html","termsUrl":"https://www.harps4.com/terms.html","privacyUrl":"https://www.harps4.com/privacy.html"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1859);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1858);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(69)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1860);
var v4 = __webpack_require__(1861);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1624)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1907),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1644)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1073),
  /* template */
  __webpack_require__(1932),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1079),
  /* template */
  __webpack_require__(1916),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1634)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1090),
  /* template */
  __webpack_require__(1921),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1654)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1091),
  /* template */
  __webpack_require__(1944),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  XMLNode = __webpack_require__(124);

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text");
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return create(XMLCData.prototype, this);
    };

    XMLCData.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<![CDATA[' + this.text + ']]>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLCData;

  })(XMLNode);

}).call(this);


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLComment, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  XMLNode = __webpack_require__(124);

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text");
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return create(XMLComment.prototype, this);
    };

    XMLComment.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!-- ' + this.text + ' -->';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLComment;

  })(XMLNode);

}).call(this);


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDeclaration, XMLNode, create, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  isObject = __webpack_require__(68);

  XMLNode = __webpack_require__(124);

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?xml';
      r += ' version="' + this.version + '"';
      if (this.encoding != null) {
        r += ' encoding="' + this.encoding + '"';
      }
      if (this.standalone != null) {
        r += ' standalone="' + this.standalone + '"';
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLProcessingInstruction, create, isObject;

  create = __webpack_require__(46);

  isObject = __webpack_require__(68);

  XMLCData = __webpack_require__(675);

  XMLComment = __webpack_require__(676);

  XMLDTDAttList = __webpack_require__(1956);

  XMLDTDEntity = __webpack_require__(1958);

  XMLDTDElement = __webpack_require__(1957);

  XMLDTDNotation = __webpack_require__(1959);

  XMLProcessingInstruction = __webpack_require__(680);

  module.exports = XMLDocType = (function() {
    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      this.documentObject = parent;
      this.stringify = this.documentObject.stringify;
      this.children = [];
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.instruction = function(target, value) {
      var child;
      child = new XMLProcessingInstruction(this, target, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.root = function() {
      return this.documentObject.root();
    };

    XMLDocType.prototype.document = function() {
      return this.documentObject;
    };

    XMLDocType.prototype.toString = function(options, level) {
      var child, i, indent, len, newline, offset, pretty, r, ref, ref1, ref2, ref3, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!DOCTYPE ' + this.root().name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      if (this.children.length > 0) {
        r += ' [';
        if (pretty) {
          r += newline;
        }
        ref3 = this.children;
        for (i = 0, len = ref3.length; i < len; i++) {
          child = ref3[i];
          r += child.toString(options, level + 1);
        }
        r += ']';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocType.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocType.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root();
    };

    XMLDocType.prototype.doc = function() {
      return this.document();
    };

    return XMLDocType;

  })();

}).call(this);


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, XMLElement, XMLNode, XMLProcessingInstruction, create, every, isFunction, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  isObject = __webpack_require__(68);

  isFunction = __webpack_require__(205);

  every = __webpack_require__(1751);

  XMLNode = __webpack_require__(124);

  XMLAttribute = __webpack_require__(1954);

  XMLProcessingInstruction = __webpack_require__(680);

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name");
      }
      this.name = this.stringify.eleName(name);
      this.children = [];
      this.instructions = [];
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, i, len, pi, ref, ref1;
      clonedSelf = create(XMLElement.prototype, this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref = this.attributes;
      for (attName in ref) {
        if (!hasProp.call(ref, attName)) continue;
        att = ref[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.instructions = [];
      ref1 = this.instructions;
      for (i = 0, len = ref1.length; i < len; i++) {
        pi = ref1[i];
        clonedSelf.instructions.push(pi.clone());
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name");
      }
      name = name.valueOf();
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, instruction, len;
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.instructions.push(instruction);
      }
      return this;
    };

    XMLElement.prototype.toString = function(options, level) {
      var att, child, i, indent, instruction, j, len, len1, name, newline, offset, pretty, r, ref, ref1, ref2, ref3, ref4, ref5, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      ref3 = this.instructions;
      for (i = 0, len = ref3.length; i < len; i++) {
        instruction = ref3[i];
        r += instruction.toString(options, level);
      }
      if (pretty) {
        r += space;
      }
      r += '<' + this.name;
      ref4 = this.attributes;
      for (name in ref4) {
        if (!hasProp.call(ref4, name)) continue;
        att = ref4[name];
        r += att.toString(options);
      }
      if (this.children.length === 0 || every(this.children, function(e) {
        return e.value === '';
      })) {
        r += '/>';
        if (pretty) {
          r += newline;
        }
      } else if (pretty && this.children.length === 1 && (this.children[0].value != null)) {
        r += '>';
        r += this.children[0].value;
        r += '</' + this.name + '>';
        r += newline;
      } else {
        r += '>';
        if (pretty) {
          r += newline;
        }
        ref5 = this.children;
        for (j = 0, len1 = ref5.length; j < len1; j++) {
          child = ref5[j];
          r += child.toString(options, level + 1);
        }
        if (pretty) {
          r += space;
        }
        r += '</' + this.name + '>';
        if (pretty) {
          r += newline;
        }
      }
      return r;
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLProcessingInstruction, create;

  create = __webpack_require__(46);

  module.exports = XMLProcessingInstruction = (function() {
    function XMLProcessingInstruction(parent, target, value) {
      this.stringify = parent.stringify;
      if (target == null) {
        throw new Error("Missing instruction target");
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return create(XMLProcessingInstruction.prototype, this);
    };

    XMLProcessingInstruction.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?';
      r += this.target;
      if (this.value) {
        r += ' ' + this.value;
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLProcessingInstruction;

  })();

}).call(this);


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, assign;

  assign = __webpack_require__(1749);

  XMLBuilder = __webpack_require__(1955);

  module.exports.create = function(name, xmldec, doctype, options) {
    options = assign({}, xmldec, doctype, options);
    return new XMLBuilder(name, options).root();
  };

}).call(this);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(691);

var Eventful = __webpack_require__(108);

var Transformable = __webpack_require__(323);

var Animatable = __webpack_require__(1989);

var zrUtil = __webpack_require__(0);

/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */
var Element = function (opts) {
  // jshint ignore:line
  Transformable.call(this, opts);
  Eventful.call(this, opts);
  Animatable.call(this, opts);
  /**
   * 画布元素ID
   * @type {string}
   */

  this.id = opts.id || guid();
};

Element.prototype = {
  /**
   * 元素类型
   * Element type
   * @type {string}
   */
  type: 'element',

  /**
   * 元素名字
   * Element name
   * @type {string}
   */
  name: '',

  /**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */
  __zr: null,

  /**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */
  ignore: false,

  /**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */
  clipPath: null,

  /**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */
  drift: function (dx, dy) {
    switch (this.draggable) {
      case 'horizontal':
        dy = 0;
        break;

      case 'vertical':
        dx = 0;
        break;
    }

    var m = this.transform;

    if (!m) {
      m = this.transform = [1, 0, 0, 1, 0, 0];
    }

    m[4] += dx;
    m[5] += dy;
    this.decomposeTransform();
    this.dirty(false);
  },

  /**
   * Hook before update
   */
  beforeUpdate: function () {},

  /**
   * Hook after update
   */
  afterUpdate: function () {},

  /**
   * Update each frame
   */
  update: function () {
    this.updateTransform();
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {},

  /**
   * @protected
   */
  attrKV: function (key, value) {
    if (key === 'position' || key === 'scale' || key === 'origin') {
      // Copy the array
      if (value) {
        var target = this[key];

        if (!target) {
          target = this[key] = [];
        }

        target[0] = value[0];
        target[1] = value[1];
      }
    } else {
      this[key] = value;
    }
  },

  /**
   * Hide the element
   */
  hide: function () {
    this.ignore = true;
    this.__zr && this.__zr.refresh();
  },

  /**
   * Show the element
   */
  show: function () {
    this.ignore = false;
    this.__zr && this.__zr.refresh();
  },

  /**
   * @param {string|Object} key
   * @param {*} value
   */
  attr: function (key, value) {
    if (typeof key === 'string') {
      this.attrKV(key, value);
    } else if (zrUtil.isObject(key)) {
      for (var name in key) {
        if (key.hasOwnProperty(name)) {
          this.attrKV(name, key[name]);
        }
      }
    }

    this.dirty(false);
    return this;
  },

  /**
   * @param {module:zrender/graphic/Path} clipPath
   */
  setClipPath: function (clipPath) {
    var zr = this.__zr;

    if (zr) {
      clipPath.addSelfToZr(zr);
    } // Remove previous clip path


    if (this.clipPath && this.clipPath !== clipPath) {
      this.removeClipPath();
    }

    this.clipPath = clipPath;
    clipPath.__zr = zr;
    clipPath.__clipTarget = this;
    this.dirty(false);
  },

  /**
   */
  removeClipPath: function () {
    var clipPath = this.clipPath;

    if (clipPath) {
      if (clipPath.__zr) {
        clipPath.removeSelfFromZr(clipPath.__zr);
      }

      clipPath.__zr = null;
      clipPath.__clipTarget = null;
      this.clipPath = null;
      this.dirty(false);
    }
  },

  /**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  addSelfToZr: function (zr) {
    this.__zr = zr; // 添加动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.addAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.addSelfToZr(zr);
    }
  },

  /**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  removeSelfFromZr: function (zr) {
    this.__zr = null; // 移除动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.removeAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.removeSelfFromZr(zr);
    }
  }
};
zrUtil.mixin(Element, Animatable);
zrUtil.mixin(Element, Transformable);
zrUtil.mixin(Element, Eventful);
var _default = Element;
module.exports = _default;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Clip = __webpack_require__(1968);

var color = __webpack_require__(78);

var _util = __webpack_require__(0);

var isArrayLike = _util.isArrayLike;

/**
 * @module echarts/animation/Animator
 */
var arraySlice = Array.prototype.slice;

function defaultGetter(target, key) {
  return target[key];
}

function defaultSetter(target, key, value) {
  target[key] = value;
}
/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */


function interpolateNumber(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */


function interpolateString(p0, p1, percent) {
  return percent > 0.5 ? p1 : p0;
}
/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */


function interpolateArray(p0, p1, percent, out, arrDim) {
  var len = p0.length;

  if (arrDim == 1) {
    for (var i = 0; i < len; i++) {
      out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
  } else {
    var len2 = len && p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
      }
    }
  }
} // arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1


function fillArr(arr0, arr1, arrDim) {
  var arr0Len = arr0.length;
  var arr1Len = arr1.length;

  if (arr0Len !== arr1Len) {
    // FIXME Not work for TypedArray
    var isPreviousLarger = arr0Len > arr1Len;

    if (isPreviousLarger) {
      // Cut the previous
      arr0.length = arr1Len;
    } else {
      // Fill the previous
      for (var i = arr0Len; i < arr1Len; i++) {
        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
      }
    }
  } // Handling NaN value


  var len2 = arr0[0] && arr0[0].length;

  for (var i = 0; i < arr0.length; i++) {
    if (arrDim === 1) {
      if (isNaN(arr0[i])) {
        arr0[i] = arr1[i];
      }
    } else {
      for (var j = 0; j < len2; j++) {
        if (isNaN(arr0[i][j])) {
          arr0[i][j] = arr1[i][j];
        }
      }
    }
  }
}
/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */


function isArraySame(arr0, arr1, arrDim) {
  if (arr0 === arr1) {
    return true;
  }

  var len = arr0.length;

  if (len !== arr1.length) {
    return false;
  }

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      if (arr0[i] !== arr1[i]) {
        return false;
      }
    }
  } else {
    var len2 = arr0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        if (arr0[i][j] !== arr1[i][j]) {
          return false;
        }
      }
    }
  }

  return true;
}
/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */


function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
  var len = p0.length;

  if (arrDim == 1) {
    for (var i = 0; i < len; i++) {
      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
  } else {
    var len2 = p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
      }
    }
  }
}
/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */


function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}

function cloneValue(value) {
  if (isArrayLike(value)) {
    var len = value.length;

    if (isArrayLike(value[0])) {
      var ret = [];

      for (var i = 0; i < len; i++) {
        ret.push(arraySlice.call(value[i]));
      }

      return ret;
    }

    return arraySlice.call(value);
  }

  return value;
}

function rgba2String(rgba) {
  rgba[0] = Math.floor(rgba[0]);
  rgba[1] = Math.floor(rgba[1]);
  rgba[2] = Math.floor(rgba[2]);
  return 'rgba(' + rgba.join(',') + ')';
}

function getArrayDim(keyframes) {
  var lastValue = keyframes[keyframes.length - 1].value;
  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
}

function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
  var getter = animator._getter;
  var setter = animator._setter;
  var useSpline = easing === 'spline';
  var trackLen = keyframes.length;

  if (!trackLen) {
    return;
  } // Guess data type


  var firstVal = keyframes[0].value;
  var isValueArray = isArrayLike(firstVal);
  var isValueColor = false;
  var isValueString = false; // For vertices morphing

  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
  var trackMaxTime; // Sort keyframe as ascending

  keyframes.sort(function (a, b) {
    return a.time - b.time;
  });
  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe

  var kfPercents = []; // Value of each keyframe

  var kfValues = [];
  var prevValue = keyframes[0].value;
  var isAllValueEqual = true;

  for (var i = 0; i < trackLen; i++) {
    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string

    var value = keyframes[i].value; // Check if value is equal, deep check if value is array

    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
      isAllValueEqual = false;
    }

    prevValue = value; // Try converting a string to a color array

    if (typeof value == 'string') {
      var colorArray = color.parse(value);

      if (colorArray) {
        value = colorArray;
        isValueColor = true;
      } else {
        isValueString = true;
      }
    }

    kfValues.push(value);
  }

  if (!forceAnimate && isAllValueEqual) {
    return;
  }

  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value

  for (var i = 0; i < trackLen - 1; i++) {
    if (isValueArray) {
      fillArr(kfValues[i], lastValue, arrDim);
    } else {
      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
        kfValues[i] = lastValue;
      }
    }
  }

  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
  // animation playback is sequency

  var lastFrame = 0;
  var lastFramePercent = 0;
  var start;
  var w;
  var p0;
  var p1;
  var p2;
  var p3;

  if (isValueColor) {
    var rgba = [0, 0, 0, 0];
  }

  var onframe = function (target, percent) {
    // Find the range keyframes
    // kf1-----kf2---------current--------kf3
    // find kf2 and kf3 and do interpolation
    var frame; // In the easing function like elasticOut, percent may less than 0

    if (percent < 0) {
      frame = 0;
    } else if (percent < lastFramePercent) {
      // Start from next key
      // PENDING start from lastFrame ?
      start = Math.min(lastFrame + 1, trackLen - 1);

      for (frame = start; frame >= 0; frame--) {
        if (kfPercents[frame] <= percent) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, trackLen - 2);
    } else {
      for (frame = lastFrame; frame < trackLen; frame++) {
        if (kfPercents[frame] > percent) {
          break;
        }
      }

      frame = Math.min(frame - 1, trackLen - 2);
    }

    lastFrame = frame;
    lastFramePercent = percent;
    var range = kfPercents[frame + 1] - kfPercents[frame];

    if (range === 0) {
      return;
    } else {
      w = (percent - kfPercents[frame]) / range;
    }

    if (useSpline) {
      p1 = kfValues[frame];
      p0 = kfValues[frame === 0 ? frame : frame - 1];
      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];

      if (isValueArray) {
        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(p1, p2, w);
        } else {
          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
        }

        setter(target, propName, value);
      }
    } else {
      if (isValueArray) {
        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
        } else {
          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
        }

        setter(target, propName, value);
      }
    }
  };

  var clip = new Clip({
    target: animator._target,
    life: trackMaxTime,
    loop: animator._loop,
    delay: animator._delay,
    onframe: onframe,
    ondestroy: oneTrackDone
  });

  if (easing && easing !== 'spline') {
    clip.easing = easing;
  }

  return clip;
}
/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */


var Animator = function (target, loop, getter, setter) {
  this._tracks = {};
  this._target = target;
  this._loop = loop || false;
  this._getter = getter || defaultGetter;
  this._setter = setter || defaultSetter;
  this._clipCount = 0;
  this._delay = 0;
  this._doneList = [];
  this._onframeList = [];
  this._clipList = [];
};

Animator.prototype = {
  /**
   * 设置动画关键帧
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */
  when: function (time
  /* ms */
  , props) {
    var tracks = this._tracks;

    for (var propName in props) {
      if (!props.hasOwnProperty(propName)) {
        continue;
      }

      if (!tracks[propName]) {
        tracks[propName] = []; // Invalid value

        var value = this._getter(this._target, propName);

        if (value == null) {
          // zrLog('Invalid property ' + propName);
          continue;
        } // If time is 0
        //  Then props is given initialize value
        // Else
        //  Initialize value from current prop value


        if (time !== 0) {
          tracks[propName].push({
            time: 0,
            value: cloneValue(value)
          });
        }
      }

      tracks[propName].push({
        time: time,
        value: props[propName]
      });
    }

    return this;
  },

  /**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */
  during: function (callback) {
    this._onframeList.push(callback);

    return this;
  },
  pause: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].pause();
    }

    this._paused = true;
  },
  resume: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].resume();
    }

    this._paused = false;
  },
  isPaused: function () {
    return !!this._paused;
  },
  _doneCallback: function () {
    // Clear all tracks
    this._tracks = {}; // Clear all clips

    this._clipList.length = 0;
    var doneList = this._doneList;
    var len = doneList.length;

    for (var i = 0; i < len; i++) {
      doneList[i].call(this);
    }
  },

  /**
   * 开始执行动画
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */
  start: function (easing, forceAnimate) {
    var self = this;
    var clipCount = 0;

    var oneTrackDone = function () {
      clipCount--;

      if (!clipCount) {
        self._doneCallback();
      }
    };

    var lastClip;

    for (var propName in this._tracks) {
      if (!this._tracks.hasOwnProperty(propName)) {
        continue;
      }

      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);

      if (clip) {
        this._clipList.push(clip);

        clipCount++; // If start after added to animation

        if (this.animation) {
          this.animation.addClip(clip);
        }

        lastClip = clip;
      }
    } // Add during callback on the last clip


    if (lastClip) {
      var oldOnFrame = lastClip.onframe;

      lastClip.onframe = function (target, percent) {
        oldOnFrame(target, percent);

        for (var i = 0; i < self._onframeList.length; i++) {
          self._onframeList[i](target, percent);
        }
      };
    } // This optimization will help the case that in the upper application
    // the view may be refreshed frequently, where animation will be
    // called repeatly but nothing changed.


    if (!clipCount) {
      this._doneCallback();
    }

    return this;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stop: function (forwardToLast) {
    var clipList = this._clipList;
    var animation = this.animation;

    for (var i = 0; i < clipList.length; i++) {
      var clip = clipList[i];

      if (forwardToLast) {
        // Move to last frame before stop
        clip.onframe(this._target, 1);
      }

      animation && animation.removeClip(clip);
    }

    clipList.length = 0;
  },

  /**
   * 设置动画延迟开始的时间
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */
  delay: function (time) {
    this._delay = time;
    return this;
  },

  /**
   * 添加动画结束的回调
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */
  done: function (cb) {
    if (cb) {
      this._doneList.push(cb);
    }

    return this;
  },

  /**
   * @return {Array.<module:zrender/animation/Clip>}
   */
  getClips: function () {
    return this._clipList;
  }
};
var _default = Animator;
module.exports = _default;

/***/ }),
/* 684 */
/***/ (function(module, exports) {

var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
  setTimeout(func, 16);
};

module.exports = _default;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  var _a = 0;
  var _b = x0; // Quick reject

  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
    return false;
  }

  if (x0 !== x1) {
    _a = (y0 - y1) / (x0 - x1);
    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
  } else {
    return Math.abs(x - x0) <= _l / 2;
  }

  var tmp = _a * x - y + _b;

  var _s = tmp * tmp / (_a * _a + 1);

  return _s <= _l / 2 * _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var windingLine = __webpack_require__(689);

var EPSILON = 1e-8;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
}

function contain(points, x, y) {
  var w = 0;
  var p = points[0];

  if (!p) {
    return false;
  }

  for (var i = 1; i < points.length; i++) {
    var p2 = points[i];
    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
    p = p2;
  } // Close polygon


  var p0 = points[0];

  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
  }

  return w !== 0;
}

exports.contain = contain;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var _curve = __webpack_require__(88);

var quadraticProjectPoint = _curve.quadraticProjectPoint;

/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
    return false;
  }

  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

var PI2 = Math.PI * 2;

function normalizeRadian(angle) {
  angle %= PI2;

  if (angle < 0) {
    angle += PI2;
  }

  return angle;
}

exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 689 */
/***/ (function(module, exports) {

function windingLine(x0, y0, x1, y1, x, y) {
  if (y > y0 && y > y1 || y < y0 && y < y1) {
    return 0;
  } // Ignore horizontal line


  if (y1 === y0) {
    return 0;
  }

  var dir = y1 < y0 ? 1 : -1;
  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon

  if (t === 1 || t === 0) {
    dir = y1 < y0 ? 0.5 : -0.5;
  }

  var x_ = t * (x1 - x0) + x0;
  return x_ > x ? dir : 0;
}

module.exports = windingLine;

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// Simple LRU cache use doubly linked list
// @module zrender/core/LRU

/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */
var LinkedList = function () {
  /**
   * @type {module:zrender/core/LRU~Entry}
   */
  this.head = null;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.tail = null;
  this._len = 0;
};

var linkedListProto = LinkedList.prototype;
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */

linkedListProto.insert = function (val) {
  var entry = new Entry(val);
  this.insertEntry(entry);
  return entry;
};
/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.insertEntry = function (entry) {
  if (!this.head) {
    this.head = this.tail = entry;
  } else {
    this.tail.next = entry;
    entry.prev = this.tail;
    entry.next = null;
    this.tail = entry;
  }

  this._len++;
};
/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.remove = function (entry) {
  var prev = entry.prev;
  var next = entry.next;

  if (prev) {
    prev.next = next;
  } else {
    // Is head
    this.head = next;
  }

  if (next) {
    next.prev = prev;
  } else {
    // Is tail
    this.tail = prev;
  }

  entry.next = entry.prev = null;
  this._len--;
};
/**
 * @return {number}
 */


linkedListProto.len = function () {
  return this._len;
};
/**
 * Clear list
 */


linkedListProto.clear = function () {
  this.head = this.tail = null;
  this._len = 0;
};
/**
 * @constructor
 * @param {} val
 */


var Entry = function (val) {
  /**
   * @type {}
   */
  this.value = val;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.next;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.prev;
};
/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */


var LRU = function (maxSize) {
  this._list = new LinkedList();
  this._map = {};
  this._maxSize = maxSize || 10;
  this._lastRemovedEntry = null;
};

var LRUProto = LRU.prototype;
/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */

LRUProto.put = function (key, value) {
  var list = this._list;
  var map = this._map;
  var removed = null;

  if (map[key] == null) {
    var len = list.len(); // Reuse last removed entry

    var entry = this._lastRemovedEntry;

    if (len >= this._maxSize && len > 0) {
      // Remove the least recently used
      var leastUsedEntry = list.head;
      list.remove(leastUsedEntry);
      delete map[leastUsedEntry.key];
      removed = leastUsedEntry.value;
      this._lastRemovedEntry = leastUsedEntry;
    }

    if (entry) {
      entry.value = value;
    } else {
      entry = new Entry(value);
    }

    entry.key = key;
    list.insertEntry(entry);
    map[key] = entry;
  }

  return removed;
};
/**
 * @param  {string} key
 * @return {}
 */


LRUProto.get = function (key) {
  var entry = this._map[key];
  var list = this._list;

  if (entry != null) {
    // Put the latest used entry in the tail
    if (entry !== list.tail) {
      list.remove(entry);
      list.insertEntry(entry);
    }

    return entry.value;
  }
};
/**
 * Clear the cache
 */


LRUProto.clear = function () {
  this._list.clear();

  this._map = {};
};

var _default = LRU;
module.exports = _default;

/***/ }),
/* 691 */
/***/ (function(module, exports) {

/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */
var idStart = 0x0907;

function _default() {
  return idStart++;
}

module.exports = _default;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Gradient = __webpack_require__(213);

/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */
var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'linear', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0 : x;
  this.y = y == null ? 0 : y;
  this.x2 = x2 == null ? 1 : x2;
  this.y2 = y2 == null ? 0 : y2; // Can be cloned

  this.type = 'linear'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

LinearGradient.prototype = {
  constructor: LinearGradient
};
zrUtil.inherits(LinearGradient, Gradient);
var _default = LinearGradient;
module.exports = _default;

/***/ }),
/* 693 */
/***/ (function(module, exports) {

var Pattern = function (image, repeat) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {image: ...}`, where this constructor will not be called.
  this.image = image;
  this.repeat = repeat; // Can be cloned

  this.type = 'pattern';
};

Pattern.prototype.getCanvasPattern = function (ctx) {
  return ctx.createPattern(this.image, this.repeat || 'repeat');
};

var _default = Pattern;
module.exports = _default;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);

var Style = function (opts, host) {
  this.extendFrom(opts, false);
  this.host = host;
};

function createLinearGradient(ctx, obj, rect) {
  var x = obj.x == null ? 0 : obj.x;
  var x2 = obj.x2 == null ? 1 : obj.x2;
  var y = obj.y == null ? 0 : obj.y;
  var y2 = obj.y2 == null ? 0 : obj.y2;

  if (!obj.global) {
    x = x * rect.width + rect.x;
    x2 = x2 * rect.width + rect.x;
    y = y * rect.height + rect.y;
    y2 = y2 * rect.height + rect.y;
  }

  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
  return canvasGradient;
}

function createRadialGradient(ctx, obj, rect) {
  var width = rect.width;
  var height = rect.height;
  var min = Math.min(width, height);
  var x = obj.x == null ? 0.5 : obj.x;
  var y = obj.y == null ? 0.5 : obj.y;
  var r = obj.r == null ? 0.5 : obj.r;

  if (!obj.global) {
    x = x * width + rect.x;
    y = y * height + rect.y;
    r = r * min;
  }

  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
  return canvasGradient;
}

Style.prototype = {
  constructor: Style,

  /**
   * @type {module:zrender/graphic/Displayable}
   */
  host: null,

  /**
   * @type {string}
   */
  fill: '#000',

  /**
   * @type {string}
   */
  stroke: null,

  /**
   * @type {number}
   */
  opacity: 1,

  /**
   * @type {Array.<number>}
   */
  lineDash: null,

  /**
   * @type {number}
   */
  lineDashOffset: 0,

  /**
   * @type {number}
   */
  shadowBlur: 0,

  /**
   * @type {number}
   */
  shadowOffsetX: 0,

  /**
   * @type {number}
   */
  shadowOffsetY: 0,

  /**
   * @type {number}
   */
  lineWidth: 1,

  /**
   * If stroke ignore scale
   * @type {Boolean}
   */
  strokeNoScale: false,
  // Bounding rect text configuration
  // Not affected by element transform

  /**
   * @type {string}
   */
  text: null,

  /**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */
  font: null,

  /**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */
  textFont: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontStyle: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontWeight: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */
  fontSize: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontFamily: null,

  /**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */
  textTag: null,

  /**
   * @type {string}
   */
  textFill: '#000',

  /**
   * @type {string}
   */
  textStroke: null,

  /**
   * @type {number}
   */
  textWidth: null,

  /**
   * Only for textBackground.
   * @type {number}
   */
  textHeight: null,

  /**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */
  textStrokeWidth: 0,

  /**
   * @type {number}
   */
  textLineHeight: null,

  /**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */
  textPosition: 'inside',

  /**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */
  textRect: null,

  /**
   * [x, y]
   * @type {Array.<number>}
   */
  textOffset: null,

  /**
   * @type {string}
   */
  textAlign: null,

  /**
   * @type {string}
   */
  textVerticalAlign: null,

  /**
   * @type {number}
   */
  textDistance: 5,

  /**
   * @type {string}
   */
  textShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textShadowBlur: 0,

  /**
   * @type {number}
   */
  textShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textShadowOffsetY: 0,

  /**
   * @type {string}
   */
  textBoxShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textBoxShadowBlur: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetY: 0,

  /**
   * Whether transform text.
   * Only useful in Path and Image element
   * @type {boolean}
   */
  transformText: false,

  /**
   * Text rotate around position of Path or Image
   * Only useful in Path and Image element and transformText is false.
   */
  textRotation: 0,

  /**
   * Text origin of text rotation, like [10, 40].
   * Based on x, y of rect.
   * Useful in label rotation of circular symbol.
   * By default, this origin is textPosition.
   * Can be 'center'.
   * @type {string|Array.<number>}
   */
  textOrigin: null,

  /**
   * @type {string}
   */
  textBackgroundColor: null,

  /**
   * @type {string}
   */
  textBorderColor: null,

  /**
   * @type {number}
   */
  textBorderWidth: 0,

  /**
   * @type {number}
   */
  textBorderRadius: 0,

  /**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */
  textPadding: null,

  /**
   * Text styles for rich text.
   * @type {Object}
   */
  rich: null,

  /**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */
  truncate: null,

  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */
  blend: null,

  /**
   * @param {CanvasRenderingContext2D} ctx
   */
  bind: function (ctx, el, prevEl) {
    var style = this;
    var prevStyle = prevEl && prevEl.style;
    var firstDraw = !prevStyle;

    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
      var prop = STYLE_COMMON_PROPS[i];
      var styleName = prop[0];

      if (firstDraw || style[styleName] !== prevStyle[styleName]) {
        // FIXME Invalid property value will cause style leak from previous element.
        ctx[styleName] = style[styleName] || prop[1];
      }
    }

    if (firstDraw || style.fill !== prevStyle.fill) {
      ctx.fillStyle = style.fill;
    }

    if (firstDraw || style.stroke !== prevStyle.stroke) {
      ctx.strokeStyle = style.stroke;
    }

    if (firstDraw || style.opacity !== prevStyle.opacity) {
      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }

    if (firstDraw || style.blend !== prevStyle.blend) {
      ctx.globalCompositeOperation = style.blend || 'source-over';
    }

    if (this.hasStroke()) {
      var lineWidth = style.lineWidth;
      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
    }
  },
  hasFill: function () {
    var fill = this.fill;
    return fill != null && fill !== 'none';
  },
  hasStroke: function () {
    var stroke = this.stroke;
    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
  },

  /**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */
  extendFrom: function (otherStyle, overwrite) {
    if (otherStyle) {
      for (var name in otherStyle) {
        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
          this[name] = otherStyle[name];
        }
      }
    }
  },

  /**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */
  set: function (obj, value) {
    if (typeof obj === 'string') {
      this[obj] = value;
    } else {
      this.extendFrom(obj, true);
    }
  },

  /**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */
  clone: function () {
    var newStyle = new this.constructor();
    newStyle.extendFrom(this, true);
    return newStyle;
  },
  getGradient: function (ctx, obj, rect) {
    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
    var canvasGradient = method(ctx, obj, rect);
    var colorStops = obj.colorStops;

    for (var i = 0; i < colorStops.length; i++) {
      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }

    return canvasGradient;
  }
};
var styleProto = Style.prototype;

for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
  var prop = STYLE_COMMON_PROPS[i];

  if (!(prop[0] in styleProto)) {
    styleProto[prop[0]] = prop[1];
  }
} // Provide for others


Style.getGradient = styleProto.getGradient;
var _default = Style;
module.exports = _default;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(33);

// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];

function _default(orignalBrush) {
  // version string can be: '11.0'
  return env.browser.ie && env.browser.version >= 11 ? function () {
    var clipPaths = this.__clipPaths;
    var style = this.style;
    var modified;

    if (clipPaths) {
      for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        var shape = clipPath && clipPath.shape;
        var type = clipPath && clipPath.type;

        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
          for (var j = 0; j < shadowTemp.length; j++) {
            // It is save to put shadowTemp static, because shadowTemp
            // will be all modified each item brush called.
            shadowTemp[j][2] = style[shadowTemp[j][0]];
            style[shadowTemp[j][0]] = shadowTemp[j][1];
          }

          modified = true;
          break;
        }
      }
    }

    orignalBrush.apply(this, arguments);

    if (modified) {
      for (var j = 0; j < shadowTemp.length; j++) {
        style[shadowTemp[j][0]] = shadowTemp[j][2];
      }
    }
  } : orignalBrush;
}

module.exports = _default;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var smoothSpline = __webpack_require__(1979);

var smoothBezier = __webpack_require__(1978);

function buildPath(ctx, shape, closePath) {
  var points = shape.points;
  var smooth = shape.smooth;

  if (points && points.length >= 2) {
    if (smooth && smooth !== 'spline') {
      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
      ctx.moveTo(points[0][0], points[0][1]);
      var len = points.length;

      for (var i = 0; i < (closePath ? len : len - 1); i++) {
        var cp1 = controlPoints[i * 2];
        var cp2 = controlPoints[i * 2 + 1];
        var p = points[(i + 1) % len];
        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
      }
    } else {
      if (smooth === 'spline') {
        points = smoothSpline(points, closePath);
      }

      ctx.moveTo(points[0][0], points[0][1]);

      for (var i = 1, l = points.length; i < l; i++) {
        ctx.lineTo(points[i][0], points[i][1]);
      }
    }

    closePath && ctx.closePath();
  }
}

exports.buildPath = buildPath;

/***/ }),
/* 697 */
/***/ (function(module, exports) {

function buildPath(ctx, shape) {
  var x = shape.x;
  var y = shape.y;
  var width = shape.width;
  var height = shape.height;
  var r = shape.r;
  var r1;
  var r2;
  var r3;
  var r4; // Convert width and height to positive for better borderRadius

  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }

  if (typeof r === 'number') {
    r1 = r2 = r3 = r4 = r;
  } else if (r instanceof Array) {
    if (r.length === 1) {
      r1 = r2 = r3 = r4 = r[0];
    } else if (r.length === 2) {
      r1 = r3 = r[0];
      r2 = r4 = r[1];
    } else if (r.length === 3) {
      r1 = r[0];
      r2 = r4 = r[1];
      r3 = r[2];
    } else {
      r1 = r[0];
      r2 = r[1];
      r3 = r[2];
      r4 = r[3];
    }
  } else {
    r1 = r2 = r3 = r4 = 0;
  }

  var total;

  if (r1 + r2 > width) {
    total = r1 + r2;
    r1 *= width / total;
    r2 *= width / total;
  }

  if (r3 + r4 > width) {
    total = r3 + r4;
    r3 *= width / total;
    r4 *= width / total;
  }

  if (r2 + r3 > height) {
    total = r2 + r3;
    r2 *= height / total;
    r3 *= height / total;
  }

  if (r1 + r4 > height) {
    total = r1 + r4;
    r1 *= height / total;
    r4 *= height / total;
  }

  ctx.moveTo(x + r1, y);
  ctx.lineTo(x + width - r2, y);
  r2 !== 0 && ctx.quadraticCurveTo(x + width, y, x + width, y + r2);
  ctx.lineTo(x + width, y + height - r3);
  r3 !== 0 && ctx.quadraticCurveTo(x + width, y + height, x + width - r3, y + height);
  ctx.lineTo(x + r4, y + height);
  r4 !== 0 && ctx.quadraticCurveTo(x, y + height, x, y + height - r4);
  ctx.lineTo(x, y + r1);
  r1 !== 0 && ctx.quadraticCurveTo(x, y, x + r1, y);
}

exports.buildPath = buildPath;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var textHelper = __webpack_require__(214);

var BoundingRect = __webpack_require__(26);

/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */
var tmpRect = new BoundingRect();

var RectText = function () {};

RectText.prototype = {
  constructor: RectText,

  /**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */
  drawRectText: function (ctx, rect) {
    var style = this.style;
    rect = style.textRect || rect; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!textHelper.needDrawText(text, style)) {
      return;
    } // FIXME


    ctx.save(); // Transform rect to view space

    var transform = this.transform;

    if (!style.transformText) {
      if (transform) {
        tmpRect.copy(rect);
        tmpRect.applyTransform(transform);
        rect = tmpRect;
      }
    } else {
      this.setTransform(ctx);
    } // transformText and textRotation can not be used at the same time.


    textHelper.renderText(this, ctx, text, style, rect);
    ctx.restore();
  }
};
var _default = RectText;
module.exports = _default;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(324);

var createElement = _core.createElement;

var zrUtil = __webpack_require__(0);

var Path = __webpack_require__(34);

var ZImage = __webpack_require__(152);

var ZText = __webpack_require__(153);

var _graphic = __webpack_require__(325);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * @file Manages elements that can be defined in <defs> in SVG,
 *       e.g., gradients, clip path, etc.
 * @author Zhang Wenli
 */
var MARK_UNUSED = '0';
var MARK_USED = '1';
/**
 * Manages elements that can be defined in <defs> in SVG,
 * e.g., gradients, clip path, etc.
 *
 * @class
 * @param {SVGElement}      svgRoot   root of SVG document
 * @param {string|string[]} tagNames  possible tag names
 * @param {string}          markLabel label name to make if the element
 *                                    is used
 */

function Definable(svgRoot, tagNames, markLabel) {
  this._svgRoot = svgRoot;
  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
  this._markLabel = markLabel;
  this.nextId = 0;
}

Definable.prototype.createElement = createElement;
/**
 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
 *
 * @param {boolean} isForceCreating if need to create when not exists
 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
 * exist and isForceCreating is false
 */

Definable.prototype.getDefs = function (isForceCreating) {
  var svgRoot = this._svgRoot;

  var defs = this._svgRoot.getElementsByTagName('defs');

  if (defs.length === 0) {
    // Not exist
    if (isForceCreating) {
      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
      svgRoot.firstChild // Insert in the front of svg
      );

      if (!defs.contains) {
        // IE doesn't support contains method
        defs.contains = function (el) {
          var children = defs.children;

          if (!children) {
            return false;
          }

          for (var i = children.length - 1; i >= 0; --i) {
            if (children[i] === el) {
              return true;
            }
          }

          return false;
        };
      }

      return defs;
    } else {
      return null;
    }
  } else {
    return defs[0];
  }
};
/**
 * Update DOM element if necessary.
 *
 * @param {Object|string} element style element. e.g., for gradient,
 *                                it may be '#ccc' or {type: 'linear', ...}
 * @param {Function|undefined} onUpdate update callback
 */


Definable.prototype.update = function (element, onUpdate) {
  if (!element) {
    return;
  }

  var defs = this.getDefs(false);

  if (element._dom && defs.contains(element._dom)) {
    // Update DOM
    if (typeof onUpdate === 'function') {
      onUpdate();
    }
  } else {
    // No previous dom, create new
    var dom = this.add(element);

    if (dom) {
      element._dom = dom;
    }
  }
};
/**
 * Add gradient dom to defs
 *
 * @param {SVGElement} dom DOM to be added to <defs>
 */


Definable.prototype.addDom = function (dom) {
  var defs = this.getDefs(true);
  defs.appendChild(dom);
};
/**
 * Remove DOM of a given element.
 *
 * @param {SVGElement} element element to remove dom
 */


Definable.prototype.removeDom = function (element) {
  var defs = this.getDefs(false);
  defs.removeChild(element._dom);
};
/**
 * Get DOMs of this element.
 *
 * @return {HTMLDomElement} doms of this defineable elements in <defs>
 */


Definable.prototype.getDoms = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // No dom when defs is not defined
    return [];
  }

  var doms = [];
  zrUtil.each(this._tagNames, function (tagName) {
    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
    // rather than real array.
    // So `doms.concat(tags)` add tags as one object.

    doms = doms.concat([].slice.call(tags));
  });
  return doms;
};
/**
 * Mark DOMs to be unused before painting, and clear unused ones at the end
 * of the painting.
 */


Definable.prototype.markAllUnused = function () {
  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    dom[that._markLabel] = MARK_UNUSED;
  });
};
/**
 * Mark a single DOM to be used.
 *
 * @param {SVGElement} dom DOM to mark
 */


Definable.prototype.markUsed = function (dom) {
  if (dom) {
    dom[this._markLabel] = MARK_USED;
  }
};
/**
 * Remove unused DOMs defined in <defs>
 */


Definable.prototype.removeUnused = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // Nothing to remove
    return;
  }

  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    if (dom[that._markLabel] !== MARK_USED) {
      // Remove gradient
      defs.removeChild(dom);
    }
  });
};
/**
 * Get SVG proxy.
 *
 * @param {Displayable} displayable displayable element
 * @return {Path|Image|Text} svg proxy of given element
 */


Definable.prototype.getSvgProxy = function (displayable) {
  if (displayable instanceof Path) {
    return svgPath;
  } else if (displayable instanceof ZImage) {
    return svgImage;
  } else if (displayable instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
};
/**
 * Get text SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element of text
 */


Definable.prototype.getTextSvgElement = function (displayable) {
  return displayable.__textSvgEl;
};
/**
 * Get SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element
 */


Definable.prototype.getSvgElement = function (displayable) {
  return displayable.__svgEl;
};

var _default = Definable;
module.exports = _default;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(33);

var urn = 'urn:schemas-microsoft-com:vml';
var win = typeof window === 'undefined' ? null : window;
var vmlInited = false;
var doc = win && win.document;

function createNode(tagName) {
  return doCreateNode(tagName);
} // Avoid assign to an exported variable, for transforming to cjs.


var doCreateNode;

if (doc && !env.canvasSupported) {
  try {
    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);

    doCreateNode = function (tagName) {
      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
    };
  } catch (e) {
    doCreateNode = function (tagName) {
      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
    };
  }
} // From raphael


function initVML() {
  if (vmlInited || !doc) {
    return;
  }

  vmlInited = true;
  var styleSheets = doc.styleSheets;

  if (styleSheets.length < 31) {
    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
  } else {
    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
  }
}

exports.doc = doc;
exports.createNode = createNode;
exports.initVML = initVML;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aqua_harps4_com/images/badge-apple.png": 630,
	"./aqua_harps4_com/images/badge-google.png": 631,
	"./aqua_harps4_com/images/bg-guide.png": 632,
	"./aqua_harps4_com/images/cs_bg.png": 633,
	"./aqua_harps4_com/images/cs_mail.png": 634,
	"./aqua_harps4_com/images/cs_secret.png": 635,
	"./aqua_harps4_com/images/icon_bell_alert@2x.png": 121,
	"./aqua_harps4_com/images/icon_bell_warning@2x.png": 122,
	"./aqua_harps4_com/images/icon_cs.png": 636,
	"./aqua_harps4_com/images/icon_folder_plus@2x.png": 302,
	"./aqua_harps4_com/images/icon_line_blue@2x.png": 123,
	"./aqua_harps4_com/images/icon_line_lightblue@2x.png": 303,
	"./aqua_harps4_com/images/icon_line_lime@2x.png": 304,
	"./aqua_harps4_com/images/img-addequipment.png": 637,
	"./aqua_harps4_com/images/img-app01.png": 638,
	"./aqua_harps4_com/images/img-complete.png": 639,
	"./aqua_harps4_com/images/img-connect-flowsensor.png": 640,
	"./aqua_harps4_com/images/img-filter.png": 641,
	"./aqua_harps4_com/images/img-flowsensor.png": 642,
	"./aqua_harps4_com/images/img-guide-character.png": 643,
	"./aqua_harps4_com/images/img-guide-character@2x.png": 644,
	"./aqua_harps4_com/images/img-iotizr.png": 645,
	"./aqua_harps4_com/images/img-register-equipments.png": 646,
	"./aqua_harps4_com/images/img-register-location.png": 647,
	"./aqua_harps4_com/images/img-setup-iotizr.png": 648,
	"./aqua_harps4_com/images/inst_dp@3x.png": 305,
	"./aqua_harps4_com/images/inst_pr@3x.png": 306,
	"./aqua_harps4_com/images/inst_ro@3x.png": 307,
	"./aqua_harps4_com/images/inst_tm@3x.png": 308,
	"./aqua_harps4_com/images/inst_wt@3x.png": 309,
	"./aqua_harps4_com/images/location-default01.png": 649,
	"./aqua_harps4_com/images/location-default02.png": 650,
	"./aqua_harps4_com/images/location-default03.png": 651,
	"./aqua_harps4_com/images/location-default04.png": 652,
	"./aqua_harps4_com/images/location-default05.png": 653,
	"./aqua_harps4_com/images/location-default06.png": 654,
	"./aqua_harps4_com/images/location-default07.png": 655,
	"./aqua_harps4_com/images/location-default08.png": 656,
	"./aqua_harps4_com/images/location-default09.png": 657,
	"./aqua_harps4_com/images/location-default10.png": 658,
	"./aqua_harps4_com/images/location-default11.png": 659,
	"./aqua_harps4_com/images/logo.png": 660,
	"./aqua_harps4_com/images/logo02.png": 206,
	"./aqua_harps4_com/images/logo03.png": 310,
	"./aqua_harps4_com/images/ng1.png": 661,
	"./aqua_harps4_com/images/ng2.png": 662,
	"./aqua_harps4_com/images/ok1.png": 663,
	"./aqua_harps4_com/images/settings_icon01@2x.png": 311,
	"./aqua_harps4_com/images/settings_icon02@2x.png": 312,
	"./aqua_harps4_com/images/settings_icon03@2x.png": 313,
	"./aqua_harps4_com/images/settings_icon04@2x.png": 314,
	"./aqua_harps4_com/images/settings_icon05@2x.png": 664,
	"./aqua_harps4_com/images/stats-calendar.png": 665,
	"./aqua_harps4_com/images/stats-iotizr.png": 315,
	"./aqua_harps4_com/images/stats-pin.png": 316,
	"./aqua_harps4_com/images/user-aplix.png": 317,
	"./aqua_harps4_com/images/user-default01.png": 207,
	"./aqua_harps4_com/images/user-default02.png": 318,
	"./aqua_harps4_com/images/user-default03.png": 319,
	"./aqua_harps4_com/translations/english": 159,
	"./aqua_harps4_com/translations/english.js": 159,
	"./aqua_harps4_com/translations/german": 160,
	"./aqua_harps4_com/translations/german.js": 160,
	"./aqua_harps4_com/translations/japanese": 161,
	"./aqua_harps4_com/translations/japanese.js": 161,
	"./aqua_harps4_com/translations/russian": 162,
	"./aqua_harps4_com/translations/russian.js": 162,
	"./connect_ecosoft_com/images/cs_bg.png": 1772,
	"./connect_ecosoft_com/images/cs_secret.png": 1773,
	"./connect_ecosoft_com/images/icon_bell_alert@2x.png": 1774,
	"./connect_ecosoft_com/images/icon_bell_warning@2x.png": 1775,
	"./connect_ecosoft_com/images/icon_cs.png": 1776,
	"./connect_ecosoft_com/images/icon_folder_plus@2x.png": 1777,
	"./connect_ecosoft_com/images/icon_line_blue@2x.png": 1778,
	"./connect_ecosoft_com/images/icon_line_lightblue@2x.png": 1779,
	"./connect_ecosoft_com/images/icon_line_lime@2x.png": 1780,
	"./connect_ecosoft_com/images/inst_dp@3x.png": 1781,
	"./connect_ecosoft_com/images/inst_pr@3x.png": 1782,
	"./connect_ecosoft_com/images/inst_ro@3x.png": 1783,
	"./connect_ecosoft_com/images/inst_tm@3x.png": 1784,
	"./connect_ecosoft_com/images/inst_wt@3x.png": 1785,
	"./connect_ecosoft_com/images/logo02.png": 1786,
	"./connect_ecosoft_com/images/logo03.png": 1787,
	"./connect_ecosoft_com/images/settings_icon01@2x.png": 1788,
	"./connect_ecosoft_com/images/settings_icon02@2x.png": 1789,
	"./connect_ecosoft_com/images/settings_icon03@2x.png": 1790,
	"./connect_ecosoft_com/images/settings_icon04@2x.png": 1791,
	"./connect_ecosoft_com/images/settings_icon05@2x.png": 1792,
	"./connect_ecosoft_com/images/stats-iotizr.png": 1793,
	"./connect_ecosoft_com/images/stats-pin.png": 1794,
	"./connect_ecosoft_com/images/user-aplix.png": 1795,
	"./connect_ecosoft_com/images/user-default01.png": 1796,
	"./connect_ecosoft_com/images/user-default02.png": 1797,
	"./connect_ecosoft_com/images/user-default03.png": 1798,
	"./connect_ecosoft_com/translations/english": 376,
	"./connect_ecosoft_com/translations/english.js": 376,
	"./connect_ecosoft_com/translations/german": 377,
	"./connect_ecosoft_com/translations/german.js": 377,
	"./connect_ecosoft_com/translations/japanese": 378,
	"./connect_ecosoft_com/translations/japanese.js": 378,
	"./connect_ecosoft_com/translations/russian": 379,
	"./connect_ecosoft_com/translations/russian.js": 379,
	"./images/badge-apple.png": 630,
	"./images/badge-google.png": 631,
	"./images/bg-guide.png": 632,
	"./images/cs_bg.png": 633,
	"./images/cs_mail.png": 634,
	"./images/cs_secret.png": 635,
	"./images/icon_bell_alert@2x.png": 121,
	"./images/icon_bell_warning@2x.png": 122,
	"./images/icon_cs.png": 636,
	"./images/icon_folder_plus@2x.png": 302,
	"./images/icon_line_blue@2x.png": 123,
	"./images/icon_line_lightblue@2x.png": 303,
	"./images/icon_line_lime@2x.png": 304,
	"./images/img-addequipment.png": 637,
	"./images/img-app01.png": 638,
	"./images/img-complete.png": 639,
	"./images/img-connect-flowsensor.png": 640,
	"./images/img-filter.png": 641,
	"./images/img-flowsensor.png": 642,
	"./images/img-guide-character.png": 643,
	"./images/img-guide-character@2x.png": 644,
	"./images/img-iotizr.png": 645,
	"./images/img-register-equipments.png": 646,
	"./images/img-register-location.png": 647,
	"./images/img-setup-iotizr.png": 648,
	"./images/inst_dp@3x.png": 305,
	"./images/inst_pr@3x.png": 306,
	"./images/inst_ro@3x.png": 307,
	"./images/inst_tm@3x.png": 308,
	"./images/inst_wt@3x.png": 309,
	"./images/location-default01.png": 649,
	"./images/location-default02.png": 650,
	"./images/location-default03.png": 651,
	"./images/location-default04.png": 652,
	"./images/location-default05.png": 653,
	"./images/location-default06.png": 654,
	"./images/location-default07.png": 655,
	"./images/location-default08.png": 656,
	"./images/location-default09.png": 657,
	"./images/location-default10.png": 658,
	"./images/location-default11.png": 659,
	"./images/logo.png": 660,
	"./images/logo02.png": 206,
	"./images/logo03.png": 310,
	"./images/ng1.png": 661,
	"./images/ng2.png": 662,
	"./images/ok1.png": 663,
	"./images/settings_icon01@2x.png": 311,
	"./images/settings_icon02@2x.png": 312,
	"./images/settings_icon03@2x.png": 313,
	"./images/settings_icon04@2x.png": 314,
	"./images/settings_icon05@2x.png": 664,
	"./images/stats-calendar.png": 665,
	"./images/stats-iotizr.png": 315,
	"./images/stats-pin.png": 316,
	"./images/user-aplix.png": 317,
	"./images/user-default01.png": 207,
	"./images/user-default02.png": 318,
	"./images/user-default03.png": 319,
	"./protectplus_britapro_com/images/badge-apple.png": 1799,
	"./protectplus_britapro_com/images/badge-google.png": 1800,
	"./protectplus_britapro_com/images/bg-guide.png": 1801,
	"./protectplus_britapro_com/images/cs_bg.png": 1802,
	"./protectplus_britapro_com/images/cs_mail.png": 1803,
	"./protectplus_britapro_com/images/cs_secret.png": 1804,
	"./protectplus_britapro_com/images/icon_bell_alert@2x.png": 1805,
	"./protectplus_britapro_com/images/icon_bell_warning@2x.png": 1806,
	"./protectplus_britapro_com/images/icon_cs.png": 1807,
	"./protectplus_britapro_com/images/icon_folder_plus@2x.png": 1808,
	"./protectplus_britapro_com/images/icon_line_blue@2x.png": 1809,
	"./protectplus_britapro_com/images/icon_line_lightblue@2x.png": 1810,
	"./protectplus_britapro_com/images/icon_line_lime@2x.png": 1811,
	"./protectplus_britapro_com/images/img-addequipment.png": 1812,
	"./protectplus_britapro_com/images/img-app01.png": 1813,
	"./protectplus_britapro_com/images/img-complete.png": 1814,
	"./protectplus_britapro_com/images/img-connect-flowsensor.png": 1815,
	"./protectplus_britapro_com/images/img-filter.png": 1816,
	"./protectplus_britapro_com/images/img-flowsensor.png": 1817,
	"./protectplus_britapro_com/images/img-guide-character.png": 1818,
	"./protectplus_britapro_com/images/img-guide-character@2x.png": 1819,
	"./protectplus_britapro_com/images/img-iotizr.png": 1820,
	"./protectplus_britapro_com/images/img-register-equipments.png": 1821,
	"./protectplus_britapro_com/images/img-register-location.png": 1822,
	"./protectplus_britapro_com/images/img-setup-iotizr.png": 1823,
	"./protectplus_britapro_com/images/inst_dp@3x.png": 1824,
	"./protectplus_britapro_com/images/inst_pr@3x.png": 1825,
	"./protectplus_britapro_com/images/inst_ro@3x.png": 1826,
	"./protectplus_britapro_com/images/inst_tm@3x.png": 1827,
	"./protectplus_britapro_com/images/inst_wt@3x.png": 1828,
	"./protectplus_britapro_com/images/location-default01.png": 1829,
	"./protectplus_britapro_com/images/location-default02.png": 1830,
	"./protectplus_britapro_com/images/location-default03.png": 1831,
	"./protectplus_britapro_com/images/location-default04.png": 1832,
	"./protectplus_britapro_com/images/location-default05.png": 1833,
	"./protectplus_britapro_com/images/location-default06.png": 1834,
	"./protectplus_britapro_com/images/location-default07.png": 1835,
	"./protectplus_britapro_com/images/location-default08.png": 1836,
	"./protectplus_britapro_com/images/location-default09.png": 1837,
	"./protectplus_britapro_com/images/location-default10.png": 1838,
	"./protectplus_britapro_com/images/location-default11.png": 1839,
	"./protectplus_britapro_com/images/logo02.png": 1840,
	"./protectplus_britapro_com/images/logo02.png.old.png": 1841,
	"./protectplus_britapro_com/images/logo03.png": 1842,
	"./protectplus_britapro_com/images/ng1.png": 1843,
	"./protectplus_britapro_com/images/ng2.png": 1844,
	"./protectplus_britapro_com/images/ok1.png": 1845,
	"./protectplus_britapro_com/images/settings_icon01@2x.png": 1846,
	"./protectplus_britapro_com/images/settings_icon02@2x.png": 1847,
	"./protectplus_britapro_com/images/settings_icon03@2x.png": 1848,
	"./protectplus_britapro_com/images/settings_icon04@2x.png": 1849,
	"./protectplus_britapro_com/images/settings_icon05@2x.png": 1850,
	"./protectplus_britapro_com/images/stats-calendar.png": 1851,
	"./protectplus_britapro_com/images/stats-iotizr.png": 1852,
	"./protectplus_britapro_com/images/stats-pin.png": 1853,
	"./protectplus_britapro_com/images/user-aplix.png": 1854,
	"./protectplus_britapro_com/images/user-default01.png": 1855,
	"./protectplus_britapro_com/images/user-default02.png": 1856,
	"./protectplus_britapro_com/images/user-default03.png": 1857,
	"./protectplus_britapro_com/translations/english": 380,
	"./protectplus_britapro_com/translations/english.js": 380,
	"./protectplus_britapro_com/translations/german": 381,
	"./protectplus_britapro_com/translations/german.js": 381,
	"./protectplus_britapro_com/translations/japanese": 382,
	"./protectplus_britapro_com/translations/japanese.js": 382,
	"./protectplus_britapro_com/translations/russian": 383,
	"./protectplus_britapro_com/translations/russian.js": 383
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./english": 159,
	"./english.js": 159,
	"./german": 160,
	"./german.js": 160,
	"./japanese": 161,
	"./japanese.js": 161,
	"./russian": 162,
	"./russian.js": 162
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 702;

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Signup_vue__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Signup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Signup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login_vue__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Activate_vue__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Activate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Activate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ResetPassword_vue__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_ResetPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Dashboard_vue__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Page404_vue__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Page404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Page404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Home_vue__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_WaterSystem_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_WaterSystem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_WaterSystem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemList_vue__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_WaterSystemList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SettingsPlugins_vue__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SettingsPlugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SettingsPlugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Account_vue__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Account_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Account_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CustomerList_vue__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CustomerList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_CustomerList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AccountUserInvite_vue__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AccountUserInvite_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_AccountUserInvite_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AccountOrganizationsUser_vue__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AccountOrganizationsUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_AccountOrganizationsUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AccountOrganizations_vue__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AccountOrganizations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_AccountOrganizations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AccountOrganizationsDetail_vue__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AccountOrganizationsDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_AccountOrganizationsDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AccountOrganizationPcList_vue__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AccountOrganizationPcList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_AccountOrganizationPcList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Settings_vue__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SettingsDisplay_vue__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SettingsDisplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_SettingsDisplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Profile_vue__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Profile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_UsageReport_vue__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_UsageReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_UsageReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Notifications_vue__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Notifications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_NotificationsMail_vue__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_NotificationsMail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_NotificationsMail_vue__);
/* eslint spaced-comment: 0 */













// Import Dashboard views

// 一時的に開発用にwatersystem単体画面を用意

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Signup_vue___default.a,
    meta: {
      title: 'Signup',
      requiresAuth: false,
      requiredRoles: []
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Login_vue___default.a,
    meta: {
      title: 'Login',
      requiresAuth: false,
      requiredRoles: []
    }
  }, {
    path: '/activate',
    name: 'Activate',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Activate_vue___default.a,
    meta: {
      title: 'Activate your account',
      requiresAuth: false,
      requiredRoles: []
    }
  }, {
    path: '/reset_password',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_ResetPassword_vue___default.a,
    meta: {
      title: 'Reset your password',
      requiresAuth: false,
      requiredRoles: []
    }
  }, {
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Dashboard_vue___default.a,
    children: [{
      path: 'home',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Home_vue___default.a,
      alias: '',
      meta: {
        title: 'Home',
        requiresAuth: true,
        requiredRoles: []
      }
    }, {
      path: '/watersystem/:id',
      name: 'WaterSystem',
      component: __WEBPACK_IMPORTED_MODULE_12__components_WaterSystem_vue___default.a,
      meta: {
        title: 'WaterSystem',
        requiresAuth: true,
        requiredRoles: [__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].role.Root]
      }
    }, {
      path: 'watersystem_list',
      name: 'WaterSystemList',
      component: __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemList_vue___default.a,
      meta: {
        title: 'WaterSystemList',
        requiresAuth: true,
        requiredRoles: []
      }
    }, {
      path: 'watersystem_list/:id',
      name: 'WaterSystemListId',
      component: __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemList_vue___default.a,
      meta: {
        title: 'WaterSystemList',
        requiresAuth: true,
        requiredRoles: []
      }
    }, {
      path: 'customer_list',
      name: 'CustomerList',
      component: __WEBPACK_IMPORTED_MODULE_16__components_CustomerList_vue___default.a,
      meta: {
        title: 'CustomerList',
        requiresAuth: true,
        requiredRoles: []
      }
    }, {
      path: 'settings',
      name: 'Settings',
      component: __WEBPACK_IMPORTED_MODULE_22__components_Settings_vue___default.a,
      meta: {
        title: 'Settings',
        requiresAuth: true,
        requiredRoles: []
      },
      children: [{
        path: 'display',
        name: 'display',
        component: __WEBPACK_IMPORTED_MODULE_23__components_SettingsDisplay_vue___default.a,
        meta: {
          title: 'Display Setting',
          requiresAuth: true,
          requiredRoles: []
        }
      }, {
        path: 'account',
        name: 'Account',
        component: __WEBPACK_IMPORTED_MODULE_15__components_Account_vue___default.a,
        alias: '',
        meta: {
          title: '',
          requiresAuth: true,
          requiredRoles: []
        },
        children: [{
          path: 'user_invite',
          name: 'UserInvite',
          component: __WEBPACK_IMPORTED_MODULE_17__components_AccountUserInvite_vue___default.a,
          meta: {
            title: 'User Invite',
            requiresAuth: true,
            requiredRoles: []
          }
        }, {
          path: 'pc_list',
          name: 'AccountOrganizationPcList',
          component: __WEBPACK_IMPORTED_MODULE_21__components_AccountOrganizationPcList_vue___default.a,
          meta: {
            title: 'P/C List',
            requiresAuth: true,
            requiredRoles: [__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].role.Root]
          }
        }, {
          path: 'organizations',
          name: 'Organizations',
          component: __WEBPACK_IMPORTED_MODULE_19__components_AccountOrganizations_vue___default.a,
          alias: '',
          meta: {
            title: 'Organization List',
            requiresAuth: true,
            requiredRoles: []
          },
          children: [{
            path: 'organizations_detail',
            name: 'AccountOrganizationsDetail',
            component: __WEBPACK_IMPORTED_MODULE_20__components_AccountOrganizationsDetail_vue___default.a,
            meta: {
              title: 'Organization Detail',
              requiresAuth: true,
              requiredRoles: []
            }
          }, {
            path: 'user_list',
            name: 'AccountOrganizationsUser',
            component: __WEBPACK_IMPORTED_MODULE_18__components_AccountOrganizationsUser_vue___default.a,
            meta: {
              title: 'User List',
              requiresAuth: true,
              requiredRoles: []
            }
          }] // organization list
        }]
      }, // account
      {
        path: 'plugins',
        name: 'Plugins',
        component: __WEBPACK_IMPORTED_MODULE_14__components_SettingsPlugins_vue___default.a,
        meta: {
          title: 'Plugins',
          requiresAuth: true,
          requiredRoles: []
        }
      }, {
        path: 'notifications',
        name: 'Notifications',
        component: __WEBPACK_IMPORTED_MODULE_26__components_Notifications_vue___default.a,
        alias: '',
        meta: {
          title: 'Notifications',
          requiresAuth: true,
          requiredRoles: []
        },
        children: [{
          path: 'notifications_mail',
          name: 'NotificationsMail',
          component: __WEBPACK_IMPORTED_MODULE_27__components_NotificationsMail_vue___default.a,
          meta: {
            title: 'Notification Mail',
            requiresAuth: true,
            requiredRoles: []
          }
        }]
      }]
    }, {
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_24__components_Profile_vue___default.a,
      meta: {
        title: 'Profile',
        requiresAuth: true,
        requiredRoles: []
      }
    }, {
      path: 'usage_report',
      name: 'Usage Report',
      component: __WEBPACK_IMPORTED_MODULE_25__components_UsageReport_vue___default.a,
      meta: {
        title: 'Usage Report',
        requiresAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    // not found handler
    path: '*',
    name: 'Page404',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Page404_vue___default.a,
    meta: {
      requiresAuth: false,
      requiredRoles: []
    }
  }],
  mode: 'history',
  base: '/dashboard/',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  // タイトル設定
  var domainConfig = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDomainConfig();
  var title = domainConfig.title;
  document.title = to.meta.title + title;

  // 認証が必要なページかどうか
  if (to.meta.requiresAuth) {
    // ログイン済みかどうか
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.token === null) {
      console.log('Not authenticated');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('logout').then(function () {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_MESSAGE', {
          title: '',
          message: 'Please login',
          level: 'error'
        });
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_LOGOUTPAGE', to.path);
        next({
          path: '/login'
        });
      });
      // 必要な role があるか
    } else if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.userHasThoseRoles(to.meta.requiredRoles)) {
      console.log('do not have permission');
      // ログアウト処理
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('logout').then(function () {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_MESSAGE', {
          title: '',
          message: 'Access Denied',
          level: 'error'
        });
        next({
          path: '/login'
        });
      }).catch(function (err) {
        console.log(err);
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1354);

__webpack_require__(1102);

__webpack_require__(1109);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1114), __esModule: true };

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(1618).polyfill();


/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}(this,function(){return function(e){function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var t={};return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},n.p="",n(n.s=0)}([function(e,n,t){"use strict";function r(e){u(_,e)}function o(){return _.id?[].concat(_.id):[]}function i(){}function a(e){return new Promise(function(n,t){var r=document.head||document.getElementsByTagName("head")[0],o=document.createElement("script");o.async=!0,o.src=e,o.charset="utf8",r.appendChild(o),o.onload=n,o.onerror=t})}function c(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}function u(e,n){return Object.keys(n).forEach(function(t){if(e[t]&&"object"==typeof e[t])return void u(e[t],n[t]);e[t]=n[t]}),e}function f(){return Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function(e){return-1!==e.src.indexOf("analytics")}).length>0}function l(e){return e.replace(/-/gi,"")}function s(){return new Promise(function(e,n){var t=setInterval(function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))},10)})}function d(e,n){if(o().length>1){return l(n)+"."+e}return e}function p(e){var n=Object.keys(e).reduce(function(n,t,r,o){var i=r===o.length-1;return n+=t+"="+e[t]+(i?"":"&")},"");return""!==n?"?"+n:""}function v(e){return-1!==B.ignoreRoutes.indexOf(e)}function g(e){return e.query&&e.params}function h(e){return e.currentRoute}function y(e){for(var n=arguments.length,t=Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];o().forEach(function(n){var r;if(void 0===window.ga||"string"!=typeof n)return void B.untracked.push({method:d(e,n),arguments:[].concat(t)});(r=window).ga.apply(r,[d(e,n)].concat(t))})}function m(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];if("object"==typeof n[0]&&n[0].constructor===Object)return void y("set",n[0]);y("set",n[0],n[1])}function b(){var e=o();B.debug.enabled&&(window.ga_debug={trace:B.debug.trace}),e.forEach(function(n){var t=l(n),r=e.length>1?D({},B.fields,{name:t}):B.fields;window.ga("create",n,"auto",r)}),B.beforeFirstHit();var n=B.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?y("require",t,n.options):y("require",t)}B.linkers.length>0&&(y("require","linker"),y("linker:autoLink",B.linkers)),B.debug.sendHitTask||m("sendHitTask",null)}function w(e){if(Array.isArray(e)){for(var n=0,t=Array(e.length);n<e.length;n++)t[n]=e[n];return t}return Array.from(e)}function k(){var e=B.untracked,n=B.autoTracking,t=e.length;if(t&&n.untracked)for(;t--;){var r=e[t];y.apply(void 0,[r.method].concat(w(r.arguments))),e.splice(t,1)}}function O(){for(var e=void 0,n=arguments.length,t=Array(n),r=0;r<n;r++)t[r]=arguments[r];if(h(t[0])&&(e=t[0].currentRoute),g(t[0])&&(e=t[0]),e){var o=B.router,i=B.autoTracking,a=i.transformQueryString,u=i.prependBase,f=p(e.query),l=o&&o.options.base,s=u&&l,d=e.path+(a?f:"");return d=s?c(l,d):d,m("page",d),void y("send","pageview",M({page:d,title:e.name,location:window.location.href},"function"==typeof t[1]&&{hitCallback:t[1]}))}y.apply(void 0,["send","pageview"].concat(t))}function j(e){if(!v(e)){var n=B.autoTracking,t=e.meta.analytics,r=void 0===t?{}:t,o=r.pageviewTemplate||n.pageviewTemplate;O(o?o(e):e)}}function x(){var e=B.router,n=B.autoTracking;n.page&&e&&(n.pageviewOnLoad&&j(e.currentRoute),B.router.afterEach(function(t,r){var o=n.skipSamePath,i=n.shouldRouterUpdate;o&&t.path===r.path||("function"!=typeof i||i(t,r))&&setTimeout(function(){j(e.currentRoute)},0)}))}function T(){if("undefined"!=typeof document){var e=B.id,n=B.debug,t=B.checkDuplicatedScript,r=B.disableScriptLoader,o=n.enabled?"analytics_debug":"analytics",i="https://www.google-analytics.com/"+o+".js";if(!e)throw new Error("[vue-analytics] Please enter a Google Analytics tracking ID");return new Promise(function(e,n){return t&&f(i)||r?e():a(i).then(function(){e()}).catch(function(){n("[vue-analytics] It's not possible to load Google Analytics script")})}).then(function(){return s()}).then(function(){return"function"==typeof e?e():e}).then(function(e){B.id=e,b(),G(),B.ready(),x(),k()}).catch(function(e){console.error(e)})}}function A(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];y.apply(void 0,["send","event"].concat(n))}function P(e){y("send","exception",{exDescription:e,exFatal:arguments.length>1&&void 0!==arguments[1]&&arguments[1]})}function E(e,n){var t=B.autoTracking.exception,r=e.message||e;t&&n.$ga.exception(r,!0)}function q(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];y.apply(void 0,["send","social"].concat(n))}function R(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];y.apply(void 0,["send","timing"].concat(n))}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function H(e){r(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}),e.directive("ga",J),e.prototype.$ga=e.$ga=z,e.config.errorHandler||(e.config.errorHandler=E),T()}Object.defineProperty(n,"__esModule",{value:!0});var I=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},L={id:null,router:null,fields:{},ignoreRoutes:[],linkers:[],commands:{},set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{shouldRouterUpdate:null,skipSamePath:!1,exception:!1,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:i,ready:i,untracked:[]},_=I({},L),B=_,D=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},F=function(){if(2==arguments.length)return void y("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1]);y("require",arguments.length<=0?void 0:arguments[0])},$=function(){B.set.forEach(function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');m(n,t)})},C=function(){var e=["ec","ecommerce"];B.require.forEach(function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!=typeof n)throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;if(n.options)return void F(t,n.options);F(t)})},G=function(){$(),C()},M=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},N=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},Q=function(e){return(B.ecommerce.enhanced?"ec":"ecommerce")+":"+e},U=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"],W=U.reduce(function(e,n){return N({},e,S({},n,function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];y.apply(void 0,[Q(n)].concat(t))}))},{}),z={event:A,exception:P,page:O,query:y,require:F,set:m,social:q,time:R,untracked:k,ecommerce:W,commands:B.commands},J={inserted:function(e,n,t){var r=n.value;e.addEventListener("click",function(){var e="string"==typeof r?B.commands[r]:r;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)})}};n.default=H,t.d(n,"onAnalyticsReady",function(){return s})}])});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue__);
/* unused harmony reexport FullCalendar */


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function (Vue, options) {
        Vue.component('full-calendar', __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue___default.a);
    },
});



/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-i18n v7.4.0 
 * (c) 2018 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * utilites
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function getOldChoiceIndexFixed (choice) {
  return choice
    ? choice > 1
      ? 1
      : 0
    : 1
}

function getChoiceIndex (choice, choicesLength) {
  choice = Math.abs(choice);

  if (choicesLength === 2) { return getOldChoiceIndexFixed(choice) }

  return choice ? Math.min(choice, 2) : 0
}

function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

var canUseDateTimeFormat =
  typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined';

var canUseNumberFormat =
  typeof Intl !== 'undefined' && typeof Intl.NumberFormat !== 'undefined';

/*  */

function extend (Vue) {
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$t', {
    get: function get () {
      var this$1 = this;

      return function (key) {
        var values = [], len = arguments.length - 1;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

        var i18n = this$1.$i18n;
        return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1 ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$tc', {
    get: function get$1 () {
      var this$1 = this;

      return function (key, choice) {
        var values = [], len = arguments.length - 2;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

        var i18n = this$1.$i18n;
        return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this$1, choice ].concat( values ))
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$te', {
    get: function get$2 () {
      var this$1 = this;

      return function (key, locale) {
        var i18n = this$1.$i18n;
        return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$d', {
    get: function get$3 () {
      var this$1 = this;

      return function (value) {
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

        return (ref = this$1.$i18n).d.apply(ref, [ value ].concat( args ))
        var ref;
      }
    }
  });
  // $FlowFixMe
  Object.defineProperty(Vue.prototype, '$n', {
    get: function get$4 () {
      var this$1 = this;

      return function (value) {
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

        return (ref = this$1.$i18n).n.apply(ref, [ value ].concat( args ))
        var ref;
      }
    }
  });
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root.$i18n;
          options.i18n.formatter = this.$root.$i18n.formatter;
          options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }
      } else {
        if (false) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    if (this._subscribing) {
      this._i18n.unsubscribeDataChanging(this);
      delete this._subscribing;
    }

    if (this._i18nWatcher) {
      this._i18nWatcher();
      delete this._i18nWatcher;
    }

    if (this._localeWatcher) {
      this._localeWatcher();
      delete this._localeWatcher;
    }

    this._i18n = null;
  }
};

/*  */

var component = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;
    var parent = ref.parent;

    var i18n = parent.$i18n;

    children = (children || []).filter(function (child) {
      return child.tag || (child.text = child.text.trim())
    });

    if (!i18n) {
      if (false) {
        warn('Cannot find VueI18n instance!');
      }
      return children
    }

    var path = props.path;
    var locale = props.locale;

    var params = {};
    var places = props.places || {};

    var hasPlaces = Array.isArray(places)
      ? places.length > 0
      : Object.keys(places).length > 0;

    var everyPlace = children.every(function (child) {
      if (child.data && child.data.attrs) {
        var place = child.data.attrs.place;
        return (typeof place !== 'undefined') && place !== ''
      }
    });

    if (hasPlaces && children.length > 0 && !everyPlace) {
      warn('If places prop is set, all child elements must have place prop set.');
    }

    if (Array.isArray(places)) {
      places.forEach(function (el, i) {
        params[i] = el;
      });
    } else {
      Object.keys(places).forEach(function (key) {
        params[key] = places[key];
      });
    }

    children.forEach(function (child, i) {
      var key = everyPlace
        ? ("" + (child.data.attrs.place))
        : ("" + i);
      params[key] = child;
    });

    return h(props.tag, data, i18n.i(path, locale, params))
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t$1(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  if (localeEqual(el, vnode) && looseEqual(binding.value, binding.oldValue)) { return }

  t$1(el, binding, vnode);
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('not exist Vue instance in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('not exist VueI18n instance in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t$1 (el, binding, vnode) {
  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  if (!path && !locale && !args) {
    warn('not support value type');
    return
  }

  if (!path) {
    warn('required `path` in v-t directive');
    return
  }

  var vm = vnode.context;
  el._vt = el.textContent = (ref$1 = vm.$i18n).t.apply(ref$1, [ path ].concat( makeParams(locale, args) ));
  el._locale = vm.$i18n.locale;
  var ref$1;
}

function parseValue (value) {
  var path;
  var locale;
  var args;

  if (typeof value === 'string') {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
  }

  return { path: path, locale: locale, args: args }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue) {
  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {
    warn('already installed.');
    return
  }
  install.installed = true;

  /* istanbul ignore if */
  if (false) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  Object.defineProperty(Vue.prototype, '$i18n', {
    get: function get () { return this._i18n }
  });

  extend(Vue);
  Vue.mixin(mixin);
  Vue.directive('t', { bind: bind, update: update });
  Vue.component(component.name, component);

  // use object-based merge strategy
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = strats.methods;
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};

var RE_TOKEN_LIST_VALUE = /^(\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== '}') {
        sub += char;
        char = format[position++];
      }

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (false) {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path paerser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30: // 0
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  // a-z, A-Z
  if ((code >= 0x61 && code <= 0x7A) || (code >= 0x41 && code <= 0x5A)) {
    return 'ident'
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) { return 'number' }

  return 'else'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





function empty (target) {
  /* istanbul ignore else */
  if (Array.isArray(target)) {
    return target.length === 0
  } else {
    return false
  }
}

var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (empty(paths)) {
    return null
  } else {
    var length = paths.length;
    var ret = null;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        last = null;
        break
      }
      last = value;
      i++;
    }

    ret = last;
    return ret
  }
};

/*  */

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || new BaseFormatter();
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : !!options.silentTranslationWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    return !isNull(this$1._path.getPathValue(message, key))
  };

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: {},messages: {},dateTimeFormats: {},numberFormats: {},locale: {},fallbackLocale: {},missing: {},formatter: {},silentTranslationWarn: {} };

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm) {
  if (!isNull(result)) { return result }
  if (this.missing) {
    this.missing.apply(null, [locale, key, vm]);
  } else {
    if (false) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }
  return key
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {
        warn(("Value of key '" + key + "' is not a string!"));
      }
      return null
    }
  }

  // Check for the existance of links within the translated string
  if (ret.indexOf('@:') >= 0) {
    ret = this._link(locale, message, ret, host, interpolateMode, values);
  }

  return !values ? ret : this._render(ret, interpolateMode, values)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values
) {
    var this$1 = this;

  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(/(@:[\w\-_|.]+)/g);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    // Remove the leading @:
    var linkPlaceholder = link.substr(2);
    // Translate the link
    var translated = this$1._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values
    );

    if (this$1._isFallbackRoot(translated)) {
      if (false) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this$1._root) { throw Error('unexpected error') }
      var root = this$1._root;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this$1._warnDefault(locale, linkPlaceholder, translated, host);

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values) {
  var ret = this._formatter.interpolate(message, values);
  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' ? ret.join('') : ret
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var res =
    this._interpolate(locale, messages[locale], key, host, interpolateMode, args);
  if (!isNull(res)) { return res }

  res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args);
  if (!isNull(res)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
    }
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];

  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
    var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host)
  }
    var ref;
};

VueI18n.prototype.t = function t (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
    var ref;
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host)
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (typeof locale !== 'string') {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
    host,
    choice
) {
    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];

    if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }
  return fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
    var ref;
};

VueI18n.prototype.tc = function tc (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
    var ref;
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  this._vm.messages[locale] = message;
};

  VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  this._vm.messages[locale] = Vue.util.extend(this._vm.messages[locale] || {}, message);
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.dateTimeFormats[locale] = format;
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.dateTimeFormats[locale] = Vue.util.extend(this._vm.dateTimeFormats[locale] || {}, format);
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + " datetime formats."));
    }
    _locale = fallback;
    formats = dateTimeFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Date value due to not support Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to datetime localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.numberFormats[locale] = format;
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.numberFormats[locale] = Vue.util.extend(this._vm.numberFormats[locale] || {}, format);
};

VueI18n.prototype._localizeNumber = function _localizeNumber (
  value,
  locale,
  fallback,
  numberFormats,
  key
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' number formats from '" + locale + " number formats."));
    }
    _locale = fallback;
    formats = numberFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._numberFormatters[id];
    if (!formatter) {
      formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._n = function _n (value, locale, key) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Date value due to not support Intl.NumberFormat.');
    return ''
  }

  if (!key) {
    return new Intl.NumberFormat(locale).format(value)
  }

  var ret =
    this._localizeNumber(value, locale, this.fallbackLocale, this._getNumberFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to number localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.n(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._n(value, locale, key)
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

VueI18n.availabilities = {
  dateTimeFormat: canUseDateTimeFormat,
  numberFormat: canUseNumberFormat
};
VueI18n.install = install;
VueI18n.version = '7.4.0';

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueI18n);
}

/* harmony default export */ __webpack_exports__["a"] = (VueI18n);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1636)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(1923),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1087),
  /* template */
  __webpack_require__(1919),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1100),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 70);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'colorable',

  props: {
    color: String
  },

  data: function data() {
    return {
      defaultColor: null
    };
  },


  computed: {
    computedColor: function computedColor() {
      return this.color || this.defaultColor;
    }
  },

  methods: {
    addBackgroundColorClassChecks: function addBackgroundColorClassChecks() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.computedColor;

      var classes = Object.assign({}, obj);

      if (color) {
        classes[color] = true;
      }

      return classes;
    },
    addTextColorClassChecks: function addTextColorClassChecks() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.computedColor;

      var classes = Object.assign({}, obj);

      if (color) {
        var _color$trim$split = color.trim().split(' '),
            _color$trim$split2 = _slicedToArray(_color$trim$split, 2),
            colorName = _color$trim$split2[0],
            colorModifier = _color$trim$split2[1];

        classes[colorName + '--text'] = true;
        colorModifier && (classes['text--' + colorModifier] = true);
      }

      return classes;
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'themeable',

  props: {
    dark: Boolean,
    light: Boolean
  },

  computed: {
    themeClasses: function themeClasses() {
      return {
        'theme--light': this.light,
        'theme--dark': this.dark
      };
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* unused harmony export directiveConfig */
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["h"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
/* harmony export (immutable) */ __webpack_exports__["i"] = getZIndex;
/* harmony export (immutable) */ __webpack_exports__["f"] = escapeHTML;
/* harmony export (immutable) */ __webpack_exports__["g"] = filterObjectOnKeys;
/* unused harmony export filterChildren */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var name = arguments[2];

  name = name || c.replace(/__/g, '-');

  return {
    name: 'v-' + name,
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    name: name,

    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};
      if (!Object.isExtensible(context.data.on)) {
        context.data.on = _extends({}, context.data.on);
      }

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = context.props.origin;
        el.style.webkitTransformOrigin = context.props.origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    name: name,

    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
  var zi = document.defaultView.getComputedStyle(el).getPropertyValue('z-index');
  if (isNaN(zi)) return getZIndex(el.parentNode);

  return zi;
}

var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};

function escapeHTML(str) {
  return str.replace(/[&<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
}

function filterObjectOnKeys(obj, keys) {
  var filtered = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (typeof obj[key] !== 'undefined') {
      filtered[key] = obj[key];
    }
  }

  return filtered;
}

function filterChildren() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tag = arguments[1];

  return array.filter(function (child) {
    return child.componentOptions && child.componentOptions.Ctor.options.name === tag;
  });
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(90);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inject;
/* harmony export (immutable) */ __webpack_exports__["b"] = provide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function generateWarning(child, parent) {
  return function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["b" /* consoleWarn */])('The ' + child + ' component must be used inside a ' + parent);
  };
}

function inject(namespace, child, parent) {
  var defaultImpl = child && parent ? {
    register: generateWarning(child, parent),
    unregister: generateWarning(child, parent)
  } : null;

  return {
    name: 'registrable-inject',

    inject: _defineProperty({}, namespace, {
      default: defaultImpl
    })
  };
}

function provide(namespace) {
  return {
    name: 'registrable-provide',

    methods: {
      register: null,
      unregister: null
    },
    provide: function provide() {
      return _defineProperty({}, namespace, {
        register: this.register,
        unregister: this.unregister
      });
    }
  };
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = consoleWarn;
/* harmony export (immutable) */ __webpack_exports__["a"] = consoleError;
function createMessage(message, componentInstance) {
  var componentInfo = componentInstance ? ' in "' + componentInstance.$options.name + '"' : '';
  return '[Vuetify] ' + message + componentInfo;
}

function consoleWarn(message) {
  var componentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  console.warn(createMessage(message, componentInstance));
}

function consoleError(message) {
  var componentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  console.error(createMessage(message, componentInstance));
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = factory;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function factory() {
  var _watch;

  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'input';

  return {
    name: 'toggleable',

    model: { prop: prop, event: event },

    props: _defineProperty({}, prop, { required: false }),

    data: function data() {
      return {
        isActive: !!this[prop]
      };
    },


    watch: (_watch = {}, _defineProperty(_watch, prop, function (val) {
      this.isActive = !!val;
    }), _defineProperty(_watch, 'isActive', function isActive(val) {
      !!val !== this[prop] && this.$emit(event, val);
    }), _watch)
  };
}

var Toggleable = factory();

/* harmony default export */ __webpack_exports__["a"] = (Toggleable);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VBottomSheetTranstion */
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VTabTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VTabReverseTransition; });
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VScaleTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* unused harmony export VRowExpandTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(40);




// Component specific transitions
var VBottomSheetTranstion = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('bottom-sheet-transition');
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', Object(__WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */])());
var VRowExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('row-expand-transition', Object(__WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */])('datatable__expand-col--expanded'));

/* harmony default export */ __webpack_exports__["g"] = (install);
/* istanbul ignore next */
function install(Vue) {
  Vue.component('v-bottom-sheet-transition', VBottomSheetTranstion);
  Vue.component('v-carousel-transition', VCarouselTransition);
  Vue.component('v-carousel-reverse-transition', VCarouselReverseTransition);
  Vue.component('v-dialog-transition', VDialogTransition);
  Vue.component('v-dialog-bottom-transition', VDialogBottomTransition);
  Vue.component('v-fab-transition', VFabTransition);
  Vue.component('v-fade-transition', VFadeTransition);
  Vue.component('v-menu-transition', VMenuTransition);
  Vue.component('v-scale-transition', VScaleTransition);
  Vue.component('v-slide-x-transition', VSlideXTransition);
  Vue.component('v-slide-x-reverse-transition', VSlideXReverseTransition);
  Vue.component('v-slide-y-transition', VSlideYTransition);
  Vue.component('v-slide-y-reverse-transition', VSlideYReverseTransition);
  Vue.component('v-tab-reverse-transition', VTabReverseTransition);
  Vue.component('v-tab-transition', VTabTransition);
  Vue.component('v-expand-transition', VExpandTransition);
  Vue.component('v-row-expand-transition', VRowExpandTransition);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function closeConditional() {
  return false;
}

function directive(e, el, binding) {
  // Args may not always be supplied
  binding.args = binding.args || {};

  // If no closeConditional was supplied assign a default
  var isActive = binding.args.closeConditional || closeConditional;

  // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components
  if (!e || isActive(e) === false) return;

  // If click was triggered programmaticaly (domEl.click()) then
  // it shouldn't be treated as click-outside
  // Chrome/Firefox support isTrusted property
  // IE/Edge support pointerType property (empty if not triggered
  // by pointing device)
  if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) return;

  // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)
  var elements = (binding.args.include || function () {
    return [];
  })();
  // Add the root element for the component this directive was defined on
  elements.push(el);

  // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occure before
  // the bubbling click event on any outside elements.
  !clickedInEls(e, elements) && setTimeout(function () {
    isActive(e) && binding.value();
  }, 0);
}

function clickedInEls(e, elements) {
  // Get position of click
  var x = e.clientX,
      y = e.clientY;
  // Loop over all included elements to see if click was in any of them

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      if (clickedInEl(el, x, y)) return true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function clickedInEl(el, x, y) {
  // Get bounding rect for element
  // (we're in capturing event and we want to check for multiple elements,
  //  so can't use target.)
  var b = el.getBoundingClientRect();
  // Check if the click was in the element's bounding rect

  return x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'click-outside',

  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  inserted: function inserted(el, binding) {
    var onClick = function onClick(e) {
      return directive(e, el, binding);
    };
    // iOS does not recognize click events on document
    // or body, this is the entire purpose of the v-app
    // component and [data-app], stop removing this
    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
    app.addEventListener('click', onClick, true);
    el._clickOutside = onClick;
  },
  unbind: function unbind(el) {
    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
    app && app.removeEventListener('click', el._clickOutside, true);
    delete el._clickOutside;
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _touchstart = function _touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var _touchend = function _touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var _touchmove = function _touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  var dirRatio = 0.5;
  var minDistance = 16;
  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
    wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
    wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
  }

  if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
    wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
    wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
  }
};

function inserted(el, _ref, _ref2) {
  var value = _ref.value;
  var context = _ref2.context;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || { passive: true

    // Needed to pass unit tests
  };if (!target) return;

  var handlers = {
    touchstart: function touchstart(e) {
      return _touchstart(e, wrapper);
    },
    touchend: function touchend(e) {
      return _touchend(e, wrapper);
    },
    touchmove: function touchmove(e) {
      return _touchmove(e, wrapper);
    }
  };
  target._touchHandlers = Object.assign(Object(target._touchHandlers), _defineProperty({}, context._uid, handlers));
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(handlers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      target.addEventListener(eventName, handlers[eventName], options);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function unbind(el, _ref3, _ref4) {
  var value = _ref3.value;
  var context = _ref4.context;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  var handlers = target._touchHandlers[context._uid];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.keys(handlers)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var eventName = _step2.value;

      target.removeEventListener(eventName, handlers[eventName]);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  delete target._touchHandlers[context._uid];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'touch',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(109);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */]);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = binding.value;
  var options = binding.options || { passive: true };

  window.addEventListener('resize', callback, options);
  el._onResize = {
    callback: callback,
    options: options
  };

  if (!binding.modifiers || !binding.modifiers.quiet) {
    callback();
  }
}

function unbind(el, binding) {
  var _el$_onResize = el._onResize,
      callback = _el$_onResize.callback,
      options = _el$_onResize.options;


  window.removeEventListener('resize', callback, options);
  delete el._onResize;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resize',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = factory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


function factory() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var props = {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  };

  return {
    name: 'positionable',
    props: selected.length ? Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* filterObjectOnKeys */])(props, selected) : props
  };
}

/* harmony default export */ __webpack_exports__["a"] = (factory());

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_ripple__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routable',

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_0__directives_ripple__["a" /* default */]
  },

  props: {
    activeClass: String,
    append: Boolean,
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: undefined
    },
    exactActiveClass: String,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: [Boolean, Object],
    tag: String,
    target: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = _defineProperty({
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple && !this.disabled ? this.ripple : false
        }]
      }, this.to ? 'nativeOn' : 'on', _extends({}, this.$listeners, {
        click: this.click
      }));

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        // Add a special activeClass hook
        // for component level styles
        var activeClass = this.activeClass;
        var exactActiveClass = this.exactActiveClass || activeClass;

        if (this.proxyClass) {
          activeClass += ' ' + this.proxyClass;
          exactActiveClass += ' ' + this.proxyClass;
        }

        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        Object.assign(data.props, {
          to: this.to,
          exact: exact,
          activeClass: activeClass,
          exactActiveClass: exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          if (this.href) data.attrs.href = this.href;
          if (this.target) data.attrs.target = this.target;
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createNativeLocaleFormatter__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monthChange__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pad__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createNativeLocaleFormatter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__monthChange__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__pad__["a"]; });






/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applicationable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positionable__ = __webpack_require__(12);


function applicationable(value) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return {
    name: 'applicationable',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__positionable__["b" /* factory */])(['absolute', 'fixed'])],

    props: {
      app: Boolean
    },

    computed: {
      applicationProperty: function applicationProperty() {
        return value;
      }
    },

    watch: {
      // If previous value was app
      // reset the provided prop
      app: function app(x, prev) {
        prev ? this.removeApplication(true) : this.callUpdate();
      }
    },

    activated: function activated() {
      this.callUpdate();
    },
    created: function created() {
      for (var i = 0, length = events.length; i < length; i++) {
        this.$watch(events[i], this.callUpdate);
      }
      this.callUpdate();
    },
    mounted: function mounted() {
      this.callUpdate();
    },
    deactivated: function deactivated() {
      this.removeApplication();
    },
    destroyed: function destroyed() {
      this.removeApplication();
    },


    methods: {
      callUpdate: function callUpdate() {
        if (!this.app) return;

        this.$vuetify.application.bind(this._uid, this.applicationProperty, this.updateApplication());
      },
      removeApplication: function removeApplication(force) {
        if (!force && !this.app) return;

        this.$vuetify.application.unbind(this._uid, this.applicationProperty);
      },

      updateApplication: function updateApplication() {}
    }
  };
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Bootable
 * @mixin
 *
 * Used to add lazy content functionality to components
 * Looks for change in "isActive" to automatically boot
 * Otherwise can be set manually
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bootable',

  data: function data() {
    return {
      isBooted: false
    };
  },

  props: {
    lazy: Boolean
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.isBooted || !this.lazy || this.isActive ? content : null;
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  el.style['transform'] = value;
  el.style['webkitTransform'] = value;
}

var ripple = {
  /**
   * @param {Event} e
   * @param {Element} el
   * @param {{ class?: string, center?: boolean }} [value={}]
   */
  show: function show(e, el) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!el._ripple || !el._ripple.enabled) {
      return;
    }

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    if (!el._ripple || !el._ripple.enabled) return;

    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}

function rippleShow(e) {
  var value = {};
  var element = e.currentTarget;
  value.center = element._ripple.centered;
  if (element._ripple.class) {
    value.class = element._ripple.class;
  }
  ripple.show(e, element, value);
}

function rippleHide(e) {
  ripple.hide(e.currentTarget);
}

function updateRipple(el, binding, wasEnabled) {
  var enabled = isRippleEnabled(binding.value);
  if (!enabled) {
    ripple.hide(el);
  }
  el._ripple = el._ripple || {};
  el._ripple.enabled = enabled;
  var value = binding.value || {};
  if (value.center) {
    el._ripple.centered = true;
  }
  if (value.class) {
    el._ripple.class = binding.value.class;
  }
  if (enabled && !wasEnabled) {
    if ('ontouchstart' in window) {
      el.addEventListener('touchend', rippleHide, false);
      el.addEventListener('touchcancel', rippleHide, false);
    }

    el.addEventListener('mousedown', rippleShow, false);
    el.addEventListener('mouseup', rippleHide, false);
    el.addEventListener('mouseleave', rippleHide, false);
    // Anchor tags can be dragged, causes other hides to fail - #1537
    el.addEventListener('dragstart', rippleHide, false);
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}

function removeListeners(el) {
  el.removeEventListener('touchstart', rippleShow, false);
  el.removeEventListener('mousedown', rippleShow, false);
  el.removeEventListener('touchend', rippleHide, false);
  el.removeEventListener('touchcancel', rippleHide, false);
  el.removeEventListener('mouseup', rippleHide, false);
  el.removeEventListener('mouseleave', rippleHide, false);
  el.removeEventListener('dragstart', rippleHide, false);
}

function directive(el, binding) {
  updateRipple(el, binding, false);
}

function unbind(el, binding) {
  delete el._ripple;
  removeListeners(el);
}

function update(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }

  var wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ripple',
  bind: directive,
  unbind: unbind,
  update: update
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loadable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validatable__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VIcon__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input',

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__loadable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__validatable__["a" /* default */]],

  data: function data() {
    return {
      isFocused: false,
      tabFocused: false,
      internalTabIndex: null,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    readonly: Boolean,
    required: Boolean,
    tabindex: {
      default: 0
    },
    toggleKeys: {
      type: Array,
      default: function _default() {
        return [13, 32];
      }
    },
    value: {
      required: false
    }
  },

  computed: {
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--async-loading': this.loading !== false,
        'input-group--focused': this.isFocused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return !!this.inputValue;
    }
  },

  methods: {
    groupFocus: function groupFocus(e) {},
    groupBlur: function groupBlur(e) {
      this.tabFocused = false;
    },
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var messages = null;

      if (this.hint && (this.isFocused || this.persistentHint) && !this.validations.length) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = [this.genError(this.validations[0])];
      }

      return this.$createElement('transition', {
        props: {
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__messages input-group__hint',
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__messages input-group__error'
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var defaultCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var shouldClear = type === 'append' && this.clearable && this.isDirty;
      var icon = shouldClear ? 'clear' : this[type + 'Icon'];
      var callback = shouldClear ? this.clearableCallback : this[type + 'IconCb'] || defaultCallback;

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', !!callback), _defineProperty(_class, 'input-group__icon-clearable', shouldClear), _class),
        props: {
          disabled: this.disabled
        },
        on: {
          click: function click(e) {
            if (!callback) return;

            e.stopPropagation();
            callback();
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultAppendCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.disabled ? -1 : this.internalTabIndex || this.tabindex
        },
        on: {
          focus: this.groupFocus,
          blur: this.groupBlur,
          click: function click() {
            return _this.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this.toggle) return;

            if (_this.toggleKeys.includes(e.keyCode)) {
              e.preventDefault();
              _this.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon || this.clearable) {
        wrapperChildren.push(this.genIcon('append', defaultAppendCallback));
      }

      var progress = this.genProgress();
      progress && detailsChildren.push(progress);

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      !this.hideDetails && detailsChildren.push(this.genMessages());

      if (this.counter) {
        detailsChildren.push(this.genCounter());
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function searchChildren(children) {
  var results = [];
  for (var index = 0; index < children.length; index++) {
    var child = children[index];
    if (child.isActive && child.isDependent) {
      results.push(child);
    } else {
      results.push.apply(results, _toConsumableArray(searchChildren(child.$children)));
    }
  }

  return results;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dependent',

  data: function data() {
    return {
      closeDependents: true,
      isDependent: true
    };
  },


  methods: {
    getOpenDependents: function getOpenDependents() {
      if (this.closeDependents) return searchChildren(this.$children);

      return [];
    },
    getOpenDependentElements: function getOpenDependentElements() {
      var result = [];
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        result.push.apply(result, _toConsumableArray(openDependents[index].getClickableDependentElements()));
      }

      return result;
    },
    getClickableDependentElements: function getClickableDependentElements() {
      var result = [this.$el];
      if (this.$refs.content) result.push(this.$refs.content);
      result.push.apply(result, _toConsumableArray(this.getOpenDependentElements()));

      return result;
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) return;

      var openDependents = this.getOpenDependents();
      for (var index = 0; index < openDependents.length; index++) {
        openDependents[index].isActive = false;
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCardActions */
/* unused harmony export VCardText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(119);
/* unused harmony reexport VCard */
/* unused harmony reexport VCardMedia */
/* unused harmony reexport VCardTitle */





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]);
  Vue.component(VCardActions.name, VCardActions);
  Vue.component(VCardText.name, VCardText);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */]);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_ripple__ = __webpack_require__(17);


/** @mixin */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rippleable',

  directives: { Ripple: __WEBPACK_IMPORTED_MODULE_0__directives_ripple__["a" /* default */] },

  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },

  methods: {
    genRipple: function genRipple() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { directives: [] };

      data.class = this.rippleClasses || 'input-group--selection-controls__ripple';
      data.directives.push({
        name: 'ripple',
        value: this.ripple && !this.disabled && { center: true }
      });
      data.on = Object.assign({
        click: this.toggle
      }, this.$listeners);

      return this.$createElement('div', data);
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var padStart = function padStart(string, targetLength, padString) {
  targetLength = targetLength >> 0;
  string = String(string);
  padString = String(padString);
  if (string.length > targetLength) {
    return String(string);
  }

  targetLength = targetLength - string.length;
  if (targetLength > padString.length) {
    padString += padString.repeat(targetLength / padString.length);
  }
  return padString.slice(0, targetLength) + String(string);
};

/* harmony default export */ __webpack_exports__["a"] = (function (n) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return padStart(n, length, '0');
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * SSRBootable
 *
 * @mixin
 *
 * Used in layout components (drawer, toolbar, content)
 * to avoid an entry animation when using SSR
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ssr-bootable',

  data: function data() {
    return {
      isBooted: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    // Use setAttribute instead of dataset
    // because dataset does not work well
    // with unit tests
    window.requestAnimationFrame(function () {
      _this.$el.setAttribute('data-booted', true);
      _this.isBooted = true;
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transitionable',

  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function validateAttachTarget(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);

  if (type === 'boolean' || type === 'string') return true;

  return val.nodeType === Node.ELEMENT_NODE;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'detachable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__bootable__["a" /* default */]],

  props: {
    attach: {
      type: null,
      default: false,
      validator: validateAttachTarget
    },
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    this.initDetach();
  },
  deactivated: function deactivated() {
    this.isActive = false;
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  },


  methods: {
    initDetach: function initDetach() {
      if (this._isDestroyed || !this.$refs.content ||
      // Leave menu in place if attached
      // and dev has not changed target
      this.attach === '' || // If used as a boolean prop (<v-menu attach>)
      this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
      this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) return;

      var target = void 0;
      if (this.attach === false) {
        // Default, detach to app
        target = document.querySelector('[data-app]');
      } else if (typeof this.attach === 'string') {
        // CSS selector
        target = document.querySelector(this.attach);
      } else {
        // DOM Element
        target = this.attach;
      }

      if (!target) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('Unable to locate target ' + (this.attach || '[data-app]'), this);
        return;
      }

      target.insertBefore(this.$refs.content, target.firstChild);
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'returnable',

  data: function data() {
    return {
      originalValue: null
    };
  },

  props: {
    returnValue: null
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.originalValue = this.returnValue;
      } else {
        this.$emit('update:returnValue', this.originalValue);
      }
    }
  },

  methods: {
    save: function save(value) {
      this.originalValue = value;
      this.$emit('update:returnValue', value);
      this.isActive = false;
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Grid;
function Grid(name) {
  return {
    name: 'v-' + name,

    functional: true,

    props: {
      id: String,
      tag: {
        type: String,
        default: 'div'
      }
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        var classes = Object.keys(data.attrs).filter(function (key) {
          var value = data.attrs[key];
          return value || typeof value === 'string';
        });

        if (classes.length) data.staticClass += ' ' + classes.join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h(props.tag, data, children);
    }
  };
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = colorToInt;
/* harmony export (immutable) */ __webpack_exports__["b"] = intToHex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__console__ = __webpack_require__(5);


/**
 * @param {string|number} color
 * @returns {number}
 */
function colorToInt(color) {
  var rgb = void 0;

  if (typeof color === 'number') {
    rgb = color;
  } else if (typeof color === 'string') {
    var c = color[0] === '#' ? color.substring(1) : color;
    if (c.length === 3) {
      c = c.split('').map(function (char) {
        return char + char;
      }).join('');
    }
    if (c.length !== 6) {
      Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('\'' + color + '\' is not a valid rgb color');
    }
    rgb = parseInt(c, 16);
  } else {
    throw new TypeError('Colors can only be numbers or strings, recieved ' + color.constructor.name + ' instead');
  }

  if (rgb < 0) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('Colors cannot be negative: \'' + color + '\'');
    rgb = 0;
  } else if (rgb > 0xffffff || isNaN(rgb)) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('\'' + color + '\' is not a valid rgb color');
    rgb = 0xffffff;
  }

  return rgb;
}

/**
 * @param {number} color
 * @returns {string}
 */
function intToHex(color) {
  color = color.toString(16);

  if (color.length < 6) color = '0'.repeat(6 - color.length) + color;

  return '#' + color;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAvatar__ = __webpack_require__(92);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */]);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-group',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__registrable__["b" /* provide */])('buttonGroup')],

  data: function data() {
    return {
      buttons: [],
      listeners: [],
      isDestroying: false
    };
  },


  watch: {
    buttons: 'update'
  },

  methods: {
    getValue: function getValue(i) {
      if (this.buttons[i].value != null) {
        return this.buttons[i].value;
      }

      // Fix for testing, this should always be false in the browser
      if (this.buttons[i].$el.value != null && this.buttons[i].$el.value !== '') {
        return this.buttons[i].$el.value;
      }

      return i;
    },
    update: function update() {
      var selected = [];

      for (var i = 0; i < this.buttons.length; i++) {
        var elm = this.buttons[i].$el;
        var button = this.buttons[i];

        elm.removeAttribute('data-only-child');

        if (this.isSelected(i)) {
          !button.to && (button.isActive = true);
          selected.push(i);
        } else {
          !button.to && (button.isActive = false);
        }
      }

      if (selected.length === 1) {
        this.buttons[selected[0]].$el.setAttribute('data-only-child', true);
      }

      this.ensureMandatoryInvariant(selected.length > 0);
    },
    register: function register(button) {
      var index = this.buttons.length;
      this.buttons.push(button);
      this.listeners.push(this.updateValue.bind(this, index));
      button.$on('click', this.listeners[index]);
    },
    unregister: function unregister(buttonToUnregister) {
      // Basic cleanup if we're destroying
      if (this.isDestroying) {
        var index = this.buttons.indexOf(buttonToUnregister);
        if (index !== -1) {
          buttonToUnregister.$off('click', this.listeners[index]);
        }
        return;
      }

      this.redoRegistrations(buttonToUnregister);
    },
    redoRegistrations: function redoRegistrations(buttonToUnregister) {
      var selectedCount = 0;

      var buttons = [];
      for (var index = 0; index < this.buttons.length; ++index) {
        var button = this.buttons[index];
        if (button !== buttonToUnregister) {
          buttons.push(button);
          selectedCount += Boolean(this.isSelected(index));
        }

        button.$off('click', this.listeners[index]);
      }

      this.buttons = [];
      this.listeners = [];

      for (var _index = 0; _index < buttons.length; ++_index) {
        this.register(buttons[_index]);
      }

      this.ensureMandatoryInvariant(selectedCount > 0);
      this.updateAllValues && this.updateAllValues();
    },
    ensureMandatoryInvariant: function ensureMandatoryInvariant(hasSelectedAlready) {
      // Preserve the mandatory invariant by selecting the first tracked button, if needed

      if (!this.mandatory || hasSelectedAlready) return;

      if (!this.listeners.length) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('There must be at least one v-btn child if the mandatory property is true.', this);
        return;
      }

      this.listeners[0]();
    }
  },

  mounted: function mounted() {
    this.update();
  },
  beforeDestroy: function beforeDestroy() {
    this.isDestroying = true;
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_detachable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_overlayable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_returnable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_stackable__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_helpers__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Mixins







// Directives


// Helpers


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_returnable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_stackable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives_click_outside__["a" /* default */]
  },

  data: function data() {
    return {
      isDependent: false,
      stackClass: 'dialog__content__active',
      stackMinZIndex: 200
    };
  },


  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 'none'
    },
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 'auto'
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, ('dialog ' + this.contentClass).trim(), true), _defineProperty(_ref, 'dialog--active', this.isActive), _defineProperty(_ref, 'dialog--persistent', this.persistent), _defineProperty(_ref, 'dialog--fullscreen', this.fullscreen), _defineProperty(_ref, 'dialog--scrollable', this.scrollable), _ref;
    },
    contentClasses: function contentClasses() {
      return {
        'dialog__content': true,
        'dialog__content__active': this.isActive
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.show();
      } else {
        this.removeOverlay();
        this.unbind();
      }
    }
  },

  mounted: function mounted() {
    this.isBooted = this.isActive;
    this.isActive && this.show();
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') this.unbind();
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent, clicked outside and we're the topmost dialog.
      // Since this should only be called in a capture event (bottom up), we shouldn't need to stop propagation
      return this.isActive && !this.persistent && Object(__WEBPACK_IMPORTED_MODULE_8__util_helpers__["i" /* getZIndex */])(this.$refs.content) >= this.getMaxZIndex() && !this.$refs.content.contains(e.target);
    },
    show: function show() {
      !this.fullscreen && !this.hideOverlay && this.genOverlay();
      this.fullscreen && this.hideScroll();
      this.$refs.content.focus();
      this.$listeners.keydown && this.bind();
    },
    bind: function bind() {
      window.addEventListener('keydown', this.onKeydown);
    },
    unbind: function unbind() {
      window.removeEventListener('keydown', this.onKeydown);
    },
    onKeydown: function onKeydown(e) {
      this.$emit('keydown', e);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional,
          include: this.getOpenDependentElements
        }
      }, { name: 'show', value: this.isActive }],
      on: {
        click: function click(e) {
          e.stopPropagation();
        }
      }
    };

    if (!this.fullscreen) {
      data.style = {
        maxWidth: this.maxWidth === 'none' ? undefined : isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px',
        width: this.width === 'auto' ? undefined : isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this.disabled) _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': this.contentClasses,
      domProps: { tabIndex: -1 },
      style: { zIndex: this.activeZIndex },
      ref: 'content'
    }, [dialog]));

    return h('div', {
      staticClass: 'dialog__container',
      style: {
        display: !this.$slots.activator || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overlayable',

  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTimeout: null,
      overlayTransitionDuration: 500 + 150 // transition + delay
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      // If fn is called and timeout is active
      // or overlay already exists
      // cancel removal of overlay and re-add active
      if (!this.isActive || this.hideOverlay || this.isActive && this.overlayTimeout || this.overlay) {
        clearTimeout(this.overlayTimeout);

        return this.overlay && this.overlay.classList.add('overlay--active');
      }

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');

      parent && parent.insertBefore(this.overlay, parent.firstChild);

      // eslint-disable-next-line no-unused-expressions
      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';

        if (_this.activeZIndex !== undefined) {
          _this.overlay.style.zIndex = _this.activeZIndex - 1;
        }
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      this.overlayTimeout = setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}

        clearTimeout(_this2.overlayTimeout);
        _this2.overlayTimeout = null;
      }, this.overlayTransitionDuration);
    },

    /**
     * @param {Event} e
     * @returns void
     */
    scrollListener: function scrollListener(e) {
      if (e.type === 'keydown') {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return;

        var up = [38, 33];
        var down = [40, 34];

        if (up.includes(e.keyCode)) {
          e.deltaY = -1;
        } else if (down.includes(e.keyCode)) {
          e.deltaY = 1;
        } else {
          return;
        }
      }

      if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
    },
    hasScrollbar: function hasScrollbar(el) {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;

      var style = window.getComputedStyle(el);
      return ['auto', 'scroll'].includes(style['overflow-y']) && el.scrollHeight > el.clientHeight;
    },
    shouldScroll: function shouldScroll(el, delta) {
      if (el.scrollTop === 0 && delta < 0) return true;
      return el.scrollTop + el.clientHeight === el.scrollHeight && delta > 0;
    },
    isInside: function isInside(el, parent) {
      if (el === parent) {
        return true;
      } else if (el === null || el === document.body) {
        return false;
      } else {
        return this.isInside(el.parentNode, parent);
      }
    },

    /**
     * @param {Event} e
     * @returns boolean
     */
    checkPath: function checkPath(e) {
      var path = e.path || this.composedPath(e);
      var delta = e.deltaY || -e.wheelDelta;

      if (e.type === 'keydown' && path[0] === document.body) {
        var dialog = this.$refs.dialog;
        var selected = window.getSelection().anchorNode;
        if (this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
          return this.shouldScroll(dialog, delta);
        }
        return true;
      }

      for (var index = 0; index < path.length; index++) {
        var el = path[index];

        if (el === document) return true;
        if (el === document.documentElement) return true;
        if (el === this.$refs.content) return true;

        if (this.hasScrollbar(el)) return this.shouldScroll(el, delta);
      }

      return true;
    },

    /**
     * Polyfill for Event.prototype.composedPath
     * @param {Event} e
     * @returns Element[]
     */
    composedPath: function composedPath(e) {
      if (e.composedPath) return e.composedPath();

      var path = [];
      var el = e.target;

      while (el) {
        path.push(el);

        if (el.tagName === 'HTML') {
          path.push(document);
          path.push(window);

          return path;
        }

        el = el.parentElement;
      }
    },
    hideScroll: function hideScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        window.addEventListener('wheel', this.scrollListener);
        window.addEventListener('keydown', this.scrollListener);
      }
    },
    showScroll: function showScroll() {
      document.documentElement.classList.remove('overflow-y-hidden');
      window.removeEventListener('wheel', this.scrollListener);
      window.removeEventListener('keydown', this.scrollListener);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stackable',

  data: function data() {
    return {
      stackBase: null,
      stackClass: 'unpecified',
      stackElement: null,
      stackExclude: null,
      stackMinZIndex: 0
    };
  },

  computed: {
    /**
     * Currently active z-index
     *
     * @return {number}
     */
    activeZIndex: function activeZIndex() {
      if (typeof window === 'undefined') return 0;

      var content = this.stackElement || this.$refs.content;
      // Return current zindex if not active

      var index = !this.isActive ? Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["i" /* getZIndex */])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;

      if (index == null) return index;

      // Return max current z-index (excluding self) + 2
      // (2 to leave room for an overlay below, if needed)
      return parseInt(index);
    }
  },
  methods: {
    getMaxZIndex: function getMaxZIndex() {
      var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var base = this.stackBase || this.$el;
      // Start with lowest allowed z-index or z-index of
      // base component's element, whichever is greater
      var zis = [this.stackMinZIndex, Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["i" /* getZIndex */])(base)];
      // Convert the NodeList to an array to
      // prevent an Edge bug with Symbol.iterator
      // https://github.com/vuetifyjs/vuetify/issues/2146
      var activeElements = [].concat(_toConsumableArray(document.getElementsByClassName(this.stackClass)));

      // Get z-index for all active dialogs
      for (var index = 0; index < activeElements.length; index++) {
        if (!exclude.includes(activeElements[index])) {
          zis.push(Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["i" /* getZIndex */])(activeElements[index]));
        }
      }

      return Math.max.apply(Math, zis);
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressCircular__ = __webpack_require__(111);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */]);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VJumbotron__ = __webpack_require__(124);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */]);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(126);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */]);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    enter: function enter(el, done) {
      el._parent = el.parentNode;

      Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

      // Get height that is to be scrolled
      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.display = 'block';
      expandedParentClass && el._parent.classList.add(expandedParentClass);

      setTimeout(function () {
        return el.style.height = el.scrollHeight + 'px';
      }, 100);
    },
    afterEnter: function afterEnter(el) {
      el.style.overflow = null;
      el.style.height = null;
    },
    leave: function leave(el, done) {
      // Remove initial transition
      Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

      // Set height before we transition to 0
      el.style.overflow = 'hidden';
      el.style.height = el.offsetHeight + 'px';

      setTimeout(function () {
        return el.style.height = 0;
      }, 100);
    },
    afterLeave: function afterLeave(el) {
      expandedParentClass && el._parent.classList.remove(expandedParentClass);
    }
  };
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectable',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  data: function data() {
    return {
      defaultColor: 'accent'
    };
  },

  props: {
    id: String,
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    },
    isDirty: function isDirty() {
      return this.isActive;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.validate(true, input);

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Loadable
 *
 * @mixin
 *
 * Used to add linear progress bar to components
 * Can use a default bar with a specific color
 * or designate a custom progress linear bar
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loadable',

  props: {
    loading: {
      type: [Boolean, String],
      default: false
    }
  },

  methods: {
    genProgress: function genProgress() {
      if (this.loading === false) return null;

      return this.$slots.progress || this.$createElement('v-progress-linear', {
        props: {
          color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
          height: 2,
          indeterminate: true
        }
      });
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(128);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VSelect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filterable__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_console__ = __webpack_require__(5);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












/**
 * DataIterable
 *
 * @mixin
 *
 * Base behavior for data table and data iterator
 * providing selection, pagination, sorting and filtering.
 *
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'data-iterable',

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_0__components_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_1__components_VIcon__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_2__components_VSelect__["a" /* default */]
  },

  data: function data() {
    return {
      searchLength: 0,
      defaultPagination: {
        descending: false,
        page: 1,
        rowsPerPage: 5,
        sortBy: null,
        totalItems: 0
      },
      expanded: {},
      actionsClasses: 'data-iterator__actions',
      actionsRangeControlsClasses: 'data-iterator__actions__range-controls',
      actionsSelectClasses: 'data-iterator__actions__select',
      actionsPaginationClasses: 'data-iterator__actions__pagination'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_3__filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__loadable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__themeable__["a" /* default */]],

  props: {
    expand: Boolean,
    hideActions: Boolean,
    disableInitialSort: Boolean,
    mustSort: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Items per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        if (search.trim() === '') return items;

        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_6__util_helpers__["h" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_6__util_helpers__["h" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    itemKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    computedPagination: function computedPagination() {
      return this.hasPagination ? this.pagination : this.defaultPagination;
    },
    hasPagination: function hasPagination() {
      var pagination = this.pagination || {};

      return Object.keys(pagination).length > 0;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      return this.filteredItemsImpl();
    },
    selected: function selected() {
      var selected = {};
      for (var index = 0; index < this.value.length; index++) {
        selected[this.value[index][this.itemKey]] = true;
      }
      return selected;
    }
  },

  watch: {
    search: function search() {
      this.updatePagination({ page: 1, totalItems: this.itemsLength });
    }
  },

  methods: {
    initPagination: function initPagination() {
      if (!this.rowsPerPageItems.length) {
        Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('The prop \'rows-per-page-items\' can not be empty', this);
      } else {
        this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
      }

      this.defaultPagination.totalItems = this.itemsLength;

      this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
    },
    updatePagination: function updatePagination(val) {
      var pagination = this.hasPagination ? this.pagination : this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);
      this.$emit('update:pagination', updatedPagination);

      if (!this.hasPagination) {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.itemKey]];
    },
    isExpanded: function isExpanded(item) {
      return this.expanded[item[this.itemKey]];
    },
    filteredItemsImpl: function filteredItemsImpl() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        for (var _len = arguments.length, additionalFilterArgs = Array(_len), _key = 0; _key < _len; _key++) {
          additionalFilterArgs[_key] = arguments[_key];
        }

        items = this.customFilter.apply(this, [items, this.search, this.filter].concat(additionalFilterArgs));
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.hasPagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (!this.mustSort) {
        this.updatePagination({ sortBy: null, descending: null });
      } else {
        this.updatePagination({ sortBy: index, descending: false });
      }
    },
    toggle: function toggle(value) {
      var _this3 = this;

      var selected = Object.assign({}, this.selected);
      for (var index = 0; index < this.filteredItems.length; index++) {
        selected[this.filteredItems[index][this.itemKey]] = value;
      }

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this3.itemKey]];
      }));
    },
    createProps: function createProps(item, index) {
      var _this4 = this;

      var props = { item: item, index: index };
      var keyProp = this.itemKey;
      var itemKey = item[keyProp];

      Object.defineProperty(props, 'selected', {
        get: function get() {
          return _this4.selected[item[_this4.itemKey]];
        },
        set: function set(value) {
          if (itemKey == null) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('"' + keyProp + '" attribute must be defined for item', _this4);
          }

          var selected = _this4.value.slice();
          if (value) selected.push(item);else selected = selected.filter(function (i) {
            return i[keyProp] !== itemKey;
          });
          _this4.$emit('input', selected);
        }
      });

      Object.defineProperty(props, 'expanded', {
        get: function get() {
          return _this4.expanded[item[_this4.itemKey]];
        },
        set: function set(value) {
          if (itemKey == null) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('"' + keyProp + '" attribute must be defined for item', _this4);
          }

          if (!_this4.expand) {
            for (var key in _this4.expanded) {
              _this4.expanded.hasOwnProperty(key) && _this4.$set(_this4.expanded, key, false);
            }
          }
          _this4.$set(_this4.expanded, itemKey, value);
        }
      });

      return props;
    },
    genItems: function genItems() {
      if (!this.itemsLength && !this.items.length) {
        var noData = this.$slots['no-data'] || this.noDataText;
        return [this.genEmptyItems(noData)];
      }

      if (!this.filteredItems.length) {
        var noResults = this.$slots['no-results'] || this.noResultsText;
        return [this.genEmptyItems(noResults)];
      }

      return this.genFilteredItems();
    },
    genPrevIcon: function genPrevIcon() {
      var _this5 = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this5.computedPagination.page;
            _this5.updatePagination({ page: page - 1 });
          }
        },
        attrs: {
          'aria-label': 'Previous page' // TODO: Localization
        }
      }, [this.$createElement('v-icon', this.prevIcon)]);
    },
    genNextIcon: function genNextIcon() {
      var _this6 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this6.computedPagination.page;
            _this6.updatePagination({ page: page + 1 });
          }
        },
        attrs: {
          'aria-label': 'Next page' // TODO: Localization
        }
      }, [this.$createElement('v-icon', this.nextIcon)]);
    },
    genSelect: function genSelect() {
      var _this7 = this;

      return this.$createElement('div', {
        'class': this.actionsSelectClasses
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        attrs: {
          'aria-label': this.rowsPerPageText
        },
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this7.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': this.actionsPaginationClasses
      }, [pagination]);
    },
    genActions: function genActions() {
      var rangeControls = this.$createElement('div', {
        'class': this.actionsRangeControlsClasses
      }, [this.genPagination(), this.genPrevIcon(), this.genNextIcon()]);

      return [this.$createElement('div', {
        'class': this.actionsClasses
      }, [this.rowsPerPageItems.length > 1 ? this.genSelect() : null, rangeControls])];
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(133);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]);

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__VList__["a"]; });
/* unused harmony reexport VListGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__VListTile__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a"]; });
/* unused harmony reexport VListTileAvatar */









var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */]);
  Vue.component(VListTileActionText.name, VListTileActionText);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__["a" /* default */]);
  Vue.component(VListTileContent.name, VListTileContent);
  Vue.component(VListTileSubTitle.name, VListTileSubTitle);
  Vue.component(VListTileTitle.name, VListTileTitle);
};

/* harmony default export */ __webpack_exports__["f"] = (__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */]);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu__ = __webpack_require__(141);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */]);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Delayable
 *
 * @mixin
 *
 * Changes the open or close
 * delay time for elements
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delayable',

  data: function data() {
    return {
      openTimeout: null,
      closeTimeout: null
    };
  },

  props: {
    openDelay: {
      type: [Number, String],
      default: 0
    },
    closeDelay: {
      type: [Number, String],
      default: 200
    }
  },

  methods: {
    /**
     * Clear any pending delay
     * timers from executing
     *
     * @return {void}
     */
    clearDelay: function clearDelay() {
      clearTimeout(this.openTimeout);
      clearTimeout(this.closeTimeout);
    },

    /**
     * Runs callback after
     * a specified delay
     *
     * @param  {String}   type
     * @param  {Function} cb
     *
     * @return {void}
     */
    runDelay: function runDelay(type, cb) {
      this.clearDelay();

      var delay = parseInt(this[type + 'Delay'], 10);

      this[type + 'Timeout'] = setTimeout(cb, delay);
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackable__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themeable__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






/* eslint-disable object-property-newline */
var dimensions = {
  activator: {
    top: 0, left: 0,
    bottom: 0, right: 0,
    width: 0, height: 0,
    offsetTop: 0, scrollHeight: 0
  },
  content: {
    top: 0, left: 0,
    bottom: 0, right: 0,
    width: 0, height: 0,
    offsetTop: 0, scrollHeight: 0
  },
  hasWindow: false
  /* eslint-enable object-property-newline */

  /**
   * Menuable
   *
   * @mixin
   *
   * Used for fixed or absolutely positioning
   * elements within the DOM
   * Can calculate X and Y axis overflows
   * As well as be manually positioned
   */
};/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menuable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__stackable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__themeable__["a" /* default */]],

  data: function data() {
    return {
      absoluteX: 0,
      absoluteY: 0,
      dimensions: Object.assign({}, dimensions),
      isContentActive: false,
      pageYOffset: 0,
      stackClass: 'menuable__content__active',
      stackMinZIndex: 6
    };
  },

  props: {
    activator: {
      default: null,
      validator: function validator(val) {
        return ['string', 'object'].includes(typeof val === 'undefined' ? 'undefined' : _typeof(val));
      }
    },
    allowOverflow: Boolean,
    maxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    minWidth: [Number, String],
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0
    },
    nudgeRight: {
      type: [Number, String],
      default: 0
    },
    nudgeTop: {
      type: [Number, String],
      default: 0
    },
    nudgeWidth: {
      type: [Number, String],
      default: 0
    },
    offsetOverflow: Boolean,
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    zIndex: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    computedLeft: function computedLeft() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var minWidth = a.width < c.width ? c.width : a.width;
      var left = 0;

      left += this.left ? a.left - (minWidth - a.width) : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);

      return left;
    },
    computedTop: function computedTop() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (!this.isAttached) top += this.pageYOffset;
      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      return top;
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    },
    isAttached: function isAttached() {
      return this.attach !== false;
    }
  },

  watch: {
    disabled: function disabled(val) {
      val && this.callDeactivate();
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val ? this.callActivate() : this.callDeactivate();
    }
  },

  beforeMount: function beforeMount() {
    this.checkForWindow();
  },


  methods: {
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    activate: function activate() {},
    calcLeft: function calcLeft() {
      return (this.isAttached ? this.computedLeft : this.calcXOverflow(this.computedLeft)) + 'px';
    },
    calcTop: function calcTop() {
      return (this.isAttached ? this.computedTop : this.calcYOverflow(this.computedTop)) + 'px';
    },
    calcXOverflow: function calcXOverflow(left) {
      var parsedMaxWidth = isNaN(parseInt(this.maxWidth)) ? 0 : parseInt(this.maxWidth);
      var innerWidth = this.getInnerWidth();
      var maxWidth = Math.max(this.dimensions.content.width, parsedMaxWidth);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 600 ? 30 : 12) // Account for scrollbar
        ;
      }

      if (left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var documentHeight = this.getInnerHeight();
      var toTop = this.pageYOffset + documentHeight;
      var activator = this.dimensions.activator;
      var contentHeight = this.dimensions.content.height;
      var totalHeight = top + contentHeight;
      var isOverflowing = toTop < totalHeight;

      // If overflowing bottom and offset
      // TODO: set 'bottom' position instead of 'top'
      if (isOverflowing && this.offsetOverflow) {
        top = this.pageYOffset + (activator.top - contentHeight);
        // If overflowing bottom
      } else if (isOverflowing && !this.allowOverflow) {
        top = toTop - contentHeight - 12;
        // If overflowing top
      } else if (top < this.pageYOffset && !this.allowOverflow) {
        top = this.pageYOffset + 12;
      }

      return top < 12 ? 12 : top;
    },
    callActivate: function callActivate() {
      if (!this.hasWindow) return;

      this.activate();
    },
    callDeactivate: function callDeactivate() {
      this.isContentActive = false;

      this.deactivate();
    },
    checkForWindow: function checkForWindow() {
      if (!this.hasWindow) {
        this.hasWindow = typeof window !== 'undefined';
      }

      if (this.hasWindow) {
        this.pageYOffset = this.getOffsetTop();
      }
    },
    deactivate: function deactivate() {},
    getActivator: function getActivator() {
      if (this.activator) {
        return typeof this.activator === 'string' ? document.querySelector(this.activator) : this.activator;
      }

      return this.$refs.activator.children.length > 0 ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    getInnerHeight: function getInnerHeight() {
      if (!this.hasWindow) return 0;

      return window.innerHeight || document.documentElement.clientHeight;
    },
    getInnerWidth: function getInnerWidth() {
      if (!this.hasWindow) return 0;

      return window.innerWidth;
    },
    getOffsetTop: function getOffsetTop() {
      if (!this.hasWindow) return 0;

      return window.pageYOffset || document.documentElement.scrollTop;
    },
    getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: Math.round(rect.top),
        left: Math.round(rect.left),
        bottom: Math.round(rect.bottom),
        right: Math.round(rect.right),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      };
    },
    measure: function measure(el, selector) {
      el = selector ? el.querySelector(selector) : el;

      if (!el || !this.hasWindow) return null;

      var rect = this.getRoundedBoundedClientRect(el);

      // Account for activator margin
      if (this.isAttached) {
        var style = window.getComputedStyle(el);

        rect.left = parseInt(style.marginLeft);
        rect.top = parseInt(style.marginTop);
      }

      return rect;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;

        if (!el || _this.isShown(el)) return cb();

        el.style.display = 'inline-block';
        cb();
        el.style.display = 'none';
      });
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
    },
    isShown: function isShown(el) {
      return el.style.display !== 'none';
    },
    updateDimensions: function updateDimensions() {
      var _this3 = this;

      this.checkForWindow();

      var dimensions = {};

      // Activator should already be shown
      dimensions.activator = !this.hasActivator || this.absolute ? this.absolutePosition() : this.measure(this.getActivator());

      // Display and hide to get dimensions
      this.sneakPeek(function () {
        dimensions.content = _this3.measure(_this3.$refs.content);

        _this3.dimensions = dimensions;
      });
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filterable',

  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mask__ = __webpack_require__(147);
/**
 * Maskable
 *
 * @mixin
 *
 * Creates an input mask that is
 * generated from a masked str
 *
 * Example: mask="#### #### #### ####"
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'maskable',

  data: function data() {
    return {
      selection: 0,
      lazySelection: 0,
      preDefined: {
        'credit-card': '#### - #### - #### - ####',
        'date': '##/##/####',
        'date-with-time': '##/##/#### ##:##',
        'phone': '(###) ### - ####',
        'social': '###-##-####',
        'time': '##:##',
        'time-with-seconds': '##:##:##'
      }
    };
  },

  props: {
    dontFillMaskBlanks: Boolean,
    mask: {
      type: [Object, String],
      default: null
    },
    returnMaskedValue: Boolean
  },

  computed: {
    masked: function masked() {
      var preDefined = this.preDefined[this.mask];
      var mask = preDefined || this.mask || '';

      return mask.split('');
    }
  },

  watch: {
    /**
     * Make sure the cursor is in the correct
     * location when the mask changes
     */
    mask: function mask() {
      var _this = this;

      if (!this.$refs.input) return;

      var oldValue = this.$refs.input.value;
      var newValue = this.maskText(Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["c" /* unmaskText */])(this.lazyValue));
      var position = 0;
      var selection = this.selection;

      for (var index = 0; index < selection; index++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(oldValue[index]) || position++;
      }

      selection = 0;
      if (newValue) {
        for (var _index = 0; _index < newValue.length; _index++) {
          Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(newValue[_index]) || position--;
          selection++;
          if (position <= 0) break;
        }
      }

      this.$nextTick(function () {
        _this.$refs.input.value = newValue;
        _this.setCaretPosition(selection);
      });
    }
  },

  beforeMount: function beforeMount() {
    if (!this.mask || this.value == null || !this.returnMaskedValue) return;

    var value = this.maskText(this.value);

    // See if masked value does not
    // match the user given value
    if (value === this.value) return;

    this.$emit('input', value);
  },


  methods: {
    setCaretPosition: function setCaretPosition(selection) {
      var _this2 = this;

      this.selection = selection;
      window.setTimeout(function () {
        _this2.$refs.input && _this2.$refs.input.setSelectionRange(_this2.selection, _this2.selection);
      }, 0);
    },
    updateRange: function updateRange() {
      if (!this.$refs.input) return;

      var newValue = this.maskText(this.lazyValue);
      var selection = 0;

      this.$refs.input.value = newValue;
      if (newValue) {
        for (var index = 0; index < newValue.length; index++) {
          if (this.lazySelection <= 0) break;
          Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(newValue[index]) || this.lazySelection--;
          selection++;
        }
      }

      this.setCaretPosition(selection);
      // this.$emit() must occur only when all internal values are correct
      this.$emit('input', this.returnMaskedValue ? this.$refs.input.value : this.lazyValue);
    },
    maskText: function maskText(text) {
      return this.mask ? Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["b" /* maskText */])(text, this.masked, this.dontFillMaskBlanks) : text;
    },
    unmaskText: function unmaskText(text) {
      return this.mask && !this.returnMaskedValue ? Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["c" /* unmaskText */])(text) : text;
    },

    // When the input changes and is
    // re-created, ensure that the
    // caret location is correct
    setSelectionRange: function setSelectionRange() {
      this.$nextTick(this.updateRange);
    },
    resetSelections: function resetSelections(input) {
      if (!input.selectionEnd) return;
      this.selection = input.selectionEnd;
      this.lazySelection = 0;

      for (var index = 0; index < this.selection; index++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(input.value[index]) || this.lazySelection++;
      }
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'soloable',

  props: {
    flat: Boolean,
    soloInverted: Boolean,
    solo: Boolean
  },

  computed: {
    isSolo: function isSolo() {
      return this.solo || this.soloInverted;
    }
  },

  methods: {
    genSoloClasses: function genSoloClasses() {
      return {
        'input-group--solo': this.isSolo,
        'input-group--solo-inverted': this.soloInverted,
        'elevation-0': this.flat
      };
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(160);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */]);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_picker_button__ = __webpack_require__(56);


// Components


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-title',

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_picker_button__["a" /* default */]],

  data: function data() {
    return {
      isReversing: false
    };
  },

  props: {
    date: {
      type: String,
      default: ''
    },
    selectingYear: Boolean,
    year: {
      type: [Number, String],
      default: ''
    },
    yearIcon: {
      type: String
    },
    value: {
      type: String
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing ? 'picker-reverse-transition' : 'picker-transition';
    }
  },

  watch: {
    value: function value(val, prev) {
      this.isReversing = val < prev;
    }
  },

  methods: {
    genYearIcon: function genYearIcon() {
      return this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon);
    },
    getYearBtn: function getYearBtn() {
      return this.genPickerButton('selectingYear', true, [this.year, this.yearIcon ? this.genYearIcon() : null], 'date-picker-title__year');
    },
    genTitleText: function genTitleText() {
      return this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: this.date || '&nbsp;' },
        key: this.value
      })]);
    },
    genTitleDate: function genTitleDate(title) {
      return this.genPickerButton('selectingYear', false, this.genTitleText(title), 'date-picker-title__date');
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'date-picker-title'
    }, [this.getYearBtn(), this.genTitleDate()]);
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPickerButton: function genPickerButton(prop, value, content) {
      var _this = this;

      var staticClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var active = this[prop] === value;
      var click = function click(event) {
        event.stopPropagation();
        _this.$emit('update:' + prop, value);
      };

      return this.$createElement('div', {
        staticClass: ('picker__title__btn ' + staticClass).trim(),
        'class': { active: active },
        on: active ? undefined : { click: click }
      }, Array.isArray(content) ? content : [content]);
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(14);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



// Components



// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-header',

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      isReversing: false,
      defaultColor: 'accent'
    };
  },


  props: {
    disabled: Boolean,
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: String,
    max: String,
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    value: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    formatter: function formatter() {
      if (this.format) {
        return this.format;
      } else if (String(this.value).split('-')[1]) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* createNativeLocaleFormatter */])(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }, { length: 7 });
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
      }
    }
  },

  watch: {
    value: function value(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },

  methods: {
    genBtn: function genBtn(change) {
      var _this = this;

      var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          disabled: disabled,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.$emit('input', _this.calculateChange(change));
          }
        }
      }, [this.$createElement('v-icon', change < 0 ? this.prevIcon : this.nextIcon)]);
    },
    calculateChange: function calculateChange(sign) {
      var _String$split$map = String(this.value).split('-').map(function (v) {
        return 1 * v;
      }),
          _String$split$map2 = _slicedToArray(_String$split$map, 2),
          year = _String$split$map2[0],
          month = _String$split$map2[1];

      if (month == null) {
        return '' + (year + sign);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* monthChange */])(String(this.value), sign);
      }
    },
    genHeader: function genHeader() {
      var _this2 = this;

      var header = this.$createElement('strong', {
        'class': this.disabled ? undefined : this.addTextColorClassChecks(),
        key: String(this.value),
        on: {
          click: function click() {
            return _this2.$emit('toggle');
          }
        }
      }, [this.$slots.default || this.formatter(String(this.value))]);

      var transition = this.$createElement('transition', {
        props: {
          name: this.isReversing ? 'tab-reverse-transition' : 'tab-transition'
        }
      }, [header]);

      return this.$createElement('div', {
        staticClass: 'date-picker-header__value',
        class: {
          'date-picker-header__value--disabled': this.disabled
        }
      }, [transition]);
    }
  },

  render: function render(h) {
    return this.$createElement('div', {
      staticClass: 'date-picker-header'
    }, [this.genBtn(-1), this.genHeader(), this.genBtn(+1)]);
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(2);
// Mixins



// Utils



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-date-table',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__["a" /* default */]],

  props: {
    events: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [String, Function, Object],
      default: 'warning'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    weekdayFormat: {
      type: Function,
      default: null
    }
  },

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { day: 'numeric', timeZone: 'UTC' }, { start: 8, length: 2 });
    },
    weekdayFormatter: function weekdayFormatter() {
      return this.weekdayFormat || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { weekday: 'narrow', timeZone: 'UTC' });
    },
    weekDays: function weekDays() {
      var _this = this;

      var first = parseInt(this.firstDayOfWeek, 10);

      return this.weekdayFormatter ? Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(7).map(function (i) {
        return _this.weekdayFormatter('2017-01-' + (first + i + 15));
      }) // 2017-01-15 is Sunday
      : Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(7).map(function (i) {
        return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][(i + first) % 7];
      });
    }
  },

  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* monthChange */])(this.tableDate, Math.sign(delta || 1));
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.weekDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genEvent: function genEvent(date) {
      var eventColor = void 0;
      if (typeof this.eventColor === 'string') {
        eventColor = this.eventColor;
      } else if (typeof this.eventColor === 'function') {
        eventColor = this.eventColor(date);
      } else {
        eventColor = this.eventColor[date];
      }
      return this.$createElement('div', {
        staticClass: 'date-picker-table__event',
        class: this.addBackgroundColorClassChecks({}, eventColor || this.color)
      });
    },

    // Returns number of the days from the firstDayOfWeek to the first day of the current month
    weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
      var firstDayOfTheMonth = new Date(this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(this.displayedMonth + 1) + '-01T00:00:00+00:00');
      var weekDay = firstDayOfTheMonth.getUTCDay();
      return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
    },
    isEvent: function isEvent(date) {
      if (Array.isArray(this.events)) {
        return this.events.indexOf(date) > -1;
      } else if (this.events instanceof Function) {
        return this.events(date);
      } else {
        return false;
      }
    },
    genTBody: function genTBody() {
      var children = [];
      var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
      var rows = [];
      var day = this.weekDaysBeforeFirstDayOfTheMonth();

      while (day--) {
        rows.push(this.$createElement('td'));
      }for (day = 1; day <= daysInMonth; day++) {
        var date = this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(this.displayedMonth + 1) + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(day);

        rows.push(this.$createElement('td', [this.genButton(date, true), this.isEvent(date) ? this.genEvent(date) : null]));

        if (rows.length % 7 === 0) {
          children.push(this.genTR(rows));
          rows = [];
        }
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      return this.$createElement('tbody', children);
    },
    genTR: function genTR(children) {
      return [this.$createElement('tr', children)];
    }
  },

  render: function render(h) {
    return this.genTable('date-picker-table date-picker-table--date', [this.genTHead(), this.genTBody()]);
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_touch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDateAllowed__ = __webpack_require__(60);


// Directives


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  directives: { Touch: __WEBPACK_IMPORTED_MODULE_1__directives_touch__["a" /* default */] },

  data: function data() {
    return {
      defaultColor: 'accent',
      isReversing: false
    };
  },


  props: {
    allowedDates: Function,
    current: String,
    disabled: Boolean,
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: String,
    max: String,
    scrollable: Boolean,
    tableDate: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing ? 'tab-reverse-transition' : 'tab-transition';
    },
    displayedMonth: function displayedMonth() {
      return this.tableDate.split('-')[1] - 1;
    },
    displayedYear: function displayedYear() {
      return this.tableDate.split('-')[0] * 1;
    }
  },

  watch: {
    tableDate: function tableDate(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },

  methods: {
    genButtonClasses: function genButtonClasses(value, isDisabled, isFloating) {
      var isSelected = value === this.value;
      var isCurrent = value === this.current;

      var classes = {
        'btn--active': isSelected,
        'btn--flat': !isSelected,
        'btn--icon': isSelected && !isDisabled && isFloating,
        'btn--floating': isFloating,
        'btn--depressed': !isFloating && isSelected,
        'btn--disabled': isDisabled || this.disabled && isSelected,
        'btn--outline': isCurrent && !isSelected
      };

      if (isSelected) return this.addBackgroundColorClassChecks(classes);
      if (isCurrent) return this.addTextColorClassChecks(classes);
      return classes;
    },
    genButton: function genButton(value, isFloating) {
      var _this = this;

      var isDisabled = !Object(__WEBPACK_IMPORTED_MODULE_2__util_isDateAllowed__["a" /* default */])(value, this.min, this.max, this.allowedDates);

      return this.$createElement('button', {
        staticClass: 'btn',
        'class': this.genButtonClasses(value, isDisabled, isFloating),
        attrs: {
          type: 'button'
        },
        domProps: {
          disabled: isDisabled,
          innerHTML: '<div class="btn__content">' + this.formatter(value) + '</div>'
        },
        on: isDisabled ? {} : {
          click: function click() {
            return _this.$emit('input', value);
          }
        }
      });
    },
    wheel: function wheel(e) {
      e.preventDefault();
      this.$emit('tableDate', this.calculateTableDate(e.deltaY));
    },
    touch: function touch(value) {
      this.$emit('tableDate', this.calculateTableDate(value));
    },
    genTable: function genTable(staticClass, children) {
      var _this2 = this;

      var transition = this.$createElement('transition', {
        props: { name: this.computedTransition }
      }, [this.$createElement('table', { key: this.tableDate }, children)]);

      var touchDirective = {
        name: 'touch',
        value: {
          left: function left(e) {
            return e.offsetX < -15 && _this2.touch(1);
          },
          right: function right(e) {
            return e.offsetX > 15 && _this2.touch(-1);
          }
        }
      };

      return this.$createElement('div', {
        staticClass: staticClass,
        on: this.scrollable ? { wheel: this.wheel } : undefined,
        directives: [touchDirective]
      }, [transition]);
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDateAllowed;
function isDateAllowed(date, min, max, allowedFn) {
  return (!allowedFn || allowedFn(date)) && (!min || date >= min) && (!max || date <= max);
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);
// Mixins



// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-month-table',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__["a" /* default */]],

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { month: 'short', timeZone: 'UTC' }, { start: 5, length: 2 });
    }
  },

  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return '' + (parseInt(this.tableDate, 10) + Math.sign(delta || 1));
    },
    genTBody: function genTBody() {
      var _this = this;

      var children = [];
      var cols = Array(3).fill(null);
      var rows = 12 / cols.length;

      var _loop = function _loop(row) {
        var tds = cols.map(function (_, col) {
          var month = row * cols.length + col;
          return _this.$createElement('td', {
            key: month
          }, [_this.genButton(_this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(month + 1), false)]);
        });

        children.push(_this.$createElement('tr', {
          key: row
        }, tds));
      };

      for (var row = 0; row < rows; row++) {
        _loop(row);
      }

      return this.$createElement('tbody', children);
    }
  },

  render: function render(h) {
    return this.genTable('date-picker-table date-picker-table--month', [this.genTBody()]);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);


// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-years',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'primary'
    };
  },


  props: {
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: [Number, String],
    max: [Number, String],
    value: [Number, String]
  },

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
    }
  },

  mounted: function mounted() {
    this.$el.scrollTop = this.$el.scrollHeight / 2 - this.$el.offsetHeight / 2;
  },


  methods: {
    genYearItem: function genYearItem(year) {
      var _this = this;

      var formatted = this.formatter('' + year);

      return this.$createElement('li', {
        key: year,
        'class': parseInt(this.value, 10) === year ? this.addTextColorClassChecks({ active: true }) : {},
        on: {
          click: function click() {
            return _this.$emit('input', year);
          }
        }
      }, formatted);
    },
    genYearItems: function genYearItems() {
      var children = [];
      var selectedYear = this.value ? parseInt(this.value, 10) : new Date().getFullYear();
      var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
      var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);

      for (var year = maxYear; year >= minYear; year--) {
        children.push(this.genYearItem(year));
      }

      return children;
    }
  },

  render: function render(h) {
    return this.$createElement('ul', {
      staticClass: 'date-picker-years',
      ref: 'years'
    }, this.genYearItems());
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VPicker__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themeable__ = __webpack_require__(1);
// Components


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picker',

  components: {
    VPicker: __WEBPACK_IMPORTED_MODULE_0__components_VPicker__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__themeable__["a" /* default */]],

  props: {
    fullWidth: Boolean,
    headerColor: String,
    landscape: Boolean,
    noTitle: Boolean,
    width: {
      type: [Number, String],
      default: 290,
      validator: function validator(value) {
        return parseInt(value, 10) > 0;
      }
    }
  },

  methods: {
    genPickerTitle: function genPickerTitle() {},
    genPickerBody: function genPickerBody() {},
    genPickerActionsSlot: function genPickerActionsSlot() {
      return this.$scopedSlots.default ? this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      }) : this.$slots.default;
    },
    genPicker: function genPicker(staticClass) {
      return this.$createElement('v-picker', {
        staticClass: staticClass,
        class: this.fullWidth ? ['picker--full-width'] : [],
        props: {
          color: this.headerColor || this.color,
          dark: this.dark,
          fullWidth: this.fullWidth,
          landscape: this.landscape,
          light: this.light,
          width: this.width
        }
      }, [this.noTitle ? null : this.genPickerTitle(), this.genPickerBody(), this.$createElement('template', { slot: 'actions' }, [this.genPickerActionsSlot()])]);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPicker__ = __webpack_require__(176);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */]);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_touch__ = __webpack_require__(9);
// Mixins


// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-items',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_registrable__["b" /* provide */])('tabs')],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_1__directives_touch__["a" /* default */] },

  inject: {
    registerItems: {
      default: null
    },
    tabProxy: {
      default: null
    },
    unregisterItems: {
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      lazyValue: this.value,
      reverse: false
    };
  },


  props: {
    cycle: Boolean,
    touchless: Boolean,
    value: [Number, String]
  },

  computed: {
    activeIndex: function activeIndex() {
      var _this = this;

      return this.items.findIndex(function (item, index) {
        return (item.id || index.toString()) === _this.lazyValue;
      });
    },
    activeItem: function activeItem() {
      if (!this.items.length) return undefined;

      return this.items[this.activeIndex];
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        val = val.toString();

        this.lazyValue = val;

        if (this.tabProxy) this.tabProxy(val);else this.$emit('input', val);
      }
    }
  },

  watch: {
    activeIndex: function activeIndex(current, previous) {
      this.reverse = current < previous;
      this.updateItems();
    },
    value: function value(val) {
      this.lazyValue = val;
    }
  },

  mounted: function mounted() {
    this.registerItems && this.registerItems(this.changeModel);
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterItems && this.unregisterItems();
  },


  methods: {
    changeModel: function changeModel(val) {
      this.inputValue = val;
    },
    next: function next(cycle) {
      var nextIndex = this.activeIndex + 1;

      if (!this.items[nextIndex]) {
        if (!cycle) return;
        nextIndex = 0;
      }

      this.inputValue = this.items[nextIndex].id || nextIndex;
    },
    prev: function prev(cycle) {
      var prevIndex = this.activeIndex - 1;

      if (!this.items[prevIndex]) {
        if (!cycle) return;
        prevIndex = this.items.length - 1;
      }

      this.inputValue = this.items[prevIndex].id || prevIndex;
    },
    onSwipe: function onSwipe(action) {
      this[action](this.cycle);
    },
    register: function register(item) {
      this.items.push(item);
    },
    unregister: function unregister(item) {
      this.items = this.items.filter(function (i) {
        return i !== item;
      });
    },
    updateItems: function updateItems() {
      for (var index = this.items.length; --index >= 0;) {
        this.items[index].toggle(this.lazyValue, this.reverse, this.isBooted, index);
      }
      this.isBooted = true;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var data = {
      staticClass: 'tabs__items',
      directives: []
    };

    !this.touchless && data.directives.push({
      name: 'touch',
      value: {
        left: function left() {
          return _this2.onSwipe('next');
        },
        right: function right() {
          return _this2.onSwipe('prev');
        }
      }
    });

    return h('div', data, this.$slots.default);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent'
    };
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'tabs__slider',
      class: this.addBackgroundColorClassChecks()
    });
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_picker_button__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__ = __webpack_require__(14);


// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker-title',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_picker_button__["a" /* default */]],

  props: {
    ampm: Boolean,
    hour: Number,
    minute: Number,
    period: {
      type: String,
      validator: function validator(period) {
        return period === 'am' || period === 'pm';
      }
    },
    selectingHour: Boolean
  },

  methods: {
    genTime: function genTime() {
      var hour = this.hour;
      if (this.ampm) {
        hour = hour ? (hour - 1) % 12 + 1 : 12;
      }

      var displayedHour = this.hour == null ? '--' : this.ampm ? hour : Object(__WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__["c" /* pad */])(hour);
      var displayedMinute = this.minute == null ? '--' : Object(__WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__["c" /* pad */])(this.minute);

      return this.$createElement('div', {
        'class': 'time-picker-title__time'
      }, [this.genPickerButton('selectingHour', true, displayedHour), this.$createElement('span', ':'), this.genPickerButton('selectingHour', false, displayedMinute)]);
    },
    genAmPm: function genAmPm() {
      return this.$createElement('div', {
        staticClass: 'time-picker-title__ampm'
      }, [this.genPickerButton('period', 'am', 'am'), this.genPickerButton('period', 'pm', 'pm')]);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'time-picker-title'
    }, [this.genTime(), this.ampm ? this.genAmPm() : null]);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__ = __webpack_require__(1);


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker-clock',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent',
      inputValue: this.value,
      isDragging: false
    };
  },


  props: {
    allowedValues: Function,
    double: Boolean,
    format: {
      type: Function,
      default: function _default(val) {
        return val;
      }
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    scrollable: Boolean,
    rotate: {
      type: Number,
      default: 0
    },
    size: {
      type: [Number, String],
      default: 270
    },
    step: {
      type: Number,
      default: 1
    },
    value: Number
  },

  computed: {
    count: function count() {
      return this.max - this.min + 1;
    },
    innerRadius: function innerRadius() {
      return this.radius - Math.max(this.radius * 0.4, 48);
    },
    outerRadius: function outerRadius() {
      return this.radius - 4;
    },
    roundCount: function roundCount() {
      return this.double ? this.count / 2 : this.count;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.roundCount;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    radius: function radius() {
      return this.size / 2;
    },
    displayedValue: function displayedValue() {
      return this.value == null ? this.min : this.value;
    }
  },

  watch: {
    value: function value(_value) {
      this.inputValue = _value;
    }
  },

  methods: {
    wheel: function wheel(e) {
      e.preventDefault();
      var value = this.displayedValue + Math.sign(e.wheelDelta || 1);
      this.update((value - this.min + this.count) % this.count + this.min);
    },
    handScale: function handScale(value) {
      return this.double && value - this.min >= this.roundCount ? this.innerRadius / this.radius : this.outerRadius / this.radius;
    },
    isAllowed: function isAllowed(value) {
      return !this.allowedValues || this.allowedValues(value);
    },
    genValues: function genValues() {
      var children = [];

      for (var value = this.min; value <= this.max; value = value + this.step) {
        var classes = {
          active: value === this.displayedValue,
          disabled: !this.isAllowed(value)
        };

        children.push(this.$createElement('span', {
          'class': this.addBackgroundColorClassChecks(classes, value === this.value ? this.computedColor : null),
          style: this.getTransform(value),
          domProps: { innerHTML: '<span>' + this.format(value) + '</span>' }
        }));
      }

      return children;
    },
    genHand: function genHand() {
      var scale = 'scaleY(' + this.handScale(this.displayedValue) + ')';
      var angle = this.rotate + this.degreesPerUnit * (this.displayedValue - this.min);

      return this.$createElement('div', {
        staticClass: 'time-picker-clock__hand',
        'class': this.value == null ? {} : this.addBackgroundColorClassChecks(),
        style: {
          transform: 'rotate(' + angle + 'deg) ' + scale
        }
      });
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(value) {
      var radius = (this.radius - 24) * this.handScale(value);
      var rotateRadians = this.rotate * Math.PI / 180;
      return {
        x: Math.round(Math.sin((value - this.min) * this.degrees + rotateRadians) * radius),
        y: Math.round(-Math.cos((value - this.min) * this.degrees + rotateRadians) * radius)
      };
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      this.isAllowed(this.inputValue) && this.$emit('change', this.inputValue);
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var _$refs$clock$getBound = this.$refs.clock.getBoundingClientRect(),
          width = _$refs$clock$getBound.width,
          top = _$refs$clock$getBound.top,
          left = _$refs$clock$getBound.left;

      var _ref = 'touches' in e ? e.touches[0] : e,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var center = { x: width / 2, y: -width / 2 };
      var coords = { x: clientX - left, y: top - clientY };
      var handAngle = Math.round(this.angle(center, coords) - this.rotate + 360) % 360;
      var insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;
      var value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.roundCount : 0);

      // Necessary to fix edge case when selecting left part of max value
      if (handAngle >= 360 - this.degreesPerUnit / 2) {
        this.update(insideClick ? this.max : this.min);
      } else {
        this.update(value);
      }
    },
    update: function update(value) {
      if (this.inputValue !== value && this.isAllowed(value)) {
        this.inputValue = value;
        this.$emit('input', value);
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = p1.x - p0.x;
      var dy = p1.y - p0.y;

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    }
  },

  render: function render(h) {
    var _this = this;

    var data = {
      staticClass: 'time-picker-clock',
      class: {
        'time-picker-clock--indeterminate': this.value == null
      },
      on: {
        mousedown: this.onMouseDown,
        mouseup: this.onMouseUp,
        mouseleave: function mouseleave() {
          return _this.isDragging && _this.onMouseUp();
        },
        touchstart: this.onMouseDown,
        touchend: this.onMouseUp,
        mousemove: this.onDragMove,
        touchmove: this.onDragMove
      },
      style: {
        height: this.size + 'px',
        width: this.size + 'px'
      },
      ref: 'clock'
    };

    this.scrollable && (data.on.wheel = this.wheel);

    return this.$createElement('div', data, [this.genHand(), this.genValues()]);
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = binding.value;
  var options = binding.options || { passive: true };
  var target = binding.arg || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    callback: callback,
    options: options,
    target: target
  };
}

function unbind(el, binding) {
  if (!el._onScroll) return;

  var _el$_onScroll = el._onScroll,
      callback = _el$_onScroll.callback,
      options = _el$_onScroll.options,
      target = _el$_onScroll.target;


  target.removeEventListener('scroll', callback, options);
  delete el._onScroll;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scroll',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_app_styl__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function Vuetify(Vue, args) {
  var Vuetify = __WEBPACK_IMPORTED_MODULE_1__components__["Vuetify"];

  Vue.use(Vuetify, _extends({
    components: __WEBPACK_IMPORTED_MODULE_1__components__,
    directives: __WEBPACK_IMPORTED_MODULE_2__directives__
  }, args));
}

Vuetify.version = '1.0.4';

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Vuetify);
}

/* harmony default export */ __webpack_exports__["default"] = (Vuetify);

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Vuetify__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Vuetify", function() { return __WEBPACK_IMPORTED_MODULE_0__Vuetify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VApp__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return __WEBPACK_IMPORTED_MODULE_1__VApp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAlert__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return __WEBPACK_IMPORTED_MODULE_2__VAlert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VAvatar__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return __WEBPACK_IMPORTED_MODULE_3__VAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VBadge__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return __WEBPACK_IMPORTED_MODULE_4__VBadge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VBottomNav__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return __WEBPACK_IMPORTED_MODULE_5__VBottomNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VBottomSheet__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return __WEBPACK_IMPORTED_MODULE_6__VBottomSheet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VBreadcrumbs__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_7__VBreadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VBtn__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return __WEBPACK_IMPORTED_MODULE_8__VBtn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VBtnToggle__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return __WEBPACK_IMPORTED_MODULE_9__VBtnToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VCard__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return __WEBPACK_IMPORTED_MODULE_10__VCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VCarousel__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return __WEBPACK_IMPORTED_MODULE_11__VCarousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VCheckbox__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_12__VCheckbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VChip__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return __WEBPACK_IMPORTED_MODULE_13__VChip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VDataIterator__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return __WEBPACK_IMPORTED_MODULE_14__VDataIterator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VDataTable__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return __WEBPACK_IMPORTED_MODULE_15__VDataTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__VDatePicker__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return __WEBPACK_IMPORTED_MODULE_16__VDatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__VDialog__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return __WEBPACK_IMPORTED_MODULE_17__VDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__VDivider__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return __WEBPACK_IMPORTED_MODULE_18__VDivider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__VExpansionPanel__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return __WEBPACK_IMPORTED_MODULE_19__VExpansionPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__VFooter__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return __WEBPACK_IMPORTED_MODULE_20__VFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__VForm__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return __WEBPACK_IMPORTED_MODULE_21__VForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__VGrid__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VGrid", function() { return __WEBPACK_IMPORTED_MODULE_22__VGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__VIcon__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return __WEBPACK_IMPORTED_MODULE_23__VIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__VJumbotron__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return __WEBPACK_IMPORTED_MODULE_24__VJumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__VList__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return __WEBPACK_IMPORTED_MODULE_25__VList__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__VMenu__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return __WEBPACK_IMPORTED_MODULE_26__VMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__VNavigationDrawer__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return __WEBPACK_IMPORTED_MODULE_27__VNavigationDrawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__VPagination__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return __WEBPACK_IMPORTED_MODULE_28__VPagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__VParallax__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return __WEBPACK_IMPORTED_MODULE_29__VParallax__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__VPicker__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return __WEBPACK_IMPORTED_MODULE_30__VPicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__VProgressCircular__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return __WEBPACK_IMPORTED_MODULE_31__VProgressCircular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__VProgressLinear__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return __WEBPACK_IMPORTED_MODULE_32__VProgressLinear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__VRadioGroup__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_33__VRadioGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__VSelect__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return __WEBPACK_IMPORTED_MODULE_34__VSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__VSlider__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return __WEBPACK_IMPORTED_MODULE_35__VSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__VSnackbar__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return __WEBPACK_IMPORTED_MODULE_36__VSnackbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__VSpeedDial__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return __WEBPACK_IMPORTED_MODULE_37__VSpeedDial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__VStepper__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return __WEBPACK_IMPORTED_MODULE_38__VStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__VSubheader__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return __WEBPACK_IMPORTED_MODULE_39__VSubheader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__VSwitch__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return __WEBPACK_IMPORTED_MODULE_40__VSwitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__VSystemBar__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return __WEBPACK_IMPORTED_MODULE_41__VSystemBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__VTabs__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return __WEBPACK_IMPORTED_MODULE_42__VTabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__VTextField__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return __WEBPACK_IMPORTED_MODULE_43__VTextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__VTimePicker__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return __WEBPACK_IMPORTED_MODULE_44__VTimePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__VToolbar__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return __WEBPACK_IMPORTED_MODULE_45__VToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__VTooltip__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return __WEBPACK_IMPORTED_MODULE_46__VTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__transitions__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transitions", function() { return __WEBPACK_IMPORTED_MODULE_47__transitions__["g"]; });

















































/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_application__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_theme__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_options__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_goTo__ = __webpack_require__(77);






var Vuetify = {
  install: function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.installed) return;

    this.installed = true;

    checkVueVersion(Vue);

    Vue.prototype.$vuetify = new Vue({
      data: {
        application: __WEBPACK_IMPORTED_MODULE_0__mixins_application__["a" /* default */],
        breakpoint: {},
        dark: false,
        options: Object(__WEBPACK_IMPORTED_MODULE_2__mixins_options__["a" /* default */])(opts.options),
        theme: Object(__WEBPACK_IMPORTED_MODULE_1__mixins_theme__["a" /* default */])(opts.theme)
      },
      methods: {
        goTo: __WEBPACK_IMPORTED_MODULE_4__util_goTo__["a" /* default */]
      }
    });

    if (opts.transitions) {
      Object.values(opts.transitions).forEach(function (transition) {
        if (transition.name !== undefined && transition.name.startsWith('v-')) {
          Vue.component(transition.name, transition);
        }
      });
    }

    if (opts.directives) {
      Object.values(opts.directives).forEach(function (directive) {
        Vue.directive(directive.name, directive);
      });
    }

    if (opts.components) {
      Object.values(opts.components).forEach(function (component) {
        Vue.use(component);
      });
    }
  }
};

/* istanbul ignore next */
function checkVueVersion(Vue) {
  var vueDep = '^2.5.0';

  var required = vueDep.split('.').map(function (v) {
    return v.replace(/\D/g, '');
  });
  var actual = Vue.version.split('.');

  // Simple semver caret range comparison
  var passes = actual[0] === required[0] && ( // major matches
  actual[1] > required[1] || // minor is greater
  actual[1] === required[1] && actual[2] >= required[2] // or minor is eq and patch is >=
  );

  if (!passes) {
    Object(__WEBPACK_IMPORTED_MODULE_3__util_console__["b" /* consoleWarn */])('Vuetify requires Vue version ' + vueDep);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Vuetify);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = ({
  bar: 0,
  bottom: 0,
  footer: 0,
  left: 0,
  right: 0,
  top: 0,
  components: {
    bar: {},
    bottom: {},
    footer: {},
    left: {},
    right: {},
    top: {}
  },
  bind: function bind(uid, target, value) {
    if (!this.components[target]) return;

    this.components[target] = _defineProperty({}, uid, value);
    this.update(target);
  },
  unbind: function unbind(uid, target) {
    if (this.components[target][uid] == null) return;

    delete this.components[target][uid];
    this.update(target);
  },
  update: function update(target) {
    this[target] = Object.values(this.components[target]).reduce(function (acc, cur) {
      return acc + cur;
    }, 0);
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = theme;
/* eslint-disable no-multi-spaces */
var THEME_DEFAULTS = {
  primary: '#1976D2', // blue.darken2
  secondary: '#424242', // grey.darken3
  accent: '#82B1FF', // blue.accent1
  error: '#FF5252', // red.accent2
  info: '#2196F3', // blue.base
  success: '#4CAF50', // green.base
  warning: '#FFC107' // amber.base
};

function theme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.assign({}, THEME_DEFAULTS, theme);
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = options;
var OPTIONS_DEFAULTS = {
  themeVariations: ['primary', 'secondary', 'accent'],
  minifyTheme: null,
  themeCache: null
};

function options() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.assign({}, OPTIONS_DEFAULTS, options);
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_easing_patterns__ = __webpack_require__(78);



var defaults = {
  duration: 500,
  offset: 0,
  easing: 'easeInOutCubic'
};

function getDocumentHeight() {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
}

function getTargetLocation(target, settings) {
  var documentHeight = getDocumentHeight();
  var windowHeight = window.innerHeight || (document.documentElement || document.body).clientHeight;

  var location = void 0;

  if (target instanceof Element) location = target.offsetTop;else if (target && target.constructor && target.constructor.name === 'VueComponent') location = target.$el.offsetTop;else if (typeof target === 'string') location = document.querySelector(target).offsetTop;else if (typeof target === 'number') location = target;else location = undefined;

  location += settings.offset;

  return Math.round(documentHeight - location < windowHeight ? documentHeight - windowHeight : location);
}

function goTo(target, options) {
  if (typeof window === 'undefined') return;

  var settings = Object.assign({}, defaults, options);

  var startTime = performance.now();
  var startLocation = window.pageYOffset;
  var targetLocation = getTargetLocation(target, settings);
  var distanceToScroll = targetLocation - startLocation;
  var easingFunction = typeof settings.easing === 'function' ? settings.easing : __WEBPACK_IMPORTED_MODULE_1__util_easing_patterns__[settings.easing];

  if (isNaN(targetLocation)) {
    var type = target && target.constructor ? target.constructor.name : target;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Target must be a Selector/Number/DOMElement/VueComponent, received ' + type + ' instead.');
  }
  if (!easingFunction) return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Easing function \'' + settings.easing + '\' not found.');

  function step(currentTime) {
    var progressPercentage = Math.min(1, (currentTime - startTime) / settings.duration);
    var targetPosition = Math.floor(startLocation + distanceToScroll * easingFunction(progressPercentage));

    window.scrollTo(0, targetPosition);
    if (Math.round(window.pageYOffset) === targetLocation) return;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuad", function() { return easeInQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuad", function() { return easeOutQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuad", function() { return easeInOutQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInCubic", function() { return easeInCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutCubic", function() { return easeOutCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutCubic", function() { return easeInOutCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuart", function() { return easeInQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuart", function() { return easeOutQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuart", function() { return easeInOutQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuint", function() { return easeInQuint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuint", function() { return easeOutQuint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuint", function() { return easeInOutQuint; });
// linear
var linear = function linear(t) {
  return t;
};
// accelerating from zero velocity
var easeInQuad = function easeInQuad(t) {
  return t * t;
};
// decelerating to zero velocity
var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
};
// acceleration until halfway, then deceleration
var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var easeInCubic = function easeInCubic(t) {
  return t * t * t;
};
// decelerating to zero velocity
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var easeInOutCubic = function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var easeInQuart = function easeInQuart(t) {
  return t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuart = function easeOutQuart(t) {
  return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuart = function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var easeInQuint = function easeInQuint(t) {
  return t * t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuint = function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuint = function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(80);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_app_theme__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_app_breakpoint__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_resize__ = __webpack_require__(11);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Component level mixins



// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-app',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_app_breakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_app_theme__["a" /* default */]],

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_3__directives_resize__["a" /* default */]
  },

  props: {
    id: {
      type: String,
      default: 'app'
    },
    dark: Boolean
  },

  computed: {
    classes: function classes() {
      return _defineProperty({}, 'theme--' + (this.dark ? 'dark' : 'light'), true);
    }
  },

  mounted: function mounted() {
    this.$vuetify.dark = this.dark;
  },


  watch: {
    dark: function dark() {
      this.$vuetify.dark = this.dark;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'application',
      'class': this.classes,
      attrs: { 'data-app': true },
      domProps: { id: this.id },
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    };

    var wrapper = h('div', { staticClass: 'application--wrap' }, this.$slots.default);

    return h('div', data, [wrapper]);
  }
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_colorUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_theme__ = __webpack_require__(83);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      style: null
    };
  },

  computed: {
    parsedTheme: function parsedTheme() {
      return __WEBPACK_IMPORTED_MODULE_1__util_theme__["c" /* parse */](this.$vuetify.theme);
    },

    /** @return string */
    generatedStyles: function generatedStyles() {
      var theme = this.parsedTheme;
      var css = void 0;

      if (this.$vuetify.options.themeCache != null) {
        css = this.$vuetify.options.themeCache.get(theme);
        if (css != null) return css;
      }

      var colors = Object.keys(theme);
      css = 'a { color: ' + Object(__WEBPACK_IMPORTED_MODULE_0__util_colorUtils__["b" /* intToHex */])(theme.primary) + '; }';

      for (var i = 0; i < colors.length; ++i) {
        var name = colors[i];
        var value = theme[name];
        if (this.$vuetify.options.themeVariations.includes(name)) {
          css += __WEBPACK_IMPORTED_MODULE_1__util_theme__["b" /* genVariations */](name, value).join('');
        } else {
          css += __WEBPACK_IMPORTED_MODULE_1__util_theme__["a" /* genBaseColor */](name, value);
        }
      }

      if (this.$vuetify.options.minifyTheme != null) {
        css = this.$vuetify.options.minifyTheme(css);
      }

      if (this.$vuetify.options.themeCache != null) {
        this.$vuetify.options.themeCache.set(theme, css);
      }

      return css;
    }
  },

  watch: {
    generatedStyles: function generatedStyles() {
      this.applyTheme();
    }
  },

  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$meta) {
      // Vue-meta
      var keyName = this.$nuxt ? 'head' : 'metaInfo';
      this.$options[keyName] = function () {
        return {
          style: [{
            cssText: _this.generatedStyles,
            type: 'text/css',
            id: 'vuetify-theme-stylesheet'
          }]
        };
      };
    }
  },
  created: function created() {
    if (this.$meta) {
      // Vue-meta
      // Handled by beforeCreate hook
    } else if (typeof document === 'undefined' && this.$ssrContext) {
      // SSR
      this.$ssrContext.head = this.$ssrContext.head || '';
      this.$ssrContext.head += '<style type="text/css" id="vuetify-theme-stylesheet">' + this.generatedStyles + '</style>';
    } else if (typeof document !== 'undefined') {
      // Client-side
      this.genStyle();
      this.applyTheme();
    }
  },


  methods: {
    applyTheme: function applyTheme() {
      this.style.innerHTML = this.generatedStyles;
    },
    genStyle: function genStyle() {
      var style = document.getElementById('vuetify-theme-stylesheet');

      if (!style) {
        style = document.createElement('style');
        style.type = 'text/css';
        style.id = 'vuetify-theme-stylesheet';
        document.head.appendChild(style);
      }

      this.style = style;
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = genVariations;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return genBaseColor; });
/* unused harmony export genVariantColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorUtils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__ = __webpack_require__(85);




/**
 * @param {object} theme
 * @returns {object}
 */
function parse(theme) {
  var colors = Object.keys(theme);
  var parsedTheme = {};

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];

    parsedTheme[name] = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["a" /* colorToInt */])(value);
  }

  return parsedTheme;
}

function genVariations(name, value) {
  var values = Array(10);
  values[0] = genBaseColor(name, value);

  for (var i = 1, n = 5; i <= 5; ++i, --n) {
    values[i] = genVariantColor(name, lighten(value, n), 'lighten', n);
  }

  for (var _i = 1; _i <= 4; ++_i) {
    values[_i + 5] = genVariantColor(name, darken(value, _i), 'darken', _i);
  }

  return values;
}

function lighten(value, amount) {
  var lab = __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["b" /* toXYZ */](value));
  lab[0] = lab[0] + amount * 10;
  return __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["b" /* toXYZ */](lab));
}

function darken(value, amount) {
  var lab = __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["b" /* toXYZ */](value));
  lab[0] = lab[0] - amount * 10;
  return __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["b" /* toXYZ */](lab));
}

/**
 * Generate the CSS for a base color (.primary)
 *
 * @param {string} name - The color name
 * @param {string|number} value - The color value
 * @returns {string}
 */
var genBaseColor = function genBaseColor(name, value) {
  value = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["b" /* intToHex */])(value);
  return '\n.' + name + ' {\n  background-color: ' + value + ' !important;\n  border-color: ' + value + ' !important;\n}\n.' + name + '--text {\n  color: ' + value + ' !important;\n}\n.' + name + '--text input,\n.' + name + '--text textarea {\n  caret-color: ' + value + ' !important;\n}\n.' + name + '--after::after {\n  background: ' + value + ' !important;\n}';
};

/**
 * Generate the CSS for a variant color (.primary.darken-2)
 *
 * @param {string} name - The color name
 * @param {string|number} value - The color value
 * @param {string} type - The variant type (darken/lighten)
 * @param {number} n - The darken/lighten step number
 * @returns {string}
 */
var genVariantColor = function genVariantColor(name, value, type, n) {
  value = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["b" /* intToHex */])(value);
  return '\n.' + name + '.' + type + '-' + n + ' {\n  background-color: ' + value + ' !important;\n  border-color: ' + value + ' !important;\n}\n.' + name + '--text.text--' + type + '-' + n + ' {\n  color: ' + value + ' !important;\n}\n.' + name + '--text.text--' + type + '-' + n + ' input,\n.' + name + '--text.text--' + type + '-' + n + ' textarea {\n  caret-color: ' + value + ' !important;\n}\n.' + name + '.' + type + '-' + n + '--after::after {\n  background: ' + value + ' !important;\n}';
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromXYZ;
/* harmony export (immutable) */ __webpack_exports__["b"] = toXYZ;
// For converting XYZ to sRGB
var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]];

// Forward gamma adjust
var srgbForwardTransform = function srgbForwardTransform(C) {
  return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
};

// For converting sRGB to XYZ
var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];

// Reverse gamma adjust
var srgbReverseTransform = function srgbReverseTransform(C) {
  return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
};

function clamp(value) {
  return Math.max(0, Math.min(1, value));
}

function fromXYZ(xyz) {
  var rgb = Array(3);
  var transform = srgbForwardTransform;
  var matrix = srgbForwardMatrix;

  // Matrix transform, then gamma adjustment
  for (var i = 0; i < 3; ++i) {
    rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
  }

  // Rescale back to [0, 255]
  return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
}

function toXYZ(rgb) {
  var xyz = Array(3);
  var transform = srgbReverseTransform;
  var matrix = srgbReverseMatrix;

  // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
  var r = transform((rgb >> 16 & 0xff) / 255);
  var g = transform((rgb >> 8 & 0xff) / 255);
  var b = transform((rgb >> 0 & 0xff) / 255);

  // Matrix color space transform
  for (var i = 0; i < 3; ++i) {
    xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
  }

  return xyz;
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromXYZ;
/* harmony export (immutable) */ __webpack_exports__["b"] = toXYZ;
var delta = 0.20689655172413793; // 6÷29

var cielabForwardTransform = function cielabForwardTransform(t) {
  return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
};

var cielabReverseTransform = function cielabReverseTransform(t) {
  return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
};

function fromXYZ(xyz) {
  var transform = cielabForwardTransform;
  var transformedY = transform(xyz[1]);

  return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
}

function toXYZ(lab) {
  var transform = cielabReverseTransform;
  var Ln = (lab[0] + 16) / 116;
  return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A modified version of https://gist.github.com/cb109/b074a65f7595cffc21cea59ce8d15f9b
 */

/**
 * A Vue mixin to get the current width/height and the associated breakpoint.
 *
 * Useful to e.g. adapt the user interface from inside a Vue component
 * as opposed to using CSS classes. The breakpoint pixel values and
 * range names are taken from Vuetify (https://github.com/vuetifyjs).
 *
 * Use within a component:
 *
 *   import breakpoint from './breakpoint.js'
 *
 *   export default {
 *     name: 'my-component',
 *     mixins: [breakpoint],
 *     ...
 *
 * Then inside a template:
 *
 *   <div v-if="$breakpoint.smAndDown">...</div>
 */
var breakpoint = {
  data: function data() {
    return {
      clientWidth: clientDimensions.getWidth(),
      clientHeight: clientDimensions.getHeight(),
      resizeTimeout: null
    };
  },


  computed: {
    breakpoint: function breakpoint() {
      var xs = this.clientWidth < 600;
      var sm = this.clientWidth < 960 && !xs;
      var md = this.clientWidth < 1280 - 16 && !(sm || xs);
      var lg = this.clientWidth < 1920 - 16 && !(md || sm || xs);
      var xl = this.clientWidth >= 1920 - 16 && !(lg || md || sm || xs);

      var xsOnly = xs;
      var smOnly = sm;
      var smAndDown = (xs || sm) && !(md || lg || xl);
      var smAndUp = !xs && (sm || md || lg || xl);
      var mdOnly = md;
      var mdAndDown = (xs || sm || md) && !(lg || xl);
      var mdAndUp = !(xs || sm) && (md || lg || xl);
      var lgOnly = lg;
      var lgAndDown = (xs || sm || md || lg) && !xl;
      var lgAndUp = !(xs || sm || md) && (lg || xl);
      var xlOnly = xl;

      var name = void 0;
      switch (true) {
        case xs:
          name = 'xs';
          break;
        case sm:
          name = 'sm';
          break;
        case md:
          name = 'md';
          break;
        case lg:
          name = 'lg';
          break;
        default:
          name = 'xl';
          break;
      }

      var result = {
        // Definite breakpoint.
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,

        // Useful e.g. to construct CSS class names dynamically.
        name: name,

        // Breakpoint ranges.
        xsOnly: xsOnly,
        smOnly: smOnly,
        smAndDown: smAndDown,
        smAndUp: smAndUp,
        mdOnly: mdOnly,
        mdAndDown: mdAndDown,
        mdAndUp: mdAndUp,
        lgOnly: lgOnly,
        lgAndDown: lgAndDown,
        lgAndUp: lgAndUp,
        xlOnly: xlOnly,

        // For custom breakpoint logic.
        width: this.clientWidth,
        height: this.clientHeight
      };

      return result;
    }
  },

  watch: {
    breakpoint: function breakpoint(val) {
      this.$vuetify.breakpoint = val;
    }
  },

  created: function created() {
    this.$vuetify.breakpoint = this.breakpoint;
  },


  methods: {
    onResize: function onResize() {
      var _this = this;

      clearTimeout(this.resizeTimeout);

      // Added debounce to match what
      // v-resize used to do but was
      // removed due to a memory leak
      // https://github.com/vuetifyjs/vuetify/pull/2997
      this.resizeTimeout = setTimeout(function () {
        _this.clientWidth = clientDimensions.getWidth();
        _this.clientHeight = clientDimensions.getHeight();
      }, 200);
    }
  }

  // Cross-browser support as described in:
  // https://stackoverflow.com/questions/1248081
};var clientDimensions = {
  getWidth: function getWidth() {
    if (typeof document === 'undefined') return 0; // SSR
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  },
  getHeight: function getHeight() {
    if (typeof document === 'undefined') return 0; // SSR
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (breakpoint);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(88);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__ = __webpack_require__(25);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    icon: String,
    outline: Boolean,
    type: {
      type: String,
      validator: function validator(val) {
        return ['info', 'error', 'success', 'warning'].includes(val);
      }
    }
  },

  data: function data() {
    return {
      defaultColor: 'error'
    };
  },

  computed: {
    classes: function classes() {
      var color = this.type && !this.color ? this.type : this.computedColor;
      var classes = {
        'alert--dismissible': this.dismissible,
        'alert--outline': this.outline
      };

      return this.outline ? this.addTextColorClassChecks(classes, color) : this.addBackgroundColorClassChecks(classes, color);
    },
    computedIcon: function computedIcon() {
      if (this.icon || !this.type) return this.icon;

      switch (this.type) {
        case 'info':
          return 'info';
        case 'error':
          return 'warning';
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (this.computedIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.computedIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], {
        props: {
          right: true
        }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      staticClass: 'alert',
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var SIZE_MAP = {
  small: '16px',
  default: '24px',
  medium: '28px',
  large: '36px',
  xLarge: '40px'
};

function isFontAwesome5(iconType) {
  return ['fas', 'far', 'fal', 'fab'].some(function (val) {
    return iconType.includes(val);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-icon',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    disabled: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    size: {
      type: [Number, String]
    },
    small: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;
    var small = props.small,
        medium = props.medium,
        large = props.large,
        xLarge = props.xLarge;

    var sizes = { small: small, medium: medium, large: large, xLarge: xLarge };
    var explicitSize = Object.keys(sizes).find(function (key) {
      return sizes[key] && key;
    });
    var fontSize = explicitSize && SIZE_MAP[explicitSize] || props.size;

    if (fontSize) data.style = _extends({ fontSize: fontSize }, data.style);

    var iconName = '';
    if (children.length) iconName = children.pop().text;
    // Support usage of v-text and v-html
    else if (data.domProps) {
        iconName = data.domProps.textContent || data.domProps.innerHTML || iconName;

        // Remove nodes so it doesn't
        // overwrite our changes
        delete data.domProps.textContent;
        delete data.domProps.innerHTML;
      }

    var iconType = 'material-icons';
    // Material Icon delimiter is _
    // https://material.io/icons/
    var delimiterIndex = iconName.indexOf('-');
    var isCustomIcon = delimiterIndex > -1;

    if (isCustomIcon) {
      iconType = iconName.slice(0, delimiterIndex);

      if (isFontAwesome5(iconType)) iconType = '';
      // Assume if not a custom icon
      // is Material Icon font
    } else children.push(iconName);

    data.attrs = data.attrs || {};
    if (!('aria-hidden' in data.attrs)) {
      data.attrs['aria-hidden'] = true;
    }

    var classes = Object.assign({
      'icon--disabled': props.disabled,
      'icon--left': props.left,
      'icon--right': props.right,
      'theme--dark': props.dark,
      'theme--light': props.light
    }, props.color ? __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */].methods.addTextColorClassChecks.call(props, {}, props.color) : {});

    // Order classes
    // * Component class
    // * Vuetify classes
    // * Icon Classes
    data.staticClass = ['icon', data.staticClass, Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' '), iconType, isCustomIcon ? iconName : null].reduce(function (prev, curr) {
      return curr ? prev + ' ' + curr : prev;
    }).trim();

    return h('i', data, children);
  }
});

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-avatar',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('avatar ' + (data.staticClass || '')).trim();
    data.style = data.style || {};

    if (props.tile) data.staticClass += ' avatar--tile';

    var size = parseInt(props.size) + 'px';
    data.style.height = size;
    data.style.width = size;
    data.class = [data.class, __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */].methods.addBackgroundColorClassChecks.call(props, {}, props.color)];

    return h('div', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBadge__ = __webpack_require__(95);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */]);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__ = __webpack_require__(25);


// Mixins





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-badge',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["b" /* factory */])(['left', 'bottom']), __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__["a" /* default */]],

  props: {
    color: {
      type: String,
      default: 'primary'
    },
    overlap: Boolean,
    transition: {
      type: String,
      default: 'fab-transition'
    },
    value: {
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'badge--bottom': this.bottom,
        'badge--left': this.left,
        'badge--overlap': this.overlap
      };
    }
  },

  render: function render(h) {
    var badge = this.$slots.badge ? [h('span', {
      staticClass: 'badge__badge',
      'class': this.addBackgroundColorClassChecks(),
      attrs: this.attrs,
      directives: [{
        name: 'show',
        value: this.isActive
      }]
    }, this.$slots.badge)] : null;

    return h('span', {
      staticClass: 'badge',
      'class': this.classes
    }, [this.$slots.default, h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, badge)]);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(98);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_button_group__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
// Styles


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-bottom-nav',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('bottom', ['height', 'value']), __WEBPACK_IMPORTED_MODULE_2__mixins_button_group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  props: {
    active: [Number, String],
    height: {
      default: 56,
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    shift: Boolean,
    value: { required: false }
  },

  watch: {
    active: function active() {
      this.update();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'bottom-nav--absolute': this.absolute,
        'bottom-nav--fixed': !this.absolute && (this.app || this.fixed),
        'bottom-nav--shift': this.shift,
        'bottom-nav--active': this.value
      };
    },
    computedHeight: function computedHeight() {
      return parseInt(this.height);
    }
  },

  methods: {
    isSelected: function isSelected(i) {
      var item = this.getValue(i);
      return this.active === item;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return !this.value ? 0 : this.computedHeight;
    },
    updateValue: function updateValue(i) {
      var item = this.getValue(i);

      this.$emit('update:active', item);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'bottom-nav',
      class: this.addBackgroundColorClassChecks(this.classes),
      style: {
        height: parseInt(this.computedHeight) + 'px'
      },
      ref: 'content'
    }, this.$slots.default);
  }
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomSheet__ = __webpack_require__(101);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */]);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDialog_VDialog__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-bottom-sheet',

  props: {
    disabled: Boolean,
    fullWidth: Boolean,
    hideOverlay: Boolean,
    inset: Boolean,
    lazy: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 'auto'
    },
    persistent: Boolean,
    value: null
  },

  render: function render(h) {
    var activator = h('template', {
      slot: 'activator'
    }, this.$slots.activator);

    var contentClass = ['bottom-sheet', this.inset ? 'bottom-sheet--inset' : ''].join(' ');

    return h(__WEBPACK_IMPORTED_MODULE_1__VDialog_VDialog__["a" /* default */], {
      attrs: _extends({}, this.$props),
      on: _extends({}, this.$listeners),
      props: {
        contentClass: contentClass,
        transition: 'bottom-sheet-transition',
        value: this.value
      }
    }, [activator, this.$slots.default]);
  }
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(108);
/* unused harmony reexport VBreadcrumbs */
/* unused harmony reexport VBreadcrumbsItem */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */]);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  props: {
    divider: {
      type: String,
      default: '/'
    },
    large: Boolean,
    justifyCenter: Boolean,
    justifyEnd: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs--large': this.large
      };
    },
    computedDivider: function computedDivider() {
      return this.$slots.divider ? this.$slots.divider : this.divider;
    },
    styles: function styles() {
      var justify = this.justifyCenter ? 'center' : this.justifyEnd ? 'flex-end' : 'flex-start';

      return {
        'justify-content': justify
      };
    }
  },

  methods: {
    /**
     * Add dividers between
     * v-breadcrumbs-item
     *
     * @return {array}
     */
    genChildren: function genChildren() {
      if (!this.$slots.default) return null;

      var children = [];
      var dividerData = { staticClass: 'breadcrumbs__divider' };
      var length = this.$slots.default.length;

      for (var i = 0; i < length; i++) {
        var elm = this.$slots.default[i];
        children.push(elm);

        if (!elm.componentOptions || elm.componentOptions.tag !== 'v-breadcrumbs-item' || i === length - 1) continue;

        children.push(this.$createElement('li', dividerData, this.computedDivider));
      }

      return children;
    }
  },

  render: function render(h) {
    return h('ul', {
      staticClass: 'breadcrumbs',
      'class': this.classes,
      style: this.styles
    }, this.genChildren());
  }
});

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_routable__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_routable__["a" /* default */]],

  props: {
    // In a breadcrumb, the currently
    // active item should be dimmed
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--disabled'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, this.disabled);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_registrable__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Styles


// Components


// Mixins







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  components: {
    VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["b" /* factory */])('inputValue'), Object(__WEBPACK_IMPORTED_MODULE_7__mixins_registrable__["a" /* inject */])('buttonGroup')],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    depressed: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    },
    value: null
  },

  computed: {
    classes: function classes() {
      var _extends2;

      var classes = _extends((_extends2 = {
        'btn': true
      }, _defineProperty(_extends2, this.activeClass, this.isActive), _defineProperty(_extends2, 'btn--absolute', this.absolute), _defineProperty(_extends2, 'btn--block', this.block), _defineProperty(_extends2, 'btn--bottom', this.bottom), _defineProperty(_extends2, 'btn--disabled', this.disabled), _defineProperty(_extends2, 'btn--flat', this.flat), _defineProperty(_extends2, 'btn--floating', this.fab), _defineProperty(_extends2, 'btn--fixed', this.fixed), _defineProperty(_extends2, 'btn--hover', this.hover), _defineProperty(_extends2, 'btn--icon', this.icon), _defineProperty(_extends2, 'btn--large', this.large), _defineProperty(_extends2, 'btn--left', this.left), _defineProperty(_extends2, 'btn--loader', this.loading), _defineProperty(_extends2, 'btn--outline', this.outline), _defineProperty(_extends2, 'btn--depressed', this.depressed && !this.flat || this.outline), _defineProperty(_extends2, 'btn--right', this.right), _defineProperty(_extends2, 'btn--round', this.round), _defineProperty(_extends2, 'btn--router', this.to), _defineProperty(_extends2, 'btn--small', this.small), _defineProperty(_extends2, 'btn--top', this.top), _extends2), this.themeClasses);

      return !this.outline && !this.flat ? this.addBackgroundColorClassChecks(classes) : this.addTextColorClassChecks(classes);
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */], {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  mounted: function mounted() {
    if (this.buttonGroup) {
      this.buttonGroup.register(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.buttonGroup) {
      this.buttonGroup.unregister(this);
    }
  },
  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    data.attrs.value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);

    return h(tag, data, children);
  }
});

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    button: Boolean,

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return this.addTextColorClassChecks({
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      });
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtnToggle__ = __webpack_require__(114);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */]);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_button_group__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_console__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_button_group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__["a" /* default */]],

  props: {
    inputValue: {
      required: false
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.hasValue,
        'theme--light': this.light,
        'theme--dark': this.dark
      };
    },
    hasValue: function hasValue() {
      return this.multiple && this.inputValue.length || !this.multiple && this.inputValue !== null && typeof this.inputValue !== 'undefined';
    }
  },

  watch: {
    inputValue: {
      handler: function handler() {
        this.update();
      },

      deep: true
    }
  },

  methods: {
    isSelected: function isSelected(i) {
      var item = this.getValue(i);
      if (!this.multiple) {
        return this.inputValue === item;
      }

      return this.inputValue.includes(item);
    },
    updateValue: function updateValue(i) {
      var item = this.getValue(i);
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item) return;
        return this.$emit('change', this.inputValue === item ? null : item);
      }

      var items = this.inputValue.slice();

      var index = items.indexOf(item);
      if (index > -1) {
        if (this.mandatory && items.length === 1) return;
        items.length >= 1 && items.splice(index, 1);
      } else {
        items.push(item);
      }

      this.$emit('change', items);
    },
    updateAllValues: function updateAllValues() {
      if (!this.multiple) return;

      var items = [];

      for (var i = 0; i < this.buttons.length; ++i) {
        var item = this.getValue(i);
        var index = this.inputValue.indexOf(item);
        if (index !== -1) {
          items.push(item);
        }
      }

      this.$emit('change', items);
    }
  },

  created: function created() {
    if (this.multiple && !Array.isArray(this.inputValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__util_console__["b" /* consoleWarn */])('Model must be bound to an array if the multiple property is true.', this);
    }
  },
  render: function render(h) {
    return h('div', { class: this.classes }, this.$slots.default);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tag: {
      type: String,
      default: 'div'
    },
    tile: Boolean,
    width: [String, Number]
  },

  computed: {
    classes: function classes() {
      return this.addBackgroundColorClassChecks({
        'card': true,
        'card--flat': this.flat,
        'card--horizontal': this.horizontal,
        'card--hover': this.hover,
        'card--raised': this.raised,
        'card--tile': this.tile,
        'theme--light': this.light,
        'theme--dark': this.dark
      });
    },
    styles: function styles() {
      var style = {
        height: isNaN(this.height) ? this.height : this.height + 'px'
      };

      if (this.img) {
        style.background = 'url("' + this.img + '") center center / cover no-repeat';
      }

      if (this.width) {
        style.width = isNaN(this.width) ? this.width : this.width + 'px';
      }

      return style;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.style = this.styles;

    return h(tag, data, this.$slots.default);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-title',

  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(123);
/* unused harmony reexport VCarousel */
/* unused harmony reexport VCarouselItem */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */]);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_touch__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_5__mixins_registrable__["b" /* provide */])('carousel')],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_6__directives_touch__["a" /* default */] },

  data: function data() {
    return {
      inputValue: null,
      items: [],
      slideTimeout: null,
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    delimiterIcon: {
      type: String,
      default: 'fiber_manual_record'
    },
    hideControls: Boolean,
    hideDelimiters: Boolean,
    interval: {
      type: [Number, String],
      default: 6000,
      validator: function validator(value) {
        return value > 0;
      }
    },
    nextIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    },
    prevIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    value: Number
  },

  watch: {
    items: function items() {
      if (this.inputValue >= this.items.length) {
        this.inputValue = this.items.length - 1;
      }
    },
    inputValue: function inputValue() {
      // Evaluates items when inputValue changes to
      // account for dynamic changing of children

      var uid = (this.items[this.inputValue] || {}).uid;
      for (var index = this.items.length; --index >= 0;) {
        this.items[index].open(uid, this.reverse);
      }

      this.$emit('input', this.inputValue);
      this.restartTimeout();
    },
    value: function value(val) {
      this.inputValue = val;
    },
    interval: function interval() {
      this.restartTimeout();
    },
    cycle: function cycle(val) {
      if (val) {
        this.restartTimeout();
      } else {
        clearTimeout(this.slideTimeout);
        this.slideTimeout = null;
      }
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genDelimiters: function genDelimiters() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
        props: { 'size': '46px' }
      }, icon)])]);
    },
    genItems: function genItems() {
      var _this = this;

      return this.items.map(function (item, index) {
        return _this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this.inputValue
          },
          props: {
            icon: true,
            small: true,
            dark: _this.dark || !_this.light,
            light: _this.light
          },
          key: index,
          on: { click: _this.select.bind(_this, index) }
        }, [_this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
          props: { size: '18px' }
        }, _this.delimiterIcon)]);
      });
    },
    restartTimeout: function restartTimeout() {
      this.slideTimeout && clearTimeout(this.slideTimeout);
      this.slideTimeout = null;

      var raf = requestAnimationFrame || setTimeout;
      raf(this.startTimeout);
    },
    init: function init() {
      this.inputValue = this.value || 0;
    },
    next: function next() {
      this.reverse = false;
      this.inputValue = (this.inputValue + 1) % this.items.length;
    },
    prev: function prev() {
      this.reverse = true;
      this.inputValue = (this.inputValue + this.items.length - 1) % this.items.length;
    },
    select: function select(index) {
      this.reverse = index < this.inputValue;
      this.inputValue = index;
    },
    startTimeout: function startTimeout() {
      var _this2 = this;

      if (!this.cycle) return;

      this.slideTimeout = setTimeout(function () {
        return _this2.next();
      }, this.interval > 0 ? this.interval : 6000);
    },
    register: function register(uid, open) {
      this.items.push({ uid: uid, open: open });
    },
    unregister: function unregister(uid) {
      this.items = this.items.filter(function (i) {
        return i.uid !== uid;
      });
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.hideControls ? null : this.genIcon('left', this.prevIcon, this.prev), this.hideControls ? null : this.genIcon('right', this.nextIcon, this.next), this.hideDelimiters ? null : this.genDelimiters(), this.$slots.default]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VJumbotron__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_registrable__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_registrable__["a" /* inject */])('carousel', 'v-carousel-item', 'v-carousel')],

  inheritAttrs: false,

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    transition: {
      type: String,
      default: 'tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  mounted: function mounted() {
    this.carousel.register(this._uid, this.open);
  },
  beforeDestroy: function beforeDestroy() {
    this.carousel.unregister(this._uid, this.open);
  },
  render: function render(h) {
    var item = h(__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */], {
      props: _extends({}, this.$attrs, {
        height: '100%'
      }),
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, this.$slots.default);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-jumbotron',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    gradient: String,
    height: {
      type: [Number, String],
      default: '400px'
    },
    src: String,
    tag: {
      type: String,
      default: 'div'
    }
  },

  computed: {
    backgroundStyles: function backgroundStyles() {
      var styles = {};

      if (this.gradient) {
        styles.background = 'linear-gradient(' + this.gradient + ')';
      }

      return styles;
    },
    classes: function classes() {
      return {
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        height: this.height
      };
    }
  },

  methods: {
    genBackground: function genBackground() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__background',
        'class': this.addBackgroundColorClassChecks(),
        style: this.backgroundStyles
      });
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__content'
      }, this.$slots.default);
    },
    genImage: function genImage() {
      if (!this.src) return null;
      if (this.$slots.img) return this.$slots.img({ src: this.src });

      return this.$createElement('img', {
        staticClass: 'jumbotron__image',
        attrs: { src: this.src }
      });
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__wrapper'
      }, [this.genImage(), this.genBackground(), this.genContent()]);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.staticClass = 'jumbotron';
    data.style = this.styles;

    return h(tag, data, [this.genWrapper()]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_rippleable__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_selectable__ = __webpack_require__(41);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_3__transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_rippleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      var classes = {
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      };

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  methods: {
    groupFocus: function groupFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    groupBlur: function groupBlur(e) {
      this.isFocused = false;
      this.tabFocused = false;
      this.$emit('blur', this.inputValue);
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      staticClass: 'icon--selection-control',
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon,
      on: Object.assign({
        click: this.toggle
      }, this.$listeners)
    }, this.icon)]);

    var data = {
      attrs: {
        tabindex: this.disabled ? -1 : this.internalTabIndex || this.tabindex,
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive ? 'true' : 'false',
        'aria-label': this.label
      }
    };

    var ripple = this.ripple ? this.genRipple() : null;

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'validatable',

  data: function data() {
    return {
      errorBucket: [],
      hasFocused: false,
      hasInput: false,
      shouldValidate: false,
      valid: false
    };
  },


  props: {
    error: {
      type: Boolean
    },
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validateOnBlur: Boolean
  },

  computed: {
    validations: function validations() {
      if (!Array.isArray(this.errorMessages)) {
        return [this.errorMessages];
      } else if (this.errorMessages.length > 0) {
        return this.errorMessages;
      } else if (this.shouldValidate) {
        return this.errorBucket;
      } else {
        return [];
      }
    },
    hasError: function hasError() {
      return this.validations.length > 0 || this.errorMessages.length > 0 || this.error;
    }
  },

  watch: {
    rules: {
      handler: function handler(newVal, oldVal) {
        // TODO: This handler seems to trigger when input changes, even though
        // rules array stays the same? Solved it like this for now
        if (newVal.length === oldVal.length) return;

        this.validate();
      },

      deep: true
    },
    inputValue: function inputValue(val) {
      // If it's the first time we're setting input,
      // mark it with hasInput
      if (!!val && !this.hasInput) this.hasInput = true;

      if (this.hasInput && !this.validateOnBlur) this.shouldValidate = true;
    },
    isFocused: function isFocused(val) {
      // If we're not focused, and it's the first time
      // we're defocusing, set shouldValidate to true
      if (!val && !this.hasFocused) {
        this.hasFocused = true;
        this.shouldValidate = true;

        this.$emit('update:error', this.errorBucket.length > 0);
      }
    },
    hasError: function hasError(val) {
      if (this.shouldValidate) {
        this.$emit('update:error', val);
      }
    },
    error: function error(val) {
      this.shouldValidate = !!val;
    }
  },

  mounted: function mounted() {
    this.shouldValidate = !!this.error;
    this.validate();
  },


  methods: {
    reset: function reset() {
      var _this = this;

      // TODO: Do this another way!
      // This is so that we can reset all types of inputs
      this.$emit('input', this.isMultiple ? [] : null);
      this.$emit('change', null);

      this.$nextTick(function () {
        _this.shouldValidate = false;
        _this.hasFocused = false;
        _this.validate();
      });
    },
    validate: function validate() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.inputValue;

      if (force) this.shouldValidate = true;

      this.errorBucket = [];

      for (var index = 0; index < this.rules.length; index++) {
        var rule = this.rules[index];
        var valid = typeof rule === 'function' ? rule(value) : rule;

        if (valid === false || typeof valid === 'string') {
          this.errorBucket.push(valid);
        } else if (valid !== true) {
          Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Rules should return a string or boolean, received \'' + (typeof valid === 'undefined' ? 'undefined' : _typeof(valid)) + '\' instead', this);
        }
      }

      this.valid = this.errorBucket.length === 0;

      return this.valid;
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    disabled: Boolean,
    label: Boolean,
    outline: Boolean,
    // Used for selects/tagging
    selected: Boolean,
    small: Boolean,
    textColor: String,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      var classes = this.addBackgroundColorClassChecks({
        'chip--disabled': this.disabled,
        'chip--selected': this.selected,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close,
        'theme--light': this.light,
        'theme--dark': this.dark
      });

      return this.textColor || this.outline ? this.addTextColorClassChecks(classes, this.textColor || this.color) : classes;
    }
  },

  methods: {
    genClose: function genClose(h) {
      var _this = this;

      var data = {
        staticClass: 'chip__close',
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      };

      return h('div', data, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], 'cancel')]);
    },
    genContent: function genContent(h) {
      var children = [this.$slots.default];

      this.close && children.push(this.genClose(h));

      return h('span', {
        staticClass: 'chip__content'
      }, children);
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'chip',
      'class': this.classes,
      attrs: { tabindex: this.disabled ? -1 : 0 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    return h('span', data, [this.genContent(h)]);
  }
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDataIterator__ = __webpack_require__(131);


__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */]);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_data_iterable__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-data-iterator',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_data_iterable__["a" /* default */]],

  inheritAttrs: false,

  props: {
    contentTag: {
      type: String,
      default: 'div'
    },
    contentProps: {
      type: Object,
      required: false
    },
    contentClass: {
      type: String,
      required: false
    }
  },

  computed: {
    classes: function classes() {
      return {
        'data-iterator': true,
        'data-iterator--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  methods: {
    genContent: function genContent() {
      var children = this.genItems();

      var data = {
        'class': this.contentClass,
        attrs: this.$attrs,
        on: this.$listeners,
        props: this.contentProps
      };

      return this.$createElement(this.contentTag, data, children);
    },
    genEmptyItems: function genEmptyItems(content) {
      return [this.$createElement('div', {
        'class': 'text-xs-center',
        style: 'width: 100%'
      }, content)];
    },
    genFilteredItems: function genFilteredItems() {
      if (!this.$scopedSlots.item) {
        return null;
      }

      var items = [];
      for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
        var item = this.filteredItems[index];
        var props = this.createProps(item, index);
        items.push(this.$scopedSlots.item(props));
      }

      return items;
    },
    genFooter: function genFooter() {
      var children = [];

      if (this.$slots.footer) {
        children.push(this.$slots.footer);
      }

      if (!this.hideActions) {
        children.push(this.genActions());
      }

      if (!children.length) return null;
      return this.$createElement('div', children);
    }
  },

  created: function created() {
    this.initPagination();
  },
  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, [this.genContent(), this.genFooter()]);
  }
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VCard__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VCheckbox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VChip__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VList__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VMenu__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_filterable__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_maskable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_soloable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_select_autocomplete__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_select_computed__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_select_events__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_select_generators__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_select_helpers__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_select_menu__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_select_props__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_select_watchers__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__directives_click_outside__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles




// Components







// Mixins







// Component level mixins









// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  inheritAttrs: false,

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__VCheckbox__["a" /* default */],
    VChip: __WEBPACK_IMPORTED_MODULE_6__VChip__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__VList__["a" /* VList */],
    VListTile: __WEBPACK_IMPORTED_MODULE_7__VList__["b" /* VListTile */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_7__VList__["c" /* VListTileAction */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_7__VList__["d" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_7__VList__["e" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_8__VMenu__["a" /* default */],
    VBtn: __WEBPACK_IMPORTED_MODULE_3__VBtn__["a" /* default */]
  },

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_23__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_select_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_select_events__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_select_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_select_helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_maskable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_select_menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixins_select_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_soloable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_select_watchers__["a" /* default */],
  // Input and Computed both
  // contain isDirty props
  // last gets merged in
  __WEBPACK_IMPORTED_MODULE_16__mixins_select_computed__["a" /* default */]],

  data: function data() {
    return {
      cachedItems: this.cacheItems ? this.items : [],
      content: {},
      defaultColor: 'primary',
      inputValue: (this.multiple || this.tags) && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      lazySearch: null,
      isActive: false,
      menuIsActive: false,
      selectedIndex: -1,
      selectedItems: [],
      shouldBreak: false
    };
  },
  mounted: function mounted() {
    // If instance is being destroyed
    // do not run mounted functions
    if (this._isDestroyed) return;

    // Evaluate the selected items immediately
    // to avoid a unnecessary label transition
    this.genSelectedItems();

    this.content = this.$refs.menu.$refs.content;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    needsTile: function needsTile(tile) {
      return tile.componentOptions == null || tile.componentOptions.tag !== 'v-list-tile';
    },
    changeSelectedIndex: function changeSelectedIndex(keyCode) {
      // backspace, left, right, delete
      if (![8, 37, 39, 46].includes(keyCode)) return;

      var indexes = this.selectedItems.length - 1;

      if (keyCode === 37) {
        // Left arrow
        this.selectedIndex = this.selectedIndex === -1 ? indexes : this.selectedIndex - 1;
      } else if (keyCode === 39) {
        // Right arrow
        this.selectedIndex = this.selectedIndex >= indexes ? -1 : this.selectedIndex + 1;
      } else if (this.selectedIndex === -1) {
        this.selectedIndex = indexes;
        return;
      }

      // backspace/delete
      if ([8, 46].includes(keyCode)) {
        var newIndex = this.selectedIndex === indexes ? this.selectedIndex - 1 : this.selectedItems[this.selectedIndex + 1] ? this.selectedIndex : -1;

        this.combobox ? this.inputValue = null : this.selectItem(this.selectedItems[this.selectedIndex]);
        this.selectedIndex = newIndex;
      }
    },
    closeConditional: function closeConditional(e) {
      return this.isActive && !!this.content && !this.content.contains(e.target) && !!this.$el && !this.$el.contains(e.target);
    },
    filterDuplicates: function filterDuplicates(arr) {
      var uniqueValues = new Map();
      for (var index = 0; index < arr.length; ++index) {
        var item = arr[index];
        var val = this.getValue(item);

        !uniqueValues.has(val) && uniqueValues.set(val, item);
      }
      return Array.from(uniqueValues.values());
    },
    genDirectives: function genDirectives() {
      var _this = this;

      return [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional
        }
      }];
    },
    genSelectedItems: function genSelectedItems() {
      var _this2 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.inputValue;

      // If we are using tags, don't filter results
      if (this.tags) return this.selectedItems = val;

      // Combobox is the single version
      // of a taggable select element
      if (this.combobox) return this.selectedItems = val != null ? [val] : [];

      var selectedItems = this.computedItems.filter(function (i) {
        if (!_this2.isMultiple) {
          return _this2.getValue(i) === _this2.getValue(val);
        } else {
          // Always return Boolean
          return _this2.findExistingIndex(i) > -1;
        }
      });

      if (!selectedItems.length && val != null && this.tags) {
        selectedItems = Array.isArray(val) ? val : [val];
      }

      this.selectedItems = selectedItems;
    },
    clearableCallback: function clearableCallback() {
      var _this3 = this;

      var inputValue = this.isMultiple ? [] : null;

      this.inputValue = inputValue;
      this.$emit('change', inputValue);
      this.genSelectedItems();

      // When input is cleared
      // reset search value and
      // re-focus the input
      setTimeout(function () {
        _this3.searchValue = null;
        _this3.focusInput();
      }, 0);

      if (this.openOnClear) {
        setTimeout(this.showMenu, 50);
      }
    },
    onScroll: function onScroll() {
      var _this4 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this4.content.scrollTop = 0;
        });
      } else {
        if (this.lastItem >= this.computedItems.length) return;

        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    findExistingItem: function findExistingItem(val) {
      var _this5 = this;

      var itemValue = this.getValue(val);
      return this.items.find(function (i) {
        return _this5.valueComparator(_this5.getValue(i), itemValue);
      });
    },
    findExistingIndex: function findExistingIndex(item) {
      var _this6 = this;

      var itemValue = this.getValue(item);
      return this.inputValue.findIndex(function (i) {
        return _this6.valueComparator(_this6.getValue(i), itemValue);
      });
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.isMultiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
        this.selectedItems = [item];
      } else {
        var selectedItems = [];
        var inputValue = this.inputValue.slice();
        var i = this.findExistingIndex(item);

        i !== -1 ? inputValue.splice(i, 1) : inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          selectedItems.push(i);
          return _this7.returnObject ? i : _this7.getValue(i);
        });

        this.selectedItems = selectedItems;
        this.selectedIndex = -1;
      }

      this.searchValue = !this.isMultiple && !this.chips && !this.$scopedSlots.selection ? this.getText(this.selectedItem) : null;

      this.$emit('change', this.inputValue);

      // List tile will re-render, reset index to
      // maintain highlighting
      var savedIndex = this.getMenuIndex();
      this.resetMenuIndex();

      // After selecting an item
      // refocus the input and
      // reset the caret pos
      this.$nextTick(function () {
        _this7.focusInput();
        _this7.setCaretPosition(_this7.currentRange);

        requestAnimationFrame(function () {
          if (savedIndex > -1) {
            _this7.setMenuIndex(savedIndex);
          }
        });
      });
    }
  },

  render: function render(h) {
    var _this8 = this;

    var data = {
      attrs: _extends({
        tabindex: this.isAutocomplete || this.disabled ? -1 : this.tabindex,
        'data-uid': this._uid
      }, this.isAutocomplete ? null : this.$attrs, {
        role: this.isAutocomplete ? null : 'combobox'
      })
    };

    if (!this.isAutocomplete) {
      data.on = this.genListeners();
      data.directives = this.genDirectives();
    } else {
      data.on = {
        click: function click() {
          if (_this8.disabled || _this8.readonly || _this8.isFocused) return;

          // If the input is dirty,
          // the input is not targetable
          // so we must manually focus
          if (_this8.isDirty) {
            _this8.focus();
            _this8.$nextTick(_this8.focusInput);
          }
        }
      };
    }

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], data, this.toggleMenu);
  }
});

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
// Styles


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["b" /* provide */])('list'), __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      'listClick': this.listClick
    };
  },


  data: function data() {
    return {
      groups: []
    };
  },

  props: {
    dense: Boolean,
    expand: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--dense': this.dense,
        'list--subheader': this.subheader,
        'list--two-line': this.twoLine,
        'list--three-line': this.threeLine,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  methods: {
    register: function register(uid, cb) {
      this.groups.push({ uid: uid, cb: cb });
    },
    unregister: function unregister(uid) {
      var index = this.groups.findIndex(function (g) {
        return g.uid === uid;
      });

      if (index > -1) {
        this.groups.splice(index, 1);
      }
    },
    listClick: function listClick(uid, isBooted) {
      if (this.expand) return;

      for (var i = this.groups.length; i--;) {
        this.groups[i].cb(uid);
      }
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'list',
      'class': this.classes
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transitions__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Components


// Mixins




// Transitions


/**
 * List group
 *
 * @component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_bootable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_registrable__["a" /* inject */])('list', 'v-list-group', 'v-list'), __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */]],

  inject: ['listClick'],

  data: function data() {
    return {
      groups: []
    };
  },

  props: {
    activeClass: {
      type: String,
      default: 'primary--text'
    },
    appendIcon: {
      type: String,
      default: 'keyboard_arrow_down'
    },
    disabled: Boolean,
    group: String,
    noAction: Boolean,
    prependIcon: String,
    subGroup: Boolean
  },

  computed: {
    groupClasses: function groupClasses() {
      return {
        'list__group--active': this.isActive,
        'list__group--disabled': this.disabled
      };
    },
    headerClasses: function headerClasses() {
      return {
        'list__group__header--active': this.isActive,
        'list__group__header--sub-group': this.subGroup
      };
    },
    itemsClasses: function itemsClasses() {
      return {
        'list__group__items--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (!this.subGroup && val) {
        this.listClick(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }

        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    this.list.register(this._uid, this.toggle);

    if (this.group && this.$route && this.value == null) {
      this.isActive = this.matchRoute(this.$route.path);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.list.unregister(this._uid);
  },


  methods: {
    click: function click() {
      if (this.disabled) return;

      this.isActive = !this.isActive;
    },
    genIcon: function genIcon(icon) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VIcon__["a" /* default */], icon);
    },
    genAppendIcon: function genAppendIcon() {
      var icon = !this.subGroup ? this.appendIcon : false;

      if (!icon && !this.$slots.appendIcon) return null;

      return this.$createElement('li', {
        staticClass: 'list__group__header__append-icon'
      }, [this.$slots.appendIcon || this.genIcon(icon)]);
    },
    genGroup: function genGroup() {
      return this.$createElement('ul', {
        staticClass: 'list__group__header',
        'class': this.headerClasses,
        on: Object.assign({}, {
          click: this.click
        }, this.$listeners),
        ref: 'item'
      }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
    },
    genItems: function genItems() {
      return this.$createElement('ul', {
        staticClass: 'list__group__items',
        'class': this.itemsClasses,
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        ref: 'group'
      }, this.showLazyContent(this.$slots.default));
    },
    genPrependIcon: function genPrependIcon() {
      var icon = this.prependIcon ? this.prependIcon : this.subGroup ? 'arrow_drop_down' : false;

      if (!icon && !this.$slots.prependIcon) return null;

      return this.$createElement('li', {
        staticClass: 'list__group__header__prepend-icon',
        'class': _defineProperty({}, this.activeClass, this.isActive)
      }, [this.$slots.prependIcon || this.genIcon(icon)]);
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    return h('li', {
      staticClass: 'list__group',
      'class': this.groupClasses
    }, [this.genGroup(), h(__WEBPACK_IMPORTED_MODULE_4__transitions__["a" /* VExpandTransition */], [this.genItems()])]);
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ripple__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Mixins




// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_3__directives_ripple__["a" /* default */]
  },

  inheritAttrs: false,

  data: function data() {
    return {
      proxyClass: 'list__tile--active'
    };
  },

  props: {
    activeClass: {
      type: String,
      default: 'primary--text'
    },
    avatar: Boolean,
    inactive: Boolean,
    tag: String
  },

  computed: {
    listClasses: function listClasses() {
      return this.disabled ? 'text--disabled' : this.color ? this.addTextColorClassChecks() : this.defaultColor;
    },
    classes: function classes() {
      return _defineProperty({
        'list__tile': true,
        'list__tile--link': this.isLink && !this.inactive,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled,
        'list__tile--active': !this.to && this.isActive
      }, this.activeClass, this.isActive);
    },
    isLink: function isLink() {
      return this.href || this.to || this.$listeners && (this.$listeners.click || this.$listeners['!click']);
    }
  },

  render: function render(h) {
    var isRouteLink = !this.inactive && this.isLink;

    var _ref2 = isRouteLink ? this.generateRouteLink() : {
      tag: this.tag || 'div',
      data: {
        class: this.classes
      }
    },
        tag = _ref2.tag,
        data = _ref2.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      'class': this.listClasses,
      attrs: {
        disabled: this.disabled
      },
      on: _extends({}, this.$listeners)
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'v-list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + data.staticClass : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAvatar__ = __webpack_require__(32);
// Components


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'v-list-tile-avatar',

  props: {
    color: String,
    size: {
      type: [Number, String],
      default: 40
    },
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('list__tile__avatar ' + (data.staticClass || '')).trim();

    var avatar = h(__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */], {
      props: {
        color: props.color,
        size: props.size,
        tile: props.tile
      }
    }, [children]);

    return h('div', data, [avatar]);
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_delayable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_detachable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_menuable_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_returnable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_menu_activator__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_menu_generators__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_menu_keyable__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_menu_position__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_resize__ = __webpack_require__(11);


// Mixins







// Component level mixins





// Directives



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_menu_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_delayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_menu_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_menu_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_menuable_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_menu_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_returnable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_11__directives_click_outside__["a" /* default */],
    Resize: __WEBPACK_IMPORTED_MODULE_12__directives_resize__["a" /* default */]
  },

  data: function data() {
    return {
      defaultOffset: 8,
      maxHeightAutoDefault: '200px',
      startIndex: 3,
      stopIndex: 0,
      hasJustFocused: false,
      resizeTimeout: null
    };
  },


  props: {
    auto: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    fullWidth: Boolean,
    maxHeight: { default: 'auto' },
    offsetX: Boolean,
    offsetY: Boolean,
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: Boolean,
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: [Boolean, String],
      default: 'menu-transition'
    }
  },

  computed: {
    calculatedLeft: function calculatedLeft() {
      if (!this.auto) return this.calcLeft();

      return this.calcXOverflow(this.calcLeftAuto()) + 'px';
    },
    calculatedMaxHeight: function calculatedMaxHeight() {
      return this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px';
    },
    calculatedMaxWidth: function calculatedMaxWidth() {
      return isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px';
    },
    calculatedMinWidth: function calculatedMinWidth() {
      if (this.minWidth) {
        return isNaN(this.minWidth) ? this.minWidth : this.minWidth + 'px';
      }

      var minWidth = this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);

      return Math.min(calculatedMaxWidth, minWidth) + 'px';
    },
    calculatedTop: function calculatedTop() {
      if (!this.auto || this.isAttached) return this.calcTop();

      return this.calcYOverflow(this.calcTopAuto()) + 'px';
    },
    styles: function styles() {
      return {
        maxHeight: this.calculatedMaxHeight,
        minWidth: this.calculatedMinWidth,
        maxWidth: this.calculatedMaxWidth,
        top: this.calculatedTop,
        left: this.calculatedLeft,
        transformOrigin: this.origin,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    isContentActive: function isContentActive(val) {
      this.hasJustFocused = val;
    }
  },

  methods: {
    activate: function activate() {
      // This exists primarily for v-select
      // helps determine which tiles to activate
      this.getTiles();
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions();
      // Start the transition
      requestAnimationFrame(this.startTransition);
      // Once transitioning, calculate scroll position
      setTimeout(this.calculateScroll, 50);
    },
    closeConditional: function closeConditional() {
      return this.isActive && this.closeOnClick;
    },
    onResize: function onResize() {
      if (!this.isActive) return;

      // Account for screen resize
      // and orientation change
      // eslint-disable-next-line no-unused-expressions
      this.$refs.content.offsetWidth;
      this.updateDimensions();

      // When resizing to a smaller width
      // content width is evaluated before
      // the new activator width has been
      // set, causing it to not size properly
      // hacky but will revisit in the future
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.updateDimensions, 100);
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'menu',
      class: {
        'menu--disabled': this.disabled
      },
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        arg: 500,
        name: 'resize',
        value: this.onResize
      }],
      on: {
        keydown: this.changeListIndex
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu activator
 *
 * @mixin
 *
 * Handles the click and hover activation
 * Supports slotted and detached activators
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;
      if (this.openOnClick && !this.isActive) {
        this.getActivator().focus();
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) {
        this.getActivator().blur();
        this.isActive = false;
      }
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      var _this = this;

      this.runDelay('open', function () {
        if (_this.hasJustFocused) return;

        _this.hasJustFocused = true;
        _this.isActive = true;
      });
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      var _this2 = this;

      // Prevent accidental re-activation
      this.runDelay('close', function () {
        if (_this2.$refs.content.contains(e.relatedTarget)) return;

        requestAnimationFrame(function () {
          _this2.isActive = false;
          _this2.callDeactivate();
        });
      });
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Menu generators
 *
 * @mixin
 *
 * Used for creating the DOM elements for VMenu
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        staticClass: 'menu__activator',
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        ref: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      if (!this.transition) return this.genContent();

      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [this.genContent()]);
    },
    genDirectives: function genDirectives() {
      var _this = this;

      // Do not add click outside for hover menu
      var directives = !this.openOnHover ? [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional,
          include: function include() {
            return [_this.$el].concat(_toConsumableArray(_this.getOpenDependentElements()));
          }
        }
      }] : [];

      directives.push({
        name: 'show',
        value: this.isContentActive
      });

      return directives;
    },
    genContent: function genContent() {
      var _class,
          _this2 = this;

      var options = {
        staticClass: 'menu__content',
        'class': (_class = {}, _defineProperty(_class, this.contentClass.trim(), true), _defineProperty(_class, 'menuable__content__active', this.isActive), _defineProperty(_class, 'theme--dark', this.dark), _defineProperty(_class, 'theme--light', this.light), _class),
        style: this.styles,
        directives: this.genDirectives(),
        ref: 'content',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this2.closeOnContentClick) _this2.isActive = false;
          }
        }
      };

      !this.disabled && this.openOnHover && (options.on.mouseenter = this.mouseEnterHandler);
      this.openOnHover && (options.on.mouseleave = this.mouseLeaveHandler);

      return this.$createElement('div', options, this.showLazyContent(this.$slots.default));
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu keyable
 *
 * @mixin
 *
 * Primarily used to support VSelect
 * Handles opening and closing of VMenu from keystrokes
 * Will conditionally highlight VListTiles for VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        var tile = this.tiles[next];
        tile.classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = tile.offsetTop - tile.clientHeight;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      // Up, Down, Enter, Space
      if ([40, 38, 13].includes(e.keyCode) || e.keyCode === 32 && !this.isActive) {
        e.preventDefault();
      }

      // Esc, Tab
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive &&
      // Enter, Space
      [13, 32].includes(e.keyCode) && this.openOnClick) {
        return this.isActive = true;
      }

      // Down
      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
        // Up
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
        // Enter
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu position
 *
 * @mixin
 *
 * Used for calculating an automatic position (used for VSelect)
 * Will position the VMenu content properly over the VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * (this.defaultOffset * 6) - this.defaultOffset * 7;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      if (this.isAttached) return 0;

      return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
    },
    calcTopAuto: function calcTopAuto() {
      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.computedTop;
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = -(this.defaultOffset * 2);
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = this.defaultOffset * 3;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = -this.defaultOffset;
        actingIndex = selectedIndex - this.stopIndex;
      }

      // Is always off by 1 pixel, send help (┛ಠ_ಠ)┛彡┻━┻
      offsetPadding--;

      return this.computedTop + offsetPadding - actingIndex * (this.defaultOffset * 6);
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultDelimiters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMaskDelimiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return maskText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unmaskText; });
/**
 * Default delimiter RegExp
 *
 * @type {RegExp}
 */
var defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;

/**
 *
 * @param {String} char
 *
 * @return {Boolean}
 */
var isMaskDelimiter = function isMaskDelimiter(char) {
  return char && defaultDelimiters.test(char);
};

/**
 * Mask keys
 *
 * @type {Object}
 */
var allowedMasks = {
  '#': {
    test: function test(char) {
      return char.match(/[0-9]/);
    }
  },
  'A': {
    test: function test(char) {
      return char.match(/[A-Z]/i);
    },
    convert: function convert(char) {
      return char.toUpperCase();
    }
  },
  'a': {
    test: function test(char) {
      return char.match(/[a-z]/i);
    },
    convert: function convert(char) {
      return char.toLowerCase();
    }
  },
  'N': {
    test: function test(char) {
      return char.match(/[0-9A-Z]/i);
    },
    convert: function convert(char) {
      return char.toUpperCase();
    }
  },
  'n': {
    test: function test(char) {
      return char.match(/[0-9a-z]/i);
    },
    convert: function convert(char) {
      return char.toLowerCase();
    }
  },
  'X': {
    test: isMaskDelimiter
  }

  /**
   * Is Character mask
   *
   * @param  {String} char
   *
   * @return {Boolean}
   */
};var isMask = function isMask(char) {
  return allowedMasks.hasOwnProperty(char);
};

/**
 * Automatically convert char case
 *
 * @param  {String} mask
 * @param  {String} char
 *
 * @return {String}
 */
var convert = function convert(mask, char) {
  return allowedMasks[mask].convert ? allowedMasks[mask].convert(char) : char;
};

/**
 * Mask Validation
 *
 * @param  {String} mask
 * @param  {String} char
 *
 * @return {Boolean}
 */
var maskValidates = function maskValidates(mask, char) {
  if (char == null || !isMask(mask)) return false;
  return allowedMasks[mask].test(char);
};

/**
 * Mask Text
 *
 * Takes a string or an array of characters
 * and returns a masked string
 *
 * @param {*} text
 * @param {Array|String} masked
 * @param {Boolean} [dontFillMaskBlanks]
 *
 * @return {String}
 */
var maskText = function maskText(text, masked, dontFillMaskBlanks) {
  if (text == null) return '';
  text = String(text);
  if (!masked.length || !text.length) return text;
  if (!Array.isArray(masked)) masked = masked.split('');

  var textIndex = 0;
  var maskIndex = 0;
  var newText = '';

  while (maskIndex < masked.length) {
    var mask = masked[maskIndex];

    // Assign the next character
    var char = text[textIndex];

    // Check if mask is delimiter
    // and current char matches
    if (!isMask(mask) && char === mask) {
      newText += mask;
      textIndex++;
      // Check if not mask
    } else if (!isMask(mask) && !dontFillMaskBlanks) {
      newText += mask;
      // Check if is mask and validates
    } else if (maskValidates(mask, char)) {
      newText += convert(mask, char);
      textIndex++;
    } else {
      return newText;
    }

    maskIndex++;
  }

  return newText;
};

/**
 * Unmask Text
 *
 * @param {String} text
 *
 * @return {String}
 */
var unmaskText = function unmaskText(text) {
  return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text;
};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


/**
 * Select autocomplete
 *
 * @mixin
 *
 * Handles logic when using the "autocomplete" prop
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    filter: {
      type: Function,
      default: function _default(item, queryText, itemText) {
        var hasValue = function hasValue(val) {
          return val != null ? val : '';
        };

        var text = hasValue(itemText);
        var query = hasValue(queryText);

        return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
      }
    }
  },

  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      if (!this.isAutocomplete) return this.computedItems;

      return this.computedItems.filter(function (i) {
        return _this.filter(i, _this.searchValue, _this.getText(i));
      });
    },
    genFiltered: function genFiltered(text) {
      text = (text || '').toString();

      if (!this.isAutocomplete || !this.searchValue || this.filteredItems.length < 1) return Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* escapeHTML */])(text);

      var _getMaskedCharacters = this.getMaskedCharacters(text),
          start = _getMaskedCharacters.start,
          middle = _getMaskedCharacters.middle,
          end = _getMaskedCharacters.end;

      return '' + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* escapeHTML */])(start) + this.genHighlight(middle) + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* escapeHTML */])(end);
    },
    genHighlight: function genHighlight(text) {
      if (this.isNotFiltering) return Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* escapeHTML */])(text);

      return '<span class="list__tile__mask">' + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* escapeHTML */])(text) + '</span>';
    },
    getMaskedCharacters: function getMaskedCharacters(text) {
      var searchValue = (this.searchValue || '').toString().toLowerCase();
      var index = text.toLowerCase().indexOf(searchValue);

      if (index < 0) return { start: '', middle: text, end: '' };

      var start = text.slice(0, index);
      var middle = text.slice(index, index + searchValue.length);
      var end = text.slice(index + searchValue.length);
      return { start: start, middle: middle, end: end };
    },
    getCurrentTag: function getCurrentTag() {
      return this.isMenuItemSelected() ? this.filteredItems[this.getMenuIndex()] : this.isAnyValueAllowed ? this.searchValue : null;
    },
    tabOut: function tabOut() {
      this.blur();
    },
    onTabDown: function onTabDown(e) {
      var _this2 = this;

      // If tabbing through inputs and
      // and there is no need for an
      // update, blur the v-select
      if (!this.isAutocomplete || !this.getCurrentTag() || this.combobox) return this.tabOut();

      var menuIndex = this.getMenuIndex();

      // When adding tags, if searching and
      // there is not a filtered options,
      // add the value to the tags list
      if (this.tags && this.searchValue && menuIndex === -1) {
        e.preventDefault();

        return this.updateTags(this.searchValue);
      }

      // An item that is selected by
      // menu-index should toggled
      if (this.menuIsActive) {
        // Reset the list index if searching
        this.searchValue && this.$nextTick(function () {
          return setTimeout(_this2.resetMenuIndex, 0);
        });

        e.preventDefault();
        this.selectListTile(menuIndex);
      }
    },
    onEnterDown: function onEnterDown() {
      this.updateTags(this.getCurrentTag());
    },
    onEscDown: function onEscDown(e) {
      e.preventDefault();
      this.menuIsActive = false;
    },
    onKeyDown: function onKeyDown(e) {
      var _this3 = this;

      // If enter, space, up, or down is pressed, open menu
      if (!this.menuIsActive && [13, 32, 38, 40].includes(e.keyCode)) {
        e.preventDefault();
        return this.showMenu();
      }

      // If escape deactivate the menu
      if (e.keyCode === 27) return this.onEscDown(e);

      // If tab - select item or close menu
      if (e.keyCode === 9) return this.onTabDown(e);

      if (!this.isAutocomplete || ![32].includes(e.keyCode) // space
      ) this.$refs.menu.changeListIndex(e);

      // Up or down
      if ([38, 40].includes(e.keyCode)) this.selectedIndex = -1;

      if (this.isAutocomplete && !this.hideSelections && !this.searchValue) this.changeSelectedIndex(e.keyCode);

      if (!this.isAnyValueAllowed || !this.searchValue) return;

      // Enter
      if (e.keyCode === 13) return this.onEnterDown();

      // Left arrow
      if (e.keyCode === 37 && this.$refs.input.selectionStart === 0 && this.selectedItems.length) {
        this.updateTags(this.searchValue);
        this.$nextTick(function () {
          _this3.selectedIndex = Math.max(_this3.selectedItems.length - 2, 0);
        });
      }

      // Right arrow
      if (e.keyCode === 39 && this.$refs.input.selectionEnd === this.searchValue.length) {
        this.resetMenuIndex();
      }
    },
    selectListTile: function selectListTile(index) {
      if (!this.$refs.menu.tiles[index]) return;

      this.$refs.menu.tiles[index].click();
    },
    updateTags: function updateTags(content) {
      var _this4 = this;

      // Avoid direct mutation
      // for vuex strict mode
      var selectedItems = this.selectedItems.slice();

      // If a duplicate item
      // exists, remove it
      if (selectedItems.includes(content)) {
        this.$delete(selectedItems, selectedItems.indexOf(content));
      }

      // When updating tags ensure
      // that that the search text
      // is populated if needed
      var searchValue = null;
      if (this.combobox) {
        selectedItems = [content];
        searchValue = this.chips ? null : content;
      } else {
        selectedItems.push(content);
      }

      this.selectedItems = selectedItems;

      this.$nextTick(function () {
        _this4.searchValue = searchValue;
        _this4.$emit('input', _this4.combobox ? content : _this4.selectedItems);
      });
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Select computed properties
 *
 * @mixin
 *
 * Computed properties for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    classes: function classes() {
      var classes = _extends({}, this.genSoloClasses(), {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.isAutocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple,
        'input-group--open': this.menuIsVisible,
        'input-group--select--selecting-index': this.selectedIndex > -1
      });

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    computedContentClass: function computedContentClass() {
      var children = ['menu__content--select', this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : '', this.isAutocomplete ? 'menu__content--autocomplete' : '', this.contentClass || ''];

      return children.join(' ');
    },
    computedItems: function computedItems() {
      return this.filterDuplicates(this.cachedItems.concat(this.items));
    },

    /**
     * The range of the current input text
     *
     * @return {Number}
     */
    currentRange: function currentRange() {
      if (this.selectedItem == null) return 0;

      return this.getText(this.selectedItem).toString().length;
    },
    filteredItems: function filteredItems() {
      // If we are not actively filtering
      // Show all available items
      var items = this.isNotFiltering ? this.computedItems : this.filterSearch();

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hideSelections: function hideSelections() {
      return this.isAutocomplete && !this.isMultiple && this.isFocused && !this.chips && !this.$scopedSlots.selection;
    },
    isNotFiltering: function isNotFiltering() {
      return this.isAutocomplete && this.isDirty && this.searchValue === this.getText(this.selectedItem);
    },
    isHidingSelected: function isHidingSelected() {
      return this.hideSelected && this.isAutocomplete && this.isMultiple;
    },
    isAutocomplete: function isAutocomplete() {
      return this.autocomplete || this.editable || this.tags || this.combobox;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length > 0 || this.isAutocomplete && this.searchValue;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable || this.isSolo;
    },
    isMultiple: function isMultiple() {
      return this.multiple || this.tags;
    },
    isAnyValueAllowed: function isAnyValueAllowed() {
      return this.tags || this.combobox;
    },
    menuIsVisible: function menuIsVisible() {
      return this.menuIsActive && this.computedItems.length > 0 && (!this.isAnyValueAllowed || this.filteredItems.length > 0);
    },
    menuItems: function menuItems() {
      var _this = this;

      return this.isHidingSelected ? this.filteredItems.filter(function (o) {
        return (_this.selectedItems || []).indexOf(o) === -1;
      }) : this.filteredItems;
    },
    nudgeTop: function nudgeTop() {
      var nudgeTop = -18;

      if (this.isSolo) nudgeTop = 0;else if (this.shouldOffset) {
        nudgeTop += 44;

        nudgeTop += this.hideDetails ? -24 : 0;
        nudgeTop += this.isAutocomplete && !this.isDropdown ? -2 : 0;
      }

      return nudgeTop;
    },

    searchValue: {
      get: function get() {
        return this.lazySearch;
      },
      set: function set(val) {
        if (!this.isAutocomplete || !this.multiple && this.selectedIndex > -1) return;

        this.lazySearch = val;

        this.$emit('update:searchInput', val);
      }
    },
    selectedItem: function selectedItem() {
      var _this2 = this;

      if (this.isMultiple) return null;

      return this.selectedItems.find(function (i) {
        return _this2.getValue(i) === _this2.getValue(_this2.inputValue);
      });
    },
    shouldOffset: function shouldOffset() {
      return this.isAutocomplete || this.isDropdown;
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Select events
 *
 * @mixin
 *
 * Event based methods for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    blur: function blur() {
      this.deactivateInput();
      this.menuIsActive = false;
      this.$emit('blur');
    },
    focus: function focus() {
      this.showMenu();

      this.$emit('focus');
    },
    focusInput: function focusInput() {
      var _this = this;

      if (this.$refs.input && this.isAutocomplete) {
        this.$refs.input.focus();

        this.$nextTick(function () {
          _this.$refs.input.select();
          _this.shouldBreak && (_this.$refs.input.scrollLeft = _this.$refs.input.scrollWidth);
        });
      } else {
        !this.isFocused && this.$el.focus();
      }
    },
    genListeners: function genListeners() {
      var _this2 = this;

      var listeners = Object.assign({}, this.$listeners);
      delete listeners.input;

      return _extends({}, listeners, {
        click: function click() {
          if (_this2.disabled || _this2.readonly) return;

          if (_this2.isFocused && !_this2.menuIsVisible) {
            return _this2.showMenuItems();
          }

          _this2.selectedIndex > -1 ? _this2.selectedIndex = -1 : _this2.focus();
        },
        focus: function focus(e) {
          if (_this2.disabled || _this2.readonly || _this2.isFocused) {
            return;
          }

          _this2.activateInput();
          _this2.$nextTick(_this2.focusInput);
        },
        keydown: this.onKeyDown // Located in mixins/select-autocomplete.js
      });
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/**
 * Select generators
 *
 * @mixin
 *
 * Used for creating the DOM elements for VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var data = {
        ref: 'menu',
        props: {
          activator: this.$el,
          auto: this.auto,
          attach: this.attach && '[data-uid="' + this._uid + '"]',
          closeOnClick: false,
          closeOnContentClick: !this.isMultiple,
          contentClass: this.computedContentClass,
          dark: this.dark,
          disabled: this.disabled,
          light: this.light,
          maxHeight: this.maxHeight,
          nudgeTop: this.nudgeTop,
          offsetY: this.shouldOffset,
          offsetOverflow: this.isAutocomplete,
          openOnClick: false,
          value: this.menuIsVisible,
          zIndex: this.menuZIndex
        },
        on: {
          input: function input(val) {
            if (!val) {
              _this.menuIsActive = false;
            }
          }
        }
      };

      if (this.isAutocomplete) data.props.transition = '';

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    getMenuIndex: function getMenuIndex() {
      return this.$refs.menu ? this.$refs.menu.listIndex : -1;
    },
    setMenuIndex: function setMenuIndex(index) {
      this.$refs.menu && (this.$refs.menu.listIndex = index);
    },
    resetMenuIndex: function resetMenuIndex() {
      this.setMenuIndex(-1);
    },
    isMenuItemSelected: function isMenuItemSelected() {
      return this.menuIsActive && this.menuItems.length && this.getMenuIndex() > -1;
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [].concat(_toConsumableArray(this.genSelections()), [this.genSearch()]));
    },
    genSelections: function genSelections() {
      if (this.hideSelections) return [];

      var length = this.selectedItems.length;
      var children = new Array(length);

      var genSelection = void 0;
      if (this.$scopedSlots.selection) {
        genSelection = this.genSlotSelection;
      } else if (this.chips) {
        genSelection = this.genChipSelection;
      } else if (this.segmented) {
        genSelection = this.genSegmentedBtn;
      } else {
        genSelection = this.genCommaSelection;
      }

      while (length--) {
        children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
      }

      return children;
    },
    genSearch: function genSearch() {
      var _this2 = this;

      var data = {
        staticClass: 'input-group--select__autocomplete',
        'class': {
          'input-group--select__autocomplete--index': this.selectedIndex > -1
        },
        style: {
          flex: this.shouldBreak ? '1 0 100%' : null
        },
        attrs: _extends({}, this.$attrs, {
          disabled: this.disabled || !this.isAutocomplete,
          readonly: this.readonly,
          tabindex: this.disabled || !this.isAutocomplete ? -1 : this.tabindex
        }),
        domProps: {
          value: this.maskText(this.lazySearch || '')
        },
        directives: [{
          name: 'show',
          value: this.isAutocomplete || this.placeholder && !this.selectedItems.length
        }],
        ref: 'input',
        key: 'input'
      };

      if (this.isAutocomplete) {
        data.attrs.role = 'combobox';
        data.domProps.autocomplete = this.browserAutocomplete;

        data.on = _extends({}, this.genListeners(), {
          input: function input(e) {
            if (_this2.selectedIndex > -1) return;

            _this2.searchValue = _this2.unmaskText(e.target.value);
          }
        });

        data.directives = data.directives.concat(this.genDirectives());
      }

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      return this.$createElement('input', data);
    },
    genSegmentedBtn: function genSegmentedBtn(item) {
      if (!item.text || !item.callback) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('When using \'segmented\' prop without a selection slot, items must contain both a text and callback property', this);
        return null;
      }

      return this.$createElement('v-btn', {
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            item.callback(e);
          }
        }
      }, [item.text]);
    },
    genSlotSelection: function genSlotSelection(item, index) {
      return this.$scopedSlots.selection({
        parent: this,
        item: item,
        index: index,
        selected: index === this.selectedIndex,
        disabled: this.disabled || this.readonly
      });
    },
    genChipSelection: function genChipSelection(item, index) {
      var _this3 = this;

      var isDisabled = this.disabled || this.readonly;
      var click = function click(e) {
        if (isDisabled) return;

        e.stopPropagation();
        _this3.focusInput();
        _this3.selectedIndex = index;
      };

      return this.$createElement('v-chip', {
        staticClass: 'chip--select-multi',
        attrs: { tabindex: '-1' },
        props: {
          close: this.deletableChips && !isDisabled,
          dark: this.dark,
          disabled: isDisabled,
          selected: index === this.selectedIndex
        },
        on: {
          click: click,
          focus: click,
          input: function input() {
            if (_this3.isMultiple) _this3.selectItem(item);else _this3.inputValue = null;
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, index, last) {
      return this.$createElement('div', {
        staticClass: 'input-group__selections__comma',
        'class': {
          'input-group__selections__comma--active': index === this.selectedIndex
        },
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (last ? '' : ', '));
    },
    genList: function genList() {
      var _this4 = this;

      var children = this.menuItems.map(function (o) {
        if (o.header) return _this4.genHeader(o);
        if (o.divider) return _this4.genDivider(o);else return _this4.genTile(o);
      });

      if (!children.length) {
        var noData = this.$slots['no-data'];
        if (noData) {
          children.push(noData);
        } else {
          children.push(this.genTile(this.noDataText, true));
        }
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        props: {
          dense: this.dense
        },
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genLabel: function genLabel() {
      var singleLine = this.singleLine || this.isDropdown;

      if (singleLine && (this.isDirty || this.isFocused && this.searchValue)) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.$slots.label || this.label);
    },
    genTile: function genTile(item, disabled) {
      var _this5 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["h" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: {
          click: function click(e) {
            if (disabled) return;

            _this5.selectItem(item);
          }
        },
        props: {
          avatar: item === Object(item) && this.itemAvatar in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      data.props.activeClass = Object.keys(this.addTextColorClassChecks()).join(' ');

      if (this.$scopedSlots.item) {
        var tile = this.$scopedSlots.item({ parent: this, item: item, tile: data });
        return this.needsTile(tile) ? this.$createElement('v-list-tile', data, [tile]) : tile;
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this6 = this;

      if (!this.isMultiple || this.isHidingSelected) return null;

      var data = {
        staticClass: 'list__tile__action--select-multi',
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this6.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', {
        props: {
          color: this.computedColor,
          inputValue: active
        }
      })]);
    },
    genContent: function genContent(item) {
      var text = this.getText(item);

      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', {
        domProps: {
          innerHTML: this.genFiltered(text)
        }
      })]);
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
// Helpers


/**
 * Select helpers
 *
 * @mixin
 *
 * Helper methods for the
 * v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["h" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Select menu methods
 *
 * @mixin
 *
 * Menu based methods for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    activateInput: function activateInput() {
      this.isActive = true;
      this.isFocused = true;
    },
    deactivateInput: function deactivateInput() {
      this.isFocused = false;
      this.isActive = false;
      this.selectedIndex = -1;
    },
    hideMenu: function hideMenu() {
      this.menuIsActive = false;
    },
    showMenu: function showMenu() {
      this.activateInput();
      this.showMenuItems();
      this.isMultiple && this.resetMenuIndex();
    },
    showMenuItems: function showMenuItems() {
      this.menuIsActive = true;
    },
    toggleMenu: function toggleMenu() {
      if (this.disabled || this.readonly || this.menuIsVisible) return this.hideMenu();

      this.showMenu();
      this.focusInput();
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    appendIconCb: Function,
    attach: Boolean,
    auto: Boolean,
    autocomplete: Boolean,
    browserAutocomplete: {
      type: String,
      default: 'on'
    },
    cacheItems: Boolean,
    chips: Boolean,
    clearable: Boolean,
    combobox: Boolean,
    contentClass: String,
    deletableChips: Boolean,
    dense: Boolean,
    editable: Boolean,
    hideSelected: Boolean,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemAvatar: {
      type: String,
      default: 'avatar'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    openOnClear: Boolean,
    overflow: Boolean,
    returnObject: Boolean,
    searchInput: {
      default: null
    },
    segmented: Boolean,
    singleLine: Boolean,
    tags: Boolean,
    valueComparator: {
      type: Function,
      default: function _default(a, b) {
        if (a !== Object(a)) return a === b;
        var aProps = Object.keys(a);
        var bProps = Object.keys(b);
        return aProps.length === bProps.length && aProps.every(function (propName) {
          return a[propName] === b[propName];
        });
      }
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Select watchers
 *
 * @mixin
 *
 * Watchers for the
 * v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    filteredItems: function filteredItems() {
      this.$refs.menu && this.$refs.menu.updateDimensions();
    },
    inputValue: function inputValue(val) {
      // Search for an existing item when a
      // value was selected from the menu
      if (this.combobox && this.isNotFiltering) {
        val = this.findExistingItem(val);
      }

      // Populate selected items
      this.genSelectedItems(val);

      // Only fire an update
      // if values do not
      // match
      val !== this.value && this.$emit('input', val);

      // When inputValue is changed
      // and combobox is true set
      // menu property to false
      if (this.combobox) this.menuIsActive = false;
    },
    isActive: function isActive(val) {
      if (val) {
        if (!this.chips && !this.$scopedSlots.selection) {
          this.searchValue = this.getText(this.selectedItem);
        }
        return;
      }

      this.blur();

      if (this.tags && this.searchValue) {
        this.updateTags(this.searchValue);
      }

      if (this.combobox && this.lazySearch && !this.isNotFiltering) {
        this.inputValue = this.lazySearch;
      }

      // Only set search value if
      // there is a value to set
      this.searchValue && (this.searchValue = null);
    },
    isBooted: function isBooted() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.content && _this.content.addEventListener) {
          _this.content.addEventListener('scroll', _this.onScroll, false);
        }
      });
    },
    items: function items(val) {
      var _this2 = this;

      if (this.cacheItems) {
        this.cachedItems = this.filterDuplicates(this.cachedItems.concat(val));
      }

      this.resetMenuIndex();

      // Tags and combobox should not
      // pre-select the first entry
      if (this.searchValue && !this.isAnyValueAllowed) {
        this.$nextTick(function () {
          return _this2.setMenuIndex(0);
        });
      }

      this.genSelectedItems();
    },
    menuIsActive: function menuIsActive(val) {
      if (!val) return;

      this.isBooted = true;
    },
    isMultiple: function isMultiple(val) {
      this.inputValue = val ? [] : null;
    },
    searchInput: function searchInput(val) {
      this.searchValue = val;
    },
    searchValue: function searchValue(val, prev) {
      var _this3 = this;

      // Wrap input to next line if overflowing
      if (this.$refs.input.scrollWidth > this.$refs.input.clientWidth) {
        this.shouldBreak = true;
        this.$nextTick(this.$refs.menu.updateDimensions);
      } else if (val === null) {
        this.shouldBreak = false;
      }

      // Activate menu if inactive and searching
      if (this.isActive && !this.menuIsActive && val !== this.getText(this.selectedItem)) {
        this.menuIsActive = true;
      }

      // Only reset list index
      // if typing in search
      !val && prev && this.resetMenuIndex();

      this.$nextTick(function () {
        if (val && !_this3.isAnyValueAllowed) {
          _this3.setMenuIndex(0);
        }
        if (val !== null && _this3.selectedIndex > -1) {
          _this3.selectedIndex = -1;
        }
      });
    },
    selectedItems: function selectedItems() {
      if (this.isAutocomplete) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(166);
/* unused harmony reexport VDataTable */
/* unused harmony reexport VEditDialog */





var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */]);
  Vue.component(VTableOverflow.name, VTableOverflow);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */]);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_data_iterable__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VProgressLinear__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_head__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_body__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_foot__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_progress__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_helpers__ = __webpack_require__(2);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-data-table',

  components: {
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_3__VProgressLinear__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_8__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      actionsClasses: 'datatable__actions',
      actionsRangeControlsClasses: 'datatable__actions__range-controls',
      actionsSelectClasses: 'datatable__actions__select',
      actionsPaginationClasses: 'datatable__actions__pagination'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_data_iterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_progress__["a" /* default */]],

  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideHeaders: Boolean,
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter, headers) {
        search = search.toString().toLowerCase();
        if (search.trim() === '') return items;

        var props = headers.map(function (h) {
          return h.value;
        });

        return items.filter(function (item) {
          return props.some(function (prop) {
            return filter(Object(__WEBPACK_IMPORTED_MODULE_8__util_helpers__["h" /* getObjectValueByPath */])(item, prop), search);
          });
        });
      }
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    filteredItems: function filteredItems() {
      return this.filteredItemsImpl(this.headers);
    },
    headerColumns: function headerColumns() {
      return this.headers.length + (this.selectAll !== false);
    }
  },

  methods: {
    hasTag: function hasTag(elements, tag) {
      return Array.isArray(elements) && elements.find(function (e) {
        return e.tag === tag;
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = !this.disableInitialSort && firstSortable ? firstSortable.value : null;

    this.initPagination();
  },
  render: function render(h) {
    var tableOverflow = h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTBody(), this.genTFoot()])]);

    return h('div', [tableOverflow, this.genActionsFooter()]);
  }
});

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitions__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_2__transitions__["d" /* VSlideXTransition */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    active: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: null
    },
    backgroundOpacity: {
      type: [Number, String],
      default: null
    },
    bufferValue: {
      type: [Number, String],
      default: 100
    },
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    query: Boolean,
    value: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (!this.indeterminate && parseInt(this.bufferValue, 10) !== 100) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    effectiveWidth: function effectiveWidth() {
      if (!this.bufferValue) {
        return 0;
      }

      return this.value * 100 / this.bufferValue;
    },
    backgroundStyle: function backgroundStyle() {
      var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);

      return {
        height: this.active ? this.height + 'px' : 0,
        opacity: backgroundOpacity,
        width: this.bufferValue + '%'
      };
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        staticClass: 'progress-linear__bar__determinate',
        class: this.addBackgroundColorClassChecks(),
        style: {
          width: this.effectiveWidth + '%'
        }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        staticClass: 'progress-linear__bar__indeterminate',
        class: this.addBackgroundColorClassChecks(_defineProperty({}, name, true))
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        staticClass: 'progress-linear__bar__indeterminate',
        class: {
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', {
      staticClass: 'progress-linear__bar',
      style: this.styles
    }, [fade, slide]);
    var background = h('div', {
      staticClass: 'progress-linear__background',
      class: [this.backgroundColor || this.color],
      style: this.backgroundStyle
    });

    return h('div', {
      staticClass: 'progress-linear',
      class: {
        'progress-linear--query': this.query
      },
      style: {
        height: this.height + 'px'
      },
      on: this.$listeners
    }, [background, bar]);
  }
});

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sortIcon: {
      type: String,
      default: 'arrow_upward'
    }
  },

  methods: {
    genTHead: function genTHead() {
      var _this = this;

      if (this.hideHeaders) return; // Exit Early since no headers are needed.

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.everyItem
        });

        children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()];
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true ? '' : this.selectAll,
            hideDetails: true,
            inputValue: this.everyItem,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = [this.genTR(_row), this.genTProgress()];
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var classes = ['column'];
      var data = {
        key: header[this.headerText],
        attrs: {
          role: 'columnheader',
          scope: 'col',
          width: header.width || null,
          'aria-label': header[this.headerText] || '',
          'aria-sort': 'none'
        }
      };

      if (header.sortable == null || header.sortable) {
        this.genHeaderSortingData(header, children, data, classes);
      } else {
        data.attrs['aria-label'] += ': Not sorted.'; // TODO: Localization
      }

      classes.push('text-xs-' + (header.align || 'left'));
      if (Array.isArray(header.class)) {
        classes.push.apply(classes, _toConsumableArray(header.class));
      } else if (header.class) {
        classes.push(header.class);
      }
      data.class = classes;

      return [data, children];
    },
    genHeaderSortingData: function genHeaderSortingData(header, children, data, classes) {
      var _this2 = this;

      if (!('value' in header)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["b" /* consoleWarn */])('Headers must have a value property that corresponds to a value in the v-model array', this);
      }

      data.attrs.tabIndex = 0;
      data.on = {
        click: function click() {
          _this2.expanded = {};
          _this2.sort(header.value);
        },
        keydown: function keydown(e) {
          // check for space
          if (e.keyCode === 32) {
            e.preventDefault();
            _this2.sort(header.value);
          }
        }
      };

      classes.push('sortable');
      var icon = this.$createElement('v-icon', {
        props: {
          small: true
        }
      }, this.sortIcon);
      if (!header.align || header.align === 'left') {
        children.push(icon);
      } else {
        children.unshift(icon);
      }

      var pagination = this.computedPagination;
      var beingSorted = pagination.sortBy === header.value;
      if (beingSorted) {
        classes.push('active');
        if (pagination.descending) {
          classes.push('desc');
          data.attrs['aria-sort'] = 'descending';
          data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.'; // TODO: Localization
        } else {
          classes.push('asc');
          data.attrs['aria-sort'] = 'ascending';
          data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.'; // TODO: Localization
        }
      } else {
        data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.'; // TODO: Localization
      }
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions_expand_transition__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = this.genItems();

      return this.$createElement('tbody', children);
    },
    genExpandedRow: function genExpandedRow(props) {
      var children = [];

      if (this.isExpanded(props.item)) {
        var expand = this.$createElement('div', {
          class: 'datatable__expand-content',
          key: props.item[this.itemKey]
        }, this.$scopedSlots.expand(props));

        children.push(expand);
      }

      var transition = this.$createElement('transition-group', {
        class: 'datatable__expand-col',
        attrs: { colspan: this.headerColumns },
        props: {
          tag: 'td'
        },
        on: Object(__WEBPACK_IMPORTED_MODULE_0__transitions_expand_transition__["a" /* default */])('datatable__expand-col--expanded')
      }, children);

      return this.genTR([transition], { class: 'datatable__expand-row' });
    },
    genFilteredItems: function genFilteredItems() {
      if (!this.$scopedSlots.items) {
        return null;
      }

      var rows = [];
      for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
        var item = this.filteredItems[index];
        var props = this.createProps(item, index);
        var row = this.$scopedSlots.items(props);

        rows.push(this.hasTag(row, 'td') ? this.genTR(row, {
          key: index,
          attrs: { active: this.isSelected(item) }
        }) : row);

        if (this.$scopedSlots.expand) {
          var expandRow = this.genExpandedRow(props);
          rows.push(expandRow);
        }
      }

      return rows;
    },
    genEmptyItems: function genEmptyItems(content) {
      if (this.hasTag(content, 'tr')) {
        return content;
      } else if (this.hasTag(content, 'td')) {
        return this.genTR(content);
      } else {
        return this.genTR([this.$createElement('td', {
          class: {
            'text-xs-center': typeof content === 'string'
          },
          attrs: { colspan: this.headerColumns }
        }, content)]);
      }
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTFoot: function genTFoot() {
      if (!this.$slots.footer) {
        return null;
      }

      var footer = this.$slots.footer;
      var row = this.hasTag(footer, 'td') ? this.genTR(footer) : footer;

      return this.$createElement('tfoot', [row]);
    },
    genActionsFooter: function genActionsFooter() {
      if (this.hideActions) {
        return null;
      }

      return this.$createElement('div', {
        'class': this.classes
      }, this.genActions());
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTProgress: function genTProgress() {
      var col = this.$createElement('th', {
        staticClass: 'column',
        attrs: {
          colspan: this.headerColumns
        }
      }, [this.genProgress()]);

      return this.genTR([col], {
        staticClass: 'datatable__progress'
      });
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_returnable__ = __webpack_require__(27);


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_returnable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    persistent: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && setTimeout(this.focus, 50); // Give DOM time to paint
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          color: 'primary',
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__actions'
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(function () {
        return _this.save(_this.returnValue);
      }, this.saveText)]);
    },
    genContent: function genContent() {
      var _this2 = this;

      return this.$createElement('div', {
        on: {
          keydown: function keydown(e) {
            var input = _this2.$refs.content.querySelector('input');
            e.keyCode === 27 && _this2.cancel();
            e.keyCode === 13 && input && _this2.save(input.value);
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this3 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        contentClass: 'small-dialog__content',
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnClick: !this.persistent,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this3.isActive = val;
        }
      }
    }, [h('a', {
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.large ? this.genActions() : null]);
  }
});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__ = __webpack_require__(62);
/* unused harmony reexport VDatePicker */
/* unused harmony reexport VDatePickerTitle */
/* unused harmony reexport VDatePickerHeader */
/* unused harmony reexport VDatePickerDateTable */
/* unused harmony reexport VDatePickerMonthTable */
/* unused harmony reexport VDatePickerYears */









/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */]);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VDatePickerTitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePickerHeader__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDatePickerDateTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VDatePickerMonthTable__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VDatePickerYears__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_picker__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_isDateAllowed__ = __webpack_require__(60);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components









// Mixins


// Utils



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
    VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */],
    VDatePickerTitle: __WEBPACK_IMPORTED_MODULE_3__VDatePickerTitle__["a" /* default */],
    VDatePickerHeader: __WEBPACK_IMPORTED_MODULE_4__VDatePickerHeader__["a" /* default */],
    VDatePickerDateTable: __WEBPACK_IMPORTED_MODULE_5__VDatePickerDateTable__["a" /* default */],
    VDatePickerMonthTable: __WEBPACK_IMPORTED_MODULE_6__VDatePickerMonthTable__["a" /* default */],
    VDatePickerYears: __WEBPACK_IMPORTED_MODULE_7__VDatePickerYears__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_picker__["a" /* default */]],

  data: function data() {
    var _this = this;

    var now = new Date();
    return {
      activePicker: this.type.toUpperCase(),
      defaultColor: 'accent',
      inputDay: null,
      inputMonth: null,
      inputYear: null,
      isReversing: false,
      now: now,
      // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
      tableDate: function () {
        if (_this.pickerDate) {
          return _this.pickerDate;
        }

        var date = _this.value || now.getFullYear() + '-' + (now.getMonth() + 1);
        var type = _this.type === 'date' ? 'month' : 'year';
        return _this.sanitizeDateString(date, type);
      }()
    };
  },


  props: {
    allowedDates: Function,
    // Function formatting the day in date picker table
    dayFormat: {
      type: Function,
      default: null
    },
    events: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [String, Function, Object],
      default: 'warning'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    // Function formatting the tableDate in the day/month table header
    headerDateFormat: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    max: String,
    min: String,
    // Function formatting month in the months table
    monthFormat: {
      type: Function,
      default: null
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    pickerDate: String,
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    reactive: Boolean,
    readonly: Boolean,
    scrollable: Boolean,
    showCurrent: {
      type: [Boolean, String],
      default: true
    },
    // Function formatting currently selected date in the picker title
    titleDateFormat: {
      type: Function,
      default: null
    },
    type: {
      type: String,
      default: 'date',
      validator: function validator(type) {
        return ['date', 'month'].includes(type);
      } // TODO: year
    },
    value: String,
    // Function formatting the year in table header and pickup title
    yearFormat: {
      type: Function,
      default: null
    },
    yearIcon: String
  },

  computed: {
    current: function current() {
      if (this.showCurrent === true) {
        return this.sanitizeDateString(this.now.getFullYear() + '-' + (this.now.getMonth() + 1) + '-' + this.now.getDate(), this.type);
      }

      return this.showCurrent || null;
    },
    inputDate: function inputDate() {
      return this.type === 'date' ? this.inputYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.inputMonth + 1) + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.inputDay) : this.inputYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.inputMonth + 1);
    },
    tableMonth: function tableMonth() {
      return (this.pickerDate || this.tableDate).split('-')[1] - 1;
    },
    tableYear: function tableYear() {
      return (this.pickerDate || this.tableDate).split('-')[0] * 1;
    },
    minMonth: function minMonth() {
      return this.min ? this.sanitizeDateString(this.min, 'month') : null;
    },
    maxMonth: function maxMonth() {
      return this.max ? this.sanitizeDateString(this.max, 'month') : null;
    },
    minYear: function minYear() {
      return this.min ? this.sanitizeDateString(this.min, 'year') : null;
    },
    maxYear: function maxYear() {
      return this.max ? this.sanitizeDateString(this.max, 'year') : null;
    },
    formatters: function formatters() {
      return {
        year: this.yearFormat || Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 }),
        titleDate: this.titleDateFormat || this.defaultTitleDateFormatter
      };
    },
    defaultTitleDateFormatter: function defaultTitleDateFormatter() {
      var titleFormats = {
        year: { year: 'numeric', timeZone: 'UTC' },
        month: { month: 'long', timeZone: 'UTC' },
        date: { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }
      };

      var titleDateFormatter = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* createNativeLocaleFormatter */])(this.locale, titleFormats[this.type], {
        start: 0,
        length: { date: 10, month: 7, year: 4 }[this.type]
      });

      var landscapeFormatter = function landscapeFormatter(date) {
        return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function (match, nonDigit, digit) {
          return nonDigit + ' ' + digit;
        }).replace(', ', ',<br>');
      };

      return this.landscape ? landscapeFormatter : titleDateFormatter;
    }
  },

  watch: {
    tableDate: function tableDate(val, prev) {
      // Make a ISO 8601 strings from val and prev for comparision, otherwise it will incorrectly
      // compare for example '2000-9' and '2000-10'
      var sanitizeType = this.type === 'month' ? 'year' : 'month';
      this.isReversing = this.sanitizeDateString(val, sanitizeType) < this.sanitizeDateString(prev, sanitizeType);
      this.$emit('update:pickerDate', val);
    },
    pickerDate: function pickerDate(val) {
      if (val) {
        this.tableDate = val;
      } else if (this.value && this.type === 'date') {
        this.tableDate = this.sanitizeDateString(this.value, 'month');
      } else if (this.value && this.type === 'month') {
        this.tableDate = this.sanitizeDateString(this.value, 'year');
      }
    },
    value: function value() {
      this.setInputDate();
      if (this.value && !this.pickerDate) {
        this.tableDate = this.sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
      }
    },
    type: function type(_type) {
      this.activePicker = _type.toUpperCase();

      if (this.value) {
        var date = this.sanitizeDateString(this.value, _type);
        this.$emit('input', this.isDateAllowed(date) ? date : null);
      }
    }
  },

  methods: {
    isDateAllowed: function isDateAllowed(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__util_isDateAllowed__["a" /* default */])(value, this.min, this.max, this.allowedDates);
    },
    yearClick: function yearClick(value) {
      this.inputYear = value;
      if (this.type === 'month') {
        this.tableDate = '' + value;
      } else {
        this.tableDate = value + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.tableMonth + 1);
      }
      this.activePicker = 'MONTH';
      this.reactive && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
    },
    monthClick: function monthClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
      if (this.type === 'date') {
        this.tableDate = value;
        this.activePicker = 'DATE';
        this.reactive && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
      } else {
        this.$emit('input', this.inputDate);
        this.$emit('change', this.inputDate);
      }
    },
    dateClick: function dateClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
      this.inputDay = parseInt(value.split('-')[2], 10);
      this.$emit('input', this.inputDate);
      this.$emit('change', this.inputDate);
    },
    genPickerTitle: function genPickerTitle() {
      var _this2 = this;

      return this.$createElement('v-date-picker-title', {
        props: {
          date: this.value ? this.formatters.titleDate(this.value) : '',
          selectingYear: this.activePicker === 'YEAR',
          year: this.formatters.year('' + this.inputYear),
          yearIcon: this.yearIcon,
          value: this.value
        },
        slot: 'title',
        style: this.readonly ? {
          'pointer-events': 'none'
        } : undefined,
        on: {
          'update:selectingYear': function updateSelectingYear(value) {
            return _this2.activePicker = value ? 'YEAR' : _this2.type.toUpperCase();
          }
        }
      });
    },
    genTableHeader: function genTableHeader() {
      var _this3 = this;

      return this.$createElement('v-date-picker-header', {
        props: {
          nextIcon: this.nextIcon,
          color: this.color,
          disabled: this.readonly,
          format: this.headerDateFormat,
          locale: this.locale,
          min: this.activePicker === 'DATE' ? this.minMonth : this.minYear,
          max: this.activePicker === 'DATE' ? this.maxMonth : this.maxYear,
          prevIcon: this.prevIcon,
          value: this.activePicker === 'DATE' ? this.tableYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.tableMonth + 1) : '' + this.tableYear
        },
        on: {
          toggle: function toggle() {
            return _this3.activePicker = _this3.activePicker === 'DATE' ? 'MONTH' : 'YEAR';
          },
          input: function input(value) {
            return _this3.tableDate = value;
          }
        }
      });
    },
    genDateTable: function genDateTable() {
      var _this4 = this;

      return this.$createElement('v-date-picker-date-table', {
        props: {
          allowedDates: this.allowedDates,
          color: this.color,
          current: this.current,
          disabled: this.readonly,
          events: this.events,
          eventColor: this.eventColor,
          firstDayOfWeek: this.firstDayOfWeek,
          format: this.dayFormat,
          locale: this.locale,
          min: this.min,
          max: this.max,
          tableDate: this.tableYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(this.tableMonth + 1),
          scrollable: this.scrollable,
          value: this.value
        },
        ref: 'table',
        on: {
          input: this.dateClick,
          tableDate: function tableDate(value) {
            return _this4.tableDate = value;
          }
        }
      });
    },
    genMonthTable: function genMonthTable() {
      var _this5 = this;

      return this.$createElement('v-date-picker-month-table', {
        props: {
          allowedDates: this.type === 'month' ? this.allowedDates : null,
          color: this.color,
          current: this.current ? this.sanitizeDateString(this.current, 'month') : null,
          disabled: this.readonly,
          format: this.monthFormat,
          locale: this.locale,
          min: this.minMonth,
          max: this.maxMonth,
          scrollable: this.scrollable,
          value: !this.value || this.type === 'month' ? this.value : this.value.substr(0, 7),
          tableDate: '' + this.tableYear
        },
        ref: 'table',
        on: {
          input: this.monthClick,
          tableDate: function tableDate(value) {
            return _this5.tableDate = value;
          }
        }
      });
    },
    genYears: function genYears() {
      return this.$createElement('v-date-picker-years', {
        props: {
          color: this.color,
          format: this.yearFormat,
          locale: this.locale,
          min: this.minYear,
          max: this.maxYear,
          value: '' + this.tableYear
        },
        on: {
          input: this.yearClick
        }
      });
    },
    genPickerBody: function genPickerBody() {
      var children = this.activePicker === 'YEAR' ? [this.genYears()] : [this.genTableHeader(), this.activePicker === 'DATE' ? this.genDateTable() : this.genMonthTable()];

      return this.$createElement('div', {
        key: this.activePicker,
        style: this.readonly ? {
          'pointer-events': 'none'
        } : undefined
      }, children);
    },

    // Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
    // 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'
    sanitizeDateString: function sanitizeDateString(dateString, type) {
      var _dateString$split = dateString.split('-'),
          _dateString$split2 = _slicedToArray(_dateString$split, 3),
          year = _dateString$split2[0],
          _dateString$split2$ = _dateString$split2[1],
          month = _dateString$split2$ === undefined ? 1 : _dateString$split2$,
          _dateString$split2$2 = _dateString$split2[2],
          date = _dateString$split2$2 === undefined ? 1 : _dateString$split2$2;

      return (year + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(month) + '-' + Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* pad */])(date)).substr(0, { date: 10, month: 7, year: 4 }[type]);
    },
    setInputDate: function setInputDate() {
      if (this.value) {
        var array = this.value.split('-');
        this.inputYear = parseInt(array[0], 10);
        this.inputMonth = parseInt(array[1], 10) - 1;
        if (this.type === 'date') {
          this.inputDay = parseInt(array[2], 10);
        }
      } else {
        this.inputYear = this.inputYear || this.now.getFullYear();
        this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
        this.inputDay = this.inputDay || this.now.getDate();
      }
    }
  },

  created: function created() {
    if (this.pickerDate !== this.tableDate) {
      this.$emit('update:pickerDate', this.tableDate);
    }
    this.setInputDate();
  },
  render: function render(h) {
    return this.genPicker('picker--date');
  }
});

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pad__ = __webpack_require__(23);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



/* harmony default export */ __webpack_exports__["a"] = (function (locale, options) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { start: 0, length: 0 },
      start = _ref.start,
      length = _ref.length;

  var makeIsoString = function makeIsoString(dateString) {
    var _dateString$trim$spli = dateString.trim().split(' ')[0].split('-'),
        _dateString$trim$spli2 = _slicedToArray(_dateString$trim$spli, 3),
        year = _dateString$trim$spli2[0],
        month = _dateString$trim$spli2[1],
        date = _dateString$trim$spli2[2];

    return [year, Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(month || 1), Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(date || 1)].join('-');
  };

  try {
    var intlFormatter = new Intl.DateTimeFormat(locale || undefined, options);
    return function (dateString) {
      return intlFormatter.format(new Date(makeIsoString(dateString) + 'T00:00:00+00:00'));
    };
  } catch (e) {
    return start || length ? function (dateString) {
      return makeIsoString(dateString).substr(start, length);
    } : null;
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pad__ = __webpack_require__(23);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



/**
 * @param {String} value YYYY-MM format
 * @param {Number} sign -1 or +1
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value, sign) {
  var _value$split$map = value.split('-').map(function (v) {
    return 1 * v;
  }),
      _value$split$map2 = _slicedToArray(_value$split$map, 2),
      year = _value$split$map2[0],
      month = _value$split$map2[1];

  if (month + sign === 0) {
    return year - 1 + '-12';
  } else if (month + sign === 13) {
    return year + 1 + '-01';
  } else {
    return year + '-' + Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(month + sign);
  }
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Components


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-picker',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'primary'
    };
  },


  props: {
    fullWidth: Boolean,
    landscape: Boolean,
    transition: {
      type: String,
      default: 'fade-transition'
    },
    width: {
      type: [Number, String],
      default: 290,
      validator: function validator(value) {
        return parseInt(value, 10) > 0;
      }
    }
  },

  computed: {
    computedTitleColor: function computedTitleColor() {
      var darkTheme = this.dark || !this.light && this.$vuetify.dark;
      var defaultTitleColor = darkTheme ? null : this.computedColor;
      return this.color || defaultTitleColor;
    }
  },

  methods: {
    genTitle: function genTitle() {
      return this.$createElement('div', {
        staticClass: 'picker__title',
        'class': this.addBackgroundColorClassChecks({
          'picker__title--landscape': this.landscape
        }, this.computedTitleColor)
      }, this.$slots.title);
    },
    genBodyTransition: function genBodyTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, this.$slots.default);
    },
    genBody: function genBody() {
      return this.$createElement('div', {
        staticClass: 'picker__body',
        style: this.fullWidth ? undefined : {
          width: this.width + 'px'
        }
      }, [this.genBodyTransition()]);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        staticClass: 'picker__actions card__actions'
      }, this.$slots.actions);
    }
  },

  render: function render(h) {
    return h('v-card', {
      staticClass: 'picker',
      'class': _extends({
        'picker--landscape': this.landscape
      }, this.themeClasses)
    }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
  }
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(34);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(180);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-divider',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('hr', data);
  }
});

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(185);
/* unused harmony reexport VExpansionPanel */
/* unused harmony reexport VExpansionPanelContent */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */]);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["b" /* provide */])('expansionPanel')],

  provide: function provide() {
    return {
      panelClick: this.panelClick,
      focusable: this.focusable
    };
  },
  data: function data() {
    return {
      items: []
    };
  },


  props: {
    expand: Boolean,
    focusable: Boolean,
    inset: Boolean,
    popout: Boolean
  },

  methods: {
    panelClick: function panelClick(uid) {
      if (!this.expand) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].toggle(uid);
        }
        return;
      }

      for (var _i = 0; _i < this.items.length; _i++) {
        if (this.items[_i].uid === uid) {
          this.items[_i].toggle(uid);
          return;
        }
      }
    },
    register: function register(uid, toggle) {
      this.items.push({ uid: uid, toggle: toggle });
    },
    unregister: function unregister(uid) {
      this.items = this.items.filter(function (i) {
        return i.uid !== uid;
      });
    }
  },

  render: function render(h) {
    return h('ul', {
      staticClass: 'expansion-panel',
      'class': _extends({
        'expansion-panel--focusable': this.focusable,
        'expansion-panel--popout': this.popout,
        'expansion-panel--inset': this.inset
      }, this.themeClasses)
    }, this.$slots.default);
  }
});

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_click_outside__ = __webpack_require__(8);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__mixins_registrable__["a" /* inject */])('expansionPanel', 'v-expansion-panel', 'v-expansion-panel-content')],

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_5__VIcon__["a" /* default */]
  },

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_6__directives_click_outside__["a" /* default */]
  },

  inject: ['focusable', 'panelClick'],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    expandIcon: {
      type: String,
      default: 'keyboard_arrow_down'
    },
    hideActions: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: false
    }
  },

  methods: {
    genBody: function genBody() {
      return this.$createElement('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, this.showLazyContent(this.$slots.default));
    },
    genHeader: function genHeader() {
      var _this = this;

      return this.$createElement('div', {
        staticClass: 'expansion-panel__header',
        directives: [{
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            return _this.panelClick(_this._uid);
          }
        }
      }, [this.$slots.header, this.genIcon()]);
    },
    genIcon: function genIcon(h) {
      if (this.hideActions) return null;

      var icon = this.$slots.actions || this.$createElement('v-icon', this.expandIcon);

      return this.$createElement('div', {
        staticClass: 'header__icon'
      }, [icon]);
    },
    toggle: function toggle(uid) {
      var _this2 = this;

      var isActive = this._uid === uid && !this.isActive;

      if (isActive) this.isBooted = true;

      // We treat bootable differently
      // Needs time to calc height
      this.$nextTick(function () {
        return _this2.isActive = isActive;
      });
    }
  },

  mounted: function mounted() {
    this.expansionPanel.register(this._uid, this.toggle);
  },
  beforeDestroy: function beforeDestroy() {
    this.expansionPanel.unregister(this._uid);
  },
  render: function render(h) {
    var _this3 = this;

    var children = [];

    this.$slots.header && children.push(this.genHeader());
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__transitions__["a" /* VExpandTransition */], [this.genBody()]));

    return h('li', {
      staticClass: 'expansion-panel__container',
      'class': {
        'expansion-panel__container--active': this.isActive
      },
      attrs: {
        tabindex: 0
      },
      on: {
        keydown: function keydown(e) {
          // Ensure element is focusable and the activeElement
          if (_this3.focusable && _this3.$el === document.activeElement && e.keyCode === 13) _this3.panelClick(_this3._uid);
        }
      }
    }, children);
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(187);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
// Styles


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-footer',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('footer', ['height']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    height: {
      default: 32,
      type: [Number, String]
    },
    inset: Boolean
  },

  computed: {
    computedMarginBottom: function computedMarginBottom() {
      if (!this.app) return;

      return this.$vuetify.application.bottom;
    },
    computedPaddingLeft: function computedPaddingLeft() {
      return !this.app || !this.inset ? 0 : this.$vuetify.application.left;
    },
    computedPaddingRight: function computedPaddingRight() {
      return !this.app ? 0 : this.$vuetify.application.right;
    },
    styles: function styles() {
      var styles = {
        height: isNaN(this.height) ? this.height : this.height + 'px'
      };

      if (this.computedPaddingLeft) {
        styles.paddingLeft = this.computedPaddingLeft + 'px';
      }

      if (this.computedPaddingRight) {
        styles.paddingRight = this.computedPaddingRight + 'px';
      }

      if (this.computedMarginBottom) {
        styles.marginBottom = this.computedMarginBottom + 'px';
      }

      return styles;
    }
  },

  methods: {
    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return isNaN(this.height) ? this.$el ? this.$el.clientHeight : 0 : this.height;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'footer',
      'class': this.addBackgroundColorClassChecks({
        'footer--absolute': this.absolute,
        'footer--fixed': !this.absolute && (this.app || this.fixed),
        'footer--inset': this.inset,
        'theme--dark': this.dark,
        'theme--light': this.light
      }),
      style: this.styles,
      ref: 'content'
    };

    return h('footer', data, this.$slots.default);
  }
});

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VForm__ = __webpack_require__(190);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */]);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-form',

  inheritAttrs: false,

  data: function data() {
    return {
      inputs: [],
      errorBag: {}
    };
  },


  props: {
    value: Boolean,
    lazyValidation: Boolean
  },

  watch: {
    errorBag: {
      handler: function handler() {
        var errors = Object.values(this.errorBag).includes(true);

        this.$emit('input', !errors);

        return !errors;
      },

      deep: true
    }
  },

  methods: {
    getInputs: function getInputs() {
      var results = [];

      var search = function search(children) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        for (var index = 0; index < children.length; index++) {
          var child = children[index];
          if (child.errorBucket !== undefined) {
            results.push(child);
          } else {
            search(child.$children, depth + 1);
          }
        }
        if (depth === 0) return results;
      };

      return search(this.$children);
    },
    watchInputs: function watchInputs() {
      var inputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getInputs();

      for (var index = 0; index < inputs.length; index++) {
        var child = inputs[index];
        if (this.inputs.includes(child)) {
          continue; // We already know about this input
        }

        this.inputs.push(child);
        this.watchChild(child);
      }
    },
    watchChild: function watchChild(child) {
      var _this = this;

      var watcher = function watcher(child) {
        child.$watch('valid', function (val) {
          _this.$set(_this.errorBag, child._uid, !val);
        }, { immediate: true });
      };

      if (!this.lazyValidation) return watcher(child);

      // Only start watching inputs if we need to
      child.$watch('shouldValidate', function (val) {
        if (!val) return;

        // Only watch if we're not already doing it
        if (_this.errorBag.hasOwnProperty(child._uid)) return;

        watcher(child);
      });
    },
    validate: function validate() {
      var errors = this.inputs.filter(function (input) {
        return !input.validate(true);
      }).length;
      return !errors;
    },
    reset: function reset() {
      for (var i = this.inputs.length; i--;) {
        this.inputs[i].reset();
      }
      if (this.lazyValidation) this.errorBag = {};
    }
  },

  mounted: function mounted() {
    this.watchInputs();
  },
  updated: function updated() {
    var inputs = this.getInputs();

    if (inputs.length < this.inputs.length) {
      // Something was removed, we don't want it in the errorBag any more
      var removed = this.inputs.filter(function (i) {
        return !inputs.includes(i);
      });

      for (var index = 0; index < removed.length; index++) {
        var input = removed[index];
        this.$delete(this.errorBag, input._uid);
        this.$delete(this.inputs, this.inputs.indexOf(input));
      }
    }

    this.watchInputs(inputs);
  },
  render: function render(h) {
    var _this2 = this;

    return h('form', {
      attrs: Object.assign({
        novalidate: true
      }, this.$attrs),
      on: {
        submit: function submit(e) {
          return _this2.$emit('submit', e);
        }
      }
    }, this.$slots.default);
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VSpacer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VContent__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VContainer__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VFlex__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VLayout__ = __webpack_require__(196);
/* unused harmony reexport VContainer */
/* unused harmony reexport VContent */
/* unused harmony reexport VFlex */
/* unused harmony reexport VLayout */






var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');



var VGrid = {};

/* istanbul ignore next */
VGrid.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VContent__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VContainer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VContainer__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VFlex__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VFlex__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VLayout__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VLayout__["a" /* default */]);
  Vue.component(VSpacer.name, VSpacer);
};

/* harmony default export */ __webpack_exports__["a"] = (VGrid);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ssr_bootable__ = __webpack_require__(24);
// Styles


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ssr_bootable__["a" /* default */]],

  props: {
    tag: {
      type: String,
      default: 'main'
    }
  },

  computed: {
    styles: function styles() {
      var _$vuetify$application = this.$vuetify.application,
          bar = _$vuetify$application.bar,
          top = _$vuetify$application.top,
          right = _$vuetify$application.right,
          footer = _$vuetify$application.footer,
          bottom = _$vuetify$application.bottom,
          left = _$vuetify$application.left;


      return {
        paddingTop: top + bar + 'px',
        paddingRight: right + 'px',
        paddingBottom: footer + bottom + 'px',
        paddingLeft: left + 'px'
      };
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'content',
      'class': this.classes,
      style: this.styles,
      ref: 'content'
    };

    return h(this.tag, data, [h('div', { staticClass: 'content--wrap' }, this.$slots.default)]);
  }
});

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('container'));

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('flex'));

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(30);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('layout'));

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(198);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ssr_bootable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_touch__ = __webpack_require__(9);


// Mixins





// Directives




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])(null, ['miniVariant', 'right', 'width']), __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_5__directives_click_outside__["a" /* default */],
    Resize: __WEBPACK_IMPORTED_MODULE_6__directives_resize__["a" /* default */],
    Touch: __WEBPACK_IMPORTED_MODULE_7__directives_touch__["a" /* default */]
  },

  data: function data() {
    return {
      isActive: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },

  props: {
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    disableResizeWatcher: Boolean,
    height: {
      type: [Number, String],
      default: '100%'
    },
    floating: Boolean,
    miniVariant: Boolean,
    miniVariantWidth: {
      type: [Number, String],
      default: 80
    },
    mobileBreakPoint: {
      type: [Number, String],
      default: 1264
    },
    permanent: Boolean,
    right: Boolean,
    stateless: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    width: {
      type: [Number, String],
      default: 300
    },
    value: { required: false }
  },

  computed: {
    /**
     * Used for setting an app
     * value from a dynamic
     * property. Called from
     * applicationable.js
     *
     * @return {string}
     */
    applicationProperty: function applicationProperty() {
      return this.right ? 'right' : 'left';
    },
    calculatedHeight: function calculatedHeight() {
      return isNaN(this.height) ? this.height : this.height + 'px';
    },
    calculatedTransform: function calculatedTransform() {
      if (this.isActive) return 0;

      return this.right ? this.calculatedWidth : -this.calculatedWidth;
    },
    calculatedWidth: function calculatedWidth() {
      return this.miniVariant ? this.miniVariantWidth : this.width;
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--fixed': !this.absolute && (this.app || this.fixed),
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    isMobile: function isMobile() {
      return !this.permanent && !this.temporary && this.$vuetify.breakpoint.width < parseInt(this.mobileBreakPoint, 10);
    },
    marginTop: function marginTop() {
      if (!this.app) return 0;
      var marginTop = this.$vuetify.application.bar;

      marginTop += this.clipped ? this.$vuetify.application.top : 0;

      return marginTop;
    },
    maxHeight: function maxHeight() {
      if (!this.app) return '100%';

      return this.clipped ? this.$vuetify.application.top + this.$vuetify.application.bottom : this.$vuetify.application.bottom;
    },
    reactsToClick: function reactsToClick() {
      return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
    },
    reactsToMobile: function reactsToMobile() {
      return !this.disableResizeWatcher && !this.stateless && !this.permanent && !this.temporary;
    },
    reactsToRoute: function reactsToRoute() {
      return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
    },
    resizeIsDisabled: function resizeIsDisabled() {
      return this.disableResizeWatcher || this.stateless;
    },
    showOverlay: function showOverlay() {
      return this.isActive && (this.isMobile || this.temporary);
    },
    styles: function styles() {
      var styles = {
        height: this.calculatedHeight,
        marginTop: this.marginTop + 'px',
        maxHeight: 'calc(100% - ' + this.maxHeight + 'px)',
        transform: 'translateX(' + this.calculatedTransform + 'px)',
        width: this.calculatedWidth + 'px'
      };

      return styles;
    }
  },

  watch: {
    $route: function $route() {
      if (this.reactsToRoute && this.closeConditional()) {
        this.isActive = false;
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.callUpdate();
    },

    /**
     * When mobile changes, adjust
     * the active state only when
     * there has been a previous
     * value
     */
    isMobile: function isMobile(val, prev) {
      !val && this.isActive && !this.temporary && this.removeOverlay();

      if (prev == null || this.resizeIsDisabled || !this.reactsToMobile) return;

      this.isActive = !val;
      this.callUpdate();
    },
    permanent: function permanent(val) {
      // If enabling prop
      // enable the drawer
      if (val) {
        this.isActive = true;
      }
      this.callUpdate();
    },
    showOverlay: function showOverlay(val) {
      if (val) this.genOverlay();else this.removeOverlay();
    },
    temporary: function temporary() {
      this.callUpdate();
    },
    value: function value(val) {
      if (this.permanent) return;

      if (val == null) return this.init();

      if (val !== this.isActive) this.isActive = val;
    }
  },

  beforeMount: function beforeMount() {
    this.init();
  },


  methods: {
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    closeConditional: function closeConditional() {
      return this.isActive && this.reactsToClick;
    },
    genDirectives: function genDirectives() {
      var _this = this;

      var directives = [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional
        }
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    },

    /**
     * Sets state before mount to avoid
     * entry transitions in SSR
     *
     * @return {void}
     */
    init: function init() {
      if (this.permanent) {
        this.isActive = true;
      } else if (this.stateless || this.value != null) {
        this.isActive = this.value;
      } else if (!this.temporary) {
        this.isActive = !this.isMobile;
      }
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return !this.isActive || this.temporary || this.isMobile ? 0 : this.calculatedWidth;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var data = {
      'class': this.classes,
      style: this.styles,
      directives: this.genDirectives(),
      on: {
        click: function click() {
          if (!_this2.miniVariant) return;

          _this2.$emit('update:miniVariant', false);
        }
      }
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(201);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  directives: { Resize: __WEBPACK_IMPORTED_MODULE_2__directives_resize__["a" /* default */] },

  data: function data() {
    return {
      maxButtons: 0,
      defaultColor: 'primary'
    };
  },


  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    totalVisible: [Number, String],
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      var maxLength = this.totalVisible || this.maxButtons;
      if (this.length <= maxLength) {
        return this.range(1, this.length);
      }

      var even = maxLength % 2 === 0 ? 1 : 0;
      var left = Math.floor(maxLength / 2);
      var right = this.length - left + 1 + even;

      if (this.value >= left && this.value <= right) {
        var start = this.value - left + 2;
        var end = this.value + left - 2 - even;

        return [1, '...'].concat(_toConsumableArray(this.range(start, end)), ['...', this.length]);
      } else {
        return [].concat(_toConsumableArray(this.range(1, left)), ['...'], _toConsumableArray(this.range(this.length - left + 1 + even, this.length)));
      }
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // TODO: Change this (f75dee3a, cbdf7caa)
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    onResize: function onResize() {
      var width = this.$el && this.$el.parentNode ? this.$el.parentNode.clientWidth : window.innerWidth;

      this.maxButtons = Math.floor((width - 96) / 42);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('button', {
        staticClass: 'pagination__navigation',
        class: {
          'pagination__navigation--disabled': disabled
        },
        on: disabled ? {} : { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('button', {
        staticClass: 'pagination__item',
        class: i === this.value ? this.addBackgroundColorClassChecks({
          'pagination__item--active': true
        }) : {},
        on: {
          click: function click() {
            return _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i, index) {
        return h('li', { key: index }, [isNaN(i) ? h('span', { class: 'pagination__more' }, [i]) : _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value <= 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value >= this.length, this.next)];

    return h('ul', {
      directives: [{ name: 'resize', value: this.onResize }],
      class: this.classes
    }, children);
  }
});

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(204);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_translatable__ = __webpack_require__(206);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_translatable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: false
    };
  },


  props: {
    alt: String,
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        opacity: this.isBooted ? 1 : 0,
        transform: 'translate(-50%, ' + this.parallax + 'px)'
      };
    }
  },

  watch: {
    parallax: function parallax() {
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var imgData = {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    };

    if (this.alt) imgData.attrs.alt = this.alt;

    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', imgData)]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: this.normalizedHeight + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'translatable',

  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      if (this.jumbotron) {
        return isNaN(this.height) ? this.height : this.height + 'px';
      }

      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VRadioGroup__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(210);
/* unused harmony reexport VRadioGroup */
/* unused harmony reexport VRadio */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */]);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_registrable__ = __webpack_require__(4);
// Styles




// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-radio-group',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__mixins_registrable__["b" /* provide */])('radio')],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  provide: function provide() {
    var _this = this;

    return {
      isMandatory: function isMandatory() {
        return _this.mandatory;
      },
      name: function name() {
        return _this.name;
      }
    };
  },


  data: function data() {
    return {
      internalTabIndex: -1,
      radios: []
    };
  },

  props: {
    column: {
      type: Boolean,
      default: true
    },
    inputValue: null,
    mandatory: {
      type: Boolean,
      default: true
    },
    name: String,
    row: Boolean
  },

  watch: {
    hasError: function hasError(val) {
      for (var index = this.radios.length; --index >= 0;) {
        this.radios[index].parentError = val;
      }
    },
    inputValue: function inputValue(val) {
      for (var index = this.radios.length; --index >= 0;) {
        var radio = this.radios[index];
        radio.isActive = val === radio.value;
      }
    }
  },

  computed: {
    classes: function classes() {
      return {
        'radio-group': true,
        'radio-group--column': this.column && !this.row,
        'radio-group--row': this.row,
        'error--text': this.hasError
      };
    }
  },

  methods: {
    toggleRadio: function toggleRadio(value) {
      var _this2 = this;

      if (this.disabled) {
        return;
      }

      this.shouldValidate = true;
      this.$emit('change', value);
      this.$nextTick(function () {
        return _this2.validate();
      });

      for (var index = this.radios.length; --index >= 0;) {
        var radio = this.radios[index];
        if (radio.value !== value) radio.isActive = false;
      }
    },
    radioBlur: function radioBlur(e) {
      if (!e.relatedTarget || !e.relatedTarget.classList.contains('radio')) {
        this.shouldValidate = true;
        this.$emit('blur', this.inputValue);
      }
    },
    register: function register(radio) {
      radio.isActive = this.inputValue === radio.value;
      radio.$el.tabIndex = radio.$el.tabIndex > 0 ? radio.$el.tabIndex : 0;
      radio.$on('change', this.toggleRadio);
      radio.$on('blur', this.radioBlur);
      radio.$on('focus', this.radioFocus);
      this.radios.push(radio);
    },
    unregister: function unregister(radio) {
      radio.$off('change', this.toggleRadio);
      radio.$off('blur', this.radioBlur);
      radio.$off('focus', this.radioFocus);

      var index = this.radios.findIndex(function (r) {
        return r === radio;
      });

      if (index > -1) this.radios.splice(index, 1);
    }
  },

  render: function render(h) {
    var data = {
      attrs: {
        role: 'radiogroup'
      }
    };
    return this.genInputGroup(this.$slots.default, data);
  }
});

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_tab_focusable__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_registrable__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Components



// Mixins






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-radio',

  inheritAttrs: false,

  inject: ['isMandatory', 'name'],

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_6__mixins_registrable__["a" /* inject */])('radio', 'v-radio', 'v-radio-group'), __WEBPACK_IMPORTED_MODULE_4__mixins_tab_focusable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent',
      isActive: false,
      parentError: false
    };
  },

  props: {
    disabled: Boolean,
    value: null,
    label: String
  },

  computed: {
    classes: function classes() {
      var classes = {
        'input-group': true,
        'input-group--active': this.isActive,
        'input-group--disabled': this.disabled,
        'input-group--selection-controls': true,
        'input-group--tab-focused': this.tabFocused,
        'radio': true,
        'theme--dark': this.dark,
        'theme--light': this.light
      };

      if (!this.parentError) {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genInput: function genInput(radio) {
      var value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);
      var input = this.$createElement('input', {
        ref: 'input',
        style: {
          display: 'none'
        },
        attrs: Object.assign({
          name: this.name && this.name(),
          id: this.id,
          type: 'radio',
          value: value
        }, this.$attrs)
      }, [value]);

      radio.push(input);

      return this.$createElement('div', {
        class: 'input-group__input'
      }, radio);
    },
    genWrapper: function genWrapper(radio) {
      var _this = this;

      var children = [];

      children.push(this.genLabel());
      children.push(this.genInput(radio));

      return this.$createElement('div', {
        class: this.classes,
        attrs: {
          role: 'radio',
          'aria-checked': this.isActive ? 'true' : 'false',
          'aria-label': this.label
        },
        on: {
          keydown: function keydown(e) {
            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this.toggle();
            }
          },
          blur: function blur(e) {
            _this.$emit('blur', e);
            _this.tabFocused = false;
          }
        }
      }, children);
    },
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: {
          click: this.toggle
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      var mandatory = !!this.isMandatory && this.isMandatory();

      if (!this.disabled && (!this.isActive || !mandatory)) {
        this.$refs.input.checked = true;
        this.isActive = true;
        this.$emit('change', this.value);
      }
    }
  },

  mounted: function mounted() {
    this.radio.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.radio.unregister(this);
  },
  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      staticClass: 'icon--selection-control',
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon,
      on: Object.assign({
        click: this.toggle
      }, this.$listeners)
    }, this.icon)]);

    var ripple = this.ripple ? this.genRipple() : null;

    return this.genWrapper([transition, ripple]);
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tab-focusable',

  data: function data() {
    return {
      tabFocused: false
    };
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(213);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_console__ = __webpack_require__(5);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */]],

  directives: { ClickOutside: __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__["a" /* default */] },

  components: { VScaleTransition: __WEBPACK_IMPORTED_MODULE_5__transitions__["c" /* VScaleTransition */] },

  data: function data() {
    return {
      app: {},
      defaultColor: 'primary',
      isActive: false,
      keyPressed: 0
    };
  },


  props: {
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: 1
    },
    ticks: Boolean,
    thumbColor: {
      type: String,
      default: null
    },
    thumbLabel: Boolean,
    trackColor: {
      type: String,
      default: null
    },
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.stepNumeric && this.ticks
      };
    },
    computedColor: function computedColor() {
      return this.disabled ? null : this.color || this.defaultColor;
    },
    computedTrackColor: function computedTrackColor() {
      return this.disabled ? null : this.trackColor || null;
    },
    computedThumbColor: function computedThumbColor() {
      return this.disabled || !this.inputWidth ? null : this.thumbColor || this.color || this.defaultColor;
    },
    stepNumeric: function stepNumeric() {
      return this.step > 0 ? parseFloat(this.step) : 0;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max;

        val = Math.min(Math.max(val, min), max);

        // Round value to ensure the
        // entire slider range can
        // be selected with step
        var value = this.roundValue(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.stepNumeric;
    },
    thumbStyles: function thumbStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate(0, -50%)'
      };
    },
    trackPadding: function trackPadding() {
      if (this.thumbLabel && this.isActive) return 0;

      return 6 + (this.isActive && !this.disabled ? 3 : 0);
    },
    trackStyles: function trackStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        left: 'calc(' + this.inputWidth + '% + ' + this.trackPadding + 'px)',
        width: 'calc(' + (100 - this.inputWidth) + '% - ' + this.trackPadding + 'px)'
      };
    },
    trackFillStyles: function trackFillStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        width: 'calc(' + this.inputWidth + '% - ' + this.trackPadding + 'px)'
      };
    },
    numTicks: function numTicks() {
      return Math.ceil((this.max - this.min) / this.stepNumeric);
    },
    inputWidth: function inputWidth() {
      return (this.roundValue(this.inputValue) - this.min) / (this.max - this.min) * 100;
    }
  },

  watch: {
    isActive: function isActive(val) {
      this.isFocused = val;
    },
    min: function min(val) {
      val > this.inputValue && this.$emit('input', parseFloat(val));
    },
    max: function max(val) {
      val < this.inputValue && this.$emit('input', parseFloat(val));
    },
    value: function value(val) {
      this.inputValue = parseFloat(val);
    }
  },

  mounted: function mounted() {
    this.inputValue = this.value;

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || Object(__WEBPACK_IMPORTED_MODULE_6__util_console__["b" /* consoleWarn */])('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
  },


  methods: {
    onMouseDown: function onMouseDown(e) {
      this.keyPressed = 2;
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      this.keyPressed = 0;
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = Math.min(Math.max((clientX - offsetLeft) / trackWidth, 0), 1);

      if (clientX >= offsetLeft - 8 && clientX <= offsetLeft + trackWidth + 8) {
        this.inputValue = parseFloat(this.min) + left * (this.max - this.min);
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (this.disabled || ![33, 34, 35, 36, 37, 39].includes(e.keyCode)) return;

      e.preventDefault();
      var step = this.stepNumeric || 1;
      var steps = (this.max - this.min) / step;
      if (e.keyCode === 37 || e.keyCode === 39) {
        // Left/right
        this.keyPressed += 1;

        var direction = e.keyCode === 37 ? -1 : 1;
        var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;

        this.inputValue = this.inputValue + direction * step * multiplier;
      } else if (e.keyCode === 36) {
        // Home
        this.inputValue = parseFloat(this.min);
      } else if (e.keyCode === 35) {
        // End
        this.inputValue = parseFloat(this.max);
      } else /* if (e.keyCode === 33 || e.keyCode === 34) */{
          // Page up/down
          var _direction = e.keyCode === 34 ? -1 : 1;
          this.inputValue = this.inputValue - _direction * step * (steps > 100 ? steps / 10 : 10);
        }
    },
    onKeyUp: function onKeyUp(e) {
      this.keyPressed = 0;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        staticClass: 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', {
        staticClass: 'slider__thumb--label',
        'class': this.addBackgroundColorClassChecks({}, this.computedThumbColor)
      }, [h('span', {}, this.inputValue)])])]);
    },
    roundValue: function roundValue(value) {
      if (!this.stepNumeric) {
        return value;
      }

      // Format input value using the same number
      // of decimals places as in the step prop
      var trimmedStep = this.step.toString().trim();
      var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
      return 1 * (Math.round(value / this.stepNumeric) * this.stepNumeric).toFixed(decimals);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', {
        staticClass: 'slider__thumb',
        'class': this.addBackgroundColorClassChecks({}, this.computedThumbColor)
      }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        staticClass: 'slider__thumb-container',
        'class': {
          'slider__thumb-container--label': this.thumbLabel
        },
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          key: i,
          staticClass: 'slider__tick',
          style: {
            left: i * (100 / _this.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        staticClass: 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        staticClass: 'slider__track',
        'class': this.addBackgroundColorClassChecks({}, this.computedTrackColor),
        style: this.trackStyles
      }), h('div', {
        staticClass: 'slider__track-fill',
        'class': this.addBackgroundColorClassChecks(),
        style: this.trackFillStyles
      })];

      return h('div', {
        staticClass: 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && this.ticks && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', {
      staticClass: 'slider'
    }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.disabled ? -1 : this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown,
        keyup: this.onKeyUp
      }, this.$listeners),
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this2.isActive = false;
        }
      }]
    });
  }
});

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(216);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["b" /* factory */])(['absolute', 'top', 'bottom', 'left', 'right'])],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    autoHeight: Boolean,
    multiLine: Boolean,
    // TODO: change this to closeDelay to match other API in delayable.js
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--auto-height': this.autoHeight,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.setTimeout();
    }
  },

  methods: {
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    })
  },

  mounted: function mounted() {
    this.setTimeout();
  },
  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        staticClass: 'snack',
        class: this.classes,
        on: this.$listeners
      }, [h('div', {
        staticClass: 'snack__wrapper',
        class: this.addBackgroundColorClassChecks()
      }, [h('div', {
        staticClass: 'snack__content'
      }, this.$slots.default)])]));
    }

    return h('transition', {
      attrs: { name: 'snack-transition' }
    }, children);
  }
});

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSpeedDial__ = __webpack_require__(219);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */]);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_transitionable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_transitionable__["a" /* default */]],

  directives: { ClickOutside: __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__["a" /* default */] },

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    openOnHover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        }
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.openOnHover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        mode: this.mode,
        origin: this.origin,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VStepperHeader */
/* unused harmony export VStepperItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(225);
/* unused harmony reexport VStepper */
/* unused harmony reexport VStepperContent */
/* unused harmony reexport VStepperStep */





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');
var VStepperItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__items');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]);
  Vue.component(VStepperHeader.name, VStepperHeader);
  Vue.component(VStepperItems.name, VStepperItems);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */]);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      this.isReverse = Number(val) < Number(prev);
      for (var index = this.steps.length; --index >= 0;) {
        this.steps[index].toggle(this.inputValue);
      }
      for (var _index = this.content.length; --_index >= 0;) {
        this.content[_index].toggle(this.inputValue, this.isReverse);
      }

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      var _this = this;

      this.getSteps();
      this.$nextTick(function () {
        return _this.inputValue = _this.value;
      });
    }
  },

  mounted: function mounted() {
    this.getSteps();

    this.inputValue = this.value || this.steps[0].step || 1;
  },


  methods: {
    getSteps: function getSteps() {
      this.steps = [];
      this.content = [];
      for (var index = 0; index < this.$children.length; index++) {
        var child = this.$children[index];
        if (child.$options._componentTag === 'v-stepper-step') {
          this.steps.push(child);
        } else if (child.$options._componentTag === 'v-stepper-content') {
          child.isVertical = this.vertical;
          this.content.push(child);
        }
      }
    },
    stepClick: function stepClick(step) {
      var _this2 = this;

      this.getSteps();
      this.$nextTick(function () {
        return _this2.inputValue = step;
      });
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  components: { VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */] },

  directives: { Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */] },

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete,
        'error--text': this.hasError
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', {
      staticClass: 'stepper__step__step',
      'class': {
        'primary': !this.hasError && (this.complete || this.isActive)
      }
    }, stepContent);

    var label = h('div', {
      staticClass: 'stepper__label'
    }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  components: {
    VTabTransition: __WEBPACK_IMPORTED_MODULE_0__transitions__["f" /* VTabTransition */],
    VTabReverseTransition: __WEBPACK_IMPORTED_MODULE_0__transitions__["e" /* VTabReverseTransition */]
  },

  data: function data() {
    return {
      height: 0,
      // Must be null to allow
      // previous comparison
      isActive: null,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive(current, previous) {
      // If active and the previous state
      // was null, is just booting up
      if (current && previous == null) {
        return this.height = 'auto';
      }

      if (!this.isVertical) return;

      if (this.isActive) this.enter();else this.leave();
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition(e) {
      if (!this.isActive || e.propertyName !== 'height') return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      requestAnimationFrame(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      });

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 10);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(227);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-subheader',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSwitch__ = __webpack_require__(230);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */]);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_selectable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_touch__ = __webpack_require__(9);




// Mixins



// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_selectable__["a" /* default */]],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_5__directives_touch__["a" /* default */] },

  computed: {
    classes: function classes() {
      var classes = {
        'input-group--selection-controls switch': true
      };

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return {
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      };
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  methods: {
    onSwipeLeft: function onSwipeLeft() {
      if (this.isActive) this.toggle();
    },
    onSwipeRight: function onSwipeRight() {
      if (!this.isActive) this.toggle();
    }
  },

  render: function render(h) {
    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), this.genRipple({
      directives: [{
        name: 'touch',
        value: {
          left: this.onSwipeLeft,
          right: this.onSwipeRight
        }
      }]
    })]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSystemBar__ = __webpack_require__(233);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */]);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-system-bar',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('bar', ['height', 'window']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    height: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addBackgroundColorClassChecks(Object.assign({
        'system-bar--lights-out': this.lightsOut,
        'system-bar--absolute': this.absolute,
        'system-bar--fixed': !this.absolute && (this.app || this.fixed),
        'system-bar--status': this.status,
        'system-bar--window': this.window
      }, this.themeClasses));
    },
    computedHeight: function computedHeight() {
      if (this.height) return parseInt(this.height);

      return this.window ? 32 : 24;
    }
  },

  methods: {
    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return this.computedHeight;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'system-bar',
      'class': this.classes,
      style: {
        height: this.computedHeight + 'px'
      }
    };

    return h('div', data, this.$slots.default);
  }
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTabs__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTab__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItems__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabItem__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsSlider__ = __webpack_require__(66);
/* unused harmony reexport VTabs */
/* unused harmony reexport VTabItem */
/* unused harmony reexport VTab */
/* unused harmony reexport VTabsItems */
/* unused harmony reexport VTabsSlider */








/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VTab__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VTab__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VTabsItems__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VTabsItems__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VTabItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VTabItem__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VTabsSlider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VTabsSlider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItems__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsSlider__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_tabs_computed__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_tabs_generators__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_tabs_props__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_tabs_touch__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_tabs_watchers__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_ssr_bootable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_touch__ = __webpack_require__(9);
// Styles


// Component imports




// Component level mixins






// Mixins





// Directives



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  components: {
    VIcon: __WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */],
    VTabsItems: __WEBPACK_IMPORTED_MODULE_2__VTabsItems__["a" /* default */],
    VTabsSlider: __WEBPACK_IMPORTED_MODULE_3__VTabsSlider__["a" /* default */]
  },

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_12__mixins_registrable__["b" /* provide */])('tabs'), __WEBPACK_IMPORTED_MODULE_9__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_tabs_computed__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_tabs_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_tabs_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_tabs_touch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_tabs_watchers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_themeable__["a" /* default */]],

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_13__directives_resize__["a" /* default */],
    Touch: __WEBPACK_IMPORTED_MODULE_14__directives_touch__["a" /* default */]
  },

  provide: function provide() {
    return {
      tabClick: this.tabClick,
      tabProxy: this.tabProxy,
      registerItems: this.registerItems,
      unregisterItems: this.unregisterItems
    };
  },
  data: function data() {
    return {
      bar: [],
      content: [],
      isBooted: false,
      isOverflowing: false,
      lazyValue: this.value,
      nextIconVisible: false,
      prevIconVisible: false,
      resizeTimeout: null,
      reverse: false,
      scrollOffset: 0,
      sliderWidth: null,
      sliderLeft: null,
      startX: 0,
      tabsContainer: null,
      tabs: [],
      tabItems: null,
      transitionTime: 300
    };
  },


  methods: {
    checkPrevIcon: function checkPrevIcon() {
      return this.scrollOffset > 0;
    },
    checkNextIcon: function checkNextIcon() {
      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var wrapper = this.$refs.wrapper;

      return container.clientWidth > this.scrollOffset + wrapper.clientWidth;
    },
    callSlider: function callSlider() {
      this.setOverflow();
      if (this.hideSlider || !this.activeTab) return false;

      // Give screen time to paint
      var action = this.activeTab.action;
      var activeTab = action === this.activeTab ? this.activeTab : this.tabs.find(function (tab) {
        return tab.action === action;
      });

      if (!activeTab) return;
      this.sliderWidth = activeTab.$el.scrollWidth;
      this.sliderLeft = activeTab.$el.offsetLeft;
    },

    /**
     * When v-navigation-drawer changes the
     * width of the container, call resize
     * after the transition is complete
     */
    onContainerResize: function onContainerResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.callSlider, this.transitionTime);
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      this.callSlider();
      this.scrollIntoView();
    },
    overflowCheck: function overflowCheck(e, fn) {
      this.isOverflowing && fn(e);
    },
    scrollTo: function scrollTo(direction) {
      this.scrollOffset = this.newOffset(direction);
    },
    setOverflow: function setOverflow() {
      this.isOverflowing = this.$refs.bar.clientWidth < this.$refs.container.clientWidth;
    },
    findActiveLink: function findActiveLink() {
      var _this = this;

      if (!this.tabs.length || this.lazyValue) return;

      var activeIndex = this.tabs.findIndex(function (tabItem, index) {
        var id = tabItem.action === tabItem ? index.toString() : tabItem.action;
        return id === _this.lazyValue || tabItem.$el.firstChild.className.indexOf(_this.activeClass) > -1;
      });

      var index = activeIndex > -1 ? activeIndex : 0;
      var tab = this.tabs[index];

      /* istanbul ignore next */
      // There is not a reliable way to test
      this.inputValue = tab.action === tab ? index : tab.action;
    },
    parseNodes: function parseNodes() {
      var item = [];
      var items = [];
      var slider = [];
      var tab = [];
      var length = (this.$slots.default || []).length;

      for (var i = 0; i < length; i++) {
        var vnode = this.$slots.default[i];

        /* istanbul ignore else */
        if (vnode.componentOptions) {
          switch (vnode.componentOptions.Ctor.options.name) {
            case 'v-tabs-slider':
              slider.push(vnode);
              break;
            case 'v-tabs-items':
              items.push(vnode);
              break;
            case 'v-tab-item':
              item.push(vnode);
              break;
            // case 'v-tab' - intentionally omitted
            default:
              tab.push(vnode);
          }
        }
      }

      return { tab: tab, slider: slider, items: items, item: item };
    },
    register: function register(options) {
      this.tabs.push(options);
    },
    scrollIntoView: function scrollIntoView() {
      if (!this.activeTab) return false;

      var _activeTab$$el = this.activeTab.$el,
          clientWidth = _activeTab$$el.clientWidth,
          offsetLeft = _activeTab$$el.offsetLeft;

      var wrapperWidth = this.$refs.wrapper.clientWidth;
      var totalWidth = wrapperWidth + this.scrollOffset;
      var itemOffset = clientWidth + offsetLeft;
      var additionalOffset = clientWidth * 0.3;

      /* instanbul ignore else */
      if (offsetLeft < this.scrollOffset) {
        this.scrollOffset = Math.max(offsetLeft - additionalOffset, 0);
      } else if (totalWidth < itemOffset) {
        this.scrollOffset -= totalWidth - itemOffset - additionalOffset;
      }
    },
    tabClick: function tabClick(tab) {
      this.inputValue = tab.action === tab ? this.tabs.indexOf(tab) : tab.action;
      this.scrollIntoView();
    },
    tabProxy: function tabProxy(val) {
      this.inputValue = val;
    },
    registerItems: function registerItems(fn) {
      this.tabItems = fn;
    },
    unregisterItems: function unregisterItems() {
      this.tabItems = null;
    },
    unregister: function unregister(tab) {
      this.tabs = this.tabs.filter(function (o) {
        return o !== tab;
      });
    },
    updateTabs: function updateTabs() {
      for (var index = this.tabs.length; --index >= 0;) {
        this.tabs[index].toggle(this.target);
      }

      this.setOverflow();
    }
  },

  mounted: function mounted() {
    this.prevIconVisible = this.checkPrevIcon();
    this.nextIconVisible = this.checkNextIcon();
  },
  render: function render(h) {
    var _parseNodes = this.parseNodes(),
        tab = _parseNodes.tab,
        slider = _parseNodes.slider,
        items = _parseNodes.items,
        item = _parseNodes.item;

    return h('div', {
      staticClass: 'tabs',
      directives: [{
        name: 'resize',
        arg: 400,
        modifiers: { quiet: true },
        value: this.onResize
      }]
    }, [this.genBar([this.hideSlider ? null : this.genSlider(slider), tab]), this.genItems(items, item)]);
  }
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs computed
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    activeIndex: function activeIndex() {
      var _this = this;

      return this.tabs.findIndex(function (tab, index) {
        var id = tab.action === tab ? index.toString() : tab.action;
        return id === _this.lazyValue;
      });
    },
    activeTab: function activeTab() {
      if (!this.tabs.length) return undefined;

      return this.tabs[this.activeIndex];
    },
    containerStyles: function containerStyles() {
      return this.height ? {
        height: parseInt(this.height, 10) + 'px'
      } : null;
    },
    hasArrows: function hasArrows() {
      return (this.showArrows || !this.isMobile) && this.isOverflowing;
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        // Always use strings
        val = val.toString();

        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.width < this.mobileBreakPoint;
    },
    sliderStyles: function sliderStyles() {
      return {
        left: this.sliderLeft + 'px',
        transition: this.sliderLeft != null ? null : 'none',
        width: this.sliderWidth + 'px'
      };
    },
    target: function target() {
      return this.activeTab ? this.activeTab.action : null;
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs generators
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genBar: function genBar(items) {
      return this.$createElement('div', {
        staticClass: 'tabs__bar',
        'class': this.addBackgroundColorClassChecks({
          'theme--dark': this.dark,
          'theme--light': this.light
        }),
        ref: 'bar'
      }, [this.genTransition('prev'), this.genWrapper(this.genContainer(items)), this.genTransition('next')]);
    },
    genContainer: function genContainer(items) {
      return this.$createElement('div', {
        staticClass: 'tabs__container',
        class: {
          'tabs__container--align-with-title': this.alignWithTitle,
          'tabs__container--centered': this.centered,
          'tabs__container--fixed-tabs': this.fixedTabs,
          'tabs__container--grow': this.grow,
          'tabs__container--icons-and-text': this.iconsAndText,
          'tabs__container--overflow': this.isOverflowing,
          'tabs__container--right': this.right
        },
        style: this.containerStyles,
        ref: 'container'
      }, items);
    },
    genIcon: function genIcon(direction) {
      var _this = this;

      if (!this.hasArrows || !this[direction + 'IconVisible']) return null;

      return this.$createElement('v-icon', {
        staticClass: 'tabs__icon tabs__icon--' + direction,
        props: {
          disabled: !this[direction + 'IconVisible']
        },
        on: {
          click: function click() {
            return _this.scrollTo(direction);
          }
        }
      }, this[direction + 'Icon']);
    },
    genItems: function genItems(items, item) {
      if (items.length > 0) return items;
      if (!item.length) return null;

      return this.$createElement('v-tabs-items', item);
    },
    genTransition: function genTransition(direction) {
      return this.$createElement('transition', {
        props: { name: 'fade-transition' }
      }, [this.genIcon(direction)]);
    },
    genWrapper: function genWrapper(items) {
      var _this2 = this;

      return this.$createElement('div', {
        staticClass: 'tabs__wrapper',
        class: {
          'tabs__wrapper--show-arrows': this.hasArrows
        },
        ref: 'wrapper',
        directives: [{
          name: 'touch',
          value: {
            start: function start(e) {
              return _this2.overflowCheck(e, _this2.onTouchStart);
            },
            move: function move(e) {
              return _this2.overflowCheck(e, _this2.onTouchMove);
            },
            end: function end(e) {
              return _this2.overflowCheck(e, _this2.onTouchEnd);
            }
          }
        }]
      }, [items]);
    },
    genSlider: function genSlider(items) {
      if (!items.length) {
        items = [this.$createElement('v-tabs-slider', {
          props: { color: this.sliderColor }
        })];
      }

      return this.$createElement('div', {
        staticClass: 'tabs__slider-wrapper',
        style: this.sliderStyles
      }, items);
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs props
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    alignWithTitle: Boolean,
    centered: Boolean,
    fixedTabs: Boolean,
    grow: Boolean,
    height: {
      type: [Number, String],
      default: undefined,
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    hideSlider: Boolean,
    iconsAndText: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1264,
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    right: Boolean,
    showArrows: Boolean,
    sliderColor: {
      type: String,
      default: 'accent'
    },
    value: [Number, String]
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs touch
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    newOffset: function newOffset(direction) {
      var clientWidth = this.$refs.wrapper.clientWidth;

      if (direction === 'prev') {
        return Math.max(this.scrollOffset - clientWidth, 0);
      } else {
        return Math.min(this.scrollOffset + clientWidth, this.$refs.container.clientWidth - clientWidth);
      }
    },
    onTouchStart: function onTouchStart(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
      this.$refs.container.style.willChange = 'transform';
    },
    onTouchMove: function onTouchMove(e) {
      this.scrollOffset = this.startX - e.touchmoveX;
    },
    onTouchEnd: function onTouchEnd() {
      var container = this.$refs.container;
      var wrapper = this.$refs.wrapper;
      var maxScrollOffset = container.clientWidth - wrapper.clientWidth;
      container.style.transition = null;
      container.style.willChange = null;

      /* istanbul ignore else */
      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= maxScrollOffset) {
        this.scrollOffset = maxScrollOffset;
      }
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs watchers
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    activeTab: function activeTab(tab, prev) {
      !prev && tab && this.updateTabs();

      setTimeout(this.callSlider, 0);

      if (!tab) return;

      var action = tab.action;
      this.tabItems && this.tabItems(action === tab ? this.tabs.indexOf(tab).toString() : action);
    },

    alignWithTitle: 'callSlider',
    centered: 'callSlider',
    fixedTabs: 'callSlider',
    isBooted: 'findActiveLink',
    lazyValue: 'updateTabs',
    right: 'callSlider',
    value: function value(val) {
      var tab = this.tabs.find(function (tab) {
        return tab.action === val;
      }) || this.tabs[val];

      if (!tab) return;

      this.tabClick(tab);
    },

    '$vuetify.application.left': 'onContainerResize',
    '$vuetify.application.right': 'onContainerResize',
    scrollOffset: function scrollOffset(val) {
      this.$refs.container.style.transform = 'translateX(' + -val + 'px)';
      if (this.hasArrows) {
        this.prevIconVisible = this.checkPrevIcon();
        this.nextIconVisible = this.checkNextIcon();
      }
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_helpers__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Mixins



// Utilities


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tab',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_registrable__["a" /* inject */])('tabs', 'v-tab', 'v-tabs'), __WEBPACK_IMPORTED_MODULE_0__mixins_routable__["a" /* default */]],

  inject: ['tabClick'],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    },
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      }, this.activeClass, !this.to && this.isActive);
    },
    action: function action() {
      var to = this.to || this.href;

      if (typeof to === 'string') return to.replace('#', '');
      if (to === Object(to) && (to.hasOwnProperty('name') || to.hasOwnProperty('path'))) return to.name || to.path;

      return this;
    }
  },

  watch: {
    $route: 'onRouteChange'
  },

  mounted: function mounted() {
    this.tabs.register(this);
    this.onRouteChange();
  },
  beforeDestroy: function beforeDestroy() {
    this.tabs.unregister(this);
  },


  methods: {
    click: function click(e) {
      // If user provides an
      // actual link, do not
      // prevent default
      if (this.href && this.href.indexOf('#') > -1) e.preventDefault();

      this.$emit('click', e);

      this.to || this.tabClick(this);
    },
    onRouteChange: function onRouteChange() {
      var _this = this;

      if (!this.to || !this.$refs.link) return;

      var path = '_vnode.data.class.' + this.activeClass;

      this.$nextTick(function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_helpers__["h" /* getObjectValueByPath */])(_this.$refs.link, path)) {
          _this.tabClick(_this);
        }
      });
    },
    toggle: function toggle(action) {
      this.isActive = action === this || action === this.action;
    }
  },

  render: function render(h) {
    var link = this.generateRouteLink();
    var data = link.data;

    // If disabled, use div as anchor tags do not support
    // being disabled

    var tag = this.disabled ? 'div' : link.tag;

    data.ref = 'link';

    return h('div', {
      staticClass: 'tabs__div'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_touch__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tab-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["a" /* inject */])('tabs', 'v-tab-item', 'v-tabs-items')],

  components: {
    VTabTransition: __WEBPACK_IMPORTED_MODULE_1__transitions__["f" /* VTabTransition */],
    VTabReverseTransition: __WEBPACK_IMPORTED_MODULE_1__transitions__["e" /* VTabReverseTransition */]
  },

  directives: {
    Touch: __WEBPACK_IMPORTED_MODULE_3__directives_touch__["a" /* default */]
  },

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: String,
    transition: {
      type: [Boolean, String],
      default: 'tab-transition'
    },
    reverseTransition: {
      type: [Boolean, String],
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition, index) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = (this.id || index.toString()) === target;
    }
  },

  mounted: function mounted() {
    this.tabs.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.tabs.unregister(this);
  },
  render: function render(h) {
    var data = {
      staticClass: 'tabs__content',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      domProps: { id: this.id },
      on: this.$listeners
    };

    var div = h('div', data, this.showLazyContent(this.$slots.default));

    if (!this.computedTransition) return div;

    return h('transition', {
      props: { name: this.computedTransition }
    }, [div]);
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(246);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_maskable__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_soloable__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles



// Mixins





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_maskable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_soloable__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      initialValue: null,
      inputHeight: null,
      internalChange: false,
      badInput: false
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    box: Boolean,
    clearable: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    counter: [Boolean, Number, String],
    fullWidth: Boolean,
    multiLine: Boolean,
    noResize: Boolean,
    placeholder: String,
    prefix: String,
    rowHeight: {
      type: [Number, String],
      default: 24,
      validator: function validator(v) {
        return !isNaN(parseFloat(v));
      }
    },
    rows: {
      type: [Number, String],
      default: 5,
      validator: function validator(v) {
        return !isNaN(parseInt(v, 10));
      }
    },
    singleLine: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _extends({}, this.genSoloClasses(), {
        'input-group--text-field': true,
        'input-group--text-field-box': this.box,
        'input-group--single-line': this.singleLine || this.isSolo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--no-resize': this.noResizeHandle,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      });

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;

      return inputLength + ' / ' + this.counterLength;
    },
    counterLength: function counterLength() {
      var parsedLength = parseInt(this.counter, 10);
      return isNaN(parsedLength) ? 25 : parsedLength;
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        if (this.mask) {
          this.lazyValue = this.unmaskText(this.maskText(this.unmaskText(val)));
          this.setSelectionRange();
        } else {
          this.lazyValue = val;
          this.$emit('input', this.lazyValue);
        }
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue != null && this.lazyValue.toString().length > 0 || this.badInput || ['time', 'date', 'datetime-local', 'week', 'month'].includes(this.type);
    },
    isTextarea: function isTextarea() {
      return this.multiLine || this.textarea;
    },
    noResizeHandle: function noResizeHandle() {
      return this.isTextarea && (this.noResize || this.shouldAutoGrow);
    },
    shouldAutoGrow: function shouldAutoGrow() {
      return this.isTextarea && this.autoGrow;
    }
  },

  watch: {
    isFocused: function isFocused(val) {
      if (val) {
        this.initialValue = this.lazyValue;
      } else if (this.initialValue !== this.lazyValue) {
        this.$emit('change', this.lazyValue);
      }
    },
    value: function value(val) {
      var _this = this;

      if (this.mask && !this.internalChange) {
        var masked = this.maskText(this.unmaskText(val));
        this.lazyValue = this.unmaskText(masked);

        // Emit when the externally set value was modified internally
        String(val) !== this.lazyValue && this.$nextTick(function () {
          _this.$refs.input.value = masked;
          _this.$emit('input', _this.lazyValue);
        });
      } else this.lazyValue = val;

      if (this.internalChange) this.internalChange = false;

      !this.validateOnBlur && this.validate();
      this.shouldAutoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    this.shouldAutoGrow && this.calculateInputHeight();
    this.autofocus && this.focus();
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input ? _this2.$refs.input.scrollHeight : 0;
        var minHeight = parseInt(_this2.rows, 10) * parseFloat(_this2.rowHeight);
        _this2.inputHeight = Math.max(minHeight, height);
      });
    },
    onInput: function onInput(e) {
      this.mask && this.resetSelections(e.target);
      this.inputValue = e.target.value;
      this.badInput = e.target.validity && e.target.validity.badInput;
      this.shouldAutoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.isFocused = false;
      // Reset internalChange state
      // to allow external change
      // to persist
      this.internalChange = false;

      this.$nextTick(function () {
        _this3.validate();
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      if (!this.$refs.input) return;

      this.isFocused = true;
      if (document.activeElement !== this.$refs.input) {
        this.$refs.input.focus();
      }
      this.$emit('focus', e);
    },
    keyDown: function keyDown(e) {
      // Prevents closing of a
      // dialog when pressing
      // enter
      if (this.isTextarea && this.isFocused && e.keyCode === 13) {
        e.stopPropagation();
      }

      this.internalChange = true;
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': this.hasError
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.isTextarea ? 'textarea' : 'input';
      var listeners = Object.assign({}, this.$listeners);
      delete listeners['change']; // Change should not be bound externally

      var data = {
        style: {},
        domProps: {
          value: this.maskText(this.lazyValue)
        },
        attrs: _extends({}, this.$attrs, {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          readonly: this.readonly,
          tabindex: this.tabindex,
          'aria-label': (!this.$attrs || !this.$attrs.id) && this.label // Label `for` will be set if we have an id
        }),
        on: Object.assign(listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus,
          keydown: this.keyDown
        }),
        ref: 'input'
      };

      if (this.shouldAutoGrow) {
        data.style.height = this.inputHeight && this.inputHeight + 'px';
      }

      if (this.placeholder) data.attrs.placeholder = this.placeholder;

      if (!this.isTextarea) {
        data.attrs.type = this.type;
      } else {
        data.attrs.rows = this.rows;
      }

      if (this.mask) {
        data.attrs.maxlength = this.masked.length;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },
    clearableCallback: function clearableCallback() {
      var _this4 = this;

      this.inputValue = null;
      this.$nextTick(function () {
        return _this4.$refs.input.focus();
      });
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTimePicker__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__ = __webpack_require__(67);
/* unused harmony reexport VTimePicker */
/* unused harmony reexport VTimePickerClock */
/* unused harmony reexport VTimePickerTitle */






/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */]);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTimePickerTitle__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_picker__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__ = __webpack_require__(23);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components



// Mixins


// Utils



var rangeHours24 = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24);
var rangeHours12am = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(12);
var rangeHours12pm = rangeHours12am.map(function (v) {
  return v + 12;
});
var rangeMinutes = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  components: {
    VTimePickerTitle: __WEBPACK_IMPORTED_MODULE_0__VTimePickerTitle__["a" /* default */],
    VTimePickerClock: __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      inputHour: null,
      inputMinute: null,
      period: 'am',
      selectingHour: true
    };
  },


  props: {
    allowedHours: Function,
    allowedMinutes: Function,
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    min: String,
    max: String,
    scrollable: Boolean,
    value: null
  },

  computed: {
    isAllowedHourCb: function isAllowedHourCb() {
      var _this = this;

      if (!this.min && !this.max) return this.allowedHours;

      var minHour = this.min ? this.min.split(':')[0] : 0;
      var maxHour = this.max ? this.max.split(':')[0] : 23;

      return function (val) {
        return val >= minHour * 1 && val <= maxHour * 1 && (!_this.allowedHours || _this.allowedHours(val));
      };
    },
    isAllowedMinuteCb: function isAllowedMinuteCb() {
      var _this2 = this;

      var isHourAllowed = !this.allowedHours || this.allowedHours(this.inputHour);
      if (!this.min && !this.max) {
        return isHourAllowed ? this.allowedMinutes : function () {
          return false;
        };
      }

      var _ref = this.min ? this.min.split(':') : [0, 0],
          _ref2 = _slicedToArray(_ref, 2),
          minHour = _ref2[0],
          minMinute = _ref2[1];

      var _ref3 = this.max ? this.max.split(':') : [23, 59],
          _ref4 = _slicedToArray(_ref3, 2),
          maxHour = _ref4[0],
          maxMinute = _ref4[1];

      var minTime = minHour * 60 + minMinute * 1;
      var maxTime = maxHour * 60 + maxMinute * 1;

      return function (val) {
        var time = 60 * _this2.inputHour + val;
        return time >= minTime && time <= maxTime && isHourAllowed && (!_this2.allowedMinutes || _this2.allowedMinutes(val));
      };
    },
    isAmPm: function isAmPm() {
      return this.format === 'ampm';
    }
  },

  watch: {
    value: 'setInputData'
  },

  methods: {
    emitValue: function emitValue() {
      if (this.inputHour != null && this.inputMinute != null) {
        this.$emit('input', Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(this.inputHour) + ':' + Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(this.inputMinute));
      }
    },
    setPeriod: function setPeriod(period) {
      this.period = period;
      if (this.inputHour != null) {
        var newHour = this.inputHour + (period === 'am' ? -12 : 12);
        this.inputHour = this.firstAllowed('hour', newHour);
        this.emitValue();
      }
    },
    setInputData: function setInputData(value) {
      if (value == null) {
        this.inputHour = null;
        this.inputMinute = null;
        return;
      }

      if (value instanceof Date) {
        this.inputHour = value.getHours();
        this.inputMinute = value.getMinutes();
      } else {
        var _ref5 = value.trim().toLowerCase().match(/^(\d+):(\d+)(:\d+)?([ap]m)?$/, '') || [],
            _ref6 = _slicedToArray(_ref5, 5),
            hour = _ref6[1],
            minute = _ref6[2],
            period = _ref6[4];

        this.inputHour = period ? this.convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
        this.inputMinute = parseInt(minute, 10);
      }

      this.period = this.inputHour < 12 ? 'am' : 'pm';
    },
    convert24to12: function convert24to12(hour) {
      return hour ? (hour - 1) % 12 + 1 : 12;
    },
    convert12to24: function convert12to24(hour, period) {
      return hour % 12 + (period === 'pm' ? 12 : 0);
    },
    onInput: function onInput(value) {
      if (this.selectingHour) {
        this.inputHour = this.isAmPm ? this.convert12to24(value, this.period) : value;
      } else {
        this.inputMinute = value;
      }
      this.emitValue();
    },
    onChange: function onChange() {
      if (!this.selectingHour) {
        this.$emit('change', this.value);
      }

      this.selectingHour = !this.selectingHour;
    },
    firstAllowed: function firstAllowed(type, value) {
      var allowedFn = type === 'hour' ? this.isAllowedHourCb : this.isAllowedMinuteCb;
      if (!allowedFn) return value;

      // TODO: clean up
      var range = type === 'minute' ? rangeMinutes : this.isAmPm ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
      var first = range.find(function (v) {
        return allowedFn((v + value) % range.length + range[0]);
      });
      return ((first || 0) + value) % range.length + range[0];
    },
    genClock: function genClock() {
      return this.$createElement('v-time-picker-clock', {
        props: {
          allowedValues: this.selectingHour ? this.isAllowedHourCb : this.isAllowedMinuteCb,
          color: this.color,
          dark: this.dark,
          double: this.selectingHour && !this.isAmPm,
          format: this.selectingHour ? this.isAmPm ? this.convert24to12 : function (val) {
            return val;
          } : function (val) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(val, 2);
          },
          max: this.selectingHour ? this.isAmPm && this.period === 'am' ? 11 : 23 : 59,
          min: this.selectingHour && this.isAmPm && this.period === 'pm' ? 12 : 0,
          scrollable: this.scrollable,
          size: this.width - (!this.fullWidth && this.landscape ? 80 : 20),
          step: this.selectingHour ? 1 : 5,
          value: this.selectingHour ? this.inputHour : this.inputMinute
        },
        on: {
          input: this.onInput,
          change: this.onChange
        },
        ref: 'clock'
      });
    },
    genPickerBody: function genPickerBody() {
      return this.$createElement('div', {
        staticClass: 'time-picker-clock__container',
        style: {
          width: this.width + 'px',
          height: this.width - (!this.fullWidth && this.landscape ? 60 : 0) + 'px'
        },
        key: this.selectingHour
      }, [this.genClock()]);
    },
    genPickerTitle: function genPickerTitle() {
      var _this3 = this;

      return this.$createElement('v-time-picker-title', {
        props: {
          ampm: this.isAmPm,
          hour: this.inputHour,
          minute: this.inputMinute,
          period: this.period,
          selectingHour: this.selectingHour
        },
        on: {
          'update:selectingHour': function updateSelectingHour(value) {
            return _this3.selectingHour = value;
          },
          'update:period': this.setPeriod
        },
        ref: 'title',
        slot: 'title'
      });
    }
  },

  mounted: function mounted() {
    this.setInputData(this.value);
  },
  render: function render(h) {
    return this.genPicker('picker--time');
  }
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VToolbarTitle */
/* unused harmony export VToolbarItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VToolbar__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__ = __webpack_require__(254);
/* unused harmony reexport VToolbar */
/* unused harmony reexport VToolbarSideIcon */





var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */]);
  Vue.component(VToolbarItems.name, VToolbarItems);
  Vue.component(VToolbarTitle.name, VToolbarTitle);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */]);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ssr_bootable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_scroll__ = __webpack_require__(69);
// Styles


// Mixins





// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('top', ['clippedLeft', 'clippedRight', 'computedHeight', 'invertedScroll', 'manualScroll']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  directives: { Scroll: __WEBPACK_IMPORTED_MODULE_5__directives_scroll__["a" /* default */] },

  data: function data() {
    return {
      activeTimeout: null,
      currentScroll: 0,
      heights: {
        mobileLandscape: 48,
        mobile: 56,
        desktop: 64,
        dense: 48
      },
      isActive: true,
      isExtended: false,
      isScrollingUp: false,
      previousScroll: null,
      previousScrollDirection: null,
      savedScroll: 0,
      target: null
    };
  },

  props: {
    card: Boolean,
    clippedLeft: Boolean,
    clippedRight: Boolean,
    dense: Boolean,
    extended: Boolean,
    extensionHeight: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    flat: Boolean,
    floating: Boolean,
    height: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    invertedScroll: Boolean,
    manualScroll: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshold: {
      type: Number,
      default: 300
    },
    tabs: Boolean
  },

  computed: {
    computedContentHeight: function computedContentHeight() {
      if (this.height) return parseInt(this.height);
      if (this.dense) return this.heights.dense;

      if (this.prominent || this.$vuetify.breakpoint.mdAndUp) return this.heights.desktop;

      if (this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height) return this.heights.mobileLandscape;

      return this.heights.mobile;
    },
    computedExtensionHeight: function computedExtensionHeight() {
      if (this.tabs) return 48;
      if (this.extensionHeight) return parseInt(this.extensionHeight);

      return this.computedContentHeight;
    },
    computedHeight: function computedHeight() {
      if (!this.isExtended) return this.computedContentHeight;

      return this.computedContentHeight + this.computedExtensionHeight;
    },
    computedMarginTop: function computedMarginTop() {
      if (!this.app) return 0;

      return this.$vuetify.application.bar;
    },
    classes: function classes() {
      return this.addBackgroundColorClassChecks({
        'toolbar': true,
        'elevation-0': this.flat || !this.isActive && !this.tabs,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--clipped': this.clippedLeft || this.clippedRight,
        'toolbar--dense': this.dense,
        'toolbar--extended': this.isExtended,
        'toolbar--fixed': !this.absolute && (this.app || this.fixed),
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'theme--dark': this.dark,
        'theme--light': this.light
      });
    },
    computedPaddingLeft: function computedPaddingLeft() {
      if (!this.app || this.clippedLeft) return 0;

      return this.$vuetify.application.left;
    },
    computedPaddingRight: function computedPaddingRight() {
      if (!this.app || this.clippedRight) return 0;

      return this.$vuetify.application.right;
    },
    computedTransform: function computedTransform() {
      return !this.isActive ? -this.computedHeight : 0;
    },
    currentThreshold: function currentThreshold() {
      return Math.abs(this.currentScroll - this.savedScroll);
    },
    styles: function styles() {
      return {
        marginTop: this.computedMarginTop + 'px',
        paddingRight: this.computedPaddingRight + 'px',
        paddingLeft: this.computedPaddingLeft + 'px',
        transform: 'translateY(' + this.computedTransform + 'px)'
      };
    }
  },

  watch: {
    currentThreshold: function currentThreshold(val) {
      if (this.invertedScroll) {
        return this.isActive = this.currentScroll > this.scrollThreshold;
      }

      if (val < this.scrollThreshold || !this.isBooted) return;

      this.isActive = this.isScrollingUp;
      this.savedScroll = this.currentScroll;
    },
    isActive: function isActive() {
      this.savedScroll = 0;
    },
    invertedScroll: function invertedScroll(val) {
      this.isActive = !val;
    },
    manualScroll: function manualScroll(val) {
      this.isActive = !val;
    },
    isScrollingUp: function isScrollingUp(val) {
      this.savedScroll = this.savedScroll || this.currentScroll;
    }
  },

  created: function created() {
    if (this.invertedScroll || this.manualScroll) this.isActive = false;
  },
  mounted: function mounted() {
    if (this.scrollTarget) {
      this.target = document.querySelector(this.scrollTarget);
    }
  },


  methods: {
    onScroll: function onScroll() {
      if (!this.scrollOffScreen || this.manualScroll || typeof window === 'undefined') return;

      var target = this.target || window;

      this.currentScroll = this.scrollTarget ? target.scrollTop : target.pageYOffset || document.documentElement.scrollTop;

      this.isScrollingUp = this.currentScroll < this.previousScroll;

      this.previousScroll = this.currentScroll;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return this.invertedScroll || this.manualScroll ? 0 : this.computedHeight;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;

    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    data.directives = [{
      arg: this.scrollTarget,
      name: 'scroll',
      value: this.onScroll
    }];

    children.push(h('div', {
      staticClass: 'toolbar__content',
      style: { height: this.computedContentHeight + 'px' },
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        staticClass: 'toolbar__extension',
        style: { height: this.computedExtensionHeight + 'px' }
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props,
        data = _ref.data;

    var classes = data.staticClass ? data.staticClass + ' toolbar__side-icon' : 'toolbar__side-icon';

    var d = Object.assign(data, {
      staticClass: classes,
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    });

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_VBtn__["a" /* default */], d, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTooltip__ = __webpack_require__(256);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */]);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_delayable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_detachable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_menuable__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Mixins







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tooltip',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_delayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_menuable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      calculatedMinWidth: 0,
      closeDependents: false
    };
  },

  props: {
    debounce: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    fixed: {
      type: Boolean,
      default: true
    },
    openDelay: {
      type: [Number, String],
      default: 200
    },
    tag: {
      type: String,
      default: 'span'
    },
    transition: String,
    zIndex: {
      default: null
    }
  },

  computed: {
    calculatedLeft: function calculatedLeft() {
      var _dimensions = this.dimensions,
          activator = _dimensions.activator,
          content = _dimensions.content;

      var unknown = !this.bottom && !this.left && !this.top && !this.right;
      var left = 0;

      if (this.top || this.bottom || unknown) {
        left = activator.left + activator.width / 2 - content.width / 2;
      } else if (this.left || this.right) {
        left = activator.left + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
      }

      return this.calcXOverflow(left) + 'px';
    },
    calculatedTop: function calculatedTop() {
      var _dimensions2 = this.dimensions,
          activator = _dimensions2.activator,
          content = _dimensions2.content;

      var top = 0;

      if (this.top || this.bottom) {
        top = activator.top - (this.top ? activator.height : -activator.height) - (this.top ? 0 : -10);
      } else if (this.left || this.right) {
        top = activator.top + activator.height / 2 - content.height / 2;
      }

      return this.calcYOverflow(top + this.pageYOffset) + 'px';
    },
    classes: function classes() {
      return {
        'tooltip--top': this.top,
        'tooltip--right': this.right,
        'tooltip--bottom': this.bottom,
        'tooltip--left': this.left
      };
    },
    computedTransition: function computedTransition() {
      if (this.transition) return this.transition;
      if (this.top) return 'slide-y-reverse-transition';
      if (this.right) return 'slide-x-transition';
      if (this.bottom) return 'slide-y-transition';
      if (this.left) return 'slide-x-reverse-transition';
    },
    offsetY: function offsetY() {
      return this.top || this.bottom;
    },
    offsetX: function offsetX() {
      return this.left || this.right;
    },
    styles: function styles() {
      return {
        left: this.calculatedLeft,
        maxWidth: isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px',
        opacity: this.isActive ? 0.9 : 0,
        top: this.calculatedTop,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },

  methods: {
    activate: function activate() {
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions();
      // Start the transition
      requestAnimationFrame(this.startTransition);
    }
  },

  mounted: function mounted() {
    this.value && this.callActivate();
  },
  render: function render(h) {
    var _addBackgroundColorCl,
        _this = this;

    var tooltip = h('div', {
      staticClass: 'tooltip__content',
      'class': this.addBackgroundColorClassChecks((_addBackgroundColorCl = {}, _defineProperty(_addBackgroundColorCl, this.contentClass, true), _defineProperty(_addBackgroundColorCl, 'menuable__content__active', this.isActive), _addBackgroundColorCl)),
      style: this.styles,
      attrs: this.attrs,
      directives: [{
        name: 'show',
        value: this.isContentActive
      }],
      ref: 'content'
    }, this.$slots.default);

    return h(this.tag, {
      staticClass: 'tooltip',
      'class': this.classes
    }, [h('transition', {
      props: {
        name: this.computedTransition
      }
    }, [tooltip]), h('span', {
      on: this.disabled ? {} : {
        mouseenter: function mouseenter() {
          _this.runDelay('open', function () {
            return _this.isActive = true;
          });
        },
        mouseleave: function mouseleave() {
          _this.runDelay('close', function () {
            return _this.isActive = false;
          });
        }
      },
      ref: 'activator'
    }, this.$slots.activator)]);
  }
});

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ripple__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scroll__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_0__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_2__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_1__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_3__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });








function install(Vue) {
  Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0__click_outside__["a" /* default */]);
  Vue.directive('ripple', __WEBPACK_IMPORTED_MODULE_2__ripple__["a" /* default */]);
  Vue.directive('resize', __WEBPACK_IMPORTED_MODULE_1__resize__["a" /* default */]);
  Vue.directive('scroll', __WEBPACK_IMPORTED_MODULE_3__scroll__["a" /* default */]);
  Vue.directive('touch', __WEBPACK_IMPORTED_MODULE_4__touch__["a" /* default */]);
}

/***/ })
/******/ ])["default"];
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports) {

exports.sync = function (store, router, options) {
  var moduleName = (options || {}).moduleName || 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute),
    mutations: {
      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
        store.state[moduleName] = cloneRoute(transition.to, transition.from)
      }
    }
  })

  var isTimeTraveling = false
  var currentPath

  // sync router on store change
  var storeUnwatch = store.watch(
    function (state) { return state[moduleName]; },
    function (route) {
      var fullPath = route.fullPath;
      if (fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = fullPath
    },
    { sync: true }
  )

  // sync store on router navigation
  var afterEachUnHook = router.afterEach(function (to, from) {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
  })

  return function unsync () {
    // On unsync, remove router hook
    if (afterEachUnHook != null) {
      afterEachUnHook()
    }

    // On unsync, remove store watch
    if (storeUnwatch != null) {
      storeUnwatch()
    }

    // On unsync, unregister Module with store
    store.unregisterModule(moduleName)
  }
}

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}



/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var AuthenticationDetails = function () {
  /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */
  function AuthenticationDetails(data) {
    _classCallCheck(this, AuthenticationDetails);

    var _ref = data || {},
        ValidationData = _ref.ValidationData,
        Username = _ref.Username,
        Password = _ref.Password,
        AuthParameters = _ref.AuthParameters;

    this.validationData = ValidationData || [];
    this.authParameters = AuthParameters || [];
    this.username = Username;
    this.password = Password;
  }

  /**
   * @returns {string} the record's username
   */


  AuthenticationDetails.prototype.getUsername = function getUsername() {
    return this.username;
  };

  /**
   * @returns {string} the record's password
   */


  AuthenticationDetails.prototype.getPassword = function getPassword() {
    return this.password;
  };

  /**
   * @returns {Array} the record's validationData
   */


  AuthenticationDetails.prototype.getValidationData = function getValidationData() {
    return this.validationData;
  };

  /**
   * @returns {Array} the record's authParameters
   */


  AuthenticationDetails.prototype.getAuthParameters = function getAuthParameters() {
    return this.authParameters;
  };

  return AuthenticationDetails;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthenticationDetails);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_clients_cognitoidentityserviceprovider__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_clients_cognitoidentityserviceprovider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_clients_cognitoidentityserviceprovider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoUser__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StorageHelper__ = __webpack_require__(340);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */






/** @class */

var CognitoUserPool = function () {
  /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */
  function CognitoUserPool(data) {
    _classCallCheck(this, CognitoUserPool);

    var _ref = data || {},
        UserPoolId = _ref.UserPoolId,
        ClientId = _ref.ClientId,
        endpoint = _ref.endpoint,
        AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;

    if (!UserPoolId || !ClientId) {
      throw new Error('Both UserPoolId and ClientId are required.');
    }
    if (!/^[\w-]+_.+$/.test(UserPoolId)) {
      throw new Error('Invalid UserPoolId format.');
    }
    var region = UserPoolId.split('_')[0];

    this.userPoolId = UserPoolId;
    this.clientId = ClientId;

    this.client = new __WEBPACK_IMPORTED_MODULE_0_aws_sdk_clients_cognitoidentityserviceprovider___default.a({
      apiVersion: '2016-04-19',
      region: region,
      endpoint: endpoint
    });

    /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */
    this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;

    this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_2__StorageHelper__["a" /* default */]().getStorage();
  }

  /**
   * @returns {string} the user pool id
   */


  CognitoUserPool.prototype.getUserPoolId = function getUserPoolId() {
    return this.userPoolId;
  };

  /**
   * @returns {string} the client id
   */


  CognitoUserPool.prototype.getClientId = function getClientId() {
    return this.clientId;
  };

  /**
   * @typedef {object} SignUpResult
   * @property {CognitoUser} user New user.
   * @property {bool} userConfirmed If the user is already confirmed.
   */
  /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @returns {void}
   */


  CognitoUserPool.prototype.signUp = function signUp(username, password, userAttributes, validationData, callback) {
    var _this = this;

    var jsonReq = {
      ClientId: this.clientId,
      Username: username,
      Password: password,
      UserAttributes: userAttributes,
      ValidationData: validationData
    };
    if (this.getUserContextData(username)) {
      jsonReq.UserContextData = this.getUserContextData(username);
    }
    this.client.makeUnauthenticatedRequest('signUp', jsonReq, function (err, data) {
      if (err) {
        return callback(err, null);
      }

      var cognitoUser = {
        Username: username,
        Pool: _this,
        Storage: _this.storage
      };

      var returnData = {
        user: new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser),
        userConfirmed: data.UserConfirmed,
        userSub: data.UserSub
      };

      return callback(null, returnData);
    });
  };

  /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */


  CognitoUserPool.prototype.getCurrentUser = function getCurrentUser() {
    var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';

    var lastAuthUser = this.storage.getItem(lastUserKey);
    if (lastAuthUser) {
      var cognitoUser = {
        Username: lastAuthUser,
        Pool: this,
        Storage: this.storage
      };

      return new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser);
    }

    return null;
  };

  /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/


  CognitoUserPool.prototype.getUserContextData = function getUserContextData(username) {
    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
      return undefined;
    }
    /* eslint-disable */
    var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
    /* eslint-enable */

    if (this.advancedSecurityDataCollectionFlag) {
      var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
      if (advancedSecurityData) {
        var userContextData = {
          EncodedData: advancedSecurityData
        };
        return userContextData;
      }
    }
    return {};
  };

  return CognitoUserPool;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserPool);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** @class */

var CookieStorage = function () {

  /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   */
  function CookieStorage(data) {
    _classCallCheck(this, CookieStorage);

    this.domain = data.domain;
    if (data.path) {
      this.path = data.path;
    } else {
      this.path = '/';
    }
    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
      this.expires = data.expires;
    } else {
      this.expires = 365;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */


  CookieStorage.prototype.setItem = function setItem(key, value) {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"](key, value, {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    });
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  CookieStorage.prototype.getItem = function getItem(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  CookieStorage.prototype.removeItem = function removeItem(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](key, {
      path: this.path,
      domain: this.domain,
      secure: this.secure
    });
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  CookieStorage.prototype.clear = function clear() {
    var cookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]();
    var index = void 0;
    for (index = 0; index < cookies.length; ++index) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](cookies[index]);
    }
    return {};
  };

  return CookieStorage;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (CookieStorage);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthenticationHelper__ = __webpack_require__(330);
/* unused harmony reexport AuthenticationHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoAccessToken__ = __webpack_require__(332);
/* unused harmony reexport CognitoAccessToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoIdToken__ = __webpack_require__(333);
/* unused harmony reexport CognitoIdToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CognitoUser__ = __webpack_require__(336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__CognitoUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__ = __webpack_require__(337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__ = __webpack_require__(717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoUserSession__ = __webpack_require__(338);
/* unused harmony reexport CognitoUserSession */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CookieStorage__ = __webpack_require__(718);
/* unused harmony reexport CookieStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateHelper__ = __webpack_require__(339);
/* unused harmony reexport DateHelper */
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */













// The version of crypto-browserify included by aws-sdk only
// checks for window.crypto, not window.msCrypto as used by
// IE 11 – so we set it explicitly here
if (typeof window !== 'undefined' && !window.crypto && window.msCrypto) {
  window.crypto = window.msCrypto;
}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"Schema":{"shape":"S5h"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4f"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4j"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7p"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7p"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3p":{"type":"string","sensitive":true},"S3r":{"type":"structure","members":{"EncodedData":{}}},"S40":{"type":"map","key":{},"value":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S46":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4a":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4f":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"S4j":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4r":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S4u":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4z":{"type":"list","member":{}},"S54":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S59":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S5c":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5d":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5h":{"type":"list","member":{"shape":"S4"}},"S5i":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5l":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5h"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"S5s":{"type":"list","member":{}},"S5u":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S5x":{"type":"list","member":{}},"S5z":{"type":"list","member":{}},"S60":{"type":"list","member":{}},"S62":{"type":"list","member":{}},"S64":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S67":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"S6r":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"},"LastModifiedDate":{"type":"timestamp"}}},"S6s":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S6x":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S6z"},"NoActionEmail":{"shape":"S6z"},"MfaEmail":{"shape":"S6z"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S73"},"MediumAction":{"shape":"S73"},"HighAction":{"shape":"S73"}}}}},"S6z":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S73":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S76":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7p":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S81":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8b":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5c"}}},"S8c":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9c":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing"},"costexplorer":{"prefix":"ce","name":"CostExplorer"},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData"},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend"},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia"},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia"},"kinesisvideo":{"name":"KinesisVideo"},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate"},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups"},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"}}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
var AWS = __webpack_require__(10);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentity'] = {};
AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
__webpack_require__(745);
Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(720);
    model.paginators = __webpack_require__(721).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentity;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
var AWS = __webpack_require__(10);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentityserviceprovider'] = {};
AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
  get: function get() {
    var model = __webpack_require__(722);
    model.paginators = __webpack_require__(723).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentityServiceProvider;


/***/ }),
/* 729 */
/***/ (function(module, exports) {

function apiLoader(svc, version) {
  if (!apiLoader.services.hasOwnProperty(svc)) {
    throw new Error('InvalidService: Failed to load api for ' + svc);
  }
  return apiLoader.services[svc][version];
}

/**
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */
apiLoader.services = {};
module.exports = apiLoader;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
__webpack_require__(341);
__webpack_require__(342);
var PromisesDependency;

/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Defaults to the global
 *       agent (`http.globalAgent`) for non-SSL connections. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
 *       milliseconds of inactivity on the socket. Defaults to two minutes
 *       (120000)
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 */
AWS.Config = AWS.util.inherit({
  /**
   * @!endgroup
   */

  /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   */
  constructor: function Config(options) {
    if (options === undefined) options = {};
    options = this.extractCredentials(options);

    AWS.util.each.call(this, this.keys, function (key, value) {
      this.set(key, options[key], value);
    });
  },

  /**
   * @!group Managing Credentials
   */

  /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */
  getCredentials: function getCredentials(callback) {
    var self = this;

    function finish(err) {
      callback(err, err ? null : self.credentials);
    }

    function credError(msg, err) {
      return new AWS.util.error(err || new Error(), {
        code: 'CredentialsError',
        message: msg,
        name: 'CredentialsError'
      });
    }

    function getAsyncCredentials() {
      self.credentials.get(function(err) {
        if (err) {
          var msg = 'Could not load credentials from ' +
            self.credentials.constructor.name;
          err = credError(msg, err);
        }
        finish(err);
      });
    }

    function getStaticCredentials() {
      var err = null;
      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
        err = credError('Missing credentials');
      }
      finish(err);
    }

    if (self.credentials) {
      if (typeof self.credentials.get === 'function') {
        getAsyncCredentials();
      } else { // static credentials
        getStaticCredentials();
      }
    } else if (self.credentialProvider) {
      self.credentialProvider.resolve(function(err, creds) {
        if (err) {
          err = credError('Could not load credentials from any providers', err);
        }
        self.credentials = creds;
        finish(err);
      });
    } else {
      finish(credError('No credentials to load'));
    }
  },

  /**
   * @!group Loading and Setting Configuration Options
   */

  /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */
  update: function update(options, allowUnknownKeys) {
    allowUnknownKeys = allowUnknownKeys || false;
    options = this.extractCredentials(options);
    AWS.util.each.call(this, options, function (key, value) {
      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
          AWS.Service.hasService(key)) {
        this.set(key, value);
      }
    });
  },

  /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */
  loadFromPath: function loadFromPath(path) {
    this.clear();

    var options = JSON.parse(AWS.util.readFileSync(path));
    var fileSystemCreds = new AWS.FileSystemCredentials(path);
    var chain = new AWS.CredentialProviderChain();
    chain.providers.unshift(fileSystemCreds);
    chain.resolve(function (err, creds) {
      if (err) throw err;
      else options.credentials = creds;
    });

    this.constructor(options);

    return this;
  },

  /**
   * Clears configuration data on this object
   *
   * @api private
   */
  clear: function clear() {
    /*jshint forin:false */
    AWS.util.each.call(this, this.keys, function (key) {
      delete this[key];
    });

    // reset credential provider
    this.set('credentials', undefined);
    this.set('credentialProvider', undefined);
  },

  /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */
  set: function set(property, value, defaultValue) {
    if (value === undefined) {
      if (defaultValue === undefined) {
        defaultValue = this.keys[property];
      }
      if (typeof defaultValue === 'function') {
        this[property] = defaultValue.call(this);
      } else {
        this[property] = defaultValue;
      }
    } else if (property === 'httpOptions' && this[property]) {
      // deep merge httpOptions
      this[property] = AWS.util.merge(this[property], value);
    } else {
      this[property] = value;
    }
  },

  /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */
  keys: {
    credentials: null,
    credentialProvider: null,
    region: null,
    logger: null,
    apiVersions: {},
    apiVersion: null,
    endpoint: undefined,
    httpOptions: {
      timeout: 120000
    },
    maxRetries: undefined,
    maxRedirects: 10,
    paramValidation: true,
    sslEnabled: true,
    s3ForcePathStyle: false,
    s3BucketEndpoint: false,
    s3DisableBodySigning: true,
    computeChecksums: true,
    convertResponseTypes: true,
    correctClockSkew: false,
    customUserAgent: null,
    dynamoDbCrc32: true,
    systemClockOffset: 0,
    signatureVersion: null,
    signatureCache: true,
    retryDelayOptions: {},
    useAccelerateEndpoint: false
  },

  /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */
  extractCredentials: function extractCredentials(options) {
    if (options.accessKeyId && options.secretAccessKey) {
      options = AWS.util.copy(options);
      options.credentials = new AWS.Credentials(options);
    }
    return options;
  },

  /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */
  setPromisesDependency: function setPromisesDependency(dep) {
    PromisesDependency = dep;
    // if null was passed in, we should try to use native promises
    if (dep === null && typeof Promise === 'function') {
      PromisesDependency = Promise;
    }
    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
    AWS.util.addPromises(constructors, PromisesDependency);
  },

  /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */
  getPromisesDependency: function getPromisesDependency() {
    return PromisesDependency;
  }
});

/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */
AWS.config = new AWS.Config();


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var CognitoIdentity = __webpack_require__(727);
var STS = __webpack_require__(154);

/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */
AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * @api private
   */
  localStorageKey: {
    id: 'aws.cognito.identity-id.',
    providers: 'aws.cognito.identity-providers.'
  },

  /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */
  constructor: function CognitoIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.data = null;
    this._identityId = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
    this.loadCachedId();
    var self = this;
    Object.defineProperty(this, 'identityId', {
      get: function() {
        self.loadCachedId();
        return self._identityId || self.params.IdentityId;
      },
      set: function(identityId) {
        self._identityId = identityId;
      }
    });
  },

  /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    self.data = null;
    self._identityId = null;
    self.getId(function(err) {
      if (!err) {
        if (!self.params.RoleArn) {
          self.getCredentialsForIdentity(callback);
        } else {
          self.getCredentialsFromSTS(callback);
        }
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */
  clearCachedId: function clearCache() {
    this._identityId = null;
    delete this.params.IdentityId;

    var poolId = this.params.IdentityPoolId;
    var loginId = this.params.LoginId || '';
    delete this.storage[this.localStorageKey.id + poolId + loginId];
    delete this.storage[this.localStorageKey.providers + poolId + loginId];
  },

  /**
   * @api private
   */
  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
    var self = this;
    if (err.code == 'NotAuthorizedException') {
      self.clearCachedId();
    }
  },

  /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */
  getId: function getId(callback) {
    var self = this;
    if (typeof self.params.IdentityId === 'string') {
      return callback(null, self.params.IdentityId);
    }

    self.cognito.getId(function(err, data) {
      if (!err && data.IdentityId) {
        self.params.IdentityId = data.IdentityId;
        callback(null, data.IdentityId);
      } else {
        callback(err);
      }
    });
  },


  /**
   * @api private
   */
  loadCredentials: function loadCredentials(data, credentials) {
    if (!data || !credentials) return;
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
  },

  /**
   * @api private
   */
  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
    var self = this;
    self.cognito.getCredentialsForIdentity(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.data = data;
        self.loadCredentials(self.data, self);
      } else {
        self.clearIdOnNotAuthorized(err);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
    var self = this;
    self.cognito.getOpenIdToken(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.params.WebIdentityToken = data.Token;
        self.webIdentityCredentials.refresh(function(webErr) {
          if (!webErr) {
            self.data = self.webIdentityCredentials.data;
            self.sts.credentialsFrom(self.data, self);
          }
          callback(webErr);
        });
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * @api private
   */
  loadCachedId: function loadCachedId() {
    var self = this;

    // in the browser we source default IdentityId from localStorage
    if (AWS.util.isBrowser() && !self.params.IdentityId) {
      var id = self.getStorage('id');
      if (id && self.params.Logins) {
        var actualProviders = Object.keys(self.params.Logins);
        var cachedProviders =
          (self.getStorage('providers') || '').split(',');

        // only load ID if at least one provider used this ID before
        var intersect = cachedProviders.filter(function(n) {
          return actualProviders.indexOf(n) !== -1;
        });
        if (intersect.length !== 0) {
          self.params.IdentityId = id;
        }
      } else if (id) {
        self.params.IdentityId = id;
      }
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    var clientConfig = this._clientConfig;
    this.webIdentityCredentials = this.webIdentityCredentials ||
      new AWS.WebIdentityCredentials(this.params, clientConfig);
    if (!this.cognito) {
      var cognitoConfig = AWS.util.merge({}, clientConfig);
      cognitoConfig.params = this.params;
      this.cognito = new CognitoIdentity(cognitoConfig);
    }
    this.sts = this.sts || new STS(clientConfig);
  },

  /**
   * @api private
   */
  cacheId: function cacheId(data) {
    this._identityId = data.IdentityId;
    this.params.IdentityId = this._identityId;

    // cache this IdentityId in browser localStorage if possible
    if (AWS.util.isBrowser()) {
      this.setStorage('id', data.IdentityId);

      if (this.params.Logins) {
        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
      }
    }
  },

  /**
   * @api private
   */
  getStorage: function getStorage(key) {
    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
  },

  /**
   * @api private
   */
  setStorage: function setStorage(key, val) {
    try {
      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
    } catch (_) {}
  },

  /**
   * @api private
   */
  storage: (function() {
    try {
      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
          window.localStorage : {};

      // Test set/remove which would throw an error in Safari's private browsing
      storage['aws.test-storage'] = 'foobar';
      delete storage['aws.test-storage'];

      return storage;
    } catch (_) {
      return {};
    }
  })()
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var STS = __webpack_require__(154);

/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */
AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */
  constructor: function SAMLCredentials(params) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithSAML(function (err, data) {
      if (!err) {
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var STS = __webpack_require__(154);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function TemporaryCredentials(params, masterCredentials) {
    AWS.Credentials.call(this);
    this.loadMasterCredentials(masterCredentials);
    this.expired = true;

    this.params = params || {};
    if (this.params.RoleArn) {
      this.params.RoleSessionName =
        this.params.RoleSessionName || 'temporary-credentials';
    }
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.masterCredentials.get(function() {
      self.service.config.credentials = self.masterCredentials;
      var operation = self.params.RoleArn ?
        self.service.assumeRole : self.service.getSessionToken;
      operation.call(self.service, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
    this.masterCredentials = masterCredentials || AWS.config.credentials;
    while (this.masterCredentials.masterCredentials) {
      this.masterCredentials = this.masterCredentials.masterCredentials;
    }

    if (typeof this.masterCredentials.get !== 'function') {
      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var STS = __webpack_require__(154);

/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */
AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */
  constructor: function WebIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
    this.data = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithWebIdentity(function (err, data) {
      self.data = null;
      if (!err) {
        self.data = data;
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    if (!this.service) {
      var stsConfig = AWS.util.merge({}, this._clientConfig);
      stsConfig.params = this.params;
      this.service = new STS(stsConfig);
    }
  }

});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var SequentialExecutor = __webpack_require__(352);
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */
AWS.EventListeners = {
  /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */
  Core: {} /* doc hack */
};

/**
 * @api private
 */
function getOperationAuthtype(req) {
  if (!req.service.api.operations) {
    return '';
  }
  var operation = req.service.api.operations[req.operation];
  return operation ? operation.authtype : '';
}

AWS.EventListeners = {
  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
    addAsync('VALIDATE_CREDENTIALS', 'validate',
        function VALIDATE_CREDENTIALS(req, done) {
      if (!req.service.api.signatureVersion) return done(); // none
      req.service.config.getCredentials(function(err) {
        if (err) {
          req.response.error = AWS.util.error(err,
            {code: 'CredentialsError', message: 'Missing credentials in config'});
        }
        done();
      });
    });

    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
        req.response.error = AWS.util.error(new Error(),
          {code: 'ConfigError', message: 'Missing region in config'});
      }
    });

    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      if (!operation) {
        return;
      }
      var idempotentMembers = operation.idempotentMembers;
      if (!idempotentMembers.length) {
        return;
      }
      // creates a copy of params so user's param object isn't mutated
      var params = AWS.util.copy(req.params);
      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
        if (!params[idempotentMembers[i]]) {
          // add the member
          params[idempotentMembers[i]] = AWS.util.uuid.v4();
        }
      }
      req.params = params;
    });

    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var rules = req.service.api.operations[req.operation].input;
      var validation = req.service.config.paramValidation;
      new AWS.ParamValidator(validation).validate(rules, req.params);
    });

    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
      req.haltHandlersOnError();
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!req.service.api.signatureVersion && !authtype) return done(); // none
      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
        var body = req.httpRequest.body || '';
        if (authtype.indexOf('unsigned-body') >= 0) {
          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
          return done();
        }
        AWS.util.computeSha256(body, function(err, sha) {
          if (err) {
            done(err);
          }
          else {
            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
            done();
          }
        });
      } else {
        done();
      }
    });

    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
      var authtype = getOperationAuthtype(req);
      if (req.httpRequest.headers['Content-Length'] === undefined
          && authtype.indexOf('unsigned-body') === -1) {
        var length = AWS.util.string.byteLength(req.httpRequest.body);
        req.httpRequest.headers['Content-Length'] = length;
      }
    });

    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
    });

    add('RESTART', 'restart', function RESTART() {
      var err = this.response.error;
      if (!err || !err.retryable) return;

      this.httpRequest = new AWS.HttpRequest(
        this.service.endpoint,
        this.service.region
      );

      if (this.response.retryCount < this.service.config.maxRetries) {
        this.response.retryCount++;
      } else {
        this.response.error = null;
      }
    });

    addAsync('SIGN', 'sign', function SIGN(req, done) {
      var service = req.service;
      var operations = req.service.api.operations || {};
      var operation = operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!service.api.signatureVersion && !authtype) return done(); // none

      service.config.getCredentials(function (err, credentials) {
        if (err) {
          req.response.error = err;
          return done();
        }

        try {
          var date = service.getSkewCorrectedDate();
          var SignerClass = service.getSignerClass(req);
          var signer = new SignerClass(req.httpRequest,
            service.api.signingName || service.api.endpointPrefix,
            {
              signatureCache: service.config.signatureCache,
              operation: operation
            });
          signer.setServiceClientId(service._clientId);

          // clear old authorization headers
          delete req.httpRequest.headers['Authorization'];
          delete req.httpRequest.headers['Date'];
          delete req.httpRequest.headers['X-Amz-Date'];

          // add new authorization
          signer.addAuthorization(credentials, date);
          req.signedAt = date;
        } catch (e) {
          req.response.error = e;
        }
        done();
      });
    });

    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
      if (this.service.successfulResponse(resp, this)) {
        resp.data = {};
        resp.error = null;
      } else {
        resp.data = null;
        resp.error = AWS.util.error(new Error(),
          {code: 'UnknownError', message: 'An unknown error occurred.'});
      }
    });

    addAsync('SEND', 'send', function SEND(resp, done) {
      resp.httpResponse._abortCallback = done;
      resp.error = null;
      resp.data = null;

      function callback(httpResp) {
        resp.httpResponse.stream = httpResp;
        var stream = resp.request.httpRequest.stream;

        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
          resp.request.emit(
            'httpHeaders',
            [statusCode, headers, resp, statusMessage]
          );

          if (!resp.httpResponse.streaming) {
            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
              httpResp.on('readable', function onReadable() {
                var data = httpResp.read();
                if (data !== null) {
                  resp.request.emit('httpData', [data, resp]);
                }
              });
            } else { // legacy streams API
              httpResp.on('data', function onData(data) {
                resp.request.emit('httpData', [data, resp]);
              });
            }
          }
        });

        httpResp.on('end', function onEnd() {
          if (!stream || !stream.didCallback) {
            resp.request.emit('httpDone');
            done();
          }
        });
      }

      function progress(httpResp) {
        httpResp.on('sendProgress', function onSendProgress(value) {
          resp.request.emit('httpUploadProgress', [value, resp]);
        });

        httpResp.on('receiveProgress', function onReceiveProgress(value) {
          resp.request.emit('httpDownloadProgress', [value, resp]);
        });
      }

      function error(err) {
        if (err.code !== 'RequestAbortedError') {
          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
          err = AWS.util.error(err, {
            code: errCode,
            region: resp.request.httpRequest.region,
            hostname: resp.request.httpRequest.endpoint.hostname,
            retryable: true
          });
        }
        resp.error = err;
        resp.request.emit('httpError', [resp.error, resp], function() {
          done();
        });
      }

      function executeSend() {
        var http = AWS.HttpClient.getInstance();
        var httpOptions = resp.request.service.config.httpOptions || {};
        try {
          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
                                          callback, error);
          progress(stream);
        } catch (err) {
          error(err);
        }
      }
      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
        this.emit('sign', [this], function(err) {
          if (err) done(err);
          else executeSend();
        });
      } else {
        executeSend();
      }
    });

    add('HTTP_HEADERS', 'httpHeaders',
        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
      resp.httpResponse.statusCode = statusCode;
      resp.httpResponse.statusMessage = statusMessage;
      resp.httpResponse.headers = headers;
      resp.httpResponse.body = new AWS.util.Buffer('');
      resp.httpResponse.buffers = [];
      resp.httpResponse.numBytes = 0;
      var dateHeader = headers.date || headers.Date;
      var service = resp.request.service;
      if (dateHeader) {
        var serverTime = Date.parse(dateHeader);
        if (service.config.correctClockSkew
            && service.isClockSkewed(serverTime)) {
          service.applyClockOffset(serverTime);
        }
      }
    });

    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
      if (chunk) {
        if (AWS.util.isNode()) {
          resp.httpResponse.numBytes += chunk.length;

          var total = resp.httpResponse.headers['content-length'];
          var progress = { loaded: resp.httpResponse.numBytes, total: total };
          resp.request.emit('httpDownloadProgress', [progress, resp]);
        }

        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
      }
    });

    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
      // convert buffers array into single buffer
      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
        resp.httpResponse.body = body;
      }
      delete resp.httpResponse.numBytes;
      delete resp.httpResponse.buffers;
    });

    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
      if (resp.httpResponse.statusCode) {
        resp.error.statusCode = resp.httpResponse.statusCode;
        if (resp.error.retryable === undefined) {
          resp.error.retryable = this.service.retryableError(resp.error, this);
        }
      }
    });

    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
      if (!resp.error) return;
      switch (resp.error.code) {
        case 'RequestExpired': // EC2 only
        case 'ExpiredTokenException':
        case 'ExpiredToken':
          resp.error.retryable = true;
          resp.request.service.config.credentials.expired = true;
      }
    });

    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
      var err = resp.error;
      if (!err) return;
      if (typeof err.code === 'string' && typeof err.message === 'string') {
        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
          resp.error.retryable = true;
        }
      }
    });

    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
      if (!resp.error) return;
      if (this.service.clockSkewError(resp.error)
          && this.service.config.correctClockSkew) {
        resp.error.retryable = true;
      }
    });

    add('REDIRECT', 'retry', function REDIRECT(resp) {
      if (resp.error && resp.error.statusCode >= 300 &&
          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
        this.httpRequest.endpoint =
          new AWS.Endpoint(resp.httpResponse.headers['location']);
        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
        resp.error.redirect = true;
        resp.error.retryable = true;
      }
    });

    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
      if (resp.error) {
        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.error.retryDelay = 0;
        } else if (resp.retryCount < resp.maxRetries) {
          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
        }
      }
    });

    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
      var delay, willRetry = false;

      if (resp.error) {
        delay = resp.error.retryDelay || 0;
        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
          resp.retryCount++;
          willRetry = true;
        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.redirectCount++;
          willRetry = true;
        }
      }

      if (willRetry) {
        resp.error = null;
        setTimeout(done, delay);
      } else {
        done();
      }
    });
  }),

  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
        var message = 'Inaccessible host: `' + err.hostname +
          '\'. This service may not be available in the `' + err.region +
          '\' region.';
        this.response.error = AWS.util.error(new Error(message), {
          code: 'UnknownEndpoint',
          region: err.region,
          hostname: err.hostname,
          retryable: true,
          originalError: err
        });
      }
    });
  }),

  Logger: new SequentialExecutor().addNamedListeners(function(add) {
    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
      var req = resp.request;
      var logger = req.service.config.logger;
      if (!logger) return;
      function filterSensitiveLog(inputShape, shape) {
        if (!shape) {
          return shape;
        }
        switch (inputShape.type) {
          case 'structure':
            var struct = {};
            AWS.util.each(shape, function(subShapeName, subShape) {
              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
              } else {
                struct[subShapeName] = subShape;
              }
            })
            return struct
          case 'list':
            var list = [];
            AWS.util.arrayEach(shape, function(subShape, index) {
              list.push(filterSensitiveLog(inputShape.member, subShape));
            })
            return list;
          case 'map':
            var map = {};
            AWS.util.each(shape, function(key, value) {
              map[key] = filterSensitiveLog(inputShape.value, value);
            })
            return map;
          default:
            if (inputShape.isSensitive) {
              return '***SensitiveInformation***'
            } else {
              return shape;
            }
        }
      }

      function buildMessage() {
        var time = resp.request.service.getSkewCorrectedDate().getTime();
        var delta = (time - req.startTime.getTime()) / 1000;
        var ansi = logger.isTTY ? true : false;
        var status = resp.httpResponse.statusCode;
        var censoredParams = req.params;
        if (
          req.service.api.operations &&
              req.service.api.operations[req.operation] &&
              req.service.api.operations[req.operation].input
        ) {
          var inputShape = req.service.api.operations[req.operation].input;
          censoredParams = filterSensitiveLog(inputShape, req.params);
        }
        var params = __webpack_require__(666).inspect(censoredParams, true, null);
        var message = '';
        if (ansi) message += '\x1B[33m';
        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
        if (ansi) message += '\x1B[0;1m';
        message += ' ' + AWS.util.string.lowerFirst(req.operation);
        message += '(' + params + ')';
        if (ansi) message += '\x1B[0m';
        return message;
      }

      var line = buildMessage();
      if (typeof logger.log === 'function') {
        logger.log(line);
      } else if (typeof logger.write === 'function') {
        logger.write(line + '\n');
      }
    });
  }),

  Json: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(220);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Rest: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(156);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(350);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(351);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Query: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(349);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  })
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var EventEmitter = __webpack_require__(492).EventEmitter;
__webpack_require__(343);

/**
 * @api private
 */
AWS.XHRClient = AWS.util.inherit({
  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
    var self = this;
    var endpoint = httpRequest.endpoint;
    var emitter = new EventEmitter();
    var href = endpoint.protocol + '//' + endpoint.hostname;
    if (endpoint.port !== 80 && endpoint.port !== 443) {
      href += ':' + endpoint.port;
    }
    href += httpRequest.path;

    var xhr = new XMLHttpRequest(), headersEmitted = false;
    httpRequest.stream = xhr;

    xhr.addEventListener('readystatechange', function() {
      try {
        if (xhr.status === 0) return; // 0 code is invalid
      } catch (e) { return; }

      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
        emitter.statusCode = xhr.status;
        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
        emitter.emit(
          'headers',
          emitter.statusCode,
          emitter.headers,
          xhr.statusText
        );
        headersEmitted = true;
      }
      if (this.readyState === this.DONE) {
        self.finishRequest(xhr, emitter);
      }
    }, false);
    xhr.upload.addEventListener('progress', function (evt) {
      emitter.emit('sendProgress', evt);
    });
    xhr.addEventListener('progress', function (evt) {
      emitter.emit('receiveProgress', evt);
    }, false);
    xhr.addEventListener('timeout', function () {
      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
    }, false);
    xhr.addEventListener('error', function () {
      errCallback(AWS.util.error(new Error('Network Failure'), {
        code: 'NetworkingError'
      }));
    }, false);
    xhr.addEventListener('abort', function () {
      errCallback(AWS.util.error(new Error('Request aborted'), {
        code: 'RequestAbortedError'
      }));
    }, false);

    callback(emitter);
    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
    AWS.util.each(httpRequest.headers, function (key, value) {
      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
        xhr.setRequestHeader(key, value);
      }
    });

    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
      xhr.timeout = httpOptions.timeout;
    }

    if (httpOptions.xhrWithCredentials) {
      xhr.withCredentials = true;
    }
    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

    try {
      if (httpRequest.body) {
        xhr.send(httpRequest.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
      } else {
        throw err;
      }
    }

    return emitter;
  },

  parseHeaders: function parseHeaders(rawHeaders) {
    var headers = {};
    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
      var key = line.split(':', 1)[0];
      var value = line.substring(key.length + 2);
      if (key.length > 0) headers[key.toLowerCase()] = value;
    });
    return headers;
  },

  finishRequest: function finishRequest(xhr, emitter) {
    var buffer;
    if (xhr.responseType === 'arraybuffer' && xhr.response) {
      var ab = xhr.response;
      buffer = new AWS.util.Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
    }

    try {
      if (!buffer && typeof xhr.responseText === 'string') {
        buffer = new AWS.util.Buffer(xhr.responseText);
      }
    } catch (e) {}

    if (buffer) emitter.emit('data', buffer);
    emitter.emit('end');
  }
});

/**
 * @api private
 */
AWS.HttpClient.prototype = AWS.XHRClient.prototype;

/**
 * @api private
 */
AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

/**
 * @api private
 */
AWS.ParamValidator = AWS.util.inherit({
  /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */
  constructor: function ParamValidator(validation) {
    if (validation === true || validation === undefined) {
      validation = {'min': true};
    }
    this.validation = validation;
  },

  validate: function validate(shape, params, context) {
    this.errors = [];
    this.validateMember(shape, params || {}, context || 'params');

    if (this.errors.length > 1) {
      var msg = this.errors.join('\n* ');
      msg = 'There were ' + this.errors.length +
        ' validation errors:\n* ' + msg;
      throw AWS.util.error(new Error(msg),
        {code: 'MultipleValidationErrors', errors: this.errors});
    } else if (this.errors.length === 1) {
      throw this.errors[0];
    } else {
      return true;
    }
  },

  fail: function fail(code, message) {
    this.errors.push(AWS.util.error(new Error(message), {code: code}));
  },

  validateStructure: function validateStructure(shape, params, context) {
    this.validateType(params, context, ['object'], 'structure');

    var paramName;
    for (var i = 0; shape.required && i < shape.required.length; i++) {
      paramName = shape.required[i];
      var value = params[paramName];
      if (value === undefined || value === null) {
        this.fail('MissingRequiredParameter',
          'Missing required key \'' + paramName + '\' in ' + context);
      }
    }

    // validate hash members
    for (paramName in params) {
      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

      var paramValue = params[paramName],
          memberShape = shape.members[paramName];

      if (memberShape !== undefined) {
        var memberContext = [context, paramName].join('.');
        this.validateMember(memberShape, paramValue, memberContext);
      } else {
        this.fail('UnexpectedParameter',
          'Unexpected key \'' + paramName + '\' found in ' + context);
      }
    }

    return true;
  },

  validateMember: function validateMember(shape, param, context) {
    switch (shape.type) {
      case 'structure':
        return this.validateStructure(shape, param, context);
      case 'list':
        return this.validateList(shape, param, context);
      case 'map':
        return this.validateMap(shape, param, context);
      default:
        return this.validateScalar(shape, param, context);
    }
  },

  validateList: function validateList(shape, params, context) {
    if (this.validateType(params, context, [Array])) {
      this.validateRange(shape, params.length, context, 'list member count');
      // validate array members
      for (var i = 0; i < params.length; i++) {
        this.validateMember(shape.member, params[i], context + '[' + i + ']');
      }
    }
  },

  validateMap: function validateMap(shape, params, context) {
    if (this.validateType(params, context, ['object'], 'map')) {
      // Build up a count of map members to validate range traits.
      var mapCount = 0;
      for (var param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
        // Validate any map key trait constraints
        this.validateMember(shape.key, param,
                            context + '[key=\'' + param + '\']')
        this.validateMember(shape.value, params[param],
                            context + '[\'' + param + '\']');
        mapCount++;
      }
      this.validateRange(shape, mapCount, context, 'map member count');
    }
  },

  validateScalar: function validateScalar(shape, value, context) {
    switch (shape.type) {
      case null:
      case undefined:
      case 'string':
        return this.validateString(shape, value, context);
      case 'base64':
      case 'binary':
        return this.validatePayload(value, context);
      case 'integer':
      case 'float':
        return this.validateNumber(shape, value, context);
      case 'boolean':
        return this.validateType(value, context, ['boolean']);
      case 'timestamp':
        return this.validateType(value, context, [Date,
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
          'Date object, ISO-8601 string, or a UNIX timestamp');
      default:
        return this.fail('UnkownType', 'Unhandled type ' +
                         shape.type + ' for ' + context);
    }
  },

  validateString: function validateString(shape, value, context) {
    var validTypes = ['string'];
    if (shape.isJsonValue) {
      validTypes = validTypes.concat(['number', 'object', 'boolean']);
    }
    if (value !== null && this.validateType(value, context, validTypes)) {
      this.validateEnum(shape, value, context);
      this.validateRange(shape, value.length, context, 'string length');
      this.validatePattern(shape, value, context);
    }
  },

  validatePattern: function validatePattern(shape, value, context) {
    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
      if (!(new RegExp(shape['pattern'])).test(value)) {
        this.fail('PatternMatchError', 'Provided value "' + value + '" '
          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
          + context);
      }
    }
  },

  validateRange: function validateRange(shape, value, context, descriptor) {
    if (this.validation['min']) {
      if (shape['min'] !== undefined && value < shape['min']) {
        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
          + shape['min'] + ', but found ' + value + ' for ' + context);
      }
    }
    if (this.validation['max']) {
      if (shape['max'] !== undefined && value > shape['max']) {
        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
          + shape['max'] + ', but found ' + value + ' for ' + context);
      }
    }
  },

  validateEnum: function validateRange(shape, value, context) {
    if (this.validation['enum'] && shape['enum'] !== undefined) {
      // Fail if the string value is not present in the enum list
      if (shape['enum'].indexOf(value) === -1) {
        this.fail('EnumError', 'Found string value of ' + value + ', but '
          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
      }
    }
  },

  validateType: function validateType(value, context, acceptedTypes, type) {
    // We will not log an error for null or undefined, but we will return
    // false so that callers know that the expected type was not strictly met.
    if (value === null || value === undefined) return false;

    var foundInvalidType = false;
    for (var i = 0; i < acceptedTypes.length; i++) {
      if (typeof acceptedTypes[i] === 'string') {
        if (typeof value === acceptedTypes[i]) return true;
      } else if (acceptedTypes[i] instanceof RegExp) {
        if ((value || '').toString().match(acceptedTypes[i])) return true;
      } else {
        if (value instanceof acceptedTypes[i]) return true;
        if (AWS.util.isType(value, acceptedTypes[i])) return true;
        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
      }
      foundInvalidType = true;
    }

    var acceptedType = type;
    if (!acceptedType) {
      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
    }

    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
              vowel + ' ' + acceptedType);
    return false;
  },

  validateNumber: function validateNumber(shape, value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') {
      var castedValue = parseFloat(value);
      if (castedValue.toString() === value) value = castedValue;
    }
    if (this.validateType(value, context, ['number'])) {
      this.validateRange(shape, value, context, 'numeric value');
    }
  },

  validatePayload: function validatePayload(value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') return;
    if (value && typeof value.byteLength === 'number') return; // typed arrays
    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
      var Stream = AWS.util.stream.Stream;
      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
    }

    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
    if (value) {
      for (var i = 0; i < types.length; i++) {
        if (AWS.util.isType(value, types[i])) return;
        if (AWS.util.typeName(value.constructor) === types[i]) return;
      }
    }

    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
      'string, Buffer, Stream, Blob, or typed array object');
  }
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);

function QueryParamSerializer() {
}

QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
  serializeStructure('', params, shape, fn);
};

function ucfirst(shape) {
  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
    return shape.name;
  } else {
    return shape.name[0].toUpperCase() + shape.name.substr(1);
  }
}

function serializeStructure(prefix, struct, rules, fn) {
  util.each(rules.members, function(name, member) {
    var value = struct[name];
    if (value === null || value === undefined) return;

    var memberName = ucfirst(member);
    memberName = prefix ? prefix + '.' + memberName : memberName;
    serializeMember(memberName, value, member, fn);
  });
}

function serializeMap(name, map, rules, fn) {
  var i = 1;
  util.each(map, function (key, value) {
    var prefix = rules.flattened ? '.' : '.entry.';
    var position = prefix + (i++) + '.';
    var keyName = position + (rules.key.name || 'key');
    var valueName = position + (rules.value.name || 'value');
    serializeMember(name + keyName, key, rules.key, fn);
    serializeMember(name + valueName, value, rules.value, fn);
  });
}

function serializeList(name, list, rules, fn) {
  var memberRules = rules.member || {};

  if (list.length === 0) {
    fn.call(this, name, null);
    return;
  }

  util.arrayEach(list, function (v, n) {
    var suffix = '.' + (n + 1);
    if (rules.api.protocol === 'ec2') {
      // Do nothing for EC2
      suffix = suffix + ''; // make linter happy
    } else if (rules.flattened) {
      if (memberRules.name) {
        var parts = name.split('.');
        parts.pop();
        parts.push(ucfirst(memberRules));
        name = parts.join('.');
      }
    } else {
      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
    }
    serializeMember(name + suffix, v, memberRules, fn);
  });
}

function serializeMember(name, value, rules, fn) {
  if (value === null || value === undefined) return;
  if (rules.type === 'structure') {
    serializeStructure(name, value, rules, fn);
  } else if (rules.type === 'list') {
    serializeList(name, value, rules, fn);
  } else if (rules.type === 'map') {
    serializeMap(name, value, rules, fn);
  } else {
    fn(name, rules.toWireFormat(value).toString());
  }
}

module.exports = QueryParamSerializer;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var regionConfig = __webpack_require__(740);

function generateRegionPrefix(region) {
  if (!region) return null;

  var parts = region.split('-');
  if (parts.length < 3) return null;
  return parts.slice(0, parts.length - 2).join('-') + '-*';
}

function derivedKeys(service) {
  var region = service.config.region;
  var regionPrefix = generateRegionPrefix(region);
  var endpointPrefix = service.api.endpointPrefix;

  return [
    [region, endpointPrefix],
    [regionPrefix, endpointPrefix],
    [region, '*'],
    [regionPrefix, '*'],
    ['*', endpointPrefix],
    ['*', '*']
  ].map(function(item) {
    return item[0] && item[1] ? item.join('/') : null;
  });
}

function applyConfig(service, config) {
  util.each(config, function(key, value) {
    if (key === 'globalEndpoint') return;
    if (service.config[key] === undefined || service.config[key] === null) {
      service.config[key] = value;
    }
  });
}

function configureEndpoint(service) {
  var keys = derivedKeys(service);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;

    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
      var config = regionConfig.rules[key];
      if (typeof config === 'string') {
        config = regionConfig.patterns[config];
      }

      // set dualstack endpoint
      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
        config = util.copy(config);
        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
      }

      // set global endpoint
      service.isGlobalEndpoint = !!config.globalEndpoint;

      // signature version
      if (!config.signatureVersion) config.signatureVersion = 'v4';

      // merge config
      applyConfig(service, config);
      return;
    }
  }
}

module.exports = configureEndpoint;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(10);
var AcceptorStateMachine = __webpack_require__(754);
var inherit = AWS.util.inherit;
var domain = AWS.util.domain;
var jmespath = __webpack_require__(120);

/**
 * @api private
 */
var hardErrorStates = {success: 1, error: 1, complete: 1};

function isTerminalState(machine) {
  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
}

var fsm = new AcceptorStateMachine();
fsm.setupStates = function() {
  var transition = function(_, done) {
    var self = this;
    self._haltHandlersOnError = false;

    self.emit(self._asm.currentState, function(err) {
      if (err) {
        if (isTerminalState(self)) {
          if (domain && self.domain instanceof domain.Domain) {
            err.domainEmitter = self;
            err.domain = self.domain;
            err.domainThrown = false;
            self.domain.emit('error', err);
          } else {
            throw err;
          }
        } else {
          self.response.error = err;
          done(err);
        }
      } else {
        done(self.response.error);
      }
    });

  };

  this.addState('validate', 'build', 'error', transition);
  this.addState('build', 'afterBuild', 'restart', transition);
  this.addState('afterBuild', 'sign', 'restart', transition);
  this.addState('sign', 'send', 'retry', transition);
  this.addState('retry', 'afterRetry', 'afterRetry', transition);
  this.addState('afterRetry', 'sign', 'error', transition);
  this.addState('send', 'validateResponse', 'retry', transition);
  this.addState('validateResponse', 'extractData', 'extractError', transition);
  this.addState('extractError', 'extractData', 'retry', transition);
  this.addState('extractData', 'success', 'retry', transition);
  this.addState('restart', 'build', 'error', transition);
  this.addState('success', 'complete', 'complete', transition);
  this.addState('error', 'complete', 'complete', transition);
  this.addState('complete', null, null, transition);
};
fsm.setupStates();

/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */
AWS.Request = inherit({

  /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */
  constructor: function Request(service, operation, params) {
    var endpoint = service.endpoint;
    var region = service.config.region;
    var customUserAgent = service.config.customUserAgent;

    // global endpoints sign as us-east-1
    if (service.isGlobalEndpoint) region = 'us-east-1';

    this.domain = domain && domain.active;
    this.service = service;
    this.operation = operation;
    this.params = params || {};
    this.httpRequest = new AWS.HttpRequest(endpoint, region);
    this.httpRequest.appendToUserAgent(customUserAgent);
    this.startTime = service.getSkewCorrectedDate();

    this.response = new AWS.Response(this);
    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
    this._haltHandlersOnError = false;

    AWS.SequentialExecutor.call(this);
    this.emit = this.emitEvent;
  },

  /**
   * @!group Sending a Request
   */

  /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */
  send: function send(callback) {
    if (callback) {
      // append to user agent
      this.httpRequest.appendToUserAgent('callback');
      this.on('complete', function (resp) {
        callback.call(resp, resp.error, resp.data);
      });
    }
    this.runTo();

    return this.response;
  },

  /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */

  /**
   * @api private
   */
  build: function build(callback) {
    return this.runTo('send', callback);
  },

  /**
   * @api private
   */
  runTo: function runTo(state, done) {
    this._asm.runTo(state, done, this);
    return this;
  },

  /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */
  abort: function abort() {
    this.removeAllListeners('validateResponse');
    this.removeAllListeners('extractError');
    this.on('validateResponse', function addAbortedError(resp) {
      resp.error = AWS.util.error(new Error('Request aborted by user'), {
         code: 'RequestAbortedError', retryable: false
      });
    });

    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
      this.httpRequest.stream.abort();
      if (this.httpRequest._abortCallback) {
         this.httpRequest._abortCallback();
      } else {
        this.removeAllListeners('send'); // haven't sent yet, so let's not
      }
    }

    return this;
  },

  /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */
  eachPage: function eachPage(callback) {
    // Make all callbacks async-ish
    callback = AWS.util.fn.makeAsync(callback, 3);

    function wrappedCallback(response) {
      callback.call(response, response.error, response.data, function (result) {
        if (result === false) return;

        if (response.hasNextPage()) {
          response.nextPage().on('complete', wrappedCallback).send();
        } else {
          callback.call(response, null, null, AWS.util.fn.noop);
        }
      });
    }

    this.on('complete', wrappedCallback).send();
  },

  /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */
  eachItem: function eachItem(callback) {
    var self = this;
    function wrappedCallback(err, data) {
      if (err) return callback(err, null);
      if (data === null) return callback(null, null);

      var config = self.service.paginationConfig(self.operation);
      var resultKey = config.resultKey;
      if (Array.isArray(resultKey)) resultKey = resultKey[0];
      var items = jmespath.search(data, resultKey);
      var continueIteration = true;
      AWS.util.arrayEach(items, function(item) {
        continueIteration = callback(null, item);
        if (continueIteration === false) {
          return AWS.util.abort;
        }
      });
      return continueIteration;
    }

    this.eachPage(wrappedCallback);
  },

  /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */
  isPageable: function isPageable() {
    return this.service.paginationConfig(this.operation) ? true : false;
  },

  /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */
  createReadStream: function createReadStream() {
    var streams = AWS.util.stream;
    var req = this;
    var stream = null;

    if (AWS.HttpClient.streamsApiVersion === 2) {
      stream = new streams.PassThrough();
      process.nextTick(function() { req.send(); });
    } else {
      stream = new streams.Stream();
      stream.readable = true;

      stream.sent = false;
      stream.on('newListener', function(event) {
        if (!stream.sent && event === 'data') {
          stream.sent = true;
          process.nextTick(function() { req.send(); });
        }
      });
    }

    this.on('error', function(err) {
      stream.emit('error', err);
    });

    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
      if (statusCode < 300) {
        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
        req.on('httpError', function streamHttpError(error) {
          resp.error = error;
          resp.error.retryable = false;
        });

        var shouldCheckContentLength = false;
        var expectedLen;
        if (req.httpRequest.method !== 'HEAD') {
          expectedLen = parseInt(headers['content-length'], 10);
        }
        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
          shouldCheckContentLength = true;
          var receivedLen = 0;
        }

        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
          if (shouldCheckContentLength && receivedLen !== expectedLen) {
            stream.emit('error', AWS.util.error(
              new Error('Stream content length mismatch. Received ' +
                receivedLen + ' of ' + expectedLen + ' bytes.'),
              { code: 'StreamContentLengthMismatch' }
            ));
          } else if (AWS.HttpClient.streamsApiVersion === 2) {
            stream.end();
          } else {
            stream.emit('end');
          }
        };

        var httpStream = resp.httpResponse.createUnbufferedStream();

        if (AWS.HttpClient.streamsApiVersion === 2) {
          if (shouldCheckContentLength) {
            var lengthAccumulator = new streams.PassThrough();
            lengthAccumulator._write = function(chunk) {
              if (chunk && chunk.length) {
                receivedLen += chunk.length;
              }
              return streams.PassThrough.prototype._write.apply(this, arguments);
            };

            lengthAccumulator.on('end', checkContentLengthAndEmit);
            stream.on('error', function(err) {
              shouldCheckContentLength = false;
              httpStream.unpipe(lengthAccumulator);
              lengthAccumulator.emit('end');
              lengthAccumulator.end();
            });
            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
          } else {
            httpStream.pipe(stream);
          }
        } else {

          if (shouldCheckContentLength) {
            httpStream.on('data', function(arg) {
              if (arg && arg.length) {
                receivedLen += arg.length;
              }
            });
          }

          httpStream.on('data', function(arg) {
            stream.emit('data', arg);
          });
          httpStream.on('end', checkContentLengthAndEmit);
        }

        httpStream.on('error', function(err) {
          shouldCheckContentLength = false;
          stream.emit('error', err);
        });
      }
    });

    return stream;
  },

  /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */
  emitEvent: function emit(eventName, args, done) {
    if (typeof args === 'function') { done = args; args = null; }
    if (!done) done = function() { };
    if (!args) args = this.eventParameters(eventName, this.response);

    var origEmit = AWS.SequentialExecutor.prototype.emit;
    origEmit.call(this, eventName, args, function (err) {
      if (err) this.response.error = err;
      done.call(this, err);
    });
  },

  /**
   * @api private
   */
  eventParameters: function eventParameters(eventName) {
    switch (eventName) {
      case 'restart':
      case 'validate':
      case 'sign':
      case 'build':
      case 'afterValidate':
      case 'afterBuild':
        return [this];
      case 'error':
        return [this.response.error, this.response];
      default:
        return [this.response];
    }
  },

  /**
   * @api private
   */
  presign: function presign(expires, callback) {
    if (!callback && typeof expires === 'function') {
      callback = expires;
      expires = null;
    }
    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
  },

  /**
   * @api private
   */
  isPresigned: function isPresigned() {
    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
  },

  /**
   * @api private
   */
  toUnauthenticated: function toUnauthenticated() {
    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
    return this;
  },

  /**
   * @api private
   */
  toGet: function toGet() {
    if (this.service.api.protocol === 'query' ||
        this.service.api.protocol === 'ec2') {
      this.removeListener('build', this.buildAsGet);
      this.addListener('build', this.buildAsGet);
    }
    return this;
  },

  /**
   * @api private
   */
  buildAsGet: function buildAsGet(request) {
    request.httpRequest.method = 'GET';
    request.httpRequest.path = request.service.endpoint.path +
                               '?' + request.httpRequest.body;
    request.httpRequest.body = '';

    // don't need these headers on a GET request
    delete request.httpRequest.headers['Content-Length'];
    delete request.httpRequest.headers['Content-Type'];
  },

  /**
   * @api private
   */
  haltHandlersOnError: function haltHandlersOnError() {
    this._haltHandlersOnError = true;
  }
});

/**
 * @api private
 */
AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = function promise() {
    var self = this;
    // append to user agent
    this.httpRequest.appendToUserAgent('promise');
    return new PromiseDependency(function(resolve, reject) {
      self.on('complete', function(resp) {
        if (resp.error) {
          reject(resp.error);
        } else {
          // define $response property so that it is not enumberable
          // this prevents circular reference errors when stringifying the JSON object
          resolve(Object.defineProperty(
            resp.data || {},
            '$response',
            {value: resp}
          ));
        }
      });
      self.runTo();
    });
  };
};

/**
 * @api private
 */
AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.Request);

AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(120);

/**
 * @api private
 */
function CHECK_ACCEPTORS(resp) {
  var waiter = resp.request._waiter;
  var acceptors = waiter.config.acceptors;
  var acceptorMatched = false;
  var state = 'retry';

  acceptors.forEach(function(acceptor) {
    if (!acceptorMatched) {
      var matcher = waiter.matchers[acceptor.matcher];
      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
        acceptorMatched = true;
        state = acceptor.state;
      }
    }
  });

  if (!acceptorMatched && resp.error) state = 'failure';

  if (state === 'success') {
    waiter.setSuccess(resp);
  } else {
    waiter.setError(resp, state === 'retry');
  }
}

/**
 * @api private
 */
AWS.ResourceWaiter = inherit({
  /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */
  constructor: function constructor(service, state) {
    this.service = service;
    this.state = state;
    this.loadWaiterConfig(this.state);
  },

  service: null,

  state: null,

  config: null,

  matchers: {
    path: function(resp, expected, argument) {
      try {
        var result = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      return jmespath.strictDeepEqual(result,expected);
    },

    pathAll: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      if (!numResults) return false;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (!jmespath.strictDeepEqual(results[ind], expected)) {
          return false;
        }
      }
      return true;
    },

    pathAny: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (jmespath.strictDeepEqual(results[ind], expected)) {
          return true;
        }
      }
      return false;
    },

    status: function(resp, expected) {
      var statusCode = resp.httpResponse.statusCode;
      return (typeof statusCode === 'number') && (statusCode === expected);
    },

    error: function(resp, expected) {
      if (typeof expected === 'string' && resp.error) {
        return expected === resp.error.code;
      }
      // if expected is not string, can be boolean indicating presence of error
      return expected === !!resp.error;
    }
  },

  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
    add('RETRY_CHECK', 'retry', function(resp) {
      var waiter = resp.request._waiter;
      if (resp.error && resp.error.code === 'ResourceNotReady') {
        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
      }
    });

    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
  }),

  /**
   * @return [AWS.Request]
   */
  wait: function wait(params, callback) {
    if (typeof params === 'function') {
      callback = params; params = undefined;
    }

    if (params && params.$waiter) {
      params = AWS.util.copy(params);
      if (typeof params.$waiter.delay === 'number') {
        this.config.delay = params.$waiter.delay;
      }
      if (typeof params.$waiter.maxAttempts === 'number') {
        this.config.maxAttempts = params.$waiter.maxAttempts;
      }
      delete params.$waiter;
    }

    var request = this.service.makeRequest(this.config.operation, params);
    request._waiter = this;
    request.response.maxRetries = this.config.maxAttempts;
    request.addListeners(this.listeners);

    if (callback) request.send(callback);
    return request;
  },

  setSuccess: function setSuccess(resp) {
    resp.error = null;
    resp.data = resp.data || {};
    resp.request.removeAllListeners('extractData');
  },

  setError: function setError(resp, retryable) {
    resp.data = null;
    resp.error = AWS.util.error(resp.error || new Error(), {
      code: 'ResourceNotReady',
      message: 'Resource is not in the state ' + this.state,
      retryable: retryable
    });
  },

  /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */
  loadWaiterConfig: function loadWaiterConfig(state) {
    if (!this.service.api.waiters[state]) {
      throw new AWS.util.error(new Error(), {
        code: 'StateNotFoundError',
        message: 'State ' + state + ' not found.'
      });
    }

    this.config = AWS.util.copy(this.service.api.waiters[state]);
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(120);

/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */
AWS.Response = inherit({

  /**
   * @api private
   */
  constructor: function Response(request) {
    this.request = request;
    this.data = null;
    this.error = null;
    this.retryCount = 0;
    this.redirectCount = 0;
    this.httpResponse = new AWS.HttpResponse();
    if (request) {
      this.maxRetries = request.service.numRetries();
      this.maxRedirects = request.service.config.maxRedirects;
    }
  },

  /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */
  nextPage: function nextPage(callback) {
    var config;
    var service = this.request.service;
    var operation = this.request.operation;
    try {
      config = service.paginationConfig(operation, true);
    } catch (e) { this.error = e; }

    if (!this.hasNextPage()) {
      if (callback) callback(this.error, null);
      else if (this.error) throw this.error;
      return null;
    }

    var params = AWS.util.copy(this.request.params);
    if (!this.nextPageTokens) {
      return callback ? callback(null, null) : null;
    } else {
      var inputTokens = config.inputToken;
      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
      for (var i = 0; i < inputTokens.length; i++) {
        params[inputTokens[i]] = this.nextPageTokens[i];
      }
      return service.makeRequest(this.request.operation, params, callback);
    }
  },

  /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */
  hasNextPage: function hasNextPage() {
    this.cacheNextPageTokens();
    if (this.nextPageTokens) return true;
    if (this.nextPageTokens === undefined) return undefined;
    else return false;
  },

  /**
   * @api private
   */
  cacheNextPageTokens: function cacheNextPageTokens() {
    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
    this.nextPageTokens = undefined;

    var config = this.request.service.paginationConfig(this.request.operation);
    if (!config) return this.nextPageTokens;

    this.nextPageTokens = null;
    if (config.moreResults) {
      if (!jmespath.search(this.data, config.moreResults)) {
        return this.nextPageTokens;
      }
    }

    var exprs = config.outputToken;
    if (typeof exprs === 'string') exprs = [exprs];
    AWS.util.arrayEach.call(this, exprs, function (expr) {
      var output = jmespath.search(this.data, expr);
      if (output) {
        this.nextPageTokens = this.nextPageTokens || [];
        this.nextPageTokens.push(output);
      }
    });

    return this.nextPageTokens;
  }

});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var Api = __webpack_require__(344);
var regionConfig = __webpack_require__(739);
var inherit = AWS.util.inherit;
var clientCount = 0;

/**
 * The service class representing an AWS service.
 *
 * @abstract
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */
AWS.Service = inherit({
  /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */
  constructor: function Service(config) {
    if (!this.loadServiceClass) {
      throw AWS.util.error(new Error(),
        'Service must be constructed with `new\' operator');
    }
    var ServiceClass = this.loadServiceClass(config || {});
    if (ServiceClass) {
      var originalConfig = AWS.util.copy(config);
      var svc = new ServiceClass(config);
      Object.defineProperty(svc, '_originalConfig', {
        get: function() { return originalConfig; },
        enumerable: false,
        configurable: true
      });
      svc._clientId = ++clientCount;
      return svc;
    }
    this.initialize(config);
  },

  /**
   * @api private
   */
  initialize: function initialize(config) {
    var svcConfig = AWS.config[this.serviceIdentifier];

    this.config = new AWS.Config(AWS.config);
    if (svcConfig) this.config.update(svcConfig, true);
    if (config) this.config.update(config, true);

    this.validateService();
    if (!this.config.endpoint) regionConfig(this);

    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
    this.setEndpoint(this.config.endpoint);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
  },

  /**
   * @api private
   */
  loadServiceClass: function loadServiceClass(serviceConfig) {
    var config = serviceConfig;
    if (!AWS.util.isEmpty(this.api)) {
      return null;
    } else if (config.apiConfig) {
      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
    } else if (!this.constructor.services) {
      return null;
    } else {
      config = new AWS.Config(AWS.config);
      config.update(serviceConfig, true);
      var version = config.apiVersions[this.constructor.serviceIdentifier];
      version = version || config.apiVersion;
      return this.getLatestServiceClass(version);
    }
  },

  /**
   * @api private
   */
  getLatestServiceClass: function getLatestServiceClass(version) {
    version = this.getLatestServiceVersion(version);
    if (this.constructor.services[version] === null) {
      AWS.Service.defineServiceApi(this.constructor, version);
    }

    return this.constructor.services[version];
  },

  /**
   * @api private
   */
  getLatestServiceVersion: function getLatestServiceVersion(version) {
    if (!this.constructor.services || this.constructor.services.length === 0) {
      throw new Error('No services defined on ' +
                      this.constructor.serviceIdentifier);
    }

    if (!version) {
      version = 'latest';
    } else if (AWS.util.isType(version, Date)) {
      version = AWS.util.date.iso8601(version).split('T')[0];
    }

    if (Object.hasOwnProperty(this.constructor.services, version)) {
      return version;
    }

    var keys = Object.keys(this.constructor.services).sort();
    var selectedVersion = null;
    for (var i = keys.length - 1; i >= 0; i--) {
      // versions that end in "*" are not available on disk and can be
      // skipped, so do not choose these as selectedVersions
      if (keys[i][keys[i].length - 1] !== '*') {
        selectedVersion = keys[i];
      }
      if (keys[i].substr(0, 10) <= version) {
        return selectedVersion;
      }
    }

    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
                    ' API to satisfy version constraint `' + version + '\'');
  },

  /**
   * @api private
   */
  api: {},

  /**
   * @api private
   */
  defaultRetryCount: 3,

  /**
   * @api private
   */
  customizeRequests: function customizeRequests(callback) {
    if (!callback) {
      this.customRequestHandler = null;
    } else if (typeof callback === 'function') {
      this.customRequestHandler = callback;
    } else {
      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    }
  },

  /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeRequest: function makeRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = null;
    }

    params = params || {};
    if (this.config.params) { // copy only toplevel bound params
      var rules = this.api.operations[operation];
      if (rules) {
        params = AWS.util.copy(params);
        AWS.util.each(this.config.params, function(key, value) {
          if (rules.input.members[key]) {
            if (params[key] === undefined || params[key] === null) {
              params[key] = value;
            }
          }
        });
      }
    }

    var request = new AWS.Request(this, operation, params);
    this.addAllRequestListeners(request);

    if (callback) request.send(callback);
    return request;
  },

  /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = {};
    }

    var request = this.makeRequest(operation, params).toUnauthenticated();
    return callback ? request.send(callback) : request;
  },

  /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  waitFor: function waitFor(state, params, callback) {
    var waiter = new AWS.ResourceWaiter(this, state);
    return waiter.wait(params, callback);
  },

  /**
   * @api private
   */
  addAllRequestListeners: function addAllRequestListeners(request) {
    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
                AWS.EventListeners.CorePost];
    for (var i = 0; i < list.length; i++) {
      if (list[i]) request.addListeners(list[i]);
    }

    // disable parameter validation
    if (!this.config.paramValidation) {
      request.removeListener('validate',
        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    }

    if (this.config.logger) { // add logging events
      request.addListeners(AWS.EventListeners.Logger);
    }

    this.setupRequestListeners(request);
    // call prototype's customRequestHandler
    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
      this.constructor.prototype.customRequestHandler(request);
    }
    // call instance's customRequestHandler
    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
      this.customRequestHandler(request);
    }
  },

  /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @abstract
   */
  setupRequestListeners: function setupRequestListeners() {
  },

  /**
   * Gets the signer class for a given request
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var version;
    // get operation authtype if present
    var operation = null;
    var authtype = '';
    if (request) {
      var operations = request.service.api.operations || {};
      operation = operations[request.operation] || null;
      authtype = operation ? operation.authtype : '';
    }
    if (this.config.signatureVersion) {
      version = this.config.signatureVersion;
    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
      version = 'v4';
    } else {
      version = this.api.signatureVersion;
    }
    return AWS.Signers.RequestSigner.getVersion(version);
  },

  /**
   * @api private
   */
  serviceInterface: function serviceInterface() {
    switch (this.api.protocol) {
      case 'ec2': return AWS.EventListeners.Query;
      case 'query': return AWS.EventListeners.Query;
      case 'json': return AWS.EventListeners.Json;
      case 'rest-json': return AWS.EventListeners.RestJson;
      case 'rest-xml': return AWS.EventListeners.RestXml;
    }
    if (this.api.protocol) {
      throw new Error('Invalid service `protocol\' ' +
        this.api.protocol + ' in API config');
    }
  },

  /**
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    return resp.httpResponse.statusCode < 300;
  },

  /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */
  numRetries: function numRetries() {
    if (this.config.maxRetries !== undefined) {
      return this.config.maxRetries;
    } else {
      return this.defaultRetryCount;
    }
  },

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
  },

  /**
   * @api private
   */
  retryableError: function retryableError(error) {
    if (this.timeoutError(error)) return true;
    if (this.networkingError(error)) return true;
    if (this.expiredCredentialsError(error)) return true;
    if (this.throttledError(error)) return true;
    if (error.statusCode >= 500) return true;
    return false;
  },

  /**
   * @api private
   */
  networkingError: function networkingError(error) {
    return error.code === 'NetworkingError';
  },

  /**
   * @api private
   */
  timeoutError: function timeoutError(error) {
    return error.code === 'TimeoutError';
  },

  /**
   * @api private
   */
  expiredCredentialsError: function expiredCredentialsError(error) {
    // TODO : this only handles *one* of the expired credential codes
    return (error.code === 'ExpiredTokenException');
  },

  /**
   * @api private
   */
  clockSkewError: function clockSkewError(error) {
    switch (error.code) {
      case 'RequestTimeTooSkewed':
      case 'RequestExpired':
      case 'InvalidSignatureException':
      case 'SignatureDoesNotMatch':
      case 'AuthFailure':
      case 'RequestInTheFuture':
        return true;
      default: return false;
    }
  },

  /**
   * @api private
   */
  getSkewCorrectedDate: function getSkewCorrectedDate() {
    return new Date(Date.now() + this.config.systemClockOffset);
  },

  /**
   * @api private
   */
  applyClockOffset: function applyClockOffset(newServerTime) {
    if (newServerTime) {
      this.config.systemClockOffset = newServerTime - Date.now();
    }
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(newServerTime) {
    if (newServerTime) {
      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
    }
  },

  /**
   * @api private
   */
  throttledError: function throttledError(error) {
    // this logic varies between services
    switch (error.code) {
      case 'ProvisionedThroughputExceededException':
      case 'Throttling':
      case 'ThrottlingException':
      case 'RequestLimitExceeded':
      case 'RequestThrottled':
        return true;
      default:
        return false;
    }
  },

  /**
   * @api private
   */
  endpointFromTemplate: function endpointFromTemplate(endpoint) {
    if (typeof endpoint !== 'string') return endpoint;

    var e = endpoint;
    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
    e = e.replace(/\{region\}/g, this.config.region);
    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
    return e;
  },

  /**
   * @api private
   */
  setEndpoint: function setEndpoint(endpoint) {
    this.endpoint = new AWS.Endpoint(endpoint, this.config);
  },

  /**
   * @api private
   */
  paginationConfig: function paginationConfig(operation, throwException) {
    var paginator = this.api.operations[operation].paginator;
    if (!paginator) {
      if (throwException) {
        var e = new Error();
        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
      }
      return null;
    }

    return paginator;
  }
});

AWS.util.update(AWS.Service, {

  /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */
  defineMethods: function defineMethods(svc) {
    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
      if (svc.prototype[method]) return;
      var operation = svc.prototype.api.operations[method];
      if (operation.authtype === 'none') {
        svc.prototype[method] = function (params, callback) {
          return this.makeUnauthenticatedRequest(method, params, callback);
        };
      } else {
        svc.prototype[method] = function (params, callback) {
          return this.makeRequest(method, params, callback);
        };
      }
    });
  },

  /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */
  defineService: function defineService(serviceIdentifier, versions, features) {
    AWS.Service._serviceMap[serviceIdentifier] = true;
    if (!Array.isArray(versions)) {
      features = versions;
      versions = [];
    }

    var svc = inherit(AWS.Service, features || {});

    if (typeof serviceIdentifier === 'string') {
      AWS.Service.addVersions(svc, versions);

      var identifier = svc.serviceIdentifier || serviceIdentifier;
      svc.serviceIdentifier = identifier;
    } else { // defineService called with an API
      svc.prototype.api = serviceIdentifier;
      AWS.Service.defineMethods(svc);
    }

    return svc;
  },

  /**
   * @api private
   */
  addVersions: function addVersions(svc, versions) {
    if (!Array.isArray(versions)) versions = [versions];

    svc.services = svc.services || {};
    for (var i = 0; i < versions.length; i++) {
      if (svc.services[versions[i]] === undefined) {
        svc.services[versions[i]] = null;
      }
    }

    svc.apiVersions = Object.keys(svc.services).sort();
  },

  /**
   * @api private
   */
  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
    var svc = inherit(superclass, {
      serviceIdentifier: superclass.serviceIdentifier
    });

    function setApi(api) {
      if (api.isApi) {
        svc.prototype.api = api;
      } else {
        svc.prototype.api = new Api(api);
      }
    }

    if (typeof version === 'string') {
      if (apiConfig) {
        setApi(apiConfig);
      } else {
        try {
          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
        } catch (err) {
          throw AWS.util.error(err, {
            message: 'Could not find API configuration ' +
              superclass.serviceIdentifier + '-' + version
          });
        }
      }
      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
      }
      superclass.services[version] = svc;
    } else {
      setApi(version);
    }

    AWS.Service.defineMethods(svc);
    return svc;
  },

  /**
   * @api private
   */
  hasService: function(identifier) {
    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
  },

  /**
   * @api private
   */
  _serviceMap: {}
});

module.exports = AWS.Service;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

AWS.util.update(AWS.CognitoIdentity.prototype, {
  getOpenIdToken: function getOpenIdToken(params, callback) {
    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
  },

  getId: function getId(params, callback) {
    return this.makeUnauthenticatedRequest('getId', params, callback);
  },

  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

AWS.util.update(AWS.STS.prototype, {
  /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */
  credentialsFrom: function credentialsFrom(data, credentials) {
    if (!data) return null;
    if (!credentials) credentials = new AWS.TemporaryCredentials();
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
    return credentials;
  },

  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
  },

  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
function signedUrlBuilder(request) {
  var expires = request.httpRequest.headers[expiresHeader];
  var signerClass = request.service.getSignerClass(request);

  delete request.httpRequest.headers['User-Agent'];
  delete request.httpRequest.headers['X-Amz-User-Agent'];

  if (signerClass === AWS.Signers.V4) {
    if (expires > 604800) { // one week expiry is invalid
      var message = 'Presigning does not support expiry time greater ' +
                    'than a week with SigV4 signing.';
      throw AWS.util.error(new Error(), {
        code: 'InvalidExpiryTime', message: message, retryable: false
      });
    }
    request.httpRequest.headers[expiresHeader] = expires;
  } else if (signerClass === AWS.Signers.S3) {
    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
    request.httpRequest.headers[expiresHeader] = parseInt(
      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
  } else {
    throw AWS.util.error(new Error(), {
      message: 'Presigning only supports S3 or SigV4 signing.',
      code: 'UnsupportedSigner', retryable: false
    });
  }
}

/**
 * @api private
 */
function signedUrlSigner(request) {
  var endpoint = request.httpRequest.endpoint;
  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
  var queryParams = {};

  if (parsedUrl.search) {
    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
  }

  var auth = request.httpRequest.headers['Authorization'].split(' ');
  if (auth[0] === 'AWS') {
    auth = auth[1].split(':');
    queryParams['AWSAccessKeyId'] = auth[0];
    queryParams['Signature'] = auth[1];

    AWS.util.each(request.httpRequest.headers, function (key, value) {
      if (key === expiresHeader) key = 'Expires';
      if (key.indexOf('x-amz-meta-') === 0) {
        // Delete existing, potentially not normalized key
        delete queryParams[key];
        key = key.toLowerCase();
      }
      queryParams[key] = value;
    });
    delete request.httpRequest.headers[expiresHeader];
    delete queryParams['Authorization'];
    delete queryParams['Host'];
  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
    auth.shift();
    var rest = auth.join(' ');
    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
    queryParams['X-Amz-Signature'] = signature;
    delete queryParams['Expires'];
  }

  // build URL
  endpoint.pathname = parsedUrl.pathname;
  endpoint.search = AWS.util.queryParamsToString(queryParams);
}

/**
 * @api private
 */
AWS.Signers.Presign = inherit({
  /**
   * @api private
   */
  sign: function sign(request, expireTime, callback) {
    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
    request.on('build', signedUrlBuilder);
    request.on('sign', signedUrlSigner);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.COMPUTE_SHA256);

    request.emit('beforePresign', [request]);

    if (callback) {
      request.build(function() {
        if (this.response.error) callback(this.response.error);
        else {
          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
        }
      });
    } else {
      request.build();
      if (request.response.error) throw request.response.error;
      return AWS.util.urlFormat(request.httpRequest.endpoint);
    }
  }
});

module.exports = AWS.Signers.Presign;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.RequestSigner = inherit({
  constructor: function RequestSigner(request) {
    this.request = request;
  },

  setServiceClientId: function setServiceClientId(id) {
    this.serviceClientId = id;
  },

  getServiceClientId: function getServiceClientId() {
    return this.serviceClientId;
  }
});

AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
  switch (version) {
    case 'v2': return AWS.Signers.V2;
    case 'v3': return AWS.Signers.V3;
    case 'v4': return AWS.Signers.V4;
    case 's3': return AWS.Signers.S3;
    case 'v3https': return AWS.Signers.V3Https;
  }
  throw new Error('Unknown signing version ' + version);
};

__webpack_require__(750);
__webpack_require__(353);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(749);
__webpack_require__(747);


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
  /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */
  subResources: {
    'acl': 1,
    'accelerate': 1,
    'analytics': 1,
    'cors': 1,
    'lifecycle': 1,
    'delete': 1,
    'inventory': 1,
    'location': 1,
    'logging': 1,
    'metrics': 1,
    'notification': 1,
    'partNumber': 1,
    'policy': 1,
    'requestPayment': 1,
    'replication': 1,
    'restore': 1,
    'tagging': 1,
    'torrent': 1,
    'uploadId': 1,
    'uploads': 1,
    'versionId': 1,
    'versioning': 1,
    'versions': 1,
    'website': 1
  },

  // when building the stringToSign, these querystring params should be
  // part of the canonical resource string with their NON-encoded values
  responseHeaders: {
    'response-content-type': 1,
    'response-content-language': 1,
    'response-expires': 1,
    'response-cache-control': 1,
    'response-content-disposition': 1,
    'response-content-encoding': 1
  },

  addAuthorization: function addAuthorization(credentials, date) {
    if (!this.request.headers['presigned-expires']) {
      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
    }

    if (credentials.sessionToken) {
      // presigned URLs require this header to be lowercased
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

    this.request.headers['Authorization'] = auth;
  },

  stringToSign: function stringToSign() {
    var r = this.request;

    var parts = [];
    parts.push(r.method);
    parts.push(r.headers['Content-MD5'] || '');
    parts.push(r.headers['Content-Type'] || '');

    // This is the "Date" header, but we use X-Amz-Date.
    // The S3 signing mechanism requires us to pass an empty
    // string for this Date header regardless.
    parts.push(r.headers['presigned-expires'] || '');

    var headers = this.canonicalizedAmzHeaders();
    if (headers) parts.push(headers);
    parts.push(this.canonicalizedResource());

    return parts.join('\n');

  },

  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

    var amzHeaders = [];

    AWS.util.each(this.request.headers, function (name) {
      if (name.match(/^x-amz-/i))
        amzHeaders.push(name);
    });

    amzHeaders.sort(function (a, b) {
      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    });

    var parts = [];
    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
    });

    return parts.join('\n');

  },

  canonicalizedResource: function canonicalizedResource() {

    var r = this.request;

    var parts = r.path.split('?');
    var path = parts[0];
    var querystring = parts[1];

    var resource = '';

    if (r.virtualHostedBucket)
      resource += '/' + r.virtualHostedBucket;

    resource += path;

    if (querystring) {

      // collect a list of sub resources and query params that need to be signed
      var resources = [];

      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
        var name = param.split('=')[0];
        var value = param.split('=')[1];
        if (this.subResources[name] || this.responseHeaders[name]) {
          var subresource = { name: name };
          if (value !== undefined) {
            if (this.subResources[name]) {
              subresource.value = value;
            } else {
              subresource.value = decodeURIComponent(value);
            }
          }
          resources.push(subresource);
        }
      });

      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

      if (resources.length) {

        querystring = [];
        AWS.util.arrayEach(resources, function (res) {
          if (res.value === undefined) {
            querystring.push(res.name);
          } else {
            querystring.push(res.name + '=' + res.value);
          }
        });

        resource += '?' + querystring.join('&');
      }

    }

    return resource;

  },

  sign: function sign(secret, string) {
    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
  }
});

module.exports = AWS.Signers.S3;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    if (!date) date = AWS.util.date.getDate();

    var r = this.request;

    r.params.Timestamp = AWS.util.date.iso8601(date);
    r.params.SignatureVersion = '2';
    r.params.SignatureMethod = 'HmacSHA256';
    r.params.AWSAccessKeyId = credentials.accessKeyId;

    if (credentials.sessionToken) {
      r.params.SecurityToken = credentials.sessionToken;
    }

    delete r.params.Signature; // delete old Signature for re-signing
    r.params.Signature = this.signature(credentials);

    r.body = AWS.util.queryParamsToString(r.params);
    r.headers['Content-Length'] = r.body.length;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push(this.request.endpoint.host.toLowerCase());
    parts.push(this.request.pathname());
    parts.push(AWS.util.queryParamsToString(this.request.params));
    return parts.join('\n');
  }

});

module.exports = AWS.Signers.V2;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var inherit = AWS.util.inherit;

__webpack_require__(353);

/**
 * @api private
 */
AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
  authorization: function authorization(credentials) {
    return 'AWS3-HTTPS ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'Signature=' + this.signature(credentials);
  },

  stringToSign: function stringToSign() {
    return this.request.headers['X-Amz-Date'];
  }
});

module.exports = AWS.Signers.V3Https;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);
var v4Credentials = __webpack_require__(753);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
  constructor: function V4(request, serviceName, options) {
    AWS.Signers.RequestSigner.call(this, request);
    this.serviceName = serviceName;
    options = options || {};
    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
    this.operation = options.operation;
  },

  algorithm: 'AWS4-HMAC-SHA256',

  addAuthorization: function addAuthorization(credentials, date) {
    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

    if (this.isPresigned()) {
      this.updateForPresigned(credentials, datetime);
    } else {
      this.addHeaders(credentials, datetime);
    }

    this.request.headers['Authorization'] =
      this.authorization(credentials, datetime);
  },

  addHeaders: function addHeaders(credentials, datetime) {
    this.request.headers['X-Amz-Date'] = datetime;
    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }
  },

  updateForPresigned: function updateForPresigned(credentials, datetime) {
    var credString = this.credentialString(datetime);
    var qs = {
      'X-Amz-Date': datetime,
      'X-Amz-Algorithm': this.algorithm,
      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
      'X-Amz-Expires': this.request.headers[expiresHeader],
      'X-Amz-SignedHeaders': this.signedHeaders()
    };

    if (credentials.sessionToken) {
      qs['X-Amz-Security-Token'] = credentials.sessionToken;
    }

    if (this.request.headers['Content-Type']) {
      qs['Content-Type'] = this.request.headers['Content-Type'];
    }
    if (this.request.headers['Content-MD5']) {
      qs['Content-MD5'] = this.request.headers['Content-MD5'];
    }
    if (this.request.headers['Cache-Control']) {
      qs['Cache-Control'] = this.request.headers['Cache-Control'];
    }

    // need to pull in any other X-Amz-* headers
    AWS.util.each.call(this, this.request.headers, function(key, value) {
      if (key === expiresHeader) return;
      if (this.isSignableHeader(key)) {
        var lowerKey = key.toLowerCase();
        // Metadata should be normalized
        if (lowerKey.indexOf('x-amz-meta-') === 0) {
          qs[lowerKey] = value;
        } else if (lowerKey.indexOf('x-amz-') === 0) {
          qs[key] = value;
        }
      }
    });

    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
    this.request.path += sep + AWS.util.queryParamsToString(qs);
  },

  authorization: function authorization(credentials, datetime) {
    var parts = [];
    var credString = this.credentialString(datetime);
    parts.push(this.algorithm + ' Credential=' +
      credentials.accessKeyId + '/' + credString);
    parts.push('SignedHeaders=' + this.signedHeaders());
    parts.push('Signature=' + this.signature(credentials, datetime));
    return parts.join(', ');
  },

  signature: function signature(credentials, datetime) {
    var signingKey = v4Credentials.getSigningKey(
      credentials,
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName,
      this.signatureCache
    );
    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
  },

  stringToSign: function stringToSign(datetime) {
    var parts = [];
    parts.push('AWS4-HMAC-SHA256');
    parts.push(datetime);
    parts.push(this.credentialString(datetime));
    parts.push(this.hexEncodedHash(this.canonicalString()));
    return parts.join('\n');
  },

  canonicalString: function canonicalString() {
    var parts = [], pathname = this.request.pathname();
    if (this.serviceName !== 's3') pathname = AWS.util.uriEscapePath(pathname);

    parts.push(this.request.method);
    parts.push(pathname);
    parts.push(this.request.search());
    parts.push(this.canonicalHeaders() + '\n');
    parts.push(this.signedHeaders());
    parts.push(this.hexEncodedBodyHash());
    return parts.join('\n');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = [];
    AWS.util.each.call(this, this.request.headers, function (key, item) {
      headers.push([key, item]);
    });
    headers.sort(function (a, b) {
      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
    });
    var parts = [];
    AWS.util.arrayEach.call(this, headers, function (item) {
      var key = item[0].toLowerCase();
      if (this.isSignableHeader(key)) {
        var value = item[1];
        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
            code: 'InvalidHeader'
          });
        }
        parts.push(key + ':' +
          this.canonicalHeaderValues(value.toString()));
      }
    });
    return parts.join('\n');
  },

  canonicalHeaderValues: function canonicalHeaderValues(values) {
    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  },

  signedHeaders: function signedHeaders() {
    var keys = [];
    AWS.util.each.call(this, this.request.headers, function (key) {
      key = key.toLowerCase();
      if (this.isSignableHeader(key)) keys.push(key);
    });
    return keys.sort().join(';');
  },

  credentialString: function credentialString(datetime) {
    return v4Credentials.createScope(
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName
    );
  },

  hexEncodedHash: function hash(string) {
    return AWS.util.crypto.sha256(string, 'hex');
  },

  hexEncodedBodyHash: function hexEncodedBodyHash() {
    var request = this.request;
    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
      return 'UNSIGNED-PAYLOAD';
    } else if (request.headers['X-Amz-Content-Sha256']) {
      return request.headers['X-Amz-Content-Sha256'];
    } else {
      return this.hexEncodedHash(this.request.body || '');
    }
  },

  unsignableHeaders: [
    'authorization',
    'content-type',
    'content-length',
    'user-agent',
    expiresHeader,
    'expect',
    'x-amzn-trace-id'
  ],

  isSignableHeader: function isSignableHeader(key) {
    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
    return this.unsignableHeaders.indexOf(key) < 0;
  },

  isPresigned: function isPresigned() {
    return this.request.headers[expiresHeader] ? true : false;
  }

});

module.exports = AWS.Signers.V4;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(10);

/**
 * @api private
 */
var cachedSecret = {};

/**
 * @api private
 */
var cacheQueue = [];

/**
 * @api private
 */
var maxCacheEntries = 50;

/**
 * @api private
 */
var v4Identifier = 'aws4_request';

module.exports = {
  /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */
  createScope: function createScope(date, region, serviceName) {
    return [
      date.substr(0, 8),
      region,
      serviceName,
      v4Identifier
    ].join('/');
  },

  /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */
  getSigningKey: function getSigningKey(
    credentials,
    date,
    region,
    service,
    shouldCache
  ) {
    var credsIdentifier = AWS.util.crypto
      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
    var cacheKey = [credsIdentifier, date, region, service].join('_');
    shouldCache = shouldCache !== false;
    if (shouldCache && (cacheKey in cachedSecret)) {
      return cachedSecret[cacheKey];
    }

    var kDate = AWS.util.crypto.hmac(
      'AWS4' + credentials.secretAccessKey,
      date,
      'buffer'
    );
    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
    if (shouldCache) {
      cachedSecret[cacheKey] = signingKey;
      cacheQueue.push(cacheKey);
      if (cacheQueue.length > maxCacheEntries) {
        // remove the oldest entry (not the least recently used)
        delete cachedSecret[cacheQueue.shift()];
      }
    }

    return signingKey;
  },

  /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */
  emptyCache: function emptyCache() {
    cachedSecret = {};
    cacheQueue = [];
  }
};


/***/ }),
/* 754 */
/***/ (function(module, exports) {

function AcceptorStateMachine(states, state) {
  this.currentState = state || null;
  this.states = states || {};
}

AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
  if (typeof finalState === 'function') {
    inputError = bindObject; bindObject = done;
    done = finalState; finalState = null;
  }

  var self = this;
  var state = self.states[self.currentState];
  state.fn.call(bindObject || self, inputError, function(err) {
    if (err) {
      if (state.fail) self.currentState = state.fail;
      else return done ? done.call(bindObject, err) : null;
    } else {
      if (state.accept) self.currentState = state.accept;
      else return done ? done.call(bindObject) : null;
    }
    if (self.currentState === finalState) {
      return done ? done.call(bindObject, err) : null;
    }

    self.runTo(finalState, done, bindObject, err);
  });
};

AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
  if (typeof acceptState === 'function') {
    fn = acceptState; acceptState = null; failState = null;
  } else if (typeof failState === 'function') {
    fn = failState; failState = null;
  }

  if (!this.currentState) this.currentState = name;
  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
  return this;
};

module.exports = AcceptorStateMachine;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var Shape = __webpack_require__(127);

function DomXmlParser() { }

DomXmlParser.prototype.parse = function(xml, shape) {
  if (xml.replace(/^\s+/, '') === '') return {};

  var result, error;
  try {
    if (window.DOMParser) {
      try {
        var parser = new DOMParser();
        result = parser.parseFromString(xml, 'text/xml');
      } catch (syntaxError) {
        throw util.error(new Error('Parse error in document'),
          {
            originalError: syntaxError,
            code: 'XMLParserError',
            retryable: true
          });
      }

      if (result.documentElement === null) {
        throw util.error(new Error('Cannot parse empty document.'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }

      var isError = result.getElementsByTagName('parsererror')[0];
      if (isError && (isError.parentNode === result ||
          isError.parentNode.nodeName === 'body' ||
          isError.parentNode.parentNode === result ||
          isError.parentNode.parentNode.nodeName === 'body')) {
        var errorElement = isError.getElementsByTagName('div')[0] || isError;
        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else if (window.ActiveXObject) {
      result = new window.ActiveXObject('Microsoft.XMLDOM');
      result.async = false;

      if (!result.loadXML(xml)) {
        throw util.error(new Error('Parse error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else {
      throw new Error('Cannot load XML parser');
    }
  } catch (e) {
    error = e;
  }

  if (result && result.documentElement && !error) {
    var data = parseXml(result.documentElement, shape);
    var metadata = result.getElementsByTagName('ResponseMetadata')[0];
    if (metadata) {
      data.ResponseMetadata = parseXml(metadata, {});
    }
    return data;
  } else if (error) {
    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
  } else { // empty xml document
    return {};
  }
};

function parseXml(xml, shape) {
  if (!shape) shape = {};
  switch (shape.type) {
    case 'structure': return parseStructure(xml, shape);
    case 'map': return parseMap(xml, shape);
    case 'list': return parseList(xml, shape);
    case undefined: case null: return parseUnknown(xml);
    default: return parseScalar(xml, shape);
  }
}

function parseStructure(xml, shape) {
  var data = {};
  if (xml === null) return data;

  util.each(shape.members, function(memberName, memberShape) {
    if (memberShape.isXmlAttribute) {
      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
        var value = xml.attributes[memberShape.name].value;
        data[memberName] = parseXml({textContent: value}, memberShape);
      }
    } else {
      var xmlChild = memberShape.flattened ? xml :
        xml.getElementsByTagName(memberShape.name)[0];
      if (xmlChild) {
        data[memberName] = parseXml(xmlChild, memberShape);
      } else if (!memberShape.flattened && memberShape.type === 'list') {
        data[memberName] = memberShape.defaultValue;
      }
    }
  });

  return data;
}

function parseMap(xml, shape) {
  var data = {};
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';
  var tagName = shape.flattened ? shape.name : 'entry';

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      var key = child.getElementsByTagName(xmlKey)[0].textContent;
      var value = child.getElementsByTagName(xmlValue)[0];
      data[key] = parseXml(value, shape.value);
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseList(xml, shape) {
  var data = [];
  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      data.push(parseXml(child, shape.member));
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseScalar(xml, shape) {
  if (xml.getAttribute) {
    var encoding = xml.getAttribute('encoding');
    if (encoding === 'base64') {
      shape = new Shape.create({type: encoding});
    }
  }

  var text = xml.textContent;
  if (text === '') text = null;
  if (typeof shape.toType === 'function') {
    return shape.toType(text);
  } else {
    return text;
  }
}

function parseUnknown(xml) {
  if (xml === undefined || xml === null) return '';

  // empty object
  if (!xml.firstElementChild) {
    if (xml.parentNode.parentNode === null) return {};
    if (xml.childNodes.length === 0) return '';
    else return xml.textContent;
  }

  // object, parse as structure
  var shape = {type: 'structure', members: {}};
  var child = xml.firstElementChild;
  while (child) {
    var tag = child.nodeName;
    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
      // multiple tags of the same name makes it a list
      shape.members[tag].type = 'list';
    } else {
      shape.members[tag] = {name: tag};
    }
    child = child.nextElementSibling;
  }
  return parseStructure(xml, shape);
}

module.exports = DomXmlParser;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(27);
var builder = __webpack_require__(681);

function XmlBuilder() { }

XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
  var xml = builder.create(rootElement);
  applyNamespaces(xml, shape);
  serialize(xml, params, shape);
  return xml.children.length > 0 || noEmpty ? xml.root().toString() : '';
};

function serialize(xml, value, shape) {
  switch (shape.type) {
    case 'structure': return serializeStructure(xml, value, shape);
    case 'map': return serializeMap(xml, value, shape);
    case 'list': return serializeList(xml, value, shape);
    default: return serializeScalar(xml, value, shape);
  }
}

function serializeStructure(xml, params, shape) {
  util.arrayEach(shape.memberNames, function(memberName) {
    var memberShape = shape.members[memberName];
    if (memberShape.location !== 'body') return;

    var value = params[memberName];
    var name = memberShape.name;
    if (value !== undefined && value !== null) {
      if (memberShape.isXmlAttribute) {
        xml.att(name, value);
      } else if (memberShape.flattened) {
        serialize(xml, value, memberShape);
      } else {
        var element = xml.ele(name);
        applyNamespaces(element, memberShape);
        serialize(element, value, memberShape);
      }
    }
  });
}

function serializeMap(xml, map, shape) {
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';

  util.each(map, function(key, value) {
    var entry = xml.ele(shape.flattened ? shape.name : 'entry');
    serialize(entry.ele(xmlKey), key, shape.key);
    serialize(entry.ele(xmlValue), value, shape.value);
  });
}

function serializeList(xml, list, shape) {
  if (shape.flattened) {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || shape.name;
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  } else {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || 'member';
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  }
}

function serializeScalar(xml, value, shape) {
  xml.txt(shape.toWireFormat(value));
}

function applyNamespaces(xml, shape) {
  var uri, prefix = 'xmlns';
  if (shape.xmlNamespaceUri) {
    uri = shape.xmlNamespaceUri;
    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
  } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
    uri = shape.api.xmlNamespaceUri;
  }

  if (uri) xml.att(prefix, uri);
}

module.exports = XmlBuilder;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"}}}}}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{}}}}}}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{}}},"output":{"shape":"S6"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sb"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Se"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sg"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"Sk"}}},"output":{"shape":"Sl"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Sq"},"properties":{}}},"output":{"shape":"St"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sv"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{}}},"output":{"shape":"Sx"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"Sz"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S11"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S13"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S8"}}},"output":{"shape":"S1g"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"Sk"},"documentationVersion":{}}},"output":{"shape":"S1i"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S1q"},"throttle":{"shape":"S1s"},"quota":{"shape":"S1t"}}},"output":{"shape":"S1v"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S1x"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{}}},"output":{"shape":"S2m"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S2o"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S6"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S8"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S6"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Se"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Se"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sg"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sg"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S2m"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2m"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sl"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sl"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"St"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"St"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sv"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"Sx"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"Sk","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S3p"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S3p"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1a"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1e"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S15"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S18"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"Sz"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sz"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S11"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S11"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"shape":"S13"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S8","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S13"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1g"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1g"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"Sk","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S4i"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S4i"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1i"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1i"}}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S4t"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S1v"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S1x"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1x"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1v"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S8"},"warnings":{"shape":"S8"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S8"},"warnings":{"shape":"S8"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"Sk","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1g"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"}}},"output":{"shape":"S3p"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"credentials":{},"requestParameters":{"shape":"Sk"},"requestTemplates":{"shape":"Sk"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S8"},"contentHandling":{}}},"output":{"shape":"S1a"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"contentHandling":{}}},"output":{"shape":"S1e"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S16"},"requestModels":{"shape":"Sk"},"requestValidatorId":{}}},"output":{"shape":"S15"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S16"},"responseModels":{"shape":"Sk"}}},"output":{"shape":"S18"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"Sk","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1g"}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S5k"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"Sk"},"additionalContext":{"shape":"Sk"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"type":"map","key":{},"value":{"shape":"S8"}},"claims":{"shape":"Sk"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S5k"},"clientCertificateId":{},"stageVariables":{"shape":"Sk"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S5k"},"log":{},"latency":{"type":"long"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S2o"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S6"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Se"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Sg"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S2m"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Sl"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"St"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Sv"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Sx"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S3p"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S1a"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S1e"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S15"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S18"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"Sz"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S11"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S13"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S1g"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S1i"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S4t"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S5q"}}},"output":{"shape":"S1v"}}},"shapes":{"S6":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S8"}}},"S8":{"type":"list","member":{}},"Sb":{"type":"list","member":{}},"Se":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sb"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sg":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sk":{"type":"map","key":{},"value":{}},"Sl":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Sq":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"St":{"type":"structure","members":{"id":{},"location":{"shape":"Sq"},"properties":{}}},"Sv":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sx":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"distributionDomainName":{}}},"Sz":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S11":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S13":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S15"}}}},"S15":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S16"},"requestModels":{"shape":"Sk"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S18"}},"methodIntegration":{"shape":"S1a"}}},"S16":{"type":"map","key":{},"value":{"type":"boolean"}},"S18":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S16"},"responseModels":{"shape":"Sk"}}},"S1a":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"credentials":{},"requestParameters":{"shape":"Sk"},"requestTemplates":{"shape":"Sk"},"passthroughBehavior":{},"contentHandling":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S8"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1e"}}}},"S1e":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"contentHandling":{}}},"S1g":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S8"},"binaryMediaTypes":{"shape":"S8"}}},"S1i":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"Sk"},"documentationVersion":{},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S1q":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{}}}},"S1s":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S1t":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S1v":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S1q"},"throttle":{"shape":"S1s"},"quota":{"shape":"S1t"},"productCode":{}}},"S1x":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S2m":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"}}},"S2o":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S1s"},"features":{"shape":"S8"},"apiKeyVersion":{}}},"S3p":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"Sk"},"responseTemplates":{"shape":"Sk"},"defaultResponse":{"type":"boolean"}}},"S4i":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S4t":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S5k":{"type":"map","key":{},"value":{}},"S5q":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"S9"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"S9"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"St"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S12"},"Alarms":{"shape":"S1g"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"St"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S12"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S1g"}}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S9":{"type":"list","member":{}},"St":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S12":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S1g":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}}}}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"}}}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sn"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"Sr"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S10"}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S17"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S18"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1a"},"InstanceMonitoring":{"shape":"S1j"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S10"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S10"}}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S28"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sn"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","LaunchConfigurationName","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"ProtectedFromScaleIn":{"type":"boolean"}}}},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S2l"},"TerminationPolicies":{"shape":"Sr"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","LaunchConfigurationName","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"ProtectedFromScaleIn":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S2s"}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S17"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S18"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1a"},"InstanceMonitoring":{"shape":"S1j"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S2s"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S28"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S3s"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S3v"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S3z"},"TargetTrackingConfiguration":{"shape":"S41"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S4h"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"type":"list","member":{}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S2l"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"Sr"}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S4h"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S57"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S57"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S4h"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S4h"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S2s"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S3s"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S3v"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S41"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S3z"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S5n"}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"SuspendProcesses":{"input":{"shape":"S5n"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S4i"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"Sn"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"Sr"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Sn":{"type":"list","member":{}},"Sr":{"type":"list","member":{}},"S10":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S17":{"type":"list","member":{}},"S18":{"type":"list","member":{}},"S1a":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}},"NoDevice":{"type":"boolean"}}}},"S1j":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S28":{"type":"list","member":{}},"S2l":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S2s":{"type":"list","member":{}},"S3s":{"type":"integer","deprecated":true},"S3v":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S3z":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S41":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S4h":{"type":"list","member":{"shape":"S4i"}},"S4i":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{}}},"S57":{"type":"list","member":{}},"S5n":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"Sn"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"St"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"Sv"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"St"},"RollbackConfiguration":{"shape":"Sn"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ResourceChange":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}}}}}}},"NextToken":{}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{}}}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"Sn"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"St"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"Sj"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"Sv"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{}}}},"NextToken":{}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"Sl"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"S4u"}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{}}}},"NextToken":{}}}},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ClientRequestToken":{}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"S4u"}}}}},"shapes":{"Se":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"list","member":{}},"S1k":{"type":"structure","members":{"RegionOrder":{"shape":"S1i"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"}}},"S4u":{"type":"list","member":{}}}}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"}}}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]}}}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{"locationName":"SubnetId"},"SshKey":{"locationName":"SshKey"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SubscriptionType":{"locationName":"SubscriptionType"},"ClientToken":{"locationName":"ClientToken"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"CreateHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"}},"locationName":"DeleteHsmRequest"},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}}},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}}},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}}},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}}},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}}},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}}},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}}},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}}},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"},"SubnetId":{"locationName":"SubnetId"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"ModifyHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"idempotent":true},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"}}}}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName","EventSelectors"],"members":{"TrailName":{},"EventSelectors":{"shape":"Si"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}}}}}}}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeTrails":{"result_key":"trailList"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S6"}},"repositoriesNotFound":{"type":"list","member":{}}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S6"}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"Sn"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"Sn"}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S11"},"committer":{"shape":"S11"},"additionalData":{}}}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S1e"},"afterBlob":{"shape":"S1e"},"changeType":{}}}},"NextToken":{}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S6"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S1m"}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S1q"},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S1m"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S1m"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"S6":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{}}},"Sn":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S11":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S1e":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S1m":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S1q"},"events":{"type":"list","member":{}}}}},"S1q":{"type":"list","member":{}}}}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"}}}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","timestampFormat":"unixTimestamp","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"Sq"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","members":{"applicationNames":{"shape":"Sw"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"Sz"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Ss"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S16"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S2n"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S2r"}},"errorMessage":{}}}},"BatchGetDeployments":{"input":{"type":"structure","members":{"deploymentIds":{"shape":"S34"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S37"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S3l"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S3e"},"autoRollbackConfiguration":{"shape":"S1u"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName","minimumHealthyHosts"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S3v"}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S19"},"onPremisesInstanceTagFilters":{"shape":"S1c"},"autoScalingGroups":{"shape":"S3f"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1k"},"alarmConfiguration":{"shape":"S1q"},"autoRollbackConfiguration":{"shape":"S1u"},"deploymentStyle":{"shape":"S1x"},"blueGreenDeploymentConfiguration":{"shape":"S20"},"loadBalancerInfo":{"shape":"S28"},"ec2TagSet":{"shape":"S2i"},"onPremisesTagSet":{"shape":"S2k"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1f"}}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"Sz"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"Sq"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S37"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S3v"},"createTime":{"type":"timestamp"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S16"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S2r"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S3l"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"Sw"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Ss"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S2n"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S34"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1c"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}}},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S19"},"onPremisesInstanceTagFilters":{"shape":"S1c"},"autoScalingGroups":{"shape":"S3f"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1k"},"alarmConfiguration":{"shape":"S1q"},"autoRollbackConfiguration":{"shape":"S1u"},"deploymentStyle":{"shape":"S1x"},"blueGreenDeploymentConfiguration":{"shape":"S20"},"loadBalancerInfo":{"shape":"S28"},"ec2TagSet":{"shape":"S2i"},"onPremisesTagSet":{"shape":"S2k"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1f"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}}}},"Sq":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Ss"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{}}},"S16":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S19"},"onPremisesInstanceTagFilters":{"shape":"S1c"},"autoScalingGroups":{"shape":"S1f"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1k"},"alarmConfiguration":{"shape":"S1q"},"autoRollbackConfiguration":{"shape":"S1u"},"deploymentStyle":{"shape":"S1x"},"blueGreenDeploymentConfiguration":{"shape":"S20"},"loadBalancerInfo":{"shape":"S28"},"lastSuccessfulDeployment":{"shape":"S2f"},"lastAttemptedDeployment":{"shape":"S2f"},"ec2TagSet":{"shape":"S2i"},"onPremisesTagSet":{"shape":"S2k"}}},"S19":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1f":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1q":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1u":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S1x":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S20":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S28":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S2f":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2i":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S19"}}}},"S2k":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1c"}}}},"S2n":{"type":"list","member":{}},"S2r":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"instanceType":{}}},"S34":{"type":"list","member":{}},"S37":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1u"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S1x"},"targetInstances":{"shape":"S3e"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S20"},"loadBalancerInfo":{"shape":"S28"},"additionalDeploymentStatusInfo":{},"fileExistsBehavior":{}}},"S3e":{"type":"structure","members":{"tagFilters":{"shape":"S19"},"autoScalingGroups":{"shape":"S3f"},"ec2TagSet":{"shape":"S2i"}}},"S3f":{"type":"list","member":{}},"S3l":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S3v":{"type":"structure","members":{"value":{"type":"integer"},"type":{}}}}}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sr"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sv"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S1x"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S34"},"latestExecution":{"type":"structure","members":{"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"type":"structure","members":{"code":{},"message":{}}}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{}}}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Ss"},"actionConfiguration":{"shape":"S1y"},"pipelineContext":{"shape":"S1z"},"inputArtifacts":{"shape":"S22"},"outputArtifacts":{"shape":"S22"},"artifactCredentials":{"shape":"S2a"},"continuationToken":{},"encryptionKey":{"shape":"S11"}}},"nonce":{}}}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sr"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Ss"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S1x"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Ss"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S34"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S4j"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S4m"},"continuationToken":{},"executionDetails":{"shape":"S4o"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S4j"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S4m"},"continuationToken":{},"executionDetails":{"shape":"S4o"}}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sv"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sv"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sr":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Ss"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Ss":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sv":{"type":"structure","required":["name","roleArn","artifactStore","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S11"}}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Ss"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1f"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{}}}}}}},"version":{"type":"integer"}}},"S11":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1f":{"type":"map","key":{},"value":{}},"S1x":{"type":"structure","members":{"actionTypeId":{"shape":"Ss"},"actionConfiguration":{"shape":"S1y"},"pipelineContext":{"shape":"S1z"},"inputArtifacts":{"shape":"S22"},"outputArtifacts":{"shape":"S22"},"artifactCredentials":{"shape":"S2a"},"continuationToken":{},"encryptionKey":{"shape":"S11"}}},"S1y":{"type":"structure","members":{"configuration":{"shape":"S1f"}}},"S1z":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{}}}}},"S22":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S2a":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{},"secretAccessKey":{},"sessionToken":{}},"sensitive":true},"S34":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S4j":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S4m":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S4o":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"},"AuthFlow":{},"AuthParameters":{"shape":"S1j"},"ClientMetadata":{"shape":"S1k"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1o"},"AuthenticationResult":{"shape":"S1p"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S1z"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S23"},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2c"},"Session":{}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1o"},"AuthenticationResult":{"shape":"S1p"}}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1q"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1h"},"SecretHash":{"shape":"S2u"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1h"},"SecretHash":{"shape":"S2u"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S24"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S34"},"AttributeMapping":{"shape":"S35"},"IdpIdentifiers":{"shape":"S37"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S3a"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S3e"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S3j"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S3n"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S3v"},"LambdaConfig":{"shape":"S3y"},"AutoVerifiedAttributes":{"shape":"S3z"},"AliasAttributes":{"shape":"S41"},"UsernameAttributes":{"shape":"S43"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S48"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S4d"},"EmailConfiguration":{"shape":"S4e"},"SmsConfiguration":{"shape":"S4g"},"UserPoolTags":{"shape":"S4h"},"AdminCreateUserConfig":{"shape":"S4i"},"Schema":{"shape":"S4l"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S4n"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S4t"},"WriteAttributes":{"shape":"S4t"},"ExplicitAuthFlows":{"shape":"S4v"},"SupportedIdentityProviders":{"shape":"S4x"},"CallbackURLs":{"shape":"S4y"},"LogoutURLs":{"shape":"S50"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S51"},"AllowedOAuthScopes":{"shape":"S53"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S56"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1q"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S3a"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S3j"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S3n"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S4n"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S56"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1q"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1h"},"SecretHash":{"shape":"S2u"},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S65"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S24"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S3a"}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S6h"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1q"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S65"}}},"authtype":"none"},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1j"},"ClientMetadata":{"shape":"S1k"},"ClientId":{"shape":"S1h"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1o"},"AuthenticationResult":{"shape":"S1p"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1q"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S1z"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S23"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S3j"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S3n"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1h"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S3y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S7o"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S7o"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1h"},"SecretHash":{"shape":"S2u"},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S65"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1h"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2c"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1o"},"AuthenticationResult":{"shape":"S1p"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S6h"}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1q"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1h"},"SecretHash":{"shape":"S2u"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S65"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S3n"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S3n"}}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1q"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S24"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S34"},"AttributeMapping":{"shape":"S35"},"IdpIdentifiers":{"shape":"S37"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S3a"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S3e"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S3j"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1q"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S65"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S3v"},"LambdaConfig":{"shape":"S3y"},"AutoVerifiedAttributes":{"shape":"S3z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S48"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S4d"},"EmailConfiguration":{"shape":"S4e"},"SmsConfiguration":{"shape":"S4g"},"UserPoolTags":{"shape":"S4h"},"AdminCreateUserConfig":{"shape":"S4i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1h"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S4t"},"WriteAttributes":{"shape":"S4t"},"ExplicitAuthFlows":{"shape":"S4v"},"SupportedIdentityProviders":{"shape":"S4x"},"CallbackURLs":{"shape":"S4y"},"LogoutURLs":{"shape":"S50"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S51"},"AllowedOAuthScopes":{"shape":"S53"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S56"}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1q"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1h":{"type":"string","sensitive":true},"S1j":{"type":"map","key":{},"value":{}},"S1k":{"type":"map","key":{},"value":{}},"S1o":{"type":"map","key":{},"value":{}},"S1p":{"type":"structure","members":{"AccessToken":{"shape":"S1q"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1q"},"IdToken":{"shape":"S1q"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1q":{"type":"string","sensitive":true},"S1z":{"type":"list","member":{"shape":"S1d"}},"S23":{"type":"list","member":{"shape":"S24"}},"S24":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2c":{"type":"map","key":{},"value":{}},"S2u":{"type":"string","sensitive":true},"S34":{"type":"map","key":{},"value":{}},"S35":{"type":"map","key":{},"value":{}},"S37":{"type":"list","member":{}},"S3a":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S34"},"AttributeMapping":{"shape":"S35"},"IdpIdentifiers":{"shape":"S37"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S3e":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S3j":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S3e"}}},"S3n":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S3v":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S3y":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{}}},"S3z":{"type":"list","member":{}},"S41":{"type":"list","member":{}},"S43":{"type":"list","member":{}},"S48":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S4d":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S4e":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S4g":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S4h":{"type":"map","key":{},"value":{}},"S4i":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S4l":{"type":"list","member":{"shape":"S4"}},"S4n":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S3v"},"LambdaConfig":{"shape":"S3y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S4l"},"AutoVerifiedAttributes":{"shape":"S3z"},"AliasAttributes":{"shape":"S41"},"UsernameAttributes":{"shape":"S43"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S48"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S4d"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S4e"},"SmsConfiguration":{"shape":"S4g"},"UserPoolTags":{"shape":"S4h"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"AdminCreateUserConfig":{"shape":"S4i"}}},"S4t":{"type":"list","member":{}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4y":{"type":"list","member":{}},"S50":{"type":"list","member":{}},"S51":{"type":"list","member":{}},"S53":{"type":"list","member":{}},"S56":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1h"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S4t"},"WriteAttributes":{"shape":"S4t"},"ExplicitAuthFlows":{"shape":"S4v"},"SupportedIdentityProviders":{"shape":"S4x"},"CallbackURLs":{"shape":"S4y"},"LogoutURLs":{"shape":"S50"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S51"},"AllowedOAuthScopes":{"shape":"S53"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"}}},"S65":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S6h":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1h"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S7o":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","serviceFullName":"Amazon Cognito Sync","signatureVersion":"v4","protocol":"rest-json","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}},"examples":{}}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"ComplianceTypes":{"shape":"Se"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"Se"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"Sd"},"NextToken":{}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S1j"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S1j"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S1r"}}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S1y"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S22"},"configHistoryDeliveryInfo":{"shape":"S22"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S1y"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S28"}}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"Se"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S2c"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"Se"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S2c"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S2j"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S2l"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S2j"}}}}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S2l"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"type":"map","key":{},"value":{}},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"type":"map","key":{},"value":{}}}}},"nextToken":{}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S14"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S1r"}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S28"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"S3z"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"S3z"}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}}},"shapes":{"Sd":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"Sk"}}},"Sk":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S14":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner","SourceIdentifier"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{}}},"S1j":{"type":"list","member":{}},"S1r":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"type":"list","member":{}}}}}},"S1y":{"type":"list","member":{}},"S22":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S28":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S2c":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{}}},"OrderingTimestamp":{"type":"timestamp"}}},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S2j":{"type":"structure","members":{"CompliantResourceCount":{"shape":"Sk"},"NonCompliantResourceCount":{"shape":"Sk"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S2l":{"type":"list","member":{}},"S3z":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}}}}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"}}}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}}}}}}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{}}}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sv"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1b"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S1v"},"unmeteredRemoteAccessDevices":{"shape":"S1v"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"Sy"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S24"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S28"},"incompatibleDevices":{"shape":"S28"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S2e"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S2l"},"nextPeriod":{"shape":"S2l"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sv"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S32"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S3a"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S3d"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1b"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S1b"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sb"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"Sy"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S2e"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S48"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S2p"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Sm"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"Sv"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S32"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S3a"}},"nextToken":{}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S3d"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S54"},"job":{"shape":"S54"},"suite":{"shape":"S54"},"test":{"shape":"S54"},"device":{"shape":"Sy"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S1b"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S48"}}}},"RenewOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S48"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","devicePoolArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"name":{},"test":{"shape":"S24"},"configuration":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"customerArtifactPaths":{"shape":"S34"},"radios":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"auxiliaryApps":{"type":"list","member":{}},"billingMethod":{}}},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S32"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"Sv"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S32"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sb"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"Si"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Sm"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sb":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"}}},"Si":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Sm":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"}}},"Sv":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"Sy"},"remoteDebugEnabled":{"type":"boolean"},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S16"},"endpoint":{},"deviceUdid":{}}},"Sy":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{}}},"S16":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1b":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{},"metadata":{},"contentType":{},"message":{}}},"S1v":{"type":"map","key":{},"value":{"type":"integer"}},"S24":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S28":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"Sy"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S2e":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2f"},"message":{},"device":{"shape":"Sy"},"deviceMinutes":{"shape":"S16"}}},"S2f":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S2l":{"type":"map","key":{},"value":{"shape":"S2n"}},"S2n":{"type":"structure","members":{"type":{},"offering":{"shape":"S2p"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S2p":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S2t"},"frequency":{}}}}}},"S2t":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S32":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2f"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S16"},"networkProfile":{"shape":"Si"},"parsingResultUrl":{},"resultCode":{},"customerArtifactPaths":{"shape":"S34"}}},"S34":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S3a":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2f"},"message":{},"deviceMinutes":{"shape":"S16"}}},"S3d":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S2f"},"message":{},"deviceMinutes":{"shape":"S16"}}},"S48":{"type":"structure","members":{"offeringStatus":{"shape":"S2n"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S2t"}}},"S54":{"type":"structure","members":{"arn":{},"name":{}}}}}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"S7"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"}}},"output":{"shape":"S7"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{}}}}},"output":{"shape":"Sp"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"Sv"}}}}},"output":{"shape":"Sp"}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"S7"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"S7"}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"Sp"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","virtualGatewayId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"Sp"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{}}},"output":{"shape":"S7"}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{}}},"output":{"shape":"S1j"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{}}},"output":{"shape":"S1o"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn","virtualGatewayId"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{}}}}},"output":{"shape":"Sp"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"Sv"}}}}},"output":{"shape":"Sp"}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"Sp"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S7"}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S1o"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S28"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S2b"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S2b"},"deprecated":true},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S2b"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S28"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S1j"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S1o"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S28"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{}}}}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"S2x"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"Sp"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"S7"}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S2x"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"}}},"output":{"shape":"S1o"}}},"shapes":{"S7":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{}}},"Sp":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"virtualGatewayId":{},"routeFilterPrefixes":{"shape":"Sv"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{}}}}}},"Sv":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S1j":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{}}},"S1o":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{},"connections":{"shape":"S1q"},"allowsHostedConnections":{"type":"boolean"}}},"S1q":{"type":"list","member":{"shape":"S7"}},"S28":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S2b":{"type":"structure","members":{"connections":{"shape":"S1q"}}},"S2x":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"Sr"}},"UnprocessedKeys":{"shape":"S2"},"ConsumedCapacity":{"shape":"St"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S10"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S10"},"ItemCollectionMetrics":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1a"}}},"ConsumedCapacity":{"shape":"St"}}}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema","ProvisionedThroughput"],"members":{"AttributeDefinitions":{"shape":"S1f"},"TableName":{},"KeySchema":{"shape":"S1j"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S1j"},"Projection":{"shape":"S1o"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection","ProvisionedThroughput"],"members":{"IndexName":{},"KeySchema":{"shape":"S1j"},"Projection":{"shape":"S1o"},"ProvisionedThroughput":{"shape":"S1u"}}}},"ProvisionedThroughput":{"shape":"S1u"},"StreamSpecification":{"shape":"S1w"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S20"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S2e"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S2m"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S20"}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S20"}}}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}},"output":{"type":"structure","members":{"Item":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3a"},"NextToken":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S14"},"Expected":{"shape":"S2e"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S2m"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S3k"}},"QueryFilter":{"shape":"S3l"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S2m"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S3l"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S2m"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S3a"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Action":{}}}},"Expected":{"shape":"S2e"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S2m"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S1f"},"TableName":{},"ProvisionedThroughput":{"shape":"S1u"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName","ProvisionedThroughput"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S1u"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection","ProvisionedThroughput"],"members":{"IndexName":{},"KeySchema":{"shape":"S1j"},"Projection":{"shape":"S1o"},"ProvisionedThroughput":{"shape":"S1u"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S1w"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S20"}}}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"S4a"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"S4a"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}},"S6":{"type":"map","key":{},"value":{"shape":"S8"}},"S8":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S8"}},"L":{"type":"list","member":{"shape":"S8"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"shape":"Ss"}},"Ss":{"type":"map","key":{},"value":{"shape":"S8"}},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"Table":{"shape":"Sw"},"LocalSecondaryIndexes":{"shape":"Sx"},"GlobalSecondaryIndexes":{"shape":"Sx"}}},"Sw":{"type":"structure","members":{"CapacityUnits":{"type":"double"}}},"Sx":{"type":"map","key":{},"value":{"shape":"Sw"}},"S10":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S14"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"S14":{"type":"map","key":{},"value":{"shape":"S8"}},"S1a":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S8"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1f":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S1j":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S1o":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S1u":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S1w":{"type":"structure","members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S20":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S1f"},"TableName":{},"KeySchema":{"shape":"S1j"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S23"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S1j"},"Projection":{"shape":"S1o"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S1j"},"Projection":{"shape":"S1o"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S23"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"StreamSpecification":{"shape":"S1w"},"LatestStreamLabel":{},"LatestStreamArn":{}}},"S23":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S2e":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S2i"}}}},"S2i":{"type":"list","member":{"shape":"S8"}},"S2m":{"type":"map","key":{},"value":{"shape":"S8"}},"S3a":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3k":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S2i"},"ComparisonOperator":{}}},"S3l":{"type":"map","key":{},"value":{"shape":"S3k"}},"S4a":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sb","locationName":"vpcPeeringConnection"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"Domain":{"locationName":"domain"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone","InstanceType","Quantity"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"Quantity":{"locationName":"quantity","type":"integer"}}},"output":{"type":"structure","members":{"HostIds":{"shape":"St","locationName":"hostIdSet"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sv","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"Sv","locationName":"assignedIpv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"Sy","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S13"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S15","locationName":"iamInstanceProfileAssociation"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId","SubnetId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["Ipv6CidrBlock","SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1c","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1h","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S1k","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S1m","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S1s"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S1w","locationName":"attachment"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S1z","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S1z"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S2b"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S2f","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S2f","locationName":"bundleInstanceTask"}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2q","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"S32","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","required":["CurrentSpotFleetRequestState","PreviousSpotFleetRequestState","SpotFleetRequestId"],"members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","required":["Error","SpotFleetRequestId"],"members":{"Error":{"locationName":"error","type":"structure","required":["Code","Message"],"members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S3c","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl"},"SourceRegion":{},"SourceSnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["BgpAsn","PublicIp","Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{"locationName":"IpAddress"},"Type":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"S3s","locationName":"customerGateway"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S3v","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"shape":"S32","locationName":"Value"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"S44","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"S4b","locationName":"egressOnlyInternetGateway"}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["DeliverLogsPermissionArn","LogGroupName","ResourceIds","ResourceType","TrafficType"],"members":{"ClientToken":{},"DeliverLogsPermissionArn":{},"LogGroupName":{},"ResourceIds":{"shape":"S32","locationName":"ResourceId"},"ResourceType":{},"TrafficType":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"S32","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"S4j","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"S4n"},"LogsStorageLocation":{"shape":"S4n"},"Description":{},"Name":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"S4q","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"S51","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"S57","locationName":"internetGateway"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"locationName":"keyMaterial"},"KeyName":{"locationName":"keyName"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["AllocationId","SubnetId"],"members":{"AllocationId":{},"ClientToken":{},"SubnetId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"S5c","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"S5j","locationName":"networkAcl"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S5o","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"S5p","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S5t","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S5u","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S5w","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"S5z","locationName":"networkInterface"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"S6d","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","required":["GroupName","Strategy"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2q","locationName":"reservedInstancesListingsSet"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"S6q","locationName":"routeTable"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S72"}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"S76","locationName":"spotDatafeedSubscription"}}}},"CreateSubnet":{"input":{"type":"structure","required":["CidrBlock","VpcId"],"members":{"AvailabilityZone":{},"CidrBlock":{},"Ipv6CidrBlock":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S7b","locationName":"subnet"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"S7f","locationName":"ResourceId"},"Tags":{"shape":"Sl","locationName":"Tag"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S7h","locationName":"TagSpecification"}}},"output":{"shape":"S7k"}},"CreateVpc":{"input":{"type":"structure","required":["CidrBlock"],"members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S3v","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["ServiceName","VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"PolicyDocument":{},"RouteTableIds":{"shape":"S32","locationName":"RouteTableId"},"ServiceName":{},"VpcId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"VpcEndpoint":{"shape":"S7r","locationName":"vpcEndpoint"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sb","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type","VpnGatewayId"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelOptions":{"type":"list","member":{"locationName":"item","type":"structure","members":{"TunnelInsideCidr":{},"PreSharedKey":{}}}}}}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"S80","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"S8c","locationName":"vpnGateway"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"FlowLogIds":{"shape":"S32","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S4j","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"S7f","locationName":"resourceId"},"Tags":{"shape":"Sl","locationName":"tag"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"S32","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S4j","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"AllocationId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S2f","locationName":"item"}}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"S62","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"Sae","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"S3s","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"S44","locationName":"item"}}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"S4b","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"S51","locationName":"item"}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"Filter":{"shape":"S9m"},"FlowLogIds":{"shape":"S32","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sbi","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"Sbr","locationName":"Owner"},"Filters":{"shape":"S9m","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"Tags":{"shape":"Sl","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"S9m"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"S9m"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"Sca","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"S9m","locationName":"filter"},"HostIds":{"shape":"Scd","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"}}}},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S15","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Scu","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Scu","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"Sd1","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"Sd2","locationName":"launchPermission"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"Description":{"shape":"S48","locationName":"description"},"KernelId":{"shape":"S48","locationName":"kernel"},"RamdiskId":{"shape":"S48","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S48","locationName":"sriovNetSupport"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"S9m","locationName":"Filter"},"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Owners":{"shape":"Sbr","locationName":"Owner"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"Sd1","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sdf","locationName":"stateReason"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m"},"ImportTaskIds":{"shape":"Sdi","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Sdm","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m"},"ImportTaskIds":{"shape":"Sdi","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Sdt","locationName":"snapshotTaskDetail"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S62","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"Sdx","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"Se0","locationName":"disableApiTermination"},"EnaSupport":{"shape":"Se0","locationName":"enaSupport"},"EbsOptimized":{"shape":"Se0","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S48","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S48","locationName":"instanceType"},"KernelId":{"shape":"S48","locationName":"kernel"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"RamdiskId":{"shape":"S48","locationName":"ramdisk"},"RootDeviceName":{"shape":"S48","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"Se0","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"S48","locationName":"sriovNetSupport"},"UserData":{"shape":"S48","locationName":"userData"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"}}}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"Se8","locationName":"instanceState"},"InstanceStatus":{"shape":"Sea","locationName":"instanceStatus"},"SystemStatus":{"shape":"Sea","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"Sej","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"shape":"S32","locationName":"internetGatewayId"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"S57","locationName":"item"}}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"S32","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"Filter":{"shape":"S9m"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"shape":"S32","locationName":"NatGatewayId"},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"S5c","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"shape":"S32","locationName":"NetworkAclId"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"S5j","locationName":"item"}}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"S61","locationName":"attachment"},"Description":{"shape":"S48","locationName":"description"},"Groups":{"shape":"S62","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Se0","locationName":"sourceDestCheck"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"S9m","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"S6d","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"S5z","locationName":"item"}}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"}}}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"shape":"S32","locationName":"PrefixListId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"S32","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"}}}}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"Sga","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"Sgi","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"Sl","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S2q","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"Sgv","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"S9m","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"Sgi","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"shape":"S32","locationName":"RouteTableId"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"S6q","locationName":"item"}}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"Shf","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Shm","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","required":["GroupId","ReferencingVpcId"],"members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"GroupIds":{"shape":"S1m","locationName":"GroupId"},"GroupNames":{"shape":"Sht","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S1z","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S1z","locationName":"ipPermissionsEgress"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"Si0","locationName":"createVolumePermission"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"Sbr","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"locationName":"SnapshotId","type":"list","member":{"locationName":"SnapshotId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"S72","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"S76","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","required":["ActiveInstances","SpotFleetRequestId"],"members":{"ActiveInstances":{"locationName":"activeInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","required":["HistoryRecords","LastEvaluatedTime","SpotFleetRequestId","StartTime"],"members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","required":["EventInformation","EventType","Timestamp"],"members":{"EventInformation":{"locationName":"eventInformation","type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"S32","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","required":["SpotFleetRequestConfigs"],"members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","required":["CreateTime","SpotFleetRequestConfig","SpotFleetRequestId","SpotFleetRequestState"],"members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"Sip","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S3c","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Sj4","locationName":"spotInstanceRequestSet"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","required":["GroupId"],"members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"Sjl","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"Sjl","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"S7b","locationName":"item"}}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"Se0","locationName":"autoEnableIO"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"Sk2","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"VolumeIds":{"shape":"Sk2","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"S7k","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"Sk2","locationName":"VolumeId"},"Filters":{"shape":"S9m","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"Skl","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"Se0","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"Se0","locationName":"enableDnsSupport"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"Skr","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"Skr"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ServiceNames":{"shape":"S32","locationName":"serviceNameSet"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S9m","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcEndpointIds":{"shape":"S32","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"S7r","locationName":"item"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"shape":"S32","locationName":"VpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"Sb","locationName":"item"}}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"S3v","locationName":"item"}}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"S80","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"S9m","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"S8c","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S1s"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S15","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1c","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S1h","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S1k","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"Smd"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"Smf","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"Sml","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"Sml","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"Sml","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"Sml","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"Sms"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{},"UserBucket":{"shape":"Smv"}}}},"DryRun":{"type":"boolean"},"Hypervisor":{},"LicenseType":{},"Platform":{},"RoleName":{}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Sdm","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"Sn0"},"Volume":{"shape":"Sn1"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"S5t","locationName":"GroupId"},"GroupNames":{"shape":"Sn3","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"Sep","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}}}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sae","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"Sms"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{},"UserBucket":{"shape":"Smv"}}},"DryRun":{"type":"boolean"},"RoleName":{}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Sdt","locationName":"snapshotTaskDetail"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"Sn0","locationName":"image"},"Volume":{"shape":"Sn1","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sae","locationName":"conversionTask"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"Sng","locationName":"UserId"},"UserGroups":{"shape":"Snh","locationName":"UserGroup"},"ProductCodes":{"shape":"Sni","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"Snk"},"Remove":{"shape":"Snk"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sbi","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["AutoPlacement","HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"Scd","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"St","locationName":"successful"},"Unsuccessful":{"shape":"Snp","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"S48"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"Sd2"},"Remove":{"shape":"Sd2"}}},"OperationType":{},"ProductCodes":{"shape":"Sni","locationName":"ProductCode"},"UserGroups":{"shape":"Snh","locationName":"UserGroup"},"UserIds":{"shape":"Sng","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"Se0"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"Se0","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"Se0","locationName":"ebsOptimized"},"EnaSupport":{"shape":"Se0","locationName":"enaSupport"},"Groups":{"shape":"S1m","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S48","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S48","locationName":"instanceType"},"Kernel":{"shape":"S48","locationName":"kernel"},"Ramdisk":{"shape":"S48","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S48","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"S48","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S5t","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Se0","locationName":"sourceDestCheck"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"Sga","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"Sgv","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"Si0"},"Remove":{"shape":"Si0"}}},"GroupNames":{"shape":"Sht","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"Sng","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"Se0"},"MapPublicIpOnLaunch":{"shape":"Se0"},"SubnetId":{"locationName":"subnetId"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"Skl","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"Se0"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"Se0"},"EnableDnsSupport":{"shape":"Se0"},"VpcId":{"locationName":"vpcId"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"AddRouteTableIds":{"shape":"S32","locationName":"AddRouteTableId"},"DryRun":{"type":"boolean"},"PolicyDocument":{},"RemoveRouteTableIds":{"shape":"S32","locationName":"RemoveRouteTableId"},"ResetPolicy":{"type":"boolean"},"VpcEndpointId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"Sok"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"Sok"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"Som","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"Som","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"Sos","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"Smd"},"LimitPrice":{},"OfferingId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"Smf","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Shm","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S4q","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"Scd","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"St","locationName":"successful"},"Unsuccessful":{"shape":"Snp","locationName":"unsuccessful"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S13"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S15","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S5o","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"S5p","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"Sa6","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"Sip","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","required":["SpotFleetRequestId"],"members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","required":["SpotPrice"],"members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S32","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"S32","locationName":"SecurityGroup"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sd1","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S13","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"Sj7","locationName":"monitoring"},"NetworkInterfaces":{"shape":"Siv","locationName":"NetworkInterface"},"Placement":{"shape":"Six","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Sj4","locationName":"spotInstanceRequestSet"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S1z","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S1z"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RunInstances":{"input":{"type":"structure","required":["ImageId","MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"S4q","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"S5u","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"Sj7"},"Placement":{"shape":"Sep"},"RamdiskId":{},"SecurityGroupIds":{"shape":"S5t","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Sn3","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S13","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"Siv","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{}}}},"TagSpecifications":{"shape":"S7h","locationName":"TagSpecification"}}},"output":{"shape":"Sej"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"Sql","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"Sql","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}}},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"Sqw","locationName":"instancesSet"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"Sqw","locationName":"instancesSet"}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"Sqw","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["Ipv6Addresses","NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"Sv","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"Sv","locationName":"unassignedIpv6Addresses"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId","PrivateIpAddresses"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"Sy","locationName":"privateIpAddress"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sa6","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"Sos","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S1z"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S1z"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"S5":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"Sb":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"Sc","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"Sc","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"Sc":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"}}},"Sl":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"St":{"type":"list","member":{"locationName":"item"}},"Sv":{"type":"list","member":{"locationName":"item"}},"Sy":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S13":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S15":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S16","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S16":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S1c":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S1h":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S1i","locationName":"ipv6CidrBlockState"}}},"S1i":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S1k":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S1i","locationName":"cidrBlockState"}}},"S1m":{"type":"list","member":{"locationName":"groupId"}},"S1s":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"S1w":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S1z":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S28","locationName":"item"}}}}},"S28":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S2b":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature"}}}}},"S2f":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S2b","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S2q":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sl","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S32":{"type":"list","member":{"locationName":"item"}},"S3c":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S3s":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S3v":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S1h","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S1k","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S44":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"S48","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S48":{"type":"structure","members":{"Value":{"locationName":"value"}}},"S4b":{"type":"structure","members":{"Attachments":{"shape":"S4c","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"}}},"S4c":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"S4j":{"type":"list","member":{"shape":"S4k","locationName":"item"}},"S4k":{"type":"structure","required":["Error"],"members":{"Error":{"locationName":"error","type":"structure","required":["Code","Message"],"members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"S4n":{"type":"structure","members":{"Bucket":{},"Key":{}}},"S4q":{"type":"list","member":{"shape":"S4r","locationName":"BlockDeviceMapping"}},"S4r":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"}}},"NoDevice":{"locationName":"noDevice"}}},"S51":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S57":{"type":"structure","members":{"Attachments":{"shape":"S4c","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S5c":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"locationName":"natGatewayAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"}}}},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S5j":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"S5o","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"S5p","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S5o":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"S5p":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"S5t":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S5u":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"S5w":{"type":"list","member":{"locationName":"item","type":"structure","required":["PrivateIpAddress"],"members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"S5z":{"type":"structure","members":{"Association":{"shape":"S60","locationName":"association"},"Attachment":{"shape":"S61","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"Groups":{"shape":"S62","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S60","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S60":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"S61":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"}}},"S62":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"S6d":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S6q":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"Tags":{"shape":"Sl","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"S72":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S76":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"S77","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"S77":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S7b":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S1c","locationName":"item"}},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S7f":{"type":"list","member":{}},"S7h":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sl","locationName":"Tag"}}}},"S7k":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S1s","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"}}},"S7r":{"type":"structure","members":{"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"S32","locationName":"routeTableIdSet"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcId":{"locationName":"vpcId"}}},"S80":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"Sl","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}}}},"S8c":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S1w","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"S9m":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"S32","locationName":"Value"}}}},"Sa6":{"type":"list","member":{"locationName":"InstanceId"}},"Sae":{"type":"structure","required":["ConversionTaskId","State"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","required":["Volumes"],"members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","required":["AvailabilityZone","BytesConverted","Image","Status","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Saj","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"Sak","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","required":["AvailabilityZone","BytesConverted","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Saj","locationName":"image"},"Volume":{"shape":"Sak","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sl","locationName":"tagSet"}}},"Saj":{"type":"structure","required":["Format","ImportManifestUrl","Size"],"members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"Sak":{"type":"structure","required":["Id"],"members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"Sbi":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"}}},"Sbm":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"Sbr":{"type":"list","member":{"locationName":"Owner"}},"Sca":{"type":"list","member":{"locationName":"item"}},"Scd":{"type":"list","member":{"locationName":"item"}},"Scu":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"Sd1":{"type":"list","member":{"shape":"S4r","locationName":"item"}},"Sd2":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Sdf":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sdi":{"type":"list","member":{"locationName":"ImportTaskId"}},"Sdm":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Sdo","locationName":"userBucket"}}}},"Sdo":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"Sdt":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Sdo","locationName":"userBucket"}}},"Sdx":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"}}}}}},"Se0":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"Se8":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"Sea":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"Sej":{"type":"structure","members":{"Groups":{"shape":"S62","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"Sen","locationName":"monitoring"},"Placement":{"shape":"Sep","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"Sbm","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"Se8","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Sdx","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S16","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Sev","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"}}},"Description":{"locationName":"description"},"Groups":{"shape":"S62","locationName":"groupSet"},"Ipv6Addresses":{"shape":"S5u","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Sev","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"}}}},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"S62","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sdf","locationName":"stateReason"},"Tags":{"shape":"Sl","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"Sen":{"type":"structure","members":{"State":{"locationName":"state"}}},"Sep":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"}}},"Sev":{"type":"structure","members":{"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Sga":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"Sgi":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"Sgv":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"Shf":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"Shm":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"Shf","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"Sht":{"type":"list","member":{"locationName":"GroupName"}},"Si0":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Sip":{"type":"structure","required":["IamFleetRole","LaunchSpecifications","SpotPrice","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"S62","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sd1","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S13","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"Siv","locationName":"networkInterfaceSet"},"Placement":{"shape":"Six","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sl","locationName":"tag"}}}}}}},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}},"Siv":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S5t","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S5u","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S5w","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}}},"Six":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"Sj4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"S77","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"locationName":"userData"},"SecurityGroups":{"shape":"S62","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Sd1","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S13","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"Siv","locationName":"networkInterfaceSet"},"Placement":{"shape":"Six","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"Sj7","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"Sl","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"Sj7":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Sjl":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S28","locationName":"item"}}}}},"Sk2":{"type":"list","member":{"locationName":"VolumeId"}},"Skl":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"Skr":{"type":"list","member":{"locationName":"VpcId"}},"Smd":{"type":"list","member":{"locationName":"item"}},"Smf":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"Sca","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"Sml":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"Sms":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"Smv":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"Sn0":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"}}},"Sn1":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"Sn3":{"type":"list","member":{"locationName":"SecurityGroup"}},"Sng":{"type":"list","member":{"locationName":"UserId"}},"Snh":{"type":"list","member":{"locationName":"UserGroup"}},"Sni":{"type":"list","member":{"locationName":"ProductCode"}},"Snk":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"Snp":{"type":"list","member":{"shape":"S4k","locationName":"item"}},"Sok":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"Som":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"Sos":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"Sen","locationName":"monitoring"}}}},"Sql":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sqw":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"Se8","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"Se8","locationName":"previousState"}}}}}}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"result_key":"DhcpOptions"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeImages":{"result_key":"Images"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"result_key":"InternetGateways"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"result_key":"NetworkAcls"},"DescribeNetworkInterfaces":{"result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribeRegions":{"result_key":"Regions"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"result_key":"RouteTables"},"DescribeSecurityGroups":{"result_key":"SecurityGroups"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeSubnets":{"result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVpcPeeringConnections":{"result_key":"VpcPeeringConnections"},"DescribeVpcs":{"result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"}}}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"ecr","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repository":{"shape":"S13"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S13"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S1p"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S13"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S1p"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageTag":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{}}},"S13":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"}}},"S1p":{"type":"list","member":{}}}}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"S4"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName","taskDefinition","desiredCount"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"S7"},"desiredCount":{"type":"integer"},"clientToken":{},"role":{},"deploymentConfiguration":{"shape":"Sa"},"placementConstraints":{"shape":"Sb"},"placementStrategy":{"shape":"Se"}}},"output":{"type":"structure","members":{"service":{"shape":"Si"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"Sp"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sp"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"S4"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{}}},"output":{"type":"structure","members":{"service":{"shape":"Si"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S10"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1b"}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"S16"}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"S4"}},"failures":{"shape":"S2a"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"S16"}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S2e"},"failures":{"shape":"S2a"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"S16"}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"Si"}},"failures":{"shape":"S2a"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1b"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"S16"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S2m"},"failures":{"shape":"S2a"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sp"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"S16"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"S16"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"S16"},"nextToken":{}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"S16"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"S16"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"S16"},"nextToken":{}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"Sp"}}},"output":{"type":"structure","members":{"attributes":{"shape":"Sp"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S13"},"versionInfo":{"shape":"S12"},"containerInstanceArn":{},"attributes":{"shape":"Sp"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S10"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S1c"},"volumes":{"shape":"S1z"},"placementConstraints":{"shape":"S24"}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S1b"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S2o"},"count":{"type":"integer"},"startedBy":{},"group":{},"placementConstraints":{"shape":"Sb"},"placementStrategy":{"shape":"Se"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S2m"},"failures":{"shape":"S2a"}}}},"StartTask":{"input":{"type":"structure","required":["taskDefinition","containerInstances"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S2o"},"containerInstances":{"shape":"S16"},"startedBy":{},"group":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S2m"},"failures":{"shape":"S2a"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S2n"}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S2t"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S10"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"S16"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S2e"},"failures":{"shape":"S2a"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sa"}}},"output":{"type":"structure","members":{"service":{"shape":"Si"}}}}},"shapes":{"S4":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"}}},"S7":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"Sa":{"type":"structure","members":{"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"}}},"Sb":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"Se":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"Si":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"S7"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sa"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"Sb"},"placementStrategy":{"shape":"Se"}}},"Sp":{"type":"list","member":{"shape":"Sq"}},"Sq":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S10":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"version":{"type":"long"},"versionInfo":{"shape":"S12"},"remainingResources":{"shape":"S13"},"registeredResources":{"shape":"S13"},"status":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"Sp"},"registeredAt":{"type":"timestamp"}}},"S12":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S13":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"S16"}}}},"S16":{"type":"list","member":{}},"S1b":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S1c"},"family":{},"taskRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S1z"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"Sq"}},"placementConstraints":{"shape":"S24"}}},"S1c":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"S16"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"S16"},"command":{"shape":"S16"},"environment":{"shape":"S1h"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"S16"},"drop":{"shape":"S16"}}}}},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"S16"},"dnsSearchDomains":{"shape":"S16"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"S16"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}}}}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"S1z":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}}}}},"S24":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S2a":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{}}}},"S2e":{"type":"list","member":{"shape":"S10"}},"S2m":{"type":"list","member":{"shape":"S2n"}},"S2n":{"type":"structure","members":{"taskArn":{},"clusterArn":{},"taskDefinitionArn":{},"containerInstanceArn":{},"overrides":{"shape":"S2o"},"lastStatus":{},"desiredStatus":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S2t"}}}},"startedBy":{},"version":{"type":"long"},"stoppedReason":{},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"stoppedAt":{"type":"timestamp"},"group":{}}},"S2o":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"S16"},"environment":{"shape":"S1h"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"}}}},"taskRoleArn":{}}},"S2t":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}}}}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"So"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"Sr"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S19"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1d"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1f"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"Sl"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"Sk","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"Sr"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"Su","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S19","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S2h"},"CacheNodeTypeSpecificParameters":{"shape":"S2k"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S1f","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2h"},"CacheNodeTypeSpecificParameters":{"shape":"S2k"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"S1m","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S38","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S3a"}},"wrapper":true}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sd","locationName":"Snapshot"}}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"type":"list","member":{}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"Sy"},"AZMode":{},"NewAvailabilityZones":{"shape":"So"},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S3q"}}},"output":{"shape":"S3s","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1d"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1f"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"CacheSecurityGroupNames":{"shape":"Sp"},"SecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"NodeGroupId":{}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S38"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"Sy"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"Su"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S3q"}}},"output":{"shape":"S3s","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1m"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}}},"wrapper":true},"Sd":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"Sk"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}}},"wrapper":true},"Sk":{"type":"structure","members":{"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"Sl"}}},"Sl":{"type":"list","member":{"locationName":"AvailabilityZone"}},"So":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"Sp":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sr":{"type":"list","member":{"locationName":"SnapshotArn"}},"Su":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"Sv"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"Sy"},"EngineVersion":{},"CacheNodeType":{}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"Sy"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"Sv"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{}},"wrapper":true},"Sv":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"Sy":{"type":"list","member":{"locationName":"CacheNodeId"}},"S19":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1d":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1f":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true}}}}},"wrapper":true},"S1m":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"Sv"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"Sv"},"PreferredAvailabilityZone":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"ConfigurationEndpoint":{"shape":"Sv"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{}},"wrapper":true},"S2h":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S2k":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S38":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S3a"}},"wrapper":true},"S3a":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3q":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S3s":{"type":"structure","members":{"CacheParameterGroupName":{}}}}}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"}}}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Si","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S17"}}},"output":{"shape":"S1d","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1i"},"SourceBundle":{"shape":"S1m"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"}}},"output":{"shape":"S1u","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S1z"}}},"output":{"shape":"S25","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S11"},"Tags":{"type":"list","member":{"shape":"S29"}},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"Sk","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1m"},"EnvironmentName":{},"OptionSettings":{"shape":"S1z"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2i"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2i"}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1f"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S1v"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1e"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2c"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S25"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S3y"},"ApplicationMetrics":{"shape":"S40"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Si","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S3y"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S40"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2o"},"SupportedAddonList":{"shape":"S2q"}}}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2i"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S6q"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sk","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1d","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S1u","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"S25","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S11"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S1z"},"OptionsToRemove":{"shape":"S2c"}}},"output":{"shape":"Sk","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S6q"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S1z"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Si":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sk"}},"NextToken":{}}},"Sk":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S11"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{}}},"S11":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S17":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1d":{"type":"structure","members":{"Application":{"shape":"S1e"}}},"S1e":{"type":"structure","members":{"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1f"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S17"}}},"S1f":{"type":"list","member":{}},"S1i":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1m":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S1u":{"type":"structure","members":{"ApplicationVersion":{"shape":"S1v"}}},"S1v":{"type":"structure","members":{"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1i"},"BuildArn":{},"SourceBundle":{"shape":"S1m"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S1z":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S25":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S1z"}}},"S29":{"type":"structure","members":{"Key":{},"Value":{}}},"S2c":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2i":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2o"},"SupportedAddonList":{"shape":"S2q"}}},"S2o":{"type":"list","member":{}},"S2q":{"type":"list","member":{}},"S3y":{"type":"list","member":{}},"S40":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S6q":{"type":"list","member":{"shape":"S29"}}}}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"}}}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"output":{"shape":"S6"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"Si"}}},"output":{"shape":"Sk"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"So"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"type":"list","member":{}}}}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"S6"}},"NextMarker":{}}}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"Si"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"Sk"}},"NextMarker":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"So"},"NextMarker":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"Si"}}}}},"shapes":{"S6":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"Si":{"type":"list","member":{}},"Sk":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{}}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","Protocol","Port","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"Sq"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"Su"},"SubnetMappings":{"shape":"Sw"},"SecurityGroups":{"shape":"Sz"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S15"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S1l"},"Priority":{"type":"integer"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name","Protocol","Port","VpcId"],"members":{"Name":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S24"},"TargetType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S28"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"Sq"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S33"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S2a"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S15"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S1s"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S3u"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S28"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S2l"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"Sq"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S33"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S33"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S1l"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S24"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S28"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S3u"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S3u"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S2k"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S1s"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"Sz"}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"Sz"}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn","Subnets"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"Su"},"SubnetMappings":{"shape":"Sw"}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S1e"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Type","TargetGroupArn"],"members":{"Type":{},"TargetGroupArn":{}}}},"Sq":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sl"}}}},"Su":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{}}}},"Sz":{"type":"list","member":{}},"S15":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S1e"},"SecurityGroups":{"shape":"Sz"},"IpAddressType":{}}}},"S1e":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"type":"list","member":{}}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S1l"},"Actions":{"shape":"Sl"},"IsDefault":{"type":"boolean"}}}},"S24":{"type":"structure","required":["HttpCode"],"members":{"HttpCode":{}}},"S28":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S24"},"LoadBalancerArns":{"shape":"S2a"},"TargetType":{}}}},"S2a":{"type":"list","member":{}},"S2k":{"type":"list","member":{"shape":"S2l"}},"S2l":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S33":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S3u":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon Elastic MapReduce","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","timestampFormat":"unixTimestamp","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"Sq"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1b"}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1k"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","members":{"ClusterId":{},"StepIds":{"shape":"S1k"}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2b"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2b"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S2c"},"AdditionalSlaveSecurityGroups":{"shape":"S2c"}}},"InstanceCollectionType":{},"LogUri":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S2f"},"Tags":{"shape":"S1n"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Sh"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1i"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S2u"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1c"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S31"}}}},"SupportedProducts":{"shape":"S33"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S39"},"ActionOnFailure":{},"Status":{"shape":"S3a"}}}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S2c"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"NormalizedInstanceHours":{"type":"integer"}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S41"},"EbsOptimized":{"type":"boolean"}}}},"LaunchSpecifications":{"shape":"Sk"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S41"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S4d"},"AutoScalingPolicy":{"shape":"S4h"}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1i"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S39"},"ActionOnFailure":{},"Status":{"shape":"S3a"}}}},"Marker":{}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S4d"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"Su"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S4h"}}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S2c"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"Sq"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S2u"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2b"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S5n"},"AdditionalSlaveSecurityGroups":{"shape":"S5n"}}},"Steps":{"shape":"S1b"},"BootstrapActions":{"type":"list","member":{"shape":"S31"}},"SupportedProducts":{"shape":"S33"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1i"}}}},"Applications":{"shape":"S2f"},"Configurations":{"shape":"Sh"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1n"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{}}},"output":{"type":"structure","members":{"JobFlowId":{}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1i"},"TerminationProtected":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1i"},"VisibleToAllUsers":{"type":"boolean"}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1i"}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Sh"}}}},"LaunchSpecifications":{"shape":"Sk"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Sh"},"Properties":{"shape":"Sj"}}}},"Sj":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["SpotSpecification"],"members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"}}}}},"Sq":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Sh"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"Su"}}}},"Su":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"Sv":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1i"}}}}},"S1i":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S25":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S2b":{"type":"list","member":{}},"S2c":{"type":"list","member":{}},"S2f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S2c"},"AdditionalInfo":{"shape":"Sj"}}}},"S2u":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2b"}}},"S31":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1i"}}}}},"S33":{"type":"list","member":{}},"S39":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sj"},"MainClass":{},"Args":{"shape":"S2c"}}},"S3a":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S41":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S4d":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S4f"},"InstancesToProtect":{"shape":"S4f"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S4f":{"type":"list","member":{}},"S4h":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"S5n":{"type":"list","member":{}}}}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"}}}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"elastictranscoder-2012-09-25","apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","signatureVersion":"v4"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"St"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S11"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S1t"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2m"},"Rules":{"shape":"S2o"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S11"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2m"},"Rules":{"shape":"S2o"}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S2z"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S34"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S2z"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S2z"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3j"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S2z"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S1t"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S2z"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3j"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"St"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2m"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S4m"}}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S4y"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S4y"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S4m"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5d"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S5k"},"ReplacementTags":{"shape":"S5d"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S5k"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S5s"},"Body":{"type":"structure","members":{"Text":{"shape":"S5s"},"Html":{"shape":"S5s"}}}}},"ReplyToAddresses":{"shape":"S4m"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5d"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S4m"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5d"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S5k"},"ReplyToAddresses":{"shape":"S4m"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5d"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S11"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S1t"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S34"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"St":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S11":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S1t":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2m":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2o":{"type":"list","member":{"shape":"S11"}},"S2z":{"type":"list","member":{}},"S34":{"type":"list","member":{}},"S3j":{"type":"list","member":{}},"S4m":{"type":"list","member":{}},"S4y":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5d":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5k":{"type":"structure","members":{"ToAddresses":{"shape":"S4m"},"CcAddresses":{"shape":"S4m"},"BccAddresses":{"shape":"S4m"}}},"S5s":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeEventBus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{}}}},"NextToken":{}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"Ss"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"type":"list","member":{}},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"Action":{},"Principal":{},"StatementId":{}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"Targets":{"shape":"Ss"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"Ids":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}}},"shapes":{"Ss":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"}}}}}}}}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"S3DestinationConfiguration":{"shape":"S7","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"Password":{"shape":"S13"},"RetryOptions":{"shape":"S14"},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","DomainARN","IndexName","TypeName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3BackupMode":{},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S1z"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S1z"}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"RetryOptions":{"shape":"S14"},"S3DestinationDescription":{"shape":"S1z"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S1z"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S1z"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"GetKinesisStream":{"input":{"type":"structure","required":["DeliveryStreamARN"],"members":{"DeliveryStreamARN":{}}},"output":{"type":"structure","members":{"KinesisStreamARN":{},"CredentialsForReadingKinesisStream":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}},"internalonly":true},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S2e"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S2e"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S2r","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S2r"}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"Sy"},"Username":{"shape":"S12"},"Password":{"shape":"S13"},"RetryOptions":{"shape":"S14"},"S3Update":{"shape":"S2r"},"ProcessingConfiguration":{"shape":"Sn"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S2r"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S1c"},"RetryOptions":{"shape":"S1f"},"S3Update":{"shape":"S2r"},"ProcessingConfiguration":{"shape":"Sn"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"Sa":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Se":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Si":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"Sn":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sy":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S12":{"type":"string","sensitive":true},"S13":{"type":"string","sensitive":true},"S14":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S1c":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S1f":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S1z":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}},"S2e":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S2r":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"BufferingHints":{"shape":"Sa"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Se"},"CloudWatchLoggingOptions":{"shape":"Si"}}}}}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"type":"list","member":{}},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sa"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sf"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sk"},"OperatingSystem":{}}},"output":{"type":"structure","members":{"Build":{"shape":"So"},"UploadCredentials":{"shape":"Ss"},"StorageLocation":{"shape":"Sk"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","BuildId","EC2InstanceType"],"members":{"Name":{},"Description":{},"BuildId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"Su"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"Sw"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S12"},"ResourceCreationLimitPolicy":{"shape":"S18"},"MetricGroups":{"shape":"S1a"},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S1d"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S1g"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1n"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1t"},"Destinations":{"shape":"S1v"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S1y"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","GameSessionQueueArns","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S20"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1g"},"GameSessionData":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S27"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S2b"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S2f"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{}},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2m"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S2p"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sf"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"So"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3d"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S1d"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3d"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}}}}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{}}}},"NextToken":{}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"InboundPermissions":{"shape":"Sw"}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3d"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"}}}},"NextToken":{}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S1n"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S42"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S1y"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4f"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"shape":"S4n"}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"S4q"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"shape":"S4n"},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S27"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S2b"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2m"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S12"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{}}}},"NextToken":{}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S2p"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Sf"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"So"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"shape":"S3d"},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","ScalingAdjustment","ScalingAdjustmentType","Threshold","ComparisonOperator","EvaluationPeriods","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{}}},"output":{"type":"structure","members":{"Name":{}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"Ss"},"StorageLocation":{"shape":"Sk"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4f"},"NextToken":{}}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S1g"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S44"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S42"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"S4t"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S4q"}}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S42"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sa"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sf"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"So"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S18"},"MetricGroups":{"shape":"S1a"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"Sw"},"InboundPermissionRevocations":{"shape":"Sw"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1n"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1t"},"Destinations":{"shape":"S1v"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S1y"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S20"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1g"},"GameSessionData":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S27"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S12"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S12"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"Sa":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Sf":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"Sa"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Sk":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{}}},"So":{"type":"structure","members":{"BuildId":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"}}},"Ss":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"Su":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"IpRange":{},"Protocol":{}}}},"S12":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S18":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S1a":{"type":"list","member":{}},"S1d":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"Su"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S18"},"MetricGroups":{"shape":"S1a"}}},"S1g":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1n":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"GameProperties":{"shape":"S1g"},"IpAddress":{},"Port":{"type":"integer"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{}}},"S1t":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S1v":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S1y":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1t"},"Destinations":{"shape":"S1v"}}},"S20":{"type":"list","member":{}},"S27":{"type":"structure","members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S20"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S1g"},"GameSessionData":{}}},"S2b":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S2f":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{},"GameSessionId":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{},"Port":{"type":"integer"},"PlayerData":{}}},"S2m":{"type":"list","member":{"shape":"S2f"}},"S2p":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S3d":{"type":"list","member":{}},"S42":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S1g"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S44"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{},"Port":{"type":"integer"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}},"GameSessionData":{}}},"S44":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S4f":{"type":"list","member":{"shape":"S1n"}},"S4n":{"type":"list","member":{}},"S4q":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"S4t"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"S4t":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"shape":"Su"},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}}}}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName","resourceGroupArn"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sm"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","resourceGroupArn","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sv"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S26"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sv"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sm"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sv"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S2q"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S2q"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S36"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S3a"},"rulesPackageArns":{"shape":"S3b"},"startTimeRange":{"shape":"S3c"},"completionTimeRange":{"shape":"S3c"},"stateChangeTimeRange":{"shape":"S3c"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S3e"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S3e"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S36"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S3a"},"rulesPackageArns":{"shape":"S3b"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S3e"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S36"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S3b"},"attributes":{"shape":"S26"},"userAttributes":{"shape":"S26"},"creationTimeRange":{"shape":"S3c"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S3e"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S3e"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S44"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"agentId":{},"autoScalingGroup":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S44"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName","resourceGroupArn"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sv":{"type":"list","member":{}},"S26":{"type":"list","member":{"shape":"S5"}},"S2q":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S36":{"type":"list","member":{}},"S3a":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S3b":{"type":"list","member":{}},"S3c":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S3e":{"type":"list","member":{}},"S44":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","signatureVersion":"v4","signingName":"execute-api","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}}},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}}}}},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"Sw"}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"S14"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S1b"}},"payload":"topicRulePayload"}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{}}}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}}}}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingTypeName":{},"attributes":{"shape":"Sx"},"version":{"type":"long"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeProperties":{"shape":"S14"},"thingTypeMetadata":{"shape":"S3x"}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}}},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"S1e"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{}}}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"S4u"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"S4u"},"nextMarker":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"S54"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"S58"},"nextMarker":{}}}},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"S54"},"nextMarker":{}}}},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{}},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"S58"}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeProperties":{"shape":"S14"},"thingTypeMetadata":{"shape":"S3x"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"attributes":{"shape":"Sx"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate","verificationCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S1b"}},"payload":"topicRulePayload"}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"Sw"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sw":{"type":"structure","members":{"attributes":{"shape":"Sx"},"merge":{"type":"boolean"}}},"Sx":{"type":"map","key":{},"value":{}},"S14":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"S1b":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"S1e"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{}}},"S1e":{"type":"list","member":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}}}}},"S3x":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"S4u":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"S54":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"S58":{"type":"list","member":{}}}}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"iot-data-2015-05-28","apiVersion":"2015-05-28","endpointPrefix":"data.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","signatureVersion":"v4","signingName":"iotdata"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"payload":{"type":"blob"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["StreamName","Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}}}}},"CreateStream":{"input":{"type":"structure","required":["StreamName","ShardCount"],"members":{"StreamName":{},"ShardCount":{"type":"integer"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"DeleteStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"Shards":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"Su"}}}},"EncryptionType":{},"KeyId":{}}}}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Su"}}},"output":{"shape":"Sz"}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Su"}}},"output":{"shape":"Sz"}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamName","ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"}}}},"ListTagsForStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}}},"MergeShards":{"input":{"type":"structure","required":["StreamName","ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{}}}},"PutRecord":{"input":{"type":"structure","required":["StreamName","Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}}},"PutRecords":{"input":{"type":"structure","required":["Records","StreamName"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["StreamName","TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}}}}},"SplitShard":{"input":{"type":"structure","required":["StreamName","ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{}}}},"StartStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"StopStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"UpdateShardCount":{"input":{"type":"structure","required":["StreamName","TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"}}}}},"shapes":{"Su":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"Su"},"DesiredShardLevelMetrics":{"shape":"Su"}}}}}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreams":{"input_token":"ExclusiveStartStreamName","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"StreamNames[-1]","result_key":"StreamNames"}}}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"S8"},"Constraints":{"shape":"Sa"},"GrantTokens":{"shape":"Se"},"Name":{}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"Origin":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"Su"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S14"}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"Su"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S14"},"EncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sb"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S14"},"KeyId":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sb"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S14"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S14"},"ParametersValidTo":{"type":"timestamp"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{}}},"output":{"shape":"S25"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sp"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S25"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Sb"},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Sb"},"GrantTokens":{"shape":"Se"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"Sp"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}}},"shapes":{"S8":{"type":"list","member":{}},"Sa":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Sb"},"EncryptionContextEquals":{"shape":"Sb"}}},"Sb":{"type":"map","key":{},"value":{}},"Se":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"Su":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"ExpirationModel":{},"KeyManager":{}}},"S14":{"type":"blob","sensitive":true},"S25":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"S8"},"Constraints":{"shape":"Sa"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"}}}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{}}},"output":{"shape":"Sg"}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["EventSourceArn","FunctionName","StartingPosition"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"}}},"output":{"shape":"Sn"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Runtime","Role","Handler","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"St"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S10"},"DeadLetterConfig":{"shape":"S15"},"Environment":{"shape":"S17"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1c"},"Tags":{"shape":"S1e"}}},"output":{"shape":"S1h"}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sn"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"Sg"}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sn"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S1h"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}},"Tags":{"shape":"S1e"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S1h"}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"St"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"St"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"Sg"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"Sn"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S2r"}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1e"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S2r"}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{}}},"output":{"shape":"S1h"}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S1e"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{}}},"output":{"shape":"Sg"}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"}}},"output":{"shape":"Sn"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"St"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"shape":"S1h"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S10"},"Environment":{"shape":"S17"},"Runtime":{},"DeadLetterConfig":{"shape":"S15"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1c"}}},"output":{"shape":"S1h"}}},"shapes":{"Sg":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{}}},"Sn":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSourceArn":{},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{}}},"St":{"type":"blob","sensitive":true},"S10":{"type":"structure","members":{"SubnetIds":{"shape":"S11"},"SecurityGroupIds":{"shape":"S13"}}},"S11":{"type":"list","member":{}},"S13":{"type":"list","member":{}},"S15":{"type":"structure","members":{"TargetArn":{}}},"S17":{"type":"structure","members":{"Variables":{"shape":"S18"}}},"S18":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S1c":{"type":"structure","members":{"Mode":{}}},"S1e":{"type":"map","key":{},"value":{}},"S1h":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S11"},"SecurityGroupIds":{"shape":"S13"},"VpcId":{}}},"DeadLetterConfig":{"shape":"S15"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S18"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"type":"string","sensitive":true}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{}}},"S2r":{"type":"list","member":{"shape":"S1h"}}}}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"}}}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Sh"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sp"},"sampleUtterances":{"shape":"Sx"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Sh"},"followUpPrompt":{"shape":"Sy"},"conclusionStatement":{"shape":"Sh"},"dialogCodeHook":{"shape":"Sz"},"fulfillmentActivity":{"shape":"S12"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S18"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Sh"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S23"}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S23"}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2b"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2b"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2h"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2h"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2h"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sp"},"sampleUtterances":{"shape":"Sx"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Sh"},"followUpPrompt":{"shape":"Sy"},"conclusionStatement":{"shape":"Sh"},"dialogCodeHook":{"shape":"Sz"},"fulfillmentActivity":{"shape":"S12"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S33"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S33"},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S18"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3b"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3b"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Sh"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Sh"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sp"},"sampleUtterances":{"shape":"Sx"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Sh"},"followUpPrompt":{"shape":"Sy"},"conclusionStatement":{"shape":"Sh"},"dialogCodeHook":{"shape":"Sz"},"fulfillmentActivity":{"shape":"S12"},"parentIntentSignature":{},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sp"},"sampleUtterances":{"shape":"Sx"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Sh"},"followUpPrompt":{"shape":"Sy"},"conclusionStatement":{"shape":"Sh"},"dialogCodeHook":{"shape":"Sz"},"fulfillmentActivity":{"shape":"S12"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S18"},"checksum":{},"valueSelectionStrategy":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S18"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{}}}},"Sh":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sp":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{}}}},"Sx":{"type":"list","member":{}},"Sy":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Sh"}}},"Sz":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S12":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"Sz"}}},"S18":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S23":{"type":"map","key":{},"value":{},"sensitive":true},"S2b":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S2h":{"type":"list","member":{}},"S33":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S3b":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}}}}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S22"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"Sx"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S22"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"Sx":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1v":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"}}}},"S22":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"machinelearning-2014-12-12","apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","serviceFullName":"Amazon Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","protocol":"json"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}},"examples":{}}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBatchPredictions":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"}}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteDashboards":{"input":{"type":"structure","members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"MetricAlarms":{"shape":"Sn"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"Sn"}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"GetDashboard":{"input":{"type":"structure","members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S10"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S10"}},"xmlOrder":["Namespace","MetricName","Dimensions"]}},"NextToken":{}},"xmlOrder":["Metrics","NextToken"]}},"PutDashboard":{"input":{"type":"structure","members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","MetricName","Namespace","Period","EvaluationPeriods","Threshold","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"Ss"},"AlarmActions":{"shape":"Ss"},"InsufficientDataActions":{"shape":"Ss"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S10"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sn":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"Ss"},"AlarmActions":{"shape":"Ss"},"InsufficientDataActions":{"shape":"Ss"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S10"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile"]}},"Ss":{"type":"list","member":{}},"S10":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}}}}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"MetricAlarms"},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Metrics"}}}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]}}}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sv"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sv"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1o"},"HIT":{"shape":"Sy"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sy"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1w"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1o"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S19"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sp"},"HITReviewPolicy":{"shape":"Sp"},"AssignmentReviewReport":{"shape":"S2q"},"HITReviewReport":{"shape":"S2q"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2c"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1w"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3j"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3j"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S19"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"type":"boolean"}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sp":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"Ss"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"Ss"}}}}}}}}},"Ss":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sy":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S19":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1o":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1w":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2c":{"type":"list","member":{"shape":"Sy"}},"S2q":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3j":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S46"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4v"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S46"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S4v"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S46":{"type":"structure","members":{"Monday":{"shape":"S47"},"Tuesday":{"shape":"S47"},"Wednesday":{"shape":"S47"},"Thursday":{"shape":"S47"},"Friday":{"shape":"S47"},"Saturday":{"shape":"S47"},"Sunday":{"shape":"S47"}}},"S47":{"type":"map","key":{},"value":{}},"S4v":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{},"Name":{"shape":"S2"}}},"LexiconAttributes":{"shape":"Si"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S2"},"Attributes":{"shape":"Si"}}}},"NextToken":{}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"},"Content":{}}},"output":{"type":"structure","members":{}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"LexiconNames":{"type":"list","member":{"shape":"S2"}},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"type":"list","member":{}},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"S2":{"type":"string","sensitive":true},"Si":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}}}}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sa"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Se"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sr"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sa"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S10"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sa"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sr"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S1w"},"VpcSecurityGroupIds":{"shape":"S1h"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sa"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sa"},"DBSubnetGroupName":{},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S10"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S2o"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S22"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"SourceIds":{"shape":"S6"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sv"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"locationName":"Certificate","type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{}},"wrapper":true}},"Marker":{}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sr","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S3q"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S3v"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"Sv","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S1j","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S49"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S49","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S1y","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S10","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S3q"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S4w"}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S13","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S22","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S57"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S57"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S3f"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S7"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S5","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S7"},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S7"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S3f"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S17","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S25","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S3f"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Se","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S6a","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S3f"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S6c"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S3f"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{}}}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S6r"},"ProvisionedIops":{"shape":"S6r"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}}}}}},"wrapper":true}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S3f"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sa"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S3q"}}},"output":{"shape":"S74","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S3y"},"ValuesToRemove":{"shape":"S3y"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S3v"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S1w"},"VpcSecurityGroupIds":{"shape":"S1h"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S3q"}}},"output":{"shape":"S7a","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S13"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S3y"},"ValuesToRemove":{"shape":"S3y"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S4w"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S2o"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S22"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S1w"},"VpcSecurityGroupMemberships":{"shape":"S1h"},"OptionSettings":{"type":"list","member":{"shape":"S1b","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S17"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S6a"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S3q"}}},"output":{"shape":"S74","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S3q"}}},"output":{"shape":"S7a","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sw"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S1j"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sa"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sa"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"Domain":{},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sk"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1y"}}}}},"shapes":{"S5":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S6"},"EventCategoriesList":{"shape":"S7"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S6":{"type":"list","member":{"locationName":"SourceId"}},"S7":{"type":"list","member":{"locationName":"EventCategory"}},"Sa":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Se":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Sr":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"Sv":{"type":"structure","members":{"AvailabilityZones":{"shape":"Sw"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"Sw":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S10":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S13":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"S17":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1b","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1c"},"VpcSecurityGroupMemberships":{"shape":"S1e"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1c":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1e":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1h":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1j":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"Sw"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1e"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"}},"wrapper":true},"S1w":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S1y":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1c"},"VpcSecurityGroups":{"shape":"S1e"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S22"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{}},"wrapper":true},"S22":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S25"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S25":{"type":"structure","members":{"Name":{}},"wrapper":true},"S2o":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S3f":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S3q":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3v":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S3y"}}}}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"AttributeValue"}},"S49":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S4w":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S3y"}},"wrapper":true}}},"wrapper":true},"S57":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S3q"}},"wrapper":true},"S6a":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S6c"},"ReservedDBInstanceArn":{}},"wrapper":true},"S6c":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S6r":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"S74":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"S7a":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]}}}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"S7"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S1g"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1m"},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S1o"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S1t"},"EventCategories":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S1w"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S1z"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S22"}}}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"S7"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S25"}}}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S7"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S2j"}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S1g","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S2q"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"S4","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sd","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S1o","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"Sv","locationName":"Cluster"}}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2q"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S1u"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S1w","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S1u"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S1z","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S22","locationName":"HsmConfiguration"}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S3x","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1r","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"type":"list","member":{"locationName":"ReservedNodeOffering","type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4c","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DescribeResizeResult","type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S25","locationName":"SnapshotCopyGrant"}}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"S4q","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S2j"},"TagValues":{"shape":"S2l"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"S8"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S3x","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier","BucketName"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{}}},"output":{"shape":"S3x","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser","ClusterIdentifier"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"type":"string","sensitive":true},"Expiration":{"type":"timestamp"}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"MasterUserPassword":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"St"},"RemoveIamRoles":{"shape":"St"}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S5b","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1m"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S1o"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S1t"},"EventCategories":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S1w"}}}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4c"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S5b","resultWrapper":"ResetClusterParameterGroupResult"}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"St"}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"S4q"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"S4"}}}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sd"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"Sv"}}}}},"shapes":{"S4":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"S7"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"S7"}}}},"Tags":{"shape":"S7"}},"wrapper":true},"S7":{"type":"list","member":{"shape":"S8","locationName":"Tag"}},"S8":{"type":"structure","members":{"Key":{},"Value":{}}},"Sd":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"S7"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"list","member":{"locationName":"IamRoleArn"}},"Sv":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"S7"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}}},"wrapper":true},"S1g":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S7"}},"wrapper":true},"S1m":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1r"},"SubnetStatus":{}}}},"Tags":{"shape":"S7"}},"wrapper":true},"S1r":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1t":{"type":"list","member":{"locationName":"SourceId"}},"S1u":{"type":"list","member":{"locationName":"EventCategory"}},"S1w":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S1t"},"EventCategoriesList":{"shape":"S1u"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"S7"}},"wrapper":true},"S1z":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"S7"}},"wrapper":true},"S22":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"S7"}},"wrapper":true},"S25":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"S7"}},"wrapper":true},"S2j":{"type":"list","member":{"locationName":"TagKey"}},"S2l":{"type":"list","member":{"locationName":"TagValue"}},"S2q":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S3x":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{}}},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4c":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S4q":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"S5b":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"}}}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"S2"},"TargetImage":{"shape":"S2"},"SimilarityThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Sf"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Sf"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{}}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"Sw"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"Sw"}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Attributes":{"shape":"S10"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S14"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"}}}},"OrientationCorrection":{}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{}}}}}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S1u"},"Name":{}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S10"}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S21"},"FaceDetail":{"shape":"S14"}}}},"OrientationCorrection":{}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S21"}},"NextToken":{}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S1u"},"Name":{},"Id":{},"Face":{"shape":"Sf"},"MatchConfidence":{"type":"float"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Sf"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S2j"}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sb"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S2j"}}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}}}},"Sb":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Sf":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"}}},"Sg":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sj":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"Sl":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S14":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"},"Confidence":{"type":"float"}}},"S1u":{"type":"list","member":{}},"S21":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sb"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"}}},"S2j":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S21"}}}}}}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"}}}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sh"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S15"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S1d"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S1y"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"S3"},"CallerReference":{},"HostedZoneConfig":{"shape":"S2e"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S2h"},"ChangeInfo":{"shape":"S8"},"DelegationSet":{"shape":"S2j"},"VPC":{"shape":"S3"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S2o"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S2j"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"S3"}}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S3y"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1y"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S49"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S49"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2h"},"DelegationSet":{"shape":"S2j"},"VPCs":{"shape":"S4h"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S2o"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S2j"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S2x"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S32"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S3y","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S1y","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S57"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S57"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S2o","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sh","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S2j","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S5n"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S5n","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S5y"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S5y"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S5y"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S2x","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S4h"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1p"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1r"},"AlarmIdentifier":{"shape":"S1t"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1y"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2h"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S2x"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S32"}}}}},"shapes":{"S3":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"S8":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sh":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{}}},"S15":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S1d":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1p"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1r"},"AlarmIdentifier":{"shape":"S1t"},"InsufficientDataHealthStatus":{}}},"S1p":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S1r":{"type":"list","member":{"locationName":"Region"}},"S1t":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S1y":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"HealthCheckConfig":{"shape":"S1d"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S2e":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S2h":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S2e"},"ResourceRecordSetCount":{"type":"long"}}},"S2j":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S2o":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S2x":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S32":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S3y":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S49":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S4h":{"type":"list","member":{"shape":"S3","locationName":"VPC"}},"S57":{"type":"list","member":{"shape":"S2h","locationName":"HostedZone"}},"S5n":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S15"}}},"S5y":{"type":"list","member":{"shape":"S32","locationName":"TrafficPolicyInstance"}}}}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","required":["Availability"],"members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"S7"}}},"output":{"type":"structure","required":["Transferability"],"members":{"Transferability":{"type":"structure","members":{"Transferable":{}}}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["DomainName","Nameservers","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"Nameservers":{"shape":"St"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{},"AbuseContactPhone":{},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"ListDomains":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Domains"],"members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Operations"],"members":{"Operations":{"type":"list","member":{"type":"structure","required":["OperationId","Status","Type","SubmittedDate"],"members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S29"}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{},"isAlreadyVerified":{"type":"boolean"}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["AuthCode"],"members":{"AuthCode":{"shape":"S7"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"St"},"AuthCode":{"shape":"S7"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true},"Nameservers":{"shape":"St"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S29"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"S7":{"type":"string","sensitive":true},"St":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"Sz":{"type":"structure","members":{"FirstName":{},"LastName":{},"ContactType":{},"OrganizationName":{},"AddressLine1":{},"AddressLine2":{},"City":{},"State":{},"CountryCode":{},"ZipCode":{},"PhoneNumber":{},"Email":{},"Fax":{},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}},"sensitive":true},"S29":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"}}}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"S5","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"S5","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"S8"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Sc","location":"header","locationName":"x-amz-lex-message"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"S8"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sf"},"requestAttributes":{"shape":"Sf"},"inputText":{"shape":"Sc"}}},"output":{"type":"structure","members":{"intentName":{},"slots":{"shape":"Sf"},"sessionAttributes":{"shape":"Sf"},"message":{"shape":"Sc"},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}}}}}},"shapes":{"S5":{"type":"string","sensitive":true},"S8":{"type":"blob","streaming":true},"Sc":{"type":"string","sensitive":true},"Sf":{"type":"map","key":{},"value":{},"sensitive":true}}}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","signatureVersion":"s3","timestampFormat":"rfc822","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1c","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy"},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket"},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"InitiateMultipartUpload"},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects"},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S2u"},"Grants":{"shape":"S2x","locationName":"AccessControlList"}}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S36"}},"payload":"AnalyticsConfiguration"}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S3m","locationName":"CORSRule"}}}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S3z"}},"payload":"InventoryConfiguration"}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S4c","locationName":"Rule"}}},"deprecated":true},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S4r","locationName":"Rule"}}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S51"}}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S59"}},"payload":"MetricsConfiguration"}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5c"},"output":{"shape":"S5d"},"deprecated":true},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5c"},"output":{"shape":"S5o"}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S67"}},"payload":"ReplicationConfiguration"}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Payer":{}}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3c"}}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S6o"},"IndexDocument":{"shape":"S6r"},"ErrorDocument":{"shape":"S6t"},"RoutingRules":{"shape":"S6u"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"}},"payload":"Body"}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S2u"},"Grants":{"shape":"S2x","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S3c"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S36"},"flattened":true}}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S3z"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S59"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Owner":{"shape":"S2u"}}},"alias":"GetService"},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S2u"},"Initiator":{"shape":"S8q"}}},"flattened":true},"CommonPrefixes":{"shape":"S8r"},"EncodingType":{}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S2u"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S2u"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S8r"},"EncodingType":{}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"S99"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S8r"},"EncodingType":{}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"S99"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"S8r"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"}}},"flattened":true},"Initiator":{"shape":"S8q"},"Owner":{"shape":"S2u"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}}},"payload":"AccelerateConfiguration"}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"S9r","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"AccessControlPolicy"}},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S36","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"AnalyticsConfiguration"}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S3m","locationName":"CORSRule"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"CORSConfiguration"}},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S3z","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"InventoryConfiguration"}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S4c","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"},"deprecated":true},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S4r","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"}},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S51"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"BucketLoggingStatus"}},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S59","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"MetricsConfiguration"}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"NotificationConfiguration":{"shape":"S5d","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"},"deprecated":true},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S5o","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Policy":{}},"payload":"Policy"}},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ReplicationConfiguration":{"shape":"S67","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"ReplicationConfiguration"}},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}}},"payload":"RequestPaymentConfiguration"}},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sab","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"}},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}}},"payload":"VersioningConfiguration"}},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S6t"},"IndexDocument":{"shape":"S6r"},"RedirectAllRequestsTo":{"shape":"S6o"},"RoutingRules":{"shape":"S6u"}}}},"payload":"WebsiteConfiguration"}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"S9r","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sab","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Days"],"members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"PostObjectRestore"},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1c","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"}}},"shapes":{"Sj":{"type":"string","sensitive":true},"S11":{"type":"map","key":{},"value":{}},"S19":{"type":"blob","sensitive":true},"S1c":{"type":"blob","sensitive":true},"S2u":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S2x":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S2z"},"Permission":{}}}},"S2z":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S36":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S39"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3c","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S39":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S3c":{"type":"list","member":{"shape":"S39","locationName":"Tag"}},"S3m":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S3z":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S4c":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S4e"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S4j"},"NoncurrentVersionTransition":{"shape":"S4l"},"NoncurrentVersionExpiration":{"shape":"S4m"},"AbortIncompleteMultipartUpload":{"shape":"S4n"}}},"flattened":true},"S4e":{"type":"structure","members":{"Date":{"shape":"S4f"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S4f":{"type":"timestamp","timestampFormat":"iso8601"},"S4j":{"type":"structure","members":{"Date":{"shape":"S4f"},"Days":{"type":"integer"},"StorageClass":{}}},"S4l":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{}}},"S4m":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"}}},"S4n":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S4r":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S4e"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S39"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3c","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S4j"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S4l"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S4m"},"AbortIncompleteMultipartUpload":{"shape":"S4n"}}},"flattened":true},"S51":{"type":"structure","members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S2z"},"Permission":{}}}},"TargetPrefix":{}}},"S59":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S39"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3c","flattened":true,"locationName":"Tag"}}}}}}},"S5c":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"S5d":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S5g","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5g","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5g","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S5g":{"type":"list","member":{},"flattened":true},"S5o":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S5g","locationName":"Event"},"Filter":{"shape":"S5r"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S5g","locationName":"Event"},"Filter":{"shape":"S5r"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S5g","locationName":"Event"},"Filter":{"shape":"S5r"}}},"flattened":true}}},"S5r":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S67":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Prefix","Status","Destination"],"members":{"ID":{},"Prefix":{},"Status":{},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"StorageClass":{}}}}},"flattened":true}}},"S6o":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S6r":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S6t":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S6u":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"S8q":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"S8r":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"S99":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Owner":{"shape":"S2u"}}},"flattened":true},"S9r":{"type":"structure","members":{"Grants":{"shape":"S2x","locationName":"AccessControlList"},"Owner":{"shape":"S2u"}}},"Sab":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3c"}}}}}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S12"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId","AccountId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{}}},"output":{"type":"structure","members":{}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","ProvisioningArtifactParameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S12"},"ProvisioningArtifactParameters":{"shape":"S1k"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"ProvisioningArtifactDetail":{"shape":"S1x"},"Tags":{"shape":"S1a"}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S1k"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S24"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId","AccountId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{}}},"output":{"type":"structure","members":{}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"},"TagOptions":{"shape":"S2o"}}}},"DescribeProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"ProvisioningArtifacts":{"shape":"S2r"}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S1n"}}}},"Tags":{"shape":"S1a"},"TagOptions":{"shape":"S2o"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"ProvisioningArtifacts":{"shape":"S2r"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S32"}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","required":["ProvisioningArtifactId","ProductId"],"members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"ConstraintSummaries":{"shape":"S3o"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S41"},"RecordOutputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"NextPageToken":{}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S24"}}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S4s"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"Sv"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S3o"},"Tags":{"shape":"S1a"},"Name":{}}}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S4s"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S4s"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S1x"}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S5g"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S41"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S2o"},"PageToken":{}}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Tags":{"shape":"S1a"},"NotificationArns":{"type":"list","member":{}},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S41"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S5g"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S32"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"S6e"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S1t"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"S6e"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S41"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"Sv"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S12"},"RemoveTags":{"shape":"S72"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S17"},"Tags":{"shape":"S1a"}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S12"},"RemoveTags":{"shape":"S72"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S1s"},"Tags":{"shape":"S1a"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S41"}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S1x"},"Info":{"shape":"S1n"},"Status":{}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S24"}}}}},"shapes":{"Sv":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{}}},"S12":{"type":"list","member":{"shape":"S13"}},"S13":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S17":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1a":{"type":"list","member":{"shape":"S13"}},"S1k":{"type":"structure","required":["Info"],"members":{"Name":{},"Description":{},"Info":{"shape":"S1n"},"Type":{}}},"S1n":{"type":"map","key":{},"value":{}},"S1s":{"type":"structure","members":{"ProductViewSummary":{"shape":"S1t"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"}}},"S1t":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S1x":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"}}},"S24":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{}}},"S2o":{"type":"list","member":{"shape":"S24"}},"S2r":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"S32":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{}}},"S3o":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S41":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S4s":{"type":"list","member":{"shape":"S17"}},"S5g":{"type":"structure","members":{"Key":{},"Value":{}}},"S6e":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S72":{"type":"list","member":{}}}}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"sns-2010-03-31","apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","signatureVersion":"v4","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"type":"map","key":{},"value":{}}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"type":"map","key":{},"value":{}}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S1n"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S1n"},"NextToken":{}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}}},"shapes":{"Sj":{"type":"map","key":{},"value":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}}}}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-11-05","endpointPrefix":"sqs","protocol":"query","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","signatureVersion":"v4","uid":"sqs-2012-11-05","xmlNamespace":"http://queue.amazonaws.com/doc/2012-11-05/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{"locationName":"AWSAccountId"},"flattened":true},"Actions":{"type":"list","member":{"locationName":"ActionName"},"flattened":true}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"resultWrapper":"ChangeMessageVisibilityBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}},"output":{"resultWrapper":"CreateQueueResult","type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"DeleteMessageBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"resultWrapper":"DeleteMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"DeleteMessageBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"St"}}},"output":{"resultWrapper":"GetQueueAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"resultWrapper":"GetQueueUrlResult","type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListDeadLetterSourceQueuesResult","type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"Sz"}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListQueueTagsResult","type":"structure","members":{"Tags":{"shape":"S12","locationName":"Tag"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{}}},"output":{"resultWrapper":"ListQueuesResult","type":"structure","members":{"QueueUrls":{"shape":"Sz"}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"St"},"MessageAttributeNames":{"type":"list","member":{"locationName":"MessageAttributeName"},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"resultWrapper":"ReceiveMessageResult","type":"structure","members":{"Messages":{"type":"list","member":{"locationName":"Message","type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"locationName":"Attribute","type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"SendMessageResult","type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"SendMessageBatchRequestEntry","type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"resultWrapper":"SendMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"SendMessageBatchResultEntry","type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"S12"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{"locationName":"TagKey"},"flattened":true}}}}},"shapes":{"Sd":{"type":"list","member":{"locationName":"BatchResultErrorEntry","type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sh":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Attribute"},"St":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"Sz":{"type":"list","member":{"locationName":"QueueUrl"},"flattened":true},"S12":{"type":"map","key":{"locationName":"Key"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Tag"},"S1g":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"flattened":true,"locationName":"StringListValue","type":"list","member":{"locationName":"StringListValue"}},"BinaryListValues":{"flattened":true,"locationName":"BinaryListValue","type":"list","member":{"locationName":"BinaryListValue","type":"blob"}},"DataType":{}}},"flattened":true}}}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListQueues":{"result_key":"QueueUrls"}}}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"Sq"},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S1l","locationName":"entries"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S17","locationName":"AssociationDescription"}},"Failed":{"type":"list","member":{"locationName":"FailedCreateAssociationEntry","type":"structure","members":{"Entry":{"shape":"S1l"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Name":{},"DocumentType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S1w"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S2f"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S2q"},"ApprovalRules":{"shape":"S2w"},"ApprovedPatches":{"shape":"S31"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S31"},"Description":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName","S3Destination"],"members":{"SyncName":{},"S3Destination":{"shape":"S38"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S3r"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S3r"},"InvalidParameters":{"shape":"S3r"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S50"}}}},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"S55"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"S5d"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S1w"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"S5u"}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"S5d"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"locationName":"InstanceInformationFilter","type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"S6k"}}}},"Filters":{"type":"list","member":{"locationName":"InstanceInformationStringFilter","type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"S6k"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"locationName":"InstanceInformation","type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sb"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"S74"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"S74"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"S55"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"S87"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"S76"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S76"},"Name":{},"Description":{"shape":"S2f"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"Su"},"TaskParameters":{"shape":"S8t"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"S8z"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S2f"}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"S7v"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2f"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"}}}},"NextToken":{}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"S9e"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"S55"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"S9v"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"S55"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"S9v"}}}},"NextToken":{}}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S50"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S50"}}}}}},"Parameters":{"shape":"S50"},"Outputs":{"shape":"S50"},"FailureMessage":{}}}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"Content":{},"DocumentType":{}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sav"},"ResultAttributes":{"type":"list","member":{"locationName":"ResultAttribute","type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"locationName":"Entity","type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sbe"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2f"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"S8t"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"S87"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"S76"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"S8t"},"TaskInvocationParameters":{"shape":"Sc5"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S8z"},"Name":{},"Description":{"shape":"S2f"}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Scn"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{},"AllowedPattern":{},"Version":{"type":"long"}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S3r"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Scv"},"InvalidParameters":{"shape":"S3r"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"S9e"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Scv"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S2q"},"ApprovalRules":{"shape":"S2w"},"ApprovedPatches":{"shape":"S31"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S31"},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"Sq"},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"locationName":"AssociationFilter","type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"locationName":"Association","type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"Su"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S1e"},"ScheduleExpression":{},"AssociationName":{}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sdi"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Sc7"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sdi"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"Sdy"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Se4"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"locationName":"Item","type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Sem"},"Details":{"shape":"Sep"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Se4"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"locationName":"Item","type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Seu"},"NonCompliantSummary":{"shape":"Sex"}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"locationName":"DocumentFilter","type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"locationName":"DocumentIdentifier","type":"structure","members":{"Name":{},"Owner":{},"PlatformTypes":{"shape":"S2a"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sav"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Sbe"},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Se4"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"locationName":"Item","type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Sem"},"CompliantSummary":{"shape":"Seu"},"NonCompliantSummary":{"shape":"Sex"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"S3Destination":{"shape":"S38"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"S5u"},"AccountIdsToRemove":{"shape":"S5u"}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Sem"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Sep"}}}},"ItemContentHash":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sbe"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value","Type"],"members":{"Name":{},"Description":{},"Value":{},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S76"},"Name":{},"Description":{"shape":"S2f"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","Targets","TaskArn","ServiceRoleArn","TaskType","MaxConcurrency","MaxErrors"],"members":{"WindowId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"S8t"},"TaskInvocationParameters":{"shape":"Sc5"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S8z"},"Name":{},"Description":{"shape":"S2f"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S50"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Su"},"DocumentName":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"Sq"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Sc7"}}},"output":{"type":"structure","members":{"Command":{"shape":"Sdy"}}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S50"},"ClientToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"Sq"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"Name":{},"Targets":{"shape":"Su"},"AssociationName":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S1a"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S17"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S1w"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{}}}}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S2f"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2f"},"Schedule":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S76"},"Name":{},"Description":{"shape":"S2f"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Su"},"OwnerInformation":{"shape":"S76"},"Name":{},"Description":{"shape":"S2f"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"S8t"},"TaskInvocationParameters":{"shape":"Sc5"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S8z"},"Name":{},"Description":{"shape":"S2f"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Su"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"S8t"},"TaskInvocationParameters":{"shape":"Sc5"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"S8z"},"Name":{},"Description":{"shape":"S2f"}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S2q"},"ApprovalRules":{"shape":"S2w"},"ApprovedPatches":{"shape":"S31"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S31"},"Description":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S2q"},"ApprovalRules":{"shape":"S2w"},"ApprovedPatches":{"shape":"S31"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S31"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{}},"Sq":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Su":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S10":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S17":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S1a"},"Overview":{"shape":"S1e"},"DocumentVersion":{},"Parameters":{"shape":"Sq"},"AssociationId":{},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{}}},"S1a":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S1e":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S1l":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"Sq"},"DocumentVersion":{},"Targets":{"shape":"Su"},"ScheduleExpression":{},"OutputLocation":{"shape":"S10"},"AssociationName":{}}},"S1w":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"locationName":"DocumentParameter","type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S2a"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"Tags":{"shape":"S4"}}},"S2a":{"type":"list","member":{"locationName":"PlatformType"}},"S2f":{"type":"string","sensitive":true},"S2q":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S2w":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup","ApproveAfterDays"],"members":{"PatchFilterGroup":{"shape":"S2q"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"}}}}}},"S31":{"type":"list","member":{}},"S38":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{}}},"S3r":{"type":"list","member":{}},"S50":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S55":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S5d":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{}}},"S5u":{"type":"list","member":{"locationName":"AccountId"}},"S6k":{"type":"list","member":{"locationName":"InstanceInformationFilterValue"}},"S74":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"OwnerInformation":{"shape":"S76"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{}}},"S76":{"type":"string","sensitive":true},"S7v":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S87":{"type":"string","sensitive":true},"S8t":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"S8z":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"S9e":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"S9v":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Sav":{"type":"list","member":{"locationName":"InventoryFilter","type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{"locationName":"FilterValue"}},"Type":{}}}},"Sbe":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Sc5":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"DocumentHash":{},"DocumentHashType":{},"NotificationConfig":{"shape":"Sc7"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"Sq"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S50"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Sc7":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Scn":{"type":"structure","members":{"Name":{},"Type":{},"Value":{},"Version":{"type":"long"}}},"Scv":{"type":"list","member":{"shape":"Scn"}},"Sdi":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sdy":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"Sq"},"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Su"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Sc7"}}},"Se4":{"type":"list","member":{"locationName":"ComplianceFilter","type":"structure","members":{"Key":{},"Values":{"type":"list","member":{"locationName":"FilterValue"}},"Type":{}}}},"Sem":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Sep":{"type":"map","key":{},"value":{}},"Seu":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sew"}}},"Sew":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Sex":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sew"}}}}}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"}}}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S15"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ClientList":{"shape":"S1d"},"Squash":{},"ReadOnly":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S1z"}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S2q"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S2y"},"CreatedDate":{"type":"timestamp"}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{},"InitiatorName":{},"SecretToAuthenticateTarget":{}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}}}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S15"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ClientList":{"shape":"S1d"},"Squash":{},"ReadOnly":{"type":"boolean"}}}}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S2q"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S2y"},"CreatedDate":{"type":"timestamp"}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S1z"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S1z"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sc"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"Sh"}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S1z"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"}}}}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{},"InitiatorName":{},"SecretToAuthenticateTarget":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour","DayOfWeek"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S15"},"DefaultStorageClass":{},"ClientList":{"shape":"S1d"},"Squash":{},"ReadOnly":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"Sc":{"type":"list","member":{}},"Sh":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S15":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1d":{"type":"list","member":{}},"S1z":{"type":"list","member":{}},"S2q":{"type":"list","member":{}},"S2y":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"Sy"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S15"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1a"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1f"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1i"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1p"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S1t"},"ChangeToken":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S1w"},"ChangeToken":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S23"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"Sy"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S15"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1a"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1f"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S3h"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S3h"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1i"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1p"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S1w"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S23"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S4n"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S4n"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S5t"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S17"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S5t"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1k"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1r"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S1y"}}}},"DefaultAction":{"shape":"S1t"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S25"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sy":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"Sz"},"RateKey":{},"RateLimit":{"type":"long"}}},"Sz":{"type":"list","member":{"shape":"S10"}},"S10":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S15":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S17"}}}},"S17":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1a":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1f":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"Sz"}}},"S1i":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1k"}}}},"S1k":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1p":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1r"}}}},"S1r":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S1t":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S1w":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S1t"},"Rules":{"type":"list","member":{"shape":"S1y"}}}},"S1y":{"type":"structure","required":["Priority","RuleId","Action"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S1t"},"Type":{}}},"S23":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S25"}}}},"S25":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3h":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S4n":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S5t":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S10"}}}}}}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"type":"string","sensitive":true}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"Sy"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S12"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S15"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1c"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1f"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1o"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1f","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserId":{"location":"querystring","locationName":"userId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"OrganizationId":{},"Initiator":{"shape":"S2b"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2b"}},"Groups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}},"ResourceMetadata":{"shape":"S2h"},"OriginalParent":{"shape":"S2h"},"CommentMetadata":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{}}}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S12"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2s"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S35"},"Documents":{"type":"list","member":{"shape":"S37"}},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1o"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S35"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"location":"querystring","locationName":"query","type":"string","sensitive":true},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S37"},"CustomMetadata":{"shape":"S15"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S3x"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2s"},"CustomMetadata":{"shape":"S15"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1c"},"CustomMetadata":{"shape":"S15"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S3x"}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S37"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S2x"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{},"Surname":{},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"Sy":{"type":"string","sensitive":true},"S12":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"Sy"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S15":{"type":"map","key":{},"value":{}},"S1c":{"type":"structure","members":{"Id":{},"Name":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1f"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1f":{"type":"list","member":{}},"S1o":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2b":{"type":"structure","members":{"Id":{},"Username":{},"GivenName":{},"Surname":{},"EmailAddress":{}}},"S2h":{"type":"structure","members":{"Type":{},"Name":{},"OriginalName":{},"Id":{},"VersionId":{},"Owner":{"shape":"S2b"},"ParentId":{}}},"S2s":{"type":"structure","members":{"Id":{},"Name":{},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S2x"}},"Source":{"type":"map","key":{},"value":{"shape":"S2x"}}}},"S2x":{"type":"string","sensitive":true},"S35":{"type":"list","member":{"shape":"S1c"}},"S37":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2s"},"ResourceState":{},"Labels":{"shape":"S1f"}}},"S3x":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}}}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['acm'] = {};
AWS.ACM = Service.defineService('acm', ['2015-12-08']);
Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
  get: function get() {
    var model = __webpack_require__(757);
    model.paginators = __webpack_require__(758).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ACM;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['apigateway'] = {};
AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
__webpack_require__(1008);
Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(759);
    model.paginators = __webpack_require__(760).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.APIGateway;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['applicationautoscaling'] = {};
AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
  get: function get() {
    var model = __webpack_require__(761);
    model.paginators = __webpack_require__(762).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ApplicationAutoScaling;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['autoscaling'] = {};
AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
  get: function get() {
    var model = __webpack_require__(763);
    model.paginators = __webpack_require__(764).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.AutoScaling;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
module.exports = {
  ACM: __webpack_require__(920),
  APIGateway: __webpack_require__(921),
  ApplicationAutoScaling: __webpack_require__(922),
  AutoScaling: __webpack_require__(923),
  CloudFormation: __webpack_require__(925),
  CloudFront: __webpack_require__(926),
  CloudHSM: __webpack_require__(927),
  CloudTrail: __webpack_require__(928),
  CloudWatch: __webpack_require__(929),
  CloudWatchEvents: __webpack_require__(930),
  CloudWatchLogs: __webpack_require__(931),
  CodeCommit: __webpack_require__(932),
  CodeDeploy: __webpack_require__(933),
  CodePipeline: __webpack_require__(934),
  CognitoIdentity: __webpack_require__(354),
  CognitoIdentityServiceProvider: __webpack_require__(935),
  CognitoSync: __webpack_require__(936),
  ConfigService: __webpack_require__(937),
  CUR: __webpack_require__(938),
  DeviceFarm: __webpack_require__(939),
  DirectConnect: __webpack_require__(940),
  DynamoDB: __webpack_require__(941),
  DynamoDBStreams: __webpack_require__(942),
  EC2: __webpack_require__(943),
  ECR: __webpack_require__(944),
  ECS: __webpack_require__(945),
  EFS: __webpack_require__(946),
  ElastiCache: __webpack_require__(947),
  ElasticBeanstalk: __webpack_require__(948),
  ELB: __webpack_require__(950),
  ELBv2: __webpack_require__(951),
  EMR: __webpack_require__(952),
  ElasticTranscoder: __webpack_require__(949),
  Firehose: __webpack_require__(953),
  GameLift: __webpack_require__(954),
  Inspector: __webpack_require__(955),
  Iot: __webpack_require__(956),
  IotData: __webpack_require__(957),
  Kinesis: __webpack_require__(958),
  KMS: __webpack_require__(959),
  Lambda: __webpack_require__(960),
  LexRuntime: __webpack_require__(962),
  MachineLearning: __webpack_require__(963),
  MarketplaceCommerceAnalytics: __webpack_require__(964),
  MTurk: __webpack_require__(966),
  MobileAnalytics: __webpack_require__(965),
  OpsWorks: __webpack_require__(967),
  Polly: __webpack_require__(968),
  RDS: __webpack_require__(969),
  Redshift: __webpack_require__(970),
  Rekognition: __webpack_require__(971),
  Route53: __webpack_require__(972),
  Route53Domains: __webpack_require__(973),
  S3: __webpack_require__(974),
  ServiceCatalog: __webpack_require__(975),
  SES: __webpack_require__(976),
  SNS: __webpack_require__(977),
  SQS: __webpack_require__(978),
  SSM: __webpack_require__(979),
  StorageGateway: __webpack_require__(980),
  STS: __webpack_require__(128),
  WAF: __webpack_require__(981),
  WorkDocs: __webpack_require__(982),
  LexModelBuildingService: __webpack_require__(961)
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudformation'] = {};
AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
  get: function get() {
    var model = __webpack_require__(765);
    model.paginators = __webpack_require__(766).pagination;
    model.waiters = __webpack_require__(767).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFormation;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudfront'] = {};
AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25']);
__webpack_require__(1009);
Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
  get: function get() {
    var model = __webpack_require__(768);
    model.paginators = __webpack_require__(769).pagination;
    model.waiters = __webpack_require__(770).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
  get: function get() {
    var model = __webpack_require__(771);
    model.paginators = __webpack_require__(772).pagination;
    model.waiters = __webpack_require__(773).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFront;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudhsm'] = {};
AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
  get: function get() {
    var model = __webpack_require__(774);
    model.paginators = __webpack_require__(775).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudHSM;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudtrail'] = {};
AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
  get: function get() {
    var model = __webpack_require__(776);
    model.paginators = __webpack_require__(777).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudTrail;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatch'] = {};
AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
  get: function get() {
    var model = __webpack_require__(865);
    model.paginators = __webpack_require__(866).pagination;
    model.waiters = __webpack_require__(867).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatch;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchevents'] = {};
AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
  get: function get() {
    var model = __webpack_require__(834);
    model.paginators = __webpack_require__(835).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchEvents;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchlogs'] = {};
AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
  get: function get() {
    var model = __webpack_require__(856);
    model.paginators = __webpack_require__(857).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchLogs;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codecommit'] = {};
AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
  get: function get() {
    var model = __webpack_require__(778);
    model.paginators = __webpack_require__(779).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeCommit;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codedeploy'] = {};
AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
  get: function get() {
    var model = __webpack_require__(780);
    model.paginators = __webpack_require__(781).pagination;
    model.waiters = __webpack_require__(782).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeDeploy;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codepipeline'] = {};
AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(783);
    model.paginators = __webpack_require__(784).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodePipeline;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentityserviceprovider'] = {};
AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
  get: function get() {
    var model = __webpack_require__(787);
    model.paginators = __webpack_require__(788).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentityServiceProvider;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitosync'] = {};
AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(789);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoSync;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['configservice'] = {};
AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
  get: function get() {
    var model = __webpack_require__(790);
    model.paginators = __webpack_require__(791).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ConfigService;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cur'] = {};
AWS.CUR = Service.defineService('cur', ['2017-01-06']);
Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
  get: function get() {
    var model = __webpack_require__(792);
    model.paginators = __webpack_require__(793).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CUR;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['devicefarm'] = {};
AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
  get: function get() {
    var model = __webpack_require__(794);
    model.paginators = __webpack_require__(795).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DeviceFarm;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['directconnect'] = {};
AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
  get: function get() {
    var model = __webpack_require__(796);
    model.paginators = __webpack_require__(797).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DirectConnect;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodb'] = {};
AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
__webpack_require__(1011);
Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
  get: function get() {
    var model = __webpack_require__(798);
    model.paginators = __webpack_require__(799).pagination;
    model.waiters = __webpack_require__(800).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(801);
    model.paginators = __webpack_require__(802).pagination;
    model.waiters = __webpack_require__(803).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDB;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodbstreams'] = {};
AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(912);
    model.paginators = __webpack_require__(913).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDBStreams;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ec2'] = {};
AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
__webpack_require__(1012);
Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
  get: function get() {
    var model = __webpack_require__(804);
    model.paginators = __webpack_require__(805).pagination;
    model.waiters = __webpack_require__(806).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EC2;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecr'] = {};
AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
  get: function get() {
    var model = __webpack_require__(807);
    model.paginators = __webpack_require__(808).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECR;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecs'] = {};
AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
  get: function get() {
    var model = __webpack_require__(809);
    model.paginators = __webpack_require__(810).pagination;
    model.waiters = __webpack_require__(811).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECS;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['efs'] = {};
AWS.EFS = Service.defineService('efs', ['2015-02-01']);
Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
  get: function get() {
    var model = __webpack_require__(817);
    model.paginators = __webpack_require__(818).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EFS;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticache'] = {};
AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
  get: function get() {
    var model = __webpack_require__(812);
    model.paginators = __webpack_require__(813).pagination;
    model.waiters = __webpack_require__(814).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElastiCache;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticbeanstalk'] = {};
AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(815);
    model.paginators = __webpack_require__(816).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticBeanstalk;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elastictranscoder'] = {};
AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
  get: function get() {
    var model = __webpack_require__(828);
    model.paginators = __webpack_require__(829).pagination;
    model.waiters = __webpack_require__(830).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticTranscoder;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elb'] = {};
AWS.ELB = Service.defineService('elb', ['2012-06-01']);
Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
  get: function get() {
    var model = __webpack_require__(819);
    model.paginators = __webpack_require__(820).pagination;
    model.waiters = __webpack_require__(821).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELB;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elbv2'] = {};
AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
  get: function get() {
    var model = __webpack_require__(822);
    model.paginators = __webpack_require__(823).pagination;
    model.waiters = __webpack_require__(824).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELBv2;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['emr'] = {};
AWS.EMR = Service.defineService('emr', ['2009-03-31']);
Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
  get: function get() {
    var model = __webpack_require__(825);
    model.paginators = __webpack_require__(826).pagination;
    model.waiters = __webpack_require__(827).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EMR;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['firehose'] = {};
AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
  get: function get() {
    var model = __webpack_require__(836);
    model.paginators = __webpack_require__(837).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Firehose;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['gamelift'] = {};
AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
  get: function get() {
    var model = __webpack_require__(838);
    model.paginators = __webpack_require__(839).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.GameLift;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['inspector'] = {};
AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
  get: function get() {
    var model = __webpack_require__(840);
    model.paginators = __webpack_require__(841).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Inspector;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iot'] = {};
AWS.Iot = Service.defineService('iot', ['2015-05-28']);
Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(842);
    model.paginators = __webpack_require__(843).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Iot;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iotdata'] = {};
AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
__webpack_require__(1013);
Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(844);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.IotData;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kinesis'] = {};
AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
  get: function get() {
    var model = __webpack_require__(845);
    model.paginators = __webpack_require__(846).pagination;
    model.waiters = __webpack_require__(847).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Kinesis;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kms'] = {};
AWS.KMS = Service.defineService('kms', ['2014-11-01']);
Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
  get: function get() {
    var model = __webpack_require__(848);
    model.paginators = __webpack_require__(849).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.KMS;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lambda'] = {};
AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
__webpack_require__(1014);
Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
  get: function get() {
    var model = __webpack_require__(850);
    model.paginators = __webpack_require__(851).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
  get: function get() {
    var model = __webpack_require__(852);
    model.paginators = __webpack_require__(853).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Lambda;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lexmodelbuildingservice'] = {};
AWS.LexModelBuildingService = Service.defineService('lexmodelbuildingservice', ['2017-04-19']);
Object.defineProperty(apiLoader.services['lexmodelbuildingservice'], '2017-04-19', {
  get: function get() {
    var model = __webpack_require__(854);
    model.paginators = __webpack_require__(855).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.LexModelBuildingService;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lexruntime'] = {};
AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
  get: function get() {
    var model = __webpack_require__(897);
    model.paginators = __webpack_require__(898).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.LexRuntime;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['machinelearning'] = {};
AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
__webpack_require__(1015);
Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
  get: function get() {
    var model = __webpack_require__(858);
    model.paginators = __webpack_require__(859).pagination;
    model.waiters = __webpack_require__(860).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MachineLearning;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['marketplacecommerceanalytics'] = {};
AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
  get: function get() {
    var model = __webpack_require__(861);
    model.paginators = __webpack_require__(862).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MarketplaceCommerceAnalytics;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mobileanalytics'] = {};
AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
  get: function get() {
    var model = __webpack_require__(864);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MobileAnalytics;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mturk'] = {};
AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
  get: function get() {
    var model = __webpack_require__(868);
    model.paginators = __webpack_require__(869).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MTurk;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['opsworks'] = {};
AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
  get: function get() {
    var model = __webpack_require__(870);
    model.paginators = __webpack_require__(871).pagination;
    model.waiters = __webpack_require__(872).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.OpsWorks;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['polly'] = {};
AWS.Polly = Service.defineService('polly', ['2016-06-10']);
__webpack_require__(1016);
Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
  get: function get() {
    var model = __webpack_require__(873);
    model.paginators = __webpack_require__(874).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Polly;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rds'] = {};
AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
__webpack_require__(1017);
Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
  get: function get() {
    var model = __webpack_require__(875);
    model.paginators = __webpack_require__(876).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
  get: function get() {
    var model = __webpack_require__(877);
    model.paginators = __webpack_require__(878).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
  get: function get() {
    var model = __webpack_require__(879);
    model.paginators = __webpack_require__(880).pagination;
    model.waiters = __webpack_require__(881).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
  get: function get() {
    var model = __webpack_require__(882);
    model.paginators = __webpack_require__(883).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
  get: function get() {
    var model = __webpack_require__(884);
    model.paginators = __webpack_require__(885).pagination;
    model.waiters = __webpack_require__(886).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.RDS;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['redshift'] = {};
AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
  get: function get() {
    var model = __webpack_require__(887);
    model.paginators = __webpack_require__(888).pagination;
    model.waiters = __webpack_require__(889).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Redshift;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rekognition'] = {};
AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
  get: function get() {
    var model = __webpack_require__(890);
    model.paginators = __webpack_require__(891).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Rekognition;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53'] = {};
AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
__webpack_require__(1018);
Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
  get: function get() {
    var model = __webpack_require__(892);
    model.paginators = __webpack_require__(893).pagination;
    model.waiters = __webpack_require__(894).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53domains'] = {};
AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
  get: function get() {
    var model = __webpack_require__(895);
    model.paginators = __webpack_require__(896).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53Domains;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['s3'] = {};
AWS.S3 = Service.defineService('s3', ['2006-03-01']);
__webpack_require__(1019);
Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
  get: function get() {
    var model = __webpack_require__(899);
    model.paginators = __webpack_require__(900).pagination;
    model.waiters = __webpack_require__(901).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.S3;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['servicecatalog'] = {};
AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
  get: function get() {
    var model = __webpack_require__(902);
    model.paginators = __webpack_require__(903).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ServiceCatalog;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ses'] = {};
AWS.SES = Service.defineService('ses', ['2010-12-01']);
Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(831);
    model.paginators = __webpack_require__(832).pagination;
    model.waiters = __webpack_require__(833).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SES;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sns'] = {};
AWS.SNS = Service.defineService('sns', ['2010-03-31']);
Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
  get: function get() {
    var model = __webpack_require__(904);
    model.paginators = __webpack_require__(905).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SNS;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sqs'] = {};
AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
__webpack_require__(1020);
Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
  get: function get() {
    var model = __webpack_require__(906);
    model.paginators = __webpack_require__(907).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SQS;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ssm'] = {};
AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
  get: function get() {
    var model = __webpack_require__(908);
    model.paginators = __webpack_require__(909).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SSM;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['storagegateway'] = {};
AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
  get: function get() {
    var model = __webpack_require__(910);
    model.paginators = __webpack_require__(911).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.StorageGateway;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['waf'] = {};
AWS.WAF = Service.defineService('waf', ['2015-08-24']);
Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
  get: function get() {
    var model = __webpack_require__(916);
    model.paginators = __webpack_require__(917).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WAF;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
var AWS = __webpack_require__(3);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['workdocs'] = {};
AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
  get: function get() {
    var model = __webpack_require__(918);
    model.paginators = __webpack_require__(919).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WorkDocs;


/***/ }),
/* 983 */
/***/ (function(module, exports) {

function apiLoader(svc, version) {
  if (!apiLoader.services.hasOwnProperty(svc)) {
    throw new Error('InvalidService: Failed to load api for ' + svc);
  }
  return apiLoader.services[svc][version];
}

/**
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */
apiLoader.services = {};
module.exports = apiLoader;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);

var AWS = __webpack_require__(3);

if (typeof window !== 'undefined') window.AWS = AWS;
if (true) module.exports = AWS;
if (typeof self !== 'undefined') self.AWS = AWS;

/**
 * @private
 * DO NOT REMOVE
 * browser builder will strip out this line if services are supplied on the command line.
 */
__webpack_require__(924);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3),
    url = AWS.util.url,
    crypto = AWS.util.crypto.lib,
    base64Encode = AWS.util.base64.encode,
    inherit = AWS.util.inherit;

var queryEncode = function (string) {
    var replacements = {
        '+': '-',
        '=': '_',
        '/': '~'
    };
    return string.replace(/[\+=\/]/g, function (match) {
        return replacements[match];
    });
};

var signPolicy = function (policy, privateKey) {
    var sign = crypto.createSign('RSA-SHA1');
    sign.write(policy);
    return queryEncode(sign.sign(privateKey, 'base64'))
};

var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
    var policy = JSON.stringify({
        Statement: [
            {
                Resource: url,
                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
            }
        ]
    });

    return {
        Expires: expires,
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy.toString(), privateKey)
    };
};

var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
    policy = policy.replace(/\s/mg, policy);

    return {
        Policy: queryEncode(base64Encode(policy)),
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy, privateKey)
    }
};

var determineScheme = function (url) {
    var parts = url.split('://');
    if (parts.length < 2) {
        throw new Error('Invalid URL.');
    }

    return parts[0].replace('*', '');
};

var getRtmpUrl = function (rtmpUrl) {
    var parsed = url.parse(rtmpUrl);
    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
};

var getResource = function (url) {
    switch (determineScheme(url)) {
        case 'http':
        case 'https':
            return url;
        case 'rtmp':
            return getRtmpUrl(url);
        default:
            throw new Error('Invalid URI scheme. Scheme must be one of'
                + ' http, https, or rtmp');
    }
};

var handleError = function (err, callback) {
    if (!callback || typeof callback !== 'function') {
        throw err;
    }

    callback(err);
};

var handleSuccess = function (result, callback) {
    if (!callback || typeof callback !== 'function') {
        return result;
    }

    callback(null, result);
};

AWS.CloudFront.Signer = inherit({
    /**
     * A signer object can be used to generate signed URLs and cookies for granting
     * access to content on restricted CloudFront distributions.
     *
     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
     *
     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
     *                              being used.
     * @param privateKey [String]   (Required) A private key in RSA format.
     */
    constructor: function Signer(keyPairId, privateKey) {
        if (keyPairId === void 0 || privateKey === void 0) {
            throw new Error('A key pair ID and private key are required');
        }

        this.keyPairId = keyPairId;
        this.privateKey = privateKey;
    },

    /**
     * Create a signed Amazon CloudFront Cookie.
     *
     * @param options [Object]            The options to create a signed cookie.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required unless you pass in a full
     *                                  policy.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the hash as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [Object] if called synchronously (with no callback), returns the
     *   signed cookie parameters.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedCookie: function (options, cb) {
        var signatureHash = 'policy' in options
            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);

        var cookieHash = {};
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                cookieHash['CloudFront-' + key] = signatureHash[key];
            }
        }

        return handleSuccess(cookieHash, cb);
    },

    /**
     * Create a signed Amazon CloudFront URL.
     *
     * Keep in mind that URLs meant for use in media/flash players may have
     * different requirements for URL formats (e.g. some require that the
     * extension be removed, some require the file name to be prefixed
     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
     *
     * @param options [Object]          The options to create a signed URL.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the URL as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [String] if called synchronously (with no callback), returns the
     *   signed URL.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedUrl: function (options, cb) {
        try {
            var resource = getResource(options.url);
        } catch (err) {
            return handleError(err, cb);
        }

        var parsedUrl = url.parse(options.url, true),
            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);

        parsedUrl.search = null;
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                parsedUrl.query[key] = signatureHash[key];
            }
        }

        try {
            var signedUrl = determineScheme(options.url) === 'rtmp'
                    ? getRtmpUrl(url.format(parsedUrl))
                    : url.format(parsedUrl);
        } catch (err) {
            return handleError(err, cb);
        }

        return handleSuccess(signedUrl, cb);
    }
});

module.exports = AWS.CloudFront.Signer;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
__webpack_require__(355);
__webpack_require__(356);
var PromisesDependency;

/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Defaults to the global
 *       agent (`http.globalAgent`) for non-SSL connections. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
 *       milliseconds of inactivity on the socket. Defaults to two minutes
 *       (120000)
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 */
AWS.Config = AWS.util.inherit({
  /**
   * @!endgroup
   */

  /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   */
  constructor: function Config(options) {
    if (options === undefined) options = {};
    options = this.extractCredentials(options);

    AWS.util.each.call(this, this.keys, function (key, value) {
      this.set(key, options[key], value);
    });
  },

  /**
   * @!group Managing Credentials
   */

  /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */
  getCredentials: function getCredentials(callback) {
    var self = this;

    function finish(err) {
      callback(err, err ? null : self.credentials);
    }

    function credError(msg, err) {
      return new AWS.util.error(err || new Error(), {
        code: 'CredentialsError',
        message: msg,
        name: 'CredentialsError'
      });
    }

    function getAsyncCredentials() {
      self.credentials.get(function(err) {
        if (err) {
          var msg = 'Could not load credentials from ' +
            self.credentials.constructor.name;
          err = credError(msg, err);
        }
        finish(err);
      });
    }

    function getStaticCredentials() {
      var err = null;
      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
        err = credError('Missing credentials');
      }
      finish(err);
    }

    if (self.credentials) {
      if (typeof self.credentials.get === 'function') {
        getAsyncCredentials();
      } else { // static credentials
        getStaticCredentials();
      }
    } else if (self.credentialProvider) {
      self.credentialProvider.resolve(function(err, creds) {
        if (err) {
          err = credError('Could not load credentials from any providers', err);
        }
        self.credentials = creds;
        finish(err);
      });
    } else {
      finish(credError('No credentials to load'));
    }
  },

  /**
   * @!group Loading and Setting Configuration Options
   */

  /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */
  update: function update(options, allowUnknownKeys) {
    allowUnknownKeys = allowUnknownKeys || false;
    options = this.extractCredentials(options);
    AWS.util.each.call(this, options, function (key, value) {
      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
          AWS.Service.hasService(key)) {
        this.set(key, value);
      }
    });
  },

  /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */
  loadFromPath: function loadFromPath(path) {
    this.clear();

    var options = JSON.parse(AWS.util.readFileSync(path));
    var fileSystemCreds = new AWS.FileSystemCredentials(path);
    var chain = new AWS.CredentialProviderChain();
    chain.providers.unshift(fileSystemCreds);
    chain.resolve(function (err, creds) {
      if (err) throw err;
      else options.credentials = creds;
    });

    this.constructor(options);

    return this;
  },

  /**
   * Clears configuration data on this object
   *
   * @api private
   */
  clear: function clear() {
    /*jshint forin:false */
    AWS.util.each.call(this, this.keys, function (key) {
      delete this[key];
    });

    // reset credential provider
    this.set('credentials', undefined);
    this.set('credentialProvider', undefined);
  },

  /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */
  set: function set(property, value, defaultValue) {
    if (value === undefined) {
      if (defaultValue === undefined) {
        defaultValue = this.keys[property];
      }
      if (typeof defaultValue === 'function') {
        this[property] = defaultValue.call(this);
      } else {
        this[property] = defaultValue;
      }
    } else if (property === 'httpOptions' && this[property]) {
      // deep merge httpOptions
      this[property] = AWS.util.merge(this[property], value);
    } else {
      this[property] = value;
    }
  },

  /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */
  keys: {
    credentials: null,
    credentialProvider: null,
    region: null,
    logger: null,
    apiVersions: {},
    apiVersion: null,
    endpoint: undefined,
    httpOptions: {
      timeout: 120000
    },
    maxRetries: undefined,
    maxRedirects: 10,
    paramValidation: true,
    sslEnabled: true,
    s3ForcePathStyle: false,
    s3BucketEndpoint: false,
    s3DisableBodySigning: true,
    computeChecksums: true,
    convertResponseTypes: true,
    correctClockSkew: false,
    customUserAgent: null,
    dynamoDbCrc32: true,
    systemClockOffset: 0,
    signatureVersion: null,
    signatureCache: true,
    retryDelayOptions: {},
    useAccelerateEndpoint: false
  },

  /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */
  extractCredentials: function extractCredentials(options) {
    if (options.accessKeyId && options.secretAccessKey) {
      options = AWS.util.copy(options);
      options.credentials = new AWS.Credentials(options);
    }
    return options;
  },

  /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */
  setPromisesDependency: function setPromisesDependency(dep) {
    PromisesDependency = dep;
    // if null was passed in, we should try to use native promises
    if (dep === null && typeof Promise === 'function') {
      PromisesDependency = Promise;
    }
    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
    AWS.util.addPromises(constructors, PromisesDependency);
  },

  /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */
  getPromisesDependency: function getPromisesDependency() {
    return PromisesDependency;
  }
});

/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */
AWS.config = new AWS.Config();


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var CognitoIdentity = __webpack_require__(354);
var STS = __webpack_require__(128);

/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */
AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * @api private
   */
  localStorageKey: {
    id: 'aws.cognito.identity-id.',
    providers: 'aws.cognito.identity-providers.'
  },

  /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */
  constructor: function CognitoIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.data = null;
    this._identityId = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
    this.loadCachedId();
    var self = this;
    Object.defineProperty(this, 'identityId', {
      get: function() {
        self.loadCachedId();
        return self._identityId || self.params.IdentityId;
      },
      set: function(identityId) {
        self._identityId = identityId;
      }
    });
  },

  /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    self.data = null;
    self._identityId = null;
    self.getId(function(err) {
      if (!err) {
        if (!self.params.RoleArn) {
          self.getCredentialsForIdentity(callback);
        } else {
          self.getCredentialsFromSTS(callback);
        }
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */
  clearCachedId: function clearCache() {
    this._identityId = null;
    delete this.params.IdentityId;

    var poolId = this.params.IdentityPoolId;
    var loginId = this.params.LoginId || '';
    delete this.storage[this.localStorageKey.id + poolId + loginId];
    delete this.storage[this.localStorageKey.providers + poolId + loginId];
  },

  /**
   * @api private
   */
  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
    var self = this;
    if (err.code == 'NotAuthorizedException') {
      self.clearCachedId();
    }
  },

  /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */
  getId: function getId(callback) {
    var self = this;
    if (typeof self.params.IdentityId === 'string') {
      return callback(null, self.params.IdentityId);
    }

    self.cognito.getId(function(err, data) {
      if (!err && data.IdentityId) {
        self.params.IdentityId = data.IdentityId;
        callback(null, data.IdentityId);
      } else {
        callback(err);
      }
    });
  },


  /**
   * @api private
   */
  loadCredentials: function loadCredentials(data, credentials) {
    if (!data || !credentials) return;
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
  },

  /**
   * @api private
   */
  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
    var self = this;
    self.cognito.getCredentialsForIdentity(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.data = data;
        self.loadCredentials(self.data, self);
      } else {
        self.clearIdOnNotAuthorized(err);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
    var self = this;
    self.cognito.getOpenIdToken(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.params.WebIdentityToken = data.Token;
        self.webIdentityCredentials.refresh(function(webErr) {
          if (!webErr) {
            self.data = self.webIdentityCredentials.data;
            self.sts.credentialsFrom(self.data, self);
          }
          callback(webErr);
        });
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * @api private
   */
  loadCachedId: function loadCachedId() {
    var self = this;

    // in the browser we source default IdentityId from localStorage
    if (AWS.util.isBrowser() && !self.params.IdentityId) {
      var id = self.getStorage('id');
      if (id && self.params.Logins) {
        var actualProviders = Object.keys(self.params.Logins);
        var cachedProviders =
          (self.getStorage('providers') || '').split(',');

        // only load ID if at least one provider used this ID before
        var intersect = cachedProviders.filter(function(n) {
          return actualProviders.indexOf(n) !== -1;
        });
        if (intersect.length !== 0) {
          self.params.IdentityId = id;
        }
      } else if (id) {
        self.params.IdentityId = id;
      }
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    var clientConfig = this._clientConfig;
    this.webIdentityCredentials = this.webIdentityCredentials ||
      new AWS.WebIdentityCredentials(this.params, clientConfig);
    if (!this.cognito) {
      var cognitoConfig = AWS.util.merge({}, clientConfig);
      cognitoConfig.params = this.params;
      this.cognito = new CognitoIdentity(cognitoConfig);
    }
    this.sts = this.sts || new STS(clientConfig);
  },

  /**
   * @api private
   */
  cacheId: function cacheId(data) {
    this._identityId = data.IdentityId;
    this.params.IdentityId = this._identityId;

    // cache this IdentityId in browser localStorage if possible
    if (AWS.util.isBrowser()) {
      this.setStorage('id', data.IdentityId);

      if (this.params.Logins) {
        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
      }
    }
  },

  /**
   * @api private
   */
  getStorage: function getStorage(key) {
    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
  },

  /**
   * @api private
   */
  setStorage: function setStorage(key, val) {
    try {
      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
    } catch (_) {}
  },

  /**
   * @api private
   */
  storage: (function() {
    try {
      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
          window.localStorage : {};

      // Test set/remove which would throw an error in Safari's private browsing
      storage['aws.test-storage'] = 'foobar';
      delete storage['aws.test-storage'];

      return storage;
    } catch (_) {
      return {};
    }
  })()
});


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var STS = __webpack_require__(128);

/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */
AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */
  constructor: function SAMLCredentials(params) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithSAML(function (err, data) {
      if (!err) {
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var STS = __webpack_require__(128);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function TemporaryCredentials(params, masterCredentials) {
    AWS.Credentials.call(this);
    this.loadMasterCredentials(masterCredentials);
    this.expired = true;

    this.params = params || {};
    if (this.params.RoleArn) {
      this.params.RoleSessionName =
        this.params.RoleSessionName || 'temporary-credentials';
    }
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.masterCredentials.get(function() {
      self.service.config.credentials = self.masterCredentials;
      var operation = self.params.RoleArn ?
        self.service.assumeRole : self.service.getSessionToken;
      operation.call(self.service, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
    this.masterCredentials = masterCredentials || AWS.config.credentials;
    while (this.masterCredentials.masterCredentials) {
      this.masterCredentials = this.masterCredentials.masterCredentials;
    }

    if (typeof this.masterCredentials.get !== 'function') {
      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var STS = __webpack_require__(128);

/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */
AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */
  constructor: function WebIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
    this.data = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithWebIdentity(function (err, data) {
      self.data = null;
      if (!err) {
        self.data = data;
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    if (!this.service) {
      var stsConfig = AWS.util.merge({}, this._clientConfig);
      stsConfig.params = this.params;
      this.service = new STS(stsConfig);
    }
  }

});


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var util = AWS.util;
var typeOf = __webpack_require__(358).typeOf;
var DynamoDBSet = __webpack_require__(357);
var NumberValue = __webpack_require__(993);

AWS.DynamoDB.Converter = {
  /**
   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
   *
   * @param data [any] The data to convert to a DynamoDB AttributeValue
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   * @return [map] An object in the Amazon DynamoDB AttributeValue format
   *
   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
   *    convert entire records (rather than individual attributes)
   */
  input: function convertInput(data, options) {
    options = options || {};
    var type = typeOf(data);
    if (type === 'Object') {
      return formatMap(data, options);
    } else if (type === 'Array') {
      return formatList(data, options);
    } else if (type === 'Set') {
      return formatSet(data, options);
    } else if (type === 'String') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { S: data };
    } else if (type === 'Number' || type === 'NumberValue') {
      return { N: data.toString() };
    } else if (type === 'Binary') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { B: data };
    } else if (type === 'Boolean') {
      return { BOOL: data };
    } else if (type === 'null') {
      return { NULL: true };
    } else if (type !== 'undefined' && type !== 'Function') {
      // this value has a custom constructor
      return formatMap(data, options);
    }
  },

  /**
   * Convert a JavaScript object into a DynamoDB record.
   *
   * @param data [any] The data to convert to a DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object in the DynamoDB record format.
   *
   * @example Convert a JavaScript object into a DynamoDB record
   *  var marshalled = AWS.DynamoDB.Converter.marshall({
   *    string: 'foo',
   *    list: ['fizz', 'buzz', 'pop'],
   *    map: {
   *      nestedMap: {
   *        key: 'value',
   *      }
   *    },
   *    number: 123,
   *    nullValue: null,
   *    boolValue: true,
   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
   *  });
   */
  marshall: function marshallItem(data, options) {
    return AWS.DynamoDB.Converter.input(data, options).M;
  },

  /**
   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
   *
   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [Object|Array|String|Number|Boolean|null]
   *
   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
   *    convert entire records (rather than individual attributes)
   */
  output: function convertOutput(data, options) {
    options = options || {};
    var list, map, i;
    for (var type in data) {
      var values = data[type];
      if (type === 'M') {
        map = {};
        for (var key in values) {
          map[key] = convertOutput(values[key], options);
        }
        return map;
      } else if (type === 'L') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertOutput(values[i], options));
        }
        return list;
      } else if (type === 'SS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(values[i] + '');
        }
        return new DynamoDBSet(list);
      } else if (type === 'NS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertNumber(values[i], options.wrapNumbers));
        }
        return new DynamoDBSet(list);
      } else if (type === 'BS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(new util.Buffer(values[i]));
        }
        return new DynamoDBSet(list);
      } else if (type === 'S') {
        return values + '';
      } else if (type === 'N') {
        return convertNumber(values, options.wrapNumbers);
      } else if (type === 'B') {
        return new util.Buffer(values);
      } else if (type === 'BOOL') {
        return (values === 'true' || values === 'TRUE' || values === true);
      } else if (type === 'NULL') {
        return null;
      }
    }
  },

  /**
   * Convert a DynamoDB record into a JavaScript object.
   *
   * @param data [any] The DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object whose properties have been converted from
   *    DynamoDB's AttributeValue format into their corresponding native
   *    JavaScript types.
   *
   * @example Convert a record received from a DynamoDB stream
   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
   *    string: {S: 'foo'},
   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
   *    map: {
   *      M: {
   *        nestedMap: {
   *          M: {
   *            key: {S: 'value'}
   *          }
   *        }
   *      }
   *    },
   *    number: {N: '123'},
   *    nullValue: {NULL: true},
   *    boolValue: {BOOL: true}
   *  });
   */
  unmarshall: function unmarshall(data, options) {
    return AWS.DynamoDB.Converter.output({M: data}, options);
  }
};

/**
 * @api private
 * @param data [Array]
 * @param options [map]
 */
function formatList(data, options) {
  var list = {L: []};
  for (var i = 0; i < data.length; i++) {
    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
  }
  return list;
}

/**
 * @api private
 * @param value [String]
 * @param wrapNumbers [Boolean]
 */
function convertNumber(value, wrapNumbers) {
  return wrapNumbers ? new NumberValue(value) : Number(value);
}

/**
 * @api private
 * @param data [map]
 * @param options [map]
 */
function formatMap(data, options) {
  var map = {M: {}};
  for (var key in data) {
    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
    if (formatted !== void 0) {
      map['M'][key] = formatted;
    }
  }
  return map;
}

/**
 * @api private
 */
function formatSet(data, options) {
  options = options || {};
  var values = data.values;
  if (options.convertEmptyValues) {
    values = filterEmptySetValues(data);
    if (values.length === 0) {
      return AWS.DynamoDB.Converter.input(null);
    }
  }

  var map = {};
  switch (data.type) {
    case 'String': map['SS'] = values; break;
    case 'Binary': map['BS'] = values; break;
    case 'Number': map['NS'] = values.map(function (value) {
      return value.toString();
    });
  }
  return map;
}

/**
 * @api private
 */
function filterEmptySetValues(set) {
    var nonEmptyValues = [];
    var potentiallyEmptyTypes = {
        String: true,
        Binary: true,
        Number: false
    };
    if (potentiallyEmptyTypes[set.type]) {
        for (var i = 0; i < set.values.length; i++) {
            if (set.values[i].length === 0) {
                continue;
            }
            nonEmptyValues.push(set.values[i]);
        }

        return nonEmptyValues;
    }

    return set.values;
}

module.exports = AWS.DynamoDB.Converter;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var Translator = __webpack_require__(994);
var DynamoDBSet = __webpack_require__(357);

/**
 * The document client simplifies working with items in Amazon DynamoDB
 * by abstracting away the notion of attribute values. This abstraction
 * annotates native JavaScript types supplied as input parameters, as well
 * as converts annotated response data to native JavaScript types.
 *
 * ## Marshalling Input and Unmarshalling Response Data
 *
 * The document client affords developers the use of native JavaScript types
 * instead of `AttributeValue`s to simplify the JavaScript development
 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
 * by the `DocumentClient`. The `DocumentClient`, does not accept
 * `AttributeValue`s in favor of native JavaScript types.
 *
 * |                             JavaScript Type                            | DynamoDB AttributeValue |
 * |:----------------------------------------------------------------------:|-------------------------|
 * | String                                                                 | S                       |
 * | Number                                                                 | N                       |
 * | Boolean                                                                | BOOL                    |
 * | null                                                                   | NULL                    |
 * | Array                                                                  | L                       |
 * | Object                                                                 | M                       |
 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
 *
 * ## Support for Sets
 *
 * The `DocumentClient` offers a convenient way to create sets from
 * JavaScript Arrays. The type of set is inferred from the first element
 * in the array. DynamoDB supports string, number, and binary sets. To
 * learn more about supported types see the
 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
 *
 */
AWS.DynamoDB.DocumentClient = AWS.util.inherit({

  /**
   * @api private
   */
  operations: {
    batchGetItem: 'batchGet',
    batchWriteItem: 'batchWrite',
    putItem: 'put',
    getItem: 'get',
    deleteItem: 'delete',
    updateItem: 'update',
    scan: 'scan',
    query: 'query'
  },

  /**
   * Creates a DynamoDB document client with a set of configuration options.
   *
   * @option options params [map] An optional map of parameters to bind to every
   *   request sent by this service object.
   * @option options service [AWS.DynamoDB] An optional pre-configured instance
   *  of the AWS.DynamoDB service object to use for requests. The object may
   *  bound parameters used by the document client.
   * @option options convertEmptyValues [Boolean] set to true if you would like
   *  the document client to convert empty values (0-length strings, binary
   *  buffers, and sets) to be converted to NULL types when persisting to
   *  DynamoDB.
   * @see AWS.DynamoDB.constructor
   *
   */
  constructor: function DocumentClient(options) {
    var self = this;
    self.options = options || {};
    self.configure(self.options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    var self = this;
    self.service = options.service;
    self.bindServiceObject(options);
    self.attrValue = options.attrValue =
      self.service.api.operations.putItem.input.members.Item.value.shape;
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(options) {
    var self = this;
    options = options || {};

    if (!self.service) {
      self.service = new AWS.DynamoDB(options);
    } else {
      var config = AWS.util.copy(self.service.config);
      self.service = new self.service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, options.params);
    }
  },

  /**
   * Returns the attributes of one or more items from one or more tables
   * by delegating to `AWS.DynamoDB.batchGetItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchGetItem
   * @example Get items from multiple tables
   *  var params = {
   *    RequestItems: {
   *      'Table-1': {
   *        Keys: [
   *          {
   *             HashKey: 'haskey',
   *             NumberRangeKey: 1
   *          }
   *        ]
   *      },
   *      'Table-2': {
   *        Keys: [
   *          { foo: 'bar' },
   *        ]
   *      }
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchGet(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchGet: function(params, callback) {
    var self = this;
    var request = self.service.batchGetItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Puts or deletes multiple items in one or more tables by delegating
   * to `AWS.DynamoDB.batchWriteItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchWriteItem
   * @example Write to and delete from a table
   *  var params = {
   *    RequestItems: {
   *      'Table-1': [
   *        {
   *          DeleteRequest: {
   *            Key: { HashKey: 'someKey' }
   *          }
   *        },
   *        {
   *          PutRequest: {
   *            Item: {
   *              HashKey: 'anotherKey',
   *              NumAttribute: 1,
   *              BoolAttribute: true,
   *              ListAttribute: [1, 'two', false],
   *              MapAttribute: { foo: 'bar' }
   *            }
   *          }
   *        }
   *      ]
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchWrite(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchWrite: function(params, callback) {
    var self = this;
    var request = self.service.batchWriteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Deletes a single item in a table by primary key by delegating to
   * `AWS.DynamoDB.deleteItem()`
   *
   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.deleteItem
   * @example Delete an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey',
   *      NumberRangeKey: 1
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.delete(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  delete: function(params, callback) {
    var self = this;
    var request = self.service.deleteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns a set of attributes for the item with the given primary key
   * by delegating to `AWS.DynamoDB.getItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.getItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.getItem
   * @example Get an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey'
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.get(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  get: function(params, callback) {
    var self = this;
    var request = self.service.getItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a new item, or replaces an old item with a new item by
   * delegating to `AWS.DynamoDB.putItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.putItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.putItem
   * @example Create a new item in a table
   *  var params = {
   *    TableName : 'Table',
   *    Item: {
   *       HashKey: 'haskey',
   *       NumAttribute: 1,
   *       BoolAttribute: true,
   *       ListAttribute: [1, 'two', false],
   *       MapAttribute: { foo: 'bar'},
   *       NullAttribute: null
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  put: function put(params, callback) {
    var self = this;
    var request = self.service.putItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Edits an existing item's attributes, or adds a new item to the table if
   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.updateItem
   * @example Update an item with expressions
   *  var params = {
   *    TableName: 'Table',
   *    Key: { HashKey : 'hashkey' },
   *    UpdateExpression: 'set #a = :x + :y',
   *    ConditionExpression: '#a < :MAX',
   *    ExpressionAttributeNames: {'#a' : 'Sum'},
   *    ExpressionAttributeValues: {
   *      ':x' : 20,
   *      ':y' : 45,
   *      ':MAX' : 100,
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.update(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  update: function(params, callback) {
    var self = this;
    var request = self.service.updateItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns one or more items and item attributes by accessing every item
   * in a table or a secondary index.
   *
   * Supply the same parameters as {AWS.DynamoDB.scan} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.scan
   * @example Scan the table with a filter expression
   *  var params = {
   *    TableName : 'Table',
   *    FilterExpression : 'Year = :this_year',
   *    ExpressionAttributeValues : {':this_year' : 2015}
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.scan(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  scan: function(params, callback) {
    var self = this;
    var request = self.service.scan(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

   /**
    * Directly access items from a table by primary key or a secondary index.
    *
    * Supply the same parameters as {AWS.DynamoDB.query} with
    * `AttributeValue`s substituted by native JavaScript types.
    *
    * @see AWS.DynamoDB.query
    * @example Query an index
    *  var params = {
    *    TableName: 'Table',
    *    IndexName: 'Index',
    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
    *    ExpressionAttributeValues: {
    *      ':hkey': 'key',
    *      ':rkey': 2015
    *    }
    *  };
    *
    *  var documentClient = new AWS.DynamoDB.DocumentClient();
    *
    *  documentClient.query(params, function(err, data) {
    *     if (err) console.log(err);
    *     else console.log(data);
    *  });
    *
    */
  query: function(params, callback) {
    var self = this;
    var request = self.service.query(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a set of elements inferring the type of set from
   * the type of the first element. Amazon DynamoDB currently supports
   * the number sets, string sets, and binary sets. For more information
   * about DynamoDB data types see the documentation on the
   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
   *
   * @param list [Array] Collection to represent your DynamoDB Set
   * @param options [map]
   *  * **validate** [Boolean] set to true if you want to validate the type
   *    of each element in the set. Defaults to `false`.
   * @example Creating a number set
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  var params = {
   *    Item: {
   *      hashkey: 'hashkey'
   *      numbers: documentClient.createSet([1, 2, 3]);
   *    }
   *  };
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  createSet: function(list, options) {
    options = options || {};
    return new DynamoDBSet(list, options);
  },

  /**
   * @api private
   */
  getTranslator: function() {
    return new Translator(this.options);
  },

  /**
   * @api private
   */
  setupRequest: function setupRequest(request) {
    var self = this;
    var translator = self.getTranslator();
    var operation = request.operation;
    var inputShape = request.service.api.operations[operation].input;
    request._events.validate.unshift(function(req) {
      req.rawParams = AWS.util.copy(req.params);
      req.params = translator.translateInput(req.rawParams, inputShape);
    });
  },

  /**
   * @api private
   */
  setupResponse: function setupResponse(request) {
    var self = this;
    var translator = self.getTranslator();
    var outputShape = self.service.api.operations[request.operation].output;
    request.on('extractData', function(response) {
      response.data = translator.translateOutput(response.data, outputShape);
    });

    var response = request.response;
    response.nextPage = function(cb) {
      var resp = this;
      var req = resp.request;
      var config;
      var service = req.service;
      var operation = req.operation;
      try {
        config = service.paginationConfig(operation, true);
      } catch (e) { resp.error = e; }

      if (!resp.hasNextPage()) {
        if (cb) cb(resp.error, null);
        else if (resp.error) throw resp.error;
        return null;
      }

      var params = AWS.util.copy(req.rawParams);
      if (!resp.nextPageTokens) {
        return cb ? cb(null, null) : null;
      } else {
        var inputTokens = config.inputToken;
        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
        for (var i = 0; i < inputTokens.length; i++) {
          params[inputTokens[i]] = resp.nextPageTokens[i];
        }
        return self[operation](params, cb);
      }
    };
  }

});

module.exports = AWS.DynamoDB.DocumentClient;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(3).util;

/**
 * An object recognizable as a numeric value that stores the underlying number
 * as a string.
 *
 * Intended to be a deserialization target for the DynamoDB Document Client when
 * the `wrapNumbers` flag is set. This allows for numeric values that lose
 * precision when converted to JavaScript's `number` type.
 */
var DynamoDBNumberValue = util.inherit({
  constructor: function NumberValue(value) {
    this.value = value.toString();
  },

  /**
   * Render the underlying value as a number when converting to JSON.
   */
  toJSON: function () {
    return this.toNumber();
  },

  /**
   * Convert the underlying value to a JavaScript number.
   */
  toNumber: function () {
    return Number(this.value);
  },

  /**
   * Return a string representing the unaltered value provided to the
   * constructor.
   */
  toString: function () {
    return this.value;
  }
});

module.exports = DynamoDBNumberValue;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(3).util;
var convert = __webpack_require__(991);

var Translator = function(options) {
  options = options || {};
  this.attrValue = options.attrValue;
  this.convertEmptyValues = Boolean(options.convertEmptyValues);
  this.wrapNumbers = Boolean(options.wrapNumbers);
};

Translator.prototype.translateInput = function(value, shape) {
  this.mode = 'input';
  return this.translate(value, shape);
};

Translator.prototype.translateOutput = function(value, shape) {
  this.mode = 'output';
  return this.translate(value, shape);
};

Translator.prototype.translate = function(value, shape) {
  var self = this;
  if (!shape || value === undefined) return undefined;

  if (shape.shape === self.attrValue) {
    return convert[self.mode](value, {
      convertEmptyValues: self.convertEmptyValues,
      wrapNumbers: self.wrapNumbers,
    });
  }
  switch (shape.type) {
    case 'structure': return self.translateStructure(value, shape);
    case 'map': return self.translateMap(value, shape);
    case 'list': return self.translateList(value, shape);
    default: return self.translateScalar(value, shape);
  }
};

Translator.prototype.translateStructure = function(structure, shape) {
  var self = this;
  if (structure == null) return undefined;

  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      var result = self.translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
};

Translator.prototype.translateList = function(list, shape) {
  var self = this;
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = self.translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
};

Translator.prototype.translateMap = function(map, shape) {
  var self = this;
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = self.translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
};

Translator.prototype.translateScalar = function(value, shape) {
  return shape.toType(value);
};

module.exports = Translator;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var SequentialExecutor = __webpack_require__(368);
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */
AWS.EventListeners = {
  /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */
  Core: {} /* doc hack */
};

/**
 * @api private
 */
function getOperationAuthtype(req) {
  if (!req.service.api.operations) {
    return '';
  }
  var operation = req.service.api.operations[req.operation];
  return operation ? operation.authtype : '';
}

AWS.EventListeners = {
  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
    addAsync('VALIDATE_CREDENTIALS', 'validate',
        function VALIDATE_CREDENTIALS(req, done) {
      if (!req.service.api.signatureVersion) return done(); // none
      req.service.config.getCredentials(function(err) {
        if (err) {
          req.response.error = AWS.util.error(err,
            {code: 'CredentialsError', message: 'Missing credentials in config'});
        }
        done();
      });
    });

    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
        req.response.error = AWS.util.error(new Error(),
          {code: 'ConfigError', message: 'Missing region in config'});
      }
    });

    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      if (!operation) {
        return;
      }
      var idempotentMembers = operation.idempotentMembers;
      if (!idempotentMembers.length) {
        return;
      }
      // creates a copy of params so user's param object isn't mutated
      var params = AWS.util.copy(req.params);
      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
        if (!params[idempotentMembers[i]]) {
          // add the member
          params[idempotentMembers[i]] = AWS.util.uuid.v4();
        }
      }
      req.params = params;
    });

    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var rules = req.service.api.operations[req.operation].input;
      var validation = req.service.config.paramValidation;
      new AWS.ParamValidator(validation).validate(rules, req.params);
    });

    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
      req.haltHandlersOnError();
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!req.service.api.signatureVersion && !authtype) return done(); // none
      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
        var body = req.httpRequest.body || '';
        if (authtype.indexOf('unsigned-body') >= 0) {
          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
          return done();
        }
        AWS.util.computeSha256(body, function(err, sha) {
          if (err) {
            done(err);
          }
          else {
            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
            done();
          }
        });
      } else {
        done();
      }
    });

    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
      var authtype = getOperationAuthtype(req);
      if (req.httpRequest.headers['Content-Length'] === undefined
          && authtype.indexOf('unsigned-body') === -1) {
        var length = AWS.util.string.byteLength(req.httpRequest.body);
        req.httpRequest.headers['Content-Length'] = length;
      }
    });

    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
    });

    add('RESTART', 'restart', function RESTART() {
      var err = this.response.error;
      if (!err || !err.retryable) return;

      this.httpRequest = new AWS.HttpRequest(
        this.service.endpoint,
        this.service.region
      );

      if (this.response.retryCount < this.service.config.maxRetries) {
        this.response.retryCount++;
      } else {
        this.response.error = null;
      }
    });

    addAsync('SIGN', 'sign', function SIGN(req, done) {
      var service = req.service;
      var operations = req.service.api.operations || {};
      var operation = operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!service.api.signatureVersion && !authtype) return done(); // none

      service.config.getCredentials(function (err, credentials) {
        if (err) {
          req.response.error = err;
          return done();
        }

        try {
          var date = service.getSkewCorrectedDate();
          var SignerClass = service.getSignerClass(req);
          var signer = new SignerClass(req.httpRequest,
            service.api.signingName || service.api.endpointPrefix,
            {
              signatureCache: service.config.signatureCache,
              operation: operation
            });
          signer.setServiceClientId(service._clientId);

          // clear old authorization headers
          delete req.httpRequest.headers['Authorization'];
          delete req.httpRequest.headers['Date'];
          delete req.httpRequest.headers['X-Amz-Date'];

          // add new authorization
          signer.addAuthorization(credentials, date);
          req.signedAt = date;
        } catch (e) {
          req.response.error = e;
        }
        done();
      });
    });

    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
      if (this.service.successfulResponse(resp, this)) {
        resp.data = {};
        resp.error = null;
      } else {
        resp.data = null;
        resp.error = AWS.util.error(new Error(),
          {code: 'UnknownError', message: 'An unknown error occurred.'});
      }
    });

    addAsync('SEND', 'send', function SEND(resp, done) {
      resp.httpResponse._abortCallback = done;
      resp.error = null;
      resp.data = null;

      function callback(httpResp) {
        resp.httpResponse.stream = httpResp;
        var stream = resp.request.httpRequest.stream;

        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
          resp.request.emit(
            'httpHeaders',
            [statusCode, headers, resp, statusMessage]
          );

          if (!resp.httpResponse.streaming) {
            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
              httpResp.on('readable', function onReadable() {
                var data = httpResp.read();
                if (data !== null) {
                  resp.request.emit('httpData', [data, resp]);
                }
              });
            } else { // legacy streams API
              httpResp.on('data', function onData(data) {
                resp.request.emit('httpData', [data, resp]);
              });
            }
          }
        });

        httpResp.on('end', function onEnd() {
          if (!stream || !stream.didCallback) {
            resp.request.emit('httpDone');
            done();
          }
        });
      }

      function progress(httpResp) {
        httpResp.on('sendProgress', function onSendProgress(value) {
          resp.request.emit('httpUploadProgress', [value, resp]);
        });

        httpResp.on('receiveProgress', function onReceiveProgress(value) {
          resp.request.emit('httpDownloadProgress', [value, resp]);
        });
      }

      function error(err) {
        if (err.code !== 'RequestAbortedError') {
          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
          err = AWS.util.error(err, {
            code: errCode,
            region: resp.request.httpRequest.region,
            hostname: resp.request.httpRequest.endpoint.hostname,
            retryable: true
          });
        }
        resp.error = err;
        resp.request.emit('httpError', [resp.error, resp], function() {
          done();
        });
      }

      function executeSend() {
        var http = AWS.HttpClient.getInstance();
        var httpOptions = resp.request.service.config.httpOptions || {};
        try {
          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
                                          callback, error);
          progress(stream);
        } catch (err) {
          error(err);
        }
      }
      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
        this.emit('sign', [this], function(err) {
          if (err) done(err);
          else executeSend();
        });
      } else {
        executeSend();
      }
    });

    add('HTTP_HEADERS', 'httpHeaders',
        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
      resp.httpResponse.statusCode = statusCode;
      resp.httpResponse.statusMessage = statusMessage;
      resp.httpResponse.headers = headers;
      resp.httpResponse.body = new AWS.util.Buffer('');
      resp.httpResponse.buffers = [];
      resp.httpResponse.numBytes = 0;
      var dateHeader = headers.date || headers.Date;
      var service = resp.request.service;
      if (dateHeader) {
        var serverTime = Date.parse(dateHeader);
        if (service.config.correctClockSkew
            && service.isClockSkewed(serverTime)) {
          service.applyClockOffset(serverTime);
        }
      }
    });

    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
      if (chunk) {
        if (AWS.util.isNode()) {
          resp.httpResponse.numBytes += chunk.length;

          var total = resp.httpResponse.headers['content-length'];
          var progress = { loaded: resp.httpResponse.numBytes, total: total };
          resp.request.emit('httpDownloadProgress', [progress, resp]);
        }

        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
      }
    });

    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
      // convert buffers array into single buffer
      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
        resp.httpResponse.body = body;
      }
      delete resp.httpResponse.numBytes;
      delete resp.httpResponse.buffers;
    });

    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
      if (resp.httpResponse.statusCode) {
        resp.error.statusCode = resp.httpResponse.statusCode;
        if (resp.error.retryable === undefined) {
          resp.error.retryable = this.service.retryableError(resp.error, this);
        }
      }
    });

    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
      if (!resp.error) return;
      switch (resp.error.code) {
        case 'RequestExpired': // EC2 only
        case 'ExpiredTokenException':
        case 'ExpiredToken':
          resp.error.retryable = true;
          resp.request.service.config.credentials.expired = true;
      }
    });

    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
      var err = resp.error;
      if (!err) return;
      if (typeof err.code === 'string' && typeof err.message === 'string') {
        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
          resp.error.retryable = true;
        }
      }
    });

    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
      if (!resp.error) return;
      if (this.service.clockSkewError(resp.error)
          && this.service.config.correctClockSkew) {
        resp.error.retryable = true;
      }
    });

    add('REDIRECT', 'retry', function REDIRECT(resp) {
      if (resp.error && resp.error.statusCode >= 300 &&
          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
        this.httpRequest.endpoint =
          new AWS.Endpoint(resp.httpResponse.headers['location']);
        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
        resp.error.redirect = true;
        resp.error.retryable = true;
      }
    });

    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
      if (resp.error) {
        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.error.retryDelay = 0;
        } else if (resp.retryCount < resp.maxRetries) {
          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
        }
      }
    });

    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
      var delay, willRetry = false;

      if (resp.error) {
        delay = resp.error.retryDelay || 0;
        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
          resp.retryCount++;
          willRetry = true;
        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.redirectCount++;
          willRetry = true;
        }
      }

      if (willRetry) {
        resp.error = null;
        setTimeout(done, delay);
      } else {
        done();
      }
    });
  }),

  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
        var message = 'Inaccessible host: `' + err.hostname +
          '\'. This service may not be available in the `' + err.region +
          '\' region.';
        this.response.error = AWS.util.error(new Error(message), {
          code: 'UnknownEndpoint',
          region: err.region,
          hostname: err.hostname,
          retryable: true,
          originalError: err
        });
      }
    });
  }),

  Logger: new SequentialExecutor().addNamedListeners(function(add) {
    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
      var req = resp.request;
      var logger = req.service.config.logger;
      if (!logger) return;

      function buildMessage() {
        var time = resp.request.service.getSkewCorrectedDate().getTime();
        var delta = (time - req.startTime.getTime()) / 1000;
        var ansi = logger.isTTY ? true : false;
        var status = resp.httpResponse.statusCode;
        var params = __webpack_require__(666).inspect(req.params, true, null);

        var message = '';
        if (ansi) message += '\x1B[33m';
        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
        if (ansi) message += '\x1B[0;1m';
        message += ' ' + AWS.util.string.lowerFirst(req.operation);
        message += '(' + params + ')';
        if (ansi) message += '\x1B[0m';
        return message;
      }

      var line = buildMessage();
      if (typeof logger.log === 'function') {
        logger.log(line);
      } else if (typeof logger.write === 'function') {
        logger.write(line + '\n');
      }
    });
  }),

  Json: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(223);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Rest: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(157);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(366);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(367);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Query: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(365);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  })
};


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var EventEmitter = __webpack_require__(492).EventEmitter;
__webpack_require__(359);

/**
 * @api private
 */
AWS.XHRClient = AWS.util.inherit({
  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
    var self = this;
    var endpoint = httpRequest.endpoint;
    var emitter = new EventEmitter();
    var href = endpoint.protocol + '//' + endpoint.hostname;
    if (endpoint.port !== 80 && endpoint.port !== 443) {
      href += ':' + endpoint.port;
    }
    href += httpRequest.path;

    var xhr = new XMLHttpRequest(), headersEmitted = false;
    httpRequest.stream = xhr;

    xhr.addEventListener('readystatechange', function() {
      try {
        if (xhr.status === 0) return; // 0 code is invalid
      } catch (e) { return; }

      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
        emitter.statusCode = xhr.status;
        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
        emitter.emit(
          'headers',
          emitter.statusCode,
          emitter.headers,
          xhr.statusText
        );
        headersEmitted = true;
      }
      if (this.readyState === this.DONE) {
        self.finishRequest(xhr, emitter);
      }
    }, false);
    xhr.upload.addEventListener('progress', function (evt) {
      emitter.emit('sendProgress', evt);
    });
    xhr.addEventListener('progress', function (evt) {
      emitter.emit('receiveProgress', evt);
    }, false);
    xhr.addEventListener('timeout', function () {
      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
    }, false);
    xhr.addEventListener('error', function () {
      errCallback(AWS.util.error(new Error('Network Failure'), {
        code: 'NetworkingError'
      }));
    }, false);
    xhr.addEventListener('abort', function () {
      errCallback(AWS.util.error(new Error('Request aborted'), {
        code: 'RequestAbortedError'
      }));
    }, false);

    callback(emitter);
    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
    AWS.util.each(httpRequest.headers, function (key, value) {
      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
        xhr.setRequestHeader(key, value);
      }
    });

    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
      xhr.timeout = httpOptions.timeout;
    }

    if (httpOptions.xhrWithCredentials) {
      xhr.withCredentials = true;
    }
    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

    try {
      if (httpRequest.body) {
        xhr.send(httpRequest.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
      } else {
        throw err;
      }
    }

    return emitter;
  },

  parseHeaders: function parseHeaders(rawHeaders) {
    var headers = {};
    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
      var key = line.split(':', 1)[0];
      var value = line.substring(key.length + 2);
      if (key.length > 0) headers[key.toLowerCase()] = value;
    });
    return headers;
  },

  finishRequest: function finishRequest(xhr, emitter) {
    var buffer;
    if (xhr.responseType === 'arraybuffer' && xhr.response) {
      var ab = xhr.response;
      buffer = new AWS.util.Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
    }

    try {
      if (!buffer && typeof xhr.responseText === 'string') {
        buffer = new AWS.util.Buffer(xhr.responseText);
      }
    } catch (e) {}

    if (buffer) emitter.emit('data', buffer);
    emitter.emit('end');
  }
});

/**
 * @api private
 */
AWS.HttpClient.prototype = AWS.XHRClient.prototype;

/**
 * @api private
 */
AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * @api private
 */
AWS.ParamValidator = AWS.util.inherit({
  /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */
  constructor: function ParamValidator(validation) {
    if (validation === true || validation === undefined) {
      validation = {'min': true};
    }
    this.validation = validation;
  },

  validate: function validate(shape, params, context) {
    this.errors = [];
    this.validateMember(shape, params || {}, context || 'params');

    if (this.errors.length > 1) {
      var msg = this.errors.join('\n* ');
      msg = 'There were ' + this.errors.length +
        ' validation errors:\n* ' + msg;
      throw AWS.util.error(new Error(msg),
        {code: 'MultipleValidationErrors', errors: this.errors});
    } else if (this.errors.length === 1) {
      throw this.errors[0];
    } else {
      return true;
    }
  },

  fail: function fail(code, message) {
    this.errors.push(AWS.util.error(new Error(message), {code: code}));
  },

  validateStructure: function validateStructure(shape, params, context) {
    this.validateType(params, context, ['object'], 'structure');

    var paramName;
    for (var i = 0; shape.required && i < shape.required.length; i++) {
      paramName = shape.required[i];
      var value = params[paramName];
      if (value === undefined || value === null) {
        this.fail('MissingRequiredParameter',
          'Missing required key \'' + paramName + '\' in ' + context);
      }
    }

    // validate hash members
    for (paramName in params) {
      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

      var paramValue = params[paramName],
          memberShape = shape.members[paramName];

      if (memberShape !== undefined) {
        var memberContext = [context, paramName].join('.');
        this.validateMember(memberShape, paramValue, memberContext);
      } else {
        this.fail('UnexpectedParameter',
          'Unexpected key \'' + paramName + '\' found in ' + context);
      }
    }

    return true;
  },

  validateMember: function validateMember(shape, param, context) {
    switch (shape.type) {
      case 'structure':
        return this.validateStructure(shape, param, context);
      case 'list':
        return this.validateList(shape, param, context);
      case 'map':
        return this.validateMap(shape, param, context);
      default:
        return this.validateScalar(shape, param, context);
    }
  },

  validateList: function validateList(shape, params, context) {
    if (this.validateType(params, context, [Array])) {
      this.validateRange(shape, params.length, context, 'list member count');
      // validate array members
      for (var i = 0; i < params.length; i++) {
        this.validateMember(shape.member, params[i], context + '[' + i + ']');
      }
    }
  },

  validateMap: function validateMap(shape, params, context) {
    if (this.validateType(params, context, ['object'], 'map')) {
      // Build up a count of map members to validate range traits.
      var mapCount = 0;
      for (var param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
        // Validate any map key trait constraints
        this.validateMember(shape.key, param,
                            context + '[key=\'' + param + '\']')
        this.validateMember(shape.value, params[param],
                            context + '[\'' + param + '\']');
        mapCount++;
      }
      this.validateRange(shape, mapCount, context, 'map member count');
    }
  },

  validateScalar: function validateScalar(shape, value, context) {
    switch (shape.type) {
      case null:
      case undefined:
      case 'string':
        return this.validateString(shape, value, context);
      case 'base64':
      case 'binary':
        return this.validatePayload(value, context);
      case 'integer':
      case 'float':
        return this.validateNumber(shape, value, context);
      case 'boolean':
        return this.validateType(value, context, ['boolean']);
      case 'timestamp':
        return this.validateType(value, context, [Date,
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
          'Date object, ISO-8601 string, or a UNIX timestamp');
      default:
        return this.fail('UnkownType', 'Unhandled type ' +
                         shape.type + ' for ' + context);
    }
  },

  validateString: function validateString(shape, value, context) {
    var validTypes = ['string'];
    if (shape.isJsonValue) {
      validTypes = validTypes.concat(['number', 'object', 'boolean']);
    }
    if (value !== null && this.validateType(value, context, validTypes)) {
      this.validateEnum(shape, value, context);
      this.validateRange(shape, value.length, context, 'string length');
      this.validatePattern(shape, value, context);
    }
  },

  validatePattern: function validatePattern(shape, value, context) {
    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
      if (!(new RegExp(shape['pattern'])).test(value)) {
        this.fail('PatternMatchError', 'Provided value "' + value + '" '
          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
          + context);
      }
    }
  },

  validateRange: function validateRange(shape, value, context, descriptor) {
    if (this.validation['min']) {
      if (shape['min'] !== undefined && value < shape['min']) {
        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
          + shape['min'] + ', but found ' + value + ' for ' + context);
      }
    }
    if (this.validation['max']) {
      if (shape['max'] !== undefined && value > shape['max']) {
        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
          + shape['max'] + ', but found ' + value + ' for ' + context);
      }
    }
  },

  validateEnum: function validateRange(shape, value, context) {
    if (this.validation['enum'] && shape['enum'] !== undefined) {
      // Fail if the string value is not present in the enum list
      if (shape['enum'].indexOf(value) === -1) {
        this.fail('EnumError', 'Found string value of ' + value + ', but '
          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
      }
    }
  },

  validateType: function validateType(value, context, acceptedTypes, type) {
    // We will not log an error for null or undefined, but we will return
    // false so that callers know that the expected type was not strictly met.
    if (value === null || value === undefined) return false;

    var foundInvalidType = false;
    for (var i = 0; i < acceptedTypes.length; i++) {
      if (typeof acceptedTypes[i] === 'string') {
        if (typeof value === acceptedTypes[i]) return true;
      } else if (acceptedTypes[i] instanceof RegExp) {
        if ((value || '').toString().match(acceptedTypes[i])) return true;
      } else {
        if (value instanceof acceptedTypes[i]) return true;
        if (AWS.util.isType(value, acceptedTypes[i])) return true;
        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
      }
      foundInvalidType = true;
    }

    var acceptedType = type;
    if (!acceptedType) {
      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
    }

    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
              vowel + ' ' + acceptedType);
    return false;
  },

  validateNumber: function validateNumber(shape, value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') {
      var castedValue = parseFloat(value);
      if (castedValue.toString() === value) value = castedValue;
    }
    if (this.validateType(value, context, ['number'])) {
      this.validateRange(shape, value, context, 'numeric value');
    }
  },

  validatePayload: function validatePayload(value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') return;
    if (value && typeof value.byteLength === 'number') return; // typed arrays
    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
      var Stream = AWS.util.stream.Stream;
      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
    }

    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
    if (value) {
      for (var i = 0; i < types.length; i++) {
        if (AWS.util.isType(value, types[i])) return;
        if (AWS.util.typeName(value.constructor) === types[i]) return;
      }
    }

    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
      'string, Buffer, Stream, Blob, or typed array object');
  }
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var rest = AWS.Protocol.Rest;

/**
 * A presigner object can be used to generate presigned urls for the Polly service.
 */
AWS.Polly.Presigner = AWS.util.inherit({
    /**
     * Creates a presigner object with a set of configuration options.
     *
     * @option options params [map] An optional map of parameters to bind to every
     *   request sent by this service object.
     * @option options service [AWS.Polly] An optional pre-configured instance
     *  of the AWS.Polly service object to use for requests. The object may
     *  bound parameters used by the presigner.
     * @see AWS.Polly.constructor
     */
    constructor: function Signer(options) {
        options = options || {};
        this.options = options;
        this.service = options.service;
        this.bindServiceObject(options);
        this._operations = {};
    },

    /**
     * @api private
     */
    bindServiceObject: function bindServiceObject(options) {
        options = options || {};
        if (!this.service) {
            this.service = new AWS.Polly(options);
        } else {
            var config = AWS.util.copy(this.service.config);
            this.service = new this.service.constructor.__super__(config);
            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
        }
    },

    /**
     * @api private
     */
    modifyInputMembers: function modifyInputMembers(input) {
        // make copies of the input so we don't overwrite the api
        // need to be careful to copy anything we access/modify
        var modifiedInput = AWS.util.copy(input);
        modifiedInput.members = AWS.util.copy(input.members);
        AWS.util.each(input.members, function(name, member) {
            modifiedInput.members[name] = AWS.util.copy(member);
            // update location and locationName
            if (!member.location || member.location === 'body') {
                modifiedInput.members[name].location = 'querystring';
                modifiedInput.members[name].locationName = name;
            }
        });
        return modifiedInput;
    },

    /**
     * @api private
     */
    convertPostToGet: function convertPostToGet(req) {
        // convert method
        req.httpRequest.method = 'GET';

        var operation = req.service.api.operations[req.operation];
        // get cached operation input first
        var input = this._operations[req.operation];
        if (!input) {
            // modify the original input
            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
        }

        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);

        req.httpRequest.path = uri;
        req.httpRequest.body = '';

        // don't need these headers on a GET request
        delete req.httpRequest.headers['Content-Length'];
        delete req.httpRequest.headers['Content-Type'];
    },

    /**
     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
     *     operation for the expected operation parameters.
     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
     *     Defaults to 1 hour.
     *   @return [string] if called synchronously (with no callback), returns the signed URL.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, url)
     *     If a callback is supplied, it is called when a signed URL has been generated.
     *     @param err [Error] the error object returned from the presigner.
     *     @param url [String] the signed URL.
     *   @see AWS.Polly.synthesizeSpeech
     */
    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
        var self = this;
        var request = this.service.makeRequest('synthesizeSpeech', params);
        // remove existing build listeners
        request.removeAllListeners('build');
        request.on('build', function(req) {
            self.convertPostToGet(req);
        });
        return request.presign(expires, callback);
    }
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);

function QueryParamSerializer() {
}

QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
  serializeStructure('', params, shape, fn);
};

function ucfirst(shape) {
  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
    return shape.name;
  } else {
    return shape.name[0].toUpperCase() + shape.name.substr(1);
  }
}

function serializeStructure(prefix, struct, rules, fn) {
  util.each(rules.members, function(name, member) {
    var value = struct[name];
    if (value === null || value === undefined) return;

    var memberName = ucfirst(member);
    memberName = prefix ? prefix + '.' + memberName : memberName;
    serializeMember(memberName, value, member, fn);
  });
}

function serializeMap(name, map, rules, fn) {
  var i = 1;
  util.each(map, function (key, value) {
    var prefix = rules.flattened ? '.' : '.entry.';
    var position = prefix + (i++) + '.';
    var keyName = position + (rules.key.name || 'key');
    var valueName = position + (rules.value.name || 'value');
    serializeMember(name + keyName, key, rules.key, fn);
    serializeMember(name + valueName, value, rules.value, fn);
  });
}

function serializeList(name, list, rules, fn) {
  var memberRules = rules.member || {};

  if (list.length === 0) {
    fn.call(this, name, null);
    return;
  }

  util.arrayEach(list, function (v, n) {
    var suffix = '.' + (n + 1);
    if (rules.api.protocol === 'ec2') {
      // Do nothing for EC2
      suffix = suffix + ''; // make linter happy
    } else if (rules.flattened) {
      if (memberRules.name) {
        var parts = name.split('.');
        parts.pop();
        parts.push(ucfirst(memberRules));
        name = parts.join('.');
      }
    } else {
      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
    }
    serializeMember(name + suffix, v, memberRules, fn);
  });
}

function serializeMember(name, value, rules, fn) {
  if (value === null || value === undefined) return;
  if (rules.type === 'structure') {
    serializeStructure(name, value, rules, fn);
  } else if (rules.type === 'list') {
    serializeList(name, value, rules, fn);
  } else if (rules.type === 'map') {
    serializeMap(name, value, rules, fn);
  } else {
    fn(name, rules.toWireFormat(value).toString());
  }
}

module.exports = QueryParamSerializer;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * @api private
 */
var service = null;

/**
 * @api private
 */
var api = {
    signatureVersion: 'v4',
    signingName: 'rds-db'
};

/**
 * @api private
 */
var requiredAuthTokenOptions = {
    region: 'string',
    hostname: 'string',
    port: 'number',
    username: 'string'
};

/**
 * A signer object can be used to generate an auth token to a database.
 */
AWS.RDS.Signer = AWS.util.inherit({
    /**
     * Creates a signer object can be used to generate an auth token.
     *
     * @option options credentials [AWS.Credentials] the AWS credentials
     *   to sign requests with. Uses the default credential provider chain
     *   if not specified.
     * @option options hostname [String] the hostname of the database to connect to.
     * @option options port [Number] the port number the database is listening on.
     * @option options region [String] the region the database is located in.
     * @option options username [String] the username to login as.
     * @example Passing in options to constructor
     *   var signer = new AWS.RDS.Signer({
     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
     *     region: 'us-east-1',
     *     hostname: 'db.us-east-1.rds.amazonaws.com',
     *     port: 8000,
     *     username: 'name'
     *   });
     */
    constructor: function Signer(options) {
        this.options = options || {};
    },

    /**
     * @api private
     * Strips the protocol from a url.
     */
    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
        // we are always using https as the protocol
        var protocol = 'https://';
        if (url.indexOf(protocol) === 0) {
            return url.substring(protocol.length);
        }
    },

    /**
     * @overload getAuthToken(options = {}, [callback])
     *   Generate an auth token to a database.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *
     *   @param options [map] The fields to use when generating an auth token.
     *     Any options specified here will be merged on top of any options passed
     *     to AWS.RDS.Signer:
     *
     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
     *         to sign requests with. Uses the default credential provider chain
     *         if not specified.
     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
     *     * **port** (Number) &mdash; the port number the database is listening on.
     *     * **region** (String) &mdash; the region the database is located in.
     *     * **username** (String) &mdash; the username to login as.
     *   @return [String] if called synchronously (with no callback), returns the
     *     auth token.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, token)
     *     If a callback is supplied, it is called when an auth token has been generated.
     *     @param err [Error] the error object returned from the signer.
     *     @param token [String] the auth token.
     *
     *   @example Generating an auth token synchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     var token = signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     });
     *   @example Generating an auth token asynchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     }, function(err, token) {
     *       if (err) {
     *         // handle error
     *       } else {
     *         // use token
     *       }
     *     });
     *
     */
    getAuthToken: function getAuthToken(options, callback) {
        if (typeof options === 'function' && callback === undefined) {
            callback = options;
            options = {};
        }
        var self = this;
        var hasCallback = typeof callback === 'function';
        // merge options with existing options
        options = AWS.util.merge(this.options, options);
        // validate options
        var optionsValidation = this.validateAuthTokenOptions(options);
        if (optionsValidation !== true) {
            if (hasCallback) {
                return callback(optionsValidation, null);
            }
            throw optionsValidation;
        }

        // 15 minutes
        var expires = 900;
        // create service to generate a request from
        var serviceOptions = {
            region: options.region,
            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
            paramValidation: false,
            signatureVersion: 'v4'
        };
        if (options.credentials) {
            serviceOptions.credentials = options.credentials;
        }
        service = new AWS.Service(serviceOptions);
        // ensure the SDK is using sigv4 signing (config is not enough)
        service.api = api;

        var request = service.makeRequest();
        // add listeners to request to properly build auth token
        this.modifyRequestForAuthToken(request, options);

        if (hasCallback) {
            request.presign(expires, function(err, url) {
                if (url) {
                    url = self.convertUrlToAuthToken(url);
                }
                callback(err, url);
            });
        } else {
            var url = request.presign(expires);
            return this.convertUrlToAuthToken(url);
        }
    },

    /**
     * @api private
     * Modifies a request to allow the presigner to generate an auth token.
     */
    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
        request.on('build', request.buildAsGet);
        var httpRequest = request.httpRequest;
        httpRequest.body = AWS.util.queryParamsToString({
            Action: 'connect',
            DBUser: options.username
        });
    },

    /**
     * @api private
     * Validates that the options passed in contain all the keys with values of the correct type that
     *   are needed to generate an auth token.
     */
    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
        // iterate over all keys in options
        var message = '';
        options = options || {};
        for (var key in requiredAuthTokenOptions) {
            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
                continue;
            }
            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
            }
        }
        if (message.length) {
            return AWS.util.error(new Error(), {
                code: 'InvalidParameter',
                message: message
            });
        }
        return true;
    }
});

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var regionConfig = __webpack_require__(1002);

function generateRegionPrefix(region) {
  if (!region) return null;

  var parts = region.split('-');
  if (parts.length < 3) return null;
  return parts.slice(0, parts.length - 2).join('-') + '-*';
}

function derivedKeys(service) {
  var region = service.config.region;
  var regionPrefix = generateRegionPrefix(region);
  var endpointPrefix = service.api.endpointPrefix;

  return [
    [region, endpointPrefix],
    [regionPrefix, endpointPrefix],
    [region, '*'],
    [regionPrefix, '*'],
    ['*', endpointPrefix],
    ['*', '*']
  ].map(function(item) {
    return item[0] && item[1] ? item.join('/') : null;
  });
}

function applyConfig(service, config) {
  util.each(config, function(key, value) {
    if (key === 'globalEndpoint') return;
    if (service.config[key] === undefined || service.config[key] === null) {
      service.config[key] = value;
    }
  });
}

function configureEndpoint(service) {
  var keys = derivedKeys(service);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;

    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
      var config = regionConfig.rules[key];
      if (typeof config === 'string') {
        config = regionConfig.patterns[config];
      }

      // set dualstack endpoint
      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
        config = util.copy(config);
        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
      }

      // set global endpoint
      service.isGlobalEndpoint = !!config.globalEndpoint;

      // signature version
      if (!config.signatureVersion) config.signatureVersion = 'v4';

      // merge config
      applyConfig(service, config);
      return;
    }
  }
}

module.exports = configureEndpoint;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3dash","us-west-1/s3":"s3dash","us-west-2/s3":"s3dash","eu-west-1/s3":"s3dash","ap-southeast-1/s3":"s3dash","ap-southeast-2/s3":"s3dash","ap-northeast-1/s3":"s3dash","sa-east-1/s3":"s3dash","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3dash":{"endpoint":"{service}-{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(3);
var AcceptorStateMachine = __webpack_require__(1028);
var inherit = AWS.util.inherit;
var domain = AWS.util.domain;
var jmespath = __webpack_require__(120);

/**
 * @api private
 */
var hardErrorStates = {success: 1, error: 1, complete: 1};

function isTerminalState(machine) {
  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
}

var fsm = new AcceptorStateMachine();
fsm.setupStates = function() {
  var transition = function(_, done) {
    var self = this;
    self._haltHandlersOnError = false;

    self.emit(self._asm.currentState, function(err) {
      if (err) {
        if (isTerminalState(self)) {
          if (domain && self.domain instanceof domain.Domain) {
            err.domainEmitter = self;
            err.domain = self.domain;
            err.domainThrown = false;
            self.domain.emit('error', err);
          } else {
            throw err;
          }
        } else {
          self.response.error = err;
          done(err);
        }
      } else {
        done(self.response.error);
      }
    });

  };

  this.addState('validate', 'build', 'error', transition);
  this.addState('build', 'afterBuild', 'restart', transition);
  this.addState('afterBuild', 'sign', 'restart', transition);
  this.addState('sign', 'send', 'retry', transition);
  this.addState('retry', 'afterRetry', 'afterRetry', transition);
  this.addState('afterRetry', 'sign', 'error', transition);
  this.addState('send', 'validateResponse', 'retry', transition);
  this.addState('validateResponse', 'extractData', 'extractError', transition);
  this.addState('extractError', 'extractData', 'retry', transition);
  this.addState('extractData', 'success', 'retry', transition);
  this.addState('restart', 'build', 'error', transition);
  this.addState('success', 'complete', 'complete', transition);
  this.addState('error', 'complete', 'complete', transition);
  this.addState('complete', null, null, transition);
};
fsm.setupStates();

/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */
AWS.Request = inherit({

  /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */
  constructor: function Request(service, operation, params) {
    var endpoint = service.endpoint;
    var region = service.config.region;
    var customUserAgent = service.config.customUserAgent;

    // global endpoints sign as us-east-1
    if (service.isGlobalEndpoint) region = 'us-east-1';

    this.domain = domain && domain.active;
    this.service = service;
    this.operation = operation;
    this.params = params || {};
    this.httpRequest = new AWS.HttpRequest(endpoint, region);
    this.httpRequest.appendToUserAgent(customUserAgent);
    this.startTime = service.getSkewCorrectedDate();

    this.response = new AWS.Response(this);
    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
    this._haltHandlersOnError = false;

    AWS.SequentialExecutor.call(this);
    this.emit = this.emitEvent;
  },

  /**
   * @!group Sending a Request
   */

  /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */
  send: function send(callback) {
    if (callback) {
      // append to user agent
      this.httpRequest.appendToUserAgent('callback');
      this.on('complete', function (resp) {
        callback.call(resp, resp.error, resp.data);
      });
    }
    this.runTo();

    return this.response;
  },

  /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */

  /**
   * @api private
   */
  build: function build(callback) {
    return this.runTo('send', callback);
  },

  /**
   * @api private
   */
  runTo: function runTo(state, done) {
    this._asm.runTo(state, done, this);
    return this;
  },

  /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */
  abort: function abort() {
    this.removeAllListeners('validateResponse');
    this.removeAllListeners('extractError');
    this.on('validateResponse', function addAbortedError(resp) {
      resp.error = AWS.util.error(new Error('Request aborted by user'), {
         code: 'RequestAbortedError', retryable: false
      });
    });

    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
      this.httpRequest.stream.abort();
      if (this.httpRequest._abortCallback) {
         this.httpRequest._abortCallback();
      } else {
        this.removeAllListeners('send'); // haven't sent yet, so let's not
      }
    }

    return this;
  },

  /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */
  eachPage: function eachPage(callback) {
    // Make all callbacks async-ish
    callback = AWS.util.fn.makeAsync(callback, 3);

    function wrappedCallback(response) {
      callback.call(response, response.error, response.data, function (result) {
        if (result === false) return;

        if (response.hasNextPage()) {
          response.nextPage().on('complete', wrappedCallback).send();
        } else {
          callback.call(response, null, null, AWS.util.fn.noop);
        }
      });
    }

    this.on('complete', wrappedCallback).send();
  },

  /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */
  eachItem: function eachItem(callback) {
    var self = this;
    function wrappedCallback(err, data) {
      if (err) return callback(err, null);
      if (data === null) return callback(null, null);

      var config = self.service.paginationConfig(self.operation);
      var resultKey = config.resultKey;
      if (Array.isArray(resultKey)) resultKey = resultKey[0];
      var items = jmespath.search(data, resultKey);
      var continueIteration = true;
      AWS.util.arrayEach(items, function(item) {
        continueIteration = callback(null, item);
        if (continueIteration === false) {
          return AWS.util.abort;
        }
      });
      return continueIteration;
    }

    this.eachPage(wrappedCallback);
  },

  /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */
  isPageable: function isPageable() {
    return this.service.paginationConfig(this.operation) ? true : false;
  },

  /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */
  createReadStream: function createReadStream() {
    var streams = AWS.util.stream;
    var req = this;
    var stream = null;

    if (AWS.HttpClient.streamsApiVersion === 2) {
      stream = new streams.PassThrough();
      process.nextTick(function() { req.send(); });
    } else {
      stream = new streams.Stream();
      stream.readable = true;

      stream.sent = false;
      stream.on('newListener', function(event) {
        if (!stream.sent && event === 'data') {
          stream.sent = true;
          process.nextTick(function() { req.send(); });
        }
      });
    }

    this.on('error', function(err) {
      stream.emit('error', err);
    });

    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
      if (statusCode < 300) {
        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
        req.on('httpError', function streamHttpError(error) {
          resp.error = error;
          resp.error.retryable = false;
        });

        var shouldCheckContentLength = false;
        var expectedLen;
        if (req.httpRequest.method !== 'HEAD') {
          expectedLen = parseInt(headers['content-length'], 10);
        }
        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
          shouldCheckContentLength = true;
          var receivedLen = 0;
        }

        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
          if (shouldCheckContentLength && receivedLen !== expectedLen) {
            stream.emit('error', AWS.util.error(
              new Error('Stream content length mismatch. Received ' +
                receivedLen + ' of ' + expectedLen + ' bytes.'),
              { code: 'StreamContentLengthMismatch' }
            ));
          } else if (AWS.HttpClient.streamsApiVersion === 2) {
            stream.end();
          } else {
            stream.emit('end');
          }
        };

        var httpStream = resp.httpResponse.createUnbufferedStream();

        if (AWS.HttpClient.streamsApiVersion === 2) {
          if (shouldCheckContentLength) {
            var lengthAccumulator = new streams.PassThrough();
            lengthAccumulator._write = function(chunk) {
              if (chunk && chunk.length) {
                receivedLen += chunk.length;
              }
              return streams.PassThrough.prototype._write.apply(this, arguments);
            };

            lengthAccumulator.on('end', checkContentLengthAndEmit);
            stream.on('error', function(err) {
              shouldCheckContentLength = false;
              httpStream.unpipe(lengthAccumulator);
              lengthAccumulator.emit('end');
              lengthAccumulator.end();
            });
            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
          } else {
            httpStream.pipe(stream);
          }
        } else {

          if (shouldCheckContentLength) {
            httpStream.on('data', function(arg) {
              if (arg && arg.length) {
                receivedLen += arg.length;
              }
            });
          }

          httpStream.on('data', function(arg) {
            stream.emit('data', arg);
          });
          httpStream.on('end', checkContentLengthAndEmit);
        }

        httpStream.on('error', function(err) {
          shouldCheckContentLength = false;
          stream.emit('error', err);
        });
      }
    });

    return stream;
  },

  /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */
  emitEvent: function emit(eventName, args, done) {
    if (typeof args === 'function') { done = args; args = null; }
    if (!done) done = function() { };
    if (!args) args = this.eventParameters(eventName, this.response);

    var origEmit = AWS.SequentialExecutor.prototype.emit;
    origEmit.call(this, eventName, args, function (err) {
      if (err) this.response.error = err;
      done.call(this, err);
    });
  },

  /**
   * @api private
   */
  eventParameters: function eventParameters(eventName) {
    switch (eventName) {
      case 'restart':
      case 'validate':
      case 'sign':
      case 'build':
      case 'afterValidate':
      case 'afterBuild':
        return [this];
      case 'error':
        return [this.response.error, this.response];
      default:
        return [this.response];
    }
  },

  /**
   * @api private
   */
  presign: function presign(expires, callback) {
    if (!callback && typeof expires === 'function') {
      callback = expires;
      expires = null;
    }
    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
  },

  /**
   * @api private
   */
  isPresigned: function isPresigned() {
    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
  },

  /**
   * @api private
   */
  toUnauthenticated: function toUnauthenticated() {
    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
    return this;
  },

  /**
   * @api private
   */
  toGet: function toGet() {
    if (this.service.api.protocol === 'query' ||
        this.service.api.protocol === 'ec2') {
      this.removeListener('build', this.buildAsGet);
      this.addListener('build', this.buildAsGet);
    }
    return this;
  },

  /**
   * @api private
   */
  buildAsGet: function buildAsGet(request) {
    request.httpRequest.method = 'GET';
    request.httpRequest.path = request.service.endpoint.path +
                               '?' + request.httpRequest.body;
    request.httpRequest.body = '';

    // don't need these headers on a GET request
    delete request.httpRequest.headers['Content-Length'];
    delete request.httpRequest.headers['Content-Type'];
  },

  /**
   * @api private
   */
  haltHandlersOnError: function haltHandlersOnError() {
    this._haltHandlersOnError = true;
  }
});

/**
 * @api private
 */
AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = function promise() {
    var self = this;
    // append to user agent
    this.httpRequest.appendToUserAgent('promise');
    return new PromiseDependency(function(resolve, reject) {
      self.on('complete', function(resp) {
        if (resp.error) {
          reject(resp.error);
        } else {
          // define $response property so that it is not enumberable
          // this prevents circular reference errors when stringifying the JSON object
          resolve(Object.defineProperty(
            resp.data || {},
            '$response',
            {value: resp}
          ));
        }
      });
      self.runTo();
    });
  };
};

/**
 * @api private
 */
AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.Request);

AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(120);

/**
 * @api private
 */
function CHECK_ACCEPTORS(resp) {
  var waiter = resp.request._waiter;
  var acceptors = waiter.config.acceptors;
  var acceptorMatched = false;
  var state = 'retry';

  acceptors.forEach(function(acceptor) {
    if (!acceptorMatched) {
      var matcher = waiter.matchers[acceptor.matcher];
      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
        acceptorMatched = true;
        state = acceptor.state;
      }
    }
  });

  if (!acceptorMatched && resp.error) state = 'failure';

  if (state === 'success') {
    waiter.setSuccess(resp);
  } else {
    waiter.setError(resp, state === 'retry');
  }
}

/**
 * @api private
 */
AWS.ResourceWaiter = inherit({
  /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */
  constructor: function constructor(service, state) {
    this.service = service;
    this.state = state;
    this.loadWaiterConfig(this.state);
  },

  service: null,

  state: null,

  config: null,

  matchers: {
    path: function(resp, expected, argument) {
      try {
        var result = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      return jmespath.strictDeepEqual(result,expected);
    },

    pathAll: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      if (!numResults) return false;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (!jmespath.strictDeepEqual(results[ind], expected)) {
          return false;
        }
      }
      return true;
    },

    pathAny: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (jmespath.strictDeepEqual(results[ind], expected)) {
          return true;
        }
      }
      return false;
    },

    status: function(resp, expected) {
      var statusCode = resp.httpResponse.statusCode;
      return (typeof statusCode === 'number') && (statusCode === expected);
    },

    error: function(resp, expected) {
      if (typeof expected === 'string' && resp.error) {
        return expected === resp.error.code;
      }
      // if expected is not string, can be boolean indicating presence of error
      return expected === !!resp.error;
    }
  },

  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
    add('RETRY_CHECK', 'retry', function(resp) {
      var waiter = resp.request._waiter;
      if (resp.error && resp.error.code === 'ResourceNotReady') {
        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
      }
    });

    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
  }),

  /**
   * @return [AWS.Request]
   */
  wait: function wait(params, callback) {
    if (typeof params === 'function') {
      callback = params; params = undefined;
    }

    if (params && params.$waiter) {
      params = AWS.util.copy(params);
      if (typeof params.$waiter.delay === 'number') {
        this.config.delay = params.$waiter.delay;
      }
      if (typeof params.$waiter.maxAttempts === 'number') {
        this.config.maxAttempts = params.$waiter.maxAttempts;
      }
      delete params.$waiter;
    }

    var request = this.service.makeRequest(this.config.operation, params);
    request._waiter = this;
    request.response.maxRetries = this.config.maxAttempts;
    request.addListeners(this.listeners);

    if (callback) request.send(callback);
    return request;
  },

  setSuccess: function setSuccess(resp) {
    resp.error = null;
    resp.data = resp.data || {};
    resp.request.removeAllListeners('extractData');
  },

  setError: function setError(resp, retryable) {
    resp.data = null;
    resp.error = AWS.util.error(resp.error || new Error(), {
      code: 'ResourceNotReady',
      message: 'Resource is not in the state ' + this.state,
      retryable: retryable
    });
  },

  /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */
  loadWaiterConfig: function loadWaiterConfig(state) {
    if (!this.service.api.waiters[state]) {
      throw new AWS.util.error(new Error(), {
        code: 'StateNotFoundError',
        message: 'State ' + state + ' not found.'
      });
    }

    this.config = AWS.util.copy(this.service.api.waiters[state]);
  }
});


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(120);

/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */
AWS.Response = inherit({

  /**
   * @api private
   */
  constructor: function Response(request) {
    this.request = request;
    this.data = null;
    this.error = null;
    this.retryCount = 0;
    this.redirectCount = 0;
    this.httpResponse = new AWS.HttpResponse();
    if (request) {
      this.maxRetries = request.service.numRetries();
      this.maxRedirects = request.service.config.maxRedirects;
    }
  },

  /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */
  nextPage: function nextPage(callback) {
    var config;
    var service = this.request.service;
    var operation = this.request.operation;
    try {
      config = service.paginationConfig(operation, true);
    } catch (e) { this.error = e; }

    if (!this.hasNextPage()) {
      if (callback) callback(this.error, null);
      else if (this.error) throw this.error;
      return null;
    }

    var params = AWS.util.copy(this.request.params);
    if (!this.nextPageTokens) {
      return callback ? callback(null, null) : null;
    } else {
      var inputTokens = config.inputToken;
      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
      for (var i = 0; i < inputTokens.length; i++) {
        params[inputTokens[i]] = this.nextPageTokens[i];
      }
      return service.makeRequest(this.request.operation, params, callback);
    }
  },

  /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */
  hasNextPage: function hasNextPage() {
    this.cacheNextPageTokens();
    if (this.nextPageTokens) return true;
    if (this.nextPageTokens === undefined) return undefined;
    else return false;
  },

  /**
   * @api private
   */
  cacheNextPageTokens: function cacheNextPageTokens() {
    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
    this.nextPageTokens = undefined;

    var config = this.request.service.paginationConfig(this.request.operation);
    if (!config) return this.nextPageTokens;

    this.nextPageTokens = null;
    if (config.moreResults) {
      if (!jmespath.search(this.data, config.moreResults)) {
        return this.nextPageTokens;
      }
    }

    var exprs = config.outputToken;
    if (typeof exprs === 'string') exprs = [exprs];
    AWS.util.arrayEach.call(this, exprs, function (expr) {
      var output = jmespath.search(this.data, expr);
      if (output) {
        this.nextPageTokens = this.nextPageTokens || [];
        this.nextPageTokens.push(output);
      }
    });

    return this.nextPageTokens;
  }

});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var byteLength = AWS.util.string.byteLength;
var Buffer = AWS.util.Buffer;

/**
 * The managed uploader allows for easy and efficient uploading of buffers,
 * blobs, or streams, using a configurable amount of concurrency to perform
 * multipart uploads where possible. This abstraction also enables uploading
 * streams of unknown size due to the use of multipart uploads.
 *
 * To construct a managed upload object, see the {constructor} function.
 *
 * ## Tracking upload progress
 *
 * The managed upload object can also track progress by attaching an
 * 'httpUploadProgress' listener to the upload manager. This event is similar
 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
 * information.
 *
 * ## Handling Multipart Cleanup
 *
 * By default, this class will automatically clean up any multipart uploads
 * when an individual part upload fails. This behavior can be disabled in order
 * to manually handle failures by setting the `leavePartsOnError` configuration
 * option to `true` when initializing the upload object.
 *
 * @!event httpUploadProgress(progress)
 *   Triggered when the uploader has uploaded more data.
 *   @note The `total` property may not be set if the stream being uploaded has
 *     not yet finished chunking. In this case the `total` will be undefined
 *     until the total stream size is known.
 *   @note This event will not be emitted in Node.js 0.8.x.
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
 *     size is known.
 *   @context (see AWS.Request~send)
 */
AWS.S3.ManagedUpload = AWS.util.inherit({
  /**
   * Creates a managed upload object with a set of configuration options.
   *
   * @note A "Body" parameter is required to be set prior to calling {send}.
   * @option options params [map] a map of parameters to pass to the upload
   *   requests. The "Body" parameter is required to be specified either on
   *   the service or in the params option.
   * @note ContentMD5 should not be provided when using the managed upload object.
   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
   *   by the managed upload object.
   * @option options queueSize [Number] (4) the size of the concurrent queue
   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
   *   of parts. Note that the uploader will buffer at most queueSize * partSize
   *   bytes into memory at any given time.
   * @option options partSize [Number] (5mb) the size in bytes for each
   *   individual part to be uploaded. Adjust the part size to ensure the number
   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
   *   minimum allowed part size.
   * @option options leavePartsOnError [Boolean] (false) whether to abort the
   *   multipart upload if an error occurs. Set to true if you want to handle
   *   failures manually.
   * @option options service [AWS.S3] an optional S3 service object to use for
   *   requests. This object might have bound parameters used by the uploader.
   * @option options tags [Array<map>] The tags to apply to the uploaded object.
   *   Each tag should have a `Key` and `Value` keys.
   * @example Creating a default uploader for a stream object
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
   *   var upload = new AWS.S3.ManagedUpload({
   *     partSize: 10 * 1024 * 1024, queueSize: 1,
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with tags
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
   *   });
   * @see send
   */
  constructor: function ManagedUpload(options) {
    var self = this;
    AWS.SequentialExecutor.call(self);
    self.body = null;
    self.sliceFn = null;
    self.callback = null;
    self.parts = {};
    self.completeInfo = [];
    self.fillQueue = function() {
      self.callback(new Error('Unsupported body payload ' + typeof self.body));
    };

    self.configure(options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    options = options || {};
    this.partSize = this.minPartSize;

    if (options.queueSize) this.queueSize = options.queueSize;
    if (options.partSize) this.partSize = options.partSize;
    if (options.leavePartsOnError) this.leavePartsOnError = true;
    if (options.tags) {
      if (!Array.isArray(options.tags)) {
        throw new Error('Tags must be specified as an array; ' +
          typeof options.tags + ' provided.');
      }
      this.tags = options.tags;
    }

    if (this.partSize < this.minPartSize) {
      throw new Error('partSize must be greater than ' +
                      this.minPartSize);
    }

    this.service = options.service;
    this.bindServiceObject(options.params);
    this.validateBody();
    this.adjustTotalBytes();
  },

  /**
   * @api private
   */
  leavePartsOnError: false,

  /**
   * @api private
   */
  queueSize: 4,

  /**
   * @api private
   */
  partSize: null,

  /**
   * @readonly
   * @return [Number] the minimum number of bytes for an individual part
   *   upload.
   */
  minPartSize: 1024 * 1024 * 5,

  /**
   * @readonly
   * @return [Number] the maximum allowed number of parts in a multipart upload.
   */
  maxTotalParts: 10000,

  /**
   * Initiates the managed upload for the payload.
   *
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *     * `Location` (String) the URL of the uploaded object
   *     * `ETag` (String) the ETag of the uploaded object
   *     * `Bucket` (String) the bucket to which the object was uploaded
   *     * `Key` (String) the key to which the object was uploaded
   * @example Sending a managed upload object
   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *   var upload = new AWS.S3.ManagedUpload({params: params});
   *   upload.send(function(err, data) {
   *     console.log(err, data);
   *   });
   */
  send: function(callback) {
    var self = this;
    self.failed = false;
    self.callback = callback || function(err) { if (err) throw err; };

    var runFill = true;
    if (self.sliceFn) {
      self.fillQueue = self.fillBuffer;
    } else if (AWS.util.isNode()) {
      var Stream = AWS.util.stream.Stream;
      if (self.body instanceof Stream) {
        runFill = false;
        self.fillQueue = self.fillStream;
        self.partBuffers = [];
        self.body.
          on('error', function(err) { self.cleanup(err); }).
          on('readable', function() { self.fillQueue(); }).
          on('end', function() {
            self.isDoneChunking = true;
            self.numParts = self.totalPartNumbers;
            self.fillQueue.call(self);

            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
              self.finishMultiPart();
            }
          });
      }
    }

    if (runFill) self.fillQueue.call(self);
  },

  /**
   * @!method  promise()
   *   Returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [map] The response data from the successful upload:
   *       `Location` (String) the URL of the uploaded object
   *       `ETag` (String) the ETag of the uploaded object
   *       `Bucket` (String) the bucket to which the object was uploaded
   *       `Key` (String) the key to which the object was uploaded
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] an error or null if no error occurred.
   *   @return [Promise] A promise that represents the state of the upload request.
   *   @example Sending an upload request using promises.
   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
   *     var promise = upload.promise();
   *     promise.then(function(data) { ... }, function(err) { ... });
   */

  /**
   * Aborts a managed upload, including all concurrent upload requests.
   * @note By default, calling this function will cleanup a multipart upload
   *   if one was created. To leave the multipart upload around after aborting
   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
   * @note Calling {abort} in the browser environment will not abort any requests
   *   that are already in flight. If a multipart upload was created, any parts
   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
   * @example Aborting an upload
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 25) // 25MB payload
   *   };
   *   var upload = s3.upload(params);
   *   upload.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(upload.abort.bind(upload), 1000);
   */
  abort: function() {
    this.cleanup(AWS.util.error(new Error('Request aborted by user'), {
      code: 'RequestAbortedError', retryable: false
    }));
  },

  /**
   * @api private
   */
  validateBody: function validateBody() {
    var self = this;
    self.body = self.service.config.params.Body;
    if (typeof self.body === 'string') {
      self.body = new AWS.util.Buffer(self.body);
    } else if (!self.body) {
      throw new Error('params.Body is required');
    }
    self.sliceFn = AWS.util.arraySliceFn(self.body);
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(params) {
    params = params || {};
    var self = this;
    // bind parameters to new service object
    if (!self.service) {
      self.service = new AWS.S3({params: params});
    } else {
      var service = self.service;
      var config = AWS.util.copy(service.config);
      config.signatureVersion = service.getSignatureVersion();
      self.service = new service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, params);
    }
  },

  /**
   * @api private
   */
  adjustTotalBytes: function adjustTotalBytes() {
    var self = this;
    try { // try to get totalBytes
      self.totalBytes = byteLength(self.body);
    } catch (e) { }

    // try to adjust partSize if we know payload length
    if (self.totalBytes) {
      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
      if (newPartSize > self.partSize) self.partSize = newPartSize;
    } else {
      self.totalBytes = undefined;
    }
  },

  /**
   * @api private
   */
  isDoneChunking: false,

  /**
   * @api private
   */
  partPos: 0,

  /**
   * @api private
   */
  totalChunkedBytes: 0,

  /**
   * @api private
   */
  totalUploadedBytes: 0,

  /**
   * @api private
   */
  totalBytes: undefined,

  /**
   * @api private
   */
  numParts: 0,

  /**
   * @api private
   */
  totalPartNumbers: 0,

  /**
   * @api private
   */
  activeParts: 0,

  /**
   * @api private
   */
  doneParts: 0,

  /**
   * @api private
   */
  parts: null,

  /**
   * @api private
   */
  completeInfo: null,

  /**
   * @api private
   */
  failed: false,

  /**
   * @api private
   */
  multipartReq: null,

  /**
   * @api private
   */
  partBuffers: null,

  /**
   * @api private
   */
  partBufferLength: 0,

  /**
   * @api private
   */
  fillBuffer: function fillBuffer() {
    var self = this;
    var bodyLen = byteLength(self.body);

    if (bodyLen === 0) {
      self.isDoneChunking = true;
      self.numParts = 1;
      self.nextChunk(self.body);
      return;
    }

    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
      self.partPos += self.partSize;

      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
        self.isDoneChunking = true;
        self.numParts = self.totalPartNumbers + 1;
      }
      self.nextChunk(buf);
    }
  },

  /**
   * @api private
   */
  fillStream: function fillStream() {
    var self = this;
    if (self.activeParts >= self.queueSize) return;

    var buf = self.body.read(self.partSize - self.partBufferLength) ||
              self.body.read();
    if (buf) {
      self.partBuffers.push(buf);
      self.partBufferLength += buf.length;
      self.totalChunkedBytes += buf.length;
    }

    if (self.partBufferLength >= self.partSize) {
      // if we have single buffer we avoid copyfull concat
      var pbuf = self.partBuffers.length === 1 ?
        self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;

      // if we have more than partSize, push the rest back on the queue
      if (pbuf.length > self.partSize) {
        var rest = pbuf.slice(self.partSize);
        self.partBuffers.push(rest);
        self.partBufferLength += rest.length;
        pbuf = pbuf.slice(0, self.partSize);
      }

      self.nextChunk(pbuf);
    }

    if (self.isDoneChunking && !self.isDoneSending) {
      // if we have single buffer we avoid copyfull concat
      pbuf = self.partBuffers.length === 1 ?
          self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;
      self.totalBytes = self.totalChunkedBytes;
      self.isDoneSending = true;

      if (self.numParts === 0 || pbuf.length > 0) {
        self.numParts++;
        self.nextChunk(pbuf);
      }
    }

    self.body.read(0);
  },

  /**
   * @api private
   */
  nextChunk: function nextChunk(chunk) {
    var self = this;
    if (self.failed) return null;

    var partNumber = ++self.totalPartNumbers;
    if (self.isDoneChunking && partNumber === 1) {
      var params = {Body: chunk};
      if (this.tags) {
        params.Tagging = this.getTaggingHeader();
      }
      var req = self.service.putObject(params);
      req._managedUpload = self;
      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
      return null;
    } else if (self.service.config.params.ContentMD5) {
      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
        code: 'InvalidDigest', retryable: false
      });

      self.cleanup(err);
      return null;
    }

    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
      return null; // Already uploaded this part.
    }

    self.activeParts++;
    if (!self.service.config.params.UploadId) {

      if (!self.multipartReq) { // create multipart
        self.multipartReq = self.service.createMultipartUpload();
        self.multipartReq.on('success', function(resp) {
          self.service.config.params.UploadId = resp.data.UploadId;
          self.multipartReq = null;
        });
        self.queueChunks(chunk, partNumber);
        self.multipartReq.on('error', function(err) {
          self.cleanup(err);
        });
        self.multipartReq.send();
      } else {
        self.queueChunks(chunk, partNumber);
      }
    } else { // multipart is created, just send
      self.uploadPart(chunk, partNumber);
    }
  },

  /**
   * @api private
   */
  getTaggingHeader: function getTaggingHeader() {
    var kvPairStrings = [];
    for (var i = 0; i < this.tags.length; i++) {
      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
        AWS.util.uriEscape(this.tags[i].Value));
    }

    return kvPairStrings.join('&');
  },

  /**
   * @api private
   */
  uploadPart: function uploadPart(chunk, partNumber) {
    var self = this;

    var partParams = {
      Body: chunk,
      ContentLength: AWS.util.string.byteLength(chunk),
      PartNumber: partNumber
    };

    var partInfo = {ETag: null, PartNumber: partNumber};
    self.completeInfo[partNumber] = partInfo;

    var req = self.service.uploadPart(partParams);
    self.parts[partNumber] = req;
    req._lastUploadedBytes = 0;
    req._managedUpload = self;
    req.on('httpUploadProgress', self.progress);
    req.send(function(err, data) {
      delete self.parts[partParams.PartNumber];
      self.activeParts--;

      if (!err && (!data || !data.ETag)) {
        var message = 'No access to ETag property on response.';
        if (AWS.util.isBrowser()) {
          message += ' Check CORS configuration to expose ETag header.';
        }

        err = AWS.util.error(new Error(message), {
          code: 'ETagMissing', retryable: false
        });
      }
      if (err) return self.cleanup(err);

      partInfo.ETag = data.ETag;
      self.doneParts++;
      if (self.isDoneChunking && self.doneParts === self.numParts) {
        self.finishMultiPart();
      } else {
        self.fillQueue.call(self);
      }
    });
  },

  /**
   * @api private
   */
  queueChunks: function queueChunks(chunk, partNumber) {
    var self = this;
    self.multipartReq.on('success', function() {
      self.uploadPart(chunk, partNumber);
    });
  },

  /**
   * @api private
   */
  cleanup: function cleanup(err) {
    var self = this;
    if (self.failed) return;

    // clean up stream
    if (typeof self.body.removeAllListeners === 'function' &&
        typeof self.body.resume === 'function') {
      self.body.removeAllListeners('readable');
      self.body.removeAllListeners('end');
      self.body.resume();
    }

    // cleanup multipartReq listeners
    if (self.multipartReq) {
      self.multipartReq.removeAllListeners('success');
      self.multipartReq.removeAllListeners('error');
      self.multipartReq.removeAllListeners('complete');
      delete self.multipartReq;
    }

    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
      self.service.abortMultipartUpload().send();
    } else if (self.leavePartsOnError) {
      self.isDoneChunking = false;
    }

    AWS.util.each(self.parts, function(partNumber, part) {
      part.removeAllListeners('complete');
      part.abort();
    });

    self.activeParts = 0;
    self.partPos = 0;
    self.numParts = 0;
    self.totalPartNumbers = 0;
    self.parts = {};
    self.failed = true;
    self.callback(err);
  },

  /**
   * @api private
   */
  finishMultiPart: function finishMultiPart() {
    var self = this;
    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
    self.service.completeMultipartUpload(completeParams, function(err, data) {
      if (err) {
        return self.cleanup(err);
      }

      if (data && typeof data.Location === 'string') {
        data.Location = data.Location.replace(/%2F/g, '/');
      }

      if (Array.isArray(self.tags)) {
        self.service.putObjectTagging(
          {Tagging: {TagSet: self.tags}},
          function(e, d) {
            if (e) {
              self.callback(e);
            } else {
              self.callback(e, data);
            }
          }
        );
      } else {
        self.callback(err, data);
      }
    });
  },

  /**
   * @api private
   */
  finishSinglePart: function finishSinglePart(err, data) {
    var upload = this.request._managedUpload;
    var httpReq = this.request.httpRequest;
    var endpoint = httpReq.endpoint;
    if (err) return upload.callback(err);
    data.Location =
      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
    data.key = this.request.params.Key; // will stay undocumented
    data.Key = this.request.params.Key;
    data.Bucket = this.request.params.Bucket;
    upload.callback(err, data);
  },

  /**
   * @api private
   */
  progress: function progress(info) {
    var upload = this._managedUpload;
    if (this.operation === 'putObject') {
      info.part = 1;
      info.key = this.params.Key;
    } else {
      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
      this._lastUploadedBytes = info.loaded;
      info = {
        loaded: upload.totalUploadedBytes,
        total: upload.totalBytes,
        part: this.params.PartNumber,
        key: this.params.Key
      };
    }
    upload.emit('httpUploadProgress', [info]);
  }
});

AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);

/**
 * @api private
 */
AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
};

/**
 * @api private
 */
AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.S3.ManagedUpload);

module.exports = AWS.S3.ManagedUpload;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var Api = __webpack_require__(360);
var regionConfig = __webpack_require__(1001);
var inherit = AWS.util.inherit;
var clientCount = 0;

/**
 * The service class representing an AWS service.
 *
 * @abstract
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */
AWS.Service = inherit({
  /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */
  constructor: function Service(config) {
    if (!this.loadServiceClass) {
      throw AWS.util.error(new Error(),
        'Service must be constructed with `new\' operator');
    }
    var ServiceClass = this.loadServiceClass(config || {});
    if (ServiceClass) {
      var originalConfig = AWS.util.copy(config);
      var svc = new ServiceClass(config);
      Object.defineProperty(svc, '_originalConfig', {
        get: function() { return originalConfig; },
        enumerable: false,
        configurable: true
      });
      svc._clientId = ++clientCount;
      return svc;
    }
    this.initialize(config);
  },

  /**
   * @api private
   */
  initialize: function initialize(config) {
    var svcConfig = AWS.config[this.serviceIdentifier];

    this.config = new AWS.Config(AWS.config);
    if (svcConfig) this.config.update(svcConfig, true);
    if (config) this.config.update(config, true);

    this.validateService();
    if (!this.config.endpoint) regionConfig(this);

    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
    this.setEndpoint(this.config.endpoint);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
  },

  /**
   * @api private
   */
  loadServiceClass: function loadServiceClass(serviceConfig) {
    var config = serviceConfig;
    if (!AWS.util.isEmpty(this.api)) {
      return null;
    } else if (config.apiConfig) {
      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
    } else if (!this.constructor.services) {
      return null;
    } else {
      config = new AWS.Config(AWS.config);
      config.update(serviceConfig, true);
      var version = config.apiVersions[this.constructor.serviceIdentifier];
      version = version || config.apiVersion;
      return this.getLatestServiceClass(version);
    }
  },

  /**
   * @api private
   */
  getLatestServiceClass: function getLatestServiceClass(version) {
    version = this.getLatestServiceVersion(version);
    if (this.constructor.services[version] === null) {
      AWS.Service.defineServiceApi(this.constructor, version);
    }

    return this.constructor.services[version];
  },

  /**
   * @api private
   */
  getLatestServiceVersion: function getLatestServiceVersion(version) {
    if (!this.constructor.services || this.constructor.services.length === 0) {
      throw new Error('No services defined on ' +
                      this.constructor.serviceIdentifier);
    }

    if (!version) {
      version = 'latest';
    } else if (AWS.util.isType(version, Date)) {
      version = AWS.util.date.iso8601(version).split('T')[0];
    }

    if (Object.hasOwnProperty(this.constructor.services, version)) {
      return version;
    }

    var keys = Object.keys(this.constructor.services).sort();
    var selectedVersion = null;
    for (var i = keys.length - 1; i >= 0; i--) {
      // versions that end in "*" are not available on disk and can be
      // skipped, so do not choose these as selectedVersions
      if (keys[i][keys[i].length - 1] !== '*') {
        selectedVersion = keys[i];
      }
      if (keys[i].substr(0, 10) <= version) {
        return selectedVersion;
      }
    }

    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
                    ' API to satisfy version constraint `' + version + '\'');
  },

  /**
   * @api private
   */
  api: {},

  /**
   * @api private
   */
  defaultRetryCount: 3,

  /**
   * @api private
   */
  customizeRequests: function customizeRequests(callback) {
    if (!callback) {
      this.customRequestHandler = null;
    } else if (typeof callback === 'function') {
      this.customRequestHandler = callback;
    } else {
      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    }
  },

  /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeRequest: function makeRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = null;
    }

    params = params || {};
    if (this.config.params) { // copy only toplevel bound params
      var rules = this.api.operations[operation];
      if (rules) {
        params = AWS.util.copy(params);
        AWS.util.each(this.config.params, function(key, value) {
          if (rules.input.members[key]) {
            if (params[key] === undefined || params[key] === null) {
              params[key] = value;
            }
          }
        });
      }
    }

    var request = new AWS.Request(this, operation, params);
    this.addAllRequestListeners(request);

    if (callback) request.send(callback);
    return request;
  },

  /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = {};
    }

    var request = this.makeRequest(operation, params).toUnauthenticated();
    return callback ? request.send(callback) : request;
  },

  /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  waitFor: function waitFor(state, params, callback) {
    var waiter = new AWS.ResourceWaiter(this, state);
    return waiter.wait(params, callback);
  },

  /**
   * @api private
   */
  addAllRequestListeners: function addAllRequestListeners(request) {
    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
                AWS.EventListeners.CorePost];
    for (var i = 0; i < list.length; i++) {
      if (list[i]) request.addListeners(list[i]);
    }

    // disable parameter validation
    if (!this.config.paramValidation) {
      request.removeListener('validate',
        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    }

    if (this.config.logger) { // add logging events
      request.addListeners(AWS.EventListeners.Logger);
    }

    this.setupRequestListeners(request);
    // call prototype's customRequestHandler
    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
      this.constructor.prototype.customRequestHandler(request);
    }
    // call instance's customRequestHandler
    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
      this.customRequestHandler(request);
    }
  },

  /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @abstract
   */
  setupRequestListeners: function setupRequestListeners() {
  },

  /**
   * Gets the signer class for a given request
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var version;
    // get operation authtype if present
    var operation = null;
    var authtype = '';
    if (request) {
      var operations = request.service.api.operations || {};
      operation = operations[request.operation] || null;
      authtype = operation ? operation.authtype : '';
    }
    if (this.config.signatureVersion) {
      version = this.config.signatureVersion;
    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
      version = 'v4';
    } else {
      version = this.api.signatureVersion;
    }
    return AWS.Signers.RequestSigner.getVersion(version);
  },

  /**
   * @api private
   */
  serviceInterface: function serviceInterface() {
    switch (this.api.protocol) {
      case 'ec2': return AWS.EventListeners.Query;
      case 'query': return AWS.EventListeners.Query;
      case 'json': return AWS.EventListeners.Json;
      case 'rest-json': return AWS.EventListeners.RestJson;
      case 'rest-xml': return AWS.EventListeners.RestXml;
    }
    if (this.api.protocol) {
      throw new Error('Invalid service `protocol\' ' +
        this.api.protocol + ' in API config');
    }
  },

  /**
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    return resp.httpResponse.statusCode < 300;
  },

  /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */
  numRetries: function numRetries() {
    if (this.config.maxRetries !== undefined) {
      return this.config.maxRetries;
    } else {
      return this.defaultRetryCount;
    }
  },

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
  },

  /**
   * @api private
   */
  retryableError: function retryableError(error) {
    if (this.timeoutError(error)) return true;
    if (this.networkingError(error)) return true;
    if (this.expiredCredentialsError(error)) return true;
    if (this.throttledError(error)) return true;
    if (error.statusCode >= 500) return true;
    return false;
  },

  /**
   * @api private
   */
  networkingError: function networkingError(error) {
    return error.code === 'NetworkingError';
  },

  /**
   * @api private
   */
  timeoutError: function timeoutError(error) {
    return error.code === 'TimeoutError';
  },

  /**
   * @api private
   */
  expiredCredentialsError: function expiredCredentialsError(error) {
    // TODO : this only handles *one* of the expired credential codes
    return (error.code === 'ExpiredTokenException');
  },

  /**
   * @api private
   */
  clockSkewError: function clockSkewError(error) {
    switch (error.code) {
      case 'RequestTimeTooSkewed':
      case 'RequestExpired':
      case 'InvalidSignatureException':
      case 'SignatureDoesNotMatch':
      case 'AuthFailure':
      case 'RequestInTheFuture':
        return true;
      default: return false;
    }
  },

  /**
   * @api private
   */
  getSkewCorrectedDate: function getSkewCorrectedDate() {
    return new Date(Date.now() + this.config.systemClockOffset);
  },

  /**
   * @api private
   */
  applyClockOffset: function applyClockOffset(newServerTime) {
    if (newServerTime) {
      this.config.systemClockOffset = newServerTime - Date.now();
    }
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(newServerTime) {
    if (newServerTime) {
      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
    }
  },

  /**
   * @api private
   */
  throttledError: function throttledError(error) {
    // this logic varies between services
    switch (error.code) {
      case 'ProvisionedThroughputExceededException':
      case 'Throttling':
      case 'ThrottlingException':
      case 'RequestLimitExceeded':
      case 'RequestThrottled':
        return true;
      default:
        return false;
    }
  },

  /**
   * @api private
   */
  endpointFromTemplate: function endpointFromTemplate(endpoint) {
    if (typeof endpoint !== 'string') return endpoint;

    var e = endpoint;
    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
    e = e.replace(/\{region\}/g, this.config.region);
    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
    return e;
  },

  /**
   * @api private
   */
  setEndpoint: function setEndpoint(endpoint) {
    this.endpoint = new AWS.Endpoint(endpoint, this.config);
  },

  /**
   * @api private
   */
  paginationConfig: function paginationConfig(operation, throwException) {
    var paginator = this.api.operations[operation].paginator;
    if (!paginator) {
      if (throwException) {
        var e = new Error();
        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
      }
      return null;
    }

    return paginator;
  }
});

AWS.util.update(AWS.Service, {

  /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */
  defineMethods: function defineMethods(svc) {
    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
      if (svc.prototype[method]) return;
      var operation = svc.prototype.api.operations[method];
      if (operation.authtype === 'none') {
        svc.prototype[method] = function (params, callback) {
          return this.makeUnauthenticatedRequest(method, params, callback);
        };
      } else {
        svc.prototype[method] = function (params, callback) {
          return this.makeRequest(method, params, callback);
        };
      }
    });
  },

  /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */
  defineService: function defineService(serviceIdentifier, versions, features) {
    AWS.Service._serviceMap[serviceIdentifier] = true;
    if (!Array.isArray(versions)) {
      features = versions;
      versions = [];
    }

    var svc = inherit(AWS.Service, features || {});

    if (typeof serviceIdentifier === 'string') {
      AWS.Service.addVersions(svc, versions);

      var identifier = svc.serviceIdentifier || serviceIdentifier;
      svc.serviceIdentifier = identifier;
    } else { // defineService called with an API
      svc.prototype.api = serviceIdentifier;
      AWS.Service.defineMethods(svc);
    }

    return svc;
  },

  /**
   * @api private
   */
  addVersions: function addVersions(svc, versions) {
    if (!Array.isArray(versions)) versions = [versions];

    svc.services = svc.services || {};
    for (var i = 0; i < versions.length; i++) {
      if (svc.services[versions[i]] === undefined) {
        svc.services[versions[i]] = null;
      }
    }

    svc.apiVersions = Object.keys(svc.services).sort();
  },

  /**
   * @api private
   */
  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
    var svc = inherit(superclass, {
      serviceIdentifier: superclass.serviceIdentifier
    });

    function setApi(api) {
      if (api.isApi) {
        svc.prototype.api = api;
      } else {
        svc.prototype.api = new Api(api);
      }
    }

    if (typeof version === 'string') {
      if (apiConfig) {
        setApi(apiConfig);
      } else {
        try {
          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
        } catch (err) {
          throw AWS.util.error(err, {
            message: 'Could not find API configuration ' +
              superclass.serviceIdentifier + '-' + version
          });
        }
      }
      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
      }
      superclass.services[version] = svc;
    } else {
      setApi(version);
    }

    AWS.Service.defineMethods(svc);
    return svc;
  },

  /**
   * @api private
   */
  hasService: function(identifier) {
    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
  },

  /**
   * @api private
   */
  _serviceMap: {}
});

module.exports = AWS.Service;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.APIGateway.prototype, {
/**
 * Sets the Accept header to application/json.
 *
 * @api private
 */
  setAcceptHeader: function setAcceptHeader(req) {
    var httpRequest = req.httpRequest;
    if (!httpRequest.headers.Accept) {
      httpRequest.headers['Accept'] = 'application/json';
    }
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.setAcceptHeader);
    if (request.operation === 'getExport') {
      var params = request.params || {};
      if (params.exportType === 'swagger') {
        request.addListener('extractData', AWS.util.convertPayloadToString);
      }
    }
  }
});



/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

// pull in CloudFront signer
__webpack_require__(985);

AWS.util.update(AWS.CloudFront.prototype, {

  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('extractData', AWS.util.hoistPayloadMember);
  }

});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.CognitoIdentity.prototype, {
  getOpenIdToken: function getOpenIdToken(params, callback) {
    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
  },

  getId: function getId(params, callback) {
    return this.makeUnauthenticatedRequest('getId', params, callback);
  },

  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
  }
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
__webpack_require__(992);

AWS.util.update(AWS.DynamoDB.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.service.config.dynamoDbCrc32) {
      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
      request.addListener('extractData', this.checkCrc32);
      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
    }
  },

  /**
   * @api private
   */
  checkCrc32: function checkCrc32(resp) {
    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
      resp.data = null;
      resp.error = AWS.util.error(new Error(), {
        code: 'CRC32CheckFailed',
        message: 'CRC32 integrity check failed',
        retryable: true
      });
      resp.request.haltHandlersOnError();
      throw (resp.error);
    }
  },

  /**
   * @api private
   */
  crc32IsValid: function crc32IsValid(resp) {
    var crc = resp.httpResponse.headers['x-amz-crc32'];
    if (!crc) return true; // no (valid) CRC32 header
    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
  },

  /**
   * @api private
   */
  defaultRetryCount: 10,

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);

    if (typeof retryDelayOptions.base !== 'number') {
        retryDelayOptions.base = 50; // default for dynamodb
    }
    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions);
    return delay;
  }
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.EC2.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
    request.addListener('extractError', this.extractError);

    if (request.operation === 'copySnapshot') {
      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
    }
  },

  /**
   * @api private
   */
  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
    if (req.params.PresignedUrl || req._subRequest) {
      return done();
    }

    req.params = AWS.util.copy(req.params);
    req.params.DestinationRegion = req.service.config.region;

    var config = AWS.util.copy(req.service.config);
    delete config.endpoint;
    config.region = req.params.SourceRegion;
    var svc = new req.service.constructor(config);
    var newReq = svc[req.operation](req.params);
    newReq._subRequest = true;
    newReq.presign(function(err, url) {
      if (err) done(err);
      else {
        req.params.PresignedUrl = url;
        done();
      }
    });
  },

  /**
   * @api private
   */
  extractError: function extractError(resp) {
    // EC2 nests the error code and message deeper than other AWS Query services.
    var httpResponse = resp.httpResponse;
    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
    if (data.Errors) {
      resp.error = AWS.util.error(new Error(), {
        code: data.Errors.Error.Code,
        message: data.Errors.Error.Message
      });
    } else {
      resp.error = AWS.util.error(new Error(), {
        code: httpResponse.statusCode,
        message: null
      });
    }
    resp.error.requestId = data.RequestID || null;
  }
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

/**
 * @api private
 */
var blobPayloadOutputOps = [
  'deleteThingShadow',
  'getThingShadow',
  'updateThingShadow'
];

/**
 * Constructs a service interface object. Each API operation is exposed as a
 * function on service.
 *
 * ### Sending a Request Using IotData
 *
 * ```javascript
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * iotdata.getThingShadow(params, function (err, data) {
 *   if (err) console.log(err, err.stack); // an error occurred
 *   else     console.log(data);           // successful response
 * });
 * ```
 *
 * ### Locking the API Version
 *
 * In order to ensure that the IotData object uses this specific API,
 * you can construct the object by passing the `apiVersion` option to the
 * constructor:
 *
 * ```javascript
 * var iotdata = new AWS.IotData({
 *   endpoint: 'my.host.tld',
 *   apiVersion: '2015-05-28'
 * });
 * ```
 *
 * You can also set the API version globally in `AWS.config.apiVersions` using
 * the **iotdata** service identifier:
 *
 * ```javascript
 * AWS.config.apiVersions = {
 *   iotdata: '2015-05-28',
 *   // other service API versions
 * };
 *
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * ```
 *
 * @note You *must* provide an `endpoint` configuration parameter when
 *   constructing this service. See {constructor} for more information.
 *
 * @!method constructor(options = {})
 *   Constructs a service object. This object has one method for each
 *   API operation.
 *
 *   @example Constructing a IotData object
 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 *   @note You *must* provide an `endpoint` when constructing this service.
 *   @option (see AWS.Config.constructor)
 *
 * @service iotdata
 * @version 2015-05-28
 */
AWS.util.update(AWS.IotData.prototype, {
    /**
     * @api private
     */
    validateService: function validateService() {
        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
            var msg = 'AWS.IotData requires an explicit ' +
                '`endpoint\' configuration option.';
            throw AWS.util.error(new Error(),
                {name: 'InvalidEndpoint', message: msg});
        }
    },

    /**
     * @api private
     */
    setupRequestListeners: function setupRequestListeners(request) {
        request.addListener('validateResponse', this.validateResponseBody);
        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
            request.addListener('extractData', AWS.util.convertPayloadToString);
        }
    },

    /**
     * @api private
     */
    validateResponseBody: function validateResponseBody(resp) {
        var body = resp.httpResponse.body.toString() || '{}';
        var bodyCheck = body.trim();
        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
            resp.httpResponse.body = '';
        }
    }

});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.Lambda.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'invoke') {
      request.addListener('extractData', AWS.util.convertPayloadToString);
    }
  }
});



/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.MachineLearning.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'predict') {
      request.addListener('build', this.buildEndpoint);
    }
  },

  /**
   * Updates request endpoint from PredictEndpoint
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.params.PredictEndpoint;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);
    }
  }

});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(998);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
__webpack_require__(1000);
 /**
  * @api private
  */
 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot'];

 AWS.util.update(AWS.RDS.prototype, {
   /**
    * @api private
    */
   setupRequestListeners: function setupRequestListeners(request) {
     if (crossRegionOperations.indexOf(request.operation) !== -1 &&
         request.params.SourceRegion) {
       request.params = AWS.util.copy(request.params);
       if (request.params.PreSignedUrl ||
           request.params.SourceRegion === this.config.region) {
         delete request.params.SourceRegion;
       } else {
         var doesParamValidation = !!this.config.paramValidation;
         // remove the validate parameters listener so we can re-add it after we build the URL
         if (doesParamValidation) {
           request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
         request.onAsync('validate', this.buildCrossRegionPresignedUrl);
         if (doesParamValidation) {
           request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
       }
     }
   },

   /**
    * @api private
    */
   buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
     var config = AWS.util.copy(req.service.config);
     config.region = req.params.SourceRegion;
     delete req.params.SourceRegion;
     delete config.endpoint;
     // relevant params for the operation will already be in req.params
     delete config.params;
     config.signatureVersion = 'v4';
     var destinationRegion = req.service.config.region;

     var svc = new req.service.constructor(config);
     var newReq = svc[req.operation](AWS.util.copy(req.params));
     newReq.on('build', function addDestinationRegionParam(request) {
       var httpRequest = request.httpRequest;
       httpRequest.params.DestinationRegion = destinationRegion;
       httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
     });
     newReq.presign(function(err, url) {
       if (err) done(err);
       else {
         req.params.PreSignedUrl = url;
         done();
       }
     });
   }
 });

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.Route53.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.on('build', this.sanitizeUrl);
  },

  /**
   * @api private
   */
  sanitizeUrl: function sanitizeUrl(request) {
    var path = request.httpRequest.path;
    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error) {
    if (error.code === 'PriorRequestNotComplete' &&
        error.statusCode === 400) {
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error);
    }
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var v4Credentials = __webpack_require__(370);

// Pull in managed upload extension
__webpack_require__(1006);

/**
 * @api private
 */
var operationsWith200StatusCodeError = {
  'completeMultipartUpload': true,
  'copyObject': true,
  'uploadPartCopy': true
};

/**
 * @api private
 */
 var regionRedirectErrorCodes = [
  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
  'BadRequest', // head operations on virtual-hosted global bucket endpoints
  'PermanentRedirect', // non-head operations on path-style or regional endpoints
  301 // head operations on path-style or regional endpoints
 ];

AWS.util.update(AWS.S3.prototype, {
  /**
   * @api private
   */
  getSignatureVersion: function getSignatureVersion(request) {
    var defaultApiVersion = this.api.signatureVersion;
    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
    var regionDefinedVersion = this.config.signatureVersion;
    var isPresigned = request ? request.isPresigned() : false;
    /*
      1) User defined version specified:
        a) always return user defined version
      2) No user defined version specified:
        a) default to lowest version the region supports
        b) If using presigned urls, default to lowest version the region supports
    */
    if (userDefinedVersion) {
      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
      return userDefinedVersion;
    }
    if (isPresigned !== true) {
      defaultApiVersion = 'v4';
    } else if (regionDefinedVersion) {
      defaultApiVersion = regionDefinedVersion;
    }
    return defaultApiVersion;
  },

  /**
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var signatureVersion = this.getSignatureVersion(request);
    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
    var msg;
    var messages = [];

    // default to us-east-1 when no region is provided
    if (!this.config.region) this.config.region = 'us-east-1';

    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
      messages.push('An endpoint must be provided when configuring ' +
                    '`s3BucketEndpoint` to true.');
    }
    if (messages.length === 1) {
      msg = messages[0];
    } else if (messages.length > 1) {
      msg = 'Multiple configuration errors:\n' + messages.join('\n');
    }
    if (msg) {
      throw AWS.util.error(new Error(),
        {name: 'InvalidEndpoint', message: msg});
    }
  },

  /**
   * @api private
   */
  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
    var signerClass = this.getSignerClass();
    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
        && request.httpRequest.endpoint.protocol === 'https:') {
      return true;
    }
    return false;
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('validate', this.validateScheme);
    request.addListener('validate', this.validateBucketEndpoint);
    request.addListener('validate', this.correctBucketRegionFromCache);
    request.addListener('validate', this.validateBucketName);
    request.addListener('build', this.addContentType);
    request.addListener('build', this.populateURI);
    request.addListener('build', this.computeContentMd5);
    request.addListener('build', this.computeSseCustomerKeyMd5);
    request.addListener('afterBuild', this.addExpect100Continue);
    request.removeListener('validate',
      AWS.EventListeners.Core.VALIDATE_REGION);
    request.addListener('extractError', this.extractError);
    request.onAsync('extractError', this.requestBucketRegion);
    request.addListener('extractData', this.extractData);
    request.addListener('extractData', AWS.util.hoistPayloadMember);
    request.addListener('beforePresign', this.prepareSignedUrl);
    if (AWS.util.isBrowser()) {
      request.onAsync('retry', this.reqRegionForNetworkingError);
    }
    if (this.shouldDisableBodySigning(request))  {
      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
      request.addListener('afterBuild', this.disableBodySigning);
    }
  },

  /**
   * @api private
   */
  validateScheme: function(req) {
    var params = req.params,
        scheme = req.httpRequest.endpoint.protocol,
        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
    if (sensitive && scheme !== 'https:') {
      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
        'to \'true\' in your configuration';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketEndpoint: function(req) {
    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketName: function validateBucketName(req) {
    var service = req.service;
    var signatureVersion = service.getSignatureVersion(req);
    // Only validate buckets when using sigv4
    if (signatureVersion !== 'v4') {
      return;
    }
    var bucket = req.params && req.params.Bucket;
    var key = req.params && req.params.Key;
    var slashIndex = bucket && bucket.indexOf('/');
    if (bucket && slashIndex >= 0) {
      if (typeof key === 'string') {
        req.params = AWS.util.copy(req.params);
        // Need to include trailing slash to match sigv2 behavior
        var prefix = bucket.substr(slashIndex + 1) || '';
        req.params.Key = prefix + '/' + key;
        req.params.Bucket = bucket.substr(0, slashIndex);
      } else {
        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
        throw AWS.util.error(new Error(),
          { code: 'InvalidBucket', message: msg });
      }
    }
  },

  /**
   * @api private
   */
  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
    var invalidOperations = [
      'createBucket',
      'deleteBucket',
      'listBuckets'
    ];
    return invalidOperations.indexOf(operation) === -1;
  },


  /**
   * S3 prefers dns-compatible bucket names to be moved from the uri path
   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
   * buckets when using SSL and the bucket name contains a dot ('.').  The
   * ssl wildcard certificate is only 1-level deep.
   *
   * @api private
   */
  populateURI: function populateURI(req) {
    var httpRequest = req.httpRequest;
    var b = req.params.Bucket;
    var service = req.service;
    var endpoint = httpRequest.endpoint;
    if (b) {
      if (!service.pathStyleBucketName(b)) {
        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
          if (service.config.useDualstack) {
            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
          } else {
            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
          }
        } else if (!service.config.s3BucketEndpoint) {
          endpoint.hostname =
            b + '.' + endpoint.hostname;
        }

        var port = endpoint.port;
        if (port !== 80 && port !== 443) {
          endpoint.host = endpoint.hostname + ':' +
            endpoint.port;
        } else {
          endpoint.host = endpoint.hostname;
        }

        httpRequest.virtualHostedBucket = b; // needed for signing the request
        service.removeVirtualHostedBucketFromPath(req);
      }
    }
  },

  /**
   * Takes the bucket name out of the path if bucket is virtual-hosted
   *
   * @api private
   */
  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
    var httpRequest = req.httpRequest;
    var bucket = httpRequest.virtualHostedBucket;
    if (bucket && httpRequest.path) {
      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
      if (httpRequest.path[0] !== '/') {
        httpRequest.path = '/' + httpRequest.path;
      }
    }
  },

  /**
   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
   * @api private
   */
  addExpect100Continue: function addExpect100Continue(req) {
    var len = req.httpRequest.headers['Content-Length'];
    if (AWS.util.isNode() && len >= 1024 * 1024) {
      req.httpRequest.headers['Expect'] = '100-continue';
    }
  },

  /**
   * Adds a default content type if none is supplied.
   *
   * @api private
   */
  addContentType: function addContentType(req) {
    var httpRequest = req.httpRequest;
    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
      // Content-Type is not set in GET/HEAD requests
      delete httpRequest.headers['Content-Type'];
      return;
    }

    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
      httpRequest.headers['Content-Type'] = 'application/octet-stream';
    }

    var contentType = httpRequest.headers['Content-Type'];
    if (AWS.util.isBrowser()) {
      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
        var charset = '; charset=UTF-8';
        httpRequest.headers['Content-Type'] += charset;
      } else {
        var replaceFn = function(_, prefix, charsetName) {
          return prefix + charsetName.toUpperCase();
        };

        httpRequest.headers['Content-Type'] =
          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
      }
    }
  },

  /**
   * @api private
   */
  computableChecksumOperations: {
    putBucketCors: true,
    putBucketLifecycle: true,
    putBucketLifecycleConfiguration: true,
    putBucketTagging: true,
    deleteObjects: true,
    putBucketReplication: true
  },

  /**
   * Checks whether checksums should be computed for the request.
   * If the request requires checksums to be computed, this will always
   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
   * is set.
   *
   * @param req [AWS.Request] the request to check against
   * @return [Boolean] whether to compute checksums for a request.
   * @api private
   */
  willComputeChecksums: function willComputeChecksums(req) {
    if (this.computableChecksumOperations[req.operation]) return true;
    if (!this.config.computeChecksums) return false;

    // TODO: compute checksums for Stream objects
    if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) &&
        typeof req.httpRequest.body !== 'string') {
      return false;
    }

    var rules = req.service.api.operations[req.operation].input.members;

    // Sha256 signing disabled, and not a presigned url
    if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, 'presigned-expires')) {
      if (rules.ContentMD5 && !req.params.ContentMD5) {
        return true;
      }
    }

    // V4 signer uses SHA256 signatures so only compute MD5 if it is required
    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
      if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
    }

    if (rules.ContentMD5 && !req.params.ContentMD5) return true;
  },

  /**
   * A listener that computes the Content-MD5 and sets it in the header.
   * @see AWS.S3.willComputeChecksums
   * @api private
   */
  computeContentMd5: function computeContentMd5(req) {
    if (req.service.willComputeChecksums(req)) {
      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
      req.httpRequest.headers['Content-MD5'] = md5;
    }
  },

  /**
   * @api private
   */
  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
    var keys = {
      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
    };
    AWS.util.each(keys, function(key, header) {
      if (req.params[key]) {
        var value = AWS.util.crypto.md5(req.params[key], 'base64');
        req.httpRequest.headers[header] = value;
      }
    });
  },

  /**
   * Returns true if the bucket name should be left in the URI path for
   * a request to S3.  This function takes into account the current
   * endpoint protocol (e.g. http or https).
   *
   * @api private
   */
  pathStyleBucketName: function pathStyleBucketName(bucketName) {
    // user can force path style requests via the configuration
    if (this.config.s3ForcePathStyle) return true;
    if (this.config.s3BucketEndpoint) return false;

    if (this.dnsCompatibleBucketName(bucketName)) {
      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
    } else {
      return true; // not dns compatible names must always use path style
    }
  },

  /**
   * Returns true if the bucket name is DNS compatible.  Buckets created
   * outside of the classic region MUST be DNS compatible.
   *
   * @api private
   */
  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
    var b = bucketName;
    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
    var dots = new RegExp(/\.\./);
    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
  },

  /**
   * @return [Boolean] whether response contains an error
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    var req = resp.request;
    var httpResponse = resp.httpResponse;
    if (operationsWith200StatusCodeError[req.operation] &&
        httpResponse.body.toString().match('<Error>')) {
      return false;
    } else {
      return httpResponse.statusCode < 300;
    }
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error, request) {
    if (operationsWith200StatusCodeError[request.operation] &&
        error.statusCode === 200) {
      return true;
    } else if (request._requestRegionForBucket &&
        request.service.bucketRegionCache[request._requestRegionForBucket]) {
      return false;
    } else if (error && error.code === 'RequestTimeout') {
      return true;
    } else if (error &&
        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
        error.region && error.region != request.httpRequest.region) {
      request.httpRequest.region = error.region;
      if (error.statusCode === 301) {
        request.service.updateReqBucketRegion(request);
      }
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error, request);
    }
  },

  /**
   * Updates httpRequest with region. If region is not provided, then
   * the httpRequest will be updated based on httpRequest.region
   *
   * @api private
   */
  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
    var httpRequest = request.httpRequest;
    if (typeof region === 'string' && region.length) {
      httpRequest.region = region;
    }
    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
      return;
    }
    var service = request.service;
    var s3Config = service.config;
    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
    if (s3BucketEndpoint) {
      delete s3Config.s3BucketEndpoint;
    }
    var newConfig = AWS.util.copy(s3Config);
    delete newConfig.endpoint;
    newConfig.region = httpRequest.region;

    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
    service.populateURI(request);
    s3Config.s3BucketEndpoint = s3BucketEndpoint;
    httpRequest.headers.Host = httpRequest.endpoint.host;

    if (request._asm.currentState === 'validate') {
      request.removeListener('build', service.populateURI);
      request.addListener('build', service.removeVirtualHostedBucketFromPath);
    }
  },

  /**
   * Provides a specialized parser for getBucketLocation -- all other
   * operations are parsed by the super class.
   *
   * @api private
   */
  extractData: function extractData(resp) {
    var req = resp.request;
    if (req.operation === 'getBucketLocation') {
      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
      delete resp.data['_'];
      if (match) {
        resp.data.LocationConstraint = match[1];
      } else {
        resp.data.LocationConstraint = '';
      }
    }
    var bucket = req.params.Bucket || null;
    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
      req.service.clearBucketRegionCache(bucket);
    } else {
      var headers = resp.httpResponse.headers || {};
      var region = headers['x-amz-bucket-region'] || null;
      if (!region && req.operation === 'createBucket' && !resp.error) {
        var createBucketConfiguration = req.params.CreateBucketConfiguration;
        if (!createBucketConfiguration) {
          region = 'us-east-1';
        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
          region = 'eu-west-1';
        } else {
          region = createBucketConfiguration.LocationConstraint;
        }
      }
      if (region) {
          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
            req.service.bucketRegionCache[bucket] = region;
          }
      }
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * Extracts an error object from the http response.
   *
   * @api private
   */
  extractError: function extractError(resp) {
    var codes = {
      304: 'NotModified',
      403: 'Forbidden',
      400: 'BadRequest',
      404: 'NotFound'
    };

    var req = resp.request;
    var code = resp.httpResponse.statusCode;
    var body = resp.httpResponse.body || '';

    var headers = resp.httpResponse.headers || {};
    var region = headers['x-amz-bucket-region'] || null;
    var bucket = req.params.Bucket || null;
    var bucketRegionCache = req.service.bucketRegionCache;
    if (region && bucket && region !== bucketRegionCache[bucket]) {
      bucketRegionCache[bucket] = region;
    }

    var cachedRegion;
    if (codes[code] && body.length === 0) {
      if (bucket && !region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }
      resp.error = AWS.util.error(new Error(), {
        code: codes[code],
        message: null,
        region: region
      });
    } else {
      var data = new AWS.XML.Parser().parse(body.toString());

      if (data.Region && !region) {
        region = data.Region;
        if (bucket && region !== bucketRegionCache[bucket]) {
          bucketRegionCache[bucket] = region;
        }
      } else if (bucket && !region && !data.Region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }

      resp.error = AWS.util.error(new Error(), {
        code: data.Code || code,
        message: data.Message || null,
        region: region
      });
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * If region was not obtained synchronously, then send async request
   * to get bucket region for errors resulting from wrong region.
   *
   * @api private
   */
  requestBucketRegion: function requestBucketRegion(resp, done) {
    var error = resp.error;
    var req = resp.request;
    var bucket = req.params.Bucket || null;

    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
        (AWS.util.isNode() && req.operation === 'headBucket') ||
        (error.statusCode === 400 && req.operation !== 'headObject') ||
        regionRedirectErrorCodes.indexOf(error.code) === -1) {
      return done();
    }
    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
    var reqParams = {Bucket: bucket};
    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
    var regionReq = req.service[reqOperation](reqParams);
    regionReq._requestRegionForBucket = bucket;
    regionReq.send(function() {
      var region = req.service.bucketRegionCache[bucket] || null;
      error.region = region;
      done();
    });
  },

   /**
   * For browser only. If NetworkingError received, will attempt to obtain
   * the bucket region.
   *
   * @api private
   */
   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
    if (!AWS.util.isBrowser()) {
      return done();
    }
    var error = resp.error;
    var request = resp.request;
    var bucket = request.params.Bucket;
    if (!error || error.code !== 'NetworkingError' || !bucket ||
        request.httpRequest.region === 'us-east-1') {
      return done();
    }
    var service = request.service;
    var bucketRegionCache = service.bucketRegionCache;
    var cachedRegion = bucketRegionCache[bucket] || null;

    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
      service.updateReqBucketRegion(request, cachedRegion);
      done();
    } else if (!service.dnsCompatibleBucketName(bucket)) {
      service.updateReqBucketRegion(request, 'us-east-1');
      if (bucketRegionCache[bucket] !== 'us-east-1') {
        bucketRegionCache[bucket] = 'us-east-1';
      }
      done();
    } else if (request.httpRequest.virtualHostedBucket) {
      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
      getRegionReq._requestRegionForBucket = bucket;

      getRegionReq.send(function() {
        var region = service.bucketRegionCache[bucket] || null;
        if (region && region !== request.httpRequest.region) {
          service.updateReqBucketRegion(request, region);
        }
        done();
      });
    } else {
      // DNS-compatible path-style
      // (s3ForcePathStyle or bucket name with dot over https)
      // Cannot obtain region information for this case
      done();
    }
   },

  /**
   * Cache for bucket region.
   *
   * @api private
   */
   bucketRegionCache: {},

  /**
   * Clears bucket region cache.
   *
   * @api private
   */
   clearBucketRegionCache: function(buckets) {
    var bucketRegionCache = this.bucketRegionCache;
    if (!buckets) {
      buckets = Object.keys(bucketRegionCache);
    } else if (typeof buckets === 'string') {
      buckets = [buckets];
    }
    for (var i = 0; i < buckets.length; i++) {
      delete bucketRegionCache[buckets[i]];
    }
    return bucketRegionCache;
   },

   /**
    * Corrects request region if bucket's cached region is different
    *
    * @api private
    */
  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
    var bucket = req.params.Bucket || null;
    if (bucket) {
      var service = req.service;
      var requestRegion = req.httpRequest.region;
      var cachedRegion = service.bucketRegionCache[bucket];
      if (cachedRegion && cachedRegion !== requestRegion) {
        service.updateReqBucketRegion(req, cachedRegion);
      }
    }
  },

  /**
   * Extracts S3 specific request ids from the http response.
   *
   * @api private
   */
  extractRequestIds: function extractRequestIds(resp) {
    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
    resp.extendedRequestId = extendedRequestId;
    resp.cfId = cfId;

    if (resp.error) {
      resp.error.requestId = resp.requestId || null;
      resp.error.extendedRequestId = extendedRequestId;
      resp.error.cfId = cfId;
    }
  },

  /**
   * Get a pre-signed URL for a given operation name.
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   * @note Not all operation parameters are supported when using pre-signed
   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
   *   request. If you are using pre-signed URLs to upload from a browser and
   *   need to use these fields, see {createPresignedPost}.
   * @param operation [String] the name of the operation to call
   * @param params [map] parameters to pass to the operation. See the given
   *   operation for the expected operation parameters. In addition, you can
   *   also pass the "Expires" parameter to inform S3 how long the URL should
   *   work for.
   * @option params Expires [Integer] (900) the number of seconds to expire
   *   the pre-signed URL operation in. Defaults to 15 minutes.
   * @param callback [Function] if a callback is provided, this function will
   *   pass the URL as the second parameter (after the error parameter) to
   *   the callback function.
   * @return [String] if called synchronously (with no callback), returns the
   *   signed URL.
   * @return [null] nothing is returned if a callback is provided.
   * @example Pre-signing a getObject operation (synchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url);
   * @example Pre-signing a putObject (asynchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   s3.getSignedUrl('putObject', params, function (err, url) {
   *     console.log('The URL is', url);
   *   });
   * @example Pre-signing a putObject operation with a specific payload
   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
   *   var url = s3.getSignedUrl('putObject', params);
   *   console.log('The URL is', url);
   * @example Passing in a 1-minute expiry time for a pre-signed URL
   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url); // expires in 60 seconds
   */
  getSignedUrl: function getSignedUrl(operation, params, callback) {
    params = AWS.util.copy(params || {});
    var expires = params.Expires || 900;
    delete params.Expires; // we can't validate this
    var request = this.makeRequest(operation, params);

    if (callback) {
      AWS.util.defer(function() {
        request.presign(expires, callback);
      });
    } else {
      return request.presign(expires, callback);
    }
  },


  /**
   * Get a pre-signed POST policy to support uploading to S3 directly from an
   * HTML form.
   *
   * @param params [map]
   * @option params Bucket [String]     The bucket to which the post should be
   *                                    uploaded
   * @option params Expires [Integer]   (3600) The number of seconds for which
   *                                    the presigned policy should be valid.
   * @option params Conditions [Array]  An array of conditions that must be met
   *                                    for the presigned policy to allow the
   *                                    upload. This can include required tags,
   *                                    the accepted range for content lengths,
   *                                    etc.
   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
   * @option params Fields [map]        Fields to include in the form. All
   *                                    values passed in as fields will be
   *                                    signed as exact match conditions.
   * @param callback [Function]
   *
   * @note All fields passed in when creating presigned post data will be signed
   *   as exact match conditions. Any fields that will be interpolated by S3
   *   must be added to the fields hash after signing, and an appropriate
   *   condition for such fields must be explicitly added to the Conditions
   *   array passed to this function before signing.
   *
   * @example Presiging post data with a known key
   *   var params = {
   *     Bucket: 'bucket',
   *     Fields: {
   *       key: 'key'
   *     }
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @example Presigning post data with an interpolated key
   *   var params = {
   *     Bucket: 'bucket',
   *     Conditions: [
   *       ['starts-with', '$key', 'path/to/uploads/']
   *     ]
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       data.Fields.key = 'path/to/uploads/${filename}';
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   *
   * @return [map]  If called synchronously (with no callback), returns a hash
   *                with the url to set as the form action and a hash of fields
   *                to include in the form.
   * @return [null] Nothing is returned if a callback is provided.
   *
   * @callback callback function (err, data)
   *  @param err [Error] the error object returned from the policy signer
   *  @param data [map] The data necessary to construct an HTML form
   *  @param data.url [String] The URL to use as the action of the form
   *  @param data.fields [map] A hash of fields that must be included in the
   *                           form for the upload to succeed. This hash will
   *                           include the signed POST policy, your access key
   *                           ID and security token (if present), etc. These
   *                           may be safely included as input elements of type
   *                           'hidden.'
   */
  createPresignedPost: function createPresignedPost(params, callback) {
    if (typeof params === 'function' && callback === undefined) {
      callback = params;
      params = null;
    }

    params = AWS.util.copy(params || {});
    var boundParams = this.config.params || {};
    var bucket = params.Bucket || boundParams.Bucket,
      self = this,
      config = this.config,
      endpoint = AWS.util.copy(this.endpoint);
    if (!config.s3BucketEndpoint) {
      endpoint.pathname = '/' + bucket;
    }

    function finalizePost() {
      return {
        url: AWS.util.urlFormat(endpoint),
        fields: self.preparePostFields(
          config.credentials,
          config.region,
          bucket,
          params.Fields,
          params.Conditions,
          params.Expires
        )
      };
    }

    if (callback) {
      config.getCredentials(function (err) {
        if (err) {
          callback(err);
        }

        callback(null, finalizePost());
      });
    } else {
      return finalizePost();
    }
  },

  /**
   * @api private
   */
  preparePostFields: function preparePostFields(
    credentials,
    region,
    bucket,
    fields,
    conditions,
    expiresInSeconds
  ) {
    var now = this.getSkewCorrectedDate();
    if (!credentials || !region || !bucket) {
      throw new Error('Unable to create a POST object policy without a bucket,'
        + ' region, and credentials');
    }
    fields = AWS.util.copy(fields || {});
    conditions = (conditions || []).slice(0);
    expiresInSeconds = expiresInSeconds || 3600;

    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
    var shortDate = signingDate.substr(0, 8);
    var scope = v4Credentials.createScope(shortDate, region, 's3');
    var credential = credentials.accessKeyId + '/' + scope;

    fields['bucket'] = bucket;
    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
    fields['X-Amz-Credential'] = credential;
    fields['X-Amz-Date'] = signingDate;
    if (credentials.sessionToken) {
      fields['X-Amz-Security-Token'] = credentials.sessionToken;
    }
    for (var field in fields) {
      if (fields.hasOwnProperty(field)) {
        var condition = {};
        condition[field] = fields[field];
        conditions.push(condition);
      }
    }

    fields.Policy = this.preparePostPolicy(
      new Date(now.valueOf() + expiresInSeconds * 1000),
      conditions
    );
    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
      fields.Policy,
      'hex'
    );

    return fields;
  },

  /**
   * @api private
   */
  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
    return AWS.util.base64.encode(JSON.stringify({
      expiration: AWS.util.date.iso8601(expiration),
      conditions: conditions
    }));
  },

  /**
   * @api private
   */
  prepareSignedUrl: function prepareSignedUrl(request) {
    request.addListener('validate', request.service.noPresignedContentLength);
    request.removeListener('build', request.service.addContentType);
    if (!request.params.Body) {
      // no Content-MD5/SHA-256 if body is not provided
      request.removeListener('build', request.service.computeContentMd5);
    } else {
      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
    }
  },

  /**
   * @api private
   * @param request
   */
  disableBodySigning: function disableBodySigning(request) {
    var headers = request.httpRequest.headers;
    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
    }
  },

  /**
   * @api private
   */
  noPresignedContentLength: function noPresignedContentLength(request) {
    if (request.params.ContentLength !== undefined) {
      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
        message: 'ContentLength is not supported in pre-signed URLs.'});
    }
  },

  createBucket: function createBucket(params, callback) {
    // When creating a bucket *outside* the classic region, the location
    // constraint must be set for the bucket and it must match the endpoint.
    // This chunk of code will set the location constraint param based
    // on the region (when possible), but it will not override a passed-in
    // location constraint.
    if (typeof params === 'function' || !params) {
      callback = callback || params;
      params = {};
    }
    var hostname = this.endpoint.hostname;
    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
      params.CreateBucketConfiguration = { LocationConstraint: this.config.region };
    }
    return this.makeRequest('createBucket', params, callback);
  },

  /**
   * @see AWS.S3.ManagedUpload
   * @overload upload(params = {}, [options], [callback])
   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
   *   concurrent handling of parts if the payload is large enough. You can
   *   configure the concurrent queue size by setting `options`. Note that this
   *   is the only operation for which the SDK can retry requests with stream
   *   bodies.
   *
   *   @param (see AWS.S3.putObject)
   *   @option (see AWS.S3.ManagedUpload.constructor)
   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
   *     `send()` or track progress.
   *   @example Uploading a stream object
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     s3.upload(params, function(err, data) {
   *       console.log(err, data);
   *     });
   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
   *     s3.upload(params, options, function(err, data) {
   *       console.log(err, data);
   *     });
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *   @param data.Location [String] the URL of the uploaded object
   *   @param data.ETag [String] the ETag of the uploaded object
   *   @param data.Bucket [String]  the bucket to which the object was uploaded
   *   @param data.Key [String] the key to which the object was uploaded
   */
  upload: function upload(params, options, callback) {
    if (typeof options === 'function' && callback === undefined) {
      callback = options;
      options = null;
    }

    options = options || {};
    options = AWS.util.merge(options || {}, {service: this, params: params});

    var uploader = new AWS.S3.ManagedUpload(options);
    if (typeof callback === 'function') uploader.send(callback);
    return uploader;
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.SQS.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.buildEndpoint);

    if (request.service.config.computeChecksums) {
      if (request.operation === 'sendMessage') {
        request.addListener('extractData', this.verifySendMessageChecksum);
      } else if (request.operation === 'sendMessageBatch') {
        request.addListener('extractData', this.verifySendMessageBatchChecksum);
      } else if (request.operation === 'receiveMessage') {
        request.addListener('extractData', this.verifyReceiveMessageChecksum);
      }
    }
  },

  /**
   * @api private
   */
  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
    if (!response.data) return;

    var md5 = response.data.MD5OfMessageBody;
    var body = this.params.MessageBody;
    var calculatedMd5 = this.service.calculateChecksum(body);
    if (calculatedMd5 !== md5) {
      var msg = 'Got "' + response.data.MD5OfMessageBody +
        '", expecting "' + calculatedMd5 + '".';
      this.service.throwInvalidChecksumError(response,
        [response.data.MessageId], msg);
    }
  },

  /**
   * @api private
   */
  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var entries = {};
    var errors = [];
    var messageIds = [];
    AWS.util.arrayEach(response.data.Successful, function (entry) {
      entries[entry.Id] = entry;
    });
    AWS.util.arrayEach(this.params.Entries, function (entry) {
      if (entries[entry.Id]) {
        var md5 = entries[entry.Id].MD5OfMessageBody;
        var body = entry.MessageBody;
        if (!service.isChecksumValid(md5, body)) {
          errors.push(entry.Id);
          messageIds.push(entries[entry.Id].MessageId);
        }
      }
    });

    if (errors.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + errors.join(', '));
    }
  },

  /**
   * @api private
   */
  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var messageIds = [];
    AWS.util.arrayEach(response.data.Messages, function(message) {
      var md5 = message.MD5OfBody;
      var body = message.Body;
      if (!service.isChecksumValid(md5, body)) {
        messageIds.push(message.MessageId);
      }
    });

    if (messageIds.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + messageIds.join(', '));
    }
  },

  /**
   * @api private
   */
  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
    response.error = AWS.util.error(new Error(), {
      retryable: true,
      code: 'InvalidChecksum',
      messageIds: ids,
      message: response.request.operation +
               ' returned an invalid MD5 response. ' + message
    });
  },

  /**
   * @api private
   */
  isChecksumValid: function isChecksumValid(checksum, data) {
    return this.calculateChecksum(data) === checksum;
  },

  /**
   * @api private
   */
  calculateChecksum: function calculateChecksum(data) {
    return AWS.util.crypto.md5(data, 'hex');
  },

  /**
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.httpRequest.params.QueueUrl;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);

      // signature version 4 requires the region name to be set,
      // sqs queue urls contain the region name
      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
      if (matches) request.httpRequest.region = matches[1];
    }
  }
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

AWS.util.update(AWS.STS.prototype, {
  /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */
  credentialsFrom: function credentialsFrom(data, credentials) {
    if (!data) return null;
    if (!credentials) credentials = new AWS.TemporaryCredentials();
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
    return credentials;
  },

  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
  },

  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
  }
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
function signedUrlBuilder(request) {
  var expires = request.httpRequest.headers[expiresHeader];
  var signerClass = request.service.getSignerClass(request);

  delete request.httpRequest.headers['User-Agent'];
  delete request.httpRequest.headers['X-Amz-User-Agent'];

  if (signerClass === AWS.Signers.V4) {
    if (expires > 604800) { // one week expiry is invalid
      var message = 'Presigning does not support expiry time greater ' +
                    'than a week with SigV4 signing.';
      throw AWS.util.error(new Error(), {
        code: 'InvalidExpiryTime', message: message, retryable: false
      });
    }
    request.httpRequest.headers[expiresHeader] = expires;
  } else if (signerClass === AWS.Signers.S3) {
    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
    request.httpRequest.headers[expiresHeader] = parseInt(
      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
  } else {
    throw AWS.util.error(new Error(), {
      message: 'Presigning only supports S3 or SigV4 signing.',
      code: 'UnsupportedSigner', retryable: false
    });
  }
}

/**
 * @api private
 */
function signedUrlSigner(request) {
  var endpoint = request.httpRequest.endpoint;
  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
  var queryParams = {};

  if (parsedUrl.search) {
    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
  }

  AWS.util.each(request.httpRequest.headers, function (key, value) {
    if (key === expiresHeader) key = 'Expires';
    if (key.indexOf('x-amz-meta-') === 0) {
      // Delete existing, potentially not normalized key
      delete queryParams[key];
      key = key.toLowerCase();
    }
    queryParams[key] = value;
  });
  delete request.httpRequest.headers[expiresHeader];

  var auth = queryParams['Authorization'].split(' ');
  if (auth[0] === 'AWS') {
    auth = auth[1].split(':');
    queryParams['AWSAccessKeyId'] = auth[0];
    queryParams['Signature'] = auth[1];
  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
    auth.shift();
    var rest = auth.join(' ');
    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
    queryParams['X-Amz-Signature'] = signature;
    delete queryParams['Expires'];
  }
  delete queryParams['Authorization'];
  delete queryParams['Host'];

  // build URL
  endpoint.pathname = parsedUrl.pathname;
  endpoint.search = AWS.util.queryParamsToString(queryParams);
}

/**
 * @api private
 */
AWS.Signers.Presign = inherit({
  /**
   * @api private
   */
  sign: function sign(request, expireTime, callback) {
    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
    request.on('build', signedUrlBuilder);
    request.on('sign', signedUrlSigner);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.COMPUTE_SHA256);

    request.emit('beforePresign', [request]);

    if (callback) {
      request.build(function() {
        if (this.response.error) callback(this.response.error);
        else {
          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
        }
      });
    } else {
      request.build();
      if (request.response.error) throw request.response.error;
      return AWS.util.urlFormat(request.httpRequest.endpoint);
    }
  }
});

module.exports = AWS.Signers.Presign;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);

var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.RequestSigner = inherit({
  constructor: function RequestSigner(request) {
    this.request = request;
  },

  setServiceClientId: function setServiceClientId(id) {
    this.serviceClientId = id;
  },

  getServiceClientId: function getServiceClientId() {
    return this.serviceClientId;
  }
});

AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
  switch (version) {
    case 'v2': return AWS.Signers.V2;
    case 'v3': return AWS.Signers.V3;
    case 'v4': return AWS.Signers.V4;
    case 's3': return AWS.Signers.S3;
    case 'v3https': return AWS.Signers.V3Https;
  }
  throw new Error('Unknown signing version ' + version);
};

__webpack_require__(1025);
__webpack_require__(369);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1024);
__webpack_require__(1022);


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
  /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */
  subResources: {
    'acl': 1,
    'accelerate': 1,
    'analytics': 1,
    'cors': 1,
    'lifecycle': 1,
    'delete': 1,
    'inventory': 1,
    'location': 1,
    'logging': 1,
    'metrics': 1,
    'notification': 1,
    'partNumber': 1,
    'policy': 1,
    'requestPayment': 1,
    'replication': 1,
    'restore': 1,
    'tagging': 1,
    'torrent': 1,
    'uploadId': 1,
    'uploads': 1,
    'versionId': 1,
    'versioning': 1,
    'versions': 1,
    'website': 1
  },

  // when building the stringToSign, these querystring params should be
  // part of the canonical resource string with their NON-encoded values
  responseHeaders: {
    'response-content-type': 1,
    'response-content-language': 1,
    'response-expires': 1,
    'response-cache-control': 1,
    'response-content-disposition': 1,
    'response-content-encoding': 1
  },

  addAuthorization: function addAuthorization(credentials, date) {
    if (!this.request.headers['presigned-expires']) {
      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
    }

    if (credentials.sessionToken) {
      // presigned URLs require this header to be lowercased
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

    this.request.headers['Authorization'] = auth;
  },

  stringToSign: function stringToSign() {
    var r = this.request;

    var parts = [];
    parts.push(r.method);
    parts.push(r.headers['Content-MD5'] || '');
    parts.push(r.headers['Content-Type'] || '');

    // This is the "Date" header, but we use X-Amz-Date.
    // The S3 signing mechanism requires us to pass an empty
    // string for this Date header regardless.
    parts.push(r.headers['presigned-expires'] || '');

    var headers = this.canonicalizedAmzHeaders();
    if (headers) parts.push(headers);
    parts.push(this.canonicalizedResource());

    return parts.join('\n');

  },

  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

    var amzHeaders = [];

    AWS.util.each(this.request.headers, function (name) {
      if (name.match(/^x-amz-/i))
        amzHeaders.push(name);
    });

    amzHeaders.sort(function (a, b) {
      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    });

    var parts = [];
    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
    });

    return parts.join('\n');

  },

  canonicalizedResource: function canonicalizedResource() {

    var r = this.request;

    var parts = r.path.split('?');
    var path = parts[0];
    var querystring = parts[1];

    var resource = '';

    if (r.virtualHostedBucket)
      resource += '/' + r.virtualHostedBucket;

    resource += path;

    if (querystring) {

      // collect a list of sub resources and query params that need to be signed
      var resources = [];

      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
        var name = param.split('=')[0];
        var value = param.split('=')[1];
        if (this.subResources[name] || this.responseHeaders[name]) {
          var subresource = { name: name };
          if (value !== undefined) {
            if (this.subResources[name]) {
              subresource.value = value;
            } else {
              subresource.value = decodeURIComponent(value);
            }
          }
          resources.push(subresource);
        }
      });

      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

      if (resources.length) {

        querystring = [];
        AWS.util.arrayEach(resources, function (res) {
          if (res.value === undefined) {
            querystring.push(res.name);
          } else {
            querystring.push(res.name + '=' + res.value);
          }
        });

        resource += '?' + querystring.join('&');
      }

    }

    return resource;

  },

  sign: function sign(secret, string) {
    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
  }
});

module.exports = AWS.Signers.S3;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    if (!date) date = AWS.util.date.getDate();

    var r = this.request;

    r.params.Timestamp = AWS.util.date.iso8601(date);
    r.params.SignatureVersion = '2';
    r.params.SignatureMethod = 'HmacSHA256';
    r.params.AWSAccessKeyId = credentials.accessKeyId;

    if (credentials.sessionToken) {
      r.params.SecurityToken = credentials.sessionToken;
    }

    delete r.params.Signature; // delete old Signature for re-signing
    r.params.Signature = this.signature(credentials);

    r.body = AWS.util.queryParamsToString(r.params);
    r.headers['Content-Length'] = r.body.length;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push(this.request.endpoint.host.toLowerCase());
    parts.push(this.request.pathname());
    parts.push(AWS.util.queryParamsToString(this.request.params));
    return parts.join('\n');
  }

});

module.exports = AWS.Signers.V2;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var inherit = AWS.util.inherit;

__webpack_require__(369);

/**
 * @api private
 */
AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
  authorization: function authorization(credentials) {
    return 'AWS3-HTTPS ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'Signature=' + this.signature(credentials);
  },

  stringToSign: function stringToSign() {
    return this.request.headers['X-Amz-Date'];
  }
});

module.exports = AWS.Signers.V3Https;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(3);
var v4Credentials = __webpack_require__(370);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
  constructor: function V4(request, serviceName, options) {
    AWS.Signers.RequestSigner.call(this, request);
    this.serviceName = serviceName;
    options = options || {};
    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
    this.operation = options.operation;
  },

  algorithm: 'AWS4-HMAC-SHA256',

  addAuthorization: function addAuthorization(credentials, date) {
    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

    if (this.isPresigned()) {
      this.updateForPresigned(credentials, datetime);
    } else {
      this.addHeaders(credentials, datetime);
    }

    this.request.headers['Authorization'] =
      this.authorization(credentials, datetime);
  },

  addHeaders: function addHeaders(credentials, datetime) {
    this.request.headers['X-Amz-Date'] = datetime;
    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }
  },

  updateForPresigned: function updateForPresigned(credentials, datetime) {
    var credString = this.credentialString(datetime);
    var qs = {
      'X-Amz-Date': datetime,
      'X-Amz-Algorithm': this.algorithm,
      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
      'X-Amz-Expires': this.request.headers[expiresHeader],
      'X-Amz-SignedHeaders': this.signedHeaders()
    };

    if (credentials.sessionToken) {
      qs['X-Amz-Security-Token'] = credentials.sessionToken;
    }

    if (this.request.headers['Content-Type']) {
      qs['Content-Type'] = this.request.headers['Content-Type'];
    }
    if (this.request.headers['Content-MD5']) {
      qs['Content-MD5'] = this.request.headers['Content-MD5'];
    }
    if (this.request.headers['Cache-Control']) {
      qs['Cache-Control'] = this.request.headers['Cache-Control'];
    }

    // need to pull in any other X-Amz-* headers
    AWS.util.each.call(this, this.request.headers, function(key, value) {
      if (key === expiresHeader) return;
      if (this.isSignableHeader(key)) {
        var lowerKey = key.toLowerCase();
        // Metadata should be normalized
        if (lowerKey.indexOf('x-amz-meta-') === 0) {
          qs[lowerKey] = value;
        } else if (lowerKey.indexOf('x-amz-') === 0) {
          qs[key] = value;
        }
      }
    });

    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
    this.request.path += sep + AWS.util.queryParamsToString(qs);
  },

  authorization: function authorization(credentials, datetime) {
    var parts = [];
    var credString = this.credentialString(datetime);
    parts.push(this.algorithm + ' Credential=' +
      credentials.accessKeyId + '/' + credString);
    parts.push('SignedHeaders=' + this.signedHeaders());
    parts.push('Signature=' + this.signature(credentials, datetime));
    return parts.join(', ');
  },

  signature: function signature(credentials, datetime) {
    var signingKey = v4Credentials.getSigningKey(
      credentials,
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName,
      this.signatureCache
    );
    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
  },

  stringToSign: function stringToSign(datetime) {
    var parts = [];
    parts.push('AWS4-HMAC-SHA256');
    parts.push(datetime);
    parts.push(this.credentialString(datetime));
    parts.push(this.hexEncodedHash(this.canonicalString()));
    return parts.join('\n');
  },

  canonicalString: function canonicalString() {
    var parts = [], pathname = this.request.pathname();
    if (this.serviceName !== 's3') pathname = AWS.util.uriEscapePath(pathname);

    parts.push(this.request.method);
    parts.push(pathname);
    parts.push(this.request.search());
    parts.push(this.canonicalHeaders() + '\n');
    parts.push(this.signedHeaders());
    parts.push(this.hexEncodedBodyHash());
    return parts.join('\n');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = [];
    AWS.util.each.call(this, this.request.headers, function (key, item) {
      headers.push([key, item]);
    });
    headers.sort(function (a, b) {
      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
    });
    var parts = [];
    AWS.util.arrayEach.call(this, headers, function (item) {
      var key = item[0].toLowerCase();
      if (this.isSignableHeader(key)) {
        var value = item[1];
        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
            code: 'InvalidHeader'
          });
        }
        parts.push(key + ':' +
          this.canonicalHeaderValues(value.toString()));
      }
    });
    return parts.join('\n');
  },

  canonicalHeaderValues: function canonicalHeaderValues(values) {
    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  },

  signedHeaders: function signedHeaders() {
    var keys = [];
    AWS.util.each.call(this, this.request.headers, function (key) {
      key = key.toLowerCase();
      if (this.isSignableHeader(key)) keys.push(key);
    });
    return keys.sort().join(';');
  },

  credentialString: function credentialString(datetime) {
    return v4Credentials.createScope(
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName
    );
  },

  hexEncodedHash: function hash(string) {
    return AWS.util.crypto.sha256(string, 'hex');
  },

  hexEncodedBodyHash: function hexEncodedBodyHash() {
    var request = this.request;
    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
      return 'UNSIGNED-PAYLOAD';
    } else if (request.headers['X-Amz-Content-Sha256']) {
      return request.headers['X-Amz-Content-Sha256'];
    } else {
      return this.hexEncodedHash(this.request.body || '');
    }
  },

  unsignableHeaders: [
    'authorization',
    'content-type',
    'content-length',
    'user-agent',
    expiresHeader,
    'expect',
    'x-amzn-trace-id'
  ],

  isSignableHeader: function isSignableHeader(key) {
    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
    return this.unsignableHeaders.indexOf(key) < 0;
  },

  isPresigned: function isPresigned() {
    return this.request.headers[expiresHeader] ? true : false;
  }

});

module.exports = AWS.Signers.V4;


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

function AcceptorStateMachine(states, state) {
  this.currentState = state || null;
  this.states = states || {};
}

AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
  if (typeof finalState === 'function') {
    inputError = bindObject; bindObject = done;
    done = finalState; finalState = null;
  }

  var self = this;
  var state = self.states[self.currentState];
  state.fn.call(bindObject || self, inputError, function(err) {
    if (err) {
      if (state.fail) self.currentState = state.fail;
      else return done ? done.call(bindObject, err) : null;
    } else {
      if (state.accept) self.currentState = state.accept;
      else return done ? done.call(bindObject) : null;
    }
    if (self.currentState === finalState) {
      return done ? done.call(bindObject, err) : null;
    }

    self.runTo(finalState, done, bindObject, err);
  });
};

AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
  if (typeof acceptState === 'function') {
    fn = acceptState; acceptState = null; failState = null;
  } else if (typeof failState === 'function') {
    fn = failState; failState = null;
  }

  if (!this.currentState) this.currentState = name;
  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
  return this;
};

module.exports = AcceptorStateMachine;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var Shape = __webpack_require__(129);

function DomXmlParser() { }

DomXmlParser.prototype.parse = function(xml, shape) {
  if (xml.replace(/^\s+/, '') === '') return {};

  var result, error;
  try {
    if (window.DOMParser) {
      try {
        var parser = new DOMParser();
        result = parser.parseFromString(xml, 'text/xml');
      } catch (syntaxError) {
        throw util.error(new Error('Parse error in document'),
          {
            originalError: syntaxError,
            code: 'XMLParserError',
            retryable: true
          });
      }

      if (result.documentElement === null) {
        throw util.error(new Error('Cannot parse empty document.'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }

      var isError = result.getElementsByTagName('parsererror')[0];
      if (isError && (isError.parentNode === result ||
          isError.parentNode.nodeName === 'body' ||
          isError.parentNode.parentNode === result ||
          isError.parentNode.parentNode.nodeName === 'body')) {
        var errorElement = isError.getElementsByTagName('div')[0] || isError;
        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else if (window.ActiveXObject) {
      result = new window.ActiveXObject('Microsoft.XMLDOM');
      result.async = false;

      if (!result.loadXML(xml)) {
        throw util.error(new Error('Parse error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else {
      throw new Error('Cannot load XML parser');
    }
  } catch (e) {
    error = e;
  }

  if (result && result.documentElement && !error) {
    var data = parseXml(result.documentElement, shape);
    var metadata = result.getElementsByTagName('ResponseMetadata')[0];
    if (metadata) {
      data.ResponseMetadata = parseXml(metadata, {});
    }
    return data;
  } else if (error) {
    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
  } else { // empty xml document
    return {};
  }
};

function parseXml(xml, shape) {
  if (!shape) shape = {};
  switch (shape.type) {
    case 'structure': return parseStructure(xml, shape);
    case 'map': return parseMap(xml, shape);
    case 'list': return parseList(xml, shape);
    case undefined: case null: return parseUnknown(xml);
    default: return parseScalar(xml, shape);
  }
}

function parseStructure(xml, shape) {
  var data = {};
  if (xml === null) return data;

  util.each(shape.members, function(memberName, memberShape) {
    if (memberShape.isXmlAttribute) {
      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
        var value = xml.attributes[memberShape.name].value;
        data[memberName] = parseXml({textContent: value}, memberShape);
      }
    } else {
      var xmlChild = memberShape.flattened ? xml :
        xml.getElementsByTagName(memberShape.name)[0];
      if (xmlChild) {
        data[memberName] = parseXml(xmlChild, memberShape);
      } else if (!memberShape.flattened && memberShape.type === 'list') {
        data[memberName] = memberShape.defaultValue;
      }
    }
  });

  return data;
}

function parseMap(xml, shape) {
  var data = {};
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';
  var tagName = shape.flattened ? shape.name : 'entry';

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      var key = child.getElementsByTagName(xmlKey)[0].textContent;
      var value = child.getElementsByTagName(xmlValue)[0];
      data[key] = parseXml(value, shape.value);
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseList(xml, shape) {
  var data = [];
  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      data.push(parseXml(child, shape.member));
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseScalar(xml, shape) {
  if (xml.getAttribute) {
    var encoding = xml.getAttribute('encoding');
    if (encoding === 'base64') {
      shape = new Shape.create({type: encoding});
    }
  }

  var text = xml.textContent;
  if (text === '') text = null;
  if (typeof shape.toType === 'function') {
    return shape.toType(text);
  } else {
    return text;
  }
}

function parseUnknown(xml) {
  if (xml === undefined || xml === null) return '';

  // empty object
  if (!xml.firstElementChild) {
    if (xml.parentNode.parentNode === null) return {};
    if (xml.childNodes.length === 0) return '';
    else return xml.textContent;
  }

  // object, parse as structure
  var shape = {type: 'structure', members: {}};
  var child = xml.firstElementChild;
  while (child) {
    var tag = child.nodeName;
    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
      // multiple tags of the same name makes it a list
      shape.members[tag].type = 'list';
    } else {
      shape.members[tag] = {name: tag};
    }
    child = child.nextElementSibling;
  }
  return parseStructure(xml, shape);
}

module.exports = DomXmlParser;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(28);
var builder = __webpack_require__(681);

function XmlBuilder() { }

XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
  var xml = builder.create(rootElement);
  applyNamespaces(xml, shape);
  serialize(xml, params, shape);
  return xml.children.length > 0 || noEmpty ? xml.root().toString() : '';
};

function serialize(xml, value, shape) {
  switch (shape.type) {
    case 'structure': return serializeStructure(xml, value, shape);
    case 'map': return serializeMap(xml, value, shape);
    case 'list': return serializeList(xml, value, shape);
    default: return serializeScalar(xml, value, shape);
  }
}

function serializeStructure(xml, params, shape) {
  util.arrayEach(shape.memberNames, function(memberName) {
    var memberShape = shape.members[memberName];
    if (memberShape.location !== 'body') return;

    var value = params[memberName];
    var name = memberShape.name;
    if (value !== undefined && value !== null) {
      if (memberShape.isXmlAttribute) {
        xml.att(name, value);
      } else if (memberShape.flattened) {
        serialize(xml, value, memberShape);
      } else {
        var element = xml.ele(name);
        applyNamespaces(element, memberShape);
        serialize(element, value, memberShape);
      }
    }
  });
}

function serializeMap(xml, map, shape) {
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';

  util.each(map, function(key, value) {
    var entry = xml.ele(shape.flattened ? shape.name : 'entry');
    serialize(entry.ele(xmlKey), key, shape.key);
    serialize(entry.ele(xmlValue), value, shape.value);
  });
}

function serializeList(xml, list, shape) {
  if (shape.flattened) {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || shape.name;
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  } else {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || 'member';
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  }
}

function serializeScalar(xml, value, shape) {
  xml.txt(shape.toWireFormat(value));
}

function applyNamespaces(xml, shape) {
  var uri, prefix = 'xmlns';
  if (shape.xmlNamespaceUri) {
    uri = shape.xmlNamespaceUri;
    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
  } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
    uri = shape.api.xmlNamespaceUri;
  }

  if (uri) xml.att(prefix, uri);
}

module.exports = XmlBuilder;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);
var bind = __webpack_require__(375);
var Axios = __webpack_require__(1033);
var defaults = __webpack_require__(224);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(372);
axios.CancelToken = __webpack_require__(1032);
axios.isCancel = __webpack_require__(373);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1047);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(372);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(224);
var utils = __webpack_require__(47);
var InterceptorManager = __webpack_require__(1034);
var dispatchRequest = __webpack_require__(1035);
var isAbsoluteURL = __webpack_require__(1043);
var combineURLs = __webpack_require__(1041);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);
var transformData = __webpack_require__(1038);
var isCancel = __webpack_require__(373);
var defaults = __webpack_require__(224);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(374);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(47);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cognito_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_router_js__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TreeView__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TreeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_TreeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_es6_promise_auto__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_polyfill__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_full_calendar__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_fullcalendar_dist_fullcalendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_HttpHook__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_HttpHook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__plugins_HttpHook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils_js__ = __webpack_require__(16);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import colors from 'vuetify/es5/util/colors'
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router_router_js__["a" /* default */]);

// 言語の設定 (default)
var transslationList = {
  'ja': 'japanese',
  'en': 'english',
  'de': 'german',
  'ru': 'russian'
};
var transslations = {};
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(transslationList).forEach(function (key) {
  transslations[key] = __webpack_require__(702)("./" + transslationList[key]);
});

// ドメイン取得
var domainConfig = __WEBPACK_IMPORTED_MODULE_18__utils_utils_js__["a" /* default */].getDomainConfig();
var path = domainConfig.path;
if (path !== 'aqua_harps4_com') {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(transslationList).forEach(function (key) {
    var whitelabelTransslation = __webpack_require__(701)("./" + path + '/translations/' + transslationList[key]);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(whitelabelTransslation).forEach(function (label) {
      if (transslations[key][label] === undefined) {
        transslations[key][label] = whitelabelTransslation[label];
      } else {
        transslations[key][label] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(transslations[key][label], whitelabelTransslation[label]);
      }
    });
  });
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: transslations,
  fallbackLocale: 'en'
});

// 地域の設定 (enでもUKとUSで日付フォーマットが違う)
// 毎回代入する（stateにはいれない）
var language = window.navigator.languages && window.navigator.languages[0] || window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage;
__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_LOCALE', language);

if (window.localStorage) {
  // local storage にあるアカウント情報をチェックして store にセット
  try {
    var localUserString = window.localStorage.getItem('user') || 'null';
    var localUser = JSON.parse(localUserString);

    if (localUser && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.user !== localUser) {
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_USER', localUser);
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_REFRESHTOKEN', window.localStorage.getItem('refreshToken'));
    }
  } catch (e) {
    console.log(e);
  }

  // 設定パラメータ
  try {
    var settingParamsString = window.localStorage.getItem('settingParams') || 'null';
    var settingParams = JSON.parse(settingParamsString);
    if (settingParams && settingParams.unit) {
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_SETTINGPARAMS', settingParams);
    }
  } catch (e) {
    console.log(e);
  }

  // StartGuide
  try {
    var showStartGuide = true;
    var showStartGuideString = window.localStorage.getItem('showStartGuide');
    if (showStartGuideString !== null) {
      var parsed = JSON.parse(showStartGuideString);
      showStartGuide = parsed.showStartGuide;
    }
    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_SHOWSTARTGUIDE', showStartGuide);
  } catch (e) {
    console.log(e);
  }

  // 言語の設定をリストア
  try {
    var _language = void 0;
    var languageString = window.localStorage.getItem('language');
    if (languageString !== null) {
      var _parsed = JSON.parse(languageString);
      _language = _parsed.language;
    } else {
      // ローカルストレージにない場合はブラウザ情報から拾う
      // chrome, safariにより形式が少し異なる。
      // 指定言語以外は英語表記
      if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale === 'ja' || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale === 'ja-JP') {
        _language = 'ja';
      } else if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale === 'de' || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale.indexOf('de-') === 0) {
        _language = 'de';
      } else if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale === 'uk' || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale.indexOf('uk-') === 0) {
        _language = 'ru';
      } else if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale === 'ru' || __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.locale.indexOf('ru-') === 0) {
        _language = 'ru';
      } else {
        _language = 'en';
      }
    }
    i18n.locale = _language;
  } catch (e) {
    console.log(e);
  }
}

// Pace.js の設定
window.Pace.options.ajax.trackMethods = ['GET', 'POST', 'DELETE', 'PUT', 'PATCH'];

// マテリアルコンポーネントフレームワーク
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    warning: '#FF9300'
  }
});

// カレンダー
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_full_calendar__["a" /* default */]);

if (path === 'aqua_harps4_com') {
  // google analytics
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_analytics___default.a, {
    id: 'UA-109213674-2',
    router: __WEBPACK_IMPORTED_MODULE_9__router_router_js__["a" /* default */]
  });
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17__plugins_HttpHook___default.a);

// 組織の階層表示用。 再帰的に表示するためにここで宣言
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('tree-view', __WEBPACK_IMPORTED_MODULE_11__components_TreeView___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_9__router_router_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App_vue___default.a },
  hoge: { hogehoge: 'hoge' },
  created: function created() {
    this.$httpHookInit();
    __WEBPACK_IMPORTED_MODULE_8__utils_http_js__["a" /* default */].request('get', '/service2/configs/getCognitoConfigs').then(function (response) {
      var data = response.data;
      __WEBPACK_IMPORTED_MODULE_7__utils_cognito_js__["a" /* default */].initialize(data.region, data.userPoolId, data.clientId);
    }).catch(function (error) {
      // TODO エラー処理 ログイン画面を出してはいけない
      console.log("http.request('get', '/service2/configs/getCognitoConfigs') failed with:", error);
    });

    // 翻訳されたサービス名をstoreに格納
    // ハードコーディングが必須要件、かつ翻訳データがあるこのタイミングで格納
    var long = [null, this.$t('service.flow-and-time'), this.$t('service.ro-membrane'), this.$t('service.temperature'), this.$t('service.leakage'), this.$t('service.pressure')];
    var short = [null, this.$t('service-short.flow-and-time'), this.$t('service-short.ro-membrane'), this.$t('service-short.temperature'), this.$t('service-short.leakage'), this.$t('service-short.pressure')];
    // タブ表示等で使う識別子。ここで入れなくてもいいけど、管理が楽なのでここで格納
    var code = [null, 'FLOW', 'RO', 'TEMPERA', 'LEAK', 'PRESS'];
    this.$store.commit('SET_SERVICELIST', { long: long, short: short, code: code });
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_cognito_js__ = __webpack_require__(126);






/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(_ref, _ref2) {
    var commit = _ref.commit;
    var username = _ref2.username,
        password = _ref2.password;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__utils_cognito_js__["a" /* default */].login(username, password).then(function (response) {
        var JwtToken = response.getIdToken().getJwtToken();
        var RefreshToken = response.getRefreshToken().getToken();
        if (JwtToken && RefreshToken) {
          commit('SET_TOKEN', JwtToken);
          commit('SET_REFRESHTOKEN', RefreshToken);
          if (window.localStorage) {
            window.localStorage.setItem('token', JwtToken);
            window.localStorage.setItem('refreshToken', RefreshToken);
          }
          resolve();
          return;
        }
        reject('Cannot retrieve token');
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('SET_USER', null);
      commit('SET_TOKEN', null);
      commit('SET_REFRESHTOKEN', null);
      commit('SET_SETTINGPARAMS', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
        window.localStorage.setItem('refreshToken', null);
        window.localStorage.setItem('settingParams', null);
      }
      // cognito.logout() // TODO:これちゃんと動いてない、、、、
      resolve();
    });
  },
  getme: function getme(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/accounts/getDetail').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          console.log(data.result);
          reject('get account data failed (get me). (' + data.result + ')');
        }

        commit('SET_USER', data);

        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        }
        resolve();
      });
    });
  },
  getSettingParam: function getSettingParam(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/accounts/getSettingModalParams').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          reject('get setting param failed. (' + data.result + ')');
        }

        if (data.settingModalParam === null) {
          data.settingModalParam = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].defaultSettingParams;
        } else {
          // 不足項目を確認して埋める
          for (var key in __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].defaultSettingParams) {
            if (!data.settingModalParam[key]) {
              data.settingModalParam[key] = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].defaultSettingParams[key];
            }
          }
        }

        commit('SET_SETTINGPARAMS', data.settingModalParam);

        if (window.localStorage) {
          window.localStorage.setItem('settingParams', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.settingModalParam));
        }

        resolve();
      });
    });
  },
  setSettingParam: function setSettingParam(_ref6, _ref7) {
    var _this = this;

    var commit = _ref6.commit;
    var unit = _ref7.unit,
        timezone = _ref7.timezone,
        pressureUnit = _ref7.pressureUnit,
        temperatureUnit = _ref7.temperatureUnit,
        emailNotification = _ref7.emailNotification,
        emailLanguage = _ref7.emailLanguage;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (!unit) {
        unit = _this.getters.settingParams.unit;
      }
      if (!timezone) {
        timezone = _this.getters.settingParams.timezone;
      }
      if (!pressureUnit) {
        pressureUnit = _this.getters.settingParams.pressureUnit;
      }
      if (!temperatureUnit) {
        temperatureUnit = _this.getters.settingParams.temperatureUnit;
      }
      if (!emailNotification) {
        emailNotification = _this.getters.settingParams.emailNotification;
      }
      if (!emailLanguage) {
        emailLanguage = _this.getters.settingParams.emailLanguage;
      }
      var params = {
        settingModalParam: {
          unit: unit,
          timezone: timezone,
          pressureUnit: pressureUnit,
          temperatureUnit: temperatureUnit,
          emailNotification: emailNotification,
          emailLanguage: emailLanguage
        }
      };
      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/updateSettingModalParams', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          reject('set setting param failed. (' + data.result + ')');
        }

        commit('SET_SETTINGPARAMS', params.settingModalParam);

        if (window.localStorage) {
          window.localStorage.setItem('settingParams', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params.settingModalParam));
        }

        resolve();
      });
    });
  },
  setShowStartGuide: function setShowStartGuide(_ref8, flag) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('SET_SHOWSTARTGUIDE', flag);

      if (window.localStorage) {
        window.localStorage.setItem('showStartGuide', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ showStartGuide: flag }));
      }
    });
  },
  setLanguage: function setLanguage(_ref9, flag) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (window.localStorage) {
        window.localStorage.setItem('language', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ language: flag }));
      }
      location.reload();
    });
  },
  refreshSession: function refreshSession(_ref10, _ref11) {
    var commit = _ref10.commit;
    var username = _ref11.username,
        refreshToken = _ref11.refreshToken;

    console.log(username);
    console.log(refreshToken);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__utils_cognito_js__["a" /* default */].refreshSession(username, refreshToken).then(function (response) {
        var JwtToken = response.getIdToken().getJwtToken();
        var RefreshToken = response.getRefreshToken().getToken();
        if (JwtToken && RefreshToken) {
          commit('SET_TOKEN', JwtToken);
          commit('SET_REFRESHTOKEN', RefreshToken);
          if (window.localStorage) {
            window.localStorage.setItem('token', JwtToken);
            window.localStorage.setItem('refreshToken', RefreshToken);
          }
          resolve(response);
          return;
        }
        reject('refreshSession: err: JwtToken || RefreshToken does not exist');
      }).catch(function (error) {
        console.log(error);
        reject('RefreshSession is Error');
      });
    });
  }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  token: function token(state) {
    return state.token;
  },
  refreshToken: function refreshToken(state) {
    return state.refreshToken;
  },
  user: function user(state) {
    return state.user;
  },
  message: function message(state) {
    return state.message;
  },
  loggedIn: function loggedIn(state) {
    return state.token !== null;
  },
  userHasThoseRoles: function userHasThoseRoles(state, getters) {
    return function (targetRoles) {
      if (targetRoles.length === 0) {
        return true;
      }
      if (state.user) {
        var res = state.user.roles.some(function (role) {
          return targetRoles.indexOf(role['name']) >= 0;
        });
        return res;
      }
      return false;
    };
  },
  settingParams: function settingParams(state) {
    return state.settingParams;
  },
  unitLabel: function unitLabel(state) {
    if (state.settingParams !== null) {
      if (state.settingParams.unit === 'liter') {
        return 'liter';
      } else if (state.settingParams.unit === 'gal') {
        return 'gal';
      }
    }
    return 'liter';
  },
  startPage: function startPage(state) {
    if (state.logoutPage !== null) {
      return state.logoutPage;
    } else {
      return '/';
    }
  },
  showStartGuide: function showStartGuide(state) {
    return state.showStartGuide;
  },
  locale: function locale(state) {
    return state.locale;
  },
  serviceList: function serviceList(state) {
    return state.serviceList;
  },
  isCustomerFormat: function isCustomerFormat(state) {
    if (state.waterSystemDisplayMode === 'customer') return true;
    return false;
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESHTOKEN: function SET_REFRESHTOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  SET_MESSAGE: function SET_MESSAGE(state, message) {
    state.message = message;
  },
  SET_SETTINGPARAMS: function SET_SETTINGPARAMS(state, settingParams) {
    state.settingParams = settingParams;
  },
  SET_SHOWSTARTGUIDE: function SET_SHOWSTARTGUIDE(state, showStartGuide) {
    state.showStartGuide = showStartGuide;
  },
  SET_LOCALE: function SET_LOCALE(state, locale) {
    state.locale = locale;
  },
  SET_LOGOUTPAGE: function SET_LOGOUTPAGE(state, path) {
    state.logoutPage = path;
  },
  SET_SERVICELIST: function SET_SERVICELIST(state, params) {
    state.serviceList = {
      longNames: params.long,
      shortNames: params.short,
      codes: params.code
    };
  },
  SET_WATERSYSTEM_DISPLAYMODE: function SET_WATERSYSTEM_DISPLAYMODE(state, mode) {
    state.waterSystemDisplayMode = mode;
  }
});

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  user: null,
  token: null,
  refreshToken: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  },
  message: null,
  settingParams: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].defaultSettingParams,
  logoutPage: null,
  showStartGuide: true,
  locale: 'en',
  serviceList: { // main.jsで格納
    longNames: [],
    shortNames: [],
    codes: []
  },
  waterSystemDisplayMode: 'customer' // Home画面のクイックリンク用
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root
    };
  },

  methods: {
    init: function init() {}
  },
  mounted: function mounted() {
    this.init();
  },
  updated: function updated() {}
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      addBtnDisabled: true,
      organizations: [],
      organization: [], // 所属組織情報
      limitCreateHierarchy: 0, // 自組織の組織作成権限
      edit: {
        parOrganization: '',
        name: '',
        contact: '',
        description: '',
        startDate: '',
        phone: '',
        email: ''
      },
      // organizations: [],
      message: '',
      submitted: false, // submitフラグ
      showAddDialog: false,
      validated: true,
      btnDisable: false,
      // rule
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('account.vali-phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('account.vali-phone-length');
      }]
    };
  },

  methods: {
    init: function init() {
      // 所属組織の情報を取得
      this.getOrganization(this.$store.getters.user.organizationId);
    },
    getOrganization: function getOrganization(organizationId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/organizations/getDetail/' + organizationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization data failed. (' + data.result + ')');
          return;
        }

        _this2.organization = data;
        _this2.setlimitCreateHierarchy(_this2.organization);
        _this2.addBtnDisabled = false; // ボタンを使用可能にする
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    setlimitCreateHierarchy: function setlimitCreateHierarchy(organization) {
      this.limitCreateHierarchy = organization.master.limitCreateHierarchy - organization.master.depth;
    },
    getOrganizations: function getOrganizations() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/organizationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization list failed. (' + data.result + ')');
          return;
        }
        _this3.organizations = _this3.limitOrganizations(data.organizations);
        console.log(_this3.organizations);
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    limitOrganizations: function limitOrganizations(organizations) {
      var result = [];
      console.log('orgni', organizations);
      for (var key in organizations) {
        // PC組織の作成制限 - (ログインユーザーの拠点基準の階層 + PC拠点基準の階層)
        var wklimitCreateHierarchy = parseInt(this.organization.master.limitCreateHierarchy) - (parseInt(organizations[key].depth) + parseInt(this.organization.master.depth));
        if (wklimitCreateHierarchy > 0) {
          // 作成可能な組織だけリストに表示
          result.push(organizations[key]);
        }
      }
      return result;
    },
    addOrganization: function addOrganization() {
      var _this4 = this;

      this.btnDisable = true;
      var params = {
        parOrganizationId: this.edit.parOrganization,
        name: this.edit.name,
        contact: this.edit.contact,
        phone: this.edit.phone,
        email: this.edit.email,
        description: this.edit.description,
        startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD 00:00:00')
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Organizations/register', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          if (data.result === -2) {
            _this4.$emit('child-action', 'error', _this4.$t('organizations.vali-create-limit'));
          } else {
            console.log('add organization data failed. (' + data.result + ')');
            _this4.$emit('child-action', 'error', data.result);
          }

          _this4.btnDisable = false;
          return;
        }
        _this4.$emit('child-action', 'success', 'success!');
        _this4.$refs.addOrganizationForm.reset();
        // ダイアログ非表示
        _this4.btnDisable = false;
        _this4.showAddDialog = false;
        _this4.$router.push('/settings/organizations_detail');
      }).catch(function (error) {
        console.log('error', error);
        _this4.$emit('child-action', 'error', error);
        if (error.response.status === 403) {
          _this4.$emit('child-action', 'error', _this4.$store.getters.message.message);
        } else {
          _this4.$emit('child-action', 'error', error);
        }
        _this4.btnDisable = false;
      });
    },
    startDialog: function startDialog() {
      // 組織作成制御
      if (this.limitCreateHierarchy === 0) {
        this.$emit('child-action', 'error', this.$t('organizations.vali-create-limit'));
        return;
      }
      this.getOrganizations();
      this.showAddDialog = true;
    },
    closeDialog: function closeDialog() {
      this.$refs.addOrganizationForm.reset();
      this.btnDisable = false;
      this.showAddDialog = false;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      organizations: [],
      configLimitCreateHierarchy: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].organizationConfig.limitCreateHierarchy,
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root,
      customerCategories: [],
      edit: {
        organization: '',
        parOrganization: '',
        name: '',
        contact: '',
        description: '',
        startDate: '',
        phone: '',
        email: '',
        username: '',
        useremail: '',
        limitCreateHierarchy: 0,
        createNoLimit: false,
        customerCategoryId: 0
      },
      showAddDialog: false,
      validated: true,
      btnDisable: false,
      errorMessage: '',
      // rule
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('account.vali-phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('account.vali-phone-length');
      }],
      useremailRules: [function (v) {
        return !!v || _this.$t('account.vali-email-must');
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }]
    };
  },

  methods: {
    init: function init() {
      this.getCustomerCategories();
    },
    getCustomerCategories: function getCustomerCategories() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/CustomerCategories/customerCategoryList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get customerCategories list failed. (' + data.result + ')');
          return;
        }
        _this2.customerCategories = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].setNameCustomerCategories(_this2.$t, data.customerCategories);
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    startDialog: function startDialog(param) {
      this.errorMessage = '';
      this.showAddDialog = true;
      this.edit.description = param.description;
      this.edit.name = param.name;
      this.edit.username = param.username;
      this.edit.useremail = param.useremail;
      this.edit.contact = param.contact;
      this.edit.phone = param.phone;
      this.edit.email = param.email;
      this.edit.limitCreateHierarchy = param.limitCreateHierarchy;
      this.edit.customerCategoryId = parseInt(param.customer_category_id);
      this.$refs.addOrganizationPcForm.reset();
      // 初期値に無限大を設定
      this.edit.createNoLimit = true;
    },
    addOrganizationPc: function addOrganizationPc() {
      var _this3 = this;

      var self = this;
      var params = {
        organizationName: this.edit.name,
        contact: this.edit.contact,
        phone: this.edit.phone,
        organizationEmail: this.edit.email,
        description: this.edit.description,
        username: this.edit.username,
        useremail: this.edit.useremail,
        generatedUuid: __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].generateUuid(),
        limitCreateHierarchy: this.setLimitCreateHierarchy(),
        customerCategoryId: this.edit.customerCategoryId
      };
      console.log(params);
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Organizations/registerPc', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          switch (data.result) {
            case -102:
              self.showError(self.$t('account.fail-username'));
              break;
            default:
              self.showError('server error');
          }
        } else {
          _this3.$emit('reload');
          _this3.closeDialog();
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    setLimitCreateHierarchy: function setLimitCreateHierarchy() {
      var limitCreateHierarchy = this.configLimitCreateHierarchy.min;
      if (this.edit.createNoLimit === true) {
        limitCreateHierarchy = this.configLimitCreateHierarchy.max;
      }
      return limitCreateHierarchy;
    },
    closeDialog: function closeDialog() {
      this.btnDisable = false;
      this.showAddDialog = false;
    },
    showError: function showError(error) {
      this.errorMessage = error;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OrganizationEdit_vue__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OrganizationEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OrganizationEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationPcAdd__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationPcAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationPcAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    organizationEditBtn: __WEBPACK_IMPORTED_MODULE_1__components_OrganizationEdit_vue___default.a,
    organizationPcAddBtn: __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationPcAdd___default.a
  },
  data: function data() {
    var _this = this;

    return {
      organizationPcs: [],
      accountList: [],
      listHeaders: [{ text: this.$t('account.label-username'), value: 'username' }, { text: this.$t('account.label-useremail'), value: 'email' }],
      settingBtnDisabled: true,
      listSearch: '',
      pc: {
        name: '',
        contact: '',
        description: '',
        phone: '',
        email: '',
        customerCategoryName: ''
      },
      // rule
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('account.vali-phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('account.vali-phone-length');
      }],

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      selectedOrganization: [] // 選択中の情報を保持
    };
  },

  computed: {
    filteredPcs: function filteredPcs() {
      var _this2 = this;

      return this.organizationPcs.filter(function (a) {
        return a.name.toLowerCase().includes(_this2.listSearch.toLowerCase());
      });
    }
  },
  methods: {
    init: function init() {
      this.getOrganizationPcs();
    },
    getLocations: function getLocations() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/locationList').then(function (response) {
        var data = response.data;
        console.log(data);
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location list failed. (' + data.result + ')');
          return;
        }
        _this3.locations = data.locations;
        _this3.initDisplayLocations = data.locations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    editOrganization: function editOrganization() {
      this.$refs.organizationEditDialog.startDialog(this.selectedOrganization);
    },
    selectOrganization: function selectOrganization(param) {
      // 選択状態のダイアログを保持
      this.selectedOrganization = param;
      this.settingBtnDisabled = false;
      // 表示情報をバインド
      this.pc.description = param.description;
      this.pc.name = param.name;
      this.pc.username = param.username;
      this.pc.useremail = param.useremail;
      this.pc.contact = param.contact;
      this.pc.phone = param.phone;
      this.pc.email = param.email;
      console.log(param);
      this.pc.customerCategoryName = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].setNameCustomerCategory(this.$t, param.customerCategoryName, param.customer_category_id);
      // アドミンアカウント情報を表示
      this.getAccounts(param.id);
    },
    addOrganizationPc: function addOrganizationPc() {
      this.$refs.organizationPcAddBtn.addOrganizationPc();
    },
    getOrganizationPcs: function getOrganizationPcs() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/pcList/').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization list failed. (' + data.result + ')');
          return;
        }
        delete data.result;
        _this4.organizationPcs = data.pcOrganizations;
        // 今表示しているデータを最新の情報で更新
        if (_this4.selectedOrganization.id) {
          // IDで絞り込み
          var nowSelectedOrganization = _this4.organizationPcs.filter(function (x) {
            return x.id === _this4.selectedOrganization.id;
          });
          if (nowSelectedOrganization) {
            _this4.selectOrganization(nowSelectedOrganization[0]);
          }
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getAccounts: function getAccounts(organizationId) {
      var _this5 = this;

      // Administrator権限ユーザーのみ取得
      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/organizations/accountList/' + organizationId + '/2').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get account list failed. (' + data.result + ')');
          return;
        }
        // 表示用の加工
        _this5.accountList = [];
        if (data.accounts.length === 0) {
          return;
        }
        for (var key in data.accounts) {
          if (data.accounts[key].roles[0].id === '2') {
            _this5.accountList.push({
              id: data.accounts[key].id,
              username: data.accounts[key].username,
              email: data.accounts[key].email,
              user_status: data.accounts[key].user_status
            });
          }
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    showMessage: function showMessage(result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg;
          this.snackbarColor = 'red lighten-3';
          this.snackbarTimeout = 6000;
          this.showSnackbar = true;
          break;
        case 'success':
          this.snackbarMessage = msg;
          this.snackbarColor = 'teal lighten-2';
          this.snackbarTimeout = 3000;
          this.showSnackbar = true;
          break;
        default:
          return;
      }
    },
    resendMail: function resendMail(accountId) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/accounts/inviteMail', { 'accountId': accountId }).then(function (response) {
        if (response.data.result === -34) {
          _this6.showMessage('error', _this6.$t('account.already-account'));
        } else if (response.data.result === 0) {
          _this6.showMessage('success', _this6.$t('account.success-dialog'));
        } else {
          _this6.showMessage('error', _this6.$t('account.fail-dialog'));
        }
      }).catch(function (error) {
        console.log(error);
        _this6.showMessage('error', _this6.$t('account.fail-dialog'));
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationAdd__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationAdd__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OrganizationAddBtn: __WEBPACK_IMPORTED_MODULE_3__components_AccountOrganizationAdd___default.a
  },
  data: function data() {
    var _this = this;

    return {
      edit: {},
      organizations: [],
      organizationsInTree: [],
      roles: [],
      btnDisable: false,
      validated: false,
      showForm: false,
      showDeleteDialog: false,

      selectedOrganizationId: null,
      preSelectedOrganizationId: null, // css用に前回の値を格納

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // rule
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('account.vali-phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('account.vali-phone-length');
      }],
      treeData: {
        name: this.$store.getters.user.organizationName,
        organizationId: this.$store.getters.user.organizationId,
        children: []
      }
    };
  },

  methods: {
    init: function init() {
      this.getTree(); // TreeView.vueを使って再帰的に階層を表現
      this.getOrganizations(); // TODO:ユーザー詳細画面に持っていく(持っていかない方法がありそう)
      this.roles = this.getRoles(this.$store.getters.user.roles[0]['name']);
    },
    getOrganizations: function getOrganizations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/organizationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization list failed. (' + data.result + ')');
          return;
        }
        _this2.organizations = data.organizations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getTree: function getTree() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/organizationTree/' + this.$store.getters.user.organizationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get tree failed. (' + data.result + ')');
          return;
        }
        _this3.treeData.children = data.organizations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getRoles: function getRoles(role) {
      var viewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-not-limited-viewer') + ')';
      var limitedViewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-limited-viewer') + ')';
      // ここはハードコード
      switch (role) {
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root:
          return [{ id: 1, name: 'Root' }, { id: 2, name: 'Administrator' }, { id: 3, name: 'Manager' }, { id: 4, name: 'Staff' }, { id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Administrator:
          return [{ id: 2, name: 'Administrator' }, { id: 3, name: 'Manager' }, { id: 4, name: 'Staff' }, { id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Manager:
          return [{ id: 3, name: 'Manager' }, { id: 4, name: 'Staff' }, { id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Staff:
          return [{ id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer:
          return [];
        default:
          return [];
      }
    },
    selectOrganization: function selectOrganization(organizationId) {
      this.selectedOrganizationId = organizationId;
      this.$refs.child.init(organizationId);

      // TODO:かなり力技でcssを変えてる
      // 再帰的にcomponentを呼んでいるので選択しているIDを子に伝えづらい・リロードしてくれない
      if (this.preSelectedOrganizationId) {
        // 前回のcssを削除
        var preBox = document.getElementById('organization' + this.preSelectedOrganizationId);
        if (preBox) preBox.style.backgroundColor = '';
      }
      // 今回のcssを付与
      var box = document.getElementById('organization' + organizationId);
      box.style.backgroundColor = '#FFF';
      // 格納
      this.preSelectedOrganizationId = organizationId;
    },
    showMessage: function showMessage(result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg;
          this.snackbarColor = 'red lighten-3';
          this.snackbarTimeout = 6000;
          this.showSnackbar = true;
          break;
        case 'success':
          this.snackbarMessage = msg;
          this.snackbarColor = 'teal lighten-2';
          this.snackbarTimeout = 3000;
          this.showSnackbar = true;
          break;
        default:
          return;
      }
      this.getOrganizations();
      this.getTree();
    }
  },
  computed: {
    organizationsForAdd: function organizationsForAdd() {
      // TODO:変更検知して子のAccountOrganizationAddに伝える(もっといい方法ありそう)
      return this.organizations;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['selectedOrganizationId'],
  data: function data() {
    var _this = this;

    return {
      edit: {},
      organizations: [],
      organizationId: null,
      btnDisable: false,
      validated: false,
      showForm: false,
      showDeleteDialog: false,
      editNameLabel: '',

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // rule
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('account.vali-phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('account.vali-phone-length');
      }]
    };
  },

  methods: {
    init: function init(organizationId) {
      // ユーザ一覧画面から組織詳細に移った場合、組織一覧では押下されたままなので、反映する
      this.organizationId = organizationId; // 一旦格納
      if (this.organizationId === undefined && this.selectedOrganizationId !== null) {
        this.organizationId = this.selectedOrganizationId;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.organizationId)) {
        this.getOrganization(this.organizationId);
      }
    },
    getOrganization: function getOrganization(organizationId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/getDetail/' + organizationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization data failed. (' + data.result + ')');
          return;
        }
        _this2.edit = data;
        _this2.disabled = true;
        _this2.editNameLabel = _this2.$t('account.organization') + ' ' + _this2.$t('account.fail-master-name');
        if (_this2.edit.master.depth !== 0) {
          _this2.disabled = false;
          _this2.editNameLabel = _this2.$t('account.organization');
        }
        // null値が入っていると、バリデーションが効かない
        for (var k in _this2.edit) {
          if (_this2.edit[k] == null) _this2.edit[k] = '';
        }_this2.showForm = true;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    updateOrganization: function updateOrganization() {
      var _this3 = this;

      this.btnDisable = true;
      var params = {
        organizationId: this.edit.id,
        contact: this.edit.contact,
        description: this.edit.description,
        phone: this.edit.phone,
        email: this.edit.email
      };
      if (this.edit.master.depth !== 0) {
        params.name = this.edit.name;
      }
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Organizations/updateDetail', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('update organization data failed. (' + data.result + ')');
          _this3.$emit('child-action', 'error', data.result);
          return;
        }
        _this3.$emit('child-action', 'success', _this3.$t('account.updated'));
      }).catch(function (error) {
        console.log('error', error);
        if (error.response.status === 403) {
          _this3.$emit('child-action', 'error', _this3.$store.getters.message.message);
        } else {
          _this3.$emit('child-action', 'error', error);
        }
      });
      this.btnDisable = false;
    },
    deleteOrganization: function deleteOrganization() {
      var _this4 = this;

      console.log('delete:' + this.edit.id);
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Organizations/deleteOrganization', { organizationId: this.edit.id }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          console.log('delete organization failed. (' + data.result + ')');
          switch (data.result) {
            case -10:
              _this4.$emit('child-action', 'error', _this4.$t('account.error-root'));
              break;
            case -11:
              _this4.$emit('child-action', 'error', _this4.$t('account.error-user'));
              break;
            case -12:
              _this4.$emit('child-action', 'error', _this4.$t('account.error-customer'));
              break;
            case -13:
              _this4.$emit('child-action', 'error', _this4.$t('account.error-system'));
              break;
            default:
              _this4.$emit('child-action', 'error', _this4.$t('account.error-delete'));
          }
          return;
        }
        _this4.$emit('child-action', 'success', _this4.edit.name + ' has been deleted.');
        _this4.showForm = false;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
        if (error.response.status === 403) {
          _this4.$emit('child-action', 'error', _this4.$store.getters.message.message);
        } else {
          _this4.$emit('child-action', 'error', error);
        }
      });
      this.showDeleteDialog = false;
    }
  },
  computed: {},
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RoleLabel_vue__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RoleLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_RoleLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AccountVisibleLocationsSetDialog_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AccountVisibleLocationsSetDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AccountVisibleLocationsSetDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils_js__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RoleLabel: __WEBPACK_IMPORTED_MODULE_3__components_RoleLabel_vue___default.a,
    VisibleLocationsSet: __WEBPACK_IMPORTED_MODULE_4__components_AccountVisibleLocationsSetDialog_vue___default.a
  },
  props: ['selectedOrganizationId', 'organizations', 'roles'],
  data: function data() {
    return {
      accounts: [],
      status: '', // 'NODATA' or 'SELECTED'
      dataTotal: null,
      listSearch: '',
      pagination: {},
      selectedAccount: [],
      listHeaders: [{ text: this.$t('user.username'), value: 'username' }, { text: this.$t('user.email'), value: 'email' }, { text: this.$t('user.role'), value: 'role' }, { text: '', sortable: false, value: '' }],
      deleteTarget: [],
      showDeleteDialog: false,
      edit: [],
      showEditDialog: false,

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000
    };
  },

  computed: {
    editRoleOrganization: function editRoleOrganization() {
      return { accountId: this.edit.id, roleId: this.edit.roleId, organizationId: this.edit.organizationId };
    }
  },
  watch: {
    editRoleOrganization: {
      handler: function handler(val, prev) {
        if (val.accountId === prev.accountId && val.roleId !== '' && val.organizationId && (val.roleId !== prev.roleId || val.organizationId !== prev.organizationId)) {
          this.edit.accountGroupResourceIds = { viewLocation: [] };
        }
      },
      deep: true
    }
  },
  methods: {
    init: function init(organizationId) {
      // 組織詳細からユーザ一覧画面に移った場合、組織一覧では押下されたままなので、反映する
      this.organizationId = organizationId;
      if (this.organizationId === undefined && this.selectedOrganizationId !== null) {
        this.organizationId = this.selectedOrganizationId;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.organizationId)) {
        this.getAccounts(this.organizationId);
      }
    },
    checkEditableRole: function checkEditableRole(targetRoleId, userRoleId) {
      return __WEBPACK_IMPORTED_MODULE_5__utils_utils_js__["a" /* default */].checkEditableRole(targetRoleId, userRoleId);
    },
    getAccounts: function getAccounts(organizationId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/organizations/accountList/' + organizationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get account list failed. (' + data.result + ')');
          return;
        }
        _this.accounts = data.accounts;
        _this.dataTotal = data.accounts.length;

        if (_this.dataTotal === 0) {
          _this.status = 'NODATA';
          return;
        }
        _this.status = 'SELECTED';
        _this.accounts.forEach(function (account) {
          // 一人複数のRoleを持つ設計になっているので、格納しなおす（このままだとソートできない）
          account.roleName = account.roles[0].name;
          account.organizationId = organizationId;
          account.roleId = Number(account.roles[0].id);
          if (account.roleId === 7) {
            account.roleName += ' (' + _this.$t('viewable-locations.select-is-not-limited-viewer') + ')';
          }
          if (account.roleId === 8) {
            account.roleName = 'Viewer (' + _this.$t('viewable-locations.select-is-limited-viewer') + ')';
          }
        });
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    openEditDialog: function openEditDialog(edit) {
      this.edit = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(edit));
      if (this.edit.roleId === 8) {
        this.getAccountGroupResourceIds();
      }
      this.showEditDialog = true;
    },
    setViewerPermission: function setViewerPermission(edit) {
      this.edit = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(edit));
    },
    editAccount: function editAccount() {
      var _this2 = this;

      if (this.edit.id === this.$store.getters.user.id) {
        // 自身のアカウントの編集はさせない（組織や権限が途中で変更された場合のバグに対応できてないため）
        this.showEditDialog = false;
        this.showMessage('error', this.$t('account.cant-edit-yourself'));
        return;
      }
      var roleId = this.edit.roleId;
      var params = {
        accountId: this.edit.id,
        organizationId: this.edit.organizationId,
        roles: [roleId],
        accountGroupResourceIds: this.edit.accountGroupResourceIds || { viewLocation: [] }
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/updateDetail', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('update account data failed. (' + data.result + ')');
          _this2.showEditDialog = false;
          _this2.showMessage('error', data.result);
          return;
        }
        _this2.showEditDialog = false;
        _this2.showMessage('success', _this2.$t('account.update-succeed'));
        _this2.getAccounts(_this2.organizationId);
      }).catch(function (error) {
        console.log('error', error);
        _this2.showEditDialog = false;
        if (error.response.status === 403) {
          _this2.showMessage('error', _this2.$store.getters.message.message);
        } else {
          _this2.showMessage('error', error);
        }
      });
    },
    deleteAccount: function deleteAccount() {
      var _this3 = this;

      console.log('delete:' + this.deleteTarget.id);
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/deleteAccount', { accountId: this.deleteTarget.id }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('delete account failed. (' + data.result + ')');
          // this.showError(data.result)
          _this3.showDeleteDialog = false;
          if (data.result === -32) {
            // 自身の削除
            _this3.showMessage('error', _this3.$t('account.cant-delete-yourself'));
          } else if (data.result === -31) {
            _this3.showMessage('error', _this3.$t('account.cant-delete-admin-user'));
          } else {
            _this3.showMessage('error', data.result);
          }
          return;
        }
        // 自身の削除だった場合にログインに戻る
        if (_this3.$store.getters.user.id === _this3.deleteTarget.id) {
          _this3.$store.dispatch('logout'); // ログアウト処理を呼び出す
          // 下記のメッセージがログイン画面に表示される
          _this3.$store.commit('SET_MESSAGE', {
            title: '',
            message: _this3.$t('account.delete-completed-myself'),
            level: 'info'
          });
          _this3.$router.push('/login'); // ログイン画面へ
          return;
        }
        _this3.showDeleteDialog = false;
        _this3.showMessage('success', _this3.$t('account.delete-succeed'));
        _this3.getAccounts(_this3.organizationId);
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
        _this3.showDeleteDialog = false;
        _this3.showMessage('error', error);
      });
    },
    showMessage: function showMessage(result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg;
          this.snackbarColor = 'red lighten-3';
          this.snackbarTimeout = 6000;
          this.showSnackbar = true;
          break;
        case 'success':
          this.snackbarMessage = msg;
          this.snackbarColor = 'teal lighten-2';
          this.snackbarTimeout = 3000;
          this.showSnackbar = true;
          break;
        default:
          return;
      }
    },
    resendMail: function resendMail(accountId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/accounts/inviteMail', { 'accountId': accountId }).then(function (response) {
        if (response.data.result === -34) {
          _this4.showMessage('error', _this4.$t('account.already-account'));
        } else if (response.data.result === 0) {
          _this4.showMessage('success', _this4.$t('account.success-dialog'));
        } else {
          _this4.showMessage('error', _this4.$t('account.fail-dialog'));
        }
      }).catch(function (error) {
        console.log(error);
        _this4.showMessage('error', _this4.$t('account.fail-dialog'));
      });
    },
    getAccountGroupResourceIds: function getAccountGroupResourceIds() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/accounts/accountGroupResourceList/' + this.edit.id).then(function (response) {
        _this5.edit.accountGroupResourceIds = { viewLocation: response.data.viewLocation };
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AccountVisibleLocationsSetDialog_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AccountVisibleLocationsSetDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AccountVisibleLocationsSetDialog_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VisibleLocationsSet: __WEBPACK_IMPORTED_MODULE_5__components_AccountVisibleLocationsSetDialog_vue___default.a
  },
  data: function data() {
    var _this = this;

    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Root,
      edit: {
        organizationId: '',
        username: '',
        password: '',
        email: '',
        roleId: '',
        acceptance: false,
        locations: []
      },
      organizations: [],
      roles: [],
      policyStatement: '',
      policyStatementLanguage: '',
      policyStatementversion: 0,
      errorMessage: '',
      successMessage: '',
      showDialog: false,
      showSnackbar: false,
      // バリデーションルール
      formValid: true,
      usernameRules: [function (v) {
        return !!v || _this.$t('account.vali-username-must');
      }, function (v) {
        return (/^[A-Za-z0-9.\-_@]+$/.test(v) || _this.$t('account.vali-username-format')
        );
      }, function (v) {
        return v && v.length <= 20 && v.length >= 4 || _this.$t('account.vali-username-char');
      }],
      emailRules: [function (v) {
        return !!v || _this.$t('account.vali-email-must');
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_4__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }],
      domain: ''
    };
  },

  computed: {
    editRoleOrganization: function editRoleOrganization() {
      return { roleId: this.edit.roleId, organizationId: this.edit.organizationId };
    }
  },
  watch: {
    editRoleOrganization: {
      handler: function handler(val, prev) {
        if (val.roleId !== '' && val.organizationId && (val.roleId !== prev.roleId || val.organizationId !== prev.organizationId)) {
          this.edit.accountGroupResourceIds = { viewLocation: [] };
        }
      },
      deep: true
    }
  },
  methods: {
    init: function init() {
      this.getOrganizations();
      this.roles = this.getRoles(this.userRole);
      this.getPolicyStatement();
      this.getDomainConfig();
    },
    getOrganizations: function getOrganizations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/organizationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization list failed. (' + data.result + ')');
          return;
        }
        _this2.organizations = data.organizations;

        // Rootアカウントの場合、直下しか見せないようにする
        if (_this2.userRole === __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Root) {
          console.log('here now root');
          var organizationsWhenRoot = _this2.organizations.filter(function (organization) {
            return organization.depth === '1';
          });
          _this2.organizations = organizationsWhenRoot;
          _this2.edit.roleId = 2; // ハードコード
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getRoles: function getRoles(role) {
      var viewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-not-limited-viewer') + ')';
      var limitedViewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-limited-viewer') + ')';
      // ここはハードコード
      switch (role) {
        case __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Root:
          return [{ id: 2, name: 'Administrator' }];
        case __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Administrator:
          return [{ id: 2, name: 'Administrator' }, { id: 3, name: 'Manager' }, { id: 4, name: 'Staff' }, { id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Manager:
          return [{ id: 3, name: 'Manager' }, { id: 4, name: 'Staff' }, { id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Staff:
          return [{ id: 7, name: viewerLabel }, { id: 8, name: limitedViewerLabel }];
        case __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Viewer:
          return [];
        default:
          return [];
      }
    },
    getPolicyStatement: function getPolicyStatement() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/policyStatements/getStatement', { language: 'English' }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get policy statement failed. (' + data.result + ')');
          return;
        }
        _this3.policyStatement = data.statement.statement;
        _this3.policyStatementLanguage = data.statement.language;
        _this3.policyStatementVersion = data.statement.maxVersion;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    setViewerPermission: function setViewerPermission(edit) {
      this.edit = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(edit));
    },
    registAccount: function registAccount() {
      var _this4 = this;

      this.showDialog = false;
      var roleId = this.edit.roleId;
      var params = {
        organizationId: this.edit.organizationId,
        username: this.edit.username,
        generatedUuid: __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].generateUuid(),
        password: this.edit.password,
        email: this.edit.email,
        roles: [roleId],
        accountGroupResourceIds: this.edit.accountGroupResourceIds || { viewLocation: [] },
        acceptance: true, // checkboxからAgreeボタンに変更
        language: this.policyStatementLanguage,
        version: this.policyStatementVersion,
        domain: this.domain
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/register', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('regist account data failed. (' + data.result + ')');
          _this4.showError(data.result);
          return;
        }

        _this4.showSnackbar = true;
        _this4.errorMessage = '';
        _this4.successMessage = _this4.edit.email;
        _this4.$refs.inviteForm.reset();
        // this.$router.push('/settings/user_invite')
        _this4.edit.accountGroupResourceIds = { viewLocation: [] };
      }).catch(function (error) {
        console.log('error', error);
        if (error.response.status === 403) {
          _this4.showError(_this4.$store.getters.message.message);
        } else {
          _this4.showError(error);
        }
      });
    },
    showError: function showError(error) {
      this.errorMessage = 'Add Account failed. (' + error + ')';
    },
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].getDomainConfig();
      this.domain = domainConfig.domain;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapModal_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MapModal_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MapModal: __WEBPACK_IMPORTED_MODULE_4__components_MapModal_vue___default.a
  },
  props: ['editProp'],
  data: function data() {
    var _this = this;

    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Root,
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Viewer,
      edit: {},
      validated: false,
      locations: [],
      errorMessage: '',
      showDialog: false,
      showMap: false,
      btnDisable: false,
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('validate.phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('validate.phone-length');
      }]
    };
  },

  watch: {},
  methods: {
    init: function init() {
      this.edit = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editProp));
      if (this.edit.accountGroupResourceIds === undefined) {
        this.edit.accountGroupResourceIds = { viewLocation: [] };
      }
      this.getLocations();
    },
    getLocations: function getLocations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/locationList/' + this.edit.organizationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location list failed. (' + data.result + ')');
          return;
        }
        _this2.locations = data.locations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    startDialog: function startDialog(edit) {
      this.$refs.viewerPermissionForm.reset(); // 一旦バリデーション等をリセット
      this.init();
      this.errorMessage = '';
      this.showMap = false;
      this.btnDisable = false;
      this.showDialog = true;
    },
    setVisibleLocations: function setVisibleLocations() {
      this.btnDisable = true; // ボタン無効化
      this.$emit('child-action', this.edit);
      this.btnDisable = true;
      this.showDialog = false;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    locale: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: ''
    },
    earliestLogInfo: Object,
    filtrationSystemProp: Object,
    filterProp: Object
  },
  data: function data() {
    var _this = this;

    return {
      filter: null,
      filtrationSystem: null,
      dateRangeMin: null,
      dateRangeMax: null,
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      showDatepickerStart: null,
      showDatepickerEnd: null,
      selectTimes: [],
      userRole: this.$store.getters.user.roles[0]['name'],
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_7__config_js__["a" /* default */].role.Viewer,
      validated: false,
      errorMessage: '',
      showErrorMessage: false,
      showDialog: false,
      btnDisable: false,
      startDateEndDateRules: [function (v) {
        return _this.startEndCorrelationValidationCase(_this.dateStartUnix, _this.dateEndUnix) || _this.$t('csv-download.invalid-start-end-datetime');
      }],
      startTimeEndTimeRules: [function (v) {
        return _this.startEndCorrelationValidationCase(_this.dateStartUnix, _this.dateEndUnix) || '';
      }]
    };
  },

  computed: {
    /**
     * 開始日時のUNIXタイムスタンプ
     */
    dateStartUnix: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].getDateTimeUnixTimestamp(this.dateStart, this.timeStart);
      }
    },
    /**
     * 終了日時のUNIXタイムスタンプ
     */
    dateEndUnix: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].getDateTimeUnixTimestamp(this.dateEnd, this.timeEnd);
      }
    },
    /**
     * 日フォーマット
     */
    formatDateStart: {
      get: function get() {
        return this.dateStart == null ? null : this.formatDateCommon(this.dateStart, { year: 'numeric', month: 'numeric', day: 'numeric' });
      },
      set: function set(dateStart) {
        this.dateStart = dateStart;
      }
    },
    /**
     * 日フォーマット
     */
    formatDateEnd: {
      get: function get() {
        return this.dateEnd == null ? null : this.formatDateCommon(this.dateEnd, { year: 'numeric', month: 'numeric', day: 'numeric' });
      },
      set: function set(dateEnd) {
        this.dateEnd = dateEnd;
      }
    },
    forbiddenBrowser: {
      get: function get() {
        return false;
      }
    }
  },
  watch: {
    filterProp: function filterProp() {
      this.filter = this.filterProp;
    },
    filtrationSystemProp: function filtrationSystemProp() {
      this.filtrationSystem = this.filtrationSystemProp;
    },
    dateStartUnix: function dateStartUnix() {
      this.$refs.csvDownloadForm.validate();
    },
    dateEndUnix: function dateEndUnix() {
      this.$refs.csvDownloadForm.validate();
    }
  },
  beforeMount: function beforeMount() {
    // 時刻セレクトボックス生成
    var minutesArr = [0, 15, 30, 45];
    for (var hour = 0; hour < 24; hour++) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(minutesArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var minute = _step.value;

          var timeInnerStr = ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2);
          var timeStr = this.formatDateCommon(new Date(1970, 1, 1, hour, minute), { hour: 'numeric', minute: 'numeric' });
          this.selectTimes.push({ text: timeStr, value: timeInnerStr });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  methods: {
    /**
     * ダウンロードダイアログを表示する
     */
    startDialog: function startDialog() {
      this.dateRangeMax = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(new Date().getTime(), this.locale, this.timezone, 'YYYY-MM-DD', true);
      this.dateRangeMin = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD');

      var datetimeEnd = Math.floor(new Date().getTime() / 1000);
      datetimeEnd = datetimeEnd - datetimeEnd % (15 * 60);
      var datetimeStart = this.earliestLogInfo.earliestTimestamp;
      datetimeStart = datetimeStart - datetimeStart % (15 * 60);

      this.dateEnd = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(datetimeEnd, this.locale, this.timezone, 'YYYY-MM-DD');
      this.dateStart = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(datetimeStart, this.locale, this.timezone, 'YYYY-MM-DD');

      this.timeEnd = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(datetimeEnd, this.locale, this.timezone, 'HH:mm');
      this.timeStart = __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(datetimeStart, this.locale, this.timezone, 'HH:mm');

      this.showDialog = true;
    },

    /**
     * エラーメッセージをダウンロードボタンの下に5秒表示する
     */
    showError: function showError(error) {
      this.showErrorMessage = true;
      this.errorMessage = error;
    },

    /**
     * ZIPファイル(中にCSVファイルが入っている)を作成し、作成に成功したらダウンロード処理を実行する
     * データがなくZIPファイルが作成されなかった場合はエラーメッセージを表示する
     */
    createDownloadZip: function createDownloadZip() {
      var _this2 = this;

      var params = this.setParams();
      // console.log(params)
      this.showDialog = false;
      __WEBPACK_IMPORTED_MODULE_8__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystemLogs/getSensorLogCsvDownloadUrl', params).then(function (response) {
        var data = response.data;
        if (data.result === -500) {
          _this2.showError(_this2.$t('csv-download.failed-create-zip-file-fatal'));
        } else if (data.result === -501) {
          _this2.showError(_this2.$t('csv-download.failed-create-zip-file-busy'));
        } else if (data.downloadShortUrl !== undefined) {
          _this2.downloadRequest(data.downloadShortUrl, params.zipFileName);
        } else {
          _this2.showError(_this2.$t('csv-download.failed-download-no-data'));
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
        _this2.showError(_this2.$t('csv-download.failed-create-zip-file-fatal'));
      });
      return;
    },

    /**
     * ZIPダウンロードリクエストを発行する
     */
    downloadRequest: function downloadRequest(downloadShortUrl, downloadFileName) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var downloadUrl, getConfig, zipRes, blob;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                downloadUrl = downloadShortUrl;

                if (!(__WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].iOS() && __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].safari())) {
                  _context.next = 5;
                  break;
                }

                // #23338
                _this3.letBrowserToSave(null, downloadUrl, downloadFileName);
                _context.next = 12;
                break;

              case 5:
                window._httpGrovalHookEnabled = false;
                getConfig = {
                  responseType: 'blob'
                };
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(downloadUrl, getConfig);

              case 9:
                zipRes = _context.sent;
                blob = new Blob([zipRes.data]);

                _this3.letBrowserToSave(blob, null, downloadFileName);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },

    /**
     * blobファイルを保存する
     * iOS safariについては、ダウンロードリンクをクリックさせる
     * @param remoteTargetUrl
     *  null でない場合は brob を使わず、ブラウザにリモートからダウンロードさせる。
     *  IE11 は未実装。
     */
    letBrowserToSave: function letBrowserToSave(blob, remoteTargetUrl, downloadFileName) {
      // IE11はwindow.navigator.msSaveOrOpenBlobを利用してBlobをダウンロードさせる
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, downloadFileName);
      } else {
        var link = document.createElement('a');
        if (remoteTargetUrl) {
          console.log('let browser download ' + downloadFileName);
          link.href = remoteTargetUrl;
        } else {
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', downloadFileName);
        }
        document.body.appendChild(link);
        console.log('link.click()');
        link.click();
      }
    },

    // ZIPダウンロード用パラメータを設定する
    // TODO サービス追加時にはこのメソッドと言語ファイルに処理、設定を追加すること
    setParams: function setParams() {
      var params = {};
      var settingParams = this.$store.getters.settingParams;
      if (settingParams === null) {
        settingParams = {};
      }
      // zipファイル内のCSVファイル名のプレフィックス
      var zipNamePrefix = this.filtrationSystem.filtrationSystemId + '_' + this.sanitizeBaseNameForFileName(this.filtrationSystem.filtrationSystemName);
      // zipファイル名の日付(yyyyMMddHHmm)
      var zipNameFrom = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.unix(this.dateStartUnix).tz(this.timezone).format('YYYYMMDDHHmm');
      var zipNameTo = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.unix(this.dateEndUnix).tz(this.timezone).format('YYYYMMDDHHmm');
      // zipファイル名
      var zipBaseName = zipNamePrefix + '_' + zipNameFrom + '_' + zipNameTo;
      // zipファイル名
      var zipFileName = this.omitLongerZipFileBaseName(zipBaseName) + '.zip';

      params = {
        filtrationSystemId: this.filtrationSystem.filtrationSystemId, // 浄水器システムID
        from: this.dateStartUnix, // 開始日時
        to: this.dateEndUnix, // 終了日時
        timezone: this.timezone, // タイムゾーン
        zipFileName: zipFileName, // zipファイル名
        units: {
          flow: settingParams.unit || 'liter',
          temperature: settingParams.temperatureUnit || '°C',
          pressure: settingParams.pressureUnit || 'MPa'
        }
      };
      return params;
    },

    /**
     * ファイル名に利用するためにzipファイルのbasenameのサニタイズをする
     * サニタイズ仕様:
     * 絵文字は''に置換する
     * ファイル名に利用できない文字が含まれていたら全角文字に変換する
     */
    sanitizeBaseNameForFileName: function sanitizeBaseNameForFileName(baseName) {
      var sanitizedBaseName = baseName.replace(/([\uD83C-\uD83F][\uDC00-\uDFFF])/g, '');
      return sanitizedBaseName.replace(/\\/g, '￥').replace(/\//g, '／').replace(/:/g, '：').replace(/\?/g, '？').replace(/"/, '”').replace(/</, '＜').replace(/>/g, '＞').replace(/\|/, '｜');
    },

    /**
     * ファイ名の文字列を切り詰める
     */
    omitLongerZipFileBaseName: function omitLongerZipFileBaseName(zipBaseName) {
      var strLen = 125;

      var _require = __webpack_require__(1771),
          StringDecoder = _require.StringDecoder;

      var decoder = new StringDecoder('utf8');
      if (Buffer.byteLength(zipBaseName, 'utf8') >= strLen) {
        var buf = new Buffer(zipBaseName);
        return decoder.write(buf.slice(0, strLen));
      } else {
        return zipBaseName;
      }
    },

    /**
     * JSONオブジェクトのディープコピー
     */
    deepCopyJson: function deepCopyJson(o) {
      var cache = [];
      var copyO = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(o, function (key, value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Duplicate reference found
            try {
              // If this value does not reference a parent it can be deduped
              return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
            } catch (error) {
              // discard key if value cannot be deduped
              return;
            }
          }
          // Store value in our collection
          cache.push(value);
        }
        return value;
      }));
      cache = null;
      return copyO;
    },

    /**
     * 日付をフォーマットする
     */
    formatDateCommon: function formatDateCommon(date, dateOptions) {
      dateOptions.timezone = this.timezone;
      return __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].dateFormatter(this.locale, __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).unix() * 1000, dateOptions);
    },

    /**
     * カレンダーの週の開始曜日を設定する
     */
    firstDayOfWeek: function firstDayOfWeek() {
      return __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale);
    },

    /**
     * 開始日時と終了日時の相関チェック
     * 開始日時 <= 終了日時であること
     * 開始日時 > 終了日時の場合はエラーメッセージを出すとともにダウンロードボタンを無効にする
     */
    startEndCorrelationValidationCase: function startEndCorrelationValidationCase(dateStartUnix, dateEndUnix) {
      return dateStartUnix <= dateEndUnix;
    }
  },
  mounted: function mounted() {
    this.init();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(109).Buffer))

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapModal_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MapModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MapModal: __WEBPACK_IMPORTED_MODULE_3__components_MapModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    return {
      mode: 'ADD', // or EDIT （顧客追加か顧客編集か）
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root,
      edit: {},
      validated: false,
      organizations: [],
      errorMessage: '',
      showDialog: false,
      showMap: false,
      btnDisable: false,
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('validate.phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('validate.phone-length');
      }]
    };
  },

  methods: {
    init: function init() {
      this.mode = 'ADD';
      this.getOrganizations();
    },
    getOrganizations: function getOrganizations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/organizationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get organization data failed. (' + data.result + ')');
          return;
        }
        _this2.organizations = data.organizations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    startDialog: function startDialog(edit) {
      this.$refs.customerForm.reset(); // 一旦バリデーション等をリセット
      if (edit.locationId != null) {
        // 引数あれば編集モード
        this.mode = 'EDIT';
        // 参照渡しにならないように各々代入 TODO:少しやり方が汚い
        this.edit.organizationId = edit.organizationId;
        this.edit.locationName = edit.locationName;
        this.edit.locationId = edit.locationId;
        this.edit.locationAddress = edit.locationAddress;
        this.edit.locationPhone = edit.locationPhone;
        this.edit.latitude = edit.latitude;
        this.edit.longitude = edit.longitude;
      } else {
        // 引数なければ追加モード
        this.mode = 'ADD';
        this.edit.organizationId = '';
        this.edit.locationName = '';
        this.edit.locationAddress = '';
        this.edit.locationPhone = '';
        this.edit.latitude = '';
        this.edit.longitude = '';
      }
      // null値が入っていると、バリデーションが効かない
      for (var k in this.edit) {
        if (this.edit[k] == null) this.edit[k] = '';
      }
      this.errorMessage = '';
      this.showMap = false;
      this.btnDisable = false;
      this.showDialog = true;
    },
    registLocation: function registLocation() {
      var _this3 = this;

      this.btnDisable = true; // ボタン無効化
      var params = {
        organizationId: this.edit.organizationId,
        name: this.edit.locationName,
        address: this.edit.locationAddress,
        phone: this.edit.locationPhone,
        latitude: this.edit.latitude,
        longitude: this.edit.longitude
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Locations/register', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('regist location data failed. (' + data.result + ')');
          _this3.showError(data.result);
          _this3.btnDisable = false;
          return;
        }
        _this3.$emit('child-action', 'success', 'success!');
        _this3.showDialog = false;
      }).catch(function (error) {
        console.log('error', error);
        _this3.showError(error);
        _this3.btnDisable = false;
      });
    },
    updateLocation: function updateLocation() {
      var _this4 = this;

      this.submitted = true; // ボタン無効化
      var params = {
        locationId: this.edit.locationId,
        organizationId: this.edit.organizationId,
        name: this.edit.locationName,
        address: this.edit.locationAddress,
        phone: this.edit.locationPhone,
        latitude: this.edit.latitude,
        longitude: this.edit.longitude
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Locations/edit', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('update location data failed. (' + data.result + ')');
          _this4.showError(data.result);
          _this4.btnDisable = false;
          return;
        }
        _this4.$emit('child-action', 'success', 'success!');
        _this4.showDialog = false;
      }).catch(function (error) {
        console.log('error', error);
        _this4.showError(error);
        _this4.btnDisable = false;
      });
    },
    getLatLng: function getLatLng() {
      var self = this;
      /* global google */
      var la = void 0,
          dv = void 0;
      la = document.getElementById('locationAddress');
      dv = la.getElementsByTagName('div');
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': this.edit.locationAddress }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          self.edit.latitude = results[0].geometry.location.lat();
          self.edit.longitude = results[0].geometry.location.lng();
          for (var i = 0; i < dv.length; i++) {
            if (dv[i].classList.contains('input-group__details')) {
              dv[i].innerHTML = '';
            }
          }
          // MapModalの地図を更新
          if (self.showMap) {
            self.$refs.mapmodal.initMap();
          }
        } else {
          for (var _i = 0; _i < dv.length; _i++) {
            if (dv[_i].classList.contains('input-group__details')) {
              dv[_i].innerHTML = self.$t('customer.error-location');
            }
            self.edit.latitude = '';
            self.edit.longitude = '';
          }
          console.log('Geocode was not successful for the following reason: ' + status);
        }
      });
    },
    showError: function showError(error) {
      this.errorMessage = 'failed. (' + error + ')';
    },
    selectLocation: function selectLocation() {
      console.log('selectLocation');
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomerEdit_vue__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomerEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CustomerEdit_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CustomerAddBtn: __WEBPACK_IMPORTED_MODULE_2__components_CustomerEdit_vue___default.a
  },
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root,
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer,
      locations: [],

      // リストテーブル用
      pagination: {
        rowsPerPage: 25
      },
      selectedLocations: [],
      listSearch: '',
      listHeaders: [{
        text: 'Customer Name',
        align: 'left',
        value: 'locationName'
      }, {
        text: 'Organization',
        value: 'organizationName'
      }],

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // ダイアログ表示用
      showDeleteDialog: false,
      deleteTarget: {},
      showFormDialog: false,

      // デザインからの要請で最初だけデータ表示
      initDisplayLocations: []

    };
  },

  methods: {
    init: function init() {
      this.getLocations();
    },
    getLocations: function getLocations() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/locationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location list failed. (' + data.result + ')');
          return;
        }
        _this.locations = data.locations;
        _this.initDisplayLocations = data.locations;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    editCustomer: function editCustomer(location) {
      this.$refs.customerDialog.startDialog(location);
    },
    deleteCustomer: function deleteCustomer() {
      var _this2 = this;

      console.log('delete:' + this.deleteTarget.locationId);
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Locations/deregister', { locationId: this.deleteTarget.locationId }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('delete location failed. (' + data.result + ')');
          var message = '';
          switch (data.result) {
            case -6:
              message = _this2.$t('customer.error-delete-connecting-device');
              break;
            default:
              message = _this2.$t('customer.error-delete') + '(' + data.result + ')';
              break;
          }
          _this2.showMessage('error', message);
          _this2.showDeleteDialog = false;
          return;
        }
        _this2.showMessage('success', _this2.$t('customer.success-delete'));
        _this2.showDeleteDialog = false;
        _this2.getLocations();
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
        _this2.showMessage('error', error);
        _this2.showDeleteDialog = false;
      });
    },
    showMessage: function showMessage(result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg;
          this.snackbarColor = 'red lighten-3';
          this.snackbarTimeout = 6000;
          this.showSnackbar = true;
          break;
        case 'success':
          this.getLocations();
          this.selectedLocations = []; // TODO: 一旦消さないと顧客詳細がEDIT時に更新されない
          this.snackbarMessage = msg;
          this.snackbarColor = 'teal lighten-2';
          this.snackbarTimeout = 3000;
          this.showSnackbar = true;
          break;
        default:
          return;
      }
    },
    toggleAll: function toggleAll() {
      // 表示してた初期データを削除
      this.initDisplayLocations = [];

      if (this.selectedLocations.length) {
        this.selectedLocations = [];
      } else {
        this.selectedLocations = this.filteredLocations;
      }
    }
  },
  computed: {
    initOrSelectedLocations: function initOrSelectedLocations() {
      if (this.initDisplayLocations.length > 0) return this.initDisplayLocations;
      return this.selectedLocations;
    },
    checkboxIndeterminate: function checkboxIndeterminate() {
      // 表示してた初期データを削除
      this.initDisplayLocations = [];

      switch (this.selectedLocations.length) {
        case 0:
          return false;
        case this.locations.length:
          this.selectedAll = true;
          return false;
        default:
          return true;
      }
    },
    filteredLocations: function filteredLocations() {
      var _this3 = this;

      return this.locations.filter(function (a) {
        return a.locationName.toLowerCase().includes(_this3.listSearch.toLowerCase());
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },

  watch: {
    selectedLocations: function selectedLocations() {
      if (this.selectedLocations.length === 0) return this.getLocations();
    }
  }
});

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DeleteConfirmModal',
  props: ['deleteTarget'],
  methods: {
    unregist: function unregist() {
      this.$emit('runDelete');
    }
  }
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      edit: {
        filtrationSystemId: '',
        filtrationSystemName: ''
      },
      validated: false,
      errorMessage: '',
      showDialog: false,
      isRoot: false,
      editBtnName: this.$t('btn.save') // 削除ボタン名
    };
  },

  methods: {
    init: function init() {
      this.setExecBtnProperty();
    },
    startDialog: function startDialog(param) {
      // 一旦バリデーション等をリセット
      this.$refs.deviceEditForm.reset();
      // 値をバインド
      this.edit.filtrationSystemId = param.filtrationSystemId;
      // エラーメッセージを初期化
      this.errorMessage = '';
      // 最新の情報を取得しセットする
      this.getSetDeviceInfomation(param.filtrationSystemId);
    },
    closeDialog: function closeDialog(update) {
      // 更新のために発火
      if (update) {
        this.$emit('child-action');
      }
      this.showDialog = false;
    },
    updateDevice: function updateDevice() {
      var _this = this;

      this.errorMessage = '';
      var params = {
        filtrationSystemId: this.edit.filtrationSystemId,
        filtrationSystemName: this.edit.filtrationSystemName
      };
      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystems/updateName', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('update organization data failed. (' + data.result + ')');
          return;
        }
        // 成功
        _this.closeDialog(true);
      }).catch(function (error) {
        console.log('error', error);
        _this.closeDialog();
      });
    },
    getSetDeviceInfomation: function getSetDeviceInfomation(filtrationSystemId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/FiltrationSystems/getFiltrationSystemName/' + filtrationSystemId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get filtration system data failed. (' + data.result + ')');
          _this2.errorMessage = 'Failed to get Divice Information.';
          return;
        }
        // 最新の値を反映
        _this2.edit.filtrationSystemId = data.device.filtrationSystemId;
        _this2.edit.filtrationSystemName = data.device.filtrationSystemName;
        // ダイアログを表示
        _this2.showDialog = true;
      }).catch(function (error) {
        // TODO エラー処理
        _this2.errorMessage = 'Failed to get Divice Information.';
        console.log('error', error);
      });
    },

    // 保存ボタンの属性をセットする
    setExecBtnProperty: function setExecBtnProperty() {
      this.isRoot = __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles); // ルートかどうかを判定
      if (this.isRoot) {
        this.editBtnName = this.$t('aplix-use-only.btn.can-not-save');
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'





var uuid = function uuid() {
  var uuid = '';
  var i = void 0;
  var random = void 0;
  for (i = 0; i < 32; i++) {
    random = Math.random() * 16 | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    uuid += (i === 12 ? 4 : i === 16 ? random & 3 | 8 : random).toString(16);
  }
  return uuid;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GraphDateSelect: __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default.a
  },
  name: 'FlowLogChart',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default: function _default() {
        return 'chart_' + uuid();
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    // 水量の単位
    unit: {
      type: String,
      default: 'ml',
      validator: function validator(value) {
        return ['ml', 'liter', 'gal', 'oz'].indexOf(value) >= 0;
      }
    },
    // スロット番号
    slotNum: {
      type: Number,
      required: true
    },
    // 開かれているタブ
    currentTab: {
      type: Number,
      default: 0
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'FlowDiff,Flow'
    },
    // TODO:言語設定を変更後、ラベルが翻訳しなおされない。
    labelFlow: {
      type: String,
      default: 'Flow'
    },
    labelFlowDiff: {
      type: String,
      default: 'FlowDiff'
    },
    labelFlowSum: {
      type: String,
      default: 'FlowSum'
    },
    earliestLogInfo: Object
  },

  data: function data() {
    return {
      // グラフデータの１プロットの間隔
      period: '15m',
      //
      items: [{ value: '15m', text: this.$t('chart.15m') }, { value: '1h', text: this.$t('chart.1h') }, { value: '1d', text: this.$t('chart.1d') }, { value: '1w', text: this.$t('chart.1w') }, { value: '1M', text: this.$t('chart.1M') }],
      // 親側で切り替えられると困るので、ここで保持しておく
      myChartId: this.id,
      // ECharts のインスタンス
      myChart: null,
      // dataZoom で現在表示中のレンジ
      range: {
        start: null,
        end: null
      },
      // dataZoom で前回表示していたレンジ
      prevRange: {
        start: null,
        end: null
      },
      firstZoomRange: null, // 初回ズーム時のレンジ
      // 日付選択
      toDatetimeUnixTime: 0,
      messagePeriodJump: '',
      messageNoData: '',
      isChangedPeriod: false, // 時間間隔を変更した場合
      isChangedRangeBar: false, // レンジバーを変更した場合
      isChangeRangeBarWidth: false, // レンジバーの幅を変更している場合
      isDataZoom: false, // ズーム範囲選択した場合
      showPeriodMessagePeriodJump: false, // 時間間隔変更時メッセージ表示
      showJumpMessagePeriodJump: false, // 日時指定移動時メッセージ表示

      // グラフの表示データ
      xAxisDatas: [],
      seriesDatas: [],
      outOfFromTimestamp: null, // fromより古いデータのうち一番新しいデータ
      outOfFromSeriesData: [],
      outOfToTimestamp: null, // toより新しいデータのうち一番古いデータ
      outOfToSeriesData: [],

      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],

      serviceCodes: this.$store.getters.serviceList.codes
    };
  },


  computed: {
    // API呼び出し時に渡す
    params: function params() {
      return {
        dataId: this.dataId,
        properties: this.properties.split(','),
        period: this.period,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to,
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale)
      };
    },


    // 現在のグラフの描画範囲（レンジの差分, 秒）
    rangeDiff: function rangeDiff() {
      return this.range.end - this.range.start;
    },

    // APIのfromに指定する値
    from: function from() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end - offsetFromPeriods * this.periodTime;
    },

    // APIのtoに指定する値
    to: function to() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end + offsetFromPeriods * this.periodTime;
    },
    periodTime: function periodTime() {
      return {
        '15m': 60 * 15,
        '1h': 60 * 60,
        '1d': 60 * 60 * 24,
        '1w': 60 * 60 * 24 * 7,
        '1M': 60 * 60 * 24 * 30
      }[this.period];
    }
  },

  methods: {
    // データ取得＆グラフ描画処理
    reload: function reload() {
      var _this = this;

      var self = this;

      // ローディング状態にする（ボタン無効化）
      self.reloading = true;
      // グラフのローディングを表示
      self.myChart.showLoading();

      console.log({
        'from': new Date(self.from * 1000),
        'to': new Date(self.to * 1000)
      });

      // APIの引数取得
      var params = self.params;
      console.log({ params: params });

      // API呼び出し
      self.graph.flowLog(params).then(function (data) {
        // Echartsオプション初期化
        self.initializeChartOption();
        self.messageNoData = '';

        var option = data;

        // 初期化
        self.xAxisDatas = [];
        self.seriesDatas = [];
        self.outOfFromTimestamp = null;
        self.outOfFromSeriesData = [];
        self.outOfToTimestamp = null;
        self.outOfToSeriesData = [];

        // レスポンスのデータをグラフにセット
        option.dataZoom = [{
          // API呼び出し前にセットしていたレンジを再設定
          startValue: self.range.start.toString(),
          endValue: self.range.end.toString()
        }];
        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        if (!option.xAxis.data.length) {
          // データがない場合は移動ボタンを無効化しメッセージ表示
          self.$refs.graphDateSelect.setDisableJump(true);
          self.messageNoData = self.$t('chart.message-no-data');
          return;
        }

        option.series.forEach(function (one) {
          one.data.forEach(function (element, index) {
            // console.log(Object.prototype.toString.call(element))
            if (element !== null) {
              one.data[index] = self.convertUnit(element);
            }
          });
        });
        // APIの引数from,toの範囲外のデータの切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].omitOutOfRangeFromToData(self, option);

        // option.dataZoom[0]の切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].fixOptionDataZoomRange(self, option);

        // 日付選択範囲によるメッセージ
        __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].setMessagePeriodJump(self, {
          'start': Number(option.dataZoom[0].startValue),
          'end': Number(option.dataZoom[0].endValue)
        });

        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        // データが少ない場合は移動ボタンを無効化
        self.setDisableJump({
          start: Number(option.dataZoom[0].startValue),
          end: Number(option.dataZoom[0].endValue)
        });

        option.xAxis.axisLabel = {
          formatter: function formatter(value) {
            // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
            // 描画時に文字列に変換する
            // moment.tz.setDefault(self.timezone)
            self.dateOptions = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period);
            self.dateOptions.timeZone = self.timezone;
            return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, value * 1000, self.dateOptions);
          }
        };

        // 先頭と末尾のデータ補正
        option = _this.fillPlotStartEnd(option);
        // グラフデータを再設定
        self.myChart.setOption(option);

        // dataZoom.rangeMode をパーセンテージに変更する
        // startValue, endValue の設定「後」にこれを行わないと、
        // dataZoom の labelFormatter がうまく効いてくれない
        setTimeout(function () {
          self.myChart.setOption({ dataZoom: [{ rangeMode: ['percent', 'percent'] }] });
        }, 0);
      }).catch(function (error) {
        console.log(error);
        // alert(JSON.stringify(error, null, 2))
      }).then(function () {
        // finally
        // ローディング状態を解除（ボタン有効化）
        self.reloading = false;
        // グラフのローディングを非表示
        self.myChart.hideLoading();
        // 読み込み時にwidth100%にする
        self.myChart.resize();
      });
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action');
    },

    // 先頭と末尾のデータ補正
    fillPlotStartEnd: function fillPlotStartEnd(option) {
      var FLOW_SERIES_INDEX = 1; // Flowのindex
      // 描画範囲内、描画範囲外のプロット位置の取得
      var fillPlotsRangeDatasets = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].retrieveFillPlotsRangeDatasets(this, option, FLOW_SERIES_INDEX);

      option.xAxis.data = fillPlotsRangeDatasets.option.xAxis.data;
      option.series = fillPlotsRangeDatasets.option.series;
      var viewRangeStartIndex = fillPlotsRangeDatasets.viewRangeStartIndex;
      var viewRangeEndIndex = fillPlotsRangeDatasets.viewRangeEndIndex;

      var rangeDatasets = fillPlotsRangeDatasets.rangeDatasets;
      // データがない状態から、データが取得できた場合は最古のタイムスタンプを反映
      this.emitEarliestTimestamp(rangeDatasets);

      // 描画範囲の先頭にプロットが描画されていない場合 かつ 描画範囲の前のデータがある場合
      if (option.series[FLOW_SERIES_INDEX].data[viewRangeStartIndex] === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        // 描画範囲の前のデータの次のデータ:タイムスタンプ
        var nextDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        // 描画範囲内の最古のデータがない場合かつ描画範囲のendより後のデータがある場合は描画範囲のendより後のデータのタイムスタンプを利用
        if (nextDataTimestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.latestViewRange.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        }
        if (nextDataTimestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.outOfViewRangeEnd.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeEnd.seriesData));
        }
        // 描画範囲内の最古のデータがない場合、かつは描画範囲のendより後のデータがない場合、描画範囲の先頭のタイムスタンプを利用
        if (nextDataTimestamp === null) {
          nextDataTimestamp = option.xAxis.data[viewRangeStartIndex];
        }
        // 描画範囲のstartの前の時刻から描画範囲の最古のデータの時刻までの経過時間
        var pasttimeFromOutOfStartToOldestRange = nextDataTimestamp - rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の時刻から描画範囲の先頭の時刻までの経過時間
        var pasttimeFromOutOfStartToRangeStart = option.xAxis.data[viewRangeStartIndex] - rangeDatasets.outOfViewRangeStart.timestamp;
        // 経過率
        var pasttimeRatio = pasttimeFromOutOfStartToOldestRange === 0 ? 1 : Number(pasttimeFromOutOfStartToRangeStart / pasttimeFromOutOfStartToOldestRange);

        // 描画範囲の前の値 - (描画範囲の前の値 - 描画範囲の先頭の値) * 経過率
        nextDataSeriesData[FLOW_SERIES_INDEX] = rangeDatasets.outOfViewRangeStart.seriesData[FLOW_SERIES_INDEX] - (rangeDatasets.outOfViewRangeStart.seriesData[FLOW_SERIES_INDEX] - nextDataSeriesData[FLOW_SERIES_INDEX]) * Number(pasttimeRatio);
        // 先頭にfromより前のデータを設定
        option.series[FLOW_SERIES_INDEX].data[viewRangeStartIndex] = {
          value: nextDataSeriesData[FLOW_SERIES_INDEX],
          symbolSize: 0
        };
      }
      // 描画範囲の末尾にプロットが描画されていない場合 かつ 描画範囲の後のデータがある場合
      if (option.series[FLOW_SERIES_INDEX].data[viewRangeEndIndex] === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
        // 描画範囲の後のデータの前のデータ:タイムスタンプ
        var prevDataTimestamp = rangeDatasets.latestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        // 描画範囲内の最新のデータがない場合かつ描画範囲のstartより前のデータがある場合は描画範囲のstartより前のデータのタイムスタンプを利用
        if (prevDataTimestamp === null && rangeDatasets.oldestViewRange.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        }
        if (prevDataTimestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeStart.seriesData));
        }
        // 描画範囲内の最新のデータがない場合、かつは描画範囲のstartより前のデータがない場合、描画範囲の末尾のタイムスタンプを利用
        if (prevDataTimestamp === null) {
          prevDataTimestamp = option.xAxis.data[viewRangeEndIndex];
        }
        // 描画範囲内の最新の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromLatestRangeToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - prevDataTimestamp;
        // 描画範囲の末尾の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromRangeEndToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - option.xAxis.data[viewRangeEndIndex];
        // 経過率
        var _pasttimeRatio = pasttimeFromLatestRangeToOutOfEnd === 0 ? 1 : Number(pasttimeFromRangeEndToOutOfEnd / pasttimeFromLatestRangeToOutOfEnd);
        // 描画範囲の末尾のデータの値
        // 描画範囲の後の値 - (描画範囲の後の値 - 描画範囲の末尾の値) * 経過率
        prevDataSeriesData[FLOW_SERIES_INDEX] = rangeDatasets.outOfViewRangeEnd.seriesData[FLOW_SERIES_INDEX] - (rangeDatasets.outOfViewRangeEnd.seriesData[FLOW_SERIES_INDEX] - prevDataSeriesData[FLOW_SERIES_INDEX]) * Number(_pasttimeRatio);
        // 末尾にfromより後のデータを設定
        option.series[FLOW_SERIES_INDEX].data[viewRangeEndIndex] = {
          value: prevDataSeriesData[FLOW_SERIES_INDEX],
          symbolSize: 0
        };
      }
      return option;
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(rangeDatasets) {
      if (rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.outOfViewRangeStart.timestamp);
      } else if (rangeDatasets.oldestViewRange.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.oldestViewRange.timestamp);
      }
    },

    // ウィンドウのリサイズイベントを取得する
    onResize: function onResize(event) {
      if (this.myChart) {
        // width or height を auto や % 指定している場合は必須
        this.myChart.resize();
      }
    },

    // 単位を変換
    convertUnit: function convertUnit(flow) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertUnit(flow, this.unit);
    },
    changeDatetime: function changeDatetime(toDatetimeUnixTime) {
      this.toDatetimeUnixTime = toDatetimeUnixTime;
    },

    // 指定した時刻にジャンプする
    jumpToDatetime: function jumpToDatetime(toDatetimeUnixTime) {
      // グラフ描画のレンジを設定しておく
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, toDatetimeUnixTime);
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },

    // 最新時刻にジャンプする
    jumpToRecent: function jumpToRecent(toDatetimeUnixTime) {
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].jumpToRecent(this, toDatetimeUnixTime);
    },

    // 描画範囲にデータがすべておさまっている場合は移動ボタンを無効化
    setDisableJump: function setDisableJump(range) {
      var isGetAllData = this.outOfFromTimestamp === null && this.outOfToTimestamp === null;
      var viewRangeStartIndex = this.xAxisDatas.indexOf(this.range.start);
      var viewRangeEndIndex = this.xAxisDatas.indexOf(this.range.end);

      if (isGetAllData && viewRangeStartIndex === 0 && viewRangeEndIndex === this.xAxisDatas.length - 1) {
        this.$refs.graphDateSelect.setDisableJump(true);
      } else {
        this.$refs.graphDateSelect.setDisableJump(false);
      }
    },

    // Echartsオプション初期化
    initializeChartOption: function initializeChartOption() {
      var self = this;
      var option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function formatter(params /* , ticket, callback */) {
            // callback形式を使うのは、params[0].valueが電圧から変換される関係上、小さい値まで表示されるから。
            var rangeLast = self.xAxisDatas[self.xAxisDatas.length - 1];
            // Flowの値がない(サーバ上のデータがない)場合、かつ現在時刻から計算した最新時刻でない場合はツールチップは表示しない
            var originalValue = self.seriesDatas[1].data[params[0].dataIndex];
            if (originalValue === null && Number(params[0].axisValue) !== rangeLast) {
              return '';
            }
            var flowValue = 0;
            var flowDiffValue = 0;
            if (params.length === 1) {
              // Flowしか設定されていない
              flowValue = params[0].value === undefined || params[0].value === null ? 0 : Number(params[0].value).toFixed(3);
              // params[1]がなく、params[0].seriesName だとFlowが来るので暫定的に即値で指定
              return 'FlowDiff' + ':' + flowDiffValue + '<br/>' + params[0].seriesName + ':' + flowValue;
            } else {
              // Flow、FlowDiffが設定されている
              flowDiffValue = params[0].value === undefined || params[0].value === null ? 0 : Number(params[0].value).toFixed(3);
              flowValue = params[1].value === undefined || params[1].value === null ? 0 : Number(params[1].value).toFixed(3);
              return params[0].seriesName + ':' + flowDiffValue + '<br/>' + params[1].seriesName + ':' + flowValue;
            }
          }
        },
        // HARPS-242 縦軸ズームをしたい
        // * -> 中止(UI上抑止し、Echarts4以降でライブラリが改善されていれば、対応)
        toolbox: {
          // show: true, // UI抑止解除の際はフラグをtrueにする
          show: false,
          top: '16%',
          right: '11%',
          borderRadius: 1,
          borderWidth: 1,
          feature: {
            dataZoom: {
              // show: true, // UI抑止解除の際はフラグをtrueにする
              show: false,
              title: {
                zoom: self.$t('chart.dataZoom-zoom'),
                back: self.$t('chart.dataZoom-back')
              },
              iconStyle: {
                emphasis: {
                  textPosition: 'bottom',
                  textAlign: 'right',
                  borderColor: '#009933'
                }
              }
            }
          }
        },
        legend: {
          data: self.properties.split(','),
          formatter: function formatter(name) {
            switch (name) {
              case 'Flow':
                return self.labelFlow;
              case 'FlowDiff':
                return self.labelFlowDiff;
              case 'FlowSum':
                return self.labelFlowSum;
            }
            return name;
          }
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          data: [],
          axisLabel: {
            formatter: function formatter(value, index) {
              // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
              // 描画時に文字列に変換する
              self.dateOptions = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period);
              self.dateOptions.timeZone = self.timezone;
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, value * 1000, self.dateOptions);
            }
          }
        },
        yAxis: [{
          type: 'value',
          name: '(' + self.unit + ')',
          axisLabel: {
            rotate: 60
          },
          splitLine: {
            show: false
          }
        }, {
          type: 'value',
          axisLabel: {
            rotate: 60
          },
          splitLine: {
            show: true
          }
        }],
        series: [],
        dataZoom: [{
          type: 'slider',
          realtime: false,
          // minValueSpan: 3,
          // maxValueSpan: 10,
          labelFormatter: function labelFormatter(value, valueStr) {
            // xAxis.axisLabel.formetter と基本的に同じでよいが、
            // valueStr に文字列で値が入ってくる点に注意
            var options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period, true);
            options.timezone = self.timezone;
            if (valueStr !== '') {
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, Number(valueStr) * 1000, options);
            }
          }
        }]
      };

      self.properties.split(',').forEach(function (property) {
        switch (property) {
          case 'FlowDiff':
            option.series.push({
              name: property,
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#83bff6' }, { offset: 0.5, color: '#188df0' }, { offset: 1, color: '#188df0' }])
                }
              },
              barWidth: '30%',
              yAxisIndex: 1,
              data: []
            });
            break;
          default:
            option.series.push({
              name: property,
              type: 'line',
              itemStyle: {
                normal: { color: '#387ada' }
              },
              data: [],
              connectNulls: true,
              symbolSize: 6,
              showAllSymbol: true
            });
        }
      });

      self.myChart.setOption(option);
    }
  },

  watch: {
    dataId: function dataId() {
      // デバイス変更時は最新表示
      this.$refs.graphDateSelect.jumpToRecent();
    },
    properties: function properties() {
      this.reload();
    },

    // グラフ描画レンジの時間単位を変更する
    period: function period() {
      // グラフ描画のレンジを設定しておく
      this.isChangeRangeBarWidth = false;
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, this.toDatetimeUnixTime);
      this.$refs.graphDateSelect.resetWaitingJump();
      this.isChangedPeriod = true;
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },
    timezone: function timezone() {
      this.reload();
    },
    currentTab: function currentTab() {
      console.log('slotNum:' + this.slotNum + 'currentTab:' + this.currentTab);
      if (this.slotNum === this.currentTab) {
        if (this.myChart) {
          console.log('resize:' + this.slotNum);
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize();
        }
      }
    },
    activeTab: function activeTab() {
      console.log('activeTab:' + this.activeTab);
      if (this.activeTab === this.serviceCodes[1]) {
        if (this.myChart) {
          console.log('resize:' + this.activeTab);
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize();
        }
      }
    },
    autoReload: function autoReload() {
      var _this2 = this;

      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(function () {
          _this2.jumpToRecent();
        }, 2000);
      } else {
        clearInterval(this.setIntervalId);
      }
    }
  },

  created: function created() {
    console.log('created');

    // 直近からグラフ描画のレンジを設定しておく
    var now = Math.floor(Date.now() / 1000);
    now = now - now % this.periodTime;
    this.range.start = now - this.periodTime * 12;
    this.range.end = now;

    this.prevRange = this.range;

    this.graph = new __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__["a" /* default */]({
      token: 'MyToken'
    });
  },
  mounted: function mounted() {
    console.log('mounted');

    var self = this;

    // ウィンドウのリサイズイベントのハンドラ登録
    window.addEventListener('resize', self.onResize);

    // Echartsインスタンス生成
    self.myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById(self.myChartId));
    // Echartsオプション初期化
    self.initializeChartOption();

    // datazoom イベントのハンドラを設定
    self.myChart.on('datazoom', function (event) {
      var axis = self.myChart.getModel().option.xAxis[0];
      // 現在描画されているレンジのインデックスを取得
      var start = axis.rangeStart === null || axis.rangeStart < 0 ? 0 : axis.rangeStart;
      var end = axis.rangeEnd === null || axis.rangeEnd >= axis.data.length ? axis.data.length - 1 : axis.rangeEnd;

      // 現在描画されているレンジの値を保存
      self.prevRange = self.range;
      // 現在描画されているレンジの値を設定
      self.range = {
        start: axis.data[start],
        end: axis.data[end]
      };
      if (self.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        self.isDataZoom = event.batch !== undefined;
        // 履歴の先頭に戻った場合はレンジをズームした時点に戻す
        if (event.batch !== undefined) {
          var ecToolBox = self.myChart.getModel()._componentsMap._ec_toolbox;
          var ecToolBoxModel = ecToolBox[0].ecModel;
          if (ecToolBoxModel['\0_ec_hist_store'].length === 2 && self.firstZoomRange === null) {
            self.firstZoomRange = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.prevRange));
          } else if (ecToolBoxModel['\0_ec_hist_store'].length === 1 && self.firstZoomRange !== null) {
            self.range = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.firstZoomRange));
            self.firstZoomRange = null;
          }
        }
      }

      // console.log([
      //   new Date(self.range.start * 1000),
      //   new Date(self.range.end * 1000)
      // ])
      // console.log([
      //   new Date(self.prevRange.start * 1000),
      //   new Date(self.prevRange.end * 1000)
      // ])
      self.isChangedRangeBar = true;
      // レンジバーの幅の変更があったかどうか
      self.isChangeRangeBarWidth = self.isChangeRangeBarWidth || self.range.end - self.range.start !== self.prevRange.end - self.prevRange.start;
      if (start === 0 && self.range.start !== self.prevRange.start) {
        // 先頭に達した場合はグラフのデータをロードする
        self.reload();
      } else if (start === 0 && self.range.start === self.prevRange.start && self.outOfFromTimestamp !== null) {
        // 先頭に達した場合はグラフのデータをロードする
        var rangeDiff = self.range.end - self.range.start;
        var rangeOffset = Math.floor(rangeDiff / 2);
        self.range = {
          start: self.range.start - rangeOffset,
          end: self.range.end - rangeOffset
        };
        self.reload();
      } else if (end === axis.data.length - 1 && self.range.end !== self.prevRange.end) {
        // 末尾に達した場合はグラフ外のデータをロードする
        self.reload();
      } else {
        // 先頭と末尾を
        var option = {
          xAxis: [],
          series: [],
          dataZoom: [{
            // API呼び出し前にセットしていたレンジを再設定
            startValue: self.range.start.toString(),
            endValue: self.range.end.toString()
          }]
        };
        option = self.fillPlotStartEnd(option);
        setTimeout(function () {
          self.myChart.setOption(option);
        }, 0);
        self.setDisableJump(self.range);
      }
    });

    // クリックイベントハンドラを設定
    // クリックした場合は日付選択フォームを更新する
    self.myChart.on('click', function (event) {
      // event.nameは選択した日時のUNIXタイムスタンプを示す
      self.toDatetimeUnixTime = Number(event.name);
      self.$refs.graphDateSelect.changeSelectDateTime(self.toDatetimeUnixTime);
    });

    // 初回データロード時は最新表示
    this.$refs.graphDateSelect.jumpToRecent();
  },
  beforeDestroy: function beforeDestroy() {
    // ウィンドウのリサイズイベントのハンドラ登録を解除
    window.removeEventListener('resize', this.onResize);
    // EChartsインスタンス破棄
    this.myChart = null;
  }
});

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import config from '@/config.js'


// import validate from '@/utils/validate.js'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    locale: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: ''
    },
    messageNoData: {
      type: String,
      default: ''
    },
    messagePeriodJump: {
      type: String,
      default: ''
    },
    earliestLogInfo: Object,
    showJumpMessagePeriodJumpProp: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDatepicker: false,
      toDatetimeUnixTime: null,
      prevToDatetimeUnixTime: null,
      toDateMax: null, // datepickerの最大
      toDate: null,
      toTime: null,
      toTimes: [],
      toDatetime: null,
      validated: true,
      waitingJump: false,
      recentLock: false,
      jumpButtonColor: 'inherit',
      disableJump: false,
      showJumpMessagePeriodJump: false
    };
  },

  watch: {
    toDate: {
      handler: function handler(newValue, oldValue) {
        this.changeDateTime();
      }
    },
    toTime: {
      handler: function handler(newValue, oldValue) {
        this.changeDateTime();
      }
    },
    toDatetimeUnixTime: {
      handler: function handler(newValue, oldValue) {
        this.waitingJump = !this.recentLock && oldValue !== null && newValue !== this.prevToDatetimeUnixTime;
        this.jumpButtonColor = this.waitingJump ? 'red' : 'inherit';
        this.recentLock = false;
      }
    },
    showJumpMessagePeriodJumpProp: {
      handler: function handler(newValue, oldValue) {
        this.showJumpMessagePeriodJump = newValue;
      }
    }
  },
  computed: {
    /**
     * 移動日フォーマット
     */
    formatToDate: {
      get: function get() {
        return this.toDate == null ? null : this.formatDateCommon(this.toDate, { year: 'numeric', month: 'numeric', day: 'numeric' });
      },
      set: function set(toDate) {
        this.toDate = toDate;
      }
    },
    toDateMin: {
      get: function get() {
        // console.log(utils.formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD'))
        return !this.earliestLogInfo.existsLogAllServices ? '' : __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD');
      },
      set: function set(toDateMin) {
        this.toDateMin = toDateMin;
      }
    }
  },
  beforeMount: function beforeMount() {
    // 時刻セレクトボックス生成
    var minutesArr = [0, 15, 30, 45];
    for (var hour = 0; hour < 24; hour++) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(minutesArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var minute = _step.value;

          var timeInnerStr = ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2);
          var timeStr = this.formatDateCommon(new Date(1970, 1, 1, hour, minute), { hour: 'numeric', minute: 'numeric' });
          this.toTimes.push({ text: timeStr, value: timeInnerStr });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  methods: {
    init: function init() {},
    changeSelectDateTime: function changeSelectDateTime(toDatetimeUnixTime) {
      this.toDatetimeUnixTime = Number(toDatetimeUnixTime);
      // console.log(this.toDatetimeUnixTime)
      // DatePickerの内部で保持している日付形式は-区切りなので一旦'-'に直す
      // utils.dateFormatterだとIE11で日付がY年m月d日となるため、momentを使う
      this.toDate = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(this.toDatetimeUnixTime, this.locale, this.timezone, 'YYYY-MM-DD');
      this.toDateMax = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(new Date().getTime(), this.locale, this.timezone, 'YYYY-MM-DD', true);
      this.toTime = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].formatDateForDatePickerAndTime(this.toDatetimeUnixTime, this.locale, this.timezone, 'HH:mm');
    },
    changeDateTime: function changeDateTime() {
      this.toDatetimeUnixTime = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].getDateTimeUnixTimestamp(this.toDate, this.toTime);
      this.$emit('changeDatetime', this.toDatetimeUnixTime);
    },
    jumpToDate: function jumpToDate() {
      this.waitingJump = false;
      this.jumpButtonColor = 'inherit';
      this.prevToDatetimeUnixTime = this.toDatetimeUnixTime;
      // ラジオボタン、セレクトボックスの値からUNIXタイムスタンプ取得
      // console.log(this.toDatetimeUnixTime)
      // 指定した日付にジャンプ
      this.$emit('jumpToDatetime', this.toDatetimeUnixTime);
    },
    jumpToRecent: function jumpToRecent() {
      this.waitingJump = false;
      this.recentLock = true;
      this.jumpButtonColor = 'inherit';
      // UNIXタイムスタンプ取得
      this.toDatetimeUnixTime = Math.floor(Date.now() / 1000);
      this.toDatetimeUnixTime = this.toDatetimeUnixTime - this.toDatetimeUnixTime % (15 * 60);
      this.prevToDatetimeUnixTime = this.toDatetimeUnixTime;
      this.changeSelectDateTime(this.toDatetimeUnixTime);
      this.$emit('jumpToRecent', this.toDatetimeUnixTime);
    },
    resetWaitingJump: function resetWaitingJump() {
      this.waitingJump = false;
      this.jumpButtonColor = 'inherit';
    },
    setDisableJump: function setDisableJump(disableJump) {
      this.disableJump = disableJump;
    },

    /**
     * 日付をフォーマットする
     */
    formatDateCommon: function formatDateCommon(date, dateOptions) {
      dateOptions.timezone = this.timezone;
      return __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].dateFormatter(this.locale, __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).unix() * 1000, dateOptions);
    },

    /**
     * カレンダーの週の開始曜日を設定する
     */
    firstDayOfWeek: function firstDayOfWeek() {
      return __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale);
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HelpDialog',
  data: function data() {
    return {
      showThresholdHelpDialog: false,
      unit: this.$store.getters.settingParams.unit,
      selectEditServiceId: 0,
      validationType: 0
    };
  },

  methods: {
    openHelpDialog: function openHelpDialog(params) {
      // 親フォームから呼び出される入り口
      this.setParam(params);
      this.showThresholdHelpDialog = true;
    },
    setParam: function setParam(params) {
      // 親からのパラメータ受け渡し
      this.selectEditServiceId = params.selectEditServiceId;
      this.validationType = params.validationType;
    }
  }
});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_statuscheck_js__ = __webpack_require__(225);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  components: {},
  data: function data() {
    return {
      user: this.$store.getters.user, // ログインユーザ
      // 時刻表示用
      timeZone: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.guess(),
      now: __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].dateFormatter(this.$store.getters.locale, Date.now(), {
        // Intl.DateTimeFormatの日本語表記バグ対応
        month: this.$store.getters.locale === 'ja-JP' || this.$store.getters.locale === 'ja' ? 'narrow' : 'long',
        day: 'numeric',
        weekday: 'short',
        timeZone: __WEBPACK_IMPORTED_MODULE_1_moment___default.a.tz.guess()
      }),

      needToReplace: [],
      notifications: [], // Notification用データ
      locationCount: 0,
      filtrationSystemCount: 0,
      toggle: {
        notification: true
      },
      calendarEvents: [],
      calendarConfig: {
        defaultView: 'month',
        eventRender: function eventRender(event, element) {},
        locale: this.$store.getters.locale,
        eventColor: '#FDD',
        eventTextColor: '#888',
        selectable: false,
        eventClick: function eventClick(event, element) {}
      },
      mailDate: '',
      language: 'en',
      information: ''
    };
  },

  methods: {
    init: function init() {
      this.getNeedtoReplace();
      this.getNotificationDate();
      this.getDomainConfig();
      this.getFiltrationSystemCount();
      this.getLocationCount();
    },
    getNotificationDate: function getNotificationDate() {
      this.mailDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()('2018-08-30').tz(this.timeZone).format('YYYY-MM-DD');
      var languageString = window.localStorage.getItem('language');
      if (languageString !== null) {
        this.language = JSON.parse(languageString).language;
      } else {
        if (this.$store.getters.locale === 'ja' || this.$store.getters.locale === 'ja-JP') {
          this.language = 'ja';
        } else {
          this.language = 'en';
        }
      }
    },
    getNeedtoReplace: function getNeedtoReplace() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/organizations/filtrationSystemList', { needReplace: true }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get needToReplace data failed. (' + data.result + ')');
          return;
        }
        _this.needToReplace = data.filtrationSystems;

        // console.log(this.needToReplace)
        if (_this.needToReplace.length > 0) {
          _this.setNextReplacementDateToCalendar();
          _this.generateNotifications();
        } else {
          // 交換必須なシステムがなくても値が残っているので空にする
          _this.needToReplace = [];
          _this.notifications = [];
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('need to replece API error', error);
      });
    },
    setNextReplacementDateToCalendar: function setNextReplacementDateToCalendar() {
      var _this2 = this;

      // カレンダーに日付をセットする
      this.needToReplace.forEach(function (fs) {
        fs.services.forEach(function (service) {
          if (service.serviceId === 1) {
            var time = service.filters[0].nextReplacementTime;
            var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).tz(_this2.timeZone).format('YYYY-MM-DD');
            var event = {
              title: fs.filtrationSystemName,
              start: date,
              allDay: true
            };
            _this2.calendarEvents.push(event);
          }
        });
      });
    },
    generateNotifications: function generateNotifications() {
      var _this3 = this;

      // Notification用のデータを作る
      var self = this;
      this.needToReplace.forEach(function (fs) {
        fs.services.forEach(function (service) {
          var statusByService = __WEBPACK_IMPORTED_MODULE_3__utils_statuscheck_js__["a" /* default */].getPluginStatusValue(service);
          if (statusByService === 0) {
            return;
          }
          var notificationSettings = __WEBPACK_IMPORTED_MODULE_3__utils_statuscheck_js__["a" /* default */].getNotificationSettings(statusByService);
          var type = notificationSettings.type;
          var message = self.$i18n.t(notificationSettings.messageKey);

          if (service.serviceId === 1) {
            if (type !== '') {
              _this3.notifications.push({
                type: type, // error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: self.$i18n.t('service.flow-and-time'),
                id: fs.filtrationSystemId
              });
            }
          }
          if (service.serviceId === 2) {
            if (type !== '') {
              _this3.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: self.$i18n.t('service.ro-membrane'),
                id: fs.filtrationSystemId
              });
            }
          }
          if (service.serviceId === 3) {
            if (type !== '') {
              _this3.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.temperature'),
                id: fs.filtrationSystemId
              });
            }
          }
          if (service.serviceId === 4) {
            if (type !== '') {
              _this3.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.leakage'),
                id: fs.filtrationSystemId
              });
            }
          }
          if (service.serviceId === 5) {
            if (type !== '') {
              _this3.notifications.push({
                type: type, // ''/error/warning
                title: fs.locationName + ' > ' + fs.filtrationSystemName,
                message: message,
                service: 'A' + service.portNumber + ' ' + self.$i18n.t('service.pressure'),
                id: fs.filtrationSystemId
              });
            }
          }
        });
      });
    },
    quickLink: function quickLink(link) {
      switch (link) {
        case 'customer':
          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'customer');
          this.$router.push('watersystem_list');
          break;
        case 'device':
          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'device');
          this.$router.push('watersystem_list');
          break;
        default:
          return;
      }
    },
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].getDomainConfig();
      this.information = this.$t('home.information', [domainConfig.translations.home.information]);
    },
    getFiltrationSystemCount: function getFiltrationSystemCount() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/getFiltrationSystemCount').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location data failed. (' + data.result + ')');
          return;
        }
        _this4.filtrationSystemCount = data.count;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getLocationCount: function getLocationCount() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/getLocationCount').then(function (response) {
        var data = response.data;

        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location data failed. (' + data.result + ')');
          return;
        }
        _this5.locationCount = data.count;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_graph_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeakageLog',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default: function _default() {
        return 'chart_' + __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* default */].generateUuid();
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'LeakageLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    details: {
      type: Array,
      default: {}
    },
    selectEditPort: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      // 親側で切り替えられると困るので、ここで保持しておく
      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],
      // サービスのコードリスト
      serviceCodes: this.$store.getters.serviceList.codes,
      leakageLog: []
    };
  },

  computed: {
    // API呼び出し時に渡す
    params: function params() {
      return {
        dataId: this.dataId,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to
      };
    }
  },
  methods: {
    // データ取得＆グラフ描画処理
    reload: function reload() {
      var _this = this;

      var self = this;
      var params = self.params;
      self.dateOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: self.timezone
        // API呼び出し
      };self.graph.leakageLog(params).then(function (data) {
        // しきい値取得
        var alertRate = 0;
        self.details.forEach(function (param) {
          if (param.portNumber === self.selectEditPort) {
            alertRate = param.alertRate;
          }
        });
        var firstDataFlag = false;
        var firstNomalFlag = false;
        var res = [];
        data.data.forEach(function (log) {
          if (alertRate > log.Rate && !firstNomalFlag) {
            res.unshift({
              state: 1,
              timestamp: __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* default */].dateFormatter(self.locale, log.Timestamp * 1000, self.dateOptions)
            });
            firstDataFlag = true;
            firstNomalFlag = true;
          } else if (firstDataFlag && alertRate < log.Rate && firstNomalFlag) {
            firstNomalFlag = false;
            res.unshift({
              state: 0,
              timestamp: __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* default */].dateFormatter(self.locale, log.Timestamp * 1000, self.dateOptions)
            });
          }
        });
        _this.emitEarliestTimestamp(data.data);
        _this.leakageLog = res;
      });
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action');
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(data) {
      if (data.length !== 0) {
        this.$emit('emit-earliest-timestamp', data[0].Timestamp);
      }
    },
    getClassName: function getClassName(state) {
      if (state === 1) {
        return 'leakage-alert';
      } else {
        return 'leakage-normal';
      }
    }
  },

  watch: {
    dataId: function dataId() {
      this.reload();
    },
    properties: function properties() {
      this.reload();
    },
    timezone: function timezone() {
      this.reload();
    },
    activeTab: function activeTab() {
      if (this.activeTab === this.serviceCodes[4]) {
        this.reload();
      }
    },
    autoReload: function autoReload() {
      var _this2 = this;

      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(function () {
          _this2.reload();
        }, 2000);
      } else {
        clearInterval(this.setIntervalId);
      }
    }
  },
  created: function created() {
    this.graph = new __WEBPACK_IMPORTED_MODULE_0__utils_graph_js__["a" /* default */]({
      token: 'MyToken'
    });
  },
  mounted: function mounted() {
    // 初回のデータロード
    this.reload();
  }
});

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapModal',
  props: ['edit'],
  data: function data() {
    return {
      mapName: 'modal-map',
      map: null,
      bounds: null,
      marker: null,
      geocoder: null,
      defaultLat: '51.4768467',
      defaultLng: '-0.0005284'
    };
  },

  methods: {
    init: function init() {
      this.initMap();
    },
    initMap: function initMap() {
      var initialPos = '';
      if (this.edit.latitude !== '' && this.edit.longitude !== '' && !isNaN(this.edit.latitude) && !isNaN(this.edit.longitude)) {
        initialPos = new google.maps.LatLng(this.edit.latitude, this.edit.longitude);
      } else {
        // 現在位置取得
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            // navigator.geolocation.getCurrentPosition(function (position) {
            var pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            self.map.setCenter(pos);
            self.marker.setPosition(pos);
            initialPos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          }, function () {
            self.handleLocationError(true);
          }, {
            timeout: 5000
          });
        }
        // デフォルトの位置情報
        initialPos = new google.maps.LatLng(this.defaultLat, this.defaultLng);
      }
      /* eslint-disable no-new */
      /* global google */
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        center: initialPos,
        zoom: 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      });

      var self = this;
      /* global $ */
      google.maps.event.addListener(this.map, 'click', function (event) {
        self.moveMarker(event.latLng);
      });

      this.marker = new google.maps.Marker({
        position: initialPos,
        map: this.map,
        draggable: true
      });
      this.geocoder = new google.maps.Geocoder();

      this.marker.setMap(this.map);
    },
    handleLocationError: function handleLocationError(browserHasGeolocation) {
      /* eslint-disable no-new */
      /* global PNotify */
      $(function () {
        new PNotify({
          title: 'Notice',
          text: browserHasGeolocation ? 'The Geolocation service failed.' : 'Your browser doesn\'t support geolocation.',
          type: 'success',
          styling: 'bootstrap3',
          buttons: {
            sticker: false
          }
        });
      });
    },
    moveMarker: function moveMarker(latLng) {
      this.marker.setPosition(latLng);
    },
    getAddress: function getAddress() {
      if (this.marker === null) {
        return;
      }

      var self = this;
      var position = this.marker.getPosition();

      this.edit.latitude = position.lat();
      this.edit.longitude = position.lng();

      // address を求める
      this.geocoder.geocode({ location: position }, function (results, status) {
        if (status === 'OK') {
          console.log('Geocoder: results:', results);
          if (results[0]) {
            self.edit.locationAddress = results[0].formatted_address;
          } else {
            console.warn('Geocoder: No results found');
          }
        } else {
          console.error('Geocoder: Failed :' + status);
        }
        self.$emit('selectLocation', self.edit);
      });
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      emailNotification: null,
      emailLanguage: '',
      mailTitle: '',
      items: []
    };
  },

  watch: {
    mail: function mail() {
      this.setTitle();
    }
  },
  methods: {
    init: function init() {
      console.log(this.$store.getters.settingParams);
      if (this.$store.getters.settingParams.emailNotification !== 'disable') {
        this.emailNotification = true;
      } else {
        this.emailNotification = false;
      }
      this.emailLanguage = this.$store.getters.settingParams.emailLanguage;
      if (this.emailLanguage === undefined) {
        this.emailLanguage = 'English';
      }
      this.setTitle();
      this.getDomainConfig();
      console.log(this.items);
    },
    setTitle: function setTitle() {
      this.mailTitle = this.emailNotification ? this.$t('notifications.enable') : this.$t('notifications.disable');
    },
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__["a" /* default */].getDomainConfig();
      for (var language in domainConfig.emailLanguage) {
        this.items.push(domainConfig.emailLanguage[language]);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  updated: function updated() {
    var setParam = this.emailNotification ? 'enable' : 'disable';
    var setLanguage = this.emailLanguage;
    if (setLanguage === '') {
      setLanguage = 'English';
    }
    if (setLanguage === '日本語') {
      setLanguage = 'Japanese';
    }
    console.log('lang', setLanguage);
    this.$store.dispatch('setSettingParam', {
      emailNotification: setParam,
      emailLanguage: setLanguage
    }).catch(function (err) {
      console.log(err);
    });
    this.setTitle();
  }
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      configLimitCreateHierarchy: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].organizationConfig.limitCreateHierarchy,
      edit: {
        organizationId: '',
        name: '',
        contact: '',
        description: '',
        phone: '',
        email: '',
        limitCreateHierarchy: 0,
        createNoLimit: false,
        customerCategoryId: 0
      },
      customerCategories: [],
      validated: false,
      errorMessage: '',
      showDialog: false,
      phoneRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].phoneFormat(v) || _this.$t('validate.phone-format');
      }, function (v) {
        return v.length <= 128 || _this.$t('validate.phone-length');
      }],
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('account.vali-email-format');
      }]
    };
  },

  methods: {
    init: function init() {
      this.getCustomerCategories();
    },
    getCustomerCategories: function getCustomerCategories() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/CustomerCategories/customerCategoryList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get customerCategories list failed. (' + data.result + ')');
          return;
        }
        _this2.customerCategories = __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].setNameCustomerCategories(_this2.$t, data.customerCategories);
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    startDialog: function startDialog(param) {
      // 一旦バリデーション等をリセット
      this.$refs.organizationEditForm.reset();
      // 値をバインド
      this.edit.organizationId = param.id;
      this.edit.name = param.name;
      this.edit.contact = param.contact;
      this.edit.description = param.description;
      this.edit.phone = param.phone;
      this.edit.email = param.email;
      this.edit.limitCreateHierarchy = parseInt(param.limit_create_hierarchy);
      this.edit.customerCategoryId = parseInt(param.customer_category_id);
      this.setCreateNoLimit();
      // エラーメッセージを初期化
      this.errorMessage = '';
      // ダイアログを表示
      this.showDialog = true;
    },
    closeDialog: function closeDialog(update) {
      // 更新のために発火
      if (update) {
        this.$emit('child-action');
      }
      this.showDialog = false;
    },
    updateOrganization: function updateOrganization() {
      var _this3 = this;

      this.errorMessage = '';
      var params = {
        organizationId: this.edit.organizationId,
        name: this.edit.name,
        contact: this.edit.contact,
        description: this.edit.description,
        phone: this.edit.phone,
        email: this.edit.email,
        limitCreateHierarchy: this.setLimitCreateHierarchy(),
        customerCategoryId: this.edit.customerCategoryId
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Organizations/updatePc', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('update organization data failed. (' + data.result + ')');
          return;
        }
        // 成功
        _this3.closeDialog(true);
      }).catch(function (error) {
        console.log('error', error);
        _this3.closeDialog();
      });
    },
    setLimitCreateHierarchy: function setLimitCreateHierarchy() {
      var limitCreateHierarchy = this.configLimitCreateHierarchy.min;
      if (this.edit.createNoLimit === true) {
        limitCreateHierarchy = this.configLimitCreateHierarchy.max;
      }
      return limitCreateHierarchy;
    },
    setCreateNoLimit: function setCreateNoLimit() {
      console.log(this.configLimitCreateHierarchy.max, this.edit.limitCreateHierarchy);
      if (this.configLimitCreateHierarchy.max === this.edit.limitCreateHierarchy) {
        this.edit.createNoLimit = true;
      }
    },
    showError: function showError(error) {
      this.errorMessage = 'failed. (' + error + ')';
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProfileImage_vue__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProfileImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ProfileImage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DeleteConfirmModal_vue__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DeleteConfirmModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DeleteConfirmModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_validate_js__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ProfileImage: __WEBPACK_IMPORTED_MODULE_4__components_ProfileImage_vue___default.a,
    DeleteConfirmModal: __WEBPACK_IMPORTED_MODULE_5__components_DeleteConfirmModal_vue___default.a
  },
  data: function data() {
    var _this = this;

    return {
      state: '', // change_email or confirm or change_password
      loader: null,
      loading: false,
      edit: {
        id: '',
        username: '',
        email: '',
        roleId: '',
        roleName: '',
        organization: '',
        organizationName: ''
      },
      password: {
        old: '',
        new: '',
        confirm: ''
      },
      oldpassRules: [function (v) {
        return !!v || _this.$t('profile.vali-blank-old-pass');
      }],
      emailRules: [function (v) {
        return __WEBPACK_IMPORTED_MODULE_6__utils_validate_js__["a" /* default */].emailFormat(v) || _this.$t('profile.vali-email-format');
      }],
      newpassRules: [function (v) {
        return v.length > 0 || _this.$t('profile.vali-blank-new-pass');
      }, function (v) {
        return _this.rules.checkNewPass(v) || _this.$t('profile.vali-format');
      }],
      newconfirmpassRules: [function (v) {
        return v.length > 0 || _this.$t('profile.vali-blank-confirm-new-pass');
      }, function (v) {
        return _this.rules.checkSamePass(v) || _this.$t('profile.vali-same-password');
      }],
      rules: {
        checkSamePass: function checkSamePass(v) {
          var n = document.getElementById('passwordNew').value;
          if (n === v) {
            return true;
          }
          return false;
        },
        checkNewPass: function checkNewPass(v) {
          var n = document.getElementById('passwordNew').value;
          if (n.match(/(?=.*[a-z])(?=.*[0-9])/) && n.length >= 8) {
            return true;
          } else {
            return false;
          }
        }
      },
      organizations: [],
      roles: [],
      deleteTarget: null,
      newEmail: '',
      emailVerified: true,
      confirminationCode: '',
      mailerror: '',
      passerror: '',
      message: '',
      domain: '',
      submitted: false, // submitフラグ
      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000
    };
  },

  computed: {
    // validator
    errors: function errors() {
      var self = this;
      return {
        newEmail: function newEmail() {
          if (self.newEmail.length === 0) {
            return true;
          }
          var emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!emailRE.test(self.newEmail)) {
            return true;
          }
        },
        confirminationCode: function confirminationCode() {
          if (self.confirminationCode.length === 0) {
            return true;
          }
        },
        oldPassword: function oldPassword() {
          if (self.password.old.length === 0) {
            return true;
          }
        },
        newPassword: function newPassword() {
          if (self.password.new.length === 0) {
            return true;
          }
          if (!self.password.new.match(/(?=.*[a-z])(?=.*[0-9])/)) {
            return true;
          }
          if (self.password.new.length < 8) {
            return true;
          }
          return false;
        },
        confirmNewPassword: function confirmNewPassword() {
          if (self.password.confirm !== self.password.new) {
            return true;
          }
        }
      };
    },
    hasError: function hasError() {
      var self = this;
      switch (self.state) {
        case 'change_email':
          return self.errors.newEmail();
        case 'confirm':
          return self.errors.confirminationCode();
        case 'change_password':
          return self.errors.oldPassword() || self.errors.newPassword() || self.errors.confirmNewPassword();
      }
      return false;
    }
  },
  methods: {
    init: function init() {
      this.getAccount();
      this.getDomainConfig();
    },
    getAccount: function getAccount() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/accounts/getDetail').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          // console.log('get account data failed(Profile). (' + data.result + ')')
          return;
        }
        self.edit.id = data.id;
        self.edit.organization = data.organizationId;
        self.edit.organizationName = data.organizationName;
        self.edit.username = data.username;
        self.edit.email = data.email;
        self.edit.roleId = data.roles[0]['id'];
        self.edit.roleName = data.roles[0]['name'];
        if (data.emailVerified === 2) {
          self.emailVerified = false;
          self.state = 'confirm';
        } else {
          self.emailVerified = true;
          self.state = '';
        }
        __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__["a" /* default */].getUserAttributes().then(function (user) {
          // console.log(user)
          self.edit.email = user.email;
        });
      }).catch(function () {
        // TODO エラー処理
        // console.log('error', error)
      });
    },
    openMailForm: function openMailForm() {
      this.state = 'change_email';
      this.newEmail = '';
      this.mailerror = '';
    },
    openVerifyForm: function openVerifyForm() {
      this.state = 'confirm';
      this.confirminationCode = '';
      this.mailerror = '';
    },
    changeEmail: function changeEmail() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__["a" /* default */].getUserAttributes().then(function (user) {
        // console.log(user)
        var params = {
          email: _this2.newEmail,
          username: user.preferred_username,
          domain: _this2.domain
        };
        __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/updateEmail', params).then(function (response) {
          _this2.state = 'confirm';
          _this2.emailVerified = false;
          _this2.getAccount();
        }).catch(function (error) {
          console.log(error);
          _this2.showMessage('error', _this2.$t('account.fail-email-update'));
        });
      });
    },
    resendConfirmationCode: function resendConfirmationCode() {
      var params = {
        mail: this.edit.email,
        domain: this.domain,
        kind: 'updateMailaddress'
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/getConfirmationCode', params).then(function (response) {});
    },
    confirmEmail: function confirmEmail() {
      var self = this;
      if (self.confirminationCode.length > 0) {
        var params = {
          kind: 'updateMailaddress',
          code: self.confirminationCode
        };
        __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/Accounts/checkConfirmationCode', params).then(function (response) {
          console.log(response.data.result);
          var data = response.data;
          switch (data.result) {
            case 0:
              alert(self.$t('profile.verified'));
              self.getAccount();
              self.state = '';
              self.newEmail = '';
              self.confirminationCode = '';
              self.mailerror = '';
              break;
            default:
              self.mailerror = self.$t('profile.vali-invalid-code');
          }
        });
      } else {
        self.mailerror = this.$t('profile.vali-empty-code');
      }
    },
    cancelEmail: function cancelEmail() {
      this.state = '';
      this.newEmail = '';
      this.confirminationCode = '';
      this.mailerror = '';
    },

    // 2019/06/11 使用箇所無しと判明
    updateAccountEmail: function updateAccountEmail(email) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service/dashboard/api/accounts/update_me', {
          email: email
        }).then(function (response) {
          var data = response.data;
          if (data.result !== 0) {
            reject({ message: 'Server error' });
          }
          resolve(data);
        }).catch(function () {
          // console.log(err)
          reject({ message: 'Server error' });
        });
      });
    },
    openPasswordForm: function openPasswordForm() {
      this.state = 'change_password';
      this.$refs.form.reset();
      this.password.old = '';
      this.password.new = '';
      this.password.confirm = '';
      this.passerror = '';
      this.submitted = false; // ボタン有効化
    },
    updatePassword: function updatePassword() {
      var _this3 = this;

      var self = this;
      this.submitted = true; // ボタン無効化
      this.passerror = '';
      if (this.password.old.length > 0 && this.password.new.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__["a" /* default */].changePassword(this.password.old, this.password.new).then(function () {
          alert(self.$t('profile.changed-password'));
          _this3.state = '';
          _this3.password.old = '';
          _this3.password.new = '';
          _this3.password.confirm = '';
          _this3.passerror = '';
        }).catch(function (err) {
          // TODO エラー処理
          console.log('error', err);
          switch (err.code) {
            case 'NotAuthorizedException':
              _this3.passerror = self.$t('profile.change-password-error');
              break;
            default:
              _this3.passerror = self.$t('profile.fail-error');
              break;
          }
        });
      }
    },
    cancelPassword: function cancelPassword() {
      this.state = '';
      this.password.old = '';
      this.password.new = '';
      this.password.confirm = '';
      this.passerror = '';
    },
    deleteAccount: function deleteAccount() {
      var _this4 = this;

      // console.log('delete:' + this.deleteTarget.id)
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service/dashboard/api/accounts/forget_me', { forget: 'me' }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          // console.log('delete account failed. (' + data.result + ')')
          _this4.showError(data.result);
          return;
        }
        alert('complete delete');
        _this4.$router.push('/login');
      }).catch(function (error) {
        // TODO エラー処理
        // console.log('error', error)
        _this4.showError(error);
      });
    },
    showError: function showError(error) {
      this.message = error;
    },
    clearMailerror: function clearMailerror() {
      this.mailerror = '';
    },
    clearPasserror: function clearPasserror() {
      this.passerror = '';
    },
    clearMessage: function clearMessage() {
      this.message = '';
    },
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].getDomainConfig();
      this.domain = domainConfig.domain;
    },
    showMessage: function showMessage(result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg;
          this.snackbarColor = 'red lighten-3';
          this.snackbarTimeout = 6000;
          this.showSnackbar = true;
          break;
        case 'success':
          this.snackbarMessage = msg;
          this.snackbarColor = 'teal lighten-2';
          this.snackbarTimeout = 3000;
          this.showSnackbar = true;
          break;
        default:
          return;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountImage',
  props: ['role'],
  methods: {
    accountImage: function accountImage(role) {
      switch (role) {
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root:
          return __webpack_require__(317);
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Administrator:
          return __webpack_require__(319);
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Manager:
          return __webpack_require__(318);
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Staff:
          return __webpack_require__(207);
        default:
          return __webpack_require__(207);
      }
    }
  }
});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GraphDateSelect: __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default.a
  },
  name: 'RoRateLogChart',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default: function _default() {
        return 'chart_' + __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].generateUuid();
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'RoRateLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    earliestLogInfo: Object
  },

  data: function data() {
    return {
      // グラフデータの１プロットの間隔
      period: '15m',
      //
      items: [{ value: '15m', text: this.$t('chart.15m') }, { value: '1h', text: this.$t('chart.1h') }, { value: '1d', text: this.$t('chart.1d') }, { value: '1w', text: this.$t('chart.1w') }, { value: '1M', text: this.$t('chart.1M') }],
      // 親側で切り替えられると困るので、ここで保持しておく
      myChartId: this.id,
      // ECharts のインスタンス
      myChart: null,
      // dataZoom で現在表示中のレンジ
      range: {
        start: null,
        end: null
      },
      // dataZoom で前回表示していたレンジ
      prevRange: {
        start: null,
        end: null
      },
      firstZoomRange: null, // 初回ズーム時のレンジ
      // 日付選択
      toDatetimeUnixTime: 0,
      messagePeriodJump: '',
      messageNoData: '',
      isChangedPeriod: false, // 時間間隔を変更した場合
      isChangedRangeBar: false, // レンジバーを変更した場合
      isChangeRangeBarWidth: false, // レンジバーの幅を変更している場合
      isDataZoom: false, // ズーム範囲選択した場合
      showPeriodMessagePeriodJump: false, // 時間間隔変更時メッセージ表示
      showJumpMessagePeriodJump: false, // 日時指定移動時メッセージ表示

      // グラフの表示データ
      xAxisDatas: [],
      seriesDatas: [],
      outOfFromTimestamp: null, // fromより古いデータのうち一番新しいデータ
      outOfFromSeriesData: [],
      outOfToTimestamp: null, // toより新しいデータのうち一番古いデータ
      outOfToSeriesData: [],

      // 現在の除去率表示ラベル
      lastRoRateLabel: this.$t('watersystem.last-impurities-removal-late'),

      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],

      // RO RATE用の瞬時値
      lastRoDataFixed: 0,

      serviceCodes: this.$store.getters.serviceList.codes
    };
  },


  computed: {
    // API呼び出し時に渡す
    params: function params() {
      return {
        dataId: this.dataId,
        period: this.period,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to,
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale)
      };
    },


    // 現在のグラフの描画範囲（レンジの差分, 秒）
    rangeDiff: function rangeDiff() {
      return this.range.end - this.range.start;
    },

    // APIのfromに指定する値
    from: function from() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end - offsetFromPeriods * this.periodTime;
    },

    // APIのtoに指定する値
    to: function to() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end + offsetFromPeriods * this.periodTime;
    },
    periodTime: function periodTime() {
      return {
        '15m': 60 * 15,
        '1h': 60 * 60,
        '1d': 60 * 60 * 24,
        '1w': 60 * 60 * 24 * 7,
        '1M': 60 * 60 * 24 * 30
      }[this.period];
    }
  },

  methods: {

    // データ取得＆グラフ描画処理
    reload: function reload() {
      var _this = this;

      var self = this;

      // ローディング状態にする（ボタン無効化）
      self.reloading = true;
      // グラフのローディングを表示
      self.myChart.showLoading();

      console.log({
        'from': new Date(self.from * 1000),
        'to': new Date(self.to * 1000)
      });

      var params = self.params;
      // console.log({params: params})
      // API呼び出し
      self.graph.roRateLog(params).then(function (data) {
        // Echartsオプション初期化
        self.initializeChartOption();
        self.messageNoData = '';

        // console.log('success')
        var option = data;

        // 初期化
        self.xAxisDatas = [];
        self.seriesDatas = [];
        self.outOfFromTimestamp = null;
        self.outOfFromSeriesData = [];
        self.outOfToTimestamp = null;
        self.outOfToSeriesData = [];

        // 線グラフ ////////////////////////////////////////////////////
        // レスポンスのデータをグラフにセット
        option.dataZoom = [{
          // API呼び出し前にセットしていたレンジを再設定
          startValue: self.range.start.toString(),
          endValue: self.range.end.toString()
        }];
        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        if (!option.xAxis.data.length) {
          // データがない場合は移動ボタンを無効化しメッセージ表示
          self.$refs.graphDateSelect.setDisableJump(true);
          self.messageNoData = self.$t('chart.message-no-data');
          return;
        }

        option.series.forEach(function (one) {
          one.data.forEach(function (element, index) {
            if (element !== null) {
              one.data[index] = element;
            }
          });
        });
        // APIの引数from,toの範囲外のデータの切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].omitOutOfRangeFromToData(self, option);

        // option.dataZoom[0]の切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].fixOptionDataZoomRange(self, option);

        // 日付選択範囲によるメッセージ
        __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].setMessagePeriodJump(self, {
          'start': Number(option.dataZoom[0].startValue),
          'end': Number(option.dataZoom[0].endValue)
        });
        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        // データが少ない場合は移動ボタンを無効化
        self.setDisableJump({
          start: Number(option.dataZoom[0].startValue),
          end: Number(option.dataZoom[0].endValue)
        });

        // 先頭と末尾のデータ補正
        option = _this.fillPlotStartEnd(option);
        // グラフデータを再設定
        self.myChart.setOption(option);

        // dataZoom.rangeMode をパーセンテージに変更する
        // startValue, endValue の設定「後」にこれを行わないと、
        // dataZoom の labelFormatter がうまく効いてくれない
        setTimeout(function () {
          self.myChart.setOption({ dataZoom: [{ rangeMode: ['percent', 'percent'] }] });
        }, 0);
      }).catch(function (error) {
        console.log(error);
        // alert(JSON.stringify(error, null, 2))
      }).then(function () {
        // finally
        // ローディング状態を解除（ボタン有効化）
        self.reloading = false;
        // グラフのローディングを非表示
        self.myChart.hideLoading();
        // 読み込み時にwidth100%にする
        self.myChart.resize();
      });
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action');
    },

    // 先頭と末尾のデータ補正
    fillPlotStartEnd: function fillPlotStartEnd(option) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      // 描画範囲内、描画範囲外のプロット位置の取得
      var fillPlotsRangeDatasets = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].retrieveFillPlotsRangeDatasets(this, option, RATE_SERIES_INDEX);

      option.xAxis.data = fillPlotsRangeDatasets.option.xAxis.data;
      option.series = fillPlotsRangeDatasets.option.series;
      var viewRangeStartIndex = fillPlotsRangeDatasets.viewRangeStartIndex;
      var viewRangeEndIndex = fillPlotsRangeDatasets.viewRangeEndIndex;

      var rangeDatasets = fillPlotsRangeDatasets.rangeDatasets;
      // データがない状態から、データが取得できた場合は最古のタイムスタンプを反映
      this.emitEarliestTimestamp(rangeDatasets);

      // 描画範囲の先頭にプロットが描画されていない場合 かつ 描画範囲の前のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        // 描画範囲の前のデータの次のデータ:タイムスタンプ
        var nextDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        // 描画範囲内の最古のデータがない場合かつ描画範囲のendより後のデータがある場合は描画範囲のendより後のデータのタイムスタンプを利用
        if (nextDataTimestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.latestViewRange.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        }
        if (nextDataTimestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.outOfViewRangeEnd.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeEnd.seriesData));
        }
        // 描画範囲内の最古のデータがない場合、かつは描画範囲のendより後のデータがない場合、描画範囲の先頭のタイムスタンプを利用
        if (nextDataTimestamp === null) {
          nextDataTimestamp = option.xAxis.data[viewRangeStartIndex];
        }
        // 描画範囲のstartの前の時刻から描画範囲の最古のデータの時刻までの経過時間
        var pasttimeFromOutOfStartToOldestRange = nextDataTimestamp - rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の時刻から描画範囲の先頭の時刻までの経過時間
        var pasttimeFromOutOfStartToRangeStart = option.xAxis.data[viewRangeStartIndex] - rangeDatasets.outOfViewRangeStart.timestamp;
        // 経過率
        var pasttimeRatio = pasttimeFromOutOfStartToOldestRange === 0 ? 1 : Number(pasttimeFromOutOfStartToRangeStart / pasttimeFromOutOfStartToOldestRange);

        // 描画範囲の前の値 - (描画範囲の前の値 - 描画範囲の先頭の値) * 経過率
        nextDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - nextDataSeriesData[RATE_SERIES_INDEX]) * Number(pasttimeRatio);
        // 先頭にfromより前のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] = {
          value: nextDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      // 描画範囲の末尾にプロットが描画されていない場合 かつ 描画範囲の後のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
        // 描画範囲の後のデータの前のデータ:タイムスタンプ
        var prevDataTimestamp = rangeDatasets.latestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        // 描画範囲内の最新のデータがない場合かつ描画範囲のstartより前のデータがある場合は描画範囲のstartより前のデータのタイムスタンプを利用
        if (prevDataTimestamp === null && rangeDatasets.oldestViewRange.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        }
        if (prevDataTimestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeStart.seriesData));
        }
        // 描画範囲内の最新のデータがない場合、かつは描画範囲のstartより前のデータがない場合、描画範囲の末尾のタイムスタンプを利用
        if (prevDataTimestamp === null) {
          prevDataTimestamp = option.xAxis.data[viewRangeEndIndex];
        }
        // 描画範囲内の最新の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromLatestRangeToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - prevDataTimestamp;
        // 描画範囲の末尾の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromRangeEndToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - option.xAxis.data[viewRangeEndIndex];
        // 経過率
        var _pasttimeRatio = pasttimeFromLatestRangeToOutOfEnd === 0 ? 1 : Number(pasttimeFromRangeEndToOutOfEnd / pasttimeFromLatestRangeToOutOfEnd);
        // 描画範囲の末尾のデータの値
        // 描画範囲の後の値 - (描画範囲の後の値 - 描画範囲の末尾の値) * 経過率
        prevDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - prevDataSeriesData[RATE_SERIES_INDEX]) * Number(_pasttimeRatio);
        // 末尾にfromより後のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] = {
          value: prevDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      this.fillLastData(rangeDatasets);
      return option;
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(rangeDatasets) {
      if (rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.outOfViewRangeStart.timestamp);
      } else if (rangeDatasets.oldestViewRange.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.oldestViewRange.timestamp);
      }
    },

    // 描画範囲の最後の値の設定
    fillLastData: function fillLastData(rangeDatasets) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      var lastRoData = null;
      var lastTimestamp = rangeDatasets.latestViewRange.timestamp;
      var isExistsOutOfViewRange = false;
      // 描画範囲のendの後の値がある
      if (this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp) !== -1 && this.seriesDatas[RATE_SERIES_INDEX].data[this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp)] !== null) {
        isExistsOutOfViewRange = true;
      }
      // 描画範囲の最新の値がある
      if (lastTimestamp !== null) {
        lastRoData = rangeDatasets.latestViewRange.seriesData[RATE_SERIES_INDEX];
      }
      if (lastRoData === null) {
        lastTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の最古の値がある
        if (lastTimestamp !== null) {
          lastRoData = rangeDatasets.oldestViewRange.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastRoData === null) {
        lastTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の値がある
        if (lastTimestamp !== null) {
          lastRoData = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastRoData === null) {
        // データが設定されていない
        this.lastRoDataFixed = 0;
        this.lastRoRateLabel = this.$t('watersystem.last-impurities-removal-late');
      } else {
        // データが設定されている
        this.lastRoDataFixed = Number(lastRoData).toFixed(2);
        if (rangeDatasets.outOfViewRangeEnd.timestamp !== null && isExistsOutOfViewRange) {
          // 描画範囲のendの後の値がある
          this.lastRoRateLabel = this.$t('watersystem.past-impurities-removal-late', [this.formatLastUpdateDate(lastTimestamp * 1000)]);
        } else {
          // 描画範囲のendの後の値がない
          this.lastRoRateLabel = this.$t('watersystem.last-impurities-removal-late') + ' (' + this.$t('watersystem.last-update-for-chart') + ':' + this.formatLastUpdateDate(lastTimestamp * 1000) + ')';
        }
      }
    },
    formatLastUpdateDate: function formatLastUpdateDate(unixTimestamp) {
      var options = {};
      options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(this.period);
      options.timeZone = this.timezone;
      this.locale = this.$store.getters.locale;

      return this.period === '1w' ? this.$t('watersystem.last-update-week-suffix-for-chart', [__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options)]) : __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options);
    },

    // ウィンドウのリサイズイベントを取得する
    onResize: function onResize(event) {
      if (this.myChart) {
        // width or height を auto や % 指定している場合は必須
        this.myChart.resize();
      }
    },
    changeDatetime: function changeDatetime(toDatetimeUnixTime) {
      this.toDatetimeUnixTime = toDatetimeUnixTime;
    },

    // 指定した時刻にジャンプする
    jumpToDatetime: function jumpToDatetime(toDatetimeUnixTime) {
      // グラフ描画のレンジを設定しておく
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, toDatetimeUnixTime);
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },

    // 最新時刻にジャンプする
    jumpToRecent: function jumpToRecent(toDatetimeUnixTime) {
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].jumpToRecent(this, toDatetimeUnixTime);
    },

    // プロット範囲が13プロット(時刻範囲が12 * 時間間隔)より小さい場合は移動ボタンを無効化
    setDisableJump: function setDisableJump(range) {
      var isGetAllData = this.outOfFromTimestamp === null && this.outOfToTimestamp === null;
      var viewRangeStartIndex = this.xAxisDatas.indexOf(this.range.start);
      var viewRangeEndIndex = this.xAxisDatas.indexOf(this.range.end);

      if (isGetAllData && viewRangeStartIndex === 0 && viewRangeEndIndex === this.xAxisDatas.length - 1) {
        this.$refs.graphDateSelect.setDisableJump(true);
      } else {
        this.$refs.graphDateSelect.setDisableJump(false);
      }
    },

    // Echartsオプション初期化
    initializeChartOption: function initializeChartOption() {
      var self = this;

      // Echarts初期設定
      var option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function formatter(params /* , ticket, callback */) {
            // callback形式を使うのは、params[0].valueが電圧から変換される関係上、小さい値まで表示されるから。
            // Rateの値がない(サーバ上のデータがない)場合、かつ現在時刻から計算した最新時刻でない場合はツールチップは表示しない
            var rangeLast = self.xAxisDatas[self.xAxisDatas.length - 1];
            var originalValue = self.seriesDatas[0].data[params[0].dataIndex];
            if (originalValue === null && Number(params[0].axisValue) !== rangeLast) {
              return '';
            }
            return params[0].seriesName + ':' + Number(params[0].value).toFixed(2);
          }
        },
        // HARPS-242 縦軸ズームをしたい
        // * -> 中止(UI上抑止し、Echarts4以降でライブラリが改善されていれば、対応)
        toolbox: {
          // show: true, // UI抑止解除の際はフラグをtrueにする
          show: false,
          top: '16%',
          right: '11%',
          borderRadius: 1,
          borderWidth: 1,
          feature: {
            dataZoom: {
              // show: true, // UI抑止解除の際はフラグをtrueにする
              show: false,
              title: {
                zoom: self.$t('chart.dataZoom-zoom'),
                back: self.$t('chart.dataZoom-back')
              },
              iconStyle: {
                emphasis: {
                  textPosition: 'bottom',
                  textAlign: 'right',
                  borderColor: '#009933'
                }
              }
            }
          }
        },
        legend: {
          data: ['RoRateLog']
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          data: [],
          axisLabel: {
            formatter: function formatter(value, index) {
              // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
              // 描画時に文字列に変換する
              self.dateOptions = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period);
              self.dateOptions.timeZone = self.timezone;
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, value * 1000, self.dateOptions);
              // return moment.unix(value).format('HH:mm');
            }
          }
        },
        yAxis: {
          name: 'rate(%)'
        },
        series: [],
        dataZoom: [{
          type: 'slider',
          realtime: false,
          // minValueSpan: 3,
          // maxValueSpan: 10,
          labelFormatter: function labelFormatter(value, valueStr) {
            // xAxis.axisLabel.formetter と基本的に同じでよいが、
            // valueStr に文字列で値が入ってくる点に注意
            var options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period, true);
            options.timezone = self.timezone;
            if (valueStr !== '') {
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, Number(valueStr) * 1000, options);
            }
          }
        }]
      };

      self.properties.split(',').forEach(function (property) {
        switch (property) {
          default:
            option.series.push({
              name: property,
              type: 'line',
              itemStyle: {
                normal: { color: '#008800' }
              },
              data: [],
              connectNulls: true,
              symbolSize: 6,
              showAllSymbol: true
            });
        }
      });

      self.myChart.setOption(option);
    }
  },

  watch: {
    dataId: function dataId() {
      // デバイス変更時は最新表示
      this.$refs.graphDateSelect.jumpToRecent();
    },
    properties: function properties() {
      this.reload();
    },

    // グラフ描画レンジの時間単位を変更する
    period: function period() {
      // グラフ描画のレンジを設定しておく
      this.isChangeRangeBarWidth = false;
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, this.toDatetimeUnixTime);
      this.$refs.graphDateSelect.resetWaitingJump();
      this.isChangedPeriod = true;
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },
    timezone: function timezone() {
      this.reload();
    },
    activeTab: function activeTab() {
      // console.log('activeTab:' + this.activeTab)
      if (this.activeTab === this.serviceCodes[2]) {
        if (this.myChart) {
          // console.log('resize:' + this.activeTab)
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize();
        }
      }
    },
    autoReload: function autoReload() {
      var _this2 = this;

      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(function () {
          _this2.jumpToRecent();
        }, 2000);
      } else {
        clearInterval(this.setIntervalId);
      }
    }
  },

  created: function created() {
    // console.log('created')

    // 直近からグラフ描画のレンジを設定しておく
    var now = Math.floor(Date.now() / 1000);
    now = now - now % this.periodTime;
    this.range.start = now - this.periodTime * 12;
    this.range.end = now;

    this.prevRange = this.range;

    this.graph = new __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__["a" /* default */]({
      token: 'MyToken'
    });
  },
  mounted: function mounted() {
    // console.log('mounted')

    var self = this;

    // ウィンドウのリサイズイベントのハンドラ登録
    window.addEventListener('resize', self.onResize);

    // Echartsインスタンス生成
    self.myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById(self.myChartId));
    // Echartsオプション初期化
    self.initializeChartOption();

    // datazoom イベントのハンドラを設定
    self.myChart.on('datazoom', function (event) {
      var axis = self.myChart.getModel().option.xAxis[0];
      // 現在描画されているレンジのインデックスを取得
      var start = axis.rangeStart === null || axis.rangeStart < 0 ? 0 : axis.rangeStart;
      var end = axis.rangeEnd === null || axis.rangeEnd >= axis.data.length ? axis.data.length - 1 : axis.rangeEnd;

      // 現在描画されているレンジの値を保存
      self.prevRange = self.range;
      // 現在描画されているレンジの値を設定
      self.range = {
        start: axis.data[start],
        end: axis.data[end]
      };
      if (self.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        self.isDataZoom = event.batch !== undefined;
        // 履歴の先頭に戻った場合はレンジをズームした時点に戻す
        if (event.batch !== undefined) {
          var ecToolBox = self.myChart.getModel()._componentsMap._ec_toolbox;
          var ecToolBoxModel = ecToolBox[0].ecModel;
          if (ecToolBoxModel['\0_ec_hist_store'].length === 2 && self.firstZoomRange === null) {
            self.firstZoomRange = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.prevRange));
          } else if (ecToolBoxModel['\0_ec_hist_store'].length === 1 && self.firstZoomRange !== null) {
            self.range = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.firstZoomRange));
            self.firstZoomRange = null;
          }
        }
      }

      // console.log([
      //   new Date(self.range.start * 1000),
      //   new Date(self.range.end * 1000)
      // ])
      // console.log([
      //   new Date(self.prevRange.start * 1000),
      //   new Date(self.prevRange.end * 1000)
      // ])

      self.isChangedRangeBar = true;
      // レンジバーの幅の変更があったかどうか
      self.isChangeRangeBarWidth = self.isChangeRangeBarWidth || self.range.end - self.range.start !== self.prevRange.end - self.prevRange.start;
      if (start === 0 && self.range.start !== self.prevRange.start) {
        // 先頭に達した場合はグラフのデータをロードする
        self.reload();
      } else if (start === 0 && self.range.start === self.prevRange.start && self.outOfFromTimestamp !== null) {
        // 先頭に達した場合はグラフのデータをロードする
        var rangeOffset = Math.floor(self.rangeDiff / 2);
        self.range = {
          start: self.range.start - rangeOffset,
          end: self.range.end - rangeOffset
        };
        self.reload();
      } else if (end === axis.data.length - 1 && self.range.end !== self.prevRange.end) {
        // 末尾に達した場合はグラフ外のデータをロードする
        self.reload();
      } else {
        // 先頭と末尾を再描画
        var option = {
          xAxis: [],
          series: [],
          dataZoom: [{
            // API呼び出し前にセットしていたレンジを再設定
            startValue: self.range.start.toString(),
            endValue: self.range.end.toString()
          }]
        };
        option = self.fillPlotStartEnd(option);
        setTimeout(function () {
          self.myChart.setOption(option);
        }, 0);
        self.setDisableJump(self.range);
      }
    });

    // クリックイベントハンドラを設定
    // クリックした場合は日付選択フォームを更新する
    self.myChart.on('click', function (event) {
      // event.nameは選択した日時のUNIXタイムスタンプを示す
      self.toDatetimeUnixTime = Number(event.name);
      self.$refs.graphDateSelect.changeSelectDateTime(self.toDatetimeUnixTime);
    });

    // 初回データロード時は最新表示
    this.$refs.graphDateSelect.jumpToRecent();
  },
  beforeDestroy: function beforeDestroy() {
    // ウィンドウのリサイズイベントのハンドラ登録を解除
    window.removeEventListener('resize', this.onResize);
    // EChartsインスタンス破棄
    this.myChart = null;
  }
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RoleLabel',
  props: ['role'],
  methods: {
    roleLabel: function roleLabel(role) {
      switch (role) {
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root:
          return 'bg-red';
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Administrator:
          return 'bg-purple';
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Manager:
          return 'bg-pink';
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Staff:
          return 'bg-blue';
        case __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer:
        default:
          return 'bg-blue';
      }
    }
  }
});

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HelpDialog_vue__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HelpDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_HelpDialog_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HelpDialog: __WEBPACK_IMPORTED_MODULE_5__components_HelpDialog_vue___default.a
  },
  name: 'ServiceSettinDialog',
  data: function data() {
    var _this = this;

    return {
      selectEditServiceId: 0,
      selectEditPort: 0,
      locationName: '',
      filtrationSystemId: null,
      filtrationSystemName: '',
      editData: [],
      selectTempretureItem: '',
      items: [{ label: this.$t('watersystem.temperature-increase'), value: '1' }, { label: this.$t('watersystem.temperature-decrease'), value: '2' }],
      showSettingDialog: false,
      unit: this.$store.getters.settingParams.unit,
      pressureUnit: this.$store.getters.settingParams.pressureUnit,
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      temperatureUnitMin: this.$store.getters.settingParams.temperatureUnit + ' ' + this.$t('watersystem.temperature-min'),
      temperatureUnitMax: this.$store.getters.settingParams.temperatureUnit + ' ' + this.$t('watersystem.temperature-max'),
      presetRadio: '0',
      flowEditData: {
        maxFlowLifeSpan: '',
        warningFlowLifeSpan: '',
        maxUptimeLifeSpan: '',
        warningUptimeLifeSpan: '',
        pluginInfoId: ''
      },
      roEditData: {
        alertRate: '',
        warningRate: ''
      },
      temperatureEditData: {
        portNumber: '',
        validationType: '',
        alertRate: {
          min: '',
          max: ''
        },
        warningRate: {
          min: '',
          max: ''
        }
      },
      pressEditData: {
        portNumber: '',
        alertRate: '',
        warningRate: '',
        isDifferentialPressure: false
      },
      flowsensors: [],
      settingDialogValid: false,
      isRoot: false, // ルートユーザかどうか
      execBtnName: this.$t('btn.save'),
      lifespanFrowRateWarningRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['max'] + _this.unit]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['min'] + _this.unit]);
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(parseFloat(v)) || _this.$t('watersystem.vali-threshold-integer');
      }, function (v) {
        return _this.thresholdCorrelationValidationCase2(_this.flowEditData.maxFlowLifeSpan, _this.flowEditData.warningFlowLifeSpan) || _this.$t('watersystem.vali-threshold-alert-less-than');
      }],
      lifespanFrowRateAlertRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['max'] + _this.unit]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['flow']['range']['min'] + _this.unit]);
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(parseFloat(v)) || _this.$t('watersystem.vali-threshold-integer');
      }, function (v) {
        return _this.thresholdCorrelationValidationCase2(_this.flowEditData.maxFlowLifeSpan, _this.flowEditData.warningFlowLifeSpan) || _this.$t('watersystem.vali-threshold-greater-than-warning');
      }],
      lifespanMonthWarningRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['max'] + _this.$t('watersystem.period-month')]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['min'] + _this.$t('watersystem.period-month')]);
      }, function (v) {
        return _this.thresholdCorrelationValidationCase2(_this.flowEditData.maxUptimeLifeSpan, _this.flowEditData.warningUptimeLifeSpan) || _this.$t('watersystem.vali-threshold-alert-less-than');
      }],
      lifespanMonthAlertRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['max'] + _this.$t('watersystem.period-month')]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[1]['time']['range']['min'] + _this.$t('watersystem.period-month')]);
      }, function (v) {
        return _this.thresholdCorrelationValidationCase2(_this.flowEditData.maxUptimeLifeSpan, _this.flowEditData.warningUptimeLifeSpan) || _this.$t('watersystem.vali-threshold-greater-than-warning');
      }],
      roRateWarningRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['max'] + '%']);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['min'] + '%']);
      }, function (v) {
        return _this.thresholdCorrelationValidationCase1(_this.roEditData.alertRate, _this.roEditData.warningRate) || _this.$t('watersystem.vali-threshold-greater-than-alert');
      }],
      roRateAlertRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['max'] + '%']);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[2]['ro']['range']['min'] + '%']);
      }, function (v) {
        return _this.thresholdCorrelationValidationCase1(_this.roEditData.alertRate, _this.roEditData.warningRate) || _this.$t('watersystem.vali-threshold-warning-less-than');
      }],
      pressureWarningRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['max'] + _this.pressureUnit]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['min'] + _this.pressureUnit]);
      }, function (v) {
        return _this.thresholdCorrelationValidationPress(_this.pressEditData.alertRate, _this.pressEditData.warningRate) || _this.thresholdCorrelationValidationPressMessage(_this.pressEditData.alertRate, _this.pressEditData.warningRate, 1);
      }],
      pressureAlertRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return !isNaN(v) || _this.$t('watersystem.vali-threshold-num');
      }, function (v) {
        return v <= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['max'] || _this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['max'] + _this.pressureUnit]);
      }, function (v) {
        return v >= __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['min'] || _this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].serviceConfig[5]['pressure']['range']['min'] + _this.pressureUnit]);
      }, function (v) {
        return _this.thresholdCorrelationValidationPress(_this.pressEditData.alertRate, _this.pressEditData.warningRate) || _this.thresholdCorrelationValidationPressMessage(_this.pressEditData.alertRate, _this.pressEditData.warningRate, 2);
      }],
      tempretureAlertRules: [function (v) {
        return _this.thresholdValidationTempreture(v, 'alert');
      }],
      tempretureWarningRules: [function (v) {
        return _this.thresholdValidationTempreture(v, 'warning');
      }],
      tempretureSelectRules: [function (v) {
        return v.length !== 0 || _this.$t('watersystem.vali-threshold-must');
      }, function (v) {
        return v !== 0 || _this.$t('watersystem.vali-threshold-must');
      }]
    };
  },

  methods: {
    openHelpDialog: function openHelpDialog() {
      var params = this.createHelpDialogParams();
      this.$refs.childHelpDialog.openHelpDialog(params);
    },

    // 子フォームで使用するパラメータを作成
    createHelpDialogParams: function createHelpDialogParams() {
      return {
        selectEditServiceId: this.selectEditServiceId,
        validationType: this.getCurrentServiceValidationType()
      };
    },
    getCurrentServiceValidationType: function getCurrentServiceValidationType() {
      // validationTypeを使用するサービスのみ参照して値を返すそれ以外は0
      var result = 0;
      if (this.selectEditServiceId === 5) {
        if (this.pressEditData.isDifferentialPressure) {
          result = 1;
        }
      }
      return result;
    },
    settingFormValidate: function settingFormValidate() {
      // 全体のバリデーションを行う
      this.$refs.settingForm.validate();
    },
    settingFormValidateReset: function settingFormValidateReset() {
      // バリデーションのリセットを行う
      this.$refs.settingForm.reset();
    },
    updateConfig: function updateConfig() {
      var _this2 = this;

      // 全体のバリデーションを行う
      if (!this.$refs.settingForm.validate()) {
        // NG
        return;
      }
      // 入力値を反映する
      this.updateEditData();
      var params = {
        'filtrationSystemId': this.filtrationSystemId,
        'filtrationSystemName': this.filtrationSystemName,
        'plugins': this.editData.plugins,
        'services': this.editData.services
      };
      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystems/updateConfig', params).then(function (response) {
        var data = response.data;
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Config Avarage failed. (' + data.result + ')');
          // フォームを閉じる
          _this2.closeSettingDialog(false);
          return;
        } else if (data.status === 304) {
          console.log('Config Avarage doesn\'t need update. (' + data.status + ')');
          // フォームを閉じる
          _this2.closeSettingDialog(false);
          return;
        }
        // フォームを閉じる（成功）
        _this2.closeSettingDialog(true);
        return;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('Config update error', error);
        // フォームを閉じる
        _this2.closeSettingDialog(false);
      });
    },
    openSettingDialog: function openSettingDialog(params) {
      // 親フォームから呼び出される入り口
      this.setParam(params);
      this.settingFormValidateReset();
      this.setSettingDialogEditData();
      this.showSettingDialog = true;
    },
    setParam: function setParam(params) {
      // 親からのパラメータ受け渡し
      this.selectEditServiceId = params.selectEditServiceId;
      this.selectEditPort = params.selectEditPort;
      this.locationName = params.locationName;
      this.filtrationSystemName = params.filtrationSystemName;
      this.filtrationSystemId = params.filtrationSystemId;
      this.editData = params.editData;
    },
    closeSettingDialog: function closeSettingDialog(filterUpdate) {
      // フィルタを更新
      this.showSettingDialog = false;
      if (filterUpdate === true) {
        // 閾値の変更に伴いロケーション、デバイスのステータスも変化するので全て読み直す
        location.reload();
      }
    },
    getPlugins: function getPlugins(pluginId) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Plugins/pluginList/' + pluginId).then(function (response) {
          var data = response.data;
          if (data.result !== 0) {
            console.log('pluginId=' + pluginId + ' list get failed. (' + data.result + ')');
            resolve([]);
          }
          resolve(data.plugins);
        }).catch(function (error) {
          // TODO エラー処理
          console.log('error', error);
          resolve([]);
        });
      });
    },
    getFlowsensors: function getFlowsensors() {
      var _this3 = this;

      this.getPlugins(1).then(function (value) {
        _this3.flowsensors = value;
      });
    },
    convertUnit: function convertUnit(flow) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertUnit(flow, this.unit);
    },
    reverseUnit: function reverseUnit(flow) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseUnit(flow, this.unit);
    },
    convertSecondToMonth: function convertSecondToMonth(second) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertSecondToMonth(second);
    },
    reverseSecondToMonth: function reverseSecondToMonth(second) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseSecondToMonth(second);
    },
    convertPressureUnit: function convertPressureUnit(pressure) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertPressureUnit(pressure, this.pressureUnit);
    },
    reversePressureUnit: function reversePressureUnit(pressure) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reversePressureUnit(pressure, this.pressureUnit);
    },
    convertMaxLifeSpanFlow: function convertMaxLifeSpanFlow(maxLifeSpanFlow) {
      var max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000;
      var maxNumFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(max, this.locale);
      return maxNumFormated;
    },
    reverseMaxLifeSpanFlow: function reverseMaxLifeSpanFlow(maxLifeSpanFlow) {
      var max = Math.round(this.reverseUnit(maxLifeSpanFlow * 1000)) / 1000;
      var maxNumFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(max, this.locale);
      return maxNumFormated;
    },
    setSettingDialogEditData: function setSettingDialogEditData() {
      // 編集中のデータを初期化
      this.initEditData();
      for (var i = 0; i < this.editData.services.length; i++) {
        if (this.editData.services[i].serviceId === this.selectEditServiceId) {
          if (this.selectEditServiceId === 1) {
            this.setEditDataFrow(this.editData.services[i]);
            return;
          } else if (this.selectEditServiceId === 2) {
            this.setEditDataRo(this.editData.services[i]);
            return;
          } else if (this.selectEditServiceId === 3 && this.editData.services[i].portNumber === this.selectEditPort) {
            this.setEditDataTempreture(this.editData.services[i], this.editData.plugins[i]);
            return;
          } else if (this.selectEditServiceId === 5 && this.editData.services[i].portNumber === this.selectEditPort) {
            this.setEditDataPress(this.editData.services[i]);
            return;
          }
        }
      }
    },
    setEditDataFrow: function setEditDataFrow(service) {
      this.flowEditData.maxFlowLifeSpan = Math.round(this.convertUnit(service.params.filters[0].maxFlowLifeSpan));
      this.flowEditData.warningFlowLifeSpan = Math.round(this.convertUnit(service.params.filters[0].warningFlowLifeSpan));
      this.flowEditData.maxUptimeLifeSpan = this.convertSecondToMonth(service.params.filters[0].maxUptimeLifeSpan);
      this.flowEditData.warningUptimeLifeSpan = this.convertSecondToMonth(service.params.filters[0].warningUptimeLifeSpan);
      this.setEditDataFrowPluginInfoId(this.editData.plugins);
    },
    setEditDataFrowPluginInfoId: function setEditDataFrowPluginInfoId(plugins) {
      for (var i = 0; i < plugins.length; i++) {
        if (plugins[i].serviceId === 1) {
          this.flowEditData.pluginInfoId = plugins[i].pluginInfoId;
        }
      }
    },
    setEditDataRo: function setEditDataRo(service) {
      this.roEditData.alertRate = service.params.alertRate;
      this.roEditData.warningRate = service.params.warningRate;
    },
    setEditDataTempreture: function setEditDataTempreture(service, plugin) {
      var selectTempretureItem = '';
      if (service.serviceId === 3 && service.portNumber === this.selectEditPort) {
        this.temperatureEditData.portNumber = service.portNumber;
        if (service.params.validationType === 1) {
          selectTempretureItem = this.$t('watersystem.temperature-increase');
        }
        if (service.params.validationType === 2) {
          selectTempretureItem = this.$t('watersystem.temperature-decrease');
        }
        this.selectTempretureItem = selectTempretureItem;
        this.temperatureEditData.validationType = service.params.validationType;
        this.temperatureEditData.alertRate.min = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(service.params.settingData.temperature[0].alertRate.min, this.temperatureUnit);
        this.temperatureEditData.alertRate.max = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(service.params.settingData.temperature[0].alertRate.max, this.temperatureUnit);
        this.temperatureEditData.warningRate.min = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(service.params.settingData.temperature[0].warningRate.min, this.temperatureUnit);
        this.temperatureEditData.warningRate.max = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(service.params.settingData.temperature[0].warningRate.max, this.temperatureUnit);
        this.temperatureEditData.plugin = plugin;
      }
    },
    setEditDataPress: function setEditDataPress(service) {
      if (service.serviceId === 5 && service.portNumber === this.selectEditPort) {
        this.pressEditData.portNumber = service.portNumber;
        this.pressEditData.alertRate = this.convertPressureUnit(service.params.alertRate);
        this.pressEditData.warningRate = this.convertPressureUnit(service.params.warningRate);
        // 差圧かどうか
        if (service.params.validationType === 0) {
          this.pressEditData.isDifferentialPressure = false;
        } else if (service.params.validationType === 1) {
          this.pressEditData.isDifferentialPressure = true;
        }
      }
    },
    updateEditData: function updateEditData() {
      for (var i = 0; i < this.editData.services.length; i++) {
        if (this.editData.services[i].serviceId === this.selectEditServiceId) {
          if (this.selectEditServiceId === 1) {
            this.updateEditDataFrow(this.editData.services[i]);
            return;
          } else if (this.selectEditServiceId === 2) {
            this.updateEditDataRo(this.editData.services[i]);
            return;
          } else if (this.selectEditServiceId === 3) {
            this.updateEditDataTempreture(this.editData.services);
            return;
          } else if (this.selectEditServiceId === 5) {
            this.updateEditDataPress(this.editData.services);
            return;
          }
        }
      }
    },
    updateEditDataFrow: function updateEditDataFrow(service) {
      service.params.filters[0].maxFlowLifeSpan = this.reverseUnit(this.flowEditData.maxFlowLifeSpan);
      service.params.filters[0].warningFlowLifeSpan = this.reverseUnit(this.flowEditData.warningFlowLifeSpan);
      service.params.filters[0].maxUptimeLifeSpan = this.reverseSecondToMonth(this.flowEditData.maxUptimeLifeSpan);
      service.params.filters[0].warningUptimeLifeSpan = this.reverseSecondToMonth(this.flowEditData.warningUptimeLifeSpan);
      this.updateEditDataFrowPluginInfoId(this.editData.plugins);
    },
    updateEditDataFrowPluginInfoId: function updateEditDataFrowPluginInfoId(plugins) {
      for (var i = 0; i < plugins.length; i++) {
        if (plugins[i].serviceId === 1) {
          plugins[i].pluginInfoId = this.flowEditData.pluginInfoId;
        }
      }
    },
    updateEditDataRo: function updateEditDataRo(service) {
      service.params.alertRate = this.roEditData.alertRate;
      service.params.warningRate = this.roEditData.warningRate;
    },
    updateEditDataTempreture: function updateEditDataTempreture(services) {
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 3 && services[i].portNumber === this.temperatureEditData.portNumber) {
          services[i].params.validationType = this.temperatureEditData.validationType;
          // TODO: しきい値を複数設定する際改修が必要、現在は固定0番目に入れる
          if (parseInt(this.temperatureEditData.validationType) === 1) {
            services[i].params.settingData.temperature[0].alertRate.min = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseTemperatureUnit(this.temperatureEditData.alertRate.min, this.temperatureUnit);
            services[i].params.settingData.temperature[0].alertRate.max = '';
            services[i].params.settingData.temperature[0].warningRate.min = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseTemperatureUnit(this.temperatureEditData.warningRate.min, this.temperatureUnit);
            services[i].params.settingData.temperature[0].warningRate.max = '';
          } else if (parseInt(this.temperatureEditData.validationType) === 2) {
            services[i].params.settingData.temperature[0].alertRate.min = '';
            services[i].params.settingData.temperature[0].alertRate.max = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseTemperatureUnit(this.temperatureEditData.alertRate.max, this.temperatureUnit);
            services[i].params.settingData.temperature[0].warningRate.min = '';
            services[i].params.settingData.temperature[0].warningRate.max = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].reverseTemperatureUnit(this.temperatureEditData.warningRate.max, this.temperatureUnit);
          }
        }
      }
    },
    updateEditDataPress: function updateEditDataPress(services) {
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 5 && services[i].portNumber === this.pressEditData.portNumber) {
          services[i].params.alertRate = this.reversePressureUnit(this.pressEditData.alertRate);
          services[i].params.warningRate = this.reversePressureUnit(this.pressEditData.warningRate);
          // 差圧かどうか
          if (this.pressEditData.isDifferentialPressure) {
            services[i].params.validationType = 1;
          } else {
            services[i].params.validationType = 0;
          }
        }
      }
    },
    settingBtnsDisabled: function settingBtnsDisabled(services) {
      for (var i = 0; i < services.length; i++) {
        this.settingBtnDisabled(services[i]);
      }
    },
    initEditData: function initEditData() {
      this.flowEditData.maxFlowLifeSpan = '';
      this.flowEditData.warningFlowLifeSpan = '';
      this.flowEditData.maxUptimeLifeSpan = '';
      this.flowEditData.warningUptimeLifeSpan = '';
      this.flowEditData.pluginInfoId = '';
      this.roEditData.alertRate = '';
      this.roEditData.warningRate = '';
      this.pressEditData.portNumber = '';
      this.pressEditData.alertRate = '';
      this.pressEditData.warningRate = '';
    },
    thresholdCorrelationValidationCase1: function thresholdCorrelationValidationCase1(alertValue, warningValue) {
      // 値が低くなるほど状態が悪い場合
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        return parseFloat(alertValue) < parseFloat(warningValue);
      }
      // 比較できない場合はチェックしない
      return true;
    },
    thresholdCorrelationValidationCase2: function thresholdCorrelationValidationCase2(alertValue, warningValue) {
      // 値が大きくなるほど状態が悪い場合
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        return parseFloat(alertValue) > parseFloat(warningValue);
      }
      // 比較できない場合はチェックしない
      return true;
    },
    thresholdValidationTempreture: function thresholdValidationTempreture(v, notificationType) {
      if (isNaN(v)) {
        return this.$t('watersystem.vali-threshold-num');
      }
      if (v.length === 0) {
        return this.$t('watersystem.vali-threshold-must');
      }
      if (v < __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.min, this.temperatureUnit)) {
        return this.$t('watersystem.vali-threshold-min-comm', [__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.min, this.temperatureUnit) + this.temperatureUnit]);
      }
      if (v > __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.max, this.temperatureUnit)) {
        return this.$t('watersystem.vali-threshold-max-comm', [__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(this.temperatureEditData.plugin.pluginMetadata.temperature.max, this.temperatureUnit) + this.temperatureUnit]);
      }
      switch (parseInt(this.temperatureEditData.validationType)) {
        case 1:
          if (parseFloat(this.temperatureEditData.warningRate.min) >= parseFloat(this.temperatureEditData.alertRate.min)) {
            if (notificationType === 'alert') {
              return this.$t('watersystem.vali-threshold-greater-than-warning');
            }
            if (notificationType === 'warning') {
              return this.$t('watersystem.vali-threshold-alert-less-than');
            }
          }
          break;
        case 2:
          if (parseFloat(this.temperatureEditData.warningRate.max) <= parseFloat(this.temperatureEditData.alertRate.max)) {
            if (notificationType === 'alert') {
              return this.$t('watersystem.vali-threshold-warning-less-than');
            }
            if (notificationType === 'warning') {
              return this.$t('watersystem.vali-threshold-greater-than-alert');
            }
          }
          break;
      }
      return true;
    },
    thresholdCorrelationValidationPress: function thresholdCorrelationValidationPress(alertValue, warningValue) {
      // 動的に条件を判定
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        if (this.pressEditData.isDifferentialPressure) {
          // 差圧
          return parseFloat(alertValue) > parseFloat(warningValue);
        } else {
          // 圧力値
          return parseFloat(alertValue) < parseFloat(warningValue);
        }
      }
    },
    thresholdCorrelationValidationPressMessage: function thresholdCorrelationValidationPressMessage(alertValue, warningValue, inputValueType) {
      // inputValueType 1:warning 2:alert
      // 動的にメッセージを返す
      if (!isNaN(alertValue) && !isNaN(warningValue)) {
        if (this.pressEditData.isDifferentialPressure) {
          // 差圧
          if (inputValueType === 1) {
            return this.$t('watersystem.vali-threshold-alert-less-than');
          } else if (inputValueType === 2) {
            return this.$t('watersystem.vali-threshold-greater-than-warning');
          }
        } else {
          // 圧力値
          if (inputValueType === 1) {
            return this.$t('watersystem.vali-threshold-greater-than-alert');
          } else if (inputValueType === 2) {
            return this.$t('watersystem.vali-threshold-warning-less-than');
          }
        }
      }
      // 比較できない場合はからを返却
      return '';
    },
    init: function init() {
      this.setExecBtnProperty(); // 保存ボタンの属性をセット
      this.getFlowsensors(); // Pluginデータ取得
    },

    // 保存ボタンの属性をセットする
    setExecBtnProperty: function setExecBtnProperty() {
      this.isRoot = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles); // ルートかどうかを判定
      if (this.isRoot) {
        this.execBtnName = this.$t('aplix-use-only.btn.can-not-save');
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SettingsSidebar_vue__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SettingsSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SettingsSidebar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_SettingsSidebar_vue___default.a
  },
  data: function data() {
    return {
      unit: '',
      timezone: '',
      localTimezone: ''
    };
  },

  methods: {
    init: function init() {
      this.unit = this.$store.getters.settingParams.unit;
      this.timezone = this.$store.getters.settingParams.timezone;
      this.localTimezone = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz.guess();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root,
      staffRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Staff,
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer,
      unit: '',
      timezone: '',
      pressureUnit: '',
      temperatureUnit: '',
      localTimezone: '',
      selectItemsTimezone: [{ text: 'UTC', value: 'utc' }, { text: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.guess(), value: 'local' }, { text: this.$t('settings.timezone-location'), value: 'location' }]
    };
  },

  methods: {
    init: function init() {
      this.unit = this.$store.getters.settingParams.unit;
      this.timezone = this.$store.getters.settingParams.timezone;
      this.pressureUnit = this.$store.getters.settingParams.pressureUnit;
      this.temperatureUnit = this.$store.getters.settingParams.temperatureUnit;
      this.localTimezone = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.guess();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  updated: function updated() {
    this.$store.dispatch('setSettingParam', {
      unit: this.unit,
      timezone: this.timezone,
      pressureUnit: this.pressureUnit,
      temperatureUnit: this.temperatureUnit
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plugins',
  data: function data() {
    return {
      currentTab: '',
      // 多言語対応のためハードコーディング TODO:共通化
      pluginName: {
        1: '流量センサー',
        2: 'TDSセンサー',
        3: '温度センサー',
        4: '漏水センサー',
        5: '圧力センサー'
      },
      flowsensors: [],
      tdssensors: [],
      pressuresensors: [],
      leakagesensors: [],
      temperaturesensors: [],
      // テーブル用の変数
      searchFlowsensor: '',
      headersFlowsensor: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Description', value: 'description' }],
      // テーブル用の変数
      searchTdssensor: '',
      headersTdssensor: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Description', value: 'description' }],
      // テーブル用の変数
      searchTemperaturesensor: '',
      headersTemperturesensor: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Description', value: 'description' }],
      // テーブル用の変数
      searchLeakagesensor: '',
      headersLeakagesensor: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Description', value: 'description' }],
      // テーブル用の変数
      searchPressuresensor: '',
      headersPressuresensor: [{ text: 'ID', value: 'id' }, { text: 'Name', value: 'name' }, { text: 'Description', value: 'description' }]
    };
  },

  methods: {
    init: function init() {
      this.getFlowsensors();
      this.getTdssensors();
      this.getPressuresensors();
      this.getLeakagesensors();
      this.getTemperaturesensors();
    },
    getFlowsensors: function getFlowsensors() {
      var _this = this;

      this.getPlugins(1).then(function (value) {
        _this.flowsensors = value;
      });
    },
    getTdssensors: function getTdssensors() {
      var _this2 = this;

      this.getPlugins(2).then(function (value) {
        _this2.tdssensors = value;
      });
    },
    getTemperaturesensors: function getTemperaturesensors() {
      var _this3 = this;

      this.getPlugins(3).then(function (value) {
        _this3.temperaturesensors = value;
      });
    },
    getLeakagesensors: function getLeakagesensors() {
      var _this4 = this;

      this.getPlugins(4).then(function (value) {
        _this4.leakagesensors = value;
      });
    },
    getPressuresensors: function getPressuresensors() {
      var _this5 = this;

      this.getPlugins(5).then(function (value) {
        _this5.pressuresensors = value;
      });
    },
    getPlugins: function getPlugins(pluginId) {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var pluginName = _this6.pluginName[pluginId];
        __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Plugins/pluginList/' + pluginId).then(function (response) {
          var data = response.data;
          console.log(data);
          if (data.result !== 0) {
            console.log(pluginName + ' list get failed. (' + data.result + ')');
            resolve([]);
          }
          resolve(data.plugins);
        }).catch(function (error) {
          // TODO エラー処理
          console.log('error', error);
          resolve([]);
        });
      });
    },
    currentTabSet: function currentTabSet() {
      this.currentTab = location.hash.replace('#', '');
    }
  },
  mounted: function mounted() {
    this.init();
    this.currentTabSet();
  },

  watch: {
    '$route': function $route() {
      this.currentTabSet();
    }
  }
});

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      ROLE_Root: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root, // Roleの定数
      ROLE_Administrator: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Administrator, // Roleの定数
      ROLE_Manager: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Manager, // Roleの定数
      ROLE_Staff: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Staff, // Roleの定数
      ROLE_Viewer: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer // Roleの定数
    };
  },

  methods: {
    requiredRoles: function requiredRoles(roles) {
      return this.$store.getters.userHasThoseRoles(roles);
    },
    manualUrl: function manualUrl() {
      return "https://www.harps4.com/help/basic_operations.html";
    }
  }
});

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GraphDateSelect: __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default.a
  },
  name: 'TemperatureLogChart',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default: function _default() {
        return 'chart_' + __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].generateUuid();
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'TemperatureLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    earliestLogInfo: Object
  },

  data: function data() {
    return {
      // グラフデータの１プロットの間隔
      period: '15m',
      //
      items: [{ value: '15m', text: this.$t('chart.15m') }, { value: '1h', text: this.$t('chart.1h') }, { value: '1d', text: this.$t('chart.1d') }, { value: '1w', text: this.$t('chart.1w') }, { value: '1M', text: this.$t('chart.1M') }],
      // 親側で切り替えられると困るので、ここで保持しておく
      myChartId: this.id,
      // ECharts のインスタンス
      myChart: null,
      // dataZoom で現在表示中のレンジ
      range: {
        start: null,
        end: null
      },
      // dataZoom で前回表示していたレンジ
      prevRange: {
        start: null,
        end: null
      },
      firstZoomRange: null, // 初回ズーム時のレンジ
      // 日付選択
      toDatetimeUnixTime: 0,
      messagePeriodJump: '',
      messageNoData: '',
      isChangedPeriod: false, // 時間間隔を変更した場合
      isChangedRangeBar: false, // レンジバーを変更した場合
      isChangeRangeBarWidth: false, // レンジバーの幅を変更している場合
      isDataZoom: false, // ズーム範囲選択した場合
      showPeriodMessagePeriodJump: false, // 時間間隔変更時メッセージ表示
      showJumpMessagePeriodJump: false, // 日時指定移動時メッセージ表示

      // グラフの表示データ
      xAxisDatas: [],
      seriesDatas: [],
      outOfFromTimestamp: null, // fromより古いデータのうち一番新しいデータ
      outOfFromSeriesData: [],
      outOfToTimestamp: null, // toより新しいデータのうち一番古いデータ
      outOfToSeriesData: [],

      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],

      // 現在の温度表示ラベル
      lastTemperatureLabel: this.$t('watersystem.now-temperature'),

      // 温度 RATE用の瞬時値
      lastTemperatureDataFixed: __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(0, this.$store.getters.settingParams.temperatureUnit),
      // 温度の表示単位
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      // サービスのコードリスト
      serviceCodes: this.$store.getters.serviceList.codes
    };
  },


  computed: {
    // API呼び出し時に渡す
    params: function params() {
      return {
        dataId: this.dataId,
        period: this.period,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to,
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale)
      };
    },


    // 現在のグラフの描画範囲（レンジの差分, 秒）
    rangeDiff: function rangeDiff() {
      return this.range.end - this.range.start;
    },

    // APIのfromに指定する値
    from: function from() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end - offsetFromPeriods * this.periodTime;
    },

    // APIのtoに指定する値
    to: function to() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end + offsetFromPeriods * this.periodTime;
    },
    periodTime: function periodTime() {
      return {
        '15m': 60 * 15,
        '1h': 60 * 60,
        '1d': 60 * 60 * 24,
        '1w': 60 * 60 * 24 * 7,
        '1M': 60 * 60 * 24 * 30
      }[this.period];
    }
  },

  methods: {
    // データ取得＆グラフ描画処理
    reload: function reload() {
      var _this = this;

      var self = this;

      // ローディング状態にする（ボタン無効化）
      self.reloading = true;
      // グラフのローディングを表示
      self.myChart.showLoading();
      var params = self.params;

      // API呼び出し
      self.graph.temperatureLog(params).then(function (data) {
        // Echartsオプション初期化
        self.initializeChartOption();
        self.messageNoData = '';
        var option = data;
        // 初期化
        self.xAxisDatas = [];
        self.seriesDatas = [];
        self.outOfFromTimestamp = null;
        self.outOfFromSeriesData = [];
        self.outOfToTimestamp = null;
        self.outOfToSeriesData = [];

        // レスポンスのデータをグラフにセット
        option.dataZoom = [{
          // API呼び出し前にセットしていたレンジを再設定
          startValue: self.range.start.toString(),
          endValue: self.range.end.toString()
        }];
        if (!option.xAxis.data.length) {
          // データがない場合は移動ボタンを無効化しメッセージ表示
          self.$refs.graphDateSelect.setDisableJump(true);
          self.messageNoData = self.$t('chart.message-no-data');
          return;
        }

        option.series.forEach(function (one) {
          one.data.forEach(function (element, index) {
            if (element !== null) {
              one.data[index] = self.convertTemperatureUnit(element, self.pressureUnit);
            }
          });
        });
        // APIの引数from,toの範囲外のデータの切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].omitOutOfRangeFromToData(self, option);

        // option.dataZoom[0]の切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].fixOptionDataZoomRange(self, option);

        // 日付選択範囲によるメッセージ
        __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].setMessagePeriodJump(self, {
          'start': Number(option.dataZoom[0].startValue),
          'end': Number(option.dataZoom[0].endValue)
        });
        // データが少ない場合は移動ボタンを無効化
        self.setDisableJump({
          start: Number(option.dataZoom[0].startValue),
          end: Number(option.dataZoom[0].endValue)
        });

        // 先頭と末尾のデータ補正
        option = _this.fillPlotStartEnd(option);
        // グラフデータを再設定
        self.myChart.setOption(option);

        // dataZoom.rangeMode をパーセンテージに変更する
        // startValue, endValue の設定「後」にこれを行わないと、
        // dataZoom の labelFormatter がうまく効いてくれない
        setTimeout(function () {
          self.myChart.setOption({ dataZoom: [{ rangeMode: ['percent', 'percent'] }] });
        }, 0);
      }).catch(function (error) {
        console.log(error);
        // alert(JSON.stringify(error, null, 2))
      }).then(function () {
        // finally
        // ローディング状態を解除（ボタン有効化）
        self.reloading = false;
        // グラフのローディングを非表示
        self.myChart.hideLoading();
        // 読み込み時にwidth100%にする
        self.myChart.resize();
      });
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action');
    },

    // 先頭と末尾のデータ補正
    fillPlotStartEnd: function fillPlotStartEnd(option) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      // 描画範囲内、描画範囲外のプロット位置の取得
      var fillPlotsRangeDatasets = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].retrieveFillPlotsRangeDatasets(this, option, RATE_SERIES_INDEX);

      option.xAxis.data = fillPlotsRangeDatasets.option.xAxis.data;
      option.series = fillPlotsRangeDatasets.option.series;
      var viewRangeStartIndex = fillPlotsRangeDatasets.viewRangeStartIndex;
      var viewRangeEndIndex = fillPlotsRangeDatasets.viewRangeEndIndex;

      var rangeDatasets = fillPlotsRangeDatasets.rangeDatasets;
      // データがない状態から、データが取得できた場合は最古のタイムスタンプを反映
      this.emitEarliestTimestamp(rangeDatasets);

      // 描画範囲の先頭にプロットが描画されていない場合 かつ 描画範囲の前のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        // 描画範囲の前のデータの次のデータ:タイムスタンプ
        var nextDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        // 描画範囲内の最古のデータがない場合かつ描画範囲のendより後のデータがある場合は描画範囲のendより後のデータのタイムスタンプを利用
        if (nextDataTimestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.latestViewRange.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        }
        if (nextDataTimestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.outOfViewRangeEnd.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeEnd.seriesData));
        }
        // 描画範囲内の最古のデータがない場合、かつは描画範囲のendより後のデータがない場合、描画範囲の先頭のタイムスタンプを利用
        if (nextDataTimestamp === null) {
          nextDataTimestamp = option.xAxis.data[viewRangeStartIndex];
        }
        // 描画範囲のstartの前の時刻から描画範囲の最古のデータの時刻までの経過時間
        var pasttimeFromOutOfStartToOldestRange = nextDataTimestamp - rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の時刻から描画範囲の先頭の時刻までの経過時間
        var pasttimeFromOutOfStartToRangeStart = option.xAxis.data[viewRangeStartIndex] - rangeDatasets.outOfViewRangeStart.timestamp;
        // 経過率
        var pasttimeRatio = pasttimeFromOutOfStartToOldestRange === 0 ? 1 : Number(pasttimeFromOutOfStartToRangeStart / pasttimeFromOutOfStartToOldestRange);

        // 描画範囲の前の値 - (描画範囲の前の値 - 描画範囲の先頭の値) * 経過率
        nextDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - nextDataSeriesData[RATE_SERIES_INDEX]) * Number(pasttimeRatio);
        // 先頭にfromより前のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] = {
          value: nextDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      // 描画範囲の末尾にプロットが描画されていない場合 かつ 描画範囲の後のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
        // 描画範囲の後のデータの前のデータ:タイムスタンプ
        var prevDataTimestamp = rangeDatasets.latestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        // 描画範囲内の最新のデータがない場合かつ描画範囲のstartより前のデータがある場合は描画範囲のstartより前のデータのタイムスタンプを利用
        if (prevDataTimestamp === null && rangeDatasets.oldestViewRange.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        }
        if (prevDataTimestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeStart.seriesData));
        }
        // 描画範囲内の最新のデータがない場合、かつは描画範囲のstartより前のデータがない場合、描画範囲の末尾のタイムスタンプを利用
        if (prevDataTimestamp === null) {
          prevDataTimestamp = option.xAxis.data[viewRangeEndIndex];
        }
        // 描画範囲内の最新の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromLatestRangeToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - prevDataTimestamp;
        // 描画範囲の末尾の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromRangeEndToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - option.xAxis.data[viewRangeEndIndex];
        // 経過率
        var _pasttimeRatio = pasttimeFromLatestRangeToOutOfEnd === 0 ? 1 : Number(pasttimeFromRangeEndToOutOfEnd / pasttimeFromLatestRangeToOutOfEnd);
        // 描画範囲の末尾のデータの値
        // 描画範囲の後の値 - (描画範囲の後の値 - 描画範囲の末尾の値) * 経過率
        prevDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - prevDataSeriesData[RATE_SERIES_INDEX]) * Number(_pasttimeRatio);
        // 末尾にfromより後のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] = {
          value: prevDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      this.fillLastData(rangeDatasets);
      return option;
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(rangeDatasets) {
      if (rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.outOfViewRangeStart.timestamp);
      } else if (rangeDatasets.oldestViewRange.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.oldestViewRange.timestamp);
      }
    },

    // 描画範囲の最後の値の設定
    fillLastData: function fillLastData(rangeDatasets) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      var lastTemperatureData = null;
      var lastTimestamp = rangeDatasets.latestViewRange.timestamp;
      var isExistsOutOfViewRange = false;
      // 描画範囲のendの後の値がある
      if (this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp) !== -1 && this.seriesDatas[RATE_SERIES_INDEX].data[this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp)] !== null) {
        isExistsOutOfViewRange = true;
      }
      // 描画範囲の最新の値がある
      if (lastTimestamp !== null) {
        lastTemperatureData = rangeDatasets.latestViewRange.seriesData[RATE_SERIES_INDEX];
      }
      if (lastTemperatureData === null) {
        lastTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の最古の値がある
        if (lastTimestamp !== null) {
          lastTemperatureData = rangeDatasets.oldestViewRange.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastTemperatureData === null) {
        lastTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の値がある
        if (lastTimestamp !== null) {
          lastTemperatureData = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastTemperatureData === null) {
        // データが設定されていない
        this.lastTemperatureDataFixed = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(0, this.temperatureUnit);
        this.lastTemperatureLabel = this.$t('watersystem.now-temperature');
      } else {
        // データが設定されている
        this.lastTemperatureDataFixed = Number(lastTemperatureData).toFixed(1);
        if (rangeDatasets.outOfViewRangeEnd.timestamp !== null && isExistsOutOfViewRange) {
          // 描画範囲のendの後の値がある
          this.lastTemperatureLabel = this.$t('watersystem.past-temperature', [this.formatLastUpdateDate(lastTimestamp * 1000)]);
        } else {
          // 描画範囲のendの後の値がない
          this.lastTemperatureLabel = this.$t('watersystem.now-temperature') + ' (' + this.$t('watersystem.last-update-for-chart') + ':' + this.formatLastUpdateDate(lastTimestamp * 1000) + ')';
        }
      }
    },
    formatLastUpdateDate: function formatLastUpdateDate(unixTimestamp) {
      var options = {};
      switch (this.period) {
        case '15m':
          options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
          break;
        case '1h':
          options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric' };
          break;
        case '1d':
          options = { year: 'numeric', month: 'numeric', day: 'numeric' };
          break;
        case '1w':
          options = { year: 'numeric', month: 'numeric', day: 'numeric' };
          break;
        case '1M':
          options = { year: 'numeric', month: 'long' };
          break;
      }
      options.timeZone = this.timezone;
      this.locale = this.$store.getters.locale;

      return this.period === '1w' ? this.$t('watersystem.last-update-week-suffix-for-chart', [__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options)]) : __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options);
    },

    // ウィンドウのリサイズイベントを取得する
    onResize: function onResize(event) {
      if (this.myChart) {
        // width or height を auto や % 指定している場合は必須
        this.myChart.resize();
      }
    },

    // 単位を変換
    convertTemperatureUnit: function convertTemperatureUnit(temperature) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(temperature, this.temperatureUnit);
    },
    changeDatetime: function changeDatetime(toDatetimeUnixTime) {
      this.toDatetimeUnixTime = toDatetimeUnixTime;
    },

    // 指定した時刻にジャンプする
    jumpToDatetime: function jumpToDatetime(toDatetimeUnixTime) {
      // グラフ描画のレンジを設定しておく
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, toDatetimeUnixTime);
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },

    // 最新時刻にジャンプする
    jumpToRecent: function jumpToRecent(toDatetimeUnixTime) {
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].jumpToRecent(this, toDatetimeUnixTime);
    },

    // プロット範囲が13プロット(時刻範囲が12 * 時間間隔)より小さい場合は移動ボタンを無効化
    setDisableJump: function setDisableJump(range) {
      var isGetAllData = this.outOfFromTimestamp === null && this.outOfToTimestamp === null;
      var viewRangeStartIndex = this.xAxisDatas.indexOf(this.range.start);
      var viewRangeEndIndex = this.xAxisDatas.indexOf(this.range.end);

      if (isGetAllData && viewRangeStartIndex === 0 && viewRangeEndIndex === this.xAxisDatas.length - 1) {
        this.$refs.graphDateSelect.setDisableJump(true);
      } else {
        this.$refs.graphDateSelect.setDisableJump(false);
      }
    },

    // Echartsオプション初期化
    initializeChartOption: function initializeChartOption() {
      var self = this;

      // Echarts初期設定
      var option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function formatter(params /* , ticket, callback */) {
            // callback形式を使うのは、params[0].valueが電圧から変換される関係上、小さい値まで表示されるから。
            // Rateの値がない(サーバ上のデータがない)場合、かつ現在時刻から計算した最新時刻でない場合はツールチップは表示しない
            var rangeLast = self.xAxisDatas[self.xAxisDatas.length - 1];
            var originalValue = self.seriesDatas[0].data[params[0].dataIndex];
            if (originalValue === null && Number(params[0].axisValue) !== rangeLast) {
              return '';
            }
            return (/* params[0].seriresName + ':' */'Temperature:' + Number(params[0].value).toFixed(2)
            );
          }
        },
        // HARPS-242 縦軸ズームをしたい
        // * -> 中止(UI上抑止し、Echarts4以降でライブラリが改善されていれば、対応)
        toolbox: {
          // show: true, // UI抑止解除の際はフラグをtrueにする
          show: false,
          top: '16%',
          right: '11%',
          borderRadius: 1,
          borderWidth: 1,
          feature: {
            dataZoom: {
              // show: true, // UI抑止解除の際はフラグをtrueにする
              show: false,
              title: {
                zoom: self.$t('chart.dataZoom-zoom'),
                back: self.$t('chart.dataZoom-back')
              },
              iconStyle: {
                emphasis: {
                  textPosition: 'bottom',
                  textAlign: 'right',
                  borderColor: '#009933'
                }
              }
            }
          }
        },
        legend: {
          data: ['TemperatureLog']
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          data: [],
          axisLabel: {
            formatter: function formatter(value, index) {
              // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
              // 描画時に文字列に変換する
              self.dateOptions = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period);
              self.dateOptions.timeZone = self.timezone;
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, value * 1000, self.dateOptions);
            }
          }
        },
        yAxis: {
          name: '(' + this.temperatureUnit + ')'
        },
        series: [],
        dataZoom: [{
          type: 'slider',
          realtime: false,
          labelFormatter: function labelFormatter(value, valueStr) {
            var options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period, true);
            options.timezone = self.timezone;
            if (valueStr !== '') {
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, Number(valueStr) * 1000, options);
            }
          }
        }]
      };

      self.properties.split(',').forEach(function (property) {
        switch (property) {
          default:
            option.series.push({
              name: property,
              type: 'line',
              itemStyle: {
                normal: { color: '#008800' }
              },
              data: [],
              connectNulls: true,
              symbolSize: 6,
              showAllSymbol: true
            });
        }
      });

      self.myChart.setOption(option);
    }
  },

  watch: {
    dataId: function dataId() {
      // 初回データロード時は最新表示
      this.$refs.graphDateSelect.jumpToRecent();
    },
    properties: function properties() {
      this.reload();
    },

    // グラフ描画レンジの時間単位を変更する
    period: function period() {
      // グラフ描画のレンジを設定しておく
      this.isChangeRangeBarWidth = false;
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, this.toDatetimeUnixTime);
      this.$refs.graphDateSelect.resetWaitingJump();
      this.isChangedPeriod = true;
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },
    timezone: function timezone() {
      this.reload();
    },
    activeTab: function activeTab() {
      this.reload();
      if (this.activeTab === this.serviceCodes[5]) {
        if (this.myChart) {
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize();
        }
      }
    },
    autoReload: function autoReload() {
      var _this2 = this;

      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(function () {
          _this2.jumpToRecent();
        }, 2000);
      } else {
        clearInterval(this.setIntervalId);
      }
    }
  },

  created: function created() {
    // 直近からグラフ描画のレンジを設定しておく
    var now = Math.floor(Date.now() / 1000);
    now = now - now % this.periodTime;
    this.range.start = now - this.periodTime * 12;
    this.range.end = now;

    this.prevRange = this.range;

    this.graph = new __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__["a" /* default */]({
      token: 'MyToken'
    });
  },
  mounted: function mounted() {
    var self = this;

    // ウィンドウのリサイズイベントのハンドラ登録
    window.addEventListener('resize', self.onResize);

    // Echartsインスタンス生成
    self.myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById(self.myChartId));
    // Echartsオプション初期化
    self.initializeChartOption();

    // datazoom イベントのハンドラを設定
    self.myChart.on('datazoom', function (event) {
      var axis = self.myChart.getModel().option.xAxis[0];
      // 現在描画されているレンジのインデックスを取得
      var start = axis.rangeStart === null || axis.rangeStart < 0 ? 0 : axis.rangeStart;
      var end = axis.rangeEnd === null || axis.rangeEnd >= axis.data.length ? axis.data.length - 1 : axis.rangeEnd;
      // 現在描画されているレンジの値を保存
      self.prevRange = self.range;
      // 現在描画されているレンジの値を設定
      self.range = {
        start: axis.data[start],
        end: axis.data[end]
      };
      if (self.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        self.isDataZoom = event.batch !== undefined;
        // 履歴の先頭に戻った場合はレンジをズームした時点に戻す
        if (event.batch !== undefined) {
          var ecToolBox = self.myChart.getModel()._componentsMap._ec_toolbox;
          var ecToolBoxModel = ecToolBox[0].ecModel;
          if (ecToolBoxModel['\0_ec_hist_store'].length === 2 && self.firstZoomRange === null) {
            self.firstZoomRange = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.prevRange));
          } else if (ecToolBoxModel['\0_ec_hist_store'].length === 1 && self.firstZoomRange !== null) {
            self.range = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.firstZoomRange));
            self.firstZoomRange = null;
          }
        }
      }

      self.isChangedRangeBar = true;
      // レンジバーの幅の変更があったかどうか
      self.isChangeRangeBarWidth = self.isChangeRangeBarWidth || self.range.end - self.range.start !== self.prevRange.end - self.prevRange.start;
      if (start === 0 && self.range.start !== self.prevRange.start) {
        // 先頭に達した場合はグラフのデータをロードする
        self.reload();
      } else if (start === 0 && self.range.start === self.prevRange.start && self.outOfFromTimestamp !== null) {
        // 先頭に達した場合はグラフのデータをロードする
        var rangeOffset = Math.floor(self.rangeDiff / 2);
        self.range = {
          start: self.range.start - rangeOffset,
          end: self.range.end - rangeOffset
        };
        self.reload();
      } else if (end === axis.data.length - 1 && self.range.end !== self.prevRange.end) {
        // 末尾に達した場合はグラフ外のデータをロードする
        self.reload();
      } else {
        // 先頭と末尾を再描画
        var option = {
          xAxis: [],
          series: [],
          dataZoom: [{
            // API呼び出し前にセットしていたレンジを再設定
            startValue: self.range.start.toString(),
            endValue: self.range.end.toString()
          }]
        };
        option = self.fillPlotStartEnd(option);
        setTimeout(function () {
          self.myChart.setOption(option);
        }, 0);
        self.setDisableJump(self.range);
      }
    });

    // クリックイベントハンドラを設定
    // クリックした場合は日付選択フォームを更新する
    self.myChart.on('click', function (event) {
      // event.nameは選択した日時のUNIXタイムスタンプを示す
      self.toDatetimeUnixTime = Number(event.name);
      self.$refs.graphDateSelect.changeSelectDateTime(self.toDatetimeUnixTime);
    });

    // 初回データロード時は最新表示
    this.$refs.graphDateSelect.jumpToRecent();
  },
  beforeDestroy: function beforeDestroy() {
    // ウィンドウのリサイズイベントのハンドラ登録を解除
    window.removeEventListener('resize', this.onResize);
    // EChartsインスタンス破棄
    this.myChart = null;
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RoleLabel_vue__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RoleLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_RoleLabel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topnav',
  components: {
    RoleLabel: __WEBPACK_IMPORTED_MODULE_0__components_RoleLabel_vue___default.a
  },
  data: function data() {
    return {
      user: this.$store.getters.user, // ログインユーザ
      ROLE_Root: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].role.Root, // Roleの定数
      ROLE_Administrator: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].role.Administrator, // Roleの定数
      ROLE_Manager: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].role.Manager, // Roleの定数
      ROLE_Staff: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].role.Staff, // Roleの定数
      topMenus: [],
      supportLanguage: [],
      topnav: {
        flag: '',
        text: '',
        class: ''
      }
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_cognito_js__["a" /* default */].logout().then(function () {
        return _this.$store.dispatch('logout');
      }).then(function () {
        console.log('logout (opt out)');
        _this.$router.push('/login');
      }).catch(function (err) {
        console.log('logout failed');
        console.log(err);
        _this.$router.push('/login');
      });
    },
    changeLanguage: function changeLanguage(lang) {
      this.$store.dispatch('setLanguage', lang);
      this.$i18n.locale = lang;
    },
    requiredRoles: function requiredRoles(roles) {
      return this.$store.getters.userHasThoseRoles(roles);
    },
    currentPage: function currentPage(to) {
      switch (to) {
        default:
          return this.$route.path === to ? 'current_page' : '';
      }
    },
    makeTopMenus: function makeTopMenus() {
      this.topMenus = [{
        to: '/',
        show: this.requiredRoles([]),
        label: this.$t('global-menu.dashboard')
      }, {
        to: '/watersystem_list',
        show: this.requiredRoles([]),
        label: this.$t('global-menu.watersystem')
      }, {
        to: '/customer_list',
        show: this.requiredRoles([]),
        label: this.$t('global-menu.customer')
      }, {
        to: '/settings/display',
        show: this.requiredRoles([]),
        label: this.$t('global-menu.setting')
      }];
    },
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].getDomainConfig();
      this.topnav = domainConfig.topnav;
      this.supportLanguage = domainConfig.supportLanguage;
    }
  },
  mounted: function mounted() {
    console.log(this.$route.fullPath);
    this.makeTopMenus();
    this.getDomainConfig();
  }
});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  // 再帰的に組織の階層を表示するコンポーネント
  props: {
    organization: Object
  },
  data: function data() {
    return {
      open: true,
      selectedOrganizationId: null
    };
  },

  computed: {
    hasChild: function hasChild() {
      return this.organization.children && this.organization.children.length;
    },
    selectedOrganizationIdForTree: function selectedOrganizationIdForTree() {
      return this.selectedOrganizationId;
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.hasChild) {
        this.open = !this.open;
      }
    },
    selectOrganization: function selectOrganization(organizationId) {
      this.selectedOrganizationId = organizationId;
      this.$emit('child-action', organizationId);
    }
  }
});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      locale: this.$store.getters.locale,
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].role.Root,
      pcRoleName: __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].role.Root,
      dispFlag: false,
      usageSummaries: {
        organizationName: '',
        totalCount: ''
      },
      dateList: [],
      selectedDate: '',
      dispDate: '',
      summariesPcListError: false,
      summariesPcList: [],
      locationListHeaders: [{ text: this.$t('usage-report.location-count-list.organization-name'), value: 'organizationName' }, { text: this.$t('usage-report.location-count-list.location-name'), value: 'locationName' }, { text: this.$t('usage-report.location-count-list.device-count'), value: 'deviceCount' }],
      locationListTable: [],
      deviceListHeaders: [{ text: this.$t('usage-report.device-count-list.organization-name'), value: 'organizationName' }, { text: this.$t('usage-report.device-count-list.location-name'), value: 'locationName' }, { text: this.$t('usage-report.device-count-list.filtration-system-name'), value: 'filtrationSystemName' }, { text: this.$t('usage-report.device-count-list.unique-id'), value: 'uniqueId' }],
      deviceListTable: [],
      errorMessage: '',
      selectPcOrg: ''
    };
  },

  methods: {
    init: function init() {
      this.getDateLists();
    },

    /**
     * Summaryのリストの年月リスト
     */
    getDateLists: function getDateLists() {
      var _this = this;

      this.dateList = [];
      // リストデータの取得
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/summaries/getDateList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get summaries date list data failed. (' + data.result + ')');
          return;
        }
        // console.log(data)
        _this.dispFlag = data.DispFlag;
        // 表示用の配列に格納
        var dateLists = data.DateLists;
        // リストが取れない場合は
        if (!dateLists) {
          // データを取得できなかった旨を表示
          _this.showError(_this.$t('usage-report.failed-display-no-data'));
          _this.dispFlag = false;
        }
        var setDate = '';
        for (var key in dateLists) {
          var row = {
            label: key,
            value: dateLists[key]
          };
          _this.dateList.push(row);
          setDate = dateLists[key];
        }
        // 初期表示月は最新月とする
        _this.selectedDate = setDate;
      }).catch(function () {
        // TODO エラー処理
        // console.log('error', error)
      });
    },

    /**
     * 対象年月のSummaryのリスト取得
     */
    getSummariesLists: function getSummariesLists() {
      var _this2 = this;

      // 共通変数の初期化
      this.dispDate = '';
      this.locationListTable = [];
      this.deviceListTable = [];
      this.errorMessage = '';
      this.usageSummaries.organizationName = '';
      this.usageSummaries.totalCount = '';
      // Rootかつ組織が選択されない場合は実行しない
      if (__WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles) && !this.selectPcOrg) {
        return;
      }
      // パラメータを生成
      var params = {
        date: this.selectedDate,
        organizationId: this.selectPcOrg
        // thisをselfに格納
      };var self = this;
      // リストデータの取得
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/summaries/getSummary', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get usage summaries data failed. (' + data.result + ')');
          // データを取得できなかった旨を表示
          _this2.showError(_this2.$t('usage-report.failed-display-no-data'));
          return;
        }
        // 日付をバインド
        _this2.getDispDate();
        self.usageSummaries.organizationName = data.organizationName;
        self.usageSummaries.totalCount = data.devices.length;
        // 設置拠点内訳
        if (data.locations.length > 0) {
          // 表示用の配列に格納
          var locations = data.locations;
          for (var i in locations) {
            var row = {
              organizationName: locations[i].organizationName,
              locationName: locations[i].locationName,
              deviceCount: locations[i].deviceCount
            };
            self.locationListTable.push(row);
          }
        }
        // 個別内訳
        if (data.devices.length > 0) {
          // 表示用の配列に格納
          var devices = data.devices;
          for (var _i in devices) {
            var _row = {
              organizationName: devices[_i].organizationName,
              locationName: devices[_i].locationName,
              filtrationSystemName: devices[_i].filtrationSystemName,
              uniqueId: devices[_i].jm1UniqueId
            };
            self.deviceListTable.push(_row);
          }
        }
      }).catch(function () {
        // TODO エラー処理
        // console.log('error', error)
      });
    },

    /**
     * 印刷
     */
    printDiv: function printDiv() {
      window.print();
    },

    /**
     * ZIPファイル(中にCSVファイルが入っている)を作成し、作成に成功したらダウンロード処理を実行する
     * データがなくZIPファイルが作成されなかった場合はエラーメッセージを表示する
     */
    createDownloadZip: function createDownloadZip() {
      var _this3 = this;

      self.errorMessage = '';
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/summaries/getCsvDownloadUrl/' + this.selectedDate).then(function (response) {
        var data = response.data;
        // console.log(data)
        if (data.result === -500) {
          _this3.showError(_this3.$t('usage-report.failed-create-zip-file-fatal'));
        } else if (data.result === -501) {
          _this3.showError(_this3.$t('usage-report.failed-create-zip-file-busy'));
        } else if (data.downloadUrl !== undefined) {
          // csvダウンロードのファイル名は、YYYYMM以外は固定
          var downloadFileName = 'Summary' + _this3.selectedDate + '01000000.zip';
          _this3.downloadRequest(data.downloadUrl, downloadFileName);
        } else {
          _this3.showError(_this3.$t('usage-report.failed-download-no-data'));
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
        _this3.showError(_this3.$t('usage-report.failed-create-zip-file-fatal'));
      });
      return;
    },

    /**
     * ZIPダウンロードリクエストを発行する
     */
    downloadRequest: function downloadRequest(downloadShortUrl, downloadFileName) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var downloadUrl, getConfig, zipRes, blob;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                downloadUrl = downloadShortUrl;

                if (!(__WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].iOS() && __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].safari())) {
                  _context.next = 5;
                  break;
                }

                // #23338
                _this4.letBrowserToSave(null, downloadUrl, downloadFileName);
                _context.next = 12;
                break;

              case 5:
                window._httpGrovalHookEnabled = false;
                getConfig = {
                  responseType: 'blob'
                };
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(downloadUrl, getConfig);

              case 9:
                zipRes = _context.sent;
                blob = new Blob([zipRes.data]);

                _this4.letBrowserToSave(blob, null, downloadFileName);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },

    /**
     * blobファイルを保存する
     * iOS safariについては、ダウンロードリンクをクリックさせる
     * @param remoteTargetUrl
     *  null でない場合は brob を使わず、ブラウザにリモートからダウンロードさせる。
     *  IE11 は未実装。
     */
    letBrowserToSave: function letBrowserToSave(blob, remoteTargetUrl, downloadFileName) {
      // IE11はwindow.navigator.msSaveOrOpenBlobを利用してBlobをダウンロードさせる
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, downloadFileName);
      } else {
        var link = document.createElement('a');
        if (remoteTargetUrl) {
          console.log('let browser download ' + downloadFileName);
          link.href = remoteTargetUrl;
        } else {
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', downloadFileName);
        }
        document.body.appendChild(link);
        console.log('link.click()');
        link.click();
      }
    },
    showError: function showError(error) {
      this.errorMessage = error;
    },

    // iOSかどうか vueの中で直接使うために関数化
    isIOS: function isIOS() {
      return __WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].iOS();
    },
    getDispDate: function getDispDate() {
      // Keyを表示してるようなので取得
      this.dateList.forEach(function (element) {
        if (element.value === this.selectedDate) {
          this.dispDate = element.label;
        }
      }, this);
    },
    getSummariesPCOrgList: function getSummariesPCOrgList() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles)) {
        // Root以外では実行しない
        return;
      }
      var self = this;
      // リストデータの取得
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/summaries/getSummariesPcList').then(function (response) {
        var data = response.data;
        console.log('data', data);
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get summariesPcList data failed. (' + data.result + ')');
          return;
        }
        self.summariesPcList = data.summariesPcList;
        console.log('summariesPcList', self.summariesPcList);
      }).catch(function () {
        // TODO エラー処理
        // console.log('error', error)
      });
    },

    // 選択されていない時に入力を促すためにエラー状態をコントロールする
    // 初期状態だとエラーにならないため
    summariesPcListErrorCntroll: function summariesPcListErrorCntroll() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles)) {
        // Root以外では実行しない
        return;
      }
      if (this.selectedDate && !this.selectPcOrg) {
        // 日付が選択されている場合は入力を促す
        this.summariesPcListError = true;
      } else {
        this.summariesPcListError = false;
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },

  watch: {
    selectedDate: function selectedDate() {
      this.getSummariesLists();
      // 以下Rootのみ機能
      this.getSummariesPCOrgList();
      this.summariesPcListErrorCntroll();
    },
    selectPcOrg: function selectPcOrg() {
      // 以下Rootのみ機能
      this.summariesPcListErrorCntroll();
      this.getSummariesLists();
    }
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GraphDateSelect: __WEBPACK_IMPORTED_MODULE_5__components_GraphDateSelect___default.a
  },
  name: 'WaterPressureLogChart',
  props: {
    // 親のテンプレートで指定した場合はそれを使う
    // 未指定の場合はUUIDユニークな値を自ら生成する
    id: {
      type: String,
      default: function _default() {
        return 'chart_' + __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].generateUuid();
      }
    },
    // グラフに描画する対象のデータID（必須）
    dataId: {
      type: String,
      required: true
    },
    // グラフ描画時のタイムゾーン設定
    timezone: {
      type: String,
      default: 'UTC'
    },
    activeTab: {
      type: String,
      default: ''
    },
    properties: {
      type: String,
      default: 'WaterPressureLog'
    },
    color: {
      type: String,
      default: 'blue'
    },
    earliestLogInfo: Object
  },

  data: function data() {
    return {
      // グラフデータの１プロットの間隔
      period: '15m',
      //
      items: [{ value: '15m', text: this.$t('chart.15m') }, { value: '1h', text: this.$t('chart.1h') }, { value: '1d', text: this.$t('chart.1d') }, { value: '1w', text: this.$t('chart.1w') }, { value: '1M', text: this.$t('chart.1M') }],
      // 親側で切り替えられると困るので、ここで保持しておく
      myChartId: this.id,
      // ECharts のインスタンス
      myChart: null,
      // dataZoom で現在表示中のレンジ
      range: {
        start: null,
        end: null
      },
      // dataZoom で前回表示していたレンジ
      prevRange: {
        start: null,
        end: null
      },
      firstZoomRange: null, // 初回ズーム時のレンジ
      // 日付選択
      toDatetimeUnixTime: 0,
      messagePeriodJump: '',
      messageNoData: '',
      isChangedPeriod: false, // 時間間隔を変更した場合
      isChangedRangeBar: false, // レンジバーを変更した場合
      isChangeRangeBarWidth: false, // レンジバーの幅を変更している場合
      isDataZoom: false, // ズーム範囲選択した場合
      showPeriodMessagePeriodJump: false, // 時間間隔変更時メッセージ表示
      showJumpMessagePeriodJump: false, // 日時指定移動時メッセージ表示

      // グラフの表示データ
      xAxisDatas: [],
      seriesDatas: [],
      outOfFromTimestamp: null, // fromより古いデータのうち一番新しいデータ
      outOfFromSeriesData: [],
      outOfToTimestamp: null, // toより新しいデータのうち一番古いデータ
      outOfToSeriesData: [],

      // リロード中フラグ
      reloading: false,
      autoReload: false,
      setIntervalId: null,

      // ブラウザのロケール情報
      locale: this.$store.getters.locale,
      dateOptions: [],

      // 現在の圧力値表示ラベル
      lastPressureLabel: this.$t('watersystem.now-pressure'),

      // 圧力 RATE用の瞬時値
      lastPressDataFixed: 0,
      // 圧力値の表示単位
      pressureUnit: this.$store.getters.settingParams.pressureUnit,
      // サービスのコードリスト
      serviceCodes: this.$store.getters.serviceList.codes
    };
  },


  computed: {
    // API呼び出し時に渡す
    params: function params() {
      return {
        dataId: this.dataId,
        period: this.period,
        sort: 'asc', // 固定
        timezone: this.timezone,
        from: this.from,
        to: this.to,
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].firstDayOfWeek(this.locale)
      };
    },


    // 現在のグラフの描画範囲（レンジの差分, 秒）
    rangeDiff: function rangeDiff() {
      return this.range.end - this.range.start;
    },

    // APIのfromに指定する値
    from: function from() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end - offsetFromPeriods * this.periodTime;
    },

    // APIのtoに指定する値
    to: function to() {
      // チャートグラフに表示する区間の制限が無かった為、表示上読めると判断した36区間に指定
      var offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 3;
      if (offsetFromPeriods > 72) {
        // レンジバーの幅を広く変えた場合は制限して取得する
        offsetFromPeriods = Math.floor(this.rangeDiff / this.periodTime) * 2;
      }

      return this.range.end + offsetFromPeriods * this.periodTime;
    },
    periodTime: function periodTime() {
      return {
        '15m': 60 * 15,
        '1h': 60 * 60,
        '1d': 60 * 60 * 24,
        '1w': 60 * 60 * 24 * 7,
        '1M': 60 * 60 * 24 * 30
      }[this.period];
    }
  },

  methods: {
    // データ取得＆グラフ描画処理
    reload: function reload() {
      var _this = this;

      var self = this;

      // ローディング状態にする（ボタン無効化）
      self.reloading = true;
      // グラフのローディングを表示
      self.myChart.showLoading();

      console.log({
        'from': new Date(self.from * 1000),
        'to': new Date(self.to * 1000)
      });

      var params = self.params;
      // console.log({params: params})

      // API呼び出し
      self.graph.waterPressureLog(params).then(function (data) {
        // Echartsオプション初期化
        self.initializeChartOption();
        self.messageNoData = '';

        // console.log('success')
        var option = data;

        // 初期化
        self.xAxisDatas = [];
        self.seriesDatas = [];
        self.outOfFromTimestamp = null;
        self.outOfFromSeriesData = [];
        self.outOfToTimestamp = null;
        self.outOfToSeriesData = [];

        // 線グラフ ////////////////////////////////////////////////////
        // レスポンスのデータをグラフにセット
        option.dataZoom = [{
          // API呼び出し前にセットしていたレンジを再設定
          startValue: self.range.start.toString(),
          endValue: self.range.end.toString()
        }];
        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        if (!option.xAxis.data.length) {
          // データがない場合は移動ボタンを無効化しメッセージ表示
          self.$refs.graphDateSelect.setDisableJump(true);
          self.messageNoData = self.$t('chart.message-no-data');
          return;
        }

        option.series.forEach(function (one) {
          one.data.forEach(function (element, index) {
            if (element !== null) {
              one.data[index] = self.convertPressureUnit(element, self.pressureUnit);
            }
          });
        });
        // APIの引数from,toの範囲外のデータの切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].omitOutOfRangeFromToData(self, option);

        // option.dataZoom[0]の切り詰め
        option = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].fixOptionDataZoomRange(self, option);

        // 日付選択範囲によるメッセージ
        __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].setMessagePeriodJump(self, {
          'start': Number(option.dataZoom[0].startValue),
          'end': Number(option.dataZoom[0].endValue)
        });
        // console.log({
        //   'start': new Date(Number(option.dataZoom[0].startValue) * 1000),
        //   'end': new Date(Number(option.dataZoom[0].endValue) * 1000)
        // })
        // データが少ない場合は移動ボタンを無効化
        self.setDisableJump({
          start: Number(option.dataZoom[0].startValue),
          end: Number(option.dataZoom[0].endValue)
        });

        // 先頭と末尾のデータ補正
        option = _this.fillPlotStartEnd(option);
        // グラフデータを再設定
        self.myChart.setOption(option);

        // dataZoom.rangeMode をパーセンテージに変更する
        // startValue, endValue の設定「後」にこれを行わないと、
        // dataZoom の labelFormatter がうまく効いてくれない
        setTimeout(function () {
          self.myChart.setOption({ dataZoom: [{ rangeMode: ['percent', 'percent'] }] });
        }, 0);
      }).catch(function (error) {
        console.log(error);
        // alert(JSON.stringify(error, null, 2))
      }).then(function () {
        // finally
        // ローディング状態を解除（ボタン有効化）
        self.reloading = false;
        // グラフのローディングを非表示
        self.myChart.hideLoading();
        // 読み込み時にwidth100%にする
        self.myChart.resize();
      });
      // メタデータの更新のためにgetFiltrationSystemを発火
      this.$emit('child-action');
    },

    // 先頭と末尾のデータ補正
    fillPlotStartEnd: function fillPlotStartEnd(option) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      // 描画範囲内、描画範囲外のプロット位置の取得
      var fillPlotsRangeDatasets = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].retrieveFillPlotsRangeDatasets(this, option, RATE_SERIES_INDEX);

      option.xAxis.data = fillPlotsRangeDatasets.option.xAxis.data;
      option.series = fillPlotsRangeDatasets.option.series;
      var viewRangeStartIndex = fillPlotsRangeDatasets.viewRangeStartIndex;
      var viewRangeEndIndex = fillPlotsRangeDatasets.viewRangeEndIndex;

      var rangeDatasets = fillPlotsRangeDatasets.rangeDatasets;
      // データがない状態から、データが取得できた場合は最古のタイムスタンプを反映
      this.emitEarliestTimestamp(rangeDatasets);

      // 描画範囲の先頭にプロットが描画されていない場合 かつ 描画範囲の前のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        // 描画範囲の前のデータの次のデータ:タイムスタンプ
        var nextDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        // 描画範囲内の最古のデータがない場合かつ描画範囲のendより後のデータがある場合は描画範囲のendより後のデータのタイムスタンプを利用
        if (nextDataTimestamp === null && rangeDatasets.latestViewRange.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.latestViewRange.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        }
        if (nextDataTimestamp === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
          nextDataTimestamp = rangeDatasets.outOfViewRangeEnd.timestamp;
          nextDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeEnd.seriesData));
        }
        // 描画範囲内の最古のデータがない場合、かつは描画範囲のendより後のデータがない場合、描画範囲の先頭のタイムスタンプを利用
        if (nextDataTimestamp === null) {
          nextDataTimestamp = option.xAxis.data[viewRangeStartIndex];
        }
        // 描画範囲のstartの前の時刻から描画範囲の最古のデータの時刻までの経過時間
        var pasttimeFromOutOfStartToOldestRange = nextDataTimestamp - rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の時刻から描画範囲の先頭の時刻までの経過時間
        var pasttimeFromOutOfStartToRangeStart = option.xAxis.data[viewRangeStartIndex] - rangeDatasets.outOfViewRangeStart.timestamp;
        // 経過率
        var pasttimeRatio = pasttimeFromOutOfStartToOldestRange === 0 ? 1 : Number(pasttimeFromOutOfStartToRangeStart / pasttimeFromOutOfStartToOldestRange);

        // 描画範囲の前の値 - (描画範囲の前の値 - 描画範囲の先頭の値) * 経過率
        nextDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX] - nextDataSeriesData[RATE_SERIES_INDEX]) * Number(pasttimeRatio);
        // 先頭にfromより前のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeStartIndex] = {
          value: nextDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      // 描画範囲の末尾にプロットが描画されていない場合 かつ 描画範囲の後のデータがある場合
      if (option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] === null && rangeDatasets.outOfViewRangeEnd.timestamp !== null) {
        // 描画範囲の後のデータの前のデータ:タイムスタンプ
        var prevDataTimestamp = rangeDatasets.latestViewRange.timestamp;
        // 描画範囲の前のデータの次のデータ:値
        var prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.latestViewRange.seriesData));
        // 描画範囲内の最新のデータがない場合かつ描画範囲のstartより前のデータがある場合は描画範囲のstartより前のデータのタイムスタンプを利用
        if (prevDataTimestamp === null && rangeDatasets.oldestViewRange.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.oldestViewRange.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.oldestViewRange.seriesData));
        }
        if (prevDataTimestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null) {
          prevDataTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
          prevDataSeriesData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rangeDatasets.outOfViewRangeStart.seriesData));
        }
        // 描画範囲内の最新のデータがない場合、かつは描画範囲のstartより前のデータがない場合、描画範囲の末尾のタイムスタンプを利用
        if (prevDataTimestamp === null) {
          prevDataTimestamp = option.xAxis.data[viewRangeEndIndex];
        }
        // 描画範囲内の最新の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromLatestRangeToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - prevDataTimestamp;
        // 描画範囲の末尾の時刻から描画範囲のendの後のデータの時刻までの経過時間
        var pasttimeFromRangeEndToOutOfEnd = rangeDatasets.outOfViewRangeEnd.timestamp - option.xAxis.data[viewRangeEndIndex];
        // 経過率
        var _pasttimeRatio = pasttimeFromLatestRangeToOutOfEnd === 0 ? 1 : Number(pasttimeFromRangeEndToOutOfEnd / pasttimeFromLatestRangeToOutOfEnd);
        // 描画範囲の末尾のデータの値
        // 描画範囲の後の値 - (描画範囲の後の値 - 描画範囲の末尾の値) * 経過率
        prevDataSeriesData[RATE_SERIES_INDEX] = rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - (rangeDatasets.outOfViewRangeEnd.seriesData[RATE_SERIES_INDEX] - prevDataSeriesData[RATE_SERIES_INDEX]) * Number(_pasttimeRatio);
        // 末尾にfromより後のデータを設定
        option.series[RATE_SERIES_INDEX].data[viewRangeEndIndex] = {
          value: prevDataSeriesData[RATE_SERIES_INDEX],
          symbolSize: 0
        };
      }
      this.fillLastData(rangeDatasets);
      return option;
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(rangeDatasets) {
      if (rangeDatasets.outOfViewRangeStart.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.outOfViewRangeStart.timestamp);
      } else if (rangeDatasets.oldestViewRange.timestamp !== null) {
        this.$emit('emit-earliest-timestamp', rangeDatasets.oldestViewRange.timestamp);
      }
    },

    // 描画範囲の最後の値の設定
    fillLastData: function fillLastData(rangeDatasets) {
      var RATE_SERIES_INDEX = 0; // Rateのindex
      var lastPressData = null;
      var lastTimestamp = rangeDatasets.latestViewRange.timestamp;
      var isExistsOutOfViewRange = false;
      // 描画範囲のendの後の値がある
      if (this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp) !== -1 && this.seriesDatas[RATE_SERIES_INDEX].data[this.xAxisDatas.indexOf(rangeDatasets.outOfViewRangeEnd.timestamp)] !== null) {
        isExistsOutOfViewRange = true;
      }
      // 描画範囲の最新の値がある
      if (lastTimestamp !== null) {
        lastPressData = rangeDatasets.latestViewRange.seriesData[RATE_SERIES_INDEX];
      }
      if (lastPressData === null) {
        lastTimestamp = rangeDatasets.oldestViewRange.timestamp;
        // 描画範囲の最古の値がある
        if (lastTimestamp !== null) {
          lastPressData = rangeDatasets.oldestViewRange.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastPressData === null) {
        lastTimestamp = rangeDatasets.outOfViewRangeStart.timestamp;
        // 描画範囲のstartの前の値がある
        if (lastTimestamp !== null) {
          lastPressData = rangeDatasets.outOfViewRangeStart.seriesData[RATE_SERIES_INDEX];
        }
      }
      if (lastPressData === null) {
        // データが設定されていない
        this.lastPressDataFixed = 0;
        this.lastPressureLabel = this.$t('watersystem.now-pressure');
      } else {
        // データが設定されている
        this.lastPressDataFixed = Number(lastPressData).toFixed(2);
        if (rangeDatasets.outOfViewRangeEnd.timestamp !== null && isExistsOutOfViewRange) {
          // 描画範囲のendの後の値がある
          this.lastPressureLabel = this.$t('watersystem.past-pressure', [this.formatLastUpdateDate(lastTimestamp * 1000)]);
        } else {
          // 描画範囲のendの後の値がない
          this.lastPressureLabel = this.$t('watersystem.now-pressure') + ' (' + this.$t('watersystem.last-update-for-chart') + ':' + this.formatLastUpdateDate(lastTimestamp * 1000) + ')';
        }
      }
    },
    formatLastUpdateDate: function formatLastUpdateDate(unixTimestamp) {
      var options = {};
      options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(this.period);
      options.timeZone = this.timezone;
      this.locale = this.$store.getters.locale;

      return this.period === '1w' ? this.$t('watersystem.last-update-week-suffix-for-chart', [__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options)]) : __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options);
    },

    // ウィンドウのリサイズイベントを取得する
    onResize: function onResize(event) {
      if (this.myChart) {
        // width or height を auto や % 指定している場合は必須
        this.myChart.resize();
      }
    },

    // 単位を変換
    convertPressureUnit: function convertPressureUnit(pressure) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertPressureUnit(pressure, this.pressureUnit);
    },
    changeDatetime: function changeDatetime(toDatetimeUnixTime) {
      this.toDatetimeUnixTime = toDatetimeUnixTime;
    },

    // 指定した時刻にジャンプする
    jumpToDatetime: function jumpToDatetime(toDatetimeUnixTime) {
      // グラフ描画のレンジを設定しておく
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, toDatetimeUnixTime);
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },

    // 最新時刻にジャンプする
    jumpToRecent: function jumpToRecent(toDatetimeUnixTime) {
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].jumpToRecent(this, toDatetimeUnixTime);
    },

    // プロット範囲が13プロット(時刻範囲が12 * 時間間隔)より小さい場合は移動ボタンを無効化
    setDisableJump: function setDisableJump(range) {
      var isGetAllData = this.outOfFromTimestamp === null && this.outOfToTimestamp === null;
      var viewRangeStartIndex = this.xAxisDatas.indexOf(this.range.start);
      var viewRangeEndIndex = this.xAxisDatas.indexOf(this.range.end);

      if (isGetAllData && viewRangeStartIndex === 0 && viewRangeEndIndex === this.xAxisDatas.length - 1) {
        this.$refs.graphDateSelect.setDisableJump(true);
      } else {
        this.$refs.graphDateSelect.setDisableJump(false);
      }
    },

    // Echartsオプション初期化
    initializeChartOption: function initializeChartOption() {
      var self = this;

      // Echarts初期設定
      var option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function formatter(params /* , ticket, callback */) {
            // callback形式を使うのは、params[0].valueが電圧から変換される関係上、小さい値まで表示されるから。
            // Rateの値がない(サーバ上のデータがない)場合、かつ現在時刻から計算した最新時刻でない場合はツールチップは表示しない
            var rangeLast = self.xAxisDatas[self.xAxisDatas.length - 1];
            var originalValue = self.seriesDatas[0].data[params[0].dataIndex];
            if (originalValue === null && Number(params[0].axisValue) !== rangeLast) {
              return '';
            }
            // params[0].seriesName だとRateが来るので暫定的に即値で指定
            return (/* params[0].seriresName + ':' */'Pressure:' + Number(params[0].value).toFixed(2)
            );
          }
        },
        // HARPS-242 縦軸ズームをしたい
        // * -> 中止(UI上抑止し、Echarts4以降でライブラリが改善されていれば、対応)
        toolbox: {
          // show: true, // UI抑止解除の際はフラグをtrueにする
          show: false,
          top: '16%',
          right: '11%',
          borderRadius: 1,
          borderWidth: 1,
          feature: {
            dataZoom: {
              // show: true, // UI抑止解除の際はフラグをtrueにする
              show: false,
              title: {
                zoom: self.$t('chart.dataZoom-zoom'),
                back: self.$t('chart.dataZoom-back')
              },
              iconStyle: {
                emphasis: {
                  textPosition: 'bottom',
                  textAlign: 'right',
                  borderColor: '#009933'
                }
              }
            }
          }
        },
        legend: {
          data: ['WaterPressureLog']
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          data: [],
          axisLabel: {
            formatter: function formatter(value, index) {
              // タイムスタンプは UNIX-Time (秒) の値をそのまま持たせて、
              // 描画時に文字列に変換する
              self.dateOptions = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period);
              self.dateOptions.timeZone = self.timezone;
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, value * 1000, self.dateOptions);
              // return moment.unix(value).format('HH:mm');
            }
          }
        },
        yAxis: {
          name: '(' + this.pressureUnit + ')'
        },
        series: [],
        dataZoom: [{
          type: 'slider',
          realtime: false,
          // minValueSpan: 3,
          // maxValueSpan: 10,
          labelFormatter: function labelFormatter(value, valueStr) {
            // xAxis.axisLabel.formetter と基本的に同じでよいが、
            // valueStr に文字列で値が入ってくる点に注意
            var options = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].getDateOptions(self.period, true);
            options.timezone = self.timezone;
            if (valueStr !== '') {
              return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(self.locale, Number(valueStr) * 1000, options);
            }
          }
        }]
      };

      self.properties.split(',').forEach(function (property) {
        switch (property) {
          default:
            option.series.push({
              name: property,
              type: 'line',
              itemStyle: {
                normal: { color: '#008800' }
              },
              data: [],
              connectNulls: true,
              symbolSize: 6,
              showAllSymbol: true
            });
        }
      });

      self.myChart.setOption(option);
    }
  },

  watch: {
    dataId: function dataId() {
      // デバイス変更時は最新表示
      this.$refs.graphDateSelect.jumpToRecent();
    },
    properties: function properties() {
      this.reload();
    },

    // グラフ描画レンジの時間単位を変更する
    period: function period() {
      // グラフ描画のレンジを設定しておく
      this.isChangeRangeBarWidth = false;
      this.range = __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].getRangeByToDatetimePeriod(this, this.toDatetimeUnixTime);
      this.$refs.graphDateSelect.resetWaitingJump();
      this.isChangedPeriod = true;
      __WEBPACK_IMPORTED_MODULE_3__utils_graphhelper_js__["a" /* default */].resetDataZoomToolBox(this);
      this.reload();
    },
    timezone: function timezone() {
      this.reload();
    },
    activeTab: function activeTab() {
      // console.log('activeTab:' + this.activeTab)
      if (this.activeTab === this.serviceCodes[5]) {
        if (this.myChart) {
          // console.log('resize:' + this.activeTab)
          // width or height を auto や % 指定している場合は必須
          this.myChart.resize();
        }
      }
    },
    autoReload: function autoReload() {
      var _this2 = this;

      // 自動リロードの有効化
      if (this.autoReload === true) {
        this.setIntervalId = setInterval(function () {
          _this2.jumpToRecent();
        }, 2000);
      } else {
        clearInterval(this.setIntervalId);
      }
    }
  },

  created: function created() {
    // console.log('created')

    // 直近からグラフ描画のレンジを設定しておく
    var now = Math.floor(Date.now() / 1000);
    now = now - now % this.periodTime;
    this.range.start = now - this.periodTime * 12;
    this.range.end = now;

    this.prevRange = this.range;

    this.graph = new __WEBPACK_IMPORTED_MODULE_2__utils_graph_js__["a" /* default */]({
      token: 'MyToken'
    });
  },
  mounted: function mounted() {
    // console.log('mounted')

    var self = this;

    // ウィンドウのリサイズイベントのハンドラ登録
    window.addEventListener('resize', self.onResize);

    // Echartsインスタンス生成
    self.myChart = __WEBPACK_IMPORTED_MODULE_1_echarts___default.a.init(document.getElementById(self.myChartId));
    // Echartsオプション初期化
    self.initializeChartOption();

    // datazoom イベントのハンドラを設定
    self.myChart.on('datazoom', function (event) {
      var axis = self.myChart.getModel().option.xAxis[0];
      // 現在描画されているレンジのインデックスを取得
      var start = axis.rangeStart === null || axis.rangeStart < 0 ? 0 : axis.rangeStart;
      var end = axis.rangeEnd === null || axis.rangeEnd >= axis.data.length ? axis.data.length - 1 : axis.rangeEnd;
      // 現在描画されているレンジの値を保存
      self.prevRange = self.range;
      // 現在描画されているレンジの値を設定
      self.range = {
        start: axis.data[start],
        end: axis.data[end]
      };
      if (self.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
        self.isDataZoom = event.batch !== undefined;
        // 履歴の先頭に戻った場合はレンジをズームした時点に戻す
        if (event.batch !== undefined) {
          var ecToolBox = self.myChart.getModel()._componentsMap._ec_toolbox;
          var ecToolBoxModel = ecToolBox[0].ecModel;
          if (ecToolBoxModel['\0_ec_hist_store'].length === 2 && self.firstZoomRange === null) {
            self.firstZoomRange = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.prevRange));
          } else if (ecToolBoxModel['\0_ec_hist_store'].length === 1 && self.firstZoomRange !== null) {
            self.range = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.firstZoomRange));
            self.firstZoomRange = null;
          }
        }
      }

      // console.log([
      //   new Date(self.range.start * 1000),
      //   new Date(self.range.end * 1000)
      // ])
      // console.log([
      //   new Date(self.prevRange.start * 1000),
      //   new Date(self.prevRange.end * 1000)
      // ])
      self.isChangedRangeBar = true;
      // レンジバーの幅の変更があったかどうか
      self.isChangeRangeBarWidth = self.isChangeRangeBarWidth || self.range.end - self.range.start !== self.prevRange.end - self.prevRange.start;
      if (start === 0 && self.range.start !== self.prevRange.start) {
        // 先頭に達した場合はグラフのデータをロードする
        self.reload();
      } else if (start === 0 && self.range.start === self.prevRange.start && self.outOfFromTimestamp !== null) {
        // 先頭に達した場合はグラフのデータをロードする
        var rangeOffset = Math.floor(self.rangeDiff / 2);
        self.range = {
          start: self.range.start - rangeOffset,
          end: self.range.end - rangeOffset
        };
        self.reload();
      } else if (end === axis.data.length - 1 && self.range.end !== self.prevRange.end) {
        // 末尾に達した場合はグラフ外のデータをロードする
        self.reload();
      } else {
        // 先頭と末尾を再描画
        var option = {
          xAxis: [],
          series: [],
          dataZoom: [{
            // API呼び出し前にセットしていたレンジを再設定
            startValue: self.range.start.toString(),
            endValue: self.range.end.toString()
          }]
        };
        option = self.fillPlotStartEnd(option);
        setTimeout(function () {
          self.myChart.setOption(option);
        }, 0);
        self.setDisableJump(self.range);
      }
    });

    // クリックイベントハンドラを設定
    // クリックした場合は日付選択フォームを更新する
    self.myChart.on('click', function (event) {
      // event.nameは選択した日時のUNIXタイムスタンプを示す
      self.toDatetimeUnixTime = Number(event.name);
      self.$refs.graphDateSelect.changeSelectDateTime(self.toDatetimeUnixTime);
    });

    // 初回データロード時は最新表示
    this.$refs.graphDateSelect.jumpToRecent();
  },
  beforeDestroy: function beforeDestroy() {
    // ウィンドウのリサイズイベントのハンドラ登録を解除
    window.removeEventListener('resize', this.onResize);
    // EChartsインスタンス破棄
    this.myChart = null;
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LeakageLog_vue__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LeakageLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_LeakageLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FlowLogChart_vue__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FlowLogChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_FlowLogChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_RoRateLogChart_vue__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_RoRateLogChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_RoRateLogChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TemperatureLogChart_vue__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TemperatureLogChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_TemperatureLogChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_WaterPressureLogChart_vue__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_WaterPressureLogChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_WaterPressureLogChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ServiceSettingDialog_vue__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ServiceSettingDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ServiceSettingDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DeviceEditDialog_vue__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DeviceEditDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_DeviceEditDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemDeleteDialog_vue__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemDeleteDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_WaterSystemDeleteDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_CsvDownloadDialog_vue__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_CsvDownloadDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_CsvDownloadDialog_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeakageLog: __WEBPACK_IMPORTED_MODULE_6__components_LeakageLog_vue___default.a,
    FlowLogChart: __WEBPACK_IMPORTED_MODULE_7__components_FlowLogChart_vue___default.a,
    RoRateLogChart: __WEBPACK_IMPORTED_MODULE_8__components_RoRateLogChart_vue___default.a,
    TemperatureLogChart: __WEBPACK_IMPORTED_MODULE_9__components_TemperatureLogChart_vue___default.a,
    WaterPressureLogChart: __WEBPACK_IMPORTED_MODULE_10__components_WaterPressureLogChart_vue___default.a,
    ServiceSettingDialog: __WEBPACK_IMPORTED_MODULE_11__components_ServiceSettingDialog_vue___default.a,
    DeviceEditDialog: __WEBPACK_IMPORTED_MODULE_12__components_DeviceEditDialog_vue___default.a,
    WaterSystemDeleteDialog: __WEBPACK_IMPORTED_MODULE_13__components_WaterSystemDeleteDialog_vue___default.a,
    CsvDownloadDialog: __WEBPACK_IMPORTED_MODULE_14__components_CsvDownloadDialog_vue___default.a
  },
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Root,
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].role.Viewer,
      filtrationSystemId: null,
      location: {},
      filtrationSystem: {},
      filter: null, // TODO フィルタが１個しか付いていない前提での実装になっている。複数フィルタに対応するには実装の変更が必要。
      history: [],
      localTimezone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess(),
      locationTimezone: 'UTC',
      locale: this.$store.getters.locale,
      unit: this.$store.getters.settingParams.unit,
      pressureUnit: this.$store.getters.settingParams.pressureUnit,
      temperatureUnit: this.$store.getters.settingParams.temperatureUnit,
      currentTab: 0,
      activeTab: null,
      serviceCodes: this.$store.getters.serviceList.codes,
      serviceNames: this.$store.getters.serviceList.longNames,
      sidebarSummaries: [],
      // メタデータ格納
      flowAndTimeMeta: null,
      failMessage: '',
      showForm: true,
      showResetDialog: false,
      selectEditPort: null, // 現在選ばれているポート番号
      selectLeakageEditPort: null,
      selectTemperatureEditPort: null,
      editData: [], // 閾値やフィルタシステムごとの設定値を変更する用途で使用する
      temperatureSettingBtnDisabled: true,
      pressSettingBtnDisabled: true,
      frowSettingBtnDisabled: true,
      roSettingBtnDisabled: true,
      earliestLogInfo: {},
      isRoot: false,
      filterResetDoBtnName: this.$t('watersystem.filter-reset-do') // フィルターチェンジボタン名
    };
  },

  methods: {
    init: function init(filtrationSystemId) {
      this.setExecBtnProperty(); // 保存ボタンの属性をセット
      if (filtrationSystemId) {
        this.filtrationSystemId = filtrationSystemId;
        this.getFiltrationSystem(true);
        this.getHistory();
        this.getEarlistLog();
        __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.locale(this.locale);
        // this.updateFlowAvg()
      } else {
        // 親のwatersystem_list契機じゃない場合でもpathにあれば開いてみる
        // 開発用の画面(/watersystem/:id)への対応の意味もある
        if (this.$route.params.id) {
          this.filtrationSystemId = this.$route.params.id;
          this.getFiltrationSystem(true);
          this.getHistory();
          this.getEarlistLog();
          __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.locale(this.locale);
          // this.updateFlowAvg()
        }
      }
    },
    updateFlowAvg: function updateFlowAvg() {
      var params = {
        'filtrationSystemId': this.filtrationSystemId
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service/dashboard/api/filtration_systems/updateFlowAvg', params).then(function (response) {
        var data = response.data;
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Flow Avarage failed. (' + data.result + ')');
          return;
        } else if (data.status === 304) {
          console.log('Flow Avarage doesn\'t need update. (' + data.status + ')');
          return;
        }
        console.log('Flow Avarage has been updated now.(' + data.status + ')');
        return;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('avg update error', error);
      });
    },

    // TODO:updateConfig () 使用箇所なし HARPS-874で対応
    updateConfig: function updateConfig() {
      var _this = this;

      // 全体のバリデーションを行う
      if (!this.$refs.settingForm.validate()) {
        // NG
        return;
      }
      // 入力値を反映する
      this.updateEditData();
      var params = {
        'filtrationSystemId': this.filtrationSystemId,
        'filtrationSystemName': this.filtrationSystem.filtrationSystemName,
        'plugins': this.editData.plugins,
        'services': this.editData.services
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystems/updateConfig', params).then(function (response) {
        var data = response.data;
        if (data.result < 0) {
          // TODO エラー処理
          console.log('update Config Avarage failed. (' + data.result + ')');
          // フォームを閉じる
          _this.closeSettingDialog(false);
          return;
        } else if (data.status === 304) {
          console.log('Config Avarage doesn\'t need update. (' + data.status + ')');
          // フォームを閉じる
          _this.closeSettingDialog(false);
          return;
        }
        // フォームを閉じる（成功）
        _this.closeSettingDialog(true);
        return;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('Config update error', error);
        // フォームを閉じる
        _this.closeSettingDialog(false);
      });
    },
    getFiltrationSystem: function getFiltrationSystem() {
      var _this2 = this;

      var initFlg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/FiltrationSystems/getDetail/' + this.filtrationSystemId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get filtration system data failed. (' + data.result + ')');
          _this2.filtrationSystem = {};
          _this2.failMessage = 'Failed to get Divice Information.';
          return;
        }
        if (data.device.services.length === 0) {
          console.log('Filtration system is not available.');
          _this2.filtrationSystem = {};
          _this2.failMessage = 'Filtration system is not available.';
          return;
        }

        _this2.location = data.location;
        _this2.locationTimezone = data.location.timezoneIdentifier;
        // マルチポート対応のサービスはそのままのServicesを使うと表示がうまくできないためデータをまとめる
        data.device.dispServices = _this2.dispServicesAdd(data.device);
        _this2.filtrationSystem = data.device;

        // サービスごとにMetadataのセット
        if (_this2.filtrationSystem) {
          _this2.filtrationSystem.dispServices.forEach(function (service) {
            switch (service.serviceId) {
              case 1:
                // プレビュー版の名残りでfilterから交換時期等を取ってくる
                _this2.filter = service.filters[0];
                _this2.setFlowAndTimeMetadata();
                break;
            }
          });

          // 直前までアクティブだったタブのサービスを含まない場合
          _this2.$nextTick(function () {
            if (!_this2.hasService(_this2.activeTab) && _this2.activeTab !== 'HISTORY') {
              console.log('Change activeTab to: ' + _this2.serviceCodes[_this2.filtrationSystem.dispServices[0].serviceId]);
              _this2.activeTab = _this2.serviceCodes[_this2.filtrationSystem.dispServices[0].serviceId];
            }
          });
          // 表示デバイスの切り替えの場合はポートを初期化
          if (initFlg === true) {
            _this2.setDefaultDispPort(_this2.filtrationSystem.dispServices);
          }
        }
        // 親のmap関数の発火
        if (_this2.location.latitude !== null && _this2.location.longitude !== null) {
          _this2.$emit('child-action', _this2.location.latitude, _this2.location.longitude);
        }
      }).catch(function (error) {
        // TODO エラー処理
        _this2.failMessage = 'Failed to get Divice Information.';
        console.log('error', error);
      });
    },
    getEarlistLog: function getEarlistLog() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/FiltrationSystems/getOldestLog/' + this.filtrationSystemId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get ealiest log failed. (' + data.result + ')');
          _this3.failMessage = 'Failed to get Earliest Log.';
          return;
        }
        // PHP-7移行時の事情で、同じController名に対する同じアクション名は使えない
        // ことになったので、Action名の変更に合わせてキー名をearliest -> oldestに変更した。
        // ただし、Dashboard全般に渡って修正すると修正量が多くなるので、
        // 下記で過去のキー名earliestTimestampに変更しているる
        var converted = {
          existsLogAllServices: data.existsLogAllServices,
          earliestTimestamp: data.oldestTimestamp,
          result: data.result
        };
        _this3.earliestLogInfo = converted;
      }).catch(function (error) {
        // TODO エラー処理
        _this3.failMessage = 'Failed to get Earliest Log.';
        console.log('error', error);
      });
    },
    emitEarliestTimestamp: function emitEarliestTimestamp(earliestTimestamp) {
      console.log('emitEarliestTimeStamp#0');
      if (!this.earliestLogInfo.existsLogAllServices) {
        console.log('emitEarliestTimeStamp#1');
        this.earliestLogInfo.existsLogAllServices = true;
        this.earliestLogInfo.earliestTimestamp = earliestTimestamp;
      } else {
        console.log('emitEarliestTimeStamp#2:' + this.earliestLogInfo.earliestTimestamp + ':' + earliestTimestamp);
        if (this.earliestLogInfo.earliestTimestamp > earliestTimestamp) {
          console.log('emitEarliestTimeStamp#3');
          this.earliestLogInfo.earliestTimestamp = earliestTimestamp;
        }
      }
      console.log('emitEarliestTimeStamp#9');
    },
    dispServicesAdd: function dispServicesAdd(data) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dispServicesAdd(data);
    },
    getSetting: function getSetting() {
      var _this4 = this;

      // 取得前にエディットの情報を初期化
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/FiltrationSystems/getConfig/' + this.filtrationSystemId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get filtration system data failed. (' + data.result + ')');
          _this4.failMessage = 'Failed to get Divice Information.';
          return;
        }
        if (data.services.length === 0) {
          console.log('Filtration system is not available.');
          _this4.failMessage = 'Filtration system is not available.';
          return;
        }
        // 更新に必要なデータを保持
        _this4.editData = data;
        // 各設定ボタンの無効を設定
        _this4.settingBtnsDisabled(_this4.editData.services);
      }).catch(function (error) {
        // TODO エラー処理
        _this4.failMessage = 'Failed to get Divice Information.';
        console.log('error', error);
      });
    },
    getHistory: function getHistory() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/FiltrationSystemLogs/history/' + this.$route.params.id).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get history data failed. (' + data.result + ')');
          return;
        }
        var shap = {
          'new': 0,
          'reset': 0,
          'flowsensor': 0,
          'iotizr': 0,
          'mail': 0
        };
        var result = [];
        data.history.forEach(function (recode) {
          if (shap[recode.type] < recode.eventTime) {
            shap[recode.type] = recode.eventTime;
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(shap).forEach(function (key) {
          if (shap[key] !== 0) {
            var push = {
              'type': key,
              'eventTime': shap[key]
            };
            result.unshift(push);
          }
        });
        _this5.history = result;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    resetFilter: function resetFilter() {
      var _this6 = this;

      // TODO filtrationSystemId, slotNumberはパラメータとして受け取るべき これではこのメソッドが this.filter に依存してしまっている
      var params = {
        'filtrationSystemId': this.$route.params.id,
        'slotNumber': this.filter.slotNumber
      };
      __WEBPACK_IMPORTED_MODULE_2__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystems/resetFiltrationSystemFilter', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('reset filter failed. (' + data.result + ')');
          return;
        }
        _this6.getFiltrationSystem();
        // console.log(data)
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    hasService: function hasService(serviceCode) {
      var _this7 = this;

      // 単純に表示しようとしているサービスがデバイス(システム)にあるか見る
      // idでtabを切り替えていても、前回開いたROが残ってしまったりする
      var matchSystem = this.filtrationSystem.services.filter(function (service) {
        return _this7.serviceCodes[service.serviceId] === serviceCode;
      });
      return matchSystem.length >= 1; // 1つでもあればtrue
    },
    setFlowAndTimeMetadata: function setFlowAndTimeMetadata() {
      // 寿命判断・パーセント格納
      var filterLifePercent = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].calcFilterLifePercent(this.filter);
      var flowPercent = filterLifePercent.flow;
      var timePercent = filterLifePercent.time;

      // 残存洗浄可能量のステータス判断
      var flowColor = 'blue';
      if (this.filter.warningLifeSpanFlow > 0 && this.filter.flow > this.filter.warningLifeSpanFlow) {
        flowColor = 'orange';
      }
      if (this.filter.maxLifeSpanFlow > 0 && this.filter.flow > this.filter.maxLifeSpanFlow) {
        flowColor = 'red';
      }

      // 残存洗浄可能量のフォーマット出力
      var left = Math.round(this.convertUnit(this.filter.flow) * 1000) / 1000;
      var max = Math.round(this.convertUnit(this.filter.maxLifeSpanFlow * 1000)) / 1000;
      var leftFlowFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(left, this.locale);
      var maxFlowFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(max, this.locale);
      var flowLifeLeft = leftFlowFormated + '/' + maxFlowFormated + this.$store.getters.unitLabel;

      // 経過時間のステータス判断
      var timeColor = 'blue';
      if (this.filter.warningLifeSpanTime > 0 && this.filter.time > this.filter.warningLifeSpanTime) {
        timeColor = 'orange';
      }
      if (this.filter.maxLifeSpanTime > 0 && this.filter.time > this.filter.maxLifeSpanTime) {
        timeColor = 'red';
      }

      if (timePercent > 100) {
        timePercent = 100;
      }

      // 経過時間のフォーマット出力
      var fromNow = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(this.filter.lastReplacementTime).diff(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()()); // ミリ秒
      var fromNowMonth = -fromNow / 60 / 60 / 24 / 30 / 1000; // ヶ月
      var maxLifeSpanMonth = this.filter.maxLifeSpanTime / 60 / 60 / 24 / 30 / 1000; // ヶ月
      var fromNowMonthRound = Math.round(fromNowMonth);
      var maxLifeSpanMonthRound = Math.round(maxLifeSpanMonth);
      // let timeContent = fromNowMonthRound + this.$t('watersystem.period-month') +
      //  ' / ' + maxLifeSpanMonthRound + this.$t('watersystem.period-month')

      this.flowAndTimeMeta = {
        // 残存洗浄可能量
        flowLifePercent: flowPercent,
        flowLifeLeft: flowLifeLeft,
        leftFlowFormated: leftFlowFormated,
        maxFlowFormated: maxFlowFormated,
        flowColor: flowColor,
        // 経過時間
        fromNowMonth: fromNowMonthRound,
        maxLifeMonth: maxLifeSpanMonthRound,
        timePercent: timePercent,
        timeColor: timeColor
      };
    },
    formatFlowLifeLeft: function formatFlowLifeLeft(flow, maxLifeSpanFlow) {
      var left = Math.round(this.convertUnit(flow) * 1000) / 1000;
      var max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000;
      var leftNumFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(left, this.locale);
      var maxNumFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(max, this.locale);
      return leftNumFormated + '/' + maxNumFormated + this.$store.getters.unitLabel;
    },
    nextReplacement: function nextReplacement(nextReplacementTime) {
      var options = { timeZone: this.selectedTimezone };
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, nextReplacementTime, options);
    },
    unixToDatetime: function unixToDatetime(unixTimestamp) {
      var options = {
        timeZone: this.selectedTimezone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      };
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dateFormatter(this.locale, unixTimestamp, options);
    },
    historyTitle: function historyTitle(type) {
      // new/reset/flowsensor/iotizr
      switch (type) {
        case 'new':
          return 'New Installation';
        case 'reset':
          return 'Filter replacement';
        case 'flowsensor':
          return 'Flowsensor replacement';
        case 'iotizr':
          return 'IoTIZR replacement';
        case 'mail':
          return 'Mail notification';
        default:
          return '';
      }
    },
    historyIcon: function historyIcon(type) {
      // new/reset/flowsensor/iotizr
      switch (type) {
        case 'new':
          return 'fa-link';
        case 'reset':
          return 'fa-refresh';
        case 'flowsensor':
          return 'fa-refresh';
        case 'iotizr':
          return 'fa-refresh';
        case 'mail':
          return 'fa-envelope';
        default:
          return '';
      }
    },
    getClassNameTabInfoHeadlineNoDisp: function getClassNameTabInfoHeadlineNoDisp(service) {
      if (__WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getServiceStatusValue(service) === 0) {
        return '';
      }
      return 'tab-info-headline-no-disp';
    },
    getClassNameServiceStatus: function getClassNameServiceStatus(service) {
      return __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getCssClassForStatus(__WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getServiceStatusValue(service), '--text');
    },
    getClassNamePluginStatus: function getClassNamePluginStatus(detail) {
      var alertClass = 'red--text';
      var warningClass = 'orange--text';
      var goodClass = 'blue--text';
      switch (detail.status) {
        case 0:
          return goodClass;
        case 1:
          return warningClass;
        case 2:
          return alertClass;
        default:
          return goodClass;
      }
    },
    getServiceStatus: function getServiceStatus(service) {
      return __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getServiceStatusValue(service);
    },
    getPluginStatus: function getPluginStatus(detail) {
      return __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getPluginStatusValue(detail);
    },
    getHeadlineMsg: function getHeadlineMsg(serviceId, validationType, statusCode) {
      // statusCode 0:normal 1:warning 2:alert
      var msg = '';
      if (serviceId === 3) {
        if (validationType === 1) {
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-temperature-up-alert');
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-temperature-up-warning');
          }
        } else if (validationType === 2) {
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-temperature-down-alert');
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-temperature-down-warning');
          }
        }
      }
      if (serviceId === 4) {
        if (statusCode === 2) {
          msg = this.$t('watersystem.headline-leakage-alert');
        }
      }
      if (serviceId === 5) {
        if (validationType === 1) {
          // 差圧
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-diff-press-alert');
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-diff-press-warning');
          }
        } else {
          // 圧力値
          if (statusCode === 2) {
            msg = this.$t('watersystem.headline-press-alert');
          } else if (statusCode === 1) {
            msg = this.$t('watersystem.headline-press-warning');
          }
        }
      }
      return msg;
    },
    convertUnit: function convertUnit(flow) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertUnit(flow, this.unit);
    },
    convertSecondToMonth: function convertSecondToMonth(second) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertSecondToMonth(second);
    },
    convertPressureUnit: function convertPressureUnit(pressure) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertPressureUnit(pressure, this.pressureUnit);
    },
    convertTemperatureUnit: function convertTemperatureUnit(temperature) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].convertTemperatureUnit(temperature, this.temperatureUnit);
    },
    convertMaxLifeSpanFlow: function convertMaxLifeSpanFlow(maxLifeSpanFlow) {
      var max = Math.round(this.convertUnit(maxLifeSpanFlow * 1000)) / 1000;
      var maxNumFormated = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].numberFormatter(max, this.locale);
      return maxNumFormated;
    },
    openSettingDialog: function openSettingDialog(serviceId) {
      var params = this.createSettingDialogParams(serviceId);
      if (serviceId === 1) {
        params.selectEditPort = this.selectEditPort;
      } else if (serviceId === 2) {
        params.selectEditPort = this.selectLeakageEditPort;
      } else if (serviceId === 3) {
        params.selectEditPort = this.selectTemperatureEditPort;
      } else if (serviceId === 4) {
        params.selectEditPort = this.selectEditPort;
      } else if (serviceId === 5) {
        params.selectEditPort = this.selectEditPort;
      }
      console.log(params);
      this.$refs.childSettingDialog.openSettingDialog(params);
    },

    // 子フォームで使用するパラメータを作成
    createSettingDialogParams: function createSettingDialogParams(serviceId) {
      return {
        selectEditServiceId: serviceId,
        locationName: this.location.locationName,
        filtrationSystemName: this.filtrationSystem.filtrationSystemName,
        filtrationSystemId: this.filtrationSystemId,
        editData: this.editData
      };
    },
    settingBtnsDisabled: function settingBtnsDisabled(services) {
      for (var i = 0; i < services.length; i++) {
        this.settingBtnDisabled(services[i]);
      }
    },
    settingBtnDisabled: function settingBtnDisabled(service) {
      // TODO プリセット編集機能ができたら外す
      if (service.serviceId === 1) {
        if (service.params.presetId === null) {
          this.frowSettingBtnDisabled = false;
          return;
        }
      } else if (service.serviceId === 2) {
        if (service.params.roPresetId === null) {
          this.roSettingBtnDisabled = false;
          return;
        }
      } else if (service.serviceId === 3) {
        if (service.params.triggerParamId === null) {
          this.temperatureSettingBtnDisabled = false;
          return;
        }
      } else if (service.serviceId === 5) {
        if (service.params.triggerParamId === null) {
          this.pressSettingBtnDisabled = false;
          return;
        }
      }
    },
    setDefaultDispPort: function setDefaultDispPort(services) {
      // 圧力タブのデフォルト表示ポートを設定する
      for (var i = 0; i < services.length; i++) {
        if (services[i].serviceId === 5) {
          if (services[i].details.length > 0) {
            this.selectEditPort = services[i].details[0].portNumber;
            return;
          }
        } else if (services[i].serviceId === 4) {
          if (services[i].details.length > 0) {
            this.selectLeakageEditPort = services[i].details[0].portNumber;
            return;
          }
        } else if (services[i].serviceId === 3) {
          if (services[i].details.length > 0) {
            this.selectTemperatureEditPort = services[i].details[0].portNumber;
            return;
          }
        }
      }
    },
    openDeviceEditDialog: function openDeviceEditDialog() {
      var params = {
        'filtrationSystemId': this.filtrationSystemId
      };
      this.$refs.deviceEditDialog.startDialog(params);
    },
    showWaterSystemDeleteDialog: function showWaterSystemDeleteDialog(device) {
      this.$refs.waterSystemDeleteDialog.startDialog(device);
    },
    reloadWaterSystemList: function reloadWaterSystemList(filtrationSystemId) {
      this.$router.push('/watersystem_list/');
      this.$emit('delete-succeed', this.filtrationSystemId);
    },

    // 保存ボタンの属性をセットする
    setExecBtnProperty: function setExecBtnProperty() {
      this.isRoot = __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles); // ルートかどうかを判定
      if (this.isRoot) {
        this.filterResetDoBtnName = this.$t('aplix-use-only.btn.can-not-execute');
      }
    }
  },
  watch: {
    filtrationSystemId: function filtrationSystemId() {
      this.getSetting();
    }
  },
  computed: {
    selectedTimezone: function selectedTimezone() {
      if (this.$store.getters.settingParams.timezone === 'utc') {
        return 'UTC';
      } else if (this.$store.getters.settingParams.timezone === 'local') {
        return this.localTimezone;
      } else if (this.$store.getters.settingParams.timezone === 'location') {
        return this.locationTimezone;
      }
      return 'UTC';
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  // props: ['filtrationSystem'],
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Root,
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].role.Viewer,
      filtrationSystem: null,
      validated: false,
      confirmMessage: '',
      resultMessage: '',
      showDialog: false,
      showResultDialog: false,
      showMap: false,
      btnDisable: false,
      isRoot: false,
      deleteBtnName: this.$t('btn.delete') // 削除ボタン名
    };
  },

  watch: {},
  methods: {
    init: function init() {
      this.setExecBtnProperty();
    },
    startDialog: function startDialog(filtrationSystem) {
      this.filtrationSystem = filtrationSystem;
      this.errorMessage = '';
      this.confirmMessage = this.$t('watersystem.delete-water-system', [filtrationSystem.filtrationSystemName]);
      if (this.filtrationSystem.jm1UniqueId) {
        this.confirmMessage += '\n' + this.$t('watersystem.delete-water-system-with-iotizr');
      }
      this.confirmMessage += '\n\n' + this.$t('watersystem.delete-water-system-ask');
      this.showDialog = true;
    },
    deleteFiltrationSystem: function deleteFiltrationSystem() {
      var _this = this;

      this.btnDisable = true; // ボタン無効化
      var params = {
        filtrationSystemId: this.filtrationSystem.filtrationSystemId
      };
      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/FiltrationSystems/deleteFiltrationSystem', params).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('delete failed. (' + data.result + ')');
          _this.resultMessage = _this.$t('watersystem.error-delete');
          _this.btnDisable = false;
          _this.showResultDialog = true;
          _this.showDialog = false;
          return;
        }
        _this.$emit('delete-succeed', _this.filtrationSystem.filtrationSystemId);
        _this.resultMessage = _this.$t('watersystem.succeed-delete');
        _this.showResultDialog = true;
        _this.showDialog = false;
      }).catch(function (error) {
        console.log('error', error);
        _this.resultMessage = _this.$t('watersystem.error-delete');
        _this.showResultDialog = true;
        _this.btnDisable = false;
      });
    },

    // 保存ボタンの属性をセットする
    setExecBtnProperty: function setExecBtnProperty() {
      this.isRoot = __WEBPACK_IMPORTED_MODULE_2__utils_utils_js__["a" /* default */].isRoot(this.$store.getters.user.roles); // ルートかどうかを判定
      if (this.isRoot) {
        this.deleteBtnName = this.$t('aplix-use-only.btn.can-not-delete');
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WaterSystem_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WaterSystem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_WaterSystem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WaterSystemDeleteDialog_vue__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WaterSystemDeleteDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_WaterSystemDeleteDialog_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SystemList',
  components: {
    WaterSystem: __WEBPACK_IMPORTED_MODULE_6__components_WaterSystem_vue___default.a,
    WaterSystemDeleteDialog: __WEBPACK_IMPORTED_MODULE_7__components_WaterSystemDeleteDialog_vue___default.a
  },
  data: function data() {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      viewerRoleName: __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].role.Viewer,
      user: this.$store.getters.user, // ログインユーザ
      locations: [],
      devices: [],
      selectedFiltrationSystemId: null,
      expandedLocations: [],
      message: '',
      shortServiceNames: this.$store.getters.serviceList.shortNames,
      isShowWaterSystemSettingsMenu: false,

      // 表示形式が拠点リストかデバイスリストかどうか
      isCustomerFormat: this.$store.getters.isCustomerFormat,

      // ----- map -----
      mapName: 'map',
      map: null,
      zoom: 13,
      bounds: null,
      points: [],
      markers: [],
      firstStartup: true,
      callingShowPointData: false,

      // 表示切り替え用 デフォルト
      active: true,
      size: 'min',
      l_detail_bar_grabbed: false,
      HISTORY_style_bak: null,

      // ソート順
      defaultOrdersLocations: [{ key: 'organizationId', isAsc: true }, { key: 'locationId', isAsc: true }], // デフォルトソート順(設置拠点)
      defaultOrdersDevices: [{ key: 'filtrationSystemId', isAsc: true }], // デフォルトソート順(デバイス)
      ordersLocations: [], // デフォルトソート順(設置拠点)
      ordersDevices: [], // デフォルトソート順(デバイス)
      defaultLocations: [], // 初期表示のリスト(設置拠点)
      defaultDevices: [] // 初期表示のリスト(デバイス)
    };
  },

  computed: {
    showMap: function showMap() {
      return {
        'active': this.active
      };
    },
    currentSize: function currentSize() {
      return {
        'max': this.size === 'max',
        'mid': this.size === 'mid',
        'min': this.size === 'min',
        'none': this.size === 'none'
      };
    }
  },
  methods: {
    init: function init() {
      if (this.$route.params.id) {
        this.changeSize('max');
        this.$refs.filtrationSystem.init(this.$route.params.id);
        this.selectedFiltrationSystemId = this.$route.params.id;
      }
      this.initMap();
      if (this.isCustomerFormat) {
        this.getLocations();
      } else {
        this.getAllFiltrationSystems();
      }
    },

    // ステータスをソート用に変換
    convertStatusForSort: function convertStatusForSort(element) {
      var status = 0;
      if (this.isCustomerFormat) {
        // 設置拠点.ステータスの昇順ならred、orange、blueの順
        var locationElement = element;
        status = locationElement.locationStatus;
      } else {
        // デバイス.ステータスの昇順ならstatusがred、orange、blueの順
        var filtrationSystem = element;
        status = __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getFiltrationSystemStatusValue(filtrationSystem);
      }
      switch (status) {
        case 2:
          // alert
          return 0;
        case 1:
          // warning
          return 1;
        case 0: // good
        default:
          return 2;
      }
    },

    // 位置情報をソート用に変換
    convertMapInfoForSort: function convertMapInfoForSort(locationElement) {
      // 設置拠点.位置情報の昇順なら位置情報あり、位置情報なしの順
      return locationElement.latitude !== null && locationElement.longitude !== 0 ? 0 : 1;
    },

    // ソート用比較 共通
    comparateCommon: function comparateCommon(a, b) {
      var isAsc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var comparatedLessA = -1;
      var comparatedLessB = 1;
      if (!isAsc) {
        comparatedLessA = 1;
        comparatedLessB = -1;
      }
      var comparated = 0;
      if (a < b) {
        comparated = comparatedLessA;
      } else if (b < a) {
        comparated = comparatedLessB;
      }
      return comparated;
    },

    // 指定されたソート順(フィールド名、昇順/降順指定)で比較
    comparateForSort: function comparateForSort(a, b, sortOrder) {
      var comparated = 0;
      // console.info([a, b])
      // サービス、設置拠点、デバイス数の場合はサービス、デバイス数でソート
      var countBySortKeys = ['services', 'devices', 'dispServices'];
      if (sortOrder.key === 'status') {
        // ステータスの場合はステータスをソート用に変換して比較
        comparated = this.comparateCommon(this.convertStatusForSort(a), this.convertStatusForSort(b), sortOrder.isAsc);
      } else if (sortOrder.key === 'mapinfo') {
        // 位置情報の場合は位置情報をソート用に変換して比較
        comparated = this.comparateCommon(this.convertMapInfoForSort(a), this.convertMapInfoForSort(b), sortOrder.isAsc);
      } else if (countBySortKeys.indexOf(sortOrder.key) > -1) {
        // サービス、設置拠点、デバイス数の場合はサービス数、デバイス数でソート(初回クリック時は降順、2回目クリック時は昇順)
        comparated = this.comparateCommon(a[sortOrder.key].length, b[sortOrder.key].length, sortOrder.isAsc);
      } else if (sortOrder.key === 'servicesName') {
        // 設置拠点.サービス名のソートの場合は設置拠点.サービスIDの順でソート
        comparated = this.comparateCommon(a.services.join(' '), b.services.join(' '), sortOrder.isAsc);
      } else if (sortOrder.key === 'dispServicesName') {
        // デバイス.サービス名のソートの場合は設置拠点.表示用サービス.サービスIDの順でソート
        comparated = this.comparateCommon(a.dispServices.map(function (service) {
          return service.serviceId;
        }).join(' '), b.dispServices.map(function (service) {
          return service.serviceId;
        }).join(' '), sortOrder.isAsc);
      } else {
        // 指定された順でソート(小文字変換後に比較後、元の値で比較)
        if (typeof a[sortOrder.key] === 'string') {
          comparated = this.comparateCommon(a[sortOrder.key].toLowerCase(), b[sortOrder.key].toLowerCase(), sortOrder.isAsc);
        }
        if (comparated === 0) {
          comparated = this.comparateCommon(a[sortOrder.key], b[sortOrder.key], sortOrder.isAsc);
        }
      }
      // console.info(sortOrder.key, [a[sortOrder.key], b[sortOrder.key]])
      return comparated;
    },

    // ソート実施
    sortBySortOrder: function sortBySortOrder(list, sortOrders) {
      var _this = this;

      list.sort(function (a, b) {
        var comparated = 0;
        sortOrders.some(function (sortOrder, index) {
          comparated = _this.comparateForSort(a, b, sortOrder);
          if (comparated !== 0) {
            return true;
          }
        });
        return comparated;
      });
      return list;
    },

    // ソート順に合わせた矢印を導出
    computeArrowSortOrder: function computeArrowSortOrder(key, sortOrders) {
      var existsSortOrderIndex = sortOrders.slice().map(function (sortOrder) {
        return sortOrder.key;
      }).indexOf(key);
      if (existsSortOrderIndex === -1) {
        return '';
      }
      if (sortOrders[existsSortOrderIndex].isAsc) {
        return 'arrow_upward';
      } else {
        return 'arrow_downward';
      }
    },

    // クリックしたらソート順をトグルし、ソートする
    toggleSortOrder: function toggleSortOrder(key, sortOrders, defaultOrders, list) {
      var _this2 = this;

      var existsSortOrderIndex = sortOrders.slice().map(function (sortOrder) {
        return sortOrder.key;
      }).indexOf(key);
      var existsSortOrder = null;
      if (existsSortOrderIndex > -1) {
        existsSortOrder = sortOrders[existsSortOrderIndex];
      }
      // サービス、設置拠点.デバイスの場合は初回クリック時は降順
      var firstClickDescKeys = ['services', 'devices', 'dispServices'];
      if (existsSortOrder === null) {
        // ソートキーは１つまで(拡張要件があれば削除)
        if (sortOrders.length > 0) {
          sortOrders.splice(0, 1);
        }
        // サービス、設置拠点.デバイスの場合は初回クリック時は降順
        sortOrders.push({ key: key, isAsc: firstClickDescKeys.indexOf(key) === -1 });
      } else if (existsSortOrder.isAsc && firstClickDescKeys.indexOf(key) === -1) {
        // サービス、設置拠点.デバイス以外の場合、2回目クリック時は降順
        sortOrders[existsSortOrderIndex].isAsc = false;
      } else if (!existsSortOrder.isAsc && firstClickDescKeys.indexOf(key) > -1) {
        // サービス、設置拠点.デバイスの場合、2回目クリック時は昇順
        sortOrders[existsSortOrderIndex].isAsc = true;
      } else {
        // 3回目クリック時はデフォルトソート
        sortOrders.splice(existsSortOrderIndex, 1);
      }

      // 画面上で選択されたソート順を元に実際にソートする順序を作成
      var sortOrdersReal = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sortOrders));
      if (this.isCustomerFormat && key === 'services' && sortOrders.length > 0) {
        // 設置拠点.サービスを選択した場合はサービス名の昇順ソートをサービス数の次のソート順として指定
        existsSortOrderIndex = sortOrdersReal.slice().map(function (sortOrder) {
          return sortOrder.key;
        }).indexOf(key);
        sortOrdersReal.splice(existsSortOrderIndex + 1, 0, { key: 'servicesName', isAsc: true });
      } else if (!this.isCustomerFormat && key === 'dispServices' && sortOrders.length > 0) {
        // デバイス.サービスを選択した場合はサービス名の昇順ソートをサービス数の次のソート順として指定
        existsSortOrderIndex = sortOrdersReal.slice().map(function (sortOrder) {
          return sortOrder.key;
        }).indexOf(key);
        sortOrdersReal.splice(existsSortOrderIndex + 1, 0, { key: 'dispServicesName', isAsc: true });
      }
      // デフォルトソート順を末尾に追加
      sortOrdersReal = sortOrdersReal.concat(defaultOrders);

      // ソート実施
      if (this.isCustomerFormat) {
        // 開いていたデバイス表示は一旦全部閉じる
        this.$refs.customerExpands.forEach(function (expand) {
          expand.isActive = false;
        });
        if (sortOrders.length === 0) {
          this.locations = this.dispServicesAdds(this.deepCopyJson(this.defaultLocations));
        } else {
          this.locations = this.sortBySortOrder(list, sortOrdersReal);
        }
        // 開いていたデバイス表示を再び開く
        this.locations.forEach(function (locationEle, index) {
          var expandedIndex = _this2.expandedLocations.indexOf(locationEle.locationId);
          if (expandedIndex > -1) {
            if (locationEle.filtrationSystems === undefined) {
              _this2.getEachFiltrationSystems(locationEle.locationId, index);
            }
            _this2.$refs.customerExpands[index].isActive = true;
          } else {
            _this2.$refs.customerExpands[index].isActive = false;
          }
        }, this);
      } else {
        if (sortOrders.length === 0) {
          this.devices = this.dispServicesAdds(this.deepCopyJson(this.defaultDevices));
        } else {
          this.devices = this.sortBySortOrder(list, sortOrdersReal);
        }
      }
      console.log({ orders: sortOrders, real: sortOrdersReal, default: defaultOrders });
    },
    deepCopyJson: function deepCopyJson(o) {
      var cache = [];
      var copyO = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(o, function (key, value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Duplicate reference found
            try {
              // If this value does not reference a parent it can be deduped
              return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
            } catch (error) {
              // discard key if value cannot be deduped
              return;
            }
          }
          // Store value in our collection
          cache.push(value);
        }
        return value;
      }));
      cache = null;
      return copyO;
    },
    getLocations: function getLocations() {
      var _this3 = this;

      this.expandedLocations = [];
      this.ordersLocations = [];
      this.ordersDevices = [];
      this.defaultLocations = [];
      this.defaultDevices = [];

      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Organizations/locationList').then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location data failed. (' + data.result + ')');
          return;
        }
        _this3.locations = _this3.sortBySortOrder(data.locations, _this3.defaultOrdersLocations);
        _this3.defaultLocations = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.locations));
        _this3.dataTotal = data.locations.length;
        if (_this3.dataTotal === 0) _this3.message = 'It seems there is no customer. please add';

        _this3.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'customer');
        _this3.isCustomerFormat = true;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getAllFiltrationSystems: function getAllFiltrationSystems() {
      var _this4 = this;

      this.expandedLocations = [];
      this.ordersLocations = [];
      this.ordersDevices = [];
      this.defaultLocations = [];
      this.defaultDevices = [];

      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/organizations/filtrationSystemList', { needReplace: false }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get all filtration systems failed. (' + data.result + ')');
          return;
        }
        _this4.devices = _this4.sortBySortOrder(_this4.dispServicesAdds(data.filtrationSystems), _this4.defaultOrdersDevices);
        _this4.defaultDevices = _this4.deepCopyJson(data.filtrationSystems);
        if (_this4.devices.length === 0) _this4.message = 'It seems there is no devices. please install with IoTIZR.';

        _this4.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'device');
        _this4.isCustomerFormat = false;
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    getEachFiltrationSystems: function getEachFiltrationSystems(locationId, key) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('get', '/service2/dashboard/api/Locations/getDetail/' + locationId).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          // TODO エラー処理
          console.log('get location data failed. (' + data.result + ')');
          return;
        }
        var filtrationSystems = _this5.sortBySortOrder(_this5.dispServicesAdds(data.devices), _this5.defaultOrdersDevices);
        // 該当ロケーションに浄水システムの一覧情報を追加。
        _this5.$set(_this5.locations[key], 'filtrationSystems', filtrationSystems);
        var isExpandedRow = _this5.$refs.customerExpands[key].isActive;
        if (isExpandedRow && filtrationSystems.length > 0) {
          var expandedIndex = _this5.expandedLocations.indexOf(locationId);
          if (expandedIndex === -1) {
            _this5.expandedLocations.push(locationId);
          }
        } else {
          var _expandedIndex = _this5.expandedLocations.indexOf(locationId);
          if (_expandedIndex > -1) {
            _this5.expandedLocations.splice(_expandedIndex, 1);
          }
        }
        if (filtrationSystems.length === 0) {
          _this5.$refs.customerExpands[key].isActive = false;
        }
      }).catch(function (error) {
        // TODO エラー処理
        console.log('error', error);
      });
    },
    showFiltrationSystem: function showFiltrationSystem(filtrationSystemId) {
      if (this.isShowWaterSystemSettingsMenu) {
        this.isShowWaterSystemSettingsMenu = false;
        return;
      }
      if (this.size != 'mid') {
        this.changeSize('mid');
      }
      this.$router.push('/watersystem_list/' + filtrationSystemId);
      this.selectedFiltrationSystemId = filtrationSystemId;
      this.$refs.filtrationSystem.init(filtrationSystemId);
    },
    statusCheck: function statusCheck(filtrationSystem) {
      // サービス総じてのステータスのチェックを行う （本来はサーバでやったほうが良さそう）
      var status = __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getFiltrationSystemStatusValue(filtrationSystem);

      // filtrationSystemのプロパティに追加する（そうしないとDOMに反映されない）
      this.$set(filtrationSystem, 'status', status);
      this.$set(filtrationSystem, 'statusCssClass', __WEBPACK_IMPORTED_MODULE_5__utils_statuscheck_js__["a" /* default */].getCssClassForStatus(status, '--text'));
      return;
    },
    statusCheckService: function statusCheckService(service) {
      var alert = 'red';
      var warning = 'orange';
      var good = 'blue';
      switch (service.status) {
        case 0:
          return good;
        case 1:
          return warning;
        case 2:
          return alert;
        default:
          return good;
      }
    },
    dispServicesAdds: function dispServicesAdds(data) {
      return __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].dispServicesAdds(data);
    },
    initMap: function initMap() {
      var self = this;
      /* eslint-disable no-new */
      /* global google */
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        center: new google.maps.LatLng(51.4768467, -0.0005284),
        zoom: 13,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      });

      google.maps.event.addListener(this.map, 'idle', function () {
        self.zoom = self.map.getZoom();
        self.bounds = self.map.getBounds();
        // console.log('idle')
        self.showPointData();
      });

      google.maps.event.addListener(this.map, 'dragend', function () {
        self.bounds = self.map.getBounds();
        // console.log('dragend')
        self.showPointData();
      });

      // 一番最初に地図を表示した時の初期化
      google.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
        self.bounds = self.map.getBounds();
        // console.log('bounds_changed')
        self.showPointData();
      });
    },

    // ----- map ------------------------------
    showPointData: function showPointData() {
      var _this6 = this;

      if (!this.callingShowPointData) {
        this.callingShowPointData = true;
        __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/locations/points', {
          zoom: this.zoomRounded(),
          northEastLat: this.bounds.getNorthEast().lat(),
          northEastLng: this.bounds.getNorthEast().lng(),
          southWestLat: this.bounds.getSouthWest().lat(),
          southWestLng: this.bounds.getSouthWest().lng()
        }).then(function (response) {
          var data = response.data;
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get account data failed. (' + data.result + ')');
            _this6.callingShowPointData = false;
            return;
          }
          _this6.points = data.locations;
          _this6.createMarker(data.locations);
          if (_this6.firstStartup) {
            if (data.locations.length > 0) {
              _this6.centerMapLocation(data.locations[0].latitude, data.locations[0].longitude);
            }
            _this6.firstStartup = false;
          }
          _this6.callingShowPointData = false;
        }).catch(function (error) {
          // TODO エラー処理
          console.log('error', error);
          _this6.callingShowPointData = false;
        });
      }
    },
    createMarker: function createMarker(data) {
      var _this7 = this;

      var _loop = function _loop(i) {
        var one = data[i];
        var latlng = new google.maps.LatLng(one.latitude, one.longitude);
        var myMarker = void 0;
        // 既にmarkerがあれば使う、なければ新しく作る
        if (_this7.markers.length > i) {
          myMarker = _this7.markers[i];
          myMarker.listener.remove();
          myMarker.info.close();
        } else {
          myMarker = {
            marker: new google.maps.Marker(),
            info: null,
            listener: null
          };
          _this7.markers.push(myMarker);
        }
        myMarker.marker.setMap(_this7.map);
        // myMarker.marker.setLabel(one.locationId.toString())
        myMarker.marker.setPosition(latlng);
        myMarker.marker.setZIndex(i + 1);
        // console.log('locationName:' + one.locationName)
        myMarker.info = new google.maps.InfoWindow({
          content: one.locationName
        });
        myMarker.listener = myMarker.marker.addListener('click', function () {
          myMarker.info.open(_this7.map, myMarker.marker);
        });
      };

      // markerを表示する
      for (var i = 0; i < data.length; i++) {
        _loop(i);
      }
      // あまりのmarkerをクリア
      this.clearMarkers(data.length);
    },
    clearMarkers: function clearMarkers(currentCount) {
      // markerを閉じる domから削除される
      for (var i = currentCount; i < this.markers.length; i++) {
        this.markers[i].listener.remove();
        this.markers[i].info.close();
        this.markers[i].marker.setMap(null);
      }
      var count = this.markers.length;
      for (var _i = currentCount; _i < count; _i++) {
        // 微妙にiの増分とpopの削除方向は逆だが気にしないことにする。
        this.markers.pop();
      }
    },
    centerMapLocation: function centerMapLocation(latitude, longitude) {
      // console.log(latitude)
      this.map.setCenter(new google.maps.LatLng(latitude, longitude));
    },
    zoomRounded: function zoomRounded() {
      var zoom = 2;
      if (this.zoom >= 0 && this.zoom <= 9) {
        zoom = 1;
      } else if (this.zoom > 9 && this.zoom <= 13) {
        zoom = 2;
      } else if (this.zoom > 13 && this.zoom <= 16) {
        zoom = 3;
      } else if (this.zoom > 16) {
        zoom = 4;
      }
      return zoom;
    },
    showWaterSystemSettingsMenu: function showWaterSystemSettingsMenu() {
      this.isShowWaterSystemSettingsMenu = true;
    },
    showWaterSystemDeleteDialog: function showWaterSystemDeleteDialog(device) {
      this.$refs.waterSystemDeleteDialog.startDialog(device);
    },
    reloadWaterSystemList: function reloadWaterSystemList(filtrationSystemId) {
      this.$router.push('/watersystem_list/');
      if (this.isCustomerFormat) {
        // 開いていたデバイス表示は一旦全部閉じる
        this.$refs.customerExpands.forEach(function (expand) {
          expand.isActive = false;
        });
        this.getLocations();
      } else {
        this.getAllFiltrationSystems();
      }
      if (this.selectedFiltrationSystemId === filtrationSystemId) {
        this.selectedFiltrationSystemId = null;
        this.$refs.filtrationSystem.filtrationSystemId = null;
        this.$refs.filtrationSystem.filtrationSystem = {};
      }
    },

    // ----- /map ------------------------------

    // 表示領域変更用function
    mapToggle: function mapToggle() {
      this.active = !this.active;
    },
    changeSize: function changeSize(size) {
      this.size = size;

      if (__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].ie11()) {
        return;
      }
      $('.l-table-wrap')[0].style = null;
      $('.l-detail-wrap')[0].style = null;
      if (this.HISTORY_style_bak != null) {
        var HISTORY = document.getElementById("HISTORY");
        if (HISTORY != null) {
          HISTORY.style.cssText = this.HISTORY_style_bak.cssText;
        }
      }
    },


    //// l_detail_bar_grab

    l_detail_bar_move: function l_detail_bar_move(clientY) {
      if (!this.l_detail_bar_grabbed) {
        return;
      }
      var Adjust = 90;
      if (clientY - Adjust < 90) {
        // ヘッダ部の下に潜らないよう止める
        return;
      }
      //console.log('l_detail_bar_move ' + clientY)

      this.changeSize('mid');

      var l_table_wrap = $('.l-table-wrap')[0];
      var l_table_wrap_height = Math.max(clientY - Adjust, 0);
      l_table_wrap.style.height = l_table_wrap_height + 'px';
      l_table_wrap.style.overflowY = 'scroll';
      //console.log('l_table_wrap.style.height=' + l_table_wrap.style.height)

      var l_submain_height = $('.l-submain')[0].offsetHeight;
      var l_detail_wrap = $('.l-detail-wrap')[0];
      //console.log('l_submain.offsetHeight=' + l_submain_height)
      var l_detail_wrap_height = l_submain_height - l_table_wrap_height;
      l_detail_wrap.style.height = l_detail_wrap_height + 'px';

      var HISTORY = document.getElementById("HISTORY");
      if (HISTORY) {
        // CSS の l-submain.mid の 500 - 440 に合わせただけ。効果不明
        HISTORY.style.height = Math.max(l_detail_wrap_height - 60, 0) + 'px';
      }
    },
    l_submain_onMouseMove: function l_submain_onMouseMove(event) {
      this.l_detail_bar_move(event.clientY);
    },
    l_detail_bar_onMouseDown: function l_detail_bar_onMouseDown(event) {
      if (__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].ie11()) {
        return;
      }
      if (this.l_detail_bar_grabbed) {
        return;
      }
      this.l_detail_bar_grabbed = true;
      //console.log('onMouseDown' + 
      //  ' ' + event.clientX +
      //  ',' + event.clientY +
      //  ' l_detail_bar_grabbed=' + this.l_detail_bar_grabbed 
      //)

      if (this.HISTORY_style_bak == null) {
        var HISTORY = document.getElementById("HISTORY");
        if (HISTORY) {
          this.HISTORY_style_bak = HISTORY.style;
        }
      }

      var body = document.getElementsByTagName('body')[0];
      body.style['-webkit-touch-callout'] = 'none';
      body.style['-webkit-user-select'] = 'none';
      body.style['-khtml-user-select'] = 'none';
      body.style['-moz-user-select'] = 'none';
      body.style['-ms-user-select'] = 'none';
      body.style['user-select'] = 'none';
    },
    l_detail_bar_grab_release: function l_detail_bar_grab_release() {
      if (!this.l_detail_bar_grabbed) {
        return;
      }
      this.l_detail_bar_grabbed = false;
      //console.log('onMouseUp' + 
      //  ' ' + event.clientX +
      //  ',' + event.clientY + 
      //  ' l_detail_bar_grabbed=' + this.l_detail_bar_grabbed 
      //)

      var body = document.getElementsByTagName('body')[0];
      body.style['-webkit-touch-callout'] = 'auto';
      body.style['-webkit-user-select'] = 'auto';
      body.style['-khtml-user-select'] = 'auto';
      body.style['-moz-user-select'] = 'auto';
      body.style['-ms-user-select'] = 'auto';
      body.style['user-select'] = 'auto';
    },
    onMouseUp: function onMouseUp(event) {
      this.l_detail_bar_grab_release();
    },
    l_submain_onMouseLeave: function l_submain_onMouseLeave(event) {
      this.l_detail_bar_grab_release();
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_LoginFooter__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_LoginFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_LoginFooter__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint semi: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LoginFooter: __WEBPACK_IMPORTED_MODULE_2__pages_LoginFooter___default.a
  },
  data: function data() {
    var _this = this;

    return {
      activationFormValid: true,
      state: 'activate', // or 'complete'
      username: this.$route.query.username ? this.$route.query.username : '',
      password: this.$route.query.temppass ? this.$route.query.temppass : '',
      newPassword: '',
      passwordReinput: '',
      passwordVisible: true,
      newPasswordVisible: false,
      passwordReinputVisible: false,
      agree: false,
      cognitoErrorMsg: '',
      submitted: false, // submitフラグ
      // 追加
      name: '',
      usernameRules: [function (v) {
        return !!v || _this.$t('login.vali-username-blank');
      }],
      checkboxRules: [function (v) {
        return !!v || 'You must agree.';
      }],
      passwordRules: [function (v) {
        return !!v || _this.$t('resetpassword.vali-pass-blank');
      }, function (v) {
        return (/[0-9]+/.test(v) && /[a-z]+/.test(v) || _this.$t('resetpassword.vali-pass-number')
        );
      }, function (v) {
        return !/[¥ ]+/.test(v) || _this.$t('resetpassword.vali-pass-whitespace');
      }, function (v) {
        return v.length >= 8 || _this.$t('resetpassword.vali-pass-length');
      }],
      passwordReinputRules: [function (v) {
        return !!v || _this.$t('resetpassword.vali-pass-blank');
      }, function (v) {
        return _this.newPassword === v || _this.$t('user-params.password_reinput_differs');
      }]
      // ここまで
    };
  },

  methods: {
    activate: function activate() {
      this.submitted = true; // ボタン無効化
      this.clearErrorMessage();
      this.activate_created_by_aplix();
    },
    activate_created_by_aplix: function activate_created_by_aplix() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/accounts/activate', {
        username: this.username,
        password: this.password,
        newPassword: this.newPassword
      }).then(function (response) {
        var data = response.data;
        if (data.result !== 0) {
          var errstr = JSON.strigify(response);
          console.error(errstr);
          switch (data.result) {
            case -102:
              _this2.cognitoErrorMsg = _this2.$t('account.fail-username');
              break;
            default:
              _this2.cognitoErrorMsg = _this2.$t('cognitoError.UnknownError'); // + '\n(' + errstr + ')')
          }
        } else {
          // success
          _this2.state = 'complete';
        }
        _this2.submitted = false; // ボタン有効化
      }).catch(function (err) {
        var cognitoExceptionName = err['response']['data'];
        var cognitoError = _this2.$t('cognitoError.' + cognitoExceptionName);
        if (cognitoError === 'cognitoError.' + cognitoExceptionName) {
          cognitoError = _this2.$t('cognitoError.UnknownError');
        }
        _this2.cognitoErrorMsg = cognitoError;
        cognitoError += '\n(' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err) + ')';
        console.error(cognitoError);
        _this2.submitted = false; // ボタン有効化
      });
    },
    goToNext: function goToNext() {
      window.location.href = '/dashboard/';
    },
    termsUrl: function termsUrl() {
      return "https://www.harps4.com/terms.html";
    },
    privacyUrl: function privacyUrl() {
      return "https://www.harps4.com/privacy.html";
    },
    clearErrorMessage: function clearErrorMessage() {
      this.cognitoErrorMsg = '';
    },
    passwordReinputValidate: function passwordReinputValidate() {
      this.$refs.passwordReinput.validate();
    }
  },
  mounted: function mounted() {
    // TODO: セッションからトークンを拾うようにする（メモリだと別タブの場合リセットされない）
    this.$store.dispatch('logout').then(function () {
      console.log('logout');
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Topnav_vue__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Topnav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Topnav_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: {
    Topnav: __WEBPACK_IMPORTED_MODULE_0__components_Topnav_vue___default.a
  },
  data: function data() {
    return {
      message: ''
    };
  }
});

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_LoginFooter__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_LoginFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_LoginFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {
    LoginFooter: __WEBPACK_IMPORTED_MODULE_0__pages_LoginFooter___default.a
  },
  data: function data() {
    var _this = this;

    return {
      username: '',
      password: '',
      response: '',
      error: '',
      submitted: false, // submitフラグ
      name: '',
      passwordVisible: false,
      usernameRules: [function (v) {
        return !!v || _this.$t('login.vali-username-blank');
      }],
      passwordRules: [function (v) {
        return !!v || _this.$t('login.vali-password-blank');
      }]
    };
  },

  computed: {
    message: function message() {
      if (this.$store.getters.message !== null) {
        this.response = this.$store.getters.message.message;
        this.$store.commit('SET_MESSAGE', null);
      }
      return this.response;
    },
    isHarps4: function isHarps4() {
      return __WEBPACK_IMPORTED_MODULE_1__utils_utils__["a" /* default */].isHarps4();
    }
  },
  methods: {
    checkCreds: function checkCreds() {
      var _this2 = this;

      this.submitted = true; // ボタン無効化
      this.username = this.username.trim();
      var username = this.username,
          password = this.password;

      this.resetResponse();
      this.clearError();

      this.$store.dispatch('login', { username: username, password: password }) // ログイン
      .then(function () {
        return _this2.$store.dispatch('getme');
      }) // ログインユーザの情報を取得
      .then(function () {
        return _this2.$store.dispatch('getSettingParam');
      }) // 設定パラメータを取得
      .then(function () {
        return _this2.$router.push(_this2.$store.getters.startPage);
      }) // home へ遷移
      .catch(function (err) {
        _this2.submitted = false; // ボタン有効化
        console.error(err);
        if (err.code !== undefined) {
          console.error(err.code);
          if (err.code === 'NewPasswordRequired') {
            _this2.$router.push({
              name: 'Activate'
            });
          }
        }
        if (err.message) {
          if (err.code === 'UserNotFoundException' || err.code === 'NotAuthorizedException') {
            _this2.error = _this2.$t('login.incorrect');
          } else {
            _this2.error = err.message;
          }
        } else {
          _this2.error = err;
        }
      });
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    clearError: function clearError() {
      this.error = '';
    }
  }
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginFooter',
  data: function data() {
    return {
      copyright: ''
    };
  },

  methods: {
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__["a" /* default */].getDomainConfig();
      this.copyright = domainConfig.copyright;
    }
  },
  mounted: function mounted() {
    this.getDomainConfig();
  }
});

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page404',
  data: function data() {
    return {
      copyright: ''
    };
  },

  methods: {
    getDomainConfig: function getDomainConfig() {
      var domainConfig = __WEBPACK_IMPORTED_MODULE_0__utils_utils_js__["a" /* default */].getDomainConfig();
      this.copyright = domainConfig.copyright;
    }
  },
  mounted: function mounted() {
    this.getDomainConfig();
  }
});

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cognito_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_LoginFooter__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_LoginFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_LoginFooter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LoginFooter: __WEBPACK_IMPORTED_MODULE_1__pages_LoginFooter___default.a
  },
  data: function data() {
    var _this = this;

    return {
      resetpassword_valid: true,
      confirm_valid: true,
      passwordVisible: false,
      submitted: false, // submitフラグ
      state: 'reset_password', // or confirm
      username: '',
      confirmationCode: '',
      newPassword: '',
      confirmNewPassword: '',
      errorMessage: '',
      // 追加
      name: '',
      usernameRules: [function (v) {
        return !!v || _this.$t('login.vali-username-blank');
      }],
      codeRules: [function (v) {
        return !!v || _this.$t('resetpassword.vali-code-blank');
      }],
      passwordRules: [function (v) {
        return !!v || _this.$t('resetpassword.vali-pass-blank');
      }, function (v) {
        return (/[0-9]+/.test(v) && /[a-z]+/.test(v) || _this.$t('resetpassword.vali-pass-number')
        );
      }, function (v) {
        return v.length >= 8 || _this.$t('resetpassword.vali-pass-length');
      }]
      // ここまで
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      this.submitted = true; // ボタン無効化
      this.username = this.username.trim();
      this.clearErrorMessage();
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0__utils_cognito_js__["a" /* default */].forgotPassword(self.username).then(function () {
        self.state = 'confirm';
        self.submitted = false; // ボタン有効化
      }).catch(function (err) {
        self.errorMessage = err.message;
        self.submitted = false; // ボタン有効化
      });
    },
    confirmResetPassword: function confirmResetPassword() {
      this.submitted = true; // ボタン無効化
      this.clearErrorMessage();
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0__utils_cognito_js__["a" /* default */].confirmResetPassword(self.username, self.confirmationCode, self.newPassword).then(function () {
        alert('Success');
        self.submitted = false; // ボタン有効化
        window.location.href = '/dashboard/';
      }).catch(function (err) {
        self.errorMessage = err.message;
        self.submitted = false; // ボタン有効化
      });
    },
    resendConfirmationCode: function resendConfirmationCode() {
      var self = this;
      // 再送もこれでok
      __WEBPACK_IMPORTED_MODULE_0__utils_cognito_js__["a" /* default */].forgotPassword(self.username).then(function () {
        alert('Success');
      }).catch(function (err) {
        alert('Fail:' + err.message);
      });
    },
    clearErrorMessage: function clearErrorMessage() {
      this.errorMessage = '';
    }
  }
});

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_LoginFooter__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_LoginFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_LoginFooter__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */


//import axios from 'axios'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {
    LoginFooter: __WEBPACK_IMPORTED_MODULE_5__pages_LoginFooter___default.a
  },
  data: function data() {
    var _this = this;

    return {
      username: '',
      //      password: '',
      //      password_reinput: '',
      useremail: '',
      response: '',
      error: '',
      name: '',
      //      passwordVisible: false,
      agree: false,
      checkboxRules: [function (v) {
        return !!v || _this.$t('activate.you_need_to_agree');
      }],
      done: false,

      confirmDialog: false,
      okDialog: false,
      errorDialog: false,
      errorDialogMessage: "",

      sitekey: "",

      lang: navigator.language || navigator.userLanguage,
      window: window,
      validate: __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */]
    };
  },
  beforeMount: function beforeMount() {
    var ip = location.hostname.split('.');
    if (location.hostname.indexOf('localhost') == 0 || location.hostname.indexOf('stage-') == 0 || ip.length == 4 && ip[0] == 172 && 16 <= ip[1] && ip[1] <= 31) {
      console.log('use sitekey for localhost');
      this.sitekey = "6LfVd2gUAAAAAP_cqo5YLUfv3vB9ylQiMy8_hBmu";
    } else {
      // production
      this.sitekey = "6LfwEjkUAAAAAKSzEQWsaxxbT-7erZ3Yc4FWDdTC";
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_4__utils_utils_js__["a" /* default */].isHarps4()) {
      this.$router.push({
        name: 'Page404'
      });
      return;
    }

    // https://maketips.net/tip/61/example-integrate-recaptcha-with-vuejs
    var retry = 50;
    var func = function func() {
      if (!window.grecaptcha.render) {
        if (retry-- <= 0) {
          console.error('grecaptcha init wait failed');
        } else {
          console.log('retry');
          setTimeout(func, 0);
        }
        return;
      }
      var div_grecaptcha = $('.g-recaptcha')[0];
      window.grecaptcha.render(div_grecaptcha, {
        sitekey: _this2.sitekey,
        callback: _this2.submit,
        'error-callback': _this2.g_recaptchaError
      });
    };
    setTimeout(func, 0);
  },

  computed: {
    message: function message() {
      if (this.$store.getters.message !== null) {
        this.response = this.$store.getters.message.message;
        this.$store.commit('SET_MESSAGE', null);
      }
      return this.response;
    }
  },
  methods: {
    checkCreds: function checkCreds() {
      console.log('checkCreds');

      // validation
      var valid = this.$refs.signupForm.validate();
      if (!valid) {
        var errors = this.$refs.signupForm.getInputs().filter(function (input) {
          return input.errorBucket.length;
        });
        var errorMsg = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(errors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var validErrMsgs = _step.value;

            errorMsg += validErrMsgs.errorBucket[0] + "\n";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        alert(errorMsg);
        return;
      }

      this.username = this.username.trim();
      this.resetResponse();
      this.clearError();

      this.confirmDialog = true;
    },
    submit: function submit(g_recaptcha_response) {
      //console.log('submit ' + JSON.stringify(g_recaptcha_response))
      // reset しないと、一度 execute した widget は再度 execute しても何もしなくなる。
      window.grecaptcha.reset();

      this.signUp(g_recaptcha_response);
    },
    g_recaptchaError: function g_recaptchaError() {
      console.log('g_recaptchaError');
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    clearError: function clearError() {
      this.error = '';
    },
    signUp: function signUp(g_recaptcha_response) {
      var _this3 = this;

      var params = {
        username: this.username,
        useremail: this.useremail,
        g_recaptcha_response: g_recaptcha_response
      };
      __WEBPACK_IMPORTED_MODULE_3__utils_http_js__["a" /* default */].request('post', '/service2/dashboard/api/organizations/signup', params)
      //      axios({
      //        method: 'post', 
      //        url: '/service/dashboard/api/organizations/signup', 
      //        data: params})
      .then(function (response) {
        //console.log('then(response => ' + JSON.stringify(response) + ')')
        var data = response.data;
        if (data.result !== 0) {
          var errstr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);
          console.error(errstr);
          switch (data.result) {
            case -102:
              if (data.rawcode) {
                _this3.showErrorDialog(_this3.$t('cognitoError.' + data.rawcode));
              } else {
                _this3.showErrorDialog(_this3.$t('cognitoError.UnknownError'));
              }
              break;
            case -33:
              _this3.showErrorDialog(_this3.$t('account.vali-username-format') + '\n' + _this3.$t('account.vali-username-char'));
              break;
            default:
              _this3.showErrorDialog(_this3.$t('cognitoError.UnknownError') + '\n(' + errstr + ')');
          }
        } else {
          // success
          _this3.done = true;
          _this3.okDialog = true;
        }
      }).catch(function (err) {
        var errstr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err);
        console.log('catch(err) ' + errstr);
        // 想定外の場合は raw メッセージを出す
        _this3.showErrorDialog(_this3.$t('cognitoError.UnknownError') + '\n(' + errstr + ')');
      });
    },
    // signUp()

    signUpCompleted: function signUpCompleted() {
      this.okDialog = false;
      //      this.$router.push({
      //        name: 'Login'
      //      })
    },
    showErrorDialog: function showErrorDialog(message) {
      this.errorDialogMessage = message.replace('\n', '<br>');
      this.errorDialog = true;
    }
  }
});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




function httpHookInit() {
  var _this = this;

  // Intercept the request to make sure the token is injected into the header.
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    if (!window._httpGrovalHookEnabled) {
      return config;
    }
    config.headers['x-jm1service-auth'] = _this.$store.getters.token;
    return config;
  });
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    if (!window._httpGrovalHookEnabled) {
      window._httpGrovalHookEnabled = true;
      return response;
    }
    // console.log(
    //   'httpHookInit:axios.interceptors.response response=' + JSON.stringify(response))
    // console.log('store.getters=' + JSON.stringify(store.getters))
    // status code は 200 でもレスポンスの result が -401 ならログアウトする
    if (response.data.result === -401) {
      var user = _this.$store.getters.user;
      if (!user || !user.username) {
        // https://aplix.backlog.com/view/HARPS-301
        // username が無いのに他の情報が中途半端に残っているとトラブルの元なので消す
        _this.$store.dispatch('logout');
        return response;
      }
      var username = user.username;
      var refreshToken = _this.$store.getters.refreshToken;
      var originalRequest = response.config;
      if (!originalRequest._retry) {
        // 再帰侵入防止
        originalRequest._retry = true;
        // console.log('httpHookInit: -401 handling...dispatch refreshSession')
        return _this.$store.dispatch('refreshSession', { username: username, refreshToken: refreshToken }).then(function () {
          console.log('httpHookInit: -401 handling...dispatch refreshSession done try again');
          return __WEBPACK_IMPORTED_MODULE_1_axios___default()(response.config);
        }).catch(function (error) {
          console.log(error);
          _this.$store.dispatch('logout'); // ログアウト処理を呼び出す
          _this.$store.commit('SET_MESSAGE', {
            title: '',
            message: 'You need to login.',
            level: 'error'
          });
          _this.$router.push('/login'); // ログイン画面へ
        });
      } else {
        console.log('httpHookInit:_retry is true: continue');
      }
    }
    return response;
  }, function (error) {
    // エラー時の共通処理
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      // 403 は message をセットして、その先の動作は呼び出し元が扱う
      if (error.response.status === 403 && window._httpGrovalHookEnabled) {
        _this.$store.commit('SET_MESSAGE', {
          title: '',
          message: 'You don\'t have permissoin.',
          level: 'error'
        });
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    if (!window._httpGrovalHookEnabled) {
      window._httpGrovalHookEnabled = true;
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    window._httpGrovalHookEnabled = true;
    Vue.prototype.$httpHookInit = function () {
      return httpHookInit.apply(this);
    };
  }
});

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1110), __esModule: true };

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1115), __esModule: true };

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1118), __esModule: true };

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1119), __esModule: true };

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1103);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1162);
module.exports = __webpack_require__(61).RegExp.escape;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
__webpack_require__(1144);
module.exports = __webpack_require__(36).Array.from;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(242);
__webpack_require__(171);
module.exports = __webpack_require__(1143);


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1146);
module.exports = __webpack_require__(36).Number.isInteger;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1147);
module.exports = __webpack_require__(36).Object.assign;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1148);
var $Object = __webpack_require__(36).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1149);
module.exports = __webpack_require__(36).Object.keys;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(403);
__webpack_require__(171);
__webpack_require__(242);
__webpack_require__(1150);
__webpack_require__(1152);
__webpack_require__(1153);
module.exports = __webpack_require__(36).Promise;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1151);
__webpack_require__(403);
__webpack_require__(1154);
__webpack_require__(1155);
module.exports = __webpack_require__(36).Symbol;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
__webpack_require__(242);
module.exports = __webpack_require__(240).f('iterator');


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(111);
var toLength = __webpack_require__(237);
var toAbsoluteIndex = __webpack_require__(1142);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(72);
var createDesc = __webpack_require__(135);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(134);
var gOPS = __webpack_require__(233);
var pIE = __webpack_require__(167);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(132);
var call = __webpack_require__(392);
var isArrayIter = __webpack_require__(391);
var anObject = __webpack_require__(71);
var toLength = __webpack_require__(237);
var getIterFn = __webpack_require__(241);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(131);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(81);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(395);
var descriptor = __webpack_require__(135);
var setToStringTag = __webpack_require__(168);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(90)(IteratorPrototype, __webpack_require__(41)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(170)('meta');
var isObject = __webpack_require__(81);
var has = __webpack_require__(89);
var setDesc = __webpack_require__(72).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(110)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(40);
var macrotask = __webpack_require__(402).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(131)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(134);
var gOPS = __webpack_require__(233);
var pIE = __webpack_require__(167);
var toObject = __webpack_require__(169);
var IObject = __webpack_require__(390);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(110)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(72);
var anObject = __webpack_require__(71);
var getKeys = __webpack_require__(134);

module.exports = __webpack_require__(80) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(167);
var createDesc = __webpack_require__(135);
var toIObject = __webpack_require__(111);
var toPrimitive = __webpack_require__(238);
var has = __webpack_require__(89);
var IE8_DOM_DEFINE = __webpack_require__(389);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(80) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(111);
var gOPN = __webpack_require__(396).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(89);
var toObject = __webpack_require__(169);
var IE_PROTO = __webpack_require__(234)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(59);
var core = __webpack_require__(36);
var fails = __webpack_require__(110);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(90);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(40);
var core = __webpack_require__(36);
var dP = __webpack_require__(72);
var DESCRIPTORS = __webpack_require__(80);
var SPECIES = __webpack_require__(41)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(236);
var defined = __webpack_require__(229);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(236);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var get = __webpack_require__(241);
module.exports = __webpack_require__(36).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(132);
var $export = __webpack_require__(59);
var toObject = __webpack_require__(169);
var call = __webpack_require__(392);
var isArrayIter = __webpack_require__(391);
var toLength = __webpack_require__(237);
var createProperty = __webpack_require__(1123);
var getIterFn = __webpack_require__(241);

$export($export.S + $export.F * !__webpack_require__(394)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1120);
var step = __webpack_require__(1130);
var Iterators = __webpack_require__(133);
var toIObject = __webpack_require__(111);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(393)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(59);

$export($export.S, 'Number', { isInteger: __webpack_require__(1128) });


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(59);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1133) });


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(59);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(80), 'Object', { defineProperty: __webpack_require__(72).f });


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(169);
var $keys = __webpack_require__(134);

__webpack_require__(1138)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(166);
var global = __webpack_require__(40);
var ctx = __webpack_require__(132);
var classof = __webpack_require__(387);
var $export = __webpack_require__(59);
var isObject = __webpack_require__(81);
var aFunction = __webpack_require__(165);
var anInstance = __webpack_require__(1121);
var forOf = __webpack_require__(1125);
var speciesConstructor = __webpack_require__(401);
var task = __webpack_require__(402).set;
var microtask = __webpack_require__(1132)();
var newPromiseCapabilityModule = __webpack_require__(232);
var perform = __webpack_require__(398);
var promiseResolve = __webpack_require__(399);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(41)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1139)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(168)($Promise, PROMISE);
__webpack_require__(1140)(PROMISE);
Wrapper = __webpack_require__(36)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(394)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(40);
var has = __webpack_require__(89);
var DESCRIPTORS = __webpack_require__(80);
var $export = __webpack_require__(59);
var redefine = __webpack_require__(400);
var META = __webpack_require__(1131).KEY;
var $fails = __webpack_require__(110);
var shared = __webpack_require__(235);
var setToStringTag = __webpack_require__(168);
var uid = __webpack_require__(170);
var wks = __webpack_require__(41);
var wksExt = __webpack_require__(240);
var wksDefine = __webpack_require__(239);
var enumKeys = __webpack_require__(1124);
var isArray = __webpack_require__(1127);
var anObject = __webpack_require__(71);
var isObject = __webpack_require__(81);
var toIObject = __webpack_require__(111);
var toPrimitive = __webpack_require__(238);
var createDesc = __webpack_require__(135);
var _create = __webpack_require__(395);
var gOPNExt = __webpack_require__(1136);
var $GOPD = __webpack_require__(1135);
var $DP = __webpack_require__(72);
var $keys = __webpack_require__(134);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(396).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(167).f = $propertyIsEnumerable;
  __webpack_require__(233).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(166)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(90)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(59);
var core = __webpack_require__(36);
var global = __webpack_require__(40);
var speciesConstructor = __webpack_require__(401);
var promiseResolve = __webpack_require__(399);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(59);
var newPromiseCapability = __webpack_require__(232);
var perform = __webpack_require__(398);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239)('asyncIterator');


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239)('observable');


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var isArray = __webpack_require__(176);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(12);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(65);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(96);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(138);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(1160)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(405) });

__webpack_require__(82)('copyWithin');


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(60)(4);

$export($export.P + $export.F * !__webpack_require__(57)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(243) });

__webpack_require__(82)('fill');


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(60)(2);

$export($export.P + $export.F * !__webpack_require__(57)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(60)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(82)(KEY);


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(60)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(82)(KEY);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(60)(0);
var STRICT = __webpack_require__(57)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(56);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var call = __webpack_require__(416);
var isArrayIter = __webpack_require__(251);
var toLength = __webpack_require__(25);
var createProperty = __webpack_require__(245);
var getIterFn = __webpack_require__(268);

$export($export.S + $export.F * !__webpack_require__(178)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(172)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(176) });


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(50);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(137) != Object || !__webpack_require__(57)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(50);
var toInteger = __webpack_require__(64);
var toLength = __webpack_require__(25);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(57)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(60)(1);

$export($export.P + $export.F * !__webpack_require__(57)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(245);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(12)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(407);

$export($export.P + $export.F * !__webpack_require__(57)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(407);

$export($export.P + $export.F * !__webpack_require__(57)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(249);
var cof = __webpack_require__(55);
var toAbsoluteIndex = __webpack_require__(100);
var toLength = __webpack_require__(25);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(12)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(60)(3);

$export($export.P + $export.F * !__webpack_require__(57)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(30);
var fails = __webpack_require__(12);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(57)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99)('Array');


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(1157);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(65);

$export($export.P + $export.F * __webpack_require__(12)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(20)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(43)(proto, TO_PRIMITIVE, __webpack_require__(1158));


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(44)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(408) });


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(49);
var HAS_INSTANCE = __webpack_require__(20)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(24).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(23) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(419);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(255);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(254);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(418) });


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(419) });


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(255) });


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(254);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(254);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var has = __webpack_require__(42);
var cof = __webpack_require__(55);
var inheritIfRequired = __webpack_require__(250);
var toPrimitive = __webpack_require__(65);
var fails = __webpack_require__(12);
var gOPN = __webpack_require__(95).f;
var gOPD = __webpack_require__(48).f;
var dP = __webpack_require__(24).f;
var $trim = __webpack_require__(114).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(94)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(23) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(44)(global, NUMBER, $Number);
}


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(11).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(415) });


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(415);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(427);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(428);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(64);
var aNumberValue = __webpack_require__(404);
var repeat = __webpack_require__(262);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(12)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(12);
var aNumberValue = __webpack_require__(404);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(421) });


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(94) });


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperties: __webpack_require__(422) });


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(83).onFreeze;

__webpack_require__(63)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(50);
var $getOwnPropertyDescriptor = __webpack_require__(48).f;

__webpack_require__(63)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(63)('getOwnPropertyNames', function () {
  return __webpack_require__(423).f;
});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(30);
var $getPrototypeOf = __webpack_require__(49);

__webpack_require__(63)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(13);

__webpack_require__(63)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(13);

__webpack_require__(63)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(13);

__webpack_require__(63)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(1161) });


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(30);
var $keys = __webpack_require__(96);

__webpack_require__(63)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(83).onFreeze;

__webpack_require__(63)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(13);
var meta = __webpack_require__(83).onFreeze;

__webpack_require__(63)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(258).set });


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(136);
var test = {};
test[__webpack_require__(20)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(44)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(427);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(428);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(93);
var global = __webpack_require__(11);
var ctx = __webpack_require__(56);
var classof = __webpack_require__(136);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(37);
var anInstance = __webpack_require__(91);
var forOf = __webpack_require__(92);
var speciesConstructor = __webpack_require__(184);
var task = __webpack_require__(264).set;
var microtask = __webpack_require__(256)();
var newPromiseCapabilityModule = __webpack_require__(257);
var perform = __webpack_require__(429);
var promiseResolve = __webpack_require__(430);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(20)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(98)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(113)($Promise, PROMISE);
__webpack_require__(99)(PROMISE);
Wrapper = __webpack_require__(61)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(178)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(9);
var rApply = (__webpack_require__(11).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(12)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(94);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var fails = __webpack_require__(12);
var bind = __webpack_require__(408);
var rConstruct = (__webpack_require__(11).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(24);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(65);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(12)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(48).f;
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(252)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(48);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(49);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(49);
var has = __webpack_require__(42);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(9);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(426) });


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(9);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(258);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(24);
var gOPD = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(49);
var has = __webpack_require__(42);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(97);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var inheritIfRequired = __webpack_require__(250);
var dP = __webpack_require__(24).f;
var gOPN = __webpack_require__(95).f;
var isRegExp = __webpack_require__(177);
var $flags = __webpack_require__(175);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(23) && (!CORRECT_NEW || __webpack_require__(12)(function () {
  re2[__webpack_require__(20)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(44)(global, 'RegExp', $RegExp);
}

__webpack_require__(99)('RegExp');


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(174)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(174)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(174)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(174)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(177);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(435);
var anObject = __webpack_require__(9);
var $flags = __webpack_require__(175);
var DESCRIPTORS = __webpack_require__(23);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(44)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(12)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(45)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(45)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(45)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(45)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(260)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(25);
var context = __webpack_require__(261);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(248)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(45)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(45)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(45)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(100);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(261);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(248)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(45)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(260)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(253)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(45)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(50);
var toLength = __webpack_require__(25);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(262)
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(45)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(25);
var context = __webpack_require__(261);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(248)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(45)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(45)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(45)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(114)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(23);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(44);
var META = __webpack_require__(83).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(183);
var setToStringTag = __webpack_require__(113);
var uid = __webpack_require__(101);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(433);
var wksDefine = __webpack_require__(267);
var enumKeys = __webpack_require__(1159);
var isArray = __webpack_require__(176);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(13);
var toIObject = __webpack_require__(50);
var toPrimitive = __webpack_require__(65);
var createDesc = __webpack_require__(97);
var _create = __webpack_require__(94);
var gOPNExt = __webpack_require__(423);
var $GOPD = __webpack_require__(48);
var $DP = __webpack_require__(24);
var $keys = __webpack_require__(96);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(95).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(138).f = $propertyIsEnumerable;
  __webpack_require__(180).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(93)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(43)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(185);
var buffer = __webpack_require__(265);
var anObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(100);
var toLength = __webpack_require__(25);
var isObject = __webpack_require__(13);
var ArrayBuffer = __webpack_require__(11).ArrayBuffer;
var speciesConstructor = __webpack_require__(184);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(12)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(99)(ARRAY_BUFFER);


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(185).ABV, {
  DataView: __webpack_require__(265).DataView
});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(411);
var validate = __webpack_require__(115);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(173)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(412);
var toObject = __webpack_require__(30);
var toLength = __webpack_require__(25);
var aFunction = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(244);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(82)('flatMap');


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(412);
var toObject = __webpack_require__(30);
var toLength = __webpack_require__(25);
var toInteger = __webpack_require__(64);
var arraySpeciesCreate = __webpack_require__(244);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(82)('flatten');


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(172)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(82)('includes');


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(256)();
var process = __webpack_require__(11).process;
var isNode = __webpack_require__(55)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(55);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(11) });


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(181)('Map');


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(182)('Map');


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(410)('Map') });


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(420);
var fround = __webpack_require__(418);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(420) });


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(24);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(23) && $export($export.P + __webpack_require__(179), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(24);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(23) && $export($export.P + __webpack_require__(179), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(425)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(426);
var toIObject = __webpack_require__(50);
var gOPD = __webpack_require__(48);
var createProperty = __webpack_require__(245);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(49);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(179), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(30);
var toPrimitive = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(49);
var getOwnPropertyDescriptor = __webpack_require__(48).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(179), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(425)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(11);
var core = __webpack_require__(61);
var microtask = __webpack_require__(256)();
var OBSERVABLE = __webpack_require__(20)('observable');
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(9);
var anInstance = __webpack_require__(91);
var redefineAll = __webpack_require__(98);
var hide = __webpack_require__(43);
var forOf = __webpack_require__(92);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(99)('Observable');


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(61);
var global = __webpack_require__(11);
var speciesConstructor = __webpack_require__(184);
var promiseResolve = __webpack_require__(430);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(257);
var perform = __webpack_require__(429);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(436);
var from = __webpack_require__(406);
var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(49);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(49);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(49);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(73);
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(37);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(181)('Set');


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(182)('Set');


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(410)('Set') });


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(260)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(62);
var toLength = __webpack_require__(25);
var isRegExp = __webpack_require__(177);
var getFlags = __webpack_require__(175);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(252)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(431);
var userAgent = __webpack_require__(266);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(431);
var userAgent = __webpack_require__(266);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(114)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(114)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(267)('asyncIterator');


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(267)('observable');


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(11) });


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(181)('WeakMap');


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(182)('WeakMap');


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(181)('WeakSet');


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(182)('WeakSet');


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(269);
var getKeys = __webpack_require__(96);
var redefine = __webpack_require__(44);
var global = __webpack_require__(11);
var hide = __webpack_require__(43);
var Iterators = __webpack_require__(112);
var wks = __webpack_require__(20);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(264);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(11);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(266);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1282);
__webpack_require__(1221);
__webpack_require__(1223);
__webpack_require__(1222);
__webpack_require__(1225);
__webpack_require__(1227);
__webpack_require__(1232);
__webpack_require__(1226);
__webpack_require__(1224);
__webpack_require__(1234);
__webpack_require__(1233);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1228);
__webpack_require__(1220);
__webpack_require__(1231);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1188);
__webpack_require__(1190);
__webpack_require__(1189);
__webpack_require__(1238);
__webpack_require__(1237);
__webpack_require__(1208);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1217);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(1269);
__webpack_require__(1274);
__webpack_require__(1281);
__webpack_require__(1272);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1270);
__webpack_require__(1275);
__webpack_require__(1277);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1271);
__webpack_require__(1273);
__webpack_require__(1276);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1183);
__webpack_require__(1185);
__webpack_require__(1184);
__webpack_require__(1187);
__webpack_require__(1186);
__webpack_require__(1172);
__webpack_require__(1170);
__webpack_require__(1176);
__webpack_require__(1173);
__webpack_require__(1179);
__webpack_require__(1181);
__webpack_require__(1169);
__webpack_require__(1175);
__webpack_require__(1166);
__webpack_require__(1180);
__webpack_require__(1164);
__webpack_require__(1178);
__webpack_require__(1177);
__webpack_require__(1171);
__webpack_require__(1174);
__webpack_require__(1163);
__webpack_require__(1165);
__webpack_require__(1168);
__webpack_require__(1167);
__webpack_require__(1182);
__webpack_require__(269);
__webpack_require__(1254);
__webpack_require__(1259);
__webpack_require__(435);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1239);
__webpack_require__(434);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(1294);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1289);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1287);
__webpack_require__(1290);
__webpack_require__(1288);
__webpack_require__(1291);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(1247);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1253);
__webpack_require__(1252);
__webpack_require__(1297);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1338);
__webpack_require__(1341);
__webpack_require__(1340);
__webpack_require__(1342);
__webpack_require__(1343);
__webpack_require__(1339);
__webpack_require__(1344);
__webpack_require__(1345);
__webpack_require__(1319);
__webpack_require__(1322);
__webpack_require__(1318);
__webpack_require__(1316);
__webpack_require__(1317);
__webpack_require__(1320);
__webpack_require__(1321);
__webpack_require__(1303);
__webpack_require__(1337);
__webpack_require__(1302);
__webpack_require__(1336);
__webpack_require__(1348);
__webpack_require__(1350);
__webpack_require__(1301);
__webpack_require__(1335);
__webpack_require__(1347);
__webpack_require__(1349);
__webpack_require__(1300);
__webpack_require__(1346);
__webpack_require__(1299);
__webpack_require__(1304);
__webpack_require__(1305);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1310);
__webpack_require__(1309);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1313);
__webpack_require__(1315);
__webpack_require__(1314);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1326);
__webpack_require__(1327);
__webpack_require__(1329);
__webpack_require__(1328);
__webpack_require__(1331);
__webpack_require__(1330);
__webpack_require__(1332);
__webpack_require__(1333);
__webpack_require__(1334);
__webpack_require__(1298);
__webpack_require__(1323);
__webpack_require__(1353);
__webpack_require__(1352);
__webpack_require__(1351);
module.exports = __webpack_require__(61);


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

var helpers = __webpack_require__(270);

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test()
{
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function md5(buf) {
  return helpers.hash(buf, core_md5, 16);
};


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// Original code adapted from Robert Kieffer.
// details at https://github.com/broofa/node-uuid
(function() {
  var _global = this;

  var mathRNG, whatwgRNG;

  // NOTE: Math.random() does not guarantee "cryptographic quality"
  mathRNG = function(size) {
    var bytes = new Array(size);
    var r;

    for (var i = 0, r; i < size; i++) {
      if ((i & 0x03) == 0) r = Math.random() * 0x100000000;
      bytes[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return bytes;
  }

  if (_global.crypto && crypto.getRandomValues) {
    whatwgRNG = function(size) {
      var bytes = new Uint8Array(size);
      crypto.getRandomValues(bytes);
      return bytes;
    }
  }

  module.exports = whatwgRNG || mathRNG;

}())


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var helpers = __webpack_require__(270);

/*
 * Calculate the SHA-1 of an array of big-endian words, and a bit length
 */
function core_sha1(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << (24 - len % 32);
  x[((len + 64 >> 9) << 4) + 15] = len;

  var w = Array(80);
  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;
  var e = -1009589776;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    var olde = e;

    for(var j = 0; j < 80; j++)
    {
      if(j < 16) w[j] = x[i + j];
      else w[j] = rol(w[j-3] ^ w[j-8] ^ w[j-14] ^ w[j-16], 1);
      var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)),
                       safe_add(safe_add(e, w[j]), sha1_kt(j)));
      e = d;
      d = c;
      c = rol(b, 30);
      b = a;
      a = t;
    }

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
    e = safe_add(e, olde);
  }
  return Array(a, b, c, d, e);

}

/*
 * Perform the appropriate triplet combination function for the current
 * iteration
 */
function sha1_ft(t, b, c, d)
{
  if(t < 20) return (b & c) | ((~b) & d);
  if(t < 40) return b ^ c ^ d;
  if(t < 60) return (b & c) | (b & d) | (c & d);
  return b ^ c ^ d;
}

/*
 * Determine the appropriate additive constant for the current iteration
 */
function sha1_kt(t)
{
  return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
         (t < 60) ? -1894007588 : -899497514;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function sha1(buf) {
  return helpers.hash(buf, core_sha1, 20, true);
};


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var helpers = __webpack_require__(270);

var safe_add = function(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
};

var S = function(X, n) {
  return (X >>> n) | (X << (32 - n));
};

var R = function(X, n) {
  return (X >>> n);
};

var Ch = function(x, y, z) {
  return ((x & y) ^ ((~x) & z));
};

var Maj = function(x, y, z) {
  return ((x & y) ^ (x & z) ^ (y & z));
};

var Sigma0256 = function(x) {
  return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
};

var Sigma1256 = function(x) {
  return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
};

var Gamma0256 = function(x) {
  return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
};

var Gamma1256 = function(x) {
  return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
};

var core_sha256 = function(m, l) {
  var K = new Array(0x428A2F98,0x71374491,0xB5C0FBCF,0xE9B5DBA5,0x3956C25B,0x59F111F1,0x923F82A4,0xAB1C5ED5,0xD807AA98,0x12835B01,0x243185BE,0x550C7DC3,0x72BE5D74,0x80DEB1FE,0x9BDC06A7,0xC19BF174,0xE49B69C1,0xEFBE4786,0xFC19DC6,0x240CA1CC,0x2DE92C6F,0x4A7484AA,0x5CB0A9DC,0x76F988DA,0x983E5152,0xA831C66D,0xB00327C8,0xBF597FC7,0xC6E00BF3,0xD5A79147,0x6CA6351,0x14292967,0x27B70A85,0x2E1B2138,0x4D2C6DFC,0x53380D13,0x650A7354,0x766A0ABB,0x81C2C92E,0x92722C85,0xA2BFE8A1,0xA81A664B,0xC24B8B70,0xC76C51A3,0xD192E819,0xD6990624,0xF40E3585,0x106AA070,0x19A4C116,0x1E376C08,0x2748774C,0x34B0BCB5,0x391C0CB3,0x4ED8AA4A,0x5B9CCA4F,0x682E6FF3,0x748F82EE,0x78A5636F,0x84C87814,0x8CC70208,0x90BEFFFA,0xA4506CEB,0xBEF9A3F7,0xC67178F2);
  var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
    var W = new Array(64);
    var a, b, c, d, e, f, g, h, i, j;
    var T1, T2;
  /* append padding */
  m[l >> 5] |= 0x80 << (24 - l % 32);
  m[((l + 64 >> 9) << 4) + 15] = l;
  for (var i = 0; i < m.length; i += 16) {
    a = HASH[0]; b = HASH[1]; c = HASH[2]; d = HASH[3]; e = HASH[4]; f = HASH[5]; g = HASH[6]; h = HASH[7];
    for (var j = 0; j < 64; j++) {
      if (j < 16) {
        W[j] = m[j + i];
      } else {
        W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
      }
      T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
      T2 = safe_add(Sigma0256(a), Maj(a, b, c));
      h = g; g = f; f = e; e = safe_add(d, T1); d = c; c = b; b = a; a = safe_add(T1, T2);
    }
    HASH[0] = safe_add(a, HASH[0]); HASH[1] = safe_add(b, HASH[1]); HASH[2] = safe_add(c, HASH[2]); HASH[3] = safe_add(d, HASH[3]);
    HASH[4] = safe_add(e, HASH[4]); HASH[5] = safe_add(f, HASH[5]); HASH[6] = safe_add(g, HASH[6]); HASH[7] = safe_add(h, HASH[7]);
  }
  return HASH;
};

module.exports = function sha256(buf) {
  return helpers.hash(buf, core_sha256, 32, true);
};


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dataloader;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getHistoryFromTriplet(indices, triplet) {
    return {
        until: parseInt(indices.timeStamps[parseInt(triplet[0], 32)], 32) * 1000,

        offset: indices.offsets[parseInt(triplet[1], 32)],

        isdst: !!parseInt(triplet[2], 10)
    };
}

function reduceToTriplets(array) {
    var result = [];
    var i = 0;

    while (i < array.length) {
        result.push([array[i], array[i + 1], array[i + 2]]);
        i += 3;
    }

    return result;
}

function unpackHistory(indices, historyStringCSV) {
    var encodedIndexList = historyStringCSV.split(',');
    var count = encodedIndexList.length;

    if (count % 3 !== 0) {
        throw new Error('wrong length of history Array, must be multiple of 3');
    }

    var history = reduceToTriplets(encodedIndexList).map(function (triplet) {
        return getHistoryFromTriplet(indices, triplet);
    });

    if (count / 3 !== history.length) {
        throw new Error('failed to harvest all data!!');
    }

    return history;
}

function enrichMetaZoneMapWithEquivalentZones(equivalentIanaTimeZones) {
    var globalSpace = this.globalSpace;

    if (!(globalSpace && globalSpace.Intl._metaZoneData)) {
        return;
    }

    var metaZoneData = globalSpace.Intl._metaZoneData;
    var foundMetaZone = null;

    equivalentIanaTimeZones.forEach(function (ianaTimeZone) {
        if (metaZoneData.get(ianaTimeZone)) {
            foundMetaZone = metaZoneData.get(ianaTimeZone);
        }
    });

    if (!foundMetaZone) {
        return;
    }

    var allMetaZoneData = metaZoneData.get();
    equivalentIanaTimeZones.forEach(function (ianaTimeZone) {
        if (!metaZoneData.get(ianaTimeZone)) {
            allMetaZoneData[ianaTimeZone] = foundMetaZone;
        }
    });
}

function loadTimeZoneData(packedTzData) {
    var _this = this;

    if (!packedTzData || !Array.isArray(packedTzData.zoneDefs) || !Array.isArray(packedTzData.timeStamps) || !Array.isArray(packedTzData.offsets)) {
        throw new Error('loadTimeZoneData: rejected packedTzData, packedTzData is not in right shape.');
    }

    var indices = {
        timeStamps: packedTzData.timeStamps,
        offsets: packedTzData.offsets
    };

    packedTzData.zoneDefs.forEach(function (zoneDef) {
        var zoneDefSplit = zoneDef.split('||');
        var equivalentIanaTimeZones = zoneDefSplit[0].split(',');
        var historyString = zoneDefSplit[1];
        var ianaTimeZoneHistoryList = unpackHistory(indices, historyString);

        equivalentIanaTimeZones.forEach(function (ianaTimeZone) {
            _this.value[ianaTimeZone] = ianaTimeZoneHistoryList;
        });

        _this.enrichMetaZoneMapWithEquivalentZones(equivalentIanaTimeZones);
    });
}

function getCLDRZoneNamesFromQuadruplet(zoneNameIndex, strQuadruplet) {
    var quadruplet = strQuadruplet.split('|');
    var lookupIndex = function lookupIndex(w) {
        return zoneNameIndex[parseInt(w, 32)];
    };

    return {
        long: {
            standard: quadruplet[0].split(',').filter(function (w) {
                return !!w;
            }).map(lookupIndex).join(''),
            daylight: quadruplet[1].split(',').filter(function (w) {
                return !!w;
            }).map(lookupIndex).join('')
        },
        short: {
            standard: quadruplet[2].split(',').filter(function (w) {
                return !!w;
            }).map(lookupIndex).join(''),
            daylight: quadruplet[3].split(',').filter(function (w) {
                return !!w;
            }).map(lookupIndex).join('')
        }
    };
}

function loadLocaleData(packedCLDRZoneData) {
    var _this2 = this;

    if (!packedCLDRZoneData || !packedCLDRZoneData.locales || !Array.isArray(packedCLDRZoneData.zoneNameIndex)) {
        throw new Error('loadLocaleData: rejected data, data is not in right shape.');
    }

    var decodeQuadruplet = function decodeQuadruplet(strQuadruplet) {
        return getCLDRZoneNamesFromQuadruplet(packedCLDRZoneData.zoneNameIndex, strQuadruplet);
    };

    Object.keys(packedCLDRZoneData.locales).forEach(function (locale) {
        var metaZones = packedCLDRZoneData.locales[locale].metazone;
        Object.keys(metaZones).forEach(function (metaZone) {
            metaZones[metaZone] = decodeQuadruplet(metaZones[metaZone]);
        });

        var ianaTimeZones = packedCLDRZoneData.locales[locale].zone;
        Object.keys(ianaTimeZones).forEach(function (ianaTimeZone) {
            ianaTimeZones[ianaTimeZone] = decodeQuadruplet(ianaTimeZones[ianaTimeZone]);
        });

        _this2.value[locale] = packedCLDRZoneData.locales[locale];
    });

    Object.keys(packedCLDRZoneData.locales).forEach(function (locale) {
        var localeItems = locale.split('-');

        for (var i = 0; i < localeItems.length - 1; i++) {
            var generalLocale = localeItems.slice(0, localeItems.length - i - 1).join('-');

            if (!_this2.value[generalLocale]) {
                _this2.value[generalLocale] = _this2.value[locale];
            }
        }
    });
}

function getLocale(locale) {
    if (this.get(locale)) {
        return this.get(locale);
    }

    var localeItems = locale.split('-');
    var fallbackLocales = [];

    for (var i = 0; i < localeItems.length - 1; i++) {
        fallbackLocales.push(localeItems.slice(0, localeItems.length - i - 1).join('-'));
    }

    for (var j = 0; j < fallbackLocales.length; j++) {
        if (this.get(fallbackLocales[j])) {
            return this.get(fallbackLocales[j]);
        }
    }

    return undefined;
}

var Loader = function Loader(loaderFunction, extraMethods) {
    var _this3 = this;

    _classCallCheck(this, Loader);

    this.value = {};
    this.load = loaderFunction || function (json) {
        this.value = json;
    };

    if (extraMethods) {
        Object.keys(extraMethods).forEach(function (name) {
            return _this3[name] = extraMethods[name];
        });
    }

    this.get = function (key) {
        if (key === undefined) {
            return this.value;
        }

        return this.value[key];
    };
};

function dataloader(globalSpace) {
    if (globalSpace.Intl) {
        globalSpace.Intl._metaZoneData = new Loader();
        globalSpace.Intl._localeData = new Loader(loadLocaleData, {
            getLocale: getLocale
        });
        globalSpace.Intl._timeZoneData = new Loader(loadTimeZoneData, {
            enrichMetaZoneMapWithEquivalentZones: enrichMetaZoneMapWithEquivalentZones.bind({
                globalSpace: globalSpace
            })
        });
    }
}
//# sourceMappingURL=data-loader.js.map


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function getGenericZoneName(offset, isShort, locale) {
    var offsetSign = offset < 0 ? '-' : '+',
        hourVal = Math.floor(Math.abs(offset / 60)),
        minuteVal = Math.abs(offset % 60);

    var hour = Intl.NumberFormat(locale, {
        minimumIntegerDigits: isShort ? 1 : 2
    }).format(hourVal);

    var minute = Intl.NumberFormat(locale, {
        minimumIntegerDigits: 2
    }).format(minuteVal);

    if (offset === 0) {
        return '';
    }

    if (isShort && minuteVal === 0) {
        minute = '';
    }

    return offsetSign + hour + (minute ? ':' : '') + minute;
}

function getRelevantMetaZone(metaNameData, timeStamp, offsetString) {
    if (!Array.isArray(metaNameData)) {
        return null;
    }

    if (metaNameData.length === 1) {
        return metaNameData[0].mzone;
    }

    var minTs = Math.pow(2, 31) * -1000;
    var maxTs = Math.pow(2, 31) * 1000;

    var mzone = null;

    metaNameData.forEach(function (metaName) {
        var fromVal = metaName.from ? new Date(metaName.from + offsetString).getTime() : minTs;
        var toVal = metaName.to ? new Date(metaName.to + offsetString).getTime() : maxTs;

        if (fromVal <= timeStamp && timeStamp <= toVal) {
            mzone = metaName.mzone;
        }
    });

    return mzone;
}

function pickZoneName(isShort, isdst, cldrZoneNames) {
    if (!isShort && cldrZoneNames.long) {
        if (isdst && cldrZoneNames.long.daylight) {
            return cldrZoneNames.long.daylight;
        } else if (!isdst && cldrZoneNames.long.standard) {
            return cldrZoneNames.long.standard;
        }
    } else if (cldrZoneNames.short) {
        if (isdst && cldrZoneNames.short.daylight) {
            return cldrZoneNames.short.daylight;
        } else if (!isdst && cldrZoneNames.short.standard) {
            return cldrZoneNames.short.standard;
        }
    }

    return false;
}

function getTimeZoneOffsetInfo(timeZoneHistory, date) {
    var ts = date.getTime();
    var offsetHist = timeZoneHistory.reduce(function (find, hist) {
        return hist.until >= ts && find === null ? hist : find;
    }, null);

    return offsetHist ? offsetHist : timeZoneHistory[timeZoneHistory.length - 1];
}

function getZoneNameForLocale(_ref) {
    var locale = _ref.locale,
        ianaTimeZone = _ref.ianaTimeZone,
        offset = _ref.offset,
        isdst = _ref.isdst,
        isShort = _ref.isShort,
        timeStamp = _ref.timeStamp;

    var metaZoneName = getRelevantMetaZone(Intl._metaZoneData.get(ianaTimeZone), timeStamp, getGenericZoneName(offset));
    var cldrZones = Intl._localeData.getLocale(locale);
    var cldrZoneNamesThruMetaZone = metaZoneName && cldrZones && cldrZones.metazone[metaZoneName];
    var cldrZoneNamesThruIanaTimeZone = cldrZones && cldrZones.zone && cldrZones.zone[ianaTimeZone];

    if (cldrZoneNamesThruIanaTimeZone && pickZoneName(isShort, isdst, cldrZoneNamesThruIanaTimeZone)) {
        return pickZoneName(isShort, isdst, cldrZoneNamesThruIanaTimeZone);
    } else if (cldrZoneNamesThruMetaZone && pickZoneName(isShort, isdst, cldrZoneNamesThruMetaZone)) {
        return pickZoneName(isShort, isdst, cldrZoneNamesThruMetaZone);
    } else if (cldrZones && cldrZones.gmtFormat && offset) {
        cldrZones.gmtFormat.replace('{0}', getGenericZoneName(offset, isShort, locale));
    } else if (cldrZones && cldrZones.gmtZeroFormat && !offset) {
        return cldrZones.gmtZeroFormat;
    }

    return offset && ['GMT', getGenericZoneName(offset, isShort, locale)].join('') || 'GMT';
}

var buildCachedCheckTimeZoneSupport = function buildCachedCheckTimeZoneSupport(globalScope) {
    var hasSupport = {};

    return function (ianaTimeZone) {
        if (hasSupport[ianaTimeZone] !== undefined) {
            return hasSupport[ianaTimeZone];
        }

        try {
            new globalScope.Intl._DateTimeFormat('en', {
                timeZone: ianaTimeZone
            });
            hasSupport[ianaTimeZone] = true;
        } catch (exp) {
            hasSupport[ianaTimeZone] = false;
        }

        return hasSupport[ianaTimeZone];
    };
};

exports.buildCachedCheckTimeZoneSupport = buildCachedCheckTimeZoneSupport;
exports.getTimeZoneOffsetInfo = getTimeZoneOffsetInfo;
exports.getZoneNameForLocale = getZoneNameForLocale;
//# sourceMappingURL=lookup-utill.js.map


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = polyfill;

var _lookupUtill = __webpack_require__(1360);

function _get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) {
            return undefined;
        }
        return _get(parent, property, receiver);
    }
    if ("value" in desc) {
        return desc.value;
    }
    var getter = desc.get;
    if (getter === undefined) {
        return undefined;
    }
    return getter.call(receiver);
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) {
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
}

function polyfill(globalSpace) {
    if (!(globalSpace.Intl && globalSpace.Intl.DateTimeFormat && !globalSpace.Intl._DateTimeFormatTimeZone)) {
        return;
    }

    var gIntl = globalSpace.Intl;
    var gDate = globalSpace.Date;
    var checkTimeZoneSupport = (0, _lookupUtill.buildCachedCheckTimeZoneSupport)(globalSpace);
    var jsonClone = function jsonClone(o) {
        return JSON.parse(JSON.stringify(o));
    };
    var _DateTimeFormat = gIntl.DateTimeFormat;

    gIntl._DateTimeFormat = _DateTimeFormat;

    gIntl._DateTimeFormatTimeZone = {
        checkTimeZoneSupport: checkTimeZoneSupport
    };

    function DateTimeFormatPolyfill(locale, options) {
        if (!(this instanceof DateTimeFormatPolyfill)) {
            return new DateTimeFormatPolyfill(locale, options);
        }

        var timeZone = options && options.timeZone || 'UTC';

        if (options === undefined) {
            _DateTimeFormat.call(this, locale, options);

            return;
        }

        if (checkTimeZoneSupport(timeZone)) {
            _DateTimeFormat.call(this, locale, options);

            return;
        }

        var timeZoneData = gIntl._timeZoneData.get(timeZone);

        if (!timeZoneData) {
            throw new RangeError("invalid time zone in DateTimeFormat():  " + timeZone);
        }

        var tsOption = jsonClone(options);
        tsOption.timeZone = 'UTC';
        _DateTimeFormat.call(this, locale, tsOption);

        var _resolvedOptions = _get(DateTimeFormatPolyfill.prototype.__proto__ || Object.getPrototypeOf(DateTimeFormatPolyfill.prototype), 'resolvedOptions', this);

        var resolvedLocale = _resolvedOptions.call(this).locale;

        if (options.timeZoneName !== undefined) {
            if (!(gIntl._localeData.getLocale(resolvedLocale) && Intl._metaZoneData.get(timeZone))) {
                throw new RangeError("unsupported value \"" + options.timeZoneName + "\" for timeZone " + timeZone + ". requires locale data for " + resolvedLocale);
            }
        }

        this._dateTimeFormatPolyfill = {
            optionTimeZone: timeZone,
            optionTimeZoneName: options.timeZoneName,
            timeZoneData: timeZoneData
        };
    }
    _inherits(DateTimeFormatPolyfill, _DateTimeFormat);

    Object.defineProperty(DateTimeFormatPolyfill.prototype, 'format', {
        configurable: true,
        value: function value(date) {
            var _format = _get(DateTimeFormatPolyfill.prototype.__proto__ || Object.getPrototypeOf(DateTimeFormatPolyfill.prototype), 'format', this);
            var _resolvedOptions = _get(DateTimeFormatPolyfill.prototype.__proto__ || Object.getPrototypeOf(DateTimeFormatPolyfill.prototype), 'resolvedOptions', this);

            if (!this._dateTimeFormatPolyfill) {
                return _format.call(this, date);
            }

            if (date === null || date === undefined) {
                date = new Date();
            }

            if (!(date instanceof Date)) {
                date = new Date(date);
            }

            var polyfill = this._dateTimeFormatPolyfill;
            var timeZoneOffsetInfo = (0, _lookupUtill.getTimeZoneOffsetInfo)(polyfill.timeZoneData, date);
            var timeZoneOffset = timeZoneOffsetInfo.offset * 60000;
            var shiftedDate = new Date(date.getTime() + timeZoneOffset);
            var shiftedFormat = _format.call(this, shiftedDate);
            var resolvedLocale = _resolvedOptions.call(this).locale;
            var doNeedToReplaceTimeZoneName = polyfill.optionTimeZoneName !== undefined;

            if (doNeedToReplaceTimeZoneName) {
                var isShort = polyfill.optionTimeZoneName === 'short';
                var timeZoneName = (0, _lookupUtill.getZoneNameForLocale)({
                    locale: resolvedLocale,
                    ianaTimeZone: polyfill.optionTimeZone,
                    isdst: timeZoneOffsetInfo.isdst,
                    offset: timeZoneOffsetInfo.offset,
                    timeStamp: date.getTime(),
                    isShort: isShort
                });
                var timeZoneNameUTC = (0, _lookupUtill.getZoneNameForLocale)({
                    locale: resolvedLocale,
                    ianaTimeZone: 'UTC',
                    isdst: false,
                    offset: 0,
                    timeStamp: date.getTime(),
                    isShort: isShort
                });

                if (shiftedFormat.indexOf(timeZoneNameUTC) < 0) {
                    return shiftedFormat.trim() + ' ' + timeZoneName;
                }

                return shiftedFormat.replace(timeZoneNameUTC, timeZoneName);
            }

            return shiftedFormat;
        }
    });

    Object.defineProperty(DateTimeFormatPolyfill.prototype, 'resolvedOptions', {
        writable: true,
        configurable: true,
        value: function value() {
            var _resolvedOptions = _get(DateTimeFormatPolyfill.prototype.__proto__ || Object.getPrototypeOf(DateTimeFormatPolyfill.prototype), 'resolvedOptions', this);

            if (this._dateTimeFormatPolyfill) {
                var options = jsonClone(_resolvedOptions.call(this));
                options.timeZone = this._dateTimeFormatPolyfill.optionTimeZone;

                return options;
            }

            return _resolvedOptions.call(this);
        }
    });

    gIntl.DateTimeFormat = DateTimeFormatPolyfill;

    gDate.prototype.toLocaleString = function (locale, options) {
        var defaultLocaleOption = {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };

        if (options === undefined) {
            options = jsonClone(defaultLocaleOption);
        }

        if (options.day === undefined && options.month === undefined && options.year === undefined && options.hour === undefined && options.minute === undefined && options.second === undefined) {
            options = jsonClone(options);
            options.day = defaultLocaleOption.day;
            options.month = defaultLocaleOption.month;
            options.year = defaultLocaleOption.year;
            options.hour = defaultLocaleOption.hour;
            options.minute = defaultLocaleOption.minute;
            options.second = defaultLocaleOption.second;
        }

        return new gIntl.DateTimeFormat(locale, options).format(this);
    };

    gDate.prototype.toLocaleDateString = function (locale, options) {
        var defaultDateOption = {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        };

        if (options === undefined) {
            options = jsonClone(defaultDateOption);
        }

        if (options.day === undefined && options.month === undefined && options.year === undefined) {
            options = jsonClone(options);
            options.day = defaultDateOption.day;
            options.month = defaultDateOption.month;
            options.year = defaultDateOption.year;
        }

        return new gIntl.DateTimeFormat(locale, options).format(this);
    };

    gDate.prototype.toLocaleTimeString = function (locale, options) {
        var defaultTimeOption = {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };

        if (options === undefined) {
            options = jsonClone(defaultTimeOption);
        }

        if (options.hour === undefined && options.minute === undefined && options.second === undefined) {
            options = jsonClone(options);
            options.hour = defaultTimeOption.hour;
            options.minute = defaultTimeOption.minute;
            options.second = defaultTimeOption.second;
        }

        return new gIntl.DateTimeFormat(locale, options).format(this);
    };
}
//# sourceMappingURL=polyfill.js.map


/***/ }),
/* 1362 */
/***/ (function(module, exports) {

/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
module.exports = function load(global) {global.Intl && global.Intl._localeData && global.Intl._localeData.load({
    "locales": {
        "af-NA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,9g||",
                "Europe/London": "|1mh,0,cd||"
            },
            "metazone": {
                "Afghanistan": "b6,5,bc|||",
                "Africa_Central": "23u,5,c5,5,bc||vj|",
                "Africa_Eastern": "18m,5,c5,5,bc||vp|",
                "Africa_Southern": "32o,5,c5,5,9g||vu|",
                "Africa_Western": "14k,5,c5,5,9g|14k,5,c5,5,cd|103|vq",
                "Alaska": "3p,5,9g|3p,5,ik||",
                "Amazon": "350,5,9g|350,5,cd||",
                "America_Central": "35d,0,9g|35d,0,ik||",
                "America_Eastern": "242,0,9g|242,0,ik||",
                "America_Mountain": "35l,5,9g|35l,5,ik||",
                "America_Pacific": "24h,0,9g|24h,0,ik||",
                "Anadyr": "3l,5,9g|3l,5,cd||",
                "Apia": "3e,5,9g|3e,5,ik||",
                "Arabian": "35r,0,9g|35r,0,ik||",
                "Argentina": "24k,5,9g|24k,5,cd||",
                "Argentina_Western": "14k,5,24k,5,9g|14k,5,24k,5,cd||",
                "Armenia": "361,5,9g|361,5,cd||",
                "Atlantic": "362,0,9g|362,0,ik||",
                "Australia_Central": "173,0,2lc,5,9g|173,0,2lb,0,ik||",
                "Australia_CentralWestern": "173,0,2lc,5,24m,0,5oa,5,bc|173,0,2lc,5,24m,0,ik||",
                "Australia_Eastern": "173,0,242,0,9g|173,0,242,0,ik||",
                "Australia_Western": "173,0,24m,0,9g|173,0,24m,0,ik||",
                "Azerbaijan": "363,5,9g|363,5,cd||",
                "Azores": "36r,5,9g|36r,5,cd||",
                "Bangladesh": "24n,5,9g|24n,5,cd||",
                "Bhutan": "5md,5,bc|||",
                "Bolivia": "aa,5,bc|||",
                "Brasilia": "372,5,9g|372,0,cd||",
                "Brunei": "50q,0,a4,5,bc|||",
                "Cape_Verde": "37k,0,3j,5,9g|37k,0,3j,5,cd||",
                "Chamorro": "6j,5,9g|||",
                "Chatham": "27,5,9g|27,5,ik||",
                "Chile": "cg,5,9g|cg,5,cd||",
                "China": "4h,5,9g|4h,5,ik||",
                "Choibalsan": "2q,5,9g|2q,5,cd||",
                "Christmas": "5d1,5,bc|||",
                "Cocos": "5km,5,bc|||",
                "Colombia": "380,5,9g|380,5,cd||",
                "Cook": "383,5,9g|383,5,5pe||",
                "Cuba": "tb,5,9g|tb,5,ik||",
                "Davis": "5s,5,bc|||",
                "DumontDUrville": "5b,5,5j,5,bc|||",
                "East_Timor": "18m,5,7n,5,bc|||",
                "Easter": "38b,5,9g|38b,5,cd||",
                "Ecuador": "ai,5,bc|||",
                "Europe_Central": "23u,5,hv,0,9g|23u,5,hv,0,cd||",
                "Europe_Eastern": "18m,5,hv,0,9g|18m,5,hv,0,cd||",
                "Europe_Further_Eastern": "1q5,5,592,0,hv,0,59e|||",
                "Europe_Western": "14k,5,hv,0,9g|14k,5,hv,0,cd||",
                "Falkland": "38d,5,9g|38d,5,cd||",
                "Fiji": "cm,5,9g|cm,5,cd||",
                "French_Guiana": "1pg,5,am,5,bc|||",
                "French_Southern": "1ph,0,648,5,0,ou,0,6bb,0,bc|||",
                "Galapagos": "ak,5,bc|||",
                "Gambier": "6v,5,bc|||",
                "Georgia": "2l4,5,9g|2l4,5,cd||",
                "Gilbert_Islands": "5bs,5,bc|||",
                "GMT": "5u,5,5de|||",
                "Greenland_Eastern": "18m,5,8o,5,9g|18m,5,8o,5,cd||",
                "Greenland_Western": "14k,5,8o,5,9g|14k,5,8o,5,cd||",
                "Gulf": "127,5,9g|||",
                "Guyana": "7a,5,bc|||",
                "Hawaii_Aleutian": "4g,5,38p,5,9g|4g,5,38p,5,ik||",
                "Hong_Kong": "qh,5,9g|qh,5,cd||",
                "Hovd": "2g,5,9g|2g,5,cd||",
                "India": "6lg,5,9g|||",
                "Indian_Ocean": "7fb,0,8hs,5,bc|||",
                "Indochina": "4s4,5,bc|||",
                "Indonesia_Central": "23u,0,2l0,5,bc|||",
                "Indonesia_Eastern": "18m,5,2l0,5,bc|||",
                "Indonesia_Western": "14k,5,2l0,5,bc|||",
                "Iran": "5g,5,9g|5g,5,ik||",
                "Irkutsk": "3h,5,9g|3h,5,cd||",
                "Israel": "4e,5,9g|4e,5,ik||",
                "Japan": "6o,5,9g|6o,5,ik||",
                "Kamchatka": "37,5,3k,5,9g|37,5,3k,5,cd||",
                "Kazakhstan_Eastern": "18m,5,2kv,5,bc|||",
                "Kazakhstan_Western": "14k,5,2kv,5,bc|||",
                "Korea": "15c,0,9g|15c,0,ik||",
                "Kosrae": "6f,5,bc|||",
                "Krasnoyarsk": "l0,5,9g|l0,5,cd||",
                "Kyrgystan": "1qu,5,bc|||",
                "Line_Islands": "ac,5,6h7,5,bc|||",
                "Lord_Howe": "1u,0,24,5,9g|1u,0,24,5,ik||",
                "Macquarie": "6m,5,38v,5,bc|||",
                "Magadan": "2o,5,9g|2o,5,cd||",
                "Malaysia": "54h,5,bc|||",
                "Maldives": "54i,5,bc|||",
                "Marquesas": "9e,5,bc|||",
                "Marshall_Islands": "59b,5,bc|||",
                "Mauritius": "4u,5,9g|4u,5,cd||",
                "Mawson": "63,5,bc|||",
                "Mexico_Northwest": "392,5,17k,5,9g|392,5,17k,5,ik||",
                "Mexico_Pacific": "394,0,24h,0,9g|394,0,24h,0,ik||",
                "Mongolia": "396,5,9g|396,5,cd||",
                "Moscow": "143,5,9g|143,5,cd||",
                "Myanmar": "1eb,5,bc|||",
                "Nauru": "5v,5,bc|||",
                "Nepal": "8u,5,bc|||",
                "New_Caledonia": "1o7,5,397,5,9g|1o7,5,397,5,cd||",
                "New_Zealand": "1o7,5,39f,5,9g|1o7,5,39f,5,ik||",
                "Newfoundland": "53,5,9g|53,5,ik||",
                "Niue": "8g,5,bc|||",
                "Norfolk": "8j8,5,bc|||",
                "Noronha": "1s,0,2,0,23,5,9g|1s,0,2,0,23,5,cd||",
                "Novosibirsk": "3b,5,9g|3b,5,cd||",
                "Omsk": "26,5,9g|26,5,cd||",
                "Pakistan": "3i,5,9g|3i,5,cd||",
                "Palau": "9b,5,bc|||",
                "Papua_New_Guinea": "1lc,5,1o7,5,39j,5,bc|||",
                "Paraguay": "3c,5,9g|3c,5,cd||",
                "Peru": "4n,5,9g|4n,5,cd||",
                "Philippines": "39k,0,9g|39k,0,cd||",
                "Phoenix_Islands": "5no,5,bc|||",
                "Pierre_Miquelon": "39l,5,33,0,ou,0,35,5,9g|39l,5,33,0,ou,0,35,5,ik||",
                "Pitcairn": "7e,5,bc|||",
                "Ponape": "9s,5,bc|||",
                "Pyongyang": "8a,5,bc|||",
                "Reunion": "b4,5,bc|||",
                "Rothera": "5q,5,bc|||",
                "Sakhalin": "55,5,9g|55,5,cd||",
                "Samara": "29,5,9g|29,5,ik||",
                "Samoa": "2c,5,9g|2c,5,ik||",
                "Seychelles": "4q8,5,bc|||",
                "Singapore": "53g,5,9g|||",
                "Solomon": "547,5,bc|||",
                "South_Georgia": "32o,5,2l4,5,bc|||",
                "Suriname": "8q,5,bc|||",
                "Syowa": "65,5,bc|||",
                "Tahiti": "8n,5,bc|||",
                "Taipei": "3d,5,9g|3d,5,ik||",
                "Tajikistan": "lc,5,bc|||",
                "Tokelau": "5d,5,bc|||",
                "Tonga": "2j,5,9g|2j,5,cd||",
                "Truk": "6p,5,bc|||",
                "Turkmenistan": "4t,5,9g|4t,5,cd||",
                "Tuvalu": "6h,5,bc|||",
                "Uruguay": "4k,5,9g|4k,5,cd||",
                "Uzbekistan": "39p,5,9g|39p,5,cd||",
                "Vanuatu": "2f,5,9g|2f,5,cd||",
                "Venezuela": "7s,5,bc|||",
                "Vladivostok": "28,5,9g|28,5,cd||",
                "Volgograd": "3f,5,9g|3f,5,cd||",
                "Vostok": "5t,5,bc|||",
                "Wake": "5r,5,38v,5,bc|||",
                "Wallis": "5f,0,ou,0,5k,5,bc|||",
                "Yakutsk": "13v,5,9g|13v,5,cd||",
                "Yekaterinburg": "q6,5,9g|q6,5,cd||"
            }
        },
        "af": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,9g||",
                "Europe/London": "|1mh,0,cd||"
            },
            "metazone": {
                "Afghanistan": "b6,5,bc|||",
                "Africa_Central": "23u,5,c5,5,bc||vj|",
                "Africa_Eastern": "18m,5,c5,5,bc||vp|",
                "Africa_Southern": "32o,5,c5,5,9g||vu|",
                "Africa_Western": "14k,5,c5,5,9g|14k,5,c5,5,cd|103|vq",
                "Alaska": "3p,5,9g|3p,5,ik||",
                "Amazon": "350,5,9g|350,5,cd||",
                "America_Central": "35d,0,9g|35d,0,ik||",
                "America_Eastern": "242,0,9g|242,0,ik||",
                "America_Mountain": "35l,5,9g|35l,5,ik||",
                "America_Pacific": "24h,0,9g|24h,0,ik||",
                "Anadyr": "3l,5,9g|3l,5,cd||",
                "Apia": "3e,5,9g|3e,5,ik||",
                "Arabian": "35r,0,9g|35r,0,ik||",
                "Argentina": "24k,5,9g|24k,5,cd||",
                "Argentina_Western": "14k,5,24k,5,9g|14k,5,24k,5,cd||",
                "Armenia": "361,5,9g|361,5,cd||",
                "Atlantic": "362,0,9g|362,0,ik||",
                "Australia_Central": "173,0,2lc,5,9g|173,0,2lb,0,ik||",
                "Australia_CentralWestern": "173,0,2lc,5,24m,0,5oa,5,bc|173,0,2lc,5,24m,0,ik||",
                "Australia_Eastern": "173,0,242,0,9g|173,0,242,0,ik||",
                "Australia_Western": "173,0,24m,0,9g|173,0,24m,0,ik||",
                "Azerbaijan": "363,5,9g|363,5,cd||",
                "Azores": "36r,5,9g|36r,5,cd||",
                "Bangladesh": "24n,5,9g|24n,5,cd||",
                "Bhutan": "5md,5,bc|||",
                "Bolivia": "aa,5,bc|||",
                "Brasilia": "372,5,9g|372,0,cd||",
                "Brunei": "50q,0,a4,5,bc|||",
                "Cape_Verde": "37k,0,3j,5,9g|37k,0,3j,5,cd||",
                "Chamorro": "6j,5,9g|||",
                "Chatham": "27,5,9g|27,5,ik||",
                "Chile": "cg,5,9g|cg,5,cd||",
                "China": "4h,5,9g|4h,5,ik||",
                "Choibalsan": "2q,5,9g|2q,5,cd||",
                "Christmas": "5d1,5,bc|||",
                "Cocos": "5km,5,bc|||",
                "Colombia": "380,5,9g|380,5,cd||",
                "Cook": "383,5,9g|383,5,5pe||",
                "Cuba": "tb,5,9g|tb,5,ik||",
                "Davis": "5s,5,bc|||",
                "DumontDUrville": "5b,5,5j,5,bc|||",
                "East_Timor": "18m,5,7n,5,bc|||",
                "Easter": "38b,5,9g|38b,5,cd||",
                "Ecuador": "ai,5,bc|||",
                "Europe_Central": "23u,5,hv,0,9g|23u,5,hv,0,cd||",
                "Europe_Eastern": "18m,5,hv,0,9g|18m,5,hv,0,cd||",
                "Europe_Further_Eastern": "1q5,5,592,0,hv,0,59e|||",
                "Europe_Western": "14k,5,hv,0,9g|14k,5,hv,0,cd||",
                "Falkland": "38d,5,9g|38d,5,cd||",
                "Fiji": "cm,5,9g|cm,5,cd||",
                "French_Guiana": "1pg,5,am,5,bc|||",
                "French_Southern": "1ph,0,648,5,0,ou,0,6bb,0,bc|||",
                "Galapagos": "ak,5,bc|||",
                "Gambier": "6v,5,bc|||",
                "Georgia": "2l4,5,9g|2l4,5,cd||",
                "Gilbert_Islands": "5bs,5,bc|||",
                "GMT": "5u,5,5de|||",
                "Greenland_Eastern": "18m,5,8o,5,9g|18m,5,8o,5,cd||",
                "Greenland_Western": "14k,5,8o,5,9g|14k,5,8o,5,cd||",
                "Gulf": "127,5,9g|||",
                "Guyana": "7a,5,bc|||",
                "Hawaii_Aleutian": "4g,5,38p,5,9g|4g,5,38p,5,ik||",
                "Hong_Kong": "qh,5,9g|qh,5,cd||",
                "Hovd": "2g,5,9g|2g,5,cd||",
                "India": "6lg,5,9g|||",
                "Indian_Ocean": "7fb,0,8hs,5,bc|||",
                "Indochina": "4s4,5,bc|||",
                "Indonesia_Central": "23u,0,2l0,5,bc|||",
                "Indonesia_Eastern": "18m,5,2l0,5,bc|||",
                "Indonesia_Western": "14k,5,2l0,5,bc|||",
                "Iran": "5g,5,9g|5g,5,ik||",
                "Irkutsk": "3h,5,9g|3h,5,cd||",
                "Israel": "4e,5,9g|4e,5,ik||",
                "Japan": "6o,5,9g|6o,5,ik||",
                "Kamchatka": "37,5,3k,5,9g|37,5,3k,5,cd||",
                "Kazakhstan_Eastern": "18m,5,2kv,5,bc|||",
                "Kazakhstan_Western": "14k,5,2kv,5,bc|||",
                "Korea": "15c,0,9g|15c,0,ik||",
                "Kosrae": "6f,5,bc|||",
                "Krasnoyarsk": "l0,5,9g|l0,5,cd||",
                "Kyrgystan": "1qu,5,bc|||",
                "Line_Islands": "ac,5,6h7,5,bc|||",
                "Lord_Howe": "1u,0,24,5,9g|1u,0,24,5,ik||",
                "Macquarie": "6m,5,38v,5,bc|||",
                "Magadan": "2o,5,9g|2o,5,cd||",
                "Malaysia": "54h,5,bc|||",
                "Maldives": "54i,5,bc|||",
                "Marquesas": "9e,5,bc|||",
                "Marshall_Islands": "59b,5,bc|||",
                "Mauritius": "4u,5,9g|4u,5,cd||",
                "Mawson": "63,5,bc|||",
                "Mexico_Northwest": "392,5,17k,5,9g|392,5,17k,5,ik||",
                "Mexico_Pacific": "394,0,24h,0,9g|394,0,24h,0,ik||",
                "Mongolia": "396,5,9g|396,5,cd||",
                "Moscow": "143,5,9g|143,5,cd||",
                "Myanmar": "1eb,5,bc|||",
                "Nauru": "5v,5,bc|||",
                "Nepal": "8u,5,bc|||",
                "New_Caledonia": "1o7,5,397,5,9g|1o7,5,397,5,cd||",
                "New_Zealand": "1o7,5,39f,5,9g|1o7,5,39f,5,ik||",
                "Newfoundland": "53,5,9g|53,5,ik||",
                "Niue": "8g,5,bc|||",
                "Norfolk": "8j8,5,bc|||",
                "Noronha": "1s,0,2,0,23,5,9g|1s,0,2,0,23,5,cd||",
                "Novosibirsk": "3b,5,9g|3b,5,cd||",
                "Omsk": "26,5,9g|26,5,cd||",
                "Pakistan": "3i,5,9g|3i,5,cd||",
                "Palau": "9b,5,bc|||",
                "Papua_New_Guinea": "1lc,5,1o7,5,39j,5,bc|||",
                "Paraguay": "3c,5,9g|3c,5,cd||",
                "Peru": "4n,5,9g|4n,5,cd||",
                "Philippines": "39k,0,9g|39k,0,cd||",
                "Phoenix_Islands": "5no,5,bc|||",
                "Pierre_Miquelon": "39l,5,33,0,ou,0,35,5,9g|39l,5,33,0,ou,0,35,5,ik||",
                "Pitcairn": "7e,5,bc|||",
                "Ponape": "9s,5,bc|||",
                "Pyongyang": "8a,5,bc|||",
                "Reunion": "b4,5,bc|||",
                "Rothera": "5q,5,bc|||",
                "Sakhalin": "55,5,9g|55,5,cd||",
                "Samara": "29,5,9g|29,5,ik||",
                "Samoa": "2c,5,9g|2c,5,ik||",
                "Seychelles": "4q8,5,bc|||",
                "Singapore": "53g,5,9g|||",
                "Solomon": "547,5,bc|||",
                "South_Georgia": "32o,5,2l4,5,bc|||",
                "Suriname": "8q,5,bc|||",
                "Syowa": "65,5,bc|||",
                "Tahiti": "8n,5,bc|||",
                "Taipei": "3d,5,9g|3d,5,ik||",
                "Tajikistan": "lc,5,bc|||",
                "Tokelau": "5d,5,bc|||",
                "Tonga": "2j,5,9g|2j,5,cd||",
                "Truk": "6p,5,bc|||",
                "Turkmenistan": "4t,5,9g|4t,5,cd||",
                "Tuvalu": "6h,5,bc|||",
                "Uruguay": "4k,5,9g|4k,5,cd||",
                "Uzbekistan": "39p,5,9g|39p,5,cd||",
                "Vanuatu": "2f,5,9g|2f,5,cd||",
                "Venezuela": "7s,5,bc|||",
                "Vladivostok": "28,5,9g|28,5,cd||",
                "Volgograd": "3f,5,9g|3f,5,cd||",
                "Vostok": "5t,5,bc|||",
                "Wake": "5r,5,38v,5,bc|||",
                "Wallis": "5f,0,ou,0,5k,5,bc|||",
                "Yakutsk": "13v,5,9g|13v,5,cd||",
                "Yekaterinburg": "q6,5,9g|q6,5,cd||"
            }
        },
        "agq": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ak": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "am": {
            "gmtFormat": "ጂ ኤም ቲ{0}",
            "gmtZeroFormat": "ጂ ኤም ቲ",
            "zone": {
                "Europe/Dublin": "|c8i,0,f1,0,8b,0,gm||",
                "Europe/London": "|c8j,0,13f,0,8b,0,gm||"
            },
            "metazone": {
                "Afghanistan": "cee,0,8b|||",
                "Africa_Central": "39s,0,2uo,0,8b|||",
                "Africa_Eastern": "2v4,0,2uo,0,8b|||",
                "Africa_Southern": "56c,0,2uo,0,f1,0,8b|||",
                "Africa_Western": "31h,0,2uo,0,f1,0,8b|31h,0,2uo,0,rm,0,8b||",
                "Alaska": "59s,0,f1,0,15g,0,gm|59s,0,vn,0,8b,0,gm||",
                "Amazon": "5el,0,f1,0,8b,0,gm|5el,0,vn,0,8b,0,gm||",
                "America_Central": "5je,0,f1,0,8b,0,gm|5je,0,vn,0,8b,0,gm||",
                "America_Eastern": "2kp,0,f1,0,15g,0,gm|2kp,0,vn,0,8b,0,gm||",
                "America_Mountain": "5mc,0,f1,0,15g,0,gm|5mc,0,ced,0,gm||",
                "America_Pacific": "5me,0,f1,0,8b,0,gm|5me,0,vn,0,8b,0,gm||",
                "Anadyr": "cec,0,8b,0,gm|ceb,0,13f,0,15g,0,gm||",
                "Apia": "5vj,0,f1,0,8b|5vj,0,vn,0,ce7,0,8b||",
                "Arabian": "641,0,f1,0,8b|641,0,vn,0,1k6,0,8b||",
                "Argentina": "4pv,0,f1,0,8b,0,gm|4pv,0,13f,0,8b,0,gm||",
                "Argentina_Western": "2kp,0,ce6,0,f1,0,8b,0,gm|4pv,0,3a1,0,6bp,0,8b,0,gm||",
                "Armenia": "6d8,0,f1,0,8b|6d8,0,rm,0,8b||",
                "Atlantic": "6go,0,f1,0,15g,0,gm|6go,0,vn,0,8b,0,gm||",
                "Australia_Central": "1r1,0,4pt,0,f1,0,15g,0,gm|1r1,0,4pt,0,vn,0,8b,0,gm||",
                "Australia_CentralWestern": "1r1,0,4pt,0,3a1,0,f1,0,8b,0,gm|1r1,0,ce5,0,6m6,0,vn,0,8b,0,gm||",
                "Australia_Eastern": "1r1,0,6n5,0,f1,0,15g,0,gm|1r1,0,6n5,0,vn,0,8b,0,gm||",
                "Australia_Western": "1r1,0,3a1,0,f1,0,8b,0,gm|1r1,0,3a1,0,vn,0,8b,0,gm||",
                "Azerbaijan": "6n6,0,f1,0,8b|6n6,0,rm,0,8b||",
                "Azores": "6oo,0,f1,0,8b|6oo,0,rm,0,8b||",
                "Bangladesh": "6op,0,f1,0,8b|6op,0,rm,0,8b||",
                "Bhutan": "cdv,0,8b|||",
                "Bolivia": "cdu,0,8b|||",
                "Brasilia": "cdk,0,f1,0,8b,0,gm|cdj,0,13f,0,8b,0,gm||",
                "Brunei": "cdi,0,cdh,0,8b|||",
                "Cape_Verde": "4tu,0,4ud,0,f1,0,8b|4tu,0,4ud,0,rm,0,8b||",
                "Chamorro": "cdg,0,f1,0,8b|||",
                "Chatham": "515,0,f1,0,8b|515,0,vn,0,1k6,0,8b||",
                "Chile": "517,0,f1,0,8b|517,0,rm,0,8b||",
                "China": "51t,0,f1,0,8b|51t,0,vn,0,1k6,0,8b||",
                "Choibalsan": "531,0,f1,0,15g,0,gm|531,0,13f,0,cdf,0,gm||",
                "Christmas": "cde,0,2uq,0,8b|||",
                "Cocos": "cdd,0,1k7,0,8b|||",
                "Colombia": "57l,0,f1,0,8b|57l,0,rm,0,8b||",
                "Cook": "58h,0,1k7,0,f1,0,8b|58h,0,1k7,0,cdc,0,rm,0,8b||",
                "Cuba": "596,0,f1,0,8b|596,0,vn,0,1k6,0,8b||",
                "Davis": "cdb,0,8b|||",
                "DumontDUrville": "cda,5,cd9,0,8b|||",
                "East_Timor": "2v4,0,cd8,0,8b|||",
                "Easter": "5c6,0,2uq,0,f1,0,8b|5c6,0,2uq,0,rm,0,8b||",
                "Ecuador": "cd7,0,8b|||",
                "Europe_Central": "39s,0,2k1,0,f1,0,8b|39s,0,2k1,0,rm,0,8b||",
                "Europe_Eastern": "4p2,0,2k1,0,f1,0,8b|4p2,0,2k1,0,rm,0,8b||",
                "Europe_Further_Eastern": "cd6,0,6m6,0,cd5,0,8b|||",
                "Europe_Western": "2kp,0,2k1,0,f1,0,8b|2kp,0,2k1,0,rm,0,8b||",
                "Falkland": "5lu,0,1k7,0,f1,0,8b|5lu,0,1k7,0,rm,0,8b||",
                "Fiji": "5m1,0,f1,0,8b|5m1,0,rm,0,8b||",
                "French_Guiana": "5m9,0,cd4,0,8b|||",
                "French_Southern": "5m9,0,cd3,0,3gk,0,ccs,0,8b|||",
                "Galapagos": "ccr,0,8b|||",
                "Gambier": "ccq,0,8b|||",
                "Georgia": "5o0,0,f1,0,8b|5o0,0,rm,0,8b||",
                "Gilbert_Islands": "cco,0,1k7,0,8b|||",
                "GMT": "ccl,0,cck,0,8b|||",
                "Greenland_Eastern": "2v4,0,3gl,0,f1,0,8b|2v4,0,3gl,0,rm,0,8b||",
                "Greenland_Western": "31h,0,3gl,0,f1,0,8b|31h,0,3gl,0,rm,0,8b||",
                "Gulf": "ccj,0,f1,0,8b|||",
                "Guyana": "cci,0,8b|||",
                "Hawaii_Aleutian": "5q8,0,5qj,0,f1,0,8b,0,gm|5q8,0,5qj,0,vn,0,8b,0,gm||",
                "Hong_Kong": "5rb,0,5rl,0,f1,0,8b|5rb,0,5rl,0,rm,0,8b||",
                "Hovd": "5rn,0,f1,0,15g,0,gm|5rn,0,13f,0,8b,0,gm||",
                "India": "5sf,0,f1,0,8b|||",
                "Indian_Ocean": "5sf,0,cch,0,8b|||",
                "Indochina": "cc0,0,8b|||",
                "Indonesia_Central": "39s,0,4om,0,8b|||",
                "Indonesia_Eastern": "4p2,0,4om,0,8b|||",
                "Indonesia_Western": "2kp,0,4om,0,8b|||",
                "Iran": "5vk,0,f1,0,8b|5vk,0,vn,0,1k6,0,8b||",
                "Irkutsk": "cbr,0,f1,0,15g,0,gm|cbq,0,13f,0,15g,0,gm||",
                "Israel": "623,0,f1,0,8b|623,0,vn,0,1k6,0,8b||",
                "Japan": "632,0,f1,0,8b|632,0,vn,0,1k6,0,8b||",
                "Kamchatka": "637,0,5,0,63c,0,8b,0,gm|637,0,5,0,63c,0,13f,0,8b,0,gm||",
                "Kazakhstan_Eastern": "2v4,0,63n,0,8b|||",
                "Kazakhstan_Western": "31h,0,63n,0,8b|||",
                "Korea": "63t,0,f1,0,8b|63t,0,vn,0,1k6,0,8b||",
                "Kosrae": "cbk,0,8b|||",
                "Krasnoyarsk": "cbf,0,f1,0,8b,0,gm|cbe,0,13f,0,8b,0,gm||",
                "Kyrgystan": "cbd,0,8b|||",
                "Line_Islands": "cb9,0,1k7,0,8b|||",
                "Lord_Howe": "67b,0,68a,0,f1,0,15g,0,gm|67b,0,68a,0,vn,0,8b,0,gm||",
                "Macquarie": "cb3,0,2uq,0,8b|||",
                "Magadan": "695,0,f1,0,8b,0,gm|695,0,6bp,0,8b,0,gm||",
                "Malaysia": "cb2,0,8b|||",
                "Maldives": "cb1,0,8b|||",
                "Marquesas": "cb0,0,8b|||",
                "Marshall_Islands": "caf,0,1k7,0,8b|||",
                "Mauritius": "6be,0,f1,0,8b|6be,0,rm,0,8b||",
                "Mawson": "cae,0,8b|||",
                "Mexico_Northwest": "6c9,0,6cb,0,3i1,0,f1,0,8b,0,gm|6c9,0,6cb,0,3i1,0,vn,0,8b,0,gm||",
                "Mexico_Pacific": "3i1,0,6d9,0,f1,0,8b,0,gm|3i1,0,6d9,0,vn,0,8b,0,gm||",
                "Mongolia": "6fk,0,6g1,0,f1,0,8b,0,gm|6fk,0,6g1,0,13f,0,8b,0,gm||",
                "Moscow": "6gf,0,f1,0,8b,0,gm|6gf,0,13f,0,8b,0,gm||",
                "Myanmar": "cad,0,8b|||",
                "Nauru": "cac,0,8b|||",
                "Nepal": "cab,0,8b|||",
                "New_Caledonia": "3i2,0,6gq,0,f1,0,8b|3i2,0,6gq,0,rm,0,8b||",
                "New_Zealand": "3i2,0,6gu,0,f1,0,8b|3i2,0,6gu,0,vn,0,1k6,0,8b||",
                "Newfoundland": "6h0,0,f1,0,15g,0,gm|6h0,0,vn,0,15g,0,gm||",
                "Niue": "ca9,0,8b|||",
                "Norfolk": "ca6,0,1k7,0,8b|||",
                "Noronha": "6hp,0,6ic,0,ca5,0,f1,0,8b,0,gm|6hp,0,6ic,0,ca0,0,13f,0,15g,0,gm||",
                "Novosibirsk": "c9u,0,f1,0,15g,0,gm|c9t,0,13f,0,c9s,0,gm||",
                "Omsk": "6mi,0,f1,0,8b,0,gm|6mi,0,13f,0,8b,0,gm||",
                "Pakistan": "6mm,0,f1,0,8b|6mm,0,rm,0,8b||",
                "Palau": "c9r,0,8b|||",
                "Papua_New_Guinea": "c9o,0,c9m,0,c9l,0,8b|||",
                "Paraguay": "6nf,0,f1,0,8b|6nf,0,rm,0,8b||",
                "Peru": "6nl,0,f1,0,8b|6nl,0,rm,0,8b||",
                "Philippines": "6nm,0,f1,0,8b|6nm,0,rm,0,8b||",
                "Phoenix_Islands": "c9k,0,1k7,0,8b|||",
                "Pierre_Miquelon": "6o3,0,6o8,0,3gk,0,6oa,0,f1,0,8b|6o3,0,6o8,0,3gk,0,6oa,0,vn,0,1k6,0,8b||",
                "Pitcairn": "c9j,0,8b|||",
                "Ponape": "c9a,0,8b|||",
                "Pyongyang": "c99,0,8b|||",
                "Reunion": "c98,0,8b|||",
                "Rothera": "c97,0,8b|||",
                "Sakhalin": "6pe,0,f1,0,8b,0,gm|6pe,0,13f,0,8b,0,gm||",
                "Samara": "6po,0,f1,0,8b,0,gm|6po,0,13f,0,8b,0,gm||",
                "Samoa": "6pu,0,f1,0,8b|6pu,0,13f,0,8b||",
                "Seychelles": "c91,0,8b|||",
                "Singapore": "c90,0,f1,0,8b|||",
                "Solomon": "c8v,0,1k7,0,8b|||",
                "South_Georgia": "56c,0,c8r,0,8b|||",
                "Suriname": "c8q,0,8b|||",
                "Syowa": "c8p,0,8b|||",
                "Tahiti": "c8o,0,8b|||",
                "Taipei": "8ck,0,f1,0,8b|8ck,0,vn,0,1k6,0,8b||",
                "Tajikistan": "c8n,0,8b|||",
                "Tokelau": "c8m,0,8b|||",
                "Tonga": "8iv,0,f1,0,8b|8iv,0,rm,0,8b||",
                "Truk": "c8l,0,8b|||",
                "Turkmenistan": "4s3,0,f1,0,8b|4s3,0,rm,0,8b||",
                "Tuvalu": "c8k,0,8b|||",
                "Uruguay": "4s5,0,f1,0,8b|4s5,0,rm,0,8b||",
                "Uzbekistan": "4sd,0,f1,0,8b|4sd,0,rm,0,8b||",
                "Vanuatu": "4st,0,f1,0,8b|4st,0,rm,0,8b||",
                "Venezuela": "c8h,0,8b|||",
                "Vladivostok": "c8g,0,f1,0,15g,0,gm|c8b,0,13f,0,15g,0,gm||",
                "Volgograd": "c8a,0,f1,0,8b,0,gm|c87,0,13f,0,8b,0,gm||",
                "Vostok": "c86,0,8b|||",
                "Wake": "c85,0,2uq,0,8b|||",
                "Wallis": "c84,0,3gk,0,c83,0,8b|||",
                "Yakutsk": "c82,0,f1,0,8b,0,gm|c81,0,13f,0,8b,0,gm||",
                "Yekaterinburg": "53s,0,f1,0,8b,0,gm|53s,0,13f,0,8b,0,gm||"
            }
        },
        "ar-AE": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-BH": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-DJ": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-DZ": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-EG": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-EH": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-ER": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-IL": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-IQ": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-JO": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-KM": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-KW": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-LB": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-LY": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-MA": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-MR": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-OM": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-PS": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-QA": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-SA": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-SD": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-SO": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-SS": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-SY": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-TD": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-TN": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar-YE": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "ar": {
            "gmtFormat": "جرينتش{0}",
            "gmtZeroFormat": "جرينتش",
            "zone": {
                "Europe/Dublin": "|7,0,uf,0,h||",
                "Europe/London": "|7,0,v3,0,g||"
            },
            "metazone": {
                "Afghanistan": "7,0,tv|||",
                "Africa_Central": "7,0,7k,0,ap|||",
                "Africa_Eastern": "7,0,51,0,ap|||",
                "Africa_Southern": "7,0,ij,0,ap|||",
                "Africa_Western": "7,0,2e,0,ap,0,h|7,0,2e,0,ap,0,g||",
                "Alaska": "1o,0,h,0,v1|7,0,tl,0,g||",
                "Amazon": "7,0,iv,0,h|7,0,iv,0,g||",
                "America_Central": "1o,0,h,0,j2,0,9j,0,8m|1o,0,g,0,j2,0,9j,0,8m||",
                "America_Eastern": "1o,0,h,0,ji,0,9j,0,8m|1o,0,g,0,ji,0,9j,0,8m||",
                "America_Mountain": "1o,0,jl,0,h,0,9j,0,8m|1o,0,jl,0,g,0,9j,0,8m||",
                "America_Pacific": "7,0,ao,0,bt,0,h|7,0,ao,0,bt,0,g||",
                "Anadyr": "7,0,v5,0,h|1o,0,g,0,vc||",
                "Apia": "1o,0,h,0,s8|1o,0,g,0,t4||",
                "Arabian": "1o,0,k5,0,h|1o,0,k5,0,g||",
                "Argentina": "7,0,bq,0,h|7,0,bq,0,g||",
                "Argentina_Western": "7,0,2e,0,bq,0,h|7,0,2e,0,bq,0,g||",
                "Armenia": "7,0,k9,0,h|7,0,k9,0,g||",
                "Atlantic": "1o,0,h,0,kr|1o,0,g,0,kr||",
                "Australia_Central": "7,0,7k,0,7i,0,h|7,0,7k,0,7i,0,g||",
                "Australia_CentralWestern": "7,0,2e,0,7k,0,7i,0,h|7,0,2e,0,7k,0,7i,0,g||",
                "Australia_Eastern": "7,0,51,0,7i,0,h|7,0,51,0,7i,0,g||",
                "Australia_Western": "7,0,2e,0,7i,0,h|7,0,2e,0,7i,0,g||",
                "Azerbaijan": "7,0,l9,0,h|7,0,l9,0,g||",
                "Azores": "7,0,la,0,h|7,0,la,0,g||",
                "Bangladesh": "7,0,li,0,h|7,0,li,0,g||",
                "Bhutan": "7,0,rp|||",
                "Bolivia": "7,0,t5|||",
                "Brasilia": "7,0,j1,0,h|7,0,j1,0,g||",
                "Brunei": "7,0,u4|||",
                "Cape_Verde": "7,0,j3,0,j4,0,h|7,0,j3,0,j4,0,g||",
                "Chamorro": "7,0,v9|||",
                "Chatham": "7,0,j8,0,h|7,0,j8,0,g||",
                "Chile": "7,0,jf,0,h|7,0,jf,0,g||",
                "China": "7,0,jg,0,h|7,0,jg,0,g||",
                "Choibalsan": "7,0,vb,0,h|1o,0,g,0,um||",
                "Christmas": "7,0,42,0,un|||",
                "Cocos": "7,0,42,0,ut|||",
                "Colombia": "7,0,jr,0,h|7,0,jr,0,g||",
                "Cook": "7,0,42,0,js,0,h|7,0,42,0,js,0,g||",
                "Cuba": "7,0,jv,0,h|7,0,jv,0,g||",
                "Davis": "7,0,vh|||",
                "DumontDUrville": "7,0,fb,0,sa,0,sl,0,so|||",
                "East_Timor": "7,0,t1,0,t2|||",
                "Easter": "7,0,bs,0,k4,0,h|7,0,bs,0,k4,0,g||",
                "Ecuador": "7,0,ta|||",
                "Europe_Central": "7,0,7k,0,9h,0,h|7,0,7k,0,9h,0,g||",
                "Europe_Eastern": "7,0,51,0,9h,0,h|7,0,51,0,9h,0,g||",
                "Europe_Further_Eastern": "1o,0,ti,0,tm,0,ue|||",
                "Europe_Western": "7,0,2e,0,9h,0,h|7,0,2e,0,9h,0,g||",
                "Falkland": "7,0,42,0,kd,0,h|7,0,42,0,kd,0,g||",
                "Fiji": "7,0,kg,0,h|7,0,kg,0,g||",
                "French_Guiana": "7,0,v2,0,kk|||",
                "French_Southern": "7,0,st,0,kk,0,t8,0,td|||",
                "Galapagos": "7,0,tg|||",
                "Gambier": "7,0,to|||",
                "Georgia": "7,0,f9,0,h|7,0,f9,0,g||",
                "Gilbert_Islands": "7,0,42,0,u6|||",
                "GMT": "7,0,ua|||",
                "Greenland_Eastern": "7,0,51,0,bo,0,h|7,0,51,0,bo,0,g||",
                "Greenland_Western": "7,0,2e,0,bo,0,h|7,0,2e,0,bo,0,g||",
                "Guam": "7,0,ub|||",
                "Gulf": "7,0,uc|||",
                "Guyana": "7,0,ud|||",
                "Hawaii_Aleutian": "7,0,lg,0,lj,0,h|7,0,lg,0,lj,0,g||",
                "Hong_Kong": "7,0,lk,0,ll,0,h|7,0,lk,0,ll,0,g||",
                "Hovd": "7,0,ld,0,h|7,0,ld,0,g||",
                "India": "7,0,lb|||",
                "Indian_Ocean": "7,0,ao,0,sj|||",
                "Indochina": "7,0,lb,0,sk|||",
                "Indonesia_Central": "7,0,7k,0,f5|||",
                "Indonesia_Eastern": "7,0,51,0,f5|||",
                "Indonesia_Western": "7,0,2e,0,f5|||",
                "Iran": "7,0,l5,0,h|7,0,l5,0,g||",
                "Irkutsk": "7,0,l1,0,h|7,0,l1,0,g||",
                "Israel": "7,0,ku,0,h|7,0,ku,0,g||",
                "Japan": "7,0,ks,0,h|7,0,ks,0,g||",
                "Kamchatka": "7,0,kq,5,kp|7,0,kq,5,kp,0,g||",
                "Kazakhstan_Eastern": "7,0,51,0,km|||",
                "Kazakhstan_Western": "7,0,2e,0,km|||",
                "Korea": "7,0,kl,0,h|7,0,kl,0,g||",
                "Kosrae": "7,0,tt|||",
                "Krasnoyarsk": "7,0,tu,0,h|1o,0,g,0,u3||",
                "Kyrgystan": "7,0,u9|||",
                "Line_Islands": "7,0,42,0,s2|||",
                "Lord_Howe": "7,0,rh,0,k2,0,h|1o,0,g,0,uo,0,k2||",
                "Macquarie": "7,0,sn|||",
                "Magadan": "7,0,ja,0,h|7,0,ja,0,g||",
                "Malaysia": "7,0,tc|||",
                "Maldives": "7,0,te|||",
                "Marquesas": "7,0,th|||",
                "Marshall_Islands": "7,0,42,0,rb|||",
                "Mauritius": "7,0,l8,0,h|7,0,l8,0,g||",
                "Mawson": "7,0,rj|||",
                "Mexico_Northwest": "1o,0,h,0,k3,0,2e,0,jt|1o,0,g,0,k3,0,2e,0,jt||",
                "Mexico_Pacific": "7,0,ao,0,bt,0,h,0,jd|7,0,ao,0,bt,0,g,0,jd||",
                "Mongolia": "7,0,jc,0,jb,0,h|7,0,jc,0,jb,0,g||",
                "Moscow": "7,0,j0,0,h|7,0,j0,0,g||",
                "Myanmar": "7,0,uh|||",
                "Nauru": "7,0,ui|||",
                "Nepal": "7,0,ul|||",
                "New_Caledonia": "7,0,kc,0,f2,0,h|7,0,kc,0,f2,0,g||",
                "New_Zealand": "7,0,lm,0,h|7,0,lm,0,g||",
                "Newfoundland": "7,0,jq,0,h|7,0,jq,0,g||",
                "Niue": "7,0,s7|||",
                "Norfolk": "7,0,bs,0,s6|||",
                "Noronha": "7,0,ig,0,fb,0,l6,0,h|7,0,ig,0,fb,0,l6,0,g||",
                "North_Mariana": "7,0,42,0,v6,0,8m|||",
                "Novosibirsk": "7,0,j5,0,h|7,0,j5,0,g||",
                "Omsk": "7,0,j6,0,h|7,0,j6,0,g||",
                "Pakistan": "7,0,j7,0,h|7,0,j7,0,g||",
                "Palau": "7,0,si|||",
                "Papua_New_Guinea": "7,0,ss,0,su,0,f2|||",
                "Paraguay": "7,0,kb,0,h|7,0,kb,0,g||",
                "Peru": "7,0,kn,0,h|7,0,kn,0,g||",
                "Philippines": "7,0,l2,0,h|7,0,l2,0,g||",
                "Phoenix_Islands": "7,0,42,0,tf|||",
                "Pierre_Miquelon": "7,0,l3,0,l4,0,l7,0,h|7,0,l3,0,l4,0,l7,0,g||",
                "Pitcairn": "7,0,tk|||",
                "Ponape": "7,0,tr|||",
                "Pyongyang": "7,0,ts,0,u1|||",
                "Reunion": "7,0,u5|||",
                "Rothera": "7,0,u7|||",
                "Sakhalin": "7,0,k0,0,h|7,0,k0,0,g||",
                "Samara": "7,0,if|7,0,if,0,g||",
                "Samoa": "7,0,ie,0,h|7,0,ie,0,g||",
                "Seychelles": "7,0,us|||",
                "Singapore": "7,0,uv|||",
                "Solomon": "7,0,42,0,v7|||",
                "South_Georgia": "7,0,ij,0,f9|||",
                "Suriname": "7,0,vd|||",
                "Syowa": "7,0,ve|||",
                "Tahiti": "7,0,vf|||",
                "Taipei": "7,0,jp,0,h|7,0,jp,0,g||",
                "Tajikistan": "7,0,vg|||",
                "Tokelau": "7,0,va|||",
                "Tonga": "7,0,j9,0,h|7,0,j9,0,g||",
                "Truk": "7,0,v8|||",
                "Turkmenistan": "7,0,jj,0,h|7,0,jj,0,g||",
                "Tuvalu": "7,0,v4|||",
                "Uruguay": "7,0,jm,0,h|7,0,jm,0,g||",
                "Uzbekistan": "7,0,ka,0,h|7,0,ka,0,g||",
                "Vanuatu": "7,0,ko,0,h|7,0,ko,0,g||",
                "Venezuela": "7,0,v0|||",
                "Vladivostok": "7,0,it,0,h|7,0,it,0,g||",
                "Volgograd": "7,0,iu,0,h|7,0,iu,0,g||",
                "Vostok": "7,0,uq|||",
                "Wake": "7,0,bs,0,up|||",
                "Wallis": "7,0,uj,0,pu,0,rg|||",
                "Yakutsk": "7,0,k7,0,h|7,0,k7,0,g||",
                "Yekaterinburg": "7,0,le,0,h|7,0,le,0,g||"
            }
        },
        "as": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "India": "c80,0,2n||c7v,0,c7u|"
            }
        },
        "asa": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ast": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,d,0,8iu||",
                "Europe/London": "|9,0,eq,0,sc||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "8,0,d,0,61o|8,0,eq,0,61o||",
                "Afghanistan": "9,0,c7t|||",
                "Africa_Central": "9,0,3im,0,6r|||",
                "Africa_Eastern": "9,0,3im,0,19,0,sr|||",
                "Africa_Southern": "9,0,2,0,sf|||",
                "Africa_Western": "9,0,d,0,3im,0,19,0,2a6|9,0,eq,0,3im,0,19,0,2a6||",
                "Alaska": "9,0,d,0,1ht|9,0,eq,0,1ht|18f|18t",
                "Almaty": "8,0,d,0,670|8,0,eq,0,670||",
                "Amazon": "9,0,d,0,19,0,bg|9,0,eq,0,19,0,bg||",
                "America_Central": "9,0,d,0,6r,0,683|9,0,eq,0,6r,0,683|19q|19p",
                "America_Eastern": "9,0,d,0,19,0,sr,0,3in|9,0,eq,0,19,0,sr,0,3in|19o|19n",
                "America_Mountain": "9,0,d,0,2,0,et,0,6ah,0,6ap|9,0,eq,0,2,0,et,0,6ah,0,6ap|18r|16i",
                "America_Pacific": "9,0,d,0,19,0,3io,0,3in|9,0,eq,0,19,0,3io,0,3in|19l|19k",
                "Anadyr": "8,0,d,0,cb|8,0,eq,0,cb||",
                "Apia": "9,0,d,0,c9|9,0,eq,0,c9||",
                "Aqtau": "9,0,d,0,6e1|9,0,eq,0,6e1||",
                "Aqtobe": "9,0,d,0,6e5|9,0,eq,0,6e5||",
                "Arabian": "9,0,d,0,6ed|9,0,eq,0,6ed||",
                "Argentina": "9,0,d,0,3is|9,0,eq,0,3is||",
                "Argentina_Western": "9,0,d,0,48,0,3is|9,0,eq,0,48,0,3is||",
                "Armenia": "9,0,d,0,6gd|9,0,eq,0,6gd||",
                "Atlantic": "9,0,d,0,19,0,6ge|9,0,eq,0,19,0,6ge|19i|190",
                "Australia_Central": "9,0,d,0,1rq,0,6r|9,0,eq,0,1rq,0,6r||",
                "Australia_CentralWestern": "9,0,d,0,1rq,0,6r,0,19,0,2a6|9,0,eq,0,1rq,0,6r,0,19,0,2a6||",
                "Australia_Eastern": "9,0,d,0,1rq,0,19,0,sr|9,0,eq,0,1rq,0,19,0,sr||",
                "Australia_Western": "9,0,d,0,1rq,0,19,0,2a6|9,0,eq,0,1rq,0,19,0,2a6||",
                "Azerbaijan": "9,0,d,0,6gl|9,0,eq,0,6gl||",
                "Azores": "9,0,d,0,2,0,et,0,4r|9,0,eq,0,2,0,4n7,0,4r||",
                "Bangladesh": "9,0,d,0,2,0,6gp|9,0,eq,0,2,0,6gp||",
                "Bhutan": "9,0,2,0,s5|||",
                "Bolivia": "9,0,2,0,aa|||",
                "Brasilia": "9,0,d,0,2,0,3a|9,0,eq,0,2,0,3a||",
                "Brunei": "9,0,2,0,gs,0,a4|||",
                "Cape_Verde": "9,0,d,0,2,0,6h1,0,3j|9,0,eq,0,2,0,6h1,0,3j||",
                "Casey": "9,0,2,0,b7|||",
                "Chamorro": "9,0,d,0,2,0,6j|||",
                "Chatham": "9,0,d,0,2,0,27|9,0,eq,0,2,0,27||",
                "Chile": "9,0,d,0,2,0,49|9,0,eq,0,2,0,49||",
                "China": "9,0,d,0,2,0,4h|9,0,eq,0,2,0,4h||",
                "Choibalsan": "9,0,d,0,2,0,2q|9,0,eq,0,2,0,2q||",
                "Christmas": "9,0,d,0,2,0,1c,0,2j2,0,99|||",
                "Cocos": "9,0,2,0,et,0,1kb,0,7v|||",
                "Colombia": "9,0,d,0,2,0,4m|9,0,eq,0,2,0,4m||",
                "Cook": "9,0,d,0,2,0,et,0,1kb,0,2v|9,0,r1,0,eq,0,2,0,et,0,1kb,0,2v||",
                "Cuba": "9,0,d,0,2,0,34|9,0,eq,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,d,0,2,0,1c,0,2j2,0,2,0,iq|9,0,eq,0,2,0,1c,0,2j2,0,2,0,iq||",
                "Ecuador": "9,0,c7s|||",
                "Europe_Central": "9,0,d,0,pn,0,n|9,0,eq,0,pn,0,n||",
                "Europe_Eastern": "9,0,d,0,pn,0,19,0,3it|9,0,eq,0,pn,0,19,0,3it||",
                "Europe_Further_Eastern": "9,0,pn,0,19,0,c7q,0,sr|||",
                "Europe_Western": "9,0,d,0,pn,0,of|9,0,eq,0,pn,0,of||",
                "Falkland": "9,0,d,0,2,0,et,0,1kb,0,4v|9,0,eq,0,2,0,et,0,1kb,0,4v||",
                "Fiji": "9,0,d,0,2,0,6o7|9,0,eq,0,2,0,6o7||",
                "French_Guiana": "9,0,2,0,mv,0,7a,0,nf|||",
                "French_Southern": "9,0,19,0,c7o,0,bk,0,c7n,0,c7m|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,d,0,2,0,4n4|9,0,eq,0,2,0,4n4||",
                "Gilbert_Islands": "9,0,2,0,et,0,1kb,0,6q|||",
                "GMT": "9,0,r1,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,d,0,2,0,b2,0,3r|9,0,eq,0,2,0,b2,0,3r||",
                "Greenland_Western": "9,0,d,0,2,0,b2,0,48|9,0,eq,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "9,0,d,0,19,0,c7l|||",
                "Guyana": "9,0,2,0,mv,0,7a|||",
                "Hawaii_Aleutian": "9,0,d,0,2,0,4g,5,1i5|9,0,eq,0,2,0,4g,5,1i5|17j|17l",
                "Hong_Kong": "9,0,d,0,2,0,78a,0,2p|9,0,eq,0,2,0,78a,0,2p||",
                "Hovd": "9,0,d,0,2,0,2g|9,0,eq,0,2,0,2g||",
                "India": "9,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "9,0,19,0,c7k,0,c7j|||",
                "Indochina": "9,0,c7i|||",
                "Indonesia_Central": "9,0,4n3,0,6r|||",
                "Indonesia_Eastern": "9,0,4n3,0,19,0,sr|||",
                "Indonesia_Western": "9,0,4n3,0,19,0,2a6|||",
                "Iran": "9,0,d,0,8ho|9,0,eq,0,8ho||",
                "Irkutsk": "9,0,d,0,1ia|9,0,eq,0,1ia||",
                "Israel": "9,0,d,0,1ic|9,0,eq,0,1ic||",
                "Japan": "9,0,d,0,2,0,3iu|9,0,eq,0,2,0,3iu||",
                "Kamchatka": "8,0,c7h,0,2,0,37,5,3k|8,0,eq,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,19,0,8j6,0,3r|||",
                "Kazakhstan_Western": "9,0,19,0,8j6,0,48|||",
                "Korea": "9,0,d,0,2,0,hf|9,0,eq,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,d,0,2,0,41|9,0,eq,0,2,0,41||",
                "Kyrgystan": "9,0,19,0,sp|||",
                "Lanka": "9,0,2,0,9c|||",
                "Line_Islands": "9,0,2,0,et,0,1kb,0,ac|||",
                "Lord_Howe": "9,0,d,0,2,0,1u,0,24|9,0,eq,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,4s7|9,0,eq,0,2,0,4s7||",
                "Macquarie": "9,0,2,0,1c,0,2j2,0,6m|||",
                "Magadan": "9,0,d,0,2,0,jh|9,0,eq,0,2,0,jh||",
                "Malaysia": "9,0,2,0,sh|||",
                "Maldives": "9,0,2,0,4n7,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,1kb,0,7o|||",
                "Mauritius": "9,0,d,0,2,0,50o|9,0,eq,0,2,0,50o||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,d,0,19,0,jn,0,2,0,3j1|9,0,eq,0,19,0,jn,0,2,0,3j1||",
                "Mexico_Pacific": "9,0,d,0,19,0,3io,0,2,0,3j1|9,0,eq,0,19,0,3io,0,2,0,3j1||",
                "Mongolia": "9,0,d,0,516,0,3j2|9,0,eq,0,516,0,3j2||",
                "Moscow": "9,0,d,0,2,0,k6|9,0,eq,0,2,0,k6||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,d,0,2,0,an,0,4o|9,0,eq,0,2,0,an,0,4o||",
                "New_Zealand": "9,0,d,0,2,0,an,0,go|9,0,eq,0,2,0,an,0,go||",
                "Newfoundland": "9,0,d,0,2,0,53|9,0,eq,0,2,0,53||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,1c,0,2j2,0,6l|||",
                "Noronha": "9,0,d,0,2,0,1s,0,2,0,23|9,0,eq,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,et,0,1kb,0,c7g,0,19,0,p4|||",
                "Novosibirsk": "9,0,d,0,2,0,3b|9,0,eq,0,2,0,3b||",
                "Omsk": "9,0,d,0,1d1|9,0,eq,0,1d1||",
                "Pakistan": "9,0,d,0,19,0,3j4|9,0,eq,0,19,0,3j4||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "9,0,d,0,19,0,58f|9,0,eq,0,19,0,58f||",
                "Peru": "9,0,d,0,19,0,ha|9,0,eq,0,19,0,ha||",
                "Philippines": "9,0,d,0,2,0,1jb|9,0,2,0,c7f,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,1kb,0,90|||",
                "Pierre_Miquelon": "9,0,d,0,2,0,8i,0,33,0,bk,0,35|9,0,eq,0,2,0,8i,0,33,0,bk,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,eq,0,2,0,4d||",
                "Reunion": "9,0,2,0,s4|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,d,0,2,0,5ad|9,0,eq,0,2,0,5ad||",
                "Samara": "9,0,d,0,2,0,29|9,0,eq,0,2,0,29||",
                "Samoa": "9,0,d,0,2,0,2c|9,0,eq,0,2,0,2c||",
                "Seychelles": "9,0,2,0,4n7,0,5an|||",
                "Singapore": "9,0,d,0,2,0,m8|||",
                "Solomon": "9,0,2,0,et,0,1kb,0,s1|||",
                "South_Georgia": "9,0,2,0,4n4,0,19,0,4mu|||",
                "Suriname": "9,0,19,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,8n|||",
                "Taipei": "9,0,d,0,2,0,lf|9,0,eq,0,2,0,lf||",
                "Tajikistan": "9,0,19,0,5et|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,d,0,2,0,2j|9,0,eq,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,d,0,19,0,lh|9,0,eq,0,19,0,lh||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,d,0,19,0,5jo|9,0,eq,0,19,0,5jo||",
                "Uzbekistan": "9,0,d,0,19,0,5ka|9,0,eq,0,19,0,5ka||",
                "Vanuatu": "9,0,d,0,2,0,2f|9,0,eq,0,2,0,2f||",
                "Venezuela": "9,0,2,0,7s|||",
                "Vladivostok": "9,0,d,0,2,0,28|9,0,eq,0,2,0,28||",
                "Volgograd": "9,0,d,0,2,0,5kf|9,0,eq,0,2,0,5kf||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,1c,0,2j2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "9,0,d,0,2,0,3u|9,0,eq,0,2,0,3u||",
                "Yekaterinburg": "9,0,d,0,2,0,5kq|9,0,eq,0,2,0,5kq||"
            }
        },
        "az-Cyrl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "az-Latn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|772,0,a3,0,30||",
                "Europe/London": "|3i5,0,a3,0,30||"
            },
            "metazone": {
                "Afghanistan": "5lp,0,30|||",
                "Africa_Central": "13u,0,c5,0,30|||",
                "Africa_Eastern": "105,0,c5,0,30|||",
                "Africa_Southern": "2ir,0,c5,0,30|||",
                "Africa_Western": "r0,0,c5,0,44,0,30|r0,0,c5,0,a3,0,30||",
                "Alaska": "1rr,0,44,0,30|1rr,0,a3,0,30||",
                "Amazon": "5m,0,44,0,30|5m,0,a3,0,30||",
                "America_Central": "17g,0,13u,0,m2,0,44,0,30|17g,0,13u,0,m2,0,a3,0,30||",
                "America_Eastern": "17g,0,105,0,m2,0,44,0,30|17g,0,105,0,m2,0,a3,0,30||",
                "America_Mountain": "17g,0,3j5,0,m2,0,44,0,30|17g,0,3j5,0,m2,0,a3,0,30||",
                "America_Pacific": "17g,0,m2,0,1ru,0,1rv,0,44,0,30|17g,0,m2,0,1ru,0,1rv,0,a3,0,30||",
                "Apia": "3e,0,44,0,30|3e,0,a3,0,30||",
                "Arabian": "3j6,0,44,0,30|3j6,0,a3,0,30||",
                "Argentina": "1e,0,44,0,30|1e,0,a3,0,30||",
                "Argentina_Western": "r0,0,1e,0,44,0,30|r0,0,1e,0,a3,0,30||",
                "Armenia": "3ja,0,44,0,30|3ja,0,a3,0,30||",
                "Atlantic": "r2,0,44,0,5ra|r2,0,a3,0,30||",
                "Australia_Central": "13u,0,r3,0,44,0,30|13u,0,r3,0,a3,0,30||",
                "Australia_CentralWestern": "13u,0,r0,0,r3,0,44,0,30|13u,0,r0,0,r3,0,a3,0,30||",
                "Australia_Eastern": "105,0,r3,0,44,0,30|105,0,r3,0,a3,0,30||",
                "Australia_Western": "r0,0,r3,0,44,0,30|r0,0,r3,0,a3,0,30||",
                "Azerbaijan": "3je,0,44,0,30|3je,0,a3,0,30||",
                "Azores": "1lg,0,44,0,30|1lg,0,a3,0,30||",
                "Bangladesh": "3jg,0,44,0,30|3jg,0,a3,0,30||",
                "Bhutan": "1k4,0,30|||",
                "Bolivia": "3jj,0,30|||",
                "Brasilia": "1s2,0,44,0,30|1s2,0,a3,0,30||",
                "Brunei": "9o,0,a4,0,1b4|||",
                "Cape_Verde": "3jk,0,3j,0,44,0,30|3jk,0,3j,0,a3,0,30||",
                "Chamorro": "4mm,0,30|||",
                "Chatham": "3jl,0,44,0,30|3jl,0,a3,0,30||",
                "Chile": "2i3,0,44,0,30|2i3,0,a3,0,30||",
                "China": "1s7,0,44,0,30|1s7,0,a3,0,30||",
                "Choibalsan": "1s8,0,44,0,30|1s8,0,a3,0,30||",
                "Christmas": "63j,0,137,0,30|||",
                "Cocos": "1eg,0,nl,0,30|||",
                "Colombia": "1s9,0,44,0,30|1s9,0,a3,0,30||",
                "Cook": "1ec,0,nl,0,44,0,30|1ec,0,nl,0,64h,0,a3,0,30||",
                "Cuba": "tb,0,44,0,30|tb,0,a3,0,30||",
                "Davis": "64p,0,30|||",
                "DumontDUrville": "64u,5,652,0,30|||",
                "East_Timor": "105,0,7n,0,30|||",
                "Easter": "1sa,0,137,0,44,0,30|1sa,0,137,0,a3,0,30||",
                "Ecuador": "1k0,0,30|||",
                "Europe_Central": "13u,0,1dv,0,44,0,30|13u,0,1dv,0,a3,0,30||",
                "Europe_Eastern": "105,0,1dv,0,44,0,30|105,0,1dv,0,a3,0,30||",
                "Europe_Further_Eastern": "677,0,105,0,1dv,0,30|||",
                "Europe_Western": "r0,0,1dv,0,44,0,30|r0,0,1dv,0,a3,0,30||",
                "Falkland": "1ov,0,nl,0,44,0,30|1ov,0,nl,0,a3,0,30||",
                "Fiji": "3jn,0,44,0,30|3jn,0,a3,0,30||",
                "French_Guiana": "1sb,0,68e,0,30|||",
                "French_Southern": "1sb,0,2ir,0,1sc,0,68j,0,30|||",
                "Galapagos": "68k,0,30|||",
                "Gambier": "68u,0,30|||",
                "Georgia": "3jo,0,44,0,30|3jo,0,a3,0,30||",
                "Gilbert_Islands": "6q,0,nl,0,30|||",
                "GMT": "69u,0,1bn,0,30|||",
                "Greenland_Eastern": "105,0,1sf,0,44,0,30|105,0,1sf,0,a3,0,30||",
                "Greenland_Western": "r0,0,1sf,0,44,0,30|r0,0,1sf,0,a3,0,30||",
                "Gulf": "6ab,0,30|||",
                "Guyana": "6ad,0,30|||",
                "Hawaii_Aleutian": "3jp,5,1l3,0,44,0,30|3jp,5,1l3,0,a3,0,30||",
                "Hong_Kong": "3k1,0,3k3,0,44,0,30|3k1,0,3k3,0,a3,0,30||",
                "Hovd": "2g,0,44,0,30|2g,0,a3,0,30||",
                "India": "30i,0,30|||",
                "Indian_Ocean": "3k9,0,6bt,0,30|||",
                "Indochina": "6c8,0,30|||",
                "Indonesia_Central": "13u,0,2hk,0,30|||",
                "Indonesia_Eastern": "105,0,2hk,0,30|||",
                "Indonesia_Western": "r0,0,2hk,0,30|||",
                "Iran": "1sj,0,44,0,30|1sj,0,a3,0,30||",
                "Irkutsk": "1sk,0,44,0,30|1sk,0,a3,0,30||",
                "Israel": "1sl,0,44,0,30|1sl,0,a3,0,30||",
                "Japan": "1sn,0,44,0,30|1sn,0,a3,0,30||",
                "Kazakhstan_Eastern": "105,0,3kc,0,30|||",
                "Kazakhstan_Western": "r0,0,3kc,0,30|||",
                "Korea": "1so,0,44,0,30|1so,0,a3,0,30||",
                "Kosrae": "6ei,0,30|||",
                "Krasnoyarsk": "41,0,44,0,30|41,0,a3,0,30||",
                "Kyrgystan": "6fj,0,30|||",
                "Line_Islands": "3kd,0,nl,0,30|||",
                "Lord_Howe": "1u,0,1i2,0,44,0,30|1u,0,1i2,0,a3,0,1b4||",
                "Macquarie": "6g4,0,137,0,30|||",
                "Magadan": "3ke,0,44,0,30|3ke,0,a3,0,30||",
                "Malaysia": "3kk,0,30|||",
                "Maldives": "3kl,0,30|||",
                "Marquesas": "6gg,0,30|||",
                "Marshall_Islands": "4m6,0,nl,0,30|||",
                "Mauritius": "3kn,0,44,0,30|3kn,0,a3,0,30||",
                "Mawson": "2v0,0,30|||",
                "Mexico_Northwest": "3ko,5,r0,0,10g,0,44,0,30|3ko,5,r0,0,10g,0,a3,0,30||",
                "Mexico_Pacific": "10g,0,1ru,0,1rv,0,44,0,30|10g,0,1ru,0,1rv,0,a3,0,30||",
                "Mongolia": "3kp,0,44,0,30|3kp,0,a3,0,30||",
                "Moscow": "pi,0,44,0,30|pi,0,a3,0,1b4||",
                "Myanmar": "3kq,0,30|||",
                "Nauru": "5v,0,30|||",
                "Nepal": "8u,0,1b4|||",
                "New_Caledonia": "142,0,1ss,0,44,0,30|142,0,1ss,0,a3,0,30||",
                "New_Zealand": "142,0,1st,0,44,0,30|142,0,1st,0,a3,0,30||",
                "Newfoundland": "1ta,0,44,0,30|1ta,0,a3,0,30||",
                "Niue": "8g,0,30|||",
                "Norfolk": "6l,0,137,0,30|||",
                "Noronha": "1s,0,2,0,1tb,0,44,0,30|1s,0,2,0,1tb,0,a3,0,30||",
                "Novosibirsk": "3b,0,44,0,30|3b,0,a3,0,30||",
                "Omsk": "26,0,44,0,30|26,0,a3,0,30||",
                "Pakistan": "3i,0,44,0,1b4|3i,0,a3,0,30||",
                "Palau": "9b,0,30|||",
                "Papua_New_Guinea": "9a,0,142,0,6j2,0,30|||",
                "Paraguay": "3ks,0,44,0,30|3ks,0,a3,0,30||",
                "Peru": "4n,0,44,0,30|4n,0,a3,0,30||",
                "Philippines": "1tc,0,44,0,30|1tc,0,a3,0,30||",
                "Phoenix_Islands": "1a7,0,nl,0,30|||",
                "Pierre_Miquelon": "io,0,1p8,0,1sc,0,u2,0,44,0,30|io,0,1p8,0,1sc,0,u2,0,a3,0,30||",
                "Pitcairn": "1ko,0,30|||",
                "Ponape": "9s,0,30|||",
                "Pyongyang": "3kv,0,30|||",
                "Reunion": "b4,0,30|||",
                "Rothera": "1po,0,30|||",
                "Sakhalin": "1th,0,44,0,30|1th,0,a3,0,30||",
                "Samara": "29,0,6i,0,1b4|29,0,6n7,0,1b4||",
                "Samoa": "2c,0,44,0,30|2c,0,a3,0,30||",
                "Seychelles": "6na,0,nl,0,30|||",
                "Singapore": "6nd,0,30|||",
                "Solomon": "b5,0,nl,0,30|||",
                "South_Georgia": "2ir,0,6nj,0,30|||",
                "Suriname": "mg,0,30|||",
                "Syowa": "3lt,0,30|||",
                "Tahiti": "8n,0,30|||",
                "Taipei": "3m3,0,44,0,30|3m3,0,a3,0,30||",
                "Tajikistan": "3mh,0,30|||",
                "Tokelau": "5d,0,30|||",
                "Tonga": "3mi,0,44,0,30|3mi,0,a3,0,30||",
                "Truk": "4lr,0,30|||",
                "Turkmenistan": "3mn,0,44,0,30|3mn,0,a3,0,30||",
                "Tuvalu": "6h,0,30|||",
                "Uruguay": "3mr,0,44,0,30|3mr,0,a3,0,30||",
                "Uzbekistan": "3po,0,44,0,30|3po,0,a3,0,30||",
                "Vanuatu": "2f,0,44,0,30|6on,0,a3,0,30||",
                "Venezuela": "2g9,0,30|||",
                "Vladivostok": "28,0,44,0,30|28,0,a3,0,30||",
                "Volgograd": "3pp,0,44,0,30|3pp,0,a3,0,30||",
                "Vostok": "5t,0,30|||",
                "Wake": "3pq,0,30|||",
                "Wallis": "3pr,0,1sc,0,5k,0,30|||",
                "Yakutsk": "3u,0,44,0,30|3u,0,a3,0,30||",
                "Yekaterinburg": "3pu,0,44,0,30|3pu,0,a3,0,30||"
            }
        },
        "az": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|772,0,a3,0,30||",
                "Europe/London": "|3i5,0,a3,0,30||"
            },
            "metazone": {
                "Afghanistan": "5lp,0,30|||",
                "Africa_Central": "13u,0,c5,0,30|||",
                "Africa_Eastern": "105,0,c5,0,30|||",
                "Africa_Southern": "2ir,0,c5,0,30|||",
                "Africa_Western": "r0,0,c5,0,44,0,30|r0,0,c5,0,a3,0,30||",
                "Alaska": "1rr,0,44,0,30|1rr,0,a3,0,30||",
                "Amazon": "5m,0,44,0,30|5m,0,a3,0,30||",
                "America_Central": "17g,0,13u,0,m2,0,44,0,30|17g,0,13u,0,m2,0,a3,0,30||",
                "America_Eastern": "17g,0,105,0,m2,0,44,0,30|17g,0,105,0,m2,0,a3,0,30||",
                "America_Mountain": "17g,0,3j5,0,m2,0,44,0,30|17g,0,3j5,0,m2,0,a3,0,30||",
                "America_Pacific": "17g,0,m2,0,1ru,0,1rv,0,44,0,30|17g,0,m2,0,1ru,0,1rv,0,a3,0,30||",
                "Apia": "3e,0,44,0,30|3e,0,a3,0,30||",
                "Arabian": "3j6,0,44,0,30|3j6,0,a3,0,30||",
                "Argentina": "1e,0,44,0,30|1e,0,a3,0,30||",
                "Argentina_Western": "r0,0,1e,0,44,0,30|r0,0,1e,0,a3,0,30||",
                "Armenia": "3ja,0,44,0,30|3ja,0,a3,0,30||",
                "Atlantic": "r2,0,44,0,5ra|r2,0,a3,0,30||",
                "Australia_Central": "13u,0,r3,0,44,0,30|13u,0,r3,0,a3,0,30||",
                "Australia_CentralWestern": "13u,0,r0,0,r3,0,44,0,30|13u,0,r0,0,r3,0,a3,0,30||",
                "Australia_Eastern": "105,0,r3,0,44,0,30|105,0,r3,0,a3,0,30||",
                "Australia_Western": "r0,0,r3,0,44,0,30|r0,0,r3,0,a3,0,30||",
                "Azerbaijan": "3je,0,44,0,30|3je,0,a3,0,30||",
                "Azores": "1lg,0,44,0,30|1lg,0,a3,0,30||",
                "Bangladesh": "3jg,0,44,0,30|3jg,0,a3,0,30||",
                "Bhutan": "1k4,0,30|||",
                "Bolivia": "3jj,0,30|||",
                "Brasilia": "1s2,0,44,0,30|1s2,0,a3,0,30||",
                "Brunei": "9o,0,a4,0,1b4|||",
                "Cape_Verde": "3jk,0,3j,0,44,0,30|3jk,0,3j,0,a3,0,30||",
                "Chamorro": "4mm,0,30|||",
                "Chatham": "3jl,0,44,0,30|3jl,0,a3,0,30||",
                "Chile": "2i3,0,44,0,30|2i3,0,a3,0,30||",
                "China": "1s7,0,44,0,30|1s7,0,a3,0,30||",
                "Choibalsan": "1s8,0,44,0,30|1s8,0,a3,0,30||",
                "Christmas": "63j,0,137,0,30|||",
                "Cocos": "1eg,0,nl,0,30|||",
                "Colombia": "1s9,0,44,0,30|1s9,0,a3,0,30||",
                "Cook": "1ec,0,nl,0,44,0,30|1ec,0,nl,0,64h,0,a3,0,30||",
                "Cuba": "tb,0,44,0,30|tb,0,a3,0,30||",
                "Davis": "64p,0,30|||",
                "DumontDUrville": "64u,5,652,0,30|||",
                "East_Timor": "105,0,7n,0,30|||",
                "Easter": "1sa,0,137,0,44,0,30|1sa,0,137,0,a3,0,30||",
                "Ecuador": "1k0,0,30|||",
                "Europe_Central": "13u,0,1dv,0,44,0,30|13u,0,1dv,0,a3,0,30||",
                "Europe_Eastern": "105,0,1dv,0,44,0,30|105,0,1dv,0,a3,0,30||",
                "Europe_Further_Eastern": "677,0,105,0,1dv,0,30|||",
                "Europe_Western": "r0,0,1dv,0,44,0,30|r0,0,1dv,0,a3,0,30||",
                "Falkland": "1ov,0,nl,0,44,0,30|1ov,0,nl,0,a3,0,30||",
                "Fiji": "3jn,0,44,0,30|3jn,0,a3,0,30||",
                "French_Guiana": "1sb,0,68e,0,30|||",
                "French_Southern": "1sb,0,2ir,0,1sc,0,68j,0,30|||",
                "Galapagos": "68k,0,30|||",
                "Gambier": "68u,0,30|||",
                "Georgia": "3jo,0,44,0,30|3jo,0,a3,0,30||",
                "Gilbert_Islands": "6q,0,nl,0,30|||",
                "GMT": "69u,0,1bn,0,30|||",
                "Greenland_Eastern": "105,0,1sf,0,44,0,30|105,0,1sf,0,a3,0,30||",
                "Greenland_Western": "r0,0,1sf,0,44,0,30|r0,0,1sf,0,a3,0,30||",
                "Gulf": "6ab,0,30|||",
                "Guyana": "6ad,0,30|||",
                "Hawaii_Aleutian": "3jp,5,1l3,0,44,0,30|3jp,5,1l3,0,a3,0,30||",
                "Hong_Kong": "3k1,0,3k3,0,44,0,30|3k1,0,3k3,0,a3,0,30||",
                "Hovd": "2g,0,44,0,30|2g,0,a3,0,30||",
                "India": "30i,0,30|||",
                "Indian_Ocean": "3k9,0,6bt,0,30|||",
                "Indochina": "6c8,0,30|||",
                "Indonesia_Central": "13u,0,2hk,0,30|||",
                "Indonesia_Eastern": "105,0,2hk,0,30|||",
                "Indonesia_Western": "r0,0,2hk,0,30|||",
                "Iran": "1sj,0,44,0,30|1sj,0,a3,0,30||",
                "Irkutsk": "1sk,0,44,0,30|1sk,0,a3,0,30||",
                "Israel": "1sl,0,44,0,30|1sl,0,a3,0,30||",
                "Japan": "1sn,0,44,0,30|1sn,0,a3,0,30||",
                "Kazakhstan_Eastern": "105,0,3kc,0,30|||",
                "Kazakhstan_Western": "r0,0,3kc,0,30|||",
                "Korea": "1so,0,44,0,30|1so,0,a3,0,30||",
                "Kosrae": "6ei,0,30|||",
                "Krasnoyarsk": "41,0,44,0,30|41,0,a3,0,30||",
                "Kyrgystan": "6fj,0,30|||",
                "Line_Islands": "3kd,0,nl,0,30|||",
                "Lord_Howe": "1u,0,1i2,0,44,0,30|1u,0,1i2,0,a3,0,1b4||",
                "Macquarie": "6g4,0,137,0,30|||",
                "Magadan": "3ke,0,44,0,30|3ke,0,a3,0,30||",
                "Malaysia": "3kk,0,30|||",
                "Maldives": "3kl,0,30|||",
                "Marquesas": "6gg,0,30|||",
                "Marshall_Islands": "4m6,0,nl,0,30|||",
                "Mauritius": "3kn,0,44,0,30|3kn,0,a3,0,30||",
                "Mawson": "2v0,0,30|||",
                "Mexico_Northwest": "3ko,5,r0,0,10g,0,44,0,30|3ko,5,r0,0,10g,0,a3,0,30||",
                "Mexico_Pacific": "10g,0,1ru,0,1rv,0,44,0,30|10g,0,1ru,0,1rv,0,a3,0,30||",
                "Mongolia": "3kp,0,44,0,30|3kp,0,a3,0,30||",
                "Moscow": "pi,0,44,0,30|pi,0,a3,0,1b4||",
                "Myanmar": "3kq,0,30|||",
                "Nauru": "5v,0,30|||",
                "Nepal": "8u,0,1b4|||",
                "New_Caledonia": "142,0,1ss,0,44,0,30|142,0,1ss,0,a3,0,30||",
                "New_Zealand": "142,0,1st,0,44,0,30|142,0,1st,0,a3,0,30||",
                "Newfoundland": "1ta,0,44,0,30|1ta,0,a3,0,30||",
                "Niue": "8g,0,30|||",
                "Norfolk": "6l,0,137,0,30|||",
                "Noronha": "1s,0,2,0,1tb,0,44,0,30|1s,0,2,0,1tb,0,a3,0,30||",
                "Novosibirsk": "3b,0,44,0,30|3b,0,a3,0,30||",
                "Omsk": "26,0,44,0,30|26,0,a3,0,30||",
                "Pakistan": "3i,0,44,0,1b4|3i,0,a3,0,30||",
                "Palau": "9b,0,30|||",
                "Papua_New_Guinea": "9a,0,142,0,6j2,0,30|||",
                "Paraguay": "3ks,0,44,0,30|3ks,0,a3,0,30||",
                "Peru": "4n,0,44,0,30|4n,0,a3,0,30||",
                "Philippines": "1tc,0,44,0,30|1tc,0,a3,0,30||",
                "Phoenix_Islands": "1a7,0,nl,0,30|||",
                "Pierre_Miquelon": "io,0,1p8,0,1sc,0,u2,0,44,0,30|io,0,1p8,0,1sc,0,u2,0,a3,0,30||",
                "Pitcairn": "1ko,0,30|||",
                "Ponape": "9s,0,30|||",
                "Pyongyang": "3kv,0,30|||",
                "Reunion": "b4,0,30|||",
                "Rothera": "1po,0,30|||",
                "Sakhalin": "1th,0,44,0,30|1th,0,a3,0,30||",
                "Samara": "29,0,6i,0,1b4|29,0,6n7,0,1b4||",
                "Samoa": "2c,0,44,0,30|2c,0,a3,0,30||",
                "Seychelles": "6na,0,nl,0,30|||",
                "Singapore": "6nd,0,30|||",
                "Solomon": "b5,0,nl,0,30|||",
                "South_Georgia": "2ir,0,6nj,0,30|||",
                "Suriname": "mg,0,30|||",
                "Syowa": "3lt,0,30|||",
                "Tahiti": "8n,0,30|||",
                "Taipei": "3m3,0,44,0,30|3m3,0,a3,0,30||",
                "Tajikistan": "3mh,0,30|||",
                "Tokelau": "5d,0,30|||",
                "Tonga": "3mi,0,44,0,30|3mi,0,a3,0,30||",
                "Truk": "4lr,0,30|||",
                "Turkmenistan": "3mn,0,44,0,30|3mn,0,a3,0,30||",
                "Tuvalu": "6h,0,30|||",
                "Uruguay": "3mr,0,44,0,30|3mr,0,a3,0,30||",
                "Uzbekistan": "3po,0,44,0,30|3po,0,a3,0,30||",
                "Vanuatu": "2f,0,44,0,30|6on,0,a3,0,30||",
                "Venezuela": "2g9,0,30|||",
                "Vladivostok": "28,0,44,0,30|28,0,a3,0,30||",
                "Volgograd": "3pp,0,44,0,30|3pp,0,a3,0,30||",
                "Vostok": "5t,0,30|||",
                "Wake": "3pq,0,30|||",
                "Wallis": "3pr,0,1sc,0,5k,0,30|||",
                "Yakutsk": "3u,0,44,0,30|3u,0,a3,0,30||",
                "Yekaterinburg": "3pu,0,44,0,30|3pu,0,a3,0,30||"
            }
        },
        "bas": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "be": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c8s,0,po,0,97||",
                "Europe/London": "|c8t,0,pe,0,97||"
            },
            "metazone": {
                "Afghanistan": "c7e,0,97|||",
                "Africa_Central": "c7d,0,97|||",
                "Africa_Eastern": "c7c,0,97|||",
                "Africa_Southern": "c7b,0,97|||",
                "Africa_Western": "6ps,0,po,0,97|6ps,0,pe,0,97||",
                "Alaska": "oj,0,97,0,6q4|pg,0,97,0,6q4||",
                "Amazon": "6r0,0,po,0,97|6r0,0,pe,0,97||",
                "America_Central": "2g5,0,6rs,0,po,0,97|2g5,0,6rs,0,pe,0,97||",
                "America_Eastern": "2g5,0,6ru,0,po,0,97|2g5,0,6ru,0,pe,0,97||",
                "America_Mountain": "2g5,0,6sb,0,po,0,97|2g5,0,6sb,0,pe,0,97||",
                "America_Pacific": "6sm,0,po,0,97|6sm,0,pe,0,97||",
                "Apia": "oj,0,97,0,6tk|pg,0,97,0,6tk||",
                "Arabian": "oj,0,97,0,6va,0,71n|pg,0,97,0,6va,0,71n||",
                "Argentina": "71s,0,po,0,97|71s,0,pe,0,97||",
                "Argentina_Western": "oj,0,97,0,3q2,0,72l|pg,0,97,0,3q2,0,72l||",
                "Armenia": "oj,0,97,0,735|pg,0,97,0,735||",
                "Atlantic": "73c,0,po,0,97|73c,0,pe,0,97||",
                "Australia_Central": "oj,0,97,0,76d,0,1tq|pg,0,97,0,76d,0,1tq||",
                "Australia_CentralWestern": "77c,0,po,0,97,0,77t,0,1tq|77c,0,pe,0,97,0,77t,0,1tq||",
                "Australia_Eastern": "oj,0,97,0,783,0,1tq|pg,0,97,0,783,0,1tq||",
                "Australia_Western": "oj,0,97,0,785,0,1tq|pg,0,97,0,785,0,1tq||",
                "Azerbaijan": "oj,0,97,0,786|pg,0,97,0,786||",
                "Azores": "oj,0,97,0,787,0,16a|pg,0,97,0,787,0,16a||",
                "Bangladesh": "oj,0,97,0,78b|pg,0,97,0,78b||",
                "Bhutan": "mf,0,c7a|||",
                "Bolivia": "c79,0,97|||",
                "Brasilia": "79p,0,po,0,97|79p,0,pe,0,97||",
                "Brunei": "mf,0,c78|||",
                "Cape_Verde": "oj,0,97,0,7ab,5,7ag|pg,0,97,0,7ab,5,7ag||",
                "Chamorro": "mf,0,c77|||",
                "Chatham": "oj,0,97,0,7ai|pg,0,97,0,7ai||",
                "Chile": "7am,0,po,0,97|7am,0,pe,0,97||",
                "China": "oj,0,97,0,7an|pg,0,97,0,7an||",
                "Choibalsan": "oj,0,97,0,7ap|pg,0,97,0,7ap||",
                "Christmas": "mf,0,1tr,0,c76|||",
                "Cocos": "mf,0,c75,0,16a|||",
                "Colombia": "7fq,0,po,0,97|7fq,0,pe,0,97||",
                "Cook": "oj,0,97,0,16a,0,17u|c74,0,97,0,16a,0,17u||",
                "Cuba": "oj,0,97,0,7op|pg,0,97,0,7op||",
                "Davis": "mf,0,2g0,0,c73|||",
                "DumontDUrville": "mf,0,2g0,0,c72,5,c71|||",
                "East_Timor": "mf,0,c70,0,c6v|||",
                "Easter": "oj,0,97,0,1tr,0,7rn|pg,0,97,0,1tr,0,7rn||",
                "Ecuador": "c6u,0,97|||",
                "Europe_Central": "7sc,0,po,0,97|7sc,0,pe,0,97||",
                "Europe_Eastern": "7sd,0,po,0,97|7sd,0,pe,0,97||",
                "Europe_Further_Eastern": "c6t,0,97|||",
                "Europe_Western": "7ve,0,po,0,97|7ve,0,pe,0,97||",
                "Falkland": "oj,0,97,0,80l,0,16a|pg,0,97,0,80l,0,16a||",
                "Fiji": "oj,0,97,0,895|pg,0,97,0,895||",
                "French_Guiana": "mf,0,c6s,0,c6r|||",
                "French_Southern": "mf,0,c6q,0,c6p,0,1tt,0,c6o,0,c6n|||",
                "Galapagos": "oj,0,97,0,c6m,0,16a|||",
                "Gambier": "mf,0,c6l,0,c6k|||",
                "Georgia": "8bi,0,po,0,97|8bi,0,pe,0,97||",
                "Gilbert_Islands": "mf,0,16a,0,8bk|||",
                "GMT": "mf,0,c6j,0,c6i|||",
                "Greenland_Eastern": "oj,0,97,0,8cf,0,3q4|pg,0,97,0,8cf,0,3q4||",
                "Greenland_Western": "oj,0,97,0,3q2,0,3q4|pg,0,97,0,3q2,0,3q4||",
                "Gulf": "mf,0,c6h,0,c6g|||",
                "Guyana": "mf,0,c6f|||",
                "Hawaii_Aleutian": "8dh,5,8do,0,po,0,97|8dh,5,8do,0,pe,0,97||",
                "Hong_Kong": "oj,0,97,0,8dp|pg,0,97,0,8dp||",
                "Hovd": "oj,0,97,0,8dq|pg,0,97,0,8dq||",
                "India": "mf,0,c6e|||",
                "Indian_Ocean": "mf,0,c6d,0,c6c|||",
                "Indochina": "c6b,0,97|||",
                "Indonesia_Central": "c6a,0,97|||",
                "Indonesia_Eastern": "c69,0,97|||",
                "Indonesia_Western": "c68,0,97|||",
                "Iran": "8gi,0,po,0,97|8gi,0,pe,0,97||",
                "Irkutsk": "8go,0,po,0,97|8go,0,pe,0,97||",
                "Israel": "8h2,0,po,0,97|8h2,0,pe,0,97||",
                "Japan": "oj,0,97,0,8hk|pg,0,97,0,8hk||",
                "Kazakhstan_Eastern": "c67,0,97|||",
                "Kazakhstan_Western": "c66,0,97|||",
                "Korea": "oj,0,97,0,8hr|pg,0,97,0,8hr||",
                "Kosrae": "mf,0,16a,0,c65|||",
                "Krasnoyarsk": "8ht,0,po,0,97|8ht,0,pe,0,97||",
                "Kyrgystan": "mf,0,c64|||",
                "Line_Islands": "mf,0,16a,0,1eo|||",
                "Lord_Howe": "oj,0,97,0,oi,5,10a|pg,0,97,0,oi,5,10a||",
                "Macquarie": "mf,0,1tr,0,c63|||",
                "Magadan": "8jb,0,po,0,97|8jb,0,pe,0,97||",
                "Malaysia": "mf,0,c62|||",
                "Maldives": "mf,0,c61|||",
                "Marquesas": "mf,0,c60,0,16a|||",
                "Marshall_Islands": "mf,0,c5v,0,16a|||",
                "Mauritius": "oj,0,97,0,4s9|pg,0,97,0,4s9||",
                "Mawson": "mf,0,2g0,0,c5u|||",
                "Mexico_Northwest": "4se,5,4sf,0,4so,0,po,0,97|4se,5,4sf,0,4so,0,pe,0,97||",
                "Mexico_Pacific": "4sp,0,4ss,0,c5t,0,97|4sp,0,4ss,0,pe,0,97||",
                "Mongolia": "oj,0,97,0,or,5,4u1|pg,0,97,0,or,5,4u1||",
                "Moscow": "4u3,0,po,0,97|4u3,0,pe,0,97||",
                "Myanmar": "mf,0,c5s|||",
                "Nauru": "mf,0,14s|||",
                "Nepal": "c5r,0,97|||",
                "New_Caledonia": "oj,0,97,0,31c,0,50s|pg,0,97,0,31c,0,50s||",
                "New_Zealand": "oj,0,97,0,31c,0,50t|pg,0,97,0,31c,0,50t||",
                "Newfoundland": "50u,0,po,0,97|50u,0,pe,0,97||",
                "Niue": "mf,0,c5q|||",
                "Norfolk": "mf,0,1tr,0,c5p|||",
                "Noronha": "oj,0,97,0,141,5,518,5,51b|pg,0,97,0,141,5,518,5,51b||",
                "Novosibirsk": "51c,0,po,0,97|51c,0,pe,0,97||",
                "Omsk": "51i,0,po,0,97|51i,0,pe,0,97||",
                "Pakistan": "51m,0,po,0,97|51m,0,pe,0,97||",
                "Palau": "mf,0,159|||",
                "Papua_New_Guinea": "mf,0,13k,5,31c,0,c5o|||",
                "Paraguay": "oj,0,97,0,52c|pg,0,97,0,52c||",
                "Peru": "52f,0,po,0,97|52f,0,pe,0,97||",
                "Philippines": "52m,0,po,0,97|52m,0,pe,0,97||",
                "Phoenix_Islands": "mf,0,16a,0,530|||",
                "Pierre_Miquelon": "oj,0,97,0,pr,5,532,0,1tt,0,3q6|oj,0,pe,0,97,0,pr,5,532,0,1tt,0,3q6||",
                "Pitcairn": "mf,0,1tr,0,c5n|||",
                "Ponape": "mf,0,1tr,0,c5m|||",
                "Pyongyang": "c5l,0,97|||",
                "Reunion": "mf,0,c5k|||",
                "Rothera": "mf,0,2g0,0,c5j|||",
                "Sakhalin": "552,0,po,0,97|552,0,pe,0,97||",
                "Samoa": "oj,0,97,0,p0|pg,0,97,0,p0||",
                "Seychelles": "mf,0,c5i,0,16a|||",
                "Singapore": "c5h,0,97|||",
                "Solomon": "mf,0,c5g,0,16a|||",
                "South_Georgia": "mf,0,c5f,0,c5e|||",
                "Suriname": "mf,0,c5d|||",
                "Syowa": "mf,0,2g0,0,1pr|||",
                "Tahiti": "mf,0,c5c|||",
                "Taipei": "oj,0,97,0,59i|pg,0,97,0,59i||",
                "Tajikistan": "mf,0,c5b|||",
                "Tokelau": "mf,0,c5a|||",
                "Tonga": "oj,0,97,0,ot|pg,0,97,0,ot||",
                "Truk": "mf,0,1f2|||",
                "Turkmenistan": "oj,0,97,0,5c0|pg,0,97,0,5c0||",
                "Tuvalu": "mf,0,14j|||",
                "Uruguay": "5cq,0,po,0,97|5cq,0,pe,0,97||",
                "Uzbekistan": "oj,0,97,0,5d0|pg,0,97,0,5d0||",
                "Vanuatu": "oj,0,97,0,os|pg,0,97,0,os||",
                "Venezuela": "c59,0,97|||",
                "Vladivostok": "5df,0,po,0,97|5df,0,pe,0,97||",
                "Volgograd": "5e6,0,po,0,97|5e6,0,pe,0,97||",
                "Vostok": "mf,0,2g0,0,c58|||",
                "Wake": "mf,0,1tr,0,1m0|||",
                "Wallis": "mf,0,16a,0,c57,0,1tt,0,14l|||",
                "Yakutsk": "5jr,0,po,0,97|5jr,0,pe,0,97||",
                "Yekaterinburg": "5k8,0,po,0,97|5k8,0,pe,0,97||"
            }
        },
        "bem": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "bez": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "bg": {
            "gmtFormat": "Гринуич{0}",
            "gmtZeroFormat": "Гринуич",
            "zone": {
                "Europe/Dublin": "|c8u,0,fd,0,m||",
                "Europe/London": "|6r5,0,fi,0,g2,0,m||"
            },
            "metazone": {
                "Afghanistan": "c56,0,m|||",
                "Africa_Central": "c55,0,m|||",
                "Africa_Eastern": "c54,0,m|||",
                "Africa_Southern": "c53,0,m|||",
                "Africa_Western": "3q7,0,fd,0,m|3q7,0,fi,0,g2,0,m||",
                "Alaska": "12l,0,kf,0,fd,0,m|12l,0,kf,0,fi,0,g2,0,m||",
                "Amazon": "5nh,0,fd,0,m|5nh,0,fi,0,g2,0,m||",
                "America_Central": "1n5,0,p6,0,fd,0,m|1n5,0,p6,0,fi,0,g2,0,m||",
                "America_Eastern": "1n5,0,3q9,0,fd,0,m|1n5,0,3q9,0,fi,0,g2,0,m||",
                "America_Mountain": "1n5,0,1gj,0,fd,0,m|1n5,0,1gj,0,fi,0,g2,0,m||",
                "America_Pacific": "1n5,0,2fm,0,fd,0,m|1n5,0,2fm,0,fi,0,g2,0,m||",
                "Anadyr": "18u,0,kf,0,fd,0,m|18u,0,kf,0,fi,0,g2,0,m||",
                "Apia": "5oi,0,kf,0,fd,0,m|5oi,0,kf,0,fi,0,g2,0,m||",
                "Arabian": "5ok,0,fd,0,m|5ok,0,fi,0,g2,0,m||",
                "Argentina": "5oq,0,fd,0,m|5oq,0,fi,0,g2,0,m||",
                "Argentina_Western": "5or,0,fd,0,m|5or,0,fi,0,g2,0,m||",
                "Armenia": "5p0,0,fd,0,m|5p0,0,fi,0,g2,0,m||",
                "Atlantic": "1n5,0,5p1,0,fd,0,m|1n5,0,5p1,0,fi,0,g2,0,m||",
                "Australia_Central": "eo,0,kf,0,p6,0,fd,0,m|eo,0,kf,0,p6,0,fi,0,g2,0,m||",
                "Australia_CentralWestern": "eo,0,kf,0,uu,0,p6,0,fd,0,m|eo,0,kf,0,uu,0,p6,0,fi,0,g2,0,m||",
                "Australia_Eastern": "eo,0,kf,0,3q9,0,fd,0,m|eo,0,kf,0,3q9,0,fi,0,g2,0,m||",
                "Australia_Western": "eo,0,kf,0,uu,0,fd,0,m|eo,0,kf,0,uu,0,fi,0,g2,0,m||",
                "Azerbaijan": "5pn,0,fd,0,m|5pn,0,fi,0,g2,0,m||",
                "Azores": "5pp,0,191,0,kf,0,fd,0,m|5pp,0,191,0,kf,0,fi,0,g2,0,m||",
                "Bangladesh": "5q4,0,fd,0,m|5q4,0,fi,0,g2,0,m||",
                "Bhutan": "c52,0,m|||",
                "Bolivia": "c51,0,m|||",
                "Brasilia": "5qb,0,fd,0,m|5qb,0,fi,0,g2,0,m||",
                "Brunei": "1gr,0,1o3|||",
                "Cape_Verde": "12p,0,115,0,kf,0,fd,0,m|12p,0,115,0,kf,0,fi,0,g2,0,m||",
                "Chamorro": "1u7,0,kf,0,fd,0,m|||",
                "Chatham": "5rp,0,kf,0,fd,0,m|5rp,0,kf,0,fi,0,g2,0,m||",
                "Chile": "5rr,0,fd,0,m|5rr,0,fi,0,g2,0,m||",
                "China": "5rt,0,fd,0,m|5rt,0,fi,0,g2,0,m||",
                "Choibalsan": "5s0,0,fd,0,m|5s0,0,fi,0,g2,0,m||",
                "Christmas": "3qa,0,4l3|||",
                "Cocos": "c50,0,191|||",
                "Colombia": "5vi,0,fd,0,m|5vi,0,fi,0,g2,0,m||",
                "Cook": "1uj,0,1p2,0,kf,0,fd,0,m|1uj,0,1p2,0,kf,0,fi,0,g2,0,m||",
                "Cuba": "5vn,0,fd,0,m|5vn,0,fi,0,g2,0,m||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,0,c4v|||",
                "East_Timor": "c4u,0,m|||",
                "Easter": "62r,0,4l2,0,kf,0,fd,0,m|62r,0,4l2,0,kf,0,fi,0,g2,0,m||",
                "Ecuador": "c4t,0,m|||",
                "Europe_Central": "639,0,fd,0,m|639,0,fi,0,g2,0,m||",
                "Europe_Eastern": "63b,0,fd,0,m|63b,0,fi,0,g2,0,m||",
                "Europe_Further_Eastern": "c4s,0,c4r,0,m|||",
                "Europe_Western": "63k,0,fd,0,m|63k,0,fi,0,m||",
                "Falkland": "63l,0,191,0,kf,0,fd,0,m|63l,0,191,0,kf,0,fi,0,g2,0,m||",
                "Fiji": "161,0,kf,0,fd,0,m|161,0,kf,0,fi,0,g2,0,m||",
                "French_Guiana": "c4q,0,1pb|||",
                "French_Southern": "c4p,0,c4o,0,il,0,c4n,0,c4m|||",
                "Galapagos": "c4l,0,m|||",
                "Gambier": "659|||",
                "Georgia": "65u,0,fd,0,m|65u,0,fi,0,g2,0,m||",
                "Gilbert_Islands": "1uj,0,c4k|||",
                "GMT": "66b,0,c4j,0,m|||",
                "Greenland_Eastern": "66p,0,fd,0,m|66p,0,fi,0,g2,0,m||",
                "Greenland_Western": "66u,0,fd,0,m|66u,0,fi,0,g2,0,m||",
                "Gulf": "c4i,0,293|||",
                "Guyana": "c4h|||",
                "Hawaii_Aleutian": "67v,5,1ae,0,fd,0,m|67v,5,1ae,0,fi,0,g2,0,m||",
                "Hong_Kong": "687,0,fd,0,m|687,0,fi,0,g2,0,m||",
                "Hovd": "688,0,fd,0,m|688,0,fi,0,g2,0,m||",
                "India": "c4g,0,fd,0,m|||",
                "Indian_Ocean": "c4f,0,1ao|||",
                "Indochina": "c4e,0,m|||",
                "Indonesia_Central": "c4d,0,m|||",
                "Indonesia_Eastern": "c4c,0,m|||",
                "Indonesia_Western": "c4b,0,m|||",
                "Iran": "69e,0,fd,0,m|69e,0,fi,0,g2,0,m||",
                "Irkutsk": "69m,0,fd,0,m|69m,0,fi,0,g2,0,m||",
                "Israel": "1cq,0,fd,0,m|1cq,0,fi,0,g2,0,m||",
                "Japan": "6a6,0,fd,0,m|6a6,0,fi,0,g2,0,m||",
                "Kamchatka": "1d8,5,6a9,0,fd,0,m|1d8,5,6a9,0,kf,0,fi,0,g2,0,m||",
                "Kazakhstan_Eastern": "c4a,0,m|||",
                "Kazakhstan_Western": "c49,0,m|||",
                "Korea": "6ac,0,fd,0,m|6ac,0,fi,0,g2,0,m||",
                "Kosrae": "c48|||",
                "Krasnoyarsk": "6ae,0,fd,0,m|6ae,0,fi,0,g2,0,m||",
                "Kyrgystan": "c47,0,m|||",
                "Line_Islands": "c46,0,191|||",
                "Lord_Howe": "oi,0,10a,0,kf,0,fd,0,m|oi,0,10a,0,kf,0,fi,0,g2,0,m||",
                "Macquarie": "1l5|||",
                "Magadan": "6b8,0,fd,0,m|6b8,0,fi,0,g2,0,m||",
                "Malaysia": "c45,0,m|||",
                "Maldives": "c44,0,191|||",
                "Marquesas": "c43,0,191|||",
                "Marshall_Islands": "c42,0,191|||",
                "Mauritius": "6c2,0,kf,0,fd,0,m|6c2,0,kf,0,fi,0,g2,0,m||",
                "Mawson": "c41|||",
                "Mexico_Northwest": "187,0,kf,0,3qb,0,fd,0,m|187,0,kf,0,3qb,0,fi,0,g2,0,m||",
                "Mexico_Pacific": "6d0,0,2fm,0,fd,0,m|6d0,0,2fm,0,fi,0,g2,0,m||",
                "Mongolia": "6d1,0,fd,0,m|6d1,0,fi,0,g2,0,m||",
                "Moscow": "6d7,0,fd,0,m|6d7,0,fi,0,g2,0,m||",
                "Myanmar": "c40,0,m|||",
                "Nauru": "14s|||",
                "Nepal": "c3v,0,m|||",
                "New_Caledonia": "6de,0,fd,0,m|6de,0,fi,0,g2,0,m||",
                "New_Zealand": "6do,0,fd,0,m|6do,0,fi,0,g2,0,m||",
                "Newfoundland": "6e0,0,fd,0,m|6e0,0,fi,0,g2,0,m||",
                "Niue": "1q4|||",
                "Norfolk": "146|||",
                "Noronha": "138,0,13a,0,6f2,0,kf,0,fd,0,m|138,0,13a,0,6f2,0,kf,0,fi,0,g2,0,m||",
                "Novosibirsk": "6fc,0,fd,0,m|6fc,0,fi,0,g2,0,m||",
                "Omsk": "6fe,0,fd,0,m|6fe,0,fi,0,g2,0,m||",
                "Pakistan": "6fi,0,fd,0,m|6fi,0,fi,0,g2,0,m||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,125,0,1m5|||",
                "Paraguay": "6fl,0,fd,0,m|6fl,0,fi,0,g2,0,m||",
                "Peru": "6fo,0,fd,0,m|6fo,0,fi,0,g2,0,m||",
                "Philippines": "6g0,0,fd,0,m|6g0,0,fi,0,g2,0,m||",
                "Phoenix_Islands": "1uj,0,158|||",
                "Pierre_Miquelon": "pr,0,6g2,0,il,0,qp,0,kf,0,fd,0,m|pr,0,6g2,0,il,0,qp,0,kf,0,fi,0,g2,0,m||",
                "Pitcairn": "1q6|||",
                "Ponape": "1v2|||",
                "Pyongyang": "c3u,0,qe,0,c3t|||",
                "Reunion": "6gi|||",
                "Rothera": "157|||",
                "Sakhalin": "6gk,0,fd,0,m|6gk,0,fi,0,g2,0,m||",
                "Samara": "17o,0,kf,0,fd,0,m|17o,0,kf,0,fi,0,g2,0,m||",
                "Samoa": "6gm,0,fd,0,m|6gm,0,fi,0,g2,0,m||",
                "Seychelles": "c3s,0,191|||",
                "Singapore": "c3r,0,m|||",
                "Solomon": "c3q,0,191|||",
                "South_Georgia": "c3p,0,6gr|||",
                "Suriname": "c3o,0,m|||",
                "Syowa": "28v|||",
                "Tahiti": "c3n,0,m|||",
                "Taipei": "6h3,0,kf,0,fd,0,m|6h3,0,kf,0,fi,0,g2,0,m||",
                "Tajikistan": "c3m,0,m|||",
                "Tokelau": "156|||",
                "Tonga": "ot,0,kf,0,fd,0,m|ot,0,kf,0,fi,0,g2,0,m||",
                "Truk": "c3l|||",
                "Turkmenistan": "6hq,0,fd,0,m|6hq,0,fi,0,g2,0,m||",
                "Tuvalu": "14j|||",
                "Uruguay": "6i1,0,fd,0,m|6i1,0,fi,0,g2,0,m||",
                "Uzbekistan": "6i3,0,fd,0,m|6i3,0,fi,0,g2,0,m||",
                "Vanuatu": "os,0,kf,0,fd,0,m|os,0,kf,0,fi,0,g2,0,m||",
                "Venezuela": "c3k,0,m|||",
                "Vladivostok": "6ie,0,fd,0,m|6ie,0,fi,0,g2,0,m||",
                "Volgograd": "6ij,0,fd,0,m|6ij,0,fi,0,g2,0,m||",
                "Vostok": "155|||",
                "Wake": "3qa,0,6j8|||",
                "Wallis": "6ja,0,il,0,14l|||",
                "Yakutsk": "6jb,0,fd,0,m|6jb,0,fi,0,g2,0,m||",
                "Yekaterinburg": "6jd,0,fd,0,m|6jd,0,fi,0,g2,0,m||"
            }
        },
        "bm": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "bn-IN": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6q3,0,9m,0,2n||",
                "Europe/London": "|6q2,0,cl,0,2n||"
            },
            "metazone": {
                "Afghanistan": "6jm,0,2n|||",
                "Africa_Central": "2ek,0,1ni,0,2n|||",
                "Africa_Eastern": "12k,0,1ni,0,2n|||",
                "Africa_Southern": "2ej,0,1ni,0,9m,0,2n|||",
                "Africa_Western": "1ai,0,1ni,0,9m,0,2n|1ai,0,1ni,0,cl,0,2n||",
                "Alaska": "3qc,0,9m,0,2n|3qc,0,nm,0,2n||",
                "Amazon": "6mt,0,9m,0,2n|6n1,0,cl,0,2n||",
                "America_Central": "1cr,0,9m,0,2n|1cr,0,nm,0,2n||",
                "America_Eastern": "3qd,0,2ei,0,2n|3qd,0,nm,0,2n||",
                "America_Mountain": "3qe,0,1v4,0,2ei,0,2n|3qe,0,1v4,0,1v5,0,2n||",
                "America_Pacific": "1v6,0,1v9,0,1v4,0,9m,0,2n|1v6,0,1v9,0,1v4,0,1v5,0,2n||",
                "Anadyr": "3qf,0,9m,0,2n|3qf,0,cl,0,2n||",
                "Apia": "3qj,0,9m,0,2n|3qj,0,1v5,0,2n||",
                "Arabian": "3qk,0,9m,0,2n|3qk,0,nm,0,2n||",
                "Argentina": "2ea,0,9m,0,2n|2ea,0,cl,0,2n||",
                "Argentina_Western": "1i0,0,6o9,0,2ei,0,2n|1i0,0,2ea,0,1va,0,2n||",
                "Armenia": "3qm,0,9m,0,2n|3qm,0,cl,0,2n||",
                "Atlantic": "3qn,0,9m,0,2n|3qn,0,nm,0,2n||",
                "Australia_Central": "172,0,1cr,0,9m,0,2n|172,0,1cr,0,nm,0,2n||",
                "Australia_CentralWestern": "172,0,1cr,0,1i0,0,9m,0,2n|172,0,1cr,0,1i0,0,nm,0,2n||",
                "Australia_Eastern": "172,0,12k,0,9m,0,2n|172,0,12k,0,nm,0,2n||",
                "Australia_Western": "172,0,1i0,0,9m,0,2n|172,0,1i0,0,nm,0,2n||",
                "Azerbaijan": "3qo,0,9m,0,2n|3qo,0,cl,0,2n||",
                "Azores": "3qt,0,9m,0,2n|3qt,0,cl,0,2n||",
                "Bangladesh": "3qv,0,9m,0,2n|3qv,0,cl,0,2n||",
                "Bhutan": "6p0,0,2n|||",
                "Bolivia": "6p4,0,2n|||",
                "Brasilia": "3r0,0,9m,0,2n|3r0,0,cl,0,2n||",
                "Brunei": "6pa,0,6pb,0,2n|||",
                "Cape_Verde": "3r4,0,3r5,0,9m,0,2n|3r4,0,3r5,0,cl,0,2n||",
                "Chamorro": "6pj,0,9m,0,2n|||",
                "Chatham": "3r7,0,9m,0,2n|3r7,0,nm,0,2n||",
                "Chile": "3rg,0,9m,0,2n|3rg,0,6pn,0,2n||",
                "China": "3ro,0,9m,0,2n|3ro,0,nm,0,2n||",
                "Choibalsan": "3rp,0,9m,0,2n|3rp,0,cl,0,2n||",
                "Christmas": "6pt,0,1lm,0,2n|||",
                "Cocos": "6q1,0,12i,0,2n|||",
                "Colombia": "3rq,0,9m,0,2n|3rq,0,cl,0,2n||",
                "Cook": "3rr,0,12i,0,9m,0,2n|3rr,0,12i,0,6q6,0,cl,0,2n||",
                "Cuba": "3rt,0,9m,0,2n|3rt,0,nm,0,2n||",
                "Davis": "6qa,0,2n|||",
                "DumontDUrville": "6qb,5,6qd,0,2n|||",
                "East_Timor": "12k,0,6qm,0,2n|||",
                "Easter": "3s0,0,1lm,0,9m,0,2n|3s0,0,1lm,0,cl,0,2n||",
                "Ecuador": "6r3,0,2n|||",
                "Europe_Central": "2ek,0,1io,0,9m,0,2n|2ek,0,1io,0,cl,0,2n||",
                "Europe_Eastern": "12k,0,1io,0,9m,0,2n|12k,0,1io,0,cl,0,2n||",
                "Europe_Further_Eastern": "6rh,5,12k,0,6ro,0,2n|||",
                "Europe_Western": "1ai,0,1io,0,9m,0,2n|1ai,0,1io,0,cl,0,2n||",
                "Falkland": "3s3,0,12i,0,9m,0,2n|3s3,0,12i,0,cl,0,2n||",
                "Fiji": "3s7,0,9m,0,2n|3s7,0,cl,0,2n||",
                "French_Guiana": "3sh,0,6sc,0,2n|||",
                "French_Southern": "3sh,0,2ej,0,3sp,0,6sn,0,2n|||",
                "Galapagos": "6t7,0,2n|||",
                "Gambier": "6te,0,2n|||",
                "Georgia": "2dp,0,9m,0,2n|2dp,0,cl,0,2n||",
                "Gilbert_Islands": "6tp,0,12i,0,2n|||",
                "GMT": "6tq,0,6u0,0,6uk|||",
                "Greenland_Eastern": "12k,0,1vp,0,9m,0,2n|12k,0,1vp,0,cl,0,2n||",
                "Greenland_Western": "1ai,0,1vp,0,9m,0,2n|1ai,0,1vp,0,cl,0,2n||",
                "Gulf": "71e,0,9m,0,2n|||",
                "Guyana": "71l,0,2n|||",
                "Hawaii_Aleutian": "3sq,5,3ss,0,9m,0,2n|3sq,5,3ss,0,nm,0,2n||",
                "Hong_Kong": "3st,0,3su,0,9m,0,2n|3st,0,3su,0,cl,0,2n||",
                "Hovd": "3t0,0,9m,0,2n|3t0,0,cl,0,2n||",
                "India": "73b,0,9m,0,2n||15a|",
                "Indian_Ocean": "73g,0,1v9,0,2n|||",
                "Indochina": "741,0,2n|||",
                "Indonesia_Central": "1cr,0,2df,0,2n|||",
                "Indonesia_Eastern": "12k,0,2df,0,2n|||",
                "Indonesia_Western": "76s,0,2df,0,2n|||",
                "Iran": "3t3,0,9m,0,2n|3t3,0,nm,0,2n||",
                "Irkutsk": "3t5,0,9m,0,2n|3t5,0,cl,0,2n||",
                "Israel": "3t8,0,9m,0,2n|3t8,0,nm,0,2n||",
                "Japan": "3t9,0,9m,0,2n|3t9,0,nm,0,2n||",
                "Kamchatka": "3ta,5,0,3te,0,3tk,0,2n|3ta,5,0,3te,0,1va,0,2n||",
                "Kazakhstan_Eastern": "12k,0,3tl,0,9m,0,2n|||",
                "Kazakhstan_Western": "1ai,0,3tl,0,9m,0,2n|||",
                "Korea": "3to,0,9m,0,2n|3to,0,nm,0,2n||",
                "Kosrae": "78d,0,2n|||",
                "Krasnoyarsk": "3tr,0,9m,0,2n|3tr,0,cl,0,2n||",
                "Kyrgystan": "791,0,2n|||",
                "Line_Islands": "79a,0,12i,0,2n|||",
                "Lord_Howe": "3uh,0,3v5,0,9m,0,3v7|3uh,0,3v5,0,nm,0,3v7||",
                "Macquarie": "79q,0,1lm,0,2n|||",
                "Magadan": "3vf,0,9m,0,2n|3vf,0,cl,0,2n||",
                "Malaysia": "79u,0,2n|||",
                "Maldives": "7a2,0,2n|||",
                "Marquesas": "7a3,0,2n|||",
                "Marshall_Islands": "7a7,0,12i,0,2n|||",
                "Mauritius": "3vv,0,9m,0,2n|3vv,0,cl,0,2n||",
                "Mawson": "7ac,0,2n|||",
                "Mexico_Northwest": "43i,0,446,0,9m,0,2n|43i,0,446,0,1v5,0,2n||",
                "Mexico_Pacific": "44c,0,1v6,0,7ak,0,9m,0,2n|44c,0,1v6,0,1v9,0,nm,0,2n||",
                "Mongolia": "451,0,45e,0,9m,0,2n|451,0,45e,0,cl,0,2n||",
                "Moscow": "4b4,0,9m,0,2n|4b4,0,cl,0,2n||",
                "Myanmar": "7eb,0,2n|||",
                "Nauru": "7ec,0,2n|||",
                "Nepal": "7el,0,2n|||",
                "New_Caledonia": "2d4,0,4df,0,9m,0,2n|2d4,0,4df,0,cl,0,2n||",
                "New_Zealand": "4dj,0,9m,0,2n|4dj,0,nm,0,2n||",
                "Newfoundland": "4do,0,9m,0,2n|4do,0,nm,0,2n||",
                "Niue": "7hg,0,2n|||",
                "Norfolk": "7hk,0,12i,0,2n|||",
                "Noronha": "4dp,0,4du,0,4e8,0,9m,0,2n|4dp,0,4du,0,4e8,0,cl,0,2n||",
                "Novosibirsk": "4ec,0,9m,0,2n|4ec,0,cl,0,2n||",
                "Omsk": "4ee,0,9m,0,2n|4ee,0,cl,0,2n||",
                "Pakistan": "4eh,0,9m,0,2n|4eh,0,cl,0,2n||",
                "Palau": "7qa,0,2n|||",
                "Papua_New_Guinea": "7qd,0,2d4,0,7qj,0,2n|||",
                "Paraguay": "4eq,0,9m,0,2n|4eq,0,cl,0,2n||",
                "Peru": "4et,0,9m,0,2n|4et,0,cl,0,2n||",
                "Philippines": "4f5,0,9m,0,2n|4f5,0,cl,0,2n||",
                "Phoenix_Islands": "7rm,0,12i,0,2n|||",
                "Pierre_Miquelon": "4f7,0,4fb,0,4gl,0,4hd,0,9m,0,2n|4f7,0,4fb,0,4gl,0,4hd,0,nm,0,2n||",
                "Pitcairn": "7sf,0,2n|||",
                "Ponape": "7sk,0,2n|||",
                "Pyongyang": "7sl,0,2n|||",
                "Reunion": "7st,0,2n|||",
                "Rothera": "7t1,0,2n|||",
                "Sakhalin": "4hc,0,9m,0,2n|4hc,0,cl,0,2n||",
                "Samara": "4hb,0,3tk,0,2n|4hb,0,1va,0,2n||",
                "Samoa": "4gf,0,9m,0,2n|4gf,0,1va,0,2n||",
                "Seychelles": "812,0,2n|||",
                "Singapore": "836,0,9m,0,2n|||",
                "Solomon": "83k,0,12i,0,2n|||",
                "South_Georgia": "2ej,0,2dp,0,2n|||",
                "Suriname": "868,0,2n|||",
                "Syowa": "88f,0,2n|||",
                "Tahiti": "88m,0,2n|||",
                "Taipei": "4gb,0,9m,0,2n|4gb,0,nm,0,2n||",
                "Tajikistan": "896,0,2n|||",
                "Tokelau": "898,0,2n|||",
                "Tonga": "4g5,0,9m,0,2n|4g5,0,cl,0,2n||",
                "Truk": "89e,0,2n|||",
                "Turkmenistan": "4g3,0,9m,0,2n|4g3,0,cl,0,2n||",
                "Tuvalu": "89h,0,2n|||",
                "Uruguay": "4fq,0,9m,0,2n|4fq,0,cl,0,2n||",
                "Uzbekistan": "4fp,0,9m,0,2n|4fp,0,cl,0,2n||",
                "Vanuatu": "4fo,0,9m,0,2n|4fo,0,cl,0,2n||",
                "Venezuela": "8ah,0,2n|||",
                "Vladivostok": "4fn,0,9m,0,2n|4fn,0,cl,0,2n||",
                "Volgograd": "4fk,0,9m,0,2n|4fk,0,cl,0,2n||",
                "Vostok": "8ar,0,2n|||",
                "Wake": "8at,0,1lm,0,2n|||",
                "Wallis": "8b4,0,3sp,0,8b5,0,2n|||",
                "Yakutsk": "4fj,0,9m,0,2n|4fj,0,cl,0,2n||",
                "Yekaterinburg": "4fh,0,9m,0,2n|4fh,0,cl,0,2n||"
            }
        },
        "bn": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6q3,0,9m,0,2n||",
                "Europe/London": "|6q2,0,cl,0,2n||"
            },
            "metazone": {
                "Afghanistan": "6jm,0,2n|||",
                "Africa_Central": "2ek,0,1ni,0,2n|||",
                "Africa_Eastern": "12k,0,1ni,0,2n|||",
                "Africa_Southern": "2ej,0,1ni,0,9m,0,2n|||",
                "Africa_Western": "1ai,0,1ni,0,9m,0,2n|1ai,0,1ni,0,cl,0,2n||",
                "Alaska": "3qc,0,9m,0,2n|3qc,0,nm,0,2n||",
                "Amazon": "6mt,0,9m,0,2n|6n1,0,cl,0,2n||",
                "America_Central": "1cr,0,9m,0,2n|1cr,0,nm,0,2n||",
                "America_Eastern": "3qd,0,2ei,0,2n|3qd,0,nm,0,2n||",
                "America_Mountain": "3qe,0,1v4,0,2ei,0,2n|3qe,0,1v4,0,1v5,0,2n||",
                "America_Pacific": "1v6,0,1v9,0,1v4,0,9m,0,2n|1v6,0,1v9,0,1v4,0,1v5,0,2n||",
                "Anadyr": "3qf,0,9m,0,2n|3qf,0,cl,0,2n||",
                "Apia": "3qj,0,9m,0,2n|3qj,0,1v5,0,2n||",
                "Arabian": "3qk,0,9m,0,2n|3qk,0,nm,0,2n||",
                "Argentina": "2ea,0,9m,0,2n|2ea,0,cl,0,2n||",
                "Argentina_Western": "1i0,0,6o9,0,2ei,0,2n|1i0,0,2ea,0,1va,0,2n||",
                "Armenia": "3qm,0,9m,0,2n|3qm,0,cl,0,2n||",
                "Atlantic": "3qn,0,9m,0,2n|3qn,0,nm,0,2n||",
                "Australia_Central": "172,0,1cr,0,9m,0,2n|172,0,1cr,0,nm,0,2n||",
                "Australia_CentralWestern": "172,0,1cr,0,1i0,0,9m,0,2n|172,0,1cr,0,1i0,0,nm,0,2n||",
                "Australia_Eastern": "172,0,12k,0,9m,0,2n|172,0,12k,0,nm,0,2n||",
                "Australia_Western": "172,0,1i0,0,9m,0,2n|172,0,1i0,0,nm,0,2n||",
                "Azerbaijan": "3qo,0,9m,0,2n|3qo,0,cl,0,2n||",
                "Azores": "3qt,0,9m,0,2n|3qt,0,cl,0,2n||",
                "Bangladesh": "3qv,0,9m,0,2n|3qv,0,cl,0,2n||",
                "Bhutan": "6p0,0,2n|||",
                "Bolivia": "6p4,0,2n|||",
                "Brasilia": "3r0,0,9m,0,2n|3r0,0,cl,0,2n||",
                "Brunei": "6pa,0,6pb,0,2n|||",
                "Cape_Verde": "3r4,0,3r5,0,9m,0,2n|3r4,0,3r5,0,cl,0,2n||",
                "Chamorro": "6pj,0,9m,0,2n|||",
                "Chatham": "3r7,0,9m,0,2n|3r7,0,nm,0,2n||",
                "Chile": "3rg,0,9m,0,2n|3rg,0,6pn,0,2n||",
                "China": "3ro,0,9m,0,2n|3ro,0,nm,0,2n||",
                "Choibalsan": "3rp,0,9m,0,2n|3rp,0,cl,0,2n||",
                "Christmas": "6pt,0,1lm,0,2n|||",
                "Cocos": "6q1,0,12i,0,2n|||",
                "Colombia": "3rq,0,9m,0,2n|3rq,0,cl,0,2n||",
                "Cook": "3rr,0,12i,0,9m,0,2n|3rr,0,12i,0,6q6,0,cl,0,2n||",
                "Cuba": "3rt,0,9m,0,2n|3rt,0,nm,0,2n||",
                "Davis": "6qa,0,2n|||",
                "DumontDUrville": "6qb,5,6qd,0,2n|||",
                "East_Timor": "12k,0,6qm,0,2n|||",
                "Easter": "3s0,0,1lm,0,9m,0,2n|3s0,0,1lm,0,cl,0,2n||",
                "Ecuador": "6r3,0,2n|||",
                "Europe_Central": "2ek,0,1io,0,9m,0,2n|2ek,0,1io,0,cl,0,2n||",
                "Europe_Eastern": "12k,0,1io,0,9m,0,2n|12k,0,1io,0,cl,0,2n||",
                "Europe_Further_Eastern": "6rh,5,12k,0,6ro,0,2n|||",
                "Europe_Western": "1ai,0,1io,0,9m,0,2n|1ai,0,1io,0,cl,0,2n||",
                "Falkland": "3s3,0,12i,0,9m,0,2n|3s3,0,12i,0,cl,0,2n||",
                "Fiji": "3s7,0,9m,0,2n|3s7,0,cl,0,2n||",
                "French_Guiana": "3sh,0,6sc,0,2n|||",
                "French_Southern": "3sh,0,2ej,0,3sp,0,6sn,0,2n|||",
                "Galapagos": "6t7,0,2n|||",
                "Gambier": "6te,0,2n|||",
                "Georgia": "2dp,0,9m,0,2n|2dp,0,cl,0,2n||",
                "Gilbert_Islands": "6tp,0,12i,0,2n|||",
                "GMT": "6tq,0,6u0,0,6uk|||",
                "Greenland_Eastern": "12k,0,1vp,0,9m,0,2n|12k,0,1vp,0,cl,0,2n||",
                "Greenland_Western": "1ai,0,1vp,0,9m,0,2n|1ai,0,1vp,0,cl,0,2n||",
                "Gulf": "71e,0,9m,0,2n|||",
                "Guyana": "71l,0,2n|||",
                "Hawaii_Aleutian": "3sq,5,3ss,0,9m,0,2n|3sq,5,3ss,0,nm,0,2n||",
                "Hong_Kong": "3st,0,3su,0,9m,0,2n|3st,0,3su,0,cl,0,2n||",
                "Hovd": "3t0,0,9m,0,2n|3t0,0,cl,0,2n||",
                "India": "73b,0,9m,0,2n||15a|",
                "Indian_Ocean": "73g,0,1v9,0,2n|||",
                "Indochina": "741,0,2n|||",
                "Indonesia_Central": "1cr,0,2df,0,2n|||",
                "Indonesia_Eastern": "12k,0,2df,0,2n|||",
                "Indonesia_Western": "76s,0,2df,0,2n|||",
                "Iran": "3t3,0,9m,0,2n|3t3,0,nm,0,2n||",
                "Irkutsk": "3t5,0,9m,0,2n|3t5,0,cl,0,2n||",
                "Israel": "3t8,0,9m,0,2n|3t8,0,nm,0,2n||",
                "Japan": "3t9,0,9m,0,2n|3t9,0,nm,0,2n||",
                "Kamchatka": "3ta,5,0,3te,0,3tk,0,2n|3ta,5,0,3te,0,1va,0,2n||",
                "Kazakhstan_Eastern": "12k,0,3tl,0,9m,0,2n|||",
                "Kazakhstan_Western": "1ai,0,3tl,0,9m,0,2n|||",
                "Korea": "3to,0,9m,0,2n|3to,0,nm,0,2n||",
                "Kosrae": "78d,0,2n|||",
                "Krasnoyarsk": "3tr,0,9m,0,2n|3tr,0,cl,0,2n||",
                "Kyrgystan": "791,0,2n|||",
                "Line_Islands": "79a,0,12i,0,2n|||",
                "Lord_Howe": "3uh,0,3v5,0,9m,0,3v7|3uh,0,3v5,0,nm,0,3v7||",
                "Macquarie": "79q,0,1lm,0,2n|||",
                "Magadan": "3vf,0,9m,0,2n|3vf,0,cl,0,2n||",
                "Malaysia": "79u,0,2n|||",
                "Maldives": "7a2,0,2n|||",
                "Marquesas": "7a3,0,2n|||",
                "Marshall_Islands": "7a7,0,12i,0,2n|||",
                "Mauritius": "3vv,0,9m,0,2n|3vv,0,cl,0,2n||",
                "Mawson": "7ac,0,2n|||",
                "Mexico_Northwest": "43i,0,446,0,9m,0,2n|43i,0,446,0,1v5,0,2n||",
                "Mexico_Pacific": "44c,0,1v6,0,7ak,0,9m,0,2n|44c,0,1v6,0,1v9,0,nm,0,2n||",
                "Mongolia": "451,0,45e,0,9m,0,2n|451,0,45e,0,cl,0,2n||",
                "Moscow": "4b4,0,9m,0,2n|4b4,0,cl,0,2n||",
                "Myanmar": "7eb,0,2n|||",
                "Nauru": "7ec,0,2n|||",
                "Nepal": "7el,0,2n|||",
                "New_Caledonia": "2d4,0,4df,0,9m,0,2n|2d4,0,4df,0,cl,0,2n||",
                "New_Zealand": "4dj,0,9m,0,2n|4dj,0,nm,0,2n||",
                "Newfoundland": "4do,0,9m,0,2n|4do,0,nm,0,2n||",
                "Niue": "7hg,0,2n|||",
                "Norfolk": "7hk,0,12i,0,2n|||",
                "Noronha": "4dp,0,4du,0,4e8,0,9m,0,2n|4dp,0,4du,0,4e8,0,cl,0,2n||",
                "Novosibirsk": "4ec,0,9m,0,2n|4ec,0,cl,0,2n||",
                "Omsk": "4ee,0,9m,0,2n|4ee,0,cl,0,2n||",
                "Pakistan": "4eh,0,9m,0,2n|4eh,0,cl,0,2n||",
                "Palau": "7qa,0,2n|||",
                "Papua_New_Guinea": "7qd,0,2d4,0,7qj,0,2n|||",
                "Paraguay": "4eq,0,9m,0,2n|4eq,0,cl,0,2n||",
                "Peru": "4et,0,9m,0,2n|4et,0,cl,0,2n||",
                "Philippines": "4f5,0,9m,0,2n|4f5,0,cl,0,2n||",
                "Phoenix_Islands": "7rm,0,12i,0,2n|||",
                "Pierre_Miquelon": "4f7,0,4fb,0,4gl,0,4hd,0,9m,0,2n|4f7,0,4fb,0,4gl,0,4hd,0,nm,0,2n||",
                "Pitcairn": "7sf,0,2n|||",
                "Ponape": "7sk,0,2n|||",
                "Pyongyang": "7sl,0,2n|||",
                "Reunion": "7st,0,2n|||",
                "Rothera": "7t1,0,2n|||",
                "Sakhalin": "4hc,0,9m,0,2n|4hc,0,cl,0,2n||",
                "Samara": "4hb,0,3tk,0,2n|4hb,0,1va,0,2n||",
                "Samoa": "4gf,0,9m,0,2n|4gf,0,1va,0,2n||",
                "Seychelles": "812,0,2n|||",
                "Singapore": "836,0,9m,0,2n|||",
                "Solomon": "83k,0,12i,0,2n|||",
                "South_Georgia": "2ej,0,2dp,0,2n|||",
                "Suriname": "868,0,2n|||",
                "Syowa": "88f,0,2n|||",
                "Tahiti": "88m,0,2n|||",
                "Taipei": "4gb,0,9m,0,2n|4gb,0,nm,0,2n||",
                "Tajikistan": "896,0,2n|||",
                "Tokelau": "898,0,2n|||",
                "Tonga": "4g5,0,9m,0,2n|4g5,0,cl,0,2n||",
                "Truk": "89e,0,2n|||",
                "Turkmenistan": "4g3,0,9m,0,2n|4g3,0,cl,0,2n||",
                "Tuvalu": "89h,0,2n|||",
                "Uruguay": "4fq,0,9m,0,2n|4fq,0,cl,0,2n||",
                "Uzbekistan": "4fp,0,9m,0,2n|4fp,0,cl,0,2n||",
                "Vanuatu": "4fo,0,9m,0,2n|4fo,0,cl,0,2n||",
                "Venezuela": "8ah,0,2n|||",
                "Vladivostok": "4fn,0,9m,0,2n|4fn,0,cl,0,2n||",
                "Volgograd": "4fk,0,9m,0,2n|4fk,0,cl,0,2n||",
                "Vostok": "8ar,0,2n|||",
                "Wake": "8at,0,1lm,0,2n|||",
                "Wallis": "8b4,0,3sp,0,8b5,0,2n|||",
                "Yakutsk": "4fj,0,9m,0,2n|4fj,0,cl,0,2n||",
                "Yekaterinburg": "4fh,0,9m,0,2n|4fh,0,cl,0,2n||"
            }
        },
        "bo-IN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "bo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "br": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8s,0,gr,0,c92||",
                "Europe/London": "|8s,0,hh,0,c93,5,c94||"
            },
            "metazone": {
                "Afghanistan": "8s,0,b6|||",
                "Africa_Central": "8s,0,c3j|||",
                "Africa_Eastern": "8s,0,c5,0,q3,0,1js|||",
                "Africa_Southern": "8s,0,gr,0,c3i|||",
                "Africa_Western": "8s,0,gr,0,c5,0,q3,0,1b5|8s,0,hh,0,c5,0,q3,0,1b5||",
                "Alaska": "8s,0,gr,0,3p|8s,0,hh,0,3p||",
                "Almaty": "8s,0,gr,0,56|8s,0,hh,0,56||",
                "Amazon": "8s,0,gr,0,nk,0,5m|8s,0,hh,0,nk,0,5m||",
                "America_Eastern": "8s,0,gr,0,q3,0,1js|8s,0,hh,0,q3,0,1js||",
                "America_Mountain": "8s,0,gr,0,q3,0,8d6|8s,0,hh,0,q3,0,8d6||",
                "Anadyr": "8s,0,gr,0,8d9|8s,0,hh,0,8d9||",
                "Apia": "8s,0,gr,0,3e|8s,0,hh,0,3e||",
                "Arabian": "8s,0,gr,0,hs|8s,0,hh,0,hs||",
                "Argentina": "8s,0,gr,0,4ff|8s,0,hh,0,4ff||",
                "Argentina_Western": "8s,0,gr,0,4ff,0,q3,0,1b5|8s,0,hh,0,4ff,0,q3,0,1b5||",
                "Armenia": "8s,0,gr,0,4l|8s,0,hh,0,4l||",
                "Australia_Central": "8s,0,gr,0,4fe|8s,0,hh,0,4fe||",
                "Australia_CentralWestern": "8s,0,gr,0,4fe,0,q3,0,1b5|8s,0,hh,0,4fe,0,q3,0,1b5||",
                "Australia_Eastern": "8s,0,gr,0,4fd,0,q3,0,1js|8s,0,hh,0,4fd,0,q3,0,1js||",
                "Australia_Western": "8s,0,gr,0,4fd,0,q3,0,1b5|8s,0,hh,0,4fd,0,q3,0,1b5||",
                "Azerbaijan": "8s,0,gr,0,8eg|8s,0,hh,0,8eg||",
                "Azores": "8s,0,gr,0,nk,0,8f4|8s,0,hh,0,nk,0,8f4||",
                "Bangladesh": "8s,0,gr,0,3n|8s,0,hh,0,3n||",
                "Bhutan": "8s,0,n4|||",
                "Bolivia": "8s,0,aa|||",
                "Brasilia": "8s,0,gr,0,in|8s,0,hh,0,in||",
                "Brunei": "8s,0,9o,0,a4|||",
                "Cape_Verde": "8s,0,gr,0,q3,0,8ff,5,8fh|8s,0,hh,0,q3,0,8ff,5,8fh||",
                "Chatham": "8s,0,gr,0,27|8s,0,hh,0,27||",
                "Chile": "8s,0,gr,0,49|8s,0,hh,0,49||",
                "China": "8s,0,gr,0,4hi|8s,0,hh,0,4hi||",
                "Christmas": "8s,0,2v7,0,99|||",
                "Cocos": "8s,0,1qc,0,c3h|||",
                "Colombia": "8s,0,gr,0,20u|8s,0,hh,0,20u||",
                "Cook": "8s,0,gr,0,1qc,0,2v|8s,0,hh,0,1qc,0,2v||",
                "Cuba": "8s,0,gr,0,tb|8s,0,hh,0,tb||",
                "East_Timor": "8s,0,7n,0,q3,0,1js|||",
                "Easter": "8s,0,gr,0,2v7,0,8h0|8s,0,hh,0,2v7,0,8h0||",
                "Ecuador": "8s,0,ai|||",
                "Europe_Central": "8s,0,gr,0,8h1|8s,0,hh,0,8h1||",
                "Europe_Eastern": "8s,0,gr,0,4p,0,q3,0,1js|8s,0,hh,0,4p,0,q3,0,1js||",
                "Europe_Western": "8s,0,gr,0,4p,0,q3,0,1b5|8s,0,hh,0,4p,0,q3,0,1b5||",
                "Falkland": "8s,0,gr,0,1qc,0,4v|8s,0,hh,0,1qc,0,4v||",
                "Fiji": "8s,0,gr,0,cm|8s,0,hh,0,cm||",
                "French_Guiana": "8s,0,8h5,0,c3g|||",
                "French_Southern": "8s,0,c3f,0,c3e,0,c3d,0,c3c,0,27v|||",
                "Galapagos": "8s,0,1qc,0,cp|||",
                "Gambier": "8s,0,6v|||",
                "Georgia": "8s,0,gr,0,8i0|8s,0,hh,0,8i0||",
                "GMT": "c3b,0,c3a,0,5u,0,c39|||",
                "Greenland_Eastern": "8s,0,gr,0,4f8,0,q3,0,1js|8s,0,hh,0,4f8,0,q3,0,1js||",
                "Greenland_Western": "8s,0,gr,0,4f8,0,q3,0,1b5|8s,0,hh,0,4f8,0,q3,0,1b5||",
                "Guam": "8s,0,gr,0,83|||",
                "Gulf": "8s,0,gr,0,q3,0,c38,5,c37,0,1qe,5,4f4,5,c36|||",
                "Guyana": "8s,0,7a|||",
                "Hong_Kong": "8s,0,gr,0,2l,0,2p|8s,0,hh,0,2l,0,2p||",
                "India": "8s,0,gr,0,af|||",
                "Indochina": "8s,0,c35,5,4hi|||",
                "Indonesia_Eastern": "8s,0,4sb,0,q3,0,1js|||",
                "Indonesia_Western": "8s,0,4sb,0,q3,0,1b5|||",
                "Iran": "8s,0,gr,0,5g|8s,0,hh,0,5g||",
                "Irkutsk": "8s,0,gr,0,3h|8s,0,hh,0,3h||",
                "Israel": "8s,0,gr,0,4e|8s,0,hh,0,4e||",
                "Japan": "8s,0,gr,0,6o|8s,0,hh,0,6o||",
                "Kazakhstan_Eastern": "8s,0,2kv,0,q3,0,1js|||",
                "Kazakhstan_Western": "8s,0,2kv,0,q3,0,1b5|||",
                "Korea": "8s,0,gr,0,qf|8s,0,hh,0,qf||",
                "Kyrgystan": "8s,0,c34|||",
                "Lanka": "8s,0,me,0,9c|||",
                "Macau": "8s,0,gr,0,57|8s,0,hh,0,57||",
                "Macquarie": "8s,0,2v7,0,6m|||",
                "Malaysia": "8s,0,bf|||",
                "Maldives": "8s,0,q3,0,c33|||",
                "Marquesas": "8s,0,1qc,0,1jm|||",
                "Marshall_Islands": "8s,0,1qc,0,7o|||",
                "Mauritius": "8s,0,gr,0,4tn|8s,0,hh,0,4tn||",
                "Mexico_Northwest": "8s,0,gr,0,4to,0,4tr|8s,0,hh,0,4to,0,4tr||",
                "Mongolia": "8s,0,gr,0,p2|8s,0,hh,0,p2||",
                "Moscow": "8s,0,gr,0,4tv|8s,0,hh,0,4tv||",
                "Myanmar": "8s,0,8v|||",
                "Nauru": "8s,0,5v|||",
                "Nepal": "8s,0,8u|||",
                "New_Caledonia": "8s,0,gr,0,215,0,4f1|8s,0,hh,0,215,0,4f1||",
                "New_Zealand": "8s,0,gr,0,1p4,5,4f1|8s,0,hh,0,1p4,5,4f1||",
                "Newfoundland": "8s,0,gr,0,53|8s,0,hh,0,53||",
                "Niue": "8s,0,8g|||",
                "Norfolk": "8s,0,2v7,0,6l|||",
                "Novosibirsk": "8s,0,gr,0,3b|8s,0,hh,0,3b||",
                "Pakistan": "8s,0,gr,0,3i|8s,0,hh,0,3i||",
                "Palau": "8s,0,9b|||",
                "Paraguay": "8s,0,gr,0,3c|8s,0,hh,0,3c||",
                "Peru": "8s,0,gr,0,4uf|8s,0,hh,0,4uf||",
                "Philippines": "8s,0,gr,0,q3,0,4ug|8s,0,hh,0,q3,0,4ug||",
                "Pierre_Miquelon": "8s,0,gr,0,50g,5,50l,5,4f4,5,u2|8s,0,hh,0,50g,5,50l,5,4f4,5,u2||",
                "Pitcairn": "8s,0,7e|||",
                "Reunion": "8s,0,q3,0,c32|||",
                "Sakhalin": "8s,0,gr,0,55|8s,0,hh,0,55||",
                "Samoa": "8s,0,gr,0,2c|8s,0,hh,0,2c||",
                "Seychelles": "8s,0,c31|||",
                "Singapore": "8s,0,gr,0,mu|||",
                "Solomon": "8s,0,1qc,0,mq|||",
                "South_Georgia": "8s,0,2u,0,q3,0,c30|||",
                "Suriname": "8s,0,mg|||",
                "Tahiti": "8s,0,8n|||",
                "Taipei": "8s,0,gr,0,3d|8s,0,hh,0,3d||",
                "Tajikistan": "8s,0,lc|||",
                "Tokelau": "8s,0,5d|||",
                "Tonga": "8s,0,gr,0,2j|8s,0,hh,0,2j||",
                "Turkmenistan": "8s,0,gr,0,4t|8s,0,hh,0,4t||",
                "Tuvalu": "8s,0,6h|||",
                "Uruguay": "8s,0,gr,0,4k|8s,0,hh,0,4k||",
                "Uzbekistan": "8s,0,gr,0,50v|8s,0,hh,0,50v||",
                "Vanuatu": "8s,0,gr,0,2f|8s,0,hh,0,2f||",
                "Venezuela": "8s,0,7s|||",
                "Vladivostok": "8s,0,gr,0,28|8s,0,hh,0,28||",
                "Volgograd": "8s,0,gr,0,3f|8s,0,hh,0,3f||",
                "Wallis": "8s,0,5f,0,4f4,0,5k|||",
                "Yakutsk": "8s,0,gr,0,3u|8s,0,hh,0,3u||",
                "Yekaterinburg": "8s,0,gr,0,511|8s,0,hh,0,511||"
            }
        },
        "brx": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c95,0,ic,0,70||",
                "Europe/London": "|c96,0,ic,0,70||"
            },
            "metazone": {
                "Acre": "514,0,aj,0,70|514,0,ic,0,70||",
                "Afghanistan": "c2v,0,aj,0,70|||",
                "Africa_Central": "1a6,0,31i,0,aj,0,70|||",
                "Africa_Eastern": "oq,0,31i,0,aj,0,70|||",
                "Africa_Southern": "1jl,0,31i,0,aj,0,70|||",
                "Africa_Western": "2bi,0,31i,0,aj,0,70|2bi,0,31i,0,ic,0,70||",
                "Alaska": "4es,0,aj,0,70|4es,0,11u,0,70||",
                "Almaty": "520,0,aj,0,70|520,0,ic,0,70||",
                "Amazon": "523,0,aj,0,70|523,0,ic,0,70||",
                "America_Central": "529,0,2bd,0,aj,0,70|529,0,2bd,0,11u,0,70||",
                "America_Eastern": "27t,0,2bd,0,aj,0,70|27t,0,2bd,0,11u,0,70||",
                "America_Mountain": "2bd,0,52g,0,aj,0,70|2bd,0,52g,0,11u,0,70||",
                "America_Pacific": "52l,0,aj,0,70|52l,0,11u,0,70||",
                "Anadyr": "4er,0,aj,0,70|4er,0,ic,0,70||",
                "Aqtau": "52n,0,aj,0,70|52n,0,ic,0,70||",
                "Aqtobe": "52v,0,aj,0,70|52v,0,ic,0,70||",
                "Arabian": "2bb,0,aj,0,70|2bb,0,11u,0,70||",
                "Argentina": "c2u,0,aj,0,70|4hn,0,ic,0,70||",
                "Argentina_Western": "2bi,0,4hn,0,aj,0,70|2bi,0,4hn,0,ic,0,70||",
                "Armenia": "537,0,aj,0,70|537,0,ic,0,70||",
                "Atlantic": "53b,0,aj,0,70|53b,0,11u,0,70||",
                "Australia_Central": "1a6,0,21b,0,aj,0,70|1a6,0,21b,0,11u,0,70||",
                "Australia_CentralWestern": "1a6,5,2bi,0,21b,0,aj,0,70|1a6,5,2bi,0,21b,0,11u,0,70||",
                "Australia_Eastern": "oq,0,21b,0,aj,0,70|oq,0,21b,0,11u,0,70||",
                "Australia_Western": "1jl,0,21b,0,aj,0,70|1jl,0,21b,0,11u,0,70||",
                "Azerbaijan": "53i,0,aj,0,70|53i,0,ic,0,70||",
                "Azores": "53r,0,aj,0,70|53r,0,ic,0,70||",
                "Bangladesh": "4eo,0,aj,0,70|4eo,0,ic,0,70||",
                "Bhutan": "c2t,0,aj,0,70|||",
                "Bolivia": "c2s,0,aj,0,70|||",
                "Brasilia": "549,0,aj,0,70|549,0,ic,0,70||",
                "Brunei": "54g,0,c2r,0,c2q,0,c2p,0,aj,0,70|||",
                "Cape_Verde": "557,0,55r,0,aj,0,70|557,0,55r,0,ic,0,70||",
                "Chamorro": "c2o,0,aj,0,70|||",
                "Chatham": "4en,0,aj,0,70|4en,0,11u,0,70||",
                "Chile": "58a,0,aj,0,70|58a,0,ic,0,70||",
                "China": "58b,0,aj,0,70|58b,0,11u,0,70||",
                "Choibalsan": "58e,0,aj,0,70|58e,0,ic,0,70||",
                "Christmas": "c2n,0,aj,0,70|||",
                "Cocos": "c2m,0,1ev,0,aj,0,70|||",
                "Colombia": "2b7,0,aj,0,70|2b7,0,ic,0,70||",
                "Cook": "1lj,0,1ev,0,aj,0,70|1lj,0,1ev,0,597,0,ic,0,70||",
                "Cuba": "599,0,aj,0,70|599,0,11u,0,70||",
                "Davis": "c2l,0,aj,0,70|||",
                "DumontDUrville": "c2k,0,c2j,0,aj,0,70|||",
                "East_Timor": "c2i,0,c2h,0,aj,0,70|||",
                "Easter": "4em,0,5bq,0,aj,0,70|4em,0,5bq,0,ic,0,70||",
                "Ecuador": "c2g,0,aj,0,70|||",
                "Europe_Central": "1a6,0,2b4,0,aj,0,70|1a6,0,2b4,0,ic,0,70||",
                "Europe_Eastern": "27t,0,2b4,0,aj,0,70|27t,0,2b4,0,ic,0,70||",
                "Europe_Western": "2au,0,2b4,0,aj,0,70|2au,0,2b4,0,ic,0,70||",
                "Falkland": "5c8,0,aj,0,70|5c8,0,ic,0,70||",
                "Fiji": "5cc,0,aj,0,70|5cc,0,ic,0,70||",
                "French_Guiana": "5cd,0,2as,0,aj,0,70|||",
                "French_Southern": "1jl,0,5cd,0,aj,0,70|||",
                "Galapagos": "c2f,0,aj,0,70|||",
                "Gambier": "c2e,0,aj,0,70|||",
                "Georgia": "5dd,0,aj,0,70|5dd,0,ic,0,70||",
                "Gilbert_Islands": "c2d,0,1ev,0,aj,0,70|||",
                "GMT": "c2c,0,aj,0,70|||",
                "Greenland_Eastern": "4el,0,27t,0,aj,0,70|4el,0,27t,0,ic,0,70||",
                "Greenland_Western": "4el,0,2au,0,aj,0,70|4el,0,2au,0,ic,0,70||",
                "Guam": "5e7,0,aj,0,70|||",
                "Gulf": "c2b,0,aj,0,70|||",
                "Guyana": "2as,0,aj,0,70|||",
                "Hawaii_Aleutian": "21u,0,5g2,0,aj,0,70|21u,0,5g2,0,11u,0,70||",
                "Hong_Kong": "5ia,0,aj,0,70|5ia,0,ic,0,70||",
                "Hovd": "4ei,0,aj,0,70|4ei,0,ic,0,70||",
                "India": "27j,0,aj,0,70||15a|",
                "Indian_Ocean": "27j,0,c2a,0,aj,0,70|||",
                "Indochina": "c29,0,c28,0,aj,0,70|||",
                "Indonesia_Central": "4ho,0,aj,0,70|||",
                "Indonesia_Eastern": "27t,0,4ho,0,aj,0,70|||",
                "Indonesia_Western": "2au,0,4ho,0,aj,0,70|||",
                "Iran": "4eg,0,aj,0,70|4eg,0,11u,0,70||",
                "Irkutsk": "5kn,0,aj,0,70|5kn,0,ic,0,70||",
                "Israel": "5kp,0,aj,0,70|5kp,0,11u,0,70||",
                "Japan": "4ef,0,aj,0,70|4ef,0,11u,0,70||",
                "Kamchatka": "5l4,0,5l7,0,aj,0,70|5l4,0,5l7,0,ic,0,70||",
                "Kazakhstan_Eastern": "5lc,0,70|||",
                "Kazakhstan_Western": "2au,0,5lc,0,70|||",
                "Korea": "5lk,0,aj,0,70|5lk,0,11u,0,70||",
                "Kosrae": "c27,0,aj,0,70|||",
                "Krasnoyarsk": "5lr,0,aj,0,70|5lr,0,ic,0,70||",
                "Kyrgystan": "c26,0,aj,0,70|||",
                "Lanka": "5m0,0,aj,0,70|||",
                "Line_Islands": "c25,0,1ev,0,aj,0,70|||",
                "Lord_Howe": "5m2,0,5m3,0,aj,0,70|5m2,0,5m3,0,11u,0,70||",
                "Macau": "5m6,0,aj,0,70|5m6,0,ic,0,70||",
                "Magadan": "5m7,0,aj,0,70|5m7,0,ic,0,70||",
                "Malaysia": "4hp,0,aj,0,70|||",
                "Maldives": "5ma,0,aj,0,70|||",
                "Marquesas": "c24,0,aj,0,70|||",
                "Marshall_Islands": "2ob,0,c23,0,70|||",
                "Mauritius": "5mf,0,aj,0,70|5mf,0,ic,0,70||",
                "Mawson": "5mg,0,aj,0,70|||",
                "Mongolia": "5na,0,aj,0,70|5na,0,ic,0,70||",
                "Moscow": "2lk,0,aj,0,70|2lk,0,ic,0,70||",
                "Myanmar": "4ed,0,aj,0,70|||",
                "Nauru": "c22,0,aj,0,70|||",
                "Nepal": "5nu,0,aj,0,70|||",
                "New_Caledonia": "4hq,0,4e9,0,aj,0,70|4hq,0,4e9,0,ic,0,70||",
                "New_Zealand": "5o7,0,aj,0,70|5o7,0,11u,0,70||",
                "Newfoundland": "5o9,0,aj,0,70|5o9,0,11u,0,70||",
                "Niue": "c21,0,aj,0,70|||",
                "Norfolk": "5od,0,aj,0,70|||",
                "Noronha": "5of,0,5og,0,1n8,0,aj,0,70|5of,0,5og,0,1n8,0,ic,0,70||",
                "North_Mariana": "c20,0,c1v,0,aj,0,70|||",
                "Novosibirsk": "5om,0,aj,0,70|5om,0,ic,0,70||",
                "Omsk": "1nb,0,aj,0,70|1nb,0,ic,0,70||",
                "Pakistan": "2li,0,aj,0,70|2li,0,ic,0,70||",
                "Palau": "5os,0,aj,0,70|||",
                "Papua_New_Guinea": "4hr,0,4hq,0,c1u,0,aj,0,70|||",
                "Paraguay": "5p8,0,aj,0,70|5p8,0,ic,0,70||",
                "Peru": "2k9,0,aj,0,70|2k9,0,ic,0,70||",
                "Philippines": "5pa,0,aj,0,70|5pa,0,ic,0,70||",
                "Phoenix_Islands": "c1t,0,1ev,0,aj,0,70|||",
                "Pierre_Miquelon": "5pj,0,5pm,0,4hs,0,5po,0,aj,0,70|5pj,0,5pm,0,4hs,0,5po,0,11u,0,70||",
                "Pitcairn": "c1s,0,aj,0,70|||",
                "Ponape": "4e6,0,c1r,0,aj,0,70|||",
                "Qyzylorda": "5q5,0,aj,0,70|5q5,0,ic,0,70||",
                "Reunion": "c1q,0,aj,0,70|||",
                "Rothera": "2qb,0,aj,0,70|||",
                "Sakhalin": "5q9,0,aj,0,70|5q9,0,ic,0,70||",
                "Samara": "4e5,0,aj,0,70|4e5,0,ic,0,70||",
                "Samoa": "4e4,0,aj,0,70|4e4,0,ic,0,70||",
                "Seychelles": "5qu,0,aj,0,70|||",
                "Singapore": "c1p,0,aj,0,70|||",
                "Solomon": "c1o,0,aj,0,70|||",
                "South_Georgia": "c1n,0,27i,0,aj,0,70|||",
                "Suriname": "c1m,0,aj,0,70|||",
                "Syowa": "c1l,0,aj,0,70|||",
                "Tahiti": "c1k,0,aj,0,70|||",
                "Tajikistan": "c1j,0,aj,0,70|||",
                "Tokelau": "c1i,0,aj,0,70|||",
                "Tonga": "5sk,0,aj,0,70|5sk,0,ic,0,70||",
                "Truk": "c1h,0,aj,0,70|||",
                "Turkmenistan": "5so,0,aj,0,70|5so,0,ic,0,70||",
                "Tuvalu": "c1g,0,aj,0,70|||",
                "Uruguay": "5ua,0,aj,0,70|5ua,0,ic,0,70||",
                "Uzbekistan": "5ug,0,aj,0,70|5ug,0,ic,0,70||",
                "Vanuatu": "5ut,0,aj,0,70|5ut,0,ic,0,70||",
                "Venezuela": "5vc,0,aj,0,70|||",
                "Vladivostok": "5vd,0,aj,0,70|5vd,0,11u,0,70||",
                "Volgograd": "5vf,0,aj,0,70|5vf,0,ic,0,70||",
                "Vostok": "c1f,0,aj,0,70|||",
                "Wake": "c1e,0,1ev,0,aj,0,70|||",
                "Wallis": "c1d,0,4hs,0,c1c,0,aj,0,70|||",
                "Yakutsk": "5vp,0,aj,0,70|5vp,0,ic,0,70||",
                "Yekaterinburg": "5vq,0,aj,0,70|5vq,0,ic,0,70||"
            }
        },
        "bs-Cyrl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "63g,0,1q,0,m|63g,0,20,0,m||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "18j,0,1q,0,m|18j,0,20,0,2b,0,2d||",
                "America_Eastern": "12g,0,1q,0,m|12g,0,20,0,2b,0,2d||",
                "America_Mountain": "4e3,0,1q,0,m|4e3,0,20,0,2b,0,2d||",
                "America_Pacific": "4dv,0,1q,0,m|4dv,0,20,0,2b,0,2d||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "64i,0,1q,0,m|64i,0,20,0,2b,0,2d||",
                "Atlantic": "64n,0,1q,0,m|64n,0,c1b,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "c1a,0,1q,0,m|c19,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "c18,0,pm,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d||",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d||",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "c17,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "4ht,0,c16,0,m|||",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "6di,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|c15,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,4dr||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "c14,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "c13,0,ir,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,4dr||",
                "Macquarie": "c12,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,4dr||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,4dr||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "1v2,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "4dn,0,1q,0,c11|4dn,0,20,0,2b,0,2d||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "26d,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "bs-Latn": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6p7,0,1a,0,10||",
                "Europe/London": "|6ou,0,4b,0,10||"
            },
            "metazone": {
                "Acre": "3q,0,1a,0,1d|3q,0,3o,0,40,0,3v||",
                "Afghanistan": "6ov,0,10|||",
                "Africa_Central": "6p1,0,10|||",
                "Africa_Eastern": "6p2,0,10|||",
                "Africa_Southern": "6p3,0,1a,0,10|||",
                "Africa_Western": "4di,0,1a,0,10|4di,0,4b,0,10||",
                "Alaska": "4de,0,1a,0,10|4de,0,4b,0,10||",
                "Almaty": "4dc,0,1a,0,1d|4dc,0,3o,0,40,0,3v||",
                "Amazon": "4db,0,1a,0,10|4db,0,4b,0,10||",
                "America_Central": "13n,0,ug,0,1a,0,10|13n,0,ug,0,4b,0,10||",
                "America_Eastern": "13n,0,111,0,1a,0,10|13n,0,111,0,4b,0,10||",
                "America_Mountain": "13n,0,17r,0,1a,0,10|13n,0,17r,0,4b,0,10||",
                "America_Pacific": "13n,0,110,0,1a,0,10|13n,0,110,0,4b,0,10||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "4d8,0,1a,0,10|4d8,0,4b,0,10||",
                "Aqtau": "4d7,0,1a,0,1d|4d7,0,3o,0,40,0,3v||",
                "Aqtobe": "4d5,0,1a,0,1d|4d5,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,10|1i1,0,4b,0,10||",
                "Argentina": "4d4,0,1a,0,10|4d4,0,4b,0,10||",
                "Argentina_Western": "4d3,0,1a,0,10|4d3,0,4b,0,10||",
                "Armenia": "4d2,0,1a,0,10|4d2,0,4b,0,10||",
                "Atlantic": "13n,0,23j,0,1a,0,10|13n,0,23j,0,4b,0,10||",
                "Australia_Central": "4cv,0,1a,0,10|4cv,0,4b,0,10||",
                "Australia_CentralWestern": "pp,0,4cu,0,1a,0,10|pp,0,4cu,0,4b,0,10||",
                "Australia_Eastern": "4ct,0,1a,0,10|4ct,0,4b,0,10||",
                "Australia_Western": "4cs,0,1a,0,10|4cs,0,4b,0,10||",
                "Azerbaijan": "4cr,0,1a,0,10|4cr,0,4b,0,10||",
                "Azores": "4cq,0,1a,0,10|4cq,0,4b,0,10||",
                "Bangladesh": "4cp,0,1a,0,10|4cp,0,4b,0,10||",
                "Bhutan": "6r8,0,10|||",
                "Bolivia": "6rg,0,10|||",
                "Brasilia": "4co,0,1a,0,10|4co,0,4b,0,10||",
                "Brunei": "6rl,0,10|||",
                "Cape_Verde": "4cn,0,1a,0,10|4cn,0,4b,0,10||",
                "Chamorro": "6rq,0,1a,0,10|||",
                "Chatham": "4cm,0,1a,0,10|4cm,0,4b,0,10||",
                "Chile": "4cl,0,1a,0,10|4cl,0,4b,0,10||",
                "China": "23o,0,1a,0,10|23o,0,4b,0,10||",
                "Choibalsan": "4ck,0,1a,0,10|4ck,0,4b,0,10||",
                "Christmas": "ln,0,52,0,6so,0,10o|||",
                "Cocos": "ln,0,52,0,1b9,0,1eg|||",
                "Colombia": "4cj,0,1a,0,10|4cj,0,4b,0,10||",
                "Cook": "1lq,0,10,0,52,0,4ci,0,1lv|6u2,0,10,0,52,0,4ci,0,1lv||",
                "Cuba": "4ch,0,1a,0,10|4ch,0,4b,0,10||",
                "Davis": "ln,0,10j,0,5s|||",
                "DumontDUrville": "ln,0,10j,0,5b,5,5j|||",
                "East_Timor": "70n,0,10|||",
                "Easter": "4cg,0,1a,0,10|4cg,0,4b,0,10||",
                "Ecuador": "71f,0,10|||",
                "Europe_Central": "4cf,0,1a,0,10|4cf,0,4b,0,10||",
                "Europe_Eastern": "1hr,0,1a,0,10|1hr,0,4b,0,10||",
                "Europe_Further_Eastern": "71p,0,10|||",
                "Europe_Western": "1hq,0,1a,0,10|1hq,0,4b,0,10||",
                "Falkland": "4ce,0,1a,0,10|4ce,0,4b,0,10||",
                "Fiji": "1lq,0,10,0,52,0,725|727,0,4b,0,10||",
                "French_Guiana": "72a,0,10|||",
                "French_Southern": "ln,0,52,0,72c,0,72f,0,72h,0,i3,0,72r|||",
                "Galapagos": "72s,0,10|||",
                "Gambier": "72t,0,10|||",
                "Georgia": "4cd,0,1a,0,10|4cd,0,4b,0,10||",
                "Gilbert_Islands": "ln,0,52,0,736,0,1lv|||",
                "GMT": "73a,0,10|||",
                "Greenland_Eastern": "4cb,0,1a,0,10|4cb,0,4b,0,10||",
                "Greenland_Western": "4ca,0,1a,0,10|4ca,0,4b,0,10||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1a,0,10|||",
                "Guyana": "740,0,10|||",
                "Hawaii_Aleutian": "1c5,5,4c9,0,1a,0,10|1c5,5,4c9,0,4b,0,10||",
                "Hong_Kong": "4c8,0,1a,0,10|4c8,0,4b,0,10||",
                "Hovd": "4c7,0,1a,0,10|4c7,0,4b,0,10||",
                "India": "1n7,0,1a,0,10|||",
                "Indian_Ocean": "ln,0,52,0,77g,0,77h|||",
                "Indochina": "77j,0,10|||",
                "Indonesia_Central": "77l,0,10|||",
                "Indonesia_Eastern": "77o,0,10|||",
                "Indonesia_Western": "77s,0,10|||",
                "Iran": "4c6,0,1a,0,10|4c6,0,4b,0,10||",
                "Irkutsk": "2c5,0,1a,0,10|2c5,0,4b,0,10||",
                "Israel": "1hm,0,1a,0,10|1hm,0,4b,0,10||",
                "Japan": "1hl,0,1a,0,10|1hl,0,4b,0,10||",
                "Kamchatka": "37,5,2c4,0,1a,0,1d|37,5,2c4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "788,0,10|||",
                "Kazakhstan_Western": "789,0,10|||",
                "Korea": "1hk,0,1a,0,10|1hk,0,4b,0,10||",
                "Kosrae": "ln,0,52,0,10o,0,6f|||",
                "Krasnoyarsk": "2br,0,1a,0,10|2br,0,4b,0,10||",
                "Kyrgystan": "78c,0,10|||",
                "Lanka": "9c,0,1d|||",
                "Line_Islands": "ln,0,52,0,1b9,0,2bp|||",
                "Lord_Howe": "1lq,0,10,0,52,0,10o,0,1u,0,1i2|2bk,0,10,0,52,0,10o,0,1u,0,1i2||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "ln,0,52,0,10o,0,794|||",
                "Magadan": "4c5,0,1a,0,10|4c5,0,4b,0,10||",
                "Malaysia": "79b,0,10|||",
                "Maldives": "79e,0,10|||",
                "Marquesas": "ln,0,52,0,1b9,0,1jm|||",
                "Marshall_Islands": "ln,0,52,0,79h,0,1lv|||",
                "Mauritius": "4c4,0,1a,0,10|4c4,0,4b,0,10||",
                "Mawson": "ln,0,10j,0,63|||",
                "Mexico_Northwest": "4c3,0,1hj,0,1a,0,10|4c3,0,1hj,0,4b,0,10||",
                "Mexico_Pacific": "4c2,0,110,0,1a,0,10|4c2,0,110,0,4b,0,10||",
                "Mongolia": "4c0,0,1a,0,10|4c0,0,4b,0,10||",
                "Moscow": "4bv,0,1a,0,10|4bv,0,4b,0,10||",
                "Myanmar": "79v,0,10|||",
                "Nauru": "ln,0,52,0,10o,0,5v|||",
                "Nepal": "7a0,0,10|||",
                "New_Caledonia": "4bu,0,1a,0,10|4bu,0,4b,0,10||",
                "New_Zealand": "4bt,0,1a,0,10|4bt,0,4b,0,10||",
                "Newfoundland": "4bs,0,1a,0,10|4bs,0,4b,0,10||",
                "Niue": "ln,0,52,0,10o,0,8g|||",
                "Norfolk": "7a8,0,10|||",
                "Noronha": "1lq,0,10,0,52,0,4bq,0,1s,0,4i,0,1hg|2bk,0,10,0,52,0,4bq,0,1s,0,4i,0,1hg||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "2b8,0,1a,0,10|2b8,0,4b,0,10||",
                "Omsk": "2b1,0,1a,0,10|2b1,0,4b,0,10||",
                "Pakistan": "4bp,0,1a,0,10|4bp,0,4b,0,10||",
                "Palau": "ln,0,52,0,10o,0,9b|||",
                "Papua_New_Guinea": "ln,0,52,0,7b2,0,7br,0,7cc|||",
                "Paraguay": "4bo,0,1a,0,10|4bo,0,4b,0,10||",
                "Peru": "4bn,0,1a,0,10|4bn,0,4b,0,10||",
                "Philippines": "4bl,0,1a,0,10|4bl,0,4b,0,10||",
                "Phoenix_Islands": "ln,0,52,0,1b9,0,7ep|||",
                "Pierre_Miquelon": "1lq,0,10,0,52,0,1b9,0,14i,0,1he,0,i3,0,u2|2bk,0,10,0,52,0,1b9,0,14i,0,1he,0,i3,0,u2||",
                "Pitcairn": "ln,0,52,0,10o,0,1ko|||",
                "Ponape": "ln,0,52,0,10o,0,9s|||",
                "Pyongyang": "2b0,0,10|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "7fs,0,10|||",
                "Rothera": "ln,0,10j,0,5q|||",
                "Sakhalin": "4bk,0,1a,0,10|4bk,0,4b,0,10||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "4bj,0,1a,0,10|4bj,0,4b,0,10||",
                "Seychelles": "7j1,0,10|||",
                "Singapore": "7j2,0,1a,0,10|||",
                "Solomon": "ln,0,52,0,7l1,0,1lv|||",
                "South_Georgia": "7o5,0,10|||",
                "Suriname": "7oe,0,10|||",
                "Syowa": "ln,0,10j,0,65|||",
                "Tahiti": "7oh,0,10|||",
                "Taipei": "4bi,0,1a,0,10|4bi,0,4b,0,10||",
                "Tajikistan": "7om,0,10|||",
                "Tokelau": "ln,0,52,0,10o,0,5d|||",
                "Tonga": "4bh,0,1a,0,10|4bh,0,4b,0,10||",
                "Truk": "7oo,0,10|||",
                "Turkmenistan": "4bg,0,1a,0,10|4bg,0,4b,0,10||",
                "Tuvalu": "7p1,0,10|||",
                "Uruguay": "4bf,0,1a,0,10|4bf,0,4b,0,10||",
                "Uzbekistan": "4be,0,1a,0,10|4be,0,4b,0,10||",
                "Vanuatu": "4bd,0,1a,0,10|4bd,0,4b,0,10||",
                "Venezuela": "7q9,0,10|||",
                "Vladivostok": "4bc,0,1a,0,10|4bc,0,4b,0,10||",
                "Volgograd": "4bb,0,1a,0,10|4bb,0,4b,0,10||",
                "Vostok": "ln,0,10j,0,5t|||",
                "Wake": "ln,0,52,0,10o,0,2ar|||",
                "Wallis": "ln,0,52,0,1b9,0,2aq,0,i3,0,5k|||",
                "Yakutsk": "2ap,0,1a,0,10|2ap,0,4b,0,10||",
                "Yekaterinburg": "4ba,0,1a,0,10|4ba,0,4b,0,10||"
            }
        },
        "bs": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6p7,0,1a,0,10||",
                "Europe/London": "|6ou,0,4b,0,10||"
            },
            "metazone": {
                "Acre": "3q,0,1a,0,1d|3q,0,3o,0,40,0,3v||",
                "Afghanistan": "6ov,0,10|||",
                "Africa_Central": "6p1,0,10|||",
                "Africa_Eastern": "6p2,0,10|||",
                "Africa_Southern": "6p3,0,1a,0,10|||",
                "Africa_Western": "4di,0,1a,0,10|4di,0,4b,0,10||",
                "Alaska": "4de,0,1a,0,10|4de,0,4b,0,10||",
                "Almaty": "4dc,0,1a,0,1d|4dc,0,3o,0,40,0,3v||",
                "Amazon": "4db,0,1a,0,10|4db,0,4b,0,10||",
                "America_Central": "13n,0,ug,0,1a,0,10|13n,0,ug,0,4b,0,10||",
                "America_Eastern": "13n,0,111,0,1a,0,10|13n,0,111,0,4b,0,10||",
                "America_Mountain": "13n,0,17r,0,1a,0,10|13n,0,17r,0,4b,0,10||",
                "America_Pacific": "13n,0,110,0,1a,0,10|13n,0,110,0,4b,0,10||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "4d8,0,1a,0,10|4d8,0,4b,0,10||",
                "Aqtau": "4d7,0,1a,0,1d|4d7,0,3o,0,40,0,3v||",
                "Aqtobe": "4d5,0,1a,0,1d|4d5,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,10|1i1,0,4b,0,10||",
                "Argentina": "4d4,0,1a,0,10|4d4,0,4b,0,10||",
                "Argentina_Western": "4d3,0,1a,0,10|4d3,0,4b,0,10||",
                "Armenia": "4d2,0,1a,0,10|4d2,0,4b,0,10||",
                "Atlantic": "13n,0,23j,0,1a,0,10|13n,0,23j,0,4b,0,10||",
                "Australia_Central": "4cv,0,1a,0,10|4cv,0,4b,0,10||",
                "Australia_CentralWestern": "pp,0,4cu,0,1a,0,10|pp,0,4cu,0,4b,0,10||",
                "Australia_Eastern": "4ct,0,1a,0,10|4ct,0,4b,0,10||",
                "Australia_Western": "4cs,0,1a,0,10|4cs,0,4b,0,10||",
                "Azerbaijan": "4cr,0,1a,0,10|4cr,0,4b,0,10||",
                "Azores": "4cq,0,1a,0,10|4cq,0,4b,0,10||",
                "Bangladesh": "4cp,0,1a,0,10|4cp,0,4b,0,10||",
                "Bhutan": "6r8,0,10|||",
                "Bolivia": "6rg,0,10|||",
                "Brasilia": "4co,0,1a,0,10|4co,0,4b,0,10||",
                "Brunei": "6rl,0,10|||",
                "Cape_Verde": "4cn,0,1a,0,10|4cn,0,4b,0,10||",
                "Chamorro": "6rq,0,1a,0,10|||",
                "Chatham": "4cm,0,1a,0,10|4cm,0,4b,0,10||",
                "Chile": "4cl,0,1a,0,10|4cl,0,4b,0,10||",
                "China": "23o,0,1a,0,10|23o,0,4b,0,10||",
                "Choibalsan": "4ck,0,1a,0,10|4ck,0,4b,0,10||",
                "Christmas": "ln,0,52,0,6so,0,10o|||",
                "Cocos": "ln,0,52,0,1b9,0,1eg|||",
                "Colombia": "4cj,0,1a,0,10|4cj,0,4b,0,10||",
                "Cook": "1lq,0,10,0,52,0,4ci,0,1lv|6u2,0,10,0,52,0,4ci,0,1lv||",
                "Cuba": "4ch,0,1a,0,10|4ch,0,4b,0,10||",
                "Davis": "ln,0,10j,0,5s|||",
                "DumontDUrville": "ln,0,10j,0,5b,5,5j|||",
                "East_Timor": "70n,0,10|||",
                "Easter": "4cg,0,1a,0,10|4cg,0,4b,0,10||",
                "Ecuador": "71f,0,10|||",
                "Europe_Central": "4cf,0,1a,0,10|4cf,0,4b,0,10||",
                "Europe_Eastern": "1hr,0,1a,0,10|1hr,0,4b,0,10||",
                "Europe_Further_Eastern": "71p,0,10|||",
                "Europe_Western": "1hq,0,1a,0,10|1hq,0,4b,0,10||",
                "Falkland": "4ce,0,1a,0,10|4ce,0,4b,0,10||",
                "Fiji": "1lq,0,10,0,52,0,725|727,0,4b,0,10||",
                "French_Guiana": "72a,0,10|||",
                "French_Southern": "ln,0,52,0,72c,0,72f,0,72h,0,i3,0,72r|||",
                "Galapagos": "72s,0,10|||",
                "Gambier": "72t,0,10|||",
                "Georgia": "4cd,0,1a,0,10|4cd,0,4b,0,10||",
                "Gilbert_Islands": "ln,0,52,0,736,0,1lv|||",
                "GMT": "73a,0,10|||",
                "Greenland_Eastern": "4cb,0,1a,0,10|4cb,0,4b,0,10||",
                "Greenland_Western": "4ca,0,1a,0,10|4ca,0,4b,0,10||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1a,0,10|||",
                "Guyana": "740,0,10|||",
                "Hawaii_Aleutian": "1c5,5,4c9,0,1a,0,10|1c5,5,4c9,0,4b,0,10||",
                "Hong_Kong": "4c8,0,1a,0,10|4c8,0,4b,0,10||",
                "Hovd": "4c7,0,1a,0,10|4c7,0,4b,0,10||",
                "India": "1n7,0,1a,0,10|||",
                "Indian_Ocean": "ln,0,52,0,77g,0,77h|||",
                "Indochina": "77j,0,10|||",
                "Indonesia_Central": "77l,0,10|||",
                "Indonesia_Eastern": "77o,0,10|||",
                "Indonesia_Western": "77s,0,10|||",
                "Iran": "4c6,0,1a,0,10|4c6,0,4b,0,10||",
                "Irkutsk": "2c5,0,1a,0,10|2c5,0,4b,0,10||",
                "Israel": "1hm,0,1a,0,10|1hm,0,4b,0,10||",
                "Japan": "1hl,0,1a,0,10|1hl,0,4b,0,10||",
                "Kamchatka": "37,5,2c4,0,1a,0,1d|37,5,2c4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "788,0,10|||",
                "Kazakhstan_Western": "789,0,10|||",
                "Korea": "1hk,0,1a,0,10|1hk,0,4b,0,10||",
                "Kosrae": "ln,0,52,0,10o,0,6f|||",
                "Krasnoyarsk": "2br,0,1a,0,10|2br,0,4b,0,10||",
                "Kyrgystan": "78c,0,10|||",
                "Lanka": "9c,0,1d|||",
                "Line_Islands": "ln,0,52,0,1b9,0,2bp|||",
                "Lord_Howe": "1lq,0,10,0,52,0,10o,0,1u,0,1i2|2bk,0,10,0,52,0,10o,0,1u,0,1i2||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "ln,0,52,0,10o,0,794|||",
                "Magadan": "4c5,0,1a,0,10|4c5,0,4b,0,10||",
                "Malaysia": "79b,0,10|||",
                "Maldives": "79e,0,10|||",
                "Marquesas": "ln,0,52,0,1b9,0,1jm|||",
                "Marshall_Islands": "ln,0,52,0,79h,0,1lv|||",
                "Mauritius": "4c4,0,1a,0,10|4c4,0,4b,0,10||",
                "Mawson": "ln,0,10j,0,63|||",
                "Mexico_Northwest": "4c3,0,1hj,0,1a,0,10|4c3,0,1hj,0,4b,0,10||",
                "Mexico_Pacific": "4c2,0,110,0,1a,0,10|4c2,0,110,0,4b,0,10||",
                "Mongolia": "4c0,0,1a,0,10|4c0,0,4b,0,10||",
                "Moscow": "4bv,0,1a,0,10|4bv,0,4b,0,10||",
                "Myanmar": "79v,0,10|||",
                "Nauru": "ln,0,52,0,10o,0,5v|||",
                "Nepal": "7a0,0,10|||",
                "New_Caledonia": "4bu,0,1a,0,10|4bu,0,4b,0,10||",
                "New_Zealand": "4bt,0,1a,0,10|4bt,0,4b,0,10||",
                "Newfoundland": "4bs,0,1a,0,10|4bs,0,4b,0,10||",
                "Niue": "ln,0,52,0,10o,0,8g|||",
                "Norfolk": "7a8,0,10|||",
                "Noronha": "1lq,0,10,0,52,0,4bq,0,1s,0,4i,0,1hg|2bk,0,10,0,52,0,4bq,0,1s,0,4i,0,1hg||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "2b8,0,1a,0,10|2b8,0,4b,0,10||",
                "Omsk": "2b1,0,1a,0,10|2b1,0,4b,0,10||",
                "Pakistan": "4bp,0,1a,0,10|4bp,0,4b,0,10||",
                "Palau": "ln,0,52,0,10o,0,9b|||",
                "Papua_New_Guinea": "ln,0,52,0,7b2,0,7br,0,7cc|||",
                "Paraguay": "4bo,0,1a,0,10|4bo,0,4b,0,10||",
                "Peru": "4bn,0,1a,0,10|4bn,0,4b,0,10||",
                "Philippines": "4bl,0,1a,0,10|4bl,0,4b,0,10||",
                "Phoenix_Islands": "ln,0,52,0,1b9,0,7ep|||",
                "Pierre_Miquelon": "1lq,0,10,0,52,0,1b9,0,14i,0,1he,0,i3,0,u2|2bk,0,10,0,52,0,1b9,0,14i,0,1he,0,i3,0,u2||",
                "Pitcairn": "ln,0,52,0,10o,0,1ko|||",
                "Ponape": "ln,0,52,0,10o,0,9s|||",
                "Pyongyang": "2b0,0,10|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "7fs,0,10|||",
                "Rothera": "ln,0,10j,0,5q|||",
                "Sakhalin": "4bk,0,1a,0,10|4bk,0,4b,0,10||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "4bj,0,1a,0,10|4bj,0,4b,0,10||",
                "Seychelles": "7j1,0,10|||",
                "Singapore": "7j2,0,1a,0,10|||",
                "Solomon": "ln,0,52,0,7l1,0,1lv|||",
                "South_Georgia": "7o5,0,10|||",
                "Suriname": "7oe,0,10|||",
                "Syowa": "ln,0,10j,0,65|||",
                "Tahiti": "7oh,0,10|||",
                "Taipei": "4bi,0,1a,0,10|4bi,0,4b,0,10||",
                "Tajikistan": "7om,0,10|||",
                "Tokelau": "ln,0,52,0,10o,0,5d|||",
                "Tonga": "4bh,0,1a,0,10|4bh,0,4b,0,10||",
                "Truk": "7oo,0,10|||",
                "Turkmenistan": "4bg,0,1a,0,10|4bg,0,4b,0,10||",
                "Tuvalu": "7p1,0,10|||",
                "Uruguay": "4bf,0,1a,0,10|4bf,0,4b,0,10||",
                "Uzbekistan": "4be,0,1a,0,10|4be,0,4b,0,10||",
                "Vanuatu": "4bd,0,1a,0,10|4bd,0,4b,0,10||",
                "Venezuela": "7q9,0,10|||",
                "Vladivostok": "4bc,0,1a,0,10|4bc,0,4b,0,10||",
                "Volgograd": "4bb,0,1a,0,10|4bb,0,4b,0,10||",
                "Vostok": "ln,0,10j,0,5t|||",
                "Wake": "ln,0,52,0,10o,0,2ar|||",
                "Wallis": "ln,0,52,0,1b9,0,2aq,0,i3,0,5k|||",
                "Yakutsk": "2ap,0,1a,0,10|2ap,0,4b,0,10||",
                "Yekaterinburg": "4ba,0,1a,0,10|4ba,0,4b,0,10||"
            }
        },
        "ca-AD": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,36,0,2v3||",
                "Europe/London": "|9,0,39,0,2v1||"
            },
            "metazone": {
                "Afghanistan": "9,0,2,0,2vj|||",
                "Africa_Central": "9,0,2,0,10i,0,n|||",
                "Africa_Eastern": "9,0,2,0,10i,0,8h|||",
                "Africa_Southern": "9,0,36,0,19,0,2vm,0,2,0,10i|||",
                "Africa_Western": "9,0,36,0,2,0,10i,0,of|9,0,39,0,2,0,10i,0,of||",
                "Alaska": "9,0,36,0,1ht|9,0,39,0,1ht||",
                "Amazon": "9,0,36,0,2,0,1ll|9,0,39,0,2,0,1ll||",
                "America_Central": "9,0,36,0,6r,0,ri,0,19,0,98|9,0,39,0,6r,0,ri,0,19,0,98||",
                "America_Eastern": "9,0,36,0,3r,0,ri,0,19,0,98|9,0,39,0,3r,0,ri,0,19,0,98||",
                "America_Mountain": "9,0,36,0,2,0,1lp,0,ri,0,19,0,98|9,0,39,0,2,0,1lp,0,ri,0,19,0,98||",
                "America_Pacific": "9,0,36,0,19,0,14b|9,0,39,0,19,0,14b||",
                "Anadyr": "9,0,36,0,cb|19v,0,39,0,cb||",
                "Apia": "9,0,36,0,c9|9,0,39,0,c9||",
                "Arabian": "9,0,36,0,1lu|9,0,39,0,1lu||",
                "Argentina": "9,0,36,0,2,0,13s|9,0,39,0,2,0,13s||",
                "Argentina_Western": "9,0,36,0,2,0,151,0,2,0,13s|9,0,39,0,2,0,151,0,2,0,13s||",
                "Armenia": "9,0,36,0,1m1|9,0,39,0,1m1||",
                "Atlantic": "9,0,36,0,2,0,1m2|9,0,39,0,2,0,1m2||",
                "Australia_Central": "9,0,36,0,p3,0,n|9,0,39,0,p3,0,n||",
                "Australia_CentralWestern": "9,0,36,0,p3,0,6n,5,48|9,0,39,0,p3,0,6n,5,48||",
                "Australia_Eastern": "9,0,36,0,p3,0,8h|9,0,39,0,p3,0,8h||",
                "Australia_Western": "9,0,36,0,p3,0,of|9,0,39,0,p3,0,of||",
                "Azerbaijan": "9,0,36,0,1m7|9,0,39,0,1m7||",
                "Azores": "9,0,36,0,2,0,et,0,b9|9,0,39,0,2,0,et,0,b9||",
                "Bangladesh": "9,0,36,0,2,0,1m9,0,1mc|9,0,39,0,2,0,1m9,0,1mc||",
                "Bhutan": "9,0,2,0,as|||",
                "Bolivia": "9,0,2,0,16g|||",
                "Brasilia": "9,0,36,0,2,0,in|9,0,39,0,2,0,in||",
                "Brunei": "9,0,2,0,9o,0,a4|||",
                "Cape_Verde": "9,0,36,0,2,0,cf,0,1mi|9,0,39,0,2,0,cf,0,1mi||",
                "Chamorro": "9,0,2,0,6j|||",
                "Chatham": "9,0,36,0,2,0,27|9,0,39,0,2,0,27||",
                "Chile": "9,0,36,0,2,0,1mj|9,0,39,0,2,0,1mj||",
                "China": "9,0,36,0,2,0,1c,0,1mk|9,0,39,0,2,0,1c,0,1mk||",
                "Choibalsan": "9,0,36,0,2,0,2q|9,0,39,0,2,0,2q||",
                "Christmas": "9,0,2,0,30k|||",
                "Cocos": "9,0,2,0,et,0,o7,0,7v|||",
                "Colombia": "9,0,36,0,2,0,1mn|9,0,39,0,2,0,1mn||",
                "Cook": "9,0,36,0,2,0,et,0,o7,0,2v|9,0,2,0,30q,0,30s,0,2,0,et,0,o7,0,2v||",
                "Cuba": "9,0,36,0,2,0,34|9,0,39,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,36,0,2,0,1mo,0,2,0,181|9,0,39,0,2,0,1mo,0,2,0,181||",
                "Ecuador": "9,0,2,0,30v|||",
                "Europe_Central": "9,0,36,0,19,0,cc,0,pn|9,0,39,0,19,0,cc,0,pn|h0|h4",
                "Europe_Eastern": "9,0,36,0,2,0,1v,0,pn|9,0,39,0,2,0,1v,0,pn|gu|gv",
                "Europe_Further_Eastern": "9,0,2,0,319,0,31b,0,2ao|||",
                "Europe_Western": "9,0,36,0,2,0,144,0,pn|9,0,39,0,2,0,144,0,pn|h1|h2",
                "Falkland": "9,0,36,0,2,0,et,0,o7,0,1nd|9,0,39,0,2,0,et,0,o7,0,1nd||",
                "Fiji": "9,0,36,0,2,0,4q|9,0,39,0,2,0,4q||",
                "French_Guiana": "9,0,2,0,1c,0,31j,0,nf|||",
                "French_Southern": "9,0,31k,0,i3,0,2ah,0,19,0,i6|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,36,0,2,0,1a0|9,0,39,0,2,0,1a0||",
                "Gilbert_Islands": "9,0,2,0,et,0,o7,0,6q|||",
                "GMT": "9,0,19,0,31o,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,36,0,2,0,1v,0,2,0,152|9,0,39,0,2,0,1v,0,2,0,152||",
                "Greenland_Western": "9,0,36,0,2,0,144,0,2,0,152|9,0,39,0,2,0,144,0,2,0,152||",
                "Gulf": "9,0,19,0,127|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "9,0,36,0,2,0,4g,5,1i5|9,0,39,0,2,0,4g,5,1i5||",
                "Hong_Kong": "9,0,36,0,2,0,2l,0,2p|9,0,39,0,2,0,2l,0,2p||",
                "Hovd": "9,0,36,0,2,0,2g|9,0,39,0,2,0,2g||",
                "India": "9,0,36,0,2,0,31q|||",
                "Indian_Ocean": "9,0,2,0,2lm,0,2ln|||",
                "Indochina": "9,0,2lo|||",
                "Indonesia_Central": "9,0,6r,0,1a1|||",
                "Indonesia_Eastern": "9,0,2,0,1nl,0,1a1|||",
                "Indonesia_Western": "9,0,2,0,151,0,1a1|||",
                "Iran": "9,0,36,0,ce|9,0,39,0,ce||",
                "Irkutsk": "9,0,36,0,1ia|9,0,39,0,1ia||",
                "Israel": "9,0,36,0,1ic|9,0,39,0,1ic||",
                "Japan": "9,0,36,0,19,0,1no|9,0,39,0,19,0,1no||",
                "Kamchatka": "9,0,36,0,2,0,37,0,2,0,1np|19v,0,39,0,2,0,37,0,2,0,1np||",
                "Kazakhstan_Eastern": "9,0,2,0,1nl,0,19,0,45|||",
                "Kazakhstan_Western": "9,0,2,0,151,0,19,0,45|||",
                "Korea": "9,0,36,0,2,0,hf|9,0,39,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,36,0,2,0,1c7|9,0,39,0,2,0,1c7||",
                "Kyrgystan": "9,0,19,0,2m4|||",
                "Line_Islands": "9,0,2,0,ac,0,o|||",
                "Lord_Howe": "9,0,36,0,2,0,1u,0,24|19v,0,39,0,2,0,1u,0,24||",
                "Macau": "9,0,36,0,2,0,57|9,0,39,0,2,0,57||",
                "Macquarie": "9,0,2,0,6m|||",
                "Magadan": "9,0,36,0,2,0,2o|9,0,39,0,2,0,2o||",
                "Malaysia": "9,0,2,0,2m6|||",
                "Maldives": "9,0,2,0,et,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,o7,0,7o|||",
                "Mauritius": "9,0,36,0,2,0,1nu|9,0,39,0,2,0,1nu||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,36,0,19,0,93,5,1o0,0,2,0,149|9,0,39,0,19,0,93,5,1o0,0,2,0,149||",
                "Mexico_Pacific": "9,0,36,0,19,0,14b,0,2,0,149|9,0,39,0,19,0,14b,0,2,0,149||",
                "Mongolia": "9,0,36,0,1o2,0,2m|9,0,39,0,1o2,0,2m||",
                "Moscow": "9,0,36,0,2,0,ca|9,0,39,0,2,0,ca||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,36,0,2,0,ba,0,1oc|9,0,39,0,2,0,ba,0,1oc||",
                "New_Zealand": "9,0,36,0,2,0,ba,0,go|9,0,39,0,2,0,ba,0,go||",
                "Newfoundland": "9,0,36,0,2,0,h5|9,0,39,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,et,0,o7,0,6l|||",
                "Noronha": "9,0,36,0,2,0,1s,0,2,0,23|9,0,39,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "9,0,36,0,2,0,3b|9,0,39,0,2,0,3b||",
                "Omsk": "9,0,36,0,1d1|9,0,39,0,1d1||",
                "Pakistan": "9,0,36,0,19,0,3i|9,0,39,0,19,0,3i||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,a8|||",
                "Paraguay": "9,0,36,0,19,0,p8|9,0,39,0,19,0,p8||",
                "Peru": "9,0,36,0,19,0,ha|9,0,39,0,19,0,ha||",
                "Philippines": "9,0,36,0,2,0,1jb|9,0,39,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,o7,0,90|||",
                "Pierre_Miquelon": "9,0,36,0,2,0,8i,5,33,0,i3,0,35|9,0,39,0,2,0,8i,5,33,0,i3,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Reunion": "9,0,2,0,2mi|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,36,0,2,0,55|9,0,39,0,2,0,55||",
                "Samara": "9,0,36,0,2,0,29|9,0,39,0,2,0,29||",
                "Samoa": "9,0,36,0,2,0,2c|9,0,39,0,2,0,2c||",
                "Seychelles": "9,0,2,0,et,0,8k|||",
                "Singapore": "9,0,2,0,m8|||",
                "Solomon": "9,0,2,0,2mk|||",
                "South_Georgia": "9,0,2,0,1a0,0,19,0,i6|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "9,0,36,0,2,0,3d|9,0,39,0,2,0,3d||",
                "Tajikistan": "9,0,19,0,lc|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,36,0,2,0,2j|9,0,39,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,36,0,19,0,4t|9,0,39,0,19,0,4t||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,36,0,2,0,1om|9,0,39,0,2,0,1om||",
                "Uzbekistan": "9,0,36,0,2,0,1op|9,0,39,0,2,0,1op||",
                "Vanuatu": "9,0,36,0,2,0,1oq|9,0,39,0,2,0,1oq||",
                "Venezuela": "9,0,2,0,2mr|||",
                "Vladivostok": "9,0,36,0,2,0,28|9,0,39,0,2,0,28||",
                "Volgograd": "9,0,36,0,2,0,3f|9,0,39,0,2,0,3f||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,i3,0,5k|||",
                "Yakutsk": "9,0,36,0,2,0,1h6|9,0,39,0,2,0,1h6||",
                "Yekaterinburg": "9,0,36,0,1os|9,0,39,0,1os||"
            }
        },
        "ca-ES-VALENCIA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,36,0,2v3||",
                "Europe/London": "|9,0,39,0,2v1||"
            },
            "metazone": {
                "Afghanistan": "9,0,2,0,2vj|||",
                "Africa_Central": "9,0,2,0,10i,0,n|||",
                "Africa_Eastern": "9,0,2,0,10i,0,8h|||",
                "Africa_Southern": "9,0,36,0,19,0,2vm,0,2,0,10i|||",
                "Africa_Western": "9,0,36,0,2,0,10i,0,of|9,0,39,0,2,0,10i,0,of||",
                "Alaska": "9,0,36,0,1ht|9,0,39,0,1ht||",
                "Amazon": "9,0,36,0,2,0,1ll|9,0,39,0,2,0,1ll||",
                "America_Central": "9,0,36,0,6r,0,ri,0,19,0,98|9,0,39,0,6r,0,ri,0,19,0,98||",
                "America_Eastern": "9,0,36,0,3r,0,ri,0,19,0,98|9,0,39,0,3r,0,ri,0,19,0,98||",
                "America_Mountain": "9,0,36,0,2,0,1lp,0,ri,0,19,0,98|9,0,39,0,2,0,1lp,0,ri,0,19,0,98||",
                "America_Pacific": "9,0,36,0,19,0,14b|9,0,39,0,19,0,14b||",
                "Anadyr": "9,0,36,0,cb|19v,0,39,0,cb||",
                "Apia": "9,0,36,0,c9|9,0,39,0,c9||",
                "Arabian": "9,0,36,0,1lu|9,0,39,0,1lu||",
                "Argentina": "9,0,36,0,2,0,13s|9,0,39,0,2,0,13s||",
                "Argentina_Western": "9,0,36,0,2,0,151,0,2,0,13s|9,0,39,0,2,0,151,0,2,0,13s||",
                "Armenia": "9,0,36,0,1m1|9,0,39,0,1m1||",
                "Atlantic": "9,0,36,0,2,0,1m2|9,0,39,0,2,0,1m2||",
                "Australia_Central": "9,0,36,0,p3,0,n|9,0,39,0,p3,0,n||",
                "Australia_CentralWestern": "9,0,36,0,p3,0,6n,5,48|9,0,39,0,p3,0,6n,5,48||",
                "Australia_Eastern": "9,0,36,0,p3,0,8h|9,0,39,0,p3,0,8h||",
                "Australia_Western": "9,0,36,0,p3,0,of|9,0,39,0,p3,0,of||",
                "Azerbaijan": "9,0,36,0,1m7|9,0,39,0,1m7||",
                "Azores": "9,0,36,0,2,0,et,0,b9|9,0,39,0,2,0,et,0,b9||",
                "Bangladesh": "9,0,36,0,2,0,1m9,0,1mc|9,0,39,0,2,0,1m9,0,1mc||",
                "Bhutan": "9,0,2,0,as|||",
                "Bolivia": "9,0,2,0,16g|||",
                "Brasilia": "9,0,36,0,2,0,in|9,0,39,0,2,0,in||",
                "Brunei": "9,0,2,0,9o,0,a4|||",
                "Cape_Verde": "9,0,36,0,2,0,cf,0,1mi|9,0,39,0,2,0,cf,0,1mi||",
                "Chamorro": "9,0,2,0,6j|||",
                "Chatham": "9,0,36,0,2,0,27|9,0,39,0,2,0,27||",
                "Chile": "9,0,36,0,2,0,1mj|9,0,39,0,2,0,1mj||",
                "China": "9,0,36,0,2,0,1c,0,1mk|9,0,39,0,2,0,1c,0,1mk||",
                "Choibalsan": "9,0,36,0,2,0,2q|9,0,39,0,2,0,2q||",
                "Christmas": "9,0,2,0,30k|||",
                "Cocos": "9,0,2,0,et,0,o7,0,7v|||",
                "Colombia": "9,0,36,0,2,0,1mn|9,0,39,0,2,0,1mn||",
                "Cook": "9,0,36,0,2,0,et,0,o7,0,2v|9,0,2,0,30q,0,30s,0,2,0,et,0,o7,0,2v||",
                "Cuba": "9,0,36,0,2,0,34|9,0,39,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,36,0,2,0,1mo,0,2,0,181|9,0,39,0,2,0,1mo,0,2,0,181||",
                "Ecuador": "9,0,2,0,30v|||",
                "Europe_Central": "9,0,36,0,19,0,cc,0,pn|9,0,39,0,19,0,cc,0,pn|h0|h4",
                "Europe_Eastern": "9,0,36,0,2,0,1v,0,pn|9,0,39,0,2,0,1v,0,pn|gu|gv",
                "Europe_Further_Eastern": "9,0,2,0,319,0,31b,0,2ao|||",
                "Europe_Western": "9,0,36,0,2,0,144,0,pn|9,0,39,0,2,0,144,0,pn|h1|h2",
                "Falkland": "9,0,36,0,2,0,et,0,o7,0,1nd|9,0,39,0,2,0,et,0,o7,0,1nd||",
                "Fiji": "9,0,36,0,2,0,4q|9,0,39,0,2,0,4q||",
                "French_Guiana": "9,0,2,0,1c,0,31j,0,nf|||",
                "French_Southern": "9,0,31k,0,i3,0,2ah,0,19,0,i6|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,36,0,2,0,1a0|9,0,39,0,2,0,1a0||",
                "Gilbert_Islands": "9,0,2,0,et,0,o7,0,6q|||",
                "GMT": "9,0,19,0,31o,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,36,0,2,0,1v,0,2,0,152|9,0,39,0,2,0,1v,0,2,0,152||",
                "Greenland_Western": "9,0,36,0,2,0,144,0,2,0,152|9,0,39,0,2,0,144,0,2,0,152||",
                "Gulf": "9,0,19,0,127|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "9,0,36,0,2,0,4g,5,1i5|9,0,39,0,2,0,4g,5,1i5||",
                "Hong_Kong": "9,0,36,0,2,0,2l,0,2p|9,0,39,0,2,0,2l,0,2p||",
                "Hovd": "9,0,36,0,2,0,2g|9,0,39,0,2,0,2g||",
                "India": "9,0,36,0,2,0,31q|||",
                "Indian_Ocean": "9,0,2,0,2lm,0,2ln|||",
                "Indochina": "9,0,2lo|||",
                "Indonesia_Central": "9,0,6r,0,1a1|||",
                "Indonesia_Eastern": "9,0,2,0,1nl,0,1a1|||",
                "Indonesia_Western": "9,0,2,0,151,0,1a1|||",
                "Iran": "9,0,36,0,ce|9,0,39,0,ce||",
                "Irkutsk": "9,0,36,0,1ia|9,0,39,0,1ia||",
                "Israel": "9,0,36,0,1ic|9,0,39,0,1ic||",
                "Japan": "9,0,36,0,19,0,1no|9,0,39,0,19,0,1no||",
                "Kamchatka": "9,0,36,0,2,0,37,0,2,0,1np|19v,0,39,0,2,0,37,0,2,0,1np||",
                "Kazakhstan_Eastern": "9,0,2,0,1nl,0,19,0,45|||",
                "Kazakhstan_Western": "9,0,2,0,151,0,19,0,45|||",
                "Korea": "9,0,36,0,2,0,hf|9,0,39,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,36,0,2,0,1c7|9,0,39,0,2,0,1c7||",
                "Kyrgystan": "9,0,19,0,2m4|||",
                "Line_Islands": "9,0,2,0,ac,0,o|||",
                "Lord_Howe": "9,0,36,0,2,0,1u,0,24|19v,0,39,0,2,0,1u,0,24||",
                "Macau": "9,0,36,0,2,0,57|9,0,39,0,2,0,57||",
                "Macquarie": "9,0,2,0,6m|||",
                "Magadan": "9,0,36,0,2,0,2o|9,0,39,0,2,0,2o||",
                "Malaysia": "9,0,2,0,2m6|||",
                "Maldives": "9,0,2,0,et,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,o7,0,7o|||",
                "Mauritius": "9,0,36,0,2,0,1nu|9,0,39,0,2,0,1nu||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,36,0,19,0,93,5,1o0,0,2,0,149|9,0,39,0,19,0,93,5,1o0,0,2,0,149||",
                "Mexico_Pacific": "9,0,36,0,19,0,14b,0,2,0,149|9,0,39,0,19,0,14b,0,2,0,149||",
                "Mongolia": "9,0,36,0,1o2,0,2m|9,0,39,0,1o2,0,2m||",
                "Moscow": "9,0,36,0,2,0,ca|9,0,39,0,2,0,ca||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,36,0,2,0,ba,0,1oc|9,0,39,0,2,0,ba,0,1oc||",
                "New_Zealand": "9,0,36,0,2,0,ba,0,go|9,0,39,0,2,0,ba,0,go||",
                "Newfoundland": "9,0,36,0,2,0,h5|9,0,39,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,et,0,o7,0,6l|||",
                "Noronha": "9,0,36,0,2,0,1s,0,2,0,23|9,0,39,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "9,0,36,0,2,0,3b|9,0,39,0,2,0,3b||",
                "Omsk": "9,0,36,0,1d1|9,0,39,0,1d1||",
                "Pakistan": "9,0,36,0,19,0,3i|9,0,39,0,19,0,3i||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,a8|||",
                "Paraguay": "9,0,36,0,19,0,p8|9,0,39,0,19,0,p8||",
                "Peru": "9,0,36,0,19,0,ha|9,0,39,0,19,0,ha||",
                "Philippines": "9,0,36,0,2,0,1jb|9,0,39,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,o7,0,90|||",
                "Pierre_Miquelon": "9,0,36,0,2,0,8i,5,33,0,i3,0,35|9,0,39,0,2,0,8i,5,33,0,i3,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Reunion": "9,0,2,0,2mi|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,36,0,2,0,55|9,0,39,0,2,0,55||",
                "Samara": "9,0,36,0,2,0,29|9,0,39,0,2,0,29||",
                "Samoa": "9,0,36,0,2,0,2c|9,0,39,0,2,0,2c||",
                "Seychelles": "9,0,2,0,et,0,8k|||",
                "Singapore": "9,0,2,0,m8|||",
                "Solomon": "9,0,2,0,2mk|||",
                "South_Georgia": "9,0,2,0,1a0,0,19,0,i6|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "9,0,36,0,2,0,3d|9,0,39,0,2,0,3d||",
                "Tajikistan": "9,0,19,0,lc|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,36,0,2,0,2j|9,0,39,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,36,0,19,0,4t|9,0,39,0,19,0,4t||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,36,0,2,0,1om|9,0,39,0,2,0,1om||",
                "Uzbekistan": "9,0,36,0,2,0,1op|9,0,39,0,2,0,1op||",
                "Vanuatu": "9,0,36,0,2,0,1oq|9,0,39,0,2,0,1oq||",
                "Venezuela": "9,0,2,0,2mr|||",
                "Vladivostok": "9,0,36,0,2,0,28|9,0,39,0,2,0,28||",
                "Volgograd": "9,0,36,0,2,0,3f|9,0,39,0,2,0,3f||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,i3,0,5k|||",
                "Yakutsk": "9,0,36,0,2,0,1h6|9,0,39,0,2,0,1h6||",
                "Yekaterinburg": "9,0,36,0,1os|9,0,39,0,1os||"
            }
        },
        "ca-FR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,36,0,2v3||",
                "Europe/London": "|9,0,39,0,2v1||"
            },
            "metazone": {
                "Afghanistan": "9,0,2,0,2vj|||",
                "Africa_Central": "9,0,2,0,10i,0,n|||",
                "Africa_Eastern": "9,0,2,0,10i,0,8h|||",
                "Africa_Southern": "9,0,36,0,19,0,2vm,0,2,0,10i|||",
                "Africa_Western": "9,0,36,0,2,0,10i,0,of|9,0,39,0,2,0,10i,0,of||",
                "Alaska": "9,0,36,0,1ht|9,0,39,0,1ht||",
                "Amazon": "9,0,36,0,2,0,1ll|9,0,39,0,2,0,1ll||",
                "America_Central": "9,0,36,0,6r,0,ri,0,19,0,98|9,0,39,0,6r,0,ri,0,19,0,98||",
                "America_Eastern": "9,0,36,0,3r,0,ri,0,19,0,98|9,0,39,0,3r,0,ri,0,19,0,98||",
                "America_Mountain": "9,0,36,0,2,0,1lp,0,ri,0,19,0,98|9,0,39,0,2,0,1lp,0,ri,0,19,0,98||",
                "America_Pacific": "9,0,36,0,19,0,14b|9,0,39,0,19,0,14b||",
                "Anadyr": "9,0,36,0,cb|19v,0,39,0,cb||",
                "Apia": "9,0,36,0,c9|9,0,39,0,c9||",
                "Arabian": "9,0,36,0,1lu|9,0,39,0,1lu||",
                "Argentina": "9,0,36,0,2,0,13s|9,0,39,0,2,0,13s||",
                "Argentina_Western": "9,0,36,0,2,0,151,0,2,0,13s|9,0,39,0,2,0,151,0,2,0,13s||",
                "Armenia": "9,0,36,0,1m1|9,0,39,0,1m1||",
                "Atlantic": "9,0,36,0,2,0,1m2|9,0,39,0,2,0,1m2||",
                "Australia_Central": "9,0,36,0,p3,0,n|9,0,39,0,p3,0,n||",
                "Australia_CentralWestern": "9,0,36,0,p3,0,6n,5,48|9,0,39,0,p3,0,6n,5,48||",
                "Australia_Eastern": "9,0,36,0,p3,0,8h|9,0,39,0,p3,0,8h||",
                "Australia_Western": "9,0,36,0,p3,0,of|9,0,39,0,p3,0,of||",
                "Azerbaijan": "9,0,36,0,1m7|9,0,39,0,1m7||",
                "Azores": "9,0,36,0,2,0,et,0,b9|9,0,39,0,2,0,et,0,b9||",
                "Bangladesh": "9,0,36,0,2,0,1m9,0,1mc|9,0,39,0,2,0,1m9,0,1mc||",
                "Bhutan": "9,0,2,0,as|||",
                "Bolivia": "9,0,2,0,16g|||",
                "Brasilia": "9,0,36,0,2,0,in|9,0,39,0,2,0,in||",
                "Brunei": "9,0,2,0,9o,0,a4|||",
                "Cape_Verde": "9,0,36,0,2,0,cf,0,1mi|9,0,39,0,2,0,cf,0,1mi||",
                "Chamorro": "9,0,2,0,6j|||",
                "Chatham": "9,0,36,0,2,0,27|9,0,39,0,2,0,27||",
                "Chile": "9,0,36,0,2,0,1mj|9,0,39,0,2,0,1mj||",
                "China": "9,0,36,0,2,0,1c,0,1mk|9,0,39,0,2,0,1c,0,1mk||",
                "Choibalsan": "9,0,36,0,2,0,2q|9,0,39,0,2,0,2q||",
                "Christmas": "9,0,2,0,30k|||",
                "Cocos": "9,0,2,0,et,0,o7,0,7v|||",
                "Colombia": "9,0,36,0,2,0,1mn|9,0,39,0,2,0,1mn||",
                "Cook": "9,0,36,0,2,0,et,0,o7,0,2v|9,0,2,0,30q,0,30s,0,2,0,et,0,o7,0,2v||",
                "Cuba": "9,0,36,0,2,0,34|9,0,39,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,36,0,2,0,1mo,0,2,0,181|9,0,39,0,2,0,1mo,0,2,0,181||",
                "Ecuador": "9,0,2,0,30v|||",
                "Europe_Central": "9,0,36,0,19,0,cc,0,pn|9,0,39,0,19,0,cc,0,pn|h0|h4",
                "Europe_Eastern": "9,0,36,0,2,0,1v,0,pn|9,0,39,0,2,0,1v,0,pn|gu|gv",
                "Europe_Further_Eastern": "9,0,2,0,319,0,31b,0,2ao|||",
                "Europe_Western": "9,0,36,0,2,0,144,0,pn|9,0,39,0,2,0,144,0,pn|h1|h2",
                "Falkland": "9,0,36,0,2,0,et,0,o7,0,1nd|9,0,39,0,2,0,et,0,o7,0,1nd||",
                "Fiji": "9,0,36,0,2,0,4q|9,0,39,0,2,0,4q||",
                "French_Guiana": "9,0,2,0,1c,0,31j,0,nf|||",
                "French_Southern": "9,0,31k,0,i3,0,2ah,0,19,0,i6|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,36,0,2,0,1a0|9,0,39,0,2,0,1a0||",
                "Gilbert_Islands": "9,0,2,0,et,0,o7,0,6q|||",
                "GMT": "9,0,19,0,31o,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,36,0,2,0,1v,0,2,0,152|9,0,39,0,2,0,1v,0,2,0,152||",
                "Greenland_Western": "9,0,36,0,2,0,144,0,2,0,152|9,0,39,0,2,0,144,0,2,0,152||",
                "Gulf": "9,0,19,0,127|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "9,0,36,0,2,0,4g,5,1i5|9,0,39,0,2,0,4g,5,1i5||",
                "Hong_Kong": "9,0,36,0,2,0,2l,0,2p|9,0,39,0,2,0,2l,0,2p||",
                "Hovd": "9,0,36,0,2,0,2g|9,0,39,0,2,0,2g||",
                "India": "9,0,36,0,2,0,31q|||",
                "Indian_Ocean": "9,0,2,0,2lm,0,2ln|||",
                "Indochina": "9,0,2lo|||",
                "Indonesia_Central": "9,0,6r,0,1a1|||",
                "Indonesia_Eastern": "9,0,2,0,1nl,0,1a1|||",
                "Indonesia_Western": "9,0,2,0,151,0,1a1|||",
                "Iran": "9,0,36,0,ce|9,0,39,0,ce||",
                "Irkutsk": "9,0,36,0,1ia|9,0,39,0,1ia||",
                "Israel": "9,0,36,0,1ic|9,0,39,0,1ic||",
                "Japan": "9,0,36,0,19,0,1no|9,0,39,0,19,0,1no||",
                "Kamchatka": "9,0,36,0,2,0,37,0,2,0,1np|19v,0,39,0,2,0,37,0,2,0,1np||",
                "Kazakhstan_Eastern": "9,0,2,0,1nl,0,19,0,45|||",
                "Kazakhstan_Western": "9,0,2,0,151,0,19,0,45|||",
                "Korea": "9,0,36,0,2,0,hf|9,0,39,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,36,0,2,0,1c7|9,0,39,0,2,0,1c7||",
                "Kyrgystan": "9,0,19,0,2m4|||",
                "Line_Islands": "9,0,2,0,ac,0,o|||",
                "Lord_Howe": "9,0,36,0,2,0,1u,0,24|19v,0,39,0,2,0,1u,0,24||",
                "Macau": "9,0,36,0,2,0,57|9,0,39,0,2,0,57||",
                "Macquarie": "9,0,2,0,6m|||",
                "Magadan": "9,0,36,0,2,0,2o|9,0,39,0,2,0,2o||",
                "Malaysia": "9,0,2,0,2m6|||",
                "Maldives": "9,0,2,0,et,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,o7,0,7o|||",
                "Mauritius": "9,0,36,0,2,0,1nu|9,0,39,0,2,0,1nu||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,36,0,19,0,93,5,1o0,0,2,0,149|9,0,39,0,19,0,93,5,1o0,0,2,0,149||",
                "Mexico_Pacific": "9,0,36,0,19,0,14b,0,2,0,149|9,0,39,0,19,0,14b,0,2,0,149||",
                "Mongolia": "9,0,36,0,1o2,0,2m|9,0,39,0,1o2,0,2m||",
                "Moscow": "9,0,36,0,2,0,ca|9,0,39,0,2,0,ca||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,36,0,2,0,ba,0,1oc|9,0,39,0,2,0,ba,0,1oc||",
                "New_Zealand": "9,0,36,0,2,0,ba,0,go|9,0,39,0,2,0,ba,0,go||",
                "Newfoundland": "9,0,36,0,2,0,h5|9,0,39,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,et,0,o7,0,6l|||",
                "Noronha": "9,0,36,0,2,0,1s,0,2,0,23|9,0,39,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "9,0,36,0,2,0,3b|9,0,39,0,2,0,3b||",
                "Omsk": "9,0,36,0,1d1|9,0,39,0,1d1||",
                "Pakistan": "9,0,36,0,19,0,3i|9,0,39,0,19,0,3i||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,a8|||",
                "Paraguay": "9,0,36,0,19,0,p8|9,0,39,0,19,0,p8||",
                "Peru": "9,0,36,0,19,0,ha|9,0,39,0,19,0,ha||",
                "Philippines": "9,0,36,0,2,0,1jb|9,0,39,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,o7,0,90|||",
                "Pierre_Miquelon": "9,0,36,0,2,0,8i,5,33,0,i3,0,35|9,0,39,0,2,0,8i,5,33,0,i3,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Reunion": "9,0,2,0,2mi|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,36,0,2,0,55|9,0,39,0,2,0,55||",
                "Samara": "9,0,36,0,2,0,29|9,0,39,0,2,0,29||",
                "Samoa": "9,0,36,0,2,0,2c|9,0,39,0,2,0,2c||",
                "Seychelles": "9,0,2,0,et,0,8k|||",
                "Singapore": "9,0,2,0,m8|||",
                "Solomon": "9,0,2,0,2mk|||",
                "South_Georgia": "9,0,2,0,1a0,0,19,0,i6|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "9,0,36,0,2,0,3d|9,0,39,0,2,0,3d||",
                "Tajikistan": "9,0,19,0,lc|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,36,0,2,0,2j|9,0,39,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,36,0,19,0,4t|9,0,39,0,19,0,4t||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,36,0,2,0,1om|9,0,39,0,2,0,1om||",
                "Uzbekistan": "9,0,36,0,2,0,1op|9,0,39,0,2,0,1op||",
                "Vanuatu": "9,0,36,0,2,0,1oq|9,0,39,0,2,0,1oq||",
                "Venezuela": "9,0,2,0,2mr|||",
                "Vladivostok": "9,0,36,0,2,0,28|9,0,39,0,2,0,28||",
                "Volgograd": "9,0,36,0,2,0,3f|9,0,39,0,2,0,3f||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,i3,0,5k|||",
                "Yakutsk": "9,0,36,0,2,0,1h6|9,0,39,0,2,0,1h6||",
                "Yekaterinburg": "9,0,36,0,1os|9,0,39,0,1os||"
            }
        },
        "ca-IT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,36,0,2v3||",
                "Europe/London": "|9,0,39,0,2v1||"
            },
            "metazone": {
                "Afghanistan": "9,0,2,0,2vj|||",
                "Africa_Central": "9,0,2,0,10i,0,n|||",
                "Africa_Eastern": "9,0,2,0,10i,0,8h|||",
                "Africa_Southern": "9,0,36,0,19,0,2vm,0,2,0,10i|||",
                "Africa_Western": "9,0,36,0,2,0,10i,0,of|9,0,39,0,2,0,10i,0,of||",
                "Alaska": "9,0,36,0,1ht|9,0,39,0,1ht||",
                "Amazon": "9,0,36,0,2,0,1ll|9,0,39,0,2,0,1ll||",
                "America_Central": "9,0,36,0,6r,0,ri,0,19,0,98|9,0,39,0,6r,0,ri,0,19,0,98||",
                "America_Eastern": "9,0,36,0,3r,0,ri,0,19,0,98|9,0,39,0,3r,0,ri,0,19,0,98||",
                "America_Mountain": "9,0,36,0,2,0,1lp,0,ri,0,19,0,98|9,0,39,0,2,0,1lp,0,ri,0,19,0,98||",
                "America_Pacific": "9,0,36,0,19,0,14b|9,0,39,0,19,0,14b||",
                "Anadyr": "9,0,36,0,cb|19v,0,39,0,cb||",
                "Apia": "9,0,36,0,c9|9,0,39,0,c9||",
                "Arabian": "9,0,36,0,1lu|9,0,39,0,1lu||",
                "Argentina": "9,0,36,0,2,0,13s|9,0,39,0,2,0,13s||",
                "Argentina_Western": "9,0,36,0,2,0,151,0,2,0,13s|9,0,39,0,2,0,151,0,2,0,13s||",
                "Armenia": "9,0,36,0,1m1|9,0,39,0,1m1||",
                "Atlantic": "9,0,36,0,2,0,1m2|9,0,39,0,2,0,1m2||",
                "Australia_Central": "9,0,36,0,p3,0,n|9,0,39,0,p3,0,n||",
                "Australia_CentralWestern": "9,0,36,0,p3,0,6n,5,48|9,0,39,0,p3,0,6n,5,48||",
                "Australia_Eastern": "9,0,36,0,p3,0,8h|9,0,39,0,p3,0,8h||",
                "Australia_Western": "9,0,36,0,p3,0,of|9,0,39,0,p3,0,of||",
                "Azerbaijan": "9,0,36,0,1m7|9,0,39,0,1m7||",
                "Azores": "9,0,36,0,2,0,et,0,b9|9,0,39,0,2,0,et,0,b9||",
                "Bangladesh": "9,0,36,0,2,0,1m9,0,1mc|9,0,39,0,2,0,1m9,0,1mc||",
                "Bhutan": "9,0,2,0,as|||",
                "Bolivia": "9,0,2,0,16g|||",
                "Brasilia": "9,0,36,0,2,0,in|9,0,39,0,2,0,in||",
                "Brunei": "9,0,2,0,9o,0,a4|||",
                "Cape_Verde": "9,0,36,0,2,0,cf,0,1mi|9,0,39,0,2,0,cf,0,1mi||",
                "Chamorro": "9,0,2,0,6j|||",
                "Chatham": "9,0,36,0,2,0,27|9,0,39,0,2,0,27||",
                "Chile": "9,0,36,0,2,0,1mj|9,0,39,0,2,0,1mj||",
                "China": "9,0,36,0,2,0,1c,0,1mk|9,0,39,0,2,0,1c,0,1mk||",
                "Choibalsan": "9,0,36,0,2,0,2q|9,0,39,0,2,0,2q||",
                "Christmas": "9,0,2,0,30k|||",
                "Cocos": "9,0,2,0,et,0,o7,0,7v|||",
                "Colombia": "9,0,36,0,2,0,1mn|9,0,39,0,2,0,1mn||",
                "Cook": "9,0,36,0,2,0,et,0,o7,0,2v|9,0,2,0,30q,0,30s,0,2,0,et,0,o7,0,2v||",
                "Cuba": "9,0,36,0,2,0,34|9,0,39,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,36,0,2,0,1mo,0,2,0,181|9,0,39,0,2,0,1mo,0,2,0,181||",
                "Ecuador": "9,0,2,0,30v|||",
                "Europe_Central": "9,0,36,0,19,0,cc,0,pn|9,0,39,0,19,0,cc,0,pn|h0|h4",
                "Europe_Eastern": "9,0,36,0,2,0,1v,0,pn|9,0,39,0,2,0,1v,0,pn|gu|gv",
                "Europe_Further_Eastern": "9,0,2,0,319,0,31b,0,2ao|||",
                "Europe_Western": "9,0,36,0,2,0,144,0,pn|9,0,39,0,2,0,144,0,pn|h1|h2",
                "Falkland": "9,0,36,0,2,0,et,0,o7,0,1nd|9,0,39,0,2,0,et,0,o7,0,1nd||",
                "Fiji": "9,0,36,0,2,0,4q|9,0,39,0,2,0,4q||",
                "French_Guiana": "9,0,2,0,1c,0,31j,0,nf|||",
                "French_Southern": "9,0,31k,0,i3,0,2ah,0,19,0,i6|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,36,0,2,0,1a0|9,0,39,0,2,0,1a0||",
                "Gilbert_Islands": "9,0,2,0,et,0,o7,0,6q|||",
                "GMT": "9,0,19,0,31o,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,36,0,2,0,1v,0,2,0,152|9,0,39,0,2,0,1v,0,2,0,152||",
                "Greenland_Western": "9,0,36,0,2,0,144,0,2,0,152|9,0,39,0,2,0,144,0,2,0,152||",
                "Gulf": "9,0,19,0,127|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "9,0,36,0,2,0,4g,5,1i5|9,0,39,0,2,0,4g,5,1i5||",
                "Hong_Kong": "9,0,36,0,2,0,2l,0,2p|9,0,39,0,2,0,2l,0,2p||",
                "Hovd": "9,0,36,0,2,0,2g|9,0,39,0,2,0,2g||",
                "India": "9,0,36,0,2,0,31q|||",
                "Indian_Ocean": "9,0,2,0,2lm,0,2ln|||",
                "Indochina": "9,0,2lo|||",
                "Indonesia_Central": "9,0,6r,0,1a1|||",
                "Indonesia_Eastern": "9,0,2,0,1nl,0,1a1|||",
                "Indonesia_Western": "9,0,2,0,151,0,1a1|||",
                "Iran": "9,0,36,0,ce|9,0,39,0,ce||",
                "Irkutsk": "9,0,36,0,1ia|9,0,39,0,1ia||",
                "Israel": "9,0,36,0,1ic|9,0,39,0,1ic||",
                "Japan": "9,0,36,0,19,0,1no|9,0,39,0,19,0,1no||",
                "Kamchatka": "9,0,36,0,2,0,37,0,2,0,1np|19v,0,39,0,2,0,37,0,2,0,1np||",
                "Kazakhstan_Eastern": "9,0,2,0,1nl,0,19,0,45|||",
                "Kazakhstan_Western": "9,0,2,0,151,0,19,0,45|||",
                "Korea": "9,0,36,0,2,0,hf|9,0,39,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,36,0,2,0,1c7|9,0,39,0,2,0,1c7||",
                "Kyrgystan": "9,0,19,0,2m4|||",
                "Line_Islands": "9,0,2,0,ac,0,o|||",
                "Lord_Howe": "9,0,36,0,2,0,1u,0,24|19v,0,39,0,2,0,1u,0,24||",
                "Macau": "9,0,36,0,2,0,57|9,0,39,0,2,0,57||",
                "Macquarie": "9,0,2,0,6m|||",
                "Magadan": "9,0,36,0,2,0,2o|9,0,39,0,2,0,2o||",
                "Malaysia": "9,0,2,0,2m6|||",
                "Maldives": "9,0,2,0,et,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,o7,0,7o|||",
                "Mauritius": "9,0,36,0,2,0,1nu|9,0,39,0,2,0,1nu||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,36,0,19,0,93,5,1o0,0,2,0,149|9,0,39,0,19,0,93,5,1o0,0,2,0,149||",
                "Mexico_Pacific": "9,0,36,0,19,0,14b,0,2,0,149|9,0,39,0,19,0,14b,0,2,0,149||",
                "Mongolia": "9,0,36,0,1o2,0,2m|9,0,39,0,1o2,0,2m||",
                "Moscow": "9,0,36,0,2,0,ca|9,0,39,0,2,0,ca||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,36,0,2,0,ba,0,1oc|9,0,39,0,2,0,ba,0,1oc||",
                "New_Zealand": "9,0,36,0,2,0,ba,0,go|9,0,39,0,2,0,ba,0,go||",
                "Newfoundland": "9,0,36,0,2,0,h5|9,0,39,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,et,0,o7,0,6l|||",
                "Noronha": "9,0,36,0,2,0,1s,0,2,0,23|9,0,39,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "9,0,36,0,2,0,3b|9,0,39,0,2,0,3b||",
                "Omsk": "9,0,36,0,1d1|9,0,39,0,1d1||",
                "Pakistan": "9,0,36,0,19,0,3i|9,0,39,0,19,0,3i||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,a8|||",
                "Paraguay": "9,0,36,0,19,0,p8|9,0,39,0,19,0,p8||",
                "Peru": "9,0,36,0,19,0,ha|9,0,39,0,19,0,ha||",
                "Philippines": "9,0,36,0,2,0,1jb|9,0,39,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,o7,0,90|||",
                "Pierre_Miquelon": "9,0,36,0,2,0,8i,5,33,0,i3,0,35|9,0,39,0,2,0,8i,5,33,0,i3,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Reunion": "9,0,2,0,2mi|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,36,0,2,0,55|9,0,39,0,2,0,55||",
                "Samara": "9,0,36,0,2,0,29|9,0,39,0,2,0,29||",
                "Samoa": "9,0,36,0,2,0,2c|9,0,39,0,2,0,2c||",
                "Seychelles": "9,0,2,0,et,0,8k|||",
                "Singapore": "9,0,2,0,m8|||",
                "Solomon": "9,0,2,0,2mk|||",
                "South_Georgia": "9,0,2,0,1a0,0,19,0,i6|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "9,0,36,0,2,0,3d|9,0,39,0,2,0,3d||",
                "Tajikistan": "9,0,19,0,lc|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,36,0,2,0,2j|9,0,39,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,36,0,19,0,4t|9,0,39,0,19,0,4t||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,36,0,2,0,1om|9,0,39,0,2,0,1om||",
                "Uzbekistan": "9,0,36,0,2,0,1op|9,0,39,0,2,0,1op||",
                "Vanuatu": "9,0,36,0,2,0,1oq|9,0,39,0,2,0,1oq||",
                "Venezuela": "9,0,2,0,2mr|||",
                "Vladivostok": "9,0,36,0,2,0,28|9,0,39,0,2,0,28||",
                "Volgograd": "9,0,36,0,2,0,3f|9,0,39,0,2,0,3f||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,i3,0,5k|||",
                "Yakutsk": "9,0,36,0,2,0,1h6|9,0,39,0,2,0,1h6||",
                "Yekaterinburg": "9,0,36,0,1os|9,0,39,0,1os||"
            }
        },
        "ca": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,36,0,2v3||",
                "Europe/London": "|9,0,39,0,2v1||"
            },
            "metazone": {
                "Afghanistan": "9,0,2,0,2vj|||",
                "Africa_Central": "9,0,2,0,10i,0,n|||",
                "Africa_Eastern": "9,0,2,0,10i,0,8h|||",
                "Africa_Southern": "9,0,36,0,19,0,2vm,0,2,0,10i|||",
                "Africa_Western": "9,0,36,0,2,0,10i,0,of|9,0,39,0,2,0,10i,0,of||",
                "Alaska": "9,0,36,0,1ht|9,0,39,0,1ht||",
                "Amazon": "9,0,36,0,2,0,1ll|9,0,39,0,2,0,1ll||",
                "America_Central": "9,0,36,0,6r,0,ri,0,19,0,98|9,0,39,0,6r,0,ri,0,19,0,98||",
                "America_Eastern": "9,0,36,0,3r,0,ri,0,19,0,98|9,0,39,0,3r,0,ri,0,19,0,98||",
                "America_Mountain": "9,0,36,0,2,0,1lp,0,ri,0,19,0,98|9,0,39,0,2,0,1lp,0,ri,0,19,0,98||",
                "America_Pacific": "9,0,36,0,19,0,14b|9,0,39,0,19,0,14b||",
                "Anadyr": "9,0,36,0,cb|19v,0,39,0,cb||",
                "Apia": "9,0,36,0,c9|9,0,39,0,c9||",
                "Arabian": "9,0,36,0,1lu|9,0,39,0,1lu||",
                "Argentina": "9,0,36,0,2,0,13s|9,0,39,0,2,0,13s||",
                "Argentina_Western": "9,0,36,0,2,0,151,0,2,0,13s|9,0,39,0,2,0,151,0,2,0,13s||",
                "Armenia": "9,0,36,0,1m1|9,0,39,0,1m1||",
                "Atlantic": "9,0,36,0,2,0,1m2|9,0,39,0,2,0,1m2||",
                "Australia_Central": "9,0,36,0,p3,0,n|9,0,39,0,p3,0,n||",
                "Australia_CentralWestern": "9,0,36,0,p3,0,6n,5,48|9,0,39,0,p3,0,6n,5,48||",
                "Australia_Eastern": "9,0,36,0,p3,0,8h|9,0,39,0,p3,0,8h||",
                "Australia_Western": "9,0,36,0,p3,0,of|9,0,39,0,p3,0,of||",
                "Azerbaijan": "9,0,36,0,1m7|9,0,39,0,1m7||",
                "Azores": "9,0,36,0,2,0,et,0,b9|9,0,39,0,2,0,et,0,b9||",
                "Bangladesh": "9,0,36,0,2,0,1m9,0,1mc|9,0,39,0,2,0,1m9,0,1mc||",
                "Bhutan": "9,0,2,0,as|||",
                "Bolivia": "9,0,2,0,16g|||",
                "Brasilia": "9,0,36,0,2,0,in|9,0,39,0,2,0,in||",
                "Brunei": "9,0,2,0,9o,0,a4|||",
                "Cape_Verde": "9,0,36,0,2,0,cf,0,1mi|9,0,39,0,2,0,cf,0,1mi||",
                "Chamorro": "9,0,2,0,6j|||",
                "Chatham": "9,0,36,0,2,0,27|9,0,39,0,2,0,27||",
                "Chile": "9,0,36,0,2,0,1mj|9,0,39,0,2,0,1mj||",
                "China": "9,0,36,0,2,0,1c,0,1mk|9,0,39,0,2,0,1c,0,1mk||",
                "Choibalsan": "9,0,36,0,2,0,2q|9,0,39,0,2,0,2q||",
                "Christmas": "9,0,2,0,30k|||",
                "Cocos": "9,0,2,0,et,0,o7,0,7v|||",
                "Colombia": "9,0,36,0,2,0,1mn|9,0,39,0,2,0,1mn||",
                "Cook": "9,0,36,0,2,0,et,0,o7,0,2v|9,0,2,0,30q,0,30s,0,2,0,et,0,o7,0,2v||",
                "Cuba": "9,0,36,0,2,0,34|9,0,39,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,8h|||",
                "Easter": "9,0,36,0,2,0,1mo,0,2,0,181|9,0,39,0,2,0,1mo,0,2,0,181||",
                "Ecuador": "9,0,2,0,30v|||",
                "Europe_Central": "9,0,36,0,19,0,cc,0,pn|9,0,39,0,19,0,cc,0,pn|h0|h4",
                "Europe_Eastern": "9,0,36,0,2,0,1v,0,pn|9,0,39,0,2,0,1v,0,pn|gu|gv",
                "Europe_Further_Eastern": "9,0,2,0,319,0,31b,0,2ao|||",
                "Europe_Western": "9,0,36,0,2,0,144,0,pn|9,0,39,0,2,0,144,0,pn|h1|h2",
                "Falkland": "9,0,36,0,2,0,et,0,o7,0,1nd|9,0,39,0,2,0,et,0,o7,0,1nd||",
                "Fiji": "9,0,36,0,2,0,4q|9,0,39,0,2,0,4q||",
                "French_Guiana": "9,0,2,0,1c,0,31j,0,nf|||",
                "French_Southern": "9,0,31k,0,i3,0,2ah,0,19,0,i6|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,36,0,2,0,1a0|9,0,39,0,2,0,1a0||",
                "Gilbert_Islands": "9,0,2,0,et,0,o7,0,6q|||",
                "GMT": "9,0,19,0,31o,0,2,0,5u||ah|",
                "Greenland_Eastern": "9,0,36,0,2,0,1v,0,2,0,152|9,0,39,0,2,0,1v,0,2,0,152||",
                "Greenland_Western": "9,0,36,0,2,0,144,0,2,0,152|9,0,39,0,2,0,144,0,2,0,152||",
                "Gulf": "9,0,19,0,127|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "9,0,36,0,2,0,4g,5,1i5|9,0,39,0,2,0,4g,5,1i5||",
                "Hong_Kong": "9,0,36,0,2,0,2l,0,2p|9,0,39,0,2,0,2l,0,2p||",
                "Hovd": "9,0,36,0,2,0,2g|9,0,39,0,2,0,2g||",
                "India": "9,0,36,0,2,0,31q|||",
                "Indian_Ocean": "9,0,2,0,2lm,0,2ln|||",
                "Indochina": "9,0,2lo|||",
                "Indonesia_Central": "9,0,6r,0,1a1|||",
                "Indonesia_Eastern": "9,0,2,0,1nl,0,1a1|||",
                "Indonesia_Western": "9,0,2,0,151,0,1a1|||",
                "Iran": "9,0,36,0,ce|9,0,39,0,ce||",
                "Irkutsk": "9,0,36,0,1ia|9,0,39,0,1ia||",
                "Israel": "9,0,36,0,1ic|9,0,39,0,1ic||",
                "Japan": "9,0,36,0,19,0,1no|9,0,39,0,19,0,1no||",
                "Kamchatka": "9,0,36,0,2,0,37,0,2,0,1np|19v,0,39,0,2,0,37,0,2,0,1np||",
                "Kazakhstan_Eastern": "9,0,2,0,1nl,0,19,0,45|||",
                "Kazakhstan_Western": "9,0,2,0,151,0,19,0,45|||",
                "Korea": "9,0,36,0,2,0,hf|9,0,39,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,36,0,2,0,1c7|9,0,39,0,2,0,1c7||",
                "Kyrgystan": "9,0,19,0,2m4|||",
                "Line_Islands": "9,0,2,0,ac,0,o|||",
                "Lord_Howe": "9,0,36,0,2,0,1u,0,24|19v,0,39,0,2,0,1u,0,24||",
                "Macau": "9,0,36,0,2,0,57|9,0,39,0,2,0,57||",
                "Macquarie": "9,0,2,0,6m|||",
                "Magadan": "9,0,36,0,2,0,2o|9,0,39,0,2,0,2o||",
                "Malaysia": "9,0,2,0,2m6|||",
                "Maldives": "9,0,2,0,et,0,9k|||",
                "Marquesas": "9,0,2,0,et,0,2it|||",
                "Marshall_Islands": "9,0,2,0,et,0,o7,0,7o|||",
                "Mauritius": "9,0,36,0,2,0,1nu|9,0,39,0,2,0,1nu||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,36,0,19,0,93,5,1o0,0,2,0,149|9,0,39,0,19,0,93,5,1o0,0,2,0,149||",
                "Mexico_Pacific": "9,0,36,0,19,0,14b,0,2,0,149|9,0,39,0,19,0,14b,0,2,0,149||",
                "Mongolia": "9,0,36,0,1o2,0,2m|9,0,39,0,1o2,0,2m||",
                "Moscow": "9,0,36,0,2,0,ca|9,0,39,0,2,0,ca||",
                "Myanmar": "9,0,2,0,8v|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,19,0,8u|||",
                "New_Caledonia": "9,0,36,0,2,0,ba,0,1oc|9,0,39,0,2,0,ba,0,1oc||",
                "New_Zealand": "9,0,36,0,2,0,ba,0,go|9,0,39,0,2,0,ba,0,go||",
                "Newfoundland": "9,0,36,0,2,0,h5|9,0,39,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,et,0,o7,0,6l|||",
                "Noronha": "9,0,36,0,2,0,1s,0,2,0,23|9,0,39,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "9,0,36,0,2,0,3b|9,0,39,0,2,0,3b||",
                "Omsk": "9,0,36,0,1d1|9,0,39,0,1d1||",
                "Pakistan": "9,0,36,0,19,0,3i|9,0,39,0,19,0,3i||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,a8|||",
                "Paraguay": "9,0,36,0,19,0,p8|9,0,39,0,19,0,p8||",
                "Peru": "9,0,36,0,19,0,ha|9,0,39,0,19,0,ha||",
                "Philippines": "9,0,36,0,2,0,1jb|9,0,39,0,2,0,1jb||",
                "Phoenix_Islands": "9,0,2,0,et,0,o7,0,90|||",
                "Pierre_Miquelon": "9,0,36,0,2,0,8i,5,33,0,i3,0,35|9,0,39,0,2,0,8i,5,33,0,i3,0,35||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Reunion": "9,0,2,0,2mi|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,36,0,2,0,55|9,0,39,0,2,0,55||",
                "Samara": "9,0,36,0,2,0,29|9,0,39,0,2,0,29||",
                "Samoa": "9,0,36,0,2,0,2c|9,0,39,0,2,0,2c||",
                "Seychelles": "9,0,2,0,et,0,8k|||",
                "Singapore": "9,0,2,0,m8|||",
                "Solomon": "9,0,2,0,2mk|||",
                "South_Georgia": "9,0,2,0,1a0,0,19,0,i6|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "9,0,36,0,2,0,3d|9,0,39,0,2,0,3d||",
                "Tajikistan": "9,0,19,0,lc|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,36,0,2,0,2j|9,0,39,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,36,0,19,0,4t|9,0,39,0,19,0,4t||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,36,0,2,0,1om|9,0,39,0,2,0,1om||",
                "Uzbekistan": "9,0,36,0,2,0,1op|9,0,39,0,2,0,1op||",
                "Vanuatu": "9,0,36,0,2,0,1oq|9,0,39,0,2,0,1oq||",
                "Venezuela": "9,0,2,0,2mr|||",
                "Vladivostok": "9,0,36,0,2,0,28|9,0,39,0,2,0,28||",
                "Volgograd": "9,0,36,0,2,0,3f|9,0,39,0,2,0,3f||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,i3,0,5k|||",
                "Yakutsk": "9,0,36,0,2,0,1h6|9,0,39,0,2,0,1h6||",
                "Yekaterinburg": "9,0,36,0,1os|9,0,39,0,1os||"
            }
        },
        "ce": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c9b,k,0,g7,0,9v||",
                "Europe/London": "|c9c,k,0,g7,0,9v||"
            },
            "metazone": {
                "Afghanistan": "c10,5,c0v|||",
                "Africa_Central": "1ou,0,mi|||",
                "Africa_Eastern": "1h3,0,mi|||",
                "Africa_Southern": "4tg,0,mi|||",
                "Africa_Western": "1h1,0,mi,k,0,gi,0,9v|1h1,0,mi,k,0,g7,0,9v||",
                "Alaska": "12l,k,0,gi,0,9v|12l,k,0,g7,0,9v||",
                "Amazon": "18e,k,0,gi,0,9v|18e,k,0,g7,0,9v||",
                "America_Central": "1ou,0,m6,k,0,gi,0,9v|1ou,0,m6,k,0,g7,0,9v||",
                "America_Eastern": "1h3,0,m6,k,0,gi,0,9v|1h3,0,m6,k,0,g7,0,9v||",
                "America_Mountain": "4u6,0,gi,0,9v,0,4uc|4u6,0,g7,0,9v,0,4uc||",
                "America_Pacific": "4b9,0,4b6,0,gi,0,9v|4b9,0,4b6,0,g7,0,9v||",
                "Apia": "gi,0,9v,0,15s,k,0,p0|g7,0,9v,0,15s,k,0,p0||",
                "Arabian": "4uh,0,4uq,k,0,gi,0,9v|4uh,0,4uq,k,0,g7,0,9v||",
                "Argentina": "hk,k,0,gi,0,9v|hk,k,0,g7,0,9v||",
                "Argentina_Western": "1h1,0,hk,k,0,gi,0,9v|1h1,0,hk,k,0,g7,0,9v||",
                "Armenia": "4us,k,0,gi,0,9v|4us,k,0,g7,0,9v||",
                "Atlantic": "4v9,0,gi,0,9v|4v9,0,g7,0,9v||",
                "Australia_Central": "1ou,0,1qs,k,0,gi,0,9v|1ou,0,1qs,k,0,g7,0,9v||",
                "Australia_CentralWestern": "1ou,0,1qs,k,0,50i,0,gi,0,9v|1ou,0,1qs,k,0,50i,0,g7,0,9v||",
                "Australia_Eastern": "1h3,0,1qs,k,0,gi,0,9v|1h3,0,1qs,k,0,g7,0,9v||",
                "Australia_Western": "1h1,0,1qs,k,0,gi,0,9v|1h1,0,1qs,k,0,g7,0,9v||",
                "Azerbaijan": "1df,k,0,gi,0,9v|1df,k,0,g7,0,9v||",
                "Azores": "50m,0,2je,k,0,gi,0,9v|50m,0,2je,k,0,g7,0,9v||",
                "Bangladesh": "q8,k,0,gi,0,9v|q8,k,0,g7,0,9v||",
                "Bhutan": "16f|||",
                "Bolivia": "c0u|||",
                "Brasilia": "50p,k,0,gi,0,9v|50p,k,0,g7,0,9v||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,gi,0,9v|12p,5,115,k,0,g7,0,9v||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,gi,0,9v|162,k,0,g7,0,9v||",
                "Chile": "150,k,0,gi,0,9v|150,k,0,g7,0,9v||",
                "China": "1dm,k,0,gi,0,9v|1dm,k,0,g7,0,9v||",
                "Choibalsan": "11e,k,0,gi,0,9v|11e,k,0,g7,0,9v||",
                "Christmas": "c0t,0,c0s,0,c0r,0,c0q,0,4i9|||",
                "Cocos": "c0p,k,0,1h0,5,1k3|||",
                "Colombia": "51d,k,0,gi,0,9v|51d,k,0,g7,0,9v||",
                "Cook": "51g,k,0,1h0,5,1k3,k,0,gi,0,9v|51g,k,0,1h0,5,1k3,k,0,g7,0,9v||",
                "Cuba": "ql,k,0,gi,0,9v|ql,k,0,g7,0,9v||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1h3,0,1ki|||",
                "Easter": "51p,0,4i9,k,0,gi,0,9v|51p,0,4i9,k,0,g7,0,9v||",
                "Ecuador": "1qk|||",
                "Europe_Central": "1ou,0,lo,k,0,gi,0,9v|1ou,0,lo,k,0,g7,0,9v||",
                "Europe_Eastern": "1h3,0,lo,k,0,gi,0,9v|1h3,0,lo,k,0,g7,0,9v||",
                "Europe_Further_Eastern": "c0o,0,1lf,k,0,c0n,0,1lf,0,9v|||",
                "Europe_Western": "1h1,0,lo,k,0,gi,0,9v|1h1,0,lo,k,0,g7,0,9v||",
                "Falkland": "524,0,2je,k,0,gi,0,9v|524,0,2je,k,0,g7,0,9v||",
                "Fiji": "161,k,0,gi,0,9v|161,k,0,g7,0,9v||",
                "French_Guiana": "525,0,1pb|||",
                "French_Southern": "525,0,c0m,0,1lf,k,0,c0l,0,1lf,0,9v|||",
                "Galapagos": "c0k,0,2je|||",
                "Gambier": "244|||",
                "Georgia": "52k,k,0,gi,0,9v|52k,k,0,g7,0,9v||",
                "Gilbert_Islands": "c0j,k,0,1h0,5,1k3|||",
                "GMT": "c0i,0,c0h,0,9v|||",
                "Greenland_Eastern": "1h3,0,4b3,k,0,gi,0,9v|1h3,0,4b3,k,0,g7,0,9v||",
                "Greenland_Western": "1h1,0,4b3,k,0,gi,0,9v|1h1,0,4b3,k,0,g7,0,9v||",
                "Gulf": "c0g,0,c0f|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "533,5,536,0,gi,0,9v|533,5,536,0,g7,0,9v||",
                "Hong_Kong": "13t,k,0,gi,0,9v|13t,k,0,g7,0,9v||",
                "Hovd": "qg,k,0,gi,0,9v|qg,k,0,g7,0,9v||",
                "India": "53a|||",
                "Indian_Ocean": "c0e,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "1ou,0,4ia|||",
                "Indonesia_Eastern": "1h3,0,4ia|||",
                "Indonesia_Western": "1h1,0,4ia|||",
                "Iran": "53l,k,0,gi,0,9v|53l,k,0,g7,0,9v||",
                "Irkutsk": "12u,k,0,gi,0,9v|12u,k,0,g7,0,9v||",
                "Israel": "165,k,0,gi,0,9v|165,k,0,g7,0,9v||",
                "Japan": "540,k,0,gi,0,9v|540,k,0,g7,0,9v||",
                "Kazakhstan_Eastern": "1h3,0,180|||",
                "Kazakhstan_Western": "1h1,0,180|||",
                "Korea": "545,k,0,gi,0,9v|545,k,0,g7,0,9v||",
                "Kosrae": "546|||",
                "Krasnoyarsk": "14h,k,0,gi,0,9v|14h,k,0,g7,0,9v||",
                "Kyrgystan": "c0d|||",
                "Line_Islands": "1eo,k,0,1h0,5,1k3|||",
                "Lord_Howe": "oi,5,10a,k,0,gi,0,9v|oi,5,10a,k,0,g7,0,9v||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,gi,0,9v|qq,k,0,g7,0,9v||",
                "Malaysia": "c0c|||",
                "Maldives": "c0b|||",
                "Marquesas": "c0a,k,0,1h0,5,1k3|||",
                "Marshall_Islands": "c09,0,k,0,1h0,5,1k3|||",
                "Mauritius": "554,k,0,gi,0,9v|554,k,0,g7,0,9v||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "55a,0,55g,0,4b0,0,gi,0,9v|55a,0,55g,0,4b0,0,g7,0,9v||",
                "Mexico_Pacific": "4b9,0,4b6,0,4b0,0,gi,0,9v|4b9,0,4b6,0,4b0,0,g7,0,9v||",
                "Mongolia": "or,5,qo,k,0,gi,0,9v|or,5,qo,k,0,g7,0,9v||",
                "Moscow": "r6,k,0,gi,0,9v|r6,k,0,g7,0,9v||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "2ps,0,57t,k,0,gi,0,9v|2ps,0,57t,k,0,g7,0,9v||",
                "New_Zealand": "2ps,0,589,k,0,gi,0,9v|2ps,0,589,k,0,g7,0,9v||",
                "Newfoundland": "14t,k,0,gi,0,9v|14t,k,0,g7,0,9v||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,gi,0,9v|141,5,17m,5,132,k,0,g7,0,9v||",
                "Novosibirsk": "qt,k,0,gi,0,9v|qt,k,0,g7,0,9v||",
                "Omsk": "r5,k,0,gi,0,9v|r5,k,0,g7,0,9v||",
                "Pakistan": "rq,k,0,gi,0,9v|rq,k,0,g7,0,9v||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,2ps,0,c08|||",
                "Paraguay": "13p,k,0,gi,0,9v|13p,k,0,g7,0,9v||",
                "Peru": "q1,k,0,gi,0,9v|q1,k,0,g7,0,9v||",
                "Philippines": "594,k,0,gi,0,9v|594,k,0,g7,0,9v||",
                "Phoenix_Islands": "158,k,0,1h0,5,1k3|||",
                "Pierre_Miquelon": "pr,5,13m,0,1lf,k,0,qp,0,1lf,k,0,gi,0,9v|pr,5,13m,0,1lf,k,0,qp,0,1lf,k,0,g7,0,9v||",
                "Pitcairn": "24j|||",
                "Ponape": "1v2,k,0,1h0,5,1k3|||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,gi,0,9v|r8,k,0,g7,0,9v||",
                "Samoa": "p0,k,0,gi,0,9v|p0,k,0,g7,0,9v||",
                "Seychelles": "c07,0,2je|||",
                "Singapore": "16b|||",
                "Solomon": "c06,k,0,1h0,5,1k3|||",
                "South_Georgia": "4tg,0,c05|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma,k,0,1h0,5,1k3|||",
                "Taipei": "1a9,k,0,gi,0,9v|1a9,k,0,g7,0,9v||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,gi,0,9v|ot,k,0,g7,0,9v||",
                "Truk": "1f2|||",
                "Turkmenistan": "5am,0,gi,0,9v|5am,0,g7,0,9v||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,gi,0,9v|14a,k,0,g7,0,9v||",
                "Uzbekistan": "5b4,0,gi,0,9v|5b4,0,g7,0,9v||",
                "Vanuatu": "os,k,0,gi,0,9v|os,k,0,g7,0,9v||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,gi,0,9v|qn,k,0,g7,0,9v||",
                "Volgograd": "q9,k,0,gi,0,9v|q9,k,0,g7,0,9v||",
                "Vostok": "155|||",
                "Wake": "1m0,k,0,1h0,5,c04|||",
                "Wallis": "1qq,0,1lf,k,0,14l,0,1lf|||",
                "Yakutsk": "14d,k,0,gi,0,9v|14d,k,0,g7,0,9v||",
                "Yekaterinburg": "136,k,0,gi,0,9v|136,k,0,g7,0,9v||"
            }
        },
        "cgg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "chr": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c9d,0,fg,0,8l||",
                "Europe/London": "|c9e,0,mj,0,8l||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Afghanistan": "c03,0,8l|||",
                "Africa_Central": "1kj,0,2qm,0,8l|||",
                "Africa_Eastern": "19t,0,2qm,0,8l|||",
                "Africa_Southern": "5d9,0,2qm,0,fg,0,8l|||",
                "Africa_Western": "14r,0,2qm,0,fg,0,8l|14r,0,2qm,0,mj,0,8l||",
                "Alaska": "5e5,0,fg,0,8l|5e5,0,sg,0,se,0,1kk|18f|18t",
                "Amazon": "5ep,0,fg,0,8l|5ep,0,mj,0,8l||",
                "America_Central": "1kj,0,fg,0,8l|1kj,0,sg,0,se,0,1kk|19q|19p",
                "America_Eastern": "19t,0,18d,0,fg,0,8l|19t,0,18d,0,sg,0,se,0,1kk|19o|19n",
                "America_Mountain": "5fo,0,fg,0,8l|5fo,0,sg,0,se,0,1kk|18r|16i",
                "America_Pacific": "14r,0,fg,0,8l|14r,0,sg,0,se,0,1kk|19l|19k",
                "Apia": "5fv,0,fg,0,8l|5fv,0,sg,0,se,0,169||",
                "Arabian": "5ht,0,fg,0,8l|5ht,0,sg,0,se,0,169||",
                "Argentina": "4au,0,fg,0,8l|4au,0,mj,0,8l||",
                "Argentina_Western": "14r,0,18d,0,4au,0,fg,0,8l|14r,0,18d,0,4au,0,mj,0,fg,0,8l||",
                "Armenia": "5jb,0,fg,0,8l|5jb,0,mj,0,8l||",
                "Atlantic": "19t,0,fg,0,8l|19t,0,sg,0,se,0,1kk|19i|190",
                "Australia_Central": "1kj,0,24o,0,fg,0,8l|1kj,0,24o,0,sg,0,se,0,169||",
                "Australia_CentralWestern": "1kj,0,24o,0,14r,0,18d,0,fg,0,8l|1kj,0,24o,0,14r,0,18d,0,sg,0,se,0,169||",
                "Australia_Eastern": "24o,0,19t,0,18d,0,fg,0,8l|24o,0,19t,0,18d,0,sg,0,se,0,169||",
                "Australia_Western": "24o,0,14r,0,18d,0,fg,0,8l|24o,0,14r,0,18d,0,sg,0,se,0,169||",
                "Azerbaijan": "5jj,0,fg,0,8l|5jj,0,mj,0,8l||",
                "Azores": "5jm,0,fg,0,8l|5jm,0,mj,0,8l||",
                "Bangladesh": "5jn,0,fg,0,8l|5jn,0,mj,0,8l||",
                "Bhutan": "c02,0,8l|||",
                "Bolivia": "c01,0,8l|||",
                "Brasilia": "5js,0,fg,0,8l|5js,0,mj,0,8l||",
                "Brunei": "c00,0,bvv,0,8l|||",
                "Cape_Verde": "5kb,0,5kc,0,fg,0,8l|5kb,0,5kc,0,mj,0,8l||",
                "Chamorro": "bvu,0,fg,0,8l|||",
                "Chatham": "5kg,0,fg,0,8l|5kg,0,sg,0,se,0,169||",
                "Chile": "5kh,0,fg,0,8l|5kh,0,mj,0,8l||",
                "China": "5kj,0,fg,0,8l|5kj,0,sg,0,se,0,169||",
                "Choibalsan": "5kk,0,fg,0,8l|5kk,0,mj,0,8l||",
                "Christmas": "bvt,0,263,0,8l|||",
                "Cocos": "bvs,0,1n9,0,8l|||",
                "Colombia": "5kt,0,fg,0,8l|5kt,0,mj,0,8l||",
                "Cook": "5ku,0,1n9,0,fg,0,8l|5ku,0,1n9,0,1kj,0,mj,0,8l||",
                "Cuba": "5l1,0,fg,0,8l|5l1,0,sg,0,se,0,1kk||",
                "Davis": "bvr,0,8l|||",
                "DumontDUrville": "bvq,5,bvp,0,8l|||",
                "East_Timor": "19t,0,bvo,0,8l|||",
                "Easter": "5lo,0,263,0,fg,0,8l|5lo,0,263,0,mj,0,8l||",
                "Ecuador": "bvn,0,8l|||",
                "Europe_Central": "1kj,0,262,0,fg,0,8l|1kj,0,262,0,mj,0,8l||",
                "Europe_Eastern": "19t,0,18d,0,262,0,fg,0,8l|19t,0,18d,0,262,0,mj,0,8l||",
                "Europe_Further_Eastern": "19t,0,262,0,8l|||",
                "Europe_Western": "14r,0,18d,0,262,0,fg,0,8l|14r,0,18d,0,262,0,mj,0,8l||",
                "Falkland": "5ls,0,1n9,0,fg,0,8l|5ls,0,1n9,0,mj,0,8l||",
                "Fiji": "5lt,0,fg,0,8l|5lt,0,mj,0,8l||",
                "French_Guiana": "bvm,0,bvl,0,8l|||",
                "French_Southern": "bvk,0,bvj,0,4as,0,bvi,0,8l|||",
                "Galapagos": "bvh,0,bvg,0,263,0,8l|||",
                "Gambier": "bvf,0,8l|||",
                "Georgia": "4ib,0,fg,0,8l|4ib,0,mj,0,8l||",
                "Gilbert_Islands": "bve,0,1n9,0,8l|||",
                "GMT": "2fi,0,bvd,0,8l|||",
                "Greenland_Eastern": "19t,0,4aq,0,fg,0,5n5|19t,0,4aq,0,mj,0,8l||",
                "Greenland_Western": "14r,0,4aq,0,fg,0,5n5|14r,0,4aq,0,mj,0,8l||",
                "Gulf": "bvc,0,fg,0,8l|||",
                "Guyana": "bvb,0,8l|||",
                "Hawaii_Aleutian": "5ni,5,5nk,0,fg,0,8l|5ni,5,5nk,0,sg,0,se,0,1kk|17j|17l",
                "Hong_Kong": "5nl,0,5nm,0,fg,0,8l|5nl,0,5nm,0,mj,0,8l||",
                "Hovd": "5nn,0,fg,0,8l|5nn,0,mj,0,8l||",
                "India": "bva,0,fg,0,8l|||",
                "Indian_Ocean": "bv9,0,bv8,0,8l|||",
                "Indochina": "bv7,0,8l|||",
                "Indonesia_Central": "1kj,0,4ic,0,8l|||",
                "Indonesia_Eastern": "19t,0,18d,0,4ic,0,8l|||",
                "Indonesia_Western": "14r,0,18d,0,4ic,0,8l|||",
                "Iran": "5o1,0,fg,0,8l|5o1,0,sg,0,se,0,169||",
                "Irkutsk": "5o2,0,fg,0,8l|5o2,0,mj,0,8l||",
                "Israel": "5o3,0,fg,0,8l|5o3,0,sg,0,se,0,169||",
                "Japan": "5o4,0,fg,0,8l|5o4,0,sg,0,se,0,169||",
                "Kazakhstan_Eastern": "19t,0,5o5,0,8l|||",
                "Kazakhstan_Western": "14r,0,5o5,0,8l|||",
                "Korea": "5o6,0,fg,0,8l|5o6,0,sg,0,se,0,169||",
                "Kosrae": "bv6,0,8l|||",
                "Krasnoyarsk": "5o8,0,fg,0,8l|5o8,0,mj,0,8l||",
                "Kyrgystan": "bv5,0,8l|||",
                "Line_Islands": "bv4,0,1n9,0,8l|||",
                "Lord_Howe": "5ob,0,5oc,0,fg,0,8l|5ob,0,5oc,0,sg,0,se,0,169||",
                "Macquarie": "bv3,0,263,0,8l|||",
                "Magadan": "5oe,0,8l,0,8l|5oe,0,mj,0,8l||",
                "Malaysia": "bv2,0,8l|||",
                "Maldives": "bv1,0,8l|||",
                "Marquesas": "bv0,0,8l|||",
                "Marshall_Islands": "buv,0,1n9,0,8l|||",
                "Mauritius": "5oj,0,fg,0,8l|5oj,0,mj,0,8l||",
                "Mawson": "buu,0,8l|||",
                "Mexico_Northwest": "5ol,0,14r,0,4ao,0,fg,0,8l|5ol,0,14r,0,4ao,0,sg,0,se,0,1kk||",
                "Mexico_Pacific": "4ao,0,14r,0,fg,0,8l|4ao,0,14r,0,sg,0,se,0,1kk||",
                "Mongolia": "5on,0,5oo,0,fg,0,8l|5on,0,5oo,0,mj,0,8l||",
                "Moscow": "5op,0,fg,0,8l|5op,0,mj,0,8l||",
                "Myanmar": "but,0,8l|||",
                "Nauru": "bus,0,8l|||",
                "Nepal": "bur,0,8l|||",
                "New_Caledonia": "2fi,0,5ot,0,fg,0,8l|2fi,0,5ot,0,mj,0,8l||",
                "New_Zealand": "2fi,0,5ou,0,fg,0,8l|2fi,0,5ou,0,sg,0,se,0,169||",
                "Newfoundland": "5ov,0,fg,0,8l|5ov,0,sg,0,se,0,1kk||",
                "Niue": "buq,0,8l|||",
                "Norfolk": "bup,0,263,0,8l|||",
                "Noronha": "5p2,0,5p3,0,5p4,0,fg,0,8l|5p2,0,5p3,0,5p4,0,mj,0,8l||",
                "Novosibirsk": "5p5,0,fg,0,8l|5p5,0,mj,0,8l||",
                "Omsk": "5p6,0,fg,0,8l|5p6,0,mj,0,8l||",
                "Pakistan": "5p7,0,fg,0,8l|5p7,0,mj,0,8l||",
                "Palau": "buo,0,8l|||",
                "Papua_New_Guinea": "bun,0,2fi,0,bum,0,8l|||",
                "Paraguay": "5pb,0,fg,0,8l|5pb,0,mj,0,8l||",
                "Peru": "5pc,0,fg,0,8l|5pc,0,mj,0,8l||",
                "Philippines": "5pd,0,fg,0,8l|5pd,0,mj,0,8l||",
                "Phoenix_Islands": "bul,0,1n9,0,8l|||",
                "Pierre_Miquelon": "5pf,0,5pg,0,4as,0,5pi,0,fg,0,8l|5pf,0,5pg,0,4as,0,5pi,0,sg,0,se,0,169||",
                "Pitcairn": "buk,0,8l|||",
                "Ponape": "buj,0,8l|||",
                "Pyongyang": "bui,0,8l|||",
                "Reunion": "buh,0,8l|||",
                "Rothera": "bug,0,8l|||",
                "Sakhalin": "5pq,0,fg,0,8l|5pq,0,mj,0,8l||",
                "Samoa": "5pr,0,fg,0,8l|5pr,0,sg,0,se,0,169||",
                "Seychelles": "buf,0,8l|||",
                "Singapore": "bue,0,fg,0,8l|||",
                "Solomon": "bud,0,1n9,0,8l|||",
                "South_Georgia": "5d9,0,4ib,0,8l|||",
                "Suriname": "buc,0,8l|||",
                "Syowa": "bub,0,8l|||",
                "Tahiti": "bua,0,8l|||",
                "Taipei": "5q7,0,fg,0,8l|5q7,0,sg,0,se,0,169||",
                "Tajikistan": "bu9,0,8l|||",
                "Tokelau": "bu8,0,8l|||",
                "Tonga": "5qa,0,fg,0,8l|5qa,0,mj,0,8l||",
                "Truk": "bu7,0,8l|||",
                "Turkmenistan": "5qd,0,fg,0,8l|5qd,0,mj,0,8l||",
                "Tuvalu": "bu6,0,8l|||",
                "Uruguay": "5qk,0,fg,0,8l|5qk,0,mj,0,8l||",
                "Uzbekistan": "5qm,0,fg,0,8l|5qm,0,mj,0,8l||",
                "Vanuatu": "5qq,0,fg,0,8l|5qq,0,mj,0,8l||",
                "Venezuela": "bu5,0,8l|||",
                "Vladivostok": "5qv,0,8l,0,8l|5qv,0,mj,0,8l||",
                "Volgograd": "5r2,0,fg,0,8l|5r2,0,mj,0,8l||",
                "Vostok": "bu4,0,8l|||",
                "Wake": "bu3,0,263,0,8l|||",
                "Wallis": "bu2,0,4as,0,bu1,0,8l|||",
                "Yakutsk": "5re,0,fg,0,8l|5re,0,mj,0,8l||",
                "Yekaterinburg": "5ri,0,fg,0,8l|5ri,0,mj,0,8l||"
            }
        },
        "ckb-IR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ckb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "cs": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c9f,0,fa,0,11||",
                "Europe/London": "|c9g,0,fa,0,11||"
            },
            "metazone": {
                "Acre": "5rk,0,fe,0,11|5rk,0,fa,0,11||",
                "Afghanistan": "bu0,0,11|||",
                "Africa_Central": "btv,0,11|||",
                "Africa_Eastern": "btu,0,11|||",
                "Africa_Southern": "btt,0,11|||",
                "Africa_Western": "5s1,0,fe,0,11|5s1,0,fa,0,11||",
                "Alaska": "5s3,0,fe,0,11|5s3,0,fa,0,11||",
                "Almaty": "5s8,0,fe,0,11|5s8,0,fa,0,11||",
                "Amazon": "5s9,0,fe,0,11|5s9,0,fa,0,11||",
                "America_Central": "256,0,5sg,0,fe,0,11|256,0,5sg,0,fa,0,11||",
                "America_Eastern": "256,0,5si,0,fe,0,11|256,0,5si,0,fa,0,11||",
                "America_Mountain": "256,0,4a1,0,fe,0,11|256,0,4a1,0,fa,0,11||",
                "America_Pacific": "256,0,49s,0,fe,0,11|256,0,49s,0,fa,0,11||",
                "Anadyr": "49r,0,fe,0,11|49r,0,fa,0,11||",
                "Apia": "5sr,0,fe,0,11|5sr,0,fa,0,11||",
                "Aqtau": "5st,0,fe,0,11|5st,0,fa,0,11||",
                "Aqtobe": "5t1,0,fe,0,11|5t1,0,fa,0,11||",
                "Arabian": "5t6,0,fe,0,11|5t6,0,fa,0,11||",
                "Argentina": "5t8,0,fe,0,11|5t8,0,fa,0,11||",
                "Argentina_Western": "5tf,0,fe,0,11|5tf,0,fa,0,11||",
                "Armenia": "5tm,0,fe,0,11|5tm,0,fa,0,11||",
                "Atlantic": "5tn,0,fe,0,11|5tn,0,fa,0,11||",
                "Australia_Central": "5u0,0,fe,0,11|5u0,0,fa,0,11||",
                "Australia_CentralWestern": "5u2,0,5u3,0,fe,0,11|5u2,0,5u3,0,fa,0,11||",
                "Australia_Eastern": "5u4,0,fe,0,11|5u4,0,fa,0,11||",
                "Australia_Western": "5u5,0,fe,0,11|5u5,0,fa,0,11||",
                "Azerbaijan": "5u6,0,fe,0,11|5u6,0,fa,0,11||",
                "Azores": "5u7,0,fe,0,11|5u7,0,fa,0,11||",
                "Bangladesh": "5u8,0,fe,0,11|5u8,0,fa,0,11||",
                "Bhutan": "bts,0,11|||",
                "Bolivia": "btr,0,11|||",
                "Brasilia": "5uc,0,fe,0,11|5uc,0,fa,0,11||",
                "Brunei": "btq,0,11|||",
                "Cape_Verde": "5uf,0,fe,0,11|5uf,0,fa,0,11||",
                "Casey": "135,0,btp,0,10j|||",
                "Chamorro": "bto,0,11|||",
                "Chatham": "5v2,0,fe,0,11|5v2,0,fa,0,11||",
                "Chile": "5v7,0,fe,0,11|5v7,0,fa,0,11||",
                "China": "5v8,0,fe,0,11|5v8,0,fa,0,11||",
                "Choibalsan": "5va,0,fe,0,11|5va,0,fa,0,11||",
                "Christmas": "135,0,btn,0,19g|||",
                "Cocos": "135,0,5ve,0,1pf|||",
                "Colombia": "5vh,0,fe,0,11|5vh,0,fa,0,11||",
                "Cook": "2uh,0,11,0,49j,0,1pf|49i,0,11,0,49j,0,1pf||",
                "Cuba": "5vm,0,fe,0,11|5vm,0,fa,0,11||",
                "Davis": "135,0,btm,0,10j|||",
                "DumontDUrville": "135,0,10j,0,5vo,0,btl|||",
                "East_Timor": "btk,0,11|||",
                "Easter": "2uh,0,11,0,5vr,0,19g|49i,0,11,0,5vr,0,19g||",
                "Ecuador": "btj,0,11|||",
                "Europe_Central": "5vt,0,fe,0,11|5vt,0,fa,0,11|5vu|606",
                "Europe_Eastern": "60o,0,fe,0,11|60o,0,fa,0,11||",
                "Europe_Further_Eastern": "bti,0,11|||",
                "Europe_Western": "60t,0,fe,0,11|60t,0,fa,0,11||",
                "Falkland": "60u,0,fe,0,11|60u,0,fa,0,11||",
                "Fiji": "610,0,fe,0,11|610,0,fa,0,11||",
                "French_Guiana": "bth,0,11|||",
                "French_Southern": "135,0,btg,0,btf,0,a6,0,61p,0,61s|||",
                "Galapagos": "bte,0,11|||",
                "Gambier": "btd,0,11|||",
                "Georgia": "62b,0,fe,0,11|62b,0,fa,0,11||",
                "Gilbert_Islands": "135,0,62i,0,1pf|||",
                "GMT": "btc,0,btb,0,11|||",
                "Greenland_Eastern": "633,0,fe,0,11|633,0,fa,0,11||",
                "Greenland_Western": "634,0,fe,0,11|634,0,fa,0,11||",
                "Guam": "bta,0,11|||",
                "Gulf": "2uh,0,11,0,bt9,0,63a|||",
                "Guyana": "bt8,0,11|||",
                "Hawaii_Aleutian": "1c5,5,48l,0,fe,0,11|1c5,5,48l,0,fa,0,11||",
                "Hong_Kong": "63e,0,fe,0,11|63e,0,fa,0,11||",
                "Hovd": "63f,0,fe,0,11|63f,0,fa,0,11||",
                "India": "bt7,0,11|||",
                "Indian_Ocean": "bt6,0,11|||",
                "Indochina": "bt5,0,11|||",
                "Indonesia_Central": "bt4,0,11|||",
                "Indonesia_Eastern": "bt3,0,11|||",
                "Indonesia_Western": "bt2,0,11|||",
                "Iran": "63o,0,fe,0,11|63o,0,fa,0,11||",
                "Irkutsk": "63p,0,fe,0,11|63p,0,fa,0,11||",
                "Israel": "63r,0,fe,0,11|63r,0,fa,0,11||",
                "Japan": "63s,0,fe,0,11|63s,0,fa,0,11||",
                "Kamchatka": "1gd,5,63v,0,fe,0,11|1gd,5,63v,0,fa,0,11||",
                "Kazakhstan_Eastern": "bt1,0,11|||",
                "Kazakhstan_Western": "bt0,0,11|||",
                "Korea": "647,0,fe,0,11|647,0,fa,0,11||",
                "Kosrae": "bsv,0,11|||",
                "Krasnoyarsk": "64f,0,fe,0,11|64f,0,fa,0,11||",
                "Kyrgystan": "bsu,0,11|||",
                "Lanka": "bst,0,11|||",
                "Line_Islands": "135,0,64l,0,1pf|||",
                "Lord_Howe": "2uh,0,11,0,19g,0,48a,0,489|49i,0,11,0,19g,0,48a,0,489||",
                "Macau": "64q,0,fe,0,11|64q,0,fa,0,11||",
                "Macquarie": "135,0,19g,0,6m|||",
                "Magadan": "64s,0,fe,0,11|64s,0,fa,0,11||",
                "Malaysia": "bss,0,11|||",
                "Maldives": "bsr,0,11|||",
                "Marquesas": "bsq,0,11|||",
                "Marshall_Islands": "135,0,65h,0,1pf|||",
                "Mauritius": "65j,0,fe,0,11|65j,0,fa,0,11||",
                "Mawson": "135,0,bsp,0,10j|||",
                "Mexico_Northwest": "65t,0,2d6,0,fe,0,11|65t,0,2d6,0,fa,0,11||",
                "Mexico_Pacific": "65v,0,49s,0,fe,0,11|65v,0,49s,0,fa,0,11||",
                "Mongolia": "663,0,fe,0,11|663,0,fa,0,11||",
                "Moscow": "665,0,fe,0,11|665,0,fa,0,11||",
                "Myanmar": "bso,0,11|||",
                "Nauru": "bsn,0,11|||",
                "Nepal": "bsm,0,11|||",
                "New_Caledonia": "66m,0,fe,0,11|66m,0,fa,0,11||",
                "New_Zealand": "66n,0,fe,0,11|66n,0,fa,0,11||",
                "Newfoundland": "66o,0,fe,0,11|66o,0,fa,0,11||",
                "Niue": "bsl,0,11|||",
                "Norfolk": "bsk,0,11|||",
                "Noronha": "2uh,0,11,0,66v,0,1s,0,2,0,23|49i,0,11,0,66v,0,1s,0,2,0,23||",
                "North_Mariana": "bsj,0,11|||",
                "Novosibirsk": "671,0,fe,0,11|671,0,fa,0,11||",
                "Omsk": "675,0,fe,0,11|675,0,fa,0,11||",
                "Pakistan": "676,0,fe,0,11|676,0,fa,0,11||",
                "Palau": "bsi,0,11|||",
                "Papua_New_Guinea": "135,0,678,5,bsh,0,67f|||",
                "Paraguay": "67h,0,fe,0,11|67h,0,fa,0,11||",
                "Peru": "67m,0,fe,0,11|67m,0,fa,0,11||",
                "Philippines": "67r,0,fe,0,11|67r,0,fa,0,11||",
                "Phoenix_Islands": "135,0,67s,0,1pf|||",
                "Pierre_Miquelon": "33,5,47t,0,fe,0,11|33,5,47t,0,fa,0,11||",
                "Pitcairn": "135,0,bsg,0,19g|||",
                "Ponape": "bsf,0,11|||",
                "Pyongyang": "bse,0,11|||",
                "Qyzylorda": "686,0,fe,0,11|686,0,fa,0,11||",
                "Reunion": "bsd,0,11|||",
                "Rothera": "135,0,bsc,0,10j|||",
                "Sakhalin": "689,0,fe,0,11|689,0,fa,0,11||",
                "Samara": "47p,0,fe,0,11|47p,0,fa,0,11||",
                "Samoa": "68d,0,fe,0,11|68d,0,fa,0,11||",
                "Seychelles": "bsb,0,11|||",
                "Singapore": "bsa,0,11|||",
                "Solomon": "135,0,bs9,0,1pf|||",
                "South_Georgia": "135,0,bs8,0,68o|||",
                "Suriname": "bs7,0,11|||",
                "Syowa": "135,0,10j,0,68s|||",
                "Tahiti": "bs6,0,11|||",
                "Taipei": "68v,0,fe,0,11|68v,0,fa,0,11||",
                "Tajikistan": "bs5,0,11|||",
                "Tokelau": "bs4,0,11|||",
                "Tonga": "69c,0,fe,0,11|69c,0,fa,0,11||",
                "Truk": "bs3,0,11|||",
                "Turkmenistan": "69j,0,fe,0,11|69j,0,fa,0,11||",
                "Tuvalu": "bs2,0,11|||",
                "Uruguay": "69p,0,fe,0,11|69p,0,fa,0,11||",
                "Uzbekistan": "69r,0,fe,0,11|69r,0,fa,0,11||",
                "Vanuatu": "69t,0,fe,0,11|69t,0,fa,0,11||",
                "Venezuela": "bs1,0,11|||",
                "Vladivostok": "69v,0,fe,0,11|69v,0,fa,0,11||",
                "Volgograd": "6a1,0,fe,0,11|6a1,0,fa,0,11||",
                "Vostok": "135,0,10j,0,5t|||",
                "Wake": "135,0,19g,0,5r|||",
                "Wallis": "135,0,1pf,0,5f,0,a6,0,5k|||",
                "Yakutsk": "6a2,0,fe,0,11|6a2,0,fa,0,11||",
                "Yekaterinburg": "6a4,0,fe,0,11|6a4,0,fa,0,11||"
            }
        },
        "cu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "cy": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|7h,0,g6,0,c9h||",
                "Europe/London": "|7h,0,g6,0,c9i||"
            },
            "metazone": {
                "Afghanistan": "7h,0,b6|||",
                "Africa_Central": "7h,0,1mg,0,30n|||",
                "Africa_Eastern": "7h,0,1ep,0,30n|||",
                "Africa_Southern": "7h,0,g1,0,47f,0,30n|||",
                "Africa_Western": "7h,0,g1,0,1au,0,30n|7h,0,g6,0,1au,0,30n||",
                "Alaska": "7h,0,g1,0,3p|7h,0,g6,0,3p||",
                "Amazon": "7h,0,g1,0,bg|7h,0,g6,0,bg||",
                "America_Central": "7h,0,g1,0,1mg,0,1mm,0,14n|7h,0,g6,0,1mg,0,1mm,0,14n||",
                "America_Eastern": "7h,0,g1,0,1ep,0,1mm,0,14n|7h,0,g6,0,1ep,0,1mm,0,14n||",
                "America_Mountain": "7h,0,g1,0,6al,0,1mm,0,14n|7h,0,g6,0,6al,0,1mm,0,14n||",
                "America_Pacific": "7h,0,g1,0,312,0,6av,0,1mm,0,14n|7h,0,g6,0,312,0,6av,0,1mm,0,14n||",
                "Apia": "7h,0,g1,0,3e|7h,0,g6,0,3e||",
                "Arabian": "7h,0,g1,0,6b7|7h,0,g6,0,6b7||",
                "Argentina": "7h,0,g1,0,47e|7h,0,g6,0,47e||",
                "Argentina_Western": "7h,0,g1,0,1au,0,47e|7h,0,g6,0,1au,0,47e||",
                "Armenia": "7h,0,g1,0,4l|7h,0,g6,0,4l||",
                "Atlantic": "7h,0,g1,0,312,0,1mp,0,6bd|7h,0,g6,0,312,0,1mp,0,6bd||",
                "Australia_Central": "7h,0,g1,0,1mg,0,257|7h,0,g6,0,1mg,0,257||",
                "Australia_CentralWestern": "7h,0,g1,0,1mg,0,1au,0,257|7h,0,g6,0,1mg,0,1au,0,257||",
                "Australia_Eastern": "7h,0,g1,0,1ep,0,257|7h,0,g6,0,1ep,0,257||",
                "Australia_Western": "7h,0,g1,0,1au,0,257|7h,0,g6,0,1au,0,257||",
                "Azerbaijan": "7h,0,g1,0,6bk|7h,0,g6,0,6bk||",
                "Azores": "7h,0,g1,0,1mp,0,4r|7h,0,g6,0,1mp,0,4r||",
                "Bangladesh": "7h,0,g1,0,3n|7h,0,g6,0,3n||",
                "Bhutan": "7h,0,as|||",
                "Bolivia": "7h,0,aa|||",
                "Brasilia": "7h,0,g1,0,in|7h,0,g6,0,in||",
                "Brunei": "7h,0,9o,0,a4|||",
                "Cape_Verde": "7h,0,g1,0,ck,0,3j|7h,0,g6,0,ck,0,3j||",
                "Chamorro": "7h,0,6j|||",
                "Chatham": "7h,0,g1,0,27|7h,0,g6,0,27||",
                "Chile": "7h,0,g1,0,49|7h,0,g6,0,49||",
                "China": "7h,0,g1,0,4ie|7h,0,g6,0,4ie||",
                "Choibalsan": "7h,0,g1,0,2q|7h,0,g6,0,2q||",
                "Christmas": "7h,0,1mv,0,6c7,0,bs0|||",
                "Cocos": "7h,0,1n1,0,7v|||",
                "Colombia": "7h,0,g1,0,4m|7h,0,g6,0,4m||",
                "Cook": "7h,0,g1,0,1n1,0,2v|7h,0,brv,0,g6,0,1n1,0,2v||",
                "Cuba": "7h,0,g1,0,34|7h,0,g6,0,34||",
                "Davis": "7h,0,5s|||",
                "DumontDUrville": "7h,0,5b,5,5j|||",
                "East_Timor": "7h,0,1ep,0,7n|||",
                "Easter": "7h,0,g1,0,1mv,0,bk,0,6cm|7h,0,g6,0,1mv,0,bk,0,6cm||",
                "Ecuador": "7h,0,ai|||",
                "Europe_Central": "7h,0,g1,0,1mg,0,288|7h,0,g6,0,1mg,0,288|h0|h4",
                "Europe_Eastern": "7h,0,g1,0,1ep,0,288|7h,0,g6,0,1ep,0,288|gu|gv",
                "Europe_Further_Eastern": "7h,0,1ep,0,bru,0,288|||",
                "Europe_Western": "7h,0,g1,0,1au,0,288|7h,0,g6,0,1au,0,288|h1|h2",
                "Falkland": "7h,0,g1,0,1n1,0,6d2|7h,0,g6,0,1n1,0,6d2||",
                "Fiji": "7h,0,g1,0,4q|7h,0,g6,0,4q||",
                "French_Guiana": "7h,0,n1,0,brt|||",
                "French_Southern": "7h,0,brs,0,brr,0,brq,0,brp|||",
                "Galapagos": "7h,0,ak|||",
                "Gambier": "7h,0,6v|||",
                "Georgia": "7h,0,g1,0,2u|7h,0,g6,0,2u||",
                "Gilbert_Islands": "7h,0,1n1,0,6q|||",
                "GMT": "7h,0,g1,0,5u||ah|",
                "Greenland_Eastern": "7h,0,g1,0,1ep,0,1mp,0,1mv,0,475|7h,0,g6,0,1ep,0,1mp,0,1mv,0,475||",
                "Greenland_Western": "7h,0,g1,0,1au,0,1mp,0,1mv,0,475|7h,0,g6,0,1au,0,1mp,0,1mv,0,475||",
                "Gulf": "7h,0,g1,0,bk,0,bro|||",
                "Guyana": "7h,0,7a|||",
                "Hawaii_Aleutian": "7h,0,g1,0,4g,5,62|7h,0,g6,0,4g,5,62||",
                "Hong_Kong": "7h,0,g1,0,2l,0,2p|7h,0,g6,0,2l,0,2p||",
                "Hovd": "7h,0,g1,0,2g|7h,0,g6,0,2g||",
                "India": "7h,0,af|||",
                "Indian_Ocean": "7h,0,312,0,af|||",
                "Indochina": "7h,0,brn,5,4ie|||",
                "Indonesia_Central": "7h,0,1mg,0,2t|||",
                "Indonesia_Eastern": "7h,0,1ep,0,2t|||",
                "Indonesia_Western": "7h,0,1au,0,2t|||",
                "Iran": "7h,0,g1,0,5g|7h,0,g6,0,5g||",
                "Irkutsk": "7h,0,g1,0,3h|7h,0,g6,0,3h||",
                "Israel": "7h,0,g1,0,4e|7h,0,g6,0,4e||",
                "Japan": "7h,0,g1,0,6eb|7h,0,g6,0,6eb||",
                "Kazakhstan_Eastern": "7h,0,1ep,0,4if|||",
                "Kazakhstan_Western": "7h,0,1au,0,4if|||",
                "Korea": "7h,0,g1,0,hf|7h,0,g6,0,hf||",
                "Kosrae": "7h,0,6f|||",
                "Krasnoyarsk": "7h,0,g1,0,41|7h,0,g6,0,41||",
                "Kyrgystan": "7h,0,4if|||",
                "Line_Islands": "7h,0,1n1,0,ac|||",
                "Lord_Howe": "7h,0,g1,0,1mp,0,6ee,0,24|7h,0,g6,0,1mp,0,6ee,0,24||",
                "Macquarie": "7h,0,1mv,0,6m|||",
                "Magadan": "7h,0,g1,0,2o|7h,0,g6,0,2o||",
                "Malaysia": "7h,0,bf|||",
                "Maldives": "7h,0,6c7,0,9k|||",
                "Marquesas": "7h,0,n3|||",
                "Marshall_Islands": "7h,0,1n1,0,7o|||",
                "Mauritius": "7h,0,g1,0,4u|7h,0,g6,0,4u||",
                "Mawson": "7h,0,63|||",
                "Mexico_Northwest": "7h,0,g1,0,1mm,0,6ek,0,472|7h,0,g6,0,1mm,0,6ek,0,472||",
                "Mexico_Pacific": "7h,0,g1,0,6f5,0,472|7h,0,g6,0,6f5,0,472||",
                "Mongolia": "7h,0,g1,0,4f,0,2m|7h,0,g6,0,4f,0,2m||",
                "Moscow": "7h,0,g1,0,6fd|7h,0,g6,0,6fd||",
                "Myanmar": "7h,0,8v|||",
                "Nauru": "7h,0,5v|||",
                "Nepal": "7h,0,8u|||",
                "New_Caledonia": "7h,0,g1,0,4o,0,2lp|7h,0,g6,0,4o,0,2lp||",
                "New_Zealand": "7h,0,g1,0,6ff,0,2lp|7h,0,g6,0,6ff,0,2lp||",
                "Newfoundland": "7h,0,g1,0,53|7h,0,g6,0,53||",
                "Niue": "7h,0,8g|||",
                "Norfolk": "7h,0,1mv,0,6l|||",
                "Noronha": "7h,0,g1,0,1s,0,2,0,23|7h,0,g6,0,1s,0,2,0,23||",
                "Novosibirsk": "7h,0,g1,0,3b|7h,0,g6,0,3b||",
                "Omsk": "7h,0,g1,0,26|7h,0,g6,0,26||",
                "Pakistan": "7h,0,g1,0,3i|7h,0,g6,0,3i||",
                "Palau": "7h,0,9b|||",
                "Papua_New_Guinea": "7h,0,9a,0,a8,0,2lp|||",
                "Paraguay": "7h,0,g1,0,3c|7h,0,g6,0,3c||",
                "Peru": "7h,0,g1,0,6fh|7h,0,g6,0,6fh||",
                "Philippines": "7h,0,g1,0,471|7h,0,g6,0,471||",
                "Phoenix_Islands": "7h,0,1n1,0,90|||",
                "Pierre_Miquelon": "7h,0,g1,0,8i,5,33,5,8p,5,35|7h,0,g6,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "7h,0,7e|||",
                "Ponape": "7h,0,e5|||",
                "Pyongyang": "7h,0,8a|||",
                "Reunion": "7h,0,i8|||",
                "Rothera": "7h,0,5q|||",
                "Sakhalin": "7h,0,g1,0,55|7h,0,g6,0,55||",
                "Samoa": "7h,0,g1,0,2c|7h,0,g6,0,2c||",
                "Seychelles": "7h,0,8k|||",
                "Singapore": "7h,0,bi|||",
                "Solomon": "7h,0,1n1,0,b5|||",
                "South_Georgia": "7h,0,47f,0,2u|||",
                "Suriname": "7h,0,8q|||",
                "Syowa": "7h,0,65|||",
                "Tahiti": "7h,0,8n|||",
                "Taipei": "7h,0,g1,0,3d|7h,0,g6,0,3d||",
                "Tajikistan": "7h,0,brm|||",
                "Tokelau": "7h,0,5d|||",
                "Tonga": "7h,0,g1,0,2j|7h,0,g6,0,2j||",
                "Truk": "7h,0,6p|||",
                "Turkmenistan": "7h,0,g1,0,6fu|7h,0,g6,0,6fu||",
                "Tuvalu": "7h,0,6h|||",
                "Uruguay": "7h,0,g1,0,4k|7h,0,g6,0,4k||",
                "Uzbekistan": "7h,0,g1,0,6fv|7h,0,g6,0,6fv||",
                "Vanuatu": "7h,0,g1,0,2f|7h,0,g6,0,2f||",
                "Venezuela": "7h,0,7s|||",
                "Vladivostok": "7h,0,g1,0,28|7h,0,g6,0,28||",
                "Volgograd": "7h,0,g1,0,3f|7h,0,g6,0,3f||",
                "Vostok": "7h,0,5t|||",
                "Wake": "7h,0,1mv,0,5r|||",
                "Wallis": "7h,0,5f,0,a6,0,5k|||",
                "Yakutsk": "7h,0,g1,0,3u|7h,0,g6,0,3u||",
                "Yekaterinburg": "7h,0,g1,0,5l|7h,0,g6,0,5l||"
            }
        },
        "da-GL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6om,0,1l||",
                "Europe/London": "|6np,0,3t||"
            },
            "metazone": {
                "Acre": "3q,5,1l|3q,5,3t||",
                "Afghanistan": "6g3,0,4j|||",
                "Africa_Central": "6g7,0,4j|||",
                "Africa_Eastern": "6g8,0,4j|||",
                "Africa_Southern": "6g9,0,4j|||",
                "Africa_Western": "470,0,1l|470,0,3t||",
                "Alaska": "3p,5,1l|3p,5,3t||",
                "Almaty": "56,5,1l|56,5,3t||",
                "Amazon": "bg,5,1l|bg,5,3t||",
                "America_Central": "n,5,1l|n,5,3t||",
                "America_Eastern": "17,5,1l|17,5,3t||",
                "America_Mountain": "5a,5,1l|5a,5,3t||",
                "America_Pacific": "2h,5,1l|2h,5,3t||",
                "Anadyr": "3l,5,1l|3l,5,3t||",
                "Apia": "3e,5,1l|3e,5,3t||",
                "Aqtau": "50,5,1l|50,5,3t||",
                "Aqtobe": "5o,5,1l|5o,5,3t||",
                "Arabian": "24b,0,1l|24b,0,3t||",
                "Argentina": "46v,0,1l|46v,0,3t||",
                "Argentina_Western": "46u,0,1l|46u,0,3t||",
                "Armenia": "46t,0,1l|46t,0,3t||",
                "Atlantic": "6g,5,1l|6g,5,3t||",
                "Australia_Central": "46s,0,1l|46s,0,3t||",
                "Australia_CentralWestern": "46r,0,46q,0,1l|46r,0,46q,0,3t||",
                "Australia_Eastern": "46p,0,1l|46p,0,3t||",
                "Australia_Western": "46o,0,1l|46o,0,3t||",
                "Azerbaijan": "46l,0,1l|46l,0,3t||",
                "Azores": "46k,5,1l|46k,5,3t||",
                "Bangladesh": "46j,0,1l|46j,0,3t||",
                "Bhutan": "6h5,0,4j|||",
                "Bolivia": "6h6,0,4j|||",
                "Brasilia": "46i,0,1l|46i,0,3t||",
                "Brunei": "9o,0,a4,5,4j|||",
                "Cape_Verde": "46h,0,1l|46h,0,3t||",
                "Chamorro": "6j,5,4j|||",
                "Chatham": "27,5,1l|27,5,3t||",
                "Chile": "46g,0,1l|46g,0,3t||",
                "China": "46d,0,1l|46d,0,3t||",
                "Choibalsan": "2q,5,1l|2q,5,3t||",
                "Christmas": "99,0,1f,5,1l|||",
                "Cocos": "6i2,5,1l|||",
                "Colombia": "46c,0,1l|46c,0,3t||",
                "Cook": "46b,5,1l|46b,5,3t||",
                "Cuba": "46a,0,1l|46a,0,3t||",
                "Davis": "5s,5,4j|||",
                "DumontDUrville": "5b,5,5j,5,4j|||",
                "East_Timor": "6if,5,4j|||",
                "Easter": "469,5,1l|469,5,3t||",
                "Ecuador": "6iv,0,4j|||",
                "Europe_Central": "468,0,1l|468,0,3t|h0|h4",
                "Europe_Eastern": "467,0,1l|467,0,3t|gu|gv",
                "Europe_Further_Eastern": "6j9,0,4j|||",
                "Europe_Western": "466,0,1l|466,0,3t|h1|h2",
                "Falkland": "465,5,1l|465,5,3t||",
                "Fiji": "464,0,1l|464,0,3t||",
                "French_Guiana": "463,0,7a,5,4j|||",
                "French_Southern": "6jo,0,6jp,0,u0,0,6jt,0,6jv,5,4j|||",
                "Galapagos": "ak,5,4j|||",
                "Gambier": "6v,5,4j|||",
                "Georgia": "461,0,1l|461,0,3t||",
                "Gilbert_Islands": "6ln,5,4j|||",
                "GMT": "ah|||",
                "Greenland_Eastern": "460,0,1l|460,0,3t||",
                "Greenland_Western": "45s,0,1l|45s,0,3t||",
                "Guam": "83,5,1l|||",
                "Gulf": "6ma,5,1l|||",
                "Guyana": "7a,5,4j|||",
                "Hawaii_Aleutian": "4g,5,62,5,1l|4g,5,62,5,3t||",
                "Hong_Kong": "qh,5,1l|qh,5,3t||",
                "Hovd": "2g,5,1l|2g,5,3t||",
                "India": "6mb,0,1l|||",
                "Indian_Ocean": "6mc,0,bv,5,1l|||",
                "Indochina": "23t,5,4j|||",
                "Indonesia_Central": "6mj,0,4j|||",
                "Indonesia_Eastern": "6mk,0,4j|||",
                "Indonesia_Western": "6ml,0,4j|||",
                "Iran": "45r,0,1l|45r,0,3t||",
                "Irkutsk": "3h,5,1l|3h,5,3t||",
                "Israel": "45q,0,1l|45q,0,3t||",
                "Japan": "45m,0,1l|45m,0,3t||",
                "Kamchatka": "37,5,3k,0,1l|37,5,3k,0,3t||",
                "Kazakhstan_Eastern": "6mp,0,4j|||",
                "Kazakhstan_Western": "6ms,0,4j|||",
                "Korea": "45k,0,1l|45k,0,3t||",
                "Kosrae": "6f,5,4j|||",
                "Krasnoyarsk": "41,5,1l|41,5,3t||",
                "Kyrgystan": "6mu,0,4j|||",
                "Lanka": "6mv,0,4j|||",
                "Line_Islands": "6n0,5,4j|||",
                "Lord_Howe": "1u,0,24,5,1l|1u,0,24,5,3t||",
                "Macau": "ip,5,1l|ip,5,3t||",
                "Macquarie": "6m,5,4j|||",
                "Magadan": "2o,5,1l|2o,5,3t||",
                "Malaysia": "6n2,0,4j|||",
                "Maldives": "6n3,0,4j|||",
                "Marquesas": "9e,5,4j|||",
                "Marshall_Islands": "6n4,5,4j|||",
                "Mauritius": "4u,5,1l|4u,5,3t||",
                "Mawson": "63,5,4j|||",
                "Mexico_Northwest": "45j,0,1l|45j,0,3t||",
                "Mexico_Pacific": "45i,0,2h,5,1l|45i,0,2h,5,3t||",
                "Mongolia": "4f,0,2m,5,1l|4f,0,2m,5,3t||",
                "Moscow": "45h,0,1l|45h,0,3t||",
                "Myanmar": "6n8,0,4j|||",
                "Nauru": "5v,5,4j|||",
                "Nepal": "6n9,0,4j|||",
                "New_Caledonia": "45d,0,1l|45d,0,3t||",
                "New_Zealand": "45c,0,1l|45c,0,3t||",
                "Newfoundland": "45b,0,1l|45b,0,3t||",
                "Niue": "8g,5,4j|||",
                "Norfolk": "6l,0,1f,5,4j|||",
                "Noronha": "1s,0,2,0,23,5,1l|1s,0,2,0,23,5,3t||",
                "North_Mariana": "6ng,5,4j|||",
                "Novosibirsk": "3b,0,1l|3b,0,3t||",
                "Omsk": "26,5,1l|26,5,3t||",
                "Pakistan": "459,0,1l|459,0,3t||",
                "Palau": "9b,5,1l|||",
                "Papua_New_Guinea": "9a,0,6nk,0,a8,5,4j|||",
                "Paraguay": "457,0,1l|457,0,3t||",
                "Peru": "456,0,1l|456,0,3t||",
                "Philippines": "454,0,1l|454,0,3t||",
                "Phoenix_Islands": "6nq,5,4j|||",
                "Pierre_Miquelon": "8i,0,33,5,0,u0,0,35,5,1l|8i,0,33,5,0,u0,0,35,5,3t||",
                "Pitcairn": "7e,5,4j|||",
                "Ponape": "9s,5,4j|||",
                "Pyongyang": "8a,5,4j|||",
                "Qyzylorda": "4d,5,1l|4d,5,3t||",
                "Reunion": "b4,5,4j|||",
                "Rothera": "5q,5,4j|||",
                "Sakhalin": "55,5,1l|55,5,3t||",
                "Samara": "29,5,1l|29,5,3t||",
                "Samoa": "2c,5,1l|2c,5,3t||",
                "Seychelles": "6nr,0,4j|||",
                "Singapore": "6nt,0,1l|||",
                "Solomon": "6o1,5,4j|||",
                "South_Georgia": "85,0,2u,5,4j|||",
                "Suriname": "mg,5,4j|||",
                "Syowa": "65,5,4j|||",
                "Tahiti": "6o4,0,4j|||",
                "Taipei": "3d,5,1l|3d,5,3t||",
                "Tajikistan": "6o6,0,4j|||",
                "Tokelau": "5d,5,4j|||",
                "Tonga": "44v,0,1l|44v,0,3t||",
                "Truk": "6p,5,4j|||",
                "Turkmenistan": "44u,0,1l|44u,0,3t||",
                "Tuvalu": "6h,5,4j|||",
                "Uruguay": "44t,0,1l|44t,0,3t||",
                "Uzbekistan": "44s,0,1l|44s,0,3t||",
                "Vanuatu": "2f,5,1l|2f,5,3t||",
                "Venezuela": "6oh,0,4j|||",
                "Vladivostok": "28,5,1l|28,5,3t||",
                "Volgograd": "3f,5,1l|3f,5,3t||",
                "Vostok": "5t,5,4j|||",
                "Wake": "6ok,5,4j|||",
                "Wallis": "5f,0,u0,0,5k,5,4j|||",
                "Yakutsk": "3u,5,1l|3u,5,3t||",
                "Yekaterinburg": "44r,0,1l|44r,0,3t||"
            }
        },
        "da": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6om,0,1l||",
                "Europe/London": "|6np,0,3t||"
            },
            "metazone": {
                "Acre": "3q,5,1l|3q,5,3t||",
                "Afghanistan": "6g3,0,4j|||",
                "Africa_Central": "6g7,0,4j|||",
                "Africa_Eastern": "6g8,0,4j|||",
                "Africa_Southern": "6g9,0,4j|||",
                "Africa_Western": "470,0,1l|470,0,3t||",
                "Alaska": "3p,5,1l|3p,5,3t||",
                "Almaty": "56,5,1l|56,5,3t||",
                "Amazon": "bg,5,1l|bg,5,3t||",
                "America_Central": "n,5,1l|n,5,3t||",
                "America_Eastern": "17,5,1l|17,5,3t||",
                "America_Mountain": "5a,5,1l|5a,5,3t||",
                "America_Pacific": "2h,5,1l|2h,5,3t||",
                "Anadyr": "3l,5,1l|3l,5,3t||",
                "Apia": "3e,5,1l|3e,5,3t||",
                "Aqtau": "50,5,1l|50,5,3t||",
                "Aqtobe": "5o,5,1l|5o,5,3t||",
                "Arabian": "24b,0,1l|24b,0,3t||",
                "Argentina": "46v,0,1l|46v,0,3t||",
                "Argentina_Western": "46u,0,1l|46u,0,3t||",
                "Armenia": "46t,0,1l|46t,0,3t||",
                "Atlantic": "6g,5,1l|6g,5,3t||",
                "Australia_Central": "46s,0,1l|46s,0,3t||",
                "Australia_CentralWestern": "46r,0,46q,0,1l|46r,0,46q,0,3t||",
                "Australia_Eastern": "46p,0,1l|46p,0,3t||",
                "Australia_Western": "46o,0,1l|46o,0,3t||",
                "Azerbaijan": "46l,0,1l|46l,0,3t||",
                "Azores": "46k,5,1l|46k,5,3t||",
                "Bangladesh": "46j,0,1l|46j,0,3t||",
                "Bhutan": "6h5,0,4j|||",
                "Bolivia": "6h6,0,4j|||",
                "Brasilia": "46i,0,1l|46i,0,3t||",
                "Brunei": "9o,0,a4,5,4j|||",
                "Cape_Verde": "46h,0,1l|46h,0,3t||",
                "Chamorro": "6j,5,4j|||",
                "Chatham": "27,5,1l|27,5,3t||",
                "Chile": "46g,0,1l|46g,0,3t||",
                "China": "46d,0,1l|46d,0,3t||",
                "Choibalsan": "2q,5,1l|2q,5,3t||",
                "Christmas": "99,0,1f,5,1l|||",
                "Cocos": "6i2,5,1l|||",
                "Colombia": "46c,0,1l|46c,0,3t||",
                "Cook": "46b,5,1l|46b,5,3t||",
                "Cuba": "46a,0,1l|46a,0,3t||",
                "Davis": "5s,5,4j|||",
                "DumontDUrville": "5b,5,5j,5,4j|||",
                "East_Timor": "6if,5,4j|||",
                "Easter": "469,5,1l|469,5,3t||",
                "Ecuador": "6iv,0,4j|||",
                "Europe_Central": "468,0,1l|468,0,3t|h0|h4",
                "Europe_Eastern": "467,0,1l|467,0,3t|gu|gv",
                "Europe_Further_Eastern": "6j9,0,4j|||",
                "Europe_Western": "466,0,1l|466,0,3t|h1|h2",
                "Falkland": "465,5,1l|465,5,3t||",
                "Fiji": "464,0,1l|464,0,3t||",
                "French_Guiana": "463,0,7a,5,4j|||",
                "French_Southern": "6jo,0,6jp,0,u0,0,6jt,0,6jv,5,4j|||",
                "Galapagos": "ak,5,4j|||",
                "Gambier": "6v,5,4j|||",
                "Georgia": "461,0,1l|461,0,3t||",
                "Gilbert_Islands": "6ln,5,4j|||",
                "GMT": "ah|||",
                "Greenland_Eastern": "460,0,1l|460,0,3t||",
                "Greenland_Western": "45s,0,1l|45s,0,3t||",
                "Guam": "83,5,1l|||",
                "Gulf": "6ma,5,1l|||",
                "Guyana": "7a,5,4j|||",
                "Hawaii_Aleutian": "4g,5,62,5,1l|4g,5,62,5,3t||",
                "Hong_Kong": "qh,5,1l|qh,5,3t||",
                "Hovd": "2g,5,1l|2g,5,3t||",
                "India": "6mb,0,1l|||",
                "Indian_Ocean": "6mc,0,bv,5,1l|||",
                "Indochina": "23t,5,4j|||",
                "Indonesia_Central": "6mj,0,4j|||",
                "Indonesia_Eastern": "6mk,0,4j|||",
                "Indonesia_Western": "6ml,0,4j|||",
                "Iran": "45r,0,1l|45r,0,3t||",
                "Irkutsk": "3h,5,1l|3h,5,3t||",
                "Israel": "45q,0,1l|45q,0,3t||",
                "Japan": "45m,0,1l|45m,0,3t||",
                "Kamchatka": "37,5,3k,0,1l|37,5,3k,0,3t||",
                "Kazakhstan_Eastern": "6mp,0,4j|||",
                "Kazakhstan_Western": "6ms,0,4j|||",
                "Korea": "45k,0,1l|45k,0,3t||",
                "Kosrae": "6f,5,4j|||",
                "Krasnoyarsk": "41,5,1l|41,5,3t||",
                "Kyrgystan": "6mu,0,4j|||",
                "Lanka": "6mv,0,4j|||",
                "Line_Islands": "6n0,5,4j|||",
                "Lord_Howe": "1u,0,24,5,1l|1u,0,24,5,3t||",
                "Macau": "ip,5,1l|ip,5,3t||",
                "Macquarie": "6m,5,4j|||",
                "Magadan": "2o,5,1l|2o,5,3t||",
                "Malaysia": "6n2,0,4j|||",
                "Maldives": "6n3,0,4j|||",
                "Marquesas": "9e,5,4j|||",
                "Marshall_Islands": "6n4,5,4j|||",
                "Mauritius": "4u,5,1l|4u,5,3t||",
                "Mawson": "63,5,4j|||",
                "Mexico_Northwest": "45j,0,1l|45j,0,3t||",
                "Mexico_Pacific": "45i,0,2h,5,1l|45i,0,2h,5,3t||",
                "Mongolia": "4f,0,2m,5,1l|4f,0,2m,5,3t||",
                "Moscow": "45h,0,1l|45h,0,3t||",
                "Myanmar": "6n8,0,4j|||",
                "Nauru": "5v,5,4j|||",
                "Nepal": "6n9,0,4j|||",
                "New_Caledonia": "45d,0,1l|45d,0,3t||",
                "New_Zealand": "45c,0,1l|45c,0,3t||",
                "Newfoundland": "45b,0,1l|45b,0,3t||",
                "Niue": "8g,5,4j|||",
                "Norfolk": "6l,0,1f,5,4j|||",
                "Noronha": "1s,0,2,0,23,5,1l|1s,0,2,0,23,5,3t||",
                "North_Mariana": "6ng,5,4j|||",
                "Novosibirsk": "3b,0,1l|3b,0,3t||",
                "Omsk": "26,5,1l|26,5,3t||",
                "Pakistan": "459,0,1l|459,0,3t||",
                "Palau": "9b,5,1l|||",
                "Papua_New_Guinea": "9a,0,6nk,0,a8,5,4j|||",
                "Paraguay": "457,0,1l|457,0,3t||",
                "Peru": "456,0,1l|456,0,3t||",
                "Philippines": "454,0,1l|454,0,3t||",
                "Phoenix_Islands": "6nq,5,4j|||",
                "Pierre_Miquelon": "8i,0,33,5,0,u0,0,35,5,1l|8i,0,33,5,0,u0,0,35,5,3t||",
                "Pitcairn": "7e,5,4j|||",
                "Ponape": "9s,5,4j|||",
                "Pyongyang": "8a,5,4j|||",
                "Qyzylorda": "4d,5,1l|4d,5,3t||",
                "Reunion": "b4,5,4j|||",
                "Rothera": "5q,5,4j|||",
                "Sakhalin": "55,5,1l|55,5,3t||",
                "Samara": "29,5,1l|29,5,3t||",
                "Samoa": "2c,5,1l|2c,5,3t||",
                "Seychelles": "6nr,0,4j|||",
                "Singapore": "6nt,0,1l|||",
                "Solomon": "6o1,5,4j|||",
                "South_Georgia": "85,0,2u,5,4j|||",
                "Suriname": "mg,5,4j|||",
                "Syowa": "65,5,4j|||",
                "Tahiti": "6o4,0,4j|||",
                "Taipei": "3d,5,1l|3d,5,3t||",
                "Tajikistan": "6o6,0,4j|||",
                "Tokelau": "5d,5,4j|||",
                "Tonga": "44v,0,1l|44v,0,3t||",
                "Truk": "6p,5,4j|||",
                "Turkmenistan": "44u,0,1l|44u,0,3t||",
                "Tuvalu": "6h,5,4j|||",
                "Uruguay": "44t,0,1l|44t,0,3t||",
                "Uzbekistan": "44s,0,1l|44s,0,3t||",
                "Vanuatu": "2f,5,1l|2f,5,3t||",
                "Venezuela": "6oh,0,4j|||",
                "Vladivostok": "28,5,1l|28,5,3t||",
                "Volgograd": "3f,5,1l|3f,5,3t||",
                "Vostok": "5t,5,4j|||",
                "Wake": "6ok,5,4j|||",
                "Wallis": "5f,0,u0,0,5k,5,4j|||",
                "Yakutsk": "3u,5,1l|3u,5,3t||",
                "Yekaterinburg": "44r,0,1l|44r,0,3t||"
            }
        },
        "dav": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "de-AT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de-BE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de-CH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de-IT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de-LI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de-LU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "de": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2a8,0,1j||",
                "Europe/London": "|2a9,0,1j||"
            },
            "metazone": {
                "Acre": "3q,5,1k|3q,5,1j||",
                "Afghanistan": "b6,5,25|||",
                "Africa_Central": "26u,0,25|||",
                "Africa_Eastern": "26v,0,25|||",
                "Africa_Southern": "270,0,25|||",
                "Africa_Western": "1ac,0,1k|1ac,0,1j||",
                "Alaska": "3p,5,1k|3p,5,1j||",
                "Almaty": "56,5,1k|56,5,1j||",
                "Amazon": "bg,5,1k|bg,5,1j||",
                "America_Central": "on,0,178,5,1k|on,0,178,5,1j||",
                "America_Eastern": "on,0,179,5,1k|on,0,179,5,1j||",
                "America_Mountain": "145,0,5a,5,1k|145,5,5a,5,1j||",
                "America_Pacific": "on,0,17b,5,1k|on,0,17b,5,1j||",
                "Anadyr": "3l,0,1k|3l,0,1j||",
                "Apia": "3e,5,1k|3e,5,1j||",
                "Aqtau": "50,5,1k|50,5,1j||",
                "Aqtobe": "rs,5,1k|rs,5,1j||",
                "Arabian": "t0,0,1k|t0,0,1j||",
                "Argentina": "1ak,0,1k|1ak,0,1j||",
                "Argentina_Western": "1al,0,1k|1al,0,1j||",
                "Armenia": "1am,0,1k|1am,0,1j||",
                "Atlantic": "r2,5,1k|r2,5,1j||",
                "Australia_Central": "1an,0,1k|1an,0,1j||",
                "Australia_CentralWestern": "17e,5,1ap,0,1k|17e,5,1ap,0,1j||",
                "Australia_Eastern": "1aq,0,1k|1aq,0,1j||",
                "Australia_Western": "1ar,0,1k|1ar,0,1j||",
                "Azerbaijan": "271,0,1k|273,0,1j||",
                "Azores": "qv,5,1k|qv,5,1j||",
                "Bangladesh": "17i,5,1k|17i,5,1j||",
                "Bhutan": "as,5,25|||",
                "Bolivia": "275,0,25|||",
                "Brasilia": "in,5,1k|in,5,1j||",
                "Brunei": "9o,5,25|||",
                "Cape_Verde": "ck,5,3j,5,1k|ck,5,3j,5,1j||",
                "Casey": "b7,5,25|||",
                "Chamorro": "6j,5,25|||",
                "Chatham": "27,5,1k|27,5,1j||",
                "Chile": "1b1,0,1k|1b1,0,1j||",
                "China": "1b2,0,1k|1b2,0,1j||",
                "Choibalsan": "1b3,5,1k|1b3,5,1j||",
                "Christmas": "278,5,25|||",
                "Cocos": "279,5,25|||",
                "Colombia": "1b6,0,1k|1b6,0,1j||",
                "Cook": "1b7,5,1k|1b7,5,1j||",
                "Cuba": "1b8,0,1k|1b8,0,1j||",
                "Davis": "5s,5,25|||",
                "DumontDUrville": "5b,5,5j,5,25|||",
                "East_Timor": "22p,5,25|||",
                "Easter": "1ba,5,1k|1ba,5,1j||",
                "Ecuador": "27b,0,25|||",
                "Europe_Central": "1bc,0,1k|1bc,0,1j|1bd|1be",
                "Europe_Eastern": "1bf,0,1k|1bf,0,1j|1bg|1bh",
                "Europe_Further_Eastern": "27c,0,25|||",
                "Europe_Western": "1bj,0,1k|1bj,0,1j|1bk|1bl",
                "Falkland": "1bm,5,1k|1bm,5,1j||",
                "Fiji": "17p,5,1k|17p,5,1j||",
                "French_Guiana": "27d,5,qk,5,25|||",
                "French_Southern": "27e,0,22k,5,0,sv,0,27f,5,25|||",
                "Galapagos": "ak,5,25|||",
                "Gambier": "6v,5,25|||",
                "Georgia": "qb,0,1k|qb,0,1j||",
                "Gilbert_Islands": "6q,5,27g,5,25|||",
                "GMT": "27h,0,5u,5,25|||",
                "Greenland_Eastern": "183,5,1k|183,5,1j||",
                "Greenland_Western": "184,5,1k|184,5,1j||",
                "Guam": "83,5,25|||",
                "Gulf": "127,5,25|||",
                "Guyana": "7a,5,25|||",
                "Hawaii_Aleutian": "4g,5,185,5,1k|4g,5,185,5,1j||",
                "Hong_Kong": "qh,5,1k|qh,5,1j||",
                "Hovd": "1c4,5,1k|1c4,5,1j||",
                "India": "193,0,25|||",
                "Indian_Ocean": "27k,0,21v,5,25|||",
                "Indochina": "9p,5,25|||",
                "Indonesia_Central": "27l,0,25|||",
                "Indonesia_Eastern": "27m,0,25|||",
                "Indonesia_Western": "27n,0,25|||",
                "Iran": "1cb,0,1k|1cb,0,1j||",
                "Irkutsk": "3h,5,1k|3h,5,1j||",
                "Israel": "1cc,0,1k|1cc,0,1j||",
                "Japan": "1cd,0,1k|1cd,0,1j||",
                "Kamchatka": "18c,5,1k|18c,5,1j||",
                "Kazakhstan_Eastern": "27o,0,25|||",
                "Kazakhstan_Western": "27q,0,25|||",
                "Korea": "1ch,0,1k|1ch,0,1j||",
                "Kosrae": "6f,5,25|||",
                "Krasnoyarsk": "l0,5,1k|l0,5,1j||",
                "Kyrgystan": "21g,5,25|||",
                "Lanka": "me,5,9c,5,25|||",
                "Line_Islands": "27r,5,25|||",
                "Lord_Howe": "1u,5,24,5,1k|1u,5,24,5,1j||",
                "Macau": "57,5,1k|57,5,1j||",
                "Macquarie": "214,5,25|||",
                "Magadan": "2o,5,1k|2o,5,1j||",
                "Malaysia": "27u,0,25|||",
                "Maldives": "281,5,25|||",
                "Marquesas": "9e,5,25|||",
                "Marshall_Islands": "283,5,25|||",
                "Mauritius": "4u,5,1k|4u,5,1j||",
                "Mawson": "63,5,25|||",
                "Mexico_Northwest": "ro,0,1cn,0,1co,5,1k|ro,0,1cn,0,1co,5,1j||",
                "Mexico_Pacific": "ro,0,1cp,5,1k|ro,0,1cp,5,1j||",
                "Mongolia": "p2,5,1k|p2,5,1j||",
                "Moscow": "131,0,1k|131,0,1j||",
                "Myanmar": "8v,5,25|||",
                "Nauru": "5v,5,25|||",
                "Nepal": "284,0,25|||",
                "New_Caledonia": "1cs,0,1k|1cs,0,1j||",
                "New_Zealand": "1ct,5,1k|1ct,5,1j||",
                "Newfoundland": "1cu,5,1k|1cu,5,1j||",
                "Niue": "8g,5,25|||",
                "Norfolk": "285,5,25|||",
                "Noronha": "1s,0,2,0,23,5,1k|1s,0,2,0,23,5,1j||",
                "North_Mariana": "286,5,287,5,25|||",
                "Novosibirsk": "16c,5,1k|16c,5,1j||",
                "Omsk": "26,5,1k|26,5,1j||",
                "Pakistan": "1d3,0,1k|1d3,0,1j||",
                "Palau": "9b,5,25|||",
                "Papua_New_Guinea": "9a,5,289,5,25|||",
                "Paraguay": "1d5,0,1k|1d5,0,1j||",
                "Peru": "1d6,0,1k|1d6,0,1j||",
                "Philippines": "1d7,0,1k|1d7,0,1j||",
                "Phoenix_Islands": "28a,5,25|||",
                "Pierre_Miquelon": "8i,5,33,5,sv,5,35,5,1k|8i,5,33,5,sv,5,35,5,1j||",
                "Pitcairn": "28b,5,25|||",
                "Ponape": "9s,5,25|||",
                "Pyongyang": "28d,5,25|||",
                "Qyzylorda": "28e,5,1k|28g,5,1j||",
                "Reunion": "i8,5,25|||",
                "Rothera": "5q,5,25|||",
                "Sakhalin": "ph,5,1k|ph,5,1j||",
                "Samara": "29,5,1k|29,5,1j||",
                "Samoa": "2c,5,1k|2c,5,1j||",
                "Seychelles": "1vo,5,25|||",
                "Singapore": "m8,5,25|||",
                "Solomon": "28j,5,25|||",
                "South_Georgia": "28k,0,25|||",
                "Suriname": "8q,5,25|||",
                "Syowa": "65,5,25|||",
                "Tahiti": "8n,5,25|||",
                "Taipei": "1dg,5,1k|1dg,5,1j||",
                "Tajikistan": "1vl,5,25|||",
                "Tokelau": "5d,5,25|||",
                "Tonga": "1di,0,1k|1di,0,1j||",
                "Truk": "6p,5,25|||",
                "Turkmenistan": "4t,5,1k|4t,5,1j||",
                "Tuvalu": "6h,5,25|||",
                "Uruguay": "28l,0,1k|28m,0,1j||",
                "Uzbekistan": "14m,5,1k|14m,5,1j||",
                "Vanuatu": "2f,5,1k|2f,5,1j||",
                "Venezuela": "7s,5,25|||",
                "Vladivostok": "15m,5,1k|15m,5,1j||",
                "Volgograd": "qi,5,1k|qi,5,1j||",
                "Vostok": "1kt,5,25|||",
                "Wake": "5r,5,1vg,5,25|||",
                "Wallis": "5f,5,sv,5,5k,5,25|||",
                "Yakutsk": "qj,5,1k|qj,5,1j||",
                "Yekaterinburg": "q6,5,1k|q6,5,1j||"
            }
        },
        "dje": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "dsb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c9n,0,g9,0,7q||",
                "Europe/London": "|6mo,0,g9,0,7q||"
            },
            "metazone": {
                "Afghanistan": "brl,0,7q|||",
                "Africa_Central": "brk,0,7q|||",
                "Africa_Eastern": "brj,0,7q|||",
                "Africa_Southern": "bri,0,7q|||",
                "Africa_Western": "7aa,0,ad,0,7q|7aa,0,g9,0,7q||",
                "Alaska": "7af,0,ad,0,7q|7af,0,g9,0,7q||",
                "Amazon": "44m,0,ad,0,7q|44m,0,g9,0,7q||",
                "America_Central": "1ve,0,44l,0,ad,0,7q|1ve,0,44l,0,g9,0,7q||",
                "America_Eastern": "1ve,0,7aj,0,ad,0,7q|1ve,0,7aj,0,g9,0,7q||",
                "America_Mountain": "1ve,0,44j,0,ad,0,7q|1ve,0,44j,0,g9,0,7q||",
                "America_Pacific": "1ve,0,1vb,0,ad,0,7q|1ve,0,1vb,0,g9,0,7q||",
                "Apia": "44i,0,ad,0,7q|44i,0,g9,0,7q||",
                "Arabian": "7ao,0,ad,0,7q|7ao,0,g9,0,7q||",
                "Argentina": "2ed,0,ad,0,7q|2ed,0,g9,0,7q||",
                "Argentina_Western": "7aq,0,ad,0,7q|7aq,0,g9,0,7q||",
                "Armenia": "7ar,0,ad,0,7q|7ar,0,g9,0,7q||",
                "Atlantic": "7as,0,ad,0,7q|7as,0,g9,0,7q||",
                "Australia_Central": "7at,0,ad,0,7q|7at,0,g9,0,7q||",
                "Australia_CentralWestern": "7b1,0,44h,0,ad,0,7q|7b1,0,44h,0,g9,0,7q||",
                "Australia_Eastern": "7b3,0,ad,0,7q|7b3,0,g9,0,7q||",
                "Australia_Western": "7b4,0,ad,0,7q|7b4,0,g9,0,7q||",
                "Azerbaijan": "7b6,0,ad,0,7q|7b6,0,g9,0,7q||",
                "Azores": "7bb,0,ad,0,7q|7bb,0,g9,0,7q||",
                "Bangladesh": "7bc,0,ad,0,7q|7bc,0,g9,0,7q||",
                "Bhutan": "brh,0,7q|||",
                "Bolivia": "brg,0,7q|||",
                "Brasilia": "in,0,ad,0,7q|in,0,g9,0,7q||",
                "Brunei": "brf,0,7q|||",
                "Cape_Verde": "44b,0,ad,0,7q|44b,0,g9,0,7q||",
                "Chamorro": "bre,0,7q|||",
                "Chatham": "7ee,0,ad,0,7q|7ee,0,g9,0,7q||",
                "Chile": "7ef,0,ad,0,7q|7ef,0,g9,0,7q||",
                "China": "7eg,0,ad,0,7q|7eg,0,g9,0,7q||",
                "Choibalsan": "7ek,0,ad,0,7q|7ek,0,g9,0,7q||",
                "Christmas": "7q,0,brd,0,10v|||",
                "Cocos": "7q,0,7eq,0,10v|||",
                "Colombia": "7ev,0,ad,0,7q|7ev,0,g9,0,7q||",
                "Cook": "7f3,0,7q,0,445,0,10v|g9,0,7q,0,445,0,10v||",
                "Cuba": "7fc,0,ad,0,7q|7fc,0,g9,0,7q||",
                "Davis": "5s,0,7q|||",
                "DumontDUrville": "brc,0,7q|||",
                "East_Timor": "brb,0,7q|||",
                "Easter": "ad,0,7q,0,7fm,0,19r|g9,0,7q,0,7fm,0,19r||",
                "Ecuador": "bra,0,7q|||",
                "Europe_Central": "7g1,0,ad,0,7q|7g1,0,g9,0,7q|1bd|1be",
                "Europe_Eastern": "7g4,0,ad,0,7q|7g4,0,g9,0,7q|1bg|1bh",
                "Europe_Further_Eastern": "7g5,0,7q|||",
                "Europe_Western": "7ga,0,ad,0,7q|7ga,0,g9,0,7q|1bk|1bl",
                "Falkland": "7gr,0,ad,0,7q|7gr,0,g9,0,7q||",
                "Fiji": "7hf,0,ad,0,7q|7hf,0,g9,0,7q||",
                "French_Guiana": "br9,0,7q|||",
                "French_Southern": "7q,0,br8,0,br7,0,a6,0,7i9,0,br6|||",
                "Galapagos": "br5,0,7q|||",
                "Gambier": "7je,0,7q|||",
                "Georgia": "7jp,0,ad,0,7q|7jp,0,g9,0,7q||",
                "Gilbert_Islands": "7q,0,7kc,0,10v|||",
                "GMT": "7kd,0,7q|||",
                "Greenland_Eastern": "7ko,0,ad,0,7q|7ko,0,g9,0,7q||",
                "Greenland_Western": "7kq,0,ad,0,7q|7kq,0,g9,0,7q||",
                "Gulf": "7q,0,br4,0,7m8|||",
                "Guyana": "br3,0,7q|||",
                "Hawaii_Aleutian": "7o7,5,2eq,0,ad,0,7q|7o7,5,2eq,0,g9,0,7q||",
                "Hong_Kong": "43m,0,ad,0,7q|43m,0,g9,0,7q||",
                "Hovd": "43l,0,ad,0,7q|43l,0,g9,0,7q||",
                "India": "br2,0,7q|||",
                "Indian_Ocean": "br1,0,7q|||",
                "Indochina": "br0,0,7q|||",
                "Indonesia_Central": "bqv,0,7q|||",
                "Indonesia_Eastern": "bqu|||",
                "Indonesia_Western": "bqt,0,7q|||",
                "Iran": "7pa,0,ad,0,7q|7pa,0,g9,0,7q||",
                "Irkutsk": "1uo,0,ad,0,7q|1uo,0,g9,0,7q||",
                "Israel": "7pd,0,ad,0,7q|7pd,0,g9,0,7q||",
                "Japan": "7pi,0,ad,0,7q|7pi,0,g9,0,7q||",
                "Kazakhstan_Eastern": "bqs,0,7q|||",
                "Kazakhstan_Western": "bqr,0,7q|||",
                "Korea": "43a,0,ad,0,7q|43a,0,g9,0,7q||",
                "Kosrae": "bqq,0,7q|||",
                "Krasnoyarsk": "1un,0,ad,0,7q|1un,0,g9,0,7q||",
                "Kyrgystan": "bqp,0,7q|||",
                "Line_Islands": "7q,0,7qh,0,10v|||",
                "Lord_Howe": "7f3,0,7q,0,19r,0,1u,5,24|g9,0,7q,0,19r,0,1u,5,24||",
                "Macquarie": "7q,0,19r,0,6m|||",
                "Magadan": "7qi,0,ad,0,7q|7qi,0,g9,0,7q||",
                "Malaysia": "bqo,0,7q|||",
                "Maldives": "bqn,0,7q|||",
                "Marquesas": "bqm,0,7q|||",
                "Marshall_Islands": "7q,0,7r5,0,10v|||",
                "Mauritius": "7ra,0,ad,0,7q|7ra,0,g9,0,7q||",
                "Mawson": "63,0,7q|||",
                "Mexico_Northwest": "424,0,7rd,0,ad,0,7q|424,0,7rd,0,g9,0,7q||",
                "Mexico_Pacific": "424,0,1vb,0,ad,0,7q|424,0,1vb,0,g9,0,7q||",
                "Mongolia": "4f,5,41m,0,ad,0,7q|4f,5,41m,0,g9,0,7q||",
                "Moscow": "41h,0,ad,0,7q|41h,0,g9,0,7q||",
                "Myanmar": "bql,0,7q|||",
                "Nauru": "bqk,0,7q|||",
                "Nepal": "7rs,0,7q|||",
                "New_Caledonia": "7rv,0,ad,0,7q|7rv,0,g9,0,7q||",
                "New_Zealand": "7s0,0,ad,0,7q|7s0,0,g9,0,7q||",
                "Newfoundland": "7s1,0,ad,0,7q|7s1,0,g9,0,7q||",
                "Niue": "bqj,0,7q|||",
                "Norfolk": "7q,0,19r,0,6l|||",
                "Noronha": "ad,0,7q,0,1s,0,2,0,23|g9,0,7q,0,1s,0,2,0,23||",
                "Novosibirsk": "414,0,ad,0,7q|414,0,g9,0,7q||",
                "Omsk": "1ug,0,ad,0,7q|1ug,0,g9,0,7q||",
                "Pakistan": "7se,0,ad,0,7q|7se,0,g9,0,7q||",
                "Palau": "bqi,0,7q|||",
                "Papua_New_Guinea": "9a,5,bqh,0,7q|||",
                "Paraguay": "40k,0,ad,0,7q|40k,0,g9,0,7q||",
                "Peru": "7sm,0,ad,0,7q|7sm,0,g9,0,7q||",
                "Philippines": "40e,0,ad,0,7q|40e,0,g9,0,7q||",
                "Phoenix_Islands": "7q,0,7su,0,10v|||",
                "Pierre_Miquelon": "7u,5,33,5,a6,5,7tl,0,ad,0,7q|7u,5,33,5,a6,5,7tl,0,g9,0,7q||",
                "Pitcairn": "7q,0,7tn,0,10v|||",
                "Ponape": "7u1,0,7q|||",
                "Reunion": "7u7,0,7q|||",
                "Rothera": "7q,0,5q|||",
                "Sakhalin": "7uv,0,ad,0,7q|7uv,0,g9,0,7q||",
                "Samoa": "7v3,0,ad,0,7q|7v3,0,g9,0,7q||",
                "Seychelles": "bqg,0,7q|||",
                "Singapore": "4j2,0,7q|||",
                "Solomon": "bqf,0,7q|||",
                "South_Georgia": "bqe,0,7q|||",
                "Suriname": "81u,0,7q|||",
                "Syowa": "65,0,7q|||",
                "Tahiti": "bqd,0,7q|||",
                "Taipei": "83g,0,ad,0,7q|83g,0,g9,0,7q||",
                "Tajikistan": "bqc,0,7q|||",
                "Tokelau": "bqb,0,7q|||",
                "Tonga": "840,0,ad,0,7q|840,0,g9,0,7q||",
                "Truk": "bqa,0,7q|||",
                "Turkmenistan": "861,0,ad,0,7q|861,0,g9,0,7q||",
                "Tuvalu": "bq9,0,7q|||",
                "Uruguay": "86c,0,ad,0,7q|86c,0,g9,0,7q||",
                "Uzbekistan": "86u,0,ad,0,7q|86u,0,g9,0,7q||",
                "Vanuatu": "872,0,ad,0,7q|872,0,g9,0,7q||",
                "Venezuela": "87d,0,7q|||",
                "Vladivostok": "403,0,ad,0,7q|403,0,g9,0,7q||",
                "Volgograd": "401,0,ad,0,7q|401,0,g9,0,7q||",
                "Vostok": "7q,0,1kt|||",
                "Wake": "7q,0,19r,0,5r|||",
                "Wallis": "7q,0,10v,0,5f,0,a6,0,5k|||",
                "Yakutsk": "1u5,0,ad,0,7q|1u5,0,g9,0,7q||",
                "Yekaterinburg": "3vt,0,ad,0,7q|3vt,0,g9,0,7q||"
            }
        },
        "dua": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "dyo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "dz": {
            "gmtFormat": "ཇི་ཨེམ་ཏི་{0}",
            "gmtZeroFormat": "ཇི་ཨེམ་ཊི་",
            "zone": {
                "Europe/Dublin": "|c9p||",
                "Europe/London": "|c9q||"
            },
            "metazone": {
                "Afghanistan": "bq8|||",
                "Africa_Central": "bq7|||",
                "Africa_Eastern": "bq6|||",
                "Africa_Southern": "bq5|||",
                "Africa_Western": "bq4|bq3||",
                "Alaska": "bq2|bq1||",
                "Amazon": "bq0|bpv||",
                "America_Central": "bpu|bpt||",
                "America_Eastern": "bps|bpr||",
                "America_Mountain": "bpq|bpp||",
                "America_Pacific": "bpo|bpn||",
                "Arabian": "bpm|bpl||",
                "Argentina": "bpk|bpj||",
                "Argentina_Western": "bpi|bph||",
                "Armenia": "bpg|bpf||",
                "Atlantic": "bpe|bpd||",
                "Australia_Central": "bpc|bpb||",
                "Australia_CentralWestern": "bpa|bp9||",
                "Australia_Eastern": "bp8|bp7||",
                "Australia_Western": "bp6|bp5||",
                "Azerbaijan": "bp4|bp3||",
                "Azores": "bp2|bp1||",
                "Bangladesh": "bp0|bov||",
                "Bhutan": "bou|||",
                "Bolivia": "bot|||",
                "Brasilia": "bos|bor||",
                "Cape_Verde": "boq|bop||",
                "Chile": "boo|bon||",
                "China": "bom|bol||",
                "Christmas": "bok|||",
                "Colombia": "boj|boi||",
                "Cuba": "boh|bog||",
                "Easter": "bof|boe||",
                "Ecuador": "bod|||",
                "Europe_Central": "boc|bob||",
                "Europe_Eastern": "boa|bo9||",
                "Europe_Western": "bo8|bo7||",
                "Falkland": "bo6|bo5||",
                "French_Guiana": "bo4|||",
                "Galapagos": "bo3|||",
                "Georgia": "bo2|bo1||",
                "GMT": "bo0|||",
                "Greenland_Eastern": "bnv|bnu||",
                "Greenland_Western": "bnt|bns||",
                "Gulf": "bnr|||",
                "Guyana": "bnq|||",
                "Hawaii_Aleutian": "4sc,5,bnp|4sc,5,bno||",
                "India": "bnn|||",
                "Indian_Ocean": "bnm|||",
                "Indochina": "bnl|||",
                "Indonesia_Central": "bnk|||",
                "Indonesia_Eastern": "bnj|||",
                "Indonesia_Western": "bni|||",
                "Iran": "bnh|bng||",
                "Irkutsk": "bnf|bne||",
                "Israel": "bnd|bnc||",
                "Japan": "bnb|bna||",
                "Korea": "bn9|bn8||",
                "Krasnoyarsk": "bn7|bn6||",
                "Magadan": "bn5|bn4||",
                "Maldives": "bn3|||",
                "Mauritius": "bn2|bn1||",
                "Moscow": "bn0|bmv||",
                "Nepal": "bmu|||",
                "New_Zealand": "bmt|bms||",
                "Newfoundland": "bmr|bmq||",
                "Noronha": "4uo,0,4up,0,bmp|4uo,0,4up,0,bmo||",
                "Novosibirsk": "bmn|bmm||",
                "Omsk": "bmi|bmh||",
                "Pakistan": "bmg|bmf||",
                "Paraguay": "bme|bmd||",
                "Peru": "bmc|bmb||",
                "Pierre_Miquelon": "bma|bm9||",
                "Reunion": "bm8|||",
                "Sakhalin": "bm7|bm6||",
                "Seychelles": "bm2|||",
                "Suriname": "bm1|||",
                "Uruguay": "blv|blr||",
                "Venezuela": "blq|||",
                "Vladivostok": "blp|bln||",
                "Volgograd": "blm|bll||",
                "Yakutsk": "blk|blj||",
                "Yekaterinburg": "bli|blh||"
            }
        },
        "ebu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ee-TG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Africa_Central": "1ah,0,c5,0,mr||vj|",
                "Africa_Eastern": "1ad,0,1t,0,mr||vp|",
                "Africa_Southern": "510,0,1t,0,mr||vu|",
                "Africa_Western": "1ii,0,c5,0,pt|1ii,0,1t,0,qm,0,mr|103|vq",
                "America_Central": "1ah,0,14n,0,pt|1ah,0,14n,0,qm,0,mr||",
                "America_Eastern": "1ad,0,14n,0,pt|1ad,0,14n,0,qm,0,mr||",
                "America_Mountain": "14n,0,3r6,0,3r3,0,pt|14n,0,3r6,0,3r3,0,3r2,0,mr||",
                "America_Pacific": "2h,0,pt|2h,0,3r2,0,mr||",
                "Arabian": "hs,0,pt|hs,0,qm,0,mr||",
                "Atlantic": "6g,0,pt|6g,0,qm,0,mr||",
                "Australia_Central": "1ah,0,4c,0,pt|1ah,0,4c,0,qm,0,mr||",
                "Australia_CentralWestern": "4c,0,3r1,0,pt|4c,0,3r1,0,qm,0,mr||",
                "Australia_Eastern": "1ad,0,4c,0,pt|1ad,0,4c,0,qm,0,mr||",
                "Australia_Western": "1ii,0,4c,0,pt|1ii,0,4c,0,qm,0,mr||",
                "China": "4h,0,pt|4h,0,qm,0,mr||",
                "Europe_Central": "1ah,0,r4,0,pt|1ah,0,r4,0,qm,0,mr||",
                "Europe_Eastern": "1ad,0,r4,0,pt|1ad,0,r4,0,qm,0,mr||",
                "Europe_Western": "1ii,0,r4,0,pt|1ii,0,r4,0,qm,0,mr||",
                "GMT": "5u,0,mr|||",
                "Israel": "4e,0,pt|4e,0,qm,0,mr||",
                "Japan": "6o,0,51e|6o,0,qm,0,mr||",
                "Korea": "qf,0,pt|qf,0,qm,0,mr||",
                "Moscow": "71,0,pt|71,0,qm,0,mr||",
                "Suriname": "8q,0,mr|||"
            }
        },
        "ee": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Africa_Central": "1ah,0,c5,0,mr||vj|",
                "Africa_Eastern": "1ad,0,1t,0,mr||vp|",
                "Africa_Southern": "510,0,1t,0,mr||vu|",
                "Africa_Western": "1ii,0,c5,0,pt|1ii,0,1t,0,qm,0,mr|103|vq",
                "America_Central": "1ah,0,14n,0,pt|1ah,0,14n,0,qm,0,mr||",
                "America_Eastern": "1ad,0,14n,0,pt|1ad,0,14n,0,qm,0,mr||",
                "America_Mountain": "14n,0,3r6,0,3r3,0,pt|14n,0,3r6,0,3r3,0,3r2,0,mr||",
                "America_Pacific": "2h,0,pt|2h,0,3r2,0,mr||",
                "Arabian": "hs,0,pt|hs,0,qm,0,mr||",
                "Atlantic": "6g,0,pt|6g,0,qm,0,mr||",
                "Australia_Central": "1ah,0,4c,0,pt|1ah,0,4c,0,qm,0,mr||",
                "Australia_CentralWestern": "4c,0,3r1,0,pt|4c,0,3r1,0,qm,0,mr||",
                "Australia_Eastern": "1ad,0,4c,0,pt|1ad,0,4c,0,qm,0,mr||",
                "Australia_Western": "1ii,0,4c,0,pt|1ii,0,4c,0,qm,0,mr||",
                "China": "4h,0,pt|4h,0,qm,0,mr||",
                "Europe_Central": "1ah,0,r4,0,pt|1ah,0,r4,0,qm,0,mr||",
                "Europe_Eastern": "1ad,0,r4,0,pt|1ad,0,r4,0,qm,0,mr||",
                "Europe_Western": "1ii,0,r4,0,pt|1ii,0,r4,0,qm,0,mr||",
                "GMT": "5u,0,mr|||",
                "Israel": "4e,0,pt|4e,0,qm,0,mr||",
                "Japan": "6o,0,51e|6o,0,qm,0,mr||",
                "Korea": "qf,0,pt|qf,0,qm,0,mr||",
                "Moscow": "71,0,pt|71,0,qm,0,mr||",
                "Suriname": "8q,0,mr|||"
            }
        },
        "el-CY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|a2,0,46,0,6mn||",
                "Europe/London": "|a2,0,46,0,6me||"
            },
            "metazone": {
                "Afghanistan": "at,0,51j|||",
                "Africa_Central": "at,0,1it,0,1n4|||",
                "Africa_Eastern": "at,0,15v,0,1n4|||",
                "Africa_Southern": "a7,0,46,0,3qu,0,1n4|||",
                "Africa_Western": "a7,0,46,0,128,0,1n4|a2,0,46,0,128,0,1n4||",
                "Alaska": "a7,0,46,0,3qs|a2,0,46,0,3qs||",
                "Amazon": "a7,0,46,0,3qr|a2,0,46,0,3qr||",
                "America_Central": "3qq,0,1ra,0,46,0,182,0,186|3qq,0,1r9,0,46,0,182,0,186||",
                "America_Eastern": "3qp,0,1ra,0,46,0,182,0,186|3qp,0,1r9,0,46,0,182,0,186||",
                "America_Mountain": "3ql,0,1ra,0,46,0,182,0,186|3ql,0,1r9,0,46,0,182,0,186||",
                "America_Pacific": "a7,0,46,0,182,0,186|a2,0,46,0,182,0,186||",
                "Anadyr": "a7,0,46,0,3qi|a2,0,46,0,3qi||",
                "Apia": "a7,0,46,0,3qh|a2,0,46,0,3qh||",
                "Arabian": "3qg,0,1ra,0,46|3qg,0,1r9,0,46||",
                "Argentina": "a7,0,46,0,1r0|a2,0,46,0,1r0||",
                "Argentina_Western": "a7,0,46,0,128,0,1r0|a2,0,46,0,128,0,1r0||",
                "Armenia": "a7,0,46,0,3q8|a2,0,46,0,3q8||",
                "Atlantic": "a7,0,46,0,3q5|a2,0,46,0,3q5||",
                "Australia_Central": "a7,0,46,0,1it,0,17d|a2,0,46,0,1it,0,17d||",
                "Australia_CentralWestern": "a7,0,46,0,3q3,0,17d|a2,0,46,0,3q3,0,17d||",
                "Australia_Eastern": "a7,0,46,0,15v,0,17d|a2,0,46,0,15v,0,17d||",
                "Australia_Western": "a7,0,46,0,128,0,17d|a2,0,46,0,128,0,17d||",
                "Azerbaijan": "a7,0,46,0,3q1|a2,0,46,0,3q1||",
                "Azores": "a7,0,46,0,3q0|a2,0,46,0,3q0||",
                "Bangladesh": "a7,0,46,0,3pv|a2,0,46,0,3pv||",
                "Bhutan": "at,0,53j|||",
                "Bolivia": "at,0,53k|||",
                "Brasilia": "a7,0,46,0,3pt|a2,0,46,0,3pt||",
                "Brunei": "at,0,53p,0,53q|||",
                "Cape_Verde": "a7,0,46,0,3ps,0,3pn|a2,0,46,0,3ps,0,3pn||",
                "Chamorro": "at,0,53v|||",
                "Chatham": "a7,0,46,0,3pm|a2,0,46,0,3pm||",
                "Chile": "a7,0,46,0,3pl|a2,0,46,0,3pl||",
                "China": "a7,0,46,0,3pk|a2,0,46,0,3pk||",
                "Choibalsan": "a7,0,46,0,3pj|a2,0,46,0,3pj||",
                "Christmas": "at,0,1o6,0,548|||",
                "Cocos": "at,0,121,0,54d|||",
                "Colombia": "a7,0,46,0,3pi|a2,0,46,0,3pi||",
                "Cook": "a7,0,46,0,121,0,3ph|a2,0,46,0,121,0,3ph||",
                "Cuba": "a7,0,46,0,3pg|a2,0,46,0,3pg||",
                "Davis": "at,0,54r|||",
                "DumontDUrville": "at,0,54u,0,550|||",
                "East_Timor": "at,0,3pf,0,553|||",
                "Easter": "a7,0,46,0,1o6,0,3pe|a2,0,46,0,1o6,0,3pe||",
                "Ecuador": "at,0,556|||",
                "Europe_Central": "a7,0,46,0,1it,0,1a5|a2,0,46,0,1it,0,1a5|h0|h4",
                "Europe_Eastern": "a7,0,46,0,15v,0,1a5|a2,0,46,0,15v,0,1a5|gu|gv",
                "Europe_Further_Eastern": "at,0,559,0,15v,0,1a5|||",
                "Europe_Western": "a7,0,46,0,128,0,1a5|a2,0,46,0,128,0,1a5|h1|h2",
                "Falkland": "a7,0,46,0,121,0,3pd|a2,0,46,0,121,0,3pd||",
                "Fiji": "a7,0,46,0,3pc|a2,0,46,0,3pc||",
                "French_Guiana": "at,0,55i,0,3pb|||",
                "French_Southern": "at,0,567,0,56b,0,247,0,577|||",
                "Galapagos": "at,0,57a|||",
                "Gambier": "at,0,57k|||",
                "Georgia": "a7,0,46,0,2lg|a2,0,46,0,2lg||",
                "Gilbert_Islands": "at,0,121,0,57m|||",
                "GMT": "57q,0,46,0,57s|||",
                "Greenland_Eastern": "a7,0,46,0,15v,0,23s|a2,0,46,0,15v,0,23s||",
                "Greenland_Western": "a7,0,46,0,128,0,23s|a2,0,46,0,128,0,23s||",
                "Guam": "at,0,585|||",
                "Gulf": "at,0,586|||",
                "Guyana": "at,0,3pb|||",
                "Hawaii_Aleutian": "a7,0,46,0,3pa,5,3p9,0,3p8|a2,0,46,0,3pa,5,3p9,0,3p8||",
                "Hong_Kong": "a7,0,46,0,3p7,0,3p6|a2,0,46,0,3p7,0,3p6||",
                "Hovd": "a7,0,46,0,3p5|a2,0,46,0,3p5||",
                "India": "at,0,58m|||",
                "Indian_Ocean": "at,0,58q,0,590|||",
                "Indochina": "at,0,591|||",
                "Indonesia_Central": "at,0,1it,0,2lh|||",
                "Indonesia_Eastern": "at,0,15v,0,2lh|||",
                "Indonesia_Western": "at,0,128,0,2lh|||",
                "Iran": "a7,0,46,0,3p4|a2,0,46,0,3p4||",
                "Irkutsk": "a7,0,46,0,3p3|a2,0,46,0,3p3||",
                "Israel": "a7,0,46,0,3p2|a2,0,46,0,3p2||",
                "Japan": "a7,0,46,0,3p1|a2,0,46,0,3p1||",
                "Kamchatka": "a7,0,46,0,3ov,5,3ou|a2,0,46,0,3ov,5,3ou||",
                "Kazakhstan_Eastern": "at,0,3pf,0,3ot|||",
                "Kazakhstan_Western": "at,0,59h,0,3ot|||",
                "Korea": "a7,0,46,0,3or|a2,0,46,0,3or||",
                "Kosrae": "at,0,59o|||",
                "Krasnoyarsk": "a7,0,46,0,3oq|a2,0,46,0,3oq||",
                "Kyrgystan": "at,0,5a5|||",
                "Line_Islands": "at,0,121,0,5ac|||",
                "Lord_Howe": "a7,0,46,0,3op,0,3oo|a2,0,46,0,3op,0,3oo||",
                "Macau": "a7,0,46,0,3on|a2,0,46,0,3on||",
                "Macquarie": "at,0,1o6,0,5au|||",
                "Magadan": "a7,0,46,0,3om|a2,0,46,0,3om||",
                "Malaysia": "at,0,5b6|||",
                "Maldives": "at,0,5b7|||",
                "Marquesas": "at,0,5be|||",
                "Marshall_Islands": "at,0,121,0,5bf|||",
                "Mauritius": "a7,0,46,0,3ol|a2,0,46,0,3ol||",
                "Mawson": "at,0,5br|||",
                "Mexico_Northwest": "a7,0,46,0,3ok,0,1vk|a2,0,46,0,3ok,0,1vk||",
                "Mexico_Pacific": "a7,0,46,0,3oj,0,1vk|a2,0,46,0,3oj,0,1vk||",
                "Mongolia": "a7,0,46,0,3oi,0,3oh|a2,0,46,0,3oi,0,3oh||",
                "Moscow": "a7,0,46,0,3og|a2,0,46,0,3og||",
                "Myanmar": "at,0,5ce|||",
                "Nauru": "at,0,5cl|||",
                "Nepal": "at,0,5cp|||",
                "New_Caledonia": "a7,0,46,0,1gs,0,3oe|a2,0,46,0,1gs,0,3oe||",
                "New_Zealand": "a7,0,46,0,1gs,0,3oc|a2,0,46,0,1gs,0,3oc||",
                "Newfoundland": "a7,0,46,0,1gs,0,3ob|a2,0,46,0,1gs,0,3ob||",
                "Niue": "at,0,5db|||",
                "Norfolk": "at,0,121,0,5dc|||",
                "Noronha": "a7,0,46,0,3oa,0,3o9,0,3o7|a2,0,46,0,3oa,0,3o9,0,3o7||",
                "North_Mariana": "at,0,121,0,5dh,0,5e4|||",
                "Novosibirsk": "a7,0,46,0,3o5|a2,0,46,0,3o5||",
                "Omsk": "a7,0,46,0,3o4|a2,0,46,0,3o4||",
                "Pakistan": "a7,0,46,0,3o3|a2,0,46,0,3o3||",
                "Palau": "at,0,5e9|||",
                "Papua_New_Guinea": "at,0,5ea,0,5eb,0,5ee|||",
                "Paraguay": "a7,0,46,0,3nu|a2,0,46,0,3nu||",
                "Peru": "a7,0,46,0,3ns|a2,0,46,0,3ns||",
                "Philippines": "a7,0,46,0,3nr|a2,0,46,0,3nr||",
                "Phoenix_Islands": "at,0,121,0,5f7|||",
                "Pierre_Miquelon": "a7,0,46,0,3nn,0,3nj,0,247,0,3nf|a2,0,46,0,3nn,0,3nj,0,247,0,3nf||",
                "Pitcairn": "at,0,5g6|||",
                "Ponape": "at,0,5gi|||",
                "Pyongyang": "at,0,5h8|||",
                "Reunion": "at,0,5he|||",
                "Rothera": "at,0,5hg|||",
                "Sakhalin": "a7,0,46,0,3ne|a2,0,46,0,3ne||",
                "Samara": "a7,0,46,0,5hu|a2,0,46,0,5i2||",
                "Samoa": "a7,0,46,0,3nc|a2,0,46,0,3nc||",
                "Seychelles": "at,0,5ih|||",
                "Singapore": "at,0,5ii|||",
                "Solomon": "at,0,121,0,5j7|||",
                "South_Georgia": "at,0,3qu,0,2lg|||",
                "Suriname": "at,0,5j8|||",
                "Syowa": "at,0,5j9|||",
                "Tahiti": "at,0,5ja|||",
                "Taipei": "a7,0,46,0,3nb|a2,0,46,0,3nb||",
                "Tajikistan": "at,0,5jc|||",
                "Tokelau": "at,0,5jd|||",
                "Tonga": "a7,0,46,0,3n8|a2,0,46,0,3n8||",
                "Truk": "at,0,5ji|||",
                "Turkmenistan": "a7,0,46,0,3n7|a2,0,46,0,3n7||",
                "Tuvalu": "at,0,5jl|||",
                "Uruguay": "a7,0,46,0,3n2|a2,0,46,0,3n2||",
                "Uzbekistan": "a7,0,46,0,3n0|a2,0,46,0,3n0||",
                "Vanuatu": "a7,0,46,0,3mv|a2,0,46,0,3mv||",
                "Venezuela": "at,0,5jq|||",
                "Vladivostok": "a7,0,46,0,3mt|a2,0,46,0,3mt||",
                "Volgograd": "a7,0,46,0,3ms|a2,0,46,0,3ms||",
                "Vostok": "at,0,5jv|||",
                "Wake": "at,0,1o6,0,5k0|||",
                "Wallis": "at,0,5k2,0,247,0,5k3|||",
                "Yakutsk": "a7,0,46,0,3mp|a2,0,46,0,3mp||",
                "Yekaterinburg": "a7,0,46,0,3mo|a2,0,46,0,3mo||"
            }
        },
        "el": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|a2,0,46,0,6mn||",
                "Europe/London": "|a2,0,46,0,6me||"
            },
            "metazone": {
                "Afghanistan": "at,0,51j|||",
                "Africa_Central": "at,0,1it,0,1n4|||",
                "Africa_Eastern": "at,0,15v,0,1n4|||",
                "Africa_Southern": "a7,0,46,0,3qu,0,1n4|||",
                "Africa_Western": "a7,0,46,0,128,0,1n4|a2,0,46,0,128,0,1n4||",
                "Alaska": "a7,0,46,0,3qs|a2,0,46,0,3qs||",
                "Amazon": "a7,0,46,0,3qr|a2,0,46,0,3qr||",
                "America_Central": "3qq,0,1ra,0,46,0,182,0,186|3qq,0,1r9,0,46,0,182,0,186||",
                "America_Eastern": "3qp,0,1ra,0,46,0,182,0,186|3qp,0,1r9,0,46,0,182,0,186||",
                "America_Mountain": "3ql,0,1ra,0,46,0,182,0,186|3ql,0,1r9,0,46,0,182,0,186||",
                "America_Pacific": "a7,0,46,0,182,0,186|a2,0,46,0,182,0,186||",
                "Anadyr": "a7,0,46,0,3qi|a2,0,46,0,3qi||",
                "Apia": "a7,0,46,0,3qh|a2,0,46,0,3qh||",
                "Arabian": "3qg,0,1ra,0,46|3qg,0,1r9,0,46||",
                "Argentina": "a7,0,46,0,1r0|a2,0,46,0,1r0||",
                "Argentina_Western": "a7,0,46,0,128,0,1r0|a2,0,46,0,128,0,1r0||",
                "Armenia": "a7,0,46,0,3q8|a2,0,46,0,3q8||",
                "Atlantic": "a7,0,46,0,3q5|a2,0,46,0,3q5||",
                "Australia_Central": "a7,0,46,0,1it,0,17d|a2,0,46,0,1it,0,17d||",
                "Australia_CentralWestern": "a7,0,46,0,3q3,0,17d|a2,0,46,0,3q3,0,17d||",
                "Australia_Eastern": "a7,0,46,0,15v,0,17d|a2,0,46,0,15v,0,17d||",
                "Australia_Western": "a7,0,46,0,128,0,17d|a2,0,46,0,128,0,17d||",
                "Azerbaijan": "a7,0,46,0,3q1|a2,0,46,0,3q1||",
                "Azores": "a7,0,46,0,3q0|a2,0,46,0,3q0||",
                "Bangladesh": "a7,0,46,0,3pv|a2,0,46,0,3pv||",
                "Bhutan": "at,0,53j|||",
                "Bolivia": "at,0,53k|||",
                "Brasilia": "a7,0,46,0,3pt|a2,0,46,0,3pt||",
                "Brunei": "at,0,53p,0,53q|||",
                "Cape_Verde": "a7,0,46,0,3ps,0,3pn|a2,0,46,0,3ps,0,3pn||",
                "Chamorro": "at,0,53v|||",
                "Chatham": "a7,0,46,0,3pm|a2,0,46,0,3pm||",
                "Chile": "a7,0,46,0,3pl|a2,0,46,0,3pl||",
                "China": "a7,0,46,0,3pk|a2,0,46,0,3pk||",
                "Choibalsan": "a7,0,46,0,3pj|a2,0,46,0,3pj||",
                "Christmas": "at,0,1o6,0,548|||",
                "Cocos": "at,0,121,0,54d|||",
                "Colombia": "a7,0,46,0,3pi|a2,0,46,0,3pi||",
                "Cook": "a7,0,46,0,121,0,3ph|a2,0,46,0,121,0,3ph||",
                "Cuba": "a7,0,46,0,3pg|a2,0,46,0,3pg||",
                "Davis": "at,0,54r|||",
                "DumontDUrville": "at,0,54u,0,550|||",
                "East_Timor": "at,0,3pf,0,553|||",
                "Easter": "a7,0,46,0,1o6,0,3pe|a2,0,46,0,1o6,0,3pe||",
                "Ecuador": "at,0,556|||",
                "Europe_Central": "a7,0,46,0,1it,0,1a5|a2,0,46,0,1it,0,1a5|h0|h4",
                "Europe_Eastern": "a7,0,46,0,15v,0,1a5|a2,0,46,0,15v,0,1a5|gu|gv",
                "Europe_Further_Eastern": "at,0,559,0,15v,0,1a5|||",
                "Europe_Western": "a7,0,46,0,128,0,1a5|a2,0,46,0,128,0,1a5|h1|h2",
                "Falkland": "a7,0,46,0,121,0,3pd|a2,0,46,0,121,0,3pd||",
                "Fiji": "a7,0,46,0,3pc|a2,0,46,0,3pc||",
                "French_Guiana": "at,0,55i,0,3pb|||",
                "French_Southern": "at,0,567,0,56b,0,247,0,577|||",
                "Galapagos": "at,0,57a|||",
                "Gambier": "at,0,57k|||",
                "Georgia": "a7,0,46,0,2lg|a2,0,46,0,2lg||",
                "Gilbert_Islands": "at,0,121,0,57m|||",
                "GMT": "57q,0,46,0,57s|||",
                "Greenland_Eastern": "a7,0,46,0,15v,0,23s|a2,0,46,0,15v,0,23s||",
                "Greenland_Western": "a7,0,46,0,128,0,23s|a2,0,46,0,128,0,23s||",
                "Guam": "at,0,585|||",
                "Gulf": "at,0,586|||",
                "Guyana": "at,0,3pb|||",
                "Hawaii_Aleutian": "a7,0,46,0,3pa,5,3p9,0,3p8|a2,0,46,0,3pa,5,3p9,0,3p8||",
                "Hong_Kong": "a7,0,46,0,3p7,0,3p6|a2,0,46,0,3p7,0,3p6||",
                "Hovd": "a7,0,46,0,3p5|a2,0,46,0,3p5||",
                "India": "at,0,58m|||",
                "Indian_Ocean": "at,0,58q,0,590|||",
                "Indochina": "at,0,591|||",
                "Indonesia_Central": "at,0,1it,0,2lh|||",
                "Indonesia_Eastern": "at,0,15v,0,2lh|||",
                "Indonesia_Western": "at,0,128,0,2lh|||",
                "Iran": "a7,0,46,0,3p4|a2,0,46,0,3p4||",
                "Irkutsk": "a7,0,46,0,3p3|a2,0,46,0,3p3||",
                "Israel": "a7,0,46,0,3p2|a2,0,46,0,3p2||",
                "Japan": "a7,0,46,0,3p1|a2,0,46,0,3p1||",
                "Kamchatka": "a7,0,46,0,3ov,5,3ou|a2,0,46,0,3ov,5,3ou||",
                "Kazakhstan_Eastern": "at,0,3pf,0,3ot|||",
                "Kazakhstan_Western": "at,0,59h,0,3ot|||",
                "Korea": "a7,0,46,0,3or|a2,0,46,0,3or||",
                "Kosrae": "at,0,59o|||",
                "Krasnoyarsk": "a7,0,46,0,3oq|a2,0,46,0,3oq||",
                "Kyrgystan": "at,0,5a5|||",
                "Line_Islands": "at,0,121,0,5ac|||",
                "Lord_Howe": "a7,0,46,0,3op,0,3oo|a2,0,46,0,3op,0,3oo||",
                "Macau": "a7,0,46,0,3on|a2,0,46,0,3on||",
                "Macquarie": "at,0,1o6,0,5au|||",
                "Magadan": "a7,0,46,0,3om|a2,0,46,0,3om||",
                "Malaysia": "at,0,5b6|||",
                "Maldives": "at,0,5b7|||",
                "Marquesas": "at,0,5be|||",
                "Marshall_Islands": "at,0,121,0,5bf|||",
                "Mauritius": "a7,0,46,0,3ol|a2,0,46,0,3ol||",
                "Mawson": "at,0,5br|||",
                "Mexico_Northwest": "a7,0,46,0,3ok,0,1vk|a2,0,46,0,3ok,0,1vk||",
                "Mexico_Pacific": "a7,0,46,0,3oj,0,1vk|a2,0,46,0,3oj,0,1vk||",
                "Mongolia": "a7,0,46,0,3oi,0,3oh|a2,0,46,0,3oi,0,3oh||",
                "Moscow": "a7,0,46,0,3og|a2,0,46,0,3og||",
                "Myanmar": "at,0,5ce|||",
                "Nauru": "at,0,5cl|||",
                "Nepal": "at,0,5cp|||",
                "New_Caledonia": "a7,0,46,0,1gs,0,3oe|a2,0,46,0,1gs,0,3oe||",
                "New_Zealand": "a7,0,46,0,1gs,0,3oc|a2,0,46,0,1gs,0,3oc||",
                "Newfoundland": "a7,0,46,0,1gs,0,3ob|a2,0,46,0,1gs,0,3ob||",
                "Niue": "at,0,5db|||",
                "Norfolk": "at,0,121,0,5dc|||",
                "Noronha": "a7,0,46,0,3oa,0,3o9,0,3o7|a2,0,46,0,3oa,0,3o9,0,3o7||",
                "North_Mariana": "at,0,121,0,5dh,0,5e4|||",
                "Novosibirsk": "a7,0,46,0,3o5|a2,0,46,0,3o5||",
                "Omsk": "a7,0,46,0,3o4|a2,0,46,0,3o4||",
                "Pakistan": "a7,0,46,0,3o3|a2,0,46,0,3o3||",
                "Palau": "at,0,5e9|||",
                "Papua_New_Guinea": "at,0,5ea,0,5eb,0,5ee|||",
                "Paraguay": "a7,0,46,0,3nu|a2,0,46,0,3nu||",
                "Peru": "a7,0,46,0,3ns|a2,0,46,0,3ns||",
                "Philippines": "a7,0,46,0,3nr|a2,0,46,0,3nr||",
                "Phoenix_Islands": "at,0,121,0,5f7|||",
                "Pierre_Miquelon": "a7,0,46,0,3nn,0,3nj,0,247,0,3nf|a2,0,46,0,3nn,0,3nj,0,247,0,3nf||",
                "Pitcairn": "at,0,5g6|||",
                "Ponape": "at,0,5gi|||",
                "Pyongyang": "at,0,5h8|||",
                "Reunion": "at,0,5he|||",
                "Rothera": "at,0,5hg|||",
                "Sakhalin": "a7,0,46,0,3ne|a2,0,46,0,3ne||",
                "Samara": "a7,0,46,0,5hu|a2,0,46,0,5i2||",
                "Samoa": "a7,0,46,0,3nc|a2,0,46,0,3nc||",
                "Seychelles": "at,0,5ih|||",
                "Singapore": "at,0,5ii|||",
                "Solomon": "at,0,121,0,5j7|||",
                "South_Georgia": "at,0,3qu,0,2lg|||",
                "Suriname": "at,0,5j8|||",
                "Syowa": "at,0,5j9|||",
                "Tahiti": "at,0,5ja|||",
                "Taipei": "a7,0,46,0,3nb|a2,0,46,0,3nb||",
                "Tajikistan": "at,0,5jc|||",
                "Tokelau": "at,0,5jd|||",
                "Tonga": "a7,0,46,0,3n8|a2,0,46,0,3n8||",
                "Truk": "at,0,5ji|||",
                "Turkmenistan": "a7,0,46,0,3n7|a2,0,46,0,3n7||",
                "Tuvalu": "at,0,5jl|||",
                "Uruguay": "a7,0,46,0,3n2|a2,0,46,0,3n2||",
                "Uzbekistan": "a7,0,46,0,3n0|a2,0,46,0,3n0||",
                "Vanuatu": "a7,0,46,0,3mv|a2,0,46,0,3mv||",
                "Venezuela": "at,0,5jq|||",
                "Vladivostok": "a7,0,46,0,3mt|a2,0,46,0,3mt||",
                "Volgograd": "a7,0,46,0,3ms|a2,0,46,0,3ms||",
                "Vostok": "at,0,5jv|||",
                "Wake": "at,0,1o6,0,5k0|||",
                "Wallis": "at,0,5k2,0,247,0,5k3|||",
                "Yakutsk": "a7,0,46,0,3mp|a2,0,46,0,3mp||",
                "Yekaterinburg": "a7,0,46,0,3mo|a2,0,46,0,3mo||"
            }
        },
        "en-001": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-150": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-AG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-AI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-AS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-AT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-AU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "17,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "hs,0,4,0,1|hs,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1|4lq|5mi",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1|5mj|5mk",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1|5ml|5mo",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1|5mp|5mq",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,1f,0,4,0,1|2v,0,1f,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,6,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,6,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1|5mr|5ms",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,c,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1|5mt|5n0",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,6,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,6,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BB": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-BZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1|ble|bld",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-CY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-DE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-DG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-DK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-DM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-ER": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-FI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-FJ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-FK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-FM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GB": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||c9v"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GD": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1||blc|",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-GY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1||blb|",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-HK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1|5nb|5ne",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-IE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||15a",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-IL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-IM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-IN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1||15a|",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-IO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-JE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-JM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-KE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-KI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-KN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-KY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-LC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-LR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-LS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1|5nb|5ne",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1|18r|16i",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MP": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-MY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1||1r5|",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NF": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-NZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1|4lq|5mi",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1|5mj|5mk",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1|5ml|5mo",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1|5mp|5mq",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1|bla|bl9",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1|5mr|5ms",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1|5mt|5n0",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-PW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-RW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SB": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SD": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1||1r5|",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1||2ad|",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1|h0|h4",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1|gu|gv",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1|h1|h2",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-SZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TV": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-TZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-UG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-UM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-US-POSIX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-VC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-VG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-VI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-VU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-WS": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-ZA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-ZM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en-ZW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1||vj|",
                "Africa_Eastern": "1r,0,1t,0,1||vp|",
                "Africa_Southern": "85,0,1t,0,4,0,1||vu|",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1|103|vq",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1||",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1||",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1||",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1||",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1||",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1||",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1||",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "en": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|c6,0,4,0,1||",
                "Europe/London": "|c1,0,6,0,1||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,0,4,0,1|3q,0,6,0,1||",
                "Afghanistan": "b6,0,1|||",
                "Africa_Central": "n,0,1t,0,1|||",
                "Africa_Eastern": "1r,0,1t,0,1|||",
                "Africa_Southern": "85,0,1t,0,4,0,1|||",
                "Africa_Western": "1g,0,1t,0,4,0,1|1g,0,1t,0,6,0,1||",
                "Alaska": "3p,0,4,0,1|3p,0,c,0,1|18f|18t",
                "Almaty": "56,0,4,0,1|56,0,6,0,1||",
                "Amazon": "5m,0,4,0,1|5m,0,6,0,1||",
                "America_Central": "n,0,4,0,1|n,0,c,0,1|19q|19p",
                "America_Eastern": "17,0,4,0,1|17,0,c,0,1|19o|19n",
                "America_Mountain": "5a,0,4,0,1|5a,0,c,0,1|18r|16i",
                "America_Pacific": "2h,0,4,0,1|2h,0,c,0,1|19l|19k",
                "Anadyr": "3l,0,4,0,1|3l,0,6,0,1||",
                "Apia": "3e,0,4,0,1|3e,0,c,0,1||",
                "Aqtau": "50,0,4,0,1|50,0,6,0,1||",
                "Aqtobe": "5o,0,4,0,1|5o,0,6,0,1||",
                "Arabian": "87,0,4,0,1|87,0,c,0,1||",
                "Argentina": "1e,0,4,0,1|1e,0,6,0,1||",
                "Argentina_Western": "t,0,1e,0,4,0,1|t,0,1e,0,6,0,1||",
                "Armenia": "4l,0,4,0,1|4l,0,6,0,1||",
                "Atlantic": "6g,0,4,0,1|6g,0,c,0,1|19i|190",
                "Australia_Central": "13,0,n,0,4,0,1|13,0,n,0,c,0,1||",
                "Australia_CentralWestern": "13,0,n,0,t,0,4,0,1|13,0,n,0,t,0,c,0,1||",
                "Australia_Eastern": "13,0,17,0,4,0,1|13,0,17,0,c,0,1||",
                "Australia_Western": "13,0,t,0,4,0,1|13,0,t,0,c,0,1||",
                "Azerbaijan": "7m,0,4,0,1|7m,0,6,0,1||",
                "Azores": "4r,0,4,0,1|4r,0,6,0,1||",
                "Bangladesh": "3n,0,4,0,1|3n,0,6,0,1||",
                "Bhutan": "as,0,1|||",
                "Bolivia": "aa,0,1|||",
                "Brasilia": "3a,0,4,0,1|3a,0,6,0,1||",
                "Brunei": "9o,0,a4,0,1|||",
                "Cape_Verde": "7c,0,3j,0,4,0,1|7c,0,3j,0,6,0,1||",
                "Casey": "b7,0,1|||",
                "Chamorro": "6j,0,4,0,1|||",
                "Chatham": "27,0,4,0,1|27,0,c,0,1||",
                "Chile": "49,0,4,0,1|49,0,6,0,1||",
                "China": "4h,0,4,0,1|4h,0,c,0,1||",
                "Choibalsan": "2q,0,4,0,1|2q,0,6,0,1||",
                "Christmas": "99,0,1f,0,1|||",
                "Cocos": "7v,0,o,0,1|||",
                "Colombia": "4m,0,4,0,1|4m,0,6,0,1||",
                "Cook": "2v,0,o,0,4,0,1|2v,0,o,0,c8,0,6,0,1||",
                "Cuba": "34,0,4,0,1|34,0,c,0,1||",
                "Davis": "5s,0,1|||",
                "DumontDUrville": "5b,5,5j,0,1|||",
                "East_Timor": "1r,0,7n,0,1|||",
                "Easter": "7t,0,1f,0,4,0,1|7t,0,1f,0,6,0,1||",
                "Ecuador": "ai,0,1|||",
                "Europe_Central": "n,0,18,0,4,0,1|n,0,18,0,6,0,1||",
                "Europe_Eastern": "17,0,18,0,4,0,1|17,0,18,0,6,0,1||",
                "Europe_Further_Eastern": "bu,5,c0,0,18,0,1|||",
                "Europe_Western": "t,0,18,0,4,0,1|t,0,18,0,6,0,1||",
                "Falkland": "4v,0,o,0,4,0,1|4v,0,o,0,6,0,1||",
                "Fiji": "4q,0,4,0,1|4q,0,6,0,1||",
                "French_Guiana": "84,0,am,0,1|||",
                "French_Southern": "84,0,c7,0,31,0,c4,0,1|||",
                "Galapagos": "ak,0,1|||",
                "Gambier": "6v,0,1|||",
                "Georgia": "2u,0,4,0,1|2u,0,6,0,1||",
                "Gilbert_Islands": "6q,0,o,0,1|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "1r,0,2k,0,4,0,1|1r,0,2k,0,6,0,1||",
                "Greenland_Western": "1g,0,2k,0,4,0,1|1g,0,2k,0,6,0,1||",
                "Guam": "83,0,4,0,1|||",
                "Gulf": "bn,0,4,0,1|||",
                "Guyana": "7a,0,1|||",
                "Hawaii_Aleutian": "4g,5,62,0,4,0,1|4g,5,62,0,c,0,1|17j|17l",
                "Hong_Kong": "2l,0,2p,0,4,0,1|2l,0,2p,0,6,0,1||",
                "Hovd": "2g,0,4,0,1|2g,0,6,0,1||",
                "India": "af,0,4,0,1|||",
                "Indian_Ocean": "br,0,bv,0,1|||",
                "Indochina": "9p,0,1|||",
                "Indonesia_Central": "n,0,2t,0,1|||",
                "Indonesia_Eastern": "17,0,2t,0,1|||",
                "Indonesia_Western": "t,0,2t,0,1|||",
                "Iran": "5g,0,4,0,1|5g,0,c,0,1||",
                "Irkutsk": "3h,0,4,0,1|3h,0,6,0,1||",
                "Israel": "4e,0,4,0,1|4e,0,c,0,1||",
                "Japan": "6o,0,4,0,1|6o,0,c,0,1||",
                "Kamchatka": "37,5,3k,0,4,0,1|37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "1r,0,45,0,1|||",
                "Kazakhstan_Western": "1g,0,45,0,1|||",
                "Korea": "88,0,4,0,1|88,0,c,0,1||",
                "Kosrae": "6f,0,1|||",
                "Krasnoyarsk": "41,0,4,0,1|41,0,6,0,1||",
                "Kyrgystan": "bl,0,1|||",
                "Lanka": "9c,0,1|||",
                "Line_Islands": "ac,0,o,0,1|||",
                "Lord_Howe": "1u,0,24,0,4,0,1|1u,0,24,0,c,0,1||",
                "Macau": "57,0,4,0,1|57,0,6,0,1||",
                "Macquarie": "6m,0,1f,0,1|||",
                "Magadan": "2o,0,4,0,1|2o,0,6,0,1||",
                "Malaysia": "bf,0,1|||",
                "Maldives": "9k,0,1|||",
                "Marquesas": "9e,0,1|||",
                "Marshall_Islands": "7o,0,o,0,1|||",
                "Mauritius": "4u,0,4,0,1|4u,0,6,0,1||",
                "Mawson": "63,0,1|||",
                "Mexico_Northwest": "80,0,5e,0,4,0,1|80,0,5e,0,c,0,1||",
                "Mexico_Pacific": "81,0,2h,0,4,0,1|81,0,2h,0,c,0,1||",
                "Mongolia": "4f,0,2m,0,4,0,1|4f,0,2m,0,6,0,1||",
                "Moscow": "71,0,4,0,1|71,0,6,0,1||",
                "Myanmar": "8v,0,1|||",
                "Nauru": "5v,0,1|||",
                "Nepal": "8u,0,1|||",
                "New_Caledonia": "1m,0,4o,0,4,0,1|1m,0,4o,0,6,0,1||",
                "New_Zealand": "1m,0,74,0,4,0,1|1m,0,74,0,c,0,1||",
                "Newfoundland": "53,0,4,0,1|53,0,c,0,1||",
                "Niue": "8g,0,1|||",
                "Norfolk": "6l,0,1f,0,1|||",
                "Noronha": "1s,0,2,0,23,0,4,0,1|1s,0,2,0,23,0,6,0,1||",
                "North_Mariana": "bm,0,bd,0,o,0,1|||",
                "Novosibirsk": "3b,0,4,0,1|3b,0,6,0,1||",
                "Omsk": "26,0,4,0,1|26,0,6,0,1||",
                "Pakistan": "3i,0,4,0,1|3i,0,6,0,1||",
                "Palau": "9b,0,1|||",
                "Papua_New_Guinea": "9a,0,1m,0,a8,0,1|||",
                "Paraguay": "3c,0,4,0,1|3c,0,6,0,1||",
                "Peru": "4n,0,4,0,1|4n,0,6,0,1||",
                "Philippines": "86,0,4,0,1|86,0,6,0,1||",
                "Phoenix_Islands": "90,0,o,0,1|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,4,0,1|7u,0,33,0,31,0,35,0,c,0,1||",
                "Pitcairn": "7e,0,1|||",
                "Ponape": "9s,0,1|||",
                "Pyongyang": "8a,0,1|||",
                "Qyzylorda": "4d,0,4,0,1|4d,0,6,0,1||",
                "Reunion": "b4,0,1|||",
                "Rothera": "5q,0,1|||",
                "Sakhalin": "55,0,4,0,1|55,0,6,0,1||",
                "Samara": "29,0,4,0,1|29,0,6,0,1||",
                "Samoa": "2c,0,4,0,1|2c,0,c,0,1||",
                "Seychelles": "8k,0,1|||",
                "Singapore": "bi,0,4,0,1|||",
                "Solomon": "b5,0,o,0,1|||",
                "South_Georgia": "85,0,2u,0,1|||",
                "Suriname": "8q,0,1|||",
                "Syowa": "65,0,1|||",
                "Tahiti": "8n,0,1|||",
                "Taipei": "3d,0,4,0,1|3d,0,c,0,1||",
                "Tajikistan": "bj,0,1|||",
                "Tokelau": "5d,0,1|||",
                "Tonga": "2j,0,4,0,1|2j,0,6,0,1||",
                "Truk": "6p,0,1|||",
                "Turkmenistan": "4t,0,4,0,1|4t,0,6,0,1||",
                "Tuvalu": "6h,0,1|||",
                "Uruguay": "4k,0,4,0,1|4k,0,6,0,1||",
                "Uzbekistan": "60,0,4,0,1|60,0,6,0,1||",
                "Vanuatu": "2f,0,4,0,1|2f,0,6,0,1||",
                "Venezuela": "7s,0,1|||",
                "Vladivostok": "28,0,4,0,1|28,0,6,0,1||",
                "Volgograd": "3f,0,4,0,1|3f,0,6,0,1||",
                "Vostok": "5t,0,1|||",
                "Wake": "5r,0,1f,0,1|||",
                "Wallis": "5f,0,31,0,5k,0,1|||",
                "Yakutsk": "3u,0,4,0,1|3u,0,6,0,1||",
                "Yekaterinburg": "5l,0,4,0,1|5l,0,6,0,1||"
            }
        },
        "eo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "es-419": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-AR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e|bl8|bl7",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48|bl6|bl5",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-BO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa||5pl|",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-BR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-CL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49|bl4|bl3",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-CO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m|bl2|bl1",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-CR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-CU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-DO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-EA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,al,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,al,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r|h0|h4",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r|gu|gv",
                "Europe_Further_Eastern": "8,0,2,0,4p,0,3r,0,2uu|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48|h1|h2",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,1gc|8,0,2,0,e,0,2,0,lt,5,1gc||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-EC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai||5ps|",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-GQ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,al,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,al,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r|h0|h4",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r|gu|gv",
                "Europe_Further_Eastern": "8,0,2,0,4p,0,3r,0,2uu|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48|h1|h2",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,1gc|8,0,2,0,e,0,2,0,lt,5,1gc||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-GT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-HN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-IC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,al,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,al,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r|h0|h4",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r|gu|gv",
                "Europe_Further_Eastern": "8,0,2,0,4p,0,3r,0,2uu|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48|h1|h2",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,1gc|8,0,2,0,e,0,2,0,lt,5,1gc||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-MX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,e,0,8iu||",
                "Europe/London": "|9,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "9,0,2,0,9d,0,n|||",
                "Africa_Eastern": "9,0,2,0,9d,0,8h|||",
                "Africa_Southern": "9,0,2,0,sf|||",
                "Africa_Western": "9,0,d,0,2,0,9d,0,of|9,0,2,0,e,0,2,0,9d,0,of||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "9,0,d,0,2,0,3e|9,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "9,0,d,0,2,0,hs|9,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "9,0,d,0,2,0,4l|9,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "9,0,d,0,2,0,4c,0,n|9,0,2,0,e,0,2,0,4c,0,n||",
                "Australia_CentralWestern": "9,0,d,0,2,0,4c,0,5pt|9,0,2,0,e,0,2,0,4c,0,5pt||",
                "Australia_Eastern": "9,0,d,0,2,0,4c,0,8h|9,0,2,0,e,0,2,0,4c,0,8h||",
                "Australia_Western": "9,0,d,0,2,0,4c,0,of|9,0,2,0,e,0,2,0,4c,0,of||",
                "Azerbaijan": "9,0,d,0,2,0,lp|9,0,2,0,e,0,2,0,lp||",
                "Azores": "9,0,d,0,2,0,32,0,4r|9,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "9,0,d,0,2,0,ck,0,3j|9,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,d,0,2,0,6j|||",
                "Chatham": "9,0,d,0,2,0,27|9,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "9,0,2,0,1c,0,av,0,2,0,vs|||",
                "Cocos": "9,0,2,0,32,0,b3,0,7v|||",
                "Colombia": "9,0,d,0,2,0,4m|9,0,2,0,e,0,2,0,4m||",
                "Cook": "9,0,d,0,2,0,32,0,b3,0,2v|9,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "9,0,d,0,2,0,1c,0,av,0,2,0,iq|9,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "9,0,2,0,ai|||",
                "Europe_Central": "9,0,d,0,2,0,4p,0,n|9,0,2,0,e,0,2,0,4p,0,n||",
                "Europe_Eastern": "9,0,d,0,2,0,4p,0,19,0,3it|9,0,2,0,e,0,2,0,4p,0,19,0,3it||",
                "Europe_Further_Eastern": "9,0,19,0,1ej,0,8h,0,2,0,4p|||",
                "Europe_Western": "9,0,d,0,2,0,4p,0,of|9,0,2,0,e,0,2,0,4p,0,of||",
                "Falkland": "9,0,d,0,2,0,32,0,b3,0,ju|9,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "9,0,d,0,2,0,m1|9,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "9,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "9,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "9,0,2,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,d,0,2,0,2u|9,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "9,0,2,0,32,0,b3,0,6q|||",
                "GMT": "9,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "9,0,d,0,19,0,oh|||",
                "Guyana": "9,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "9,0,19,0,5pv,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "9,0,d,0,2,0,3h|9,0,2,0,e,0,2,0,3h||",
                "Israel": "9,0,d,0,2,0,4e|9,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "9,0,2,0,m3,0,8h|||",
                "Kazakhstan_Western": "9,0,2,0,m3,0,of|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,d,0,2,0,41|9,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "9,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "9,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "9,0,d,0,2,0,1u,0,24|9,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "9,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "9,0,d,0,2,0,jh|9,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "9,0,2,0,32,0,b3,0,9e|||",
                "Marshall_Islands": "9,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "9,0,d,0,2,0,kt|9,0,2,0,e,0,2,0,kt||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "9,0,d,0,2,0,k6|9,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "9,0,d,0,2,0,an,0,4o|9,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "9,0,d,0,2,0,an,0,go|9,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,2,0,32,0,b3,0,6l|||",
                "Noronha": "9,0,d,0,2,0,1s,0,2,0,23|9,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "9,0,d,0,2,0,3b|9,0,2,0,e,0,2,0,3b||",
                "Omsk": "9,0,d,0,2,0,26|9,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "9,0,2,0,gt|||",
                "Papua_New_Guinea": "9,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "9,0,d,0,2,0,3c|9,0,2,0,e,0,2,0,3c||",
                "Peru": "9,0,d,0,2,0,ha|9,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "9,0,2,0,32,0,b3,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "9,0,2,0,s4|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,d,0,2,0,m4|9,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "9,0,d,0,2,0,2c|9,0,2,0,e,0,2,0,2c||",
                "Seychelles": "9,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "9,0,2,0,32,0,b3,0,s1|||",
                "South_Georgia": "9,0,2,0,2u,0,104|||",
                "Suriname": "9,0,2,0,mg|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "9,0,2,0,100|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,d,0,2,0,2j|9,0,2,0,e,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,d,0,2,0,lh|9,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,d,0,2,0,4k|9,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "9,0,d,0,2,0,lq|9,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "9,0,d,0,2,0,2f|9,0,2,0,e,0,2,0,2f||",
                "Venezuela": "9,0,2,0,7s|||",
                "Vladivostok": "9,0,d,0,2,0,28|9,0,2,0,e,0,2,0,28||",
                "Volgograd": "9,0,d,0,2,0,ff|9,0,2,0,e,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "9,0,d,0,2,0,3u|9,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "9,0,d,0,2,0,kh|9,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-NI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-PA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-PE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha|5q0|5q1",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-PH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,al,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,al,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r|h0|h4",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r|gu|gv",
                "Europe_Further_Eastern": "8,0,2,0,4p,0,3r,0,2uu|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48|h1|h2",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,1gc|8,0,2,0,e,0,2,0,lt,5,1gc||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-PR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-PY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-SV": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-US": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p|18f|18t",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r|19q|19p",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r|19o|19n",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls|18r|16i",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u|19l|19k",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk|19i|190",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa|17j|17l",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-UY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k|bl0|bkv",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es-VE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,b3,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,b3,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r||",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r||",
                "Europe_Further_Eastern": "n0,0,19,0,13i,0,sr,0,2,0,4p|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48||",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u|||",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,oa|8,0,2,0,e,0,2,0,lt,5,oa||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,2,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,12m|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s||bku|",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "es": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|8,0,2,0,e,0,2,0,pk||",
                "Europe/London": "|8,0,2,0,e,0,sc||"
            },
            "metazone": {
                "Acre": "9,0,d,0,2,0,3q|9,0,2,0,e,0,2,0,3q||",
                "Afghanistan": "8,0,2,0,t9|||",
                "Africa_Central": "8,0,2,0,9d,0,6r|||",
                "Africa_Eastern": "8,0,2,0,9d,0,3r|||",
                "Africa_Southern": "8,0,2,0,sf|||",
                "Africa_Western": "8,0,d,0,2,0,9d,0,48|8,0,2,0,e,0,2,0,9d,0,48||",
                "Alaska": "8,0,d,0,2,0,3p|8,0,2,0,e,0,2,0,3p||",
                "Amazon": "8,0,d,0,19,0,bg|8,0,2,0,e,0,19,0,bg||",
                "America_Central": "8,0,d,0,6r|8,0,2,0,e,0,6r||",
                "America_Eastern": "8,0,d,0,3r|8,0,2,0,e,0,3r||",
                "America_Mountain": "8,0,d,0,2,0,32,0,ls|8,0,2,0,e,0,2,0,32,0,ls||",
                "America_Pacific": "8,0,d,0,19,0,9u|8,0,2,0,e,0,19,0,9u||",
                "Anadyr": "9,0,d,0,2,0,3l|9,0,2,0,e,0,2,0,3l||",
                "Apia": "8,0,d,0,2,0,3e|n0,0,2,0,e,0,2,0,3e||",
                "Aqtau": "9,0,d,0,2,0,i4|9,0,2,0,e,0,2,0,i4||",
                "Aqtobe": "9,0,d,0,2,0,im|9,0,2,0,e,0,2,0,im||",
                "Arabian": "8,0,d,0,2,0,hs|8,0,2,0,e,0,2,0,hs||",
                "Argentina": "8,0,d,0,2,0,1e|8,0,2,0,e,0,2,0,1e||",
                "Argentina_Western": "8,0,d,0,2,0,1e,0,48|8,0,2,0,e,0,2,0,1e,0,48||",
                "Armenia": "8,0,d,0,2,0,4l|8,0,2,0,e,0,2,0,4l||",
                "Atlantic": "8,0,d,0,19,0,jk|8,0,2,0,e,0,19,0,jk||",
                "Australia_Central": "8,0,d,0,2,0,4c,0,6r|8,0,2,0,e,0,2,0,4c,0,6r||",
                "Australia_CentralWestern": "8,0,d,0,2,0,4c,0,m9|8,0,2,0,e,0,2,0,4c,0,m9||",
                "Australia_Eastern": "8,0,d,0,2,0,4c,0,3r|8,0,2,0,e,0,2,0,4c,0,3r||",
                "Australia_Western": "8,0,d,0,2,0,4c,0,48|8,0,2,0,e,0,2,0,4c,0,48||",
                "Azerbaijan": "8,0,d,0,2,0,lp|8,0,2,0,e,0,2,0,lp||",
                "Azores": "8,0,d,0,2,0,32,0,4r|8,0,2,0,e,0,2,0,32,0,4r||",
                "Bangladesh": "8,0,d,0,2,0,je|8,0,2,0,e,0,2,0,je||",
                "Bhutan": "8,0,2,0,s5|||",
                "Bolivia": "8,0,2,0,aa|||",
                "Brasilia": "8,0,d,0,2,0,3a|8,0,2,0,e,0,2,0,3a||",
                "Brunei": "8,0,2,0,gs|||",
                "Cape_Verde": "8,0,d,0,2,0,ck,0,3j|8,0,2,0,e,0,2,0,ck,0,3j||",
                "Chamorro": "8,0,d,0,2,0,6j|||",
                "Chatham": "8,0,d,0,2,0,27|8,0,2,0,e,0,2,0,27||",
                "Chile": "8,0,d,0,2,0,49|8,0,2,0,e,0,2,0,49||",
                "China": "8,0,d,0,2,0,4h|8,0,2,0,e,0,2,0,4h||",
                "Choibalsan": "8,0,d,0,2,0,2q|8,0,2,0,e,0,2,0,2q||",
                "Christmas": "8,0,2,0,1c,0,10f,0,2,0,vs|||",
                "Cocos": "8,0,2,0,32,0,al,0,7v|||",
                "Colombia": "8,0,d,0,2,0,4m|8,0,2,0,e,0,2,0,4m||",
                "Cook": "8,0,d,0,2,0,32,0,al,0,2v|8,0,2,0,e,0,r1,0,2,0,32,0,al,0,2v||",
                "Cuba": "8,0,d,0,2,0,34|8,0,2,0,e,0,2,0,34||",
                "Davis": "8,0,2,0,5s|||",
                "DumontDUrville": "8,0,2,0,5b,5,5j|||",
                "East_Timor": "8,0,2,0,7n,0,8h|||",
                "Easter": "8,0,d,0,2,0,1c,0,av,0,2,0,iq|8,0,2,0,e,0,2,0,1c,0,av,0,2,0,iq||",
                "Ecuador": "8,0,2,0,ai|||",
                "Europe_Central": "8,0,d,0,2,0,4p,0,6r|8,0,2,0,e,0,2,0,4p,0,6r|h0|h4",
                "Europe_Eastern": "8,0,d,0,2,0,4p,0,3r|8,0,2,0,e,0,2,0,4p,0,3r|gu|gv",
                "Europe_Further_Eastern": "8,0,2,0,4p,0,3r,0,2uu|||",
                "Europe_Western": "8,0,d,0,2,0,4p,0,48|8,0,2,0,e,0,2,0,4p,0,48|h1|h2",
                "Falkland": "8,0,d,0,2,0,32,0,b3,0,ju|8,0,2,0,e,0,2,0,32,0,b3,0,ju||",
                "Fiji": "8,0,d,0,2,0,m1|8,0,2,0,e,0,2,0,m1||",
                "French_Guiana": "8,0,2,0,1c,0,qk,0,nf|||",
                "French_Southern": "8,0,2,0,32,0,vv,0,101,0,bk,0,sd,0,pf|||",
                "Galapagos": "8,0,2,0,cp|||",
                "Gambier": "8,0,2,0,6v|||",
                "Georgia": "8,0,d,0,2,0,2u|8,0,2,0,e,0,2,0,2u||",
                "Gilbert_Islands": "8,0,2,0,32,0,b3,0,6q|||",
                "GMT": "8,0,19,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "8,0,d,0,2,0,b2,0,3r|8,0,2,0,e,0,2,0,b2,0,3r||",
                "Greenland_Western": "8,0,d,0,2,0,b2,0,48|8,0,2,0,e,0,2,0,b2,0,48||",
                "Guam": "9,0,d,0,2,0,83|||",
                "Gulf": "8,0,d,0,19,0,oh|||",
                "Guyana": "8,0,2,0,7a|||",
                "Hawaii_Aleutian": "8,0,d,0,2,0,lt,5,1gc|8,0,2,0,e,0,2,0,lt,5,1gc||",
                "Hong_Kong": "8,0,d,0,2,0,2l,0,2p|8,0,2,0,e,0,2,0,2l,0,2p||",
                "Hovd": "8,0,d,0,2,0,2g|8,0,2,0,e,0,2,0,2g||",
                "India": "8,0,d,0,2,0,1c,0,af|||",
                "Indian_Ocean": "8,0,19,0,10h,0,pa|||",
                "Indochina": "8,0,2,0,9p|||",
                "Indonesia_Central": "8,0,2,0,2t,0,6r|||",
                "Indonesia_Eastern": "8,0,2,0,2t,0,3r|||",
                "Indonesia_Western": "8,0,2,0,2t,0,48|||",
                "Iran": "8,0,d,0,2,0,k1|8,0,2,0,e,0,2,0,k1||",
                "Irkutsk": "8,0,d,0,2,0,3h|8,0,2,0,e,0,2,0,3h||",
                "Israel": "8,0,d,0,2,0,4e|8,0,2,0,e,0,2,0,4e||",
                "Japan": "8,0,d,0,2,0,lu|8,0,2,0,e,0,2,0,lu||",
                "Kamchatka": "9,0,2,0,d,0,2,0,lr|9,0,2,0,e,0,2,0,lr||",
                "Kazakhstan_Eastern": "8,0,2,0,m3,0,3r|||",
                "Kazakhstan_Western": "8,0,2,0,m3,0,48|||",
                "Korea": "8,0,d,0,2,0,hf|8,0,2,0,e,0,2,0,hf||",
                "Kosrae": "8,0,2,0,6f|||",
                "Krasnoyarsk": "8,0,d,0,2,0,41|8,0,2,0,e,0,2,0,41||",
                "Kyrgystan": "8,0,2,0,sp|||",
                "Lanka": "9,0,2,0,me,0,9c|||",
                "Line_Islands": "8,0,2,0,32,0,102,0,vt|||",
                "Lord_Howe": "8,0,d,0,2,0,1u,0,24|8,0,2,0,e,0,2,0,1u,0,24||",
                "Macau": "9,0,d,0,2,0,ip|9,0,2,0,e,0,2,0,ip||",
                "Macquarie": "8,0,2,0,1c,0,av,0,6m|||",
                "Magadan": "8,0,d,0,2,0,jh|8,0,2,0,e,0,2,0,jh||",
                "Malaysia": "8,0,2,0,sh|||",
                "Maldives": "8,0,2,0,ov|||",
                "Marquesas": "8,0,2,0,9e|||",
                "Marshall_Islands": "8,0,2,0,32,0,al,0,7o|||",
                "Mauritius": "8,0,d,0,2,0,kt|8,0,2,0,e,0,2,0,kt||",
                "Mawson": "8,0,2,0,63|||",
                "Mexico_Northwest": "8,0,d,0,19,0,jn,0,2,0,au|8,0,2,0,e,0,19,0,jn,0,2,0,au||",
                "Mexico_Pacific": "8,0,d,0,19,0,9u,0,2,0,au|8,0,2,0,e,0,19,0,9u,0,2,0,au||",
                "Mongolia": "8,0,d,0,2,0,ke,0,2m|8,0,2,0,e,0,2,0,ke,0,2m||",
                "Moscow": "8,0,d,0,2,0,k6|8,0,2,0,e,0,2,0,k6||",
                "Myanmar": "8,0,2,0,ra|||",
                "Nauru": "8,0,2,0,5v|||",
                "Nepal": "8,0,2,0,8u|||",
                "New_Caledonia": "8,0,d,0,2,0,an,0,4o|8,0,2,0,e,0,2,0,an,0,4o||",
                "New_Zealand": "8,0,d,0,2,0,an,0,go|8,0,2,0,e,0,2,0,an,0,go||",
                "Newfoundland": "8,0,d,0,2,0,h5|8,0,2,0,e,0,2,0,h5||",
                "Niue": "8,0,2,0,8g|||",
                "Norfolk": "8,0,2,0,1c,0,av,0,6l|||",
                "Noronha": "8,0,d,0,2,0,1s,0,2,0,23|8,0,2,0,e,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,2,0,32,0,al,0,vm,0,19,0,p4|||",
                "Novosibirsk": "8,0,d,0,2,0,3b|8,0,2,0,e,0,2,0,3b||",
                "Omsk": "8,0,d,0,2,0,26|8,0,2,0,e,0,2,0,26||",
                "Pakistan": "8,0,d,0,2,0,lv|8,0,2,0,e,0,2,0,lv||",
                "Palau": "8,0,2,0,gt|||",
                "Papua_New_Guinea": "8,0,2,0,re,0,an,0,a8|||",
                "Paraguay": "8,0,d,0,2,0,3c|8,0,2,0,e,0,2,0,3c||",
                "Peru": "8,0,d,0,2,0,ha|8,0,2,0,e,0,2,0,ha||",
                "Philippines": "8,0,d,0,2,0,g0|8,0,2,0,e,0,2,0,g0||",
                "Phoenix_Islands": "8,0,2,0,32,0,al,0,pd|||",
                "Pierre_Miquelon": "8,0,d,0,2,0,io,0,gp,0,bk,0,m0|8,0,2,0,e,0,2,0,io,0,gp,0,bk,0,m0||",
                "Pitcairn": "8,0,2,0,7e|||",
                "Ponape": "8,0,2,0,e5|||",
                "Pyongyang": "8,0,2,0,8a|||",
                "Qyzylorda": "9,0,d,0,2,0,4d|9,0,2,0,e,0,2,0,4d||",
                "Reunion": "8,0,2,0,s4|||",
                "Rothera": "8,0,2,0,5q|||",
                "Sakhalin": "8,0,d,0,2,0,m4|8,0,2,0,e,0,2,0,m4||",
                "Samara": "9,0,d,0,2,0,29|9,0,2,0,e,0,2,0,29||",
                "Samoa": "8,0,d,0,2,0,2c|8,0,2,0,e,0,2,0,2c||",
                "Seychelles": "8,0,2,0,8k|||",
                "Singapore": "8,0,2,0,m8|||",
                "Solomon": "8,0,2,0,32,0,al,0,s1|||",
                "South_Georgia": "8,0,2,0,2u,0,104|||",
                "Suriname": "8,0,2,0,mg|||",
                "Syowa": "8,0,2,0,65|||",
                "Tahiti": "8,0,2,0,qr|||",
                "Taipei": "8,0,d,0,2,0,lf|8,0,2,0,e,0,2,0,lf||",
                "Tajikistan": "8,0,2,0,100|||",
                "Tokelau": "8,0,2,0,5d|||",
                "Tonga": "8,0,d,0,2,0,2j|8,0,2,0,e,0,2,0,2j||",
                "Truk": "8,0,2,0,6p|||",
                "Turkmenistan": "8,0,d,0,2,0,lh|8,0,2,0,e,0,2,0,lh||",
                "Tuvalu": "8,0,2,0,6h|||",
                "Uruguay": "8,0,d,0,2,0,4k|8,0,2,0,e,0,2,0,4k||",
                "Uzbekistan": "8,0,d,0,2,0,lq|8,0,2,0,e,0,2,0,lq||",
                "Vanuatu": "8,0,d,0,2,0,2f|8,0,2,0,e,0,2,0,2f||",
                "Venezuela": "8,0,2,0,7s|||",
                "Vladivostok": "8,0,d,0,2,0,28|8,0,2,0,e,0,2,0,28||",
                "Volgograd": "8,0,d,0,2,0,ff|8,0,2,0,e,0,2,0,ff||",
                "Vostok": "8,0,2,0,5t|||",
                "Wake": "8,0,2,0,1c,0,av,0,5r|||",
                "Wallis": "8,0,2,0,5f,0,bk,0,5k|||",
                "Yakutsk": "8,0,d,0,2,0,3u|8,0,2,0,e,0,2,0,3u||",
                "Yekaterinburg": "8,0,d,0,2,0,kh|8,0,2,0,e,0,2,0,kh||"
            }
        },
        "et": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ca1,0,el||",
                "Europe/London": "|ca2,0,el||"
            },
            "metazone": {
                "Acre": "3q,0,e8|3q,0,el||",
                "Afghanistan": "bkt,0,i2|||",
                "Africa_Central": "1oo,5,2va,0,i2|||",
                "Africa_Eastern": "1on,5,2va,0,i2|||",
                "Africa_Southern": "5qc,5,2va,0,e8|||",
                "Africa_Western": "1e6,5,2va,0,e8|1e6,5,2va,0,el||",
                "Alaska": "3p,0,e8|3p,0,el||",
                "Almaty": "5qe,0,e8|5qe,0,el||",
                "Amazon": "5qf,0,e8|5qf,0,el||",
                "America_Central": "1oo,5,5qg,0,e8|1oo,5,5qg,0,el||",
                "America_Eastern": "5qh,0,e8|5qh,0,el||",
                "America_Mountain": "5qi,0,e8|5qi,0,el||",
                "America_Pacific": "3mk,0,2ve,0,e8|3mk,0,2ve,0,el||",
                "Anadyr": "5ql,0,e8|5ql,0,el||",
                "Apia": "3e,0,e8|3e,0,el||",
                "Aqtau": "i4,0,e8|i4,0,el||",
                "Aqtobe": "2gg,0,e8|2gg,0,el||",
                "Arabian": "5qn,0,e8|5qn,0,el||",
                "Argentina": "1e,0,e8|1e,0,el||",
                "Argentina_Western": "1e6,5,1e,0,e8|1e6,5,1e,0,el||",
                "Armenia": "5qo,0,e8|5qo,0,el||",
                "Atlantic": "5qp,0,e8|5qp,0,el||",
                "Australia_Central": "1oo,5,1ti,0,e8|1oo,5,1ti,0,el||",
                "Australia_CentralWestern": "1oo,5,1e6,0,1ti,0,e8|1oo,5,1e6,0,1ti,0,el||",
                "Australia_Eastern": "1on,5,1ti,0,e8|1on,5,1ti,0,el||",
                "Australia_Western": "1e6,5,1ti,0,e8|1e6,5,1ti,0,el||",
                "Azerbaijan": "5qr,0,e8|5qr,0,el||",
                "Azores": "5qs,0,e8|5qs,0,el||",
                "Bangladesh": "5qt,0,e8|5qt,0,el||",
                "Bhutan": "bks,0,i2|||",
                "Bolivia": "bkr,0,i2|||",
                "Brasilia": "5r0,0,e8|5r0,0,el||",
                "Brunei": "9o,0,i2|||",
                "Cape_Verde": "5r1,0,e8|5r1,0,el||",
                "Chamorro": "bkq,0,e8|||",
                "Chatham": "5r3,0,e8|5r3,0,el||",
                "Chile": "5r4,0,e8|5r4,0,el||",
                "China": "5r5,0,e8|5r5,0,el||",
                "Choibalsan": "5r6,0,e8|5r6,0,el||",
                "Christmas": "bkp,0,i2|||",
                "Cocos": "bko,0,i2|||",
                "Colombia": "4m,0,e8|4m,0,el||",
                "Cook": "5r9,0,29d,0,e8|5r9,0,29d,0,bkn,0,el||",
                "Cuba": "5rc,0,e8|5rc,0,el||",
                "Davis": "bkm,0,i2|||",
                "DumontDUrville": "5b,5,bkl,0,i2|||",
                "East_Timor": "1on,5,bkk,0,i2|||",
                "Easter": "5rg,0,e8|5rg,0,el||",
                "Ecuador": "bkj,0,i2|||",
                "Europe_Central": "1oo,5,2g2,0,e8|1oo,5,2g2,0,el||",
                "Europe_Eastern": "1on,5,2g2,0,e8|1on,5,2g2,0,el||",
                "Europe_Further_Eastern": "bki,0,1pq,0,bkh,0,i2|||",
                "Europe_Western": "1e6,5,2g2,0,e8|1e6,5,2g2,0,el||",
                "Falkland": "5rm,0,29d,0,e8|5rm,0,29d,0,el||",
                "Fiji": "1fh,0,e8|1fh,0,el||",
                "French_Guiana": "5ro,0,bkg,0,i2|||",
                "French_Southern": "5ro,0,bkf,0,1pq,0,bke,0,i2|||",
                "Galapagos": "bkd,0,i2|||",
                "Gambier": "bkc,0,i2|||",
                "Georgia": "5ru,0,e8|5ru,0,el||",
                "Gilbert_Islands": "bkb,0,29d,0,i2|||",
                "GMT": "bka,0,i2|||",
                "Greenland_Eastern": "1on,5,3m5,0,e8|1on,5,3m5,0,el||",
                "Greenland_Western": "1e6,5,3m5,0,e8|1e6,5,3m5,0,el||",
                "Guam": "5s2,0,e8|||",
                "Gulf": "bk9,0,bk8,0,e8|||",
                "Guyana": "7a,0,i2|||",
                "Hawaii_Aleutian": "4g,5,5s5,0,e8|4g,5,5s5,0,el||",
                "Hong_Kong": "5s6,0,e8|5s6,0,el||",
                "Hovd": "5s7,0,e8|5s7,0,el||",
                "India": "af,0,i2|||",
                "Indian_Ocean": "af,0,2ve,0,i2|||",
                "Indochina": "bk7,0,i2|||",
                "Indonesia_Central": "1oo,5,4lv,0,i2|||",
                "Indonesia_Eastern": "1on,5,4lv,0,i2|||",
                "Indonesia_Western": "1e6,5,4lv,0,i2|||",
                "Iran": "5sa,0,e8|5sa,0,el||",
                "Irkutsk": "1uo,0,e8|1uo,0,el||",
                "Israel": "5sb,0,e8|5sb,0,el||",
                "Japan": "5sc,0,e8|5sc,0,el||",
                "Kamchatka": "5sd,0,e8|5sd,0,el||",
                "Kazakhstan_Eastern": "1on,5,5se,0,i2|||",
                "Kazakhstan_Western": "1e6,5,5se,0,i2|||",
                "Korea": "qf,0,e8|qf,0,el||",
                "Kosrae": "6f,0,i2|||",
                "Krasnoyarsk": "1un,0,e8|1un,0,el||",
                "Kyrgystan": "bk6,0,i2|||",
                "Line_Islands": "bk5,0,29d,0,i2|||",
                "Lord_Howe": "1u,0,5sh,0,e8|1u,0,5sh,0,el||",
                "Macquarie": "6m,0,bk4,0,i2|||",
                "Magadan": "5sj,0,e8|5sj,0,el||",
                "Malaysia": "3lm,0,bk3|||",
                "Maldives": "bk2,0,i2|||",
                "Marquesas": "bk1,0,i2|||",
                "Marshall_Islands": "bk0,0,5sp,0,i2|||",
                "Mauritius": "5sq,0,e8|5sq,0,el||",
                "Mawson": "bjv,0,i2|||",
                "Mexico_Northwest": "5ss,5,3li,0,e8|5ss,5,3li,0,el||",
                "Mexico_Pacific": "3li,0,3mk,0,2ve,0,e8|3li,0,3mk,0,2ve,0,el||",
                "Mongolia": "5su,0,e8|5su,0,el||",
                "Moscow": "pi,0,e8|pi,0,el||",
                "Myanmar": "bju,0,i2|||",
                "Nauru": "5v,0,i2|||",
                "Nepal": "bjt,0,i2|||",
                "New_Caledonia": "30g,5,5t2,0,e8|30g,5,5t2,0,el||",
                "New_Zealand": "30g,5,5t3,0,e8|30g,5,5t3,0,el||",
                "Newfoundland": "5t4,0,e8|5t4,0,el||",
                "Niue": "8g,0,i2|||",
                "Norfolk": "bjs,0,29d,0,i2|||",
                "Noronha": "1s,0,2,0,23,0,e8|1s,0,2,0,23,0,el||",
                "Novosibirsk": "3lg,0,e8|3lg,0,el||",
                "Omsk": "1ug,0,e8|1ug,0,el||",
                "Pakistan": "5t7,0,e8|5t7,0,el||",
                "Palau": "bjr,0,i2|||",
                "Papua_New_Guinea": "bjq,0,30g,5,a8,0,i2|||",
                "Paraguay": "3c,0,e8|3c,0,el||",
                "Peru": "5ta,0,e8|5ta,0,el||",
                "Philippines": "5tb,0,e8|5tb,0,el||",
                "Phoenix_Islands": "bjp,0,i2|||",
                "Pierre_Miquelon": "8i,5,5td,0,1pq,0,5te,0,e8|8i,5,5td,0,1pq,0,5te,0,el||",
                "Pitcairn": "bjo,0,i2|||",
                "Ponape": "e5,0,i2|||",
                "Pyongyang": "bjn,0,i2|||",
                "Qyzylorda": "5th,0,e8|5th,0,el||",
                "Reunion": "bjm,0,i2|||",
                "Rothera": "5q,0,i2|||",
                "Sakhalin": "5tj,0,e8|5tj,0,el||",
                "Samara": "29,0,e8|29,0,el||",
                "Samoa": "2c,0,e8|2c,0,el||",
                "Seychelles": "bjl,0,i2|||",
                "Singapore": "bjk,0,e8|||",
                "Solomon": "bjj,0,5sp,0,i2|||",
                "South_Georgia": "5qc,5,2u,0,i2|||",
                "Suriname": "8q,0,i2|||",
                "Syowa": "65,0,i2|||",
                "Tahiti": "8n,0,i2|||",
                "Taipei": "3d,0,e8|3d,0,el||",
                "Tajikistan": "bji,0,i2|||",
                "Tokelau": "5d,0,i2|||",
                "Tonga": "2j,0,e8|2j,0,el||",
                "Truk": "bjh,0,i2|||",
                "Turkmenistan": "5tp,0,e8|5tp,0,el||",
                "Tuvalu": "6h,0,i2|||",
                "Uruguay": "4k,0,e8|4k,0,el||",
                "Uzbekistan": "5tq,0,e8|5tq,0,el||",
                "Vanuatu": "2f,0,e8|2f,0,el||",
                "Venezuela": "7s,0,i2|||",
                "Vladivostok": "5tr,0,e8|5tr,0,el||",
                "Volgograd": "5ts,0,e8|5ts,0,el||",
                "Vostok": "bjg,0,i2|||",
                "Wake": "bjf,0,i2|||",
                "Wallis": "bje,0,1pq,0,5k,0,i2|||",
                "Yakutsk": "1u5,0,e8|1u5,0,el||",
                "Yekaterinburg": "bjd,0,e8|bjc,0,el||"
            }
        },
        "eu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ca3,0,17f,0,f6||",
                "Europe/London": "|ca4,0,fv,0,b8||"
            },
            "metazone": {
                "Afghanistan": "bjb,0,b8|||",
                "Africa_Central": "c5,0,1q2,0,b8|||",
                "Africa_Eastern": "c5,0,1eq,0,b8|||",
                "Africa_Southern": "c5,0,bja,0,b8|||",
                "Africa_Western": "c5,0,1e5,0,hm,0,f6|c5,0,1e5,0,fv,0,b8||",
                "Alaska": "5ub,0,17f,0,f6|5ub,0,fv,0,13l||",
                "Amazon": "5ue,0,17f,0,f6|5ue,0,fv,0,13l||",
                "America_Central": "1uv,0,1v0,0,1q2,0,hm,0,f6|1uv,0,1v0,0,1q2,0,fv,0,13l||",
                "America_Eastern": "1uv,0,1v0,0,1eq,0,17f,0,f6|1uv,0,1v0,0,1eq,0,fv,0,13l||",
                "America_Mountain": "1uv,0,1v0,0,5uh,0,17f,0,f6|1uv,0,1v0,0,5uh,0,fv,0,13l||",
                "America_Pacific": "1uv,0,1v0,0,3la,0,17f,0,f6|1uv,0,1v0,0,3la,0,fv,0,13l||",
                "Anadyr": "5uj,0,hm,0,f6|5uj,0,fv,0,b8||",
                "Apia": "5uk,0,hm,0,f6|5uk,0,fv,0,b8||",
                "Arabian": "5ul,0,hm,0,f6|5ul,0,fv,0,b8||",
                "Argentina": "5um,0,17f,0,f6|5um,0,fv,0,13l||",
                "Argentina_Western": "1e,0,1e5,0,13l,0,f6|1e,0,1e5,0,fv,0,13l||",
                "Armenia": "5un,0,hm,0,f6|5un,0,fv,0,b8||",
                "Atlantic": "5uo,0,17f,0,f6|5uo,0,fv,0,13l||",
                "Australia_Central": "4c,0,1q2,0,hm,0,f6|4c,0,1q2,0,fv,0,b8||",
                "Australia_CentralWestern": "4c,0,5up,5,1e5,0,hm,0,f6|4c,0,5up,5,1e5,0,fv,0,b8||",
                "Australia_Eastern": "4c,0,1eq,0,hm,0,f6|4c,0,1eq,0,fv,0,b8||",
                "Australia_Western": "4c,0,1e5,0,hm,0,f6|4c,0,1e5,0,fv,0,b8||",
                "Azerbaijan": "5uq,0,hm,0,f6|5uq,0,fv,0,b8||",
                "Azores": "5ur,0,hm,0,f6|5ur,0,fv,0,b8||",
                "Bangladesh": "5us,0,hm,0,f6|5us,0,fv,0,b8||",
                "Bhutan": "bj9,0,b8|||",
                "Bolivia": "bj8,0,13l|||",
                "Brasilia": "5uv,0,hm,0,f6|5uv,0,fv,0,b8||",
                "Brunei": "9o,0,bj7,0,b8|||",
                "Cape_Verde": "ck,0,5v1,0,hm,0,f6|ck,0,5v1,0,fv,0,b8||",
                "Chamorro": "bj6,0,hm,0,f6|||",
                "Chatham": "5v3,0,hm,0,f6|5v3,0,fv,0,b8||",
                "Chile": "5v4,0,hm,0,f6|5v4,0,fv,0,b8||",
                "China": "5v5,0,hm,0,f6|5v5,0,fv,0,b8||",
                "Choibalsan": "5v6,0,hm,0,f6|5v6,0,fv,0,b8||",
                "Christmas": "99,0,31a,0,b8|||",
                "Cocos": "7v,0,19m,0,b8|||",
                "Colombia": "5v9,0,hm,0,f6|5v9,0,fv,0,b8||",
                "Cook": "2v,0,19m,0,hm,0,f6|2v,0,19m,0,bj5,0,1q2,0,b8||",
                "Cuba": "5vb,0,17f,0,f6|5vb,0,fv,0,13l||",
                "Davis": "bj4,0,b8|||",
                "DumontDUrville": "5b,5,bj3,0,b8|||",
                "East_Timor": "bj2,0,bj1,0,b8|||",
                "Easter": "5vg,0,31a,0,hm,0,f6|5vg,0,31a,0,fv,0,b8||",
                "Ecuador": "bj0,0,b8|||",
                "Europe_Central": "4p,0,1q2,0,hm,0,f6|4p,0,1q2,0,fv,0,b8|h0|h4",
                "Europe_Eastern": "4p,0,1eq,0,hm,0,f6|4p,0,1eq,0,fv,0,b8|gu|gv",
                "Europe_Further_Eastern": "biv,0,biu,0,bit,0,b8|||",
                "Europe_Western": "4p,0,1e5,0,hm,0,f6|4p,0,1e5,0,fv,0,b8|h1|h2",
                "Falkland": "4v,0,19m,0,hm,0,f6|4v,0,19m,0,fv,0,b8||",
                "Fiji": "5vl,0,hm,0,f6|5vl,0,fv,0,b8||",
                "French_Guiana": "7a,0,bis,0,b8|||",
                "French_Southern": "bir,0,biq,0,bip,0,3l0,0,bio,0,13l|||",
                "Galapagos": "bin,0,b8|||",
                "Gambier": "bim,0,b8|||",
                "Georgia": "4m0,0,hm,0,f6|4m0,0,fv,0,b8||",
                "Gilbert_Islands": "6q,0,19m,0,b8|||",
                "GMT": "5u,0,bil,0,b8||ah|",
                "Greenland_Eastern": "b2,0,1eq,0,17f,0,f6|b2,0,1eq,0,fv,0,13l||",
                "Greenland_Western": "b2,0,1e5,0,17f,0,f6|b2,0,1e5,0,fv,0,13l||",
                "Gulf": "bij,0,hm,0,f6|||",
                "Guyana": "bii,0,b8|||",
                "Hawaii_Aleutian": "4g,5,602,0,19m,0,17f,0,f6|4g,5,602,0,19m,0,fv,0,13l||",
                "Hong_Kong": "2l,0,603,0,hm,0,f6|2l,0,603,0,fv,0,b8||",
                "Hovd": "604,0,hm,0,f6|604,0,fv,0,b8||",
                "India": "bif,0,b8|||",
                "Indian_Ocean": "bie,0,bia,0,b8|||",
                "Indochina": "bi8,0,b8|||",
                "Indonesia_Central": "2t,0,1q2,0,b8|||",
                "Indonesia_Eastern": "2t,0,1eq,0,b8|||",
                "Indonesia_Western": "2t,0,1e5,0,b8|||",
                "Iran": "609,0,hm,0,f6|609,0,fv,0,b8||",
                "Irkutsk": "60a,0,hm,0,f6|60a,0,fv,0,b8||",
                "Israel": "60b,0,hm,0,f6|60b,0,fv,0,b8||",
                "Japan": "60c,0,hm,0,f6|60c,0,fv,0,b8||",
                "Kamchatka": "37,5,60d,0,hm,0,f6|37,5,60d,0,fv,0,b8||",
                "Kazakhstan_Eastern": "45,0,1eq,0,b8|||",
                "Kazakhstan_Western": "45,0,1e5,0,b8|||",
                "Korea": "60e,0,hm,0,f6|60e,0,fv,0,b8||",
                "Kosrae": "bi7,0,b8|||",
                "Krasnoyarsk": "60g,0,hm,0,f6|60g,0,fv,0,b8||",
                "Kyrgystan": "bi6,0,b8|||",
                "Line_Islands": "ac,0,19m,0,b8|||",
                "Lord_Howe": "1u,0,60i,0,hm,0,f6|1u,0,60i,0,fv,0,b8||",
                "Macquarie": "6m,0,31a,0,b8|||",
                "Magadan": "60j,0,hm,0,f6|60j,0,fv,0,b8||",
                "Malaysia": "bi5,0,b8|||",
                "Maldives": "bi3,0,b8|||",
                "Marquesas": "bhu,0,b8|||",
                "Marshall_Islands": "7o,0,19m,0,b8|||",
                "Mauritius": "60n,0,hm,0,f6|60n,0,fv,0,b8||",
                "Mawson": "bhr,0,b8|||",
                "Mexico_Northwest": "3ku,0,60q,5,1eq,0,17f,0,f6|3ku,0,60q,5,1eq,0,fv,0,13l||",
                "Mexico_Pacific": "3ku,0,3la,0,17f,0,f6|3ku,0,3la,0,fv,0,13l||",
                "Mongolia": "4f,0,60r,0,hm,0,f6|4f,0,60r,0,fv,0,b8||",
                "Moscow": "60s,0,hm,0,f6|60s,0,fv,0,b8||",
                "Myanmar": "bhq,0,b8|||",
                "Nauru": "bhp,0,b8|||",
                "Nepal": "bho,0,b8|||",
                "New_Caledonia": "215,0,2lv,0,hm,0,f6|215,0,2lv,0,fv,0,b8||",
                "New_Zealand": "611,0,2lv,0,hm,0,f6|611,0,2lv,0,fv,0,b8||",
                "Newfoundland": "612,0,17f,0,f6|612,0,fv,0,13l||",
                "Niue": "bhl,0,b8|||",
                "Norfolk": "6l,0,19m,0,b8|||",
                "Noronha": "1s,0,2,0,614,0,hm,0,f6|1s,0,2,0,614,0,fv,0,b8||",
                "Novosibirsk": "615,0,hm,0,f6|615,0,fv,0,b8||",
                "Omsk": "616,0,hm,0,f6|616,0,fv,0,b8||",
                "Pakistan": "617,0,hm,0,f6|617,0,fv,0,b8||",
                "Palau": "bhk,0,b8|||",
                "Papua_New_Guinea": "9a,0,bhj,0,2lv,0,b8|||",
                "Paraguay": "61a,0,hm,0,f6|61a,0,fv,0,b8||",
                "Peru": "61b,0,hm,0,f6|61b,0,fv,0,b8||",
                "Philippines": "61c,0,hm,0,f6|61c,0,fv,0,b8||",
                "Phoenix_Islands": "90,0,19m,0,b8|||",
                "Pierre_Miquelon": "8i,5,33,0,3l0,0,61d,0,17f,0,f6|8i,5,33,0,3l0,0,61d,0,fv,0,13l||",
                "Pitcairn": "bhi,0,b8|||",
                "Ponape": "bhh,0,b8|||",
                "Pyongyang": "bhg,0,b8|||",
                "Reunion": "b4,0,19m,0,b8|||",
                "Rothera": "bhf,0,b8|||",
                "Sakhalin": "61i,0,hm,0,f6|61i,0,fv,0,b8||",
                "Samara": "61j,0,hm,0,f6|61j,0,fv,0,b8||",
                "Samoa": "61k,0,hm,0,f6|61k,0,fv,0,b8||",
                "Seychelles": "4q8,0,19m,0,b8|||",
                "Singapore": "bhe,0,hm,0,f6|||",
                "Solomon": "mq,0,19m,0,b8|||",
                "South_Georgia": "bhd,0,4m0,0,b8|||",
                "Suriname": "bhc,0,b8|||",
                "Syowa": "bhb,0,b8|||",
                "Tahiti": "bha,0,b8|||",
                "Taipei": "61q,0,hm,0,f6|61q,0,fv,0,b8||",
                "Tajikistan": "bh9,0,b8|||",
                "Tokelau": "bh8,0,b8|||",
                "Tonga": "61u,0,hm,0,f6|61u,0,fv,0,b8||",
                "Truk": "bh7,0,b8|||",
                "Turkmenistan": "620,0,hm,0,f6|620,0,fv,0,b8||",
                "Tuvalu": "bh6,0,b8|||",
                "Uruguay": "624,0,hm,0,f6|624,0,fv,0,b8||",
                "Uzbekistan": "627,0,hm,0,f6|627,0,fv,0,b8||",
                "Vanuatu": "628,0,hm,0,f6|628,0,fv,0,b8||",
                "Venezuela": "bh1,0,b8|||",
                "Vladivostok": "62e,0,hm,0,f6|62e,0,fv,0,b8||",
                "Volgograd": "62f,0,hm,0,f6|62f,0,fv,0,b8||",
                "Vostok": "bh0,0,b8|||",
                "Wake": "5r,0,31a,0,b8|||",
                "Wallis": "5f,0,3l0,0,bgv,0,13l|||",
                "Yakutsk": "62l,0,hm,0,f6|62l,0,fv,0,b8||",
                "Yekaterinburg": "bgu,0,hm,0,f6|bgt,0,fv,0,b8||"
            }
        },
        "ewo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "fa-AF": {
            "gmtFormat": "{0} گرینویچ",
            "gmtZeroFormat": "گرینویچ",
            "zone": {
                "Europe/Dublin": "|1n,0,92,0,6js||",
                "Europe/London": "|1n,0,9f,0,6ha||"
            },
            "metazone": {
                "Afghanistan": "1n,0,3ki|||",
                "Africa_Central": "1n,0,14g,0,1kr|||",
                "Africa_Eastern": "1n,0,51,0,1kr|||",
                "Africa_Southern": "1n,0,92,0,ij,0,1kr|||",
                "Africa_Western": "1n,0,92,0,2e,0,1kr|1n,0,9f,0,2e,0,1kr||",
                "Alaska": "1n,0,92,0,3kh|1n,0,9f,0,3kh||",
                "Almaty": "1n,0,92,0,3kg|1n,0,9f,0,3kg||",
                "Amazon": "1n,0,92,0,3kf|1n,0,9f,0,3kf||",
                "America_Central": "1n,0,92,0,14g,0,18i|1n,0,9f,0,14g,0,18i||",
                "America_Eastern": "1n,0,92,0,51,0,18i|1n,0,9f,0,51,0,18i||",
                "America_Mountain": "1n,0,92,0,3k8,0,18i|1n,0,9f,0,3k8,0,18i||",
                "America_Pacific": "1n,0,92,0,2e,0,18i|1n,0,9f,0,2e,0,18i||",
                "Anadyr": "1n,0,92,0,3k7|1n,0,9f,0,3k7||",
                "Apia": "1n,0,92,0,3k6|1n,0,9f,0,3k6||",
                "Arabian": "1n,0,92,0,3k5|1n,0,9f,0,3k5||",
                "Argentina": "1n,0,92,0,20j|1n,0,9f,0,20j||",
                "Argentina_Western": "1n,0,92,0,2e,0,20j|1n,0,9f,0,2e,0,20j||",
                "Armenia": "1n,0,92,0,3k4|1n,0,9f,0,3k4||",
                "Atlantic": "1n,0,92,0,3k2|1n,0,9f,0,3k2||",
                "Australia_Central": "1n,0,92,0,14g,0,18h|1n,0,9f,0,14g,0,18h||",
                "Australia_CentralWestern": "1n,0,92,0,14g,5,2e,0,18h|1n,0,9f,0,14g,5,2e,0,18h||",
                "Australia_Eastern": "1n,0,92,0,51,0,18h|1n,0,9f,0,51,0,18h||",
                "Australia_Western": "1n,0,92,0,2e,0,18h|1n,0,9f,0,2e,0,18h||",
                "Azerbaijan": "1n,0,92,0,3k0,0,3jv|1n,0,9f,0,3k0,0,3jv||",
                "Azores": "1n,0,92,0,3jt|1n,0,9f,0,3jt||",
                "Bangladesh": "1n,0,92,0,3js|1n,0,9f,0,3js||",
                "Bhutan": "1n,0,rp|||",
                "Bolivia": "1n,0,63u|||",
                "Brasilia": "1n,0,92,0,20q|1n,0,9f,0,20q||",
                "Brunei": "1n,0,3jr,0,3jq|||",
                "Cape_Verde": "1n,0,92,0,3jm|1n,0,9f,0,3jm||",
                "Chamorro": "1n,0,92,0,3ji|||",
                "Chatham": "1n,0,92,0,3jh|1n,0,9f,0,3jh||",
                "Chile": "1n,0,92,0,3jd|1n,0,9f,0,3jd||",
                "China": "1n,0,92,0,211|1n,0,9f,0,211||",
                "Choibalsan": "1n,0,92,0,3jc|1n,0,9f,0,3jc||",
                "Christmas": "1n,0,1p0,0,64o|||",
                "Cocos": "1n,0,113,0,3jb|||",
                "Colombia": "1n,0,92,0,3j9|1n,0,9f,0,3j9||",
                "Cook": "1n,0,92,0,113,0,3j8|1n,0,9f,0,113,0,3j8||",
                "Cuba": "1n,0,92,0,3j7|1n,0,9f,0,3j7||",
                "Davis": "1n,0,653|||",
                "DumontDUrville": "1n,0,654,0,655|||",
                "East_Timor": "1n,0,3j3,0,65a|||",
                "Easter": "1n,0,92,0,1p0,0,3j0|1n,0,9f,0,1p0,0,3j0||",
                "Ecuador": "1n,0,65i|||",
                "Europe_Central": "1n,0,92,0,14g,0,19h|1n,0,9f,0,14g,0,19h||",
                "Europe_Eastern": "1n,0,92,0,51,0,19h|1n,0,9f,0,51,0,19h||",
                "Europe_Further_Eastern": "1n,0,9f,0,65n,0,65r,0,51,0,19h|||",
                "Europe_Western": "1n,0,92,0,2e,0,19h|1n,0,9f,0,2e,0,19h||",
                "Falkland": "1n,0,92,0,113,0,3iv|1n,0,9f,0,113,0,3iv||",
                "Fiji": "1n,0,92,0,3ir|1n,0,9f,0,3ir||",
                "French_Guiana": "1n,0,3iq,0,3ip|||",
                "French_Southern": "1n,0,662,0,1ot,0,pu,0,664,0,3ip|||",
                "Galapagos": "1n,0,4nd|||",
                "Gambier": "1n,0,666|||",
                "Georgia": "1n,0,92,0,3ij|1n,0,9f,0,3ij||",
                "Gilbert_Islands": "1n,0,113,0,668|||",
                "GMT": "1n,0,66a|||",
                "Greenland_Eastern": "1n,0,92,0,51,0,21j|1n,0,9f,0,51,0,21j||",
                "Greenland_Western": "1n,0,92,0,2e,0,21j|1n,0,9f,0,2e,0,21j||",
                "Guam": "1n,0,92,0,66d|||",
                "Gulf": "1n,0,92,0,3ii,0,66j|||",
                "Guyana": "1n,0,3iq|||",
                "Hawaii_Aleutian": "1n,0,92,0,3ig|1n,0,9f,0,3ig||",
                "Hong_Kong": "1n,0,92,0,3ie|1n,0,9f,0,3ie||",
                "Hovd": "1n,0,92,0,3id|1n,0,9f,0,3id||",
                "India": "1n,0,3ic|||",
                "Indian_Ocean": "1n,0,66s,0,3ic|||",
                "Indochina": "1n,0,66t|||",
                "Indonesia_Central": "1n,0,14g,0,2at|||",
                "Indonesia_Eastern": "1n,0,51,0,2at|||",
                "Indonesia_Western": "1n,0,2e,0,2at|||",
                "Iran": "1n,0,92,0,21q|1n,0,9f,0,21q||",
                "Irkutsk": "1n,0,92,0,3ib|1n,0,9f,0,3ib||",
                "Israel": "1n,0,92,0,21s|1n,0,9f,0,21s||",
                "Japan": "1n,0,92,0,3ia|1n,0,9f,0,3ia||",
                "Kamchatka": "1n,0,92,0,3i9|1n,0,9f,0,3i9||",
                "Kazakhstan_Eastern": "1n,0,51,0,3i8|||",
                "Kazakhstan_Western": "1n,0,2e,0,3i8|||",
                "Korea": "1n,0,92,0,3i7|1n,0,9f,0,3i7||",
                "Kosrae": "1n,0,67a|||",
                "Krasnoyarsk": "1n,0,92,0,3i6|1n,0,9f,0,3i6||",
                "Kyrgystan": "1n,0,67c|||",
                "Lanka": "1n,0,67d|||",
                "Line_Islands": "1n,0,113,0,67e|||",
                "Lord_Howe": "1n,0,92,0,3i3|1n,0,9f,0,3i3||",
                "Macau": "1n,0,92,0,3hj|1n,0,9f,0,3hj||",
                "Macquarie": "1n,0,1p0,0,67l|||",
                "Magadan": "1n,0,92,0,2al|1n,0,9f,0,2al||",
                "Malaysia": "1n,0,67n|||",
                "Maldives": "1n,0,67p|||",
                "Marquesas": "1n,0,67q|||",
                "Marshall_Islands": "1n,0,113,0,rb|||",
                "Mauritius": "1n,0,92,0,3hi|1n,0,9f,0,3hi||",
                "Mawson": "1n,0,rj|||",
                "Mexico_Northwest": "1n,0,92,0,225,0,2e,0,226|1n,0,9f,0,225,0,2e,0,226||",
                "Mexico_Pacific": "1n,0,92,0,51,0,226|1n,0,9f,0,51,0,226||",
                "Mongolia": "1n,0,92,0,3hh|1n,0,9f,0,3hh||",
                "Moscow": "1n,0,92,0,3hd|1n,0,9f,0,3hd||",
                "Myanmar": "1n,0,3hc|||",
                "Nauru": "1n,0,684|||",
                "Nepal": "1n,0,685|||",
                "New_Caledonia": "1n,0,92,0,3hb,0,3h7|1n,0,9f,0,3hb,0,3h7||",
                "New_Zealand": "1n,0,92,0,3h3,0,2jl|1n,0,9f,0,3h3,0,2jl||",
                "Newfoundland": "1n,0,92,0,3h2|1n,0,9f,0,3h2||",
                "Niue": "1n,0,68b|||",
                "Norfolk": "1n,0,113,0,68c|||",
                "Noronha": "1n,0,92,0,ig,0,3gd,0,3g9|1n,0,9f,0,ig,0,3gd,0,3g9||",
                "North_Mariana": "1n,0,113,0,68f,0,68g|||",
                "Novosibirsk": "1n,0,92,0,3g8|1n,0,9f,0,3g8||",
                "Omsk": "1n,0,92,0,22h|1n,0,9f,0,22h||",
                "Pakistan": "1n,0,92,0,22i|1n,0,9f,0,22i||",
                "Palau": "1n,0,68l|||",
                "Papua_New_Guinea": "1n,0,68m,0,68n,0,2jl|||",
                "Paraguay": "1n,0,92,0,3g7|1n,0,9f,0,3g7||",
                "Peru": "1n,0,92,0,3g6|1n,0,9f,0,3g6||",
                "Philippines": "1n,0,92,0,3g5|1n,0,9f,0,3g5||",
                "Phoenix_Islands": "1n,0,113,0,68t|||",
                "Pierre_Miquelon": "1n,0,92,0,3g4,0,pu,0,3g3|1n,0,9f,0,3g4,0,pu,0,3g3||",
                "Pitcairn": "1n,0,690|||",
                "Ponape": "1n,0,691|||",
                "Pyongyang": "1n,0,694|||",
                "Qyzylorda": "1n,0,92,0,3g2|1n,0,9f,0,3g2||",
                "Reunion": "1n,0,696|||",
                "Rothera": "1n,0,69a|||",
                "Sakhalin": "1n,0,92,0,3g1|1n,0,9f,0,3g1||",
                "Samara": "1n,0,92,0,2ij|1n,0,9f,0,2ij||",
                "Samoa": "1n,0,92,0,ie|1n,0,9f,0,ie||",
                "Seychelles": "1n,0,69d|||",
                "Singapore": "1n,0,3g0|||",
                "Solomon": "1n,0,113,0,69g|||",
                "South_Georgia": "1n,0,69i,0,1ot|||",
                "Suriname": "1n,0,3fv|||",
                "Syowa": "1n,0,69k|||",
                "Tahiti": "1n,0,69l|||",
                "Taipei": "1n,0,92,0,3fu|1n,0,9f,0,3fu||",
                "Tajikistan": "1n,0,69n|||",
                "Tokelau": "1n,0,69o|||",
                "Tonga": "1n,0,92,0,2ho|1n,0,9f,0,2ho||",
                "Truk": "1n,0,69q|||",
                "Turkmenistan": "1n,0,92,0,3fr|1n,0,9f,0,3fr||",
                "Tuvalu": "1n,0,69s|||",
                "Uruguay": "1n,0,92,0,3fq|1n,0,9f,0,3fq||",
                "Uzbekistan": "1n,0,92,0,231|1n,0,9f,0,231||",
                "Vanuatu": "1n,0,92,0,3fp|1n,0,9f,0,3fp||",
                "Venezuela": "1n,0,6a0|||",
                "Vladivostok": "1n,0,92,0,3fo|1n,0,9f,0,3fo||",
                "Volgograd": "1n,0,92,0,3fn|1n,0,9f,0,3fn||",
                "Vostok": "1n,0,6a3|||",
                "Wake": "1n,0,1p0,0,2pn|||",
                "Wallis": "1n,0,6a5,0,pu,0,rg|||",
                "Yakutsk": "1n,0,92,0,3fm|1n,0,9f,0,3fm||",
                "Yekaterinburg": "1n,0,92,0,3fl|1n,0,9f,0,3fl||"
            }
        },
        "fa": {
            "gmtFormat": "{0} گرینویچ",
            "gmtZeroFormat": "گرینویچ",
            "zone": {
                "Europe/Dublin": "|1n,0,92,0,6js||",
                "Europe/London": "|1n,0,9f,0,6ha||"
            },
            "metazone": {
                "Afghanistan": "1n,0,3ki|||",
                "Africa_Central": "1n,0,14g,0,1kr|||",
                "Africa_Eastern": "1n,0,51,0,1kr|||",
                "Africa_Southern": "1n,0,92,0,ij,0,1kr|||",
                "Africa_Western": "1n,0,92,0,2e,0,1kr|1n,0,9f,0,2e,0,1kr||",
                "Alaska": "1n,0,92,0,3kh|1n,0,9f,0,3kh||",
                "Almaty": "1n,0,92,0,3kg|1n,0,9f,0,3kg||",
                "Amazon": "1n,0,92,0,3kf|1n,0,9f,0,3kf||",
                "America_Central": "1n,0,92,0,14g,0,18i|1n,0,9f,0,14g,0,18i||",
                "America_Eastern": "1n,0,92,0,51,0,18i|1n,0,9f,0,51,0,18i||",
                "America_Mountain": "1n,0,92,0,3k8,0,18i|1n,0,9f,0,3k8,0,18i||",
                "America_Pacific": "1n,0,92,0,2e,0,18i|1n,0,9f,0,2e,0,18i||",
                "Anadyr": "1n,0,92,0,3k7|1n,0,9f,0,3k7||",
                "Apia": "1n,0,92,0,3k6|1n,0,9f,0,3k6||",
                "Arabian": "1n,0,92,0,3k5|1n,0,9f,0,3k5||",
                "Argentina": "1n,0,92,0,20j|1n,0,9f,0,20j||",
                "Argentina_Western": "1n,0,92,0,2e,0,20j|1n,0,9f,0,2e,0,20j||",
                "Armenia": "1n,0,92,0,3k4|1n,0,9f,0,3k4||",
                "Atlantic": "1n,0,92,0,3k2|1n,0,9f,0,3k2||",
                "Australia_Central": "1n,0,92,0,14g,0,18h|1n,0,9f,0,14g,0,18h||",
                "Australia_CentralWestern": "1n,0,92,0,14g,5,2e,0,18h|1n,0,9f,0,14g,5,2e,0,18h||",
                "Australia_Eastern": "1n,0,92,0,51,0,18h|1n,0,9f,0,51,0,18h||",
                "Australia_Western": "1n,0,92,0,2e,0,18h|1n,0,9f,0,2e,0,18h||",
                "Azerbaijan": "1n,0,92,0,3k0,0,3jv|1n,0,9f,0,3k0,0,3jv||",
                "Azores": "1n,0,92,0,3jt|1n,0,9f,0,3jt||",
                "Bangladesh": "1n,0,92,0,3js|1n,0,9f,0,3js||",
                "Bhutan": "1n,0,rp|||",
                "Bolivia": "1n,0,63u|||",
                "Brasilia": "1n,0,92,0,20q|1n,0,9f,0,20q||",
                "Brunei": "1n,0,3jr,0,3jq|||",
                "Cape_Verde": "1n,0,92,0,3jm|1n,0,9f,0,3jm||",
                "Chamorro": "1n,0,92,0,3ji|||",
                "Chatham": "1n,0,92,0,3jh|1n,0,9f,0,3jh||",
                "Chile": "1n,0,92,0,3jd|1n,0,9f,0,3jd||",
                "China": "1n,0,92,0,211|1n,0,9f,0,211||",
                "Choibalsan": "1n,0,92,0,3jc|1n,0,9f,0,3jc||",
                "Christmas": "1n,0,1p0,0,64o|||",
                "Cocos": "1n,0,113,0,3jb|||",
                "Colombia": "1n,0,92,0,3j9|1n,0,9f,0,3j9||",
                "Cook": "1n,0,92,0,113,0,3j8|1n,0,9f,0,113,0,3j8||",
                "Cuba": "1n,0,92,0,3j7|1n,0,9f,0,3j7||",
                "Davis": "1n,0,653|||",
                "DumontDUrville": "1n,0,654,0,655|||",
                "East_Timor": "1n,0,3j3,0,65a|||",
                "Easter": "1n,0,92,0,1p0,0,3j0|1n,0,9f,0,1p0,0,3j0||",
                "Ecuador": "1n,0,65i|||",
                "Europe_Central": "1n,0,92,0,14g,0,19h|1n,0,9f,0,14g,0,19h||",
                "Europe_Eastern": "1n,0,92,0,51,0,19h|1n,0,9f,0,51,0,19h||",
                "Europe_Further_Eastern": "1n,0,9f,0,65n,0,65r,0,51,0,19h|||",
                "Europe_Western": "1n,0,92,0,2e,0,19h|1n,0,9f,0,2e,0,19h||",
                "Falkland": "1n,0,92,0,113,0,3iv|1n,0,9f,0,113,0,3iv||",
                "Fiji": "1n,0,92,0,3ir|1n,0,9f,0,3ir||",
                "French_Guiana": "1n,0,3iq,0,3ip|||",
                "French_Southern": "1n,0,662,0,1ot,0,pu,0,664,0,3ip|||",
                "Galapagos": "1n,0,4nd|||",
                "Gambier": "1n,0,666|||",
                "Georgia": "1n,0,92,0,3ij|1n,0,9f,0,3ij||",
                "Gilbert_Islands": "1n,0,113,0,668|||",
                "GMT": "1n,0,66a|||",
                "Greenland_Eastern": "1n,0,92,0,51,0,21j|1n,0,9f,0,51,0,21j||",
                "Greenland_Western": "1n,0,92,0,2e,0,21j|1n,0,9f,0,2e,0,21j||",
                "Guam": "1n,0,92,0,66d|||",
                "Gulf": "1n,0,92,0,3ii,0,66j|||",
                "Guyana": "1n,0,3iq|||",
                "Hawaii_Aleutian": "1n,0,92,0,3ig|1n,0,9f,0,3ig||",
                "Hong_Kong": "1n,0,92,0,3ie|1n,0,9f,0,3ie||",
                "Hovd": "1n,0,92,0,3id|1n,0,9f,0,3id||",
                "India": "1n,0,3ic|||",
                "Indian_Ocean": "1n,0,66s,0,3ic|||",
                "Indochina": "1n,0,66t|||",
                "Indonesia_Central": "1n,0,14g,0,2at|||",
                "Indonesia_Eastern": "1n,0,51,0,2at|||",
                "Indonesia_Western": "1n,0,2e,0,2at|||",
                "Iran": "1n,0,92,0,21q|1n,0,9f,0,21q||",
                "Irkutsk": "1n,0,92,0,3ib|1n,0,9f,0,3ib||",
                "Israel": "1n,0,92,0,21s|1n,0,9f,0,21s||",
                "Japan": "1n,0,92,0,3ia|1n,0,9f,0,3ia||",
                "Kamchatka": "1n,0,92,0,3i9|1n,0,9f,0,3i9||",
                "Kazakhstan_Eastern": "1n,0,51,0,3i8|||",
                "Kazakhstan_Western": "1n,0,2e,0,3i8|||",
                "Korea": "1n,0,92,0,3i7|1n,0,9f,0,3i7||",
                "Kosrae": "1n,0,67a|||",
                "Krasnoyarsk": "1n,0,92,0,3i6|1n,0,9f,0,3i6||",
                "Kyrgystan": "1n,0,67c|||",
                "Lanka": "1n,0,67d|||",
                "Line_Islands": "1n,0,113,0,67e|||",
                "Lord_Howe": "1n,0,92,0,3i3|1n,0,9f,0,3i3||",
                "Macau": "1n,0,92,0,3hj|1n,0,9f,0,3hj||",
                "Macquarie": "1n,0,1p0,0,67l|||",
                "Magadan": "1n,0,92,0,2al|1n,0,9f,0,2al||",
                "Malaysia": "1n,0,67n|||",
                "Maldives": "1n,0,67p|||",
                "Marquesas": "1n,0,67q|||",
                "Marshall_Islands": "1n,0,113,0,rb|||",
                "Mauritius": "1n,0,92,0,3hi|1n,0,9f,0,3hi||",
                "Mawson": "1n,0,rj|||",
                "Mexico_Northwest": "1n,0,92,0,225,0,2e,0,226|1n,0,9f,0,225,0,2e,0,226||",
                "Mexico_Pacific": "1n,0,92,0,51,0,226|1n,0,9f,0,51,0,226||",
                "Mongolia": "1n,0,92,0,3hh|1n,0,9f,0,3hh||",
                "Moscow": "1n,0,92,0,3hd|1n,0,9f,0,3hd||",
                "Myanmar": "1n,0,3hc|||",
                "Nauru": "1n,0,684|||",
                "Nepal": "1n,0,685|||",
                "New_Caledonia": "1n,0,92,0,3hb,0,3h7|1n,0,9f,0,3hb,0,3h7||",
                "New_Zealand": "1n,0,92,0,3h3,0,2jl|1n,0,9f,0,3h3,0,2jl||",
                "Newfoundland": "1n,0,92,0,3h2|1n,0,9f,0,3h2||",
                "Niue": "1n,0,68b|||",
                "Norfolk": "1n,0,113,0,68c|||",
                "Noronha": "1n,0,92,0,ig,0,3gd,0,3g9|1n,0,9f,0,ig,0,3gd,0,3g9||",
                "North_Mariana": "1n,0,113,0,68f,0,68g|||",
                "Novosibirsk": "1n,0,92,0,3g8|1n,0,9f,0,3g8||",
                "Omsk": "1n,0,92,0,22h|1n,0,9f,0,22h||",
                "Pakistan": "1n,0,92,0,22i|1n,0,9f,0,22i||",
                "Palau": "1n,0,68l|||",
                "Papua_New_Guinea": "1n,0,68m,0,68n,0,2jl|||",
                "Paraguay": "1n,0,92,0,3g7|1n,0,9f,0,3g7||",
                "Peru": "1n,0,92,0,3g6|1n,0,9f,0,3g6||",
                "Philippines": "1n,0,92,0,3g5|1n,0,9f,0,3g5||",
                "Phoenix_Islands": "1n,0,113,0,68t|||",
                "Pierre_Miquelon": "1n,0,92,0,3g4,0,pu,0,3g3|1n,0,9f,0,3g4,0,pu,0,3g3||",
                "Pitcairn": "1n,0,690|||",
                "Ponape": "1n,0,691|||",
                "Pyongyang": "1n,0,694|||",
                "Qyzylorda": "1n,0,92,0,3g2|1n,0,9f,0,3g2||",
                "Reunion": "1n,0,696|||",
                "Rothera": "1n,0,69a|||",
                "Sakhalin": "1n,0,92,0,3g1|1n,0,9f,0,3g1||",
                "Samara": "1n,0,92,0,2ij|1n,0,9f,0,2ij||",
                "Samoa": "1n,0,92,0,ie|1n,0,9f,0,ie||",
                "Seychelles": "1n,0,69d|||",
                "Singapore": "1n,0,3g0|||",
                "Solomon": "1n,0,113,0,69g|||",
                "South_Georgia": "1n,0,69i,0,1ot|||",
                "Suriname": "1n,0,3fv|||",
                "Syowa": "1n,0,69k|||",
                "Tahiti": "1n,0,69l|||",
                "Taipei": "1n,0,92,0,3fu|1n,0,9f,0,3fu||",
                "Tajikistan": "1n,0,69n|||",
                "Tokelau": "1n,0,69o|||",
                "Tonga": "1n,0,92,0,2ho|1n,0,9f,0,2ho||",
                "Truk": "1n,0,69q|||",
                "Turkmenistan": "1n,0,92,0,3fr|1n,0,9f,0,3fr||",
                "Tuvalu": "1n,0,69s|||",
                "Uruguay": "1n,0,92,0,3fq|1n,0,9f,0,3fq||",
                "Uzbekistan": "1n,0,92,0,231|1n,0,9f,0,231||",
                "Vanuatu": "1n,0,92,0,3fp|1n,0,9f,0,3fp||",
                "Venezuela": "1n,0,6a0|||",
                "Vladivostok": "1n,0,92,0,3fo|1n,0,9f,0,3fo||",
                "Volgograd": "1n,0,92,0,3fn|1n,0,9f,0,3fn||",
                "Vostok": "1n,0,6a3|||",
                "Wake": "1n,0,1p0,0,2pn|||",
                "Wallis": "1n,0,6a5,0,pu,0,rg|||",
                "Yakutsk": "1n,0,92,0,3fm|1n,0,9f,0,3fm||",
                "Yekaterinburg": "1n,0,92,0,3fl|1n,0,9f,0,3fl||"
            }
        },
        "ff-CM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ff-GN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ff-MR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ff": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "fi": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|ca7,0,ef||",
                "Europe/London": "|ca8,0,ef||"
            },
            "metazone": {
                "Acre": "6a8,0,ee|6a8,0,ef||",
                "Afghanistan": "bgs,0,hd|||",
                "Africa_Central": "23b,5,2q0,0,hd|||",
                "Africa_Eastern": "1li,5,2q0,0,hd|||",
                "Africa_Southern": "6ag,5,2q0,0,hd|||",
                "Africa_Western": "1f6,5,2q0,0,ee|1f6,5,2q0,0,ef||",
                "Alaska": "6ai,0,ee|6ai,0,ef||",
                "Almaty": "6aj,0,ee|6aj,0,ef||",
                "Amazon": "6ak,0,ee|6ak,0,ef||",
                "America_Central": "2ck,0,6am,0,ee|2ck,0,6am,0,ef||",
                "America_Eastern": "2ck,0,6an,0,ee|2ck,0,6an,0,ef||",
                "America_Mountain": "6ao,0,ee|6ao,0,ef||",
                "America_Pacific": "2ck,0,3fi,0,ee|2ck,0,3fi,0,ef||",
                "Anadyr": "6aq,0,ee|6aq,0,ef||",
                "Apia": "6ar,0,ee|6ar,0,ef||",
                "Aqtau": "6as,0,ee|6as,0,ef||",
                "Aqtobe": "6at,0,ee|6at,0,ef||",
                "Arabian": "6au,5,87,0,ee|6au,5,87,0,ef||",
                "Argentina": "3fh,0,ee|3fh,0,ef||",
                "Argentina_Western": "1f6,5,3fh,0,ee|1f6,5,3fh,0,ef||",
                "Armenia": "6b0,0,ee|6b0,0,ef||",
                "Atlantic": "6b1,0,6b2,0,ee|6b1,0,6b2,0,ef||",
                "Australia_Central": "23b,5,13,0,ee|23b,5,13,0,ef||",
                "Australia_CentralWestern": "6b3,0,23b,5,13,0,ee|6b3,0,23b,5,13,0,ef||",
                "Australia_Eastern": "1li,5,13,0,ee|1li,5,13,0,ef||",
                "Australia_Western": "1f6,5,13,0,ee|1f6,5,13,0,ef||",
                "Azerbaijan": "6b4,0,ee|6b4,0,ef||",
                "Azores": "6b5,0,ee|6b5,0,ef||",
                "Bangladesh": "6b6,0,ee|6b6,0,ef||",
                "Bhutan": "bgr,0,hd|||",
                "Bolivia": "bgq,0,hd|||",
                "Brasilia": "6b9,0,ee|6b9,0,ef||",
                "Brunei": "bgp,0,hd|||",
                "Cape_Verde": "1l8,0,6bc,0,ee|1l8,0,6bc,0,ef||",
                "Casey": "bgo,0,hd|||",
                "Chamorro": "bgn,0,hd|||",
                "Chatham": "6bf,0,ee|6bf,0,ef||",
                "Chile": "6bg,0,ee|6bg,0,ef||",
                "China": "6bh,0,ee|6bh,0,ef||",
                "Choibalsan": "6bi,0,ee|6bi,0,ef||",
                "Christmas": "bgm,0,hd|||",
                "Cocos": "bgl,0,hd|||",
                "Colombia": "6bl,0,ee|6bl,0,ef||",
                "Cook": "6bm,0,ee|6bm,0,ef||",
                "Cuba": "6bn,0,ee|6bn,0,ef||",
                "Davis": "bgk,0,hd|||",
                "DumontDUrville": "5b,5,bgj,0,hd|||",
                "East_Timor": "1li,5,bgi,0,hd|||",
                "Easter": "6br,0,ee|6br,0,ef||",
                "Ecuador": "bgh,0,hd|||",
                "Europe_Central": "23b,5,268,0,ee|23b,5,268,0,ef||",
                "Europe_Eastern": "1li,5,268,0,ee|1li,5,268,0,ef||",
                "Europe_Further_Eastern": "bgg,0,268,0,hd|||",
                "Europe_Western": "1f6,5,268,0,ee|1f6,5,268,0,ef||",
                "Falkland": "6bv,0,ee|6bv,0,ef||",
                "Fiji": "6c0,0,ee|6c0,0,ef||",
                "French_Guiana": "6c1,0,bgf,0,hd|||",
                "French_Southern": "6c1,0,bge,0,1pq,0,bgd,0,bgc,0,hd|||",
                "Galapagos": "bgb,0,hd|||",
                "Gambier": "bga,0,hd|||",
                "Georgia": "4pe,0,ee|4pe,0,ef||",
                "Gilbert_Islands": "bg9,0,hd|||",
                "GMT": "bg8,0,ee|||",
                "Greenland_Eastern": "1li,5,3ev,0,ee|1li,5,3ev,0,ef||",
                "Greenland_Western": "1f6,5,3ev,0,ee|1f6,5,3ev,0,ef||",
                "Guam": "bg7,0,hd|||",
                "Gulf": "bg6,0,ee|||",
                "Guyana": "bg5,0,hd|||",
                "Hawaii_Aleutian": "6cf,5,6cg,0,ee|6cf,5,6cg,0,ef||",
                "Hong_Kong": "6ch,0,ee|6ch,0,ef||",
                "Hovd": "6ci,0,ee|6ci,0,ef||",
                "India": "6cj,0,hd|||",
                "Indian_Ocean": "6cj,0,bg4,0,hd|||",
                "Indochina": "bg3,0,hd|||",
                "Indonesia_Central": "23b,5,4pg,0,hd|||",
                "Indonesia_Eastern": "1li,5,4pg,0,hd|||",
                "Indonesia_Western": "1f6,5,4pg,0,hd|||",
                "Iran": "6cn,0,ee|6cn,0,ef||",
                "Irkutsk": "6cp,0,ee|6cp,0,ef||",
                "Israel": "6cq,0,ee|6cq,0,ef||",
                "Japan": "6cr,0,ee|6cr,0,ef||",
                "Kamchatka": "6cs,0,ee|6cs,0,ef||",
                "Kazakhstan_Eastern": "1li,5,6ct,0,hd|||",
                "Kazakhstan_Western": "1f6,5,6ct,0,hd|||",
                "Korea": "88,0,ee|88,0,ef||",
                "Kosrae": "bg2,0,hd|||",
                "Krasnoyarsk": "6cv,0,ee|6cv,0,ef||",
                "Kyrgystan": "bg1,0,hd|||",
                "Lanka": "me,0,bg0,0,hd|||",
                "Line_Islands": "bfv,0,hd|||",
                "Lord_Howe": "1u,0,6d3,0,ee|1u,0,6d3,0,ef||",
                "Macau": "6d4,0,ee|6d4,0,ef||",
                "Macquarie": "bfu,0,hd|||",
                "Magadan": "6d6,0,ee|6d6,0,ef||",
                "Malaysia": "bft,0,hd|||",
                "Maldives": "bfs,0,hd|||",
                "Marquesas": "bfr,0,hd|||",
                "Marshall_Islands": "bfq,0,hd|||",
                "Mauritius": "6db,0,ee|6db,0,ef||",
                "Mawson": "bfp,0,hd|||",
                "Mexico_Northwest": "6dd,5,3el,0,ee|6dd,5,3el,0,ef||",
                "Mexico_Pacific": "3el,0,3fi,0,ee|3el,0,3fi,0,ef||",
                "Mongolia": "4f,0,6df,0,ee|4f,0,6df,0,ef||",
                "Moscow": "6dg,0,ee|6dg,0,ef||",
                "Myanmar": "bfo,0,hd|||",
                "Nauru": "bfn,0,hd|||",
                "Nepal": "bfm,0,hd|||",
                "New_Caledonia": "2qv,5,6dl,0,ee|2qv,5,6dl,0,ef||",
                "New_Zealand": "2qv,5,6dm,0,ee|2qv,5,6dm,0,ef||",
                "Newfoundland": "6dn,0,ee|6dn,0,ef||",
                "Niue": "bfl,0,hd|||",
                "Norfolk": "bfk,0,hd|||",
                "Noronha": "1s,0,2,0,6dq,0,ee|1s,0,2,0,6dq,0,ef||",
                "North_Mariana": "bfj,5,bfi,0,hd|||",
                "Novosibirsk": "6dt,0,ee|6dt,0,ef||",
                "Omsk": "6du,0,ee|6du,0,ef||",
                "Pakistan": "6dv,0,ee|6dv,0,ef||",
                "Palau": "bfh,0,hd|||",
                "Papua_New_Guinea": "9a,5,2qv,5,bfg,0,hd|||",
                "Paraguay": "6e2,0,ee|6e2,0,ef||",
                "Peru": "6e3,0,ee|6e3,0,ef||",
                "Philippines": "6e4,0,ee|6e4,0,ef||",
                "Phoenix_Islands": "bff,0,hd|||",
                "Pierre_Miquelon": "8i,5,6e6,0,1pq,0,6e7,0,ee|8i,5,6e6,0,1pq,0,6e7,0,ef||",
                "Pitcairn": "bfe,0,hd|||",
                "Ponape": "bfd,0,hd|||",
                "Pyongyang": "bfc,0,hd|||",
                "Qyzylorda": "6ec,0,ee|6ec,0,ef||",
                "Reunion": "bfb,0,hd|||",
                "Rothera": "bfa,0,hd|||",
                "Sakhalin": "6ef,0,ee|6ef,0,ef||",
                "Samara": "6eg,0,ee|6eg,0,ef||",
                "Samoa": "6eh,0,ee|6eh,0,ef||",
                "Seychelles": "bf9,0,hd|||",
                "Singapore": "bf8,0,hd|||",
                "Solomon": "bf7,0,hd|||",
                "South_Georgia": "6ag,5,4pe,0,hd|||",
                "Suriname": "bf6,0,hd|||",
                "Syowa": "bf5,0,hd|||",
                "Tahiti": "bf4,0,hd|||",
                "Taipei": "6eo,0,ee|6eo,0,ef||",
                "Tajikistan": "bf3,0,hd|||",
                "Tokelau": "bf2,0,hd|||",
                "Tonga": "6er,0,ee|6er,0,ef||",
                "Truk": "bf1,0,hd|||",
                "Turkmenistan": "6et,0,ee|6et,0,ef||",
                "Tuvalu": "bf0,0,hd|||",
                "Uruguay": "6ev,0,ee|6ev,0,ef||",
                "Uzbekistan": "6f0,0,ee|6f0,0,ef||",
                "Vanuatu": "6f1,0,ee|6f1,0,ef||",
                "Venezuela": "bev,0,hd|||",
                "Vladivostok": "6f3,0,ee|6f3,0,ef||",
                "Volgograd": "6f4,0,ee|6f4,0,ef||",
                "Vostok": "beu,0,hd|||",
                "Wake": "bet,0,hd|||",
                "Wallis": "bes,0,1pq,0,ber,0,hd|||",
                "Yakutsk": "6fa,0,ee|6fa,0,ef||",
                "Yekaterinburg": "6fb,0,ee|6fb,0,ef||"
            }
        },
        "fil": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4,0,52,0,8r,0,8c,0,3i4||",
                "Europe/London": "|8r,0,8c,0,mc,5,mb,0,h8,0,caa||"
            },
            "metazone": {
                "Afghanistan": "8r,0,8c,0,b6|||",
                "Africa_Central": "8r,0,8c,0,24l,0,1t|||",
                "Africa_Eastern": "8r,0,8c,0,1qp,0,1t|||",
                "Africa_Southern": "8r,0,8c,0,6fg,0,1t|||",
                "Africa_Western": "4,0,52,0,8r,0,8c,0,1fi,0,1t|8r,0,8c,0,mc,5,mb,0,h8,0,1fi,0,1t||",
                "Alaska": "4,0,52,0,8r,0,8c,0,3p|c,0,1,0,8c,0,3p||",
                "Amazon": "4,0,52,0,8r,0,8c,0,5m|8r,0,8c,0,mc,5,mb,0,h8,0,5m||",
                "America_Central": "1qr,0,52,0,6fm,0,8r|1qr,0,52,0,c,0,1||",
                "America_Eastern": "17,0,52,0,4,0,52,0,8r|17,0,c,0,1||",
                "America_Mountain": "6fm,0,8r,0,8c,0,6fn|c,0,1,0,8c,0,6fn||",
                "America_Pacific": "4,0,52,0,8r,0,8c,0,3e8|c,0,1,0,8c,0,3e8||",
                "Anadyr": "4,0,1,0,8c,0,3l|6,0,1,0,8c,0,3l||",
                "Apia": "4,0,52,0,8r,0,8c,0,3e|3e,0,c,0,1||",
                "Arabian": "4,0,52,0,8r,0,8c,0,hs|c,0,1,0,8c,0,hs||",
                "Argentina": "4,0,52,0,8r,0,8c,0,1e|8r,0,8c,0,mc,5,mb,0,h8,0,1e||",
                "Argentina_Western": "4,0,52,0,8r,0,8c,0,1fi,0,1e|8r,0,8c,0,mc,5,mb,0,h8,0,1fi,0,1e||",
                "Armenia": "4,0,52,0,8r,0,8c,0,4l|8r,0,8c,0,mc,5,mb,0,h8,0,4l||",
                "Atlantic": "4,0,52,0,8r,0,8c,0,6fp|c,0,1,0,8c,0,6fp||",
                "Australia_Central": "4,0,1,0,h8,0,24l,0,24t|c,0,1,0,h8,0,24l,0,24t||",
                "Australia_CentralWestern": "4,0,1,0,h8,0,24l,0,6fr,0,h8,0,24t|c,0,1,0,h8,0,24l,0,6fr,0,h8,0,24t||",
                "Australia_Eastern": "4,0,1,0,h8,0,1qp,0,24t|c,0,1,0,h8,0,1qp,0,24t||",
                "Australia_Western": "4,0,1,0,h8,0,1fi,0,24t|c,0,1,0,8c,0,1fi,0,24t||",
                "Azerbaijan": "4,0,52,0,8r,0,8c,0,7m|8r,0,8c,0,mc,5,mb,0,h8,0,7m||",
                "Azores": "4,0,52,0,8r,0,8c,0,4r|8r,0,8c,0,mc,5,mb,0,h8,0,4r||",
                "Bangladesh": "4,0,52,0,8r,0,8c,0,3n|8r,0,8c,0,mc,5,mb,0,h8,0,3n||",
                "Bhutan": "8r,0,8c,0,as|||",
                "Bolivia": "8r,0,8c,0,aa|||",
                "Brasilia": "4,0,52,0,8r,0,8c,0,3a|8r,0,8c,0,mc,5,mb,0,h8,0,3a||",
                "Brunei": "8r,0,h8,0,9o,0,a4|||",
                "Cape_Verde": "4,0,52,0,8r,0,8c,0,7c,0,3j|8r,0,8c,0,mc,5,mb,0,h8,0,7c,0,3j||",
                "Chamorro": "4,0,52,0,8r,0,8c,0,6j|||",
                "Chatham": "4,0,52,0,8r,0,8c,0,27|c,0,1,0,8c,0,27||",
                "Chile": "4,0,52,0,8r,0,8c,0,49|8r,0,8c,0,mc,5,mb,0,h8,0,49||",
                "China": "4,0,52,0,8r,0,8c,0,4h|c,0,1,0,8c,0,4h||",
                "Choibalsan": "4,0,52,0,8r,0,8c,0,2q|8r,0,8c,0,mc,5,mb,0,h8,0,2q||",
                "Christmas": "8r,0,8c,0,99,0,1f|||",
                "Cocos": "8r,0,8c,0,7v,0,o|||",
                "Colombia": "4,0,52,0,8r,0,8c,0,4m|8r,0,8c,0,mc,5,mb,0,h8,0,4m||",
                "Cook": "4,0,52,0,8r,0,8c,0,2v,0,o|8r,0,8c,0,beq,0,h8,0,mc,5,mb,0,h8,0,2v,0,o||",
                "Cuba": "4,0,52,0,8r,0,8c,0,34|c,0,1,0,8c,0,34||",
                "Davis": "8r,0,8c,0,5s|||",
                "DumontDUrville": "8r,0,8c,0,5b,5,5j|||",
                "East_Timor": "8r,0,h8,0,1r,0,7n|||",
                "Easter": "4,0,52,0,8r,0,8c,0,7t,0,1f|8r,0,8c,0,mc,5,mb,0,h8,0,7t,0,1f||",
                "Ecuador": "8r,0,8c,0,ai|||",
                "Europe_Central": "4,0,52,0,8r,0,8c,0,24l,0,r4|8r,0,8c,0,mc,5,mb,0,h8,0,24l,0,r4||",
                "Europe_Eastern": "4,0,52,0,8r,0,8c,0,1qp,0,r4|8r,0,8c,0,mc,5,mb,0,h8,0,1qp,0,r4||",
                "Europe_Further_Eastern": "8r,0,8c,0,bep,5,beo,0,r4|||",
                "Europe_Western": "4,0,52,0,8r,0,8c,0,1fi,0,r4|8r,0,8c,0,mc,5,mb,0,h8,0,1fi,0,r4||",
                "Falkland": "4,0,52,0,8r,0,8c,0,4v,0,o|8r,0,8c,0,mc,5,mb,0,h8,0,4v,0,o||",
                "Fiji": "4,0,52,0,8r,0,8c,0,4q|8r,0,8c,0,mc,5,mb,0,h8,0,4q||",
                "French_Guiana": "8r,0,8c,0,84,0,am|||",
                "French_Southern": "8r,0,8c,0,ben,0,bem,0,bel,0,bek|||",
                "Galapagos": "8r,0,8c,0,ak|||",
                "Gambier": "8r,0,8c,0,6v|||",
                "Georgia": "4,0,52,0,8r,0,8c,0,2u|8r,0,8c,0,mc,5,mb,0,h8,0,2u||",
                "Gilbert_Islands": "8r,0,8c,0,6q,0,o|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "4,0,52,0,8r,0,8c,0,1qp,0,2k|8r,0,8c,0,mc,5,mb,0,h8,0,1qp,0,2k||",
                "Greenland_Western": "4,0,52,0,8r,0,8c,0,1fi,0,2k|8r,0,8c,0,mc,5,mb,0,h8,0,1fi,0,2k||",
                "Gulf": "8r,0,8c,0,bn|||",
                "Guyana": "8r,0,8c,0,7a|||",
                "Hawaii_Aleutian": "4,0,52,0,8r,0,8c,0,4g,5,62|8r,0,8c,0,mc,5,mb,0,h8,0,4g,5,62||",
                "Hong_Kong": "4,0,52,0,8r,0,8c,0,2l,0,2p|8r,0,8c,0,mc,5,mb,0,h8,0,2l,0,2p||",
                "Hovd": "4,0,52,0,8r,0,8c,0,2g|8r,0,8c,0,mc,5,mb,0,h8,0,2g||",
                "India": "4,0,52,0,8r,0,8c,0,as|||",
                "Indian_Ocean": "8r,0,8c,0,br,0,bv|||",
                "Indochina": "8r,0,h8,0,9p|||",
                "Indonesia_Central": "8r,0,h8,0,24l,0,4ph|||",
                "Indonesia_Eastern": "8r,0,h8,0,1qp,0,4ph|||",
                "Indonesia_Western": "8r,0,h8,0,1fi,0,4ph|||",
                "Iran": "4,0,52,0,8r,0,8c,0,5g|c,0,1,0,8c,0,5g||",
                "Irkutsk": "4,0,52,0,8r,0,8c,0,3h|8r,0,8c,0,mc,5,mb,0,h8,0,3h||",
                "Israel": "4,0,52,0,8r,0,8c,0,4e|c,0,1,0,8c,0,4e||",
                "Japan": "4,0,52,0,8r,0,8c,0,6o|c,0,1,0,8c,0,6o||",
                "Kamchatka": "4,0,1,0,8c,0,37,5,3k|6,0,1,0,8c,0,37,5,3k||",
                "Kazakhstan_Eastern": "8r,0,8c,0,1qp,0,45|||",
                "Kazakhstan_Western": "8r,0,8c,0,1fi,0,45|||",
                "Korea": "4,0,52,0,8r,0,8c,0,qf|c,0,1,0,8c,0,qf||",
                "Kosrae": "8r,0,8c,0,6f|||",
                "Krasnoyarsk": "4,0,52,0,8r,0,8c,0,41|8r,0,8c,0,mc,5,mb,0,h8,0,41||",
                "Kyrgystan": "8r,0,8c,0,bl|||",
                "Line_Islands": "8r,0,8c,0,ac,0,o|||",
                "Lord_Howe": "4,0,52,0,8r,0,8c,0,1u,0,24|c,0,1,0,8c,0,bej,0,24||",
                "Macquarie": "8r,0,8c,0,6m,0,1f|||",
                "Magadan": "4,0,52,0,8r,0,8c,0,2o|8r,0,8c,0,mc,5,mb,0,h8,0,2o||",
                "Malaysia": "8r,0,h8,0,bf|||",
                "Maldives": "8r,0,8c,0,9k|||",
                "Marquesas": "8r,0,8c,0,9e|||",
                "Marshall_Islands": "8r,0,8c,0,7o,0,o|||",
                "Mauritius": "4,0,52,0,8r,0,8c,0,4u|8r,0,8c,0,mc,5,mb,0,h8,0,4u||",
                "Mawson": "8r,0,8c,0,63|||",
                "Mexico_Northwest": "4,0,52,0,8r,0,8c,0,6g5,5,6g6,0,5e|c,0,1,0,8c,0,6g5,5,6g6,0,5e||",
                "Mexico_Pacific": "4,0,52,0,8r,0,8c,0,3e8,0,h8,0,5e|c,0,1,0,8c,0,3e8,0,h8,0,5e||",
                "Mongolia": "4,0,52,0,8r,0,8c,0,4f,0,2m|8r,0,8c,0,mc,5,mb,0,h8,0,4f,0,2m||",
                "Moscow": "4,0,52,0,8r,0,8c,0,71|8r,0,8c,0,mc,5,mb,0,h8,0,71||",
                "Myanmar": "8r,0,h8,0,8v|||",
                "Nauru": "8r,0,8c,0,5v|||",
                "Nepal": "8r,0,8c,0,8u|||",
                "New_Caledonia": "4,0,52,0,8r,0,8c,0,1m,0,4o|8r,0,8c,0,mc,5,mb,0,h8,0,1m,0,4o||",
                "New_Zealand": "4,0,52,0,8r,0,8c,0,1m,0,74|c,0,1,0,8c,0,1m,0,74||",
                "Newfoundland": "4,0,52,0,8r,0,8c,0,53|c,0,1,0,8c,0,53||",
                "Niue": "8r,0,8c,0,8g|||",
                "Norfolk": "8r,0,8c,0,6l,0,1f|||",
                "Noronha": "4,0,52,0,8r,0,8c,0,1s,0,2,0,23|8r,0,8c,0,mc,5,mb,0,h8,0,1s,0,2,0,23||",
                "Novosibirsk": "4,0,52,0,8r,0,8c,0,3b|8r,0,8c,0,mc,5,mb,0,h8,0,3b||",
                "Omsk": "4,0,52,0,8r,0,8c,0,26|8r,0,8c,0,mc,5,mb,0,h8,0,26||",
                "Pakistan": "4,0,52,0,8r,0,8c,0,3i|8r,0,8c,0,mc,5,mb,0,h8,0,3i||",
                "Palau": "8r,0,8c,0,9b|||",
                "Papua_New_Guinea": "8r,0,8c,0,9a,0,1m,0,a8|||",
                "Paraguay": "4,0,52,0,8r,0,8c,0,3c|8r,0,8c,0,mc,5,mb,0,h8,0,3c||",
                "Peru": "4,0,52,0,8r,0,8c,0,4n|8r,0,8c,0,mc,5,mb,0,h8,0,4n||",
                "Philippines": "4,0,52,0,8r,0,8c,0,471|8r,0,8c,0,mc,5,mb,0,h8,0,471||",
                "Phoenix_Islands": "8r,0,8c,0,90,0,o|||",
                "Pierre_Miquelon": "4,0,52,0,8r,0,8c,0,8i,0,33,0,4pi,0,35|c,0,1,0,8c,0,8i,0,33,0,4pi,0,35||",
                "Pitcairn": "8r,0,8c,0,7e|||",
                "Ponape": "8r,0,8c,0,9s|||",
                "Pyongyang": "8r,0,8c,0,8a|||",
                "Reunion": "8r,0,8c,0,b4|||",
                "Rothera": "8r,0,8c,0,5q|||",
                "Sakhalin": "4,0,52,0,8r,0,8c,0,55|8r,0,8c,0,mc,5,mb,0,h8,0,55||",
                "Samara": "4,0,1,0,8c,0,29|29,0,c||",
                "Samoa": "4,0,52,0,8r,0,8c,0,2c|c,0,1,0,8c,0,2c||",
                "Seychelles": "8r,0,8c,0,8k|||",
                "Singapore": "4,0,52,0,8r,0,8c,0,bi|||",
                "Solomon": "8r,0,8c,0,b5,0,o|||",
                "South_Georgia": "8r,0,8c,0,6fg,0,2u|||",
                "Suriname": "8r,0,8c,0,8q|||",
                "Syowa": "8r,0,8c,0,65|||",
                "Tahiti": "8r,0,8c,0,8n|||",
                "Taipei": "4,0,52,0,8r,0,8c,0,3d|c,0,1,0,8c,0,3d||",
                "Tajikistan": "8r,0,8c,0,bj|||",
                "Tokelau": "8r,0,8c,0,5d|||",
                "Tonga": "4,0,52,0,8r,0,8c,0,2j|8r,0,8c,0,mc,5,mb,0,h8,0,2j||",
                "Truk": "8r,0,8c,0,6p|||",
                "Turkmenistan": "4,0,52,0,8r,0,8c,0,4t|8r,0,8c,0,mc,5,mb,0,h8,0,4t||",
                "Tuvalu": "8r,0,8c,0,6h|||",
                "Uruguay": "4,0,52,0,8r,0,8c,0,4k|8r,0,8c,0,mc,5,mb,0,h8,0,4k||",
                "Uzbekistan": "4,0,52,0,8r,0,8c,0,60|8r,0,8c,0,mc,5,mb,0,h8,0,60||",
                "Vanuatu": "4,0,52,0,8r,0,8c,0,2f|8r,0,8c,0,mc,5,mb,0,h8,0,2f||",
                "Venezuela": "8r,0,8c,0,7s|||",
                "Vladivostok": "4,0,52,0,8r,0,8c,0,28|8r,0,8c,0,mc,5,mb,0,h8,0,28||",
                "Volgograd": "4,0,52,0,8r,0,8c,0,3f|8r,0,8c,0,mc,5,mb,0,h8,0,3f||",
                "Vostok": "8r,0,8c,0,5t|||",
                "Wake": "8r,0,8c,0,5r,0,1f|||",
                "Wallis": "8r,0,8c,0,5f,0,4pi,0,5k|||",
                "Yakutsk": "4,0,52,0,8r,0,8c,0,3u|8r,0,8c,0,mc,5,mb,0,h8,0,3u||",
                "Yekaterinburg": "4,0,52,0,8r,0,8c,0,5l|8r,0,8c,0,mc,5,mb,0,h8,0,5l||"
            }
        },
        "fo-DK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6gn,0,9q,0,4s||",
                "Europe/London": "|6gj,0,6gh,0,a9||"
            },
            "metazone": {
                "Afghanistan": "2f0,0,4s|||",
                "Africa_Central": "6ga,0,4s|||",
                "Africa_Eastern": "6gb,0,4s|||",
                "Africa_Southern": "6gc,0,9q,0,4s|||",
                "Africa_Western": "3do,0,9q,0,4s|3do,0,a9||",
                "Alaska": "3p,0,9q,0,4s|3p,0,a9||",
                "Amazon": "3dn,0,9q,0,4s|3dn,0,a9||",
                "America_Central": "n,0,9q,0,4s|n,0,a9||",
                "America_Eastern": "17,0,9q,0,4s|17,0,a9||",
                "America_Mountain": "5a,0,9q,0,4s|5a,0,a9||",
                "America_Pacific": "2h,0,9q,0,4s|2h,0,a9||",
                "Apia": "3e,0,9q,0,4s|3e,0,a9||",
                "Arabian": "24b,0,9q,0,4s|24b,0,a9||",
                "Argentina": "1e,0,9q,0,4s|1e,0,a9||",
                "Argentina_Western": "11j,0,1e,0,9q,0,4s|11j,0,1e,0,a9||",
                "Armenia": "4l,0,9q,0,4s|4l,0,a9||",
                "Atlantic": "6g,0,9q,0,4s|6g,0,a9||",
                "Australia_Central": "3dl,0,17s,0,9q,0,4s|3dl,0,17s,0,a9||",
                "Australia_CentralWestern": "3dj,0,17s,0,9q,0,4s|3dj,0,17s,0,a9||",
                "Australia_Eastern": "3di,0,17s,0,9q,0,4s|3di,0,17s,0,a9||",
                "Australia_Western": "3dh,0,17s,0,9q,0,4s|3dh,0,17s,0,a9||",
                "Azerbaijan": "3df,0,9q,0,4s|3df,0,a9||",
                "Azores": "3dc,0,9q,0,4s|3dc,0,a9||",
                "Bangladesh": "24n,0,9q,0,4s|24n,0,a9||",
                "Bhutan": "1k4,0,4s|||",
                "Bolivia": "aa,0,4s|||",
                "Brasilia": "3a,0,9q,0,4s|3a,0,a9||",
                "Brunei": "9o,0,a4,0,4s|||",
                "Cape_Verde": "3d9,0,9q,0,4s|3d9,0,a9||",
                "Chamorro": "6j,0,9q,0,4s|||",
                "Chatham": "27,0,9q,0,4s|27,0,a9||",
                "Chile": "3d7,0,9q,0,4s|3d7,0,a9||",
                "China": "25m,0,9q,0,4s|25m,0,a9||",
                "Choibalsan": "2q,0,9q,0,4s|2q,0,a9||",
                "Christmas": "6gs,0,4s|||",
                "Cocos": "6gt,0,4s|||",
                "Colombia": "20u,0,9q,0,4s|20u,0,a9||",
                "Cook": "3d5,0,9q,0,4s|3d5,0,a9||",
                "Cuba": "34,0,9q,0,4s|34,0,a9||",
                "Davis": "5s,0,4s|||",
                "DumontDUrville": "5b,5,5j,0,4s|||",
                "East_Timor": "6gv,0,4s|||",
                "Easter": "3d4,0,9q,0,4s|3d4,0,a9||",
                "Ecuador": "1k0,0,4s|||",
                "Europe_Central": "3d2,0,9q,0,4s|3d2,0,a9||",
                "Europe_Eastern": "2in,0,9q,0,4s|2in,0,a9||",
                "Europe_Further_Eastern": "6h4,0,2in,0,4s|||",
                "Europe_Western": "3cs,0,9q,0,4s|3cs,0,a9||",
                "Falkland": "3co,0,9q,0,4s|3co,0,a9||",
                "Fiji": "4q,0,9q,0,4s|4q,0,a9||",
                "French_Guiana": "25t,0,2fd,0,4s|||",
                "French_Southern": "6he,0,6hf,0,6hi,0,u0,0,6hm,0,4s|||",
                "Galapagos": "ak,0,4s|||",
                "Gambier": "6v,0,4s|||",
                "Georgia": "2u,0,9q,0,4s|2u,0,a9||",
                "Gilbert_Islands": "6hn,0,4s|||",
                "GMT": "5u,0,bh,0,4s|||",
                "Greenland_Eastern": "25v,0,25u,0,9q,0,4s|25v,0,25u,0,a9||",
                "Greenland_Western": "11j,0,25u,0,9q,0,4s|11j,0,25u,0,a9||",
                "Gulf": "bn,0,9q,0,4s|||",
                "Guyana": "2fd,0,4s|||",
                "Hawaii_Aleutian": "4g,5,62,0,9q,0,4s|4g,5,62,0,a9||",
                "Hong_Kong": "2l,0,2p,0,9q,0,4s|2l,0,2p,0,a9||",
                "Hovd": "2g,0,9q,0,4s|2g,0,a9||",
                "India": "af,0,4s|||",
                "Indian_Ocean": "6ht,0,4s|||",
                "Indochina": "23t,0,4s|||",
                "Indonesia_Central": "25s,0,2t,0,4s|||",
                "Indonesia_Eastern": "25v,0,2t,0,4s|||",
                "Indonesia_Western": "11j,0,2t,0,4s|||",
                "Iran": "5g,0,9q,0,4s|5g,0,a9||",
                "Irkutsk": "3h,0,9q,0,4s|3h,0,a9||",
                "Israel": "2fv,0,9q,0,4s|2fv,0,a9||",
                "Japan": "6o,0,9q,0,4s|6o,0,a9||",
                "Kazakhstan_Eastern": "25v,0,2g1,0,4s|||",
                "Kazakhstan_Western": "11j,0,2g1,0,4s|||",
                "Korea": "qf,0,9q,0,4s|qf,0,a9||",
                "Kosrae": "6f,0,4s|||",
                "Krasnoyarsk": "41,0,9q,0,4s|41,0,a9||",
                "Kyrgystan": "6i4,0,4s|||",
                "Line_Islands": "6i5,0,4s|||",
                "Lord_Howe": "1u,0,24,0,9q,0,4s|1u,0,24,0,a9||",
                "Macquarie": "6i6,0,4s|||",
                "Magadan": "2o,0,9q,0,4s|2o,0,a9||",
                "Malaysia": "3lm,0,4s|||",
                "Maldives": "6i9,0,4s|||",
                "Marquesas": "9e,0,4s|||",
                "Marshall_Islands": "6ib,0,4s|||",
                "Mauritius": "3cl,0,9q,0,4s|3cl,0,a9||",
                "Mawson": "63,0,4s|||",
                "Mexico_Northwest": "80,0,5e,0,9q,0,4s|80,0,5e,0,a9||",
                "Mexico_Pacific": "81,0,2h,0,9q,0,4s|81,0,2h,0,a9||",
                "Mongolia": "4f,0,2m,0,9q,0,4s|4f,0,2m,0,a9||",
                "Moscow": "pi,0,9q,0,4s|pi,0,a9||",
                "Myanmar": "8v,0,6id,0,4s|||",
                "Nauru": "5v,0,4s|||",
                "Nepal": "8u,0,4s|||",
                "New_Caledonia": "3ck,0,9q,0,4s|3ck,0,a9||",
                "New_Zealand": "3cj,0,9q,0,4s|3cj,0,a9||",
                "Newfoundland": "53,0,9q,0,4s|53,0,a9||",
                "Niue": "8g,0,4s|||",
                "Norfolk": "6ih,0,4s|||",
                "Noronha": "1s,0,2,0,23,0,9q,0,4s|1s,0,2,0,23,0,a9||",
                "Novosibirsk": "3b,0,9q,0,4s|3b,0,a9||",
                "Omsk": "26,0,9q,0,4s|26,0,a9||",
                "Pakistan": "3i,0,9q,0,4s|3i,0,a9||",
                "Palau": "9b,0,4s|||",
                "Papua_New_Guinea": "9a,0,6ii,0,4s|||",
                "Paraguay": "p8,0,9q,0,4s|p8,0,a9||",
                "Peru": "4n,0,9q,0,4s|4n,0,a9||",
                "Philippines": "3ci,0,9q,0,4s|3ci,0,a9||",
                "Phoenix_Islands": "6io,0,4s|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,9q,0,4s|7u,0,33,0,31,0,35,0,a9||",
                "Pitcairn": "6ip,0,4s|||",
                "Ponape": "9s,0,4s|||",
                "Pyongyang": "8a,0,4s|||",
                "Reunion": "i8,0,4s|||",
                "Rothera": "5q,0,4s|||",
                "Sakhalin": "55,0,9q,0,4s|55,0,a9||",
                "Samoa": "2c,0,9q,0,4s|2c,0,a9||",
                "Seychelles": "6iq,0,4s|||",
                "Singapore": "6ir,0,4s|||",
                "Solomon": "6is,0,4s|||",
                "South_Georgia": "6it,0,4s|||",
                "Suriname": "mg,0,4s|||",
                "Syowa": "65,0,4s|||",
                "Tahiti": "8n,0,4s|||",
                "Taipei": "3d,0,9q,0,4s|3d,0,a9||",
                "Tajikistan": "6iu,0,4s|||",
                "Tokelau": "5d,0,4s|||",
                "Tonga": "2j,0,9q,0,4s|2j,0,a9||",
                "Truk": "6p,0,4s|||",
                "Turkmenistan": "4t,0,9q,0,4s|4t,0,a9||",
                "Tuvalu": "6h,0,4s|||",
                "Uruguay": "rn,0,9q,0,4s|rn,0,a9||",
                "Uzbekistan": "14m,0,9q,0,4s|14m,0,a9||",
                "Vanuatu": "2f,0,9q,0,4s|2f,0,a9||",
                "Venezuela": "2g9,0,4s|||",
                "Vladivostok": "28,0,9q,0,4s|28,0,a9||",
                "Volgograd": "3f,0,9q,0,4s|3f,0,a9||",
                "Vostok": "5t,0,4s|||",
                "Wake": "6j0,0,4s|||",
                "Wallis": "5f,5,0,u0,0,6j1,0,4s|||",
                "Yakutsk": "3u,0,9q,0,4s|3u,0,a9||",
                "Yekaterinburg": "5l,0,9q,0,4s|5l,0,a9||"
            }
        },
        "fo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6gn,0,9q,0,4s||",
                "Europe/London": "|6gj,0,6gh,0,a9||"
            },
            "metazone": {
                "Afghanistan": "2f0,0,4s|||",
                "Africa_Central": "6ga,0,4s|||",
                "Africa_Eastern": "6gb,0,4s|||",
                "Africa_Southern": "6gc,0,9q,0,4s|||",
                "Africa_Western": "3do,0,9q,0,4s|3do,0,a9||",
                "Alaska": "3p,0,9q,0,4s|3p,0,a9||",
                "Amazon": "3dn,0,9q,0,4s|3dn,0,a9||",
                "America_Central": "n,0,9q,0,4s|n,0,a9||",
                "America_Eastern": "17,0,9q,0,4s|17,0,a9||",
                "America_Mountain": "5a,0,9q,0,4s|5a,0,a9||",
                "America_Pacific": "2h,0,9q,0,4s|2h,0,a9||",
                "Apia": "3e,0,9q,0,4s|3e,0,a9||",
                "Arabian": "24b,0,9q,0,4s|24b,0,a9||",
                "Argentina": "1e,0,9q,0,4s|1e,0,a9||",
                "Argentina_Western": "11j,0,1e,0,9q,0,4s|11j,0,1e,0,a9||",
                "Armenia": "4l,0,9q,0,4s|4l,0,a9||",
                "Atlantic": "6g,0,9q,0,4s|6g,0,a9||",
                "Australia_Central": "3dl,0,17s,0,9q,0,4s|3dl,0,17s,0,a9||",
                "Australia_CentralWestern": "3dj,0,17s,0,9q,0,4s|3dj,0,17s,0,a9||",
                "Australia_Eastern": "3di,0,17s,0,9q,0,4s|3di,0,17s,0,a9||",
                "Australia_Western": "3dh,0,17s,0,9q,0,4s|3dh,0,17s,0,a9||",
                "Azerbaijan": "3df,0,9q,0,4s|3df,0,a9||",
                "Azores": "3dc,0,9q,0,4s|3dc,0,a9||",
                "Bangladesh": "24n,0,9q,0,4s|24n,0,a9||",
                "Bhutan": "1k4,0,4s|||",
                "Bolivia": "aa,0,4s|||",
                "Brasilia": "3a,0,9q,0,4s|3a,0,a9||",
                "Brunei": "9o,0,a4,0,4s|||",
                "Cape_Verde": "3d9,0,9q,0,4s|3d9,0,a9||",
                "Chamorro": "6j,0,9q,0,4s|||",
                "Chatham": "27,0,9q,0,4s|27,0,a9||",
                "Chile": "3d7,0,9q,0,4s|3d7,0,a9||",
                "China": "25m,0,9q,0,4s|25m,0,a9||",
                "Choibalsan": "2q,0,9q,0,4s|2q,0,a9||",
                "Christmas": "6gs,0,4s|||",
                "Cocos": "6gt,0,4s|||",
                "Colombia": "20u,0,9q,0,4s|20u,0,a9||",
                "Cook": "3d5,0,9q,0,4s|3d5,0,a9||",
                "Cuba": "34,0,9q,0,4s|34,0,a9||",
                "Davis": "5s,0,4s|||",
                "DumontDUrville": "5b,5,5j,0,4s|||",
                "East_Timor": "6gv,0,4s|||",
                "Easter": "3d4,0,9q,0,4s|3d4,0,a9||",
                "Ecuador": "1k0,0,4s|||",
                "Europe_Central": "3d2,0,9q,0,4s|3d2,0,a9||",
                "Europe_Eastern": "2in,0,9q,0,4s|2in,0,a9||",
                "Europe_Further_Eastern": "6h4,0,2in,0,4s|||",
                "Europe_Western": "3cs,0,9q,0,4s|3cs,0,a9||",
                "Falkland": "3co,0,9q,0,4s|3co,0,a9||",
                "Fiji": "4q,0,9q,0,4s|4q,0,a9||",
                "French_Guiana": "25t,0,2fd,0,4s|||",
                "French_Southern": "6he,0,6hf,0,6hi,0,u0,0,6hm,0,4s|||",
                "Galapagos": "ak,0,4s|||",
                "Gambier": "6v,0,4s|||",
                "Georgia": "2u,0,9q,0,4s|2u,0,a9||",
                "Gilbert_Islands": "6hn,0,4s|||",
                "GMT": "5u,0,bh,0,4s|||",
                "Greenland_Eastern": "25v,0,25u,0,9q,0,4s|25v,0,25u,0,a9||",
                "Greenland_Western": "11j,0,25u,0,9q,0,4s|11j,0,25u,0,a9||",
                "Gulf": "bn,0,9q,0,4s|||",
                "Guyana": "2fd,0,4s|||",
                "Hawaii_Aleutian": "4g,5,62,0,9q,0,4s|4g,5,62,0,a9||",
                "Hong_Kong": "2l,0,2p,0,9q,0,4s|2l,0,2p,0,a9||",
                "Hovd": "2g,0,9q,0,4s|2g,0,a9||",
                "India": "af,0,4s|||",
                "Indian_Ocean": "6ht,0,4s|||",
                "Indochina": "23t,0,4s|||",
                "Indonesia_Central": "25s,0,2t,0,4s|||",
                "Indonesia_Eastern": "25v,0,2t,0,4s|||",
                "Indonesia_Western": "11j,0,2t,0,4s|||",
                "Iran": "5g,0,9q,0,4s|5g,0,a9||",
                "Irkutsk": "3h,0,9q,0,4s|3h,0,a9||",
                "Israel": "2fv,0,9q,0,4s|2fv,0,a9||",
                "Japan": "6o,0,9q,0,4s|6o,0,a9||",
                "Kazakhstan_Eastern": "25v,0,2g1,0,4s|||",
                "Kazakhstan_Western": "11j,0,2g1,0,4s|||",
                "Korea": "qf,0,9q,0,4s|qf,0,a9||",
                "Kosrae": "6f,0,4s|||",
                "Krasnoyarsk": "41,0,9q,0,4s|41,0,a9||",
                "Kyrgystan": "6i4,0,4s|||",
                "Line_Islands": "6i5,0,4s|||",
                "Lord_Howe": "1u,0,24,0,9q,0,4s|1u,0,24,0,a9||",
                "Macquarie": "6i6,0,4s|||",
                "Magadan": "2o,0,9q,0,4s|2o,0,a9||",
                "Malaysia": "3lm,0,4s|||",
                "Maldives": "6i9,0,4s|||",
                "Marquesas": "9e,0,4s|||",
                "Marshall_Islands": "6ib,0,4s|||",
                "Mauritius": "3cl,0,9q,0,4s|3cl,0,a9||",
                "Mawson": "63,0,4s|||",
                "Mexico_Northwest": "80,0,5e,0,9q,0,4s|80,0,5e,0,a9||",
                "Mexico_Pacific": "81,0,2h,0,9q,0,4s|81,0,2h,0,a9||",
                "Mongolia": "4f,0,2m,0,9q,0,4s|4f,0,2m,0,a9||",
                "Moscow": "pi,0,9q,0,4s|pi,0,a9||",
                "Myanmar": "8v,0,6id,0,4s|||",
                "Nauru": "5v,0,4s|||",
                "Nepal": "8u,0,4s|||",
                "New_Caledonia": "3ck,0,9q,0,4s|3ck,0,a9||",
                "New_Zealand": "3cj,0,9q,0,4s|3cj,0,a9||",
                "Newfoundland": "53,0,9q,0,4s|53,0,a9||",
                "Niue": "8g,0,4s|||",
                "Norfolk": "6ih,0,4s|||",
                "Noronha": "1s,0,2,0,23,0,9q,0,4s|1s,0,2,0,23,0,a9||",
                "Novosibirsk": "3b,0,9q,0,4s|3b,0,a9||",
                "Omsk": "26,0,9q,0,4s|26,0,a9||",
                "Pakistan": "3i,0,9q,0,4s|3i,0,a9||",
                "Palau": "9b,0,4s|||",
                "Papua_New_Guinea": "9a,0,6ii,0,4s|||",
                "Paraguay": "p8,0,9q,0,4s|p8,0,a9||",
                "Peru": "4n,0,9q,0,4s|4n,0,a9||",
                "Philippines": "3ci,0,9q,0,4s|3ci,0,a9||",
                "Phoenix_Islands": "6io,0,4s|||",
                "Pierre_Miquelon": "7u,0,33,0,31,0,35,0,9q,0,4s|7u,0,33,0,31,0,35,0,a9||",
                "Pitcairn": "6ip,0,4s|||",
                "Ponape": "9s,0,4s|||",
                "Pyongyang": "8a,0,4s|||",
                "Reunion": "i8,0,4s|||",
                "Rothera": "5q,0,4s|||",
                "Sakhalin": "55,0,9q,0,4s|55,0,a9||",
                "Samoa": "2c,0,9q,0,4s|2c,0,a9||",
                "Seychelles": "6iq,0,4s|||",
                "Singapore": "6ir,0,4s|||",
                "Solomon": "6is,0,4s|||",
                "South_Georgia": "6it,0,4s|||",
                "Suriname": "mg,0,4s|||",
                "Syowa": "65,0,4s|||",
                "Tahiti": "8n,0,4s|||",
                "Taipei": "3d,0,9q,0,4s|3d,0,a9||",
                "Tajikistan": "6iu,0,4s|||",
                "Tokelau": "5d,0,4s|||",
                "Tonga": "2j,0,9q,0,4s|2j,0,a9||",
                "Truk": "6p,0,4s|||",
                "Turkmenistan": "4t,0,9q,0,4s|4t,0,a9||",
                "Tuvalu": "6h,0,4s|||",
                "Uruguay": "rn,0,9q,0,4s|rn,0,a9||",
                "Uzbekistan": "14m,0,9q,0,4s|14m,0,a9||",
                "Vanuatu": "2f,0,9q,0,4s|2f,0,a9||",
                "Venezuela": "2g9,0,4s|||",
                "Vladivostok": "28,0,9q,0,4s|28,0,a9||",
                "Volgograd": "3f,0,9q,0,4s|3f,0,a9||",
                "Vostok": "5t,0,4s|||",
                "Wake": "6j0,0,4s|||",
                "Wallis": "5f,5,0,u0,0,6j1,0,4s|||",
                "Yakutsk": "3u,0,9q,0,4s|3u,0,a9||",
                "Yekaterinburg": "5l,0,9q,0,4s|5l,0,a9||"
            }
        },
        "fr-BE": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-BF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-BI": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-BJ": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-BL": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CA": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,f0,0,nq||",
                "Europe/London": "|3,0,f0,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,f0,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,77,0,9r|||",
                "Africa_Eastern": "bei,0,77,0,op|||",
                "Africa_Southern": "3,0,a,0,77,0,f,0,i6|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,f0,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,f0,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,f0,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,f0,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,cc|3,0,f0,0,f,0,cc|beh|beg",
                "America_Eastern": "3,0,a,0,2,0,1v|3,0,f0,0,2,0,1v|bee|bed",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,f0,0,j,0,e3|bec|beb",
                "America_Pacific": "3,0,a,0,f,0,8t|3,0,f0,0,f,0,8t|bea|be8",
                "Anadyr": "3,0,a,0,cb|3,0,f0,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,f0,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,f0,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,f0,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,f0,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,f0,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,f0,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,f0,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,f0,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,f0,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,f0,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,f0,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,f0,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,f0,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,f0,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,f0,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,f0,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,f0,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,6qi,0,27|3,0,f0,0,j,0,6qi,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,f0,0,f,0,cg||",
                "China": "3,0,a,0,2,0,d5|3,0,f0,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,f0,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,f0,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,f0,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,f0,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,f0,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,f0,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,f0,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,f0,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,f0,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,f0,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,f0,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,f0,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,f0,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,6ql,5,ds|3,0,f0,0,6ql,5,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,f0,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,f0,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,f0,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,f0,0,da||",
                "Israel": "3,0,a,0,db|3,0,f0,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,f0,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,f0,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,f0,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,f0,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,f0,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,f0,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,f0,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,f0,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,f0,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,f0,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,f0,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,f0,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,f0,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,f0,0,2,0,co,5,de|be7|be6",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,f0,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,f0,0,2,0,di||",
                "Omsk": "3,0,a,0,1d1|3,0,f0,0,1d1||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,f0,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,f0,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,f0,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,f0,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,f0,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,1c,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,f0,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,f0,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,f0,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,f0,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,f0,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,f0,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,f0,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,f0,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,f0,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,f0,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,f0,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,f0,0,dv||"
            }
        },
        "fr-CD": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CG": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CH": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CI": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-CM": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-DJ": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-DZ": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-GA": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-GF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne||be5|",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-GN": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-GP": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-GQ": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-HT": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-KM": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-LU": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MA": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MC": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MG": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-ML": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MQ": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MR": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-MU": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-NC": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-NE": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-PF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-PM": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-RE": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-RW": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-SC": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-SN": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-SY": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-TD": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-TG": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-TN": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-VU": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-WF": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr-YT": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fr": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {
                "Europe/Dublin": "|3,0,b,0,nq||",
                "Europe/London": "|3,0,b,0,o4||"
            },
            "metazone": {
                "Acre": "3,0,a,0,2,0,d8|3,0,b,0,2,0,d8||",
                "Afghanistan": "3,0,2,0,o3|||",
                "Africa_Central": "3,0,a,0,77,0,9r|||",
                "Africa_Eastern": "3,0,a,0,77,0,2,0,1v|||",
                "Africa_Southern": "3,0,a,0,77,0,o8|||",
                "Africa_Western": "3,0,a,0,77,0,2,0,1p|3,0,b,0,77,0,2,0,1p||",
                "Alaska": "3,0,a,0,2,0,d4|3,0,b,0,2,0,d4||",
                "Almaty": "3,0,a,0,d2,0,c2|3,0,b,0,d2,0,c2||",
                "Amazon": "3,0,a,0,2,0,cv|3,0,b,0,2,0,cv||",
                "America_Central": "3,0,a,0,f,0,6n,0,93,5,b0|3,0,b,0,f,0,cc||",
                "America_Eastern": "3,0,a,0,2,0,1v,0,93,5,b0|3,0,b,0,2,0,1v||",
                "America_Mountain": "3,0,a,0,j,0,e3|3,0,b,0,j,0,e3||",
                "America_Pacific": "3,0,a,0,f,0,8t,0,93,5,b0|3,0,b,0,f,0,8t||",
                "Anadyr": "3,0,a,0,cb|3,0,b,0,cb||",
                "Apia": "3,0,a,0,c9|3,0,b,0,c9||",
                "Aqtau": "3,0,a,0,e0|3,0,b,0,e0||",
                "Aqtobe": "3,0,a,0,dm|3,0,b,0,dm||",
                "Arabian": "3,0,a,0,2,0,dl|3,0,b,0,2,0,dl||",
                "Argentina": "3,0,a,0,na|3,0,b,0,2,0,o6||",
                "Argentina_Western": "3,0,a,0,2,0,1p,0,df|3,0,b,0,2,0,1p,0,df||",
                "Armenia": "3,0,a,0,2,0,nh|3,0,b,0,ni||",
                "Atlantic": "3,0,a,0,2,0,dd|3,0,b,0,2,0,dd||",
                "Australia_Central": "3,0,a,0,f,0,6n,0,2,0,3m|3,0,b,0,f,0,6n,0,2,0,3m||",
                "Australia_CentralWestern": "3,0,a,0,f,0,6n,5,d7,0,2,0,3m|3,0,b,0,f,0,6n,5,d7,0,2,0,3m||",
                "Australia_Eastern": "3,0,a,0,2,0,1v,0,2,0,3m|3,0,b,0,2,0,1v,0,2,0,3m||",
                "Australia_Western": "3,0,a,0,2,0,1p,0,2,0,3m|3,0,b,0,2,0,1p,0,2,0,3m||",
                "Azerbaijan": "3,0,a,0,2,0,ns|3,0,b,0,nn||",
                "Azores": "3,0,a,0,j,0,b9|3,0,b,0,j,0,b9||",
                "Bangladesh": "3,0,a,0,f,0,3n|3,0,b,0,f,0,3n||",
                "Bhutan": "3,0,f,0,n4|||",
                "Bolivia": "3,0,2,0,nj|||",
                "Brasilia": "3,0,a,0,2,0,3a|3,0,b,0,2,0,3a||",
                "Brunei": "3,0,f,0,gs|||",
                "Cape_Verde": "3,0,a,0,f,0,cf,5,d6|3,0,b,0,f,0,cf,5,d6||",
                "Chamorro": "3,0,j,0,6j|||",
                "Chatham": "3,0,a,0,j,0,12,0,27|3,0,b,0,j,0,12,0,27||",
                "Chile": "3,0,a,0,f,0,cg|3,0,b,0,f,0,cg||",
                "China": "3,0,a,0,2,0,1c,0,d5|3,0,b,0,2,0,d5||",
                "Choibalsan": "3,0,a,0,2,0,2q|3,0,b,0,2,0,2q||",
                "Christmas": "3,0,2,0,4a,0,99|||",
                "Cocos": "3,0,j,0,12,0,7v|||",
                "Colombia": "3,0,a,0,2,0,e1|3,0,b,0,2,0,e1||",
                "Cook": "3,0,a,0,j,0,12,0,2v|3,0,b,0,j,0,12,0,2v||",
                "Cuba": "3,0,a,0,2,0,34|3,0,b,0,2,0,34||",
                "Davis": "3,0,2,0,5s|||",
                "DumontDUrville": "3,0,2,0,5b,5,5j|||",
                "East_Timor": "3,0,f,0,7n,0,3r|||",
                "Easter": "3,0,a,0,2,0,4a,0,2,0,dt|3,0,b,0,2,0,4a,0,2,0,dt||",
                "Ecuador": "3,0,2,0,ng|||",
                "Europe_Central": "3,0,a,0,54,0,9r|3,0,b,0,54,0,9r||",
                "Europe_Eastern": "3,0,a,0,54,0,2,0,1v|3,0,b,0,54,0,2,0,1v||",
                "Europe_Further_Eastern": "3,0,2,0,mo|||",
                "Europe_Western": "3,0,a,0,54,0,2,0,1p|3,0,b,0,54,0,2,0,1p||",
                "Falkland": "3,0,a,0,j,0,12,0,dr|3,0,b,0,j,0,12,0,dr||",
                "Fiji": "3,0,a,0,j,0,12,0,cm|3,0,b,0,j,0,12,0,cm||",
                "French_Guiana": "3,0,2,0,1c,0,n1,0,ne|||",
                "French_Southern": "3,0,j,0,nc,0,o5,0,8p,0,o1,0,no|||",
                "Galapagos": "3,0,j,0,12,0,cp|||",
                "Gambier": "3,0,j,0,12,0,6v|||",
                "Georgia": "3,0,a,0,2,0,1c,0,aq|3,0,b,0,2,0,aq||",
                "Gilbert_Islands": "3,0,j,0,12,0,6q|||",
                "GMT": "3,0,np,0,2,0,5u|||",
                "Greenland_Eastern": "3,0,a,0,2,0,1v,0,f,0,8o|3,0,b,0,2,0,1v,0,f,0,8o||",
                "Greenland_Western": "3,0,a,0,2,0,1p,0,f,0,8o|3,0,b,0,2,0,1p,0,f,0,8o||",
                "Guam": "3,0,2,0,83|||",
                "Gulf": "3,0,f,0,n7|||",
                "Guyana": "3,0,f,0,7a|||",
                "Hawaii_Aleutian": "3,0,a,0,ea,0,5,0,ds|3,0,b,0,ea,0,5,0,ds||",
                "Hong_Kong": "3,0,a,0,2,0,2l,0,2p|3,0,b,0,2,0,2l,0,2p||",
                "Hovd": "3,0,a,0,2,0,2g|3,0,b,0,2,0,2g||",
                "India": "3,0,2,0,nv|||",
                "Indian_Ocean": "3,0,2,0,n5,0,n8|||",
                "Indochina": "3,0,nb|||",
                "Indonesia_Central": "3,0,f,0,cc,0,ar|||",
                "Indonesia_Eastern": "3,0,2,0,1v,0,ar|||",
                "Indonesia_Western": "3,0,2,0,1p,0,ar|||",
                "Iran": "3,0,a,0,ce|3,0,b,0,ce||",
                "Irkutsk": "3,0,a,0,da|3,0,b,0,da||",
                "Israel": "3,0,a,0,db|3,0,b,0,db||",
                "Japan": "3,0,a,0,f,0,dg|3,0,b,0,f,0,dg||",
                "Kamchatka": "3,0,a,0,2,0,37,5,3k|3,0,b,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "3,0,2,0,1v,0,f,0,45|||",
                "Kazakhstan_Western": "3,0,2,0,1p,0,f,0,45|||",
                "Korea": "3,0,a,0,2,0,1c,0,d3|3,0,b,0,2,0,d3||",
                "Kosrae": "3,0,2,0,6f|||",
                "Krasnoyarsk": "3,0,a,0,2,0,d9|3,0,b,0,2,0,d9||",
                "Kyrgystan": "3,0,f,0,mm|||",
                "Line_Islands": "3,0,j,0,12,0,2,0,1c,0,n9|||",
                "Lord_Howe": "3,0,a,0,2,0,1u,0,24|3,0,b,0,2,0,1u,0,24||",
                "Macquarie": "3,0,2,0,4a,0,6m|||",
                "Magadan": "3,0,a,0,2,0,2o|3,0,b,0,2,0,2o||",
                "Malaysia": "3,0,2,0,1c,0,nt|||",
                "Maldives": "3,0,j,0,9k|||",
                "Marquesas": "3,0,j,0,12,0,n3|||",
                "Marshall_Islands": "3,0,j,0,12,0,7o|||",
                "Mauritius": "3,0,a,0,2,0,cs|3,0,b,0,2,0,cs||",
                "Mawson": "3,0,2,0,63|||",
                "Mexico_Northwest": "3,0,a,0,f,0,98,5,e2,0,f,0,e4|3,0,b,0,f,0,98,5,e2,0,f,0,e4||",
                "Mexico_Pacific": "3,0,a,0,f,0,8t,0,ct|3,0,b,0,f,0,8t,0,ct||",
                "Mongolia": "3,0,a,0,cu,5,2m|3,0,b,0,cu,5,2m||",
                "Moscow": "3,0,a,0,2,0,ca|3,0,b,0,2,0,ca||",
                "Myanmar": "3,0,f,0,8v|||",
                "Nauru": "3,0,2,0,5v|||",
                "Nepal": "3,0,f,0,n6|||",
                "New_Caledonia": "3,0,a,0,2,0,1c,0,76,5,d1|3,0,b,0,2,0,76,5,d1||",
                "New_Zealand": "3,0,a,0,2,0,1c,0,76,5,dc|3,0,b,0,2,0,1c,0,76,5,dc||",
                "Newfoundland": "3,0,a,0,2,0,co,5,de|3,0,b,0,2,0,co,5,de||",
                "Niue": "3,0,2,0,nr|||",
                "Norfolk": "3,0,2,0,4a,0,6l|||",
                "Noronha": "3,0,a,0,2,0,1s,0,2,0,23|3,0,b,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "3,0,j,0,12,0,nu,0,f,0,98|||",
                "Novosibirsk": "3,0,a,0,2,0,di|3,0,b,0,2,0,di||",
                "Omsk": "3,0,a,0,2,0,26|3,0,b,0,2,0,26||",
                "Pakistan": "3,0,a,0,f,0,3i|3,0,b,0,f,0,3i||",
                "Palau": "3,0,j,0,gt|||",
                "Papua_New_Guinea": "3,0,2,0,1c,0,o2,5,76,5,o0|||",
                "Paraguay": "3,0,a,0,f,0,3c|3,0,b,0,f,0,3c||",
                "Peru": "3,0,a,0,f,0,dj|3,0,b,0,f,0,dj||",
                "Philippines": "3,0,a,0,j,0,dk|3,0,b,0,j,0,dk||",
                "Phoenix_Islands": "3,0,j,0,12,0,90|||",
                "Pierre_Miquelon": "3,0,a,0,2,0,8i,5,33,5,8p,5,35|3,0,b,0,2,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "3,0,j,0,12,0,7e|||",
                "Ponape": "3,0,2,0,4a,0,2,0,e5|||",
                "Pyongyang": "3,0,2,0,8a|||",
                "Reunion": "3,0,2,0,mv,0,i8|||",
                "Rothera": "3,0,2,0,5q|||",
                "Sakhalin": "3,0,a,0,2,0,dn|3,0,b,0,2,0,dn||",
                "Samara": "3,0,a,0,2,0,29|3,0,b,0,2,0,29||",
                "Samoa": "3,0,a,0,j,0,2c|3,0,b,0,j,0,2c||",
                "Seychelles": "3,0,j,0,8k|||",
                "Singapore": "3,0,2,0,mu|||",
                "Solomon": "3,0,j,0,12,0,mq|||",
                "South_Georgia": "3,0,2,0,aq,0,f,0,i6|||",
                "Suriname": "3,0,f,0,8q|||",
                "Syowa": "3,0,2,0,65|||",
                "Tahiti": "3,0,2,0,8n|||",
                "Taipei": "3,0,a,0,2,0,3d|3,0,b,0,2,0,3d||",
                "Tajikistan": "3,0,f,0,lc|||",
                "Tokelau": "3,0,2,0,5d|||",
                "Tonga": "3,0,a,0,j,0,2j|3,0,b,0,2,0,2j||",
                "Truk": "3,0,2,0,6p|||",
                "Turkmenistan": "3,0,a,0,f,0,dp|3,0,b,0,f,0,dp||",
                "Tuvalu": "3,0,j,0,6h|||",
                "Uruguay": "3,0,a,0,2,0,dq|3,0,b,0,2,0,dq||",
                "Uzbekistan": "3,0,a,0,2,0,d0|3,0,b,0,2,0,d0||",
                "Vanuatu": "3,0,a,0,f,0,2f|3,0,b,0,2,0,2f||",
                "Venezuela": "3,0,f,0,7s|||",
                "Vladivostok": "3,0,a,0,2,0,28|3,0,b,0,2,0,28||",
                "Volgograd": "3,0,a,0,2,0,3f|3,0,b,0,2,0,3f||",
                "Vostok": "3,0,2,0,5t|||",
                "Wake": "3,0,2,0,4a,0,5r|||",
                "Wallis": "3,0,2,0,5f,5,8p,5,5k|||",
                "Yakutsk": "3,0,a,0,2,0,du|3,0,b,0,2,0,du||",
                "Yekaterinburg": "3,0,a,0,dv|3,0,b,0,dv||"
            }
        },
        "fur": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Europe_Central": "234,0,38,0,2,0,r4,0,6r7|234,0,3c7,0,2,0,r4,0,6r7|h0|h4",
                "Europe_Eastern": "234,0,38,0,2,0,r4,0,6r9|234,0,3c7,0,2,0,r4,0,6r9|gu|gv",
                "Europe_Western": "234,0,38,0,2,0,r4,0,6rb|234,0,3c7,0,2,0,r4,0,6rb|h1|h2",
                "GMT": "||ah|",
                "Moscow": "234,0,38,0,4i,0,6rc|234,0,3c7,0,4i,0,6rc||"
            }
        },
        "fy": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,ev||",
                "Europe/London": "|1mh,0,ev||"
            },
            "metazone": {
                "Acre": "3q,5,er|3q,5,ev||",
                "Afghanistan": "be4,0,hq|||",
                "Africa_Central": "6rm,5,30r,0,hq|||",
                "Africa_Eastern": "1r,5,30r,0,hq|||",
                "Africa_Southern": "6rp,5,30r,0,hq|||",
                "Africa_Western": "1g,5,30r,0,er|1g,5,30r,0,ev||",
                "Alaska": "3p,5,er|3p,5,ev||",
                "Almaty": "16j,5,c2,5,er|16j,5,c2,5,ev||",
                "Amazon": "16q,5,er|16q,5,ev||",
                "America_Central": "n,5,er|n,5,ev||",
                "America_Eastern": "17,5,er|17,5,ev||",
                "America_Mountain": "5a,5,er|5a,5,ev||",
                "America_Pacific": "10c,5,er|10c,5,ev||",
                "Anadyr": "3l,5,er|3l,5,ev||",
                "Aqtau": "50,5,er|50,5,ev||",
                "Aqtobe": "rs,5,er|rs,5,ev||",
                "Arabian": "6s8,0,er|6s8,0,ev||",
                "Argentina": "3c6,0,er|3c6,0,ev||",
                "Argentina_Western": "1g,5,3c6,0,er|1g,5,3c6,0,ev||",
                "Armenia": "16v,0,er|16v,0,ev||",
                "Atlantic": "6g,5,er|6g,5,ev||",
                "Australia_Central": "ms,5,22r,0,er|ms,5,22r,0,ev||",
                "Australia_CentralWestern": "ms,5,22r,0,174,0,er|ms,5,22r,0,174,0,ev||",
                "Australia_Eastern": "1r,5,22r,0,er|1r,5,22r,0,ev||",
                "Australia_Western": "1g,5,22r,0,er|1g,5,22r,0,ev||",
                "Azerbaijan": "6t2,0,er|6t2,0,ev||",
                "Azores": "qv,5,er|qv,5,ev||",
                "Bangladesh": "17c,0,er|17c,0,ev||",
                "Bhutan": "be3,0,hq|||",
                "Bolivia": "be2,0,hq|||",
                "Brasilia": "6ta,0,er|6ta,0,ev||",
                "Brunei": "22q,0,hq|||",
                "Cape_Verde": "6tf,0,er|6tf,0,ev||",
                "Chamorro": "6j,5,hq|||",
                "Chatham": "27,0,er|27,0,ev||",
                "Chile": "6tg,0,er|6tg,0,ev||",
                "China": "6tj,0,er|6tj,0,ev||",
                "Choibalsan": "148,0,er|148,0,ev||",
                "Christmas": "be1,0,hq|||",
                "Cocos": "be0,0,hq|||",
                "Colombia": "6tu,0,er|6tu,0,ev||",
                "Cook": "6tv,0,er|6tv,0,22m,0,ev||",
                "Cuba": "6u1,0,er|6u1,0,ev||",
                "Davis": "5s,0,hq|||",
                "DumontDUrville": "5b,5,5j,0,hq|||",
                "East_Timor": "1r,5,22l,0,hq|||",
                "Easter": "6uf,0,er|6uf,0,ev||",
                "Ecuador": "bdv,0,hq|||",
                "Europe_Central": "ms,5,2j6,0,er|ms,5,2j6,0,ev|h0|h4",
                "Europe_Eastern": "1r,5,2j6,0,er|1r,5,2j6,0,ev|gu|gv",
                "Europe_Western": "1g,5,2j6,0,er|1g,5,2j6,0,ev|h1|h2",
                "Falkland": "6vi,0,er|6vi,0,ev||",
                "Fiji": "6vo,0,er|6vo,0,ev||",
                "French_Guiana": "bdu,5,70q,0,hq|||",
                "French_Southern": "bdt,0,bds,0,ou,0,bdr,0,hq|||",
                "Galapagos": "bdq,0,hq|||",
                "Gambier": "bdp,0,hq|||",
                "Georgia": "4pj,0,er|4pj,0,ev||",
                "Gilbert_Islands": "bdo,0,hq|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "1r,5,3br,0,er|1r,5,3br,0,ev||",
                "Greenland_Western": "1g,5,3br,0,er|1g,5,3br,0,ev||",
                "Guam": "22b,0,er|||",
                "Gulf": "127,0,er|||",
                "Guyana": "70q,0,hq|||",
                "Hawaii_Aleutian": "4g,5,71t,0,er|4g,5,71t,0,ev||",
                "Hong_Kong": "188,0,er|188,0,ev||",
                "Hovd": "2g,0,er|2g,0,ev||",
                "India": "bdn,0,hq|||",
                "Indian_Ocean": "bdm,0,229,5,hq|||",
                "Indochina": "bdl,0,hq|||",
                "Indonesia_Central": "6rm,5,4pk,0,hq|||",
                "Indonesia_Eastern": "1r,5,4pk,0,hq|||",
                "Indonesia_Western": "1g,5,4pk,0,hq|||",
                "Iran": "72b,0,er|72b,0,ev||",
                "Irkutsk": "16k,5,er|16k,5,ev||",
                "Israel": "72d,0,er|72d,0,ev||",
                "Japan": "72e,0,er|72e,0,ev||",
                "Kamchatka": "37,5,16l,5,er|37,5,16l,5,ev||",
                "Kazakhstan_Eastern": "1r,5,16n,0,hq|||",
                "Kazakhstan_Western": "1g,5,16n,0,hq|||",
                "Korea": "72j,0,er|72j,0,ev||",
                "Kosrae": "224,0,hq|||",
                "Krasnoyarsk": "l0,5,er|l0,5,ev||",
                "Kyrgystan": "bdk,0,hq|||",
                "Lanka": "9c,5,hq|||",
                "Line_Islands": "ac,5,2aj,0,hq|||",
                "Lord_Howe": "1u,0,24,5,2aj,0,er|1u,0,24,5,2aj,0,ev||",
                "Macau": "16o,0,er|16o,0,ev||",
                "Macquarie": "6m,5,2aj,0,hq|||",
                "Magadan": "2o,5,er|2o,5,ev||",
                "Malaysia": "bdj,0,hq|||",
                "Maldives": "bdi,0,hq|||",
                "Marquesas": "bdh,0,hq|||",
                "Marshall_Islands": "bdg,0,hq|||",
                "Mauritius": "739,0,er|739,0,ev||",
                "Mawson": "63,0,hq|||",
                "Mongolia": "p2,0,er|p2,0,ev||",
                "Moscow": "143,5,er|143,5,ev||",
                "Myanmar": "220,0,hq|||",
                "Nauru": "bdf,0,hq|||",
                "Nepal": "21t,0,hq|||",
                "New_Caledonia": "2m1,5,73l,0,er|2m1,5,73l,0,ev||",
                "New_Zealand": "2m1,5,73r,0,er|2m1,5,73r,0,ev||",
                "Newfoundland": "73t,5,er|73t,5,ev||",
                "Niue": "21r,0,hq|||",
                "Norfolk": "bde,0,hq|||",
                "Noronha": "1s,0,2,0,23,5,er|1s,0,2,0,23,5,ev||",
                "North_Mariana": "bdd,0,bdc,0,hq|||",
                "Novosibirsk": "3b,5,er|3b,5,ev||",
                "Omsk": "26,5,er|26,5,ev||",
                "Pakistan": "75s,0,er|75s,0,ev||",
                "Palau": "21p,0,hq|||",
                "Papua_New_Guinea": "1lc,5,2m1,5,bdb,0,hq|||",
                "Paraguay": "76l,0,er|76l,0,ev||",
                "Peru": "76n,0,er|76n,0,ev||",
                "Philippines": "16t,0,er|16t,0,ev||",
                "Phoenix_Islands": "bda,0,hq|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,er|8i,0,33,0,ou,0,35,5,ev||",
                "Pitcairn": "bd9,0,hq|||",
                "Ponape": "e5,0,hq|||",
                "Qyzylorda": "4d,5,er|4d,5,ev||",
                "Reunion": "21l,0,hq|||",
                "Rothera": "5q,0,hq|||",
                "Sakhalin": "ph,5,er|ph,5,ev||",
                "Samara": "29,5,er|29,5,ev||",
                "Samoa": "77d,0,er|77d,0,ev||",
                "Seychelles": "21h,0,hq|||",
                "Singapore": "21f,0,er|||",
                "Solomon": "bd8,0,hq|||",
                "South_Georgia": "6rp,5,4pj,0,hq|||",
                "Suriname": "bd7,0,hq|||",
                "Syowa": "65,0,hq|||",
                "Tahiti": "bd6,0,hq|||",
                "Taipei": "3d,0,er|3d,0,ev||",
                "Tajikistan": "21d,0,hq|||",
                "Tokelau": "5d,5,2aj,0,hq|||",
                "Tonga": "77q,0,er|77q,0,ev||",
                "Truk": "21c,0,hq|||",
                "Turkmenistan": "171,0,er|171,0,ev||",
                "Tuvalu": "bd5,0,hq|||",
                "Uruguay": "781,0,er|781,0,ev||",
                "Uzbekistan": "175,0,er|175,0,ev||",
                "Vanuatu": "784,0,er|784,0,ev||",
                "Venezuela": "bd4,0,hq|||",
                "Vladivostok": "28,5,er|28,5,ev||",
                "Volgograd": "qi,5,er|qi,5,ev||",
                "Vostok": "5t,0,hq|||",
                "Wake": "5r,5,2aj,0,hq|||",
                "Wallis": "5f,0,ou,0,219,0,hq|||",
                "Yakutsk": "13v,5,er|13v,5,ev||",
                "Yekaterinburg": "17a,5,er|17a,5,ev||"
            }
        },
        "ga": {
            "gmtFormat": "MAG{0}",
            "gmtZeroFormat": "MAG",
            "zone": {
                "Europe/Dublin": "|66,0,cag,0,52,0,cah||cai",
                "Europe/London": "|66,0,cr,0,52,0,caj||cak"
            },
            "metazone": {
                "Acre": "66,0,dh,0,3q|66,0,cr,0,3q||",
                "Afghanistan": "66,0,52,0,bd3|||",
                "Africa_Central": "66,0,2bg,0,52,0,2mo|||",
                "Africa_Eastern": "66,0,1qf,0,52,0,2mo|||",
                "Africa_Southern": "66,0,dh,0,52,0,2mo,0,790|||",
                "Africa_Western": "66,0,dh,0,1jk,0,52,0,2mo|66,0,cr,0,1jk,0,52,0,2mo||",
                "Alaska": "66,0,dh,0,tj|66,0,cr,0,tj||",
                "Almaty": "66,0,dh,0,56|66,0,cr,0,56||",
                "Amazon": "66,0,dh,0,52,0,795|66,0,cr,0,52,0,795||",
                "America_Central": "66,0,dh,0,796|66,0,cr,0,796||",
                "America_Eastern": "66,0,dh,0,nk,0,798|66,0,cr,0,nk,0,798||",
                "America_Mountain": "66,0,dh,0,52,0,799|66,0,cr,0,52,0,799||",
                "America_Pacific": "66,0,dh,0,nk,0,2ms,0,3b8|66,0,cr,0,nk,0,2ms,0,3b8||",
                "Anadyr": "66,0,dh,0,3l|66,0,cr,0,3l||",
                "Apia": "66,0,dh,0,3e|66,0,cr,0,3e||",
                "Aqtau": "66,0,dh,0,50|66,0,cr,0,50||",
                "Aqtobe": "66,0,dh,0,5o|66,0,cr,0,5o||",
                "Arabian": "66,0,dh,0,52,0,79c|66,0,cr,0,52,0,79c||",
                "Argentina": "66,0,dh,0,52,0,3b5|66,0,cr,0,52,0,3b5||",
                "Argentina_Western": "66,0,dh,0,1jk,0,52,0,3b5|66,0,cr,0,1jk,0,52,0,3b5||",
                "Armenia": "66,0,dh,0,52,0,79f|66,0,cr,0,52,0,79f||",
                "Atlantic": "66,0,dh,0,nk,0,79g|66,0,cr,0,nk,0,79g||",
                "Australia_Central": "66,0,dh,0,2bg,0,52,0,210|66,0,cr,0,2bg,0,52,0,210||",
                "Australia_CentralWestern": "66,0,dh,0,79i,0,52,0,210|66,0,cr,0,79i,0,52,0,210||",
                "Australia_Eastern": "66,0,dh,0,1qf,0,52,0,210|66,0,cr,0,1qf,0,52,0,210||",
                "Australia_Western": "66,0,dh,0,1jk,0,52,0,210|66,0,cr,0,1jk,0,52,0,210||",
                "Azerbaijan": "66,0,dh,0,52,0,79j|66,0,cr,0,52,0,79j||",
                "Azores": "66,0,dh,0,52,0,79k|66,0,cr,0,52,0,79k||",
                "Bangladesh": "66,0,dh,0,52,0,79l|66,0,cr,0,52,0,79l||",
                "Bhutan": "66,0,52,0,bd2|||",
                "Bolivia": "66,0,52,0,bd1|||",
                "Brasilia": "66,0,dh,0,79o|66,0,cr,0,79o||",
                "Brunei": "66,0,bd0,0,bcv|||",
                "Cape_Verde": "66,0,dh,0,79r,0,3j|66,0,cr,0,79r,0,3j||",
                "Casey": "66,0,280,0,b7|||",
                "Chamorro": "66,0,dh,0,bcu|||",
                "Chatham": "66,0,dh,0,27|66,0,cr,0,27||",
                "Chile": "66,0,dh,0,52,0,3b1|66,0,cr,0,52,0,3b1||",
                "China": "66,0,dh,0,52,0,4pl|66,0,cr,0,52,0,4pl||",
                "Choibalsan": "66,0,dh,0,2q|66,0,cr,0,2q||",
                "Christmas": "66,0,1qd,0,52,0,bct|||",
                "Cocos": "66,0,1f0,0,7v|||",
                "Colombia": "66,0,dh,0,52,0,7a4|66,0,cr,0,52,0,7a4||",
                "Cook": "66,0,dh,0,1f0,0,2v|66,0,bcs,0,1f0,0,2v||",
                "Cuba": "66,0,dh,0,7a6|66,0,cr,0,7a6||",
                "Davis": "66,0,280,0,5s|||",
                "DumontDUrville": "66,0,280,0,5b,5,5j|||",
                "East_Timor": "66,0,bcr,0,bcq|||",
                "Easter": "66,0,dh,0,1qd,0,52,0,7a9|66,0,cr,0,1qd,0,52,0,7a9||",
                "Ecuador": "66,0,bcp|||",
                "Europe_Central": "66,0,dh,0,2bg,0,52,0,282|66,0,cr,0,2bg,0,52,0,282|h0|h4",
                "Europe_Eastern": "66,0,dh,0,1qf,0,52,0,282|66,0,cr,0,1qf,0,52,0,282|gu|gv",
                "Europe_Further_Eastern": "66,0,bco,0,52,0,282|||",
                "Europe_Western": "66,0,dh,0,1jk,0,52,0,282|66,0,cr,0,1jk,0,52,0,282|h1|h2",
                "Falkland": "66,0,dh,0,1f0,0,7ad|66,0,cr,0,1f0,0,7ad||",
                "Fiji": "66,0,dh,0,7ae|66,0,cr,0,7ae||",
                "French_Guiana": "66,0,bcn,0,52,0,bcm|||",
                "French_Southern": "66,0,bcl,0,bck,0,bcj,0,nk,0,bci|||",
                "Galapagos": "66,0,1f0,0,cp|||",
                "Gambier": "66,0,7al|||",
                "Georgia": "66,0,dh,0,52,0,4pm|66,0,cr,0,52,0,4pm||",
                "Gilbert_Islands": "66,0,bch|||",
                "GMT": "bcg,5,66,0,5u||bcf|",
                "Greenland_Eastern": "66,0,dh,0,1qf,0,52,0,3ad|66,0,cr,0,1qf,0,52,0,3ad||",
                "Greenland_Western": "66,0,dh,0,1jk,0,52,0,3ad|66,0,cr,0,1jk,0,52,0,3ad||",
                "Guam": "66,0,dh,0,bce|||",
                "Gulf": "66,0,dh,0,52,0,bcd|||",
                "Guyana": "66,0,52,0,bcc|||",
                "Hawaii_Aleutian": "66,0,dh,0,7au,5,7av|66,0,cr,0,7au,5,7av||",
                "Hong_Kong": "66,0,dh,0,2l,0,7b0|66,0,cr,0,2l,0,7b0||",
                "Hovd": "66,0,dh,0,2g|66,0,cr,0,2g||",
                "India": "66,0,dh,0,52,0,bcb|||",
                "Indian_Ocean": "66,0,nk,0,2ms,0,bca|||",
                "Indochina": "66,0,52,0,bc9,5,4pl|||",
                "Indonesia_Central": "66,0,2bg,0,52,0,4ps|||",
                "Indonesia_Eastern": "66,0,1qf,0,52,0,4ps|||",
                "Indonesia_Western": "66,0,1jk,0,52,0,4ps|||",
                "Iran": "66,0,dh,0,52,0,7b5|66,0,cr,0,52,0,7b5||",
                "Irkutsk": "66,0,dh,0,3h|66,0,cr,0,3h||",
                "Israel": "66,0,dh,0,3a6|66,0,cr,0,3a6||",
                "Japan": "66,0,dh,0,52,0,7b7|66,0,cr,0,52,0,7b7||",
                "Kamchatka": "66,0,dh,0,7b8,5,3k|66,0,cr,0,7b8,5,3k||",
                "Kazakhstan_Eastern": "66,0,1qf,0,52,0,7b9|||",
                "Kazakhstan_Western": "66,0,1jk,0,52,0,7b9|||",
                "Korea": "66,0,dh,0,52,0,7ba|66,0,cr,0,52,0,7ba||",
                "Kosrae": "66,0,6f|||",
                "Krasnoyarsk": "66,0,dh,0,41|66,0,cr,0,41||",
                "Kyrgystan": "66,0,52,0,bc8|||",
                "Lanka": "66,0,bc7,0,7bf|||",
                "Line_Islands": "66,0,1f0,0,52,0,bc6|||",
                "Lord_Howe": "66,0,dh,0,1u,0,24|66,0,cr,0,1u,0,24||",
                "Macau": "66,0,dh,0,7bi|66,0,cr,0,7bi||",
                "Macquarie": "66,0,1qd,0,bc5,0,bc4|||",
                "Magadan": "66,0,dh,0,7bm|66,0,cr,0,7bm||",
                "Malaysia": "66,0,52,0,bc2|||",
                "Maldives": "66,0,1f0,0,bc1|||",
                "Marquesas": "66,0,52,0,3a5,0,bbv|||",
                "Marshall_Islands": "66,0,1f0,0,7o|||",
                "Mauritius": "66,0,dh,0,1qd,0,7bt|66,0,cr,0,1qd,0,7bt||",
                "Mawson": "66,0,280,0,63|||",
                "Mexico_Northwest": "66,0,dh,0,7c0,0,7c1|66,0,cr,0,7c0,0,7c1||",
                "Mexico_Pacific": "66,0,dh,0,7c2,0,nk,0,2ms,0,3b8|66,0,cr,0,7c2,0,nk,0,2ms,0,3b8||",
                "Mongolia": "66,0,dh,0,7c3|66,0,cr,0,7c3||",
                "Moscow": "66,0,dh,0,7c4|66,0,cr,0,7c4||",
                "Myanmar": "66,0,bbu|||",
                "Nauru": "66,0,7c6|||",
                "Nepal": "66,0,bbt|||",
                "New_Caledonia": "66,0,dh,0,52,0,2o7,5,7ce|66,0,cr,0,52,0,2o7,5,7ce||",
                "New_Zealand": "66,0,dh,0,52,0,2o7,5,7cg|66,0,cr,0,52,0,2o7,5,7cg||",
                "Newfoundland": "66,0,dh,0,7ci,0,nk,0,7cm|66,0,cr,0,7ci,0,nk,0,7cm||",
                "Niue": "66,0,8g|||",
                "Norfolk": "66,0,1qd,0,6l|||",
                "Noronha": "66,0,dh,0,7cn,0,2,0,23|66,0,cr,0,7cn,0,2,0,23||",
                "North_Mariana": "66,0,52,0,3a5,0,bbr,0,bbi|||",
                "Novosibirsk": "66,0,dh,0,3b|66,0,cr,0,3b||",
                "Omsk": "66,0,dh,0,26|66,0,cr,0,26||",
                "Pakistan": "66,0,dh,0,52,0,7ct|66,0,cr,0,52,0,7ct||",
                "Palau": "66,0,1f0,0,9b|||",
                "Papua_New_Guinea": "66,0,2o7,5,bbh,0,bbd|||",
                "Paraguay": "66,0,dh,0,7d0|66,0,cr,0,7d0||",
                "Peru": "66,0,dh,0,7d1|66,0,cr,0,7d1||",
                "Philippines": "66,0,dh,0,52,0,3a5,0,7d2|66,0,cr,0,52,0,3a5,0,7d2||",
                "Phoenix_Islands": "66,0,1f0,0,nk,0,bbc|||",
                "Pierre_Miquelon": "66,0,dh,0,8i,5,33,5,8p,5,35|66,0,cr,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "66,0,1qd,0,7e|||",
                "Ponape": "66,0,bbb|||",
                "Pyongyang": "66,0,8a|||",
                "Qyzylorda": "66,0,dh,0,4d|66,0,cr,0,4d||",
                "Reunion": "66,0,i8|||",
                "Rothera": "66,0,280,0,5q|||",
                "Sakhalin": "66,0,dh,0,7d7|66,0,cr,0,7d7||",
                "Samara": "66,0,dh,0,7d8|66,0,cr,0,7d8||",
                "Samoa": "66,0,dh,0,7d9|66,0,cr,0,7d9||",
                "Seychelles": "66,0,52,0,bb9|||",
                "Singapore": "66,0,dh,0,bb8|||",
                "Solomon": "66,0,1f0,0,bb7|||",
                "South_Georgia": "66,0,52,0,4pm,0,790|||",
                "Suriname": "66,0,bb6|||",
                "Syowa": "66,0,280,0,65|||",
                "Tahiti": "66,0,bb4|||",
                "Taipei": "66,0,dh,0,7df|66,0,cr,0,7df||",
                "Tajikistan": "66,0,52,0,bb3|||",
                "Tokelau": "66,0,1f0,0,bb2|||",
                "Tonga": "66,0,dh,0,7di|66,0,cr,0,7di||",
                "Truk": "66,0,6p|||",
                "Turkmenistan": "66,0,dh,0,52,0,7dj|66,0,cr,0,52,0,7dj||",
                "Tuvalu": "66,0,bb1|||",
                "Uruguay": "66,0,dh,0,7dm|66,0,cr,0,7dm||",
                "Uzbekistan": "66,0,dh,0,52,0,7dn|66,0,cr,0,52,0,7dn||",
                "Vanuatu": "66,0,dh,0,7dp|66,0,cr,0,7dp||",
                "Venezuela": "66,0,bau|||",
                "Vladivostok": "66,0,dh,0,28|66,0,cr,0,28||",
                "Volgograd": "66,0,dh,0,3f|66,0,cr,0,3f||",
                "Vostok": "66,0,280,0,5t|||",
                "Wake": "66,0,1qd,0,5r|||",
                "Wallis": "66,0,bat,0,2o8,0,bas|||",
                "Yakutsk": "66,0,dh,0,7ed|66,0,cr,0,7ed||",
                "Yekaterinburg": "66,0,dh,0,5l|66,0,cr,0,5l||"
            }
        },
        "gd": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ei,5,eh,0,52,0,2oo,5,cal||cam,0,can",
                "Europe/London": "|ep,0,g4,0,cao||cap",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "ei,5,eh,0,3q|ep,0,g4,0,3q||",
                "Afghanistan": "he,0,bar|||",
                "Africa_Central": "he,0,1p7,0,2og|||",
                "Africa_Eastern": "he,0,2og,0,nk,0,1jq|||",
                "Africa_Southern": "he,0,2og,0,a6,0,7f2|||",
                "Africa_Western": "ei,5,eh,0,2og,0,nk,0,1c8|ep,0,cr,0,2og,0,nk,0,1c8||",
                "Alaska": "ei,5,eh,0,3p|ep,0,g4,0,3p|18f|18t",
                "Almaty": "ei,5,eh,0,56|ep,0,g4,0,56||",
                "Amazon": "ei,5,eh,0,7f6|ep,0,g4,0,7f6||",
                "America_Central": "ei,5,eh,0,1p7,0,2d7,0,a6,0,28f|ep,0,g4,0,1p7,0,2d7,0,a6,0,28f|19q|19p",
                "America_Eastern": "ei,5,eh,0,2d7,0,a6,0,28f,0,nk,0,1jq|ep,0,g4,0,2d7,0,a6,0,28f,0,nk,0,1jq|19o|19n",
                "America_Mountain": "ei,5,eh,0,7ff,0,2d7,0,a6,0,28f|ep,0,g4,0,7ff,0,2d7,0,a6,0,28f|18r|16i",
                "America_Pacific": "ei,5,eh,0,1kh,0,2da,0,3a3|ep,0,g4,0,1kh,0,2da,0,3a3|19l|19k",
                "Anadyr": "ei,5,eh,0,3l|ep,0,g4,0,3l||",
                "Apia": "ei,5,eh,0,3e|ep,0,g4,0,3e||",
                "Aqtau": "ei,5,eh,0,50|ep,0,g4,0,50||",
                "Aqtobe": "ei,5,eh,0,5o|ep,0,g4,0,5o||",
                "Arabian": "ei,5,eh,0,7fn|ep,0,g4,0,7fn||",
                "Argentina": "ei,5,eh,0,52,0,2oo,5,3a2|ep,0,g4,0,52,0,2oo,5,3a2||",
                "Argentina_Western": "ei,5,eh,0,52,0,2oo,5,3a2,0,7ft|ep,0,g4,0,52,0,2oo,5,3a2,0,7ft||",
                "Armenia": "ei,5,eh,0,7fu|ep,0,g4,0,7fu||",
                "Atlantic": "ei,5,eh,0,1kh,0,2da,0,7fv|ep,0,g4,0,1kh,0,2da,0,7fv|19i|190",
                "Australia_Central": "ei,5,eh,0,1p7,0,1vt|ep,0,g4,0,1p7,0,1vt||",
                "Australia_CentralWestern": "ei,5,eh,0,1p7,0,1vt,0,nk,0,1c8|ep,0,g4,0,1p7,0,1vt,0,nk,0,1c8||",
                "Australia_Eastern": "ei,5,eh,0,1vt,0,nk,0,1jq|ep,0,g4,0,1vt,0,nk,0,1jq||",
                "Australia_Western": "ei,5,eh,0,1vt,0,nk,0,1c8|ep,0,g4,0,1vt,0,nk,0,1c8||",
                "Azerbaijan": "ei,5,eh,0,7g2|ep,0,g4,0,7g2||",
                "Azores": "ei,5,eh,0,15r,0,14u,0,7g6|ep,0,g4,0,15r,0,14u,0,7g6||",
                "Bangladesh": "ei,5,eh,0,7g7|ep,0,g4,0,7g7||",
                "Bhutan": "he,0,baq|||",
                "Bolivia": "he,0,bap|||",
                "Brasilia": "ei,5,eh,0,7gc|ep,0,g4,0,7gc||",
                "Brunei": "he,0,bak,0,bah,0,bag,5,baf|||",
                "Cape_Verde": "ei,5,eh,0,1kh,0,7gj,0,7gk|ep,0,g4,0,1kh,0,7gj,0,7gk||",
                "Casey": "he,0,bae|||",
                "Chamorro": "he,0,6j|||",
                "Chatham": "ei,5,eh,0,27|ep,0,g4,0,27||",
                "Chile": "ei,5,eh,0,52,0,3b1|ep,0,g4,0,52,0,3b1||",
                "China": "ei,5,eh,0,52,0,7gm|ep,0,g4,0,52,0,7gm||",
                "Choibalsan": "ei,5,eh,0,2q|ep,0,g4,0,2q||",
                "Christmas": "he,0,2dg,0,52,0,bad|||",
                "Cocos": "he,0,14u,0,bac|||",
                "Colombia": "ei,5,eh,0,7h4|ep,0,g4,0,7h4||",
                "Cook": "ei,5,eh,0,14u,0,2v|bab,5,baa,0,g4,0,14u,0,2v||",
                "Cuba": "ei,5,eh,0,7h8|ep,0,g4,0,7h8||",
                "Davis": "he,0,ba2|||",
                "DumontDUrville": "he,0,5b,5,5j|||",
                "East_Timor": "he,0,ba1,0,nk,0,1jq|||",
                "Easter": "ei,5,eh,0,2dg,0,52,0,7hc|ep,0,g4,0,2dg,0,52,0,7hc||",
                "Ecuador": "he,0,ba0|||",
                "Europe_Central": "ei,5,eh,0,1p7,0,52,0,28h,5,28i|ep,0,g4,0,1p7,0,52,0,28h,5,28i|h0|h4",
                "Europe_Eastern": "ei,5,eh,0,52,0,28h,5,28i,0,nk,0,1jq|ep,0,g4,0,52,0,28h,5,28i,0,nk,0,1jq|gu|gv",
                "Europe_Further_Eastern": "he,0,52,0,28h,5,28i,0,b9v,0,b9r,0,b9q|||",
                "Europe_Western": "ei,5,eh,0,52,0,28h,5,28i,0,nk,0,1c8|ep,0,g4,0,52,0,28h,5,28i,0,nk,0,1c8|h1|h2",
                "Falkland": "ei,5,eh,0,15r,0,14u,0,7hp|ep,0,g4,0,15r,0,14u,0,7hp||",
                "Fiji": "ei,5,eh,0,7hq|ep,0,g4,0,7hq||",
                "French_Guiana": "he,0,7hs,0,52,0,7hu|||",
                "French_Southern": "he,0,b9o,0,2o8,0,b9f,0,52,0,7hu|||",
                "Galapagos": "he,0,b9e|||",
                "Gambier": "he,0,7al|||",
                "Georgia": "ei,5,eh,0,52,0,7i6|ep,0,g4,0,52,0,7i6||",
                "Gilbert_Islands": "he,0,14u,0,b9d|||",
                "GMT": "5u,0,bh,0,1||ah|",
                "Greenland_Eastern": "ei,5,eh,0,52,0,39q,0,nk,0,1jq|ep,0,g4,0,52,0,39q,0,nk,0,1jq||",
                "Greenland_Western": "ei,5,eh,0,52,0,39q,0,nk,0,1c8|ep,0,g4,0,52,0,39q,0,nk,0,1c8||",
                "Guam": "he,0,83|||",
                "Gulf": "he,0,1kh,0,b9a|||",
                "Guyana": "he,0,7hs|||",
                "Hawaii_Aleutian": "ei,5,eh,0,15r,0,14u,0,7id,0,7ie,0,7if|ep,0,cr,0,15r,0,14u,0,7id,0,7ie,0,7if|17j|17l",
                "Hong_Kong": "ei,5,eh,0,2l,0,2p|ep,0,g4,0,2l,0,2p||",
                "Hovd": "ei,5,eh,0,2g|ep,0,g4,0,2g||",
                "India": "he,0,15r,0,7ig|||",
                "Indian_Ocean": "he,0,b99,0,15r,0,7ig|||",
                "Indochina": "he,0,b93,5,b92|||",
                "Indonesia_Central": "he,0,1p7,0,15r,0,4q4,5,4q5|||",
                "Indonesia_Eastern": "he,0,15r,0,4q4,5,4q5,0,nk,0,1jq|||",
                "Indonesia_Western": "he,0,15r,0,4q4,5,4q5,0,nk,0,1c8|||",
                "Iran": "ei,5,eh,0,7j6|ep,0,g4,0,7j6||",
                "Irkutsk": "ei,5,eh,0,3h|ep,0,cr,0,3h||",
                "Israel": "ei,5,eh,0,3a6|ep,0,g4,0,3a6||",
                "Japan": "ei,5,eh,0,52,0,7j8|ep,0,g4,0,52,0,7j8||",
                "Kamchatka": "ei,5,eh,0,37,5,4q6|ep,0,g4,0,37,5,4q6||",
                "Kazakhstan_Eastern": "he,0,7jf,0,nk,0,1jq|||",
                "Kazakhstan_Western": "he,0,7jf,0,nk,0,1c8|||",
                "Korea": "ei,5,eh,0,7jo|ep,0,g4,0,7jo||",
                "Kosrae": "he,0,6f|||",
                "Krasnoyarsk": "ei,5,eh,0,41|ep,0,g4,0,41||",
                "Kyrgystan": "he,0,b8v|||",
                "Lanka": "he,0,7bf|||",
                "Line_Islands": "he,0,14u,0,b8u|||",
                "Lord_Howe": "ei,5,eh,0,1u,0,24|ep,0,g4,0,1u,0,24||",
                "Macau": "ei,5,eh,0,7ju|ep,0,g4,0,7ju||",
                "Macquarie": "he,0,7k1,0,b8t|||",
                "Magadan": "ei,5,eh,0,2o|ep,0,cr,0,2o||",
                "Malaysia": "he,0,b8s|||",
                "Maldives": "he,0,15r,0,14u,0,b8p|||",
                "Marquesas": "he,0,14u,0,1kh,0,b8n|||",
                "Marshall_Islands": "he,0,14u,0,b8k|||",
                "Mauritius": "ei,5,eh,0,15r,0,14u,0,7kp|ep,0,g4,0,15r,0,14u,0,7kp||",
                "Mawson": "he,0,b8j|||",
                "Mexico_Northwest": "ei,5,eh,0,39d,0,nk,0,1c8,5,7l2|ep,0,g4,0,39d,0,nk,0,1c8,5,7l2||",
                "Mexico_Pacific": "ei,5,eh,0,1kh,0,2da,0,3a3,0,39d|ep,0,g4,0,1kh,0,2da,0,3a3,0,39d||",
                "Mongolia": "ei,5,eh,0,4f,0,2m|ep,0,g4,0,4f,0,2m||",
                "Moscow": "ei,5,eh,0,7l3|ep,0,g4,0,7l3||",
                "Myanmar": "he,0,b8i|||",
                "Nauru": "he,0,b8h|||",
                "Nepal": "he,0,b8g|||",
                "New_Caledonia": "ei,5,eh,0,7lu,0,2pd|ep,0,g4,0,7lu,0,2pd||",
                "New_Zealand": "ei,5,eh,0,7mf,0,2pd|ep,0,g4,0,7mf,0,2pd||",
                "Newfoundland": "ei,5,eh,0,7mj,0,nk,0,7mp|ep,0,g4,0,7mj,0,nk,0,7mp||",
                "Niue": "he,0,8g|||",
                "Norfolk": "he,0,7k1,0,6l|||",
                "Noronha": "ei,5,eh,0,1s,0,2,0,23|ep,0,cr,0,1s,0,2,0,23||",
                "North_Mariana": "he,0,15r,0,14u,0,b8f,0,a6,0,28f|||",
                "Novosibirsk": "ei,5,eh,0,3b|ep,0,g4,0,3b||",
                "Omsk": "ei,5,eh,0,26|ep,0,g4,0,26||",
                "Pakistan": "ei,5,eh,0,7n4|ep,0,g4,0,7n4||",
                "Palau": "he,0,b8e|||",
                "Papua_New_Guinea": "he,0,b8d,0,2pd,0,b8c|||",
                "Paraguay": "ei,5,eh,0,7ne|ep,0,g4,0,7ne||",
                "Peru": "ei,5,eh,0,7nf|ep,0,g4,0,7nf||",
                "Philippines": "ei,5,eh,0,15r,0,2dg,0,7ng|ep,0,g4,0,15r,0,2dg,0,7ng||",
                "Phoenix_Islands": "he,0,14u,0,90|||",
                "Pierre_Miquelon": "ei,5,eh,0,8i,0,33,0,2o8,0,35|ep,0,cr,0,8i,0,33,0,2o8,0,35||",
                "Pitcairn": "he,0,b8b,0,1kh,0,b8a|||",
                "Ponape": "he,0,e5|||",
                "Qyzylorda": "ei,5,eh,0,7np|ep,0,g4,0,7np||",
                "Reunion": "he,0,b4|||",
                "Rothera": "he,0,5q|||",
                "Sakhalin": "ei,5,eh,0,55|ep,0,g4,0,55||",
                "Samara": "ei,5,eh,0,29|ep,0,g4,0,29||",
                "Samoa": "ei,5,eh,0,7ns|ep,0,g4,0,7ns||",
                "Seychelles": "he,0,15r,0,14u,0,b89|||",
                "Singapore": "he,0,b88|||",
                "Solomon": "he,0,14u,0,b87|||",
                "South_Georgia": "he,0,b86,0,a6,0,7f2|||",
                "Suriname": "he,0,b85|||",
                "Syowa": "he,0,b84|||",
                "Tahiti": "he,0,8n|||",
                "Taipei": "ei,5,eh,0,3d|ep,0,g4,0,3d||",
                "Tajikistan": "he,0,b83|||",
                "Tokelau": "he,0,5d|||",
                "Tonga": "ei,5,eh,0,2j|ep,0,g4,0,2j||",
                "Truk": "he,0,6p|||",
                "Turkmenistan": "ei,5,eh,0,7o8|ep,0,g4,0,7o8||",
                "Tuvalu": "he,0,b82|||",
                "Uruguay": "ei,5,eh,0,7oc|ep,0,g4,0,7oc||",
                "Uzbekistan": "ei,5,eh,0,7od|ep,0,g4,0,7od||",
                "Vanuatu": "ei,5,eh,0,2f|ep,0,g4,0,2f||",
                "Venezuela": "he,0,52,0,b81|||",
                "Vladivostok": "ei,5,eh,0,28|ep,0,cr,0,28||",
                "Volgograd": "ei,5,eh,0,3f|ep,0,g4,0,3f||",
                "Vostok": "he,0,5t|||",
                "Wake": "he,0,2dg,0,5r|||",
                "Wallis": "he,0,b80,0,2o8,0,5k|||",
                "Yakutsk": "ei,5,eh,0,3u|ep,0,g4,0,3u||",
                "Yekaterinburg": "ei,5,eh,0,5l|ep,0,g4,0,5l||"
            }
        },
        "gl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|75,0,d,0,caq||",
                "Europe/London": "|75,0,2,0,fl,0,car||"
            },
            "metazone": {
                "Afghanistan": "75,0,2,0,t9|||",
                "Africa_Central": "75,0,2,0,9d,0,n|||",
                "Africa_Eastern": "75,0,2,0,9d,0,8h|||",
                "Africa_Southern": "75,0,d,0,2,0,9d,0,16,0,4mu|||",
                "Africa_Western": "75,0,d,0,2,0,9d,0,of|75,0,2,0,fl,0,2,0,9d,0,of||",
                "Alaska": "75,0,d,0,2,0,tj|75,0,2,0,fl,0,2,0,tj||",
                "Amazon": "75,0,d,0,16,0,bg|75,0,2,0,fl,0,16,0,bg||",
                "America_Central": "75,0,d,0,6r,k,0,1vh|75,0,2,0,fl,0,6r,k,0,1vh||",
                "America_Eastern": "75,0,d,0,16,0,4qj,k,0,1vh|75,0,2,0,fl,0,16,0,4qj,k,0,1vh||",
                "America_Mountain": "75,0,d,0,14,0,7or,k,0,1vh|75,0,2,0,fl,0,14,0,7or,k,0,1vh||",
                "America_Pacific": "75,0,d,0,16,0,9u,k,0,1vh|75,0,2,0,fl,0,16,0,9u,k,0,1vh||",
                "Anadyr": "75,0,d,0,2,0,1eh|75,0,2,0,fl,0,2,0,1eh||",
                "Apia": "75,0,d,0,2,0,3e|75,0,2,0,fl,0,2,0,3e||",
                "Arabian": "75,0,d,0,7os|75,0,2,0,fl,0,7os||",
                "Argentina": "75,0,d,0,2,0,398|75,0,2,0,fl,0,2,0,398||",
                "Argentina_Western": "75,0,d,0,2,0,398,0,of|75,0,2,0,fl,0,2,0,398,0,of||",
                "Armenia": "75,0,d,0,2,0,4l|75,0,2,0,fl,0,2,0,4l||",
                "Atlantic": "75,0,d,0,16,0,jk|75,0,2,0,fl,0,16,0,jk||",
                "Australia_Central": "75,0,d,0,2,0,4c,0,n|75,0,2,0,fl,0,2,0,4c,0,n||",
                "Australia_CentralWestern": "75,0,d,0,2,0,4c,0,of,0,n|75,0,2,0,fl,0,2,0,4c,0,of,0,n||",
                "Australia_Eastern": "75,0,d,0,2,0,4c,0,8h|75,0,2,0,fl,0,2,0,4c,0,8h||",
                "Australia_Western": "75,0,d,0,2,0,4c,0,of|75,0,2,0,fl,0,2,0,4c,0,of||",
                "Azerbaijan": "75,0,d,0,2,0,7p2|75,0,2,0,fl,0,2,0,7p2||",
                "Azores": "75,0,d,0,6t,0,4r|75,0,2,0,fl,0,6t,0,4r||",
                "Bangladesh": "75,0,d,0,2,0,je|75,0,2,0,fl,0,2,0,je||",
                "Bhutan": "75,0,2,0,s5|||",
                "Bolivia": "75,0,2,0,aa|||",
                "Brasilia": "75,0,d,0,2,0,3a|75,0,2,0,fl,0,2,0,3a||",
                "Brunei": "75,0,2,0,9o,0,a4|||",
                "Cape_Verde": "75,0,d,0,2,0,ck,0,3j|75,0,2,0,fl,0,2,0,ck,0,3j||",
                "Chamorro": "75,0,d,0,b7v|||",
                "Chatham": "75,0,d,0,2,0,27|75,0,2,0,fl,0,2,0,27||",
                "Chile": "75,0,d,0,2,0,49|75,0,2,0,fl,0,2,0,49||",
                "China": "75,0,d,0,2,0,4h|75,0,2,0,fl,0,2,0,4h||",
                "Choibalsan": "75,0,d,0,2,0,2q|75,0,2,0,fl,0,2,0,2q||",
                "Christmas": "75,0,14,0,2pp,0,2,0,b7u|||",
                "Cocos": "75,0,6t,0,1kd,0,7v|||",
                "Colombia": "75,0,d,0,2,0,4m|75,0,2,0,fl,0,2,0,4m||",
                "Cook": "75,0,d,0,6t,0,1kd,0,2v|75,0,2,0,fl,0,b7t,0,6t,0,1kd,0,2v||",
                "Cuba": "75,0,d,0,2,0,34|75,0,2,0,fl,0,2,0,34||",
                "Davis": "75,0,2,0,5s|||",
                "DumontDUrville": "75,0,2,0,5b,5,5j|||",
                "East_Timor": "75,0,2,0,7n,0,vk|||",
                "Easter": "75,0,d,0,14,0,2pp,0,2,0,iq|75,0,2,0,fl,0,14,0,2pp,0,2,0,iq||",
                "Ecuador": "75,0,2,0,ai|||",
                "Europe_Central": "75,0,d,0,2,0,4p,0,n|75,0,2,0,fl,0,2,0,4p,0,n|h0|h4",
                "Europe_Eastern": "75,0,d,0,2,0,4p,0,8h|75,0,2,0,fl,0,2,0,4p,0,8h|gu|gv",
                "Europe_Further_Eastern": "75,0,16,0,b7s,0,4qj,0,b7n|||",
                "Europe_Western": "75,0,d,0,2,0,4p,0,of|75,0,2,0,fl,0,2,0,4p,0,of|h1|h2",
                "Falkland": "75,0,d,0,6t,0,1kd,0,ju|75,0,2,0,fl,0,6t,0,1kd,0,ju||",
                "Fiji": "75,0,d,0,2,0,7pv|75,0,2,0,fl,0,2,0,7pv||",
                "French_Guiana": "75,0,14,0,7q4,0,nf|||",
                "French_Southern": "75,0,6t,0,1h4,0,1h2,0,15,0,sd,0,pf|||",
                "Galapagos": "75,0,6t,0,cp|||",
                "Gambier": "75,0,2,0,6v|||",
                "Georgia": "75,0,d,0,2,0,4qk|75,0,2,0,fl,0,2,0,4qk||",
                "Gilbert_Islands": "75,0,6t,0,1kd,0,6q|||",
                "GMT": "75,0,16,0,rc,0,2,0,5u||ah|",
                "Greenland_Eastern": "75,0,d,0,2,0,b2,0,8h|75,0,2,0,fl,0,2,0,b2,0,8h||",
                "Greenland_Western": "75,0,d,0,2,0,b2,0,of|75,0,2,0,fl,0,2,0,b2,0,of||",
                "Gulf": "75,0,d,0,16,0,oh|||",
                "Guyana": "75,0,14,0,7q4|||",
                "Hawaii_Aleutian": "75,0,d,0,2,0,7qe,5,1gc|75,0,2,0,fl,0,2,0,7qe,5,1gc||",
                "Hong_Kong": "75,0,d,0,2,0,2l,0,2p|75,0,2,0,fl,0,2,0,2l,0,2p||",
                "Hovd": "75,0,d,0,2,0,2g|75,0,2,0,fl,0,2,0,2g||",
                "India": "75,0,d,0,14,0,af|||",
                "Indian_Ocean": "75,0,16,0,5pv,0,pa|||",
                "Indochina": "75,0,2,0,9p|||",
                "Indonesia_Central": "75,0,2,0,2t,0,n|||",
                "Indonesia_Eastern": "75,0,2,0,2t,0,8h|||",
                "Indonesia_Western": "75,0,2,0,2t,0,of|||",
                "Iran": "75,0,d,0,2,0,k1|75,0,2,0,fl,0,2,0,k1||",
                "Irkutsk": "75,0,d,0,2,0,3h|75,0,2,0,fl,0,2,0,3h||",
                "Israel": "75,0,d,0,2,0,4e|75,0,2,0,fl,0,2,0,4e||",
                "Japan": "75,0,d,0,16,0,3iu|75,0,2,0,fl,0,16,0,3iu||",
                "Kamchatka": "75,0,d,0,2,0,7qf,5,3k|75,0,2,0,fl,0,2,0,7qf,5,3k||",
                "Kazakhstan_Eastern": "75,0,2,0,7qg,0,8h|||",
                "Kazakhstan_Western": "75,0,2,0,7qg,0,of|||",
                "Korea": "75,0,d,0,2,0,hf|75,0,2,0,fl,0,2,0,hf||",
                "Kosrae": "75,0,2,0,6f|||",
                "Krasnoyarsk": "75,0,d,0,2,0,41|75,0,2,0,fl,0,2,0,41||",
                "Kyrgystan": "75,0,2,0,b7m|||",
                "Line_Islands": "75,0,6t,0,1kd,0,14,0,b7l|||",
                "Lord_Howe": "75,0,d,0,2,0,1u,0,24|75,0,2,0,fl,0,2,0,1u,0,24||",
                "Macquarie": "75,0,14,0,2pp,0,6m|||",
                "Magadan": "75,0,d,0,2,0,2o|75,0,2,0,fl,0,2,0,2o||",
                "Malaysia": "75,0,2,0,3lm|||",
                "Maldives": "75,0,6t,0,ov|||",
                "Marquesas": "75,0,6t,0,9e|||",
                "Marshall_Islands": "75,0,6t,0,1kd,0,7o|||",
                "Mauritius": "75,0,d,0,2,0,kt|75,0,2,0,fl,0,2,0,kt||",
                "Mawson": "75,0,2,0,63|||",
                "Mexico_Northwest": "75,0,d,0,2,0,au,0,107|75,0,2,0,fl,0,2,0,au,0,107||",
                "Mexico_Pacific": "75,0,d,0,16,0,9u,0,7qk|75,0,2,0,fl,0,16,0,9u,0,7qk||",
                "Mongolia": "75,0,d,0,2,0,ke,0,3j2|75,0,2,0,fl,0,2,0,ke,0,3j2||",
                "Moscow": "75,0,d,0,2,0,7qn|75,0,2,0,fl,0,2,0,7qn||",
                "Myanmar": "75,0,2,0,ra|||",
                "Nauru": "75,0,2,0,5v|||",
                "Nepal": "75,0,2,0,8u|||",
                "New_Caledonia": "75,0,d,0,2,0,ba,0,4o|75,0,2,0,fl,0,2,0,ba,0,4o||",
                "New_Zealand": "75,0,d,0,2,0,ba,0,395|75,0,2,0,fl,0,2,0,ba,0,395||",
                "Newfoundland": "75,0,d,0,2,0,h5|75,0,2,0,fl,0,2,0,h5||",
                "Niue": "75,0,2,0,8g|||",
                "Norfolk": "75,0,6t,0,1kd,0,6l|||",
                "Noronha": "75,0,d,0,2,0,1s,0,2,0,23|75,0,2,0,fl,0,2,0,1s,0,2,0,23||",
                "Novosibirsk": "75,0,d,0,2,0,3b|75,0,2,0,fl,0,2,0,3b||",
                "Omsk": "75,0,d,0,2,0,26|75,0,2,0,fl,0,2,0,26||",
                "Pakistan": "75,0,d,0,2,0,3j4|75,0,2,0,fl,0,2,0,3j4||",
                "Palau": "75,0,2,0,9b|||",
                "Papua_New_Guinea": "75,0,2,0,re,5,ba,0,a8|||",
                "Paraguay": "75,0,d,0,2,0,p8|75,0,2,0,fl,0,2,0,p8||",
                "Peru": "75,0,d,0,2,0,ha|75,0,2,0,fl,0,2,0,ha||",
                "Philippines": "75,0,d,0,2,0,g0|75,0,2,0,fl,0,2,0,g0||",
                "Phoenix_Islands": "75,0,6t,0,1kd,0,pd|||",
                "Pierre_Miquelon": "75,0,d,0,2,0,8i,0,33,0,15,0,35|75,0,2,0,fl,0,2,0,8i,0,33,0,15,0,35||",
                "Pitcairn": "75,0,2,0,7e|||",
                "Ponape": "75,0,2,0,e5|||",
                "Pyongyang": "75,0,2,0,8a|||",
                "Reunion": "75,0,2,0,s4|||",
                "Rothera": "75,0,2,0,5q|||",
                "Sakhalin": "75,0,d,0,2,0,b7k|75,0,2,0,fl,0,2,0,55||",
                "Samara": "75,0,d,0,2,0,29|75,0,2,0,fl,0,2,0,29||",
                "Samoa": "75,0,d,0,2,0,2c|75,0,2,0,fl,0,2,0,2c||",
                "Seychelles": "75,0,6t,0,5an|||",
                "Singapore": "75,0,d,0,2,0,m8|||",
                "Solomon": "75,0,6t,0,1kd,0,s1|||",
                "South_Georgia": "75,0,2,0,4qk,0,16,0,4mu|||",
                "Suriname": "75,0,2,0,8q|||",
                "Syowa": "75,0,2,0,65|||",
                "Tahiti": "75,0,2,0,qr|||",
                "Taipei": "75,0,d,0,2,0,3d|75,0,2,0,fl,0,2,0,3d||",
                "Tajikistan": "75,0,2,0,5et|||",
                "Tokelau": "75,0,2,0,b7j|||",
                "Tonga": "75,0,d,0,2,0,2j|75,0,2,0,fl,0,2,0,2j||",
                "Truk": "75,0,2,0,6p|||",
                "Turkmenistan": "75,0,d,0,2,0,7r1|75,0,2,0,fl,0,2,0,7r1||",
                "Tuvalu": "75,0,2,0,6h|||",
                "Uruguay": "75,0,d,0,2,0,rn|75,0,2,0,fl,0,2,0,rn||",
                "Uzbekistan": "75,0,d,0,2,0,7r4|75,0,2,0,fl,0,2,0,7r4||",
                "Vanuatu": "75,0,d,0,2,0,2f|75,0,2,0,fl,0,2,0,2f||",
                "Venezuela": "75,0,2,0,7s|||",
                "Vladivostok": "75,0,d,0,2,0,28|75,0,2,0,fl,0,2,0,28||",
                "Volgograd": "75,0,d,0,2,0,ff|75,0,2,0,fl,0,2,0,ff||",
                "Vostok": "75,0,2,0,5t|||",
                "Wake": "75,0,14,0,2pp,0,5r|||",
                "Wallis": "75,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "75,0,d,0,2,0,1h6|75,0,2,0,fl,0,2,0,1h6||",
                "Yekaterinburg": "75,0,d,0,2,0,kh|75,0,2,0,fl,0,2,0,kh||"
            }
        },
        "gsw-FR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Acre": "3q,5,s0|3q,5,rf||",
                "Afghanistan": "4qn,5,1pe|||",
                "Africa_Central": "4qo,0,1pe|||",
                "Africa_Eastern": "4qp,0,1pe|||",
                "Africa_Southern": "4qq,0,4qr|||",
                "Africa_Western": "2ev,0,s0|2ev,0,rf||",
                "Alaska": "3p,5,s0|3p,5,rf||",
                "Almaty": "56,5,s0|56,5,rf||",
                "Amazon": "bg,5,s0|bg,5,rf||",
                "America_Central": "m2,5,291,0,s0|m2,5,291,0,rf||",
                "Europe_Central": "2f1,0,s0|2f1,0,rf|1bd|1be",
                "Europe_Eastern": "2f2,0,s0|2f2,0,rf|1bg|1bh",
                "Europe_Western": "2f3,0,s0|2f3,0,rf|1bk|1bl",
                "Moscow": "131,0,s0|131,0,rf||"
            }
        },
        "gsw-LI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Acre": "3q,5,s0|3q,5,rf||",
                "Afghanistan": "4qn,5,1pe|||",
                "Africa_Central": "4qo,0,1pe|||",
                "Africa_Eastern": "4qp,0,1pe|||",
                "Africa_Southern": "4qq,0,4qr|||",
                "Africa_Western": "2ev,0,s0|2ev,0,rf||",
                "Alaska": "3p,5,s0|3p,5,rf||",
                "Almaty": "56,5,s0|56,5,rf||",
                "Amazon": "bg,5,s0|bg,5,rf||",
                "America_Central": "m2,5,291,0,s0|m2,5,291,0,rf||",
                "Europe_Central": "2f1,0,s0|2f1,0,rf|1bd|1be",
                "Europe_Eastern": "2f2,0,s0|2f2,0,rf|1bg|1bh",
                "Europe_Western": "2f3,0,s0|2f3,0,rf|1bk|1bl",
                "Moscow": "131,0,s0|131,0,rf||"
            }
        },
        "gsw": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Acre": "3q,5,s0|3q,5,rf||",
                "Afghanistan": "4qn,5,1pe|||",
                "Africa_Central": "4qo,0,1pe|||",
                "Africa_Eastern": "4qp,0,1pe|||",
                "Africa_Southern": "4qq,0,4qr|||",
                "Africa_Western": "2ev,0,s0|2ev,0,rf||",
                "Alaska": "3p,5,s0|3p,5,rf||",
                "Almaty": "56,5,s0|56,5,rf||",
                "Amazon": "bg,5,s0|bg,5,rf||",
                "America_Central": "m2,5,291,0,s0|m2,5,291,0,rf||",
                "Europe_Central": "2f1,0,s0|2f1,0,rf|1bd|1be",
                "Europe_Eastern": "2f2,0,s0|2f2,0,rf|1bg|1bh",
                "Europe_Western": "2f3,0,s0|2f3,0,rf|1bk|1bl",
                "Moscow": "131,0,s0|131,0,rf||"
            }
        },
        "gu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cas,0,hg,0,6e||",
                "Europe/London": "|cat,0,ih,0,6e||"
            },
            "metazone": {
                "Acre": "7s5,0,11f,0,6e|7s5,0,ih,0,6e||",
                "Afghanistan": "b7i,0,6e|||",
                "Africa_Central": "1q1,0,2qq,0,6e|||",
                "Africa_Eastern": "2qr,0,2qq,0,6e|||",
                "Africa_Southern": "7ss,0,2qq,0,hg,0,6e|||",
                "Africa_Western": "2qt,0,2qq,0,hg,0,6e|2qt,0,2qq,0,ih,0,6e||",
                "Alaska": "7t0,0,11f,0,6e|7t0,0,vi,0,6e||",
                "Almaty": "7ta,0,11f,0,6e|7ta,0,ih,0,6e||",
                "Amazon": "7tj,0,hg,0,6e|7tj,0,ih,0,6e||",
                "America_Central": "1q0,0,1ue,0,b7h,0,11f,0,6e|1q0,0,1ue,0,1q1,0,vi,0,6e||",
                "America_Eastern": "1q0,0,1ue,0,38u,0,11f,0,6e|1q0,0,1ue,0,38u,0,vi,0,6e||",
                "America_Mountain": "1q0,0,1ue,0,7u2,0,11f,0,6e|1q0,0,1ue,0,7u2,0,vi,0,6e||",
                "America_Pacific": "1q0,0,1ue,0,38t,0,11f,0,6e|1q0,0,1ue,0,38t,0,vi,0,6e||",
                "Anadyr": "7ua,0,11f,0,6e|7ua,0,ih,0,6e||",
                "Apia": "b7g,0,11f,0,6e|b7b,0,vi,0,6e||",
                "Aqtau": "7ud,0,11f,0,6e|7ud,0,ih,0,6e||",
                "Aqtobe": "7ug,0,11f,0,6e|7ug,0,ih,0,6e||",
                "Arabian": "7uh,0,hg,0,6e|7uh,0,vi,0,6e||",
                "Argentina": "4qs,0,hg,0,6e|b7a,0,ih,0,6e||",
                "Argentina_Western": "1pv,0,4qs,0,hg,0,6e|1pv,0,4qs,0,ih,0,6e||",
                "Armenia": "7v4,0,hg,0,6e|7v4,0,ih,0,6e||",
                "Atlantic": "7v5,0,11f,0,6e|7v5,0,vi,0,6e||",
                "Australia_Central": "1u9,0,1q1,0,11f,0,6e|1u9,0,1q1,0,vi,0,6e||",
                "Australia_CentralWestern": "1u9,0,1q1,0,1pv,0,11f,0,6e|1u9,0,1q1,0,1pv,0,vi,0,6e||",
                "Australia_Eastern": "1u9,0,38r,0,11f,0,6e|1u9,0,38r,0,vi,0,6e||",
                "Australia_Western": "1u9,0,1pv,0,11f,0,6e|1u9,0,1pv,0,vi,0,6e||",
                "Azerbaijan": "7vn,0,hg,0,6e|7vn,0,ih,0,6e||",
                "Azores": "7vr,0,hg,0,6e|7vr,0,ih,0,6e||",
                "Bangladesh": "7vs,0,hg,0,6e|7vs,0,ih,0,6e||",
                "Bhutan": "b78,0,6e|||",
                "Bolivia": "b77,0,6e|||",
                "Brasilia": "802,0,hg,0,6e|802,0,ih,0,6e||",
                "Brunei": "b76,0,b74,0,6e|||",
                "Cape_Verde": "805,0,806,0,hg,0,6e|805,0,806,0,ih,0,6e||",
                "Chamorro": "b70,0,hg,0,6e|||",
                "Chatham": "808,0,hg,0,6e|808,0,vi,0,6e||",
                "Chile": "809,0,hg,0,6e|809,0,ih,0,6e||",
                "China": "80c,0,hg,0,6e|80c,0,vi,0,6e||",
                "Choibalsan": "80f,0,hg,0,6e|80f,0,ih,0,6e||",
                "Christmas": "b6m,0,1u6,0,6e|||",
                "Cocos": "b6j,0,1u6,0,6e|||",
                "Colombia": "80s,0,hg,0,6e|80s,0,ih,0,6e||",
                "Cook": "80t,0,1ps,0,hg,0,6e|80t,0,1ps,0,b6g,0,ih,0,6e||",
                "Cuba": "817,0,hg,0,6e|817,0,vi,0,6e||",
                "Davis": "b6f,0,6e|||",
                "DumontDUrville": "b6e,5,b6c,0,6e|||",
                "East_Timor": "2qr,0,b6b,0,6e|||",
                "Easter": "81p,0,1u6,0,hg,0,6e|81p,0,1u6,0,ih,0,6e||",
                "Ecuador": "b6a,0,6e|||",
                "Europe_Central": "1q1,0,2r9,0,hg,0,6e|1q1,0,2r9,0,ih,0,6e||",
                "Europe_Eastern": "38u,0,2r9,0,hg,0,6e|38u,0,81v,0,ih,0,6e||",
                "Europe_Further_Eastern": "b66,5,38r,0,81v,0,6e|||",
                "Europe_Western": "1pv,0,2r9,0,hg,0,6e|1pv,0,2r9,0,ih,0,6e||",
                "Falkland": "b65,0,1ps,0,hg,0,6e|b64,0,1ps,0,ih,0,6e||",
                "Fiji": "82a,0,hg,0,6e|82a,0,ih,0,6e||",
                "French_Guiana": "82b,0,82i,0,6e|||",
                "French_Southern": "82b,0,b62,0,82r,0,b61,0,6e|||",
                "Galapagos": "b5v,0,6e|||",
                "Gambier": "b5u,0,6e|||",
                "Georgia": "834,0,hg,0,6e|834,0,ih,0,6e||",
                "Gilbert_Islands": "b5t,0,1u6,0,6e|||",
                "GMT": "b5s,0,b5o,0,6e|||",
                "Greenland_Eastern": "2qr,0,38q,0,hg,0,6e|2qr,0,38q,0,ih,0,6e||",
                "Greenland_Western": "2qt,0,38q,0,hg,0,6e|2qt,0,38q,0,ih,0,6e||",
                "Guam": "b5n,0,11f,0,6e|||",
                "Gulf": "b5m,0,hg,0,6e|||",
                "Guyana": "82i,0,6e|||",
                "Hawaii_Aleutian": "83l,5,83n,0,hg,0,6e|83l,5,83n,0,vi,0,6e||",
                "Hong_Kong": "83o,0,83p,0,hg,0,6e|83o,0,83p,0,ih,0,6e||",
                "Hovd": "83q,0,hg,0,6e|83q,0,ih,0,6e||",
                "India": "83r,0,hg,0,6e||15a|",
                "Indian_Ocean": "83r,0,b5l,0,6e|||",
                "Indochina": "b5j,0,6e|||",
                "Indonesia_Central": "1q1,0,4qu,0,6e|||",
                "Indonesia_Eastern": "38r,0,4qu,0,6e|||",
                "Indonesia_Western": "1pv,0,4qu,0,6e|||",
                "Iran": "841,0,hg,0,6e|841,0,vi,0,6e||",
                "Irkutsk": "842,0,hg,0,6e|842,0,ih,0,6e||",
                "Israel": "843,0,hg,0,6e|843,0,vi,0,6e||",
                "Japan": "844,0,hg,0,6e|844,0,vi,0,6e||",
                "Kamchatka": "845,5,847,0,11f,0,6e|845,5,847,0,ih,0,6e||",
                "Kazakhstan_Eastern": "2qr,0,848,0,6e|||",
                "Kazakhstan_Western": "2qt,0,848,0,6e|||",
                "Korea": "84a,0,hg,0,6e|84a,0,vi,0,6e||",
                "Kosrae": "b5e,0,6e|||",
                "Krasnoyarsk": "b5d,0,hg,0,6e|b59,0,ih,0,6e||",
                "Kyrgystan": "b57,0,6e|||",
                "Lanka": "b56,0,6e|||",
                "Line_Islands": "b55,0,1ps,0,6e|||",
                "Lord_Howe": "84r,0,84s,0,11f,0,6e|84r,0,84s,0,vi,0,6e||",
                "Macau": "84t,0,11f,0,6e|84t,0,ih,0,6e||",
                "Macquarie": "b54,0,1u6,0,6e|||",
                "Magadan": "84v,0,hg,0,6e|84v,0,ih,0,6e||",
                "Malaysia": "b53,0,6e|||",
                "Maldives": "b52,0,6e|||",
                "Marquesas": "b51,0,6e|||",
                "Marshall_Islands": "b50,0,1ps,0,6e|||",
                "Mauritius": "85b,0,hg,0,6e|85b,0,ih,0,6e||",
                "Mawson": "b4v,0,6e|||",
                "Mexico_Northwest": "85g,0,85o,0,hg,0,6e|85g,0,85o,0,vi,0,6e||",
                "Mexico_Pacific": "85p,0,38t,0,hg,0,6e|85p,0,38t,0,vi,0,6e||",
                "Mongolia": "85q,0,b4t,0,hg,0,6e|85q,0,b4r,0,ih,0,6e||",
                "Moscow": "85t,0,11f,0,6e|85t,0,ih,0,6e||",
                "Myanmar": "b4q,0,6e|||",
                "Nauru": "b4p,0,6e|||",
                "Nepal": "b4o,0,6e|||",
                "New_Caledonia": "4r0,0,863,0,hg,0,6e|4r0,0,863,0,ih,0,6e||",
                "New_Zealand": "866,0,hg,0,6e|866,0,vi,0,6e||",
                "Newfoundland": "867,0,11f,0,6e|867,0,vi,0,6e||",
                "Niue": "b4l,0,6e|||",
                "Norfolk": "b4i,0,1u6,0,6e|||",
                "Noronha": "b4f,0,b4e,0,b4d,0,hg,0,6e|b4c,0,b4b,0,b4a,0,ih,0,6e||",
                "North_Mariana": "1q0,0,b49,0,1ps|||",
                "Novosibirsk": "86v,0,hg,0,6e|86v,0,ih,0,6e||",
                "Omsk": "b41,0,hg,0,6e|b3v,0,ih,0,6e||",
                "Pakistan": "873,0,hg,0,6e|873,0,ih,0,6e||",
                "Palau": "b3u,0,6e|||",
                "Papua_New_Guinea": "b3t,0,4r0,0,b3r,0,6e|||",
                "Paraguay": "87g,0,hg,0,6e|87g,0,ih,0,6e||",
                "Peru": "87h,0,hg,0,6e|87h,0,ih,0,6e||",
                "Philippines": "87j,0,hg,0,6e|87j,0,ih,0,6e||",
                "Phoenix_Islands": "b3p,0,1ps,0,6e|||",
                "Pierre_Miquelon": "87o,0,87p,0,87t,0,87v,0,hg,0,6e|87o,0,87p,0,87t,0,87v,0,vi,0,6e||",
                "Pitcairn": "b3o,0,6e|||",
                "Ponape": "b3n,0,6e|||",
                "Pyongyang": "b3m,0,6e|||",
                "Qyzylorda": "885,0,11f,0,6e|885,0,ih,0,6e||",
                "Reunion": "b3j,0,6e|||",
                "Rothera": "b3i,0,6e|||",
                "Sakhalin": "888,0,hg,0,6e|888,0,ih,0,6e||",
                "Samara": "889,0,11f,0,6e|889,0,ih,0,6e||",
                "Samoa": "88a,0,hg,0,6e|88a,0,ih,0,6e||",
                "Seychelles": "b3f,0,6e|||",
                "Singapore": "b3c,0,hg,0,6e|||",
                "Solomon": "b3b,0,1ps,0,6e|||",
                "South_Georgia": "7ss,0,b3a,0,6e|||",
                "Suriname": "b38,0,6e|||",
                "Syowa": "b37,0,6e|||",
                "Tahiti": "b36,0,6e|||",
                "Taipei": "88i,0,hg,0,6e|88i,0,vi,0,6e||",
                "Tajikistan": "b35,0,6e|||",
                "Tokelau": "b34,0,6e|||",
                "Tonga": "88o,0,hg,0,6e|88o,0,ih,0,6e||",
                "Truk": "b33,0,6e|||",
                "Turkmenistan": "88q,0,hg,0,6e|88q,0,ih,0,6e||",
                "Tuvalu": "b32,0,6e|||",
                "Uruguay": "88s,0,hg,0,6e|88s,0,ih,0,6e||",
                "Uzbekistan": "88u,0,hg,0,6e|88u,0,ih,0,6e||",
                "Vanuatu": "88v,0,hg,0,6e|88v,0,ih,0,6e||",
                "Venezuela": "b31,0,6e|||",
                "Vladivostok": "891,0,hg,0,6e|891,0,ih,0,6e||",
                "Volgograd": "892,0,hg,0,6e|892,0,ih,0,6e||",
                "Vostok": "b30,0,6e|||",
                "Wake": "b2v,0,1u6,0,6e|||",
                "Wallis": "b2u,0,82r,0,b2t,0,6e|||",
                "Yakutsk": "89a,0,hg,0,6e|89a,0,ih,0,6e||",
                "Yekaterinburg": "89b,0,hg,0,6e|89b,0,ih,0,6e||"
            }
        },
        "guz": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "gv": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ha-GH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ha-NE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ha": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "haw": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Alaska": "||18f|18t",
                "Hawaii_Aleutian": "||17j|17l"
            }
        },
        "he": {
            "gmtFormat": "GMT{0}‎",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|72,0,2gc,0,cau||",
                "Europe/London": "|72,0,2gc,0,cav||"
            },
            "metazone": {
                "Afghanistan": "72,0,b2s|||",
                "Africa_Central": "72,0,1ns,0,2rt|||",
                "Africa_Eastern": "72,0,1n2,0,2rt|||",
                "Africa_Southern": "72,0,89i,0,2rt|||",
                "Africa_Western": "72,0,14e,0,2rt,0,gh|72,0,14e,0,2rt,0,gl||",
                "Alaska": "72,0,89t,0,gh|72,0,89t,0,gl||",
                "Amazon": "72,0,89v,0,gh|72,0,89v,0,gl||",
                "America_Central": "72,0,1ns,0,38e,0,gh|72,0,1ns,0,38e,0,gl||",
                "America_Eastern": "72,0,8a3,0,8a4,0,gh|72,0,8a3,0,8a4,0,gl||",
                "America_Mountain": "72,0,8a7,0,8a8,0,8a9,0,gh|72,0,8a7,0,8a8,0,8a9,0,gl||",
                "America_Pacific": "72,0,14e,0,38e,0,gh|72,0,14e,0,38e,0,gl||",
                "Anadyr": "72,0,4r3,0,8ac|72,0,2gc,0,8ac||",
                "Apia": "72,0,8af,0,gh|72,0,8af,0,gl||",
                "Arabian": "72,0,8ag,0,2s5,0,8ai,0,gh|72,0,8ag,0,2s5,0,8ai,0,gl||",
                "Argentina": "72,0,38c,0,gh|72,0,38c,0,gl||",
                "Argentina_Western": "72,0,14e,0,38c,0,gh|72,0,14e,0,38c,0,gl||",
                "Armenia": "72,0,8ak,0,gh|72,0,8ak,0,gl||",
                "Atlantic": "72,0,4r4,0,8ao,0,gh|72,0,4r4,0,8ao,0,gl||",
                "Australia_Central": "72,0,1ns,0,1tj,0,gh|72,0,1ns,0,1tj,0,gl||",
                "Australia_CentralWestern": "72,0,1ns,5,14e,0,1tj,0,gh|72,0,1ns,5,14e,0,1tj,0,gl||",
                "Australia_Eastern": "72,0,1n2,0,1tj,0,gh|72,0,1n2,0,1tj,0,gl||",
                "Australia_Western": "72,0,14e,0,1tj,0,gh|72,0,14e,0,1tj,0,gl||",
                "Azerbaijan": "72,0,8as,0,gh|72,0,8as,0,gl||",
                "Azores": "72,0,2s9,0,8au,0,gh|72,0,2s9,0,8au,0,gl||",
                "Bangladesh": "72,0,8av,0,gh|72,0,8av,0,gl||",
                "Bhutan": "72,0,b2r|||",
                "Bolivia": "72,0,b2q|||",
                "Brasilia": "72,0,8b2,0,gh|72,0,8b2,0,gl||",
                "Brunei": "72,0,b2p,0,b2o|||",
                "Cape_Verde": "72,0,8b6,0,8b7,0,gh|72,0,8b6,0,8b7,0,gl||",
                "Chamorro": "72,0,b2n|||",
                "Chatham": "72,0,8b9,0,gh|72,0,8b9,0,gl||",
                "Chile": "72,0,8ba,0,gh|72,0,8ba,0,gl||",
                "China": "72,0,4r6,0,gh|72,0,4r6,0,gl||",
                "Choibalsan": "72,0,8bf,0,gh|72,0,8bf,0,gl||",
                "Christmas": "72,0,2s5,0,b2m|||",
                "Cocos": "72,0,1e3,0,b2l|||",
                "Colombia": "72,0,8bn,0,gh|72,0,8bn,0,gl||",
                "Cook": "72,0,1e3,0,8bo,0,gh|72,0,1e3,0,8bo,0,b2j,0,b2h||",
                "Cuba": "72,0,8c4,0,gh|72,0,8c4,0,gl||",
                "Davis": "72,0,b2g|||",
                "DumontDUrville": "72,0,b2e,0,b2d|||",
                "East_Timor": "72,0,1n2,0,b2c|||",
                "Easter": "72,0,37q,0,8cj,0,gh|72,0,37q,0,8cj,0,gl||",
                "Ecuador": "72,0,b2b|||",
                "Europe_Central": "72,0,1ns,0,2gs,0,gh|72,0,1ns,0,2gs,0,gl||",
                "Europe_Eastern": "72,0,1n2,0,2gs,0,gh|72,0,1n2,0,2gs,0,gl||",
                "Europe_Further_Eastern": "72,0,b2a|||",
                "Europe_Western": "72,0,14e,0,2gs,0,gh|72,0,14e,0,2gs,0,gl||",
                "Falkland": "72,0,1e3,0,8cp,0,gh|72,0,1e3,0,8cp,0,gl||",
                "Fiji": "72,0,8d0,0,gh|72,0,8d0,0,gl||",
                "French_Guiana": "72,0,8d1,0,b29|||",
                "French_Southern": "72,0,b28,0,b27,0,b26,0,b25,0,b24|||",
                "Galapagos": "72,0,1e3,0,b23|||",
                "Gambier": "72,0,1e3,0,b22|||",
                "Georgia": "72,0,8dm,0,gh|72,0,8dm,0,gl||",
                "Gilbert_Islands": "72,0,1e3,0,b21|||",
                "GMT": "72,0,b20|||",
                "Greenland_Eastern": "72,0,1n2,0,377,0,gh|72,0,1n2,0,377,0,gl||",
                "Greenland_Western": "72,0,14e,0,377,0,gh|72,0,14e,0,377,0,gl||",
                "Gulf": "72,0,b1v,0,b1u|||",
                "Guyana": "72,0,8d1|||",
                "Hawaii_Aleutian": "72,0,2s9,0,8du,0,8dv,0,gh|72,0,2s9,0,8du,0,8dv,0,gl||",
                "Hong_Kong": "72,0,8e0,0,8e3,0,gh|72,0,8e0,0,8e3,0,gl||",
                "Hovd": "72,0,8e7,0,gh|72,0,8e7,0,gl||",
                "India": "72,0,8ec|||",
                "Indian_Ocean": "72,0,4r4,0,b1t|||",
                "Indochina": "72,0,8ec,5,4r6|||",
                "Indonesia_Central": "72,0,1ns,0,4r9|||",
                "Indonesia_Eastern": "72,0,1n2,0,4r9|||",
                "Indonesia_Western": "72,0,14e,0,4r9|||",
                "Iran": "72,0,8ei,0,gh|72,0,8ei,0,gl||",
                "Irkutsk": "72,0,b1s,0,gh|72,0,b1r,0,gl||",
                "Israel": "72,0,8er,0,gh|72,0,8er,0,gl||",
                "Japan": "72,0,8et,0,gh|72,0,8et,0,gl||",
                "Kamchatka": "72,0,4r3,0,8eu,5,8ev|72,0,2gc,0,8eu,5,8ev||",
                "Kazakhstan_Eastern": "72,0,1n2,0,8f0|||",
                "Kazakhstan_Western": "72,0,14e,0,8f0|||",
                "Korea": "72,0,8f1,0,gh|72,0,8f1,0,gl||",
                "Kosrae": "72,0,b1q|||",
                "Krasnoyarsk": "72,0,8f3,0,gh|72,0,8f3,0,gl||",
                "Kyrgystan": "72,0,b1p|||",
                "Line_Islands": "72,0,1e3,0,b1o|||",
                "Lord_Howe": "72,0,37q,0,8f6,0,8f7,0,gh|72,0,37q,0,8f6,0,8f7,0,gl||",
                "Macau": "72,0,b1n,0,8f9|72,0,2gc,0,8f9||",
                "Macquarie": "72,0,b1m|||",
                "Magadan": "72,0,8fb,0,gh|72,0,8fb,0,gl||",
                "Malaysia": "72,0,b1l|||",
                "Maldives": "72,0,2s9,0,b1k|||",
                "Marquesas": "72,0,1e3,0,b1j|||",
                "Marshall_Islands": "72,0,1e3,0,b1i|||",
                "Mauritius": "72,0,8fg,0,gh|72,0,8fg,0,gl||",
                "Mawson": "72,0,b1h|||",
                "Mexico_Northwest": "72,0,8fi,5,14e,0,36v,0,gh|72,0,8fi,5,14e,0,36v,0,gl||",
                "Mexico_Pacific": "72,0,14e,0,36v,0,gh|72,0,14e,0,36v,0,gl||",
                "Mongolia": "72,0,8fk,0,8fl,0,gh|72,0,8fk,0,8fl,0,gl||",
                "Moscow": "72,0,8fm,0,gh|72,0,8fm,0,gl||",
                "Myanmar": "72,0,b1g|||",
                "Nauru": "72,0,b1f|||",
                "Nepal": "72,0,b1e|||",
                "New_Caledonia": "72,0,8fq,0,4rb,0,gh|72,0,8fq,0,4rb,0,gl||",
                "New_Zealand": "72,0,8fs,0,8fv,0,gh|72,0,8fs,0,8fv,0,gl||",
                "Newfoundland": "72,0,8g0,0,gh|72,0,8g0,0,gl||",
                "Niue": "72,0,b1d|||",
                "Norfolk": "72,0,2s5,0,b1c|||",
                "Noronha": "72,0,8g5,0,8g6,0,8g7,0,gh|72,0,8g5,0,8g6,0,8g7,0,gl||",
                "Novosibirsk": "72,0,8g9,0,gh|72,0,8g9,0,gl||",
                "Omsk": "72,0,8ga,0,gh|72,0,8ga,0,gl||",
                "Pakistan": "72,0,8gb,0,gh|72,0,8gb,0,gl||",
                "Palau": "72,0,b1b|||",
                "Papua_New_Guinea": "72,0,b1a,0,b19,0,4rb|||",
                "Paraguay": "72,0,8gj,0,gh|72,0,8gj,0,gl||",
                "Peru": "72,0,8gm,0,gh|72,0,8gm,0,gl||",
                "Philippines": "72,0,8gn,0,gh|72,0,8gn,0,gl||",
                "Phoenix_Islands": "72,0,1e3,0,b18|||",
                "Pierre_Miquelon": "72,0,8gq,0,8gu,0,8gv,0,gh|72,0,8gq,0,8gu,0,8gv,0,gl||",
                "Pitcairn": "72,0,b17|||",
                "Ponape": "72,0,b16|||",
                "Pyongyang": "72,0,b15|||",
                "Reunion": "72,0,b14|||",
                "Rothera": "72,0,b13|||",
                "Sakhalin": "72,0,8ha,0,gh|72,0,8ha,0,gl||",
                "Samara": "72,0,4r3,0,8he|72,0,2gc,0,8he||",
                "Samoa": "72,0,8hf,0,gh|72,0,8hf,0,gl||",
                "Seychelles": "72,0,1e3,0,b12|||",
                "Singapore": "72,0,b11|||",
                "Solomon": "72,0,1e3,0,b10|||",
                "South_Georgia": "72,0,89i,0,b0v|||",
                "Suriname": "72,0,b0u|||",
                "Syowa": "72,0,b0t|||",
                "Tahiti": "72,0,b0s|||",
                "Taipei": "72,0,8hv,0,gh|72,0,8hv,0,gl||",
                "Tajikistan": "72,0,b0r|||",
                "Tokelau": "72,0,b0q|||",
                "Tonga": "72,0,8ia,0,gh|72,0,8ia,0,gl||",
                "Truk": "72,0,b0p|||",
                "Turkmenistan": "72,0,8id,0,gh|72,0,8id,0,gl||",
                "Tuvalu": "72,0,b0k|||",
                "Uruguay": "72,0,8if,0,gh|72,0,8if,0,gl||",
                "Uzbekistan": "72,0,8ii,0,gh|72,0,8ii,0,gl||",
                "Vanuatu": "72,0,8ij,0,gh|72,0,8ij,0,gl||",
                "Venezuela": "72,0,b0j|||",
                "Vladivostok": "72,0,8il,0,gh|72,0,8il,0,gl||",
                "Volgograd": "72,0,8im,0,gh|72,0,8im,0,gl||",
                "Vostok": "72,0,b0h|||",
                "Wake": "72,0,2s5,0,b0g|||",
                "Wallis": "72,0,b0f,0,b0d|||",
                "Yakutsk": "72,0,8ir,0,gh|72,0,8ir,0,gl||",
                "Yekaterinburg": "72,0,8is,0,gh|72,0,8is,0,gl||"
            }
        },
        "hi": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4ni,0,5n,0,1b||",
                "Europe/London": "|6aa,0,a5,0,1b||"
            },
            "metazone": {
                "Afghanistan": "b0b,0,1b|||",
                "Africa_Central": "1a6,0,2tu,0,1b|||",
                "Africa_Eastern": "oq,0,2tu,0,1b|||",
                "Africa_Southern": "1jl,0,2tu,0,1b|||",
                "Africa_Western": "124,0,2tu,0,5n,0,1b|124,0,2tu,0,a5,0,1b||",
                "Alaska": "8j9,0,5n,0,1b|8j9,0,s9,0,1b||",
                "Amazon": "8jc,0,5n,0,1b|8jc,0,a5,0,1b||",
                "America_Central": "1s6,0,1s5,0,1s4,0,5n,0,1b|1s6,0,1s5,0,1s4,0,s9,0,1b||",
                "America_Eastern": "1s6,0,1s5,0,oq,0,5n,0,1b|1s6,0,1s5,0,oq,0,s9,0,1b||",
                "America_Mountain": "1s6,0,1s5,0,4s6,0,5n,0,1b|1s6,0,1s5,0,4s6,0,s9,0,1b||",
                "America_Pacific": "1s6,0,1s5,0,369,0,5n,0,1b|1s6,0,1s5,0,369,0,s9,0,1b||",
                "Anadyr": "4s8,0,5n,0,1b|4s8,0,a5,0,1b||",
                "Apia": "8jd,0,5n,0,1b|8jd,0,s9,0,1b||",
                "Arabian": "4sa,0,5n,0,1b|4sa,0,s9,0,1b||",
                "Argentina": "366,0,5n,0,1b|366,0,a5,0,1b||",
                "Argentina_Western": "q4,0,366,0,5n,0,1b|q4,0,366,0,a5,0,1b||",
                "Armenia": "365,0,5n,0,1b|365,0,a5,0,1b||",
                "Atlantic": "364,0,5n,0,1b|364,0,s9,0,1b||",
                "Australia_Central": "2ie,0,1s4,0,5n,0,1b|2ie,0,1s4,0,s9,0,1b||",
                "Australia_CentralWestern": "2ie,0,1s4,0,q4,0,5n,0,1b|2ie,0,1s4,0,q4,0,s9,0,1b||",
                "Australia_Eastern": "2ie,0,oq,0,5n,0,1b|2ie,0,oq,0,s9,0,1b||",
                "Australia_Western": "4sg,0,q4,0,5n,0,1b|4sg,0,q4,0,s9,0,1b||",
                "Azerbaijan": "4sh,0,5n,0,1b|4sh,0,a5,0,1b||",
                "Azores": "4si,0,5n,0,1b|4si,0,a5,0,1b||",
                "Bangladesh": "4sj,0,5n,0,1b|4sj,0,a5,0,1b||",
                "Bhutan": "b08,0,1b|||",
                "Bolivia": "b00,0,1b|||",
                "Brasilia": "4sm,0,5n,0,1b|4sm,0,a5,0,1b||",
                "Brunei": "avv,0,4rf,0,1b|||",
                "Cape_Verde": "1s1,0,4sq,0,5n,0,1b|1s1,0,4sq,0,a5,0,1b||",
                "Chamorro": "4sr,0,5n,0,1b|||",
                "Chatham": "4en,0,5n,0,1b|4en,0,s9,0,1b||",
                "Chile": "1s0,0,5n,0,1b|1s0,0,a5,0,1b||",
                "China": "2ii,0,5n,0,1b|2ii,0,s9,0,1b||",
                "Choibalsan": "4su,0,5n,0,1b|4su,0,a5,0,1b||",
                "Christmas": "avu,0,1ev,0,1b|||",
                "Cocos": "4rg,0,1l0,0,1b|||",
                "Colombia": "2b7,0,5n,0,1b|2b7,0,a5,0,1b||",
                "Cook": "1lj,0,1l0,0,5n,0,1b|1lj,0,1l0,0,avr,0,a5,0,1b||",
                "Cuba": "360,0,5n,0,1b|360,0,s9,0,1b||",
                "Davis": "avo,0,1b|||",
                "DumontDUrville": "avn,0,avm,0,1b|||",
                "East_Timor": "oq,0,4t7,0,1b|||",
                "Easter": "4em,0,1ev,0,5n,0,1b|4em,0,1ev,0,a5,0,1b||",
                "Ecuador": "avl,0,1b|||",
                "Europe_Central": "1a6,0,29u,0,5n,0,1b|2um,0,29u,0,4tb,0,1b||",
                "Europe_Eastern": "oq,0,29u,0,5n,0,1b|oq,0,29u,0,a5,0,1b||",
                "Europe_Further_Eastern": "4tc,0,oq,0,29u,0,1b|||",
                "Europe_Western": "q4,0,29u,0,5n,0,1b|q4,0,29u,0,4tb,0,1b||",
                "Falkland": "4td,0,1l0,0,5n,0,1b|4td,0,1l0,0,a5,0,1b||",
                "Fiji": "4te,0,5n,0,1b|4te,0,a5,0,1b||",
                "French_Guiana": "avj,0,2as,0,1b|||",
                "French_Southern": "35u,0,avi,0,35t,0,avh,0,1b|||",
                "Galapagos": "ave,0,avd,0,1b|||",
                "Gambier": "avc,0,1b|||",
                "Georgia": "27i,0,5n,0,1b|27i,0,a5,0,1b||",
                "Gilbert_Islands": "35s,0,1l0,0,1b|||",
                "GMT": "4ri,0,ava,0,av9|||",
                "Greenland_Eastern": "oq,0,35q,0,5n,0,1b|oq,0,35q,0,a5,0,1b||",
                "Greenland_Western": "q4,0,35q,0,5n,0,1b|q4,0,35q,0,a5,0,1b||",
                "Gulf": "av8,0,5n,0,1b|||",
                "Guyana": "2as,0,1b|||",
                "Hawaii_Aleutian": "4tt,0,5n,0,1b|4tt,0,s9,0,1b||",
                "Hong_Kong": "35p,0,35o,0,5n,0,1b|35p,0,35o,0,a5,0,1b||",
                "Hovd": "4ei,0,5n,0,1b|4ei,0,a5,0,1b||",
                "India": "27j,0,5n,0,1b||15a|",
                "Indian_Ocean": "av5,0,4rj,0,1b|||",
                "Indochina": "av4,0,1b|||",
                "Indonesia_Central": "1a6,0,2j0,0,1b|||",
                "Indonesia_Eastern": "oq,0,2j0,0,1b|||",
                "Indonesia_Western": "q4,0,2j0,0,1b|||",
                "Iran": "4eg,0,5n,0,1b|4eg,0,s9,0,1b||",
                "Irkutsk": "4u4,0,5n,0,1b|4u4,0,a5,0,1b||",
                "Israel": "4u5,0,5n,0,1b|4u5,0,s9,0,1b||",
                "Japan": "2j1,0,5n,0,1b|2j1,0,s9,0,1b||",
                "Kamchatka": "4u7,5,4u8,0,5n,0,1b|4u7,5,4u8,0,a5,0,1b||",
                "Kazakhstan_Eastern": "1lo,0,4ua,0,1b|||",
                "Kazakhstan_Western": "124,0,4ua,0,1b|||",
                "Korea": "4ub,0,5n,0,1b|4ub,0,s9,0,1b||",
                "Kosrae": "4rk,0,1b|||",
                "Krasnoyarsk": "4rl,0,5n,0,1b|4rl,0,a5,0,1b||",
                "Kyrgystan": "av3,0,1b|||",
                "Line_Islands": "35k,0,1l0,0,1b|||",
                "Lord_Howe": "35j,0,35i,0,5n,0,1b|35j,0,35i,0,s9,0,1b||",
                "Macquarie": "auv,0,1ev,0,1b|||",
                "Magadan": "2j8,0,5n,0,1b|2j8,0,a5,0,1b||",
                "Malaysia": "4hp,0,1b|||",
                "Maldives": "5ma,0,1b|||",
                "Marquesas": "auu,0,1b|||",
                "Marshall_Islands": "2ob,0,1l0,0,1b|||",
                "Mauritius": "35e,0,5n,0,1b|35e,0,a5,0,1b||",
                "Mawson": "aut,0,1b|||",
                "Mexico_Northwest": "2a5,0,q4,0,2ja,0,5n,0,1b|2a5,0,q4,0,2ja,0,s9,0,1b||",
                "Mexico_Pacific": "2jb,0,369,0,5n,0,1b|2jb,0,369,0,s9,0,1b||",
                "Mongolia": "1rp,0,4ur,0,5n,0,1b|1rp,0,4ur,0,a5,0,1b||",
                "Moscow": "2lk,0,5n,0,1b|2lk,0,a5,0,1b||",
                "Myanmar": "aus,0,1b|||",
                "Nauru": "auq,0,1b|||",
                "Nepal": "5nu,0,1b|||",
                "New_Caledonia": "1ld,0,4e9,0,5n,0,1b|1ld,0,4e9,0,a5,0,1b||",
                "New_Zealand": "4uv,0,5n,0,1b|4uv,0,s9,0,1b||",
                "Newfoundland": "4v0,0,5n,0,1b|4v0,0,s9,0,1b||",
                "Niue": "aul,0,1b|||",
                "Norfolk": "auj,0,1ev,0,1b|||",
                "Noronha": "4v3,0,2jf,0,1n8,0,5n,0,1b|4v3,0,2jf,0,1n8,0,a5,0,1b||",
                "Novosibirsk": "356,0,5n,0,1b|356,0,a5,0,1b||",
                "Omsk": "1nb,0,5n,0,1b|1nb,0,a5,0,1b||",
                "Pakistan": "2li,0,5n,0,1b|2li,0,a5,0,1b||",
                "Palau": "aui,0,1b|||",
                "Papua_New_Guinea": "4hr,0,1ld,0,355,0,1b|||",
                "Paraguay": "4v8,0,5n,0,1b|4v8,0,a5,0,1b||",
                "Peru": "354,0,5n,0,1b|354,0,a5,0,1b||",
                "Philippines": "4va,0,5n,0,1b|4va,0,a5,0,1b||",
                "Phoenix_Islands": "aue,0,1l0,0,1b|||",
                "Pierre_Miquelon": "351,0,4vd,0,35t,0,4ve,0,5n,0,1b|351,0,4vd,0,35t,0,4ve,0,s9,0,1b||",
                "Pitcairn": "4vf,0,1b|||",
                "Ponape": "4e6,0,1b|||",
                "Pyongyang": "auc,0,1b|||",
                "Reunion": "aub,0,1b|||",
                "Rothera": "2qb,0,1b|||",
                "Sakhalin": "4vi,0,5n,0,1b|4vi,0,a5,0,1b||",
                "Samara": "4e5,0,5n,0,1b|4e5,0,a5,0,1b||",
                "Samoa": "4e4,0,5n,0,1b|4e4,0,s9,0,1b||",
                "Seychelles": "aua,0,1b|||",
                "Singapore": "4rq,0,1b|||",
                "Solomon": "au9,0,1l0,0,1b|||",
                "South_Georgia": "35u,0,27i,0,1b|||",
                "Suriname": "au8,0,1b|||",
                "Syowa": "34v,0,1b|||",
                "Tahiti": "34u,0,1b|||",
                "Taipei": "4vp,0,5n,0,1b|4vp,0,s9,0,1b||",
                "Tajikistan": "4vq,0,1b|||",
                "Tokelau": "4vr,0,1b|||",
                "Tonga": "1rl,0,5n,0,1b|1rl,0,a5,0,1b||",
                "Truk": "4vt,0,1b|||",
                "Turkmenistan": "1ri,0,5n,0,1b|1ri,0,a5,0,1b||",
                "Tuvalu": "4vv,0,1b|||",
                "Uruguay": "2jp,0,5n,0,1b|2jp,0,a5,0,1b||",
                "Uzbekistan": "501,0,5n,0,1b|501,0,a5,0,1b||",
                "Vanuatu": "502,0,5n,0,1b|502,0,a5,0,1b||",
                "Venezuela": "5vc,0,1b|||",
                "Vladivostok": "34t,0,5n,0,1b|34t,0,a5,0,1b||",
                "Volgograd": "504,0,5n,0,1b|504,0,a5,0,1b||",
                "Vostok": "au7,0,1b|||",
                "Wake": "34s,0,1ev,0,1b|||",
                "Wallis": "au6,0,35t,0,au5,0,1b|||",
                "Yakutsk": "509,0,5n,0,1b|509,0,a5,0,1b||",
                "Yekaterinburg": "50a,0,5n,0,1b|50a,0,a5,0,1b||"
            }
        },
        "hr-BA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6a7,0,1a,0,10||",
                "Europe/London": "|68h,0,4b,0,10||"
            },
            "metazone": {
                "Acre": "3q,0,1a,0,10|3q,0,4b,0,10||",
                "Afghanistan": "50b,0,10|||",
                "Africa_Central": "50c,0,10|||",
                "Africa_Eastern": "50d,0,10|||",
                "Africa_Southern": "50e,0,10|||",
                "Africa_Western": "34q,0,1a,0,10|34q,0,4b,0,10||",
                "Alaska": "34p,0,1a,0,10|34p,0,4b,0,10||",
                "Almaty": "34o,0,1a,0,10|34o,0,4b,0,10||",
                "Amazon": "34n,0,1a,0,10|34n,0,4b,0,10||",
                "America_Central": "1rf,0,1a,0,10|1rf,0,4b,0,10||",
                "America_Eastern": "111,0,1a,0,10|111,0,4b,0,10||",
                "America_Mountain": "17r,0,1a,0,10|17r,0,4b,0,10||",
                "America_Pacific": "110,0,1a,0,10|110,0,4b,0,10||",
                "Anadyr": "34m,0,1a,0,10|34m,0,4b,0,10||",
                "Apia": "1a,0,10,0,34l|4b,0,10,0,34l||",
                "Aqtau": "1a,0,10,0,18s,0,i4|4b,0,10,0,18s,0,i4||",
                "Aqtobe": "1a,0,10,0,18s,0,im|4b,0,10,0,18s,0,im||",
                "Arabian": "34k,0,1a,0,10|34k,0,4b,0,10||",
                "Argentina": "1rd,0,1a,0,10|1rd,0,4b,0,10||",
                "Argentina_Western": "11c,5,1rd,0,1a,0,10|11c,5,1rd,0,4b,0,10||",
                "Armenia": "34h,0,1a,0,10|34h,0,4b,0,10||",
                "Atlantic": "23j,0,1a,0,10|23j,0,4b,0,10||",
                "Australia_Central": "34g,0,1a,0,10|34g,0,4b,0,10||",
                "Australia_CentralWestern": "34f,0,1rf,0,11c,0,1a,0,10|34f,0,1rf,0,11c,0,4b,0,10||",
                "Australia_Eastern": "34e,0,1a,0,10|34e,0,4b,0,10||",
                "Australia_Western": "34d,0,1a,0,10|34d,0,4b,0,10||",
                "Azerbaijan": "34c,0,1a,0,10|34c,0,4b,0,10||",
                "Azores": "34a,0,1a,0,10|34a,0,4b,0,10||",
                "Bangladesh": "348,0,1a,0,10|348,0,4b,0,10||",
                "Bhutan": "512,0,10|||",
                "Bolivia": "513,0,10|||",
                "Brasilia": "347,0,1a,0,10|347,0,4b,0,10||",
                "Brunei": "10,0,l,0,2kg,0,a4|||",
                "Cape_Verde": "1a,0,10,0,343,0,33v|4b,0,10,0,343,0,33v||",
                "Casey": "10,0,519|||",
                "Chamorro": "1a,0,10,0,51a|||",
                "Chatham": "1a,0,10,0,33t|4b,0,10,0,33t||",
                "Chile": "33s,0,1a,0,10|33s,0,4b,0,10||",
                "China": "33r,0,1a,0,10|33r,0,4b,0,10||",
                "Choibalsan": "33q,0,1a,0,10|33q,0,4b,0,10||",
                "Christmas": "10,0,51f,0,1cl|||",
                "Cocos": "10,0,51h,0,12b|||",
                "Colombia": "33o,0,1a,0,10|33o,0,4b,0,10||",
                "Cook": "1a,0,10,0,51k,0,12b|51l,0,33l,k,0,51n,0,51o,k,0,4b,0,10||",
                "Cuba": "33k,0,1a,0,10|33k,0,4b,0,10||",
                "Davis": "10,0,51q|||",
                "DumontDUrville": "10,0,5b,5,4s0|||",
                "East_Timor": "51s,0,10|||",
                "Easter": "1a,0,10,0,33i,0,1cl|4b,0,10,0,33i,0,1cl||",
                "Ecuador": "51u,0,10|||",
                "Europe_Central": "33h,0,1a,0,10|33h,0,4b,0,10|h0|h4",
                "Europe_Eastern": "33g,0,1a,0,10|33g,0,4b,0,10|gu|gv",
                "Europe_Further_Eastern": "521,0,522,0,10|||",
                "Europe_Western": "33f,0,1a,0,10|33f,0,4b,0,10|h1|h2",
                "Falkland": "33e,0,1a,0,10|33e,0,4b,0,10||",
                "Fiji": "1a,0,10,0,33d|4b,0,10,0,33d||",
                "French_Guiana": "10,0,526,0,527|||",
                "French_Southern": "528,0,i3,0,2l1,0,10|||",
                "Galapagos": "10,0,52a|||",
                "Gambier": "10,0,52b|||",
                "Georgia": "33c,0,1a,0,10|33c,0,4b,0,10||",
                "Gilbert_Islands": "10,0,52d,0,12b|||",
                "GMT": "52e,0,10||ah|",
                "Greenland_Eastern": "33b,0,1a,0,10|33b,0,4b,0,10||",
                "Greenland_Western": "33a,0,1a,0,10|33a,0,4b,0,10||",
                "Guam": "52h,0,1a,0,10|||",
                "Gulf": "52i,0,1a,0,10|||",
                "Guyana": "52j,0,10|||",
                "Hawaii_Aleutian": "2l5,5,1k2,0,1a,0,10|2l5,5,1k2,0,4b,0,10||",
                "Hong_Kong": "339,0,1a,0,10|339,0,4b,0,10||",
                "Hovd": "338,0,1a,0,10|338,0,4b,0,10||",
                "India": "52o,0,10|||",
                "Indian_Ocean": "10,0,52p,0,52q|||",
                "Indochina": "52r,0,10|||",
                "Indonesia_Central": "52s,0,10|||",
                "Indonesia_Eastern": "52t,0,10|||",
                "Indonesia_Western": "52u,0,10|||",
                "Iran": "337,0,1a,0,10|337,0,4b,0,10||",
                "Irkutsk": "336,0,1a,0,10|336,0,4b,0,10||",
                "Israel": "335,0,1a,0,10|335,0,4b,0,10||",
                "Japan": "334,0,1a,0,10|334,0,4b,0,10||",
                "Kamchatka": "37,5,1i4,0,1a,0,10|37,5,1i4,0,4b,0,10||",
                "Kazakhstan_Eastern": "534,0,10|||",
                "Kazakhstan_Western": "535,0,10|||",
                "Korea": "333,0,1a,0,10|333,0,4b,0,10||",
                "Kosrae": "10,0,6f|||",
                "Krasnoyarsk": "332,0,1a,0,10|332,0,4b,0,10||",
                "Kyrgystan": "538,0,10|||",
                "Lanka": "539,0,10|||",
                "Line_Islands": "10,0,12b,0,ac|||",
                "Lord_Howe": "1a,0,10,0,1cl,0,1u,0,24|4b,0,10,0,1cl,0,1u,0,24||",
                "Macau": "1a,0,331,0,10|4b,0,331,0,10||",
                "Macquarie": "10,0,1cl,0,6m|||",
                "Magadan": "32u,0,1a,0,10|32u,0,4b,0,10||",
                "Malaysia": "53c,0,10|||",
                "Maldives": "53d,0,10|||",
                "Marquesas": "53e,0,10|||",
                "Marshall_Islands": "10,0,53f,0,12b|||",
                "Mauritius": "1a,0,10,0,32r|4b,0,10,0,32r||",
                "Mawson": "53h,0,10|||",
                "Mexico_Northwest": "32q,0,1hj,0,1a,0,10|32q,0,1hj,0,4b,0,10||",
                "Mexico_Pacific": "1hj,0,110,0,1a,0,10|1hj,0,110,0,4b,0,10||",
                "Mongolia": "32m,5,32l,0,1a,0,10|32m,5,32l,0,4b,0,10||",
                "Moscow": "31s,0,1a,0,10|31s,0,4b,0,10||",
                "Myanmar": "53m,0,10|||",
                "Nauru": "10,0,53n|||",
                "Nepal": "53o,0,10|||",
                "New_Caledonia": "1a,0,10,0,2ll,0,3rs|4b,0,10,0,2ll,0,3rs||",
                "New_Zealand": "31t,0,1a,0,10|31t,0,4b,0,10||",
                "Newfoundland": "31u,0,1a,0,10|31u,0,4b,0,10||",
                "Niue": "10,0,53t|||",
                "Norfolk": "10,0,12b,0,6l|||",
                "Noronha": "1a,0,10,0,18s,0,1s,0,2,0,23|4b,0,10,0,18s,0,1s,0,2,0,23||",
                "North_Mariana": "10,0,53u,0,12b|||",
                "Novosibirsk": "31v,0,1a,0,10|31v,0,4b,0,10||",
                "Omsk": "320,0,1a,0,10|320,0,4b,0,10||",
                "Pakistan": "321,0,1a,0,10|321,0,4b,0,10||",
                "Palau": "10,0,542|||",
                "Papua_New_Guinea": "10,0,543,0,2ll,0,544|||",
                "Paraguay": "322,0,1a,0,10|322,0,4b,0,10||",
                "Peru": "323,0,1a,0,10|323,0,4b,0,10||",
                "Philippines": "324,0,1a,0,10|324,0,4b,0,10||",
                "Phoenix_Islands": "10,0,12b,0,90|||",
                "Pierre_Miquelon": "1a,0,10,0,l,0,325,0,326,0,i3,0,u2|4b,0,10,0,l,0,325,0,326,0,i3,0,u2||",
                "Pitcairn": "10,0,54a|||",
                "Ponape": "10,0,54b|||",
                "Pyongyang": "54c,0,10|||",
                "Qyzylorda": "1a,0,10,0,18s,0,327|4b,0,10,0,18s,0,327||",
                "Reunion": "10,0,54e|||",
                "Rothera": "10,0,54f|||",
                "Sakhalin": "328,0,1a,0,10|328,0,4b,0,10||",
                "Samara": "329,0,1a,0,10|329,0,4b,0,10||",
                "Samoa": "32a,0,1a,0,10|32a,0,4b,0,10||",
                "Seychelles": "54j,0,10|||",
                "Singapore": "54k,0,10|||",
                "Solomon": "10,0,54l,0,12b|||",
                "South_Georgia": "10,0,54m,0,54n|||",
                "Suriname": "54o,0,10|||",
                "Syowa": "10,0,54p|||",
                "Tahiti": "10,0,54q|||",
                "Taipei": "32b,0,1a,0,10|32b,0,4b,0,10||",
                "Tajikistan": "54s,0,10|||",
                "Tokelau": "10,0,54t|||",
                "Tonga": "1a,0,10,0,32c|4b,0,10,0,32c||",
                "Truk": "10,0,54v|||",
                "Turkmenistan": "32d,0,1a,0,10|32d,0,4b,0,10||",
                "Tuvalu": "10,0,551|||",
                "Uruguay": "32e,0,1a,0,10|32e,0,4b,0,10||",
                "Uzbekistan": "32f,0,1a,0,10|32f,0,4b,0,10||",
                "Vanuatu": "1a,0,10,0,32g|4b,0,10,0,32g||",
                "Venezuela": "555,0,10|||",
                "Vladivostok": "32h,0,1a,0,10|32h,0,4b,0,10||",
                "Volgograd": "32i,0,1a,0,10|32i,0,4b,0,10||",
                "Vostok": "558,0,10|||",
                "Wake": "10,0,12b,0,5r|||",
                "Wallis": "10,0,12b,0,5f,0,i3,0,5k|||",
                "Yakutsk": "32j,0,1a,0,10|32j,0,4b,0,10||",
                "Yekaterinburg": "32k,0,1a,0,10|32k,0,4b,0,10||"
            }
        },
        "hr": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6a7,0,1a,0,10||",
                "Europe/London": "|68h,0,4b,0,10||"
            },
            "metazone": {
                "Acre": "3q,0,1a,0,10|3q,0,4b,0,10||",
                "Afghanistan": "50b,0,10|||",
                "Africa_Central": "50c,0,10|||",
                "Africa_Eastern": "50d,0,10|||",
                "Africa_Southern": "50e,0,10|||",
                "Africa_Western": "34q,0,1a,0,10|34q,0,4b,0,10||",
                "Alaska": "34p,0,1a,0,10|34p,0,4b,0,10||",
                "Almaty": "34o,0,1a,0,10|34o,0,4b,0,10||",
                "Amazon": "34n,0,1a,0,10|34n,0,4b,0,10||",
                "America_Central": "1rf,0,1a,0,10|1rf,0,4b,0,10||",
                "America_Eastern": "111,0,1a,0,10|111,0,4b,0,10||",
                "America_Mountain": "17r,0,1a,0,10|17r,0,4b,0,10||",
                "America_Pacific": "110,0,1a,0,10|110,0,4b,0,10||",
                "Anadyr": "34m,0,1a,0,10|34m,0,4b,0,10||",
                "Apia": "1a,0,10,0,34l|4b,0,10,0,34l||",
                "Aqtau": "1a,0,10,0,18s,0,i4|4b,0,10,0,18s,0,i4||",
                "Aqtobe": "1a,0,10,0,18s,0,im|4b,0,10,0,18s,0,im||",
                "Arabian": "34k,0,1a,0,10|34k,0,4b,0,10||",
                "Argentina": "1rd,0,1a,0,10|1rd,0,4b,0,10||",
                "Argentina_Western": "11c,5,1rd,0,1a,0,10|11c,5,1rd,0,4b,0,10||",
                "Armenia": "34h,0,1a,0,10|34h,0,4b,0,10||",
                "Atlantic": "23j,0,1a,0,10|23j,0,4b,0,10||",
                "Australia_Central": "34g,0,1a,0,10|34g,0,4b,0,10||",
                "Australia_CentralWestern": "34f,0,1rf,0,11c,0,1a,0,10|34f,0,1rf,0,11c,0,4b,0,10||",
                "Australia_Eastern": "34e,0,1a,0,10|34e,0,4b,0,10||",
                "Australia_Western": "34d,0,1a,0,10|34d,0,4b,0,10||",
                "Azerbaijan": "34c,0,1a,0,10|34c,0,4b,0,10||",
                "Azores": "34a,0,1a,0,10|34a,0,4b,0,10||",
                "Bangladesh": "348,0,1a,0,10|348,0,4b,0,10||",
                "Bhutan": "512,0,10|||",
                "Bolivia": "513,0,10|||",
                "Brasilia": "347,0,1a,0,10|347,0,4b,0,10||",
                "Brunei": "10,0,l,0,2kg,0,a4|||",
                "Cape_Verde": "1a,0,10,0,343,0,33v|4b,0,10,0,343,0,33v||",
                "Casey": "10,0,519|||",
                "Chamorro": "1a,0,10,0,51a|||",
                "Chatham": "1a,0,10,0,33t|4b,0,10,0,33t||",
                "Chile": "33s,0,1a,0,10|33s,0,4b,0,10||",
                "China": "33r,0,1a,0,10|33r,0,4b,0,10||",
                "Choibalsan": "33q,0,1a,0,10|33q,0,4b,0,10||",
                "Christmas": "10,0,51f,0,1cl|||",
                "Cocos": "10,0,51h,0,12b|||",
                "Colombia": "33o,0,1a,0,10|33o,0,4b,0,10||",
                "Cook": "1a,0,10,0,51k,0,12b|51l,0,33l,k,0,51n,0,51o,k,0,4b,0,10||",
                "Cuba": "33k,0,1a,0,10|33k,0,4b,0,10||",
                "Davis": "10,0,51q|||",
                "DumontDUrville": "10,0,5b,5,4s0|||",
                "East_Timor": "51s,0,10|||",
                "Easter": "1a,0,10,0,33i,0,1cl|4b,0,10,0,33i,0,1cl||",
                "Ecuador": "51u,0,10|||",
                "Europe_Central": "33h,0,1a,0,10|33h,0,4b,0,10|h0|h4",
                "Europe_Eastern": "33g,0,1a,0,10|33g,0,4b,0,10|gu|gv",
                "Europe_Further_Eastern": "521,0,522,0,10|||",
                "Europe_Western": "33f,0,1a,0,10|33f,0,4b,0,10|h1|h2",
                "Falkland": "33e,0,1a,0,10|33e,0,4b,0,10||",
                "Fiji": "1a,0,10,0,33d|4b,0,10,0,33d||",
                "French_Guiana": "10,0,526,0,527|||",
                "French_Southern": "528,0,i3,0,2l1,0,10|||",
                "Galapagos": "10,0,52a|||",
                "Gambier": "10,0,52b|||",
                "Georgia": "33c,0,1a,0,10|33c,0,4b,0,10||",
                "Gilbert_Islands": "10,0,52d,0,12b|||",
                "GMT": "52e,0,10||ah|",
                "Greenland_Eastern": "33b,0,1a,0,10|33b,0,4b,0,10||",
                "Greenland_Western": "33a,0,1a,0,10|33a,0,4b,0,10||",
                "Guam": "52h,0,1a,0,10|||",
                "Gulf": "52i,0,1a,0,10|||",
                "Guyana": "52j,0,10|||",
                "Hawaii_Aleutian": "2l5,5,1k2,0,1a,0,10|2l5,5,1k2,0,4b,0,10||",
                "Hong_Kong": "339,0,1a,0,10|339,0,4b,0,10||",
                "Hovd": "338,0,1a,0,10|338,0,4b,0,10||",
                "India": "52o,0,10|||",
                "Indian_Ocean": "10,0,52p,0,52q|||",
                "Indochina": "52r,0,10|||",
                "Indonesia_Central": "52s,0,10|||",
                "Indonesia_Eastern": "52t,0,10|||",
                "Indonesia_Western": "52u,0,10|||",
                "Iran": "337,0,1a,0,10|337,0,4b,0,10||",
                "Irkutsk": "336,0,1a,0,10|336,0,4b,0,10||",
                "Israel": "335,0,1a,0,10|335,0,4b,0,10||",
                "Japan": "334,0,1a,0,10|334,0,4b,0,10||",
                "Kamchatka": "37,5,1i4,0,1a,0,10|37,5,1i4,0,4b,0,10||",
                "Kazakhstan_Eastern": "534,0,10|||",
                "Kazakhstan_Western": "535,0,10|||",
                "Korea": "333,0,1a,0,10|333,0,4b,0,10||",
                "Kosrae": "10,0,6f|||",
                "Krasnoyarsk": "332,0,1a,0,10|332,0,4b,0,10||",
                "Kyrgystan": "538,0,10|||",
                "Lanka": "539,0,10|||",
                "Line_Islands": "10,0,12b,0,ac|||",
                "Lord_Howe": "1a,0,10,0,1cl,0,1u,0,24|4b,0,10,0,1cl,0,1u,0,24||",
                "Macau": "1a,0,331,0,10|4b,0,331,0,10||",
                "Macquarie": "10,0,1cl,0,6m|||",
                "Magadan": "32u,0,1a,0,10|32u,0,4b,0,10||",
                "Malaysia": "53c,0,10|||",
                "Maldives": "53d,0,10|||",
                "Marquesas": "53e,0,10|||",
                "Marshall_Islands": "10,0,53f,0,12b|||",
                "Mauritius": "1a,0,10,0,32r|4b,0,10,0,32r||",
                "Mawson": "53h,0,10|||",
                "Mexico_Northwest": "32q,0,1hj,0,1a,0,10|32q,0,1hj,0,4b,0,10||",
                "Mexico_Pacific": "1hj,0,110,0,1a,0,10|1hj,0,110,0,4b,0,10||",
                "Mongolia": "32m,5,32l,0,1a,0,10|32m,5,32l,0,4b,0,10||",
                "Moscow": "31s,0,1a,0,10|31s,0,4b,0,10||",
                "Myanmar": "53m,0,10|||",
                "Nauru": "10,0,53n|||",
                "Nepal": "53o,0,10|||",
                "New_Caledonia": "1a,0,10,0,2ll,0,3rs|4b,0,10,0,2ll,0,3rs||",
                "New_Zealand": "31t,0,1a,0,10|31t,0,4b,0,10||",
                "Newfoundland": "31u,0,1a,0,10|31u,0,4b,0,10||",
                "Niue": "10,0,53t|||",
                "Norfolk": "10,0,12b,0,6l|||",
                "Noronha": "1a,0,10,0,18s,0,1s,0,2,0,23|4b,0,10,0,18s,0,1s,0,2,0,23||",
                "North_Mariana": "10,0,53u,0,12b|||",
                "Novosibirsk": "31v,0,1a,0,10|31v,0,4b,0,10||",
                "Omsk": "320,0,1a,0,10|320,0,4b,0,10||",
                "Pakistan": "321,0,1a,0,10|321,0,4b,0,10||",
                "Palau": "10,0,542|||",
                "Papua_New_Guinea": "10,0,543,0,2ll,0,544|||",
                "Paraguay": "322,0,1a,0,10|322,0,4b,0,10||",
                "Peru": "323,0,1a,0,10|323,0,4b,0,10||",
                "Philippines": "324,0,1a,0,10|324,0,4b,0,10||",
                "Phoenix_Islands": "10,0,12b,0,90|||",
                "Pierre_Miquelon": "1a,0,10,0,l,0,325,0,326,0,i3,0,u2|4b,0,10,0,l,0,325,0,326,0,i3,0,u2||",
                "Pitcairn": "10,0,54a|||",
                "Ponape": "10,0,54b|||",
                "Pyongyang": "54c,0,10|||",
                "Qyzylorda": "1a,0,10,0,18s,0,327|4b,0,10,0,18s,0,327||",
                "Reunion": "10,0,54e|||",
                "Rothera": "10,0,54f|||",
                "Sakhalin": "328,0,1a,0,10|328,0,4b,0,10||",
                "Samara": "329,0,1a,0,10|329,0,4b,0,10||",
                "Samoa": "32a,0,1a,0,10|32a,0,4b,0,10||",
                "Seychelles": "54j,0,10|||",
                "Singapore": "54k,0,10|||",
                "Solomon": "10,0,54l,0,12b|||",
                "South_Georgia": "10,0,54m,0,54n|||",
                "Suriname": "54o,0,10|||",
                "Syowa": "10,0,54p|||",
                "Tahiti": "10,0,54q|||",
                "Taipei": "32b,0,1a,0,10|32b,0,4b,0,10||",
                "Tajikistan": "54s,0,10|||",
                "Tokelau": "10,0,54t|||",
                "Tonga": "1a,0,10,0,32c|4b,0,10,0,32c||",
                "Truk": "10,0,54v|||",
                "Turkmenistan": "32d,0,1a,0,10|32d,0,4b,0,10||",
                "Tuvalu": "10,0,551|||",
                "Uruguay": "32e,0,1a,0,10|32e,0,4b,0,10||",
                "Uzbekistan": "32f,0,1a,0,10|32f,0,4b,0,10||",
                "Vanuatu": "1a,0,10,0,32g|4b,0,10,0,32g||",
                "Venezuela": "555,0,10|||",
                "Vladivostok": "32h,0,1a,0,10|32h,0,4b,0,10||",
                "Volgograd": "32i,0,1a,0,10|32i,0,4b,0,10||",
                "Vostok": "558,0,10|||",
                "Wake": "10,0,12b,0,5r|||",
                "Wallis": "10,0,12b,0,5f,0,i3,0,5k|||",
                "Yakutsk": "32j,0,1a,0,10|32j,0,4b,0,10||",
                "Yekaterinburg": "32k,0,1a,0,10|32k,0,4b,0,10||"
            }
        },
        "hsb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cb4,0,g5,0,11||",
                "Europe/London": "|6mo,0,g5,0,11||"
            },
            "metazone": {
                "Afghanistan": "au1,0,11|||",
                "Africa_Central": "au0,0,11|||",
                "Africa_Eastern": "atv,0,11|||",
                "Africa_Southern": "atu,0,11|||",
                "Africa_Western": "55f,0,ad,0,11|55f,0,g5,0,11||",
                "Alaska": "55h,0,ad,0,11|55h,0,g5,0,11||",
                "Amazon": "44m,0,ad,0,11|44m,0,g5,0,11||",
                "America_Central": "1uc,0,44l,0,ad,0,11|1uc,0,44l,0,g5,0,11||",
                "America_Eastern": "1uc,0,55j,0,ad,0,11|1uc,0,55j,0,g5,0,11||",
                "America_Mountain": "1uc,0,55k,0,ad,0,11|1uc,0,55k,0,g5,0,11||",
                "America_Pacific": "1uc,0,1vb,0,ad,0,11|1uc,0,1vb,0,g5,0,11||",
                "Apia": "44i,0,ad,0,11|44i,0,g5,0,11||",
                "Arabian": "55l,0,ad,0,11|55l,0,g5,0,11||",
                "Argentina": "55m,0,ad,0,11|55m,0,g5,0,11||",
                "Argentina_Western": "55n,0,ad,0,11|55n,0,g5,0,11||",
                "Armenia": "55o,0,ad,0,11|55o,0,g5,0,11||",
                "Atlantic": "55p,0,ad,0,11|55p,0,g5,0,11||",
                "Australia_Central": "55q,0,ad,0,11|55q,0,g5,0,11||",
                "Australia_CentralWestern": "atr,0,44h,0,ad,0,11|atn,0,44h,0,g5,0,11||",
                "Australia_Eastern": "55t,0,ad,0,11|55t,0,g5,0,11||",
                "Australia_Western": "55u,0,ad,0,11|55u,0,g5,0,11||",
                "Azerbaijan": "55v,0,ad,0,11|55v,0,g5,0,11||",
                "Azores": "560,0,ad,0,11|560,0,g5,0,11||",
                "Bangladesh": "561,0,ad,0,11|561,0,g5,0,11||",
                "Bhutan": "ati,0,11|||",
                "Bolivia": "ath,0,11|||",
                "Brasilia": "564,0,ad,0,11|564,0,g5,0,11||",
                "Brunei": "atg,0,11|||",
                "Cape_Verde": "566,0,ad,0,11|566,0,g5,0,11||",
                "Chamorro": "atf,0,11|||",
                "Chatham": "568,0,ad,0,11|568,0,g5,0,11||",
                "Chile": "569,0,ad,0,11|569,0,g5,0,11||",
                "China": "56a,0,ad,0,11|56a,0,g5,0,11||",
                "Choibalsan": "32p,0,ad,0,11|32p,0,g5,0,11||",
                "Christmas": "11,0,atd,0,19r|||",
                "Cocos": "11,0,7eq,0,10v|||",
                "Colombia": "56d,0,ad,0,11|56d,0,g5,0,11||",
                "Cook": "ad,0,11,0,445,0,10v|g5,0,11,0,445,0,10v||",
                "Cuba": "56e,0,ad,0,11|56e,0,g5,0,11||",
                "Davis": "atb,0,11|||",
                "DumontDUrville": "5b,0,at6,0,at5,0,11|||",
                "East_Timor": "at4,0,11|||",
                "Easter": "ad,0,11,0,56j,0,19r|g5,0,11,0,56j,0,19r||",
                "Ecuador": "at1,0,11|||",
                "Europe_Central": "56l,0,ad,0,11|56l,0,g5,0,11|1bd|1be",
                "Europe_Eastern": "56m,0,ad,0,11|56m,0,g5,0,11|1bg|1bh",
                "Europe_Further_Eastern": "7g5,0,11|||",
                "Europe_Western": "56n,0,ad,0,11|56n,0,g5,0,11|1bk|1bl",
                "Falkland": "56o,0,ad,0,11|56o,0,g5,0,11||",
                "Fiji": "56p,0,ad,0,11|56p,0,g5,0,11||",
                "French_Guiana": "at0,0,11|||",
                "French_Southern": "11,0,asv,0,asu,0,a6,0,7i9,0,asr|||",
                "Galapagos": "asq,0,11|||",
                "Gambier": "aso,0,11|||",
                "Georgia": "570,0,ad,0,11|570,0,g5,0,11||",
                "Gilbert_Islands": "11,0,7kc,0,10v|||",
                "GMT": "7kd,0,11|||",
                "Greenland_Eastern": "571,0,ad,0,11|571,0,g5,0,11||",
                "Greenland_Western": "572,0,ad,0,11|572,0,g5,0,11||",
                "Gulf": "11,0,asl,0,7m8|||",
                "Guyana": "ask,0,11|||",
                "Hawaii_Aleutian": "575,5,2eq,0,ad,0,11|575,5,2eq,0,g5,0,11||",
                "Hong_Kong": "43m,0,ad,0,11|43m,0,g5,0,11||",
                "Hovd": "43l,0,ad,0,11|43l,0,g5,0,11||",
                "India": "asj,0,11|||",
                "Indian_Ocean": "asi,0,11|||",
                "Indochina": "ash,0,11|||",
                "Indonesia_Central": "asg,0,11|||",
                "Indonesia_Eastern": "asf|||",
                "Indonesia_Western": "ase,0,11|||",
                "Iran": "57c,0,ad,0,11|57c,0,g5,0,11||",
                "Irkutsk": "1uo,0,ad,0,11|1uo,0,g5,0,11||",
                "Israel": "57d,0,ad,0,11|57d,0,g5,0,11||",
                "Japan": "57e,0,ad,0,11|57e,0,g5,0,11||",
                "Kazakhstan_Eastern": "asd,0,11|||",
                "Kazakhstan_Western": "asc,0,11|||",
                "Korea": "57h,0,ad,0,11|57h,0,g5,0,11||",
                "Kosrae": "asb,0,11|||",
                "Krasnoyarsk": "1un,0,ad,0,11|1un,0,g5,0,11||",
                "Kyrgystan": "asa,0,11|||",
                "Line_Islands": "11,0,7qh,0,10v|||",
                "Lord_Howe": "ad,0,11,0,19r,0,1u,5,24|g5,0,11,0,19r,0,1u,5,24||",
                "Macquarie": "11,0,19r,0,6m|||",
                "Magadan": "32t,0,ad,0,11|32t,0,g5,0,11||",
                "Malaysia": "as9,0,11|||",
                "Maldives": "as8,0,11|||",
                "Marquesas": "as7,0,11|||",
                "Marshall_Islands": "11,0,7r5,0,10v|||",
                "Mauritius": "57o,0,ad,0,11|57o,0,g5,0,11||",
                "Mawson": "57p,0,11|||",
                "Mexico_Northwest": "330,0,57r,0,ad,0,11|330,0,57r,0,g5,0,11||",
                "Mexico_Pacific": "330,0,1vb,0,ad,0,11|330,0,1vb,0,g5,0,11||",
                "Mongolia": "4f,5,41m,0,ad,0,11|4f,5,41m,0,g5,0,11||",
                "Moscow": "41h,0,ad,0,11|41h,0,g5,0,11||",
                "Myanmar": "as6,0,11|||",
                "Nauru": "as5,0,11|||",
                "Nepal": "as4,0,11|||",
                "New_Caledonia": "57v,0,ad,0,11|57v,0,g5,0,11||",
                "New_Zealand": "580,0,ad,0,11|580,0,g5,0,11||",
                "Newfoundland": "581,0,ad,0,11|581,0,g5,0,11||",
                "Niue": "as3,0,11|||",
                "Norfolk": "11,0,19r,0,6l|||",
                "Noronha": "ad,0,11,0,10v,0,1s,0,2,0,23|g5,0,11,0,10v,0,1s,0,2,0,23||",
                "Novosibirsk": "414,0,ad,0,11|414,0,g5,0,11||",
                "Omsk": "1ug,0,ad,0,11|1ug,0,g5,0,11||",
                "Pakistan": "583,0,ad,0,11|583,0,g5,0,11||",
                "Palau": "as2,0,11|||",
                "Papua_New_Guinea": "as1,5,arv,0,11|||",
                "Paraguay": "40k,0,ad,0,11|40k,0,g5,0,11||",
                "Peru": "587,0,ad,0,11|587,0,g5,0,11||",
                "Philippines": "588,0,ad,0,11|588,0,g5,0,11||",
                "Phoenix_Islands": "11,0,7su,0,10v|||",
                "Pierre_Miquelon": "ad,0,11,0,10v,0,7u,0,33,0,a6,0,35|g5,0,11,0,10v,0,7u,0,33,0,a6,0,35||",
                "Pitcairn": "11,0,7tn,0,10v|||",
                "Ponape": "aru,0,11|||",
                "Reunion": "art,0,11|||",
                "Rothera": "arr,0,11|||",
                "Sakhalin": "58c,0,ad,0,11|58c,0,g5,0,11||",
                "Samoa": "58d,0,ad,0,11|58d,0,g5,0,11||",
                "Seychelles": "arq,0,11|||",
                "Singapore": "4j2,0,11|||",
                "Solomon": "11,0,arp,0,10v|||",
                "South_Georgia": "aro,0,11|||",
                "Suriname": "arn,0,11|||",
                "Syowa": "arm,0,11|||",
                "Tahiti": "arl,0,11|||",
                "Taipei": "58k,0,ad,0,11|58k,0,g5,0,11||",
                "Tajikistan": "arh,0,11|||",
                "Tokelau": "arg,0,11|||",
                "Tonga": "58n,0,ad,0,11|58n,0,g5,0,11||",
                "Truk": "arf,0,11|||",
                "Turkmenistan": "58p,0,ad,0,11|58p,0,g5,0,11||",
                "Tuvalu": "ard,0,11|||",
                "Uruguay": "58r,0,ad,0,11|58r,0,g5,0,11||",
                "Uzbekistan": "58s,0,ad,0,11|58s,0,g5,0,11||",
                "Vanuatu": "58t,0,ad,0,11|58t,0,g5,0,11||",
                "Venezuela": "arb,0,11|||",
                "Vladivostok": "403,0,ad,0,11|403,0,g5,0,11||",
                "Volgograd": "401,0,ad,0,11|401,0,g5,0,11||",
                "Vostok": "ar5,0,11|||",
                "Wake": "11,0,19r,0,5r|||",
                "Wallis": "11,0,10v,0,5f,0,a6,0,5k|||",
                "Yakutsk": "1u5,0,ad,0,11|1u5,0,g5,0,11||",
                "Yekaterinburg": "3vt,0,ad,0,11|3vt,0,g5,0,11||"
            }
        },
        "hu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cb5,0,eb,0,7f||",
                "Europe/London": "|cb6,0,eb,0,7f||"
            },
            "metazone": {
                "Acre": "3q,0,147|3q,0,eb,0,7f||",
                "Afghanistan": "ar4,0,7f|||",
                "Africa_Central": "1qv,5,310,0,eu,0,7f|||",
                "Africa_Eastern": "1n3,5,310,0,eu,0,7f|||",
                "Africa_Southern": "ar3,5,310,0,eu,0,7f|||",
                "Africa_Western": "1a8,5,310,0,eu,0,7f|1a8,5,310,0,eb,0,7f||",
                "Alaska": "59a,0,147|59a,0,eb,0,7f||",
                "Almaty": "1nf,0,147|1nf,0,eb,0,7f||",
                "Amazon": "59c,0,eu,0,7f|59c,0,eb,0,7f||",
                "America_Central": "59d,0,33m,0,147|59d,0,33m,0,eb,0,7f||",
                "America_Eastern": "59f,0,33m,0,147|59f,0,33m,0,eb,0,7f||",
                "America_Mountain": "59g,0,147|59g,0,eb,0,7f||",
                "America_Pacific": "33n,5,2ae,0,147|33n,5,2ae,0,eb,0,7f||",
                "Anadyr": "59j,0,147|59j,0,eb,0,7f||",
                "Apia": "59k,0,eu,0,7f|59k,0,eb,0,7f||",
                "Aqtau": "59l,0,147|59l,0,eb,0,7f||",
                "Aqtobe": "59m,0,147|59m,0,eb,0,7f||",
                "Arabian": "59n,0,eu,0,7f|59n,0,eb,0,7f||",
                "Argentina": "4rv,0,eu,0,7f|ar1,0,eb,0,7f||",
                "Argentina_Western": "1a8,5,4rv,0,eu,0,7f|1a8,5,4rv,0,eb,0,7f||",
                "Armenia": "59q,0,eu,0,7f|59q,0,eb,0,7f||",
                "Atlantic": "59r,5,2ae,0,147|59r,5,2ae,0,eb,0,7f||",
                "Australia_Central": "1qv,5,1r2,0,eu,0,7f|1qv,5,1r2,0,eb,0,7f||",
                "Australia_CentralWestern": "1qv,5,1a8,5,1r2,0,eu,0,7f|1qv,5,1a8,5,1r2,0,eb,0,7f||",
                "Australia_Eastern": "1n3,5,1r2,0,eu,0,7f|1n3,5,1r2,0,eb,0,7f||",
                "Australia_Western": "1a8,5,1r2,0,eu,0,7f|1a8,5,1r2,0,eb,0,7f||",
                "Azerbaijan": "59t,0,eu,0,7f|59t,0,eb,0,7f||",
                "Azores": "59u,0,eu,0,7f|59u,0,eb,0,7f||",
                "Bangladesh": "59v,0,eu,0,7f|59v,0,eb,0,7f||",
                "Bhutan": "aqv,0,7f|||",
                "Bolivia": "aqu,0,eu,0,7f|||",
                "Brasilia": "5a2,0,eu,0,7f|5a2,0,eb,0,7f||",
                "Brunei": "9o,0,a4,5,i3,0,7f|||",
                "Cape_Verde": "5a3,5,5a4,5,140,0,eu,0,7f|5a3,5,5a4,5,140,0,eb,0,7f||",
                "Chamorro": "aqt,0,eu,0,7f|||",
                "Chatham": "5a7,0,eu,0,7f|5a7,0,eb,0,7f||",
                "Chile": "5a8,0,eu,0,7f|5a8,0,eb,0,7f||",
                "China": "5a9,0,eu,0,7f|5a9,0,eb,0,7f||",
                "Choibalsan": "5aa,0,eu,0,7f|5aa,0,eb,0,7f||",
                "Christmas": "aqs,5,1r6,0,eu,0,7f|||",
                "Cocos": "aqr,5,140,0,eu,0,7f|||",
                "Colombia": "5ae,0,eu,0,7f|5ae,0,eb,0,7f||",
                "Cook": "5af,5,140,0,eu,0,7f|5af,5,140,0,aqp,0,eb,0,7f||",
                "Cuba": "5ah,0,eu,0,7f|5ah,0,eb,0,7f||",
                "Davis": "aqo,0,7f|||",
                "DumontDUrville": "aqn,5,5j,5,i3,0,7f|||",
                "East_Timor": "1n3,5,aqm,0,eu,0,7f|||",
                "Easter": "5al,5,1r6,0,eu,0,7f|5al,5,1r6,0,eb,0,7f||",
                "Ecuador": "aqj,0,eu,0,7f|||",
                "Europe_Central": "1qv,5,2ki,0,eu,0,7f|1qv,5,2ki,0,eb,0,7f|h0|h4",
                "Europe_Eastern": "1n3,5,2ki,0,eu,0,7f|1n3,5,2ki,0,eb,0,7f|gu|gv",
                "Europe_Further_Eastern": "aqg,0,7f|||",
                "Europe_Western": "1a8,5,2ki,0,eu,0,7f|1a8,5,2ki,0,eb,0,7f|h1|h2",
                "Falkland": "5ap,5,140,0,eu,0,7f|5ap,5,140,0,eb,0,7f||",
                "Fiji": "5aq,0,eu,0,7f|5aq,0,eb,0,7f||",
                "French_Guiana": "5ar,5,aqe,0,7f|||",
                "French_Southern": "5ar,0,5at,0,340,0,aqd,0,7f|||",
                "Galapagos": "aqc,0,eu,0,7f|||",
                "Gambier": "aqb,0,7f|||",
                "Georgia": "5b2,0,eu,0,7f|5b2,0,eb,0,7f||",
                "Gilbert_Islands": "aqa,5,140,0,7f|||",
                "GMT": "aq9,0,aq6,k,0,eu,0,7f||ah|",
                "Greenland_Eastern": "1n3,5,342,0,eu,0,7f|1n3,5,342,0,eb,0,7f||",
                "Greenland_Western": "1a8,5,342,0,eu,0,7f|1a8,5,342,0,eb,0,7f||",
                "Guam": "5s2,0,147|||",
                "Gulf": "aq5,0,eu,0,7f|||",
                "Guyana": "aq4,0,eu,0,7f|||",
                "Hawaii_Aleutian": "5b9,5,5ba,0,eu,0,7f|5b9,5,5ba,0,eb,0,7f||",
                "Hong_Kong": "5bb,0,eu,0,7f|5bb,0,eb,0,7f||",
                "Hovd": "5bc,0,eu,0,7f|5bc,0,eb,0,7f||",
                "India": "5bd,0,eu,0,7f|||",
                "Indian_Ocean": "5bd,5,2ae,0,7f|||",
                "Indochina": "aq0,0,7f|||",
                "Indonesia_Central": "1qv,5,4rs,0,7f|||",
                "Indonesia_Eastern": "1n3,5,4rs,0,7f|||",
                "Indonesia_Western": "1a8,5,4rs,0,eu,0,7f|||",
                "Iran": "5bg,0,eu,0,7f|5bg,0,eb,0,7f||",
                "Irkutsk": "5bh,0,eu,0,7f|5bh,0,eb,0,7f||",
                "Israel": "5bi,0,eu,0,7f|5bi,0,eb,0,7f||",
                "Japan": "5bj,0,eu,0,7f|5bj,0,eb,0,7f||",
                "Kamchatka": "5bk,5,5bl,0,147|5bk,5,5bl,0,eb,0,7f||",
                "Kazakhstan_Eastern": "1n3,5,5bm,0,7f|||",
                "Kazakhstan_Western": "1a8,5,5bm,0,7f|||",
                "Korea": "5bn,0,eu,0,7f|5bn,0,eb,0,7f||",
                "Kosrae": "aps,0,7f|||",
                "Krasnoyarsk": "5bp,0,eu,0,7f|5bp,0,eb,0,7f||",
                "Kyrgystan": "apq,0,7f|||",
                "Lanka": "app,0,7f|||",
                "Line_Islands": "apn,5,140,0,7f|||",
                "Lord_Howe": "1u,0,24,5,1r6,0,eu,0,7f|1u,0,24,5,1r6,0,eb,0,7f||",
                "Macau": "5bt,0,147|5bt,0,eb,0,7f||",
                "Macquarie": "apm,5,1r6,0,eu,0,7f|||",
                "Magadan": "aph,0,eu,0,7f|apg,0,eb,0,7f||",
                "Malaysia": "ape,0,7f|||",
                "Maldives": "apd,5,140,0,7f|||",
                "Marquesas": "apc,5,140,0,7f|||",
                "Marshall_Islands": "apb,5,140,0,7f|||",
                "Mauritius": "5c5,0,eu,0,7f|5c5,0,eb,0,7f||",
                "Mawson": "apa,0,7f|||",
                "Mexico_Northwest": "5c7,5,34b,0,147|5c7,5,34b,0,eb,0,7f||",
                "Mexico_Pacific": "34b,0,33n,5,2ae,0,147|34b,0,33n,5,2ae,0,eb,0,7f||",
                "Mongolia": "5c9,0,eu,0,7f|5c9,0,eb,0,7f||",
                "Moscow": "5ca,0,eu,0,7f|5ca,0,eb,0,7f||",
                "Myanmar": "ap8,0,7f|||",
                "Nauru": "ap6,0,7f|||",
                "Nepal": "ap5,0,7f|||",
                "New_Caledonia": "2ab,5,5cf,0,eu,0,7f|2ab,5,5cf,0,eb,0,7f||",
                "New_Zealand": "2ab,5,5cg,0,eu,0,7f|2ab,5,5cg,0,eb,0,7f||",
                "Newfoundland": "2ab,5,5ch,0,147|2ab,5,5ch,0,eb,0,7f||",
                "Niue": "ap4,0,7f|||",
                "Norfolk": "ap3,5,140,0,7f|||",
                "Noronha": "1s,0,2,0,23,5,i3,0,eu,0,7f|1s,0,2,0,23,5,i3,0,eb,0,7f||",
                "North_Mariana": "ap2,5,ap1,5,140,0,7f|||",
                "Novosibirsk": "5cm,0,eu,0,7f|5cm,0,eb,0,7f||",
                "Omsk": "5cn,0,eu,0,7f|5cn,0,eb,0,7f||",
                "Pakistan": "5co,0,eu,0,7f|5co,0,eb,0,7f||",
                "Palau": "ap0,0,7f|||",
                "Papua_New_Guinea": "aov,0,2ab,5,aou,0,7f|||",
                "Paraguay": "5cs,0,eu,0,7f|5cs,0,eb,0,7f||",
                "Peru": "5ct,0,eu,0,7f|5ct,0,eb,0,7f||",
                "Philippines": "5cu,5,140,0,eu,0,7f|5cu,5,140,0,eb,0,7f||",
                "Phoenix_Islands": "aot,5,140,0,eu,0,7f|||",
                "Pierre_Miquelon": "8i,0,33,0,340,0,35,5,i3,0,147|8i,0,33,0,340,0,35,5,i3,0,eb,0,7f||",
                "Pitcairn": "aos,5,140,0,7f|||",
                "Ponape": "aor,5,1r6,0,7f|||",
                "Pyongyang": "aoq,0,7f|||",
                "Qyzylorda": "5d3,0,147|5d3,0,eb,0,7f||",
                "Reunion": "aop,0,7f|||",
                "Rothera": "aoo,0,7f|||",
                "Sakhalin": "5d6,0,eu,0,7f|5d6,0,eb,0,7f||",
                "Samara": "5d7,0,147|5d7,0,eb,0,7f||",
                "Samoa": "5d8,0,eu,0,7f|5d8,0,eb,0,7f||",
                "Seychelles": "aon,5,140,0,7f|||",
                "Singapore": "aom,0,eu,0,7f|||",
                "Solomon": "aol,5,140,0,7f|||",
                "South_Georgia": "5at,5,aok,0,7f|||",
                "Suriname": "aoj,0,7f|||",
                "Syowa": "aoi,0,7f|||",
                "Tahiti": "aoh,0,7f|||",
                "Taipei": "5dg,0,eu,0,7f|5dg,0,eb,0,7f||",
                "Tajikistan": "aog,0,7f|||",
                "Tokelau": "aku,0,7f|||",
                "Tonga": "5dj,0,eu,0,7f|5dj,0,eb,0,7f||",
                "Truk": "ak9,0,7f|||",
                "Turkmenistan": "5dl,0,eu,0,7f|5dl,0,eb,0,7f||",
                "Tuvalu": "ago,0,7f|||",
                "Uruguay": "5dn,0,eu,0,7f|5dn,0,eb,0,7f||",
                "Uzbekistan": "5do,0,eu,0,7f|5do,0,eb,0,7f||",
                "Vanuatu": "5dp,0,eu,0,7f|5dp,0,eb,0,7f||",
                "Venezuela": "agn,0,7f|||",
                "Vladivostok": "5dr,0,eu,0,7f|5dr,0,eb,0,7f||",
                "Volgograd": "5ds,0,eu,0,7f|5ds,0,eb,0,7f||",
                "Vostok": "agi,0,7f|||",
                "Wake": "agh,5,1r6,0,7f|||",
                "Wallis": "5f,0,340,0,5k,5,i3,0,7f|||",
                "Yakutsk": "agf,0,eu,0,7f|age,0,eb,0,7f||",
                "Yekaterinburg": "agd,0,eu,0,7f|agb,0,eb,0,7f||"
            }
        },
        "hy": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cb7,0,ge,0,7j||",
                "Europe/London": "|cb8,0,gk,0,7j||"
            },
            "metazone": {
                "Afghanistan": "ag9,0,7j|||",
                "Africa_Central": "1nr,0,2vq,0,7j|||",
                "Africa_Eastern": "1gk,0,2vq,0,7j|||",
                "Africa_Southern": "5e8,0,2vq,0,7j|||",
                "Africa_Western": "1fu,0,2vq,0,ge,0,7j|1fu,0,2vq,0,gk,0,7j||",
                "Alaska": "5ec,0,ge,0,7j|5ec,0,gk,0,7j||",
                "Amazon": "5ed,0,ge,0,7j|5ed,0,gk,0,7j||",
                "America_Central": "1nr,0,352,0,ge,0,7j|1nr,0,352,0,gk,0,7j||",
                "America_Eastern": "1gk,0,352,0,ge,0,7j|1gk,0,352,0,gk,0,7j||",
                "America_Mountain": "5ef,0,ge,0,7j,0,5eg|5ef,0,gk,0,7j,0,5eg||",
                "America_Pacific": "5eh,0,ge,0,7j|5eh,0,gk,0,7j||",
                "Apia": "5ei,0,ge,0,7j|5ei,0,gk,0,7j||",
                "Arabian": "5ej,0,5ek,0,ge,0,7j|5ej,0,5ek,0,gk,0,7j||",
                "Argentina": "353,0,5em,0,7j|353,0,gk,0,7j||",
                "Argentina_Western": "1fu,0,353,0,5em,0,7j|1fu,0,353,0,gk,0,7j||",
                "Armenia": "5en,0,ge,0,7j|5en,0,gk,0,7j||",
                "Atlantic": "5eo,0,ge,0,7j|5eo,0,gk,0,7j||",
                "Australia_Central": "1nr,0,1rm,0,ge,0,7j|1nr,0,1rm,0,gk,0,7j||",
                "Australia_CentralWestern": "1nr,0,1rm,0,5eq,0,ge,0,7j|1nr,0,1rm,0,5eq,0,gk,0,7j||",
                "Australia_Eastern": "1gk,0,1rm,0,ge,0,7j|1gk,0,1rm,0,gk,0,7j||",
                "Australia_Western": "1fu,0,1rm,0,ge,0,7j|1fu,0,1rm,0,gk,0,7j||",
                "Azerbaijan": "5er,0,ge,0,7j|5er,0,gk,0,7j||",
                "Azores": "5es,0,16r,0,ge,0,7j|5es,0,16r,0,gk,0,7j||",
                "Bangladesh": "5eu,0,ge,0,7j|5eu,0,gk,0,7j||",
                "Bhutan": "ag5,0,7j|||",
                "Bolivia": "afu,0,7j|||",
                "Brasilia": "5f1,0,ge,0,7j|5f1,0,gk,0,7j||",
                "Brunei": "aft,0,7j|||",
                "Cape_Verde": "5f3,0,5f4,0,ge,0,7j|5f3,0,5f4,0,gk,0,7j||",
                "Chamorro": "afs,0,7j|||",
                "Chatham": "5f6,0,1pk,0,ge,0,7j|5f6,0,1pk,0,gk,0,7j||",
                "Chile": "5f8,0,ge,0,7j|5f8,0,gk,0,7j||",
                "China": "5f9,0,ge,0,7j|5f9,0,gk,0,7j||",
                "Choibalsan": "5fa,0,ge,0,7j|5fa,0,gk,0,7j||",
                "Christmas": "afp,0,afk,0,1pk,0,7j|||",
                "Cocos": "afi,0,16r,0,7j|||",
                "Colombia": "5fe,0,ge,0,7j|5fe,0,gk,0,7j||",
                "Cook": "5ff,0,16r,0,ge,0,7j|5ff,0,16r,0,afg,0,7j||",
                "Cuba": "5fh,0,ge,0,7j|5fh,0,gk,0,7j||",
                "Davis": "aff,0,7j|||",
                "DumontDUrville": "afe,0,af8,0,7j|||",
                "East_Timor": "1gk,0,af3,0,7j|||",
                "Easter": "5fm,0,1pk,0,ge,0,7j|5fm,0,1pk,0,gk,0,7j||",
                "Ecuador": "af2,0,7j|||",
                "Europe_Central": "1nr,0,2jd,0,ge,0,7j|1nr,0,2jd,0,gk,0,7j||",
                "Europe_Eastern": "1gk,0,2jd,0,ge,0,7j|1gk,0,2jd,0,gk,0,7j||",
                "Europe_Further_Eastern": "af1,0,7j|||",
                "Europe_Western": "1fu,0,2jd,0,ge,0,7j|1fu,0,2jd,0,gk,0,7j||",
                "Falkland": "5fq,0,16r,0,ge,0,7j|5fq,0,16r,0,gk,0,7j||",
                "Fiji": "5fr,0,ge,0,7j|5fr,0,gk,0,7j||",
                "French_Guiana": "5fs,0,aeu,0,7j|||",
                "French_Southern": "5fs,0,aet,0,358,0,aes,0,7j|||",
                "Galapagos": "aer,0,16r,0,7j|||",
                "Gambier": "aeq,0,16r,0,7j|||",
                "Georgia": "5g3,0,ge,0,7j|5g3,0,gk,0,7j||",
                "Gilbert_Islands": "aem,0,16r,0,7j|||",
                "GMT": "ael,0,7j|||",
                "Greenland_Eastern": "1gk,0,35a,0,ge,0,7j|1gk,0,35a,0,gk,0,7j||",
                "Greenland_Western": "1fu,0,35a,0,ge,0,7j|1fu,0,35a,0,gk,0,7j||",
                "Gulf": "aek,0,aej,0,ge,0,7j|||",
                "Guyana": "aei,0,7j|||",
                "Hawaii_Aleutian": "5ga,5,5gb,0,ge,0,7j|5ga,5,5gb,0,gk,0,7j||",
                "Hong_Kong": "5gc,0,ge,0,7j|5gc,0,gk,0,7j||",
                "Hovd": "5gd,0,ge,0,7j|5gd,0,gk,0,7j||",
                "India": "aeh,0,ge,0,7j|||",
                "Indian_Ocean": "aef,0,aea,0,7j|||",
                "Indochina": "ae8,0,7j|||",
                "Indonesia_Central": "1nr,0,4ro,0,7j|||",
                "Indonesia_Eastern": "1gk,0,4ro,0,7j|||",
                "Indonesia_Western": "1fu,0,4ro,0,7j|||",
                "Iran": "5gj,0,ge,0,7j|5gj,0,gk,0,7j||",
                "Irkutsk": "5gk,0,ge,0,7j|5gk,0,gk,0,7j||",
                "Israel": "5gl,0,ge,0,7j|5gl,0,gk,0,7j||",
                "Japan": "5gm,0,ge,0,7j|5gm,0,gk,0,7j||",
                "Kazakhstan_Eastern": "1gk,0,5gn,0,7j|||",
                "Kazakhstan_Western": "1fu,0,5gn,0,7j|||",
                "Korea": "5go,0,ge,0,7j|5go,0,gk,0,7j||",
                "Kosrae": "ae7,0,7j|||",
                "Krasnoyarsk": "5gq,0,ge,0,7j|5gq,0,gk,0,7j||",
                "Kyrgystan": "ae6,0,7j|||",
                "Line_Islands": "ae2,0,16r,0,7j|||",
                "Lord_Howe": "5gt,0,5gu,0,ge,0,7j|5gt,0,5gu,0,gk,0,7j||",
                "Macquarie": "ae0,0,1pk,0,7j|||",
                "Magadan": "5h0,0,ge,0,7j|5h0,0,gk,0,7j||",
                "Malaysia": "adt,0,7j|||",
                "Maldives": "ads,0,7j|||",
                "Marquesas": "adr,0,16r,0,7j|||",
                "Marshall_Islands": "adq,0,16r,0,7j|||",
                "Mauritius": "5h5,0,ge,0,7j|5h5,0,gk,0,7j||",
                "Mawson": "adp,0,7j|||",
                "Mexico_Northwest": "5h7,0,35c,0,ge,0,7j|5h7,0,35c,0,gk,0,7j||",
                "Mexico_Pacific": "35c,0,5h9,0,ge,0,7j|35c,0,5h9,0,gk,0,7j||",
                "Mongolia": "5ha,0,5hb,0,ge,0,7j|5ha,0,5hb,0,gk,0,7j||",
                "Moscow": "5hc,0,ge,0,7j|5hc,0,gk,0,7j||",
                "Myanmar": "ado,0,7j|||",
                "Nauru": "adn,0,7j|||",
                "Nepal": "adh,0,7j|||",
                "New_Caledonia": "2v8,0,5hh,0,ge,0,7j|2v8,0,5hh,0,gk,0,7j||",
                "New_Zealand": "2v8,0,5hi,0,ge,0,7j|2v8,0,5hi,0,gk,0,7j||",
                "Newfoundland": "5hj,0,ge,0,7j|5hj,0,gk,0,7j||",
                "Niue": "adg,0,7j|||",
                "Norfolk": "adf,0,1pk,0,7j|||",
                "Noronha": "5hm,0,5hn,0,5ho,0,ge,0,7j|5hm,0,5hn,0,5ho,0,gk,0,7j||",
                "Novosibirsk": "5hp,0,ge,0,7j|5hp,0,gk,0,7j||",
                "Omsk": "5hq,0,ge,0,7j|5hq,0,gk,0,7j||",
                "Pakistan": "5hr,0,ge,0,7j|5hr,0,gk,0,7j||",
                "Palau": "ade,0,7j|||",
                "Papua_New_Guinea": "adb,0,2v8,0,ad7,0,7j|||",
                "Paraguay": "5hv,0,ge,0,7j|5hv,0,gk,0,7j||",
                "Peru": "5i0,0,ge,0,7j|5i0,0,gk,0,7j||",
                "Philippines": "5i1,0,ge,0,7j|5i1,0,gk,0,7j||",
                "Phoenix_Islands": "ad3,0,16r,0,7j|||",
                "Pierre_Miquelon": "5i3,0,5i4,0,358,0,5i5,0,ge,0,7j|5i3,0,5i4,0,358,0,5i5,0,gk,0,7j||",
                "Pitcairn": "ad2,0,7j|||",
                "Ponape": "ad1,0,1pk,0,7j|||",
                "Pyongyang": "ad0,0,7j|||",
                "Reunion": "acv,0,7j|||",
                "Rothera": "act,0,7j|||",
                "Sakhalin": "5ib,0,ge,0,7j|5ib,0,gk,0,7j||",
                "Samoa": "5ic,0,ge,0,7j|5ic,0,gk,0,7j||",
                "Seychelles": "acr,0,16r,0,7j|||",
                "Singapore": "acm,0,7j|||",
                "Solomon": "ack,0,16r,0,7j|||",
                "South_Georgia": "5e8,0,acj,0,7j|||",
                "Suriname": "aci,0,7j|||",
                "Syowa": "acg,0,7j|||",
                "Tahiti": "ace,0,7j|||",
                "Taipei": "5ik,0,ge,0,7j|5ik,0,gk,0,7j||",
                "Tajikistan": "acd,0,7j|||",
                "Tokelau": "acc,0,7j|||",
                "Tonga": "5in,0,ge,0,7j|5in,0,gk,0,7j||",
                "Truk": "acb,0,7j|||",
                "Turkmenistan": "5ip,0,ge,0,7j|5ip,0,gk,0,7j||",
                "Tuvalu": "ac9,0,7j|||",
                "Uruguay": "5ir,0,ge,0,7j|5ir,0,gk,0,7j||",
                "Uzbekistan": "5is,0,ge,0,7j|5is,0,gk,0,7j||",
                "Vanuatu": "5it,0,ge,0,7j|5it,0,gk,0,7j||",
                "Venezuela": "ac8,0,7j|||",
                "Vladivostok": "5iv,0,ge,0,7j|5iv,0,gk,0,7j||",
                "Volgograd": "5j0,0,ge,0,7j|5j0,0,gk,0,7j||",
                "Vostok": "ac5,0,7j|||",
                "Wake": "ac2,0,1pk,0,7j|||",
                "Wallis": "ac1,0,358,0,ac0,0,7j|||",
                "Yakutsk": "5j5,0,ge,0,7j|5j5,0,gk,0,7j||",
                "Yekaterinburg": "5j6,0,ge,0,7j|5j6,0,gk,0,7j||"
            }
        },
        "id": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|u,0,e6,0,66f||",
                "Europe/London": "|u,0,5i,0,5h,0,cba||"
            },
            "metazone": {
                "Acre": "u,0,e6,0,3q|u,0,5i,0,5h,0,3q||",
                "Afghanistan": "u,0,2f0|||",
                "Africa_Central": "u,0,c5,0,pl|||",
                "Africa_Eastern": "u,0,c5,0,mt|||",
                "Africa_Southern": "u,0,e6,0,c5,0,1jj|||",
                "Africa_Western": "u,0,e6,0,c5,0,ht|u,0,5i,0,5h,0,c5,0,ht||",
                "Alaska": "u,0,e6,0,3p|u,0,5i,0,5h,0,3p||",
                "Almaty": "u,0,e6,0,56|u,0,5i,0,5h,0,56||",
                "Amazon": "u,0,e6,0,5m|u,0,5i,0,5h,0,5m||",
                "America_Central": "u,0,e6,0,pl|u,0,5i,0,5h,0,pl||",
                "America_Eastern": "u,0,e6,0,mt|u,0,5i,0,5h,0,mt||",
                "America_Mountain": "u,0,e6,0,5jf|u,0,5i,0,5h,0,5jf||",
                "America_Pacific": "u,0,e6,0,10c|u,0,5i,0,5h,0,10c||",
                "Anadyr": "u,0,e6,0,3l|u,0,5i,0,5h,0,3l||",
                "Apia": "u,0,e6,0,3e|u,0,5i,0,5h,0,3e||",
                "Aqtau": "u,0,e6,0,50|u,0,5i,0,5h,0,50||",
                "Aqtobe": "u,0,e6,0,5o|u,0,5i,0,5h,0,5o||",
                "Arabian": "u,0,e6,0,1qe|u,0,5i,0,5h,0,1qe||",
                "Argentina": "u,0,e6,0,1e|u,0,5i,0,5h,0,1e||",
                "Argentina_Western": "u,0,e6,0,1e,0,5jg,0,ht|u,0,5i,0,5h,0,1e,0,5jg,0,ht||",
                "Armenia": "u,0,e6,0,4l|u,0,5i,0,5h,0,4l||",
                "Atlantic": "u,0,e6,0,r2|u,0,5i,0,5h,0,r2||",
                "Australia_Central": "u,0,e6,0,pl,0,4c|u,0,5i,0,5h,0,pl,0,4c||",
                "Australia_CentralWestern": "u,0,e6,0,ht,0,pl,0,4c|u,0,5i,0,5h,0,ht,0,pl,0,4c||",
                "Australia_Eastern": "u,0,e6,0,mt,0,4c|u,0,5i,0,5h,0,mt,0,4c||",
                "Australia_Western": "u,0,e6,0,ht,0,4c|u,0,5i,0,5h,0,ht,0,4c||",
                "Azerbaijan": "u,0,e6,0,7m|u,0,5i,0,5h,0,7m||",
                "Azores": "u,0,e6,0,4r|u,0,5i,0,5h,0,4r||",
                "Bangladesh": "u,0,e6,0,3n|u,0,5i,0,5h,0,3n||",
                "Bhutan": "u,0,as|||",
                "Bolivia": "u,0,aa|||",
                "Brasilia": "u,0,e6,0,5jh|u,0,5i,0,5h,0,5jh||",
                "Brunei": "u,0,9o,0,a4|||",
                "Cape_Verde": "u,0,e6,0,1rs,0,3j|u,0,5i,0,5h,0,1rs,0,3j||",
                "Casey": "u,0,b7|||",
                "Chamorro": "u,0,e6,0,6j|||",
                "Chatham": "u,0,e6,0,27|u,0,5i,0,5h,0,27||",
                "Chile": "u,0,e6,0,1rt|u,0,5i,0,5h,0,1rt||",
                "China": "u,0,e6,0,5jk|u,0,5i,0,5h,0,5jk||",
                "Choibalsan": "u,0,e6,0,2q|u,0,5i,0,5h,0,2q||",
                "Christmas": "u,0,15f,0,1jn|||",
                "Cocos": "u,0,oo,0,7v|||",
                "Colombia": "u,0,e6,0,20u|u,0,5i,0,5h,0,20u||",
                "Cook": "u,0,e6,0,2if,0,2v|u,0,pl,0,5i,0,5h,0,2if,0,2v||",
                "Cuba": "u,0,e6,0,tb|u,0,5i,0,5h,0,tb||",
                "Davis": "u,0,5s|||",
                "DumontDUrville": "u,0,5b,5,5j|||",
                "East_Timor": "u,0,7n,0,vk|||",
                "Easter": "u,0,e6,0,15f,0,5jp|u,0,5i,0,5h,0,15f,0,5jp||",
                "Ecuador": "u,0,abv|||",
                "Europe_Central": "u,0,e6,0,29r,0,pl|u,0,5i,0,5h,0,29r,0,pl||",
                "Europe_Eastern": "u,0,e6,0,29r,0,mt|u,0,5i,0,5h,0,29r,0,mt||",
                "Europe_Further_Eastern": "u,0,29r,0,mt,0,abu|||",
                "Europe_Western": "u,0,e6,0,29r,0,ht|u,0,5i,0,5h,0,29r,0,ht||",
                "Falkland": "u,0,e6,0,oo,0,4v|u,0,5i,0,5h,0,oo,0,4v||",
                "Fiji": "u,0,e6,0,4q|u,0,5i,0,5h,0,4q||",
                "French_Guiana": "u,0,7a,0,5jt|||",
                "French_Southern": "u,0,abt,0,1jj,0,17t,0,27v,0,5jt|||",
                "Galapagos": "u,0,ak|||",
                "Gambier": "u,0,6v|||",
                "Georgia": "u,0,e6,0,2u|u,0,5i,0,5h,0,2u||",
                "Gilbert_Islands": "u,0,2if,0,6q|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "u,0,e6,0,2k,0,mt|u,0,5i,0,5h,0,2k,0,mt||",
                "Greenland_Western": "u,0,e6,0,2k,0,ht|u,0,5i,0,5h,0,2k,0,ht||",
                "Guam": "u,0,83|||",
                "Gulf": "u,0,e6,0,367|||",
                "Guyana": "u,0,7a|||",
                "Hawaii_Aleutian": "u,0,e6,0,4g,5,62|u,0,5i,0,5h,0,4g,5,62||",
                "Hong_Kong": "u,0,e6,0,2l,0,2p|u,0,5i,0,5h,0,2l,0,2p||",
                "Hovd": "u,0,e6,0,2g|u,0,5i,0,5h,0,2g||",
                "India": "u,0,af|||",
                "Indian_Ocean": "u,0,abs,0,abq|||",
                "Indochina": "u,0,9p|||",
                "Indonesia_Central": "u,0,2t,0,pl||abp|",
                "Indonesia_Eastern": "u,0,2t,0,mt||abo|",
                "Indonesia_Western": "u,0,2t,0,ht||abn|",
                "Iran": "u,0,e6,0,5g|u,0,5i,0,5h,0,5g||",
                "Irkutsk": "u,0,e6,0,3h|u,0,5i,0,5h,0,3h||",
                "Israel": "u,0,e6,0,4e|u,0,5i,0,5h,0,4e||",
                "Japan": "u,0,e6,0,5k6|u,0,5i,0,5h,0,5k6||",
                "Kamchatka": "u,0,e6,0,37,5,4q6|u,0,5i,0,5h,0,37,5,3k||",
                "Kazakhstan_Eastern": "u,0,45,0,mt|||",
                "Kazakhstan_Western": "u,0,45,0,ht|||",
                "Korea": "u,0,e6,0,qf|u,0,5i,0,5h,0,qf||",
                "Kosrae": "u,0,6f|||",
                "Krasnoyarsk": "u,0,e6,0,41|u,0,5i,0,5h,0,41||",
                "Kyrgystan": "u,0,abm|||",
                "Lanka": "u,0,9c|||",
                "Line_Islands": "u,0,2if,0,ac|||",
                "Lord_Howe": "u,0,e6,0,1u,0,24|u,0,5i,0,5h,0,1u,0,24||",
                "Macau": "u,0,e6,0,36a|u,0,5i,0,5h,0,36a||",
                "Macquarie": "u,0,oo,0,6m|||",
                "Magadan": "u,0,e6,0,2o|u,0,5i,0,5h,0,2o||",
                "Malaysia": "u,0,bf|||",
                "Maldives": "u,0,abl|||",
                "Marquesas": "u,0,9e|||",
                "Marshall_Islands": "u,0,2if,0,7o|||",
                "Mauritius": "u,0,e6,0,4u|u,0,5i,0,5h,0,4u||",
                "Mawson": "u,0,63|||",
                "Mexico_Northwest": "u,0,e6,0,17k,0,ht,0,1se|u,0,5i,0,5h,0,17k,0,ht,0,1se||",
                "Mexico_Pacific": "u,0,e6,0,10c,0,17k|u,0,5i,0,5h,0,10c,0,17k||",
                "Mongolia": "u,0,e6,0,4f,0,2m|u,0,5i,0,5h,0,4f,0,2m||",
                "Moscow": "u,0,e6,0,36c|u,0,5i,0,5h,0,36c||",
                "Myanmar": "u,0,8v|||",
                "Nauru": "u,0,5v|||",
                "Nepal": "u,0,8u|||",
                "New_Caledonia": "u,0,e6,0,215,0,36d|u,0,5i,0,5h,0,215,0,36d||",
                "New_Zealand": "u,0,e6,0,5kd,0,36d|u,0,5i,0,5h,0,5kd,0,36d||",
                "Newfoundland": "u,0,e6,0,53|u,0,5i,0,5h,0,53||",
                "Niue": "u,0,8g|||",
                "Norfolk": "u,0,oo,0,6l|||",
                "Noronha": "u,0,e6,0,1s,0,2,0,23|u,0,5i,0,5h,0,1s,0,2,0,23||",
                "North_Mariana": "u,0,2if,0,bd,0,abk|||",
                "Novosibirsk": "u,0,e6,0,3b|u,0,5i,0,5h,0,3b||",
                "Omsk": "u,0,e6,0,26|u,0,5i,0,5h,0,26||",
                "Pakistan": "u,0,e6,0,3i|u,0,5i,0,5h,0,3i||",
                "Palau": "u,0,9b|||",
                "Papua_New_Guinea": "u,0,9a,0,abj|||",
                "Paraguay": "u,0,e6,0,3c|u,0,5i,0,5h,0,3c||",
                "Peru": "u,0,e6,0,4n|u,0,5i,0,5h,0,4n||",
                "Philippines": "u,0,e6,0,1sg|u,0,5i,0,5h,0,1sg||",
                "Phoenix_Islands": "u,0,oo,0,90|||",
                "Pierre_Miquelon": "u,0,e6,0,8i,0,33,0,17t,0,35|u,0,5i,0,5h,0,8i,0,33,0,17t,0,35||",
                "Pitcairn": "u,0,7e|||",
                "Ponape": "u,0,9s|||",
                "Pyongyang": "u,0,8a|||",
                "Qyzylorda": "u,0,e6,0,4d|u,0,5i,0,5h,0,4d||",
                "Reunion": "u,0,b4|||",
                "Rothera": "u,0,5q|||",
                "Sakhalin": "u,0,e6,0,55|u,0,5i,0,5h,0,55||",
                "Samara": "u,0,e6,0,29|u,0,5i,0,5h,0,29||",
                "Samoa": "u,0,e6,0,2c|u,0,5i,0,5h,0,2c||",
                "Seychelles": "u,0,8k|||",
                "Singapore": "u,0,e6,0,196|||",
                "Solomon": "u,0,oo,0,b5|||",
                "South_Georgia": "u,0,2u,0,1jj|||",
                "Suriname": "u,0,8q|||",
                "Syowa": "u,0,65|||",
                "Tahiti": "u,0,8n|||",
                "Taipei": "u,0,e6,0,3d|u,0,5i,0,5h,0,3d||",
                "Tajikistan": "u,0,bj|||",
                "Tokelau": "u,0,5d|||",
                "Tonga": "u,0,e6,0,2j|u,0,5i,0,5h,0,2j||",
                "Truk": "u,0,6p|||",
                "Turkmenistan": "u,0,e6,0,4t|u,0,5i,0,5h,0,4t||",
                "Tuvalu": "u,0,6h|||",
                "Uruguay": "u,0,e6,0,4k|u,0,5i,0,5h,0,4k||",
                "Uzbekistan": "u,0,e6,0,60|u,0,5i,0,5h,0,60||",
                "Vanuatu": "u,0,e6,0,2f|u,0,5i,0,5h,0,2f||",
                "Venezuela": "u,0,7s|||",
                "Vladivostok": "u,0,e6,0,28|u,0,5i,0,5h,0,28||",
                "Volgograd": "u,0,e6,0,3f|u,0,5i,0,5h,0,3f||",
                "Vostok": "u,0,5t|||",
                "Wake": "u,0,oo,0,5r|||",
                "Wallis": "u,0,5f,0,17t,0,5k|||",
                "Yakutsk": "u,0,e6,0,3u|u,0,5i,0,5h,0,3u||",
                "Yekaterinburg": "u,0,e6,0,5l|u,0,5i,0,5h,0,5l||"
            }
        },
        "ig": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ii": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "is": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|fr,0,is,0,cbb||",
                "Europe/London": "|fr,0,be,0,cbc||"
            },
            "metazone": {
                "Afghanistan": "abi|||",
                "Africa_Central": "25s,5,4rc|||",
                "Africa_Eastern": "1pn,5,4rc|||",
                "Africa_Southern": "5kl,5,4rc|||",
                "Africa_Western": "fo,0,be,0,11j,5,5ko|fr,0,be,0,11j,5,5ko||",
                "Alaska": "fo,0,be,0,3p|fr,0,be,0,3p||",
                "Amazon": "fo,0,is,0,5kr|fr,0,is,0,5kr||",
                "America_Central": "fo,0,be,0,5ks,0,36n,0,u0,0,36o|fr,0,be,0,5ks,0,36n,0,u0,0,36o||",
                "America_Eastern": "fo,0,be,0,5kv,0,36n,0,u0,0,36o|fr,0,be,0,5kv,0,36n,0,u0,0,36o||",
                "America_Mountain": "fo,0,be,0,5l0|fr,0,be,0,5l0||",
                "America_Pacific": "fo,0,is,0,36p|fr,0,is,0,36p||",
                "Anadyr": "fo,0,be,0,3l|fr,0,be,0,3l||",
                "Apia": "fo,0,be,0,5l2|fr,0,be,0,5l2||",
                "Arabian": "fo,0,be,0,5l3|fr,0,be,0,5l3||",
                "Argentina": "fo,0,be,0,36q|fr,0,be,0,36q||",
                "Argentina_Western": "fo,0,be,0,11j,5,36q|fr,0,be,0,11j,5,36q||",
                "Armenia": "fo,0,be,0,5l5|fr,0,be,0,5l5||",
                "Atlantic": "fo,0,is,0,5l6|fr,0,is,0,5l6||",
                "Australia_Central": "fo,0,be,0,25s,5,1sm|fr,0,be,0,25s,5,1sm||",
                "Australia_CentralWestern": "fo,0,be,0,5l8,0,1sm|fr,0,be,0,5l8,0,1sm||",
                "Australia_Eastern": "fo,0,be,0,1pn,5,1sm|fr,0,be,0,1pn,5,1sm||",
                "Australia_Western": "fo,0,be,0,11j,5,1sm|fr,0,be,0,11j,5,1sm||",
                "Azerbaijan": "fo,0,be,0,5l9|fr,0,be,0,5l9||",
                "Azores": "fo,0,is,0,5la|fr,0,is,0,5la||",
                "Bangladesh": "fo,0,be,0,5lb|fr,0,be,0,5lb||",
                "Bhutan": "abh|||",
                "Bolivia": "abg|||",
                "Brasilia": "fo,0,be,0,5le|fr,0,be,0,5le||",
                "Brunei": "abf|||",
                "Cape_Verde": "fo,0,is,0,5lg|fr,0,is,0,5lg||",
                "Chamorro": "6j,5,5lh|||",
                "Chatham": "fo,0,be,0,27|fr,0,be,0,27||",
                "Chile": "fo,0,be,0,5li|fr,0,be,0,5li||",
                "China": "fo,0,be,0,5lj|fr,0,be,0,5lj||",
                "Choibalsan": "fo,0,be,0,2q|fr,0,be,0,2q||",
                "Christmas": "abe|||",
                "Cocos": "abd|||",
                "Colombia": "fo,0,be,0,5lm|fr,0,be,0,5lm||",
                "Cook": "fo,0,is,0,5ln,5,36u|abc,0,is,0,5ln,5,36u||",
                "Cuba": "fo,0,is,0,5lq|fr,0,is,0,5lq||",
                "Davis": "5s,5,13c|||",
                "DumontDUrville": "1ha,0,is,0,5b,5,5j|||",
                "East_Timor": "abb,0,is,0,aba,5,vk|||",
                "Easter": "fo,0,is,0,5lv|fr,0,is,0,5lv||",
                "Ecuador": "ab9|||",
                "Europe_Central": "fo,0,be,0,25s,5,2h5|fr,0,be,0,25s,5,2h5||",
                "Europe_Eastern": "fo,0,be,0,1pn,5,2h5|fr,0,be,0,1pn,5,2h5||",
                "Europe_Further_Eastern": "ab8,0,ab6|||",
                "Europe_Western": "fo,0,be,0,11j,5,2h5|fr,0,be,0,11j,5,2h5||",
                "Falkland": "fo,0,is,0,5m4|fr,0,is,0,5m4||",
                "Fiji": "fo,0,is,0,5m5|fr,0,is,0,5m5||",
                "French_Guiana": "1ha,0,be,0,ab5,0,ab4|||",
                "French_Southern": "1ha,0,is,0,ab3,0,ab2,0,u0,0,ab1|||",
                "Galapagos": "ak,5,13c|||",
                "Gambier": "6v,5,13c|||",
                "Georgia": "fo,0,be,0,5mb|fr,0,be,0,5mb||",
                "Gilbert_Islands": "1ha,0,is,0,6q,5,36u|||",
                "GMT": "5u,5,5lh|||",
                "Greenland_Eastern": "fo,0,is,0,1pn,5,37c|fr,0,is,0,1pn,5,37c||",
                "Greenland_Western": "fo,0,is,0,11j,5,37c|fr,0,is,0,11j,5,37c||",
                "Gulf": "fo,0,ab0,0,aav|||",
                "Guyana": "aau|||",
                "Hawaii_Aleutian": "fo,0,is,0,37g,0,u0,0,5mh|fr,0,is,0,37g,0,u0,0,5mh||",
                "Hong_Kong": "fo,0,be,0,2l,0,2p|fr,0,be,0,2l,0,2p||",
                "Hovd": "fo,0,be,0,2g|fr,0,be,0,2g||",
                "India": "aat|||",
                "Indian_Ocean": "aas|||",
                "Indochina": "aar|||",
                "Indonesia_Central": "25s,5,4r8|||",
                "Indonesia_Eastern": "1pn,5,4r8|||",
                "Indonesia_Western": "11j,5,4r8|||",
                "Iran": "fo,0,be,0,5mm|fr,0,be,0,5mm||",
                "Irkutsk": "fo,0,be,0,3h|fr,0,be,0,3h||",
                "Israel": "fo,0,be,0,2fv|fr,0,be,0,2fv||",
                "Japan": "fo,0,be,0,6o|fr,0,be,0,6o||",
                "Kamchatka": "fo,0,be,0,37,5,3k|fr,0,be,0,37,5,3k||",
                "Kazakhstan_Eastern": "1ha,0,be,0,1pn,5,2g1|||",
                "Kazakhstan_Western": "1ha,0,be,0,11j,5,2g1|||",
                "Korea": "fo,0,be,0,5mn|fr,0,be,0,5mn||",
                "Kosrae": "6f,5,13c|||",
                "Krasnoyarsk": "fo,0,be,0,41|fr,0,be,0,41||",
                "Kyrgystan": "1qu,5,13c|||",
                "Line_Islands": "aaq,5,13c|||",
                "Lord_Howe": "fo,0,is,0,1u,0,24,5,37m|fr,0,is,0,1u,0,24,5,37m||",
                "Macquarie": "6m,5,aap|||",
                "Magadan": "fo,0,be,0,2o|fr,0,be,0,2o||",
                "Malaysia": "aao|||",
                "Maldives": "aan,5,13c|||",
                "Marquesas": "1ha,0,is,0,aam|||",
                "Marshall_Islands": "1ha,0,is,0,7o,5,36u|||",
                "Mauritius": "fo,0,is,0,5mu|fr,0,is,0,5mu||",
                "Mawson": "63,5,13c|||",
                "Mexico_Northwest": "fo,0,be,0,5mv,5,37r|fr,0,be,0,5mv,5,37r||",
                "Mexico_Pacific": "fo,0,be,0,37r,0,is,0,36p|fr,0,be,0,37r,0,is,0,36p||",
                "Mongolia": "fo,0,be,0,5n1,0,2m|fr,0,be,0,5n1,0,2m||",
                "Moscow": "fo,0,be,0,5n2|fr,0,be,0,5n2||",
                "Myanmar": "aal,5,13c|||",
                "Nauru": "7c6,5,13c|||",
                "Nepal": "aak|||",
                "New_Caledonia": "fo,0,be,0,4r7,5,5n6|fr,0,be,0,4r7,5,5n6||",
                "New_Zealand": "fo,0,is,0,5n7,5,5n8|fr,0,is,0,5n7,5,5n8||",
                "Newfoundland": "fo,0,is,0,5n9|fr,0,is,0,5n9||",
                "Niue": "8g,5,13c|||",
                "Norfolk": "1ha,0,is,0,6l,5,37m|||",
                "Noronha": "fo,0,be,0,1s,0,2,0,23|fr,0,be,0,1s,0,2,0,23||",
                "Novosibirsk": "fo,0,be,0,3b|fr,0,be,0,3b||",
                "Omsk": "fo,0,be,0,26|fr,0,be,0,26||",
                "Pakistan": "fo,0,be,0,3i|fr,0,be,0,3i||",
                "Palau": "aaj|||",
                "Papua_New_Guinea": "1ha,0,is,0,re,0,4r7,5,aai|||",
                "Paraguay": "fo,0,be,0,5nc|fr,0,be,0,5nc||",
                "Peru": "fo,0,be,0,ha|fr,0,be,0,ha||",
                "Philippines": "fo,0,is,0,5nd|fr,0,is,0,5nd||",
                "Phoenix_Islands": "aah|||",
                "Pierre_Miquelon": "fo,0,is,0,5nf,0,33,0,u0,0,35|fr,0,is,0,5nf,0,33,0,u0,0,35||",
                "Pitcairn": "7e,5,13c|||",
                "Ponape": "9s,5,13c|||",
                "Reunion": "i8,5,13c|||",
                "Rothera": "5q,5,13c|||",
                "Sakhalin": "fo,0,be,0,55|fr,0,be,0,55||",
                "Samara": "fo,0,be,0,29|fr,0,be,0,29||",
                "Samoa": "fo,0,is,0,5ng|fr,0,is,0,5ng||",
                "Seychelles": "8k,5,aag|||",
                "Singapore": "aaf|||",
                "Solomon": "aae|||",
                "South_Georgia": "5kl,5,aad|||",
                "Suriname": "aac|||",
                "Syowa": "65,5,13c|||",
                "Tahiti": "aab,5,13c|||",
                "Taipei": "fo,0,be,0,3d|fr,0,be,0,3d||",
                "Tajikistan": "aaa,5,13c|||",
                "Tokelau": "aa9,5,13c|||",
                "Tonga": "fo,0,is,0,2j|fr,0,is,0,2j||",
                "Truk": "6p,5,13c|||",
                "Turkmenistan": "fo,0,be,0,5np|fr,0,be,0,5np||",
                "Tuvalu": "aa8|||",
                "Uruguay": "fo,0,be,0,5nr|fr,0,be,0,5nr||",
                "Uzbekistan": "fo,0,be,0,5ns|fr,0,be,0,5ns||",
                "Vanuatu": "fo,0,is,0,5nt|fr,0,is,0,5nt||",
                "Venezuela": "aa7|||",
                "Vladivostok": "fo,0,be,0,28|fr,0,be,0,28||",
                "Volgograd": "fo,0,be,0,3f|fr,0,be,0,3f||",
                "Vostok": "5t,5,13c|||",
                "Wake": "1ha,0,is,0,5r,5,37m|||",
                "Wallis": "1ha,0,is,0,5f,5,0,u0,0,aa6|||",
                "Yakutsk": "fo,0,be,0,3u|fr,0,be,0,3u||",
                "Yekaterinburg": "fo,0,be,0,aa5|fr,0,be,0,5l||"
            }
        },
        "it-CH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|i,0,61,0,4nj||",
                "Europe/London": "|i,0,61,0,19,0,4nk,0,4nl||"
            },
            "metazone": {
                "Afghanistan": "i,0,4r2|||",
                "Africa_Central": "i,0,19s,0,9r|||",
                "Africa_Eastern": "i,0,19s,0,op|||",
                "Africa_Southern": "i,0,19s,0,4r1|||",
                "Africa_Western": "i,0,38,0,19s,0,nd|i,0,61,0,19s,0,nd||",
                "Alaska": "i,0,38,0,2fr|i,0,61,0,2fr||",
                "Amazon": "i,0,38,0,2fq|i,0,61,0,2fq||",
                "America_Central": "i,0,38,0,9r,0,10r|i,0,61,0,9r,0,10r||",
                "America_Eastern": "i,0,38,0,op,0,10r|i,0,61,0,op,0,10r||",
                "America_Mountain": "i,0,38,0,2fo,0,2fn,0,10r|i,0,61,0,2fo,0,2fn,0,10r||",
                "America_Pacific": "i,0,38,0,19,0,1gl,0,10r|i,0,61,0,19,0,1gl,0,10r||",
                "Anadyr": "i,0,38,0,4i,0,3l|i,0,61,0,4i,0,3l||",
                "Apia": "i,0,38,0,4i,0,3e|i,0,61,0,4i,0,3e||",
                "Arabian": "i,0,38,0,2fl|i,0,61,0,2fl||",
                "Argentina": "i,0,38,0,1gt|i,0,61,0,1gt||",
                "Argentina_Western": "i,0,38,0,1gt,0,nd|i,0,61,0,1gt,0,nd||",
                "Armenia": "i,0,38,0,2ff|i,0,61,0,2ff||",
                "Atlantic": "i,0,38,0,2fe|i,0,61,0,2fe||",
                "Australia_Central": "i,0,38,0,112,0,9r|i,0,61,0,112,0,9r||",
                "Australia_CentralWestern": "i,0,38,0,112,0,2eu|i,0,61,0,112,0,2eu||",
                "Australia_Eastern": "i,0,38,0,112,0,op|i,0,61,0,112,0,op||",
                "Australia_Western": "i,0,38,0,112,0,nd|i,0,61,0,112,0,nd||",
                "Azerbaijan": "i,0,38,0,2et|i,0,61,0,2et||",
                "Azores": "i,0,38,0,em,0,2er|i,0,61,0,em,0,2er||",
                "Bangladesh": "i,0,38,0,19,0,3n|i,0,61,0,19,0,3n||",
                "Bhutan": "i,0,19,0,as|||",
                "Bolivia": "i,0,ho,0,aa|||",
                "Brasilia": "i,0,38,0,4i,0,3a|i,0,61,0,4i,0,3a||",
                "Brunei": "i,0,19,0,9o,0,a4|||",
                "Cape_Verde": "i,0,38,0,4i,0,2em,0,3j|i,0,61,0,4i,0,2em,0,3j||",
                "Chamorro": "i,0,4i,0,6j|||",
                "Chatham": "i,0,38,0,em,0,27|i,0,61,0,em,0,27||",
                "Chile": "i,0,38,0,19,0,1rt|i,0,61,0,19,0,1rt||",
                "China": "i,0,38,0,ho,0,2el|i,0,61,0,ho,0,2el||",
                "Choibalsan": "i,0,38,0,4i,0,2q|i,0,61,0,4i,0,2q||",
                "Christmas": "i,0,194,0,99|||",
                "Cocos": "i,0,em,0,vl,0,7v|||",
                "Colombia": "i,0,38,0,ho,0,4m|i,0,61,0,ho,0,4m||",
                "Cook": "i,0,38,0,em,0,1q8,0,2v|i,0,61,0,r1,0,em,0,1q8,0,2v||",
                "Cuba": "i,0,38,0,4i,0,34|i,0,61,0,4i,0,34||",
                "Davis": "i,0,4i,0,5s|||",
                "DumontDUrville": "i,0,4i,0,5b,5,5j|||",
                "East_Timor": "i,0,4i,0,7n,0,195|||",
                "Easter": "i,0,38,0,194,0,4i,0,181|i,0,61,0,194,0,4i,0,181||",
                "Ecuador": "i,0,4qi|||",
                "Europe_Central": "i,0,38,0,13g,0,9r|i,0,61,0,13g,0,9r|h0|h4",
                "Europe_Eastern": "i,0,38,0,13g,0,op|i,0,61,0,13g,0,op|gu|gv",
                "Europe_Further_Eastern": "i,0,13g,0,op,0,4qh|||",
                "Europe_Western": "i,0,38,0,13g,0,nd|i,0,61,0,13g,0,nd|h1|h2",
                "Falkland": "i,0,38,0,em,0,vl,0,4v|i,0,61,0,em,0,vl,0,4v||",
                "Fiji": "i,0,38,0,em,0,2du|i,0,61,0,em,0,2du||",
                "French_Guiana": "i,0,ho,0,am,0,4qg|||",
                "French_Southern": "i,0,em,0,co,0,4qe,0,15,0,4qd,0,4qc|||",
                "Galapagos": "i,0,em,0,ak|||",
                "Gambier": "i,0,4i,0,6v|||",
                "Georgia": "i,0,38,0,ho,0,2u|i,0,61,0,ho,0,2u||",
                "Gilbert_Islands": "i,0,em,0,1q8,0,6q|||",
                "GMT": "i,0,19,0,rc,0,4i,0,5u|||",
                "Greenland_Eastern": "i,0,38,0,ho,0,b2,0,op|i,0,61,0,ho,0,b2,0,op||",
                "Greenland_Western": "i,0,38,0,ho,0,b2,0,nd|i,0,61,0,ho,0,b2,0,nd||",
                "Gulf": "i,0,19,0,oh|||",
                "Guyana": "i,0,ho,0,7a|||",
                "Hawaii_Aleutian": "i,0,38,0,em,0,vl,0,4g,5,1ml|i,0,61,0,em,0,vl,0,4g,5,1ml||",
                "Hong_Kong": "i,0,38,0,4i,0,2l,0,2p|i,0,61,0,4i,0,2l,0,2p||",
                "Hovd": "i,0,38,0,4i,0,2g|i,0,61,0,4i,0,2g||",
                "India": "i,0,38,0,4qb|||",
                "Indian_Ocean": "i,0,4qa,0,4q9|||",
                "Indochina": "i,0,4q7|||",
                "Indonesia_Central": "i,0,1qa,0,9r|||",
                "Indonesia_Eastern": "i,0,1qa,0,op|||",
                "Indonesia_Western": "i,0,1qa,0,nd|||",
                "Iran": "i,0,38,0,2dn|i,0,61,0,2dn||",
                "Irkutsk": "i,0,38,0,4i,0,3h|i,0,61,0,4i,0,3h||",
                "Israel": "i,0,38,0,4i,0,2dm|i,0,61,0,4i,0,2dm||",
                "Japan": "i,0,38,0,19,0,2dl|i,0,61,0,19,0,2dl||",
                "Kamchatka": "i,0,38,0,4i,0,37,5,3k|i,0,61,0,4i,0,37,5,3k||",
                "Kazakhstan_Eastern": "i,0,19,0,1mt,0,op|||",
                "Kazakhstan_Western": "i,0,19,0,1mt,0,nd|||",
                "Korea": "i,0,38,0,2dj|i,0,61,0,2dj||",
                "Kosrae": "i,0,19,0,6f|||",
                "Krasnoyarsk": "i,0,38,0,4i,0,41|i,0,61,0,4i,0,41||",
                "Kyrgystan": "i,0,19,0,mm|||",
                "Line_Islands": "i,0,em,0,4q2,0,4q1|||",
                "Lord_Howe": "i,0,38,0,4i,0,1u,0,24|i,0,61,0,4i,0,1u,0,24||",
                "Macquarie": "i,0,194,0,6m|||",
                "Magadan": "i,0,38,0,4i,0,2o|i,0,61,0,4i,0,2o||",
                "Malaysia": "i,0,ho,0,4q0|||",
                "Maldives": "i,0,em,0,2ot|||",
                "Marquesas": "i,0,em,0,4pu|||",
                "Marshall_Islands": "i,0,em,0,vl,0,7o|||",
                "Mauritius": "i,0,38,0,em,0,4u|i,0,61,0,em,0,4u||",
                "Mawson": "i,0,4i,0,63|||",
                "Mexico_Northwest": "i,0,38,0,19,0,2dc,0,93,5,nd|i,0,61,0,19,0,2dc,0,93,5,nd||",
                "Mexico_Pacific": "i,0,38,0,19,0,1gl,0,2db|i,0,61,0,19,0,1gl,0,2db||",
                "Mongolia": "i,0,38,0,4i,0,4f,0,2m|i,0,61,0,4i,0,4f,0,2m||",
                "Moscow": "i,0,38,0,4i,0,2cu|i,0,61,0,4i,0,2cu||",
                "Myanmar": "i,0,ho,0,ra|||",
                "Nauru": "i,0,4i,0,5v|||",
                "Nepal": "i,0,19,0,8u|||",
                "New_Caledonia": "i,0,38,0,ho,0,197,0,4o|i,0,61,0,ho,0,197,0,4o||",
                "New_Zealand": "i,0,38,0,ho,0,197,0,go|i,0,61,0,ho,0,197,0,go||",
                "Newfoundland": "i,0,38,0,4i,0,h5|i,0,61,0,4i,0,h5||",
                "Niue": "i,0,4i,0,8g|||",
                "Norfolk": "i,0,em,0,vl,0,6l|||",
                "Noronha": "i,0,38,0,4i,0,1s,0,2,0,23|i,0,61,0,4i,0,1s,0,2,0,23||",
                "Novosibirsk": "i,0,38,0,4i,0,3b|i,0,61,0,4i,0,3b||",
                "Omsk": "i,0,38,0,4i,0,26|i,0,61,0,4i,0,26||",
                "Pakistan": "i,0,38,0,19,0,3i|i,0,61,0,19,0,3i||",
                "Palau": "i,0,4i,0,9b|||",
                "Papua_New_Guinea": "i,0,ho,0,9a,0,197,0,a8|||",
                "Paraguay": "i,0,38,0,19,0,3c|i,0,61,0,19,0,3c||",
                "Peru": "i,0,38,0,19,0,2cp|i,0,61,0,19,0,2cp||",
                "Philippines": "i,0,38,0,em,0,2co|i,0,61,0,em,0,2co||",
                "Phoenix_Islands": "i,0,em,0,vl,0,ho,0,4pr|||",
                "Pierre_Miquelon": "i,0,38,0,4i,0,8i,5,33,0,15,0,35|i,0,61,0,4i,0,8i,5,33,0,15,0,35||",
                "Pitcairn": "i,0,em,0,7e|||",
                "Ponape": "i,0,4i,0,e5|||",
                "Pyongyang": "i,0,4i,0,8a|||",
                "Reunion": "i,0,4i,0,4pq|||",
                "Rothera": "i,0,4i,0,5q|||",
                "Sakhalin": "i,0,38,0,4i,0,55|i,0,61,0,4i,0,55||",
                "Samara": "i,0,38,0,4i,0,29|i,0,61,0,4i,0,29||",
                "Samoa": "i,0,38,0,4i,0,2c|i,0,61,0,4i,0,2c||",
                "Seychelles": "i,0,em,0,8k|||",
                "Singapore": "i,0,4i,0,bi|||",
                "Solomon": "i,0,em,0,vl,0,4pp|||",
                "South_Georgia": "i,0,ho,0,2u,0,19,0,i6|||",
                "Suriname": "i,0,19,0,8q|||",
                "Syowa": "i,0,4i,0,65|||",
                "Tahiti": "i,0,4i,0,8n|||",
                "Taipei": "i,0,38,0,4i,0,3d|i,0,61,0,4i,0,3d||",
                "Tajikistan": "i,0,19,0,4po|||",
                "Tokelau": "i,0,4i,0,5d|||",
                "Tonga": "i,0,38,0,4i,0,2j|i,0,61,0,4i,0,2j||",
                "Truk": "i,0,19,0,6p|||",
                "Turkmenistan": "i,0,38,0,19,0,4t|i,0,61,0,19,0,4t||",
                "Tuvalu": "i,0,4i,0,6h|||",
                "Uruguay": "i,0,38,0,2cl|i,0,61,0,2cl||",
                "Uzbekistan": "i,0,38,0,2ch|i,0,61,0,2ch||",
                "Vanuatu": "i,0,38,0,19,0,2f|i,0,61,0,19,0,2f||",
                "Venezuela": "i,0,19,0,7s|||",
                "Vladivostok": "i,0,38,0,4i,0,28|i,0,61,0,4i,0,28||",
                "Volgograd": "i,0,38,0,4i,0,3f|i,0,61,0,4i,0,3f||",
                "Vostok": "i,0,4i,0,5t|||",
                "Wake": "i,0,194,0,4i,0,5r|||",
                "Wallis": "i,0,4i,0,5f,0,15,0,5k|||",
                "Yakutsk": "i,0,38,0,4i,0,3u|i,0,61,0,4i,0,3u||",
                "Yekaterinburg": "i,0,38,0,4i,0,1lr|i,0,61,0,4i,0,1lr||"
            }
        },
        "it-SM": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|i,0,61,0,4nj||",
                "Europe/London": "|i,0,61,0,19,0,4nk,0,4nl||"
            },
            "metazone": {
                "Afghanistan": "i,0,4r2|||",
                "Africa_Central": "i,0,19s,0,9r|||",
                "Africa_Eastern": "i,0,19s,0,op|||",
                "Africa_Southern": "i,0,19s,0,4r1|||",
                "Africa_Western": "i,0,38,0,19s,0,nd|i,0,61,0,19s,0,nd||",
                "Alaska": "i,0,38,0,2fr|i,0,61,0,2fr||",
                "Amazon": "i,0,38,0,2fq|i,0,61,0,2fq||",
                "America_Central": "i,0,38,0,9r,0,10r|i,0,61,0,9r,0,10r||",
                "America_Eastern": "i,0,38,0,op,0,10r|i,0,61,0,op,0,10r||",
                "America_Mountain": "i,0,38,0,2fo,0,2fn,0,10r|i,0,61,0,2fo,0,2fn,0,10r||",
                "America_Pacific": "i,0,38,0,19,0,1gl,0,10r|i,0,61,0,19,0,1gl,0,10r||",
                "Anadyr": "i,0,38,0,4i,0,3l|i,0,61,0,4i,0,3l||",
                "Apia": "i,0,38,0,4i,0,3e|i,0,61,0,4i,0,3e||",
                "Arabian": "i,0,38,0,2fl|i,0,61,0,2fl||",
                "Argentina": "i,0,38,0,1gt|i,0,61,0,1gt||",
                "Argentina_Western": "i,0,38,0,1gt,0,nd|i,0,61,0,1gt,0,nd||",
                "Armenia": "i,0,38,0,2ff|i,0,61,0,2ff||",
                "Atlantic": "i,0,38,0,2fe|i,0,61,0,2fe||",
                "Australia_Central": "i,0,38,0,112,0,9r|i,0,61,0,112,0,9r||",
                "Australia_CentralWestern": "i,0,38,0,112,0,2eu|i,0,61,0,112,0,2eu||",
                "Australia_Eastern": "i,0,38,0,112,0,op|i,0,61,0,112,0,op||",
                "Australia_Western": "i,0,38,0,112,0,nd|i,0,61,0,112,0,nd||",
                "Azerbaijan": "i,0,38,0,2et|i,0,61,0,2et||",
                "Azores": "i,0,38,0,em,0,2er|i,0,61,0,em,0,2er||",
                "Bangladesh": "i,0,38,0,19,0,3n|i,0,61,0,19,0,3n||",
                "Bhutan": "i,0,19,0,as|||",
                "Bolivia": "i,0,ho,0,aa|||",
                "Brasilia": "i,0,38,0,4i,0,3a|i,0,61,0,4i,0,3a||",
                "Brunei": "i,0,19,0,9o,0,a4|||",
                "Cape_Verde": "i,0,38,0,4i,0,2em,0,3j|i,0,61,0,4i,0,2em,0,3j||",
                "Chamorro": "i,0,4i,0,6j|||",
                "Chatham": "i,0,38,0,em,0,27|i,0,61,0,em,0,27||",
                "Chile": "i,0,38,0,19,0,1rt|i,0,61,0,19,0,1rt||",
                "China": "i,0,38,0,ho,0,2el|i,0,61,0,ho,0,2el||",
                "Choibalsan": "i,0,38,0,4i,0,2q|i,0,61,0,4i,0,2q||",
                "Christmas": "i,0,194,0,99|||",
                "Cocos": "i,0,em,0,vl,0,7v|||",
                "Colombia": "i,0,38,0,ho,0,4m|i,0,61,0,ho,0,4m||",
                "Cook": "i,0,38,0,em,0,1q8,0,2v|i,0,61,0,r1,0,em,0,1q8,0,2v||",
                "Cuba": "i,0,38,0,4i,0,34|i,0,61,0,4i,0,34||",
                "Davis": "i,0,4i,0,5s|||",
                "DumontDUrville": "i,0,4i,0,5b,5,5j|||",
                "East_Timor": "i,0,4i,0,7n,0,195|||",
                "Easter": "i,0,38,0,194,0,4i,0,181|i,0,61,0,194,0,4i,0,181||",
                "Ecuador": "i,0,4qi|||",
                "Europe_Central": "i,0,38,0,13g,0,9r|i,0,61,0,13g,0,9r|h0|h4",
                "Europe_Eastern": "i,0,38,0,13g,0,op|i,0,61,0,13g,0,op|gu|gv",
                "Europe_Further_Eastern": "i,0,13g,0,op,0,4qh|||",
                "Europe_Western": "i,0,38,0,13g,0,nd|i,0,61,0,13g,0,nd|h1|h2",
                "Falkland": "i,0,38,0,em,0,vl,0,4v|i,0,61,0,em,0,vl,0,4v||",
                "Fiji": "i,0,38,0,em,0,2du|i,0,61,0,em,0,2du||",
                "French_Guiana": "i,0,ho,0,am,0,4qg|||",
                "French_Southern": "i,0,em,0,co,0,4qe,0,15,0,4qd,0,4qc|||",
                "Galapagos": "i,0,em,0,ak|||",
                "Gambier": "i,0,4i,0,6v|||",
                "Georgia": "i,0,38,0,ho,0,2u|i,0,61,0,ho,0,2u||",
                "Gilbert_Islands": "i,0,em,0,1q8,0,6q|||",
                "GMT": "i,0,19,0,rc,0,4i,0,5u|||",
                "Greenland_Eastern": "i,0,38,0,ho,0,b2,0,op|i,0,61,0,ho,0,b2,0,op||",
                "Greenland_Western": "i,0,38,0,ho,0,b2,0,nd|i,0,61,0,ho,0,b2,0,nd||",
                "Gulf": "i,0,19,0,oh|||",
                "Guyana": "i,0,ho,0,7a|||",
                "Hawaii_Aleutian": "i,0,38,0,em,0,vl,0,4g,5,1ml|i,0,61,0,em,0,vl,0,4g,5,1ml||",
                "Hong_Kong": "i,0,38,0,4i,0,2l,0,2p|i,0,61,0,4i,0,2l,0,2p||",
                "Hovd": "i,0,38,0,4i,0,2g|i,0,61,0,4i,0,2g||",
                "India": "i,0,38,0,4qb|||",
                "Indian_Ocean": "i,0,4qa,0,4q9|||",
                "Indochina": "i,0,4q7|||",
                "Indonesia_Central": "i,0,1qa,0,9r|||",
                "Indonesia_Eastern": "i,0,1qa,0,op|||",
                "Indonesia_Western": "i,0,1qa,0,nd|||",
                "Iran": "i,0,38,0,2dn|i,0,61,0,2dn||",
                "Irkutsk": "i,0,38,0,4i,0,3h|i,0,61,0,4i,0,3h||",
                "Israel": "i,0,38,0,4i,0,2dm|i,0,61,0,4i,0,2dm||",
                "Japan": "i,0,38,0,19,0,2dl|i,0,61,0,19,0,2dl||",
                "Kamchatka": "i,0,38,0,4i,0,37,5,3k|i,0,61,0,4i,0,37,5,3k||",
                "Kazakhstan_Eastern": "i,0,19,0,1mt,0,op|||",
                "Kazakhstan_Western": "i,0,19,0,1mt,0,nd|||",
                "Korea": "i,0,38,0,2dj|i,0,61,0,2dj||",
                "Kosrae": "i,0,19,0,6f|||",
                "Krasnoyarsk": "i,0,38,0,4i,0,41|i,0,61,0,4i,0,41||",
                "Kyrgystan": "i,0,19,0,mm|||",
                "Line_Islands": "i,0,em,0,4q2,0,4q1|||",
                "Lord_Howe": "i,0,38,0,4i,0,1u,0,24|i,0,61,0,4i,0,1u,0,24||",
                "Macquarie": "i,0,194,0,6m|||",
                "Magadan": "i,0,38,0,4i,0,2o|i,0,61,0,4i,0,2o||",
                "Malaysia": "i,0,ho,0,4q0|||",
                "Maldives": "i,0,em,0,2ot|||",
                "Marquesas": "i,0,em,0,4pu|||",
                "Marshall_Islands": "i,0,em,0,vl,0,7o|||",
                "Mauritius": "i,0,38,0,em,0,4u|i,0,61,0,em,0,4u||",
                "Mawson": "i,0,4i,0,63|||",
                "Mexico_Northwest": "i,0,38,0,19,0,2dc,0,93,5,nd|i,0,61,0,19,0,2dc,0,93,5,nd||",
                "Mexico_Pacific": "i,0,38,0,19,0,1gl,0,2db|i,0,61,0,19,0,1gl,0,2db||",
                "Mongolia": "i,0,38,0,4i,0,4f,0,2m|i,0,61,0,4i,0,4f,0,2m||",
                "Moscow": "i,0,38,0,4i,0,2cu|i,0,61,0,4i,0,2cu||",
                "Myanmar": "i,0,ho,0,ra|||",
                "Nauru": "i,0,4i,0,5v|||",
                "Nepal": "i,0,19,0,8u|||",
                "New_Caledonia": "i,0,38,0,ho,0,197,0,4o|i,0,61,0,ho,0,197,0,4o||",
                "New_Zealand": "i,0,38,0,ho,0,197,0,go|i,0,61,0,ho,0,197,0,go||",
                "Newfoundland": "i,0,38,0,4i,0,h5|i,0,61,0,4i,0,h5||",
                "Niue": "i,0,4i,0,8g|||",
                "Norfolk": "i,0,em,0,vl,0,6l|||",
                "Noronha": "i,0,38,0,4i,0,1s,0,2,0,23|i,0,61,0,4i,0,1s,0,2,0,23||",
                "Novosibirsk": "i,0,38,0,4i,0,3b|i,0,61,0,4i,0,3b||",
                "Omsk": "i,0,38,0,4i,0,26|i,0,61,0,4i,0,26||",
                "Pakistan": "i,0,38,0,19,0,3i|i,0,61,0,19,0,3i||",
                "Palau": "i,0,4i,0,9b|||",
                "Papua_New_Guinea": "i,0,ho,0,9a,0,197,0,a8|||",
                "Paraguay": "i,0,38,0,19,0,3c|i,0,61,0,19,0,3c||",
                "Peru": "i,0,38,0,19,0,2cp|i,0,61,0,19,0,2cp||",
                "Philippines": "i,0,38,0,em,0,2co|i,0,61,0,em,0,2co||",
                "Phoenix_Islands": "i,0,em,0,vl,0,ho,0,4pr|||",
                "Pierre_Miquelon": "i,0,38,0,4i,0,8i,5,33,0,15,0,35|i,0,61,0,4i,0,8i,5,33,0,15,0,35||",
                "Pitcairn": "i,0,em,0,7e|||",
                "Ponape": "i,0,4i,0,e5|||",
                "Pyongyang": "i,0,4i,0,8a|||",
                "Reunion": "i,0,4i,0,4pq|||",
                "Rothera": "i,0,4i,0,5q|||",
                "Sakhalin": "i,0,38,0,4i,0,55|i,0,61,0,4i,0,55||",
                "Samara": "i,0,38,0,4i,0,29|i,0,61,0,4i,0,29||",
                "Samoa": "i,0,38,0,4i,0,2c|i,0,61,0,4i,0,2c||",
                "Seychelles": "i,0,em,0,8k|||",
                "Singapore": "i,0,4i,0,bi|||",
                "Solomon": "i,0,em,0,vl,0,4pp|||",
                "South_Georgia": "i,0,ho,0,2u,0,19,0,i6|||",
                "Suriname": "i,0,19,0,8q|||",
                "Syowa": "i,0,4i,0,65|||",
                "Tahiti": "i,0,4i,0,8n|||",
                "Taipei": "i,0,38,0,4i,0,3d|i,0,61,0,4i,0,3d||",
                "Tajikistan": "i,0,19,0,4po|||",
                "Tokelau": "i,0,4i,0,5d|||",
                "Tonga": "i,0,38,0,4i,0,2j|i,0,61,0,4i,0,2j||",
                "Truk": "i,0,19,0,6p|||",
                "Turkmenistan": "i,0,38,0,19,0,4t|i,0,61,0,19,0,4t||",
                "Tuvalu": "i,0,4i,0,6h|||",
                "Uruguay": "i,0,38,0,2cl|i,0,61,0,2cl||",
                "Uzbekistan": "i,0,38,0,2ch|i,0,61,0,2ch||",
                "Vanuatu": "i,0,38,0,19,0,2f|i,0,61,0,19,0,2f||",
                "Venezuela": "i,0,19,0,7s|||",
                "Vladivostok": "i,0,38,0,4i,0,28|i,0,61,0,4i,0,28||",
                "Volgograd": "i,0,38,0,4i,0,3f|i,0,61,0,4i,0,3f||",
                "Vostok": "i,0,4i,0,5t|||",
                "Wake": "i,0,194,0,4i,0,5r|||",
                "Wallis": "i,0,4i,0,5f,0,15,0,5k|||",
                "Yakutsk": "i,0,38,0,4i,0,3u|i,0,61,0,4i,0,3u||",
                "Yekaterinburg": "i,0,38,0,4i,0,1lr|i,0,61,0,4i,0,1lr||"
            }
        },
        "it": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|i,0,61,0,4nj||",
                "Europe/London": "|i,0,61,0,19,0,4nk,0,4nl||"
            },
            "metazone": {
                "Afghanistan": "i,0,4r2|||",
                "Africa_Central": "i,0,19s,0,9r|||",
                "Africa_Eastern": "i,0,19s,0,op|||",
                "Africa_Southern": "i,0,19s,0,4r1|||",
                "Africa_Western": "i,0,38,0,19s,0,nd|i,0,61,0,19s,0,nd||",
                "Alaska": "i,0,38,0,2fr|i,0,61,0,2fr||",
                "Amazon": "i,0,38,0,2fq|i,0,61,0,2fq||",
                "America_Central": "i,0,38,0,9r,0,10r|i,0,61,0,9r,0,10r||",
                "America_Eastern": "i,0,38,0,op,0,10r|i,0,61,0,op,0,10r||",
                "America_Mountain": "i,0,38,0,2fo,0,2fn,0,10r|i,0,61,0,2fo,0,2fn,0,10r||",
                "America_Pacific": "i,0,38,0,19,0,1gl,0,10r|i,0,61,0,19,0,1gl,0,10r||",
                "Anadyr": "i,0,38,0,4i,0,3l|i,0,61,0,4i,0,3l||",
                "Apia": "i,0,38,0,4i,0,3e|i,0,61,0,4i,0,3e||",
                "Arabian": "i,0,38,0,2fl|i,0,61,0,2fl||",
                "Argentina": "i,0,38,0,1gt|i,0,61,0,1gt||",
                "Argentina_Western": "i,0,38,0,1gt,0,nd|i,0,61,0,1gt,0,nd||",
                "Armenia": "i,0,38,0,2ff|i,0,61,0,2ff||",
                "Atlantic": "i,0,38,0,2fe|i,0,61,0,2fe||",
                "Australia_Central": "i,0,38,0,112,0,9r|i,0,61,0,112,0,9r||",
                "Australia_CentralWestern": "i,0,38,0,112,0,2eu|i,0,61,0,112,0,2eu||",
                "Australia_Eastern": "i,0,38,0,112,0,op|i,0,61,0,112,0,op||",
                "Australia_Western": "i,0,38,0,112,0,nd|i,0,61,0,112,0,nd||",
                "Azerbaijan": "i,0,38,0,2et|i,0,61,0,2et||",
                "Azores": "i,0,38,0,em,0,2er|i,0,61,0,em,0,2er||",
                "Bangladesh": "i,0,38,0,19,0,3n|i,0,61,0,19,0,3n||",
                "Bhutan": "i,0,19,0,as|||",
                "Bolivia": "i,0,ho,0,aa|||",
                "Brasilia": "i,0,38,0,4i,0,3a|i,0,61,0,4i,0,3a||",
                "Brunei": "i,0,19,0,9o,0,a4|||",
                "Cape_Verde": "i,0,38,0,4i,0,2em,0,3j|i,0,61,0,4i,0,2em,0,3j||",
                "Chamorro": "i,0,4i,0,6j|||",
                "Chatham": "i,0,38,0,em,0,27|i,0,61,0,em,0,27||",
                "Chile": "i,0,38,0,19,0,1rt|i,0,61,0,19,0,1rt||",
                "China": "i,0,38,0,ho,0,2el|i,0,61,0,ho,0,2el||",
                "Choibalsan": "i,0,38,0,4i,0,2q|i,0,61,0,4i,0,2q||",
                "Christmas": "i,0,194,0,99|||",
                "Cocos": "i,0,em,0,vl,0,7v|||",
                "Colombia": "i,0,38,0,ho,0,4m|i,0,61,0,ho,0,4m||",
                "Cook": "i,0,38,0,em,0,1q8,0,2v|i,0,61,0,r1,0,em,0,1q8,0,2v||",
                "Cuba": "i,0,38,0,4i,0,34|i,0,61,0,4i,0,34||",
                "Davis": "i,0,4i,0,5s|||",
                "DumontDUrville": "i,0,4i,0,5b,5,5j|||",
                "East_Timor": "i,0,4i,0,7n,0,195|||",
                "Easter": "i,0,38,0,194,0,4i,0,181|i,0,61,0,194,0,4i,0,181||",
                "Ecuador": "i,0,4qi|||",
                "Europe_Central": "i,0,38,0,13g,0,9r|i,0,61,0,13g,0,9r|h0|h4",
                "Europe_Eastern": "i,0,38,0,13g,0,op|i,0,61,0,13g,0,op|gu|gv",
                "Europe_Further_Eastern": "i,0,13g,0,op,0,4qh|||",
                "Europe_Western": "i,0,38,0,13g,0,nd|i,0,61,0,13g,0,nd|h1|h2",
                "Falkland": "i,0,38,0,em,0,vl,0,4v|i,0,61,0,em,0,vl,0,4v||",
                "Fiji": "i,0,38,0,em,0,2du|i,0,61,0,em,0,2du||",
                "French_Guiana": "i,0,ho,0,am,0,4qg|||",
                "French_Southern": "i,0,em,0,co,0,4qe,0,15,0,4qd,0,4qc|||",
                "Galapagos": "i,0,em,0,ak|||",
                "Gambier": "i,0,4i,0,6v|||",
                "Georgia": "i,0,38,0,ho,0,2u|i,0,61,0,ho,0,2u||",
                "Gilbert_Islands": "i,0,em,0,1q8,0,6q|||",
                "GMT": "i,0,19,0,rc,0,4i,0,5u|||",
                "Greenland_Eastern": "i,0,38,0,ho,0,b2,0,op|i,0,61,0,ho,0,b2,0,op||",
                "Greenland_Western": "i,0,38,0,ho,0,b2,0,nd|i,0,61,0,ho,0,b2,0,nd||",
                "Gulf": "i,0,19,0,oh|||",
                "Guyana": "i,0,ho,0,7a|||",
                "Hawaii_Aleutian": "i,0,38,0,em,0,vl,0,4g,5,1ml|i,0,61,0,em,0,vl,0,4g,5,1ml||",
                "Hong_Kong": "i,0,38,0,4i,0,2l,0,2p|i,0,61,0,4i,0,2l,0,2p||",
                "Hovd": "i,0,38,0,4i,0,2g|i,0,61,0,4i,0,2g||",
                "India": "i,0,38,0,4qb|||",
                "Indian_Ocean": "i,0,4qa,0,4q9|||",
                "Indochina": "i,0,4q7|||",
                "Indonesia_Central": "i,0,1qa,0,9r|||",
                "Indonesia_Eastern": "i,0,1qa,0,op|||",
                "Indonesia_Western": "i,0,1qa,0,nd|||",
                "Iran": "i,0,38,0,2dn|i,0,61,0,2dn||",
                "Irkutsk": "i,0,38,0,4i,0,3h|i,0,61,0,4i,0,3h||",
                "Israel": "i,0,38,0,4i,0,2dm|i,0,61,0,4i,0,2dm||",
                "Japan": "i,0,38,0,19,0,2dl|i,0,61,0,19,0,2dl||",
                "Kamchatka": "i,0,38,0,4i,0,37,5,3k|i,0,61,0,4i,0,37,5,3k||",
                "Kazakhstan_Eastern": "i,0,19,0,1mt,0,op|||",
                "Kazakhstan_Western": "i,0,19,0,1mt,0,nd|||",
                "Korea": "i,0,38,0,2dj|i,0,61,0,2dj||",
                "Kosrae": "i,0,19,0,6f|||",
                "Krasnoyarsk": "i,0,38,0,4i,0,41|i,0,61,0,4i,0,41||",
                "Kyrgystan": "i,0,19,0,mm|||",
                "Line_Islands": "i,0,em,0,4q2,0,4q1|||",
                "Lord_Howe": "i,0,38,0,4i,0,1u,0,24|i,0,61,0,4i,0,1u,0,24||",
                "Macquarie": "i,0,194,0,6m|||",
                "Magadan": "i,0,38,0,4i,0,2o|i,0,61,0,4i,0,2o||",
                "Malaysia": "i,0,ho,0,4q0|||",
                "Maldives": "i,0,em,0,2ot|||",
                "Marquesas": "i,0,em,0,4pu|||",
                "Marshall_Islands": "i,0,em,0,vl,0,7o|||",
                "Mauritius": "i,0,38,0,em,0,4u|i,0,61,0,em,0,4u||",
                "Mawson": "i,0,4i,0,63|||",
                "Mexico_Northwest": "i,0,38,0,19,0,2dc,0,93,5,nd|i,0,61,0,19,0,2dc,0,93,5,nd||",
                "Mexico_Pacific": "i,0,38,0,19,0,1gl,0,2db|i,0,61,0,19,0,1gl,0,2db||",
                "Mongolia": "i,0,38,0,4i,0,4f,0,2m|i,0,61,0,4i,0,4f,0,2m||",
                "Moscow": "i,0,38,0,4i,0,2cu|i,0,61,0,4i,0,2cu||",
                "Myanmar": "i,0,ho,0,ra|||",
                "Nauru": "i,0,4i,0,5v|||",
                "Nepal": "i,0,19,0,8u|||",
                "New_Caledonia": "i,0,38,0,ho,0,197,0,4o|i,0,61,0,ho,0,197,0,4o||",
                "New_Zealand": "i,0,38,0,ho,0,197,0,go|i,0,61,0,ho,0,197,0,go||",
                "Newfoundland": "i,0,38,0,4i,0,h5|i,0,61,0,4i,0,h5||",
                "Niue": "i,0,4i,0,8g|||",
                "Norfolk": "i,0,em,0,vl,0,6l|||",
                "Noronha": "i,0,38,0,4i,0,1s,0,2,0,23|i,0,61,0,4i,0,1s,0,2,0,23||",
                "Novosibirsk": "i,0,38,0,4i,0,3b|i,0,61,0,4i,0,3b||",
                "Omsk": "i,0,38,0,4i,0,26|i,0,61,0,4i,0,26||",
                "Pakistan": "i,0,38,0,19,0,3i|i,0,61,0,19,0,3i||",
                "Palau": "i,0,4i,0,9b|||",
                "Papua_New_Guinea": "i,0,ho,0,9a,0,197,0,a8|||",
                "Paraguay": "i,0,38,0,19,0,3c|i,0,61,0,19,0,3c||",
                "Peru": "i,0,38,0,19,0,2cp|i,0,61,0,19,0,2cp||",
                "Philippines": "i,0,38,0,em,0,2co|i,0,61,0,em,0,2co||",
                "Phoenix_Islands": "i,0,em,0,vl,0,ho,0,4pr|||",
                "Pierre_Miquelon": "i,0,38,0,4i,0,8i,5,33,0,15,0,35|i,0,61,0,4i,0,8i,5,33,0,15,0,35||",
                "Pitcairn": "i,0,em,0,7e|||",
                "Ponape": "i,0,4i,0,e5|||",
                "Pyongyang": "i,0,4i,0,8a|||",
                "Reunion": "i,0,4i,0,4pq|||",
                "Rothera": "i,0,4i,0,5q|||",
                "Sakhalin": "i,0,38,0,4i,0,55|i,0,61,0,4i,0,55||",
                "Samara": "i,0,38,0,4i,0,29|i,0,61,0,4i,0,29||",
                "Samoa": "i,0,38,0,4i,0,2c|i,0,61,0,4i,0,2c||",
                "Seychelles": "i,0,em,0,8k|||",
                "Singapore": "i,0,4i,0,bi|||",
                "Solomon": "i,0,em,0,vl,0,4pp|||",
                "South_Georgia": "i,0,ho,0,2u,0,19,0,i6|||",
                "Suriname": "i,0,19,0,8q|||",
                "Syowa": "i,0,4i,0,65|||",
                "Tahiti": "i,0,4i,0,8n|||",
                "Taipei": "i,0,38,0,4i,0,3d|i,0,61,0,4i,0,3d||",
                "Tajikistan": "i,0,19,0,4po|||",
                "Tokelau": "i,0,4i,0,5d|||",
                "Tonga": "i,0,38,0,4i,0,2j|i,0,61,0,4i,0,2j||",
                "Truk": "i,0,19,0,6p|||",
                "Turkmenistan": "i,0,38,0,19,0,4t|i,0,61,0,19,0,4t||",
                "Tuvalu": "i,0,4i,0,6h|||",
                "Uruguay": "i,0,38,0,2cl|i,0,61,0,2cl||",
                "Uzbekistan": "i,0,38,0,2ch|i,0,61,0,2ch||",
                "Vanuatu": "i,0,38,0,19,0,2f|i,0,61,0,19,0,2f||",
                "Venezuela": "i,0,19,0,7s|||",
                "Vladivostok": "i,0,38,0,4i,0,28|i,0,61,0,4i,0,28||",
                "Volgograd": "i,0,38,0,4i,0,3f|i,0,61,0,4i,0,3f||",
                "Vostok": "i,0,4i,0,5t|||",
                "Wake": "i,0,194,0,4i,0,5r|||",
                "Wallis": "i,0,4i,0,5f,0,15,0,5k|||",
                "Yakutsk": "i,0,38,0,4i,0,3u|i,0,61,0,4i,0,3u||",
                "Yekaterinburg": "i,0,38,0,4i,0,1lr|i,0,61,0,4i,0,1lr||"
            }
        },
        "ja": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cbg||",
                "Europe/London": "|cbh||"
            },
            "metazone": {
                "Acre": "aa4|aa3||",
                "Afghanistan": "aa2|||",
                "Africa_Central": "aa1|||",
                "Africa_Eastern": "aa0|||",
                "Africa_Southern": "a9v|||",
                "Africa_Western": "a9u|a9t||",
                "Alaska": "a9s|a9r||",
                "Almaty": "a9q|a9p||",
                "Amazon": "a9o|a9n||",
                "America_Central": "a9m|a9l||",
                "America_Eastern": "a9k|a9j||",
                "America_Mountain": "a9i|a9h||",
                "America_Pacific": "a9g|a9f||",
                "Anadyr": "a9e|a9d||",
                "Apia": "a9c|a9b||",
                "Aqtau": "a9a|a99||",
                "Aqtobe": "a98|a97||",
                "Arabian": "a96|a95||",
                "Argentina": "a94|a93||",
                "Argentina_Western": "a92|a91||",
                "Armenia": "a90|a8v||",
                "Atlantic": "a8u|a8t||",
                "Australia_Central": "a8s|a8r||",
                "Australia_CentralWestern": "a8q|a8p||",
                "Australia_Eastern": "a8o|a8n||",
                "Australia_Western": "a8m|a8l||",
                "Azerbaijan": "a8k|a8j||",
                "Azores": "a8i|a8h||",
                "Bangladesh": "a8g|a8f||",
                "Bhutan": "a8e|||",
                "Bolivia": "a8d|||",
                "Brasilia": "a8c|a8b||",
                "Brunei": "a8a|||",
                "Cape_Verde": "a89|a88||",
                "Casey": "a87|||",
                "Chamorro": "a86|||",
                "Chatham": "a85|a84||",
                "Chile": "a83|a82||",
                "China": "a81|a80||",
                "Choibalsan": "a7v|a7u||",
                "Christmas": "a7t|||",
                "Cocos": "a7s|||",
                "Colombia": "a7r|a7q||",
                "Cook": "a7p|a7o||",
                "Cuba": "a7n|a7m||",
                "Davis": "a7l|||",
                "DumontDUrville": "a7k|||",
                "East_Timor": "a7j|||",
                "Easter": "a7i|a7h||",
                "Ecuador": "a7g|||",
                "Europe_Central": "a7f|a7e||",
                "Europe_Eastern": "a7d|a7c||",
                "Europe_Further_Eastern": "a7b|||",
                "Europe_Western": "a7a|a79||",
                "Falkland": "a78|a77||",
                "Fiji": "a76|a75||",
                "French_Guiana": "a74|||",
                "French_Southern": "a73|||",
                "Galapagos": "a72|||",
                "Gambier": "a71|||",
                "Georgia": "a70|a6v||",
                "Gilbert_Islands": "a6u|||",
                "GMT": "a6t|||",
                "Greenland_Eastern": "a6s|a6r||",
                "Greenland_Western": "a6q|a6p||",
                "Guam": "a6o|||",
                "Gulf": "a6n|||",
                "Guyana": "a6m|||",
                "Hawaii_Aleutian": "a6l|a6k||",
                "Hong_Kong": "a6j|a6i||",
                "Hovd": "a6h|a6g||",
                "India": "a6f|||",
                "Indian_Ocean": "a6e|||",
                "Indochina": "a6d|||",
                "Indonesia_Central": "a6c|||",
                "Indonesia_Eastern": "a6b|||",
                "Indonesia_Western": "a6a|||",
                "Iran": "a69|a68||",
                "Irkutsk": "a67|a66||",
                "Israel": "a65|a64||",
                "Japan": "a63|a62|a61|a60",
                "Kamchatka": "a5v|a5u||",
                "Kazakhstan_Eastern": "a5t|||",
                "Kazakhstan_Western": "a5s|||",
                "Korea": "a5r|a5q||",
                "Kosrae": "a5p|||",
                "Krasnoyarsk": "a5o|a5n||",
                "Kyrgystan": "a5m|||",
                "Lanka": "a5l|||",
                "Line_Islands": "a5k|||",
                "Lord_Howe": "a5j|a5i||",
                "Macau": "a5h|a5g||",
                "Macquarie": "a5f|||",
                "Magadan": "a5e|a5d||",
                "Malaysia": "a5c|||",
                "Maldives": "a5b|||",
                "Marquesas": "a5a|||",
                "Marshall_Islands": "a59|||",
                "Mauritius": "a58|a57||",
                "Mawson": "a56|||",
                "Mexico_Northwest": "a55|a54||",
                "Mexico_Pacific": "a53|a52||",
                "Mongolia": "a51|a50||",
                "Moscow": "a4v|a4u||",
                "Myanmar": "a4t|||",
                "Nauru": "a4s|||",
                "Nepal": "a4r|||",
                "New_Caledonia": "a4q|a4p||",
                "New_Zealand": "a4o|a4n||",
                "Newfoundland": "a4m|a4l||",
                "Niue": "a4k|||",
                "Norfolk": "a4j|||",
                "Noronha": "a4i|a4h||",
                "North_Mariana": "a4g|||",
                "Novosibirsk": "a4f|a4e||",
                "Omsk": "a4d|a4c||",
                "Pakistan": "a4b|a4a||",
                "Palau": "a49|||",
                "Papua_New_Guinea": "a48|||",
                "Paraguay": "a47|a46||",
                "Peru": "a45|a44||",
                "Philippines": "a43|a42||",
                "Phoenix_Islands": "a41|||",
                "Pierre_Miquelon": "a40|a3v||",
                "Pitcairn": "a3u|||",
                "Ponape": "a3t|||",
                "Pyongyang": "a3s|||",
                "Qyzylorda": "a3r|a3q||",
                "Reunion": "a3p|||",
                "Rothera": "a3o|||",
                "Sakhalin": "a3n|a3m||",
                "Samara": "a3l|a3k||",
                "Samoa": "a3j|a3i||",
                "Seychelles": "a3h|||",
                "Singapore": "a3g|||",
                "Solomon": "a3f|||",
                "South_Georgia": "a3e|||",
                "Suriname": "a3d|||",
                "Syowa": "2op|||",
                "Tahiti": "a3c|||",
                "Taipei": "a3b|a3a||",
                "Tajikistan": "a39|||",
                "Tokelau": "a38|||",
                "Tonga": "a37|a36||",
                "Truk": "a35|||",
                "Turkmenistan": "a34|a33||",
                "Tuvalu": "a32|||",
                "Uruguay": "a31|a30||",
                "Uzbekistan": "a2v|a2u||",
                "Vanuatu": "a2t|a2s||",
                "Venezuela": "a2r|||",
                "Vladivostok": "a2q|a2p||",
                "Volgograd": "a2o|a2n||",
                "Vostok": "a2m|||",
                "Wake": "a2l|||",
                "Wallis": "a2k|||",
                "Yakutsk": "a2j|a2i||",
                "Yekaterinburg": "a2h|a2g||"
            }
        },
        "jgo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "jmc": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ka": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cbi,0,gd,0,7p||",
                "Europe/London": "|cbj,0,gn,0,7p||"
            },
            "metazone": {
                "Afghanistan": "a2f,0,7p|||",
                "Africa_Central": "1oa,0,2oa,0,7p|||",
                "Africa_Eastern": "1kq,0,2oa,0,7p|||",
                "Africa_Southern": "61t,0,2oa,0,7p|||",
                "Africa_Western": "18a,0,2oa,0,gd,0,7p|18a,0,2oa,0,gn,0,7p||",
                "Alaska": "621,0,gd,0,7p|621,0,gn,0,7p||",
                "Amazon": "622,0,gd,0,7p|622,0,gn,0,7p||",
                "America_Central": "21n,0,21m,0,1oa,0,gd,0,7p|21n,0,21m,0,1oa,0,gn,0,7p||",
                "America_Eastern": "21n,0,21m,0,625,0,gd,0,7p|21n,0,21m,0,625,0,gn,0,7p||",
                "America_Mountain": "21n,0,21m,0,626,0,gd,0,7p|21n,0,21m,0,626,0,gn,0,7p||",
                "America_Pacific": "21n,0,21m,0,3if,0,27p,0,gd,0,7p|21n,0,21m,0,3if,0,27p,0,gn,0,7p||",
                "Apia": "629,0,gd,0,7p|629,0,gn,0,7p||",
                "Arabian": "62a,0,gd,0,7p|62a,0,gn,0,7p||",
                "Argentina": "3ih,0,gd,0,7p|3ih,0,gn,0,7p||",
                "Argentina_Western": "18a,0,3ih,0,gd,0,7p|18a,0,3ih,0,gn,0,7p||",
                "Armenia": "62c,0,gd,0,7p|62c,0,gn,0,7p||",
                "Atlantic": "62d,0,27p,0,gd,0,7p|62d,0,27p,0,gn,0,7p||",
                "Australia_Central": "21k,0,1oa,0,gd,0,7p|21k,0,1oa,0,gn,0,7p||",
                "Australia_CentralWestern": "1oa,0,21i,0,18a,0,21k,0,gd,0,7p|1oa,0,21i,0,18a,0,21k,0,gn,0,7p||",
                "Australia_Eastern": "1kq,0,21k,0,gd,0,7p|1kq,0,21k,0,gn,0,7p||",
                "Australia_Western": "18a,0,21k,0,gd,0,7p|18a,0,21k,0,gn,0,7p||",
                "Azerbaijan": "62g,0,gd,0,7p|62g,0,gn,0,7p||",
                "Azores": "62h,0,192,0,gd,0,7p|62h,0,192,0,gn,0,7p||",
                "Bangladesh": "62j,0,gd,0,7p|62j,0,gn,0,7p||",
                "Bhutan": "a2e,0,7p|||",
                "Bolivia": "a2d,0,7p|||",
                "Brasilia": "62m,0,gd,0,7p|62m,0,gn,0,7p||",
                "Brunei": "a2c,5,a2b,0,7p|||",
                "Cape_Verde": "62p,5,62q,0,gd,0,7p|62p,5,62q,0,gn,0,7p||",
                "Chamorro": "a2a,0,7p|||",
                "Chatham": "62s,0,gd,0,7p|62s,0,gn,0,7p||",
                "Chile": "62t,0,gd,0,7p|62t,0,gn,0,7p||",
                "China": "62u,0,gd,0,7p|62u,0,62v,0,630||",
                "Choibalsan": "631,0,gd,0,7p|631,0,gn,0,7p||",
                "Christmas": "a29,0,2b5,0,7p|||",
                "Cocos": "a28,0,192,0,7p|||",
                "Colombia": "635,0,gd,0,7p|635,0,gn,0,7p||",
                "Cook": "636,0,192,0,gd,0,7p|636,0,192,0,a27,0,gn,0,7p||",
                "Cuba": "638,0,gd,0,7p|638,0,gn,0,7p||",
                "Davis": "a26,0,7p|||",
                "DumontDUrville": "a25,5,a24,0,7p|||",
                "East_Timor": "1kq,0,a23,0,7p|||",
                "Easter": "63d,0,2b5,0,gd,0,7p|63d,0,2b5,0,gn,0,7p||",
                "Ecuador": "a22,0,7p|||",
                "Europe_Central": "1oa,0,27s,0,gd,0,7p|1oa,0,27s,0,gn,0,7p||",
                "Europe_Eastern": "1kq,0,27s,0,gd,0,7p|1kq,0,27s,0,gn,0,7p||",
                "Europe_Further_Eastern": "a21,0,1kq,0,27s,0,7p|||",
                "Europe_Western": "18a,0,27s,0,gd,0,7p|18a,0,27s,0,gn,0,7p||",
                "Falkland": "63h,0,192,0,gd,0,7p|63h,0,192,0,gn,0,7p||",
                "Fiji": "63i,0,gd,0,7p|63i,0,gn,0,7p||",
                "French_Guiana": "a20,0,a1v,0,7p|||",
                "French_Southern": "a1u,0,a1t,0,21i,0,a1s,0,7p|||",
                "Galapagos": "a1r,0,7p|||",
                "Gambier": "a1q,0,7p|||",
                "Georgia": "63q,0,gd,0,7p|63q,0,gn,0,7p||",
                "Gilbert_Islands": "a1p,0,192,0,7p|||",
                "GMT": "a1o,0,a1n,0,7p|||",
                "Greenland_Eastern": "1kq,0,3jf,0,gd,0,7p|1kq,0,3jf,0,gn,0,7p||",
                "Greenland_Western": "18a,0,3jf,0,gd,0,7p|18a,0,3jf,0,gn,0,7p||",
                "Gulf": "a1m,0,a1l,0,gd,0,7p|||",
                "Guyana": "a1k,0,7p|||",
                "Hawaii_Aleutian": "642,0,21i,0,643,0,gd,0,7p|642,0,21i,0,643,0,gn,0,7p||",
                "Hong_Kong": "644,0,gd,0,7p|644,0,gn,0,7p||",
                "Hovd": "645,0,gd,0,7p|645,0,gn,0,7p||",
                "India": "646,0,7p|||",
                "Indian_Ocean": "646,0,27p,0,192,0,7p|||",
                "Indochina": "a1j,0,7p|||",
                "Indonesia_Central": "1oa,0,4mn,0,7p|||",
                "Indonesia_Eastern": "1kq,0,4mn,0,7p|||",
                "Indonesia_Western": "18a,0,4mn,0,7p|||",
                "Iran": "649,0,gd,0,7p|649,0,62v,0,630||",
                "Irkutsk": "64a,0,gd,0,7p|64a,0,gn,0,7p||",
                "Israel": "64b,0,gd,0,7p|64b,0,gn,0,7p||",
                "Japan": "64c,0,gd,0,7p|64c,0,gn,0,7p||",
                "Kazakhstan_Eastern": "1kq,0,64d,0,7p|||",
                "Kazakhstan_Western": "18a,0,64d,0,7p|||",
                "Korea": "64e,0,gd,0,7p|64e,0,gn,0,7p||",
                "Kosrae": "a1i,0,7p|||",
                "Krasnoyarsk": "64g,0,gd,0,7p|64g,0,gn,0,7p||",
                "Kyrgystan": "a1h,0,7p|||",
                "Line_Islands": "a1g,0,192,0,7p|||",
                "Lord_Howe": "64j,5,64k,0,gd,0,7p|64j,5,64k,0,gn,0,7p||",
                "Macquarie": "a1f,0,2b5,0,7p|||",
                "Magadan": "64m,0,gd,0,7p|64m,0,gn,0,7p||",
                "Malaysia": "a1e,0,7p|||",
                "Maldives": "a1d,0,7p|||",
                "Marquesas": "a1c,0,192,0,7p|||",
                "Marshall_Islands": "a1b,0,192,0,7p|||",
                "Mauritius": "64r,0,gd,0,7p|64r,0,gn,0,7p||",
                "Mawson": "a1a,0,7p|||",
                "Mexico_Northwest": "64t,5,18a,0,3ju,0,7p|64t,5,18a,0,3ju,0,gn,0,7p||",
                "Mexico_Pacific": "3ju,0,3if,0,27p,0,gd,0,7p|3ju,0,3if,0,27p,0,gn,0,7p||",
                "Mongolia": "64v,5,650,0,gd,0,7p|64v,5,650,0,gn,0,7p||",
                "Moscow": "651,0,gd,0,7p|651,0,gn,0,7p||",
                "Myanmar": "a19,0,7p|||",
                "Nauru": "a18,0,7p|||",
                "Nepal": "a17,0,7p|||",
                "New_Caledonia": "2mt,0,656,0,gd,0,7p|2mt,0,656,0,gn,0,7p||",
                "New_Zealand": "2mt,0,657,0,gd,0,7p|2mt,0,657,0,gn,0,7p||",
                "Newfoundland": "658,0,gd,0,7p|658,0,gn,0,7p||",
                "Niue": "a16,0,7p|||",
                "Norfolk": "a15,0,2b5,0,7p|||",
                "Noronha": "65b,5,65c,5,65d,0,gd,0,7p|65b,5,65c,5,65d,0,gn,0,7p||",
                "Novosibirsk": "65e,0,gd,0,7p|65e,0,gn,0,7p||",
                "Omsk": "65f,0,gd,0,7p|65f,0,gn,0,7p||",
                "Pakistan": "65g,0,gd,0,7p|65g,0,gn,0,7p||",
                "Palau": "a14,0,7p|||",
                "Papua_New_Guinea": "a13,5,2mt,0,a12,0,7p|||",
                "Paraguay": "65k,0,gd,0,7p|65k,0,gn,0,7p||",
                "Peru": "65l,0,gd,0,7p|65l,0,gn,0,7p||",
                "Philippines": "65m,0,gd,0,7p|65m,0,gn,0,7p||",
                "Phoenix_Islands": "a11,0,192,0,7p|||",
                "Pierre_Miquelon": "65o,5,65p,0,21i,0,65q,0,gd,0,7p|65o,5,65p,0,21i,0,65q,0,gn,0,7p||",
                "Pitcairn": "a10,0,7p|||",
                "Ponape": "a0v,0,7p|||",
                "Pyongyang": "a0u,0,7p|||",
                "Reunion": "a0t,0,7p|||",
                "Rothera": "a0s,0,7p|||",
                "Sakhalin": "660,0,gd,0,7p|660,0,gn,0,7p||",
                "Samoa": "661,0,gd,0,7p|661,0,gn,0,7p||",
                "Seychelles": "a0r,0,192,0,7p|||",
                "Singapore": "a0q,0,7p|||",
                "Solomon": "a0p,0,192,0,7p|||",
                "South_Georgia": "61t,0,a0o,0,7p|||",
                "Suriname": "a0n,0,7p|||",
                "Syowa": "a0m,0,7p|||",
                "Tahiti": "a0l,0,7p|||",
                "Taipei": "669,0,gd,0,7p|669,0,gn,0,7p||",
                "Tajikistan": "a0k,0,7p|||",
                "Tokelau": "a0j,0,7p|||",
                "Tonga": "66c,0,gd,0,7p|66c,0,gn,0,7p||",
                "Truk": "a0i,0,7p|||",
                "Turkmenistan": "66e,0,gd,0,7p|66e,0,gn,0,7p||",
                "Tuvalu": "a0h,0,7p|||",
                "Uruguay": "66g,0,gd,0,7p|66g,0,gn,0,7p||",
                "Uzbekistan": "66h,0,gd,0,7p|66h,0,gn,0,7p||",
                "Vanuatu": "66i,0,gd,0,7p|66i,0,gn,0,7p||",
                "Venezuela": "a0g,0,7p|||",
                "Vladivostok": "66k,0,gd,0,7p|66k,0,gn,0,7p||",
                "Volgograd": "66l,0,gd,0,7p|66l,0,gn,0,7p||",
                "Vostok": "a0f,0,7p|||",
                "Wake": "a0e,0,2b5,0,7p|||",
                "Wallis": "a0d,0,21i,0,a0c,0,7p|||",
                "Yakutsk": "66q,0,gd,0,7p|66q,0,gn,0,7p||",
                "Yekaterinburg": "66r,0,gd,0,7p|66r,0,gn,0,7p||"
            }
        },
        "kab": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kam": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kde": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kea": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Africa_Central": "i,0,4i,0,c5,0,1qr|||",
                "Africa_Eastern": "i,0,4i,0,c5,0,8h|||",
                "Africa_Southern": "i,0,4i,0,10d,0,4i,0,c5|||",
                "Africa_Western": "i,0,1el,0,4i,0,c5,0,1vi|i,0,4i,0,ec,0,4i,0,c5,0,1vi||",
                "America_Central": "i,0,1qr,0,1el|i,0,1qr,0,4i,0,1ie||",
                "America_Eastern": "i,0,8h,0,1el|i,0,8h,0,4i,0,1ie||",
                "America_Mountain": "i,0,4i,0,109,0,1el|i,0,4i,0,1ie,0,4i,0,109||",
                "America_Pacific": "i,0,4i,0,672,0,1el|i,0,4i,0,672,0,4i,0,1ie||",
                "Atlantic": "i,0,1el,0,4i,0,673|i,0,4i,0,1ie,0,4i,0,673||",
                "Australia_Central": "i,0,1el,0,4i,0,4c,0,1qr|i,0,4i,0,1ie,0,4i,0,4c,0,1qr||",
                "Australia_CentralWestern": "i,0,1el,0,4i,0,4c,0,674,5,1vi|i,0,4i,0,1ie,0,4i,0,4c,0,674,5,1vi||",
                "Australia_Eastern": "i,0,1el,0,4i,0,4c,0,8h|i,0,4i,0,1ie,0,4i,0,4c,0,8h||",
                "Australia_Western": "i,0,1el,0,4i,0,4c,0,1vi|i,0,4i,0,1ie,0,4i,0,4c,0,1vi||",
                "Europe_Central": "i,0,1el,0,4i,0,4p,0,1qr|i,0,4i,0,1ie,0,4i,0,4p,0,1qr||",
                "Europe_Eastern": "i,0,1el,0,4i,0,4p,0,8h|i,0,4i,0,1ie,0,4i,0,4p,0,8h||",
                "Europe_Western": "i,0,1el,0,4i,0,4p,0,1vi|i,0,4i,0,1ie,0,4i,0,4p,0,1vi||"
            }
        },
        "khq": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ki": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,0,ga,0,7l||",
                "Europe/London": "|cbl,0,ga,0,7l||"
            },
            "metazone": {
                "Afghanistan": "a0b,0,7l|||",
                "Africa_Central": "3l6,0,mi,0,7l|||",
                "Africa_Eastern": "1q7,0,mi,0,7l|||",
                "Africa_Southern": "679,0,mi,0,7l|||",
                "Africa_Western": "1hp,0,mi,0,ft,0,7l|1hp,0,mi,0,ga,0,7l||",
                "Alaska": "12l,0,ft,0,7l|12l,0,ga,0,7l||",
                "Amazon": "15q,0,ft,0,7l|15q,0,ga,0,7l||",
                "America_Central": "1mq,0,m6,0,ft,0,2f8,0,7l|1mq,0,m6,0,ga,0,2f8,0,7l||",
                "America_Eastern": "1mq,0,m6,0,ft,0,3ld,0,7l|1mq,0,m6,0,ga,0,3ld,0,7l||",
                "America_Mountain": "1mq,0,m6,0,ft,0,67g,0,7l|1mq,0,m6,0,ga,0,67g,0,7l||",
                "America_Pacific": "1mq,0,m6,0,ft,0,3le,0,67i,0,7l|1mq,0,m6,0,ga,0,3le,0,67i,0,7l||",
                "Apia": "15s,0,ft,0,7l|15s,0,ga,0,7l||",
                "Arabian": "67j,0,67k,0,ft,0,7l|67j,0,67k,0,ga,0,7l||",
                "Argentina": "hk,0,ft,0,7l|hk,0,ga,0,7l||",
                "Argentina_Western": "1hp,0,hk,0,ft,0,7l|1hp,0,hk,0,ga,0,7l||",
                "Armenia": "18n,0,ft,0,7l|18n,0,ga,0,7l||",
                "Atlantic": "2fc,0,ft,0,7l|2fc,0,ga,0,7l||",
                "Australia_Central": "eo,0,ft,0,2f8,0,7l|eo,0,ga,0,2f8,0,7l||",
                "Australia_CentralWestern": "eo,0,ft,0,2f8,5,3lh,0,7l|eo,0,ga,0,2f8,5,3lh,0,7l||",
                "Australia_Eastern": "eo,0,ft,0,3ld,0,7l|eo,0,ga,0,3ld,0,7l||",
                "Australia_Western": "eo,0,ft,0,3lh,0,7l|eo,0,ga,0,3lh,0,7l||",
                "Azerbaijan": "67o,0,ft,0,7l|67o,0,ga,0,7l||",
                "Azores": "30f,0,2fg,0,ft,0,7l|30f,0,2fg,0,ga,0,7l||",
                "Bangladesh": "q8,0,ft,0,7l|q8,0,ga,0,7l||",
                "Bhutan": "16f,0,7l|||",
                "Bolivia": "1pu,0,7l|||",
                "Brasilia": "15k,0,ft,0,7l|15k,0,ga,0,7l||",
                "Brunei": "1gr,5,1o3,0,7l|||",
                "Cape_Verde": "12p,5,115,0,ft,0,7l|12p,5,115,0,ga,0,7l||",
                "Chamorro": "1qj,0,ft,0,7l|||",
                "Chatham": "162,0,ft,0,7l|162,0,ga,0,7l||",
                "Chile": "150,0,ft,0,7l|150,0,ga,0,7l||",
                "China": "67t,0,ft,0,7l|67t,0,ga,0,7l||",
                "Choibalsan": "11e,0,ft,0,7l|11e,0,ga,0,7l||",
                "Christmas": "4l3,0,67u,0,7l|||",
                "Cocos": "1le,0,1nc,0,7l|||",
                "Colombia": "15d,0,ft,0,7l|15d,0,ga,0,7l||",
                "Cook": "1p2,0,1nc,0,ft,0,7l|1p2,0,1nc,0,a0a,0,ga,0,7l||",
                "Cuba": "ql,0,ft,0,7l|ql,0,ga,0,7l||",
                "Davis": "1q3,0,7l|||",
                "DumontDUrville": "1gu,5,241,0,7l|||",
                "East_Timor": "1q7,0,1ki,0,7l|||",
                "Easter": "682,0,3lp,0,ft,0,7l|682,0,3lp,0,ga,0,7l||",
                "Ecuador": "1qk,0,7l|||",
                "Europe_Central": "3l6,0,298,0,ft,0,7l|3l6,0,298,0,ga,0,7l||",
                "Europe_Eastern": "1q7,0,298,0,ft,0,7l|1q7,0,298,0,ga,0,7l|gu|gv",
                "Europe_Further_Eastern": "a09,0,1q7,0,298,0,7l|||",
                "Europe_Western": "1hp,0,298,0,ft,0,7l|1hp,0,298,0,ga,0,7l||",
                "Falkland": "3ls,0,2fg,0,ft,0,7l|3ls,0,2fg,0,ga,0,7l||",
                "Fiji": "161,0,ft,0,7l|161,0,ga,0,7l||",
                "French_Guiana": "307,0,a08,0,7l|||",
                "French_Southern": "a07,0,a06,0,a05,0,2fj,0,4lu,0,7l|||",
                "Galapagos": "1na,0,7l|||",
                "Gambier": "244,0,7l|||",
                "Georgia": "15e,0,ft,0,7l|15e,0,ga,0,7l||",
                "Gilbert_Islands": "1ne,0,1nc,0,7l|||",
                "GMT": "4ht,0,7l|||",
                "Greenland_Eastern": "1q7,0,pq,0,ft,0,7l|1q7,0,pq,0,ga,0,7l||",
                "Greenland_Western": "1hp,0,pq,0,ft,0,7l|1hp,0,pq,0,ga,0,7l||",
                "Gulf": "a04,0,a03,0,7l|||",
                "Guyana": "1ql,0,7l|||",
                "Hawaii_Aleutian": "68i,0,2fj,0,3m8,0,2fg,0,ft,0,7l|68i,0,2fj,0,3m8,0,2fg,0,ga,0,7l||",
                "Hong_Kong": "13t,0,ft,0,7l|13t,0,ga,0,7l||",
                "Hovd": "qg,0,ft,0,7l|qg,0,ga,0,7l||",
                "India": "a02,0,ft,0,7l|||",
                "Indian_Ocean": "a01,0,a00,0,7l|||",
                "Indochina": "9vv,0,7l|||",
                "Indonesia_Central": "3l6,0,vo,0,7l|||",
                "Indonesia_Eastern": "1q7,0,vo,0,7l|||",
                "Indonesia_Western": "1hp,0,vo,0,7l|||",
                "Iran": "rr,0,ft,0,7l|rr,0,ga,0,7l||",
                "Irkutsk": "12u,0,ft,0,7l|12u,0,ga,0,7l||",
                "Israel": "165,0,ft,0,7l|165,0,ga,0,7l||",
                "Japan": "68p,0,ft,0,7l|68p,0,ga,0,7l||",
                "Kazakhstan_Eastern": "1q7,0,68q,0,7l|||",
                "Kazakhstan_Western": "1hp,0,68q,0,7l|||",
                "Korea": "15j,0,ft,0,7l|15j,0,ga,0,7l||",
                "Kosrae": "546,0,7l|||",
                "Krasnoyarsk": "14h,0,ft,0,7l|14h,0,ga,0,7l||",
                "Kyrgystan": "9vu,0,7l|||",
                "Line_Islands": "1eo,0,1nc,0,7l|||",
                "Lord_Howe": "oi,5,10a,0,ft,0,7l|oi,5,10a,0,ga,0,7l||",
                "Macquarie": "1l5,0,3lp,0,7l|||",
                "Magadan": "qq,0,ft,0,7l|qq,0,ga,0,7l||",
                "Malaysia": "1pp,0,7l|||",
                "Maldives": "4lt,0,1nc,0,7l|||",
                "Marquesas": "26l,0,1nc,0,7l|||",
                "Marshall_Islands": "4ls,0,1nc,0,7l|||",
                "Mauritius": "15t,0,ft,0,7l|15t,0,ga,0,7l||",
                "Mawson": "1lt,0,7l|||",
                "Mexico_Northwest": "1mq,5,1hp,0,1tg,0,ft,0,7l|1mq,5,1hp,0,1tg,0,ga,0,7l||",
                "Mexico_Pacific": "1tg,0,ft,0,3le,0,692,0,7l|1tg,0,ga,0,3le,0,692,0,7l||",
                "Mongolia": "or,5,qo,0,ft,0,7l|or,5,qo,0,ga,0,7l||",
                "Moscow": "693,0,ft,0,7l|693,0,ga,0,7l||",
                "Myanmar": "1qm,0,7l|||",
                "Nauru": "14s,0,7l|||",
                "Nepal": "16d,0,7l|||",
                "New_Caledonia": "2ut,0,15l,0,ft,0,7l|2ut,0,15l,0,ga,0,7l||",
                "New_Zealand": "2ut,0,15h,0,ft,0,7l|2ut,0,15h,0,ga,0,7l||",
                "Newfoundland": "14t,0,ft,0,7l|14t,0,ga,0,7l||",
                "Niue": "1qn,0,7l|||",
                "Norfolk": "146,0,3lp,0,7l|||",
                "Noronha": "141,5,17m,5,132,0,ft,0,7l|141,5,17m,5,132,0,ga,0,7l||",
                "Novosibirsk": "697,0,ft,0,7l|697,0,ga,0,7l||",
                "Omsk": "698,0,ft,0,7l|698,0,ga,0,7l||",
                "Pakistan": "699,0,ft,0,7l|699,0,ga,0,7l||",
                "Palau": "159,0,7l|||",
                "Papua_New_Guinea": "13k,0,kf,0,2ut,0,1m5,0,7l|||",
                "Paraguay": "13p,0,ft,0,7l|13p,0,ga,0,7l||",
                "Peru": "q1,0,ft,0,7l|q1,0,ga,0,7l||",
                "Philippines": "2lj,0,ft,0,7l|2lj,0,ga,0,7l||",
                "Phoenix_Islands": "158,0,1nc,0,7l|||",
                "Pierre_Miquelon": "pr,5,13m,0,2fj,0,qp,0,ft,0,7l|pr,5,13m,0,2fj,0,qp,0,ga,0,7l||",
                "Pitcairn": "24j,0,7l|||",
                "Ponape": "1v2,0,7l|||",
                "Pyongyang": "1u8,0,7l|||",
                "Reunion": "1qo,0,7l|||",
                "Rothera": "157,0,7l|||",
                "Sakhalin": "r8,0,ft,0,7l|r8,0,ga,0,7l||",
                "Samoa": "p0,0,ft,0,7l|p0,0,ga,0,7l||",
                "Seychelles": "9vt,0,7l|||",
                "Singapore": "16b,0,ft,0,7l|||",
                "Solomon": "4lp,0,1nc,0,7l|||",
                "South_Georgia": "679,0,261,0,7l|||",
                "Suriname": "18v,0,7l|||",
                "Syowa": "1pr,0,7l|||",
                "Tahiti": "1ma,0,7l|||",
                "Taipei": "69f,0,ft,0,7l|69f,0,ga,0,7l||",
                "Tajikistan": "9vs,0,7l|||",
                "Tokelau": "156,0,7l|||",
                "Tonga": "ot,0,ft,0,7l|ot,0,ga,0,7l||",
                "Truk": "1f2,0,7l|||",
                "Turkmenistan": "69h,0,ft,0,7l|69h,0,ga,0,7l||",
                "Tuvalu": "14j,0,7l|||",
                "Uruguay": "14a,0,ft,0,7l|14a,0,ga,0,7l||",
                "Uzbekistan": "3mu,0,ft,0,7l|3mu,0,ga,0,7l||",
                "Vanuatu": "os,0,ft,0,7l|os,0,ga,0,7l||",
                "Venezuela": "1mf,0,7l|||",
                "Vladivostok": "qn,0,ft,0,7l|qn,0,ga,0,7l||",
                "Volgograd": "q9,0,ft,0,7l|q9,0,ga,0,7l||",
                "Vostok": "155,0,7l|||",
                "Wake": "1m0,0,67u,0,7l|||",
                "Wallis": "1qq,0,2fj,0,14l,0,7l|||",
                "Yakutsk": "14d,0,ft,0,7l|14d,0,ga,0,7l||",
                "Yekaterinburg": "136,0,ft,0,7l|136,0,ga,0,7l||"
            }
        },
        "kkj": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "kln": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "km": {
            "gmtFormat": "ម៉ោង​សកល {0}",
            "gmtZeroFormat": "ម៉ោង​សកល",
            "zone": {
                "Europe/Dublin": "|cbm||",
                "Europe/London": "|cbn||"
            },
            "metazone": {
                "Afghanistan": "9vr|||",
                "Africa_Central": "9vq|||",
                "Africa_Eastern": "9vp|||",
                "Africa_Southern": "9vo|||",
                "Africa_Western": "9vn|9vm||",
                "Alaska": "9vl|9vk||",
                "Amazon": "9vj|9vi||",
                "America_Central": "9vh|9vg||",
                "America_Eastern": "9vf|9ve||",
                "America_Mountain": "9vd|9vc||",
                "America_Pacific": "9vb|9va||",
                "Apia": "9v9|9v8||",
                "Arabian": "9v7|9v6||",
                "Argentina": "9v5|9v4||",
                "Argentina_Western": "9v3|9v2||",
                "Armenia": "9v1|9v0||",
                "Atlantic": "9uv|9uu||",
                "Australia_Central": "9ut|9us||",
                "Australia_CentralWestern": "9ur|9uq||",
                "Australia_Eastern": "9up|9uo||",
                "Australia_Western": "9un|9um||",
                "Azerbaijan": "9ul|9uk||",
                "Azores": "9uj|9ui||",
                "Bangladesh": "9uh|9ug||",
                "Bhutan": "9uf|||",
                "Bolivia": "9ue|||",
                "Brasilia": "9ud|9uc||",
                "Brunei": "9ub|||",
                "Cape_Verde": "9ua|9u9||",
                "Chamorro": "9u8|||",
                "Chatham": "9u7|9u6||",
                "Chile": "9u5|9u4||",
                "China": "9u3|9u2||",
                "Choibalsan": "9u1|9u0||",
                "Christmas": "9tv|||",
                "Cocos": "9tu|||",
                "Colombia": "9tt|9ts||",
                "Cook": "9tr|9tq||",
                "Cuba": "9tp|9to||",
                "Davis": "9tn|||",
                "DumontDUrville": "9tm|||",
                "East_Timor": "9tl|||",
                "Easter": "9tk|9tj||",
                "Ecuador": "9ti|||",
                "Europe_Central": "9th|9tg||",
                "Europe_Eastern": "9tf|9te||",
                "Europe_Further_Eastern": "9td|||",
                "Europe_Western": "9tc|9tb||",
                "Falkland": "9ta|9t9||",
                "Fiji": "9t8|9t7||",
                "French_Guiana": "9t6|||",
                "French_Southern": "9t5,0,9t4|||",
                "Galapagos": "9t3|||",
                "Gambier": "9t2|||",
                "Georgia": "9t1|9t0||",
                "Gilbert_Islands": "9sv|||",
                "GMT": "9su|||",
                "Greenland_Eastern": "9st|9ss||",
                "Greenland_Western": "9sr|9sq||",
                "Gulf": "9sp|||",
                "Guyana": "9so|||",
                "Hawaii_Aleutian": "9sn,5,6co|9sm,5,6co||",
                "Hong_Kong": "9sl|9sk||",
                "Hovd": "9sj|9si||",
                "India": "9sh|||",
                "Indian_Ocean": "9sg|||",
                "Indochina": "9sf|||",
                "Indonesia_Central": "9se|||",
                "Indonesia_Eastern": "9sd|||",
                "Indonesia_Western": "9sc|||",
                "Iran": "9sb|9sa||",
                "Irkutsk": "9s9|9s8||",
                "Israel": "9s7|9s6||",
                "Japan": "9s5|9s4||",
                "Kazakhstan_Eastern": "9s3|||",
                "Kazakhstan_Western": "9s2|||",
                "Korea": "9s1|9s0||",
                "Kosrae": "9rv|||",
                "Krasnoyarsk": "9ru|9rt||",
                "Kyrgystan": "9rs|||",
                "Line_Islands": "9rr|||",
                "Lord_Howe": "9rq|9rp||",
                "Macquarie": "9ro|||",
                "Magadan": "9rn|9rm||",
                "Malaysia": "9rl|||",
                "Maldives": "9rk|||",
                "Marquesas": "9rj|||",
                "Marshall_Islands": "9ri|||",
                "Mauritius": "9rh|9rg||",
                "Mawson": "9rf|||",
                "Mexico_Northwest": "9re|9rd||",
                "Mexico_Pacific": "9rc|9rb||",
                "Mongolia": "9ra|9r9||",
                "Moscow": "9r8|9r7,0,6e9||",
                "Myanmar": "9r6|||",
                "Nauru": "9r5|||",
                "Nepal": "9r4|||",
                "New_Caledonia": "9r3|9r2,0,6e9||",
                "New_Zealand": "9r1|9r0||",
                "Newfoundland": "9qv|9qu||",
                "Niue": "9qt|||",
                "Norfolk": "9qs|||",
                "Noronha": "9qr|9qq||",
                "Novosibirsk": "9qp|9qo||",
                "Omsk": "9qn|9qm||",
                "Pakistan": "9ql|9qk||",
                "Palau": "9qj|||",
                "Papua_New_Guinea": "9qi|||",
                "Paraguay": "9qh|9qg||",
                "Peru": "9qf|9qe||",
                "Philippines": "9qd|9qc||",
                "Phoenix_Islands": "9qb|||",
                "Pierre_Miquelon": "9qa,0,6f7|9q9,0,6f7||",
                "Pitcairn": "9q8|||",
                "Ponape": "9q7|||",
                "Pyongyang": "9q6|||",
                "Reunion": "9q5|||",
                "Rothera": "9q4|||",
                "Sakhalin": "9q3|9q2||",
                "Samoa": "9q1|9q0||",
                "Seychelles": "9pv|||",
                "Singapore": "9pu|||",
                "Solomon": "9pt|||",
                "South_Georgia": "9ps|||",
                "Suriname": "9pr|||",
                "Syowa": "9pq|||",
                "Tahiti": "9pp|||",
                "Taipei": "9po|9pn||",
                "Tajikistan": "9pm|||",
                "Tokelau": "9pl|||",
                "Tonga": "9pk|9pj||",
                "Truk": "9pi|||",
                "Turkmenistan": "9ph|9pg||",
                "Tuvalu": "9pf|||",
                "Uruguay": "9pe|9pd||",
                "Uzbekistan": "9pc|9pb||",
                "Vanuatu": "9pa|9p9||",
                "Venezuela": "9p8|||",
                "Vladivostok": "9p7|9p6||",
                "Volgograd": "9p5|9p4||",
                "Vostok": "9p3|||",
                "Wake": "9p2|||",
                "Wallis": "9p1,0,9p0|||",
                "Yakutsk": "9ov|9ou||",
                "Yekaterinburg": "9ot|9os||"
            }
        },
        "kn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cbo,0,en,0,78||",
                "Europe/London": "|cbp,0,ma,0,78||"
            },
            "metazone": {
                "Afghanistan": "9or,0,78|||",
                "Africa_Central": "3u1,0,315,0,78|||",
                "Africa_Eastern": "1kn,0,315,0,78|||",
                "Africa_Southern": "4j9,0,315,0,en,0,78|||",
                "Africa_Western": "1dp,0,315,0,en,0,78|1dp,0,315,0,ma,0,78||",
                "Alaska": "9oq,0,en,0,78|9op,0,153,0,78||",
                "Amazon": "6h2,0,en,0,78|6h2,0,ma,0,78||",
                "America_Central": "1t5,0,1t6,0,30p,0,en,0,78|1t5,0,1t6,0,9oo,0,29h,0,78||",
                "America_Eastern": "1t5,0,1t6,0,6h8,0,en,0,78|1t5,0,1t6,0,6h8,0,29h,0,78||",
                "America_Mountain": "1t5,0,1t6,0,6h9,0,en,0,78|1t5,0,1t6,0,6h9,0,29h,0,78||",
                "America_Pacific": "1t5,0,1t6,0,3ug,0,en,0,78|1t5,0,1t6,0,3ug,0,29h,0,78||",
                "Anadyr": "6hb,0,en,0,78|6hb,0,153,0,78||",
                "Apia": "6hc,0,en,0,78|6hc,0,153,0,78||",
                "Arabian": "6hd,0,en,0,78|6hd,0,153,0,78||",
                "Argentina": "4j8,0,en,0,78|9on,0,ma,0,78||",
                "Argentina_Western": "1dp,0,4j8,0,en,0,78|1dp,0,4j8,0,ma,0,78||",
                "Armenia": "6hg,0,en,0,78|6hg,0,ma,0,78||",
                "Atlantic": "6hh,0,en,0,78|6hh,0,29h,0,78||",
                "Australia_Central": "1t9,0,30p,0,en,0,78|1t9,0,30p,0,153,0,78||",
                "Australia_CentralWestern": "1t9,0,30p,0,1dp,0,en,0,78|1t9,0,30p,0,1dp,0,153,0,78||",
                "Australia_Eastern": "1t9,0,1kn,0,en,0,78|1kn,0,1t9,0,153,0,78||",
                "Australia_Western": "1t9,0,1dp,0,en,0,78|1t9,0,1dp,0,153,0,78||",
                "Azerbaijan": "6hj,0,en,0,78|6hj,0,ma,0,78||",
                "Azores": "6hk,0,en,0,78|6hk,0,ma,0,78||",
                "Bangladesh": "6hl,0,en,0,78|6hl,0,ma,0,78||",
                "Bhutan": "9om,0,78|||",
                "Bolivia": "9ol,0,78|||",
                "Brasilia": "6ho,0,en,0,78|6ho,0,ma,0,78||",
                "Brunei": "9ok,0,9oj,0,78|||",
                "Cape_Verde": "6hr,0,6hs,0,en,0,78|6hr,0,6hs,0,ma,0,78||",
                "Chamorro": "9oi,0,en,0,78|||",
                "Chatham": "6hu,0,en,0,78|6hu,0,153,0,78||",
                "Chile": "6hv,0,en,0,78|6hv,0,ma,0,78||",
                "China": "6i0,0,en,0,78|6i0,0,153,0,78||",
                "Choibalsan": "9oh,0,en,0,78|9og,0,ma,0,78||",
                "Christmas": "9of,0,2gh,0,78|||",
                "Cocos": "9oe,0,1og,0,78|||",
                "Colombia": "6i7,0,en,0,78|6i7,0,ma,0,78||",
                "Cook": "6i8,0,1og,0,en,0,78|6i8,0,1og,0,9od,0,ma,0,78||",
                "Cuba": "6ia,0,en,0,78|6ia,0,29h,0,78||",
                "Davis": "9oc,0,78|||",
                "DumontDUrville": "9ob,5,9oa,0,9o9,0,78|||",
                "East_Timor": "1kn,0,9o8,0,78|||",
                "Easter": "6ig,0,2gh,0,en,0,78|6ig,0,2gh,0,ma,0,78||",
                "Ecuador": "9o7,0,78|||",
                "Europe_Central": "3u1,0,29c,0,en,0,78|3u1,0,29c,0,ma,0,78||",
                "Europe_Eastern": "1kn,0,29c,0,en,0,78|1kn,0,29c,0,ma,0,78||",
                "Europe_Further_Eastern": "9o6,5,1kn,0,29c,0,78|||",
                "Europe_Western": "1dp,0,29c,0,en,0,78|1dp,0,29c,0,ma,0,78||",
                "Falkland": "6ik,0,1og,0,en,0,78|6ik,0,1og,0,ma,0,78||",
                "Fiji": "6il,0,en,0,78|6il,0,ma,0,78||",
                "French_Guiana": "6im,0,6in,0,78|||",
                "French_Southern": "4j9,0,6im,0,3v8,0,9o5,0,78|||",
                "Galapagos": "9o4,0,78|||",
                "Gambier": "9o3,0,78|||",
                "Georgia": "4j5,0,en,0,78|4j5,0,ma,0,78||",
                "Gilbert_Islands": "9o2,0,1og,0,78|||",
                "GMT": "9o1,0,9o0,0,9nv|||",
                "Greenland_Eastern": "1kn,0,3vh,0,en,0,78|1kn,0,3vh,0,ma,0,78||",
                "Greenland_Western": "1dp,0,3vh,0,en,0,78|1dp,0,3vh,0,ma,0,78||",
                "Gulf": "9nu,0,en,0,78|||",
                "Guyana": "6in,0,78|||",
                "Hawaii_Aleutian": "6j3,5,6j4,0,en,0,78|6j3,5,6j4,0,153,0,78||",
                "Hong_Kong": "6j5,0,6j6,0,en,0,78|6j5,0,6j6,0,ma,0,78||",
                "Hovd": "6j7,0,en,0,78|6j7,0,ma,0,78||",
                "India": "9nt,0,en,0,78||15a|",
                "Indian_Ocean": "9ns,0,9nr,0,78|||",
                "Indochina": "9nq,0,78|||",
                "Indonesia_Central": "3u1,0,6jc,0,78|||",
                "Indonesia_Eastern": "1kn,0,6jc,0,78|||",
                "Indonesia_Western": "1dp,0,9np,0,78|||",
                "Iran": "6je,0,en,0,78|6je,0,153,0,78||",
                "Irkutsk": "6jf,0,en,0,78|6jf,0,ma,0,78||",
                "Israel": "6jg,0,en,0,78|6jg,0,153,0,78||",
                "Japan": "6jh,0,en,0,78|6jh,0,153,0,78||",
                "Kamchatka": "6ji,5,6jj,0,en,0,78|6ji,5,6jj,0,ma,0,78||",
                "Kazakhstan_Eastern": "1kn,0,6jk,0,78|||",
                "Kazakhstan_Western": "1dp,0,6jk,0,78|||",
                "Korea": "6jl,0,en,0,78|6jl,0,153,0,78||",
                "Kosrae": "9no,0,78|||",
                "Krasnoyarsk": "6jn,0,en,0,78|6jn,0,ma,0,78||",
                "Kyrgystan": "9nn,0,78|||",
                "Line_Islands": "9nm,0,1og,0,78|||",
                "Lord_Howe": "6jq,0,6jr,0,en,0,78|6jq,0,6jr,0,9nl,0,78||",
                "Macquarie": "9nk,0,2gh,0,78|||",
                "Magadan": "6ju,0,en,0,78|6ju,0,ma,0,78||",
                "Malaysia": "9nj,0,78|||",
                "Maldives": "9ni,0,78|||",
                "Marquesas": "9ng,0,78|||",
                "Marshall_Islands": "9nf,0,1og,0,78|||",
                "Mauritius": "6k3,0,en,0,78|6k3,0,ma,0,78||",
                "Mawson": "9ne,0,78|||",
                "Mexico_Northwest": "6k5,0,6k6,0,en,0,78|6k5,0,6k6,0,153,0,78||",
                "Mexico_Pacific": "6k7,0,3ug,0,en,0,78|6k7,0,3ug,0,153,0,78||",
                "Mongolia": "6k8,0,6k9,0,en,0,78|6k8,0,6k9,0,ma,0,78||",
                "Moscow": "6ka,0,en,0,78|6ka,0,ma,0,78||",
                "Myanmar": "9nd,0,78|||",
                "Nauru": "9nc,0,78|||",
                "Nepal": "9na,0,78|||",
                "New_Caledonia": "6ke,0,6kf,0,en,0,78|6ke,0,6kf,0,9n9,0,78||",
                "New_Zealand": "6kh,0,en,0,78|6kh,0,153,0,78||",
                "Newfoundland": "6ki,0,en,0,78|6ki,0,29h,0,78||",
                "Niue": "9n8,0,78|||",
                "Norfolk": "9n5,0,2gh,0,78|||",
                "Noronha": "9n0,0,9mv,0,6kn,0,en,0,78|9mu,0,9mp,0,6kn,0,ma,0,78||",
                "Novosibirsk": "6kq,0,en,0,78|6kq,0,ma,0,78||",
                "Omsk": "6kr,0,en,0,78|6kr,0,ma,0,78||",
                "Pakistan": "6ks,0,en,0,78|6ks,0,ma,0,78||",
                "Palau": "9mo,0,78|||",
                "Papua_New_Guinea": "9ml,0,9mk,0,9mh,0,78|||",
                "Paraguay": "6l1,0,en,0,78|6l1,0,ma,0,78||",
                "Peru": "6l2,0,en,0,78|6l2,0,ma,0,78||",
                "Philippines": "6l3,0,en,0,78|6l3,0,ma,0,78||",
                "Phoenix_Islands": "9mg,0,1og,0,78|||",
                "Pierre_Miquelon": "6l5,0,6l6,0,3v8,0,6l7,0,en,0,78|6l5,0,6l6,0,3v8,0,6l7,0,153,0,78||",
                "Pitcairn": "9mf,0,78|||",
                "Ponape": "9mc,0,78|||",
                "Pyongyang": "9mb,0,78|||",
                "Reunion": "9ma,0,78|||",
                "Rothera": "9m9,0,78|||",
                "Sakhalin": "6ld,0,en,0,78|6ld,0,ma,0,78||",
                "Samara": "6le,0,en,0,78|6le,0,ma,0,78||",
                "Samoa": "6lf,0,en,0,78|6lf,0,ma,0,78||",
                "Seychelles": "9m8,0,78|||",
                "Singapore": "9m7,0,en,0,78|||",
                "Solomon": "9ls,0,1og,0,78|||",
                "South_Georgia": "4j9,0,4j5,0,78|||",
                "Suriname": "9lr,0,78|||",
                "Syowa": "9lq,0,78|||",
                "Tahiti": "9lp,0,78|||",
                "Taipei": "6lm,0,en,0,78|6lm,0,153,0,78||",
                "Tajikistan": "9ln,0,78|||",
                "Tokelau": "9lj,0,78|||",
                "Tonga": "6lp,0,en,0,78|6lp,0,ma,0,78||",
                "Truk": "9li,0,78|||",
                "Turkmenistan": "6lr,0,en,0,78|6lr,0,ma,0,78||",
                "Tuvalu": "9lh,0,78|||",
                "Uruguay": "6lt,0,en,0,78|6lt,0,ma,0,78||",
                "Uzbekistan": "6lu,0,en,0,78|6lu,0,ma,0,78||",
                "Vanuatu": "6lv,0,en,0,78|6lv,0,ma,0,78||",
                "Venezuela": "9le,0,78|||",
                "Vladivostok": "6m1,0,en,0,78|6m1,0,ma,0,78||",
                "Volgograd": "6m2,0,en,0,78|6m2,0,ma,0,78||",
                "Vostok": "9ld,0,78|||",
                "Wake": "9l9,0,2gh,0,78|||",
                "Wallis": "9l6,0,3v8,0,9l3,0,78|||",
                "Yakutsk": "6m7,0,en,0,78|6m7,0,ma,0,78||",
                "Yekaterinburg": "9l1,0,en,0,78|9l0,0,ma,0,78||"
            }
        },
        "ko-KP": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|61v,0,3s||",
                "Europe/London": "|60p,0,94,0,3s||"
            },
            "metazone": {
                "Acre": "402,0,3s|402,0,94,0,3s||",
                "Afghanistan": "6md,0,b1|||",
                "Africa_Central": "6mf,0,b1|||",
                "Africa_Eastern": "6mg,0,b1|||",
                "Africa_Southern": "6mh,0,b1|||",
                "Africa_Western": "406,0,3s|406,0,94,0,3s||",
                "Alaska": "407,0,3s|407,0,94,0,3s||",
                "Almaty": "408,0,1nh,0,3s|408,0,94,0,3s||",
                "Amazon": "40a,0,3s|40a,0,94,0,3s||",
                "America_Central": "15p,0,1e8,0,3s|15p,0,1e8,0,94,0,3s||",
                "America_Eastern": "15p,0,16p,0,3s|15p,0,16p,0,94,0,3s||",
                "America_Mountain": "15p,0,6mq,0,3s|15p,0,6mr,0,94,0,3s||",
                "America_Pacific": "15p,0,1ua,0,3s|15p,0,1ua,0,94,0,3s||",
                "Anadyr": "40f,0,3s|40f,0,94,0,3s||",
                "Apia": "40g,0,3s|40g,0,94,0,3s||",
                "Aqtau": "40h,0,1nh,0,3s|40h,0,94,0,3s||",
                "Aqtobe": "40i,0,1nh,0,3s|40i,0,94,0,3s||",
                "Arabian": "40j,0,3s|40j,0,94,0,3s||",
                "Argentina": "1ub,0,3s|1ub,0,94,0,3s||",
                "Argentina_Western": "1ub,0,17q,0,3s|1ub,0,17q,0,94,0,3s||",
                "Armenia": "40m,0,3s|40m,0,94,0,3s||",
                "Atlantic": "40n,0,3s|15p,0,40n,0,94,0,3s||",
                "Australia_Central": "189,0,1e8,0,3s|189,0,1e8,0,94,0,3s||",
                "Australia_CentralWestern": "189,0,40p,0,3s|189,0,40p,0,94,0,3s||",
                "Australia_Eastern": "189,0,16p,0,3s|189,0,16p,0,94,0,3s||",
                "Australia_Western": "189,0,17q,0,3s|189,0,17q,0,94,0,3s||",
                "Azerbaijan": "40q,0,3s|40q,0,94,0,3s||",
                "Azores": "40r,0,3s|40r,0,94,0,3s||",
                "Bangladesh": "40s,0,3s|40s,0,94,0,3s||",
                "Bhutan": "6nb,0,b1|||",
                "Bolivia": "6nc,0,b1|||",
                "Brasilia": "40t,0,3s|40t,0,94,0,3s||",
                "Brunei": "6ne,0,b1|||",
                "Cape_Verde": "40u,0,40v,0,3s|40u,0,40v,0,94,0,3s||",
                "Casey": "6nh,0,b1|||",
                "Chamorro": "6ni,0,b1|||",
                "Chatham": "410,0,3s|410,0,94,0,3s||",
                "Chile": "411,0,3s|411,0,94,0,3s||",
                "China": "412,0,3s|412,0,94,0,3s||",
                "Choibalsan": "413,0,3s|413,0,94,0,3s||",
                "Christmas": "6nn,0,b1|||",
                "Cocos": "6no,0,11o,0,b1|||",
                "Colombia": "415,0,3s|415,0,94,0,3s||",
                "Cook": "416,0,11o,0,3s|416,0,11o,0,6ns,0,94,0,3s||",
                "Cuba": "417,0,3s|417,0,94,0,3s||",
                "Davis": "6nu,0,b1|||",
                "DumontDUrville": "6nv,0,b1|||",
                "East_Timor": "6o0,0,b1|||",
                "Easter": "418,0,3s|418,0,94,0,3s||",
                "Ecuador": "6o2,0,b1|||",
                "Europe_Central": "1e8,0,2fb,0,3s|1e8,0,2fb,0,94,0,3s||",
                "Europe_Eastern": "41a,0,3s|41a,0,94,0,3s||",
                "Europe_Further_Eastern": "6o5,0,2fb,0,3s|||",
                "Europe_Western": "41b,0,3s|41b,0,94,0,3s||",
                "Falkland": "41c,0,11o,0,3s|41c,0,11o,0,94,0,3s||",
                "Fiji": "41d,0,3s|41d,0,94,0,3s||",
                "French_Guiana": "41e,0,41f,0,b1|||",
                "French_Southern": "41e,0,6ob,0,6oc,0,6od,0,6oe,0,b1|||",
                "Galapagos": "6of,0,b1|||",
                "Gambier": "6og,0,b1|||",
                "Georgia": "41g,0,3s|41g,0,94,0,3s||",
                "Gilbert_Islands": "6oi,0,11o,0,b1|||",
                "GMT": "6oj,0,3s|||",
                "Greenland_Eastern": "1ui,0,16p,0,3s|1ui,0,16p,0,94,0,3s||",
                "Greenland_Western": "1ui,0,17q,0,3s|1ui,0,17q,0,94,0,3s||",
                "Gulf": "6ol,0,3s|||",
                "Guyana": "41f,0,b1|||",
                "Hawaii_Aleutian": "41i,0,41j,0,3s|41i,0,41j,0,94,0,3s||",
                "Hong_Kong": "41k,0,3s|41k,0,94,0,3s||",
                "Hovd": "41l,0,3s|41l,0,94,0,3s||",
                "India": "6oq,0,3s|||",
                "Indian_Ocean": "6or,0,b1|||",
                "Indochina": "6os,0,b1|||",
                "Indonesia_Central": "1e8,0,2f9,0,b1|||",
                "Indonesia_Eastern": "16p,0,2f9,0,b1|||",
                "Indonesia_Western": "17q,0,2f9,0,b1|||",
                "Iran": "41n,0,3s|41n,0,94,0,3s||",
                "Irkutsk": "41o,0,3s|41o,0,94,0,3s||",
                "Israel": "41p,0,3s|41p,0,94,0,3s||",
                "Japan": "41q,0,3s|41q,0,94,0,3s||",
                "Kamchatka": "41r,5,41s,0,3s|41r,5,41s,0,94,0,3s||",
                "Kazakhstan_Eastern": "16p,0,41t,0,b1|||",
                "Kazakhstan_Western": "17q,0,41t,0,b1|||",
                "Korea": "6p5,0,3s|6p5,0,94,0,3s||",
                "Kosrae": "6p6,0,b1|||",
                "Krasnoyarsk": "41u,0,3s|41u,0,94,0,3s||",
                "Kyrgystan": "6p8,0,b1|||",
                "Line_Islands": "6p9,0,11o,0,b1|||",
                "Lord_Howe": "41v,0,420,0,3s|41v,0,420,0,94,0,3s||",
                "Macau": "421,0,1nh,0,b1|421,0,94,0,3s||",
                "Macquarie": "6pd,0,b1|||",
                "Magadan": "422,0,3s|422,0,94,0,3s||",
                "Malaysia": "6pf,0,b1|||",
                "Maldives": "6pg,0,b1|||",
                "Marquesas": "6ph,0,11o,0,b1|||",
                "Marshall_Islands": "6pi,0,11o,0,b1|||",
                "Mauritius": "423,0,3s|423,0,94,0,3s||",
                "Mawson": "6pk,0,b1|||",
                "Mexico_Northwest": "1ul,0,425,0,3s|1ul,0,425,0,94,0,3s||",
                "Mexico_Pacific": "1ul,0,1ua,0,3s|1ul,0,1ua,0,94,0,3s||",
                "Mongolia": "426,0,3s|426,0,94,0,3s||",
                "Moscow": "427,0,3s|427,0,94,0,3s||",
                "Myanmar": "6pp,0,b1|||",
                "Nauru": "6pq,0,b1|||",
                "Nepal": "6pr,0,b1|||",
                "New_Caledonia": "428,0,3s|428,0,94,0,3s||",
                "New_Zealand": "429,0,3s|429,0,94,0,3s||",
                "Newfoundland": "42a,0,3s|42a,0,94,0,3s||",
                "Niue": "6pv,0,b1|||",
                "Norfolk": "6q0,0,b1|||",
                "Noronha": "42b,0,42c,0,42d,0,3s|42b,0,42c,0,42d,0,94,0,3s||",
                "Novosibirsk": "42e,0,3s|42e,0,94,0,3s||",
                "Omsk": "42f,0,3s|42f,0,94,0,3s||",
                "Pakistan": "42g,0,3s|42g,0,94,0,3s||",
                "Palau": "6q7,0,b1|||",
                "Papua_New_Guinea": "6q8,0,b1|||",
                "Paraguay": "42h,0,3s|42h,0,94,0,3s||",
                "Peru": "42i,0,3s|42i,0,94,0,3s||",
                "Philippines": "42j,0,3s|42j,0,94,0,3s||",
                "Phoenix_Islands": "6qc,0,11o,0,b1|||",
                "Pierre_Miquelon": "42k,0,42l,0,3s|42k,0,42l,0,94,0,3s||",
                "Pitcairn": "6qf,0,b1|||",
                "Ponape": "6qg,0,b1|||",
                "Pyongyang": "6qh,0,b1|||",
                "Qyzylorda": "42m,0,1nh,0,b1|42m,0,94,0,3s||",
                "Reunion": "6qj,0,b1|||",
                "Rothera": "6qk,0,b1|||",
                "Sakhalin": "42n,0,3s|42n,0,94,0,3s||",
                "Samara": "42o,0,3s|42o,0,94,0,3s||",
                "Samoa": "42p,0,3s|42p,0,94,0,3s||",
                "Seychelles": "6qo,0,b1|||",
                "Singapore": "6qp,0,3s|||",
                "Solomon": "6qq,0,11o,0,b1|||",
                "South_Georgia": "6qr,0,6qs,0,b1|||",
                "Suriname": "6qt,0,b1|||",
                "Syowa": "6qu,0,b1|||",
                "Tahiti": "6qv,0,b1|||",
                "Taipei": "42q,0,3s|42q,0,94,0,3s||",
                "Tajikistan": "6r1,0,b1|||",
                "Tokelau": "6r2,0,b1|||",
                "Tonga": "42r,0,3s|42r,0,94,0,3s||",
                "Truk": "6r4,0,b1|||",
                "Turkmenistan": "42s,0,3s|42s,0,94,0,3s||",
                "Tuvalu": "6r6,0,b1|||",
                "Uruguay": "42t,0,3s|42t,0,94,0,3s||",
                "Uzbekistan": "42u,0,3s|42u,0,94,0,3s||",
                "Vanuatu": "42v,0,3s|42v,0,94,0,3s||",
                "Venezuela": "6ra,0,b1|||",
                "Vladivostok": "430,0,3s|430,0,94,0,3s||",
                "Volgograd": "431,0,3s|431,0,94,0,3s||",
                "Vostok": "6rd,0,b1|||",
                "Wake": "6re,0,b1|||",
                "Wallis": "6rf,0,11o,0,b1|||",
                "Yakutsk": "432,0,3s|432,0,94,0,3s||",
                "Yekaterinburg": "433,0,3s|433,0,94,0,3s||"
            }
        },
        "ko": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|61v,0,3s||",
                "Europe/London": "|60p,0,94,0,3s||"
            },
            "metazone": {
                "Acre": "402,0,3s|402,0,94,0,3s||",
                "Afghanistan": "6md,0,b1|||",
                "Africa_Central": "6mf,0,b1|||",
                "Africa_Eastern": "6mg,0,b1|||",
                "Africa_Southern": "6mh,0,b1|||",
                "Africa_Western": "406,0,3s|406,0,94,0,3s||",
                "Alaska": "407,0,3s|407,0,94,0,3s||",
                "Almaty": "408,0,1nh,0,3s|408,0,94,0,3s||",
                "Amazon": "40a,0,3s|40a,0,94,0,3s||",
                "America_Central": "15p,0,1e8,0,3s|15p,0,1e8,0,94,0,3s||",
                "America_Eastern": "15p,0,16p,0,3s|15p,0,16p,0,94,0,3s||",
                "America_Mountain": "15p,0,6mq,0,3s|15p,0,6mr,0,94,0,3s||",
                "America_Pacific": "15p,0,1ua,0,3s|15p,0,1ua,0,94,0,3s||",
                "Anadyr": "40f,0,3s|40f,0,94,0,3s||",
                "Apia": "40g,0,3s|40g,0,94,0,3s||",
                "Aqtau": "40h,0,1nh,0,3s|40h,0,94,0,3s||",
                "Aqtobe": "40i,0,1nh,0,3s|40i,0,94,0,3s||",
                "Arabian": "40j,0,3s|40j,0,94,0,3s||",
                "Argentina": "1ub,0,3s|1ub,0,94,0,3s||",
                "Argentina_Western": "1ub,0,17q,0,3s|1ub,0,17q,0,94,0,3s||",
                "Armenia": "40m,0,3s|40m,0,94,0,3s||",
                "Atlantic": "40n,0,3s|15p,0,40n,0,94,0,3s||",
                "Australia_Central": "189,0,1e8,0,3s|189,0,1e8,0,94,0,3s||",
                "Australia_CentralWestern": "189,0,40p,0,3s|189,0,40p,0,94,0,3s||",
                "Australia_Eastern": "189,0,16p,0,3s|189,0,16p,0,94,0,3s||",
                "Australia_Western": "189,0,17q,0,3s|189,0,17q,0,94,0,3s||",
                "Azerbaijan": "40q,0,3s|40q,0,94,0,3s||",
                "Azores": "40r,0,3s|40r,0,94,0,3s||",
                "Bangladesh": "40s,0,3s|40s,0,94,0,3s||",
                "Bhutan": "6nb,0,b1|||",
                "Bolivia": "6nc,0,b1|||",
                "Brasilia": "40t,0,3s|40t,0,94,0,3s||",
                "Brunei": "6ne,0,b1|||",
                "Cape_Verde": "40u,0,40v,0,3s|40u,0,40v,0,94,0,3s||",
                "Casey": "6nh,0,b1|||",
                "Chamorro": "6ni,0,b1|||",
                "Chatham": "410,0,3s|410,0,94,0,3s||",
                "Chile": "411,0,3s|411,0,94,0,3s||",
                "China": "412,0,3s|412,0,94,0,3s||",
                "Choibalsan": "413,0,3s|413,0,94,0,3s||",
                "Christmas": "6nn,0,b1|||",
                "Cocos": "6no,0,11o,0,b1|||",
                "Colombia": "415,0,3s|415,0,94,0,3s||",
                "Cook": "416,0,11o,0,3s|416,0,11o,0,6ns,0,94,0,3s||",
                "Cuba": "417,0,3s|417,0,94,0,3s||",
                "Davis": "6nu,0,b1|||",
                "DumontDUrville": "6nv,0,b1|||",
                "East_Timor": "6o0,0,b1|||",
                "Easter": "418,0,3s|418,0,94,0,3s||",
                "Ecuador": "6o2,0,b1|||",
                "Europe_Central": "1e8,0,2fb,0,3s|1e8,0,2fb,0,94,0,3s||",
                "Europe_Eastern": "41a,0,3s|41a,0,94,0,3s||",
                "Europe_Further_Eastern": "6o5,0,2fb,0,3s|||",
                "Europe_Western": "41b,0,3s|41b,0,94,0,3s||",
                "Falkland": "41c,0,11o,0,3s|41c,0,11o,0,94,0,3s||",
                "Fiji": "41d,0,3s|41d,0,94,0,3s||",
                "French_Guiana": "41e,0,41f,0,b1|||",
                "French_Southern": "41e,0,6ob,0,6oc,0,6od,0,6oe,0,b1|||",
                "Galapagos": "6of,0,b1|||",
                "Gambier": "6og,0,b1|||",
                "Georgia": "41g,0,3s|41g,0,94,0,3s||",
                "Gilbert_Islands": "6oi,0,11o,0,b1|||",
                "GMT": "6oj,0,3s|||",
                "Greenland_Eastern": "1ui,0,16p,0,3s|1ui,0,16p,0,94,0,3s||",
                "Greenland_Western": "1ui,0,17q,0,3s|1ui,0,17q,0,94,0,3s||",
                "Gulf": "6ol,0,3s|||",
                "Guyana": "41f,0,b1|||",
                "Hawaii_Aleutian": "41i,0,41j,0,3s|41i,0,41j,0,94,0,3s||",
                "Hong_Kong": "41k,0,3s|41k,0,94,0,3s||",
                "Hovd": "41l,0,3s|41l,0,94,0,3s||",
                "India": "6oq,0,3s|||",
                "Indian_Ocean": "6or,0,b1|||",
                "Indochina": "6os,0,b1|||",
                "Indonesia_Central": "1e8,0,2f9,0,b1|||",
                "Indonesia_Eastern": "16p,0,2f9,0,b1|||",
                "Indonesia_Western": "17q,0,2f9,0,b1|||",
                "Iran": "41n,0,3s|41n,0,94,0,3s||",
                "Irkutsk": "41o,0,3s|41o,0,94,0,3s||",
                "Israel": "41p,0,3s|41p,0,94,0,3s||",
                "Japan": "41q,0,3s|41q,0,94,0,3s||",
                "Kamchatka": "41r,5,41s,0,3s|41r,5,41s,0,94,0,3s||",
                "Kazakhstan_Eastern": "16p,0,41t,0,b1|||",
                "Kazakhstan_Western": "17q,0,41t,0,b1|||",
                "Korea": "6ri,0,3s|6ri,0,94,0,3s||",
                "Kosrae": "6p6,0,b1|||",
                "Krasnoyarsk": "41u,0,3s|41u,0,94,0,3s||",
                "Kyrgystan": "6p8,0,b1|||",
                "Line_Islands": "6p9,0,11o,0,b1|||",
                "Lord_Howe": "41v,0,420,0,3s|41v,0,420,0,94,0,3s||",
                "Macau": "421,0,1nh,0,b1|421,0,94,0,3s||",
                "Macquarie": "6pd,0,b1|||",
                "Magadan": "422,0,3s|422,0,94,0,3s||",
                "Malaysia": "6pf,0,b1|||",
                "Maldives": "6pg,0,b1|||",
                "Marquesas": "6ph,0,11o,0,b1|||",
                "Marshall_Islands": "6pi,0,11o,0,b1|||",
                "Mauritius": "423,0,3s|423,0,94,0,3s||",
                "Mawson": "6pk,0,b1|||",
                "Mexico_Northwest": "1ul,0,425,0,3s|1ul,0,425,0,94,0,3s||",
                "Mexico_Pacific": "1ul,0,1ua,0,3s|1ul,0,1ua,0,94,0,3s||",
                "Mongolia": "426,0,3s|426,0,94,0,3s||",
                "Moscow": "427,0,3s|427,0,94,0,3s||",
                "Myanmar": "6pp,0,b1|||",
                "Nauru": "6pq,0,b1|||",
                "Nepal": "6pr,0,b1|||",
                "New_Caledonia": "428,0,3s|428,0,94,0,3s||",
                "New_Zealand": "429,0,3s|429,0,94,0,3s||",
                "Newfoundland": "42a,0,3s|42a,0,94,0,3s||",
                "Niue": "6pv,0,b1|||",
                "Norfolk": "6q0,0,b1|||",
                "Noronha": "42b,0,42c,0,42d,0,3s|42b,0,42c,0,42d,0,94,0,3s||",
                "Novosibirsk": "42e,0,3s|42e,0,94,0,3s||",
                "Omsk": "42f,0,3s|42f,0,94,0,3s||",
                "Pakistan": "42g,0,3s|42g,0,94,0,3s||",
                "Palau": "6q7,0,b1|||",
                "Papua_New_Guinea": "6q8,0,b1|||",
                "Paraguay": "42h,0,3s|42h,0,94,0,3s||",
                "Peru": "42i,0,3s|42i,0,94,0,3s||",
                "Philippines": "42j,0,3s|42j,0,94,0,3s||",
                "Phoenix_Islands": "6qc,0,11o,0,b1|||",
                "Pierre_Miquelon": "42k,0,42l,0,3s|42k,0,42l,0,94,0,3s||",
                "Pitcairn": "6qf,0,b1|||",
                "Ponape": "6qg,0,b1|||",
                "Pyongyang": "6qh,0,b1|||",
                "Qyzylorda": "42m,0,1nh,0,b1|42m,0,94,0,3s||",
                "Reunion": "6qj,0,b1|||",
                "Rothera": "6qk,0,b1|||",
                "Sakhalin": "42n,0,3s|42n,0,94,0,3s||",
                "Samara": "42o,0,3s|42o,0,94,0,3s||",
                "Samoa": "42p,0,3s|42p,0,94,0,3s||",
                "Seychelles": "6qo,0,b1|||",
                "Singapore": "6qp,0,3s|||",
                "Solomon": "6qq,0,11o,0,b1|||",
                "South_Georgia": "6qr,0,6qs,0,b1|||",
                "Suriname": "6qt,0,b1|||",
                "Syowa": "6qu,0,b1|||",
                "Tahiti": "6qv,0,b1|||",
                "Taipei": "42q,0,3s|42q,0,94,0,3s||",
                "Tajikistan": "6r1,0,b1|||",
                "Tokelau": "6r2,0,b1|||",
                "Tonga": "42r,0,3s|42r,0,94,0,3s||",
                "Truk": "6r4,0,b1|||",
                "Turkmenistan": "42s,0,3s|42s,0,94,0,3s||",
                "Tuvalu": "6r6,0,b1|||",
                "Uruguay": "42t,0,3s|42t,0,94,0,3s||",
                "Uzbekistan": "42u,0,3s|42u,0,94,0,3s||",
                "Vanuatu": "42v,0,3s|42v,0,94,0,3s||",
                "Venezuela": "6ra,0,b1|||",
                "Vladivostok": "430,0,3s|430,0,94,0,3s||",
                "Volgograd": "431,0,3s|431,0,94,0,3s||",
                "Vostok": "6rd,0,b1|||",
                "Wake": "6re,0,b1|||",
                "Wallis": "6rf,0,11o,0,b1|||",
                "Yakutsk": "432,0,3s|432,0,94,0,3s||",
                "Yekaterinburg": "433,0,3s|433,0,94,0,3s||"
            }
        },
        "kok": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "India": "27j,0,1b||15a|"
            }
        },
        "ks": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cbs,0,hr,0,73||",
                "Europe/London": "|cbt,0,hr,0,73||"
            },
            "metazone": {
                "Acre": "6rj,0,f4,0,73|6rj,0,hr,0,73||",
                "Afghanistan": "9kv,0,73|||",
                "Africa_Central": "1mu,0,438,0,73|||",
                "Africa_Eastern": "10l,0,438,0,73|||",
                "Africa_Southern": "6rr,0,1kr,0,73|||",
                "Africa_Western": "ru,0,438,0,f4,0,73|ru,0,438,0,hr,0,73||",
                "Alaska": "6rt,0,f4,0,73|6rt,0,1i8,0,73||",
                "Almaty": "6rv,0,f4,0,73|6rv,0,hr,0,73||",
                "Amazon": "6s0,0,f4,0,73|6s0,0,hr,0,73||",
                "America_Central": "1mu,0,f4,0,73|1mu,0,1i8,0,73||",
                "America_Eastern": "10l,0,f4,0,73|10l,0,1i8,0,73||",
                "America_Mountain": "6s1,0,f4,0,73|6s1,0,1i8,0,73||",
                "America_Pacific": "6s2,0,f4,0,73|6s2,0,1i8,0,73||",
                "Anadyr": "9ks,0,f4,0,73|9kr,0,hr,0,73||",
                "Aqtau": "6s5,0,f4,0,73|6s5,0,hr,0,73||",
                "Aqtobe": "6s6,0,f4,0,73|6s6,0,hr,0,73||",
                "Arabian": "6s7,0,f4,0,73|6s7,0,1i8,0,73||",
                "Argentina": "43c,0,f4,0,73|43c,0,hr,0,73||",
                "Argentina_Western": "ru,0,43c,0,f4,0,73|ru,0,43c,0,hr,0,73||",
                "Armenia": "6s9,0,f4,0,73|6s9,0,hr,0,73||",
                "Atlantic": "6sa,0,f4,0,73|6sa,0,1i8,0,73||",
                "Australia_Central": "1up,0,1mu,0,f4,0,73|1up,0,1mu,0,1i8,0,73||",
                "Australia_CentralWestern": "1up,0,1mu,0,ru,0,f4,0,73|1up,0,1mu,0,ru,0,1i8,0,73||",
                "Australia_Eastern": "1up,0,10l,0,f4,0,73|1up,0,10l,0,1i8,0,73||",
                "Australia_Western": "1up,0,294,0,f4,0,73|1up,0,9kp,0,9ko,0,73||",
                "Azerbaijan": "6sf,0,f4,0,73|6sf,0,hr,0,73||",
                "Azores": "6sg,0,f4,0,73|6sg,0,hr,0,9km||",
                "Bangladesh": "6si,0,f4,0,73|6si,0,hr,0,73||",
                "Bhutan": "9kk,0,73|||",
                "Bolivia": "9kj,0,73|||",
                "Brasilia": "6sl,0,f4,0,73|6sl,0,hr,0,73||",
                "Brunei": "9ki,0,9kg,0,73|||",
                "Cape_Verde": "2es,0,9ke,0,f4,0,73|2es,0,hr,0,73||",
                "Chamorro": "9kd,0,f4,0,73|||",
                "Chatham": "9kc,0,f4,0,73|9k9,0,hr,0,73||",
                "Chile": "6st,0,f4,0,73|6st,0,hr,0,73||",
                "China": "6su,0,f4,0,73|6su,0,1i8,0,73||",
                "Choibalsan": "6sv,0,f4,0,73|6sv,0,hr,0,73||",
                "Christmas": "9k6,0,73|||",
                "Cocos": "9k5,0,4j1,0,73|||",
                "Colombia": "6t3,0,f4,0,73|6t3,0,hr,0,73||",
                "Cook": "6t4,0,4j1,0,f4,0,73|6t4,0,4j1,0,9k4,0,hr,0,73||",
                "Cuba": "6t6,0,f4,0,73|6t6,0,1i8,0,73||",
                "Davis": "9k3,0,73|||",
                "DumontDUrville": "9k2,0,2u7,0,9k1,0,73|||",
                "East_Timor": "9k0,0,9jv,0,73|||",
                "Easter": "6td,0,f4,0,73|6td,0,hr,0,73||",
                "Ecuador": "9ju,0,73|||",
                "Europe_Central": "1mu,0,2u3,0,f4,0,73|1mu,0,2u3,0,hr,0,73||",
                "Europe_Eastern": "10l,0,2u3,0,f4,0,73|10l,0,2u3,0,hr,0,73||",
                "Europe_Western": "294,0,2u3,0,f4,0,73|294,0,9jt,0,hr,0,73||",
                "Falkland": "6th,0,f4,0,73|6th,0,hr,0,73||",
                "Fiji": "6ti,0,f4,0,73|6ti,0,hr,0,73||",
                "French_Guiana": "9js,0,9jr,0,73|||",
                "French_Southern": "6rr,0,9jq,0,73|||",
                "Galapagos": "9jp,0,73|||",
                "Gambier": "9jo,0,73|||",
                "Georgia": "6to,0,f4,0,73|6to,0,hr,0,73||",
                "Gilbert_Islands": "9jn,0,2tv,0,73|||",
                "GMT": "9jm,0,9jl,0,9jk,0,73|||",
                "Greenland_Eastern": "43u,0,43v,0,440,0,f4,0,73|43u,0,43v,0,440,0,hr,0,73||",
                "Greenland_Western": "294,0,43v,0,440,0,f4,0,73|294,0,43v,0,440,0,hr,0,73||",
                "Guam": "9jj,0,73|||",
                "Gulf": "9ji,0,f4,0,73|||",
                "Guyana": "9jh,0,73|||",
                "Hawaii_Aleutian": "6u4,0,6u5,0,f4,0,73|6u4,0,6u5,0,hr,0,73||",
                "Hong_Kong": "9jc,0,6u7,0,f4,0,73|9jb,0,6u7,0,hr,0,73||",
                "Hovd": "6u9,0,f4,0,73|6u9,0,hr,0,73||",
                "India": "9ja|||",
                "Indian_Ocean": "9j9,0,9j7,0,9j6|||",
                "Indochina": "9j5,0,73|||",
                "Indonesia_Central": "1mu,0,4iu,0,73|||",
                "Indonesia_Eastern": "43u,0,4iu,0,73|||",
                "Indonesia_Western": "294,0,4iu,0,73|||",
                "Iran": "9j3,0,f4,0,73|9j1,0,hr,0,73||",
                "Irkutsk": "6ui,0,f4,0,73|6ui,0,hr,0,73||",
                "Israel": "6uj,0,f4,0,73|6uj,0,2tq,0,73||",
                "Japan": "6ul,0,f4,0,73|6ul,0,2tq,0,73||",
                "Kamchatka": "6um,0,f4,0,73|6um,0,hr,0,73||",
                "Kazakhstan_Eastern": "43u,0,6un,0,73|||",
                "Kazakhstan_Western": "294,0,6un,0,73|||",
                "Korea": "6uo,0,f4,0,73|6uo,0,2tq,0,73||",
                "Kosrae": "9iu,0,73|||",
                "Krasnoyarsk": "6uq,0,f4,0,73|6uq,0,hr,0,73||",
                "Kyrgystan": "9in,0,73|||",
                "Lanka": "9im,0,73|||",
                "Line_Islands": "9ig,0,2tv,0,73|||",
                "Lord_Howe": "6uu,0,9if,0,f4,0,73|6uu,0,6v0,0,73||",
                "Macau": "6v1,0,f4,0,73|6v1,0,hr,0,73||",
                "Magadan": "6v2,0,f4,0,73|6v2,0,hr,0,73||",
                "Malaysia": "9ie,0,73|||",
                "Maldives": "9id,0,73|||",
                "Marquesas": "9ia,0,73|||",
                "Marshall_Islands": "9i9,0,2tv,0,73|||",
                "Mauritius": "6v7,0,f4,0,73|6v7,0,hr,0,73||",
                "Mawson": "9i8,0,73|||",
                "Mongolia": "6v9,0,f4,0,73|6v9,0,hr,0,73||",
                "Moscow": "2eo,0,f4,0,73|2eo,0,hr,0,73||",
                "Myanmar": "9i7,0,73|||",
                "Nauru": "9i4,0,73|||",
                "Nepal": "9i3,0,73|||",
                "New_Caledonia": "6ve,0,9i2,0,f4,0,73|6ve,0,9hu,0,hr,0,73||",
                "New_Zealand": "6vh,0,f4,0,73|6vh,0,6v0,0,73||",
                "Newfoundland": "4it,0,9ht,0,f4,0,73|4it,0,9hs,0,9hq,0,2tq,0,73||",
                "Niue": "9hm,0,73|||",
                "Norfolk": "9hk,0,73|||",
                "Noronha": "447,0,f4,0,73|447,0,hr,0,73||",
                "North_Mariana": "6vp,0,9hi,0,73|||",
                "Novosibirsk": "6vr,0,f4,0,73|6vr,0,hr,0,73||",
                "Omsk": "6vs,0,f4,0,73|6vs,0,hr,0,73||",
                "Pakistan": "6vt,0,f4,0,73|6vt,0,hr,0,73||",
                "Palau": "9hd,0,73|||",
                "Papua_New_Guinea": "9hc,0,4it,0,9hb,0,73|||",
                "Paraguay": "701,0,f4,0,73|701,0,hr,0,73||",
                "Peru": "702,0,f4,0,73|702,0,hr,0,73||",
                "Philippines": "703,0,f4,0,73|703,0,hr,0,73||",
                "Phoenix_Islands": "9ha,0,2tv,0,73|||",
                "Pierre_Miquelon": "705,0,706,0,707,0,f4,0,73|705,0,706,0,707,0,2tq,0,73||",
                "Pitcairn": "9h3,0,73|||",
                "Ponape": "9h2,0,73|||",
                "Qyzylorda": "70a,0,f4,0,73|70a,0,hr,0,73||",
                "Reunion": "9gv,0,73|||",
                "Rothera": "9gu,0,73|||",
                "Sakhalin": "70d,0,f4,0,73|70d,0,hr,0,73||",
                "Samara": "70e,0,f4,0,73|70e,0,hr,0,73||",
                "Samoa": "70f,0,f4,0,73|70f,0,hr,0,73||",
                "Seychelles": "9gs,0,73|||",
                "Singapore": "9gm,0,73|||",
                "Solomon": "9gl,0,9gk,0,9gi,0,73|||",
                "South_Georgia": "6vp,0,9gh,0,73|||",
                "Suriname": "9gf,0,73|||",
                "Syowa": "4is,0,73|||",
                "Tahiti": "9gc,0,73|||",
                "Tajikistan": "9gb,0,73|||",
                "Tokelau": "9ga,0,73|||",
                "Tonga": "70r,0,f4,0,73|70r,0,hr,0,73||",
                "Truk": "9g8,0,73|||",
                "Turkmenistan": "70t,0,f4,0,73|70t,0,hr,0,73||",
                "Tuvalu": "9g7,0,73|||",
                "Uruguay": "70v,0,f4,0,73|70v,0,hr,0,73||",
                "Uzbekistan": "9g6,0,f4,0,73|9g5,0,hr,0,73||",
                "Vanuatu": "712,0,f4,0,73|712,0,hr,0,73||",
                "Venezuela": "9g3,0,73|||",
                "Vladivostok": "714,0,f4,0,73|714,0,hr,0,73||",
                "Volgograd": "715,0,f4,0,73|715,0,hr,0,73||",
                "Vostok": "9g1,0,73|||",
                "Wake": "2pn,0,2tv,0,73|||",
                "Wallis": "9fu,0,9ft,0,9fs,0,73|||",
                "Yakutsk": "9fr,0,f4,0,73|9fq,0,hr,0,73||",
                "Yekaterinburg": "9fp,0,f4,0,73|9fo,0,hr,0,73||"
            }
        },
        "ksb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ksf": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ksh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cbu,0,1m3,0,2ee||",
                "Europe/London": "|cbv,0,1m3,0,2ee||"
            },
            "metazone": {
                "Africa_Central": "291,5,2tm,0,1v3|||",
                "Africa_Eastern": "4ir,5,2tm,0,1v3|||",
                "Africa_Southern": "9fn,5,2tm,0,1v3|||",
                "Africa_Western": "4iq,0,71j,5,2tm,0,1v3|71j,5,2tm,0,71k||",
                "Azores": "2,0,2eg,0,71m,0,44f,0,2ef|2,0,2eg,0,71m,0,2ee||",
                "Cape_Verde": "4iq,0,71q,0,1v3|71q,0,71k||",
                "Europe_Central": "71r,5,2e9,0,1m3,0,44f,0,2ef|71r,5,2e9,0,1m3,0,2ee|1bd|1be",
                "Europe_Eastern": "4ir,5,2e9,0,1m3,0,44f,0,2ef|4ir,5,2e9,0,1m3,0,2ee|1bg|1bh",
                "Europe_Western": "71u,5,2e9,0,1m3,0,44f,0,2ef|71u,5,2e9,0,1m3,0,2ee|1bk|1bl",
                "GMT": "5u,0,1m3,0,9fm,5,2ef|||",
                "Indian_Ocean": "9fl,0,193,0,9fk,0,1m3,0,2ef|||",
                "Mauritius": "4iq,0,1v3,0,44k,0,4u|9fj,0,44k,0,4u||",
                "Reunion": "1v3,0,44k,0,b4|||",
                "Seychelles": "1v3,0,44k,0,2,0,9fi|||"
            }
        },
        "kw": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ky": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,0,g8,0,i1||",
                "Europe/London": "|5u9,0,gc,0,a0||"
            },
            "metazone": {
                "Afghanistan": "28q,0,a0|||",
                "Africa_Central": "44n,0,mi,0,a0|||",
                "Africa_Eastern": "1vf,0,mi,0,a0|||",
                "Africa_Southern": "729,0,mi,0,a0|||",
                "Africa_Western": "1ls,0,mi,0,g8,0,i1|1ls,0,mi,0,gc,0,a0||",
                "Alaska": "12l,0,g8,0,a0|12l,0,gc,0,a0||",
                "Amazon": "15q,0,g8,0,a0|15q,0,gc,0,a0||",
                "America_Central": "1ln,0,m6,k,0,2fa,0,g8,0,a0|1ln,0,m6,k,0,2fa,0,gc,0,72g||",
                "America_Eastern": "1ln,0,m6,k,0,26q,0,g8,0,a0|1ln,0,m6,k,0,26q,0,gc,0,a0||",
                "America_Mountain": "1ln,0,m6,k,0,72i,0,g8,0,a0|1ln,0,m6,k,0,72i,0,gc,0,a0||",
                "America_Pacific": "1ln,0,m6,k,0,450,0,1ao,0,g8,0,a0|1ln,0,m6,k,0,450,0,1ao,0,gc,0,a0||",
                "Apia": "15s,0,g8,0,i1|15s,0,gc,0,a0||",
                "Arabian": "72k,0,g8,0,i1|72k,0,gc,0,i1||",
                "Argentina": "hk,0,g8,0,a0|hk,0,gc,0,a0||",
                "Argentina_Western": "1ls,0,hk,0,g8,0,a0|1ls,0,hk,0,gc,0,a0||",
                "Armenia": "18n,0,g8,0,i1|18n,0,gc,0,a0||",
                "Atlantic": "2fc,0,g8,0,a0|2fc,0,gc,0,a0||",
                "Australia_Central": "eo,0,2fa,0,g8,0,i1|eo,0,2fa,0,gc,0,a0||",
                "Australia_CentralWestern": "eo,0,2fa,0,4ip,0,g8,0,i1|eo,0,2fa,0,26q,0,gc,0,a0||",
                "Australia_Eastern": "eo,0,26q,0,g8,0,i1|eo,0,26q,0,gc,0,a0||",
                "Australia_Western": "eo,0,4ip,0,g8,0,i1|eo,0,4ip,0,gc,0,a0||",
                "Azerbaijan": "72m,0,g8,0,i1|72m,0,gc,0,a0||",
                "Azores": "30f,0,g8,0,i1|9fh,0,gc,0,a0||",
                "Bangladesh": "q8,0,g8,0,i1|q8,0,gc,0,a0||",
                "Bhutan": "16f,0,a0|||",
                "Bolivia": "1pu,0,a0|||",
                "Brasilia": "15k,0,g8,0,a0|15k,0,gc,0,a0||",
                "Brunei": "1gr,0,1o3,0,a0|||",
                "Cape_Verde": "72o,0,115,0,g8,0,i1|72o,0,115,0,gc,0,a0||",
                "Chamorro": "1qj,0,a0|||",
                "Chatham": "1bu,0,g8,0,72g|1bu,0,gc,0,a0||",
                "Chile": "150,0,g8,0,a0|150,0,gc,0,a0||",
                "China": "452,0,g8,0,i1|452,0,gc,0,i1||",
                "Choibalsan": "11e,0,g8,0,i1|11e,0,gc,0,a0||",
                "Christmas": "72q,0,4io,0,a0|||",
                "Cocos": "1le,0,1f5,0,a0|||",
                "Colombia": "15d,0,g8,0,a0|15d,0,gc,0,a0||",
                "Cook": "1p2,0,1f5,0,g8,0,i1|1p2,0,1f5,0,9fg,0,gc,0,a0||",
                "Cuba": "ql,0,g8,0,a0|ql,0,gc,0,a0||",
                "Davis": "72u,0,a0|||",
                "DumontDUrville": "1gu,5,72v,5,730,0,a0|||",
                "East_Timor": "1vf,0,1ki,0,a0|||",
                "Easter": "731,0,4io,0,g8,0,i1|731,0,4io,0,gc,0,i1||",
                "Ecuador": "9ff,0,a0|||",
                "Europe_Central": "44n,0,lo,0,g8,0,i1|44n,0,lo,0,gc,0,a0||",
                "Europe_Eastern": "1vf,0,lo,0,g8,0,i1|1vf,0,lo,0,gc,0,a0||",
                "Europe_Further_Eastern": "9fe,0,2nv,0,9fd,0,a0|||",
                "Europe_Western": "1ls,0,lo,0,g8,0,i1|1ls,0,lo,0,gc,0,a0||",
                "Falkland": "3ls,0,1f5,0,g8,0,i1|3ls,0,1f5,0,gc,0,a0||",
                "Fiji": "458,0,g8,0,i1|458,0,gc,0,a0||",
                "French_Guiana": "307,0,1pb,0,a0|||",
                "French_Southern": "307,0,9fc,0,2nv,0,4lu,0,a0|||",
                "Galapagos": "1na,0,a0|||",
                "Gambier": "659,0,a0|||",
                "Georgia": "15e,0,g8,0,i1|15e,0,gc,0,a0||",
                "Gilbert_Islands": "1ne,0,a0|||",
                "GMT": "ah,k,0,g8,0,i1|||",
                "Greenland_Eastern": "1vf,0,pq,0,g8,0,a0|1vf,0,pq,0,gc,0,a0||",
                "Greenland_Western": "1ls,0,pq,0,g8,0,a0|1ls,0,pq,0,gc,0,a0||",
                "Gulf": "9fb,0,9fa,0,gc,0,i1|||",
                "Guyana": "1pb,0,a0|||",
                "Hawaii_Aleutian": "45a,5,3m8,0,g8,0,a0|45a,5,3m8,0,gc,0,a0||",
                "Hong_Kong": "13t,0,g8,0,i1|13t,0,gc,0,a0||",
                "Hovd": "qg,0,g8,0,i1|qg,0,gc,0,a0||",
                "India": "26o,0,a0|||",
                "Indian_Ocean": "53a,0,1ao,0,a0|||",
                "Indochina": "9f9,0,a0|||",
                "Indonesia_Central": "44n,0,vo,0,a0|||",
                "Indonesia_Eastern": "1vf,0,vo,0,a0|||",
                "Indonesia_Western": "1ls,0,vo,0,a0|||",
                "Iran": "rr,0,g8,0,i1|rr,0,9f8,0,a0||",
                "Irkutsk": "12u,0,g8,0,i1|12u,0,gc,0,i1||",
                "Israel": "165,0,g8,0,i1|165,0,gc,0,i1||",
                "Japan": "73e,0,g8,0,i1|73e,0,gc,0,a0||",
                "Kazakhstan_Eastern": "1vf,0,73f,0,a0|||",
                "Kazakhstan_Western": "1ls,0,73f,0,a0|||",
                "Korea": "15j,0,g8,0,i1|15j,0,gc,0,i1||",
                "Kosrae": "1qi,0,a0|||",
                "Krasnoyarsk": "14h,0,g8,0,i1|14h,0,gc,0,a0||",
                "Kyrgystan": "9f3,0,a0|||",
                "Line_Islands": "1eo,0,1f5,0,a0|||",
                "Lord_Howe": "oi,0,10a,0,g8,0,i1|oi,0,10a,0,gc,0,a0||",
                "Macquarie": "73i,0,a0|||",
                "Magadan": "qq,0,g8,0,i1|qq,0,gc,0,a0||",
                "Malaysia": "1pp,0,a0|||",
                "Maldives": "4lt,0,a0|||",
                "Marquesas": "73j,0,a0|||",
                "Marshall_Islands": "4ls,0,1f5,0,a0|||",
                "Mauritius": "15t,0,g8,0,i1|15t,0,gc,0,a0||",
                "Mawson": "1lt,0,a0|||",
                "Mexico_Northwest": "1ln,5,26q,0,1tg,0,g8,0,a0|1ln,5,26q,0,1tg,0,gc,0,a0||",
                "Mexico_Pacific": "1tg,k,0,450,0,1ao,0,g8,0,a0|1tg,k,0,450,0,1ao,0,gc,0,a0||",
                "Mongolia": "or,0,qo,0,g8,0,i1|or,0,qo,0,gc,0,a0||",
                "Moscow": "r6,0,g8,0,i1|r6,0,gc,0,a0||",
                "Myanmar": "9f2,0,a0|||",
                "Nauru": "14s,0,a0|||",
                "Nepal": "16d,0,a0|||",
                "New_Caledonia": "4in,0,15l,0,g8,0,i1|4in,0,15l,0,gc,0,a0||",
                "New_Zealand": "4in,0,15h,0,g8,0,i1|73m,0,15h,0,gc,0,i1||",
                "Newfoundland": "73n,0,g8,0,a0|73n,0,gc,0,a0||",
                "Niue": "1qn,0,a0|||",
                "Norfolk": "146,0,a0|||",
                "Noronha": "138,0,13a,0,132,0,g8,0,a0|138,0,13a,0,132,0,gc,0,a0||",
                "Novosibirsk": "qt,0,g8,0,i1|qt,0,gc,0,a0||",
                "Omsk": "r5,0,g8,0,i1|r5,0,gc,0,a0||",
                "Pakistan": "rq,0,g8,0,i1|rq,0,gc,0,a0||",
                "Palau": "159,0,a0|||",
                "Papua_New_Guinea": "13k,5,73m,0,1m5,0,a0|||",
                "Paraguay": "13p,0,g8,0,a0|13p,0,gc,0,a0||",
                "Peru": "q1,0,g8,0,a0|q1,0,gc,0,a0||",
                "Philippines": "2lj,0,1f5,0,g8,0,a0|2lj,0,1f5,0,gc,0,a0||",
                "Phoenix_Islands": "158,0,1f5,0,a0|||",
                "Pierre_Miquelon": "pr,0,13m,0,2nv,0,qp,0,g8,0,a0|pr,0,13m,0,2nv,0,qp,0,gc,0,a0||",
                "Pitcairn": "9et,0,a0|||",
                "Ponape": "1v2,0,a0|||",
                "Pyongyang": "1u8,0,i1|||",
                "Reunion": "6gi,0,a0|||",
                "Rothera": "157,0,a0|||",
                "Sakhalin": "r8,0,g8,0,i1|r8,0,gc,0,a0||",
                "Samoa": "p0,0,g8,0,i1|p0,0,gc,0,a0||",
                "Seychelles": "73p,0,a0|||",
                "Singapore": "16b,0,a0|||",
                "Solomon": "4lp,0,1f5,0,a0|||",
                "South_Georgia": "729,0,9es,0,a0|||",
                "Suriname": "9eq,0,a0|||",
                "Syowa": "9ep,0,a0|||",
                "Tahiti": "1ma,0,a0|||",
                "Taipei": "45g,0,g8,0,i1|45g,0,gc,0,i1||",
                "Tajikistan": "9eo,0,a0|||",
                "Tokelau": "156,0,a0|||",
                "Tonga": "ot,0,g8,0,i1|ot,0,gc,0,a0||",
                "Truk": "1f2,0,a0|||",
                "Turkmenistan": "73v,0,g8,0,i1|73v,0,gc,0,a0||",
                "Tuvalu": "14j,0,a0|||",
                "Uruguay": "14a,0,g8,0,a0|14a,0,gc,0,a0||",
                "Uzbekistan": "3mu,0,g8,0,i1|3mu,0,gc,0,a0||",
                "Vanuatu": "os,0,g8,0,i1|os,0,gc,0,a0||",
                "Venezuela": "1mf,0,a0|||",
                "Vladivostok": "qn,0,g8,0,i1|qn,0,gc,0,a0||",
                "Volgograd": "q9,0,g8,0,i1|q9,0,gc,0,a0||",
                "Vostok": "155,0,a0|||",
                "Wake": "6j8,0,1f5,0,a0|||",
                "Wallis": "6ja,0,2nv,0,14l,0,a0|||",
                "Yakutsk": "14d,0,g8,0,i1|14d,0,gc,0,a0||",
                "Yekaterinburg": "136,0,g8,0,i1|136,0,gc,0,a0||"
            }
        },
        "lag": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "lb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cc1,0,fc||",
                "Europe/London": "|cc2,0,fc||"
            },
            "metazone": {
                "Acre": "3q,5,fn|3q,5,fc||",
                "Afghanistan": "b6,5,hp|||",
                "Africa_Central": "9en,0,hp|||",
                "Africa_Eastern": "9el,0,hp|||",
                "Africa_Southern": "9ej,0,hp|||",
                "Africa_Western": "746,0,fn|746,0,fc||",
                "Alaska": "3p,5,fn|3p,5,fc||",
                "Almaty": "56,5,fn|56,5,fc||",
                "Amazon": "bg,5,fn|bg,5,fc||",
                "America_Central": "2ci,0,178,5,fn|2ci,0,178,5,fc||",
                "America_Eastern": "2ci,0,179,5,fn|2ci,0,179,5,fc||",
                "America_Mountain": "145,5,5a,5,fn|145,5,5a,5,fc||",
                "America_Pacific": "2ci,0,17b,5,fn|2ci,0,17b,5,fc||",
                "Anadyr": "3l,5,fn|3l,5,fc||",
                "Arabian": "748,0,fn|748,0,fc||",
                "Argentina": "749,0,fn|749,0,fc||",
                "Argentina_Western": "74a,0,fn|74a,0,fc||",
                "Armenia": "74b,0,fn|74b,0,fc||",
                "Atlantic": "r2,5,fn|r2,5,fc||",
                "Australia_Central": "74c,0,fn|74c,0,fc||",
                "Australia_CentralWestern": "17e,5,74d,0,fn|17e,5,74d,0,fc||",
                "Australia_Eastern": "74e,0,fn|74e,0,fc||",
                "Australia_Western": "74f,0,fn|74f,0,fc||",
                "Azerbaijan": "9eg,0,fn|9e8,0,fc||",
                "Azores": "qv,5,fn|qv,5,fc||",
                "Bangladesh": "17i,5,fn|17i,5,fc||",
                "Bhutan": "as,5,hp|||",
                "Bolivia": "9e7,0,hp|||",
                "Brasilia": "in,5,fn|in,5,fc||",
                "Brunei": "9o,5,hp|||",
                "Cape_Verde": "1l8,5,3j,5,fn|1l8,5,3j,5,fc||",
                "Chamorro": "6j,5,hp|||",
                "Chatham": "27,5,fn|27,5,fc||",
                "Chile": "74j,0,fn|74j,0,fc||",
                "China": "74k,0,fn|74k,0,fc||",
                "Choibalsan": "2q,5,fn|2q,5,fc||",
                "Christmas": "9e1,5,hp|||",
                "Cocos": "9e0,5,hp|||",
                "Colombia": "74n,0,fn|74n,0,fc||",
                "Cook": "74o,5,fn|74o,5,fc||",
                "Cuba": "74p,0,fn|74p,0,fc||",
                "Davis": "5s,5,hp|||",
                "DumontDUrville": "5b,5,5j,5,hp|||",
                "East_Timor": "22p,5,hp|||",
                "Easter": "74q,5,fn|74q,5,fc||",
                "Ecuador": "9dv,0,hp|||",
                "Europe_Central": "74s,0,fn|74s,0,fc||",
                "Europe_Eastern": "74t,0,fn|74t,0,fc||",
                "Europe_Western": "74u,0,fn|74u,0,fc||",
                "Falkland": "74v,5,fn|74v,5,fc||",
                "Fiji": "17p,5,fn|17p,5,fc||",
                "French_Guiana": "750,5,9dt,5,hp|||",
                "French_Southern": "750,0,22k,5,0,nk,0,9ds,5,hp|||",
                "Galapagos": "ak,5,hp|||",
                "Gambier": "6v,5,hp|||",
                "Georgia": "753,0,fn|753,0,fc||",
                "Gilbert_Islands": "6q,5,9dr,5,hp|||",
                "GMT": "9dm,0,5u,5,hp|||",
                "Greenland_Eastern": "183,5,fn|183,5,fc||",
                "Greenland_Western": "184,5,fn|184,5,fc||",
                "Guam": "83,5,hp|||",
                "Gulf": "127,5,hp|||",
                "Guyana": "7a,5,hp|||",
                "Hawaii_Aleutian": "4g,5,185,5,fn|4g,5,185,5,fc||",
                "Hong_Kong": "2l,5,2p,5,fn|2l,5,2p,5,fc||",
                "Hovd": "2g,5,fn|2g,5,fc||",
                "India": "9dl,0,hp|||",
                "Indian_Ocean": "9dk,0,21v,5,hp|||",
                "Indochina": "9p,5,hp|||",
                "Indonesia_Central": "9dj,0,hp|||",
                "Indonesia_Eastern": "9di,0,hp|||",
                "Indonesia_Western": "9dh,0,hp|||",
                "Iran": "75b,0,fn|75b,0,fc||",
                "Irkutsk": "3h,5,fn|3h,5,fc||",
                "Israel": "75c,0,fn|75c,0,fc||",
                "Japan": "75d,0,fn|75d,0,fc||",
                "Kamchatka": "18c,5,fn|18c,5,fc||",
                "Kazakhstan_Eastern": "9de,0,hp|||",
                "Kazakhstan_Western": "9dd,0,hp|||",
                "Korea": "75g,0,fn|75g,0,fc||",
                "Kosrae": "6f,5,hp|||",
                "Krasnoyarsk": "l0,5,fn|l0,5,fc||",
                "Kyrgystan": "21g,5,hp|||",
                "Line_Islands": "9dc,5,hp|||",
                "Lord_Howe": "1u,5,24,5,fn|1u,5,24,5,fc||",
                "Macquarie": "214,5,hp|||",
                "Magadan": "2o,5,fn|2o,5,fc||",
                "Malaysia": "9db,0,hp|||",
                "Maldives": "9d7,5,hp|||",
                "Marquesas": "9e,5,hp|||",
                "Marshall_Islands": "9d6,5,hp|||",
                "Mauritius": "4u,5,fn|4u,5,fc||",
                "Mawson": "63,5,hp|||",
                "Mexico_Northwest": "75l,5,ro,5,fn|75l,5,ro,5,fc||",
                "Mexico_Pacific": "75m,0,75n,5,fn|75m,0,75n,5,fc||",
                "Mongolia": "p2,5,fn|p2,5,fc||",
                "Moscow": "131,0,fn|131,0,fc||",
                "Myanmar": "8v,5,hp|||",
                "Nauru": "5v,5,hp|||",
                "Nepal": "9d5,0,hp|||",
                "New_Caledonia": "75p,0,fn|75p,0,fc||",
                "New_Zealand": "75q,5,fn|75q,5,fc||",
                "Newfoundland": "75r,5,fn|75r,5,fc||",
                "Niue": "8g,5,hp|||",
                "Norfolk": "9d4,5,hp|||",
                "Noronha": "1s,5,2,5,23,5,fn|1s,5,2,5,23,5,fc||",
                "Novosibirsk": "16c,5,fn|16c,5,fc||",
                "Omsk": "26,5,fn|26,5,fc||",
                "Pakistan": "75t,0,fn|75t,0,fc||",
                "Palau": "9b,5,hp|||",
                "Papua_New_Guinea": "9a,5,9d3,5,hp|||",
                "Paraguay": "75v,0,fn|75v,0,fc||",
                "Peru": "760,0,fn|760,0,fc||",
                "Philippines": "761,0,fn|761,0,fc||",
                "Phoenix_Islands": "9d1,5,hp|||",
                "Pierre_Miquelon": "8i,5,33,5,a6,5,35,5,fn|8i,5,33,5,a6,5,35,5,fc||",
                "Pitcairn": "9cs,5,hp|||",
                "Ponape": "9s,5,hp|||",
                "Reunion": "i8,5,hp|||",
                "Rothera": "5q,5,hp|||",
                "Sakhalin": "55,5,fn|55,5,fc||",
                "Samara": "29,5,fn|29,5,fc||",
                "Samoa": "2c,5,fn|2c,5,fc||",
                "Seychelles": "1vo,5,hp|||",
                "Singapore": "m8,5,9cq|||",
                "Solomon": "9cp,5,hp|||",
                "South_Georgia": "9ck,0,hp|||",
                "Suriname": "8q,5,hp|||",
                "Syowa": "65,5,hp|||",
                "Tahiti": "8n,5,hp|||",
                "Taipei": "3d,5,fn|3d,5,fc||",
                "Tajikistan": "1vl,5,hp|||",
                "Tokelau": "5d,5,hp|||",
                "Tonga": "767,0,fn|767,0,fc||",
                "Truk": "6p,5,hp|||",
                "Turkmenistan": "4t,5,fn|4t,5,fc||",
                "Tuvalu": "6h,5,hp|||",
                "Uruguay": "9ci,0,fn|9ch,0,fc||",
                "Uzbekistan": "14m,5,fn|14m,5,fc||",
                "Vanuatu": "2f,5,fn|2f,5,fc||",
                "Venezuela": "7s,5,hp|||",
                "Vladivostok": "15m,5,fn|15m,5,fc||",
                "Volgograd": "qi,5,fn|qi,5,fc||",
                "Vostok": "1kt,5,hp|||",
                "Wake": "5r,5,1vg,5,hp|||",
                "Wallis": "5f,5,a6,5,5k,5,hp|||",
                "Yakutsk": "qj,5,fn|qj,5,fc||",
                "Yekaterinburg": "76a,5,fn|76a,5,fc||"
            }
        },
        "lg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "lkt": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ln-AO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ln-CF": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ln-CG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ln": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "lo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cc3||",
                "Europe/London": "|cc4||"
            },
            "metazone": {
                "Acre": "9cg|9cf||",
                "Afghanistan": "2cg,0,9ce|||",
                "Africa_Central": "9cd|||",
                "Africa_Eastern": "9cc|||",
                "Africa_Southern": "9c7|||",
                "Africa_Western": "9c6|9c5||",
                "Alaska": "9c4|9c2||",
                "Almaty": "9bv|9br||",
                "Amazon": "9bp|9bo||",
                "America_Central": "9bn|9bm||",
                "America_Eastern": "9bk|9bi||",
                "America_Mountain": "9bh|9bc||",
                "America_Pacific": "9ba|9b9||",
                "Apia": "9b7|9b5||",
                "Aqtau": "9b4|9b3||",
                "Aqtobe": "9b2|9b0||",
                "Arabian": "9at|9aq||",
                "Argentina": "9ap|9ao||",
                "Argentina_Western": "9am|9al||",
                "Armenia": "9ak|9aj||",
                "Atlantic": "9ai|9ah||",
                "Australia_Central": "9ag|9af||",
                "Australia_CentralWestern": "9ae|9ad||",
                "Australia_Eastern": "9ac|9ab||",
                "Australia_Western": "9aa|9a9||",
                "Azerbaijan": "9a8|9a7||",
                "Azores": "9a6|9a5||",
                "Bangladesh": "77u,0,77v|2cg,0,9a4,0,77v||",
                "Bhutan": "9a3|||",
                "Bolivia": "9a2|||",
                "Brasilia": "9a1|9a0||",
                "Brunei": "99v|||",
                "Cape_Verde": "99u|99s||",
                "Casey": "99r|||",
                "Chamorro": "99q|||",
                "Chatham": "99p|99o||",
                "Chile": "99n|99m||",
                "China": "99l|99k||",
                "Choibalsan": "99j|99i||",
                "Christmas": "99h|||",
                "Cocos": "99g|||",
                "Colombia": "99f|99e||",
                "Cook": "99d|99c||",
                "Cuba": "99b|99a||",
                "Davis": "999|||",
                "DumontDUrville": "997|||",
                "East_Timor": "996|||",
                "Easter": "995|994||",
                "Ecuador": "990|||",
                "Europe_Central": "98v|98u||",
                "Europe_Eastern": "98t|98s||",
                "Europe_Further_Eastern": "98r|||",
                "Europe_Western": "98q|98p||",
                "Falkland": "98o|98n||",
                "Fiji": "98m|98l||",
                "French_Guiana": "98k|||",
                "French_Southern": "98j,0,79d,0,98i|||",
                "Galapagos": "98h|||",
                "Gambier": "98g|||",
                "Georgia": "98f|98e||",
                "Gilbert_Islands": "98d|||",
                "GMT": "98c|||",
                "Greenland_Eastern": "98b|98a||",
                "Greenland_Western": "989|988||",
                "Guam": "987|||",
                "Gulf": "986|||",
                "Guyana": "985|||",
                "Hawaii_Aleutian": "984,5,79t|983,5,79t||",
                "Hong_Kong": "982|981||",
                "Hovd": "980|97v||",
                "India": "2cg,0,97u|||",
                "Indian_Ocean": "97t|||",
                "Indochina": "97s|||",
                "Indonesia_Central": "97r|||",
                "Indonesia_Eastern": "97q|||",
                "Indonesia_Western": "97p|||",
                "Iran": "97o|97n||",
                "Irkutsk": "97m|97l||",
                "Israel": "97k|97j||",
                "Japan": "97i|97h||",
                "Kazakhstan_Eastern": "97g|||",
                "Kazakhstan_Western": "97f|||",
                "Korea": "97e|97d||",
                "Kosrae": "97c|||",
                "Krasnoyarsk": "97b|97a||",
                "Kyrgystan": "979|||",
                "Lanka": "978|||",
                "Line_Islands": "977|||",
                "Lord_Howe": "976|975||",
                "Macau": "974|973||",
                "Macquarie": "972|||",
                "Magadan": "971|970||",
                "Malaysia": "96v|||",
                "Maldives": "96u|||",
                "Marquesas": "96t|||",
                "Marshall_Islands": "96s|||",
                "Mauritius": "96r|96q||",
                "Mawson": "96p|||",
                "Mexico_Northwest": "96o|96n||",
                "Mexico_Pacific": "96m|96l||",
                "Mongolia": "77u,0,96k|96j||",
                "Moscow": "96i|96h||",
                "Myanmar": "96g|||",
                "Nauru": "96f|||",
                "Nepal": "96e|||",
                "New_Caledonia": "96d|96c||",
                "New_Zealand": "96b|96a||",
                "Newfoundland": "969|968||",
                "Niue": "967|||",
                "Norfolk": "966|||",
                "Noronha": "965|964||",
                "North_Mariana": "963|||",
                "Novosibirsk": "962|961||",
                "Omsk": "960|95v||",
                "Pakistan": "95u|95t||",
                "Palau": "95s|||",
                "Papua_New_Guinea": "95r|||",
                "Paraguay": "95q|95p||",
                "Peru": "95o|95n||",
                "Philippines": "95m|95l||",
                "Phoenix_Islands": "95k|||",
                "Pierre_Miquelon": "95j,0,7cf|95i,0,7cf||",
                "Pitcairn": "95h|||",
                "Ponape": "95g|||",
                "Pyongyang": "95f|||",
                "Qyzylorda": "95e|95d||",
                "Reunion": "95c|||",
                "Rothera": "2cg,0,95b|||",
                "Sakhalin": "95a|959||",
                "Samoa": "958|957||",
                "Seychelles": "956|||",
                "Singapore": "955|||",
                "Solomon": "954|||",
                "South_Georgia": "953|||",
                "Suriname": "952|||",
                "Syowa": "2cg,0,951|||",
                "Tahiti": "950|||",
                "Taipei": "94v|94u||",
                "Tajikistan": "94t|||",
                "Tokelau": "94s|||",
                "Tonga": "94r|94q||",
                "Truk": "94p|||",
                "Turkmenistan": "94o|94n||",
                "Tuvalu": "94m|||",
                "Uruguay": "94l|94k||",
                "Uzbekistan": "94j|94i||",
                "Vanuatu": "94h|94g||",
                "Venezuela": "94f|||",
                "Vladivostok": "94e|94d||",
                "Volgograd": "94c|94b||",
                "Vostok": "2cg,0,94a|||",
                "Wake": "949|||",
                "Wallis": "948,0,79d,0,945|||",
                "Yakutsk": "944|943||",
                "Yekaterinburg": "942|941||"
            }
        },
        "lrc-IQ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "America_Central": "7e0,0,7e1,0,7e2|7e3,0,7e4,0,7e5||"
            }
        },
        "lrc": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "America_Central": "7e0,0,7e1,0,7e2|7e3,0,7e4,0,7e5||"
            }
        },
        "lt": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cc5,0,ed,0,64||",
                "Europe/London": "|cc6,0,ed,0,64||"
            },
            "metazone": {
                "Acre": "7e6,0,940,0,64|7e6,0,ed,0,64||",
                "Afghanistan": "93p,0,64|||",
                "Africa_Central": "2f7,0,2tb,0,64|||",
                "Africa_Eastern": "24q,0,2tb,0,64|||",
                "Africa_Southern": "4id,0,2tb,0,64|||",
                "Africa_Western": "1gq,0,2tb,0,es,0,64|1gq,0,2tb,0,ed,0,64||",
                "Alaska": "7eh,0,es,0,64|7eh,0,ed,0,64||",
                "Almaty": "7ei,0,es,0,64|7ei,0,ed,0,64||",
                "Amazon": "7ej,0,es,0,64|7ej,0,ed,0,64||",
                "America_Central": "1kl,0,24p,0,7em,0,es,0,64|1kl,0,24p,0,7em,0,ed,0,64||",
                "America_Eastern": "1kl,0,24p,0,2rs,0,es,0,64|1kl,0,24p,0,2rs,0,ed,0,64||",
                "America_Mountain": "1kl,0,24p,0,7eo,0,es,0,64|1kl,0,24p,0,7eo,0,ed,0,64||",
                "America_Pacific": "1kl,0,24p,0,4at,0,2r4,0,es,0,64|1kl,0,24p,0,4at,0,2r4,0,ed,0,64||",
                "Anadyr": "7er,0,es,0,64|7er,0,ed,0,64||",
                "Apia": "7es,0,es,0,64|7es,0,ed,0,64||",
                "Aqtau": "i4,0,es,0,64|i4,0,ed,0,64||",
                "Aqtobe": "7et,0,es,0,64|7et,0,ed,0,64||",
                "Arabian": "7eu,0,es,0,64|7eu,0,ed,0,64||",
                "Argentina": "4av,0,es,0,64|4av,0,ed,0,64||",
                "Argentina_Western": "1gq,0,4av,0,es,0,64|1gq,0,4av,0,ed,0,64||",
                "Armenia": "7f0,0,es,0,64|7f0,0,ed,0,64||",
                "Atlantic": "7f1,0,es,0,64|7f1,0,ed,0,64||",
                "Australia_Central": "2f7,0,249,0,es,0,64|2f7,0,249,0,ed,0,64||",
                "Australia_CentralWestern": "2f7,0,4b1,0,249,0,es,0,64|2f7,0,4b1,0,249,0,ed,0,64||",
                "Australia_Eastern": "24q,0,249,0,es,0,64|24q,0,249,0,ed,0,64||",
                "Australia_Western": "1gq,0,249,0,es,0,64|1gq,0,249,0,ed,0,64||",
                "Azerbaijan": "7f4,0,es,0,64|7f4,0,ed,0,64||",
                "Azores": "7f5,0,19u,0,es,0,64|7f5,0,19u,0,ed,0,64||",
                "Bangladesh": "7f7,0,es,0,64|7f7,0,ed,0,64||",
                "Bhutan": "93o,0,64|||",
                "Bolivia": "93n,0,64|||",
                "Brasilia": "7fa,0,es,0,64|7fa,0,ed,0,64||",
                "Brunei": "93j,0,93i,0,64|||",
                "Cape_Verde": "7fd,0,7fe,0,es,0,64|7fd,0,7fe,0,ed,0,64||",
                "Casey": "93h,0,64|||",
                "Chamorro": "2nf,0,64|||",
                "Chatham": "7fh,0,es,0,64|7fh,0,ed,0,64||",
                "Chile": "7fi,0,es,0,64|7fi,0,ed,0,64||",
                "China": "7fj,0,es,0,64|7fj,0,ed,0,64||",
                "Choibalsan": "7fk,0,es,0,64|7fk,0,ed,0,64||",
                "Christmas": "93g,0,4b8,0,64|||",
                "Cocos": "93f,0,19u,0,64|||",
                "Colombia": "7fo,0,es,0,64|7fo,0,ed,0,64||",
                "Cook": "7fp,0,19u,0,es,0,64|7fp,0,19u,0,93e,0,ed,0,64||",
                "Cuba": "7fr,0,es,0,64|7fr,0,ed,0,64||",
                "Davis": "93d,0,64|||",
                "DumontDUrville": "93c,0,93b,0,64|||",
                "East_Timor": "24q,0,93a,0,64|||",
                "Easter": "7g0,0,939,0,es,0,64|7g0,0,4b8,0,ed,0,64||",
                "Ecuador": "938,0,64|||",
                "Europe_Central": "7g3,0,267,0,es,0,64|7g3,0,267,0,ed,0,64||",
                "Europe_Eastern": "24q,0,267,0,es,0,64|24q,0,267,0,ed,0,64||",
                "Europe_Further_Eastern": "937,0,2rs,0,267,0,64|||",
                "Europe_Western": "1gq,0,267,0,es,0,64|1gq,0,267,0,ed,0,64||",
                "Falkland": "936,0,19u,0,es,0,64|935,0,19u,0,ed,0,64||",
                "Fiji": "7g8,0,es,0,64|7g8,0,ed,0,64||",
                "French_Guiana": "7g9,0,934,0,64|||",
                "French_Southern": "4id,0,7g9,0,4bm,0,933,0,64|||",
                "Galapagos": "932,0,64|||",
                "Gambier": "931,0,64|||",
                "Georgia": "7gf,0,es,0,64|7gf,0,ed,0,64||",
                "Gilbert_Islands": "7gg,0,19u,0,64|||",
                "GMT": "930,0,64|||",
                "Greenland_Eastern": "4br,0,2rs,0,es,0,64|4br,0,2rs,0,ed,0,64||",
                "Greenland_Western": "4br,0,4b1,0,es,0,64|4br,0,4b1,0,ed,0,64||",
                "Guam": "92v,0,64|||",
                "Gulf": "92u,0,92t,0,64|||",
                "Guyana": "92s,0,64|||",
                "Hawaii_Aleutian": "7gn,0,es,0,64|7gn,0,ed,0,64||",
                "Hong_Kong": "7go,0,es,0,64|7go,0,ed,0,64||",
                "Hovd": "7gp,0,es,0,64|7gp,0,ed,0,64||",
                "India": "7gq,0,64|||",
                "Indian_Ocean": "7gq,0,2r4,0,64|||",
                "Indochina": "92r,0,64|||",
                "Indonesia_Central": "2f7,0,4i8,0,64|||",
                "Indonesia_Eastern": "24q,0,4i8,0,64|||",
                "Indonesia_Western": "1gq,0,4i8,0,64|||",
                "Iran": "7gt,0,es,0,64|7gt,0,ed,0,64||",
                "Irkutsk": "2c5,0,es,0,64|2c5,0,ed,0,64||",
                "Israel": "7gu,0,es,0,64|7gu,0,ed,0,64||",
                "Japan": "7gv,0,es,0,64|7gv,0,ed,0,64||",
                "Kamchatka": "7h0,0,1gd,0,es,0,64|7h0,0,1gd,0,ed,0,64||",
                "Kazakhstan_Eastern": "24q,0,7h1,0,64|||",
                "Kazakhstan_Western": "1gq,0,7h1,0,64|||",
                "Korea": "7h2,0,es,0,64|7h2,0,ed,0,64||",
                "Kosrae": "92q,0,64|||",
                "Krasnoyarsk": "2br,0,es,0,64|2br,0,ed,0,64||",
                "Kyrgystan": "92p,0,64|||",
                "Lanka": "92o,0,64|||",
                "Line_Islands": "92n,0,19u,0,64|||",
                "Lord_Howe": "7h7,0,1i2,0,es,0,64|7h7,0,1i2,0,ed,0,64||",
                "Macau": "36a,0,es,0,64|36a,0,ed,0,64||",
                "Macquarie": "92m,0,4b8,0,64|||",
                "Magadan": "7h9,0,es,0,64|7h9,0,ed,0,64||",
                "Malaysia": "92l,0,64|||",
                "Maldives": "92k,0,64|||",
                "Marquesas": "92j,0,19u,0,64|||",
                "Marshall_Islands": "92i,0,19u,0,64|||",
                "Mauritius": "7he,0,es,0,64|7he,0,ed,0,64||",
                "Mawson": "92h,0,64|||",
                "Mexico_Northwest": "1kl,0,1gq,0,4cc,0,es,0,64|1kl,0,1gq,0,4cc,0,ed,0,64||",
                "Mexico_Pacific": "4cc,0,4at,0,2r4,0,es,0,64|4cc,0,4at,0,2r4,0,ed,0,64||",
                "Mongolia": "4f,0,7hh,0,es,0,64|4f,0,7hh,0,ed,0,64||",
                "Moscow": "7hi,0,es,0,64|7hi,0,ed,0,64||",
                "Myanmar": "92g,0,64|||",
                "Nauru": "5v,0,64|||",
                "Nepal": "92f,0,64|||",
                "New_Caledonia": "2r3,0,7hm,0,es,0,64|2r3,0,7hm,0,ed,0,64||",
                "New_Zealand": "2r3,0,7hn,0,es,0,64|2r3,0,7hn,0,ed,0,64||",
                "Newfoundland": "7ho,0,es,0,64|7ho,0,ed,0,64||",
                "Niue": "92e,0,64|||",
                "Norfolk": "92d,0,19u,0,64|||",
                "Noronha": "1s,0,2,0,7hr,0,es,0,64|1s,0,2,0,7hr,0,ed,0,64||",
                "North_Mariana": "1kl,0,92c,0,19u,0,64|||",
                "Novosibirsk": "2b8,0,es,0,64|2b8,0,ed,0,64||",
                "Omsk": "2b1,0,es,0,64|2b1,0,ed,0,64||",
                "Pakistan": "7ht,0,es,0,64|7ht,0,ed,0,64||",
                "Palau": "9b,0,64|||",
                "Papua_New_Guinea": "9a,0,2r3,0,92b,0,64|||",
                "Paraguay": "7hv,0,es,0,64|7hv,0,ed,0,64||",
                "Peru": "4n,0,es,0,64|4n,0,ed,0,64||",
                "Philippines": "7i0,0,es,0,64|7i0,0,ed,0,64||",
                "Phoenix_Islands": "92a,0,19u,0,64|||",
                "Pierre_Miquelon": "14i,0,7i2,0,4bm,0,7i3,0,es,0,64|14i,0,7i2,0,4bm,0,7i3,0,ed,0,64||",
                "Pitcairn": "929,0,64|||",
                "Ponape": "928,0,64|||",
                "Pyongyang": "927,0,64|||",
                "Qyzylorda": "7i7,0,es,0,64|7i7,0,ed,0,64||",
                "Reunion": "926,0,64|||",
                "Rothera": "925,0,64|||",
                "Sakhalin": "7ia,0,es,0,64|7ia,0,ed,0,64||",
                "Samara": "7ib,0,es,0,64|7ib,0,ed,0,64||",
                "Samoa": "2c,0,es,0,64|2c,0,ed,0,64||",
                "Seychelles": "924,0,64|||",
                "Singapore": "923,0,64|||",
                "Solomon": "922,0,19u,0,64|||",
                "South_Georgia": "4id,0,921,0,64|||",
                "Suriname": "920,0,64|||",
                "Syowa": "91v,0,64|||",
                "Tahiti": "91r,0,64|||",
                "Taipei": "7ij,0,es,0,64|7ij,0,ed,0,64||",
                "Tajikistan": "91p,0,64|||",
                "Tokelau": "5d,0,64|||",
                "Tonga": "7il,0,es,0,64|7il,0,ed,0,64||",
                "Truk": "91o,0,64|||",
                "Turkmenistan": "7in,0,es,0,64|7in,0,ed,0,64||",
                "Tuvalu": "6h,0,64|||",
                "Uruguay": "7io,0,es,0,64|7io,0,ed,0,64||",
                "Uzbekistan": "7ip,0,es,0,64|7ip,0,ed,0,64||",
                "Vanuatu": "2f,0,es,0,64|2f,0,ed,0,64||",
                "Venezuela": "91n,0,64|||",
                "Vladivostok": "7ir,0,es,0,64|7ir,0,ed,0,64||",
                "Volgograd": "ff,0,es,0,64|ff,0,ed,0,64||",
                "Vostok": "91m,0,64|||",
                "Wake": "91l,0,4b8,0,64|||",
                "Wallis": "91k,0,4bm,0,91i,0,64|||",
                "Yakutsk": "2ap,0,es,0,64|2ap,0,ed,0,64||",
                "Yekaterinburg": "7j0,0,es,0,64|7j0,0,ed,0,64||"
            }
        },
        "lu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "luo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "luy": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "lv": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cc7,0,f7,0,7b||",
                "Europe/London": "|cc8,0,fh,0,7b||"
            },
            "metazone": {
                "Afghanistan": "91g,0,7b|||",
                "Africa_Central": "91b,0,7b|||",
                "Africa_Eastern": "91a,0,7b|||",
                "Africa_Southern": "918,0,f7,0,7b|||",
                "Africa_Western": "7j7,0,f7,0,7b|7j7,0,fh,0,7b||",
                "Alaska": "7j9,0,f7,0,7b|7j9,0,fh,0,7b||",
                "Amazon": "7ja,0,f7,0,7b|7ja,0,fh,0,7b||",
                "America_Central": "7jb,0,f7,0,7b|7jb,0,fh,0,7b||",
                "America_Eastern": "7jc,0,f7,0,7b|7jc,0,fh,0,7b||",
                "America_Mountain": "7jd,0,f7,0,7b|7jd,0,fh,0,7b||",
                "America_Pacific": "4d6,0,2p8,0,f7,0,7b|4d6,0,2p8,0,fh,0,7b||",
                "Anadyr": "7jg,0,f7,0,7b|7jg,0,fh,0,7b||",
                "Apia": "7jh,0,f7,0,7b|7jh,0,fh,0,7b||",
                "Arabian": "7ji,0,7jj,0,f7,0,7b|7ji,0,7jj,0,fh,0,7b||",
                "Argentina": "7jk,0,f7,0,7b|7jk,0,fh,0,7b||",
                "Argentina_Western": "7jl,0,f7,0,7b|7jl,0,fh,0,7b||",
                "Armenia": "7jm,0,f7,0,7b|7jm,0,fh,0,7b||",
                "Atlantic": "7jn,0,f7,0,7b|7jn,0,fh,0,7b||",
                "Australia_Central": "23i,0,4d9,0,f7,0,7b|23i,0,4d9,0,fh,0,7b||",
                "Australia_CentralWestern": "23i,0,4d9,0,4da,0,f7,0,7b|23i,0,4d9,0,4da,0,fh,0,7b||",
                "Australia_Eastern": "23i,0,7jr,0,f7,0,7b|23i,0,7jr,0,fh,0,7b||",
                "Australia_Western": "23i,0,4da,0,f7,0,7b|23i,0,4da,0,fh,0,7b||",
                "Azerbaijan": "7js,0,f7,0,7b|7js,0,fh,0,7b||",
                "Azores": "7jt,0,19j,0,f7,0,7b|7jt,0,19j,0,fh,0,7b||",
                "Bangladesh": "7jv,0,f7,0,7b|7jv,0,fh,0,7b||",
                "Bhutan": "917,0,7b|||",
                "Bolivia": "916,0,7b|||",
                "Brasilia": "7k2,0,f7,0,7b|7k2,0,fh,0,7b||",
                "Brunei": "914,0,913,0,7b|||",
                "Cape_Verde": "7k5,0,f7,0,7b|7k5,0,fh,0,7b||",
                "Chamorro": "912,0,f7,0,7b|||",
                "Chatham": "7k7,0,f7,0,7b|7k7,0,fh,0,7b||",
                "Chile": "7k8,0,f7,0,7b|7k8,0,fh,0,7b||",
                "China": "7k9,0,f7,0,7b|7k9,0,fh,0,7b||",
                "Choibalsan": "7ka,0,f7,0,7b|7ka,0,fh,0,7b||",
                "Christmas": "911,0,23e,0,7b|||",
                "Cocos": "90q,0,90p,0,19j,0,7b|||",
                "Colombia": "7kf,0,f7,0,7b|7kf,0,fh,0,7b||",
                "Cook": "4dg,0,19j,0,f7,0,7b|4dg,0,19j,0,fh,0,7b||",
                "Cuba": "7kh,0,f7,0,7b|7kh,0,fh,0,7b||",
                "Davis": "90o,0,7b|||",
                "DumontDUrville": "90n,0,7b|||",
                "East_Timor": "90m,0,7b|||",
                "Easter": "7kl,0,23e,0,f7,0,7b|7kl,0,23e,0,fh,0,7b||",
                "Ecuador": "90l,0,7b|||",
                "Europe_Central": "7kn,0,f7,0,7b|7kn,0,fh,0,7b|h0|h4",
                "Europe_Eastern": "4i4,0,f7,0,7b|4i4,0,fh,0,7b|gu|gv",
                "Europe_Further_Eastern": "4i4,0,90k,0,90i,0,90e|||",
                "Europe_Western": "7ks,0,f7,0,7b|7ks,0,fh,0,7b|h1|h2",
                "Falkland": "7kt,0,7ku,0,19j,0,f7,0,7b|7kt,0,7ku,0,19j,0,fh,0,7b||",
                "Fiji": "1fh,0,f7,0,7b|1fh,0,fh,0,7b||",
                "French_Guiana": "90d,0,90c,0,7b|||",
                "French_Southern": "909,0,908,0,4dm,0,906,0,901,0,7b|||",
                "Galapagos": "900,0,7b|||",
                "Gambier": "8vv,0,19j,0,7b|||",
                "Georgia": "7l8,0,f7,0,7b|7l8,0,fh,0,7b||",
                "Gilbert_Islands": "4i0,0,19j,0,7b|||",
                "GMT": "8vu,0,7b|||",
                "Greenland_Eastern": "7lb,0,f7,0,7b|7lb,0,fh,0,7b||",
                "Greenland_Western": "7lc,0,f7,0,7b|7lc,0,fh,0,7b||",
                "Gulf": "8vs,0,8vr,0,7b|||",
                "Guyana": "8vq,0,7b|||",
                "Hawaii_Aleutian": "7lg,0,f7,0,7b|7lg,0,fh,0,7b||",
                "Hong_Kong": "7lh,0,f7,0,7b|7lh,0,fh,0,7b||",
                "Hovd": "7li,0,f7,0,7b|7li,0,fh,0,7b||",
                "India": "7lj,0,f7,0,7b|||",
                "Indian_Ocean": "7lj,0,2p8,0,7b|||",
                "Indochina": "8vp,0,7b|||",
                "Indonesia_Central": "8vo,0,7b|||",
                "Indonesia_Eastern": "8vn,0,7b|||",
                "Indonesia_Western": "8vm,0,7b|||",
                "Iran": "7lo,0,f7,0,7b|7lo,0,fh,0,7b||",
                "Irkutsk": "7lp,0,f7,0,7b|7lp,0,fh,0,7b||",
                "Israel": "7lq,0,f7,0,7b|7lq,0,fh,0,7b||",
                "Japan": "7lr,0,f7,0,7b|7lr,0,fh,0,7b||",
                "Kamchatka": "7ls,5,7lt,0,f7,0,7b|7ls,5,7lt,0,fh,0,7b||",
                "Kazakhstan_Eastern": "8vi,0,7b|||",
                "Kazakhstan_Western": "8vh,0,7b|||",
                "Korea": "7m0,0,f7,0,7b|7m0,0,fh,0,7b||",
                "Kosrae": "6f,0,7b|||",
                "Krasnoyarsk": "7m1,0,f7,0,7b|7m1,0,fh,0,7b||",
                "Kyrgystan": "8vg,0,7b|||",
                "Line_Islands": "8ve,0,19j,0,7b|||",
                "Lord_Howe": "7m4,0,7m5,0,23e,0,f7,0,7b|7m4,0,7m5,0,23e,0,fh,0,7b||",
                "Macquarie": "8vd,0,23e,0,7b|||",
                "Magadan": "7m7,0,f7,0,7b|7m7,0,fh,0,7b||",
                "Malaysia": "8vc,0,7b|||",
                "Maldives": "8va,0,7b|||",
                "Marquesas": "8v9,0,19j,0,7b|||",
                "Marshall_Islands": "8v8,0,19j,0,7b|||",
                "Mauritius": "7mc,0,f7,0,7b|7mc,0,fh,0,7b||",
                "Mawson": "8v7,0,7b|||",
                "Mexico_Northwest": "7me,0,4ds,0,f7,0,7b|7me,0,4ds,0,fh,0,7b||",
                "Mexico_Pacific": "4ds,0,4d6,0,2p8,0,7mg,0,f7,0,7b|4ds,0,4d6,0,2p8,0,7mg,0,fh,0,7b||",
                "Mongolia": "7mh,0,f7,0,7b|7mh,0,fh,0,7b||",
                "Moscow": "7mi,0,f7,0,7b|7mi,0,fh,0,7b||",
                "Myanmar": "8v6,0,7b|||",
                "Nauru": "5v,0,7b|||",
                "Nepal": "8v5,0,7b|||",
                "New_Caledonia": "7ml,0,f7,0,7b|7ml,0,fh,0,7b||",
                "New_Zealand": "7mm,0,f7,0,7b|7mm,0,fh,0,7b||",
                "Newfoundland": "7mn,0,f7,0,7b|7mn,0,fh,0,7b||",
                "Niue": "8g,0,7b|||",
                "Norfolk": "8v4,0,23e,0,7b|||",
                "Noronha": "23a,0,4i,0,7mq,0,f7,0,7b|23a,0,4i,0,7mq,0,fh,0,7b||",
                "Novosibirsk": "7mr,0,f7,0,7b|7mr,0,fh,0,7b||",
                "Omsk": "7ms,0,f7,0,7b|7ms,0,fh,0,7b||",
                "Pakistan": "7mt,0,f7,0,7b|7mt,0,fh,0,7b||",
                "Palau": "9b,0,7b|||",
                "Papua_New_Guinea": "9a,5,8v3,0,7b|||",
                "Paraguay": "7mv,0,f7,0,7b|7mv,0,fh,0,7b||",
                "Peru": "4n,0,f7,0,7b|4n,0,fh,0,7b||",
                "Philippines": "7n0,0,f7,0,7b|7n0,0,fh,0,7b||",
                "Phoenix_Islands": "8v2,0,19j,0,7b|||",
                "Pierre_Miquelon": "7n2,0,4dm,0,7n3,0,f7,0,7b|7n2,0,4dm,0,7n3,0,fh,0,7b||",
                "Pitcairn": "8v1,0,7b|||",
                "Ponape": "8v0,0,7b|||",
                "Pyongyang": "8uv,0,7b|||",
                "Reunion": "8uu,0,7b|||",
                "Rothera": "8ut,0,7b|||",
                "Sakhalin": "7n9,0,f7,0,7b|7n9,0,fh,0,7b||",
                "Samara": "7na,0,f7,0,7b|7na,0,fh,0,7b||",
                "Samoa": "2c,0,f7,0,7b|2c,0,fh,0,7b||",
                "Seychelles": "8us,0,19j,0,7b|||",
                "Singapore": "8ur,0,7b|||",
                "Solomon": "8uq,0,19j,0,7b|||",
                "South_Georgia": "8up,0,7b|||",
                "Suriname": "8uo,0,7b|||",
                "Syowa": "8un,0,7b|||",
                "Tahiti": "198,0,7b|||",
                "Taipei": "7ni,0,f7,0,7b|7ni,0,fh,0,7b||",
                "Tajikistan": "8um,0,7b|||",
                "Tokelau": "5d,0,7b|||",
                "Tonga": "7nk,0,f7,0,7b|7nk,0,fh,0,7b||",
                "Truk": "8ul,0,7b|||",
                "Turkmenistan": "7nm,0,f7,0,7b|7nm,0,fh,0,7b||",
                "Tuvalu": "6h,0,7b|||",
                "Uruguay": "7nn,0,f7,0,7b|7nn,0,fh,0,7b||",
                "Uzbekistan": "7no,0,f7,0,7b|7no,0,fh,0,7b||",
                "Vanuatu": "2f,0,f7,0,7b|2f,0,fh,0,7b||",
                "Venezuela": "8uh,0,7b|||",
                "Vladivostok": "7nq,0,f7,0,7b|7nq,0,fh,0,7b||",
                "Volgograd": "7nr,0,f7,0,7b|7nr,0,fh,0,7b||",
                "Vostok": "8ug,0,7b|||",
                "Wake": "8uf,0,23e,0,7b|||",
                "Wallis": "8ue,0,4dm,0,8ud,0,7b|||",
                "Yakutsk": "7o0,0,f7,0,7b|7o0,0,fh,0,7b||",
                "Yekaterinburg": "7o1,0,f7,0,7b|7o1,0,fh,0,7b||"
            }
        },
        "mas-TZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mas": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mer": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mfe": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mgh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mgo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "mk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cc9,0,1q,0,m||",
                "Europe/London": "|6r5,0,1de,0,m||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,1de,0,od,0,ag,0,oe||",
                "Afghanistan": "i7,0,9l,0,2ak|||",
                "Africa_Central": "8uc,0,m|||",
                "Africa_Eastern": "8ub,0,m|||",
                "Africa_Southern": "i7,0,9l,0,8ua,0,8u9|||",
                "Africa_Western": "3q7,0,1q,0,m|3q7,0,1de,0,od,0,ag,0,oe||",
                "Alaska": "hi,0,m,0,9l,0,1jf|hl,0,od,0,ag,0,oe,0,9l,0,1jf||",
                "Amazon": "hi,0,m,0,9l,0,15q|hl,0,od,0,ag,0,oe,0,9l,0,15q||",
                "America_Central": "18j,0,1q,0,m,0,9l,0,26j,0,m6|18j,0,1de,0,od,0,ag,0,oe||",
                "America_Eastern": "12g,0,1q,0,m|12g,0,1de,0,od,0,ag,0,oe||",
                "America_Mountain": "4e3,0,1q,0,m|4e3,0,1de,0,od,0,ag,0,oe||",
                "America_Pacific": "4dv,0,1q,0,m|4dv,0,1de,0,od,0,ag,0,oe||",
                "Anadyr": "7og,0,1q,0,m|7og,0,1de,0,m||",
                "Apia": "hi,0,m,0,9l,0,1jh|hl,0,m,0,9l,0,1jh||",
                "Arabian": "hi,0,8u8,0,m|8u7,0,1de,0,od,0,ag,0,oe||",
                "Argentina": "hi,0,m,0,9l,0,hk|hl,0,od,0,ag,0,oe,0,9l,0,hk||",
                "Argentina_Western": "hi,0,m,0,9l,0,7ok,0,hk|hl,0,od,0,ag,0,oe,0,9l,0,7ok,0,hk||",
                "Armenia": "hi,0,m,0,9l,0,7ol|hl,0,m,0,9l,0,7ol||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,1de,0,od,0,ag,0,oe||",
                "Australia_Central": "hi,0,m,0,9l,0,2lu,0,218|hl,0,od,0,ag,0,oe,0,9l,0,2lu,0,218||",
                "Australia_CentralWestern": "hi,0,m,0,9l,0,2lu,0,il,0,16h,0,218|hl,0,od,0,ag,0,oe,0,9l,0,2lu,0,il,0,16h,0,218||",
                "Australia_Eastern": "hi,0,m,0,9l,0,4hl,0,218|hl,0,od,0,ag,0,oe,0,9l,0,4hl,0,218||",
                "Australia_Western": "hi,0,m,0,9l,0,16h,0,218|hl,0,od,0,ag,0,oe,0,9l,0,16h,0,218||",
                "Azerbaijan": "hi,0,m,0,9l,0,1b0|hl,0,m,0,9l,0,1b0||",
                "Azores": "hi,0,m,0,9l,0,7oq|hl,0,m,0,9l,0,7oq||",
                "Bangladesh": "hi,0,m,0,9l,0,q8|hl,0,m,0,9l,0,q8||",
                "Bhutan": "i7,0,9l,0,16f|||",
                "Bolivia": "i7,0,9l,0,27a|||",
                "Brasilia": "hi,0,m,0,9l,0,1bo|hl,0,od,0,ag,0,oe,0,9l,0,1bo||",
                "Brunei": "i7,0,9l,0,8u6,0,8u5|||",
                "Cape_Verde": "hi,0,m,0,ag,0,7ot,0,7ou|hl,0,m,0,ag,0,7ot,0,7ou||",
                "Chamorro": "i7,0,9l,0,1u7|||",
                "Chatham": "hi,0,m,0,9l,0,7ov|hl,0,od,0,ag,0,oe,0,9l,0,7ov||",
                "Chile": "hi,0,m,0,9l,0,1c0|hl,0,od,0,ag,0,oe,0,9l,0,1c0||",
                "China": "hi,0,m,0,9l,0,22t|hl,0,od,0,ag,0,oe,0,9l,0,22t||",
                "Choibalsan": "hi,0,m,0,9l,0,1c6|hl,0,m,0,9l,0,1c6||",
                "Christmas": "i7,0,ag,0,8u4,0,4l2|||",
                "Cocos": "i7,0,ag,0,8u3,0,1uj|||",
                "Colombia": "hi,0,m,0,9l,0,1ck|hl,0,od,0,ag,0,oe,0,9l,0,1ck||",
                "Cook": "hi,0,m,0,ag,0,30j,0,1p2|hl,0,m,0,ag,0,30j,0,1p2||",
                "Cuba": "hi,0,m,0,9l,0,ql|hl,0,od,0,ag,0,oe,0,9l,0,ql||",
                "Davis": "i7,0,9l,0,277|||",
                "DumontDUrville": "i7,0,9l,0,276,5,8u2|||",
                "East_Timor": "i7,0,9l,0,4f2,0,1ki|||",
                "Easter": "hi,0,m,0,ag,0,7p5,0,3qa|hl,0,m,0,ag,0,7p5,0,3qa||",
                "Ecuador": "i7,0,9l,0,274|||",
                "Europe_Central": "7p6,0,1q,0,m|7p6,0,1de,0,m|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,1de,0,m|gu|gv",
                "Europe_Further_Eastern": "8u1,0,m|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,1de,0,m|h1|h2",
                "Falkland": "hi,0,m,0,ag,0,7p8,0,1uj|hl,0,od,0,ag,0,oe,0,ag,0,7p8,0,1uj||",
                "Fiji": "hi,0,m,0,9l,0,1dn|hl,0,m,0,9l,0,1dn||",
                "French_Guiana": "i7,0,9l,0,272,0,1dr|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "i7,0,9l,0,1na|||",
                "Gambier": "i7,0,9l,0,8u0|||",
                "Georgia": "hi,0,m,0,9l,0,19a|hl,0,m,0,9l,0,19a||",
                "Gilbert_Islands": "i7,0,ag,0,30j,0,1ne|||",
                "GMT": "66b,0,m,0,1jo,0,8tv|||",
                "Greenland_Eastern": "hi,0,m,0,9l,0,4f2,0,ur|hl,0,od,0,ag,0,oe,0,9l,0,4f2,0,ur||",
                "Greenland_Western": "hi,0,m,0,9l,0,4hk,0,ur|hl,0,od,0,ag,0,oe,0,9l,0,4hk,0,ur||",
                "Gulf": "i7,0,ag,0,8tu,0,6di|||",
                "Guyana": "i7,0,9l,0,1dr|||",
                "Hawaii_Aleutian": "hi,0,m,0,9l,0,7pe,0,5,0,7pf,0,191|hl,0,od,0,ag,0,oe,0,9l,0,7pe,0,5,0,7pf,0,191||",
                "Hong_Kong": "hi,0,m,0,9l,0,19c,0,1eu|hl,0,m,0,9l,0,19c,0,1eu||",
                "Hovd": "hi,0,m,0,9l,0,qg|hl,0,m,0,9l,0,qg||",
                "India": "i7,0,9l,0,8tt|||",
                "Indian_Ocean": "i7,0,ag,0,8ts,0,1ao|||",
                "Indochina": "i7,0,9l,0,26p|||",
                "Indonesia_Central": "i7,0,9l,0,2lu,0,4hj|||",
                "Indonesia_Eastern": "i7,0,9l,0,4hl,0,4hj|||",
                "Indonesia_Western": "i7,0,9l,0,16h,0,4hj|||",
                "Iran": "hi,0,m,0,9l,0,rr|hl,0,od,0,ag,0,oe,0,9l,0,rr||",
                "Irkutsk": "hi,0,m,0,9l,0,12u|hl,0,m,0,9l,0,12u||",
                "Israel": "hi,0,m,0,9l,0,7pj|hl,0,od,0,ag,0,oe,0,9l,0,7pj||",
                "Japan": "hi,0,m,0,9l,0,7pk|hl,0,od,0,ag,0,oe,0,9l,0,7pk||",
                "Kazakhstan_Eastern": "i7,0,9l,0,4f2,0,180|||",
                "Kazakhstan_Western": "i7,0,9l,0,4hk,0,180|||",
                "Korea": "hi,0,m,0,9l,0,7pl|hl,0,od,0,ag,0,oe,0,9l,0,7pl||",
                "Kosrae": "i7,0,9l,0,8tr|||",
                "Krasnoyarsk": "hi,0,m,0,9l,0,1af|hl,0,m,0,9l,0,1af||",
                "Kyrgystan": "i7,0,9l,0,2bo|||",
                "Line_Islands": "i7,0,9l,0,8tq,0,1uj|||",
                "Lord_Howe": "hi,0,m,0,9l,0,oi,0,10a|hl,0,od,0,ag,0,oe,0,9l,0,oi,0,10a||",
                "Macquarie": "i7,0,ag,0,8tp,0,73i|||",
                "Magadan": "hi,0,m,0,9l,0,qq|hl,0,m,0,9l,0,qq||",
                "Malaysia": "i7,0,9l,0,26n|||",
                "Maldives": "i7,0,ag,0,26m|||",
                "Marquesas": "i7,0,9l,0,8to|||",
                "Marshall_Islands": "i7,0,ag,0,8tn,0,191|||",
                "Mauritius": "hi,0,m,0,ag,0,7ps|hl,0,od,0,ag,0,oe,0,ag,0,7ps||",
                "Mawson": "i7,0,9l,0,26k|||",
                "Mexico_Northwest": "hi,0,m,0,9l,0,3qb,0,187|hl,0,od,0,ag,0,oe,0,9l,0,3qb,0,187||",
                "Mexico_Pacific": "hi,0,2fm,0,m,0,9l,0,187|hl,0,2fm,0,m,0,9l,0,187||",
                "Mongolia": "hi,0,m,0,9l,0,or,0,qo|hl,0,m,0,9l,0,or,0,qo||",
                "Moscow": "hi,0,m,0,9l,0,r6|hl,0,od,0,ag,0,oe,0,9l,0,r6||",
                "Myanmar": "i7,0,9l,0,8tm|||",
                "Nauru": "i7,0,9l,0,14s|||",
                "Nepal": "i7,0,9l,0,16d|||",
                "New_Caledonia": "hi,0,m,0,9l,0,125,0,1bq|hl,0,m,0,9l,0,125,0,1bq||",
                "New_Zealand": "hi,0,m,0,9l,0,7pu,0,1bs|hl,0,od,0,ag,0,oe,0,9l,0,7pu,0,1bs||",
                "Newfoundland": "hi,0,m,0,ag,0,1bt|hl,0,od,0,ag,0,oe,0,ag,0,1bt||",
                "Niue": "i7,0,9l,0,1q4|||",
                "Norfolk": "i7,0,ag,0,30j,0,146|||",
                "Noronha": "hi,0,m,0,ag,0,138,0,13a,0,1bv|hl,0,od,0,ag,0,oe,0,ag,0,138,0,13a,0,1bv||",
                "Novosibirsk": "hi,0,m,0,9l,0,qt|hl,0,m,0,9l,0,qt||",
                "Omsk": "hi,0,m,0,9l,0,r5|hl,0,m,0,9l,0,r5||",
                "Pakistan": "hi,0,m,0,9l,0,rq|hl,0,m,0,9l,0,rq||",
                "Palau": "i7,0,9l,0,159|||",
                "Papua_New_Guinea": "i7,0,9l,0,13k,0,125,0,26i|||",
                "Paraguay": "hi,0,m,0,9l,0,1ca|hl,0,od,0,ag,0,oe,0,9l,0,1ca||",
                "Peru": "hi,0,m,0,9l,0,q1|hl,0,od,0,ag,0,oe,0,9l,0,q1||",
                "Philippines": "hi,0,m,0,9l,0,1cg|hl,0,m,0,9l,0,1cg||",
                "Phoenix_Islands": "i7,0,ag,0,30j,0,158|||",
                "Pierre_Miquelon": "hi,0,m,0,ag,0,2c3,0,1ci,0,il,0,7q0|hl,0,od,0,ag,0,oe,0,ag,0,2c3,0,1ci,0,il,0,7q0||",
                "Pitcairn": "i7,0,9l,0,1q6|||",
                "Ponape": "i7,0,9l,0,1v2|||",
                "Pyongyang": "8tl|||",
                "Reunion": "i7,0,ag,0,8tk|||",
                "Rothera": "i7,0,9l,0,157|||",
                "Sakhalin": "hi,0,m,0,9l,0,7q3|hl,0,m,0,9l,0,7q3||",
                "Samara": "17o,0,1q,0,m|17o,0,1de,0,od,0,ag,0,oe||",
                "Samoa": "hi,0,m,0,9l,0,p0|hl,0,m,0,9l,0,p0||",
                "Seychelles": "i7,0,ag,0,26h|||",
                "Singapore": "i7,0,9l,0,16b|||",
                "Solomon": "i7,0,ag,0,8tj,0,191|||",
                "South_Georgia": "i7,0,9l,0,26g,0,19a|||",
                "Suriname": "i7,0,9l,0,18v|||",
                "Syowa": "i7,0,9l,0,8ti|||",
                "Tahiti": "i7,0,9l,0,26f|||",
                "Taipei": "hi,0,m,0,9l,0,4dn|hl,0,od,0,ag,0,oe,0,9l,0,4dn||",
                "Tajikistan": "i7,0,9l,0,26e|||",
                "Tokelau": "i7,0,9l,0,156|||",
                "Tonga": "hi,0,m,0,9l,0,ot|hl,0,m,0,9l,0,ot||",
                "Truk": "i7,0,9l,0,1f2|||",
                "Turkmenistan": "hi,0,m,0,9l,0,1db|hl,0,m,0,9l,0,1db||",
                "Tuvalu": "i7,0,9l,0,14j|||",
                "Uruguay": "hi,0,m,0,9l,0,1dc|hl,0,od,0,ag,0,oe,0,9l,0,1dc||",
                "Uzbekistan": "hi,0,m,0,9l,0,108|hl,0,m,0,9l,0,108||",
                "Vanuatu": "hi,0,m,0,9l,0,os|hl,0,m,0,9l,0,os||",
                "Venezuela": "i7,0,9l,0,26c|||",
                "Vladivostok": "hi,0,m,0,9l,0,qn|hl,0,m,0,9l,0,qn||",
                "Volgograd": "hi,0,m,0,9l,0,q9|hl,0,od,0,ag,0,oe,0,9l,0,q9||",
                "Vostok": "i7,0,9l,0,155|||",
                "Wake": "i7,0,ag,0,8th,0,26b|||",
                "Wallis": "i7,0,9l,0,26a,0,il,0,14l|||",
                "Yakutsk": "hi,0,m,0,9l,0,1do|hl,0,m,0,9l,0,1do||",
                "Yekaterinburg": "hi,0,m,0,9l,0,136|hl,0,m,0,9l,0,136||"
            }
        },
        "ml": {
            "gmtFormat": "ജിഎംടി {0}",
            "gmtZeroFormat": "ജിഎംടി",
            "zone": {
                "Europe/Dublin": "|cca,0,cq,0,6a||",
                "Europe/London": "|ccb,0,mk,0,6a||"
            },
            "metazone": {
                "Acre": "7q7,0,cq,0,6a|7q7,0,1qb,0,6a||",
                "Afghanistan": "8tg,0,6a|||",
                "Africa_Central": "7qc,0,4fg,0,6a|||",
                "Africa_Eastern": "1jt,0,4fg,0,6a|||",
                "Africa_Southern": "8tf,0,cq,0,6a|||",
                "Africa_Western": "1ag,0,4fg,0,cq,0,6a|1ag,0,4fg,0,mk,0,6a||",
                "Alaska": "8te,0,cq,0,6a|8td,0,106,0,6a||",
                "Almaty": "7ql,0,cq,0,6a|7ql,0,1qb,0,6a||",
                "Amazon": "7qm,0,cq,0,6a|7qm,0,mk,0,6a||",
                "America_Central": "209,0,208,0,207,0,cq,0,6a|209,0,208,0,207,0,106,0,6a||",
                "America_Eastern": "209,0,208,0,1jt,0,cq,0,6a|209,0,208,0,1jt,0,106,0,6a||",
                "America_Mountain": "209,0,208,0,7qq,0,cq,0,6a|209,0,208,0,7qq,0,106,0,6a||",
                "America_Pacific": "209,0,208,0,4fr,0,cq,0,6a|209,0,208,0,4fr,0,106,0,6a||",
                "Anadyr": "7qs,0,cq,0,6a|7qs,0,1qb,0,6a||",
                "Apia": "7qt,0,cq,0,6a|7qt,0,106,0,6a||",
                "Aqtau": "7qu,0,cq,0,6a|7qu,0,1qb,0,6a||",
                "Aqtobe": "7qv,0,cq,0,6a|7qv,0,1qb,0,6a||",
                "Arabian": "7r0,0,cq,0,6a|7r0,0,106,0,6a||",
                "Argentina": "4fs,0,cq,0,6a|4fs,0,mk,0,6a||",
                "Argentina_Western": "1ag,0,4fs,0,cq,0,6a|1ag,0,4fs,0,mk,0,6a||",
                "Armenia": "7r2,0,cq,0,6a|7r2,0,mk,0,6a||",
                "Atlantic": "7r3,0,cq,0,6a|7r3,0,106,0,6a||",
                "Australia_Central": "4ft,0,207,0,cq,0,6a|4ft,0,207,0,106,0,6a||",
                "Australia_CentralWestern": "4ft,0,207,0,1ag,0,cq,0,6a|4ft,0,207,0,1ag,0,106,0,6a||",
                "Australia_Eastern": "4fu,0,1jt,0,cq,0,6a|4fu,0,1jt,0,106,0,6a||",
                "Australia_Western": "4fu,0,1ag,0,cq,0,6a|4fu,0,1ag,0,106,0,6a||",
                "Azerbaijan": "7r6,0,cq,0,6a|7r6,0,mk,0,6a||",
                "Azores": "7r7,0,cq,0,6a|7r7,0,mk,0,6a||",
                "Bangladesh": "7r8,0,cq,0,6a|7r8,0,mk,0,6a||",
                "Bhutan": "8tc,0,6a|||",
                "Bolivia": "8tb,0,6a|||",
                "Brasilia": "7rb,0,cq,0,6a|7rb,0,mk,0,6a||",
                "Brunei": "8ta,0,8t9,0,6a|||",
                "Cape_Verde": "7re,0,7rf,0,cq,0,6a|7re,0,7rf,0,mk,0,6a||",
                "Chamorro": "8t8,0,cq,0,6a|||",
                "Chatham": "7rh,0,cq,0,6a|7rh,0,mk,0,6a||",
                "Chile": "7ri,0,cq,0,6a|7ri,0,mk,0,6a||",
                "China": "7rj,0,cq,0,6a|7rj,0,106,0,6a||",
                "Choibalsan": "8t7,0,cq,0,6a|8t6,0,mk,0,6a||",
                "Christmas": "8t5,0,2ts,0,6a|||",
                "Cocos": "8t4,0,1ju,0,6a|||",
                "Colombia": "7rq,0,cq,0,6a|7rq,0,mk,0,6a||",
                "Cook": "7rr,0,1ju,0,cq,0,6a|7rr,0,1ju,0,8t3,0,mk,0,6a||",
                "Cuba": "7rt,0,cq,0,6a|7rt,0,106,0,6a||",
                "Davis": "8t2,0,6a|||",
                "DumontDUrville": "8t1,0,4hh,0,8t0,0,6a|||",
                "East_Timor": "1jt,0,8sv,0,6a|||",
                "Easter": "7s3,0,2ts,0,cq,0,6a|7s3,0,2ts,0,mk,0,6a||",
                "Ecuador": "8su,0,6a|||",
                "Europe_Central": "207,0,260,0,cq,0,6a|207,0,260,0,7s6,0,6a||",
                "Europe_Eastern": "1jt,0,260,0,cq,0,6a|1jt,0,260,0,7s6,0,6a||",
                "Europe_Further_Eastern": "8st,0,260,0,6a|||",
                "Europe_Western": "1ag,0,260,0,cq,0,6a|1ag,0,260,0,mk,0,6a||",
                "Falkland": "7s8,0,1ju,0,cq,0,6a|7s8,0,1ju,0,mk,0,6a||",
                "Fiji": "7s9,0,cq,0,6a|7s9,0,mk,0,6a||",
                "French_Guiana": "7sa,0,7sb,0,6a|||",
                "French_Southern": "7sa,0,8ss,k,0,8sr,0,6a|||",
                "Galapagos": "8sq,0,6a|||",
                "Gambier": "8sp,0,6a|||",
                "Georgia": "7sg,0,cq,0,6a|7sg,0,mk,0,6a||",
                "Gilbert_Islands": "8so,0,1ju,0,6a|||",
                "GMT": "8sn,0,8sm,0,6a|||",
                "Greenland_Eastern": "1jt,0,4gg,0,cq,0,6a|1jt,0,4gg,0,mk,0,6a||",
                "Greenland_Western": "1ag,0,4gg,0,cq,0,6a|1ag,0,4gg,0,mk,0,6a||",
                "Guam": "8sl,0,cq,0,6a|||",
                "Gulf": "8sk,0,cq,0,6a|||",
                "Guyana": "7sb,0,6a|||",
                "Hawaii_Aleutian": "7sn,5,7so,0,cq,0,6a|7sn,5,7so,0,106,0,6a||",
                "Hong_Kong": "7sp,0,cq,0,6a|7sp,0,mk,0,6a||",
                "Hovd": "7sq,0,cq,0,6a|7sq,0,mk,0,6a||",
                "India": "7sr,0,cq,0,6a||15a|",
                "Indian_Ocean": "7sr,0,8sj,0,6a|||",
                "Indochina": "8si,0,6a|||",
                "Indonesia_Central": "7qc,0,4mp,0,6a|||",
                "Indonesia_Eastern": "1jt,0,4mp,0,6a|||",
                "Indonesia_Western": "1ag,0,4mp,0,6a|||",
                "Iran": "7sv,0,cq,0,6a|7sv,0,106,0,6a||",
                "Irkutsk": "8sh,0,cq,0,6a|8sg,0,mk,0,6a||",
                "Israel": "7t2,0,cq,0,6a|7t2,0,106,0,6a||",
                "Japan": "7t3,0,cq,0,6a|7t3,0,106,0,6a||",
                "Kamchatka": "7t4,0,7t5,0,cq,0,6a|7t4,0,7t5,0,1qb,0,6a||",
                "Kazakhstan_Eastern": "1jt,0,7t6,0,6a|||",
                "Kazakhstan_Western": "1ag,0,7t6,0,6a|||",
                "Korea": "7t7,0,cq,0,6a|7t7,0,106,0,6a||",
                "Kosrae": "8sf,0,6a|||",
                "Krasnoyarsk": "7t9,0,cq,0,6a|7t9,0,mk,0,6a||",
                "Kyrgystan": "8se,0,6a|||",
                "Lanka": "8sd,0,6a|||",
                "Line_Islands": "8sc,0,1ju,0,6a|||",
                "Lord_Howe": "7td,0,7te,0,cq,0,6a|7td,0,7te,0,106,0,6a||",
                "Macau": "7tf,0,cq,0,6a|7tf,0,1qb,0,6a||",
                "Macquarie": "8sb,0,2ts,0,6a|||",
                "Magadan": "7th,0,cq,0,6a|7th,0,mk,0,6a||",
                "Malaysia": "8sa,0,6a|||",
                "Maldives": "8s9,0,6a|||",
                "Marquesas": "8s8,0,6a|||",
                "Marshall_Islands": "8s7,0,1ju,0,6a|||",
                "Mauritius": "7tm,0,cq,0,6a|7tm,0,mk,0,6a||",
                "Mawson": "8s6,0,6a|||",
                "Mexico_Northwest": "7to,0,7tp,0,cq,0,6a|7to,0,7tq,0,106,0,6a||",
                "Mexico_Pacific": "7tp,0,4fr,0,cq,0,6a|7tq,0,4fr,0,106,0,6a||",
                "Mongolia": "7tr,0,7ts,0,cq,0,6a|7tr,0,7ts,0,mk,0,6a||",
                "Moscow": "8s5,0,cq,0,6a|8s4,0,mk,0,6a||",
                "Myanmar": "8s3,0,6a|||",
                "Nauru": "8s2,0,6a|||",
                "Nepal": "8s1,0,6a|||",
                "New_Caledonia": "4hg,0,7u3,0,cq,0,6a|4hg,0,7u3,0,mk,0,6a||",
                "New_Zealand": "7u4,0,cq,0,6a|7u4,0,106,0,6a||",
                "Newfoundland": "7u5,0,cq,0,6a|7u5,0,106,0,6a||",
                "Niue": "8s0,0,6a|||",
                "Norfolk": "8rv,0,1ju,0,6a|||",
                "Noronha": "7u8,0,4hh,0,7u9,0,cq,0,6a|7u8,0,4hh,0,7u9,0,mk,0,6a||",
                "North_Mariana": "8ru,0,8rt,0,1ju,0,6a|||",
                "Novosibirsk": "8rs,0,cq,0,6a|8rr,0,mk,0,6a||",
                "Omsk": "7ue,0,cq,0,6a|7ue,0,mk,0,6a||",
                "Pakistan": "7uf,0,cq,0,6a|7uf,0,mk,0,6a||",
                "Palau": "8rq,0,6a|||",
                "Papua_New_Guinea": "8rp,0,4hg,0,8ro,0,6a|||",
                "Paraguay": "7uj,0,cq,0,6a|7uj,0,mk,0,6a||",
                "Peru": "7uk,0,cq,0,6a|7uk,0,mk,0,6a||",
                "Philippines": "7ul,0,cq,0,6a|7ul,0,mk,0,6a||",
                "Phoenix_Islands": "8rn,0,1ju,0,6a|||",
                "Pierre_Miquelon": "7un,0,7uo,0,7up,0,7uq,0,cq,0,6a|7un,0,7uo,0,7up,0,7uq,0,106,0,6a||",
                "Pitcairn": "8rm,0,6a|||",
                "Ponape": "8rl,0,6a|||",
                "Pyongyang": "8rk,0,6a|||",
                "Qyzylorda": "7uu,0,cq,0,6a|7uu,0,1qb,0,6a||",
                "Reunion": "8rj,0,6a|||",
                "Rothera": "8ri,0,6a|||",
                "Sakhalin": "7v1,0,cq,0,6a|7v1,0,mk,0,6a||",
                "Samara": "7v2,0,cq,0,6a|7v2,0,1qb,0,6a||",
                "Samoa": "8rh,0,cq,0,6a|8rg,0,mk,0,6a||",
                "Seychelles": "8rf,0,6a|||",
                "Singapore": "8re,0,cq,0,6a|||",
                "Solomon": "8rd,0,1ju,0,6a|||",
                "South_Georgia": "8rc,0,8rb,0,6a|||",
                "Suriname": "8ra,0,6a|||",
                "Syowa": "8r9,0,6a|||",
                "Tahiti": "8r8,0,6a|||",
                "Taipei": "7vd,0,cq,0,6a|7vd,0,106,0,6a||",
                "Tajikistan": "8r7,0,6a|||",
                "Tokelau": "8r6,0,6a|||",
                "Tonga": "7vg,0,cq,0,6a|7vg,0,mk,0,6a||",
                "Truk": "8r5,0,6a|||",
                "Turkmenistan": "7vi,0,cq,0,6a|7vi,0,mk,0,6a||",
                "Tuvalu": "8r4,0,6a|||",
                "Uruguay": "7vk,0,cq,0,6a|7vk,0,mk,0,6a||",
                "Uzbekistan": "7vl,0,cq,0,6a|7vl,0,mk,0,6a||",
                "Vanuatu": "7vm,0,cq,0,6a|7vm,0,mk,0,6a||",
                "Venezuela": "8r3,0,6a|||",
                "Vladivostok": "7vo,0,cq,0,6a|7vo,0,mk,0,6a||",
                "Volgograd": "7vp,0,cq,0,6a|7vp,0,mk,0,6a||",
                "Vostok": "8r2,0,6a|||",
                "Wake": "8r1,0,2ts,0,6a|||",
                "Wallis": "8r0,0,8qv,0,8qu,0,6a|||",
                "Yakutsk": "7vv,0,cq,0,6a|7vv,0,mk,0,6a||",
                "Yekaterinburg": "800,0,cq,0,6a|800,0,mk,0,6a||"
            }
        },
        "mn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ccc,0,ab,0,7g||",
                "Europe/London": "|ccd,0,gf,0,7g||"
            },
            "metazone": {
                "Afghanistan": "8qt,0,7g|||",
                "Africa_Central": "203,0,2te,0,7g|||",
                "Africa_Eastern": "1jv,0,2te,0,7g|||",
                "Africa_Southern": "4hm,0,2te,0,ab,0,7g|||",
                "Africa_Western": "1k1,0,2te,0,ab,0,7g|1k1,0,2te,0,gf,0,7g||",
                "Alaska": "80a,0,ab,0,7g|80a,0,gf,0,7g||",
                "Amazon": "80b,0,ab,0,7g|80b,0,gf,0,7g||",
                "America_Central": "203,0,ab,0,7g|203,0,gf,0,7g||",
                "America_Eastern": "1jv,0,202,0,ab,0,7g|1jv,0,202,0,gf,0,7g||",
                "America_Mountain": "80d,0,ab,0,7g|80d,0,gf,0,7g||",
                "America_Pacific": "80e,0,2s7,0,ab,0,7g|80e,0,2s7,0,gf,0,7g||",
                "Apia": "80g,0,ab,0,7g|80g,0,gf,0,7g||",
                "Arabian": "80h,0,ab,0,7g|80h,0,gf,0,7g||",
                "Argentina": "4e7,0,ab,0,7g|4e7,0,gf,0,7g||",
                "Argentina_Western": "1k1,0,4e7,0,ab,0,7g|1k1,0,4e7,0,gf,0,7g||",
                "Armenia": "80j,0,ab,0,7g|80j,0,gf,0,7g||",
                "Atlantic": "80k,0,ab,0,7g|80k,0,gf,0,7g||",
                "Australia_Central": "203,0,200,0,ab,0,7g|203,0,200,0,gf,0,7g||",
                "Australia_CentralWestern": "200,0,80m,0,4dq,0,202,0,ab,0,7g|200,0,80m,0,4dq,0,202,0,gf,0,7g||",
                "Australia_Eastern": "200,0,80o,0,202,0,ab,0,7g|200,0,80o,0,202,0,gf,0,7g||",
                "Australia_Western": "200,0,4dq,0,202,0,ab,0,7g|200,0,4dq,0,202,0,gf,0,7g||",
                "Azerbaijan": "80p,0,ab,0,7g|80p,0,gf,0,7g||",
                "Azores": "80q,0,ab,0,7g|80q,0,gf,0,7g||",
                "Bangladesh": "80r,0,ab,0,7g|80r,0,gf,0,7g||",
                "Bhutan": "8qs,0,7g|||",
                "Bolivia": "8qr,0,7g|||",
                "Brasilia": "80u,0,ab,0,7g|80u,0,gf,0,7g||",
                "Brunei": "1gr,0,8qq,0,7g|||",
                "Cape_Verde": "810,0,811,0,ab,0,7g|810,0,811,0,gf,0,7g||",
                "Chamorro": "8qp,0,7g|||",
                "Chatham": "813,0,ab,0,7g|813,0,gf,0,7g||",
                "Chile": "814,0,ab,0,7g|814,0,gf,0,7g||",
                "China": "4i2,0,ab,0,7g|4i2,0,gf,0,7g||",
                "Choibalsan": "816,0,ab,0,7g|816,0,gf,0,7g||",
                "Christmas": "72q,0,1p9,0,7g|||",
                "Cocos": "1le,0,1p9,0,7g|||",
                "Colombia": "818,0,ab,0,7g|818,0,gf,0,7g||",
                "Cook": "819,0,1p9,0,ab,0,7g|819,0,1p9,0,8qo,0,gf,0,7g||",
                "Cuba": "81b,0,ab,0,7g|81b,0,gf,0,7g||",
                "Davis": "8qn,0,7g|||",
                "DumontDUrville": "1gu,0,8qm,0,7g|||",
                "East_Timor": "1jv,0,8ql,0,7g|||",
                "Easter": "1jv,0,81f,0,ab,0,7g|1jv,0,81f,0,gf,0,7g||",
                "Ecuador": "8qk,0,7g|||",
                "Europe_Central": "203,0,28c,0,ab,0,7g|203,0,28c,0,gf,0,7g||",
                "Europe_Eastern": "1jv,0,28c,0,ab,0,7g|1jv,0,28c,0,gf,0,7g||",
                "Europe_Further_Eastern": "8qj,0,8qi,0,28c,0,7g|||",
                "Europe_Western": "1k1,0,28c,0,ab,0,7g|1k1,0,28c,0,gf,0,7g||",
                "Falkland": "81k,0,81l,0,ab,0,7g|81k,0,81l,0,gf,0,7g||",
                "Fiji": "81m,0,ab,0,7g|81m,0,gf,0,7g||",
                "French_Guiana": "81n,0,8qh,0,7g|||",
                "French_Southern": "81n,0,4hm,0,4c1,0,8qg,0,7g|||",
                "Galapagos": "8qf,0,7g|||",
                "Gambier": "8qe,0,7g|||",
                "Georgia": "81t,0,ab,0,7g|81t,0,gf,0,7g||",
                "Gilbert_Islands": "8qd,0,1p9,0,7g|||",
                "GMT": "8qc,0,8qb,0,7g|||",
                "Greenland_Eastern": "1jv,0,4an,0,ab,0,7g|1jv,0,4an,0,gf,0,7g||",
                "Greenland_Western": "1k1,0,4an,0,ab,0,7g|1k1,0,4an,0,gf,0,7g||",
                "Gulf": "8qa,0,ab,0,7g|||",
                "Guyana": "8q9,0,7g|||",
                "Hawaii_Aleutian": "824,5,825,0,ab,0,7g|824,5,825,0,gf,0,7g||",
                "Hong_Kong": "19c,0,826,0,ab,0,7g|19c,0,826,0,gf,0,7g||",
                "Hovd": "827,0,ab,0,7g|827,0,gf,0,7g||",
                "India": "828,0,7g|||",
                "Indian_Ocean": "828,0,2s7,0,7g|||",
                "Indochina": "8q8,5,4i2,0,8q7,0,7g|||",
                "Indonesia_Central": "203,0,4ig,0,7g|||",
                "Indonesia_Eastern": "1jv,0,4ig,0,7g|||",
                "Indonesia_Western": "1k1,0,4ig,0,7g|||",
                "Iran": "82c,0,ab,0,7g|82c,0,gf,0,7g||",
                "Irkutsk": "82d,0,ab,0,7g|82d,0,gf,0,7g||",
                "Israel": "82e,0,ab,0,7g|82e,0,gf,0,7g||",
                "Japan": "82f,0,ab,0,7g|82f,0,gf,0,7g||",
                "Kazakhstan_Eastern": "1jv,0,82g,0,7g|||",
                "Kazakhstan_Western": "1k1,0,82g,0,7g|||",
                "Korea": "82h,0,ab,0,7g|82h,0,gf,0,7g||",
                "Kosrae": "8q6,0,7g|||",
                "Krasnoyarsk": "82j,0,ab,0,7g|82j,0,gf,0,7g||",
                "Kyrgystan": "8q5,0,7g|||",
                "Line_Islands": "1eo,0,1p9,0,7g|||",
                "Lord_Howe": "oi,0,82l,0,ab,0,7g|oi,0,82l,0,gf,0,7g||",
                "Macquarie": "1l5,0,8q4,0,7g|||",
                "Magadan": "82n,0,ab,0,7g|82n,0,gf,0,7g||",
                "Malaysia": "8q3,0,7g|||",
                "Maldives": "8q2,0,7g|||",
                "Marquesas": "8q1,0,7g|||",
                "Marshall_Islands": "8q0,0,1p9,0,7g|||",
                "Mauritius": "82s,0,ab,0,7g|82s,0,gf,0,7g||",
                "Mawson": "8pv,0,7g|||",
                "Mexico_Northwest": "1k1,0,82u,0,45n,0,ab,0,7g|1k1,0,82u,0,45n,0,gf,0,7g||",
                "Mexico_Pacific": "45n,0,830,0,2s7,0,ab,0,7g|45n,0,830,0,2s7,0,gf,0,7g||",
                "Mongolia": "831,0,ab,0,7g|831,0,gf,0,7g||",
                "Moscow": "832,0,ab,0,7g|832,0,gf,0,7g||",
                "Myanmar": "8pu,0,7g|||",
                "Nauru": "8pt,0,7g|||",
                "Nepal": "8ps,0,7g|||",
                "New_Caledonia": "2q5,0,837,0,ab,0,7g|2q5,0,837,0,gf,0,7g||",
                "New_Zealand": "2q5,0,838,0,ab,0,7g|2q5,0,838,0,gf,0,7g||",
                "Newfoundland": "839,5,83a,0,ab,0,7g|839,5,83a,0,gf,0,7g||",
                "Niue": "8pr,0,7g|||",
                "Norfolk": "146,0,1p9,0,7g|||",
                "Noronha": "138,0,13a,0,83c,0,ab,0,7g|138,0,13a,0,83c,0,gf,0,7g||",
                "Novosibirsk": "83d,0,ab,0,7g|83d,0,gf,0,7g||",
                "Omsk": "83e,0,ab,0,7g|83e,0,gf,0,7g||",
                "Pakistan": "83f,0,ab,0,7g|83f,0,gf,0,7g||",
                "Palau": "8pq,0,7g|||",
                "Papua_New_Guinea": "13k,0,2q5,0,cef,0,7g|||",
                "Paraguay": "83i,0,ab,0,7g|83i,0,gf,0,7g||",
                "Peru": "83j,0,ab,0,7g|83j,0,gf,0,7g||",
                "Philippines": "1cf,0,ab,0,7g|1cf,0,gf,0,7g||",
                "Phoenix_Islands": "158,0,1p9,0,7g|||",
                "Pierre_Miquelon": "2c3,5,8po,0,4c1,0,83m,0,ab,0,7g|2c3,5,13m,0,4c1,0,83m,0,gf,0,7g||",
                "Pitcairn": "8pn,0,7g|||",
                "Ponape": "8pm,0,7g|||",
                "Pyongyang": "8pl,0,7g|||",
                "Reunion": "8pk,0,7g|||",
                "Rothera": "8pj,0,7g|||",
                "Sakhalin": "83s,0,ab,0,7g|83s,0,gf,0,7g||",
                "Samoa": "83t,0,ab,0,7g|83t,0,gf,0,7g||",
                "Seychelles": "8pi,0,7g|||",
                "Singapore": "8ph,0,7g|||",
                "Solomon": "8pg,0,8pf,0,7g|||",
                "South_Georgia": "4hm,0,8pe,0,7g|||",
                "Suriname": "8pd,0,7g|||",
                "Syowa": "8pc,0,7g|||",
                "Tahiti": "8pb,0,7g|||",
                "Taipei": "846,0,ab,0,7g|846,0,gf,0,7g||",
                "Tajikistan": "8pa,0,7g|||",
                "Tokelau": "8p9,0,7g|||",
                "Tonga": "849,0,ab,0,7g|849,0,gf,0,7g||",
                "Truk": "8p8,0,7g|||",
                "Turkmenistan": "84b,0,ab,0,7g|84b,0,gf,0,7g||",
                "Tuvalu": "8p7,0,7g|||",
                "Uruguay": "84d,0,ab,0,7g|84d,0,gf,0,7g||",
                "Uzbekistan": "84e,0,ab,0,7g|84e,0,gf,0,7g||",
                "Vanuatu": "84f,0,ab,0,7g|84f,0,gf,0,7g||",
                "Venezuela": "8p6,0,7g|||",
                "Vladivostok": "84h,0,ab,0,7g|84h,0,gf,0,7g||",
                "Volgograd": "84i,0,ab,0,7g|84i,0,gf,0,7g||",
                "Vostok": "8p5,0,7g|||",
                "Wake": "84k,0,1p9,0,7g|||",
                "Wallis": "1qq,0,4c1,0,8p4,0,7g|||",
                "Yakutsk": "84m,0,ab,0,7g|84m,0,gf,0,7g||",
                "Yekaterinburg": "84n,0,ab,0,7g|84n,0,gf,0,7g||"
            }
        },
        "mr": {
            "gmtFormat": "[GMT]{0}",
            "gmtZeroFormat": "[GMT]",
            "zone": {
                "Europe/Dublin": "|cce,0,f3,0,6u||",
                "Europe/London": "|6aa,0,mh,0,6u||"
            },
            "metazone": {
                "Acre": "8p3,0,1nk|8p2,0,4jl,0,6u||",
                "Afghanistan": "8p1,0,6u|||",
                "Africa_Central": "2um,0,2n2,0,6u|||",
                "Africa_Eastern": "1lo,0,2n2,0,6u|||",
                "Africa_Southern": "1jl,0,2n2,0,f3,0,6u|||",
                "Africa_Western": "124,0,2n2,0,f3,0,6u|124,0,2n2,0,mh,0,6u||",
                "Alaska": "4es,0,f3,0,6u|4es,0,sm,0,6u||",
                "Almaty": "852,0,1nk|852,0,a5,0,6u||",
                "Amazon": "853,0,f3,0,6u|853,0,mh,0,6u||",
                "America_Central": "1s4,0,f3,0,6u|1s4,0,sm,0,6u||",
                "America_Eastern": "3sn,0,f3,0,6u|3sn,0,sm,0,6u||",
                "America_Mountain": "855,0,f3,0,6u|855,0,sm,0,6u||",
                "America_Pacific": "3sm,0,f3,0,6u|3sm,0,sm,0,6u||",
                "Anadyr": "4er,0,1nk|4er,0,a5,0,6u||",
                "Apia": "857,0,f3,0,6u|857,0,sm,0,6u||",
                "Aqtau": "858,0,1nk|858,0,a5,0,6u||",
                "Aqtobe": "859,0,1nk|859,0,a5,0,6u||",
                "Arabian": "85a,0,f3,0,6u|85a,0,sm,0,6u||",
                "Argentina": "3si,0,f3,0,6u|3si,0,mh,0,6u||",
                "Argentina_Western": "q4,0,3si,0,f3,0,6u|q4,0,3si,0,mh,0,6u||",
                "Armenia": "365,0,f3,0,6u|365,0,mh,0,6u||",
                "Atlantic": "364,0,f3,0,6u|364,0,sm,0,6u||",
                "Australia_Central": "1vm,0,1a6,0,f3,0,6u|1vm,0,1a6,0,sm,0,6u||",
                "Australia_CentralWestern": "1vm,0,1a6,5,124,0,f3,0,6u|1vm,0,1a6,5,124,0,sm,0,6u||",
                "Australia_Eastern": "1vm,0,1lo,0,f3,0,6u|1vm,0,1lo,0,sm,0,6u||",
                "Australia_Western": "1vm,0,124,0,f3,0,6u|1vm,0,124,0,sm,0,6u||",
                "Azerbaijan": "85d,0,f3,0,6u|85d,0,mh,0,6u||",
                "Azores": "85e,0,f3,0,6u|85e,0,mh,0,6u||",
                "Bangladesh": "4eo,0,f3,0,6u|4eo,0,mh,0,6u||",
                "Bhutan": "8p0,0,6u|||",
                "Bolivia": "8ov,0,6u|||",
                "Brasilia": "85h,0,f3,0,6u|85h,0,mh,0,6u||",
                "Brunei": "54g,0,8ou,0,6u|||",
                "Cape_Verde": "1s1,0,85j,0,f3,0,6u|1s1,0,85j,0,mh,0,6u||",
                "Chamorro": "4sr,0,f3,0,6u|||",
                "Chatham": "85k,0,f3,0,6u|85k,0,sm,0,6u||",
                "Chile": "1s0,0,f3,0,6u|1s0,0,mh,0,6u||",
                "China": "85l,0,f3,0,6u|85l,0,sm,0,6u||",
                "Choibalsan": "85m,0,f3,0,6u|85m,0,mh,0,6u||",
                "Christmas": "8ot,0,2ag,0,6u|||",
                "Cocos": "8os,0,1k5,0,6u|||",
                "Colombia": "2b7,0,f3,0,6u|2b7,0,mh,0,6u||",
                "Cook": "1lj,0,1k5,0,f3,0,6u|1lj,0,1k5,0,597,0,mh,0,6u||",
                "Cuba": "360,0,f3,0,6u|360,0,sm,0,6u||",
                "Davis": "8or,0,6u|||",
                "DumontDUrville": "8oq,5,8op,0,6u|||",
                "East_Timor": "1lo,0,4t7,0,6u|||",
                "Easter": "2ds,0,2ag,0,f3,0,6u|2ds,0,2ag,0,mh,0,6u||",
                "Ecuador": "8oo,0,6u|||",
                "Europe_Central": "2um,0,2dv,0,f3,0,6u|2um,0,2dv,0,mh,0,6u||",
                "Europe_Eastern": "1lo,0,2dv,0,f3,0,6u|1lo,0,2dv,0,mh,0,6u||",
                "Europe_Further_Eastern": "4tc,5,3sn,0,8on,0,6u|||",
                "Europe_Western": "124,0,2dv,0,f3,0,6u|124,0,2dv,0,mh,0,6u||",
                "Falkland": "862,0,1k5,0,f3,0,6u|862,0,1k5,0,mh,0,6u||",
                "Fiji": "2e1,0,f3,0,6u|2e1,0,mh,0,6u||",
                "French_Guiana": "864,0,865,0,6u|||",
                "French_Southern": "864,0,1jl,0,3rm,0,8om,0,6u|||",
                "Galapagos": "8ol,0,6u|||",
                "Gambier": "8oj,0,6u|||",
                "Georgia": "27i,0,f3,0,6u|27i,0,mh,0,6u||",
                "Gilbert_Islands": "35s,0,1k5,0,6u|||",
                "GMT": "8of,0,f3,0,6u|||",
                "Greenland_Eastern": "1lo,0,3re,0,f3,0,6u|1lo,0,3re,0,mh,0,6u||",
                "Greenland_Western": "124,0,3re,0,f3,0,6u|124,0,3re,0,mh,0,6u||",
                "Guam": "5e7,0,1nk|||",
                "Gulf": "4kg,0,f3,0,6u|||",
                "Guyana": "865,0,6u|||",
                "Hawaii_Aleutian": "21u,5,86d,0,f3,0,6u|21u,5,86d,0,sm,0,6u||",
                "Hong_Kong": "35p,0,35o,0,f3,0,6u|35p,0,35o,0,mh,0,6u||",
                "Hovd": "86e,0,f3,0,6u|86e,0,mh,0,6u||",
                "India": "27j,0,f3,0,6u||15a|",
                "Indian_Ocean": "8oe,0,6u|||",
                "Indochina": "8od,0,6u|||",
                "Indonesia_Central": "2um,0,2j0,0,6u|||",
                "Indonesia_Eastern": "3sn,0,2j0,0,6u|||",
                "Indonesia_Western": "q4,0,2j0,0,6u|||",
                "Iran": "86h,0,f3,0,6u|86h,0,sm,0,6u||",
                "Irkutsk": "86i,0,f3,0,6u|86i,0,mh,0,6u||",
                "Israel": "86j,0,f3,0,6u|86j,0,sm,0,6u||",
                "Japan": "4ef,0,f3,0,6u|4ef,0,sm,0,6u||",
                "Kamchatka": "86k,5,0,86l,0,1nk|86k,5,0,86l,0,a5,0,6u||",
                "Kazakhstan_Eastern": "1lo,0,86m,0,6u|||",
                "Kazakhstan_Western": "124,0,86m,0,6u|||",
                "Korea": "86n,0,f3,0,6u|86n,0,sm,0,6u||",
                "Kosrae": "8oa,0,6u|||",
                "Krasnoyarsk": "4rl,0,f3,0,6u|8o9,0,mh,0,6u||",
                "Kyrgystan": "8o8,0,6u|||",
                "Lanka": "5m0,0,6u|||",
                "Line_Islands": "35k,0,1k5,0,6u|||",
                "Lord_Howe": "35j,0,35i,0,f3,0,6u|35j,0,35i,0,sm,0,6u||",
                "Macau": "86r,0,1nk|86r,0,a5,0,6u||",
                "Macquarie": "8o7,0,2ag,0,6u|||",
                "Magadan": "86t,0,f3,0,6u|86t,0,mh,0,6u||",
                "Malaysia": "4hp,0,6u|||",
                "Maldives": "8o6,0,6u|||",
                "Marquesas": "8o5,0,6u|||",
                "Marshall_Islands": "2ob,0,1k5,0,6u|||",
                "Mauritius": "35e,0,f3,0,6u|35e,0,mh,0,6u||",
                "Mawson": "5mg,0,6u|||",
                "Mexico_Northwest": "870,0,2ja,0,f3,0,6u|870,0,2ja,0,sm,0,6u||",
                "Mexico_Pacific": "2ja,0,3sm,0,f3,0,6u|2ja,0,3sm,0,sm,0,6u||",
                "Mongolia": "1rp,0,2e6,0,f3,0,6u|1rp,0,2e6,0,mh,0,6u||",
                "Moscow": "2lk,0,f3,0,6u|2lk,0,mh,0,6u||",
                "Myanmar": "4ed,0,6u|||",
                "Nauru": "8o4,0,6u|||",
                "Nepal": "8o3,0,6u|||",
                "New_Caledonia": "1ld,0,874,0,f3,0,6u|1ld,0,874,0,mh,0,6u||",
                "New_Zealand": "875,0,f3,0,6u|875,0,sm,0,6u||",
                "Newfoundland": "1ld,0,876,0,f3,0,6u|1ld,0,876,0,sm,0,6u||",
                "Niue": "8o2,0,6u|||",
                "Norfolk": "5od,0,2ag,0,6u|||",
                "Noronha": "878,0,879,0,1n8,0,f3,0,6u|878,0,879,0,1n8,0,mh,0,6u||",
                "North_Mariana": "2a5,0,8o1,0,1k5,0,6u|||",
                "Novosibirsk": "356,0,f3,0,6u|356,0,mh,0,6u||",
                "Omsk": "1nb,0,f3,0,6u|1nb,0,mh,0,6u||",
                "Pakistan": "2li,0,f3,0,6u|2li,0,mh,0,6u||",
                "Palau": "5os,0,6u|||",
                "Papua_New_Guinea": "4hr,0,1ld,0,355,0,6u|||",
                "Paraguay": "87b,0,f3,0,6u|87b,0,mh,0,6u||",
                "Peru": "2k9,0,f3,0,6u|2k9,0,mh,0,6u||",
                "Philippines": "87c,0,f3,0,6u|87c,0,mh,0,6u||",
                "Phoenix_Islands": "8o0,0,1k5,0,6u|||",
                "Pierre_Miquelon": "351,0,87e,0,3rm,0,87f,0,f3,0,6u|351,0,87e,0,3rm,0,87f,0,sm,0,6u||",
                "Pitcairn": "4vf,0,6u|||",
                "Ponape": "8nv,0,6u|||",
                "Pyongyang": "8nu,0,6u|||",
                "Qyzylorda": "87i,0,1nk|87i,0,a5,0,6u||",
                "Reunion": "4l0,0,6u|||",
                "Rothera": "2qb,0,6u|||",
                "Sakhalin": "87k,0,f3,0,6u|87k,0,mh,0,6u||",
                "Samara": "87l,0,1nk|87l,0,a5,0,6u||",
                "Samoa": "87m,0,f3,0,6u|87m,0,sm,0,6u||",
                "Seychelles": "5qu,0,6u|||",
                "Singapore": "8nt,0,f3,0,6u|||",
                "Solomon": "8ns,0,1k5,0,6u|||",
                "South_Georgia": "1jl,0,27i,0,6u|||",
                "Suriname": "8nr,0,6u|||",
                "Syowa": "34v,0,6u|||",
                "Tahiti": "34u,0,6u|||",
                "Taipei": "87q,0,f3,0,6u|87q,0,sm,0,6u||",
                "Tajikistan": "4vq,0,6u|||",
                "Tokelau": "4vr,0,6u|||",
                "Tonga": "1rl,0,f3,0,6u|1rl,0,mh,0,6u||",
                "Truk": "4vt,0,6u|||",
                "Turkmenistan": "1ri,0,f3,0,6u|1ri,0,mh,0,6u||",
                "Tuvalu": "4vv,0,6u|||",
                "Uruguay": "2jp,0,f3,0,6u|2jp,0,mh,0,6u||",
                "Uzbekistan": "87r,0,f3,0,6u|87r,0,mh,0,6u||",
                "Vanuatu": "87s,0,f3,0,6u|87s,0,mh,0,6u||",
                "Venezuela": "8nq,0,6u|||",
                "Vladivostok": "34t,0,f3,0,6u|34t,0,mh,0,6u||",
                "Volgograd": "87u,0,f3,0,6u|87u,0,mh,0,6u||",
                "Vostok": "8np,0,6u|||",
                "Wake": "34s,0,2ag,0,6u|||",
                "Wallis": "8no,0,3rm,0,4l7,0,6u|||",
                "Yakutsk": "882,0,f3,0,6u|882,0,mh,0,6u||",
                "Yekaterinburg": "883,0,f3,0,6u|883,0,mh,0,6u||"
            }
        },
        "ms-BN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|u,0,5i,0,5h,0,3i4||",
                "Europe/London": "|u,0,5i,0,5h,0,c1||"
            },
            "metazone": {
                "Afghanistan": "u,0,b6|||",
                "Africa_Central": "u,0,c5,0,pl|||",
                "Africa_Eastern": "u,0,c5,0,mt|||",
                "Africa_Southern": "u,0,5p,0,c5,0,1jj|||",
                "Africa_Western": "u,0,5p,0,c5,0,ht|u,0,5i,0,5h,0,c5,0,ht||",
                "Alaska": "u,0,5p,0,3p|u,0,fq,0,3p||",
                "Amazon": "u,0,5p,0,5m|u,0,5i,0,5h,0,5m||",
                "America_Central": "u,0,5p,0,4la|u,0,fq,0,pl||",
                "America_Eastern": "u,0,5p,0,mt|u,0,fq,0,mt||",
                "America_Mountain": "u,0,5p,0,2g4|u,0,4lc,0,fq,0,2g4||",
                "America_Pacific": "u,0,5p,0,10c|u,0,fq,0,10c||",
                "Anadyr": "u,0,5p,0,3l|u,0,5i,0,5h,0,3l||",
                "Apia": "u,0,4,0,3e|u,0,fq,0,3e||",
                "Arabian": "u,0,5p,0,1qe|u,0,fq,0,1qe||",
                "Argentina": "u,0,5p,0,1e|u,0,5i,0,5h,0,1e||",
                "Argentina_Western": "u,0,5p,0,1e,0,ht|u,0,5i,0,5h,0,1e,0,ht||",
                "Armenia": "u,0,5p,0,4l|u,0,5i,0,5h,0,4l||",
                "Atlantic": "u,0,5p,0,r2|u,0,fq,0,r2||",
                "Australia_Central": "u,0,5p,0,4c,0,pl|u,0,fq,0,4c,0,pl||",
                "Australia_CentralWestern": "u,0,5p,0,ht,0,pl,0,4c|u,0,fq,0,ht,0,pl,0,4c||",
                "Australia_Eastern": "u,0,5p,0,mt,0,4c|u,0,fq,0,4c,0,mt||",
                "Australia_Western": "u,0,5p,0,4c,0,ht|u,0,fq,0,4c,0,ht||",
                "Azerbaijan": "u,0,5p,0,7m|u,0,5i,0,5h,0,7m||",
                "Azores": "u,0,5p,0,4r|u,0,5i,0,5h,0,4r||",
                "Bangladesh": "u,0,5p,0,3n|u,0,5i,0,5h,0,3n||",
                "Bhutan": "u,0,as|||",
                "Bolivia": "u,0,aa|||",
                "Brasilia": "u,0,5p,0,3a|u,0,5i,0,5h,0,3a||",
                "Brunei": "u,0,9o,0,a4|||",
                "Cape_Verde": "u,0,5p,0,1rs,0,3j|u,0,5i,0,5h,0,1rs,0,3j||",
                "Chamorro": "u,0,5p,0,6j|||",
                "Chatham": "u,0,5p,0,27|u,0,fq,0,27||",
                "Chile": "u,0,5p,0,49|u,0,5i,0,5h,0,49||",
                "China": "u,0,5p,0,4h|u,0,fq,0,4h||",
                "Choibalsan": "u,0,5p,0,2q|u,0,5i,0,5h,0,2q||",
                "Christmas": "u,0,15f,0,99|||",
                "Cocos": "u,0,oo,0,7v|||",
                "Colombia": "u,0,5p,0,4m|u,0,5i,0,5h,0,4m||",
                "Cook": "u,0,5p,0,oo,0,2v|u,0,5i,0,5h,0,4ld,0,oo,0,2v||",
                "Cuba": "u,0,5p,0,34|u,0,fq,0,34||",
                "Davis": "u,0,5s|||",
                "DumontDUrville": "u,0,5b,5,5j|||",
                "East_Timor": "u,0,7n,0,mt|||",
                "Easter": "u,0,5p,0,15f,0,7t|u,0,5i,0,5h,0,15f,0,7t||",
                "Ecuador": "u,0,ai|||",
                "Europe_Central": "u,0,5p,0,13b,0,pl|u,0,5i,0,5h,0,13b,0,pl||",
                "Europe_Eastern": "u,0,5p,0,13b,0,mt|u,0,5i,0,5h,0,13b,0,mt||",
                "Europe_Further_Eastern": "u,0,13b,0,4lf,0,4lg|||",
                "Europe_Western": "u,0,5p,0,13b,0,ht|u,0,5i,0,5h,0,13b,0,ht||",
                "Falkland": "u,0,5p,0,oo,0,4v|u,0,5i,0,5h,0,oo,0,4v||",
                "Fiji": "u,0,5p,0,4q|u,0,5i,0,5h,0,4q||",
                "French_Guiana": "u,0,7a,0,2g6|||",
                "French_Southern": "u,0,2g6,0,1jj,0,17t,0,4li|||",
                "Galapagos": "u,0,ak|||",
                "Gambier": "u,0,6v|||",
                "Georgia": "u,0,5p,0,2u|u,0,5i,0,5h,0,2u||",
                "Gilbert_Islands": "u,0,oo,0,6q|||",
                "GMT": "u,0,4lj,0,5u|||",
                "Greenland_Eastern": "u,0,5p,0,2k,0,mt|u,0,5i,0,5h,0,2k,0,mt||",
                "Greenland_Western": "u,0,5p,0,2k,0,ht|u,0,5i,0,5h,0,2k,0,ht||",
                "Gulf": "u,0,367|||",
                "Guyana": "u,0,7a|||",
                "Hawaii_Aleutian": "u,0,5p,0,4g,5,62|u,0,fq,0,4g,5,62||",
                "Hong_Kong": "u,0,5p,0,2l,0,2p|u,0,5i,0,5h,0,2l,0,2p||",
                "Hovd": "u,0,5p,0,2g|u,0,5i,0,5h,0,2g||",
                "India": "u,0,5p,0,af|||",
                "Indian_Ocean": "u,0,4lk,0,1to|||",
                "Indochina": "u,0,9p|||",
                "Indonesia_Central": "u,0,2t,0,pl|||",
                "Indonesia_Eastern": "u,0,2t,0,mt|||",
                "Indonesia_Western": "u,0,2t,0,ht|||",
                "Iran": "u,0,5p,0,5g|u,0,fq,0,5g||",
                "Irkutsk": "u,0,5p,0,3h|u,0,5i,0,5h,0,3h||",
                "Israel": "u,0,5p,0,4e|u,0,fq,0,4e||",
                "Japan": "u,0,5p,0,2g8|u,0,fq,0,2g8||",
                "Kamchatka": "u,0,5p,0,37,5,3k|u,0,5i,0,5h,0,37,5,3k||",
                "Kazakhstan_Eastern": "u,0,45,0,mt|||",
                "Kazakhstan_Western": "u,0,45,0,ht|||",
                "Korea": "u,0,5p,0,qf|u,0,fq,0,qf||",
                "Kosrae": "u,0,6f|||",
                "Krasnoyarsk": "u,0,5p,0,41|u,0,5i,0,5h,0,41||",
                "Kyrgystan": "u,0,bl|||",
                "Line_Islands": "u,0,oo,0,ac|||",
                "Lord_Howe": "u,0,5p,0,1u,0,24|u,0,fq,0,1u,0,24||",
                "Macquarie": "u,0,15f,0,6m|||",
                "Magadan": "u,0,5p,0,2o|u,0,5i,0,5h,0,2o||",
                "Malaysia": "u,0,bf||1r5|",
                "Maldives": "u,0,9k|||",
                "Marquesas": "u,0,9e|||",
                "Marshall_Islands": "u,0,oo,0,7o|||",
                "Mauritius": "u,0,5p,0,4u|u,0,5i,0,5h,0,4u||",
                "Mawson": "u,0,63|||",
                "Mexico_Northwest": "u,0,5p,0,ht,0,1se,0,5e|u,0,fq,0,ht,0,1se,0,5e||",
                "Mexico_Pacific": "u,0,5p,0,10c,0,5e|u,0,fq,0,10c,0,5e||",
                "Mongolia": "u,0,5p,0,4f,0,2m|u,0,5i,0,5h,0,4f,0,2m||",
                "Moscow": "u,0,5p,0,71|u,0,5i,0,5h,0,71||",
                "Myanmar": "u,0,8v|||",
                "Nauru": "u,0,5v|||",
                "Nepal": "u,0,8u|||",
                "New_Caledonia": "u,0,5p,0,1m,0,4o|u,0,5i,0,5h,0,1m,0,4o||",
                "New_Zealand": "u,0,5p,0,1m,0,74|u,0,fq,0,1m,0,74||",
                "Newfoundland": "u,0,5p,0,53|u,0,fq,0,53||",
                "Niue": "u,0,8g|||",
                "Norfolk": "u,0,oo,0,6l|||",
                "Noronha": "u,0,5p,0,1s,0,2,0,23|u,0,5i,0,5h,0,1s,0,2,0,23||",
                "Novosibirsk": "u,0,5p,0,3b|u,0,5i,0,5h,0,3b||",
                "Omsk": "u,0,5p,0,26|u,0,5i,0,5h,0,26||",
                "Pakistan": "u,0,5p,0,3i|u,0,5i,0,5h,0,3i||",
                "Palau": "u,0,9b|||",
                "Papua_New_Guinea": "u,0,9a,0,1m,0,a8|||",
                "Paraguay": "u,0,5p,0,3c|u,0,5i,0,5h,0,3c||",
                "Peru": "u,0,5p,0,4n|u,0,5i,0,5h,0,4n||",
                "Philippines": "u,0,5p,0,1sg|u,0,5i,0,5h,0,1sg||",
                "Phoenix_Islands": "u,0,oo,0,90|||",
                "Pierre_Miquelon": "u,0,5p,0,8i,0,33,0,17t,0,35|u,0,fq,0,8i,0,33,0,17t,0,35||",
                "Pitcairn": "u,0,7e|||",
                "Ponape": "u,0,9s|||",
                "Pyongyang": "u,0,8a|||",
                "Reunion": "u,0,b4|||",
                "Rothera": "u,0,5q|||",
                "Sakhalin": "u,0,5p,0,55|u,0,5i,0,5h,0,55||",
                "Samara": "u,0,5p,0,29|u,0,5i,0,5h,0,29||",
                "Samoa": "u,0,5p,0,2c|u,0,5i,0,5h,0,2c||",
                "Seychelles": "u,0,8k|||",
                "Singapore": "u,0,5p,0,196||2ad|",
                "Solomon": "u,0,oo,0,b5|||",
                "South_Georgia": "u,0,2u,0,1jj|||",
                "Suriname": "u,0,8q|||",
                "Syowa": "u,0,65|||",
                "Tahiti": "u,0,8n|||",
                "Taipei": "u,0,5p,0,3d|u,0,fq,0,3d||",
                "Tajikistan": "u,0,bj|||",
                "Tokelau": "u,0,5d|||",
                "Tonga": "u,0,5p,0,2j|u,0,5i,0,5h,0,2j||",
                "Truk": "u,0,6p|||",
                "Turkmenistan": "u,0,5p,0,4t|u,0,5i,0,5h,0,4t||",
                "Tuvalu": "u,0,6h|||",
                "Uruguay": "u,0,5p,0,4k|u,0,5i,0,5h,0,4k||",
                "Uzbekistan": "u,0,5p,0,60|u,0,5i,0,5h,0,60||",
                "Vanuatu": "u,0,5p,0,2f|u,0,5i,0,5h,0,2f||",
                "Venezuela": "u,0,7s|||",
                "Vladivostok": "u,0,5p,0,28|u,0,5i,0,5h,0,28||",
                "Volgograd": "u,0,5p,0,3f|u,0,5i,0,5h,0,3f||",
                "Vostok": "u,0,5t|||",
                "Wake": "u,0,15f,0,5r|||",
                "Wallis": "u,0,5f,0,17t,0,5k|||",
                "Yakutsk": "u,0,5p,0,3u|u,0,5i,0,5h,0,3u||",
                "Yekaterinburg": "u,0,5p,0,5l|u,0,5i,0,5h,0,5l||"
            }
        },
        "ms-SG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|u,0,5i,0,5h,0,3i4||",
                "Europe/London": "|u,0,5i,0,5h,0,c1||"
            },
            "metazone": {
                "Afghanistan": "u,0,b6|||",
                "Africa_Central": "u,0,c5,0,pl|||",
                "Africa_Eastern": "u,0,c5,0,mt|||",
                "Africa_Southern": "u,0,5p,0,c5,0,1jj|||",
                "Africa_Western": "u,0,5p,0,c5,0,ht|u,0,5i,0,5h,0,c5,0,ht||",
                "Alaska": "u,0,5p,0,3p|u,0,fq,0,3p||",
                "Amazon": "u,0,5p,0,5m|u,0,5i,0,5h,0,5m||",
                "America_Central": "u,0,5p,0,4la|u,0,fq,0,pl||",
                "America_Eastern": "u,0,5p,0,mt|u,0,fq,0,mt||",
                "America_Mountain": "u,0,5p,0,2g4|u,0,4lc,0,fq,0,2g4||",
                "America_Pacific": "u,0,5p,0,10c|u,0,fq,0,10c||",
                "Anadyr": "u,0,5p,0,3l|u,0,5i,0,5h,0,3l||",
                "Apia": "u,0,4,0,3e|u,0,fq,0,3e||",
                "Arabian": "u,0,5p,0,1qe|u,0,fq,0,1qe||",
                "Argentina": "u,0,5p,0,1e|u,0,5i,0,5h,0,1e||",
                "Argentina_Western": "u,0,5p,0,1e,0,ht|u,0,5i,0,5h,0,1e,0,ht||",
                "Armenia": "u,0,5p,0,4l|u,0,5i,0,5h,0,4l||",
                "Atlantic": "u,0,5p,0,r2|u,0,fq,0,r2||",
                "Australia_Central": "u,0,5p,0,4c,0,pl|u,0,fq,0,4c,0,pl||",
                "Australia_CentralWestern": "u,0,5p,0,ht,0,pl,0,4c|u,0,fq,0,ht,0,pl,0,4c||",
                "Australia_Eastern": "u,0,5p,0,mt,0,4c|u,0,fq,0,4c,0,mt||",
                "Australia_Western": "u,0,5p,0,4c,0,ht|u,0,fq,0,4c,0,ht||",
                "Azerbaijan": "u,0,5p,0,7m|u,0,5i,0,5h,0,7m||",
                "Azores": "u,0,5p,0,4r|u,0,5i,0,5h,0,4r||",
                "Bangladesh": "u,0,5p,0,3n|u,0,5i,0,5h,0,3n||",
                "Bhutan": "u,0,as|||",
                "Bolivia": "u,0,aa|||",
                "Brasilia": "u,0,5p,0,3a|u,0,5i,0,5h,0,3a||",
                "Brunei": "u,0,9o,0,a4|||",
                "Cape_Verde": "u,0,5p,0,1rs,0,3j|u,0,5i,0,5h,0,1rs,0,3j||",
                "Chamorro": "u,0,5p,0,6j|||",
                "Chatham": "u,0,5p,0,27|u,0,fq,0,27||",
                "Chile": "u,0,5p,0,49|u,0,5i,0,5h,0,49||",
                "China": "u,0,5p,0,4h|u,0,fq,0,4h||",
                "Choibalsan": "u,0,5p,0,2q|u,0,5i,0,5h,0,2q||",
                "Christmas": "u,0,15f,0,99|||",
                "Cocos": "u,0,oo,0,7v|||",
                "Colombia": "u,0,5p,0,4m|u,0,5i,0,5h,0,4m||",
                "Cook": "u,0,5p,0,oo,0,2v|u,0,5i,0,5h,0,4ld,0,oo,0,2v||",
                "Cuba": "u,0,5p,0,34|u,0,fq,0,34||",
                "Davis": "u,0,5s|||",
                "DumontDUrville": "u,0,5b,5,5j|||",
                "East_Timor": "u,0,7n,0,mt|||",
                "Easter": "u,0,5p,0,15f,0,7t|u,0,5i,0,5h,0,15f,0,7t||",
                "Ecuador": "u,0,ai|||",
                "Europe_Central": "u,0,5p,0,13b,0,pl|u,0,5i,0,5h,0,13b,0,pl||",
                "Europe_Eastern": "u,0,5p,0,13b,0,mt|u,0,5i,0,5h,0,13b,0,mt||",
                "Europe_Further_Eastern": "u,0,13b,0,4lf,0,4lg|||",
                "Europe_Western": "u,0,5p,0,13b,0,ht|u,0,5i,0,5h,0,13b,0,ht||",
                "Falkland": "u,0,5p,0,oo,0,4v|u,0,5i,0,5h,0,oo,0,4v||",
                "Fiji": "u,0,5p,0,4q|u,0,5i,0,5h,0,4q||",
                "French_Guiana": "u,0,7a,0,2g6|||",
                "French_Southern": "u,0,2g6,0,1jj,0,17t,0,4li|||",
                "Galapagos": "u,0,ak|||",
                "Gambier": "u,0,6v|||",
                "Georgia": "u,0,5p,0,2u|u,0,5i,0,5h,0,2u||",
                "Gilbert_Islands": "u,0,oo,0,6q|||",
                "GMT": "u,0,4lj,0,5u|||",
                "Greenland_Eastern": "u,0,5p,0,2k,0,mt|u,0,5i,0,5h,0,2k,0,mt||",
                "Greenland_Western": "u,0,5p,0,2k,0,ht|u,0,5i,0,5h,0,2k,0,ht||",
                "Gulf": "u,0,367|||",
                "Guyana": "u,0,7a|||",
                "Hawaii_Aleutian": "u,0,5p,0,4g,5,62|u,0,fq,0,4g,5,62||",
                "Hong_Kong": "u,0,5p,0,2l,0,2p|u,0,5i,0,5h,0,2l,0,2p||",
                "Hovd": "u,0,5p,0,2g|u,0,5i,0,5h,0,2g||",
                "India": "u,0,5p,0,af|||",
                "Indian_Ocean": "u,0,4lk,0,1to|||",
                "Indochina": "u,0,9p|||",
                "Indonesia_Central": "u,0,2t,0,pl|||",
                "Indonesia_Eastern": "u,0,2t,0,mt|||",
                "Indonesia_Western": "u,0,2t,0,ht|||",
                "Iran": "u,0,5p,0,5g|u,0,fq,0,5g||",
                "Irkutsk": "u,0,5p,0,3h|u,0,5i,0,5h,0,3h||",
                "Israel": "u,0,5p,0,4e|u,0,fq,0,4e||",
                "Japan": "u,0,5p,0,2g8|u,0,fq,0,2g8||",
                "Kamchatka": "u,0,5p,0,37,5,3k|u,0,5i,0,5h,0,37,5,3k||",
                "Kazakhstan_Eastern": "u,0,45,0,mt|||",
                "Kazakhstan_Western": "u,0,45,0,ht|||",
                "Korea": "u,0,5p,0,qf|u,0,fq,0,qf||",
                "Kosrae": "u,0,6f|||",
                "Krasnoyarsk": "u,0,5p,0,41|u,0,5i,0,5h,0,41||",
                "Kyrgystan": "u,0,bl|||",
                "Line_Islands": "u,0,oo,0,ac|||",
                "Lord_Howe": "u,0,5p,0,1u,0,24|u,0,fq,0,1u,0,24||",
                "Macquarie": "u,0,15f,0,6m|||",
                "Magadan": "u,0,5p,0,2o|u,0,5i,0,5h,0,2o||",
                "Malaysia": "u,0,bf||1r5|",
                "Maldives": "u,0,9k|||",
                "Marquesas": "u,0,9e|||",
                "Marshall_Islands": "u,0,oo,0,7o|||",
                "Mauritius": "u,0,5p,0,4u|u,0,5i,0,5h,0,4u||",
                "Mawson": "u,0,63|||",
                "Mexico_Northwest": "u,0,5p,0,ht,0,1se,0,5e|u,0,fq,0,ht,0,1se,0,5e||",
                "Mexico_Pacific": "u,0,5p,0,10c,0,5e|u,0,fq,0,10c,0,5e||",
                "Mongolia": "u,0,5p,0,4f,0,2m|u,0,5i,0,5h,0,4f,0,2m||",
                "Moscow": "u,0,5p,0,71|u,0,5i,0,5h,0,71||",
                "Myanmar": "u,0,8v|||",
                "Nauru": "u,0,5v|||",
                "Nepal": "u,0,8u|||",
                "New_Caledonia": "u,0,5p,0,1m,0,4o|u,0,5i,0,5h,0,1m,0,4o||",
                "New_Zealand": "u,0,5p,0,1m,0,74|u,0,fq,0,1m,0,74||",
                "Newfoundland": "u,0,5p,0,53|u,0,fq,0,53||",
                "Niue": "u,0,8g|||",
                "Norfolk": "u,0,oo,0,6l|||",
                "Noronha": "u,0,5p,0,1s,0,2,0,23|u,0,5i,0,5h,0,1s,0,2,0,23||",
                "Novosibirsk": "u,0,5p,0,3b|u,0,5i,0,5h,0,3b||",
                "Omsk": "u,0,5p,0,26|u,0,5i,0,5h,0,26||",
                "Pakistan": "u,0,5p,0,3i|u,0,5i,0,5h,0,3i||",
                "Palau": "u,0,9b|||",
                "Papua_New_Guinea": "u,0,9a,0,1m,0,a8|||",
                "Paraguay": "u,0,5p,0,3c|u,0,5i,0,5h,0,3c||",
                "Peru": "u,0,5p,0,4n|u,0,5i,0,5h,0,4n||",
                "Philippines": "u,0,5p,0,1sg|u,0,5i,0,5h,0,1sg||",
                "Phoenix_Islands": "u,0,oo,0,90|||",
                "Pierre_Miquelon": "u,0,5p,0,8i,0,33,0,17t,0,35|u,0,fq,0,8i,0,33,0,17t,0,35||",
                "Pitcairn": "u,0,7e|||",
                "Ponape": "u,0,9s|||",
                "Pyongyang": "u,0,8a|||",
                "Reunion": "u,0,b4|||",
                "Rothera": "u,0,5q|||",
                "Sakhalin": "u,0,5p,0,55|u,0,5i,0,5h,0,55||",
                "Samara": "u,0,5p,0,29|u,0,5i,0,5h,0,29||",
                "Samoa": "u,0,5p,0,2c|u,0,5i,0,5h,0,2c||",
                "Seychelles": "u,0,8k|||",
                "Singapore": "u,0,5p,0,196||2ad|",
                "Solomon": "u,0,oo,0,b5|||",
                "South_Georgia": "u,0,2u,0,1jj|||",
                "Suriname": "u,0,8q|||",
                "Syowa": "u,0,65|||",
                "Tahiti": "u,0,8n|||",
                "Taipei": "u,0,5p,0,3d|u,0,fq,0,3d||",
                "Tajikistan": "u,0,bj|||",
                "Tokelau": "u,0,5d|||",
                "Tonga": "u,0,5p,0,2j|u,0,5i,0,5h,0,2j||",
                "Truk": "u,0,6p|||",
                "Turkmenistan": "u,0,5p,0,4t|u,0,5i,0,5h,0,4t||",
                "Tuvalu": "u,0,6h|||",
                "Uruguay": "u,0,5p,0,4k|u,0,5i,0,5h,0,4k||",
                "Uzbekistan": "u,0,5p,0,60|u,0,5i,0,5h,0,60||",
                "Vanuatu": "u,0,5p,0,2f|u,0,5i,0,5h,0,2f||",
                "Venezuela": "u,0,7s|||",
                "Vladivostok": "u,0,5p,0,28|u,0,5i,0,5h,0,28||",
                "Volgograd": "u,0,5p,0,3f|u,0,5i,0,5h,0,3f||",
                "Vostok": "u,0,5t|||",
                "Wake": "u,0,15f,0,5r|||",
                "Wallis": "u,0,5f,0,17t,0,5k|||",
                "Yakutsk": "u,0,5p,0,3u|u,0,5i,0,5h,0,3u||",
                "Yekaterinburg": "u,0,5p,0,5l|u,0,5i,0,5h,0,5l||"
            }
        },
        "ms": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|u,0,5i,0,5h,0,3i4||",
                "Europe/London": "|u,0,5i,0,5h,0,c1||"
            },
            "metazone": {
                "Afghanistan": "u,0,b6|||",
                "Africa_Central": "u,0,c5,0,pl|||",
                "Africa_Eastern": "u,0,c5,0,mt|||",
                "Africa_Southern": "u,0,5p,0,c5,0,1jj|||",
                "Africa_Western": "u,0,5p,0,c5,0,ht|u,0,5i,0,5h,0,c5,0,ht||",
                "Alaska": "u,0,5p,0,3p|u,0,fq,0,3p||",
                "Amazon": "u,0,5p,0,5m|u,0,5i,0,5h,0,5m||",
                "America_Central": "u,0,5p,0,4la|u,0,fq,0,pl||",
                "America_Eastern": "u,0,5p,0,mt|u,0,fq,0,mt||",
                "America_Mountain": "u,0,5p,0,2g4|u,0,4lc,0,fq,0,2g4||",
                "America_Pacific": "u,0,5p,0,10c|u,0,fq,0,10c||",
                "Anadyr": "u,0,5p,0,3l|u,0,5i,0,5h,0,3l||",
                "Apia": "u,0,4,0,3e|u,0,fq,0,3e||",
                "Arabian": "u,0,5p,0,1qe|u,0,fq,0,1qe||",
                "Argentina": "u,0,5p,0,1e|u,0,5i,0,5h,0,1e||",
                "Argentina_Western": "u,0,5p,0,1e,0,ht|u,0,5i,0,5h,0,1e,0,ht||",
                "Armenia": "u,0,5p,0,4l|u,0,5i,0,5h,0,4l||",
                "Atlantic": "u,0,5p,0,r2|u,0,fq,0,r2||",
                "Australia_Central": "u,0,5p,0,4c,0,pl|u,0,fq,0,4c,0,pl||",
                "Australia_CentralWestern": "u,0,5p,0,ht,0,pl,0,4c|u,0,fq,0,ht,0,pl,0,4c||",
                "Australia_Eastern": "u,0,5p,0,mt,0,4c|u,0,fq,0,4c,0,mt||",
                "Australia_Western": "u,0,5p,0,4c,0,ht|u,0,fq,0,4c,0,ht||",
                "Azerbaijan": "u,0,5p,0,7m|u,0,5i,0,5h,0,7m||",
                "Azores": "u,0,5p,0,4r|u,0,5i,0,5h,0,4r||",
                "Bangladesh": "u,0,5p,0,3n|u,0,5i,0,5h,0,3n||",
                "Bhutan": "u,0,as|||",
                "Bolivia": "u,0,aa|||",
                "Brasilia": "u,0,5p,0,3a|u,0,5i,0,5h,0,3a||",
                "Brunei": "u,0,9o,0,a4|||",
                "Cape_Verde": "u,0,5p,0,1rs,0,3j|u,0,5i,0,5h,0,1rs,0,3j||",
                "Chamorro": "u,0,5p,0,6j|||",
                "Chatham": "u,0,5p,0,27|u,0,fq,0,27||",
                "Chile": "u,0,5p,0,49|u,0,5i,0,5h,0,49||",
                "China": "u,0,5p,0,4h|u,0,fq,0,4h||",
                "Choibalsan": "u,0,5p,0,2q|u,0,5i,0,5h,0,2q||",
                "Christmas": "u,0,15f,0,99|||",
                "Cocos": "u,0,oo,0,7v|||",
                "Colombia": "u,0,5p,0,4m|u,0,5i,0,5h,0,4m||",
                "Cook": "u,0,5p,0,oo,0,2v|u,0,5i,0,5h,0,4ld,0,oo,0,2v||",
                "Cuba": "u,0,5p,0,34|u,0,fq,0,34||",
                "Davis": "u,0,5s|||",
                "DumontDUrville": "u,0,5b,5,5j|||",
                "East_Timor": "u,0,7n,0,mt|||",
                "Easter": "u,0,5p,0,15f,0,7t|u,0,5i,0,5h,0,15f,0,7t||",
                "Ecuador": "u,0,ai|||",
                "Europe_Central": "u,0,5p,0,13b,0,pl|u,0,5i,0,5h,0,13b,0,pl||",
                "Europe_Eastern": "u,0,5p,0,13b,0,mt|u,0,5i,0,5h,0,13b,0,mt||",
                "Europe_Further_Eastern": "u,0,13b,0,4lf,0,4lg|||",
                "Europe_Western": "u,0,5p,0,13b,0,ht|u,0,5i,0,5h,0,13b,0,ht||",
                "Falkland": "u,0,5p,0,oo,0,4v|u,0,5i,0,5h,0,oo,0,4v||",
                "Fiji": "u,0,5p,0,4q|u,0,5i,0,5h,0,4q||",
                "French_Guiana": "u,0,7a,0,2g6|||",
                "French_Southern": "u,0,2g6,0,1jj,0,17t,0,4li|||",
                "Galapagos": "u,0,ak|||",
                "Gambier": "u,0,6v|||",
                "Georgia": "u,0,5p,0,2u|u,0,5i,0,5h,0,2u||",
                "Gilbert_Islands": "u,0,oo,0,6q|||",
                "GMT": "u,0,4lj,0,5u|||",
                "Greenland_Eastern": "u,0,5p,0,2k,0,mt|u,0,5i,0,5h,0,2k,0,mt||",
                "Greenland_Western": "u,0,5p,0,2k,0,ht|u,0,5i,0,5h,0,2k,0,ht||",
                "Gulf": "u,0,367|||",
                "Guyana": "u,0,7a|||",
                "Hawaii_Aleutian": "u,0,5p,0,4g,5,62|u,0,fq,0,4g,5,62||",
                "Hong_Kong": "u,0,5p,0,2l,0,2p|u,0,5i,0,5h,0,2l,0,2p||",
                "Hovd": "u,0,5p,0,2g|u,0,5i,0,5h,0,2g||",
                "India": "u,0,5p,0,af|||",
                "Indian_Ocean": "u,0,4lk,0,1to|||",
                "Indochina": "u,0,9p|||",
                "Indonesia_Central": "u,0,2t,0,pl|||",
                "Indonesia_Eastern": "u,0,2t,0,mt|||",
                "Indonesia_Western": "u,0,2t,0,ht|||",
                "Iran": "u,0,5p,0,5g|u,0,fq,0,5g||",
                "Irkutsk": "u,0,5p,0,3h|u,0,5i,0,5h,0,3h||",
                "Israel": "u,0,5p,0,4e|u,0,fq,0,4e||",
                "Japan": "u,0,5p,0,2g8|u,0,fq,0,2g8||",
                "Kamchatka": "u,0,5p,0,37,5,3k|u,0,5i,0,5h,0,37,5,3k||",
                "Kazakhstan_Eastern": "u,0,45,0,mt|||",
                "Kazakhstan_Western": "u,0,45,0,ht|||",
                "Korea": "u,0,5p,0,qf|u,0,fq,0,qf||",
                "Kosrae": "u,0,6f|||",
                "Krasnoyarsk": "u,0,5p,0,41|u,0,5i,0,5h,0,41||",
                "Kyrgystan": "u,0,bl|||",
                "Line_Islands": "u,0,oo,0,ac|||",
                "Lord_Howe": "u,0,5p,0,1u,0,24|u,0,fq,0,1u,0,24||",
                "Macquarie": "u,0,15f,0,6m|||",
                "Magadan": "u,0,5p,0,2o|u,0,5i,0,5h,0,2o||",
                "Malaysia": "u,0,bf||1r5|",
                "Maldives": "u,0,9k|||",
                "Marquesas": "u,0,9e|||",
                "Marshall_Islands": "u,0,oo,0,7o|||",
                "Mauritius": "u,0,5p,0,4u|u,0,5i,0,5h,0,4u||",
                "Mawson": "u,0,63|||",
                "Mexico_Northwest": "u,0,5p,0,ht,0,1se,0,5e|u,0,fq,0,ht,0,1se,0,5e||",
                "Mexico_Pacific": "u,0,5p,0,10c,0,5e|u,0,fq,0,10c,0,5e||",
                "Mongolia": "u,0,5p,0,4f,0,2m|u,0,5i,0,5h,0,4f,0,2m||",
                "Moscow": "u,0,5p,0,71|u,0,5i,0,5h,0,71||",
                "Myanmar": "u,0,8v|||",
                "Nauru": "u,0,5v|||",
                "Nepal": "u,0,8u|||",
                "New_Caledonia": "u,0,5p,0,1m,0,4o|u,0,5i,0,5h,0,1m,0,4o||",
                "New_Zealand": "u,0,5p,0,1m,0,74|u,0,fq,0,1m,0,74||",
                "Newfoundland": "u,0,5p,0,53|u,0,fq,0,53||",
                "Niue": "u,0,8g|||",
                "Norfolk": "u,0,oo,0,6l|||",
                "Noronha": "u,0,5p,0,1s,0,2,0,23|u,0,5i,0,5h,0,1s,0,2,0,23||",
                "Novosibirsk": "u,0,5p,0,3b|u,0,5i,0,5h,0,3b||",
                "Omsk": "u,0,5p,0,26|u,0,5i,0,5h,0,26||",
                "Pakistan": "u,0,5p,0,3i|u,0,5i,0,5h,0,3i||",
                "Palau": "u,0,9b|||",
                "Papua_New_Guinea": "u,0,9a,0,1m,0,a8|||",
                "Paraguay": "u,0,5p,0,3c|u,0,5i,0,5h,0,3c||",
                "Peru": "u,0,5p,0,4n|u,0,5i,0,5h,0,4n||",
                "Philippines": "u,0,5p,0,1sg|u,0,5i,0,5h,0,1sg||",
                "Phoenix_Islands": "u,0,oo,0,90|||",
                "Pierre_Miquelon": "u,0,5p,0,8i,0,33,0,17t,0,35|u,0,fq,0,8i,0,33,0,17t,0,35||",
                "Pitcairn": "u,0,7e|||",
                "Ponape": "u,0,9s|||",
                "Pyongyang": "u,0,8a|||",
                "Reunion": "u,0,b4|||",
                "Rothera": "u,0,5q|||",
                "Sakhalin": "u,0,5p,0,55|u,0,5i,0,5h,0,55||",
                "Samara": "u,0,5p,0,29|u,0,5i,0,5h,0,29||",
                "Samoa": "u,0,5p,0,2c|u,0,5i,0,5h,0,2c||",
                "Seychelles": "u,0,8k|||",
                "Singapore": "u,0,5p,0,196||2ad|",
                "Solomon": "u,0,oo,0,b5|||",
                "South_Georgia": "u,0,2u,0,1jj|||",
                "Suriname": "u,0,8q|||",
                "Syowa": "u,0,65|||",
                "Tahiti": "u,0,8n|||",
                "Taipei": "u,0,5p,0,3d|u,0,fq,0,3d||",
                "Tajikistan": "u,0,bj|||",
                "Tokelau": "u,0,5d|||",
                "Tonga": "u,0,5p,0,2j|u,0,5i,0,5h,0,2j||",
                "Truk": "u,0,6p|||",
                "Turkmenistan": "u,0,5p,0,4t|u,0,5i,0,5h,0,4t||",
                "Tuvalu": "u,0,6h|||",
                "Uruguay": "u,0,5p,0,4k|u,0,5i,0,5h,0,4k||",
                "Uzbekistan": "u,0,5p,0,60|u,0,5i,0,5h,0,60||",
                "Vanuatu": "u,0,5p,0,2f|u,0,5i,0,5h,0,2f||",
                "Venezuela": "u,0,7s|||",
                "Vladivostok": "u,0,5p,0,28|u,0,5i,0,5h,0,28||",
                "Volgograd": "u,0,5p,0,3f|u,0,5i,0,5h,0,3f||",
                "Vostok": "u,0,5t|||",
                "Wake": "u,0,15f,0,5r|||",
                "Wallis": "u,0,5f,0,17t,0,5k|||",
                "Yakutsk": "u,0,5p,0,3u|u,0,5i,0,5h,0,3u||",
                "Yekaterinburg": "u,0,5p,0,5l|u,0,5i,0,5h,0,5l||"
            }
        },
        "mt": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Europe_Central": "88j,0,88k,0,88l,0,4|88j,0,88k,0,88l,0,8nn,5,8nm|h0|h4",
                "Europe_Eastern": "||gu|gv",
                "Europe_Western": "||h1|h2",
                "GMT": "||ah|"
            }
        },
        "mua": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "my": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ccf||",
                "Europe/London": "|ccg||"
            },
            "metazone": {
                "Afghanistan": "8nl,0,fm|||",
                "Africa_Central": "8nk,0,fm|||",
                "Africa_Eastern": "8nj,0,fm|||",
                "Africa_Southern": "8ni,0,fm|||",
                "Africa_Western": "88t,0,id|88t,0,m5,0,fm||",
                "Alaska": "8nh|8ng,0,2vd||",
                "Amazon": "893,0,id|893,0,894||",
                "America_Central": "1sr,0,8nf|1sr,0,2ha,0,2vd||",
                "America_Eastern": "1sr,0,8ne|1sr,0,899,0,2vd||",
                "America_Mountain": "1sr,0,8nd|1sr,0,8nc,0,2vd||",
                "America_Pacific": "1sr,0,8nb|1sr,0,4ma,0,2vd||",
                "Apia": "8na|8n9,0,m5,0,fm||",
                "Arabian": "89g,0,id|89g,0,m5,0,fm||",
                "Argentina": "3kb,0,id|3kb,0,894||",
                "Argentina_Western": "3ka,0,3kb,0,id|3ka,0,3kb,0,m5,0,fm||",
                "Armenia": "89j,0,id|89j,0,m5,0,fm||",
                "Atlantic": "89k,0,id|89k,0,m5,0,id||",
                "Australia_Central": "311,0,2ha,0,id|311,0,2ha,0,m5,0,fm||",
                "Australia_CentralWestern": "311,0,89m,0,id|311,0,89m,0,m5,0,fm||",
                "Australia_Eastern": "89n,0,id|89n,0,m5,0,fm||",
                "Australia_Western": "8n8,0,id|311,0,m5,0,fm||",
                "Azerbaijan": "89p,0,id|89p,0,m5,0,fm||",
                "Azores": "89q,0,id|89q,0,m5,0,fm||",
                "Bangladesh": "89r,0,id|89r,0,m5,0,fm||",
                "Bhutan": "8n7,0,fm|||",
                "Bolivia": "8n6,0,fm|||",
                "Brasilia": "89u,0,id|89u,0,m5,0,fm||",
                "Brunei": "8n5,0,id|||",
                "Cape_Verde": "8a0,0,8a1,0,id|8a0,0,8a1,0,m5,0,fm||",
                "Chamorro": "8n4|||",
                "Chatham": "8n3|8n2,0,m5,0,fm||",
                "Chile": "8a5,0,id|8a5,0,m5,0,fm||",
                "China": "8a6,0,id|8a6,0,m5,0,fm||",
                "Choibalsan": "8n1|8n0||",
                "Christmas": "8mv|||",
                "Cocos": "8mu|||",
                "Colombia": "8ab,0,id|8ab,0,m5,0,fm||",
                "Cook": "8mt|8ms||",
                "Cuba": "8ae,0,id|8ae,0,m5,0,id||",
                "Davis": "8mr|||",
                "DumontDUrville": "8mq,0,8mp|||",
                "East_Timor": "8mo,0,fm|||",
                "Easter": "8mn|8mm||",
                "Ecuador": "8ml,0,fm|||",
                "Europe_Central": "8am,0,2ha,0,id|8am,0,2ha,0,m5,0,fm||",
                "Europe_Eastern": "8an,0,id|8an,0,m5,0,fm||",
                "Europe_Further_Eastern": "8mk|||",
                "Europe_Western": "8ap,0,id|8ap,0,m5,0,fm||",
                "Falkland": "8aq,0,id|8aq,0,m5,0,fm||",
                "Fiji": "8mj|8mi||",
                "French_Guiana": "8mh,0,8mg,0,fm|||",
                "French_Southern": "8mf,0,8me|||",
                "Galapagos": "8md|||",
                "Gambier": "8mc,0,fm|||",
                "Georgia": "8b3,0,id|8b3,0,m5,0,fm||",
                "Gilbert_Islands": "8mb|||",
                "GMT": "8ma,0,id|||",
                "Greenland_Eastern": "8m9,0,id|8m8,0,m5,0,id||",
                "Greenland_Western": "3ka,0,8m7,0,id|3ka,0,8m6,0,m5,0,id||",
                "Gulf": "8m5,0,fm|||",
                "Guyana": "8m4,0,fm|||",
                "Hawaii_Aleutian": "8bc,0,8bd,0,id|8bc,0,8bd,0,m5,0,id||",
                "Hong_Kong": "8be,0,id|8be,0,m5,0,fm||",
                "Hovd": "8m3|8m2||",
                "India": "8bh,0,id|||",
                "Indian_Ocean": "8bh,0,8m1,0,fm|||",
                "Indochina": "8m0,0,fm|||",
                "Indonesia_Central": "2ha,0,4no,0,fm|||",
                "Indonesia_Eastern": "899,0,4no,0,fm|||",
                "Indonesia_Western": "8lv,0,4no,0,fm|||",
                "Iran": "8bm,0,id|8bm,0,m5,0,fm||",
                "Irkutsk": "8lu|8lt||",
                "Israel": "8bp,0,id|8bp,0,m5,0,fm||",
                "Japan": "8bq,0,id|8bq,0,m5,0,fm||",
                "Kazakhstan_Eastern": "8ls,0,fm|||",
                "Kazakhstan_Western": "8lr|||",
                "Korea": "8bt,0,id|8bt,0,m5,0,fm||",
                "Kosrae": "8lq|||",
                "Krasnoyarsk": "8lp|8lo||",
                "Kyrgystan": "8ln,0,fm|||",
                "Lanka": "8lm,0,fm|||",
                "Line_Islands": "8ll|||",
                "Lord_Howe": "8lk|8lj,0,m5,0,fm||",
                "Macau": "8c6,0,id|8c6,0,m5,0,fm||",
                "Macquarie": "8li,0,fm|||",
                "Magadan": "8lh|8lg||",
                "Malaysia": "8lf,0,fm|||",
                "Maldives": "8le,0,fm|||",
                "Marquesas": "8ld|||",
                "Marshall_Islands": "8lc|||",
                "Mauritius": "8ce,0,id|8ce,0,m5,0,fm||",
                "Mawson": "8lb|||",
                "Mexico_Northwest": "8cg,0,8la,0,id|8cg,0,8l9,0,m5,0,id||",
                "Mexico_Pacific": "8l8,0,4ma,0,id|8l7,0,4ma,0,m5,0,id||",
                "Mongolia": "8l6|8l5||",
                "Moscow": "8l4|8l3,0,m5,0,fm||",
                "Myanmar": "8l2,0,fm|||",
                "Nauru": "8l1|||",
                "Nepal": "8l0,0,fm|||",
                "New_Caledonia": "8kv|8ku||",
                "New_Zealand": "8cu,0,id|8cu,0,m5,0,fm||",
                "Newfoundland": "8cv,0,id|8cv,0,m5,0,id||",
                "Niue": "8kt|||",
                "Norfolk": "8ks|||",
                "Noronha": "8kr|8kq||",
                "Novosibirsk": "8kp|8ko||",
                "Omsk": "8kn|8km||",
                "Pakistan": "8d8,0,id|8d8,0,m5,0,fm||",
                "Palau": "8kl,0,fm|||",
                "Papua_New_Guinea": "8kk,0,fm|||",
                "Paraguay": "8db,0,id|8db,0,m5,0,fm||",
                "Peru": "8dc,0,id|8dc,0,m5,0,fm||",
                "Philippines": "8dd,0,id|8dd,0,m5,0,fm||",
                "Phoenix_Islands": "8kj|||",
                "Pierre_Miquelon": "8ki|8kh,0,8kg,0,m5,0,id||",
                "Pitcairn": "8kf,0,fm|||",
                "Ponape": "8ke|||",
                "Pyongyang": "8kd,0,fm|||",
                "Reunion": "8kc,0,fm|||",
                "Rothera": "8kb|||",
                "Sakhalin": "8ka|8k9,0,m5,0,fm||",
                "Samoa": "8k8|8k7,0,m5,0,fm||",
                "Seychelles": "8k6,0,fm|||",
                "Singapore": "8k5,0,fm|||",
                "Solomon": "8k4|||",
                "South_Georgia": "8k3,0,fm|||",
                "Suriname": "8k2|||",
                "Syowa": "8k1|||",
                "Tahiti": "8k0|||",
                "Taipei": "8e2,0,id|8e2,0,m5,0,fm||",
                "Tajikistan": "8jv,0,fm|||",
                "Tokelau": "8ju,0,fm|||",
                "Tonga": "8jt|8js||",
                "Truk": "8jr|||",
                "Turkmenistan": "8e8,0,id|8e8,0,m5,0,fm||",
                "Tuvalu": "8jq|||",
                "Uruguay": "8ea,0,id|8ea,0,m5,0,fm||",
                "Uzbekistan": "8eb,0,id|8eb,0,m5,0,fm||",
                "Vanuatu": "8jp|8jo||",
                "Venezuela": "8jn,0,fm|||",
                "Vladivostok": "8ef,0,id|8ef,0,m5,0,fm||",
                "Volgograd": "8jm|8jl||",
                "Vostok": "8jk|||",
                "Wake": "8jj|||",
                "Wallis": "8ji,0,8jh,0,fm|||",
                "Yakutsk": "8jg|8jf||",
                "Yekaterinburg": "8pp|8je||"
            }
        },
        "mzn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "naq": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nb-SJ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|5sn,0,3t||",
                "Europe/London": "|5q6,0,3t||"
            },
            "metazone": {
                "Acre": "3q,0,1l|3q,0,3t||",
                "Afghanistan": "2qd,0,4j|||",
                "Africa_Central": "4p3,0,4j|||",
                "Africa_Eastern": "8es,0,4j|||",
                "Africa_Southern": "4p4,0,4j|||",
                "Africa_Western": "2k2,0,1l|2k2,0,3t||",
                "Alaska": "3gf,0,1l|3gf,0,3t|18f|18t",
                "Almaty": "56,k,0,12j|56,k,0,3t||",
                "Amazon": "1l,0,89,0,bg|3t,0,89,0,bg||",
                "America_Central": "1l,0,89,0,3gc,0,2lb,0,98,5,m2|3t,0,89,0,3gc,0,2lb,0,98,5,m2|19q|19p",
                "America_Eastern": "1l,0,89,0,1i6,0,1rc,0,3gb|3t,0,89,0,1i6,0,1rc,0,3gb|19o|19n",
                "America_Mountain": "1l,0,89,0,145,0,3ga,0,3f1|3t,0,89,0,145,0,3ga,0,3f1|18r|16i",
                "America_Pacific": "1l,0,89,0,1i6,0,1rc,0,1r8|3t,0,89,0,1i6,0,1rc,0,1r8|19l|19k",
                "Anadyr": "1j0,0,3ds,0,1l|1j0,0,3ds,0,3t||",
                "Apia": "1l,0,89,0,3e|3t,0,89,0,3e||",
                "Aqtau": "50,k,0,12j|50,k,0,3t||",
                "Aqtobe": "5o,k,0,12j|5o,k,0,3t||",
                "Arabian": "3dp,0,12j|3dp,0,3t||",
                "Argentina": "3bt,0,1l|3bt,0,3t||",
                "Argentina_Western": "3bk,0,1l|3bk,0,3t||",
                "Armenia": "3b0,0,1l|3b0,0,3t||",
                "Atlantic": "3ah,0,12j|3ah,0,3t|19i|190",
                "Australia_Central": "1j3,0,1l|1j3,0,3t||",
                "Australia_CentralWestern": "1o9,5,1j3,0,1l|1o9,5,1j3,0,3t||",
                "Australia_Eastern": "3aa,0,1l|3aa,0,3t||",
                "Australia_Western": "2km,0,1l|2km,0,3t||",
                "Azerbaijan": "3a8,0,1l|3a8,0,3t||",
                "Azores": "3a7,0,1l|3a7,0,3t||",
                "Bangladesh": "1o1,0,1l|1o1,0,3t||",
                "Bhutan": "2vt,0,4j|||",
                "Bolivia": "2vl,0,4j|||",
                "Brasilia": "1l,0,89,0,3a|3t,0,89,0,3a||",
                "Brunei": "h9,0,89,0,9o,0,a4|||",
                "Cape_Verde": "1l,0,89,0,39u,0,3j|3t,0,89,0,39u,0,3j||",
                "Casey": "b7,5,4j|||",
                "Chamorro": "h9,0,89,0,6j|||",
                "Chatham": "1l,0,89,0,27|3t,0,89,0,27||",
                "Chile": "1ng,0,1l|1ng,0,3t||",
                "China": "1la,0,1l|1la,0,3t||",
                "Choibalsan": "1l,0,89,0,148|3t,0,89,0,148||",
                "Christmas": "h9,0,89,0,8ft|||",
                "Cocos": "h9,0,89,0,8fu|||",
                "Colombia": "1nv,0,1l|1nv,0,3t||",
                "Cook": "1l,0,89,0,39o|8g1,0,3t,0,89,0,39o||",
                "Cuba": "39n,0,1l|39n,0,3t||",
                "Davis": "h9,0,89,0,5s|||",
                "DumontDUrville": "h9,0,89,0,5b,0,5j|||",
                "East_Timor": "8g3,0,4j|||",
                "Easter": "1l,0,89,0,39m|3t,0,89,0,39m||",
                "Ecuador": "2ug,0,4j|||",
                "Europe_Central": "2kq,0,1l|2kq,0,3t|h0|h4",
                "Europe_Eastern": "2kr,0,1l|2kr,0,3t|gu|gv",
                "Europe_Further_Eastern": "8g8,5,2kr,0,4j|||",
                "Europe_Western": "2ks,0,1l|2ks,0,3t|h1|h2",
                "Falkland": "1l,0,89,0,39h|3t,0,89,0,39h||",
                "Fiji": "39g,0,1l|39g,0,3t||",
                "French_Guiana": "h9,0,89,0,463,0,7a|||",
                "French_Southern": "h9,0,89,0,47f,0,8gc,0,8gd|||",
                "Galapagos": "h9,0,89,0,8ge|||",
                "Gambier": "h9,0,89,0,6v|||",
                "Georgia": "1ol,0,1l|1ol,0,3t||",
                "Gilbert_Islands": "h9,0,89,0,8gg|||",
                "GMT": "5u,0,4qf||ah|",
                "Greenland_Eastern": "39e,0,1l|39e,0,3t||",
                "Greenland_Western": "39c,0,1l|39c,0,3t||",
                "Guam": "83,5,4j|||",
                "Gulf": "h9,0,89,0,8gk|||",
                "Guyana": "8gl,0,4j|||",
                "Hawaii_Aleutian": "1l,0,89,0,4g,0,u0,0,39a|3t,0,89,0,4g,0,u0,0,39a|17j|17l",
                "Hong_Kong": "1l,0,89,0,qh|3t,0,89,0,qh||",
                "Hovd": "1l,0,89,0,399|3t,0,89,0,399||",
                "India": "2n9,0,4j|||",
                "Indian_Ocean": "h9,0,89,0,8gp|||",
                "Indochina": "31n,0,4j|||",
                "Indonesia_Central": "8gr,0,4j|||",
                "Indonesia_Eastern": "8gs,0,4j|||",
                "Indonesia_Western": "8gt,0,4j|||",
                "Iran": "1me,0,1l|1me,0,3t||",
                "Irkutsk": "1l,0,89,0,3h|3t,0,89,0,3h||",
                "Israel": "393,0,1l|393,0,3t||",
                "Japan": "1l9,0,1l|1l9,0,3t||",
                "Kamchatka": "1j0,0,391,5,390,0,1l|1j0,0,391,5,390,0,3t||",
                "Kazakhstan_Eastern": "8h3,0,4j|||",
                "Kazakhstan_Western": "8h4,0,4j|||",
                "Korea": "1pa,0,1l|1pa,0,3t||",
                "Kosrae": "h9,0,89,0,6f|||",
                "Krasnoyarsk": "1l,0,89,0,l0|3t,0,89,0,l0||",
                "Kyrgystan": "8h6,0,4j|||",
                "Lanka": "9c,5,4j|||",
                "Line_Islands": "h9,0,89,0,8h7|||",
                "Lord_Howe": "1l,0,89,0,1u,0,24,5,38s|3t,0,89,0,1u,0,24,5,38s||",
                "Macau": "57,k,0,12j|57,k,0,3t||",
                "Macquarie": "h9,0,89,0,8h9|||",
                "Magadan": "1l,0,89,0,2o|3t,0,89,0,2o||",
                "Malaysia": "2lt,0,4j|||",
                "Maldives": "8hb,0,4j|||",
                "Marquesas": "h9,0,89,0,8hc|||",
                "Marshall_Islands": "h9,0,89,0,8hd|||",
                "Mauritius": "38n,0,1l|38n,0,3t||",
                "Mawson": "h9,0,89,0,63|||",
                "Mexico_Northwest": "1l,0,89,0,38m,0,5e|3t,0,89,0,38m,0,5e||",
                "Mexico_Pacific": "1l,0,89,0,1i6,0,38l,0,1r8|3t,0,89,0,1i6,0,38l,0,1r8||",
                "Mongolia": "1l,0,89,0,4f,0,2m|3t,0,89,0,4f,0,2m||",
                "Moscow": "1l,0,89,0,pi|3t,0,89,0,pi||",
                "Myanmar": "8hh,0,4j|||",
                "Nauru": "8hi,0,4j|||",
                "Nepal": "8hj,0,4j|||",
                "New_Caledonia": "38h,0,1l|38h,0,3t||",
                "New_Zealand": "38f,0,1l|38f,0,3t||",
                "Newfoundland": "1l,0,89,0,53|3t,0,89,0,53||",
                "Niue": "h9,0,89,0,8g|||",
                "Norfolk": "h9,0,89,0,8hm|||",
                "Noronha": "1l,0,89,0,1s,0,2,0,23|3t,0,89,0,1s,0,2,0,23||",
                "North_Mariana": "98,5,8hn,5,4j|||",
                "Novosibirsk": "1l,0,89,0,3b|3t,0,89,0,3b||",
                "Omsk": "1l,0,89,0,26|3t,0,89,0,26||",
                "Pakistan": "1m6,0,1l|1m6,0,3t||",
                "Palau": "8hp,0,4j|||",
                "Papua_New_Guinea": "8hq,0,4j|||",
                "Paraguay": "1pd,0,1l|1pd,0,3t||",
                "Peru": "1nj,0,1l|1nj,0,3t||",
                "Philippines": "1ms,0,1l|1ms,0,3t||",
                "Phoenix_Islands": "h9,0,89,0,8hu|||",
                "Pierre_Miquelon": "1l,0,89,0,8i,5,33,5,8p,5,35|3t,0,89,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "h9,0,89,0,7e|||",
                "Ponape": "h9,0,89,0,e5|||",
                "Pyongyang": "h9,0,89,0,8a|||",
                "Qyzylorda": "4d,k,0,12j|4d,k,0,3t||",
                "Reunion": "h9,0,89,0,i8|||",
                "Rothera": "h9,0,89,0,5q|||",
                "Sakhalin": "1l,0,89,0,55|3t,0,89,0,55||",
                "Samara": "1j0,0,37u,0,1l|1j0,0,37u,0,3t||",
                "Samoa": "1nt,0,1l|1nt,0,3t||",
                "Seychelles": "8i1,0,4j|||",
                "Singapore": "8i2,0,4j|||",
                "Solomon": "h9,0,89,0,8i3|||",
                "South_Georgia": "h9,0,89,0,8i4,5,2u|||",
                "Suriname": "8i5,0,4j|||",
                "Syowa": "h9,0,89,0,65|||",
                "Tahiti": "8i6,0,4j|||",
                "Taipei": "1l,0,89,0,3d|3t,0,89,0,3d||",
                "Tajikistan": "8i7,0,4j|||",
                "Tokelau": "h9,0,89,0,5d|||",
                "Tonga": "374,0,1l|374,0,3t||",
                "Truk": "h9,0,89,0,8i9|||",
                "Turkmenistan": "1l4,0,1l|1l4,0,3t||",
                "Tuvalu": "8ib,0,4j|||",
                "Uruguay": "1p5,0,1l|1p5,0,3t||",
                "Uzbekistan": "36h,0,1l|36h,0,3t||",
                "Vanuatu": "368,0,1l|368,0,3t||",
                "Venezuela": "2tl,0,4j|||",
                "Vladivostok": "1l,0,89,0,28|3t,0,89,0,28||",
                "Volgograd": "1l,0,89,0,3f|3t,0,89,0,3f||",
                "Vostok": "h9,0,89,0,5t|||",
                "Wake": "h9,0,89,0,5r,0,1f|||",
                "Wallis": "h9,0,89,0,5f,5,0,u0,0,8ig|||",
                "Yakutsk": "1l,0,89,0,qj|3t,0,89,0,qj||",
                "Yekaterinburg": "1l,0,89,0,q6|3t,0,89,0,q6||"
            }
        },
        "nb": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|5sn,0,3t||",
                "Europe/London": "|5q6,0,3t||"
            },
            "metazone": {
                "Acre": "3q,0,1l|3q,0,3t||",
                "Afghanistan": "2qd,0,4j|||",
                "Africa_Central": "4p3,0,4j|||",
                "Africa_Eastern": "8es,0,4j|||",
                "Africa_Southern": "4p4,0,4j|||",
                "Africa_Western": "2k2,0,1l|2k2,0,3t||",
                "Alaska": "3gf,0,1l|3gf,0,3t|18f|18t",
                "Almaty": "56,k,0,12j|56,k,0,3t||",
                "Amazon": "1l,0,89,0,bg|3t,0,89,0,bg||",
                "America_Central": "1l,0,89,0,3gc,0,2lb,0,98,5,m2|3t,0,89,0,3gc,0,2lb,0,98,5,m2|19q|19p",
                "America_Eastern": "1l,0,89,0,1i6,0,1rc,0,3gb|3t,0,89,0,1i6,0,1rc,0,3gb|19o|19n",
                "America_Mountain": "1l,0,89,0,145,0,3ga,0,3f1|3t,0,89,0,145,0,3ga,0,3f1|18r|16i",
                "America_Pacific": "1l,0,89,0,1i6,0,1rc,0,1r8|3t,0,89,0,1i6,0,1rc,0,1r8|19l|19k",
                "Anadyr": "1j0,0,3ds,0,1l|1j0,0,3ds,0,3t||",
                "Apia": "1l,0,89,0,3e|3t,0,89,0,3e||",
                "Aqtau": "50,k,0,12j|50,k,0,3t||",
                "Aqtobe": "5o,k,0,12j|5o,k,0,3t||",
                "Arabian": "3dp,0,12j|3dp,0,3t||",
                "Argentina": "3bt,0,1l|3bt,0,3t||",
                "Argentina_Western": "3bk,0,1l|3bk,0,3t||",
                "Armenia": "3b0,0,1l|3b0,0,3t||",
                "Atlantic": "3ah,0,12j|3ah,0,3t|19i|190",
                "Australia_Central": "1j3,0,1l|1j3,0,3t||",
                "Australia_CentralWestern": "1o9,5,1j3,0,1l|1o9,5,1j3,0,3t||",
                "Australia_Eastern": "3aa,0,1l|3aa,0,3t||",
                "Australia_Western": "2km,0,1l|2km,0,3t||",
                "Azerbaijan": "3a8,0,1l|3a8,0,3t||",
                "Azores": "3a7,0,1l|3a7,0,3t||",
                "Bangladesh": "1o1,0,1l|1o1,0,3t||",
                "Bhutan": "2vt,0,4j|||",
                "Bolivia": "2vl,0,4j|||",
                "Brasilia": "1l,0,89,0,3a|3t,0,89,0,3a||",
                "Brunei": "h9,0,89,0,9o,0,a4|||",
                "Cape_Verde": "1l,0,89,0,39u,0,3j|3t,0,89,0,39u,0,3j||",
                "Casey": "b7,5,4j|||",
                "Chamorro": "h9,0,89,0,6j|||",
                "Chatham": "1l,0,89,0,27|3t,0,89,0,27||",
                "Chile": "1ng,0,1l|1ng,0,3t||",
                "China": "1la,0,1l|1la,0,3t||",
                "Choibalsan": "1l,0,89,0,148|3t,0,89,0,148||",
                "Christmas": "h9,0,89,0,8ft|||",
                "Cocos": "h9,0,89,0,8fu|||",
                "Colombia": "1nv,0,1l|1nv,0,3t||",
                "Cook": "1l,0,89,0,39o|8g1,0,3t,0,89,0,39o||",
                "Cuba": "39n,0,1l|39n,0,3t||",
                "Davis": "h9,0,89,0,5s|||",
                "DumontDUrville": "h9,0,89,0,5b,0,5j|||",
                "East_Timor": "8g3,0,4j|||",
                "Easter": "1l,0,89,0,39m|3t,0,89,0,39m||",
                "Ecuador": "2ug,0,4j|||",
                "Europe_Central": "2kq,0,1l|2kq,0,3t|h0|h4",
                "Europe_Eastern": "2kr,0,1l|2kr,0,3t|gu|gv",
                "Europe_Further_Eastern": "8g8,5,2kr,0,4j|||",
                "Europe_Western": "2ks,0,1l|2ks,0,3t|h1|h2",
                "Falkland": "1l,0,89,0,39h|3t,0,89,0,39h||",
                "Fiji": "39g,0,1l|39g,0,3t||",
                "French_Guiana": "h9,0,89,0,463,0,7a|||",
                "French_Southern": "h9,0,89,0,47f,0,8gc,0,8gd|||",
                "Galapagos": "h9,0,89,0,8ge|||",
                "Gambier": "h9,0,89,0,6v|||",
                "Georgia": "1ol,0,1l|1ol,0,3t||",
                "Gilbert_Islands": "h9,0,89,0,8gg|||",
                "GMT": "5u,0,4qf||ah|",
                "Greenland_Eastern": "39e,0,1l|39e,0,3t||",
                "Greenland_Western": "39c,0,1l|39c,0,3t||",
                "Guam": "83,5,4j|||",
                "Gulf": "h9,0,89,0,8gk|||",
                "Guyana": "8gl,0,4j|||",
                "Hawaii_Aleutian": "1l,0,89,0,4g,0,u0,0,39a|3t,0,89,0,4g,0,u0,0,39a|17j|17l",
                "Hong_Kong": "1l,0,89,0,qh|3t,0,89,0,qh||",
                "Hovd": "1l,0,89,0,399|3t,0,89,0,399||",
                "India": "2n9,0,4j|||",
                "Indian_Ocean": "h9,0,89,0,8gp|||",
                "Indochina": "31n,0,4j|||",
                "Indonesia_Central": "8gr,0,4j|||",
                "Indonesia_Eastern": "8gs,0,4j|||",
                "Indonesia_Western": "8gt,0,4j|||",
                "Iran": "1me,0,1l|1me,0,3t||",
                "Irkutsk": "1l,0,89,0,3h|3t,0,89,0,3h||",
                "Israel": "393,0,1l|393,0,3t||",
                "Japan": "1l9,0,1l|1l9,0,3t||",
                "Kamchatka": "1j0,0,391,5,390,0,1l|1j0,0,391,5,390,0,3t||",
                "Kazakhstan_Eastern": "8h3,0,4j|||",
                "Kazakhstan_Western": "8h4,0,4j|||",
                "Korea": "1pa,0,1l|1pa,0,3t||",
                "Kosrae": "h9,0,89,0,6f|||",
                "Krasnoyarsk": "1l,0,89,0,l0|3t,0,89,0,l0||",
                "Kyrgystan": "8h6,0,4j|||",
                "Lanka": "9c,5,4j|||",
                "Line_Islands": "h9,0,89,0,8h7|||",
                "Lord_Howe": "1l,0,89,0,1u,0,24,5,38s|3t,0,89,0,1u,0,24,5,38s||",
                "Macau": "57,k,0,12j|57,k,0,3t||",
                "Macquarie": "h9,0,89,0,8h9|||",
                "Magadan": "1l,0,89,0,2o|3t,0,89,0,2o||",
                "Malaysia": "2lt,0,4j|||",
                "Maldives": "8hb,0,4j|||",
                "Marquesas": "h9,0,89,0,8hc|||",
                "Marshall_Islands": "h9,0,89,0,8hd|||",
                "Mauritius": "38n,0,1l|38n,0,3t||",
                "Mawson": "h9,0,89,0,63|||",
                "Mexico_Northwest": "1l,0,89,0,38m,0,5e|3t,0,89,0,38m,0,5e||",
                "Mexico_Pacific": "1l,0,89,0,1i6,0,38l,0,1r8|3t,0,89,0,1i6,0,38l,0,1r8||",
                "Mongolia": "1l,0,89,0,4f,0,2m|3t,0,89,0,4f,0,2m||",
                "Moscow": "1l,0,89,0,pi|3t,0,89,0,pi||",
                "Myanmar": "8hh,0,4j|||",
                "Nauru": "8hi,0,4j|||",
                "Nepal": "8hj,0,4j|||",
                "New_Caledonia": "38h,0,1l|38h,0,3t||",
                "New_Zealand": "38f,0,1l|38f,0,3t||",
                "Newfoundland": "1l,0,89,0,53|3t,0,89,0,53||",
                "Niue": "h9,0,89,0,8g|||",
                "Norfolk": "h9,0,89,0,8hm|||",
                "Noronha": "1l,0,89,0,1s,0,2,0,23|3t,0,89,0,1s,0,2,0,23||",
                "North_Mariana": "98,5,8hn,5,4j|||",
                "Novosibirsk": "1l,0,89,0,3b|3t,0,89,0,3b||",
                "Omsk": "1l,0,89,0,26|3t,0,89,0,26||",
                "Pakistan": "1m6,0,1l|1m6,0,3t||",
                "Palau": "8hp,0,4j|||",
                "Papua_New_Guinea": "8hq,0,4j|||",
                "Paraguay": "1pd,0,1l|1pd,0,3t||",
                "Peru": "1nj,0,1l|1nj,0,3t||",
                "Philippines": "1ms,0,1l|1ms,0,3t||",
                "Phoenix_Islands": "h9,0,89,0,8hu|||",
                "Pierre_Miquelon": "1l,0,89,0,8i,5,33,5,8p,5,35|3t,0,89,0,8i,5,33,5,8p,5,35||",
                "Pitcairn": "h9,0,89,0,7e|||",
                "Ponape": "h9,0,89,0,e5|||",
                "Pyongyang": "h9,0,89,0,8a|||",
                "Qyzylorda": "4d,k,0,12j|4d,k,0,3t||",
                "Reunion": "h9,0,89,0,i8|||",
                "Rothera": "h9,0,89,0,5q|||",
                "Sakhalin": "1l,0,89,0,55|3t,0,89,0,55||",
                "Samara": "1j0,0,37u,0,1l|1j0,0,37u,0,3t||",
                "Samoa": "1nt,0,1l|1nt,0,3t||",
                "Seychelles": "8i1,0,4j|||",
                "Singapore": "8i2,0,4j|||",
                "Solomon": "h9,0,89,0,8i3|||",
                "South_Georgia": "h9,0,89,0,8i4,5,2u|||",
                "Suriname": "8i5,0,4j|||",
                "Syowa": "h9,0,89,0,65|||",
                "Tahiti": "8i6,0,4j|||",
                "Taipei": "1l,0,89,0,3d|3t,0,89,0,3d||",
                "Tajikistan": "8i7,0,4j|||",
                "Tokelau": "h9,0,89,0,5d|||",
                "Tonga": "374,0,1l|374,0,3t||",
                "Truk": "h9,0,89,0,8i9|||",
                "Turkmenistan": "1l4,0,1l|1l4,0,3t||",
                "Tuvalu": "8ib,0,4j|||",
                "Uruguay": "1p5,0,1l|1p5,0,3t||",
                "Uzbekistan": "36h,0,1l|36h,0,3t||",
                "Vanuatu": "368,0,1l|368,0,3t||",
                "Venezuela": "2tl,0,4j|||",
                "Vladivostok": "1l,0,89,0,28|3t,0,89,0,28||",
                "Volgograd": "1l,0,89,0,3f|3t,0,89,0,3f||",
                "Vostok": "h9,0,89,0,5t|||",
                "Wake": "h9,0,89,0,5r,0,1f|||",
                "Wallis": "h9,0,89,0,5f,5,0,u0,0,8ig|||",
                "Yakutsk": "1l,0,89,0,qj|3t,0,89,0,qj||",
                "Yekaterinburg": "1l,0,89,0,q6|3t,0,89,0,q6||"
            }
        },
        "nd": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nds-NL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nds": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ne-IN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4ni,0,5n,0,1b||",
                "Europe/London": "|5pu,0,a5,0,1b||"
            },
            "metazone": {
                "Afghanistan": "8ih,0,1b|||",
                "Africa_Central": "14c,0,1or,0,1b|||",
                "Africa_Eastern": "oq,0,1or,0,1b|||",
                "Africa_Southern": "1jl,0,1or,0,1b|||",
                "Africa_Western": "124,0,1or,0,5n,0,1b|124,0,1or,0,a5,0,1b||",
                "Alaska": "35v,0,5n,0,1b|35v,0,jo,0,1b||",
                "Amazon": "35n,0,5n,0,1b|35n,0,a5,0,1b||",
                "America_Central": "14c,0,5n,0,1b|14c,0,jo,0,1b||",
                "America_Eastern": "oq,0,5n,0,1b|oq,0,jo,0,1b||",
                "America_Mountain": "35m,0,5n,0,1b|35m,0,jo,0,1b||",
                "America_Pacific": "24g,0,5n,0,1b|24g,0,jo,0,1b||",
                "Apia": "35g,0,5n,0,1b|35g,0,jo,0,1b||",
                "Arabian": "2bb,0,5n,0,1b|2bb,0,jo,0,1b||",
                "Argentina": "1u1,0,5n,0,1b|1u1,0,a5,0,1b||",
                "Argentina_Western": "q4,0,1u1,0,5n,0,1b|q4,0,1u1,0,a5,0,1b||",
                "Armenia": "35b,0,5n,0,1b|35b,0,a5,0,1b||",
                "Atlantic": "359,0,5n,0,1b|359,0,jo,0,1b||",
                "Australia_Central": "14c,0,177,0,5n,0,1b|14c,0,177,0,jo,0,1b||",
                "Australia_CentralWestern": "14c,0,q4,0,177,0,5n,0,1b|14c,0,q4,0,177,0,jo,0,1b||",
                "Australia_Eastern": "oq,0,177,0,5n,0,1b|oq,0,177,0,jo,0,1b||",
                "Australia_Western": "q4,0,177,0,5n,0,1b|q4,0,177,0,jo,0,1b||",
                "Azerbaijan": "34r,0,5n,0,1b|34r,0,a5,0,1b||",
                "Azores": "345,0,5n,0,1b|345,0,a5,0,1b||",
                "Bangladesh": "341,0,5n,0,1b|341,0,a5,0,1b||",
                "Bhutan": "8j1,0,1b|||",
                "Bolivia": "8j2,0,1b|||",
                "Brasilia": "8j3,0,5n,0,1b|8j4,0,a5,0,1b||",
                "Brunei": "8j5,0,4rf,0,1b|||",
                "Cape_Verde": "1s1,0,33u,0,5n,0,1b|1s1,0,33u,0,a5,0,1b||",
                "Chamorro": "8j7,0,5n,0,1b|||",
                "Chatham": "33p,0,5n,0,1b|33p,0,jo,0,1b||",
                "Chile": "1s0,0,5n,0,1b|1s0,0,a5,0,1b||",
                "China": "2ii,0,5n,0,1b|2ii,0,jo,0,1b||",
                "Choibalsan": "33j,0,5n,0,1b|33j,0,a5,0,1b||",
                "Christmas": "8ja,0,12h,0,1b|||",
                "Cocos": "4rg,0,12h,0,1b|||",
                "Colombia": "4hf,0,5n,0,1b|4hf,0,a5,0,1b||",
                "Cook": "1lj,0,12h,0,5n,0,1b|1lj,0,12h,0,8ep,0,a5,0,1b||",
                "Cuba": "3gh,0,5n,0,1b|3gh,0,jo,0,1b||",
                "Davis": "8en,0,1b|||",
                "DumontDUrville": "8em,5,8el,0,8ek,0,1b|||",
                "East_Timor": "oq,0,8ej,0,1b|||",
                "Easter": "2ds,0,1md,0,5n,0,1b|2ds,0,1md,0,4jl,0,1b||",
                "Ecuador": "8eh,0,1b|||",
                "Europe_Central": "14c,0,1e4,0,5n,0,1b|14c,0,1e4,0,a5,0,1b||",
                "Europe_Eastern": "oq,0,1e4,0,5n,0,1b|oq,0,1e4,0,a5,0,1b||",
                "Europe_Further_Eastern": "8ee,5,oq,0,1e4,0,1b|||",
                "Europe_Western": "q4,0,1e4,0,5n,0,1b|1e4,0,a5,0,1b||",
                "Falkland": "3gi,0,1md,0,5n,0,1b|3gi,0,1md,0,a5,0,1b||",
                "Fiji": "2e1,0,5n,0,1b|2e1,0,a5,0,1b||",
                "French_Guiana": "3gj,0,8e9,0,1b|||",
                "French_Southern": "3gj,0,35u,0,1re,0,8e6,0,1b|||",
                "Galapagos": "8e5,0,1b|||",
                "Gambier": "8e4,0,1b|||",
                "Georgia": "2ju,0,5n,0,1b|2ju,0,a5,0,1b||",
                "Gilbert_Islands": "35s,0,12h,0,1b|||",
                "GMT": "4ri,0,8e1,0,1b|||",
                "Greenland_Eastern": "oq,0,1rg,0,5n,0,1b|oq,0,1rg,0,a5,0,1b||",
                "Greenland_Western": "q4,0,1rg,0,5n,0,1b|q4,0,1rg,0,a5,0,1b||",
                "Gulf": "4kg,0,5n,0,1b|||",
                "Guyana": "2as,0,1b|||",
                "Hawaii_Aleutian": "21u,5,3gm,0,5n,0,1b|21u,5,3gm,0,jo,0,1b||",
                "Hong_Kong": "3gn,0,5n,0,1b|3gn,0,a5,0,1b||",
                "Hovd": "3go,0,5n,0,1b|3go,0,a5,0,1b||",
                "India": "27j,0,5n,0,1b||15a|",
                "Indian_Ocean": "8ds,0,4rj,0,1b|||",
                "Indochina": "8dr,0,1b|||",
                "Indonesia_Central": "14c,0,2jr,0,1b|||",
                "Indonesia_Eastern": "oq,0,2jr,0,1b|||",
                "Indonesia_Western": "q4,0,2jr,0,1b|||",
                "Iran": "3gp,0,5n,0,1b|3gp,0,jo,0,1b||",
                "Irkutsk": "3gq,0,5n,0,1b|3gq,0,a5,0,1b||",
                "Israel": "3gr,0,5n,0,1b|3gr,0,jo,0,1b||",
                "Japan": "2j1,0,5n,0,1b|2j1,0,jo,0,1b||",
                "Kazakhstan_Eastern": "oq,0,3gs,0,1b|||",
                "Kazakhstan_Western": "124,0,3gs,0,1b|||",
                "Korea": "3gt,0,5n,0,1b|3gt,0,jo,0,1b||",
                "Kosrae": "4rk,0,1b|||",
                "Krasnoyarsk": "3gu,0,5n,0,1b|3gu,0,a5,0,1b||",
                "Kyrgystan": "8dj,0,1b|||",
                "Line_Islands": "35k,0,12h,0,1b|||",
                "Lord_Howe": "3gv,0,3h0,0,5n,0,1b|3gv,0,3h0,0,jo,0,1b||",
                "Macquarie": "8dg,0,12h,0,1b|||",
                "Magadan": "2j8,0,5n,0,1b|2j8,0,a5,0,1b||",
                "Malaysia": "8df,0,1b|||",
                "Maldives": "8de,0,1b|||",
                "Marquesas": "8da,0,1b|||",
                "Marshall_Islands": "2ob,0,12h,0,1b|||",
                "Mauritius": "3h1,0,5n,0,1b|3h1,0,a5,0,1b||",
                "Mawson": "8d7,0,1b|||",
                "Mexico_Northwest": "2a5,0,124,0,3h4,0,5n,0,1b|2a5,0,124,0,3h4,0,jo,0,1b||",
                "Mexico_Pacific": "2jb,0,24g,0,5n,0,1b|2jb,0,24g,0,jo,0,1b||",
                "Mongolia": "1rp,0,2e6,0,5n,0,1b|1rp,0,2e6,0,a5,0,1b||",
                "Moscow": "3h5,0,5n,0,1b|3h5,0,a5,0,1b||",
                "Myanmar": "4ed,0,1b|||",
                "Nauru": "8d4,0,1b|||",
                "Nepal": "8d3,0,1b|||",
                "New_Caledonia": "3h6,0,3h8,0,5n,0,1b|3h6,0,3h8,0,a5,0,1b||",
                "New_Zealand": "3h9,0,5n,0,1b|3h9,0,jo,0,1b||",
                "Newfoundland": "8ct,0,5n,0,1b|8cs,0,jo,0,1b||",
                "Niue": "8cr,0,1b|||",
                "Norfolk": "8cq,0,1md,0,1b|||",
                "Noronha": "3ha,0,2jf,0,1n8,0,5n,0,1b|3ha,0,2jf,0,1n8,0,a5,0,1b||",
                "Novosibirsk": "3he,0,5n,0,1b|3he,0,a5,0,1b||",
                "Omsk": "1nb,0,5n,0,1b|1nb,0,a5,0,1b||",
                "Pakistan": "3hf,0,5n,0,1b|3hf,0,a5,0,1b||",
                "Palau": "8cm,0,1b|||",
                "Papua_New_Guinea": "8cl,0,1ld,0,355,0,1b|||",
                "Paraguay": "3hg,0,5n,0,1b|3hg,0,a5,0,1b||",
                "Peru": "354,0,5n,0,1b|2k9,0,a5,0,1b||",
                "Philippines": "3hk,0,5n,0,1b|3hk,0,a5,0,1b||",
                "Phoenix_Islands": "8ci,0,12h,0,1b|||",
                "Pierre_Miquelon": "3hl,0,3hm,0,1re,0,3hn,0,5n,0,1b|3hl,0,3hm,0,1re,0,3hn,0,jo,0,1b||",
                "Pitcairn": "8cc,0,1b|||",
                "Ponape": "4e6,0,1b|||",
                "Pyongyang": "8cb,0,1b|||",
                "Reunion": "4l0,0,1b|||",
                "Rothera": "2qb,0,1b|||",
                "Sakhalin": "3ho,0,5n,0,1b|3ho,0,a5,0,1b||",
                "Samoa": "3hp,0,5n,0,1b|3hp,0,jo,0,1b||",
                "Seychelles": "8c8,0,1b|||",
                "Singapore": "4rq,0,5n,0,1b|||",
                "Solomon": "8c7,0,12h,0,1b|||",
                "South_Georgia": "1jl,0,2ju,0,1b|||",
                "Suriname": "8c5,0,1b|||",
                "Syowa": "34v,0,1b|||",
                "Tahiti": "34u,0,1b|||",
                "Taipei": "3hq,0,5n,0,1b|3hq,0,jo,0,1b||",
                "Tajikistan": "8c3,0,1b|||",
                "Tokelau": "8c2,0,1b|||",
                "Tonga": "1rl,0,5n,0,1b|1rl,0,a5,0,1b||",
                "Truk": "8c1,0,1b|||",
                "Turkmenistan": "1ri,0,5n,0,1b|1ri,0,a5,0,5n,0,1b||",
                "Tuvalu": "8c0,0,1b|||",
                "Uruguay": "8bv,0,5n,0,1b|2jp,0,a5,0,1b||",
                "Uzbekistan": "3hr,0,5n,0,1b|3hr,0,a5,0,1b||",
                "Vanuatu": "3hs,0,5n,0,1b|3hs,0,a5,0,1b||",
                "Venezuela": "8br,0,1b|||",
                "Vladivostok": "3ht,0,5n,0,1b|3ht,0,a5,0,1b||",
                "Volgograd": "3hu,0,5n,0,1b|3hu,0,a5,0,1b||",
                "Vostok": "8bl,0,1b|||",
                "Wake": "34s,0,12h,0,1b|||",
                "Wallis": "8bj,0,1re,0,4l7,0,1b|||",
                "Yakutsk": "3hv,0,5n,0,1b|3hv,0,a5,0,1b||",
                "Yekaterinburg": "3i0,0,5n,0,1b|3i0,0,a5,0,1b||"
            }
        },
        "ne": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4ni,0,5n,0,1b||",
                "Europe/London": "|5pu,0,a5,0,1b||"
            },
            "metazone": {
                "Afghanistan": "8ih,0,1b|||",
                "Africa_Central": "14c,0,1or,0,1b|||",
                "Africa_Eastern": "oq,0,1or,0,1b|||",
                "Africa_Southern": "1jl,0,1or,0,1b|||",
                "Africa_Western": "124,0,1or,0,5n,0,1b|124,0,1or,0,a5,0,1b||",
                "Alaska": "35v,0,5n,0,1b|35v,0,jo,0,1b||",
                "Amazon": "35n,0,5n,0,1b|35n,0,a5,0,1b||",
                "America_Central": "14c,0,5n,0,1b|14c,0,jo,0,1b||",
                "America_Eastern": "oq,0,5n,0,1b|oq,0,jo,0,1b||",
                "America_Mountain": "35m,0,5n,0,1b|35m,0,jo,0,1b||",
                "America_Pacific": "24g,0,5n,0,1b|24g,0,jo,0,1b||",
                "Apia": "35g,0,5n,0,1b|35g,0,jo,0,1b||",
                "Arabian": "2bb,0,5n,0,1b|2bb,0,jo,0,1b||",
                "Argentina": "1u1,0,5n,0,1b|1u1,0,a5,0,1b||",
                "Argentina_Western": "q4,0,1u1,0,5n,0,1b|q4,0,1u1,0,a5,0,1b||",
                "Armenia": "35b,0,5n,0,1b|35b,0,a5,0,1b||",
                "Atlantic": "359,0,5n,0,1b|359,0,jo,0,1b||",
                "Australia_Central": "14c,0,177,0,5n,0,1b|14c,0,177,0,jo,0,1b||",
                "Australia_CentralWestern": "14c,0,q4,0,177,0,5n,0,1b|14c,0,q4,0,177,0,jo,0,1b||",
                "Australia_Eastern": "oq,0,177,0,5n,0,1b|oq,0,177,0,jo,0,1b||",
                "Australia_Western": "q4,0,177,0,5n,0,1b|q4,0,177,0,jo,0,1b||",
                "Azerbaijan": "34r,0,5n,0,1b|34r,0,a5,0,1b||",
                "Azores": "345,0,5n,0,1b|345,0,a5,0,1b||",
                "Bangladesh": "341,0,5n,0,1b|341,0,a5,0,1b||",
                "Bhutan": "8j1,0,1b|||",
                "Bolivia": "8j2,0,1b|||",
                "Brasilia": "8j3,0,5n,0,1b|8j4,0,a5,0,1b||",
                "Brunei": "8j5,0,4rf,0,1b|||",
                "Cape_Verde": "1s1,0,33u,0,5n,0,1b|1s1,0,33u,0,a5,0,1b||",
                "Chamorro": "8j7,0,5n,0,1b|||",
                "Chatham": "33p,0,5n,0,1b|33p,0,jo,0,1b||",
                "Chile": "1s0,0,5n,0,1b|1s0,0,a5,0,1b||",
                "China": "2ii,0,5n,0,1b|2ii,0,jo,0,1b||",
                "Choibalsan": "33j,0,5n,0,1b|33j,0,a5,0,1b||",
                "Christmas": "8ja,0,12h,0,1b|||",
                "Cocos": "4rg,0,12h,0,1b|||",
                "Colombia": "4hf,0,5n,0,1b|4hf,0,a5,0,1b||",
                "Cook": "1lj,0,12h,0,5n,0,1b|1lj,0,12h,0,8ep,0,a5,0,1b||",
                "Cuba": "3gh,0,5n,0,1b|3gh,0,jo,0,1b||",
                "Davis": "8en,0,1b|||",
                "DumontDUrville": "8em,5,8el,0,8ek,0,1b|||",
                "East_Timor": "oq,0,8ej,0,1b|||",
                "Easter": "2ds,0,1md,0,5n,0,1b|2ds,0,1md,0,4jl,0,1b||",
                "Ecuador": "8eh,0,1b|||",
                "Europe_Central": "14c,0,1e4,0,5n,0,1b|14c,0,1e4,0,a5,0,1b||",
                "Europe_Eastern": "oq,0,1e4,0,5n,0,1b|oq,0,1e4,0,a5,0,1b||",
                "Europe_Further_Eastern": "8ee,5,oq,0,1e4,0,1b|||",
                "Europe_Western": "q4,0,1e4,0,5n,0,1b|1e4,0,a5,0,1b||",
                "Falkland": "3gi,0,1md,0,5n,0,1b|3gi,0,1md,0,a5,0,1b||",
                "Fiji": "2e1,0,5n,0,1b|2e1,0,a5,0,1b||",
                "French_Guiana": "3gj,0,8e9,0,1b|||",
                "French_Southern": "3gj,0,35u,0,1re,0,8e6,0,1b|||",
                "Galapagos": "8e5,0,1b|||",
                "Gambier": "8e4,0,1b|||",
                "Georgia": "2ju,0,5n,0,1b|2ju,0,a5,0,1b||",
                "Gilbert_Islands": "35s,0,12h,0,1b|||",
                "GMT": "4ri,0,8e1,0,1b|||",
                "Greenland_Eastern": "oq,0,1rg,0,5n,0,1b|oq,0,1rg,0,a5,0,1b||",
                "Greenland_Western": "q4,0,1rg,0,5n,0,1b|q4,0,1rg,0,a5,0,1b||",
                "Gulf": "4kg,0,5n,0,1b|||",
                "Guyana": "2as,0,1b|||",
                "Hawaii_Aleutian": "21u,5,3gm,0,5n,0,1b|21u,5,3gm,0,jo,0,1b||",
                "Hong_Kong": "3gn,0,5n,0,1b|3gn,0,a5,0,1b||",
                "Hovd": "3go,0,5n,0,1b|3go,0,a5,0,1b||",
                "India": "27j,0,5n,0,1b|||",
                "Indian_Ocean": "8ds,0,4rj,0,1b|||",
                "Indochina": "8dr,0,1b|||",
                "Indonesia_Central": "14c,0,2jr,0,1b|||",
                "Indonesia_Eastern": "oq,0,2jr,0,1b|||",
                "Indonesia_Western": "q4,0,2jr,0,1b|||",
                "Iran": "3gp,0,5n,0,1b|3gp,0,jo,0,1b||",
                "Irkutsk": "3gq,0,5n,0,1b|3gq,0,a5,0,1b||",
                "Israel": "3gr,0,5n,0,1b|3gr,0,jo,0,1b||",
                "Japan": "2j1,0,5n,0,1b|2j1,0,jo,0,1b||",
                "Kazakhstan_Eastern": "oq,0,3gs,0,1b|||",
                "Kazakhstan_Western": "124,0,3gs,0,1b|||",
                "Korea": "3gt,0,5n,0,1b|3gt,0,jo,0,1b||",
                "Kosrae": "4rk,0,1b|||",
                "Krasnoyarsk": "3gu,0,5n,0,1b|3gu,0,a5,0,1b||",
                "Kyrgystan": "8dj,0,1b|||",
                "Line_Islands": "35k,0,12h,0,1b|||",
                "Lord_Howe": "3gv,0,3h0,0,5n,0,1b|3gv,0,3h0,0,jo,0,1b||",
                "Macquarie": "8dg,0,12h,0,1b|||",
                "Magadan": "2j8,0,5n,0,1b|2j8,0,a5,0,1b||",
                "Malaysia": "8df,0,1b|||",
                "Maldives": "8de,0,1b|||",
                "Marquesas": "8da,0,1b|||",
                "Marshall_Islands": "2ob,0,12h,0,1b|||",
                "Mauritius": "3h1,0,5n,0,1b|3h1,0,a5,0,1b||",
                "Mawson": "8d7,0,1b|||",
                "Mexico_Northwest": "2a5,0,124,0,3h4,0,5n,0,1b|2a5,0,124,0,3h4,0,jo,0,1b||",
                "Mexico_Pacific": "2jb,0,24g,0,5n,0,1b|2jb,0,24g,0,jo,0,1b||",
                "Mongolia": "1rp,0,2e6,0,5n,0,1b|1rp,0,2e6,0,a5,0,1b||",
                "Moscow": "3h5,0,5n,0,1b|3h5,0,a5,0,1b||",
                "Myanmar": "4ed,0,1b|||",
                "Nauru": "8d4,0,1b|||",
                "Nepal": "8d3,0,1b|||",
                "New_Caledonia": "3h6,0,3h8,0,5n,0,1b|3h6,0,3h8,0,a5,0,1b||",
                "New_Zealand": "3h9,0,5n,0,1b|3h9,0,jo,0,1b||",
                "Newfoundland": "8ct,0,5n,0,1b|8cs,0,jo,0,1b||",
                "Niue": "8cr,0,1b|||",
                "Norfolk": "8cq,0,1md,0,1b|||",
                "Noronha": "3ha,0,2jf,0,1n8,0,5n,0,1b|3ha,0,2jf,0,1n8,0,a5,0,1b||",
                "Novosibirsk": "3he,0,5n,0,1b|3he,0,a5,0,1b||",
                "Omsk": "1nb,0,5n,0,1b|1nb,0,a5,0,1b||",
                "Pakistan": "3hf,0,5n,0,1b|3hf,0,a5,0,1b||",
                "Palau": "8cm,0,1b|||",
                "Papua_New_Guinea": "8cl,0,1ld,0,355,0,1b|||",
                "Paraguay": "3hg,0,5n,0,1b|3hg,0,a5,0,1b||",
                "Peru": "354,0,5n,0,1b|2k9,0,a5,0,1b||",
                "Philippines": "3hk,0,5n,0,1b|3hk,0,a5,0,1b||",
                "Phoenix_Islands": "8ci,0,12h,0,1b|||",
                "Pierre_Miquelon": "3hl,0,3hm,0,1re,0,3hn,0,5n,0,1b|3hl,0,3hm,0,1re,0,3hn,0,jo,0,1b||",
                "Pitcairn": "8cc,0,1b|||",
                "Ponape": "4e6,0,1b|||",
                "Pyongyang": "8cb,0,1b|||",
                "Reunion": "4l0,0,1b|||",
                "Rothera": "2qb,0,1b|||",
                "Sakhalin": "3ho,0,5n,0,1b|3ho,0,a5,0,1b||",
                "Samoa": "3hp,0,5n,0,1b|3hp,0,jo,0,1b||",
                "Seychelles": "8c8,0,1b|||",
                "Singapore": "4rq,0,5n,0,1b|||",
                "Solomon": "8c7,0,12h,0,1b|||",
                "South_Georgia": "1jl,0,2ju,0,1b|||",
                "Suriname": "8c5,0,1b|||",
                "Syowa": "34v,0,1b|||",
                "Tahiti": "34u,0,1b|||",
                "Taipei": "3hq,0,5n,0,1b|3hq,0,jo,0,1b||",
                "Tajikistan": "8c3,0,1b|||",
                "Tokelau": "8c2,0,1b|||",
                "Tonga": "1rl,0,5n,0,1b|1rl,0,a5,0,1b||",
                "Truk": "8c1,0,1b|||",
                "Turkmenistan": "1ri,0,5n,0,1b|1ri,0,a5,0,5n,0,1b||",
                "Tuvalu": "8c0,0,1b|||",
                "Uruguay": "8bv,0,5n,0,1b|2jp,0,a5,0,1b||",
                "Uzbekistan": "3hr,0,5n,0,1b|3hr,0,a5,0,1b||",
                "Vanuatu": "3hs,0,5n,0,1b|3hs,0,a5,0,1b||",
                "Venezuela": "8br,0,1b|||",
                "Vladivostok": "3ht,0,5n,0,1b|3ht,0,a5,0,1b||",
                "Volgograd": "3hu,0,5n,0,1b|3hu,0,a5,0,1b||",
                "Vostok": "8bl,0,1b|||",
                "Wake": "34s,0,12h,0,1b|||",
                "Wallis": "8bj,0,1re,0,4l7,0,1b|||",
                "Yakutsk": "3hv,0,5n,0,1b|3hv,0,a5,0,1b||",
                "Yekaterinburg": "3i0,0,5n,0,1b|3i0,0,a5,0,1b||"
            }
        },
        "nl-AW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl-BE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl-BQ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl-CW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl-SR": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i||8ob|",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl-SX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1mr,0,1i||",
                "Europe/London": "|1mh,0,1i||",
                "Pacific/Honolulu": "||13h|13d"
            },
            "metazone": {
                "Acre": "3q,5,1h|3q,5,1i||",
                "Afghanistan": "2aa,0,2i|||",
                "Africa_Central": "1e1,5,qa,0,2i|||",
                "Africa_Eastern": "hc,5,qa,0,2i|||",
                "Africa_Southern": "1a2,5,qa,0,2i|||",
                "Africa_Western": "1g,5,qa,0,1h|1g,5,qa,0,1i||",
                "Alaska": "3p,5,1h|3p,5,1i||",
                "Almaty": "16j,5,c2,5,1h|16j,5,c2,5,1i||",
                "Amazon": "16q,5,1h|16q,5,1i||",
                "America_Central": "n,5,1h|n,5,1i||",
                "America_Eastern": "17,5,1h|17,5,1i||",
                "America_Mountain": "5a,5,1h|5a,5,1i||",
                "America_Pacific": "2h,5,1h|2h,5,1i||",
                "Anadyr": "3l,5,1h|3l,5,1i||",
                "Apia": "3e,5,1h|3e,5,1i||",
                "Aqtau": "50,5,1h|50,5,1i||",
                "Aqtobe": "rs,5,1h|rs,5,1i||",
                "Arabian": "t0,0,1h|t0,0,1i||",
                "Argentina": "sb,0,1h|sb,0,1i||",
                "Argentina_Western": "1g,5,sb,0,1h|1g,5,sb,0,1i||",
                "Armenia": "16v,0,1h|16v,0,1i||",
                "Atlantic": "6g,5,1h|6g,5,1i||",
                "Australia_Central": "ms,5,kv,0,1h|ms,5,kv,0,1i||",
                "Australia_CentralWestern": "ms,5,kv,0,174,0,1h|ms,5,kv,0,174,0,1i||",
                "Australia_Eastern": "hc,5,kv,0,1h|hc,5,kv,0,1i||",
                "Australia_Western": "1g,5,kv,0,1h|1g,5,kv,0,1i||",
                "Azerbaijan": "1ce,0,1h|1ce,0,1i||",
                "Azores": "qv,5,1h|qv,5,1i||",
                "Bangladesh": "17c,0,1h|17c,0,1i||",
                "Bhutan": "2a3,0,2i|||",
                "Bolivia": "2a2,0,2i|||",
                "Brasilia": "1e7,0,1h|1e7,0,1i||",
                "Brunei": "22q,0,2i|||",
                "Cape_Verde": "1e0,0,1h|1e0,0,1i||",
                "Casey": "b7,0,2i|||",
                "Chamorro": "6j,5,2i|||",
                "Chatham": "27,5,1h|27,5,1i||",
                "Chile": "1dk,0,1h|1dk,0,1i||",
                "China": "1da,0,1h|1da,0,1i||",
                "Choibalsan": "148,5,1h|148,5,1i||",
                "Christmas": "2a1,0,2i|||",
                "Cocos": "2a0,0,2i|||",
                "Colombia": "1at,0,1h|1at,0,1i||",
                "Cook": "1e2,0,1h|1e2,0,22m,0,1i||",
                "Cuba": "1du,0,1h|1du,0,1i||",
                "Davis": "5s,5,2i|||",
                "DumontDUrville": "5b,5,5j,5,2i|||",
                "East_Timor": "hc,5,22l,0,2i|||",
                "Easter": "1aj,0,1h|1aj,0,1i||",
                "Ecuador": "29v,0,2i|||",
                "Europe_Central": "ms,5,hv,0,1h|ms,5,hv,0,1i|h0|h4",
                "Europe_Eastern": "hc,5,hv,0,1h|hc,5,hv,0,1i|gu|gv",
                "Europe_Further_Eastern": "1q5,5,29t,5,hv,0,2i|||",
                "Europe_Western": "1g,5,hv,0,1h|1g,5,hv,0,1i|h1|h2",
                "Falkland": "1dt,0,1h|1dt,0,1i||",
                "Fiji": "1d4,0,1h|1d4,0,1i||",
                "French_Guiana": "1pg,5,1c9,0,2i|||",
                "French_Southern": "1ph,0,29s,0,ou,0,29q,0,2i|||",
                "Galapagos": "29p,0,2i|||",
                "Gambier": "29o,0,2i|||",
                "Georgia": "qb,0,1h|qb,0,1i||",
                "Gilbert_Islands": "29n,0,2i|||",
                "GMT": "5u,0,bh,0,1|||",
                "Greenland_Eastern": "hc,5,uk,0,1h|hc,5,uk,0,1i||",
                "Greenland_Western": "1g,5,uk,0,1h|1g,5,uk,0,1i||",
                "Guam": "22b,0,1h|||",
                "Gulf": "127,5,1h|||",
                "Guyana": "1c9,0,2i|||",
                "Hawaii_Aleutian": "4g,5,1d2,0,1h|4g,5,1d2,0,1i||",
                "Hong_Kong": "188,0,1h|188,0,1i||",
                "Hovd": "2g,5,1h|2g,5,1i||",
                "India": "29m,0,2i|||",
                "Indian_Ocean": "193,0,229,5,2i|||",
                "Indochina": "29l,0,2i|||",
                "Indonesia_Central": "1e1,5,13j,0,2i|||",
                "Indonesia_Eastern": "hc,5,13j,0,2i|||",
                "Indonesia_Western": "1g,5,13j,0,2i|||",
                "Iran": "1c1,0,1h|1c1,0,1i||",
                "Irkutsk": "16k,5,1h|16k,5,1i||",
                "Israel": "1av,0,1h|1av,0,1i||",
                "Japan": "1aa,0,1h|1aa,0,1i||",
                "Kamchatka": "37,5,16l,5,1h|37,5,16l,5,1i||",
                "Kazakhstan_Eastern": "hc,5,16n,0,2i|||",
                "Kazakhstan_Western": "1g,5,16n,0,2i|||",
                "Korea": "15c,0,1h|15c,0,1i||",
                "Kosrae": "224,0,2i|||",
                "Krasnoyarsk": "l0,5,1h|l0,5,1i||",
                "Kyrgystan": "29k,0,2i|||",
                "Lanka": "9c,5,2i|||",
                "Line_Islands": "ac,5,om,0,2i|||",
                "Lord_Howe": "1u,0,24,5,om,0,1h|1u,0,24,5,om,0,1i||",
                "Macau": "16o,0,1h|16o,0,1i||",
                "Macquarie": "6m,5,om,0,2i|||",
                "Magadan": "2o,5,1h|2o,5,1i||",
                "Malaysia": "29j,0,2i|||",
                "Maldives": "29i,0,2i|||",
                "Marquesas": "29g,0,2i|||",
                "Marshall_Islands": "29f,0,2i|||",
                "Mauritius": "1e9,0,1h|1e9,0,1i||",
                "Mawson": "63,5,2i|||",
                "Mexico_Northwest": "1ei,5,t3,0,1h|1ei,5,t3,0,1i||",
                "Mexico_Pacific": "t3,0,2h,5,1h|t3,0,2h,5,1i||",
                "Mongolia": "p2,5,1h|p2,5,1i||",
                "Moscow": "143,5,1h|143,5,1i||",
                "Myanmar": "220,0,2i|||",
                "Nauru": "29e,0,2i|||",
                "Nepal": "21t,0,2i|||",
                "New_Caledonia": "qc,5,1ea,0,1h|qc,5,1ea,0,1i||",
                "New_Zealand": "qc,5,1a4,0,1h|qc,5,1a4,0,1i||",
                "Newfoundland": "53,5,1h|53,5,1i||",
                "Niue": "21r,0,2i|||",
                "Norfolk": "299,0,2i|||",
                "Noronha": "1s,0,2,0,23,5,1h|1s,0,2,0,23,5,1i||",
                "North_Mariana": "297,0,296,0,2i|||",
                "Novosibirsk": "3b,5,1h|3b,5,1i||",
                "Omsk": "26,5,1h|26,5,1i||",
                "Pakistan": "1ee,0,1h|1ee,0,1i||",
                "Palau": "21p,0,2i|||",
                "Papua_New_Guinea": "1lc,5,qc,5,292,0,2i|||",
                "Paraguay": "1c3,0,1h|1c3,0,1i||",
                "Peru": "1d0,0,1h|1d0,0,1i||",
                "Philippines": "16t,0,1h|16t,0,1i||",
                "Phoenix_Islands": "28u,0,2i|||",
                "Pierre_Miquelon": "8i,0,33,0,ou,0,35,5,1h|8i,0,33,0,ou,0,35,5,1i||",
                "Pitcairn": "28t,0,2i|||",
                "Ponape": "e5,5,2i|||",
                "Pyongyang": "8a,5,2i|||",
                "Qyzylorda": "4d,5,1h|4d,5,1i||",
                "Reunion": "21l,0,2i|||",
                "Rothera": "5q,5,2i|||",
                "Sakhalin": "ph,5,1h|ph,5,1i||",
                "Samara": "29,5,1h|29,5,1i||",
                "Samoa": "1ef,0,1h|1ef,0,1i||",
                "Seychelles": "21h,0,2i|||",
                "Singapore": "21f,0,1h|||",
                "Solomon": "28s,0,2i|||",
                "South_Georgia": "1a2,5,qb,0,2i|||",
                "Suriname": "28r,0,2i|||",
                "Syowa": "65,5,2i|||",
                "Tahiti": "28p,0,2i|||",
                "Taipei": "3d,5,1h|3d,5,1i||",
                "Tajikistan": "21d,0,2i|||",
                "Tokelau": "5d,5,om,0,2i|||",
                "Tonga": "1as,0,1h|1as,0,1i||",
                "Truk": "21c,0,2i|||",
                "Turkmenistan": "171,0,1h|171,0,1i||",
                "Tuvalu": "28o,0,2i|||",
                "Uruguay": "1bi,0,1h|1bi,0,1i||",
                "Uzbekistan": "175,0,1h|175,0,1i||",
                "Vanuatu": "1bp,0,1h|1bp,0,1i||",
                "Venezuela": "28n,0,2i|||",
                "Vladivostok": "28,5,1h|28,5,1i||",
                "Volgograd": "qi,5,1h|qi,5,1i||",
                "Vostok": "5t,5,2i|||",
                "Wake": "5r,5,om,0,2i|||",
                "Wallis": "5f,0,ou,0,219,0,2i|||",
                "Yakutsk": "13v,5,1h|13v,5,1i||",
                "Yekaterinburg": "17a,5,1h|17a,5,1i||"
            }
        },
        "nmg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Africa_Central": "4p3,0,4j|||",
                "Africa_Eastern": "8oc,0,4j|||",
                "Africa_Southern": "4p4,0,4j|||",
                "Africa_Western": "2k2,0,12j|2k2,0,6c||",
                "Australia_Central": "1j3,0,12j|1j3,0,6c||",
                "Australia_CentralWestern": "1o9,5,1j3,0,12j|1o9,5,1j3,0,6c||",
                "Australia_Eastern": "86f,0,12j|86f,0,6c||",
                "Australia_Western": "2km,0,12j|2km,0,6c||",
                "Europe_Central": "2kq,0,12j|2kq,0,6c|h0|h4",
                "Europe_Eastern": "86a,0,12j|86a,0,6c|gu|gv",
                "Europe_Western": "2ks,0,12j|2ks,0,6c|h1|h2",
                "GMT": "8og,0,4qf||ah|"
            }
        },
        "nnh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nus": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "nyn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "om-KE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "om": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "or": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Christmas": "8oh,0,8oi,0,869|||",
                "Galapagos": "8ok,0,869|||",
                "India": "||15a|"
            }
        },
        "os-RU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Europe_Central": "3rf,0,1i7,0,1lh,0,12a|3rf,0,1i7,0,1m8,0,12a||",
                "Europe_Eastern": "3s1,0,1i7,0,1lh,0,12a|3s1,0,1i7,0,1m8,0,12a||",
                "Europe_Western": "3s2,0,1i7,0,1lh,0,12a|3s2,0,1i7,0,1m8,0,12a||",
                "Georgia": "3s5,0,1lh,0,12a|3s5,0,1m8,0,12a||",
                "GMT": "85n,0,85i,0,12a|||",
                "Moscow": "3sg,0,1lh,0,12a|3sg,0,1m8,0,12a||"
            }
        },
        "os": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Europe_Central": "3rf,0,1i7,0,1lh,0,12a|3rf,0,1i7,0,1m8,0,12a||",
                "Europe_Eastern": "3s1,0,1i7,0,1lh,0,12a|3s1,0,1i7,0,1m8,0,12a||",
                "Europe_Western": "3s2,0,1i7,0,1lh,0,12a|3s2,0,1i7,0,1m8,0,12a||",
                "Georgia": "3s5,0,1lh,0,12a|3s5,0,1m8,0,12a||",
                "GMT": "85n,0,85i,0,12a|||",
                "Moscow": "3sg,0,1lh,0,12a|3sg,0,1m8,0,12a||"
            }
        },
        "pa-Arab": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "pa-Guru": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|5p9,0,91,0,2r||",
                "Europe/London": "|5oh,0,ch,0,ci,0,2r||"
            },
            "metazone": {
                "Afghanistan": "85f,0,2r|||",
                "Africa_Central": "1ab,0,1vr,0,2r|||",
                "Africa_Eastern": "10b,0,1vr,0,2r|||",
                "Africa_Southern": "2d9,0,84g,0,91,0,2r|||",
                "Africa_Western": "r7,0,1vr,0,91,0,2r|r7,0,1vr,0,ch,0,ci,0,2r||",
                "Alaska": "3tq,0,91,0,2r|3tq,0,k8,0,2r||",
                "Almaty": "3u4,0,91,0,tq|3u4,0,1oj,5,1ok,0,tq||",
                "Amazon": "3vc,0,91,0,2r|3vc,0,ch,0,ci,0,2r||",
                "America_Central": "15o,0,18q,0,1ab,0,91,0,2r|15o,0,18q,0,1ab,0,k8,0,2r||",
                "America_Eastern": "15o,0,18q,0,10b,0,91,0,2r|15o,0,18q,0,10b,0,k8,0,2r||",
                "America_Mountain": "15o,0,18q,0,40c,0,91,0,2r|15o,0,18q,0,40c,0,k8,0,2r||",
                "America_Pacific": "15o,0,18q,0,1vu,0,91,0,2r|15o,0,18q,0,1vu,0,k8,0,2r||",
                "Apia": "43j,0,91,0,2r|43j,0,k8,0,2r||",
                "Aqtau": "43s,0,91,0,tq|43s,0,1oj,5,1ok,0,tq||",
                "Aqtobe": "443,0,91,0,tq|443,0,1oj,5,1ok,0,tq||",
                "Arabian": "448,0,91,0,2r|448,0,k8,0,2r||",
                "Argentina": "1vv,0,91,0,2r|1vv,0,ch,0,ci,0,2r||",
                "Argentina_Western": "r7,0,1vv,0,91,0,2r|r7,0,1vv,0,ch,0,ci,0,2r||",
                "Armenia": "44d,0,91,0,2r|44d,0,ch,0,ci,0,2r||",
                "Atlantic": "453,0,91,0,2r|453,0,k8,0,2r||",
                "Australia_Central": "18k,0,1ab,0,91,0,2r|18k,0,1ab,0,k8,0,2r||",
                "Australia_CentralWestern": "18k,0,1ab,0,r7,0,91,0,2r|18k,0,1ab,0,r7,0,k8,0,2r||",
                "Australia_Eastern": "18k,0,10b,0,91,0,2r|18k,0,10b,0,k8,0,2r||",
                "Australia_Western": "18k,0,r7,0,91,0,2r|18k,0,r7,0,k8,0,2r||",
                "Azerbaijan": "45f,0,91,0,2r|45f,0,ch,0,ci,0,2r||",
                "Azores": "46e,0,91,0,2r|46e,0,ch,0,ci,0,2r||",
                "Bangladesh": "46f,0,91,0,2r|46f,0,ch,0,ci,0,2r||",
                "Bhutan": "82q,0,2r|||",
                "Bolivia": "82p,0,2r|||",
                "Brasilia": "46m,0,91,0,2r|46m,0,ch,0,ci,0,2r||",
                "Brunei": "82m,0,82k,0,2r|||",
                "Cape_Verde": "46n,0,473,0,91,0,2r|46n,0,473,0,ch,0,ci,0,2r||",
                "Casey": "829,0,tq|||",
                "Chamorro": "823,0,91,0,2r|||",
                "Chatham": "47d,0,91,0,2r|47d,0,k8,0,2r||",
                "Chile": "4ap,0,91,0,2r|4ap,0,ch,0,ci,0,2r||",
                "China": "4ar,0,91,0,2r|4ar,0,k8,0,2r||",
                "Choibalsan": "4b2,0,91,0,2r|4b2,0,ch,0,ci,0,2r||",
                "Christmas": "81s,0,u8,0,2r|||",
                "Cocos": "81q,0,u8,0,2r|||",
                "Colombia": "4d0,0,91,0,2r|4d0,0,ch,0,ci,0,2r||",
                "Cook": "4d1,0,u8,0,91,0,2r|4d1,0,u8,0,81i,0,ch,0,ci,0,2r||",
                "Cuba": "4dh,0,91,0,2r|4dh,0,k8,0,2r||",
                "Davis": "81e,0,2r|||",
                "DumontDUrville": "81d,0,81c,0,2r|||",
                "East_Timor": "10b,0,81a,0,2r|||",
                "Easter": "4dk,0,u8,0,91,0,2r|4dk,0,u8,0,ch,0,ci,0,2r||",
                "Ecuador": "80v,0,2r|||",
                "Europe_Central": "2d2,0,1dd,0,91,0,2r|2d2,0,1dd,0,ch,0,ci,0,2r||",
                "Europe_Eastern": "10b,0,1dd,0,91,0,2r|10b,0,1dd,0,ch,0,ci,0,2r||",
                "Europe_Further_Eastern": "801,5,10b,0,1dd,0,2r|||",
                "Europe_Western": "r7,0,1dd,0,91,0,2r|r7,0,1dd,0,ch,0,ci,0,2r||",
                "Falkland": "4g8,0,2ct,0,91,0,2r|4g8,0,2ct,0,ch,0,ci,0,2r||",
                "Fiji": "4gu,0,91,0,2r|4gu,0,ch,0,ci,0,2r||",
                "French_Guiana": "4he,0,7vq,0,2r|||",
                "French_Southern": "4he,0,2d9,0,204,0,7vj,0,2r|||",
                "Galapagos": "7vh,0,2r|||",
                "Gambier": "7vf,0,2r|||",
                "Georgia": "2cq,0,91,0,2r|2cq,0,ch,0,ci,0,2r||",
                "Gilbert_Islands": "7vc,0,u8,0,2r|||",
                "GMT": "7vb,0,7va,0,2r|||",
                "Greenland_Eastern": "10b,0,206,0,91,0,2r|10b,0,206,0,ch,0,ci,0,2r||",
                "Greenland_Western": "r7,0,206,0,91,0,2r|r7,0,206,0,ch,0,ci,0,2r||",
                "Guam": "7v8,0,tq|||",
                "Gulf": "7v7,0,91,0,2r|||",
                "Guyana": "7v6,0,2r|||",
                "Hawaii_Aleutian": "4ha,5,4h9,0,91,0,2r|4ha,5,4h9,0,k8,0,2r||",
                "Hong_Kong": "4h8,0,4h7,0,91,0,2r|4h8,0,4h7,0,ch,0,ci,0,2r||",
                "Hovd": "4h6,0,91,0,2r|4h6,0,ch,0,ci,0,2r||",
                "India": "7ut,0,91,0,2r||15a|",
                "Indian_Ocean": "7us,0,7ur,0,2r|||",
                "Indochina": "7um,0,2r|||",
                "Indonesia_Central": "2d2,0,7ui,0,2r|||",
                "Indonesia_Eastern": "10b,0,4h5,0,2r|||",
                "Indonesia_Western": "r7,0,4h5,0,2r|||",
                "Iran": "4h4,0,91,0,2r|4h4,0,k8,0,2r||",
                "Irkutsk": "4h3,0,91,0,2r|4h3,0,ch,0,ci,0,2r||",
                "Israel": "4h2,0,91,0,2r|4h2,0,k8,0,2r||",
                "Japan": "4h1,0,91,0,2r|4h1,0,k8,0,2r||",
                "Kazakhstan_Eastern": "10b,0,4h0,0,2r|||",
                "Kazakhstan_Western": "r7,0,4h0,0,2r|||",
                "Korea": "4gv,0,91,0,2r|4gv,0,k8,0,2r||",
                "Kosrae": "7u6,0,2r|||",
                "Krasnoyarsk": "4gt,0,91,0,2r|4gt,0,ch,0,ci,0,2r||",
                "Kyrgystan": "7u0,0,2r|||",
                "Lanka": "7tv,0,tq|||",
                "Line_Islands": "7tu,0,u8,0,2r|||",
                "Lord_Howe": "4gs,0,4gr,0,91,0,2r|4gs,0,4gr,0,k8,0,2r||",
                "Macau": "4gq,0,91,0,tq|4gq,0,1oj,5,1ok,0,tq||",
                "Macquarie": "7tk,0,u8,0,2r|||",
                "Magadan": "4gp,0,91,0,2r|4gp,0,ch,0,ci,0,2r||",
                "Malaysia": "7ti,0,2r|||",
                "Maldives": "7tg,0,2r|||",
                "Marquesas": "7tc,0,2r|||",
                "Marshall_Islands": "7tb,0,u8,0,2r|||",
                "Mauritius": "4go,0,91,0,2r|4go,0,ch,0,ci,0,2r||",
                "Mawson": "7t8,0,2r|||",
                "Mexico_Northwest": "4gn,0,r7,0,4gm,0,91,0,2r|4gn,0,r7,0,4gm,0,k8,0,2r||",
                "Mexico_Pacific": "4gk,0,1vu,0,91,0,2r|4gk,0,1vu,0,k8,0,2r||",
                "Mongolia": "4gj,0,4gi,0,91,0,2r|4gj,0,4gi,0,ch,0,ci,0,2r||",
                "Moscow": "4gh,0,91,0,2r|4gh,0,ch,0,ci,0,2r||",
                "Myanmar": "7sj,0,2r|||",
                "Nauru": "7si,0,2r|||",
                "Nepal": "7sh,0,2r|||",
                "New_Caledonia": "2cm,0,4ge,0,91,0,2r|2cm,0,4ge,0,ch,0,ci,0,2r||",
                "New_Zealand": "4gd,0,91,0,2r|4gd,0,k8,0,2r||",
                "Newfoundland": "4gc,0,91,0,2r|4gc,0,k8,0,2r||",
                "Niue": "7s7,0,2r|||",
                "Norfolk": "7s4,0,u8,0,2r|||",
                "Noronha": "4ga,0,4g9,0,4g7,0,91,0,2r|4ga,0,4g9,0,4g7,0,ch,0,ci,0,2r||",
                "North_Mariana": "15o,0,7ru,0,u8,0,tq|||",
                "Novosibirsk": "4g6,0,91,0,2r|4g6,0,ch,0,ci,0,2r||",
                "Omsk": "4g4,0,91,0,2r|4g4,0,ch,0,ci,0,2r||",
                "Pakistan": "4g2,0,91,0,2r|4g2,0,ch,0,ci,0,2r||",
                "Palau": "7rl,0,2r|||",
                "Papua_New_Guinea": "7rk,0,2cm,0,7rg,0,2r|||",
                "Paraguay": "4g1,0,91,0,2r|4g1,0,ch,0,ci,0,2r||",
                "Peru": "4g0,0,91,0,2r|4g0,0,ch,0,ci,0,2r||",
                "Philippines": "4fv,0,91,0,2r|4fv,0,ch,0,ci,0,2r||",
                "Phoenix_Islands": "7r9,0,u8,0,2r|||",
                "Pierre_Miquelon": "4fm,0,4fl,0,204,0,4fi,0,91,0,2r|4fm,0,4fl,0,204,0,4fi,0,k8,0,2r||",
                "Pitcairn": "7qb,0,2r|||",
                "Ponape": "7q6,0,2r|||",
                "Pyongyang": "7q5,0,2r|||",
                "Qyzylorda": "4fc,0,91,0,tq|4fc,0,1oj,5,1ok,0,tq||",
                "Reunion": "7q2,0,2r|||",
                "Rothera": "7q1,0,2r|||",
                "Sakhalin": "4fa,0,91,0,2r|4fa,0,ch,0,ci,0,2r||",
                "Samoa": "4f9,0,91,0,2r|4f9,0,k8,0,2r||",
                "Seychelles": "7pq,0,2r|||",
                "Singapore": "7pp,0,91,0,2r|||",
                "Solomon": "7po,0,2ct,0,2r|||",
                "South_Georgia": "2d9,0,2cq,0,2r|||",
                "Suriname": "7pm,0,2r|||",
                "Syowa": "7ph,0,2r|||",
                "Tahiti": "7pg,0,2r|||",
                "Taipei": "4f6,0,91,0,2r|4f6,0,k8,0,2r||",
                "Tajikistan": "7pb,0,2r|||",
                "Tokelau": "7p9,0,2r|||",
                "Tonga": "4f3,0,91,0,2r|4f3,0,ch,0,ci,0,2r||",
                "Truk": "7p3,0,2r|||",
                "Turkmenistan": "4f0,0,91,0,2r|4f0,0,ch,0,ci,0,2r||",
                "Tuvalu": "7p0,0,2r|||",
                "Uruguay": "4ev,0,91,0,2r|4ev,0,ch,0,ci,0,2r||",
                "Uzbekistan": "4eu,0,91,0,2r|4eu,0,ch,0,ci,0,2r||",
                "Vanuatu": "4ep,0,91,0,2r|4ep,0,ch,0,ci,0,2r||",
                "Venezuela": "7oi,0,2r|||",
                "Vladivostok": "4ek,0,91,0,2r|4ek,0,ch,0,ci,0,2r||",
                "Volgograd": "4ej,0,91,0,2r|4ej,0,ch,0,ci,0,2r||",
                "Vostok": "7oa,0,2r|||",
                "Wake": "7o9,0,u8,0,2r|||",
                "Wallis": "7nv,0,204,0,7nu,0,2r|||",
                "Yakutsk": "4eb,0,91,0,2r|4eb,0,ch,0,ci,0,2r||",
                "Yekaterinburg": "4ea,0,91,0,2r|4ea,0,ch,0,ci,0,2r||"
            }
        },
        "pa": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|5p9,0,91,0,2r||",
                "Europe/London": "|5oh,0,ch,0,ci,0,2r||"
            },
            "metazone": {
                "Afghanistan": "85f,0,2r|||",
                "Africa_Central": "1ab,0,1vr,0,2r|||",
                "Africa_Eastern": "10b,0,1vr,0,2r|||",
                "Africa_Southern": "2d9,0,84g,0,91,0,2r|||",
                "Africa_Western": "r7,0,1vr,0,91,0,2r|r7,0,1vr,0,ch,0,ci,0,2r||",
                "Alaska": "3tq,0,91,0,2r|3tq,0,k8,0,2r||",
                "Almaty": "3u4,0,91,0,tq|3u4,0,1oj,5,1ok,0,tq||",
                "Amazon": "3vc,0,91,0,2r|3vc,0,ch,0,ci,0,2r||",
                "America_Central": "15o,0,18q,0,1ab,0,91,0,2r|15o,0,18q,0,1ab,0,k8,0,2r||",
                "America_Eastern": "15o,0,18q,0,10b,0,91,0,2r|15o,0,18q,0,10b,0,k8,0,2r||",
                "America_Mountain": "15o,0,18q,0,40c,0,91,0,2r|15o,0,18q,0,40c,0,k8,0,2r||",
                "America_Pacific": "15o,0,18q,0,1vu,0,91,0,2r|15o,0,18q,0,1vu,0,k8,0,2r||",
                "Apia": "43j,0,91,0,2r|43j,0,k8,0,2r||",
                "Aqtau": "43s,0,91,0,tq|43s,0,1oj,5,1ok,0,tq||",
                "Aqtobe": "443,0,91,0,tq|443,0,1oj,5,1ok,0,tq||",
                "Arabian": "448,0,91,0,2r|448,0,k8,0,2r||",
                "Argentina": "1vv,0,91,0,2r|1vv,0,ch,0,ci,0,2r||",
                "Argentina_Western": "r7,0,1vv,0,91,0,2r|r7,0,1vv,0,ch,0,ci,0,2r||",
                "Armenia": "44d,0,91,0,2r|44d,0,ch,0,ci,0,2r||",
                "Atlantic": "453,0,91,0,2r|453,0,k8,0,2r||",
                "Australia_Central": "18k,0,1ab,0,91,0,2r|18k,0,1ab,0,k8,0,2r||",
                "Australia_CentralWestern": "18k,0,1ab,0,r7,0,91,0,2r|18k,0,1ab,0,r7,0,k8,0,2r||",
                "Australia_Eastern": "18k,0,10b,0,91,0,2r|18k,0,10b,0,k8,0,2r||",
                "Australia_Western": "18k,0,r7,0,91,0,2r|18k,0,r7,0,k8,0,2r||",
                "Azerbaijan": "45f,0,91,0,2r|45f,0,ch,0,ci,0,2r||",
                "Azores": "46e,0,91,0,2r|46e,0,ch,0,ci,0,2r||",
                "Bangladesh": "46f,0,91,0,2r|46f,0,ch,0,ci,0,2r||",
                "Bhutan": "82q,0,2r|||",
                "Bolivia": "82p,0,2r|||",
                "Brasilia": "46m,0,91,0,2r|46m,0,ch,0,ci,0,2r||",
                "Brunei": "82m,0,82k,0,2r|||",
                "Cape_Verde": "46n,0,473,0,91,0,2r|46n,0,473,0,ch,0,ci,0,2r||",
                "Casey": "829,0,tq|||",
                "Chamorro": "823,0,91,0,2r|||",
                "Chatham": "47d,0,91,0,2r|47d,0,k8,0,2r||",
                "Chile": "4ap,0,91,0,2r|4ap,0,ch,0,ci,0,2r||",
                "China": "4ar,0,91,0,2r|4ar,0,k8,0,2r||",
                "Choibalsan": "4b2,0,91,0,2r|4b2,0,ch,0,ci,0,2r||",
                "Christmas": "81s,0,u8,0,2r|||",
                "Cocos": "81q,0,u8,0,2r|||",
                "Colombia": "4d0,0,91,0,2r|4d0,0,ch,0,ci,0,2r||",
                "Cook": "4d1,0,u8,0,91,0,2r|4d1,0,u8,0,81i,0,ch,0,ci,0,2r||",
                "Cuba": "4dh,0,91,0,2r|4dh,0,k8,0,2r||",
                "Davis": "81e,0,2r|||",
                "DumontDUrville": "81d,0,81c,0,2r|||",
                "East_Timor": "10b,0,81a,0,2r|||",
                "Easter": "4dk,0,u8,0,91,0,2r|4dk,0,u8,0,ch,0,ci,0,2r||",
                "Ecuador": "80v,0,2r|||",
                "Europe_Central": "2d2,0,1dd,0,91,0,2r|2d2,0,1dd,0,ch,0,ci,0,2r||",
                "Europe_Eastern": "10b,0,1dd,0,91,0,2r|10b,0,1dd,0,ch,0,ci,0,2r||",
                "Europe_Further_Eastern": "801,5,10b,0,1dd,0,2r|||",
                "Europe_Western": "r7,0,1dd,0,91,0,2r|r7,0,1dd,0,ch,0,ci,0,2r||",
                "Falkland": "4g8,0,2ct,0,91,0,2r|4g8,0,2ct,0,ch,0,ci,0,2r||",
                "Fiji": "4gu,0,91,0,2r|4gu,0,ch,0,ci,0,2r||",
                "French_Guiana": "4he,0,7vq,0,2r|||",
                "French_Southern": "4he,0,2d9,0,204,0,7vj,0,2r|||",
                "Galapagos": "7vh,0,2r|||",
                "Gambier": "7vf,0,2r|||",
                "Georgia": "2cq,0,91,0,2r|2cq,0,ch,0,ci,0,2r||",
                "Gilbert_Islands": "7vc,0,u8,0,2r|||",
                "GMT": "7vb,0,7va,0,2r|||",
                "Greenland_Eastern": "10b,0,206,0,91,0,2r|10b,0,206,0,ch,0,ci,0,2r||",
                "Greenland_Western": "r7,0,206,0,91,0,2r|r7,0,206,0,ch,0,ci,0,2r||",
                "Guam": "7v8,0,tq|||",
                "Gulf": "7v7,0,91,0,2r|||",
                "Guyana": "7v6,0,2r|||",
                "Hawaii_Aleutian": "4ha,5,4h9,0,91,0,2r|4ha,5,4h9,0,k8,0,2r||",
                "Hong_Kong": "4h8,0,4h7,0,91,0,2r|4h8,0,4h7,0,ch,0,ci,0,2r||",
                "Hovd": "4h6,0,91,0,2r|4h6,0,ch,0,ci,0,2r||",
                "India": "7ut,0,91,0,2r||15a|",
                "Indian_Ocean": "7us,0,7ur,0,2r|||",
                "Indochina": "7um,0,2r|||",
                "Indonesia_Central": "2d2,0,7ui,0,2r|||",
                "Indonesia_Eastern": "10b,0,4h5,0,2r|||",
                "Indonesia_Western": "r7,0,4h5,0,2r|||",
                "Iran": "4h4,0,91,0,2r|4h4,0,k8,0,2r||",
                "Irkutsk": "4h3,0,91,0,2r|4h3,0,ch,0,ci,0,2r||",
                "Israel": "4h2,0,91,0,2r|4h2,0,k8,0,2r||",
                "Japan": "4h1,0,91,0,2r|4h1,0,k8,0,2r||",
                "Kazakhstan_Eastern": "10b,0,4h0,0,2r|||",
                "Kazakhstan_Western": "r7,0,4h0,0,2r|||",
                "Korea": "4gv,0,91,0,2r|4gv,0,k8,0,2r||",
                "Kosrae": "7u6,0,2r|||",
                "Krasnoyarsk": "4gt,0,91,0,2r|4gt,0,ch,0,ci,0,2r||",
                "Kyrgystan": "7u0,0,2r|||",
                "Lanka": "7tv,0,tq|||",
                "Line_Islands": "7tu,0,u8,0,2r|||",
                "Lord_Howe": "4gs,0,4gr,0,91,0,2r|4gs,0,4gr,0,k8,0,2r||",
                "Macau": "4gq,0,91,0,tq|4gq,0,1oj,5,1ok,0,tq||",
                "Macquarie": "7tk,0,u8,0,2r|||",
                "Magadan": "4gp,0,91,0,2r|4gp,0,ch,0,ci,0,2r||",
                "Malaysia": "7ti,0,2r|||",
                "Maldives": "7tg,0,2r|||",
                "Marquesas": "7tc,0,2r|||",
                "Marshall_Islands": "7tb,0,u8,0,2r|||",
                "Mauritius": "4go,0,91,0,2r|4go,0,ch,0,ci,0,2r||",
                "Mawson": "7t8,0,2r|||",
                "Mexico_Northwest": "4gn,0,r7,0,4gm,0,91,0,2r|4gn,0,r7,0,4gm,0,k8,0,2r||",
                "Mexico_Pacific": "4gk,0,1vu,0,91,0,2r|4gk,0,1vu,0,k8,0,2r||",
                "Mongolia": "4gj,0,4gi,0,91,0,2r|4gj,0,4gi,0,ch,0,ci,0,2r||",
                "Moscow": "4gh,0,91,0,2r|4gh,0,ch,0,ci,0,2r||",
                "Myanmar": "7sj,0,2r|||",
                "Nauru": "7si,0,2r|||",
                "Nepal": "7sh,0,2r|||",
                "New_Caledonia": "2cm,0,4ge,0,91,0,2r|2cm,0,4ge,0,ch,0,ci,0,2r||",
                "New_Zealand": "4gd,0,91,0,2r|4gd,0,k8,0,2r||",
                "Newfoundland": "4gc,0,91,0,2r|4gc,0,k8,0,2r||",
                "Niue": "7s7,0,2r|||",
                "Norfolk": "7s4,0,u8,0,2r|||",
                "Noronha": "4ga,0,4g9,0,4g7,0,91,0,2r|4ga,0,4g9,0,4g7,0,ch,0,ci,0,2r||",
                "North_Mariana": "15o,0,7ru,0,u8,0,tq|||",
                "Novosibirsk": "4g6,0,91,0,2r|4g6,0,ch,0,ci,0,2r||",
                "Omsk": "4g4,0,91,0,2r|4g4,0,ch,0,ci,0,2r||",
                "Pakistan": "4g2,0,91,0,2r|4g2,0,ch,0,ci,0,2r||",
                "Palau": "7rl,0,2r|||",
                "Papua_New_Guinea": "7rk,0,2cm,0,7rg,0,2r|||",
                "Paraguay": "4g1,0,91,0,2r|4g1,0,ch,0,ci,0,2r||",
                "Peru": "4g0,0,91,0,2r|4g0,0,ch,0,ci,0,2r||",
                "Philippines": "4fv,0,91,0,2r|4fv,0,ch,0,ci,0,2r||",
                "Phoenix_Islands": "7r9,0,u8,0,2r|||",
                "Pierre_Miquelon": "4fm,0,4fl,0,204,0,4fi,0,91,0,2r|4fm,0,4fl,0,204,0,4fi,0,k8,0,2r||",
                "Pitcairn": "7qb,0,2r|||",
                "Ponape": "7q6,0,2r|||",
                "Pyongyang": "7q5,0,2r|||",
                "Qyzylorda": "4fc,0,91,0,tq|4fc,0,1oj,5,1ok,0,tq||",
                "Reunion": "7q2,0,2r|||",
                "Rothera": "7q1,0,2r|||",
                "Sakhalin": "4fa,0,91,0,2r|4fa,0,ch,0,ci,0,2r||",
                "Samoa": "4f9,0,91,0,2r|4f9,0,k8,0,2r||",
                "Seychelles": "7pq,0,2r|||",
                "Singapore": "7pp,0,91,0,2r|||",
                "Solomon": "7po,0,2ct,0,2r|||",
                "South_Georgia": "2d9,0,2cq,0,2r|||",
                "Suriname": "7pm,0,2r|||",
                "Syowa": "7ph,0,2r|||",
                "Tahiti": "7pg,0,2r|||",
                "Taipei": "4f6,0,91,0,2r|4f6,0,k8,0,2r||",
                "Tajikistan": "7pb,0,2r|||",
                "Tokelau": "7p9,0,2r|||",
                "Tonga": "4f3,0,91,0,2r|4f3,0,ch,0,ci,0,2r||",
                "Truk": "7p3,0,2r|||",
                "Turkmenistan": "4f0,0,91,0,2r|4f0,0,ch,0,ci,0,2r||",
                "Tuvalu": "7p0,0,2r|||",
                "Uruguay": "4ev,0,91,0,2r|4ev,0,ch,0,ci,0,2r||",
                "Uzbekistan": "4eu,0,91,0,2r|4eu,0,ch,0,ci,0,2r||",
                "Vanuatu": "4ep,0,91,0,2r|4ep,0,ch,0,ci,0,2r||",
                "Venezuela": "7oi,0,2r|||",
                "Vladivostok": "4ek,0,91,0,2r|4ek,0,ch,0,ci,0,2r||",
                "Volgograd": "4ej,0,91,0,2r|4ej,0,ch,0,ci,0,2r||",
                "Vostok": "7oa,0,2r|||",
                "Wake": "7o9,0,u8,0,2r|||",
                "Wallis": "7nv,0,204,0,7nu,0,2r|||",
                "Yakutsk": "4eb,0,91,0,2r|4eb,0,ch,0,ci,0,2r||",
                "Yekaterinburg": "4ea,0,91,0,2r|4ea,0,ch,0,ci,0,2r||"
            }
        },
        "pl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|66f,0,bb,0,i0||",
                "Europe/London": "|ccm,0,ccn,0,154||"
            },
            "metazone": {
                "Afghanistan": "2f0|||",
                "Africa_Central": "og,0,8ui|||",
                "Africa_Eastern": "og,0,8uj|||",
                "Africa_Southern": "og,0,8uk|||",
                "Africa_Western": "og,0,7nl,0,15i|og,0,7nl,0,154||",
                "Alaska": "3p,0,bb,0,i5|3p,0,bb,0,i0||",
                "Amazon": "og,0,7nc,0,15i|og,0,7nc,0,154||",
                "America_Central": "og,0,7nb,0,15i|og,0,7nb,0,154||",
                "America_Eastern": "og,0,7n8,0,15i|og,0,7n8,0,154||",
                "America_Mountain": "og,0,44j,0,15i|og,0,44j,0,154||",
                "America_Pacific": "og,0,4e2,0,15i|og,0,4e2,0,154||",
                "Anadyr": "og,0,15i,0,3l|og,0,3l,0,154||",
                "Apia": "3e,0,bb,0,i5|3e,0,bb,0,i0||",
                "Arabian": "7n6,0,4e1,0,bb,0,i5|7n6,0,4e1,0,bb,0,i0||",
                "Argentina": "4e0,0,bb,0,i5|4e0,0,bb,0,i0||",
                "Argentina_Western": "4e0,0,2tg,0,bb,0,i5|4e0,0,2tg,0,bb,0,i0||",
                "Armenia": "4l,0,bb,0,i5|4l,0,bb,0,i0||",
                "Atlantic": "og,0,7mu,0,15i|og,0,7mu,0,154||",
                "Australia_Central": "og,0,7mo,0,15i|og,0,7mo,0,154||",
                "Australia_CentralWestern": "og,0,7mk,5,4dt,0,15i|og,0,7mk,5,4dt,0,154||",
                "Australia_Eastern": "og,0,7md,0,15i|og,0,7md,0,154||",
                "Australia_Western": "og,0,4dt,0,15i|og,0,4dt,0,154||",
                "Azerbaijan": "7mb,0,bb,0,i5|7mb,0,bb,0,i0||",
                "Azores": "7ma,0,bb,0,i5|7ma,0,bb,0,i0||",
                "Bangladesh": "7m9,0,bb,0,i5|7m9,0,bb,0,i0||",
                "Bhutan": "as|||",
                "Bolivia": "8vb|||",
                "Brasilia": "in,0,bb,0,i5|in,0,bb,0,i0||",
                "Brunei": "9o,0,a4|||",
                "Cape_Verde": "23d,0,7m6,0,7m3,0,bb,0,i5|23d,0,7m6,0,7m3,0,bb,0,i0||",
                "Chamorro": "8vf|||",
                "Chatham": "27,0,bb,0,i5|27,0,bb,0,i0||",
                "Chile": "49,0,bb,0,i5|49,0,bb,0,i0||",
                "China": "7m2,0,bb,0,i5|7m2,0,bb,0,i0||",
                "Choibalsan": "7lv,0,bb,0,i5|7lv,0,bb,0,i0||",
                "Christmas": "4hu,0,8vj,0,8vk|||",
                "Cocos": "23d,0,8vl|||",
                "Colombia": "7ln,0,bb,0,i5|7ln,0,bb,0,i0||",
                "Cook": "23d,0,7lm,0,bb,0,i5|23d,0,7lm,0,bb,0,i0||",
                "Cuba": "tb,0,bb,0,i5|tb,0,bb,0,i0||",
                "Davis": "5s|||",
                "DumontDUrville": "5b,5,5j|||",
                "East_Timor": "7n,0,7ll|||",
                "Easter": "4hu,0,7lk,0,bb,0,i5|4hu,0,7lk,0,bb,0,i0||",
                "Ecuador": "7lf|||",
                "Europe_Central": "og,0,7le,0,15i|og,0,7le,0,154|h0|h4",
                "Europe_Eastern": "og,0,4hv,0,15i|og,0,4hv,0,154|gu|gv",
                "Europe_Further_Eastern": "og,0,4hv,0,8vt|||",
                "Europe_Western": "og,0,7la,0,15i|og,0,7la,0,154|h1|h2",
                "Falkland": "7l7,0,bb,0,i5|7l7,0,bb,0,i0||",
                "Fiji": "7l6,0,bb,0,i5|7l6,0,bb,0,i0||",
                "French_Guiana": "2fd,0,2n4|||",
                "French_Southern": "902,0,903,0,904,0,i3,0,905|||",
                "Galapagos": "ak|||",
                "Gambier": "6v|||",
                "Georgia": "7l4,0,bb,0,i5|7l4,0,bb,0,i0||",
                "Gilbert_Islands": "23d,0,4i0|||",
                "GMT": "og,0,907|||",
                "Greenland_Eastern": "4dl,0,4i1,0,bb,0,i5|4dl,0,4i1,0,bb,0,i0||",
                "Greenland_Western": "4dl,0,2tg,0,bb,0,i5|4dl,0,2tg,0,bb,0,i0||",
                "Gulf": "90a,0,90b|||",
                "Guyana": "2fd|||",
                "Hawaii_Aleutian": "7l0,5,7kv,0,bb,0,i5|7l0,5,7kv,0,bb,0,i0||",
                "Hong_Kong": "qh,0,bb,0,i5|qh,0,bb,0,i0||",
                "Hovd": "7kr,0,bb,0,i5|7kr,0,bb,0,i0||",
                "India": "og,0,90f|||",
                "Indian_Ocean": "bv,0,90g|||",
                "Indochina": "og,0,90h|||",
                "Indonesia_Central": "4i3,0,90j|||",
                "Indonesia_Eastern": "4i3,0,4i1|||",
                "Indonesia_Western": "4i3,0,2tg|||",
                "Iran": "5g,0,bb,0,i5|5g,0,bb,0,i0||",
                "Irkutsk": "1oi,0,bb,0,i5|1oi,0,bb,0,i0||",
                "Israel": "7km,0,bb,0,i5|7km,0,bb,0,i0||",
                "Japan": "7kk,0,bb,0,i5|7kk,0,bb,0,i0||",
                "Kamchatka": "og,0,15i,0,7kj,0,7ki|og,0,7kj,0,7ki,0,154||",
                "Kazakhstan_Eastern": "7ke,0,7ll|||",
                "Kazakhstan_Western": "7ke,0,4i5|||",
                "Korea": "qf,0,bb,0,i5|qf,0,bb,0,i0||",
                "Kosrae": "6f|||",
                "Krasnoyarsk": "l0,0,bb,0,i5|l0,0,bb,0,i0||",
                "Kyrgystan": "1qu|||",
                "Line_Islands": "90r,0,90s|||",
                "Lord_Howe": "1u,0,24,0,bb,0,i5|1u,0,24,0,bb,0,i0||",
                "Macquarie": "6m|||",
                "Magadan": "2o,0,bb,0,i5|2o,0,bb,0,i0||",
                "Malaysia": "90t|||",
                "Maldives": "90u|||",
                "Marquesas": "90v|||",
                "Marshall_Islands": "23d,0,910|||",
                "Mauritius": "4u,0,bb,0,i5|4u,0,bb,0,i0||",
                "Mawson": "63|||",
                "Mexico_Northwest": "4dd,0,7k6,5,4i5,0,bb,0,i5|4dd,0,7k6,5,4i5,0,bb,0,i0||",
                "Mexico_Pacific": "4dd,0,bb,0,4e2,0,i5|4dd,0,bb,0,4e2,0,i0||",
                "Mongolia": "7k4,0,2m,0,bb,0,i5|7k4,0,2m,0,bb,0,i0||",
                "Moscow": "og,0,7k3,0,15i|og,0,7k3,0,154||",
                "Myanmar": "915|||",
                "Nauru": "5v|||",
                "Nepal": "8u|||",
                "New_Caledonia": "269,0,215,0,bb,0,i5|269,0,215,0,bb,0,i0||",
                "New_Zealand": "269,0,395,0,bb,0,i5|269,0,395,0,bb,0,i0||",
                "Newfoundland": "269,0,7k0,0,bb,0,i5|269,0,7k0,0,bb,0,i0||",
                "Niue": "8g|||",
                "Norfolk": "6l|||",
                "Noronha": "1s,0,2,0,23,0,bb,0,i5|1s,0,2,0,23,0,bb,0,i0||",
                "Novosibirsk": "7j5,0,bb,0,i5|7j5,0,bb,0,i0||",
                "Omsk": "26,0,bb,0,i5|26,0,bb,0,i0||",
                "Pakistan": "3i,0,bb,0,i5|3i,0,bb,0,i0||",
                "Palau": "9b|||",
                "Papua_New_Guinea": "9a,5,269,0,919|||",
                "Paraguay": "7j4,0,bb,0,i5|7j4,0,bb,0,i0||",
                "Peru": "4n,0,bb,0,i5|4n,0,bb,0,i0||",
                "Philippines": "7j3,0,bb,0,i5|7j3,0,bb,0,i0||",
                "Phoenix_Islands": "1a7|||",
                "Pierre_Miquelon": "8i,5,33,0,i3,0,35,0,bb,0,i5|8i,5,33,0,i3,0,35,0,bb,0,i0||",
                "Pitcairn": "7e|||",
                "Ponape": "e5|||",
                "Pyongyang": "91c|||",
                "Reunion": "b4|||",
                "Rothera": "5q|||",
                "Sakhalin": "ph,0,bb,0,i5|ph,0,bb,0,i0||",
                "Samara": "og,0,15i,0,29|og,0,29,0,154||",
                "Samoa": "2c,0,bb,0,i5|2c,0,bb,0,i0||",
                "Seychelles": "91d|||",
                "Singapore": "m8|||",
                "Solomon": "23d,0,91e|||",
                "South_Georgia": "2u,0,91f|||",
                "Suriname": "mg|||",
                "Syowa": "65|||",
                "Tahiti": "8n|||",
                "Taipei": "1pc,0,bb,0,i5|1pc,0,bb,0,i0||",
                "Tajikistan": "91h|||",
                "Tokelau": "5d|||",
                "Tonga": "2j,0,bb,0,i5|2j,0,bb,0,i0||",
                "Truk": "6p|||",
                "Turkmenistan": "4t,0,bb,0,i5|4t,0,bb,0,i0||",
                "Tuvalu": "6h|||",
                "Uruguay": "7iv,0,bb,0,i5|7iv,0,bb,0,i0||",
                "Uzbekistan": "60,0,bb,0,i5|60,0,bb,0,i0||",
                "Vanuatu": "2f,0,bb,0,i5|2f,0,bb,0,i0||",
                "Venezuela": "91j|||",
                "Vladivostok": "7iu,0,bb,0,i5|7iu,0,bb,0,i0||",
                "Volgograd": "7it,0,bb,0,i5|7it,0,bb,0,i0||",
                "Vostok": "1kt|||",
                "Wake": "5r|||",
                "Wallis": "5f,0,i3,0,5k|||",
                "Yakutsk": "7is,0,bb,0,i5|7is,0,bb,0,i0||",
                "Yekaterinburg": "7iq,0,bb,0,i5|7iq,0,bb,0,i0||"
            }
        },
        "prg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ps": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Almaty": "|||",
                "Europe_Western": "4i6,0,7ik,0,19h,0,91q,0,4i7|4i6,0,7ik,0,91s,0,4i6,0,91t,0,4i7||",
                "GMT": "91u,0,4i7|||"
            }
        },
        "pt-AO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-CH": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9|4b7|4b5",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n|h0|h4",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h|gu|gv",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i|h1|h2",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-CV": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-GQ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9|4b7|4b5",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n|h0|h4",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h|gu|gv",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i|h1|h2",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-GW": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-LU": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9|4b7|4b5",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n|h0|h4",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h|gu|gv",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i|h1|h2",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-MO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-MZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-PT": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9|4b7|4b5",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n|h0|h4",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h|gu|gv",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i|h1|h2",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-ST": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt-TL": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|9,0,2,0,s,0,14,0,pk||",
                "Europe/London": "|9,0,2,0,s,0,1kg||"
            },
            "metazone": {
                "Acre": "9,0,q,0,16,0,3q|9,0,2,0,s,0,16,0,3q||",
                "Afghanistan": "9,0,16,0,1hv|||",
                "Africa_Central": "9,0,14,0,9d,0,n|||",
                "Africa_Eastern": "9,0,14,0,9d,0,8h|||",
                "Africa_Southern": "9,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "9,0,q,0,14,0,9d,0,9i|9,0,2,0,s,0,14,0,9d,0,9i||",
                "Alaska": "9,0,q,0,16,0,tj|9,0,2,0,s,0,16,0,tj||",
                "Almaty": "9,0,q,0,2,0,56|9,0,2,0,s,0,2,0,56||",
                "Amazon": "9,0,q,0,16,0,bg|9,0,2,0,s,0,16,0,bg||",
                "America_Central": "9,0,q,0,n|9,0,2,0,s,0,n||",
                "America_Eastern": "9,0,q,0,8h|9,0,2,0,s,0,8h||",
                "America_Mountain": "9,0,q,0,14,0,109|9,0,2,0,s,0,14,0,109||",
                "America_Pacific": "9,0,q,0,16,0,9u|9,0,2,0,s,0,16,0,9u||",
                "Anadyr": "9,0,q,0,2,0,3l|9,0,2,0,s,0,2,0,3l||",
                "Apia": "9,0,q,0,2,0,3e|9,0,2,0,s,0,2,0,3e||",
                "Aqtau": "9,0,q,0,2,0,50|9,0,2,0,s,0,2,0,50||",
                "Aqtobe": "9,0,q,0,2,0,5o|9,0,2,0,s,0,2,0,5o||",
                "Arabian": "9,0,q,0,14,0,10t|9,0,2,0,s,0,14,0,10t||",
                "Argentina": "9,0,q,0,14,0,1e|9,0,2,0,s,0,14,0,1e||",
                "Argentina_Western": "9,0,q,0,14,0,1e,0,9i|9,0,2,0,s,0,14,0,1e,0,9i||",
                "Armenia": "9,0,q,0,14,0,12d|9,0,2,0,s,0,14,0,12d||",
                "Atlantic": "9,0,q,0,16,0,10s|9,0,2,0,s,0,16,0,10s||",
                "Australia_Central": "9,0,q,0,14,0,cn,0,n|9,0,2,0,s,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "9,0,q,0,14,0,cn,0,n,0,9i|9,0,2,0,s,0,14,0,cn,0,n,0,9i||",
                "Australia_Eastern": "9,0,q,0,14,0,cn,0,8h|9,0,2,0,s,0,14,0,cn,0,8h||",
                "Australia_Western": "9,0,q,0,14,0,cn,0,9i|9,0,2,0,s,0,14,0,cn,0,9i||",
                "Azerbaijan": "9,0,q,0,16,0,133|9,0,2,0,s,0,16,0,133||",
                "Azores": "9,0,q,0,10q,0,b9|9,0,2,0,s,0,10q,0,b9||",
                "Bangladesh": "9,0,q,0,16,0,3n|9,0,2,0,s,0,16,0,3n||",
                "Bhutan": "9,0,16,0,1hu|||",
                "Bolivia": "9,0,14,0,16g|||",
                "Brasilia": "9,0,q,0,2,0,in|9,0,2,0,s,0,2,0,in||",
                "Brunei": "9,0,16,0,9o,0,a4|||",
                "Cape_Verde": "9,0,q,0,2,0,ck,0,3j|9,0,2,0,s,0,2,0,ck,0,3j||",
                "Chamorro": "9,0,q,0,16,0,6j|||",
                "Chatham": "9,0,q,0,16,0,27|9,0,2,0,s,0,16,0,27||",
                "Chile": "9,0,q,0,16,0,49|9,0,2,0,s,0,16,0,49||",
                "China": "9,0,q,0,14,0,4h|9,0,2,0,s,0,14,0,4h||",
                "Choibalsan": "9,0,q,0,2,0,2q|9,0,2,0,s,0,2,0,2q||",
                "Christmas": "9,0,14,0,h7,0,16,0,1jn|||",
                "Cocos": "9,0,6t,0,ae,0,7v|||",
                "Colombia": "9,0,q,0,14,0,10n|9,0,2,0,s,0,14,0,10n||",
                "Cook": "9,0,q,0,6t,0,ae,0,2v|9,0,2,0,s,0,6t,0,ae,0,2v||",
                "Cuba": "9,0,q,0,2,0,34|9,0,2,0,s,0,2,0,34||",
                "Davis": "9,0,2,0,5s|||",
                "DumontDUrville": "9,0,2,0,5b,5,5j|||",
                "East_Timor": "9,0,2,0,7n,0,vk|||",
                "Easter": "9,0,q,0,14,0,h7,0,14,0,120|9,0,2,0,s,0,14,0,h7,0,14,0,120||",
                "Ecuador": "9,0,16,0,1hs|||",
                "Europe_Central": "9,0,q,0,14,0,4p,0,n|9,0,2,0,s,0,14,0,4p,0,n||",
                "Europe_Eastern": "9,0,q,0,14,0,4p,0,8h|9,0,2,0,s,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "9,0,16,0,1ej,0,vk,0,14,0,4p|||",
                "Europe_Western": "9,0,q,0,14,0,4p,0,9i|9,0,2,0,s,0,14,0,4p,0,9i||",
                "Falkland": "9,0,q,0,6t,0,ae,0,4v|9,0,2,0,s,0,6t,0,ae,0,4v||",
                "Fiji": "9,0,q,0,2,0,4q|9,0,2,0,s,0,2,0,4q||",
                "French_Guiana": "9,0,14,0,am,0,nf|||",
                "French_Southern": "9,0,6t,0,1h4,0,1h2,0,15,0,1ku,0,pf|||",
                "Galapagos": "9,0,6t,0,cp|||",
                "Gambier": "9,0,2,0,6v|||",
                "Georgia": "9,0,q,0,14,0,pv|9,0,2,0,s,0,14,0,pv||",
                "Gilbert_Islands": "9,0,6t,0,ae,0,6q|||",
                "GMT": "9,0,2,0,5u|||",
                "Greenland_Eastern": "9,0,q,0,14,0,o9,0,8h|9,0,2,0,s,0,14,0,o9,0,8h||",
                "Greenland_Western": "9,0,q,0,14,0,o9,0,9i|9,0,2,0,s,0,14,0,o9,0,9i||",
                "Guam": "9,0,q,0,2,0,83|||",
                "Gulf": "9,0,q,0,16,0,oh|||",
                "Guyana": "9,0,14,0,am|||",
                "Hawaii_Aleutian": "9,0,q,0,16,0,12f,0,15,0,11d|9,0,2,0,s,0,16,0,12f,0,15,0,11d||",
                "Hong_Kong": "9,0,q,0,2,0,2l,0,2p|9,0,2,0,s,0,2,0,2l,0,2p||",
                "Hovd": "9,0,q,0,2,0,2g|9,0,2,0,s,0,2,0,2g||",
                "India": "9,0,q,0,14,0,1ho|||",
                "Indian_Ocean": "9,0,16,0,1hn,0,pa|||",
                "Indochina": "9,0,14,0,9p|||",
                "Indonesia_Central": "9,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "9,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "9,0,14,0,q2,0,9i|||",
                "Iran": "9,0,q,0,16,0,12r|9,0,2,0,s,0,16,0,12r||",
                "Irkutsk": "9,0,q,0,2,0,3h|9,0,2,0,s,0,2,0,3h||",
                "Israel": "9,0,q,0,2,0,4e|9,0,2,0,s,0,2,0,4e||",
                "Japan": "9,0,q,0,16,0,11g|9,0,2,0,s,0,16,0,11g||",
                "Kamchatka": "9,0,q,0,2,0,37,5,3k|9,0,2,0,s,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "9,0,16,0,12n,0,8h|||",
                "Kazakhstan_Western": "9,0,16,0,12n,0,9i|||",
                "Korea": "9,0,q,0,14,0,10p|9,0,2,0,s,0,14,0,10p||",
                "Kosrae": "9,0,2,0,6f|||",
                "Krasnoyarsk": "9,0,q,0,2,0,41|9,0,2,0,s,0,2,0,41||",
                "Kyrgystan": "9,0,16,0,1hi|||",
                "Lanka": "9,0,16,0,me,0,9c|||",
                "Line_Islands": "9,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "9,0,q,0,2,0,1u,0,24|9,0,2,0,s,0,2,0,1u,0,24||",
                "Macau": "9,0,q,0,2,0,57|9,0,2,0,s,0,2,0,57||",
                "Macquarie": "9,0,14,0,h7,0,6m|||",
                "Magadan": "9,0,q,0,2,0,2o|9,0,2,0,s,0,2,0,2o||",
                "Malaysia": "9,0,14,0,1hh|||",
                "Maldives": "9,0,6t,0,ov|||",
                "Marquesas": "9,0,6t,0,ae,0,9e|||",
                "Marshall_Islands": "9,0,6t,0,ae,0,7o|||",
                "Mauritius": "9,0,q,0,14,0,12q|9,0,2,0,s,0,14,0,12q||",
                "Mawson": "9,0,2,0,63|||",
                "Mexico_Northwest": "9,0,q,0,16,0,107,0,16,0,au|9,0,2,0,s,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "9,0,q,0,16,0,9u,0,12t|9,0,2,0,s,0,16,0,9u,0,12t||",
                "Mongolia": "9,0,q,0,2,0,4f,0,2m|9,0,2,0,s,0,2,0,4f,0,2m||",
                "Moscow": "9,0,q,0,2,0,134|9,0,2,0,s,0,2,0,134||",
                "Myanmar": "9,0,2,0,1eb|||",
                "Nauru": "9,0,2,0,5v|||",
                "Nepal": "9,0,16,0,8u|||",
                "New_Caledonia": "9,0,q,0,14,0,ba,0,12e|9,0,2,0,s,0,14,0,ba,0,12e||",
                "New_Zealand": "9,0,q,0,14,0,ba,0,117|9,0,2,0,s,0,14,0,ba,0,117||",
                "Newfoundland": "9,0,q,0,14,0,119,0,ba|9,0,2,0,s,0,14,0,119,0,ba||",
                "Niue": "9,0,2,0,8g|||",
                "Norfolk": "9,0,14,0,h7,0,6l|||",
                "Noronha": "9,0,q,0,2,0,1s,0,2,0,23|9,0,2,0,s,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "9,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "9,0,q,0,2,0,3b|9,0,2,0,s,0,2,0,3b||",
                "Omsk": "9,0,q,0,2,0,26|9,0,2,0,s,0,2,0,26||",
                "Pakistan": "9,0,q,0,16,0,11h|9,0,2,0,s,0,16,0,11h||",
                "Palau": "9,0,2,0,9b|||",
                "Papua_New_Guinea": "9,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "9,0,q,0,16,0,p8|9,0,2,0,s,0,16,0,p8||",
                "Peru": "9,0,q,0,16,0,4n|9,0,2,0,s,0,16,0,4n||",
                "Philippines": "9,0,q,0,6t,0,g0|9,0,2,0,s,0,6t,0,g0||",
                "Phoenix_Islands": "9,0,6t,0,ae,0,pd|||",
                "Pierre_Miquelon": "9,0,q,0,2,0,12c,0,gp,0,15,0,12s|9,0,2,0,s,0,2,0,12c,0,gp,0,15,0,12s||",
                "Pitcairn": "9,0,2,0,7e|||",
                "Ponape": "9,0,2,0,9s|||",
                "Pyongyang": "9,0,2,0,8a|||",
                "Qyzylorda": "9,0,q,0,2,0,4d|9,0,2,0,s,0,2,0,4d||",
                "Reunion": "9,0,2,0,1hc|||",
                "Rothera": "9,0,2,0,5q|||",
                "Sakhalin": "9,0,q,0,2,0,11v|9,0,2,0,s,0,2,0,11v||",
                "Samara": "9,0,q,0,2,0,29|9,0,2,0,s,0,2,0,29||",
                "Samoa": "9,0,q,0,2,0,2c|9,0,2,0,s,0,2,0,2c||",
                "Seychelles": "9,0,6t,0,1ke|||",
                "Singapore": "9,0,q,0,2,0,196|||",
                "Solomon": "9,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "9,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "9,0,16,0,8q|||",
                "Syowa": "9,0,2,0,65|||",
                "Tahiti": "9,0,16,0,198|||",
                "Taipei": "9,0,q,0,2,0,12v|9,0,2,0,s,0,2,0,12v||",
                "Tajikistan": "9,0,16,0,1h7|||",
                "Tokelau": "9,0,2,0,5d|||",
                "Tonga": "9,0,q,0,2,0,2j|9,0,2,0,s,0,2,0,2j||",
                "Truk": "9,0,2,0,6p|||",
                "Turkmenistan": "9,0,q,0,16,0,130|9,0,2,0,s,0,16,0,130||",
                "Tuvalu": "9,0,2,0,6h|||",
                "Uruguay": "9,0,q,0,16,0,rn|9,0,2,0,s,0,16,0,rn||",
                "Uzbekistan": "9,0,q,0,16,0,123|9,0,2,0,s,0,16,0,123||",
                "Vanuatu": "9,0,q,0,16,0,2f|9,0,2,0,s,0,16,0,2f||",
                "Venezuela": "9,0,14,0,7s|||",
                "Vladivostok": "9,0,q,0,2,0,28|9,0,2,0,s,0,2,0,28||",
                "Volgograd": "9,0,q,0,2,0,ff|9,0,2,0,s,0,2,0,ff||",
                "Vostok": "9,0,2,0,5t|||",
                "Wake": "9,0,14,0,h7,0,5r|||",
                "Wallis": "9,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "9,0,q,0,2,0,3u|9,0,2,0,s,0,2,0,3u||",
                "Yekaterinburg": "9,0,q,0,2,0,11s|9,0,2,0,s,0,2,0,11s||"
            }
        },
        "pt": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|69,0,e9,0,14,0,pk||",
                "Europe/London": "|69,0,2,0,ec,0,ccp||"
            },
            "metazone": {
                "Acre": "69,0,e9,0,16,0,3q|69,0,2,0,ec,0,16,0,3q|93k|4lq",
                "Afghanistan": "69,0,16,0,1hv|||",
                "Africa_Central": "69,0,14,0,9d,0,n|||",
                "Africa_Eastern": "69,0,14,0,9d,0,8h|||",
                "Africa_Southern": "69,0,14,0,9d,0,16,0,10d|||",
                "Africa_Western": "69,0,e9,0,14,0,9d,0,9i|69,0,2,0,ec,0,14,0,9d,0,9i||",
                "Alaska": "69,0,e9,0,16,0,tj|69,0,2,0,ec,0,16,0,tj||",
                "Almaty": "69,0,e9,0,16,0,56|69,0,2,0,ec,0,16,0,56||",
                "Amazon": "69,0,e9,0,16,0,bg|69,0,2,0,ec,0,16,0,bg|93l|93m",
                "America_Central": "69,0,e9,0,n|69,0,2,0,ec,0,n||",
                "America_Eastern": "69,0,e9,0,8h|69,0,2,0,ec,0,8h||",
                "America_Mountain": "69,0,e9,0,14,0,109|69,0,2,0,ec,0,14,0,109||",
                "America_Pacific": "69,0,e9,0,16,0,9u|69,0,2,0,ec,0,16,0,9u||",
                "Anadyr": "69,0,e9,0,16,0,3l|69,0,2,0,ec,0,16,0,3l||",
                "Apia": "69,0,e9,0,2,0,3e|69,0,2,0,ec,0,2,0,3e||",
                "Aqtau": "69,0,e9,0,16,0,50|69,0,2,0,ec,0,16,0,50||",
                "Aqtobe": "69,0,e9,0,16,0,5o|69,0,2,0,ec,0,16,0,5o||",
                "Arabian": "69,0,e9,0,14,0,10t|69,0,2,0,ec,0,14,0,10t||",
                "Argentina": "69,0,e9,0,14,0,1e|69,0,2,0,ec,0,14,0,1e||",
                "Argentina_Western": "69,0,e9,0,14,0,1e,0,9i|69,0,2,0,ec,0,14,0,1e,0,9i||",
                "Armenia": "69,0,e9,0,14,0,7f9|69,0,2,0,ec,0,14,0,7f9||",
                "Atlantic": "69,0,e9,0,16,0,10s|69,0,2,0,ec,0,16,0,10s||",
                "Australia_Central": "69,0,e9,0,14,0,cn,0,n|69,0,2,0,ec,0,14,0,cn,0,n||",
                "Australia_CentralWestern": "69,0,e9,0,14,0,cn,0,7f8,5,9i|69,0,2,0,ec,0,14,0,cn,0,7f8,5,9i||",
                "Australia_Eastern": "69,0,e9,0,14,0,cn,0,8h|69,0,2,0,ec,0,14,0,cn,0,8h||",
                "Australia_Western": "69,0,e9,0,14,0,cn,0,9i|69,0,2,0,ec,0,14,0,cn,0,9i||",
                "Azerbaijan": "69,0,e9,0,16,0,7ea|69,0,2,0,ec,0,16,0,7ea||",
                "Azores": "69,0,e9,0,10q,0,b9|69,0,2,0,ec,0,10q,0,b9||",
                "Bangladesh": "69,0,e9,0,2,0,3n|69,0,2,0,ec,0,2,0,3n||",
                "Bhutan": "69,0,16,0,1hu|||",
                "Bolivia": "69,0,14,0,16g|||",
                "Brasilia": "69,0,e9,0,2,0,in|69,0,2,0,ec,0,2,0,in|93q|93r",
                "Brunei": "69,0,2,0,9o,0,a4|||",
                "Cape_Verde": "69,0,e9,0,16,0,ck,0,3j|69,0,2,0,ec,0,16,0,ck,0,3j||",
                "Chamorro": "69,0,2,0,6j|||",
                "Chatham": "69,0,e9,0,2,0,27|69,0,2,0,ec,0,2,0,27||",
                "Chile": "69,0,e9,0,16,0,49|69,0,2,0,ec,0,16,0,49||",
                "China": "69,0,e9,0,14,0,4h|69,0,2,0,ec,0,14,0,4h||",
                "Choibalsan": "69,0,e9,0,2,0,2q|69,0,2,0,ec,0,2,0,2q||",
                "Christmas": "69,0,14,0,h7,0,99|||",
                "Cocos": "69,0,6t,0,ae,0,93s|||",
                "Colombia": "69,0,e9,0,14,0,10n|69,0,2,0,ec,0,14,0,10n||",
                "Cook": "69,0,e9,0,6t,0,ae,0,2v|93t,0,69,0,2,0,ec,0,6t,0,ae,0,2v||",
                "Cuba": "69,0,e9,0,2,0,34|69,0,2,0,ec,0,2,0,34||",
                "Davis": "69,0,2,0,5s|||",
                "DumontDUrville": "69,0,2,0,5b,5,5j|||",
                "East_Timor": "69,0,16,0,7n,5,vk|||",
                "Easter": "69,0,e9,0,14,0,h7,0,2,0,120|69,0,2,0,ec,0,14,0,h7,0,2,0,120||",
                "Ecuador": "69,0,16,0,1hs|||",
                "Europe_Central": "69,0,e9,0,14,0,4p,0,n|69,0,2,0,ec,0,14,0,4p,0,n||",
                "Europe_Eastern": "69,0,e9,0,14,0,4p,0,8h|69,0,2,0,ec,0,14,0,4p,0,8h||",
                "Europe_Further_Eastern": "69,0,16,0,1ej,0,vk,0,2ao|||",
                "Europe_Western": "69,0,e9,0,14,0,4p,0,9i|69,0,2,0,ec,0,14,0,4p,0,9i||",
                "Falkland": "69,0,e9,0,6t,0,ae,0,4v|69,0,2,0,ec,0,6t,0,ae,0,4v||",
                "Fiji": "69,0,e9,0,2,0,4q|69,0,2,0,ec,0,2,0,4q||",
                "French_Guiana": "69,0,14,0,am,0,nf|||",
                "French_Southern": "69,0,14,0,93u,0,15,0,16,0,10d,0,14,0,2ah|||",
                "Galapagos": "69,0,2,0,cp|||",
                "Gambier": "69,0,2,0,6v|||",
                "Georgia": "69,0,e9,0,14,0,pv|69,0,2,0,ec,0,14,0,pv||",
                "Gilbert_Islands": "69,0,6t,0,ae,0,7gg|||",
                "GMT": "69,0,16,0,93v,0,2,0,5u|||",
                "Greenland_Eastern": "69,0,e9,0,14,0,7e7,0,8h|69,0,2,0,ec,0,14,0,7e7,0,8h||",
                "Greenland_Western": "69,0,e9,0,14,0,7dv,0,9i|69,0,2,0,ec,0,14,0,7dv,0,9i||",
                "Guam": "69,0,e9,0,2,0,83|||",
                "Gulf": "69,0,16,0,oh|||",
                "Guyana": "69,0,14,0,am|||",
                "Hawaii_Aleutian": "69,0,e9,0,16,0,37g,0,15,0,ae,0,11d|69,0,2,0,ec,0,16,0,37g,0,15,0,ae,0,11d||",
                "Hong_Kong": "69,0,e9,0,2,0,2l,0,2p|69,0,2,0,ec,0,2,0,2l,0,2p||",
                "Hovd": "69,0,e9,0,2,0,2g|69,0,2,0,ec,0,2,0,2g||",
                "India": "69,0,e9,0,14,0,1ho|||",
                "Indian_Ocean": "69,0,16,0,1hn,0,pa|||",
                "Indochina": "69,0,14,0,9p|||",
                "Indonesia_Central": "69,0,14,0,q2,0,n|||",
                "Indonesia_Eastern": "69,0,14,0,q2,0,8h|||",
                "Indonesia_Western": "69,0,14,0,q2,0,9i|||",
                "Iran": "69,0,e9,0,16,0,7du|69,0,2,0,ec,0,16,0,7du||",
                "Irkutsk": "69,0,e9,0,2,0,3h|69,0,2,0,ec,0,2,0,3h||",
                "Israel": "69,0,e9,0,2,0,4e|69,0,2,0,ec,0,2,0,4e||",
                "Japan": "69,0,e9,0,16,0,11g|69,0,2,0,ec,0,16,0,11g||",
                "Kamchatka": "69,0,e9,0,2,0,37,5,3k|69,0,2,0,ec,0,2,0,37,5,3k||",
                "Kazakhstan_Eastern": "69,0,16,0,7dt,0,8h|||",
                "Kazakhstan_Western": "69,0,16,0,7dt,0,9i|||",
                "Korea": "69,0,e9,0,14,0,10p|69,0,2,0,ec,0,14,0,10p||",
                "Kosrae": "69,0,2,0,6f|||",
                "Krasnoyarsk": "69,0,e9,0,2,0,41|69,0,2,0,ec,0,2,0,41||",
                "Kyrgystan": "69,0,16,0,1hi|||",
                "Lanka": "69,0,2,0,9c|||",
                "Line_Islands": "69,0,6t,0,ae,0,ac|||",
                "Lord_Howe": "69,0,e9,0,2,0,1u,0,24|69,0,2,0,ec,0,2,0,1u,0,24||",
                "Macau": "69,0,e9,0,2,0,57|69,0,2,0,ec,0,2,0,57||",
                "Macquarie": "69,0,14,0,h7,0,6m|||",
                "Magadan": "69,0,e9,0,2,0,2o|69,0,2,0,ec,0,2,0,2o||",
                "Malaysia": "69,0,14,0,1hh|||",
                "Maldives": "69,0,6t,0,ae,0,ov|||",
                "Marquesas": "69,0,6t,0,9e|||",
                "Marshall_Islands": "69,0,6t,0,ae,0,7o|||",
                "Mauritius": "69,0,e9,0,6t,0,ae,0,7ds|69,0,2,0,ec,0,6t,0,ae,0,7ds||",
                "Mawson": "69,0,2,0,63|||",
                "Mexico_Northwest": "69,0,e9,0,16,0,107,0,16,0,au|69,0,2,0,ec,0,16,0,107,0,16,0,au||",
                "Mexico_Pacific": "69,0,e9,0,16,0,9u,0,16,0,au|69,0,2,0,ec,0,16,0,9u,0,16,0,au||",
                "Mongolia": "69,0,e9,0,2,0,4f,0,2m|69,0,2,0,ec,0,2,0,4f,0,2m||",
                "Moscow": "69,0,e9,0,2,0,ca|69,0,2,0,ec,0,2,0,ca||",
                "Myanmar": "69,0,2,0,1eb|||",
                "Nauru": "69,0,2,0,5v|||",
                "Nepal": "69,0,16,0,8u|||",
                "New_Caledonia": "69,0,e9,0,14,0,ba,0,7dr|69,0,2,0,ec,0,14,0,ba,0,7dr||",
                "New_Zealand": "69,0,e9,0,14,0,ba,0,117|69,0,2,0,ec,0,14,0,ba,0,117||",
                "Newfoundland": "69,0,e9,0,2,0,119,0,ba|69,0,2,0,ec,0,2,0,119,0,ba||",
                "Niue": "69,0,2,0,8g|||",
                "Norfolk": "69,0,14,0,h7,0,6l|||",
                "Noronha": "69,0,e9,0,2,0,1s,0,2,0,23|69,0,2,0,ec,0,2,0,1s,0,2,0,23||",
                "North_Mariana": "69,0,6t,0,ae,0,bd,0,16,0,p4|||",
                "Novosibirsk": "69,0,e9,0,2,0,3b|69,0,2,0,ec,0,2,0,3b||",
                "Omsk": "69,0,e9,0,2,0,26|69,0,2,0,ec,0,2,0,26||",
                "Pakistan": "69,0,e9,0,16,0,11h|69,0,2,0,ec,0,16,0,11h||",
                "Palau": "69,0,2,0,9b|||",
                "Papua_New_Guinea": "69,0,2,0,9a,0,ba,0,1hf|||",
                "Paraguay": "69,0,e9,0,16,0,p8|69,0,2,0,ec,0,16,0,p8||",
                "Peru": "69,0,e9,0,16,0,4n|69,0,2,0,ec,0,16,0,4n||",
                "Philippines": "69,0,e9,0,6t,0,g0|69,0,2,0,ec,0,6t,0,g0||",
                "Phoenix_Islands": "69,0,6t,0,ae,0,946|||",
                "Pierre_Miquelon": "69,0,e9,0,2,0,8i,0,33,0,15,0,35|69,0,2,0,ec,0,2,0,8i,0,33,0,15,0,35||",
                "Pitcairn": "69,0,2,0,7e|||",
                "Ponape": "69,0,2,0,9s|||",
                "Pyongyang": "69,0,2,0,8a|||",
                "Qyzylorda": "69,0,e9,0,2,0,4d|69,0,2,0,ec,0,2,0,4d||",
                "Reunion": "69,0,6t,0,ae,0,1hc|||",
                "Rothera": "69,0,2,0,5q|||",
                "Sakhalin": "69,0,e9,0,2,0,11v|69,0,2,0,ec,0,2,0,11v||",
                "Samara": "69,0,e9,0,2,0,29|69,0,2,0,ec,0,2,0,29||",
                "Samoa": "69,0,e9,0,2,0,2c|69,0,2,0,ec,0,2,0,2c||",
                "Seychelles": "69,0,6t,0,ae,0,8k|||",
                "Singapore": "69,0,e9,0,2,0,947|||",
                "Solomon": "69,0,6t,0,ae,0,1h8|||",
                "South_Georgia": "69,0,14,0,pv,0,16,0,10d|||",
                "Suriname": "69,0,16,0,8q|||",
                "Syowa": "69,0,2,0,65|||",
                "Tahiti": "69,0,16,0,198|||",
                "Taipei": "69,0,e9,0,2,0,3d|69,0,2,0,ec,0,2,0,3d||",
                "Tajikistan": "69,0,16,0,1h7|||",
                "Tokelau": "69,0,2,0,5d|||",
                "Tonga": "69,0,e9,0,2,0,2j|69,0,2,0,ec,0,2,0,2j||",
                "Truk": "69,0,2,0,6p|||",
                "Turkmenistan": "69,0,e9,0,16,0,7dq|69,0,2,0,ec,0,16,0,7dq||",
                "Tuvalu": "69,0,2,0,6h|||",
                "Uruguay": "69,0,e9,0,16,0,rn|69,0,2,0,ec,0,16,0,rn||",
                "Uzbekistan": "69,0,e9,0,16,0,123|69,0,2,0,ec,0,16,0,123||",
                "Vanuatu": "69,0,e9,0,2,0,2f|69,0,2,0,ec,0,2,0,2f||",
                "Venezuela": "69,0,14,0,7s|||",
                "Vladivostok": "69,0,e9,0,2,0,28|69,0,2,0,ec,0,2,0,28||",
                "Volgograd": "69,0,e9,0,2,0,ff|69,0,2,0,ec,0,2,0,ff||",
                "Vostok": "69,0,2,0,5t|||",
                "Wake": "69,0,6t,0,ae,0,5r|||",
                "Wallis": "69,0,2,0,5f,0,15,0,5k|||",
                "Yakutsk": "69,0,e9,0,2,0,3u|69,0,2,0,ec,0,2,0,3u||",
                "Yekaterinburg": "69,0,e9,0,2,0,11s|69,0,2,0,ec,0,2,0,11s||"
            }
        },
        "qu-BO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Bolivia": "||5pl|"
            }
        },
        "qu-EC": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Ecuador": "||5ps|"
            }
        },
        "qu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Peru": "||5q0|5q1"
            }
        },
        "rm": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "rn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ro-MD": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|i,0,2,0,9n,0,a6,0,5nv||",
                "Europe/London": "|i,0,2,0,9n,0,5nq||"
            },
            "metazone": {
                "Acre": "i,0,38,0,3q|i,0,2,0,9n,0,3q||",
                "Afghanistan": "i,0,7do|||",
                "Africa_Central": "i,0,1nn,0,1gp|||",
                "Africa_Eastern": "i,0,1nn,0,2f6|||",
                "Africa_Southern": "i,0,1nn,0,7dk|||",
                "Africa_Western": "i,0,38,0,a6,0,1nn,0,18o|i,0,2,0,9n,0,a6,0,1nn,0,18o||",
                "Alaska": "i,0,38,0,6d,0,3p|i,0,2,0,9n,0,6d,0,3p||",
                "Amazon": "i,0,38,0,a6,0,4ab|i,0,2,0,9n,0,a6,0,4ab||",
                "America_Central": "i,0,38,0,4aa,0,93,5,14q|i,0,2,0,9n,0,4aa,0,93,5,14q||",
                "America_Eastern": "i,0,38,0,4a8,0,93,5,14q|i,0,2,0,9n,0,4a8,0,93,5,14q||",
                "America_Mountain": "i,0,38,0,1go,0,1gn,0,4a5,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,4a5,0,93,5,14q||",
                "America_Pacific": "i,0,38,0,1go,0,1gn,0,2h,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,2h,0,93,5,14q||",
                "Anadyr": "i,0,38,0,6d,0,3l|i,0,2,0,9n,0,6d,0,3l||",
                "Apia": "i,0,38,0,6d,0,3e|i,0,2,0,9n,0,6d,0,3e||",
                "Arabian": "i,0,38,0,4a4|i,0,2,0,9n,0,4a4||",
                "Argentina": "i,0,38,0,a6,0,24u|i,0,2,0,9n,0,a6,0,24u||",
                "Argentina_Western": "i,0,38,0,a6,0,24u,0,18o|i,0,2,0,9n,0,a6,0,24u,0,18o||",
                "Armenia": "i,0,38,0,a6,0,4a2|i,0,2,0,9n,0,a6,0,4a2||",
                "Atlantic": "i,0,38,0,1go,0,1gn,0,6g,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,6g,0,93,5,14q||",
                "Australia_Central": "i,0,38,0,a6,0,17v,0,1gp|i,0,2,0,9n,0,a6,0,17v,0,1gp||",
                "Australia_CentralWestern": "i,0,38,0,a6,0,17v,0,n,0,18o|i,0,2,0,9n,0,a6,0,17v,0,n,0,18o||",
                "Australia_Eastern": "i,0,38,0,a6,0,17v,0,2f6|i,0,2,0,9n,0,a6,0,17v,0,2f6||",
                "Australia_Western": "i,0,38,0,a6,0,17v,0,18o|i,0,2,0,9n,0,a6,0,17v,0,18o||",
                "Azerbaijan": "i,0,38,0,a6,0,4a0|i,0,2,0,9n,0,a6,0,4a0||",
                "Azores": "i,0,38,0,6d,0,2eg|i,0,2,0,9n,0,6d,0,2eg||",
                "Bangladesh": "i,0,38,0,6d,0,3n|i,0,2,0,9n,0,6d,0,3n||",
                "Bhutan": "i,0,7d5|||",
                "Bolivia": "i,0,7d4|||",
                "Brasilia": "i,0,38,0,a6,0,49v|i,0,2,0,9n,0,a6,0,49v||",
                "Brunei": "i,0,6d,0,9o,0,a4|||",
                "Cape_Verde": "i,0,38,0,6d,0,49u,0,3j|i,0,2,0,9n,0,6d,0,49u,0,3j||",
                "Chamorro": "i,0,6d,0,6j|||",
                "Chatham": "i,0,38,0,6d,0,27|i,0,2,0,9n,0,6d,0,27||",
                "Chile": "i,0,38,0,6d,0,49|i,0,2,0,9n,0,6d,0,49||",
                "China": "i,0,38,0,a6,0,49t|i,0,2,0,9n,0,a6,0,49t||",
                "Choibalsan": "i,0,38,0,6d,0,2q|i,0,2,0,9n,0,6d,0,2q||",
                "Christmas": "i,0,6d,0,2en,0,99|||",
                "Cocos": "i,0,167,0,7v|||",
                "Colombia": "i,0,38,0,a6,0,49q|i,0,2,0,9n,0,a6,0,49q||",
                "Cook": "i,0,38,0,a6,0,167,0,2v|i,0,2,0,9n,0,a6,0,167,0,2v||",
                "Cuba": "i,0,38,0,a6,0,49p|i,0,2,0,9n,0,a6,0,49p||",
                "Davis": "i,0,6d,0,5s|||",
                "DumontDUrville": "i,0,6d,0,5b,5,5j|||",
                "East_Timor": "i,0,7cs,0,2,0,195|||",
                "Easter": "i,0,38,0,6d,0,2en,0,49o|i,0,2,0,9n,0,6d,0,2en,0,49o||",
                "Ecuador": "i,0,7cq|||",
                "Europe_Central": "i,0,38,0,a6,0,1cm,0,1gp|i,0,2,0,9n,0,a6,0,1cm,0,1gp|h0|h4",
                "Europe_Eastern": "i,0,38,0,a6,0,1cm,0,2,0,195|i,0,2,0,9n,0,a6,0,1cm,0,2,0,195|gu|gv",
                "Europe_Further_Eastern": "i,0,1cm,0,2,0,195,0,7co|||",
                "Europe_Western": "i,0,38,0,a6,0,1cm,0,2,0,258|i,0,2,0,9n,0,a6,0,1cm,0,2,0,258|h1|h2",
                "Falkland": "i,0,38,0,6d,0,2eb,0,4v|i,0,2,0,9n,0,6d,0,2eb,0,4v||",
                "Fiji": "i,0,38,0,6d,0,4q|i,0,2,0,9n,0,6d,0,4q||",
                "French_Guiana": "i,0,6d,0,7a,0,7cl|||",
                "French_Southern": "i,0,6d,0,7ck,0,7cj,0,25a,0,7ch,0,25d|||",
                "Galapagos": "i,0,6d,0,ak|||",
                "Gambier": "i,0,6d,0,6v|||",
                "Georgia": "i,0,38,0,a6,0,2e0|i,0,2,0,9n,0,a6,0,2e0||",
                "Gilbert_Islands": "i,0,167,0,6q|||",
                "GMT": "i,0,2,0,7cd||ah|",
                "Greenland_Eastern": "i,0,38,0,a6,0,25e,0,op|i,0,2,0,9n,0,a6,0,25e,0,op||",
                "Greenland_Western": "i,0,38,0,a6,0,25e,0,nd|i,0,2,0,9n,0,a6,0,25e,0,nd||",
                "Gulf": "i,0,38,0,a6,0,7cb|||",
                "Guyana": "i,0,6d,0,7a|||",
                "Hawaii_Aleutian": "i,0,38,0,6d,0,4g,5,1ml|i,0,2,0,9n,0,6d,0,4g,5,1ml||",
                "Hong_Kong": "i,0,38,0,6d,0,2l,0,2p|i,0,2,0,9n,0,6d,0,2l,0,2p||",
                "Hovd": "i,0,38,0,6d,0,2g|i,0,2,0,9n,0,6d,0,2g||",
                "India": "i,0,7ca|||",
                "Indian_Ocean": "i,0,7c9,0,br|||",
                "Indochina": "i,0,7c8|||",
                "Indonesia_Central": "i,0,2di,0,1gp|||",
                "Indonesia_Eastern": "i,0,2di,0,2,0,195|||",
                "Indonesia_Western": "i,0,2di,0,2,0,258|||",
                "Iran": "i,0,38,0,a6,0,49f|i,0,2,0,9n,0,a6,0,49f||",
                "Irkutsk": "i,0,38,0,6d,0,49e|i,0,2,0,9n,0,6d,0,49e||",
                "Israel": "i,0,38,0,a6,0,49d|i,0,2,0,9n,0,a6,0,49d||",
                "Japan": "i,0,38,0,a6,0,49c|i,0,2,0,9n,0,a6,0,49c||",
                "Kamchatka": "i,0,38,0,6d,0,37,5,49b|i,0,2,0,9n,0,6d,0,37,5,49b||",
                "Kazakhstan_Eastern": "i,0,6d,0,49a,0,2,0,195|||",
                "Kazakhstan_Western": "i,0,6d,0,49a,0,2,0,258|||",
                "Korea": "i,0,38,0,a6,0,499|i,0,2,0,9n,0,a6,0,499||",
                "Kosrae": "i,0,6d,0,6f|||",
                "Krasnoyarsk": "i,0,38,0,6d,0,1c7|i,0,2,0,9n,0,6d,0,1c7||",
                "Kyrgystan": "i,0,6d,0,7bv|||",
                "Line_Islands": "i,0,6d,0,2eb,0,ac|||",
                "Lord_Howe": "i,0,38,0,6d,0,1u,0,24|i,0,2,0,9n,0,6d,0,1u,0,24||",
                "Macquarie": "i,0,6d,0,6m|||",
                "Magadan": "i,0,38,0,6d,0,2o|i,0,2,0,9n,0,6d,0,2o||",
                "Malaysia": "i,0,6d,0,bf|||",
                "Maldives": "i,0,6d,0,2ot|||",
                "Marquesas": "i,0,167,0,7bu|||",
                "Marshall_Islands": "i,0,167,0,7o|||",
                "Mauritius": "i,0,38,0,6d,0,4u|i,0,2,0,9n,0,6d,0,4u||",
                "Mawson": "i,0,6d,0,63|||",
                "Mexico_Northwest": "i,0,38,0,a6,0,498,0,2,0,93,5,1o9|i,0,2,0,9n,0,a6,0,498,0,2,0,93,5,1o9||",
                "Mexico_Pacific": "i,0,38,0,a6,0,497,0,2h,0,496|i,0,2,0,9n,0,a6,0,497,0,2h,0,496||",
                "Mongolia": "i,0,38,0,6d,0,4f,0,2m|i,0,2,0,9n,0,6d,0,4f,0,2m||",
                "Moscow": "i,0,38,0,a6,0,495|i,0,2,0,9n,0,a6,0,495||",
                "Myanmar": "i,0,7bp|||",
                "Nauru": "i,0,6d,0,5v|||",
                "Nepal": "i,0,7bo|||",
                "New_Caledonia": "i,0,38,0,a6,0,25f,0,493|i,0,2,0,9n,0,a6,0,25f,0,493||",
                "New_Zealand": "i,0,38,0,a6,0,25f,0,492|i,0,2,0,9n,0,a6,0,25f,0,492||",
                "Newfoundland": "i,0,38,0,6d,0,53|i,0,2,0,9n,0,6d,0,53||",
                "Niue": "i,0,6d,0,8g|||",
                "Norfolk": "i,0,167,0,6l|||",
                "Noronha": "i,0,38,0,6d,0,1s,0,2,0,23|i,0,2,0,9n,0,6d,0,1s,0,2,0,23||",
                "Novosibirsk": "i,0,38,0,6d,0,3b|i,0,2,0,9n,0,6d,0,3b||",
                "Omsk": "i,0,38,0,6d,0,26|i,0,2,0,9n,0,6d,0,26||",
                "Pakistan": "i,0,38,0,a6,0,491|i,0,2,0,9n,0,a6,0,491||",
                "Palau": "i,0,6d,0,9b|||",
                "Papua_New_Guinea": "i,0,6d,0,9a,0,7bj,0,39j|||",
                "Paraguay": "i,0,38,0,6d,0,3c|i,0,2,0,9n,0,6d,0,3c||",
                "Peru": "i,0,38,0,6d,0,4n|i,0,2,0,9n,0,6d,0,4n||",
                "Philippines": "i,0,38,0,6d,0,490|i,0,2,0,9n,0,6d,0,490||",
                "Phoenix_Islands": "i,0,167,0,90|||",
                "Pierre_Miquelon": "i,0,38,0,6d,0,8i,5,33,0,25a,0,35|i,0,2,0,9n,0,6d,0,8i,5,33,0,25a,0,35||",
                "Pitcairn": "i,0,6d,0,7e|||",
                "Ponape": "i,0,6d,0,9s|||",
                "Pyongyang": "i,0,6d,0,8a|||",
                "Reunion": "i,0,6d,0,b4|||",
                "Rothera": "i,0,6d,0,5q|||",
                "Sakhalin": "i,0,38,0,6d,0,164|i,0,2,0,9n,0,6d,0,164||",
                "Samara": "i,0,38,0,6d,0,29|i,0,2,0,9n,0,6d,0,29||",
                "Samoa": "i,0,38,0,6d,0,2c|i,0,2,0,9n,0,6d,0,2c||",
                "Seychelles": "i,0,6d,0,8k|||",
                "Singapore": "i,0,6d,0,bi|||",
                "Solomon": "i,0,167,0,b5|||",
                "South_Georgia": "i,0,2e0,0,2,0,i6|||",
                "Suriname": "i,0,7bg|||",
                "Syowa": "i,0,6d,0,65|||",
                "Tahiti": "i,0,6d,0,8n|||",
                "Taipei": "i,0,38,0,6d,0,3d|i,0,2,0,9n,0,6d,0,3d||",
                "Tajikistan": "i,0,6d,0,lc|||",
                "Tokelau": "i,0,6d,0,5d|||",
                "Tonga": "i,0,38,0,6d,0,2j|i,0,2,0,9n,0,6d,0,2j||",
                "Truk": "i,0,6d,0,6p|||",
                "Turkmenistan": "i,0,38,0,6d,0,4t|i,0,2,0,9n,0,6d,0,4t||",
                "Tuvalu": "i,0,6d,0,6h|||",
                "Uruguay": "i,0,38,0,a6,0,48u|i,0,2,0,9n,0,a6,0,48u||",
                "Uzbekistan": "i,0,38,0,6d,0,60|i,0,2,0,9n,0,6d,0,60||",
                "Vanuatu": "i,0,38,0,6d,0,2f|i,0,2,0,9n,0,6d,0,2f||",
                "Venezuela": "i,0,7be|||",
                "Vladivostok": "i,0,38,0,6d,0,28|i,0,2,0,9n,0,6d,0,28||",
                "Volgograd": "i,0,38,0,6d,0,3f|i,0,2,0,9n,0,6d,0,3f||",
                "Vostok": "i,0,6d,0,5t|||",
                "Wake": "i,0,7bd,0,5r|||",
                "Wallis": "i,0,6d,0,5f,0,25a,0,5k|||",
                "Yakutsk": "i,0,38,0,6d,0,48t|i,0,2,0,9n,0,6d,0,48t||",
                "Yekaterinburg": "i,0,38,0,6d,0,1lr|i,0,2,0,9n,0,6d,0,1lr||"
            }
        },
        "ro": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|i,0,2,0,9n,0,a6,0,5nv||",
                "Europe/London": "|i,0,2,0,9n,0,5nq||"
            },
            "metazone": {
                "Acre": "i,0,38,0,3q|i,0,2,0,9n,0,3q||",
                "Afghanistan": "i,0,7do|||",
                "Africa_Central": "i,0,1nn,0,1gp|||",
                "Africa_Eastern": "i,0,1nn,0,2f6|||",
                "Africa_Southern": "i,0,1nn,0,7dk|||",
                "Africa_Western": "i,0,38,0,a6,0,1nn,0,18o|i,0,2,0,9n,0,a6,0,1nn,0,18o||",
                "Alaska": "i,0,38,0,6d,0,3p|i,0,2,0,9n,0,6d,0,3p||",
                "Amazon": "i,0,38,0,a6,0,4ab|i,0,2,0,9n,0,a6,0,4ab||",
                "America_Central": "i,0,38,0,4aa,0,93,5,14q|i,0,2,0,9n,0,4aa,0,93,5,14q||",
                "America_Eastern": "i,0,38,0,4a8,0,93,5,14q|i,0,2,0,9n,0,4a8,0,93,5,14q||",
                "America_Mountain": "i,0,38,0,1go,0,1gn,0,4a5,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,4a5,0,93,5,14q||",
                "America_Pacific": "i,0,38,0,1go,0,1gn,0,2h,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,2h,0,93,5,14q||",
                "Anadyr": "i,0,38,0,6d,0,3l|i,0,2,0,9n,0,6d,0,3l||",
                "Apia": "i,0,38,0,6d,0,3e|i,0,2,0,9n,0,6d,0,3e||",
                "Arabian": "i,0,38,0,4a4|i,0,2,0,9n,0,4a4||",
                "Argentina": "i,0,38,0,a6,0,24u|i,0,2,0,9n,0,a6,0,24u||",
                "Argentina_Western": "i,0,38,0,a6,0,24u,0,18o|i,0,2,0,9n,0,a6,0,24u,0,18o||",
                "Armenia": "i,0,38,0,a6,0,4a2|i,0,2,0,9n,0,a6,0,4a2||",
                "Atlantic": "i,0,38,0,1go,0,1gn,0,6g,0,93,5,14q|i,0,2,0,9n,0,1go,0,1gn,0,6g,0,93,5,14q||",
                "Australia_Central": "i,0,38,0,a6,0,17v,0,1gp|i,0,2,0,9n,0,a6,0,17v,0,1gp||",
                "Australia_CentralWestern": "i,0,38,0,a6,0,17v,0,n,0,18o|i,0,2,0,9n,0,a6,0,17v,0,n,0,18o||",
                "Australia_Eastern": "i,0,38,0,a6,0,17v,0,2f6|i,0,2,0,9n,0,a6,0,17v,0,2f6||",
                "Australia_Western": "i,0,38,0,a6,0,17v,0,18o|i,0,2,0,9n,0,a6,0,17v,0,18o||",
                "Azerbaijan": "i,0,38,0,a6,0,4a0|i,0,2,0,9n,0,a6,0,4a0||",
                "Azores": "i,0,38,0,6d,0,2eg|i,0,2,0,9n,0,6d,0,2eg||",
                "Bangladesh": "i,0,38,0,6d,0,3n|i,0,2,0,9n,0,6d,0,3n||",
                "Bhutan": "i,0,7d5|||",
                "Bolivia": "i,0,7d4|||",
                "Brasilia": "i,0,38,0,a6,0,49v|i,0,2,0,9n,0,a6,0,49v||",
                "Brunei": "i,0,6d,0,9o,0,a4|||",
                "Cape_Verde": "i,0,38,0,6d,0,49u,0,3j|i,0,2,0,9n,0,6d,0,49u,0,3j||",
                "Chamorro": "i,0,6d,0,6j|||",
                "Chatham": "i,0,38,0,6d,0,27|i,0,2,0,9n,0,6d,0,27||",
                "Chile": "i,0,38,0,6d,0,49|i,0,2,0,9n,0,6d,0,49||",
                "China": "i,0,38,0,a6,0,49t|i,0,2,0,9n,0,a6,0,49t||",
                "Choibalsan": "i,0,38,0,6d,0,2q|i,0,2,0,9n,0,6d,0,2q||",
                "Christmas": "i,0,6d,0,2en,0,99|||",
                "Cocos": "i,0,167,0,7v|||",
                "Colombia": "i,0,38,0,a6,0,49q|i,0,2,0,9n,0,a6,0,49q||",
                "Cook": "i,0,38,0,a6,0,167,0,2v|i,0,2,0,9n,0,a6,0,167,0,2v||",
                "Cuba": "i,0,38,0,a6,0,49p|i,0,2,0,9n,0,a6,0,49p||",
                "Davis": "i,0,6d,0,5s|||",
                "DumontDUrville": "i,0,6d,0,5b,5,5j|||",
                "East_Timor": "i,0,7cs,0,2,0,195|||",
                "Easter": "i,0,38,0,6d,0,2en,0,49o|i,0,2,0,9n,0,6d,0,2en,0,49o||",
                "Ecuador": "i,0,7cq|||",
                "Europe_Central": "i,0,38,0,a6,0,1cm,0,1gp|i,0,2,0,9n,0,a6,0,1cm,0,1gp|h0|h4",
                "Europe_Eastern": "i,0,38,0,a6,0,1cm,0,2,0,195|i,0,2,0,9n,0,a6,0,1cm,0,2,0,195|gu|gv",
                "Europe_Further_Eastern": "i,0,1cm,0,2,0,195,0,7co|||",
                "Europe_Western": "i,0,38,0,a6,0,1cm,0,2,0,258|i,0,2,0,9n,0,a6,0,1cm,0,2,0,258|h1|h2",
                "Falkland": "i,0,38,0,6d,0,2eb,0,4v|i,0,2,0,9n,0,6d,0,2eb,0,4v||",
                "Fiji": "i,0,38,0,6d,0,4q|i,0,2,0,9n,0,6d,0,4q||",
                "French_Guiana": "i,0,6d,0,7a,0,7cl|||",
                "French_Southern": "i,0,6d,0,7ck,0,7cj,0,25a,0,7ch,0,25d|||",
                "Galapagos": "i,0,6d,0,ak|||",
                "Gambier": "i,0,6d,0,6v|||",
                "Georgia": "i,0,38,0,a6,0,2e0|i,0,2,0,9n,0,a6,0,2e0||",
                "Gilbert_Islands": "i,0,167,0,6q|||",
                "GMT": "i,0,2,0,7cd||ah|",
                "Greenland_Eastern": "i,0,38,0,a6,0,25e,0,op|i,0,2,0,9n,0,a6,0,25e,0,op||",
                "Greenland_Western": "i,0,38,0,a6,0,25e,0,nd|i,0,2,0,9n,0,a6,0,25e,0,nd||",
                "Gulf": "i,0,38,0,a6,0,7cb|||",
                "Guyana": "i,0,6d,0,7a|||",
                "Hawaii_Aleutian": "i,0,38,0,6d,0,4g,5,1ml|i,0,2,0,9n,0,6d,0,4g,5,1ml||",
                "Hong_Kong": "i,0,38,0,6d,0,2l,0,2p|i,0,2,0,9n,0,6d,0,2l,0,2p||",
                "Hovd": "i,0,38,0,6d,0,2g|i,0,2,0,9n,0,6d,0,2g||",
                "India": "i,0,7ca|||",
                "Indian_Ocean": "i,0,7c9,0,br|||",
                "Indochina": "i,0,7c8|||",
                "Indonesia_Central": "i,0,2di,0,1gp|||",
                "Indonesia_Eastern": "i,0,2di,0,2,0,195|||",
                "Indonesia_Western": "i,0,2di,0,2,0,258|||",
                "Iran": "i,0,38,0,a6,0,49f|i,0,2,0,9n,0,a6,0,49f||",
                "Irkutsk": "i,0,38,0,6d,0,49e|i,0,2,0,9n,0,6d,0,49e||",
                "Israel": "i,0,38,0,a6,0,49d|i,0,2,0,9n,0,a6,0,49d||",
                "Japan": "i,0,38,0,a6,0,49c|i,0,2,0,9n,0,a6,0,49c||",
                "Kamchatka": "i,0,38,0,6d,0,37,5,49b|i,0,2,0,9n,0,6d,0,37,5,49b||",
                "Kazakhstan_Eastern": "i,0,6d,0,49a,0,2,0,195|||",
                "Kazakhstan_Western": "i,0,6d,0,49a,0,2,0,258|||",
                "Korea": "i,0,38,0,a6,0,499|i,0,2,0,9n,0,a6,0,499||",
                "Kosrae": "i,0,6d,0,6f|||",
                "Krasnoyarsk": "i,0,38,0,6d,0,1c7|i,0,2,0,9n,0,6d,0,1c7||",
                "Kyrgystan": "i,0,6d,0,7bv|||",
                "Line_Islands": "i,0,6d,0,2eb,0,ac|||",
                "Lord_Howe": "i,0,38,0,6d,0,1u,0,24|i,0,2,0,9n,0,6d,0,1u,0,24||",
                "Macquarie": "i,0,6d,0,6m|||",
                "Magadan": "i,0,38,0,6d,0,2o|i,0,2,0,9n,0,6d,0,2o||",
                "Malaysia": "i,0,6d,0,bf|||",
                "Maldives": "i,0,6d,0,2ot|||",
                "Marquesas": "i,0,167,0,7bu|||",
                "Marshall_Islands": "i,0,167,0,7o|||",
                "Mauritius": "i,0,38,0,6d,0,4u|i,0,2,0,9n,0,6d,0,4u||",
                "Mawson": "i,0,6d,0,63|||",
                "Mexico_Northwest": "i,0,38,0,a6,0,498,0,2,0,93,5,1o9|i,0,2,0,9n,0,a6,0,498,0,2,0,93,5,1o9||",
                "Mexico_Pacific": "i,0,38,0,a6,0,497,0,2h,0,496|i,0,2,0,9n,0,a6,0,497,0,2h,0,496||",
                "Mongolia": "i,0,38,0,6d,0,4f,0,2m|i,0,2,0,9n,0,6d,0,4f,0,2m||",
                "Moscow": "i,0,38,0,a6,0,495|i,0,2,0,9n,0,a6,0,495||",
                "Myanmar": "i,0,7bp|||",
                "Nauru": "i,0,6d,0,5v|||",
                "Nepal": "i,0,7bo|||",
                "New_Caledonia": "i,0,38,0,a6,0,25f,0,493|i,0,2,0,9n,0,a6,0,25f,0,493||",
                "New_Zealand": "i,0,38,0,a6,0,25f,0,492|i,0,2,0,9n,0,a6,0,25f,0,492||",
                "Newfoundland": "i,0,38,0,6d,0,53|i,0,2,0,9n,0,6d,0,53||",
                "Niue": "i,0,6d,0,8g|||",
                "Norfolk": "i,0,167,0,6l|||",
                "Noronha": "i,0,38,0,6d,0,1s,0,2,0,23|i,0,2,0,9n,0,6d,0,1s,0,2,0,23||",
                "Novosibirsk": "i,0,38,0,6d,0,3b|i,0,2,0,9n,0,6d,0,3b||",
                "Omsk": "i,0,38,0,6d,0,26|i,0,2,0,9n,0,6d,0,26||",
                "Pakistan": "i,0,38,0,a6,0,491|i,0,2,0,9n,0,a6,0,491||",
                "Palau": "i,0,6d,0,9b|||",
                "Papua_New_Guinea": "i,0,6d,0,9a,0,7bj,0,39j|||",
                "Paraguay": "i,0,38,0,6d,0,3c|i,0,2,0,9n,0,6d,0,3c||",
                "Peru": "i,0,38,0,6d,0,4n|i,0,2,0,9n,0,6d,0,4n||",
                "Philippines": "i,0,38,0,6d,0,490|i,0,2,0,9n,0,6d,0,490||",
                "Phoenix_Islands": "i,0,167,0,90|||",
                "Pierre_Miquelon": "i,0,38,0,6d,0,8i,5,33,0,25a,0,35|i,0,2,0,9n,0,6d,0,8i,5,33,0,25a,0,35||",
                "Pitcairn": "i,0,6d,0,7e|||",
                "Ponape": "i,0,6d,0,9s|||",
                "Pyongyang": "i,0,6d,0,8a|||",
                "Reunion": "i,0,6d,0,b4|||",
                "Rothera": "i,0,6d,0,5q|||",
                "Sakhalin": "i,0,38,0,6d,0,164|i,0,2,0,9n,0,6d,0,164||",
                "Samara": "i,0,38,0,6d,0,29|i,0,2,0,9n,0,6d,0,29||",
                "Samoa": "i,0,38,0,6d,0,2c|i,0,2,0,9n,0,6d,0,2c||",
                "Seychelles": "i,0,6d,0,8k|||",
                "Singapore": "i,0,6d,0,bi|||",
                "Solomon": "i,0,167,0,b5|||",
                "South_Georgia": "i,0,2e0,0,2,0,i6|||",
                "Suriname": "i,0,7bg|||",
                "Syowa": "i,0,6d,0,65|||",
                "Tahiti": "i,0,6d,0,8n|||",
                "Taipei": "i,0,38,0,6d,0,3d|i,0,2,0,9n,0,6d,0,3d||",
                "Tajikistan": "i,0,6d,0,lc|||",
                "Tokelau": "i,0,6d,0,5d|||",
                "Tonga": "i,0,38,0,6d,0,2j|i,0,2,0,9n,0,6d,0,2j||",
                "Truk": "i,0,6d,0,6p|||",
                "Turkmenistan": "i,0,38,0,6d,0,4t|i,0,2,0,9n,0,6d,0,4t||",
                "Tuvalu": "i,0,6d,0,6h|||",
                "Uruguay": "i,0,38,0,a6,0,48u|i,0,2,0,9n,0,a6,0,48u||",
                "Uzbekistan": "i,0,38,0,6d,0,60|i,0,2,0,9n,0,6d,0,60||",
                "Vanuatu": "i,0,38,0,6d,0,2f|i,0,2,0,9n,0,6d,0,2f||",
                "Venezuela": "i,0,7be|||",
                "Vladivostok": "i,0,38,0,6d,0,28|i,0,2,0,9n,0,6d,0,28||",
                "Volgograd": "i,0,38,0,6d,0,3f|i,0,2,0,9n,0,6d,0,3f||",
                "Vostok": "i,0,6d,0,5t|||",
                "Wake": "i,0,7bd,0,5r|||",
                "Wallis": "i,0,6d,0,5f,0,25a,0,5k|||",
                "Yakutsk": "i,0,38,0,6d,0,48t|i,0,2,0,9n,0,6d,0,48t||",
                "Yekaterinburg": "i,0,38,0,6d,0,1lr|i,0,2,0,9n,0,6d,0,1lr||"
            }
        },
        "rof": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "root": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ru-BY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "ru-KG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "ru-KZ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "ru-MD": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "ru-UA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "ru": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,k,0,21,0,p||",
                "Europe/London": "|2jt,k,0,22,0,p||"
            },
            "metazone": {
                "Acre": "1gm,0,21,0,p|1gm,0,22,0,p||",
                "Afghanistan": "28q|||",
                "Africa_Central": "ii,0,mi|||",
                "Africa_Eastern": "ib,0,mi|||",
                "Africa_Southern": "1gi,0,mi|||",
                "Africa_Western": "hn,0,mi,k,0,21,0,p|hn,0,mi,k,0,22,0,p||",
                "Alaska": "12l,k,0,21,0,p|12l,k,0,22,0,p||",
                "Almaty": "1gh,5,1gg,0,21,0,p|1gh,5,1gg,0,22,0,p||",
                "Amazon": "18e,k,0,21,0,p|18e,k,0,22,0,p||",
                "America_Central": "ii,0,m6,k,0,21,0,p|ii,0,m6,k,0,22,0,p||",
                "America_Eastern": "ib,0,m6,k,0,21,0,p|ib,0,m6,k,0,22,0,p||",
                "America_Mountain": "1gf,0,21,0,p,0,1ge|1gf,0,22,0,p,0,1ge||",
                "America_Pacific": "11b,0,21,0,p|11b,0,22,0,p||",
                "Anadyr": "1g7,0,21,0,p|1g7,0,22,0,p||",
                "Apia": "15s,k,0,21,0,p|15s,k,0,22,0,p||",
                "Aqtau": "1g6,k,0,21,0,p|1g6,0,22,0,p||",
                "Aqtobe": "1g5,0,21,0,p|1g5,0,22,0,p||",
                "Arabian": "1g4,0,1g2,k,0,21,0,p|1g4,0,1g2,k,0,22,0,p||",
                "Argentina": "hk,k,0,21,0,p|hk,k,0,22,0,p||",
                "Argentina_Western": "hn,0,hk,k,0,21,0,p|hn,0,hk,k,0,22,0,p||",
                "Armenia": "18n,k,0,21,0,p|18n,k,0,22,0,p||",
                "Atlantic": "1g0,0,21,0,p|1g0,0,22,0,p||",
                "Australia_Central": "ii,0,eo,k,0,21,0,p|ii,0,eo,k,0,22,0,p||",
                "Australia_CentralWestern": "ii,0,eo,k,0,11n,0,21,0,p|ii,0,eo,k,0,11n,0,22,0,p||",
                "Australia_Eastern": "ib,0,eo,k,0,21,0,p|ib,0,eo,k,0,22,0,p||",
                "Australia_Western": "hn,0,eo,k,0,21,0,p|hn,0,eo,k,0,22,0,p||",
                "Azerbaijan": "1df,k,0,21,0,p|1df,k,0,22,0,p||",
                "Azores": "1fv,0,h3,5,hb,k,0,21,0,p|1fv,0,h3,5,hb,k,0,22,0,p||",
                "Bangladesh": "q8,k,0,21,0,p|q8,k,0,22,0,p||",
                "Bhutan": "16f|||",
                "Bolivia": "1pu|||",
                "Brasilia": "15k,k,0,21,0,p|15k,k,0,22,0,p||",
                "Brunei": "1gr,5,1o3|||",
                "Cape_Verde": "12p,5,115,k,0,21,0,p|12p,5,115,k,0,22,0,p||",
                "Casey": "2d5|||",
                "Chamorro": "1qj|||",
                "Chatham": "162,k,0,21,0,p|162,k,0,22,0,p||",
                "Chile": "150,k,0,21,0,p|150,k,0,22,0,p||",
                "China": "1dm,k,0,21,0,p|1dm,k,0,22,0,p||",
                "Choibalsan": "11e,k,0,21,0,p|11e,k,0,22,0,p||",
                "Christmas": "h3,5,qe,0,2d3|||",
                "Cocos": "2d1,0,h3,5,hb|||",
                "Colombia": "15d,k,0,21,0,p|15d,k,0,22,0,p||",
                "Cook": "rk,0,17u,k,0,21,0,p|rk,0,17u,k,0,2d0,0,p||",
                "Cuba": "ql,k,0,21,0,p|ql,k,0,22,0,p||",
                "Davis": "1q3|||",
                "DumontDUrville": "1gu,5,241|||",
                "East_Timor": "1fs,0,1ki|||",
                "Easter": "1fq,5,qe,0,170,k,0,21,0,p|1fq,5,qe,0,170,k,0,22,0,p||",
                "Ecuador": "1qk|||",
                "Europe_Central": "ii,0,lo,k,0,21,0,p|ii,0,lo,k,0,22,0,p||",
                "Europe_Eastern": "ib,0,lo,k,0,21,0,p|ib,0,lo,k,0,22,0,p||",
                "Europe_Further_Eastern": "2cr,0,p|||",
                "Europe_Western": "hn,0,lo,k,0,21,0,p|hn,0,lo,k,0,22,0,p||",
                "Falkland": "1fp,0,h3,5,hb,k,0,21,0,p|1fp,0,h3,5,hb,k,0,22,0,p||",
                "Fiji": "161,k,0,21,0,p|161,k,0,22,0,p||",
                "French_Guiana": "2cj,0,1pb|||",
                "French_Southern": "2cf,0,2dr,0,il,0,2gk,0,2ji|||",
                "Galapagos": "2av,0,h3,5,hb|||",
                "Gambier": "244|||",
                "Georgia": "15e,k,0,21,0,p|15e,k,0,22,0,p||",
                "Gilbert_Islands": "h3,5,hb,0,2dd|||",
                "GMT": "2dq,0,p,0,1jo,0,2e3|||",
                "Greenland_Eastern": "ib,0,pq,k,0,2e7,0,p|ib,0,pq,k,0,22,0,p||",
                "Greenland_Western": "hn,0,pq,k,0,21,0,p|hn,0,pq,k,0,22,0,p||",
                "Guam": "1ir|||",
                "Gulf": "2e8,0,293|||",
                "Guyana": "1ql|||",
                "Hawaii_Aleutian": "1fm,5,1fk,0,21,0,p|1fm,5,1fk,0,22,0,p||",
                "Hong_Kong": "13t,k,0,21,0,p|13t,k,0,22,0,p||",
                "Hovd": "qg,k,0,21,0,p|qg,k,0,22,0,p||",
                "India": "26o|||",
                "Indian_Ocean": "2eh,0,1ao|||",
                "Indochina": "265|||",
                "Indonesia_Central": "ii,0,vo|||",
                "Indonesia_Eastern": "ib,0,vo|||",
                "Indonesia_Western": "hn,0,vo|||",
                "Iran": "rr,k,0,21,0,p|rr,k,0,22,0,p||",
                "Irkutsk": "12u,k,0,21,0,p|12u,k,0,22,0,p||",
                "Israel": "165,k,0,21,0,p|165,k,0,22,0,p||",
                "Japan": "1bb,k,0,21,0,p|1bb,k,0,22,0,p||",
                "Kamchatka": "1d8,5,1fj,k,0,21,0,p|1d8,5,1fj,k,0,22,0,p||",
                "Kazakhstan_Eastern": "1fs,0,180|||",
                "Kazakhstan_Western": "2f4,0,180|||",
                "Korea": "15j,k,0,21,0,p|15j,k,0,22,0,p||",
                "Kosrae": "1qi|||",
                "Krasnoyarsk": "14h,k,0,21,0,p|14h,k,0,22,0,p||",
                "Kyrgystan": "2fp|||",
                "Lanka": "1if,5,1et|||",
                "Line_Islands": "h3,5,hb,0,1eo|||",
                "Lord_Howe": "oi,5,10a,k,0,21,0,p|oi,5,10a,k,0,22,0,p||",
                "Macau": "118,k,0,21,0,p|118,k,0,22,0,p||",
                "Macquarie": "1l5|||",
                "Magadan": "qq,k,0,21,0,p|qq,k,0,22,0,p||",
                "Malaysia": "1pp|||",
                "Maldives": "2g7|||",
                "Marquesas": "2ga,0,h3,5,hb|||",
                "Marshall_Islands": "2h8,0,rk|||",
                "Mauritius": "15t,k,0,21,0,p|15t,k,0,22,0,p||",
                "Mawson": "1lt|||",
                "Mexico_Northwest": "1fg,5,11n,0,11r,0,21,0,p|1fg,5,11n,0,11r,0,22,0,p||",
                "Mexico_Pacific": "11b,0,11r,0,21,0,p|11b,0,11r,0,22,0,p||",
                "Mongolia": "or,5,qo,k,0,21,0,p|or,5,qo,k,0,22,0,p||",
                "Moscow": "r6,k,0,21,0,p|r6,k,0,22,0,p||",
                "Myanmar": "1qm|||",
                "Nauru": "14s|||",
                "Nepal": "16d|||",
                "New_Caledonia": "rl,0,15l,k,0,21,0,p|rl,0,15l,k,0,22,0,p||",
                "New_Zealand": "rl,0,15h,k,0,21,0,p|rl,0,15h,k,0,22,0,p||",
                "Newfoundland": "14t,k,0,21,0,p|14t,k,0,22,0,p||",
                "Niue": "1qn|||",
                "Norfolk": "146|||",
                "Noronha": "141,5,17m,5,132,k,0,21,0,p|141,5,17m,5,132,k,0,22,0,p||",
                "North_Mariana": "2hb,0,2i4,0,h3,5,hb|||",
                "Novosibirsk": "qt,k,0,21,0,p|qt,k,0,22,0,p||",
                "Omsk": "r5,k,0,21,0,p|r5,k,0,22,0,p||",
                "Pakistan": "rq,k,0,21,0,p|rq,k,0,22,0,p||",
                "Palau": "159|||",
                "Papua_New_Guinea": "13k,0,kf,0,rl,0,1m5|||",
                "Paraguay": "13p,k,0,21,0,p|13p,k,0,22,0,p||",
                "Peru": "q1,k,0,21,0,p|q1,k,0,22,0,p||",
                "Philippines": "1cf,k,0,21,0,p|1cf,k,0,22,0,p||",
                "Phoenix_Islands": "h3,5,hb,0,158|||",
                "Pierre_Miquelon": "pr,5,13m,0,il,0,qp,k,0,21,0,p|pr,5,13m,0,il,0,qp,k,0,22,0,p||",
                "Pitcairn": "24j|||",
                "Ponape": "2ia|||",
                "Pyongyang": "1u8|||",
                "Qyzylorda": "1ff,k,0,21,0,1fe|1ff,k,0,22,0,1fe||",
                "Reunion": "1qo|||",
                "Rothera": "157|||",
                "Sakhalin": "r8,k,0,21,0,p|r8,k,0,22,0,p||",
                "Samara": "1fd,0,21,0,p|1fd,0,22,0,p||",
                "Samoa": "p0,k,0,21,0,p|p0,k,0,22,0,p||",
                "Seychelles": "2im,0,rk|||",
                "Singapore": "16b|||",
                "Solomon": "2is,0,rk|||",
                "South_Georgia": "1gi,0,261|||",
                "Suriname": "18v|||",
                "Syowa": "1pr|||",
                "Tahiti": "1ma|||",
                "Taipei": "1a9,k,0,21,0,p|1a9,k,0,22,0,p||",
                "Tajikistan": "264|||",
                "Tokelau": "156|||",
                "Tonga": "ot,k,0,21,0,p|ot,k,0,22,0,p||",
                "Truk": "26d|||",
                "Turkmenistan": "1fc,k,0,21,0,p|1fc,k,0,22,0,p||",
                "Tuvalu": "14j|||",
                "Uruguay": "14a,k,0,21,0,p|14a,k,0,22,0,p||",
                "Uzbekistan": "108,k,0,21,0,p|108,k,0,22,0,p||",
                "Vanuatu": "os,k,0,21,0,p|os,k,0,22,0,p||",
                "Venezuela": "1mf|||",
                "Vladivostok": "qn,k,0,21,0,p|qn,k,0,22,0,p||",
                "Volgograd": "q9,k,0,21,0,p|q9,k,0,22,0,p||",
                "Vostok": "155|||",
                "Wake": "1m0|||",
                "Wallis": "1qq,0,il,0,14l|||",
                "Yakutsk": "14d,k,0,21,0,p|14d,k,0,22,0,p||",
                "Yekaterinburg": "136,k,0,21,0,p|136,k,0,22,0,p||"
            }
        },
        "rw": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "rwk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "sah": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Arabian": "797,0,10m,0,m7|797,0,122,0,m7||",
                "Armenia": "793,0,10m,0,m7|793,0,122,0,m7||",
                "Australia_Central": "792,0,eo,0,10m,0,m7|792,0,eo,0,122,0,m7||",
                "Australia_Eastern": "4ih,0,eo,0,10m,0,m7|4ih,0,eo,0,122,0,m7||",
                "Australia_Western": "4ii,0,eo,0,10m,0,m7|4ii,0,eo,0,122,0,m7||",
                "China": "452,0,10m,0,m7|452,0,122,0,m7||",
                "Choibalsan": "11e,0,10m,0,m7|11e,0,122,0,m7||",
                "Georgia": "78v,0,10m,0,m7|78v,0,122,0,m7||",
                "India": "991,0,10m,0,m7|||",
                "Iran": "992,0,10m,0,m7|993,0,122,0,m7||",
                "Japan": "78u,0,10m,0,m7|78u,0,122,0,m7||",
                "Kazakhstan_Eastern": "4ih,0,78t,0,m7|||",
                "Kazakhstan_Western": "4ii,0,78t,0,m7|||",
                "Korea": "78s,0,10m,0,m7|78s,0,122,0,m7||",
                "Krasnoyarsk": "78r,0,10m,0,m7|78r,0,122,0,m7||",
                "Kyrgystan": "998,0,m7|||",
                "Magadan": "78q,0,10m,0,m7|78q,0,122,0,m7||",
                "Mongolia": "or,0,78p,0,10m,0,m7|or,0,78p,0,122,0,m7||",
                "Moscow": "78o,0,10m,0,m7|78o,0,122,0,m7||",
                "New_Zealand": "78n,0,78m,0,10m,0,m7|78n,0,78m,0,122,0,m7||",
                "Novosibirsk": "78l,0,10m,0,m7|78l,0,122,0,m7||",
                "Omsk": "78k,0,10m,0,m7|78k,0,122,0,m7||",
                "Pakistan": "78j,0,10m,0,m7|78j,0,122,0,m7||",
                "Sakhalin": "78i,0,10m,0,m7|78i,0,122,0,m7||",
                "Vladivostok": "78h,0,10m,0,m7|78h,0,122,0,m7||",
                "Volgograd": "q9,0,10m,0,m7|q9,0,122,0,m7||",
                "Yakutsk": "78g,0,10m,0,m7|78g,0,122,0,m7||",
                "Yekaterinburg": "78f,0,10m,0,m7|78f,0,122,0,m7||"
            }
        },
        "saq": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "sbp": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "se-FI": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {},
            "metazone": {
                "Europe_Central": "2iu,5,15b,0,1fb|2iu,5,15b,0,1fa|h0|h4",
                "Europe_Eastern": "2iv,5,15b,0,1fb|2iv,5,15b,0,1fa|gu|gv",
                "Europe_Western": "2j4,5,15b,0,1fb|2j4,5,15b,0,1fa|h1|h2",
                "GMT": "5u,0,4ij,0,4ik||ah|",
                "Moscow": "pi,5,1fb|pi,5,1fa||"
            }
        },
        "se-SE": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {},
            "metazone": {
                "Europe_Central": "2iu,5,15b,0,1fb|2iu,5,15b,0,1fa|h0|h4",
                "Europe_Eastern": "2iv,5,15b,0,1fb|2iv,5,15b,0,1fa|gu|gv",
                "Europe_Western": "2j4,5,15b,0,1fb|2j4,5,15b,0,1fa|h1|h2",
                "GMT": "5u,0,4ij,0,4ik||ah|",
                "Moscow": "pi,5,1fb|pi,5,1fa||"
            }
        },
        "se": {
            "gmtFormat": "UTC{0}",
            "gmtZeroFormat": "UTC",
            "zone": {},
            "metazone": {
                "Europe_Central": "2iu,5,15b,0,1fb|2iu,5,15b,0,1fa|h0|h4",
                "Europe_Eastern": "2iv,5,15b,0,1fb|2iv,5,15b,0,1fa|gu|gv",
                "Europe_Western": "2j4,5,15b,0,1fb|2j4,5,15b,0,1fa|h1|h2",
                "GMT": "5u,0,4ij,0,4ik||ah|",
                "Moscow": "pi,5,1fb|pi,5,1fa||"
            }
        },
        "seh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ses": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "sg": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "shi-Latn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "shi-Tfng": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "shi": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "si": {
            "gmtFormat": "ග්‍රිමවේ{0}",
            "gmtZeroFormat": "ග්‍රිමවේ",
            "zone": {
                "Europe/Dublin": "|cct,0,4im,0,12o||",
                "Europe/London": "|ccu,0,4im,0,12o||"
            },
            "metazone": {
                "Afghanistan": "99t,0,8f|||",
                "Africa_Central": "1p6,0,2n3,0,8f|||",
                "Africa_Eastern": "1f9,0,2n3,0,8f|||",
                "Africa_Southern": "782,0,2n3,0,8f|||",
                "Africa_Western": "1dq,0,2n3,0,gj,0,8f|1dq,0,2n3,0,ml,0,12o||",
                "Alaska": "77r,0,gj,0,8f|77r,0,1f8,0,8f||",
                "Amazon": "77p,0,gj,0,8f|77p,0,ml,0,12o||",
                "America_Central": "240,0,23v,0,1p6,0,gj,0,8f|240,0,23v,0,1p6,0,1f8,0,8f||",
                "America_Eastern": "240,0,23v,0,1f9,0,gj,0,8f|240,0,23v,0,1f9,0,1f8,0,8f||",
                "America_Mountain": "240,0,23v,0,77m,0,gj,0,8f|240,0,23v,0,77m,0,1f8,0,8f||",
                "America_Pacific": "240,0,23v,0,462,0,gj,0,8f|240,0,23v,0,462,0,1f8,0,8f||",
                "Apia": "77k,0,gj,0,8f|77k,0,2nd,0,8f||",
                "Arabian": "77i,0,gj,0,8f|77i,0,1nm,0,8f||",
                "Argentina": "45v,0,gj,0,8f|45v,0,ml,0,12o||",
                "Argentina_Western": "1dq,0,45v,0,gj,0,8f|1dq,0,45v,0,ml,0,12o||",
                "Armenia": "77f,0,gj,0,8f|77f,0,ml,0,8f||",
                "Atlantic": "77e,0,gj,0,8f|77e,0,1f8,0,8f||",
                "Australia_Central": "45u,0,gj,0,8f|1p6,0,45t,0,1nm,0,8f||",
                "Australia_CentralWestern": "1p6,0,1dq,0,45t,0,gj,0,8f|1p6,0,1dq,0,45t,0,1nm,0,8f||",
                "Australia_Eastern": "1f9,0,45u,0,gj,0,8f|9an,0,45u,0,1nm,0,8f||",
                "Australia_Western": "1dq,0,45u,0,gj,0,8f|1dq,0,45t,0,1nm,0,8f||",
                "Azerbaijan": "77b,0,gj,0,8f|77b,0,ml,0,8f||",
                "Azores": "77a,0,gj,0,8f|77a,0,ml,0,8f||",
                "Bangladesh": "779,0,gj,0,8f|779,0,ml,0,12o||",
                "Bhutan": "9ar,0,8f|||",
                "Bolivia": "9as,0,8f|||",
                "Brasilia": "778,0,gj,0,8f|778,0,ml,0,12o||",
                "Brunei": "9au,0,9av,0,8f|||",
                "Cape_Verde": "777,0,gj,0,8f|777,0,ml,0,12o||",
                "Chamorro": "9b1,0,8f|||",
                "Chatham": "776,0,gj,0,8f|776,0,2nd,0,8f||",
                "Chile": "775,0,gj,0,8f|775,0,ml,0,12o||",
                "China": "774,0,gj,0,8f|774,0,1nm,0,8f||",
                "Choibalsan": "773,0,gj,0,8f|773,0,ml,0,8f||",
                "Christmas": "9b6,0,1l2,0,8f|||",
                "Cocos": "9b8,0,1l2,0,8f|||",
                "Colombia": "771,0,gj,0,8f|771,0,ml,0,12o||",
                "Cook": "770,0,1l2,0,gj,0,8f|770,0,1l2,0,9bb,0,ml,0,8f||",
                "Cuba": "76v,0,gj,0,8f|76v,0,1f8,0,8f||",
                "Davis": "9bd,0,8f|||",
                "DumontDUrville": "9be,5,9bf,0,8f|||",
                "East_Timor": "1f9,0,9bg,0,8f|||",
                "Easter": "76u,0,2j7,0,gj,0,8f|76u,0,2j7,0,ml,0,12o||",
                "Ecuador": "9bj,0,8f|||",
                "Europe_Central": "1p6,0,266,0,gj,0,8f|1p6,0,266,0,ml,0,8f||",
                "Europe_Eastern": "1f9,0,266,0,gj,0,8f|1f9,0,266,0,ml,0,8f||",
                "Europe_Further_Eastern": "9bl,5,1f9,0,266,0,8f|||",
                "Europe_Western": "1dq,0,266,0,gj,0,8f|1dq,0,266,0,ml,0,8f||",
                "Falkland": "76r,0,2j7,0,gj,0,8f|76r,0,2j7,0,ml,0,12o||",
                "Fiji": "76q,0,gj,0,8f|76q,0,ml,0,8f||",
                "French_Guiana": "76p,0,76o,0,8f|||",
                "French_Southern": "76p,0,9bq,0,45p,0,9bs,0,8f|||",
                "Galapagos": "9bt,0,8f|||",
                "Gambier": "9bu,0,8f|||",
                "Georgia": "76m,0,gj,0,8f|76m,0,ml,0,8f||",
                "Gilbert_Islands": "9c0,0,1l2,0,8f|||",
                "GMT": "9c1,0,1p6,0,8f|||",
                "Greenland_Eastern": "1f9,0,45o,0,gj,0,8f|1f9,0,45o,0,ml,0,12o||",
                "Greenland_Western": "1dq,0,45o,0,gj,0,8f|1dq,0,45o,0,ml,0,12o||",
                "Gulf": "9c3,0,8f|||",
                "Guyana": "76o,0,8f|||",
                "Hawaii_Aleutian": "76k,5,76j,0,gj,0,8f|76k,5,76j,0,1f8,0,8f||",
                "Hong_Kong": "76i,0,gj,0,8f|76i,0,ml,0,8f||",
                "Hovd": "76h,0,gj,0,8f|76h,0,ml,0,8f||",
                "India": "9c8,0,8f|||",
                "Indian_Ocean": "9c9,0,9ca,0,8f|||",
                "Indochina": "9cb,0,8f|||",
                "Indonesia_Central": "1p6,0,4il,0,8f|||",
                "Indonesia_Eastern": "1f9,0,4il,0,8f|||",
                "Indonesia_Western": "1dq,0,4il,0,8f|||",
                "Iran": "76f,0,gj,0,8f|76f,0,2nd,0,12o||",
                "Irkutsk": "76e,0,gj,0,8f|76e,0,ml,0,8f||",
                "Israel": "76c,0,gj,0,8f|76c,0,1nm,0,8f||",
                "Japan": "76b,0,gj,0,8f|76b,0,1nm,0,8f||",
                "Kazakhstan_Eastern": "1f9,0,769,0,8f|||",
                "Kazakhstan_Western": "1dq,0,769,0,8f|||",
                "Korea": "768,0,gj,0,8f|768,0,1nm,0,8f||",
                "Kosrae": "9cj,0,8f|||",
                "Krasnoyarsk": "766,0,gj,0,8f|766,0,ml,0,8f||",
                "Kyrgystan": "9cl,0,8f|||",
                "Lanka": "9cm,0,9cn,0,8f|||",
                "Line_Islands": "9co,0,1l2,0,8f|||",
                "Lord_Howe": "765,0,764,0,gj,0,8f|765,0,764,0,2nd,0,8f||",
                "Macquarie": "9cr,0,1l2,0,8f|||",
                "Magadan": "763,0,gj,0,8f|763,0,ml,0,8f||",
                "Malaysia": "9ct,0,8f|||",
                "Maldives": "9cu,0,8f|||",
                "Marquesas": "9cv,0,8f|||",
                "Marshall_Islands": "9d0,0,1l2,0,8f|||",
                "Mauritius": "762,0,gj,0,8f|762,0,ml,0,12o||",
                "Mawson": "9d2,0,8f|||",
                "Mexico_Northwest": "75u,0,45l,0,gj,0,8f|75u,0,45l,0,1f8,0,8f||",
                "Mexico_Pacific": "45l,0,462,0,gj,0,8f|45l,0,462,0,1f8,0,8f||",
                "Mongolia": "75o,0,75k,0,gj,0,8f|75o,0,75k,0,ml,0,8f||",
                "Moscow": "75j,0,gj,0,8f|75j,0,ml,0,8f||",
                "Myanmar": "9d8,0,8f|||",
                "Nauru": "9d9,0,8f|||",
                "Nepal": "9da,0,8f|||",
                "New_Caledonia": "75i,0,75h,0,gj,0,8f|75i,0,75h,0,ml,0,8f||",
                "New_Zealand": "75f,0,gj,0,8f|75f,0,2nd,0,8f||",
                "Newfoundland": "75e,0,gj,0,8f|75e,0,1f8,0,8f||",
                "Niue": "9df,0,8f|||",
                "Norfolk": "9dg,0,1l2,0,8f|||",
                "Noronha": "75a,0,759,0,758,0,gj,0,8f|75a,0,759,0,758,0,ml,0,12o||",
                "Novosibirsk": "757,0,gj,0,8f|757,0,ml,0,8f||",
                "Omsk": "756,0,gj,0,8f|756,0,ml,0,8f||",
                "Pakistan": "755,0,gj,0,8f|755,0,ml,0,12o||",
                "Palau": "9dn,0,8f|||",
                "Papua_New_Guinea": "9do,0,9dp,0,9dq,0,8f|||",
                "Paraguay": "754,0,gj,0,8f|754,0,ml,0,12o||",
                "Peru": "752,0,gj,0,8f|752,0,ml,0,12o||",
                "Philippines": "751,0,gj,0,8f|751,0,ml,0,8f||",
                "Phoenix_Islands": "9du,0,1l2,0,8f|||",
                "Pierre_Miquelon": "74r,0,74m,0,45p,0,74l,0,gj,0,8f|74r,0,74m,0,45p,0,74l,0,1f8,0,8f||",
                "Pitcairn": "9e2,0,8f|||",
                "Ponape": "9e3,0,8f|||",
                "Pyongyang": "9e4,0,8f|||",
                "Reunion": "9e5,0,8f|||",
                "Rothera": "9e6,0,8f|||",
                "Sakhalin": "74i,0,gj,0,8f|74i,0,ml,0,8f||",
                "Samoa": "74h,0,gj,0,8f|74h,0,ml,0,8f||",
                "Seychelles": "9e9,0,8f|||",
                "Singapore": "9ea,0,8f|||",
                "Solomon": "9eb,0,2j7,0,8f|||",
                "South_Georgia": "782,0,9ec,0,8f|||",
                "Suriname": "9ed,0,8f|||",
                "Syowa": "9ee,0,8f|||",
                "Tahiti": "9ef,0,8f|||",
                "Taipei": "74g,0,gj,0,8f|74g,0,1nm,0,8f||",
                "Tajikistan": "9eh,0,8f|||",
                "Tokelau": "9ei,0,8f|||",
                "Tonga": "745,0,gj,0,8f|745,0,ml,0,8f||",
                "Truk": "9ek,0,8f|||",
                "Turkmenistan": "744,0,gj,0,8f|744,0,ml,0,8f||",
                "Tuvalu": "9em,0,8f|||",
                "Uruguay": "743,0,gj,0,8f|743,0,ml,0,12o||",
                "Uzbekistan": "73u,0,gj,0,8f|73u,0,ml,0,8f||",
                "Vanuatu": "73s,0,gj,0,8f|73s,0,4im,0,8f||",
                "Venezuela": "9er,0,8f|||",
                "Vladivostok": "73q,0,gj,0,8f|73q,0,ml,0,8f||",
                "Volgograd": "73o,0,gj,0,8f|73o,0,ml,0,8f||",
                "Vostok": "9eu,0,8f|||",
                "Wake": "9ev,0,2j7,0,8f|||",
                "Wallis": "9f0,0,45p,0,9f1,0,8f|||",
                "Yakutsk": "73k,0,gj,0,8f|73k,0,ml,0,8f||",
                "Yekaterinburg": "73h,0,gj,0,8f|73h,0,ml,0,8f||"
            }
        },
        "sk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ccv,0,f8,0,11||",
                "Europe/London": "|cd0,0,fp,0,11||"
            },
            "metazone": {
                "Afghanistan": "9f4,0,11|||",
                "Africa_Central": "9f5,0,11|||",
                "Africa_Eastern": "9f6,0,11|||",
                "Africa_Southern": "9f7,0,11|||",
                "Africa_Western": "73d,0,f8,0,11|73d,0,fp,0,11||",
                "Alaska": "738,0,f8,0,11|738,0,fp,0,11||",
                "Amazon": "737,0,f8,0,11|737,0,fp,0,11||",
                "America_Central": "23c,0,733,0,f8,0,11|23c,0,733,0,fp,0,11||",
                "America_Eastern": "23c,0,732,0,f8,0,11|23c,0,732,0,fp,0,11||",
                "America_Mountain": "23c,0,4a1,0,f8,0,11|23c,0,4a1,0,fp,0,11||",
                "America_Pacific": "23c,0,455,0,f8,0,11|23c,0,455,0,fp,0,11||",
                "Anadyr": "49r,0,f8,0,11|49r,0,fp,0,11||",
                "Apia": "72n,0,f8,0,11|72n,0,fp,0,11||",
                "Arabian": "724,0,f8,0,11|724,0,fp,0,11||",
                "Argentina": "723,0,f8,0,11|723,0,fp,0,11||",
                "Argentina_Western": "721,0,f8,0,11|721,0,fp,0,11||",
                "Armenia": "720,0,f8,0,11|720,0,fp,0,11||",
                "Atlantic": "71v,0,f8,0,11|71v,0,fp,0,11||",
                "Australia_Central": "71h,0,f8,0,11|71h,0,fp,0,11||",
                "Australia_CentralWestern": "71d,0,71c,0,f8,0,11|71d,0,71c,0,fp,0,11||",
                "Australia_Eastern": "71b,0,f8,0,11|71b,0,fp,0,11||",
                "Australia_Western": "71a,0,f8,0,11|71a,0,fp,0,11||",
                "Azerbaijan": "719,0,f8,0,11|719,0,fp,0,11||",
                "Azores": "718,0,f8,0,11|718,0,fp,0,11||",
                "Bangladesh": "717,0,f8,0,11|717,0,fp,0,11||",
                "Bhutan": "9fv,0,11|||",
                "Bolivia": "9g0,0,11|||",
                "Brasilia": "716,0,f8,0,11|716,0,fp,0,11||",
                "Brunei": "9g2,0,11|||",
                "Cape_Verde": "713,0,f8,0,11|713,0,fp,0,11||",
                "Chamorro": "9g4,0,f8,0,11|||",
                "Chatham": "711,0,f8,0,11|711,0,fp,0,11||",
                "Chile": "710,0,f8,0,11|710,0,fp,0,11||",
                "China": "70u,0,f8,0,11|70u,0,fp,0,11||",
                "Choibalsan": "70s,0,f8,0,11|70s,0,fp,0,11||",
                "Christmas": "11,0,9g9,0,19g|||",
                "Cocos": "11,0,5ve,0,1mb|||",
                "Colombia": "70p,0,f8,0,11|70p,0,fp,0,11||",
                "Cook": "f8,0,11,0,49j,0,1mb|fp,0,11,0,49j,0,1mb||",
                "Cuba": "70o,0,f8,0,11|70o,0,fp,0,11||",
                "Davis": "11,0,9gd,0,10j|||",
                "DumontDUrville": "11,0,10j,0,5vo,0,4s0|||",
                "East_Timor": "9ge,0,11|||",
                "Easter": "f8,0,11,0,70m,0,19g|fp,0,11,0,70m,0,19g||",
                "Ecuador": "9gg,0,11|||",
                "Europe_Central": "70l,0,f8,0,11|70l,0,fp,0,11|5vu|606",
                "Europe_Eastern": "70k,0,f8,0,11|70k,0,fp,0,11||",
                "Europe_Further_Eastern": "9gj,0,11|||",
                "Europe_Western": "70j,0,f8,0,11|70j,0,fp,0,11||",
                "Falkland": "70i,0,f8,0,11|70i,0,fp,0,11||",
                "Fiji": "70h,0,f8,0,11|70h,0,fp,0,11||",
                "French_Guiana": "9gn,0,11|||",
                "French_Southern": "11,0,9go,0,9gp,0,a6,0,61p,0,61s|||",
                "Galapagos": "9gq,0,11|||",
                "Gambier": "9gr,0,11|||",
                "Georgia": "70g,0,f8,0,11|70g,0,fp,0,11||",
                "Gilbert_Islands": "11,0,62i,0,1mb|||",
                "GMT": "9gt,0,11|||",
                "Greenland_Eastern": "70c,0,f8,0,11|70c,0,fp,0,11||",
                "Greenland_Western": "70b,0,f8,0,11|70b,0,fp,0,11||",
                "Gulf": "f8,0,11,0,9h0,0,63a|||",
                "Guyana": "9h1,0,11|||",
                "Hawaii_Aleutian": "2l5,5,48l,0,f8,0,11|2l5,5,48l,0,fp,0,11||",
                "Hong_Kong": "709,0,f8,0,11|709,0,fp,0,11||",
                "Hovd": "708,0,f8,0,11|708,0,fp,0,11||",
                "India": "9h4,0,11|||",
                "Indian_Ocean": "9h5,0,11|||",
                "Indochina": "9h6,0,11|||",
                "Indonesia_Central": "9h7,0,11|||",
                "Indonesia_Eastern": "9h8,0,11|||",
                "Indonesia_Western": "9h9,0,11|||",
                "Iran": "704,0,f8,0,11|704,0,fp,0,11||",
                "Irkutsk": "700,0,f8,0,11|700,0,fp,0,11||",
                "Israel": "6vv,0,f8,0,11|6vv,0,fp,0,11||",
                "Japan": "6vu,0,f8,0,11|6vu,0,fp,0,11||",
                "Kamchatka": "37,5,9he,0,f8,0,11|37,5,9hf,0,fp,0,11||",
                "Kazakhstan_Eastern": "9hg,0,11|||",
                "Kazakhstan_Western": "9hh,0,11|||",
                "Korea": "6vq,0,f8,0,11|6vq,0,fp,0,11||",
                "Kosrae": "9hj,0,11|||",
                "Krasnoyarsk": "6vn,0,f8,0,11|6vn,0,fp,0,11||",
                "Kyrgystan": "9hl,0,11|||",
                "Line_Islands": "11,0,64l,0,1mb|||",
                "Lord_Howe": "f8,0,11,0,19g,0,48a,0,489|fp,0,11,0,19g,0,48a,0,489||",
                "Macquarie": "11,0,19g,0,6m|||",
                "Magadan": "6vm,0,f8,0,11|6vm,0,fp,0,11||",
                "Malaysia": "9hn,0,11|||",
                "Maldives": "9ho,0,11|||",
                "Marquesas": "9hp,0,11|||",
                "Marshall_Islands": "11,0,65h,0,1mb|||",
                "Mauritius": "6vl,0,f8,0,11|6vl,0,fp,0,11||",
                "Mawson": "11,0,9hr,0,10j|||",
                "Mexico_Northwest": "6vk,0,2d6,0,f8,0,11|6vk,0,2d6,0,fp,0,11||",
                "Mexico_Pacific": "2d6,0,455,0,f8,0,11|2d6,0,455,0,fp,0,11||",
                "Mongolia": "6vj,0,f8,0,11|6vj,0,fp,0,11||",
                "Moscow": "6vg,0,f8,0,11|6vg,0,fp,0,11||",
                "Myanmar": "9hv,0,11|||",
                "Nauru": "9i0,0,11|||",
                "Nepal": "9i1,0,11|||",
                "New_Caledonia": "6vf,0,f8,0,11|6vf,0,fp,0,11||",
                "New_Zealand": "6vd,0,f8,0,11|6vd,0,fp,0,11||",
                "Newfoundland": "6vc,0,f8,0,11|6vc,0,fp,0,11||",
                "Niue": "9i5,0,11|||",
                "Norfolk": "9i6,0,11|||",
                "Noronha": "f8,0,11,0,6vb,0,1s,0,2,0,23|fp,0,11,0,6vb,0,1s,0,2,0,23||",
                "Novosibirsk": "6v8,0,f8,0,11|6v8,0,fp,0,11||",
                "Omsk": "6v6,0,f8,0,11|6v6,0,fp,0,11||",
                "Pakistan": "6v5,0,f8,0,11|6v5,0,fp,0,11||",
                "Palau": "9ib,0,11|||",
                "Papua_New_Guinea": "11,0,678,5,9ic,0,67f|||",
                "Paraguay": "6v4,0,f8,0,11|6v4,0,fp,0,11||",
                "Peru": "6v3,0,f8,0,11|6v3,0,fp,0,11||",
                "Philippines": "6uv,0,f8,0,11|6uv,0,fp,0,11||",
                "Phoenix_Islands": "11,0,67s,0,1mb|||",
                "Pierre_Miquelon": "6ut,5,47t,0,f8,0,11|6ut,5,47t,0,fp,0,11||",
                "Pitcairn": "11,0,9ih,0,1mb|||",
                "Ponape": "9ii,0,11|||",
                "Pyongyang": "9ij,0,11|||",
                "Reunion": "9ik,0,11|||",
                "Rothera": "11,0,9il,0,10j|||",
                "Sakhalin": "6us,0,f8,0,11|6us,0,fp,0,11||",
                "Samara": "47p,0,f8,0,11|47p,0,fp,0,11||",
                "Samoa": "6ur,0,f8,0,11|6ur,0,fp,0,11||",
                "Seychelles": "9io,0,11|||",
                "Singapore": "9ip,0,f8,0,11|||",
                "Solomon": "11,0,9iq,0,1mb|||",
                "South_Georgia": "11,0,9ir,0,68o|||",
                "Suriname": "9is,0,11|||",
                "Syowa": "11,0,10j,0,68s|||",
                "Tahiti": "9it,0,11|||",
                "Taipei": "6up,0,f8,0,11|6up,0,fp,0,11||",
                "Tajikistan": "9iv,0,11|||",
                "Tokelau": "9j0,0,11|||",
                "Tonga": "6uh,0,f8,0,11|6uh,0,fp,0,11||",
                "Truk": "9j2,0,11|||",
                "Turkmenistan": "6ug,0,f8,0,11|6ug,0,fp,0,11||",
                "Tuvalu": "9j4,0,11|||",
                "Uruguay": "6ue,0,f8,0,11|6ue,0,fp,0,11||",
                "Uzbekistan": "6ud,0,f8,0,11|6ud,0,fp,0,11||",
                "Vanuatu": "6uc,0,f8,0,11|6uc,0,fp,0,11||",
                "Venezuela": "9j8,0,11|||",
                "Vladivostok": "6ub,0,f8,0,11|6ub,0,fp,0,11||",
                "Volgograd": "6ua,0,f8,0,11|6ua,0,fp,0,11||",
                "Vostok": "11,0,10j,0,5t|||",
                "Wake": "11,0,19g,0,5r|||",
                "Wallis": "11,0,1mb,0,5f,0,a6,0,5k|||",
                "Yakutsk": "6u8,0,f8,0,11|6u8,0,fp,0,11||",
                "Yekaterinburg": "6u6,0,f8,0,11|6u6,0,fp,0,11||"
            }
        },
        "sl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cd1,0,fu,0,11||",
                "Europe/London": "|cd2,0,gq,0,11||"
            },
            "metazone": {
                "Afghanistan": "9jd,0,11|||",
                "Africa_Central": "9je,0,11|||",
                "Africa_Eastern": "9jf,0,11|||",
                "Africa_Southern": "9jg,0,11|||",
                "Africa_Western": "6u3,0,fu,0,11|6u3,0,gq,0,11||",
                "Alaska": "6tt,0,fu,0,11|6tt,0,gq,0,11||",
                "Amazon": "6ts,0,fu,0,11|6ts,0,gq,0,11||",
                "America_Central": "6tr,0,fu,0,11|6tr,0,gq,0,11||",
                "America_Eastern": "4iv,0,fu,0,11|4iv,0,gq,0,11||",
                "America_Mountain": "6tn,0,fu,0,11|6tn,0,gq,0,11||",
                "America_Pacific": "6tm,0,fu,0,11|6tm,0,gq,0,11||",
                "Anadyr": "6tl,0,fu,0,11|6tl,0,gq,0,11||",
                "Apia": "2u0,0,1v1,0,3e|2u2,0,1v1,0,3e||",
                "Arabian": "4e1,0,fu,0,11|4e1,0,gq,0,11||",
                "Argentina": "2ed,0,fu,0,11|2ed,0,gq,0,11||",
                "Argentina_Western": "2ed,0,290,0,fu,0,11|2ed,0,290,0,gq,0,11||",
                "Armenia": "6tc,0,fu,0,11|6tc,0,gq,0,11||",
                "Atlantic": "6tb,0,fu,0,11|6tb,0,gq,0,11||",
                "Australia_Central": "1us,0,43k,0,fu,0,11|1us,0,43k,0,gq,0,11||",
                "Australia_CentralWestern": "1us,0,43k,0,290,0,fu,0,11|1us,0,43k,0,290,0,gq,0,11||",
                "Australia_Eastern": "1us,0,4j0,0,fu,0,11|1us,0,4j0,0,gq,0,11||",
                "Australia_Western": "1us,0,290,0,fu,0,11|1us,0,290,0,gq,0,11||",
                "Azerbaijan": "6t5,0,fu,0,11|6t5,0,gq,0,11||",
                "Azores": "6t1,0,fu,0,11|6t1,0,gq,0,11||",
                "Bangladesh": "6t0,0,fu,0,11|6t0,0,gq,0,11||",
                "Bhutan": "9k7,0,11|||",
                "Bolivia": "9k8,0,11|||",
                "Brasilia": "6ss,0,fu,0,11|6ss,0,gq,0,11||",
                "Brunei": "9ka,0,11|||",
                "Cape_Verde": "44b,0,fu,0,11|44b,0,gq,0,11||",
                "Chamorro": "9kb,0,fu,0,11|||",
                "Chatham": "6sr,0,fu,0,11|6sr,0,gq,0,11||",
                "Chile": "6sq,0,fu,0,11|6sq,0,gq,0,11||",
                "China": "6sp,0,fu,0,11|6sp,0,gq,0,11||",
                "Choibalsan": "32p,0,fu,0,11|32p,0,gq,0,11||",
                "Christmas": "9kf,0,11|||",
                "Cocos": "1ek,0,9kh,0,2ub|||",
                "Colombia": "6sk,0,fu,0,11|6sk,0,gq,0,11||",
                "Cook": "6sj,0,fu,0,11|6sj,0,9kl,0,11||",
                "Cuba": "6sh,0,fu,0,11|6sh,0,gq,0,11||",
                "Davis": "1ek,0,5s|||",
                "DumontDUrville": "1ek,0,5b,5,5j|||",
                "East_Timor": "9kn,0,11|||",
                "Easter": "2u0,0,1v1,0,6se,0,6sd|2u2,0,1v1,0,6se,0,6sd||",
                "Ecuador": "9kq,0,11|||",
                "Europe_Central": "6s4,0,fu,0,11|6s4,0,gq,0,11||",
                "Europe_Eastern": "6s3,0,fu,0,11|6s3,0,gq,0,11||",
                "Europe_Further_Eastern": "9kt,0,9ku,0,11|||",
                "Europe_Western": "6rn,0,fu,0,11|6rn,0,gq,0,11||",
                "Falkland": "2u0,0,1v1,0,6m9,0,33l|2u2,0,1v1,0,6m9,0,33l||",
                "Fiji": "6m8,0,fu,0,11|6m8,0,gq,0,11||",
                "French_Guiana": "1ek,0,9l2,0,1pt|||",
                "French_Southern": "9l4,0,9l5,0,400,0,9l7,0,11|||",
                "Galapagos": "9l8,0,11|||",
                "Gambier": "7je,0,11|||",
                "Georgia": "6m4,0,fu,0,11|6m4,0,gq,0,11||",
                "Gilbert_Islands": "1ek,0,9la,0,2ub|||",
                "GMT": "9lb,0,9lc,0,11|||",
                "Greenland_Eastern": "6m3,0,fu,0,11|6m3,0,gq,0,11||",
                "Greenland_Western": "6m0,0,fu,0,11|6m0,0,gq,0,11||",
                "Gulf": "9lf,0,fu,0,11|||",
                "Guyana": "9lg,0,11|||",
                "Hawaii_Aleutian": "6ls,0,2eq,0,fu,0,11|6ls,0,2eq,0,gq,0,11||",
                "Hong_Kong": "6lq,0,fu,0,11|6lq,0,gq,0,11||",
                "Hovd": "6lo,0,fu,0,11|6lo,0,gq,0,11||",
                "India": "9lk,0,fu,0,11|||",
                "Indian_Ocean": "9ll,0,11|||",
                "Indochina": "9lm,0,11|||",
                "Indonesia_Central": "4j3,0,9lo,0,11|||",
                "Indonesia_Eastern": "4j3,0,4j0,0,11|||",
                "Indonesia_Western": "4j3,0,290,0,11|||",
                "Iran": "6ll,0,fu,0,11|6ll,0,gq,0,11||",
                "Irkutsk": "1uo,0,fu,0,11|1uo,0,gq,0,11||",
                "Israel": "6lk,0,fu,0,11|6lk,0,gq,0,11||",
                "Japan": "6lj,0,fu,0,11|6lj,0,gq,0,11||",
                "Kamchatka": "37,5,2c4,0,fu,0,11|37,5,2c4,0,gq,0,11||",
                "Kazakhstan_Eastern": "4iv,0,6li,0,11|||",
                "Kazakhstan_Western": "9lt,0,6li,0,11|||",
                "Korea": "43a,0,fu,0,11|43a,0,gq,0,11||",
                "Kosrae": "9lu,0,11|||",
                "Krasnoyarsk": "1un,0,fu,0,11|1un,0,gq,0,11||",
                "Kyrgystan": "9lv,0,11|||",
                "Line_Islands": "9m0,0,9m1,0,135|||",
                "Lord_Howe": "2u0,0,11,0,1cl,0,1u,0,24|2u2,0,11,0,1cl,0,1u,0,24||",
                "Macquarie": "9m2,0,11|||",
                "Magadan": "32t,0,fu,0,11|32t,0,gq,0,11||",
                "Malaysia": "9m3,0,11|||",
                "Maldives": "9m4,0,11|||",
                "Marquesas": "1ek,0,9m5,0,2ub|||",
                "Marshall_Islands": "1ek,0,9m6,0,2ub|||",
                "Mauritius": "6lh,0,fu,0,11|6lh,0,gq,0,11||",
                "Mawson": "57p,0,11|||",
                "Mexico_Northwest": "3vu,0,6lc,0,fu,0,11|3vu,0,6lc,0,gq,0,11||",
                "Mexico_Pacific": "3vu,0,6lb,0,fu,0,11|3vu,0,6lb,0,gq,0,11||",
                "Mongolia": "6la,0,fu,0,11|6la,0,gq,0,11||",
                "Moscow": "6l9,0,fu,0,11|6l9,0,gq,0,11||",
                "Myanmar": "9md,0,11|||",
                "Nauru": "9me,0,11|||",
                "Nepal": "7rs,0,11|||",
                "New_Caledonia": "6l8,0,fu,0,11|6l8,0,gq,0,11||",
                "New_Zealand": "6l4,0,fu,0,11|6l4,0,gq,0,11||",
                "Newfoundland": "6l0,0,fu,0,11|6l0,0,gq,0,11||",
                "Niue": "9mi,0,11|||",
                "Norfolk": "1ek,0,9mj,0,2ub|||",
                "Noronha": "1s,0,2,0,6kv,0,fu,0,11|1s,0,2,0,6kv,0,gq,0,11||",
                "Novosibirsk": "3lg,0,fu,0,11|3lg,0,gq,0,11||",
                "Omsk": "1ug,0,fu,0,11|1ug,0,gq,0,11||",
                "Pakistan": "6ku,0,fu,0,11|6ku,0,gq,0,11||",
                "Palau": "9mm,0,11|||",
                "Papua_New_Guinea": "9mn,0,11|||",
                "Paraguay": "6kt,0,fu,0,11|6kt,0,gq,0,11||",
                "Peru": "6kp,0,fu,0,11|6kp,0,gq,0,11||",
                "Philippines": "40e,0,fu,0,11|40e,0,gq,0,11||",
                "Phoenix_Islands": "1ek,0,9mq,0,1a7|||",
                "Pierre_Miquelon": "2u0,0,1v1,0,8i,0,33,0,400,0,35|2u2,0,1v1,0,8i,0,33,0,400,0,35||",
                "Pitcairn": "9mr,0,11|||",
                "Ponape": "7u1,0,11|||",
                "Pyongyang": "9ms,0,11|||",
                "Reunion": "7u7,0,11|||",
                "Rothera": "9mt,0,11|||",
                "Sakhalin": "6ko,0,fu,0,11|6ko,0,gq,0,11||",
                "Samara": "6km,0,fu,0,11|6km,0,gq,0,11||",
                "Samoa": "6kl,0,fu,0,11|6kl,0,gq,0,11||",
                "Seychelles": "9n1,0,11|||",
                "Singapore": "4j2,0,fu,0,11|||",
                "Solomon": "9n2,0,11|||",
                "South_Georgia": "9n3,0,11|||",
                "Suriname": "81u,0,11|||",
                "Syowa": "1ek,0,65|||",
                "Tahiti": "9n4,0,11|||",
                "Taipei": "6kk,0,fu,0,11|6kk,0,gq,0,11||",
                "Tajikistan": "9n6,0,11|||",
                "Tokelau": "9n7,0,11|||",
                "Tonga": "6kj,0,fu,0,11|6kj,0,gq,0,11||",
                "Truk": "1ek,0,6kg,0,6p|||",
                "Turkmenistan": "6kd,0,fu,0,11|6kd,0,gq,0,11||",
                "Tuvalu": "9nb,0,11|||",
                "Uruguay": "6kc,0,fu,0,11|6kc,0,gq,0,11||",
                "Uzbekistan": "6kb,0,fu,0,11|6kb,0,gq,0,11||",
                "Vanuatu": "6k4,0,fu,0,11|6k4,0,gq,0,11||",
                "Venezuela": "87d,0,11|||",
                "Vladivostok": "6k2,0,fu,0,11|6k2,0,gq,0,11||",
                "Volgograd": "6k1,0,fu,0,11|6k1,0,gq,0,11||",
                "Vostok": "9nh,0,11|||",
                "Wake": "1ek,0,6kg,0,5r|||",
                "Wallis": "1ek,0,5f,0,400,0,5k|||",
                "Yakutsk": "1u5,0,fu,0,11|1u5,0,gq,0,11||",
                "Yekaterinburg": "6k0,0,fu,0,11|6k0,0,gq,0,11||"
            }
        },
        "smn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "sn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "so-DJ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Colombia": "1u4,0,3vs,0,3vr,0,3vq,0,3vp|1u4,0,3vo,0,3vn||",
                "Galapagos": "3vm,0,3vl|||"
            }
        },
        "so-ET": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Colombia": "1u4,0,3vs,0,3vr,0,3vq,0,3vp|1u4,0,3vo,0,3vn||",
                "Galapagos": "3vm,0,3vl|||"
            }
        },
        "so-KE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Colombia": "1u4,0,3vs,0,3vr,0,3vq,0,3vp|1u4,0,3vo,0,3vn||",
                "Galapagos": "3vm,0,3vl|||"
            }
        },
        "so": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Colombia": "1u4,0,3vs,0,3vr,0,3vq,0,3vp|1u4,0,3vo,0,3vn||",
                "Galapagos": "3vm,0,3vl|||"
            }
        },
        "sq-MK": {
            "gmtFormat": "Ora e Grinuiçit: {0}",
            "gmtZeroFormat": "Ora e Grinuiçit",
            "zone": {
                "Europe/Dublin": "|i,0,4os,0,15,0,4ov||",
                "Europe/London": "|i,0,5c,0,4p0||"
            },
            "metazone": {
                "Acre": "i,0,58,0,15,0,2fk,0,2fs|i,0,5c,0,15,0,2fk,0,2fs||",
                "Afghanistan": "i,0,15,0,4j4|||",
                "Africa_Central": "i,0,15,0,199,0,11l|||",
                "Africa_Eastern": "i,0,15,0,199,0,qs|||",
                "Africa_Southern": "i,0,58,0,15,0,199,0,2fu|||",
                "Africa_Western": "i,0,58,0,15,0,199,0,pc|i,0,5c,0,15,0,199,0,pc||",
                "Alaska": "i,0,58,0,15,0,4j6|i,0,5c,0,15,0,4j7||",
                "Almaty": "i,0,58,0,15,0,2gb|i,0,5c,0,15,0,2gb||",
                "Amazon": "i,0,58,0,15,0,2gd|i,0,5c,0,15,0,2gd||",
                "America_Central": "i,0,58,0,15,0,1fr,5,pb,0,11l|i,0,5c,0,15,0,1fr,5,pb,0,11l||",
                "America_Eastern": "i,0,58,0,15,0,1fr,5,pb,0,qs|i,0,5c,0,15,0,1fr,5,pb,0,qs||",
                "America_Mountain": "i,0,58,0,1ft,0,15,0,2ge,0,2gf|i,0,5c,0,1ft,0,15,0,2ge,0,2gf||",
                "America_Pacific": "i,0,58,0,1ft,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,1ft,0,15,0,1g1,0,q5,0,1g3||",
                "Anadyr": "i,0,58,0,15,0,2gi|i,0,5c,0,15,0,2gi||",
                "Apia": "i,0,58,0,15,0,2gj|i,0,5c,0,15,0,2gj||",
                "Aqtau": "i,0,58,0,15,0,2gl|i,0,5c,0,15,0,2gl||",
                "Aqtobe": "i,0,58,0,15,0,2gn|i,0,5c,0,15,0,2gn||",
                "Arabian": "i,0,58,0,2go|i,0,5c,0,2go||",
                "Argentina": "i,0,58,0,15,0,1g8|i,0,5c,0,15,0,1g8||",
                "Argentina_Western": "i,0,58,0,15,0,1g8,0,pc|i,0,5c,0,15,0,1g8,0,pc||",
                "Armenia": "i,0,58,0,15,0,2gq|i,0,5c,0,15,0,2gq||",
                "Atlantic": "i,0,58,0,15,0,2gr|i,0,5c,0,15,0,2gr||",
                "Australia_Central": "i,0,58,0,15,0,11a,0,11l|i,0,5c,0,15,0,11a,0,11l||",
                "Australia_CentralWestern": "i,0,58,0,15,0,11a,0,2gt,5,pc|i,0,5c,0,15,0,11a,0,2gt,5,pc||",
                "Australia_Eastern": "i,0,58,0,15,0,11a,0,qs|i,0,5c,0,15,0,11a,0,qs||",
                "Australia_Western": "i,0,58,0,15,0,11a,0,pc|i,0,5c,0,15,0,11a,0,pc||",
                "Azerbaijan": "i,0,58,0,15,0,2gu|i,0,5c,0,15,0,2gu||",
                "Azores": "i,0,58,0,15,0,2gv|i,0,5c,0,15,0,2gv||",
                "Bangladesh": "i,0,58,0,15,0,2h0|i,0,5c,0,15,0,2h0||",
                "Bhutan": "i,0,15,0,4ja|||",
                "Bolivia": "i,0,15,0,4jb|||",
                "Brasilia": "i,0,58,0,15,0,2h1|i,0,5c,0,15,0,2h1||",
                "Brunei": "i,0,15,0,9o,5,4jc|||",
                "Cape_Verde": "i,0,58,0,15,0,2h2,0,q5,0,2h3|i,0,5c,0,15,0,2h2,0,q5,0,2h3||",
                "Casey": "i,0,15,0,4jd|||",
                "Chamorro": "i,0,15,0,4je|||",
                "Chatham": "i,0,58,0,15,0,2h4|i,0,5c,0,15,0,2h4||",
                "Chile": "i,0,58,0,15,0,2h7|i,0,5c,0,15,0,2h7||",
                "China": "i,0,58,0,15,0,2h9|i,0,5c,0,15,0,2h9||",
                "Choibalsan": "i,0,58,0,15,0,2hd|i,0,5c,0,15,0,2hd||",
                "Christmas": "i,0,15,0,163,0,q5,0,4jf|||",
                "Cocos": "i,0,15,0,ol,0,1eg|||",
                "Colombia": "i,0,58,0,15,0,2he|i,0,5c,0,15,0,2he||",
                "Cook": "i,0,58,0,15,0,ol,0,1ec|i,0,5c,0,15,0,ol,0,1ec||",
                "Cuba": "i,0,58,0,15,0,2hg|i,0,5c,0,15,0,2hg||",
                "Davis": "i,0,15,0,4jg|||",
                "DumontDUrville": "i,0,15,0,5b,5,4jh|||",
                "East_Timor": "i,0,15,0,4ji,0,2hh|||",
                "Easter": "i,0,58,0,15,0,163,0,q5,0,2hi|i,0,5c,0,15,0,163,0,q5,0,2hi||",
                "Ecuador": "i,0,15,0,4jj|||",
                "Europe_Central": "i,0,58,0,15,0,13e,0,11l|i,0,5c,0,15,0,13e,0,11l||",
                "Europe_Eastern": "i,0,58,0,15,0,13e,0,qs|i,0,5c,0,15,0,13e,0,qs||",
                "Europe_Further_Eastern": "i,0,15,0,13e,0,pb,0,4jk,0,qs|||",
                "Europe_Western": "i,0,58,0,15,0,13e,0,pc|i,0,5c,0,15,0,13e,0,pc||",
                "Falkland": "i,0,58,0,15,0,ol,0,4v|i,0,5c,0,15,0,ol,0,4v||",
                "Fiji": "i,0,58,0,15,0,2hj|i,0,5c,0,15,0,2hj||",
                "French_Guiana": "i,0,15,0,2hl,0,25d|||",
                "French_Southern": "i,0,15,0,4jm,0,2fu,0,1h9,0,4jn,0,25d|||",
                "Galapagos": "i,0,15,0,4jo|||",
                "Gambier": "i,0,15,0,4jp|||",
                "Georgia": "i,0,58,0,15,0,2hn|i,0,5c,0,15,0,2hn||",
                "Gilbert_Islands": "i,0,15,0,ol,0,6q|||",
                "GMT": "i,0,15,0,4jq,0,q5,0,4jr|||",
                "Greenland_Eastern": "i,0,58,0,15,0,1hb,0,qs|i,0,5c,0,15,0,1hb,0,qs||",
                "Greenland_Western": "i,0,58,0,15,0,1hb,0,pc|i,0,5c,0,15,0,1hb,0,pc||",
                "Guam": "i,0,15,0,4js|||",
                "Gulf": "i,0,15,0,4jt|||",
                "Guyana": "i,0,15,0,2hl|||",
                "Hawaii_Aleutian": "i,0,58,0,15,0,ol,0,2hp,5,62|i,0,5c,0,15,0,ol,0,2hp,5,62||",
                "Hong_Kong": "i,0,58,0,15,0,2l,5,2hq|i,0,5c,0,15,0,2l,5,2hq||",
                "Hovd": "i,0,58,0,15,0,2hr|i,0,5c,0,15,0,2hr||",
                "India": "i,0,58,0,15,0,4ju|||",
                "Indian_Ocean": "i,0,15,0,4jv,0,br|||",
                "Indochina": "i,0,15,0,4k0|||",
                "Indonesia_Central": "i,0,15,0,1pm,0,11l|||",
                "Indonesia_Eastern": "i,0,15,0,1pm,0,qs|||",
                "Indonesia_Western": "i,0,15,0,1pm,0,pc|||",
                "Iran": "i,0,58,0,15,0,2hs|i,0,5c,0,15,0,2hs||",
                "Irkutsk": "i,0,58,0,15,0,2hu|i,0,5c,0,15,0,2hu||",
                "Israel": "i,0,58,0,15,0,2hv|i,0,5c,0,15,0,2hv||",
                "Japan": "i,0,58,0,15,0,2i0|i,0,5c,0,15,0,2i0||",
                "Kamchatka": "i,0,58,0,15,0,2i1,5,2i2|i,0,5c,0,15,0,2i1,5,2i2||",
                "Kazakhstan_Eastern": "i,0,15,0,2i6,0,2hh|||",
                "Kazakhstan_Western": "i,0,15,0,2i6,0,4k1|||",
                "Korea": "i,0,58,0,2i7|i,0,5c,0,2i7||",
                "Kosrae": "i,0,15,0,4k2|||",
                "Krasnoyarsk": "i,0,58,0,15,0,2i8|i,0,5c,0,15,0,2i8||",
                "Kyrgystan": "i,0,15,0,4k3|||",
                "Lanka": "i,0,15,0,4k4|||",
                "Line_Islands": "i,0,15,0,ol,0,4k5,0,4k6|||",
                "Lord_Howe": "i,0,58,0,15,0,1u,5,2i9|i,0,5c,0,15,0,1u,5,2i9||",
                "Macau": "i,0,58,0,15,0,2ib|i,0,5c,0,15,0,2ib||",
                "Macquarie": "i,0,15,0,163,0,4k7|||",
                "Magadan": "i,0,58,0,15,0,2ig|i,0,5c,0,15,0,2ig||",
                "Malaysia": "i,0,15,0,4k8|||",
                "Maldives": "i,0,15,0,4k9|||",
                "Marquesas": "i,0,15,0,ol,0,4ka|||",
                "Marshall_Islands": "i,0,15,0,ol,0,4kb|||",
                "Mauritius": "i,0,58,0,15,0,2ih|i,0,5c,0,15,0,2ih||",
                "Mawson": "i,0,15,0,4kc|||",
                "Mexico_Northwest": "i,0,58,0,15,0,2ik,0,2il|i,0,5c,0,15,0,2ik,0,2il||",
                "Mexico_Pacific": "i,0,58,0,2io,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,2io,0,15,0,1g1,0,q5,0,1g3||",
                "Mongolia": "i,0,58,0,15,0,4f,5,2ip|i,0,5c,0,15,0,4f,5,2ip||",
                "Moscow": "i,0,58,0,15,0,2iq|i,0,5c,0,15,0,2iq||",
                "Myanmar": "i,0,15,0,4kd|||",
                "Nauru": "i,0,15,0,4ke|||",
                "Nepal": "i,0,15,0,4kf|||",
                "New_Caledonia": "i,0,58,0,15,0,2j3,0,pb,0,19f|i,0,5c,0,15,0,2j3,0,pb,0,19f||",
                "New_Zealand": "i,0,58,0,15,0,2jc,0,pb,0,19f|i,0,5c,0,15,0,2jc,0,pb,0,19f||",
                "Newfoundland": "i,0,58,0,15,0,2jg,0,2jh,0,pb,0,2jn|i,0,5c,0,15,0,2jg,0,2jh,0,pb,0,2jn||",
                "Niue": "i,0,15,0,4kh|||",
                "Norfolk": "i,0,15,0,163,0,6l|||",
                "Noronha": "i,0,58,0,15,0,1s,5,2,5,2jo|i,0,5c,0,15,0,1s,5,2,5,2jo||",
                "North_Mariana": "i,0,15,0,ol,0,q5,0,4ki,0,pb,0,4kj|||",
                "Novosibirsk": "i,0,58,0,15,0,2jq|i,0,5c,0,15,0,2jq||",
                "Omsk": "i,0,58,0,15,0,2js|i,0,5c,0,15,0,2js||",
                "Pakistan": "i,0,58,0,15,0,2jv|i,0,5c,0,15,0,2jv||",
                "Palau": "i,0,15,0,4kk|||",
                "Papua_New_Guinea": "i,0,15,0,9a,5,4kl,0,pb,0,19f|||",
                "Paraguay": "i,0,58,0,15,0,2k0|i,0,4km,0,15,0,2k0||",
                "Peru": "i,0,58,0,15,0,2k4|i,0,5c,0,15,0,2k4||",
                "Philippines": "i,0,58,0,15,0,2k5|i,0,5c,0,15,0,2k5||",
                "Phoenix_Islands": "i,0,15,0,ol,0,1a7|||",
                "Pierre_Miquelon": "i,0,58,0,15,0,2k8,5,1p8,0,1h9,0,2ka|i,0,5c,0,15,0,2k8,5,1p8,0,1h9,0,2ka||",
                "Pitcairn": "i,0,15,0,4kn|||",
                "Ponape": "i,0,15,0,4ko|||",
                "Pyongyang": "i,0,15,0,4kp|||",
                "Qyzylorda": "i,0,58,0,15,0,2kj|i,0,5c,0,15,0,2kj||",
                "Reunion": "i,0,15,0,4kq|||",
                "Rothera": "i,0,15,0,4kr|||",
                "Sakhalin": "i,0,58,0,15,0,2kk|i,0,5c,0,15,0,2kk||",
                "Samara": "i,0,58,0,15,0,2kl|i,0,5c,0,15,0,2kl||",
                "Samoa": "i,0,58,0,15,0,2kn|i,0,5c,0,15,0,2kn||",
                "Seychelles": "i,0,15,0,4ks|||",
                "Singapore": "i,0,15,0,4kt|||",
                "Solomon": "i,0,15,0,ol,0,b5|||",
                "South_Georgia": "i,0,15,0,4ku,0,q5,0,4kv|||",
                "Suriname": "i,0,15,0,4l1|||",
                "Syowa": "i,0,15,0,4l4|||",
                "Tahiti": "i,0,15,0,4l5|||",
                "Taipei": "i,0,58,0,15,0,2kt|i,0,5c,0,15,0,2kt||",
                "Tajikistan": "i,0,15,0,4l6|||",
                "Tokelau": "i,0,15,0,4l8|||",
                "Tonga": "i,0,58,0,15,0,2ku|i,0,5c,0,15,0,2ku||",
                "Truk": "i,0,15,0,4l9|||",
                "Turkmenistan": "i,0,58,0,15,0,2l6|i,0,5c,0,15,0,2l6||",
                "Tuvalu": "i,0,15,0,4lb|||",
                "Uruguay": "i,0,58,0,15,0,2l7|i,0,5c,0,15,0,2l7||",
                "Uzbekistan": "i,0,58,0,15,0,2l8|i,0,5c,0,15,0,2l8||",
                "Vanuatu": "i,0,58,0,15,0,2l9|i,0,5c,0,15,0,2l9||",
                "Venezuela": "i,0,15,0,4lh|||",
                "Vladivostok": "i,0,58,0,15,0,2la|i,0,5c,0,15,0,2la||",
                "Volgograd": "i,0,58,0,15,0,2ld|i,0,5c,0,15,0,2ld||",
                "Vostok": "i,0,15,0,4ll|||",
                "Wake": "i,0,15,0,163,0,4lm|||",
                "Wallis": "i,0,15,0,4ln,0,1h9,0,4lo|||",
                "Yakutsk": "i,0,58,0,15,0,2le|i,0,5c,0,15,0,2le||",
                "Yekaterinburg": "i,0,58,0,15,0,2lf|i,0,5c,0,15,0,2lf||"
            }
        },
        "sq-XK": {
            "gmtFormat": "Ora e Grinuiçit: {0}",
            "gmtZeroFormat": "Ora e Grinuiçit",
            "zone": {
                "Europe/Dublin": "|i,0,4os,0,15,0,4ov||",
                "Europe/London": "|i,0,5c,0,4p0||"
            },
            "metazone": {
                "Acre": "i,0,58,0,15,0,2fk,0,2fs|i,0,5c,0,15,0,2fk,0,2fs||",
                "Afghanistan": "i,0,15,0,4j4|||",
                "Africa_Central": "i,0,15,0,199,0,11l|||",
                "Africa_Eastern": "i,0,15,0,199,0,qs|||",
                "Africa_Southern": "i,0,58,0,15,0,199,0,2fu|||",
                "Africa_Western": "i,0,58,0,15,0,199,0,pc|i,0,5c,0,15,0,199,0,pc||",
                "Alaska": "i,0,58,0,15,0,4j6|i,0,5c,0,15,0,4j7||",
                "Almaty": "i,0,58,0,15,0,2gb|i,0,5c,0,15,0,2gb||",
                "Amazon": "i,0,58,0,15,0,2gd|i,0,5c,0,15,0,2gd||",
                "America_Central": "i,0,58,0,15,0,1fr,5,pb,0,11l|i,0,5c,0,15,0,1fr,5,pb,0,11l||",
                "America_Eastern": "i,0,58,0,15,0,1fr,5,pb,0,qs|i,0,5c,0,15,0,1fr,5,pb,0,qs||",
                "America_Mountain": "i,0,58,0,1ft,0,15,0,2ge,0,2gf|i,0,5c,0,1ft,0,15,0,2ge,0,2gf||",
                "America_Pacific": "i,0,58,0,1ft,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,1ft,0,15,0,1g1,0,q5,0,1g3||",
                "Anadyr": "i,0,58,0,15,0,2gi|i,0,5c,0,15,0,2gi||",
                "Apia": "i,0,58,0,15,0,2gj|i,0,5c,0,15,0,2gj||",
                "Aqtau": "i,0,58,0,15,0,2gl|i,0,5c,0,15,0,2gl||",
                "Aqtobe": "i,0,58,0,15,0,2gn|i,0,5c,0,15,0,2gn||",
                "Arabian": "i,0,58,0,2go|i,0,5c,0,2go||",
                "Argentina": "i,0,58,0,15,0,1g8|i,0,5c,0,15,0,1g8||",
                "Argentina_Western": "i,0,58,0,15,0,1g8,0,pc|i,0,5c,0,15,0,1g8,0,pc||",
                "Armenia": "i,0,58,0,15,0,2gq|i,0,5c,0,15,0,2gq||",
                "Atlantic": "i,0,58,0,15,0,2gr|i,0,5c,0,15,0,2gr||",
                "Australia_Central": "i,0,58,0,15,0,11a,0,11l|i,0,5c,0,15,0,11a,0,11l||",
                "Australia_CentralWestern": "i,0,58,0,15,0,11a,0,2gt,5,pc|i,0,5c,0,15,0,11a,0,2gt,5,pc||",
                "Australia_Eastern": "i,0,58,0,15,0,11a,0,qs|i,0,5c,0,15,0,11a,0,qs||",
                "Australia_Western": "i,0,58,0,15,0,11a,0,pc|i,0,5c,0,15,0,11a,0,pc||",
                "Azerbaijan": "i,0,58,0,15,0,2gu|i,0,5c,0,15,0,2gu||",
                "Azores": "i,0,58,0,15,0,2gv|i,0,5c,0,15,0,2gv||",
                "Bangladesh": "i,0,58,0,15,0,2h0|i,0,5c,0,15,0,2h0||",
                "Bhutan": "i,0,15,0,4ja|||",
                "Bolivia": "i,0,15,0,4jb|||",
                "Brasilia": "i,0,58,0,15,0,2h1|i,0,5c,0,15,0,2h1||",
                "Brunei": "i,0,15,0,9o,5,4jc|||",
                "Cape_Verde": "i,0,58,0,15,0,2h2,0,q5,0,2h3|i,0,5c,0,15,0,2h2,0,q5,0,2h3||",
                "Casey": "i,0,15,0,4jd|||",
                "Chamorro": "i,0,15,0,4je|||",
                "Chatham": "i,0,58,0,15,0,2h4|i,0,5c,0,15,0,2h4||",
                "Chile": "i,0,58,0,15,0,2h7|i,0,5c,0,15,0,2h7||",
                "China": "i,0,58,0,15,0,2h9|i,0,5c,0,15,0,2h9||",
                "Choibalsan": "i,0,58,0,15,0,2hd|i,0,5c,0,15,0,2hd||",
                "Christmas": "i,0,15,0,163,0,q5,0,4jf|||",
                "Cocos": "i,0,15,0,ol,0,1eg|||",
                "Colombia": "i,0,58,0,15,0,2he|i,0,5c,0,15,0,2he||",
                "Cook": "i,0,58,0,15,0,ol,0,1ec|i,0,5c,0,15,0,ol,0,1ec||",
                "Cuba": "i,0,58,0,15,0,2hg|i,0,5c,0,15,0,2hg||",
                "Davis": "i,0,15,0,4jg|||",
                "DumontDUrville": "i,0,15,0,5b,5,4jh|||",
                "East_Timor": "i,0,15,0,4ji,0,2hh|||",
                "Easter": "i,0,58,0,15,0,163,0,q5,0,2hi|i,0,5c,0,15,0,163,0,q5,0,2hi||",
                "Ecuador": "i,0,15,0,4jj|||",
                "Europe_Central": "i,0,58,0,15,0,13e,0,11l|i,0,5c,0,15,0,13e,0,11l||",
                "Europe_Eastern": "i,0,58,0,15,0,13e,0,qs|i,0,5c,0,15,0,13e,0,qs||",
                "Europe_Further_Eastern": "i,0,15,0,13e,0,pb,0,4jk,0,qs|||",
                "Europe_Western": "i,0,58,0,15,0,13e,0,pc|i,0,5c,0,15,0,13e,0,pc||",
                "Falkland": "i,0,58,0,15,0,ol,0,4v|i,0,5c,0,15,0,ol,0,4v||",
                "Fiji": "i,0,58,0,15,0,2hj|i,0,5c,0,15,0,2hj||",
                "French_Guiana": "i,0,15,0,2hl,0,25d|||",
                "French_Southern": "i,0,15,0,4jm,0,2fu,0,1h9,0,4jn,0,25d|||",
                "Galapagos": "i,0,15,0,4jo|||",
                "Gambier": "i,0,15,0,4jp|||",
                "Georgia": "i,0,58,0,15,0,2hn|i,0,5c,0,15,0,2hn||",
                "Gilbert_Islands": "i,0,15,0,ol,0,6q|||",
                "GMT": "i,0,15,0,4jq,0,q5,0,4jr|||",
                "Greenland_Eastern": "i,0,58,0,15,0,1hb,0,qs|i,0,5c,0,15,0,1hb,0,qs||",
                "Greenland_Western": "i,0,58,0,15,0,1hb,0,pc|i,0,5c,0,15,0,1hb,0,pc||",
                "Guam": "i,0,15,0,4js|||",
                "Gulf": "i,0,15,0,4jt|||",
                "Guyana": "i,0,15,0,2hl|||",
                "Hawaii_Aleutian": "i,0,58,0,15,0,ol,0,2hp,5,62|i,0,5c,0,15,0,ol,0,2hp,5,62||",
                "Hong_Kong": "i,0,58,0,15,0,2l,5,2hq|i,0,5c,0,15,0,2l,5,2hq||",
                "Hovd": "i,0,58,0,15,0,2hr|i,0,5c,0,15,0,2hr||",
                "India": "i,0,58,0,15,0,4ju|||",
                "Indian_Ocean": "i,0,15,0,4jv,0,br|||",
                "Indochina": "i,0,15,0,4k0|||",
                "Indonesia_Central": "i,0,15,0,1pm,0,11l|||",
                "Indonesia_Eastern": "i,0,15,0,1pm,0,qs|||",
                "Indonesia_Western": "i,0,15,0,1pm,0,pc|||",
                "Iran": "i,0,58,0,15,0,2hs|i,0,5c,0,15,0,2hs||",
                "Irkutsk": "i,0,58,0,15,0,2hu|i,0,5c,0,15,0,2hu||",
                "Israel": "i,0,58,0,15,0,2hv|i,0,5c,0,15,0,2hv||",
                "Japan": "i,0,58,0,15,0,2i0|i,0,5c,0,15,0,2i0||",
                "Kamchatka": "i,0,58,0,15,0,2i1,5,2i2|i,0,5c,0,15,0,2i1,5,2i2||",
                "Kazakhstan_Eastern": "i,0,15,0,2i6,0,2hh|||",
                "Kazakhstan_Western": "i,0,15,0,2i6,0,4k1|||",
                "Korea": "i,0,58,0,2i7|i,0,5c,0,2i7||",
                "Kosrae": "i,0,15,0,4k2|||",
                "Krasnoyarsk": "i,0,58,0,15,0,2i8|i,0,5c,0,15,0,2i8||",
                "Kyrgystan": "i,0,15,0,4k3|||",
                "Lanka": "i,0,15,0,4k4|||",
                "Line_Islands": "i,0,15,0,ol,0,4k5,0,4k6|||",
                "Lord_Howe": "i,0,58,0,15,0,1u,5,2i9|i,0,5c,0,15,0,1u,5,2i9||",
                "Macau": "i,0,58,0,15,0,2ib|i,0,5c,0,15,0,2ib||",
                "Macquarie": "i,0,15,0,163,0,4k7|||",
                "Magadan": "i,0,58,0,15,0,2ig|i,0,5c,0,15,0,2ig||",
                "Malaysia": "i,0,15,0,4k8|||",
                "Maldives": "i,0,15,0,4k9|||",
                "Marquesas": "i,0,15,0,ol,0,4ka|||",
                "Marshall_Islands": "i,0,15,0,ol,0,4kb|||",
                "Mauritius": "i,0,58,0,15,0,2ih|i,0,5c,0,15,0,2ih||",
                "Mawson": "i,0,15,0,4kc|||",
                "Mexico_Northwest": "i,0,58,0,15,0,2ik,0,2il|i,0,5c,0,15,0,2ik,0,2il||",
                "Mexico_Pacific": "i,0,58,0,2io,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,2io,0,15,0,1g1,0,q5,0,1g3||",
                "Mongolia": "i,0,58,0,15,0,4f,5,2ip|i,0,5c,0,15,0,4f,5,2ip||",
                "Moscow": "i,0,58,0,15,0,2iq|i,0,5c,0,15,0,2iq||",
                "Myanmar": "i,0,15,0,4kd|||",
                "Nauru": "i,0,15,0,4ke|||",
                "Nepal": "i,0,15,0,4kf|||",
                "New_Caledonia": "i,0,58,0,15,0,2j3,0,pb,0,19f|i,0,5c,0,15,0,2j3,0,pb,0,19f||",
                "New_Zealand": "i,0,58,0,15,0,2jc,0,pb,0,19f|i,0,5c,0,15,0,2jc,0,pb,0,19f||",
                "Newfoundland": "i,0,58,0,15,0,2jg,0,2jh,0,pb,0,2jn|i,0,5c,0,15,0,2jg,0,2jh,0,pb,0,2jn||",
                "Niue": "i,0,15,0,4kh|||",
                "Norfolk": "i,0,15,0,163,0,6l|||",
                "Noronha": "i,0,58,0,15,0,1s,5,2,5,2jo|i,0,5c,0,15,0,1s,5,2,5,2jo||",
                "North_Mariana": "i,0,15,0,ol,0,q5,0,4ki,0,pb,0,4kj|||",
                "Novosibirsk": "i,0,58,0,15,0,2jq|i,0,5c,0,15,0,2jq||",
                "Omsk": "i,0,58,0,15,0,2js|i,0,5c,0,15,0,2js||",
                "Pakistan": "i,0,58,0,15,0,2jv|i,0,5c,0,15,0,2jv||",
                "Palau": "i,0,15,0,4kk|||",
                "Papua_New_Guinea": "i,0,15,0,9a,5,4kl,0,pb,0,19f|||",
                "Paraguay": "i,0,58,0,15,0,2k0|i,0,4km,0,15,0,2k0||",
                "Peru": "i,0,58,0,15,0,2k4|i,0,5c,0,15,0,2k4||",
                "Philippines": "i,0,58,0,15,0,2k5|i,0,5c,0,15,0,2k5||",
                "Phoenix_Islands": "i,0,15,0,ol,0,1a7|||",
                "Pierre_Miquelon": "i,0,58,0,15,0,2k8,5,1p8,0,1h9,0,2ka|i,0,5c,0,15,0,2k8,5,1p8,0,1h9,0,2ka||",
                "Pitcairn": "i,0,15,0,4kn|||",
                "Ponape": "i,0,15,0,4ko|||",
                "Pyongyang": "i,0,15,0,4kp|||",
                "Qyzylorda": "i,0,58,0,15,0,2kj|i,0,5c,0,15,0,2kj||",
                "Reunion": "i,0,15,0,4kq|||",
                "Rothera": "i,0,15,0,4kr|||",
                "Sakhalin": "i,0,58,0,15,0,2kk|i,0,5c,0,15,0,2kk||",
                "Samara": "i,0,58,0,15,0,2kl|i,0,5c,0,15,0,2kl||",
                "Samoa": "i,0,58,0,15,0,2kn|i,0,5c,0,15,0,2kn||",
                "Seychelles": "i,0,15,0,4ks|||",
                "Singapore": "i,0,15,0,4kt|||",
                "Solomon": "i,0,15,0,ol,0,b5|||",
                "South_Georgia": "i,0,15,0,4ku,0,q5,0,4kv|||",
                "Suriname": "i,0,15,0,4l1|||",
                "Syowa": "i,0,15,0,4l4|||",
                "Tahiti": "i,0,15,0,4l5|||",
                "Taipei": "i,0,58,0,15,0,2kt|i,0,5c,0,15,0,2kt||",
                "Tajikistan": "i,0,15,0,4l6|||",
                "Tokelau": "i,0,15,0,4l8|||",
                "Tonga": "i,0,58,0,15,0,2ku|i,0,5c,0,15,0,2ku||",
                "Truk": "i,0,15,0,4l9|||",
                "Turkmenistan": "i,0,58,0,15,0,2l6|i,0,5c,0,15,0,2l6||",
                "Tuvalu": "i,0,15,0,4lb|||",
                "Uruguay": "i,0,58,0,15,0,2l7|i,0,5c,0,15,0,2l7||",
                "Uzbekistan": "i,0,58,0,15,0,2l8|i,0,5c,0,15,0,2l8||",
                "Vanuatu": "i,0,58,0,15,0,2l9|i,0,5c,0,15,0,2l9||",
                "Venezuela": "i,0,15,0,4lh|||",
                "Vladivostok": "i,0,58,0,15,0,2la|i,0,5c,0,15,0,2la||",
                "Volgograd": "i,0,58,0,15,0,2ld|i,0,5c,0,15,0,2ld||",
                "Vostok": "i,0,15,0,4ll|||",
                "Wake": "i,0,15,0,163,0,4lm|||",
                "Wallis": "i,0,15,0,4ln,0,1h9,0,4lo|||",
                "Yakutsk": "i,0,58,0,15,0,2le|i,0,5c,0,15,0,2le||",
                "Yekaterinburg": "i,0,58,0,15,0,2lf|i,0,5c,0,15,0,2lf||"
            }
        },
        "sq": {
            "gmtFormat": "Ora e Grinuiçit: {0}",
            "gmtZeroFormat": "Ora e Grinuiçit",
            "zone": {
                "Europe/Dublin": "|i,0,4os,0,15,0,4ov||",
                "Europe/London": "|i,0,5c,0,4p0||"
            },
            "metazone": {
                "Acre": "i,0,58,0,15,0,2fk,0,2fs|i,0,5c,0,15,0,2fk,0,2fs||",
                "Afghanistan": "i,0,15,0,4j4|||",
                "Africa_Central": "i,0,15,0,199,0,11l|||",
                "Africa_Eastern": "i,0,15,0,199,0,qs|||",
                "Africa_Southern": "i,0,58,0,15,0,199,0,2fu|||",
                "Africa_Western": "i,0,58,0,15,0,199,0,pc|i,0,5c,0,15,0,199,0,pc||",
                "Alaska": "i,0,58,0,15,0,4j6|i,0,5c,0,15,0,4j7||",
                "Almaty": "i,0,58,0,15,0,2gb|i,0,5c,0,15,0,2gb||",
                "Amazon": "i,0,58,0,15,0,2gd|i,0,5c,0,15,0,2gd||",
                "America_Central": "i,0,58,0,15,0,1fr,5,pb,0,11l|i,0,5c,0,15,0,1fr,5,pb,0,11l||",
                "America_Eastern": "i,0,58,0,15,0,1fr,5,pb,0,qs|i,0,5c,0,15,0,1fr,5,pb,0,qs||",
                "America_Mountain": "i,0,58,0,1ft,0,15,0,2ge,0,2gf|i,0,5c,0,1ft,0,15,0,2ge,0,2gf||",
                "America_Pacific": "i,0,58,0,1ft,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,1ft,0,15,0,1g1,0,q5,0,1g3||",
                "Anadyr": "i,0,58,0,15,0,2gi|i,0,5c,0,15,0,2gi||",
                "Apia": "i,0,58,0,15,0,2gj|i,0,5c,0,15,0,2gj||",
                "Aqtau": "i,0,58,0,15,0,2gl|i,0,5c,0,15,0,2gl||",
                "Aqtobe": "i,0,58,0,15,0,2gn|i,0,5c,0,15,0,2gn||",
                "Arabian": "i,0,58,0,2go|i,0,5c,0,2go||",
                "Argentina": "i,0,58,0,15,0,1g8|i,0,5c,0,15,0,1g8||",
                "Argentina_Western": "i,0,58,0,15,0,1g8,0,pc|i,0,5c,0,15,0,1g8,0,pc||",
                "Armenia": "i,0,58,0,15,0,2gq|i,0,5c,0,15,0,2gq||",
                "Atlantic": "i,0,58,0,15,0,2gr|i,0,5c,0,15,0,2gr||",
                "Australia_Central": "i,0,58,0,15,0,11a,0,11l|i,0,5c,0,15,0,11a,0,11l||",
                "Australia_CentralWestern": "i,0,58,0,15,0,11a,0,2gt,5,pc|i,0,5c,0,15,0,11a,0,2gt,5,pc||",
                "Australia_Eastern": "i,0,58,0,15,0,11a,0,qs|i,0,5c,0,15,0,11a,0,qs||",
                "Australia_Western": "i,0,58,0,15,0,11a,0,pc|i,0,5c,0,15,0,11a,0,pc||",
                "Azerbaijan": "i,0,58,0,15,0,2gu|i,0,5c,0,15,0,2gu||",
                "Azores": "i,0,58,0,15,0,2gv|i,0,5c,0,15,0,2gv||",
                "Bangladesh": "i,0,58,0,15,0,2h0|i,0,5c,0,15,0,2h0||",
                "Bhutan": "i,0,15,0,4ja|||",
                "Bolivia": "i,0,15,0,4jb|||",
                "Brasilia": "i,0,58,0,15,0,2h1|i,0,5c,0,15,0,2h1||",
                "Brunei": "i,0,15,0,9o,5,4jc|||",
                "Cape_Verde": "i,0,58,0,15,0,2h2,0,q5,0,2h3|i,0,5c,0,15,0,2h2,0,q5,0,2h3||",
                "Casey": "i,0,15,0,4jd|||",
                "Chamorro": "i,0,15,0,4je|||",
                "Chatham": "i,0,58,0,15,0,2h4|i,0,5c,0,15,0,2h4||",
                "Chile": "i,0,58,0,15,0,2h7|i,0,5c,0,15,0,2h7||",
                "China": "i,0,58,0,15,0,2h9|i,0,5c,0,15,0,2h9||",
                "Choibalsan": "i,0,58,0,15,0,2hd|i,0,5c,0,15,0,2hd||",
                "Christmas": "i,0,15,0,163,0,q5,0,4jf|||",
                "Cocos": "i,0,15,0,ol,0,1eg|||",
                "Colombia": "i,0,58,0,15,0,2he|i,0,5c,0,15,0,2he||",
                "Cook": "i,0,58,0,15,0,ol,0,1ec|i,0,5c,0,15,0,ol,0,1ec||",
                "Cuba": "i,0,58,0,15,0,2hg|i,0,5c,0,15,0,2hg||",
                "Davis": "i,0,15,0,4jg|||",
                "DumontDUrville": "i,0,15,0,5b,5,4jh|||",
                "East_Timor": "i,0,15,0,4ji,0,2hh|||",
                "Easter": "i,0,58,0,15,0,163,0,q5,0,2hi|i,0,5c,0,15,0,163,0,q5,0,2hi||",
                "Ecuador": "i,0,15,0,4jj|||",
                "Europe_Central": "i,0,58,0,15,0,13e,0,11l|i,0,5c,0,15,0,13e,0,11l||",
                "Europe_Eastern": "i,0,58,0,15,0,13e,0,qs|i,0,5c,0,15,0,13e,0,qs||",
                "Europe_Further_Eastern": "i,0,15,0,13e,0,pb,0,4jk,0,qs|||",
                "Europe_Western": "i,0,58,0,15,0,13e,0,pc|i,0,5c,0,15,0,13e,0,pc||",
                "Falkland": "i,0,58,0,15,0,ol,0,4v|i,0,5c,0,15,0,ol,0,4v||",
                "Fiji": "i,0,58,0,15,0,2hj|i,0,5c,0,15,0,2hj||",
                "French_Guiana": "i,0,15,0,2hl,0,25d|||",
                "French_Southern": "i,0,15,0,4jm,0,2fu,0,1h9,0,4jn,0,25d|||",
                "Galapagos": "i,0,15,0,4jo|||",
                "Gambier": "i,0,15,0,4jp|||",
                "Georgia": "i,0,58,0,15,0,2hn|i,0,5c,0,15,0,2hn||",
                "Gilbert_Islands": "i,0,15,0,ol,0,6q|||",
                "GMT": "i,0,15,0,4jq,0,q5,0,4jr|||",
                "Greenland_Eastern": "i,0,58,0,15,0,1hb,0,qs|i,0,5c,0,15,0,1hb,0,qs||",
                "Greenland_Western": "i,0,58,0,15,0,1hb,0,pc|i,0,5c,0,15,0,1hb,0,pc||",
                "Guam": "i,0,15,0,4js|||",
                "Gulf": "i,0,15,0,4jt|||",
                "Guyana": "i,0,15,0,2hl|||",
                "Hawaii_Aleutian": "i,0,58,0,15,0,ol,0,2hp,5,62|i,0,5c,0,15,0,ol,0,2hp,5,62||",
                "Hong_Kong": "i,0,58,0,15,0,2l,5,2hq|i,0,5c,0,15,0,2l,5,2hq||",
                "Hovd": "i,0,58,0,15,0,2hr|i,0,5c,0,15,0,2hr||",
                "India": "i,0,58,0,15,0,4ju|||",
                "Indian_Ocean": "i,0,15,0,4jv,0,br|||",
                "Indochina": "i,0,15,0,4k0|||",
                "Indonesia_Central": "i,0,15,0,1pm,0,11l|||",
                "Indonesia_Eastern": "i,0,15,0,1pm,0,qs|||",
                "Indonesia_Western": "i,0,15,0,1pm,0,pc|||",
                "Iran": "i,0,58,0,15,0,2hs|i,0,5c,0,15,0,2hs||",
                "Irkutsk": "i,0,58,0,15,0,2hu|i,0,5c,0,15,0,2hu||",
                "Israel": "i,0,58,0,15,0,2hv|i,0,5c,0,15,0,2hv||",
                "Japan": "i,0,58,0,15,0,2i0|i,0,5c,0,15,0,2i0||",
                "Kamchatka": "i,0,58,0,15,0,2i1,5,2i2|i,0,5c,0,15,0,2i1,5,2i2||",
                "Kazakhstan_Eastern": "i,0,15,0,2i6,0,2hh|||",
                "Kazakhstan_Western": "i,0,15,0,2i6,0,4k1|||",
                "Korea": "i,0,58,0,2i7|i,0,5c,0,2i7||",
                "Kosrae": "i,0,15,0,4k2|||",
                "Krasnoyarsk": "i,0,58,0,15,0,2i8|i,0,5c,0,15,0,2i8||",
                "Kyrgystan": "i,0,15,0,4k3|||",
                "Lanka": "i,0,15,0,4k4|||",
                "Line_Islands": "i,0,15,0,ol,0,4k5,0,4k6|||",
                "Lord_Howe": "i,0,58,0,15,0,1u,5,2i9|i,0,5c,0,15,0,1u,5,2i9||",
                "Macau": "i,0,58,0,15,0,2ib|i,0,5c,0,15,0,2ib||",
                "Macquarie": "i,0,15,0,163,0,4k7|||",
                "Magadan": "i,0,58,0,15,0,2ig|i,0,5c,0,15,0,2ig||",
                "Malaysia": "i,0,15,0,4k8|||",
                "Maldives": "i,0,15,0,4k9|||",
                "Marquesas": "i,0,15,0,ol,0,4ka|||",
                "Marshall_Islands": "i,0,15,0,ol,0,4kb|||",
                "Mauritius": "i,0,58,0,15,0,2ih|i,0,5c,0,15,0,2ih||",
                "Mawson": "i,0,15,0,4kc|||",
                "Mexico_Northwest": "i,0,58,0,15,0,2ik,0,2il|i,0,5c,0,15,0,2ik,0,2il||",
                "Mexico_Pacific": "i,0,58,0,2io,0,15,0,1g1,0,q5,0,1g3|i,0,5c,0,2io,0,15,0,1g1,0,q5,0,1g3||",
                "Mongolia": "i,0,58,0,15,0,4f,5,2ip|i,0,5c,0,15,0,4f,5,2ip||",
                "Moscow": "i,0,58,0,15,0,2iq|i,0,5c,0,15,0,2iq||",
                "Myanmar": "i,0,15,0,4kd|||",
                "Nauru": "i,0,15,0,4ke|||",
                "Nepal": "i,0,15,0,4kf|||",
                "New_Caledonia": "i,0,58,0,15,0,2j3,0,pb,0,19f|i,0,5c,0,15,0,2j3,0,pb,0,19f||",
                "New_Zealand": "i,0,58,0,15,0,2jc,0,pb,0,19f|i,0,5c,0,15,0,2jc,0,pb,0,19f||",
                "Newfoundland": "i,0,58,0,15,0,2jg,0,2jh,0,pb,0,2jn|i,0,5c,0,15,0,2jg,0,2jh,0,pb,0,2jn||",
                "Niue": "i,0,15,0,4kh|||",
                "Norfolk": "i,0,15,0,163,0,6l|||",
                "Noronha": "i,0,58,0,15,0,1s,5,2,5,2jo|i,0,5c,0,15,0,1s,5,2,5,2jo||",
                "North_Mariana": "i,0,15,0,ol,0,q5,0,4ki,0,pb,0,4kj|||",
                "Novosibirsk": "i,0,58,0,15,0,2jq|i,0,5c,0,15,0,2jq||",
                "Omsk": "i,0,58,0,15,0,2js|i,0,5c,0,15,0,2js||",
                "Pakistan": "i,0,58,0,15,0,2jv|i,0,5c,0,15,0,2jv||",
                "Palau": "i,0,15,0,4kk|||",
                "Papua_New_Guinea": "i,0,15,0,9a,5,4kl,0,pb,0,19f|||",
                "Paraguay": "i,0,58,0,15,0,2k0|i,0,4km,0,15,0,2k0||",
                "Peru": "i,0,58,0,15,0,2k4|i,0,5c,0,15,0,2k4||",
                "Philippines": "i,0,58,0,15,0,2k5|i,0,5c,0,15,0,2k5||",
                "Phoenix_Islands": "i,0,15,0,ol,0,1a7|||",
                "Pierre_Miquelon": "i,0,58,0,15,0,2k8,5,1p8,0,1h9,0,2ka|i,0,5c,0,15,0,2k8,5,1p8,0,1h9,0,2ka||",
                "Pitcairn": "i,0,15,0,4kn|||",
                "Ponape": "i,0,15,0,4ko|||",
                "Pyongyang": "i,0,15,0,4kp|||",
                "Qyzylorda": "i,0,58,0,15,0,2kj|i,0,5c,0,15,0,2kj||",
                "Reunion": "i,0,15,0,4kq|||",
                "Rothera": "i,0,15,0,4kr|||",
                "Sakhalin": "i,0,58,0,15,0,2kk|i,0,5c,0,15,0,2kk||",
                "Samara": "i,0,58,0,15,0,2kl|i,0,5c,0,15,0,2kl||",
                "Samoa": "i,0,58,0,15,0,2kn|i,0,5c,0,15,0,2kn||",
                "Seychelles": "i,0,15,0,4ks|||",
                "Singapore": "i,0,15,0,4kt|||",
                "Solomon": "i,0,15,0,ol,0,b5|||",
                "South_Georgia": "i,0,15,0,4ku,0,q5,0,4kv|||",
                "Suriname": "i,0,15,0,4l1|||",
                "Syowa": "i,0,15,0,4l4|||",
                "Tahiti": "i,0,15,0,4l5|||",
                "Taipei": "i,0,58,0,15,0,2kt|i,0,5c,0,15,0,2kt||",
                "Tajikistan": "i,0,15,0,4l6|||",
                "Tokelau": "i,0,15,0,4l8|||",
                "Tonga": "i,0,58,0,15,0,2ku|i,0,5c,0,15,0,2ku||",
                "Truk": "i,0,15,0,4l9|||",
                "Turkmenistan": "i,0,58,0,15,0,2l6|i,0,5c,0,15,0,2l6||",
                "Tuvalu": "i,0,15,0,4lb|||",
                "Uruguay": "i,0,58,0,15,0,2l7|i,0,5c,0,15,0,2l7||",
                "Uzbekistan": "i,0,58,0,15,0,2l8|i,0,5c,0,15,0,2l8||",
                "Vanuatu": "i,0,58,0,15,0,2l9|i,0,5c,0,15,0,2l9||",
                "Venezuela": "i,0,15,0,4lh|||",
                "Vladivostok": "i,0,58,0,15,0,2la|i,0,5c,0,15,0,2la||",
                "Volgograd": "i,0,58,0,15,0,2ld|i,0,5c,0,15,0,2ld||",
                "Vostok": "i,0,15,0,4ll|||",
                "Wake": "i,0,15,0,163,0,4lm|||",
                "Wallis": "i,0,15,0,4ln,0,1h9,0,4lo|||",
                "Yakutsk": "i,0,58,0,15,0,2le|i,0,5c,0,15,0,2le||",
                "Yekaterinburg": "i,0,58,0,15,0,2lf|i,0,5c,0,15,0,2lf||"
            }
        },
        "sr-Cyrl-BA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tc,0,1q,0,m||",
                "Europe/London": "|2me,0,20,0,2b,0,2d||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Afghanistan": "2ak,0,m|||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "1jf,k,0,1q,0,m|1jf,k,0,20,0,2b,0,2d||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "p7,0,p6,0,1q,0,m|p7,0,p6,0,20,0,m||",
                "America_Eastern": "p7,0,139,0,1q,0,m|p7,0,139,0,20,0,m||",
                "America_Mountain": "p7,0,1gj,0,1q,0,m|p7,0,1gj,0,20,0,m||",
                "America_Pacific": "p7,0,1o4,0,1q,0,m|p7,0,1o4,0,20,0,m||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Apia": "1jh,0,1q,0,m|1jh,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "1o5,0,1q,0,m|1o5,0,20,0,2b,0,2d||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,20,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "1o8,0,ir,0,1q,0,m|1o8,0,ir,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "2p0,0,1ka,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d|gu|gv",
                "Europe_Further_Eastern": "2p1,0,2p2,0,2p3|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d|h1|h2",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "2p5,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "2p6,0,m,0,1jo,0,2p7||ah|",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "2pb,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|19c,0,1eu,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,2d||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "2bo,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "ir,0,2pc,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,2d||",
                "Macquarie": "1k9,0,2pe,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,2d||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mexico_Northwest": "1od,0,187,0,1q,0,m|1od,0,187,0,20,0,2b,0,2d||",
                "Mexico_Pacific": "1oe,0,1of,0,1q,0,m|1oe,0,1of,0,20,0,2b,0,2d||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Palau": "159,0,m|||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,2d||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "2pk,0,m|||",
                "Pyongyang": "2pl,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "1oh,0,1q,0,m|1oh,0,20,0,m||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "1f2,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "sr-Cyrl-ME": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tc,0,1q,0,m||",
                "Europe/London": "|2me,0,20,0,2b,0,2d||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Afghanistan": "2ak,0,m|||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "1jf,k,0,1q,0,m|1jf,k,0,20,0,2b,0,2d||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "p7,0,p6,0,1q,0,m|p7,0,p6,0,20,0,m||",
                "America_Eastern": "p7,0,139,0,1q,0,m|p7,0,139,0,20,0,m||",
                "America_Mountain": "p7,0,1gj,0,1q,0,m|p7,0,1gj,0,20,0,m||",
                "America_Pacific": "p7,0,1o4,0,1q,0,m|p7,0,1o4,0,20,0,m||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Apia": "1jh,0,1q,0,m|1jh,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "1o5,0,1q,0,m|1o5,0,20,0,2b,0,2d||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,20,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "1o8,0,ir,0,1q,0,m|1o8,0,ir,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "2p0,0,1ka,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d|gu|gv",
                "Europe_Further_Eastern": "2p1,0,2p2,0,2p3|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d|h1|h2",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "2p5,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "2p6,0,m,0,1jo,0,2p7||ah|",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "2pb,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|19c,0,1eu,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,2d||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "2bo,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "ir,0,2pc,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,2d||",
                "Macquarie": "1k9,0,2pe,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,2d||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mexico_Northwest": "1od,0,187,0,1q,0,m|1od,0,187,0,20,0,2b,0,2d||",
                "Mexico_Pacific": "1oe,0,1of,0,1q,0,m|1oe,0,1of,0,20,0,2b,0,2d||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Palau": "159,0,m|||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,2d||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "2pk,0,m|||",
                "Pyongyang": "2pl,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "1oh,0,1q,0,m|1oh,0,20,0,m||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "1f2,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "sr-Cyrl-XK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tc,0,1q,0,m||",
                "Europe/London": "|2me,0,20,0,2b,0,2d||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Afghanistan": "2ak,0,m|||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "1jf,k,0,1q,0,m|1jf,k,0,20,0,2b,0,2d||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "p7,0,p6,0,1q,0,m|p7,0,p6,0,20,0,m||",
                "America_Eastern": "p7,0,139,0,1q,0,m|p7,0,139,0,20,0,m||",
                "America_Mountain": "p7,0,1gj,0,1q,0,m|p7,0,1gj,0,20,0,m||",
                "America_Pacific": "p7,0,1o4,0,1q,0,m|p7,0,1o4,0,20,0,m||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Apia": "1jh,0,1q,0,m|1jh,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "1o5,0,1q,0,m|1o5,0,20,0,2b,0,2d||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,20,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "1o8,0,ir,0,1q,0,m|1o8,0,ir,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "2p0,0,1ka,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d|gu|gv",
                "Europe_Further_Eastern": "2p1,0,2p2,0,2p3|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d|h1|h2",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "2p5,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "2p6,0,m,0,1jo,0,2p7||ah|",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "2pb,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|19c,0,1eu,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,2d||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "2bo,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "ir,0,2pc,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,2d||",
                "Macquarie": "1k9,0,2pe,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,2d||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mexico_Northwest": "1od,0,187,0,1q,0,m|1od,0,187,0,20,0,2b,0,2d||",
                "Mexico_Pacific": "1oe,0,1of,0,1q,0,m|1oe,0,1of,0,20,0,2b,0,2d||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Palau": "159,0,m|||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,2d||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "2pk,0,m|||",
                "Pyongyang": "2pl,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "1oh,0,1q,0,m|1oh,0,20,0,m||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "1f2,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "sr-Cyrl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tc,0,1q,0,m||",
                "Europe/London": "|2me,0,20,0,2b,0,2d||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Afghanistan": "2ak,0,m|||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "1jf,k,0,1q,0,m|1jf,k,0,20,0,2b,0,2d||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "p7,0,p6,0,1q,0,m|p7,0,p6,0,20,0,m||",
                "America_Eastern": "p7,0,139,0,1q,0,m|p7,0,139,0,20,0,m||",
                "America_Mountain": "p7,0,1gj,0,1q,0,m|p7,0,1gj,0,20,0,m||",
                "America_Pacific": "p7,0,1o4,0,1q,0,m|p7,0,1o4,0,20,0,m||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Apia": "1jh,0,1q,0,m|1jh,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "1o5,0,1q,0,m|1o5,0,20,0,2b,0,2d||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,20,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "1o8,0,ir,0,1q,0,m|1o8,0,ir,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "2p0,0,1ka,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d|gu|gv",
                "Europe_Further_Eastern": "2p1,0,2p2,0,2p3|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d|h1|h2",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "2p5,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "2p6,0,m,0,1jo,0,2p7||ah|",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "2pb,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|19c,0,1eu,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,2d||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "2bo,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "ir,0,2pc,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,2d||",
                "Macquarie": "1k9,0,2pe,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,2d||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mexico_Northwest": "1od,0,187,0,1q,0,m|1od,0,187,0,20,0,2b,0,2d||",
                "Mexico_Pacific": "1oe,0,1of,0,1q,0,m|1oe,0,1of,0,20,0,2b,0,2d||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Palau": "159,0,m|||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,2d||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "2pk,0,m|||",
                "Pyongyang": "2pl,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "1oh,0,1q,0,m|1oh,0,20,0,m||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "1f2,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "sr-Latn-BA": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3gg,0,1a,0,1d||",
                "Europe/London": "|3ge,0,3o,0,40,0,3v||"
            },
            "metazone": {
                "Acre": "22d,0,1a,0,1d|22d,0,3o,0,40,0,3v||",
                "Afghanistan": "3p0,0,1d|||",
                "Africa_Central": "228,5,14v,0,1d|||",
                "Africa_Eastern": "1j7,5,14v,0,1d|||",
                "Africa_Southern": "3os,5,14v,0,1d|||",
                "Africa_Western": "16s,5,14v,0,1a,0,1d|16s,5,14v,0,3o,0,40,0,3v||",
                "Alaska": "216,k,0,1a,0,1d|216,k,0,3o,0,40,0,3v||",
                "Almaty": "1nf,0,1a,0,1d|1nf,0,3o,0,40,0,3v||",
                "Amazon": "5m,0,1a,0,1d|5m,0,3o,0,40,0,3v||",
                "America_Central": "qu,0,ug,0,1a,0,1d|qu,0,ug,0,3o,0,1d||",
                "America_Eastern": "qu,0,111,0,1a,0,1d|qu,0,111,0,3o,0,1d||",
                "America_Mountain": "qu,0,17r,0,1a,0,1d|qu,0,17r,0,3o,0,1d||",
                "America_Pacific": "qu,0,110,0,1a,0,1d|qu,0,110,0,3o,0,1d||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "20v,0,1a,0,1d|20v,0,3o,0,40,0,3v||",
                "Aqtau": "20p,0,1a,0,1d|20p,0,3o,0,40,0,3v||",
                "Aqtobe": "20n,0,1a,0,1d|20n,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,1d|1i1,0,3o,0,40,0,3v||",
                "Argentina": "1e,0,1a,0,1d|1e,0,3o,0,40,0,3v||",
                "Argentina_Western": "20a,0,1e,0,1a,0,1d|20a,0,1e,0,3o,0,40,0,3v||",
                "Armenia": "1vn,0,1a,0,1d|1vn,0,3o,0,40,0,3v||",
                "Atlantic": "1vd,0,1a,0,1d|1vd,0,3o,0,40,0,3v||",
                "Australia_Central": "pp,0,ug,0,1a,0,1d|pp,0,ug,0,3o,0,40,0,3v||",
                "Australia_CentralWestern": "pp,0,ug,0,11c,0,1a,0,1d|pp,0,ug,0,11c,0,3o,0,40,0,3v||",
                "Australia_Eastern": "pp,0,111,0,1a,0,1d|pp,0,111,0,3o,0,40,0,3v||",
                "Australia_Western": "pp,0,11c,0,1a,0,1d|pp,0,11c,0,3o,0,40,0,3v||",
                "Azerbaijan": "1v8,0,1a,0,1d|1v8,0,3o,0,40,0,3v||",
                "Azores": "1uu,0,1a,0,1d|1uu,0,3o,0,40,0,3v||",
                "Bangladesh": "1ut,0,1a,0,1d|1ut,0,3o,0,40,0,3v||",
                "Bhutan": "1k4,0,1d|||",
                "Bolivia": "3of,0,1d|||",
                "Brasilia": "1ur,0,1a,0,1d|1ur,0,3o,0,40,0,3v||",
                "Brunei": "2kg,0,3od,0,1d|||",
                "Cape_Verde": "1uq,0,ok,0,1a,0,1d|1uq,0,ok,0,3o,0,40,0,3v||",
                "Chamorro": "2nf,0,1d|||",
                "Chatham": "1um,0,1a,0,1d|1um,0,3o,0,40,0,3v||",
                "Chile": "1uk,0,1a,0,1d|1uk,0,3o,0,40,0,3v||",
                "China": "23o,0,1a,0,1d|25m,0,3o,0,40,0,3v||",
                "Choibalsan": "1uh,0,1a,0,1d|1uh,0,3o,0,40,0,3v||",
                "Christmas": "3o8,0,1ud,0,1d|||",
                "Cocos": "1eg,0,3o6,0,ok,0,1d|||",
                "Colombia": "1ro,0,1a,0,1d|1ro,0,3o,0,40,0,3v||",
                "Cook": "1rh,0,10u,0,1a,0,1d|1rh,0,10u,0,3o2,5,3o,0,40,0,3v||",
                "Cuba": "tb,0,1a,0,1d|tb,0,3o,0,40,0,3v||",
                "Davis": "3o1,0,1d|||",
                "DumontDUrville": "3o0,0,3nv,0,1d|||",
                "East_Timor": "1fl,0,3nt,0,1d|||",
                "Easter": "24r,0,10u,0,1a,0,1d|24r,0,10u,0,3o,0,40,0,3v||",
                "Ecuador": "1k0,0,1d|||",
                "Europe_Central": "23r,0,1a,0,1d|23r,0,3o,0,40,0,3v|h0|h4",
                "Europe_Eastern": "1hr,0,1a,0,1d|1hr,0,3o,0,40,0,3v|gu|gv",
                "Europe_Further_Eastern": "3nq,0,3np,0,3no|||",
                "Europe_Western": "1hq,0,1a,0,1d|1hq,0,3o,0,40,0,3v|h1|h2",
                "Falkland": "25c,0,ok,0,1a,0,1d|25c,0,ok,0,3o,0,40,0,3v||",
                "Fiji": "1fh,0,1a,0,1d|1fh,0,3o,0,40,0,3v||",
                "French_Guiana": "2n4,0,1pt,0,1d|||",
                "French_Southern": "3nm,0,3nl,0,i3,0,2l1,0,1d|||",
                "Galapagos": "ak,0,1d|||",
                "Gambier": "3nk,0,1d|||",
                "Georgia": "1qt,0,1a,0,1d|1qt,0,3o,0,40,0,3v||",
                "Gilbert_Islands": "6q,0,10u,0,1d|||",
                "GMT": "3ni,0,1d,0,3nh,0,3ng||ah|",
                "Greenland_Eastern": "1fl,0,18g,0,1a,0,1d|1fl,0,18g,0,3o,0,40,0,3v||",
                "Greenland_Western": "1rj,0,18g,0,1a,0,1d|1rj,0,18g,0,3o,0,40,0,3v||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1d|||",
                "Guyana": "1pt,0,1d|||",
                "Hawaii_Aleutian": "1c5,5,1k2,0,1a,0,1d|1c5,5,1k2,0,3o,0,40,0,3v||",
                "Hong_Kong": "2l,0,2p,0,1a,0,1d|2l,0,2p,0,3o,0,40,0,3v||",
                "Hovd": "2g,0,1a,0,1d|2g,0,3o,0,40,0,3v||",
                "India": "1n7,0,1a,0,1d|||",
                "Indian_Ocean": "1n7,0,3nd,0,1d|||",
                "Indochina": "23t,0,1d|||",
                "Indonesia_Central": "228,5,1f1,0,1d|||",
                "Indonesia_Eastern": "1j7,5,1f1,0,1d|||",
                "Indonesia_Western": "16s,5,1f1,0,1d|||",
                "Iran": "5g,0,1a,0,1d|5g,0,3o,0,40,0,3v||",
                "Irkutsk": "1oi,0,1a,0,1d|1oi,0,3o,0,40,0,3v||",
                "Israel": "1hm,0,1a,0,1d|1hm,0,3o,0,40,0,3v||",
                "Japan": "1hl,0,1a,0,1d|1hl,0,3o,0,40,0,3v||",
                "Kamchatka": "1gd,5,1i4,0,1a,0,1d|1gd,5,1i4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "1j7,5,1s3,0,1d|||",
                "Kazakhstan_Western": "16s,5,1s3,0,1d|||",
                "Korea": "1hk,0,1a,0,1d|1hk,0,3o,0,40,0,3v||",
                "Kosrae": "3na,0,1d|||",
                "Krasnoyarsk": "l0,0,1a,0,1d|l0,0,3o,0,40,0,3v||",
                "Kyrgystan": "1qu,0,1d|||",
                "Lanka": "3n9,0,9c,0,1d|||",
                "Line_Islands": "ok,0,2bp,0,1d|||",
                "Lord_Howe": "1u,0,1sd,0,1a,0,1d|1u,0,1sd,0,3o,0,40,0,3v||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "1sh,0,3n6,0,1d|||",
                "Magadan": "2o,0,1a,0,1d|2o,0,3o,0,40,0,3v||",
                "Malaysia": "3n5,0,1d|||",
                "Maldives": "3n4,0,1d|||",
                "Marquesas": "1jm,0,1d|||",
                "Marshall_Islands": "3n3,0,ok,0,1d|||",
                "Mauritius": "1te,0,1a,0,1d|1te,0,3o,0,40,0,3v||",
                "Mawson": "3n1,0,1d|||",
                "Mexico_Northwest": "1tn,0,17k,0,1a,0,1d|1tn,0,17k,0,3o,0,40,0,3v||",
                "Mexico_Pacific": "1ts,0,1tu,0,1a,0,1d|1ts,0,1tu,0,3o,0,40,0,3v||",
                "Mongolia": "4f,0,2m,0,1a,0,1d|4f,0,2m,0,3o,0,40,0,3v||",
                "Moscow": "pi,0,1a,0,1d|pi,0,3o,0,40,0,3v||",
                "Myanmar": "3mq,0,1d|||",
                "Nauru": "5v,0,1d|||",
                "Nepal": "8u,0,1d|||",
                "New_Caledonia": "ba,0,1tp,0,1a,0,1d|ba,0,1tp,0,3o,0,40,0,3v||",
                "New_Zealand": "1tv,0,1p4,0,1a,0,1d|1tv,0,1p4,0,3o,0,40,0,3v||",
                "Newfoundland": "1u0,0,1a,0,1d|1u0,0,3o,0,40,0,3v||",
                "Niue": "8g,0,1d|||",
                "Norfolk": "6l,0,1sh,0,1d|||",
                "Noronha": "1s,0,2,0,1hg,0,1a,0,1d|1s,0,2,0,1hg,0,3o,0,40,0,3v||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "3b,0,1a,0,1d|3b,0,3o,0,40,0,3v||",
                "Omsk": "26,0,1a,0,1d|26,0,3o,0,40,0,3v||",
                "Pakistan": "3i,0,1a,0,1d|3i,0,3o,0,40,0,3v||",
                "Palau": "9b,0,1d|||",
                "Papua_New_Guinea": "9a,0,ba,0,3ma,0,1d|||",
                "Paraguay": "1u2,0,1a,0,1d|1u2,0,3o,0,40,0,3v||",
                "Peru": "4n,0,1a,0,1d|4n,0,3o,0,40,0,3v||",
                "Philippines": "1u3,0,1a,0,1d|1u3,0,3o,0,40,0,3v||",
                "Phoenix_Islands": "1a7,0,10u,0,1d|||",
                "Pierre_Miquelon": "14i,0,1he,0,i3,0,u2,0,1a,0,1d|14i,0,1he,0,i3,0,u2,0,3o,0,40,0,3v||",
                "Pitcairn": "1ko,0,1d|||",
                "Ponape": "3m6,0,1d|||",
                "Pyongyang": "2b0,0,1d|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "3m1,0,1d|||",
                "Rothera": "1po,0,1d|||",
                "Sakhalin": "164,0,1a,0,1d|164,0,3o,0,40,0,3v||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "2c,0,1a,0,1d|2c,0,3o,0,40,0,3v||",
                "Seychelles": "3m0,0,1d|||",
                "Singapore": "m8,0,1a,0,1d|||",
                "Solomon": "3lv,0,ok,0,1d|||",
                "South_Georgia": "3lu,0,3lr,0,1d|||",
                "Suriname": "mg,0,1d|||",
                "Syowa": "3lo,0,1d|||",
                "Tahiti": "8n,0,1d|||",
                "Taipei": "1pc,0,1a,0,1d|1pc,0,3o,0,1d||",
                "Tajikistan": "3l4,0,1d|||",
                "Tokelau": "5d,0,1d|||",
                "Tonga": "2j,0,1a,0,1d|2j,0,3o,0,40,0,3v||",
                "Truk": "3kt,0,1d|||",
                "Turkmenistan": "4t,0,1a,0,1d|4t,0,3o,0,40,0,3v||",
                "Tuvalu": "6h,0,1d|||",
                "Uruguay": "1vq,0,1a,0,1d|1vq,0,3o,0,40,0,3v||",
                "Uzbekistan": "60,0,1a,0,1d|60,0,3o,0,40,0,3v||",
                "Vanuatu": "2f,0,1a,0,1d|2f,0,3o,0,40,0,3v||",
                "Venezuela": "3kr,0,1d|||",
                "Vladivostok": "28,0,1a,0,1d|28,0,3o,0,40,0,3v||",
                "Volgograd": "3f,0,1a,0,1d|3f,0,3o,0,40,0,3v||",
                "Vostok": "5t,0,1d|||",
                "Wake": "2ar,0,1ud,0,1d|||",
                "Wallis": "2aq,0,i3,0,5k,0,ok,0,1d|||",
                "Yakutsk": "qj,0,1a,0,1d|qj,0,3o,0,40,0,3v||",
                "Yekaterinburg": "q6,0,1a,0,1d|q6,0,3o,0,40,0,3v||"
            }
        },
        "sr-Latn-ME": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3gg,0,1a,0,1d||",
                "Europe/London": "|3ge,0,3o,0,40,0,3v||"
            },
            "metazone": {
                "Acre": "22d,0,1a,0,1d|22d,0,3o,0,40,0,3v||",
                "Afghanistan": "3p0,0,1d|||",
                "Africa_Central": "228,5,14v,0,1d|||",
                "Africa_Eastern": "1j7,5,14v,0,1d|||",
                "Africa_Southern": "3os,5,14v,0,1d|||",
                "Africa_Western": "16s,5,14v,0,1a,0,1d|16s,5,14v,0,3o,0,40,0,3v||",
                "Alaska": "216,k,0,1a,0,1d|216,k,0,3o,0,40,0,3v||",
                "Almaty": "1nf,0,1a,0,1d|1nf,0,3o,0,40,0,3v||",
                "Amazon": "5m,0,1a,0,1d|5m,0,3o,0,40,0,3v||",
                "America_Central": "qu,0,ug,0,1a,0,1d|qu,0,ug,0,3o,0,1d||",
                "America_Eastern": "qu,0,111,0,1a,0,1d|qu,0,111,0,3o,0,1d||",
                "America_Mountain": "qu,0,17r,0,1a,0,1d|qu,0,17r,0,3o,0,1d||",
                "America_Pacific": "qu,0,110,0,1a,0,1d|qu,0,110,0,3o,0,1d||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "20v,0,1a,0,1d|20v,0,3o,0,40,0,3v||",
                "Aqtau": "20p,0,1a,0,1d|20p,0,3o,0,40,0,3v||",
                "Aqtobe": "20n,0,1a,0,1d|20n,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,1d|1i1,0,3o,0,40,0,3v||",
                "Argentina": "1e,0,1a,0,1d|1e,0,3o,0,40,0,3v||",
                "Argentina_Western": "20a,0,1e,0,1a,0,1d|20a,0,1e,0,3o,0,40,0,3v||",
                "Armenia": "1vn,0,1a,0,1d|1vn,0,3o,0,40,0,3v||",
                "Atlantic": "1vd,0,1a,0,1d|1vd,0,3o,0,40,0,3v||",
                "Australia_Central": "pp,0,ug,0,1a,0,1d|pp,0,ug,0,3o,0,40,0,3v||",
                "Australia_CentralWestern": "pp,0,ug,0,11c,0,1a,0,1d|pp,0,ug,0,11c,0,3o,0,40,0,3v||",
                "Australia_Eastern": "pp,0,111,0,1a,0,1d|pp,0,111,0,3o,0,40,0,3v||",
                "Australia_Western": "pp,0,11c,0,1a,0,1d|pp,0,11c,0,3o,0,40,0,3v||",
                "Azerbaijan": "1v8,0,1a,0,1d|1v8,0,3o,0,40,0,3v||",
                "Azores": "1uu,0,1a,0,1d|1uu,0,3o,0,40,0,3v||",
                "Bangladesh": "1ut,0,1a,0,1d|1ut,0,3o,0,40,0,3v||",
                "Bhutan": "1k4,0,1d|||",
                "Bolivia": "3of,0,1d|||",
                "Brasilia": "1ur,0,1a,0,1d|1ur,0,3o,0,40,0,3v||",
                "Brunei": "2kg,0,3od,0,1d|||",
                "Cape_Verde": "1uq,0,ok,0,1a,0,1d|1uq,0,ok,0,3o,0,40,0,3v||",
                "Chamorro": "2nf,0,1d|||",
                "Chatham": "1um,0,1a,0,1d|1um,0,3o,0,40,0,3v||",
                "Chile": "1uk,0,1a,0,1d|1uk,0,3o,0,40,0,3v||",
                "China": "23o,0,1a,0,1d|25m,0,3o,0,40,0,3v||",
                "Choibalsan": "1uh,0,1a,0,1d|1uh,0,3o,0,40,0,3v||",
                "Christmas": "3o8,0,1ud,0,1d|||",
                "Cocos": "1eg,0,3o6,0,ok,0,1d|||",
                "Colombia": "1ro,0,1a,0,1d|1ro,0,3o,0,40,0,3v||",
                "Cook": "1rh,0,10u,0,1a,0,1d|1rh,0,10u,0,3o2,5,3o,0,40,0,3v||",
                "Cuba": "tb,0,1a,0,1d|tb,0,3o,0,40,0,3v||",
                "Davis": "3o1,0,1d|||",
                "DumontDUrville": "3o0,0,3nv,0,1d|||",
                "East_Timor": "1fl,0,3nt,0,1d|||",
                "Easter": "24r,0,10u,0,1a,0,1d|24r,0,10u,0,3o,0,40,0,3v||",
                "Ecuador": "1k0,0,1d|||",
                "Europe_Central": "23r,0,1a,0,1d|23r,0,3o,0,40,0,3v|h0|h4",
                "Europe_Eastern": "1hr,0,1a,0,1d|1hr,0,3o,0,40,0,3v|gu|gv",
                "Europe_Further_Eastern": "3nq,0,3np,0,3no|||",
                "Europe_Western": "1hq,0,1a,0,1d|1hq,0,3o,0,40,0,3v|h1|h2",
                "Falkland": "25c,0,ok,0,1a,0,1d|25c,0,ok,0,3o,0,40,0,3v||",
                "Fiji": "1fh,0,1a,0,1d|1fh,0,3o,0,40,0,3v||",
                "French_Guiana": "2n4,0,1pt,0,1d|||",
                "French_Southern": "3nm,0,3nl,0,i3,0,2l1,0,1d|||",
                "Galapagos": "ak,0,1d|||",
                "Gambier": "3nk,0,1d|||",
                "Georgia": "1qt,0,1a,0,1d|1qt,0,3o,0,40,0,3v||",
                "Gilbert_Islands": "6q,0,10u,0,1d|||",
                "GMT": "3ni,0,1d,0,3nh,0,3ng||ah|",
                "Greenland_Eastern": "1fl,0,18g,0,1a,0,1d|1fl,0,18g,0,3o,0,40,0,3v||",
                "Greenland_Western": "1rj,0,18g,0,1a,0,1d|1rj,0,18g,0,3o,0,40,0,3v||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1d|||",
                "Guyana": "1pt,0,1d|||",
                "Hawaii_Aleutian": "1c5,5,1k2,0,1a,0,1d|1c5,5,1k2,0,3o,0,40,0,3v||",
                "Hong_Kong": "2l,0,2p,0,1a,0,1d|2l,0,2p,0,3o,0,40,0,3v||",
                "Hovd": "2g,0,1a,0,1d|2g,0,3o,0,40,0,3v||",
                "India": "1n7,0,1a,0,1d|||",
                "Indian_Ocean": "1n7,0,3nd,0,1d|||",
                "Indochina": "23t,0,1d|||",
                "Indonesia_Central": "228,5,1f1,0,1d|||",
                "Indonesia_Eastern": "1j7,5,1f1,0,1d|||",
                "Indonesia_Western": "16s,5,1f1,0,1d|||",
                "Iran": "5g,0,1a,0,1d|5g,0,3o,0,40,0,3v||",
                "Irkutsk": "1oi,0,1a,0,1d|1oi,0,3o,0,40,0,3v||",
                "Israel": "1hm,0,1a,0,1d|1hm,0,3o,0,40,0,3v||",
                "Japan": "1hl,0,1a,0,1d|1hl,0,3o,0,40,0,3v||",
                "Kamchatka": "1gd,5,1i4,0,1a,0,1d|1gd,5,1i4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "1j7,5,1s3,0,1d|||",
                "Kazakhstan_Western": "16s,5,1s3,0,1d|||",
                "Korea": "1hk,0,1a,0,1d|1hk,0,3o,0,40,0,3v||",
                "Kosrae": "3na,0,1d|||",
                "Krasnoyarsk": "l0,0,1a,0,1d|l0,0,3o,0,40,0,3v||",
                "Kyrgystan": "1qu,0,1d|||",
                "Lanka": "3n9,0,9c,0,1d|||",
                "Line_Islands": "ok,0,2bp,0,1d|||",
                "Lord_Howe": "1u,0,1sd,0,1a,0,1d|1u,0,1sd,0,3o,0,40,0,3v||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "1sh,0,3n6,0,1d|||",
                "Magadan": "2o,0,1a,0,1d|2o,0,3o,0,40,0,3v||",
                "Malaysia": "3n5,0,1d|||",
                "Maldives": "3n4,0,1d|||",
                "Marquesas": "1jm,0,1d|||",
                "Marshall_Islands": "3n3,0,ok,0,1d|||",
                "Mauritius": "1te,0,1a,0,1d|1te,0,3o,0,40,0,3v||",
                "Mawson": "3n1,0,1d|||",
                "Mexico_Northwest": "1tn,0,17k,0,1a,0,1d|1tn,0,17k,0,3o,0,40,0,3v||",
                "Mexico_Pacific": "1ts,0,1tu,0,1a,0,1d|1ts,0,1tu,0,3o,0,40,0,3v||",
                "Mongolia": "4f,0,2m,0,1a,0,1d|4f,0,2m,0,3o,0,40,0,3v||",
                "Moscow": "pi,0,1a,0,1d|pi,0,3o,0,40,0,3v||",
                "Myanmar": "3mq,0,1d|||",
                "Nauru": "5v,0,1d|||",
                "Nepal": "8u,0,1d|||",
                "New_Caledonia": "ba,0,1tp,0,1a,0,1d|ba,0,1tp,0,3o,0,40,0,3v||",
                "New_Zealand": "1tv,0,1p4,0,1a,0,1d|1tv,0,1p4,0,3o,0,40,0,3v||",
                "Newfoundland": "1u0,0,1a,0,1d|1u0,0,3o,0,40,0,3v||",
                "Niue": "8g,0,1d|||",
                "Norfolk": "6l,0,1sh,0,1d|||",
                "Noronha": "1s,0,2,0,1hg,0,1a,0,1d|1s,0,2,0,1hg,0,3o,0,40,0,3v||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "3b,0,1a,0,1d|3b,0,3o,0,40,0,3v||",
                "Omsk": "26,0,1a,0,1d|26,0,3o,0,40,0,3v||",
                "Pakistan": "3i,0,1a,0,1d|3i,0,3o,0,40,0,3v||",
                "Palau": "9b,0,1d|||",
                "Papua_New_Guinea": "9a,0,ba,0,3ma,0,1d|||",
                "Paraguay": "1u2,0,1a,0,1d|1u2,0,3o,0,40,0,3v||",
                "Peru": "4n,0,1a,0,1d|4n,0,3o,0,40,0,3v||",
                "Philippines": "1u3,0,1a,0,1d|1u3,0,3o,0,40,0,3v||",
                "Phoenix_Islands": "1a7,0,10u,0,1d|||",
                "Pierre_Miquelon": "14i,0,1he,0,i3,0,u2,0,1a,0,1d|14i,0,1he,0,i3,0,u2,0,3o,0,40,0,3v||",
                "Pitcairn": "1ko,0,1d|||",
                "Ponape": "3m6,0,1d|||",
                "Pyongyang": "2b0,0,1d|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "3m1,0,1d|||",
                "Rothera": "1po,0,1d|||",
                "Sakhalin": "164,0,1a,0,1d|164,0,3o,0,40,0,3v||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "2c,0,1a,0,1d|2c,0,3o,0,40,0,3v||",
                "Seychelles": "3m0,0,1d|||",
                "Singapore": "m8,0,1a,0,1d|||",
                "Solomon": "3lv,0,ok,0,1d|||",
                "South_Georgia": "3lu,0,3lr,0,1d|||",
                "Suriname": "mg,0,1d|||",
                "Syowa": "3lo,0,1d|||",
                "Tahiti": "8n,0,1d|||",
                "Taipei": "1pc,0,1a,0,1d|1pc,0,3o,0,1d||",
                "Tajikistan": "3l4,0,1d|||",
                "Tokelau": "5d,0,1d|||",
                "Tonga": "2j,0,1a,0,1d|2j,0,3o,0,40,0,3v||",
                "Truk": "3kt,0,1d|||",
                "Turkmenistan": "4t,0,1a,0,1d|4t,0,3o,0,40,0,3v||",
                "Tuvalu": "6h,0,1d|||",
                "Uruguay": "1vq,0,1a,0,1d|1vq,0,3o,0,40,0,3v||",
                "Uzbekistan": "60,0,1a,0,1d|60,0,3o,0,40,0,3v||",
                "Vanuatu": "2f,0,1a,0,1d|2f,0,3o,0,40,0,3v||",
                "Venezuela": "3kr,0,1d|||",
                "Vladivostok": "28,0,1a,0,1d|28,0,3o,0,40,0,3v||",
                "Volgograd": "3f,0,1a,0,1d|3f,0,3o,0,40,0,3v||",
                "Vostok": "5t,0,1d|||",
                "Wake": "2ar,0,1ud,0,1d|||",
                "Wallis": "2aq,0,i3,0,5k,0,ok,0,1d|||",
                "Yakutsk": "qj,0,1a,0,1d|qj,0,3o,0,40,0,3v||",
                "Yekaterinburg": "q6,0,1a,0,1d|q6,0,3o,0,40,0,3v||"
            }
        },
        "sr-Latn-XK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3gg,0,1a,0,1d||",
                "Europe/London": "|3ge,0,3o,0,40,0,3v||"
            },
            "metazone": {
                "Acre": "22d,0,1a,0,1d|22d,0,3o,0,40,0,3v||",
                "Afghanistan": "3p0,0,1d|||",
                "Africa_Central": "228,5,14v,0,1d|||",
                "Africa_Eastern": "1j7,5,14v,0,1d|||",
                "Africa_Southern": "3os,5,14v,0,1d|||",
                "Africa_Western": "16s,5,14v,0,1a,0,1d|16s,5,14v,0,3o,0,40,0,3v||",
                "Alaska": "216,k,0,1a,0,1d|216,k,0,3o,0,40,0,3v||",
                "Almaty": "1nf,0,1a,0,1d|1nf,0,3o,0,40,0,3v||",
                "Amazon": "5m,0,1a,0,1d|5m,0,3o,0,40,0,3v||",
                "America_Central": "qu,0,ug,0,1a,0,1d|qu,0,ug,0,3o,0,1d||",
                "America_Eastern": "qu,0,111,0,1a,0,1d|qu,0,111,0,3o,0,1d||",
                "America_Mountain": "qu,0,17r,0,1a,0,1d|qu,0,17r,0,3o,0,1d||",
                "America_Pacific": "qu,0,110,0,1a,0,1d|qu,0,110,0,3o,0,1d||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "20v,0,1a,0,1d|20v,0,3o,0,40,0,3v||",
                "Aqtau": "20p,0,1a,0,1d|20p,0,3o,0,40,0,3v||",
                "Aqtobe": "20n,0,1a,0,1d|20n,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,1d|1i1,0,3o,0,40,0,3v||",
                "Argentina": "1e,0,1a,0,1d|1e,0,3o,0,40,0,3v||",
                "Argentina_Western": "20a,0,1e,0,1a,0,1d|20a,0,1e,0,3o,0,40,0,3v||",
                "Armenia": "1vn,0,1a,0,1d|1vn,0,3o,0,40,0,3v||",
                "Atlantic": "1vd,0,1a,0,1d|1vd,0,3o,0,40,0,3v||",
                "Australia_Central": "pp,0,ug,0,1a,0,1d|pp,0,ug,0,3o,0,40,0,3v||",
                "Australia_CentralWestern": "pp,0,ug,0,11c,0,1a,0,1d|pp,0,ug,0,11c,0,3o,0,40,0,3v||",
                "Australia_Eastern": "pp,0,111,0,1a,0,1d|pp,0,111,0,3o,0,40,0,3v||",
                "Australia_Western": "pp,0,11c,0,1a,0,1d|pp,0,11c,0,3o,0,40,0,3v||",
                "Azerbaijan": "1v8,0,1a,0,1d|1v8,0,3o,0,40,0,3v||",
                "Azores": "1uu,0,1a,0,1d|1uu,0,3o,0,40,0,3v||",
                "Bangladesh": "1ut,0,1a,0,1d|1ut,0,3o,0,40,0,3v||",
                "Bhutan": "1k4,0,1d|||",
                "Bolivia": "3of,0,1d|||",
                "Brasilia": "1ur,0,1a,0,1d|1ur,0,3o,0,40,0,3v||",
                "Brunei": "2kg,0,3od,0,1d|||",
                "Cape_Verde": "1uq,0,ok,0,1a,0,1d|1uq,0,ok,0,3o,0,40,0,3v||",
                "Chamorro": "2nf,0,1d|||",
                "Chatham": "1um,0,1a,0,1d|1um,0,3o,0,40,0,3v||",
                "Chile": "1uk,0,1a,0,1d|1uk,0,3o,0,40,0,3v||",
                "China": "23o,0,1a,0,1d|25m,0,3o,0,40,0,3v||",
                "Choibalsan": "1uh,0,1a,0,1d|1uh,0,3o,0,40,0,3v||",
                "Christmas": "3o8,0,1ud,0,1d|||",
                "Cocos": "1eg,0,3o6,0,ok,0,1d|||",
                "Colombia": "1ro,0,1a,0,1d|1ro,0,3o,0,40,0,3v||",
                "Cook": "1rh,0,10u,0,1a,0,1d|1rh,0,10u,0,3o2,5,3o,0,40,0,3v||",
                "Cuba": "tb,0,1a,0,1d|tb,0,3o,0,40,0,3v||",
                "Davis": "3o1,0,1d|||",
                "DumontDUrville": "3o0,0,3nv,0,1d|||",
                "East_Timor": "1fl,0,3nt,0,1d|||",
                "Easter": "24r,0,10u,0,1a,0,1d|24r,0,10u,0,3o,0,40,0,3v||",
                "Ecuador": "1k0,0,1d|||",
                "Europe_Central": "23r,0,1a,0,1d|23r,0,3o,0,40,0,3v|h0|h4",
                "Europe_Eastern": "1hr,0,1a,0,1d|1hr,0,3o,0,40,0,3v|gu|gv",
                "Europe_Further_Eastern": "3nq,0,3np,0,3no|||",
                "Europe_Western": "1hq,0,1a,0,1d|1hq,0,3o,0,40,0,3v|h1|h2",
                "Falkland": "25c,0,ok,0,1a,0,1d|25c,0,ok,0,3o,0,40,0,3v||",
                "Fiji": "1fh,0,1a,0,1d|1fh,0,3o,0,40,0,3v||",
                "French_Guiana": "2n4,0,1pt,0,1d|||",
                "French_Southern": "3nm,0,3nl,0,i3,0,2l1,0,1d|||",
                "Galapagos": "ak,0,1d|||",
                "Gambier": "3nk,0,1d|||",
                "Georgia": "1qt,0,1a,0,1d|1qt,0,3o,0,40,0,3v||",
                "Gilbert_Islands": "6q,0,10u,0,1d|||",
                "GMT": "3ni,0,1d,0,3nh,0,3ng||ah|",
                "Greenland_Eastern": "1fl,0,18g,0,1a,0,1d|1fl,0,18g,0,3o,0,40,0,3v||",
                "Greenland_Western": "1rj,0,18g,0,1a,0,1d|1rj,0,18g,0,3o,0,40,0,3v||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1d|||",
                "Guyana": "1pt,0,1d|||",
                "Hawaii_Aleutian": "1c5,5,1k2,0,1a,0,1d|1c5,5,1k2,0,3o,0,40,0,3v||",
                "Hong_Kong": "2l,0,2p,0,1a,0,1d|2l,0,2p,0,3o,0,40,0,3v||",
                "Hovd": "2g,0,1a,0,1d|2g,0,3o,0,40,0,3v||",
                "India": "1n7,0,1a,0,1d|||",
                "Indian_Ocean": "1n7,0,3nd,0,1d|||",
                "Indochina": "23t,0,1d|||",
                "Indonesia_Central": "228,5,1f1,0,1d|||",
                "Indonesia_Eastern": "1j7,5,1f1,0,1d|||",
                "Indonesia_Western": "16s,5,1f1,0,1d|||",
                "Iran": "5g,0,1a,0,1d|5g,0,3o,0,40,0,3v||",
                "Irkutsk": "1oi,0,1a,0,1d|1oi,0,3o,0,40,0,3v||",
                "Israel": "1hm,0,1a,0,1d|1hm,0,3o,0,40,0,3v||",
                "Japan": "1hl,0,1a,0,1d|1hl,0,3o,0,40,0,3v||",
                "Kamchatka": "1gd,5,1i4,0,1a,0,1d|1gd,5,1i4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "1j7,5,1s3,0,1d|||",
                "Kazakhstan_Western": "16s,5,1s3,0,1d|||",
                "Korea": "1hk,0,1a,0,1d|1hk,0,3o,0,40,0,3v||",
                "Kosrae": "3na,0,1d|||",
                "Krasnoyarsk": "l0,0,1a,0,1d|l0,0,3o,0,40,0,3v||",
                "Kyrgystan": "1qu,0,1d|||",
                "Lanka": "3n9,0,9c,0,1d|||",
                "Line_Islands": "ok,0,2bp,0,1d|||",
                "Lord_Howe": "1u,0,1sd,0,1a,0,1d|1u,0,1sd,0,3o,0,40,0,3v||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "1sh,0,3n6,0,1d|||",
                "Magadan": "2o,0,1a,0,1d|2o,0,3o,0,40,0,3v||",
                "Malaysia": "3n5,0,1d|||",
                "Maldives": "3n4,0,1d|||",
                "Marquesas": "1jm,0,1d|||",
                "Marshall_Islands": "3n3,0,ok,0,1d|||",
                "Mauritius": "1te,0,1a,0,1d|1te,0,3o,0,40,0,3v||",
                "Mawson": "3n1,0,1d|||",
                "Mexico_Northwest": "1tn,0,17k,0,1a,0,1d|1tn,0,17k,0,3o,0,40,0,3v||",
                "Mexico_Pacific": "1ts,0,1tu,0,1a,0,1d|1ts,0,1tu,0,3o,0,40,0,3v||",
                "Mongolia": "4f,0,2m,0,1a,0,1d|4f,0,2m,0,3o,0,40,0,3v||",
                "Moscow": "pi,0,1a,0,1d|pi,0,3o,0,40,0,3v||",
                "Myanmar": "3mq,0,1d|||",
                "Nauru": "5v,0,1d|||",
                "Nepal": "8u,0,1d|||",
                "New_Caledonia": "ba,0,1tp,0,1a,0,1d|ba,0,1tp,0,3o,0,40,0,3v||",
                "New_Zealand": "1tv,0,1p4,0,1a,0,1d|1tv,0,1p4,0,3o,0,40,0,3v||",
                "Newfoundland": "1u0,0,1a,0,1d|1u0,0,3o,0,40,0,3v||",
                "Niue": "8g,0,1d|||",
                "Norfolk": "6l,0,1sh,0,1d|||",
                "Noronha": "1s,0,2,0,1hg,0,1a,0,1d|1s,0,2,0,1hg,0,3o,0,40,0,3v||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "3b,0,1a,0,1d|3b,0,3o,0,40,0,3v||",
                "Omsk": "26,0,1a,0,1d|26,0,3o,0,40,0,3v||",
                "Pakistan": "3i,0,1a,0,1d|3i,0,3o,0,40,0,3v||",
                "Palau": "9b,0,1d|||",
                "Papua_New_Guinea": "9a,0,ba,0,3ma,0,1d|||",
                "Paraguay": "1u2,0,1a,0,1d|1u2,0,3o,0,40,0,3v||",
                "Peru": "4n,0,1a,0,1d|4n,0,3o,0,40,0,3v||",
                "Philippines": "1u3,0,1a,0,1d|1u3,0,3o,0,40,0,3v||",
                "Phoenix_Islands": "1a7,0,10u,0,1d|||",
                "Pierre_Miquelon": "14i,0,1he,0,i3,0,u2,0,1a,0,1d|14i,0,1he,0,i3,0,u2,0,3o,0,40,0,3v||",
                "Pitcairn": "1ko,0,1d|||",
                "Ponape": "3m6,0,1d|||",
                "Pyongyang": "2b0,0,1d|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "3m1,0,1d|||",
                "Rothera": "1po,0,1d|||",
                "Sakhalin": "164,0,1a,0,1d|164,0,3o,0,40,0,3v||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "2c,0,1a,0,1d|2c,0,3o,0,40,0,3v||",
                "Seychelles": "3m0,0,1d|||",
                "Singapore": "m8,0,1a,0,1d|||",
                "Solomon": "3lv,0,ok,0,1d|||",
                "South_Georgia": "3lu,0,3lr,0,1d|||",
                "Suriname": "mg,0,1d|||",
                "Syowa": "3lo,0,1d|||",
                "Tahiti": "8n,0,1d|||",
                "Taipei": "1pc,0,1a,0,1d|1pc,0,3o,0,1d||",
                "Tajikistan": "3l4,0,1d|||",
                "Tokelau": "5d,0,1d|||",
                "Tonga": "2j,0,1a,0,1d|2j,0,3o,0,40,0,3v||",
                "Truk": "3kt,0,1d|||",
                "Turkmenistan": "4t,0,1a,0,1d|4t,0,3o,0,40,0,3v||",
                "Tuvalu": "6h,0,1d|||",
                "Uruguay": "1vq,0,1a,0,1d|1vq,0,3o,0,40,0,3v||",
                "Uzbekistan": "60,0,1a,0,1d|60,0,3o,0,40,0,3v||",
                "Vanuatu": "2f,0,1a,0,1d|2f,0,3o,0,40,0,3v||",
                "Venezuela": "3kr,0,1d|||",
                "Vladivostok": "28,0,1a,0,1d|28,0,3o,0,40,0,3v||",
                "Volgograd": "3f,0,1a,0,1d|3f,0,3o,0,40,0,3v||",
                "Vostok": "5t,0,1d|||",
                "Wake": "2ar,0,1ud,0,1d|||",
                "Wallis": "2aq,0,i3,0,5k,0,ok,0,1d|||",
                "Yakutsk": "qj,0,1a,0,1d|qj,0,3o,0,40,0,3v||",
                "Yekaterinburg": "q6,0,1a,0,1d|q6,0,3o,0,40,0,3v||"
            }
        },
        "sr-Latn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3gg,0,1a,0,1d||",
                "Europe/London": "|3ge,0,3o,0,40,0,3v||"
            },
            "metazone": {
                "Acre": "22d,0,1a,0,1d|22d,0,3o,0,40,0,3v||",
                "Afghanistan": "3p0,0,1d|||",
                "Africa_Central": "228,5,14v,0,1d|||",
                "Africa_Eastern": "1j7,5,14v,0,1d|||",
                "Africa_Southern": "3os,5,14v,0,1d|||",
                "Africa_Western": "16s,5,14v,0,1a,0,1d|16s,5,14v,0,3o,0,40,0,3v||",
                "Alaska": "216,k,0,1a,0,1d|216,k,0,3o,0,40,0,3v||",
                "Almaty": "1nf,0,1a,0,1d|1nf,0,3o,0,40,0,3v||",
                "Amazon": "5m,0,1a,0,1d|5m,0,3o,0,40,0,3v||",
                "America_Central": "qu,0,ug,0,1a,0,1d|qu,0,ug,0,3o,0,1d||",
                "America_Eastern": "qu,0,111,0,1a,0,1d|qu,0,111,0,3o,0,1d||",
                "America_Mountain": "qu,0,17r,0,1a,0,1d|qu,0,17r,0,3o,0,1d||",
                "America_Pacific": "qu,0,110,0,1a,0,1d|qu,0,110,0,3o,0,1d||",
                "Anadyr": "1eh,0,1a,0,1d|1eh,0,3o,0,40,0,3v||",
                "Apia": "20v,0,1a,0,1d|20v,0,3o,0,40,0,3v||",
                "Aqtau": "20p,0,1a,0,1d|20p,0,3o,0,40,0,3v||",
                "Aqtobe": "20n,0,1a,0,1d|20n,0,3o,0,40,0,3v||",
                "Arabian": "1i1,0,1a,0,1d|1i1,0,3o,0,40,0,3v||",
                "Argentina": "1e,0,1a,0,1d|1e,0,3o,0,40,0,3v||",
                "Argentina_Western": "20a,0,1e,0,1a,0,1d|20a,0,1e,0,3o,0,40,0,3v||",
                "Armenia": "1vn,0,1a,0,1d|1vn,0,3o,0,40,0,3v||",
                "Atlantic": "1vd,0,1a,0,1d|1vd,0,3o,0,40,0,3v||",
                "Australia_Central": "pp,0,ug,0,1a,0,1d|pp,0,ug,0,3o,0,40,0,3v||",
                "Australia_CentralWestern": "pp,0,ug,0,11c,0,1a,0,1d|pp,0,ug,0,11c,0,3o,0,40,0,3v||",
                "Australia_Eastern": "pp,0,111,0,1a,0,1d|pp,0,111,0,3o,0,40,0,3v||",
                "Australia_Western": "pp,0,11c,0,1a,0,1d|pp,0,11c,0,3o,0,40,0,3v||",
                "Azerbaijan": "1v8,0,1a,0,1d|1v8,0,3o,0,40,0,3v||",
                "Azores": "1uu,0,1a,0,1d|1uu,0,3o,0,40,0,3v||",
                "Bangladesh": "1ut,0,1a,0,1d|1ut,0,3o,0,40,0,3v||",
                "Bhutan": "1k4,0,1d|||",
                "Bolivia": "3of,0,1d|||",
                "Brasilia": "1ur,0,1a,0,1d|1ur,0,3o,0,40,0,3v||",
                "Brunei": "2kg,0,3od,0,1d|||",
                "Cape_Verde": "1uq,0,ok,0,1a,0,1d|1uq,0,ok,0,3o,0,40,0,3v||",
                "Chamorro": "2nf,0,1d|||",
                "Chatham": "1um,0,1a,0,1d|1um,0,3o,0,40,0,3v||",
                "Chile": "1uk,0,1a,0,1d|1uk,0,3o,0,40,0,3v||",
                "China": "23o,0,1a,0,1d|25m,0,3o,0,40,0,3v||",
                "Choibalsan": "1uh,0,1a,0,1d|1uh,0,3o,0,40,0,3v||",
                "Christmas": "3o8,0,1ud,0,1d|||",
                "Cocos": "1eg,0,3o6,0,ok,0,1d|||",
                "Colombia": "1ro,0,1a,0,1d|1ro,0,3o,0,40,0,3v||",
                "Cook": "1rh,0,10u,0,1a,0,1d|1rh,0,10u,0,3o2,5,3o,0,40,0,3v||",
                "Cuba": "tb,0,1a,0,1d|tb,0,3o,0,40,0,3v||",
                "Davis": "3o1,0,1d|||",
                "DumontDUrville": "3o0,0,3nv,0,1d|||",
                "East_Timor": "1fl,0,3nt,0,1d|||",
                "Easter": "24r,0,10u,0,1a,0,1d|24r,0,10u,0,3o,0,40,0,3v||",
                "Ecuador": "1k0,0,1d|||",
                "Europe_Central": "23r,0,1a,0,1d|23r,0,3o,0,40,0,3v|h0|h4",
                "Europe_Eastern": "1hr,0,1a,0,1d|1hr,0,3o,0,40,0,3v|gu|gv",
                "Europe_Further_Eastern": "3nq,0,3np,0,3no|||",
                "Europe_Western": "1hq,0,1a,0,1d|1hq,0,3o,0,40,0,3v|h1|h2",
                "Falkland": "25c,0,ok,0,1a,0,1d|25c,0,ok,0,3o,0,40,0,3v||",
                "Fiji": "1fh,0,1a,0,1d|1fh,0,3o,0,40,0,3v||",
                "French_Guiana": "2n4,0,1pt,0,1d|||",
                "French_Southern": "3nm,0,3nl,0,i3,0,2l1,0,1d|||",
                "Galapagos": "ak,0,1d|||",
                "Gambier": "3nk,0,1d|||",
                "Georgia": "1qt,0,1a,0,1d|1qt,0,3o,0,40,0,3v||",
                "Gilbert_Islands": "6q,0,10u,0,1d|||",
                "GMT": "3ni,0,1d,0,3nh,0,3ng||ah|",
                "Greenland_Eastern": "1fl,0,18g,0,1a,0,1d|1fl,0,18g,0,3o,0,40,0,3v||",
                "Greenland_Western": "1rj,0,18g,0,1a,0,1d|1rj,0,18g,0,3o,0,40,0,3v||",
                "Guam": "83,0,1a,0,1d|||",
                "Gulf": "2cb,0,1d|||",
                "Guyana": "1pt,0,1d|||",
                "Hawaii_Aleutian": "1c5,5,1k2,0,1a,0,1d|1c5,5,1k2,0,3o,0,40,0,3v||",
                "Hong_Kong": "2l,0,2p,0,1a,0,1d|2l,0,2p,0,3o,0,40,0,3v||",
                "Hovd": "2g,0,1a,0,1d|2g,0,3o,0,40,0,3v||",
                "India": "1n7,0,1a,0,1d|||",
                "Indian_Ocean": "1n7,0,3nd,0,1d|||",
                "Indochina": "23t,0,1d|||",
                "Indonesia_Central": "228,5,1f1,0,1d|||",
                "Indonesia_Eastern": "1j7,5,1f1,0,1d|||",
                "Indonesia_Western": "16s,5,1f1,0,1d|||",
                "Iran": "5g,0,1a,0,1d|5g,0,3o,0,40,0,3v||",
                "Irkutsk": "1oi,0,1a,0,1d|1oi,0,3o,0,40,0,3v||",
                "Israel": "1hm,0,1a,0,1d|1hm,0,3o,0,40,0,3v||",
                "Japan": "1hl,0,1a,0,1d|1hl,0,3o,0,40,0,3v||",
                "Kamchatka": "1gd,5,1i4,0,1a,0,1d|1gd,5,1i4,0,3o,0,40,0,3v||",
                "Kazakhstan_Eastern": "1j7,5,1s3,0,1d|||",
                "Kazakhstan_Western": "16s,5,1s3,0,1d|||",
                "Korea": "1hk,0,1a,0,1d|1hk,0,3o,0,40,0,3v||",
                "Kosrae": "3na,0,1d|||",
                "Krasnoyarsk": "l0,0,1a,0,1d|l0,0,3o,0,40,0,3v||",
                "Kyrgystan": "1qu,0,1d|||",
                "Lanka": "3n9,0,9c,0,1d|||",
                "Line_Islands": "ok,0,2bp,0,1d|||",
                "Lord_Howe": "1u,0,1sd,0,1a,0,1d|1u,0,1sd,0,3o,0,40,0,3v||",
                "Macau": "176,0,1a,0,1d|176,0,3o,0,40,0,3v||",
                "Macquarie": "1sh,0,3n6,0,1d|||",
                "Magadan": "2o,0,1a,0,1d|2o,0,3o,0,40,0,3v||",
                "Malaysia": "3n5,0,1d|||",
                "Maldives": "3n4,0,1d|||",
                "Marquesas": "1jm,0,1d|||",
                "Marshall_Islands": "3n3,0,ok,0,1d|||",
                "Mauritius": "1te,0,1a,0,1d|1te,0,3o,0,40,0,3v||",
                "Mawson": "3n1,0,1d|||",
                "Mexico_Northwest": "1tn,0,17k,0,1a,0,1d|1tn,0,17k,0,3o,0,40,0,3v||",
                "Mexico_Pacific": "1ts,0,1tu,0,1a,0,1d|1ts,0,1tu,0,3o,0,40,0,3v||",
                "Mongolia": "4f,0,2m,0,1a,0,1d|4f,0,2m,0,3o,0,40,0,3v||",
                "Moscow": "pi,0,1a,0,1d|pi,0,3o,0,40,0,3v||",
                "Myanmar": "3mq,0,1d|||",
                "Nauru": "5v,0,1d|||",
                "Nepal": "8u,0,1d|||",
                "New_Caledonia": "ba,0,1tp,0,1a,0,1d|ba,0,1tp,0,3o,0,40,0,3v||",
                "New_Zealand": "1tv,0,1p4,0,1a,0,1d|1tv,0,1p4,0,3o,0,40,0,3v||",
                "Newfoundland": "1u0,0,1a,0,1d|1u0,0,3o,0,40,0,3v||",
                "Niue": "8g,0,1d|||",
                "Norfolk": "6l,0,1sh,0,1d|||",
                "Noronha": "1s,0,2,0,1hg,0,1a,0,1d|1s,0,2,0,1hg,0,3o,0,40,0,3v||",
                "North_Mariana": "2bc,0,2ba,0,ok,0,1d|||",
                "Novosibirsk": "3b,0,1a,0,1d|3b,0,3o,0,40,0,3v||",
                "Omsk": "26,0,1a,0,1d|26,0,3o,0,40,0,3v||",
                "Pakistan": "3i,0,1a,0,1d|3i,0,3o,0,40,0,3v||",
                "Palau": "9b,0,1d|||",
                "Papua_New_Guinea": "9a,0,ba,0,3ma,0,1d|||",
                "Paraguay": "1u2,0,1a,0,1d|1u2,0,3o,0,40,0,3v||",
                "Peru": "4n,0,1a,0,1d|4n,0,3o,0,40,0,3v||",
                "Philippines": "1u3,0,1a,0,1d|1u3,0,3o,0,40,0,3v||",
                "Phoenix_Islands": "1a7,0,10u,0,1d|||",
                "Pierre_Miquelon": "14i,0,1he,0,i3,0,u2,0,1a,0,1d|14i,0,1he,0,i3,0,u2,0,3o,0,40,0,3v||",
                "Pitcairn": "1ko,0,1d|||",
                "Ponape": "3m6,0,1d|||",
                "Pyongyang": "2b0,0,1d|||",
                "Qyzylorda": "1hd,0,1a,0,1d|1hd,0,3o,0,40,0,3v||",
                "Reunion": "3m1,0,1d|||",
                "Rothera": "1po,0,1d|||",
                "Sakhalin": "164,0,1a,0,1d|164,0,3o,0,40,0,3v||",
                "Samara": "29,0,1a,0,1d|29,0,3o,0,40,0,3v||",
                "Samoa": "2c,0,1a,0,1d|2c,0,3o,0,40,0,3v||",
                "Seychelles": "3m0,0,1d|||",
                "Singapore": "m8,0,1a,0,1d|||",
                "Solomon": "3lv,0,ok,0,1d|||",
                "South_Georgia": "3lu,0,3lr,0,1d|||",
                "Suriname": "mg,0,1d|||",
                "Syowa": "3lo,0,1d|||",
                "Tahiti": "8n,0,1d|||",
                "Taipei": "1pc,0,1a,0,1d|1pc,0,3o,0,1d||",
                "Tajikistan": "3l4,0,1d|||",
                "Tokelau": "5d,0,1d|||",
                "Tonga": "2j,0,1a,0,1d|2j,0,3o,0,40,0,3v||",
                "Truk": "3kt,0,1d|||",
                "Turkmenistan": "4t,0,1a,0,1d|4t,0,3o,0,40,0,3v||",
                "Tuvalu": "6h,0,1d|||",
                "Uruguay": "1vq,0,1a,0,1d|1vq,0,3o,0,40,0,3v||",
                "Uzbekistan": "60,0,1a,0,1d|60,0,3o,0,40,0,3v||",
                "Vanuatu": "2f,0,1a,0,1d|2f,0,3o,0,40,0,3v||",
                "Venezuela": "3kr,0,1d|||",
                "Vladivostok": "28,0,1a,0,1d|28,0,3o,0,40,0,3v||",
                "Volgograd": "3f,0,1a,0,1d|3f,0,3o,0,40,0,3v||",
                "Vostok": "5t,0,1d|||",
                "Wake": "2ar,0,1ud,0,1d|||",
                "Wallis": "2aq,0,i3,0,5k,0,ok,0,1d|||",
                "Yakutsk": "qj,0,1a,0,1d|qj,0,3o,0,40,0,3v||",
                "Yekaterinburg": "q6,0,1a,0,1d|q6,0,3o,0,40,0,3v||"
            }
        },
        "sr": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tc,0,1q,0,m||",
                "Europe/London": "|2me,0,20,0,2b,0,2d||"
            },
            "metazone": {
                "Acre": "1ed,0,1q,0,m|1ed,0,20,0,2b,0,2d||",
                "Afghanistan": "2ak,0,m|||",
                "Africa_Central": "18j,5,rt,0,m|||",
                "Africa_Eastern": "12g,5,rt,0,m|||",
                "Africa_Southern": "2j9,5,rt,0,m|||",
                "Africa_Western": "11m,5,rt,0,1q,0,m|11m,5,rt,0,20,0,2b,0,2d||",
                "Alaska": "1jf,k,0,1q,0,m|1jf,k,0,20,0,2b,0,2d||",
                "Almaty": "1ja,0,1q,0,m|1ja,0,20,0,2b,0,2d||",
                "Amazon": "15q,0,1q,0,m|15q,0,20,0,2b,0,2d||",
                "America_Central": "p7,0,p6,0,1q,0,m|p7,0,p6,0,20,0,m||",
                "America_Eastern": "p7,0,139,0,1q,0,m|p7,0,139,0,20,0,m||",
                "America_Mountain": "p7,0,1gj,0,1q,0,m|p7,0,1gj,0,20,0,m||",
                "America_Pacific": "p7,0,1o4,0,1q,0,m|p7,0,1o4,0,20,0,m||",
                "Anadyr": "18u,0,1q,0,m|18u,0,20,0,2b,0,2d||",
                "Apia": "1jh,0,1q,0,m|1jh,0,20,0,2b,0,2d||",
                "Aqtau": "1j9,0,1q,0,m|1j9,0,20,0,2b,0,2d||",
                "Aqtobe": "1j8,0,1q,0,m|1j8,0,20,0,2b,0,2d||",
                "Arabian": "1j6,0,1q,0,m|1j6,0,20,0,2b,0,2d||",
                "Argentina": "hk,0,1q,0,m|hk,0,20,0,2b,0,2d||",
                "Argentina_Western": "16h,0,hk,0,1q,0,m|16h,0,hk,0,20,0,2b,0,2d||",
                "Armenia": "1o5,0,1q,0,m|1o5,0,20,0,2b,0,2d||",
                "Atlantic": "1ji,0,1q,0,m|1ji,0,20,0,2b,0,2d||",
                "Australia_Central": "mp,0,p6,0,1q,0,m|mp,0,p6,0,20,0,2b,0,2d||",
                "Australia_CentralWestern": "mp,0,p6,0,uu,0,1q,0,m|mp,0,p6,0,uu,0,20,0,2b,0,2d||",
                "Australia_Eastern": "mp,0,139,0,1q,0,m|mp,0,139,0,20,0,2b,0,2d||",
                "Australia_Western": "mp,0,uu,0,1q,0,m|mp,0,uu,0,20,0,2b,0,2d||",
                "Azerbaijan": "1b0,0,1q,0,m|1b0,0,20,0,2b,0,2d||",
                "Azores": "1j5,0,1q,0,m|1j5,0,20,0,2b,0,2d||",
                "Bangladesh": "q8,0,1q,0,m|q8,0,20,0,2b,0,2d||",
                "Bhutan": "16f,0,m|||",
                "Bolivia": "27a,0,m|||",
                "Brasilia": "1bo,0,1q,0,m|1bo,0,20,0,2b,0,2d||",
                "Brunei": "2id,0,2ic,0,m|||",
                "Cape_Verde": "1o8,0,ir,0,1q,0,m|1o8,0,ir,0,20,0,2b,0,2d||",
                "Chamorro": "1u7,0,m|||",
                "Chatham": "1bu,0,1q,0,m|1bu,0,20,0,2b,0,2d||",
                "Chile": "1c0,0,1q,0,m|1c0,0,20,0,2b,0,2d||",
                "China": "2i5,0,1q,0,m|22t,0,20,0,2b,0,2d||",
                "Choibalsan": "1c6,0,1q,0,m|1c6,0,20,0,2b,0,2d||",
                "Christmas": "2p0,0,1ka,0,m|||",
                "Cocos": "1le,0,2hm,0,ir,0,m|||",
                "Colombia": "1ck,0,1q,0,m|1ck,0,20,0,2b,0,2d||",
                "Cook": "1j4,0,pm,0,1q,0,m|1j4,0,pm,0,2hc,5,20,0,2b,0,2d||",
                "Cuba": "ql,0,1q,0,m|ql,0,20,0,2b,0,2d||",
                "Davis": "277,0,m|||",
                "DumontDUrville": "276,0,2gp,0,m|||",
                "East_Timor": "15u,0,2gm,0,m|||",
                "Easter": "1j2,0,pm,0,1q,0,m|1j2,0,pm,0,20,0,2b,0,2d||",
                "Ecuador": "274,0,m|||",
                "Europe_Central": "1j1,0,1q,0,m|1j1,0,20,0,2b,0,2d|h0|h4",
                "Europe_Eastern": "1dh,0,1q,0,m|1dh,0,20,0,2b,0,2d|gu|gv",
                "Europe_Further_Eastern": "2p1,0,2p2,0,2p3|||",
                "Europe_Western": "1dj,0,1q,0,m|1dj,0,20,0,2b,0,2d|h1|h2",
                "Falkland": "1iv,0,ir,0,1q,0,m|1iv,0,ir,0,20,0,2b,0,2d||",
                "Fiji": "1dn,0,1q,0,m|1dn,0,20,0,2b,0,2d||",
                "French_Guiana": "272,0,1dr,0,m|||",
                "French_Southern": "26t,0,26s,0,il,0,26r,0,m|||",
                "Galapagos": "1na,0,m|||",
                "Gambier": "2p5,0,m|||",
                "Georgia": "19a,0,1q,0,m|19a,0,20,0,2b,0,2d||",
                "Gilbert_Islands": "1ne,0,pm,0,m|||",
                "GMT": "2p6,0,m,0,1jo,0,2p7||ah|",
                "Greenland_Eastern": "15u,0,ur,0,1q,0,m|15u,0,ur,0,20,0,2b,0,2d||",
                "Greenland_Western": "1is,0,ur,0,1q,0,m|1is,0,ur,0,20,0,2b,0,2d||",
                "Guam": "1ir,0,1q,0,m|||",
                "Gulf": "2pb,0,m|||",
                "Guyana": "1dr,0,m|||",
                "Hawaii_Aleutian": "1iq,5,1ae,0,1q,0,m|1iq,5,1ae,0,20,0,2b,0,2d||",
                "Hong_Kong": "19c,0,1eu,0,1q,0,m|19c,0,1eu,0,20,0,2b,0,2d||",
                "Hovd": "qg,0,1q,0,m|qg,0,20,0,2b,0,2d||",
                "India": "1in,0,1q,0,m|||",
                "Indian_Ocean": "1in,0,2ep,0,m|||",
                "Indochina": "26p,0,m|||",
                "Indonesia_Central": "18j,5,160,0,m|||",
                "Indonesia_Eastern": "12g,5,160,0,m|||",
                "Indonesia_Western": "11m,5,160,0,m|||",
                "Iran": "rr,0,1q,0,m|rr,0,20,0,2b,0,2d||",
                "Irkutsk": "1im,0,1q,0,m|1im,0,20,0,2b,0,2d||",
                "Israel": "1cq,0,1q,0,m|1cq,0,20,0,2b,0,2d||",
                "Japan": "1il,0,1q,0,m|1il,0,20,0,2b,0,2d||",
                "Kamchatka": "1ik,5,1ij,0,1q,0,m|1ik,5,1ij,0,20,0,2b,0,2d||",
                "Kazakhstan_Eastern": "12g,5,1ih,0,m|||",
                "Kazakhstan_Western": "11m,5,1ih,0,m|||",
                "Korea": "1ig,0,1q,0,m|1ig,0,20,0,2b,0,2d||",
                "Kosrae": "2ec,0,m|||",
                "Krasnoyarsk": "1af,0,1q,0,m|1af,0,20,0,2b,0,2d||",
                "Kyrgystan": "2bo,0,m|||",
                "Lanka": "1if,0,1et,0,m|||",
                "Line_Islands": "ir,0,2pc,0,m|||",
                "Lord_Howe": "oi,0,1id,0,1q,0,m|oi,0,1id,0,20,0,2b,0,2d||",
                "Macau": "118,0,1q,0,m|118,0,20,0,2b,0,2d||",
                "Macquarie": "1k9,0,2pe,0,m|||",
                "Magadan": "qq,0,1q,0,m|qq,0,20,0,2b,0,2d||",
                "Malaysia": "26n,0,m|||",
                "Maldives": "26m,0,m|||",
                "Marquesas": "26l,0,m|||",
                "Marshall_Islands": "2e5,0,ir,0,m|||",
                "Mauritius": "1ib,0,1q,0,m|1ib,0,20,0,2b,0,2d||",
                "Mawson": "26k,0,m|||",
                "Mexico_Northwest": "1od,0,187,0,1q,0,m|1od,0,187,0,20,0,2b,0,2d||",
                "Mexico_Pacific": "1oe,0,1of,0,1q,0,m|1oe,0,1of,0,20,0,2b,0,2d||",
                "Mongolia": "or,0,qo,0,1q,0,m|or,0,qo,0,20,0,2b,0,2d||",
                "Moscow": "r6,0,1q,0,m|r6,0,20,0,2b,0,2d||",
                "Myanmar": "2e2,0,m|||",
                "Nauru": "14s,0,m|||",
                "Nepal": "16d,0,m|||",
                "New_Caledonia": "125,0,1bq,0,1q,0,m|125,0,1bq,0,20,0,2b,0,2d||",
                "New_Zealand": "1i9,0,1bs,0,1q,0,m|1i9,0,1bs,0,20,0,2b,0,2d||",
                "Newfoundland": "1bt,0,1q,0,m|1bt,0,20,0,2b,0,2d||",
                "Niue": "1q4,0,m|||",
                "Norfolk": "146,0,1k9,0,m|||",
                "Noronha": "138,0,13a,0,1bv,0,1q,0,m|138,0,13a,0,1bv,0,20,0,2b,0,2d||",
                "North_Mariana": "26j,0,2dt,0,ir,0,m|||",
                "Novosibirsk": "qt,0,1q,0,m|qt,0,20,0,2b,0,2d||",
                "Omsk": "r5,0,1q,0,m|r5,0,20,0,2b,0,2d||",
                "Pakistan": "rq,0,1q,0,m|rq,0,20,0,2b,0,2d||",
                "Palau": "159,0,m|||",
                "Papua_New_Guinea": "13k,0,125,0,26i,0,m|||",
                "Paraguay": "1ca,0,1q,0,m|1ca,0,20,0,2b,0,2d||",
                "Peru": "q1,0,1q,0,m|q1,0,20,0,2b,0,2d||",
                "Philippines": "1cg,0,1q,0,m|1cg,0,20,0,2b,0,2d||",
                "Phoenix_Islands": "158,0,pm,0,m|||",
                "Pierre_Miquelon": "pr,0,1ci,0,il,0,qp,0,1q,0,m|pr,0,1ci,0,il,0,qp,0,20,0,2b,0,2d||",
                "Pitcairn": "1q6,0,m|||",
                "Ponape": "2pk,0,m|||",
                "Pyongyang": "2pl,0,m|||",
                "Qyzylorda": "1cj,0,1q,0,m|1cj,0,20,0,2b,0,2d||",
                "Reunion": "2do,0,m|||",
                "Rothera": "157,0,m|||",
                "Sakhalin": "r8,0,1q,0,m|r8,0,20,0,2b,0,2d||",
                "Samara": "17o,0,1q,0,m|17o,0,20,0,2b,0,2d||",
                "Samoa": "p0,0,1q,0,m|p0,0,20,0,2b,0,2d||",
                "Seychelles": "26h,0,m|||",
                "Singapore": "16b,0,1q,0,m|||",
                "Solomon": "2dh,0,ir,0,m|||",
                "South_Georgia": "26g,0,2d8,0,m|||",
                "Suriname": "18v,0,m|||",
                "Syowa": "28v,0,m|||",
                "Tahiti": "26f,0,m|||",
                "Taipei": "1oh,0,1q,0,m|1oh,0,20,0,m||",
                "Tajikistan": "26e,0,m|||",
                "Tokelau": "156,0,m|||",
                "Tonga": "ot,0,1q,0,m|ot,0,20,0,2b,0,2d||",
                "Truk": "1f2,0,m|||",
                "Turkmenistan": "1db,0,1q,0,m|1db,0,20,0,2b,0,2d||",
                "Tuvalu": "14j,0,m|||",
                "Uruguay": "1dc,0,1q,0,m|1dc,0,20,0,2b,0,2d||",
                "Uzbekistan": "108,0,1q,0,m|108,0,20,0,2b,0,2d||",
                "Vanuatu": "os,0,1q,0,m|os,0,20,0,2b,0,2d||",
                "Venezuela": "26c,0,m|||",
                "Vladivostok": "qn,0,1q,0,m|qn,0,20,0,2b,0,2d||",
                "Volgograd": "q9,0,1q,0,m|q9,0,20,0,2b,0,2d||",
                "Vostok": "155,0,m|||",
                "Wake": "26b,0,1ka,0,m|||",
                "Wallis": "26a,0,il,0,14l,0,ir,0,m|||",
                "Yakutsk": "1do,0,1q,0,m|1do,0,20,0,2b,0,2d||",
                "Yekaterinburg": "1i3,0,1q,0,m|1i3,0,20,0,2b,0,2d||"
            }
        },
        "sv-AX": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4p8,0,6c||",
                "Europe/London": "|4pa,0,6c||",
                "Pacific/Honolulu": "||4pb|4pf"
            },
            "metazone": {
                "Acre": "2de,0,1l|2de,0,6c||",
                "Afghanistan": "2qd,0,4j|||",
                "Africa_Central": "4m3,0,4j|||",
                "Africa_Eastern": "4m4,0,4j|||",
                "Africa_Southern": "4m5,0,4j|||",
                "Africa_Western": "2cv,0,1l|2cv,0,6c||",
                "Alaska": "3p,k,0,1l|3p,k,0,6c||",
                "Almaty": "4m7|4m8||",
                "Amazon": "bg,k,0,1l|bg,k,0,6c||",
                "America_Central": "2cs,0,1l|2cs,0,6c||",
                "America_Eastern": "2cn,0,1l|2cn,0,6c||",
                "America_Mountain": "2ce,0,2cd,k,0,1l|2ce,0,2cd,k,0,6c||",
                "America_Pacific": "2cc,0,1l|2cc,0,6c||",
                "Anadyr": "4m9|4mb||",
                "Apia": "3e,k,0,1l|3e,k,0,6c||",
                "Aqtau": "4mc|4md||",
                "Aqtobe": "4me|4mf||",
                "Arabian": "2ca,0,1l|2ca,0,6c||",
                "Argentina": "2c9,0,1l|2c9,0,6c||",
                "Argentina_Western": "2c8,0,1l|2c8,0,6c||",
                "Armenia": "2c7,0,1l|2c7,0,6c||",
                "Atlantic": "2c6,0,4mg|2c6,0,4mh||",
                "Australia_Central": "2c2,0,1l|2c2,0,6c||",
                "Australia_CentralWestern": "2c1,0,1l|2c1,0,6c||",
                "Australia_Eastern": "2c0,0,1l|2c0,0,6c||",
                "Australia_Western": "2bv,0,1l|2bv,0,6c||",
                "Azerbaijan": "2bu,0,1l|2bu,0,6c||",
                "Azores": "2bt,0,1l|2bt,0,6c||",
                "Bangladesh": "1o1,0,1l|1o1,0,6c||",
                "Bhutan": "2vt,0,4j|||",
                "Bolivia": "2vl,0,4j|||",
                "Brasilia": "3a,k,0,1l|3a,k,0,6c||",
                "Brunei": "4mi|||",
                "Cape_Verde": "1l8,0,3j,k,0,1l|1l8,0,3j,k,0,6c||",
                "Casey": "4mj|||",
                "Chamorro": "4mk|||",
                "Chatham": "27,k,0,1l|27,k,0,6c||",
                "Chile": "1ng,0,1l|1ng,0,6c||",
                "China": "1la,0,1l|1la,0,6c||",
                "Choibalsan": "2bs,k,0,1l|2bs,k,0,6c||",
                "Christmas": "4ml,0,4j|||",
                "Cocos": "4mo,0,4j|||",
                "Colombia": "1nv,0,1l|1nv,0,6c||",
                "Cook": "2bq,0,1l|2bq,0,6c||",
                "Cuba": "2bn,0,1l|2bn,0,6c||",
                "Davis": "4s2|||",
                "DumontDUrville": "5b,0,5j,5,4j|||",
                "East_Timor": "4mq,0,4j|||",
                "Easter": "2bm,k,0,1l|2bm,k,0,6c||",
                "Ecuador": "2ug,0,4j|||",
                "Europe_Central": "2bl,0,1l|2bl,0,6c|h0|h4",
                "Europe_Eastern": "2bj,0,1l|2bj,0,6c|gu|gv",
                "Europe_Further_Eastern": "4mr|||",
                "Europe_Western": "2bh,0,1l|2bh,0,6c|h1|h2",
                "Falkland": "2bf,k,0,1l|2bf,k,0,6c||",
                "Fiji": "4q,k,0,1l|4q,k,0,6c||",
                "French_Guiana": "25t,0,2be|||",
                "French_Southern": "25t,0,4ms,0,4j|||",
                "Galapagos": "4mt|||",
                "Gambier": "4mv|||",
                "Georgia": "1ol,0,1l|1ol,0,6c||",
                "Gilbert_Islands": "4n0|||",
                "GMT": "4n1||ah|",
                "Greenland_Eastern": "2b9,0,1l|2b9,0,6c||",
                "Greenland_Western": "2b6,0,1l|2b6,0,6c||",
                "Guam": "4n2|||",
                "Gulf": "4n5,0,4n8|||",
                "Guyana": "2be|||",
                "Hawaii_Aleutian": "2b3,k,0,1l|2b3,k,0,6c||",
                "Hong_Kong": "qh,k,0,1l|qh,k,0,6c||",
                "Hovd": "2b2,k,0,1l|2b2,k,0,6c||",
                "India": "2n9,0,4j|||",
                "Indian_Ocean": "4n9,0,4na,0,4nb,0,4j|||",
                "Indochina": "31n,0,4j|||",
                "Indonesia_Central": "4nc,0,4j|||",
                "Indonesia_Eastern": "4ne,0,4j|||",
                "Indonesia_Western": "4nf,0,4j|||",
                "Iran": "1me,0,1l|1me,0,6c||",
                "Irkutsk": "3h,k,0,1l|3h,k,0,6c||",
                "Israel": "2an,0,1l|2an,0,6c||",
                "Japan": "1l9,0,1l|1l9,0,6c||",
                "Kamchatka": "4ng|4nh||",
                "Kazakhstan_Eastern": "4nm,0,4j|||",
                "Kazakhstan_Western": "4nn,0,4j|||",
                "Korea": "1pa,0,1l|1pa,0,6c||",
                "Kosrae": "4np|||",
                "Krasnoyarsk": "l0,k,0,1l|l0,k,0,6c||",
                "Kyrgystan": "4nq,0,4j|||",
                "Lanka": "me,0,4nr|||",
                "Line_Islands": "4ns,0,4j|||",
                "Lord_Howe": "1u,0,24,k,0,1l|1u,0,24,k,0,6c||",
                "Macau": "4nt|4nu||",
                "Macquarie": "4nv|||",
                "Magadan": "2o,k,0,1l|2o,k,0,6c||",
                "Malaysia": "2lt,0,4j|||",
                "Maldives": "4o0|||",
                "Marquesas": "4o1|||",
                "Marshall_Islands": "4o2,0,4j|||",
                "Mauritius": "4u,k,0,1l|4u,k,0,6c||",
                "Mawson": "4o3|||",
                "Mexico_Northwest": "2am,0,1l|2am,0,6c||",
                "Mexico_Pacific": "2ai,0,2ko,k,0,1l|2ai,0,2ko,k,0,6c||",
                "Mongolia": "p2,k,0,1l|p2,k,0,6c||",
                "Moscow": "pi,k,0,1l|pi,k,0,6c||",
                "Myanmar": "4o4,0,4j|||",
                "Nauru": "4o5|||",
                "Nepal": "4o6,0,4j|||",
                "New_Caledonia": "1qg,0,2kf,k,0,1l|1qg,0,2kf,k,0,6c||",
                "New_Zealand": "2kd,0,1l|2kd,0,6c||",
                "Newfoundland": "53,k,0,1l|53,k,0,6c||",
                "Niue": "4o7|||",
                "Norfolk": "4o8,0,4j|||",
                "Noronha": "1s,0,2,0,23,k,0,1l|1s,0,2,0,23,k,0,6c||",
                "North_Mariana": "4o9,0,4j|||",
                "Novosibirsk": "3b,k,0,1l|3b,k,0,6c||",
                "Omsk": "26,k,0,1l|26,k,0,6c||",
                "Pakistan": "1m6,0,1l|1m6,0,6c||",
                "Palau": "4oa|||",
                "Papua_New_Guinea": "9a,0,1qg,0,4ob,0,4j|||",
                "Paraguay": "1pd,0,1l|1pd,0,6c||",
                "Peru": "1nj,0,1l|1nj,0,6c||",
                "Philippines": "1ms,0,1l|1ms,0,6c||",
                "Phoenix_Islands": "4oc|||",
                "Pierre_Miquelon": "2jm,0,33,0,1qh,0,35,k,0,1l|2jm,0,33,0,1qh,0,35,k,0,6c||",
                "Pitcairn": "4od|||",
                "Ponape": "4oe|||",
                "Pyongyang": "4of|||",
                "Qyzylorda": "4og|4oh||",
                "Reunion": "4oi|||",
                "Rothera": "4oj|||",
                "Sakhalin": "ph,k,0,1l|ph,k,0,6c||",
                "Samara": "4ok|4ol||",
                "Samoa": "1nt,0,1l|1nt,0,6c||",
                "Seychelles": "4on|||",
                "Singapore": "4oo|||",
                "Solomon": "4op,0,4j|||",
                "South_Georgia": "4oq,0,4j|||",
                "Suriname": "4or|||",
                "Syowa": "4ot|||",
                "Tahiti": "4ou|||",
                "Taipei": "3d,k,0,1l|3d,k,0,6c||",
                "Tajikistan": "4p1|||",
                "Tokelau": "4p5|||",
                "Tonga": "2j,k,0,1l|2j,k,0,6c||",
                "Truk": "4p6|||",
                "Turkmenistan": "1l4,0,1l|1l4,0,6c||",
                "Tuvalu": "4p7|||",
                "Uruguay": "1p5,0,1l|1p5,0,6c||",
                "Uzbekistan": "2jk,0,1l|2jk,0,6c||",
                "Vanuatu": "2f,k,0,1l|2f,k,0,6c||",
                "Venezuela": "2tl,0,4j|||",
                "Vladivostok": "28,k,0,1l|28,k,0,6c||",
                "Volgograd": "3f,k,0,1l|3f,k,0,6c||",
                "Vostok": "4p9|||",
                "Wake": "4pc,0,4j|||",
                "Wallis": "5f,5,0,1qh,0,4pd,0,4j|||",
                "Yakutsk": "qj,k,0,1l|qj,k,0,6c||",
                "Yekaterinburg": "q6,k,0,1l|q6,k,0,6c||"
            }
        },
        "sv-FI": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4p8,0,6c||",
                "Europe/London": "|4pa,0,6c||",
                "Pacific/Honolulu": "||4pb|4pf"
            },
            "metazone": {
                "Acre": "2de,0,1l|2de,0,6c||",
                "Afghanistan": "2qd,0,4j|||",
                "Africa_Central": "4m3,0,4j|||",
                "Africa_Eastern": "4m4,0,4j|||",
                "Africa_Southern": "4m5,0,4j|||",
                "Africa_Western": "2cv,0,1l|2cv,0,6c||",
                "Alaska": "3p,k,0,1l|3p,k,0,6c||",
                "Almaty": "4m7|4m8||",
                "Amazon": "bg,k,0,1l|bg,k,0,6c||",
                "America_Central": "2cs,0,1l|2cs,0,6c||",
                "America_Eastern": "2cn,0,1l|2cn,0,6c||",
                "America_Mountain": "2ce,0,2cd,k,0,1l|2ce,0,2cd,k,0,6c||",
                "America_Pacific": "2cc,0,1l|2cc,0,6c||",
                "Anadyr": "4m9|4mb||",
                "Apia": "3e,k,0,1l|3e,k,0,6c||",
                "Aqtau": "4mc|4md||",
                "Aqtobe": "4me|4mf||",
                "Arabian": "2ca,0,1l|2ca,0,6c||",
                "Argentina": "2c9,0,1l|2c9,0,6c||",
                "Argentina_Western": "2c8,0,1l|2c8,0,6c||",
                "Armenia": "2c7,0,1l|2c7,0,6c||",
                "Atlantic": "2c6,0,4mg|2c6,0,4mh||",
                "Australia_Central": "2c2,0,1l|2c2,0,6c||",
                "Australia_CentralWestern": "2c1,0,1l|2c1,0,6c||",
                "Australia_Eastern": "2c0,0,1l|2c0,0,6c||",
                "Australia_Western": "2bv,0,1l|2bv,0,6c||",
                "Azerbaijan": "2bu,0,1l|2bu,0,6c||",
                "Azores": "2bt,0,1l|2bt,0,6c||",
                "Bangladesh": "1o1,0,1l|1o1,0,6c||",
                "Bhutan": "2vt,0,4j|||",
                "Bolivia": "2vl,0,4j|||",
                "Brasilia": "3a,k,0,1l|3a,k,0,6c||",
                "Brunei": "4mi|||",
                "Cape_Verde": "1l8,0,3j,k,0,1l|1l8,0,3j,k,0,6c||",
                "Casey": "4mj|||",
                "Chamorro": "4mk|||",
                "Chatham": "27,k,0,1l|27,k,0,6c||",
                "Chile": "1ng,0,1l|1ng,0,6c||",
                "China": "1la,0,1l|1la,0,6c||",
                "Choibalsan": "2bs,k,0,1l|2bs,k,0,6c||",
                "Christmas": "4ml,0,4j|||",
                "Cocos": "4mo,0,4j|||",
                "Colombia": "1nv,0,1l|1nv,0,6c||",
                "Cook": "2bq,0,1l|2bq,0,6c||",
                "Cuba": "2bn,0,1l|2bn,0,6c||",
                "Davis": "4s2|||",
                "DumontDUrville": "5b,0,5j,5,4j|||",
                "East_Timor": "4mq,0,4j|||",
                "Easter": "2bm,k,0,1l|2bm,k,0,6c||",
                "Ecuador": "2ug,0,4j|||",
                "Europe_Central": "2bl,0,1l|2bl,0,6c|h0|h4",
                "Europe_Eastern": "2bj,0,1l|2bj,0,6c|gu|gv",
                "Europe_Further_Eastern": "4mr|||",
                "Europe_Western": "2bh,0,1l|2bh,0,6c|h1|h2",
                "Falkland": "2bf,k,0,1l|2bf,k,0,6c||",
                "Fiji": "4q,k,0,1l|4q,k,0,6c||",
                "French_Guiana": "25t,0,2be|||",
                "French_Southern": "25t,0,4ms,0,4j|||",
                "Galapagos": "4mt|||",
                "Gambier": "4mv|||",
                "Georgia": "1ol,0,1l|1ol,0,6c||",
                "Gilbert_Islands": "4n0|||",
                "GMT": "4n1||ah|",
                "Greenland_Eastern": "2b9,0,1l|2b9,0,6c||",
                "Greenland_Western": "2b6,0,1l|2b6,0,6c||",
                "Guam": "4n2|||",
                "Gulf": "4n5,0,4n8|||",
                "Guyana": "2be|||",
                "Hawaii_Aleutian": "2b3,k,0,1l|2b3,k,0,6c||",
                "Hong_Kong": "qh,k,0,1l|qh,k,0,6c||",
                "Hovd": "2b2,k,0,1l|2b2,k,0,6c||",
                "India": "2n9,0,4j|||",
                "Indian_Ocean": "4n9,0,4na,0,4nb,0,4j|||",
                "Indochina": "31n,0,4j|||",
                "Indonesia_Central": "4nc,0,4j|||",
                "Indonesia_Eastern": "4ne,0,4j|||",
                "Indonesia_Western": "4nf,0,4j|||",
                "Iran": "1me,0,1l|1me,0,6c||",
                "Irkutsk": "3h,k,0,1l|3h,k,0,6c||",
                "Israel": "2an,0,1l|2an,0,6c||",
                "Japan": "1l9,0,1l|1l9,0,6c||",
                "Kamchatka": "4ng|4nh||",
                "Kazakhstan_Eastern": "4nm,0,4j|||",
                "Kazakhstan_Western": "4nn,0,4j|||",
                "Korea": "1pa,0,1l|1pa,0,6c||",
                "Kosrae": "4np|||",
                "Krasnoyarsk": "l0,k,0,1l|l0,k,0,6c||",
                "Kyrgystan": "4nq,0,4j|||",
                "Lanka": "me,0,4nr|||",
                "Line_Islands": "4ns,0,4j|||",
                "Lord_Howe": "1u,0,24,k,0,1l|1u,0,24,k,0,6c||",
                "Macau": "4nt|4nu||",
                "Macquarie": "4nv|||",
                "Magadan": "2o,k,0,1l|2o,k,0,6c||",
                "Malaysia": "2lt,0,4j|||",
                "Maldives": "4o0|||",
                "Marquesas": "4o1|||",
                "Marshall_Islands": "4o2,0,4j|||",
                "Mauritius": "4u,k,0,1l|4u,k,0,6c||",
                "Mawson": "4o3|||",
                "Mexico_Northwest": "2am,0,1l|2am,0,6c||",
                "Mexico_Pacific": "2ai,0,2ko,k,0,1l|2ai,0,2ko,k,0,6c||",
                "Mongolia": "p2,k,0,1l|p2,k,0,6c||",
                "Moscow": "pi,k,0,1l|pi,k,0,6c||",
                "Myanmar": "4o4,0,4j|||",
                "Nauru": "4o5|||",
                "Nepal": "4o6,0,4j|||",
                "New_Caledonia": "1qg,0,2kf,k,0,1l|1qg,0,2kf,k,0,6c||",
                "New_Zealand": "2kd,0,1l|2kd,0,6c||",
                "Newfoundland": "53,k,0,1l|53,k,0,6c||",
                "Niue": "4o7|||",
                "Norfolk": "4o8,0,4j|||",
                "Noronha": "1s,0,2,0,23,k,0,1l|1s,0,2,0,23,k,0,6c||",
                "North_Mariana": "4o9,0,4j|||",
                "Novosibirsk": "3b,k,0,1l|3b,k,0,6c||",
                "Omsk": "26,k,0,1l|26,k,0,6c||",
                "Pakistan": "1m6,0,1l|1m6,0,6c||",
                "Palau": "4oa|||",
                "Papua_New_Guinea": "9a,0,1qg,0,4ob,0,4j|||",
                "Paraguay": "1pd,0,1l|1pd,0,6c||",
                "Peru": "1nj,0,1l|1nj,0,6c||",
                "Philippines": "1ms,0,1l|1ms,0,6c||",
                "Phoenix_Islands": "4oc|||",
                "Pierre_Miquelon": "2jm,0,33,0,1qh,0,35,k,0,1l|2jm,0,33,0,1qh,0,35,k,0,6c||",
                "Pitcairn": "4od|||",
                "Ponape": "4oe|||",
                "Pyongyang": "4of|||",
                "Qyzylorda": "4og|4oh||",
                "Reunion": "4oi|||",
                "Rothera": "4oj|||",
                "Sakhalin": "ph,k,0,1l|ph,k,0,6c||",
                "Samara": "4ok|4ol||",
                "Samoa": "1nt,0,1l|1nt,0,6c||",
                "Seychelles": "4on|||",
                "Singapore": "4oo|||",
                "Solomon": "4op,0,4j|||",
                "South_Georgia": "4oq,0,4j|||",
                "Suriname": "4or|||",
                "Syowa": "4ot|||",
                "Tahiti": "4ou|||",
                "Taipei": "3d,k,0,1l|3d,k,0,6c||",
                "Tajikistan": "4p1|||",
                "Tokelau": "4p5|||",
                "Tonga": "2j,k,0,1l|2j,k,0,6c||",
                "Truk": "4p6|||",
                "Turkmenistan": "1l4,0,1l|1l4,0,6c||",
                "Tuvalu": "4p7|||",
                "Uruguay": "1p5,0,1l|1p5,0,6c||",
                "Uzbekistan": "2jk,0,1l|2jk,0,6c||",
                "Vanuatu": "2f,k,0,1l|2f,k,0,6c||",
                "Venezuela": "2tl,0,4j|||",
                "Vladivostok": "28,k,0,1l|28,k,0,6c||",
                "Volgograd": "3f,k,0,1l|3f,k,0,6c||",
                "Vostok": "4p9|||",
                "Wake": "4pc,0,4j|||",
                "Wallis": "5f,5,0,1qh,0,4pd,0,4j|||",
                "Yakutsk": "qj,k,0,1l|qj,k,0,6c||",
                "Yekaterinburg": "q6,k,0,1l|q6,k,0,6c||"
            }
        },
        "sv": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|4p8,0,6c||",
                "Europe/London": "|4pa,0,6c||",
                "Pacific/Honolulu": "||4pb|4pf"
            },
            "metazone": {
                "Acre": "2de,0,1l|2de,0,6c||",
                "Afghanistan": "2qd,0,4j|||",
                "Africa_Central": "4m3,0,4j|||",
                "Africa_Eastern": "4m4,0,4j|||",
                "Africa_Southern": "4m5,0,4j|||",
                "Africa_Western": "2cv,0,1l|2cv,0,6c||",
                "Alaska": "3p,k,0,1l|3p,k,0,6c||",
                "Almaty": "4m7|4m8||",
                "Amazon": "bg,k,0,1l|bg,k,0,6c||",
                "America_Central": "2cs,0,1l|2cs,0,6c||",
                "America_Eastern": "2cn,0,1l|2cn,0,6c||",
                "America_Mountain": "2ce,0,2cd,k,0,1l|2ce,0,2cd,k,0,6c||",
                "America_Pacific": "2cc,0,1l|2cc,0,6c||",
                "Anadyr": "4m9|4mb||",
                "Apia": "3e,k,0,1l|3e,k,0,6c||",
                "Aqtau": "4mc|4md||",
                "Aqtobe": "4me|4mf||",
                "Arabian": "2ca,0,1l|2ca,0,6c||",
                "Argentina": "2c9,0,1l|2c9,0,6c||",
                "Argentina_Western": "2c8,0,1l|2c8,0,6c||",
                "Armenia": "2c7,0,1l|2c7,0,6c||",
                "Atlantic": "2c6,0,4mg|2c6,0,4mh||",
                "Australia_Central": "2c2,0,1l|2c2,0,6c||",
                "Australia_CentralWestern": "2c1,0,1l|2c1,0,6c||",
                "Australia_Eastern": "2c0,0,1l|2c0,0,6c||",
                "Australia_Western": "2bv,0,1l|2bv,0,6c||",
                "Azerbaijan": "2bu,0,1l|2bu,0,6c||",
                "Azores": "2bt,0,1l|2bt,0,6c||",
                "Bangladesh": "1o1,0,1l|1o1,0,6c||",
                "Bhutan": "2vt,0,4j|||",
                "Bolivia": "2vl,0,4j|||",
                "Brasilia": "3a,k,0,1l|3a,k,0,6c||",
                "Brunei": "4mi|||",
                "Cape_Verde": "1l8,0,3j,k,0,1l|1l8,0,3j,k,0,6c||",
                "Casey": "4mj|||",
                "Chamorro": "4mk|||",
                "Chatham": "27,k,0,1l|27,k,0,6c||",
                "Chile": "1ng,0,1l|1ng,0,6c||",
                "China": "1la,0,1l|1la,0,6c||",
                "Choibalsan": "2bs,k,0,1l|2bs,k,0,6c||",
                "Christmas": "4ml,0,4j|||",
                "Cocos": "4mo,0,4j|||",
                "Colombia": "1nv,0,1l|1nv,0,6c||",
                "Cook": "2bq,0,1l|2bq,0,6c||",
                "Cuba": "2bn,0,1l|2bn,0,6c||",
                "Davis": "4s2|||",
                "DumontDUrville": "5b,0,5j,5,4j|||",
                "East_Timor": "4mq,0,4j|||",
                "Easter": "2bm,k,0,1l|2bm,k,0,6c||",
                "Ecuador": "2ug,0,4j|||",
                "Europe_Central": "2bl,0,1l|2bl,0,6c|h0|h4",
                "Europe_Eastern": "2bj,0,1l|2bj,0,6c|gu|gv",
                "Europe_Further_Eastern": "4mr|||",
                "Europe_Western": "2bh,0,1l|2bh,0,6c|h1|h2",
                "Falkland": "2bf,k,0,1l|2bf,k,0,6c||",
                "Fiji": "4q,k,0,1l|4q,k,0,6c||",
                "French_Guiana": "25t,0,2be|||",
                "French_Southern": "25t,0,4ms,0,4j|||",
                "Galapagos": "4mt|||",
                "Gambier": "4mv|||",
                "Georgia": "1ol,0,1l|1ol,0,6c||",
                "Gilbert_Islands": "4n0|||",
                "GMT": "4n1||ah|",
                "Greenland_Eastern": "2b9,0,1l|2b9,0,6c||",
                "Greenland_Western": "2b6,0,1l|2b6,0,6c||",
                "Guam": "4n2|||",
                "Gulf": "4n5,0,4n8|||",
                "Guyana": "2be|||",
                "Hawaii_Aleutian": "2b3,k,0,1l|2b3,k,0,6c||",
                "Hong_Kong": "qh,k,0,1l|qh,k,0,6c||",
                "Hovd": "2b2,k,0,1l|2b2,k,0,6c||",
                "India": "2n9,0,4j|||",
                "Indian_Ocean": "4n9,0,4na,0,4nb,0,4j|||",
                "Indochina": "31n,0,4j|||",
                "Indonesia_Central": "4nc,0,4j|||",
                "Indonesia_Eastern": "4ne,0,4j|||",
                "Indonesia_Western": "4nf,0,4j|||",
                "Iran": "1me,0,1l|1me,0,6c||",
                "Irkutsk": "3h,k,0,1l|3h,k,0,6c||",
                "Israel": "2an,0,1l|2an,0,6c||",
                "Japan": "1l9,0,1l|1l9,0,6c||",
                "Kamchatka": "4ng|4nh||",
                "Kazakhstan_Eastern": "4nm,0,4j|||",
                "Kazakhstan_Western": "4nn,0,4j|||",
                "Korea": "1pa,0,1l|1pa,0,6c||",
                "Kosrae": "4np|||",
                "Krasnoyarsk": "l0,k,0,1l|l0,k,0,6c||",
                "Kyrgystan": "4nq,0,4j|||",
                "Lanka": "me,0,4nr|||",
                "Line_Islands": "4ns,0,4j|||",
                "Lord_Howe": "1u,0,24,k,0,1l|1u,0,24,k,0,6c||",
                "Macau": "4nt|4nu||",
                "Macquarie": "4nv|||",
                "Magadan": "2o,k,0,1l|2o,k,0,6c||",
                "Malaysia": "2lt,0,4j|||",
                "Maldives": "4o0|||",
                "Marquesas": "4o1|||",
                "Marshall_Islands": "4o2,0,4j|||",
                "Mauritius": "4u,k,0,1l|4u,k,0,6c||",
                "Mawson": "4o3|||",
                "Mexico_Northwest": "2am,0,1l|2am,0,6c||",
                "Mexico_Pacific": "2ai,0,2ko,k,0,1l|2ai,0,2ko,k,0,6c||",
                "Mongolia": "p2,k,0,1l|p2,k,0,6c||",
                "Moscow": "pi,k,0,1l|pi,k,0,6c||",
                "Myanmar": "4o4,0,4j|||",
                "Nauru": "4o5|||",
                "Nepal": "4o6,0,4j|||",
                "New_Caledonia": "1qg,0,2kf,k,0,1l|1qg,0,2kf,k,0,6c||",
                "New_Zealand": "2kd,0,1l|2kd,0,6c||",
                "Newfoundland": "53,k,0,1l|53,k,0,6c||",
                "Niue": "4o7|||",
                "Norfolk": "4o8,0,4j|||",
                "Noronha": "1s,0,2,0,23,k,0,1l|1s,0,2,0,23,k,0,6c||",
                "North_Mariana": "4o9,0,4j|||",
                "Novosibirsk": "3b,k,0,1l|3b,k,0,6c||",
                "Omsk": "26,k,0,1l|26,k,0,6c||",
                "Pakistan": "1m6,0,1l|1m6,0,6c||",
                "Palau": "4oa|||",
                "Papua_New_Guinea": "9a,0,1qg,0,4ob,0,4j|||",
                "Paraguay": "1pd,0,1l|1pd,0,6c||",
                "Peru": "1nj,0,1l|1nj,0,6c||",
                "Philippines": "1ms,0,1l|1ms,0,6c||",
                "Phoenix_Islands": "4oc|||",
                "Pierre_Miquelon": "2jm,0,33,0,1qh,0,35,k,0,1l|2jm,0,33,0,1qh,0,35,k,0,6c||",
                "Pitcairn": "4od|||",
                "Ponape": "4oe|||",
                "Pyongyang": "4of|||",
                "Qyzylorda": "4og|4oh||",
                "Reunion": "4oi|||",
                "Rothera": "4oj|||",
                "Sakhalin": "ph,k,0,1l|ph,k,0,6c||",
                "Samara": "4ok|4ol||",
                "Samoa": "1nt,0,1l|1nt,0,6c||",
                "Seychelles": "4on|||",
                "Singapore": "4oo|||",
                "Solomon": "4op,0,4j|||",
                "South_Georgia": "4oq,0,4j|||",
                "Suriname": "4or|||",
                "Syowa": "4ot|||",
                "Tahiti": "4ou|||",
                "Taipei": "3d,k,0,1l|3d,k,0,6c||",
                "Tajikistan": "4p1|||",
                "Tokelau": "4p5|||",
                "Tonga": "2j,k,0,1l|2j,k,0,6c||",
                "Truk": "4p6|||",
                "Turkmenistan": "1l4,0,1l|1l4,0,6c||",
                "Tuvalu": "4p7|||",
                "Uruguay": "1p5,0,1l|1p5,0,6c||",
                "Uzbekistan": "2jk,0,1l|2jk,0,6c||",
                "Vanuatu": "2f,k,0,1l|2f,k,0,6c||",
                "Venezuela": "2tl,0,4j|||",
                "Vladivostok": "28,k,0,1l|28,k,0,6c||",
                "Volgograd": "3f,k,0,1l|3f,k,0,6c||",
                "Vostok": "4p9|||",
                "Wake": "4pc,0,4j|||",
                "Wallis": "5f,5,0,1qh,0,4pd,0,4j|||",
                "Yakutsk": "qj,k,0,1l|qj,k,0,6c||",
                "Yekaterinburg": "q6,k,0,1l|q6,k,0,6c||"
            }
        },
        "sw-CD": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3et||",
                "Europe/London": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3ae||"
            },
            "metazone": {
                "Afghanistan": "v,0,l,0,b6|||",
                "Africa_Central": "v,0,l,0,c5,0,59,0,ps|||",
                "Africa_Eastern": "v,0,l,0,c5,0,mn|||",
                "Africa_Southern": "v,0,43,0,l,0,c5,0,1f3|||",
                "Africa_Western": "v,0,l,0,43,0,l,0,c5,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,c5,0,hu||",
                "Alaska": "v,0,l,0,43,0,l,0,3p|v,0,l,0,cj,0,l,0,3p||",
                "Amazon": "v,0,l,0,43,0,l,0,5m|v,0,l,0,8d,0,59,0,8j,0,l,0,5m||",
                "America_Central": "v,0,l,0,43,0,l,0,ps|v,0,l,0,cj,0,l,0,ps||",
                "America_Eastern": "v,0,l,0,43,0,l,0,mn|v,0,l,0,cj,0,l,0,mn||",
                "America_Mountain": "v,0,l,0,43,0,l,0,5a|v,0,l,0,cj,0,l,0,5a||",
                "America_Pacific": "v,0,l,0,43,0,l,0,22s|v,0,l,0,cj,0,l,0,22s||",
                "Anadyr": "v,0,l,0,43,0,l,0,3l|v,0,l,0,1f4,0,l,0,3l||",
                "Apia": "v,0,43,0,l,0,3e|v,0,l,0,cj,0,l,0,3e||",
                "Arabian": "v,0,43,0,l,0,3ft|v,0,l,0,cj,0,l,0,3fs||",
                "Argentina": "v,0,l,0,43,0,l,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,1e||",
                "Argentina_Western": "v,0,43,0,l,0,hu,0,oc,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,1e||",
                "Armenia": "v,0,43,0,l,0,4l|v,0,l,0,8d,0,59,0,8j,0,l,0,4l||",
                "Atlantic": "v,0,l,0,43,0,l,0,230|v,0,l,0,cj,0,l,0,230||",
                "Australia_Central": "v,0,43,0,l,0,4c,0,59,0,ps|v,0,l,0,cj,0,l,0,4c,0,59,0,ps||",
                "Australia_CentralWestern": "v,0,43,0,l,0,hu,0,59,0,ps,0,59,0,4c|v,0,l,0,cj,0,l,0,hu,0,59,0,ps,0,59,0,4c||",
                "Australia_Eastern": "v,0,43,0,l,0,mn,0,oc,0,4c|v,0,l,0,cj,0,l,0,mn,0,oc,0,4c||",
                "Australia_Western": "v,0,43,0,l,0,4c,0,hu|v,0,l,0,cj,0,l,0,4c,0,hu||",
                "Azerbaijan": "v,0,43,0,l,0,232|v,0,l,0,8d,0,59,0,8j,0,l,0,232||",
                "Azores": "v,0,43,0,l,0,4r|v,0,l,0,8d,0,59,0,8j,0,l,0,4r||",
                "Bangladesh": "v,0,43,0,l,0,3n|v,0,l,0,8d,0,59,0,8j,0,l,0,3n||",
                "Bhutan": "v,0,l,0,as|||",
                "Bolivia": "v,0,l,0,aa|||",
                "Brasilia": "v,0,l,0,43,0,l,0,3a|v,0,l,0,8d,0,59,0,8j,0,l,0,3a||",
                "Brunei": "v,0,l,0,9o,0,a4|||",
                "Cape_Verde": "v,0,l,0,43,0,l,0,7c,0,3j|v,0,l,0,8d,0,59,0,8j,0,l,0,7c,0,3j||",
                "Chamorro": "v,0,43,0,l,0,6j|||",
                "Chatham": "v,0,43,0,l,0,27|v,0,l,0,cj,0,l,0,27||",
                "Chile": "v,0,l,0,43,0,l,0,49|v,0,l,0,8d,0,59,0,8j,0,l,0,49||",
                "China": "v,0,43,0,l,0,233|v,0,l,0,cj,0,l,0,233||",
                "Choibalsan": "v,0,43,0,l,0,2q|v,0,l,0,8d,0,59,0,8j,0,l,0,2q||",
                "Christmas": "v,0,l,0,13r,0,11t,0,99|||",
                "Cocos": "v,0,l,0,p9,0,q0,0,7v|||",
                "Colombia": "v,0,l,0,43,0,l,0,4m|v,0,l,0,8d,0,59,0,8j,0,l,0,4m||",
                "Cook": "v,0,43,0,l,0,p9,0,q0,0,2v|v,0,l,0,8d,0,3fj,0,59,0,8j,0,l,0,p9,0,2v||",
                "Cuba": "v,0,l,0,43,0,59,0,34|v,0,l,0,cj,0,l,0,34||",
                "Davis": "v,0,l,0,5s|||",
                "DumontDUrville": "v,0,l,0,5b,5,5j|||",
                "East_Timor": "v,0,l,0,7n,0,mn|||",
                "Easter": "v,0,43,0,l,0,13r,0,11t,0,23f|v,0,l,0,8d,0,59,0,8j,0,l,0,13r,0,11t,0,23f||",
                "Ecuador": "v,0,l,0,ai|||",
                "Europe_Central": "v,0,43,0,l,0,114,0,59,0,3fg|v,0,l,0,8d,0,59,0,8j,0,l,0,114,0,59,0,ps||",
                "Europe_Eastern": "v,0,43,0,l,0,mn,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,mn,0,oc,0,114||",
                "Europe_Further_Eastern": "v,0,l,0,bu,5,c0,0,18,0,1|||",
                "Europe_Western": "v,0,43,0,l,0,hu,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,114||",
                "Falkland": "v,0,43,0,l,0,p9,0,q0,0,4v|v,0,l,0,8d,0,59,0,8j,0,l,0,p9,0,q0,0,4v||",
                "Fiji": "v,0,43,0,l,0,4q|v,0,l,0,8d,0,59,0,8j,0,l,0,4q||",
                "French_Guiana": "v,0,l,0,am,0,59,0,23h|||",
                "French_Southern": "v,0,l,0,1f3,0,oc,0,23h,0,52,0,3fe|||",
                "Galapagos": "v,0,l,0,ak|||",
                "Gambier": "v,0,l,0,6v|||",
                "Georgia": "v,0,43,0,l,0,1f7|v,0,l,0,8d,0,59,0,8j,0,l,0,1f7||",
                "Gilbert_Islands": "v,0,l,0,p9,0,q0,0,6q|||",
                "GMT": "v,0,l,0,5u|||",
                "Greenland_Eastern": "v,0,l,0,43,0,l,0,2k,0,mn|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,mn||",
                "Greenland_Western": "v,0,l,0,43,0,l,0,2k,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,hu||",
                "Gulf": "v,0,43,0,l,0,bn|||",
                "Guyana": "v,0,l,0,7a|||",
                "Hawaii_Aleutian": "v,0,l,0,43,0,l,0,4g,5,62|v,0,l,0,cj,0,l,0,4g,5,62||",
                "Hong_Kong": "v,0,43,0,l,0,2l,0,2p|v,0,l,0,8d,0,59,0,8j,0,l,0,2l,0,2p||",
                "Hovd": "v,0,43,0,l,0,2g|v,0,l,0,8d,0,59,0,8j,0,l,0,2g||",
                "India": "v,0,43,0,l,0,af|||",
                "Indian_Ocean": "v,0,l,0,3fc,0,1to|||",
                "Indochina": "v,0,l,0,9p|||",
                "Indonesia_Central": "v,0,l,0,2t,0,59,0,ps|||",
                "Indonesia_Eastern": "v,0,l,0,mn,0,oc,0,2t|||",
                "Indonesia_Western": "v,0,l,0,hu,0,oc,0,2t|||",
                "Iran": "v,0,43,0,l,0,5g|v,0,l,0,cj,0,l,0,5g||",
                "Irkutsk": "v,0,l,0,43,0,l,0,3h|v,0,l,0,8d,0,59,0,8j,0,l,0,3h||",
                "Israel": "v,0,43,0,l,0,23k|v,0,l,0,cj,0,l,0,23k||",
                "Japan": "v,0,43,0,l,0,6o|v,0,l,0,cj,0,l,0,6o||",
                "Kamchatka": "v,0,l,0,43,0,l,0,37,5,3k|v,0,l,0,1f4,0,l,0,37,5,3k||",
                "Kazakhstan_Eastern": "v,0,l,0,45,0,mn|||",
                "Kazakhstan_Western": "v,0,l,0,45,0,hu|||",
                "Korea": "v,0,43,0,l,0,qf|v,0,l,0,cj,0,l,0,qf||",
                "Kosrae": "v,0,l,0,6f|||",
                "Krasnoyarsk": "v,0,l,0,43,0,l,0,3fa|v,0,l,0,8d,0,59,0,8j,0,l,0,41||",
                "Kyrgystan": "v,0,l,0,bl|||",
                "Line_Islands": "v,0,l,0,p9,0,q0,0,ac|||",
                "Lord_Howe": "v,0,43,0,l,0,1u,0,24|v,0,l,0,cj,0,l,0,1u,0,24||",
                "Macquarie": "v,0,l,0,3f9,0,11t,0,6m|||",
                "Magadan": "v,0,l,0,43,0,l,0,2o|v,0,l,0,8d,0,59,0,8j,0,l,0,2o||",
                "Malaysia": "v,0,l,0,bf|||",
                "Maldives": "v,0,l,0,9k|||",
                "Marquesas": "v,0,l,0,9e|||",
                "Marshall_Islands": "v,0,l,0,p9,0,q0,0,7o|||",
                "Mauritius": "v,0,l,0,43,0,l,0,4u|v,0,l,0,8d,0,59,0,8j,0,l,0,4u||",
                "Mawson": "v,0,l,0,63|||",
                "Mexico_Northwest": "v,0,43,0,l,0,5e,0,23l,0,hu|v,0,l,0,23m,0,l,0,5e,0,23l,0,hu||",
                "Mexico_Pacific": "v,0,l,0,3f6,0,l,0,23n,0,l,0,5e|v,0,l,0,23m,0,l,0,23n,0,l,0,5e||",
                "Mongolia": "v,0,43,0,l,0,4f,0,2m|v,0,l,0,8d,0,59,0,8j,0,l,0,4f,0,2m||",
                "Moscow": "v,0,l,0,43,0,l,0,71|v,0,l,0,8d,0,59,0,8j,0,l,0,71||",
                "Myanmar": "v,0,l,0,8v|||",
                "Nauru": "v,0,l,0,5v|||",
                "Nepal": "v,0,l,0,8u|||",
                "New_Caledonia": "v,0,43,0,l,0,1m,0,4o|v,0,l,0,8d,0,59,0,8j,0,l,0,1m,0,4o||",
                "New_Zealand": "v,0,43,0,l,0,1m,0,74|v,0,l,0,cj,0,l,0,1m,0,74||",
                "Newfoundland": "v,0,l,0,43,0,l,0,53|v,0,l,0,cj,0,l,0,53||",
                "Niue": "v,0,l,0,8g|||",
                "Norfolk": "v,0,l,0,13r,0,11t,0,6l|||",
                "Noronha": "v,0,43,0,l,0,1s,0,2,0,23|v,0,l,0,8d,0,59,0,8j,0,l,0,1s,0,2,0,23||",
                "Novosibirsk": "v,0,l,0,43,0,l,0,3b|v,0,l,0,8d,0,59,0,8j,0,l,0,3b||",
                "Omsk": "v,0,l,0,43,0,l,0,26|v,0,l,0,8d,0,59,0,8j,0,l,0,26||",
                "Pakistan": "v,0,43,0,l,0,3i|v,0,l,0,8d,0,59,0,8j,0,l,0,3i||",
                "Palau": "v,0,l,0,9b|||",
                "Papua_New_Guinea": "v,0,l,0,9a,0,1m,0,a8|||",
                "Paraguay": "v,0,l,0,43,0,l,0,3c|v,0,l,0,8d,0,59,0,8j,0,l,0,3c||",
                "Peru": "v,0,l,0,43,0,l,0,4n|v,0,l,0,8d,0,59,0,8j,0,l,0,4n||",
                "Philippines": "v,0,43,0,l,0,23p|v,0,l,0,8d,0,59,0,8j,0,l,0,23p||",
                "Phoenix_Islands": "v,0,l,0,p9,0,q0,0,90|||",
                "Pierre_Miquelon": "v,0,l,0,43,0,59,0,8i,5,33,0,52,0,35|v,0,l,0,cj,0,l,0,8i,5,33,0,52,0,35||",
                "Pitcairn": "v,0,l,0,7e|||",
                "Ponape": "v,0,l,0,9s|||",
                "Pyongyang": "v,0,l,0,8a|||",
                "Reunion": "v,0,l,0,b4|||",
                "Rothera": "v,0,l,0,5q|||",
                "Sakhalin": "v,0,l,0,43,0,l,0,55|v,0,l,0,8d,0,59,0,8j,0,l,0,55||",
                "Samara": "v,0,l,0,43,0,l,0,29|v,0,l,0,1f4,0,l,0,29||",
                "Samoa": "v,0,43,0,l,0,2c|v,0,l,0,8d,0,59,0,8j,0,l,0,2c||",
                "Seychelles": "v,0,l,0,3f3|||",
                "Singapore": "v,0,43,0,l,0,bi|||",
                "Solomon": "v,0,l,0,p9,0,q0,0,b5|||",
                "South_Georgia": "v,0,l,0,1f7,0,1f3|||",
                "Suriname": "v,0,l,0,8q|||",
                "Syowa": "v,0,l,0,65|||",
                "Tahiti": "v,0,l,0,8n|||",
                "Taipei": "v,0,43,0,l,0,3d|v,0,l,0,cj,0,l,0,3d||",
                "Tajikistan": "v,0,l,0,bj|||",
                "Tokelau": "v,0,l,0,5d|||",
                "Tonga": "v,0,43,0,l,0,2j|v,0,l,0,8d,0,59,0,8j,0,l,0,2j||",
                "Truk": "v,0,l,0,6p|||",
                "Turkmenistan": "v,0,l,0,43,0,l,0,4t|v,0,l,0,8d,0,59,0,8j,0,l,0,4t||",
                "Tuvalu": "v,0,l,0,6h|||",
                "Uruguay": "v,0,l,0,43,0,l,0,4k|v,0,l,0,8d,0,59,0,8j,0,l,0,4k||",
                "Uzbekistan": "v,0,l,0,43,0,l,0,60|v,0,l,0,8d,0,59,0,8j,0,l,0,60||",
                "Vanuatu": "v,0,43,0,l,0,2f|v,0,l,0,8d,0,59,0,8j,0,l,0,2f||",
                "Venezuela": "v,0,l,0,7s|||",
                "Vladivostok": "v,0,l,0,43,0,l,0,28|v,0,l,0,8d,0,59,0,8j,0,l,0,28||",
                "Volgograd": "v,0,l,0,43,0,l,0,3f|v,0,l,0,8d,0,59,0,8j,0,l,0,3f||",
                "Vostok": "v,0,l,0,5t|||",
                "Wake": "v,0,l,0,13r,0,11t,0,5r|||",
                "Wallis": "v,0,l,0,5f,0,52,0,5k|||",
                "Yakutsk": "v,0,l,0,43,0,l,0,3u|v,0,l,0,8d,0,59,0,8j,0,l,0,3u||",
                "Yekaterinburg": "v,0,l,0,43,0,l,0,5l|v,0,l,0,8d,0,59,0,8j,0,l,0,5l||"
            }
        },
        "sw-KE": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3et||",
                "Europe/London": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3ae||"
            },
            "metazone": {
                "Afghanistan": "v,0,l,0,b6|||",
                "Africa_Central": "v,0,l,0,c5,0,59,0,ps|||",
                "Africa_Eastern": "v,0,l,0,c5,0,mn|||",
                "Africa_Southern": "v,0,43,0,l,0,c5,0,1f3|||",
                "Africa_Western": "v,0,l,0,43,0,l,0,c5,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,c5,0,hu||",
                "Alaska": "v,0,l,0,43,0,l,0,3p|v,0,l,0,cj,0,l,0,3p||",
                "Amazon": "v,0,l,0,43,0,l,0,5m|v,0,l,0,8d,0,59,0,8j,0,l,0,5m||",
                "America_Central": "v,0,l,0,43,0,l,0,ps|v,0,l,0,cj,0,l,0,ps||",
                "America_Eastern": "v,0,l,0,43,0,l,0,mn|v,0,l,0,cj,0,l,0,mn||",
                "America_Mountain": "v,0,l,0,43,0,l,0,5a|v,0,l,0,cj,0,l,0,5a||",
                "America_Pacific": "v,0,l,0,43,0,l,0,22s|v,0,l,0,cj,0,l,0,22s||",
                "Anadyr": "v,0,l,0,43,0,l,0,3l|v,0,l,0,1f4,0,l,0,3l||",
                "Apia": "v,0,43,0,l,0,3e|v,0,l,0,cj,0,l,0,3e||",
                "Arabian": "v,0,43,0,l,0,3ft|v,0,l,0,cj,0,l,0,3fs||",
                "Argentina": "v,0,l,0,43,0,l,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,1e||",
                "Argentina_Western": "v,0,43,0,l,0,hu,0,oc,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,1e||",
                "Armenia": "v,0,43,0,l,0,4l|v,0,l,0,8d,0,59,0,8j,0,l,0,4l||",
                "Atlantic": "v,0,l,0,43,0,l,0,230|v,0,l,0,cj,0,l,0,230||",
                "Australia_Central": "v,0,43,0,l,0,4c,0,59,0,ps|v,0,l,0,cj,0,l,0,4c,0,59,0,ps||",
                "Australia_CentralWestern": "v,0,43,0,l,0,hu,0,59,0,ps,0,59,0,4c|v,0,l,0,cj,0,l,0,hu,0,59,0,ps,0,59,0,4c||",
                "Australia_Eastern": "v,0,43,0,l,0,mn,0,oc,0,4c|v,0,l,0,cj,0,l,0,mn,0,oc,0,4c||",
                "Australia_Western": "v,0,43,0,l,0,4c,0,hu|v,0,l,0,cj,0,l,0,4c,0,hu||",
                "Azerbaijan": "v,0,43,0,l,0,232|v,0,l,0,8d,0,59,0,8j,0,l,0,232||",
                "Azores": "v,0,43,0,l,0,4r|v,0,l,0,8d,0,59,0,8j,0,l,0,4r||",
                "Bangladesh": "v,0,43,0,l,0,3n|v,0,l,0,8d,0,59,0,8j,0,l,0,3n||",
                "Bhutan": "v,0,l,0,as|||",
                "Bolivia": "v,0,l,0,aa|||",
                "Brasilia": "v,0,l,0,43,0,l,0,3a|v,0,l,0,8d,0,59,0,8j,0,l,0,3a||",
                "Brunei": "v,0,l,0,9o,0,a4|||",
                "Cape_Verde": "v,0,l,0,43,0,l,0,7c,0,3j|v,0,l,0,8d,0,59,0,8j,0,l,0,7c,0,3j||",
                "Chamorro": "v,0,43,0,l,0,6j|||",
                "Chatham": "v,0,43,0,l,0,27|v,0,l,0,cj,0,l,0,27||",
                "Chile": "v,0,l,0,43,0,l,0,49|v,0,l,0,8d,0,59,0,8j,0,l,0,49||",
                "China": "v,0,43,0,l,0,233|v,0,l,0,cj,0,l,0,233||",
                "Choibalsan": "v,0,43,0,l,0,2q|v,0,l,0,8d,0,59,0,8j,0,l,0,2q||",
                "Christmas": "v,0,l,0,13r,0,11t,0,99|||",
                "Cocos": "v,0,l,0,p9,0,q0,0,7v|||",
                "Colombia": "v,0,l,0,43,0,l,0,4m|v,0,l,0,8d,0,59,0,8j,0,l,0,4m||",
                "Cook": "v,0,43,0,l,0,p9,0,q0,0,2v|v,0,l,0,8d,0,3fj,0,59,0,8j,0,l,0,p9,0,2v||",
                "Cuba": "v,0,l,0,43,0,59,0,34|v,0,l,0,cj,0,l,0,34||",
                "Davis": "v,0,l,0,5s|||",
                "DumontDUrville": "v,0,l,0,5b,5,5j|||",
                "East_Timor": "v,0,l,0,7n,0,mn|||",
                "Easter": "v,0,43,0,l,0,13r,0,11t,0,23f|v,0,l,0,8d,0,59,0,8j,0,l,0,13r,0,11t,0,23f||",
                "Ecuador": "v,0,l,0,ai|||",
                "Europe_Central": "v,0,43,0,l,0,114,0,59,0,3fg|v,0,l,0,8d,0,59,0,8j,0,l,0,114,0,59,0,ps||",
                "Europe_Eastern": "v,0,43,0,l,0,mn,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,mn,0,oc,0,114||",
                "Europe_Further_Eastern": "v,0,l,0,bu,5,c0,0,18,0,1|||",
                "Europe_Western": "v,0,43,0,l,0,hu,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,114||",
                "Falkland": "v,0,43,0,l,0,p9,0,q0,0,4v|v,0,l,0,8d,0,59,0,8j,0,l,0,p9,0,q0,0,4v||",
                "Fiji": "v,0,43,0,l,0,4q|v,0,l,0,8d,0,59,0,8j,0,l,0,4q||",
                "French_Guiana": "v,0,l,0,am,0,59,0,23h|||",
                "French_Southern": "v,0,l,0,1f3,0,oc,0,23h,0,52,0,3fe|||",
                "Galapagos": "v,0,l,0,ak|||",
                "Gambier": "v,0,l,0,6v|||",
                "Georgia": "v,0,43,0,l,0,1f7|v,0,l,0,8d,0,59,0,8j,0,l,0,1f7||",
                "Gilbert_Islands": "v,0,l,0,p9,0,q0,0,6q|||",
                "GMT": "v,0,l,0,5u|||",
                "Greenland_Eastern": "v,0,l,0,43,0,l,0,2k,0,mn|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,mn||",
                "Greenland_Western": "v,0,l,0,43,0,l,0,2k,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,hu||",
                "Gulf": "v,0,43,0,l,0,bn|||",
                "Guyana": "v,0,l,0,7a|||",
                "Hawaii_Aleutian": "v,0,l,0,43,0,l,0,4g,5,62|v,0,l,0,cj,0,l,0,4g,5,62||",
                "Hong_Kong": "v,0,43,0,l,0,2l,0,2p|v,0,l,0,8d,0,59,0,8j,0,l,0,2l,0,2p||",
                "Hovd": "v,0,43,0,l,0,2g|v,0,l,0,8d,0,59,0,8j,0,l,0,2g||",
                "India": "v,0,43,0,l,0,af|||",
                "Indian_Ocean": "v,0,l,0,3fc,0,1to|||",
                "Indochina": "v,0,l,0,9p|||",
                "Indonesia_Central": "v,0,l,0,2t,0,59,0,ps|||",
                "Indonesia_Eastern": "v,0,l,0,mn,0,oc,0,2t|||",
                "Indonesia_Western": "v,0,l,0,hu,0,oc,0,2t|||",
                "Iran": "v,0,43,0,l,0,5g|v,0,l,0,cj,0,l,0,5g||",
                "Irkutsk": "v,0,l,0,43,0,l,0,3h|v,0,l,0,8d,0,59,0,8j,0,l,0,3h||",
                "Israel": "v,0,43,0,l,0,23k|v,0,l,0,cj,0,l,0,23k||",
                "Japan": "v,0,43,0,l,0,6o|v,0,l,0,cj,0,l,0,6o||",
                "Kamchatka": "v,0,l,0,43,0,l,0,37,5,3k|v,0,l,0,1f4,0,l,0,37,5,3k||",
                "Kazakhstan_Eastern": "v,0,l,0,45,0,mn|||",
                "Kazakhstan_Western": "v,0,l,0,45,0,hu|||",
                "Korea": "v,0,43,0,l,0,qf|v,0,l,0,cj,0,l,0,qf||",
                "Kosrae": "v,0,l,0,6f|||",
                "Krasnoyarsk": "v,0,l,0,43,0,l,0,3fa|v,0,l,0,8d,0,59,0,8j,0,l,0,41||",
                "Kyrgystan": "v,0,l,0,bl|||",
                "Line_Islands": "v,0,l,0,p9,0,q0,0,ac|||",
                "Lord_Howe": "v,0,43,0,l,0,1u,0,24|v,0,l,0,cj,0,l,0,1u,0,24||",
                "Macquarie": "v,0,l,0,3f9,0,11t,0,6m|||",
                "Magadan": "v,0,l,0,43,0,l,0,2o|v,0,l,0,8d,0,59,0,8j,0,l,0,2o||",
                "Malaysia": "v,0,l,0,bf|||",
                "Maldives": "v,0,l,0,9k|||",
                "Marquesas": "v,0,l,0,9e|||",
                "Marshall_Islands": "v,0,l,0,p9,0,q0,0,7o|||",
                "Mauritius": "v,0,l,0,43,0,l,0,4u|v,0,l,0,8d,0,59,0,8j,0,l,0,4u||",
                "Mawson": "v,0,l,0,63|||",
                "Mexico_Northwest": "v,0,43,0,l,0,5e,0,23l,0,hu|v,0,l,0,23m,0,l,0,5e,0,23l,0,hu||",
                "Mexico_Pacific": "v,0,l,0,3f6,0,l,0,23n,0,l,0,5e|v,0,l,0,23m,0,l,0,23n,0,l,0,5e||",
                "Mongolia": "v,0,43,0,l,0,4f,0,2m|v,0,l,0,8d,0,59,0,8j,0,l,0,4f,0,2m||",
                "Moscow": "v,0,l,0,43,0,l,0,71|v,0,l,0,8d,0,59,0,8j,0,l,0,71||",
                "Myanmar": "v,0,l,0,8v|||",
                "Nauru": "v,0,l,0,5v|||",
                "Nepal": "v,0,l,0,8u|||",
                "New_Caledonia": "v,0,43,0,l,0,1m,0,4o|v,0,l,0,8d,0,59,0,8j,0,l,0,1m,0,4o||",
                "New_Zealand": "v,0,43,0,l,0,1m,0,74|v,0,l,0,cj,0,l,0,1m,0,74||",
                "Newfoundland": "v,0,l,0,43,0,l,0,53|v,0,l,0,cj,0,l,0,53||",
                "Niue": "v,0,l,0,8g|||",
                "Norfolk": "v,0,l,0,13r,0,11t,0,6l|||",
                "Noronha": "v,0,43,0,l,0,1s,0,2,0,23|v,0,l,0,8d,0,59,0,8j,0,l,0,1s,0,2,0,23||",
                "Novosibirsk": "v,0,l,0,43,0,l,0,3b|v,0,l,0,8d,0,59,0,8j,0,l,0,3b||",
                "Omsk": "v,0,l,0,43,0,l,0,26|v,0,l,0,8d,0,59,0,8j,0,l,0,26||",
                "Pakistan": "v,0,43,0,l,0,3i|v,0,l,0,8d,0,59,0,8j,0,l,0,3i||",
                "Palau": "v,0,l,0,9b|||",
                "Papua_New_Guinea": "v,0,l,0,9a,0,1m,0,a8|||",
                "Paraguay": "v,0,l,0,43,0,l,0,3c|v,0,l,0,8d,0,59,0,8j,0,l,0,3c||",
                "Peru": "v,0,l,0,43,0,l,0,4n|v,0,l,0,8d,0,59,0,8j,0,l,0,4n||",
                "Philippines": "v,0,43,0,l,0,23p|v,0,l,0,8d,0,59,0,8j,0,l,0,23p||",
                "Phoenix_Islands": "v,0,l,0,p9,0,q0,0,90|||",
                "Pierre_Miquelon": "v,0,l,0,43,0,59,0,8i,5,33,0,52,0,35|v,0,l,0,cj,0,l,0,8i,5,33,0,52,0,35||",
                "Pitcairn": "v,0,l,0,7e|||",
                "Ponape": "v,0,l,0,9s|||",
                "Pyongyang": "v,0,l,0,8a|||",
                "Reunion": "v,0,l,0,b4|||",
                "Rothera": "v,0,l,0,5q|||",
                "Sakhalin": "v,0,l,0,43,0,l,0,55|v,0,l,0,8d,0,59,0,8j,0,l,0,55||",
                "Samara": "v,0,l,0,43,0,l,0,29|v,0,l,0,1f4,0,l,0,29||",
                "Samoa": "v,0,43,0,l,0,2c|v,0,l,0,8d,0,59,0,8j,0,l,0,2c||",
                "Seychelles": "v,0,l,0,3f3|||",
                "Singapore": "v,0,43,0,l,0,bi|||",
                "Solomon": "v,0,l,0,p9,0,q0,0,b5|||",
                "South_Georgia": "v,0,l,0,1f7,0,1f3|||",
                "Suriname": "v,0,l,0,8q|||",
                "Syowa": "v,0,l,0,65|||",
                "Tahiti": "v,0,l,0,8n|||",
                "Taipei": "v,0,43,0,l,0,3d|v,0,l,0,cj,0,l,0,3d||",
                "Tajikistan": "v,0,l,0,bj|||",
                "Tokelau": "v,0,l,0,5d|||",
                "Tonga": "v,0,43,0,l,0,2j|v,0,l,0,8d,0,59,0,8j,0,l,0,2j||",
                "Truk": "v,0,l,0,6p|||",
                "Turkmenistan": "v,0,l,0,43,0,l,0,4t|v,0,l,0,8d,0,59,0,8j,0,l,0,4t||",
                "Tuvalu": "v,0,l,0,6h|||",
                "Uruguay": "v,0,l,0,43,0,l,0,4k|v,0,l,0,8d,0,59,0,8j,0,l,0,4k||",
                "Uzbekistan": "v,0,l,0,43,0,l,0,60|v,0,l,0,8d,0,59,0,8j,0,l,0,60||",
                "Vanuatu": "v,0,43,0,l,0,2f|v,0,l,0,8d,0,59,0,8j,0,l,0,2f||",
                "Venezuela": "v,0,l,0,7s|||",
                "Vladivostok": "v,0,l,0,43,0,l,0,28|v,0,l,0,8d,0,59,0,8j,0,l,0,28||",
                "Volgograd": "v,0,l,0,43,0,l,0,3f|v,0,l,0,8d,0,59,0,8j,0,l,0,3f||",
                "Vostok": "v,0,l,0,5t|||",
                "Wake": "v,0,l,0,13r,0,11t,0,5r|||",
                "Wallis": "v,0,l,0,5f,0,52,0,5k|||",
                "Yakutsk": "v,0,l,0,43,0,l,0,3u|v,0,l,0,8d,0,59,0,8j,0,l,0,3u||",
                "Yekaterinburg": "v,0,l,0,43,0,l,0,5l|v,0,l,0,8d,0,59,0,8j,0,l,0,5l||"
            }
        },
        "sw-UG": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3et||",
                "Europe/London": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3ae||"
            },
            "metazone": {
                "Afghanistan": "v,0,l,0,b6|||",
                "Africa_Central": "v,0,l,0,c5,0,59,0,ps|||",
                "Africa_Eastern": "v,0,l,0,c5,0,mn|||",
                "Africa_Southern": "v,0,43,0,l,0,c5,0,1f3|||",
                "Africa_Western": "v,0,l,0,43,0,l,0,c5,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,c5,0,hu||",
                "Alaska": "v,0,l,0,43,0,l,0,3p|v,0,l,0,cj,0,l,0,3p||",
                "Amazon": "v,0,l,0,43,0,l,0,5m|v,0,l,0,8d,0,59,0,8j,0,l,0,5m||",
                "America_Central": "v,0,l,0,43,0,l,0,ps|v,0,l,0,cj,0,l,0,ps||",
                "America_Eastern": "v,0,l,0,43,0,l,0,mn|v,0,l,0,cj,0,l,0,mn||",
                "America_Mountain": "v,0,l,0,43,0,l,0,5a|v,0,l,0,cj,0,l,0,5a||",
                "America_Pacific": "v,0,l,0,43,0,l,0,22s|v,0,l,0,cj,0,l,0,22s||",
                "Anadyr": "v,0,l,0,43,0,l,0,3l|v,0,l,0,1f4,0,l,0,3l||",
                "Apia": "v,0,43,0,l,0,3e|v,0,l,0,cj,0,l,0,3e||",
                "Arabian": "v,0,43,0,l,0,3ft|v,0,l,0,cj,0,l,0,3fs||",
                "Argentina": "v,0,l,0,43,0,l,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,1e||",
                "Argentina_Western": "v,0,43,0,l,0,hu,0,oc,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,1e||",
                "Armenia": "v,0,43,0,l,0,4l|v,0,l,0,8d,0,59,0,8j,0,l,0,4l||",
                "Atlantic": "v,0,l,0,43,0,l,0,230|v,0,l,0,cj,0,l,0,230||",
                "Australia_Central": "v,0,43,0,l,0,4c,0,59,0,ps|v,0,l,0,cj,0,l,0,4c,0,59,0,ps||",
                "Australia_CentralWestern": "v,0,43,0,l,0,hu,0,59,0,ps,0,59,0,4c|v,0,l,0,cj,0,l,0,hu,0,59,0,ps,0,59,0,4c||",
                "Australia_Eastern": "v,0,43,0,l,0,mn,0,oc,0,4c|v,0,l,0,cj,0,l,0,mn,0,oc,0,4c||",
                "Australia_Western": "v,0,43,0,l,0,4c,0,hu|v,0,l,0,cj,0,l,0,4c,0,hu||",
                "Azerbaijan": "v,0,43,0,l,0,232|v,0,l,0,8d,0,59,0,8j,0,l,0,232||",
                "Azores": "v,0,43,0,l,0,4r|v,0,l,0,8d,0,59,0,8j,0,l,0,4r||",
                "Bangladesh": "v,0,43,0,l,0,3n|v,0,l,0,8d,0,59,0,8j,0,l,0,3n||",
                "Bhutan": "v,0,l,0,as|||",
                "Bolivia": "v,0,l,0,aa|||",
                "Brasilia": "v,0,l,0,43,0,l,0,3a|v,0,l,0,8d,0,59,0,8j,0,l,0,3a||",
                "Brunei": "v,0,l,0,9o,0,a4|||",
                "Cape_Verde": "v,0,l,0,43,0,l,0,7c,0,3j|v,0,l,0,8d,0,59,0,8j,0,l,0,7c,0,3j||",
                "Chamorro": "v,0,43,0,l,0,6j|||",
                "Chatham": "v,0,43,0,l,0,27|v,0,l,0,cj,0,l,0,27||",
                "Chile": "v,0,l,0,43,0,l,0,49|v,0,l,0,8d,0,59,0,8j,0,l,0,49||",
                "China": "v,0,43,0,l,0,233|v,0,l,0,cj,0,l,0,233||",
                "Choibalsan": "v,0,43,0,l,0,2q|v,0,l,0,8d,0,59,0,8j,0,l,0,2q||",
                "Christmas": "v,0,l,0,13r,0,11t,0,99|||",
                "Cocos": "v,0,l,0,p9,0,q0,0,7v|||",
                "Colombia": "v,0,l,0,43,0,l,0,4m|v,0,l,0,8d,0,59,0,8j,0,l,0,4m||",
                "Cook": "v,0,43,0,l,0,p9,0,q0,0,2v|v,0,l,0,8d,0,3fj,0,59,0,8j,0,l,0,p9,0,2v||",
                "Cuba": "v,0,l,0,43,0,59,0,34|v,0,l,0,cj,0,l,0,34||",
                "Davis": "v,0,l,0,5s|||",
                "DumontDUrville": "v,0,l,0,5b,5,5j|||",
                "East_Timor": "v,0,l,0,7n,0,mn|||",
                "Easter": "v,0,43,0,l,0,13r,0,11t,0,23f|v,0,l,0,8d,0,59,0,8j,0,l,0,13r,0,11t,0,23f||",
                "Ecuador": "v,0,l,0,ai|||",
                "Europe_Central": "v,0,43,0,l,0,114,0,59,0,3fg|v,0,l,0,8d,0,59,0,8j,0,l,0,114,0,59,0,ps||",
                "Europe_Eastern": "v,0,43,0,l,0,mn,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,mn,0,oc,0,114||",
                "Europe_Further_Eastern": "v,0,l,0,bu,5,c0,0,18,0,1|||",
                "Europe_Western": "v,0,43,0,l,0,hu,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,114||",
                "Falkland": "v,0,43,0,l,0,p9,0,q0,0,4v|v,0,l,0,8d,0,59,0,8j,0,l,0,p9,0,q0,0,4v||",
                "Fiji": "v,0,43,0,l,0,4q|v,0,l,0,8d,0,59,0,8j,0,l,0,4q||",
                "French_Guiana": "v,0,l,0,am,0,59,0,23h|||",
                "French_Southern": "v,0,l,0,1f3,0,oc,0,23h,0,52,0,3fe|||",
                "Galapagos": "v,0,l,0,ak|||",
                "Gambier": "v,0,l,0,6v|||",
                "Georgia": "v,0,43,0,l,0,1f7|v,0,l,0,8d,0,59,0,8j,0,l,0,1f7||",
                "Gilbert_Islands": "v,0,l,0,p9,0,q0,0,6q|||",
                "GMT": "v,0,l,0,5u|||",
                "Greenland_Eastern": "v,0,l,0,43,0,l,0,2k,0,mn|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,mn||",
                "Greenland_Western": "v,0,l,0,43,0,l,0,2k,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,hu||",
                "Gulf": "v,0,43,0,l,0,bn|||",
                "Guyana": "v,0,l,0,7a|||",
                "Hawaii_Aleutian": "v,0,l,0,43,0,l,0,4g,5,62|v,0,l,0,cj,0,l,0,4g,5,62||",
                "Hong_Kong": "v,0,43,0,l,0,2l,0,2p|v,0,l,0,8d,0,59,0,8j,0,l,0,2l,0,2p||",
                "Hovd": "v,0,43,0,l,0,2g|v,0,l,0,8d,0,59,0,8j,0,l,0,2g||",
                "India": "v,0,43,0,l,0,af|||",
                "Indian_Ocean": "v,0,l,0,3fc,0,1to|||",
                "Indochina": "v,0,l,0,9p|||",
                "Indonesia_Central": "v,0,l,0,2t,0,59,0,ps|||",
                "Indonesia_Eastern": "v,0,l,0,mn,0,oc,0,2t|||",
                "Indonesia_Western": "v,0,l,0,hu,0,oc,0,2t|||",
                "Iran": "v,0,43,0,l,0,5g|v,0,l,0,cj,0,l,0,5g||",
                "Irkutsk": "v,0,l,0,43,0,l,0,3h|v,0,l,0,8d,0,59,0,8j,0,l,0,3h||",
                "Israel": "v,0,43,0,l,0,23k|v,0,l,0,cj,0,l,0,23k||",
                "Japan": "v,0,43,0,l,0,6o|v,0,l,0,cj,0,l,0,6o||",
                "Kamchatka": "v,0,l,0,43,0,l,0,37,5,3k|v,0,l,0,1f4,0,l,0,37,5,3k||",
                "Kazakhstan_Eastern": "v,0,l,0,45,0,mn|||",
                "Kazakhstan_Western": "v,0,l,0,45,0,hu|||",
                "Korea": "v,0,43,0,l,0,qf|v,0,l,0,cj,0,l,0,qf||",
                "Kosrae": "v,0,l,0,6f|||",
                "Krasnoyarsk": "v,0,l,0,43,0,l,0,3fa|v,0,l,0,8d,0,59,0,8j,0,l,0,41||",
                "Kyrgystan": "v,0,l,0,bl|||",
                "Line_Islands": "v,0,l,0,p9,0,q0,0,ac|||",
                "Lord_Howe": "v,0,43,0,l,0,1u,0,24|v,0,l,0,cj,0,l,0,1u,0,24||",
                "Macquarie": "v,0,l,0,3f9,0,11t,0,6m|||",
                "Magadan": "v,0,l,0,43,0,l,0,2o|v,0,l,0,8d,0,59,0,8j,0,l,0,2o||",
                "Malaysia": "v,0,l,0,bf|||",
                "Maldives": "v,0,l,0,9k|||",
                "Marquesas": "v,0,l,0,9e|||",
                "Marshall_Islands": "v,0,l,0,p9,0,q0,0,7o|||",
                "Mauritius": "v,0,l,0,43,0,l,0,4u|v,0,l,0,8d,0,59,0,8j,0,l,0,4u||",
                "Mawson": "v,0,l,0,63|||",
                "Mexico_Northwest": "v,0,43,0,l,0,5e,0,23l,0,hu|v,0,l,0,23m,0,l,0,5e,0,23l,0,hu||",
                "Mexico_Pacific": "v,0,l,0,3f6,0,l,0,23n,0,l,0,5e|v,0,l,0,23m,0,l,0,23n,0,l,0,5e||",
                "Mongolia": "v,0,43,0,l,0,4f,0,2m|v,0,l,0,8d,0,59,0,8j,0,l,0,4f,0,2m||",
                "Moscow": "v,0,l,0,43,0,l,0,71|v,0,l,0,8d,0,59,0,8j,0,l,0,71||",
                "Myanmar": "v,0,l,0,8v|||",
                "Nauru": "v,0,l,0,5v|||",
                "Nepal": "v,0,l,0,8u|||",
                "New_Caledonia": "v,0,43,0,l,0,1m,0,4o|v,0,l,0,8d,0,59,0,8j,0,l,0,1m,0,4o||",
                "New_Zealand": "v,0,43,0,l,0,1m,0,74|v,0,l,0,cj,0,l,0,1m,0,74||",
                "Newfoundland": "v,0,l,0,43,0,l,0,53|v,0,l,0,cj,0,l,0,53||",
                "Niue": "v,0,l,0,8g|||",
                "Norfolk": "v,0,l,0,13r,0,11t,0,6l|||",
                "Noronha": "v,0,43,0,l,0,1s,0,2,0,23|v,0,l,0,8d,0,59,0,8j,0,l,0,1s,0,2,0,23||",
                "Novosibirsk": "v,0,l,0,43,0,l,0,3b|v,0,l,0,8d,0,59,0,8j,0,l,0,3b||",
                "Omsk": "v,0,l,0,43,0,l,0,26|v,0,l,0,8d,0,59,0,8j,0,l,0,26||",
                "Pakistan": "v,0,43,0,l,0,3i|v,0,l,0,8d,0,59,0,8j,0,l,0,3i||",
                "Palau": "v,0,l,0,9b|||",
                "Papua_New_Guinea": "v,0,l,0,9a,0,1m,0,a8|||",
                "Paraguay": "v,0,l,0,43,0,l,0,3c|v,0,l,0,8d,0,59,0,8j,0,l,0,3c||",
                "Peru": "v,0,l,0,43,0,l,0,4n|v,0,l,0,8d,0,59,0,8j,0,l,0,4n||",
                "Philippines": "v,0,43,0,l,0,23p|v,0,l,0,8d,0,59,0,8j,0,l,0,23p||",
                "Phoenix_Islands": "v,0,l,0,p9,0,q0,0,90|||",
                "Pierre_Miquelon": "v,0,l,0,43,0,59,0,8i,5,33,0,52,0,35|v,0,l,0,cj,0,l,0,8i,5,33,0,52,0,35||",
                "Pitcairn": "v,0,l,0,7e|||",
                "Ponape": "v,0,l,0,9s|||",
                "Pyongyang": "v,0,l,0,8a|||",
                "Reunion": "v,0,l,0,b4|||",
                "Rothera": "v,0,l,0,5q|||",
                "Sakhalin": "v,0,l,0,43,0,l,0,55|v,0,l,0,8d,0,59,0,8j,0,l,0,55||",
                "Samara": "v,0,l,0,43,0,l,0,29|v,0,l,0,1f4,0,l,0,29||",
                "Samoa": "v,0,43,0,l,0,2c|v,0,l,0,8d,0,59,0,8j,0,l,0,2c||",
                "Seychelles": "v,0,l,0,3f3|||",
                "Singapore": "v,0,43,0,l,0,bi|||",
                "Solomon": "v,0,l,0,p9,0,q0,0,b5|||",
                "South_Georgia": "v,0,l,0,1f7,0,1f3|||",
                "Suriname": "v,0,l,0,8q|||",
                "Syowa": "v,0,l,0,65|||",
                "Tahiti": "v,0,l,0,8n|||",
                "Taipei": "v,0,43,0,l,0,3d|v,0,l,0,cj,0,l,0,3d||",
                "Tajikistan": "v,0,l,0,bj|||",
                "Tokelau": "v,0,l,0,5d|||",
                "Tonga": "v,0,43,0,l,0,2j|v,0,l,0,8d,0,59,0,8j,0,l,0,2j||",
                "Truk": "v,0,l,0,6p|||",
                "Turkmenistan": "v,0,l,0,43,0,l,0,4t|v,0,l,0,8d,0,59,0,8j,0,l,0,4t||",
                "Tuvalu": "v,0,l,0,6h|||",
                "Uruguay": "v,0,l,0,43,0,l,0,4k|v,0,l,0,8d,0,59,0,8j,0,l,0,4k||",
                "Uzbekistan": "v,0,l,0,43,0,l,0,60|v,0,l,0,8d,0,59,0,8j,0,l,0,60||",
                "Vanuatu": "v,0,43,0,l,0,2f|v,0,l,0,8d,0,59,0,8j,0,l,0,2f||",
                "Venezuela": "v,0,l,0,7s|||",
                "Vladivostok": "v,0,l,0,43,0,l,0,28|v,0,l,0,8d,0,59,0,8j,0,l,0,28||",
                "Volgograd": "v,0,l,0,43,0,l,0,3f|v,0,l,0,8d,0,59,0,8j,0,l,0,3f||",
                "Vostok": "v,0,l,0,5t|||",
                "Wake": "v,0,l,0,13r,0,11t,0,5r|||",
                "Wallis": "v,0,l,0,5f,0,52,0,5k|||",
                "Yakutsk": "v,0,l,0,43,0,l,0,3u|v,0,l,0,8d,0,59,0,8j,0,l,0,3u||",
                "Yekaterinburg": "v,0,l,0,43,0,l,0,5l|v,0,l,0,8d,0,59,0,8j,0,l,0,5l||"
            }
        },
        "sw": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3et||",
                "Europe/London": "|1r7,0,18p,0,8d,0,59,0,1r3,0,18p,0,3ae||"
            },
            "metazone": {
                "Afghanistan": "v,0,l,0,b6|||",
                "Africa_Central": "v,0,l,0,c5,0,59,0,ps|||",
                "Africa_Eastern": "v,0,l,0,c5,0,mn|||",
                "Africa_Southern": "v,0,43,0,l,0,c5,0,1f3|||",
                "Africa_Western": "v,0,l,0,43,0,l,0,c5,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,c5,0,hu||",
                "Alaska": "v,0,l,0,43,0,l,0,3p|v,0,l,0,cj,0,l,0,3p||",
                "Amazon": "v,0,l,0,43,0,l,0,5m|v,0,l,0,8d,0,59,0,8j,0,l,0,5m||",
                "America_Central": "v,0,l,0,43,0,l,0,ps|v,0,l,0,cj,0,l,0,ps||",
                "America_Eastern": "v,0,l,0,43,0,l,0,mn|v,0,l,0,cj,0,l,0,mn||",
                "America_Mountain": "v,0,l,0,43,0,l,0,5a|v,0,l,0,cj,0,l,0,5a||",
                "America_Pacific": "v,0,l,0,43,0,l,0,22s|v,0,l,0,cj,0,l,0,22s||",
                "Anadyr": "v,0,l,0,43,0,l,0,3l|v,0,l,0,1f4,0,l,0,3l||",
                "Apia": "v,0,43,0,l,0,3e|v,0,l,0,cj,0,l,0,3e||",
                "Arabian": "v,0,43,0,l,0,3ft|v,0,l,0,cj,0,l,0,3fs||",
                "Argentina": "v,0,l,0,43,0,l,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,1e||",
                "Argentina_Western": "v,0,43,0,l,0,hu,0,oc,0,1e|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,1e||",
                "Armenia": "v,0,43,0,l,0,4l|v,0,l,0,8d,0,59,0,8j,0,l,0,4l||",
                "Atlantic": "v,0,l,0,43,0,l,0,230|v,0,l,0,cj,0,l,0,230||",
                "Australia_Central": "v,0,43,0,l,0,4c,0,59,0,ps|v,0,l,0,cj,0,l,0,4c,0,59,0,ps||",
                "Australia_CentralWestern": "v,0,43,0,l,0,hu,0,59,0,ps,0,59,0,4c|v,0,l,0,cj,0,l,0,hu,0,59,0,ps,0,59,0,4c||",
                "Australia_Eastern": "v,0,43,0,l,0,mn,0,oc,0,4c|v,0,l,0,cj,0,l,0,mn,0,oc,0,4c||",
                "Australia_Western": "v,0,43,0,l,0,4c,0,hu|v,0,l,0,cj,0,l,0,4c,0,hu||",
                "Azerbaijan": "v,0,43,0,l,0,232|v,0,l,0,8d,0,59,0,8j,0,l,0,232||",
                "Azores": "v,0,43,0,l,0,4r|v,0,l,0,8d,0,59,0,8j,0,l,0,4r||",
                "Bangladesh": "v,0,43,0,l,0,3n|v,0,l,0,8d,0,59,0,8j,0,l,0,3n||",
                "Bhutan": "v,0,l,0,as|||",
                "Bolivia": "v,0,l,0,aa|||",
                "Brasilia": "v,0,l,0,43,0,l,0,3a|v,0,l,0,8d,0,59,0,8j,0,l,0,3a||",
                "Brunei": "v,0,l,0,9o,0,a4|||",
                "Cape_Verde": "v,0,l,0,43,0,l,0,7c,0,3j|v,0,l,0,8d,0,59,0,8j,0,l,0,7c,0,3j||",
                "Chamorro": "v,0,43,0,l,0,6j|||",
                "Chatham": "v,0,43,0,l,0,27|v,0,l,0,cj,0,l,0,27||",
                "Chile": "v,0,l,0,43,0,l,0,49|v,0,l,0,8d,0,59,0,8j,0,l,0,49||",
                "China": "v,0,43,0,l,0,233|v,0,l,0,cj,0,l,0,233||",
                "Choibalsan": "v,0,43,0,l,0,2q|v,0,l,0,8d,0,59,0,8j,0,l,0,2q||",
                "Christmas": "v,0,l,0,13r,0,11t,0,99|||",
                "Cocos": "v,0,l,0,p9,0,q0,0,7v|||",
                "Colombia": "v,0,l,0,43,0,l,0,4m|v,0,l,0,8d,0,59,0,8j,0,l,0,4m||",
                "Cook": "v,0,43,0,l,0,p9,0,q0,0,2v|v,0,l,0,8d,0,3fj,0,59,0,8j,0,l,0,p9,0,2v||",
                "Cuba": "v,0,l,0,43,0,59,0,34|v,0,l,0,cj,0,l,0,34||",
                "Davis": "v,0,l,0,5s|||",
                "DumontDUrville": "v,0,l,0,5b,5,5j|||",
                "East_Timor": "v,0,l,0,7n,0,mn|||",
                "Easter": "v,0,43,0,l,0,13r,0,11t,0,23f|v,0,l,0,8d,0,59,0,8j,0,l,0,13r,0,11t,0,23f||",
                "Ecuador": "v,0,l,0,ai|||",
                "Europe_Central": "v,0,43,0,l,0,114,0,59,0,3fg|v,0,l,0,8d,0,59,0,8j,0,l,0,114,0,59,0,ps||",
                "Europe_Eastern": "v,0,43,0,l,0,mn,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,mn,0,oc,0,114||",
                "Europe_Further_Eastern": "v,0,l,0,bu,5,c0,0,18,0,1|||",
                "Europe_Western": "v,0,43,0,l,0,hu,0,oc,0,114|v,0,l,0,8d,0,59,0,8j,0,l,0,hu,0,oc,0,114||",
                "Falkland": "v,0,43,0,l,0,p9,0,q0,0,4v|v,0,l,0,8d,0,59,0,8j,0,l,0,p9,0,q0,0,4v||",
                "Fiji": "v,0,43,0,l,0,4q|v,0,l,0,8d,0,59,0,8j,0,l,0,4q||",
                "French_Guiana": "v,0,l,0,am,0,59,0,23h|||",
                "French_Southern": "v,0,l,0,1f3,0,oc,0,23h,0,52,0,3fe|||",
                "Galapagos": "v,0,l,0,ak|||",
                "Gambier": "v,0,l,0,6v|||",
                "Georgia": "v,0,43,0,l,0,1f7|v,0,l,0,8d,0,59,0,8j,0,l,0,1f7||",
                "Gilbert_Islands": "v,0,l,0,p9,0,q0,0,6q|||",
                "GMT": "v,0,l,0,5u|||",
                "Greenland_Eastern": "v,0,l,0,43,0,l,0,2k,0,mn|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,mn||",
                "Greenland_Western": "v,0,l,0,43,0,l,0,2k,0,hu|v,0,l,0,8d,0,59,0,8j,0,l,0,2k,0,hu||",
                "Gulf": "v,0,43,0,l,0,bn|||",
                "Guyana": "v,0,l,0,7a|||",
                "Hawaii_Aleutian": "v,0,l,0,43,0,l,0,4g,5,62|v,0,l,0,cj,0,l,0,4g,5,62||",
                "Hong_Kong": "v,0,43,0,l,0,2l,0,2p|v,0,l,0,8d,0,59,0,8j,0,l,0,2l,0,2p||",
                "Hovd": "v,0,43,0,l,0,2g|v,0,l,0,8d,0,59,0,8j,0,l,0,2g||",
                "India": "v,0,43,0,l,0,af|||",
                "Indian_Ocean": "v,0,l,0,3fc,0,1to|||",
                "Indochina": "v,0,l,0,9p|||",
                "Indonesia_Central": "v,0,l,0,2t,0,59,0,ps|||",
                "Indonesia_Eastern": "v,0,l,0,mn,0,oc,0,2t|||",
                "Indonesia_Western": "v,0,l,0,hu,0,oc,0,2t|||",
                "Iran": "v,0,43,0,l,0,5g|v,0,l,0,cj,0,l,0,5g||",
                "Irkutsk": "v,0,l,0,43,0,l,0,3h|v,0,l,0,8d,0,59,0,8j,0,l,0,3h||",
                "Israel": "v,0,43,0,l,0,23k|v,0,l,0,cj,0,l,0,23k||",
                "Japan": "v,0,43,0,l,0,6o|v,0,l,0,cj,0,l,0,6o||",
                "Kamchatka": "v,0,l,0,43,0,l,0,37,5,3k|v,0,l,0,1f4,0,l,0,37,5,3k||",
                "Kazakhstan_Eastern": "v,0,l,0,45,0,mn|||",
                "Kazakhstan_Western": "v,0,l,0,45,0,hu|||",
                "Korea": "v,0,43,0,l,0,qf|v,0,l,0,cj,0,l,0,qf||",
                "Kosrae": "v,0,l,0,6f|||",
                "Krasnoyarsk": "v,0,l,0,43,0,l,0,3fa|v,0,l,0,8d,0,59,0,8j,0,l,0,41||",
                "Kyrgystan": "v,0,l,0,bl|||",
                "Line_Islands": "v,0,l,0,p9,0,q0,0,ac|||",
                "Lord_Howe": "v,0,43,0,l,0,1u,0,24|v,0,l,0,cj,0,l,0,1u,0,24||",
                "Macquarie": "v,0,l,0,3f9,0,11t,0,6m|||",
                "Magadan": "v,0,l,0,43,0,l,0,2o|v,0,l,0,8d,0,59,0,8j,0,l,0,2o||",
                "Malaysia": "v,0,l,0,bf|||",
                "Maldives": "v,0,l,0,9k|||",
                "Marquesas": "v,0,l,0,9e|||",
                "Marshall_Islands": "v,0,l,0,p9,0,q0,0,7o|||",
                "Mauritius": "v,0,l,0,43,0,l,0,4u|v,0,l,0,8d,0,59,0,8j,0,l,0,4u||",
                "Mawson": "v,0,l,0,63|||",
                "Mexico_Northwest": "v,0,43,0,l,0,5e,0,23l,0,hu|v,0,l,0,23m,0,l,0,5e,0,23l,0,hu||",
                "Mexico_Pacific": "v,0,l,0,3f6,0,l,0,23n,0,l,0,5e|v,0,l,0,23m,0,l,0,23n,0,l,0,5e||",
                "Mongolia": "v,0,43,0,l,0,4f,0,2m|v,0,l,0,8d,0,59,0,8j,0,l,0,4f,0,2m||",
                "Moscow": "v,0,l,0,43,0,l,0,71|v,0,l,0,8d,0,59,0,8j,0,l,0,71||",
                "Myanmar": "v,0,l,0,8v|||",
                "Nauru": "v,0,l,0,5v|||",
                "Nepal": "v,0,l,0,8u|||",
                "New_Caledonia": "v,0,43,0,l,0,1m,0,4o|v,0,l,0,8d,0,59,0,8j,0,l,0,1m,0,4o||",
                "New_Zealand": "v,0,43,0,l,0,1m,0,74|v,0,l,0,cj,0,l,0,1m,0,74||",
                "Newfoundland": "v,0,l,0,43,0,l,0,53|v,0,l,0,cj,0,l,0,53||",
                "Niue": "v,0,l,0,8g|||",
                "Norfolk": "v,0,l,0,13r,0,11t,0,6l|||",
                "Noronha": "v,0,43,0,l,0,1s,0,2,0,23|v,0,l,0,8d,0,59,0,8j,0,l,0,1s,0,2,0,23||",
                "Novosibirsk": "v,0,l,0,43,0,l,0,3b|v,0,l,0,8d,0,59,0,8j,0,l,0,3b||",
                "Omsk": "v,0,l,0,43,0,l,0,26|v,0,l,0,8d,0,59,0,8j,0,l,0,26||",
                "Pakistan": "v,0,43,0,l,0,3i|v,0,l,0,8d,0,59,0,8j,0,l,0,3i||",
                "Palau": "v,0,l,0,9b|||",
                "Papua_New_Guinea": "v,0,l,0,9a,0,1m,0,a8|||",
                "Paraguay": "v,0,l,0,43,0,l,0,3c|v,0,l,0,8d,0,59,0,8j,0,l,0,3c||",
                "Peru": "v,0,l,0,43,0,l,0,4n|v,0,l,0,8d,0,59,0,8j,0,l,0,4n||",
                "Philippines": "v,0,43,0,l,0,23p|v,0,l,0,8d,0,59,0,8j,0,l,0,23p||",
                "Phoenix_Islands": "v,0,l,0,p9,0,q0,0,90|||",
                "Pierre_Miquelon": "v,0,l,0,43,0,59,0,8i,5,33,0,52,0,35|v,0,l,0,cj,0,l,0,8i,5,33,0,52,0,35||",
                "Pitcairn": "v,0,l,0,7e|||",
                "Ponape": "v,0,l,0,9s|||",
                "Pyongyang": "v,0,l,0,8a|||",
                "Reunion": "v,0,l,0,b4|||",
                "Rothera": "v,0,l,0,5q|||",
                "Sakhalin": "v,0,l,0,43,0,l,0,55|v,0,l,0,8d,0,59,0,8j,0,l,0,55||",
                "Samara": "v,0,l,0,43,0,l,0,29|v,0,l,0,1f4,0,l,0,29||",
                "Samoa": "v,0,43,0,l,0,2c|v,0,l,0,8d,0,59,0,8j,0,l,0,2c||",
                "Seychelles": "v,0,l,0,3f3|||",
                "Singapore": "v,0,43,0,l,0,bi|||",
                "Solomon": "v,0,l,0,p9,0,q0,0,b5|||",
                "South_Georgia": "v,0,l,0,1f7,0,1f3|||",
                "Suriname": "v,0,l,0,8q|||",
                "Syowa": "v,0,l,0,65|||",
                "Tahiti": "v,0,l,0,8n|||",
                "Taipei": "v,0,43,0,l,0,3d|v,0,l,0,cj,0,l,0,3d||",
                "Tajikistan": "v,0,l,0,bj|||",
                "Tokelau": "v,0,l,0,5d|||",
                "Tonga": "v,0,43,0,l,0,2j|v,0,l,0,8d,0,59,0,8j,0,l,0,2j||",
                "Truk": "v,0,l,0,6p|||",
                "Turkmenistan": "v,0,l,0,43,0,l,0,4t|v,0,l,0,8d,0,59,0,8j,0,l,0,4t||",
                "Tuvalu": "v,0,l,0,6h|||",
                "Uruguay": "v,0,l,0,43,0,l,0,4k|v,0,l,0,8d,0,59,0,8j,0,l,0,4k||",
                "Uzbekistan": "v,0,l,0,43,0,l,0,60|v,0,l,0,8d,0,59,0,8j,0,l,0,60||",
                "Vanuatu": "v,0,43,0,l,0,2f|v,0,l,0,8d,0,59,0,8j,0,l,0,2f||",
                "Venezuela": "v,0,l,0,7s|||",
                "Vladivostok": "v,0,l,0,43,0,l,0,28|v,0,l,0,8d,0,59,0,8j,0,l,0,28||",
                "Volgograd": "v,0,l,0,43,0,l,0,3f|v,0,l,0,8d,0,59,0,8j,0,l,0,3f||",
                "Vostok": "v,0,l,0,5t|||",
                "Wake": "v,0,l,0,13r,0,11t,0,5r|||",
                "Wallis": "v,0,l,0,5f,0,52,0,5k|||",
                "Yakutsk": "v,0,l,0,43,0,l,0,3u|v,0,l,0,8d,0,59,0,8j,0,l,0,3u||",
                "Yekaterinburg": "v,0,l,0,43,0,l,0,5l|v,0,l,0,8d,0,59,0,8j,0,l,0,5l||"
            }
        },
        "ta-LK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3ab,0,47,0,r||",
                "Europe/London": "|3a9,0,6s,0,r||"
            },
            "metazone": {
                "Acre": "23q,0,p5,0,r|23q,0,6s,0,r||",
                "Afghanistan": "3eu,0,r|||",
                "Africa_Central": "p1,0,14o,0,r|||",
                "Africa_Eastern": "11p,0,14o,0,r|||",
                "Africa_Southern": "3eq,0,14o,0,47,0,r|||",
                "Africa_Western": "14f,0,14o,0,47,0,r|14f,0,14o,0,6s,0,r||",
                "Alaska": "243,0,47,0,r|243,0,bp,0,r||",
                "Almaty": "245,0,p5,0,r|245,0,6s,0,r||",
                "Amazon": "246,0,47,0,r|246,0,6s,0,r||",
                "America_Central": "p1,0,47,0,r|p1,0,bp,0,r||",
                "America_Eastern": "sq,0,47,0,r|sq,0,bp,0,r||",
                "America_Mountain": "248,0,47,0,r|248,0,bp,0,r||",
                "America_Pacific": "17n,0,47,0,r|17n,0,bp,0,r||",
                "Anadyr": "24a,0,p5,0,r|24a,0,6s,0,r||",
                "Apia": "24c,0,47,0,r|24c,0,bp,0,r||",
                "Aqtau": "24d,0,p5,0,r|24d,0,6s,0,r||",
                "Aqtobe": "24e,0,p5,0,r|24e,0,6s,0,r||",
                "Arabian": "24f,0,47,0,r|24f,0,bp,0,r||",
                "Argentina": "16u,0,47,0,r|16u,0,6s,0,r||",
                "Argentina_Western": "q7,0,16u,0,47,0,r|q7,0,16u,0,6s,0,r||",
                "Armenia": "24i,0,47,0,r|24i,0,6s,0,r||",
                "Atlantic": "24s,0,47,0,r|24s,0,bp,0,r||",
                "Australia_Central": "r9,0,p1,0,47,0,r|r9,0,p1,0,bp,0,r||",
                "Australia_CentralWestern": "r9,0,p1,0,q7,0,47,0,r|r9,0,p1,0,q7,0,bp,0,r||",
                "Australia_Eastern": "r9,0,sq,0,47,0,r|r9,0,sq,0,bp,0,r||",
                "Australia_Western": "r9,0,q7,0,47,0,r|r9,0,q7,0,bp,0,r||",
                "Azerbaijan": "24v,0,47,0,r|24v,0,6s,0,r||",
                "Azores": "3e5,0,47,0,r|3e4,0,6s,0,r||",
                "Bangladesh": "250,0,47,0,r|250,0,6s,0,r||",
                "Bhutan": "3e2,0,r|||",
                "Bolivia": "3e1,0,r|||",
                "Brasilia": "251,0,47,0,r|251,0,6s,0,r||",
                "Brunei": "3dv,0,3du,0,r|||",
                "Cape_Verde": "252,0,253,0,47,0,r|252,0,253,0,6s,0,r||",
                "Chamorro": "3dr,0,47,0,r|||",
                "Chatham": "254,0,47,0,r|254,0,bp,0,r||",
                "Chile": "255,0,47,0,r|255,0,6s,0,r||",
                "China": "259,0,47,0,r|259,0,bp,0,r||",
                "Choibalsan": "25b,0,47,0,r|25b,0,6s,0,r||",
                "Christmas": "3dm,0,11i,0,r|||",
                "Cocos": "3dk,0,ob,0,r|||",
                "Colombia": "25g,0,47,0,r|25g,0,6s,0,r||",
                "Cook": "25h,0,ob,0,47,0,r|25h,0,ob,0,3dg,0,6s,0,r||",
                "Cuba": "25i,0,47,0,r|25i,0,bp,0,r||",
                "Davis": "3de,0,r|||",
                "DumontDUrville": "3dd,5,1fn,0,3db,0,r|||",
                "East_Timor": "11p,0,3da,0,r|||",
                "Easter": "25k,0,11i,0,47,0,r|25k,0,11i,0,6s,0,r||",
                "Ecuador": "3d8,0,r|||",
                "Europe_Central": "p1,0,tp,0,47,0,r|p1,0,tp,0,6s,0,r||",
                "Europe_Eastern": "sq,0,tp,0,47,0,r|sq,0,tp,0,6s,0,r||",
                "Europe_Further_Eastern": "3d6,5,11p,0,tp,0,r|||",
                "Europe_Western": "q7,0,tp,0,47,0,r|q7,0,tp,0,6s,0,r||",
                "Falkland": "25n,0,ob,0,47,0,r|25n,0,ob,0,6s,0,r||",
                "Fiji": "25o,0,47,0,r|25o,0,6s,0,r||",
                "French_Guiana": "3d3,0,25p,0,r|||",
                "French_Southern": "3d1,0,3d0,0,31,0,3cv,0,r|||",
                "Galapagos": "3cu,0,r|||",
                "Gambier": "3ct,0,r|||",
                "Georgia": "1fo,0,47,0,r|1fo,0,6s,0,r||",
                "Gilbert_Islands": "3cr,0,ob,0,r|||",
                "GMT": "3cq,0,3cp,0,r|||",
                "Greenland_Eastern": "11p,0,17h,0,47,0,r|11p,0,17h,0,6s,0,r||",
                "Greenland_Western": "14f,0,17h,0,47,0,r|14f,0,17h,0,6s,0,r||",
                "Guam": "3cn,0,p5,0,r|||",
                "Gulf": "3cm,0,47,0,r|||",
                "Guyana": "25p,0,r|||",
                "Hawaii_Aleutian": "25r,5,25q,0,47,0,r|25r,5,25q,0,bp,0,r||",
                "Hong_Kong": "25l,0,47,0,r|25l,0,6s,0,r||",
                "Hovd": "25j,0,47,0,r|25j,0,6s,0,r||",
                "India": "3ch,0,47,0,r||15a|",
                "Indian_Ocean": "3cg,0,3cf,0,r|||",
                "Indochina": "3ce,0,r|||",
                "Indonesia_Central": "p1,0,1iu,0,r|||",
                "Indonesia_Eastern": "sq,0,1iu,0,r|||",
                "Indonesia_Western": "q7,0,1iu,0,r|||",
                "Iran": "239,0,47,0,r|239,0,bp,0,r||",
                "Irkutsk": "238,0,47,0,r|238,0,6s,0,r||",
                "Israel": "237,0,47,0,r|237,0,bp,0,r||",
                "Japan": "236,0,47,0,r|236,0,bp,0,r||",
                "Kamchatka": "235,0,22v,0,p5,0,r|235,0,22v,0,6s,0,r||",
                "Kazakhstan_Eastern": "11p,0,22u,0,r|||",
                "Kazakhstan_Western": "14f,0,22u,0,r|||",
                "Korea": "22n,0,47,0,r|22n,0,bp,0,r||",
                "Kosrae": "3c4,0,r|||",
                "Krasnoyarsk": "22j,0,47,0,r|22j,0,6s,0,r||",
                "Kyrgystan": "3c2,0,r|||",
                "Lanka": "3c1,0,r|||",
                "Line_Islands": "3c0,0,ob,0,r|||",
                "Lord_Howe": "22g,0,22f,0,47,0,r|22g,0,22f,0,bp,0,r||",
                "Macau": "22e,0,p5,0,r|22e,0,6s,0,r||",
                "Macquarie": "3bs,0,11i,0,r|||",
                "Magadan": "22c,0,47,0,r|22c,0,6s,0,r||",
                "Malaysia": "3bq,0,r|||",
                "Maldives": "3bp,0,r|||",
                "Marquesas": "3bo,0,r|||",
                "Marshall_Islands": "3bn,0,ob,0,r|||",
                "Mauritius": "22a,0,47,0,r|22a,0,6s,0,r||",
                "Mawson": "3bl,0,r|||",
                "Mexico_Northwest": "227,0,223,0,47,0,r|227,0,223,0,bp,0,r||",
                "Mexico_Pacific": "222,0,17n,0,47,0,r|222,0,17n,0,bp,0,r||",
                "Mongolia": "221,0,21o,0,47,0,r|221,0,21o,0,6s,0,r||",
                "Moscow": "21e,0,47,0,r|21e,0,6s,0,r||",
                "Myanmar": "3be,0,r|||",
                "Nauru": "3bd,0,r|||",
                "Nepal": "3bc,0,r|||",
                "New_Caledonia": "1je,0,21a,0,47,0,r|1je,0,21a,0,6s,0,r||",
                "New_Zealand": "217,0,47,0,r|217,0,bp,0,r||",
                "Newfoundland": "213,0,47,0,r|213,0,bp,0,r||",
                "Niue": "3b7,0,r|||",
                "Norfolk": "3b6,0,11i,0,r|||",
                "Noronha": "212,0,1fn,0,20t,0,47,0,r|212,0,1fn,0,20t,0,6s,0,r||",
                "North_Mariana": "3b3,0,3b2,0,ob,0,r|||",
                "Novosibirsk": "20s,0,47,0,r|20s,0,6s,0,r||",
                "Omsk": "20r,0,47,0,r|20r,0,6s,0,r||",
                "Pakistan": "20o,0,47,0,r|20o,0,6s,0,r||",
                "Palau": "3au,0,r|||",
                "Papua_New_Guinea": "3at,0,1je,0,3as,0,r|||",
                "Paraguay": "20l,0,47,0,r|20l,0,6s,0,r||",
                "Peru": "20k,0,47,0,r|20k,0,6s,0,r||",
                "Philippines": "20h,0,47,0,r|20h,0,6s,0,r||",
                "Phoenix_Islands": "3ao,0,ob,0,r|||",
                "Pierre_Miquelon": "20g,0,20f,0,31,0,20d,0,47,0,r|20g,0,20f,0,31,0,20d,0,bp,0,r||",
                "Pitcairn": "3ak,0,r|||",
                "Ponape": "3aj,0,r|||",
                "Pyongyang": "3ai,0,r|||",
                "Qyzylorda": "20c,0,p5,0,r|20c,0,6s,0,r||",
                "Reunion": "3ag,0,r|||",
                "Rothera": "3af,0,r|||",
                "Sakhalin": "1tm,0,47,0,r|1tm,0,6s,0,r||",
                "Samara": "1tl,0,p5,0,r|1tl,0,6s,0,r||",
                "Samoa": "1tk,0,47,0,r|1tk,0,bp,0,r||",
                "Seychelles": "38a,0,r|||",
                "Singapore": "389,0,47,0,r|||",
                "Solomon": "388,0,ob,0,r|||",
                "South_Georgia": "387,0,1fo,0,r|||",
                "Suriname": "386,0,r|||",
                "Syowa": "385,0,r|||",
                "Tahiti": "384,0,r|||",
                "Taipei": "1tf,0,47,0,r|1tf,0,bp,0,r||",
                "Tajikistan": "382,0,r|||",
                "Tokelau": "381,0,r|||",
                "Tonga": "1td,0,47,0,r|1td,0,6s,0,r||",
                "Truk": "37v,0,r|||",
                "Turkmenistan": "1t8,0,47,0,r|1t8,0,6s,0,r||",
                "Tuvalu": "37s,0,r|||",
                "Uruguay": "1t7,0,47,0,r|1t7,0,6s,0,r||",
                "Uzbekistan": "1t4,0,47,0,r|1t4,0,6s,0,r||",
                "Vanuatu": "1t3,0,47,0,r|1t3,0,6s,0,r||",
                "Venezuela": "37n,0,r|||",
                "Vladivostok": "1t1,0,47,0,r|1t1,0,6s,0,r||",
                "Volgograd": "1t0,0,47,0,r|1t0,0,6s,0,r||",
                "Vostok": "37i,0,r|||",
                "Wake": "37h,0,11i,0,r|||",
                "Wallis": "37f,0,37e,0,37d,0,r|||",
                "Yakutsk": "1sv,0,47,0,r|1sv,0,6s,0,r||",
                "Yekaterinburg": "1su,0,47,0,r|1su,0,6s,0,r||"
            }
        },
        "ta-MY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3ab,0,47,0,r||",
                "Europe/London": "|3a9,0,6s,0,r||"
            },
            "metazone": {
                "Acre": "23q,0,p5,0,r|23q,0,6s,0,r||",
                "Afghanistan": "3eu,0,r|||",
                "Africa_Central": "p1,0,14o,0,r|||",
                "Africa_Eastern": "11p,0,14o,0,r|||",
                "Africa_Southern": "3eq,0,14o,0,47,0,r|||",
                "Africa_Western": "14f,0,14o,0,47,0,r|14f,0,14o,0,6s,0,r||",
                "Alaska": "243,0,47,0,r|243,0,bp,0,r||",
                "Almaty": "245,0,p5,0,r|245,0,6s,0,r||",
                "Amazon": "246,0,47,0,r|246,0,6s,0,r||",
                "America_Central": "p1,0,47,0,r|p1,0,bp,0,r||",
                "America_Eastern": "sq,0,47,0,r|sq,0,bp,0,r||",
                "America_Mountain": "248,0,47,0,r|248,0,bp,0,r||",
                "America_Pacific": "17n,0,47,0,r|17n,0,bp,0,r||",
                "Anadyr": "24a,0,p5,0,r|24a,0,6s,0,r||",
                "Apia": "24c,0,47,0,r|24c,0,bp,0,r||",
                "Aqtau": "24d,0,p5,0,r|24d,0,6s,0,r||",
                "Aqtobe": "24e,0,p5,0,r|24e,0,6s,0,r||",
                "Arabian": "24f,0,47,0,r|24f,0,bp,0,r||",
                "Argentina": "16u,0,47,0,r|16u,0,6s,0,r||",
                "Argentina_Western": "q7,0,16u,0,47,0,r|q7,0,16u,0,6s,0,r||",
                "Armenia": "24i,0,47,0,r|24i,0,6s,0,r||",
                "Atlantic": "24s,0,47,0,r|24s,0,bp,0,r||",
                "Australia_Central": "r9,0,p1,0,47,0,r|r9,0,p1,0,bp,0,r||",
                "Australia_CentralWestern": "r9,0,p1,0,q7,0,47,0,r|r9,0,p1,0,q7,0,bp,0,r||",
                "Australia_Eastern": "r9,0,sq,0,47,0,r|r9,0,sq,0,bp,0,r||",
                "Australia_Western": "r9,0,q7,0,47,0,r|r9,0,q7,0,bp,0,r||",
                "Azerbaijan": "24v,0,47,0,r|24v,0,6s,0,r||",
                "Azores": "3e5,0,47,0,r|3e4,0,6s,0,r||",
                "Bangladesh": "250,0,47,0,r|250,0,6s,0,r||",
                "Bhutan": "3e2,0,r|||",
                "Bolivia": "3e1,0,r|||",
                "Brasilia": "251,0,47,0,r|251,0,6s,0,r||",
                "Brunei": "3dv,0,3du,0,r|||",
                "Cape_Verde": "252,0,253,0,47,0,r|252,0,253,0,6s,0,r||",
                "Chamorro": "3dr,0,47,0,r|||",
                "Chatham": "254,0,47,0,r|254,0,bp,0,r||",
                "Chile": "255,0,47,0,r|255,0,6s,0,r||",
                "China": "259,0,47,0,r|259,0,bp,0,r||",
                "Choibalsan": "25b,0,47,0,r|25b,0,6s,0,r||",
                "Christmas": "3dm,0,11i,0,r|||",
                "Cocos": "3dk,0,ob,0,r|||",
                "Colombia": "25g,0,47,0,r|25g,0,6s,0,r||",
                "Cook": "25h,0,ob,0,47,0,r|25h,0,ob,0,3dg,0,6s,0,r||",
                "Cuba": "25i,0,47,0,r|25i,0,bp,0,r||",
                "Davis": "3de,0,r|||",
                "DumontDUrville": "3dd,5,1fn,0,3db,0,r|||",
                "East_Timor": "11p,0,3da,0,r|||",
                "Easter": "25k,0,11i,0,47,0,r|25k,0,11i,0,6s,0,r||",
                "Ecuador": "3d8,0,r|||",
                "Europe_Central": "p1,0,tp,0,47,0,r|p1,0,tp,0,6s,0,r||",
                "Europe_Eastern": "sq,0,tp,0,47,0,r|sq,0,tp,0,6s,0,r||",
                "Europe_Further_Eastern": "3d6,5,11p,0,tp,0,r|||",
                "Europe_Western": "q7,0,tp,0,47,0,r|q7,0,tp,0,6s,0,r||",
                "Falkland": "25n,0,ob,0,47,0,r|25n,0,ob,0,6s,0,r||",
                "Fiji": "25o,0,47,0,r|25o,0,6s,0,r||",
                "French_Guiana": "3d3,0,25p,0,r|||",
                "French_Southern": "3d1,0,3d0,0,31,0,3cv,0,r|||",
                "Galapagos": "3cu,0,r|||",
                "Gambier": "3ct,0,r|||",
                "Georgia": "1fo,0,47,0,r|1fo,0,6s,0,r||",
                "Gilbert_Islands": "3cr,0,ob,0,r|||",
                "GMT": "3cq,0,3cp,0,r|||",
                "Greenland_Eastern": "11p,0,17h,0,47,0,r|11p,0,17h,0,6s,0,r||",
                "Greenland_Western": "14f,0,17h,0,47,0,r|14f,0,17h,0,6s,0,r||",
                "Guam": "3cn,0,p5,0,r|||",
                "Gulf": "3cm,0,47,0,r|||",
                "Guyana": "25p,0,r|||",
                "Hawaii_Aleutian": "25r,5,25q,0,47,0,r|25r,5,25q,0,bp,0,r||",
                "Hong_Kong": "25l,0,47,0,r|25l,0,6s,0,r||",
                "Hovd": "25j,0,47,0,r|25j,0,6s,0,r||",
                "India": "3ch,0,47,0,r|||",
                "Indian_Ocean": "3cg,0,3cf,0,r|||",
                "Indochina": "3ce,0,r|||",
                "Indonesia_Central": "p1,0,1iu,0,r|||",
                "Indonesia_Eastern": "sq,0,1iu,0,r|||",
                "Indonesia_Western": "q7,0,1iu,0,r|||",
                "Iran": "239,0,47,0,r|239,0,bp,0,r||",
                "Irkutsk": "238,0,47,0,r|238,0,6s,0,r||",
                "Israel": "237,0,47,0,r|237,0,bp,0,r||",
                "Japan": "236,0,47,0,r|236,0,bp,0,r||",
                "Kamchatka": "235,0,22v,0,p5,0,r|235,0,22v,0,6s,0,r||",
                "Kazakhstan_Eastern": "11p,0,22u,0,r|||",
                "Kazakhstan_Western": "14f,0,22u,0,r|||",
                "Korea": "22n,0,47,0,r|22n,0,bp,0,r||",
                "Kosrae": "3c4,0,r|||",
                "Krasnoyarsk": "22j,0,47,0,r|22j,0,6s,0,r||",
                "Kyrgystan": "3c2,0,r|||",
                "Lanka": "3c1,0,r|||",
                "Line_Islands": "3c0,0,ob,0,r|||",
                "Lord_Howe": "22g,0,22f,0,47,0,r|22g,0,22f,0,bp,0,r||",
                "Macau": "22e,0,p5,0,r|22e,0,6s,0,r||",
                "Macquarie": "3bs,0,11i,0,r|||",
                "Magadan": "22c,0,47,0,r|22c,0,6s,0,r||",
                "Malaysia": "3bq,0,r||1r5|",
                "Maldives": "3bp,0,r|||",
                "Marquesas": "3bo,0,r|||",
                "Marshall_Islands": "3bn,0,ob,0,r|||",
                "Mauritius": "22a,0,47,0,r|22a,0,6s,0,r||",
                "Mawson": "3bl,0,r|||",
                "Mexico_Northwest": "227,0,223,0,47,0,r|227,0,223,0,bp,0,r||",
                "Mexico_Pacific": "222,0,17n,0,47,0,r|222,0,17n,0,bp,0,r||",
                "Mongolia": "221,0,21o,0,47,0,r|221,0,21o,0,6s,0,r||",
                "Moscow": "21e,0,47,0,r|21e,0,6s,0,r||",
                "Myanmar": "3be,0,r|||",
                "Nauru": "3bd,0,r|||",
                "Nepal": "3bc,0,r|||",
                "New_Caledonia": "1je,0,21a,0,47,0,r|1je,0,21a,0,6s,0,r||",
                "New_Zealand": "217,0,47,0,r|217,0,bp,0,r||",
                "Newfoundland": "213,0,47,0,r|213,0,bp,0,r||",
                "Niue": "3b7,0,r|||",
                "Norfolk": "3b6,0,11i,0,r|||",
                "Noronha": "212,0,1fn,0,20t,0,47,0,r|212,0,1fn,0,20t,0,6s,0,r||",
                "North_Mariana": "3b3,0,3b2,0,ob,0,r|||",
                "Novosibirsk": "20s,0,47,0,r|20s,0,6s,0,r||",
                "Omsk": "20r,0,47,0,r|20r,0,6s,0,r||",
                "Pakistan": "20o,0,47,0,r|20o,0,6s,0,r||",
                "Palau": "3au,0,r|||",
                "Papua_New_Guinea": "3at,0,1je,0,3as,0,r|||",
                "Paraguay": "20l,0,47,0,r|20l,0,6s,0,r||",
                "Peru": "20k,0,47,0,r|20k,0,6s,0,r||",
                "Philippines": "20h,0,47,0,r|20h,0,6s,0,r||",
                "Phoenix_Islands": "3ao,0,ob,0,r|||",
                "Pierre_Miquelon": "20g,0,20f,0,31,0,20d,0,47,0,r|20g,0,20f,0,31,0,20d,0,bp,0,r||",
                "Pitcairn": "3ak,0,r|||",
                "Ponape": "3aj,0,r|||",
                "Pyongyang": "3ai,0,r|||",
                "Qyzylorda": "20c,0,p5,0,r|20c,0,6s,0,r||",
                "Reunion": "3ag,0,r|||",
                "Rothera": "3af,0,r|||",
                "Sakhalin": "1tm,0,47,0,r|1tm,0,6s,0,r||",
                "Samara": "1tl,0,p5,0,r|1tl,0,6s,0,r||",
                "Samoa": "1tk,0,47,0,r|1tk,0,bp,0,r||",
                "Seychelles": "38a,0,r|||",
                "Singapore": "389,0,47,0,r||2ad|",
                "Solomon": "388,0,ob,0,r|||",
                "South_Georgia": "387,0,1fo,0,r|||",
                "Suriname": "386,0,r|||",
                "Syowa": "385,0,r|||",
                "Tahiti": "384,0,r|||",
                "Taipei": "1tf,0,47,0,r|1tf,0,bp,0,r||",
                "Tajikistan": "382,0,r|||",
                "Tokelau": "381,0,r|||",
                "Tonga": "1td,0,47,0,r|1td,0,6s,0,r||",
                "Truk": "37v,0,r|||",
                "Turkmenistan": "1t8,0,47,0,r|1t8,0,6s,0,r||",
                "Tuvalu": "37s,0,r|||",
                "Uruguay": "1t7,0,47,0,r|1t7,0,6s,0,r||",
                "Uzbekistan": "1t4,0,47,0,r|1t4,0,6s,0,r||",
                "Vanuatu": "1t3,0,47,0,r|1t3,0,6s,0,r||",
                "Venezuela": "37n,0,r|||",
                "Vladivostok": "1t1,0,47,0,r|1t1,0,6s,0,r||",
                "Volgograd": "1t0,0,47,0,r|1t0,0,6s,0,r||",
                "Vostok": "37i,0,r|||",
                "Wake": "37h,0,11i,0,r|||",
                "Wallis": "37f,0,37e,0,37d,0,r|||",
                "Yakutsk": "1sv,0,47,0,r|1sv,0,6s,0,r||",
                "Yekaterinburg": "1su,0,47,0,r|1su,0,6s,0,r||"
            }
        },
        "ta-SG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3ab,0,47,0,r||",
                "Europe/London": "|3a9,0,6s,0,r||"
            },
            "metazone": {
                "Acre": "23q,0,p5,0,r|23q,0,6s,0,r||",
                "Afghanistan": "3eu,0,r|||",
                "Africa_Central": "p1,0,14o,0,r|||",
                "Africa_Eastern": "11p,0,14o,0,r|||",
                "Africa_Southern": "3eq,0,14o,0,47,0,r|||",
                "Africa_Western": "14f,0,14o,0,47,0,r|14f,0,14o,0,6s,0,r||",
                "Alaska": "243,0,47,0,r|243,0,bp,0,r||",
                "Almaty": "245,0,p5,0,r|245,0,6s,0,r||",
                "Amazon": "246,0,47,0,r|246,0,6s,0,r||",
                "America_Central": "p1,0,47,0,r|p1,0,bp,0,r||",
                "America_Eastern": "sq,0,47,0,r|sq,0,bp,0,r||",
                "America_Mountain": "248,0,47,0,r|248,0,bp,0,r||",
                "America_Pacific": "17n,0,47,0,r|17n,0,bp,0,r||",
                "Anadyr": "24a,0,p5,0,r|24a,0,6s,0,r||",
                "Apia": "24c,0,47,0,r|24c,0,bp,0,r||",
                "Aqtau": "24d,0,p5,0,r|24d,0,6s,0,r||",
                "Aqtobe": "24e,0,p5,0,r|24e,0,6s,0,r||",
                "Arabian": "24f,0,47,0,r|24f,0,bp,0,r||",
                "Argentina": "16u,0,47,0,r|16u,0,6s,0,r||",
                "Argentina_Western": "q7,0,16u,0,47,0,r|q7,0,16u,0,6s,0,r||",
                "Armenia": "24i,0,47,0,r|24i,0,6s,0,r||",
                "Atlantic": "24s,0,47,0,r|24s,0,bp,0,r||",
                "Australia_Central": "r9,0,p1,0,47,0,r|r9,0,p1,0,bp,0,r||",
                "Australia_CentralWestern": "r9,0,p1,0,q7,0,47,0,r|r9,0,p1,0,q7,0,bp,0,r||",
                "Australia_Eastern": "r9,0,sq,0,47,0,r|r9,0,sq,0,bp,0,r||",
                "Australia_Western": "r9,0,q7,0,47,0,r|r9,0,q7,0,bp,0,r||",
                "Azerbaijan": "24v,0,47,0,r|24v,0,6s,0,r||",
                "Azores": "3e5,0,47,0,r|3e4,0,6s,0,r||",
                "Bangladesh": "250,0,47,0,r|250,0,6s,0,r||",
                "Bhutan": "3e2,0,r|||",
                "Bolivia": "3e1,0,r|||",
                "Brasilia": "251,0,47,0,r|251,0,6s,0,r||",
                "Brunei": "3dv,0,3du,0,r|||",
                "Cape_Verde": "252,0,253,0,47,0,r|252,0,253,0,6s,0,r||",
                "Chamorro": "3dr,0,47,0,r|||",
                "Chatham": "254,0,47,0,r|254,0,bp,0,r||",
                "Chile": "255,0,47,0,r|255,0,6s,0,r||",
                "China": "259,0,47,0,r|259,0,bp,0,r||",
                "Choibalsan": "25b,0,47,0,r|25b,0,6s,0,r||",
                "Christmas": "3dm,0,11i,0,r|||",
                "Cocos": "3dk,0,ob,0,r|||",
                "Colombia": "25g,0,47,0,r|25g,0,6s,0,r||",
                "Cook": "25h,0,ob,0,47,0,r|25h,0,ob,0,3dg,0,6s,0,r||",
                "Cuba": "25i,0,47,0,r|25i,0,bp,0,r||",
                "Davis": "3de,0,r|||",
                "DumontDUrville": "3dd,5,1fn,0,3db,0,r|||",
                "East_Timor": "11p,0,3da,0,r|||",
                "Easter": "25k,0,11i,0,47,0,r|25k,0,11i,0,6s,0,r||",
                "Ecuador": "3d8,0,r|||",
                "Europe_Central": "p1,0,tp,0,47,0,r|p1,0,tp,0,6s,0,r||",
                "Europe_Eastern": "sq,0,tp,0,47,0,r|sq,0,tp,0,6s,0,r||",
                "Europe_Further_Eastern": "3d6,5,11p,0,tp,0,r|||",
                "Europe_Western": "q7,0,tp,0,47,0,r|q7,0,tp,0,6s,0,r||",
                "Falkland": "25n,0,ob,0,47,0,r|25n,0,ob,0,6s,0,r||",
                "Fiji": "25o,0,47,0,r|25o,0,6s,0,r||",
                "French_Guiana": "3d3,0,25p,0,r|||",
                "French_Southern": "3d1,0,3d0,0,31,0,3cv,0,r|||",
                "Galapagos": "3cu,0,r|||",
                "Gambier": "3ct,0,r|||",
                "Georgia": "1fo,0,47,0,r|1fo,0,6s,0,r||",
                "Gilbert_Islands": "3cr,0,ob,0,r|||",
                "GMT": "3cq,0,3cp,0,r|||",
                "Greenland_Eastern": "11p,0,17h,0,47,0,r|11p,0,17h,0,6s,0,r||",
                "Greenland_Western": "14f,0,17h,0,47,0,r|14f,0,17h,0,6s,0,r||",
                "Guam": "3cn,0,p5,0,r|||",
                "Gulf": "3cm,0,47,0,r|||",
                "Guyana": "25p,0,r|||",
                "Hawaii_Aleutian": "25r,5,25q,0,47,0,r|25r,5,25q,0,bp,0,r||",
                "Hong_Kong": "25l,0,47,0,r|25l,0,6s,0,r||",
                "Hovd": "25j,0,47,0,r|25j,0,6s,0,r||",
                "India": "3ch,0,47,0,r|||",
                "Indian_Ocean": "3cg,0,3cf,0,r|||",
                "Indochina": "3ce,0,r|||",
                "Indonesia_Central": "p1,0,1iu,0,r|||",
                "Indonesia_Eastern": "sq,0,1iu,0,r|||",
                "Indonesia_Western": "q7,0,1iu,0,r|||",
                "Iran": "239,0,47,0,r|239,0,bp,0,r||",
                "Irkutsk": "238,0,47,0,r|238,0,6s,0,r||",
                "Israel": "237,0,47,0,r|237,0,bp,0,r||",
                "Japan": "236,0,47,0,r|236,0,bp,0,r||",
                "Kamchatka": "235,0,22v,0,p5,0,r|235,0,22v,0,6s,0,r||",
                "Kazakhstan_Eastern": "11p,0,22u,0,r|||",
                "Kazakhstan_Western": "14f,0,22u,0,r|||",
                "Korea": "22n,0,47,0,r|22n,0,bp,0,r||",
                "Kosrae": "3c4,0,r|||",
                "Krasnoyarsk": "22j,0,47,0,r|22j,0,6s,0,r||",
                "Kyrgystan": "3c2,0,r|||",
                "Lanka": "3c1,0,r|||",
                "Line_Islands": "3c0,0,ob,0,r|||",
                "Lord_Howe": "22g,0,22f,0,47,0,r|22g,0,22f,0,bp,0,r||",
                "Macau": "22e,0,p5,0,r|22e,0,6s,0,r||",
                "Macquarie": "3bs,0,11i,0,r|||",
                "Magadan": "22c,0,47,0,r|22c,0,6s,0,r||",
                "Malaysia": "3bq,0,r||1r5|",
                "Maldives": "3bp,0,r|||",
                "Marquesas": "3bo,0,r|||",
                "Marshall_Islands": "3bn,0,ob,0,r|||",
                "Mauritius": "22a,0,47,0,r|22a,0,6s,0,r||",
                "Mawson": "3bl,0,r|||",
                "Mexico_Northwest": "227,0,223,0,47,0,r|227,0,223,0,bp,0,r||",
                "Mexico_Pacific": "222,0,17n,0,47,0,r|222,0,17n,0,bp,0,r||",
                "Mongolia": "221,0,21o,0,47,0,r|221,0,21o,0,6s,0,r||",
                "Moscow": "21e,0,47,0,r|21e,0,6s,0,r||",
                "Myanmar": "3be,0,r|||",
                "Nauru": "3bd,0,r|||",
                "Nepal": "3bc,0,r|||",
                "New_Caledonia": "1je,0,21a,0,47,0,r|1je,0,21a,0,6s,0,r||",
                "New_Zealand": "217,0,47,0,r|217,0,bp,0,r||",
                "Newfoundland": "213,0,47,0,r|213,0,bp,0,r||",
                "Niue": "3b7,0,r|||",
                "Norfolk": "3b6,0,11i,0,r|||",
                "Noronha": "212,0,1fn,0,20t,0,47,0,r|212,0,1fn,0,20t,0,6s,0,r||",
                "North_Mariana": "3b3,0,3b2,0,ob,0,r|||",
                "Novosibirsk": "20s,0,47,0,r|20s,0,6s,0,r||",
                "Omsk": "20r,0,47,0,r|20r,0,6s,0,r||",
                "Pakistan": "20o,0,47,0,r|20o,0,6s,0,r||",
                "Palau": "3au,0,r|||",
                "Papua_New_Guinea": "3at,0,1je,0,3as,0,r|||",
                "Paraguay": "20l,0,47,0,r|20l,0,6s,0,r||",
                "Peru": "20k,0,47,0,r|20k,0,6s,0,r||",
                "Philippines": "20h,0,47,0,r|20h,0,6s,0,r||",
                "Phoenix_Islands": "3ao,0,ob,0,r|||",
                "Pierre_Miquelon": "20g,0,20f,0,31,0,20d,0,47,0,r|20g,0,20f,0,31,0,20d,0,bp,0,r||",
                "Pitcairn": "3ak,0,r|||",
                "Ponape": "3aj,0,r|||",
                "Pyongyang": "3ai,0,r|||",
                "Qyzylorda": "20c,0,p5,0,r|20c,0,6s,0,r||",
                "Reunion": "3ag,0,r|||",
                "Rothera": "3af,0,r|||",
                "Sakhalin": "1tm,0,47,0,r|1tm,0,6s,0,r||",
                "Samara": "1tl,0,p5,0,r|1tl,0,6s,0,r||",
                "Samoa": "1tk,0,47,0,r|1tk,0,bp,0,r||",
                "Seychelles": "38a,0,r|||",
                "Singapore": "389,0,47,0,r||2ad|",
                "Solomon": "388,0,ob,0,r|||",
                "South_Georgia": "387,0,1fo,0,r|||",
                "Suriname": "386,0,r|||",
                "Syowa": "385,0,r|||",
                "Tahiti": "384,0,r|||",
                "Taipei": "1tf,0,47,0,r|1tf,0,bp,0,r||",
                "Tajikistan": "382,0,r|||",
                "Tokelau": "381,0,r|||",
                "Tonga": "1td,0,47,0,r|1td,0,6s,0,r||",
                "Truk": "37v,0,r|||",
                "Turkmenistan": "1t8,0,47,0,r|1t8,0,6s,0,r||",
                "Tuvalu": "37s,0,r|||",
                "Uruguay": "1t7,0,47,0,r|1t7,0,6s,0,r||",
                "Uzbekistan": "1t4,0,47,0,r|1t4,0,6s,0,r||",
                "Vanuatu": "1t3,0,47,0,r|1t3,0,6s,0,r||",
                "Venezuela": "37n,0,r|||",
                "Vladivostok": "1t1,0,47,0,r|1t1,0,6s,0,r||",
                "Volgograd": "1t0,0,47,0,r|1t0,0,6s,0,r||",
                "Vostok": "37i,0,r|||",
                "Wake": "37h,0,11i,0,r|||",
                "Wallis": "37f,0,37e,0,37d,0,r|||",
                "Yakutsk": "1sv,0,47,0,r|1sv,0,6s,0,r||",
                "Yekaterinburg": "1su,0,47,0,r|1su,0,6s,0,r||"
            }
        },
        "ta": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|3ab,0,47,0,r||",
                "Europe/London": "|3a9,0,6s,0,r||"
            },
            "metazone": {
                "Acre": "23q,0,p5,0,r|23q,0,6s,0,r||",
                "Afghanistan": "3eu,0,r|||",
                "Africa_Central": "p1,0,14o,0,r|||",
                "Africa_Eastern": "11p,0,14o,0,r|||",
                "Africa_Southern": "3eq,0,14o,0,47,0,r|||",
                "Africa_Western": "14f,0,14o,0,47,0,r|14f,0,14o,0,6s,0,r||",
                "Alaska": "243,0,47,0,r|243,0,bp,0,r||",
                "Almaty": "245,0,p5,0,r|245,0,6s,0,r||",
                "Amazon": "246,0,47,0,r|246,0,6s,0,r||",
                "America_Central": "p1,0,47,0,r|p1,0,bp,0,r||",
                "America_Eastern": "sq,0,47,0,r|sq,0,bp,0,r||",
                "America_Mountain": "248,0,47,0,r|248,0,bp,0,r||",
                "America_Pacific": "17n,0,47,0,r|17n,0,bp,0,r||",
                "Anadyr": "24a,0,p5,0,r|24a,0,6s,0,r||",
                "Apia": "24c,0,47,0,r|24c,0,bp,0,r||",
                "Aqtau": "24d,0,p5,0,r|24d,0,6s,0,r||",
                "Aqtobe": "24e,0,p5,0,r|24e,0,6s,0,r||",
                "Arabian": "24f,0,47,0,r|24f,0,bp,0,r||",
                "Argentina": "16u,0,47,0,r|16u,0,6s,0,r||",
                "Argentina_Western": "q7,0,16u,0,47,0,r|q7,0,16u,0,6s,0,r||",
                "Armenia": "24i,0,47,0,r|24i,0,6s,0,r||",
                "Atlantic": "24s,0,47,0,r|24s,0,bp,0,r||",
                "Australia_Central": "r9,0,p1,0,47,0,r|r9,0,p1,0,bp,0,r||",
                "Australia_CentralWestern": "r9,0,p1,0,q7,0,47,0,r|r9,0,p1,0,q7,0,bp,0,r||",
                "Australia_Eastern": "r9,0,sq,0,47,0,r|r9,0,sq,0,bp,0,r||",
                "Australia_Western": "r9,0,q7,0,47,0,r|r9,0,q7,0,bp,0,r||",
                "Azerbaijan": "24v,0,47,0,r|24v,0,6s,0,r||",
                "Azores": "3e5,0,47,0,r|3e4,0,6s,0,r||",
                "Bangladesh": "250,0,47,0,r|250,0,6s,0,r||",
                "Bhutan": "3e2,0,r|||",
                "Bolivia": "3e1,0,r|||",
                "Brasilia": "251,0,47,0,r|251,0,6s,0,r||",
                "Brunei": "3dv,0,3du,0,r|||",
                "Cape_Verde": "252,0,253,0,47,0,r|252,0,253,0,6s,0,r||",
                "Chamorro": "3dr,0,47,0,r|||",
                "Chatham": "254,0,47,0,r|254,0,bp,0,r||",
                "Chile": "255,0,47,0,r|255,0,6s,0,r||",
                "China": "259,0,47,0,r|259,0,bp,0,r||",
                "Choibalsan": "25b,0,47,0,r|25b,0,6s,0,r||",
                "Christmas": "3dm,0,11i,0,r|||",
                "Cocos": "3dk,0,ob,0,r|||",
                "Colombia": "25g,0,47,0,r|25g,0,6s,0,r||",
                "Cook": "25h,0,ob,0,47,0,r|25h,0,ob,0,3dg,0,6s,0,r||",
                "Cuba": "25i,0,47,0,r|25i,0,bp,0,r||",
                "Davis": "3de,0,r|||",
                "DumontDUrville": "3dd,5,1fn,0,3db,0,r|||",
                "East_Timor": "11p,0,3da,0,r|||",
                "Easter": "25k,0,11i,0,47,0,r|25k,0,11i,0,6s,0,r||",
                "Ecuador": "3d8,0,r|||",
                "Europe_Central": "p1,0,tp,0,47,0,r|p1,0,tp,0,6s,0,r||",
                "Europe_Eastern": "sq,0,tp,0,47,0,r|sq,0,tp,0,6s,0,r||",
                "Europe_Further_Eastern": "3d6,5,11p,0,tp,0,r|||",
                "Europe_Western": "q7,0,tp,0,47,0,r|q7,0,tp,0,6s,0,r||",
                "Falkland": "25n,0,ob,0,47,0,r|25n,0,ob,0,6s,0,r||",
                "Fiji": "25o,0,47,0,r|25o,0,6s,0,r||",
                "French_Guiana": "3d3,0,25p,0,r|||",
                "French_Southern": "3d1,0,3d0,0,31,0,3cv,0,r|||",
                "Galapagos": "3cu,0,r|||",
                "Gambier": "3ct,0,r|||",
                "Georgia": "1fo,0,47,0,r|1fo,0,6s,0,r||",
                "Gilbert_Islands": "3cr,0,ob,0,r|||",
                "GMT": "3cq,0,3cp,0,r|||",
                "Greenland_Eastern": "11p,0,17h,0,47,0,r|11p,0,17h,0,6s,0,r||",
                "Greenland_Western": "14f,0,17h,0,47,0,r|14f,0,17h,0,6s,0,r||",
                "Guam": "3cn,0,p5,0,r|||",
                "Gulf": "3cm,0,47,0,r|||",
                "Guyana": "25p,0,r|||",
                "Hawaii_Aleutian": "25r,5,25q,0,47,0,r|25r,5,25q,0,bp,0,r||",
                "Hong_Kong": "25l,0,47,0,r|25l,0,6s,0,r||",
                "Hovd": "25j,0,47,0,r|25j,0,6s,0,r||",
                "India": "3ch,0,47,0,r||15a|",
                "Indian_Ocean": "3cg,0,3cf,0,r|||",
                "Indochina": "3ce,0,r|||",
                "Indonesia_Central": "p1,0,1iu,0,r|||",
                "Indonesia_Eastern": "sq,0,1iu,0,r|||",
                "Indonesia_Western": "q7,0,1iu,0,r|||",
                "Iran": "239,0,47,0,r|239,0,bp,0,r||",
                "Irkutsk": "238,0,47,0,r|238,0,6s,0,r||",
                "Israel": "237,0,47,0,r|237,0,bp,0,r||",
                "Japan": "236,0,47,0,r|236,0,bp,0,r||",
                "Kamchatka": "235,0,22v,0,p5,0,r|235,0,22v,0,6s,0,r||",
                "Kazakhstan_Eastern": "11p,0,22u,0,r|||",
                "Kazakhstan_Western": "14f,0,22u,0,r|||",
                "Korea": "22n,0,47,0,r|22n,0,bp,0,r||",
                "Kosrae": "3c4,0,r|||",
                "Krasnoyarsk": "22j,0,47,0,r|22j,0,6s,0,r||",
                "Kyrgystan": "3c2,0,r|||",
                "Lanka": "3c1,0,r|||",
                "Line_Islands": "3c0,0,ob,0,r|||",
                "Lord_Howe": "22g,0,22f,0,47,0,r|22g,0,22f,0,bp,0,r||",
                "Macau": "22e,0,p5,0,r|22e,0,6s,0,r||",
                "Macquarie": "3bs,0,11i,0,r|||",
                "Magadan": "22c,0,47,0,r|22c,0,6s,0,r||",
                "Malaysia": "3bq,0,r|||",
                "Maldives": "3bp,0,r|||",
                "Marquesas": "3bo,0,r|||",
                "Marshall_Islands": "3bn,0,ob,0,r|||",
                "Mauritius": "22a,0,47,0,r|22a,0,6s,0,r||",
                "Mawson": "3bl,0,r|||",
                "Mexico_Northwest": "227,0,223,0,47,0,r|227,0,223,0,bp,0,r||",
                "Mexico_Pacific": "222,0,17n,0,47,0,r|222,0,17n,0,bp,0,r||",
                "Mongolia": "221,0,21o,0,47,0,r|221,0,21o,0,6s,0,r||",
                "Moscow": "21e,0,47,0,r|21e,0,6s,0,r||",
                "Myanmar": "3be,0,r|||",
                "Nauru": "3bd,0,r|||",
                "Nepal": "3bc,0,r|||",
                "New_Caledonia": "1je,0,21a,0,47,0,r|1je,0,21a,0,6s,0,r||",
                "New_Zealand": "217,0,47,0,r|217,0,bp,0,r||",
                "Newfoundland": "213,0,47,0,r|213,0,bp,0,r||",
                "Niue": "3b7,0,r|||",
                "Norfolk": "3b6,0,11i,0,r|||",
                "Noronha": "212,0,1fn,0,20t,0,47,0,r|212,0,1fn,0,20t,0,6s,0,r||",
                "North_Mariana": "3b3,0,3b2,0,ob,0,r|||",
                "Novosibirsk": "20s,0,47,0,r|20s,0,6s,0,r||",
                "Omsk": "20r,0,47,0,r|20r,0,6s,0,r||",
                "Pakistan": "20o,0,47,0,r|20o,0,6s,0,r||",
                "Palau": "3au,0,r|||",
                "Papua_New_Guinea": "3at,0,1je,0,3as,0,r|||",
                "Paraguay": "20l,0,47,0,r|20l,0,6s,0,r||",
                "Peru": "20k,0,47,0,r|20k,0,6s,0,r||",
                "Philippines": "20h,0,47,0,r|20h,0,6s,0,r||",
                "Phoenix_Islands": "3ao,0,ob,0,r|||",
                "Pierre_Miquelon": "20g,0,20f,0,31,0,20d,0,47,0,r|20g,0,20f,0,31,0,20d,0,bp,0,r||",
                "Pitcairn": "3ak,0,r|||",
                "Ponape": "3aj,0,r|||",
                "Pyongyang": "3ai,0,r|||",
                "Qyzylorda": "20c,0,p5,0,r|20c,0,6s,0,r||",
                "Reunion": "3ag,0,r|||",
                "Rothera": "3af,0,r|||",
                "Sakhalin": "1tm,0,47,0,r|1tm,0,6s,0,r||",
                "Samara": "1tl,0,p5,0,r|1tl,0,6s,0,r||",
                "Samoa": "1tk,0,47,0,r|1tk,0,bp,0,r||",
                "Seychelles": "38a,0,r|||",
                "Singapore": "389,0,47,0,r|||",
                "Solomon": "388,0,ob,0,r|||",
                "South_Georgia": "387,0,1fo,0,r|||",
                "Suriname": "386,0,r|||",
                "Syowa": "385,0,r|||",
                "Tahiti": "384,0,r|||",
                "Taipei": "1tf,0,47,0,r|1tf,0,bp,0,r||",
                "Tajikistan": "382,0,r|||",
                "Tokelau": "381,0,r|||",
                "Tonga": "1td,0,47,0,r|1td,0,6s,0,r||",
                "Truk": "37v,0,r|||",
                "Turkmenistan": "1t8,0,47,0,r|1t8,0,6s,0,r||",
                "Tuvalu": "37s,0,r|||",
                "Uruguay": "1t7,0,47,0,r|1t7,0,6s,0,r||",
                "Uzbekistan": "1t4,0,47,0,r|1t4,0,6s,0,r||",
                "Vanuatu": "1t3,0,47,0,r|1t3,0,6s,0,r||",
                "Venezuela": "37n,0,r|||",
                "Vladivostok": "1t1,0,47,0,r|1t1,0,6s,0,r||",
                "Volgograd": "1t0,0,47,0,r|1t0,0,6s,0,r||",
                "Vostok": "37i,0,r|||",
                "Wake": "37h,0,11i,0,r|||",
                "Wallis": "37f,0,37e,0,37d,0,r|||",
                "Yakutsk": "1sv,0,47,0,r|1sv,0,6s,0,r||",
                "Yekaterinburg": "1su,0,47,0,r|1su,0,6s,0,r||"
            }
        },
        "te": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cdl,0,do,0,68||",
                "Europe/London": "|cdm,0,ia,0,68||"
            },
            "metazone": {
                "Acre": "5m8,0,do,0,68|5m8,0,ia,0,68||",
                "Afghanistan": "ab7,0,68|||",
                "Africa_Central": "376,0,2t2,0,68|||",
                "Africa_Eastern": "1er,0,2t2,0,68|||",
                "Africa_Southern": "4ra,0,2t2,0,do,0,68|||",
                "Africa_Western": "1br,0,2t2,0,do,0,68|1br,0,2t2,0,ia,0,68||",
                "Alaska": "5ll,0,do,0,68|5ll,0,vr,0,68||",
                "Almaty": "5lf,0,do,0,68|5lf,0,ia,0,68||",
                "Amazon": "5ld,0,do,0,68|5ld,0,ia,0,68||",
                "America_Central": "2hf,0,do,0,68|2hf,0,vr,0,68||",
                "America_Eastern": "1er,0,do,0,68|1er,0,vr,0,68||",
                "America_Mountain": "5ki,0,do,0,68|5ki,0,vr,0,68||",
                "America_Pacific": "36e,0,do,0,68|36e,0,vr,0,68||",
                "Anadyr": "5ke,0,do,0,68|5ke,0,ia,0,68||",
                "Apia": "5k9,0,do,0,68|5k9,0,vr,0,68||",
                "Aqtau": "5k7,0,do,0,68|5k7,0,ia,0,68||",
                "Aqtobe": "5k5,0,do,0,68|5k5,0,ia,0,68||",
                "Arabian": "5k4,0,do,0,68|5k4,0,vr,0,1pl,0,68||",
                "Argentina": "4rd,0,do,0,68|abr,0,ia,0,68||",
                "Argentina_Western": "1br,0,4rd,0,do,0,68|1br,0,4rd,0,ia,0,68||",
                "Armenia": "5k1,0,do,0,68|5k1,0,ia,0,68||",
                "Atlantic": "5ju,0,do,0,68|5ju,0,vr,0,68||",
                "Australia_Central": "2ua,0,2hf,0,do,0,68|2ua,0,2hf,0,vr,0,68||",
                "Australia_CentralWestern": "2hf,0,2ua,0,1br,0,do,0,68|2hf,0,4re,0,1br,0,vr,0,68||",
                "Australia_Eastern": "1er,0,2ua,0,do,0,68|1er,0,2ua,0,vr,0,68||",
                "Australia_Western": "1br,0,4re,0,do,0,68|1br,0,4re,0,vr,0,68||",
                "Azerbaijan": "5j4,0,do,0,68|5j4,0,ia,0,68||",
                "Azores": "5j3,0,do,0,68|5j3,0,ia,0,68||",
                "Bangladesh": "5j2,0,do,0,68|5j2,0,ia,0,68||",
                "Bhutan": "ac3,0,68|||",
                "Bolivia": "ac4,0,68|||",
                "Brasilia": "5j1,0,do,0,68|5j1,0,ia,0,68||",
                "Brunei": "ac6,0,ac7,0,68|||",
                "Cape_Verde": "5iu,0,5iq,0,do,0,68|5iu,0,5iq,0,ia,0,68||",
                "Chamorro": "aca,0,do,0,68|||",
                "Chatham": "5io,0,do,0,68|5io,0,vr,0,1pl,0,68||",
                "Chile": "5im,0,do,0,68|5im,0,ia,0,68||",
                "China": "5il,0,do,0,68|5il,0,vr,0,1pl,0,68||",
                "Choibalsan": "5ij,0,do,0,68|5ij,0,ia,0,68||",
                "Christmas": "acf,0,2j5,0,68|||",
                "Cocos": "ach,0,1kc,0,68|||",
                "Colombia": "5ig,0,do,0,68|5ig,0,ia,0,68||",
                "Cook": "5if,0,1kc,0,do,0,68|5if,0,1kc,0,acl,0,ia,0,68||",
                "Cuba": "5ie,0,do,0,68|5ie,0,vr,0,68||",
                "Davis": "acn,0,68|||",
                "DumontDUrville": "aco,5,acp,0,68|||",
                "East_Timor": "1er,0,acq,0,68|||",
                "Easter": "5id,0,2j5,0,do,0,68|5id,0,2j5,0,ia,0,68||",
                "Ecuador": "acs,0,68|||",
                "Europe_Central": "376,0,2a4,0,do,0,68|376,0,2a4,0,ia,0,68||",
                "Europe_Eastern": "1er,0,2a4,0,do,0,68|1er,0,2a4,0,ia,0,68||",
                "Europe_Further_Eastern": "acu,5,1er,0,2a4,0,68|||",
                "Europe_Western": "1br,0,2a4,0,do,0,68|1br,0,2a4,0,ia,0,68||",
                "Falkland": "5i9,0,1kc,0,do,0,68|5i9,0,1kc,0,ia,0,68||",
                "Fiji": "5i8,0,do,0,68|5i8,0,ia,0,68||",
                "French_Guiana": "5i7,0,5i6,0,68|||",
                "French_Southern": "5i7,0,4ra,0,35h,0,ad4,0,68|||",
                "Galapagos": "ad5,0,68|||",
                "Gambier": "ad6,0,68|||",
                "Georgia": "4rm,0,do,0,68|4rm,0,ia,0,68||",
                "Gilbert_Islands": "ad8,0,1kc,0,68|||",
                "GMT": "ad9,0,ada,0,68|||",
                "Greenland_Eastern": "1er,0,35f,0,do,0,68|1er,0,35f,0,ia,0,68||",
                "Greenland_Western": "1br,0,35f,0,do,0,68|1br,0,35f,0,ia,0,68||",
                "Guam": "adc,0,do,0,68|||",
                "Gulf": "add,0,do,0,68|||",
                "Guyana": "5i6,0,68|||",
                "Hawaii_Aleutian": "5hs,5,5hl,0,do,0,68|5hs,5,5hl,0,vr,0,1pl,0,68||",
                "Hong_Kong": "5hk,0,do,0,68|5hk,0,ia,0,68||",
                "Hovd": "5hf,0,do,0,68|5hf,0,ia,0,68||",
                "India": "adi,0,68||15a|",
                "Indian_Ocean": "adj,0,adk,0,adl,0,68|||",
                "Indochina": "adm,0,68|||",
                "Indonesia_Central": "376,0,4rn,0,68|||",
                "Indonesia_Eastern": "1er,0,4rn,0,68|||",
                "Indonesia_Western": "1br,0,4rn,0,68|||",
                "Iran": "5hd,0,do,0,68|5hd,0,vr,0,1pl,0,68||",
                "Irkutsk": "5h6,0,do,0,68|5h6,0,ia,0,68||",
                "Israel": "5h4,0,do,0,68|5h4,0,vr,0,1pl,0,68||",
                "Japan": "5h3,0,do,0,68|5h3,0,vr,0,1pl,0,68||",
                "Kamchatka": "5h2,5,5h1,0,do,0,68|5h2,5,5h1,0,ia,0,68||",
                "Kazakhstan_Eastern": "1er,0,adu,0,68|||",
                "Kazakhstan_Western": "1br,0,adv,0,68|||",
                "Korea": "5gv,0,do,0,68|5gv,0,vr,0,1pl,0,68||",
                "Kosrae": "ae1,0,68|||",
                "Krasnoyarsk": "5gs,0,do,0,68|5gs,0,ia,0,68||",
                "Kyrgystan": "ae3,0,68|||",
                "Lanka": "ae4,0,68|||",
                "Line_Islands": "ae5,0,1kc,0,68|||",
                "Lord_Howe": "5gr,0,5gp,0,do,0,68|5gr,0,5gp,0,vr,0,68||",
                "Macau": "5gh,0,do,0,68|5gh,0,ia,0,68||",
                "Macquarie": "ae9,0,2j5,0,68|||",
                "Magadan": "5gg,0,do,0,68|5gg,0,ia,0,68||",
                "Malaysia": "aeb,0,68|||",
                "Maldives": "aec,0,68|||",
                "Marquesas": "aed,0,68|||",
                "Marshall_Islands": "aee,0,1kc,0,68|||",
                "Mauritius": "5gf,0,do,0,68|5gf,0,ia,0,68||",
                "Mawson": "aeg,0,68|||",
                "Mexico_Northwest": "5ge,0,5g9,0,do,0,68|5ge,0,5g9,0,vr,0,68||",
                "Mexico_Pacific": "5g8,0,36e,0,do,0,68|5g8,0,36e,0,vr,0,68||",
                "Mongolia": "5g7,0,5g5,0,do,0,68|5g7,0,5g5,0,ia,0,68||",
                "Moscow": "5g4,0,do,0,68|5g4,0,ia,0,68||",
                "Myanmar": "aen,0,68|||",
                "Nauru": "aeo,0,68|||",
                "Nepal": "aep,0,68|||",
                "New_Caledonia": "4rp,0,5g1,0,do,0,68|4rp,0,5g1,0,ia,0,68||",
                "New_Zealand": "5g0,0,do,0,68|5g0,0,vr,0,1pl,0,68||",
                "Newfoundland": "5fu,0,5ft,0,do,0,68|5fu,0,5ft,0,vr,0,68||",
                "Niue": "aev,0,68|||",
                "Norfolk": "af0,0,2j5,0,68|||",
                "Noronha": "5fp,0,5fn,0,5fl,0,do,0,68|5fp,0,5fn,0,5fl,0,ia,0,68||",
                "North_Mariana": "af4,0,af5,0,1kc,0,68|||",
                "Novosibirsk": "af6,0,do,0,68|af7,0,ia,0,68||",
                "Omsk": "5fk,0,do,0,68|5fk,0,ia,0,68||",
                "Pakistan": "af9,0,do,0,68|afa,0,ia,0,68||",
                "Palau": "afb,0,68|||",
                "Papua_New_Guinea": "afc,0,4rp,0,afd,0,68|||",
                "Paraguay": "5fj,0,do,0,68|5fj,0,ia,0,68||",
                "Peru": "5fi,0,do,0,68|5fi,0,ia,0,68||",
                "Philippines": "5fg,0,do,0,68|5fg,0,ia,0,68||",
                "Phoenix_Islands": "afh,0,1kc,0,68|||",
                "Pierre_Miquelon": "5fd,0,afj,0,35h,0,5fc,0,do,0,68|5fd,0,afl,0,35h,0,5fc,0,vr,0,68||",
                "Pitcairn": "afm,0,68|||",
                "Ponape": "afn,0,68|||",
                "Pyongyang": "afo,0,68|||",
                "Qyzylorda": "5fb,0,do,0,68|5fb,0,ia,0,68||",
                "Reunion": "afq,0,68|||",
                "Rothera": "afr,0,68|||",
                "Sakhalin": "5f5,0,do,0,68|5f5,0,ia,0,68||",
                "Samara": "5f2,0,do,0,68|5f2,0,ia,0,68||",
                "Samoa": "5f0,0,do,0,68|5f0,0,ia,0,68||",
                "Seychelles": "afv,0,68|||",
                "Singapore": "ag0,0,do,0,68|||",
                "Solomon": "ag1,0,1kc,0,68|||",
                "South_Georgia": "4ra,0,4rm,0,68|||",
                "Suriname": "ag2,0,68|||",
                "Syowa": "ag3,0,68|||",
                "Tahiti": "ag4,0,68|||",
                "Taipei": "5ev,0,do,0,68|5ev,0,vr,0,ag6,0,68||",
                "Tajikistan": "ag7,0,68|||",
                "Tokelau": "ag8,0,68|||",
                "Tonga": "5e3,0,do,0,68|5e3,0,ia,0,68||",
                "Truk": "aga,0,68|||",
                "Turkmenistan": "5e2,0,do,0,68|5e2,0,ia,0,68||",
                "Tuvalu": "agc,0,68|||",
                "Uruguay": "5e1,0,do,0,68|5e1,0,ia,0,68||",
                "Uzbekistan": "5e0,0,do,0,68|5e0,0,ia,0,68||",
                "Vanuatu": "5dv,0,do,0,68|5dv,0,ia,0,68||",
                "Venezuela": "agg,0,68|||",
                "Vladivostok": "5du,0,do,0,68|5du,0,ia,0,68||",
                "Volgograd": "5dt,0,do,0,68|5dt,0,ia,0,68||",
                "Vostok": "agj,0,68|||",
                "Wake": "agk,0,2j5,0,68|||",
                "Wallis": "agl,0,35h,0,agm,0,68|||",
                "Yakutsk": "5dq,0,do,0,68|5dq,0,ia,0,68||",
                "Yekaterinburg": "5dm,0,do,0,68|5dm,0,ia,0,68||"
            }
        },
        "teo-KE": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "teo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "th": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cdn||",
                "Europe/London": "|cdo||"
            },
            "metazone": {
                "Acre": "agp|agq||",
                "Afghanistan": "agr|||",
                "Africa_Central": "ags|||",
                "Africa_Eastern": "agt|||",
                "Africa_Southern": "agu|||",
                "Africa_Western": "agv|ah0||",
                "Alaska": "ah1|ah2||",
                "Almaty": "ah3|ah4||",
                "Amazon": "ah5|ah6||",
                "America_Central": "ah7|ah8||",
                "America_Eastern": "ah9|aha||",
                "America_Mountain": "ahb|ahc||",
                "America_Pacific": "ahd|ahe||",
                "Anadyr": "ahf|ahg||",
                "Apia": "ahh|ahi||",
                "Aqtau": "ahj|ahk||",
                "Aqtobe": "ahl|ahm||",
                "Arabian": "ahn|aho||",
                "Argentina": "ahp|ahq||",
                "Argentina_Western": "ahr|ahs||",
                "Armenia": "aht|ahu||",
                "Atlantic": "ahv|ai0||",
                "Australia_Central": "ai1|ai2||",
                "Australia_CentralWestern": "ai3|ai4||",
                "Australia_Eastern": "ai5|ai6||",
                "Australia_Western": "ai7|ai8||",
                "Azerbaijan": "ai9|aia||",
                "Azores": "aib|aic||",
                "Bangladesh": "aid|aie||",
                "Bhutan": "aif|||",
                "Bolivia": "aig|||",
                "Brasilia": "aih|aii||",
                "Brunei": "aij|||",
                "Cape_Verde": "aik|ail||",
                "Casey": "aim|||",
                "Chamorro": "ain|||",
                "Chatham": "aio|aip||",
                "Chile": "aiq|air||",
                "China": "ais|ait||",
                "Choibalsan": "aiu|aiv||",
                "Christmas": "aj0|||",
                "Cocos": "aj1|||",
                "Colombia": "aj2|aj3||",
                "Cook": "aj4|aj5||",
                "Cuba": "aj6|aj7||",
                "Davis": "aj8|||",
                "DumontDUrville": "aj9|||",
                "East_Timor": "aja|||",
                "Easter": "ajb|ajc||",
                "Ecuador": "ajd|||",
                "Europe_Central": "aje|ajf||",
                "Europe_Eastern": "ajg|ajh||",
                "Europe_Further_Eastern": "aji|||",
                "Europe_Western": "ajj|ajk||",
                "Falkland": "ajl|ajm||",
                "Fiji": "ajn|ajo||",
                "French_Guiana": "ajp|||",
                "French_Southern": "ajq|||",
                "Galapagos": "ajr|||",
                "Gambier": "ajs|||",
                "Georgia": "ajt|aju||",
                "Gilbert_Islands": "ajv|||",
                "GMT": "ak0|||",
                "Greenland_Eastern": "ak1|ak2||",
                "Greenland_Western": "ak3|ak4||",
                "Guam": "ak5|||",
                "Gulf": "ak6|||",
                "Guyana": "ak7|||",
                "Hawaii_Aleutian": "ak8,5,5dk|aka,5,5dk||",
                "Hong_Kong": "akb|akc||",
                "Hovd": "akd|ake||",
                "India": "akf|||",
                "Indian_Ocean": "akg|||",
                "Indochina": "akh|||",
                "Indonesia_Central": "aki|||",
                "Indonesia_Eastern": "akj|||",
                "Indonesia_Western": "akk|||",
                "Iran": "akl|akm||",
                "Irkutsk": "akn|ako||",
                "Israel": "akp|akq||",
                "Japan": "akr|aks||",
                "Kamchatka": "akt,5,5di|akv,5,5di||",
                "Kazakhstan_Eastern": "al0|||",
                "Kazakhstan_Western": "al1|||",
                "Korea": "al2|al3||",
                "Kosrae": "al4|||",
                "Krasnoyarsk": "al5|al6||",
                "Kyrgystan": "al7|||",
                "Lanka": "al8|||",
                "Line_Islands": "al9|||",
                "Lord_Howe": "ala|alb||",
                "Macau": "alc|ald||",
                "Macquarie": "ale|||",
                "Magadan": "alf|alg||",
                "Malaysia": "alh|||",
                "Maldives": "ali|||",
                "Marquesas": "alj|||",
                "Marshall_Islands": "alk|||",
                "Mauritius": "all|alm||",
                "Mawson": "aln|||",
                "Mexico_Northwest": "alo|alp||",
                "Mexico_Pacific": "alq|alr||",
                "Mongolia": "als|alt||",
                "Moscow": "alu|alv||",
                "Myanmar": "am0|||",
                "Nauru": "am1|||",
                "Nepal": "am2|||",
                "New_Caledonia": "am3|am4||",
                "New_Zealand": "am5|am6||",
                "Newfoundland": "am7|am8||",
                "Niue": "am9|||",
                "Norfolk": "ama|||",
                "Noronha": "amb|amc||",
                "North_Mariana": "amd|||",
                "Novosibirsk": "ame|amf||",
                "Omsk": "amg|amh||",
                "Pakistan": "ami|amj||",
                "Palau": "amk|||",
                "Papua_New_Guinea": "aml|||",
                "Paraguay": "amm|amn||",
                "Peru": "amo|amp||",
                "Philippines": "amq|amr||",
                "Phoenix_Islands": "ams|||",
                "Pierre_Miquelon": "amt|amu||",
                "Pitcairn": "amv|||",
                "Ponape": "an0|||",
                "Pyongyang": "an1|||",
                "Qyzylorda": "an2|an3||",
                "Reunion": "an4|||",
                "Rothera": "an5|||",
                "Sakhalin": "an6|an7||",
                "Samara": "an8|an9||",
                "Samoa": "ana|anb||",
                "Seychelles": "anc|||",
                "Singapore": "and|||",
                "Solomon": "ane|||",
                "South_Georgia": "anf|||",
                "Suriname": "ang|||",
                "Syowa": "anh|||",
                "Tahiti": "ani|||",
                "Taipei": "anj|ank||",
                "Tajikistan": "anl|||",
                "Tokelau": "anm|||",
                "Tonga": "ann|ano||",
                "Truk": "anp|||",
                "Turkmenistan": "anq|anr||",
                "Tuvalu": "ans|||",
                "Uruguay": "ant|anu||",
                "Uzbekistan": "anv|ao0||",
                "Vanuatu": "ao1|ao2||",
                "Venezuela": "ao3|||",
                "Vladivostok": "ao4|ao5||",
                "Volgograd": "ao6|ao7||",
                "Vostok": "ao8|||",
                "Wake": "ao9|||",
                "Wallis": "aoa|||",
                "Yakutsk": "aob|aoc||",
                "Yekaterinburg": "aod|aoe||"
            }
        },
        "ti-ER": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ti": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "tk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|cdp,k,0,6i,0,9t||",
                "Europe/London": "|cdq,0,cdr,k,0,gb,0,9t||"
            },
            "metazone": {
                "Afghanistan": "aof|||",
                "Africa_Central": "1c2,0,c5|||",
                "Africa_Eastern": "1kf,0,c5|||",
                "Africa_Southern": "2vv,0,c5,k,0,6i,0,9t|||",
                "Africa_Western": "1h5,0,c5,k,0,6i,0,9t|1h5,0,c5,k,0,gb,0,9t||",
                "Alaska": "5da,k,0,6i,0,9t|5da,k,0,gb,0,9t||",
                "Amazon": "2k3,k,0,6i,0,9t|2k3,k,0,gb,0,9t||",
                "America_Central": "1c2,0,m2,k,0,6i,0,9t|1c2,0,m2,k,0,gb,0,9t||",
                "America_Eastern": "2vv,0,m2,k,0,6i,0,9t|2vv,0,m2,k,0,gb,0,9t||",
                "America_Mountain": "5d5,0,5d4,k,0,6i,0,9t,0,5d2|5d5,0,5d4,k,0,gb,0,9t,0,5d2||",
                "America_Pacific": "34j,0,34i,k,0,6i,0,9t|34j,0,34i,k,0,gb,0,9t||",
                "Apia": "3e,k,0,6i,0,9t|3e,k,0,gb,0,9t||",
                "Arabian": "5cv,0,5cr,k,0,6i,0,9t|5cv,0,5cr,k,0,gb,0,9t||",
                "Argentina": "1e,k,0,6i,0,9t|1e,k,0,gb,0,9t||",
                "Argentina_Western": "1h5,0,1e,k,0,6i,0,9t|1h5,0,1e,k,0,gb,0,9t||",
                "Armenia": "2k6,k,0,6i,0,9t|2k6,k,0,gb,0,9t||",
                "Atlantic": "2k7,k,0,6i,0,9t|2k7,k,0,gb,0,9t||",
                "Australia_Central": "1c2,0,1rb,k,0,6i,0,9t|1c2,0,1rb,k,0,gb,0,9t||",
                "Australia_CentralWestern": "1c2,0,1rb,k,0,5ck,0,5cj,k,0,6i,0,9t|1c2,0,1rb,k,0,5ck,0,5cj,k,0,gb,0,9t||",
                "Australia_Eastern": "1kf,0,1rb,k,0,6i,0,9t|1kf,0,1rb,k,0,gb,0,9t||",
                "Australia_Western": "1h5,0,1rb,k,0,6i,0,9t|1h5,0,1rb,k,0,gb,0,9t||",
                "Azerbaijan": "5ci,k,0,6i,0,9t|5ci,k,0,gb,0,9t||",
                "Azores": "1lg,0,19b,k,0,6i,0,9t|1lg,0,19b,k,0,gb,0,9t||",
                "Bangladesh": "2kb,k,0,6i,0,9t|2kb,k,0,gb,0,9t||",
                "Bhutan": "1k4|||",
                "Bolivia": "ap7|||",
                "Brasilia": "5cb,k,0,6i,0,9t|5cb,k,0,gb,0,9t||",
                "Brunei": "ap9,5,a4|||",
                "Cape_Verde": "2kc,5,5c4,k,0,6i,0,9t|2kc,5,5c4,k,0,gb,0,9t||",
                "Chamorro": "4mm|||",
                "Chatham": "5c3,k,0,6i,0,9t|5c3,k,0,gb,0,9t||",
                "Chile": "2i3,k,0,6i,0,9t|2i3,k,0,gb,0,9t||",
                "China": "5c2,k,0,6i,0,9t|5c2,k,0,gb,0,9t||",
                "Choibalsan": "5c1,k,0,6i,0,9t|5c1,k,0,gb,0,9t||",
                "Christmas": "apf,0,349|||",
                "Cocos": "1eg,0,19b|||",
                "Colombia": "5bv,k,0,6i,0,9t|5bv,k,0,gb,0,9t||",
                "Cook": "4dg,0,19b,k,0,6i,0,9t|4dg,0,19b,k,0,gb,0,9t||",
                "Cuba": "tb,k,0,6i,0,9t|tb,k,0,gb,0,9t||",
                "Davis": "api|||",
                "DumontDUrville": "apj,5,apk,5,apl|||",
                "East_Timor": "1kf,0,7n|||",
                "Easter": "5bu,0,349,k,0,6i,0,9t|5bu,0,349,k,0,gb,0,9t||",
                "Ecuador": "7lf|||",
                "Europe_Central": "1c2,0,2ac,k,0,6i,0,9t|1c2,0,2ac,k,0,gb,0,9t||",
                "Europe_Eastern": "1kf,0,2ac,k,0,6i,0,9t|1kf,0,2ac,k,0,gb,0,9t||",
                "Europe_Further_Eastern": "apo,0,1kf,0,2ac|||",
                "Europe_Western": "1h5,0,2ac,k,0,6i,0,9t|1h5,0,2ac,k,0,gb,0,9t||",
                "Falkland": "1ov,0,19b,k,0,6i,0,9t|1ov,0,19b,k,0,gb,0,9t||",
                "Fiji": "4q,k,0,6i,0,9t|4q,k,0,gb,0,9t||",
                "French_Guiana": "2ke,0,8h5|||",
                "French_Southern": "2vv,0,2ke,0,346,0,27v|||",
                "Galapagos": "ak,0,19b|||",
                "Gambier": "apr|||",
                "Georgia": "5bo,k,0,6i,0,9t|5bo,k,0,gb,0,9t||",
                "Gilbert_Islands": "4i0,0,19b|||",
                "GMT": "apt,0,apu,0,apv,0,9t|||",
                "Greenland_Eastern": "1kf,0,344,k,0,6i,0,9t|1kf,0,344,k,0,gb,0,9t||",
                "Greenland_Western": "1h5,0,344,k,0,6i,0,9t|1h5,0,344,k,0,gb,0,9t||",
                "Gulf": "aq1,0,aq2,k,0,6i,0,9t|||",
                "Guyana": "aq3|||",
                "Hawaii_Aleutian": "5b8,5,1l3,k,0,6i,0,9t|5b8,5,1l3,k,0,gb,0,9t||",
                "Hong_Kong": "2kh,k,0,6i,0,9t|2kh,k,0,gb,0,9t||",
                "Hovd": "5b5,k,0,6i,0,9t|5b5,k,0,gb,0,9t||",
                "India": "30i|||",
                "Indian_Ocean": "1to,0,aq7|||",
                "Indochina": "aq8|||",
                "Indonesia_Central": "1c2,0,4rt|||",
                "Indonesia_Eastern": "1kf,0,4rt|||",
                "Indonesia_Western": "1h5,0,4rt|||",
                "Iran": "5b3,k,0,6i,0,9t|5b3,k,0,gb,0,9t||",
                "Irkutsk": "3h,k,0,6i,0,9t|3h,k,0,gb,0,9t||",
                "Israel": "5b1,k,0,6i,0,9t|5b1,k,0,gb,0,9t||",
                "Japan": "5b0,k,0,6i,0,9t|5b0,k,0,gb,0,9t||",
                "Kazakhstan_Eastern": "1kf,0,5av|||",
                "Kazakhstan_Western": "1h5,0,5av|||",
                "Korea": "5as,k,0,6i,0,9t|5as,k,0,gb,0,9t||",
                "Kosrae": "aqf|||",
                "Krasnoyarsk": "5ao,k,0,6i,0,9t|5ao,k,0,gb,0,9t||",
                "Kyrgystan": "aqh|||",
                "Line_Islands": "aqi,0,19b|||",
                "Lord_Howe": "1u,5,1i2,k,0,6i,0,9t|1u,5,1i2,k,0,gb,0,9t||",
                "Macquarie": "4ru|||",
                "Magadan": "2o,k,0,6i,0,9t|2o,k,0,gb,0,9t||",
                "Malaysia": "aqk|||",
                "Maldives": "aql|||",
                "Marquesas": "1jm,0,19b|||",
                "Marshall_Islands": "4m6,0,19b|||",
                "Mauritius": "5ak,k,0,6i,0,9t|5ak,k,0,gb,0,9t||",
                "Mawson": "2v0|||",
                "Mexico_Northwest": "5aj,5,5ai,0,10g,k,0,6i,0,9t|5aj,5,5ai,0,10g,k,0,gb,0,9t||",
                "Mexico_Pacific": "5ag,0,34j,0,34i,k,0,6i,0,9t|5ag,0,34j,0,34i,k,0,gb,0,9t||",
                "Mongolia": "4f,5,2m,k,0,6i,0,9t|4f,5,2m,k,0,gb,0,9t||",
                "Moscow": "36c,k,0,6i,0,9t|36c,k,0,gb,0,9t||",
                "Myanmar": "aqq|||",
                "Nauru": "5v|||",
                "Nepal": "8u|||",
                "New_Caledonia": "30l,0,5ab,k,0,6i,0,9t|30l,0,5ab,k,0,gb,0,9t||",
                "New_Zealand": "30l,0,5a6,k,0,6i,0,9t|30l,0,5a6,k,0,gb,0,9t||",
                "Newfoundland": "5a1,k,0,6i,0,9t|5a1,k,0,gb,0,9t||",
                "Niue": "8g|||",
                "Norfolk": "6l|||",
                "Noronha": "23a,5,4i,5,5a0,k,0,6i,0,9t|23a,5,4i,5,5a0,k,0,gb,0,9t||",
                "Novosibirsk": "16c,k,0,6i,0,9t|ar0,k,0,gb,0,9t||",
                "Omsk": "26,k,0,6i,0,9t|26,k,0,gb,0,9t||",
                "Pakistan": "59p,k,0,6i,0,9t|59p,k,0,gb,0,9t||",
                "Palau": "9b|||",
                "Papua_New_Guinea": "9a,0,5,0,30l,0,ar2|||",
                "Paraguay": "598,k,0,6i,0,9t|598,k,0,gb,0,9t||",
                "Peru": "4n,k,0,6i,0,9t|4n,k,0,gb,0,9t||",
                "Philippines": "593,k,0,6i,0,9t|593,k,0,gb,0,9t||",
                "Phoenix_Islands": "1a7,0,19b|||",
                "Pierre_Miquelon": "14i,0,58v,0,346,0,u2,k,0,6i,0,9t|14i,0,58v,0,346,0,u2,k,0,gb,0,9t||",
                "Pitcairn": "1ko|||",
                "Ponape": "9s|||",
                "Reunion": "ar6|||",
                "Rothera": "1po|||",
                "Sakhalin": "164,k,0,6i,0,9t|164,k,0,gb,0,9t||",
                "Samoa": "2c,k,0,6i,0,9t|2c,k,0,gb,0,9t||",
                "Seychelles": "ar7,0,19b|||",
                "Singapore": "m8,k,0,6i,0,9t|||",
                "Solomon": "b5,0,19b|||",
                "South_Georgia": "2vv,0,ar8|||",
                "Suriname": "mg|||",
                "Syowa": "ar9|||",
                "Tahiti": "ara|||",
                "Taipei": "58u,k,0,6i,0,9t|58u,k,0,gb,0,9t||",
                "Tajikistan": "arc|||",
                "Tokelau": "5d|||",
                "Tonga": "2j,k,0,6i,0,9t|2j,k,0,gb,0,9t||",
                "Truk": "4lr|||",
                "Turkmenistan": "2l2,k,0,6i,0,9t|2l2,k,0,gb,0,9t||",
                "Tuvalu": "are|||",
                "Uruguay": "58o,k,0,6i,0,9t|58o,k,0,gb,0,9t||",
                "Uzbekistan": "2l3,k,0,6i,0,9t|2l3,k,0,gb,0,9t||",
                "Vanuatu": "58l,k,0,6i,0,9t|58l,k,0,gb,0,9t||",
                "Venezuela": "ari|||",
                "Vladivostok": "15m,k,0,6i,0,9t|15m,k,0,gb,0,9t||",
                "Volgograd": "qi,k,0,6i,0,9t|qi,k,0,gb,0,9t||",
                "Vostok": "1kt|||",
                "Wake": "arj,0,349|||",
                "Wallis": "ark,0,346,0,5k|||",
                "Yakutsk": "58j,k,0,6i,0,9t|58j,k,0,gb,0,9t||",
                "Yekaterinburg": "58i,k,0,6i,0,9t|58i,k,0,gb,0,9t||"
            }
        },
        "to": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|67,0,cds,0,96,0,eg||",
                "Europe/London": "|67,0,cdt,0,96,0,ek||"
            },
            "metazone": {
                "Acre": "67,0,58g,0,96,0,eg|67,0,58g,0,96,0,ek||",
                "Afghanistan": "67,0,ars|||",
                "Africa_Central": "67,0,31e,5,1p3|||",
                "Africa_Eastern": "67,0,31e,5,1es|||",
                "Africa_Southern": "67,0,31e,5,as0|||",
                "Africa_Western": "67,0,31e,5,1a3,0,96,0,eg|67,0,31e,5,1a3,0,96,0,ek||",
                "Alaska": "67,0,584,0,96,0,eg|67,0,584,0,96,0,ek||",
                "Almaty": "67,0,582,0,96,0,eg|67,0,582,0,96,0,ek||",
                "Amazon": "67,0,57u,0,96,0,eg|67,0,57u,0,96,0,ek||",
                "America_Central": "67,0,1l1,5,1kv,0,1p3,0,96,0,eg|67,0,1l1,5,1kv,0,1p3,0,96,0,ek||",
                "America_Eastern": "67,0,1l1,5,1kv,0,1es,0,96,0,eg|67,0,1l1,5,1kv,0,1es,0,96,0,ek||",
                "America_Mountain": "67,0,1l1,5,1kv,0,57n,0,96,0,eg|67,0,1l1,5,1kv,0,57n,0,96,0,ek||",
                "America_Pacific": "67,0,1l1,5,1kv,0,32v,0,96,0,eg|67,0,1l1,5,1kv,0,32v,0,96,0,ek||",
                "Anadyr": "67,0,tn,5,57j,0,96,0,eg|67,0,tn,5,57j,0,96,0,ek||",
                "Apia": "67,0,57i,0,96,0,eg|67,0,57i,0,96,0,ek||",
                "Aqtau": "67,0,57g,0,96,0,eg|67,0,57g,0,96,0,ek||",
                "Aqtobe": "67,0,57f,0,96,0,eg|67,0,57f,0,96,0,ek||",
                "Arabian": "67,0,57b,0,96,0,eg|67,0,57b,0,96,0,ek||",
                "Argentina": "67,0,32s,0,96,0,eg|67,0,32s,0,96,0,ek||",
                "Argentina_Western": "67,0,32s,5,1a3,0,96,0,eg|67,0,32s,5,1a3,0,96,0,ek||",
                "Armenia": "67,0,579,0,96,0,eg|67,0,579,0,96,0,ek||",
                "Atlantic": "67,0,1l1,5,1kv,0,578,0,96,0,eg|67,0,1l1,5,1kv,0,578,0,96,0,ek||",
                "Australia_Central": "67,0,23g,5,1p3,0,96,0,eg|67,0,23g,5,1p3,0,96,0,ek||",
                "Australia_CentralWestern": "67,0,23g,5,1p3,5,1a3,0,96,0,eg|67,0,23g,5,1p3,5,1a3,0,96,0,ek||",
                "Australia_Eastern": "67,0,23g,5,1es,0,96,0,eg|67,0,23g,5,1es,0,96,0,ek||",
                "Australia_Western": "67,0,23g,5,1a3,0,96,0,eg|67,0,23g,5,1a3,0,96,0,ek||",
                "Azerbaijan": "67,0,576,0,96,0,eg|67,0,576,0,96,0,ek||",
                "Azores": "67,0,574,0,96,0,eg|67,0,574,0,96,0,ek||",
                "Bangladesh": "67,0,573,0,96,0,eg|67,0,573,0,96,0,ek||",
                "Bhutan": "67,0,asm|||",
                "Bolivia": "67,0,asn|||",
                "Brasilia": "67,0,56v,0,96,0,eg|67,0,56v,0,96,0,ek||",
                "Brunei": "67,0,asp|||",
                "Cape_Verde": "67,0,56u,5,56t,0,96,0,eg|67,0,56u,5,56t,0,96,0,ek||",
                "Casey": "67,0,ass|||",
                "Chamorro": "67,0,ast|||",
                "Chatham": "67,0,56s,0,96,0,eg|67,0,56s,0,96,0,ek||",
                "Chile": "67,0,56r,0,96,0,eg|67,0,56r,0,96,0,ek||",
                "China": "67,0,56q,0,96,0,eg|67,0,56q,0,96,0,ek||",
                "Choibalsan": "67,0,56k,0,96,0,eg|67,0,56k,0,96,0,ek||",
                "Christmas": "67,0,at2|||",
                "Cocos": "67,0,at3|||",
                "Colombia": "67,0,56i,0,96,0,eg|67,0,56i,0,96,0,ek||",
                "Cook": "67,0,56h,0,96,0,eg|67,0,56h,0,96,0,ek||",
                "Cuba": "67,0,56g,0,96,0,eg|67,0,56g,0,96,0,ek||",
                "Davis": "67,0,at7|||",
                "DumontDUrville": "67,0,at8,5,at9|||",
                "East_Timor": "67,0,ata,5,1es|||",
                "Easter": "67,0,56f,0,96,0,eg|67,0,56f,0,96,0,ek||",
                "Ecuador": "67,0,atc|||",
                "Europe_Central": "67,0,2af,5,1p3,0,96,0,eg|67,0,2af,5,1p3,0,96,0,ek||",
                "Europe_Eastern": "67,0,2af,5,1es,0,96,0,eg|67,0,2af,5,1es,0,96,0,ek||",
                "Europe_Further_Eastern": "67,0,2af,5,1es,5,ate|||",
                "Europe_Western": "67,0,2af,5,1a3,0,96,0,eg|67,0,2af,5,1a3,0,96,0,ek||",
                "Falkland": "67,0,4s1,5,565,0,96,0,eg|67,0,4s1,5,565,0,96,0,ek||",
                "Fiji": "67,0,563,0,96,0,eg|67,0,563,0,96,0,ek||",
                "French_Guiana": "67,0,562,5,atj|||",
                "French_Southern": "67,0,atk|||",
                "Galapagos": "67,0,atl|||",
                "Gambier": "67,0,atm|||",
                "Georgia": "67,0,55s,0,96,0,eg|67,0,55s,0,96,0,ek||",
                "Gilbert_Islands": "67,0,ato|||",
                "GMT": "67,0,atp,0,atq|||",
                "Greenland_Eastern": "67,0,32n,5,1es,0,96,0,eg|67,0,32n,5,1es,0,96,0,ek||",
                "Greenland_Western": "67,0,32n,5,1a3,0,96,0,eg|67,0,32n,5,1a3,0,96,0,ek||",
                "Guam": "67,0,ats|||",
                "Gulf": "67,0,att|||",
                "Guyana": "67,0,562|||",
                "Hawaii_Aleutian": "67,0,55e,0,96,0,eg|67,0,55e,0,96,0,ek||",
                "Hong_Kong": "67,0,55d,5,55c,0,96,0,eg|67,0,55d,5,55c,0,96,0,ek||",
                "Hovd": "67,0,55b,0,96,0,eg|67,0,55b,0,96,0,ek||",
                "India": "67,0,au2|||",
                "Indian_Ocean": "67,0,au3|||",
                "Indochina": "67,0,au4|||",
                "Indonesia_Central": "67,0,4rr,5,1p3|||",
                "Indonesia_Eastern": "67,0,4rr,5,1es|||",
                "Indonesia_Western": "67,0,4rr,5,1a3|||",
                "Iran": "67,0,507,0,96,0,eg|67,0,507,0,96,0,ek||",
                "Irkutsk": "67,0,tn,5,505,0,96,0,eg|67,0,tn,5,505,0,96,0,ek||",
                "Israel": "67,0,4vm,0,96,0,eg|67,0,4vm,0,96,0,ek||",
                "Japan": "67,0,4vl,0,96,0,eg|67,0,4vl,0,96,0,ek||",
                "Kamchatka": "67,0,tn,5,4vj,0,96,0,eg|67,0,tn,5,4vj,0,96,0,ek||",
                "Kazakhstan_Eastern": "67,0,4vh,5,1es|||",
                "Kazakhstan_Western": "67,0,4vh,5,1a3|||",
                "Korea": "67,0,4vg,0,96,0,eg|67,0,4vg,0,96,0,ek||",
                "Kosrae": "67,0,aud|||",
                "Krasnoyarsk": "67,0,tn,5,4vb,0,96,0,eg|67,0,tn,5,4vb,0,96,0,ek||",
                "Kyrgystan": "67,0,auf|||",
                "Lanka": "67,0,aug|||",
                "Line_Islands": "67,0,auh|||",
                "Lord_Howe": "67,0,4v6,0,96,0,eg|67,0,4v6,0,96,0,ek||",
                "Macau": "67,0,4v2,0,96,0,eg|67,0,4v2,0,96,0,ek||",
                "Macquarie": "67,0,auk|||",
                "Magadan": "67,0,tn,5,4v1,0,96,0,eg|67,0,tn,5,4v1,0,96,0,ek||",
                "Malaysia": "67,0,aum|||",
                "Maldives": "67,0,aun|||",
                "Marquesas": "67,0,auo|||",
                "Marshall_Islands": "67,0,aup|||",
                "Mauritius": "67,0,4ut,0,96,0,eg|67,0,4ut,0,96,0,ek||",
                "Mawson": "67,0,aur|||",
                "Mexico_Northwest": "67,0,357,5,4um,0,96,0,eg|67,0,357,5,4um,0,96,0,ek||",
                "Mexico_Pacific": "67,0,357,5,32v,0,96,0,eg|67,0,357,5,32v,0,96,0,ek||",
                "Mongolia": "67,0,4uk,0,96,0,eg|67,0,4uk,0,96,0,ek||",
                "Moscow": "67,0,tn,5,4ui,0,96,0,eg|67,0,tn,5,4ui,0,96,0,ek||",
                "Myanmar": "67,0,av0|||",
                "Nauru": "67,0,av1|||",
                "Nepal": "67,0,av2|||",
                "New_Caledonia": "67,0,4ue,0,96,0,eg|67,0,4ue,0,96,0,ek||",
                "New_Zealand": "67,0,4u2,0,96,0,eg|67,0,4u2,0,96,0,ek||",
                "Newfoundland": "67,0,4u0,0,96,0,eg|67,0,4u0,0,96,0,ek||",
                "Niue": "67,0,av6|||",
                "Norfolk": "67,0,av7|||",
                "Noronha": "67,0,4ts,5,4tq,5,4tp,0,96,0,eg|67,0,4ts,5,4tq,5,4tp,0,96,0,ek||",
                "North_Mariana": "67,0,avb|||",
                "Novosibirsk": "67,0,tn,5,4tm,0,96,0,eg|67,0,tn,5,4tm,0,96,0,ek||",
                "Omsk": "67,0,tn,5,4tl,0,96,0,eg|67,0,tn,5,4tl,0,96,0,ek||",
                "Pakistan": "67,0,4tk,0,96,0,eg|67,0,4tk,0,96,0,ek||",
                "Palau": "67,0,avf|||",
                "Papua_New_Guinea": "67,0,avg|||",
                "Paraguay": "67,0,4tj,0,96,0,eg|67,0,4tj,0,96,0,ek||",
                "Peru": "67,0,4th,0,96,0,eg|67,0,4th,0,96,0,ek||",
                "Philippines": "67,0,4tf,0,96,0,eg|67,0,4tf,0,96,0,ek||",
                "Phoenix_Islands": "67,0,avk|||",
                "Pierre_Miquelon": "67,0,4t8,5,4t6,5,4rh,5,4t4,0,96,0,eg|67,0,4t8,5,4t6,5,4rh,5,4t4,0,96,0,ek||",
                "Pitcairn": "67,0,avp|||",
                "Ponape": "67,0,avq|||",
                "Qyzylorda": "67,0,4t2,0,96,0,eg|67,0,4t2,0,96,0,ek||",
                "Reunion": "67,0,avs|||",
                "Rothera": "67,0,avt|||",
                "Sakhalin": "67,0,tn,5,4sv,0,96,0,eg|67,0,tn,5,4sv,0,96,0,ek||",
                "Samara": "67,0,tn,5,4sn,0,96,0,eg|67,0,tn,5,4sn,0,96,0,ek||",
                "Samoa": "67,0,4sl,0,96,0,eg|67,0,4sl,0,96,0,ek||",
                "Seychelles": "67,0,4s1,5,b01|||",
                "Singapore": "67,0,b02|||",
                "Solomon": "67,0,b03|||",
                "South_Georgia": "67,0,b04|||",
                "Suriname": "67,0,b05|||",
                "Syowa": "67,0,b06|||",
                "Tahiti": "67,0,b07|||",
                "Taipei": "67,0,4sk,0,96,0,eg|67,0,4sk,0,96,0,ek||",
                "Tajikistan": "67,0,b09|||",
                "Tokelau": "67,0,b0a|||",
                "Tonga": "67,0,8it,0,96,0,eg|67,0,8it,0,96,0,ek||",
                "Truk": "67,0,b0c|||",
                "Turkmenistan": "67,0,8iq,0,96,0,eg|67,0,8iq,0,96,0,ek||",
                "Tuvalu": "67,0,b0e|||",
                "Uruguay": "67,0,8ip,0,96,0,eg|67,0,8ip,0,96,0,ek||",
                "Uzbekistan": "67,0,8io,0,96,0,eg|67,0,8io,0,96,0,ek||",
                "Vanuatu": "67,0,8in,0,96,0,eg|67,0,8in,0,96,0,ek||",
                "Venezuela": "67,0,b0i|||",
                "Vladivostok": "67,0,tn,5,8ik,0,96,0,eg|67,0,tn,5,8ik,0,96,0,ek||",
                "Volgograd": "67,0,tn,5,8ie,0,96,0,eg|67,0,tn,5,8ie,0,96,0,ek||",
                "Vostok": "67,0,b0l|||",
                "Wake": "67,0,b0m|||",
                "Wallis": "67,0,b0n,0,4rh,0,b0o|||",
                "Yakutsk": "67,0,tn,5,8ic,0,96,0,eg|67,0,tn,5,8ic,0,96,0,ek||",
                "Yekaterinburg": "67,0,tn,5,8i8,0,96,0,eg|67,0,tn,5,8i8,0,96,0,ek||"
            }
        },
        "tr-CY": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|78e,0,44,0,2a||",
                "Europe/London": "|722,0,95,0,2a||"
            },
            "metazone": {
                "Acre": "3q,0,44,0,2a|3q,0,95,0,2a||",
                "Afghanistan": "2f0,0,2a|||",
                "Africa_Central": "1bn,0,c5,0,2a|||",
                "Africa_Eastern": "10e,0,c5,0,2a|||",
                "Africa_Southern": "2ht,0,c5,0,44,0,2a|||",
                "Africa_Western": "11k,0,c5,0,44,0,2a|11k,0,c5,0,95,0,2a||",
                "Alaska": "3p,0,44,0,2a|3p,0,95,0,2a||",
                "Almaty": "36b,0,44,0,2a|36b,0,95,0,2a||",
                "Amazon": "5m,0,44,0,2a|5m,0,95,0,2a||",
                "America_Central": "15n,0,m2,0,1c2,0,44,0,2a|15n,0,m2,0,1c2,0,95,0,2a||",
                "America_Eastern": "15n,0,m2,0,10e,0,44,0,2a|15n,0,m2,0,10e,0,95,0,2a||",
                "America_Mountain": "15n,0,m2,0,36f,0,44,0,2a|15n,0,m2,0,36f,0,95,0,2a||",
                "America_Pacific": "15n,0,m2,0,10c,0,44,0,2a|15n,0,m2,0,10c,0,95,0,2a||",
                "Anadyr": "36g,0,44,0,2a|36g,0,95,0,2a||",
                "Apia": "3e,0,44,0,2a|3e,0,95,0,2a||",
                "Aqtau": "36i,0,44,0,2a|36i,0,95,0,2a||",
                "Aqtobe": "2gg,0,44,0,2a|2gg,0,95,0,2a||",
                "Arabian": "36j,0,44,0,2a|36j,0,95,0,2a||",
                "Argentina": "1si,0,44,0,2a|1si,0,95,0,2a||",
                "Argentina_Western": "11k,0,1si,0,44,0,2a|11k,0,1si,0,95,0,2a||",
                "Armenia": "2k6,0,44,0,2a|2k6,0,95,0,2a||",
                "Atlantic": "r2,0,44,0,2a|r2,0,95,0,2a||",
                "Australia_Central": "1bn,0,16m,0,44,0,2a|1bn,0,16m,0,95,0,2a||",
                "Australia_CentralWestern": "36k,0,16m,0,44,0,2a|36k,0,16m,0,95,0,2a||",
                "Australia_Eastern": "10e,0,16m,0,44,0,2a|10e,0,16m,0,95,0,2a||",
                "Australia_Western": "11k,0,16m,0,44,0,2a|11k,0,16m,0,95,0,2a||",
                "Azerbaijan": "36l,0,44,0,2a|36l,0,95,0,2a||",
                "Azores": "36m,0,44,0,2a|36m,0,95,0,2a||",
                "Bangladesh": "2kb,0,44,0,2a|2kb,0,95,0,2a||",
                "Bhutan": "as,0,2a|||",
                "Bolivia": "8gf,0,2a|||",
                "Brasilia": "3a,0,44,0,2a|3a,0,95,0,2a||",
                "Brunei": "9o,0,8g4,5,8g2,0,2a|||",
                "Cape_Verde": "7c,0,3j,0,44,0,2a|7c,0,3j,0,95,0,2a||",
                "Casey": "b7,0,2a|||",
                "Chamorro": "6j,0,2a|||",
                "Chatham": "27,0,44,0,2a|27,0,95,0,2a||",
                "Chile": "36s,0,44,0,2a|36s,0,95,0,2a||",
                "China": "1s7,0,44,0,2a|1s7,0,95,0,2a||",
                "Choibalsan": "1s8,0,44,0,2a|1s8,0,95,0,2a||",
                "Christmas": "99,0,137,0,2a|||",
                "Cocos": "7v,0,nl,0,2a|||",
                "Colombia": "36t,0,44,0,2a|36t,0,95,0,2a||",
                "Cook": "2v,0,nl,0,44,0,2a|2v,0,nl,0,8fn,0,95,0,2a||",
                "Cuba": "370,0,44,0,2a|370,0,95,0,2a||",
                "Davis": "5s,0,2a|||",
                "DumontDUrville": "5b,5,5j,0,2a|||",
                "East_Timor": "10e,0,7n,0,2a|||",
                "Easter": "371,0,137,0,44,0,2a|371,0,137,0,95,0,2a||",
                "Ecuador": "1k0,0,2a|||",
                "Europe_Central": "1bn,0,1ds,0,44,0,2a|1bn,0,1ds,0,95,0,2a||",
                "Europe_Eastern": "10e,0,1ds,0,44,0,2a|10e,0,1ds,0,95,0,2a||",
                "Europe_Further_Eastern": "8fd,0,10e,0,1ds,0,2a|||",
                "Europe_Western": "11k,0,1ds,0,44,0,2a|11k,0,1ds,0,95,0,2a||",
                "Falkland": "4v,0,nl,0,44,0,2a|4v,0,nl,0,95,0,2a||",
                "Fiji": "4q,0,44,0,2a|4q,0,95,0,2a||",
                "French_Guiana": "1sb,0,8fc,0,2a|||",
                "French_Southern": "1sb,0,2ht,0,1sp,0,27v,0,2a|||",
                "Galapagos": "ak,0,2a|||",
                "Gambier": "6v,0,2a|||",
                "Georgia": "373,0,44,0,2a|373,0,95,0,2a||",
                "Gilbert_Islands": "6q,0,nl,0,2a|||",
                "GMT": "5u,0,8f5,0,2a|||",
                "Greenland_Eastern": "10e,0,1sq,0,44,0,2a|10e,0,1sq,0,95,0,2a||",
                "Greenland_Western": "11k,0,1sq,0,44,0,2a|11k,0,1sq,0,95,0,2a||",
                "Guam": "83,0,44,0,2a|||",
                "Gulf": "8f2,0,2a|||",
                "Guyana": "7a,0,2a|||",
                "Hawaii_Aleutian": "4g,5,1l3,0,44,0,2a|4g,5,1l3,0,95,0,2a||",
                "Hong_Kong": "2l,0,2p,0,44,0,2a|2l,0,2p,0,95,0,2a||",
                "Hovd": "2g,0,44,0,2a|2g,0,95,0,2a||",
                "India": "30i,0,44,0,2a|||",
                "Indian_Ocean": "8eq,0,8eo,0,2a|||",
                "Indochina": "8ed,0,2a|||",
                "Indonesia_Central": "1bn,0,2h6,0,2a|||",
                "Indonesia_Eastern": "10e,0,2h6,0,2a|||",
                "Indonesia_Western": "11k,0,2h6,0,2a|||",
                "Iran": "1sj,0,44,0,2a|1sj,0,95,0,2a||",
                "Irkutsk": "1sk,0,44,0,2a|1sk,0,95,0,2a||",
                "Israel": "1sl,0,44,0,2a|1sl,0,95,0,2a||",
                "Japan": "375,0,44,0,2a|375,0,95,0,2a||",
                "Kamchatka": "37,5,378,0,44,0,2a|37,5,378,0,95,0,2a||",
                "Kazakhstan_Eastern": "10e,0,1mt,0,2a|||",
                "Kazakhstan_Western": "11k,0,1mt,0,2a|||",
                "Korea": "379,0,44,0,2a|379,0,95,0,2a||",
                "Kosrae": "6f,0,2a|||",
                "Krasnoyarsk": "41,0,44,0,2a|41,0,95,0,2a||",
                "Kyrgystan": "8dl,0,2a|||",
                "Lanka": "9c,0,2a|||",
                "Line_Islands": "ac,0,nl,0,2a|||",
                "Lord_Howe": "1u,0,24,0,44,0,2a|1u,0,24,0,95,0,2a||",
                "Macau": "176,0,44,0,2a|176,0,95,0,2a||",
                "Macquarie": "6m,0,137,0,2a|||",
                "Magadan": "2o,0,44,0,2a|2o,0,95,0,2a||",
                "Malaysia": "8dk,0,2a|||",
                "Maldives": "8di,0,2a|||",
                "Marquesas": "1jm,0,nl,0,2a|||",
                "Marshall_Islands": "7o,0,nl,0,2a|||",
                "Mauritius": "4u,0,44,0,2a|4u,0,95,0,2a||",
                "Mawson": "63,0,2a|||",
                "Mexico_Northwest": "37a,0,10g,0,44,0,2a|37a,0,10g,0,95,0,2a||",
                "Mexico_Pacific": "10g,0,10c,0,37b,0,44,0,2a|10g,0,10c,0,37b,0,95,0,2a||",
                "Mongolia": "4f,0,37j,0,44,0,2a|4f,0,37j,0,95,0,2a||",
                "Moscow": "37l,0,44,0,2a|37l,0,95,0,2a||",
                "Myanmar": "8v,0,2a|||",
                "Nauru": "5v,0,2a|||",
                "Nepal": "8u,0,2a|||",
                "New_Caledonia": "142,0,37o,0,44,0,2a|142,0,37o,0,95,0,2a||",
                "New_Zealand": "142,0,go,0,44,0,2a|142,0,go,0,95,0,2a||",
                "Newfoundland": "53,0,44,0,2a|53,0,95,0,2a||",
                "Niue": "8g,0,2a|||",
                "Norfolk": "6l,0,137,0,2a|||",
                "Noronha": "1s,0,2,0,23,0,44,0,2a|1s,0,2,0,23,0,95,0,2a||",
                "North_Mariana": "15n,0,bd,0,nl,0,2a|||",
                "Novosibirsk": "3b,0,44,0,2a|3b,0,95,0,2a||",
                "Omsk": "26,0,44,0,2a|26,0,95,0,2a||",
                "Pakistan": "3i,0,44,0,2a|3i,0,95,0,2a||",
                "Palau": "9b,0,2a|||",
                "Papua_New_Guinea": "9a,0,142,0,8co,0,2a|||",
                "Paraguay": "3c,0,44,0,2a|3c,0,95,0,2a||",
                "Peru": "4n,0,44,0,2a|4n,0,95,0,2a||",
                "Philippines": "37p,0,44,0,2a|37p,0,95,0,2a||",
                "Phoenix_Islands": "90,0,nl,0,2a|||",
                "Pierre_Miquelon": "8i,0,33,0,1sp,0,35,0,44,0,2a|8i,0,33,0,1sp,0,35,0,95,0,2a||",
                "Pitcairn": "7e,0,2a|||",
                "Ponape": "9s,0,2a|||",
                "Pyongyang": "8a,0,2a|||",
                "Qyzylorda": "37t,0,44,0,2a|37t,0,95,0,2a||",
                "Reunion": "b4,0,2a|||",
                "Rothera": "5q,0,2a|||",
                "Sakhalin": "164,0,44,0,2a|164,0,95,0,2a||",
                "Samara": "29,0,44,0,2a|29,0,95,0,2a||",
                "Samoa": "2c,0,44,0,2a|2c,0,95,0,2a||",
                "Seychelles": "8cd,0,2a|||",
                "Singapore": "m8,0,44,0,2a|||",
                "Solomon": "b5,0,nl,0,2a|||",
                "South_Georgia": "2ht,0,2u,0,2a|||",
                "Suriname": "mg,0,2a|||",
                "Syowa": "8ca,0,2a|||",
                "Tahiti": "8n,0,2a|||",
                "Taipei": "3d,0,44,0,2a|3d,0,95,0,2a||",
                "Tajikistan": "3mh,0,2a|||",
                "Tokelau": "5d,0,2a|||",
                "Tonga": "2j,0,44,0,2a|2j,0,95,0,2a||",
                "Truk": "6p,0,2a|||",
                "Turkmenistan": "2l2,0,44,0,2a|2l2,0,95,0,2a||",
                "Tuvalu": "6h,0,2a|||",
                "Uruguay": "4k,0,44,0,2a|4k,0,95,0,2a||",
                "Uzbekistan": "2l3,0,44,0,2a|2l3,0,95,0,2a||",
                "Vanuatu": "2f,0,44,0,2a|2f,0,95,0,2a||",
                "Venezuela": "7s,0,2a|||",
                "Vladivostok": "28,0,44,0,2a|28,0,95,0,2a||",
                "Volgograd": "3f,0,44,0,2a|3f,0,95,0,2a||",
                "Vostok": "5t,0,2a|||",
                "Wake": "5r,0,137,0,2a|||",
                "Wallis": "5f,0,1sp,0,5k,0,2a|||",
                "Yakutsk": "3u,0,44,0,2a|3u,0,95,0,2a||",
                "Yekaterinburg": "5l,0,44,0,2a|5l,0,95,0,2a||"
            }
        },
        "tr": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|78e,0,44,0,2a||",
                "Europe/London": "|722,0,95,0,2a||"
            },
            "metazone": {
                "Acre": "3q,0,44,0,2a|3q,0,95,0,2a||",
                "Afghanistan": "2f0,0,2a|||",
                "Africa_Central": "1bn,0,c5,0,2a|||",
                "Africa_Eastern": "10e,0,c5,0,2a|||",
                "Africa_Southern": "2ht,0,c5,0,44,0,2a|||",
                "Africa_Western": "11k,0,c5,0,44,0,2a|11k,0,c5,0,95,0,2a||",
                "Alaska": "3p,0,44,0,2a|3p,0,95,0,2a||",
                "Almaty": "36b,0,44,0,2a|36b,0,95,0,2a||",
                "Amazon": "5m,0,44,0,2a|5m,0,95,0,2a||",
                "America_Central": "15n,0,m2,0,1c2,0,44,0,2a|15n,0,m2,0,1c2,0,95,0,2a||",
                "America_Eastern": "15n,0,m2,0,10e,0,44,0,2a|15n,0,m2,0,10e,0,95,0,2a||",
                "America_Mountain": "15n,0,m2,0,36f,0,44,0,2a|15n,0,m2,0,36f,0,95,0,2a||",
                "America_Pacific": "15n,0,m2,0,10c,0,44,0,2a|15n,0,m2,0,10c,0,95,0,2a||",
                "Anadyr": "36g,0,44,0,2a|36g,0,95,0,2a||",
                "Apia": "3e,0,44,0,2a|3e,0,95,0,2a||",
                "Aqtau": "36i,0,44,0,2a|36i,0,95,0,2a||",
                "Aqtobe": "2gg,0,44,0,2a|2gg,0,95,0,2a||",
                "Arabian": "36j,0,44,0,2a|36j,0,95,0,2a||",
                "Argentina": "1si,0,44,0,2a|1si,0,95,0,2a||",
                "Argentina_Western": "11k,0,1si,0,44,0,2a|11k,0,1si,0,95,0,2a||",
                "Armenia": "2k6,0,44,0,2a|2k6,0,95,0,2a||",
                "Atlantic": "r2,0,44,0,2a|r2,0,95,0,2a||",
                "Australia_Central": "1bn,0,16m,0,44,0,2a|1bn,0,16m,0,95,0,2a||",
                "Australia_CentralWestern": "36k,0,16m,0,44,0,2a|36k,0,16m,0,95,0,2a||",
                "Australia_Eastern": "10e,0,16m,0,44,0,2a|10e,0,16m,0,95,0,2a||",
                "Australia_Western": "11k,0,16m,0,44,0,2a|11k,0,16m,0,95,0,2a||",
                "Azerbaijan": "36l,0,44,0,2a|36l,0,95,0,2a||",
                "Azores": "36m,0,44,0,2a|36m,0,95,0,2a||",
                "Bangladesh": "2kb,0,44,0,2a|2kb,0,95,0,2a||",
                "Bhutan": "as,0,2a|||",
                "Bolivia": "8gf,0,2a|||",
                "Brasilia": "3a,0,44,0,2a|3a,0,95,0,2a||",
                "Brunei": "9o,0,8g4,5,8g2,0,2a|||",
                "Cape_Verde": "7c,0,3j,0,44,0,2a|7c,0,3j,0,95,0,2a||",
                "Casey": "b7,0,2a|||",
                "Chamorro": "6j,0,2a|||",
                "Chatham": "27,0,44,0,2a|27,0,95,0,2a||",
                "Chile": "36s,0,44,0,2a|36s,0,95,0,2a||",
                "China": "1s7,0,44,0,2a|1s7,0,95,0,2a||",
                "Choibalsan": "1s8,0,44,0,2a|1s8,0,95,0,2a||",
                "Christmas": "99,0,137,0,2a|||",
                "Cocos": "7v,0,nl,0,2a|||",
                "Colombia": "36t,0,44,0,2a|36t,0,95,0,2a||",
                "Cook": "2v,0,nl,0,44,0,2a|2v,0,nl,0,8fn,0,95,0,2a||",
                "Cuba": "370,0,44,0,2a|370,0,95,0,2a||",
                "Davis": "5s,0,2a|||",
                "DumontDUrville": "5b,5,5j,0,2a|||",
                "East_Timor": "10e,0,7n,0,2a|||",
                "Easter": "371,0,137,0,44,0,2a|371,0,137,0,95,0,2a||",
                "Ecuador": "1k0,0,2a|||",
                "Europe_Central": "1bn,0,1ds,0,44,0,2a|1bn,0,1ds,0,95,0,2a||",
                "Europe_Eastern": "10e,0,1ds,0,44,0,2a|10e,0,1ds,0,95,0,2a||",
                "Europe_Further_Eastern": "8fd,0,10e,0,1ds,0,2a|||",
                "Europe_Western": "11k,0,1ds,0,44,0,2a|11k,0,1ds,0,95,0,2a||",
                "Falkland": "4v,0,nl,0,44,0,2a|4v,0,nl,0,95,0,2a||",
                "Fiji": "4q,0,44,0,2a|4q,0,95,0,2a||",
                "French_Guiana": "1sb,0,8fc,0,2a|||",
                "French_Southern": "1sb,0,2ht,0,1sp,0,27v,0,2a|||",
                "Galapagos": "ak,0,2a|||",
                "Gambier": "6v,0,2a|||",
                "Georgia": "373,0,44,0,2a|373,0,95,0,2a||",
                "Gilbert_Islands": "6q,0,nl,0,2a|||",
                "GMT": "5u,0,8f5,0,2a|||",
                "Greenland_Eastern": "10e,0,1sq,0,44,0,2a|10e,0,1sq,0,95,0,2a||",
                "Greenland_Western": "11k,0,1sq,0,44,0,2a|11k,0,1sq,0,95,0,2a||",
                "Guam": "83,0,44,0,2a|||",
                "Gulf": "8f2,0,2a|||",
                "Guyana": "7a,0,2a|||",
                "Hawaii_Aleutian": "4g,5,1l3,0,44,0,2a|4g,5,1l3,0,95,0,2a||",
                "Hong_Kong": "2l,0,2p,0,44,0,2a|2l,0,2p,0,95,0,2a||",
                "Hovd": "2g,0,44,0,2a|2g,0,95,0,2a||",
                "India": "30i,0,44,0,2a|||",
                "Indian_Ocean": "8eq,0,8eo,0,2a|||",
                "Indochina": "8ed,0,2a|||",
                "Indonesia_Central": "1bn,0,2h6,0,2a|||",
                "Indonesia_Eastern": "10e,0,2h6,0,2a|||",
                "Indonesia_Western": "11k,0,2h6,0,2a|||",
                "Iran": "1sj,0,44,0,2a|1sj,0,95,0,2a||",
                "Irkutsk": "1sk,0,44,0,2a|1sk,0,95,0,2a||",
                "Israel": "1sl,0,44,0,2a|1sl,0,95,0,2a||",
                "Japan": "375,0,44,0,2a|375,0,95,0,2a||",
                "Kamchatka": "37,5,378,0,44,0,2a|37,5,378,0,95,0,2a||",
                "Kazakhstan_Eastern": "10e,0,1mt,0,2a|||",
                "Kazakhstan_Western": "11k,0,1mt,0,2a|||",
                "Korea": "379,0,44,0,2a|379,0,95,0,2a||",
                "Kosrae": "6f,0,2a|||",
                "Krasnoyarsk": "41,0,44,0,2a|41,0,95,0,2a||",
                "Kyrgystan": "8dl,0,2a|||",
                "Lanka": "9c,0,2a|||",
                "Line_Islands": "ac,0,nl,0,2a|||",
                "Lord_Howe": "1u,0,24,0,44,0,2a|1u,0,24,0,95,0,2a||",
                "Macau": "176,0,44,0,2a|176,0,95,0,2a||",
                "Macquarie": "6m,0,137,0,2a|||",
                "Magadan": "2o,0,44,0,2a|2o,0,95,0,2a||",
                "Malaysia": "8dk,0,2a|||",
                "Maldives": "8di,0,2a|||",
                "Marquesas": "1jm,0,nl,0,2a|||",
                "Marshall_Islands": "7o,0,nl,0,2a|||",
                "Mauritius": "4u,0,44,0,2a|4u,0,95,0,2a||",
                "Mawson": "63,0,2a|||",
                "Mexico_Northwest": "37a,0,10g,0,44,0,2a|37a,0,10g,0,95,0,2a||",
                "Mexico_Pacific": "10g,0,10c,0,37b,0,44,0,2a|10g,0,10c,0,37b,0,95,0,2a||",
                "Mongolia": "4f,0,37j,0,44,0,2a|4f,0,37j,0,95,0,2a||",
                "Moscow": "37l,0,44,0,2a|37l,0,95,0,2a||",
                "Myanmar": "8v,0,2a|||",
                "Nauru": "5v,0,2a|||",
                "Nepal": "8u,0,2a|||",
                "New_Caledonia": "142,0,37o,0,44,0,2a|142,0,37o,0,95,0,2a||",
                "New_Zealand": "142,0,go,0,44,0,2a|142,0,go,0,95,0,2a||",
                "Newfoundland": "53,0,44,0,2a|53,0,95,0,2a||",
                "Niue": "8g,0,2a|||",
                "Norfolk": "6l,0,137,0,2a|||",
                "Noronha": "1s,0,2,0,23,0,44,0,2a|1s,0,2,0,23,0,95,0,2a||",
                "North_Mariana": "15n,0,bd,0,nl,0,2a|||",
                "Novosibirsk": "3b,0,44,0,2a|3b,0,95,0,2a||",
                "Omsk": "26,0,44,0,2a|26,0,95,0,2a||",
                "Pakistan": "3i,0,44,0,2a|3i,0,95,0,2a||",
                "Palau": "9b,0,2a|||",
                "Papua_New_Guinea": "9a,0,142,0,8co,0,2a|||",
                "Paraguay": "3c,0,44,0,2a|3c,0,95,0,2a||",
                "Peru": "4n,0,44,0,2a|4n,0,95,0,2a||",
                "Philippines": "37p,0,44,0,2a|37p,0,95,0,2a||",
                "Phoenix_Islands": "90,0,nl,0,2a|||",
                "Pierre_Miquelon": "8i,0,33,0,1sp,0,35,0,44,0,2a|8i,0,33,0,1sp,0,35,0,95,0,2a||",
                "Pitcairn": "7e,0,2a|||",
                "Ponape": "9s,0,2a|||",
                "Pyongyang": "8a,0,2a|||",
                "Qyzylorda": "37t,0,44,0,2a|37t,0,95,0,2a||",
                "Reunion": "b4,0,2a|||",
                "Rothera": "5q,0,2a|||",
                "Sakhalin": "164,0,44,0,2a|164,0,95,0,2a||",
                "Samara": "29,0,44,0,2a|29,0,95,0,2a||",
                "Samoa": "2c,0,44,0,2a|2c,0,95,0,2a||",
                "Seychelles": "8cd,0,2a|||",
                "Singapore": "m8,0,44,0,2a|||",
                "Solomon": "b5,0,nl,0,2a|||",
                "South_Georgia": "2ht,0,2u,0,2a|||",
                "Suriname": "mg,0,2a|||",
                "Syowa": "8ca,0,2a|||",
                "Tahiti": "8n,0,2a|||",
                "Taipei": "3d,0,44,0,2a|3d,0,95,0,2a||",
                "Tajikistan": "3mh,0,2a|||",
                "Tokelau": "5d,0,2a|||",
                "Tonga": "2j,0,44,0,2a|2j,0,95,0,2a||",
                "Truk": "6p,0,2a|||",
                "Turkmenistan": "2l2,0,44,0,2a|2l2,0,95,0,2a||",
                "Tuvalu": "6h,0,2a|||",
                "Uruguay": "4k,0,44,0,2a|4k,0,95,0,2a||",
                "Uzbekistan": "2l3,0,44,0,2a|2l3,0,95,0,2a||",
                "Vanuatu": "2f,0,44,0,2a|2f,0,95,0,2a||",
                "Venezuela": "7s,0,2a|||",
                "Vladivostok": "28,0,44,0,2a|28,0,95,0,2a||",
                "Volgograd": "3f,0,44,0,2a|3f,0,95,0,2a||",
                "Vostok": "5t,0,2a|||",
                "Wake": "5r,0,137,0,2a|||",
                "Wallis": "5f,0,1sp,0,5k,0,2a|||",
                "Yakutsk": "3u,0,44,0,2a|3u,0,95,0,2a||",
                "Yekaterinburg": "5l,0,44,0,2a|5l,0,95,0,2a||"
            }
        },
        "twq": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "tzm": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "ug": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|ce0,0,ej,0,6k||",
                "Europe/London": "|ce1,0,ej,0,6k||"
            },
            "metazone": {
                "Acre": "b2f,0,e7,0,6k|b2i,0,ej,0,6k||",
                "Afghanistan": "b2k,0,6k|||",
                "Africa_Central": "1p1,0,2se,0,6k|||",
                "Africa_Eastern": "1g9,0,2se,0,6k|||",
                "Africa_Southern": "4r5,0,2se,0,e7,0,6k|||",
                "Africa_Western": "18l,0,2se,0,e7,0,6k|18l,0,2se,0,ej,0,6k||",
                "Alaska": "8b1,0,e7,0,6k|8b1,0,ej,0,6k||",
                "Almaty": "8b0,0,e7,0,6k|8b0,0,ej,0,6k||",
                "Amazon": "89d,0,e7,0,6k|89d,0,ej,0,6k||",
                "America_Central": "1p1,0,1dl,0,e7,0,6k|1p1,0,1dl,0,ej,0,6k||",
                "America_Eastern": "1g9,0,1dl,0,e7,0,6k|1g9,0,1dl,0,ej,0,6k||",
                "America_Mountain": "897,0,e7,0,6k|897,0,ej,0,6k||",
                "America_Pacific": "38g,0,29b,0,e7,0,6k|38g,0,29b,0,ej,0,6k||",
                "Anadyr": "890,0,e7,0,6k|890,0,ej,0,6k||",
                "Aqtau": "88r,0,e7,0,6k|88r,0,ej,0,6k||",
                "Aqtobe": "88p,0,e7,0,6k|88p,0,ej,0,6k||",
                "Arabian": "88n,0,e7,0,6k|88n,0,ej,0,6k||",
                "Argentina": "38i,0,e7,0,6k|38i,0,ej,0,6k||",
                "Argentina_Western": "18l,0,38i,0,e7,0,6k|18l,0,38i,0,ej,0,6k||",
                "Armenia": "88h,0,e7,0,6k|88h,0,ej,0,6k||",
                "Atlantic": "88g,0,29b,0,e7,0,6k|88g,0,29b,0,ej,0,6k||",
                "Australia_Central": "29a,0,1p1,0,1dl,0,e7,0,6k|29a,0,1p1,0,1dl,0,ej,0,6k||",
                "Australia_CentralWestern": "b39,0,1p1,0,18l,0,1dl,0,e7,0,6k|29a,0,1p1,0,18l,0,1dl,0,ej,0,6k||",
                "Australia_Eastern": "29a,0,1g9,0,1dl,0,e7,0,6k|29a,0,1g9,0,1dl,0,ej,0,6k||",
                "Australia_Western": "29a,0,18l,0,1dl,0,e7,0,6k|29a,0,18l,0,1dl,0,ej,0,6k||",
                "Azerbaijan": "88e,0,e7,0,6k|88e,0,ej,0,6k||",
                "Azores": "88d,0,e7,0,6k|88d,0,ej,0,6k||",
                "Bangladesh": "88c,0,e7,0,6k|88c,0,ej,0,6k||",
                "Bhutan": "b3d,0,6k|||",
                "Bolivia": "b3e,0,6k|||",
                "Brasilia": "88b,0,e7,0,6k|88b,0,ej,0,6k||",
                "Brunei": "b3g,0,b3h,0,6k|||",
                "Cape_Verde": "887,0,886,0,e7,0,6k|887,0,886,0,ej,0,6k||",
                "Casey": "b3k,0,6k|||",
                "Chamorro": "b3l,0,e7,0,6k|||",
                "Chatham": "884,0,e7,0,6k|884,0,ej,0,6k||",
                "Chile": "881,0,e7,0,6k|881,0,ej,0,6k||",
                "China": "880,0,e7,0,6k|880,0,ej,0,6k||",
                "Choibalsan": "87n,0,e7,0,6k|87n,0,ej,0,6k||",
                "Christmas": "b3q,0,2rl,0,6k|||",
                "Cocos": "b3s,0,2rl,0,6k|||",
                "Colombia": "87a,0,e7,0,6k|87a,0,ej,0,6k||",
                "Cook": "877,0,1gb,0,e7,0,6k|877,0,1gb,0,b40,0,ej,0,6k||",
                "Cuba": "871,0,e7,0,6k|871,0,ej,0,6k||",
                "Davis": "b42,0,6k|||",
                "DumontDUrville": "b43,5,b44,0,6k|||",
                "East_Timor": "1g9,0,b45,0,6k|||",
                "Easter": "b46,0,2rl,0,e7,0,6k|b47,0,2rl,0,ej,0,6k||",
                "Ecuador": "b48,0,6k|||",
                "Europe_Central": "1p1,0,2ft,0,e7,0,6k|1p1,0,2ft,0,ej,0,6k||",
                "Europe_Eastern": "1g9,0,2ft,0,e7,0,6k|1g9,0,2ft,0,ej,0,6k||",
                "Europe_Western": "18l,0,2ft,0,e7,0,6k|18l,0,2ft,0,ej,0,6k||",
                "Falkland": "86s,0,1gb,0,e7,0,6k|86s,0,1gb,0,ej,0,6k||",
                "Fiji": "86q,0,e7,0,6k|86q,0,ej,0,6k||",
                "French_Guiana": "86p,0,86o,0,86g,0,6k|||",
                "French_Southern": "86p,0,86o,0,4r5,0,38j,0,b4g,0,6k|||",
                "Galapagos": "4nd,0,6k|||",
                "Gambier": "b4h,0,6k|||",
                "Georgia": "86b,0,e7,0,6k|86b,0,ej,0,6k||",
                "Gilbert_Islands": "b4j,0,1gb,0,6k|||",
                "GMT": "b4k,0,6k|||",
                "Greenland_Eastern": "1g9,0,38k,0,e7,0,6k|1g9,0,38k,0,ej,0,6k||",
                "Greenland_Western": "18l,0,38k,0,e7,0,6k|18l,0,38k,0,ej,0,6k||",
                "Guam": "b4m,0,e7,0,6k|||",
                "Gulf": "b4n,0,e7,0,6k|||",
                "Guyana": "86g,0,6k|||",
                "Hawaii_Aleutian": "860,5,85v,0,e7,0,6k|860,5,85v,0,ej,0,6k||",
                "Hong_Kong": "85u,0,e7,0,6k|85u,0,ej,0,6k||",
                "Hovd": "85s,0,e7,0,6k|85s,0,ej,0,6k||",
                "India": "b4s,0,e7,0,6k|||",
                "Indian_Ocean": "85r,0,29b,0,6k|||",
                "Indochina": "85r,0,b4u,0,6k|||",
                "Indonesia_Central": "1p1,0,4qv,0,6k|||",
                "Indonesia_Eastern": "1g9,0,4qv,0,6k|||",
                "Indonesia_Western": "18l,0,4qv,0,6k|||",
                "Iran": "856,0,e7,0,6k|856,0,ej,0,6k||",
                "Irkutsk": "854,0,e7,0,6k|854,0,ej,0,6k||",
                "Israel": "851,0,e7,0,6k|851,0,ej,0,6k||",
                "Japan": "850,0,e7,0,6k|850,0,ej,0,6k||",
                "Kamchatka": "84u,5,84q,0,e7,0,6k|84u,5,84q,0,ej,0,6k||",
                "Kazakhstan_Eastern": "1g9,0,84p,0,6k|||",
                "Kazakhstan_Western": "18l,0,84p,0,6k|||",
                "Korea": "84o,0,e7,0,6k|84o,0,ej,0,6k||",
                "Kosrae": "b58,0,6k|||",
                "Krasnoyarsk": "84l,0,e7,0,6k|84l,0,ej,0,6k||",
                "Kyrgystan": "b5a,0,6k|||",
                "Lanka": "b5b,0,b5c,0,6k|||",
                "Line_Islands": "s2,0,1gb,0,6k|||",
                "Lord_Howe": "rh,5,84j,0,e7,0,6k|rh,5,84j,0,ej,0,6k||",
                "Macau": "84c,0,e7,0,6k|84c,0,ej,0,6k||",
                "Macquarie": "b5f,0,1gb,0,6k|||",
                "Magadan": "2al,0,e7,0,6k|2al,0,ej,0,6k||",
                "Malaysia": "b5g,0,6k|||",
                "Maldives": "b5h,0,6k|||",
                "Marquesas": "b5i,0,6k|||",
                "Marshall_Islands": "rb,0,1gb,0,6k|||",
                "Mauritius": "83v,0,e7,0,6k|83v,0,ej,0,6k||",
                "Mawson": "b5k,0,6k|||",
                "Mexico_Northwest": "38o,0,18l,0,4qt,0,1dl,0,e7,0,6k|38o,0,18l,0,4qt,0,1dl,0,ej,0,6k||",
                "Mexico_Pacific": "38o,0,38g,0,29b,0,e7,0,6k|38o,0,38g,0,29b,0,ej,0,6k||",
                "Mongolia": "83h,0,e7,0,6k|83h,0,ej,0,6k||",
                "Moscow": "83b,0,e7,0,6k|83b,0,ej,0,6k||",
                "Myanmar": "b5p,0,6k|||",
                "Nauru": "b5q,0,6k|||",
                "Nepal": "b5r,0,6k|||",
                "New_Caledonia": "2ra,0,835,0,e7,0,6k|2ra,0,835,0,ej,0,6k||",
                "New_Zealand": "2ra,0,833,0,e7,0,6k|2ra,0,833,0,ej,0,6k||",
                "Newfoundland": "82v,0,e7,0,6k|82v,0,ej,0,6k||",
                "Niue": "b60,0,6k|||",
                "Norfolk": "s6,0,1gb,0,6k|||",
                "Noronha": "82t,5,82o,0,e7,0,6k|82t,5,82o,0,ej,0,6k||",
                "North_Mariana": "4qt,0,b63,0,1gb,0,6k|||",
                "Novosibirsk": "822,0,e7,0,6k|822,0,ej,0,6k||",
                "Omsk": "821,0,e7,0,6k|821,0,ej,0,6k||",
                "Pakistan": "820,0,e7,0,6k|820,0,ej,0,6k||",
                "Palau": "b67,0,6k|||",
                "Papua_New_Guinea": "b68,0,2ra,0,b69,0,6k|||",
                "Paraguay": "81r,0,e7,0,6k|81r,0,ej,0,6k||",
                "Peru": "81o,0,e7,0,6k|81o,0,ej,0,6k||",
                "Philippines": "81j,0,e7,0,6k|81j,0,ej,0,6k||",
                "Phoenix_Islands": "b6d,0,1gb,0,6k|||",
                "Pierre_Miquelon": "81h,0,81g,0,38j,0,815,0,e7,0,6k|81h,0,81g,0,38j,0,815,0,ej,0,6k||",
                "Pitcairn": "b6h,0,6k|||",
                "Ponape": "b6i,0,6k|||",
                "Qyzylorda": "80n,0,e7,0,6k|80n,0,ej,0,6k||",
                "Reunion": "b6k,0,6k|||",
                "Rothera": "b6l,0,6k|||",
                "Sakhalin": "80i,0,e7,0,6k|80i,0,ej,0,6k||",
                "Samara": "2ij,0,e7,0,6k|2ij,0,ej,0,6k||",
                "Samoa": "b6n,0,e7,0,6k|b6o,0,ej,0,6k||",
                "Seychelles": "b6p,0,6k|||",
                "Singapore": "b6q,0,6k|||",
                "Solomon": "b6r,0,1gb,0,6k|||",
                "South_Georgia": "4r5,0,b6s,0,6k|||",
                "Suriname": "b6t,0,6k|||",
                "Syowa": "b6u,0,6k|||",
                "Tahiti": "b6v,0,6k|||",
                "Taipei": "807,0,e7,0,6k|807,0,ej,0,6k||",
                "Tajikistan": "b71,0,6k|||",
                "Tokelau": "b72,0,6k|||",
                "Tonga": "2ho,0,e7,0,6k|2ho,0,ej,0,6k||",
                "Truk": "b73,0,6k|||",
                "Turkmenistan": "804,0,e7,0,6k|804,0,ej,0,6k||",
                "Tuvalu": "b75,0,6k|||",
                "Uruguay": "803,0,e7,0,6k|803,0,ej,0,6k||",
                "Uzbekistan": "7vu,0,e7,0,6k|7vu,0,ej,0,6k||",
                "Vanuatu": "7vt,0,e7,0,6k|7vt,0,ej,0,6k||",
                "Venezuela": "b79,0,6k|||",
                "Vladivostok": "7v0,0,e7,0,6k|7v0,0,ej,0,6k||",
                "Volgograd": "7uc,0,e7,0,6k|7uc,0,ej,0,6k||",
                "Vostok": "b7c,0,6k|||",
                "Wake": "b7d,0,2rl,0,6k|||",
                "Wallis": "b7e,0,38j,0,b7f,0,6k|||",
                "Yakutsk": "7ub,0,e7,0,6k|7ub,0,ej,0,6k||",
                "Yekaterinburg": "7tt,0,e7,0,6k|7tt,0,ej,0,6k||"
            }
        },
        "uk": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|79,0,fk,0,7d,0,qe,0,ce2||",
                "Europe/London": "|79,0,fk,0,7d,0,n2,0,ce3,0,ce4||"
            },
            "metazone": {
                "Acre": "295,0,7qr,k,0,4qm|295,0,7qr,k,0,4ql||",
                "Afghanistan": "79,0,7d,0,qe,0,b7o|||",
                "Africa_Central": "79,0,b7p,0,7d|||",
                "Africa_Eastern": "79,0,b7q,0,7d|||",
                "Africa_Southern": "79,0,b7r,0,7d|||",
                "Africa_Western": "79,0,7pr,0,fs,0,7d|79,0,7pr,0,fk,0,7d||",
                "Alaska": "79,0,fs,0,7d,0,ag,0,7p7|79,0,fk,0,7d,0,ag,0,7p7||",
                "Amazon": "79,0,fs,0,7d,0,ag,0,7of|79,0,fk,0,7d,0,ag,0,7of||",
                "America_Central": "79,0,1vj,0,7ob,0,fs,0,7d|79,0,1vj,0,7ob,0,fk,0,7d||",
                "America_Eastern": "79,0,1vj,0,2pf,0,fs,0,7d|79,0,1vj,0,2pf,0,fk,0,7d||",
                "America_Mountain": "79,0,1vj,0,7o6,0,fs,0,7d|79,0,1vj,0,7o6,0,fk,0,7d||",
                "America_Pacific": "79,0,1vj,0,39b,0,fs,0,7d|79,0,1vj,0,39b,0,fk,0,7d||",
                "Anadyr": "295,0,18u,k,0,4qm|295,0,18u,k,0,4ql||",
                "Apia": "79,0,fs,0,7d,0,qe,0,7o4|79,0,fk,0,7d,0,qe,0,7o4||",
                "Arabian": "79,0,7o3,0,fs,0,7d|79,0,7o3,0,fk,0,7d||",
                "Argentina": "79,0,fs,0,7o2,0,7d|79,0,fk,0,7o2,0,7d||",
                "Argentina_Western": "79,0,fs,0,7nt,0,7d|79,0,fk,0,79,0,7nt,0,7d||",
                "Armenia": "79,0,7nj,0,fs,0,7d|79,0,7nj,0,fk,0,7d||",
                "Atlantic": "79,0,7nh,0,fs,0,7d|79,0,7nh,0,fk,0,7d||",
                "Australia_Central": "79,0,fs,0,7nd,0,7d|79,0,fk,0,7nd,0,7d||",
                "Australia_CentralWestern": "79,0,fs,0,7n7,0,7n5,0,7d|79,0,fk,0,7n7,0,7n5,0,7d||",
                "Australia_Eastern": "79,0,fs,0,7n1,0,7d|79,0,fk,0,7n1,0,7d||",
                "Australia_Western": "79,0,fs,0,7ld,0,7d|79,0,fk,0,7ld,0,7d||",
                "Azerbaijan": "79,0,fs,0,7d,0,qe,0,7l9|79,0,fk,0,7d,0,qe,0,7l9||",
                "Azores": "79,0,fs,0,7d,0,ag,0,7l5,0,1q9|79,0,fk,0,7d,0,ag,0,7l5,0,1q9||",
                "Bangladesh": "79,0,fs,0,7d,0,n2,0,q8|79,0,fk,0,7d,0,n2,0,q8||",
                "Bhutan": "79,0,7d,0,n2,0,b8l|||",
                "Bolivia": "79,0,b8m,0,7d|||",
                "Brasilia": "79,0,fs,0,7kg,0,7d|79,0,fk,0,7kg,0,7d||",
                "Brunei": "79,0,7d,0,n2,0,b8o|||",
                "Cape_Verde": "79,0,fs,0,7d,0,ag,0,129,0,12p,5,115|79,0,fk,0,7d,0,ag,0,129,0,12p,5,115||",
                "Chamorro": "79,0,7d,0,ag,0,b8q,0,b8r,0,129|||",
                "Chatham": "79,0,fs,0,7d,0,ag,0,39i,0,162|79,0,fk,0,7d,0,ag,0,39i,0,162||",
                "Chile": "79,0,fs,0,7kb,0,7d|79,0,fk,0,7kb,0,7d||",
                "China": "79,0,7jq,0,fs,0,7d|79,0,7jq,0,fk,0,7d||",
                "Choibalsan": "79,0,fs,0,7d,0,n2,0,11e|79,0,fk,0,7d,0,n2,0,11e||",
                "Christmas": "79,0,7d,0,ag,0,126,0,b90|||",
                "Cocos": "79,0,7d,0,ag,0,b91,0,1q9|||",
                "Colombia": "79,0,fs,0,7im,0,7d|79,0,fk,0,7im,0,7d||",
                "Cook": "79,0,fs,0,7d,0,ag,0,1q9,0,17u|79,0,fk,0,7d,0,ag,0,1q9,0,17u||",
                "Cuba": "79,0,fs,0,7d,0,ag,0,7ii|79,0,fk,0,7d,0,ag,0,7ii||",
                "Davis": "79,0,7d,0,n2,0,b94|||",
                "DumontDUrville": "79,0,7d,0,n2,0,1gu,0,b95|||",
                "East_Timor": "79,0,7d,0,n2,0,b96,0,b97|||",
                "Easter": "79,0,fs,0,7d,0,ag,0,126,0,170|79,0,fk,0,7d,0,ag,0,126,0,170||",
                "Ecuador": "79,0,7d,0,qe,0,b98|||",
                "Europe_Central": "79,0,7ih,0,fs,0,7d|79,0,7ih,0,fk,0,7d||",
                "Europe_Eastern": "79,0,7ic,0,fs,0,7d|79,0,7ic,0,fk,0,7d||",
                "Europe_Further_Eastern": "79,0,b9b,0,b9c,0,7d|||",
                "Europe_Western": "79,0,7i8,0,fs,0,7d|79,0,7i8,0,fk,0,7d||",
                "Falkland": "79,0,fs,0,7d,0,ag,0,7i5,0,1q9|79,0,fk,0,7d,0,ag,0,7i5,0,1q9||",
                "Fiji": "79,0,fs,0,7d,0,ag,0,7i4|79,0,fk,0,7d,0,ag,0,7i4||",
                "French_Guiana": "79,0,7d,0,b9g,0,b9h|||",
                "French_Southern": "79,0,7d,0,ag,0,b9i,0,b9j,0,1tt,0,b9k,0,b9l|||",
                "Galapagos": "79,0,7d,0,ag,0,b9m,0,129|||",
                "Gambier": "79,0,7d,0,ag,0,126,0,b9n|||",
                "Georgia": "79,0,fs,0,7d,0,n2,0,7i1|79,0,fk,0,7d,0,n2,0,7i1||",
                "Gilbert_Islands": "79,0,7d,0,ag,0,129,0,8bk|||",
                "GMT": "79,0,b9p|||",
                "Greenland_Eastern": "79,0,fs,0,2pf,0,7d,0,n2,0,39r|79,0,fk,0,2pf,0,7d,0,n2,0,39r||",
                "Greenland_Western": "79,0,fs,0,4q3,0,7d,0,n2,0,39r|79,0,fk,0,4q3,0,7d,0,n2,0,39r||",
                "Gulf": "79,0,7d,0,b9s,0,b9t|||",
                "Guyana": "79,0,7d,0,n2,0,b9u|||",
                "Hawaii_Aleutian": "79,0,fs,0,7hj,5,7hd,0,7d|79,0,fk,0,7hj,5,7hd,0,7d||",
                "Hong_Kong": "79,0,fs,0,7d,0,n2,0,7hb|79,0,fk,0,7d,0,n2,0,7hb||",
                "Hovd": "79,0,fs,0,7d,0,n2,0,7ha|79,0,fk,0,7d,0,n2,0,7ha||",
                "India": "79,0,ba3,0,fs,0,7d|||",
                "Indian_Ocean": "79,0,7d,0,qe,0,ba4,0,ba5|||",
                "Indochina": "79,0,7d,0,qe,0,ba6|||",
                "Indonesia_Central": "79,0,ba7,0,7d|||",
                "Indonesia_Eastern": "79,0,ba8,0,7d|||",
                "Indonesia_Western": "79,0,ba9,0,7d|||",
                "Iran": "79,0,7h6,0,fs,0,7d|79,0,7h6,0,fk,0,7d||",
                "Irkutsk": "79,0,7h5,0,fs,0,7d|79,0,7h5,0,fk,0,7d||",
                "Israel": "79,0,7h3,0,fs,0,7d|79,0,7h3,0,fk,0,7d||",
                "Japan": "79,0,7gs,0,fs,0,7d|79,0,7gs,0,fk,0,7d||",
                "Kamchatka": "79,0,7gl,0,fs,0,7d|79,0,7gl,0,fk,0,7d||",
                "Kazakhstan_Eastern": "79,0,2pf,0,7d,0,n2,0,7gi|||",
                "Kazakhstan_Western": "79,0,4q3,0,7d,0,n2,0,7gi|||",
                "Korea": "79,0,7gh,0,fs,0,7d|79,0,7gh,0,fk,0,7d||",
                "Kosrae": "79,0,7d,0,ag,0,126,0,1qi|||",
                "Krasnoyarsk": "79,0,7ge,0,fs,0,7d|79,0,7ge,0,fk,0,7d||",
                "Kyrgystan": "79,0,7d,0,n2,0,bai|||",
                "Lanka": "295,0,1et|||",
                "Line_Islands": "79,0,7d,0,ag,0,126,0,1eo|||",
                "Lord_Howe": "79,0,fs,0,7d,0,ag,0,126,0,oi,5,10a|79,0,fk,0,7d,0,ag,0,126,0,oi,5,10a||",
                "Macquarie": "79,0,7d,0,ag,0,126,0,baj|||",
                "Magadan": "79,0,7gd,0,fs,0,7d|79,0,7gd,0,fk,0,7d||",
                "Malaysia": "79,0,7d,0,n2,0,bal|||",
                "Maldives": "79,0,7d,0,ag,0,bam|||",
                "Marquesas": "79,0,7d,0,ag,0,ban,0,129|||",
                "Marshall_Islands": "79,0,7d,0,ag,0,bao,0,1q9|||",
                "Mauritius": "79,0,fs,0,7d,0,ag,0,126,0,7gb|79,0,fk,0,7d,0,ag,0,126,0,7gb||",
                "Mawson": "79,0,7d,0,ag,0,3a0,0,1lt|||",
                "Mexico_Northwest": "79,0,fs,0,7en,0,7d,0,n2,0,3a4|79,0,fk,0,7en,0,7d,0,n2,0,3a4||",
                "Mexico_Pacific": "79,0,fs,0,39b,0,7d,0,n2,0,3a4|79,0,fk,0,39b,0,7d,0,n2,0,3a4||",
                "Mongolia": "79,0,fs,0,7d,0,qe,0,or,5,7e9|79,0,fk,0,7d,0,qe,0,or,5,7e9||",
                "Moscow": "79,0,7e8,0,fs,0,7d|79,0,7e8,0,fk,0,7d||",
                "Myanmar": "79,0,7d,0,n2,0,bav|||",
                "Nauru": "79,0,7d,0,ag,0,126,0,14s|||",
                "Nepal": "79,0,7d,0,n2,0,bb0|||",
                "New_Caledonia": "79,0,fs,0,7d,0,ag,0,129,0,7dl,0,7dh|79,0,fk,0,7d,0,ag,0,129,0,7dl,0,7dh||",
                "New_Zealand": "79,0,fs,0,7d,0,n2,0,7dg,0,7de|79,0,fk,0,7d,0,n2,0,7dg,0,7de||",
                "Newfoundland": "79,0,fs,0,7d,0,ag,0,126,0,14t|79,0,fk,0,7d,0,n2,0,14t||",
                "Niue": "79,0,7d,0,ag,0,126,0,bb5|||",
                "Norfolk": "79,0,7d,0,ag,0,126,0,146|||",
                "Noronha": "79,0,fs,0,7d,0,ag,0,39i,0,141,5,7dd,5,132|79,0,fk,0,7d,0,ag,0,39i,0,141,5,7dd,5,132||",
                "Novosibirsk": "79,0,7dc,0,fs,0,7d|79,0,7dc,0,fk,0,7d||",
                "Omsk": "79,0,7db,0,fs,0,7d|79,0,7db,0,fk,0,7d||",
                "Pakistan": "79,0,fs,0,7d,0,n2,0,7da|79,0,fk,0,7d,0,n2,0,7da||",
                "Palau": "79,0,7d,0,ag,0,126,0,159|||",
                "Papua_New_Guinea": "79,0,7d,0,ag,0,129,0,13k,0,125,0,bba|||",
                "Paraguay": "79,0,fs,0,7d6,0,7d|79,0,fk,0,7d6,0,7d||",
                "Peru": "79,0,fs,0,7d,0,n2,0,q1|79,0,fk,0,7d,0,n2,0,q1||",
                "Philippines": "79,0,fs,0,7d,0,ag,0,7d3|79,0,fk,0,7d,0,ag,0,7d3||",
                "Phoenix_Islands": "79,0,7d,0,ag,0,129,0,530|||",
                "Pierre_Miquelon": "79,0,fs,0,7d,0,ag,0,129,0,pr,5,7cv,0,1tt,0,3q6|79,0,fk,0,7d,0,ag,0,129,0,pr,5,7cv,0,1tt,0,3q6||",
                "Pitcairn": "79,0,7d,0,ag,0,129,0,bbe|||",
                "Ponape": "79,0,7d,0,ag,0,126,0,1v2|||",
                "Pyongyang": "79,0,7d,0,n2,0,bbf|||",
                "Qyzylorda": "295,0,1cj,k,0,4qm|295,0,1cj,k,0,4ql||",
                "Reunion": "79,0,7d,0,ag,0,126,0,bbg|||",
                "Rothera": "79,0,7d,0,ag,0,3a0,0,157|||",
                "Sakhalin": "79,0,7cu,0,fs,0,7d|79,0,7cu,0,fk,0,7d||",
                "Samara": "79,0,7cr,0,fs,0,7d|79,0,7cr,0,fk,0,7d||",
                "Samoa": "79,0,fs,0,7d,0,ag,0,126,0,p0|79,0,fk,0,7d,0,ag,0,126,0,p0||",
                "Seychelles": "79,0,7d,0,ag,0,bbj,0,1q9|||",
                "Singapore": "79,0,7d,0,n2,0,bbk|||",
                "Solomon": "79,0,7d,0,ag,0,bbl,0,129|||",
                "South_Georgia": "79,0,7d,0,ag,0,126,0,bbm,0,bbn|||",
                "Suriname": "79,0,7d,0,n2,0,bbo|||",
                "Syowa": "79,0,7d,0,ag,0,3a0,0,bbp|||",
                "Tahiti": "79,0,7d,0,ag,0,126,0,bbq|||",
                "Taipei": "79,0,fs,0,7d,0,n2,0,7cp|79,0,fk,0,7d,0,n2,0,7cp||",
                "Tajikistan": "79,0,7d,0,n2,0,bbs|||",
                "Tokelau": "79,0,7d,0,ag,0,129,0,156|||",
                "Tonga": "79,0,fs,0,7d,0,ag,0,129,0,ot|79,0,fk,0,7d,0,ag,0,129,0,ot||",
                "Truk": "79,0,7d,0,ag,0,129,0,1f2|||",
                "Turkmenistan": "79,0,fs,0,7d,0,n2,0,7c7|79,0,fk,0,7d,0,n2,0,7c7||",
                "Tuvalu": "79,0,7d,0,ag,0,129,0,14j|||",
                "Uruguay": "79,0,fs,0,7d,0,qe,0,7c5|79,0,fk,0,7d,0,qe,0,7c5||",
                "Uzbekistan": "79,0,fs,0,7d,0,qe,0,7bs|79,0,fk,0,7d,0,qe,0,7bs||",
                "Vanuatu": "79,0,fs,0,7d,0,ag,0,129,0,os|79,0,fk,0,7d,0,ag,0,129,0,os||",
                "Venezuela": "79,0,7d,0,n2,0,bc0|||",
                "Vladivostok": "79,0,7bq,0,fs,0,7d|79,0,7bq,0,fk,0,7d||",
                "Volgograd": "79,0,7bn,0,fs,0,7d|79,0,7bn,0,fk,0,7d||",
                "Vostok": "79,0,7d,0,ag,0,3a0,0,155|||",
                "Wake": "79,0,7d,0,ag,0,126,0,84k|||",
                "Wallis": "79,0,7d,0,ag,0,129,0,bc3,0,1tt,0,14l|||",
                "Yakutsk": "79,0,7bl,0,fs,0,7d|79,0,7bl,0,fk,0,7d||",
                "Yekaterinburg": "79,0,7bk,0,fs,0,7d|79,0,7bk,0,fk,0,7d||"
            }
        },
        "ur-IN": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6m5,0,i9,0,3g||",
                "Europe/London": "|6af,0,gg,0,3g||"
            },
            "metazone": {
                "Afghanistan": "3ki,0,3g|||",
                "Africa_Central": "205,0,1lb,0,3g|||",
                "Africa_Eastern": "10l,0,1lb,0,3g|||",
                "Africa_Southern": "1ot,0,1lb,0,fj,0,3g|||",
                "Africa_Western": "ru,0,1lb,0,fj,0,3g|ru,0,1lb,0,gg,0,3g||",
                "Alaska": "3ac,0,i9,0,3g|3ac,0,ki,0,kj,0,3g||",
                "Amazon": "4pn,0,fj,0,3g|4pn,0,gg,0,3g||",
                "America_Central": "1jr,0,i9,0,3g|1jr,0,ki,0,kj,0,3g||",
                "America_Eastern": "20b,0,i9,0,3g|20b,0,ki,0,kj,0,3g||",
                "America_Mountain": "3al,0,i9,0,3g|3al,0,ki,0,kj,0,3g||",
                "America_Pacific": "20e,0,i9,0,3g|20e,0,ki,0,kj,0,3g||",
                "Anadyr": "3am,0,i9,0,3g|3am,0,gg,0,3g||",
                "Apia": "3an,0,fj,0,3g|3an,0,ki,0,kj,0,3g||",
                "Arabian": "3ap,0,fj,0,3g|3ap,0,ki,0,kj,0,3g||",
                "Argentina": "20i,0,fj,0,3g|20i,0,gg,0,3g||",
                "Argentina_Western": "ru,0,20i,0,fj,0,3g|ru,0,20i,0,gg,0,3g||",
                "Armenia": "3aq,0,fj,0,3g|3aq,0,gg,0,3g||",
                "Atlantic": "3ar,0,i9,0,3g|3ar,0,ki,0,kj,0,3g||",
                "Australia_Central": "1cv,0,1jr,0,i9,0,3g|1cv,0,1jr,0,ki,0,kj,0,3g||",
                "Australia_CentralWestern": "1cv,0,1jr,0,20m,0,i9,0,3g|1cv,0,1jr,0,20m,0,ki,0,kj,0,3g||",
                "Australia_Eastern": "1cv,0,20b,0,i9,0,3g|1cv,0,20b,0,ki,0,kj,0,3g||",
                "Australia_Western": "7a5,0,20m,0,i9,0,3g|1cv,0,20m,0,ki,0,kj,0,3g||",
                "Azerbaijan": "3av,0,fj,0,3g|3av,0,gg,0,3g||",
                "Azores": "3b4,0,c3,0,rd,0,1n|3b4,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Bangladesh": "3b9,0,3ba,0,fj,0,3g|3b9,0,3ba,0,gg,0,3g||",
                "Bhutan": "780,0,3g|||",
                "Bolivia": "77n,0,3g|||",
                "Brasilia": "20q,0,fj,0,3g|20q,0,gg,0,3g||",
                "Brunei": "3jr,0,3jq,0,3g|||",
                "Cape_Verde": "2es,0,3bb,0,fj,0,3g|2es,0,3bb,0,gg,0,3g||",
                "Chamorro": "3ji,0,fj,0,3g|||",
                "Chatham": "3bf,0,i9,0,3g|3bf,0,ki,0,kj,0,3g||",
                "Chile": "3bg,0,fj,0,3g|3bg,0,gg,0,3g||",
                "China": "211,0,fj,0,3g|76t,0,ki,0,kj,0,3g||",
                "Choibalsan": "76g,0,fj,0,3g|747,0,gg,0,3g||",
                "Christmas": "742,0,1jd,0,3g|||",
                "Cocos": "3jb,0,13q,0,3g|||",
                "Colombia": "3bh,0,fj,0,3g|3bh,0,gg,0,3g||",
                "Cook": "3bi,0,13q,0,fj,0,3g|3bi,0,13q,0,734,0,gg,0,3g||",
                "Cuba": "3bj,0,i9,0,3g|3bj,0,ki,0,kj,0,3g||",
                "Davis": "72p,0,3g|||",
                "DumontDUrville": "728,5,726,0,3g|||",
                "East_Timor": "10l,0,3j3,0,3g|||",
                "Easter": "3bm,0,1jd,0,fj,0,3g|3bm,0,1jd,0,gg,0,3g||",
                "Ecuador": "71o,0,3g|||",
                "Europe_Central": "205,0,1jc,0,c3,0,rd,0,1n|205,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Europe_Eastern": "10l,0,1jc,0,c3,0,rd,0,1n|10l,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Europe_Further_Eastern": "71i,0,10l,0,71g,0,1n|||",
                "Europe_Western": "ru,0,1jc,0,c3,0,rd,0,1n|ru,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Falkland": "3bu,0,14p,0,13q,0,fj,0,3g|3bu,0,14p,0,13q,0,gg,0,3g||",
                "Fiji": "3bv,0,fj,0,3g|3bv,0,gg,0,3g||",
                "French_Guiana": "3c3,0,3c5,0,3g|||",
                "French_Southern": "3c3,0,1ot,0,22o,0,6t9,0,3g|||",
                "Galapagos": "6t8,0,3g|||",
                "Gambier": "6rk,0,3g|||",
                "Georgia": "2g3,0,fj,0,3g|2g3,0,gg,0,3g||",
                "Gilbert_Islands": "6qn,0,13q,0,3g|||",
                "GMT": "1n0,0,6qe,0,be9,0,3g|||",
                "Greenland_Eastern": "10l,0,1n0,0,14p,0,i9,0,3g|10l,0,1n0,0,14p,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Greenland_Western": "ru,0,1n0,0,14p,0,i9,0,3g|ru,0,1n0,0,14p,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Gulf": "3ii,0,fj,0,3g|||",
                "Guyana": "3c5,0,3g|||",
                "Hawaii_Aleutian": "3c8,0,3c9,0,i9,0,3g|3c8,0,3c9,0,ki,0,kj,0,3g||",
                "Hong_Kong": "3ca,0,3cb,0,fj,0,3g|3ca,0,3cb,0,gg,0,3g||",
                "Hovd": "3cc,0,fj,0,3g|3cc,0,gg,0,3g||",
                "India": "bef,0,fj,0,3g|||",
                "Indian_Ocean": "6q5,0,3cd,0,3g|||",
                "Indochina": "3cd,0,211,0,3g|||",
                "Indonesia_Central": "205,0,2f5,0,3g|||",
                "Indonesia_Eastern": "10l,0,2f5,0,3g|||",
                "Indonesia_Western": "ru,0,2f5,0,3g|||",
                "Iran": "21q,0,fj,0,3g|21q,0,ki,0,kj,0,3g||",
                "Irkutsk": "3dq,0,fj,0,3g|3dq,0,gg,0,3g||",
                "Israel": "21s,0,fj,0,3g|21s,0,ki,0,kj,0,3g||",
                "Japan": "3dt,0,fj,0,3g|3dt,0,ki,0,kj,0,3g||",
                "Kamchatka": "3e0,5,3e3,0,i9,0,3g|3e0,5,3e3,0,gg,0,3g||",
                "Kazakhstan_Eastern": "10l,0,3e6,0,3g|||",
                "Kazakhstan_Western": "ru,0,3e6,0,3g|||",
                "Korea": "3e7,0,fj,0,3g|3e7,0,ki,0,kj,0,3g||",
                "Kosrae": "6ft,0,3g|||",
                "Krasnoyarsk": "6fs,0,fj,0,3g|6f9,0,gg,0,3g||",
                "Kyrgystan": "6f8,0,3g|||",
                "Line_Islands": "6f6,0,13q,0,3g|||",
                "Lord_Howe": "3e9,0,3ea,0,i9,0,3g|3e9,0,3ea,0,ki,0,kj,0,3g||",
                "Macquarie": "6eu,0,1jd,0,3g|||",
                "Magadan": "6es,0,i9,0,3g|6eq,0,gg,0,3g||",
                "Malaysia": "6ep,0,3g|||",
                "Maldives": "6en,0,3g|||",
                "Marquesas": "6em,0,3g|||",
                "Marshall_Islands": "6el,0,13q,0,3g|||",
                "Mauritius": "3eb,0,fj,0,3g|3eb,0,gg,0,3g||",
                "Mawson": "6ej,0,3g|||",
                "Mexico_Northwest": "225,0,ru,0,3ec,0,i9,0,3g|225,0,ru,0,3ec,0,ki,0,kj,0,3g||",
                "Mexico_Pacific": "3ed,0,20e,0,i9,0,3g|3ed,0,20e,0,ki,0,kj,0,3g||",
                "Mongolia": "3ee,0,3ef,0,fj,0,3g|3ee,0,3ef,0,gg,0,3g||",
                "Moscow": "2eo,0,i9,0,3g|2eo,0,gg,0,3g||",
                "Myanmar": "3hc,0,3g|||",
                "Nauru": "6ea,0,3g|||",
                "Nepal": "6e8,0,3g|||",
                "New_Caledonia": "1ob,0,3eg,0,fj,0,3g|1ob,0,3eg,0,gg,0,3g||",
                "New_Zealand": "3eh,0,14p,0,fj,0,3g|3eh,0,14p,0,ki,0,kj,0,3g||",
                "Newfoundland": "1ob,0,3ei,0,14p,0,i9,0,3g|1ob,0,3ei,0,14p,0,ki,0,kj,0,3g||",
                "Niue": "6dr,0,3g|||",
                "Norfolk": "6dp,0,1jd,0,c3,0,1n|||",
                "Noronha": "3ej,0,2u7,0,6dj,0,fj,0,3g|3ej,0,2u7,0,447,0,gg,0,3g||",
                "Novosibirsk": "3ek,0,fj,0,3g|3ek,0,gg,0,3g||",
                "Omsk": "22h,0,fj,0,3g|22h,0,gg,0,3g||",
                "Pakistan": "22i,0,fj,0,3g|22i,0,gg,0,3g||",
                "Palau": "6dh,0,3g|||",
                "Papua_New_Guinea": "6dc,0,1ob,0,6da,0,3g|||",
                "Paraguay": "3em,0,fj,0,3g|3em,0,gg,0,3g||",
                "Peru": "3en,0,fj,0,3g|3en,0,gg,0,3g||",
                "Philippines": "3eo,0,fj,0,3g|3eo,0,gg,0,3g||",
                "Phoenix_Islands": "6d5,0,13q,0,3g|||",
                "Pierre_Miquelon": "3ep,0,3er,0,22o,0,3es,0,i9,0,3g|3ep,0,3er,0,22o,0,3es,0,ki,0,kj,0,3g||",
                "Pitcairn": "6cu,0,3g|||",
                "Ponape": "6cl,0,3g|||",
                "Pyongyang": "6ck,0,6ce,0,1n|||",
                "Reunion": "6cd,0,6cc,0,3g|||",
                "Rothera": "6ca,0,3g|||",
                "Sakhalin": "3f0,0,fj,0,3g|3f0,0,gg,0,3g||",
                "Samara": "if,0,i9,0,3g|if,0,gg,0,3g||",
                "Samoa": "3f2,0,fj,0,3g|3f2,0,ki,0,kj,0,3g||",
                "Seychelles": "6c6,0,3g|||",
                "Singapore": "3g0,0,fj,0,3g|||",
                "Solomon": "6c5,0,13q,0,3g|||",
                "South_Georgia": "1ot,0,2g3,0,3g|||",
                "Suriname": "3fv,0,3g|||",
                "Syowa": "4is,0,3g|||",
                "Tahiti": "6c4,0,3g|||",
                "Taipei": "6c3,0,3f4,0,i9,0,3g|6bu,0,3f4,0,ki,0,kj,0,3g||",
                "Tajikistan": "6bs,0,3g|||",
                "Tokelau": "6bq,0,3g|||",
                "Tonga": "3f5,0,fj,0,3g|3f5,0,gg,0,3g||",
                "Truk": "6bo,0,3g|||",
                "Turkmenistan": "3f7,0,fj,0,3g|3f7,0,gg,0,3g||",
                "Tuvalu": "6bj,0,3g|||",
                "Uruguay": "3f8,0,fj,0,3g|3f8,0,gg,0,3g||",
                "Uzbekistan": "231,0,fj,0,3g|231,0,gg,0,3g||",
                "Vanuatu": "3fb,0,fj,0,3g|3fb,0,gg,0,3g||",
                "Venezuela": "6ba,0,3g|||",
                "Vladivostok": "3fd,0,3ff,0,fj,0,3g|3fd,0,3ff,0,gg,0,3g||",
                "Volgograd": "3fk,0,i9,0,3g|3fk,0,gg,0,3g||",
                "Vostok": "62o,0,3g|||",
                "Wake": "2pn,0,1jd,0,3g|||",
                "Wallis": "62n,0,22o,0,62k,0,3g|||",
                "Yakutsk": "3kj,0,i9,0,3g|3kj,0,gg,0,3g||",
                "Yekaterinburg": "3km,0,i9,0,3g|3km,0,gg,0,3g||"
            }
        },
        "ur": {
            "gmtFormat": "GMT {0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6m5,0,i9,0,3g||",
                "Europe/London": "|6af,0,gg,0,3g||"
            },
            "metazone": {
                "Afghanistan": "3ki,0,c3,0,1n|||",
                "Africa_Central": "205,0,1lb,0,3g|||",
                "Africa_Eastern": "10l,0,1lb,0,3g|||",
                "Africa_Southern": "1ot,0,1lb,0,fj,0,3g|||",
                "Africa_Western": "ru,0,1lb,0,fj,0,3g|ru,0,1lb,0,gg,0,3g||",
                "Alaska": "3ac,0,i9,0,3g|3ac,0,ki,0,kj,0,3g||",
                "Amazon": "4pn,0,fj,0,3g|bh2,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "America_Central": "1jr,0,i9,0,3g|1jr,0,ki,0,kj,0,3g||",
                "America_Eastern": "20b,0,i9,0,3g|20b,0,ki,0,kj,0,3g||",
                "America_Mountain": "3al,0,i9,0,3g|3al,0,ki,0,kj,0,3g||",
                "America_Pacific": "20e,0,i9,0,3g|20e,0,ki,0,kj,0,3g||",
                "Anadyr": "3am,0,i9,0,3g|3am,0,gg,0,3g||",
                "Apia": "3an,0,fj,0,3g|3an,0,ki,0,kj,0,3g||",
                "Arabian": "3ap,0,c3,0,rd,0,1n|3ap,0,ki,0,kj,0,3g||",
                "Argentina": "20i,0,fj,0,3g|20i,0,gg,0,3g||",
                "Argentina_Western": "ru,0,20i,0,c3,0,rd,0,1n|ru,0,20i,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Armenia": "3aq,0,c3,0,rd,0,1n|3aq,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Atlantic": "3ar,0,i9,0,3g|3ar,0,ki,0,kj,0,3g||",
                "Australia_Central": "1cv,0,1jr,0,i9,0,3g|1cv,0,1jr,0,ki,0,kj,0,3g||",
                "Australia_CentralWestern": "1cv,0,1jr,0,20m,0,i9,0,3g|1cv,0,1jr,0,20m,0,ki,0,kj,0,3g||",
                "Australia_Eastern": "1cv,0,20b,0,i9,0,3g|1cv,0,20b,0,ki,0,kj,0,3g||",
                "Australia_Western": "7a5,0,20m,0,i9,0,3g|1cv,0,20m,0,ki,0,kj,0,3g||",
                "Azerbaijan": "3av,0,c3,0,rd,0,1n|3av,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Azores": "3b4,0,c3,0,rd,0,1n|3b4,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Bangladesh": "3b9,0,3ba,0,c3,0,rd,0,1n|3b9,0,3ba,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Bhutan": "780,0,c3,0,1n|||",
                "Bolivia": "77n,0,c3,0,1n|||",
                "Brasilia": "20q,0,i9,0,3g|20q,0,gg,0,3g||",
                "Brunei": "3jr,0,3jq,0,3g|||",
                "Cape_Verde": "2es,0,3bb,0,fj,0,3g|2es,0,3bb,0,gg,0,3g||",
                "Chamorro": "3ji,0,fj,0,3g|||",
                "Chatham": "3bf,0,i9,0,3g|3bf,0,ki,0,kj,0,3g||",
                "Chile": "3bg,0,c3,0,rd,0,1n|3bg,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "China": "211,0,fj,0,3g|76t,0,ki,0,kj,0,3g||",
                "Choibalsan": "76g,0,fj,0,3g|747,0,gg,0,3g||",
                "Christmas": "742,0,1jd,0,3g|||",
                "Cocos": "3jb,0,13q,0,3g|||",
                "Colombia": "3bh,0,c3,0,rd,0,1n|3bh,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Cook": "3bi,0,13q,0,fj,0,3g|3bi,0,13q,0,734,0,gg,0,3g||",
                "Cuba": "3bj,0,i9,0,3g|3bj,0,ki,0,kj,0,3g||",
                "Davis": "72p,0,3g|||",
                "DumontDUrville": "728,5,726,0,3g|||",
                "East_Timor": "10l,0,3j3,0,3g|||",
                "Easter": "3bm,0,1jd,0,c3,0,rd,0,1n|3bm,0,1jd,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Ecuador": "71o,0,c3,0,1n|||",
                "Europe_Central": "205,0,1jc,0,c3,0,rd,0,1n|205,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Europe_Eastern": "10l,0,1jc,0,c3,0,rd,0,1n|10l,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Europe_Further_Eastern": "71i,0,10l,0,71g,0,1n|||",
                "Europe_Western": "ru,0,1jc,0,c3,0,rd,0,1n|ru,0,1jc,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Falkland": "3bu,0,14p,0,13q,0,c3,0,rd,0,1n|3bu,0,14p,0,13q,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Fiji": "3bv,0,fj,0,3g|3bv,0,gg,0,3g||",
                "French_Guiana": "3c3,0,3c5,0,c3,0,1n|||",
                "French_Southern": "3c3,0,1ot,0,22o,0,6t9,0,3g|||",
                "Galapagos": "6t8,0,c3,0,1n|||",
                "Gambier": "6rk,0,3g|||",
                "Georgia": "2g3,0,c3,0,rd,0,1n|2g3,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Gilbert_Islands": "6qn,0,13q,0,3g|||",
                "GMT": "1n0,0,6qe,0,c3,0,bh3,0,1n|||",
                "Greenland_Eastern": "10l,0,1n0,0,14p,0,i9,0,3g|10l,0,1n0,0,14p,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Greenland_Western": "ru,0,1n0,0,14p,0,i9,0,3g|ru,0,1n0,0,14p,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Gulf": "3ii,0,c3,0,rd,0,1n|||",
                "Guyana": "3c5,0,c3,0,1n|||",
                "Hawaii_Aleutian": "3c8,0,3c9,0,i9,0,3g|3c8,0,3c9,0,ki,0,kj,0,3g||",
                "Hong_Kong": "3ca,0,3cb,0,fj,0,3g|3ca,0,3cb,0,gg,0,3g||",
                "Hovd": "3cc,0,fj,0,3g|3cc,0,gg,0,3g||",
                "India": "bh4,0,c3,0,rd,0,1n|||",
                "Indian_Ocean": "6q5,0,3cd,0,3g|||",
                "Indochina": "3cd,0,211,0,3g|||",
                "Indonesia_Central": "205,0,2f5,0,3g|||",
                "Indonesia_Eastern": "10l,0,2f5,0,3g|||",
                "Indonesia_Western": "ru,0,2f5,0,3g|||",
                "Iran": "21q,0,c3,0,rd,0,1n|21q,0,ki,0,kj,0,3g||",
                "Irkutsk": "3dq,0,fj,0,3g|3dq,0,gg,0,3g||",
                "Israel": "21s,0,c3,0,rd,0,1n|21s,0,ki,0,kj,0,3g||",
                "Japan": "3dt,0,fj,0,3g|3dt,0,ki,0,kj,0,3g||",
                "Kamchatka": "3e0,5,3e3,0,i9,0,3g|3e0,5,3e3,0,gg,0,3g||",
                "Kazakhstan_Eastern": "10l,0,3e6,0,c3,0,1n|||",
                "Kazakhstan_Western": "ru,0,3e6,0,c3,0,1n|||",
                "Korea": "3e7,0,fj,0,3g|3e7,0,ki,0,kj,0,3g||",
                "Kosrae": "6ft,0,3g|||",
                "Krasnoyarsk": "6fs,0,fj,0,3g|6f9,0,gg,0,3g||",
                "Kyrgystan": "6f8,0,c3,0,1n|||",
                "Line_Islands": "6f6,0,13q,0,3g|||",
                "Lord_Howe": "3e9,0,3ea,0,i9,0,3g|3e9,0,3ea,0,ki,0,kj,0,3g||",
                "Macquarie": "6eu,0,1jd,0,c3,0,1n|||",
                "Magadan": "6es,0,i9,0,3g|6eq,0,gg,0,3g||",
                "Malaysia": "6ep,0,3g|||",
                "Maldives": "6en,0,c3,0,1n|||",
                "Marquesas": "6em,0,3g|||",
                "Marshall_Islands": "6el,0,13q,0,3g|||",
                "Mauritius": "3eb,0,fj,0,3g|3eb,0,gg,0,3g||",
                "Mawson": "6ej,0,3g|||",
                "Mexico_Northwest": "225,0,ru,0,3ec,0,i9,0,3g|225,0,ru,0,3ec,0,ki,0,kj,0,3g||",
                "Mexico_Pacific": "3ed,0,20e,0,i9,0,3g|3ed,0,20e,0,ki,0,kj,0,3g||",
                "Mongolia": "3ee,0,3ef,0,fj,0,3g|3ee,0,3ef,0,gg,0,3g||",
                "Moscow": "2eo,0,i9,0,3g|2eo,0,gg,0,3g||",
                "Myanmar": "3hc,0,3g|||",
                "Nauru": "6ea,0,3g|||",
                "Nepal": "6e8,0,c3,0,1n|||",
                "New_Caledonia": "1ob,0,3eg,0,fj,0,3g|1ob,0,3eg,0,gg,0,3g||",
                "New_Zealand": "3eh,0,14p,0,c3,0,rd,0,1n|3eh,0,14p,0,ki,0,kj,0,3g||",
                "Newfoundland": "1ob,0,3ei,0,14p,0,i9,0,3g|1ob,0,3ei,0,14p,0,ki,0,kj,0,3g||",
                "Niue": "6dr,0,3g|||",
                "Norfolk": "6dp,0,1jd,0,c3,0,1n|||",
                "Noronha": "3ej,0,2u7,0,6dj,0,c3,0,rd,0,1n|3ej,0,2u7,0,447,0,gg,0,3g||",
                "Novosibirsk": "3ek,0,fj,0,3g|3ek,0,gg,0,3g||",
                "Omsk": "22h,0,fj,0,3g|22h,0,gg,0,3g||",
                "Pakistan": "22i,0,c3,0,rd,0,1n|22i,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Palau": "6dh,0,3g|||",
                "Papua_New_Guinea": "6dc,0,1ob,0,6da,0,3g|||",
                "Paraguay": "3em,0,c3,0,rd,0,1n|3em,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Peru": "3en,0,c3,0,rd,0,1n|3en,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Philippines": "3eo,0,fj,0,3g|3eo,0,gg,0,3g||",
                "Phoenix_Islands": "6d5,0,13q,0,3g|||",
                "Pierre_Miquelon": "3ep,0,3er,0,22o,0,3es,0,i9,0,3g|3ep,0,3er,0,22o,0,3es,0,ki,0,kj,0,3g||",
                "Pitcairn": "6cu,0,3g|||",
                "Ponape": "6cl,0,3g|||",
                "Pyongyang": "6ck,0,6ce,0,1n|||",
                "Reunion": "6cd,0,6cc,0,3g|||",
                "Rothera": "6ca,0,c3,0,1n|||",
                "Sakhalin": "3f0,0,fj,0,3g|3f0,0,gg,0,3g||",
                "Samara": "if,0,i9,0,3g|if,0,gg,0,3g||",
                "Samoa": "3f2,0,fj,0,3g|3f2,0,ki,0,kj,0,3g||",
                "Seychelles": "6c6,0,3g|||",
                "Singapore": "3g0,0,fj,0,3g|||",
                "Solomon": "6c5,0,13q,0,3g|||",
                "South_Georgia": "1ot,0,2g3,0,3g|||",
                "Suriname": "3fv,0,c3,0,1n|||",
                "Syowa": "4is,0,3g|||",
                "Tahiti": "6c4,0,3g|||",
                "Taipei": "6c3,0,3f4,0,i9,0,3g|6bu,0,3f4,0,ki,0,kj,0,3g||",
                "Tajikistan": "6bs,0,c3,0,1n|||",
                "Tokelau": "6bq,0,3g|||",
                "Tonga": "3f5,0,fj,0,3g|3f5,0,gg,0,3g||",
                "Truk": "6bo,0,3g|||",
                "Turkmenistan": "3f7,0,c3,0,rd,0,1n|3f7,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Tuvalu": "6bj,0,3g|||",
                "Uruguay": "3f8,0,c3,0,rd,0,1n|3f8,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Uzbekistan": "231,0,c3,0,rd,0,1n|231,0,c3,0,t6,0,t7,0,c3,0,1n||",
                "Vanuatu": "3fb,0,fj,0,3g|3fb,0,gg,0,3g||",
                "Venezuela": "6ba,0,c3,0,1n|||",
                "Vladivostok": "3fd,0,3ff,0,fj,0,3g|3fd,0,3ff,0,gg,0,3g||",
                "Volgograd": "3fk,0,i9,0,3g|3fk,0,gg,0,3g||",
                "Vostok": "62o,0,c3,0,1n|||",
                "Wake": "2pn,0,1jd,0,3g|||",
                "Wallis": "62n,0,22o,0,62k,0,3g|||",
                "Yakutsk": "3kj,0,i9,0,3g|3kj,0,gg,0,3g||",
                "Yekaterinburg": "3km,0,i9,0,3g|3km,0,gg,0,3g||"
            }
        },
        "uz-Arab": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "uz-Cyrl": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|1pi,0,md,0,82||",
                "Europe/London": "|5u9,0,md,0,82||"
            },
            "metazone": {
                "Afghanistan": "bh5,0,82|||",
                "Africa_Central": "201,0,mi,0,82|||",
                "Africa_Eastern": "1l7,0,mi,0,82|||",
                "Africa_Southern": "61r,0,mi,0,82|||",
                "Africa_Western": "1d9,0,mi,0,ab,0,82|1d9,0,mi,0,md,0,82||",
                "Alaska": "12l,0,ab,0,82|12l,0,10k,0,82||",
                "Amazon": "18e,0,ab,0,82|18e,0,md,0,82||",
                "America_Central": "1vs,0,m6,0,61l,0,ab,0,82|1vs,0,m6,0,61l,0,10k,0,82||",
                "America_Eastern": "1vs,0,m6,0,61h,0,ab,0,82|1vs,0,m6,0,61h,0,10k,0,82||",
                "America_Mountain": "1vs,0,m6,0,61g,0,ab,0,82|1vs,0,m6,0,61g,0,10k,0,82||",
                "America_Pacific": "1vs,0,m6,0,61f,0,4m2,0,ab,0,82|1vs,0,m6,0,61f,0,4m2,0,10k,0,82||",
                "Arabian": "619,0,ab,0,82|619,0,10k,0,82||",
                "Argentina": "hk,0,ab,0,82|hk,0,md,0,82||",
                "Argentina_Western": "1d9,0,hk,0,ab,0,82|1d9,0,hk,0,md,0,82||",
                "Armenia": "618,0,ab,0,82|618,0,md,0,82||",
                "Atlantic": "2fc,0,ab,0,82|2fc,0,10k,0,82||",
                "Australia_Central": "201,0,eo,0,ab,0,82|201,0,eo,0,10k,0,82||",
                "Australia_CentralWestern": "201,0,eo,0,1d9,0,ab,0,82|201,0,eo,0,1d9,0,10k,0,82||",
                "Australia_Eastern": "1l7,0,eo,0,ab,0,82|1l7,0,eo,0,10k,0,82||",
                "Australia_Western": "1d9,0,eo,0,ab,0,82|1d9,0,eo,0,10k,0,82||",
                "Azerbaijan": "613,0,ab,0,82|613,0,md,0,82||",
                "Azores": "30f,0,ab,0,82|30f,0,md,0,82||",
                "Bangladesh": "q8,0,ab,0,82|q8,0,md,0,82||",
                "Bhutan": "16f,0,82|||",
                "Bolivia": "1pu,0,82|||",
                "Brasilia": "15k,0,ab,0,82|15k,0,md,0,82||",
                "Brunei": "1gr,0,bhm,0,82|||",
                "Cape_Verde": "12p,5,115,0,ab,0,82|12p,5,115,0,md,0,82||",
                "Chamorro": "bhn,0,82|||",
                "Chatham": "60v,0,ab,0,82|60v,0,10k,0,82||",
                "Chile": "150,0,ab,0,82|150,0,md,0,82||",
                "China": "4m1,0,ab,0,82|4m1,0,10k,0,82||",
                "Choibalsan": "11e,0,ab,0,82|11e,0,md,0,82||",
                "Christmas": "4l3,0,2dk,0,82|||",
                "Cocos": "1le,0,1ks,0,82|||",
                "Colombia": "15d,0,ab,0,82|15d,0,md,0,82||",
                "Cook": "1p2,0,1ks,0,ab,0,82|1p2,0,1ks,0,bhs,0,md,0,82||",
                "Cuba": "ql,0,ab,0,82|ql,0,10k,0,82||",
                "Davis": "72u,0,82|||",
                "DumontDUrville": "bht,5,72v,5,730,0,82|||",
                "East_Timor": "1l7,0,1ki,0,82|||",
                "Easter": "170,0,2dk,0,ab,0,82|170,0,2dk,0,md,0,82||",
                "Ecuador": "1qk,0,82|||",
                "Europe_Central": "201,0,lo,0,ab,0,82|201,0,lo,0,md,0,82||",
                "Europe_Eastern": "1l7,0,lo,0,ab,0,82|1l7,0,lo,0,md,0,82||",
                "Europe_Western": "1d9,0,lo,0,ab,0,82|1d9,0,lo,0,md,0,82||",
                "Falkland": "60m,0,1ks,0,ab,0,82|60m,0,1ks,0,md,0,82||",
                "Fiji": "458,0,ab,0,82|458,0,md,0,82||",
                "French_Guiana": "307,0,bhv,0,82|||",
                "French_Southern": "307,0,bi0,0,hb,0,4lu,0,82|||",
                "Galapagos": "1na,0,82|||",
                "Gambier": "bi1,0,82|||",
                "Georgia": "15e,0,ab,0,82|15e,0,md,0,82||",
                "Gilbert_Islands": "1ne,0,1ks,0,82|||",
                "GMT": "4ht,0,82|||",
                "Greenland_Eastern": "1l7,0,pq,0,ab,0,82|1l7,0,pq,0,md,0,82||",
                "Greenland_Western": "1d9,0,pq,0,ab,0,82|1d9,0,pq,0,md,0,82||",
                "Gulf": "bi2,0,82|||",
                "Guyana": "1ql,0,82|||",
                "Hawaii_Aleutian": "45a,5,60l,0,ab,0,82|45a,5,60l,0,10k,0,82||",
                "Hong_Kong": "13t,0,ab,0,82|13t,0,md,0,82||",
                "Hovd": "qg,0,ab,0,82|qg,0,md,0,82||",
                "India": "bi4,0,82|||",
                "Indian_Ocean": "60k,0,4m2,0,82|||",
                "Indochina": "60k,5,4m1,0,82|||",
                "Indonesia_Central": "201,0,vo,0,82|||",
                "Indonesia_Eastern": "1l7,0,vo,0,82|||",
                "Indonesia_Western": "1d9,0,vo,0,82|||",
                "Iran": "60h,0,ab,0,82|60h,0,10k,0,82||",
                "Irkutsk": "12u,0,ab,0,82|12u,0,md,0,82||",
                "Israel": "60f,0,ab,0,82|60f,0,10k,0,82||",
                "Japan": "1bb,0,ab,0,82|1bb,0,10k,0,82||",
                "Kazakhstan_Eastern": "1l7,0,608,0,82|||",
                "Kazakhstan_Western": "1d9,0,608,0,82|||",
                "Korea": "15j,0,ab,0,82|15j,0,10k,0,82||",
                "Kosrae": "1qi,0,82|||",
                "Krasnoyarsk": "14h,0,ab,0,82|14h,0,md,0,82||",
                "Kyrgystan": "bi9,0,82|||",
                "Line_Islands": "1eo,0,1ks,0,82|||",
                "Lord_Howe": "oi,0,607,0,ab,0,82|oi,0,607,0,10k,0,82||",
                "Macquarie": "bib,0,2dk,0,82|||",
                "Magadan": "qq,0,ab,0,82|qq,0,md,0,82||",
                "Malaysia": "1pp,0,82|||",
                "Maldives": "4lt,0,bic|||",
                "Marquesas": "73j,0,82|||",
                "Marshall_Islands": "4ls,0,1ks,0,82|||",
                "Mauritius": "15t,0,ab,0,82|15t,0,md,0,82||",
                "Mawson": "bid,0,82|||",
                "Mongolia": "or,5,qo,0,ab,0,82|or,5,qo,0,md,0,82||",
                "Moscow": "r6,0,ab,0,82|r6,0,md,0,82||",
                "Myanmar": "1qm,0,82|||",
                "Nauru": "14s,0,82|||",
                "Nepal": "16d,0,82|||",
                "New_Caledonia": "2lq,0,15l,0,ab,0,82|2lq,0,15l,0,md,0,82||",
                "New_Zealand": "2lq,0,15h,0,ab,0,82|2lq,0,15h,0,10k,0,82||",
                "Newfoundland": "14t,0,ab,0,82|14t,0,10k,0,82||",
                "Niue": "1q4,0,82|||",
                "Norfolk": "146,0,2dk,0,82|||",
                "Noronha": "138,0,13a,0,132,0,ab,0,82|138,0,13a,0,132,0,md,0,82||",
                "Novosibirsk": "qt,0,ab,0,82|qt,0,md,0,82||",
                "Omsk": "r5,0,ab,0,82|r5,0,md,0,82||",
                "Pakistan": "605,0,ab,0,82|605,0,md,0,82||",
                "Palau": "159,0,82|||",
                "Papua_New_Guinea": "13k,5,2lq,0,1m5,0,82|||",
                "Paraguay": "13p,0,ab,0,82|13p,0,md,0,82||",
                "Peru": "q1,0,ab,0,82|q1,0,md,0,82||",
                "Philippines": "2lj,0,ab,0,82|2lj,0,md,0,82||",
                "Phoenix_Islands": "158,0,1ks,0,82|||",
                "Pierre_Miquelon": "2c3,5,13m,0,hb,0,qp,0,ab,0,82|2c3,5,13m,0,hb,0,qp,0,10k,0,82||",
                "Pitcairn": "1q6,0,82|||",
                "Ponape": "1v2,0,82|||",
                "Reunion": "1qo,0,82|||",
                "Rothera": "157,0,82|||",
                "Sakhalin": "r8,0,ab,0,82|r8,0,md,0,82||",
                "Samoa": "p0,0,ab,0,82|p0,0,10k,0,82||",
                "Seychelles": "73p,0,1ks,0,82|||",
                "Singapore": "16b,0,82|||",
                "Solomon": "4lp,0,1ks,0,82|||",
                "South_Georgia": "61r,0,6gr,0,82|||",
                "Suriname": "18v,0,82|||",
                "Syowa": "big,0,82|||",
                "Tahiti": "1ma,0,82|||",
                "Taipei": "45g,0,ab,0,82|45g,0,10k,0,82||",
                "Tajikistan": "bih,0,82|||",
                "Tokelau": "156,0,82|||",
                "Tonga": "ot,0,ab,0,82|ot,0,md,0,82||",
                "Truk": "1f2,0,82|||",
                "Turkmenistan": "601,0,ab,0,82|601,0,md,0,82||",
                "Tuvalu": "14j,0,82|||",
                "Uruguay": "14a,0,ab,0,82|14a,0,md,0,82||",
                "Uzbekistan": "600,0,ab,0,82|600,0,md,0,82||",
                "Vanuatu": "os,0,ab,0,82|os,0,md,0,82||",
                "Venezuela": "1mf,0,82|||",
                "Vladivostok": "qn,0,ab,0,82|qn,0,md,0,82||",
                "Volgograd": "q9,0,ab,0,82|q9,0,md,0,82||",
                "Vostok": "155,0,82|||",
                "Wake": "1m0,0,2dk,0,82|||",
                "Wallis": "bik,0,hb,0,14l,0,82|||",
                "Yakutsk": "14d,0,ab,0,82|14d,0,md,0,82||",
                "Yekaterinburg": "136,0,ab,0,82|136,0,md,0,82||"
            }
        },
        "uz-Latn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|640,0,a1,0,2s||",
                "Europe/London": "|3i5,0,a1,0,2s||"
            },
            "metazone": {
                "Afghanistan": "5vv,0,2s|||",
                "Africa_Central": "13o,0,c5,0,2s|||",
                "Africa_Eastern": "11q,0,c5,0,2s|||",
                "Africa_Southern": "2e4,0,c5,0,6i,0,2s|||",
                "Africa_Western": "1jp,0,c5,0,6i,0,2s|1jp,0,c5,0,a1,0,2s||",
                "Alaska": "1rr,0,6i,0,2s|1rr,0,a1,0,2s||",
                "Amazon": "2k3,0,6i,0,2s|2k3,0,a1,0,2s||",
                "America_Central": "13o,0,m2,0,6i,0,2s|13o,0,m2,0,a1,0,2s||",
                "America_Eastern": "11q,0,m2,0,6i,0,2s|11q,0,m2,0,a1,0,2s||",
                "America_Mountain": "3l1,0,6i,0,2s,0,3l2|3l1,0,a1,0,2s,0,3l2||",
                "America_Pacific": "1vc,0,1m4,0,6i,0,2s|1vc,0,1m4,0,a1,0,2s||",
                "Apia": "3e,0,6i,0,2s|3e,0,a1,0,2s||",
                "Arabian": "3l3,0,3l5,0,6i,0,2s|3l3,0,3l5,0,a1,0,2s||",
                "Argentina": "1e,0,6i,0,2s|1e,0,a1,0,2s||",
                "Argentina_Western": "1jp,0,1e,0,6i,0,2s|1jp,0,1e,0,a1,0,2s||",
                "Armenia": "3l7,0,6i,0,2s|3l7,0,a1,0,2s||",
                "Atlantic": "2k7,0,6i,0,2s|2k7,0,a1,0,2s||",
                "Australia_Central": "13o,0,r3,0,6i,0,2s|13o,0,r3,0,a1,0,2s||",
                "Australia_CentralWestern": "13o,0,r3,0,1v7,0,6i,0,2s|13o,0,r3,0,1v7,0,a1,0,2s||",
                "Australia_Eastern": "11q,0,r3,0,6i,0,2s|11q,0,r3,0,a1,0,2s||",
                "Australia_Western": "1gv,0,r3,0,6i,0,2s|1gv,0,r3,0,a1,0,2s||",
                "Azerbaijan": "3l8,0,6i,0,2s|3l8,0,a1,0,2s||",
                "Azores": "1lg,0,rv,0,6i,0,2s|1lg,0,rv,0,a1,0,2s||",
                "Bangladesh": "3n,0,6i,0,2s|3n,0,a1,0,2s||",
                "Bhutan": "1k4,0,2s|||",
                "Bolivia": "3jj,0,2s|||",
                "Brasilia": "1s2,0,6i,0,2s|1s2,0,a1,0,2s||",
                "Brunei": "5v0,5,5uu,0,2s|||",
                "Cape_Verde": "2kc,5,3j,0,6i,0,2s|2kc,5,3j,0,a1,0,2s||",
                "Chamorro": "6j,0,6i,0,2s|||",
                "Chatham": "3l9,0,6i,0,2s|3l9,0,a1,0,2s||",
                "Chile": "cg,0,6i,0,2s|cg,0,a1,0,2s||",
                "China": "3lb,0,6i,0,2s|3lb,0,a1,0,2s||",
                "Choibalsan": "3lc,0,6i,0,2s|3lc,0,a1,0,2s||",
                "Christmas": "5u1,0,1ip,0,2s|||",
                "Cocos": "1eg,0,rv,0,2s|||",
                "Colombia": "1s9,0,6i,0,2s|1s9,0,a1,0,2s||",
                "Cook": "1ec,0,rv,0,6i,0,2s|1ec,0,rv,0,5tv,0,a1,0,2s||",
                "Cuba": "tb,0,6i,0,2s|tb,0,a1,0,2s||",
                "Davis": "5tu,0,2s|||",
                "DumontDUrville": "5tt,5,5to,0,2s|||",
                "East_Timor": "11q,0,7n,0,2s|||",
                "Easter": "1sa,0,1ip,0,6i,0,2s|1sa,0,1ip,0,a1,0,2s||",
                "Ecuador": "1k0,0,2s|||",
                "Europe_Central": "13o,0,1jg,0,6i,0,2s|13o,0,1jg,0,a1,0,2s||",
                "Europe_Eastern": "11q,0,1jg,0,6i,0,2s|11q,0,1jg,0,a1,0,2s||",
                "Europe_Further_Eastern": "mo,0,1n6,0,5tl,0,2s|||",
                "Europe_Western": "1gv,0,1jg,0,6i,0,2s|1gv,0,1jg,0,a1,0,2s||",
                "Falkland": "1ov,0,rv,0,6i,0,2s|1ov,0,rv,0,a1,0,2s||",
                "Fiji": "4q,0,6i,0,2s|4q,0,a1,0,2s||",
                "French_Guiana": "2ke,0,5tk,0,2s|||",
                "French_Southern": "2ke,0,2e4,0,5ti,0,1n6,0,27v,0,2s|||",
                "Galapagos": "ak,0,2s|||",
                "Gambier": "5tg,0,2s|||",
                "Georgia": "3lf,0,6i,0,2s|3lf,0,a1,0,2s||",
                "Gilbert_Islands": "6q,0,rv,0,2s|||",
                "GMT": "5tc,0,5t9,0,2s|||",
                "Greenland_Eastern": "11q,0,1uf,0,6i,0,2s|11q,0,1uf,0,a1,0,2s||",
                "Greenland_Western": "1gv,0,1uf,0,6i,0,2s|1gv,0,1uf,0,a1,0,2s||",
                "Gulf": "5t5,0,5t0,0,6i,0,2s|||",
                "Guyana": "5sv,0,2s|||",
                "Hawaii_Aleutian": "3lj,5,3lk,0,6i,0,2s|3lj,5,3lk,0,a1,0,2s||",
                "Hong_Kong": "2kh,0,6i,0,2s|2kh,0,a1,0,2s||",
                "Hovd": "3ll,0,6i,0,2s|3ll,0,a1,0,2s||",
                "India": "5sm,0,2s|||",
                "Indian_Ocean": "3k9,0,1m4,0,2s|||",
                "Indochina": "5sl,0,2s|||",
                "Indonesia_Central": "13o,0,2fh,0,2s|||",
                "Indonesia_Eastern": "11q,0,2fh,0,2s|||",
                "Indonesia_Western": "1jp,0,2fh,0,2s|||",
                "Iran": "3ln,0,6i,0,2s|3ln,0,a1,0,2s||",
                "Irkutsk": "3h,0,6i,0,2s|3h,0,a1,0,2s||",
                "Israel": "3lq,0,6i,0,2s|3lq,0,a1,0,2s||",
                "Japan": "1sn,0,6i,0,2s|1sn,0,a1,0,2s||",
                "Kazakhstan_Eastern": "11q,0,3m2,0,2s|||",
                "Kazakhstan_Western": "1jp,0,3m2,0,2s|||",
                "Korea": "1so,0,6i,0,2s|1so,0,a1,0,2s||",
                "Kosrae": "6f,0,2s|||",
                "Krasnoyarsk": "41,0,6i,0,2s|41,0,a1,0,2s||",
                "Kyrgystan": "5s4,0,2s|||",
                "Line_Islands": "3kd,0,rv,0,2s|||",
                "Lord_Howe": "1u,5,3m4,0,6i,0,2s|1u,5,3m4,0,a1,0,2s||",
                "Macquarie": "4ru,0,1ip,0,2s|||",
                "Magadan": "2o,0,6i,0,2s|2o,0,a1,0,2s||",
                "Malaysia": "3kk,0,2s|||",
                "Maldives": "3kl,0,rv,0,2s|||",
                "Marquesas": "1jm,0,rv,0,2s|||",
                "Marshall_Islands": "7o,0,rv,0,2s|||",
                "Mauritius": "3m7,0,6i,0,2s|3m7,0,a1,0,2s||",
                "Mawson": "2v0,0,2s|||",
                "Mexico_Northwest": "3m9,5,1v7,0,10g,0,6i,0,2s|3m9,5,1v7,0,10g,0,a1,0,2s||",
                "Mexico_Pacific": "10g,0,1vc,0,1m4,0,6i,0,2s|10g,0,1vc,0,1m4,0,a1,0,2s||",
                "Mongolia": "4f,5,2m,0,6i,0,2s|4f,5,2m,0,a1,0,2s||",
                "Moscow": "pi,0,6i,0,2s|pi,0,a1,0,2s||",
                "Myanmar": "3kq,0,2s|||",
                "Nauru": "5v,0,2s|||",
                "Nepal": "8u,0,2s|||",
                "New_Caledonia": "1nq,0,1ss,0,6i,0,2s|1nq,0,1ss,0,a1,0,2s||",
                "New_Zealand": "1nq,0,1st,0,6i,0,2s|1nq,0,1st,0,a1,0,2s||",
                "Newfoundland": "1ta,0,6i,0,2s|1ta,0,a1,0,2s||",
                "Niue": "5rs,0,2s|||",
                "Norfolk": "6l,0,1ip,0,2s|||",
                "Noronha": "23a,5,4i,5,1tb,0,6i,0,2s|23a,5,4i,5,1tb,0,a1,0,2s||",
                "Novosibirsk": "3b,0,6i,0,2s|3b,0,a1,0,2s||",
                "Omsk": "26,0,6i,0,2s|26,0,a1,0,2s||",
                "Pakistan": "3mb,0,6i,0,2s|3mb,0,a1,0,2s||",
                "Palau": "9b,0,2s|||",
                "Papua_New_Guinea": "9a,5,1nq,0,5rq,0,2s|||",
                "Paraguay": "3mc,0,6i,0,2s|3mc,0,a1,0,2s||",
                "Peru": "4n,0,6i,0,2s|4n,0,a1,0,2s||",
                "Philippines": "1tc,0,6i,0,2s|1tc,0,a1,0,2s||",
                "Phoenix_Islands": "1a7,0,rv,0,2s|||",
                "Pierre_Miquelon": "14i,5,3md,0,1n6,0,u2,0,6i,0,2s|14i,5,3md,0,1n6,0,u2,0,a1,0,2s||",
                "Pitcairn": "1ko,0,2s|||",
                "Ponape": "9s,0,2s|||",
                "Pyongyang": "3kv,0,2s|||",
                "Reunion": "5rj,0,2s|||",
                "Rothera": "1po,0,2s|||",
                "Sakhalin": "1th,0,6i,0,2s|1th,0,a1,0,2s||",
                "Samoa": "2c,0,6i,0,2s|2c,0,a1,0,2s||",
                "Seychelles": "5rh,0,rv,0,2s|||",
                "Singapore": "m8,0,2s|||",
                "Solomon": "b5,0,rv,0,2s|||",
                "South_Georgia": "2e4,0,5rf,0,2s|||",
                "Suriname": "mg,0,2s|||",
                "Syowa": "3lt,0,2s|||",
                "Tahiti": "198,0,2s|||",
                "Taipei": "3me,0,6i,0,2s|3me,0,a1,0,2s||",
                "Tajikistan": "5rd,0,2s|||",
                "Tokelau": "5d,0,2s|||",
                "Tonga": "2j,0,6i,0,2s|2j,0,a1,0,2s||",
                "Truk": "6p,0,2s|||",
                "Turkmenistan": "3mf,0,6i,0,2s|3mf,0,a1,0,2s||",
                "Tuvalu": "6h,0,2s|||",
                "Uruguay": "3mg,0,6i,0,2s|3mg,0,a1,0,2s||",
                "Uzbekistan": "3mj,0,6i,0,2s|3mj,0,a1,0,2s||",
                "Vanuatu": "2f,0,6i,0,2s|2f,0,a1,0,2s||",
                "Venezuela": "2g9,0,2s|||",
                "Vladivostok": "28,0,6i,0,2s|28,0,a1,0,2s||",
                "Volgograd": "3f,0,6i,0,2s|3f,0,a1,0,2s||",
                "Vostok": "5t,0,2s|||",
                "Wake": "3pq,0,1ip,0,2s|||",
                "Wallis": "3pr,0,1n6,0,5k,0,2s|||",
                "Yakutsk": "3u,0,6i,0,2s|3u,0,a1,0,2s||",
                "Yekaterinburg": "5l,0,6i,0,2s|5l,0,a1,0,2s||"
            }
        },
        "uz": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|640,0,a1,0,2s||",
                "Europe/London": "|3i5,0,a1,0,2s||"
            },
            "metazone": {
                "Afghanistan": "5vv,0,2s|||",
                "Africa_Central": "13o,0,c5,0,2s|||",
                "Africa_Eastern": "11q,0,c5,0,2s|||",
                "Africa_Southern": "2e4,0,c5,0,6i,0,2s|||",
                "Africa_Western": "1jp,0,c5,0,6i,0,2s|1jp,0,c5,0,a1,0,2s||",
                "Alaska": "1rr,0,6i,0,2s|1rr,0,a1,0,2s||",
                "Amazon": "2k3,0,6i,0,2s|2k3,0,a1,0,2s||",
                "America_Central": "13o,0,m2,0,6i,0,2s|13o,0,m2,0,a1,0,2s||",
                "America_Eastern": "11q,0,m2,0,6i,0,2s|11q,0,m2,0,a1,0,2s||",
                "America_Mountain": "3l1,0,6i,0,2s,0,3l2|3l1,0,a1,0,2s,0,3l2||",
                "America_Pacific": "1vc,0,1m4,0,6i,0,2s|1vc,0,1m4,0,a1,0,2s||",
                "Apia": "3e,0,6i,0,2s|3e,0,a1,0,2s||",
                "Arabian": "3l3,0,3l5,0,6i,0,2s|3l3,0,3l5,0,a1,0,2s||",
                "Argentina": "1e,0,6i,0,2s|1e,0,a1,0,2s||",
                "Argentina_Western": "1jp,0,1e,0,6i,0,2s|1jp,0,1e,0,a1,0,2s||",
                "Armenia": "3l7,0,6i,0,2s|3l7,0,a1,0,2s||",
                "Atlantic": "2k7,0,6i,0,2s|2k7,0,a1,0,2s||",
                "Australia_Central": "13o,0,r3,0,6i,0,2s|13o,0,r3,0,a1,0,2s||",
                "Australia_CentralWestern": "13o,0,r3,0,1v7,0,6i,0,2s|13o,0,r3,0,1v7,0,a1,0,2s||",
                "Australia_Eastern": "11q,0,r3,0,6i,0,2s|11q,0,r3,0,a1,0,2s||",
                "Australia_Western": "1gv,0,r3,0,6i,0,2s|1gv,0,r3,0,a1,0,2s||",
                "Azerbaijan": "3l8,0,6i,0,2s|3l8,0,a1,0,2s||",
                "Azores": "1lg,0,rv,0,6i,0,2s|1lg,0,rv,0,a1,0,2s||",
                "Bangladesh": "3n,0,6i,0,2s|3n,0,a1,0,2s||",
                "Bhutan": "1k4,0,2s|||",
                "Bolivia": "3jj,0,2s|||",
                "Brasilia": "1s2,0,6i,0,2s|1s2,0,a1,0,2s||",
                "Brunei": "5v0,5,5uu,0,2s|||",
                "Cape_Verde": "2kc,5,3j,0,6i,0,2s|2kc,5,3j,0,a1,0,2s||",
                "Chamorro": "6j,0,6i,0,2s|||",
                "Chatham": "3l9,0,6i,0,2s|3l9,0,a1,0,2s||",
                "Chile": "cg,0,6i,0,2s|cg,0,a1,0,2s||",
                "China": "3lb,0,6i,0,2s|3lb,0,a1,0,2s||",
                "Choibalsan": "3lc,0,6i,0,2s|3lc,0,a1,0,2s||",
                "Christmas": "5u1,0,1ip,0,2s|||",
                "Cocos": "1eg,0,rv,0,2s|||",
                "Colombia": "1s9,0,6i,0,2s|1s9,0,a1,0,2s||",
                "Cook": "1ec,0,rv,0,6i,0,2s|1ec,0,rv,0,5tv,0,a1,0,2s||",
                "Cuba": "tb,0,6i,0,2s|tb,0,a1,0,2s||",
                "Davis": "5tu,0,2s|||",
                "DumontDUrville": "5tt,5,5to,0,2s|||",
                "East_Timor": "11q,0,7n,0,2s|||",
                "Easter": "1sa,0,1ip,0,6i,0,2s|1sa,0,1ip,0,a1,0,2s||",
                "Ecuador": "1k0,0,2s|||",
                "Europe_Central": "13o,0,1jg,0,6i,0,2s|13o,0,1jg,0,a1,0,2s||",
                "Europe_Eastern": "11q,0,1jg,0,6i,0,2s|11q,0,1jg,0,a1,0,2s||",
                "Europe_Further_Eastern": "mo,0,1n6,0,5tl,0,2s|||",
                "Europe_Western": "1gv,0,1jg,0,6i,0,2s|1gv,0,1jg,0,a1,0,2s||",
                "Falkland": "1ov,0,rv,0,6i,0,2s|1ov,0,rv,0,a1,0,2s||",
                "Fiji": "4q,0,6i,0,2s|4q,0,a1,0,2s||",
                "French_Guiana": "2ke,0,5tk,0,2s|||",
                "French_Southern": "2ke,0,2e4,0,5ti,0,1n6,0,27v,0,2s|||",
                "Galapagos": "ak,0,2s|||",
                "Gambier": "5tg,0,2s|||",
                "Georgia": "3lf,0,6i,0,2s|3lf,0,a1,0,2s||",
                "Gilbert_Islands": "6q,0,rv,0,2s|||",
                "GMT": "5tc,0,5t9,0,2s|||",
                "Greenland_Eastern": "11q,0,1uf,0,6i,0,2s|11q,0,1uf,0,a1,0,2s||",
                "Greenland_Western": "1gv,0,1uf,0,6i,0,2s|1gv,0,1uf,0,a1,0,2s||",
                "Gulf": "5t5,0,5t0,0,6i,0,2s|||",
                "Guyana": "5sv,0,2s|||",
                "Hawaii_Aleutian": "3lj,5,3lk,0,6i,0,2s|3lj,5,3lk,0,a1,0,2s||",
                "Hong_Kong": "2kh,0,6i,0,2s|2kh,0,a1,0,2s||",
                "Hovd": "3ll,0,6i,0,2s|3ll,0,a1,0,2s||",
                "India": "5sm,0,2s|||",
                "Indian_Ocean": "3k9,0,1m4,0,2s|||",
                "Indochina": "5sl,0,2s|||",
                "Indonesia_Central": "13o,0,2fh,0,2s|||",
                "Indonesia_Eastern": "11q,0,2fh,0,2s|||",
                "Indonesia_Western": "1jp,0,2fh,0,2s|||",
                "Iran": "3ln,0,6i,0,2s|3ln,0,a1,0,2s||",
                "Irkutsk": "3h,0,6i,0,2s|3h,0,a1,0,2s||",
                "Israel": "3lq,0,6i,0,2s|3lq,0,a1,0,2s||",
                "Japan": "1sn,0,6i,0,2s|1sn,0,a1,0,2s||",
                "Kazakhstan_Eastern": "11q,0,3m2,0,2s|||",
                "Kazakhstan_Western": "1jp,0,3m2,0,2s|||",
                "Korea": "1so,0,6i,0,2s|1so,0,a1,0,2s||",
                "Kosrae": "6f,0,2s|||",
                "Krasnoyarsk": "41,0,6i,0,2s|41,0,a1,0,2s||",
                "Kyrgystan": "5s4,0,2s|||",
                "Line_Islands": "3kd,0,rv,0,2s|||",
                "Lord_Howe": "1u,5,3m4,0,6i,0,2s|1u,5,3m4,0,a1,0,2s||",
                "Macquarie": "4ru,0,1ip,0,2s|||",
                "Magadan": "2o,0,6i,0,2s|2o,0,a1,0,2s||",
                "Malaysia": "3kk,0,2s|||",
                "Maldives": "3kl,0,rv,0,2s|||",
                "Marquesas": "1jm,0,rv,0,2s|||",
                "Marshall_Islands": "7o,0,rv,0,2s|||",
                "Mauritius": "3m7,0,6i,0,2s|3m7,0,a1,0,2s||",
                "Mawson": "2v0,0,2s|||",
                "Mexico_Northwest": "3m9,5,1v7,0,10g,0,6i,0,2s|3m9,5,1v7,0,10g,0,a1,0,2s||",
                "Mexico_Pacific": "10g,0,1vc,0,1m4,0,6i,0,2s|10g,0,1vc,0,1m4,0,a1,0,2s||",
                "Mongolia": "4f,5,2m,0,6i,0,2s|4f,5,2m,0,a1,0,2s||",
                "Moscow": "pi,0,6i,0,2s|pi,0,a1,0,2s||",
                "Myanmar": "3kq,0,2s|||",
                "Nauru": "5v,0,2s|||",
                "Nepal": "8u,0,2s|||",
                "New_Caledonia": "1nq,0,1ss,0,6i,0,2s|1nq,0,1ss,0,a1,0,2s||",
                "New_Zealand": "1nq,0,1st,0,6i,0,2s|1nq,0,1st,0,a1,0,2s||",
                "Newfoundland": "1ta,0,6i,0,2s|1ta,0,a1,0,2s||",
                "Niue": "5rs,0,2s|||",
                "Norfolk": "6l,0,1ip,0,2s|||",
                "Noronha": "23a,5,4i,5,1tb,0,6i,0,2s|23a,5,4i,5,1tb,0,a1,0,2s||",
                "Novosibirsk": "3b,0,6i,0,2s|3b,0,a1,0,2s||",
                "Omsk": "26,0,6i,0,2s|26,0,a1,0,2s||",
                "Pakistan": "3mb,0,6i,0,2s|3mb,0,a1,0,2s||",
                "Palau": "9b,0,2s|||",
                "Papua_New_Guinea": "9a,5,1nq,0,5rq,0,2s|||",
                "Paraguay": "3mc,0,6i,0,2s|3mc,0,a1,0,2s||",
                "Peru": "4n,0,6i,0,2s|4n,0,a1,0,2s||",
                "Philippines": "1tc,0,6i,0,2s|1tc,0,a1,0,2s||",
                "Phoenix_Islands": "1a7,0,rv,0,2s|||",
                "Pierre_Miquelon": "14i,5,3md,0,1n6,0,u2,0,6i,0,2s|14i,5,3md,0,1n6,0,u2,0,a1,0,2s||",
                "Pitcairn": "1ko,0,2s|||",
                "Ponape": "9s,0,2s|||",
                "Pyongyang": "3kv,0,2s|||",
                "Reunion": "5rj,0,2s|||",
                "Rothera": "1po,0,2s|||",
                "Sakhalin": "1th,0,6i,0,2s|1th,0,a1,0,2s||",
                "Samoa": "2c,0,6i,0,2s|2c,0,a1,0,2s||",
                "Seychelles": "5rh,0,rv,0,2s|||",
                "Singapore": "m8,0,2s|||",
                "Solomon": "b5,0,rv,0,2s|||",
                "South_Georgia": "2e4,0,5rf,0,2s|||",
                "Suriname": "mg,0,2s|||",
                "Syowa": "3lt,0,2s|||",
                "Tahiti": "198,0,2s|||",
                "Taipei": "3me,0,6i,0,2s|3me,0,a1,0,2s||",
                "Tajikistan": "5rd,0,2s|||",
                "Tokelau": "5d,0,2s|||",
                "Tonga": "2j,0,6i,0,2s|2j,0,a1,0,2s||",
                "Truk": "6p,0,2s|||",
                "Turkmenistan": "3mf,0,6i,0,2s|3mf,0,a1,0,2s||",
                "Tuvalu": "6h,0,2s|||",
                "Uruguay": "3mg,0,6i,0,2s|3mg,0,a1,0,2s||",
                "Uzbekistan": "3mj,0,6i,0,2s|3mj,0,a1,0,2s||",
                "Vanuatu": "2f,0,6i,0,2s|2f,0,a1,0,2s||",
                "Venezuela": "2g9,0,2s|||",
                "Vladivostok": "28,0,6i,0,2s|28,0,a1,0,2s||",
                "Volgograd": "3f,0,6i,0,2s|3f,0,a1,0,2s||",
                "Vostok": "5t,0,2s|||",
                "Wake": "3pq,0,1ip,0,2s|||",
                "Wallis": "3pr,0,1n6,0,5k,0,2s|||",
                "Yakutsk": "3u,0,6i,0,2s|3u,0,a1,0,2s||",
                "Yekaterinburg": "5l,0,6i,0,2s|5l,0,a1,0,2s||"
            }
        },
        "vai-Latn": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "vai-Vaii": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "vai": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "vi": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|6b,0,1km,0,ce8,5,ce9||",
                "Europe/London": "|6b,0,h6,0,hj,0,cea||"
            },
            "metazone": {
                "Acre": "6b,0,g3,0,3q|6b,0,h6,0,hj,0,3q||",
                "Afghanistan": "6b,0,b6|||",
                "Africa_Central": "6b,0,1kp,0,2v2|||",
                "Africa_Eastern": "6b,0,1ga,0,2v2|||",
                "Africa_Southern": "6b,0,g3,0,3ml,0,2v2|||",
                "Africa_Western": "6b,0,g3,0,18b,0,2v2|6b,0,h6,0,hj,0,18b,0,2v2||",
                "Alaska": "6b,0,g3,0,3p|6b,0,h6,0,hj,0,3p||",
                "Almaty": "6b,0,g3,0,56|6b,0,h6,0,hj,0,56||",
                "Amazon": "6b,0,g3,0,5m|6b,0,h6,0,hj,0,5m||",
                "America_Central": "6b,0,1km,0,1t2,0,5pk|6b,0,19e,0,168,0,1t2,0,5pk||",
                "America_Eastern": "6b,0,1km,0,1t2,0,5ph|6b,0,19e,0,168,0,1t2,0,5ph||",
                "America_Mountain": "6b,0,1km,0,1t2,0,5nj|6b,0,19e,0,168,0,1t2,0,5nj||",
                "America_Pacific": "6b,0,1km,0,3mm,0,2so,0,1r4|6b,0,h6,0,168,0,3mm,0,2so,0,1r4||",
                "Anadyr": "6b,0,g3,0,3l|6b,0,19e,0,168,0,3l||",
                "Apia": "6b,0,g3,0,3e|6b,0,h6,0,hj,0,3e||",
                "Aqtau": "6b,0,g3,0,50|6b,0,h6,0,hj,0,50||",
                "Aqtobe": "6b,0,g3,0,5o|6b,0,h6,0,hj,0,5o||",
                "Arabian": "6b,0,1km,0,5n4,0,5n3|6b,0,h6,0,hj,0,5n4,0,5n3||",
                "Argentina": "6b,0,g3,0,1e|6b,0,h6,0,hj,0,1e||",
                "Argentina_Western": "6b,0,1km,0,1t2,0,blf,0,1e|6b,0,19e,0,168,0,1t2,0,blg,0,1e||",
                "Armenia": "6b,0,g3,0,4l|6b,0,h6,0,hj,0,4l||",
                "Atlantic": "6b,0,g3,0,50r,0,18b,0,1r4|6b,0,h6,0,168,0,50r,0,18b,0,1r4||",
                "Australia_Central": "6b,0,g3,0,16e,0,1kp,0,1pj,0,1rk|6b,0,h6,0,hj,0,16e,0,1kp,0,1pj,0,1rk||",
                "Australia_CentralWestern": "6b,0,g3,0,16e,0,1kp,0,18b,0,1pj,0,1rk|6b,0,h6,0,hj,0,16e,0,1kp,0,18b,0,1pj,0,1rk||",
                "Australia_Eastern": "6b,0,g3,0,16e,0,1ga,0,1pj,0,1rk|6b,0,h6,0,hj,0,16e,0,1ga,0,1pj,0,1rk||",
                "Australia_Western": "6b,0,g3,0,16e,0,18b,0,1pj,0,1rk|6b,0,h6,0,hj,0,16e,0,18b,0,1pj,0,1rk||",
                "Azerbaijan": "6b,0,g3,0,7m|6b,0,h6,0,hj,0,7m||",
                "Azores": "6b,0,g3,0,4r|6b,0,h6,0,hj,0,4r||",
                "Bangladesh": "6b,0,g3,0,3n|6b,0,h6,0,hj,0,3n||",
                "Bhutan": "6b,0,as|||",
                "Bolivia": "6b,0,aa|||",
                "Brasilia": "6b,0,g3,0,3a|6b,0,h6,0,hj,0,3a||",
                "Brunei": "6b,0,9o,0,a4|||",
                "Cape_Verde": "6b,0,g3,0,7c,0,3j|6b,0,h6,0,hj,0,7c,0,3j||",
                "Chamorro": "6b,0,6j|||",
                "Chatham": "6b,0,g3,0,27|6b,0,h6,0,hj,0,27||",
                "Chile": "6b,0,g3,0,49|6b,0,h6,0,hj,0,49||",
                "China": "6b,0,g3,0,1kp,0,3r8|6b,0,h6,0,hj,0,1kp,0,3r8||",
                "Choibalsan": "6b,0,g3,0,2q|6b,0,h6,0,hj,0,2q||",
                "Christmas": "6b,0,19d,0,99|||",
                "Cocos": "6b,0,1k8,0,19d,0,7v|||",
                "Colombia": "6b,0,g3,0,4m|6b,0,h6,0,hj,0,4m||",
                "Cook": "6b,0,g3,0,1k8,0,19d,0,2v|6b,0,blo,0,h6,0,hj,0,1k8,0,19d,0,2v||",
                "Cuba": "6b,0,g3,0,34|6b,0,h6,0,hj,0,34||",
                "Davis": "6b,0,5s|||",
                "DumontDUrville": "6b,0,5b,5,5j|||",
                "East_Timor": "6b,0,1ga,0,7n|||",
                "Easter": "6b,0,g3,0,19d,0,50k,0,50j|6b,0,h6,0,hj,0,19d,0,50k,0,50j||",
                "Ecuador": "6b,0,ai|||",
                "Europe_Central": "6b,0,g3,0,1kp,0,2a7|6b,0,h6,0,hj,0,1kp,0,2a7||",
                "Europe_Eastern": "6b,0,g3,0,1ga,0,2a7|6b,0,h6,0,hj,0,1ga,0,2a7||",
                "Europe_Further_Eastern": "6b,0,bls,0,2a7,0,blt,0,1ga|||",
                "Europe_Western": "6b,0,g3,0,18b,0,2a7|6b,0,h6,0,168,0,18b,0,2a7||",
                "Falkland": "6b,0,g3,0,1k8,0,19d,0,4v|6b,0,h6,0,hj,0,1k8,0,19d,0,4v||",
                "Fiji": "6b,0,g3,0,4q|6b,0,h6,0,hj,0,4q||",
                "French_Guiana": "6b,0,am,0,blu,0,50h|||",
                "French_Southern": "6b,0,3ml,0,bm0,0,3r9,0,3ml,0,1pj,0,50h|||",
                "Galapagos": "6b,0,ak|||",
                "Gambier": "6b,0,6v|||",
                "Georgia": "6b,0,g3,0,50f|6b,0,h6,0,hj,0,50f||",
                "Gilbert_Islands": "6b,0,1k8,0,19d,0,6q|||",
                "GMT": "6b,0,1kp,0,bm3,0,5u|||",
                "Greenland_Eastern": "6b,0,g3,0,16e,0,1ga,0,2k|6b,0,h6,0,hj,0,16e,0,1ga,0,2k||",
                "Greenland_Western": "6b,0,g3,0,16e,0,18b,0,2k|6b,0,h6,0,hj,0,16e,0,18b,0,2k||",
                "Guam": "6b,0,g3,0,83|||",
                "Gulf": "6b,0,g3,0,bm4,0,bm5|||",
                "Guyana": "6b,0,7a|||",
                "Hawaii_Aleutian": "6b,0,g3,0,4g,5,62|6b,0,h6,0,hj,0,4g,5,62||",
                "Hong_Kong": "6b,0,g3,0,508,0,506|6b,0,h6,0,hj,0,508,0,506||",
                "Hovd": "6b,0,g3,0,2g|6b,0,h6,0,hj,0,2g||",
                "India": "6b,0,g3,0,503,0,500|||",
                "Indian_Ocean": "6b,0,503,0,500,0,1r4|||",
                "Indochina": "6b,0,1ga,0,1r4|||",
                "Indonesia_Central": "6b,0,16e,0,1kp,0,2t|||",
                "Indonesia_Eastern": "6b,0,16e,0,1ga,0,2t|||",
                "Indonesia_Western": "6b,0,16e,0,18b,0,2t|||",
                "Iran": "6b,0,g3,0,5g|6b,0,h6,0,hj,0,5g||",
                "Irkutsk": "6b,0,g3,0,3h|6b,0,h6,0,hj,0,3h||",
                "Israel": "6b,0,g3,0,4e|6b,0,h6,0,hj,0,4e||",
                "Japan": "6b,0,g3,0,4vu,0,4vs|6b,0,h6,0,hj,0,4vu,0,4vs||",
                "Kamchatka": "6b,0,1km,0,37,5,3k|6b,0,19e,0,168,0,37,5,3k||",
                "Kazakhstan_Eastern": "6b,0,16e,0,1ga,0,45|||",
                "Kazakhstan_Western": "6b,0,16e,0,18b,0,45|||",
                "Korea": "6b,0,g3,0,4vo,0,3r8|6b,0,h6,0,hj,0,4vo,0,3r8||",
                "Kosrae": "6b,0,6f|||",
                "Krasnoyarsk": "6b,0,g3,0,41|6b,0,h6,0,hj,0,41||",
                "Kyrgystan": "6b,0,bl|||",
                "Lanka": "6b,0,9c|||",
                "Line_Islands": "6b,0,1k8,0,19d,0,ac|||",
                "Lord_Howe": "6b,0,g3,0,1u,0,24|6b,0,h6,0,hj,0,1u,0,24||",
                "Macau": "6b,0,g3,0,4vn,0,4vk|6b,0,h6,0,hj,0,4vn,0,4vk||",
                "Macquarie": "6b,0,4vc,0,6m|||",
                "Magadan": "6b,0,g3,0,2o|6b,0,19e,0,168,0,2o||",
                "Malaysia": "6b,0,bf|||",
                "Maldives": "6b,0,9k|||",
                "Marquesas": "6b,0,9e|||",
                "Marshall_Islands": "6b,0,1k8,0,19d,0,7o|||",
                "Mauritius": "6b,0,g3,0,4u|6b,0,h6,0,hj,0,4u||",
                "Mawson": "6b,0,63|||",
                "Mexico_Northwest": "6b,0,g3,0,18b,0,2mp,0,5e|6b,0,h6,0,hj,0,18b,0,2mp,0,5e||",
                "Mexico_Pacific": "6b,0,g3,0,3mm,0,2so,0,1r4,0,5e|6b,0,h6,0,hj,0,3mm,0,2so,0,1r4,0,5e||",
                "Mongolia": "6b,0,1km,0,4f,0,2m|6b,0,19e,0,168,0,4f,0,2m||",
                "Moscow": "6b,0,g3,0,4v7|6b,0,h6,0,hj,0,4v7||",
                "Myanmar": "6b,0,8v|||",
                "Nauru": "6b,0,5v|||",
                "Nepal": "6b,0,8u|||",
                "New_Caledonia": "6b,0,g3,0,1m,0,4o|6b,0,h6,0,hj,0,1m,0,4o||",
                "New_Zealand": "6b,0,g3,0,1m,0,74|6b,0,h6,0,hj,0,1m,0,74||",
                "Newfoundland": "6b,0,g3,0,53|6b,0,h6,0,hj,0,53||",
                "Niue": "6b,0,8g|||",
                "Norfolk": "6b,0,4vc,0,6l|||",
                "Noronha": "6b,0,g3,0,1s,0,2,0,23|6b,0,h6,0,hj,0,1s,0,2,0,23||",
                "North_Mariana": "6b,0,1k8,0,19d,0,2mp,0,bd|||",
                "Novosibirsk": "6b,0,1km,0,3b|6b,0,19e,0,168,0,3b||",
                "Omsk": "6b,0,1km,0,26|6b,0,19e,0,168,0,26||",
                "Pakistan": "6b,0,g3,0,3i|6b,0,h6,0,hj,0,3i||",
                "Palau": "6b,0,9b|||",
                "Papua_New_Guinea": "6b,0,9a,0,1m,0,a8|||",
                "Paraguay": "6b,0,g3,0,3c|6b,0,h6,0,hj,0,3c||",
                "Peru": "6b,0,g3,0,4n|6b,0,h6,0,hj,0,4n||",
                "Philippines": "6b,0,g3,0,4v5|6b,0,h6,0,hj,0,4v5||",
                "Phoenix_Islands": "6b,0,1k8,0,19d,0,90|||",
                "Pierre_Miquelon": "6b,0,g3,0,7u,0,33,0,3r9,0,35|6b,0,h6,0,hj,0,8i,0,33,0,3r9,0,35||",
                "Pitcairn": "6b,0,7e|||",
                "Ponape": "6b,0,9s|||",
                "Pyongyang": "6b,0,2so,0,bmj|||",
                "Qyzylorda": "6b,0,g3,0,4d|6b,0,h6,0,hj,0,4d||",
                "Reunion": "6b,0,b4|||",
                "Rothera": "6b,0,5q|||",
                "Sakhalin": "6b,0,g3,0,55|6b,0,19e,0,168,0,55||",
                "Samara": "6b,0,g3,0,29|6b,0,19e,0,168,0,29||",
                "Samoa": "6b,0,g3,0,2c|6b,0,bmk,0,bml,0,2c||",
                "Seychelles": "6b,0,8k|||",
                "Singapore": "6b,0,bi|||",
                "Solomon": "6b,0,1k8,0,19d,0,b5|||",
                "South_Georgia": "6b,0,3ml,0,2u|||",
                "Suriname": "6b,0,8q|||",
                "Syowa": "6b,0,65|||",
                "Tahiti": "6b,0,8n|||",
                "Taipei": "6b,0,g3,0,4v4,0,2mp|6b,0,h6,0,hj,0,4v4,0,2mp||",
                "Tajikistan": "6b,0,bj|||",
                "Tokelau": "6b,0,5d|||",
                "Tonga": "6b,0,g3,0,2j|6b,0,h6,0,hj,0,2j||",
                "Truk": "6b,0,6p|||",
                "Turkmenistan": "6b,0,g3,0,4t|6b,0,h6,0,hj,0,4t||",
                "Tuvalu": "6b,0,6h|||",
                "Uruguay": "6b,0,g3,0,4k|6b,0,h6,0,hj,0,4k||",
                "Uzbekistan": "6b,0,g3,0,60|6b,0,h6,0,hj,0,60||",
                "Vanuatu": "6b,0,g3,0,2f|6b,0,h6,0,hj,0,2f||",
                "Venezuela": "6b,0,7s|||",
                "Vladivostok": "6b,0,g3,0,28|6b,0,19e,0,168,0,28||",
                "Volgograd": "6b,0,g3,0,3f|6b,0,h6,0,hj,0,3f||",
                "Vostok": "6b,0,5t|||",
                "Wake": "6b,0,19d,0,5r|||",
                "Wallis": "6b,0,5f,0,3r9,0,5k|||",
                "Yakutsk": "6b,0,g3,0,3u|6b,0,19e,0,168,0,3u||",
                "Yekaterinburg": "6b,0,g3,0,5l|6b,0,19e,0,168,0,5l||"
            }
        },
        "vo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "vun": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "wae": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {
                "Atlantic": "4uu,0,3ra|4uu,0,3rb||",
                "Europe_Central": "4un,0,3ra|4un,0,3rb|1bd|1be",
                "Europe_Eastern": "4ul,0,3ra|4ul,0,3rb|1bg|1bh",
                "Europe_Western": "4uj,0,3ra|4uj,0,3rb|1bk|1bl"
            }
        },
        "xog": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "yav": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "yi": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "yo-BJ": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "yo": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "yue": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|39v||",
                "Europe/London": "|39t||"
            },
            "metazone": {
                "Acre": "3rc|3rd||",
                "Afghanistan": "3rh|||",
                "Africa_Central": "3ri|||",
                "Africa_Eastern": "3rj|||",
                "Africa_Southern": "4u9|||",
                "Africa_Western": "3rk|3rl||",
                "Alaska": "3rn|31r||",
                "Almaty": "3ru|3rv||",
                "Amazon": "3s4|3s6||",
                "America_Central": "4ti|3s8||",
                "America_Eastern": "4ta|4t9||",
                "America_Mountain": "4t5|4t3||",
                "America_Pacific": "4t1|4t0||",
                "Anadyr": "3s9|3sa||",
                "Apia": "3sb|3sc||",
                "Aqtau": "3sd|3se||",
                "Aqtobe": "3sf|3sj||",
                "Arabian": "3sk|3sl||",
                "Argentina": "3so|3sr||",
                "Argentina_Western": "3sv|3t1||",
                "Armenia": "3t2|3t4||",
                "Atlantic": "3t6|3t7||",
                "Australia_Central": "3tb|3tc||",
                "Australia_CentralWestern": "3td|3tf||",
                "Australia_Eastern": "3tg|3th||",
                "Australia_Western": "3ti|3tj||",
                "Azerbaijan": "8hg|8h8||",
                "Azores": "3tm|3tn||",
                "Bangladesh": "3tp|3ts||",
                "Bhutan": "3tt|||",
                "Bolivia": "3tu|||",
                "Brasilia": "3tv|3u0||",
                "Brunei": "3u2|||",
                "Cape_Verde": "8fo|8fj||",
                "Casey": "3u3|||",
                "Chamorro": "3u5|||",
                "Chatham": "3u6|3u7||",
                "Chile": "3u8|3u9||",
                "China": "3ua|3ub||",
                "Choibalsan": "3uc|3ud||",
                "Christmas": "3ue|||",
                "Cocos": "8dn|||",
                "Colombia": "3uf|3ui||",
                "Cook": "3uj|3uk||",
                "Cuba": "3ul|3um||",
                "Davis": "3un|||",
                "DumontDUrville": "8ch|||",
                "East_Timor": "3uo|||",
                "Easter": "3up|3uq||",
                "Ecuador": "8bs|||",
                "Europe_Central": "3ur|3us||",
                "Europe_Eastern": "3ut|3uu||",
                "Europe_Further_Eastern": "3uv|||",
                "Europe_Western": "3v0|3v1||",
                "Falkland": "3v2|3v3||",
                "Fiji": "3v4|3v6||",
                "French_Guiana": "3v9|||",
                "French_Southern": "3va|||",
                "Galapagos": "8aa|||",
                "Gambier": "3vb|||",
                "Georgia": "89s|89o||",
                "Gilbert_Islands": "3vd|||",
                "GMT": "3ve|||",
                "Greenland_Eastern": "3vg|3vi||",
                "Greenland_Western": "3vj|3vk||",
                "Guam": "404|||",
                "Gulf": "85c|||",
                "Guyana": "83u|||",
                "Hawaii_Aleutian": "166,5,405|166,5,409||",
                "Hong_Kong": "40b|40d||",
                "Hovd": "40l|40o||",
                "India": "7s2|||",
                "Indian_Ocean": "419|||",
                "Indochina": "7ro|||",
                "Indonesia_Central": "434|||",
                "Indonesia_Eastern": "435|||",
                "Indonesia_Western": "436|||",
                "Iran": "437|439||",
                "Irkutsk": "7pt|7pn||",
                "Israel": "43b|43d||",
                "Japan": "43e|43f||",
                "Kamchatka": "43g|43h||",
                "Kazakhstan_Eastern": "43n|||",
                "Kazakhstan_Western": "43o|||",
                "Korea": "43p|43q||",
                "Kosrae": "7hl|||",
                "Krasnoyarsk": "43r|43t||",
                "Kyrgystan": "441|||",
                "Lanka": "442|||",
                "Line_Islands": "444|||",
                "Lord_Howe": "449|44a||",
                "Macau": "44e|44g||",
                "Macquarie": "7bh|||",
                "Magadan": "44o|44p||",
                "Malaysia": "44q|||",
                "Maldives": "7a1|||",
                "Marquesas": "6fq|||",
                "Marshall_Islands": "474|||",
                "Mauritius": "6ds|6dk||",
                "Mawson": "476|||",
                "Mexico_Northwest": "477|478||",
                "Mexico_Pacific": "479|47a||",
                "Mongolia": "47b|47c||",
                "Moscow": "47g|47h||",
                "Myanmar": "47i|||",
                "Nauru": "69b|||",
                "Nepal": "47j|||",
                "New_Caledonia": "47k|68r||",
                "New_Zealand": "47l|47m||",
                "Newfoundland": "47n|47o||",
                "Niue": "47q|||",
                "Norfolk": "47r|||",
                "Noronha": "47s,0,5,0,681|47s,0,5,0,680||",
                "North_Mariana": "47u|||",
                "Novosibirsk": "47v|480||",
                "Omsk": "481|482||",
                "Pakistan": "483|484||",
                "Palau": "485|||",
                "Papua_New_Guinea": "65s|||",
                "Paraguay": "486|487||",
                "Peru": "488|48b||",
                "Philippines": "48c|48d||",
                "Phoenix_Islands": "48e|||",
                "Pierre_Miquelon": "48f|48g||",
                "Pitcairn": "63m|||",
                "Ponape": "48h|||",
                "Qyzylorda": "48i|48j||",
                "Reunion": "48k|||",
                "Rothera": "48m|||",
                "Sakhalin": "48n|48o||",
                "Samara": "48p|48q||",
                "Samoa": "48r|48s||",
                "Seychelles": "61n|||",
                "Singapore": "61m|||",
                "Solomon": "61e|||",
                "South_Georgia": "48v|||",
                "Suriname": "5vs|||",
                "Syowa": "2op|||",
                "Tahiti": "494|||",
                "Taipei": "49g|49h||",
                "Tajikistan": "49k|||",
                "Tokelau": "49l|||",
                "Tonga": "5ui|5ud||",
                "Truk": "49m|||",
                "Turkmenistan": "49n|4a3||",
                "Tuvalu": "5rv|||",
                "Uruguay": "4a6|4a7||",
                "Uzbekistan": "4a9|4ac||",
                "Vanuatu": "5r8|5r7||",
                "Venezuela": "4ad|||",
                "Vladivostok": "4ae|4af||",
                "Volgograd": "4ag|4ah||",
                "Vostok": "4ai|||",
                "Wake": "4aj|||",
                "Wallis": "4ak|||",
                "Yakutsk": "5q3|5q2||",
                "Yekaterinburg": "4al|4am||"
            }
        },
        "zgh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {},
            "metazone": {}
        },
        "zh-Hans-HK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tp||",
                "Europe/London": "|2ti||"
            },
            "metazone": {
                "Acre": "2t9|2t8||",
                "Afghanistan": "2t7|||",
                "Africa_Central": "2t6|||",
                "Africa_Eastern": "2t5|||",
                "Africa_Southern": "2t4|||",
                "Africa_Western": "2t3|2t1||",
                "Alaska": "2t0|2sv||",
                "Almaty": "2su|2st||",
                "Amazon": "2ss|2sq||",
                "America_Central": "2sp|2sn||",
                "America_Eastern": "2sm|2sl||",
                "America_Mountain": "2sk|2sj||",
                "America_Pacific": "2si|2sh||",
                "Anadyr": "2sf|2sd||",
                "Apia": "2sc|2sb||",
                "Aqtau": "2sa|2s8||",
                "Aqtobe": "2s6|2s3||",
                "Arabian": "2s1|2s0||",
                "Argentina": "2rv|2ru||",
                "Argentina_Western": "2rr|2rq||",
                "Armenia": "2rp|2ro||",
                "Atlantic": "2rm|2rk||",
                "Australia_Central": "2rj|2ri||",
                "Australia_CentralWestern": "2rh|2rf||",
                "Australia_Eastern": "2rd|2rc||",
                "Australia_Western": "2rb|2r8||",
                "Azerbaijan": "2r7|2r6||",
                "Azores": "2qj|2qf||",
                "Bangladesh": "2q9|2q8||",
                "Bhutan": "2q7|||",
                "Bolivia": "2q2|||",
                "Brasilia": "2pm|2pj||",
                "Brunei": "2pi|||",
                "Cape_Verde": "2ph|2pg||",
                "Casey": "2os|||",
                "Chamorro": "2on|||",
                "Chatham": "2om|2ok||",
                "Chile": "2oj|2oi||",
                "China": "2of|2oe||",
                "Choibalsan": "2od|2oc||",
                "Christmas": "2o9|||",
                "Cocos": "2o0|||",
                "Colombia": "2nt|2ns||",
                "Cook": "2nr|2nq||",
                "Cuba": "2nk|2n1||",
                "Davis": "2n0|||",
                "DumontDUrville": "2n5|||",
                "East_Timor": "318|||",
                "Easter": "314|30u||",
                "Ecuador": "304|||",
                "Europe_Central": "2vs|2vn||",
                "Europe_Eastern": "2uj|2uc||",
                "Europe_Further_Eastern": "2u9|||",
                "Europe_Western": "2tn|2r5||",
                "Falkland": "2r2|2r1||",
                "Fiji": "2r0|2qu||",
                "French_Guiana": "2qs|||",
                "French_Southern": "2qp|||",
                "Galapagos": "2qo|||",
                "Gambier": "2qn|||",
                "Georgia": "2ql|2qk||",
                "Gilbert_Islands": "2qh|||",
                "GMT": "2qg|||",
                "Greenland_Eastern": "2qe|2qa||",
                "Greenland_Western": "2q6|2q4||",
                "Guam": "2q1|||",
                "Gulf": "2pu|||",
                "Guyana": "2po|||",
                "Hawaii_Aleutian": "166,5,2pa|166,5,2p4||",
                "Hong_Kong": "2or|2oh||",
                "Hovd": "2o6|2o4||",
                "India": "2o3|||",
                "Indian_Ocean": "2o2|||",
                "Indochina": "2no|||",
                "Indonesia_Central": "2nn|||",
                "Indonesia_Eastern": "2nm|||",
                "Indonesia_Western": "2nh|||",
                "Iran": "2ne|2v5||",
                "Irkutsk": "2nb|2na||",
                "Israel": "2n6|2mv||",
                "Japan": "2mu|2mq||",
                "Kamchatka": "1lk,5,2mm|1lk,5,2mg||",
                "Kazakhstan_Eastern": "2mf|||",
                "Kazakhstan_Western": "2md|||",
                "Korea": "2mc|2mb||",
                "Kosrae": "2ma|||",
                "Krasnoyarsk": "2m9|2m8||",
                "Kyrgystan": "2m2|||",
                "Lanka": "31g|||",
                "Line_Islands": "317|||",
                "Lord_Howe": "30t|30o||",
                "Macau": "30d|309||",
                "Macquarie": "306|||",
                "Magadan": "303|300||",
                "Malaysia": "2vu|||",
                "Maldives": "2vr|||",
                "Marquesas": "2vp|||",
                "Marshall_Islands": "2vo|||",
                "Mauritius": "2vk|2vi||",
                "Mawson": "2vh|||",
                "Mexico_Northwest": "2vg|2vf||",
                "Mexico_Pacific": "2vb|2ul||",
                "Mongolia": "2uf|2uk||",
                "Moscow": "2ui|2ue||",
                "Myanmar": "2ud|||",
                "Nauru": "2u6|||",
                "Nepal": "2u5|||",
                "New_Caledonia": "2u4|2u1||",
                "New_Zealand": "2tt|2to||",
                "Newfoundland": "2tk|2s2||",
                "Niue": "2rn|||",
                "Norfolk": "2qi|||",
                "Noronha": "1l6,5,2qc|1l6,5,2q3||",
                "North_Mariana": "2pv|||",
                "Novosibirsk": "2pr|2pq||",
                "Omsk": "2p9|2ov||",
                "Pakistan": "2ou|2o5||",
                "Palau": "2o1|||",
                "Papua_New_Guinea": "2nu|||",
                "Paraguay": "2np|2nj||",
                "Peru": "2ni|2nc||",
                "Philippines": "2n8|2n7||",
                "Phoenix_Islands": "2mn|||",
                "Pierre_Miquelon": "2ml|2mj||",
                "Pitcairn": "2mh|||",
                "Ponape": "2m7|||",
                "Pyongyang": "2m5|||",
                "Qyzylorda": "2m0|2ls||",
                "Reunion": "2lr|||",
                "Rothera": "31p|||",
                "Sakhalin": "31m|31l||",
                "Samara": "316|30b||",
                "Samoa": "30a|2uv||",
                "Seychelles": "2us|||",
                "Singapore": "2ur|||",
                "Solomon": "2up|||",
                "South_Georgia": "2un|||",
                "Suriname": "2u8|||",
                "Syowa": "2tr|||",
                "Tahiti": "2th|||",
                "Taipei": "2tf|2td||",
                "Tajikistan": "2ta|||",
                "Tokelau": "2sr|||",
                "Tonga": "2sg|2s4||",
                "Truk": "2rg|||",
                "Turkmenistan": "2re|2pt||",
                "Tuvalu": "2oq|||",
                "Uruguay": "2ol|2nl||",
                "Uzbekistan": "2ng|2m3||",
                "Vanuatu": "31f|31d||",
                "Venezuela": "313|||",
                "Vladivostok": "30m|30h||",
                "Volgograd": "30e|30c||",
                "Vostok": "308|||",
                "Wake": "305|||",
                "Wallis": "302|||",
                "Yakutsk": "301|2vc||",
                "Yekaterinburg": "2v9|2v6||"
            }
        },
        "zh-Hans-MO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tp||",
                "Europe/London": "|2ti||"
            },
            "metazone": {
                "Acre": "2t9|2t8||",
                "Afghanistan": "2t7|||",
                "Africa_Central": "2t6|||",
                "Africa_Eastern": "2t5|||",
                "Africa_Southern": "2t4|||",
                "Africa_Western": "2t3|2t1||",
                "Alaska": "2t0|2sv||",
                "Almaty": "2su|2st||",
                "Amazon": "2ss|2sq||",
                "America_Central": "2sp|2sn||",
                "America_Eastern": "2sm|2sl||",
                "America_Mountain": "2sk|2sj||",
                "America_Pacific": "2si|2sh||",
                "Anadyr": "2sf|2sd||",
                "Apia": "2sc|2sb||",
                "Aqtau": "2sa|2s8||",
                "Aqtobe": "2s6|2s3||",
                "Arabian": "2s1|2s0||",
                "Argentina": "2rv|2ru||",
                "Argentina_Western": "2rr|2rq||",
                "Armenia": "2rp|2ro||",
                "Atlantic": "2rm|2rk||",
                "Australia_Central": "2rj|2ri||",
                "Australia_CentralWestern": "2rh|2rf||",
                "Australia_Eastern": "2rd|2rc||",
                "Australia_Western": "2rb|2r8||",
                "Azerbaijan": "2r7|2r6||",
                "Azores": "2qj|2qf||",
                "Bangladesh": "2q9|2q8||",
                "Bhutan": "2q7|||",
                "Bolivia": "2q2|||",
                "Brasilia": "2pm|2pj||",
                "Brunei": "2pi|||",
                "Cape_Verde": "2ph|2pg||",
                "Casey": "2os|||",
                "Chamorro": "2on|||",
                "Chatham": "2om|2ok||",
                "Chile": "2oj|2oi||",
                "China": "2of|2oe||",
                "Choibalsan": "2od|2oc||",
                "Christmas": "2o9|||",
                "Cocos": "2o0|||",
                "Colombia": "2nt|2ns||",
                "Cook": "2nr|2nq||",
                "Cuba": "2nk|2n1||",
                "Davis": "2n0|||",
                "DumontDUrville": "2n5|||",
                "East_Timor": "318|||",
                "Easter": "314|30u||",
                "Ecuador": "304|||",
                "Europe_Central": "2vs|2vn||",
                "Europe_Eastern": "2uj|2uc||",
                "Europe_Further_Eastern": "2u9|||",
                "Europe_Western": "2tn|2r5||",
                "Falkland": "2r2|2r1||",
                "Fiji": "2r0|2qu||",
                "French_Guiana": "2qs|||",
                "French_Southern": "2qp|||",
                "Galapagos": "2qo|||",
                "Gambier": "2qn|||",
                "Georgia": "2ql|2qk||",
                "Gilbert_Islands": "2qh|||",
                "GMT": "2qg|||",
                "Greenland_Eastern": "2qe|2qa||",
                "Greenland_Western": "2q6|2q4||",
                "Guam": "2q1|||",
                "Gulf": "2pu|||",
                "Guyana": "2po|||",
                "Hawaii_Aleutian": "166,5,2pa|166,5,2p4||",
                "Hong_Kong": "2or|2oh||",
                "Hovd": "2o6|2o4||",
                "India": "2o3|||",
                "Indian_Ocean": "2o2|||",
                "Indochina": "2no|||",
                "Indonesia_Central": "2nn|||",
                "Indonesia_Eastern": "2nm|||",
                "Indonesia_Western": "2nh|||",
                "Iran": "2ne|2v5||",
                "Irkutsk": "2nb|2na||",
                "Israel": "2n6|2mv||",
                "Japan": "2mu|2mq||",
                "Kamchatka": "1lk,5,2mm|1lk,5,2mg||",
                "Kazakhstan_Eastern": "2mf|||",
                "Kazakhstan_Western": "2md|||",
                "Korea": "2mc|2mb||",
                "Kosrae": "2ma|||",
                "Krasnoyarsk": "2m9|2m8||",
                "Kyrgystan": "2m2|||",
                "Lanka": "31g|||",
                "Line_Islands": "317|||",
                "Lord_Howe": "30t|30o||",
                "Macau": "30d|309||",
                "Macquarie": "306|||",
                "Magadan": "303|300||",
                "Malaysia": "2vu|||",
                "Maldives": "2vr|||",
                "Marquesas": "2vp|||",
                "Marshall_Islands": "2vo|||",
                "Mauritius": "2vk|2vi||",
                "Mawson": "2vh|||",
                "Mexico_Northwest": "2vg|2vf||",
                "Mexico_Pacific": "2vb|2ul||",
                "Mongolia": "2uf|2uk||",
                "Moscow": "2ui|2ue||",
                "Myanmar": "2ud|||",
                "Nauru": "2u6|||",
                "Nepal": "2u5|||",
                "New_Caledonia": "2u4|2u1||",
                "New_Zealand": "2tt|2to||",
                "Newfoundland": "2tk|2s2||",
                "Niue": "2rn|||",
                "Norfolk": "2qi|||",
                "Noronha": "1l6,5,2qc|1l6,5,2q3||",
                "North_Mariana": "2pv|||",
                "Novosibirsk": "2pr|2pq||",
                "Omsk": "2p9|2ov||",
                "Pakistan": "2ou|2o5||",
                "Palau": "2o1|||",
                "Papua_New_Guinea": "2nu|||",
                "Paraguay": "2np|2nj||",
                "Peru": "2ni|2nc||",
                "Philippines": "2n8|2n7||",
                "Phoenix_Islands": "2mn|||",
                "Pierre_Miquelon": "2ml|2mj||",
                "Pitcairn": "2mh|||",
                "Ponape": "2m7|||",
                "Pyongyang": "2m5|||",
                "Qyzylorda": "2m0|2ls||",
                "Reunion": "2lr|||",
                "Rothera": "31p|||",
                "Sakhalin": "31m|31l||",
                "Samara": "316|30b||",
                "Samoa": "30a|2uv||",
                "Seychelles": "2us|||",
                "Singapore": "2ur|||",
                "Solomon": "2up|||",
                "South_Georgia": "2un|||",
                "Suriname": "2u8|||",
                "Syowa": "2tr|||",
                "Tahiti": "2th|||",
                "Taipei": "2tf|2td||",
                "Tajikistan": "2ta|||",
                "Tokelau": "2sr|||",
                "Tonga": "2sg|2s4||",
                "Truk": "2rg|||",
                "Turkmenistan": "2re|2pt||",
                "Tuvalu": "2oq|||",
                "Uruguay": "2ol|2nl||",
                "Uzbekistan": "2ng|2m3||",
                "Vanuatu": "31f|31d||",
                "Venezuela": "313|||",
                "Vladivostok": "30m|30h||",
                "Volgograd": "30e|30c||",
                "Vostok": "308|||",
                "Wake": "305|||",
                "Wallis": "302|||",
                "Yakutsk": "301|2vc||",
                "Yekaterinburg": "2v9|2v6||"
            }
        },
        "zh-Hans-SG": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tp||",
                "Europe/London": "|2ti||"
            },
            "metazone": {
                "Acre": "2t9|2t8||",
                "Afghanistan": "2t7|||",
                "Africa_Central": "2t6|||",
                "Africa_Eastern": "2t5|||",
                "Africa_Southern": "2t4|||",
                "Africa_Western": "2t3|2t1||",
                "Alaska": "2t0|2sv||",
                "Almaty": "2su|2st||",
                "Amazon": "2ss|2sq||",
                "America_Central": "2sp|2sn||",
                "America_Eastern": "2sm|2sl||",
                "America_Mountain": "2sk|2sj||",
                "America_Pacific": "2si|2sh||",
                "Anadyr": "2sf|2sd||",
                "Apia": "2sc|2sb||",
                "Aqtau": "2sa|2s8||",
                "Aqtobe": "2s6|2s3||",
                "Arabian": "2s1|2s0||",
                "Argentina": "2rv|2ru||",
                "Argentina_Western": "2rr|2rq||",
                "Armenia": "2rp|2ro||",
                "Atlantic": "2rm|2rk||",
                "Australia_Central": "2rj|2ri||",
                "Australia_CentralWestern": "2rh|2rf||",
                "Australia_Eastern": "2rd|2rc||",
                "Australia_Western": "2rb|2r8||",
                "Azerbaijan": "2r7|2r6||",
                "Azores": "2qj|2qf||",
                "Bangladesh": "2q9|2q8||",
                "Bhutan": "2q7|||",
                "Bolivia": "2q2|||",
                "Brasilia": "2pm|2pj||",
                "Brunei": "2pi|||",
                "Cape_Verde": "2ph|2pg||",
                "Casey": "2os|||",
                "Chamorro": "2on|||",
                "Chatham": "2om|2ok||",
                "Chile": "2oj|2oi||",
                "China": "2of|2oe||",
                "Choibalsan": "2od|2oc||",
                "Christmas": "2o9|||",
                "Cocos": "2o0|||",
                "Colombia": "2nt|2ns||",
                "Cook": "2nr|2nq||",
                "Cuba": "2nk|2n1||",
                "Davis": "2n0|||",
                "DumontDUrville": "2n5|||",
                "East_Timor": "318|||",
                "Easter": "314|30u||",
                "Ecuador": "304|||",
                "Europe_Central": "2vs|2vn||",
                "Europe_Eastern": "2uj|2uc||",
                "Europe_Further_Eastern": "2u9|||",
                "Europe_Western": "2tn|2r5||",
                "Falkland": "2r2|2r1||",
                "Fiji": "2r0|2qu||",
                "French_Guiana": "2qs|||",
                "French_Southern": "2qp|||",
                "Galapagos": "2qo|||",
                "Gambier": "2qn|||",
                "Georgia": "2ql|2qk||",
                "Gilbert_Islands": "2qh|||",
                "GMT": "2qg|||",
                "Greenland_Eastern": "2qe|2qa||",
                "Greenland_Western": "2q6|2q4||",
                "Guam": "2q1|||",
                "Gulf": "2pu|||",
                "Guyana": "2po|||",
                "Hawaii_Aleutian": "166,5,2pa|166,5,2p4||",
                "Hong_Kong": "2or|2oh||",
                "Hovd": "2o6|2o4||",
                "India": "2o3|||",
                "Indian_Ocean": "2o2|||",
                "Indochina": "2no|||",
                "Indonesia_Central": "2nn|||",
                "Indonesia_Eastern": "2nm|||",
                "Indonesia_Western": "2nh|||",
                "Iran": "2ne|2v5||",
                "Irkutsk": "2nb|2na||",
                "Israel": "2n6|2mv||",
                "Japan": "2mu|2mq||",
                "Kamchatka": "1lk,5,2mm|1lk,5,2mg||",
                "Kazakhstan_Eastern": "2mf|||",
                "Kazakhstan_Western": "2md|||",
                "Korea": "2mc|2mb||",
                "Kosrae": "2ma|||",
                "Krasnoyarsk": "2m9|2m8||",
                "Kyrgystan": "2m2|||",
                "Lanka": "31g|||",
                "Line_Islands": "317|||",
                "Lord_Howe": "30t|30o||",
                "Macau": "30d|309||",
                "Macquarie": "306|||",
                "Magadan": "303|300||",
                "Malaysia": "2vu||1r5|",
                "Maldives": "2vr|||",
                "Marquesas": "2vp|||",
                "Marshall_Islands": "2vo|||",
                "Mauritius": "2vk|2vi||",
                "Mawson": "2vh|||",
                "Mexico_Northwest": "2vg|2vf||",
                "Mexico_Pacific": "2vb|2ul||",
                "Mongolia": "2uf|2uk||",
                "Moscow": "2ui|2ue||",
                "Myanmar": "2ud|||",
                "Nauru": "2u6|||",
                "Nepal": "2u5|||",
                "New_Caledonia": "2u4|2u1||",
                "New_Zealand": "2tt|2to||",
                "Newfoundland": "2tk|2s2||",
                "Niue": "2rn|||",
                "Norfolk": "2qi|||",
                "Noronha": "1l6,5,2qc|1l6,5,2q3||",
                "North_Mariana": "2pv|||",
                "Novosibirsk": "2pr|2pq||",
                "Omsk": "2p9|2ov||",
                "Pakistan": "2ou|2o5||",
                "Palau": "2o1|||",
                "Papua_New_Guinea": "2nu|||",
                "Paraguay": "2np|2nj||",
                "Peru": "2ni|2nc||",
                "Philippines": "2n8|2n7||",
                "Phoenix_Islands": "2mn|||",
                "Pierre_Miquelon": "2ml|2mj||",
                "Pitcairn": "2mh|||",
                "Ponape": "2m7|||",
                "Pyongyang": "2m5|||",
                "Qyzylorda": "2m0|2ls||",
                "Reunion": "2lr|||",
                "Rothera": "31p|||",
                "Sakhalin": "31m|31l||",
                "Samara": "316|30b||",
                "Samoa": "30a|2uv||",
                "Seychelles": "2us|||",
                "Singapore": "2ur||2ad|",
                "Solomon": "2up|||",
                "South_Georgia": "2un|||",
                "Suriname": "2u8|||",
                "Syowa": "2tr|||",
                "Tahiti": "2th|||",
                "Taipei": "2tf|2td||",
                "Tajikistan": "2ta|||",
                "Tokelau": "2sr|||",
                "Tonga": "2sg|2s4||",
                "Truk": "2rg|||",
                "Turkmenistan": "2re|2pt||",
                "Tuvalu": "2oq|||",
                "Uruguay": "2ol|2nl||",
                "Uzbekistan": "2ng|2m3||",
                "Vanuatu": "31f|31d||",
                "Venezuela": "313|||",
                "Vladivostok": "30m|30h||",
                "Volgograd": "30e|30c||",
                "Vostok": "308|||",
                "Wake": "305|||",
                "Wallis": "302|||",
                "Yakutsk": "301|2vc||",
                "Yekaterinburg": "2v9|2v6||"
            }
        },
        "zh-Hans": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tp||",
                "Europe/London": "|2ti||"
            },
            "metazone": {
                "Acre": "2t9|2t8||",
                "Afghanistan": "2t7|||",
                "Africa_Central": "2t6|||",
                "Africa_Eastern": "2t5|||",
                "Africa_Southern": "2t4|||",
                "Africa_Western": "2t3|2t1||",
                "Alaska": "2t0|2sv||",
                "Almaty": "2su|2st||",
                "Amazon": "2ss|2sq||",
                "America_Central": "2sp|2sn||",
                "America_Eastern": "2sm|2sl||",
                "America_Mountain": "2sk|2sj||",
                "America_Pacific": "2si|2sh||",
                "Anadyr": "2sf|2sd||",
                "Apia": "2sc|2sb||",
                "Aqtau": "2sa|2s8||",
                "Aqtobe": "2s6|2s3||",
                "Arabian": "2s1|2s0||",
                "Argentina": "2rv|2ru||",
                "Argentina_Western": "2rr|2rq||",
                "Armenia": "2rp|2ro||",
                "Atlantic": "2rm|2rk||",
                "Australia_Central": "2rj|2ri||",
                "Australia_CentralWestern": "2rh|2rf||",
                "Australia_Eastern": "2rd|2rc||",
                "Australia_Western": "2rb|2r8||",
                "Azerbaijan": "2r7|2r6||",
                "Azores": "2qj|2qf||",
                "Bangladesh": "2q9|2q8||",
                "Bhutan": "2q7|||",
                "Bolivia": "2q2|||",
                "Brasilia": "2pm|2pj||",
                "Brunei": "2pi|||",
                "Cape_Verde": "2ph|2pg||",
                "Casey": "2os|||",
                "Chamorro": "2on|||",
                "Chatham": "2om|2ok||",
                "Chile": "2oj|2oi||",
                "China": "2of|2oe||",
                "Choibalsan": "2od|2oc||",
                "Christmas": "2o9|||",
                "Cocos": "2o0|||",
                "Colombia": "2nt|2ns||",
                "Cook": "2nr|2nq||",
                "Cuba": "2nk|2n1||",
                "Davis": "2n0|||",
                "DumontDUrville": "2n5|||",
                "East_Timor": "318|||",
                "Easter": "314|30u||",
                "Ecuador": "304|||",
                "Europe_Central": "2vs|2vn||",
                "Europe_Eastern": "2uj|2uc||",
                "Europe_Further_Eastern": "2u9|||",
                "Europe_Western": "2tn|2r5||",
                "Falkland": "2r2|2r1||",
                "Fiji": "2r0|2qu||",
                "French_Guiana": "2qs|||",
                "French_Southern": "2qp|||",
                "Galapagos": "2qo|||",
                "Gambier": "2qn|||",
                "Georgia": "2ql|2qk||",
                "Gilbert_Islands": "2qh|||",
                "GMT": "2qg|||",
                "Greenland_Eastern": "2qe|2qa||",
                "Greenland_Western": "2q6|2q4||",
                "Guam": "2q1|||",
                "Gulf": "2pu|||",
                "Guyana": "2po|||",
                "Hawaii_Aleutian": "166,5,2pa|166,5,2p4||",
                "Hong_Kong": "2or|2oh||",
                "Hovd": "2o6|2o4||",
                "India": "2o3|||",
                "Indian_Ocean": "2o2|||",
                "Indochina": "2no|||",
                "Indonesia_Central": "2nn|||",
                "Indonesia_Eastern": "2nm|||",
                "Indonesia_Western": "2nh|||",
                "Iran": "2ne|2v5||",
                "Irkutsk": "2nb|2na||",
                "Israel": "2n6|2mv||",
                "Japan": "2mu|2mq||",
                "Kamchatka": "1lk,5,2mm|1lk,5,2mg||",
                "Kazakhstan_Eastern": "2mf|||",
                "Kazakhstan_Western": "2md|||",
                "Korea": "2mc|2mb||",
                "Kosrae": "2ma|||",
                "Krasnoyarsk": "2m9|2m8||",
                "Kyrgystan": "2m2|||",
                "Lanka": "31g|||",
                "Line_Islands": "317|||",
                "Lord_Howe": "30t|30o||",
                "Macau": "30d|309||",
                "Macquarie": "306|||",
                "Magadan": "303|300||",
                "Malaysia": "2vu|||",
                "Maldives": "2vr|||",
                "Marquesas": "2vp|||",
                "Marshall_Islands": "2vo|||",
                "Mauritius": "2vk|2vi||",
                "Mawson": "2vh|||",
                "Mexico_Northwest": "2vg|2vf||",
                "Mexico_Pacific": "2vb|2ul||",
                "Mongolia": "2uf|2uk||",
                "Moscow": "2ui|2ue||",
                "Myanmar": "2ud|||",
                "Nauru": "2u6|||",
                "Nepal": "2u5|||",
                "New_Caledonia": "2u4|2u1||",
                "New_Zealand": "2tt|2to||",
                "Newfoundland": "2tk|2s2||",
                "Niue": "2rn|||",
                "Norfolk": "2qi|||",
                "Noronha": "1l6,5,2qc|1l6,5,2q3||",
                "North_Mariana": "2pv|||",
                "Novosibirsk": "2pr|2pq||",
                "Omsk": "2p9|2ov||",
                "Pakistan": "2ou|2o5||",
                "Palau": "2o1|||",
                "Papua_New_Guinea": "2nu|||",
                "Paraguay": "2np|2nj||",
                "Peru": "2ni|2nc||",
                "Philippines": "2n8|2n7||",
                "Phoenix_Islands": "2mn|||",
                "Pierre_Miquelon": "2ml|2mj||",
                "Pitcairn": "2mh|||",
                "Ponape": "2m7|||",
                "Pyongyang": "2m5|||",
                "Qyzylorda": "2m0|2ls||",
                "Reunion": "2lr|||",
                "Rothera": "31p|||",
                "Sakhalin": "31m|31l||",
                "Samara": "316|30b||",
                "Samoa": "30a|2uv||",
                "Seychelles": "2us|||",
                "Singapore": "2ur|||",
                "Solomon": "2up|||",
                "South_Georgia": "2un|||",
                "Suriname": "2u8|||",
                "Syowa": "2tr|||",
                "Tahiti": "2th|||",
                "Taipei": "2tf|2td||",
                "Tajikistan": "2ta|||",
                "Tokelau": "2sr|||",
                "Tonga": "2sg|2s4||",
                "Truk": "2rg|||",
                "Turkmenistan": "2re|2pt||",
                "Tuvalu": "2oq|||",
                "Uruguay": "2ol|2nl||",
                "Uzbekistan": "2ng|2m3||",
                "Vanuatu": "31f|31d||",
                "Venezuela": "313|||",
                "Vladivostok": "30m|30h||",
                "Volgograd": "30e|30c||",
                "Vostok": "308|||",
                "Wake": "305|||",
                "Wallis": "302|||",
                "Yakutsk": "301|2vc||",
                "Yekaterinburg": "2v9|2v6||"
            }
        },
        "zh-Hant-HK": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|39v||",
                "Europe/London": "|39t||"
            },
            "metazone": {
                "Acre": "3rc|3rd||",
                "Afghanistan": "3rh|||",
                "Africa_Central": "3ri|||",
                "Africa_Eastern": "3rj|||",
                "Africa_Southern": "8hl|||",
                "Africa_Western": "3rk|3rl||",
                "Alaska": "3rn|31r||",
                "Almaty": "3ru|3rv||",
                "Amazon": "3s4|3s6||",
                "America_Central": "8gh|3s8||",
                "America_Eastern": "8fr|8fp||",
                "America_Mountain": "8fe|8fa||",
                "America_Pacific": "8f8|8dt||",
                "Anadyr": "3s9|3sa||",
                "Apia": "3sb|3sc||",
                "Aqtau": "3sd|3se||",
                "Aqtobe": "3sf|3sj||",
                "Arabian": "3sk|3sl||",
                "Argentina": "3so|3sr||",
                "Argentina_Western": "3sv|3t1||",
                "Armenia": "3t2|3t4||",
                "Atlantic": "3t6|3t7||",
                "Australia_Central": "3tb|3tc||",
                "Australia_CentralWestern": "3td|3tf||",
                "Australia_Eastern": "3tg|3th||",
                "Australia_Western": "3ti|3tj||",
                "Azerbaijan": "8d5|8d2||",
                "Azores": "3tm|3tn||",
                "Bangladesh": "3tp|3ts||",
                "Bhutan": "3tt|||",
                "Bolivia": "3tu|||",
                "Brasilia": "3tv|3u0||",
                "Brunei": "3u2|||",
                "Cape_Verde": "8cn|8c9||",
                "Casey": "3u3|||",
                "Chamorro": "3u5|||",
                "Chatham": "3u6|3u7||",
                "Chile": "3u8|3u9||",
                "China": "3ua|3ub||",
                "Choibalsan": "3uc|3ud||",
                "Christmas": "3ue|||",
                "Cocos": "8bu|||",
                "Colombia": "3uf|3ui||",
                "Cook": "3uj|3uk||",
                "Cuba": "3ul|3um||",
                "Davis": "3un|||",
                "DumontDUrville": "8bg|||",
                "East_Timor": "3uo|||",
                "Easter": "3up|3uq||",
                "Ecuador": "8bb|||",
                "Europe_Central": "3ur|3us||",
                "Europe_Eastern": "3ut|3uu||",
                "Europe_Further_Eastern": "3uv|||",
                "Europe_Western": "3v0|3v1||",
                "Falkland": "3v2|3v3||",
                "Fiji": "3v4|3v6||",
                "French_Guiana": "3v9|||",
                "French_Southern": "3va|||",
                "Galapagos": "8b8|||",
                "Gambier": "3vb|||",
                "Georgia": "8al|8aj||",
                "Gilbert_Islands": "3vd|||",
                "GMT": "3ve|||",
                "Greenland_Eastern": "3vg|3vi||",
                "Greenland_Western": "3vj|3vk||",
                "Guam": "404|||",
                "Gulf": "8a2|||",
                "Guyana": "89l|||",
                "Hawaii_Aleutian": "166,5,405|166,5,409||",
                "Hong_Kong": "40b|40d||",
                "Hovd": "40l|40o||",
                "India": "89f|||",
                "Indian_Ocean": "419|||",
                "Indochina": "89c|||",
                "Indonesia_Central": "434|||",
                "Indonesia_Eastern": "435|||",
                "Indonesia_Western": "436|||",
                "Iran": "437|439||",
                "Irkutsk": "7v9|7rp||",
                "Israel": "43b|43d||",
                "Japan": "43e|43f||",
                "Kamchatka": "43g|43h||",
                "Kazakhstan_Eastern": "43n|||",
                "Kazakhstan_Western": "43o|||",
                "Korea": "43p|43q||",
                "Kosrae": "7rc|||",
                "Krasnoyarsk": "43r|43t||",
                "Kyrgystan": "441|||",
                "Lanka": "442|||",
                "Line_Islands": "444|||",
                "Lord_Howe": "449|44a||",
                "Macau": "44e|44g||",
                "Macquarie": "7qp|||",
                "Magadan": "44o|44p||",
                "Malaysia": "44q|||",
                "Maldives": "7qo|||",
                "Marquesas": "7q8|||",
                "Marshall_Islands": "474|||",
                "Mauritius": "7pc|7on||",
                "Mawson": "476|||",
                "Mexico_Northwest": "477|478||",
                "Mexico_Pacific": "479|47a||",
                "Mongolia": "47b|47c||",
                "Moscow": "47g|47h||",
                "Myanmar": "47i|||",
                "Nauru": "7fl|||",
                "Nepal": "47j|||",
                "New_Caledonia": "47k|7fg||",
                "New_Zealand": "47l|47m||",
                "Newfoundland": "47n|47o||",
                "Niue": "47q|||",
                "Norfolk": "47r|||",
                "Noronha": "7ah|79s||",
                "North_Mariana": "47u|||",
                "Novosibirsk": "47v|480||",
                "Omsk": "481|482||",
                "Pakistan": "483|484||",
                "Palau": "485|||",
                "Papua_New_Guinea": "79n|||",
                "Paraguay": "486|487||",
                "Peru": "488|48b||",
                "Philippines": "48c|48d||",
                "Phoenix_Islands": "48e|||",
                "Pierre_Miquelon": "48f|48g||",
                "Pitcairn": "79m|||",
                "Ponape": "48h|||",
                "Pyongyang": "4le|||",
                "Qyzylorda": "48i|48j||",
                "Reunion": "48k|||",
                "Rothera": "48m|||",
                "Sakhalin": "48n|48o||",
                "Samara": "48p|48q||",
                "Samoa": "48r|48s||",
                "Seychelles": "6pm|||",
                "Singapore": "6pl|||",
                "Solomon": "6pc|||",
                "South_Georgia": "48v|||",
                "Suriname": "595|||",
                "Syowa": "2op|||",
                "Tahiti": "494|||",
                "Taipei": "49g|49h||",
                "Tajikistan": "49k|||",
                "Tokelau": "49l|||",
                "Tonga": "541|8j0||",
                "Truk": "49m|||",
                "Turkmenistan": "49n|4a3||",
                "Tuvalu": "8ad|||",
                "Uruguay": "4a6|4a7||",
                "Uzbekistan": "4a9|4ac||",
                "Vanuatu": "7p4|7oj||",
                "Venezuela": "4ad|||",
                "Vladivostok": "4ae|4af||",
                "Volgograd": "4ag|4ah||",
                "Vostok": "4ai|||",
                "Wake": "4aj|||",
                "Wallis": "4ak|||",
                "Yakutsk": "6q9|6ot||",
                "Yekaterinburg": "4al|4am||"
            }
        },
        "zh-Hant-MO": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|39v||",
                "Europe/London": "|39t||"
            },
            "metazone": {
                "Acre": "3rc|3rd||",
                "Afghanistan": "3rh|||",
                "Africa_Central": "3ri|||",
                "Africa_Eastern": "3rj|||",
                "Africa_Southern": "8hl|||",
                "Africa_Western": "3rk|3rl||",
                "Alaska": "3rn|31r||",
                "Almaty": "3ru|3rv||",
                "Amazon": "3s4|3s6||",
                "America_Central": "8gh|3s8||",
                "America_Eastern": "8fr|8fp||",
                "America_Mountain": "8fe|8fa||",
                "America_Pacific": "8f8|8dt||",
                "Anadyr": "3s9|3sa||",
                "Apia": "3sb|3sc||",
                "Aqtau": "3sd|3se||",
                "Aqtobe": "3sf|3sj||",
                "Arabian": "3sk|3sl||",
                "Argentina": "3so|3sr||",
                "Argentina_Western": "3sv|3t1||",
                "Armenia": "3t2|3t4||",
                "Atlantic": "3t6|3t7||",
                "Australia_Central": "3tb|3tc||",
                "Australia_CentralWestern": "3td|3tf||",
                "Australia_Eastern": "3tg|3th||",
                "Australia_Western": "3ti|3tj||",
                "Azerbaijan": "8d5|8d2||",
                "Azores": "3tm|3tn||",
                "Bangladesh": "3tp|3ts||",
                "Bhutan": "3tt|||",
                "Bolivia": "3tu|||",
                "Brasilia": "3tv|3u0||",
                "Brunei": "3u2|||",
                "Cape_Verde": "8cn|8c9||",
                "Casey": "3u3|||",
                "Chamorro": "3u5|||",
                "Chatham": "3u6|3u7||",
                "Chile": "3u8|3u9||",
                "China": "3ua|3ub||",
                "Choibalsan": "3uc|3ud||",
                "Christmas": "3ue|||",
                "Cocos": "8bu|||",
                "Colombia": "3uf|3ui||",
                "Cook": "3uj|3uk||",
                "Cuba": "3ul|3um||",
                "Davis": "3un|||",
                "DumontDUrville": "8bg|||",
                "East_Timor": "3uo|||",
                "Easter": "3up|3uq||",
                "Ecuador": "8bb|||",
                "Europe_Central": "3ur|3us||",
                "Europe_Eastern": "3ut|3uu||",
                "Europe_Further_Eastern": "3uv|||",
                "Europe_Western": "3v0|3v1||",
                "Falkland": "3v2|3v3||",
                "Fiji": "3v4|3v6||",
                "French_Guiana": "3v9|||",
                "French_Southern": "3va|||",
                "Galapagos": "8b8|||",
                "Gambier": "3vb|||",
                "Georgia": "8al|8aj||",
                "Gilbert_Islands": "3vd|||",
                "GMT": "3ve|||",
                "Greenland_Eastern": "3vg|3vi||",
                "Greenland_Western": "3vj|3vk||",
                "Guam": "404|||",
                "Gulf": "8a2|||",
                "Guyana": "89l|||",
                "Hawaii_Aleutian": "166,5,405|166,5,409||",
                "Hong_Kong": "40b|40d||",
                "Hovd": "40l|40o||",
                "India": "89f|||",
                "Indian_Ocean": "419|||",
                "Indochina": "89c|||",
                "Indonesia_Central": "434|||",
                "Indonesia_Eastern": "435|||",
                "Indonesia_Western": "436|||",
                "Iran": "437|439||",
                "Irkutsk": "7v9|7rp||",
                "Israel": "43b|43d||",
                "Japan": "43e|43f||",
                "Kamchatka": "43g|43h||",
                "Kazakhstan_Eastern": "43n|||",
                "Kazakhstan_Western": "43o|||",
                "Korea": "43p|43q||",
                "Kosrae": "7rc|||",
                "Krasnoyarsk": "43r|43t||",
                "Kyrgystan": "441|||",
                "Lanka": "442|||",
                "Line_Islands": "444|||",
                "Lord_Howe": "449|44a||",
                "Macau": "44e|44g||",
                "Macquarie": "7qp|||",
                "Magadan": "44o|44p||",
                "Malaysia": "44q|||",
                "Maldives": "7qo|||",
                "Marquesas": "7q8|||",
                "Marshall_Islands": "474|||",
                "Mauritius": "7pc|7on||",
                "Mawson": "476|||",
                "Mexico_Northwest": "477|478||",
                "Mexico_Pacific": "479|47a||",
                "Mongolia": "47b|47c||",
                "Moscow": "47g|47h||",
                "Myanmar": "47i|||",
                "Nauru": "7fl|||",
                "Nepal": "47j|||",
                "New_Caledonia": "47k|7fg||",
                "New_Zealand": "47l|47m||",
                "Newfoundland": "47n|47o||",
                "Niue": "47q|||",
                "Norfolk": "47r|||",
                "Noronha": "7ah|79s||",
                "North_Mariana": "47u|||",
                "Novosibirsk": "47v|480||",
                "Omsk": "481|482||",
                "Pakistan": "483|484||",
                "Palau": "485|||",
                "Papua_New_Guinea": "79n|||",
                "Paraguay": "486|487||",
                "Peru": "488|48b||",
                "Philippines": "48c|48d||",
                "Phoenix_Islands": "48e|||",
                "Pierre_Miquelon": "48f|48g||",
                "Pitcairn": "79m|||",
                "Ponape": "48h|||",
                "Pyongyang": "4le|||",
                "Qyzylorda": "48i|48j||",
                "Reunion": "48k|||",
                "Rothera": "48m|||",
                "Sakhalin": "48n|48o||",
                "Samara": "48p|48q||",
                "Samoa": "48r|48s||",
                "Seychelles": "6pm|||",
                "Singapore": "6pl|||",
                "Solomon": "6pc|||",
                "South_Georgia": "48v|||",
                "Suriname": "595|||",
                "Syowa": "2op|||",
                "Tahiti": "494|||",
                "Taipei": "49g|49h||",
                "Tajikistan": "49k|||",
                "Tokelau": "49l|||",
                "Tonga": "541|8j0||",
                "Truk": "49m|||",
                "Turkmenistan": "49n|4a3||",
                "Tuvalu": "8ad|||",
                "Uruguay": "4a6|4a7||",
                "Uzbekistan": "4a9|4ac||",
                "Vanuatu": "7p4|7oj||",
                "Venezuela": "4ad|||",
                "Vladivostok": "4ae|4af||",
                "Volgograd": "4ag|4ah||",
                "Vostok": "4ai|||",
                "Wake": "4aj|||",
                "Wallis": "4ak|||",
                "Yakutsk": "6q9|6ot||",
                "Yekaterinburg": "4al|4am||"
            }
        },
        "zh-Hant": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|39v||",
                "Europe/London": "|39t||"
            },
            "metazone": {
                "Acre": "3rc|3rd||",
                "Afghanistan": "3rh|||",
                "Africa_Central": "3ri|||",
                "Africa_Eastern": "3rj|||",
                "Africa_Southern": "4u9|||",
                "Africa_Western": "3rk|3rl||",
                "Alaska": "3rn|31r||",
                "Almaty": "3ru|3rv||",
                "Amazon": "3s4|3s6||",
                "America_Central": "4ti|3s8||",
                "America_Eastern": "4ta|4t9||",
                "America_Mountain": "4t5|4t3||",
                "America_Pacific": "4t1|4t0||",
                "Anadyr": "3s9|3sa||",
                "Apia": "3sb|3sc||",
                "Aqtau": "3sd|3se||",
                "Aqtobe": "3sf|3sj||",
                "Arabian": "3sk|3sl||",
                "Argentina": "3so|3sr||",
                "Argentina_Western": "3sv|3t1||",
                "Armenia": "3t2|3t4||",
                "Atlantic": "3t6|3t7||",
                "Australia_Central": "3tb|3tc||",
                "Australia_CentralWestern": "3td|3tf||",
                "Australia_Eastern": "3tg|3th||",
                "Australia_Western": "3ti|3tj||",
                "Azerbaijan": "8hg|8h8||",
                "Azores": "3tm|3tn||",
                "Bangladesh": "3tp|3ts||",
                "Bhutan": "3tt|||",
                "Bolivia": "3tu|||",
                "Brasilia": "3tv|3u0||",
                "Brunei": "3u2|||",
                "Cape_Verde": "8fo|8fj||",
                "Casey": "3u3|||",
                "Chamorro": "3u5|||",
                "Chatham": "3u6|3u7||",
                "Chile": "3u8|3u9||",
                "China": "3ua|3ub||",
                "Choibalsan": "3uc|3ud||",
                "Christmas": "3ue|||",
                "Cocos": "8dn|||",
                "Colombia": "3uf|3ui||",
                "Cook": "3uj|3uk||",
                "Cuba": "3ul|3um||",
                "Davis": "3un|||",
                "DumontDUrville": "8ch|||",
                "East_Timor": "3uo|||",
                "Easter": "3up|3uq||",
                "Ecuador": "8bs|||",
                "Europe_Central": "3ur|3us||",
                "Europe_Eastern": "3ut|3uu||",
                "Europe_Further_Eastern": "3uv|||",
                "Europe_Western": "3v0|3v1||",
                "Falkland": "3v2|3v3||",
                "Fiji": "3v4|3v6||",
                "French_Guiana": "3v9|||",
                "French_Southern": "3va|||",
                "Galapagos": "8aa|||",
                "Gambier": "3vb|||",
                "Georgia": "89s|89o||",
                "Gilbert_Islands": "3vd|||",
                "GMT": "3ve|||",
                "Greenland_Eastern": "3vg|3vi||",
                "Greenland_Western": "3vj|3vk||",
                "Guam": "404|||",
                "Gulf": "85c|||",
                "Guyana": "83u|||",
                "Hawaii_Aleutian": "166,5,405|166,5,409||",
                "Hong_Kong": "40b|40d||",
                "Hovd": "40l|40o||",
                "India": "7s2|||",
                "Indian_Ocean": "419|||",
                "Indochina": "7ro|||",
                "Indonesia_Central": "434|||",
                "Indonesia_Eastern": "435|||",
                "Indonesia_Western": "436|||",
                "Iran": "437|439||",
                "Irkutsk": "7pt|7pn||",
                "Israel": "43b|43d||",
                "Japan": "43e|43f||",
                "Kamchatka": "43g|43h||",
                "Kazakhstan_Eastern": "43n|||",
                "Kazakhstan_Western": "43o|||",
                "Korea": "43p|43q||",
                "Kosrae": "7hl|||",
                "Krasnoyarsk": "43r|43t||",
                "Kyrgystan": "441|||",
                "Lanka": "442|||",
                "Line_Islands": "444|||",
                "Lord_Howe": "449|44a||",
                "Macau": "44e|44g||",
                "Macquarie": "7bh|||",
                "Magadan": "44o|44p||",
                "Malaysia": "44q|||",
                "Maldives": "7a1|||",
                "Marquesas": "6fq|||",
                "Marshall_Islands": "474|||",
                "Mauritius": "6ds|6dk||",
                "Mawson": "476|||",
                "Mexico_Northwest": "477|478||",
                "Mexico_Pacific": "479|47a||",
                "Mongolia": "47b|47c||",
                "Moscow": "47g|47h||",
                "Myanmar": "47i|||",
                "Nauru": "69b|||",
                "Nepal": "47j|||",
                "New_Caledonia": "47k|68r||",
                "New_Zealand": "47l|47m||",
                "Newfoundland": "47n|47o||",
                "Niue": "47q|||",
                "Norfolk": "47r|||",
                "Noronha": "47s,0,5,0,681|47s,0,5,0,680||",
                "North_Mariana": "47u|||",
                "Novosibirsk": "47v|480||",
                "Omsk": "481|482||",
                "Pakistan": "483|484||",
                "Palau": "485|||",
                "Papua_New_Guinea": "65s|||",
                "Paraguay": "486|487||",
                "Peru": "488|48b||",
                "Philippines": "48c|48d||",
                "Phoenix_Islands": "48e|||",
                "Pierre_Miquelon": "48f|48g||",
                "Pitcairn": "63m|||",
                "Ponape": "48h|||",
                "Pyongyang": "4le|||",
                "Qyzylorda": "48i|48j||",
                "Reunion": "48k|||",
                "Rothera": "48m|||",
                "Sakhalin": "48n|48o||",
                "Samara": "48p|48q||",
                "Samoa": "48r|48s||",
                "Seychelles": "61n|||",
                "Singapore": "61m|||",
                "Solomon": "61e|||",
                "South_Georgia": "48v|||",
                "Suriname": "5vs|||",
                "Syowa": "2op|||",
                "Tahiti": "494|||",
                "Taipei": "49g|49h||",
                "Tajikistan": "49k|||",
                "Tokelau": "49l|||",
                "Tonga": "5ui|5ud||",
                "Truk": "49m|||",
                "Turkmenistan": "49n|4a3||",
                "Tuvalu": "5rv|||",
                "Uruguay": "4a6|4a7||",
                "Uzbekistan": "4a9|4ac||",
                "Vanuatu": "5r8|5r7||",
                "Venezuela": "4ad|||",
                "Vladivostok": "4ae|4af||",
                "Volgograd": "4ag|4ah||",
                "Vostok": "4ai|||",
                "Wake": "4aj|||",
                "Wallis": "4ak|||",
                "Yakutsk": "5q3|5q2||",
                "Yekaterinburg": "4al|4am||"
            }
        },
        "zh": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|2tp||",
                "Europe/London": "|2ti||"
            },
            "metazone": {
                "Acre": "2t9|2t8||",
                "Afghanistan": "2t7|||",
                "Africa_Central": "2t6|||",
                "Africa_Eastern": "2t5|||",
                "Africa_Southern": "2t4|||",
                "Africa_Western": "2t3|2t1||",
                "Alaska": "2t0|2sv||",
                "Almaty": "2su|2st||",
                "Amazon": "2ss|2sq||",
                "America_Central": "2sp|2sn||",
                "America_Eastern": "2sm|2sl||",
                "America_Mountain": "2sk|2sj||",
                "America_Pacific": "2si|2sh||",
                "Anadyr": "2sf|2sd||",
                "Apia": "2sc|2sb||",
                "Aqtau": "2sa|2s8||",
                "Aqtobe": "2s6|2s3||",
                "Arabian": "2s1|2s0||",
                "Argentina": "2rv|2ru||",
                "Argentina_Western": "2rr|2rq||",
                "Armenia": "2rp|2ro||",
                "Atlantic": "2rm|2rk||",
                "Australia_Central": "2rj|2ri||",
                "Australia_CentralWestern": "2rh|2rf||",
                "Australia_Eastern": "2rd|2rc||",
                "Australia_Western": "2rb|2r8||",
                "Azerbaijan": "2r7|2r6||",
                "Azores": "2qj|2qf||",
                "Bangladesh": "2q9|2q8||",
                "Bhutan": "2q7|||",
                "Bolivia": "2q2|||",
                "Brasilia": "2pm|2pj||",
                "Brunei": "2pi|||",
                "Cape_Verde": "2ph|2pg||",
                "Casey": "2os|||",
                "Chamorro": "2on|||",
                "Chatham": "2om|2ok||",
                "Chile": "2oj|2oi||",
                "China": "2of|2oe||",
                "Choibalsan": "2od|2oc||",
                "Christmas": "2o9|||",
                "Cocos": "2o0|||",
                "Colombia": "2nt|2ns||",
                "Cook": "2nr|2nq||",
                "Cuba": "2nk|2n1||",
                "Davis": "2n0|||",
                "DumontDUrville": "2n5|||",
                "East_Timor": "318|||",
                "Easter": "314|30u||",
                "Ecuador": "304|||",
                "Europe_Central": "2vs|2vn||",
                "Europe_Eastern": "2uj|2uc||",
                "Europe_Further_Eastern": "2u9|||",
                "Europe_Western": "2tn|2r5||",
                "Falkland": "2r2|2r1||",
                "Fiji": "2r0|2qu||",
                "French_Guiana": "2qs|||",
                "French_Southern": "2qp|||",
                "Galapagos": "2qo|||",
                "Gambier": "2qn|||",
                "Georgia": "2ql|2qk||",
                "Gilbert_Islands": "2qh|||",
                "GMT": "2qg|||",
                "Greenland_Eastern": "2qe|2qa||",
                "Greenland_Western": "2q6|2q4||",
                "Guam": "2q1|||",
                "Gulf": "2pu|||",
                "Guyana": "2po|||",
                "Hawaii_Aleutian": "166,5,2pa|166,5,2p4||",
                "Hong_Kong": "2or|2oh||",
                "Hovd": "2o6|2o4||",
                "India": "2o3|||",
                "Indian_Ocean": "2o2|||",
                "Indochina": "2no|||",
                "Indonesia_Central": "2nn|||",
                "Indonesia_Eastern": "2nm|||",
                "Indonesia_Western": "2nh|||",
                "Iran": "2ne|2v5||",
                "Irkutsk": "2nb|2na||",
                "Israel": "2n6|2mv||",
                "Japan": "2mu|2mq||",
                "Kamchatka": "1lk,5,2mm|1lk,5,2mg||",
                "Kazakhstan_Eastern": "2mf|||",
                "Kazakhstan_Western": "2md|||",
                "Korea": "2mc|2mb||",
                "Kosrae": "2ma|||",
                "Krasnoyarsk": "2m9|2m8||",
                "Kyrgystan": "2m2|||",
                "Lanka": "31g|||",
                "Line_Islands": "317|||",
                "Lord_Howe": "30t|30o||",
                "Macau": "30d|309||",
                "Macquarie": "306|||",
                "Magadan": "303|300||",
                "Malaysia": "2vu|||",
                "Maldives": "2vr|||",
                "Marquesas": "2vp|||",
                "Marshall_Islands": "2vo|||",
                "Mauritius": "2vk|2vi||",
                "Mawson": "2vh|||",
                "Mexico_Northwest": "2vg|2vf||",
                "Mexico_Pacific": "2vb|2ul||",
                "Mongolia": "2uf|2uk||",
                "Moscow": "2ui|2ue||",
                "Myanmar": "2ud|||",
                "Nauru": "2u6|||",
                "Nepal": "2u5|||",
                "New_Caledonia": "2u4|2u1||",
                "New_Zealand": "2tt|2to||",
                "Newfoundland": "2tk|2s2||",
                "Niue": "2rn|||",
                "Norfolk": "2qi|||",
                "Noronha": "1l6,5,2qc|1l6,5,2q3||",
                "North_Mariana": "2pv|||",
                "Novosibirsk": "2pr|2pq||",
                "Omsk": "2p9|2ov||",
                "Pakistan": "2ou|2o5||",
                "Palau": "2o1|||",
                "Papua_New_Guinea": "2nu|||",
                "Paraguay": "2np|2nj||",
                "Peru": "2ni|2nc||",
                "Philippines": "2n8|2n7||",
                "Phoenix_Islands": "2mn|||",
                "Pierre_Miquelon": "2ml|2mj||",
                "Pitcairn": "2mh|||",
                "Ponape": "2m7|||",
                "Pyongyang": "2m5|||",
                "Qyzylorda": "2m0|2ls||",
                "Reunion": "2lr|||",
                "Rothera": "31p|||",
                "Sakhalin": "31m|31l||",
                "Samara": "316|30b||",
                "Samoa": "30a|2uv||",
                "Seychelles": "2us|||",
                "Singapore": "2ur|||",
                "Solomon": "2up|||",
                "South_Georgia": "2un|||",
                "Suriname": "2u8|||",
                "Syowa": "2tr|||",
                "Tahiti": "2th|||",
                "Taipei": "2tf|2td||",
                "Tajikistan": "2ta|||",
                "Tokelau": "2sr|||",
                "Tonga": "2sg|2s4||",
                "Truk": "2rg|||",
                "Turkmenistan": "2re|2pt||",
                "Tuvalu": "2oq|||",
                "Uruguay": "2ol|2nl||",
                "Uzbekistan": "2ng|2m3||",
                "Vanuatu": "31f|31d||",
                "Venezuela": "313|||",
                "Vladivostok": "30m|30h||",
                "Volgograd": "30e|30c||",
                "Vostok": "308|||",
                "Wake": "305|||",
                "Wallis": "302|||",
                "Yakutsk": "301|2vc||",
                "Yekaterinburg": "2v9|2v6||"
            }
        },
        "zu": {
            "gmtFormat": "GMT{0}",
            "gmtZeroFormat": "GMT",
            "zone": {
                "Europe/Dublin": "|667,0,8e,5,c6,0,s3||",
                "Europe/London": "|667,0,8e,5,c1,0,qd||"
            },
            "metazone": {
                "Afghanistan": "7r,0,8e,5,b6|||",
                "Africa_Central": "7r,0,8e,5,n,0,1t|||",
                "Africa_Eastern": "7r,0,c7p,0,c5|||",
                "Africa_Southern": "7r,0,pj,0,c7r,0,c5|||",
                "Africa_Western": "7r,0,pj,0,4n6,0,c5|7r,0,qd,0,4n6,0,c5||",
                "Alaska": "7r,0,8e,5,3p,0,pj|7r,0,8e,5,3p,0,116||",
                "Amazon": "7r,0,8e,5,5m,0,pj|7r,0,8e,5,5m,0,qd||",
                "America_Central": "7r,0,8e,5,bm,0,1rn,0,n,0,pj|7r,0,8e,5,bm,0,1rn,0,n,0,116||",
                "America_Eastern": "7r,0,8e,5,bm,0,1rn,0,1r,0,pj|7r,0,8e,5,bm,0,1rn,0,1r,0,116||",
                "America_Mountain": "7r,0,8e,5,bm,0,1rn,0,5a,0,pj|7r,0,8e,5,bm,0,1rn,0,5a,0,116||",
                "America_Pacific": "7r,0,8e,5,bm,0,1rn,0,2h,0,pj|7r,0,8e,5,bm,0,1rn,0,2h,0,116||",
                "Anadyr": "2jj,5,3l,0,4,0,1|2jj,5,3l,0,6,0,1||",
                "Apia": "7r,0,8e,5,3e,0,s3|7r,0,8e,5,3e,0,116||",
                "Arabian": "7r,0,s3,0,8e,5,87|7r,0,2tj,0,8e,5,87||",
                "Argentina": "7r,0,8e,5,1e,0,pj|7r,0,8e,5,1e,0,qd||",
                "Argentina_Western": "7r,0,51v,0,3il,5,1e,0,pj|7r,0,51v,0,3il,5,1e,0,qd||",
                "Armenia": "7r,0,51r,0,8e,5,4l|7r,0,1em,0,8e,5,4l||",
                "Atlantic": "7r,0,8e,5,6g,0,pj|7r,0,8e,5,6g,0,116||",
                "Australia_Central": "7r,0,8e,5,13,0,n,0,s3|7r,0,8e,5,13,0,n,0,116||",
                "Australia_CentralWestern": "7r,0,8e,5,13,0,n,0,1g,0,s3|7r,0,116,0,8e,5,13,0,n,0,1g||",
                "Australia_Eastern": "7r,0,s3,0,8e,5,13,0,1r|7r,0,116,0,8e,5,13,0,1r||",
                "Australia_Western": "7r,0,8e,5,13,0,t,0,s3|7r,0,8e,5,13,0,t,0,116||",
                "Azerbaijan": "7r,0,s3,0,8e,5,7m|7r,0,1em,0,8e,5,7m||",
                "Azores": "7r,0,pj,0,8e,5,4r|7r,0,qd,0,8e,5,4r||",
                "Bangladesh": "7r,0,8e,5,3n,0,s3|7r,0,8e,5,3n,0,qd||",
                "Bhutan": "7r,0,8e,5,as|||",
                "Bolivia": "7r,0,8e,5,aa|||",
                "Brasilia": "7r,0,8e,5,3a,0,pj|7r,0,8e,5,3a,0,qd||",
                "Brunei": "7r,0,8e,5,9o,0,a4|||",
                "Cape_Verde": "7r,0,51r,0,8e,5,7c,0,3j|7r,0,1em,0,8e,5,7c,0,3j||",
                "Chamorro": "7r,0,pj,0,8e,5,6j|||",
                "Chatham": "7r,0,s3,0,8e,5,27|7r,0,116,0,8e,5,27||",
                "Chile": "7r,0,8e,5,49,0,pj|7r,0,8e,5,49,0,qd||",
                "China": "7r,0,s3,0,8e,5,4h|7r,0,2tj,0,8e,5,4h||",
                "Choibalsan": "7r,0,1en,0,8e,5,2q|7r,0,1em,0,15,5,2q||",
                "Christmas": "7r,0,8e,5,99,0,1f|||",
                "Cocos": "7r,0,8e,5,7v,0,o|||",
                "Colombia": "7r,0,8e,5,4m,0,pj|7r,0,8e,5,4m,0,qd||",
                "Cook": "7r,0,s3,0,8e,5,2v,0,o|7r,0,c88,0,c89,0,8e,5,2v,0,o||",
                "Cuba": "7r,0,8e,5,34,0,pj|7r,0,8e,5,34,0,116||",
                "Davis": "7r,0,8e,5,5s|||",
                "DumontDUrville": "7r,0,8e,5,5b,5,5j|||",
                "East_Timor": "7r,0,8e,5,1r,0,7n|||",
                "Easter": "7r,0,8e,5,7t,0,1f,0,pj|7r,0,8e,5,7t,0,1f,0,qd||",
                "Ecuador": "7r,0,8e,5,ai|||",
                "Europe_Central": "7r,0,pj,0,8e,5,n,0,r4|7r,0,qd,0,8e,5,n,0,r4||",
                "Europe_Eastern": "7r,0,pj,0,8e,5,17,0,r4|7r,0,qd,0,8e,5,17,0,r4||",
                "Europe_Further_Eastern": "7r,0,8e,5,bu,5,c0,0,r4|||",
                "Europe_Western": "7r,0,pj,0,8e,5,t,0,r4|7r,0,qd,0,8e,5,t,0,r4||",
                "Falkland": "7r,0,8e,5,4v,0,o,0,pj|7r,0,8e,5,4v,0,o,0,qd||",
                "Fiji": "7r,0,s3,0,8e,5,4q|7r,0,1em,0,8e,5,4q||",
                "French_Guiana": "7r,0,8e,5,84,0,am|||",
                "French_Southern": "7r,0,8e,5,84,0,c7,0,3ik,5,c4|||",
                "Galapagos": "7r,0,8e,5,ak|||",
                "Gambier": "7r,0,8e,5,6v|||",
                "Georgia": "7r,0,s3,0,8e,5,2u|7r,0,1em,0,8e,5,2u||",
                "Gilbert_Islands": "7r,0,8e,5,6q,0,o|||",
                "GMT": "7r,0,8e,5,5u,0,bh|||",
                "Greenland_Eastern": "7r,0,8e,5,1r,0,2k,0,pj|7r,0,8e,5,1r,0,2k,0,116||",
                "Greenland_Western": "7r,0,8e,5,1g,0,2k,0,pj|7r,0,8e,5,1g,0,2k,0,qd||",
                "Gulf": "7r,0,s3,0,8e,5,bn|||",
                "Guyana": "7r,0,8e,5,7a|||",
                "Hawaii_Aleutian": "7r,0,8e,5,4g,5,50n,0,pj|7r,0,8e,5,4g,5,50n,0,116||",
                "Hong_Kong": "7r,0,s3,0,8e,5,2l,0,2p|7r,0,1em,0,8e,5,2l,0,2p||",
                "Hovd": "7r,0,1en,0,8e,5,2g|7r,0,1em,0,15,5,2g||",
                "India": "7r,0,8e,5,af,0,s3|||",
                "Indian_Ocean": "7r,0,8e,5,br,0,bv|||",
                "Indochina": "7r,0,8e,5,9p|||",
                "Indonesia_Central": "7r,0,8e,5,n,0,2t|||",
                "Indonesia_Eastern": "7r,0,8e,5,17,0,2t|||",
                "Indonesia_Western": "7r,0,8e,5,t,0,2t|||",
                "Iran": "7r,0,8e,5,5g,0,s3|7r,0,8e,5,5g,0,116||",
                "Irkutsk": "7r,0,1en,0,8e,5,3h|7r,0,qd,0,15,5,3h||",
                "Israel": "7r,0,s3,0,8e,5,4e|7r,0,116,0,c8c,5,4e||",
                "Japan": "7r,0,s3,0,8e,5,6o|7r,0,2tj,0,8e,5,6o||",
                "Kamchatka": "2jj,5,37,5,3k,0,4,0,1|2jj,5,37,5,3k,0,6,0,1||",
                "Kazakhstan_Eastern": "7r,0,8e,5,c8d,0,3il,5,45|||",
                "Kazakhstan_Western": "7r,0,4n6,0,3il,5,45|||",
                "Korea": "7r,0,c8e,0,8e,5,qf|7r,0,2tj,0,8e,5,qf||",
                "Kosrae": "7r,0,8e,5,6f|||",
                "Krasnoyarsk": "7r,0,1en,0,8e,5,41|7r,0,qd,0,15,5,41||",
                "Kyrgystan": "7r,0,8e,5,bl|||",
                "Line_Islands": "7r,0,8e,5,ac,0,o|||",
                "Lord_Howe": "7r,0,8e,5,1u,0,24,0,s3|7r,0,8e,5,1u,0,24,0,116||",
                "Macquarie": "7r,0,8e,5,6m,0,1f|||",
                "Magadan": "7r,0,1en,0,8e,5,2o|7r,0,qd,0,15,5,2o||",
                "Malaysia": "7r,0,8e,5,bf|||",
                "Maldives": "7r,0,8e,5,9k|||",
                "Marquesas": "7r,0,8e,5,9e|||",
                "Marshall_Islands": "7r,0,8e,5,7o,0,o|||",
                "Mauritius": "7r,0,s3,0,8e,5,4u|7r,0,1em,0,8e,5,4u||",
                "Mawson": "7r,0,8e,5,63|||",
                "Mexico_Northwest": "7r,0,8e,5,80,0,5e,0,pj|7r,0,8e,5,80,0,5e,0,116||",
                "Mexico_Pacific": "7r,0,8e,5,81,0,2h,0,pj|7r,0,8e,5,81,0,2h,0,116||",
                "Mongolia": "7r,0,1en,0,8e,5,4f,0,2m|7r,0,1em,0,15,5,4f,0,2m||",
                "Moscow": "7r,0,8e,5,71,0,pj|7r,0,qd,0,15,5,71||",
                "Myanmar": "7r,0,8e,5,8v|||",
                "Nauru": "7r,0,8e,5,5v|||",
                "Nepal": "7r,0,8e,5,8u|||",
                "New_Caledonia": "7r,0,8e,5,1m,0,4o,0,pj|7r,0,8e,5,1m,0,4o,0,qd||",
                "New_Zealand": "7r,0,s3,0,8e,5,1m,0,74|7r,0,116,0,8e,5,1m,0,74||",
                "Newfoundland": "7r,0,8e,5,53,0,pj|7r,0,8e,5,53,0,116||",
                "Niue": "7r,0,8e,5,8g|||",
                "Norfolk": "7r,0,8e,5,6l,0,o|||",
                "Noronha": "7r,0,8e,5,1s,0,2,0,23,0,pj|7r,0,8e,5,1s,0,2,0,23,0,qd||",
                "Novosibirsk": "7r,0,1en,0,8e,5,3b|7r,0,qd,0,8e,5,3b||",
                "Omsk": "7r,0,1en,0,8e,5,26|7r,0,qd,0,8e,5,26||",
                "Pakistan": "7r,0,8e,5,3i,0,s3|7r,0,8e,5,3i,0,qd||",
                "Palau": "7r,0,8e,5,9b|||",
                "Papua_New_Guinea": "7r,0,8e,5,9a,0,1m,0,a8|||",
                "Paraguay": "7r,0,8e,5,3c,0,pj|7r,0,8e,5,3c,0,qd||",
                "Peru": "7r,0,8e,5,4n,0,pj|7r,0,8e,5,4n,0,qd||",
                "Philippines": "7r,0,s3,0,8e,5,86|7r,0,1em,0,8e,5,86||",
                "Phoenix_Islands": "7r,0,8e,5,90,0,o|||",
                "Pierre_Miquelon": "c8f,0,8e,5,8i,0,33,0,3ik,5,35,0,pj|7r,0,8e,5,8i,0,33,0,3ik,5,35,0,116||",
                "Pitcairn": "7r,0,8e,5,7e|||",
                "Ponape": "7r,0,8e,5,9s|||",
                "Pyongyang": "7r,0,8e,5,8a|||",
                "Reunion": "7r,0,8e,5,b4|||",
                "Rothera": "7r,0,8e,5,5q|||",
                "Sakhalin": "7r,0,1en,0,8e,5,55|7r,0,qd,0,15,5,55||",
                "Samara": "2jj,5,29,0,4,0,1|2jj,5,29,0,6,0,1||",
                "Samoa": "7r,0,8e,5,2c,0,pj|7r,0,8e,5,2c,0,116||",
                "Seychelles": "7r,0,8e,5,8k|||",
                "Singapore": "7r,0,s3,0,8e,5,bi|||",
                "Solomon": "7r,0,8e,5,b5,0,o|||",
                "South_Georgia": "7r,0,8e,5,85,0,2u|||",
                "Suriname": "7r,0,8e,5,8q|||",
                "Syowa": "7r,0,8e,5,65|||",
                "Tahiti": "7r,0,8e,5,8n|||",
                "Taipei": "7r,0,s3,0,8e,5,3d|7r,0,2tj,0,8e,5,3d||",
                "Tajikistan": "7r,0,8e,5,bj|||",
                "Tokelau": "7r,0,8e,5,5d|||",
                "Tonga": "7r,0,8e,5,2j,0,pj|7r,0,8e,5,2j,0,qd||",
                "Truk": "7r,0,8e,5,6p|||",
                "Turkmenistan": "7r,0,s3,0,8e,5,4t|7r,0,1em,0,8e,5,4t||",
                "Tuvalu": "7r,0,8e,5,6h|||",
                "Uruguay": "7r,0,8e,5,4k,0,pj|7r,0,8e,5,4k,0,qd||",
                "Uzbekistan": "7r,0,s3,0,8e,5,60|7r,0,1em,0,8e,5,60||",
                "Vanuatu": "7r,0,8e,5,2f,0,pj|7r,0,8e,5,2f,0,qd||",
                "Venezuela": "7r,0,8e,5,7s|||",
                "Vladivostok": "7r,0,1en,0,8e,5,28|7r,0,qd,0,15,5,28||",
                "Volgograd": "7r,0,1en,0,8e,5,3f|7r,0,8e,5,3f,0,qd||",
                "Vostok": "7r,0,8e,5,5t|||",
                "Wake": "7r,0,8e,5,5r,0,1f|||",
                "Wallis": "7r,0,8e,5,5f,0,3ik,5,5k|||",
                "Yakutsk": "7r,0,1en,0,8e,5,3u|7r,0,qd,0,15,5,3u||",
                "Yekaterinburg": "7r,0,1en,0,8e,5,5l|7r,0,qd,0,15,5,5l||"
            }
        }
    },
    "zoneNameIndex": [
        " ",
        "Time",
        "de",
        "heure",
        "Standard",
        "-",
        "Summer",
        "توقيت",
        "hora",
        "Hora",
        "normale",
        "d’été",
        "Daylight",
        "estándar",
        "verano",
        "du",
        "الصيفي",
        "الرسمي",
        "Ora",
        "des",
        ",",
        "za",
        "време",
        "Central",
        "Islands",
        "время",
        "padrão",
        "நேரம்",
        "verão",
        "Western",
        "Waktu",
        "Saa",
        "vrijeme",
        "čas",
        "îles",
        "Australian",
        "da",
        "e",
        "do",
        "Eastern",
        "European",
        "del",
        "standardno",
        "समय",
        "la",
        "vreme",
        "Argentina",
        "Island",
        "West",
        "standaardtijd",
        "zomertijd",
        "Sommerzeit",
        "Normalzeit",
        "normaltid",
        "New",
        "وقت",
        "التوقيت",
        "l’Ouest",
        "стандардно",
        "East",
        "Fernando",
        "Africa",
        "Lord",
        "l’Est",
        "летње",
        "стандартное",
        "летнее",
        "Noronha",
        "Howe",
        "Zeit",
        "Omsk",
        "Chatham",
        "Vladivostok",
        "Samara",
        "Saati",
        "рачунање",
        "Samoa",
        "времена",
        "غرب",
        "Vanuatu",
        "Hovd",
        "Pacific",
        "tijd",
        "Tonga",
        "Greenland",
        "Hong",
        "Bator",
        "সময়",
        "Magadan",
        "Kong",
        "Choibalsan",
        "ਵੇਲਾ",
        "vaqti",
        "Indonesia",
        "Georgia",
        "Cook",
        "Vaxtı",
        "&",
        "las",
        "Pierre",
        "Cuba",
        "Miquelon",
        "estàndard",
        "Petropavlovsk",
        "standard",
        "d’estiu",
        "Brasilia",
        "Novosibirsk",
        "Paraguay",
        "Taipei",
        "Apia",
        "Volgograd",
        "ٹائم",
        "Irkutsk",
        "Pakistan",
        "Verde",
        "Kamchatski",
        "Anadyr",
        "l’Australie",
        "Bangladesh",
        "letnje",
        "Alaska",
        "Acre",
        "oriental",
        "표준시",
        "sommertid",
        "Yakutsk",
        "vremena",
        "računanje",
        "Krasnoyarsk",
        "جزر",
        "Wastani",
        "Standart",
        "Kazakhstan",
        "ώρα",
        "நிலையான",
        "occidental",
        "Chile",
        "l’île",
        "ljetno",
        "Australia",
        "Qyzylorda",
        "Israel",
        "Ulan",
        "Hawaii",
        "China",
        "di",
        "tid",
        "Uruguay",
        "Armenia",
        "Colombia",
        "Peru",
        "Caledonia",
        "Europa",
        "Fiji",
        "Azores",
        "tíð",
        "Turkmenistan",
        "Mauritius",
        "Falkland",
        "Aqtau",
        "شرق",
        "na",
        "Newfoundland",
        "d’Europe",
        "Sakhalin",
        "Almaty",
        "Macau",
        "standarde",
        "ya",
        "Mountain",
        "Dumont",
        "verore",
        "Tokelau",
        "Mexico",
        "Wallis",
        "Iran",
        "Panas",
        "Musim",
        "d’Urville",
        "Futuna",
        "Yekaterinburg",
        "Amazon",
        "मानक",
        "Aqtobe",
        "Piawai",
        "Rothera",
        "Wake",
        "Davis",
        "Vostok",
        "Greenwich",
        "Nauru",
        "Uzbekistan",
        "legale",
        "Aleutian",
        "Mawson",
        "laikas",
        "Syowa",
        "Am",
        "houa",
        "సమయం",
        "Horário",
        "സമയം",
        "Giờ",
        "sommartid",
        "din",
        "સમય",
        "Kosrae",
        "Atlantic",
        "Tuvalu",
        "standart",
        "Chamorro",
        "ۋاقتى",
        "Norfolk",
        "Macquarie",
        "centre",
        "Japan",
        "Chuuk",
        "Gilbert",
        "central",
        "கோடை",
        "das",
        "वेळ",
        "Gambier",
        "टाईम",
        "Moscow",
        "שעון",
        "ٹایِم",
        "Zealand",
        "Horario",
        "Nouvelle",
        "d’Afrique",
        "ಸಮಯ",
        "за",
        "Guyana",
        "laiks",
        "Cape",
        "часом",
        "Pitcairn",
        "idő",
        "цаг",
        "Amser",
        "أستراليا",
        "ժամանակ",
        "وسط",
        "уақыты",
        "Azerbaijan",
        "Timor",
        "Marshall",
        "დრო",
        "cas",
        "Isikhathi",
        "Venezuela",
        "Easter",
        "St.",
        "Cocos",
        "Northwest",
        "Mexican",
        "вақти",
        "Guam",
        "French",
        "South",
        "Philippine",
        "Arabian",
        "Korean",
        "for",
        "Pyongyang",
        "ሰዓት",
        "sa",
        "Majira",
        "sase",
        "වේලාව",
        "Niue",
        "Oriental",
        "Saint",
        "joto",
        "Seychelles",
        "ᎠᏟᎢᎵᏒ",
        "الشمالية",
        "Tahiti",
        "Groenland",
        "et",
        "Suriname",
        "Oras",
        "eur",
        "Pacifique",
        "Nepal",
        "Myanmar",
        "Phoenix",
        "ਮਿਆਰੀ",
        "عادی",
        "nord",
        "하계",
        "Yaz",
        "taimi",
        "час",
        "Nord",
        "Christmas",
        "Papua",
        "Palau",
        "Lanka",
        "África",
        "Marquesas",
        "تابستانی",
        "standaardtyd",
        "أوروبا",
        "Ocidental",
        "لأمريكا",
        "Maldives",
        "во",
        "মানক",
        "vară",
        "Brunei",
        "Indochina",
        "vanlig",
        "centrale",
        "Ponape",
        "wagt",
        "Pacífico",
        "хан",
        "убактысы",
        "yozgi",
        "Θερινή",
        "Yay",
        "Darussalam",
        "ग्रीष्मकालीन",
        "a",
        "Χειμερινή",
        "Guinea",
        "summartíð",
        "Bolivia",
        "стандарт",
        "Line",
        "standardny",
        "Ilhas",
        "India",
        "на",
        "GMT",
        "Ecuador",
        "स्टैंडर्ड",
        "Galapagos",
        "Islas",
        "Guiana",
        "Nueva",
        "المحيط",
        "أفريقيا",
        "Géorgie",
        "indonésien",
        "Bhutan",
        "Ώρα",
        "México",
        "isla",
        "américain",
        "시간",
        "Groenlandia",
        "islas",
        "Reunion",
        "Solomon",
        "Afghanistan",
        "Casey",
        "ordua",
        "Açores",
        "Nova",
        "(czas",
        "tyd",
        "Mariana",
        "í",
        "Malaysia",
        "Amazonas",
        "Mean",
        "Singapore",
        "Tajikistan",
        "y",
        "Kyrgystan",
        "North",
        "Gulf",
        "غرينلاند",
        "பகலொளி",
        "الأرجنتين",
        "Indian",
        "جزيرة",
        "الهادي",
        "Further",
        "Ocean",
        "eastern",
        "British",
        "Ata",
        "کا",
        "Antarctic",
        "Afrika",
        "Irish",
        "Southern",
        "Half",
        "d’Apia",
        "Moscou",
        "d’Anadyr",
        "Centre",
        "somertyd",
        "d’Iran",
        "Cap",
        "Chili",
        "ਗਰਮੀਆਂ",
        "ਦਾ",
        "Mchana",
        "Cabo",
        "গ্রীষ্মকালীন",
        "Fidji",
        "Austrália",
        "Terre",
        "Galápagos",
        "സ്റ്റാൻഡേർഡ്",
        "Samhraidh",
        "Maurice",
        "mexicain",
        "d’Oulan",
        "l’Amazonie",
        "l’Ouzbékistan",
        "Calédonie",
        "d’Alma",
        "Corée",
        "l’Alaska",
        "Chine",
        "Vert",
        "ouest",
        "l’Acre",
        "Krasnoïarsk",
        "d’Irkoutsk",
        "d’Israël",
        "Zélande",
        "l’Atlantique",
        "Neuve",
        "argentin",
        "Japon",
        "Caighdeánach",
        "Novossibirsk",
        "Pérou",
        "Philippines",
        "l’Arabie",
        "d’Aqtöbe",
        "Sakhaline",
        "ప్రామాణిక",
        "Turkménistan",
        "l’Uruguay",
        "Malouines",
        "Aléoutiennes",
        "Pâques",
        "Iakoutsk",
        "d’Ekaterinbourg",
        "d’Aktaou",
        "Colombie",
        "Ouest",
        "Rocheuses",
        "Mexique",
        "Pohnpei",
        "Standar",
        "ئۆلچەملىك",
        "standardaeg",
        "Padrão",
        "d’Hawaii",
        "nyári",
        "Verão",
        "vasaros",
        "normaaliaika",
        "kesäaika",
        "totonu",
        "àm",
        "Bun",
        "يازلىق",
        "liliu",
        "suveaeg",
        "delle",
        "ಪ್ರಮಾಣಿತ",
        "Австралия",
        "Tìde",
        "braniega",
        "standerttiid",
        "žiemos",
        "les",
        "téli",
        "simmertiid",
        "avancée",
        "መደበኛ",
        "الجديدة",
        "प्रमाण",
        "سٹینڑاڑ",
        "إندونيسيا",
        "estandarra",
        "ziemas",
        "štandardný",
        "جورجيا",
        "letní",
        "دي",
        "Summerzäit",
        "стандартно",
        "standardní",
        "Volgogrado",
        "ᎠᏟᎶᏍᏗ",
        "vasaras",
        "лятно",
        "سٹینڈرڈ",
        "літнім",
        "verán",
        "အချိန်",
        "Normalzäit",
        "Staðaltími",
        "letný",
        "Siang",
        "Sumartími",
        "стандартним",
        "стандартты",
        "standardni",
        "udako",
        "Filipinas",
        "Safonol",
        "часово",
        "Chuẩn",
        "samhraidh",
        "lětni",
        "Haf",
        "аьхкенан",
        "кышкы",
        "lěśojski",
        "жазғы",
        "tomusky",
        "жайкы",
        "სტანდარტული",
        "ստանդարտ",
        "зуны",
        "سمر",
        "(חורף)",
        "стандартан",
        "සම්මත",
        "ամառային",
        "(קיץ)",
        "አቆጣጠር",
        "ზაფხულის",
        "Zelanda",
        "Pedro",
        "poletni",
        "cʼhoañv",
        "Brunéi",
        "Palaos",
        "EET",
        "EEST",
        "CET",
        "WET",
        "WEST",
        "о",
        "CEST",
        "Terranova",
        "Mùa",
        "Ilha",
        "ng",
        "tidssone",
        "Perú",
        "ва",
        "Oost",
        "aika",
        "Àm",
        "Corea",
        "માનક",
        "hañv",
        "Стандардно",
        "Hè",
        "Аргентина",
        "Летно",
        "ordu",
        "Западная",
        "della",
        "Zäit",
        "tiid",
        "سَمَر",
        "Arabia",
        "Barat",
        "Magharibi",
        "Europese",
        "letni)",
        "убакыты",
        "aeg",
        "i",
        "Aktau",
        "standardowy)",
        "Sud",
        "Време",
        "Réunion",
        "اسٹینڈرڈ",
        "వేసవి",
        "Восточная",
        "समर",
        "စံတော်ချိန်",
        "ساموا",
        "سمارا",
        "فرناندو",
        "ગ્રીષ્મ",
        "Центральная",
        "جنوب",
        "dagligtyd",
        "и",
        "Aktobe",
        "Brasília",
        "San",
        "Macao",
        "Pascua",
        "Острва",
        "á",
        "فلاديفوستوك",
        "فولغوغراد",
        "الأمازون",
        "موسكو",
        "برازيليا",
        "المركزي",
        "الرأس",
        "الأخضر",
        "نوفوسيبيرسك",
        "أومسك",
        "باكستان",
        "تشاتام",
        "تونغا",
        "ماغادان",
        "باتور",
        "أولان",
        "للمكسيك",
        "Bangladés",
        "شيلي",
        "الصين",
        "Magadán",
        "الشرقي",
        "تركمانستان",
        "Atlántico",
        "الجبلي",
        "أورغواي",
        "noroeste",
        "दिवा",
        "تايبيه",
        "نيوفاوندلاند",
        "كولومبيا",
        "كووك",
        "المكسيك",
        "Malvinas",
        "كوبا",
        "ساخالين",
        "Irán",
        "هاو",
        "لشمال",
        "استر",
        "العربي",
        "Moscú",
        "ياكوتسك",
        "ਪ੍ਰਕਾਸ਼",
        "أرمينيا",
        "أوزبكستان",
        "باراغواي",
        "كاليدونيا",
        "فوكلاند",
        "Ulán",
        "–",
        "فيجي",
        "Ekaterimburgo",
        "ڈے",
        "لائٹ",
        "الفرنسية",
        "كوريا",
        "كازاخستان",
        "بيرو",
        "فانواتو",
        "كامتشاتسكي",
        "بيتروبافلوفسك",
        "الأطلسي",
        "اليابان",
        "Mauricio",
        "إسرائيل",
        "Australische",
        "Krasnojarsk",
        "إركوتسك",
        "الفيلبين",
        "سانت",
        "بيير",
        "إيران",
        "نورونها",
        "وميكولون",
        "موريشيوس",
        "أذربيجان",
        "أزورس",
        "الهند",
        "Tadjikistan",
        "هوفد",
        "يكاترينبورغ",
        "Taipéi",
        "هاواي",
        "Turkmenistán",
        "بنجلاديش",
        "ألوتيان",
        "هونغ",
        "كونغ",
        "نيوزيلندا",
        "Vrijeme",
        "Европа",
        "Azerbaiyán",
        "Uzbekistán",
        "Kamchatka",
        "Montañas",
        "Hawái",
        "Japón",
        "Pakistán",
        "Miquelón",
        "Fiyi",
        "Amerika",
        "Kazajistán",
        "Sajalín",
        "နွေရာသီ",
        "Америка",
        "кэмэ",
        "Singapur",
        "centroccidental",
        "ಬೇಸಿಗೆ",
        "init",
        "Tag",
        "ёзги",
        "Sri",
        "Час",
        "Surinam",
        "उन्हाळी",
        "Африка",
        "ᎪᎩ",
        "ഗ്രീഷ്‌മകാല",
        "ග්‍රීෂ්ම",
        "Kirghizistan",
        "Mashariki",
        "Kaliningrad",
        "Аустралијско",
        "Salomon",
        "gaƒoƒome",
        "Midden",
        "Timur",
        "Singapour",
        "La",
        "horario",
        "Guyane",
        "у",
        "Marquises",
        "Bhoutan",
        "l’Océan",
        "Népal",
        "Golfe",
        "Indien",
        "Ligne",
        "d’Argentine",
        "d’Indochine",
        "Terres",
        "occidentale",
        "française",
        "Francesa",
        "l’Équateur",
        "l’Arménie",
        "d’Arménie",
        "Bolivie",
        "an",
        "Adaları",
        "দিবালোক",
        "d’Azerbaïdjan",
        "françaises",
        "moyenne",
        "irlandaise",
        "Nioué",
        "l’Azerbaïdjan",
        "Malaisie",
        "Mariannes",
        "l’Inde",
        "Guinée",
        "antarctiques",
        "Papouasie",
        "l’Afghanistan",
        "britannique",
        "australes",
        "l’Argentine",
        "illes",
        "méridionale",
        "Gronelândia",
        "Aleutianas",
        "தீவுகள்",
        "mwa",
        "сметање",
        "времето",
        "Occidental",
        "Czas",
        "Golfo",
        "Лорд",
        "Стандартны",
        "Ostrva",
        "Ishujve",
        "eilandse",
        "Nordamerikanische",
        "Kepulauan",
        "orientale",
        "पूर्वी",
        "Улан",
        "Вануату",
        "Тонга",
        "en",
        "Maldivas",
        "Самоа",
        "மத்திய",
        "Ulaanbaatar",
        "d’Austràlia",
        "Norte",
        "தர",
        "централно",
        "Северноамеричко",
        "Paraguai",
        "Visiwa",
        "Índico",
        "së",
        "Perëndimore",
        "Fénix",
        "летні",
        "Francesas",
        "Летні",
        "Sachalin",
        "Moskva",
        "esijwayelekile",
        "Irlanda",
        "Tengah",
        "острва",
        "d’Europa",
        "стандартны",
        "Australijsko",
        "Гренландия",
        "Сен",
        "Kati",
        "gaƒoƒoɖoanyime",
        "و",
        "Geórgia",
        "vya",
        "Перу",
        "Indonésia",
        "ar",
        "पश्चिमी",
        "të",
        "Jekaterinburg",
        "மேற்கத்திய",
        "Бангладеш",
        "Волгоград",
        "Afrikaanse",
        "Georgische",
        "Nieuw",
        "sasehlobo",
        "в",
        "Korea",
        "Ховд",
        "Hongkong",
        "Wolgograd",
        "Jakutsk",
        "Guayana",
        "Куба",
        "ŋkekeme",
        "Владивосток",
        "Батор",
        "Микелон",
        "Магадан",
        "Tahití",
        "Lindore",
        "Новосибирск",
        "Severnoameričko",
        "Azoren",
        "Qərbi",
        "media",
        "Atlantik",
        "Avstraliya",
        "Europe",
        "Омск",
        "Москва",
        "ਪੱਛਮੀ",
        "Сахалин",
        "ஆஸ்திரேலியன்",
        "Birmania",
        "مارشال",
        "meridiano",
        "معیاری",
        "Papúa",
        "Summerziit",
        "فوتونا",
        "لورد",
        "d’Amèrica",
        "ماوسون",
        "Острова",
        "Новая",
        "ክረምት",
        "Uruguai",
        "Mexiko",
        "بوتان",
        "Пакистан",
        "Иран",
        "Aqtöbe",
        "афричко",
        "مغربی",
        "orollari",
        "Schtandardziit",
        "Salomón",
        "لاين",
        "esivamile",
        "Reunión",
        "Bután",
        "نورفولك",
        "نيوي",
        "لآبيا",
        "डेलाइट",
        "مونت",
        "Argentijnse",
        "británica",
        "Antárticas",
        "ᎢᎦ",
        "Sudáfrica",
        "ᎪᎯ",
        "Malasia",
        "بالاو",
        "الهندي",
        "الصينية",
        "دو",
        "सूर्यप्रकाश",
        "ماكواري",
        "روفيل",
        "Kirguistán",
        "கிழக்கத்திய",
        "este",
        "بابوا",
        "المقاطعات",
        "غينيا",
        "und",
        "Arabische",
        "تيمور",
        "الشرقية",
        "Mexicaanse",
        "لأبيا",
        "بوليفيا",
        "موسم",
        "گرما",
        "الجنوبية",
        "Afganistán",
        "الإكوادور",
        "Kuba",
        "ماليزيا",
        "والأنتارتيكية",
        "الـمالديف",
        "فينكس",
        "غلاباغوس",
        "ماركيساس",
        "الأوروبي",
        "Alasca",
        "بيتكيرن",
        "ألاسكا",
        "(أكثر",
        "fakalūsia",
        "جامبير",
        "ஐரோப்பிய",
        "ਸਮਾਂ",
        "بونابي",
        "بيونغ",
        "كوسرا",
        "كراسنويارسك",
        "أفغانستان",
        "og",
        "يانغ",
        "Mikelon",
        "لكراسنويارسك",
        "بروناي",
        "ريونيون",
        "جيلبرت",
        "روثيرا",
        "ਆਈਲੈਂਡ",
        "قرغيزستان",
        "غرينتش",
        "غوام",
        "الخليج",
        "غيانا",
        "شرقًا)",
        "أيرلندا",
        "centralno",
        "ميانمار",
        "ناورو",
        "واليس",
        "Groenlandse",
        "نيبال",
        "لشويبالسان",
        "الكريسماس",
        "للورد",
        "ويك",
        "فوستوك",
        "Гренланд",
        "سيشل",
        "كوكوس",
        "западно",
        "سنغافورة",
        "فنزويلا",
        "لألاسكا",
        "غايانا",
        "بريطانيا",
        "توفالو",
        "أنادير",
        "ماريانا",
        "سليمان",
        "شوك",
        "تشامورو",
        "توكيلاو",
        "شويبالسان",
        "لأنادير",
        "سورينام",
        "سايووا",
        "تاهيتي",
        "طاجكستان",
        "دافيز",
        "દિવસ",
        "CAT",
        "Leste",
        "Isole",
        "Marianas",
        "የቀን",
        "Индонезия",
        "EAT",
        "WAST",
        "పగటి",
        "Navidad",
        "Ecuatoriales",
        "SAST",
        "Tierras",
        "Tayikistán",
        "Australes",
        "Espóradas",
        "WAT",
        "meridional",
        "Şərqi",
        "ഡേലൈറ്റ്",
        "Noroeste",
        "Узбекистан",
        "Montanha",
        "Хау",
        "ਪੂਰਬੀ",
        "Pasifik",
        "Sul",
        "Doğu",
        "Isla",
        "Meksika",
        "océano",
        "l’Àfrica",
        "stanice",
        "кундузги",
        "مشرقی",
        "сүрүн",
        "Colômbia",
        "Ostrvu",
        "Coreia",
        "dos",
        "USA",
        "Atlântico",
        "Arábia",
        "ostrva",
        "kupow",
        "pacifičko",
        "istočno",
        "dell’Australia",
        "جزایر",
        "Ulaya",
        "Верде",
        "sasemini",
        "Zelândia",
        "Макао",
        "Terra",
        "Australisë",
        "Тихоокеанское",
        "zapadno",
        "Aleutas",
        "Чойбалсан",
        "પ્રમાણભૂત",
        "Japão",
        "Paquistão",
        "தீவு",
        "Vestur",
        "Batı",
        "Qendrore",
        "Западно",
        "западное",
        "제도",
        "கிழக்கு",
        "Sharqiy",
        "мексиканское",
        "Ecaterimburgo",
        "cha",
        "डेलाईट",
        "Sacalina",
        "Páscoa",
        "Νησιών",
        "сайыҥҥы",
        "Uzbequistão",
        "पश्चिम",
        "Нова",
        "острові",
        "Golf",
        "Δυτικής",
        "островах",
        "рӕстӕг",
        "Otoka",
        "São",
        "Arménia",
        "Caledónia",
        "Havai",
        "Источно",
        "टापु",
        "দ্বীপপুঞ্জ",
        "standardtid",
        "পূর্ব",
        "Аляска",
        "Pionyang",
        "Cazaquistão",
        "කාලය",
        "Кабо",
        "Maurícia",
        "Irão",
        "Miquelão",
        "Mexicano",
        "Иркутск",
        "Taipé",
        "Turquemenistão",
        "Moskauer",
        "Норонья",
        "Azerbaijão",
        "Moscovo",
        "Čas",
        "Екатеринбург",
        "Adası",
        "Фернандо",
        "источно",
        "де",
        "Eropah",
        "tími",
        "HDT",
        "Evropës",
        "የበጋ",
        "dell’Europa",
        "HST",
        "lejano",
        "Indonesische",
        "Папуа",
        "ordutegia",
        "Пьер",
        "Sjevernoameričko",
        "Markaziy",
        "Парагвай",
        "آئلینڈز",
        "Kisiwa",
        "l’Argentina",
        "Гонконг",
        "Mərkəzi",
        "Jakoetsk",
        "szigeteki",
        "Фернанду",
        "Yeni",
        "Moskou",
        "l’Oest",
        "Rocky",
        "Норфолк",
        "zónaidő",
        "Tsjojbalsan",
        "Mèxic",
        "Уругвай",
        "Pacífic",
        "केन्द्रीय",
        "Якутск",
        "מערב",
        "மேற்கு",
        "مرکز",
        "Красноярск",
        "Sen",
        "Тувалу",
        "Wes",
        "Футуна",
        "Usbekistan",
        "America",
        "ஆப்பிரிக்க",
        "لینڈ",
        "americană",
        "ᏭᏕᎵᎬ",
        "Науру",
        "Ньюфаундленд",
        "Eileanan",
        "afričko",
        "Чили",
        "l’oest",
        "Grenlàndia",
        "ಹಗಲು",
        "letni",
        "Восток",
        "Токелау",
        "Ротера",
        "Феникс",
        "Палау",
        "IST",
        "Eurohpá",
        "Koreaanse",
        "Колумбия",
        "Грузия",
        "Pulau",
        "የሰዓት",
        "Зеландия",
        "standardowy",
        "Корея",
        "Бразилия",
        "Каледония",
        "Wladiwostok",
        "Kuzey",
        "ਉੱਤਰੀ",
        "미",
        "Амазон",
        "nan",
        "Апиа",
        "Маврикий",
        "Источни",
        "Ανατολικής",
        "индонезијско",
        "Фиджи",
        "Чатем",
        "Ishullit",
        "Sahalin",
        "Израиль",
        "夏威夷",
        "Insulelor",
        "hè",
        "ᎠᏟᎢᎵᏒᎩ",
        "астравоў",
        "Сингапур",
        "Nowosibirsk",
        "Непал",
        "Miền",
        "Бутан",
        "Bolívia",
        "Западна",
        "MDT",
        "Alma",
        "Irkoetsk",
        "Kamtsjatski",
        "Avustralya",
        "Kazachse",
        "Macause",
        "동부",
        "Amazone",
        "կղզիների",
        "Zapadno",
        "Filipijnse",
        "அர்ஜென்டினா",
        "Armeense",
        "Пасхи",
        "Turkmeense",
        "অস্ট্রেলীয়",
        "Australiese",
        "westelijke",
        "Oezbeekse",
        "Makao",
        "अस्ट्रेलिया",
        "Inland",
        "Ostküsten",
        "Jekaterinenburg",
        "Westküsten",
        "Bengalese",
        "Αυστραλίας",
        "Zentral",
        "ordutegi",
        "Şimali",
        "கிரீன்லாந்து",
        "Bangladesch",
        "HAST",
        "Meksiko",
        "HADT",
        "ди",
        "பசிபிக்",
        "Самара",
        "Fidschi",
        "서부",
        "planinsko",
        "Avstralia",
        "dan",
        "Кука",
        "Australiei",
        "Казахстан",
        "Pasqua",
        "Βόρειας",
        "Ostgrönland",
        "Westgrönland",
        "Aleuten",
        "Αμερικής",
        "Мексико",
        "Hongkongse",
        "오스트레일리아",
        "დასავლეთ",
        "Tây",
        "Kamtschatka",
        "ᏗᏜ",
        "Амазонка",
        "AKST",
        "Grenland",
        "استرالیا",
        "امریکا",
        "Централно",
        "ਆਸਟ੍ਰੇਲੀਆਈ",
        "غەربىي",
        "Oos",
        "Армения",
        "Occidentale",
        "wa",
        "ਅਮਰੀਕੀ",
        "MST",
        "grada",
        "AKDT",
        "Анадир",
        "Суринам",
        "ADT",
        "острови",
        "კუნძულების",
        "Indische",
        "dell’Isola",
        "Est",
        "Singapura",
        "Nuova",
        "Taiti",
        "Afrikës",
        "Грузија",
        "adalary",
        "Хонг",
        "Đảo",
        "mùa",
        "Re",
        "ostrova",
        "اروپا",
        "AST",
        "salu",
        "PDT",
        "PST",
        "uharteetako",
        "EDT",
        "EST",
        "CDT",
        "CST",
        "kupy",
        "dell’Africa",
        "ᏗᎧᎸᎬ",
        "Salų",
        "Horari",
        "Geòrgia",
        "d’Indonèsia",
        "Zuid",
        "hihifo",
        "Zeelandse",
        "Ευρώπης",
        "मध्य",
        "Feniks",
        "nyugat",
        "Тайвань",
        "Japanse",
        "ਕੇਂਦਰੀ",
        "Westafrikanische",
        "Ɣedzeƒe",
        "алеутско",
        "Краснојарск",
        "പടിഞ്ഞാറൻ",
        "Titina",
        "পশ্চিম",
        "Paaseilandse",
        "Argentinische",
        "Westargentinische",
        "Armenische",
        "Zentralaustralische",
        "океан",
        "/Westaustralische",
        "Ostaustralische",
        "Westaustralische",
        "Tongaanse",
        "Colombiaanse",
        "Gorllewin",
        "Israëlische",
        "Азербејџан",
        "Chilenische",
        "Chinesische",
        "Tschoibalsan",
        "vaxtı",
        "Cʼhornôg",
        "Kolumbianische",
        "Cookinseln",
        "Kubanische",
        "Ostrvima",
        "Osterinsel",
        "Япония",
        "Mitteleuropäische",
        "MEZ",
        "MESZ",
        "Osteuropäische",
        "OEZ",
        "OESZ",
        "Uruguayaanse",
        "Westeuropäische",
        "WEZ",
        "WESZ",
        "Falklandinseln",
        "Orta",
        "Бразилија",
        "Vanuatuaanse",
        "Каледонија",
        "పశ్చిమ",
        "Зеланд",
        "Њуфаундленд",
        "Чатам",
        "Нороња",
        "Чиле",
        "Iraanse",
        "Merkezi",
        "Paraguayaanse",
        "Chowd",
        "Havajsko",
        "Чојбалсан",
        "Krasnoiarsk",
        "Iar",
        "Guyaanse",
        "Парагвај",
        "Iranische",
        "Israelische",
        "Japanische",
        "Azerbeidzjaanse",
        "Филиппины",
        "Филипини",
        "Koreanische",
        "Пјер",
        "Кизилорда",
        "Колумбија",
        "otoka",
        "Europei",
        "Nordwestliche",
        "Zone",
        "Pazifikzone",
        "Израелско",
        "কেন্দ্রীয়",
        "Neukaledonische",
        "Neuseeland",
        "Neufundland",
        "آسٹریلین",
        "Peruaanse",
        "d’Omsk",
        "Aleoetische",
        "Pakistanische",
        "Fijische",
        "Paraguayanische",
        "Peruanische",
        "Philippinische",
        "Петропавловск",
        "Ғарбий",
        "Chinese",
        "Туркменистан",
        "Уругвај",
        "ਯੂਰਪੀ",
        "летно",
        "Азербайджан",
        "Taipeh",
        "Источноевропско",
        "Tonganische",
        "Западноевропско",
        "Chileense",
        "قىسىم",
        "Китай",
        "Фиџи",
        "Јакутск",
        "ಪಶ್ಚಿಮ",
        "බටහිර",
        "Гвајана",
        "Avrupa",
        "Falklandeilandse",
        "Cubaanse",
        "Avropa",
        "Kaapverdische",
        "Centraal",
        "Cookeilandse",
        "איי",
        "युरोपेली",
        "mendebaldeko",
        "Lääne",
        "Braziliaanse",
        "중부",
        "Mauritiaanse",
        "Caledonische",
        "Mianmar",
        "Kuk",
        "Акре",
        "Pakistaanse",
        "Samoaanse",
        "Kokos",
        "Anadir",
        "Noordwest",
        "Extremo",
        "Čas:",
        "Padrãu",
        "sehlobo",
        "Esimisiwe",
        "Лайн",
        "Dwyrain",
        "ekialdeko",
        "తూర్పు",
        "hahake",
        "Ланка",
        "Конг",
        "द्वीप",
        "Oileáin",
        "indonezijsko",
        "Чуук",
        "Kusini",
        "Kiangazi",
        "аралдарынын",
        "Länsi",
        "Jojia",
        "දිවාආලෝක",
        "නැගෙනහිර",
        "geassiáigi",
        "dábálašáigi",
        "Туркмения",
        "Самарское",
        "время*",
        "Кызылорда",
        "Северо",
        "Fidži",
        "Kanlurang",
        "Камчатский",
        "алеутское",
        "Istočni",
        "Гавайско",
        "டி",
        "ஜார்ஜியா",
        "Фолклендские",
        "О",
        "SHBA",
        "Восточный",
        "amerikane",
        "Արևմտյան",
        "Азорские",
        "Атлантическое",
        "Bregut",
        "Аравия",
        "Paqësorit",
        "Саудовская",
        "Актобе",
        "Актау",
        "Анадырь",
        "Argjentinës",
        "شەرقىي",
        "Đông",
        "ئاراللىرى",
        "Aleutiano",
        "Petropavlovsko",
        "(США)",
        "Горное",
        "Ата",
        "Алма",
        "Южная",
        "планинско",
        "Արևելյան",
        "Pacifico",
        "Акри",
        "zona",
        "în",
        "Centrale",
        "Vakarų",
        "Бруней",
        "Νέας",
        "dell’Argentina",
        "Дюмон",
        "G‘arbiy",
        "гӀ",
        "Малхбузен",
        "Austrais",
        "Малхбален",
        "Terras",
        "Günbatar",
        "Iakutsk",
        "Tajiquistão",
        "Salomão",
        "dhe",
        "Tími",
        "Grenlandës",
        "Reunião",
        "Kizilorda",
        "Pjer",
        "Guiné",
        "Noronja",
        "Malásia",
        "Quirguistão",
        "meksičko",
        "Korejsko",
        "Japansko",
        "Izraelsko",
        "Oceano",
        "Índia",
        "Батыс",
        "Zapadnoevropsko",
        "Istočnoevropsko",
        "Equador",
        "d’Alaska",
        "Butão",
        "Afeganistão",
        "পশ্চিমি",
        "Arabijsko",
        "Hau",
        "Јекатеринбург",
        "kamčatsko",
        "Aleutianes",
        "den",
        "Европӕйаг",
        "ڈےلایِٔٹ",
        "Нови",
        "d’Irkutsk",
        "Маурицијус",
        "d’Israel",
        "Хов",
        "Verãu",
        "Шри",
        "Корејско",
        "казахстанско",
        "Ɣetoɖoƒe",
        "камчатско",
        "Петропавловско",
        "Јапанско",
        "Иркуцк",
        "Индијско",
        "ইউরোপের",
        "oroli",
        "Хавајско",
        "Гуам",
        "Западни",
        "Κεντρικής",
        "இந்தோனேசிய",
        "Фолкландска",
        "Russisk",
        "Средњеевропско",
        "Ускршња",
        "sentralaustralsk",
        "Кукова",
        "Азори",
        "Арабијско",
        "Istočno",
        "Акутобе",
        "Акватау",
        "Алмати",
        "Filipines",
        "یورپ",
        "آئلینڈ",
        "நியூ",
        "Аљаска",
        "Yevropa",
        "Апија",
        "Атлантско",
        "Selatan",
        "Iarthar",
        "दक्षिण",
        "Markiz",
        "Natal",
        "по",
        "Gʻarbiy",
        "Ear",
        "سنٹرل",
        "Reter",
        "കിഴക്കൻ",
        "ദ്വീപുകൾ",
        "Зүүн",
        "Ekvador",
        "Баруун",
        "aleutsko",
        "наш",
        "Butan",
        "बेटे",
        "ብርሃን",
        "ደሴቶች",
        "Quần",
        "Острво",
        "острво",
        "Islles",
        "దీవుల",
        "Illas",
        "Seicheles",
        "Gündogar",
        "Britânica",
        "a’",
        "Тимор",
        "ᎠᏰᏟ",
        "ᎠᏟᎢᎵᏍᏒᎩ",
        "Šiaurės",
        "chuẩn",
        "ಪೂರ್ವ",
        "Pitkern",
        "Trung",
        "აღმოსავლეთ",
        "افریقا",
        "ороллари",
        "Wostok",
        "Antárcticas",
        "tokelau",
        "द्वीपसमूह",
        "fakaʻamelika",
        "දුපත්",
        "Aleut",
        "turkmensk",
        "Маккуори",
        "费尔南多",
        "Шарқий",
        "Kap",
        "japansk",
        "kinesisk",
        "افریقہ",
        "Papoea",
        "न्यू",
        "Кокос",
        "а",
        "Azor",
        "стандартон",
        "Itä",
        "कुक",
        "彼得罗巴甫洛夫斯克",
        "l’Amazones",
        "দ্বীপ",
        "Түндүк",
        "पूर्व",
        "muntanya",
        "Standardno",
        "Ekaterinburg",
        "Батыш",
        "Моусон",
        "àrab",
        "ostrvima",
        "Уэйк",
        "d’Armènia",
        "l’Atlàntic",
        "sing",
        "okeani",
        "Гвинея",
        "pakistansk",
        "d’Azerbaidjan",
        "сӕрдыгон",
        "Bangla",
        "Таити",
        "ostrovov",
        "Desh",
        "टापू",
        "iransk",
        "Венесуэла",
        "Canolbarth",
        "Britse",
        "Verd",
        "Xile",
        "Xina",
        "Aleutine",
        "Gogledd",
        "Colòmbia",
        "l’illa",
        "yr",
        "Солтүстік",
        "Ierse",
        "filippinsk",
        "Kazakistan",
        "مرکزی",
        "Ynys",
        "گرین",
        "Ynysoedd",
        "מזרח",
        "kelet",
        "Αφρικής",
        "Северноамериканско",
        "va",
        "Indijsko",
        "नोरोन्हा",
        "ᏚᎦᏚᏛᎢ",
        "Галапагос",
        "ओम्स्क",
        "аралдарының",
        "Malvines",
        "Гилберт",
        "Almati",
        "chilensk",
        "표준",
        "আফ্রিকা",
        "peruansk",
        "प्रमाणवेळ",
        "l’est",
        "දහවල්",
        "Africii",
        "Japó",
        "Kamtxatka",
        "Yangi",
        "Կենտրոնական",
        "מרכז",
        "samoansk",
        "Maurici",
        "colombiansk",
        "oest",
        "bangladeshisk",
        "d’Ulan",
        "Даруссалам",
        "пацифичко",
        "Јерменија",
        "Νησιού",
        "Nieu",
        "Зеленортска",
        "vest",
        "ცენტრალური",
        "نیو",
        "Caledònia",
        "Северозападни",
        "Мексички",
        "Пацифик",
        "ದ್ವೀಪಗಳ",
        "Тајпеј",
        "Irkuck",
        "ਗਰਮੀ",
        "ਰੁੱਤ",
        "georgisk",
        "l’Uruguai",
        "Ida",
        "Kesk",
        "l’Uzbekistan",
        "Vanatu",
        "अफ्रिकी",
        "d’Ekaterinburg",
        "جنوبی",
        "Юккъера",
        "Folklend",
        "جزیرهٔ",
        "ئوتتۇرا",
        "Кук",
        "loto",
        "Zeland",
        "uruguayansk",
        "මධ්‍යම",
        "Meadhan",
        "Pier",
        "арлын",
        "koreansk",
        "Гвиана",
        "Tajpej",
        "paraguayansk",
        "Ziit",
        "ostrovů",
        "Frans",
        "Franse",
        "Ирландия",
        "Nước",
        "կղզու",
        "వెలుతురు",
        "Indonezisë",
        "Austur",
        "Rotera",
        "Малайзия",
        "ja",
        "Сёва",
        "આઇલેન્ડ્સ",
        "Gvajana",
        "Боливия",
        "પશ્ચિમી",
        "ઉત્તર",
        "મધ્ય",
        "erdialdeko",
        "Дейвис",
        "Ниуе",
        "Verder",
        "Питкерн",
        "Шығыс",
        "isole",
        "Островах",
        "dell’Indonesia",
        "വേനൽക്കാല",
        "Inizi",
        "Oileán",
        "Arab",
        "Oirthear",
        "Nya",
        "och",
        "Косрае",
        "Чаморро",
        "Эквадор",
        "Гайана",
        "Мьянма",
        "Ниуэ",
        "Реюньон",
        "Silangang",
        "Уоллис",
        "Sentral",
        "Австрали",
        "Gruzija",
        "Kirgistan",
        "közép",
        "Αργεντινής",
        "የአውስትራሊያ",
        "ausztráliai",
        "Joto",
        "Dương",
        "MYT",
        "szigeti",
        "Muda",
        "Stillehavskysten",
        "θερινή",
        "χειμερινή",
        "Awstraliýa",
        "nordamerikanske",
        "argentinsko",
        "र",
        "središnje",
        "ग्रीनल्यान्डको",
        "Kukova",
        "तुर्कमेनिस्तान",
        "Zapadni",
        "Úc",
        "टोंगा",
        "Ավստրալիայի",
        "American",
        "Kolumbija",
        "उलान",
        "d’Australia",
        "Alyaska",
        "Tanjung",
        "Cile",
        "Sakit",
        "Okean",
        "चिली",
        "केप",
        "Braziliya",
        "kazahstansko",
        "केंद्रीय",
        "अमेरिकी",
        "उत्तरी",
        "Çin",
        "Çoybalsan",
        "Kolumbiya",
        "Pasxa",
        "Fransız",
        "və",
        "Hov",
        "Laut",
        "Qrenlandiya",
        "Filipina",
        "Ostrvo",
        "Arjantin",
        "İran",
        "İrkutsk",
        "İsrail",
        "Ástralíu",
        "Yaponiya",
        "Koreya",
        "ve",
        "Grönland",
        "မြောက်အမေရိက",
        "Kaledoniya",
        "Zelandiya",
        "யேகாடெரின்பர்க்",
        "யகுட்ஸ்க்",
        "வோல்கோக்ராட்",
        "விளாடிவோஸ்டோக்",
        "miền",
        "வனுவாட்டு",
        "உஸ்பெகிஸ்தான்",
        "ಉತ್ತರ",
        "ಅಮೆರಿಕದ",
        "உருகுவே",
        "துர்க்மெனிஸ்தான்",
        "ಆಸ್ಟ್ರೇಲಿಯಾದ",
        "Nyufaundlend",
        "Noronya",
        "Filippin",
        "டோங்கா",
        "Mauricijus",
        "தாய்பே",
        "Мексика",
        "Saxalin",
        "Austraalia",
        "אוסטרליה",
        "சமோவா",
        "சமரா",
        "சகலின்",
        "Severozapadni",
        "Hindi",
        "Kaledonija",
        "Аўстраліі",
        "вострава",
        "Meksički",
        "і",
        "Pacifik",
        "Novi",
        "Njufaundlend",
        "अर्जेनटिनी",
        "Paragvaj",
        "Filipini",
        "Waqtiyada",
        "Jakutski",
        "આઇલેન્ડ",
        "Чаморо",
        "Пхеньян",
        "ઓસ્ટ્રેલિયન",
        "태평양",
        "아르헨티나",
        "sewjeroameriski",
        "ostrvo",
        "અમેરિકન",
        "Grenlandiya",
        "Omski",
        "Čojbalsan",
        "그린란드",
        "Острови",
        "Čile",
        "멕시코",
        "Čatam",
        "Krasnojarski",
        "Irkutski",
        "آسٹریلِیَن",
        "Zelenortska",
        "Brazilija",
        "Avstralski",
        "Bangladeš",
        "Azori",
        "Ipar",
        "Amerikako",
        "čas:",
        "Понапе",
        "Zigg",
        "অঞ্চলের",
        "দিনের",
        "প্রশান্ত",
        "g‘arbiy",
        "Azerbejdžan",
        "মহাসাগরীয়",
        "গৃষ্মকালীন",
        "pacifiski",
        "Tinch",
        "Atlantsko",
        "Pódpołnocnoameriski",
        "Чыгыш",
        "Insel",
        "Norteamérica",
        "Osidental",
        "північноамериканським",
        "Μεξικού",
        "Tadschikistan",
        "ऑस्ट्रेलियन",
        "Jermenija",
        "Seychellen",
        "গ্রীনল্যান্ড",
        "Urugvaj",
        "ਅਫਰੀਕਾ",
        "Шимолий",
        "Astràilia",
        "ਪੈਸਿਫਿਕ",
        "ਅਰਜਨਟੀਨਾ",
        "Австралийн",
        "Марказий",
        "эргийн",
        "Төв",
        "ਅਤੇ",
        "وسطی",
        "ਗ੍ਰੀਨਲੈਂਡ",
        "സെൻട്രൽ",
        "അമേരിക്കൻ",
        "വടക്കെ",
        "Zapadna",
        "ایسٹرن",
        "கைஜைலோர்டா",
        "மிக்குயிலான்",
        "پیسفک",
        "பியரி",
        "செயின்ட்",
        "பிலிப்பைன்",
        "ارجنٹینا",
        "آرژانتین",
        "பெரு",
        "பராகுவே",
        "ویسٹرن",
        "Akutobe",
        "பாகிஸ்தான்",
        "Akvatau",
        "برازیلیا",
        "ஓம்ஸ்க்",
        "நோவோசிபிரிஸ்க்",
        "நோரோன்ஹா",
        "Kolombia",
        "Apija",
        "hAstráile",
        "چین",
        "பெர்னான்டோ",
        "நியூஃபவுண்ட்லாந்து",
        "Macquarieinsel",
        "Kaledonia",
        "Aljaska",
        "நியூசிலாந்து",
        "Австралија",
        "Futunase",
        "கலிடோனியா",
        "ओस्ट्रेलिया",
        "Chuukse",
        "Tadzjiekse",
        "மாஸ்கோ",
        "Singaporese",
        "Kirgisistan",
        "Seychelse",
        "და",
        "گرینلند",
        "ავსტრალიის",
        "Réunionse",
        "ამერიკის",
        "ჩრდილოეთ",
        "பாடர்",
        "Belause",
        "ایران",
        "Niuese",
        "اسرائیل",
        "Nepalese",
        "हवाई",
        "Ozean",
        "Myanmarese",
        "உலன்",
        "மெக்ஸிகன்",
        "மெக்ஸிகோ",
        "Kosraese",
        "شمال",
        "مکزیک",
        "வடமேற்கு",
        "Centralno",
        "Oceaan",
        "மொரிஷியஸ்",
        "Guamese",
        "மகதன்",
        "Akre",
        "மக்காவ்",
        "ஹோவ்",
        "லார்ட்",
        "اومسک",
        "پاکستان",
        "க்ரஸ்னோயார்ஸ்க்",
        "Süd",
        "Timorese",
        "halve",
        "கொரிய",
        "اور",
        "Osttimor",
        "Bruneise",
        "Australyske",
        "Pasifiki",
        "Кина",
        "கஜகஸ்தான்",
        "கம்சட்ஸ்கி",
        "Atlantiki",
        "ازبکستان",
        "Azeribaijani",
        "Uchina",
        "Ore",
        "பெட்ரோபவ்லோவ்ஸ்க்",
        "ஜப்பான்",
        "இஸ்ரேல்",
        "இர்குட்ஸ்க்",
        "ஈரான்",
        "Fernandu",
        "Keski",
        "severoamerický",
        "Wyspy",
        "salas",
        "Pasaka",
        "fakaʻaositelēlia",
        "Ufaransa",
        "Austrālijas",
        "atlantsko",
        "Israeli",
        "Kaskazini",
        "mchana",
        "pasifiki",
        "Kinesko",
        "Ufilipino",
        "அக்ரே",
        "Srednjeevropsko",
        "Γροιλανδίας",
        "Indokina",
        "Sentraal",
        "ඇමරිකානු",
        "උතුරු",
        "д’Юрвиль",
        "Oostelike",
        "அலாஸ்கா",
        "Гамбье",
        "அல்மாடி",
        "அமேசான்",
        "και",
        "மவுன்டைன்",
        "Australijos",
        "அனாடையர்",
        "Arabisk",
        "ஏபியா",
        "அட்டௌ",
        "அட்டோபே",
        "அரேபிய",
        "प्यासिफिक",
        "Pasifiese",
        "ஆர்மேனிய",
        "Питкэрн",
        "Argentinië",
        "Gitnang",
        "Westelike",
        "Bangladesj",
        "ᎡᎳᏗᏜ",
        "Amerikos",
        "Rytų",
        "Uskršnja",
        "அட்லாண்டிக்",
        "Australya",
        "Argentinei",
        "அசர்பைஜான்",
        "வங்கதேச",
        "பிரேசிலியா",
        "கேப்",
        "வெர்டே",
        "சத்தாம்",
        "சிலி",
        "Severoamerický",
        "Awstralia",
        "Vest",
        "சீன",
        "și",
        "சோய்பால்சன்",
        "Folklandska",
        "Franceze",
        "Groenlandei",
        "Noii",
        "கொலம்பியா",
        "குக்",
        "கியூபா",
        "ஹோவ்த்",
        "ஈஸ்டர்",
        "ஹாங்காங்",
        "Kina",
        "ஃபாக்லாந்து",
        "ஃபிஜி",
        "கயானா",
        "அலேஷியன்",
        "ஹவாய்",
        "Mið",
        "Franska",
        "grønlendsk",
        "Eystur",
        "യൂറോപ്യൻ",
        "Георгия",
        "ᏳᎳᏈ",
        "ᎤᎦᏚᏛᎢ",
        "Таджикистан",
        "Индокитай",
        "යුරෝපීය",
        "Europos",
        "Euroopan",
        "Nowa",
        "Валис",
        "Вејк",
        "Венецуела",
        "Трук",
        "Таџикистан",
        "Тахити",
        "Јужна",
        "Сејшели",
        "Гвинеја",
        "Северна",
        "Мосон",
        "Маркиз",
        "Малдиви",
        "Малезија",
        "Индия",
        "Индокина",
        "чыгыш",
        "антарктичко",
        "јужно",
        "Француско",
        "Zentralafrikanische",
        "Ostafrikanische",
        "Südafrikanische",
        "Aserbeidschanische",
        "Француска",
        "Aserbaidschanische",
        "Еквадор",
        "Bolivianische",
        "Димон",
        "Дејвис",
        "Weihnachtsinsel",
        "Kokosinseln",
        "Боливија",
        "Ecuadorianische",
        "Kaliningrader",
        "Französisch",
        "Französische",
        "Antarktisgebiete",
        "Inseln",
        "Mittlere",
        "जॉर्जिया",
        "भारतीय",
        "Indischer",
        "Zentralindonesische",
        "Ostindonesische",
        "Westindonesische",
        "Ostkasachische",
        "ოკეანის",
        "Westkasachische",
        "Linieninseln",
        "ევროპის",
        "ईस्टर्न",
        "Malaysische",
        "Antarktika",
        "Stáisiún",
        "Malediven",
        "hEorpa",
        "Marshallinseln",
        "Nepalesische",
        "Norfolkinsel",
        "Nördliche",
        "Marianen",
        "Ewrop",
        "Neuguinea",
        "Phoenixinseln",
        "Pitcairninseln",
        "Европын",
        "Pjöngjang",
        "Quysylorda",
        "Tuath",
        "Qysylorda",
        "Roinn",
        "Eòrpa",
        "Salomoninseln",
        "Südgeorgische",
        "Uruguyanische",
        "Uruguayanische",
        "Venezolaanse",
        "Tuvaluaanse",
        "Tahitiaanse",
        "Афганистан",
        "Surinaamse",
        "Salomonseilandse",
        "Pitcairneilandse",
        "Phoenixeilandse",
        "Шова",
        "zahodni",
        "Zentraal",
        "Guineese",
        "залив",
        "مغرِبی",
        "час:",
        "Mariaanse",
        "Noordelijk",
        "Еуропа",
        "Norfolkeilandse",
        "ئاۋسترالىيە",
        "ئوكيان",
        "ಯುರೋಪಿಯನ್",
        "saarte",
        "Nauruaanse",
        "Marshalleilandse",
        "Marquesaseilandse",
        "ದಿನದ",
        "Maldivische",
        "Maleisische",
        "Kirgizische",
        "Indochinese",
        "Indiase",
        "Gilberteilandse",
        "Gambiereilandse",
        "Galapagoseilandse",
        "Antarctische",
        "Eropa",
        "zuidelijke",
        "oostelijk",
        "यूरोपीय",
        "Ecuadoraanse",
        "Cocoseilandse",
        "Christmaseilandse",
        "Boliviaanse",
        "Bhutaanse",
        "యూరోపియన్",
        "उत्तर",
        "oeste",
        "Âu",
        "Irische",
        "Britische",
        "Afghaanse",
        "új",
        "Ýewropa",
        "SGT",
        "óceáni",
        "fakaʻeulope",
        "बेट",
        "França",
        "mexikansk",
        "eilânske",
        "Авганистан",
        "ماگادان",
        "nordvästmexikansk",
        "israelisk",
        "Europeu",
        "Jakutsko",
        "Valis",
        "Vejk",
        "गुयाना",
        "اندونزی",
        "वेस्टर्न",
        "Галапагосские",
        "Pjongjanško",
        "Omsko",
        "Chovd",
        "Honolulu",
        "यूरोप",
        "კუნძულის",
        "västgrönländsk",
        "कोलंबिया",
        "Novosibirsko",
        "östgrönländsk",
        "Marijanska",
        "अरबी",
        "Severna",
        "अमरिका",
        "Guyanatid",
        "Falklandsöarna",
        "Lár",
        "västeuropeisk",
        "पश्चीम",
        "östeuropeisk",
        "Ljetno",
        "centraleuropeisk",
        "Påskön",
        "kubansk",
        "Киргистан",
        "Lajn",
        "Cooköarnas",
        "Krasnojarsko",
        "Tjojbalsan",
        "azorisk",
        "azerbajdzjansk",
        "västaustralisk",
        "östaustralisk",
        "västcentralaustralisk",
        "centralaustralisk",
        "Сент",
        "Kamčatski",
        "Irkutsko",
        "nordamerikansk",
        "armenisk",
        "västargentinsk",
        "östargentinsk",
        "saudiarabisk",
        "Zalivsko",
        "västnordamerikansk",
        "bergen",
        "Klippiga",
        "Французские",
        "ເວລາ",
        "dell’Uzbekistan",
        "Nordamerikanesch",
        "Французская",
        "Yhdysvaltain",
        "dell’Uruguay",
        "ਨਿਊ",
        "östnordamerikansk",
        "Filippine",
        "Perù",
        "ਜਾਰਜੀਆ",
        "Минское",
        "centralnordamerikansk",
        "ਆਈਲੈਂਡਸ",
        "Mosca",
        "västafrikansk",
        "полулетнее",
        "Кокосовые",
        "ਮੱਧ",
        "Рождества",
        "নিউ",
        "Кейси",
        "mexický",
        "Aimeireaga",
        "Џорџија",
        "ਦੱਖਣੀ",
        "Chuain",
        "(Messico)",
        "Messico",
        "Гилберта",
        "västbrasiliansk",
        "ইন্দোনেশিয়া",
        "Eilean",
        "Соломонска",
        "Indoneziei",
        "coreana",
        "ороли",
        "Giappone",
        "Israele",
        "dell’Iran",
        "Реинион",
        "জর্জিয়া",
        "Среднее",
        "Южные",
        "इस्टर",
        "Маријанска",
        "Figi",
        "युरोपियन",
        "Georgiei",
        "फिजी",
        "Мијанмар",
        "Гринвичу",
        "Janubiy",
        "Маршалска",
        "बाटोर",
        "стандарное",
        "Персидский",
        "Europpa",
        "আর্জেনটিনা",
        "Insulele",
        "Кошре",
        "Argentinski",
        "Summerzick",
        "Zick",
        "Azore",
        "Индийский",
        "প্রমাণ",
        "দক্ষিণ",
        "মধ্য",
        "Cina",
        "Capo",
        "Insula",
        "ماسکو",
        "океанско",
        "aleutski",
        "Azzorre",
        "کیپ",
        "dell’Azerbaigian",
        "centroccidentale",
        "Weschtafrikanischi",
        "Afganistan",
        "Mitteleuropäischi",
        "Oschteuropäischi",
        "Weschteuropäischi",
        "Западный",
        "انڈونیشیا",
        "Orientale",
        "Centrinės",
        "орталық",
        "인도네시아",
        "борбордук",
        "유럽",
        "Атлантика",
        "Gujana",
        "dell’Atlantico",
        "dell’Armenia",
        "аралдары",
        "Indoneziya",
        "ᎢᏤ",
        "және",
        "Ejkrit",
        "araba",
        "тихоокеанско",
        "Rocciose",
        "Montagne",
        "Киргизия",
        "dell’Amazzonia",
        "dell’Alaska",
        "[Ako]",
        "ياۋروپا",
        "Jugore",
        "Ísrael",
        "станцыі",
        "Kasakstan",
        "Euroopa",
        "جارجیا",
        "Pergunungan",
        "Паўночнаамерыканскі",
        "Perancis",
        "Мальдивы",
        "Jepun",
        "Venesuela",
        "Маркизские",
        "Almatit",
        "קיץ",
        "Amazonës",
        "Brezit",
        "Malor",
        "Aktöbe",
        "ದ್ವೀಪ",
        "Anadirit",
        "Apias",
        "Антарктические",
        "Aktaut",
        "тимор",
        "Aktobit",
        "arabe",
        "д’Урвил",
        "Armenisë",
        "Atlantikut",
        "אירופה",
        "Qendroro",
        "Azerbajxhanit",
        "Azoreve",
        "Bangladeshit",
        "Brasilës",
        "Kepit",
        "Gjelbër",
        "Katamit",
        "Evrópu",
        "Endonezya",
        "Kilit",
        "Маршалловы",
        "Kinës",
        "အလယ်ပိုင်း",
        "Северные",
        "полу",
        "Çoibalsanit",
        "Kolumbisë",
        "మధ్యమ",
        "Kubës",
        "Lindor",
        "Pashkës",
        "Fixhit",
        "İndoneziya",
        "Guajanës",
        "(Келинг)",
        "Gjeorgjisë",
        "تونگا",
        "Hauai",
        "Kongut",
        "Hovdit",
        "Iranit",
        "Güney",
        "Irkutskut",
        "Izraelit",
        "Japonisë",
        "Petropavllovsk",
        "Kamçatkës",
        "Çili",
        "Марианские",
        "Кинеско",
        "Kazakistanit",
        "koreane",
        "Krasnojarskut",
        "Houit",
        "Понпеи",
        "Makaos",
        "Дарусалум",
        "Брунеј",
        "ऑस्‍ट्रेलियाई",
        "Kep.",
        "Magadanit",
        "Mauritiusit",
        "चीन",
        "سامارا",
        "Meksikës",
        "Veriperëndimore",
        "Сейшельские",
        "Eysturevropa",
        "meksikane",
        "Batorit",
        "Moskës",
        "Cənubi",
        "Соломоновы",
        "Marqueses",
        "gaska",
        "nuorti",
        "इंडोनेशिया",
        "जापान",
        "Islla",
        "Kaledonisë",
        "oarje",
        "దీవి",
        "Europeeske",
        "දූපත්",
        "मागादान",
        "Јужно",
        "मेक्सिको",
        "मेक्सिकन",
        "Zelandës",
        "Եվրոպայի",
        "гӀайренаш",
        "डे",
        "Njufaundlendit",
        "[Tokës",
        "территории",
        "esase",
        "uzbekisk",
        "نو",
        "S:t",
        "Re]",
        "Noronjës",
        "उरुग्वे",
        "Novosibirskut",
        "इन्डोनेशिया",
        "Omskut",
        "Великобритания",
        "जर्जिया",
        "Pakistanit",
        "Paraguait",
        "አውሮፓ",
        "vestafrikansk",
        "Amazonka",
        "Perusë",
        "Filipineve",
        "Ermenistan",
        "Atlantika",
        "Shën",
        "पेरु",
        "Mikuelon",
        "Bangladeş",
        "Kabo",
        "nyzeeländsk",
        "Fransuz",
        "Kaledonien",
        "Brunej",
        "Gonkong",
        "európai",
        "Kizilordit",
        "Sakalinit",
        "Samarës",
        "vestaustralsk",
        "Samoas",
        "stillahavstid",
        "የምዕራባዊ",
        "sentraleuropeisk",
        "østeuropeisk",
        "vesteuropeisk",
        "Tajpeit",
        "Tongës",
        "Kazakstan",
        "Indonesië",
        "antarktičko",
        "Türkmenistan",
        "Özbekistan",
        "Georgië",
        "havajsko",
        "Turkmenistanit",
        "Uruguait",
        "Uzbekistanit",
        "Vanuatusë",
        "Vladivostokut",
        "sentrale",
        "sentraal",
        "Volgogradit",
        "Jakutskut",
        "Ekaterinburgut",
        "Γεωργίας",
        "Ινδονησίας",
        "पाकिस्तान",
        "Филиппин",
        "मॉस्को",
        "Nove",
        "l’oceà",
        "Índic",
        "d’Indoxina",
        "Newydd",
        "Янги",
        "留尼汪时间",
        "克孜洛尔达夏令时间",
        "malaysisk",
        "Централна",
        "Berriko",
        "克孜洛尔达标准时间",
        "Nij",
        "吉尔吉斯斯坦时间",
        "乌兹别克斯坦夏令时间",
        "Kirguizistan",
        "平壤时间",
        "Malàisia",
        "波纳佩时间",
        "克拉斯诺亚尔斯克夏令时间",
        "克拉斯诺亚尔斯克标准时间",
        "科斯雷时间",
        "韩国夏令时间",
        "韩国标准时间",
        "哈萨克斯坦西部时间",
        "Британија",
        "哈萨克斯坦东部时间",
        "堪察加夏令时间",
        "皮特凯恩时间",
        "Reunió",
        "圣皮埃尔和密克隆群岛夏令时间",
        "Salomó",
        "圣皮埃尔和密克隆群岛标准时间",
        "堪察加标准时间",
        "菲尼克斯群岛时间",
        "hAfraice",
        "Bắc",
        "日本夏令时间",
        "Veneçuela",
        "Aigéin",
        "ახალი",
        "日本标准时间",
        "以色列夏令时间",
        "戴维斯时间",
        "古巴夏令时间",
        "आफ्रिका",
        "අප්‍රිකානු",
        "Francuska",
        "迪蒙迪尔维尔时间",
        "以色列标准时间",
        "菲律宾夏令时间",
        "菲律宾标准时间",
        "indisk",
        "伊尔库茨克夏令时间",
        "伊尔库茨克标准时间",
        "秘鲁夏令时间",
        "දිවා",
        "伊朗标准时间",
        "Čamoro",
        "乌兹别克斯坦标准时间",
        "印度尼西亚西部时间",
        "秘鲁标准时间",
        "巴拉圭夏令时间",
        "古巴标准时间",
        "乌拉圭夏令时间",
        "印度尼西亚东部时间",
        "印度尼西亚中部时间",
        "印度支那时间",
        "巴拉圭标准时间",
        "库克群岛仲夏时间",
        "库克群岛标准时间",
        "哥伦比亚夏令时间",
        "哥伦比亚标准时间",
        "巴布亚新几内亚时间",
        "жана",
        "科科斯群岛时间",
        "帕劳时间",
        "印度洋时间",
        "印度时间",
        "科布多夏令时间",
        "巴基斯坦夏令时间",
        "科布多标准时间",
        "Nua",
        "agus",
        "圣诞岛时间",
        "აფრიკის",
        "मार्शल",
        "乔巴山夏令时间",
        "乔巴山标准时间",
        "中国夏令时间",
        "中国标准时间",
        "Afraga",
        "香港夏令时间",
        "智利夏令时间",
        "智利标准时间",
        "查坦夏令时间",
        "乌拉圭标准时间",
        "查坦标准时间",
        "查莫罗时间",
        "h",
        "昭和基地時間",
        "图瓦卢时间",
        "香港标准时间",
        "凯西时间",
        "Maldive",
        "巴基斯坦标准时间",
        "鄂木斯克夏令时间",
        "Божићно",
        "даљи",
        "исток",
        "Европе",
        "阿留申夏令时间",
        "Гамбије",
        "Средње",
        "Гриничу",
        "okeāna",
        "鄂木斯克标准时间",
        "阿留申标准时间",
        "Заливско",
        "Лајн",
        "Nuaidh",
        "Маквери",
        "східним",
        "佛得角夏令时间",
        "佛得角标准时间",
        "文莱达鲁萨兰时间",
        "巴西利亚夏令时间",
        "Понпеј",
        "Пјонгјаншко",
        "巴西利亚标准时间",
        "ویک",
        "圭亚那时间",
        "Illa",
        "新西伯利亚夏令时间",
        "新西伯利亚标准时间",
        "Керла",
        "土库曼斯坦夏令时间",
        "海湾标准时间",
        "北马里亚纳群岛时间",
        "Afrikan",
        "关岛时间",
        "玻利维亚标准时间",
        "迪诺罗尼亚岛夏令时间",
        "格陵兰岛西部夏令时间",
        "Шинэ",
        "格陵兰岛西部标准时间",
        "不丹时间",
        "孟加拉夏令时间",
        "孟加拉标准时间",
        "格陵兰岛东部夏令时间",
        "रोथेरा",
        "迪诺罗尼亚岛标准时间",
        "afghansk",
        "格陵兰岛东部标准时间",
        "亚速尔群岛夏令时间",
        "格林尼治标准时间",
        "吉尔伯特群岛时间",
        "诺福克岛时间",
        "亚速尔群岛标准时间",
        "格鲁吉亚夏令时间",
        "格鲁吉亚标准时间",
        "ᎬᎿᎨᏍᏛ",
        "甘比尔时间",
        "加拉帕戈斯时间",
        "法属南方和南极领地时间",
        "આફ્રિકા",
        "પૂર્વ",
        "法属圭亚那标准时间",
        "પશ્ચિમ",
        "斐济夏令时间",
        "Uuden",
        "斐济标准时间",
        "福克兰群岛夏令时间",
        "福克兰群岛标准时间",
        "Naujosios",
        "vandenyno",
        "西欧夏令时间",
        "阿塞拜疆夏令时间",
        "阿塞拜疆标准时间",
        "澳大利亚西部夏令时间",
        "યુરોપિયન",
        "يېڭى",
        "澳大利亚西部标准时间",
        "澳大利亚东部夏令时间",
        "澳大利亚东部标准时间",
        "土库曼斯坦标准时间",
        "澳大利亚中西部夏令时间",
        "楚克时间",
        "澳大利亚中西部标准时间",
        "澳大利亚中部夏令时间",
        "澳大利亚中部标准时间",
        "大西洋夏令时间",
        "ئارىلى",
        "大西洋标准时间",
        "纽埃时间",
        "亚美尼亚夏令时间",
        "亚美尼亚标准时间",
        "阿根廷西部夏令时间",
        "阿根廷西部标准时间",
        "rytų",
        "אפריקה",
        "阿根廷夏令时间",
        "阿根廷标准时间",
        "阿拉伯夏令时间",
        "阿拉伯标准时间",
        "纽芬兰夏令时间",
        "阿克托别夏令时间",
        "汤加夏令时间",
        "האי",
        "阿克托别标准时间",
        "далайн",
        "阿克套夏令时间",
        "האיים",
        "阿克套标准时间",
        "阿皮亚夏令时间",
        "阿皮亚标准时间",
        "阿纳德尔夏令时间",
        "ئافرىقا",
        "阿纳德尔标准时间",
        "汤加标准时间",
        "北美太平洋夏令时间",
        "北美太平洋标准时间",
        "北美山区夏令时间",
        "北美山区标准时间",
        "北美东部夏令时间",
        "北美东部标准时间",
        "北美中部夏令时间",
        "Bình",
        "北美中部标准时间",
        "亚马逊夏令时间",
        "托克劳时间",
        "亚马逊标准时间",
        "阿拉木图夏令时间",
        "阿拉木图标准时间",
        "阿拉斯加夏令时间",
        "阿拉斯加标准时间",
        "西部非洲夏令时间",
        "ఆఫ్రికా",
        "西部非洲标准时间",
        "南部非洲时间",
        "东部非洲时间",
        "中部非洲时间",
        "阿富汗时间",
        "阿克里夏令时间",
        "阿克里标准时间",
        "塔吉克斯坦时间",
        "Afrikos",
        "Ирска",
        "台北夏令时间",
        "Африкийн",
        "台北标准时间",
        "Zachodnia",
        "塔希提岛时间",
        "英国夏令时间",
        "semini",
        "纽芬兰标准时间",
        "venezuelansk",
        "Affrekaanesche",
        "西欧标准时间",
        "新西兰夏令时间",
        "爱尔兰标准时间",
        "ڑےلایِٔٹ",
        "昭和时间",
        "ദ്വീപ്",
        "新西兰标准时间",
        "अफ़्रीका",
        "ججیٖرُک",
        "Standardni",
        "新喀里多尼亚夏令时间",
        "Poletni",
        "یوٗرپی",
        "新喀里多尼亚标准时间",
        "尼泊尔时间",
        "瑙鲁时间",
        "ڈی",
        "苏里南时间",
        "远东标准时间",
        "ఆస్ట్రేలియా",
        "otoki",
        "东欧夏令时间",
        "缅甸时间",
        "莫斯科夏令时间",
        "乌兰巴托标准时间",
        "ecuadoriansk",
        "Standardní",
        "莫斯科标准时间",
        "东欧标准时间",
        "乌兰巴托夏令时间",
        "墨西哥太平洋夏令时间",
        "मध्‍य",
        "南乔治亚岛时间",
        "አፍሪካ",
        "所罗门群岛时间",
        "ደሴት",
        "新加坡标准时间",
        "塞舌尔时间",
        "Жаңа",
        "lejana",
        "萨摩亚夏令时间",
        "Mouson",
        "britànica",
        "Phi",
        "d’Irlanda",
        "የምስራቅ",
        "伊朗夏令时间",
        "叶卡捷琳堡夏令时间",
        "Enez",
        "Նոր",
        "叶卡捷琳堡标准时间",
        "Aafrika",
        "墨西哥太平洋标准时间",
        "雅库茨克夏令时间",
        "နွေရာသီစံတော်ချိန်",
        "ookeani",
        "墨西哥西北部夏令时间",
        "墨西哥西北部标准时间",
        "莫森时间",
        "毛里求斯夏令时间",
        "l’Afganistan",
        "毛里求斯标准时间",
        "boliviansk",
        "sud",
        "中欧夏令时间",
        "马绍尔群岛时间",
        "马克萨斯群岛时间",
        "Աֆրիկայի",
        "马尔代夫时间",
        "中欧标准时间",
        "bhutansk",
        "马来西亚时间",
        "Günorta",
        "马加丹夏令时间",
        "雅库茨克标准时间",
        "瓦利斯和富图纳时间",
        "马加丹标准时间",
        "厄瓜多尔标准时间",
        "威克岛时间",
        "麦夸里岛时间",
        "Француз",
        "沃斯托克时间",
        "澳门夏令时间",
        "萨摩亚标准时间",
        "萨马拉夏令时间",
        "伏尔加格勒夏令时间",
        "澳门标准时间",
        "伏尔加格勒标准时间",
        "Азор",
        "Uus",
        "海参崴夏令时间",
        "Hindistan",
        "Островите",
        "Kiritimati",
        "Täze",
        "海参崴标准时间",
        "Affrica",
        "豪勋爵岛夏令时间",
        "ಕೇಂದ್ರ",
        "mig",
        "Afrikaanske",
        "estiu",
        "豪勋爵岛标准时间",
        "复活节岛夏令时间",
        "l’Equador",
        "afrikai",
        "ဩစတြေးလျား",
        "Cefnfor",
        "委内瑞拉时间",
        "复活节岛标准时间",
        "ಆಫ್ರಿಕಾ",
        "萨马拉标准时间",
        "莱恩群岛时间",
        "东帝汶时间",
        "l’Extrem",
        "uharteko",
        "Orient",
        "Новай",
        "瓦努阿图夏令时间",
        "fakaʻafelika",
        "瓦努阿图标准时间",
        "兰卡时间",
        "የምዕራብ",
        "अफ्रीका",
        "Guaiana",
        "d’Antàrtida",
        "库页岛夏令时间",
        "库页岛标准时间",
        "indokinesisk",
        "Meridià",
        "罗瑟拉时间",
        "l’Índia",
        "阿拉斯加夏令時間",
        "moskovsko",
        "novozelandsko",
        "newfoundlandsko",
        "novosibirsko",
        "omsko",
        "pakistansko",
        "paragvajsko",
        "peruansko",
        "filipinsko",
        "Sveti",
        "Petar",
        "Kizilorde",
        "sahalinsko",
        "samarsko",
        "samoansko",
        "tajpeško",
        "Tonge",
        "turkmenistansko",
        "urugvajsko",
        "uzbekistansko",
        "Vanuatua",
        "vladivostočko",
        "volgogradsko",
        "jakutsko",
        "ekaterinburško",
        "batorsko",
        "ulan",
        "fakafonuamata",
        "Suid",
        "Čojbalsanski",
        "sjeverozapadno",
        "Mauricijusa",
        "fakaʻasenitina",
        "Magadanski",
        "magadansko",
        "pasifika",
        "mexiski",
        "makaosko",
        "krasnojarsko",
        "korejsko",
        "japansko",
        "izraelsko",
        "irkutsko",
        "iransko",
        "hovdsko",
        "hongkonško",
        "zapadnogrenlandsko",
        "istočnogrenlandsko",
        "gruzijsko",
        "Fidžija",
        "falklandsko",
        "zapadnoeuropsko",
        "istočnoeuropsko",
        "srednjoeuropsko",
        "Uskršnjeg",
        "चोइबाल्सन",
        "kubansko",
        "otočje",
        "államokbeli",
        "csendes",
        "kolumbijsko",
        "चाथाम",
        "choibalsansko",
        "kinesko",
        "čileansko",
        "Chathama",
        "भर्दे",
        "otočja",
        "és",
        "बंगलादेशी",
        "grönlandi",
        "Zelenortskog",
        "Grenlandiýa",
        "एजोरेस्",
        "we",
        "brazilijsko",
        "bangladeško",
        "adasy",
        "azorsko",
        "mexikói",
        "azerbajdžansko",
        "zapadnoaustralsko",
        "istočnoaustralsko",
        "australsko",
        "srednjoaustralsko",
        "armensko",
        "umman",
        "Ýuwaş",
        "arapsko",
        "Apije",
        "anadirsko",
        "amazonsko",
        "altmajsko",
        "aljaško",
        "zapadnoafričko",
        "अजरबैजान",
        "वेक",
        "व्लादिवोस्तोक",
        "ताहिती",
        "स्योवा",
        "Amasone",
        "सेंट",
        "Ամերիկայի",
        "Արգենտինայի",
        "पेरू",
        "गिनी",
        "नोवोसिबिर्स्क",
        "fakamekisikou",
        "և",
        "एट्लान्टिक",
        "Գրենլանդիայի",
        "अर्मेनिया",
        "Մեքսիկայի",
        "Sentrale",
        "मॉरीशस",
        "గ్రీన్‌ల్యాండ్",
        "आपिया",
        "మరియు",
        "होवे",
        "लॉर्ड",
        "लाइन",
        "Berg",
        "हिमाली",
        "अमेजन",
        "काँग",
        "हाँग",
        "ग्रीनलैंड",
        "Arabiese",
        "गिल्बर्ट",
        "और",
        "दक्षिणी",
        "अलस्काको",
        "क्यूबा",
        "Armenië",
        "Atlantiese",
        "Aserbeidjan",
        "अटलांटिक",
        "आर्मेनिया",
        "अर्जेंटीना",
        "Teluk",
        "vanuatisk",
        "प्रशांत",
        "Makau",
        "Almatı",
        "Moskwa",
        "Baru",
        "పసిఫిక్",
        "Dağ",
        "Anadır",
        "usbekisk",
        "Aktav",
        "Arabistan",
        "İçbatı",
        "Azerbaycan",
        "Azorlar",
        "Bandaríkjanna",
        "Kanada",
        "Kyrrahafssvæðinu",
        "Argentínu",
        "Asore",
        "Şili",
        "Kolombiya",
        "eyjum",
        "מקסיקו",
        "Küba",
        "Paskalya",
        "Brasilië",
        "Gürcistan",
        "tongansk",
        "Japonya",
        "సెంట్రల్",
        "גרינלנד",
        "Kamçatski",
        "Kore",
        "Kuzeybatı",
        "Kıyısı",
        "Grænlandi",
        "ஃப்யூடுனா",
        "மற்றும்",
        "வாலிஸ்",
        "Havaí",
        "வேக்",
        "வோஸ்டோக்",
        "Batur",
        "Kaap",
        "Moskova",
        "eyju",
        "வெனிசுலா",
        "Kaledonya",
        "Filipinler",
        "אי",
        "Mexíkó",
        "துவாலு",
        "Kızılorda",
        "(Samara)",
        "சுக்",
        "Colombië",
        "டோக்கெலாவ்",
        "தஜிகிஸ்தான்",
        "Cookeilande",
        "தஹிதி",
        "ஸ்யோவா",
        "சுரினாம்",
        "தெற்கு",
        "சாலமன்",
        "சிங்கப்பூர்",
        "சீசெல்ஸ்",
        "Paaseiland",
        "ארגנטינה",
        "Falklandeilande",
        "ארה״ב",
        "newzealandsk",
        "تىنچ",
        "kaledonsk",
        "ئارگېنتىنا",
        "ۋە",
        "گىرېنلاند",
        "meksikanske",
        "nordvestlige",
        "mauritisk",
        "مېكسىكا",
        "Aleusiër",
        "ગ્રીનલેન્ડ",
        "પૂર્વીય",
        "øya",
        "પેસિફિક",
        "પૂર્વી",
        "eiland",
        "Kamtsjatskij)",
        "(Petropavlovsk",
        "Noordwes",
        "israelsk",
        "Meksikaanse",
        "Zelandia",
        "Ulaanbatar",
        "Kaledonië",
        "Arxentina",
        "Khovd",
        "Aleutene",
        "тихоокеанським",
        "vestgrønlandsk",
        "Mheagsago",
        "østgrønlandsk",
        "Seeland",
        "fijiansk",
        "Falklandsøyene",
        "архіпелазі",
        "Guinee",
        "Filippynse",
        "Sint",
        "Påskeøya",
        "cubansk",
        "Cookøyene",
        "Oesbekistan",
        "Graonlainn",
        "Гренландії",
        "የመካከለኛው",
        "英國夏令時間",
        "Kapp",
        "愛爾蘭標準時間",
        "станції",
        "ምስራቃዊ",
        "Argantaine",
        "Sèimh",
        "Мексиці",
        "nOileán",
        "Iosrael",
        "asorisk",
        "aserbajdsjansk",
        "பிரிட்டிஷ்",
        "østaustralsk",
        "ஐரிஷ்",
        "الاسکا",
        "Graonlainne",
        "Uingereza",
        "ரோதேரா",
        "ரீயூனியன்",
        "atlanterhavskystlig",
        "பியாங்யாங்",
        "போனாபே",
        "பிட்கெய்ர்ன்",
        "ماؤنٹین",
        "انیدر",
        "ایپیا",
        "ஃபோனிக்ஸ்",
        "عرب",
        "آرمینیا",
        "اٹلانٹک",
        "கினியா",
        "பபுவா",
        "பாலவ்",
        "آذربائیجان",
        "armensk",
        "Sile",
        "மரினா",
        "வடக்கு",
        "ازوریس",
        "hAirgintíne",
        "நார்ஃபோக்",
        "நியு",
        "Chiúin",
        "بنگلہ",
        "دیش",
        "ورڈی",
        "நேபாள",
        "நவ்ரூ",
        "மியான்மர்",
        "چیتھم",
        "چلی",
        "کولمبیا",
        "کک",
        "کیوبا",
        "vestargentinsk",
        "மாசன்",
        "ایسٹر",
        "மார்ஷல்",
        "மார்கியூசாஸ்",
        "மாலத்தீவுகள்",
        "மலேஷிய",
        "Groenlânske",
        "மாக்கியூரி",
        "argentinsk",
        "فاک",
        "فجی",
        "லைன்",
        "லங்கா",
        "கிர்கிஸ்தான்",
        "فرینچ",
        "கோஸ்ரே",
        "گیانا",
        "Argentynske",
        "estive",
        "ہوائی",
        "الیوٹیئن",
        "ہانگ",
        "کانگ",
        "ہووڈ",
        "ہند",
        "இந்தோசீன",
        "பெருங்கடல்",
        "இந்தியப்",
        "இந்திய",
        "Filipsoyggjar",
        "Nýsæland",
        "Nýkaledónia",
        "Móritius",
        "வளைகுடா",
        "கம்",
        "Falklandsoyggjar",
        "சராசரி",
        "கிரீன்விச்",
        "கில்பர்ட்",
        "Vesturevropa",
        "கேம்பியர்",
        "கலபகோஸ்",
        "அண்டார்டிக்",
        "தெற்கத்திய",
        "பிரெஞ்சு",
        "Miðevropa",
        "ஃபிரஞ்சு",
        "Páskaoyggin",
        "Cooksoyggjar",
        "தூர",
        "Kili",
        "ஈக்வடார்",
        "Grønhøvdaoyggjar",
        "திமோர்",
        "உர்வில்லே",
        "Azorurnar",
        "டுமோண்ட்",
        "டேவிஸ்",
        "Aserbadjan",
        "அரை",
        "vestur",
        "eystur",
        "miðvestur",
        "கோகோஸ்",
        "mið",
        "கிறிஸ்துமஸ்",
        "Amasona",
        "Vesturafrika",
        "arabisk",
        "ارکتسک",
        "சாமோரோ",
        "(Anadyr)",
        "جاپان",
        "டருஸ்ஸலாம்",
        "புருனே",
        "پیٹروپاؤلووسک",
        "பொலிவியா",
        "பூடான்",
        "کیمچسکی",
        "அசோர்ஸ்",
        "அசோரஸ்",
        "قزاخستان",
        "کوریا",
        "Pasipiko",
        "لارڈ",
        "ہووے",
        "ماریشس",
        "میکسیکو",
        "میکسیکن",
        "یولان",
        "بیتور",
        "کیلیڈونیا",
        "نیوزی",
        "فاؤنڈ",
        "فرنانڈو",
        "نوووسیبرسک",
        "Meksikon",
        "پیراگوئے",
        "پیرو",
        "فلپائن",
        "سینٹ",
        "தென்",
        "پیئر",
        "مکلیئون",
        "Ayalandi",
        "ஆஃப்கானிஸ்தான்",
        "Grönlannin",
        "سخالین",
        "(USA)",
        "ساموآ",
        "Ushelisheli",
        "پیئی",
        "ٹونگا",
        "wastani",
        "ترکمانستان",
        "یوروگوئے",
        "kisiwa",
        "Krasnoyask",
        "وانوآٹو",
        "Bahari",
        "ولادی",
        "Antaktiki",
        "ووستک",
        "kati",
        "Argentiinan",
        "Tyynenmeren",
        "nusu",
        "وولگوگراد",
        "یکاترینبورگ",
        "یاکوتسک",
        "ولگاگراد",
        "ولادی‌وستوک",
        "واناتو",
        "اروگوئه",
        "ترکمنستان",
        "Arabiani",
        "Uarabuni",
        "تایپه",
        "سورینام",
        "سنگاپور",
        "ساخالین",
        "قیزیل‌اوردا",
        "میکلون",
        "سنت‌پیر",
        "فیلیپین",
        "پرو",
        "پاراگوئه",
        "نووسیبیرسک",
        "نورونیا",
        "Mountains",
        "østkysten",
        "det",
        "دی",
        "Britanija",
        "alaskisk",
        "Irska",
        "क्यूबाको",
        "फल्कल्यान्ड",
        "फ्रेन्च",
        "እና",
        "ግሪንላንድ",
        "एलुटियन",
        "हङकङ",
        "होब्ड",
        "इरानी",
        "ईर्कुट्स्क",
        "इजरायल",
        "काजकस्तान",
        "कोरियाली",
        "क्रासनोयार्क",
        "लर्ड",
        "हावे",
        "मउरिटस",
        "نیوفاندلند",
        "زلاند",
        "मेक्सिकोको",
        "मस्को",
        "नयाँ",
        "جدید",
        "कालेदोनिया",
        "न्यूजिल्यान्ड",
        "फर्नान्डो",
        "کالدونیای",
        "میانمار",
        "مسکو",
        "नोभोसिविर्स्क",
        "पाकिस्तानी",
        "पाराग्वे",
        "اولان‌باتور",
        "موریس",
        "ماکائو",
        "फिलिपिनी",
        "सेन्ट",
        "पियर्रे",
        "मिक्युलोनको",
        "साखालिन",
        "सामोअ",
        "ताइपेइ",
        "उज्बेकिस्तान",
        "भानुआतु",
        "भ्लादिभास्टोक",
        "भोल्गाग्राद",
        "याकुस्ट",
        "येकाटेरिनबर्ग",
        "የሜክሲኮ",
        "የኒው",
        "لردهو",
        "Ireland",
        "Britaniya",
        "کراسنویارسک",
        "کره",
        "قزاقستان",
        "پتروپاولوسک‐کامچاتسکی",
        "ژاپن",
        "ایرکوتسک",
        "هند",
        "خوود",
        "هنگ‌کنگ",
        "წყნარი",
        "هاوایی‐الوشن",
        "არგენტინის",
        "خلیج",
        "گرجستان",
        "nase",
        "ne",
        "d’África",
        "norteamericanu",
        "Pacíficu",
        "فرانسه",
        "گویان",
        "فیجی",
        "d’Arxentina",
        "Este",
        "Xapón",
        "فالکلند",
        "ایستر",
        "Méxicu",
        "Bátor",
        "تیمور",
        "Paquistán",
        "Dağlıq",
        "Ərəbistan",
        "کوبا",
        "کوک",
        "کلمبیا",
        "Ermənistan",
        "کوکوس",
        "چویبالسان",
        "شیلی",
        "Azərbaycan",
        "გრენლანდიის",
        "Banqladeş",
        "چت‌هام",
        "چامورو",
        "Boliviya",
        "Kape",
        "Çatham",
        "کیپ‌ورد",
        "Fici",
        "Gurcüstan",
        "Havay",
        "دارالسلام",
        "برونئی",
        "بنگلادش",
        "آزور",
        "მექსიკის",
        "آذربایجان",
        "جمهوری",
        "Honq",
        "آتلانتیک",
        "Konq",
        "ارمنستان",
        "عربستان",
        "آپیا",
        "آنادیر",
        "کوهستانی",
        "Hind",
        "အနောက်",
        "အာဂျင်တီးနား",
        "Qazaxıstan",
        "Layn",
        "Maqadan",
        "آمازون",
        "آلماآتا",
        "آلاسکا",
        "افغانستان",
        "یکوتسک",
        "Malayziya",
        "Maldiv",
        "یکاٹیرِنبرگ",
        "Mavriki",
        "Şimal",
        "Ulanbator",
        "Myanma",
        "Venecuela",
        "Paraqvay",
        "Čuuk",
        "Mexikoko",
        "Pxenyan",
        "eta",
        "Tog‘",
        "(AQSH)",
        "Saudiya",
        "Tadžikistan",
        "Arabistoni",
        "Орталық",
        "Armaniston",
        "Ozarbayjon",
        "Chatem",
        "Pazifikoko",
        "Xitoy",
        "Choybalsan",
        "шығыс",
        "Тынық",
        "Gruziya",
        "Novosibirski",
        "батыс",
        "Mehhiko",
        "Gavayi",
        "aleut",
        "Xovd",
        "Malaisia",
        "Eron",
        "Šova",
        "аралы",
        "Isroil",
        "Džordžija",
        "Фолкленд",
        "Syova",
        "Južna",
        "Solomonska",
        "Sejšeli",
        "Reinion",
        "Qozogʻiston",
        "Taybey",
        "Xau",
        "Gröönimaa",
        "Ponpej",
        "Mavrikiy",
        "Алеут",
        "Shimoli",
        "Gvineja",
        "Pokiston",
        "Paragvay",
        "Pyer",
        "Tayvan",
        "Turkmaniston",
        "Urugvay",
        "Tacikistan",
        "Tonqa",
        "O‘zbekiston",
        "Vaikse",
        "Nam",
        "Thái",
        "Türkmənistan",
        "Αικατερίνμπουργκ",
        "Γιακούτσκ",
        "Mijanmar",
        "Uruqvay",
        "Βόλγκογκραντ",
        "Βλαδιβοστόκ",
        "Өзбекстан",
        "Βανουάτου",
        "Ουζμπεκιστάν",
        "Moson",
        "Ουρουγουάης",
        "Maršalska",
        "Maldivi",
        "Malezija",
        "Makveri",
        "Τουρκμενιστάν",
        "Τόνγκα",
        "Šri",
        "Košre",
        "Ταϊπέι",
        "Σαμόα",
        "okeansko",
        "Σαχαλίνης",
        "Μικελόν",
        "Griniču",
        "po",
        "Srednje",
        "Πιερ",
        "Gambije",
        "južno",
        "Francusko",
        "Σαιντ",
        "Evrope",
        "istok",
        "dalji",
        "Φιλιππινών",
        "Περού",
        "timor",
        "Παραγουάης",
        "d’Urvil",
        "Dimon",
        "Dejvis",
        "polu",
        "Πακιστάν",
        "Ομσκ",
        "Νοβοσιμπίρσκ",
        "(Keling)",
        "Νορόνια",
        "Božićno",
        "ντε",
        "Φερνάρντο",
        "Γης",
        "Ζηλανδίας",
        "Darusalum",
        "Καληδονίας",
        "Bolivija",
        "Μόσχας",
        "Μπατόρ",
        "Ουλάν",
        "Ειρηνικού",
        "Βορειοδυτικού",
        "Μαυρίκιου",
        "Μάγκανταν",
        "Μακάο",
        "Χάου",
        "Λορντ",
        "Κρασνόγιαρσκ",
        "Κορέας",
        "Južno",
        "Καζακστάν",
        "Καμτσάτσκι",
        "Πετροπαβλόβσκ",
        "Avganistan",
        "Ιαπωνίας",
        "Ισραήλ",
        "Ιρκούτσκ",
        "Ιράν",
        "Χοβντ",
        "Κονγκ",
        "Χονγκ",
        "νήσων",
        "Αλεούτιων",
        "Χαβάης",
        "Γουιάνας",
        "Φίτζι",
        "Φώκλαντ",
        "Πάσχα",
        "Ανατολικού",
        "Κούβας",
        "Κουκ",
        "Κολομβίας",
        "Τσοϊμπαλσάν",
        "Κίνας",
        "Χιλής",
        "Τσάθαμ",
        "Ακρωτηρίου",
        "Özbəkistan",
        "Volqoqrad",
        "Ueyk",
        "Uollis",
        "Πράσινου",
        "Μπραζίλια",
        "Yekaterinburq",
        "Μπανγκλαντές",
        "Αζορών",
        "Αζερμπαϊτζάν",
        "Заходняй",
        "Κεντροδυτικής",
        "Грэнландыі",
        "Ατλαντικού",
        "Мікелон",
        "Западноафриканско",
        "Αρμενίας",
        "източно",
        "Остров",
        "северозападно",
        "আলাস্কা",
        "পূর্বাঞ্চলের",
        "পার্বত্য",
        "অনদ্য্র্",
        "Αραβική",
        "Απία",
        "Αναντίρ",
        "অপিয়া",
        "আরবি",
        "Ορεινή",
        "আর্মেনিয়া",
        "অতলান্তিক",
        "আজারবাইজান",
        "Ανατολική",
        "Κεντρική",
        "Αμαζονίου",
        "Αλάσκας",
        "এজোরেস",
        "Νότιας",
        "বাংলাদেশ",
        "ব্রাসিলিয়া",
        "ɣetoɖofe",
        "ŋkekme",
        "ƒe",
        "কেপ",
        "ভার্দ",
        "Todzidukɔwo",
        "চ্যাথাম",
        "Quốc",
        "và",
        "Standardzit",
        "Summerzit",
        "艾克標準時間",
        "艾克夏令時間",
        "ग्रीनलँड",
        "Астӕуккаг",
        "চিলি",
        "阿富汗時間",
        "中非時間",
        "東非時間",
        "西非標準時間",
        "西非夏令時間",
        "आणि",
        "阿拉斯加標準時間",
        "চীন",
        "চয়বালসন",
        "কোলোম্বিয়া",
        "কুক",
        "Kaledonije",
        "কিউবা",
        "阿拉木圖標準時間",
        "阿拉木圖夏令時間",
        "ইস্টার",
        "Скӕсӕн",
        "Ныгъуылӕн",
        "ফকল্যান্ড",
        "亞馬遜標準時間",
        "Гуырдзыстоны",
        "亞馬遜夏令時間",
        "ফিজি",
        "中部夏令時間",
        "阿那底河標準時間",
        "阿那底河夏令時間",
        "阿皮亞標準時間",
        "阿皮亞夏令時間",
        "阿克陶標準時間",
        "阿克陶夏令時間",
        "阿克托比標準時間",
        "Мӕскуыйы",
        "ফরাসি",
        "अर्जेंटिना",
        "阿克托比夏令時間",
        "阿拉伯標準時間",
        "阿拉伯夏令時間",
        "पॅसिफिक",
        "पौर्वात्य",
        "阿根廷標準時間",
        "এবং",
        "হাওয়াই",
        "阿根廷夏令時間",
        "আলেউত",
        "হং",
        "কং",
        "阿根廷西部標準時間",
        "হোভড",
        "阿根廷西部夏令時間",
        "亞美尼亞標準時間",
        "ইরান",
        "亞美尼亞夏令時間",
        "ইরকুটস্ক",
        "大西洋標準時間",
        "大西洋夏令時間",
        "ইজরায়েল",
        "জাপান",
        "পিত্রেপ্যাভলস্ক",
        "澳洲中部標準時間",
        "澳洲中部夏令時間",
        "澳洲中西部標準時間",
        "ক্যামচ্যাটস্কি",
        "澳洲中西部夏令時間",
        "澳洲東部標準時間",
        "澳洲東部夏令時間",
        "澳洲西部標準時間",
        "澳洲西部夏令時間",
        "মান",
        "কজাকস্তান",
        "亞速爾群島標準時間",
        "亞速爾群島夏令時間",
        "কোরিয়ান",
        "孟加拉標準時間",
        "ਅਲਾਸਕਾ",
        "ক্রাসনোয়ার্স্কি",
        "孟加拉夏令時間",
        "不丹時間",
        "玻利維亞時間",
        "巴西利亞標準時間",
        "巴西利亞夏令時間",
        "ಮಧ್ಯ",
        "汶萊時間",
        "凱西站時間",
        "ਅਲਮਾਟੀ",
        "查莫洛時間",
        "查坦群島標準時間",
        "查坦群島夏令時間",
        "智利標準時間",
        "智利夏令時間",
        "中國標準時間",
        "中國夏令時間",
        "喬巴山標準時間",
        "喬巴山夏令時間",
        "聖誕島時間",
        "哥倫比亞標準時間",
        "ಪೆಸಿಫಿಕ್",
        "লর্ড",
        "哥倫比亞夏令時間",
        "庫克群島標準時間",
        "庫克群島半夏令時間",
        "古巴標準時間",
        "古巴夏令時間",
        "戴維斯時間",
        "東帝汶時間",
        "復活節島標準時間",
        "復活節島夏令時間",
        "中歐標準時間",
        "中歐夏令時間",
        "東歐標準時間",
        "東歐夏令時間",
        "歐洲遠東時間",
        "西歐標準時間",
        "西歐夏令時間",
        "福克蘭群島標準時間",
        "福克蘭群島夏令時間",
        "斐濟標準時間",
        "হাওয়ে",
        "斐濟夏令時間",
        "মসয়",
        "ಮತ್ತು",
        "法屬圭亞那時間",
        "法國南方及南極時間",
        "甘比爾群島時間",
        "ਅਮੇਜ਼ਨ",
        "吉爾伯特群島時間",
        "格林威治標準時間",
        "ম্যাগাডান",
        "格陵蘭東部標準時間",
        "ಗ್ರೀನ್‌ಲ್ಯಾಂಡ್",
        "格陵蘭東部夏令時間",
        "格陵蘭西部標準時間",
        "格陵蘭西部夏令時間",
        "Galabagos",
        "Waqtiga",
        "Kolambiya",
        "Xagaaga",
        "kolambiya",
        "ee",
        "ah",
        "Caadiga",
        "Jekaterinburgski",
        "mehiški",
        "মরিশাস",
        "in",
        "Wolgogradski",
        "아크레",
        "Wladiwostokski",
        "關島標準時間",
        "阿留申標準時間",
        "서아프리카",
        "알래스카",
        "알마티",
        "阿留申夏令時間",
        "아마존",
        "香港標準時間",
        "ਮਾਉਂਟੇਨ",
        "香港夏令時間",
        "Filipinski",
        "아나디리",
        "아피아",
        "악타우",
        "악퇴베",
        "아라비아",
        "Paraguayski",
        "科布多標準時間",
        "아르메니아",
        "대서양",
        "科布多夏令時間",
        "중서부",
        "아제르바이잔",
        "아조레스",
        "방글라데시",
        "브라질리아",
        "카보",
        "베르데",
        "채텀",
        "칠레",
        "중국",
        "초이발산",
        "Nowosibirski",
        "콜롬비아",
        "쿡",
        "쿠바",
        "이스터섬",
        "印度洋時間",
        "동유럽",
        "서유럽",
        "포클랜드",
        "피지",
        "프랑스령",
        "가이아나",
        "그루지아",
        "Moskowski",
        "하와이",
        "알류샨",
        "홍콩",
        "호브드",
        "Batorski",
        "이란",
        "이르쿠츠크",
        "이스라엘",
        "일본",
        "페트로파블롭스크",
        "캄차츠키",
        "카자흐스탄",
        "크라스노야르스크",
        "로드",
        "하우",
        "마카오",
        "마가단",
        "모리셔스",
        "Mexiski",
        "북서부",
        "울란바토르",
        "모스크바",
        "뉴칼레도니아",
        "뉴질랜드",
        "뉴펀들랜드",
        "페르난도",
        "데",
        "노로냐",
        "노보시비르스크",
        "옴스크",
        "파키스탄",
        "파라과이",
        "페루",
        "필리핀",
        "세인트피에르",
        "미클롱",
        "키질로르다",
        "사할린",
        "사마라",
        "사모아",
        "대만",
        "통가",
        "투르크메니스탄",
        "우루과이",
        "우즈베키스탄",
        "바누아투",
        "블라디보스토크",
        "볼고그라드",
        "야쿠츠크",
        "예카테린부르크",
        "印尼中部時間",
        "印尼東部時間",
        "印尼西部時間",
        "伊朗標準時間",
        "افریٖقا",
        "伊朗夏令時間",
        "Korejski",
        "以色列標準時間",
        "ارجٮ۪نٹیٖنا",
        "以色列夏令時間",
        "日本標準時間",
        "日本夏令時間",
        "彼得羅巴甫洛夫斯克標準時間",
        "彼得羅巴甫洛夫斯克日光節約時間",
        "উত্তরপশ্চিম",
        "ਐਪੀਆ",
        "centralni",
        "Chowdski",
        "Hongkongski",
        "東哈薩克時間",
        "西哈薩克時間",
        "韓國標準時間",
        "韓國夏令時間",
        "克拉斯諾亞爾斯克標準時間",
        "ਅਕਤਾਉ",
        "克拉斯諾亞爾斯克夏令時間",
        "مشرِقی",
        "گریٖن",
        "لینڑُک",
        "吉爾吉斯時間",
        "蘭卡時間",
        "ਅਕਤੋਬ",
        "萊恩群島時間",
        "Cookowych",
        "মেক্সিকোর",
        "نورونہا",
        "ਅਰਬੀ",
        "豪勳爵島標準時間",
        "豪勳爵島夏令時間",
        "Kapverdski",
        "মেক্সিকান",
        "ਅਰਮੀਨੀਆ",
        "澳門標準時間",
        "jewöhnlijje",
        "澳門夏令時間",
        "awstralski",
        "Apiaski",
        "górski",
        "vun",
        "centralny",
        "Amaconaski",
        "Борбордук",
        "馬加丹標準時間",
        "馬加丹夏令時間",
        "馬來西亞時間",
        "Yekaterinburgsk",
        "Usbekisk",
        "Uruguayansk",
        "Turkmensk",
        "Tongansk",
        "Тынч",
        "উলান",
        "Кытай",
        "ਅਟਲਾਂਟਿਕ",
        "Filippinsk",
        "tichomorský",
        "Peruviansk",
        "Paraguayansk",
        "Фижи",
        "Pakistansk",
        "Гавайи",
        "Newfoundlandsk",
        "Newzealandsk",
        "Nykaledonsk",
        "বাতোর",
        "ਅਜ਼ਰਬਾਈਜਾਨ",
        "Тайпей",
        "Moskovitisk",
        "Mexicansk",
        "Nordvestmexicansk",
        "Koreansk",
        "මෙක්සිකෝ",
        "Japansk",
        "Мексикийн",
        "ග්‍රීන්ලන්ත",
        "සහ",
        "Israelsk",
        "Iransk",
        "Vestgrønlandsk",
        "ඔස්ට්‍රේලියානු",
        "ඕස්ට්‍රේලියානු",
        "ආර්ජන්ටිනා",
        "Østgrønlandsk",
        "Georgiansk",
        "පැසිෆික්",
        "Fransk",
        "Fijiansk",
        "Falklandsøerne",
        "Vesteuropæisk",
        "Østeuropæisk",
        "Centraleuropæisk",
        "Påskeøen",
        "Cubansk",
        "Cookøerne",
        "Colombiansk",
        "Kinesisk",
        "ਅਜੋਰੇਸ",
        "ਬੰਗਲਾਦੇਸ਼",
        "Chilensk",
        "Kapverdisk",
        "Brasiliansk",
        "Bangladeshisk",
        "Azorerne",
        "Aserbajdsjansk",
        "ਬ੍ਰਾਜ਼ੀਲੀਆ",
        "ਕੇਪ",
        "Vestaustralsk",
        "Østaustralsk",
        "centralaustralsk",
        "Vestlig",
        "Centralaustralsk",
        "Armensk",
        "Vestargentinsk",
        "Argentinsk",
        "Vestafrikansk",
        "Pilipinas",
        "Mecsico",
        "ਵਰਡ",
        "馬紹爾群島時間",
        "Las",
        "莫森時間",
        "墨西哥西北部標準時間",
        "墨西哥西北部夏令時間",
        "墨西哥太平洋標準時間",
        "墨西哥太平洋夏令時間",
        "烏蘭巴托標準時間",
        "烏蘭巴托夏令時間",
        "ਚੈਥਮ",
        "Ariannin",
        "De",
        "莫斯科標準時間",
        "莫斯科夏令時間",
        "緬甸時間",
        "尼泊爾時間",
        "新喀里多尼亞標準時間",
        "紐西蘭標準時間",
        "紐西蘭夏令時間",
        "紐芬蘭標準時間",
        "紐芬蘭夏令時間",
        "Samarský",
        "紐埃島時間",
        "諾福克島時間",
        "費爾南多",
        "miquelonský",
        "北馬里亞納群島時間",
        "新西伯利亞標準時間",
        "新西伯利亞夏令時間",
        "鄂木斯克標準時間",
        "鄂木斯克夏令時間",
        "巴基斯坦標準時間",
        "巴基斯坦夏令時間",
        "帛琉時間",
        "巴拉圭標準時間",
        "巴拉圭夏令時間",
        "秘魯標準時間",
        "Howa",
        "lorda",
        "秘魯夏令時間",
        "菲律賓標準時間",
        "菲律賓夏令時間",
        "鳳凰群島時間",
        "聖皮埃爾和密克隆群島標準時間",
        "聖皮埃爾和密克隆群島夏令時間",
        "波納佩時間",
        "克孜勒奧爾達標準時間",
        "克孜勒奧爾達夏令時間",
        "留尼旺時間",
        "aleutský",
        "羅瑟拉時間",
        "庫頁島標準時間",
        "庫頁島夏令時間",
        "薩馬拉標準時間",
        "薩馬拉夏令時間",
        "薩摩亞標準時間",
        "薩摩亞夏令時間",
        "Yakuțk",
        "Uruguayului",
        "南喬治亞時間",
        "Filipine",
        "Pakistanului",
        "Zeelande",
        "Caledonii",
        "大溪地時間",
        "Moscovei",
        "mexicane",
        "zonei",
        "Mexicului",
        "Coreei",
        "Kazahstanul",
        "Kamciațki",
        "Japoniei",
        "Israelului",
        "Irkuțk",
        "Iranului",
        "台北標準時間",
        "台北夏令時間",
        "Letní",
        "Cookových",
        "塔吉克時間",
        "托克勞群島時間",
        "楚克島時間",
        "土庫曼標準時間",
        "Paștelui",
        "Cubei",
        "Columbiei",
        "Anadyrský",
        "pacifický",
        "Chinei",
        "Capul",
        "Brasiliei",
        "Azerbaidjanului",
        "horský",
        "Armeniei",
        "土庫曼夏令時間",
        "arabă",
        "montană",
        "烏拉圭標準時間",
        "烏拉圭夏令時間",
        "orientală",
        "烏茲別克標準時間",
        "centrală",
        "Amazonului",
        "烏茲別克夏令時間",
        "委內瑞拉時間",
        "海參崴標準時間",
        "海參崴夏令時間",
        "伏爾加格勒標準時間",
        "伏爾加格勒夏令時間",
        "沃斯托克時間",
        "威克島時間",
        "瓦利斯和富圖納群島時間",
        "葉卡捷琳堡標準時間",
        "葉卡捷琳堡夏令時間",
        "Гринландын",
        "ᎠᏂᏍᏆᏂ",
        "ਚਿਲੀ",
        "ᎢᏤᏍᏛᏱ",
        "ਚੀਨ",
        "ᎠᎴ",
        "Ramiojo",
        "ᎠᏥᏂᏘᏂᎠ",
        "Argentinos",
        "Мексикан",
        "vakarų",
        "ਚੌਇਬਾਲਸਨ",
        "Гренланди",
        "মস্কো",
        "AZOST",
        "океанан",
        "AZOT",
        "Salos",
        "Тийна",
        "Jekaterinburško",
        "Volgogradsko",
        "Vladivostočko",
        "Vanuatuansko",
        "Uzbekistansko",
        "Urugvajsko",
        "Turkmenistansko",
        "Tongansko",
        "Tajpejsko",
        "Samoansko",
        "Sahalinsko",
        "Filipinsko",
        "ir",
        "Peruansko",
        "Paragvajsko",
        "Pakistansko",
        "ostrvu",
        "Grenlandijos",
        "Njufaundlendsko",
        "Novozelandsko",
        "Novokaledonijsko",
        "Moskovsko",
        "Ulanbatorsko",
        "ба",
        "Meksičko",
        "Sjeverozapadno",
        "Mauricijsko",
        "Magadansko",
        "Iransko",
        "Hovdsko",
        "Hongkonško",
        "aleućansko",
        "Zapadnogrenlandsko",
        "Istočnogrenlandsko",
        "Meksikos",
        "Gruzijsko",
        "Folklandsko",
        "Centralnoevropsko",
        "Uskršnjeostrvsko",
        "Kubansko",
        "Kukovim",
        "Kolumbijsko",
        "Čojbalsansko",
        "Čileansko",
        "Čatamsko",
        "Zelenortsko",
        "Brazilijsko",
        "Bangladeško",
        "Azorsko",
        "Azerbejdžansko",
        "Zapadnoaustralijsko",
        "Istočnoaustralijsko",
        "centralnozapadno",
        "Centralnoaustralijsko",
        "ਕੋਲੰਬੀਆ",
        "ਕੁੱਕ",
        "Armensko",
        "Zapadnoargentinsko",
        "Argentinsko",
        "Akvtobe",
        "Klusā",
        "Akvtau",
        "Apijsko",
        "centrālais",
        "rietumu",
        "Amazonsko",
        "Almatu",
        "Meksyk",
        "Aljaskansko",
        "ক্যালেডোনিয়া",
        "Kuka",
        "ਕਿਊਬਾ",
        "Zapadnoafričko",
        "নিউজিল্যান্ড",
        "ਈਸਟਰ",
        "Grenlandia",
        "un",
        "Таипеи",
        "নিউফাউন্ডল্যান্ড",
        "ফার্নান্দো",
        "баруун",
        "вемена",
        "Meksikas",
        "zachodnioaustralijski",
        "ডি",
        "Пацифичко",
        "Argentyna",
        "Arabski",
        "pacyficzny",
        "Планинско",
        "समोआ",
        "समारा",
        "पोनापे",
        "Аргентины",
        "নোরোনহা",
        "कैलेडोनिया",
        "ਯਕੇਤਰਿਨਬਰਗ",
        "ਯਕੁਤਸਕ",
        "নোভোসিবির্স্ক",
        "म्यानमार",
        "ওমস্ক",
        "जपान",
        "ईरान",
        "পাকিস্তান",
        "होव्ड",
        "ਵੋਲਗੋਗ੍ਰੇਡ",
        "ਵਲਾਦੀਵੋਸਤਕ",
        "ग्रीनलैण्ड",
        "ईस्टर",
        "चैथम",
        "बांगलादेश",
        "ਵਾਨੂਆਟੂ",
        "প্যারাগুয়ে",
        "अनादीर",
        "अलास्का",
        "পেরু",
        "ਉਜ਼ਬੇਕਿਸਤਾਨ",
        "ਉਰੂਗਵੇ",
        "ਤੁਰਕਮੇਨਿਸਤਾਨ",
        "Nevez",
        "Источен",
        "ਟੋਂਗਾ",
        "ha",
        "ফিলিপাইন",
        "ਤੈਪਈ",
        "সেন্ট",
        "Greunland",
        "ਸਾਮੋਆ",
        "ਸਖਲੀਨ",
        "পিয়ের",
        "ਕਿਜ਼ਲੋਰਡਾ",
        "Aostralia",
        "Kreizaostralia",
        "Arcʼhantina",
        "ആഫ്രിക്ക",
        "ইয়েকাতেরিনবুর্গ",
        "ਮਿਕੇਲਨ",
        "য়াকুতস্ক",
        "ভলগোগ্রাড",
        "ਪੀਅਰੇ",
        "ਸੈਂਟ",
        "ব্লাদিবোস্তোক",
        "ভানুয়াতু",
        "উজবেকিস্তান",
        "উরুগুয়ে",
        "പസഫിക്",
        "അർജന്റീന",
        "ഓസ്ട്രേലിയൻ",
        "ഓസ്‌ട്രേലിയൻ",
        "ਫਿਲਿਪੀਨੀ",
        "ਪੇਰੂ",
        "ਪੈਰਾਗਵੇ",
        "ਪਾਕਿਸਤਾਨ",
        "তুর্কমেনিস্তান",
        "ਓਮਸਕ",
        "টোঙ্গা",
        "ਨੌਵੋਸਿਬੀਰਸਕ",
        "ਨੋਰੋਨਹਾ",
        "ਫ਼ਾਕਲੈਂਡ",
        "ਡੇ",
        "ਫਰਨਾਂਡੋ",
        "তাইপেই",
        "ਨਿਊਫਾਉਂਡਲੈਂਡ",
        "ਨਿਊਜ਼ੀਲੈਂਡ",
        "ਕੈਲੇਡੋਨੀਆ",
        "সামোয়া",
        "ഗ്രീൻലാൻഡ്",
        "ਮਾਸਕੋ",
        "ਬਟੋਰ",
        "ਉਲਨ",
        "ਮੈਕਸੀਕਨ",
        "ও",
        "ਮੈਕਸੀਕੋ",
        "ਉੱਤਰ",
        "ਮੌਰਿਸ਼ਸ",
        "ਮੈਗੇਡਨ",
        "ਮਕਾਉ",
        "ਹੋਵੇ",
        "ਲੌਰਡ",
        "ਕ੍ਰਾਸਨੋਯਾਰਸਕ",
        "ਫ਼ਿਜ਼ੀ",
        "ਕੋਰੀਆਈ",
        "ਕਜ਼ਾਖ਼ਸਤਾਨ",
        "ਜਪਾਨ",
        "ਇਜ਼ਰਾਈਲ",
        "ਇਰਕੁਤਸਕ",
        "ਈਰਾਨ",
        "ਇੰਡੋਨੇਸ਼ੀਆ",
        "ਹੋਵਡ",
        "ਕਾਂਗ",
        "ਹਾਂਗ",
        "ਅਲੇਯੂਸ਼ਿਅਨ",
        "ਹਵਾਈ",
        "সামারা",
        "সাখালিন",
        "মিকেলন",
        "ਫ੍ਰੈਂਚ",
        "कोलम्बियाली",
        "ന്യൂ",
        "ഡി",
        "Sina",
        "Индонезија",
        "Западен",
        "Источна",
        "Өмнөд",
        "अर्जण्टिना",
        "ईंडोनीशिया",
        "मलेशिया",
        "न्यु",
        "पापुआ",
        "एवं",
        "Гринвич",
        "Wyspa",
        "wschodnioeuropejski",
        "Gilberta",
        "Wschodnia",
        "Хятадын",
        "Indonezja",
        "Austrumeiropas",
        "Zachodni",
        "د",
        "وخت",
        "Indonezijos",
        "гӀайре",
        "Индонези",
        "ᏣᎠᏥᎢ",
        "ᎢᏂᏙᏂᏍᏯ",
        "Pietų",
        "Tsieina",
        "Casachstan",
        "Индонезийн",
        "Илин",
        "Арҕаа",
        "gaskka",
        "áigi",
        "ඉන්දුනීසියානු",
        "ගිම්හාන",
        "Жаӊы",
        "аралынын",
        "батыш",
        "Jewöhnlijje",
        "Oß",
        "سیووا",
        "نیوٗ",
        "اِنڑونیشِیا",
        "Vzhodni",
        "vzhodni",
        "اَیلینڑز",
        "Singapurski",
        "Indonezijski",
        "Afganistanit",
        "ಜಾರ್ಜಿಯಾ",
        "Alaskës",
        "Alsaskës",
        "ಅರ್ಜೆಂಟೀನಾ",
        "ದಕ್ಷಿಣ",
        "Butanit",
        "Bolivisë",
        "Durasalamit",
        "Kejsit",
        "Kamorros",
        "Krishtlindjeve",
        "Dejvisit",
        "d’Urvilës",
        "Timorit",
        "Ekuadorit",
        "Largët",
        "ग्रीष्म",
        "Territoreve",
        "Antarktike",
        "Galapagosit",
        "Gambierit",
        "Meridianit",
        "Grinuiçit",
        "Guamit",
        "Gjirit",
        "Indisë",
        "Oqeanit",
        "Indokinës",
        "Perëndimor",
        "Kosrës",
        "Kirgistanit",
        "Lankasë",
        "Sporadikë",
        "Ekuatorialë",
        "Makuari",
        "Malajzisë",
        "Maldivit",
        "Markezë",
        "Marshallë",
        "Mausonit",
        "Mianmarit",
        "Naurusë",
        "Nepalit",
        "खाडी",
        "Niuesë",
        "Marianës",
        "Veriut",
        "Palaut",
        "Guinesë",
        "Verore",
        "Pitkernit",
        "Ponapeit",
        "Penianit",
        "Reunionit",
        "Rodherës",
        "Sishelës",
        "Singaporit",
        "Xhorxhas",
        "Jugut",
        "रियुनियन",
        "Surinamit",
        "остров",
        "Рождество",
        "Sjouit",
        "Tahitit",
        "Taxhikistanit",
        "फुटुना",
        "Tokelaut",
        "Çukut",
        "Pusat",
        "Tuvalusë",
        "Hari",
        "Separuh",
        "平壤時間",
        "ceruk",
        "timur",
        "Venezuelës",
        "Antartika",
        "Min",
        "Lautan",
        "Vostokut",
        "Uejk",
        "Uollisit",
        "Futunës",
        "Соломон",
        "ACST",
        "Çuuk",
        "Маршалл",
        "Мальдив",
        "Антарктика",
        "Indoneesia",
        "Georgiako",
        "Хитой",
        "океани",
        "centralafrikansk",
        "östafrikansk",
        "sydafrikansk",
        "Marşal",
        "Almatynormaltid",
        "Almatysommartid",
        "Anadyrnormaltid",
        "ပစိဖိတ်",
        "Anadyrsommartid",
        "Aqtaunormaltid",
        "Aqtausommartid",
        "Aqtöbenormaltid",
        "Aqtöbesommartid",
        "atlantnormaltid",
        "atlantsommartid",
        "Bruneitid",
        "Caseytid",
        "Chamorrotid",
        "Julöns",
        "Çamorro",
        "ინდონეზიის",
        "Keelingöarnas",
        "ഇന്തോനേഷ്യ",
        "östtimorisk",
        "Kaliningradtid",
        "Sydterritoriernas",
        "Galápagostid",
        "Sur",
        "Gambiertid",
        "Kiribatitid",
        "Greenwichtid",
        "Guamtid",
        "d’Indonesia",
        "Xeorxa",
        "Persiska",
        "saseNtshonalanga",
        "Les",
        "vikentid",
        "Brittiska",
        "Indiska",
        "oceanöarnas",
        "centralindonesisk",
        "گالاپاگوس",
        "östindonesisk",
        "västindonesisk",
        "Kamtjatkanormaltid",
        "Kamtjatkasommartid",
        "आइरिश",
        "dell’Irlanda",
        "Regno",
        "Unito",
        "östkazakstansk",
        "västkazakstansk",
        "အင်ဒိုနီးရှား",
        "Kosraetid",
        "kirgizisk",
        "Lankatid",
        "Lineöarnas",
        "Macaunormaltid",
        "Macausommartid",
        "Macquarietid",
        "Maldivernatid",
        "Marquesastid",
        "Marshallöarnas",
        "Mawsontid",
        "burmesisk",
        "Naurutid",
        "nepalesisk",
        "Niuetid",
        "Norfolköns",
        "Nordmarianernas",
        "Palautid",
        "Guineas",
        "Enderburytid",
        "Pitcairntid",
        "Ponapetid",
        "Pyongyangtid",
        "Qyzylordanormaltid",
        "Qyzylordasommartid",
        "Réuniontid",
        "Rotheratid",
        "Samaranormaltid",
        "Samarasommartid",
        "ኢንዶኔዢያ",
        "Seychellernatid",
        "Singaporetid",
        "Salomonöarnas",
        "sydgeorgisk",
        "Surinamtid",
        "strandarde",
        "Syowatid",
        "Tahititid",
        "Irlandës",
        "britanike",
        "Tadzjikistantid",
        "የምስራቃዊ",
        "sentralafrikansk",
        "sørafrikansk",
        "Tokelautid",
        "Chuuktid",
        "Tuvalutid",
        "irländsk",
        "Vostoktid",
        "brittisk",
        "Honolulunormaltid",
        "Wakeöarnas",
        "Futunaöarnas",
        "Georgian",
        "Honolulusommartid",
        "Indonesian",
        "Indonesiya",
        "and",
        "Georgyske",
        "Yndonezyske",
        "Síne",
        "Seoirsia",
        "ایمیزون",
        "Tagikistan",
        "Salomone",
        "Riunione",
        "Fenice",
        "hIndinéise",
        "መካከለኛ",
        "Marchesi",
        "የአርጀንቲና",
        "Malesia",
        "equatoriali",
        "Sporadi",
        "західним",
        "Innd",
        "Innse",
        "Kamchatsky",
        "dell’Indocina",
        "Seychelle",
        "Indiano",
        "dell’Oceano",
        "dell’India",
        "francesi",
        "antartiche",
        "australi",
        "middeltid",
        "francese",
        "(Kaliningrad)",
        "dell’Ecuador",
        "leste",
        "Xeorxia",
        "літній",
        "стандартний",
        "Afghanischtan",
        "Zentralafrikanischi",
        "Oschtafrikanischi",
        "Süüdafrikanischi",
        "ziit",
        "અર્જેન્ટીના",
        "شىمالىي",
        "ઇન્ડોનેશિયા",
        "ھىندونېزىيە",
        "ન્યુ",
        "meridionale",
        "dell’Afghanistan",
        "רגיל",
        "האוקיינוס",
        "جەنۇبىي",
        "סין",
        "Nýju",
        "Indónesíutími",
        "אינדונזיה",
        "దక్షిణ",
        "החדשה",
        "Afríkutími",
        "అర్జెంటీనా",
        "ఆస్ట్రేలియన్",
        "दारूस्सलम",
        "कोकोस",
        "mo",
        "ग्रीनविच",
        "महासागर",
        "कोसराए",
        "क्रास्नोयार्स्क",
        "జార్జియా",
        "ఇండోనేషియా",
        "Ինդոնեզիայի",
        "న్యూ",
        "सिंगापुर",
        "fakaʻinitonisia",
        "indonéziai",
        "Indoneziýa",
        "Makkuori",
        "argentínai",
        "d’Urvillea",
        "fakaʻotumotu",
        "Davistid",
        "የቱርክመኒስታን",
        "Indosjina",
        "የኡራጓይ",
        "माउंटेन",
        "Macáu",
        "एनाडीयर",
        "Маўрыкія",
        "अरब",
        "Indonezia",
        "ཧ་ཝའི་",
        "የኡዝቤኪስታን",
        "Паўночна",
        "заходні",
        "ऑस्ट्रेलियाई",
        "अज़रबैजान",
        "अज़ोरेस",
        "बांग्लादेश",
        "fakataipei",
        "fakahaʻamoa",
        "ब्राजीलिया",
        "samala",
        "мексіканскі",
        "Мексіканскі",
        "वर्ड",
        "चामोरो",
        "ціхаакіянскі",
        "የቫኗቱ",
        "कॉइबाल्सन",
        "sakāline",
        "太平洋夏令時間",
        "太平洋標準時間",
        "fakakisilōta",
        "山區夏令時間",
        "mikeloni",
        "山區標準時間",
        "piea",
        "तिमोर",
        "fakasā",
        "東部夏令時間",
        "東部標準時間",
        "ग्रीष्‍मकालीन",
        "अग्र",
        "फ़ॉकलैंड",
        "फ़िजी",
        "fakafilipaine",
        "Къилба",
        "fakapelū",
        "中部標準時間",
        "fakapalakuai",
        "fakapākisitani",
        "ʻomisiki",
        "novosipīsiki",
        "Moris",
        "Gwalarn",
        "nolōnia",
        "te",
        "Mecʼhiko",
        "fakafēnanito",
        "हवाई–आल्यूशन",
        "የኬፕ",
        "Moskov",
        "fakafonuaʻilofoʻou",
        "Батара",
        "fakanuʻusila",
        "Маскоўскі",
        "इर्कुत्स्क",
        "इज़राइल",
        "Лаьмнийн",
        "पेट्रोपेवलास्क",
        "कैमचात्सकी",
        "南非標準時間",
        "कज़ाखस्तान",
        "कोरियाई",
        "(АЦШ)",
        "ቨርዴ",
        "fakakaletōniafoʻou",
        "Perou",
        "Filipinez",
        "СаӀудийн",
        "mosikou",
        "Wešteuropäiši",
        "fakaʻulānipātā",
        "Ošteuropäiši",
        "tokelauhihifo",
        "Mitteleuropäiši",
        "ཕར་ནེན་ཌོ་",
        "ཌི་",
        "Арави",
        "बटोर",
        "Эрмалойчоь",
        "fakamaulitiusi",
        "Atlantiši",
        "न्यूज़ीलैंड",
        "न्यूफ़ाउंडलैंड",
        "makatani",
        "fakamakau",
        "फ़र्नांर्डो",
        "Đài",
        "Philippin",
        "fakamotuʻeikihoue",
        "Matxcơva",
        "पैराग्वे",
        "Атлантикан",
        "फ़िलिपीन",
        "kalasinoiāsiki",
        "đảo",
        "पियरे",
        "मिकेलान",
        "पिटकैर्न",
        "fakakōlea",
        "fakakasakitani",
        "सखालिन",
        "petelopavilovisiki",
        "Cao",
        "fakasiapani",
        "fakaʻisileli",
        "Ma",
        "Hàn",
        "ताइपे",
        "ताजिकिस्तान",
        "टोकेलाऊ",
        "Bản",
        "चूक",
        "Nhật",
        "तुवालू",
        "Độ",
        "उज़्बेकिस्तान",
        "वनुआतू",
        "Ấn",
        "वोल्गोग्राड",
        "ʻīkutisiki",
        "Kông",
        "fakaʻilaani",
        "Hồng",
        "याकुत्स्क",
        "येकातेरिनबर्ग",
        "afganistansko",
        "srednjoafričko",
        "istočnoafričko",
        "južnoafričko",
        "Gruzia",
        "Sant",
        "Pháp",
        "малхбузен",
        "Sinh",
        "Phục",
        "Pêr",
        "Азоран",
        "Aleutia",
        "Mauriciu",
        "Бразили",
        "Broenei",
        "Đại",
        "Каледоніі",
        "Зеландыі",
        "Ньюфаўндлендскі",
        "Ouzbekistan",
        "Anyiehe",
        "Yekaterinbourg",
        "butansko",
        "bolivijsko",
        "आकर",
        "የቻታም",
        "d’Ulán",
        "የቺሊ",
        "ды",
        "Caseyja",
        "Chamorra",
        "Наронья",
        "Новасібірскі",
        "Колумби",
        "gaƒoƒoɖanyime",
        "Božićnog",
        "Кукан",
        "Kokosovih",
        "Омскі",
        "Αφγανιστάν",
        "Cookovih",
        "Cookovo",
        "Пакістанскі",
        "polusatni",
        "pomak",
        "Мархин",
        "Davisa",
        "esezingeni",
        "istočnotimorsko",
        "የቻይና",
        "ekvadorsko",
        "saseNyakatho",
        "अलमाटी",
        "dalekoistočno",
        "europsko",
        "अमाज़ोन",
        "Фолклендан",
        "Французийн",
        "Francuske",
        "Gvajane",
        "južnofrancusko",
        "सैंट्रल",
        "Galapagosa",
        "Gambiera",
        "Парагвая",
        "Gilbertovih",
        "univerzalno",
        "Перуанскі",
        "माऊन्टन",
        "guamsko",
        "zaljevsko",
        "gvajansko",
        "Гуьржийчоь",
        "पैसीफीक",
        "Філіпінскі",
        "अक़्टाऊ",
        "indijsko",
        "Indijskog",
        "oceana",
        "indokinesko",
        "srednjoindonezijsko",
        "istočnoindonezijsko",
        "zapadnoindonezijsko",
        "अक़्टोबे",
        "Фенікс",
        "የቾይባልሳን",
        "П’ер",
        "Гавайн",
        "istočnokazahstansko",
        "zapadnokazahstansko",
        "алеутийн",
        "आरमीनी",
        "kirgistansko",
        "lankansko",
        "Инди",
        "अटलांटीक",
        "malezijsko",
        "maldivsko",
        "markižansko",
        "Maršalovih",
        "Singapoer",
        "mawsonsko",
        "आज़रबैजान",
        "Μπουτάν",
        "Βολιβίας",
        "ГӀажарийчоь",
        "mianmarsko",
        "Naurua",
        "nepalsko",
        "Μπρουνέι",
        "Νταρουσαλάμ",
        "आज़ोर",
        "የየካተሪንበርግ",
        "Niuea",
        "Sjevernomarijanskih",
        "Τσαμόρο",
        "Япони",
        "湯加標準時間",
        "Palaua",
        "Papue",
        "Gvineje",
        "Корей",
        "Косраэ",
        "Solomoneilande",
        "Χριστουγέννων",
        "ब्राज़ीलिया",
        "Pitcairna",
        "Ponapea",
        "pjongjanško",
        "Κόκος",
        "Reuniona",
        "Rothere",
        "ब्रुनेई",
        "Maleisië",
        "Maledive",
        "sejšelsko",
        "singapursko",
        "Salomonskih",
        "Južne",
        "Georgije",
        "surinamsko",
        "Syowe",
        "Tahitija",
        "Ντέιβις",
        "tadžikistansko",
        "Tokelaua",
        "Ντιμόντ",
        "Chuuka",
        "Ντερβίλ",
        "Tuvalua",
        "Сахалінскі",
        "Τιμόρ",
        "Маврики",
        "venezuelsko",
        "Εκουαδόρ",
        "काप",
        "vostočko",
        "περαιτέρω",
        "Къилбаседа",
        "fakahovite",
        "kongi",
        "fakahongi",
        "fakahauaʻi",
        "zapadoafriski",
        "Американ",
        "alaskaski",
        "Γαλλικής",
        "wuchodny",
        "hórski",
        "arabski",
        "argentinski",
        "zapadoargentinski",
        "armenski",
        "atlantiski",
        "srjedźoawstralski",
        "वेर्दे",
        "fakaseōsia",
        "wuchodoawstralski",
        "zapadoawstralski",
        "azerbajdźanski",
        "acorski",
        "bangladešski",
        "fakakuiana",
        "fakafisi",
        "Brasiliski",
        "fokulani",
        "kapverdski",
        "Γαλλικού",
        "chathamski",
        "chilski",
        "chinski",
        "Νότου",
        "የደቡብ",
        "kolumbiski",
        "kubaski",
        "fakalapanui",
        "fakakiupa",
        "fakaʻotumotukuki",
        "fakakolomipia",
        "Jutrowneje",
        "fakakoipalisani",
        "srjedźoeuropski",
        "wuchodoeuropski",
        "zapadoeuropski",
        "falklandski",
        "fidźiski",
        "fakasiaina",
        "fakasili",
        "fakasatihami",
        "vēte",
        "fakamuiʻi",
        "fakapalāsila",
        "georgiski",
        "wuchodogrönlandski",
        "zapadogrönlandski",
        "fakapengilātesi",
        "fakaʻāsolesi",
        "hawaiisko",
        "fakaʻasapaisani",
        "Ανταρκτικής",
        "ʻatalanitiki",
        "fakaʻāmenia",
        "Γκαλάπαγκος",
        "fakaʻalepea",
        "iranski",
        "israelski",
        "japanski",
        "fakaʻakitōpe",
        "fakaʻakitau",
        "korejski",
        "fakaapia",
        "ʻanatili",
        "Γκάμπιερ",
        "የኮሎምቢያ",
        "Γκίλμπερτ",
        "moʻunga",
        "mauritiuski",
        "Mawsonski",
        "Μέση",
        "sewjerozapadny",
        "Γκρίνουιτς",
        "Каледони",
        "fakaʻamasōne",
        "nowokaledonski",
        "nowoseelandski",
        "nowofundlandski",
        "fakaʻalamati",
        "pakistanski",
        "fakaʻalasika",
        "Γκουάμ",
        "Κόλπου",
        "peruski",
        "filipinski",
        "Зеланди",
        "चीली",
        "चाईना",
        "sachalinski",
        "samoaski",
        "चोईबालसान",
        "Paraguái",
        "fakaʻakelī",
        "የኩክ",
        "Ýekaterinburg",
        "Ýakutsk",
        "Taipehski",
        "Wanuatu",
        "Ινδίας",
        "tongaski",
        "Urugwaý",
        "turkmenski",
        "Ινδικού",
        "uruguayski",
        "uzbekski",
        "vanuatuski",
        "Taýbeý",
        "Pýer",
        "Ωκεανού",
        "Ινδοκίνας",
        "oosterse",
        "Filippinler",
        "Филиппинаш",
        "蘇里南時間",
        "የኩባ",
        "अर्ध",
        "Paragwaý",
        "क्युबा",
        "alaszkai",
        "Marshalleilande",
        "amazóniai",
        "középső",
        "Tyd",
        "keleti",
        "hegyvidéki",
        "Δυτικού",
        "Тайбэя",
        "Anadíri",
        "apiai",
        "Aqtaui",
        "Aqtobei",
        "arab",
        "Κοσράης",
        "Päkistan",
        "örményországi",
        "atlanti",
        "የአላስካ",
        "azerbajdzsáni",
        "azori",
        "bangladesi",
        "Noronýa",
        "Nýufaundlend",
        "brazíliai",
        "zöld",
        "foki",
        "Κιργιστάν",
        "Zelandiýa",
        "chathami",
        "chilei",
        "kínai",
        "csojbalszani",
        "Kaledoniýa",
        "Λάιν",
        "Saxalín",
        "kolumbiai",
        "cook",
        "Meksikan",
        "kubai",
        "G.b.",
        "D.g.",
        "Mawrikiý",
        "húsvét",
        "Туркменин",
        "Seixeles",
        "Krasnoýarsk",
        "falkland",
        "fidzsi",
        "francia",
        "Koreýa",
        "déli",
        "Μακουάρι",
        "Gazagystan",
        "Ýaponiýa",
        "Ysraýyl",
        "grúziai",
        "Eýran",
        "Узбекистанан",
        "Howd",
        "Μαλαισίας",
        "Μαλδίβων",
        "Gawaý",
        "hawaii",
        "aleuti",
        "hongkongi",
        "hovdi",
        "indiai",
        "Μαρκέσας",
        "Μάρσαλ",
        "iráni",
        "irkutszki",
        "izraeli",
        "japán",
        "Petropavlovszk",
        "kamcsatkai",
        "kazahsztáni",
        "koreai",
        "Gruziýa",
        "krasznojarszki",
        "आईलंड",
        "Μόσον",
        "Gilberteilande",
        "Macaui",
        "Pasha",
        "Kolumbiýa",
        "Туркменістана",
        "Çoýbalsan",
        "Hytaý",
        "Çatem",
        "Werde",
        "mauritiusi",
        "የኢስተር",
        "északnyugat",
        "फ़ाल्कलैण्ड",
        "ulánbátori",
        "moszkvai",
        "Braziliýa",
        "फीजी",
        "फ्रान्सीसी",
        "Μιανμάρ",
        "kaledóniai",
        "zélandi",
        "fundlandi",
        "Azerbaýjan",
        "tarap",
        "günbatar",
        "Ναούρου",
        "novoszibirszki",
        "omszki",
        "pakisztáni",
        "Νεπάλ",
        "Уругвайскі",
        "ýurtlary",
        "paraguayi",
        "perui",
        "fülöp",
        "Arap",
        "Узбекістана",
        "Kersfeeseiland",
        "(ABŞ)",
        "Qyzylordai",
        "ýeri",
        "Daglyk",
        "szahalini",
        "Szamarai",
        "szamoai",
        "ᏧᎦᎾᏮ",
        "Alýaska",
        "Νιούε",
        "Νόρφολκ",
        "जोर्जिया",
        "mediaantyd",
        "Уладзівастоцкі",
        "taipei",
        "Βόρειες",
        "คัมชัตสกี",
        "tongai",
        "อะลูเชียน",
        "türkmenisztáni",
        "ఏకాటెరిన్బర్గ్",
        "uruguayi",
        "üzbegisztáni",
        "vanuatui",
        "యాకుట్స్క్",
        "vlagyivosztoki",
        "volgográdi",
        "వోల్గోగ్రాడ్",
        "వ్లాడివోస్టోక్",
        "వనౌటు",
        "ఉజ్బెకిస్తాన్",
        "ఉరుగ్వే",
        "తుర్క్మెనిస్థాన్",
        "టాంగా",
        "Μαριάνες",
        "ᎠᎳᏍᎦ",
        "Валгаградскі",
        "गुआम",
        "Հարավային",
        "Παλάου",
        "Παπουά",
        "Νέα",
        "Ալյասկայի",
        "Ամազոնյան",
        "Γουινέα",
        "Լեռնային",
        "(ԱՄՆ)",
        "Խաղաղօվկիանոսյան",
        "Ապիայի",
        "Սաուդյան",
        "Արաբիայի",
        "የአማዞን",
        "ստնադարտ",
        "Հայաստանի",
        "Ատլանտյան",
        "ᎠᎺᏌᏂ",
        "արևմտյան",
        "Ադրբեջանի",
        "Ազորյան",
        "Taxiquistán",
        "Բանգլադեշի",
        "తైపీ",
        "సమోవా",
        "Բրազիլիայի",
        "సమారా",
        "Կաբո",
        "Վերդեի",
        "సఖాలిన్",
        "Չաթեմ",
        "Φίνιξ",
        "Չիլիի",
        "Չինաստանի",
        "Չոյբալսանի",
        "కిజిలోర్డా",
        "మిక్వెలాన్",
        "సెయింట్",
        "Կոլումբիայի",
        "Կուկի",
        "ఫిలిప్పైన్",
        "Կուբայի",
        "పెరూ",
        "పరాగ్వే",
        "ఓమ్స్క్",
        "నొరోన్హా",
        "Զատկի",
        "డి",
        "ᎣᏓᎸ",
        "ఫెర్నాండో",
        "Ֆոլքլենդյան",
        "Ֆիջիի",
        "Ֆրանսիական",
        "ల్యాండ్",
        "న్యూఫౌండ్",
        "ᎠᏈᎠ",
        "న్యూజిల్యాండ్",
        "కాలెడోనియా",
        "आलटन",
        "Վրաստանի",
        "మాస్కో",
        "బతోర్",
        "Πίτκερν",
        "ఉలన్",
        "మెక్సికన్",
        "మెక్సికో",
        "Հավայան",
        "ալեության",
        "Հոնկոնգի",
        "Հովդի",
        "వాయవ్య",
        "మారిషస్",
        "మగడాన్",
        "మకావ్",
        "Πονάπε",
        "Իրանի",
        "Իրկուտսկի",
        "Իսրայելի",
        "Ճապոնիայի",
        "Ղազախստանի",
        "Կորեայի",
        "హోవ్",
        "Կրասնոյարսկի",
        "లార్డ్",
        "క్రాస్నోయార్స్క్",
        "Լորդ",
        "Հաուի",
        "కొరియన్",
        "Մագադանի",
        "కామ్ఛాట్స్కి",
        "పెట్రోపావ్లోవ్స్క్",
        "జపాన్",
        "ఇజ్రాయిల్",
        "Մավրիկիոսի",
        "ఇరక్వుట్స్క్",
        "Հյուսիսարևմտյան",
        "Πιονγιάνγκ",
        "խաղաղօվկիանոսյան",
        "Ուլան",
        "Բատորի",
        "Մոսկվայի",
        "ఇరాన్",
        "Ρεϊνιόν",
        "హోవ్డ్",
        "Ροθέρα",
        "Կալեդոնիայի",
        "Զելանդիայի",
        "Նյուֆաունդլենդի",
        "హాంకాంగ్",
        "అల్యూషియన్",
        "Ֆերնանդու",
        "դի",
        "Նորոնյայի",
        "Նովոսիբիրսկի",
        "Օմսկի",
        "Պակիստանի",
        "హవాయ్",
        "ᎠᎴᏈᏯ",
        "Σάμαρας",
        "Պարագվայի",
        "Պերուի",
        "Ֆիլիպինների",
        "Σαμάρας",
        "Սեն",
        "Պիեռ",
        "Միքելոնի",
        "గయానా",
        "ఫ్రెంచ్",
        "ఫిజీ",
        "ఫాక్‌ల్యాండ్",
        "हाँगकॉंग",
        "Սախալինի",
        "Սամոայի",
        "ఈస్టర్",
        "క్యూబా",
        "కుక్",
        "కొలంబియా",
        "Σεϋχελλών",
        "Σιγκαπούρης",
        "చోయిబల్సాన్",
        "Թայպեյի",
        "చైనా",
        "చిలీ",
        "Տոնգայի",
        "చాథమ్",
        "Թուրքմենստանի",
        "వెర్డె",
        "Ուրուգվայի",
        "Ուզբեկստանի",
        "Վանուատույի",
        "కేప్",
        "Վլադիվոստոկի",
        "Վոլգոգրադի",
        "బ్రెజిలియా",
        "బంగ్లాదేశ్",
        "అజోర్స్",
        "అజర్బైజాన్",
        "Յակուտսկի",
        "Եկատերինբուրգի",
        "Σολομώντα",
        "Σουρινάμ",
        "Σίοβα",
        "Αϊτής",
        "ᎠᎵᎻᏂᎠ",
        "Τατζικιστάν",
        "Τοκελάου",
        "የመካከለኛ",
        "Pegunungan",
        "Bagian",
        "Brasil",
        "Τσουκ",
        "ᎠᏏᎵᏆᏌᏂ",
        "Tiongkok",
        "Τουβαλού",
        "ᎠᏐᎴᏏ",
        "ᏆᏂᎦᎵᏕᏍ",
        "Uruguái",
        "Paskah",
        "Βενεζουέλας",
        "Якуцкі",
        "ᏆᏏᎵᏯ",
        "Prancis",
        "అట్లాంటిక్",
        "Βόστοκ",
        "Γουέικ",
        "ఆర్మేనియా",
        "Ουόλις",
        "Φουτούνα",
        "అరేబియన్",
        "అక్టోబె",
        "Jepang",
        "అక్వాటు",
        "Екацярынбургскі",
        "ఏపియా",
        "Uzbequistán",
        "ᎢᎬᎾᏕᎾ",
        "ᎢᏤᏳᏍᏗ",
        "Selandia",
        "అనాన్డ్రి",
        "Volgográu",
        "ᏣᏝᎻ",
        "ᏥᎵ",
        "మౌంటెయిన్",
        "ᏓᎶᏂᎨᏍᏛ",
        "ᏦᏱᏆᎵᏌᏂ",
        "Suður",
        "Cocoseilande",
        "ईरकुर्त्स्क",
        "Afríku",
        "ईस्राइल",
        "Yekaterimburgu",
        "Amasónsvæðinu",
        "miðhluta",
        "ᎪᎸᎻᏈᎢᎠ",
        "ᎠᏓᏍᏓᏴᎲᏍᎩ",
        "austurhluta",
        "Klettafjöllum",
        "ᎫᏆ",
        "Apía",
        "Arabíu",
        "पेत्रोपावलोस्क",
        "Armeníu",
        "Atlantshafssvæðinu",
        "कामचटका",
        "miðvesturhluta",
        "Aserbaídsjan",
        "Asóreyjum",
        "Bangladess",
        "क़ज़ाख़स्तान",
        "అమెజాన్",
        "Brasilíu",
        "అల్మాటి",
        "Grænhöfðaeyjum",
        "staðaltími",
        "Síle",
        "Kína",
        "कोरिया",
        "అలాస్కా",
        "Kólumbíu",
        "Cooks",
        "ᏥᏌᏕᎴᎯᏌᏅ",
        "Əfqanıstan",
        "Kúbu",
        "क्रासनोयार्स्क",
        "ᏩᎩ",
        "ᏫᏥ",
        "የፋልክላንድ",
        "Páskaeyju",
        "लंका",
        "የፊጂ",
        "लार्ड़",
        "होव",
        "Falklandseyjum",
        "Fídjíeyjum",
        "माकाऊ",
        "मगदन",
        "ఏకర్",
        "የፈረንሳይ",
        "मालदीव",
        "Georgíu",
        "የተራራ",
        "Bhoetan",
        "የፓስፊክ",
        "मॉरिशीयस",
        "मॉसन",
        "Aleúta",
        "ACDT",
        "ACWST",
        "ACWDT",
        "AEST",
        "Íran",
        "Kóreu",
        "AEDT",
        "AWST",
        "AWDT",
        "LHST",
        "LHDT",
        "NZST",
        "Máritíus",
        "Norðvestur",
        "NZDT",
        "Úlan",
        "Moskvu",
        "Rập",
        "Ả",
        "ᎠᎵᎢᎵᏒ",
        "Kaledóníu",
        "Nýja",
        "Sjálandi",
        "Nýfundnalandi",
        "मँगोलिया",
        "HKT",
        "Paragvæ",
        "Filippseyjum",
        "HKST",
        "Sankti",
        "Samóa",
        "Амазонско",
        "ᎭᏩᏱ",
        "núi",
        "ᎠᎵᏳᏏᎠᏂ",
        "ᎰᏂᎩ",
        "ᎪᏂᎩ",
        "ᎰᏩᏗ",
        "Fenikseilande",
        "Túrkmenistan",
        "britanică",
        "Úrúgvæ",
        "Úsbekistan",
        "Vanúatú",
        "नेपाल",
        "Irlandei",
        "የጂዮርጂያ",
        "ᎢᎳᏂ",
        "ᎢᎫᏥᎧ",
        "ᎢᏏᎵᏱ",
        "ᏣᏩᏂᏏ",
        "ᎧᏎᎧᏍᏕᏂ",
        "ᎪᎵᎠᏂ",
        "न्युज़ीलैण्ड",
        "ᏝᏍᏃᏯᏍᎧ",
        "न्युफाऊंडलैण्ड",
        "standaard",
        "ᎤᎬᏫᏳᎯ",
        "ᎭᏫ",
        "नॉरफोक",
        "ᎹᎦᏓᏂ",
        "फेरनान्दो",
        "द",
        "ਬ੍ਰਿਟਿਸ਼",
        "Апия",
        "ᎼᎵᏏᎥᏍ",
        "Арабско",
        "ᏧᏴᏢ",
        "नोवोसीबीर्स्क",
        "ᎤᎳᏂ",
        "ᏆᏙᎸ",
        "ᎹᏍᎦᏫ",
        "Аржентинско",
        "Западноаржентинско",
        "पलाऊ",
        "ᎧᎵᏙᏂᎠᏂ",
        "ᏏᎢᎴᏂᏗ",
        "ᎢᏤᎤᏂᏩᏛᏓᎦᏙᎯ",
        "Арменско",
        "атлантическо",
        "ᏪᎾᏅᏙ",
        "Ꮥ",
        "ᏃᎶᎾᎭ",
        "ᏃᏬᏏᏈᏍᎧ",
        "ᎣᎻᏍᎧ",
        "ᏆᎩᏍᏖᏂ",
        "पारागुए",
        "ਆਇਰਿਸ਼",
        "फीलीपीन्स",
        "ᏆᎵᏇ",
        "ᏇᎷ",
        "ᎠᏂᏈᎵᎩᏃ",
        "halfsomertyd",
        "ᎤᏓᏅᏘ",
        "ᏈᏰ",
        "đông",
        "ᎻᏇᎶᏂ",
        "सेँ",
        "trung",
        "BOT",
        "पीयॅर",
        "Азербайджанско",
        "मीकलों",
        "Азорски",
        "ᏌᎧᎵᏂ",
        "ᏌᎼᎠ",
        "ECT",
        "Centroccidental",
        "बेलायती",
        "Océano",
        "PET",
        "PEST",
        "雅庫次克夏令時間",
        "雅庫次克標準時間",
        "Бангладешко",
        "क़ीज़ीलोर्डा",
        "britisk",
        "ᏔᏱᏇ",
        "የሃዋይ",
        "सख़ालीन",
        "ᏙᎾᎦ",
        "Бразилско",
        "Lõuna",
        "ᏛᎵᎩᎺᏂᏍᏔᏂ",
        "Almatõ",
        "Amazonase",
        "Ameerika",
        "Idaranniku",
        "Mäestikuvööndi",
        "አሌኡት",
        "ᏳᎷᏇ",
        "Anadõri",
        "ᎤᏍᏇᎩᏍᏖᏂ",
        "Araabia",
        "Armeenia",
        "Atlandi",
        "ᏩᏄᏩᏚ",
        "Aserbaidžaani",
        "Assooride",
        "Bangladeshi",
        "सेशेल्स",
        "ᏭᎳᏗᏬᏍᏙᎩ",
        "Brasiilia",
        "Roheneemesaarte",
        "ᏬᎶᎪᏝᏗ",
        "Chathami",
        "Tšiili",
        "Hiina",
        "Tšojbalsani",
        "萬那杜夏令時間",
        "萬那杜標準時間",
        "Cooki",
        "Vaxt",
        "የሆንግ",
        "Kuuba",
        "Tojikiston",
        "ᏯᎫᏥᎧ",
        "Georgiya",
        "Lihavõttesaare",
        "Seyshel",
        "ᏰᎧᏖᎵᏂᏊᎦ",
        "Reyunion",
        "Acrejský",
        "ኮንግ",
        "Falklandi",
        "የሆቭድ",
        "Prantsuse",
        "Чатъм",
        "Gvineya",
        "Чилийско",
        "Niuye",
        "Китайско",
        "Gruusia",
        "吐瓦魯時間",
        "Чойбалсанско",
        "Západoafrický",
        "Guami",
        "Aljašský",
        "Qirgʻiziston",
        "Aleuudi",
        "Hongkongi",
        "Hovdi",
        "Almatský",
        "Amazonský",
        "Iraani",
        "Iisraeli",
        "Jaapani",
        "Kamtšatka",
        "Kasahstani",
        "የህንድ",
        "centrální",
        "Howe’i",
        "východní",
        "Magadani",
        "टॉंगा",
        "Hindixitoy",
        "Hindiston",
        "irsk",
        "तुर्कमेनीस्तान",
        "Saarte",
        "Mauritiuse",
        "Apijský",
        "Loode",
        "Aktauský",
        "Ulaanbaatari",
        "Gayana",
        "ko‘rfazi",
        "Aktobský",
        "Kaledoonia",
        "Meremaa",
        "Newfoundlandi",
        "Fors",
        "Arabský",
        "Pakistani",
        "Argentinský",
        "o‘rtacha",
        "Peruu",
        "Filipiini",
        "Grinvich",
        "Pierre’i",
        "Miqueloni",
        "Západoargentinský",
        "Gambye",
        "Kõzõlorda",
        "hududlari",
        "Sahhalini",
        "Gvianasi",
        "Minsk",
        "Arménský",
        "Atlantický",
        "d’Yurvil",
        "Türkmenistani",
        "Usbekistani",
        "Vladivostoki",
        "Volgogradi",
        "Dyumon",
        "Deyvis",
        "yarim",
        "Středoaustralský",
        "Rojdestvo",
        "Středozápadní",
        "australský",
        "Východoaustralský",
        "Západoaustralský",
        "Ázerbájdžánský",
        "Azorský",
        "Bangladéšský",
        "Британия",
        "ऊरुगुए",
        "Alaskako",
        "Brasilijský",
        "東加夏令時間",
        "Amazoniako",
        "Kapverdský",
        "ऊज़्बेकिस्तान",
        "mendialdeko",
        "東加標準時間",
        "Anadyrreko",
        "Apiako",
        "Arabiako",
        "Argentinako",
        "Armeniako",
        "Atlantikoko",
        "erdi",
        "Azerbaijango",
        "Azoreetako",
        "Bangladesheko",
        "वनुआटु",
        "Dorussalom",
        "Brasiliako",
        "Bruney",
        "Verdeko",
        "Chathamský",
        "Chathamgo",
        "Txileko",
        "Txinako",
        "Choibalsango",
        "Chilský",
        "Čínský",
        "Kolonbiako",
        "Čojbalsanský",
        "Kubako",
        "वेनेज़ुएला",
        "व्लादीवॉस्तॉक",
        "Kokosových",
        "वॉलगोग्राद",
        "Pazko",
        "Kolumbijský",
        "Колумбийско",
        "የአፒያ",
        "የኢራን",
        "Fijiko",
        "Kubánský",
        "Кубинско",
        "Dumonta",
        "याकुट्स्क",
        "येकातेरीनाबुर्ग",
        "Velikonočního",
        "蘇利南時間",
        "Středoevropský",
        "SEČ",
        "Afgʻoniston",
        "Ўзбекистон",
        "Туркманистон",
        "Aleutiar",
        "Kongo",
        "Hovdeko",
        "Покистон",
        "SELČ",
        "Хове",
        "Қозоғистон",
        "Irango",
        "Irkutskeko",
        "Israelgo",
        "Japoniako",
        "Kamchatskiko",
        "Koreako",
        "Исроил",
        "Krasnoyarskeko",
        "Эрон",
        "Howeko",
        "Magadango",
        "Ҳинд",
        "алеут",
        "Фолькленд",
        "Maurizioko",
        "Východoevropský",
        "영국",
        "ipar",
        "Batorreko",
        "Moskuko",
        "Západoevropský",
        "Falklandský",
        "Чатхам",
        "Fidžijský",
        "Zeelanda",
        "Ternuako",
        "Озарбайжон",
        "Noronhako",
        "Novosibirskeko",
        "Omskeko",
        "Pakistango",
        "Арманистон",
        "Арабистон",
        "Paraguayko",
        "Peruko",
        "Filipinetako",
        "Mikeluneko",
        "索羅門群島時間",
        "тинч",
        "тоғ",
        "шарқий",
        "Sakhalingo",
        "Samarako",
        "Samoako",
        "марказий",
        "新加坡標準時間",
        "塞席爾時間",
        "d’Acre",
        "antarktických",
        "Taipeiko",
        "Жанубий",
        "území",
        "სამხრეთ",
        "Tongako",
        "아일랜드",
        "Turkmenistango",
        "ალასკის",
        "ამაზონიის",
        "የእስራኤል",
        "Uruguayko",
        "აღმოსავლეთის",
        "მაუნთინის",
        "Uzbekistango",
        "Vanuatuko",
        "აპიას",
        "არაბეთის",
        "Gruzínský",
        "სომხეთის",
        "ატლანტიკის",
        "Vladivostokeko",
        "Volgogradeko",
        "აზერბაიჯანის",
        "აზორის",
        "Gilbertových",
        "ბანგლადეშის",
        "فٹونا",
        "Yakutskeko",
        "ბრაზილიის",
        "والیز",
        "ووسٹاک",
        "კაბო",
        "ვერდეს",
        "Великденски",
        "ჩატემის",
        "ჩილეს",
        "ჩინეთის",
        "დროის",
        "სარტყელი",
        "ჩოიბალსანის",
        "የጃፓን",
        "Východogrónský",
        "Západogrónský",
        "კოლუმბიის",
        "კუკის",
        "የፔትሮፓቭሎስኪ",
        "კუბის",
        "Централноевропейско",
        "zálivu",
        "Източноевропейско",
        "ካምቻትስኪ",
        "აღდგომის",
        "Hongkongský",
        "Hovdský",
        "Аљашко",
        "ფოლკლენდის",
        "ფიჯის",
        "Milad",
        "Западноевропейско",
        "Фолклендски",
        "皮特肯時間",
        "ካዛኪስታን",
        "Íránský",
        "Irkutský",
        "საქართველოს",
        "Izraelský",
        "Japonský",
        "የኮሪያ",
        "بولیوی",
        "kamčatský",
        "Irlandiya",
        "የዓረቢያ",
        "ჰავაისა",
        "ალეუტის",
        "ჰონკონგის",
        "ჰოვდის",
        "ინდოეთის",
        "Korejský",
        "Suider",
        "ირანის",
        "ირკუტსკის",
        "ისრაელის",
        "იაპონიის",
        "ყაზახეთის",
        "კორეის",
        "Krasnojarský",
        "კრასნოიარსკის",
        "Yarım",
        "Арменија",
        "ლორდ",
        "ჰაუს",
        "Rovníkových",
        "მაგადანის",
        "Атланско",
        "کریسمس",
        "Devis",
        "Macajský",
        "მავრიკის",
        "Magadanský",
        "ჩრდილო",
        "Dümon",
        "ულან",
        "ბატორის",
        "მოსკოვის",
        "d’Ürvil",
        "دیویس",
        "دومون",
        "دورویل",
        "კალედონიის",
        "ზელანდიის",
        "ნიუფაუნდლენდის",
        "Гамбие",
        "شرقی",
        "ფერნანდო",
        "დე",
        "ნორონიას",
        "ნოვოსიბირსკის",
        "ომსკის",
        "პაკისტანის",
        "Marshallových",
        "اکوادور",
        "Mauricijský",
        "პარაგვაის",
        "პერუს",
        "ფილიპინების",
        "مکان‌های",
        "სენ",
        "პიერის",
        "მიკელონის",
        "دیگر",
        "巴布亞紐幾內亞時間",
        "Severozápadní",
        "Грузинско",
        "Mexický",
        "სახალინის",
        "სამოას",
        "سرزمین‌های",
        "Ulánbátarský",
        "جنوبگان",
        "Moskevský",
        "گامبیه",
        "isikhathi",
        "گیلبرت",
        "ტაიბეის",
        "گرینویچ",
        "Средно",
        "ტონგის",
        "گوام",
        "თურქმენეთის",
        "Irlandia",
        "ურუგვაის",
        "უზბეკეთის",
        "ვანუატუს",
        "فارس",
        "ვლადივოსტოკის",
        "ვოლგოგრადის",
        "Novokaledonský",
        "Novozélandský",
        "Newfoundlandský",
        "Източногренландско",
        "იაკუტსკის",
        "ეკატერინბურგის",
        "اقیانوس",
        "هندوچین",
        "Западногренландско",
        "souostroví",
        "d’Almaty",
        "Novosibirský",
        "Pasifiku",
        "Atlantiku",
        "Sentru",
        "Omský",
        "Pákistánský",
        "Kənar",
        "Papuy",
        "Оңтүстік",
        "کوسرای",
        "የሎርድ",
        "قرقیزستان",
        "لانکا",
        "لاین",
        "Guiney",
        "тау",
        "Paraguayský",
        "мұхиты",
        "Сауд",
        "Арабиясы",
        "مکواری",
        "Peruánský",
        "مالزی",
        "Әзірбайжан",
        "مالدیو",
        "مارکوئز",
        "Filipínský",
        "Fénixových",
        "Қытай",
        "аралының",
        "Хавайско",
        "迪諾羅尼亞夏令時間",
        "迪諾羅尼亞標準時間",
        "Пасха",
        "norteamericana",
        "نائورو",
        "نپال",
        "Kyzylordský",
        "Хонконгско",
        "Ховдско",
        "Sachalinský",
        "ሆዌ",
        "نیوئه",
        "نورفولک",
        "Samojský",
        "Qvianası",
        "ماریانای",
        "شمالی",
        "britansko",
        "Гавай",
        "Antarktik",
        "Qalapaqos",
        "پالائو",
        "پاپوا",
        "گینهٔ",
        "Georgie",
        "Жапония",
        "Қазақстан",
        "新喀里多尼亞群島夏令時間",
        "Šówa",
        "فونیکس",
        "Qambier",
        "Tchajpejský",
        "پیتکایرن",
        "پوناپه",
        "мұхит",
        "Мәскеу",
        "پیونگ‌یانگ",
        "የማጋዳን",
        "ریونیون",
        "Новосібір",
        "Омбы",
        "Пәкістан",
        "روترا",
        "諾魯時間",
        "Tonžský",
        "سیشل",
        "Иранско",
        "Тайбэй",
        "سلیمان",
        "Түрікменстан",
        "جورجیای",
        "Turkmenský",
        "شووا",
        "تاهیتی",
        "Иркутско",
        "تاجیکستان",
        "توکلائو",
        "Uruguayský",
        "چوئوک",
        "Uzbecký",
        "تووالو",
        "Vanuatský",
        "Qrinviç",
        "Vladivostocký",
        "ونزوئلا",
        "Volgogradský",
        "Jakutský",
        "وستوک",
        "Jekatěrinburský",
        "والیس",
        "Японско",
        "irsko",
        "Acren",
        "Камчатски",
        "ब्रिटिश",
        "Körfəz",
        "Корейско",
        "Qayana",
        "Красноярско",
        "برٹش",
        "Etelä",
        "montañes",
        "Alaskan",
        "Almatyn",
        "Amazonin",
        "Mynyddoedd",
        "keskinen",
        "itäinen",
        "Kalliovuorten",
        "norteamericanes",
        "Anadyrin",
        "Apian",
        "Aqtaw’n",
        "Aqtöben",
        "Saudi",
        "Tawel",
        "Armenian",
        "Kanadan",
        "Atlantin",
        "Läntisen",
        "Azerbaidžanin",
        "Azorien",
        "Bangladeshin",
        "Arabaidd",
        "Магаданско",
        "Brasilian",
        "وینزوئیلا",
        "Antarktiese",
        "Verden",
        "Iwerydd",
        "የማውሪሺየስ",
        "Chathamin",
        "Chilen",
        "Kiinan",
        "Tšoibalsan",
        "ٹوالو",
        "Aserbaijan",
        "Kolumbian",
        "Cookinsaarten",
        "Kuuban",
        "چوک",
        "በጋ",
        "ٹوکیلاؤ",
        "Pääsiäissaaren",
        "تاجکستان",
        "Okeanı",
        "تئی",
        "Falklandinsaarten",
        "Fidžin",
        "Ranskan",
        "Мавриций",
        "تائی",
        "تاہیتی",
        "سولمن",
        "سیشلیز",
        "Y",
        "Hindçin",
        "ሰሜናዊ",
        "روتھیرا",
        "ምእራብ",
        "یونین",
        "ری",
        "یانگ",
        "Havaijin",
        "Aleuttien",
        "Hongkongin",
        "Hovdin",
        "Intian",
        "پیانگ",
        "پوناپے",
        "Pasg",
        "Iranin",
        "អាល់ដ្យូសិន",
        "Irkutskin",
        "Israelin",
        "Japanin",
        "Kamtšatkan",
        "Kazakstanin",
        "پٹکائرن",
        "Krasnojarskin",
        "Мексиканско",
        "Уланбаторско",
        "Falklands/Malvinas",
        "Howen",
        "Macaon",
        "فینکس",
        "Magadanin",
        "Московско",
        "የአርመኒያ",
        "ፓሲፊክ",
        "گنی",
        "Mauritiuksen",
        "پاپوآ",
        "Luoteis",
        "Новокаледонско",
        "Batorin",
        "Moskovan",
        "پلاؤ",
        "Залив",
        "نورنہا",
        "模里西斯夏令時間",
        "Kaledonian",
        "Seelannin",
        "Newfoundlandin",
        "Новозеландско",
        "نارفوک",
        "Noronhan",
        "نیئو",
        "模里西斯標準時間",
        "Novosibirskin",
        "Omskin",
        "Pakistanin",
        "Нюфаундлендско",
        "d’Aqtau",
        "Paraguayn",
        "Perun",
        "Filippiinien",
        "d’Aqtobe",
        "Pierren",
        "Miquelonin",
        "نیپال",
        "រដូវ​ក្ដៅ",
        "ناؤرو",
        "Siapan",
        "Qızılordan",
        "d’Arabia",
        "Arglwydd",
        "Sahalinin",
        "Samaran",
        "Samoan",
        "Korse",
        "ماؤسن",
        "Orllewin",
        "مارشل",
        "مارکیسس",
        "مالدیپ",
        "Taipein",
        "ملیشیا",
        "میگیدن",
        "Tongan",
        "مگادان",
        "Turkmenistanin",
        "مکوآری",
        "Uruguayn",
        "Uzbekistanin",
        "Vanuatun",
        "Нороня",
        "Vladivostokin",
        "Volgogradin",
        "Pasiffig",
        "لائن",
        "និង​មីគុយឡុង",
        "کرغستان",
        "کریسنویارسک",
        "Jakutskin",
        "Jekaterinburgin",
        "Новосибирско",
        "Moscfa",
        "Омско",
        "Seland",
        "Timog",
        "Periw",
        "Пакистанско",
        "Qırğızıstan",
        "የኡላን",
        "Парагвайско",
        "Karaniwang",
        "Bundok",
        "Перуанско",
        "Atlantiko",
        "馬可薩斯時間",
        "Kanluran",
        "کرسنویارسک",
        "کوسرے",
        "Tyrcmenistan",
        "Wsbecistan",
        "Филипинско",
        "ባቶር",
        "Пиер",
        "Afghansk",
        "Makari",
        "Hilagang",
        "kanlurang",
        "Centralafrikansk",
        "Østafrikansk",
        "Sydafrikansk",
        "Miðafrika",
        "Eysturafrika",
        "Suðurafrika",
        "d’Armenia",
        "Atlánticu",
        "የሞስኮ",
        "Markesas",
        "Bretland",
        "Реюнион",
        "Stóra",
        "Сахалинско",
        "d’Azerbaixán",
        "Самоанско",
        "Írsk",
        "የአትላንቲክ",
        "Bangladex",
        "ካሌዶኒያ",
        "Джорджия",
        "Jólaoyggj",
        "Kokosoyggjar",
        "ዚላንድ",
        "Eysturtimor",
        "የኒውፋውንድላንድ",
        "Cabu",
        "ಅಮೆಜಾನ್",
        "Тайпе",
        "longri",
        "Bhutanesisk",
        "Boliviansk",
        "eilande",
        "ಪೂರ್ವದ",
        "ಪರ್ವತ",
        "بریتانیا",
        "ಅನಡೀರ್‌",
        "ಅಪಿಯಾ",
        "ಅರೇಬಿಯನ್",
        "Fronsku",
        "sunnaru",
        "ಅರ್ಮೇನಿಯ",
        "ಅಟ್ಲಾಂಟಿಕ್",
        "landaøki",
        "ಅಜರ್ಬೈಜಾನ್",
        "ಅಜೋರಸ್",
        "ಬಾಂಗ್ಲಾದೇಶ",
        "Antarktis",
        "Gilbertoyggjar",
        "ಬ್ರೆಸಿಲಿಯಾ",
        "የፈርናንዶ",
        "Туркменистанско",
        "ಕೇಪ್",
        "ವರ್ಡ್",
        "Indiahav",
        "ಚಥಾಮ್",
        "ಚಿಲಿ",
        "ಚೀನಾ",
        "Уругвайско",
        "Cocosøerne",
        "Узбекистанско",
        "Kirgisia",
        "Lineoyggjar",
        "Macquariesoyggj",
        "ಕೊಲಂಬಿಯಾ",
        "ಕುಕ್",
        "Maldivoyggjar",
        "ಕ್ಯೂಬಾ",
        "Marshalloyggjar",
        "ዲ",
        "(Burma)",
        "Владивостокско",
        "Østtimor",
        "ಈಸ್ಟರ್",
        "Norfolksoyggj",
        "Nýguinea",
        "Волгоградско",
        "ಫಾಲ್ಕ್‌ಲ್ಯಾಂಡ್",
        "ಫಿಜಿ",
        "ಫ್ರೆಂಚ್",
        "ಗಯಾನಾ",
        "Phoenixoyggjar",
        "Pitcairnoyggjar",
        "Seyskelloyggjar",
        "Singapor",
        "Salomonoyggjar",
        "Suðurgeorgiaoyggjar",
        "Tadsjikistan",
        "Ecuadoriansk",
        "Wakeoyggj",
        "Futunaoyggjar",
        "Qvineya",
        "ಹವಾಯಿ",
        "ಅಲ್ಯುಟಿಯನ್",
        "ಹಾಂಗ್",
        "ಕಾಂಗ್",
        "ಹವ್ಡ್",
        "Уейк",
        "Fjernøsteuropæisk",
        "Уолис",
        "Якутскско",
        "ಇಂಡೋನೇಷಿಯಾ",
        "Екатеринбургско",
        "ಇರಾನ್",
        "ಇರ್‌ಕುಟಸ್ಕ್",
        "ಇಸ್ರೇಲ್",
        "ಜಪಾನ್",
        "ಪೆತ್ರೋಪಾವ್ಲೋಸ್ಕ್‌‌",
        "ಕಮ್ಚತ್ಸ್‌ಕೀ",
        "ಕಜಕಿಸ್ತಾನ್",
        "ಕೊರಿಯನ್",
        "আফগানিস্তান",
        "ಕ್ರಾಸ್‌ನೊಯಾರ್ಸ್ಕ್",
        "Franske",
        "Sydlige",
        "ಲಾರ್ಡ್",
        "ಹೋವ್",
        "ایرلند",
        "Antarktiske",
        "ಮಗಡಾನ್",
        "Territorier",
        "Jekaterinburški",
        "Volgograjski",
        "Vladivostoški",
        "ಮಾರಿಷಸ್",
        "Vanuatujski",
        "ವಾಯವ್ಯ",
        "ಮೆಕ್ಸಿಕೊ",
        "ಮೆಕ್ಸಿಕನ್",
        "ಉಲನ್",
        "ಬ್ಯಾಟರ್",
        "ಮಾಸ್ಕೋ",
        "Uzbekistanski",
        "Urugvajski",
        "Turkmenistanski",
        "ಹೊಸ",
        "ಕ್ಯಾಲೆಡೋನಿಯಾ",
        "Otok",
        "ನ್ಯೂಜಿಲ್ಯಾಂಡ್",
        "ನ್ಯೂಫೌಂಡ್‌ಲ್ಯಾಂಡ್",
        "Tongovski",
        "Tajpejski",
        "Samoanski",
        "Samarski",
        "ನೊರೊನ್ಹಾ",
        "Sahalinski",
        "Perujski",
        "ನೊವೊಸಿಬಿರ್‌ಸ್ಕ್",
        "ಒಮಾಸ್ಕ್",
        "ಪಾಕಿಸ್ತಾನ",
        "Paragvajski",
        "Pakistanski",
        "Noronški",
        "Novofundlandski",
        "ಪರಾಗ್ವೇ",
        "ಪೆರು",
        "ಫಿಲಿಫೈನ್",
        "Novozelandski",
        "ಸೇಂಟ್",
        "ಪಿಯರ್",
        "ಮಿಕ್ವೆಲನ್",
        "Novokaledonijski",
        "Moskovski",
        "Ulanbatorski",
        "pacifiški",
        "severozahodni",
        "ಸ್ಯಾಕ್‌ಹಲಿನ್",
        "ಸಮರ",
        "ಸಮೋವಾ",
        "Indië",
        "Mauricijski",
        "kazahstanski",
        "Japonski",
        "Izraelski",
        "Iranski",
        "ತೈಪೆ",
        "Gilbertøerne",
        "Hovdski",
        "ಟೊಂಗಾ",
        "Hongkonški",
        "ತುರ್ಕ್‌ಮೇನಿಸ್ತಾನ್",
        "Havajski",
        "ಉರುಗ್ವೇ",
        "ಉಜ್ಬೇಕಿಸ್ತಾನ್",
        "ವನೌತು",
        "Zahodnogrenlandski",
        "ವ್ಲಾಡಿವೋಸ್ಟೋಕ್",
        "ವೋಲ್ಗೋಗಾರ್ಡ್",
        "Vzhodnogrenlandski",
        "Gruzijski",
        "آئرش",
        "ምስራቅ",
        "ಯಾಕುಟ್ಸಕ್",
        "Fidžijski",
        "Falklandsko",
        "Golflandene",
        "Indisk",
        "Indiske",
        "아프가니스탄",
        "Βρετανίας",
        "중앙아프리카",
        "동아프리카",
        "남아프리카",
        "የኦምስክ",
        "Centralindonesisk",
        "Østindonesisk",
        "Vestindonesisk",
        "የፓኪስታን",
        "Ιρλανδίας",
        "Britiski",
        "Østkasakhstansk",
        "산악",
        "산지",
        "Vestkasakhstansk",
        "আমাজন",
        "Kirgisisk",
        "Langa",
        "Linjeøerne",
        "অ্যামাজন",
        "Malaysisk",
        "Maldivisk",
        "Marshalløerne",
        "ምዕራባዊ",
        "የአዘርባይጃን",
        "yay",
        "Myanmarsk",
        "Nepalesisk",
        "Seyşel",
        "부탄",
        "볼리비아",
        "Sinqapur",
        "브루나이",
        "የፓራጓይ",
        "Nordmarianerne",
        "케이시",
        "차모로",
        "Corciya",
        "Ny",
        "የፔሩ",
        "የፊሊፒን",
        "크리스마스섬",
        "코코스",
        "Britisk",
        "Phoenixøen",
        "Seychellisk",
        "절반",
        "Singaporeansk",
        "데이비스",
        "뒤몽뒤르빌",
        "동티모르",
        "Salomonøerne",
        "에콰도르",
        "ቅዱስ",
        "Tahitisk",
        "극동",
        "Tadsjikisk",
        "Fixi",
        "የፒዬር",
        "আর্জেনটিনার",
        "ሚኴሎን",
        "남부",
        "식민지",
        "및",
        "남극",
        "갈라파고스",
        "감비에",
        "Venezuelansk",
        "길버트",
        "그리니치",
        "Wakeøen",
        "걸프만",
        "Irsk",
        "Vaunatu",
        "የአዞረስ",
        "የባንግላዴሽ",
        "인도",
        "인도양",
        "인도차이나",
        "雅庫茨克夏令時間",
        "Britansko",
        "Afganistansko",
        "ভুটান",
        "Centralnoafričko",
        "Istočnoafričko",
        "Južnoafričko",
        "বোলিভিয়া",
        "조선",
        "코스라에섬",
        "Irsko",
        "키르기스스탄",
        "라인",
        "ব্রুনেই",
        "দারুসসালাম",
        "所羅門群島時間",
        "매쿼리섬",
        "የሳክሃሊን",
        "말레이시아",
        "몰디브",
        "마르키즈",
        "마셜",
        "চামেরো",
        "모슨",
        "新加坡時間",
        "塞舌爾時間",
        "গ্রীষ্মকাল",
        "የሳማራ",
        "미얀마",
        "나우루",
        "네팔",
        "Заходнеафрыканскі",
        "ক্রিসমাস",
        "የሳሞዋ",
        "니우에",
        "노퍽섬",
        "কোকোস",
        "ব্রিটিশ",
        "আইরিশ",
        "Аляскі",
        "بحر",
        "অর্ধেক",
        "팔라우",
        "파푸아뉴기니",
        "雅庫茨克標準時間",
        "ডেভিস",
        "ডুমন্ট",
        "피닉스",
        "দ্য’উরভিলে",
        "وچ",
        "핏케언",
        "포나페",
        "평양",
        "Îles",
        "레위니옹",
        "로데라",
        "d’Hawaï",
        "টিমর",
        "جلبرٹ",
        "세이셸",
        "싱가포르",
        "솔로몬",
        "사우스",
        "조지아",
        "수리남",
        "쇼와",
        "타히티",
        "Амазонскі",
        "타지키스탄",
        "토켈라우",
        "ইকুয়েডর",
        "추크",
        "Британско",
        "투발루",
        "centrâl",
        "Butansko",
        "orientâl",
        "베네수엘라",
        "ocidentâl",
        "Mosche",
        "보스톡",
        "웨이크섬",
        "월리스푸투나",
        "Bolivijsko",
        "অতিরিক্ত",
        "대한민국",
        "اٮ۪کرے",
        "گیمبیئر",
        "Brunejsko",
        "Sintraal",
        "Zahodnoevropski",
        "ইউরোপীয়",
        "Sûd",
        "Čamorsko",
        "جنوٗبی",
        "цэнтральны",
        "اٮ۪لاسکا",
        "ўсходні",
        "اٮ۪لمٮ۪ٹی",
        "اٮ۪مَزَن",
        "ماونٹین",
        "پیسِفِک",
        "Vzhodnoevropski",
        "Srednjeevropski",
        "اٮ۪کٹاؤ",
        "اٮ۪کٹوب",
        "ارٮ۪بِیَن",
        "Arabyske",
        "ارمیٖنِیا",
        "اٮ۪ٹلانٹِک",
        "горны",
        "গায়ানা",
        "otok",
        "Velikonočni",
        "اَزَربیجان",
        "اٮ۪زورٕس",
        "Kubanski",
        "بَنٛگلادیش",
        "Cookovootoški",
        "Kolumbijski",
        "برٮ۪سِلِیا",
        "Ціхаакіянскі",
        "আন্টার্কটিক",
        "Božićnom",
        "Kitajski",
        "Čilski",
        "Čatamski",
        "Brasilski",
        "چِلی",
        "چَینا",
        "کوےبٮ۪لسَن",
        "Bangladeški",
        "Azorski",
        "Azerbeidzjaanske",
        "کولومبِیا",
        "کُک",
        "Azerbajdžanski",
        "کیوٗبا",
        "গালাপাগোস",
        "گالاپاگوز",
        "انٹارکٹک",
        "Brazyljaanske",
        "Atlantski",
        "Armenski",
        "ایٖسٹَر",
        "গ্যাম্বিয়ার",
        "Kaapverdyske",
        "Sileenske",
        "فاکلینڑ",
        "فیٖجی",
        "Sineeske",
        "Апіі",
        "Anadirski",
        "Pacifiški",
        "Gorski",
        "جورجِیاہُک",
        "গিলবার্ট",
        "গ্রীনিচ",
        "Centralni",
        "Amazonski",
        "Aljaški",
        "Kolombiaanske",
        "Cookeilânse",
        "মিন",
        "Kubaanske",
        "Poluljetno",
        "Zahodnoafriški",
        "حَواے",
        "اٮ۪لیوٗٹِیَن",
        "jekaterinburský",
        "کانٛگ",
        "jakutský",
        "حووڑ",
        "volgogradský",
        "vladivostocký",
        "vanuatský",
        "uzbecký",
        "uruguajský",
        "Peaskeeilânske",
        "turkménsky",
        "tonžský",
        "اِرکُٹسک",
        "اِسرٲیِلی",
        "টাইম",
        "جاپٲنۍ",
        "کَمچَٹکا",
        "کَزاکھِستان",
        "کورِیا",
        "tchajpejský",
        "کرٮ۪سنوےیارسک",
        "samojský",
        "sachalinský",
        "pierre",
        "لعاڑ",
        "filipínsky",
        "ڑےلایٔٹ",
        "مَکَعوٗ",
        "مَگَدَن",
        "peruánsky",
        "paraguajský",
        "pakistanský",
        "omský",
        "مورِشَس",
        "novosibirský",
        "مونگولِیا",
        "Саудаўскай",
        "súostrovia",
        "newfoundlandský",
        "novozélandský",
        "نِو",
        "novokaledónsky",
        "moskovský",
        "نِوزِلینڑ",
        "Falklâneilânske",
        "ulanbátarský",
        "severozápadný",
        "maurícijský",
        "magadanský",
        "krasnojarský",
        "Fijyske",
        "شُمٲلی",
        "kórejský",
        "نۄوۄسِبٔرسک",
        "اۄمسک",
        "پاکِستان",
        "japonský",
        "izraelský",
        "irkutský",
        "پیرٮ۪گوے",
        "پٔروٗ",
        "پھِلِپایِن",
        "iránsky",
        "سینٛٹ",
        "پَیری",
        "مِقیوٗلَن",
        "chovdský",
        "hongkonský",
        "قِزلوڑا",
        "západogrónsky",
        "východogrónsky",
        "سَکھٮ۪لِن",
        "سمٮ۪را",
        "سٮ۪موآ",
        "gruzínsky",
        "fidžijský",
        "falklandský",
        "západoeurópsky",
        "východoeurópsky",
        "stredoeurópsky",
        "Veľkonočného",
        "Istočnotimorsko",
        "kubánsky",
        "kolumbijský",
        "Guyaanske",
        "ٹعانٛگا",
        "čojbalsanský",
        "تُرکمٮ۪نِستان",
        "čínsky",
        "یوٗرٮ۪گوَے",
        "čilský",
        "chathamský",
        "وَنوٗاَٹوٗ",
        "kapverdský",
        "ولاڑِووسٹوک",
        "وولگوگریڑ",
        "brazílsky",
        "bangladéšsky",
        "azorský",
        "azerbajdžanský",
        "západoaustrálsky",
        "východoaustrálsky",
        "austrálsky",
        "stredozápadný",
        "উপসাগরীয়",
        "Ekvadorsko",
        "یورپی",
        "stredoaustrálsky",
        "بعید",
        "Wäß",
        "Sommerzigg",
        "গুয়ানা",
        "ier",
        "Аравіі",
        "ایکواڈور",
        "Dalekoistočnoevropsko",
        "Kapvärdejaansche",
        "Meddel",
        "Аргенцінскі",
        "Aleoetyske",
        "Weß",
        "atlantický",
        "arménsky",
        "západoargentínsky",
        "İngiltere",
        "argentínsky",
        "arabský",
        "Fidžiju",
        "ڈی’ارویلے",
        "Fidžijsko",
        "ڈومونٹ",
        "Түштүк",
        "Francuskogvajansko",
        "Iraanske",
        "Francuskoj",
        "Israëlyske",
        "Japanske",
        "Južnoj",
        "убакыт",
        "Teritoriji",
        "тоо",
        "Koreaanske",
        "Арабия",
        "Аргенціны",
        "Азербайжан",
        "apijský",
        "Капе",
        "ڈیوس",
        "Крисмас",
        "Antarktiku",
        "Galapagosko",
        "Gambijersko",
        "Дэвис",
        "д",
        "Урвил",
        "Истер",
        "východný",
        "centrálny",
        "نصف",
        "Арменіі",
        "Gilbertovim",
        "amazonský",
        "aljašský",
        "Mauritiaanske",
        "Griničko",
        "ভারতীয়",
        "Атлантычны",
        "západoafrický",
        "Жапон",
        "Казакстан",
        "ভারত",
        "යෙකටෙරින්බර්ග්",
        "Макуари",
        "Маркезас",
        "යකුට්ස්ක්",
        "Kaledonyske",
        "Жаңы",
        "Нюфаундлэнд",
        "වොල්ගොග්‍රාඩ්",
        "Сейшел",
        "ව්ලදිවෝස්ටෝක්",
        "Seelânske",
        "වනුආටු",
        "Newfoundlânske",
        "උස්බෙකිස්තාන",
        "Түркмөнстан",
        "Gvajansko",
        "ইন্দোচীন",
        "کرسمس",
        "උරුගුවේ",
        "ටර්ක්මෙනිස්තාන",
        "ටොංගා",
        "Westafrikanesch",
        "کوائبلسان",
        "Arabesch",
        "Argentinesch",
        "Westargentinesch",
        "Armenesch",
        "Zentralaustralesch",
        "/Westaustralesch",
        "Ostaustralesch",
        "Westaustralesch",
        "තායිපේ",
        "සැමෝවා",
        "සඛලින්",
        "Chilenesch",
        "Chinesesch",
        "මැකෝලන්",
        "පියරේ",
        "Kolumbianesch",
        "Cookinselen",
        "Kubanesch",
        "Ouschterinsel",
        "ශාන්ත",
        "Mëtteleuropäesch",
        "Osteuropäesch",
        "Westeuropäesch",
        "Falklandinselen",
        "Franséisch",
        "පිලිපීන",
        "පේරු",
        "Georgesch",
        "පැරගුවේ",
        "පාකිස්ථාන",
        "ඔම්ස්ක්",
        "නොවසිබිර්ස්ක්",
        "නොරොන්හා",
        "ඩි",
        "ෆර්නැන්ඩෝ",
        "Iranesch",
        "Israelesch",
        "Japanesch",
        "නිව්ෆවුන්ලන්ත",
        "නවසීලන්ත",
        "Koreanesch",
        "සෙලඩොනියානු",
        "නව",
        "මොස්කව්",
        "බාටර්",
        "Nordwest",
        "Mexikanesch",
        "Pazifik",
        "උලාන්",
        "Neikaledonesch",
        "Neiséiland",
        "Neifundland",
        "Pakistaanske",
        "Pakistanesch",
        "වයඹ",
        "Paraguayanesch",
        "Peruanesch",
        "Philippinnesch",
        "මුරුසි",
        "මෙගඩන්",
        "හෝව්",
        "ලෝර්ඩ්",
        "ක්‍රස්නොයාර්ස්ක්",
        "Tonganesch",
        "කොරියානු",
        "කසකස්තාන",
        "Jekaterinbuerg",
        "ජපාන",
        "ඊශ්‍රායල",
        "цэнтральнай",
        "ඉර්කුට්ස්ක්",
        "ඉරාන",
        "کوئبلسان",
        "හොව්ඩ්",
        "හොංකොං",
        "අලෙයුතියාන්",
        "හවායි",
        "Paraguayaanske",
        "ජෝර්ජියානු",
        "Peruaanske",
        "ගයනා",
        "ප්‍රංශ",
        "ෆිජි",
        "ෆෝක්ලන්ඩ්",
        "পশ্চিমী",
        "چینی",
        "ඊස්ටර්",
        "කියුබානු",
        "කුක්",
        "කොලොම්බියා",
        "İrlandiya",
        "චොයිබල්සාන්",
        "චීන",
        "චිලී",
        "චැතම්",
        "කේප්වේඩ්",
        "බ්‍රසීල",
        "බංගලාදේශ",
        "ඇසොර්ස්",
        "අසර්බයිජාන්",
        "Заходні",
        "Samoaanske",
        "අත්ලාන්තික්",
        "ආමේනියානු",
        "Indijskom",
        "okeanu",
        "අරාබි",
        "Indokinesko",
        "අපියා",
        "Centralnoindonezijsko",
        "කඳුකර",
        "بولیویا",
        "Istočnoindonezijsko",
        "ඇමර්සන්",
        "Tongaanske",
        "ඇලස්කා",
        "Zapadnoindonezijsko",
        "Цэнтральнай",
        "ເວລາມາດຕະຖານ",
        "ບັງກະລາເທດ",
        "بھوٹان",
        "Uruguayaanske",
        "දකුණු",
        "усходняй",
        "Vanuatuaanske",
        "заходняй",
        "Азербайджана",
        "Азорскіх",
        "Istočnokazahstansko",
        "Zapadnokazahstansko",
        "Ḥong",
        "Бангладэш",
        "Kirgistansko",
        "কোসরেই",
        "İrlanda",
        "Екатеринбуур",
        "Дьокуускай",
        "Быладьыбастыак",
        "Сахалыын",
        "Пакистаан",
        "Омскай",
        "Новосибирскай",
        "Сэйлэнд",
        "Саҥа",
        "Москуба",
        "Баатар",
        "Магадаан",
        "Красноярскай",
        "Кэриэй",
        "Казахстаан",
        "Дьоппуон",
        "Курусуун",
        "Theas",
        "কিরগিস্তান",
        "Киин",
        "Эрмээн",
        "Makvori",
        "hAmasóine",
        "Lárnach",
        "Арааб",
        "Oirthir",
        "Sléibhte",
        "লাইন",
        "Malezijsko",
        "hAraibe",
        "ແລະ",
        "Maldivsko",
        "hAirméine",
        "Atlantaigh",
        "Maršalovim",
        "Mheániarthar",
        "hAsarbaiseáine",
        "nAsór",
        "Banglaidéise",
        "皮特康時間",
        "巴布亞新畿內亞時間",
        "Bhrasília",
        "Бразільскі",
        "ম্যাককুরি",
        "Rinn",
        "費爾南多迪諾羅尼亞夏令時間",
        "ເອລູທຽນ",
        "মালয়েশিয়া",
        "Mijanmarsko",
        "Nepalsko",
        "馬爾地夫時間",
        "মালদ্বীপ",
        "মার্কেসাস",
        "Colóime",
        "آسٹریلیا",
        "Chúba",
        "মার্শাল",
        "Norfolško",
        "Cásca",
        "Pódwjacornoafriski",
        "Каба",
        "মসন",
        "Fháclainne",
        "Fhidsí",
        "Alaskojski",
        "Вердэ",
        "費爾南多迪諾羅尼亞標準時間",
        "Чатэма",
        "pódzajtšny",
        "মহসাগরীয়",
        "Ghambier",
        "Чылійскі",
        "Кітая",
        "Arabiski",
        "Чайбалсана",
        "Pódwjacornoargentinski",
        "Armeński",
        "Atlantiski",
        "Srjejźoawstralski",
        "Haváí",
        "Ailiúit",
        "Cong",
        "Srjejźopódwjacorny",
        "Papui",
        "Pódzajtšnoawstralski",
        "Pódwjacornoawstralski",
        "hIaráine",
        "Azerbajdžaniski",
        "Seapáine",
        "Phetropavlovsk",
        "Casacstáine",
        "Cóiré",
        "Acorski",
        "Bangladešski",
        "Insulei",
        "Venezuelei",
        "Lanca",
        "Surinamului",
        "麥覺理時間",
        "Mhacao",
        "Noua",
        "єкатеринбурзьким",
        "якутським",
        "Mhagadan",
        "волгоградським",
        "Nepalului",
        "Myanmarului",
        "владивостоцьким",
        "Novoj",
        "Узбекистані",
        "Mhuirís",
        "Marchize",
        "Kârgâzstan",
        "Iarthuaisceart",
        "Mheicsiceo",
        "Meicsiceach",
        "Ulánbátar",
        "Mhoscó",
        "Уругваї",
        "Nárú",
        "Туркменістані",
        "Indochinei",
        "Oceanului",
        "Indiei",
        "Golfului",
        "Gvineji",
        "Greenwhich",
        "Chaladóine",
        "ແລະ​ມິ​ກົວ​ລອນ",
        "Shéalainne",
        "Antarctice",
        "Thalamh",
        "Australe",
        "Teritoriile",
        "Franceză",
        "Éisc",
        "Fhernando",
        "îndepărtate",
        "Тайбеї",
        "Ecuadorului",
        "самарським",
        "Timorului",
        "Pacastáine",
        "сахалінським",
        "П’єр",
        "Pharagua",
        "Pheiriú",
        "Filipíneach",
        "Філіппінах",
        "Boliviei",
        "Bhutanului",
        "парагвайським",
        "Shakhalin",
        "Shamara",
        "Shamó",
        "Пакистані",
        "омським",
        "новосибірським",
        "ді",
        "Зеландії",
        "Thaipei",
        "Новій",
        "Каледонії",
        "Thonga",
        "Tuircméanastáine",
        "Meridionale",
        "Нової",
        "Uragua",
        "hÚisbéiceastáine",
        "Afganistanului",
        "Vanuatú",
        "Turcomenistão",
        "Caledônia",
        "Maurício",
        "Casaquistão",
        "Irã",
        "Groenlândia",
        "گاٛت",
        "مینجاٛیی",
        "ئستاٛنداٛرد",
        "روٙشنایی",
        "نئهادار",
        "روٙز",
        "Ako",
        "Groelândia",
        "московським",
        "Баторі",
        "Arzeibaijão",
        "মায়ানমার",
        "নাউরু",
        "Iacútsc",
        "Chathamski",
        "Chilski",
        "Chinski",
        "Aliaskos",
        "Almatos",
        "Amazonės",
        "Choibalsański",
        "নেপাল",
        "centro",
        "північнозахідним",
        "kalnų",
        "Finiks",
        "Kokosowych",
        "Anadyrės",
        "Apijos",
        "Aktobės",
        "Arabijos",
        "Kolumbiski",
        "Armėnijos",
        "Atlanto",
        "Deas",
        "Standardny",
        "Azerbaidžano",
        "Azorų",
        "Amasoin",
        "Bangladešo",
        "Centro",
        "Armênia",
        "Brazilijos",
        "Indiese",
        "Kubański",
        "Žaliojo",
        "Kyšulio",
        "Monadh",
        "新喀里多尼亞夏令時間",
        "Čatamo",
        "Čilės",
        "Kinijos",
        "Čoibalsano",
        "瑙魯時間",
        "Jatšowneje",
        "Arabach",
        "Kolumbijos",
        "Kuko",
        "Калумбійскі",
        "Kubos",
        "Reunionsko",
        "Siaraich",
        "Airmeinia",
        "Siar",
        "Velykų",
        "Srjejźoeuropski",
        "Asarbaideàin",
        "Vidurio",
        "Pódzajtšnoeuropski",
        "Kaliningradski",
        "Asorach",
        "Bangladais",
        "Fidžio",
        "Prancūzijos",
        "Pódwjacornoeuropski",
        "Маврикій",
        "Bhrasilia",
        "магаданським",
        "красноярським",
        "Gruzijos",
        "Gilberto",
        "корейським",
        "Казахстані",
        "Chip",
        "Uaine",
        "камчатським",
        "Sìne",
        "Havajų–Aleutų",
        "Honkongo",
        "Hovdo",
        "Indijos",
        "Falklandski",
        "японським",
        "Irano",
        "Izraelio",
        "Japonijos",
        "Kamčiatkos",
        "Kazachstano",
        "Korėjos",
        "ізраїльським",
        "Coloimbia",
        "іркутським",
        "іранським",
        "Lordo",
        "Cùba",
        "Magadano",
        "Ховді",
        "Гонконзі",
        "Càisge",
        "алеутським",
        "Mauricijaus",
        "Fidźiski",
        "নিউই",
        "Batoro",
        "Maskvos",
        "гавайсько",
        "নরফোক",
        "科斯瑞時間",
        "Kaledonijos",
        "Zelandijos",
        "Niufaundlendo",
        "Fàclannach",
        "Fìdi",
        "Noronjos",
        "Guidheàna",
        "Pakistano",
        "Frainge",
        "Paragvajaus",
        "Filipinų",
        "Грузії",
        "Pjero",
        "Mikelono",
        "Фіджі",
        "Фолклендських",
        "Cairtbheile",
        "Kyzylordos",
        "західноєвропейським",
        "antarktiskeho",
        "Sachalino",
        "Samaros",
        "східноєвропейським",
        "Hawai’i",
        "’s",
        "Aleutach",
        "Innseachan",
        "центральноєвропейським",
        "Кубі",
        "Taipėjaus",
        "لودیځې",
        "Tongos",
        "колумбійським",
        "Turkmėnistano",
        "Urugvajaus",
        "Uzbekistano",
        "Jekaterynburg",
        "Vladivostoko",
        "Jakuck",
        "Wołgograd",
        "Władywostok",
        "Urugwaj",
        "Jekaterinburgo",
        "Sejšelsko",
        "Singapursko",
        "Filipiny",
        "Paragwaj",
        "Nowosybirsk",
        "Ioràin",
        "Rietumāfrikas",
        "Seapaine",
        "Aļaskas",
        "Amazones",
        "Centrālais",
        "Austrumu",
        "Kalnu",
        "Gambierski",
        "Casachstàin",
        "Anadiras",
        "Apijas",
        "Arābijas",
        "pussalas",
        "Argentīnas",
        "Rietumargentīnas",
        "Armēnijas",
        "Atlantijas",
        "Choirèa",
        "Georgiski",
        "китайським",
        "austrumu",
        "Azerbaidžānas",
        "Azoru",
        "Macàthu",
        "Bangladešas",
        "Fundlandia",
        "Eilein",
        "Brazīlijas",
        "moskiewski",
        "Ułan",
        "Kaboverdes",
        "Północno",
        "Četemas",
        "Čīles",
        "Ķīnas",
        "Čoibalsanas",
        "чилійським",
        "Gilbertowych",
        "Greenwichski",
        "Kazachstan",
        "Kolumbijas",
        "бразильським",
        "Kubas",
        "Kamczacki",
        "Pietropawłowsk",
        "Japonia",
        "Lieldienu",
        "Izrael",
        "Centrāleiropas",
        "Pódzajtšnogrönlandski",
        "Mhoiriseas",
        "Pódwjacornogrönlandski",
        "Kobdo",
        "Rietumeiropas",
        "Folklenda",
        "(Malvinu)",
        "Aleuty",
        "Hawaje",
        "Solomonskim",
        "thuath",
        "Mhosgo",
        "Gruzja",
        "Азорських",
        "Fidżi",
        "Falklandy",
        "Gruzijas",
        "Азербайджані",
        "zachodnioeuropejski",
        "Austrumgrenlandes",
        "Rietumgrenlandes",
        "західноавстралійським",
        "środkowoeuropejski",
        "Ekwador",
        "Havaju–Aleutu",
        "Honkongas",
        "Hovdas",
        "Indijas",
        "Wielkanocna",
        "Wschodni",
        "Cooka",
        "Kolumbia",
        "Irānas",
        "Irkutskas",
        "Izraēlas",
        "Japānas",
        "Petropavlovskas",
        "Kamčatskas",
        "Chailleann",
        "Czojbalsan",
        "Korejas",
        "Krasnojarskas",
        "Chiny",
        "Przylądka",
        "Lorda",
        "Hava",
        "Zielonego",
        "Magadanas",
        "golfa",
        "Bangladesz",
        "Azory",
        "Azerbejdżan",
        "Maurīcijas",
        "wschodnioaustralijski",
        "Ziemeļrietumu",
        "Shealainn",
        "piekrastes",
        "Ulanbatoras",
        "Maskavas",
        "Talamh",
        "środkowo",
        "Jaunkaledonijas",
        "Jaunzēlandes",
        "Ņūfaundlendas",
        "środkowoaustralijski",
        "Èisg",
        "Noroņas",
        "Novosibirskas",
        "Omskas",
        "Pakistānas",
        "atlantycki",
        "Paragvajas",
        "Filipīnu",
        "східноавстралійським",
        "Senpjēras",
        "Mikelonas",
        "Pagastàin",
        "австралійським",
        "Półwysep",
        "центральнозахідним",
        "wschodnioamerykański",
        "Sahalīnas",
        "Samaras",
        "środkowoamerykański",
        "amazoński",
        "центральноавстралійським",
        "Paraguaidh",
        "Pearù",
        "Filipineach",
        "атлантичним",
        "Taibei",
        "вірменським",
        "Tongas",
        "zachodnioafrykański",
        "Turkmenistānas",
        "Urugvajas",
        "Uzbekistānas",
        "Qızılorda",
        "Vladivostokas",
        "Volgogradas",
        "Samotha",
        "західноаргентинським",
        "ਫੁਟੂਨਾ",
        "ਵਾਲਿਸ",
        "Jakutskas",
        "Jekaterinburgas",
        "аргентинським",
        "арабським",
        "Апіа",
        "Južnodžordžijsko",
        "гірським",
        "Hawaiisko",
        "Turcmanastàin",
        "ਵੇਕ",
        "ਵੋਸਟੋਕ",
        "центральним",
        "Uruguaidh",
        "Usbagastàn",
        "Surinamsko",
        "Амазонці",
        "Анадирско",
        "Tahićansko",
        "ਵੈਨੇਜ਼ੂਏਲਾ",
        "瓦努阿圖夏令時間",
        "западна",
        "Ерменија",
        "Tadžikistansko",
        "毛里裘斯夏令時間",
        "Čučko",
        "Кубы",
        "Азорес",
        "montaña",
        "árabe",
        "Зелениот",
        "‘Рт",
        "Четем",
        "ਟੁਵਾਲੂ",
        "Tuvaluansko",
        "Acerbaixán",
        "ਚੂਕ",
        "瓦努阿圖標準時間",
        "Велигденскиот",
        "Средноевропско",
        "Алясці",
        "Фолкландските",
        "ਟੋਕੇਲਾਉ",
        "Irański",
        "ਤਾਜਿਕਿਸਤਾਨ",
        "毛里裘斯標準時間",
        "Israelski",
        "Хаваи",
        "Алеутски",
        "ਤਾਹੀਤੀ",
        "ਸਿਓਵਾ",
        "Japański",
        "Израел",
        "Јапонија",
        "Кореја",
        "ਸੂਰੀਨਾਮ",
        "伊爾庫次克夏令時間",
        "ਸੋਲੋਮਨ",
        "ਸਿੰਗਾਪੁਰ",
        "ਸੇਸ਼ਲਸ",
        "західноафриканським",
        "Маврициус",
        "伊爾庫次克標準時間",
        "Нов",
        "Fidxi",
        "Микелан",
        "ਰੋਥੇਰਾ",
        "ਰਿਯੂਨੀਅਨ",
        "Сакалин",
        "Güiana",
        "ਪਯੋਂਗਯਾਂਗ",
        "ਪੋਨਾਪੇ",
        "എയ്ക്കർ",
        "馬克薩斯時間",
        "Venecuelansko",
        "পালাউ",
        "ਪਿਟਕੈਰਨ",
        "മധ്യ",
        "পাপুয়া",
        "Hawai",
        "Petropávlovsk",
        "Casaquistán",
        "Linijowych",
        "Magadański",
        "গিনি",
        "mexicano",
        "അൽമതി",
        "ആമസോൺ",
        "Moscova",
        "馬爾代夫時間",
        "麥夸里群島時間",
        "മൗണ്ടൻ",
        "Акрі",
        "അനാഡിർ",
        "അപിയ",
        "അഖ്തൌ",
        "അഖ്തോബ്",
        "അറേബ്യൻ",
        "Turcomenistán",
        "അർമേനിയ",
        "അറ്റ്‌ലാന്റിക്",
        "Usbequistán",
        "Marshallowych",
        "അസർബൈജാൻ",
        "അസോർസ്",
        "ബംഗ്ലാദേശ്",
        "ਫਿਨਿਕਸ",
        "Mauriciski",
        "ബ്രസീലിയ",
        "科斯雷時間",
        "dłujkowjacorny",
        "കേപ്",
        "വെർദെ",
        "ਗਿਨੀ",
        "ചാത്തം",
        "ചിലി",
        "ചൈന",
        "ਪਾਪੂਆ",
        "ਪਲਾਉ",
        "ফোনিক্স",
        "Пасхі",
        "印度支那時間",
        "伊爾庫茨克夏令時間",
        "കൊളംബിയ",
        "കുക്ക്",
        "Nepalski",
        "ക്യൂബ",
        "ਮਰਿਆਨਾ",
        "Nowokaledoniski",
        "Nowoseelandski",
        "Nowofundlandski",
        "印度標準時間",
        "ഈസ്റ്റർ",
        "ਨੋਰਫੌਕ",
        "એકર",
        "ഗ്രീഷ്മകാല",
        "ਨੀਊ",
        "ഫാക്ക്‌ലാൻഡ്",
        "ഫിജി",
        "ഫ്രഞ്ച്",
        "ഗയാന",
        "Цэнтральнаеўрапейскі",
        "Усходнееўрапейскі",
        "Pakistański",
        "পিটকেয়ার্ন",
        "ജോർജ്ജിയ",
        "ਨੇਪਾਲ",
        "ਨਾਉਰੂ",
        "ਮਿਆਂਮਾਰ",
        "পোনাপে",
        "পিয়ংইয়াং",
        "Peruski",
        "ഹവായ്",
        "അലൂഷ്യൻ",
        "ഹോങ്കോങ്ങ്",
        "ഹോഡ്",
        "ഇന്ത്യൻ",
        "દક્ષિણ",
        "রিইউনিয়ন",
        "Phoenixowych",
        "ഇറാൻ",
        "અલાસ્કા",
        "রথেরা",
        "ഇസ്രായേൽ",
        "ജപ്പാൻ",
        "പെട്രോപാവ്‌ലോസ്ക്",
        "കംചാസ്കി",
        "കസാഖിസ്ഥാൻ",
        "കൊറിയൻ",
        "ਮੌਸਨ",
        "ക്രാസ്‌നോയാർസ്‌ക്",
        "અલ્માટી",
        "ਮਾਰਸ਼ਲ",
        "ਮਾਰਕਿਸਾਸ",
        "ലോർഡ്",
        "ഹോവ്",
        "മകൌ",
        "ਮਾਲਦੀਵ",
        "മഗാദൻ",
        "ਮਲੇਸ਼ੀਆ",
        "એમેઝોન",
        "ਮੈਕਕਵੇਰੀ",
        "Miqueloński",
        "മൗറീഷ്യസ്",
        "Pitcairnowych",
        "വടക്കുപടിഞ്ഞാറൻ",
        "മെക്‌സിക്കൻ",
        "മെക്സിക്കൻ",
        "ഉലൻ",
        "ബറ്റർ",
        "يېكاتېرىنبۇرگ",
        "ਲਾਈਨ",
        "ਲੰਕਾ",
        "ਕਿਰਗਿਸਤਾਨ",
        "Ponapski",
        "માઉન્ટન",
        "കാലിഡോണിയ",
        "ന്യൂസിലാൻഡ്",
        "ന്യൂഫൗണ്ട്‌ലാന്റ്",
        "ਕੋਸਰੇ",
        "Reunionski",
        "ഫെർണാഡോ",
        "നൊറോൻഹ",
        "અનાડિર",
        "ياكۇتسك",
        "ۋولگاگراد",
        "અક્તાઉ",
        "ഓംസ്‌ക്ക്",
        "പാക്കിസ്ഥാൻ",
        "ઍક્ટોબ",
        "અરેબિયન",
        "ਇੰਡੋਨੇਸ਼ੀਆਈ",
        "പരാഗ്വേ",
        "പെറു",
        "ഫിലിപ്പൈൻ",
        "ਇੰਡੋਚਾਈਨਾ",
        "സെന്റ്",
        "പിയറി",
        "ആൻഡ്",
        "മിക്വലൻ",
        "ਮਹਾਂਸਾਗਰ",
        "ਹਿੰਦ",
        "ਭਾਰਤੀ",
        "ഖിസിലോർഡ",
        "Sachalinski",
        "ۋىلادىۋوستوك",
        "സഖാലിൻ",
        "സമാറ",
        "Samoaski",
        "આર્મેનિયા",
        "અટલાન્ટિક",
        "ਗੁਯਾਨਾ",
        "ਖਾੜੀ",
        "ਗੁਆਮ",
        "伊爾庫茨克標準時間",
        "ਮੀਨ",
        "ਗ੍ਰੀਨਵਿਚ",
        "ਗਿਲਬਰਟ",
        "തായ്‌പെയ്",
        "Заходнееўрапейскі",
        "ਗੈਂਬੀਅਰ",
        "ടോംഗ",
        "ਗਲਾਪਾਗੋਸ",
        "തുർക്ക്‌മെനിസ്ഥാൻ",
        "ਐਂਟਾਰਟਿਕ",
        "ഉറുഗ്വേ",
        "ഉസ്‌ബെക്കിസ്ഥാൻ",
        "വന്വാതു",
        "અઝરબૈજાન",
        "വ്ലാഡിവോസ്റ്റോക്",
        "വോൾഗോഗ്രാഡ്",
        "ਗੁਏਨਾ",
        "એઝોર્સ",
        "બાંગ્લાદેશ",
        "ۋانۇئاتۇ",
        "ئۆزبېكىستان",
        "യാകസ്‌ക്ക്",
        "യെക്കാറ്റരിൻബർഗ്",
        "ਹੋਰ",
        "બ્રાઝિલિયા",
        "ئۇرۇگۋاي",
        "تۈركمەنىستان",
        "કૅપ",
        "વર્ડે",
        "تەيبېي",
        "ચેતહામ",
        "ચિલી",
        "Аляскийн",
        "Амазоны",
        "ચીન",
        "Уулын",
        "Номхон",
        "ચોઇબાલ્સન",
        "Апиагийн",
        "Арабын",
        "ساخارىن",
        "Арменийн",
        "Атлантын",
        "Фалклендскіх",
        "төв",
        "قىزىلئوردا",
        "зүүн",
        "Азербайжаны",
        "Азорын",
        "Бангладешийн",
        "કોલંબિયા",
        "કુક",
        "Бразилийн",
        "ਇਕਵੇਡੋਰ",
        "Кэйп",
        "Вердийн",
        "সেশেলস",
        "Чатемын",
        "Чилийн",
        "مىكېلون",
        "Чойбалсангийн",
        "ક્યૂબા",
        "Колумбын",
        "Күүк",
        "ਤਿਮੂਰ",
        "Кубын",
        "ਡਿਉਰਵਿਲੇ",
        "ਡਿਉਮੋਂਟ",
        "ਡੇਵਿਸ",
        "Исландын",
        "پىئېر",
        "ساينىت",
        "ਅੱਧ",
        "فىلىپپىن",
        "Фолькландын",
        "Арлуудын",
        "Фижигийн",
        "Францын",
        "پېرۇ",
        "ઇસ્ટર",
        "ਕੋਕਸ",
        "پاراگۋاي",
        "ਕ੍ਰਿਸਮਸ",
        "Гүржийн",
        "Surinamski",
        "યુરોપીયન",
        "پاكىستان",
        "ئومسك",
        "نوۋوسىبىرسك",
        "ਚਾਮੋਰੋ",
        "Хавай",
        "Алеутын",
        "Конгийн",
        "Ховдын",
        "Энэтхэгийн",
        "ਕੇਸੀ",
        "ફિજી",
        "ફ્રેન્ચ",
        "Ираны",
        "Эрхүүгийн",
        "Израилийн",
        "Японы",
        "Казахстаны",
        "Солонгосын",
        "ગયાના",
        "Красноярскийн",
        "ਦਾਰੂਸਲਾਮ",
        "Хоугийн",
        "ਬਰੂਨੇਈ",
        "Магаданы",
        "نورونخا",
        "ਬੋਲੀਵੀਆ",
        "ਭੂਟਾਨ",
        "અને",
        "Мавритусын",
        "فېرناندو",
        "хойд",
        "نىۋفوئۇنلاند",
        "номхон",
        "Улаанбаатарын",
        "Москвагийн",
        "زېلاندىيە",
        "જ્યોર્જિયા",
        "كالېدونىيە",
        "সিঙ্গাপুর",
        "Каледонийн",
        "Зеландын",
        "Нью",
        "Фаундлендын",
        "موسكۋا",
        "Норонагийн",
        "Новосибирскийн",
        "Омскийн",
        "Пакистаны",
        "Tchajpejski",
        "ئۇلانباتور",
        "Парагвайн",
        "Перугийн",
        "সলোমন",
        "હવાઇ",
        "Микелоны",
        "એલ્યુશિઅન",
        "હોંગ",
        "કોંગ",
        "હોવ્ડ",
        "ભારતીય",
        "Сахалины",
        "Самоагийн",
        "蓋亞那時間",
        "ماۋرىتىئۇس",
        "Tongaski",
        "ઈરાન",
        "ઇર્કુત્સ્ક",
        "ઇઝરાઇલ",
        "જાપાન",
        "પેટ્રોપેવલોવ્સ્ક",
        "Тайпейн",
        "કામચતસ્કી",
        "કઝાકિસ્તાન",
        "Тонгагийн",
        "કોરિયન",
        "Туркменистаны",
        "ئاۋمېن",
        "Уругвайн",
        "Узбекистаны",
        "Вануатугийн",
        "ਅਫ਼ਰੀਕਾ",
        "Владивостокийн",
        "Волгоградын",
        "خاي",
        "Вейк",
        "كىراسنويارسك",
        "Якутын",
        "Екатеринбургийн",
        "كورىيە",
        "قازاقىستان",
        "كامچاتكسكى",
        "લોર્ડ",
        "હોવ",
        "મકાઉ",
        "پېتروپاۋلوۋسك",
        "મગાડન",
        "ياپونىيە",
        "ئىسرائىلىيە",
        "अल्माटी",
        "अ‍ॅमेझॉन",
        "ئىركۇتسك",
        "पर्वतीय",
        "ئىران",
        "एपिया",
        "अ‍ॅक्ताउ",
        "अ‍ॅक्टोबे",
        "अरेबियन",
        "મોરિશિયસ",
        "波斯灣海域標準時間",
        "अझरबैजान",
        "अ‍ॅझोरेस",
        "ਅਫ਼ਗਾਨਿਸਤਾਨ",
        "ઉત્તરપશ્ચિમ",
        "ब्राझिलिया",
        "рӕстӕмбис",
        "व्हर्डे",
        "चॅथम",
        "चीनी",
        "चोईबाल्सन",
        "Гринвичы",
        "મેક્સિકો",
        "મેક્સીકન",
        "ઉલાન",
        "ھىندى",
        "خوۋد",
        "મોસ્કો",
        "شياڭگاڭ",
        "ئالېيۇت",
        "ھاۋاي",
        "Turkmeniski",
        "फॉकलंड",
        "સેલેડોનિયા",
        "फ्रेंच",
        "गयाना",
        "ન્યુઝીલેન્ડ",
        "ન્યૂફાઉન્ડલેન્ડ",
        "সুরিনাম",
        "ସମୟ",
        "austeuropeisk",
        "گىرۇزىيە",
        "Uruguayski",
        "अलूशन",
        "होव्ह्ड",
        "austaustralsk",
        "گىۋىيانا",
        "इराण",
        "इर्कुत्सक",
        "इस्रायल",
        "पेट्रोपाव्हलोस्क",
        "कामचाट्स्की",
        "कझाकस्तान",
        "कोरियन",
        "قاراشلىق",
        "فىرانسىيەگە",
        "فىجى",
        "मकाऊ",
        "فالكلاند",
        "मॅगाडन",
        "Uzbekiski",
        "નોવસિબિર્સ્ક",
        "वायव्य",
        "كۇبا",
        "Vanuatski",
        "પાકિસ્તાન",
        "कॅलेडोनिया",
        "न्यूझीलंड",
        "फाउंडलंड",
        "كۇك",
        "फर्नांडो",
        "दी",
        "كولومبىيە",
        "पॅराग्वे",
        "फिलिपाइन",
        "Venezuelski",
        "पियर",
        "मिक्वेलोन",
        "પેરાગ્વે",
        "પેરુ",
        "क़िझीलोर्डा",
        "ફિલિપાઇન",
        "सखलिन",
        "सामरा",
        "सामोआ",
        "چويبالسان",
        "સેંટ",
        "પીએરે",
        "तैपेई",
        "उझबेकिस्तान",
        "वानुआतु",
        "એન્ડ",
        "व्होल्गोग्राड",
        "મિકીલોન",
        "جۇڭگو",
        "چىلى",
        "याकुत्सक",
        "येकतरिनबर्ग",
        "چاتام",
        "કિઝિલોર્ડા",
        "تۇمشۇق",
        "يېشىل",
        "સખાલિન",
        "સમારા",
        "સમોઆ",
        "بىرازىلىيە",
        "باڭلادىش",
        "ئازور",
        "ئەزەربەيجان",
        "সায়োওয়া",
        "ئاتلانتىك",
        "ئەرمېنىيە",
        "તાઇપેઇ",
        "Ħin",
        "Ċentrali",
        "Ewropew",
        "তাহিতি",
        "ئەرەب",
        "ટોંગા",
        "ئاقتۆبە",
        "તુર્કમેનિસ્તાન",
        "ئاقتاي",
        "ઉરૂગ્વે",
        "အနောက်အာဖရိက",
        "ઉઝ્બેકિસ્તાન",
        "વનાતૂ",
        "ئانادىر",
        "વ્લાડિવોસ્ટોક",
        "વોલ્ગોગ્રેડ",
        "အာမေဇုံ",
        "နွေရာသီအချိန်",
        "Фіджы",
        "তাজাখাস্তান",
        "تاغ",
        "টোকেলাউ",
        "အရှေ့ပိုင်း",
        "યાકુત્સ્ક",
        "યેકાટેરિનબર્ગ",
        "中南半島時間",
        "ئامازون",
        "চুক",
        "印度時間",
        "အာရေဗျ",
        "টুভালু",
        "דרום",
        "အာမေးနီးယား",
        "အတ္တလန်တစ်",
        "圭亞那時間",
        "အလယ်အနောက်ပိုင်း",
        "အရှေ့ဩစတြေးလျား",
        "喬治亞夏令時間",
        "အဇာဘိုင်ဂျန်",
        "အေဇိုးရီးစ်",
        "ဘင်္ဂလားဒေ့ရှ်",
        "喬治亞標準時間",
        "אלסקה",
        "ဘရာဇီး",
        "אמזונס",
        "ကိတ်ပ်",
        "ဗာဒီ",
        "波斯灣海域時間",
        "החוף",
        "המזרחי",
        "ချီလီ",
        "တရုတ်",
        "אזור",
        "ההרים",
        "בארה״ב",
        "加拉巴哥群島時間",
        "ကိုလံဘီယာ",
        "אנדיר",
        "圖瓦盧時間",
        "ကျူးဘား",
        "אפיה",
        "חצי",
        "ভেনেজুয়েলা",
        "ערב",
        "格魯吉亞夏令時間",
        "ארמניה",
        "格魯吉亞標準時間",
        "ဥရောပ",
        "အရှေ့ဥရောပ",
        "האטלנטי",
        "အနောက်ဥရောပ",
        "ဖော့ကလန်ကျွန်းစု",
        "ভসটক",
        "אזרבייג׳אן",
        "ওয়েক",
        "האזוריים",
        "בנגלדש",
        "ئالمۇتا",
        "ئالياسكا",
        "ברזיליה",
        "ဂျော်ဂျီယာ",
        "ওয়ালিস",
        "ফুটুনা",
        "כף",
        "ורדה",
        "加拉帕戈群島時間",
        "צ׳טהאם",
        "צ׳ילה",
        "厄瓜多爾時間",
        "ဟာဝိုင်ယီ",
        "အယ်လူးရှန်း",
        "ဟောင်ကောင်",
        "צ׳ויבלסן",
        "迪蒙迪維爾時間",
        "အိန္ဒိယ",
        "Грузінскі",
        "वालिस्",
        "Гілберта",
        "भास्टोक",
        "အီရန်",
        "קולומביה",
        "קוק",
        "အစ္စရေး",
        "ဂျပန်",
        "भेनेज्युएला",
        "厄瓜多時間",
        "ကိုရီးယား",
        "可可斯群島時間",
        "उरूग्वे",
        "टुभालु",
        "चुउक",
        "तोकेलाउ",
        "ताजिकस्तान",
        "קובה",
        "सुरिनामा",
        "မကာအို",
        "सोलोमोन",
        "सेयेचेलास्",
        "佛得角夏令時間",
        "Showa",
        "प्योङयाङ",
        "पिटकैरण",
        "Seyşeller",
        "မောရစ်ရှ်",
        "Усходняй",
        "အနောက်တောင်",
        "杜蒙杜比爾時間",
        "फिनिक्स",
        "הפסחא",
        "የታይፔይ",
        "पपूवा",
        "पालाउ",
        "佛得角標準時間",
        "Gine",
        "פוקלנד",
        "नोर्फल्क",
        "निउए",
        "न्यूफाउनल्यान्डको",
        "न्यूफाउनडल्यान्डको",
        "နယူးဇီလန်",
        "နယူးဖောင်လန်",
        "פיג׳י",
        "גיאנה",
        "亞塞拜疆夏令時間",
        "नेपाली",
        "नाउरु",
        "亞塞拜疆標準時間",
        "Menezioù",
        "म्वसन",
        "ပါကစ္စတန်",
        "Anadyrʼ",
        "मार्किसस",
        "ပါရာဂွေး",
        "ပီရူး",
        "ဖိလစ်ပိုင်",
        "माल्दिभ्स",
        "मलेसिया",
        "माक्वेरी",
        "Гавайска",
        "Maldivler",
        "किर्गिस्तान",
        "Malezya",
        "Kırgızistan",
        "גאורגיה",
        "科科斯群島時間",
        "Алеуцкі",
        "Ганконга",
        "Хоўда",
        "इन्डोचाइना",
        "हिन्द",
        "北美太平洋夏令時間",
        "האלאוטיים",
        "הוואי",
        "הונג",
        "मिन",
        "ထိုင်ပေ",
        "קונג",
        "ग्याम्बियर",
        "गालापागोस्",
        "अन्टार्टिक",
        "חובד",
        "တာ့ခ်မင်နစ္စတန်",
        "ग्वाना",
        "ဥရုဂွေး",
        "ဥဇဘက်ကစ္စတန်",
        "הודו",
        "Hindiçin",
        "थप",
        "ဗလာဒီဗော့စတော့ခ်",
        "Azerbaidjan",
        "ईक्वोडोर",
        "איראן",
        "टिमोर",
        "उर्भिले",
        "डी‘",
        "डुमोन्ट",
        "डेभिस",
        "Okyanusu",
        "आधा",
        "Hint",
        "ישראל",
        "østafrikansk",
        "יפן",
        "פטרופבלובסק",
        "קמצ׳טסקי",
        "קזחסטן",
        "קוריאה",
        "Körfez",
        "קרסנויארסק",
        "Azorez",
        "Ortalama",
        "הלורד",
        "האו",
        "北美太平洋標準時間",
        "מקאו",
        "北美山區夏令時間",
        "מגדן",
        "Guyanası",
        "Daha",
        "北美山區標準時間",
        "Cʼhab",
        "מאוריציוס",
        "Glas",
        "צפון",
        "維德角夏令時間",
        "אולן",
        "בטור",
        "מוסקבה",
        "Yarı",
        "維德角標準時間",
        "北美東部夏令時間",
        "קלדוניה",
        "北美東部標準時間",
        "ניו",
        "Christmasøya",
        "Kokosøyene",
        "זילנד",
        "ניופאונדלנד",
        "halv",
        "Selam",
        "østtimoresisk",
        "Darü’s",
        "פרננדו",
        "די",
        "נורוניה",
        "fjern",
        "נובוסיבירסק",
        "אומסק",
        "פקיסטן",
        "franske",
        "sørterritorier",
        "Galápagosøyene",
        "Bolivya",
        "Gilbertøyene",
        "北美中部標準時間",
        "Іранскі",
        "פרגוואי",
        "Persiabukta",
        "guyansk",
        "פרו",
        "הפיליפינים",
        "Іркуцкі",
        "Indiahavet",
        "סנט",
        "sentralindonesisk",
        "østindonesisk",
        "vestindonesisk",
        "פייר",
        "ומיקלון",
        "Pask",
        "Kreizeuropa",
        "Ізраільскі",
        "østkasakhstansk",
        "vestkasakhstansk",
        "Gwiana",
        "kirgisisk",
        "Linjeøyene",
        "亞塞拜然夏令時間",
        "Macquarieøya",
        "סחלין",
        "maldivisk",
        "Marquesasøyene",
        "Marshalløyene",
        "סמרה",
        "סמואה",
        "亞塞拜然標準時間",
        "myanmarsk",
        "naurisk",
        "nepalsk",
        "Японіі",
        "南非時間",
        "Norfolkøya",
        "Marianene",
        "d’Irán",
        "palauisk",
        "papuansk",
        "Карэі",
        "Oseaan",
        "Краснаярскі",
        "Phoenixøyene",
        "טאיפיי",
        "Jorjia",
        "seychellisk",
        "singaporsk",
        "Salomonøyene",
        "Sør",
        "surinamsk",
        "tahitisk",
        "tadsjikisk",
        "ʻiekatelinepūki",
        "Chuukøyene",
        "טונגה",
        "tuvalsk",
        "ʻiākutisiki",
        "טורקמניסטן",
        "volikokalati",
        "אורוגוואי",
        "Futunaøyene",
        "अफगानिस्तान",
        "אוזבקיסטן",
        "ונואטו",
        "valativositoki",
        "ולדיווסטוק",
        "וולגוגרד",
        "fakavanuatu",
        "fakaʻusipekitani",
        "fakaʻulukuai",
        "fakatūkimenisitani",
        "יקוטסק",
        "יקטרינבורג",
        "fakatonga",
        "irlandesa",
        "የቶንጋ",
        "湯加夏令時間",
        "भुटानी",
        "बोलिभिया",
        "ब्राजिलिया",
        "ब्राजिलीया",
        "ब्रुनाइ",
        "Kazakstán",
        "चामोर्रो",
        "Norfolkeilande",
        "अलास्‍का",
        "क्रिस्मस",
        "Магаданскі",
        "अमेज़न",
        "एपिआ",
        "ရယ်ခါးတီရင်ဘာခ်နွေရာသီအချိန်",
        "ယူခူးတ်စ်နွေရာသီအချိန်",
        "ယူခူးတ်စ်စံတော်ချိန်",
        "ဖူကျူနာ",
        "ဝေါလီစ်နှင့်",
        "ဝိတ်ခ်ကျွန်းအချိန်",
        "ဗိုစ်တိုခ်အချိန်",
        "ဗိုလ်ဂိုဂရက်နွေရာသီအချိန်",
        "ဗိုလ်ဂိုဂရက်စံတော်ချိန်",
        "ဗင်နီဇွဲလား",
        "ဗနွားတူနွေရာသီအချိန်",
        "ဗနွားတူစံတော်ချိန်",
        "တူဗားလူအချိန်",
        "ချုခ်အချိန်",
        "တွန်ဂါနွေရာသီအချိန်",
        "တွန်ဂါစံတော်ချိန်",
        "တိုကီလာဥ",
        "တာဂျစ်ကစ္စတန်",
        "တဟီတီအချိန်",
        "ရှိုဝါအချိန်",
        "စူးရီနာမ်အချိန်",
        "တောင်ဂျော်ဂျီယာ",
        "ဆော်လမွန်ကျွန်းစုအချိန်",
        "စင်္ကာပူ",
        "ဆေးရှဲ",
        "ဆမိုးအား",
        "ဆမိုးအားစံတော်ချိန်",
        "ဆာခါလင်",
        "ဆာခါလင်စံတော်ချိန်",
        "ရိုသီရာအချိန်",
        "ဟေညွန်",
        "ပြုံယန်း",
        "ဖိုနာဖဲအ်အချိန်",
        "ပါတ်ကယ်ရင်",
        "မီခွီလွန်",
        "စိန့်ပီအဲနှင့်",
        "စိန့်ပီအဲနှင့်မီခွီလွန်စံတော်ချိန်",
        "ဖီးနစ်ကျွန်းစုအချိန်",
        "ပါပူအာနယူးဂီနီ",
        "ပလာအို",
        "အွမ်းစ်ခ်နွေရာသီအချိန်",
        "အွမ်းစ်ခ်စံတော်ချိန်",
        "နိုဗိုစဲဘီအဲယ်စ်နွေရာသီအချိန်",
        "နိုဗိုစဲဘီအဲယ်စ်စံတော်ချိန်",
        "ဖာနန်ဒိုးဒီနိုးရိုးညာနွေရာသီအချိန်",
        "ဖာနန်ဒိုးဒီနိုးရိုးညာစံတော်ချိန်",
        "နောဖော့ခ်ကျွန်းအချိန်",
        "နီဦးအေအချိန်",
        "နယူးကာလီဒိုးနီးယားနွေရာသီအချိန်",
        "နယူးကာလီဒိုးနီးယားစံတော်ချိန်",
        "နီပေါ",
        "နာဥူရူအချိန်",
        "မြန်မာ",
        "မော်စကို",
        "မော်စကိုစံတော်ချိန်",
        "ဥလန်ဘာတောနွေရာသီအချိန်",
        "ဥလန်ဘာတောစံတော်ချိန်",
        "မက္ကစီကန်",
        "မက္ကဆီကန်",
        "မက္ကစီကို",
        "မက္ကဆီကို",
        "မော်စွန်အချိန်",
        "မာရှယ်ကျွန်းစုအချိန်",
        "မာခေးအပ်စ်အချိန်",
        "မော်လဒိုက်",
        "မလေးရှား",
        "မာဂါဒန်းနွေရာသီအချိန်",
        "မာဂါဒန်းစံတော်ချိန်",
        "မက်ကွယ်ရီကျွန်း",
        "လော့ဒ်ဟောင်",
        "လော့ဒ်ဟောင်စံတော်ချိန်",
        "လိုင်းကျွန်းစုအချိန်",
        "သီရိလင်္ကာ",
        "ကာဂျစ္စတန်",
        "ခရာ့စ်နိုရာစ်နွေရာသီအချိန်",
        "ခရာ့စ်နိုရာစ်စံတော်ချိန်",
        "ခိုစ်ရိုင်အချိန်",
        "အနောက်ကာဇက်စတန်အချိန်",
        "အရှေ့ကာဇက်စတန်",
        "အီရူခူတ်နွေရာသီအချိန်",
        "အီရူခူတ်စံတော်ချိန်",
        "အနောက်ပိုင်း",
        "အင်ဒိုချိုင်းနား",
        "သမုဒ္ဒရာ",
        "ဟိုးဗ်နွေရာသီအချိန်",
        "ဟိုးဗ်စံတော်ချိန်",
        "ဂိုင်ယာနာ",
        "ပင်လယ်ကွေ့",
        "ဂရင်းလန်",
        "ဂရင်းလန်း",
        "အရှေ့ဂရင်းလန်",
        "အရှေ့ဂရင်းလန်း",
        "ဂရင်းနစ်",
        "ဂီလ်ဘတ်ကျွန်းစုအချိန်",
        "ဂမ်ဘီယာ",
        "ဂါလားပါဂိုးစ်အချိန်",
        "အန္တာတိတ်အချိန်",
        "ပြင်သစ်တောင်ပိုင်းနှင့်",
        "ဂီအားနား",
        "ပြင်သစ်",
        "ဖီဂျီနွေရာသီအချိန်",
        "ဖီဂျီစံတော်ချိန်",
        "ထပ်တိုးအရှေ့ပိုင်းဥရောပအချိန်",
        "အီကွေဒေါ",
        "အီစတာကျွန်းနွေရာသီအချိန်",
        "အီစတာကျွန်းစံတော်ချိန်",
        "အရှေ့တီမော",
        "ဒါရ်ဗီးလ်အချိန်",
        "ဒူးမော့တ်",
        "ဒေးဗစ်အချိန်",
        "ကွတ်က်ကျွန်းစုနွေရာသီအချိန်",
        "ကွတ်ခ်ကျွန်းစုစံတော်ချိန်",
        "ကိုကိုးကျွန်းအချိန်",
        "ခရစ်စမတ်ကျွန်းအချိန်",
        "ချွဲဘော်ဆန်းနွေရာသီအချိန်",
        "ချွဲဘော်ဆန်းစံတော်ချိန်",
        "ချာသမ်",
        "ချားသမ်စံတော်ချိန်",
        "ချာမိုရိုအချိန်",
        "ဘရူနိုင်း",
        "ဘိုလီးဘီးယား",
        "ဘူတန်",
        "အနောက်ဩစတြေးလျား",
        "အပီယာ",
        "အပီယာစံတော်ချိန်",
        "ပစိဖိတ်စံတော်ချိန်",
        "တောင်တန်းဒေသ",
        "တောင်တန်းဒေသစံတော်ချိန်",
        "အရှေ့ပိုင်းစံတော်ချိန်",
        "အလယ်ပိုင်းစံတော်ချိန်",
        "အလားစကား",
        "အလားစကားစံတော်ချိန်",
        "တောင်အာဖရိက",
        "အရှေ့အာဖရိက",
        "အလယ်အာဖရိက",
        "အာဖဂန်နစ္စတန်",
        "Sajf",
        "tas",
        "वॉलिस",
        "व्होस्टॉक",
        "व्हेनेझुएला",
        "सुरिनाम",
        "सोलोमॉन",
        "सिंगापूर",
        "प्योंगयंँग",
        "पोनॅपे",
        "‍फोनिक्स",
        "मरिना",
        "न्युए",
        "नेपाळ",
        "नउरु",
        "मार्क्वेसास",
        "मालदिव",
        "मॅक्वेरी",
        "किरगिस्तान",
        "क्रास्नोयार्क्स",
        "कोस्राई",
        "SRT",
        "austafrikansk",
        "इंडोचायना",
        "हिंदमहासागर",
        "ग्रीनिच",
        "greenwich",
        "ଖ୍ରୀଷ୍ଟମାସ",
        "ଆଇଲ୍ୟାଣ୍ଡ",
        "गॅम्बियर",
        "ଗାଲାପାଗୋସ୍",
        "गॅलापागोस",
        "अंटार्क्टिक",
        "यूरोपीयन",
        "इक्वेडोर",
        "ड्युर्विल",
        "ड्युमॉन्ट",
        "डेव्हिस",
        "कॉकोस",
        "ख्रिसमस",
        "दारूसलाम",
        "बोलिव्हिया",
        "भूतान",
        "अफगाणिस्तान",
        "ऐकर",
        "एकर",
        "Футунагийн",
        "Востокийн",
        "Венесуэлийн",
        "Тувалугийн",
        "Чүүкийн",
        "Токелаугийн",
        "Тажикистаны",
        "Таитигийн",
        "Сёвагийн",
        "Суринамын",
        "Жоржийн",
        "арлуудын",
        "Соломоны",
        "Сингапурын",
        "Сейшелийн",
        "Ротерагийн",
        "Реюньоны",
        "Пхеньяны",
        "Понапегийн",
        "Питкернийн",
        "Пьерре",
        "ရယ်ခါးတီရင်ဘားခ်စံတော်ချိန်",
        "Палаугийн",
        "Ниуэгийн",
        "Балбын",
        "Науругийн",
        "Мьянмарын",
        "Моусоны",
        "Маршаллын",
        "Маркесасын",
        "Мальдивийн",
        "Малайзын",
        "Арлын",
        "Кыргызстаны",
        "Косрэгийн",
        "хойгийн",
        "Энэтхэг",
        "Гуяанагийн",
        "Гольфийн",
        "үндсэн",
        "Гринвичийн",
        "Жильбер",
        "Гамбьегийн",
        "Галапагосын",
        "Антарктик",
        "Гияанагийн",
        "дорнод",
        "Алс",
        "Эквадорын",
        "Тиморын",
        "д’Юрвилийн",
        "Дэвисийн",
        "хагас",
        "Чаморрогийн",
        "Дарассаламын",
        "Боливийн",
        "Бутаны",
        "Афганистаны",
        "ഫ്യൂച്യുന",
        "ആന്റ്",
        "വാലിസ്",
        "വേക്ക്",
        "വോസ്റ്റോക്",
        "വെനിസ്വേല",
        "ടുവാലു",
        "ചൂക്ക്",
        "ടോക്കെലൂ",
        "താജിക്കിസ്ഥാൻ",
        "താഹിതി",
        "സയോവ",
        "സുരിനെയിം",
        "ജോർജ്ജിയൻ",
        "ദക്ഷിണ",
        "സോളമൻ",
        "സിംഗപ്പൂർ",
        "സീഷെൽസ്",
        "സമോവാ",
        "സമോവ",
        "റോഥെറ",
        "റീയൂണിയൻ",
        "പ്യോംഗ്‌യാംഗ്",
        "പൊനാപ്പ്",
        "പിറ്റ്കേൻ",
        "ഫിനിക്‌സ്",
        "ഗിനിയ",
        "പാപ്പുവ",
        "പലാവു",
        "നോവോസിബിർസ്‌ക്",
        "നോവോസിബിർസ്ക്",
        "മറിയാനാ",
        "നോർത്ത്",
        "നോർഫാക്ക്",
        "ന്യൂയി",
        "നേപ്പാൾ",
        "നൗറു",
        "മ്യാൻമാർ",
        "മോസ്‌കോ",
        "മോസ്കോ",
        "മാസൺ",
        "മാർഷൽ",
        "മർക്കസസ്",
        "മാലിദ്വീപുകൾ",
        "മലേഷ്യ",
        "മക്വാറി",
        "ലൈൻ",
        "ലങ്ക",
        "കിർഗിസ്ഥാൻ",
        "കൊസ്ര",
        "ഇർകസ്‌ക്",
        "ഇർകസ്ക്",
        "ഇൻഡോചൈന",
        "മഹാസമുദ്ര",
        "ഗൾഫ്",
        "ഗ്വാം",
        "മീൻ",
        "ഗ്രീൻവിച്ച്",
        "ഗിൽബേർട്ട്",
        "ഗാമ്പിയർ",
        "ഗാലപ്പഗോസ്",
        "അന്റാർട്ടിക്",
        "സതേൺ",
        "കിഴക്കേയറ്റത്തെ",
        "ഇക്വഡോർ",
        "തിമോർ",
        "ഉർവില്ലെ",
        "ഡുമോണ്ട്",
        "ഡേവിസ്",
        "അർദ്ധ",
        "കൊക്കോസ്",
        "ക്രിസ്‌മസ്",
        "ചോയിബൽസാൻ",
        "ചോയ്‌ബൽസാൻ",
        "ചമോറോ",
        "ദാറുസ്സലാം",
        "ബ്രൂണൈ",
        "ബൊളീവിയ",
        "ഭൂട്ടാൻ",
        "അലാസ്‌ക",
        "അലാസ്ക",
        "ദക്ഷിണാഫ്രിക്ക",
        "അഫ്‌ഗാനിസ്ഥാൻ",
        "островот",
        "Сајова",
        "Соломонските",
        "Ријунион",
        "Пјонгјанг",
        "Мјанмар",
        "Маршалски",
        "Маркесас",
        "Островот",
        "Линиски",
        "Косра",
        "Индиски",
        "Индија",
        "Мексиканскиот",
        "Гринич",
        "Гамбе",
        "Калининградско",
        "дурвил",
        "Кокосовите",
        "Божиќниот",
        "Дарусалам",
        "Брунеи",
        "Арапско",
        "арапско",
        "Република",
        "Јужноафриканска",
        "Источноафриканско",
        "Средноафриканско",
        "Futunas",
        "Volisas",
        "Veika",
        "Vostokas",
        "Venecuēlas",
        "środkowoafrykański",
        "wschodnioafrykański",
        "południowoafrykański",
        "Čūkas",
        "Tadžikistānas",
        "Šovas",
        "Surinamas",
        "Dienviddžordžijas",
        "Zālamana",
        "Singapūras",
        "Seišeļu",
        "Roteras",
        "Reinjonas",
        "Phenjanas",
        "Ponapē",
        "Pitkērnas",
        "Fēniksa",
        "Jaungvinejas",
        "Norfolkas",
        "Nepālas",
        "Mjanmas",
        "Mosonas",
        "Māršala",
        "Marķīza",
        "Maldīvijas",
        "Boliwia",
        "Malaizijas",
        "Makvorija",
        "Lainas",
        "Czamorro",
        "Kirgizstānas",
        "Rietumkazahstānas",
        "Austrumkazahstānas",
        "Bożego",
        "Narodzenia",
        "Kokosowe",
        "Rietumindonēzijas",
        "Austrumindonēzijas",
        "Centrālindonēzijas",
        "Indoķīnas",
        "Gajānas",
        "līča",
        "Persijas",
        "dalszy",
        "Griničas",
        "Gambjē",
        "Galapagu",
        "teritorijas",
        "Francuskie",
        "Terytoria",
        "Południowe",
        "Antarktyczne",
        "Antarktikas",
        "uniwersalny",
        "Dienvidjūru",
        "Francijas",
        "Zatoka",
        "Perska",
        "Gviānas",
        "Franču",
        "(FET)",
        "indyjski",
        "Indyjski",
        "indochiński",
        "josla",
        "Środkowa",
        "laika",
        "Ekvadoras",
        "Austrumtimoras",
        "Dimondirvilas",
        "Deivisas",
        "(Kīlinga)",
        "Kokosu",
        "Sporady",
        "Środkowopolinezyjskie",
        "Malezja",
        "Malediwy",
        "Markizy",
        "Marshalla",
        "Ziemsvētku",
        "Čamorra",
        "Darusalamas",
        "Brunejas",
        "Mjanma",
        "Bolīvijas",
        "Butānas",
        "Dienvidāfrikas",
        "Gwinea",
        "Austrumāfrikas",
        "Centrālāfrikas",
        "Pjongjang",
        "Seszele",
        "Salomona",
        "Południowa",
        "Afganistānas",
        "Tadżykistan",
        "Futūnos",
        "Wenezuela",
        "Voliso",
        "Veiko",
        "Vostoko",
        "Venesuelos",
        "Čuko",
        "Tadžikistano",
        "معیاري",
        "Tahičio",
        "اورپا",
        "اوړي",
        "گرينويچ",
        "Siovos",
        "Surinamo",
        "Džordžijos",
        "Saliamono",
        "Singapūro",
        "Seišelių",
        "Roteros",
        "Reunjono",
        "Pchenjano",
        "Ponapės",
        "Pitkerno",
        "Fenikso",
        "Gvinėjos",
        "Marianos",
        "Norfolko",
        "Niujė",
        "Nepalo",
        "Mianmaro",
        "Mosono",
        "Maršalo",
        "Markizo",
        "Maldyvų",
        "Malaizijos",
        "Makvorio",
        "Laino",
        "Lankos",
        "Kirgistano",
        "Kosrajė",
        "Indokinijos",
        "Gajanos",
        "įlankos",
        "Persijos",
        "Guamo",
        "Grinvičo",
        "Gambyro",
        "Galapagų",
        "antarktinis",
        "Gvianos",
        "Folklando",
        "Folklandų",
        "Tolimųjų",
        "Ekvadoro",
        "salos",
        "Timoro",
        "d’Urvilio",
        "Diumono",
        "Deiviso",
        "pusės",
        "Kokosų",
        "Kalėdų",
        "Keisio",
        "Darusalamo",
        "Brunėjaus",
        "ACT",
        "AMT",
        "AMST",
        "Bolivijos",
        "Butano",
        "Afganistano",
        "BRT",
        "BRST",
        "Coco",
        "Meio",
        "Antártida",
        "Meridiano",
        "standartinis",
        "ເວລາລະດູຮ້ອນເຢກາເຕລິນເບີກ",
        "ເວລາມາດຕະຖານເຢກາເຕລິນເບີກ",
        "ເວລາລະດູຮ້ອນຢາກູດສ",
        "ເວລາມາດຕະຖານຢາກູດສ",
        "ຟູຕູນາ",
        "Fênix",
        "Cingapura",
        "ເວລາວາລລິສ",
        "ເວລາເກາະເວກ",
        "ວອສໂຕກ",
        "ເວລາລະດູຮ້ອນໂວໂກກຣາດ",
        "ເວລາມາດຕະຖານໂວໂກກຣາດ",
        "ເວລາລະດູຮ້ອນລາດີໂວສຕົກ",
        "ເວລາມາດຕະຖານລາດີໂວສຕົກ",
        "ເວ​ລາ​ເວ​ເນ​ຊູ​ເອ​ລາ",
        "ເວລາລະດູຮ້ອນວານູອາຕູ",
        "ເວລາມາດຕະຖານວານູອາຕູ",
        "ເວລາລະດູຮ້ອນອຸສເບກິດສະຖານ",
        "ເວລາມາດຕະຖານອຸສເບກິດສະຖານ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ອູ​ຣູ​ກວຍ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ອູ​ຣູ​ກວຍ",
        "ເວລາຕູວາລູ",
        "ເວລາລະດູຮ້ອນຕວກເມນິສຖານ",
        "ເວລາມາດຕະຖານຕວກເມນິສຖານ",
        "ເວລາຊຸກ",
        "ເວລາລະດູຮ້ອນຕອງກາ",
        "ເວລາມາດຕະຖານຕອງກາ",
        "ເວລາໂຕເກເລົາ",
        "ເວລາທາຈິກິສຖານ",
        "ເວ​ລາ​ຕອນ​ທ່​ຽງ​ໄທ​ເປ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ໄທ​ເປ",
        "ເວລາທາຮິຕິ",
        "ໂຊວາ",
        "ເວ​ລາ​ຊຸ​ຣິ​ນາມ",
        "ເວລາຈໍເຈຍໃຕ້",
        "ເວລາຫມູ່ເກາະໂຊໂລມອນ",
        "ເວ​ລາ​ສິງ​ກະ​ໂປ",
        "ເວ​ລາ​ເຊ​ເຊ​ລ​ສ໌",
        "ເວລາລະດູຮ້ອນຊາມົວ",
        "ເວລາມາດຕະຖານຊາມົວ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນຊາ​ຮາ​ລິນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານຊາ​ຮາ​ລິນ",
        "ໂຣທີຕາ",
        "ເວ​ລາ​ເຣ​ອູ​ນິ​ຢົງ",
        "ເວລາລະດູຮ້ອນຄີວລໍດາ",
        "ເວລາມາດຕະຖານຄີວລໍດາ",
        "ເວລາປຽງຢາງ",
        "ເວລາໂປເນບ",
        "ເວລາພິດແຄຣ໌ນ",
        "​ເວ​ລາຕອນ​ທ່ຽງເຊນ​ປີ​ແອ",
        "​ເວ​ລາມາດ​ຕະ​ຖານເຊນ​ປີ​ແອ",
        "ເວລາຫມູ່ເກາະຟີນິກ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ຟິ​ລິບ​ປິນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຟິ​ລິບ​ປິນ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ເປ​ຣູ",
        "ເວ​ລາ​​ມາ​ດ​ຕະ​ຖານເປ​ຣູ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ປາ​ຣາ​ກວຍ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ປາ​ຣາ​ກວຍ",
        "ເວລາປາປົວກິນີ",
        "ເວລາປາເລົາ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ປາ​ກີ​ສ​ຖານ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ປາ​ກີສຖານ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນອອມ​ສ​ຄ໌",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອອມ​ສ​ຄ໌",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນໂນ​ໂບ​ຊິ​ບິ​ສ​ຄ໌",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານໂນ​ໂບ​ຊິ​ບິ​ສ​ຄ໌",
        "ເວລາຫມູ່ເກາະມາເຣຍນາເຫນືອ",
        "ເວລາລະດູຮ້ອນເຟນັນໂດເດໂນຮອນຮາ",
        "ເວລາມາດຕະຖານເຟນັນໂດເດໂນຮອນຮາ",
        "ເວ​ລາ​ເກາະ​ນໍ​ຟອ​ລ໌ກ",
        "ເວລານິອູເອ",
        "ເວລາກາງເວັນນິວຟາວແລນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ນິວ​ຟາວ​ແລນ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ນິວ​ຊີ​ແລນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານນິວ​ຊີ​ແລນ",
        "ເວລາລະດູຮ້ອນນິວແຄລິໂດເນຍ",
        "ເວລາມາດຕະຖານນິວແຄລິໂດເນຍ",
        "​ເວ​ລາ​ເນ​ປານ",
        "ເວ​ລາ​ນາ​ອູ​ຣຸ",
        "ເວລາມຽນມາ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນມອ​ສ​ໂຄ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານມອ​ສ​ໂຄ",
        "ເວລາລະດູຮ້ອນອູລານບາເຕີ",
        "ອູລານບາເຕີ",
        "ເວລາກາງເວັນແປຊິຟິກເມັກຊິກັນ",
        "ເວລາມາດຕະຖານແປຊິຟິກເມັກຊິກັນ",
        "ເວລາກາງເວັນເມັກຊິກັນນອດເວສ",
        "​ເວ​ລາ​ມາດ​ຕະ​ຖານນອດ​ເວ​ສ​ເມັກ​ຊິ​ໂກ",
        "ເວລາມໍສັນ",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ເມົາ​ຣິ​ທຽ​ສ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານເມົາ​ຣິ​ທຽ​ສ",
        "ເວ​ລາ​ໝູ່​ເກາະ​ມາ​ແຊວ",
        "ເວລາມາເຄີຊັສ",
        "ເວລາມັນດີຟ",
        "ເວ​ລາ​ມາ​ເລ​ເຊຍ",
        "ເວລາລະດູຮ້ອນເມັກກາເດນ",
        "ເວລາມາດຕະຖານເມັກກາເດນ",
        "ເວ​ລາ​ເກາະ​ແມັກ​ຄົວ​ຣີ",
        "ເວລາລະດູຮ້ອນມາເກົາ",
        "ເວລາມາດຕະຖານມາເກົາ",
        "​ເວ​ລ​ສາ​ຕອນ​​ທ່ຽງ​ລອດ​ເຮົາ​",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ລອດ​ເຮົາ",
        "ເວ​ລາ​ໝູ່​ເກາະ​ລາຍ",
        "ເວລາລັງກາ",
        "ເວລາເຄຍກິສຖານ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນຄຣັສ​ໂນ​ຢາ​ສ​ຄ໌",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານຄຣັສ​ໂນ​ຢາ​ສ​ຄ໌",
        "ເວລາຄອສແຣ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ເກົາ​ຫລີ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ເກົາ​ຫລີ",
        "ເວ​ລາ​ຄາ​ຊັກ​ສ​ຖານ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ຄາ​ຊັກ​ສ​ຖານ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ຍີ່​ປຸ່ນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຍີ່​ປຸ່ນ",
        "ເວລາກາງເວັນອິສຣາເອວ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອິ​ສ​ຣາ​ເອວ",
        "ເວ​ລາລະ​ດູ​ຮ້ອນອີ​ຄຸດ​ສ​ຄ໌",
        "ເວ​ລາມາດ​ຕະ​ຖານອີ​ຄຸດ​ສ​ຄ໌",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ອີ​ຣາ​ນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອີ​ຣານ",
        "ເວ​ລາ​ອິນ​ໂດ​ເນ​ເຊຍ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ອິນ​ໂດ​ເນ​ເຊຍ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ອິນ​ໂດ​ເນ​ເຊຍ​ກາງ",
        "ເວລາອິນດູຈີນ",
        "ເວລາຫມະຫາສະຫມຸດອິນເດຍ",
        "ອິນເດຍ",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ຮອບ​ດ໌",
        "​ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຮອບ​ດ໌",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ຮອງ​ກົງ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຮອງ​ກົງ",
        "ເວລາຕອນທ່ຽງຮາວາຍ",
        "ເວລາມາດຕະຖານຮາວາຍ",
        "ເວລາກາຍອານາ",
        "ເວ​ລາ​ກູ​ລ​໌ຟ",
        "ເວລາກວມ",
        "ເວລາຕອນທ່ຽງກຣີນແລນຕາເວັນຕົກ",
        "ເວລາມາດຕະຖານກຣີນແລນຕາເວັນຕົກ",
        "ເວລາລະດູຮ້ອນກຣີນແລນຕາເວັນອອກ",
        "ເວລາມາດຕະຖານຕາເວັນອອກກຣີນແລນ",
        "ເວ​ລາກຣີນ​ວິ​ຊ",
        "ເວລາຫມູ່ເກາະກິລເບີດ",
        "ເວລາລະດູຮ້ອນຈໍເຈຍ",
        "ເວລາມາດຕະຖານຈໍເຈຍ",
        "ເວລາແກມເບຍ",
        "ເວ​ລາ​ກາ​ລາ​ປາ​ກອ​ສ",
        "ແອນຕາກຕິກ",
        "ເວລາຝຣັ່ງຕອນໃຕ້",
        "ເວ​ລາ​ເຟ​ຣນ​ຊ໌​ເກຍ​ນາ",
        "ເວລາລະດູຮ້ອນຟິຈິ",
        "ເວລາມາດຕະຖານຟິຈິ",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນໝູ່​ເກາະ​ຟອ​ລ໌ກ​ແລນ",
        "​ເວ​ລາ​ມາດ​ຕະ​ຖານໝູ່​ເກາະ​ຟອ​ລ໌ກ​ແລນ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນຢູ​ໂຣບ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານຢູ​ໂຣບ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​​ຢູ​ໂຣ​ປຽນ​ຕາ​ເວັນ​ອອກ​ໄກ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນຢູ​ໂຣບ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ມາ​ດ​ຕະ​ຖານ​ຢູ​ໂຣບ​ຕາ​ເວັນ​ອອກ",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ຢູ​ໂຣບ​ກາງ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຢູ​ໂຣບກາງ",
        "ເວ​ລາ​ເອ​ກົວ​ດໍ",
        "Ииндийэ",
        "Ираан",
        "Ыраан",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນເກາະ​ອີ​ສ​ເຕີ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານເກາະ​ອີ​ສ​ເຕີ",
        "ເວລາຕີມໍຕາເວັນອອກ",
        "ເວລາດູມອງດູວິລ",
        "Кыргыстаан",
        "ເວລາເດວິດ",
        "ເວລາກາງເວັນຄິວບາ",
        "ເວລາມາດຕະຖານຂອງຄິວບາ",
        "ເວ​ລາ​ເຄິ່ງ​ລະ​ດູ​ຮ້ອນ​ໝູ່​ເກາະ​ຄຸກ",
        "ເວລາມາດຕະຖານຫມູ່ເກາະຄຸກ",
        "ເວລາລະດູຮ້ອນໂຄລໍາເບຍ",
        "ເວລາມາດຕະຖານໂຄລຳເບຍ",
        "ເວລາຫມູ່ເກາະໂກໂກສ",
        "ເວ​ລາ​ເກາະ​ຄ​ຣິສ​ມາສ",
        "ເວລາລະ​ດູ​ຮ້ອນໂຊຍບາຊັນ",
        "ເວລາມາດຕະຖານໂຊຍບາຊັນ",
        "​ເວ​ລາ​ຕອນ​ທ່ຽງ​ຈີນ",
        "ເວລາມາດຕະຖານຈີນ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນຊິ​ລີ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານຊິ​ລີ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ຊາ​ທາມ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ຊາ​ທາມ",
        "ເວ​ລາ​ຈາ​ໂມ​ໂຣ",
        "ເວລາເຄຊີ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ເຄບ​ເວີດ",
        "ඇෆ්ගනිස්ථාන",
        "​ເວ​ລາ​ມາດ​ຕະ​ຖານ​ເຄບ​ເວີດ",
        "​ເວ​ລາບຣູ​ໄນດາ​ຣຸສ​ຊາ​ລາມ",
        "ເວລາຕາມເຂດລະດູຮ້ອນຕາມເຂດບຣາຊີເລຍ",
        "ເວລາມາດຕາຖານເບຣຊີເລຍ",
        "ເວ​ລາ​ໂບ​ລິ​ເວຍ",
        "ເວ​ລາ​ພູ​ຖານ",
        "ລະດູຮ້ອນ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນອາ​ໂຊ​ເຣ​ສ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອາ​ໂຊ​ເຣ​ສ",
        "ເວລາລະດູຮ້ອນອັສເຊີໄບຈັນ",
        "ເວລາມາດຕະຖານອັສເຊີໄບຈັນ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ອອສ​ເຕຣ​ລຽນ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ມາ​ດ​ຕະ​ຖານອອສ​ເຕຣ​ລຽນ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ອອສ​ເຕຣ​ລຽນ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ມາດຕະຖານ​​​ອອສ​ເຕຣ​ລຽນ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ອອສ​ເຕຣ​ລຽນ​ກາງ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອອສ​ເຕຣ​ລຽນ​ກາງ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ຕອນ​ທ່ຽງ​ອອສ​ເຕຣ​ເລຍ​ກາງ",
        "ເວ​ລາມາດ​ຕະ​ຖານອອ​ສ​ເຕຣ​ເລຍ​ກ​າງ",
        "ເວລາກາງເວັນຂອງອາແລນຕິກ",
        "ເວລາມາດຕະຖານຂອງອາແລນຕິກ",
        "ເວລາລະດູຮ້ອນອາເມເນຍ",
        "ເວລາມາດຕະຖານອາເມເນຍ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນເວ​ສ​ເທິນອາ​ເຈນ​ທິ​ນາ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານເວ​ສ​ເທິນອາ​ເຈນ​ທິ​ນາ",
        "නැඟෙනහිර",
        "​ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ອາ​ເຈນ​ທິ​ນາ",
        "​ເວ​ລາ​ມາດ​ຕະ​ຖານອາ​ເຈນ​ທິ​ນາ",
        "ເວລາກາງເວັນອາຣາບຽນ",
        "භුතාන",
        "බොලිවියා",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອາ​ຣາ​ບຽນ",
        "බෘනායි",
        "දරුස්සලාම්",
        "ເວລາລະດູຮ້ອນອັດໂຕເບ",
        "චමොරෝ",
        "ເວລາມາດຕະຖານອັດໂຕເບ",
        "ເວລາລະດູຮ້ອນອັດຕາອູ",
        "ເວລາມາດຕະຖານອັດຕາອູ",
        "ເວລາກາງເວັນອາເພຍ",
        "ක්‍රිස්මස්",
        "ເວລາມາດຕະຖານເອເພຍ",
        "කොකෝස්",
        "ເວລາກາງເວັນແປຊິຟິກ",
        "ເວລາມາດຕະຖານແປຊິຟິກ",
        "භාග",
        "ເວລາກາງເວັນແຖບພູເຂົາ",
        "ඩාවිස්",
        "දුමොන්ත්",
        "ඩ්උර්විල්",
        "ටිමෝර්",
        "ເວລາມາດຕະຖານແຖບພູເຂົາ",
        "ເວລາກາງເວັນຕາເວັນອອກ",
        "ඉක්වදෝර්",
        "ເວລາມາດຕະຖານຕາເວັນອອກ",
        "තවත්",
        "ເວລາກາງເວັນກາງ",
        "ເວລາມາດຕະຖານກາງ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນອາ​ເມ​ຊອນ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານອາ​ເມ​ຊອນ",
        "දකුණුදිග",
        "ເວລາລະດູຮ້ອນອໍມາຕີ",
        "ඇන්ටාර්ක්ටික්",
        "ගලපගොස්",
        "ගැම්බියර්",
        "ເວລາມາດຕະຖານອໍມາຕີ",
        "ගිල්බර්ට්",
        "ග්‍රිනිච්",
        "ເວລາກາງເວັນອະແລສກາ",
        "ගල්ෆ්",
        "ເວລາມາດຕະຖານອະແລສກາ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ອາ​ຟຣິ​ກາ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ອາ​ຟຣິ​ກາ​ຕາ​ເວັນ​ຕົກ",
        "ເວ​ລາ​ອາ​ຟຣິ​ກາ​ໃຕ້",
        "ඉන්දියානු",
        "ඉන්දියන්",
        "සාගර",
        "ඉන්දුචීන",
        "ເວ​ລາ​ອາ​ຟຣິ​ກາ​ຕາ​ເວັນ​ອອກ",
        "ເວ​ລາ​ອາ​ຟຣິ​ກາ​ກາງ",
        "ອັຟການິສຖານ",
        "ເວລາລະດູຮ້ອນຂອງອາເກຣ",
        "ເວລາມາດຕະຖານຂອງອາເກຣ",
        "Uruguayanesch",
        "Uruguyanesch",
        "කොස්රේ",
        "Südgeorgesch",
        "කිර්ගිස්තාන",
        "ශ්‍රී",
        "ලංකා",
        "ලයින්",
        "Salomoninselen",
        "Standardzäit",
        "මැක්කුඅරි",
        "Pitcairninselen",
        "මැලේසියානු",
        "මාලදිවයින්",
        "මාර්කුඑසාස්",
        "මාර්ෂල්",
        "Phoenixinselen",
        "මොව්සන්",
        "Neiguinea",
        "Norfolkinselen",
        "Nepalesesch",
        "Marshallinselen",
        "Maldiven",
        "මියන්මාර්",
        "නාවුරු",
        "නේපාල",
        "Malaysesch",
        "Linneninselen",
        "Westkasachesch",
        "Ostkasachesch",
        "නියු",
        "නොෆොල්ක්",
        "Westindonesesch",
        "Ostindonesesch",
        "Zentralindonesesch",
        "Indeschen",
        "Indesch",
        "Mëttler",
        "පලාවු",
        "පැපුවා",
        "නිව්",
        "ගිනීයා",
        "Inselen",
        "Antarktisgebidder",
        "Guayane",
        "ෆීනික්ස්",
        "Ecuadorianesch",
        "Kokosinselen",
        "Chrëschtdagsinsel",
        "පිට්කෙයාන්",
        "පොනපේ",
        "ප්යොන්ග්යන්",
        "රියුනියන්",
        "රොතෙරා",
        "Bolivianesch",
        "Aserbaidschanesch",
        "සීෂෙල්ස්",
        "සිංගප්පුරු",
        "සොලොමන්",
        "ජෝජියා",
        "සුරිනාම",
        "ස්යෝවා",
        "ටාහිටි",
        "Aserbeidschanesch",
        "ටජිකිස්තාන",
        "ටොකෙලාවු",
        "Südafrikanesch",
        "චුක්",
        "Ostafrikanesch",
        "ටුවාලු",
        "Zentralafrikanesch",
        "Тажикстан",
        "Саоа",
        "Суринаме",
        "වෙනිසියුලා",
        "Жоржия",
        "Питкэрнг",
        "වොස්ටොක්",
        "වේක්",
        "වැලිස්",
        "ෆුටුනා",
        "Мйанмар",
        "Кыргызстан",
        "afganský",
        "stredoafrický",
        "východoafrický",
        "juhoafrický",
        "күндүзгү",
        "Индокытай",
        "булуңунун",
        "Персия",
        "Түштүгү",
        "Минск",
        "Калининград",
        "Экуадор",
        "жарым",
        "Азорс",
        "Seischälle",
        "Summerzigg",
        "Ozejan",
        "dem",
        "Standat",
        "Söd",
        "یٮ۪کَٹرِنبٔرگ",
        "یٮ۪کَٹٔرِنبٔرگ",
        "یَکُٹُسک",
        "یَکُٹسک",
        "فیوٗٹیوٗنا",
        "تہٕ",
        "والِس",
        "bhutánsky",
        "bolívijský",
        "ووسٹوک",
        "brunejský",
        "وٮ۪نٮ۪زیوٗلا",
        "chamorrský",
        "اُزبیکِستانُک",
        "اُزبیکِستان",
        "ٹوٗوَلوٗ",
        "ٹٔرک",
        "Vianočného",
        "ٹوکٮ۪لو",
        "تازِکِستان",
        "ٹاہِٹی",
        "Davisovej",
        "východotimorský",
        "سُرِنام",
        "ekvádorský",
        "جورجِیا",
        "ہُنٛد",
        "minský",
        "ججیٖرَن",
        "سولومَن",
        "سِنٛگاپوٗر",
        "francúzskoguyanský",
        "Francúzskych",
        "južných",
        "galapágsky",
        "gambierský",
        "سیشٮ۪لٕز",
        "greenwichský",
        "روتھٮ۪را",
        "رِیوٗنِیَن",
        "Perzského",
        "guyanský",
        "پونیپ",
        "پِٹکیرٕن",
        "indický",
        "indickooceánsky",
        "indočínsky",
        "stredoindonézsky",
        "východoindonézsky",
        "západoindonézsky",
        "پھونِکس",
        "گٮ۪نی",
        "پاپُعا",
        "پَلاو",
        "Kamčatský",
        "Kamčatskijský",
        "východokazachstanský",
        "západokazachstanský",
        "مَرِیانا",
        "kosrajský",
        "نورفعاک",
        "kirgizský",
        "نِیوٗ",
        "malajzijský",
        "maldivský",
        "markézsky",
        "لینڑ",
        "Mawsonovej",
        "فاونڑ",
        "فاونڑلینڑ",
        "کیلٮ۪ڑونِیس",
        "mjanmarský",
        "nauruský",
        "nepálsky",
        "کیلٮ۪ڑونِیا",
        "نٮ۪پٲلۍ",
        "نَعوٗروٗ",
        "niuejský",
        "norfolský",
        "مِیانمَر",
        "ماسَن",
        "مارشَل",
        "مارقیوٗسَس",
        "palauský",
        "Novej",
        "مالدیٖوٕز",
        "مَلیشِیا",
        "حووے",
        "لایِٔن",
        "Pitcairnových",
        "ponapský",
        "pchjongjanský",
        "réunionský",
        "Rotherovej",
        "لَنٛکا",
        "کِرگِستان",
        "seychelský",
        "singapurský",
        "Šalamúnových",
        "Južnej",
        "surinamský",
        "tahitský",
        "کورسَے",
        "tadžický",
        "tokelauský",
        "اِیٖرٲنی",
        "chuukský",
        "اِیٖرٲنۍ",
        "tuvalský",
        "اِنڑوچَینا",
        "ٹایِن",
        "اوشَن",
        "venezuelský",
        "ہِندوستٲنۍ",
        "ہِنٛدوستان",
        "حانٛگ",
        "حانگ",
        "Afganistanski",
        "Centralnoafriški",
        "Vzhodnoafriški",
        "Južnoafriški",
        "گُیَنا",
        "گَلف",
        "گُوٮ۪م",
        "میٖن",
        "وِچ",
        "گرٛیٖن",
        "گِلبٲٹ",
        "گٮ۪مبِیَر",
        "گٮ۪لٮ۪پیٚگوز",
        "فرٮ۪نٛچ",
        "گیوٗٮ۪نا",
        "فرٛٮ۪نٛچ",
        "یوٗرِپی",
        "اِکویڑَر",
        "ٹیٖمَر",
        "ایٖسٹ",
        "اُرویٖل",
        "ڑمانٹ",
        "ڑیوِس",
        "حاف",
        "کوکوز",
        "کرٛسمَس",
        "Butanski",
        "Bolivijski",
        "چٮ۪تھَم",
        "Brunejski",
        "Čamorski",
        "کٮ۪تھَم",
        "کٮ۪مورو",
        "ؤرڑو",
        "Božičnootoški",
        "دَروٗسَلَم",
        "Kokosovi",
        "برٛوٗنَے",
        "بولِوِیا",
        "بوٗٹان",
        "srednjepoletni",
        "ٹ",
        "Vzhodnotimorski",
        "ڈےلایٔٹ",
        "مغرِبیٖ",
        "Ekvadorski",
        "اٮ۪نڑیٖر",
        "اٮ۪نَڑیٖر",
        "Dodatni",
        "vzhodnoevropski",
        "افغانِستان",
        "ಯೇಕೇಟರಿನ್‍ಬರ್ಗ್",
        "ಯೇಕಟರಿನ್‌ಬರ್ಗ್",
        "Francoska",
        "ಫ್ಯುಟುನಾ",
        "Francoski",
        "južni",
        "ವ್ಯಾಲೀಸ್",
        "antarktični",
        "Galapaški",
        "ವೇಕ್",
        "Gilbertovi",
        "Greenwiški",
        "srednji",
        "ವೋಸ್ಟೊಕ್",
        "ವೆನಿಜುವೆಲಾ",
        "Zalivski",
        "Gvajanski",
        "ತುವಾಲು",
        "ಚುಕ್",
        "ಟೊಕೆಲಾವ್",
        "Indijski",
        "Indijskooceanski",
        "Indokitajski",
        "ತಝಕಿಸ್ತಾನ್",
        "osrednji",
        "ತಾಹಿತಿ",
        "ಸ್ಯೊವಾ",
        "ಸುರಿನೇಮ್",
        "ಸಾಲಮನ್",
        "Zahodni",
        "Kosrajški",
        "Kirgizistanski",
        "Ekvatorski",
        "otoki:",
        "Macquarieski",
        "Malezijski",
        "Maldivski",
        "Markizni",
        "Marshallovi",
        "ಸಿಂಗಾಪುರ್",
        "ಸೀಷೆಲ್ಸ್",
        "ರೊತೇರಾ",
        "ರಿಯೂನಿಯನ್",
        "ಪ್ಯೊಂಗ್ಯಾಂಗ್",
        "ಪೊನಾಪೆ",
        "Mjanmarski",
        "Naurujski",
        "ಪಿಟ್‌ಕೈರ್ನ್",
        "ಫಿನಿಕ್ಸ್",
        "ಗಿನಿಯಾ",
        "Niuejski",
        "Norfolški",
        "ನ್ಯೂ",
        "ಪಪುವಾ",
        "Palavski",
        "Papuanski",
        "ಪಾಲಾವ್",
        "ದೆ",
        "Otočje",
        "Pitcairnski",
        "Pjongjanški",
        "Rotherski",
        "ಫರ್ನಾಂಡೋ",
        "ಡೆ",
        "ಫೆರ್ನಾಂಡೋ",
        "Sejšelski",
        "Salomonovootoški",
        "Južnogeorgijski",
        "Tahitijski",
        "ನಾರ್ಫೋಕ್",
        "Tadžikistanski",
        "Tokelavski",
        "ನಿಯು",
        "ಬೇಸಿಗೆಯ",
        "ನೇಪಾಳ",
        "Tuvalujski",
        "ನೌರು",
        "ಮ್ಯಾನ್ಮಾರ್",
        "ಮಾವ್‌ಸನ್",
        "ಮಾರ್ಷಲ್",
        "ಮಾರ್ಕ್ಯುಸಸ್",
        "vostoški",
        "ಮಾಲ್ಡೀವ್ಸ್",
        "ಮಲೇಷಿಯಾ",
        "ಮ್ಯಾಕ್‌ಕ್ಯುರೈ",
        "ಬೆಳಗಿನ",
        "ಲೈನ್",
        "ಕಿರ್ಗಿಸ್ತಾನ್",
        "ಕೊಸರೆ",
        "ಇಂಡೋನೇಷಿಯ",
        "ಇಂಡೊಚೈನಾ",
        "ಮಹಾಸಾಗರ",
        "ಹಿಂದೂ",
        "ಭಾರತೀಯ",
        "ಗಲ್ಫ್",
        "ಕಾಲಮಾನ",
        "ಸರಾಸರಿ",
        "ಗ್ರೀನ್‌ವಿಚ್",
        "ಗಿಲ್ಬರ್ಟ್",
        "ಗ್ಯಾಂಬಿಯರ್",
        "ಗಾಲಾಪಾಗೋಸ್",
        "ಅಂಟಾರ್ಟಿಕಾ",
        "ಮತ್ತಷ್ಟು",
        "ಈಕ್ವೆಡಾರ್",
        "ಟಿಮೋರ್",
        "ಉರ್ವಿಲೆ",
        "ಡಿ",
        "ಡುಮಂಟ್",
        "ಡೇವಿಸ್",
        "ಮಧ್ಯಕಾಲೀನ",
        "ಕೋಕೋಸ್",
        "ಕ್ರಿಸ್ಮಸ್",
        "ಚೊಯ್‌ಬಲ್ಸಾನ್",
        "ಚೊಯ್‌‌ಬಲ್ಸಾನ್‌",
        "ಚಮೋರೋ",
        "ದಾರುಸಲೆಮ್",
        "ಬ್ರೂನಿ",
        "ಬೊಲಿವಿಯಾ",
        "ಭೂತಾನ್",
        "ಅರ್ಜೆಂಟಿನಾ",
        "ಕೇಂದ್ರೀಯ",
        "‌ಅಲಾಸ್ಕಾ",
        "ಅಲಸ್ಕಾ",
        "ಅಫಘಾನಿಸ್ತಾನ",
        "ម៉ោង​នៅ​អ៊ិខាធឺរីនប៊័ក​រដួវ​​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ិខាធឺរីនប៊័ក",
        "ម៉ោង​នៅ​យ៉ាគុត​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​យ៉ាគុត",
        "និង​ផូទូណា",
        "ម៉ោង​នៅ​វ៉ាលីស",
        "ម៉ោង​នៅ​កោះវេក",
        "ម៉ោង​នៅ​វ័រស្តុក",
        "ម៉ោង​នៅ​វ៉ូហ្កាក្រាត​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​វ៉ូហ្កាក្រាត",
        "ម៉ោង​នៅ​វ៉្លាឌីវ៉ូស្តក​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​វ៉្លាឌីវ៉ូស្តក",
        "ម៉ោង​នៅ​វ៉េណេស៊ុយអេឡា",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​វ៉ានូទូ",
        "ម៉ោង​​ស្តង់ដារ​នៅ​វ៉ានូទូ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អ៊ូសបេគីស្ថាន",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ូសបេគីស្ថាន",
        "ម៉ោង​​រដូវ​ក្ដៅ​នៅ​អ៊ុយរូហ្គាយ",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ុយរូហ្គាយ",
        "ម៉ោង​នៅ​ទុយវ៉ាឡុ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​តួកម៉េនីស្ថាន​",
        "ម៉ោង​ស្តង់ដារ​នៅតួកម៉េនីស្ថាន",
        "ម៉ោង​នៅ​ចូអុក",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​តុងកា",
        "ម៉ោង​ស្តង់ដារ​​នៅ​តុងកា",
        "ម៉ោង​នៅ​តូខេឡៅ",
        "ម៉ោងនៅតាជីគីស្តង់",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​តៃប៉ិ",
        "ម៉ោង​ស្តង់ដារ​នៅ​តៃប៉ិ",
        "ម៉ោង​នៅ​តាហិទី",
        "ម៉ោង​នៅ​ស៊ីអូវ៉ា",
        "ម៉ោង​នៅ​សូរីណាម",
        "ម៉ោង​នៅ​កោះ​ហ្សកហ្ស៊ី",
        "ម៉ោង​នៅ​កោះ​សូឡូម៉ុន",
        "ម៉ោង​នៅ​សិង្ហបូរី",
        "ម៉ោង​នៅ​សីស្ហែល",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​សាម៉ៅ",
        "ម៉ោង​ស្តង់ដារនៅ​សាម៉ៅ",
        "ម៉ោង​នៅ​សាក់ខាលីន​រដួវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​សាក់ខាលីន",
        "ម៉ោង​នៅ​រ៉ូធឺរ៉ា",
        "ម៉ោងនៅរេអ៊ុយ៉ុង",
        "ម៉ោងនៅព្យុងយ៉ាង",
        "ម៉ោង​នៅ​ប៉ូណាប់",
        "ម៉ោង​នៅ​ភីឃឺន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅសង់​ព្យែរ",
        "ម៉ោង​ស្តង់ដារ​នៅសង់​ព្យែរ",
        "ម៉ោង​នៅ​កោះ​ផូនីក",
        "ម៉ោង​រដូវ​ក្ដៅ​​នៅ​ហ្វីលីពីន",
        "ម៉ោង​ស្តង់ដារ​នៅ​ហ្វីលីពីន",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ប៉េរូ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ប៉េរូ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅប៉ារ៉ាហ្គាយ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ប៉ារ៉ាហ្គាយ",
        "ម៉ោង​នៅ​ប៉ាបៅញូកីនៀ",
        "ម៉ោង​នៅ​ផាឡៅ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ប៉ាគីស្ថាន",
        "ម៉ោង​ស្ដង់ដារ​នៅ​ប៉ាគីស្ថាន",
        "ម៉ោង​នៅ​អូម​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​អូម",
        "ម៉ោង​នៅ​ណូវ៉ូស៊ីប៊ីក​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ណូវ៉ូស៊ីប៊ីក",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ហ្វឺណាន់ដូ​ដឺណូរ៉ុនហា",
        "ម៉ោង​​ស្តង់ដារ​នៅ​ហ្វឺណាន់ដូ​ដឺណូរ៉ុនហា",
        "ម៉ោង​នៅ​កោះ​ន័រហ្វក់",
        "ម៉ោងនៅ​ដ្យូអៀ",
        "ម៉ោង​ពេលថ្ងៃ​នៅ​ញូហ្វោនឡែន",
        "ម៉ោង​​ស្តង់ដារ​​នៅ​ញូហ្វោនឡែន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​នូវែលសេឡង់",
        "ម៉ោង​ស្តង់ដារ​នៅ​នូវែលសេឡង់",
        "ម៉ោង​នៅ​ញូ​កាឡេដូនៀ",
        "ម៉ោង​ស្តង់ដារ​នៅ​កាឡេដូនៀ",
        "ម៉ោងនៅនេប៉ាល់",
        "ម៉ោង​នៅ​ណូរូ",
        "ម៉ោង​នៅ​ភូមា",
        "ម៉ោង​នៅ​មូស្គូ​",
        "ម៉ោង​ស្តង់ដារ​នៅ​មូស្គូ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អ៊ូឡាន​បាទូ",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ូឡាន​បាទូ",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ប៉ាសីុហ្វិក​ម៉ិកស៊ិក",
        "ម៉ោង​ស្តង់ដា​នៅ​ប៉ាសីុហ្វិក​ម៉ិកស៊ិក",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ម៉ិកស៊ិកភាគពាយព្យ",
        "ម៉ោង​ស្តង់ដា​នៅ​ម៉ិកស៊ិកភាគពាយព្យ",
        "ម៉ោង​នៅ​ម៉ៅ​សាន់",
        "ម៉ោង​​រដូវ​ក្ដៅនៅ​ម៉ូរីស",
        "ម៉ោង​ស្តង់ដារ​នៅ​ម៉ូរីស",
        "ម៉ោង​នៅ​ម៉ាសាល",
        "ម៉ោង​នៅ​កោះ​ម៉ាគឺសាស់",
        "ម៉ោង​នៅ​ម៉ាល់ឌីវ",
        "ម៉ោង​នៅ​ម៉ាឡេស៊ី",
        "ម៉ោង​នៅ​ម៉ាហ្កាដាន​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ម៉ាហ្កាដាន",
        "ម៉ោង​នៅ​កោះ​ម៉ាកគែរី",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ឡតហៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ឡត​ហៅ",
        "ម៉ោង​នៅ​កោះ​ឡាញ",
        "ម៉ោងនៅគៀរហ្គីស្តង់",
        "ម៉ោង​នៅ​ក្រាណូយ៉ាស​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ក្រាណូយ៉ាស",
        "ម៉ោង​នៅ​កូស្រៃ",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​កូរ៉េ",
        "ម៉ោង​ស្តង់ដារ​នៅ​កូរ៉េ",
        "ម៉ោង​នៅ​កាហ្សាក់ស្ថាន​ខាង​​​លិច",
        "ម៉ោង​កាហ្សាក់ស្ថាន​​ខាង​កើត",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅជប៉ុន",
        "ម៉ោង​ស្តង់ដារ​នៅ​ជប៉ុន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អ៊ីស្រាអែល",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ីស្រាអែល",
        "ម៉ោង​នៅ​អ៊ីគុត​រដូវ​ក្ដៅ",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ីគុត",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អ៊ីរ៉ង់",
        "ម៉ោង​ស្តង់ដារ​នៅ​អ៊ីរ៉ង់",
        "ម៉ោង​នៅ​ឥណ្ឌូណេស៊ី​​ខាង​លិច",
        "ម៉ោង​នៅ​ឥណ្ឌូណេស៊ី​​ខាង​កើត",
        "ម៉ោង​នៅ​ឥណ្ឌូណេស៊ី​​​កណ្ដាល",
        "ម៉ោង​នៅ​ឥណ្ឌូចិន",
        "ម៉ោង​នៅ​មហាសមុទ្រ​ឥណ្ឌា",
        "ម៉ោង​នៅ​ឥណ្ឌា",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ហូវ",
        "ម៉ោង​ស្តង់ដារ​នៅហូវ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ហុងកុង",
        "ម៉ោង​ស្តង់ដារ​នៅ​ហុងកុង",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ហាវៃ",
        "ម៉ោង​ស្តង់ដារ​​នៅ​ហាវៃ",
        "ម៉ោង​នៅ​ឃ្វីយ៉ាន",
        "ម៉ោង​ស្តង់ដា​នៅ​កាល់",
        "ម៉ោងរដូវក្តៅនៅហ្គ្រីនលែនខាងលិច",
        "ម៉ោងស្តង់ដារនៅហ្គ្រីនលែនខាងលិច",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ហ្គ្រីនលែនខាង​កើត",
        "ម៉ោង​​​ស្តង់ដារ​នៅ​​ហ្គ្រីនលែន​ខាង​កើត",
        "ម៉ោងនៅគ្រីនវិច",
        "ម៉ោង​នៅ​កោះ​កីប៊ឺត",
        "ម៉ោង​​រដូវ​ក្ដៅ​នៅ​ហ្សកហ្ស៊ី",
        "ម៉ោង​ស្តង់ដារ​នៅ​ហ្សកហ្ស៊ី",
        "ម៉ោង​នៅ​កាំបៀ",
        "ម៉ោង​នៅ​កាឡាប៉ាកូស",
        "និង​បារាំង​ខាង​ត្បូង",
        "ម៉ោង​នៅ​អែតាឃីត",
        "ម៉ោង​នៅ​ឃ្វីយ៉ាន​បារាំង",
        "ម៉ោង​​រដូវ​ក្ដៅ​នៅ​ហ៊្វីជី",
        "ម៉ោង​ស្តង់ដារ​នៅ​ហ៊្វីជី",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​កោះ​ហ្វក់ឡែន",
        "ម៉ោង​ស្តង់ដារ​នៅ​កោះ​ហ្វក់ឡែន",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អឺរ៉ុប​ខាង​លិច",
        "ម៉ោង​ស្តង់ដារ​នៅ​អឺរ៉ុប​ខាង​លិច",
        "ម៉ោង​នៅ​ចុងភាគ​ខាង​កើត​អឺរ៉ុប​",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អឺរ៉ុប​​ខាង​កើត​",
        "ម៉ោង​ស្តង់ដារ​​នៅ​អឺរ៉ុប​​ខាង​កើត​",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អឺរ៉ុប​កណ្ដាល",
        "ម៉ោង​ស្តង់ដារ​នៅ​អឺរ៉ុប​កណ្ដាល",
        "ម៉ោង​នៅ​អេក្វាទ័រ",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​កោះ​​ខាង​កើត",
        "ម៉ោង​ស្តង់ដារ​នៅ​កោះ​​​ខាង​កើត",
        "ម៉ោង​នៅ​​ទីម័រ​ខាង​កើត",
        "ម៉ោង​នៅ​ឌុយម៉ុងដឺអ៊ុយវីល",
        "ម៉ោង​នៅ​ដាវីស",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​គុយបា",
        "ម៉ោង​ស្តង់ដារ​នៅ​គុយបា",
        "ម៉ោង​​ពាក់កណ្ដាល​រដូវ​ក្ដៅ​នៅ​កោះ​ខូក",
        "ម៉ោង​ស្តង់ដារ​នៅ​កោះ​ខូក",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​កូឡុំប៊ី",
        "ម៉ោង​ស្តង់ដារ​នៅ​កូឡុំប៊ី",
        "ម៉ោង​នៅ​កោះ​កូកូស",
        "ម៉ោង​នៅ​កោះ​គ្រីស្មាស",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​ឆូបាល់សាន",
        "ម៉ោង​ស្តង់ដារ​នៅ​ឆូបាល់សាន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ចិន",
        "ម៉ោង​ស្តង់ដារ​នៅ​ចិន",
        "ម៉ោងរដូវក្តៅនៅឈីលី",
        "ម៉ោងស្តង់ដារនៅឈីលី",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​ចាថាំ",
        "ម៉ោង​ស្តង់ដារ​នៅ​ចាថាំ",
        "ម៉ោង​នៅ​ចាំម៉ូរ៉ូ",
        "ម៉ោង​​រដូវ​ក្ដៅនៅ​កាប់វែរ",
        "ម៉ោង​ស្តង់ដារ​នៅ​កាប់វែរ",
        "ម៉ោងនៅប្រ៊ុយណេដារូសាឡឹម",
        "ម៉ោង​​រដូវ​ក្ដៅ​នៅ​ប្រាស៊ីលីយ៉ា",
        "ម៉ោង​ស្តង់ដារ​នៅ​ប្រាស៊ីលីយ៉ា",
        "ម៉ោង​នៅ​បូលីវី",
        "ម៉ោងនៅប៊ូតាន",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​បង់ក្លាដែស",
        "ម៉ោង​ស្ដង់ដារ​នៅ​បង់ក្លាដែស",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អេហ្សស",
        "ម៉ោង​ស្តង់ដារ​នៅ​អេហ្សស",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អាស៊ែបៃហ្សង់",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាស៊ែបៃហ្សង់",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អូស្ត្រាលី​ខាង​លិច",
        "ម៉ោង​​ស្តង់ដារ​នៅ​អូស្ត្រាលី​ខាង​លិច",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អូស្ត្រាលី​ខាង​កើត",
        "ម៉ោង​ស្តង់ដារ​នៅ​អូស្ត្រាលី​ខាង​កើត",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​​ភាគ​ខាង​លិច​នៃ​អូស្ត្រាលី​កណ្ដាល",
        "ម៉ោង​ស្តង់ដារ​នៅ​ភាគ​ខាង​លិច​នៃ​អូស្ត្រាលី​កណ្ដាល",
        "ម៉ោង​ពេលថ្ងៃ​​​​នៅ​អូស្ត្រាលី​កណ្ដាល",
        "ម៉ោង​ស្តង់ដារ​នៅ​អូស្ត្រាលី​កណ្ដាល",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អាត្លង់ទិក",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាត្លង់ទិក",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អាមេនី",
        "ម៉ោង​ស្ដង់ដារ​នៅ​អាមេនី",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អាសង់ទីន​​ខាង​លិច",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាសង់ទីន​​ខាង​លិច",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អាសង់ទីន",
        "ម៉ោង​​ស្តង់ដារ​នៅ​អាសង់ទីន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អារ៉ាប់",
        "ម៉ោង​ស្តង់ដារ​នៅ​អារ៉ាប់",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​អាប្យា",
        "ម៉ោង​ស្តង់ដា​នៅ​អាប្យា",
        "ម៉ោង​ពេល​ថ្ងៃ​​ភាគ​ខាងលិច​នៅ​អាមេរិក​ភាគ​ខាង​ជើង",
        "ម៉ោង​ស្តង់ដារ​ភាគ​ខាង​លិច​នៅ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​តំបន់​ភ្នំ​អាមេរិក​ភាគ​ខាង​ជើង",
        "ម៉ោង​ស្តង់ដារ​នៅ​តំបន់​ភ្នំ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​ពេល​ថ្ងៃ​ភាគខាង​កើតនៅ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​ស្តង់ដារ​ភាគ​ខាង​កើត​នៅ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​ពេល​ថ្ងៃ​ភាគ​កណ្ដាល​នៅ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​ស្តង់ដារ​ភាគ​កណ្ដាល​នៅ​អាមេរិក​ខាង​ជើង",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អាម៉ាសូន",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាម៉ាសូន",
        "ម៉ោង​ពេល​ថ្ងៃ​នៅ​​អាឡាស្កា",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាឡាស្កា",
        "ម៉ោង​​រដូវ​ក្ដៅ​នៅ​អាហ្វ្រិក​​​ខាងលិច",
        "ម៉ោង​ស្តង់ដារ​នៅ​អាហ្វ្រិក​ខាង​លិច",
        "ម៉ោង​នៅ​អាហ្វ្រិក​ខាង​ត្បូង",
        "ម៉ោង​នៅ​អាហ្វ្រិក​ខាង​កើត",
        "ម៉ោង​នៅ​អាហ្វ្រិក​កណ្ដាល",
        "ម៉ោង​នៅ​អាហ្វហ្គានីស្ថាន",
        "Тәжікстан",
        "Сейшель",
        "Қырғызстан",
        "Үндіқытай",
        "мұхитының",
        "Үнді",
        "Үндістан",
        "шығанағы",
        "Парсы",
        "аймағы",
        "оңтүстік",
        "Францияның",
        "Гвианасы",
        "Қиыр",
        "жартылай",
        "Ауғанстан",
        "ფუტუნას",
        "ვოლისი",
        "ვეიკის",
        "ვოსტოკის",
        "ვენესუელის",
        "ტუვალუს",
        "ჩუუკის",
        "ტოკელაუს",
        "ტაჯიკეთის",
        "ტაიტის",
        "სიოვას",
        "სურინამის",
        "გეორგიის",
        "სოლომონის",
        "სინგაპურის",
        "სეიშელის",
        "როთერის",
        "რეიუნიონის",
        "ფხენიანის",
        "პონაპეს",
        "პიტკერნის",
        "ფენიქსის",
        "გვინეის",
        "პაპუა",
        "პალაუს",
        "ნორფოლკის",
        "ნიუეს",
        "ნეპალის",
        "ნაურუს",
        "მიანმარის",
        "მოუსონის",
        "მარშალის",
        "მარკიზის",
        "მალდივების",
        "მალაიზიის",
        "მაქკუორის",
        "ლაინის",
        "ყირგიზეთის",
        "კოსრეს",
        "ინდოჩინეთის",
        "გაიანის",
        "ყურის",
        "სპარსეთის",
        "საშუალო",
        "გრინვიჩის",
        "გილბერტის",
        "გამბიერის",
        "გალაპაგოსის",
        "ანტარქტიკის",
        "სამხრეთის",
        "ფრანგული",
        "გვიანის",
        "საფრანგეთის",
        "შორეული",
        "ეკვადორის",
        "ტიმორის",
        "დურვილის",
        "დუმონ",
        "დევისის",
        "ნახევრად",
        "ქოქოსის",
        "შობის",
        "ჩამოროს",
        "დარუსალამის",
        "ბრუნეი",
        "ბოლივიის",
        "ბუტანის",
        "ავღანეთის",
        "エカテリンブルグ夏時間",
        "エカテリンブルグ標準時",
        "ヤクーツク夏時間",
        "ヤクーツク標準時",
        "ウォリス・フツナ時間",
        "ウェーク島時間",
        "ボストーク基地時間",
        "ボルゴグラード夏時間",
        "ボルゴグラード標準時",
        "ウラジオストク夏時間",
        "ウラジオストク標準時",
        "ベネズエラ時間",
        "バヌアツ夏時間",
        "バヌアツ標準時",
        "ウズベキスタン夏時間",
        "ウズベキスタン標準時",
        "ウルグアイ夏時間",
        "ウルグアイ標準時",
        "ツバル時間",
        "トルクメニスタン夏時間",
        "トルクメニスタン標準時",
        "チューク時間",
        "トンガ夏時間",
        "トンガ標準時",
        "トケラウ時間",
        "タジキスタン時間",
        "台北夏時間",
        "台北標準時",
        "タヒチ時間",
        "スリナム時間",
        "サウスジョージア時間",
        "ソロモン諸島時間",
        "シンガポール標準時",
        "セーシェル時間",
        "サモア夏時間",
        "サモア標準時",
        "サマラ夏時間",
        "サマラ標準時",
        "サハリン夏時間",
        "サハリン標準時",
        "ロゼラ基地時間",
        "レユニオン時間",
        "クズロルダ夏時間",
        "クズロルダ標準時",
        "平壌時間",
        "ポナペ時間",
        "ピトケアン時間",
        "サンピエール・ミクロン夏時間",
        "サンピエール・ミクロン標準時",
        "フェニックス諸島時間",
        "フィリピン夏時間",
        "フィリピン標準時",
        "ペルー夏時間",
        "ペルー標準時",
        "パラグアイ夏時間",
        "パラグアイ標準時",
        "パプアニューギニア時間",
        "パラオ時間",
        "パキスタン夏時間",
        "パキスタン標準時",
        "オムスク夏時間",
        "オムスク標準時",
        "ノヴォシビルスク夏時間",
        "ノヴォシビルスク標準時",
        "北マリアナ諸島時間",
        "フェルナンド・デ・ノローニャ夏時間",
        "フェルナンド・デ・ノローニャ標準時",
        "ノーフォーク島時間",
        "ニウエ時間",
        "ニューファンドランド夏時間",
        "ニューファンドランド標準時",
        "ニュージーランド夏時間",
        "ニュージーランド標準時",
        "ニューカレドニア夏時間",
        "ニューカレドニア標準時",
        "ネパール時間",
        "ナウル時間",
        "ミャンマー時間",
        "モスクワ夏時間",
        "モスクワ標準時",
        "ウランバートル夏時間",
        "ウランバートル標準時",
        "メキシコ太平洋夏時間",
        "メキシコ太平洋標準時",
        "メキシコ北西部夏時間",
        "メキシコ北西部標準時",
        "モーソン基地時間",
        "モーリシャス夏時間",
        "モーリシャス標準時",
        "マーシャル諸島時間",
        "マルキーズ時間",
        "モルディブ時間",
        "マレーシア時間",
        "マガダン夏時間",
        "マガダン標準時",
        "マッコーリー島時間",
        "マカオ夏時間",
        "マカオ標準時",
        "ロードハウ夏時間",
        "ロードハウ標準時",
        "ライン諸島時間",
        "ランカ時間",
        "キルギスタン時間",
        "クラスノヤルスク夏時間",
        "クラスノヤルスク標準時",
        "コスラエ時間",
        "韓国夏時間",
        "韓国標準時",
        "西カザフスタン時間",
        "東カザフスタン時間",
        "ペトロパブロフスク・カムチャツキー夏時間",
        "ペトロパブロフスク・カムチャツキー標準時",
        "JDT",
        "JST",
        "日本夏時間",
        "日本標準時",
        "イスラエル夏時間",
        "イスラエル標準時",
        "イルクーツク夏時間",
        "イルクーツク標準時",
        "イラン夏時間",
        "イラン標準時",
        "インドネシア西部時間",
        "インドネシア東部時間",
        "インドネシア中部時間",
        "インドシナ時間",
        "インド洋時間",
        "インド標準時",
        "ホブド夏時間",
        "ホブド標準時",
        "香港夏時間",
        "香港標準時",
        "ハワイ・アリューシャン夏時間",
        "ハワイ・アリューシャン標準時",
        "ガイアナ時間",
        "湾岸標準時",
        "グアム時間",
        "グリーンランド西部夏時間",
        "グリーンランド西部標準時",
        "グリーンランド東部夏時間",
        "グリーンランド東部標準時",
        "グリニッジ標準時",
        "ギルバート諸島時間",
        "ジョージア夏時間",
        "ジョージア標準時",
        "ガンビエ諸島時間",
        "ガラパゴス時間",
        "仏領南方南極時間",
        "仏領ギアナ時間",
        "フィジー夏時間",
        "フィジー標準時",
        "フォークランド諸島夏時間",
        "フォークランド諸島標準時",
        "西ヨーロッパ夏時間",
        "西ヨーロッパ標準時",
        "極東ヨーロッパ時間",
        "東ヨーロッパ夏時間",
        "東ヨーロッパ標準時",
        "中央ヨーロッパ夏時間",
        "中央ヨーロッパ標準時",
        "エクアドル時間",
        "イースター島夏時間",
        "イースター島標準時",
        "東ティモール時間",
        "デュモン・デュルヴィル基地時間",
        "デービス基地時間",
        "キューバ夏時間",
        "キューバ標準時",
        "クック諸島夏時間",
        "クック諸島標準時",
        "コロンビア夏時間",
        "コロンビア標準時",
        "ココス諸島時間",
        "クリスマス島時間",
        "チョイバルサン夏時間",
        "チョイバルサン標準時",
        "中国夏時間",
        "中国標準時",
        "チリ夏時間",
        "チリ標準時",
        "チャタム夏時間",
        "チャタム標準時",
        "チャモロ時間",
        "ケイシー基地時間",
        "カーボベルデ夏時間",
        "カーボベルデ標準時",
        "ブルネイ・ダルサラーム時間",
        "ブラジリア夏時間",
        "ブラジリア標準時",
        "ボリビア時間",
        "ブータン時間",
        "バングラデシュ夏時間",
        "バングラデシュ標準時",
        "アゾレス夏時間",
        "アゾレス標準時",
        "アゼルバイジャン夏時間",
        "アゼルバイジャン標準時",
        "オーストラリア西部夏時間",
        "オーストラリア西部標準時",
        "オーストラリア東部夏時間",
        "オーストラリア東部標準時",
        "オーストラリア中西部夏時間",
        "オーストラリア中西部標準時",
        "オーストラリア中部夏時間",
        "オーストラリア中部標準時",
        "大西洋夏時間",
        "大西洋標準時",
        "アルメニア夏時間",
        "アルメニア標準時",
        "西部アルゼンチン夏時間",
        "西部アルゼンチン標準時",
        "アルゼンチン夏時間",
        "アルゼンチン標準時",
        "アラビア夏時間",
        "アラビア標準時",
        "アクトベ夏時間",
        "アクトベ標準時",
        "アクタウ夏時間",
        "アクタウ標準時",
        "アピア夏時間",
        "アピア標準時",
        "アナディリ夏時間",
        "アナディリ標準時",
        "アメリカ太平洋夏時間",
        "アメリカ太平洋標準時",
        "アメリカ山地夏時間",
        "アメリカ山地標準時",
        "アメリカ東部夏時間",
        "アメリカ東部標準時",
        "アメリカ中部夏時間",
        "アメリカ中部標準時",
        "アマゾン夏時間",
        "アマゾン標準時",
        "アルマトイ夏時間",
        "アルトマイ標準時",
        "アラスカ夏時間",
        "アラスカ標準時",
        "西アフリカ夏時間",
        "西アフリカ標準時",
        "南アフリカ標準時",
        "東アフリカ時間",
        "中央アフリカ時間",
        "アフガニスタン時間",
        "アクレ夏時間",
        "アクレ標準時",
        "Yekaterinborg",
        "Fútúnaeyjum",
        "Venesúelatími",
        "Túvalútími",
        "Tókelá",
        "Tadsjíkistan",
        "Tahítí",
        "Súrinamtími",
        "Georgíutími",
        "Salómonseyjatími",
        "Singapúrtími",
        "eyjatími",
        "Fönixeyjatími",
        "Gíneu",
        "Palátími",
        "Nepaltími",
        "Mjanmar",
        "Markgreifafrúreyjum",
        "Maldíveyja",
        "Malasíutími",
        "eyjartími",
        "Línueyja",
        "Indókínatími",
        "Indlandshafstími",
        "Indlandstími",
        "Gvæjanatími",
        "Persaflóa",
        "við",
        "Suðurskautslandssvæði",
        "suðurhafssvæðum",
        "frönsku",
        "Gvæjana",
        "Frönsku",
        "Kalíníngrad",
        "ఆఫ్ఘనిస్థాన్",
        "Staðartími",
        "Ekvadortími",
        "Tímor",
        "Tíminn",
        "Hálfsumartími",
        "Kókoseyjatími",
        "Jólaeyjartími",
        "Brúneitími",
        "Bólivíutími",
        "Bútantími",
        "Afganistantími",
        "Nugini",
        "Utara",
        "Maladewa",
        "Kirghizia",
        "WIB",
        "WIT",
        "WITA",
        "Hindia",
        "ఆర్జెంటీనా",
        "Samudera",
        "Wilayah",
        "Jauh",
        "Ekuador",
        "Ֆուտունայի",
        "Ուոլիս",
        "Ուեյք",
        "భూటాన్",
        "బొలీవియా",
        "Վոստոկի",
        "బ్రూనే",
        "దరుసలామ్",
        "Վենեսուելայի",
        "Տուվալույի",
        "చామర్రో",
        "Տրուկի",
        "Տոկելաույի",
        "Տաջիկստանի",
        "Թաիթիի",
        "క్రిస్మస్",
        "Սյովայի",
        "కాకోస్",
        "Սուրինամի",
        "Ջորջիայի",
        "Սողոմոնի",
        "అర్థ",
        "Սինգապուրի",
        "డేవిస్",
        "డ్యూమాంట్",
        "డి’ఉర్విల్లే",
        "తైమూర్",
        "Սեյշելյան",
        "ఈక్వడార్",
        "Ռոտերայի",
        "సుదూర",
        "Ռեյունիոնի",
        "Փխենյանի",
        "Պոնապե",
        "Պիտկեռնի",
        "Ֆինիքս",
        "అంటార్కిటిక్",
        "గాలాపాగోస్",
        "గాంబియర్",
        "Գվինեայի",
        "గిల్బర్ట్",
        "గ్రీన్‌విచ్",
        "సగటు",
        "Պապուա",
        "గ్వామ్",
        "గల్ఫ్",
        "Պալաույի",
        "Նորֆոլկ",
        "Նիուեյի",
        "Նեպալի",
        "భారతదేశ",
        "హిందూ",
        "మహా",
        "సముద్ర",
        "ఇండోచైనా",
        "Նաուրուի",
        "Մյանմայի",
        "Մոուսոնի",
        "Մարշալյան",
        "Մարկիզյան",
        "Մալդիվների",
        "Մալայզիայի",
        "కజకి‌స్తాన్",
        "కజకిస్తాన్",
        "Մակկուորի",
        "కోస్రాయి",
        "Լայն",
        "కిర్గిస్థాన్",
        "లంకా",
        "లైన్",
        "Ղրղզստանի",
        "Կոսրաեյի",
        "Հնդկաչինական",
        "మాక్క్వారీ",
        "օվկիանոսի",
        "మలేషియా",
        "మాల్దీవుల",
        "మార్క్వేసాస్",
        "మార్షల్",
        "Հնդկական",
        "మావ్సన్",
        "Հնդկաստանի",
        "Գայանայի",
        "ծոցի",
        "Պարսից",
        "Գրինվիչի",
        "Ջիլբերթի",
        "మయన్మార్",
        "నౌరు",
        "నేపాల్",
        "Գամբյե",
        "Գալապագոսյան",
        "անտարկտիդյան",
        "հարավային",
        "Գվիանայի",
        "నియూ",
        "నార్ఫోక్",
        "Մինսկի",
        "Էկվադորի",
        "Թիմորի",
        "ఉత్తర",
        "మారియానా",
        "నోవోసిబిర్క్స్",
        "నోవోసిబిర్స్క్",
        "դ’Յուրվիլի",
        "పాకిస్తాన్",
        "పాకిస్థాన్",
        "పాలావ్",
        "పాపువా",
        "గినియా",
        "Դյումոն",
        "Դեյվիսի",
        "կիսաամառային",
        "ఫినిక్స్",
        "Կոկոսյան",
        "పియెర్",
        "Ծննդյան",
        "పియర్",
        "పిట్కైరన్",
        "పొనేప్",
        "ప్యోంగాంగ్",
        "Սուրբ",
        "రీయూనియన్",
        "రొతేరా",
        "Չամոռոյի",
        "Բրունեյի",
        "Բոլիվիայի",
        "సీషెల్స్",
        "సింగపూర్",
        "సొలొమన్",
        "సూరినామ్",
        "స్యోవా",
        "తహితి",
        "Բութանի",
        "వెలుతరు",
        "తజికిస్తాన్",
        "టోకెలావ్",
        "Աֆղանստանի",
        "చక్",
        "Jekatyerinburgi",
        "తువాలు",
        "jekatyerinburgi",
        "Jakutszki",
        "jakutszki",
        "వెనిజులా",
        "wake",
        "vosztoki",
        "వోస్టోక్",
        "వేక్",
        "వాలీస్",
        "ఫుటునా",
        "venezuelai",
        "tuvalui",
        "เวลามาตรฐานอาเกร",
        "เวลาฤดูร้อนอาเกร",
        "เวลาอัฟกานิสถาน",
        "เวลาแอฟริกากลาง",
        "เวลาแอฟริกาตะวันออก",
        "เวลาแอฟริกาใต้",
        "เวลามาตรฐานแอฟริกาตะวันตก",
        "เวลาฤดูร้อนแอฟริกาตะวันตก",
        "เวลามาตรฐานอะแลสกา",
        "เวลาออมแสงของอะแลสกา",
        "เวลามาตรฐานอัลมาตี",
        "เวลาฤดูร้อนอัลมาตี",
        "เวลามาตรฐานแอมะซอน",
        "เวลาฤดูร้อนแอมะซอน",
        "เวลามาตรฐานตอนกลางในอเมริกาเหนือ",
        "เวลาออมแสงตอนกลางในอเมริกาเหนือ",
        "เวลามาตรฐานทางตะวันออกในอเมริกาเหนือ",
        "เวลาออมแสงทางตะวันออกในอเมริกาเหนือ",
        "เวลามาตรฐานแถบภูเขาในอเมริกาเหนือ",
        "เวลาออมแสงแถบภูเขาในอเมริกาเหนือ",
        "เวลามาตรฐานแปซิฟิกในอเมริกาเหนือ",
        "เวลาออมแสงแปซิฟิกในอเมริกาเหนือ",
        "เวลามาตรฐานอะนาดีร์",
        "เวลาฤดูร้อนอะนาดีร์",
        "เวลามาตรฐานอาปีอา",
        "เวลาออมแสงอาปีอา",
        "เวลามาตรฐานอัคตาอู",
        "เวลาฤดูร้อนอัคตาอู",
        "เวลามาตรฐานอัคโทเบ",
        "เวลาฤดูร้อนอัคโทเบ",
        "เวลามาตรฐานอาหรับ",
        "เวลาออมแสงอาหรับ",
        "เวลามาตรฐานอาร์เจนตินา",
        "เวลาฤดูร้อนอาร์เจนตินา",
        "เวลามาตรฐานทางตะวันตกของอาร์เจนตินา",
        "เวลาฤดูร้อนทางตะวันตกของอาร์เจนตินา",
        "เวลามาตรฐานอาร์เมเนีย",
        "เวลาฤดูร้อนอาร์เมเนีย",
        "เวลามาตรฐานแอตแลนติก",
        "เวลาออมแสงของแอตแลนติก",
        "เวลามาตรฐานทางตอนกลางของออสเตรเลีย",
        "เวลาออมแสงทางตอนกลางของออสเตรเลีย",
        "เวลามาตรฐานทางตะวันตกตอนกลางของออสเตรเลีย",
        "เวลาออมแสงทางตะวันตกตอนกลางของออสเตรเลีย",
        "เวลามาตรฐานทางตะวันออกของออสเตรเลีย",
        "เวลาออมแสงทางตะวันออกของออสเตรเลีย",
        "เวลามาตรฐานทางตะวันตกของออสเตรเลีย",
        "เวลาออมแสงทางตะวันตกของออสเตรเลีย",
        "เวลามาตรฐานอาเซอร์ไบจาน",
        "เวลาฤดูร้อนอาเซอร์ไบจาน",
        "เวลามาตรฐานอะโซร์ส",
        "เวลาฤดูร้อนอะโซร์ส",
        "เวลามาตรฐานบังกลาเทศ",
        "เวลาฤดูร้อนบังกลาเทศ",
        "เวลาภูฏาน",
        "เวลาโบลิเวีย",
        "เวลามาตรฐานบราซิเลีย",
        "เวลาฤดูร้อนบราซิเลีย",
        "เวลาบรูไนดารุสซาลาม",
        "เวลามาตรฐานเคปเวิร์ด",
        "เวลาฤดูร้อนเคปเวิร์ด",
        "เวลาเคซีย์",
        "เวลาชามอร์โร",
        "เวลามาตรฐานแชทัม",
        "เวลาออมแสงแชทัม",
        "เวลามาตรฐานชิลี",
        "เวลาฤดูร้อนชิลี",
        "เวลามาตรฐานจีน",
        "เวลาออมแสงจีน",
        "เวลามาตรฐานชอยปาลชาน",
        "เวลาฤดูร้อนชอยปาลชาน",
        "เวลาเกาะคริสต์มาส",
        "เวลาหมู่เกาะโคโคส",
        "เวลามาตรฐานโคลอมเบีย",
        "เวลาฤดูร้อนโคลอมเบีย",
        "เวลามาตรฐานหมู่เกาะคุก",
        "เวลาครึ่งฤดูร้อนหมู่เกาะคุก",
        "เวลามาตรฐานคิวบา",
        "เวลาออมแสงของคิวบา",
        "เวลาเดวิส",
        "เวลาดูมองต์ดูร์วิลล์",
        "เวลาติมอร์ตะวันออก",
        "เวลามาตรฐานเกาะอีสเตอร์",
        "เวลาฤดูร้อนเกาะอีสเตอร์",
        "เวลาเอกวาดอร์",
        "เวลามาตรฐานยุโรปกลาง",
        "เวลาฤดูร้อนยุโรปกลาง",
        "เวลามาตรฐานยุโรปตะวันออก",
        "เวลาฤดูร้อนยุโรปตะวันออก",
        "เวลายุโรปตะวันออกไกล",
        "เวลามาตรฐานยุโรปตะวันตก",
        "เวลาฤดูร้อนยุโรปตะวันตก",
        "เวลามาตรฐานหมู่เกาะฟอล์กแลนด์",
        "เวลาฤดูร้อนหมู่เกาะฟอล์กแลนด์",
        "เวลามาตรฐานฟิจิ",
        "เวลาฤดูร้อนฟิจิ",
        "เวลาเฟรนช์เกียนา",
        "เวลาเฟรนช์เซาเทิร์นและแอนตาร์กติก",
        "เวลากาลาปาโกส",
        "เวลาแกมเบียร์",
        "เวลามาตรฐานจอร์เจีย",
        "เวลาฤดูร้อนจอร์เจีย",
        "เวลาหมู่เกาะกิลเบิร์ต",
        "เวลามาตรฐานกรีนิช",
        "เวลามาตรฐานกรีนแลนด์ตะวันออก",
        "เวลาฤดูร้อนกรีนแลนด์ตะวันออก",
        "เวลามาตรฐานกรีนแลนด์ตะวันตก",
        "เวลาฤดูร้อนกรีนแลนด์ตะวันตก",
        "เวลากวม",
        "เวลากัลฟ์",
        "เวลากายอานา",
        "เวลามาตรฐานฮาวาย",
        "truki",
        "เวลาออมแสงฮาวาย",
        "เวลามาตรฐานฮ่องกง",
        "เวลาฤดูร้อนฮ่องกง",
        "เวลามาตรฐานฮอฟด์",
        "เวลาฤดูร้อนฮอฟด์",
        "เวลาอินเดีย",
        "เวลามหาสมุทรอินเดีย",
        "เวลาอินโดจีน",
        "เวลาอินโดนีเซียตอนกลาง",
        "เวลาอินโดนีเซียฝั่งตะวันออก",
        "เวลาอินโดนีเซียฝั่งตะวันตก",
        "เวลามาตรฐานอิหร่าน",
        "เวลาออมแสงอิหร่าน",
        "เวลามาตรฐานอีร์คุตสค์",
        "เวลาฤดูร้อนอีร์คุตสค์",
        "เวลามาตรฐานอิสราเอล",
        "เวลาออมแสงอิสราเอล",
        "เวลามาตรฐานญี่ปุ่น",
        "เวลาออมแสงญี่ปุ่น",
        "เวลาเปโตรปัฟลอฟสค์",
        "tokelaui",
        "เวลาฤดูร้อนเปโตรปัฟลอฟสค์",
        "เวลาคาซัคสถานตะวันออก",
        "เวลาคาซัคสถานตะวันตก",
        "เวลามาตรฐานเกาหลี",
        "เวลาออมแสงเกาหลี",
        "เวลาคอสไร",
        "เวลามาตรฐานครัสโนยาสค์",
        "เวลาฤดูร้อนครัสโนยาสค์",
        "เวลาคีร์กีซสถาน",
        "เวลาลังกา",
        "เวลาหมู่เกาะไลน์",
        "เวลามาตรฐานลอร์ดโฮว์",
        "เวลาออมแสงลอร์ดโฮว์",
        "เวลามาตรฐานมาเก๊า",
        "เวลาฤดูร้อนมาเก๊า",
        "เวลาเกาะแมกควอรี",
        "เวลามาตรฐานมากาดาน",
        "เวลาฤดูร้อนมากาดาน",
        "เวลามาเลเซีย",
        "เวลามัลดีฟส์",
        "เวลามาร์เคซัส",
        "เวลาหมู่เกาะมาร์แชลล์",
        "เวลามาตรฐานมอริเชียส",
        "เวลาฤดูร้อนของมอริเชียส",
        "เวลามอว์สัน",
        "เวลามาตรฐานเม็กซิโกตะวันตกเฉียงเหนือ",
        "เวลาออมแสงเม็กซิโกตะวันตกเฉียงเหนือ",
        "เวลามาตรฐานแปซิฟิกเม็กซิโก",
        "เวลาออมแสงแปซิฟิกเม็กซิโก",
        "เวลามาตรฐานอูลานบาตอร์",
        "เวลาฤดูร้อนอูลานบาตอร์",
        "เวลามาตรฐานมอสโก",
        "เวลาฤดูร้อนมอสโก",
        "เวลาพม่า",
        "เวลานาอูรู",
        "เวลาเนปาล",
        "เวลามาตรฐานนิวแคลิโดเนีย",
        "เวลาฤดูร้อนนิวแคลิโดเนีย",
        "เวลามาตรฐานนิวซีแลนด์",
        "เวลาออมแสงนิวซีแลนด์",
        "เวลามาตรฐานนิวฟันด์แลนด์",
        "เวลาออมแสงนิวฟันด์แลนด์",
        "เวลานีอูเอ",
        "เวลาเกาะนอร์ฟอล์ก",
        "เวลามาตรฐานหมู่เกาะเฟอร์นันโด",
        "เวลาฤดูร้อนของหมู่เกาะเฟอร์นันโด",
        "เวลาหมู่เกาะมาเรียนาเหนือ",
        "เวลามาตรฐานโนโวซีบีสค์",
        "เวลาฤดูร้อนโนโวซีบีสค์",
        "เวลามาตรฐานออมสค์",
        "เวลาฤดูร้อนออมสค์",
        "เวลามาตรฐานปากีสถาน",
        "เวลาฤดูร้อนปากีสถาน",
        "เวลาปาเลา",
        "เวลาปาปัวนิวกินี",
        "เวลามาตรฐานปารากวัย",
        "เวลาฤดูร้อนปารากวัย",
        "เวลามาตรฐานเปรู",
        "เวลาฤดูร้อนเปรู",
        "เวลามาตรฐานฟิลิปปินส์",
        "เวลาฤดูร้อนฟิลิปปินส์",
        "เวลาหมู่เกาะฟินิกซ์",
        "เวลามาตรฐานแซงปีแยร์และมีเกอลง",
        "เวลาออมแสงของแซงปีแยร์และมีเกอลง",
        "เวลาพิตแคร์น",
        "เวลาโปนาเป",
        "เวลาเปียงยาง",
        "เวลามาตรฐานคืยซิลออร์ดา",
        "เวลาฤดูร้อนคืยซิลออร์ดา",
        "เวลาเรอูนียง",
        "เวลาโรธีรา",
        "เวลามาตรฐานซาคาลิน",
        "เวลาฤดูร้อนซาคาลิน",
        "เวลามาตรฐานซามารา",
        "เวลาฤดูร้อนซามารา",
        "เวลามาตรฐานซามัว",
        "เวลาฤดูร้อนซามัว",
        "เวลาเซเชลส์",
        "เวลาสิงคโปร์",
        "เวลาหมู่เกาะโซโลมอน",
        "เวลาเซาท์จอร์เจีย",
        "เวลาซูรินาเม",
        "เวลาไซโยวา",
        "เวลาตาฮีตี",
        "เวลามาตรฐานไทเป",
        "เวลาออมแสงไทเป",
        "เวลาทาจิกิสถาน",
        "เวลาโตเกเลา",
        "เวลามาตรฐานตองกา",
        "เวลาฤดูร้อนตองกา",
        "เวลาชุก",
        "เวลามาตรฐานเติร์กเมนิสถาน",
        "เวลาฤดูร้อนเติร์กเมนิสถาน",
        "เวลาตูวาลู",
        "เวลามาตรฐานอุรุกวัย",
        "เวลาฤดูร้อนอุรุกวัย",
        "เวลามาตรฐานอุซเบกิสถาน",
        "เวลาฤดูร้อนอุซเบกิสถาน",
        "เวลามาตรฐานวานูอาตู",
        "เวลาฤดูร้อนวานูอาตู",
        "เวลาเวเนซุเอลา",
        "เวลามาตรฐานวลาดีวอสตอค",
        "เวลาฤดูร้อนวลาดีวอสตอค",
        "เวลามาตรฐานวอลโกกราด",
        "เวลาฤดูร้อนวอลโกกราด",
        "เวลาวอสตอค",
        "เวลาเกาะเวก",
        "เวลาวาลลิสและฟุตูนา",
        "เวลามาตรฐานยาคุตสค์",
        "เวลาฤดูร้อนยาคุตสค์",
        "เวลามาตรฐานเยคาเตรินบูร์ก",
        "เวลาฤดูร้อนเยคาเตรินบูร์ก",
        "Owganystan",
        "tádzsikisztáni",
        "tahiti",
        "syowai",
        "szurinámi",
        "georgiai",
        "salamon",
        "szingapúri",
        "seychelle",
        "rotherai",
        "réunioni",
        "phenjani",
        "ponape",
        "pitcairn",
        "phoenix",
        "guineai",
        "pápua",
        "palaui",
        "mariana",
        "Észak",
        "norfolk",
        "niuei",
        "nepáli",
        "naurui",
        "Boliwiýa",
        "mianmari",
        "Bruneý",
        "mawsoni",
        "marshall",
        "marquises",
        "maldív",
        "malajziai",
        "Krismas",
        "magadáni",
        "magadani",
        "Deýwis",
        "Dýumon",
        "d",
        "Ýurwil",
        "macquarie",
        "sor",
        "Uzak",
        "Lankai",
        "kirgizisztáni",
        "Gambýe",
        "kosraei",
        "Grinwiç",
        "boýunça",
        "orta",
        "indokínai",
        "Pars",
        "aýlagy",
        "Gaýana",
        "guyanai",
        "öbölbeli",
        "középidő",
        "ummany",
        "Hindihytaý",
        "greenwichi",
        "gilbert",
        "gambieri",
        "galápagosi",
        "antarktiszi",
        "guianai",
        "Kosraýe",
        "minszki",
        "Gyrgyzstan",
        "Laýn",
        "ecuadori",
        "Malaýziýa",
        "Maldiwler",
        "timori",
        "dumont",
        "davisi",
        "fél",
        "Mýanma",
        "kókusz",
        "karácsony",
        "chamorrói",
        "bolíviai",
        "butáni",
        "Nowosibisk",
        "Argentínai",
        "Gwineýa",
        "dél",
        "afganisztáni",
        "Wostokski",
        "Reýunýon",
        "Seýşel",
        "Georgiýa",
        "Sýowa",
        "Taýiti",
        "venezuelski",
        "Täjigistan",
        "tuvaluski",
        "Tuwalu",
        "chuukski",
        "tokelauski",
        "tadźikski",
        "Wenesuela",
        "Weýk",
        "Wollis",
        "tahitiski",
        "Syowaski",
        "surinamski",
        "južnogeorgiski",
        "Salomonskich",
        "seychellski",
        "Rotheraski",
        "fakaʻafikānisitani",
        "reunionski",
        "ponapeski",
        "nowoginejski",
        "tonga",
        "papua",
        "palauski",
        "niueski",
        "nepalski",
        "nauruski",
        "myanmarski",
        "marquesaski",
        "malediwski",
        "malajziski",
        "kirgiski",
        "kosraeski",
        "zapadnokazachski",
        "wuchodnokazachski",
        "zapadoindoneski",
        "wuchodoindoneski",
        "srjedźoindoneski",
        "indochinski",
        "indiskooceanski",
        "indiski",
        "guyanski",
        "Persiskeho",
        "fakapūtani",
        "fakapolīvia",
        "gambierski",
        "fakapulunei",
        "galapagoski",
        "teritorija",
        "fakakeesi",
        "fakakamolo",
        "južneho",
        "Francoskeho",
        "francoskoguyanski",
        "ekwadorski",
        "fakamotukilisimasi",
        "fakamotukokosi",
        "wuchodnotimorski",
        "Urvilleski",
        "d´",
        "fakatavisi",
        "fakatūmoni",
        "tūvile",
        "fakatimoa",
        "Daviski",
        "fakaʻekuetoa",
        "Hodowneje",
        "ange",
        "chamorroski",
        "bruneiski",
        "boliwiski",
        "bhutanski",
        "fakafalanisē",
        "fakaʻanetātikafalanisē",
        "fakakalapakosi",
        "fakakamipiē",
        "sjedźozapadny",
        "fakakilipasi",
        "fakakiliniuisi",
        "mālie",
        "srjedźozapadny",
        "fakakuami",
        "fakakūlifi",
        "južnoafriski",
        "wuchodoafriski",
        "centralnoafriski",
        "afghanski",
        "fakaʻinitia",
        "fakamoanaʻinitia",
        "fakaʻinitosiaina",
        "फ़्यूचूना",
        "वालिस",
        "वोस्तोक",
        "सूरीनाम",
        "सोलोमन",
        "सेशल्स",
        "रीयूनियन",
        "प्योंगयांग",
        "fakakosilae",
        "फ़ीनिक्स",
        "fakakīkisitani",
        "fakalangikā",
        "fakaʻotumotulaine",
        "पलाउ",
        "नॉरफ़ॉक",
        "fakamotumakuali",
        "नीयू",
        "fakamaleisia",
        "fakamalativisi",
        "fakamākesasi",
        "fakaʻotumotumasolo",
        "नौरू",
        "fakamausoni",
        "म्यांमार",
        "माव्सन",
        "मार्केसस",
        "मक्वारी",
        "fakapema",
        "fakanaulu",
        "fakanepali",
        "किर्गिस्‍तान",
        "इंडोचाइना",
        "हिंद",
        "fakaniuē",
        "fakanoafōki",
        "खाड़ी",
        "टाइम",
        "मीन",
        "fakamalianatokelau",
        "गैंबियर",
        "का",
        "गैलापेगोस",
        "fakapalau",
        "fakapapuaniukini",
        "अंटार्कटिक",
        "फ़्रांस",
        "फ़्रेंच",
        "fakaʻotumotufoinikisi",
        "इक्वाडोर",
        "डर्विल",
        "ड्यूमोंट",
        "डेविस",
        "fakapitikani",
        "fakapōnapē",
        "अर्द्ध",
        "fakalēunioni",
        "fakalotela",
        "क्रिसमस",
        "ब्रूनेई",
        "बोलीविया",
        "seiseli",
        "fakasingapoa",
        "fakaʻotumotusolomone",
        "fakasiosiatonga",
        "fakasuliname",
        "fakasioua",
        "fakatahisi",
        "भूटान",
        "fakatasikitani",
        "fakatokelau",
        "अफ़गानिस्तान",
        "fakatūke",
        "ופוטונה",
        "fakatūvalu",
        "וואליס",
        "וייק",
        "ווסטוק",
        "fakavenesuela",
        "ונצואלה",
        "טובאלו",
        "fakavositoki",
        "fakamotuueke",
        "fakaʻuvea",
        "futuna",
        "צ׳וק",
        "טוקלאו",
        "טג׳יקיסטן",
        "טהיטי",
        "סייווה",
        "סורינאם",
        "ג׳ורג׳יה",
        "שלמה",
        "סינגפור",
        "סיישל",
        "רות׳רה",
        "ראוניון",
        "פיונגיאנג",
        "פונאפי",
        "פיטקרן",
        "פיניקס",
        "גיניאה",
        "פפואה",
        "פלאו",
        "נורפוק",
        "ניואה",
        "נפאל",
        "נאורו",
        "מיאנמר",
        "מאוסון",
        "מרשל",
        "מרקיז",
        "המלדיביים",
        "מלזיה",
        "מקווארי",
        "חורף",
        "ליין",
        "קירגיזסטן",
        "קוסראה",
        "אירקוסטק",
        "אירקוטסק",
        "ההודי",
        "המפרץ",
        "מדינות",
        "גריניץ׳‏",
        "גילברט",
        "גמבייה",
        "גלאפגוס",
        "צרפת",
        "של",
        "והאנטארקטיות",
        "הדרומיות",
        "הארצות",
        "הצרפתית",
        "מינסק",
        "אקוודור",
        "טימור",
        "ד׳אורוויל",
        "דומון",
        "ئاكرې",
        "דיוויס",
        "הקיץ)",
        "ئاكرى",
        "(מחצית",
        "ئافغانىستان",
        "קוקוס",
        "כריסטמס",
        "צ׳אמורו",
        "דארוסלאם",
        "ברוניי",
        "בוליביה",
        "בהוטן",
        "אפגניסטן",
        "ફ્યુચુના",
        "વૉલિસ",
        "વૅક",
        "વોસ્ટોક",
        "વેનેઝુએલા",
        "ટવાલૂ",
        "ચુઉક",
        "ટોકલાઉ",
        "તાજીકિસ્તાન",
        "તાહિતી",
        "સ્યોવા",
        "સૂરીનામ",
        "ئاۋستىرالىيە",
        "જ્યોર્જીયા",
        "સોલોમન",
        "સિંગાપુર",
        "بۇتان",
        "بولىۋىيە",
        "સેશલ્સ",
        "بىرۇنىي",
        "دارۇسسالام",
        "રોથેરા",
        "રીયૂનિયન",
        "كاسېي",
        "چاموررو",
        "યોન્ગ્યાન્ગ",
        "પોનપે",
        "પિટકેયર્ન",
        "ફોનિક્સ",
        "روژدېستۋو",
        "ગિની",
        "كوكۇس",
        "પાપુઆ",
        "પલાઉ",
        "ઓમ્સ્ક",
        "يېرىم",
        "ઓમસ્ક",
        "داۋىس",
        "دۇمونت",
        "دۇرۋىل",
        "تىمور",
        "پاسكاليا",
        "ئېستېر",
        "ئېكۋادور",
        "મારિયાના",
        "નોરોહા",
        "દે",
        "ફરનેન્ડો",
        "નોરોન્હા",
        "ડી",
        "ફર્નાન્ડો",
        "ئانتاركتىكا",
        "گامبىيېر",
        "નોરફૉક",
        "گىلبېرت",
        "گىرىنۋىچ",
        "નીયુ",
        "گۇئام",
        "گۇلف",
        "નેપાળ",
        "નૌરુ",
        "મ્યાનમાર",
        "બટોર",
        "ھىندىستان",
        "બાટોર",
        "چىنى",
        "મોસન",
        "માર્શલ",
        "માર્ક્યૂસસ",
        "માલદીવ",
        "મલેશિયા",
        "મેક્વાયર",
        "લાઇન",
        "લંકા",
        "કિર્ગિઝતાન",
        "كوسرائې",
        "ક્રેસનોયાર્સ્ક",
        "قىرغىزىستان",
        "سىرى",
        "لانكا",
        "ક્રસ્નોયાર્સ્ક",
        "કોસરે",
        "ماككۇۋارى",
        "مالايشىيا",
        "مالدىۋې",
        "ماركىز",
        "ઇન્ડોચાઇના",
        "ماۋسون",
        "મહાસાગર",
        "ગલ્ફ",
        "ગ્વામ",
        "મધ્યમ",
        "بىرما",
        "ناۋرۇ",
        "نېپال",
        "ગ્રીનવિચ",
        "ગિલબર્ટ",
        "ગેમ્બિયર",
        "ગાલાપાગોસ",
        "نىيۇئې",
        "એન્ટાર્કટિક",
        "સાઉધર્ન",
        "مارىيانا",
        "ફોકલૅંડ",
        "ફૉકલૅંડ",
        "આગળનું",
        "پالاۋ",
        "پاپۇئا",
        "گىۋىنېيەسى",
        "એક્વાડોર",
        "તિમોર",
        "ડી‘ઉર્વિલ",
        "فېنىكس",
        "ડ્યુમોન્ટ",
        "ડેવિસ",
        "અર્ધ",
        "پىتكاير",
        "پونپېي",
        "કોકોઝ",
        "رېئونىيون",
        "روتېرا",
        "ક્રિસમસ",
        "ساموئا",
        "سەمەرقەنت",
        "سېيشېل",
        "سىنگاپور",
        "سولومون",
        "جورجىيە",
        "سۇرىنام",
        "شوۋا",
        "تايتى",
        "કેમોરો",
        "تاجىكىستان",
        "توكېلاۋ",
        "چۇك",
        "દારુસલામ",
        "تۇۋالۇ",
        "બ્રૂનેઈ",
        "બોલિવિયા",
        "ભૂટાન",
        "ۋېنېزۇئېلا",
        "આર્જેન્ટીના",
        "અપિયા",
        "ۋوستوك",
        "ۋېيك",
        "ۋاللىس",
        "فۇتۇنا",
        "એપિયા",
        "કેન્દ્રિય",
        "અફઘાનિસ્તાન",
        "Toquelau",
        "Sakhalín",
        "Liña",
        "Quirguicistán",
        "europeo",
        "Афганістані",
        "центральноафриканським",
        "східноафриканським",
        "південноафриканським",
        "extremo",
        "medio",
        "Nadal",
        "chamorro",
        "Uallas",
        "Bheiniseala",
        "Tubhalu",
        "Taidigeastàin",
        "Shyowa",
        "Suranaim",
        "Seòrsea",
        "Sholaimh",
        "Singeapòr",
        "Sheiseall",
        "Chàirn",
        "Peit",
        "Paputhaiche",
        "Gini",
        "Palabh",
        "Mairianach",
        "Neapàl",
        "Nabhru",
        "Miànmar",
        "Mhawson",
        "Mharshall",
        "Бутані",
        "болівійським",
        "Mharcais",
        "Брунеї",
        "Mhaladaibh",
        "Північних",
        "Маріанських",
        "Mhalaidhsea",
        "MhicGuaire",
        "Teraina",
        "Cìorgastain",
        "Різдва",
        "Кокосових",
        "Innseanach",
        "Sìn",
        "Девіс",
        "дʼЮрвіль",
        "Східному",
        "Тиморі",
        "Еквадорі",
        "Cuan",
        "Chamais",
        "далекосхідним",
        "європейським",
        "Ghileabairt",
        "Ghalapagos",
        "Antartaigeach",
        "Французької",
        "Гвіани",
        "Французьких",
        "Південних",
        "Антарктичних",
        "територіях",
        "Галапагоських",
        "Гамб’є",
        "Deasach",
        "Гринвічем",
        "ear",
        "fhaide",
        "Перської",
        "затоки",
        "Гаяні",
        "nas",
        "Eacuadoir",
        "Thìomor",
        "Dhavis",
        "індійським",
        "Індійському",
        "Океані",
        "Індокитаї",
        "центральноіндонезійським",
        "східноіндонезійським",
        "західноіндонезійським",
        "thìde",
        "Leth",
        "Chocos",
        "Nollaig",
        "Chasey",
        "Salàm",
        "as",
        "Dàr",
        "Киргизстані",
        "Маккуорі",
        "Bhrùnaigh",
        "Малайзії",
        "Мальдівах",
        "Маркізьких",
        "Маршалових",
        "Boilibhia",
        "Butàin",
        "Afghanastàin",
        "Futúna",
        "Vailís",
        "Veiniséala",
        "Мʼянмі",
        "Непалі",
        "Thuvalu",
        "Tócalá",
        "Táidsíceastáine",
        "Thaihítí",
        "Ніуе",
        "Shuranam",
        "Sholomón",
        "Shingeapór",
        "Séiséal",
        "Гвінея",
        "Phohnpei",
        "Fhéinics",
        "Phapua",
        "Піткерн",
        "Пхеньяні",
        "Реюньйон",
        "Ghuine",
        "Thuaidh",
        "Сейшельських",
        "Сінгапурі",
        "Соломонових",
        "Південна",
        "Джорджія",
        "Суринамі",
        "Сева",
        "Таїті",
        "Máirianach",
        "Таджикистані",
        "Neipeal",
        "Mhaenmar",
        "Marcasach",
        "Венесуелі",
        "Mhaildíve",
        "Malaeisia",
        "Уолліс",
        "Guaire",
        "Mhic",
        "Líne",
        "Shrí",
        "Cirgeastáine",
        "hInd",
        "Indiaigh",
        "hIndia",
        "Guáine",
        "Murascaille",
        "Ghuam",
        "MAG",
        "Meán",
        "Chireabaití",
        "Domhain",
        "Deisceart",
        "Francacha",
        "Chríocha",
        "Fraince",
        "Ghuáin",
        "Chianoirthear",
        "Eacuadór",
        "Thoir",
        "Thíomór",
        "Leathshamhraidh",
        "Nollag",
        "Seamórach",
        "Darasalám",
        "Brúiné",
        "Bolaive",
        "Bútáine",
        "hAfganastáine",
        "Fenezolaanske",
        "Tuvaluaanske",
        "Tahitiaanske",
        "Surinaamske",
        "Salomonseilânske",
        "Pitcairneillânske",
        "Phoenixeilânske",
        "Guineeske",
        "Mariaanske",
        "Noardlike",
        "Norfolkeilânske",
        "Nauruaanske",
        "Marshalleilânske",
        "Marquesaseilânske",
        "Maldivyske",
        "Maleisyske",
        "Kirgizyske",
        "Yndochinese",
        "Yndyske",
        "Yndiaaske",
        "Gilberteilânske",
        "Gambiereilânske",
        "Galapagoseilânske",
        "Antarctyske",
        "Súdlike",
        "Frânske",
        "Frâns",
        "Ecuadoraanske",
        "Kokoseilânske",
        "Krysteilânske",
        "Boliviaanske",
        "Bhutaanske",
        "Afghaanske",
        "GFT",
        "HAT",
        "HNT",
        "HAP",
        "مین",
        "HNP",
        "HAR",
        "HNR",
        "HAE",
        "HNE",
        "انڈیا",
        "HAC",
        "HNC",
        "Heure",
        "Lorde",
        "Antartiko",
        "at",
        "France",
        "Katimugang",
        "silangang",
        "Pinaka",
        "Kalahati",
        "Futunan",
        "Wallisin",
        "Waken",
        "Vostokin",
        "Venezuelan",
        "Tuvalun",
        "Chuukin",
        "Tokelaun",
        "Tadžikistanin",
        "Tahitin",
        "Syowan",
        "Surinamen",
        "Salomonsaarten",
        "Singaporen",
        "Seychellien",
        "Rotheran",
        "Réunionin",
        "Pjongjangin",
        "Pohnpein",
        "Pitcairnin",
        "Phoenixsaarten",
        "Guinean",
        "Palaun",
        "Mariaanien",
        "Pohjois",
        "Norfolkinsaarten",
        "Niuen",
        "Nepalin",
        "Naurun",
        "Myanmarin",
        "Mawsonin",
        "Marshallinsaarten",
        "Marquesasin",
        "Malediivien",
        "Malesian",
        "Macquariensaaren",
        "Linesaarten",
        "Lankan",
        "Kirgisian",
        "Kosraen",
        "Indokiinan",
        "valtameren",
        "Guyanan",
        "Arabiemiirikuntien",
        "Guamin",
        "Greenwichin",
        "Gilbertsaarten",
        "Gambierin",
        "Galápagossaarten",
        "alueiden",
        "antarktisten",
        "eteläisten",
        "Guayanan",
        "Itäisemmän",
        "Ecuadorin",
        "Timorin",
        "d’Urvillen",
        "Davisin",
        "Kookossaarten",
        "Joulusaaren",
        "Tšamorron",
        "Caseyn",
        "Brunein",
        "Bolivian",
        "Bhutanin",
        "Afganistanin",
        "Yekaterinburgeko",
        "Jekaterinburgeko",
        "Futunako",
        "Vostokeko",
        "Venezuelako",
        "امیزون",
        "اصل",
        "ہندوستان",
        "Афғонистон",
        "Tuvaluko",
        "Chuukeko",
        "Tokelauko",
        "Tadjikistango",
        "Tahitiko",
        "Syowako",
        "Surinamgo",
        "Hego",
        "Singapurreko",
        "Rotherako",
        "Piongiangeko",
        "Ponapeko",
        "Pitcairneko",
        "Ginea",
        "Palauko",
        "Niueko",
        "Даруссалом",
        "Каморро",
        "Nepalgo",
        "Nauruko",
        "Myanmarreko",
        "Mawsoneko",
        "ярим",
        "Думонт",
        "Markesetako",
        "Гвианаси",
        "жанубий",
        "Гамбиер",
        "Кўрфаз",
        "Maldivetako",
        "Ҳиндистон",
        "Malaysiako",
        "Kirgizistango",
        "Kosraeko",
        "Indotxinako",
        "Қирғизистон",
        "Indikoko",
        "Маквари",
        "ороллар",
        "Моувсон",
        "Ozeano",
        "Indiako",
        "Сьова",
        "Тожикистон",
        "Guyanako",
        "Golkoko",
        "Уэллис",
        "meridianoko",
        "Gambierreko",
        "Galapagoetako",
        "antartikoetako",
        "austral",
        "lurralde",
        "Frantziaren",
        "Frantseseko",
        "Europako",
        "urruneko",
        "Ekialde",
        "Ekuadorreko",
        "Timorreko",
        "Ekialdeko",
        "d’Urvilleko",
        "Daviseko",
        "uda",
        "Chamorroko",
        "Darussalamgo",
        "Boliviako",
        "Bhutango",
        "hegoaldeko",
        "Afganistango",
        "Jakaterinburgi",
        "Jekaterinburgi",
        "Wallise",
        "Wake’i",
        "Vostoki",
        "Chuuki",
        "Tadžikistani",
        "Saalomoni",
        "Singapuri",
        "Seišelli",
        "Réunioni",
        "Pyongyangi",
        "Pitcairni",
        "Fööniksisaarte",
        "Paapua",
        "Belau",
        "Norfolki",
        "Nepali",
        "Birma",
        "Mawsoni",
        "Marshalli",
        "Markiisaarte",
        "Maldiivi",
        "​​aeg",
        "saare",
        "Line’i",
        "Kõrgõzstani",
        "Indohiina",
        "lahe",
        "Pärsia",
        "Greenwichi",
        "Gilberti",
        "Gambier’",
        "Galapagose",
        "Lõunaalade",
        "Antarktiliste",
        "Guajaana",
        "Valgevene",
        "Kaliningradi",
        "Ecuadori",
        "Timori",
        "d’Urville’i",
        "Davise",
        "osaline",
        "Kookossaarte",
        "Jõulusaare",
        "Tšamorro",
        "Boliivia",
        "Bhutani",
        "Afganistani",
        "VET",
        "UYST",
        "UYT",
        "COST",
        "COT",
        "CLST",
        "CLT",
        "WARST",
        "WART",
        "ARST",
        "ART",
        "CHADT",
        "CHAST",
        "GYT",
        "ChST",
        "NDT",
        "NST",
        "mây",
        "tây",
        "ཡེ་ཀ་ཏེ་རིན་བརག་བྱཱར་དུས་ཆུ་ཚོད",
        "ཡེ་ཀ་ཏེ་རིན་བརག་ཚད་ལྡན་ཆུ་ཚོད",
        "ཡ་ཀུཙིཀི་བྱཱར་དུས་ཆུ་ཚོད",
        "ཡ་ཀུཙིཀི་ཚད་ལྡན་ཆུ་ཚོད",
        "བཱོལ་གོ་གིརེཌ་བྱཱར་དུས་ཆུ་ཚོད",
        "བཱོལ་གོ་གིརེཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "བ་ལ་ཌི་བོསི་ཏོཀ་བྱཱར་དུས་ཆུ་ཚོད",
        "Nửa",
        "བ་ལ་ཌི་བོསི་ཏོཀ་ཚད་ལྡན་ཆུ་ཚོད",
        "བེ་ནི་ཛུ་ཝེ་ལ་ཆུ་ཚོད",
        "ཡུ་རུ་གུ་ཝཱའི་བྱཱར་དུས་ཆུ་ཚོད",
        "Châu",
        "Viễn",
        "thuộc",
        "ཡུ་རུ་གུ་ཝཱའི་ཚད་ལྡན་ཆུ་ཚོད",
        "Cực",
        "སུ་རི་ནཱམ་ཆུ་ཚོད",
        "སེ་ཤཱལས་ཆུ་ཚོད",
        "bình",
        "Vùng",
        "Vịnh",
        "ས་ཁ་ལིན་བྱཱར་དུས་ཆུ་ཚོད",
        "ས་ཁ་ལིན་ཚད་ལྡན་ཆུ་ཚོད",
        "རི་ཡུ་ནི་ཡཱན་ཆུ་ཚོད",
        "པའི་རི་དང་མི་ཀི་ལཱོན་ཉིན་སྲུང་ཆུ་ཚོད",
        "པའི་རི་དང་མི་ཀི་ལཱོན་ཚད་ལྡན་ཆུ་ཚོད",
        "པ་རུ་བྱཱར་དུས་ཆུ་ཚོད",
        "པ་རུ་ཚད་ལྡན་ཆུ་ཚོད",
        "པ་ར་གུ་ཝའི་བྱཱར་དུས་ཆུ་ཚོད",
        "པ་ར་གུ་ཝའི་ཚད་ལྡན་ཆུ་ཚོད",
        "པ་ཀི་ས྄ཏཱན་བྱཱར་དུས་ཆུ་ཚོད",
        "པ་ཀི་ས྄ཏཱན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨོམསཀི་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨོམསཀི་ཚད་ལྡན་ཆུ་ཚོད",
        "Nhưỡng",
        "ban",
        "ngày",
        "ནོ་བོ་སི་བིརསཀི་བྱཱར་དུས་ཆུ་ཚོད",
        "ནོ་བོ་སི་བིརསཀི་ཚད་ལྡན་ཆུ་ཚོད",
        "ནོ་རཱོན་ཧ་བྱཱར་དུས་ཆུ་ཚོད",
        "ནོ་རཱོན་ཧ་ཚད་ལྡན་ཆུ་ཚོད",
        "ནིའུ་ཕའུནཌ་ལེནཌ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ནིའུ་ཕའུནཌ་ལེནཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "ནིའུ་ཛི་ལེནཌ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ནིའུ་ཛི་ལེནཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "ནེ་པཱལ་ཆུ་ཚོད",
        "མཽས་ཀོ་བྱཱར་དུས་ཆུ་ཚོད",
        "མཽས་ཀོ་ཚད་ལྡན་ཆུ་ཚོད",
        "མོ་རི་ཤཱས་བྱཱར་དུས་ཆུ་ཚོད",
        "མོ་རི་ཤཱས་ཚད་ལྡན་ཆུ་ཚོད",
        "མཱལ་དིབས་ཆུ་ཚོད",
        "མ་གྷ་དཱན་བྱཱར་དུས་ཆུ་ཚོད",
        "མ་གྷ་དཱན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཀརསི་ནོ་ཡརསཀི་བྱཱར་དུས་ཆུ་ཚོད",
        "ཀརསི་ནོ་ཡརསཀི་ཚད་ལྡན་ཆུ་ཚོད",
        "ཀོ་རི་ཡ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཀོ་རི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཇ་པཱན་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཇ་པཱན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨིས་རེལ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཨིས་རེལ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨར་ཀུཙི་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨར་ཀུཙི་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨི་རཱན་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཨི་རཱན་ཚད་ལྡན་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨིན་ཌོ་ནེ་ཤི་ཡ་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཨིན་ཌོ་ནེ་ཤི་ཡ་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཨིན་ཌོ་ནེ་ཤི་ཡ་ཆུ་ཚོད",
        "ཨིན་ཌོ་ཅཱའི་ན་ཆུ་ཚོད",
        "རྒྱ་གར་གྱི་རྒྱ་མཚོ་ཆུ་ཚོད",
        "རྒྱ་གར་ཆུ་ཚོད",
        "ཨེ་ལིའུ་ཤེན་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཨེ་ལིའུ་ཤེན་ཚད་ལྡན་ཆུ་ཚོད",
        "གུ་ཡ་ན་ཆུ་ཚོད",
        "གཱལཕི་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་གིརིན་ལེནཌ་བྱཱར་དུས་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་གིརིན་ལེནཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་གིརིན་ལེནཌ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་གིརིན་ལེནཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "གིརིན་ཝིཆ་ལུ་ཡོད་པའི་ཆུ་ཚོད",
        "ཇཽ་ཇཱ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཇཽ་ཇཱ་ཚད་ལྡན་ཆུ་ཚོད",
        "ག་ལ་པ་གོསི་ཆུ་ཚོད",
        "ཕིརེནཅ་གི་ཡ་ན་ཆུ་ཚོད",
        "ཕལཀ་ལེནཌ་ཨཱའི་ལེནཌས་བྱཱར་དུས་ཆུ་ཚོད",
        "ཕལཀ་ལེནཌ་ཨཱའི་ལེནཌས་ཚད་ལྡན་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཡུ་རོ་པེན་བྱཱར་དུས་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཡུ་རོ་པེན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཡུ་རོ་པེན་བྱཱར་དུས་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཡུ་རོ་པེན་ཚད་ལྡན་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཡུ་རོ་པེན་བྱཱར་དུས་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཡུ་རོ་པེན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨེ་ཀུ་ཌཽ་ཆུ་ཚོད",
        "ཨིསི་ཊར་ཨཱའི་ལེནཌ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨིསི་ཊར་ཨཱའི་ལེནཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཀིའུ་བྷ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཀིའུ་བྷ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཀོ་ལོམ་བྷི་ཡ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཀོ་ལོམ་བྷི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཁི་རིསྟ་མེས་མཚོ་གླིང་ཆུ་ཚོད",
        "རྒྱ་ནག་ཉིན་སྲུང་ཆུ་ཚོད",
        "རྒྱ་ནག་ཚད་ལྡན་ཆུ་ཚོད",
        "ཅི་ལི་བྱཱར་དུས་ཆུ་ཚོད",
        "ཅི་ལི་ཚད་ལྡན་ཆུ་ཚོད",
        "ཀེཔ་བཱཌ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཀེཔ་བཱཌ་ཚད་ལྡན་ཆུ་ཚོད",
        "བྲ་ཛི་ལི་ཡ་བྱཱར་དུས་ཆུ་ཚོད",
        "བྲ་ཛི་ལི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "བྷོ་ལི་བི་ཡ་ཆུ་ཚོད",
        "འབྲུག་ཡུལ་ཆུ་ཚོད",
        "བངྒ་ལ་དེཤ་བྱཱར་དུས་ཆུ་ཚོད",
        "བངྒ་ལ་དེཤ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨེ་ཛོརས་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨེ་ཛོརས་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨ་ཛར་བྷའི་ཇཱན་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨ་ཛར་བྷའི་ཇཱན་ཚད་ལྡན་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "དབུས་ནུབ་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཉིན་སྲུང་ཆུ་ཚོད",
        "དབུས་ནུབ་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཉིན་སྲུང་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཨཱོས་ཊྲེལ་ལི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨེཊ་ལེན་ཊིཀ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཨེཊ་ལེན་ཊིཀ་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨར་མི་ནི་ཡ་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨར་མི་ནི་ཡ་ཚད་ལྡན་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨར་ཇེན་ཊི་ན་བྱཱར་དུས་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨར་ཇེན་ཊི་ན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨར་ཇེན་ཊི་ན་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨར་ཇེན་ཊི་ན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨ་རེ་བྷི་ཡན་སྲུང་ཆུ་ཚོད",
        "ཨ་རེ་བྷི་ཡན་ཚད་ལྡན་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་པེ་སི་ཕིག་ཉིན་སྲུང་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་པེ་སི་ཕིག་ཚད་ལྡན་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་མའུ་ཊེན་ཉིན་སྲུང་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་མའུ་ཊེན་ཚད་ལྡན་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་ཤར་ཕྱོགས་ཉིན་སྲུང་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་ཤར་ཕྱོགས་ཚད་ལྡན་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་དབུས་ཕྱོགས་ཉིན་སྲུང་ཆུ་ཚོད",
        "བྱང་ཨ་མི་རི་ཀ་དབུས་ཕྱོགས་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨེ་མ་ཛཱོན་བྱཱར་དུས་ཆུ་ཚོད",
        "ཨེ་མ་ཛཱོན་ཚད་ལྡན་ཆུ་ཚོད",
        "ཨ་ལསི་ཀ་ཉིན་སྲུང་ཆུ་ཚོད",
        "ཨ་ལསི་ཀ་ཚད་ལྡན་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨཕ་རི་ཀཱ་བྱཱར་དུས་ཆུ་ཚོད",
        "ནུབ་ཕྱོགས་ཨཕ་རི་ཀཱ་ཚད་ལྡན་ཆུ་ཚོད",
        "ལྷོ་ཕྱོགས་ཨཕ་རི་ཀཱ་ཆུ་ཚོད",
        "ཤར་ཕྱོགས་ཨཕ་རི་ཀཱ་ཆུ་ཚོད",
        "དབུས་ཕྱོགས་ཨཕ་རི་ཀཱ་ཆུ་ཚོད",
        "ཨཕ་ག་ནི་ས྄ཏཱནཆུ་ཚོད",
        "Tuvalski",
        "Chuukski",
        "Tokelauski",
        "Tadźikiski",
        "Tahitiski",
        "Pódpołdnjowogeorgiski",
        "Salomoński",
        "Seychelski",
        "Nowoginejski",
        "Palauski",
        "Niueski",
        "Nauruski",
        "Myanmarski",
        "Marqueski",
        "Malediwski",
        "Malajziski",
        "Kirgiski",
        "Kosraeski",
        "Pódwjacornokazachski",
        "Pódzajtšnokazachski",
        "Pódwjacornoindoneski",
        "Pódzajtšnoindoneski",
        "Srjejźoindoneski",
        "Indochinski",
        "Indiskooceaniski",
        "Indiski",
        "Guyański",
        "Persiskego",
        "Galapagoski",
        "teritoriuma",
        "pódpołdnjowego",
        "francojskego",
        "Francojskoguyański",
        "Ekuadorski",
        "Pódzajtšnotimorski",
        "DumontDUrville",
        "Gódownych",
        "Chamorrski",
        "Bruneiski",
        "Boliwiski",
        "Bhutański",
        "Pódpołdnjowoafriski",
        "Pódzajtšnoafriski",
        "Srjejźoafriski",
        "Afghaniski",
        "Tajicistan",
        "Indo",
        "Gwlff",
        "Frengig",
        "Antarctig",
        "ac",
        "Deheuol",
        "Ffrengig",
        "Pell",
        "Hanner",
        "Nadolig",
        "Venezuelský",
        "Tuvalský",
        "Chuukský",
        "Tokelauský",
        "Tádžický",
        "Tahitský",
        "Surinamský",
        "Jižní",
        "Šalamounových",
        "Singapurský",
        "Seychelský",
        "Rotherovy",
        "Réunionský",
        "Pchjongjangský",
        "Ponapský",
        "Pitcairnova",
        "Nové",
        "Palauský",
        "Severomariánský",
        "Norfolský",
        "Niuejský",
        "Nepálský",
        "Naurský",
        "Myanmarský",
        "Mawsonovy",
        "Markézský",
        "Maledivský",
        "Malajský",
        "Srílanský",
        "Kyrgyzský",
        "Kosrajský",
        "Západokazachstánský",
        "Východokazachstánský",
        "Západoindonéský",
        "Východoindonéský",
        "Středoindonéský",
        "Indočínský",
        "Indickooceánský",
        "Indický",
        "Guyanský",
        "Perského",
        "Guamský",
        "střední",
        "Greenwichský",
        "Gambierský",
        "Galapážský",
        "jižních",
        "Francouzských",
        "Francouzskoguyanský",
        "Dálněvýchodoevropský",
        "Ekvádorský",
        "Východotimorský",
        "d’Urvilla",
        "Davisovy",
        "Vánočního",
        "Chamorrský",
        "Caseyho",
        "Brunejský",
        "Bolivijský",
        "Bhútánský",
        "Jihoafrický",
        "Východoafrický",
        "Středoafrický",
        "Afghánský",
        "ᏊᏚᎾ",
        "ᏩᎵᏍ",
        "ᎤᏰᏨ",
        "ᏬᏍᏙᎧ",
        "ᏪᏁᏑᏪᎳ",
        "ᏚᏩᎷ",
        "ᏧᎩ",
        "ᏙᎨᎳᎤ",
        "ᏔᏥᎩᏍᏕᏂ",
        "ᏔᎯᏘ",
        "ᏏᏲᏩ",
        "ᏒᎵᎾᎻ",
        "ᏐᎶᎹᏂ",
        "ᏏᏂᎦᏉᎵ",
        "ᏎᏤᎴᏏ",
        "ᎳᏞᎳ",
        "ᎴᏳᏂᎠᏂ",
        "ᏈᏯᏂᎩᏰᏂᎩ",
        "ᏉᎾᏇ",
        "ᏈᎧᎵᏂ",
        "ᏧᎴᎯᏌᏅᎯ",
        "ᎩᎢᏂ",
        "ᏆᏇ",
        "ᏆᎷ",
        "ᏃᎵᏬᎵᎩ",
        "ᏂᏳ",
        "ᏁᏆᎵ",
        "ᎾᎷ",
        "ᎹᏯᎹᎵ",
        "ᎹᏌᏂ",
        "ᎹᏌᎵ",
        "ᎹᎵᎨᏌᏏ",
        "ᎹᎵᏗᏫᏍ",
        "ᎹᎴᏏᎢᎠ",
        "ᎹᏇᎵ",
        "ᎠᏍᏓᏅᏅ",
        "ᎩᎵᏣᎢᏍ",
        "ᎪᏍᎴ",
        "ᎢᏂᏙᏓᎶᏂᎨᏍᏛ",
        "ᎠᎺᏉᎯ",
        "ᎠᏂᏴᏫᏯ",
        "ᎢᏂᏗᎢᎠ",
        "ᎦᏯᎾ",
        "ᎡᏉᏄᎸᏗ",
        "ᎢᏳᏍᏗ",
        "ᎩᎵᏇᏘ",
        "ᎦᎻᏇᎵ",
        "ᏓᎦᏏ",
        "ᎡᏆ",
        "ᎤᏁᏍᏓᎶ",
        "ᎤᎦᏃᏮ",
        "ᎠᏂᎦᎸᏥ",
        "ᏈᏯᎾ",
        "ᎠᏂᎦᎸ",
        "ᎡᏆᏙᎵ",
        "ᏘᎼᎵ",
        "Ꮧ’ᎤᎵᏫᎵ",
        "ᏚᎼᎾᏘ",
        "ᏕᏫᏏ",
        "ᎪᎪᏍ",
        "ᏓᏂᏍᏓᏲᎯᎲ",
        "ᏣᎼᎶ",
        "ᏓᎷᏌᎳᎻ",
        "ᏊᎾᎢ",
        "ᏉᎵᏫᎠ",
        "ᏊᏔᏂ",
        "ᎠᏫᎨᏂᏍᏖᏂ",
        "е",
        "Георги",
        "Соломонан",
        "Сейшелан",
        "Гвиней",
        "Маршалан",
        "Маркизан",
        "Мальдиваш",
        "Малайзи",
        "Киргизи",
        "Индин",
        "айма",
        "ГӀажарийн",
        "юкъара",
        "Гринвичица",
        "Гилбертан",
        "Галапагосан",
        "Антарктидан",
        "къилба",
        "Минскера",
        "Калининградера",
        "Кокосийн",
        "ден",
        "винчу",
        "пайхамар",
        "Ӏийса",
        "Боливи",
        "пачхьалкх",
        "ОвхӀан",
        "веме",
        "Макверијско",
        "Лине",
        "Киргизстан",
        "Хонгконшко",
        "средње",
        "Гамбијер",
        "Божићна",
        "Зеленортско",
        "Зелениртско",
        "лтње",
        "फ़ुतुना",
        "वालीस",
        "वाके",
        "वॉस्तॉक",
        "तुवालु",
        "ट्रुक",
        "टोकेलौ",
        "ताजीक़ीस्तान",
        "टाहिटी",
        "सीओवा",
        "सुरीनाम",
        "साऊथ",
        "सॉलॉमन",
        "सींगापुर",
        "रियूनियन",
        "(पोह्नपेई)",
        "पीटकैर्न",
        "फीनीक्स",
        "गीनी",
        "मारिआना",
        "नॉर्थ",
        "नीऊई",
        "नाऊरु",
        "र्स्टैंडर्ड",
        "मार्केज़ास",
        "लाईन",
        "क़ीर्ग़स्तान",
        "कोसरी",
        "चइना",
        "ईंडो",
        "महासगर",
        "गल्फ़",
        "ग्रीनीच",
        "गीलबर्ट",
        "गांबिये",
        "गालापागोस",
        "एक्वाडौर",
        "टीमोर",
        "ईस्ट",
        "ड्युरवील",
        "ड्युमों",
        "डेवीस",
        "कोको",
        "क्रीसमस",
        "चामरो",
        "सलाम",
        "उस",
        "दर",
        "बोलिविया",
        "भुटान",
        "अर्जनटिना",
        "अफ़गानी",
        "Su",
        "Sechelez",
        "Reünion",
        "Maldivez",
        "Kyrgyzstan",
        "Indez",
        "Pers",
        "mor",
        "Pleg",
        "(AKG)",
        "keitat",
        "Amzer",
        "hag",
        "Frañs",
        "aostral",
        "Douaroù",
        "cʼhall",
        "Kokoz",
        "Suafrika",
        "Kreizafrika",
        "Венецуелско",
        "Чуюк",
        "Таджикистанско",
        "Таитянско",
        "Суринамско",
        "Южна",
        "Соломонови",
        "Сингапурско",
        "Сейшелски",
        "Пхенян",
        "Времето",
        "Непалско",
        "Мианмарско",
        "Моусън",
        "Маршалови",
        "Маркизки",
        "Малдивски",
        "Малайзийско",
        "Екваториални",
        "Киргизстанско",
        "Кошрай",
        "Западноказахстанско",
        "Източноказахстанско",
        "Западноиндонезийско",
        "Източноиндонезийско",
        "Централноиндонезийско",
        "Индокитайско",
        "Индийски",
        "Индийско",
        "Гаяна",
        "Персийски",
        "гринуичко",
        "Гилбърт",
        "Галапагоско",
        "територии",
        "антарктически",
        "южни",
        "Френски",
        "Френска",
        "източноевропейско",
        "Далечно",
        "Еквадорско",
        "Източнотиморско",
        "Дюрвил",
        "Кокосови",
        "Боливийско",
        "Бутанско",
        "Южноафриканско",
        "Източноафриканско",
        "Централноафриканско",
        "Афганистанско",
        "Уоліс",
        "Усход",
        "Венесуэльскі",
        "Такелау",
        "Таджыкістана",
        "Таіці",
        "Сурынама",
        "Джорджыі",
        "Паўднёвай",
        "Саламонавых",
        "Сінгапурскі",
        "Сейшэльскіх",
        "Ратэра",
        "Рэюньёна",
        "Пхеньянскі",
        "Понпеі",
        "Піткэрн",
        "Гвінеі",
        "Норфалк",
        "Ніуэ",
        "Непальскі",
        "М’янмы",
        "стандатны",
        "Моўсан",
        "Маршалавых",
        "Маркізскіх",
        "Мальдыў",
        "Малайзіі",
        "Макуоры",
        "Кыргызстана",
        "Кусаіе",
        "Заходнеказахстанскі",
        "Усходнеказахстанскі",
        "Заходнеінданезійскі",
        "Усходнеінданезійскі",
        "Цэнтральнаінданезійскі",
        "Індакітайскі",
        "акіяна",
        "Індыйскага",
        "Індыі",
        "Гаяны",
        "заліва",
        "Персідскага",
        "Грынвічы",
        "па",
        "Гамб’е",
        "атравоў",
        "Галапагоскіх",
        "тэрыторый",
        "Антарктычных",
        "Паўднёвых",
        "Французскіх",
        "Гвіяны",
        "Французскай",
        "Беларускі",
        "Эквадорскі",
        "Тымора",
        "Усходняга",
        "Дзюрвіль",
        "Дзюмон",
        "Дэйвіс",
        "Паўлетні",
        "Какосавых",
        "Каляд",
        "Чамора",
        "Брунея",
        "Балівійскі",
        "Бутана",
        "Паўднёваафрыканскі",
        "Усходнеафрыканскі",
        "Цэнтральнаафрыканскі",
        "Афганістанскі",
        "branu",
        "Marianes",
        "estandar",
        "d’Indochina",
        "Índicu",
        "Océanu",
        "Golfu",
        "francés",
        "l’antárticu",
        "sur",
        "saseMpumalanga",
        "estremu",
        "saseNingizimu",
        "d’Ecuador",
        "d’Afganistán",
        "স.",
        "ভা.",
        "ভাৰতীয়",
        "የያኩትስክ",
        "ያኩትስክ",
        "ፉቱና",
        "የዋሊስ",
        "የዌክ",
        "የቮስቶክ",
        "የቫልጎራድ",
        "esiyingxenye",
        "yasehlobo",
        "የቮልጎራድ",
        "የቭላዲቮስቶክ",
        "sakwa",
        "Mpumalanga",
        "esisezengeni",
        "Iikhathi",
        "የቪላዲቮስቶክ",
        "የቬኔዝዌላ",
        "የአይሪሽ",
        "የብሪትሽ",
        "የቱቫሉ",
        "የቹክ",
        "የቶኬላው",
        "የታጂኪስታን",
        "የታሂቲ",
        "የሲዮዋ",
        "የሱሪናም",
        "ጂዮርጂያ",
        "Ірландскі",
        "Брытанскі",
        "Ирландско",
        "የሰለሞን",
        "የሲንጋፒር",
        "የሴሸልስ",
        "Iwerzhon",
        "Breizh",
        "Veur",
        "आईरीश",
        "ब्रीटीश",
        "የሮቴራ",
        "የሬዩኒየን",
        "የፕዮንግያንግ",
        "የፖናፔ",
        "Ирланди",
        "Британин",
        "ᎨᎵᎩ",
        "ᏈᏗᏏ",
        "Irský",
        "Britský",
        "Iwerddon",
        "Prydain",
        "የፒትካይርን",
        "የፊኒክስ",
        "ጊኒ",
        "ኒው",
        "Iriski",
        "የፓፗ",
        "ཨཱ་ཡརིཤ་བྱཱར་དུས་ཆུ་ཚོད",
        "བྲཱི་ཊིཤ་བྱཱར་དུས་ཆུ་ཚོད",
        "የፓላው",
        "ሰአት",
        "የኖቮሲብሪስክ",
        "የኖቮሲቢርስክ",
        "BST",
        "ኖሮንሃ",
        "Iiri",
        "Briti",
        "Irlandako",
        "Londresko",
        "ኖሮንቻ",
        "የኖርፎልክ",
        "Irlannin",
        "Britannian",
        "የኒዩዌ",
        "Britain",
        "የኔፓል",
        "የናውሩ",
        "የሚያንማር",
        "የማውሰን",
        "የማርሻል",
        "Caighdéanach",
        "hÉireann",
        "ACÉ",
        "Breataine",
        "ASB",
        "Èireann",
        "TSÈ",
        "(Èirinn)",
        "Bhreatainn",
        "TSB",
        "irlandés",
        "británico",
        "આઈરિશ",
        "બ્રિટિશ",
        "אירלנד",
        "בריטניה",
        "የማርኴሳስ",
        "የማልዲቭስ",
        "የማሌይዢያ",
        "የማከሪ",
        "Irski",
        "ír",
        "brit",
        "Իռլանդական",
        "Բրիտանական",
        "የላይን",
        "Inggris",
        "Írlandi",
        "Bretlandi",
        "የኪርጊስታን",
        "የክራስኖያርስክ",
        "የክራስኖይአርስክ",
        "アイルランド標準時",
        "英国夏時間",
        "ირლანდიის",
        "ბრიტანეთის",
        "የኮስራኤ",
        "Ұлыбритания",
        "ម៉ោង​រដូវ​ក្ដៅ​នៅ​អៀរឡង់​",
        "ម៉ោង​រដូវ​ក្ដៅ​​នៅ​ចក្រភព​អង់គ្លេស",
        "ಐರಿಷ್",
        "ಬ್ರಿಟಿಷ್",
        "ኢርኩትስክ",
        "የኢርኩትስክ",
        "اَیرِش",
        "برطٲنوی",
        "Irland",
        "Jrußbretannije",
        "የኢንዶቻይና",
        "Iresch",
        "Britesch",
        "ເວ​ລາ​ມາດ​ຕະ​ຖານ​ໄອ​ຣິ​ຊ",
        "ເວ​ລາ​ລະ​ດູ​ຮ້ອນ​ອັງ​ກິດ",
        "Airijos",
        "Britanijos",
        "Īrijas",
        "Lielbritānijas",
        "Ирско",
        "ഐറിഷ്",
        "ബ്രിട്ടീഷ്",
        "Ирландын",
        "Британийн",
        "आयरिश",
        "အိုင်းရစ်ရှ်စံတော်ချိန်",
        "ဗြိတိန်နွေရာသီအချိန်",
        "ውቅያኖስ",
        "የጉያና",
        "የባህረሰላጤ",
        "ማዕከላዊ",
        "ግሪንዊች",
        "Brytyjski",
        "czas",
        "የጂልበርት",
        "Britânico",
        "የጋምቢየር",
        "የጋላፓጎስ",
        "አንታርክቲክ",
        "අයර්ලන්ත",
        "බ්‍රිතාන්‍ය",
        "írsky",
        "britský",
        "irski",
        "britanski",
        "ደቡባዊ",
        "ጉያና",
        "የአውሮፓ",
        "የሩቅ",
        "የኢኳዶር",
        "ቲሞር",
        "ዱርቪል",
        "የዱሞንት",
        "የዴቪስ",
        "ግማሽ",
        "የኮኮስ",
        "የገና",
        "የሰአት",
        "የቻሞሮ",
        "ዳሩሳላም",
        "የብሩኔይ",
        "የብራዚላ",
        "የብራሲሊያ",
        "ఐరిష్",
        "బ్రిటీష్",
        "เวลามาตรฐานไอร์แลนด์",
        "เวลาฤดูร้อนอังกฤษ",
        "Irlandiýa",
        "Beýik",
        "Britaniýa",
        "fakaʻaealani",
        "fakapilitānia",
        "የቦሊቪያ",
        "የቡታን",
        "ئىرېلاند",
        "ئەنگلىيە",
        "Ірландії",
        "Великій",
        "Британії",
        "መካከለኛው",
        "አርጀንቲና",
        "ጊዜ",
        "Ai",
        "len",
        "Anh",
        "የአናድይር",
        "የአናዲይር",
        "የቀንሰዓት",
        "የአፍጋኒስታን",
        "Гвинейн"
    ]
});};


/***/ }),
/* 1363 */
/***/ (function(module, exports) {

/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
module.exports = function load(global) {global.Intl && global.Intl._metaZoneData && global.Intl._metaZoneData.load({
    "Africa/Abidjan": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Accra": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Addis_Ababa": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Algiers": [
        {
            "mzone": "Europe_Western",
            "to": "1977-10-20 23:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1977-10-20 23:00",
            "to": "1979-10-25 23:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1979-10-25 23:00",
            "to": "1981-05-01 00:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1981-05-01 00:00"
        }
    ],
    "Africa/Asmera": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Bamako": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Bangui": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Banjul": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Bissau": [
        {
            "mzone": "Africa_FarWestern",
            "to": "1975-01-01 01:00"
        },
        {
            "mzone": "GMT",
            "from": "1975-01-01 01:00"
        }
    ],
    "Africa/Blantyre": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Brazzaville": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Bujumbura": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Cairo": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Africa/Casablanca": [
        {
            "mzone": "Europe_Western",
            "to": "1984-03-16 00:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1984-03-16 00:00",
            "to": "1985-12-31 23:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1985-12-31 23:00"
        }
    ],
    "Africa/Ceuta": [
        {
            "mzone": "Europe_Western",
            "to": "1984-03-16 00:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1984-03-16 00:00"
        }
    ],
    "Africa/Conakry": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Dakar": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Dar_es_Salaam": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Djibouti": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Douala": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/El_Aaiun": [
        {
            "mzone": "Africa_FarWestern",
            "to": "1976-04-14 01:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1976-04-14 01:00"
        }
    ],
    "Africa/Freetown": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Gaborone": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Harare": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Johannesburg": [
        {
            "mzone": "Africa_Southern"
        }
    ],
    "Africa/Juba": [
        {
            "mzone": "Africa_Central",
            "to": "2000-01-15 10:00"
        },
        {
            "mzone": "Africa_Eastern",
            "from": "2000-01-15 10:00"
        }
    ],
    "Africa/Kampala": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Khartoum": [
        {
            "mzone": "Africa_Central",
            "to": "2000-01-15 10:00"
        },
        {
            "mzone": "Africa_Eastern",
            "from": "2000-01-15 10:00"
        }
    ],
    "Africa/Kigali": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Kinshasa": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Lagos": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Libreville": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Lome": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Luanda": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Lubumbashi": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Lusaka": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Malabo": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Maputo": [
        {
            "mzone": "Africa_Central"
        }
    ],
    "Africa/Maseru": [
        {
            "mzone": "Africa_Southern"
        }
    ],
    "Africa/Mbabane": [
        {
            "mzone": "Africa_Southern"
        }
    ],
    "Africa/Mogadishu": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Monrovia": [
        {
            "mzone": "Liberia",
            "to": "1972-05-01 00:45"
        },
        {
            "mzone": "GMT",
            "from": "1972-05-01 00:45"
        }
    ],
    "Africa/Nairobi": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Africa/Ndjamena": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Niamey": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Nouakchott": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Ouagadougou": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Porto-Novo": [
        {
            "mzone": "Africa_Western"
        }
    ],
    "Africa/Sao_Tome": [
        {
            "mzone": "GMT"
        }
    ],
    "Africa/Tripoli": [
        {
            "mzone": "Europe_Eastern",
            "to": "1981-12-31 22:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1981-12-31 22:00",
            "to": "1990-05-03 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1990-05-03 23:00",
            "to": "1996-09-29 22:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1996-09-29 22:00",
            "to": "1997-10-03 22:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1997-10-03 22:00",
            "to": "2012-11-10 00:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "2012-11-10 00:00",
            "to": "2013-10-25 00:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "2013-10-25 00:00"
        }
    ],
    "Africa/Tunis": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Africa/Windhoek": [
        {
            "mzone": "Africa_Southern",
            "to": "1990-03-20 22:00"
        },
        {
            "mzone": "Africa_Central",
            "from": "1990-03-20 22:00",
            "to": "1994-04-02 22:00"
        },
        {
            "mzone": "Africa_Western",
            "from": "1994-04-02 22:00"
        }
    ],
    "America/Adak": [
        {
            "mzone": "Bering",
            "to": "1983-10-30 12:00"
        },
        {
            "mzone": "Hawaii_Aleutian",
            "from": "1983-11-30 10:00"
        }
    ],
    "America/Anchorage": [
        {
            "mzone": "Alaska_Hawaii",
            "to": "1983-10-30 11:00"
        },
        {
            "mzone": "Yukon",
            "from": "1983-10-30 11:00",
            "to": "1983-11-30 09:00"
        },
        {
            "mzone": "Alaska",
            "from": "1983-11-30 09:00"
        }
    ],
    "America/Anguilla": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Antigua": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Araguaina": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Argentina/La_Rioja": [
        {
            "mzone": "Argentina",
            "to": "1991-03-01 02:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "1991-03-01 02:00",
            "to": "1991-05-07 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-05-07 04:00",
            "to": "2004-06-01 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-06-01 03:00",
            "to": "2004-06-20 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-06-20 04:00"
        }
    ],
    "America/Argentina/Rio_Gallegos": [
        {
            "mzone": "Argentina",
            "to": "2004-06-01 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-06-01 03:00",
            "to": "2004-06-20 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-06-20 04:00"
        }
    ],
    "America/Argentina/Salta": [
        {
            "mzone": "Argentina",
            "to": "1991-03-03 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-10-20 04:00"
        }
    ],
    "America/Argentina/San_Juan": [
        {
            "mzone": "Argentina",
            "to": "1991-03-01 02:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "1991-03-01 02:00",
            "to": "1991-05-07 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-05-07 04:00",
            "to": "2004-05-31 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-05-31 03:00",
            "to": "2004-07-25 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-07-25 04:00"
        }
    ],
    "America/Argentina/San_Luis": [
        {
            "mzone": "Argentina",
            "to": "1990-03-14 02:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "1990-03-14 02:00",
            "to": "1991-06-01 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-06-01 04:00",
            "to": "1999-10-03 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "1999-10-03 03:00",
            "to": "2000-03-03 03:00"
        },
        {
            "mzone": "Argentina",
            "from": "2000-03-03 03:00",
            "to": "2004-05-31 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-05-31 03:00",
            "to": "2004-07-25 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-07-25 04:00",
            "to": "2008-01-21 02:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2008-01-21 02:00"
        }
    ],
    "America/Argentina/Tucuman": [
        {
            "mzone": "Argentina",
            "to": "1991-03-03 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-10-20 04:00",
            "to": "2004-06-01 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-06-01 03:00",
            "to": "2004-06-13 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-06-13 04:00"
        }
    ],
    "America/Argentina/Ushuaia": [
        {
            "mzone": "Argentina",
            "to": "2004-05-30 03:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-06-20 04:00"
        }
    ],
    "America/Aruba": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Asuncion": [
        {
            "mzone": "Paraguay"
        }
    ],
    "America/Bahia": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Bahia_Banderas": [
        {
            "mzone": "America_Pacific",
            "to": "1970-01-01 08:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "1970-01-01 08:00",
            "to": "2010-04-04 09:00"
        },
        {
            "mzone": "America_Central",
            "from": "2010-04-04 09:00"
        }
    ],
    "America/Barbados": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Belem": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Belize": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Blanc-Sablon": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Boa_Vista": [
        {
            "mzone": "Amazon"
        }
    ],
    "America/Bogota": [
        {
            "mzone": "Colombia"
        }
    ],
    "America/Boise": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "America/Buenos_Aires": [
        {
            "mzone": "Argentina"
        }
    ],
    "America/Cambridge_Bay": [
        {
            "mzone": "America_Mountain",
            "to": "1999-10-31 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "1999-10-31 08:00",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00",
            "to": "2000-11-05 05:00"
        },
        {
            "mzone": "America_Central",
            "from": "2000-11-05 05:00",
            "to": "2001-04-01 09:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "2001-04-01 09:00"
        }
    ],
    "America/Campo_Grande": [
        {
            "mzone": "Amazon"
        }
    ],
    "America/Cancun": [
        {
            "mzone": "America_Central",
            "to": "1981-12-23 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1981-12-23 06:00",
            "to": "1998-08-02 06:00"
        },
        {
            "mzone": "America_Central",
            "from": "1998-08-02 06:00",
            "to": "2015-02-01 08:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2015-02-01 08:00"
        }
    ],
    "America/Caracas": [
        {
            "mzone": "Venezuela"
        }
    ],
    "America/Catamarca": [
        {
            "mzone": "Argentina",
            "to": "1991-03-03 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-10-20 04:00",
            "to": "2004-06-01 03:00"
        },
        {
            "mzone": "Argentina_Western",
            "from": "2004-06-01 03:00",
            "to": "2004-06-20 04:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-06-20 04:00"
        }
    ],
    "America/Cayenne": [
        {
            "mzone": "French_Guiana"
        }
    ],
    "America/Cayman": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Chicago": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Chihuahua": [
        {
            "mzone": "America_Central",
            "to": "1998-04-05 09:00"
        },
        {
            "mzone": "Mexico_Pacific",
            "from": "1998-04-05 09:00"
        }
    ],
    "America/Coral_Harbour": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Cordoba": [
        {
            "mzone": "Argentina",
            "to": "1991-03-03 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-10-20 04:00"
        }
    ],
    "America/Costa_Rica": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Creston": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "America/Cuiaba": [
        {
            "mzone": "Amazon"
        }
    ],
    "America/Curacao": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Danmarkshavn": [
        {
            "mzone": "Greenland_Western",
            "to": "1996-01-01 03:00"
        },
        {
            "mzone": "GMT",
            "from": "1996-01-01 03:00"
        }
    ],
    "America/Dawson": [
        {
            "mzone": "Yukon",
            "to": "1973-10-28 09:00"
        },
        {
            "mzone": "America_Pacific",
            "from": "1973-10-28 09:00"
        }
    ],
    "America/Dawson_Creek": [
        {
            "mzone": "America_Pacific",
            "to": "1972-08-30 09:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "1972-08-30 09:00"
        }
    ],
    "America/Denver": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "America/Detroit": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Dominica": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Edmonton": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "America/Eirunepe": [
        {
            "mzone": "Acre",
            "to": "2008-06-24 05:00"
        },
        {
            "mzone": "Amazon",
            "from": "2008-06-24 05:00",
            "to": "2013-11-10 04:00"
        },
        {
            "mzone": "Acre",
            "from": "2013-11-10 04:00"
        }
    ],
    "America/El_Salvador": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Fort_Nelson": [
        {
            "mzone": "America_Pacific",
            "to": "2015-03-08 10:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "2015-03-08 10:00"
        }
    ],
    "America/Fortaleza": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Glace_Bay": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Godthab": [
        {
            "mzone": "Greenland_Western"
        }
    ],
    "America/Goose_Bay": [
        {
            "mzone": "Atlantic",
            "to": "1988-04-03 04:01"
        },
        {
            "mzone": "Goose_Bay",
            "from": "1988-04-03 04:01",
            "to": "1988-10-30 02:01"
        },
        {
            "mzone": "Atlantic",
            "from": "1988-10-30 02:01"
        }
    ],
    "America/Grand_Turk": [
        {
            "mzone": "America_Eastern",
            "to": "2015-11-01 06:00"
        },
        {
            "mzone": "Atlantic",
            "from": "2015-11-01 06:00"
        }
    ],
    "America/Grenada": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Guadeloupe": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Guatemala": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Guayaquil": [
        {
            "mzone": "Ecuador"
        }
    ],
    "America/Guyana": [
        {
            "mzone": "Guyana"
        }
    ],
    "America/Halifax": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Havana": [
        {
            "mzone": "Cuba"
        }
    ],
    "America/Hermosillo": [
        {
            "mzone": "America_Pacific",
            "to": "1970-01-01 08:00"
        },
        {
            "mzone": "Mexico_Pacific",
            "from": "1970-01-01 08:00"
        }
    ],
    "America/Indiana/Knox": [
        {
            "mzone": "America_Central",
            "to": "1991-10-27 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1991-10-27 07:00",
            "to": "2006-04-02 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "2006-04-02 07:00"
        }
    ],
    "America/Indiana/Marengo": [
        {
            "mzone": "America_Eastern",
            "to": "1974-01-06 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "1974-01-06 07:00",
            "to": "1974-10-27 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1974-10-27 07:00"
        }
    ],
    "America/Indiana/Petersburg": [
        {
            "mzone": "America_Central",
            "to": "1977-10-30 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1977-10-30 07:00",
            "to": "2006-04-02 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "2006-04-02 07:00",
            "to": "2007-11-04 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2007-11-04 07:00"
        }
    ],
    "America/Indiana/Tell_City": [
        {
            "mzone": "America_Eastern",
            "to": "2006-04-02 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "2006-04-02 07:00"
        }
    ],
    "America/Indiana/Vevay": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Indiana/Vincennes": [
        {
            "mzone": "America_Eastern",
            "to": "2006-04-02 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "2006-04-02 07:00",
            "to": "2007-11-04 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2007-11-04 07:00"
        }
    ],
    "America/Indiana/Winamac": [
        {
            "mzone": "America_Eastern",
            "to": "2006-04-02 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "2006-04-02 07:00",
            "to": "2007-03-11 08:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2007-03-11 08:00"
        }
    ],
    "America/Indianapolis": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Inuvik": [
        {
            "mzone": "America_Pacific",
            "to": "1979-04-29 10:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "1979-04-29 10:00"
        }
    ],
    "America/Iqaluit": [
        {
            "mzone": "America_Eastern",
            "to": "1999-10-31 06:00"
        },
        {
            "mzone": "America_Central",
            "from": "1999-10-31 06:00",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00"
        }
    ],
    "America/Jamaica": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Jujuy": [
        {
            "mzone": "Argentina",
            "to": "1990-03-04 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1991-10-06 04:00"
        }
    ],
    "America/Juneau": [
        {
            "mzone": "America_Pacific",
            "to": "1980-04-27 10:00"
        },
        {
            "mzone": "Yukon",
            "from": "1980-04-27 10:00",
            "to": "1980-10-26 10:00"
        },
        {
            "mzone": "America_Pacific",
            "from": "1980-10-26 10:00",
            "to": "1983-10-30 09:00"
        },
        {
            "mzone": "Yukon",
            "from": "1983-10-30 09:00",
            "to": "1983-11-30 09:00"
        },
        {
            "mzone": "Alaska",
            "from": "1983-11-30 09:00"
        }
    ],
    "America/Kentucky/Monticello": [
        {
            "mzone": "America_Central",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00"
        }
    ],
    "America/Kralendijk": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/La_Paz": [
        {
            "mzone": "Bolivia"
        }
    ],
    "America/Lima": [
        {
            "mzone": "Peru"
        }
    ],
    "America/Los_Angeles": [
        {
            "mzone": "America_Pacific"
        }
    ],
    "America/Louisville": [
        {
            "mzone": "America_Eastern",
            "to": "1974-01-06 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "1974-01-06 07:00",
            "to": "1974-10-27 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1974-10-27 07:00"
        }
    ],
    "America/Lower_Princes": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Maceio": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Managua": [
        {
            "mzone": "America_Central",
            "to": "1973-05-01 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1973-05-01 06:00",
            "to": "1975-02-16 05:00"
        },
        {
            "mzone": "America_Central",
            "from": "1975-02-16 05:00",
            "to": "1992-01-01 10:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1992-01-01 10:00",
            "to": "1992-09-24 05:00"
        },
        {
            "mzone": "America_Central",
            "from": "1992-09-24 05:00",
            "to": "1993-01-01 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1993-01-01 06:00",
            "to": "1997-01-01 05:00"
        },
        {
            "mzone": "America_Central",
            "from": "1997-01-01 05:00"
        }
    ],
    "America/Manaus": [
        {
            "mzone": "Amazon"
        }
    ],
    "America/Marigot": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Martinique": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Matamoros": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Mazatlan": [
        {
            "mzone": "America_Pacific",
            "to": "1970-01-01 08:00"
        },
        {
            "mzone": "Mexico_Pacific",
            "from": "1970-01-01 08:00"
        }
    ],
    "America/Mendoza": [
        {
            "mzone": "Argentina",
            "to": "1990-03-04 02:00"
        },
        {
            "mzone": "Argentina",
            "from": "1992-10-18 04:00",
            "to": "2004-05-23 03:00"
        },
        {
            "mzone": "Argentina",
            "from": "2004-09-26 04:00"
        }
    ],
    "America/Menominee": [
        {
            "mzone": "America_Eastern",
            "to": "1973-04-29 07:00"
        },
        {
            "mzone": "America_Central",
            "from": "1973-04-29 07:00"
        }
    ],
    "America/Merida": [
        {
            "mzone": "America_Central",
            "to": "1981-12-23 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1981-12-23 06:00",
            "to": "1982-12-02 05:00"
        },
        {
            "mzone": "America_Central",
            "from": "1982-12-02 05:00"
        }
    ],
    "America/Metlakatla": [
        {
            "mzone": "America_Pacific",
            "to": "2015-11-01 10:00"
        },
        {
            "mzone": "Alaska",
            "from": "2015-11-01 10:00"
        }
    ],
    "America/Mexico_City": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Miquelon": [
        {
            "mzone": "Atlantic",
            "to": "1980-05-01 04:00"
        },
        {
            "mzone": "Pierre_Miquelon",
            "from": "1980-05-01 04:00"
        }
    ],
    "America/Moncton": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Monterrey": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Montevideo": [
        {
            "mzone": "Uruguay"
        }
    ],
    "America/Montserrat": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Nassau": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/New_York": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Nipigon": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Nome": [
        {
            "mzone": "Bering",
            "to": "1983-10-30 12:00"
        },
        {
            "mzone": "Yukon",
            "from": "1983-10-30 12:00",
            "to": "1983-11-30 09:00"
        },
        {
            "mzone": "Alaska",
            "from": "1983-11-30 09:00"
        }
    ],
    "America/Noronha": [
        {
            "mzone": "Noronha"
        }
    ],
    "America/North_Dakota/Beulah": [
        {
            "mzone": "America_Mountain",
            "to": "2010-11-07 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "2010-11-07 08:00"
        }
    ],
    "America/North_Dakota/Center": [
        {
            "mzone": "America_Mountain",
            "to": "1992-10-25 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "1992-10-25 08:00"
        }
    ],
    "America/North_Dakota/New_Salem": [
        {
            "mzone": "America_Mountain",
            "to": "2003-10-26 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "2003-10-26 08:00"
        }
    ],
    "America/Ojinaga": [
        {
            "mzone": "America_Central",
            "to": "1998-04-05 09:00"
        },
        {
            "mzone": "America_Mountain",
            "from": "1998-04-05 09:00"
        }
    ],
    "America/Panama": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Pangnirtung": [
        {
            "mzone": "Atlantic",
            "to": "1995-04-02 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "1995-04-02 06:00",
            "to": "1999-10-31 06:00"
        },
        {
            "mzone": "America_Central",
            "from": "1999-10-31 06:00",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00"
        }
    ],
    "America/Paramaribo": [
        {
            "mzone": "Dutch_Guiana",
            "to": "1975-11-20 03:30"
        },
        {
            "mzone": "Suriname",
            "from": "1975-11-20 03:30"
        }
    ],
    "America/Phoenix": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "America/Port_of_Spain": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Port-au-Prince": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Porto_Velho": [
        {
            "mzone": "Amazon"
        }
    ],
    "America/Puerto_Rico": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Rainy_River": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Rankin_Inlet": [
        {
            "mzone": "America_Central",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00",
            "to": "2001-04-01 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "2001-04-01 08:00"
        }
    ],
    "America/Recife": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Regina": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Resolute": [
        {
            "mzone": "America_Central",
            "to": "2000-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 07:00",
            "to": "2001-04-01 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "2001-04-01 08:00",
            "to": "2006-10-29 07:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2006-10-29 07:00",
            "to": "2007-03-11 08:00"
        },
        {
            "mzone": "America_Central",
            "from": "2007-03-11 08:00"
        }
    ],
    "America/Rio_Branco": [
        {
            "mzone": "Acre",
            "to": "2008-06-24 05:00"
        },
        {
            "mzone": "Amazon",
            "from": "2008-06-24 05:00",
            "to": "2013-11-10 04:00"
        },
        {
            "mzone": "Acre",
            "from": "2013-11-10 04:00"
        }
    ],
    "America/Santa_Isabel": [
        {
            "mzone": "Mexico_Northwest"
        }
    ],
    "America/Santarem": [
        {
            "mzone": "Amazon",
            "to": "2008-06-24 04:00"
        },
        {
            "mzone": "Brasilia",
            "from": "2008-06-24 04:00"
        }
    ],
    "America/Santiago": [
        {
            "mzone": "Chile"
        }
    ],
    "America/Santo_Domingo": [
        {
            "mzone": "Dominican",
            "to": "1974-10-27 05:00"
        },
        {
            "mzone": "Atlantic",
            "from": "1974-10-27 05:00",
            "to": "2000-10-29 06:00"
        },
        {
            "mzone": "America_Eastern",
            "from": "2000-10-29 06:00",
            "to": "2000-12-03 06:00"
        },
        {
            "mzone": "Atlantic",
            "from": "2000-12-03 06:00"
        }
    ],
    "America/Sao_Paulo": [
        {
            "mzone": "Brasilia"
        }
    ],
    "America/Scoresbysund": [
        {
            "mzone": "Greenland_Central",
            "to": "1981-03-29 02:00"
        },
        {
            "mzone": "Greenland_Eastern",
            "from": "1981-03-29 02:00"
        }
    ],
    "America/Sitka": [
        {
            "mzone": "America_Pacific",
            "to": "1983-10-30 09:00"
        },
        {
            "mzone": "Yukon",
            "from": "1983-10-30 09:00",
            "to": "1983-11-30 09:00"
        },
        {
            "mzone": "Alaska",
            "from": "1983-11-30 09:00"
        }
    ],
    "America/St_Barthelemy": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/St_Johns": [
        {
            "mzone": "Newfoundland"
        }
    ],
    "America/St_Kitts": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/St_Lucia": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/St_Thomas": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/St_Vincent": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Swift_Current": [
        {
            "mzone": "America_Mountain",
            "to": "1972-04-30 09:00"
        },
        {
            "mzone": "America_Central",
            "from": "1972-04-30 09:00"
        }
    ],
    "America/Tegucigalpa": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Thule": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Thunder_Bay": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Tijuana": [
        {
            "mzone": "America_Pacific"
        }
    ],
    "America/Toronto": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "America/Tortola": [
        {
            "mzone": "Atlantic"
        }
    ],
    "America/Vancouver": [
        {
            "mzone": "America_Pacific"
        }
    ],
    "America/Whitehorse": [
        {
            "mzone": "America_Pacific"
        }
    ],
    "America/Winnipeg": [
        {
            "mzone": "America_Central"
        }
    ],
    "America/Yakutat": [
        {
            "mzone": "Yukon",
            "to": "1983-11-30 09:00"
        },
        {
            "mzone": "Alaska",
            "from": "1983-11-30 09:00"
        }
    ],
    "America/Yellowknife": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "Antarctica/Casey": [
        {
            "mzone": "Australia_Western",
            "to": "2009-10-17 18:00"
        },
        {
            "mzone": "Casey",
            "from": "2009-10-17 18:00",
            "to": "2010-03-04 15:00"
        },
        {
            "mzone": "Australia_Western",
            "from": "2010-03-04 15:00",
            "to": "2011-10-27 18:00"
        },
        {
            "mzone": "Casey",
            "from": "2011-10-27 18:00",
            "to": "2012-02-21 17:00"
        },
        {
            "mzone": "Australia_Western",
            "from": "2012-02-21 17:00"
        }
    ],
    "Antarctica/Davis": [
        {
            "mzone": "Davis"
        }
    ],
    "Antarctica/DumontDUrville": [
        {
            "mzone": "DumontDUrville"
        }
    ],
    "Antarctica/Macquarie": [
        {
            "mzone": "Australia_Eastern",
            "to": "2010-04-03 16:00"
        },
        {
            "mzone": "Macquarie",
            "from": "2010-04-03 16:00"
        }
    ],
    "Antarctica/Mawson": [
        {
            "mzone": "Mawson"
        }
    ],
    "Antarctica/McMurdo": [
        {
            "mzone": "New_Zealand"
        }
    ],
    "Antarctica/Palmer": [
        {
            "mzone": "Argentina",
            "to": "1982-05-01 03:00"
        },
        {
            "mzone": "Chile",
            "from": "1982-05-01 03:00"
        }
    ],
    "Antarctica/Rothera": [
        {
            "mzone": "Rothera"
        }
    ],
    "Antarctica/Syowa": [
        {
            "mzone": "Syowa"
        }
    ],
    "Antarctica/Troll": [
        {
            "mzone": "GMT"
        }
    ],
    "Antarctica/Vostok": [
        {
            "mzone": "Vostok"
        }
    ],
    "Arctic/Longyearbyen": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Asia/Aden": [
        {
            "mzone": "Arabian"
        }
    ],
    "Asia/Almaty": [
        {
            "mzone": "Almaty",
            "to": "2004-10-30 20:00"
        },
        {
            "mzone": "Kazakhstan_Eastern",
            "from": "2004-10-30 20:00"
        }
    ],
    "Asia/Amman": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Asia/Anadyr": [
        {
            "mzone": "Anadyr",
            "to": "2010-03-27 14:00"
        },
        {
            "mzone": "Magadan",
            "from": "2010-03-27 14:00",
            "to": "2014-10-25 14:00"
        },
        {
            "mzone": "Anadyr",
            "from": "2014-10-25 14:00"
        }
    ],
    "Asia/Aqtau": [
        {
            "mzone": "Shevchenko",
            "to": "1991-12-15 19:00"
        },
        {
            "mzone": "Aqtau",
            "from": "1991-12-15 19:00",
            "to": "2004-10-30 22:00"
        },
        {
            "mzone": "Kazakhstan_Western",
            "from": "2004-10-30 22:00"
        }
    ],
    "Asia/Aqtobe": [
        {
            "mzone": "Aktyubinsk",
            "to": "1991-12-15 19:00"
        },
        {
            "mzone": "Aqtobe",
            "from": "1991-12-15 19:00",
            "to": "2004-10-30 21:00"
        },
        {
            "mzone": "Kazakhstan_Western",
            "from": "2005-10-30 21:00"
        }
    ],
    "Asia/Ashgabat": [
        {
            "mzone": "Ashkhabad",
            "to": "1991-10-26 20:00"
        },
        {
            "mzone": "Turkmenistan",
            "from": "1991-10-26 20:00"
        }
    ],
    "Asia/Baghdad": [
        {
            "mzone": "Arabian"
        }
    ],
    "Asia/Bahrain": [
        {
            "mzone": "Gulf",
            "to": "1972-05-31 20:00"
        },
        {
            "mzone": "Arabian",
            "from": "1972-05-31 20:00"
        }
    ],
    "Asia/Baku": [
        {
            "mzone": "Baku",
            "to": "1991-08-29 20:00"
        },
        {
            "mzone": "Azerbaijan",
            "from": "1991-08-29 20:00"
        }
    ],
    "Asia/Bangkok": [
        {
            "mzone": "Indochina"
        }
    ],
    "Asia/Beirut": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Asia/Bishkek": [
        {
            "mzone": "Frunze",
            "to": "1991-08-30 20:00"
        },
        {
            "mzone": "Kyrgystan",
            "from": "1991-08-30 20:00"
        }
    ],
    "Asia/Brunei": [
        {
            "mzone": "Brunei"
        }
    ],
    "Asia/Calcutta": [
        {
            "mzone": "India"
        }
    ],
    "Asia/Chita": [
        {
            "mzone": "Yakutsk",
            "to": "2014-10-25 16:00"
        },
        {
            "mzone": "Irkutsk",
            "from": "2014-10-25 16:00",
            "to": "2016-03-26 18:00"
        },
        {
            "mzone": "Yakutsk",
            "from": "2016-03-26 18:00"
        }
    ],
    "Asia/Choibalsan": [
        {
            "mzone": "Mongolia",
            "to": "1983-03-31 16:00"
        },
        {
            "mzone": "Choibalsan",
            "from": "1983-03-31 16:00"
        }
    ],
    "Asia/Colombo": [
        {
            "mzone": "India",
            "to": "1996-05-24 18:30"
        },
        {
            "mzone": "Lanka",
            "from": "1996-05-24 18:30",
            "to": "2006-04-14 18:30"
        },
        {
            "mzone": "India",
            "from": "2006-04-14 18:30"
        }
    ],
    "Asia/Damascus": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Asia/Dhaka": [
        {
            "mzone": "Dacca",
            "to": "1971-03-25 18:00"
        },
        {
            "mzone": "Bangladesh",
            "from": "1971-03-25 18:00"
        }
    ],
    "Asia/Dili": [
        {
            "mzone": "East_Timor",
            "to": "1976-05-02 15:00"
        },
        {
            "mzone": "Indonesia_Central",
            "from": "1976-05-02 15:00",
            "to": "2000-09-16 16:00"
        },
        {
            "mzone": "East_Timor",
            "from": "2000-09-16 16:00"
        }
    ],
    "Asia/Dubai": [
        {
            "mzone": "Gulf"
        }
    ],
    "Asia/Dushanbe": [
        {
            "mzone": "Dushanbe",
            "to": "1991-09-08 21:00"
        },
        {
            "mzone": "Tajikistan",
            "from": "1991-09-08 21:00"
        }
    ],
    "Asia/Gaza": [
        {
            "mzone": "Israel",
            "to": "1995-12-31 22:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1995-12-31 22:00"
        }
    ],
    "Asia/Hebron": [
        {
            "mzone": "Israel",
            "to": "1995-12-31 22:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1995-12-31 22:00"
        }
    ],
    "Asia/Hong_Kong": [
        {
            "mzone": "Hong_Kong"
        }
    ],
    "Asia/Hovd": [
        {
            "mzone": "Hovd"
        }
    ],
    "Asia/Irkutsk": [
        {
            "mzone": "Irkutsk"
        }
    ],
    "Asia/Jakarta": [
        {
            "mzone": "Indonesia_Western"
        }
    ],
    "Asia/Jayapura": [
        {
            "mzone": "Indonesia_Eastern"
        }
    ],
    "Asia/Jerusalem": [
        {
            "mzone": "Israel"
        }
    ],
    "Asia/Kabul": [
        {
            "mzone": "Afghanistan"
        }
    ],
    "Asia/Kamchatka": [
        {
            "mzone": "Kamchatka"
        }
    ],
    "Asia/Karachi": [
        {
            "mzone": "Karachi",
            "to": "1971-03-25 19:00"
        },
        {
            "mzone": "Pakistan",
            "from": "1971-03-25 19:00"
        }
    ],
    "Asia/Katmandu": [
        {
            "mzone": "Nepal"
        }
    ],
    "Asia/Khandyga": [
        {
            "mzone": "Yakutsk",
            "to": "2003-12-31 15:00"
        },
        {
            "mzone": "Vladivostok",
            "from": "2003-12-31 15:00",
            "to": "2011-09-12 13:00"
        },
        {
            "mzone": "Yakutsk",
            "from": "2011-09-12 13:00"
        }
    ],
    "Asia/Krasnoyarsk": [
        {
            "mzone": "Krasnoyarsk"
        }
    ],
    "Asia/Kuala_Lumpur": [
        {
            "mzone": "Malaya",
            "to": "1981-12-31 16:30"
        },
        {
            "mzone": "Malaysia",
            "from": "1981-12-31 16:30"
        }
    ],
    "Asia/Kuching": [
        {
            "mzone": "Borneo",
            "to": "1981-12-31 16:00"
        },
        {
            "mzone": "Malaysia",
            "from": "1981-12-31 16:00"
        }
    ],
    "Asia/Kuwait": [
        {
            "mzone": "Arabian"
        }
    ],
    "Asia/Macau": [
        {
            "mzone": "Macau",
            "to": "1999-12-19 16:00"
        },
        {
            "mzone": "China",
            "from": "1999-12-19 16:00"
        }
    ],
    "Asia/Magadan": [
        {
            "mzone": "Magadan"
        }
    ],
    "Asia/Makassar": [
        {
            "mzone": "Indonesia_Central"
        }
    ],
    "Asia/Manila": [
        {
            "mzone": "Philippines"
        }
    ],
    "Asia/Muscat": [
        {
            "mzone": "Gulf"
        }
    ],
    "Asia/Nicosia": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Asia/Novokuznetsk": [
        {
            "mzone": "Krasnoyarsk",
            "to": "2010-03-27 19:00"
        },
        {
            "mzone": "Novosibirsk",
            "from": "2010-03-27 19:00",
            "to": "2014-10-25 19:00"
        },
        {
            "mzone": "Krasnoyarsk",
            "from": "2014-10-25 19:00"
        }
    ],
    "Asia/Novosibirsk": [
        {
            "mzone": "Novosibirsk"
        }
    ],
    "Asia/Omsk": [
        {
            "mzone": "Omsk"
        }
    ],
    "Asia/Oral": [
        {
            "mzone": "Uralsk",
            "to": "1991-12-15 20:00"
        },
        {
            "mzone": "Oral",
            "from": "1991-12-15 20:00",
            "to": "2004-10-30 22:00"
        },
        {
            "mzone": "Kazakhstan_Western",
            "from": "2004-10-30 22:00"
        }
    ],
    "Asia/Phnom_Penh": [
        {
            "mzone": "Indochina"
        }
    ],
    "Asia/Pontianak": [
        {
            "mzone": "Indonesia_Central",
            "to": "1987-12-31 16:00"
        },
        {
            "mzone": "Indonesia_Western",
            "from": "1987-12-31 16:00"
        }
    ],
    "Asia/Pyongyang": [
        {
            "mzone": "Korea",
            "to": "2015-08-14 15:00"
        },
        {
            "mzone": "Pyongyang",
            "from": "2015-08-14 15:00"
        }
    ],
    "Asia/Qatar": [
        {
            "mzone": "Gulf",
            "to": "1972-05-31 20:00"
        },
        {
            "mzone": "Arabian",
            "from": "1972-05-31 20:00"
        }
    ],
    "Asia/Qyzylorda": [
        {
            "mzone": "Kizilorda",
            "to": "1991-12-15 19:00"
        },
        {
            "mzone": "Qyzylorda",
            "from": "1991-12-15 19:00",
            "to": "2004-10-30 21:00"
        },
        {
            "mzone": "Kazakhstan_Eastern",
            "from": "2004-10-30 21:00"
        }
    ],
    "Asia/Rangoon": [
        {
            "mzone": "Myanmar"
        }
    ],
    "Asia/Riyadh": [
        {
            "mzone": "Arabian"
        }
    ],
    "Asia/Saigon": [
        {
            "mzone": "Indochina",
            "from": "1975-06-12 16:00"
        }
    ],
    "Asia/Sakhalin": [
        {
            "mzone": "Sakhalin"
        }
    ],
    "Asia/Samarkand": [
        {
            "mzone": "Samarkand",
            "to": "1981-09-30 18:00"
        },
        {
            "mzone": "Tashkent",
            "from": "1981-09-30 18:00",
            "to": "1982-03-31 18:00"
        },
        {
            "mzone": "Samarkand",
            "from": "1982-03-31 18:00",
            "to": "1991-08-31 18:00"
        },
        {
            "mzone": "Uzbekistan",
            "from": "1991-08-31 18:00"
        }
    ],
    "Asia/Seoul": [
        {
            "mzone": "Korea"
        }
    ],
    "Asia/Shanghai": [
        {
            "mzone": "China"
        }
    ],
    "Asia/Singapore": [
        {
            "mzone": "Singapore"
        }
    ],
    "Asia/Srednekolymsk": [
        {
            "mzone": "Magadan",
            "to": "2014-10-25 14:00"
        }
    ],
    "Asia/Taipei": [
        {
            "mzone": "Taipei"
        }
    ],
    "Asia/Tashkent": [
        {
            "mzone": "Tashkent",
            "to": "1991-08-31 18:00"
        },
        {
            "mzone": "Uzbekistan",
            "from": "1991-08-31 18:00"
        }
    ],
    "Asia/Tbilisi": [
        {
            "mzone": "Tbilisi",
            "to": "1991-04-08 20:00"
        },
        {
            "mzone": "Georgia",
            "from": "1991-04-08 20:00"
        }
    ],
    "Asia/Tehran": [
        {
            "mzone": "Iran"
        }
    ],
    "Asia/Thimphu": [
        {
            "mzone": "India",
            "to": "1987-09-30 18:30"
        },
        {
            "mzone": "Bhutan",
            "from": "1987-09-30 18:30"
        }
    ],
    "Asia/Tokyo": [
        {
            "mzone": "Japan"
        }
    ],
    "Asia/Ulaanbaatar": [
        {
            "mzone": "Mongolia"
        }
    ],
    "Asia/Urumqi": [
        {
            "mzone": "Urumqi"
        }
    ],
    "Asia/Ust-Nera": [
        {
            "mzone": "Yakutsk",
            "to": "1981-03-31 15:00"
        },
        {
            "mzone": "Magadan",
            "from": "1981-03-31 15:00",
            "to": "2011-09-12 12:00"
        },
        {
            "mzone": "Vladivostok",
            "from": "2011-09-12 12:00"
        }
    ],
    "Asia/Vientiane": [
        {
            "mzone": "Indochina"
        }
    ],
    "Asia/Vladivostok": [
        {
            "mzone": "Vladivostok"
        }
    ],
    "Asia/Yakutsk": [
        {
            "mzone": "Yakutsk"
        }
    ],
    "Asia/Yekaterinburg": [
        {
            "mzone": "Sverdlovsk",
            "to": "1992-01-18 22:00"
        },
        {
            "mzone": "Yekaterinburg",
            "from": "1992-01-18 22:00"
        }
    ],
    "Asia/Yerevan": [
        {
            "mzone": "Yerevan",
            "to": "1991-09-22 20:00"
        },
        {
            "mzone": "Armenia",
            "from": "1991-09-22 20:00"
        }
    ],
    "Atlantic/Azores": [
        {
            "mzone": "Azores",
            "to": "1992-09-27 02:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1992-09-27 02:00",
            "to": "1993-03-28 01:00"
        },
        {
            "mzone": "Azores",
            "from": "1993-03-28 01:00"
        }
    ],
    "Atlantic/Bermuda": [
        {
            "mzone": "Atlantic"
        }
    ],
    "Atlantic/Canary": [
        {
            "mzone": "Europe_Western"
        }
    ],
    "Atlantic/Cape_Verde": [
        {
            "mzone": "Cape_Verde"
        }
    ],
    "Atlantic/Faeroe": [
        {
            "mzone": "Europe_Western"
        }
    ],
    "Atlantic/Madeira": [
        {
            "mzone": "Europe_Western"
        }
    ],
    "Atlantic/Reykjavik": [
        {
            "mzone": "GMT"
        }
    ],
    "Atlantic/South_Georgia": [
        {
            "mzone": "South_Georgia"
        }
    ],
    "Atlantic/St_Helena": [
        {
            "mzone": "GMT"
        }
    ],
    "Atlantic/Stanley": [
        {
            "mzone": "Falkland"
        }
    ],
    "Australia/Adelaide": [
        {
            "mzone": "Australia_Central"
        }
    ],
    "Australia/Brisbane": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "Australia/Broken_Hill": [
        {
            "mzone": "Australia_Central"
        }
    ],
    "Australia/Currie": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "Australia/Darwin": [
        {
            "mzone": "Australia_Central"
        }
    ],
    "Australia/Eucla": [
        {
            "mzone": "Australia_CentralWestern"
        }
    ],
    "Australia/Hobart": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "Australia/Lindeman": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "Australia/Lord_Howe": [
        {
            "mzone": "Australia_Eastern",
            "to": "1981-02-28 14:00"
        },
        {
            "mzone": "Lord_Howe",
            "from": "1981-02-28 14:00"
        }
    ],
    "Australia/Melbourne": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "Australia/Perth": [
        {
            "mzone": "Australia_Western"
        }
    ],
    "Australia/Sydney": [
        {
            "mzone": "Australia_Eastern"
        }
    ],
    "CST6CDT": [
        {
            "mzone": "America_Central"
        }
    ],
    "EST5EDT": [
        {
            "mzone": "America_Eastern"
        }
    ],
    "Europe/Amsterdam": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Andorra": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Astrakhan": [
        {
            "mzone": "Moscow",
            "from": "1992-03-28 22:00",
            "to": "2016-03-26 23:00"
        }
    ],
    "Europe/Athens": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Europe/Belgrade": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Berlin": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Bratislava": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Brussels": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Bucharest": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Europe/Budapest": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Busingen": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Chisinau": [
        {
            "mzone": "Moscow",
            "to": "1990-05-05 21:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1990-05-05 21:00"
        }
    ],
    "Europe/Copenhagen": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Dublin": [
        {
            "mzone": "Irish",
            "to": "1971-10-31 02:00"
        },
        {
            "mzone": "GMT",
            "from": "1971-10-31 02:00"
        }
    ],
    "Europe/Gibraltar": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Guernsey": [
        {
            "mzone": "British",
            "to": "1971-10-31 02:00"
        },
        {
            "mzone": "GMT",
            "from": "1971-10-31 02:00"
        }
    ],
    "Europe/Helsinki": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Europe/Isle_of_Man": [
        {
            "mzone": "British",
            "to": "1971-10-31 02:00"
        },
        {
            "mzone": "GMT",
            "from": "1971-10-31 02:00"
        }
    ],
    "Europe/Istanbul": [
        {
            "mzone": "Europe_Eastern",
            "to": "1978-10-14 21:00"
        },
        {
            "mzone": "Turkey",
            "from": "1978-10-14 21:00",
            "to": "1985-04-19 21:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1985-04-19 21:00",
            "to": "2016-09-06 21:00"
        },
        {
            "mzone": "Turkey",
            "from": "2016-09-06 21:00"
        }
    ],
    "Europe/Jersey": [
        {
            "mzone": "British",
            "to": "1971-10-31 02:00"
        },
        {
            "mzone": "GMT",
            "from": "1971-10-31 02:00"
        }
    ],
    "Europe/Kaliningrad": [
        {
            "mzone": "Moscow",
            "to": "1989-03-25 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1989-03-25 23:00",
            "to": "2011-03-27 00:00"
        },
        {
            "mzone": "Europe_Further_Eastern",
            "from": "2011-03-27 00:00",
            "to": "2014-10-25 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "2014-10-25 23:00"
        }
    ],
    "Europe/Kiev": [
        {
            "mzone": "Moscow",
            "to": "1990-06-30 22:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1990-06-30 22:00"
        }
    ],
    "Europe/Lisbon": [
        {
            "mzone": "Europe_Central",
            "to": "1976-09-26 00:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1976-09-26 00:00",
            "to": "1992-09-27 01:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1992-09-27 01:00",
            "to": "1996-03-31 01:00"
        },
        {
            "mzone": "Europe_Western",
            "from": "1996-03-31 01:00"
        }
    ],
    "Europe/Ljubljana": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/London": [
        {
            "mzone": "British",
            "to": "1971-10-31 02:00"
        },
        {
            "mzone": "GMT",
            "from": "1971-10-31 02:00"
        }
    ],
    "Europe/Luxembourg": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Madrid": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Malta": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Mariehamn": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Europe/Minsk": [
        {
            "mzone": "Moscow",
            "to": "1991-03-30 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1991-03-30 23:00",
            "to": "2011-03-27 00:00"
        },
        {
            "mzone": "Europe_Further_Eastern",
            "from": "2011-03-27 00:00",
            "to": "2014-10-26 22:00"
        },
        {
            "mzone": "Moscow",
            "from": "2014-10-26 22:00"
        }
    ],
    "Europe/Monaco": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Moscow": [
        {
            "mzone": "Moscow",
            "to": "1991-03-30 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1991-03-30 23:00",
            "to": "1992-01-19 00:00"
        },
        {
            "mzone": "Moscow",
            "from": "1992-01-19 00:00"
        }
    ],
    "Europe/Oslo": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Paris": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Podgorica": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Prague": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Riga": [
        {
            "mzone": "Moscow",
            "to": "1989-03-25 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1989-03-25 23:00"
        }
    ],
    "Europe/Rome": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Samara": [
        {
            "mzone": "Kuybyshev",
            "to": "1989-03-25 22:00"
        },
        {
            "mzone": "Moscow",
            "from": "1989-03-25 22:00",
            "to": "1991-03-30 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1991-03-30 23:00",
            "to": "1991-09-29 00:00"
        },
        {
            "mzone": "Samara",
            "from": "1991-09-29 00:00"
        }
    ],
    "Europe/San_Marino": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Sarajevo": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Simferopol": [
        {
            "mzone": "Moscow",
            "to": "1990-06-30 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1990-06-30 23:00",
            "to": "1994-04-30 21:00"
        },
        {
            "mzone": "Moscow",
            "from": "1994-04-30 21:00",
            "to": "1997-03-30 01:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1997-03-30 01:00",
            "to": "2014-03-30 00:00"
        },
        {
            "mzone": "Moscow",
            "from": "2014-03-30 00:00"
        }
    ],
    "Europe/Skopje": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Sofia": [
        {
            "mzone": "Europe_Eastern"
        }
    ],
    "Europe/Stockholm": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Tallinn": [
        {
            "mzone": "Moscow",
            "to": "1989-03-25 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1989-03-25 23:00"
        }
    ],
    "Europe/Tirane": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Ulyanovsk": [
        {
            "mzone": "Moscow",
            "from": "1992-01-19 00:00",
            "to": "2016-03-26 23:00"
        }
    ],
    "Europe/Uzhgorod": [
        {
            "mzone": "Moscow",
            "to": "1990-06-30 23:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1990-06-30 23:00",
            "to": "1991-03-31 02:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1991-03-31 02:00"
        }
    ],
    "Europe/Vaduz": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Vatican": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Vienna": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Vilnius": [
        {
            "mzone": "Moscow",
            "to": "1989-03-25 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1989-03-25 23:00",
            "to": "1998-03-29 01:00"
        },
        {
            "mzone": "Europe_Central",
            "from": "1998-03-29 01:00",
            "to": "1999-10-31 01:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1999-10-31 01:00"
        }
    ],
    "Europe/Volgograd": [
        {
            "mzone": "Volgograd",
            "to": "1992-03-28 22:00"
        },
        {
            "mzone": "Moscow",
            "from": "1992-03-28 22:00"
        }
    ],
    "Europe/Warsaw": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Zagreb": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Europe/Zaporozhye": [
        {
            "mzone": "Moscow",
            "to": "1991-03-30 23:00"
        },
        {
            "mzone": "Europe_Eastern",
            "from": "1991-03-30 23:00"
        }
    ],
    "Europe/Zurich": [
        {
            "mzone": "Europe_Central"
        }
    ],
    "Indian/Antananarivo": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Indian/Chagos": [
        {
            "mzone": "Indian_Ocean"
        }
    ],
    "Indian/Christmas": [
        {
            "mzone": "Christmas"
        }
    ],
    "Indian/Cocos": [
        {
            "mzone": "Cocos"
        }
    ],
    "Indian/Comoro": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Indian/Kerguelen": [
        {
            "mzone": "French_Southern"
        }
    ],
    "Indian/Mahe": [
        {
            "mzone": "Seychelles"
        }
    ],
    "Indian/Maldives": [
        {
            "mzone": "Maldives"
        }
    ],
    "Indian/Mauritius": [
        {
            "mzone": "Mauritius"
        }
    ],
    "Indian/Mayotte": [
        {
            "mzone": "Africa_Eastern"
        }
    ],
    "Indian/Reunion": [
        {
            "mzone": "Reunion"
        }
    ],
    "MST7MDT": [
        {
            "mzone": "America_Mountain"
        }
    ],
    "Pacific/Apia": [
        {
            "mzone": "Apia"
        }
    ],
    "Pacific/Auckland": [
        {
            "mzone": "New_Zealand"
        }
    ],
    "Pacific/Bougainville": [
        {
            "mzone": "Papua_New_Guinea",
            "to": "2014-12-27 16:00"
        }
    ],
    "Pacific/Chatham": [
        {
            "mzone": "Chatham"
        }
    ],
    "Pacific/Easter": [
        {
            "mzone": "Easter"
        }
    ],
    "Pacific/Efate": [
        {
            "mzone": "Vanuatu"
        }
    ],
    "Pacific/Enderbury": [
        {
            "mzone": "Phoenix_Islands"
        }
    ],
    "Pacific/Fakaofo": [
        {
            "mzone": "Tokelau"
        }
    ],
    "Pacific/Fiji": [
        {
            "mzone": "Fiji"
        }
    ],
    "Pacific/Funafuti": [
        {
            "mzone": "Tuvalu"
        }
    ],
    "Pacific/Galapagos": [
        {
            "mzone": "Ecuador",
            "to": "1986-01-01 05:00"
        },
        {
            "mzone": "Galapagos",
            "from": "1986-01-01 05:00"
        }
    ],
    "Pacific/Gambier": [
        {
            "mzone": "Gambier"
        }
    ],
    "Pacific/Guadalcanal": [
        {
            "mzone": "Solomon"
        }
    ],
    "Pacific/Guam": [
        {
            "mzone": "Guam",
            "to": "2000-12-22 14:00"
        },
        {
            "mzone": "Chamorro",
            "from": "2000-12-22 14:00"
        }
    ],
    "Pacific/Honolulu": [
        {
            "mzone": "Alaska_Hawaii",
            "to": "1983-10-30 11:00"
        },
        {
            "mzone": "Hawaii_Aleutian",
            "from": "1983-10-30 11:00"
        }
    ],
    "Pacific/Johnston": [
        {
            "mzone": "Alaska_Hawaii",
            "to": "1983-10-30 11:00"
        },
        {
            "mzone": "Hawaii_Aleutian",
            "from": "1983-10-30 11:00"
        }
    ],
    "Pacific/Kiritimati": [
        {
            "mzone": "Line_Islands"
        }
    ],
    "Pacific/Kosrae": [
        {
            "mzone": "Kosrae"
        }
    ],
    "Pacific/Kwajalein": [
        {
            "mzone": "Kwajalein",
            "to": "1993-08-20 12:00"
        },
        {
            "mzone": "Marshall_Islands",
            "from": "1993-08-20 12:00"
        }
    ],
    "Pacific/Majuro": [
        {
            "mzone": "Marshall_Islands"
        }
    ],
    "Pacific/Marquesas": [
        {
            "mzone": "Marquesas"
        }
    ],
    "Pacific/Midway": [
        {
            "mzone": "Bering",
            "to": "1983-10-30 12:00"
        },
        {
            "mzone": "Samoa",
            "from": "1983-10-30 12:00"
        }
    ],
    "Pacific/Nauru": [
        {
            "mzone": "Nauru"
        }
    ],
    "Pacific/Niue": [
        {
            "mzone": "Niue"
        }
    ],
    "Pacific/Norfolk": [
        {
            "mzone": "Norfolk"
        }
    ],
    "Pacific/Noumea": [
        {
            "mzone": "New_Caledonia"
        }
    ],
    "Pacific/Pago_Pago": [
        {
            "mzone": "Bering",
            "to": "1983-10-30 12:00"
        },
        {
            "mzone": "Samoa",
            "from": "1983-10-30 12:00"
        }
    ],
    "Pacific/Palau": [
        {
            "mzone": "Palau"
        }
    ],
    "Pacific/Pitcairn": [
        {
            "mzone": "Pitcairn"
        }
    ],
    "Pacific/Ponape": [
        {
            "mzone": "Ponape"
        }
    ],
    "Pacific/Port_Moresby": [
        {
            "mzone": "Papua_New_Guinea"
        }
    ],
    "Pacific/Rarotonga": [
        {
            "mzone": "Cook"
        }
    ],
    "Pacific/Saipan": [
        {
            "mzone": "North_Mariana",
            "to": "2000-12-22 14:00"
        },
        {
            "mzone": "Chamorro",
            "from": "2000-12-22 14:00"
        }
    ],
    "Pacific/Tahiti": [
        {
            "mzone": "Tahiti"
        }
    ],
    "Pacific/Tarawa": [
        {
            "mzone": "Gilbert_Islands"
        }
    ],
    "Pacific/Tongatapu": [
        {
            "mzone": "Tonga"
        }
    ],
    "Pacific/Truk": [
        {
            "mzone": "Truk"
        }
    ],
    "Pacific/Wake": [
        {
            "mzone": "Wake"
        }
    ],
    "Pacific/Wallis": [
        {
            "mzone": "Wallis"
        }
    ],
    "PST8PDT": [
        {
            "mzone": "America_Pacific"
        }
    ]
});};


/***/ }),
/* 1364 */
/***/ (function(module, exports) {

/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
module.exports = function load(global) {global.Intl && global.Intl._timeZoneData && global.Intl._timeZoneData.load({
    "zoneDefs": [
        "Africa/Abidjan,Africa/Bamako,Africa/Banjul,Africa/Conakry,Africa/Dakar,Africa/Freetown,Africa/Lome,Africa/Nouakchott,Africa/Ouagadougou,Africa/Sao_Tome,Africa/Timbuktu,Atlantic/St_Helena||0,0,0,1,1,0",
        "Africa/Accra||2,2,0,3,1,0,4,3,1,5,1,0,6,3,1,7,1,0,8,3,1,9,1,0,a,3,1,b,1,0,c,3,1,d,1,0,e,3,1,f,1,0,g,3,1,h,1,0,i,3,1,j,1,0,k,3,1,l,1,0,m,3,1,n,1,0,o,3,1,p,1,0,q,3,1,r,1,0,s,3,1,t,1,0,u,3,1,v,1,0,10,3,1,11,1,0,12,3,1,13,1,0,14,3,1,15,1,0,16,3,1,17,1,0,18,3,1,19,1,0,1a,3,1,1b,1,0,1c,3,1,1d,1,0,1e,3,1,1f,1,0,1g,3,1,1,1,0",
        "Africa/Addis_Ababa,Africa/Asmara,Africa/Asmera,Africa/Dar_es_Salaam,Africa/Djibouti,Africa/Kampala,Africa/Mogadishu,Africa/Nairobi,Indian/Antananarivo,Indian/Comoro,Indian/Mayotte||1h,4,0,1i,5,0,1j,6,0,1k,7,0,1,5,0",
        "Africa/Algiers||1l,8,0,1m,1,0,1n,9,1,1o,1,0,1p,9,1,1q,1,0,1r,9,1,1s,1,0,1t,9,1,1u,1,0,1v,9,1,20,1,0,21,9,1,22,1,0,23,9,1,24,1,0,25,9,0,26,a,1,27,9,0,28,a,1,29,9,0,2a,1,0,2b,9,0,2c,1,0,2d,9,1,2e,1,0,2f,9,1,2g,9,0,2h,a,1,2i,9,0,2j,1,0,2k,9,1,2l,1,0,1,9,0",
        "Africa/Bangui,Africa/Brazzaville,Africa/Douala,Africa/Kinshasa,Africa/Lagos,Africa/Libreville,Africa/Luanda,Africa/Malabo,Africa/Niamey,Africa/Porto-Novo||2m,b,0,1,9,0",
        "Africa/Bissau||2n,c,0,2o,d,0,1,1,0",
        "Africa/Blantyre,Africa/Bujumbura,Africa/Gaborone,Africa/Harare,Africa/Kigali,Africa/Lubumbashi,Africa/Lusaka,Africa/Maputo||2p,e,0,1,a,0",
        "Africa/Cairo,Egypt||2q,a,0,2r,5,1,2s,a,0,2t,5,1,2u,a,0,2v,5,1,30,a,0,31,5,1,32,a,0,33,5,1,34,a,0,35,5,1,36,a,0,37,5,1,38,a,0,39,5,1,3a,a,0,3b,5,1,3c,a,0,3d,5,1,3e,a,0,3f,5,1,3g,a,0,3h,5,1,3i,a,0,3j,5,1,3k,a,0,3l,5,1,3m,a,0,3n,5,1,3o,a,0,3p,5,1,3q,a,0,3r,5,1,3s,a,0,3t,5,1,3u,a,0,3v,5,1,40,a,0,41,5,1,42,a,0,43,5,1,44,a,0,45,5,1,46,a,0,47,5,1,48,a,0,49,5,1,4a,a,0,4b,5,1,4c,a,0,4d,5,1,4e,a,0,4f,5,1,4g,a,0,4h,5,1,4i,a,0,4j,5,1,4k,a,0,4l,5,1,4m,a,0,4n,5,1,4o,a,0,4p,5,1,4q,a,0,4r,5,1,4s,a,0,4t,5,1,4u,a,0,4v,5,1,50,a,0,51,5,1,52,a,0,53,5,1,54,a,0,55,5,1,56,a,0,57,5,1,58,a,0,59,5,1,5a,a,0,5b,5,1,5c,a,0,5d,5,1,5e,a,0,5f,5,1,5g,a,0,5h,5,1,5i,a,0,5j,5,1,5k,a,0,5l,5,1,5m,a,0,5n,5,1,5o,a,0,5p,5,1,5q,a,0,5r,5,1,5s,a,0,5t,5,1,5u,a,0,5v,5,1,60,a,0,61,5,1,62,a,0,63,5,1,64,a,0,65,5,1,66,a,0,67,5,1,68,a,0,69,5,1,6a,a,0,6b,5,1,6c,a,0,6d,5,1,6e,a,0,6f,5,1,6g,a,0,6h,5,1,6i,a,0,6j,5,1,6k,a,0,6l,5,1,6m,a,0,6n,5,1,1,a,0",
        "Africa/Casablanca||6o,f,0,6p,1,0,6q,9,1,6r,1,0,6s,9,1,6t,1,0,6u,9,1,6v,1,0,70,9,1,71,1,0,72,9,1,73,1,0,74,9,1,75,1,0,76,9,1,77,1,0,78,9,1,79,1,0,7a,9,0,7b,1,0,7c,9,1,7d,1,0,7e,9,1,7f,1,0,7g,9,1,7h,1,0,7i,9,1,7j,1,0,7k,9,1,7l,1,0,7m,9,1,7n,1,0,7o,9,1,7p,1,0,7q,9,1,7r,1,0,7s,9,1,7t,1,0,7u,9,1,7v,1,0,80,9,1,81,1,0,82,9,1,83,1,0,84,9,1,85,1,0,86,9,1,87,1,0,88,9,1,89,1,0,8a,9,1,8b,1,0,8c,9,1,8d,1,0,8e,9,1,8f,1,0,8g,9,1,8h,1,0,8i,9,1,8j,1,0,8k,9,1,8l,1,0,8m,9,1,8n,1,0,8o,9,1,8p,1,0,8q,9,1,8r,1,0,8s,9,1,8t,1,0,8u,9,1,8v,1,0,90,9,1,91,1,0,92,9,1,93,1,0,94,9,1,95,1,0,96,9,1,97,1,0,98,9,1,99,1,0,9a,9,1,9b,1,0,9c,9,1,9d,1,0,9e,9,1,9f,1,0,9g,9,1,9h,1,0,9i,9,1,9j,1,0,9k,9,1,9l,1,0,9m,9,1,9n,1,0,9o,9,1,9p,1,0,9q,9,1,1,1,0",
        "Africa/Ceuta||9r,1,0,9s,9,1,9t,1,0,9u,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,a4,9,1,6v,1,0,70,9,1,71,1,0,72,9,1,73,1,0,74,9,1,75,1,0,76,9,1,77,1,0,78,9,1,79,1,0,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Africa/El_Aaiun||dd,g,0,de,d,0,73,1,0,74,9,1,75,1,0,76,9,1,77,1,0,78,9,1,7b,1,0,7c,9,1,7d,1,0,7e,9,1,7f,1,0,7g,9,1,7h,1,0,7i,9,1,7j,1,0,7k,9,1,7l,1,0,7m,9,1,7n,1,0,7o,9,1,7p,1,0,7q,9,1,7r,1,0,7s,9,1,7t,1,0,7u,9,1,7v,1,0,80,9,1,81,1,0,82,9,1,83,1,0,84,9,1,85,1,0,86,9,1,87,1,0,88,9,1,89,1,0,8a,9,1,8b,1,0,8c,9,1,8d,1,0,8e,9,1,8f,1,0,8g,9,1,8h,1,0,8i,9,1,8j,1,0,8k,9,1,8l,1,0,8m,9,1,8n,1,0,8o,9,1,8p,1,0,8q,9,1,8r,1,0,8s,9,1,8t,1,0,8u,9,1,8v,1,0,90,9,1,91,1,0,92,9,1,93,1,0,94,9,1,95,1,0,96,9,1,97,1,0,98,9,1,99,1,0,9a,9,1,9b,1,0,9c,9,1,9d,1,0,9e,9,1,9f,1,0,9g,9,1,9h,1,0,9i,9,1,9j,1,0,9k,9,1,9l,1,0,9m,9,1,9n,1,0,9o,9,1,9p,1,0,9q,9,1,1,1,0",
        "Africa/Johannesburg,Africa/Maseru,Africa/Mbabane||df,h,0,dg,a,0,dh,5,1,di,a,0,dj,5,1,1,a,0",
        "Africa/Juba,Africa/Khartoum||dk,e,0,dl,a,0,dm,5,1,dn,a,0,do,5,1,dp,a,0,dq,5,1,dr,a,0,ds,5,1,dt,a,0,du,5,1,dv,a,0,e0,5,1,e1,a,0,e2,5,1,e3,a,0,e4,5,1,e5,a,0,e6,5,1,e7,a,0,e8,5,1,e9,a,0,ea,5,1,eb,a,0,ec,5,1,ed,a,0,ee,5,1,ef,a,0,eg,5,1,eh,a,0,ei,5,1,ej,a,0,ek,5,1,el,a,0,1,5,0",
        "Africa/Monrovia||em,i,0,en,j,0,1,1,0",
        "Africa/Ndjamena||eo,9,0,ep,9,0,eq,a,1,1,9,0",
        "Africa/Tripoli,Libya||er,k,0,es,9,0,et,a,1,eu,9,0,ev,a,1,f0,9,0,f1,a,1,f2,9,0,f3,a,0,f4,9,0,f5,a,1,f6,9,0,f7,a,1,f8,9,0,f9,a,1,fa,9,0,fb,a,1,fc,9,0,fd,a,1,fe,9,0,ff,a,1,fg,9,0,fh,a,1,fi,9,0,fj,a,1,fk,9,0,fl,a,0,fm,9,0,fn,a,1,fo,a,0,fp,9,0,fq,a,1,1,a,0",
        "Africa/Tunis||1l,8,0,fr,9,0,fs,a,1,ft,9,0,fu,a,1,fv,9,0,g0,a,1,g1,9,0,g2,a,1,g3,9,0,g4,a,1,25,9,0,g5,a,1,27,9,0,g6,a,1,g7,9,0,g8,a,1,4g,9,0,g9,a,1,ga,9,0,gb,a,1,gc,9,0,gd,a,1,58,9,0,ge,a,1,gf,9,0,gg,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,1,9,0",
        "Africa/Windhoek||df,h,0,dg,a,0,dh,5,1,gh,a,0,gi,a,0,gj,9,0,gk,a,1,gl,9,0,gm,a,1,gn,9,0,go,a,1,gp,9,0,gq,a,1,gr,9,0,gs,a,1,gt,9,0,gu,a,1,gv,9,0,h0,a,1,h1,9,0,h2,a,1,h3,9,0,h4,a,1,h5,9,0,h6,a,1,h7,9,0,h8,a,1,h9,9,0,ha,a,1,hb,9,0,hc,a,1,hd,9,0,he,a,1,hf,9,0,hg,a,1,hh,9,0,hi,a,1,hj,9,0,7h,a,1,hk,9,0,hl,a,1,hm,9,0,hn,a,1,ho,9,0,hp,a,1,hq,9,0,hr,a,1,hs,9,0,ht,a,1,hu,9,0,hv,a,1,i0,9,0,i1,a,1,i2,9,0,i3,a,1,i4,9,0,i5,a,1,i6,9,0,i7,a,1,i8,9,0,i9,a,1,ia,9,0,ib,a,1,ic,9,0,id,a,1,ie,9,0,if,a,1,ig,9,0,ih,a,1,ii,9,0,ij,a,1,ik,9,0,il,a,1,im,9,0,in,a,1,io,9,0,ip,a,1,iq,9,0,ir,a,1,is,9,0,it,a,1,iu,9,0,iv,a,1,j0,9,0,j1,a,1,j2,9,0,j3,a,1,j4,9,0,j5,a,1,j6,9,0,j7,a,1,j8,9,0,1,a,1",
        "America/Adak,America/Atka,US/Aleutian||j9,l,0,ja,m,1,jb,m,1,jc,l,0,jd,l,0,je,m,1,jf,l,0,jg,m,1,jh,l,0,ji,m,1,jj,l,0,jk,m,1,jl,l,0,jm,m,1,jn,l,0,jo,m,1,jp,l,0,jq,m,1,jr,l,0,js,m,1,jt,l,0,ju,m,1,jv,l,0,k0,m,1,k1,l,0,k2,m,1,k3,l,0,k4,m,1,k5,l,0,k6,m,1,k7,l,0,k8,m,1,k9,l,0,ka,m,1,kb,m,0,kc,m,0,kd,n,1,ke,m,0,kf,n,1,kg,m,0,kh,n,1,ki,m,0,kj,n,1,kk,m,0,kl,n,1,km,m,0,kn,n,1,ko,m,0,kp,n,1,kq,m,0,kr,n,1,ks,m,0,kt,n,1,ku,m,0,kv,n,1,l0,m,0,l1,n,1,l2,m,0,l3,n,1,l4,m,0,l5,n,1,l6,m,0,l7,n,1,l8,m,0,l9,n,1,la,m,0,lb,n,1,lc,m,0,ld,n,1,le,m,0,lf,n,1,lg,m,0,lh,n,1,li,m,0,lj,n,1,lk,m,0,ll,n,1,lm,m,0,ln,n,1,lo,m,0,lp,n,1,lq,m,0,lr,n,1,ls,m,0,lt,n,1,lu,m,0,lv,n,1,m0,m,0,m1,n,1,m2,m,0,m3,n,1,m4,m,0,m5,n,1,m6,m,0,m7,n,1,m8,m,0,m9,n,1,ma,m,0,mb,n,1,mc,m,0,md,n,1,me,m,0,mf,n,1,mg,m,0,mh,n,1,mi,m,0,mj,n,1,mk,m,0,ml,n,1,mm,m,0,mn,n,1,mo,m,0,mp,n,1,mq,m,0,mr,n,1,ms,m,0,mt,n,1,mu,m,0,mv,n,1,n0,m,0,n1,n,1,n2,m,0,n3,n,1,n4,m,0,n5,n,1,n6,m,0,n7,n,1,n8,m,0,n9,n,1,na,m,0,nb,n,1,nc,m,0,nd,n,1,ne,m,0,nf,n,1,ng,m,0,nh,n,1,ni,m,0,nj,n,1,nk,m,0,nl,n,1,nm,m,0,nn,n,1,1,m,0",
        "America/Anchorage,US/Alaska||no,m,0,ja,n,1,np,n,1,nq,m,0,nr,m,0,ns,n,1,nt,m,0,nu,n,1,nv,m,0,o0,n,1,o1,m,0,o2,n,1,o3,m,0,o4,n,1,o5,m,0,o6,n,1,o7,m,0,o8,n,1,o9,m,0,oa,n,1,ob,m,0,oc,n,1,od,m,0,oe,n,1,of,m,0,og,n,1,oh,m,0,oi,n,1,oj,m,0,ok,n,1,ol,m,0,om,n,1,on,m,0,oo,n,1,op,n,0,oq,n,0,or,o,1,os,n,0,ot,o,1,ou,n,0,ov,o,1,p0,n,0,p1,o,1,p2,n,0,p3,o,1,p4,n,0,p5,o,1,p6,n,0,p7,o,1,p8,n,0,p9,o,1,pa,n,0,pb,o,1,pc,n,0,pd,o,1,pe,n,0,pf,o,1,pg,n,0,ph,o,1,pi,n,0,pj,o,1,pk,n,0,pl,o,1,pm,n,0,pn,o,1,po,n,0,pp,o,1,pq,n,0,pr,o,1,ps,n,0,pt,o,1,pu,n,0,pv,o,1,q0,n,0,q1,o,1,q2,n,0,q3,o,1,q4,n,0,q5,o,1,q6,n,0,q7,o,1,q8,n,0,q9,o,1,qa,n,0,qb,o,1,qc,n,0,qd,o,1,qe,n,0,qf,o,1,qg,n,0,qh,o,1,qi,n,0,qj,o,1,qk,n,0,ql,o,1,qm,n,0,qn,o,1,qo,n,0,qp,o,1,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/Anguilla,America/Antigua,America/Dominica,America/Grenada,America/Guadeloupe,America/Marigot,America/Montserrat,America/Port_of_Spain,America/St_Barthelemy,America/St_Kitts,America/St_Lucia,America/St_Thomas,America/St_Vincent,America/Tortola,America/Virgin||s6,p,0,1,q,0",
        "America/Araguaina||s7,r,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,t8,s,0,t9,t,1,ta,s,0,tb,t,1,tc,s,0,td,t,1,te,s,0,tf,t,1,tg,s,0,th,t,1,ti,s,0,tj,t,1,tk,s,0,tl,t,1,tm,s,0,tn,t,1,to,s,0,tp,t,1,1,s,0",
        "America/Argentina/Buenos_Aires,America/Buenos_Aires||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vb,s,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vg,s,0,vh,t,1,vi,s,0,vj,t,1,1,s,0",
        "America/Argentina/Catamarca,America/Argentina/ComodRivadavia,America/Catamarca||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vk,q,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vl,s,0,vm,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/Cordoba,America/Cordoba,America/Rosario||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vk,q,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vg,s,0,vh,t,1,vi,s,0,vj,t,1,1,s,0",
        "America/Argentina/Jujuy,America/Jujuy||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,vn,q,0,vo,s,1,vp,q,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/La_Rioja||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,vq,t,1,vr,q,0,vb,s,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vl,s,0,vm,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/Mendoza,America/Mendoza||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,vs,q,0,vt,s,1,vu,q,0,vv,s,1,100,q,0,ve,t,1,tg,s,0,vf,s,1,101,s,0,102,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/Rio_Gallegos||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vb,s,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vl,s,0,vm,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/Salta||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vk,q,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/San_Juan||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,vq,t,1,vr,q,0,vb,s,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,103,s,0,104,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Argentina/San_Luis||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,105,t,1,vs,q,0,vt,s,1,106,q,0,tg,s,0,vf,s,1,103,s,0,104,q,0,vg,s,0,107,t,1,108,s,1,109,q,0,10a,s,1,10b,q,0,1,s,0",
        "America/Argentina/Tucuman||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vk,q,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,vl,s,0,10c,q,0,vg,s,0,vh,t,1,vi,s,0,vj,t,1,1,s,0",
        "America/Argentina/Ushuaia||tq,u,0,tr,q,0,ts,s,1,tt,q,0,tu,s,1,tv,q,0,u0,s,1,u1,q,0,u2,s,1,u3,q,0,u4,s,1,u5,q,0,u6,s,1,u7,q,0,u8,s,1,u9,q,0,ua,s,1,ub,q,0,uc,s,1,ud,q,0,ue,s,1,uf,q,0,ug,s,1,uh,q,0,ui,s,1,uj,q,0,uk,s,1,ul,q,0,um,s,1,un,q,0,uo,s,1,up,q,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,v6,s,0,v7,t,1,t6,s,0,v8,t,1,v9,s,0,va,t,1,vb,s,0,vc,t,1,vd,s,0,ve,t,1,tg,s,0,vf,s,1,10d,s,0,vm,q,0,vg,s,0,vh,t,1,1,s,0",
        "America/Aruba,America/Curacao,America/Kralendijk,America/Lower_Princes||10e,v,0,10f,10,0,1,q,0",
        "America/Asuncion||10g,11,0,10h,q,0,10i,s,0,10j,q,0,10k,s,1,10l,q,0,10m,s,1,10n,q,0,10o,s,1,10p,q,0,10q,s,1,10r,q,0,10s,s,1,10t,q,0,10u,s,1,10v,q,0,110,s,1,111,q,0,112,s,1,113,q,0,114,s,1,115,q,0,116,s,1,117,q,0,118,s,1,119,q,0,11a,s,1,11b,q,0,11c,s,1,11d,q,0,11e,s,1,11f,q,0,11g,s,1,11h,q,0,11i,s,1,vp,q,0,vv,s,1,11j,q,0,11k,s,1,11l,q,0,11m,s,1,11n,q,0,11o,s,1,11p,q,0,11q,s,1,11r,q,0,11s,s,1,11t,q,0,11u,s,1,11v,q,0,120,s,1,121,q,0,122,s,1,123,q,0,124,s,1,125,q,0,126,s,1,127,q,0,128,s,1,129,q,0,12a,s,1,12b,q,0,12c,s,1,12d,q,0,12e,s,1,12f,q,0,12g,s,1,12h,q,0,108,s,1,12i,q,0,10a,s,1,12j,q,0,12k,s,1,12l,q,0,12m,s,1,12n,q,0,12o,s,1,12p,q,0,12q,s,1,12r,q,0,12s,s,1,12t,q,0,12u,s,1,12v,q,0,130,s,1,131,q,0,132,s,1,133,q,0,134,s,1,135,q,0,136,s,1,137,q,0,138,s,1,139,q,0,13a,s,1,13b,q,0,13c,s,1,13d,q,0,13e,s,1,13f,q,0,13g,s,1,13h,q,0,13i,s,1,13j,q,0,13k,s,1,13l,q,0,13m,s,1,13n,q,0,13o,s,1,13p,q,0,13q,s,1,13r,q,0,13s,s,1,13t,q,0,13u,s,1,13v,q,0,140,s,1,141,q,0,142,s,1,143,q,0,144,s,1,145,q,0,146,s,1,147,q,0,148,s,1,149,q,0,14a,s,1,14b,q,0,1,s,1",
        "America/Atikokan,America/Coral_Harbour||14c,12,0,14d,13,1,14e,12,0,14f,13,1,ja,13,1,14g,13,1,1,13,0",
        "America/Bahia||14h,14,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,v9,s,0,14i,t,1,vb,s,0,14j,t,1,14k,s,0,14l,t,1,14m,s,0,14n,t,1,14o,s,0,14p,t,1,t8,s,0,t9,t,1,ta,s,0,tb,t,1,tc,s,0,td,t,1,te,s,0,tf,t,1,tg,s,0,th,t,1,ti,s,0,tj,t,1,tk,s,0,tl,t,1,tm,s,0,tn,t,1,14q,s,0,14r,t,1,1,s,0",
        "America/Bahia_Banderas||14s,15,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,152,12,0,153,16,0,154,o,0,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,15f,16,0,15g,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,15r,16,0,15s,12,1,15t,16,0,15u,12,1,15v,16,0,160,12,1,161,16,0,162,13,1,163,12,0,164,13,1,165,12,0,166,13,1,167,12,0,168,13,1,169,12,0,16a,13,1,16b,12,0,16c,13,1,16d,12,0,16e,13,1,16f,12,0,16g,13,1,16h,12,0,16i,13,1,16j,12,0,16k,13,1,16l,12,0,16m,13,1,16n,12,0,16o,13,1,16p,12,0,16q,13,1,16r,12,0,16s,13,1,16t,12,0,16u,13,1,16v,12,0,170,13,1,171,12,0,172,13,1,173,12,0,174,13,1,175,12,0,176,13,1,177,12,0,178,13,1,179,12,0,17a,13,1,17b,12,0,17c,13,1,17d,12,0,17e,13,1,17f,12,0,17g,13,1,17h,12,0,17i,13,1,17j,12,0,17k,13,1,17l,12,0,17m,13,1,17n,12,0,17o,13,1,1,12,0",
        "America/Barbados||17p,17,0,17q,17,0,17r,q,0,17s,s,1,17t,q,0,17u,s,1,17v,q,0,180,s,1,181,q,0,182,s,1,1,q,0",
        "America/Belem||183,18,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,1,s,0",
        "America/Belize||184,19,0,185,12,0,186,1a,1,187,12,0,188,1a,1,189,12,0,18a,1a,1,18b,12,0,18c,1a,1,18d,12,0,18e,1a,1,18f,12,0,18g,1a,1,18h,12,0,18i,1a,1,18j,12,0,18k,1a,1,18l,12,0,18m,1a,1,18n,12,0,18o,1a,1,18p,12,0,18q,1a,1,18r,12,0,18s,1a,1,18t,12,0,18u,1a,1,18v,12,0,190,1a,1,191,12,0,192,1a,1,193,12,0,194,1a,1,195,12,0,196,1a,1,197,12,0,198,1a,1,199,12,0,19a,1a,1,19b,12,0,19c,1a,1,19d,12,0,19e,1a,1,19f,12,0,19g,1a,1,19h,12,0,19i,1a,1,19j,12,0,19k,1a,1,19l,12,0,19m,1a,1,19n,12,0,19o,13,1,19p,12,0,19q,13,1,1,12,0",
        "America/Blanc-Sablon||19r,q,0,19s,s,1,19t,q,0,ja,s,1,19u,s,1,1,q,0",
        "America/Boa_Vista||19v,1b,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,121,q,0,1aq,s,1,1ar,q,0,1as,s,1,1,q,0",
        "America/Bogota||1at,1c,0,1au,13,0,1av,q,1,1,13,0",
        "America/Boise||1b0,o,0,1b1,16,1,1b2,o,0,1b3,16,1,1b4,o,0,1b5,16,0,ja,12,1,1b6,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,1bl,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Cambridge_Bay||1f1,1,0,1b5,16,0,ja,12,1,1b6,12,1,1f2,16,0,1f3,13,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,1f4,12,0,1f5,13,1,1f6,13,0,1d1,12,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Campo_Grande||1f7,1d,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,1f8,q,0,1f9,s,1,1fa,q,0,1fb,s,1,1fc,q,0,1fd,s,1,vk,q,0,1fe,s,1,1ff,q,0,1fg,s,1,1fh,q,0,1fi,s,1,1fj,q,0,1fk,s,1,1fl,q,0,1fm,s,1,11r,q,0,1fn,s,1,1fo,q,0,11u,s,1,1fp,q,0,1fq,s,1,121,q,0,1aq,s,1,1ar,q,0,1fr,s,1,1fs,q,0,1ft,s,1,1fu,q,0,1fv,s,1,1g0,q,0,1g1,s,1,1g2,q,0,1g3,s,1,12d,q,0,1g4,s,1,1g5,q,0,1g6,s,1,1g7,q,0,1g8,s,1,12i,q,0,1g9,s,1,12j,q,0,1ga,s,1,1gb,q,0,1gc,s,1,1gd,q,0,1ge,s,1,1gf,q,0,1gg,s,1,1gh,q,0,1gi,s,1,1gj,q,0,1gk,s,1,1gl,q,0,1gm,s,1,1gn,q,0,1go,s,1,1gp,q,0,1gq,s,1,1gr,q,0,1gs,s,1,1gt,q,0,1gu,s,1,1gv,q,0,1h0,s,1,1h1,q,0,1h2,s,1,1h3,q,0,1h4,s,1,1h5,q,0,1h6,s,1,1h7,q,0,1h8,s,1,1h9,q,0,1ha,s,1,1hb,q,0,1hc,s,1,1hd,q,0,1he,s,1,1hf,q,0,1hg,s,1,1hh,q,0,1hi,s,1,1hj,q,0,1hk,s,1,1hl,q,0,1hm,s,1,1hn,q,0,1ho,s,1,1hp,q,0,1hq,s,1,1hr,q,0,1hs,s,1,1ht,q,0,1hu,s,1,1hv,q,0,1i0,s,1,1i1,q,0,1,s,1",
        "America/Cancun||1i2,1e,0,1i3,12,0,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,1i9,q,1,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1id,12,0,1ie,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1ip,12,0,1iq,13,1,1ir,12,0,1is,13,1,1it,12,0,1iu,13,1,1iv,12,0,162,13,1,163,12,0,164,13,1,165,12,0,166,13,1,167,12,0,168,13,1,169,12,0,16a,13,1,1j0,12,0,1,13,0",
        "America/Caracas||1j1,1f,0,10f,10,0,1j2,q,0,1j3,10,0,1,q,0",
        "America/Cayenne||1j4,1g,0,uv,q,0,1,s,0",
        "America/Cayman,America/Panama||1j5,1h,0,1,13,0",
        "America/Chicago,US/Central||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,1j9,12,0,1ja,13,1,1jb,12,0,1jc,13,1,1jd,12,0,1je,13,1,1jf,12,0,1jg,13,1,1jh,12,0,1ji,13,1,1jj,12,0,1jk,13,1,1jl,12,0,1jm,13,1,1jn,12,0,1jo,13,1,1jp,12,0,1jq,13,1,1jr,12,0,1js,13,1,1jt,12,0,1ju,13,1,1jv,12,0,1k0,13,1,1k1,12,0,1k2,13,1,1k3,12,0,1k4,13,1,1k5,12,0,1k6,13,1,1k7,12,0,1k8,13,1,1k9,12,0,1ka,13,0,1kb,12,0,1kc,13,1,1kd,12,0,1ke,13,1,1kf,12,0,1kg,13,1,1kh,12,0,1ki,13,1,1kj,12,0,1kk,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1kn,12,0,1ko,13,1,1kp,12,0,1kq,13,1,1kr,12,0,1ks,13,1,1kt,12,0,1ku,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,1l8,13,1,1l9,12,0,1la,13,1,1lb,12,0,1lc,13,1,1ld,12,0,1le,13,1,1lf,12,0,1lg,13,1,1lh,12,0,1li,13,1,1lj,12,0,1lk,13,1,1ll,12,0,1lm,13,1,1ln,12,0,1lo,13,1,1lp,12,0,1lq,13,1,1lr,12,0,1f3,13,1,1ls,12,0,1lt,13,1,1lu,12,0,1lv,13,1,1m0,12,0,1m1,13,1,1m2,12,0,1m3,13,1,1m4,12,0,1m5,13,1,1m6,12,0,1m7,13,1,1m8,12,0,1m9,13,1,1ma,12,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,12,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Chihuahua||14s,1i,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,159,12,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,15f,16,0,15g,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,15r,16,0,15s,12,1,15t,16,0,15u,12,1,15v,16,0,160,12,1,161,16,0,1pt,12,1,1pu,16,0,1pv,12,1,1q0,16,0,1q1,12,1,1q2,16,0,1q3,12,1,1q4,16,0,1q5,12,1,1q6,16,0,1q7,12,1,1q8,16,0,1q9,12,1,1qa,16,0,1qb,12,1,1qc,16,0,1qd,12,1,1qe,16,0,1qf,12,1,1qg,16,0,1qh,12,1,1qi,16,0,1qj,12,1,1qk,16,0,1ql,12,1,1qm,16,0,1qn,12,1,1qo,16,0,1qp,12,1,1qq,16,0,1qr,12,1,1qs,16,0,1qt,12,1,1qu,16,0,1qv,12,1,1r0,16,0,1r1,12,1,1r2,16,0,1r3,12,1,1r4,16,0,1r5,12,1,1r6,16,0,1r7,12,1,1r8,16,0,1r9,12,1,1ra,16,0,1rb,12,1,1rc,16,0,1rd,12,1,1re,16,0,1rf,12,1,1rg,16,0,1rh,12,1,1ri,16,0,1rj,12,1,1,16,0",
        "America/Costa_Rica||1rk,1j,0,1rl,12,0,1rm,13,1,1rn,12,0,1ro,13,1,1rp,12,0,1rq,13,1,1rr,12,0,1rs,13,1,1,12,0",
        "America/Creston||1rt,16,0,1ru,o,0,1,16,0",
        "America/Cuiaba||1rv,1k,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,1f8,q,0,1f9,s,1,1fa,q,0,1fb,s,1,1fc,q,0,1fd,s,1,vk,q,0,1fe,s,1,1ff,q,0,1fg,s,1,1fh,q,0,1fi,s,1,1fj,q,0,1fk,s,1,1fl,q,0,1fm,s,1,11r,q,0,1fn,s,1,1fo,q,0,11u,s,1,1fp,q,0,1fq,s,1,121,q,0,1aq,s,1,1ar,q,0,1fr,s,1,1fs,q,0,1ft,s,1,1fu,q,0,1fv,s,1,1g2,q,0,1g3,s,1,12d,q,0,1g4,s,1,1g5,q,0,1g6,s,1,1g7,q,0,1g8,s,1,12i,q,0,1g9,s,1,12j,q,0,1ga,s,1,1gb,q,0,1gc,s,1,1gd,q,0,1ge,s,1,1gf,q,0,1gg,s,1,1gh,q,0,1gi,s,1,1gj,q,0,1gk,s,1,1gl,q,0,1gm,s,1,1gn,q,0,1go,s,1,1gp,q,0,1gq,s,1,1gr,q,0,1gs,s,1,1gt,q,0,1gu,s,1,1gv,q,0,1h0,s,1,1h1,q,0,1h2,s,1,1h3,q,0,1h4,s,1,1h5,q,0,1h6,s,1,1h7,q,0,1h8,s,1,1h9,q,0,1ha,s,1,1hb,q,0,1hc,s,1,1hd,q,0,1he,s,1,1hf,q,0,1hg,s,1,1hh,q,0,1hi,s,1,1hj,q,0,1hk,s,1,1hl,q,0,1hm,s,1,1hn,q,0,1ho,s,1,1hp,q,0,1hq,s,1,1hr,q,0,1hs,s,1,1ht,q,0,1hu,s,1,1hv,q,0,1i0,s,1,1i1,q,0,1,s,1",
        "America/Danmarkshavn||1s0,1l,0,1s1,s,0,1s2,t,1,1s3,s,0,1s4,t,1,1s5,s,0,1s6,t,1,1s7,s,0,1s8,t,1,1s9,s,0,1sa,t,1,1sb,s,0,1sc,t,1,a5,s,0,a6,t,1,a7,s,0,a8,t,1,a9,s,0,aa,t,1,ab,s,0,ac,t,1,ad,s,0,ae,t,1,af,s,0,ag,t,1,ah,s,0,ai,t,1,aj,s,0,ak,t,1,al,s,0,am,t,1,an,s,0,ao,t,1,1sd,s,0,1,1,0",
        "America/Dawson||1se,n,0,1sf,o,1,1sg,n,0,1sh,o,1,1si,n,0,ja,o,1,1sj,o,1,1sk,n,0,1sl,16,1,1sm,n,0,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "America/Dawson_Creek||20b,o,0,1b1,16,1,20c,o,0,ja,16,1,20d,16,1,20e,o,0,20f,16,1,20g,o,0,20h,16,1,20i,o,0,20j,16,1,20k,o,0,20l,16,1,20m,o,0,20n,16,1,20o,o,0,20p,16,1,20q,o,0,20r,16,1,20s,o,0,20t,16,1,20u,o,0,20v,16,1,210,o,0,211,16,1,212,o,0,213,16,1,214,o,0,215,16,1,216,o,0,217,16,1,218,o,0,219,16,1,21a,o,0,21b,16,1,21c,o,0,21d,16,1,21e,o,0,21f,16,1,21g,o,0,21h,16,1,21i,o,0,1sl,16,1,21j,o,0,21k,16,1,21l,o,0,21m,16,1,21n,o,0,21o,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,220,16,1,1,16,0",
        "America/Denver,America/Shiprock,Navajo,US/Mountain||221,16,0,222,12,1,223,16,0,224,12,1,225,16,0,226,12,1,227,16,0,228,12,1,1b5,16,0,ja,12,1,1b6,12,1,1sk,16,0,229,12,1,22a,16,0,22b,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,22c,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Detroit,US/Michigan||22d,1m,0,22e,12,0,22f,13,0,ja,q,1,22g,q,1,22h,13,0,22i,q,1,22j,13,0,22k,q,1,22l,13,0,22m,q,1,22n,13,0,22o,q,1,22p,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Edmonton,Canada/Mountain||26i,1n,0,26j,16,0,222,12,1,26k,16,0,26l,12,1,26m,16,0,226,12,1,26n,16,0,26o,12,1,26p,16,0,26q,12,1,26r,16,0,26s,12,1,1b5,16,0,ja,12,1,1b6,12,1,26t,16,0,26u,12,1,1b7,16,0,1b8,12,1,1bb,16,0,1bc,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,26v,16,0,1bm,12,1,270,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Eirunepe||271,1o,0,272,13,0,273,q,1,274,13,0,275,q,1,276,13,0,277,q,1,278,13,0,279,q,1,27a,13,0,27b,q,1,27c,13,0,27d,q,1,27e,13,0,27f,q,1,27g,13,0,27h,q,1,27i,13,0,27j,q,1,27k,13,0,27l,q,1,27m,13,0,27n,q,1,27o,13,0,27p,q,1,27q,13,0,27r,q,1,27s,13,0,27t,q,1,27u,13,0,27v,q,1,280,13,0,281,q,0,1,13,0",
        "America/El_Salvador||282,1p,0,283,12,0,284,13,1,285,12,0,286,13,1,1,12,0",
        "America/Ensenada,America/Santa_Isabel,America/Tijuana,Mexico/BajaNorte||287,1q,0,288,16,0,289,o,0,28a,16,0,28b,o,0,28c,16,1,28d,o,0,ja,16,1,28e,16,1,28f,o,0,153,16,1,28g,o,0,20t,16,1,28h,o,0,20v,16,1,28i,o,0,211,16,1,28j,o,0,213,16,1,28k,o,0,215,16,1,28l,o,0,217,16,1,28m,o,0,219,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,28v,o,0,290,16,1,291,o,0,292,16,1,293,o,0,294,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "America/Fort_Nelson||20b,o,0,1b1,16,1,20c,o,0,ja,16,1,20d,16,1,20e,o,0,20f,16,1,20g,o,0,20h,16,1,20i,o,0,20j,16,1,20k,o,0,20l,16,1,20m,o,0,20n,16,1,20o,o,0,20p,16,1,20q,o,0,20r,16,1,20s,o,0,20t,16,1,20u,o,0,20v,16,1,210,o,0,211,16,1,212,o,0,213,16,1,214,o,0,215,16,1,216,o,0,217,16,1,218,o,0,219,16,1,21a,o,0,21b,16,1,21c,o,0,21d,16,1,21e,o,0,21f,16,1,21g,o,0,21h,16,1,21i,o,0,1sl,16,1,21j,o,0,21k,16,1,21l,o,0,21m,16,1,21n,o,0,21o,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,297,o,0,298,16,1,299,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1,16,0",
        "America/Fort_Wayne,America/Indiana/Indianapolis,America/Indianapolis,US/East-Indiana||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,29b,12,0,1kk,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1kn,12,0,1ko,13,1,1kp,12,0,1kq,13,1,1kr,12,0,1ks,13,1,1kt,12,0,1ku,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,29c,13,0,1ld,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Fortaleza||29h,1r,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,tg,s,0,th,t,1,ti,s,0,29i,t,1,tk,s,0,tl,t,1,1,s,0",
        "America/Glace_Bay||29j,q,0,19r,q,0,19s,s,1,19t,q,0,ja,s,1,19u,s,1,29k,q,0,29l,s,1,29m,q,0,29n,s,1,29o,q,0,29p,s,1,29q,q,0,29r,s,1,29s,q,0,29t,s,1,29u,q,0,29v,s,1,2a0,q,0,2a1,s,1,2a2,q,0,2a3,s,1,2a4,q,0,2a5,s,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2ak,q,0,27s,s,1,2al,q,0,2am,s,1,2an,q,0,2ao,s,1,2ap,q,0,2aq,s,1,2ar,q,0,2as,s,1,2at,q,0,2au,s,1,2av,q,0,2b0,s,1,2b1,q,0,2b2,s,1,2b3,q,0,2b4,s,1,2b5,q,0,2b6,s,1,2b7,q,0,2b8,s,1,2b9,q,0,2ba,s,1,2bb,q,0,2bc,s,1,2bd,q,0,2be,s,1,2bf,q,0,2bg,s,1,2bh,q,0,2bi,s,1,2bj,q,0,2bk,s,1,2bl,q,0,2bm,s,1,2bn,q,0,2bo,s,1,2bp,q,0,2bq,s,1,2br,q,0,2bs,s,1,2bt,q,0,2bu,s,1,2bv,q,0,2c0,s,1,2c1,q,0,2c2,s,1,2c3,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "America/Godthab||2dp,1s,0,1s1,s,0,1s2,t,1,1s3,s,0,1s4,t,1,1s5,s,0,1s6,t,1,1s7,s,0,1s8,t,1,1s9,s,0,1sa,t,1,1sb,s,0,1sc,t,1,a5,s,0,a6,t,1,a7,s,0,a8,t,1,a9,s,0,aa,t,1,ab,s,0,ac,t,1,ad,s,0,ae,t,1,af,s,0,ag,t,1,ah,s,0,ai,t,1,aj,s,0,ak,t,1,al,s,0,am,t,1,an,s,0,ao,t,1,ap,s,0,aq,t,1,ar,s,0,as,t,1,at,s,0,au,t,1,av,s,0,b0,t,1,b1,s,0,b2,t,1,b3,s,0,b4,t,1,b5,s,0,b6,t,1,b7,s,0,b8,t,1,b9,s,0,ba,t,1,bb,s,0,bc,t,1,bd,s,0,be,t,1,bf,s,0,bg,t,1,bh,s,0,bi,t,1,bj,s,0,bk,t,1,bl,s,0,bm,t,1,bn,s,0,bo,t,1,bp,s,0,bq,t,1,br,s,0,bs,t,1,bt,s,0,bu,t,1,bv,s,0,c0,t,1,c1,s,0,c2,t,1,c3,s,0,c4,t,1,c5,s,0,c6,t,1,c7,s,0,c8,t,1,c9,s,0,ca,t,1,cb,s,0,cc,t,1,cd,s,0,ce,t,1,cf,s,0,cg,t,1,ch,s,0,ci,t,1,cj,s,0,ck,t,1,cl,s,0,cm,t,1,cn,s,0,co,t,1,cp,s,0,cq,t,1,cr,s,0,cs,t,1,ct,s,0,cu,t,1,cv,s,0,d0,t,1,d1,s,0,d2,t,1,d3,s,0,d4,t,1,d5,s,0,d6,t,1,d7,s,0,d8,t,1,d9,s,0,da,t,1,db,s,0,dc,t,1,1,s,0",
        "America/Goose_Bay||2dq,1t,0,2dr,1u,1,2ds,1t,0,2dt,1g,0,2du,1v,1,2dv,1g,0,2e0,1v,1,2e1,1g,0,2e2,1v,1,2e3,1g,0,2e4,1v,1,2e5,1g,0,2e6,1v,1,2e7,1g,0,2e8,1v,1,2e9,1g,0,ja,1v,1,2ea,1v,1,2eb,1g,0,2ec,1v,1,2ed,1g,0,2ee,1v,1,2ef,1g,0,2eg,1v,1,2eh,1g,0,2ei,1v,1,2ej,1g,0,2ek,1v,1,2el,1g,0,2em,1v,1,2en,1g,0,2eo,1v,1,2ep,1g,0,2eq,1v,1,2er,1g,0,2es,1v,1,2et,1g,0,2eu,1v,1,2ev,1g,0,2f0,1v,1,2f1,1g,0,2f2,1v,1,2f3,1g,0,2f4,1v,1,2f5,1g,0,2f6,1v,1,2f7,1g,0,2f8,1v,1,2f9,1g,0,2fa,1v,1,2fb,1g,0,2fc,1v,1,2fd,1g,0,2fe,1v,1,2ff,1g,0,2fg,1v,1,2fh,1g,0,2fi,1v,1,2fj,1g,0,2fk,q,0,2fl,s,1,2fm,q,0,2fn,s,1,2fo,q,0,2fp,s,1,2fq,q,0,2fr,s,1,2fs,q,0,2ft,s,1,2fu,q,0,2fv,s,1,29m,q,0,29n,s,1,29o,q,0,29p,s,1,29q,q,0,29r,s,1,29s,q,0,29t,s,1,29u,q,0,29v,s,1,2a0,q,0,2a1,s,1,2a2,q,0,2a3,s,1,2a4,q,0,2a5,s,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2g0,q,0,2g1,s,1,2g2,q,0,2g3,t,1,2g4,q,0,2g5,s,1,2g6,q,0,2g7,s,1,2g8,q,0,2g9,s,1,2ga,q,0,2gb,s,1,2gc,q,0,2gd,s,1,2ge,q,0,2gf,s,1,2gg,q,0,2gh,s,1,2gi,q,0,2gj,s,1,2gk,q,0,2gl,s,1,2gm,q,0,2gn,s,1,2go,q,0,2gp,s,1,2gq,q,0,2gr,s,1,2gs,q,0,2gt,s,1,2gu,q,0,2gv,s,1,2h0,q,0,2h1,s,1,2h2,q,0,2h3,s,1,2h4,q,0,2h5,s,1,2h6,q,0,2h7,s,1,2h8,q,0,2h9,s,1,2ha,q,0,2hb,s,1,2hc,q,0,2hd,s,1,2he,q,0,2hf,s,1,2hg,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "America/Grand_Turk||2hh,20,0,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,1,q,0",
        "America/Guatemala||2hi,21,0,2hj,12,0,2hk,13,1,2hl,12,0,2hm,13,1,2hn,12,0,2ho,13,1,2hp,12,0,2hq,13,1,1,12,0",
        "America/Guayaquil||2hr,22,0,1,13,0",
        "America/Guyana||2hs,23,0,2ht,1k,0,2hu,1k,0,2hv,s,0,1,q,0",
        "America/Halifax,Canada/Atlantic||2i0,24,0,2i1,q,0,2i2,s,1,19r,q,0,19s,s,1,2i3,q,0,2i4,s,1,2i5,q,0,2i6,s,1,2i7,q,0,2i8,s,1,2i9,q,0,2ia,s,1,2ib,q,0,2ic,s,1,2id,q,0,2ie,s,1,2if,q,0,2ig,s,1,2ih,q,0,2ii,s,1,2ij,q,0,2ik,s,1,2il,q,0,2im,s,1,2in,q,0,2io,s,1,2ip,q,0,2iq,s,1,2ir,q,0,2is,s,1,2it,q,0,2iu,s,1,2iv,q,0,2j0,s,1,2j1,q,0,2j2,s,1,2j3,q,0,2j4,s,1,2j5,q,0,2j6,s,1,2j7,q,0,2j8,s,1,2j9,q,0,2ja,s,1,2jb,q,0,2jc,s,1,2jd,q,0,2je,s,1,19t,q,0,ja,s,1,19u,s,1,2jf,q,0,2jg,s,1,2jh,q,0,2ji,s,1,2jj,q,0,2jk,s,1,2jl,q,0,2jm,s,1,2jn,q,0,2jo,s,1,2jp,q,0,2jq,s,1,29k,q,0,29l,s,1,2jr,q,0,2js,s,1,2jt,q,0,2ju,s,1,2jv,q,0,2k0,s,1,2k1,q,0,2k2,s,1,2k3,q,0,2k4,s,1,2k5,q,0,2k6,s,1,2k7,q,0,2k8,s,1,2k9,q,0,2ka,s,1,2kb,q,0,2kc,s,1,2fk,q,0,2fl,s,1,2fm,q,0,2fn,s,1,2fo,q,0,2fp,s,1,2fq,q,0,2fr,s,1,2fs,q,0,2ft,s,1,2fu,q,0,2fv,s,1,29m,q,0,29n,s,1,29o,q,0,29p,s,1,29q,q,0,29r,s,1,29s,q,0,29t,s,1,29u,q,0,29v,s,1,2a0,q,0,2a1,s,1,2a2,q,0,2a3,s,1,2a4,q,0,2a5,s,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2ak,q,0,27s,s,1,2al,q,0,2am,s,1,2an,q,0,2ao,s,1,2ap,q,0,2aq,s,1,2ar,q,0,2as,s,1,2at,q,0,2au,s,1,2av,q,0,2b0,s,1,2b1,q,0,2b2,s,1,2b3,q,0,2b4,s,1,2b5,q,0,2b6,s,1,2b7,q,0,2b8,s,1,2b9,q,0,2ba,s,1,2bb,q,0,2bc,s,1,2bd,q,0,2be,s,1,2bf,q,0,2bg,s,1,2bh,q,0,2bi,s,1,2bj,q,0,2bk,s,1,2bl,q,0,2bm,s,1,2bn,q,0,2bo,s,1,2bp,q,0,2bq,s,1,2br,q,0,2bs,s,1,2bt,q,0,2bu,s,1,2bv,q,0,2c0,s,1,2c1,q,0,2c2,s,1,2c3,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "America/Havana,Cuba||2kd,1a,0,2ke,13,0,2kf,q,1,2kg,13,0,2kh,q,1,2ki,13,0,2kj,q,1,2kk,13,0,2kl,q,1,2km,13,0,2kn,q,1,2ko,13,0,2kp,q,1,2kq,13,0,2kr,q,1,2ks,13,0,2kt,q,1,2ku,13,0,2kv,q,1,2l0,13,0,2l1,q,1,2l2,13,0,2l3,q,1,2l4,13,0,2l5,q,1,2l6,13,0,2l7,q,1,2l8,13,0,2l9,q,1,2la,13,0,2lb,q,1,2lc,13,0,2ld,q,1,2le,13,0,2lf,q,1,2lg,13,0,2lh,q,1,2li,13,0,2lj,q,1,2lk,13,0,2ll,q,1,2lm,13,0,2ln,q,1,2lo,13,0,2lp,q,1,2lq,13,0,2lr,q,1,2ls,13,0,2lt,q,1,2lu,13,0,2lv,q,1,2m0,13,0,2m1,q,1,2m2,13,0,2m3,q,1,2m4,13,0,2m5,q,1,2m6,13,0,2m7,q,1,2m8,13,0,2m9,q,1,2ma,13,0,2mb,q,1,2mc,13,0,2md,q,1,2me,13,0,2mf,q,1,2mg,13,0,2mh,q,1,2mi,13,0,2mj,q,1,2mk,13,0,2ml,q,1,2mm,13,0,2mn,q,1,2mo,13,0,2mp,q,1,2mq,13,0,2mr,q,1,2ms,13,0,2ba,q,1,2mt,13,0,2bc,q,1,2mu,13,0,2be,q,1,2mv,13,0,2bg,q,1,2n0,13,0,2bi,q,1,2n1,13,0,2bk,q,1,2n2,13,0,2bq,q,1,2n3,13,0,2n4,q,1,2n5,13,0,2n6,q,1,2n7,13,0,2n8,q,1,2n9,13,0,2na,q,1,2nb,13,0,2nc,q,1,2nd,13,0,2c6,q,1,2ne,13,0,2c8,q,1,2nf,13,0,2ca,q,1,2ng,13,0,2cc,q,1,2nh,13,0,2ce,q,1,2ni,13,0,2cg,q,1,2nj,13,0,2ci,q,1,2nk,13,0,2ck,q,1,2nl,13,0,2cm,q,1,2nm,13,0,2co,q,1,2nn,13,0,2cq,q,1,2no,13,0,2cs,q,1,2np,13,0,2cu,q,1,2nq,13,0,2d0,q,1,2nr,13,0,2d2,q,1,2ns,13,0,2d4,q,1,2nt,13,0,2d6,q,1,2nu,13,0,2d8,q,1,2nv,13,0,2da,q,1,2o0,13,0,2dc,q,1,2o1,13,0,2de,q,1,2o2,13,0,2dg,q,1,2o3,13,0,2di,q,1,2o4,13,0,2dk,q,1,2o5,13,0,2dm,q,1,2o6,13,0,2do,q,1,1,13,0",
        "America/Hermosillo||14s,25,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,152,12,0,153,16,0,154,o,0,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,1,16,0",
        "America/Indiana/Knox,America/Knox_IN,US/Indiana-Starke||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kn,12,0,1ko,13,1,1kp,12,0,1kq,13,1,1kr,12,0,1ks,13,1,1kt,12,0,1ku,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,1l8,13,1,1l9,12,0,1la,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,1lg,13,1,1lh,12,0,1li,13,1,1lj,12,0,1lk,13,1,1ll,12,0,1lo,13,0,1lu,12,0,1lv,13,1,1m0,12,0,1m1,13,1,1m2,12,0,1m3,13,1,1m4,12,0,1m5,13,1,1m6,12,0,1m7,13,1,1m8,12,0,1m9,13,1,1ma,12,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,24i,13,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Indiana/Marengo||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kv,12,0,1l0,13,1,1l5,12,0,1l6,13,1,1l7,12,0,2o8,13,1,1l9,12,0,2o9,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,2oa,13,1,1lh,12,0,2ob,13,1,1lj,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,22n,13,0,1md,13,1,2og,13,0,22q,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Indiana/Petersburg||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,2oh,12,0,2o8,13,1,1l9,12,0,2o9,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,2oa,13,1,1lh,12,0,2ob,13,1,1lj,12,0,1lk,13,1,1ll,12,0,1lm,13,1,1ln,12,0,1lo,13,1,1lp,12,0,1lq,13,1,1lr,12,0,1lt,13,0,1lu,12,0,1lv,13,1,1m0,12,0,1m1,13,1,1m2,12,0,1m3,13,1,1m4,12,0,1m5,13,1,1m6,12,0,1m7,13,1,1m8,12,0,1m9,13,1,1ma,12,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,24i,13,0,1io,13,1,1nv,12,0,1o0,13,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Indiana/Tell_City||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,2oh,12,0,2o8,13,1,1l9,12,0,2o9,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,2oa,13,1,1lh,12,0,1li,13,1,1lj,12,0,2oi,13,1,1ll,12,0,1lm,13,1,1ln,12,0,1lo,13,1,1lp,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,24i,13,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Indiana/Vevay||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1l5,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Indiana/Vincennes||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,2oh,12,0,2o8,13,1,1l9,12,0,2o9,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,2oa,13,1,1lh,12,0,1li,13,1,1lj,12,0,2oi,13,1,1ll,12,0,1lm,13,1,1ln,12,0,1lo,13,1,1lp,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,24i,13,0,1io,13,1,1nv,12,0,1o0,13,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Indiana/Winamac||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1kn,12,0,1ko,13,1,1kp,12,0,1kq,13,1,1kr,12,0,1ks,13,1,1kt,12,0,1ku,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,1l8,13,1,1l9,12,0,1la,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,2oa,13,1,1lh,12,0,2ob,13,1,1lj,12,0,29d,13,0,29e,q,1,29f,13,0,29g,q,1,24i,13,0,1io,13,1,1nv,12,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Inuvik||2oj,1,0,1lr,o,0,229,12,1,28t,o,0,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Iqaluit||2ok,1,0,ja,q,1,22g,q,1,2ol,13,0,2kc,s,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,1f4,12,0,1f5,13,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Jamaica,Jamaica||2hh,20,0,22n,13,0,22o,q,1,2og,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,1,13,0",
        "America/Juneau||20c,o,0,ja,16,1,20d,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,2om,o,0,298,16,1,2on,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,2oo,o,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,op,n,0,oq,n,0,or,o,1,os,n,0,ot,o,1,ou,n,0,ov,o,1,p0,n,0,p1,o,1,p2,n,0,p3,o,1,p4,n,0,p5,o,1,p6,n,0,p7,o,1,p8,n,0,p9,o,1,pa,n,0,pb,o,1,pc,n,0,pd,o,1,pe,n,0,pf,o,1,pg,n,0,ph,o,1,pi,n,0,pj,o,1,pk,n,0,pl,o,1,pm,n,0,pn,o,1,po,n,0,pp,o,1,pq,n,0,pr,o,1,ps,n,0,pt,o,1,pu,n,0,pv,o,1,q0,n,0,q1,o,1,q2,n,0,q3,o,1,q4,n,0,q5,o,1,q6,n,0,q7,o,1,q8,n,0,q9,o,1,qa,n,0,qb,o,1,qc,n,0,qd,o,1,qe,n,0,qf,o,1,qg,n,0,qh,o,1,qi,n,0,qj,o,1,qk,n,0,ql,o,1,qm,n,0,qn,o,1,qo,n,0,qp,o,1,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/Kentucky/Louisville,America/Louisville||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,2op,12,0,2oq,13,1,1kj,12,0,1kk,13,1,14f,12,0,ja,13,1,14g,13,1,2or,12,0,2os,13,1,1kn,12,0,1ku,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,2o8,13,1,1l9,12,0,1la,13,1,1lb,12,0,1lc,13,1,1ld,12,0,1le,13,1,1lf,12,0,1lg,13,1,1lh,12,0,1li,13,1,1lj,12,0,2ot,13,1,2ou,13,0,2ov,q,1,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,22n,13,0,1md,13,1,2og,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Kentucky/Monticello||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1m0,12,0,1m1,13,1,1m2,12,0,1m3,13,1,1m4,12,0,1m5,13,1,1m6,12,0,1m7,13,1,1m8,12,0,1m9,13,1,1ma,12,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/La_Paz||2p0,26,0,2p1,27,1,1,q,0",
        "America/Lima||2p2,28,0,2p3,13,0,2p4,q,1,2p5,13,0,2p6,q,1,2p7,13,0,2p8,q,1,2p9,13,0,2pa,q,1,2pb,13,0,2pc,q,1,2pd,13,0,2pe,q,1,2pf,13,0,2pg,q,1,1,13,0",
        "America/Los_Angeles,US/Pacific-New,US/Pacific||1b0,o,0,1b1,16,1,1b2,o,0,1b3,16,1,20c,o,0,ja,16,1,20d,16,1,2ph,o,0,2pi,16,1,2pj,o,0,20l,16,1,2pk,o,0,20n,16,1,2pl,o,0,20p,16,1,2pm,o,0,20r,16,1,28g,o,0,20t,16,1,28h,o,0,20v,16,1,28i,o,0,211,16,1,28j,o,0,213,16,1,28k,o,0,215,16,1,28l,o,0,217,16,1,28m,o,0,219,16,1,2pn,o,0,21b,16,1,2po,o,0,21d,16,1,2pp,o,0,21f,16,1,2pq,o,0,21h,16,1,1sk,o,0,1sl,16,1,22a,o,0,21k,16,1,21l,o,0,21m,16,1,21n,o,0,21o,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,2om,o,0,298,16,1,2on,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "America/Maceio||2pr,29,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,t8,s,0,t9,t,1,tg,s,0,th,t,1,ti,s,0,29i,t,1,tk,s,0,tl,t,1,1,s,0",
        "America/Managua||2ps,2a,0,2pt,12,0,2pu,13,0,2pv,12,0,2q0,13,1,2q1,12,0,2q2,13,1,2q3,12,0,2q4,13,0,2q5,12,0,2q6,13,0,2q7,12,0,2q8,13,1,2q9,12,0,2qa,13,1,1,12,0",
        "America/Manaus,Brazil/West||2qb,2b,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,1fh,q,0,1fi,s,1,1,q,0",
        "America/Martinique||2qc,2c,0,2qd,q,0,2qe,s,1,1,q,0",
        "America/Matamoros||1i2,2d,0,1n8,12,0,1n9,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1id,12,0,1ie,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1ip,12,0,1iq,13,1,1ir,12,0,1is,13,1,1it,12,0,1iu,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Mazatlan,Mexico/BajaSur||14s,2e,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,152,12,0,153,16,0,154,o,0,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,15f,16,0,15g,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,15r,16,0,15s,12,1,15t,16,0,15u,12,1,15v,16,0,160,12,1,161,16,0,1pt,12,1,1pu,16,0,1pv,12,1,1q0,16,0,1q1,12,1,1q2,16,0,1q3,12,1,1q4,16,0,1q5,12,1,1q6,16,0,1q7,12,1,1q8,16,0,1q9,12,1,1qa,16,0,1qb,12,1,1qc,16,0,1qd,12,1,1qe,16,0,1qf,12,1,1qg,16,0,1qh,12,1,1qi,16,0,1qj,12,1,1qk,16,0,1ql,12,1,1qm,16,0,1qn,12,1,1qo,16,0,1qp,12,1,1qq,16,0,1qr,12,1,1qs,16,0,1qt,12,1,1qu,16,0,1qv,12,1,1r0,16,0,1r1,12,1,1r2,16,0,1r3,12,1,1r4,16,0,1r5,12,1,1r6,16,0,1r7,12,1,1r8,16,0,1r9,12,1,1ra,16,0,1rb,12,1,1rc,16,0,1rd,12,1,1re,16,0,1rf,12,1,1rg,16,0,1rh,12,1,1ri,16,0,1rj,12,1,1,16,0",
        "America/Menominee||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1kl,12,0,1km,13,1,1ls,12,0,1lt,13,1,1m2,12,0,22l,13,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,12,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Merida||1i2,2f,0,1i3,12,0,2qf,13,0,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1id,12,0,1ie,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1ip,12,0,1iq,13,1,1ir,12,0,1is,13,1,1it,12,0,1iu,13,1,1iv,12,0,162,13,1,163,12,0,164,13,1,165,12,0,166,13,1,167,12,0,168,13,1,169,12,0,16a,13,1,16b,12,0,16c,13,1,16d,12,0,16e,13,1,16f,12,0,16g,13,1,16h,12,0,16i,13,1,16j,12,0,16k,13,1,16l,12,0,16m,13,1,16n,12,0,16o,13,1,16p,12,0,16q,13,1,16r,12,0,16s,13,1,16t,12,0,16u,13,1,16v,12,0,170,13,1,171,12,0,172,13,1,173,12,0,174,13,1,175,12,0,176,13,1,177,12,0,178,13,1,179,12,0,17a,13,1,17b,12,0,17c,13,1,17d,12,0,17e,13,1,17f,12,0,17g,13,1,17h,12,0,17i,13,1,17j,12,0,17k,13,1,17l,12,0,17m,13,1,17n,12,0,17o,13,1,1,12,0",
        "America/Metlakatla||20c,o,0,ja,16,1,20d,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,2om,o,0,298,16,1,2on,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,qp,o,0,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/Mexico_City,Mexico/General||14s,2g,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,2qg,12,0,2qh,13,1,2qi,12,0,2qj,13,1,2qk,12,0,2ql,13,1,2qm,12,0,2qn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1id,12,0,1ie,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1ip,12,0,1iq,13,1,1ir,12,0,1is,13,1,1it,12,0,1iu,13,1,1iv,12,0,162,13,1,163,12,0,164,13,1,165,12,0,166,13,1,167,12,0,168,13,1,169,12,0,16a,13,1,16b,12,0,16c,13,1,16d,12,0,16e,13,1,16f,12,0,16g,13,1,16h,12,0,16i,13,1,16j,12,0,16k,13,1,16l,12,0,16m,13,1,16n,12,0,16o,13,1,16p,12,0,16q,13,1,16r,12,0,16s,13,1,16t,12,0,16u,13,1,16v,12,0,170,13,1,171,12,0,172,13,1,173,12,0,174,13,1,175,12,0,176,13,1,177,12,0,178,13,1,179,12,0,17a,13,1,17b,12,0,17c,13,1,17d,12,0,17e,13,1,17f,12,0,17g,13,1,17h,12,0,17i,13,1,17j,12,0,17k,13,1,17l,12,0,17m,13,1,17n,12,0,17o,13,1,1,12,0",
        "America/Miquelon||2qo,1k,0,2qp,q,0,2qq,s,0,1ao,t,1,2qr,s,0,2qs,t,1,2qt,s,0,2qu,t,1,2mc,s,0,vn,t,1,2me,s,0,2qv,t,1,2mg,s,0,1ff,t,1,2mi,s,0,2r0,t,1,2mk,s,0,2r1,t,1,2mm,s,0,2r2,t,1,2mo,s,0,2r3,t,1,2mq,s,0,2r4,t,1,2r5,s,0,2r6,t,1,2r7,s,0,2r8,t,1,2mu,s,0,2r9,t,1,2mv,s,0,2ra,t,1,2n0,s,0,2rb,t,1,2n1,s,0,2rc,t,1,2rd,s,0,2re,t,1,2rf,s,0,2rg,t,1,2rh,s,0,2ri,t,1,2n3,s,0,2rj,t,1,2rk,s,0,2rl,t,1,2n7,s,0,2rm,t,1,2n9,s,0,2rn,t,1,2ro,s,0,2rp,t,1,2rq,s,0,2rr,t,1,2ne,s,0,2rs,t,1,2nf,s,0,2rt,t,1,2ng,s,0,2ru,t,1,2nh,s,0,2rv,t,1,2ni,s,0,2s0,t,1,2nj,s,0,2s1,t,1,2nk,s,0,2s2,t,1,2nl,s,0,2s3,t,1,2nm,s,0,2s4,t,1,2nn,s,0,2s5,t,1,2no,s,0,2s6,t,1,2np,s,0,2s7,t,1,2nq,s,0,2s8,t,1,2nr,s,0,2s9,t,1,2ns,s,0,2sa,t,1,2nt,s,0,2sb,t,1,2nu,s,0,2sc,t,1,2nv,s,0,2sd,t,1,2o0,s,0,2se,t,1,2o1,s,0,2sf,t,1,2o2,s,0,2sg,t,1,2o3,s,0,2sh,t,1,2o4,s,0,2si,t,1,2o5,s,0,2sj,t,1,2o6,s,0,2sk,t,1,1,s,0",
        "America/Moncton||2sl,13,0,19r,q,0,19s,s,1,2sm,q,0,2sn,s,1,2so,q,0,2sp,s,1,2sq,q,0,2sr,s,1,2ss,q,0,2st,s,1,2su,q,0,2sv,s,1,2t0,q,0,2t1,s,1,2t2,q,0,2t3,s,1,2t4,q,0,2t5,s,1,2t6,q,0,2t7,s,1,19t,q,0,ja,s,1,19u,s,1,2jf,q,0,2jg,s,1,2jh,q,0,2ji,s,1,2jj,q,0,2jk,s,1,2jl,q,0,2jm,s,1,2t8,q,0,2t9,s,1,2jn,q,0,2jo,s,1,2jp,q,0,2jq,s,1,29k,q,0,29l,s,1,2jr,q,0,2js,s,1,2ta,q,0,2tb,s,1,2jt,q,0,2ju,s,1,2jv,q,0,2tc,s,1,2k1,q,0,2td,s,1,2k3,q,0,2te,s,1,2tf,q,0,2tg,s,1,2th,q,0,2ti,s,1,2k5,q,0,2k6,s,1,2k7,q,0,2k8,s,1,2k9,q,0,2ka,s,1,2kb,q,0,2kc,s,1,2fk,q,0,2fl,s,1,2fm,q,0,2fn,s,1,2fo,q,0,2fp,s,1,2fq,q,0,2fr,s,1,2fs,q,0,2ft,s,1,2fu,q,0,2fv,s,1,29m,q,0,29n,s,1,29q,q,0,29r,s,1,29s,q,0,29t,s,1,29u,q,0,29v,s,1,2a0,q,0,2a1,s,1,2a2,q,0,2a3,s,1,2a4,q,0,2a5,s,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2ak,q,0,27s,s,1,2al,q,0,2am,s,1,2an,q,0,2ao,s,1,2ap,q,0,2aq,s,1,2ar,q,0,2as,s,1,2at,q,0,2au,s,1,2gc,q,0,2gd,s,1,2ge,q,0,2gf,s,1,2gg,q,0,2gh,s,1,2gi,q,0,2gj,s,1,2gk,q,0,2gl,s,1,2gm,q,0,2gn,s,1,2go,q,0,2gp,s,1,2gq,q,0,2gr,s,1,2gs,q,0,2gt,s,1,2gu,q,0,2gv,s,1,2h0,q,0,2h1,s,1,2h2,q,0,2h3,s,1,2h4,q,0,2h5,s,1,2h6,q,0,2h7,s,1,2br,q,0,2bs,s,1,2bt,q,0,2bu,s,1,2bv,q,0,2c0,s,1,2c1,q,0,2c2,s,1,2c3,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "America/Monterrey||1i2,2h,0,1n8,12,0,1n9,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1id,12,0,1ie,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1ip,12,0,1iq,13,1,1ir,12,0,1is,13,1,1it,12,0,1iu,13,1,1iv,12,0,162,13,1,163,12,0,164,13,1,165,12,0,166,13,1,167,12,0,168,13,1,169,12,0,16a,13,1,16b,12,0,16c,13,1,16d,12,0,16e,13,1,16f,12,0,16g,13,1,16h,12,0,16i,13,1,16j,12,0,16k,13,1,16l,12,0,16m,13,1,16n,12,0,16o,13,1,16p,12,0,16q,13,1,16r,12,0,16s,13,1,16t,12,0,16u,13,1,16v,12,0,170,13,1,171,12,0,172,13,1,173,12,0,174,13,1,175,12,0,176,13,1,177,12,0,178,13,1,179,12,0,17a,13,1,17b,12,0,17c,13,1,17d,12,0,17e,13,1,17f,12,0,17g,13,1,17h,12,0,17i,13,1,17j,12,0,17k,13,1,17l,12,0,17m,13,1,17n,12,0,17o,13,1,1,12,0",
        "America/Montevideo||2tj,1k,0,2tk,1g,0,2tl,s,1,2tm,1g,0,2tn,s,1,2to,1g,0,2tp,s,1,2tq,1g,0,2tr,s,1,2ts,1g,0,2tt,s,1,2tu,1g,0,2tv,s,1,2u0,1g,0,2u1,s,1,2u2,1g,0,2u3,s,1,2u4,1g,0,2u5,s,1,2u6,1g,0,2u7,s,1,2u8,1g,0,2u9,s,1,2ua,1g,0,2ub,s,1,2uc,1g,0,2ud,t,1,2ue,s,0,2uf,t,1,2ug,s,0,2uh,t,1,2ui,s,0,2uj,t,1,2uk,s,0,2ul,t,1,uu,s,0,2um,t,1,2un,s,0,2uo,1v,1,2up,s,0,2uq,1v,1,2ur,s,0,2us,1v,1,2ut,s,0,2uu,t,1,2uv,s,0,2v0,1v,1,2v1,t,1,2v2,s,0,2v3,t,1,2v4,s,0,2v5,t,1,2v6,s,0,2v7,t,1,2v8,s,0,2v9,t,1,2va,s,0,v8,t,1,v9,s,0,va,t,1,2vb,s,0,vc,t,1,vd,s,0,2vc,t,1,2vd,s,0,2ve,t,1,2vf,s,0,2vg,t,1,2hq,s,0,2vh,t,1,2vi,s,0,2vj,t,1,2vk,s,0,2vl,t,1,2vm,s,0,2vn,t,1,2vo,s,0,2vp,t,1,2vq,s,0,2vr,t,1,2vs,s,0,2vt,t,1,2vu,s,0,2vv,t,1,300,s,0,301,t,1,1,s,0",
        "America/Montreal,America/Toronto,Canada/Eastern||302,13,0,303,q,1,304,13,0,305,q,1,306,13,0,307,q,1,308,13,0,309,q,1,30a,13,0,30b,q,1,30c,13,0,30d,q,1,30e,13,0,30f,q,1,30g,13,0,30h,q,1,30i,13,0,30j,q,1,30k,13,0,30l,q,1,30m,13,0,30n,q,1,30o,13,0,30p,q,1,30q,13,0,30r,q,1,30s,13,0,30t,q,1,30u,13,0,30v,q,1,310,13,0,311,q,1,312,13,0,313,q,1,314,13,0,315,q,1,316,13,0,317,q,1,318,13,0,319,q,1,31a,13,0,31b,q,1,31c,13,0,31d,q,1,31e,13,0,22f,q,1,ja,q,1,22g,q,1,31f,13,0,31g,q,1,31h,13,0,31i,q,1,31j,13,0,31k,q,1,31l,13,0,31m,q,1,31n,13,0,31o,q,1,31p,13,0,31q,q,1,31r,13,0,31s,q,1,31t,13,0,31u,q,1,31v,13,0,320,q,1,321,13,0,322,q,1,323,13,0,324,q,1,325,13,0,326,q,1,327,13,0,328,q,1,329,13,0,32a,q,1,32b,13,0,32c,q,1,32d,13,0,32e,q,1,32f,13,0,32g,q,1,32h,13,0,32i,q,1,32j,13,0,32k,q,1,1f2,13,0,32l,q,1,32m,13,0,32n,q,1,32o,13,0,22k,q,1,2ou,13,0,2ov,q,1,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,32p,13,0,22o,q,1,22p,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Nassau||32q,2i,0,32j,13,0,32k,q,1,1f2,13,0,32l,q,1,32m,13,0,32n,q,1,32o,13,0,22k,q,1,2ou,13,0,2ov,q,1,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,32p,13,0,22o,q,1,22p,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/New_York,US/Eastern||32r,13,0,303,q,1,32s,13,0,32t,q,1,32u,13,0,32v,q,1,330,13,0,331,q,1,332,13,0,333,q,1,334,13,0,335,q,1,336,13,0,337,q,1,338,13,0,339,q,1,33a,13,0,33b,q,1,33c,13,0,30l,q,1,30m,13,0,30n,q,1,30o,13,0,30p,q,1,30q,13,0,30r,q,1,30s,13,0,30t,q,1,33d,13,0,30v,q,1,310,13,0,33e,q,1,312,13,0,313,q,1,314,13,0,315,q,1,316,13,0,317,q,1,318,13,0,319,q,1,31a,13,0,31b,q,1,31c,13,0,31d,q,1,31e,13,0,14e,q,1,33f,13,0,33g,q,1,22f,13,0,ja,q,1,22g,q,1,31f,13,0,31g,q,1,33h,13,0,33i,q,1,22h,13,0,22i,q,1,33j,13,0,33k,q,1,31n,13,0,33l,q,1,31p,13,0,31q,q,1,31r,13,0,31s,q,1,31t,13,0,31u,q,1,31v,13,0,320,q,1,321,13,0,33m,q,1,323,13,0,33n,q,1,325,13,0,326,q,1,327,13,0,328,q,1,329,13,0,32a,q,1,32b,13,0,32c,q,1,32d,13,0,32e,q,1,32f,13,0,32g,q,1,32h,13,0,32i,q,1,32j,13,0,32k,q,1,1f2,13,0,32l,q,1,32m,13,0,32n,q,1,32o,13,0,22k,q,1,2ou,13,0,2ov,q,1,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,22n,13,0,22o,q,1,2og,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Nipigon||302,13,0,303,q,1,33o,13,0,22f,q,1,ja,q,1,22g,q,1,32p,13,0,22o,q,1,22p,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Nome||j9,l,0,ja,m,1,jb,m,1,jc,l,0,jd,l,0,je,m,1,jf,l,0,jg,m,1,jh,l,0,ji,m,1,jj,l,0,jk,m,1,jl,l,0,jm,m,1,jn,l,0,jo,m,1,jp,l,0,jq,m,1,jr,l,0,js,m,1,jt,l,0,ju,m,1,jv,l,0,k0,m,1,k1,l,0,k2,m,1,k3,l,0,k4,m,1,k5,l,0,k6,m,1,k7,l,0,k8,m,1,k9,l,0,ka,m,1,op,n,0,oq,n,0,or,o,1,os,n,0,ot,o,1,ou,n,0,ov,o,1,p0,n,0,p1,o,1,p2,n,0,p3,o,1,p4,n,0,p5,o,1,p6,n,0,p7,o,1,p8,n,0,p9,o,1,pa,n,0,pb,o,1,pc,n,0,pd,o,1,pe,n,0,pf,o,1,pg,n,0,ph,o,1,pi,n,0,pj,o,1,pk,n,0,pl,o,1,pm,n,0,pn,o,1,po,n,0,pp,o,1,pq,n,0,pr,o,1,ps,n,0,pt,o,1,pu,n,0,pv,o,1,q0,n,0,q1,o,1,q2,n,0,q3,o,1,q4,n,0,q5,o,1,q6,n,0,q7,o,1,q8,n,0,q9,o,1,qa,n,0,qb,o,1,qc,n,0,qd,o,1,qe,n,0,qf,o,1,qg,n,0,qh,o,1,qi,n,0,qj,o,1,qk,n,0,ql,o,1,qm,n,0,qn,o,1,qo,n,0,qp,o,1,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/Noronha,Brazil/DeNoronha||33p,2j,0,33q,t,0,33r,d,1,33s,t,0,33t,d,1,33u,t,0,33v,d,1,340,t,0,341,d,1,342,t,0,343,d,1,344,t,0,345,d,1,346,t,0,347,d,1,348,t,0,349,d,1,34a,t,0,34b,d,1,34c,t,0,34d,d,1,34e,t,0,34f,d,1,34g,t,0,34h,d,1,34i,t,0,34j,d,1,34k,t,0,34l,d,1,34m,t,0,34n,d,1,34o,t,0,34p,d,1,34q,t,0,34r,d,1,34s,t,0,34t,d,1,34u,t,0,34v,d,1,1,t,0",
        "America/North_Dakota/Beulah||221,16,0,222,12,1,223,16,0,224,12,1,1b5,16,0,ja,12,1,1b6,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,22c,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/North_Dakota/Center||221,16,0,222,12,1,223,16,0,224,12,1,1b5,16,0,ja,12,1,1b6,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,22c,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,12,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/North_Dakota/New_Salem||221,16,0,222,12,1,223,16,0,224,12,1,1b5,16,0,ja,12,1,1b6,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,22c,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Ojinaga||14s,2k,0,14t,16,0,14u,12,0,14v,16,0,150,12,0,151,16,0,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,159,12,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,15f,16,0,15g,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,15r,16,0,15s,12,1,15t,16,0,15u,12,1,15v,16,0,160,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "America/Pangnirtung||350,1,0,19t,q,0,ja,s,1,19u,s,1,351,q,0,352,t,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2ak,q,0,27s,s,1,2al,q,0,2am,s,1,2an,q,0,2ao,s,1,2ap,q,0,2aq,s,1,2ar,q,0,2as,s,1,2at,q,0,2au,s,1,2av,q,0,2b0,s,1,2b1,q,0,2b2,s,1,2b3,q,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,1f4,12,0,1f5,13,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Paramaribo||353,2l,0,354,2l,0,355,1g,0,356,1g,0,1,s,0",
        "America/Phoenix,US/Arizona||221,16,0,222,12,1,223,16,0,224,12,1,1b5,16,0,357,12,1,358,16,0,359,12,1,1b7,16,0,1b8,12,1,1,16,0",
        "America/Port-au-Prince||35a,2m,0,2lu,13,0,35b,q,1,35c,13,0,35d,q,1,35e,13,0,35f,q,1,35g,13,0,35h,q,1,35i,13,0,1ao,q,1,2al,13,0,23k,q,1,2an,13,0,23m,q,1,2ap,13,0,23o,q,1,2ar,13,0,23q,q,1,2at,13,0,23s,q,1,2av,13,0,23u,q,1,2b1,13,0,240,q,1,2b3,13,0,242,q,1,2b5,13,0,1i5,q,1,2b7,13,0,1i7,q,1,2rf,13,0,2rg,q,1,2rh,13,0,2ri,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,1,13,0",
        "America/Porto_Acre,America/Rio_Branco,Brazil/Acre||35j,2n,0,272,13,0,273,q,1,274,13,0,275,q,1,276,13,0,277,q,1,278,13,0,279,q,1,27a,13,0,27b,q,1,27c,13,0,27d,q,1,27e,13,0,27f,q,1,27g,13,0,27h,q,1,27i,13,0,27j,q,1,27k,13,0,27l,q,1,27m,13,0,27n,q,1,27o,13,0,27p,q,1,27q,13,0,27r,q,1,27s,13,0,27t,q,1,280,13,0,281,q,0,1,13,0",
        "America/Porto_Velho||35k,2o,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,1,q,0",
        "America/Puerto_Rico||35l,q,0,ja,s,1,19u,s,1,1,q,0",
        "America/Rainy_River||14c,12,0,14d,13,1,14e,12,0,14f,13,1,ja,13,1,14g,13,1,35m,12,0,1md,13,1,35n,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,12,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Rankin_Inlet||35o,1,0,2kb,12,0,32l,q,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,13,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Recife||35p,2p,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,sk,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,tg,s,0,th,t,1,ti,s,0,35q,t,1,tk,s,0,tl,t,1,1,s,0",
        "America/Regina,Canada/East-Saskatchewan,Canada/Saskatchewan||35r,2q,0,26j,16,0,222,12,1,35s,16,0,18t,12,1,35t,16,0,18v,12,1,30u,16,0,191,12,1,35u,16,0,311,12,1,35v,16,0,195,12,1,360,16,0,361,12,1,362,16,0,19d,12,1,363,16,0,19f,12,1,364,16,0,365,12,1,366,16,0,367,12,1,1b5,16,0,ja,12,1,1b6,12,1,368,16,0,369,12,1,26t,16,0,26u,12,1,36a,16,0,36b,12,1,36c,16,0,36d,12,1,2pj,16,0,36e,12,1,2pk,16,0,36f,12,1,2pl,16,0,36g,12,1,2pm,16,0,36h,12,1,28g,16,0,36i,12,1,28h,16,0,36j,12,1,28i,16,0,36k,12,1,28j,16,0,36l,12,1,28l,16,0,36m,12,1,28m,16,0,1,12,0",
        "America/Resolute||36n,1,0,2kb,12,0,32l,q,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,13,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,13,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Santarem||36o,1d,0,1a0,q,0,1a1,s,1,1a2,q,0,1a3,s,1,1a4,q,0,1a5,s,1,1a6,q,0,1a7,s,1,1a8,q,0,1a9,s,1,1aa,q,0,1ab,s,1,1ac,q,0,uo,s,1,1ad,q,0,1ae,s,1,1af,q,0,us,s,1,1ag,q,0,1ah,s,1,1ai,q,0,1aj,s,1,1ak,q,0,1al,s,1,1am,q,0,1an,s,1,1ao,q,0,1ap,s,1,36p,q,0,1,s,0",
        "America/Santiago,Chile/Continental||36q,2r,0,36r,13,0,36s,2r,0,36t,q,0,36u,2r,0,36v,q,1,370,13,0,371,q,1,372,13,0,373,q,1,374,13,0,375,q,1,376,13,0,273,q,1,377,13,0,378,q,0,379,13,0,37a,q,0,37b,s,1,37c,q,0,37d,13,0,37e,q,0,37f,s,1,37g,q,0,37h,s,1,37i,q,0,37j,s,1,37k,q,0,37l,s,1,37m,q,0,37n,s,1,37o,q,0,2uv,s,1,37p,q,0,37q,s,1,37r,q,0,37s,s,1,37t,q,0,37u,s,1,37v,q,0,380,s,1,381,q,0,382,s,1,2ln,q,0,383,s,1,2lp,q,0,384,s,1,2lr,q,0,385,s,1,2lt,q,0,386,s,1,2lv,q,0,387,s,1,2m1,q,0,388,s,1,2m3,q,0,389,s,1,2m5,q,0,38a,s,1,2m7,q,0,38b,s,1,2m9,q,0,38c,s,1,1fa,q,0,38d,s,1,38e,q,0,38f,s,1,38g,q,0,38h,s,1,38i,q,0,38j,s,1,38k,q,0,38l,s,1,38m,q,0,38n,s,1,1fl,q,0,38o,s,1,38p,q,0,38q,s,1,38r,q,0,38s,s,1,38t,q,0,38u,s,1,38v,q,0,390,s,1,391,q,0,392,s,1,1fs,q,0,393,s,1,394,q,0,395,s,1,396,q,0,397,s,1,398,q,0,12c,s,1,399,q,0,12e,s,1,12f,q,0,12g,s,1,1g7,q,0,39a,s,1,109,q,0,39b,s,1,10b,q,0,39c,s,1,39d,q,0,39e,s,1,39f,q,0,39g,s,1,39h,q,0,39i,s,1,39j,q,0,39k,s,1,39l,q,0,39m,s,1,39n,q,0,39o,s,1,39p,q,0,39q,s,1,39r,q,0,39s,s,1,39t,q,0,39u,s,1,39v,q,0,3a0,s,1,3a1,q,0,3a2,s,1,3a3,q,0,3a4,s,1,3a5,q,0,3a6,s,1,3a7,q,0,3a8,s,1,3a9,q,0,3aa,s,1,3ab,q,0,3ac,s,1,3ad,q,0,3ae,s,1,3af,q,0,3ag,s,1,3ah,q,0,3ai,s,1,3aj,q,0,3ak,s,1,3al,q,0,3am,s,1,3an,q,0,3ao,s,1,3ap,q,0,3aq,s,1,3ar,q,0,3as,s,1,3at,q,0,3au,s,1,3av,q,0,3b0,s,1,3b1,q,0,1,s,1",
        "America/Santo_Domingo||3b2,1o,0,2fl,13,0,3b3,q,1,2fr,13,0,3b4,10,1,2ft,13,0,3b5,10,1,2fv,13,0,3b6,10,1,29n,13,0,3b7,10,1,29p,13,0,3b8,10,1,29r,13,0,247,q,0,3b9,13,0,1,q,0",
        "America/Sao_Paulo,Brazil/East||3ba,2s,0,s8,s,0,s9,t,1,sa,s,0,sb,t,1,sc,s,0,sd,t,1,se,s,0,sf,t,1,sg,s,0,sh,t,1,si,s,0,sj,t,1,3bb,s,0,sl,t,1,sm,s,0,sn,t,1,so,s,0,sp,t,1,sq,s,0,sr,t,1,ss,s,0,st,t,1,su,s,0,sv,t,1,t0,s,0,t1,t,1,t2,s,0,t3,t,1,t4,s,0,t5,t,1,t6,s,0,t7,t,1,v9,s,0,14i,t,1,vb,s,0,14j,t,1,14k,s,0,14l,t,1,14m,s,0,14n,t,1,14o,s,0,14p,t,1,t8,s,0,t9,t,1,ta,s,0,tb,t,1,tc,s,0,td,t,1,te,s,0,tf,t,1,tg,s,0,th,t,1,ti,s,0,tj,t,1,tk,s,0,tl,t,1,tm,s,0,tn,t,1,3bc,s,0,3bd,t,1,3be,s,0,3bf,t,1,3bg,s,0,3bh,t,1,3bi,s,0,3bj,t,1,3bk,s,0,3bl,t,1,vi,s,0,3bm,t,1,3bn,s,0,3bo,t,1,3bp,s,0,3bq,t,1,14q,s,0,14r,t,1,to,s,0,tp,t,1,3br,s,0,3bs,t,1,3bt,s,0,3bu,t,1,3bv,s,0,3c0,t,1,3c1,s,0,3c2,t,1,3c3,s,0,3c4,t,1,3c5,s,0,3c6,t,1,3c7,s,0,3c8,t,1,3c9,s,0,3ca,t,1,3cb,s,0,3cc,t,1,3cd,s,0,3ce,t,1,3cf,s,0,3cg,t,1,3ch,s,0,3ci,t,1,3cj,s,0,3ck,t,1,3cl,s,0,3cm,t,1,3cn,s,0,3co,t,1,3cp,s,0,3cq,t,1,3cr,s,0,3cs,t,1,3ct,s,0,3cu,t,1,3cv,s,0,3d0,t,1,3d1,s,0,3d2,t,1,3d3,s,0,3d4,t,1,3d5,s,0,3d6,t,1,3d7,s,0,3d8,t,1,3d9,s,0,3da,t,1,3db,s,0,1,t,1",
        "America/Scoresbysund||3dc,2t,0,2qd,t,0,3dd,d,1,3de,t,0,1s4,1,1,1s5,d,0,1s6,1,1,1s7,d,0,1s8,1,1,1s9,d,0,1sa,1,1,1sb,d,0,1sc,1,1,a5,d,0,a6,1,1,a7,d,0,a8,1,1,a9,d,0,aa,1,1,ab,d,0,ac,1,1,ad,d,0,ae,1,1,af,d,0,ag,1,1,ah,d,0,ai,1,1,aj,d,0,ak,1,1,al,d,0,am,1,1,an,d,0,ao,1,1,ap,d,0,aq,1,1,ar,d,0,as,1,1,at,d,0,au,1,1,av,d,0,b0,1,1,b1,d,0,b2,1,1,b3,d,0,b4,1,1,b5,d,0,b6,1,1,b7,d,0,b8,1,1,b9,d,0,ba,1,1,bb,d,0,bc,1,1,bd,d,0,be,1,1,bf,d,0,bg,1,1,bh,d,0,bi,1,1,bj,d,0,bk,1,1,bl,d,0,bm,1,1,bn,d,0,bo,1,1,bp,d,0,bq,1,1,br,d,0,bs,1,1,bt,d,0,bu,1,1,bv,d,0,c0,1,1,c1,d,0,c2,1,1,c3,d,0,c4,1,1,c5,d,0,c6,1,1,c7,d,0,c8,1,1,c9,d,0,ca,1,1,cb,d,0,cc,1,1,cd,d,0,ce,1,1,cf,d,0,cg,1,1,ch,d,0,ci,1,1,cj,d,0,ck,1,1,cl,d,0,cm,1,1,cn,d,0,co,1,1,cp,d,0,cq,1,1,cr,d,0,cs,1,1,ct,d,0,cu,1,1,cv,d,0,d0,1,1,d1,d,0,d2,1,1,d3,d,0,d4,1,1,d5,d,0,d6,1,1,d7,d,0,d8,1,1,d9,d,0,da,1,1,db,d,0,dc,1,1,1,d,0",
        "America/Sitka||20c,o,0,ja,16,1,20d,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,2om,o,0,298,16,1,2on,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,op,n,0,oq,n,0,or,o,1,os,n,0,ot,o,1,ou,n,0,ov,o,1,p0,n,0,p1,o,1,p2,n,0,p3,o,1,p4,n,0,p5,o,1,p6,n,0,p7,o,1,p8,n,0,p9,o,1,pa,n,0,pb,o,1,pc,n,0,pd,o,1,pe,n,0,pf,o,1,pg,n,0,ph,o,1,pi,n,0,pj,o,1,pk,n,0,pl,o,1,pm,n,0,pn,o,1,po,n,0,pp,o,1,pq,n,0,pr,o,1,ps,n,0,pt,o,1,pu,n,0,pv,o,1,q0,n,0,q1,o,1,q2,n,0,q3,o,1,q4,n,0,q5,o,1,q6,n,0,q7,o,1,q8,n,0,q9,o,1,qa,n,0,qb,o,1,qc,n,0,qd,o,1,qe,n,0,qf,o,1,qg,n,0,qh,o,1,qi,n,0,qj,o,1,qk,n,0,ql,o,1,qm,n,0,qn,o,1,qo,n,0,qp,o,1,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/St_Johns,Canada/Newfoundland||3df,1t,0,3dg,1u,1,2dq,1t,0,2dr,1u,1,3dh,1t,0,3di,1u,1,3dj,1t,0,3dk,1u,1,3dl,1t,0,3dm,1u,1,3dn,1t,0,3do,1u,1,3dp,1t,0,3dq,1u,1,3dr,1t,0,3ds,1u,1,3dt,1t,0,3du,1u,1,3dv,1t,0,3e0,1u,1,3e1,1t,0,3e2,1u,1,3e3,1t,0,3e4,1u,1,3e5,1t,0,3e6,1u,1,3e7,1t,0,3e8,1u,1,3e9,1t,0,3ea,1u,1,3eb,1t,0,3ec,1u,1,3ed,1t,0,3ee,1u,1,3ef,1t,0,3eg,1u,1,2ds,1t,0,3eh,1g,0,3ei,1v,1,2dt,1g,0,2du,1v,1,2dv,1g,0,2e0,1v,1,2e1,1g,0,2e2,1v,1,2e3,1g,0,2e4,1v,1,2e5,1g,0,2e6,1v,1,2e7,1g,0,2e8,1v,1,2e9,1g,0,ja,1v,1,2ea,1v,1,2eb,1g,0,2ec,1v,1,2ed,1g,0,2ee,1v,1,2ef,1g,0,2eg,1v,1,2eh,1g,0,2ei,1v,1,2ej,1g,0,2ek,1v,1,2el,1g,0,2em,1v,1,2en,1g,0,2eo,1v,1,2ep,1g,0,2eq,1v,1,2er,1g,0,2es,1v,1,2et,1g,0,2eu,1v,1,2ev,1g,0,2f0,1v,1,2f1,1g,0,2f2,1v,1,2f3,1g,0,2f4,1v,1,2f5,1g,0,2f6,1v,1,2f7,1g,0,2f8,1v,1,2f9,1g,0,2fa,1v,1,2fb,1g,0,2fc,1v,1,2fd,1g,0,2fe,1v,1,2ff,1g,0,2fg,1v,1,2fh,1g,0,2fi,1v,1,3ej,1g,0,3ek,1v,1,3el,1g,0,3em,1v,1,3en,1g,0,3eo,1v,1,3ep,1g,0,3eq,1v,1,3er,1g,0,3es,1v,1,3et,1g,0,3eu,1v,1,3ev,1g,0,3f0,1v,1,3f1,1g,0,3f2,1v,1,3f3,1g,0,3f4,1v,1,3f5,1g,0,3f6,1v,1,3f7,1g,0,3f8,1v,1,3f9,1g,0,3fa,1v,1,3fb,1g,0,3fc,1v,1,3fd,1g,0,3fe,1v,1,3ff,1g,0,3fg,1v,1,3fh,1g,0,3fi,1v,1,3fj,1g,0,3fk,1v,1,3fl,1g,0,3fm,1v,1,3fn,1g,0,3fo,1v,1,3fp,1g,0,3fq,1v,1,3fr,1g,0,3fs,1v,1,3ft,1g,0,3fu,1v,1,3fv,1g,0,3g0,2u,1,3g1,1g,0,3g2,1v,1,3g3,1g,0,3g4,1v,1,3g5,1g,0,3g6,1v,1,3g7,1g,0,3g8,1v,1,3g9,1g,0,3ga,1v,1,3gb,1g,0,3gc,1v,1,3gd,1g,0,3ge,1v,1,3gf,1g,0,3gg,1v,1,3gh,1g,0,3gi,1v,1,3gj,1g,0,3gk,1v,1,3gl,1g,0,3gm,1v,1,3gn,1g,0,3go,1v,1,3gp,1g,0,3gq,1v,1,3gr,1g,0,3gs,1v,1,3gt,1g,0,3gu,1v,1,3gv,1g,0,3h0,1v,1,3h1,1g,0,3h2,1v,1,3h3,1g,0,3h4,1v,1,3h5,1g,0,3h6,1v,1,3h7,1g,0,3h8,1v,1,3h9,1g,0,3ha,1v,1,3hb,1g,0,3hc,1v,1,3hd,1g,0,3he,1v,1,3hf,1g,0,3hg,1v,1,3hh,1g,0,3hi,1v,1,3hj,1g,0,3hk,1v,1,3hl,1g,0,3hm,1v,1,3hn,1g,0,3ho,1v,1,3hp,1g,0,3hq,1v,1,3hr,1g,0,3hs,1v,1,3ht,1g,0,3hu,1v,1,3hv,1g,0,3i0,1v,1,3i1,1g,0,3i2,1v,1,3i3,1g,0,3i4,1v,1,3i5,1g,0,3i6,1v,1,3i7,1g,0,3i8,1v,1,3i9,1g,0,3ia,1v,1,3ib,1g,0,3ic,1v,1,3id,1g,0,3ie,1v,1,3if,1g,0,3ig,1v,1,3ih,1g,0,3ii,1v,1,3ij,1g,0,3ik,1v,1,3il,1g,0,3im,1v,1,3in,1g,0,3io,1v,1,3ip,1g,0,3iq,1v,1,3ir,1g,0,3is,1v,1,3it,1g,0,3iu,1v,1,3iv,1g,0,3j0,1v,1,3j1,1g,0,3j2,1v,1,1,1g,0",
        "America/Swift_Current||3j3,2v,0,26j,16,0,222,12,1,1b5,16,0,ja,12,1,1b6,12,1,3j4,16,0,369,12,1,26t,16,0,26u,12,1,36a,16,0,36b,12,1,36c,16,0,36d,12,1,28j,16,0,3j5,12,1,28l,16,0,36m,12,1,28m,16,0,3j6,12,1,2pn,16,0,3j7,12,1,1bh,16,0,1,12,0",
        "America/Tegucigalpa||3j8,30,0,283,12,0,284,13,1,285,12,0,286,13,1,3j9,12,0,3ja,13,1,1,12,0",
        "America/Thule||3jb,v,0,3jc,q,0,3jd,s,1,3je,q,0,3jf,s,1,2av,q,0,2b0,s,1,2b1,q,0,2b2,s,1,2b3,q,0,2b4,s,1,2b5,q,0,2b6,s,1,2b7,q,0,2b8,s,1,2b9,q,0,2ba,s,1,2bb,q,0,2bc,s,1,2bd,q,0,2be,s,1,2bf,q,0,2bg,s,1,2bh,q,0,2bi,s,1,2bj,q,0,2bk,s,1,2bl,q,0,2bm,s,1,2bn,q,0,2bo,s,1,2bp,q,0,2bq,s,1,2br,q,0,2bs,s,1,2bt,q,0,2bu,s,1,2bv,q,0,2c0,s,1,2c1,q,0,2c2,s,1,2c3,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "America/Thunder_Bay||3jg,12,0,22f,13,0,ja,q,1,22g,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,32p,13,0,22o,q,1,22p,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "America/Vancouver,Canada/Pacific||20b,o,0,1b1,16,1,20c,o,0,ja,16,1,20d,16,1,3jh,o,0,3ji,16,1,20e,o,0,20f,16,1,20g,o,0,20h,16,1,20i,o,0,20j,16,1,20k,o,0,20l,16,1,20m,o,0,20n,16,1,20o,o,0,20p,16,1,20q,o,0,20r,16,1,20s,o,0,20t,16,1,20u,o,0,20v,16,1,210,o,0,211,16,1,212,o,0,213,16,1,214,o,0,215,16,1,216,o,0,217,16,1,218,o,0,219,16,1,21a,o,0,21b,16,1,21c,o,0,21d,16,1,21e,o,0,21f,16,1,21g,o,0,21h,16,1,21i,o,0,1sl,16,1,21j,o,0,21k,16,1,21l,o,0,21m,16,1,21n,o,0,21o,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,297,o,0,298,16,1,299,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "America/Whitehorse,Canada/Yukon||1se,n,0,1sf,o,1,1sg,n,0,1sh,o,1,1si,n,0,ja,o,1,1sj,o,1,1sk,n,0,1sl,16,1,3jj,n,0,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "America/Winnipeg,Canada/Central||3jk,12,0,3jl,13,1,14c,12,0,14d,13,1,3jm,12,0,1kc,13,1,14f,12,0,ja,13,1,14g,13,1,3jn,12,0,3jo,13,1,1kn,12,0,1ko,13,1,1kp,12,0,1kq,13,1,1kr,12,0,1ks,13,1,3jp,12,0,3jq,13,1,1kv,12,0,1l0,13,1,1l1,12,0,1l2,13,1,1l3,12,0,1l4,13,1,1l5,12,0,1l6,13,1,1l7,12,0,2o8,13,1,1l9,12,0,2o9,13,1,1lb,12,0,29c,13,1,1ld,12,0,2o7,13,1,1lf,12,0,1lg,13,1,1lh,12,0,2ob,13,1,1ln,12,0,3jr,13,1,1ls,12,0,22b,13,1,1lu,12,0,1b8,13,1,1m0,12,0,1ba,13,1,1m2,12,0,1bc,13,1,1m4,12,0,1be,13,1,1m6,12,0,1bg,13,1,1m8,12,0,1bi,13,1,1ma,12,0,1bk,13,1,35m,12,0,1bm,13,1,35n,12,0,1bo,13,1,1mg,12,0,1bq,13,1,1mi,12,0,1bs,13,1,1mk,12,0,1bu,13,1,1mm,12,0,1c0,13,1,1mo,12,0,1c2,13,1,1mq,12,0,1c4,13,1,1ms,12,0,1c6,13,1,1mu,12,0,1c8,13,1,1n0,12,0,1ca,13,1,1n2,12,0,1cc,13,1,1n4,12,0,1ce,13,1,1n6,12,0,1cg,13,1,1n8,12,0,1ci,13,1,1na,12,0,1ck,13,1,1nc,12,0,1cm,13,1,1ne,12,0,1co,13,1,1ng,12,0,1cq,13,1,1ni,12,0,1cs,13,1,1nk,12,0,1cu,13,1,1nm,12,0,1d0,13,1,1no,12,0,156,13,1,1nq,12,0,158,13,1,1ns,12,0,15a,13,1,1ib,12,0,15c,13,1,1f4,12,0,15e,13,1,1nt,12,0,1d2,13,1,1if,12,0,15i,13,1,1ih,12,0,15k,13,1,1ij,12,0,15m,13,1,1il,12,0,15o,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "America/Yakutat||1si,n,0,ja,o,1,1sj,o,1,3js,n,0,3jt,o,1,3ju,n,0,3jv,o,1,3k0,n,0,3k1,o,1,3k2,n,0,3k3,o,1,3k4,n,0,3k5,o,1,3k6,n,0,3k7,o,1,3k8,n,0,3k9,o,1,3ka,n,0,3kb,o,1,3kc,n,0,3kd,o,1,3ke,n,0,3kf,o,1,3kg,n,0,3kh,o,1,3ki,n,0,2oo,o,1,3kj,n,0,3kk,o,1,3kl,n,0,3km,o,1,3kn,n,0,3ko,o,1,op,n,0,oq,n,0,or,o,1,os,n,0,ot,o,1,ou,n,0,ov,o,1,p0,n,0,p1,o,1,p2,n,0,p3,o,1,p4,n,0,p5,o,1,p6,n,0,p7,o,1,p8,n,0,p9,o,1,pa,n,0,pb,o,1,pc,n,0,pd,o,1,pe,n,0,pf,o,1,pg,n,0,ph,o,1,pi,n,0,pj,o,1,pk,n,0,pl,o,1,pm,n,0,pn,o,1,po,n,0,pp,o,1,pq,n,0,pr,o,1,ps,n,0,pt,o,1,pu,n,0,pv,o,1,q0,n,0,q1,o,1,q2,n,0,q3,o,1,q4,n,0,q5,o,1,q6,n,0,q7,o,1,q8,n,0,q9,o,1,qa,n,0,qb,o,1,qc,n,0,qd,o,1,qe,n,0,qf,o,1,qg,n,0,qh,o,1,qi,n,0,qj,o,1,qk,n,0,ql,o,1,qm,n,0,qn,o,1,qo,n,0,qp,o,1,qq,n,0,qr,o,1,qs,n,0,qt,o,1,qu,n,0,qv,o,1,r0,n,0,r1,o,1,r2,n,0,r3,o,1,r4,n,0,r5,o,1,r6,n,0,r7,o,1,r8,n,0,r9,o,1,ra,n,0,rb,o,1,rc,n,0,rd,o,1,re,n,0,rf,o,1,rg,n,0,rh,o,1,ri,n,0,rj,o,1,rk,n,0,rl,o,1,rm,n,0,rn,o,1,ro,n,0,rp,o,1,rq,n,0,rr,o,1,rs,n,0,rt,o,1,ru,n,0,rv,o,1,s0,n,0,s1,o,1,s2,n,0,s3,o,1,s4,n,0,s5,o,1,1,n,0",
        "America/Yellowknife||3kp,1,0,1b5,16,0,ja,12,1,1b6,12,1,1f2,16,0,1f3,13,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "Antarctica/Casey||3kq,1,0,3kr,31,0,3ks,32,0,3kt,31,0,3ku,32,0,3kv,31,0,1,32,0",
        "Antarctica/Davis||3l0,1,0,3l1,33,0,3l2,1,0,3l3,33,0,3l4,34,0,3l5,33,0,3l6,34,0,1,33,0",
        "Antarctica/DumontDUrville||3l7,1,0,3l8,35,0,3l9,1,0,1,35,0",
        "Antarctica/Macquarie||3la,35,0,3lb,32,1,3lc,35,0,3ld,1,0,3le,35,0,3lf,32,1,3lg,35,0,3lh,32,1,3li,35,0,3lj,32,1,3lk,35,0,3ll,32,1,3lm,35,0,3ln,32,1,3lo,35,0,3lp,32,1,3lq,35,0,3lr,32,1,3ls,35,0,3lt,32,1,3lu,35,0,3lv,32,1,3m0,35,0,3m1,32,1,3m2,35,0,3m3,32,1,3m4,35,0,3m5,32,1,3m6,35,0,3m7,32,1,3m8,35,0,3m9,32,1,3ma,35,0,3mb,32,1,3mc,35,0,3md,32,1,3me,35,0,3mf,32,1,3mg,35,0,3mh,32,1,3mi,35,0,3mj,32,1,3mk,35,0,3ml,32,1,3mm,35,0,3mn,32,1,3mo,35,0,3mp,32,1,3mq,35,0,3mr,32,1,3ms,35,0,3mt,32,1,3mu,35,0,3mv,32,1,3n0,35,0,3n1,32,1,3n2,35,0,3n3,32,1,3n4,35,0,3n5,32,1,3n6,35,0,3n7,32,1,3n8,35,0,3n9,32,1,3na,35,0,3nb,32,1,3nc,35,0,3nd,32,1,3ne,35,0,3nf,32,1,3ng,35,0,3nh,32,1,3ni,35,0,3nj,32,1,3nk,35,0,3nl,32,1,3nm,35,0,3nn,32,1,3no,35,0,3np,32,1,3nq,35,0,3nr,32,1,3ns,35,0,3nt,32,1,3nu,35,0,3nv,32,1,3o0,35,0,3o1,32,1,3o2,35,0,3o3,32,1,1,32,0",
        "Antarctica/Mawson||3o4,1,0,3o5,36,0,1,34,0",
        "Antarctica/McMurdo,Antarctica/South_Pole,NZ,Pacific/Auckland||3o6,37,0,3o7,38,1,3o8,37,0,3o9,39,1,3oa,37,0,3ob,39,1,3oc,37,0,3od,39,1,3oe,37,0,3of,39,1,3og,37,0,3oh,39,1,3oi,37,0,3oj,39,1,3ok,37,0,3ol,39,1,3om,37,0,3on,39,1,3oo,37,0,3op,39,1,3oq,37,0,3or,39,1,3os,37,0,3ot,39,1,3ou,37,0,3ov,39,1,3p0,37,0,3p1,39,0,3p2,3a,1,3p3,39,0,3p4,3a,1,3p5,39,0,3p6,3a,1,3p7,39,0,3p8,3a,1,3p9,39,0,3pa,3a,1,3pb,39,0,3pc,3a,1,3pd,39,0,3pe,3a,1,3pf,39,0,3pg,3a,1,3ph,39,0,3pi,3a,1,3pj,39,0,3pk,3a,1,3pl,39,0,3pm,3a,1,3pn,39,0,3po,3a,1,3pp,39,0,3pq,3a,1,3pr,39,0,3ps,3a,1,3pt,39,0,3pu,3a,1,3pv,39,0,3q0,3a,1,3q1,39,0,3q2,3a,1,3q3,39,0,3q4,3a,1,3q5,39,0,3q6,3a,1,3q7,39,0,3q8,3a,1,3q9,39,0,3qa,3a,1,3qb,39,0,3qc,3a,1,3qd,39,0,3qe,3a,1,3qf,39,0,3qg,3a,1,3qh,39,0,3qi,3a,1,3qj,39,0,3qk,3a,1,3ql,39,0,3qm,3a,1,3qn,39,0,3qo,3a,1,3qp,39,0,3qq,3a,1,3qr,39,0,3qs,3a,1,3qt,39,0,3qu,3a,1,3qv,39,0,3r0,3a,1,3r1,39,0,3r2,3a,1,3r3,39,0,3r4,3a,1,3r5,39,0,3r6,3a,1,3r7,39,0,3r8,3a,1,3r9,39,0,3ra,3a,1,3rb,39,0,3rc,3a,1,3rd,39,0,3re,3a,1,3rf,39,0,3rg,3a,1,3rh,39,0,3ri,3a,1,3rj,39,0,3rk,3a,1,3rl,39,0,3rm,3a,1,3rn,39,0,3ro,3a,1,3rp,39,0,3rq,3a,1,3rr,39,0,3rs,3a,1,3rt,39,0,3ru,3a,1,3rv,39,0,3s0,3a,1,3s1,39,0,3s2,3a,1,3s3,39,0,3s4,3a,1,3s5,39,0,3s6,3a,1,3s7,39,0,3s8,3a,1,3s9,39,0,3sa,3a,1,3sb,39,0,3sc,3a,1,3sd,39,0,3se,3a,1,3sf,39,0,3sg,3a,1,3sh,39,0,3si,3a,1,3sj,39,0,3sk,3a,1,3sl,39,0,3sm,3a,1,3sn,39,0,3so,3a,1,3sp,39,0,3sq,3a,1,3sr,39,0,3ss,3a,1,3st,39,0,3su,3a,1,3sv,39,0,1,3a,1",
        "Antarctica/Palmer||3t0,1,0,uq,s,1,ur,q,0,us,s,1,ut,q,0,uu,s,1,uv,q,0,v0,s,1,v1,q,0,v2,s,1,v3,q,0,v4,s,0,v5,t,1,3t1,s,0,2lt,q,0,386,s,1,2lv,q,0,387,s,1,2m1,q,0,388,s,1,2m3,q,0,389,s,1,2m5,q,0,38a,s,1,2m7,q,0,38b,s,1,2m9,q,0,38c,s,1,1fa,q,0,38d,s,1,38e,q,0,38f,s,1,38g,q,0,38h,s,1,38i,q,0,38j,s,1,38k,q,0,38l,s,1,38m,q,0,38n,s,1,1fl,q,0,38o,s,1,38p,q,0,38q,s,1,38r,q,0,38s,s,1,38t,q,0,38u,s,1,38v,q,0,390,s,1,391,q,0,392,s,1,1fs,q,0,393,s,1,394,q,0,395,s,1,396,q,0,397,s,1,398,q,0,12c,s,1,399,q,0,12e,s,1,12f,q,0,12g,s,1,1g7,q,0,39a,s,1,109,q,0,39b,s,1,10b,q,0,39c,s,1,39d,q,0,39e,s,1,39f,q,0,39g,s,1,39h,q,0,39i,s,1,39j,q,0,39k,s,1,39l,q,0,39m,s,1,39n,q,0,39o,s,1,39p,q,0,39q,s,1,39r,q,0,39s,s,1,39t,q,0,39u,s,1,39v,q,0,3a0,s,1,3a1,q,0,3a2,s,1,3a3,q,0,3a4,s,1,3a5,q,0,3a6,s,1,3a7,q,0,3a8,s,1,3a9,q,0,3aa,s,1,3ab,q,0,3ac,s,1,3ad,q,0,3ae,s,1,3af,q,0,3ag,s,1,3ah,q,0,3ai,s,1,3aj,q,0,3ak,s,1,3al,q,0,3am,s,1,3an,q,0,3ao,s,1,3ap,q,0,3aq,s,1,3ar,q,0,3as,s,1,3at,q,0,3au,s,1,3av,q,0,3b0,s,1,3b1,q,0,1,s,1",
        "Antarctica/Rothera||3t2,1,0,1,s,0",
        "Antarctica/Syowa||3t3,1,0,1,5,0",
        "Antarctica/Troll||3t4,1,0,bb,1,0,bc,a,1,bd,1,0,be,a,1,bf,1,0,bg,a,1,bh,1,0,bi,a,1,bj,1,0,bk,a,1,bl,1,0,bm,a,1,bn,1,0,bo,a,1,bp,1,0,bq,a,1,br,1,0,bs,a,1,bt,1,0,bu,a,1,bv,1,0,c0,a,1,c1,1,0,c2,a,1,c3,1,0,c4,a,1,c5,1,0,c6,a,1,c7,1,0,c8,a,1,c9,1,0,ca,a,1,cb,1,0,cc,a,1,cd,1,0,ce,a,1,cf,1,0,cg,a,1,ch,1,0,ci,a,1,cj,1,0,ck,a,1,cl,1,0,cm,a,1,cn,1,0,co,a,1,cp,1,0,cq,a,1,cr,1,0,cs,a,1,ct,1,0,cu,a,1,cv,1,0,d0,a,1,d1,1,0,d2,a,1,d3,1,0,d4,a,1,d5,1,0,d6,a,1,d7,1,0,d8,a,1,d9,1,0,da,a,1,db,1,0,dc,a,1,1,1,0",
        "Antarctica/Vostok||3t5,1,0,1,36,0",
        "Arctic/Longyearbyen,Atlantic/Jan_Mayen,Europe/Oslo||3t6,9,0,3t7,a,1,3t8,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,3tb,a,1,3tc,9,0,3td,a,1,3te,9,0,3tf,a,1,3tg,9,0,3th,a,1,3ti,9,0,3tj,a,1,3tk,9,0,3tl,a,1,3tm,9,0,3tn,a,1,3to,9,0,3tp,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Asia/Aden,Asia/Kuwait,Asia/Riyadh||3tr,3b,0,1,5,0",
        "Asia/Almaty||3ts,3c,0,3tt,34,0,3tu,36,0,3tv,33,1,3u0,36,0,3u1,33,1,3u2,36,0,3u3,33,1,3u4,36,0,3u5,33,1,3u6,36,0,3u7,33,1,3u8,36,0,3u9,33,1,3ua,36,0,3ub,33,1,3uc,36,0,3ud,33,1,3ue,36,0,3uf,33,1,3ug,36,0,3uh,33,1,3ui,36,1,3uj,34,0,3uk,36,0,3ul,33,1,3um,36,0,3un,33,1,3uo,36,0,3up,33,1,3uq,36,0,3ur,33,1,3us,36,0,3ut,33,1,3uu,36,0,3uv,33,1,3v0,36,0,3v1,33,1,3v2,36,0,3v3,33,1,3v4,36,0,3v5,33,1,3v6,36,0,3v7,33,1,3v8,36,0,3v9,33,1,3va,36,0,3vb,33,1,3vc,36,0,3vd,33,1,1,36,0",
        "Asia/Amman||3ve,3d,0,3vf,a,0,3vg,5,1,3vh,a,0,3vi,5,1,3vj,a,0,3vk,5,1,3vl,a,0,3vm,5,1,3vn,a,0,3vo,5,1,e5,a,0,3vp,5,1,3vq,a,0,3vr,5,1,3vs,a,0,3vt,5,1,3vu,a,0,3vv,5,1,400,a,0,401,5,1,402,a,0,403,5,1,404,a,0,405,5,1,406,a,0,407,5,1,408,a,0,409,5,1,40a,a,0,40b,5,1,40c,a,0,40d,5,1,40e,a,0,40f,5,1,40g,a,0,40h,5,1,40i,a,0,40j,5,1,40k,a,0,40l,5,1,40m,a,0,40n,5,1,40o,a,0,40p,5,1,40q,a,0,40r,5,1,40s,a,0,40t,5,1,40u,a,0,40v,5,1,410,a,0,411,5,1,412,a,0,413,5,1,414,a,0,415,5,1,416,a,0,417,5,1,418,a,0,419,5,1,41a,a,0,41b,5,1,41c,a,0,41d,5,1,41e,a,0,41f,5,1,41g,a,0,41h,5,1,41i,a,0,41j,5,1,41k,a,0,41l,5,1,41m,a,0,41n,5,1,41o,a,0,41p,5,1,41q,a,0,41r,5,1,41s,a,0,41t,5,1,41u,a,0,41v,5,1,420,a,0,421,5,1,422,a,0,423,5,1,424,a,0,425,5,1,426,a,0,427,5,1,428,a,0,429,5,1,42a,a,0,42b,5,1,42c,a,0,42d,5,1,42e,a,0,42f,5,1,42g,a,0,42h,5,1,42i,a,0,42j,5,1,42k,a,0,42l,5,1,42m,a,0,42n,5,1,42o,a,0,42p,5,1,42q,a,0,42r,5,1,42s,a,0,42t,5,1,42u,a,0,42v,5,1,430,a,0,431,5,1,1,a,0",
        "Asia/Anadyr||432,3e,0,433,39,0,434,3a,0,435,3f,1,436,3a,1,437,39,0,438,3a,1,439,39,0,43a,3a,1,43b,39,0,43c,3a,1,43d,39,0,43e,3a,1,43f,39,0,43g,3a,1,43h,39,0,43i,3a,1,43j,39,0,43k,3a,1,43l,39,0,43m,3a,1,43n,39,1,43o,32,0,43p,39,0,43q,3a,1,43r,39,0,43s,3a,1,43t,39,0,43u,3a,1,43v,39,0,440,3a,1,441,39,0,442,3a,1,443,39,0,444,3a,1,445,39,0,446,3a,1,447,39,0,448,3a,1,449,39,0,44a,3a,1,44b,39,0,44c,3a,1,44d,39,0,44e,3a,1,44f,39,0,44g,3a,1,44h,39,0,44i,3a,1,44j,39,0,44k,3a,1,44l,39,0,44m,3a,1,44n,39,0,44o,3a,1,44p,39,0,44q,3a,1,44r,39,0,44s,3a,1,44t,39,1,44u,32,0,1,39,0",
        "Asia/Aqtau||44v,3g,0,450,3h,0,451,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,45j,34,1,45k,3h,0,45l,34,0,45m,36,1,45n,34,0,45o,36,1,45p,34,0,45q,36,1,45r,3h,0,45s,34,1,45t,3h,0,45u,34,1,45v,3h,0,460,34,1,461,3h,0,462,34,1,463,3h,0,464,34,1,465,3h,0,466,34,1,467,3h,0,468,34,1,469,3h,0,46a,34,1,46b,3h,0,46c,34,1,46d,3h,0,1,34,0",
        "Asia/Aqtobe||46e,3i,0,450,3h,0,46f,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,45j,34,1,45k,3h,0,45l,34,0,45m,36,1,45n,34,0,45o,36,1,45p,34,0,45q,36,1,46g,34,0,46h,36,1,46i,34,0,46j,36,1,46k,34,0,46l,36,1,46m,34,0,46n,36,1,46o,34,0,46p,36,1,46q,34,0,46r,36,1,46s,34,0,46t,36,1,46u,34,0,46v,36,1,470,34,0,471,36,1,472,34,0,473,36,1,1,34,0",
        "Asia/Ashgabat,Asia/Ashkhabad||474,3j,0,450,3h,0,46f,34,0,475,36,1,476,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,45j,34,1,45k,3h,0,1,34,0",
        "Asia/Atyrau||477,3k,0,450,3h,0,451,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,45j,34,1,45k,3h,0,45l,34,0,45m,36,1,45n,34,0,45o,36,1,45p,34,0,45q,36,1,46g,34,0,46h,36,1,46i,34,0,46j,36,1,46k,34,0,46l,36,1,46m,34,0,46n,36,1,464,34,1,465,3h,0,466,34,1,467,3h,0,468,34,1,469,3h,0,46a,34,1,46b,3h,0,46c,34,1,46d,3h,0,1,34,0",
        "Asia/Baghdad||478,3l,0,479,5,0,47a,3h,1,47b,5,0,47c,3h,1,47d,5,0,47e,3h,1,47f,5,0,47g,3h,1,47h,5,0,47i,3h,1,47j,5,0,47k,3h,1,47l,5,0,47m,3h,1,47n,5,0,47o,3h,1,47p,5,0,47q,3h,1,47r,5,0,5b,3h,1,47s,5,0,5d,3h,1,47t,5,0,5f,3h,1,47u,5,0,5h,3h,1,47v,5,0,480,3h,1,481,5,0,482,3h,1,483,5,0,484,3h,1,485,5,0,486,3h,1,487,5,0,488,3h,1,489,5,0,48a,3h,1,h0,5,0,48b,3h,1,48c,5,0,48d,3h,1,48e,5,0,48f,3h,1,48g,5,0,48h,3h,1,48i,5,0,48j,3h,1,48k,5,0,48l,3h,1,hc,5,0,48m,3h,1,1,5,0",
        "Asia/Bahrain,Asia/Qatar||48n,3m,0,48o,3h,0,1,5,0",
        "Asia/Baku||48p,3n,0,48q,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,47n,3h,0,47o,34,1,47p,3h,0,47q,34,1,493,3h,1,494,5,0,ap,3h,0,aq,34,1,495,3h,0,496,34,1,497,3h,0,498,34,1,499,3h,0,49a,34,1,49b,3h,0,49c,34,1,49d,3h,0,49e,34,1,49f,3h,0,49g,34,1,49h,3h,0,49i,34,1,49j,3h,0,49k,34,1,49l,3h,0,49m,34,1,49n,3h,0,49o,34,1,49p,3h,0,49q,34,1,49r,3h,0,49s,34,1,49t,3h,0,49u,34,1,49v,3h,0,4a0,34,1,4a1,3h,0,4a2,34,1,4a3,3h,0,4a4,34,1,4a5,3h,0,4a6,34,1,4a7,3h,0,4a8,34,1,4a9,3h,0,4aa,34,1,1,3h,0",
        "Asia/Bangkok,Asia/Phnom_Penh,Asia/Vientiane||4ab,3o,0,1,33,0",
        "Asia/Barnaul||4ac,3p,0,4ad,36,0,4ae,33,0,4af,31,1,4ag,33,0,4ah,31,1,4ai,33,0,4aj,31,1,4ak,33,0,4al,31,1,4am,33,0,4an,31,1,4ao,33,0,4ap,31,1,4aq,33,0,4ar,31,1,4as,33,0,4at,31,1,4au,33,0,4av,31,1,4b0,33,0,4b1,31,1,4b2,33,1,4b3,36,0,4b4,33,0,4b5,31,1,4b6,33,0,4b7,31,1,4b8,33,0,4b9,31,1,4ba,33,0,4bb,31,1,3ur,33,1,3us,36,0,3ut,33,1,3uu,36,0,3uv,33,1,3v0,36,0,3v1,33,1,3v2,36,0,3v3,33,1,3v4,36,0,3v5,33,1,3v6,36,0,3v7,33,1,3v8,36,0,3v9,33,1,3va,36,0,3vb,33,1,3vc,36,0,3vd,33,1,4bc,36,0,4bd,33,1,4be,36,0,4bf,33,1,4bg,36,0,4bh,33,1,4bi,36,0,4bj,33,1,4bk,36,0,4bl,33,1,4bm,36,0,4bn,33,1,4bo,36,0,4bp,33,0,4bq,36,0,1,33,0",
        "Asia/Beirut||4br,a,0,4bs,5,1,4bt,a,0,4bu,5,1,4bv,a,0,4c0,5,1,4c1,a,0,4c2,5,1,4c3,a,0,37,5,1,38,a,0,39,5,1,4c4,a,0,4c5,5,1,4c6,a,0,4c7,5,1,4c8,a,0,4c9,5,1,4ca,a,0,4cb,5,1,4cc,a,0,3vg,5,1,3vh,a,0,3vi,5,1,3vj,a,0,3vk,5,1,3vl,a,0,4cd,5,1,3vn,a,0,3vo,5,1,e5,a,0,3vp,5,1,4ce,a,0,4cf,5,1,4cg,a,0,4ch,5,1,4ci,a,0,4cj,5,1,4ck,a,0,4cl,5,1,4cm,a,0,4cn,5,1,4co,a,0,4cp,5,1,4cq,a,0,4cr,5,1,4cs,a,0,4ct,5,1,4cu,a,0,4cv,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,4d2,5,1,45v,a,0,4d3,5,1,461,a,0,4d4,5,1,463,a,0,46p,5,1,465,a,0,46r,5,1,467,a,0,46t,5,1,469,a,0,46v,5,1,46b,a,0,471,5,1,46d,a,0,473,5,1,4d5,a,0,4d6,5,1,4d7,a,0,4d8,5,1,4d9,a,0,4da,5,1,4db,a,0,4dc,5,1,4dd,a,0,4de,5,1,4df,a,0,4dg,5,1,4dh,a,0,4di,5,1,4dj,a,0,4dk,5,1,4dl,a,0,4dm,5,1,4dn,a,0,4do,5,1,4dp,a,0,4dq,5,1,4dr,a,0,4ds,5,1,4dt,a,0,4du,5,1,4dv,a,0,4e0,5,1,4e1,a,0,4e2,5,1,4e3,a,0,4e4,5,1,4e5,a,0,4e6,5,1,4e7,a,0,4e8,5,1,4e9,a,0,4ea,5,1,4eb,a,0,4ec,5,1,4ed,a,0,4ee,5,1,4ef,a,0,4eg,5,1,4eh,a,0,4ei,5,1,4ej,a,0,4ek,5,1,4el,a,0,4em,5,1,4en,a,0,4eo,5,1,4ep,a,0,4eq,5,1,4er,a,0,4es,5,1,4et,a,0,4eu,5,1,4ev,a,0,4f0,5,1,4f1,a,0,4f2,5,1,4f3,a,0,4f4,5,1,4f5,a,0,4f6,5,1,1,a,0",
        "Asia/Bishkek||4f7,3q,0,3tt,34,0,3tu,36,0,3tv,33,1,3u0,36,0,3u1,33,1,3u2,36,0,3u3,33,1,3u4,36,0,3u5,33,1,3u6,36,0,3u7,33,1,3u8,36,0,3u9,33,1,3ua,36,0,3ub,33,1,3uc,36,0,3ud,33,1,3ue,36,0,3uf,33,1,3ug,36,0,3uh,33,1,4f8,36,1,4f9,34,0,4fa,36,1,4fb,34,0,4fc,36,1,4fd,34,0,4fe,36,1,4ff,34,0,4fg,36,1,4fh,34,0,4fi,36,1,4fj,34,0,4fk,36,1,4fl,34,0,4fm,36,1,4fn,34,0,4fo,36,1,4fp,34,0,4fq,36,1,4fr,34,0,4fs,36,1,4ft,34,0,4fu,36,1,4fv,34,0,4g0,36,1,4g1,34,0,4g2,36,1,4g3,34,0,1,36,0",
        "Asia/Brunei||4g4,3r,0,4g5,3s,0,1,31,0",
        "Asia/Calcutta,Asia/Kolkata||4g6,3t,0,4g7,3u,0,4g8,3v,0,4g9,3u,1,1,3v,0",
        "Asia/Chita||4ga,40,0,4gb,31,0,4gc,41,0,4gd,35,1,4ge,41,0,4gf,35,1,4gg,41,0,4gh,35,1,4gi,41,0,4gj,35,1,4gk,41,0,4gl,35,1,4gm,41,0,4gn,35,1,4go,41,0,4gp,35,1,4gq,41,0,4gr,35,1,4gs,41,0,4gt,35,1,4gu,41,0,4gv,35,1,4h0,41,1,4h1,31,0,4h2,41,0,4h3,35,1,4h4,41,0,4h5,35,1,4h6,41,0,4h7,35,1,4h8,41,0,4h9,35,1,4ha,41,0,4hb,35,1,4hc,41,0,4hd,35,1,4he,41,0,4hf,35,1,4hg,41,0,4hh,35,1,4hi,41,0,4hj,35,1,4hk,41,0,4hl,35,1,4hm,41,0,4hn,35,1,4ho,41,0,4hp,35,1,4hq,41,0,4hr,35,1,4hs,41,0,4ht,35,1,4hu,41,0,4hv,35,1,4i0,41,0,4i1,35,1,4i2,41,0,4i3,35,1,4i4,41,0,4i5,35,1,4i6,41,0,4i7,35,1,4i8,41,0,4i9,35,0,4ia,31,0,1,41,0",
        "Asia/Choibalsan||4ib,42,0,4ic,33,0,4id,31,0,4gh,35,1,4gi,41,0,43a,35,1,4ie,41,0,43c,35,1,4if,41,0,43e,35,1,4ig,41,0,43g,35,1,4ih,41,0,43i,35,1,4ii,41,0,43k,35,1,4ij,41,0,43m,35,1,4ik,41,0,4il,35,1,4im,41,0,43q,35,1,4in,41,0,43s,35,1,4io,41,0,43u,35,1,4ip,41,0,440,35,1,4iq,41,0,4ir,35,1,4is,41,0,4it,35,1,4iu,41,0,4iv,35,1,4j0,41,0,4j1,35,1,4j2,41,0,4j3,35,1,4j4,41,0,4j5,35,1,4j6,41,0,4j7,35,1,4j8,41,0,4j9,35,1,4ja,41,0,4jb,35,1,4jc,41,0,4jd,31,0,4je,41,1,4jf,31,0,4jg,41,1,4jh,31,0,4ji,41,1,4jj,31,0,4jk,41,1,4jl,31,0,4jm,41,1,4jn,31,0,4jo,41,1,4jp,31,0,4jq,41,1,4jr,31,0,4js,41,1,4jt,31,0,4ju,41,1,4jv,31,0,4k0,41,1,4k1,31,0,4k2,41,1,4k3,31,0,4k4,41,1,4k5,31,0,4k6,41,1,4k7,31,0,4k8,41,1,4k9,31,0,4ka,41,1,4kb,31,0,4kc,41,1,4kd,31,0,4ke,41,1,4kf,31,0,4kg,41,1,4kh,31,0,4ki,41,1,4kj,31,0,4kk,41,1,4kl,31,0,4km,41,1,4kn,31,0,4ko,41,1,4kp,31,0,4kq,41,1,1,31,0",
        "Asia/Chongqing,Asia/Chungking,Asia/Harbin,Asia/Shanghai,PRC||4kr,31,0,4ks,41,1,4kt,31,0,4ku,41,1,4kv,31,0,4l0,41,1,4l1,31,0,4l2,41,1,4l3,31,0,4l4,41,1,4l5,31,0,4l6,41,1,4l7,31,0,4l8,41,1,4l9,31,0,4la,41,1,1,31,0",
        "Asia/Colombo||4lb,43,0,4lc,3v,0,4ld,36,1,4le,3u,1,4lf,3v,0,4lg,3u,0,4lh,36,0,1,3v,0",
        "Asia/Dacca,Asia/Dhaka||4g6,3t,0,4g7,3u,0,4g8,3v,0,4li,3u,0,4lj,36,0,4lk,36,0,4ll,33,1,1,36,0",
        "Asia/Damascus||4lm,44,0,4ln,a,0,4lo,5,1,4lp,a,0,4lq,5,1,4lr,a,0,4ls,5,1,4lt,a,0,4lu,5,1,4lv,a,0,4m0,5,1,4m1,a,0,4m2,5,1,4m3,a,0,4m4,5,1,4m5,a,0,4m6,5,1,4m7,a,0,4m8,5,1,4m9,a,0,70,5,1,4ma,a,0,4mb,5,1,4mc,a,0,4md,5,1,4me,a,0,4mf,5,1,4mg,a,0,4mh,5,1,4mi,a,0,4mj,5,1,4mk,a,0,4ml,5,1,4mm,a,0,4mn,5,1,4mo,a,0,4mp,5,1,73,a,0,4mq,5,1,75,a,0,4mr,5,1,4ms,a,0,4mt,5,1,4mu,a,0,4mv,5,1,4n0,a,0,4n1,5,1,4n2,a,0,4n3,5,1,4n4,a,0,4n5,5,1,4n6,a,0,4n7,5,1,4n8,a,0,4n9,5,1,4na,a,0,ge,5,1,4nb,a,0,4nc,5,1,4nd,a,0,4ne,5,1,4nf,a,0,4ng,5,1,40c,a,0,4nh,5,1,4ni,a,0,4nj,5,1,4nk,a,0,4nl,5,1,4nm,a,0,4nn,5,1,4no,a,0,4np,5,1,4nq,a,0,5r,5,1,4nr,a,0,4ns,5,1,4nt,a,0,4nu,5,1,4nv,a,0,4o0,5,1,4o1,a,0,4o2,5,1,4o3,a,0,65,5,1,412,a,0,4o4,5,1,4o5,a,0,69,5,1,416,a,0,4o6,5,1,4o7,a,0,4o8,5,1,41a,a,0,4o9,5,1,4oa,a,0,4ob,5,1,41e,a,0,4oc,5,1,41g,a,0,4od,5,1,4oe,a,0,4of,5,1,41i,a,0,4og,5,1,41k,a,0,4oh,5,1,4oi,a,0,4oj,5,1,41o,a,0,4ok,5,1,41q,a,0,4ol,5,1,41s,a,0,4om,5,1,41u,a,0,4on,5,1,420,a,0,4oo,5,1,4op,a,0,4oq,5,1,424,a,0,4or,5,1,426,a,0,4os,5,1,428,a,0,4ot,5,1,42a,a,0,4ou,5,1,42c,a,0,4ov,5,1,42e,a,0,4p0,5,1,42g,a,0,4p1,5,1,42i,a,0,4p2,5,1,42k,a,0,4p3,5,1,42m,a,0,4p4,5,1,4p5,a,0,4p6,5,1,42q,a,0,4p7,5,1,42s,a,0,4p8,5,1,42u,a,0,4p9,5,1,430,a,0,4pa,5,1,1,a,0",
        "Asia/Dili||4pb,45,0,4pc,31,0,4pd,41,0,4pe,41,0,4pf,31,0,1,41,0",
        "Asia/Dubai,Asia/Muscat||4pg,46,0,1,3h,0",
        "Asia/Dushanbe||4ph,47,0,3tt,34,0,3tu,36,0,3tv,33,1,3u0,36,0,3u1,33,1,3u2,36,0,3u3,33,1,3u4,36,0,3u5,33,1,3u6,36,0,3u7,33,1,3u8,36,0,3u9,33,1,3ua,36,0,3ub,33,1,3uc,36,0,3ud,33,1,3ue,36,0,3uf,33,1,3ug,36,0,3uh,33,1,4pi,36,1,1,34,0",
        "Asia/Famagusta||4pj,48,0,4pk,a,0,4pl,5,1,4pm,a,0,4pn,5,1,4po,a,0,4pp,5,1,4pq,a,0,4pr,5,1,4ps,a,0,4pt,5,1,4pu,a,0,4pv,5,1,4q0,a,0,4q1,5,1,4q2,a,0,4q3,5,1,4q4,a,0,4q5,5,1,4q6,a,0,456,5,1,492,a,0,458,5,1,47h,a,0,45a,5,1,47j,a,0,45c,5,1,47l,a,0,45e,5,1,47n,a,0,45g,5,1,47p,a,0,45i,5,1,4q7,a,0,3ui,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,4d2,5,1,45v,a,0,4d3,5,1,461,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,4q9,5,1,1,5,0",
        "Asia/Gaza||4qa,a,0,4qb,5,1,4qc,a,0,31,5,1,32,a,0,33,5,1,34,a,0,4qd,5,1,4qe,a,0,4qf,5,1,36,a,0,37,5,1,38,a,0,39,5,1,3a,a,0,3b,5,1,3c,a,0,3d,5,1,3e,a,0,3f,5,1,3g,a,0,3h,5,1,3i,a,0,3j,5,1,3k,a,0,3l,5,1,3m,a,0,3n,5,1,3o,a,0,3p,5,1,3q,a,0,4qg,5,1,4qh,a,0,4qi,5,1,4qj,a,0,4qk,5,1,4ql,a,0,4qm,5,1,4qn,a,0,4qo,5,1,4qp,a,0,4qq,5,1,4qr,a,0,4qs,5,1,4qt,a,0,4qu,5,1,47p,a,0,4qv,5,1,4r0,a,0,4r1,5,1,4q8,a,0,4r2,5,1,40a,a,0,4r3,5,1,40c,a,0,4r4,5,1,4r5,a,0,4r6,5,1,4r7,a,0,40g,a,0,40h,5,1,40i,a,0,40j,5,1,40k,a,0,40l,5,1,4r8,a,0,4r9,5,1,4ra,a,0,4rb,5,1,4rc,a,0,4rd,5,1,4re,a,0,4rf,5,1,4rg,a,0,4rh,5,1,4ri,a,0,4rj,5,1,4rk,a,0,4rl,5,1,4o5,a,0,69,5,1,4rm,a,0,4rn,5,1,418,a,0,6d,5,1,41a,a,0,4ro,5,1,4rp,a,0,6h,5,1,4rq,a,0,4rr,5,1,41g,a,0,4rs,5,1,4oe,a,0,4rt,5,1,41i,a,0,4ru,5,1,4rv,a,0,4s0,5,1,4s1,a,0,4s2,5,1,4s3,a,0,4s4,5,1,4s5,a,0,4s6,5,1,4s7,a,0,4s8,5,1,4s9,a,0,4sa,5,1,4sb,a,0,4sc,5,1,4sd,a,0,4se,5,1,4sf,a,0,4sg,5,1,4sh,a,0,4si,5,1,4sj,a,0,4sk,5,1,4sl,a,0,4sm,5,1,4sn,a,0,4so,5,1,4sp,a,0,4sq,5,1,4sr,a,0,4ss,5,1,4st,a,0,4su,5,1,4sv,a,0,4t0,5,1,4t1,a,0,4t2,5,1,4t3,a,0,4t4,5,1,4t5,a,0,4t6,5,1,4t7,a,0,4t8,5,1,4t9,a,0,4ta,5,1,4tb,a,0,4tc,5,1,1,a,0",
        "Asia/Hebron||4qa,a,0,4qb,5,1,4qc,a,0,31,5,1,32,a,0,33,5,1,34,a,0,4qd,5,1,4qe,a,0,4qf,5,1,36,a,0,37,5,1,38,a,0,39,5,1,3a,a,0,3b,5,1,3c,a,0,3d,5,1,3e,a,0,3f,5,1,3g,a,0,3h,5,1,3i,a,0,3j,5,1,3k,a,0,3l,5,1,3m,a,0,3n,5,1,3o,a,0,3p,5,1,3q,a,0,4qg,5,1,4qh,a,0,4qi,5,1,4qj,a,0,4qk,5,1,4ql,a,0,4qm,5,1,4qn,a,0,4qo,5,1,4qp,a,0,4qq,5,1,4qr,a,0,4qs,5,1,4qt,a,0,4qu,5,1,47p,a,0,4qv,5,1,4r0,a,0,4r1,5,1,4q8,a,0,4r2,5,1,40a,a,0,4r3,5,1,40c,a,0,4r4,5,1,4r5,a,0,4r6,5,1,4r7,a,0,40g,a,0,40h,5,1,40i,a,0,40j,5,1,40k,a,0,40l,5,1,4r8,a,0,4r9,5,1,4ra,a,0,4rb,5,1,4rc,a,0,4rd,5,1,4re,a,0,4rf,5,1,4rg,a,0,4rh,5,1,4ri,a,0,4rj,5,1,4rk,a,0,4rl,5,1,4o5,a,0,69,5,1,4rm,a,0,4rn,5,1,418,a,0,4td,5,1,41a,a,0,4ro,5,1,41c,a,0,6h,5,1,4rq,a,0,4rr,5,1,4te,a,0,4tf,5,1,41g,a,0,4rs,5,1,4oe,a,0,4rt,5,1,41i,a,0,4ru,5,1,4rv,a,0,4s0,5,1,4s1,a,0,4s2,5,1,4s3,a,0,4s4,5,1,4s5,a,0,4s6,5,1,4s7,a,0,4s8,5,1,4s9,a,0,4sa,5,1,4sb,a,0,4sc,5,1,4sd,a,0,4se,5,1,4sf,a,0,4sg,5,1,4sh,a,0,4si,5,1,4sj,a,0,4sk,5,1,4sl,a,0,4sm,5,1,4sn,a,0,4so,5,1,4sp,a,0,4sq,5,1,4sr,a,0,4ss,5,1,4st,a,0,4su,5,1,4sv,a,0,4t0,5,1,4t1,a,0,4t2,5,1,4t3,a,0,4t4,5,1,4t5,a,0,4t6,5,1,4t7,a,0,4t8,5,1,4t9,a,0,4ta,5,1,4tb,a,0,4tc,5,1,1,a,0",
        "Asia/Ho_Chi_Minh,Asia/Saigon||4tg,49,0,4th,49,0,4ti,33,0,4tj,31,0,4tk,41,0,4tl,33,0,4tm,31,0,4tn,33,0,4to,31,0,1,33,0",
        "Asia/Hong_Kong,Hongkong||4tp,4a,0,4tq,31,0,4tr,41,1,4ts,31,0,4tt,41,0,4tu,31,0,4tv,41,1,4u0,31,0,4u1,41,1,4u2,31,0,4u3,41,1,4u4,31,0,4u5,41,1,4u6,31,0,4u7,41,1,4u8,31,0,4u9,41,1,4ua,31,0,4ub,41,1,4uc,31,0,4ud,41,1,4ue,31,0,4uf,41,1,4ug,31,0,4uh,41,1,4ui,31,0,4uj,41,1,4uk,31,0,4ul,41,1,4um,31,0,4un,41,1,4uo,31,0,4up,41,1,4uq,31,0,4ur,41,1,4us,31,0,4ut,41,1,4uu,31,0,4uv,41,1,4v0,31,0,4v1,41,1,4v2,31,0,4v3,41,1,4v4,31,0,4v5,41,1,4v6,31,0,4v7,41,1,4v8,31,0,4v9,41,1,4va,31,0,4vb,41,1,4vc,31,0,4vd,41,1,4ve,31,0,4vf,41,1,4vg,31,0,4vh,41,1,4vi,31,0,4vj,41,1,4vk,31,0,4vl,41,1,4vm,31,0,4vn,41,1,4vo,31,0,4vp,41,1,4vq,31,0,4vr,41,1,4vs,31,0,4vt,41,1,1,31,0",
        "Asia/Hovd||4vu,4b,0,4vv,36,0,4ai,33,0,4aj,31,1,4ak,33,0,500,31,1,4gk,33,0,501,31,1,4gm,33,0,502,31,1,4go,33,0,503,31,1,4gq,33,0,504,31,1,4gs,33,0,505,31,1,4gu,33,0,506,31,1,507,33,0,508,31,1,4h2,33,0,509,31,1,4h4,33,0,50a,31,1,4h6,33,0,50b,31,1,4h8,33,0,50c,31,1,4ha,33,0,50d,31,1,4hc,33,0,50e,31,1,4he,33,0,50f,31,1,50g,33,0,50h,31,1,50i,33,0,50j,31,1,50k,33,0,50l,31,1,50m,33,0,50n,31,1,50o,33,0,50p,31,1,50q,33,0,50r,31,1,50s,33,0,50t,31,1,50u,33,0,50v,31,1,510,33,0,511,31,1,512,33,0,513,31,1,514,33,0,515,31,1,516,33,0,517,31,1,518,33,0,519,31,1,51a,33,0,51b,31,1,51c,33,0,51d,31,1,51e,33,0,51f,31,1,51g,33,0,51h,31,1,51i,33,0,51j,31,1,51k,33,0,51l,31,1,51m,33,0,51n,31,1,51o,33,0,51p,31,1,51q,33,0,51r,31,1,51s,33,0,51t,31,1,51u,33,0,51v,31,1,520,33,0,521,31,1,522,33,0,523,31,1,524,33,0,525,31,1,526,33,0,527,31,1,528,33,0,529,31,1,1,33,0",
        "Asia/Irkutsk||52a,4c,0,52b,33,0,52c,31,0,52d,41,1,52e,31,0,52f,41,1,4id,31,0,52g,41,1,52h,31,0,52i,41,1,52j,31,0,52k,41,1,52l,31,0,52m,41,1,52n,31,0,52o,41,1,52p,31,0,52q,41,1,52r,31,0,52s,41,1,52t,31,0,52u,41,1,52v,31,1,530,33,0,531,31,0,4fa,41,1,532,31,0,4fc,41,1,533,31,0,4fe,41,1,534,31,0,4fg,41,1,535,31,0,536,41,1,537,31,0,538,41,1,539,31,0,53a,41,1,53b,31,0,53c,41,1,53d,31,0,53e,41,1,53f,31,0,53g,41,1,53h,31,0,53i,41,1,53j,31,0,53k,41,1,53l,31,0,53m,41,1,53n,31,0,53o,41,1,53p,31,0,53q,41,1,53r,31,0,53s,41,1,53t,31,0,53u,41,1,53v,31,0,540,41,1,541,31,0,542,41,1,543,31,0,544,41,0,1,31,0",
        "Asia/Istanbul,Europe/Istanbul,Turkey||545,4d,0,546,a,0,547,5,1,4br,a,0,4bs,5,1,4bt,a,0,4bu,5,1,4bv,a,0,4c0,5,1,548,a,0,549,5,1,54a,a,0,54b,5,1,54c,a,0,54d,5,1,54e,a,0,54f,5,1,2u,a,0,4qb,5,1,54g,a,0,54h,5,1,54i,a,0,54j,5,1,54k,a,0,54l,5,1,54m,a,0,54n,5,1,54o,a,0,54p,5,1,54q,a,0,54r,5,1,54s,a,0,54t,5,1,54u,a,0,54v,5,1,550,a,0,551,5,1,552,a,0,553,5,1,554,a,0,555,5,1,556,a,0,557,5,1,558,a,0,559,5,1,55a,a,0,55b,5,1,55c,a,0,55d,5,1,55e,a,0,55f,5,1,4po,a,0,55g,5,1,4pq,a,0,e6,5,1,55h,3h,1,55i,5,0,55j,3h,1,55k,5,0,55l,3h,1,55m,5,0,55n,3h,1,55o,5,0,55p,3h,1,55q,5,0,55r,5,1,55s,a,0,55t,5,1,55u,a,0,55v,5,1,560,a,0,gb,5,1,gc,a,0,gd,5,1,561,a,0,ge,5,1,562,a,0,493,5,1,494,a,0,563,5,1,564,a,0,565,5,1,566,a,0,567,5,1,568,a,0,569,5,1,56a,a,0,56b,5,1,56c,a,0,56d,5,1,56e,a,0,56f,5,1,56g,a,0,56h,5,1,56i,a,0,56j,5,1,56k,a,0,56l,5,1,56m,a,0,56n,5,1,56o,a,0,56p,5,1,56q,a,0,56r,5,1,56s,a,0,56t,5,1,56u,a,0,56v,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,570,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,571,a,0,bu,5,1,bv,a,0,572,5,1,c1,a,0,573,5,1,1,5,0",
        "Asia/Jakarta||574,4e,0,575,4f,0,576,3s,0,4pd,41,0,577,3s,0,578,31,0,579,3s,0,1,33,0",
        "Asia/Jayapura||57a,4g,0,57b,41,0,57c,4h,0,1,41,0",
        "Asia/Jerusalem,Asia/Tel_Aviv,Israel||57d,4i,0,4qa,a,0,4qb,5,1,4qc,a,0,31,5,1,32,a,0,33,5,1,34,a,0,4qd,5,1,4qe,a,0,4qf,5,1,57e,a,0,57f,3h,1,57g,5,1,57h,a,0,57i,5,1,57j,a,0,57k,5,1,57l,a,0,57m,5,1,57n,a,0,57o,5,1,57p,a,0,57q,5,1,57r,a,0,57s,5,1,57t,a,0,57u,5,1,57v,a,0,580,5,1,581,a,0,582,5,1,4qh,a,0,4qi,5,1,4qj,a,0,4qk,5,1,4ql,a,0,4qm,5,1,4qn,a,0,4qo,5,1,4qp,a,0,4qq,5,1,4qr,a,0,4qs,5,1,4qt,a,0,4qu,5,1,47p,a,0,4qv,5,1,4r0,a,0,4r1,5,1,4q8,a,0,4r2,5,1,40a,a,0,4r3,5,1,40c,a,0,4r4,5,1,4r5,a,0,4r6,5,1,583,a,0,584,5,1,585,a,0,586,5,1,587,a,0,588,5,1,589,a,0,58a,5,1,58b,a,0,58c,5,1,58d,a,0,58e,5,1,58f,a,0,58g,5,1,58h,a,0,58i,5,1,58j,a,0,58k,5,1,48i,a,0,58l,5,1,58m,a,0,58n,5,1,58o,a,0,58p,5,1,58q,a,0,58r,5,1,58s,a,0,58t,5,1,58u,a,0,58v,5,1,590,a,0,591,5,1,592,a,0,593,5,1,fp,a,0,594,5,1,595,a,0,596,5,1,597,a,0,598,5,1,599,a,0,59a,5,1,59b,a,0,59c,5,1,59d,a,0,59e,5,1,59f,a,0,59g,5,1,59h,a,0,59i,5,1,59j,a,0,59k,5,1,59l,a,0,59m,5,1,59n,a,0,59o,5,1,59p,a,0,59q,5,1,59r,a,0,59s,5,1,59t,a,0,59u,5,1,59v,a,0,5a0,5,1,5a1,a,0,5a2,5,1,5a3,a,0,5a4,5,1,5a5,a,0,5a6,5,1,5a7,a,0,5a8,5,1,5a9,a,0,5aa,5,1,5ab,a,0,5ac,5,1,5ad,a,0,5ae,5,1,5af,a,0,5ag,5,1,5ah,a,0,5ai,5,1,5aj,a,0,5ak,5,1,1,a,0",
        "Asia/Kabul||5al,3h,0,1,4j,0",
        "Asia/Kamchatka||5am,4k,0,5an,32,0,5ao,39,0,5ap,3a,1,5aq,39,0,436,3a,1,437,39,0,438,3a,1,439,39,0,43a,3a,1,43b,39,0,43c,3a,1,43d,39,0,43e,3a,1,43f,39,0,43g,3a,1,43h,39,0,43i,3a,1,43j,39,0,43k,3a,1,43l,39,0,43m,3a,1,43n,39,1,43o,32,0,43p,39,0,43q,3a,1,43r,39,0,43s,3a,1,43t,39,0,43u,3a,1,43v,39,0,440,3a,1,441,39,0,442,3a,1,443,39,0,444,3a,1,445,39,0,446,3a,1,447,39,0,448,3a,1,449,39,0,44a,3a,1,44b,39,0,44c,3a,1,44d,39,0,44e,3a,1,44f,39,0,44g,3a,1,44h,39,0,44i,3a,1,44j,39,0,44k,3a,1,44l,39,0,44m,3a,1,44n,39,0,44o,3a,1,44p,39,0,44q,3a,1,44r,39,0,44s,3a,1,44t,39,1,44u,32,0,1,39,0",
        "Asia/Karachi||5ar,4l,0,4g8,3v,0,4g9,3u,1,5as,3v,0,5at,34,0,5au,34,0,5av,36,1,5b0,34,0,5b1,36,1,5b2,34,0,5b3,36,1,1,34,0",
        "Asia/Kashgar,Asia/Urumqi||5b4,4m,0,1,36,0",
        "Asia/Kathmandu,Asia/Katmandu||5b5,4n,0,5b6,3v,0,1,4o,0",
        "Asia/Khandyga||5b7,4p,0,4gb,31,0,4gc,41,0,4gd,35,1,4ge,41,0,4gf,35,1,4gg,41,0,4gh,35,1,4gi,41,0,4gj,35,1,4gk,41,0,4gl,35,1,4gm,41,0,4gn,35,1,4go,41,0,4gp,35,1,4gq,41,0,4gr,35,1,4gs,41,0,4gt,35,1,4gu,41,0,4gv,35,1,4h0,41,1,4h1,31,0,4h2,41,0,4h3,35,1,4h4,41,0,4h5,35,1,4h6,41,0,4h7,35,1,4h8,41,0,4h9,35,1,4ha,41,0,4hb,35,1,4hc,41,0,4hd,35,1,4he,41,0,4hf,35,1,4hg,41,0,4hh,35,1,4hi,41,0,4hj,35,1,4hk,41,0,4hl,35,1,4hm,41,0,4hn,35,1,4ho,41,0,4hp,35,1,5b8,41,0,3nn,35,0,5b9,32,1,3np,35,0,5ba,32,1,5bb,35,0,5bc,32,1,3nt,35,0,5bd,32,1,5be,35,0,5bf,32,1,5bg,35,0,5bh,32,1,5bi,35,0,5bj,32,1,5bk,35,0,5bl,32,0,4i9,35,0,1,41,0",
        "Asia/Krasnoyarsk||5bm,4q,0,4ad,36,0,4ae,33,0,4af,31,1,4ag,33,0,4ah,31,1,4ai,33,0,4aj,31,1,4ak,33,0,4al,31,1,4am,33,0,4an,31,1,4ao,33,0,4ap,31,1,4aq,33,0,4ar,31,1,4as,33,0,4at,31,1,4au,33,0,4av,31,1,4b0,33,0,4b1,31,1,4b2,33,1,4b3,36,0,4b4,33,0,4b5,31,1,4b6,33,0,4b7,31,1,4b8,33,0,4b9,31,1,4ba,33,0,5bn,31,1,5bo,33,0,5bp,31,1,5bq,33,0,5br,31,1,5bs,33,0,5bt,31,1,5bu,33,0,5bv,31,1,5c0,33,0,5c1,31,1,5c2,33,0,5c3,31,1,5c4,33,0,5c5,31,1,5c6,33,0,5c7,31,1,5c8,33,0,5c9,31,1,5ca,33,0,5cb,31,1,5cc,33,0,5cd,31,1,5ce,33,0,5cf,31,1,5cg,33,0,5ch,31,1,5ci,33,0,5cj,31,1,5ck,33,0,5cl,31,1,5cm,33,0,5cn,31,0,1,33,0",
        "Asia/Kuala_Lumpur||5co,4r,0,5cp,33,0,5cq,4f,1,5cr,4f,0,5cs,3s,0,5ct,41,0,5cu,3s,0,1,31,0",
        "Asia/Kuching||5cv,4s,0,4g5,3s,0,5d0,31,0,5d1,4t,1,5d2,31,0,5d3,4t,1,5d4,31,0,5d5,4t,1,5d6,31,0,5d7,4t,1,5d8,31,0,5d9,4t,1,5da,31,0,5db,4t,1,5dc,31,0,5dd,4t,1,5de,31,0,5ct,41,0,5df,31,0,1,31,0",
        "Asia/Macao,Asia/Macau||5dg,4u,0,4us,31,0,4ut,41,1,4uu,31,0,4uv,41,1,5dh,31,0,4v1,41,1,4v2,31,0,4v3,41,1,5di,31,0,5dj,41,1,4v6,31,0,4v7,41,1,4v8,31,0,4v9,41,1,4va,31,0,4vb,41,1,4vc,31,0,4vd,41,1,4ve,31,0,4vf,41,1,4vg,31,0,4vh,41,1,5dk,31,0,5dl,41,1,5dm,31,0,5dn,41,1,5do,31,0,4vn,41,1,4vo,31,0,4vp,41,1,4vq,31,0,4vr,41,1,5dp,31,0,5dq,41,1,5dr,31,0,5ds,41,1,5dt,31,0,5du,41,1,5dv,31,0,5e0,41,1,5e1,31,0,1,31,0",
        "Asia/Magadan||5e2,4v,0,5e3,35,0,5e4,32,0,5e5,39,1,5e6,32,0,5e7,39,1,5e8,32,0,5e9,39,1,5ea,32,0,5eb,39,1,4ie,32,0,5ec,39,1,4if,32,0,5ed,39,1,4ig,32,0,5ee,39,1,4ih,32,0,5ef,39,1,4ii,32,0,5eg,39,1,4ij,32,0,5eh,39,1,508,32,1,5ei,35,0,4im,32,0,5ej,39,1,4in,32,0,5ek,39,1,4io,32,0,5el,39,1,4ip,32,0,5em,39,1,4iq,32,0,5en,39,1,4is,32,0,5eo,39,1,4iu,32,0,5ep,39,1,5eq,32,0,5er,39,1,5es,32,0,5et,39,1,5eu,32,0,5ev,39,1,5f0,32,0,5f1,39,1,5f2,32,0,5f3,39,1,5f4,32,0,5f5,39,1,5f6,32,0,5f7,39,1,5f8,32,0,5f9,39,1,5fa,32,0,5fb,39,1,5fc,32,0,5fd,39,1,5fe,32,0,5ff,39,1,5fg,32,0,44t,39,1,44u,32,0,5fh,39,0,5fi,35,0,1,32,0",
        "Asia/Makassar,Asia/Ujung_Pandang||5fj,50,0,5fk,50,0,5fl,31,0,4pd,41,0,1,31,0",
        "Asia/Manila||5fm,31,0,5fn,41,1,5fo,31,0,5fp,41,0,5fq,31,0,5fr,41,1,5fs,31,0,5ft,41,1,1,31,0",
        "Asia/Nicosia,Europe/Nicosia||5fu,51,0,4pk,a,0,4pl,5,1,4pm,a,0,4pn,5,1,4po,a,0,4pp,5,1,4pq,a,0,4pr,5,1,4ps,a,0,4pt,5,1,4pu,a,0,4pv,5,1,4q0,a,0,4q1,5,1,4q2,a,0,4q3,5,1,4q4,a,0,4q5,5,1,4q6,a,0,456,5,1,492,a,0,458,5,1,47h,a,0,45a,5,1,47j,a,0,45c,5,1,47l,a,0,45e,5,1,47n,a,0,45g,5,1,47p,a,0,45i,5,1,4q7,a,0,3ui,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,4d2,5,1,45v,a,0,4d3,5,1,461,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Asia/Novokuznetsk||5fv,52,0,4ad,36,0,4ae,33,0,4af,31,1,4ag,33,0,4ah,31,1,4ai,33,0,4aj,31,1,4ak,33,0,4al,31,1,4am,33,0,4an,31,1,4ao,33,0,4ap,31,1,4aq,33,0,4ar,31,1,4as,33,0,4at,31,1,4au,33,0,4av,31,1,4b0,33,0,4b1,31,1,4b2,33,1,4b3,36,0,4b4,33,0,4b5,31,1,4b6,33,0,4b7,31,1,4b8,33,0,4b9,31,1,4ba,33,0,5bn,31,1,5bo,33,0,5bp,31,1,5bq,33,0,5br,31,1,5bs,33,0,5bt,31,1,5bu,33,0,5bv,31,1,5c0,33,0,5c1,31,1,5c2,33,0,5c3,31,1,5c4,33,0,5c5,31,1,5c6,33,0,5c7,31,1,5c8,33,0,5c9,31,1,5ca,33,0,5cb,31,1,5cc,33,0,5cd,31,1,5ce,33,0,5cf,31,1,5cg,33,0,5ch,31,1,5ci,33,0,5cj,31,1,4bn,33,1,4bo,36,0,1,33,0",
        "Asia/Novosibirsk||5g0,53,0,4ad,36,0,4ae,33,0,4af,31,1,4ag,33,0,4ah,31,1,4ai,33,0,4aj,31,1,4ak,33,0,4al,31,1,4am,33,0,4an,31,1,4ao,33,0,4ap,31,1,4aq,33,0,4ar,31,1,4as,33,0,4at,31,1,4au,33,0,4av,31,1,4b0,33,0,4b1,31,1,4b2,33,1,4b3,36,0,4b4,33,0,4b5,31,1,4b6,33,0,5g1,31,1,3un,33,1,3uo,36,0,3up,33,1,3uq,36,0,3ur,33,1,3us,36,0,3ut,33,1,3uu,36,0,3uv,33,1,3v0,36,0,3v1,33,1,3v2,36,0,3v3,33,1,3v4,36,0,3v5,33,1,3v6,36,0,3v7,33,1,3v8,36,0,3v9,33,1,3va,36,0,3vb,33,1,3vc,36,0,3vd,33,1,4bc,36,0,4bd,33,1,4be,36,0,4bf,33,1,4bg,36,0,4bh,33,1,4bi,36,0,4bj,33,1,4bk,36,0,4bl,33,1,4bm,36,0,4bn,33,1,4bo,36,0,4bp,33,0,5g2,36,0,1,33,0",
        "Asia/Omsk||5g3,54,0,3tt,34,0,3tu,36,0,3tv,33,1,3u0,36,0,3u1,33,1,3u2,36,0,3u3,33,1,3u4,36,0,3u5,33,1,3u6,36,0,3u7,33,1,3u8,36,0,3u9,33,1,3ua,36,0,3ub,33,1,3uc,36,0,3ud,33,1,3ue,36,0,3uf,33,1,3ug,36,0,3uh,33,1,3ui,36,1,3uj,34,0,3uk,36,0,3ul,33,1,3um,36,0,3un,33,1,3uo,36,0,3up,33,1,3uq,36,0,3ur,33,1,3us,36,0,3ut,33,1,3uu,36,0,3uv,33,1,3v0,36,0,3v1,33,1,3v2,36,0,3v3,33,1,3v4,36,0,3v5,33,1,3v6,36,0,3v7,33,1,3v8,36,0,3v9,33,1,3va,36,0,3vb,33,1,3vc,36,0,3vd,33,1,4bc,36,0,4bd,33,1,4be,36,0,4bf,33,1,4bg,36,0,4bh,33,1,4bi,36,0,4bj,33,1,4bk,36,0,4bl,33,1,4bm,36,0,4bn,33,1,4bo,36,0,4bp,33,0,1,36,0",
        "Asia/Oral||5g4,55,0,450,3h,0,46f,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,47o,34,1,47p,3h,0,47q,34,1,4q7,3h,0,45j,34,1,45k,3h,0,5g5,34,1,4d0,3h,0,5g6,34,1,4d1,3h,0,5g7,34,1,45r,3h,0,45s,34,1,45t,3h,0,45u,34,1,45v,3h,0,460,34,1,461,3h,0,462,34,1,463,3h,0,464,34,1,465,3h,0,466,34,1,467,3h,0,468,34,1,469,3h,0,46a,34,1,46b,3h,0,46c,34,1,46d,3h,0,1,34,0",
        "Asia/Pontianak||5g8,56,0,5g9,56,0,5ga,3s,0,4pd,41,0,577,3s,0,578,31,0,579,3s,0,5gb,31,0,1,33,0",
        "Asia/Pyongyang||5gc,57,0,5gd,58,0,5ge,41,0,5gf,41,0,5gg,41,0,1,58,0",
        "Asia/Qyzylorda||5gh,59,0,450,3h,0,46f,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,3uj,34,0,45m,36,1,45n,34,0,45o,36,1,45p,34,0,45q,36,1,46g,34,0,46h,36,1,46i,34,0,46j,36,1,46k,34,0,46l,36,1,46m,34,0,46n,36,1,46o,34,0,46p,36,1,46q,34,0,46r,36,1,46s,34,0,46t,36,1,46u,34,0,46v,36,1,470,34,0,471,36,1,472,34,0,1,36,0",
        "Asia/Rangoon,Asia/Yangon||5gi,5a,0,5gj,3u,0,5gk,41,0,1,3u,0",
        "Asia/Sakhalin||5gl,4h,0,5gm,41,0,5e4,32,0,5e5,39,1,5e6,32,0,5e7,39,1,5e8,32,0,5e9,39,1,5ea,32,0,5eb,39,1,4ie,32,0,5ec,39,1,4if,32,0,5ed,39,1,4ig,32,0,5ee,39,1,4ih,32,0,5ef,39,1,4ii,32,0,5eg,39,1,4ij,32,0,5eh,39,1,508,32,1,5ei,35,0,4im,32,0,5ej,39,1,4in,32,0,5ek,39,1,4io,32,0,5el,39,1,4ip,32,0,5em,39,1,4iq,32,0,5en,39,1,5gn,32,1,3nb,35,0,5go,32,1,3nd,35,0,5gp,32,1,3nf,35,0,5gq,32,1,3nh,35,0,5gr,32,1,3nj,35,0,5gs,32,1,3nl,35,0,5gt,32,1,3nn,35,0,5b9,32,1,3np,35,0,5ba,32,1,5bb,35,0,5bc,32,1,3nt,35,0,5bd,32,1,5be,35,0,5bf,32,1,5bg,35,0,5bh,32,1,5bi,35,0,5bj,32,1,5bk,35,0,5gu,32,0,5gv,35,0,1,32,0",
        "Asia/Samarkand||5h0,5b,0,450,3h,0,46f,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,5h1,34,0,3ui,36,1,1,34,0",
        "Asia/Seoul,ROK||5h2,5c,0,5gd,58,0,5ge,41,0,5h3,41,0,5h4,41,0,5h5,58,0,5h6,4h,1,5h7,58,0,5h8,4h,1,5h9,58,0,5ha,4h,1,5hb,58,0,5hc,4h,1,5hd,58,0,5he,4h,1,5hf,58,0,5hg,4h,1,5hh,58,0,5hi,41,0,5hj,35,1,5hk,41,0,5hl,35,1,1,41,0",
        "Asia/Singapore,Singapore||5co,4r,0,5cp,33,0,5cq,4f,1,5cr,4f,0,5cs,3s,0,5ct,41,0,5hm,3s,0,5cu,3s,0,1,31,0",
        "Asia/Srednekolymsk||5hn,5d,0,5e3,35,0,5e4,32,0,5e5,39,1,5e6,32,0,5e7,39,1,5e8,32,0,5e9,39,1,5ea,32,0,5eb,39,1,4ie,32,0,5ec,39,1,4if,32,0,5ed,39,1,4ig,32,0,5ee,39,1,4ih,32,0,5ef,39,1,4ii,32,0,5eg,39,1,4ij,32,0,5eh,39,1,508,32,1,5ei,35,0,4im,32,0,5ej,39,1,4in,32,0,5ek,39,1,4io,32,0,5el,39,1,4ip,32,0,5em,39,1,4iq,32,0,5en,39,1,4is,32,0,5eo,39,1,4iu,32,0,5ep,39,1,5eq,32,0,5er,39,1,5es,32,0,5et,39,1,5eu,32,0,5ev,39,1,5f0,32,0,5f1,39,1,5f2,32,0,5f3,39,1,5f4,32,0,5f5,39,1,5f6,32,0,5f7,39,1,5f8,32,0,5f9,39,1,5fa,32,0,5fb,39,1,5fc,32,0,5fd,39,1,5fe,32,0,5ff,39,1,5fg,32,0,44t,39,1,44u,32,0,5fh,39,0,1,32,0",
        "Asia/Taipei,ROC||5ho,31,0,5hp,41,0,5hq,31,0,5hr,41,1,5hs,31,0,5ht,41,1,5hu,31,0,5hv,41,1,5i0,31,0,5i1,41,1,578,31,0,5i2,41,1,5i3,31,0,5i4,41,1,5i5,31,0,5i6,41,1,5i7,31,0,5i8,41,1,5i9,31,0,5ia,41,1,5ib,31,0,5ic,41,1,5id,31,0,5ie,41,1,5if,31,0,5ig,41,1,5ih,31,0,5ii,41,1,5ij,31,0,5ik,41,1,5il,31,0,5im,41,1,5in,31,0,5io,41,1,5ip,31,0,5iq,41,1,5ir,31,0,5is,41,1,5it,31,0,5iu,41,1,1,31,0",
        "Asia/Tashkent||5iv,5e,0,3tt,34,0,3tu,36,0,3tv,33,1,3u0,36,0,3u1,33,1,3u2,36,0,3u3,33,1,3u4,36,0,3u5,33,1,3u6,36,0,3u7,33,1,3u8,36,0,3u9,33,1,3ua,36,0,3ub,33,1,3uc,36,0,3ud,33,1,3ue,36,0,3uf,33,1,3ug,36,0,3uh,33,1,3ui,36,1,1,34,0",
        "Asia/Tbilisi||5j0,5f,0,48q,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,47n,3h,0,47o,34,1,47p,3h,0,47q,34,1,493,3h,1,45l,5,0,3ul,3h,1,45n,5,0,3un,3h,1,45p,5,0,3uq,3h,0,5bn,34,1,3us,3h,0,5br,34,1,3v0,3h,0,5bt,34,1,3v2,3h,0,5bv,34,1,3v4,3h,0,5c1,34,1,3v6,3h,0,5c3,34,1,3v8,3h,0,5c5,34,1,3va,3h,0,5c7,34,1,3vc,3h,0,5j1,34,1,56r,3h,1,56s,5,0,1,3h,0",
        "Asia/Tehran,Iran||5j2,55,0,5j3,55,0,5j4,5g,0,5j5,3h,0,5j6,34,1,5j7,3h,0,5j8,5g,0,5j9,4j,1,5ja,5g,0,5jb,4j,1,5jc,5g,0,5jd,4j,1,5je,5g,0,5jf,4j,1,5jg,5g,0,5jh,4j,1,5ji,5g,0,5jj,4j,1,5jk,5g,0,5jl,4j,1,5jm,5g,0,5jn,4j,1,5jo,5g,0,5jp,4j,1,5jq,5g,0,5jr,4j,1,5js,5g,0,5jt,4j,1,5ju,5g,0,5jv,4j,1,5k0,5g,0,5k1,4j,1,5k2,5g,0,5k3,4j,1,5k4,5g,0,5k5,4j,1,5k6,5g,0,5k7,4j,1,5k8,5g,0,5k9,4j,1,5ka,5g,0,5kb,4j,1,5kc,5g,0,5kd,4j,1,5ke,5g,0,5kf,4j,1,5kg,5g,0,5kh,4j,1,5ki,5g,0,5kj,4j,1,5kk,5g,0,5kl,4j,1,5km,5g,0,5kn,4j,1,5ko,5g,0,5kp,4j,1,5kq,5g,0,5kr,4j,1,5ks,5g,0,5kt,4j,1,5ku,5g,0,5kv,4j,1,5l0,5g,0,5l1,4j,1,5l2,5g,0,5l3,4j,1,5l4,5g,0,5l5,4j,1,5l6,5g,0,5l7,4j,1,5l8,5g,0,5l9,4j,1,5la,5g,0,5lb,4j,1,5lc,5g,0,5ld,4j,1,5le,5g,0,5lf,4j,1,5lg,5g,0,5lh,4j,1,5li,5g,0,5lj,4j,1,5lk,5g,0,5ll,4j,1,5lm,5g,0,5ln,4j,1,5lo,5g,0,5lp,4j,1,5lq,5g,0,5lr,4j,1,5ls,5g,0,5lt,4j,1,5lu,5g,0,5lv,4j,1,5m0,5g,0,5m1,4j,1,5m2,5g,0,5m3,4j,1,5m4,5g,0,5m5,4j,1,1,5g,0",
        "Asia/Thimbu,Asia/Thimphu||5m6,5h,0,5m7,3v,0,1,36,0",
        "Asia/Tokyo,Japan||5ge,41,0,5m8,41,0,5m9,35,1,5ma,41,0,5mb,35,1,5mc,41,0,5md,35,1,5me,41,0,5mf,35,1,1,41,0",
        "Asia/Tomsk||5mg,5i,0,4ad,36,0,4ae,33,0,4af,31,1,4ag,33,0,4ah,31,1,4ai,33,0,4aj,31,1,4ak,33,0,4al,31,1,4am,33,0,4an,31,1,4ao,33,0,4ap,31,1,4aq,33,0,4ar,31,1,4as,33,0,4at,31,1,4au,33,0,4av,31,1,4b0,33,0,4b1,31,1,4b2,33,1,4b3,36,0,4b4,33,0,4b5,31,1,4b6,33,0,4b7,31,1,4b8,33,0,4b9,31,1,4ba,33,0,5bn,31,1,5bo,33,0,5bp,31,1,5bq,33,0,5br,31,1,5bs,33,0,5bt,31,1,5bu,33,0,5bv,31,1,5c0,33,0,5c1,31,1,5c2,33,0,5c3,31,1,5c4,33,0,5mh,31,1,3v9,33,1,3va,36,0,3vb,33,1,3vc,36,0,3vd,33,1,4bc,36,0,4bd,33,1,4be,36,0,4bf,33,1,4bg,36,0,4bh,33,1,4bi,36,0,4bj,33,1,4bk,36,0,4bl,33,1,4bm,36,0,4bn,33,1,4bo,36,0,4bp,33,0,5mi,36,0,1,33,0",
        "Asia/Ulaanbaatar,Asia/Ulan_Bator||5mj,4e,0,4ic,33,0,4id,31,0,52g,41,1,52h,31,0,5eb,41,1,5mk,31,0,5ec,41,1,5ml,31,0,5ed,41,1,5mm,31,0,5ee,41,1,5mn,31,0,5ef,41,1,5mo,31,0,5eg,41,1,5mp,31,0,5eh,41,1,3mt,31,0,43n,41,1,3mv,31,0,5ej,41,1,3n1,31,0,5ek,41,1,3n3,31,0,5el,41,1,3n5,31,0,5em,41,1,3n7,31,0,5mq,41,1,3n9,31,0,5mr,41,1,3nb,31,0,5ms,41,1,5mt,31,0,5mu,41,1,5mv,31,0,5n0,41,1,5n1,31,0,5n2,41,1,5n3,31,0,5n4,41,1,5n5,31,0,5n6,41,1,5n7,31,0,5n8,41,1,4jd,31,0,4je,41,1,4jf,31,0,4jg,41,1,4jh,31,0,4ji,41,1,4jj,31,0,4jk,41,1,4jl,31,0,4jm,41,1,4jn,31,0,4jo,41,1,4jp,31,0,4jq,41,1,4jr,31,0,4js,41,1,4jt,31,0,4ju,41,1,4jv,31,0,4k0,41,1,4k1,31,0,4k2,41,1,4k3,31,0,4k4,41,1,4k5,31,0,4k6,41,1,4k7,31,0,4k8,41,1,4k9,31,0,4ka,41,1,4kb,31,0,4kc,41,1,4kd,31,0,4ke,41,1,4kf,31,0,4kg,41,1,4kh,31,0,4ki,41,1,4kj,31,0,4kk,41,1,4kl,31,0,4km,41,1,4kn,31,0,4ko,41,1,4kp,31,0,4kq,41,1,1,31,0",
        "Asia/Ust-Nera||5n9,5j,0,4gb,31,0,4gc,41,0,5e5,39,1,5e6,32,0,5e7,39,1,5e8,32,0,5e9,39,1,5ea,32,0,5eb,39,1,4ie,32,0,5ec,39,1,4if,32,0,5ed,39,1,4ig,32,0,5ee,39,1,4ih,32,0,5ef,39,1,4ii,32,0,5eg,39,1,4ij,32,0,5eh,39,1,508,32,1,5ei,35,0,4im,32,0,5ej,39,1,4in,32,0,5ek,39,1,4io,32,0,5el,39,1,4ip,32,0,5em,39,1,4iq,32,0,5en,39,1,4is,32,0,5eo,39,1,4iu,32,0,5ep,39,1,5eq,32,0,5er,39,1,5es,32,0,5et,39,1,5eu,32,0,5ev,39,1,5f0,32,0,5f1,39,1,5f2,32,0,5f3,39,1,5f4,32,0,5f5,39,1,5f6,32,0,5f7,39,1,5f8,32,0,5f9,39,1,5fa,32,0,5fb,39,1,5fc,32,0,5fd,39,1,5fe,32,0,5ff,39,1,5fg,32,0,44t,39,1,44u,32,0,5na,39,0,5gu,32,0,1,35,0",
        "Asia/Vladivostok||5nb,5k,0,5nc,41,0,5nd,35,0,5ne,32,1,5nf,35,0,5ng,32,1,5nh,35,0,5ni,32,1,5nj,35,0,500,32,1,5mk,35,0,501,32,1,5ml,35,0,502,32,1,5mm,35,0,503,32,1,5mn,35,0,504,32,1,5mo,35,0,505,32,1,5mp,35,0,506,32,1,5nk,35,1,5nl,41,0,3mv,35,0,509,32,1,3n1,35,0,50a,32,1,3n3,35,0,50b,32,1,3n5,35,0,50c,32,1,3n7,35,0,5nm,32,1,3n9,35,0,5gn,32,1,3nb,35,0,5go,32,1,3nd,35,0,5gp,32,1,3nf,35,0,5gq,32,1,3nh,35,0,5gr,32,1,3nj,35,0,5gs,32,1,3nl,35,0,5gt,32,1,3nn,35,0,5b9,32,1,3np,35,0,5ba,32,1,5bb,35,0,5bc,32,1,3nt,35,0,5bd,32,1,5be,35,0,5bf,32,1,5bg,35,0,5bh,32,1,5bi,35,0,5bj,32,1,5bk,35,0,5gu,32,0,1,35,0",
        "Asia/Yakutsk||5nn,5l,0,4gb,31,0,4gc,41,0,4gd,35,1,4ge,41,0,4gf,35,1,4gg,41,0,4gh,35,1,4gi,41,0,4gj,35,1,4gk,41,0,4gl,35,1,4gm,41,0,4gn,35,1,4go,41,0,4gp,35,1,4gq,41,0,4gr,35,1,4gs,41,0,4gt,35,1,4gu,41,0,4gv,35,1,4h0,41,1,4h1,31,0,4h2,41,0,4h3,35,1,4h4,41,0,4h5,35,1,4h6,41,0,4h7,35,1,4h8,41,0,4h9,35,1,4ha,41,0,4hb,35,1,4hc,41,0,4hd,35,1,4he,41,0,4hf,35,1,4hg,41,0,4hh,35,1,4hi,41,0,4hj,35,1,4hk,41,0,4hl,35,1,4hm,41,0,4hn,35,1,4ho,41,0,4hp,35,1,4hq,41,0,4hr,35,1,4hs,41,0,4ht,35,1,4hu,41,0,4hv,35,1,4i0,41,0,4i1,35,1,4i2,41,0,4i3,35,1,4i4,41,0,4i5,35,1,4i6,41,0,4i7,35,1,4i8,41,0,4i9,35,0,1,41,0",
        "Asia/Yekaterinburg||5no,5m,0,5np,5n,0,450,3h,0,46f,34,0,475,36,1,476,34,0,452,36,1,453,34,0,454,36,1,455,34,0,456,36,1,457,34,0,458,36,1,459,34,0,45a,36,1,45b,34,0,45c,36,1,45d,34,0,45e,36,1,45f,34,0,45g,36,1,45h,34,0,45i,36,1,45j,34,1,45k,3h,0,45l,34,0,45m,36,1,45n,34,0,45o,36,1,45p,34,0,45q,36,1,46g,34,0,46h,36,1,46i,34,0,46j,36,1,46k,34,0,46l,36,1,46m,34,0,46n,36,1,46o,34,0,46p,36,1,46q,34,0,46r,36,1,46s,34,0,46t,36,1,46u,34,0,46v,36,1,470,34,0,471,36,1,472,34,0,473,36,1,5nq,34,0,4d6,36,1,5nr,34,0,4d8,36,1,5ns,34,0,4da,36,1,5nt,34,0,4dc,36,1,5nu,34,0,4de,36,1,5nv,34,0,4dg,36,1,5o0,34,0,5o1,36,0,1,34,0",
        "Asia/Yerevan||5o2,5o,0,48q,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,47n,3h,0,47o,34,1,47p,3h,0,47q,34,1,493,3h,1,494,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,45v,3h,0,460,34,1,461,3h,0,462,34,1,463,3h,0,464,34,1,465,3h,0,466,34,1,467,3h,0,468,34,1,469,3h,0,46a,34,1,46b,3h,0,46c,34,1,46d,3h,0,5o4,34,1,4d5,3h,0,5o5,34,1,4d7,3h,0,5o6,34,1,4d9,3h,0,5o7,34,1,4db,3h,0,5o8,34,1,4dd,3h,0,5o9,34,1,4df,3h,0,5oa,34,1,4dh,3h,0,5ob,34,1,1,3h,0",
        "Atlantic/Azores||5oc,5p,0,5od,t,0,5oe,d,1,5of,t,0,5og,d,1,5oh,t,0,5oi,d,1,5oj,t,0,5ok,d,1,5ol,t,0,5om,d,1,5on,t,0,5oo,d,1,5op,t,0,5oq,d,1,5or,t,0,5os,d,1,5ot,t,0,5ou,d,1,5ov,t,0,5p0,d,1,5p1,t,0,5p2,d,1,5p3,t,0,5p4,d,1,5p5,t,0,5p6,d,1,5p7,t,0,5p8,d,1,5p9,t,0,5pa,d,1,5pb,t,0,5pc,d,1,5pd,t,0,5pe,d,1,5pf,t,0,5pg,d,1,5ph,t,0,5pi,d,1,5pj,t,0,5pk,d,1,5pl,t,0,5pm,d,1,5pn,t,0,5po,d,1,5pp,1,1,5pq,d,1,5pr,t,0,5ps,d,1,5pt,1,1,5pu,d,1,5pv,t,0,5q0,d,1,5q1,1,1,5q2,d,1,5q3,t,0,5q4,d,1,5q5,1,1,5q6,d,1,5q7,t,0,5q8,d,1,5q9,t,0,5qa,d,1,5qb,t,0,5qc,d,1,5qd,t,0,5qe,d,1,279,t,0,5qf,d,1,5qg,t,0,5qh,d,1,5qi,t,0,5qj,d,1,5qk,t,0,5ql,d,1,5qm,t,0,5qn,d,1,5qo,t,0,5qp,d,1,5qq,t,0,5qr,d,1,5qs,t,0,5qt,d,1,5qu,t,0,5qv,d,1,5r0,t,0,5r1,d,1,5r2,t,0,5r3,d,1,5r4,t,0,5r5,d,1,5r6,t,0,5r7,d,1,5r8,t,0,5r9,d,1,5ra,t,0,5rb,d,1,5rc,t,0,5rd,d,0,5re,1,1,5rf,d,0,5rg,1,1,5rh,d,0,5ri,1,1,5rj,d,0,5rk,1,1,3de,d,0,5rl,1,1,5rm,d,0,5rn,1,1,5ro,d,0,5rp,1,1,5rq,d,0,5rr,1,1,5rs,d,0,5rt,1,1,5ru,d,0,5rv,1,1,5s0,d,0,5s1,1,1,5s2,d,0,5s3,1,1,5s4,d,0,5s5,1,1,5s6,d,0,5s7,1,1,5s8,d,0,5s9,1,1,5sa,d,0,5sb,1,1,aj,1,0,ak,1,1,al,d,0,am,1,1,an,d,0,ao,1,1,ap,d,0,aq,1,1,ar,d,0,as,1,1,at,d,0,au,1,1,av,d,0,b0,1,1,b1,d,0,b2,1,1,b3,d,0,b4,1,1,b5,d,0,b6,1,1,b7,d,0,b8,1,1,b9,d,0,ba,1,1,bb,d,0,bc,1,1,bd,d,0,be,1,1,bf,d,0,bg,1,1,bh,d,0,bi,1,1,bj,d,0,bk,1,1,bl,d,0,bm,1,1,bn,d,0,bo,1,1,bp,d,0,bq,1,1,br,d,0,bs,1,1,bt,d,0,bu,1,1,bv,d,0,c0,1,1,c1,d,0,c2,1,1,c3,d,0,c4,1,1,c5,d,0,c6,1,1,c7,d,0,c8,1,1,c9,d,0,ca,1,1,cb,d,0,cc,1,1,cd,d,0,ce,1,1,cf,d,0,cg,1,1,ch,d,0,ci,1,1,cj,d,0,ck,1,1,cl,d,0,cm,1,1,cn,d,0,co,1,1,cp,d,0,cq,1,1,cr,d,0,cs,1,1,ct,d,0,cu,1,1,cv,d,0,d0,1,1,d1,d,0,d2,1,1,d3,d,0,d4,1,1,d5,d,0,d6,1,1,d7,d,0,d8,1,1,d9,d,0,da,1,1,db,d,0,dc,1,1,1,d,0",
        "Atlantic/Bermuda||5sc,5q,0,29q,q,0,29r,s,1,29s,q,0,29t,s,1,29u,q,0,29v,s,1,2a0,q,0,2a1,s,1,2a2,q,0,2a3,s,1,2a4,q,0,2a5,s,1,2a6,q,0,2a7,s,1,2a8,q,0,2a9,s,1,2aa,q,0,2ab,s,1,2ac,q,0,2ad,s,1,2ae,q,0,2af,s,1,2ag,q,0,2ah,s,1,2ai,q,0,2aj,s,1,2ak,q,0,27s,s,1,2al,q,0,2am,s,1,2an,q,0,2ao,s,1,2ap,q,0,2aq,s,1,2ar,q,0,2as,s,1,2at,q,0,2au,s,1,2av,q,0,2b0,s,1,2b1,q,0,2b2,s,1,2b3,q,0,2b4,s,1,2b5,q,0,2b6,s,1,2b7,q,0,2b8,s,1,2b9,q,0,2ba,s,1,2bb,q,0,2bc,s,1,2bd,q,0,2be,s,1,2bf,q,0,2bg,s,1,2bh,q,0,2bi,s,1,2bj,q,0,2bk,s,1,2bl,q,0,2bm,s,1,2bn,q,0,2bo,s,1,2bp,q,0,2bq,s,1,2br,q,0,2bs,s,1,2bt,q,0,2bu,s,1,2bv,q,0,2c0,s,1,2c1,q,0,2c2,s,1,2c3,q,0,2c4,s,1,2c5,q,0,2c6,s,1,2c7,q,0,2c8,s,1,2c9,q,0,2ca,s,1,2cb,q,0,2cc,s,1,2cd,q,0,2ce,s,1,2cf,q,0,2cg,s,1,2ch,q,0,2ci,s,1,2cj,q,0,2ck,s,1,2cl,q,0,2cm,s,1,2cn,q,0,2co,s,1,2cp,q,0,2cq,s,1,2cr,q,0,2cs,s,1,2ct,q,0,2cu,s,1,2cv,q,0,2d0,s,1,2d1,q,0,2d2,s,1,2d3,q,0,2d4,s,1,2d5,q,0,2d6,s,1,2d7,q,0,2d8,s,1,2d9,q,0,2da,s,1,2db,q,0,2dc,s,1,2dd,q,0,2de,s,1,2df,q,0,2dg,s,1,2dh,q,0,2di,s,1,2dj,q,0,2dk,s,1,2dl,q,0,2dm,s,1,2dn,q,0,2do,s,1,1,q,0",
        "Atlantic/Canary||5sd,5r,0,5se,d,0,55i,1,0,1s2,9,1,1s3,1,0,1s4,9,1,1s5,1,0,1s6,9,1,1s7,1,0,1s8,9,1,1s9,1,0,1sa,9,1,1sb,1,0,1sc,9,1,a5,1,0,a6,9,1,a7,1,0,a8,9,1,a9,1,0,aa,9,1,ab,1,0,ac,9,1,ad,1,0,ae,9,1,af,1,0,ag,9,1,ah,1,0,ai,9,1,aj,1,0,ak,9,1,al,1,0,am,9,1,an,1,0,ao,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Atlantic/Cape_Verde||5sf,5s,0,5sg,t,0,5sh,d,1,5si,t,0,1,d,0",
        "Atlantic/Faeroe,Atlantic/Faroe||5sj,5t,0,1s3,1,0,1s4,9,1,1s5,1,0,1s6,9,1,1s7,1,0,1s8,9,1,1s9,1,0,1sa,9,1,1sb,1,0,1sc,9,1,a5,1,0,a6,9,1,a7,1,0,a8,9,1,a9,1,0,aa,9,1,ab,1,0,ac,9,1,ad,1,0,ae,9,1,af,1,0,ag,9,1,ah,1,0,ai,9,1,aj,1,0,ak,9,1,al,1,0,am,9,1,an,1,0,ao,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Atlantic/Madeira||5sk,5u,0,5sl,d,0,5sm,1,1,5sn,d,0,5so,1,1,5sp,d,0,5sq,1,1,5sr,d,0,5ss,1,1,5st,d,0,5su,1,1,5sv,d,0,5t0,1,1,5t1,d,0,5t2,1,1,5t3,d,0,5t4,1,1,5t5,d,0,5t6,1,1,5t7,d,0,5t8,1,1,5t9,d,0,5ta,1,1,5tb,d,0,5tc,1,1,5td,d,0,5te,1,1,5tf,d,0,5tg,1,1,5th,d,0,5ti,1,1,5tj,d,0,5tk,1,1,5tl,d,0,5tm,1,1,5tn,d,0,5to,1,1,5tp,d,0,23,1,1,6r,d,0,5tq,1,1,5tr,d,0,5ts,1,1,5tt,d,0,5tu,1,1,5tv,9,1,5u0,1,1,5u1,d,0,5u2,1,1,5u3,9,1,5u4,1,1,5u5,d,0,5u6,1,1,5u7,9,1,5u8,1,1,5u9,d,0,5ua,1,1,5ub,9,1,5uc,1,1,5ud,d,0,5ue,1,1,5uf,d,0,5ug,1,1,5uh,d,0,5ui,1,1,5uj,d,0,5uk,1,1,1a7,d,0,5ul,1,1,5um,d,0,5un,1,1,5uo,d,0,5up,1,1,5uq,d,0,5ur,1,1,5us,d,0,5ut,1,1,5uu,d,0,5uv,1,1,5v0,d,0,5v1,1,1,5v2,d,0,5v3,1,1,5v4,d,0,5v5,1,1,5v6,d,0,5v7,1,1,5v8,d,0,5v9,1,1,5va,d,0,5vb,1,1,5vc,d,0,5vd,1,1,5ve,d,0,5vf,1,1,2ui,d,0,5vg,1,1,2uk,d,0,5vh,1,0,5vi,9,1,5vj,1,0,4h,9,1,5vk,1,0,5vl,9,1,5vm,1,0,1s2,9,1,1s3,1,0,1s4,9,1,1s5,1,0,1s6,9,1,5vn,1,0,1s8,9,1,1s9,1,0,1sa,9,1,1sb,1,0,1sc,9,1,a5,1,0,a6,9,1,a7,1,0,a8,9,1,a9,1,0,aa,9,1,ab,1,0,ac,9,1,ad,1,0,ae,9,1,af,1,0,ag,9,1,ah,1,0,ai,9,1,aj,1,0,ak,9,1,al,1,0,am,9,1,an,1,0,ao,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Atlantic/Reykjavik,Iceland||5vo,2t,0,5vp,d,0,5vq,1,1,5vr,d,0,5vs,1,1,5vt,d,0,5vu,1,1,5vv,d,0,600,1,1,601,d,0,602,1,1,603,d,0,604,1,1,605,d,0,606,1,1,607,d,0,608,1,1,609,d,0,60a,1,1,60b,d,0,60c,1,1,60d,d,0,60e,1,1,60f,d,0,60g,1,1,60h,d,0,60i,1,1,60j,d,0,60k,1,1,60l,d,0,60m,1,1,60n,d,0,60o,1,1,sf,d,0,60p,1,1,60q,d,0,60r,1,1,60s,d,0,60t,1,1,60u,d,0,60v,1,1,610,d,0,611,1,1,612,d,0,613,1,1,614,d,0,615,1,1,616,d,0,617,1,1,618,d,0,619,1,1,61a,d,0,61b,1,1,61c,d,0,61d,1,1,61e,d,0,61f,1,1,61g,d,0,61h,1,1,61i,d,0,61j,1,1,61k,d,0,61l,1,1,61m,d,0,61n,1,1,61o,d,0,61p,1,1,61q,d,0,1,1,0",
        "Atlantic/South_Georgia,Etc/GMT+2||1,t,0",
        "Atlantic/Stanley||61r,5v,0,61s,q,0,61t,s,1,61u,q,0,61v,s,1,620,q,0,621,s,1,622,q,0,623,s,1,624,q,0,625,s,1,626,q,0,627,s,1,628,q,0,629,s,0,62a,t,1,62b,s,0,62c,t,1,62d,s,0,62e,s,1,62f,q,0,62g,s,1,62h,q,0,62i,s,1,62j,q,0,62k,s,1,62l,q,0,62m,s,1,62n,q,0,62o,s,1,62p,q,0,62q,s,1,62r,q,0,62s,s,1,62t,q,0,62u,s,1,62v,q,0,630,s,1,631,q,0,632,s,1,633,q,0,634,s,1,635,q,0,636,s,1,637,q,0,638,s,1,639,q,0,63a,s,1,63b,q,0,63c,s,1,63d,q,0,63e,s,1,63f,q,0,63g,s,1,63h,q,0,63i,s,1,63j,q,0,63k,s,1,63l,q,0,63m,s,1,63n,q,0,63o,s,1,63p,q,0,63q,s,1,63r,q,0,63s,s,1,63t,q,0,63u,s,1,63v,q,0,1,s,0",
        "Australia/ACT,Australia/Canberra,Australia/NSW,Australia/Sydney||640,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3lm,35,0,3ln,32,1,3lo,35,0,3lp,32,1,3lq,35,0,3lr,32,1,3ls,35,0,3lt,32,1,3lu,35,0,3lv,32,1,3m0,35,0,3m1,32,1,3m2,35,0,3m3,32,1,3m4,35,0,3m5,32,1,3m6,35,0,3m7,32,1,3m8,35,0,3m9,32,1,3ma,35,0,647,32,1,3mc,35,0,648,32,1,3me,35,0,3mf,32,1,3mg,35,0,3mh,32,1,3mi,35,0,649,32,1,3mk,35,0,3ml,32,1,3mm,35,0,3mn,32,1,3mo,35,0,3mp,32,1,3mq,35,0,64a,32,1,3ms,35,0,64b,32,1,64c,35,0,64d,32,1,64e,35,0,64f,32,1,64g,35,0,64h,32,1,64i,35,0,64j,32,1,64k,35,0,3n7,32,1,5nm,35,0,3n9,32,1,5gn,35,0,3nb,32,1,5go,35,0,3nd,32,1,5gp,35,0,3nf,32,1,3ng,35,0,3nh,32,1,5gr,35,0,3nj,32,1,5gs,35,0,3nl,32,1,5gt,35,0,3nn,32,1,5b9,35,0,3np,32,1,5ba,35,0,3nr,32,1,5bc,35,0,3nt,32,1,5bd,35,0,3nv,32,1,3o0,35,0,3o1,32,1,3o2,35,0,3o3,32,1,64l,35,0,64m,32,1,64n,35,0,64o,32,1,64p,35,0,64q,32,1,64r,35,0,64s,32,1,64t,35,0,64u,32,1,64v,35,0,650,32,1,651,35,0,652,32,1,653,35,0,654,32,1,655,35,0,656,32,1,657,35,0,658,32,1,659,35,0,65a,32,1,65b,35,0,65c,32,1,65d,35,0,65e,32,1,65f,35,0,65g,32,1,65h,35,0,65i,32,1,65j,35,0,65k,32,1,65l,35,0,65m,32,1,65n,35,0,65o,32,1,65p,35,0,65q,32,1,65r,35,0,65s,32,1,65t,35,0,65u,32,1,65v,35,0,660,32,1,661,35,0,662,32,1,663,35,0,664,32,1,665,35,0,666,32,1,667,35,0,668,32,1,669,35,0,66a,32,1,66b,35,0,1,32,1",
        "Australia/Adelaide,Australia/South||66c,4h,0,66d,60,1,66e,4h,0,66f,60,1,66g,4h,0,66h,60,1,66i,4h,0,66j,60,1,66k,4h,0,66l,60,1,66m,4h,0,66n,60,1,66o,4h,0,66p,60,1,66q,4h,0,66r,60,1,66s,4h,0,66t,60,1,66u,4h,0,66v,60,1,670,4h,0,671,60,1,672,4h,0,673,60,1,674,4h,0,675,60,1,676,4h,0,677,60,1,678,4h,0,679,60,1,67a,4h,0,67b,60,1,67c,4h,0,67d,60,1,67e,4h,0,67f,60,1,67g,4h,0,67h,60,1,67i,4h,0,67j,60,1,67k,4h,0,67l,60,1,67m,4h,0,67n,60,1,67o,4h,0,67p,60,1,67q,4h,0,67r,60,1,67s,4h,0,67t,60,1,67u,4h,0,67v,60,1,680,4h,0,681,60,1,682,4h,0,683,60,1,684,4h,0,685,60,1,686,4h,0,687,60,1,688,4h,0,689,60,1,68a,4h,0,68b,60,1,68c,4h,0,68d,60,1,68e,4h,0,68f,60,1,68g,4h,0,68h,60,1,68i,4h,0,68j,60,1,68k,4h,0,68l,60,1,68m,4h,0,68n,60,1,68o,4h,0,68p,60,1,68q,4h,0,68r,60,1,68s,4h,0,68t,60,1,68u,4h,0,68v,60,1,690,4h,0,691,60,1,692,4h,0,693,60,1,694,4h,0,695,60,1,696,4h,0,697,60,1,698,4h,0,699,60,1,69a,4h,0,69b,60,1,69c,4h,0,69d,60,1,69e,4h,0,69f,60,1,69g,4h,0,69h,60,1,69i,4h,0,69j,60,1,69k,4h,0,69l,60,1,69m,4h,0,69n,60,1,69o,4h,0,69p,60,1,69q,4h,0,69r,60,1,69s,4h,0,69t,60,1,69u,4h,0,69v,60,1,6a0,4h,0,6a1,60,1,6a2,4h,0,6a3,60,1,6a4,4h,0,6a5,60,1,6a6,4h,0,6a7,60,1,6a8,4h,0,6a9,60,1,6aa,4h,0,6ab,60,1,6ac,4h,0,6ad,60,1,6ae,4h,0,6af,60,1,6ag,4h,0,6ah,60,1,6ai,4h,0,6aj,60,1,6ak,4h,0,6al,60,1,6am,4h,0,6an,60,1,6ao,4h,0,1,60,1",
        "Australia/Brisbane,Australia/Queensland||640,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3lm,35,0,3ln,32,1,3mq,35,0,64a,32,1,3ms,35,0,64b,32,1,64c,35,0,64d,32,1,1,35,0",
        "Australia/Broken_Hill,Australia/Yancowinna||66c,4h,0,66d,60,1,66e,4h,0,66f,60,1,66g,4h,0,66h,60,1,66i,4h,0,66j,60,1,66k,4h,0,66l,60,1,66m,4h,0,66n,60,1,66o,4h,0,66p,60,1,66q,4h,0,66r,60,1,66s,4h,0,66t,60,1,66u,4h,0,66v,60,1,670,4h,0,671,60,1,672,4h,0,673,60,1,674,4h,0,675,60,1,676,4h,0,677,60,1,678,4h,0,6ap,60,1,67a,4h,0,67b,60,1,67c,4h,0,67d,60,1,67e,4h,0,67f,60,1,67g,4h,0,67h,60,1,67i,4h,0,67j,60,1,67k,4h,0,67l,60,1,67m,4h,0,67n,60,1,67o,4h,0,6aq,60,1,67q,4h,0,67r,60,1,67s,4h,0,6ar,60,1,67u,4h,0,67v,60,1,680,4h,0,6as,60,1,682,4h,0,6at,60,1,684,4h,0,685,60,1,686,4h,0,687,60,1,688,4h,0,689,60,1,68a,4h,0,68b,60,1,68c,4h,0,68d,60,1,68e,4h,0,68f,60,1,68g,4h,0,68h,60,1,68i,4h,0,68j,60,1,68k,4h,0,68l,60,1,68m,4h,0,68n,60,1,68o,4h,0,68p,60,1,68q,4h,0,68r,60,1,68s,4h,0,68t,60,1,68u,4h,0,68v,60,1,690,4h,0,691,60,1,692,4h,0,693,60,1,694,4h,0,695,60,1,696,4h,0,697,60,1,698,4h,0,699,60,1,69a,4h,0,69b,60,1,69c,4h,0,69d,60,1,69e,4h,0,69f,60,1,69g,4h,0,69h,60,1,69i,4h,0,69j,60,1,69k,4h,0,69l,60,1,69m,4h,0,69n,60,1,69o,4h,0,69p,60,1,69q,4h,0,69r,60,1,69s,4h,0,69t,60,1,69u,4h,0,69v,60,1,6a0,4h,0,6a1,60,1,6a2,4h,0,6a3,60,1,6a4,4h,0,6a5,60,1,6a6,4h,0,6a7,60,1,6a8,4h,0,6a9,60,1,6aa,4h,0,6ab,60,1,6ac,4h,0,6ad,60,1,6ae,4h,0,6af,60,1,6ag,4h,0,6ah,60,1,6ai,4h,0,6aj,60,1,6ak,4h,0,6al,60,1,6am,4h,0,6an,60,1,6ao,4h,0,1,60,1",
        "Australia/Currie||3la,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3lm,35,0,3ln,32,1,3lo,35,0,3lp,32,1,3lq,35,0,3lr,32,1,3ls,35,0,3lt,32,1,3lu,35,0,3lv,32,1,3m0,35,0,3m1,32,1,3m2,35,0,3m3,32,1,3m4,35,0,3m5,32,1,3m6,35,0,3m7,32,1,3m8,35,0,3m9,32,1,3ma,35,0,3mb,32,1,3mc,35,0,3md,32,1,3me,35,0,3mf,32,1,3mg,35,0,3mh,32,1,3mi,35,0,3mj,32,1,3mk,35,0,3ml,32,1,3mm,35,0,3mn,32,1,3mo,35,0,3mp,32,1,3mq,35,0,3mr,32,1,3ms,35,0,3mt,32,1,3mu,35,0,3mv,32,1,3n0,35,0,3n1,32,1,3n2,35,0,3n3,32,1,3n4,35,0,3n5,32,1,3n6,35,0,3n7,32,1,3n8,35,0,3n9,32,1,3na,35,0,3nb,32,1,3nc,35,0,3nd,32,1,3ne,35,0,3nf,32,1,3ng,35,0,3nh,32,1,3ni,35,0,3nj,32,1,3nk,35,0,3nl,32,1,3nm,35,0,3nn,32,1,3no,35,0,3np,32,1,3nq,35,0,3nr,32,1,3ns,35,0,3nt,32,1,3nu,35,0,3nv,32,1,3o0,35,0,3o1,32,1,3o2,35,0,3o3,32,1,64l,35,0,64m,32,1,64n,35,0,64o,32,1,64p,35,0,64q,32,1,64r,35,0,64s,32,1,64t,35,0,64u,32,1,64v,35,0,650,32,1,651,35,0,652,32,1,653,35,0,654,32,1,655,35,0,656,32,1,657,35,0,658,32,1,659,35,0,65a,32,1,65b,35,0,65c,32,1,65d,35,0,65e,32,1,65f,35,0,65g,32,1,65h,35,0,65i,32,1,65j,35,0,65k,32,1,65l,35,0,65m,32,1,65n,35,0,65o,32,1,65p,35,0,65q,32,1,65r,35,0,65s,32,1,65t,35,0,65u,32,1,65v,35,0,660,32,1,661,35,0,662,32,1,663,35,0,664,32,1,665,35,0,666,32,1,667,35,0,668,32,1,669,35,0,66a,32,1,66b,35,0,1,32,1",
        "Australia/Darwin,Australia/North||66c,4h,0,66d,60,1,66e,4h,0,66f,60,1,66g,4h,0,66h,60,1,66i,4h,0,66j,60,1,1,4h,0",
        "Australia/Eucla||6au,61,0,6av,62,1,6b0,61,0,6b1,62,1,6b2,61,0,6b3,62,1,6b4,61,0,6b5,62,1,6b6,61,0,6b7,62,1,6b8,61,0,6b9,62,1,6ba,61,0,6bb,62,1,6bc,61,0,6bd,62,1,6be,61,0,6bf,62,1,1,61,0",
        "Australia/Hobart,Australia/Tasmania||3la,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3le,35,0,3lf,32,1,3lg,35,0,3lh,32,1,3li,35,0,3lj,32,1,3lk,35,0,3ll,32,1,3lm,35,0,3ln,32,1,3lo,35,0,3lp,32,1,3lq,35,0,3lr,32,1,3ls,35,0,3lt,32,1,3lu,35,0,3lv,32,1,3m0,35,0,3m1,32,1,3m2,35,0,3m3,32,1,3m4,35,0,3m5,32,1,3m6,35,0,3m7,32,1,3m8,35,0,3m9,32,1,3ma,35,0,3mb,32,1,3mc,35,0,3md,32,1,3me,35,0,3mf,32,1,3mg,35,0,3mh,32,1,3mi,35,0,3mj,32,1,3mk,35,0,3ml,32,1,3mm,35,0,3mn,32,1,3mo,35,0,3mp,32,1,3mq,35,0,3mr,32,1,3ms,35,0,3mt,32,1,3mu,35,0,3mv,32,1,3n0,35,0,3n1,32,1,3n2,35,0,3n3,32,1,3n4,35,0,3n5,32,1,3n6,35,0,3n7,32,1,3n8,35,0,3n9,32,1,3na,35,0,3nb,32,1,3nc,35,0,3nd,32,1,3ne,35,0,3nf,32,1,3ng,35,0,3nh,32,1,3ni,35,0,3nj,32,1,3nk,35,0,3nl,32,1,3nm,35,0,3nn,32,1,3no,35,0,3np,32,1,3nq,35,0,3nr,32,1,3ns,35,0,3nt,32,1,3nu,35,0,3nv,32,1,3o0,35,0,3o1,32,1,3o2,35,0,3o3,32,1,64l,35,0,64m,32,1,64n,35,0,64o,32,1,64p,35,0,64q,32,1,64r,35,0,64s,32,1,64t,35,0,64u,32,1,64v,35,0,650,32,1,651,35,0,652,32,1,653,35,0,654,32,1,655,35,0,656,32,1,657,35,0,658,32,1,659,35,0,65a,32,1,65b,35,0,65c,32,1,65d,35,0,65e,32,1,65f,35,0,65g,32,1,65h,35,0,65i,32,1,65j,35,0,65k,32,1,65l,35,0,65m,32,1,65n,35,0,65o,32,1,65p,35,0,65q,32,1,65r,35,0,65s,32,1,65t,35,0,65u,32,1,65v,35,0,660,32,1,661,35,0,662,32,1,663,35,0,664,32,1,665,35,0,666,32,1,667,35,0,668,32,1,669,35,0,66a,32,1,66b,35,0,1,32,1",
        "Australia/LHI,Australia/Lord_Howe||3pe,35,0,6bg,60,0,6bh,37,1,6bi,60,0,6bj,37,1,6bk,60,0,6bl,37,1,6bm,60,0,6bn,37,1,6bo,60,0,6bp,32,1,6bq,60,0,6br,32,1,6bs,60,0,6bt,32,1,6bu,60,0,6bv,32,1,6c0,60,0,6c1,32,1,6c2,60,0,6c3,32,1,6c4,60,0,6c5,32,1,6c6,60,0,6c7,32,1,6c8,60,0,6c9,32,1,6ca,60,0,6cb,32,1,6cc,60,0,4iq,32,1,6cd,60,0,4is,32,1,6ce,60,0,4iu,32,1,6cf,60,0,5eq,32,1,6cg,60,0,5es,32,1,6ch,60,0,5eu,32,1,6ci,60,0,5f0,32,1,6cj,60,0,5f2,32,1,6ck,60,0,5f4,32,1,6cl,60,0,5f6,32,1,6cm,60,0,6cn,32,1,6co,60,0,5fa,32,1,6cp,60,0,6cq,32,1,6cr,60,0,6cs,32,1,6ct,60,0,6cu,32,1,6cv,60,0,6d0,32,1,6d1,60,0,6d2,32,1,6d3,60,0,6d4,32,1,6d5,60,0,6d6,32,1,6d7,60,0,6d8,32,1,6d9,60,0,6da,32,1,6db,60,0,6dc,32,1,6dd,60,0,6de,32,1,6df,60,0,6dg,32,1,6dh,60,0,6di,32,1,6dj,60,0,6dk,32,1,6dl,60,0,6dm,32,1,6dn,60,0,6do,32,1,6dp,60,0,6dq,32,1,6dr,60,0,6ds,32,1,6dt,60,0,6du,32,1,6dv,60,0,6e0,32,1,6e1,60,0,6e2,32,1,6e3,60,0,6e4,32,1,6e5,60,0,6e6,32,1,6e7,60,0,6e8,32,1,6e9,60,0,6ea,32,1,6eb,60,0,6ec,32,1,6ed,60,0,6ee,32,1,6ef,60,0,6eg,32,1,6eh,60,0,6ei,32,1,6ej,60,0,6ek,32,1,6el,60,0,1,32,1",
        "Australia/Lindeman||640,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3lm,35,0,3ln,32,1,3mq,35,0,64a,32,1,3ms,35,0,64b,32,1,64c,35,0,64d,32,1,64e,35,0,64f,32,1,64g,35,0,64h,32,1,1,35,0",
        "Australia/Melbourne,Australia/Victoria||640,35,0,3lb,32,1,641,35,0,642,32,1,643,35,0,644,32,1,645,35,0,646,32,1,3lm,35,0,3ln,32,1,3lo,35,0,3lp,32,1,3lq,35,0,3lr,32,1,3ls,35,0,3lt,32,1,3lu,35,0,3lv,32,1,3m0,35,0,3m1,32,1,3m2,35,0,3m3,32,1,3m4,35,0,3m5,32,1,3m6,35,0,3m7,32,1,3m8,35,0,3m9,32,1,3ma,35,0,6em,32,1,3mc,35,0,648,32,1,3me,35,0,3mf,32,1,3mg,35,0,3mh,32,1,3mi,35,0,649,32,1,3mk,35,0,3ml,32,1,6en,35,0,3mn,32,1,3mo,35,0,3mp,32,1,3mq,35,0,3mr,32,1,3ms,35,0,64b,32,1,64c,35,0,64d,32,1,64e,35,0,64f,32,1,64g,35,0,64h,32,1,64i,35,0,3n5,32,1,64k,35,0,3n7,32,1,5nm,35,0,3n9,32,1,5gn,35,0,3nb,32,1,5go,35,0,3nd,32,1,5gp,35,0,3nf,32,1,3ng,35,0,3nh,32,1,5gr,35,0,3nj,32,1,5gs,35,0,3nl,32,1,5gt,35,0,3nn,32,1,5b9,35,0,3np,32,1,5ba,35,0,3nr,32,1,5bc,35,0,3nt,32,1,5bd,35,0,3nv,32,1,3o0,35,0,3o1,32,1,3o2,35,0,3o3,32,1,64l,35,0,64m,32,1,64n,35,0,64o,32,1,64p,35,0,64q,32,1,64r,35,0,64s,32,1,64t,35,0,64u,32,1,64v,35,0,650,32,1,651,35,0,652,32,1,653,35,0,654,32,1,655,35,0,656,32,1,657,35,0,658,32,1,659,35,0,65a,32,1,65b,35,0,65c,32,1,65d,35,0,65e,32,1,65f,35,0,65g,32,1,65h,35,0,65i,32,1,65j,35,0,65k,32,1,65l,35,0,65m,32,1,65n,35,0,65o,32,1,65p,35,0,65q,32,1,65r,35,0,65s,32,1,65t,35,0,65u,32,1,65v,35,0,660,32,1,661,35,0,662,32,1,663,35,0,664,32,1,665,35,0,666,32,1,667,35,0,668,32,1,669,35,0,66a,32,1,66b,35,0,1,32,1",
        "Australia/Perth,Australia/West||6eo,31,0,6ep,41,1,6eq,31,0,6er,41,1,6es,31,0,6et,41,1,6eu,31,0,6ev,41,1,6f0,31,0,6f1,41,1,6f2,31,0,6f3,41,1,6f4,31,0,53r,41,1,53s,31,0,53t,41,1,53u,31,0,53v,41,1,1,31,0",
        "CET,MET||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,6fb,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "CST6CDT||1j6,12,0,14d,13,1,1j7,12,0,1j8,13,1,14f,12,0,ja,13,1,14g,13,1,1lu,12,0,1lv,13,1,1m0,12,0,1m1,13,1,1m2,12,0,1m3,13,1,1m4,12,0,1m5,13,1,1m6,12,0,1m7,13,1,1m8,12,0,1m9,13,1,1ma,12,0,1mb,13,1,1mc,12,0,1md,13,1,1me,12,0,1mf,13,1,1mg,12,0,1mh,13,1,1mi,12,0,1mj,13,1,1mk,12,0,1ml,13,1,1mm,12,0,1mn,13,1,1mo,12,0,1mp,13,1,1mq,12,0,1mr,13,1,1ms,12,0,1mt,13,1,1mu,12,0,1mv,13,1,1n0,12,0,1n1,13,1,1n2,12,0,1n3,13,1,1n4,12,0,1n5,13,1,1n6,12,0,1n7,13,1,1n8,12,0,1n9,13,1,1na,12,0,1nb,13,1,1nc,12,0,1nd,13,1,1ne,12,0,1nf,13,1,1ng,12,0,1nh,13,1,1ni,12,0,1nj,13,1,1nk,12,0,1nl,13,1,1nm,12,0,1nn,13,1,1no,12,0,1np,13,1,1nq,12,0,1nr,13,1,1ns,12,0,1ia,13,1,1ib,12,0,1ic,13,1,1f4,12,0,1f5,13,1,1nt,12,0,1nu,13,1,1if,12,0,1ig,13,1,1ih,12,0,1ii,13,1,1ij,12,0,1ik,13,1,1il,12,0,1im,13,1,1in,12,0,1io,13,1,1nv,12,0,1o0,13,1,1o1,12,0,1o2,13,1,1o3,12,0,1o4,13,1,1o5,12,0,1o6,13,1,1o7,12,0,1o8,13,1,1o9,12,0,1oa,13,1,1ob,12,0,1oc,13,1,1od,12,0,1oe,13,1,1of,12,0,1og,13,1,1oh,12,0,1oi,13,1,1oj,12,0,1ok,13,1,1ol,12,0,1om,13,1,1on,12,0,1oo,13,1,1op,12,0,1oq,13,1,1or,12,0,1os,13,1,1ot,12,0,1ou,13,1,1ov,12,0,1p0,13,1,1p1,12,0,1p2,13,1,1p3,12,0,1p4,13,1,1p5,12,0,1p6,13,1,1p7,12,0,1p8,13,1,1p9,12,0,1pa,13,1,1pb,12,0,1pc,13,1,1pd,12,0,1pe,13,1,1pf,12,0,1pg,13,1,1ph,12,0,1pi,13,1,1pj,12,0,1pk,13,1,1pl,12,0,1pm,13,1,1pn,12,0,1po,13,1,1pp,12,0,1pq,13,1,1pr,12,0,1ps,13,1,1,12,0",
        "Chile/EasterIsland,Pacific/Easter||6fd,63,0,37e,16,0,37f,12,1,37g,16,0,37h,12,1,37i,16,0,37j,12,1,37k,16,0,37l,12,1,37m,16,0,37n,12,1,37o,16,0,2uv,12,1,37p,16,0,37q,12,1,37r,16,0,37s,12,1,37t,16,0,37u,12,1,37v,16,0,380,12,1,381,16,0,382,12,1,2ln,16,0,383,12,1,2lp,16,0,384,12,1,2lr,16,0,385,12,1,2lt,12,0,386,13,1,2lv,12,0,387,13,1,2m1,12,0,388,13,1,2m3,12,0,389,13,1,2m5,12,0,38a,13,1,2m7,12,0,38b,13,1,2m9,12,0,38c,13,1,1fa,12,0,38d,13,1,38e,12,0,38f,13,1,38g,12,0,38h,13,1,38i,12,0,38j,13,1,38k,12,0,38l,13,1,38m,12,0,38n,13,1,1fl,12,0,38o,13,1,38p,12,0,38q,13,1,38r,12,0,38s,13,1,38t,12,0,38u,13,1,38v,12,0,390,13,1,391,12,0,392,13,1,1fs,12,0,393,13,1,394,12,0,395,13,1,396,12,0,397,13,1,398,12,0,12c,13,1,399,12,0,12e,13,1,12f,12,0,12g,13,1,1g7,12,0,39a,13,1,109,12,0,39b,13,1,10b,12,0,39c,13,1,39d,12,0,39e,13,1,39f,12,0,39g,13,1,39h,12,0,39i,13,1,39j,12,0,39k,13,1,39l,12,0,39m,13,1,39n,12,0,39o,13,1,39p,12,0,39q,13,1,39r,12,0,39s,13,1,39t,12,0,39u,13,1,39v,12,0,3a0,13,1,3a1,12,0,3a2,13,1,3a3,12,0,3a4,13,1,3a5,12,0,3a6,13,1,3a7,12,0,3a8,13,1,3a9,12,0,3aa,13,1,3ab,12,0,3ac,13,1,3ad,12,0,3ae,13,1,3af,12,0,3ag,13,1,3ah,12,0,3ai,13,1,3aj,12,0,3ak,13,1,3al,12,0,3am,13,1,3an,12,0,3ao,13,1,3ap,12,0,3aq,13,1,3ar,12,0,3as,13,1,3at,12,0,3au,13,1,3av,12,0,3b0,13,1,3b1,12,0,1,13,1",
        "EET||6fc,a,0,5re,5,1,5rf,a,0,5rg,5,1,5rh,a,0,5vl,5,1,3tq,a,0,1s2,5,1,1s3,a,0,1s4,5,1,1s5,a,0,1s6,5,1,1s7,a,0,1s8,5,1,1s9,a,0,1sa,5,1,1sb,a,0,1sc,5,1,a5,a,0,a6,5,1,a7,a,0,a8,5,1,a9,a,0,aa,5,1,ab,a,0,ac,5,1,ad,a,0,ae,5,1,af,a,0,ag,5,1,ah,a,0,ai,5,1,aj,a,0,ak,5,1,al,a,0,am,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "EST,Etc/GMT+5||1,13,0",
        "EST5EDT||32r,13,0,303,q,1,32s,13,0,32t,q,1,22f,13,0,ja,q,1,22g,q,1,32o,13,0,22k,q,1,2ou,13,0,2ov,q,1,29d,13,0,29e,q,1,29f,13,0,29g,q,1,2oc,13,0,2od,q,1,2oe,13,0,2of,q,1,22l,13,0,22m,q,1,22n,13,0,22o,q,1,2og,13,0,22q,q,1,22r,13,0,22s,q,1,22t,13,0,22u,q,1,22v,13,0,230,q,1,231,13,0,232,q,1,233,13,0,234,q,1,235,13,0,236,q,1,237,13,0,238,q,1,239,13,0,23a,q,1,23b,13,0,23c,q,1,23d,13,0,23e,q,1,23f,13,0,23g,q,1,23h,13,0,23i,q,1,23j,13,0,23k,q,1,23l,13,0,23m,q,1,23n,13,0,23o,q,1,23p,13,0,23q,q,1,23r,13,0,23s,q,1,23t,13,0,23u,q,1,23v,13,0,240,q,1,241,13,0,242,q,1,1i4,13,0,1i5,q,1,1i6,13,0,1i7,q,1,1i8,13,0,243,q,1,244,13,0,245,q,1,246,13,0,247,q,1,248,13,0,249,q,1,24a,13,0,24b,q,1,24c,13,0,24d,q,1,24e,13,0,24f,q,1,24g,13,0,24h,q,1,24i,13,0,24j,q,1,24k,13,0,24l,q,1,24m,13,0,24n,q,1,24o,13,0,24p,q,1,24q,13,0,24r,q,1,24s,13,0,24t,q,1,24u,13,0,24v,q,1,250,13,0,251,q,1,252,13,0,253,q,1,254,13,0,255,q,1,256,13,0,257,q,1,258,13,0,259,q,1,25a,13,0,25b,q,1,25c,13,0,25d,q,1,25e,13,0,25f,q,1,25g,13,0,25h,q,1,25i,13,0,25j,q,1,25k,13,0,25l,q,1,25m,13,0,25n,q,1,25o,13,0,25p,q,1,25q,13,0,25r,q,1,25s,13,0,25t,q,1,25u,13,0,25v,q,1,260,13,0,261,q,1,262,13,0,263,q,1,264,13,0,265,q,1,266,13,0,267,q,1,268,13,0,269,q,1,26a,13,0,26b,q,1,26c,13,0,26d,q,1,26e,13,0,26f,q,1,26g,13,0,26h,q,1,1,13,0",
        "Eire,Europe/Dublin||6fe,64,0,6ff,65,1,6fg,1,0,6fh,9,1,6fi,1,0,6fj,9,1,6fk,1,0,6fl,9,1,6fm,1,0,6fn,9,1,6fo,1,0,6fp,9,1,6fq,1,0,6fr,9,1,6fs,1,0,6ft,9,1,6fu,1,0,6fv,9,1,6g0,1,0,6g1,9,1,6g2,1,0,6g3,9,1,6g4,1,0,6g5,9,1,6g6,1,0,6g7,9,1,6g8,1,0,6g9,9,1,6ga,1,0,6gb,9,1,6gc,1,0,6gd,9,1,6ge,1,0,6gf,9,1,6gg,1,0,6gh,9,1,6gi,1,0,6gj,9,1,6gk,1,0,6gl,9,1,6gm,1,0,6gn,9,1,6go,1,0,6gp,9,1,6gq,1,0,6gr,9,1,6gs,1,0,6gt,9,1,24,1,0,5q8,9,1,6gu,1,0,6gv,9,1,6h0,1,0,6h1,9,1,60l,1,0,60m,9,1,33v,1,0,60o,9,1,6h2,1,0,6h3,9,1,6h4,1,0,60r,9,1,6h5,1,0,6h6,9,1,6h7,1,0,6h8,9,1,6h9,1,0,6ha,9,1,6hb,1,0,6hc,9,1,6hd,1,0,6he,9,1,6hf,1,0,6hg,9,1,6hh,1,0,6hi,9,1,6hj,1,0,6hk,9,1,6hl,1,0,6hm,9,1,6hn,1,0,61f,9,1,6ho,1,0,61h,9,1,6hp,1,0,61j,9,1,6hq,1,0,61l,9,1,6hr,1,0,61n,9,1,6hs,1,0,61p,9,1,6ht,1,0,6hu,9,0,6hv,1,0,6i0,9,1,6i1,1,0,6i2,9,1,6i3,1,0,6i4,9,1,6i5,1,0,6i6,9,1,6i7,1,0,6i8,9,1,6i9,1,0,6ia,9,1,6ib,1,0,6ic,9,1,6id,1,0,6ie,9,1,6if,1,0,6ig,9,1,1s3,1,0,6ih,9,1,1s5,1,0,6ii,9,1,1s7,1,0,6ij,9,1,1s9,1,0,6ik,9,1,1sb,1,0,6il,9,1,a5,1,0,6im,9,1,a7,1,0,6in,9,1,a9,1,0,6io,9,1,ab,1,0,6ip,9,1,ad,1,0,6iq,9,1,af,1,0,6ir,9,1,ah,1,0,6is,9,1,aj,1,0,6it,9,1,al,1,0,6iu,9,1,an,1,0,6iv,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Etc/GMT+0,Etc/GMT-0,Etc/GMT,Etc/GMT0,Etc/Greenwich,Etc/UCT,Etc/UTC,Etc/Universal,Etc/Zulu,GMT+0,GMT-0,GMT,GMT0,Greenwich,UCT,UTC,Universal,Zulu||1,1,0",
        "Etc/GMT+1||1,d,0",
        "Etc/GMT+10,HST||1,m,0",
        "Etc/GMT+11||1,l,0",
        "Etc/GMT+12||1,66,0",
        "Etc/GMT+3||1,s,0",
        "Etc/GMT+4||1,q,0",
        "Etc/GMT+6||1,12,0",
        "Etc/GMT+7,MST||1,16,0",
        "Etc/GMT+8||1,o,0",
        "Etc/GMT+9||1,n,0",
        "Etc/GMT-1||1,9,0",
        "Etc/GMT-10,Pacific/Chuuk,Pacific/Port_Moresby,Pacific/Truk,Pacific/Yap||1,35,0",
        "Etc/GMT-11,Pacific/Pohnpei,Pacific/Ponape||1,32,0",
        "Etc/GMT-12,Pacific/Funafuti,Pacific/Tarawa,Pacific/Wake,Pacific/Wallis||1,39,0",
        "Etc/GMT-13||1,3a,0",
        "Etc/GMT-14||1,3f,0",
        "Etc/GMT-2||1,a,0",
        "Etc/GMT-3||1,5,0",
        "Etc/GMT-4||1,3h,0",
        "Etc/GMT-5||1,34,0",
        "Etc/GMT-6||1,36,0",
        "Etc/GMT-7,Indian/Christmas||1,33,0",
        "Etc/GMT-8||1,31,0",
        "Etc/GMT-9,Pacific/Palau||1,41,0",
        "Europe/Amsterdam||6j0,67,0,6j1,68,1,6j2,67,0,6j3,68,1,6j4,67,0,6j5,68,1,6j6,67,0,6j7,68,1,6j8,67,0,6j9,68,1,6ja,67,0,6jb,68,1,6jc,67,0,6jd,68,1,6je,67,0,6jf,68,1,6jg,67,0,6jh,68,1,6ji,67,0,6jj,68,1,6jk,67,0,6jl,68,1,6jm,67,0,6jn,68,1,6jo,67,0,6jp,68,1,6jq,67,0,6jr,68,1,6js,67,0,6jt,68,1,6ju,67,0,6jv,68,1,6k0,67,0,6k1,68,1,6k2,67,0,6k3,68,1,6k4,67,0,6k5,68,1,6k6,67,0,6k7,68,1,6k8,67,0,6k9,68,1,6ka,67,0,6kb,68,1,6kc,69,1,6kd,3,0,6ke,69,1,6kf,3,0,6kg,69,1,6kh,3,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,6fb,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Andorra||6ki,1,0,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Astrakhan||6kj,6a,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,gd,3h,1,561,5,0,ge,3h,1,562,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,6kv,5,0,1,3h,0",
        "Europe/Athens||6l0,6b,0,6l1,a,0,6l2,5,1,6l3,a,0,6l4,5,1,g0,a,1,6l5,9,0,6l6,a,1,6l7,9,0,6l8,a,0,6l9,5,1,6la,a,0,6lb,5,1,6lc,a,0,6ld,5,1,6le,a,0,6lf,5,1,5vj,a,0,6lg,5,1,6lh,a,0,6li,5,1,6lj,a,0,4pv,5,1,1s3,a,0,1s4,5,1,1s5,a,0,1s6,5,1,1s7,a,0,1s8,5,1,1s9,a,0,1sa,5,1,1sb,a,0,1sc,5,1,a5,a,0,a6,5,1,a7,a,0,a8,5,1,a9,a,0,aa,5,1,ab,a,0,ac,5,1,ad,a,0,ae,5,1,af,a,0,ag,5,1,ah,a,0,ai,5,1,aj,a,0,ak,5,1,al,a,0,am,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Belfast,Europe/Guernsey,Europe/Isle_of_Man,Europe/Jersey,Europe/London,GB-Eire,GB||6lk,1,0,6ll,9,1,6fg,1,0,6fh,9,1,6fi,1,0,6fj,9,1,6fk,1,0,6fl,9,1,6fm,1,0,6fn,9,1,6fo,1,0,6fp,9,1,6fq,1,0,6fr,9,1,6fs,1,0,6ft,9,1,6fu,1,0,6fv,9,1,6g0,1,0,6g1,9,1,6g2,1,0,6g3,9,1,6g4,1,0,6g5,9,1,6g6,1,0,6g7,9,1,6g8,1,0,6g9,9,1,6ga,1,0,6gb,9,1,6gc,1,0,6gd,9,1,6ge,1,0,6gf,9,1,6gg,1,0,6gh,9,1,6gi,1,0,6gj,9,1,6gk,1,0,6gl,9,1,6gm,1,0,6gn,9,1,6go,1,0,6gp,9,1,6gq,1,0,6gr,9,1,6gs,1,0,6gt,9,1,24,1,0,6lm,9,1,6ln,a,1,6lo,9,1,6lp,a,1,6lq,9,1,6lr,a,1,6ls,9,1,6lt,a,1,27,9,1,6lu,a,1,6lv,9,1,6m0,1,0,6m1,9,1,6gu,1,0,6m2,9,1,6m3,a,1,6m4,9,1,6m5,1,0,6h1,9,1,60l,1,0,60m,9,1,33v,1,0,60o,9,1,6h2,1,0,6h3,9,1,6h4,1,0,60r,9,1,6h5,1,0,6h6,9,1,6h7,1,0,6h8,9,1,6h9,1,0,6ha,9,1,6hb,1,0,6hc,9,1,6hd,1,0,6he,9,1,6hf,1,0,6hg,9,1,6hh,1,0,6hi,9,1,6hj,1,0,6hk,9,1,6hl,1,0,6hm,9,1,6hn,1,0,61f,9,1,6ho,1,0,61h,9,1,6hp,1,0,61j,9,1,6hq,1,0,61l,9,1,6hr,1,0,61n,9,1,6hs,1,0,61p,9,1,6ht,1,0,6hu,9,0,6hv,1,0,6i0,9,1,6i1,1,0,6i2,9,1,6i3,1,0,6i4,9,1,6i5,1,0,6i6,9,1,6i7,1,0,6i8,9,1,6i9,1,0,6ia,9,1,6ib,1,0,6ic,9,1,6id,1,0,6ie,9,1,6if,1,0,6ig,9,1,1s3,1,0,6ih,9,1,1s5,1,0,6ii,9,1,1s7,1,0,6ij,9,1,1s9,1,0,6ik,9,1,1sb,1,0,6il,9,1,a5,1,0,6im,9,1,a7,1,0,6in,9,1,a9,1,0,6io,9,1,ab,1,0,6ip,9,1,ad,1,0,6iq,9,1,af,1,0,6ir,9,1,ah,1,0,6is,9,1,aj,1,0,6it,9,1,al,1,0,6iu,9,1,an,1,0,6iv,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Europe/Belgrade,Europe/Ljubljana,Europe/Podgorica,Europe/Sarajevo,Europe/Skopje,Europe/Zagreb||6m6,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,6m7,9,0,6fb,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Berlin||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,6m8,a,1,6m9,5,1,6ma,a,1,6mb,9,0,6mc,a,1,60h,9,0,6md,a,1,6me,5,1,6mf,a,1,6mg,9,0,6mh,a,1,6mi,9,0,6mj,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Bratislava,Europe/Prague||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,6lt,a,1,6mk,9,0,6ma,a,1,6ml,9,0,5q8,a,1,6mm,9,0,6mf,a,1,6mg,9,0,6mh,a,1,6mn,9,0,6mj,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Brussels||6mo,1,0,6mp,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,6mq,9,0,1s,1,0,6mr,9,1,1u,1,0,1v,9,1,20,1,0,6ms,9,1,6mt,1,0,6mu,9,1,6mv,1,0,4lu,9,1,6n0,1,0,9u,9,1,6n1,1,0,6n2,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,6g7,9,1,6g8,1,0,6g9,9,1,6ga,1,0,6gb,9,1,6gc,1,0,6gd,9,1,6n3,1,0,6gf,9,1,6n4,1,0,6gh,9,1,6n5,1,0,6gj,9,1,6n6,1,0,6gl,9,1,6gm,1,0,6gn,9,1,6n7,1,0,6gp,9,1,6n8,1,0,6gr,9,1,6gs,1,0,6gt,9,1,24,1,0,6n9,9,1,g0,a,1,g1,9,0,3t9,a,1,25,9,0,6lt,a,1,27,9,0,6fb,a,1,6na,9,0,6mc,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Bucharest||6nb,6c,0,6nc,a,0,6nd,5,1,6ne,a,0,6nf,5,1,6ng,a,0,6nh,5,1,6ni,a,0,6nj,5,1,6nk,a,0,6nl,5,1,6nm,a,0,6nn,5,1,6no,a,0,6np,5,1,6nq,a,0,6nr,5,1,6ns,a,0,4pt,5,1,6nt,a,0,6nu,5,1,55k,a,0,6nv,5,1,55m,a,0,6o0,5,1,6o1,a,0,6o2,5,1,6o3,a,0,6o4,5,1,6o5,a,0,6o6,5,1,6o7,a,0,6o8,5,1,6o9,a,0,6oa,5,1,6ob,a,0,6oc,5,1,6od,a,0,6oe,5,1,6of,a,0,6og,5,1,4q7,a,0,45j,5,1,4q8,a,0,5g5,5,1,4d0,a,0,5g6,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,46j,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Budapest||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6oh,9,0,6f9,a,1,6oi,9,0,6oj,a,1,6ok,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,6ol,9,0,6om,a,1,6on,9,0,5q8,a,1,6oo,9,0,6mf,a,1,6op,9,0,6mh,a,1,6mi,9,0,6mj,a,1,6oq,9,0,6or,a,1,6os,9,0,6ot,a,1,6ou,9,0,6ov,a,1,6p0,9,0,6p1,a,1,6p2,9,0,6p3,a,1,55i,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Busingen,Europe/Vaduz,Europe/Zurich||6p4,9,0,5ts,a,1,6p5,9,0,6p6,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Chisinau,Europe/Tiraspol||6p7,6d,0,6nb,6c,0,6nc,a,0,6nd,5,1,6ne,a,0,6nf,5,1,6ng,a,0,6nh,5,1,6ni,a,0,6nj,5,1,6nk,a,0,6nl,5,1,6nm,a,0,6nn,5,1,6no,a,0,6np,5,1,6nq,a,0,6nr,5,1,6p8,a,0,6p9,5,1,g0,a,1,g1,9,0,3t9,a,1,25,9,0,6pa,a,1,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,6pi,3h,1,6og,5,1,6pj,a,0,6pk,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,46j,5,1,495,a,0,496,5,1,497,a,0,498,5,1,499,a,0,49a,5,1,49b,a,0,49c,5,1,49d,a,0,49e,5,1,49f,a,0,49g,5,1,49h,a,0,49i,5,1,49j,a,0,49k,5,1,49l,a,0,49m,5,1,49n,a,0,49o,5,1,49p,a,0,49q,5,1,49r,a,0,49s,5,1,49t,a,0,49u,5,1,49v,a,0,4a0,5,1,4a1,a,0,4a2,5,1,4a3,a,0,4a4,5,1,4a5,a,0,4a6,5,1,4a7,a,0,4a8,5,1,4a9,a,0,4aa,5,1,6pl,a,0,6pm,5,1,6pn,a,0,6po,5,1,6pp,a,0,6pq,5,1,6pr,a,0,6ps,5,1,6pt,a,0,6pu,5,1,6pv,a,0,6q0,5,1,6q1,a,0,6q2,5,1,6q3,a,0,6q4,5,1,6q5,a,0,6q6,5,1,6q7,a,0,6q8,5,1,6q9,a,0,6qa,5,1,6qb,a,0,6qc,5,1,6qd,a,0,6qe,5,1,6qf,a,0,6qg,5,1,6qh,a,0,6qi,5,1,6qj,a,0,6qk,5,1,6ql,a,0,6qm,5,1,6qn,a,0,6qo,5,1,6qp,a,0,6qq,5,1,6qr,a,0,6qs,5,1,6qt,a,0,6qu,5,1,6qv,a,0,6r0,5,1,1,a,0",
        "Europe/Copenhagen||6r1,9,0,547,a,1,6r2,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,6r3,a,1,6r4,9,0,6r5,a,1,6r6,9,0,6m3,a,1,6r7,9,0,6r8,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Gibraltar||6lk,1,0,6ll,9,1,6fg,1,0,6fh,9,1,6fi,1,0,6fj,9,1,6fk,1,0,6fl,9,1,6fm,1,0,6fn,9,1,6fo,1,0,6fp,9,1,6fq,1,0,6fr,9,1,6fs,1,0,6ft,9,1,6fu,1,0,6fv,9,1,6g0,1,0,6g1,9,1,6g2,1,0,6g3,9,1,6g4,1,0,6g5,9,1,6g6,1,0,6g7,9,1,6g8,1,0,6g9,9,1,6ga,1,0,6gb,9,1,6gc,1,0,6gd,9,1,6ge,1,0,6gf,9,1,6gg,1,0,6gh,9,1,6gi,1,0,6gj,9,1,6gk,1,0,6gl,9,1,6gm,1,0,6gn,9,1,6go,1,0,6gp,9,1,6gq,1,0,6gr,9,1,6gs,1,0,6gt,9,1,24,1,0,6lm,9,1,6ln,a,1,6lo,9,1,6lp,a,1,6lq,9,1,6lr,a,1,6ls,9,1,6lt,a,1,27,9,1,6lu,a,1,6lv,9,1,6m0,1,0,6m1,9,1,6gu,1,0,6m2,9,1,6m3,a,1,6m4,9,1,6m5,1,0,6h1,9,1,60l,1,0,60m,9,1,33v,1,0,60o,9,1,6h2,1,0,6h3,9,1,6h4,1,0,60r,9,1,6h5,1,0,6h6,9,1,6h7,1,0,6h8,9,1,6h9,1,0,6ha,9,1,6hb,1,0,6hc,9,1,6hd,1,0,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Helsinki,Europe/Mariehamn||6r9,6e,0,6ra,a,0,6rb,5,1,55k,a,0,6nv,5,1,55m,a,0,6o0,5,1,1s7,a,0,1s8,5,1,1s9,a,0,1sa,5,1,1sb,a,0,1sc,5,1,a5,a,0,a6,5,1,a7,a,0,a8,5,1,a9,a,0,aa,5,1,ab,a,0,ac,5,1,ad,a,0,ae,5,1,af,a,0,ag,5,1,ah,a,0,ai,5,1,aj,a,0,ak,5,1,al,a,0,am,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Kaliningrad||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,6rc,9,0,6rd,a,0,35,5,1,6re,a,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,6oe,5,1,6of,a,0,6og,5,1,6pj,a,0,6pk,5,1,6rf,a,0,6rg,5,1,6rh,a,0,6ri,5,1,6rj,a,0,6rk,5,1,6rl,a,0,6rm,5,1,6rn,a,0,6ro,5,1,495,a,0,496,5,1,497,a,0,498,5,1,499,a,0,49a,5,1,49b,a,0,49c,5,1,49d,a,0,49e,5,1,49f,a,0,49g,5,1,49h,a,0,49i,5,1,49j,a,0,49k,5,1,49l,a,0,49m,5,1,49n,a,0,49o,5,1,49p,a,0,49q,5,1,49r,a,0,49s,5,1,49t,a,0,49u,5,1,49v,a,0,4a0,5,1,4a1,a,0,596,5,0,1,a,0",
        "Europe/Kiev||6rp,6f,0,6rq,a,0,6rr,5,0,g0,a,1,g1,9,0,3t9,a,1,6rs,9,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,6rt,3h,1,6pk,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Kirov||6ru,6g,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,gd,3h,1,561,5,0,ge,3h,1,562,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,1,5,0",
        "Europe/Lisbon,Portugal||6rv,6h,0,6s0,1,0,6s1,9,1,6s2,1,0,6s3,9,1,6s4,1,0,6s5,9,1,6s6,1,0,6s7,9,1,6s8,1,0,6s9,9,1,6sa,1,0,6sb,9,1,9t,1,0,6sc,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,a4,9,1,6sd,1,0,6se,9,1,6sf,1,0,6sg,9,1,6sh,1,0,6si,9,1,6sj,1,0,6sk,9,1,6sl,1,0,6sm,9,1,6sn,1,0,6so,9,1,6sp,1,0,6sq,9,1,6sr,1,0,6ss,9,1,6st,1,0,6q,9,1,6su,1,0,6sv,9,1,6t0,1,0,6t1,9,1,6t2,1,0,6t3,9,1,6t4,a,1,6t5,9,1,6t6,1,0,6t7,9,1,6t8,a,1,6t9,9,1,6ta,1,0,6tb,9,1,6tc,a,1,6td,9,1,6te,1,0,6tf,9,1,6tg,a,1,6th,9,1,6ti,1,0,6tj,9,1,60h,1,0,6tk,9,1,60j,1,0,6tl,9,1,60l,1,0,6tm,9,1,sf,1,0,6tn,9,1,60q,1,0,6to,9,1,60s,1,0,6h6,9,1,60u,1,0,6h8,9,1,610,1,0,6ha,9,1,612,1,0,6hc,9,1,614,1,0,6he,9,1,616,1,0,6hg,9,1,618,1,0,6hi,9,1,61a,1,0,6hk,9,1,61c,1,0,6tp,9,1,61e,1,0,6tq,9,1,61g,1,0,6tr,9,1,61i,1,0,6ts,9,1,61k,1,0,6tt,9,1,61m,1,0,6tu,9,0,5vh,1,0,5vi,9,1,5vj,1,0,4h,9,1,5vk,1,0,5vl,9,1,5vm,1,0,1s2,9,1,1s3,1,0,1s4,9,1,1s5,1,0,1s6,9,1,5vn,1,0,1s8,9,1,1s9,1,0,1sa,9,1,1sb,1,0,1sc,9,1,a5,1,0,a6,9,1,a7,1,0,a8,9,1,a9,1,0,aa,9,1,ab,1,0,ac,9,1,ad,1,0,ae,9,1,af,1,0,ag,9,1,ah,1,0,ai,9,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0",
        "Europe/Luxembourg||6tv,6i,0,6r1,9,0,6f5,a,1,6u0,9,0,6u1,a,1,6f8,9,0,6f9,a,1,6u2,9,0,1s,1,0,6u3,9,1,1u,1,0,6u4,9,1,20,1,0,6u5,9,1,6mt,1,0,6u6,9,1,6mv,1,0,6u7,9,1,6n0,1,0,6u8,9,1,6u9,1,0,6ua,9,1,9v,1,0,5t4,9,1,a1,1,0,5t6,9,1,a3,1,0,5t8,9,1,6sd,1,0,6g9,9,1,6ga,1,0,6gb,9,1,6gc,1,0,6gd,9,1,6n3,1,0,6gf,9,1,6n4,1,0,6gh,9,1,6n5,1,0,6gj,9,1,6n6,1,0,6gl,9,1,6gm,1,0,6gn,9,1,6n7,1,0,6gp,9,1,6n8,1,0,6gr,9,1,6gs,1,0,6gt,9,1,24,1,0,6ub,9,1,g0,a,1,g1,9,0,3t9,a,1,25,9,0,6uc,a,1,27,9,0,6fb,a,1,6na,9,0,6mc,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Madrid||6ud,1,0,6ue,9,1,6uf,1,0,1r,9,1,6ug,1,0,6uh,9,1,9t,1,0,9u,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,a4,9,1,6sd,1,0,6se,9,1,6ui,1,0,6sq,9,1,6uj,1,0,6ss,9,1,6st,1,0,6uk,9,1,6ul,1,0,6um,9,1,6un,a,1,6t7,9,1,6l6,a,1,6uo,9,1,6up,a,1,6uq,9,1,6ur,a,1,6us,9,1,6ut,a,1,57h,9,0,6uu,a,1,6uv,9,0,6v0,a,1,4qj,9,0,6v1,a,1,6v2,9,0,6v3,a,1,4po,9,0,6v4,a,1,6v5,9,0,g9,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Malta||6v6,9,0,6v7,a,1,6v8,9,0,6v9,a,1,1q,9,0,6va,a,1,1s,9,0,6vb,a,1,6vc,9,0,6vd,a,1,6ve,9,0,g0,a,1,g1,9,0,3t9,a,1,6ls,9,0,6lt,a,1,27,9,0,6vf,a,1,6vg,9,0,5q8,a,1,6vh,9,0,6vi,a,1,6vj,9,0,6mh,a,1,6vk,9,0,6vl,a,1,6vm,9,0,6vn,a,1,6vo,9,0,6vp,a,1,6vq,9,0,6vr,a,1,6vs,9,0,6vt,a,1,6vu,9,0,6vv,a,1,700,9,0,4mj,a,1,701,9,0,702,a,1,703,9,0,704,a,1,705,9,0,706,a,1,707,9,0,708,a,1,709,9,0,70a,a,1,70b,9,0,70c,a,1,70d,9,0,70e,a,1,70f,9,0,70g,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Minsk||70h,6j,0,6rq,a,0,70i,5,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,70j,a,1,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,562,5,0,6pk,5,1,6rf,a,0,6rg,5,1,6rh,a,0,6ri,5,1,6rj,a,0,6rk,5,1,6rl,a,0,6rm,5,1,6rn,a,0,6ro,5,1,495,a,0,496,5,1,497,a,0,498,5,1,499,a,0,49a,5,1,49b,a,0,49c,5,1,49d,a,0,49e,5,1,49f,a,0,49g,5,1,49h,a,0,49i,5,1,49j,a,0,49k,5,1,49l,a,0,49m,5,1,49n,a,0,49o,5,1,49p,a,0,49q,5,1,49r,a,0,49s,5,1,49t,a,0,49u,5,1,49v,a,0,4a0,5,1,4a1,a,0,1,5,0",
        "Europe/Monaco||1l,8,0,1m,1,0,1n,9,1,1o,1,0,1p,9,1,1q,1,0,1r,9,1,1s,1,0,1t,9,1,1u,1,0,1v,9,1,20,1,0,6ms,9,1,6mt,1,0,6mu,9,1,70k,1,0,4lu,9,1,6n0,1,0,9u,9,1,6n1,1,0,6n2,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,a4,9,1,6sd,1,0,6se,9,1,70l,1,0,70m,9,1,6sf,1,0,6sg,9,1,6sh,1,0,6si,9,1,70n,1,0,70o,9,1,6sj,1,0,6sk,9,1,6sl,1,0,6sm,9,1,6sn,1,0,6so,9,1,6sp,1,0,6sq,9,1,6sr,1,0,6ss,9,1,6st,1,0,6q,9,1,24,1,0,70p,9,1,fu,a,1,fv,9,1,g0,a,1,g1,9,1,3t9,a,1,25,9,1,70q,a,1,27,9,1,6fb,a,1,70r,9,0,6v3,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Moscow,W-SU||70s,6,0,70t,6k,0,70u,6l,1,70v,6k,0,710,6m,1,711,6l,1,6ru,6m,1,712,3h,1,713,5,0,714,3h,1,715,34,1,716,3h,1,717,5,0,6rq,a,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,ge,3h,1,562,5,0,6pk,5,1,718,a,0,494,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,1,5,0",
        "Europe/Paris||719,8,0,1m,1,0,1n,9,1,1o,1,0,1p,9,1,1q,1,0,1r,9,1,1s,1,0,1t,9,1,1u,1,0,1v,9,1,20,1,0,6ms,9,1,6mt,1,0,6mu,9,1,70k,1,0,4lu,9,1,6n0,1,0,9u,9,1,6n1,1,0,6n2,9,1,9v,1,0,a0,9,1,a1,1,0,a2,9,1,a3,1,0,a4,9,1,6sd,1,0,6se,9,1,70l,1,0,70m,9,1,6sf,1,0,6sg,9,1,6sh,1,0,6si,9,1,70n,1,0,70o,9,1,6sj,1,0,6sk,9,1,6sl,1,0,6sm,9,1,6sn,1,0,6so,9,1,6sp,1,0,6sq,9,1,6sr,1,0,6ss,9,1,6st,1,0,6q,9,1,24,1,0,71a,9,1,g0,a,1,g1,9,0,3t9,a,1,25,9,0,71b,a,1,70q,a,1,27,9,1,6fb,a,1,70r,9,0,6v3,a,1,6fc,9,0,5re,a,1,5rf,9,0,5rg,a,1,5rh,9,0,5vl,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Riga||71c,6n,0,71d,6o,1,71e,6n,0,71f,6o,1,71g,6n,0,71h,a,0,71i,5,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,71j,9,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,6oe,5,1,6of,a,0,6og,5,1,6pj,a,0,6pk,5,1,6rf,a,0,6rg,5,1,6rh,a,0,6ri,5,1,6rj,a,0,6rk,5,1,6rl,a,0,6rm,5,1,6rn,a,0,71k,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Rome,Europe/San_Marino,Europe/Vatican||6v6,9,0,6v7,a,1,6v8,9,0,6v9,a,1,1q,9,0,6va,a,1,1s,9,0,6vb,a,1,6vc,9,0,6vd,a,1,6ve,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,6lt,a,1,27,9,0,6vf,a,1,6vg,9,0,5q8,a,1,6vh,9,0,6vi,a,1,6vj,9,0,6mh,a,1,6vk,9,0,6vl,a,1,6vm,9,0,6vn,a,1,6vo,9,0,6vp,a,1,6vq,9,0,6vr,a,1,6vs,9,0,6vt,a,1,6vu,9,0,6vv,a,1,700,9,0,4mj,a,1,558,9,0,71l,a,1,71m,9,0,71n,a,1,71o,9,0,71p,a,1,71q,9,0,6v3,a,1,71r,9,0,6v4,a,1,71s,9,0,g9,a,1,71t,9,0,71u,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Samara||6ru,6p,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,gd,3h,1,561,5,0,ge,3h,1,71v,5,0,4q8,3h,0,5g5,34,1,4d0,3h,0,5g6,34,1,4d1,3h,0,5g7,34,1,45r,3h,0,45s,34,1,45t,3h,0,45u,34,1,45v,3h,0,460,34,1,461,3h,0,462,34,1,463,3h,0,464,34,1,465,3h,0,466,34,1,467,3h,0,468,34,1,469,3h,0,46a,34,1,46b,3h,0,46c,34,1,46d,3h,0,5o4,34,1,4d5,3h,0,5o5,34,1,4d7,3h,0,5o6,34,1,4d9,3h,0,5o7,34,1,4db,3h,0,5o8,34,1,4dd,3h,0,5o9,34,1,6ks,3h,1,6kt,5,0,1,3h,0",
        "Europe/Saratov||6ru,6q,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,ge,3h,1,562,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,720,5,0,1,3h,0",
        "Europe/Simferopol||721,6r,0,6rq,a,0,722,5,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,723,a,1,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,724,5,0,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,725,5,1,3up,3h,1,46g,5,0,3ur,3h,1,46i,5,0,6ro,3h,1,ar,5,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,4a7,a,0,6ku,3h,0,1,5,0",
        "Europe/Sofia||g0,a,0,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,726,9,0,727,a,0,728,5,1,6nt,a,0,729,5,1,72a,a,0,72b,5,1,72c,a,0,6o0,5,1,6o1,a,0,6o2,5,1,6o3,a,0,6o4,5,1,6o5,a,0,6o6,5,1,6o7,a,0,6o8,5,1,6o9,a,0,6oa,5,1,6ob,a,0,6oc,5,1,6od,a,0,6oe,5,1,6of,a,0,6og,5,1,4q7,a,0,3ui,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,45r,a,0,46h,5,1,45t,a,0,46j,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Stockholm||6r1,9,0,6f5,a,1,3tq,9,0,1s2,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Tallinn||72d,6e,0,6f8,9,0,6f9,a,1,72e,9,0,72f,6e,0,72g,a,0,72h,5,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,72i,a,1,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,6oe,5,1,6of,a,0,6og,5,1,6pj,a,0,6pk,5,1,6rf,a,0,6rg,5,1,6rh,a,0,6ri,5,1,6rj,a,0,6rk,5,1,6rl,a,0,6rm,5,1,6rn,a,0,6ro,5,1,495,a,0,496,5,1,497,a,0,au,5,1,av,a,0,b0,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Tirane||72j,68,0,72k,9,0,g0,a,1,g1,9,0,72l,a,1,72m,9,0,72n,a,1,4a,9,0,72o,a,1,72p,9,0,72q,a,1,72r,9,0,72s,a,1,72t,9,0,72u,a,1,72v,9,0,730,a,1,731,9,0,732,a,1,733,9,0,734,a,1,735,9,0,736,a,1,737,9,0,f7,a,1,f8,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Ulyanovsk||6ru,6s,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,47l,3h,0,47m,34,1,gd,3h,1,561,5,0,ge,3h,1,6pk,5,1,718,a,0,494,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,6kv,5,0,1,3h,0",
        "Europe/Uzhgorod||6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,738,a,1,739,9,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,724,5,0,5s8,9,0,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Vienna||546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,73a,9,0,73b,a,1,6fa,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,3ta,a,1,27,9,0,73c,a,1,6mb,9,0,5q8,a,1,6oo,9,0,6mf,a,1,6mg,9,0,6mh,a,1,73d,9,0,6nu,a,1,1s3,9,0,1s4,a,1,1s5,9,0,1s6,a,1,1s7,9,0,1s8,a,1,1s9,9,0,1sa,a,1,1sb,9,0,1sc,a,1,a5,9,0,a6,a,1,a7,9,0,a8,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Vilnius||73e,6t,0,73f,6u,0,73g,9,0,73h,a,0,73i,9,0,73j,5,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,73k,a,1,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,6oe,5,1,6of,a,0,6og,5,1,6pj,a,0,6pk,5,1,6rf,a,0,6rg,5,1,6rh,a,0,6ri,5,1,6rj,a,0,6rk,5,1,6rl,a,0,6rm,5,1,6rn,a,0,6ro,5,1,495,a,0,496,5,1,at,a,0,au,a,1,av,9,0,b0,a,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Europe/Volgograd||73l,3l,0,6kk,5,0,48r,3h,0,451,34,1,48s,3h,0,48t,34,1,48u,3h,0,48v,34,1,490,3h,0,491,34,1,492,3h,0,47g,34,1,47h,3h,0,47i,34,1,47j,3h,0,47k,34,1,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,ge,3h,1,562,5,0,563,3h,1,564,5,0,565,3h,1,5o3,5,0,567,3h,1,568,5,0,569,3h,1,56a,5,0,56b,3h,1,56c,5,0,56d,3h,1,56e,5,0,56f,3h,1,56g,5,0,56h,3h,1,56i,5,0,56j,3h,1,56k,5,0,56l,3h,1,56m,5,0,56n,3h,1,56o,5,0,56p,3h,1,56q,5,0,56r,3h,1,56s,5,0,56t,3h,1,56u,5,0,56v,3h,1,6kl,5,0,6km,3h,1,6kn,5,0,6ko,3h,1,6kp,5,0,6kq,3h,1,6kr,5,0,6ks,3h,1,6kt,5,0,6ku,3h,0,1,5,0",
        "Europe/Warsaw,Poland||73m,6t,0,546,9,0,6f5,a,1,6f6,9,0,6f7,a,1,6f8,9,0,6f9,a,1,73n,a,0,73o,5,1,73p,a,0,73q,9,0,g0,a,1,g1,9,0,3t9,a,1,25,9,0,73r,a,1,73s,9,0,6om,a,1,73t,9,0,6mc,a,1,6r6,9,0,6mf,a,1,6mg,9,0,6mh,a,1,6mi,9,0,6mj,a,1,6p2,9,0,73u,a,1,73v,9,0,740,a,1,741,9,0,742,a,1,743,9,0,744,a,1,745,9,0,746,a,1,747,9,0,3h,a,1,748,9,0,749,a,1,74a,9,0,74b,a,1,6le,9,0,5vi,a,1,5vj,9,0,4h,a,1,5vk,9,0,74c,a,1,55i,9,0,74d,a,1,55k,9,0,6nv,a,1,55m,9,0,6o0,a,1,6o1,9,0,6o2,a,1,6o3,9,0,6o4,a,1,6o5,9,0,6o6,a,1,6o7,9,0,6o8,a,1,6o9,9,0,6oa,a,1,a9,9,0,aa,a,1,ab,9,0,ac,a,1,ad,9,0,ae,a,1,af,9,0,ag,a,1,ah,9,0,ai,a,1,aj,9,0,ak,a,1,al,9,0,am,a,1,an,9,0,ao,a,1,ap,9,0,aq,a,1,ar,9,0,as,a,1,at,9,0,au,a,1,av,9,0,b0,a,1,b1,9,0,b2,a,1,b3,9,0,b4,a,1,b5,9,0,b6,a,1,b7,9,0,b8,a,1,b9,9,0,ba,a,1,bb,9,0,bc,a,1,bd,9,0,be,a,1,bf,9,0,bg,a,1,bh,9,0,bi,a,1,bj,9,0,bk,a,1,bl,9,0,bm,a,1,bn,9,0,bo,a,1,bp,9,0,bq,a,1,br,9,0,bs,a,1,bt,9,0,bu,a,1,bv,9,0,c0,a,1,c1,9,0,c2,a,1,c3,9,0,c4,a,1,c5,9,0,c6,a,1,c7,9,0,c8,a,1,c9,9,0,ca,a,1,cb,9,0,cc,a,1,cd,9,0,ce,a,1,cf,9,0,cg,a,1,ch,9,0,ci,a,1,cj,9,0,ck,a,1,cl,9,0,cm,a,1,cn,9,0,co,a,1,cp,9,0,cq,a,1,cr,9,0,cs,a,1,ct,9,0,cu,a,1,cv,9,0,d0,a,1,d1,9,0,d2,a,1,d3,9,0,d4,a,1,d5,9,0,d6,a,1,d7,9,0,d8,a,1,d9,9,0,da,a,1,db,9,0,dc,a,1,1,9,0",
        "Europe/Zaporozhye||74e,4i,0,6rq,a,0,74f,5,0,g0,a,1,g1,9,0,3t9,a,1,74g,9,0,6pb,5,0,6pc,3h,1,6pd,5,0,47a,3h,1,6pe,5,0,47c,3h,1,47d,5,0,6pf,3h,1,6pg,5,0,6ph,3h,1,55s,5,0,55t,3h,1,55u,5,0,55v,3h,1,560,5,0,gb,3h,1,gc,5,0,gd,3h,1,561,5,0,ge,3h,1,562,5,0,3ui,5,1,4q8,a,0,45m,5,1,4d0,a,0,45o,5,1,4d1,a,0,45q,5,1,an,a,0,ao,5,1,ap,a,0,aq,5,1,ar,a,0,as,5,1,at,a,0,au,5,1,av,a,0,b0,5,1,b1,a,0,b2,5,1,b3,a,0,b4,5,1,b5,a,0,b6,5,1,b7,a,0,b8,5,1,b9,a,0,ba,5,1,bb,a,0,bc,5,1,bd,a,0,be,5,1,bf,a,0,bg,5,1,bh,a,0,bi,5,1,bj,a,0,bk,5,1,bl,a,0,bm,5,1,bn,a,0,bo,5,1,bp,a,0,bq,5,1,br,a,0,bs,5,1,bt,a,0,bu,5,1,bv,a,0,c0,5,1,c1,a,0,c2,5,1,c3,a,0,c4,5,1,c5,a,0,c6,5,1,c7,a,0,c8,5,1,c9,a,0,ca,5,1,cb,a,0,cc,5,1,cd,a,0,ce,5,1,cf,a,0,cg,5,1,ch,a,0,ci,5,1,cj,a,0,ck,5,1,cl,a,0,cm,5,1,cn,a,0,co,5,1,cp,a,0,cq,5,1,cr,a,0,cs,5,1,ct,a,0,cu,5,1,cv,a,0,d0,5,1,d1,a,0,d2,5,1,d3,a,0,d4,5,1,d5,a,0,d6,5,1,d7,a,0,d8,5,1,d9,a,0,da,5,1,db,a,0,dc,5,1,1,a,0",
        "Indian/Chagos||74h,6v,0,74i,34,0,1,36,0",
        "Indian/Cocos||1,3u,0",
        "Indian/Kerguelen||74j,1,0,1,34,0",
        "Indian/Mahe||74k,46,0,1,3h,0",
        "Indian/Maldives||74l,70,0,1,34,0",
        "Indian/Mauritius||74m,71,0,74n,3h,0,74o,34,1,5o8,3h,0,5nu,34,1,1,3h,0",
        "Indian/Reunion||74p,46,0,1,3h,0",
        "Kwajalein,Pacific/Kwajalein||74q,32,0,74r,66,0,1,39,0",
        "MST7MDT||221,16,0,222,12,1,223,16,0,224,12,1,1b5,16,0,ja,12,1,1b6,12,1,1b7,16,0,1b8,12,1,1b9,16,0,1ba,12,1,1bb,16,0,1bc,12,1,1bd,16,0,1be,12,1,1bf,16,0,1bg,12,1,1bh,16,0,1bi,12,1,1bj,16,0,1bk,12,1,22c,16,0,1bm,12,1,1bn,16,0,1bo,12,1,1bp,16,0,1bq,12,1,1br,16,0,1bs,12,1,1bt,16,0,1bu,12,1,1bv,16,0,1c0,12,1,1c1,16,0,1c2,12,1,1c3,16,0,1c4,12,1,1c5,16,0,1c6,12,1,1c7,16,0,1c8,12,1,1c9,16,0,1ca,12,1,1cb,16,0,1cc,12,1,1cd,16,0,1ce,12,1,1cf,16,0,1cg,12,1,1ch,16,0,1ci,12,1,1cj,16,0,1ck,12,1,1cl,16,0,1cm,12,1,1cn,16,0,1co,12,1,1cp,16,0,1cq,12,1,1cr,16,0,1cs,12,1,1ct,16,0,1cu,12,1,1cv,16,0,1d0,12,1,155,16,0,156,12,1,157,16,0,158,12,1,159,16,0,15a,12,1,15b,16,0,15c,12,1,15d,16,0,15e,12,1,1d1,16,0,1d2,12,1,15h,16,0,15i,12,1,15j,16,0,15k,12,1,15l,16,0,15m,12,1,15n,16,0,15o,12,1,15p,16,0,15q,12,1,1d3,16,0,1d4,12,1,1d5,16,0,1d6,12,1,1d7,16,0,1d8,12,1,1d9,16,0,1da,12,1,1db,16,0,1dc,12,1,1dd,16,0,1de,12,1,1df,16,0,1dg,12,1,1dh,16,0,1di,12,1,1dj,16,0,1dk,12,1,1dl,16,0,1dm,12,1,1dn,16,0,1do,12,1,1dp,16,0,1dq,12,1,1dr,16,0,1ds,12,1,1dt,16,0,1du,12,1,1dv,16,0,1e0,12,1,1e1,16,0,1e2,12,1,1e3,16,0,1e4,12,1,1e5,16,0,1e6,12,1,1e7,16,0,1e8,12,1,1e9,16,0,1ea,12,1,1eb,16,0,1ec,12,1,1ed,16,0,1ee,12,1,1ef,16,0,1eg,12,1,1eh,16,0,1ei,12,1,1ej,16,0,1ek,12,1,1el,16,0,1em,12,1,1en,16,0,1eo,12,1,1ep,16,0,1eq,12,1,1er,16,0,1es,12,1,1et,16,0,1eu,12,1,1ev,16,0,1f0,12,1,1,16,0",
        "NZ-CHAT,Pacific/Chatham||74s,72,0,3p1,73,0,3p2,74,1,3p3,73,0,3p4,74,1,3p5,73,0,3p6,74,1,3p7,73,0,3p8,74,1,3p9,73,0,3pa,74,1,3pb,73,0,3pc,74,1,3pd,73,0,3pe,74,1,3pf,73,0,3pg,74,1,3ph,73,0,3pi,74,1,3pj,73,0,3pk,74,1,3pl,73,0,3pm,74,1,3pn,73,0,3po,74,1,3pp,73,0,3pq,74,1,3pr,73,0,3ps,74,1,3pt,73,0,3pu,74,1,3pv,73,0,3q0,74,1,3q1,73,0,3q2,74,1,3q3,73,0,3q4,74,1,3q5,73,0,3q6,74,1,3q7,73,0,3q8,74,1,3q9,73,0,3qa,74,1,3qb,73,0,3qc,74,1,3qd,73,0,3qe,74,1,3qf,73,0,3qg,74,1,3qh,73,0,3qi,74,1,3qj,73,0,3qk,74,1,3ql,73,0,3qm,74,1,3qn,73,0,3qo,74,1,3qp,73,0,3qq,74,1,3qr,73,0,3qs,74,1,3qt,73,0,3qu,74,1,3qv,73,0,3r0,74,1,3r1,73,0,3r2,74,1,3r3,73,0,3r4,74,1,3r5,73,0,3r6,74,1,3r7,73,0,3r8,74,1,3r9,73,0,3ra,74,1,3rb,73,0,3rc,74,1,3rd,73,0,3re,74,1,3rf,73,0,3rg,74,1,3rh,73,0,3ri,74,1,3rj,73,0,3rk,74,1,3rl,73,0,3rm,74,1,3rn,73,0,3ro,74,1,3rp,73,0,3rq,74,1,3rr,73,0,3rs,74,1,3rt,73,0,3ru,74,1,3rv,73,0,3s0,74,1,3s1,73,0,3s2,74,1,3s3,73,0,3s4,74,1,3s5,73,0,3s6,74,1,3s7,73,0,3s8,74,1,3s9,73,0,3sa,74,1,3sb,73,0,3sc,74,1,3sd,73,0,3se,74,1,3sf,73,0,3sg,74,1,3sh,73,0,3si,74,1,3sj,73,0,3sk,74,1,3sl,73,0,3sm,74,1,3sn,73,0,3so,74,1,3sp,73,0,3sq,74,1,3sr,73,0,3ss,74,1,3st,73,0,3su,74,1,3sv,73,0,1,74,1",
        "PST8PDT||1b0,o,0,1b1,16,1,1b2,o,0,1b3,16,1,20c,o,0,ja,16,1,20d,16,1,21l,o,0,21m,16,1,21n,o,0,21o,16,1,21p,o,0,21q,16,1,21r,o,0,21s,16,1,21t,o,0,21u,16,1,21v,o,0,295,16,1,296,o,0,1sm,16,1,2om,o,0,298,16,1,2on,o,0,29a,16,1,28n,o,0,28o,16,1,28p,o,0,28q,16,1,28r,o,0,28s,16,1,28t,o,0,28u,16,1,1sn,o,0,1so,16,1,1sp,o,0,1sq,16,1,1sr,o,0,1ss,16,1,1st,o,0,1su,16,1,1sv,o,0,1t0,16,1,1t1,o,0,1t2,16,1,1t3,o,0,1t4,16,1,1t5,o,0,1t6,16,1,1t7,o,0,1t8,16,1,1t9,o,0,1ta,16,1,1tb,o,0,1tc,16,1,1td,o,0,1te,16,1,1tf,o,0,1tg,16,1,1th,o,0,1ti,16,1,1tj,o,0,1tk,16,1,1tl,o,0,1tm,16,1,1tn,o,0,1to,16,1,1tp,o,0,1tq,16,1,1tr,o,0,1ts,16,1,1tt,o,0,1tu,16,1,1tv,o,0,1u0,16,1,1u1,o,0,1u2,16,1,1u3,o,0,1u4,16,1,1u5,o,0,1u6,16,1,1u7,o,0,1u8,16,1,1u9,o,0,1ua,16,1,1ub,o,0,1uc,16,1,1ud,o,0,1ue,16,1,1uf,o,0,1ug,16,1,1uh,o,0,1ui,16,1,1uj,o,0,1uk,16,1,1ul,o,0,1um,16,1,1un,o,0,1uo,16,1,1up,o,0,1uq,16,1,1ur,o,0,1us,16,1,1ut,o,0,1uu,16,1,1uv,o,0,1v0,16,1,1v1,o,0,1v2,16,1,1v3,o,0,1v4,16,1,1v5,o,0,1v6,16,1,1v7,o,0,1v8,16,1,1v9,o,0,1va,16,1,1vb,o,0,1vc,16,1,1vd,o,0,1ve,16,1,1vf,o,0,1vg,16,1,1vh,o,0,1vi,16,1,1vj,o,0,1vk,16,1,1vl,o,0,1vm,16,1,1vn,o,0,1vo,16,1,1vp,o,0,1vq,16,1,1vr,o,0,1vs,16,1,1vt,o,0,1vu,16,1,1vv,o,0,200,16,1,201,o,0,202,16,1,203,o,0,204,16,1,205,o,0,206,16,1,207,o,0,208,16,1,209,o,0,20a,16,1,1,o,0",
        "Pacific/Apia||74t,75,0,74u,76,0,74v,l,0,3ra,m,1,3rb,l,0,750,m,1,3rc,3f,1,3rd,3a,0,3re,3f,1,3rf,3a,0,3rg,3f,1,3rh,3a,0,3ri,3f,1,3rj,3a,0,3rk,3f,1,3rl,3a,0,3rm,3f,1,3rn,3a,0,3ro,3f,1,3rp,3a,0,3rq,3f,1,3rr,3a,0,3rs,3f,1,3rt,3a,0,3ru,3f,1,3rv,3a,0,3s0,3f,1,3s1,3a,0,3s2,3f,1,3s3,3a,0,3s4,3f,1,3s5,3a,0,3s6,3f,1,3s7,3a,0,3s8,3f,1,3s9,3a,0,3sa,3f,1,3sb,3a,0,3sc,3f,1,3sd,3a,0,3se,3f,1,3sf,3a,0,3sg,3f,1,3sh,3a,0,3si,3f,1,3sj,3a,0,3sk,3f,1,3sl,3a,0,3sm,3f,1,3sn,3a,0,3so,3f,1,3sp,3a,0,3sq,3f,1,3sr,3a,0,3ss,3f,1,3st,3a,0,3su,3f,1,3sv,3a,0,1,3f,1",
        "Pacific/Bougainville||751,35,0,752,41,0,753,35,0,1,32,0",
        "Pacific/Efate||754,77,0,755,32,0,756,39,1,757,32,0,758,39,1,759,32,0,75a,39,1,75b,32,0,75c,39,1,75d,32,0,75e,39,1,75f,32,0,75g,39,1,75h,32,0,75i,39,1,75j,32,0,75k,39,1,75l,32,0,75m,39,1,75n,32,0,75o,39,1,1,32,0",
        "Pacific/Enderbury||75p,66,0,75q,l,0,1,3a,0",
        "Pacific/Fakaofo||75r,l,0,1,3a,0",
        "Pacific/Fiji||75s,78,0,75t,39,0,75u,3a,1,75v,39,0,760,3a,1,761,39,0,762,3a,1,763,39,0,764,3a,1,765,39,0,766,3a,1,767,39,0,768,3a,1,769,39,0,76a,3a,1,76b,39,0,76c,3a,1,76d,39,0,76e,3a,1,76f,39,0,76g,3a,1,76h,39,0,76i,3a,1,76j,39,0,76k,3a,1,76l,39,0,76m,3a,1,76n,39,0,76o,3a,1,76p,39,0,76q,3a,1,76r,39,0,76s,3a,1,76t,39,0,76u,3a,1,76v,39,0,770,3a,1,771,39,0,772,3a,1,773,39,0,774,3a,1,775,39,0,776,3a,1,777,39,0,778,3a,1,779,39,0,77a,3a,1,77b,39,0,77c,3a,1,77d,39,0,77e,3a,1,77f,39,0,77g,3a,1,77h,39,0,77i,3a,1,77j,39,0,77k,3a,1,77l,39,0,77m,3a,1,77n,39,0,77o,3a,1,77p,39,0,77q,3a,1,1,39,0",
        "Pacific/Galapagos||77r,2f,0,2p9,13,0,1,12,0",
        "Pacific/Gambier||77s,n,0,1,n,0",
        "Pacific/Guadalcanal||77t,79,0,1,32,0",
        "Pacific/Guam,Pacific/Saipan||77u,35,0,1,35,0",
        "Pacific/Honolulu,Pacific/Johnston,US/Hawaii||77v,7a,0,780,7b,1,781,7a,0,782,7b,1,783,7a,0,1,m,0",
        "Pacific/Kiritimati||784,7c,0,785,m,0,1,3f,0",
        "Pacific/Kosrae||74q,32,0,786,39,0,1,32,0",
        "Pacific/Majuro||74q,32,0,1,39,0",
        "Pacific/Marquesas||787,7d,0,1,7b,0",
        "Pacific/Midway,Pacific/Pago_Pago,Pacific/Samoa,US/Samoa||788,7e,0,jc,l,0,789,l,0,1,l,0",
        "Pacific/Nauru||78a,7f,0,78b,37,0,78c,41,0,78d,37,0,1,39,0",
        "Pacific/Niue||78e,7g,0,78f,76,0,1,l,0",
        "Pacific/Norfolk||78g,7h,0,78h,37,0,78i,38,1,78j,37,0,1,32,0",
        "Pacific/Noumea||78k,7i,0,78l,32,0,78m,39,1,78n,32,0,78o,39,1,78p,32,0,78q,39,1,1,32,0",
        "Pacific/Pitcairn||78r,7j,0,1,o,0",
        "Pacific/Rarotonga||78s,7a,0,78t,7b,1,3kh,m,0,78u,7b,1,2oo,m,0,78v,7b,1,3kk,m,0,790,7b,1,3km,m,0,791,7b,1,3ko,m,0,792,7b,1,or,m,0,793,7b,1,ot,m,0,794,7b,1,ov,m,0,795,7b,1,p1,m,0,796,7b,1,p3,m,0,797,7b,1,p5,m,0,798,7b,1,p7,m,0,799,7b,1,1,m,0",
        "Pacific/Tahiti||79a,7k,0,1,m,0",
        "Pacific/Tongatapu||79b,7l,0,79c,3a,0,79d,3f,1,79e,3a,0,79f,3f,1,79g,3a,0,79h,3f,1,79i,3a,0,79j,3f,1,79k,3a,0,79l,3f,1,79m,3a,0,79n,3f,1,79o,3a,0,79p,3f,1,79q,3a,0,79r,3f,1,79s,3a,0,79t,3f,1,79u,3a,0,79v,3f,1,7a0,3a,0,7a1,3f,1,7a2,3a,0,7a3,3f,1,7a4,3a,0,7a5,3f,1,7a6,3a,0,7a7,3f,1,7a8,3a,0,7a9,3f,1,7aa,3a,0,7ab,3f,1,7ac,3a,0,7ad,3f,1,7ae,3a,0,7af,3f,1,7ag,3a,0,7ah,3f,1,7ai,3a,0,7aj,3f,1,7ak,3a,0,7al,3f,1,7am,3a,0,7an,3f,1,7ao,3a,0,7ap,3f,1,7aq,3a,0,7ar,3f,1,7as,3a,0,7at,3f,1,1,3a,0",
        "WET||6fc,1,0,5re,9,1,5rf,1,0,5rg,9,1,5rh,1,0,5vl,9,1,3tq,1,0,1s2,9,1,1s3,1,0,1s4,9,1,1s5,1,0,1s6,9,1,1s7,1,0,1s8,9,1,1s9,1,0,1sa,9,1,1sb,1,0,1sc,9,1,a5,1,0,a6,9,1,a7,1,0,a8,9,1,a9,1,0,aa,9,1,ab,1,0,ac,9,1,ad,1,0,ae,9,1,af,1,0,ag,9,1,ah,1,0,ai,9,1,aj,1,0,ak,9,1,al,1,0,am,9,1,an,1,0,ao,9,1,ap,1,0,aq,9,1,ar,1,0,as,9,1,at,1,0,au,9,1,av,1,0,b0,9,1,b1,1,0,b2,9,1,b3,1,0,b4,9,1,b5,1,0,b6,9,1,b7,1,0,b8,9,1,b9,1,0,ba,9,1,bb,1,0,bc,9,1,bd,1,0,be,9,1,bf,1,0,bg,9,1,bh,1,0,bi,9,1,bj,1,0,bk,9,1,bl,1,0,bm,9,1,bn,1,0,bo,9,1,bp,1,0,bq,9,1,br,1,0,bs,9,1,bt,1,0,bu,9,1,bv,1,0,c0,9,1,c1,1,0,c2,9,1,c3,1,0,c4,9,1,c5,1,0,c6,9,1,c7,1,0,c8,9,1,c9,1,0,ca,9,1,cb,1,0,cc,9,1,cd,1,0,ce,9,1,cf,1,0,cg,9,1,ch,1,0,ci,9,1,cj,1,0,ck,9,1,cl,1,0,cm,9,1,cn,1,0,co,9,1,cp,1,0,cq,9,1,cr,1,0,cs,9,1,ct,1,0,cu,9,1,cv,1,0,d0,9,1,d1,1,0,d2,9,1,d3,1,0,d4,9,1,d5,1,0,d6,9,1,d7,1,0,d8,9,1,d9,1,0,da,9,1,db,1,0,dc,9,1,1,1,0"
    ],
    "timeStamps": [
        "-1mhirdp",
        "1vvvvvv",
        "-1gsv6ad",
        "-1ecn141",
        "-1e2o0th",
        "-1dekk81",
        "-1d4lk1h",
        "-1cgi7c1",
        "-1c6j75h",
        "-1bifqg1",
        "-1b8gq9h",
        "-1akap81",
        "-1aabp1h",
        "-19m8cc1",
        "-19c9c5h",
        "-18o5vg1",
        "-18e6v9h",
        "-17q3ik1",
        "-17g4idh",
        "-16ruhc1",
        "-16hvh5h",
        "-15ts4g1",
        "-15jt49h",
        "-14vpnk1",
        "-14lqndh",
        "-141nao1",
        "-13noahh",
        "-133i9g1",
        "-12pj99h",
        "-125fsk1",
        "-11rgsdh",
        "-117dfo1",
        "-10tefhh",
        "-109b2s1",
        "-vvc2lh",
        "-vb61k1",
        "-v171dh",
        "-ud3ko1",
        "-u34khh",
        "-tf17s1",
        "-t527lh",
        "-sgur01",
        "-s6vqph",
        "-rippo1",
        "-r8qphh",
        "-qkncs1",
        "-qaoclh",
        "-pml001",
        "-pclvph",
        "-1712985",
        "-15jqp9h",
        "-s6te19",
        "-9d07hd",
        "-1n9vbti",
        "-1ibh1oh",
        "-1i2hksh",
        "-1hk6rkh",
        "-1h3vdoh",
        "-1gnc0ch",
        "-1g5vl8h",
        "-1fpumgh",
        "-1f7vsoh",
        "-1et3r8h",
        "-1e8bcoh",
        "-1dskvgh",
        "-1dkfuch",
        "-sg1uch",
        "-saehc1",
        "-s2btj1",
        "-o6rivh",
        "-nnc001",
        "-n8rqfh",
        "-mr3msh",
        "-lr9u4h",
        "-d32b81",
        "-6a6joh",
        "17hgff",
        "1k7i7f",
        "6svlnv",
        "7aqh7f",
        "7ngmfv",
        "86gm8f",
        "97cgrf",
        "9mcgjv",
        "a5uv0f",
        "akunnv",
        "-1fas35h",
        "-1mhion5",
        "4meo8f",
        "-1uriegd",
        "-rmoip1",
        "-rgb11h",
        "-r06411",
        "-qjg5ph",
        "-q38kd1",
        "-pi1lhh",
        "-p567h1",
        "-oji2ph",
        "-o71691",
        "-nld1hh",
        "-n7n7p1",
        "-mnaklh",
        "-bsj751",
        "-bgnklh",
        "-av8hl1",
        "-ail7ph",
        "-a1618h",
        "-9kl4o1",
        "-93100h",
        "-8mg3g1",
        "-84uj4h",
        "-7odmk1",
        "-76s68h",
        "-6qb9o1",
        "-68ppch",
        "-5s8ss1",
        "-5ako4h",
        "-4u3rk1",
        "-4cib8h",
        "-401eo1",
        "-3efuch",
        "-31sdg1",
        "-2gdhgh",
        "-23q0k1",
        "-1i8g8h",
        "-15kvc1",
        "-k63ch",
        "-7iig1",
        "9s9ff",
        "mfqbv",
        "17umbf",
        "1ki77v",
        "263njf",
        "2in8fv",
        "3464ff",
        "3gplbv",
        "428hbf",
        "4es27v",
        "50au7f",
        "5cuf3v",
        "5ufvff",
        "6b3gbv",
        "6sicbf",
        "795t7v",
        "7qkp7f",
        "878a3v",
        "8on63f",
        "95amvv",
        "9ms7bf",
        "a3fo7v",
        "akuk7f",
        "b1i53v",
        "bq14vf",
        "bvkhvv",
        "cn18vf",
        "ctmurv",
        "df8f7f",
        "drs03v",
        "edas3f",
        "epucvv",
        "fbd8vf",
        "fo0prv",
        "g9flrf",
        "gm36nv",
        "h7kn3f",
        "hk87vv",
        "i649rf",
        "iiakrv",
        "j3pgrf",
        "jgd1nv",
        "k1rtnf",
        "kefejv",
        "l00uvf",
        "lckfrv",
        "lu3brf",
        "mamsnv",
        "ms5onf",
        "n8p9jv",
        "nq04uv",
        "o6m36f",
        "onvtev",
        "p4lrmf",
        "plvluv",
        "q2lk6f",
        "qjveev",
        "r0lcmf",
        "rihliv",
        "rv7jqf",
        "sghe2v",
        "st7caf",
        "teh6iv",
        "tr74qf",
        "ucgv2v",
        "up6taf",
        "vagniv",
        "vn6lqf",
        "1092umv",
        "10losuf",
        "1172n6v",
        "11jolef",
        "1252fmv",
        "12h5vaf",
        "133286v",
        "13e0qif",
        "14120mv",
        "14be4ef",
        "14v1p6v",
        "158reaf",
        "15tk0av",
        "1663fef",
        "168im6v",
        "16a9uif",
        "19nae6v",
        "19qp2ef",
        "19tlf2v",
        "1a290if",
        "-1kqs1j5",
        "-sg1qs1",
        "-saeksh",
        "-s2c4k1",
        "-mltj8h",
        "-ickn01",
        "-i13m0h",
        "-2dl3e1",
        "-23q44h",
        "46n13v",
        "4ccrff",
        "5ug2vv",
        "662hvf",
        "6sifrv",
        "78tsjf",
        "7t6kbv",
        "82f8rf",
        "dbf9fv",
        "f1grvf",
        "1443pjv",
        "14bm8jf",
        "15266fv",
        "158rlbf",
        "15tpg3v",
        "165rpbf",
        "16pfe3v",
        "173937f",
        "17pp84v",
        "180hesv",
        "18336gv",
        "186f9sv",
        "18np0kv",
        "18thisv",
        "190b7kv",
        "196ossv",
        "19jeukv",
        "19qs8cv",
        "19tohgv",
        "1a4olcv",
        "1ahen4v",
        "1anpo0v",
        "1aqm14v",
        "1b2odsv",
        "1bfefkv",
        "1bl71sv",
        "1bo3b0v",
        "1c1al0v",
        "1cde84v",
        "1ci1t4v",
        "1clgksv",
        "1cvadgv",
        "1dbe0kv",
        "1dff70v",
        "1dibg4v",
        "1dta60v",
        "1ea07ov",
        "1ecsgsv",
        "1efoq0v",
        "1er9ugv",
        "1f8008v",
        "1f9nc4v",
        "1fcjl8v",
        "1fp9n0v",
        "1g5voov",
        "1g74m0v",
        "1ga0v4v",
        "1gnru4v",
        "1h7e90v",
        "1hlrmkv",
        "1i4948v",
        "1ijrf4v",
        "1j1me4v",
        "1jhr7kv",
        "1jv3o0v",
        "1kfr04v",
        "1ksh1sv",
        "1ldqokv",
        "1lqgqcv",
        "1mccvov",
        "1mogisv",
        "1naco8v",
        "1nmgbcv",
        "1o8cgov",
        "1ol2igv",
        "1p6c98v",
        "1pj2b0v",
        "1q4c1ov",
        "1qh23gv",
        "1r2u8sv",
        "1rf1s0v",
        "1s0u1cv",
        "1sd1kgv",
        "1sutpsv",
        "1tb1d0v",
        "1tsticv",
        "1u9jk4v",
        "1uqas8v",
        "1v7jckv",
        "1vn5ngv",
        "-1gij2kh",
        "-1g5t4d1",
        "-1avk44h",
        "-1ahh80h",
        "-193cm0h",
        "-18lhn0h",
        "-185vc4h",
        "-17nhugh",
        "-177d50h",
        "-16ovnch",
        "f8p40f",
        "fnp08f",
        "g6osgf",
        "glooof",
        "h4ol0f",
        "hjoh8f",
        "i2odgf",
        "iho9of",
        "j0o60f",
        "jgagsf",
        "jvad4f",
        "kea9cf",
        "kta5kf",
        "lca1sf",
        "lr9u4f",
        "ma9qcf",
        "mp9mkf",
        "n89isf",
        "nn9f4f",
        "o69bcf",
        "olrm8f",
        "p75d0f",
        "pjreof",
        "q555gf",
        "qhr78f",
        "r34u0f",
        "rfqvof",
        "s1n54f",
        "sdqo8f",
        "svmtkf",
        "tbqgof",
        "ttmm4f",
        "uacnsf",
        "urmekf",
        "v8cgcf",
        "vpm74f",
        "106c8sf",
        "10o8e8f",
        "114c1cf",
        "11m86of",
        "122bpsf",
        "12k7v8f",
        "130bicf",
        "13i7nof",
        "13utpgf",
        "14g7g8f",
        "14sti0f",
        "15e78of",
        "15qtagf",
        "16cpfsf",
        "16ot30f",
        "17ap8cf",
        "17msrgf",
        "188p0sf",
        "18lf2kf",
        "196opcf",
        "19jer4f",
        "1a4ohsf",
        "1ahejkf",
        "1b2oacf",
        "1bfec4f",
        "1c1ahgf",
        "1cde4kf",
        "1cvaa0f",
        "1dbdt4f",
        "1dta2gf",
        "1ea048f",
        "1er9r0f",
        "1f7vsof",
        "1fp9jgf",
        "1g5vl8f",
        "1gnrqkf",
        "1h3vdof",
        "1hlrj4f",
        "1i1v68f",
        "1ijrbkf",
        "1j0hdcf",
        "1jhr44f",
        "1juh5sf",
        "1kfqskf",
        "1ksgucf",
        "1ldql4f",
        "1lqgmsf",
        "1mccs8f",
        "1mogfcf",
        "1nackof",
        "1nmg7sf",
        "1o8cd8f",
        "1ol2f0f",
        "1p6c5of",
        "1pj27gf",
        "1q4bu8f",
        "1qh200f",
        "1r2u5cf",
        "1rf1ogf",
        "1s0ttsf",
        "1sd1h0f",
        "1sutmcf",
        "1tb19gf",
        "1tstesf",
        "1u9jgkf",
        "1uqt7cf",
        "1v7j94f",
        "1vosvsf",
        "-11re3p1",
        "5t3c4f",
        "-1uric4p",
        "-pl2ss1",
        "-p6344h",
        "-on34c1",
        "-o83bkh",
        "-14lo9g1",
        "9s5uv",
        "nkd2f",
        "17ruev",
        "1lmpuf",
        "260vmv",
        "2jrr6f",
        "340o6v",
        "3hu82f",
        "420gmv",
        "4g0kuf",
        "50096v",
        "5e31qf",
        "5u01mv",
        "6c832f",
        "6rvq6v",
        "7aafuf",
        "7qi1av",
        "88csqf",
        "8ohpqv",
        "96f9mf",
        "9mhiav",
        "a4kauf",
        "akhaqv",
        "b2mnqf",
        "bih3av",
        "c0p4mf",
        "cggrqv",
        "curhif",
        "df32uv",
        "dt0iqf",
        "ed2rev",
        "er2vmf",
        "s80h8v",
        "-1fq14r5",
        "263tnd",
        "-1mhivst",
        "96csbf",
        "9idniv",
        "-1f0qfmt",
        "-h48jnh",
        "-gtokl1",
        "-f8ebfh",
        "-f1h6h1",
        "-dd1g4h",
        "-d5ccp1",
        "-ab2e8h",
        "b94giv",
        "bghtrf",
        "bvkauv",
        "cekanf",
        "ctmnqv",
        "dcpbvf",
        "drrp2v",
        "eb8unf",
        "epu5uv",
        "f962rf",
        "fo5riv",
        "g70ijf",
        "gm2vmv",
        "h55jrf",
        "hk80uv",
        "i380nf",
        "iiadqv",
        "j41dvf",
        "p4tsav",
        "pk8djf",
        "q3aqmv",
        "189r67v",
        "18l9mbv",
        "196jd3v",
        "-ssatp1",
        "-saeod1",
        "-s29n91",
        "-qhrap1",
        "-q555gh",
        "-phhd7h",
        "-p5dq3h",
        "-p3rqg1",
        "-p36jvh",
        "-olrio1",
        "-nnc711",
        "-mr3qd1",
        "6sfnvf",
        "78jb3f",
        "8786jf",
        "ha6enf",
        "hjoa7f",
        "i2o6ff",
        "iho2nf",
        "jga9rf",
        "11783ff",
        "11jovvv",
        "j0d9uv",
        "mprqmv",
        "n6i70f",
        "nnrq7v",
        "o4hvgf",
        "ome1bv",
        "p2ho0f",
        "pkdprv",
        "q13v4f",
        "qidibv",
        "qv3nkf",
        "rgdarv",
        "rt3g4f",
        "sed3bv",
        "sr38kf",
        "tccrrv",
        "tp314f",
        "uav2vv",
        "un2pkf",
        "v8urfv",
        "vll0of",
        "106ujvv",
        "10jkp8f",
        "114ucfv",
        "11hkhof",
        "122u4vv",
        "12fka8f",
        "130ttfv",
        "13dk2of",
        "13vg4jv",
        "14c69sf",
        "14tft3v",
        "15a62cf",
        "15rfljv",
        "1685qsf",
        "1765jcf",
        "17nf6jv",
        "1845bsf",
        "18m1dnv",
        "19254cf",
        "19k167v",
        "1a0nbgf",
        "1ai0unv",
        "1aun40f",
        "1bg0n7v",
        "1bsmsgf",
        "1ce0fnv",
        "1cqml0f",
        "1dc087v",
        "1domdgf",
        "1eaifbv",
        "1emm60f",
        "1f8i7rv",
        "1fl8d4f",
        "1g6i0bv",
        "1gj85kf",
        "1h4horv",
        "1hh7u4f",
        "1i2hhbv",
        "1if7mkf",
        "1j13ofv",
        "1jd7f4f",
        "1jv3gvv",
        "1kbpm8f",
        "1kt39fv",
        "1l9peof",
        "1lr31vv",
        "1m7p78f",
        "1mp2qfv",
        "1n5ovof",
        "1nn2ivv",
        "1o3oo8f",
        "1olkq3v",
        "1p1ogof",
        "1pjkijv",
        "1q0ansf",
        "1qhkb3v",
        "1quagcf",
        "1rfk3jv",
        "1rsa8sf",
        "1sdjs3v",
        "1sqa1cf",
        "1tbjkjv",
        "1to9psf",
        "1ua5rnv",
        "1ums10f",
        "1v85k7v",
        "1vkrpgf",
        "-q7deph",
        "-mto2sh",
        "-mptbu1",
        "-2iraih",
        "-kf3lh",
        "-5fau1",
        "9gkqf",
        "ogdhv",
        "17gdaf",
        "1n2klv",
        "262kef",
        "2l2d5v",
        "342cuf",
        "3j25lv",
        "3oqref",
        "4h1u5v",
        "4qrqaf",
        "5f1mlv",
        "5u1mef",
        "6djtpv",
        "6s1euf",
        "7bjm9v",
        "7qjm2f",
        "89jepv",
        "8ojeif",
        "97j79v",
        "9mj72f",
        "a5ivpv",
        "akivif",
        "b3io9v",
        "biio2f",
        "c24vdv",
        "cgigif",
        "d04ntv",
        "d2m8gv",
        "df4k5v",
        "du4ctf",
        "ed4clv",
        "es45df",
        "fb455v",
        "fq3ttf",
        "g7chpv",
        "go3mdf",
        "h5ca9v",
        "hmlthf",
        "i3c2pv",
        "iklm1f",
        "j1br9v",
        "jilehf",
        "jvu2dv",
        "kgl71f",
        "kttqtv",
        "lekvhf",
        "lrtjdv",
        "md76lf",
        "mptbtv",
        "nb6v5f",
        "nnt4dv",
        "o96nlf",
        "omfbhv",
        "p76g5f",
        "pkf41v",
        "q568lf",
        "qieshv",
        "r3615f",
        "rgel1v",
        "s1o89f",
        "seedhv",
        "svo0pf",
        "tce61v",
        "ttnp9f",
        "ub0d5v",
        "urnhpf",
        "v905lv",
        "vpna9f",
        "106vu5v",
        "10o9hdf",
        "114vmlv",
        "11m99tf",
        "122vf5v",
        "12k92df",
        "12v7rpv",
        "13ir9hf",
        "13t7k9v",
        "14gr21f",
        "14r7cpv",
        "15eqqhf",
        "15ppjtv",
        "16dd1lf",
        "16npcdv",
        "17bcq5f",
        "17lp4tv",
        "189cilf",
        "18jotdv",
        "197cb5f",
        "19holtv",
        "1a5c3lf",
        "1afoedv",
        "1b3bs5f",
        "1bealhv",
        "1c1u39f",
        "1ccae1v",
        "1cvtrpf",
        "1daa6hv",
        "1dttk9f",
        "1e89v1v",
        "1ertcpf",
        "1f69nhv",
        "1fpt59f",
        "1g4rulv",
        "1gofcdf",
        "1h2rn5v",
        "1hmf4tf",
        "1i0rflv",
        "1iketdf",
        "1iur85v",
        "1jieltf",
        "1jsr0lv",
        "1kgeedf",
        "1kqqp5v",
        "1lee6tf",
        "1lpd09v",
        "1md0e1f",
        "1mncopv",
        "1nb06hf",
        "1nlch9v",
        "1o8vv1f",
        "1ojc9pv",
        "1p6vnhf",
        "1phc29v",
        "1q4vg1f",
        "1qfu9dv",
        "1r3hn5f",
        "1rdu1tv",
        "1s1hflf",
        "1sbtqdv",
        "1svh85f",
        "1t9titv",
        "1tth0lf",
        "1u7tbdv",
        "1urgp5f",
        "1v5t3tv",
        "1vpghlf",
        "-q7dia1",
        "-mptfeh",
        "-2ire31",
        "-kf761",
        "-5feeh",
        "9gh9v",
        "oga1f",
        "17g9pv",
        "1n2h5f",
        "262gtv",
        "2l29lf",
        "3429dv",
        "3j225f",
        "3oqntv",
        "4h1qlf",
        "4qrmpv",
        "5f1j5f",
        "5u1itv",
        "6djq9f",
        "6s1bdv",
        "7bjipf",
        "7qjihv",
        "89jb9f",
        "8ojb1v",
        "97j3pf",
        "9mj3hv",
        "a5is9f",
        "akis1v",
        "b3ikpf",
        "biikhv",
        "c24rtf",
        "cgid1v",
        "d04kdf",
        "d2m50f",
        "df4glf",
        "du49cv",
        "ed495f",
        "es41sv",
        "fb41lf",
        "fq3qcv",
        "g7ce9f",
        "go3isv",
        "h5c6pf",
        "hmlq0v",
        "i3bv9f",
        "ikligv",
        "j1bnpf",
        "jilb0v",
        "jvtutf",
        "kgl3gv",
        "kttndf",
        "leks0v",
        "lrtftf",
        "md734v",
        "mpt8df",
        "nb6rkv",
        "nnt0tf",
        "o96k4v",
        "omf81f",
        "p76ckv",
        "pkf0hf",
        "q5654v",
        "qiep1f",
        "r35tkv",
        "rgehhf",
        "s1o4ov",
        "seea1f",
        "svnt8v",
        "tce2hf",
        "ttnlov",
        "ub09lf",
        "urne8v",
        "v9025f",
        "vpn6ov",
        "106vqlf",
        "10o9dsv",
        "114vj5f",
        "11m96cv",
        "122vblf",
        "12k8usv",
        "12v7o9f",
        "13ir60v",
        "13t7gpf",
        "14gqugv",
        "14r799f",
        "15eqn0v",
        "15ppgdf",
        "16dcu4v",
        "16np8tf",
        "17bcmkv",
        "17lp1df",
        "189cf4v",
        "18joptf",
        "197c7kv",
        "19hoidf",
        "1a5c04v",
        "1afoatf",
        "1b3bokv",
        "1beai1f",
        "1c1tvov",
        "1ccaahf",
        "1cvto8v",
        "1daa31f",
        "1dttgov",
        "1e89rhf",
        "1ert98v",
        "1f69k1f",
        "1fpt1ov",
        "1g4rr5f",
        "1gof8sv",
        "1h2rjlf",
        "1hmf1cv",
        "1i0rc5f",
        "1ikepsv",
        "1iur4lf",
        "1jieicv",
        "1jsqt5f",
        "1kgeasv",
        "1kqqllf",
        "1lee3cv",
        "1lpcspf",
        "1md0agv",
        "1mncl9f",
        "1nb030v",
        "1nlcdpf",
        "1o8vrgv",
        "1ojc69f",
        "1p6vk0v",
        "1phbupf",
        "1q4vcgv",
        "1qfu5tf",
        "1r3hjkv",
        "1rdtudf",
        "1s1hc4v",
        "1sbtmtf",
        "1svh4kv",
        "1t9tfdf",
        "1ttgt4v",
        "1u7t7tf",
        "1urglkv",
        "1v5t0df",
        "1vpge4v",
        "-1mchj2l",
        "-1klb2uh",
        "-13v1dh1",
        "-13g5fr1",
        "-130tiuh",
        "-12i32v1",
        "-isekeh",
        "-ih81eh",
        "-huc7ih",
        "-hkd9n1",
        "-h09qmh",
        "-gm88f1",
        "-g24peh",
        "-fqnj71",
        "-5mg02h",
        "-5fl8f1",
        "-4jv6uh",
        "-4f3ob1",
        "-3qtkuh",
        "-3jgen1",
        "-2vabah",
        "-2le1r1",
        "-217ueh",
        "-1n90j1",
        "esj3hf",
        "f7hlsv",
        "fq0ddf",
        "g37jsv",
        "go2q9f",
        "h0ni4v",
        "hlg45f",
        "hu4s0v",
        "ijfslf",
        "it9hov",
        "o80u9f",
        "ohqjcv",
        "p5e85f",
        "pgcqgv",
        "q3gl1f",
        "qfhg8v",
        "r207pf",
        "rcuq4v",
        "rvdhlf",
        "sbh18v",
        "stvopf",
        "t8ub4v",
        "tshvtf",
        "u6u3kv",
        "us949f",
        "v4ts4v",
        "1886p9f",
        "18i0ecv",
        "-1emqs6h",
        "-14o9be1",
        "-14eadih",
        "-13u2s61",
        "-13in3uh",
        "-12uh0i1",
        "-12kkn2h",
        "-120ejm1",
        "-11mia6h",
        "-112c6q1",
        "-10oftah",
        "-1049pu1",
        "-vqas2h",
        "-v64om1",
        "-us8f6h",
        "-u82bq1",
        "-tu62ah",
        "-t9vuu1",
        "-t03leh",
        "-sbti21",
        "-s1uk6h",
        "-rnsqu1",
        "-qr4nih",
        "-qh2ua1",
        "-or406h",
        "-oku4i1",
        "-mddiih",
        "-lrp6q1",
        "-5s5tuh",
        "-5m02a1",
        "-5fl4uh",
        "-4srru1",
        "-4hio2h",
        "-3upf21",
        "-3jgb6h",
        "-30n261",
        "-2ipiah",
        "-23pii1",
        "-1k7b6h",
        "-157be1",
        "-m7imh",
        "-77iu1",
        "3q6ilf",
        "428rsv",
        "hp9ddf",
        "i1154v",
        "iv0tkv",
        "ji23pf",
        "jt0m4v",
        "kg1s9f",
        "kr0ekv",
        "le1kpf",
        "lpilov",
        "sbualf",
        "13ne2df",
        "13tovov",
        "14fl8lf",
        "14roo8v",
        "kg1vpv",
        "10bns9f",
        "10da2tv",
        "jikltv",
        "ju5mtf",
        "ket2hv",
        "jsrdcv",
        "k2c9hv",
        "jhid1v",
        "jsrgtf",
        "kfkptv",
        "kr0i5f",
        "le1o9v",
        "10b04tf",
        "10lcflv",
        "10bl7tf",
        "10g6c1v",
        "ivr9cv",
        "k4e6tv",
        "13p7v4v",
        "13t6klf",
        "14f2thv",
        "14r6d5f",
        "15d2m1v",
        "10cnk9v",
        "10bijhf",
        "-1me3keu",
        "-4me4tp",
        "-13ug2jh",
        "2inmhv",
        "3vps5f",
        "5cut5v",
        "5pfilf",
        "6b3udv",
        "6nhvhf",
        "796b9v",
        "7lkcdf",
        "878o5v",
        "8m8gtf",
        "95b51v",
        "9kdi5f",
        "a3g69v",
        "aifv1f",
        "b1ij5v",
        "bgibtf",
        "bvl01v",
        "cekopf",
        "ctnctv",
        "dcpq1f",
        "drse5v",
        "eas6tf",
        "epur1v",
        "f8ujpf",
        "fo17tv",
        "g710lf",
        "gm3kpv",
        "h561tf",
        "hk8m1v",
        "i38epf",
        "ik2epv",
        "j1arlf",
        "jgdfpv",
        "jvd8hf",
        "lcvfdv",
        "lri29f",
        "manapv",
        "mn035f",
        "n8pnlv",
        "nkvrlf",
        "o6s4hv",
        "ojcq1f",
        "p5eblv",
        "pgvclf",
        "q3e45v",
        "qfhjpf",
        "r1dslv",
        "re3qtf",
        "rvdl5v",
        "sc3jdf",
        "stddlv",
        "ta3btf",
        "trvkpv",
        "uavdhf",
        "un345v",
        "v8v61f",
        "vllb9v",
        "106uuhf",
        "10n3rhv",
        "1137b5f",
        "11l3k1v",
        "12173lf",
        "12j3chv",
        "12v6s5f",
        "13hljlv",
        "14flc5v",
        "15dl4lv",
        "15s2epf",
        "16afvtv",
        "16q279f",
        "178fodv",
        "17o1vpf",
        "1871vhv",
        "18ksr1f",
        "1951o1v",
        "19isjhf",
        "1a31ghv",
        "1agsc1f",
        "1b1191v",
        "1bfej5f",
        "1bv11hv",
        "1cdeblf",
        "1ct0q1v",
        "1dbe45f",
        "1drj15v",
        "1e9dslf",
        "1epiplv",
        "1f7dl5f",
        "1fnii5v",
        "1g5vs9f",
        "1glialv",
        "1h3vkpf",
        "1hji35v",
        "1i1vd9f",
        "1ihhrlv",
        "1ivv5pf",
        "1jg42pv",
        "1jtuu9f",
        "1ke3r9v",
        "1krumpf",
        "1lc3jpv",
        "1lqgttf",
        "1ma3c9v",
        "1mogmdf",
        "1n834pv",
        "1nmgetf",
        "1o6lbtv",
        "1okg7df",
        "1p4l4dv",
        "1pifvtf",
        "1q2kstv",
        "1qh271f",
        "1r0kldv",
        "1rf1vhf",
        "1rukdtv",
        "1sd1o1f",
        "1ssk6dv",
        "1tb1ghf",
        "1tr6dhv",
        "1u9191f",
        "1up661v",
        "1v711hf",
        "1vn5uhv",
        "-1gkenk1",
        "-1g4a1kh",
        "-rgfa51",
        "-q7e0c1",
        "-mpttgh",
        "-1klb575",
        "jrrosv",
        "kp92ov",
        "lek3df",
        "lmmckv",
        "mc1d9f",
        "mmdh0v",
        "na15pf",
        "nkd9gv",
        "179ki5f",
        "17kj4gv",
        "-1d4i5sh",
        "-180r491",
        "-14pjad1",
        "-14bobd1",
        "-13v7id1",
        "-13g4u8h",
        "-q1b3l1",
        "-jmsioh",
        "s3v",
        "omf10f",
        "p765jv",
        "pkepgf",
        "q55u3v",
        "qiei0f",
        "r35mjv",
        "rgeagf",
        "s1ntnv",
        "see30f",
        "svnm7v",
        "tfa4kf",
        "trdk7v",
        "ub02kf",
        "urn77v",
        "v8vr4f",
        "vpmvnv",
        "106vjkf",
        "10o96rv",
        "114vc4f",
        "11m8vbv",
        "122v4kf",
        "12k8nrv",
        "130ut4f",
        "13i8gbv",
        "13vh48f",
        "14g88rv",
        "14tgsof",
        "15e81bv",
        "15rgl8f",
        "16cq4vf",
        "16pga7v",
        "17aptff",
        "17ng2nv",
        "188plvf",
        "18m29rv",
        "196peff",
        "19k22bv",
        "1a4p6vf",
        "1ai1qrv",
        "1b2ovff",
        "1bg1jbv",
        "1c1b6jf",
        "1ce1brv",
        "1cvav3f",
        "1dc14bv",
        "1dtanjf",
        "1eajbfv",
        "1erag3f",
        "1f8j3vv",
        "1fpa8jf",
        "1g6isfv",
        "1gnsfnf",
        "1h4ikvv",
        "1hls87f",
        "1i2idfv",
        "1ijs0nf",
        "1j14kjv",
        "1jhrp7f",
        "1jv4d3v",
        "1kfrhnf",
        "1kt45jv",
        "1ldra7f",
        "1lr3u3v",
        "1mcdhbf",
        "1mp3mjv",
        "1nad9rf",
        "1nn3f3v",
        "1o8d2bf",
        "1ollm7v",
        "1p6cqrf",
        "1pjlenv",
        "1q4cjbf",
        "1qhl77v",
        "1r2uqff",
        "1rfkvnv",
        "1s0uivf",
        "1sdko7v",
        "1suubff",
        "1tbkgnv",
        "1tsu3vf",
        "1ua6nrv",
        "1uqtsff",
        "1v86gbv",
        "1votkvf",
        "-1b8dmos",
        "-13nl70s",
        "701smv",
        "79936f",
        "7pe06v",
        "878rmf",
        "8ndomv",
        "958k6f",
        "9lvvqv",
        "a30fif",
        "-1klb2sd",
        "-1ma29ih",
        "-1g61h11",
        "-1frlbh9",
        "-1f81oh1",
        "-1et34d9",
        "-1ea2011",
        "-1dv3bt9",
        "-1dc27h1",
        "-1d13jd9",
        "-1cdg0d1",
        "-1c33qt9",
        "-1bfg7t1",
        "-1b542d9",
        "-1ahgfd1",
        "-1a6hr99",
        "-19jgmt1",
        "-198i2p9",
        "-18lgud1",
        "-18aia99",
        "-17nh5t1",
        "-17cihp9",
        "-16ouup1",
        "-16eip99",
        "-15qv691",
        "-15gj0p9",
        "-14svdp1",
        "-14i0pl9",
        "-13uvl91",
        "-13k1159",
        "-130vsp1",
        "-12m18l9",
        "-122dll1",
        "-11o1g59",
        "-114dt51",
        "-10q1nl9",
        "-106e4l1",
        "-vs1v59",
        "-v8ec51",
        "-utfo19",
        "-uaejl1",
        "-tvfvh9",
        "-tcer51",
        "-t1g719",
        "-sdsk11",
        "-s3geh9",
        "-rfsrh1",
        "-r5gm19",
        "-qht311",
        "-q6uet9",
        "-pjtah1",
        "-p8umd9",
        "3m5mqv",
        "3rjk2f",
        "c62sav",
        "camdqf",
        "-1gkeul1",
        "-1g4a8lh",
        "-q7e7d1",
        "-mpu4hh",
        "-1klb011",
        "-13v1a0h",
        "-13g5cah",
        "-130tfe1",
        "-12i2veh",
        "-isegu1",
        "-ih7tu1",
        "-huc421",
        "-hkd66h",
        "-h09n61",
        "-gm84uh",
        "-g24lu1",
        "-fqnfmh",
        "-5mfsi1",
        "-4jv3e1",
        "-4f3kqh",
        "-3qthe1",
        "-2va7q1",
        "-2lduah",
        "-217qu1",
        "-1n8t2h",
        "esj71v",
        "f7hpdf",
        "fq0gtv",
        "g37ndf",
        "go2tpv",
        "h0nllf",
        "sbh4pf",
        "stvs9v",
        "sui7df",
        "-1jqfakh",
        "l06sqf",
        "lrsn9v",
        "-1gljdr1",
        "-1g49qjh",
        "-1fnjlb1",
        "-1f6a23h",
        "-1brjcv1",
        "-q7dsrh",
        "-mptq01",
        "-2gf2nh",
        "-21fa01",
        "-1ifa7h",
        "-13fhg1",
        "-kfhnh",
        "-5fp01",
        "9g6of",
        "ofvfv",
        "17fv8f",
        "1n26jv",
        "2626cf",
        "2l1v3v",
        "341usf",
        "3j1njv",
        "3r47sf",
        "4h1g3v",
        "4qrc8f",
        "5f18jv",
        "5u18cf",
        "6djfnv",
        "6s10sf",
        "7bj87v",
        "7qj80f",
        "89j0nv",
        "8oj0gf",
        "97ip7v",
        "9mip0f",
        "a5ihnv",
        "akihgf",
        "b3ia7v",
        "biia0f",
        "c24hbv",
        "cgi2gf",
        "d049rv",
        "df49kf",
        "du42bv",
        "ed424f",
        "es3qrv",
        "fb3qkf",
        "fq3jbv",
        "g7c78f",
        "go3brv",
        "h5bvof",
        "hmlivv",
        "i3bo8f",
        "iklbfv",
        "j1bgof",
        "jil3vv",
        "jvtnsf",
        "kgksfv",
        "kttgcf",
        "lekkvv",
        "lrt8sf",
        "md6s3v",
        "mpt1cf",
        "nb6kjv",
        "nnspsf",
        "o96d3v",
        "tcdrgf",
        "ttnenv",
        "12v7h8f",
        "13iquvv",
        "13t79of",
        "14gqnfv",
        "14r728f",
        "15eqfvv",
        "15pp9cf",
        "16dcn3v",
        "16np1sf",
        "17bcfjv",
        "17loqcf",
        "189c83v",
        "18joisf",
        "197c0jv",
        "19hobcf",
        "1a5bp3v",
        "1afo3sf",
        "1b3bhjv",
        "1beab0f",
        "1c1tonv",
        "1cca3gf",
        "1cvth7v",
        "1da9s0f",
        "1dtt9nv",
        "1e89kgf",
        "1ert27v",
        "1f69d0f",
        "1fpsqnv",
        "1g4rk4f",
        "1gof1rv",
        "1h2rckf",
        "1hmeqbv",
        "1i0r54f",
        "1ikeirv",
        "1iuqtkf",
        "1jiebbv",
        "1jsqm4f",
        "1kge3rv",
        "1kqqekf",
        "1ledsbv",
        "1lpclof",
        "1md03fv",
        "1mnce8f",
        "1navrvv",
        "1nlc6of",
        "1o8vkfv",
        "1ojbv8f",
        "1p6vcvv",
        "1phbnof",
        "1q4v5fv",
        "1qftusf",
        "1r3hcjv",
        "1rdtncf",
        "1s1h53v",
        "1sbtfsf",
        "1svgtjv",
        "1t9t8cf",
        "1ttgm3v",
        "1u7t0sf",
        "1urgejv",
        "1v5spcf",
        "1vpg73v",
        "-1f0qck1",
        "-4d19ch",
        "-3teugh",
        "sedvfv",
        "svninf",
        "t09qaf",
        "-1klb1ed",
        "hlg7lv",
        "hu4vhf",
        "ijg05v",
        "it9l9f",
        "ji279v",
        "jrrsdf",
        "kp969f",
        "lek6tv",
        "lmmg5f",
        "mc1gpv",
        "mmdkhf",
        "na199v",
        "nkdd1f",
        "o811pv",
        "ohqmtf",
        "pgcu1f",
        "q3gohv",
        "r20b9v",
        "rcutlf",
        "t8uelf",
        "tsi3dv",
        "u6u75f",
        "us97pv",
        "v4tvlf",
        "vp431v",
        "102to5f",
        "10oe1hv",
        "111fv9f",
        "11vfnpf",
        "12kqodv",
        "12u1utf",
        "13h351v",
        "13rf8pf",
        "14pf19f",
        "15o18df",
        "16bkt5v",
        "16m10tf",
        "179kllv",
        "17kj81f",
        "1886spv",
        "18i0htf",
        "1966l9v",
        "19g0adf",
        "1a46dpv",
        "1aeihhf",
        "1b2669v",
        "1bcia1f",
        "1c05upv",
        "1cai2hf",
        "1cu5n9v",
        "1d8hr1f",
        "1dsnudv",
        "1e6hjhf",
        "1eqnmtv",
        "1f4hc1f",
        "1fonfdv",
        "1g33j5f",
        "1gmn7tv",
        "1h13blf",
        "1hkn0dv",
        "1hvlipf",
        "1iimotv",
        "1it2slf",
        "1jh901v",
        "1jr2l5f",
        "1kf8ohv",
        "1kpks9f",
        "1ld8h1v",
        "1lnkkpf",
        "1mb89hv",
        "1mlkd9f",
        "1n9821v",
        "1njk5pf",
        "1o7q95v",
        "1ohju9f",
        "1p5q1lv",
        "1pfjmpf",
        "1q3pq5v",
        "1qdjf9f",
        "1r1pilv",
        "1rc5mdf",
        "1rvpb5v",
        "1santhf",
        "1stp3lv",
        "1t857df",
        "1tsbapv",
        "1u64vtf",
        "1uqb39v",
        "1v4n71f",
        "1voarpv",
        "-1d4i9d1",
        "b8dlav",
        "omepvf",
        "p75uiv",
        "pkeiff",
        "q55n2v",
        "qieavf",
        "qs802v",
        "r35j3f",
        "rge6vv",
        "s1nq7f",
        "tfa13v",
        "trdgnf",
        "uavv3v",
        "urn3nf",
        "v8vnjv",
        "vpms7f",
        "106vg3v",
        "10o93bf",
        "114v8jv",
        "11m8rrf",
        "122v13v",
        "12k8kbf",
        "130upjv",
        "13i8crf",
        "13vh0nv",
        "14g85bf",
        "14tgp7v",
        "15e7trf",
        "15rghnv",
        "1acrn7v",
        "-1me3ku5",
        "13ln4jf",
        "1bibabf",
        "-1n0nl3h",
        "-1q0n7gp",
        "-1gljks1",
        "-1fnjsc1",
        "-1f6a94h",
        "-1ej9301",
        "-1e7o20h",
        "-1drkbc1",
        "-1d9o9gh",
        "-1cqo9o1",
        "-1cekq4h",
        "-1bsoh81",
        "-1bg2j0h",
        "-1auooo1",
        "-1ai2qgh",
        "-1a0p081",
        "-19k320h",
        "-192p7o1",
        "-18m39gh",
        "-184pf81",
        "-17o3h0h",
        "-1767841",
        "-16ph9sh",
        "-1687fk1",
        "-15rhhch",
        "-15a7n41",
        "-14thosh",
        "-14c7uk1",
        "-13vi0ch",
        "-13e8641",
        "-131i7sh",
        "-12flv01",
        "-123ifch",
        "-11hm6g1",
        "-115088h",
        "-10jme01",
        "-1070foh",
        "-vqaag1",
        "-v4vgsh",
        "-unmt01",
        "-ub0uoh",
        "-tpn4g1",
        "-td168h",
        "-sr4tc1",
        "-sf1doh",
        "-rt54s1",
        "-rgf6kh",
        "-qv5cc1",
        "-qife4h",
        "-m8k381",
        "-lru50h",
        "-lakao1",
        "-ktucgh",
        "-kcki81",
        "-jvuk0h",
        "-jekpo1",
        "-j1urgh",
        "-ig2ik1",
        "-i3v30h",
        "-hi2q41",
        "-h5crsh",
        "-gk31k1",
        "-g7d3ch",
        "-fm3941",
        "-f9dash",
        "-eo3gk1",
        "-ebdich",
        "-dq3o41",
        "-dahgoh",
        "-crhh01",
        "-ccho8h",
        "-bthog1",
        "-behvoh",
        "-avi001",
        "-agi78h",
        "-a1i7g1",
        "-9iieoh",
        "-93if01",
        "-8k07kh",
        "-8507s1",
        "-7m0f4h",
        "-770fc1",
        "-6o0mkh",
        "-690ms1",
        "-5q0u4h",
        "-5b0uc1",
        "-4s15kh",
        "-4d15s1",
        "-3f1dc1",
        "-2vf60h",
        "-2gf681",
        "-21fdgh",
        "-1ifdo1",
        "-13fl0h",
        "-kfl81",
        "-5fsgh",
        "9g37v",
        "ofrvf",
        "17frnv",
        "1n233f",
        "2622rv",
        "2l1rjf",
        "341rbv",
        "3j1k3f",
        "3oq9rv",
        "4h1cjf",
        "4qr8nv",
        "5f153f",
        "5u14rv",
        "6djc7f",
        "6s0tbv",
        "7bj4nf",
        "7qj4fv",
        "89it7f",
        "8oisvv",
        "97ilnf",
        "9milfv",
        "a5ie7f",
        "akidvv",
        "b3i6nf",
        "bii6fv",
        "c24drf",
        "cghuvv",
        "d046bf",
        "df463v",
        "du3urf",
        "ed3ujv",
        "es3nbf",
        "fb3n3v",
        "fq3frf",
        "g7c3nv",
        "go38bf",
        "h5bs7v",
        "hmlfff",
        "i3bknv",
        "ikl7vf",
        "j1bd7v",
        "jil0ff",
        "jvtkbv",
        "kgkovf",
        "kttcrv",
        "lekhff",
        "lrt5bv",
        "md6ojf",
        "mpstrv",
        "nb6h3f",
        "nnsmbv",
        "o969jf",
        "ometfv",
        "p7623f",
        "pkelvv",
        "q55qjf",
        "qieefv",
        "tcdnvv",
        "ttnb7f",
        "12v7dnv",
        "13iqrff",
        "13t767v",
        "14gqjvf",
        "14r6unv",
        "15eqcff",
        "15pp5rv",
        "16dcjjf",
        "16noubv",
        "17bcc3f",
        "17lomrv",
        "189c4jf",
        "18jofbv",
        "197bt3f",
        "19ho7rv",
        "1a5bljf",
        "1afo0bv",
        "1b3be3f",
        "1bea7fv",
        "1c1tl7f",
        "1cc9vvv",
        "1cvtdnf",
        "1da9ofv",
        "1dtt67f",
        "1e89gvv",
        "1ersunf",
        "1f699fv",
        "1fpsn7f",
        "1g4rgjv",
        "1goeubf",
        "1h2r93v",
        "1hmemrf",
        "1i0r1jv",
        "1ikefbf",
        "1iuqq3v",
        "1jie7rf",
        "1jsqijv",
        "1kge0bf",
        "1kqqb3v",
        "1ledorf",
        "1lpci7v",
        "1mcvvvf",
        "1mncanv",
        "1navoff",
        "1nlc37v",
        "1o8vgvf",
        "1ojbrnv",
        "1p6v9ff",
        "1phbk7v",
        "1q4v1vf",
        "1qftrbv",
        "1r3h93f",
        "1rdtjrv",
        "1s1h1jf",
        "1sbtcbv",
        "1svgq3f",
        "1t9t4rv",
        "1ttgijf",
        "1u7stbv",
        "1urgb3f",
        "1v5slrv",
        "1vpg3jf",
        "16cq8fv",
        "16pgdof",
        "17aq0vv",
        "17ng68f",
        "188ppfv",
        "18m2dcf",
        "196phvv",
        "19k25sf",
        "1a4pafv",
        "1ai1ucf",
        "1b2p2vv",
        "1bg1msf",
        "1c1ba3v",
        "1ce1fcf",
        "1cvb2jv",
        "1dc17sf",
        "1dtar3v",
        "1eajf0f",
        "1erajjv",
        "1f8j7gf",
        "1fpac3v",
        "1g6j00f",
        "1gnsj7v",
        "1h4iogf",
        "1hlsbnv",
        "1i2ih0f",
        "1ijs47v",
        "1j14o4f",
        "1jhrsnv",
        "1jv4gkf",
        "1kfrl7v",
        "1kt494f",
        "1ldrdnv",
        "1lr41kf",
        "1mcdkrv",
        "1mp3q4f",
        "1naddbv",
        "1nn3ikf",
        "1o8d5rv",
        "1ollpof",
        "1p6cubv",
        "1pjli8f",
        "1q4cmrv",
        "1qhlaof",
        "1r2utvv",
        "1rfl38f",
        "1s0umfv",
        "1sdkrof",
        "1suuevv",
        "1tbkk8f",
        "1tsu7fv",
        "1ua6rcf",
        "1uqtvvv",
        "1v86jsf",
        "1votofv",
        "-1e1fqdk",
        "8jciav",
        "8rerif",
        "9hcaqv",
        "9pek2f",
        "jpfo2v",
        "k6tdmf",
        "knfgiv",
        "ks5mef",
        "-1i2jd4h",
        "-1ggdh81",
        "-1klb13d",
        "-1i7vdo1",
        "9kqv2f",
        "a37ukf",
        "ai7qsf",
        "b17n4f",
        "bg7jcf",
        "bv7fkf",
        "ce7bsf",
        "ct784f",
        "dc74cf",
        "drpf8f",
        "eapbgf",
        "epp7of",
        "oeejhf",
        "-1gked2h",
        "-1g49n31",
        "-1fivsqh",
        "-1f5qbc1",
        "-q7dlqh",
        "-mptiv1",
        "-4d12bh",
        "-3tenfh",
        "3j1r4f",
        "9misgv",
        "a5il8f",
        "akil0v",
        "b3idof",
        "biidgv",
        "c24ksf",
        "cgi60v",
        "d04dcf",
        "df4d4v",
        "du45sf",
        "ed45kv",
        "es3ucf",
        "fb3u4v",
        "fq3msf",
        "g7caov",
        "go3fcf",
        "h5c38v",
        "hmlmgf",
        "i3brov",
        "iklf0f",
        "j1bk8v",
        "jil7gf",
        "jvtrcv",
        "kgl00f",
        "kttjsv",
        "lekogf",
        "lrtccv",
        "md6vkf",
        "mpt4sv",
        "nb6o4f",
        "nnstcv",
        "o96gkf",
        "omf4gv",
        "p7694f",
        "pket0v",
        "q561kf",
        "qielgv",
        "r35q4f",
        "rgee0v",
        "s1o18f",
        "see6gv",
        "svnpof",
        "tcdv0v",
        "ttni8f",
        "ub064v",
        "urnaof",
        "v8vukv",
        "vpn38f",
        "106vn4v",
        "10o9acf",
        "114vfkv",
        "11m92sf",
        "122v84v",
        "12k8rcf",
        "12v7kov",
        "13ir2gf",
        "13t7d8v",
        "14gqr0f",
        "14r75ov",
        "15eqjgf",
        "15ppcsv",
        "16dcqkf",
        "16np5cv",
        "17bcj4f",
        "17lotsv",
        "189cbkf",
        "18jomcv",
        "197c44f",
        "19hoesv",
        "1a5bskf",
        "1afo7cv",
        "1b3bl4f",
        "1beaegv",
        "1c1ts8f",
        "1cca70v",
        "1cvtkof",
        "1da9vgv",
        "1dttd8f",
        "1e89o0v",
        "1ert5of",
        "1f69ggv",
        "1fpsu8f",
        "1g4rnkv",
        "1gof5cf",
        "1h2rg4v",
        "1hmetsf",
        "1i0r8kv",
        "1ikemcf",
        "1iur14v",
        "1jieesf",
        "1jsqpkv",
        "1kge7cf",
        "1kqqi4v",
        "1ledvsf",
        "1lpcp8v",
        "1md070f",
        "1mnchov",
        "1navvgf",
        "1nlca8v",
        "1o8vo0f",
        "1ojc2ov",
        "1p6vggf",
        "1phbr8v",
        "1q4v90f",
        "1qfu2cv",
        "1r3hg4f",
        "1rdtqsv",
        "1s1h8kf",
        "1sbtjcv",
        "1svh14f",
        "1t9tbsv",
        "1ttgpkf",
        "1u7t4cv",
        "1urgi4f",
        "1v5sssv",
        "1vpgakf",
        "-1gkegj1",
        "-q7dpb1",
        "-mptmfh",
        "-lak3n1",
        "-ktu5fh",
        "-kckb71",
        "-jvucvh",
        "-jekin1",
        "-j1ukfh",
        "-ig2bj1",
        "-i3urvh",
        "-hi2j31",
        "-h5ckrh",
        "-gk2qj1",
        "-g7csbh",
        "-fm3231",
        "-f9d3rh",
        "-eo39j1",
        "-ebdbbh",
        "-dq3h31",
        "-dddirh",
        "-crh9v1",
        "-cerbnh",
        "-bthhf1",
        "-bgrj7h",
        "-avhov1",
        "-airqnh",
        "-a1i0f1",
        "-9ks27h",
        "-93i7v1",
        "-8ms9nh",
        "-8500r1",
        "-7osh7h",
        "-7708b1",
        "-6o0fjh",
        "-690fr1",
        "-5q0n3h",
        "-5b0nb1",
        "-4s0ujh",
        "-4d0ur1",
        "-3f16b1",
        "-2veuvh",
        "-2gev71",
        "-21f6fh",
        "-1if6n1",
        "-13fdvh",
        "-kfe71",
        "-5flfh",
        "9ga8v",
        "og30f",
        "17g2ov",
        "1n2a4f",
        "2629sv",
        "2g3s4f",
        "-1gljhbh",
        "-1g49u41",
        "-1fnjorh",
        "-1f6a5k1",
        "-1epk0bh",
        "-1e7nug1",
        "-1drk7rh",
        "-1dn0mc1",
        "-3ter01",
        "-3f19rh",
        "-2vf2g1",
        "3oqdcf",
        "-1t45nd6",
        "-1jc6r01",
        "-q7e3sh",
        "-mpu111",
        "-kckloh",
        "-jvunh1",
        "-2coksh",
        "-21fh11",
        "341nrf",
        "3j1giv",
        "3oq6bf",
        "4h192v",
        "5018rf",
        "5f11iv",
        "5u11bf",
        "6dj8mv",
        "6s0prf",
        "7bj16v",
        "7qj0vf",
        "89ipmv",
        "8oipff",
        "97ii6v",
        "9mihvf",
        "a5iamv",
        "akiaff",
        "b3i36v",
        "bii2vf",
        "c24aav",
        "cghrff",
        "d042qv",
        "df42jf",
        "du3rav",
        "ed3r3f",
        "es3jqv",
        "fb3jjf",
        "fq3cav",
        "g7c07f",
        "go34qv",
        "h5bonf",
        "hmlbuv",
        "i3bh7f",
        "ikl4ev",
        "j1b9nf",
        "jiksuv",
        "jvtgrf",
        "kgklev",
        "ktt9bf",
        "lekduv",
        "lrt1rf",
        "md6l2v",
        "mpsqbf",
        "nb6div",
        "nnsirf",
        "o9662v",
        "r35fiv",
        "rge3ff",
        "s1nmmv",
        "sedrvf",
        "svnf6v",
        "tcdkff",
        "ttn7mv",
        "uavrjf",
        "urn06v",
        "v8vk3f",
        "vpmomv",
        "106vcjf",
        "10o8vqv",
        "114v53f",
        "11m8oav",
        "122utjf",
        "12k8gqv",
        "12v7a7f",
        "13iqnuv",
        "13t72nf",
        "14gqgev",
        "14r6r7f",
        "15eq8uv",
        "15pp2bf",
        "16dcg2v",
        "16noqrf",
        "17bc8iv",
        "17lojbf",
        "189c12v",
        "18jobrf",
        "197bpiv",
        "19ho4bf",
        "1a5bi2v",
        "1afnsrf",
        "1b3baiv",
        "1bea3vf",
        "1c1thmv",
        "1cc9sff",
        "1cvta6v",
        "1da9kvf",
        "1dtt2mv",
        "1e89dff",
        "1ersr6v",
        "1f695vf",
        "1fpsjmv",
        "1g4rd3f",
        "1goeqqv",
        "1h2r5jf",
        "1hmejav",
        "1i0qu3f",
        "1ikebqv",
        "1iuqmjf",
        "1jie4av",
        "1jsqf3f",
        "1kgdsqv",
        "1kqq7jf",
        "1ledlav",
        "1lpcenf",
        "1mcvsev",
        "1mnc77f",
        "1navkuv",
        "1nlbvnf",
        "1o8vdev",
        "1ojbo7f",
        "1p6v5uv",
        "1phbgnf",
        "1q4uuev",
        "1qftnrf",
        "1r3h5iv",
        "1rdtgbf",
        "1s1gu2v",
        "1sbt8rf",
        "1svgmiv",
        "1t9t1bf",
        "1ttgf2v",
        "1u7sprf",
        "1urg7iv",
        "1v5sibf",
        "1vpg02v",
        "-1ri2c91",
        "-1gkek3h",
        "-1fmerjh",
        "-1fiquk1",
        "-1ena5rh",
        "-1dpadbh",
        "-1dckf41",
        "-1cqo67h",
        "-1cekmk1",
        "-1bsodnh",
        "-1bg2fg1",
        "-lak77h",
        "-ktu901",
        "421ncf",
        "501fsf",
        "-1klats1",
        "-13v16g1",
        "-13g58q1",
        "-130tbth",
        "-12i2ru1",
        "-iseddh",
        "-ih7qdh",
        "-huc0hh",
        "-hkd2m1",
        "-h09jlh",
        "-gm81e1",
        "-g24idh",
        "-fqnc61",
        "-5mfp1h",
        "-5fl1e1",
        "-4juvth",
        "-4f3ha1",
        "-3qtdth",
        "-3jg7m1",
        "-2va49h",
        "-2ldqq1",
        "-217ndh",
        "-1n8pi1",
        "esjaif",
        "f7hstv",
        "fq0kef",
        "g37qtv",
        "go31af",
        "h0np5v",
        "mc1kaf",
        "mmdo1v",
        "1460vqf",
        "197u15v",
        "-1e2kmf1",
        "g9ln6v",
        "glp6qf",
        "h7lfmv",
        "hjovaf",
        "-1d4i2c1",
        "-1b8dc4h",
        "-180r0oh",
        "-14pj6sh",
        "-14e9s01",
        "-13va38h",
        "-q1ask1",
        "-mmchch",
        "-ke99o1",
        "-eo3d3h",
        "-dq3kjh",
        "-crhdfh",
        "-bthkvh",
        "-avhsfh",
        "-a1i3vh",
        "-93ibfh",
        "5u1bsv",
        "6djj8f",
        "6s14cv",
        "7bjbof",
        "7qjbgv",
        "89j48f",
        "8oj40v",
        "97isof",
        "130v0kv",
        "13i8jsf",
        "13vh7ov",
        "14g8ccf",
        "14th08v",
        "15e84sf",
        "2l22kf",
        "3422cv",
        "421qsv",
        "4h1jkf",
        "501jcv",
        "5f1c4f",
        "-qqhnc1",
        "-bgrq8h",
        "-kfooh",
        "-5g011",
        "9fvnf",
        "ofoev",
        "-1klb579",
        "sv4igv",
        "-1vgslud",
        "-fm3g51",
        "-f9dhth",
        "261rqv",
        "2l1kif",
        "341kav",
        "3j1d2f",
        "421cqv",
        "4h15if",
        "5015av",
        "5f0u2f",
        "5u0tqv",
        "6dj56f",
        "6s0mav",
        "7bitmf",
        "7qitev",
        "89im6f",
        "8oiluv",
        "97iemf",
        "9mieev",
        "a5i76f",
        "aki6uv",
        "b3hvmf",
        "bihvev",
        "c246qf",
        "cghnuv",
        "d03vaf",
        "df3v2v",
        "du3nqf",
        "ed3niv",
        "es3gaf",
        "fb3g2v",
        "fq38qf",
        "g7bsmv",
        "h5bl6v",
        "hml8ef",
        "i3bdmv",
        "ikl0uf",
        "j1b66v",
        "jikpef",
        "jvtdav",
        "kgkhuf",
        "ktt5qv",
        "lekaef",
        "lrsuav",
        "md6hif",
        "mpsmqv",
        "nb6a2f",
        "nnsfav",
        "o962if",
        "omemev",
        "p75r2f",
        "pkeeuv",
        "q55jif",
        "qie7ev",
        "r35c2f",
        "rgdvuv",
        "s1nj6f",
        "sedoev",
        "svnbmf",
        "tcdguv",
        "ttn46f",
        "uavo2v",
        "urmsmf",
        "v8vgiv",
        "vpml6f",
        "106v92v",
        "10o8saf",
        "114v1iv",
        "11m8kqf",
        "122uq2v",
        "12k8daf",
        "12v76mv",
        "13iqkef",
        "13t6v6v",
        "14gqcuf",
        "14r6nmv",
        "15eq5ef",
        "15pouqv",
        "16dccif",
        "16nonav",
        "17bc52f",
        "17lofqv",
        "189btif",
        "18jo8av",
        "197bm2f",
        "19ho0qv",
        "1a5beif",
        "1afnpav",
        "1b3b72f",
        "1bea0ev",
        "1c1te6f",
        "1cc9ouv",
        "1cvt6mf",
        "1da9hev",
        "1dtsv6f",
        "1e899uv",
        "1ersnmf",
        "1f692ev",
        "1fpsg6f",
        "1g4r9iv",
        "1goenaf",
        "1h2r22v",
        "1hmefqf",
        "1i0qqiv",
        "1ike8af",
        "1iuqj2v",
        "1jie0qf",
        "1jsqbiv",
        "1kgdpaf",
        "1kqq42v",
        "1ledhqf",
        "1lpcb6v",
        "1mcvouf",
        "1mnc3mv",
        "1navhef",
        "1nlbs6v",
        "1o8v9uf",
        "1ojbkmv",
        "1p6v2ef",
        "1phbd6v",
        "1q4uquf",
        "1qftkav",
        "1r3h22f",
        "1rdtcqv",
        "1s1gqif",
        "1sbt5av",
        "1svgj2f",
        "1t9stqv",
        "1ttgbif",
        "1u7smav",
        "1urg42f",
        "1v5seqv",
        "1vpfsif",
        "-1i7v601",
        "-1gkf0bl",
        "-1g4aac5",
        "-10m3ckl",
        "-vkfjm9",
        "-v8c42p",
        "-umfr69",
        "-uacbip",
        "-tog2m9",
        "-tccj2p",
        "-sptri9",
        "-secqip",
        "-rru329",
        "-rfqjep",
        "-qtuai9",
        "-qhqqup",
        "-pvui29",
        "-mpu69p",
        "-m7fep9",
        "-lrbv5p",
        "-l9fm99",
        "-ktc6lp",
        "-kbftp9",
        "-jvce5p",
        "-jdg599",
        "-j1cllp",
        "-ietu59",
        "-i2qehp",
        "-hi32t9",
        "-h5d4lp",
        "-gk3ad9",
        "-g7dc5p",
        "-fm3ht9",
        "-f9djlp",
        "-eo3pd9",
        "-ebdr5p",
        "-dq40t9",
        "-dde2lp",
        "-crhpp9",
        "-cerrhp",
        "-bti199",
        "-bgs31p",
        "-avi8p9",
        "-aisahp",
        "-a1ig99",
        "-9ksi1p",
        "-93inp9",
        "-8k0gdp",
        "-850gl9",
        "-7m0ntp",
        "-770o59",
        "-6o0vdp",
        "-690vl9",
        "-5q16tp",
        "-5b1759",
        "-4s1edp",
        "-4d1el9",
        "-3tf79p",
        "-3ib559",
        "-3f1kd1",
        "-2vfd1h",
        "-2gfd91",
        "-21fkhh",
        "-1ifkp1",
        "-13fs1h",
        "-kfs91",
        "-5g3hh",
        "9fs6v",
        "ofkuf",
        "17fkmv",
        "1n1s2f",
        "g7blnr",
        "go2qbb",
        "h5be7r",
        "hmktur",
        "i3b6nr",
        "ikkpvb",
        "j1av7r",
        "jikifb",
        "jvt6br",
        "kgkavb",
        "ktsurr",
        "lek3fb",
        "lrsnbr",
        "md6ajb",
        "mpsfrr",
        "nb633b",
        "nns8br",
        "o95rjb",
        "omeffr",
        "p75k3b",
        "pke7vr",
        "q55cjb",
        "qie0fr",
        "r3553b",
        "rgdovr",
        "s1nc7b",
        "sedhfr",
        "svn4nb",
        "tcd9vr",
        "ttmt7b",
        "uavh3r",
        "urmlnb",
        "v8v9jr",
        "vpme7b",
        "106v23r",
        "10o8lbb",
        "114uqjr",
        "11m8drb",
        "122uj3r",
        "12k86bb",
        "12v6vnr",
        "13iqdfb",
        "13t6o7r",
        "14gq5vb",
        "14r6gnr",
        "15epufb",
        "15ponrr",
        "16dc5jb",
        "16nogbr",
        "-1mf0io2",
        "-1g64595",
        "3lbb2v",
        "3sr5mf",
        "ciou2v",
        "csvp2f",
        "julrmv",
        "kcgn6f",
        "1258kiv",
        "12huiqf",
        "-14lnff9",
        "-1jid1jp",
        "-3cdga5",
        "57rd1r",
        "jnvupf",
        "-1vgsl31",
        "-1ihm8a1",
        "-1i2jr6h",
        "-1em5q61",
        "-1ecujmh",
        "-1dobae1",
        "-1de9o6h",
        "-1cqonq1",
        "-1cg7bah",
        "-1bs6gm1",
        "-1bi7iqh",
        "-1au6o61",
        "-1aj5heh",
        "-1a06vm1",
        "-19k0rmh",
        "-19129u1",
        "-18n60eh",
        "-1847em1",
        "-17o1amh",
        "-1752ou1",
        "-16r93qh",
        "-16730e1",
        "-15tmh6h",
        "-15937u1",
        "-14ukfqh",
        "-14b3fe1",
        "-13vfq2h",
        "-13dm5i1",
        "-131g1ih",
        "-12fmd21",
        "-122tqeh",
        "-11fv8m1",
        "-1165jih",
        "-10gqiu1",
        "-106u9eh",
        "-vio621",
        "-va3e6h",
        "-un4se1",
        "-uauoeh",
        "-tp53u1",
        "-tcuvuh",
        "-sorgu1",
        "-sev7eh",
        "-rsj4a1",
        "-rgd0ah",
        "-qujbq1",
        "-qid7qh",
        "-m8ka91",
        "-lruc1h",
        "-lakhp1",
        "-ktujhh",
        "-kckp91",
        "-jvur1h",
        "-jel0p1",
        "-j1v2hh",
        "-hi3151",
        "-h5d2th",
        "-gk38l1",
        "-g7dadh",
        "-eo3nl1",
        "-ebdpdh",
        "-crho11",
        "-cerpph",
        "-bthvh1",
        "-bgs19h",
        "-avi711",
        "-ais8ph",
        "-a1ieh1",
        "-9ksg9h",
        "-770md1",
        "-6o0tlh",
        "-690tt1",
        "-5q155h",
        "-5b15d1",
        "-4s1clh",
        "-4d1ct1",
        "-3tf5hh",
        "-19pqfc1",
        "-172oqth",
        "-16on8m1",
        "-rq969h",
        "-ripbm1",
        "-qs9dph",
        "-qk74i1",
        "-ptn6lh",
        "-pm7c21",
        "-n3nt5h",
        "-ms82i1",
        "-m5o4lh",
        "-lu8a21",
        "-49vuhh",
        "-4010m1",
        "-3c5eph",
        "-31pb21",
        "-2i9h1h",
        "-25gue1",
        "-1jklhh",
        "-17h5u1",
        "-kfvph",
        "-5g721",
        "9fomf",
        "ofhdv",
        "17fh6f",
        "1n1ohv",
        "261oaf",
        "2ja55v",
        "341gqf",
        "3hci1v",
        "4219af",
        "4feutv",
        "5011qf",
        "5f0qhv",
        "5u0qaf",
        "6dj1lv",
        "6s0iqf",
        "7biq5v",
        "7r58if",
        "87r6pv",
        "8l3qmf",
        "96ddtv",
        "9j3j6f",
        "a4d6dv",
        "aln0mf",
        "b2cutv",
        "bjmp6f",
        "c0cndv",
        "chmhmf",
        "cucftv",
        "dfma6f",
        "dsun1v",
        "edm2mf",
        "equfhv",
        "f7kkqf",
        "fou81v",
        "g5kdaf",
        "gmu0hv",
        "h46kef",
        "hktp1v",
        "i26cuf",
        "iithhv",
        "j1b2mf",
        "jhfolv",
        "jvt9qf",
        "kffkmf",
        "ktt2af",
        "ldfd6f",
        "lrsqqf",
        "mbf5mf",
        "mpsjaf",
        "n9eu6f",
        "nnsbqf",
        "o7emmf",
        "omeiuf",
        "p5ef6f",
        "pkebef",
        "q40maf",
        "qhrlaf",
        "rfrdqf",
        "sedkuf",
        "tcddef",
        "uavkif",
        "v8vd2f",
        "106cmuf",
        "12v736f",
        "13i85qf",
        "13tpaaf",
        "14g7uaf",
        "14r6k6f",
        "15e7mqf",
        "15poraf",
        "16cptuf",
        "16ob2ef",
        "17bujmf",
        "17nfo6f",
        "18jo4qf",
        "19hntaf",
        "1afnlqf",
        "1be9suf",
        "1cc9lef",
        "1da9duf",
        "1e896ef",
        "1f68uuf",
        "1g4r62f",
        "1h2quif",
        "1i0qn2f",
        "1iuqfif",
        "1jsq82f",
        "1kqq0if",
        "1lpc7mf",
        "1mnc06f",
        "1nlbomf",
        "1ojbh6f",
        "1phb9mf",
        "1qftgqf",
        "1rdt9af",
        "1sbt1qf",
        "1t9sqaf",
        "1u7siqf",
        "1v5sbaf",
        "-ais1oh",
        "-dddpsh",
        "-cerioh",
        "-9ks98h",
        "-8msgoh",
        "17fo7f",
        "1n1viv",
        "261vbf",
        "2l1o2v",
        "4qr57f",
        "-dphgh1",
        "-7oso8h",
        "-fvjcc1",
        "-pp6nk1",
        "-4d1gdh",
        "3oqgsv",
        "4qrfov",
        "a5ioov",
        "-1doo281",
        "-1dejrkh",
        "-mi8q51",
        "-m5ntkh",
        "-7u2rsh",
        "-1ifh8h",
        "-13foh1",
        "-13u2q8t",
        "-13h2ahd",
        "-1ponfpd",
        "-u31ddh",
        "-trk761",
        "-td1d9h",
        "-su1ki1",
        "-sf1kph",
        "-s01s21",
        "f1hh2f",
        "f8un9v",
        "fvjtuf",
        "g7145v",
        "iptouf",
        "j1av5v",
        "mia0qf",
        "mpn71v",
        "-kg32t5",
        "-jnukjh",
        "-ig2f3h",
        "-hi2mjh",
        "-gk2u3h",
        "-fm35jh",
        "-8504bh",
        "-770brh",
        "-690jbh",
        "-5b0qrh",
        "-1klb5s5",
        "-11d5dop",
        "346t2v",
        "4q8fif",
        "8l3u6v",
        "8t8rqf",
        "9j3mmv",
        "9r8kaf",
        "km348v",
        "lc2iqf",
        "lk7nev",
        "pcjrqf",
        "115hg6v",
        "11juqaf",
        "1258rjv",
        "12humav",
        "-1klb05t",
        "-1n5odtt",
        "9kqrhv",
        "a385lf",
        "c4oiqf",
        "-t22jt1",
        "-smhith",
        "-rak3h1",
        "-r1a8lh",
        "-ofqe91",
        "-o4hadh",
        "-imdqh1",
        "-i8iv1h",
        "-1n4jhqp",
        "9msotv",
        "g7bp6f",
        "h5bhmf",
        "hml4tv",
        "i3ba6f",
        "ikktdv",
        "kgkedv",
        "md6e1v",
        "nb66hv",
        "o95v1v",
        "p75nhv",
        "q55g1v",
        "qie3uf",
        "r358hv",
        "rgdsef",
        "s1nflv",
        "svn85v",
        "ttn0lv",
        "urmp5v",
        "vpmhlv",
        "106v5if",
        "10o8opv",
        "114uu2f",
        "11m8h9v",
        "122umif",
        "12k89pv",
        "13iqgtv",
        "13t6rmf",
        "14gq9dv",
        "15eq1tv",
        "16dc91v",
        "16nojqf",
        "17bc1hv",
        "17locaf",
        "189bq1v",
        "197bihv",
        "1a5bb1v",
        "1b3b3hv",
        "1c1talv",
        "1cvt35v",
        "1dtsrlv",
        "1ersk5v",
        "1fpsclv",
        "1goejpv",
        "1hmec9v",
        "1ike4pv",
        "1jidt9v",
        "1kgdlpv",
        "1lede9v",
        "1mcvldv",
        "1navdtv",
        "1o8v6dv",
        "1p6uutv",
        "1q4undv",
        "1r3guhv",
        "1s1gn1v",
        "1svgfhv",
        "1ttg81v",
        "1urg0hv",
        "1vpfp1v",
        "-1vgsidh",
        "-12c7hph",
        "-124nn61",
        "-11e7p9h",
        "-116num1",
        "-10g80ph",
        "-108o661",
        "-vi889h",
        "-vaodm1",
        "-uk8fph",
        "-ucol61",
        "-tm8n9h",
        "-teosm1",
        "-sou1ph",
        "-sf4cm1",
        "-rre3hh",
        "-rh4k61",
        "-quj89h",
        "-qiid21",
        "-ig2pl1",
        "-i3va1h",
        "-dq3v51",
        "-dde0th",
        "-bei6ph",
        "-agie9h",
        "-9iilph",
        "-93im11",
        "-8k0elh",
        "-850et1",
        "-7m0m5h",
        "-1emqu2l",
        "-1bftmi9",
        "-1b0ts2h",
        "-1ahr9m9",
        "-1a2rf6h",
        "-19josq9",
        "-194p2ah",
        "-120mii9",
        "-11k0iih",
        "-112mq29",
        "-10m0q2h",
        "-104n1i9",
        "-vo11ih",
        "-v64qe9",
        "-uq192h",
        "-u851u9",
        "-ts1gih",
        "-ta59e9",
        "-su1o2h",
        "-sc5gu9",
        "-rvfguh",
        "-re5oe9",
        "-r1foeh",
        "-qn8o69",
        "-qalcih",
        "-pe2cm9",
        "-p6l871",
        "-9v8uih",
        "-9grkf1",
        "-9bldah",
        "-97kaf1",
        "-4ep3ah",
        "-40bp71",
        "-3gpaqh",
        "-2vd371",
        "-21amb1",
        "-1g3geh",
        "-10h7ap",
        "-i13ih",
        "-2eqep",
        "c199f",
        "rjid7",
        "25hn1f",
        "2erhsv",
        "3tvrtf",
        "4lkhp7",
        "6b3ncv",
        "7eevpf",
        "7o60gv",
        "95b1hf",
        "9mshsv",
        "gs6l1f",
        "h3mfkv",
        "hq3p5f",
        "i1jjov",
        "ikkptf",
        "kgkatf",
        "lp074v",
        "10kpthf",
        "114cbtv",
        "11kh8uf",
        "121775v",
        "12v6vlv",
        "13ggpuf",
        "13t6o5v",
        "14egief",
        "14r6glv",
        "15cgauf",
        "15ponpv",
        "16ag3ef",
        "16nog9v",
        "178fruf",
        "17lo8pv",
        "187232f",
        "18jo19v",
        "1951rif",
        "19hnppv",
        "1a31k2f",
        "1afni9v",
        "-1gker4h",
        "-1g4a551",
        "-1fnhk9p",
        "-1f6ajm1",
        "-1emnu8h",
        "-1eaklm1",
        "-1dnj8gh",
        "-1ddf1t1",
        "-1cpjg0h",
        "-1cf7c91",
        "-1brjngh",
        "-1bh7jp1",
        "-1au6dkh",
        "-1ailcl1",
        "-1a06l4h",
        "-19klk51",
        "-1926skh",
        "-18mlrl1",
        "-184744h",
        "-17o3kh1",
        "-1767bkh",
        "-16phdd1",
        "-1687j4h",
        "-15rhkt1",
        "-15a7qkh",
        "-14thsd1",
        "-14c824h",
        "-13vi3t1",
        "-13dlr0h",
        "-131ibd1",
        "-12fm2gh",
        "-1230491",
        "-11hma0h",
        "-1150bp1",
        "-10jmhgh",
        "-1070j91",
        "-vlmp0h",
        "-v90qp1",
        "-unn0gh",
        "-ub1291",
        "-tpn80h",
        "-td19p1",
        "-sr50sh",
        "-sf1h91",
        "-rt58ch",
        "-m8k6oh",
        "-lru8h1",
        "-lakl9h",
        "-ktun21",
        "-kcksph",
        "-jvuui1",
        "-jel49h",
        "-isp2e1",
        "-ig2m4h",
        "-hup2t1",
        "-hi2tkh",
        "-h5cvd1",
        "-gk354h",
        "-g7d6t1",
        "-fm3ckh",
        "-f9ded1",
        "-eo3k4h",
        "-ebdlt1",
        "-dq3rkh",
        "-dddtd1",
        "-crhkgh",
        "-cerm91",
        "-bths0h",
        "-bei391",
        "-avi3gh",
        "-agiap1",
        "-a1ib0h",
        "-9iii91",
        "-93iigh",
        "-8k0b51",
        "-850bch",
        "-7m0il1",
        "-770ish",
        "-6o0q51",
        "-690qch",
        "-5q11l1",
        "-5b11sh",
        "-4s1951",
        "-3tf211",
        "-3f1gsh",
        "-2vf9h1",
        "-2gf9oh",
        "421gbf",
        "-1mchfbn",
        "-1gljoch",
        "-1fnjvsh",
        "-1f6acl1",
        "-1epk7ch",
        "-1e7o5h1",
        "-1dpakch",
        "-1dckm51",
        "-1cqod8h",
        "-1cektl1",
        "-1bsokoh",
        "-1bg2mh1",
        "-1auos8h",
        "-1ai2u11",
        "-1a0p3oh",
        "-19k35h1",
        "-192pb8h",
        "-18m3d11",
        "-184pioh",
        "-13e89kh",
        "-123iit1",
        "-qv5fsh",
        "-qifhl1",
        "-lake8h",
        "-ktug11",
        "-jekt8h",
        "-j1uv11",
        "-i3v6h1",
        "-dahk91",
        "-cchrp1",
        "-rgfdlh",
        "-1klb6kt",
        "-13v1h1h",
        "-13g5jbh",
        "-130tmf1",
        "-12i36fh",
        "-isenv1",
        "-ih84v1",
        "-hucb31",
        "-hkdd7h",
        "-h09u71",
        "-gm8bvh",
        "-g24sv1",
        "-fqnmnh",
        "-5mg3j1",
        "-5flbvh",
        "-4jvaf1",
        "-4f3rrh",
        "-3qtof1",
        "-3jgi7h",
        "-2vaer1",
        "-2le5bh",
        "-2181v1",
        "-1n943h",
        "esj00v",
        "f7hicf",
        "fq09sv",
        "g37gcf",
        "go2mov",
        "h0nekf",
        "hlg0kv",
        "hu4ogf",
        "ijfp4v",
        "it9e8f",
        "rvde4v",
        "sbgtof",
        "stvl8v",
        "sui0cf",
        "tshscv",
        "u6u04f",
        "-1e2lbc1",
        "-4d1ju1",
        "-3tf921",
        "-1nfksa9",
        "-mprkqd",
        "5h2m5n",
        "drscdn",
        "-oeg875",
        "-o706il",
        "-nntpf5",
        "-1hp33g5",
        "d03rpv",
        "df3rif",
        "du3k9v",
        "ed3k2f",
        "es3cpv",
        "fb3cif",
        "fq359v",
        "g9352f",
        "-1klaubh",
        "-1klav8p",
        "-q0jja1",
        "421jrv",
        "501cbv",
        "-c774g1",
        "-1klb629",
        "sui3sv",
        "-1sg4r75",
        "-159lc0h",
        "-14bljgh",
        "-12f3jsh",
        "-11h3rch",
        "-uortoh",
        "-u9s511",
        "-tqs58h",
        "-ssscoh",
        "-rua5kh",
        "-rfact1",
        "-r0ad4h",
        "-qhakd1",
        "-m9osvh",
        "-lqp481",
        "-kckenh",
        "-jvugg1",
        "-jekm7h",
        "-j1uo01",
        "-i3uvg1",
        "-h5coc1",
        "-g7cvs1",
        "-f9d7c1",
        "-ebdes1",
        "-dddmc1",
        "-cerf81",
        "-bgrmo1",
        "-9iib81",
        "-l08vk1",
        "-1klb1dp",
        "1460s9v",
        "-1ocve5r",
        "-1ia66lh",
        "-1g8679r",
        "-1ffv3i1",
        "-17q321r",
        "-178hgm1",
        "-16rtvph",
        "-16af3q1",
        "-15trith",
        "-15ccmu1",
        "-14vp61h",
        "-14eaa21",
        "-141mp5h",
        "-133hnth",
        "-pu74e1",
        "-pp661h",
        "-m26s21",
        "-lu8dih",
        "-lcpai1",
        "-l8ire1",
        "-12tgu1",
        "-mq1ah",
        "-36ci1",
        "75n5f",
        "nak5v",
        "140idf",
        "1laclv",
        "220atf",
        "2jsjpv",
        "3003df",
        "3gnf1v",
        "4fs4pv",
        "4rvkdf",
        "5drt9v",
        "5qhrhf",
        "6brlpv",
        "6ohk1f",
        "79re9v",
        "7mhchf",
        "88dldv",
        "8kh51f",
        "9igthf",
        "ah34lf",
        "bf2t5f",
        "cd2llf",
        "db2e5f",
        "e926lf",
        "f71v5f",
        "g7u0pf",
        "h3jupf",
        "i1jn9f",
        "ivjfpf",
        "jf5u5v",
        "jtj89f",
        "kffh5v",
        "ks5fdf",
        "ldf9lv",
        "lq57tf",
        "mbf25v",
        "mo50df",
        "n9eqlv",
        "nm4otf",
        "ok4hdf",
        "p60q9v",
        "pjrlpf",
        "q40ipv",
        "qgmh1f",
        "r0re1v",
        "rgdldf",
        "s003pv",
        "scm21f",
        "suiatv",
        "talqhf",
        "u8lj1f",
        "uqhrtv",
        "v6lbhf",
        "vohkdv",
        "1057ilf",
        "10mhctv",
        "11kh5dv",
        "13uu0hf",
        "14rorpf",
        "15rg05f",
        "16b2ehv",
        "16sc1pf",
        "17510lv",
        "17ppblf",
        "1845mdv",
        "18np45f",
        "192nthv",
        "19loslf",
        "1a0nm1v",
        "1bjfphf",
        "1bqvr5v",
        "1chfi1f",
        "1covjlv",
        "1dffahf",
        "1dmvc5v",
        "1edf31f",
        "1ekv4lv",
        "1fberhf",
        "1fiut5v",
        "1g9ek1f",
        "1ghh49v",
        "1h80r5f",
        "1hfgspv",
        "1i60jlf",
        "1idgl9v",
        "1j40c5f",
        "1jbgdpv",
        "1k204lf",
        "1k9g69v",
        "1kvvt5f",
        "1l7fupv",
        "1ltvllf",
        "1m625tv",
        "1mshspf",
        "1n41udv",
        "1nqhl9f",
        "1o21mtv",
        "1oohdpf",
        "1p01fdv",
        "1pmh69f",
        "1pu17tv",
        "1qkgupf",
        "1qsjf1v",
        "1rj35tf",
        "1rqj7hv",
        "1sh2udf",
        "1soj01v",
        "1tf2mtf",
        "1tmiohv",
        "1ud2fdf",
        "1ukih1v",
        "1vb27tf",
        "1vii9hv",
        "-12i1fd1",
        "-2lgf61",
        "46uu7",
        "vkvq7",
        "1tq127",
        "2rv2a7",
        "3q1f67",
        "t2joav",
        "-1klb3ad",
        "-5qbtmh",
        "vp3vhf",
        "102tkkv",
        "10odu1f",
        "111frov",
        "11l3ghf",
        "11vfk8v",
        "12kqktf",
        "12u1rcv",
        "13h31hf",
        "13rf58v",
        "14petov",
        "15dl15f",
        "15o14sv",
        "16bkplf",
        "16m0tcv",
        "1966hpf",
        "19g06sv",
        "1a46a9f",
        "1aeie0v",
        "1b262pf",
        "1bci6gv",
        "1c05r9f",
        "1cahv0v",
        "1cu5jpf",
        "1d8hngv",
        "1dsnqtf",
        "1e6hg0v",
        "1eqnjdf",
        "1f4h8gv",
        "1fonbtf",
        "1g33fkv",
        "1gmn4df",
        "1h1384v",
        "1hkmstf",
        "1hvlf8v",
        "1iimldf",
        "1it2p4v",
        "1jh8shf",
        "1jr2hkv",
        "1kf8l1f",
        "1kpkoov",
        "1ld8dhf",
        "1lnkh8v",
        "1mb861f",
        "1mlk9ov",
        "1n97uhf",
        "1njk28v",
        "1o7q5lf",
        "1ohjqov",
        "1p5pu5f",
        "1pfjj8v",
        "1q3pmlf",
        "1qdjbov",
        "1r1pf5f",
        "1rc5isv",
        "1rvp7lf",
        "1sanq0v",
        "1stp05f",
        "1t853sv",
        "1tsb79f",
        "1u64scv",
        "1uqavpf",
        "1v4n3gv",
        "1voao9f",
        "-1i7vcv9",
        "a3895v",
        "ai7ucv",
        "-1hj17fl",
        "-1h5m685",
        "-1fkitp5",
        "-1fce05l",
        "-1emlpl5",
        "-1e7m0tl",
        "-1dom155",
        "-1d9m8dl",
        "-1cq3q15",
        "-1cbmftl",
        "-1bs41h5",
        "-1bdmndl",
        "-1au4915",
        "-1afmutl",
        "-1a04gh5",
        "-19hn6dl",
        "-1924o15",
        "-18j4v9l",
        "-1844vh5",
        "-17l56pl",
        "-175iod5",
        "-16n5e9l",
        "-167ivt5",
        "-15p5lpl",
        "-159j7d5",
        "-14r5t9l",
        "-14bjet5",
        "-13t64pl",
        "-13djmd5",
        "-12ujtll",
        "-12f1f95",
        "-120k55l",
        "-11h1mp5",
        "-112kcll",
        "-10j1uap",
        "-104kk79",
        "-3f1m59",
        "-2vfepp",
        "-2gff19",
        "-21fm9p",
        "-1ifmh9",
        "-13ftpp",
        "-kfu19",
        "-5g59p",
        "9fqen",
        "ofj67",
        "17fiun",
        "1n1qa7",
        "261q2n",
        "2l1iq7",
        "341iin",
        "3j1ba7",
        "421b2n",
        "4h13q7",
        "5013in",
        "5f0sa7",
        "5u0s2n",
        "6dj3e7",
        "6s0kin",
        "7biru7",
        "7qirmn",
        "89ike7",
        "8oik6n",
        "97icu7",
        "9micmn",
        "a5i5e7",
        "aki56n",
        "b3htu7",
        "bihtmn",
        "c24527",
        "cghm6n",
        "d03ti7",
        "df3tan",
        "du3m27",
        "ed3lqn",
        "es3ei7",
        "fb3ean",
        "fq3727",
        "g7bjvj",
        "go2oj3",
        "h5bcfj",
        "hmks6j",
        "i3b4vj",
        "ikko73",
        "j1atfj",
        "jikgn3",
        "jvt4jj",
        "kgk973",
        "ktst3j",
        "lek1n3",
        "lrsljj",
        "md68r3",
        "mpse3j",
        "nb61b3",
        "nns6jj",
        "o95pr3",
        "omednj",
        "p75ib3",
        "pke67j",
        "q55ar3",
        "qidunj",
        "r353b3",
        "rgdn7j",
        "s1naf3",
        "sedfnj",
        "svn2v3",
        "tcd87j",
        "ttmrf3",
        "uavfbj",
        "urmjv3",
        "v8v7rj",
        "vpmcf3",
        "106v0bj",
        "10o8jj3",
        "114uorj",
        "11m8c33",
        "122uhbj",
        "12k84j3",
        "12v6tvj",
        "13iqbn3",
        "13t6mfj",
        "14gq473",
        "14r6evj",
        "15epsn3",
        "15pom3j",
        "16dc3r3",
        "16noejj",
        "17bc3a7",
        "17loe2n",
        "189brq7",
        "18jo6in",
        "197bka7",
        "19hnv2n",
        "1a5bcq7",
        "1afnnin",
        "1b3b5a7",
        "1be9umn",
        "1c1tce7",
        "1cc9n6n",
        "1cvt4u7",
        "1da9fmn",
        "1dtste7",
        "1e8986n",
        "1erslu7",
        "1f690mn",
        "1fpsee7",
        "1g4r7qn",
        "1goeli7",
        "1h2r0an",
        "1hmee27",
        "1i0qoqn",
        "1ike6i7",
        "1iuqhan",
        "1jidv27",
        "1jsq9qn",
        "1kgdni7",
        "1kqq2an",
        "1ledg27",
        "1lpc9en",
        "1mcvn67",
        "1mnc1un",
        "1navfm7",
        "1nlbqen",
        "1o8v867",
        "1ojbiun",
        "1p6v0m7",
        "1phbben",
        "1q4up67",
        "1qftiin",
        "1r3h0a7",
        "1rdtb2n",
        "1s1goq7",
        "1sbt3in",
        "1svgha7",
        "1t9ss2n",
        "1ttg9q7",
        "1u7skin",
        "1urg2a7",
        "1v5sd2n",
        "1vpfqq7",
        "-1sg4qf9",
        "-m8jvnh",
        "-behs81",
        "-8msd81",
        "-7osko1",
        "-1dr7d5t",
        "125r36v",
        "12ddi6f",
        "-1i7v205",
        "jvaumv",
        "keanef",
        "ktan6v",
        "lcafuf",
        "-1odn111",
        "-m8js71",
        "-lqp0nh",
        "-2e587h",
        "-1ifs111",
        "-1i3ohdh",
        "-ulvh41",
        "-m7f601",
        "-lqp7oh",
        "-ifvu81",
        "-i3f8oh",
        "-5st78h",
        "-kfamh",
        "-5fhv1",
        "9gdpf",
        "og6gv",
        "17g69f",
        "1n2dkv",
        "262ddf",
        "2l264v",
        "3425tf",
        "3j1ukv",
        "3oqkdf",
        "4h1n4v",
        "4qrj9f",
        "5f1fkv",
        "5u1fdf",
        "6djmov",
        "6s17tf",
        "7bjf8v",
        "7qjf1f",
        "89j7ov",
        "8oj7hf",
        "97j08v",
        "9mj01f",
        "akiohf",
        "b3ih8v",
        "biih1f",
        "c24ocv",
        "cgi9hf",
        "d04gsv",
        "-10tbq01",
        "-u2cs1",
        "15dk1gv",
        "15ovinf",
        "17aj70v",
        "17k7jcf",
        "1c0kerv",
        "-c67g01",
        "-4rg87h",
        "-rgl81",
        "15dk51f",
        "15pfuhv",
        "17ajahf",
        "17k7ttv",
        "-lk72c1",
        "-gsn7t1",
        "-cc7vc1",
        "-1i2l1s1",
        "-1hk7noh",
        "-1fngit1",
        "-kf7601",
        "-23qso1",
        "-1kr0g1",
        "-13h9o1",
        "-oijs1",
        "-5hh81",
        "5d4jv",
        "oe77v",
        "13vbnv",
        "1n0ebv",
        "20q6vv",
        "2l06rv",
        "2vce3v",
        "3ivvbv",
        "3tc6jv",
        "4gvnrv",
        "4rbv3v",
        "5evgbv",
        "5pu67v",
        "6dhnfv",
        "6ntunv",
        "7bhfvv",
        "7ltn7v",
        "89h8fv",
        "8jtfnv",
        "97h0vv",
        "9ht87v",
        "a5gpfv",
        "aft0nv",
        "b3ghvv",
        "bg6jnv",
        "c22p3v",
        "ce6c7v",
        "d02hjv",
        "daeorv",
        "du2a3v",
        "e8ehbv",
        "es22jv",
        "f6e9rv",
        "fpfcfv",
        "g5ivjv",
        "go1jjv",
        "h456nv",
        "hmjqnv",
        "i24v7v",
        "ikjj7v",
        "j04nnv",
        "jijbnv",
        "jv9dfv",
        "kerobv",
        "kt95vv",
        "lcrgrv",
        "lr8ufv",
        "mar9bv",
        "mp8mvv",
        "n8r1rv",
        "nn8ffv",
        "o6qqbv",
        "olqmjv",
        "p5d1fv",
        "pjqf3v",
        "q3cpvv",
        "qhq7jv",
        "r1cifv",
        "rfq03v",
        "rvcavv",
        "sdpojv",
        "sqfqbv",
        "tbph3v",
        "truajv",
        "uabo7v",
        "upu33v",
        "v8bgnv",
        "vntrjv",
        "106b97v",
        "10ltk3v",
        "114b1nv",
        "11jtcjv",
        "122t8rv",
        "12ht53v",
        "130ainv",
        "13gfc7v",
        "13vf8fv",
        "14ef4nv",
        "14tf0vv",
        "15cet7v",
        "15repfv",
        "-etvjc1",
        "15dk8hv",
        "-17kmj8p",
        "-17asu59",
        "-16oe6kp",
        "-16bo6l1",
        "-15qee4p",
        "-15doe51",
        "-14selkp",
        "-14foll1",
        "-13uet4p",
        "-13h6eh1",
        "-130f4kp",
        "-12j6m11",
        "-122fc4p",
        "-11ho5p1",
        "-115228p",
        "-10jod91",
        "-10729op",
        "-vlokp1",
        "-v92h8p",
        "-unos91",
        "-ub2oop",
        "-tpp3p1",
        "-td308p",
        "-sr6sl1",
        "-sf37op",
        "-rt7451",
        "-rgh0kp",
        "4hhvev",
        "4qp9ev",
        "5ev9av",
        "5ptv6v",
        "6dhgev",
        "6ntnmv",
        "7bh8uv",
        "7ltg6v",
        "89h1ev",
        "8jt8mv",
        "97gpuv",
        "9ht16v",
        "a5giev",
        "afspmv",
        "b3gauv",
        "bef0qv",
        "c22i2v",
        "ccepav",
        "d02aiv",
        "daehqv",
        "du232v",
        "e8eaav",
        "es1riv",
        "f6e2qv",
        "fq1k2v",
        "g4drav",
        "go1civ",
        "h302ev",
        "hmjjmv",
        "i0vquv",
        "iis0av",
        "j04gmv",
        "jgroqv",
        "ju496v",
        "kerhav",
        "ks41mv",
        "lcr9qv",
        "lqm8qv",
        "mar2av",
        "mom1av",
        "n8qqqv",
        "nmlpqv",
        "o6qjav",
        "okliav",
        "p5cqev",
        "pilaqv",
        "q3ciuv",
        "qgl3av",
        "r1cbev",
        "rf7aev",
        "rvc3uv",
        "sd72uv",
        "stbsev",
        "tb6rev",
        "tru3iv",
        "u96juv",
        "upts2v",
        "v76cev",
        "vntkiv",
        "105ojiv",
        "10ltd2v",
        "113oc2v",
        "11jt5iv",
        "121o4iv",
        "12hsu2v",
        "12vnt2v",
        "13fsmiv",
        "13vf1ev",
        "14dsf2v",
        "14tepuv",
        "15bs7iv",
        "15reiev",
        "169s02v",
        "16peauv",
        "177roiv",
        "17ne3ev",
        "186dvmv",
        "18m0aiv",
        "194do6v",
        "19k032v",
        "1a2dgmv",
        "1ahvriv",
        "1b0d96v",
        "1bfvk2v",
        "1bud1mv",
        "1cdvciv",
        "1cscq6v",
        "1dbv52v",
        "1dqv1av",
        "1eahc6v",
        "1eoupqv",
        "1f8h4mv",
        "1fmuiav",
        "1g6gt6v",
        "1gkuaqv",
        "1h4glmv",
        "1hiu3av",
        "1i2ge6v",
        "1igtrqv",
        "1j12lav",
        "1jfg2uv",
        "1jv2dqv",
        "1kdfrev",
        "1kt26av",
        "1lbfjuv",
        "1lr1uqv",
        "1m9fcev",
        "1mp1nav",
        "1n7f4uv",
        "1nn1fqv",
        "1o61c2v",
        "1oljmuv",
        "1p414iv",
        "1pjjfev",
        "1q20t2v",
        "1qhj7uv",
        "1r00liv",
        "1rfj0ev",
        "1ru0e2v",
        "1sdiouv",
        "1ss06iv",
        "1tbihev",
        "1tqidmv",
        "1ua4oiv",
        "1uoi66v",
        "1v84h2v",
        "1vmhumv",
        "-4meko1",
        "bj1f5f",
        "6g4b7v",
        "-c4ta01",
        "110qhnv",
        "-baetk1",
        "-1idg781",
        "-1i2n151",
        "-rkhcl1",
        "-olrf7h",
        "-nnrmnh",
        "-mpru7h",
        "-a51nrh",
        "-9lfcvh",
        "-96fgnh",
        "-8nfkfh",
        "-88fo7h",
        "-7pfrvh",
        "-7afvnh",
        "-6rg3fh",
        "-6cg77h",
        "-5tgavh",
        "-5egenh",
        "-4uu3rh",
        "-4d1ufh",
        "-40ubbh",
        "9kqh0f",
        "-le9iad",
        "-1aud115",
        "-155o46h",
        "aievcv",
        "b1hcgf",
        "bghc8v",
        "bvjpcf",
        "cejp4v",
        "ctm68f",
        "dcoqcv",
        "drotlv",
        "eaoptv",
        "epom5v",
        "f8oidv",
        "fnoelv",
        "g6oatv",
        "glo75v",
        "h4o3dv",
        "hjnvlv",
        "i2nrtv",
        "ihno5v",
        "j0nkdv",
        "jg9v9v",
        "ke9raf",
        "knh5af",
        "kt9k1v",
        "lc9g9v",
        "lr9chv",
        "ma98pv",
        "mp951v",
        "n8919v",
        "nn8thv",
        "o68ppv",
        "olr4lv",
        "p74rdv",
        "pjqt5v",
        "q54jtv",
        "qhqllv",
        "r34cdv",
        "rfqe5v",
        "s1mjhv",
        "sdq6lv",
        "svmc1v",
        "tbpv5v",
        "ttm4hv",
        "uac69v",
        "urlt1v",
        "v8bupv",
        "vpllhv",
        "106bn9v",
        "10o7slv",
        "-14loa9h",
        "374uev",
        "3gpaqf",
        "428dqv",
        "4ernmf",
        "50aqmv",
        "5cu4if",
        "5ufruv",
        "6dktef",
        "6si8qv",
        "795imf",
        "875b6f",
        "earlav",
        "epu2ef",
        "f95vav",
        "fo5o2f",
        "g75nqv",
        "gm5gif",
        "h55gav",
        "hknnmf",
        "i69f2v",
        "iing6f",
        "j3erqv",
        "jgn8mf",
        "k0msuv",
        "ke4iif",
        "ku9fiv",
        "lcmpmf",
        "lrmpev",
        "mami6f",
        "mpmhuv",
        "n7hdef",
        "no8p2v",
        "o5h9ev",
        "om8hiv",
        "p43giv",
        "pk8a2v",
        "q2392v",
        "qi82iv",
        "r031iv",
        "rnl4qv",
        "rul8mv",
        "se4v6v",
        "st7fqv",
        "tc4nmv",
        "tr78av",
        "ua74iv",
        "up70qv",
        "v86t2v",
        "vpgjqv",
        "1066liv",
        "10mttmv",
        "114osmv",
        "11joouv",
        "122ol6v",
        "12k2buv",
        "130odmv",
        "13i24ev",
        "13uo66v",
        "14gkbiv",
        "14snumv",
        "15ek42v",
        "15qnn6v",
        "16cjsiv",
        "16p9uav",
        "17ajl2v",
        "17n9mqv",
        "19b6nif",
        "19j97qv",
        "1a55d6v",
        "1ah90av",
        "1b355mv",
        "1bfr7ev",
        "1c14u6v",
        "1cdqvuv",
        "1cv4mmv",
        "1dbqoev",
        "1dt4f6v",
        "1e9qguv",
        "1er47mv",
        "1f7q9ev",
        "1fpmeqv",
        "1g5q1uv",
        "1gnm7av",
        "1h4c92v",
        "1hllvqv",
        "1i2c1iv",
        "1ijloav",
        "1j0bq2v",
        "1jhlgqv",
        "1jubiiv",
        "1kg7nuv",
        "1ksbb2v",
        "1le7gev",
        "1lqb3iv",
        "1mc78uv",
        "1motamv",
        "1na71ev",
        "1nmt36v",
        "1o86puv",
        "1oksrmv",
        "1p66iev",
        "1pisk6v",
        "1q4opiv",
        "1qgscmv",
        "1r2oi2v",
        "1rfejqv",
        "1s0oaiv",
        "1sdecav",
        "1suo32v",
        "1tbe4qv",
        "1tsnriv",
        "1u9dtav",
        "1ura2mv",
        "1v7dlqv",
        "1vp9r6v",
        "-1audoj5",
        "-155osq1",
        "aie6pf",
        "b1gjsv",
        "bvj49f",
        "cej41v",
        "ctlh5f",
        "dco59v",
        "dro8iv",
        "eao4qv",
        "epo12v",
        "f8ntav",
        "fnnpiv",
        "g6nlqv",
        "glni2v",
        "h4neav",
        "hjnaiv",
        "i2n6qv",
        "ihn32v",
        "j0mvav",
        "jg9a6v",
        "ke967f",
        "kngg7f",
        "kt8uuv",
        "lc8r6v",
        "lr8nev",
        "ma8jmv",
        "mp8fuv",
        "n88c6v",
        "nn88ev",
        "o684mv",
        "olqfiv",
        "p746av",
        "pjq82v",
        "q53uqv",
        "qhq0iv",
        "r33nav",
        "rfpp2v",
        "s1luev",
        "sdphiv",
        "svlmuv",
        "tbpa2v",
        "ttlfev",
        "uabh6v",
        "url7uv",
        "v8b9mv",
        "vpl0ev",
        "106b26v",
        "10o77iv",
        "114aqmv",
        "11m702v",
        "122aj6v",
        "12k6oiv",
        "130abmv",
        "13i6h2v",
        "13usiqv",
        "14g69iv",
        "14ssbav",
        "15e622v",
        "16cocnf",
        "16orvrf",
        "-1aucqp1",
        "-155o0m1",
        "b1hjhf",
        "bvjssv",
        "cejslf",
        "ctm9ov",
        "dcottf",
        "drp16f",
        "eaotef",
        "epopmf",
        "f8oluf",
        "fnoi6f",
        "g6oeef",
        "gloamf",
        "h4o6uf",
        "hjo36f",
        "i2nvef",
        "ihnrmf",
        "j0nnuf",
        "jga2qf",
        "ke9uqv",
        "knh8qv",
        "kt9nif",
        "lc9jqf",
        "lr9g2f",
        "ma9caf",
        "mp98if",
        "n894qf",
        "nn94iv",
        "o690qv",
        "olrbmv",
        "p752ev",
        "pjr46v",
        "q54quv",
        "qhqsmv",
        "r34jev",
        "rfql6v",
        "s1mqiv",
        "sdqdmv",
        "svmj2v",
        "tbq66v",
        "ttmbiv",
        "uacdav",
        "urm42v",
        "v8c5qv",
        "vplsiv",
        "106buav",
        "-1aucscp",
        "aif2tf",
        "nn912f",
        "o68taf",
        "olr86f",
        "p74uuf",
        "pjr0mf",
        "q54nef",
        "qhqp6f",
        "r34fuf",
        "rfqhmf",
        "s1mn2f",
        "sdqa6f",
        "svmfif",
        "tbq2mf",
        "ttm82f",
        "uac9qf",
        "urm0if",
        "v8c2af",
        "vplp2f",
        "106bqqf",
        "10o806f",
        "-1aucslt",
        "b1hg0v",
        "bghfpf",
        "-1aucr5h",
        "-1gsvgp1",
        "bj0q2f",
        "bvk3tv",
        "cehfaf",
        "ctmgpv",
        "dcp4uf",
        "drri1v",
        "earhqf",
        "epot6v",
        "f8opev",
        "fnolmv",
        "g6ohuv",
        "gloe6v",
        "h4oaev",
        "hjo6mv",
        "i2o2uv",
        "ihnv6v",
        "j0nrev",
        "jga6av",
        "jvctvv",
        "kthv7v",
        "lrkc3v",
        "mpmovv",
        "nnp5rv",
        "o6rmfv",
        "olu73v",
        "p50nnv",
        "pk0jvv",
        "q334jv",
        "qi30rv",
        "r15hfv",
        "rg5dnv",
        "rv7ubv",
        "seaevv",
        "stcvjv",
        "trfcfv",
        "uaf8nv",
        "uphpbv",
        "v8hljv",
        "vnk67v",
        "106mmrv",
        "10lp7fv",
        "114p3nv",
        "11jrkbv",
        "122rgjv",
        "12hu17v",
        "13g0e3v",
        "-1f0qomh",
        "28l4lv",
        "-1aucqlt",
        "-c2bsth",
        "aif6dv",
        "bghj9v",
        "bvk0df",
        "cek05v",
        "ctmd9f",
        "dcp1dv",
        "drp4mv",
        "eap0uv",
        "kea2bf",
        "kt9ujf",
        "pjrb7v",
        "q551vv",
        "qhr3nv",
        "r34qfv",
        "rfqs7v",
        "s1n1jv",
        "sdqknv",
        "svmq3v",
        "tbqd7v",
        "ttmijv",
        "uackbv",
        "urmb3v",
        "v8ccrv",
        "vpm3jv",
        "106c5bv",
        "10o8anv",
        "114btrv",
        "11m837v",
        "122bmbv",
        "12k7rnv",
        "130berv",
        "13i7k7v",
        "13utlvv",
        "14g7cnv",
        "14stefv",
        "15e757v",
        "15qt6vv",
        "16cpcbv",
        "16osvfv",
        "17ap4rv",
        "17msnvv",
        "188otbv",
        "18lev3v",
        "196olrv",
        "19jenjv",
        "1a4oebv",
        "1aheg3v",
        "1b2o6rv",
        "-1epb61t",
        "-1f2l0g5",
        "-155o7n1",
        "aiersf",
        "b1h8vv",
        "bgh8of",
        "bvjlrv",
        "cejlkf",
        "ctm2nv",
        "dcomsf",
        "droq5f",
        "eaomdf",
        "epoilf",
        "f8oetf",
        "fnob5f",
        "g6o7df",
        "glo3lf",
        "h4nvtf",
        "hjns5f",
        "i2nodf",
        "ihnklf",
        "j0ngtf",
        "jg9rpf",
        "ke9npv",
        "knh1pv",
        "kt9ghf",
        "lc9cpf",
        "lr991f",
        "ma959f",
        "mp91hf",
        "n88tpf",
        "nn8q1f",
        "nsej3v",
        "114bfpv",
        "11m7l5v",
        "122b89v",
        "12k7dlv",
        "130b0pv",
        "13i765v",
        "13ut7tv",
        "14g6ulv",
        "14st0dv",
        "15e6n5v",
        "15qsotv",
        "16cou9v",
        "16oshdv",
        "1a4nspf",
        "1bfdqhv",
        "-1epl711",
        "-1e88vdh",
        "-1dr2vt1",
        "-1dc0iph",
        "-1ctlm11",
        "-1cdh01h",
        "-1btc311",
        "-1bh8jdh",
        "-btauh1",
        "-a164p1",
        "-9kiqth",
        "-9313h1",
        "-8mdplh",
        "-84uml1",
        "-7obcph",
        "2acniv",
        "2imtuf",
        "3460uv",
        "6b35qf",
        "df8bmv",
        "dt376f",
        "edaoiv",
        "er5k2f",
        "fbd5ev",
        "fp80uf",
        "g9fiav",
        "gnadqf",
        "ha6b6v",
        "hlff2f",
        "i6enqv",
        "ijhruf",
        "j3pdav",
        "jhk8qf",
        "k1rq6v",
        "kfmlmf",
        "l00rev",
        "lcs2ef",
        "lr9jiv",
        "mp9c2v",
        "p4r4ef",
        "q2qsuf",
        "r0qlef",
        "114bmqv",
        "11m7omf",
        "122bfav",
        "12k7h6f",
        "130b7qv",
        "13i79mf",
        "13uteuv",
        "14g726f",
        "14st7ev",
        "15e6qmf",
        "15qsvuv",
        "16cp1qf",
        "16osoev",
        "17aoqaf",
        "17msguv",
        "188oiqf",
        "18leo2v",
        "196obaf",
        "19jegiv",
        "1a4o3qf",
        "1ahe92v",
        "1b2nsaf",
        "1bfe1iv",
        "1c1a3ef",
        "1cddq2v",
        "1cv9ruf",
        "1dbdiiv",
        "1dt9kef",
        "1e9vpmv",
        "1er9cuf",
        "1f7vi6v",
        "1fp95ef",
        "1g5vamv",
        "1gnrcif",
        "1h3v36v",
        "1hlr52f",
        "1i1urmv",
        "1ijqtif",
        "1j0h2qv",
        "1jhqm2f",
        "1jugrav",
        "1kfqeif",
        "1ksgjqv",
        "1ldq72f",
        "1lqgcav",
        "1mcce6f",
        "1mog4qv",
        "1nac6mf",
        "1nmftav",
        "1o8bv6f",
        "1ol24ev",
        "1p6bnmf",
        "1pj1suv",
        "1q4bg6f",
        "1qh1lev",
        "1r2tnaf",
        "1rf1duv",
        "1s0tfqf",
        "1sd16ev",
        "1sut8af",
        "1tb0uuv",
        "1tst0qf",
        "1u9j62v",
        "1uqspaf",
        "1v7iuiv",
        "1voshqf",
        "-1aud0fh",
        "kbt8tv",
        "kuedpf",
        "lc998v",
        "lse69f",
        "ma91ov",
        "mqdupf",
        "n88q8v",
        "nodn9f",
        "o68iov",
        "omdfpf",
        "p4qpsv",
        "pjr2en",
        "q54lm7",
        "qhqqun",
        "r34e67",
        "rfqjen",
        "s1mla7",
        "sdqbun",
        "svmdq7",
        "tbq4en",
        "ttm6a7",
        "uacbin",
        "urluq7",
        "v8c42n",
        "vplna7",
        "106bsin",
        "10o7ue7",
        "114bl2n",
        "-197bvdt",
        "-12phe3p",
        "-qi8uah",
        "-pvl3n9",
        "-pmljap",
        "-monrb9",
        "-1f281j1",
        "-155oeo1",
        "aiekrf",
        "b1h1uv",
        "bgh1nf",
        "bvjeqv",
        "cejejf",
        "ctlrmv",
        "dcofrf",
        "droj4f",
        "eaofcf",
        "epobkf",
        "f8o7sf",
        "fno44f",
        "g6o0cf",
        "glnskf",
        "h4nosf",
        "hjnl4f",
        "i2nhcf",
        "ihndkf",
        "j0n9sf",
        "jg9kof",
        "ke9gov",
        "kngqov",
        "kt99gf",
        "lc95of",
        "lr920f",
        "ma8u8f",
        "mp8qgf",
        "n88mof",
        "nn8j0f",
        "o68f8f",
        "olqq4f",
        "p74gsf",
        "pjqikf",
        "q549cf",
        "qhqb4f",
        "r341sf",
        "rfq3kf",
        "s1m90f",
        "sdps4f",
        "svm1gf",
        "tbpkkf",
        "ttlq0f",
        "uabrof",
        "urligf",
        "v8bk8f",
        "vplb0f",
        "106bcof",
        "10o7i4f",
        "114b58f",
        "11m7akf",
        "122atof",
        "12k734f",
        "130am8f",
        "13i6rkf",
        "13ustcf",
        "14g6k4f",
        "14sslsf",
        "15e6ckf",
        "15qsecf",
        "16cojof",
        "16os6sf",
        "1a4ni7v",
        "1bfdjgv",
        "-1sio66p",
        "7gnn4f",
        "ceji3v",
        "eao8bf",
        "f8o0rf",
        "g6npbf",
        "h4nhrf",
        "i2nabf",
        "j0n2rf",
        "jv99vf",
        "ke92mv",
        "kt92ff",
        "lr8qvf",
        "mp8jff",
        "nn8bvf",
        "olqj3f",
        "p4qbqv",
        "pjqbjf",
        "q2q4av",
        "qhq43f",
        "r0psqv",
        "tej9cf",
        "tr97jv",
        "ua97cf",
        "up903v",
        "v88vsf",
        "vn8ojv",
        "1068ocf",
        "10l8h3v",
        "1148gsf",
        "11j89jv",
        "12289cf",
        "12hqgnv",
        "13uvanf",
        "1ahb6kv",
        "1b0aobf",
        "1bfav4v",
        "1buagrf",
        "1cdankv",
        "1cssnvf",
        "1dbsuov",
        "1dqsgff",
        "1e9sn8v",
        "1eos8vf",
        "1f7sfov",
        "1fms1ff",
        "1g5s88v",
        "1gkrpvf",
        "1h3s0ov",
        "1hiriff",
        "1i1rp8v",
        "1ihdpjf",
        "1j0e0cv",
        "1jfdi3f",
        "1judosv",
        "1kddajf",
        "1ksdhcv",
        "1lbd33f",
        "1lqd9sv",
        "1m9crjf",
        "1mod2cv",
        "1n7v2nf",
        "1nmv9gv",
        "1o5ur7f",
        "1okv20v",
        "1p3ujnf",
        "1piuqgv",
        "1q1uc7f",
        "1qguj0v",
        "1qvu4nf",
        "1reubgv",
        "1rttt7f",
        "1scu40v",
        "1ssg4bf",
        "1tbgb4v",
        "1tqfsrf",
        "1u9g3kv",
        "1uoflbf",
        "1v7fs4v",
        "1vmfdrf",
        "-rq7vk1",
        "-rgbm4h",
        "-r2lsc1",
        "-qi998h",
        "fbkdfv",
        "fmivrf",
        "g7sq3v",
        "gkiobf",
        "h5sijv",
        "hiigrf",
        "i4epnv",
        "ih4nvf",
        "j2ei7v",
        "jf4gff",
        "k0eanv",
        "kd48vf",
        "-1s64gn5",
        "-qaboup",
        "-pmll31",
        "-mokvu9",
        "oqc017",
        "p7200v",
        "123vqh7",
        "-h5ebb9",
        "14v78v",
        "153nh0f",
        "15jpm4f",
        "-1f0ql49",
        "-1entk41",
        "-1ea2okh",
        "-1dptrk1",
        "-1dc304h",
        "-1cru341",
        "-1ce37kh",
        "-1btuak1",
        "-1bfh0gh",
        "-771bg1",
        "-6q8osh",
        "-68pls1",
        "-5s90ch",
        "-5akkk1",
        "-4u1aoh",
        "-4ci7o1",
        "-401i8h",
        "-3f29g1",
        "-31sh0h",
        "-2gde01",
        "-1i8co1",
        "-15l2sh",
        "-k5vs1",
        "-7im0h",
        "9scvv",
        "mfmrf",
        "17uprv",
        "1ki3nf",
        "263r3v",
        "2in4vf",
        "3467vv",
        "3gphrf",
        "428krv",
        "4erunf",
        "50b1nv",
        "5cubjf",
        "6b3crf",
        "76mmff",
        "7qksnv",
        "84p3bf",
        "cf9h7v",
        "ctmrbf",
        "ddeifv",
        "drrsjf",
        "f5a8nv",
        "folpbf",
        "g4eufv",
        "goi6ff",
        "h3osvv",
        "hmn7nf",
        "i35frv",
        "iiahbf",
        "j1ah3v",
        "jvcmuv",
        "kef42f",
        "ku46qv",
        "lck5af",
        "lr4aqv",
        "ma6nuf",
        "n8ov2f",
        "nnouqv",
        "o6rbuf",
        "olu02v",
        "p50d6f",
        "pjtoiv",
        "q32q2f",
        "qhth2v",
        "r156uf",
        "rg56mv",
        "sea7uv",
        "stcl2f",
        "tcckqv",
        "trf1uf",
        "uaf1mv",
        "upheqf",
        "v8heiv",
        "vnjrmf",
        "106mfqv",
        "11jr9qf",
        "122r9iv",
        "13ikfif",
        "13vakqv",
        "14gmsef",
        "15ek0if",
        "15ra5qv",
        "16cjp2f",
        "17ajhif",
        "188ja2f",
        "18l9fav",
        "196j2if",
        "1a559mf",
        "1b3526f",
        "1bf8oqv",
        "1c14qmf",
        "1cv4j6f",
        "1dt4bmf",
        "1er446f",
        "1fpmbaf",
        "1gnm3qf",
        "1h3pqev",
        "1hllsaf",
        "1ijlkqf",
        "1jhldaf",
        "1kg7kef",
        "1le7cuf",
        "1mc75ef",
        "1na6tuf",
        "1o86mef",
        "1p66euf",
        "1q4om2f",
        "1r2oeif",
        "1res56v",
        "1s0o72f",
        "1sunvif",
        "1tsno2f",
        "1ur9v6f",
        "1vp9nmf",
        "-1mhjppt",
        "-q6dj8h",
        "-mqi4ch",
        "5ukc3f",
        "ss767v",
        "-1f0qpip",
        "-1aucv41",
        "kcl3qf",
        "-1d8hoel",
        "4urbuv",
        "5dr4mf",
        "5vkp6v",
        "6bthif",
        "6q8eav",
        "78loef",
        "7o86qv",
        "87ajuf",
        "8m7vav",
        "957o2f",
        "9kq6ev",
        "a37gif",
        "ai7gav",
        "b1792f",
        "bg78qv",
        "bv71if",
        "ce71av",
        "ct6q2f",
        "dc6pqv",
        "jva2iv",
        "kt9r2v",
        "1bt0vuf",
        "-rqcj91",
        "-phkflh",
        "-p560g1",
        "-mnadkh",
        "-m9kjs1",
        "-lp87ph",
        "-2dhfdh",
        "47p2uv",
        "4frc6f",
        "4vdqiv",
        "5accuf",
        "ebtu6v",
        "eojsef",
        "fcpvqv",
        "fm16af",
        "g85cav",
        "gkjdef",
        "h5t7mv",
        "hi0naf",
        "i5kc2v",
        "ig0fqf",
        "jddpmf",
        "junjuv",
        "kc00qf",
        "lai7uf",
        "m8i0ef",
        "n5vaaf",
        "nnmaev",
        "o4hhef",
        "oee1uv",
        "rhcoav",
        "s0ch2f",
        "sfuvev",
        "suuo6f",
        "tdunuv",
        "tsugmf",
        "ubugev",
        "uqu96f",
        "v9u8uv",
        "vou1mf",
        "107u1ev",
        "10lp0ev",
        "115tpuv",
        "11k3dvf",
        "130tmev",
        "13egrrf",
        "15a0f2v",
        "15qqbkr",
        "16p9ucr",
        "173bgif",
        "185n4ev",
        "194982f",
        "1a4ir2f",
        "1ahbkmv",
        "1b2ijif",
        "1bfbgnf",
        "1c17iiv",
        "1cdb97f",
        "1cv7b2v",
        "1dbtgbf",
        "1dt73iv",
        "1e9t8rf",
        "1er6s2v",
        "1f7t1bf",
        "1fpp36v",
        "1g5sprf",
        "1gnormv",
        "1h3sibf",
        "1hlok6v",
        "1i1sarf",
        "1ijocmv",
        "1j0ehvf",
        "1jho56v",
        "1jueaff",
        "1kfntmv",
        "1kse2vf",
        "1lea4qv",
        "1lqdrff",
        "1mc9tav",
        "1modjvf",
        "1na9lqv",
        "1nmvr3f",
        "1o89eav",
        "1okvjjf",
        "1p696qv",
        "1pivc3f",
        "1q48vav",
        "1qgv4jf",
        "1r2r6ev",
        "1reut3f",
        "1s0quuv",
        "1sculjf",
        "1suqnev",
        "1tbgsnf",
        "1tsqfuv",
        "1u9gl7f",
        "1uqq8ev",
        "1v7gdnf",
        "1vpcfiv",
        "14bm1if",
        "175o2uv",
        "1789n2f",
        "-1rn7f41",
        "-1n5pl7n",
        "-pck6c1",
        "-naccch",
        "-ms9g8h",
        "-lcqh7h",
        "-dki6s1",
        "-9d0q01",
        "53rhnv",
        "-1t9d98b",
        "-r1ba29",
        "-qibhap",
        "-qb91s1",
        "-mr77ch",
        "-m9ai69",
        "-lmpdap",
        "-lbqju9",
        "-kmahip",
        "-kc3fi9",
        "-jt3mqp",
        "-jgdhi9",
        "-iv3uap",
        "-iidp29",
        "-i145qp",
        "-hke0i9",
        "-h34dap",
        "-glrpe9",
        "-g5796p",
        "-fns0u9",
        "-f6idmp",
        "-er15m9",
        "-e8il6p",
        "-dt1d69",
        "-da0e2p",
        "-cv1km9",
        "-cc0lip",
        "-c0fdi9",
        "-be0t2p",
        "-b2fl29",
        "-ag14ip",
        "-a4fsi9",
        "-9i1c2p",
        "-96g429",
        "-8jf4up",
        "-88gbi9",
        "-7lfcep",
        "-7agj29",
        "-6nfjup",
        "-6bubu9",
        "-5pfrep",
        "-5duje9",
        "-4rg2up",
        "-4dl0e9",
        "-3ul7mp",
        "-3fl7u9",
        "-30lf6p",
        "-2hlfe9",
        "-22382p",
        "-1j38a9",
        "-143fip",
        "-l3fq9",
        "-63n2p",
        "8s8ln",
        "ns1d7",
        "16s15n",
        "1lrpt7",
        "24rpln",
        "2ke117",
        "33e0pn",
        "3idph7",
        "3o6f9n",
        "4gdi17",
        "4vdhpn",
        "5edah7",
        "5tda9n",
        "6cd317",
        "8pme9n",
        "96ur57",
        "-1sio0rd",
        "7gnqkv",
        "drofjv",
        "epo83v",
        "fno0jv",
        "glnp3v",
        "hjnhjv",
        "ihna3v",
        "jg9h7v",
        "jv9h0f",
        "ke99nv",
        "lc927v",
        "ma8qnv",
        "n88j7v",
        "o68bnv",
        "p4qirv",
        "q2qbbv",
        "r0q3rv",
        "tejgdf",
        "tr9ekv",
        "ua9edf",
        "up974v",
        "v896tf",
        "vn8vkv",
        "1068vdf",
        "10l8o4v",
        "1148ntf",
        "11j8gkv",
        "1228gdf",
        "12hqnov",
        "1ahba5f",
        "1b0arrv",
        "1bfb2lf",
        "1buakbv",
        "1cdar5f",
        "1cssrfv",
        "1dbt29f",
        "1dqsjvv",
        "1e9sqpf",
        "1eoscfv",
        "1f7sj9f",
        "1fms4vv",
        "1g5sbpf",
        "1gkrtfv",
        "1h3s49f",
        "1hirlvv",
        "1i1rspf",
        "1ihdt3v",
        "1j0e3tf",
        "1jfdljv",
        "1judsdf",
        "1kdde3v",
        "1ksdktf",
        "1lbd6jv",
        "1lqdddf",
        "1m9cv3v",
        "1mod5tf",
        "1n7v67v",
        "1nmvd1f",
        "1o5uunv",
        "1okv5hf",
        "1p3un7v",
        "1piuu1f",
        "1q1ufnv",
        "1qgumhf",
        "1qvu87v",
        "1reuf1f",
        "1rtu0nv",
        "1scu7hf",
        "1ssg7rv",
        "1tbgelf",
        "1tqg0bv",
        "1u9g75f",
        "1uoforv",
        "1v7fvlf",
        "1vmfhbv",
        "-1eurs22",
        "-155ob7h",
        "aieobv",
        "b1h5ff",
        "bgh57v",
        "bvjibf",
        "ctlv7f",
        "dcojbv",
        "dromkv",
        "eaoisv",
        "epof4v",
        "f8obcv",
        "fno7kv",
        "g6o3sv",
        "glo04v",
        "h4nscv",
        "hjnokv",
        "i2nksv",
        "ihnh4v",
        "j0ndcv",
        "jg9o8v",
        "ke9k9f",
        "kngu9f",
        "kt9d0v",
        "lr95gv",
        "mp8u0v",
        "nn8mgv",
        "olqtkv",
        "p74kcv",
        "pjqm4v",
        "q54csv",
        "qhqekv",
        "r345cv",
        "rfq74v",
        "s1mcgv",
        "sdpvkv",
        "svm50v",
        "tbpo4v",
        "ttltgv",
        "uabv8v",
        "urlm0v",
        "v8bnov",
        "vplegv",
        "106bg8v",
        "10o7lkv",
        "114b8ov",
        "11m7e4v",
        "122b18v",
        "12k76kv",
        "130apov",
        "13i6v4v",
        "13ut0sv",
        "14g6nkv",
        "14sspcv",
        "15e6g4v",
        "15qshsv",
        "16con8v",
        "16osacv",
        "1a4nlof",
        "-1nn82j9",
        "-1if7q51",
        "-1i2kg9h",
        "-1atflt1",
        "-1ahs0hh",
        "-1a0cth1",
        "-19jpjlh",
        "-ro04d1",
        "-rg0fhh",
        "-rba2l1",
        "-qj2vth",
        "-n8s511",
        "-mp9tlh",
        "-m5rhl1",
        "-lrpvdh",
        "-lb7sh1",
        "-ktd11h",
        "-kd8411",
        "-jvd8hh",
        "-jfqq51",
        "-j1dg1h",
        "-ih0lt1",
        "-i2r8th",
        "-himbt1",
        "-h4os1h",
        "-70mhl1",
        "-6pmh9h",
        "-59fud1",
        "-4u1hph",
        "a1emv",
        "mncuf",
        "18176v",
        "1kn5ef",
        "26jeav",
        "2j9cif",
        "36t4rf",
        "3jja3v",
        "3vmt7v",
        "4hj9kv",
        "4tmemv",
        "5f01uf",
        "611jiv",
        "6di92f",
        "7ad4af",
        "96f65v",
        "9kqdfv",
        "a4eulv",
        "ai7nbv",
        "b2en5v",
        "bg7frv",
        "c0eflv",
        "coj52f",
        "ctp55v",
        "ecdkuf",
        "epm5af",
        "f8osvf",
        "fnop7f",
        "g6olff",
        "glohnf",
        "h4odvf",
        "j0nuvf",
        "jva63f",
        "lc9qrf",
        "lr9n3f",
        "ma9jbf",
        "mon0vf",
        "n89brf",
        "nn983f",
        "o694bf",
        "olrf7f",
        "p755vf",
        "pjr7nf",
        "q54uff",
        "qhr07f",
        "r34mvf",
        "rfqonf",
        "s1mu3f",
        "sdqh7f",
        "svmmjf",
        "tbq9nf",
        "ttmf3f",
        "uacgrf",
        "urm7jf",
        "v8c9bf",
        "vpm03f",
        "106c1rf",
        "10o877f",
        "114bqbf",
        "11m7vnf",
        "122birf",
        "12k7o7f",
        "16ovncf",
        "19jhfgf",
        "1b3t7kf",
        "1bsubif",
        "-1b8euh1",
        "-12ui8d1",
        "-q40v3p",
        "-kc6efp",
        "-ig1mg1",
        "-5kkgbp",
        "-12uifj9",
        "-nqehgh",
        "-5kkncp",
        "-1gsvejp",
        "-kabqt1",
        "-k21o21",
        "-jt0ikh",
        "-je3e91",
        "-iuu5oh",
        "-ih8j11",
        "-i4nj01",
        "-hkdnp1",
        "-h1uso1",
        "-gkmcc1",
        "-g5mg41",
        "-fn92g1",
        "-faj0o1",
        "-ek3dd1",
        "-ecjiph",
        "-dm6281",
        "-dejq9h",
        "-comb11",
        "-cesbc1",
        "-btg081",
        "-bhfc1h",
        "okh5mv",
        "p3orif",
        "pj3cqv",
        "q1lvmf",
        "qh35av",
        "qv39if",
        "rg823v",
        "rsu0bf",
        "sfcnrv",
        "stpuev",
        "td1rbf",
        "tqsmqv",
        "ua783f",
        "uq1civ",
        "v870jf",
        "vnp7uv",
        "1076djf",
        "10l192v",
        "11kgjrf",
        "122os7v",
        "12httnf",
        "130oknv",
        "13eoovf",
        "13uod7v",
        "14eftbf",
        "14so5nv",
        "15bt77f",
        "15qnu7v",
        "168o2ff",
        "16pa5bv",
        "178f6rf",
        "17n9trv",
        "185sgnf",
        "196oibf",
        "19j9erv",
        "1a4oarf",
        "1ah97bv",
        "1b2o3bf",
        "1bf8vrv",
        "1c1aaff",
        "1cd8obv",
        "1cva2vf",
        "1db8grv",
        "1dt9rff",
        "1e9qnvv",
        "1er9jvf",
        "1f7qgfv",
        "1fp9cff",
        "1g5q8vv",
        "1gnrjjf",
        "1h3q1fv",
        "1hlrc3f",
        "1i1ppvv",
        "1ijr4jf",
        "1j0c13v",
        "1jhqt3f",
        "1jubpjv",
        "1kfqljf",
        "1ksbi3v",
        "1ldqe3f",
        "1lqbajv",
        "1mccl7f",
        "1mob33v",
        "1nacdnf",
        "1nmarjv",
        "1o8c67f",
        "1okt2nv",
        "1p6bunf",
        "1pisr7v",
        "1q4bn7f",
        "1qgsjnv",
        "1r2tubf",
        "1resc7v",
        "1s0tmrf",
        "1scs4nv",
        "1sutfbf",
        "1tart7v",
        "1tst7rf",
        "1u9e4bv",
        "1uqt0bf",
        "1v7dsrv",
        "1vosorf",
        "-ngca61",
        "-1caqq9t",
        "-155op9h",
        "aiea9v",
        "b1gndf",
        "bggn5v",
        "-1r820qt",
        "-h5e7qp",
        "14vapf",
        "uauhdf",
        "upua4v",
        "144381f",
        "14gmhsv",
        "14u9n9f",
        "15eouov",
        "-17g2hct",
        "-1f0r0jt",
        "f1gc57",
        "-1f286om",
        "vv5p3f",
        "10o7ejv",
        "11m773v",
        "122aq7v",
        "12k6vjv",
        "13i6o3v",
        "13usprv",
        "14g6gjv",
        "14ssibv",
        "15e693v",
        "15qsarv",
        "16cog7v",
        "16os3bv",
        "176s0if",
        "-1f0dsgf",
        "o68m9f",
        "olr15f",
        "p74ntf",
        "pjqplf",
        "q54gdf",
        "qhqi5f",
        "r348tf",
        "rfqalf",
        "s1mg1f",
        "sdq35f",
        "svm8hf",
        "tbprlf",
        "ttm11f",
        "uac2pf",
        "urlphf",
        "v8br9f",
        "vpli1f",
        "106bjpf",
        "10o7p5f",
        "114bc9f",
        "11m7hlf",
        "122b4pf",
        "12k7a5f",
        "130at9f",
        "13i72lf",
        "13ut4df",
        "14g6r5f",
        "14ssstf",
        "15e6jlf",
        "15qsldf",
        "16coqpf",
        "16osdtf",
        "1a4np8v",
        "-1snouiu",
        "-12phcbh",
        "-vva6t1",
        "-qko6l1",
        "-q6t87p",
        "-mrf4gh",
        "b93t87",
        "-197bubh",
        "-1089m41",
        "-100pp5h",
        "-va4ks1",
        "-v2knth",
        "-uc2801",
        "-u4ib1h",
        "-tdvr41",
        "-t6fu5h",
        "-sfte81",
        "-s8dh9h",
        "-rhod01",
        "-ra8g1h",
        "-qjm041",
        "-qc635h",
        "-q6ta01",
        "b93rfv",
        "-1mhjmvt",
        "-6ch6s1",
        "-4fv781",
        "-3tgmoh",
        "24rdbv",
        "2jr63f",
        "32r5rv",
        "3idd7f",
        "41dcvv",
        "6rd2pn",
        "7acrh7",
        "7pcevv",
        "88c7nf",
        "8nc7fv",
        "96uerf",
        "9luejv",
        "a4u7bf",
        "s5q07v",
        "-1audib1",
        "-155olp1",
        "aiedqf",
        "b1gqtv",
        "bggqmf",
        "bvj7pv",
        "cej7if",
        "ctlklv",
        "dco8qf",
        "droc3f",
        "epo4jf",
        "fnnt3f",
        "glnljf",
        "hjne3f",
        "ihn6jf",
        "jg9dnf",
        "kngjnv",
        "lc8unf",
        "ma8n7f",
        "n88fnf",
        "o6887f",
        "p749rf",
        "q542bf",
        "r33qrf",
        "rfpsjf",
        "s1m1vf",
        "sdpl3f",
        "svlqff",
        "tbpdjf",
        "ttlivf",
        "uabknf",
        "urlbff",
        "v8bd7f",
        "vpl3vf",
        "106b5nf",
        "10o7b3f",
        "114au7f",
        "11m73jf",
        "122amnf",
        "12k6s3f",
        "130af7f",
        "13i6kjf",
        "13usmbf",
        "14g6d3f",
        "14sserf",
        "15e65jf",
        "15qs7bf",
        "1a4nb6v",
        "1bhn6vv",
        "-1f0r8jh",
        "-12uiajh",
        "-q7fok1",
        "-v662s1",
        "-uujjsh",
        "-q0q681",
        "-nldmkh",
        "-ep7ho1",
        "-eikn8h",
        "7nahjv",
        "86cunf",
        "-1d8hoa9",
        "-1aufnq1",
        "-1f29pmt",
        "lvsjfv",
        "1bp7j5v",
        "-1f4pfqb",
        "-1aucr15",
        "lc9nav",
        "ma9fqv",
        "n898av",
        "-1q00sg1",
        "-12ui881",
        "-q8cmvp",
        "gtkt3v",
        "-1q2g3j5",
        "-1mhjq89",
        "-ualh4h",
        "-mt17kh",
        "1ass0jf",
        "-1aucub1",
        "-1f0r359",
        "-q0q0v9",
        "-n6b60h",
        "-1sguci9",
        "-msuj8h",
        "q545rv",
        "r33ubv",
        "s1m5fv",
        "svltvv",
        "ttlmfv",
        "urlevv",
        "vpl7fv",
        "1a4nenf",
        "1bfdcfv",
        "-1aucuma",
        "jv9v2f",
        "-1q2g3s9",
        "-mrpm0h",
        "-er1lgh",
        "-dp8i09",
        "-deppsp",
        "-cprv49",
        "-cetcop",
        "-bt13s9",
        "-bhg2sp",
        "-av1bc9",
        "-ajgacp",
        "-a11is9",
        "-9lghsp",
        "-931qc9",
        "-8ngpcp",
        "-7sl3k9",
        "ga6o4f",
        "gmspsf",
        "h86gkf",
        "hksicf",
        "-44bcjp",
        "-1audj0t",
        "-ualdk1",
        "-mqn9k1",
        "-m79141",
        "-lrqkgh",
        "-lblng1",
        "-kr6g0h",
        "-kc6g81",
        "-jvj6ch",
        "-je43c1",
        "-j1gpgh",
        "-i3eckh",
        "-hhv9k1",
        "-h5bvoh",
        "-gor381",
        "-g4l6sh",
        "-fo6uo1",
        "-f6iq0h",
        "-eq4hs1",
        "-e8gd4h",
        "-ds2501",
        "-dcvnsh",
        "-ctt3o1",
        "-ceqmkh",
        "-bvqms1",
        "-bgo9oh",
        "-b1oa01",
        "-ailssh",
        "-a3lt41",
        "-9kjg0h",
        "-90g101",
        "-8meeoh",
        "-82dk41",
        "-7oc1sh",
        "3volfv",
        "4er2jf",
        "4tr2bv",
        "5ctfff",
        "8tn8bv",
        "959nbf",
        "-1aucv7o",
        "-1aucpg0",
        "10drhtf",
        "-1ip70hp",
        "-mi9r9p",
        "7bn8i7",
        "7n8b9v",
        "88sg1f",
        "8eqehv",
        "8lapu7",
        "94ailn",
        "9jfr67",
        "a2q5dn",
        "k20tm7",
        "kdn7dn",
        "ksn767",
        "lbs8ln",
        "lqpk27",
        "m9ulhn",
        "mos0u7",
        "n812dn",
        "nmudq7",
        "o63f9n",
        "ol0qm7",
        "p45s5n",
        "pj5ru7",
        "q2atdn",
        "qh88q7",
        "r0da9n",
        "rfalm7",
        "rufn5n",
        "sdd2i7",
        "ssi41n",
        "tbi3q7",
        "tqn59n",
        "u9kgm7",
        "uopi5n",
        "v7mti7",
        "vmrv1n",
        "105pae7",
        "10kubtn",
        "113ubm7",
        "11j3d5n",
        "13u5ia7",
        "14dajpn",
        "14saji7",
        "15bfl1n",
        "15qd0e7",
        "169i1tn",
        "16ofda7",
        "177kepn",
        "17mhq67",
        "185mrln",
        "18kmre7",
        "193rstn",
        "19ip8a7",
        "1a1u9pn",
        "1agrl67",
        "1b00mln",
        "1beu227",
        "1bu33hn",
        "1cd33a7",
        "1cs84pn",
        "1db5g67",
        "1dqahln",
        "1e97t27",
        "1eocuhn",
        "1f7a9u7",
        "1fmfbdn",
        "1g5fb67",
        "1gkkcln",
        "1h3ho27",
        "1himphn",
        "1i1k4u7",
        "1igp6dn",
        "1ivmhq7",
        "1jerj9n",
        "1jtrj27",
        "1kd0khn",
        "1krtvu7",
        "1lb31dn",
        "1lq0cq7",
        "1m95e9n",
        "1mo2pm7",
        "1n77r5n",
        "1nm56i7",
        "1o5a81n",
        "1oka7q7",
        "1p3f99n",
        "1pickm7",
        "1q1hm5n",
        "1qgf1i7",
        "1qvk31n",
        "1rehee7",
        "1rtmftn",
        "1scmfm7",
        "1srrh5n",
        "1taosi7",
        "1tptu1n",
        "1u8r9e7",
        "1uo0atn",
        "1v6tma7",
        "1vm2npn",
        "-l1jqkd",
        "gm2jd7",
        "-kc3obh",
        "-k17qc1",
        "-jgdqbh",
        "-j381s1",
        "-ifhonh",
        "-i589c1",
        "-hhi07h",
        "-h78gs1",
        "-1f1lc98",
        "uctqdf",
        "1bkju5v",
        "-1sio4dl",
        "eaobrv",
        "f8o4bv",
        "g6nsrv",
        "h4nlbv",
        "i2ndrv",
        "j0n6bv",
        "p4qfbf",
        "q2q7rf",
        "r0q0bf",
        "tejcsv",
        "tr9b4f",
        "ua9asv",
        "up93kf",
        "v893cv",
        "vn8s4f",
        "1068rsv",
        "10l8kkf",
        "1148kcv",
        "11j8d4f",
        "1228csv",
        "12hqk8f",
        "-1f288i7",
        "176rt1v",
        "-1cade54",
        "-155oi8h",
        "aiehav",
        "b1guef",
        "bggu6v",
        "bvjbaf",
        "cejb2v",
        "ctlo6f",
        "dcocav",
        "ke9d8f",
        "kngn8f",
        "p74dbv",
        "-1f285d3",
        "-1ia1tmq",
        "-1feqjg2",
        "114bjaf",
        "122bbqf",
        "130b4af",
        "13utbef",
        "14st3uf",
        "15qssef",
        "16oskuf",
        "1a4o09v",
        "-1aucpdp",
        "mp9fjf",
        "10o83mv",
        "11m7s6v",
        "12k7kmv",
        "13i7d6v",
        "14g75mv",
        "15e6u6v",
        "16cp5av",
        "17aotqv",
        "-1mhill9",
        "-1ib8tjh",
        "-1i02731",
        "-1hm5tjh",
        "-1h3co3h",
        "-1go0sbh",
        "-1g5ab7h",
        "-1fq13rh",
        "-1f77ubh",
        "-1ers2jh",
        "-1e92t3h",
        "-1dtplnh",
        "-1db0g7h",
        "-1avjt3h",
        "-1agml7h",
        "-193cevh",
        "-18lhfvh",
        "-185v53h",
        "-17nhnfh",
        "-177ctvh",
        "-16ovgbh",
        "-168qmrh",
        "-15qvnrh",
        "-14cr5rh",
        "-13v06rh",
        "-13g0ajh",
        "-1310ebh",
        "-11jeavh",
        "-114eenh",
        "-10m113h",
        "-106em7h",
        "-vm9snh",
        "-v8etnh",
        "-upf1fh",
        "-uaf57h",
        "-ts1njh",
        "-tcfcnh",
        "-ssaj7h",
        "-saedrh",
        "-s2c13h",
        "-rftd3h",
        "-r0tgrh",
        "-qhr07h",
        "-q4l47h",
        "-q16g01",
        "-pnv601",
        "-pi6g7h",
        "-p6lbnh",
        "-p3p641",
        "-ooqg81",
        "-ojk93h",
        "-o8lj7h",
        "-o56v01",
        "-nqqno1",
        "-nlkgjh",
        "-nalqnh",
        "-n776g1",
        "-msqv81",
        "-mnko3h",
        "-mac7nh",
        "-lrcbfh",
        "-lcc4m1",
        "-ktc8e1",
        "-kecc61",
        "-jvcfu1",
        "-jgcjm1",
        "-j1cne1",
        "-h4qnq1",
        "-glqri1",
        "-g6qva1",
        "-fnr321",
        "-f8r6q1",
        "-eprai1",
        "-earea1",
        "-drri21",
        "-dcrlq1",
        "-ctrpi1",
        "-ce9em1",
        "-bv9ie1",
        "-bg9m61",
        "-b19pu1",
        "-ai9tm1",
        "-a3a1e1",
        "-9ka561",
        "-95a8u1",
        "-8macm1",
        "-87age1",
        "-7oak61",
        "-79anu1",
        "-6pod21",
        "-6aogq1",
        "-5roki1",
        "-5cooa1",
        "-4tos21",
        "-4eovq1",
        "-3vp3i1",
        "-3gp7a1",
        "6pma8f",
        "78m6gf",
        "7o8hcf",
        "878dkf",
        "8m89sf",
        "9589kv",
        "9k82cf",
        "a3824v",
        "b17qkv",
        "bg7msv",
        "bv7j4v",
        "ce7itf",
        "ct7bkv",
        "dc77sv",
        "drpiov",
        "eapf0v",
        "eppb8v",
        "f8p7gv",
        "fnp3ov",
        "g6p00v",
        "glos8v",
        "h4oogv",
        "hjokov",
        "i2oh0v",
        "ihod8v",
        "j0o9gv",
        "jgakcv",
        "jvagkv",
        "keacsv",
        "kta94v",
        "lca5cv",
        "-15jpogr",
        "-1cvn8oh",
        "-lrs271",
        "-1r81bjl",
        "-pmkov1",
        "-mon0vh",
        "5hftpv",
        "-1q94mt9",
        "-1mhiod9",
        "-1ib9141",
        "-1i02ajh",
        "-1hm6141",
        "-1h3crk1",
        "-1go0vs1",
        "-1g5aeo1",
        "-1fq17c1",
        "-1f781s1",
        "-1ers641",
        "-1e930k1",
        "-1dtpp81",
        "-1db0jo1",
        "-1avk0k1",
        "-1agmoo1",
        "-193cig1",
        "-18lhjg1",
        "-185v8k1",
        "-17nhr01",
        "-177d1g1",
        "-16ovjs1",
        "-168qqc1",
        "-15qvrc1",
        "-14cr9c1",
        "-13v0ac1",
        "-13g0e41",
        "-1310hs1",
        "-11jeeg1",
        "-114ei81",
        "-10m14k1",
        "-106epo1",
        "-vma081",
        "-v8f181",
        "-upf501",
        "-uaf8o1",
        "-ts1r41",
        "-tcfg81",
        "-ssamo1",
        "-rftgk1",
        "-r0tkc1",
        "-qhr3o1",
        "-q4l7o1",
        "-q16jgh",
        "-pnv9gh",
        "-pi6jo1",
        "-p6lf81",
        "-p3p9kh",
        "-ooqjoh",
        "-ojkck1",
        "-o8lmo1",
        "-o572gh",
        "-nqqr8h",
        "-nlkk41",
        "-nalu81",
        "-n77a0h",
        "-msr2oh",
        "-mnkrk1",
        "-macb81",
        "-lrcf01",
        "-lcc86h",
        "-ktcbuh",
        "-kecfmh",
        "-jvcjeh",
        "-jgcn6h",
        "-j1cquh",
        "-h4qrah",
        "-glqv2h",
        "-g6r2qh",
        "-fnr6ih",
        "-f8raah",
        "-epre2h",
        "-earhqh",
        "-drrlih",
        "-dcrpah",
        "-ctrt2h",
        "-ce9i6h",
        "-bv9luh",
        "-bg9pmh",
        "-b19teh",
        "-aia16h",
        "-a3a4uh",
        "-9ka8mh",
        "-95aceh",
        "-8mag6h",
        "-87ajuh",
        "-7oanmh",
        "-79areh",
        "-6pogih",
        "-6aokah",
        "-5roo2h",
        "-5corqh",
        "-4tovih",
        "-3vp72h",
        "6pm6nv",
        "78m2vv",
        "7o8drv",
        "8m86bv",
        "95864f",
        "9k7urv",
        "ce7fcv",
        "-1q9uv31",
        "-1hmtog1",
        "-1h2strh",
        "-1gorbk1",
        "-1g2lv7h",
        "-1fqouo1",
        "-1f4jibh",
        "-1ds7m41",
        "-1dkd2vh",
        "-sr5pg1",
        "-sc5m71",
        "-s2bq2h",
        "-rdjf31",
        "-r3pmf1",
        "-qfjmj1",
        "-q57fb1",
        "-pi6cn1",
        "-p77mr1",
        "-ok6k71",
        "-o97ub1",
        "-nm6rn1",
        "-nb85r1",
        "-mnkkj1",
        "-md8db1",
        "-lpks31",
        "-lccbn1",
        "-krl3j1",
        "-kecj71",
        "-jtlb31",
        "-jgcqn1",
        "-iv33v1",
        "-iid271",
        "-i1lq31",
        "-h33iv1",
        "-glr2j1",
        "-g53qf1",
        "-fnra31",
        "-f741v1",
        "-eprhj1",
        "-e949f1",
        "-drrp31",
        "-db4gv1",
        "-cts0j1",
        "-cci9r1",
        "-bv9pf1",
        "-beihb1",
        "-b1a0v1",
        "-agior1",
        "-a3a8f1",
        "-9ij0b1",
        "-95afv1",
        "-8kj7r1",
        "-87anf1",
        "-7mjfb1",
        "-79auv1",
        "-6o1871",
        "-6aonr1",
        "-5q1fn1",
        "-5covb1",
        "-4s1n71",
        "-4ep6r1",
        "-3u1un1",
        "-3gpeb1",
        "-302671",
        "-2iplr1",
        "-21fv31",
        "-1k7en1",
        "-1mbn865",
        "-ub19a1",
        "-tsjv6h",
        "-td1gq1",
        "-suk6mh",
        "-sef9m1",
        "-s01vih",
        "-rgfh61",
        "-r2272h",
        "-qifom1",
        "-q42eih",
        "-pkg061",
        "-pcivmh",
        "ch3vhv",
        "ct7f5f",
        "df3h0v",
        "dqkp1f",
        "ed39gv",
        "eokhhf",
        "fagmtf",
        "fmkdhv",
        "g8gfdf",
        "gkk61v",
        "h6g7tf",
        "hijuhv",
        "i4g0df",
        "igjn1v",
        "j327hf",
        "jejfhv",
        "k1201f",
        "kd5mlv",
        "kv1ohf",
        "lb5f5v",
        "lt1h1f",
        "m957lv",
        "mr19hf",
        "n7505v",
        "np121f",
        "o54olv",
        "onj95f",
        "p3mvpv",
        "plj1lf",
        "q1mo9v",
        "qjiq5f",
        "qvmgpv",
        "rhiilf",
        "rtm99v",
        "sfib5f",
        "srm1pv",
        "tdiamf",
        "tp3imv",
        "uc4hqf",
        "un3b6v",
        "va4aaf",
        "vlliav",
        "10842qf",
        "10jlaqv",
        "1163raf",
        "11hl3av",
        "1243jqf",
        "12fkrqv",
        "1323caf",
        "13dkkav",
        "140ljef",
        "14c6rev",
        "14ulbuf",
        "15a6juv",
        "15sl4ef",
        "1686cev",
        "-1hr2mb5",
        "-qamj81",
        "-q3ha4h",
        "-pkhac1",
        "-p5hhkh",
        "-olv381",
        "-o7hp4h",
        "bgp2bv",
        "ccf0bv",
        "f7j73v",
        "iuvqfv",
        "jsvivv",
        "kgj47v",
        "kqvbfv",
        "leisnv",
        "lphijv",
        "md53rv",
        "mnhb3v",
        "nb4sbv",
        "nlh3jv",
        "o94krv",
        "16aelnv",
        "16pehvv",
        "178ee7v",
        "17neafv",
        "1870lbv",
        "18m0hjv",
        "1950drv",
        "19k0a3v",
        "1a306bv",
        "1ai02jv",
        "1b0vurv",
        "1bfvr3v",
        "1buvnbv",
        "1cdvjjv",
        "1csvfrv",
        "1dbvc3v",
        "1drhmvv",
        "1eahj7v",
        "1ephffv",
        "1f8hbnv",
        "1fnh7vv",
        "1g6h47v",
        "1glh0fv",
        "1h4gsnv",
        "1hjgovv",
        "1i2gl7v",
        "1ihghfv",
        "1j12sbv",
        "1jg2ojv",
        "1jv2krv",
        "1ke2h3v",
        "1kt2dbv",
        "1lc29jv",
        "1lr25rv",
        "1ma223v",
        "1mp1ubv",
        "1n81qjv",
        "1nn1mrv",
        "1o6k1nv",
        "1oljtvv",
        "1p4jq7v",
        "1pjjmfv",
        "1q2jinv",
        "1qhjevv",
        "1r0jb7v",
        "1rfj7fv",
        "1ruj3nv",
        "1sdivvv",
        "1ssis7v",
        "1tbiofv",
        "1tr53bv",
        "1ua4vjv",
        "1up4rrv",
        "1v84o3v",
        "1vn4kbv",
        "-1hr2kit",
        "-1hk7m09",
        "-qamhfp",
        "-q3h8c9",
        "-pkh8jp",
        "-p5hfs9",
        "-olv1fp",
        "-o7hnc9",
        "1n0g47",
        "20q8o7",
        "2l08k7",
        "2vcfs7",
        "3j0147",
        "3tc8c7",
        "4gvpk7",
        "4rc0s7",
        "5evi47",
        "5pu807",
        "6dhp87",
        "6nu0g7",
        "7bhho7",
        "7ltp07",
        "89ha87",
        "8jthg7",
        "97h2o7",
        "9hta07",
        "a5gr87",
        "aft2g7",
        "b3gjo7",
        "bef9k7",
        "c22qs7",
        "ccf247",
        "d02jc7",
        "daeqk7",
        "du2bs7",
        "e8ej47",
        "es24c7",
        "f7j8s7",
        "fpfe87",
        "g5j1c7",
        "go1lc7",
        "h458g7",
        "hmjsg7",
        "i25107",
        "ikjl07",
        "j04pg7",
        "jijdg7",
        "jsvko7",
        "kgj607",
        "ksmp47",
        "leiug7",
        "lphkc7",
        "md55k7",
        "moma47",
        "nb4u47",
        "nn8h87",
        "o94mk7",
        "olqoc7",
        "p74f47",
        "pjqgs7",
        "q547k7",
        "qhq9c7",
        "r34047",
        "rfq1s7",
        "s1m787",
        "sdpqc7",
        "svlvo7",
        "tbpis7",
        "ttlo87",
        "uabq07",
        "urlgo7",
        "v8big7",
        "vpl987",
        "106bb07",
        "10o7gc7",
        "114b3g7",
        "11m78s7",
        "122tak7",
        "12k71c7",
        "130akg7",
        "13i6ps7",
        "13vfa87",
        "14ef6g7",
        "14tf2o7",
        "15cev07",
        "15rer87",
        "16aeng7",
        "16pejo7",
        "178eg07",
        "17nec87",
        "1870n47",
        "18m0jc7",
        "1950fk7",
        "19k0bs7",
        "1a30847",
        "1ai04c7",
        "1b100k7",
        "1bfvss7",
        "1buvp47",
        "1cdvlc7",
        "1csvhk7",
        "1dbvds7",
        "1drhoo7",
        "1eahl07",
        "1ephh87",
        "1f8hdg7",
        "1fnh9o7",
        "1g6h607",
        "1glh287",
        "1h4gug7",
        "1hjgqo7",
        "1i2gn07",
        "1ihgj87",
        "1j12u47",
        "1jg2qc7",
        "1jv2mk7",
        "1ke2is7",
        "1kt2f47",
        "1lc2bc7",
        "1lr27k7",
        "1ma23s7",
        "1mp2047",
        "1n81sc7",
        "1nn1ok7",
        "1o6k3g7",
        "1oljvo7",
        "1p4js07",
        "1pjjo87",
        "1q2jkg7",
        "1qhjgo7",
        "1r0jd07",
        "1rfj987",
        "1ruj5g7",
        "1sdj1o7",
        "1ssiu07",
        "1tbiq87",
        "1tr5547",
        "1ua51c7",
        "1up4tk7",
        "1v84ps7",
        "1vn4m47",
        "bgp447",
        "iuvs87",
        "kqvd87",
        "mnhcs7",
        "nlh5c7",
        "-1hr2huh",
        "-1hk7jbt",
        "-qamerd",
        "-q3h5nt",
        "-pkh5vd",
        "-p5hd7t",
        "4gvs8j",
        "4rc3gj",
        "d02m0j",
        "daet8j",
        "kiakgj",
        "kqvfsj",
        "12n3d4j",
        "130an4j",
        "13i6sgj",
        "13usu8j",
        "14g6l0j",
        "14ssmoj",
        "b3gg7n",
        "bef2j7",
        "c22nbn",
        "ccer37",
        "d02frn",
        "daejj7",
        "du28bn",
        "e8ec37",
        "es20rn",
        "f7j3jf",
        "fpfann",
        "g5is3f",
        "go1hrn",
        "h4537f",
        "hmjovn",
        "i24rnf",
        "ikjhfn",
        "iuvmvf",
        "jij9vn",
        "jsvfff",
        "kgj2fn",
        "kqv7vf",
        "leiqvn",
        "lphf3f",
        "md523n",
        "mnh7jf",
        "nb4qjn",
        "nlh03f",
        "o94j3n",
        "p74bjn",
        "q5443n",
        "r33sjn",
        "s1m3nn",
        "sqfojn",
        "ttlknn",
        "urld7n",
        "vpl5nn",
        "10o7crn",
        "11m75bn",
        "122t5bf",
        "12k6trn",
        "13i6mbn",
        "13vf4vf",
        "14ef2vn",
        "14tetff",
        "15cerfn",
        "15relvf",
        "16aejvn",
        "16peeff",
        "178ecfn",
        "17ne6vf",
        "1870jjn",
        "18m0e3f",
        "1950c3n",
        "19k06jf",
        "1a304jn",
        "1ahvv3f",
        "1b0vt3n",
        "1bfvnjf",
        "1buvljn",
        "1cdvg3f",
        "1csve3n",
        "1dbv8jf",
        "1drhl7n",
        "1eahfnf",
        "1ephdnn",
        "1f8h87f",
        "1fnh67n",
        "1g6h0nf",
        "1glgunn",
        "1h4gp7f",
        "1hjgn7n",
        "1i2ghnf",
        "1ihgfnn",
        "1j12orf",
        "1jg2mrn",
        "1jv2hbf",
        "1ke2fbn",
        "1kt29rf",
        "1lc27rn",
        "1lr22bf",
        "1ma20bn",
        "1mp1qrf",
        "1n81orn",
        "1nn1jbf",
        "1o6jvvn",
        "1oljqff",
        "1p4jofn",
        "1pjjivf",
        "1q2jgvn",
        "1qhjbff",
        "1r0j9fn",
        "1rfj3vf",
        "1ruj1vn",
        "1sdisff",
        "1ssiqfn",
        "1tbikvf",
        "1tr51jn",
        "1ua4s3f",
        "1up4q3n",
        "1v84kjf",
        "1vn4ijn",
        "bef7rv",
        "gnf4vv",
        "-1hr2fa5",
        "-1hk7gnh",
        "-qamc71",
        "-q3h33h",
        "-pkh3b1",
        "-p5hajh",
        "4gvusv",
        "4rc64v",
        "d02okv",
        "daevsv",
        "kian4v",
        "kqvigv",
        "12n3fov",
        "-1i2k98h",
        "-1hickbh",
        "-1h5mijh",
        "-1gkcrrh",
        "-1g7mq3h",
        "-rvd3jh",
        "-mr3frh",
        "6q8osf",
        "-133hfrp",
        "-1idij3g",
        "-1i2jt7g",
        "-1hj1jr1",
        "-1h5mf31",
        "-1gm6oj1",
        "-1g6hpb1",
        "-1fnkhf1",
        "-1f8i0r1",
        "-1epkov1",
        "-1e88dr1",
        "-1dr2hr1",
        "-1dc0171",
        "-1ctl7v1",
        "-1cdgef1",
        "-1btbkv1",
        "-1bh81r1",
        "-1avub31",
        "-1ailqn1",
        "-1a1c3v1",
        "-19jh4v1",
        "-193cbf1",
        "-18lhcf1",
        "-185v1j1",
        "-17nhjv1",
        "-176qbr1",
        "-16ovcr1",
        "-168qjb1",
        "-15qvkb1",
        "-15bd9f1",
        "-14svrr1",
        "-14cr2b1",
        "-13v03b1",
        "-13er9r1",
        "-1310ar1",
        "-12hdvv1",
        "-122e3n1",
        "-11i9a71",
        "-114eb71",
        "-10ks0b1",
        "-106ein1",
        "-vm9p71",
        "-v8eq71",
        "-uoa0n1",
        "-uaf1n1",
        "-tqsmr1",
        "-tcf971",
        "-ssafn1",
        "-saeab1",
        "-le3nj1",
        "-kr2ofh",
        "-kd7lv1",
        "-jt2sf1",
        "-hj8cf1",
        "-h3m1j1",
        "-gkm5b1",
        "-fmmcr1",
        "-f8rdr1",
        "-ep92v1",
        "-earlb1",
        "-dqmrr1",
        "-dcrsr1",
        "-cs4kn1",
        "-ce9ln1",
        "-bunar1",
        "-bg9t71",
        "-b053n1",
        "-aia4n1",
        "-a25b71",
        "-9kac71",
        "-94o1b1",
        "-8majn1",
        "-87t631",
        "-7m10n1",
        "-79tdj1",
        "-6bb6f1",
        "-5dtsj1",
        "-4fu431",
        "-3hubj1",
        "-2juj31",
        "-1o8l31",
        "1n1hgv",
        "22im0v",
        "2l1a0v",
        "30iegv",
        "3j12gv",
        "3ui70v",
        "4h0r0v",
        "4shvgv",
        "5f0jgv",
        "5r46kv",
        "6d0c0v",
        "6p3v4v",
        "7b04gv",
        "7n3nkv",
        "89ibkv",
        "8l3g4v",
        "97i44v",
        "9j38kv",
        "a5hskv",
        "b3hhkf",
        "c1ha4f",
        "cvh2kf",
        "du39of",
        "es328f",
        "fq2qof",
        "go2j8f",
        "hm2bof",
        "ikkisf",
        "jikbcf",
        "kgk3sf",
        "lejscf",
        "mcjksf",
        "najdcf",
        "o8j5sf",
        "-1if7k8l",
        "-1i2kad5",
        "-1hichvl",
        "-1h5mg7l",
        "-1glhmnl",
        "-1g6hqfl",
        "-1fmvfjl",
        "-1f8i1vl",
        "-1eovn3l",
        "-1eai9fl",
        "-1dqvujl",
        "-1dcigvl",
        "-1ctl93l",
        "-1cdgfjl",
        "-1bq273l",
        "-1bfgn3l",
        "-1b139fl",
        "-1ahgujl",
        "-19tg7fl",
        "-19jh63l",
        "-19156fl",
        "-18lhdjl",
        "-1832pjl",
        "-17nhl3l",
        "-174tobl",
        "-16ovdvl",
        "-166rbfl",
        "-15qvlfl",
        "-158oujl",
        "-14svsvl",
        "-14amhnl",
        "-13v04fl",
        "-13bv1rl",
        "-1310bvl",
        "-12ef3jl",
        "-122e4rl",
        "-11gcmnl",
        "-114ecbl",
        "-10ia9rl",
        "-106ejrl",
        "-vk58jl",
        "-v8erbl",
        "-ulgd3l",
        "-ui78l5",
        "-uaf2sh",
        "-to0esh",
        "-tcfach",
        "-spu20h",
        "-sdt38h",
        "-rrmjdh",
        "-lrs981",
        "-1aufekd",
        "-155nt5h",
        "130bbbf",
        "13i7gnf",
        "13utiff",
        "14g797f",
        "14stavf",
        "15e71nf",
        "15qt3ff",
        "16cp8rf",
        "16osrvf",
        "1a4o7av",
        "1bfe53f",
        "-1i7vnk1",
        "-13865h1",
        "-133ik1h",
        "-r0r711",
        "-quulth",
        "-p5bcoh",
        "-olrpp1",
        "-o6p5kh",
        "-geood1",
        "-g4htdh",
        "4uoniv",
        "5hht2v",
        "5srbfv",
        "6br7nv",
        "6q8lbv",
        "78onbv",
        "86lv0f",
        "8m8uvf",
        "955anf",
        "9kd0iv",
        "-1idikj1",
        "-1i2jun1",
        "-qujmbh",
        "-qmh9jh",
        "-q2tobh",
        "-pohh3h",
        "-p4tvrh",
        "-opv9vh",
        "-o6u7bh",
        "-np38bh",
        "-n09jfh",
        "-mpc0f1",
        "-m9plj1",
        "-lrc7v1",
        "-lbq0jh",
        "-l207vh",
        "-kr2kv1",
        "-kg3v31",
        "-qvrih1",
        "-n5ssvh",
        "-n4iqg1",
        "-mqegc1",
        "-mltc7h",
        "-m9pp3h",
        "-lr9n3h",
        "-l9g63h",
        "-l5f381",
        "-ktcivh",
        "-kd7pfh",
        "-jvcqfh",
        "-jfqfjh",
        "-j1d1vh",
        "-n8c07h",
        "-m7vorh",
        "-lb7hvh",
        "-jft3vh",
        "-1jrndk1",
        "-1if7mkh",
        "-1g321uh",
        "-1f82h4h",
        "-1da3n4h",
        "-1ctligh",
        "-1cdgp0h",
        "-1btbvgh",
        "-1b13ish",
        "-1a2hboh",
        "-19jhfgh",
        "-13g0731",
        "-12iit71",
        "-11je7f1",
        "-10m0tj1",
        "-upetv1",
        "-ts1k31",
        "-rrbpn1",
        "-m6tfvh",
        "-144ubfp",
        "-13c2351",
        "-1310ot1",
        "-12i0sl1",
        "-12310d1",
        "-11jelh1",
        "-114ep91",
        "-10let11",
        "-106f0p1",
        "-vnf4h1",
        "-v8f891",
        "-upfc11",
        "-uaffp1",
        "-trfjh1",
        "-tcfn91",
        "-stfr11",
        "-sefup1",
        "8qrkav",
        "9kq2uf",
        "a37k2v",
        "b17jjv",
        "bv7c3v",
        "ce78bv",
        "ct74jv",
        "dc70rv",
        "drpbnv",
        "eap7vv",
        "epp47v",
        "f8p0fv",
        "fnosnv",
        "g6oovv",
        "glol7v",
        "h4ohfv",
        "hjodnv",
        "i2o9vv",
        "iho67v",
        "j0o2fv",
        "jgadbv",
        "-1glhlj1",
        "-1fmabf1",
        "-1f3ufbh",
        "-r0of4h",
        "-n6d1p1",
        "-mnah51",
        "-maumbh",
        "-lccf7h",
        "-kecmnh",
        "-ih5k3h",
        "-i1j97h",
        "-elqloh",
        "-eas3d1",
        "-dno8sh",
        "-dcpmh1",
        "-com7gh",
        "-cesid1",
        "-bqmbg1",
        "-bgsfbh",
        "-quh5g1",
        "-q0hd01",
        "-pjrb81",
        "-1gp8o7l",
        "-rk6r51",
        "-qoh0lh",
        "-nr2rt1",
        "aif9uf",
        "b1hn1v",
        "bghmqf",
        "cek3mf",
        "drp87f",
        "eap4ff",
        "epp0nf",
        "j46j6v",
        "jva9jv",
        "kea5rv",
        "1bfe8jv",
        "1c1advv",
        "1cde13v",
        "1cva6fv",
        "1dbdpjv",
        "1dt9uvv",
        "1ea00nv",
        "1er9nfv",
        "1f7vp7v",
        "1fp9fvv",
        "1g5vhnv",
        "1gnrn3v",
        "1h3va7v",
        "1hlrfjv",
        "1i1v2nv",
        "1ijr83v",
        "1j0h9rv",
        "1jhr0jv",
        "1juh2bv",
        "1kfqp3v",
        "1ksgqrv",
        "1ldqhjv",
        "1lqgjbv",
        "1mcconv",
        "1mogbrv",
        "1nach7v",
        "1nmg4bv",
        "1o8c9nv",
        "1ol2bfv",
        "1p6c27v",
        "1pj23vv",
        "1q4bqnv",
        "1qh1sfv",
        "1r2u1rv",
        "1rf1kvv",
        "1s0tqbv",
        "1sd1dfv",
        "1sutirv",
        "1tb15vv",
        "1tstbbv",
        "1u9jd3v",
        "1uqt3rv",
        "1v7j5jv",
        "1vossbv",
        "-1ie2st1",
        "-rrpa4h",
        "-mtnrrh",
        "-m8cunh",
        "-lu8kjh",
        "-la2knh",
        "-kbgdjh",
        "-k40ffh",
        "-1dop476",
        "-q33bl1",
        "-pju6l1",
        "-ngbvkh",
        "-n6kut1",
        "-mi9m91",
        "kta23v",
        "lc9ubv",
        "lr9qjv",
        "ma9mrv",
        "mp9j3v",
        "n89fbv",
        "nn9bjv",
        "o697rv",
        "olrinv",
        "p759fv",
        "-1aucm4t",
        "-155npl1",
        "-qj5k9h",
        "-oj4lsh",
        "j8q86v",
        "-1ffvhk1",
        "-1mhiq74",
        "-1ib94kh",
        "-1i02e41",
        "-1hm64kh",
        "-1h3cv4h",
        "-1go13ch",
        "-1g5ai8h",
        "-1fq1ash",
        "-1f785ch",
        "-1ers9kh",
        "-1e9344h",
        "-1dtpsoh",
        "-1db0n8h",
        "-1agms8h",
        "-168qtsh",
        "-15qvush",
        "-14crcsh",
        "-13v0dsh",
        "-13g0hkh",
        "-1310lch",
        "-11jei0h",
        "-114eloh",
        "-10m184h",
        "-106et8h",
        "-vma3oh",
        "-v8f4oh",
        "-upf8gh",
        "-uafc8h",
        "-ts1ukh",
        "-tcfjoh",
        "-ssaq8h",
        "-s2c84h",
        "-rftk4h",
        "-r0tnsh",
        "-qhr78h",
        "-q4lb8h",
        "-q16n11",
        "-pnvd11",
        "-pi6n8h",
        "-p6lioh",
        "-p3pd51",
        "-ooqn91",
        "-ojkg4h",
        "-o8lq8h",
        "-o57611",
        "-nqqup1",
        "-nlknkh",
        "-nam1oh",
        "-n77dh1",
        "-msr691",
        "-mnkv4h",
        "-maceoh",
        "-lrcigh",
        "-ktcff1",
        "-jvcmv1",
        "-j1cuf1",
        "-h4qur1",
        "-g6r6b1",
        "-7oar71",
        "-6pok31",
        "-5rorj1",
        "-4tp331",
        "-3vpaj1",
        "6amafv",
        "-1tlqki5",
        "-1hham11",
        "-1h5mpkh",
        "-1g1uesh",
        "-1f826j1",
        "-1e8b5nh",
        "-1da3g3h",
        "-1cdglg1",
        "-1bfgpfh",
        "-1ahh4g1",
        "-1a2ench",
        "-19jhc01",
        "-rrrjv1",
        "-np0jvh",
        "-1hgo3sh",
        "-1h4224h",
        "-1gkaegh",
        "-1fn2dch",
        "-1f7t8ch",
        "-ule24h",
        "-tscg4h",
        "-sdtckh",
        "-s0ks8h",
        "-q0k8d1",
        "-pmiil1",
        "-o5pkl1",
        "-nn49t1",
        "-n7ps51",
        "-mpupkh",
        "-m9q3l1",
        "-lrsg91",
        "-j1ihoh",
        "40rjev",
        "4f94jf",
        "5d8t3f",
        "5rm76v",
        "6am6vf",
        "78lvff",
        "7oar6v",
        "-1ice1sh",
        "-1i2kcp1",
        "-1hjkd0h",
        "-1h4hvt1",
        "-1g5vop1",
        "-1f82kl1",
        "-1eq7i4h",
        "-1eb7pd1",
        "-rp7igh",
        "-mr6b8h",
        "-mc3jjh",
        "-le424h",
        "-ktcq0h",
        "-kh8vrh",
        "-3coigh",
        "-32cep1",
        "-2e6bch",
        "-24cioh",
        "-1g6ish",
        "-16cq8h",
        "-hkboh",
        "-7qj4h",
        "cbcnf",
        "m55bf",
        "19omjf",
        "1k4trf",
        "28atnf",
        "31kcrf",
        "3gk93f",
        "41e5jf",
        "4dkd3f",
        "4ve54f",
        "5c43bv",
        "5tdtkf",
        "6a3rrv",
        "6rdm4f",
        "783kbv",
        "7pdekf",
        "863crv",
        "8nd74f",
        "9435bv",
        "9kamof",
        "a2lcfv",
        "-1aucle9",
        "-qq33ph",
        "-nvbvd1",
        "-1bqfmch",
        "-15bdk0h",
        "-14t06ch",
        "-12ij7oh",
        "-122ee8h",
        "-quh90h",
        "-nnc3gh",
        "5rme7v",
        "-1ia1o9q",
        "-1hc23c8",
        "-1gta488",
        "-1gghhko",
        "-1g7na08",
        "-1fif4oo",
        "-1fc6me1",
        "-1duv4i1",
        "-1ds5jah",
        "-1del5qh",
        "-1dc5v21",
        "-1ce3elh",
        "knhfrv",
        "-1n9vbrm",
        "-rp7m11",
        "-nr07h1",
        "-1gkcu03",
        "-1g7ms83",
        "-1fnfec3",
        "-1fj8v83",
        "-191g3h3",
        "-rl16t1",
        "-qpr6lh",
        "-nmutkh",
        "p4revv",
        "3gmtff",
        "44aenf",
        "4emlvf",
        "52slrf",
        "5cmeff",
        "60sebf",
        "6u9o7f",
        "7srvbf",
        "8qrnrf",
        "957v3f",
        "kg1hnv",
        "1c46jjf",
        "-1aucmv1",
        "-qfmshh",
        "-o61hp1",
        "j8qbnf",
        "ms5hmf",
        "-n8rmv1",
        "8m7rqf",
        "95afuv",
        "a3a8ev",
        "aipref",
        "b17g3f",
        "bgpjuf",
        "-1gqdkhl",
        "-1ffvl4h",
        "-1dop45l",
        "-rkuih1",
        "-qjiq5h",
        "-nomd11",
        "-1klbisp",
        "-rp4u4h",
        "-p4e5jh",
        "42geff",
        "4eufiv",
        "5d0sev",
        "5uijrf",
        "6b8i2v",
        "6t4qvf",
        "798aiv",
        "7r1v3f",
        "87832v",
        "8p1njf",
        "957riv",
        "9n1g3f",
        "a3neav",
        "akhebf",
        "b17civ",
        "bj3lff",
        "bvpjmv",
        "cg153f",
        "-nlso91",
        "-n1k0gh",
        "-1eovpfh",
        "-1ebn93h",
        "-n81enh",
        "9kq9vf",
        "-1hr1o5h",
        "-1f7ldb9",
        "-1egtjoh",
        "-1e9j1t1",
        "-rl6c4h",
        "-qqdl9h",
        "-nsvgh1",
        "-1f0le95",
        "-1j5fl9h",
        "-1fmaig1",
        "-1f9kgo1",
        "-1co50t1",
        "-roi8fh",
        "-nnmhg1",
        "-n6krch",
        "-m9q04h",
        "-bgsis1",
        "-b1smk1",
        "-aisqc1",
        "-9umqg1",
        "-9kaj81",
        "-95an01",
        "-8maqo1",
        "-82n9g1",
        "-7ob281",
        "-74nh01",
        "-66nog1",
        "-5sbh81",
        "-585hc1",
        "-4uboo1",
        "9582jv",
        "a37r3v",
        "-1aucn6h",
        "-qla61h",
        "-ok4ach",
        "-1r82235",
        "oedndf",
        "-ipt7c1",
        "-1rpm6bt",
        "-9d0f39",
        "-1r81uj9",
        "c0br9v",
        "cdmshf",
        "-1n37hk1",
        "-7jp5h",
        "m79f5v",
        "-miaqa5",
        "-1nfk101",
        "-ipruu9",
        "169u9tf",
        "17fr2sv",
        "-prpid1",
        "-mt94oh",
        "1a9tlrv",
        "-1mgkfad",
        "ct5tuf",
        "dc5mlv",
        "dtkpmf",
        "ea5f5v",
        "epntif",
        "f857lv",
        "fnnm2f",
        "g6nepv",
        "glneif",
        "h4n79v",
        "hjn72f",
        "i2mvpv",
        "ihmvif",
        "j0mo9v",
        "jfmo2f",
        "jumgpv",
        "ke8v6f",
        "ko2k9v",
        "leii6f",
        "lm2cpv",
        "95c15v",
        "ngd2pf",
        "17fr6df",
        "-1iuoji1",
        "r3m5uv",
        "rdfuiv",
        "s28d2v",
        "sbfn2v",
        "15h2b6v",
        "15qs3qv",
        "16c5qiv",
        "16n4gev",
        "17a5j2v",
        "17hlh6v",
        "1885biv",
        "18fl9mv",
        "196nimv",
        "19dkumf",
        "1a59pqv",
        "1abkqmv",
        "1b39iav",
        "1b9kj6v",
        "1c1rpev",
        "1c7kbmv",
        "1cvrhuv",
        "1d66iqv",
        "1dtraev",
        "1e46bav",
        "1err2uv",
        "1f263qv",
        "1fpqrev",
        "1g05sav",
        "1god2iv",
        "1gu5kqv",
        "1hmcr2v",
        "1hs5dav",
        "1ikcjiv",
        "1iqnkev",
        "1jicc2v",
        "1joncuv",
        "1kgc4iv",
        "1kmn5ev",
        "1lebt2v",
        "1lkmtuv",
        "1mcu46v",
        "1mimmev",
        "1natsmv",
        "1nh8tiv",
        "1o8tl6v",
        "1of8m2v",
        "1p6tdmv",
        "1pd8eiv",
        "1q4t66v",
        "1qb872v",
        "1r3fdav",
        "1r97viv",
        "1s1f5qv",
        "1s77o2v",
        "1sveuav",
        "1t5pv6v",
        "1ttemqv",
        "1u3pnmv",
        "1urefav",
        "1v1pg6v",
        "1vpe7qv",
        "1vvp8mv",
        "-14lncs1",
        "-1lqvdvt",
        "-1lr1j3l",
        "t46niv",
        "-12flf5p",
        "-12dt3l9",
        "-q7dghp",
        "-mptdm9",
        "-l7535p",
        "95bsfv",
        "ngcv8v",
        "r8mppv",
        "-1lqvctp",
        "-1nfk17p",
        "d2mc1f",
        "-1e1hl7t",
        "-q4mg5p",
        "-nrrbsh",
        "8om167",
        "-hrpil1",
        "879ihn",
        "-hrs1s1",
        "4gvij7",
        "4rbman",
        "1b0vpj7",
        "-1mgkesd",
        "7edeif",
        "7ldetv",
        "8cd72f",
        "8jfrpv",
        "pa0ivf",
        "phgh3f",
        "qk8gg7",
        "8ao6p7",
        "8jvd8n",
        "9hv5on",
        "afuu8n",
        "beh5cn",
        "ccgtsn",
        "dagmcn",
        "e8gesn",
        "f6g7cn",
        "g4fvsn",
        "h3270n",
        "i11vgn",
        "iv1o0n",
        "jt1ggn",
        "-1lqvai9",
        "-r8pfbh",
        "rvmhuf",
        "sd6vef",
        "t0822f",
        "t75e1v",
        "tu7qif",
        "u556hv",
        "1c1rluf",
        "1c7k86f",
        "1cvreef",
        "1d66faf",
        "1dtr6uf",
        "1e467qf",
        "1erqvef",
        "1f260af",
        "1fpqnuf",
        "1g05oqf",
        "1gocv2f",
        "1gu5haf",
        "1hmcnif",
        "1hs59qf",
        "1ikcg2f",
        "1iqnguf",
        "1jic8if",
        "1jon9ef",
        "1kgc12f",
        "1kmn1uf",
        "1lebpif",
        "1lkmqef",
        "1mcu0mf",
        "1mimiuf",
        "1natp6f",
        "1nh8q2f",
        "1o8thmf",
        "1of8iif",
        "1p6ta6f",
        "1pd8b2f",
        "1q4t2mf",
        "1qb83if",
        "1r3f9qf",
        "1r97s2f",
        "1s1f2af",
        "1s77kif",
        "1sveqqf",
        "1t5prmf",
        "1ttejaf",
        "1u3pk6f",
        "1urebqf",
        "1v1pcmf",
        "1vpe4af",
        "1vvp56f"
    ],
    "offsets": [
        -17,
        0,
        -1,
        20,
        147,
        180,
        150,
        165,
        9,
        60,
        120,
        13,
        -63,
        -60,
        130,
        -31,
        -53,
        90,
        -44,
        -45,
        52,
        -660,
        -600,
        -540,
        -480,
        -247,
        -240,
        -193,
        -180,
        -120,
        -257,
        -276,
        -270,
        -231,
        -360,
        -300,
        -155,
        -421,
        -420,
        -239,
        -194,
        -353,
        -330,
        -243,
        -297,
        -219,
        -348,
        -268,
        -210,
        -320,
        -425,
        -337,
        -225,
        -75,
        -333,
        -454,
        -280,
        -357,
        -469,
        -154,
        -207,
        -211,
        -151,
        -150,
        -308,
        -363,
        -314,
        -233,
        -255,
        -444,
        -273,
        -213,
        -309,
        -143,
        -346,
        -241,
        -245,
        -400,
        -426,
        -359,
        -397,
        -402,
        -310,
        -130,
        -418,
        -221,
        -289,
        -272,
        -256,
        -140,
        -419,
        -283,
        -187,
        -88,
        -90,
        -432,
        -349,
        480,
        660,
        420,
        300,
        600,
        360,
        690,
        750,
        720,
        780,
        186,
        307,
        143,
        709,
        840,
        201,
        240,
        228,
        233,
        207,
        177,
        206,
        199,
        402,
        335,
        298,
        459,
        450,
        353,
        390,
        330,
        453,
        540,
        458,
        319,
        145,
        502,
        221,
        275,
        135,
        426,
        456,
        366,
        417,
        116,
        427,
        440,
        562,
        570,
        140,
        270,
        634,
        268,
        350,
        341,
        345,
        542,
        371,
        415,
        441,
        500,
        454,
        603,
        477,
        133,
        348,
        331,
        293,
        205,
        437,
        503,
        510,
        261,
        384,
        267,
        507,
        614,
        277,
        179,
        210,
        358,
        339,
        572,
        527,
        518,
        242,
        225,
        178,
        -115,
        -260,
        -62,
        -95,
        -28,
        -68,
        -232,
        630,
        525,
        585,
        -438,
        -26,
        34,
        -720,
        19,
        79,
        80,
        192,
        94,
        104,
        115,
        99,
        122,
        198,
        -37,
        24,
        110,
        151,
        211,
        271,
        96,
        156,
        200,
        184,
        136,
        193,
        84,
        95,
        289,
        294,
        230,
        735,
        765,
        825,
        -687,
        -690,
        673,
        715,
        639,
        -630,
        -570,
        -640,
        -558,
        -683,
        667,
        -680,
        672,
        665,
        -510,
        -599,
        740
    ]
});};


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
var myGlobal = (typeof global !== "undefined" && {}.toString.call(global) === '[object global]') ? global : window;
(__webpack_require__(1361).default)(myGlobal);
(__webpack_require__(1359).default)(myGlobal);
(__webpack_require__(1364))(myGlobal);
(__webpack_require__(1363))(myGlobal);
(__webpack_require__(1362))(myGlobal);
module.exports = myGlobal.Intl.DateTimeFormat;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js

function ExtensionAPI(chartInstance) {
  zrUtil.each(echartsAPIList, function (name) {
    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
  }, this);
}

var _default = ExtensionAPI;
module.exports = _default;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var barLayoutGrid = __webpack_require__(283);

__webpack_require__(281);

__webpack_require__(1368);

__webpack_require__(1369);

__webpack_require__(144);

// In case developer forget to include grid component
echarts.registerLayout(zrUtil.curry(barLayoutGrid, 'bar')); // Visual coding for legend

echarts.registerVisual(function (ecModel) {
  ecModel.eachSeriesByType('bar', function (seriesModel) {
    var data = seriesModel.getData();
    data.setVisual('legendSymbol', 'roundRect');
  });
});

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var BaseBarSeries = __webpack_require__(442);

var _default = BaseBarSeries.extend({
  type: 'series.bar',
  dependencies: ['grid', 'polar'],
  brushSelector: 'rect'
});

module.exports = _default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var _helper = __webpack_require__(443);

var setLabel = _helper.setLabel;

var Model = __webpack_require__(29);

var barItemStyle = __webpack_require__(1372);

var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'normal', 'barBorderWidth']; // FIXME
// Just for compatible with ec2.

zrUtil.extend(Model.prototype, barItemStyle);

var _default = echarts.extendChartView({
  type: 'bar',
  render: function (seriesModel, ecModel, api) {
    var coordinateSystemType = seriesModel.get('coordinateSystem');

    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
      this._render(seriesModel, ecModel, api);
    } else {}

    return this.group;
  },
  dispose: zrUtil.noop,
  _render: function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coord = seriesModel.coordinateSystem;
    var baseAxis = coord.getBaseAxis();
    var isHorizontalOrRadial;

    if (coord.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
    } else if (coord.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
    }

    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = data.getItemModel(dataIndex);
      var layout = getLayout[coord.type](data, dataIndex, itemModel);
      var el = elementCreator[coord.type](data, dataIndex, itemModel, layout, isHorizontalOrRadial, animationModel);
      data.setItemGraphicEl(dataIndex, el);
      group.add(el);
      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).update(function (newIndex, oldIndex) {
      var el = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(el);
        return;
      }

      var itemModel = data.getItemModel(newIndex);
      var layout = getLayout[coord.type](data, newIndex, itemModel);

      if (el) {
        graphic.updateProps(el, {
          shape: layout
        }, animationModel, newIndex);
      } else {
        el = elementCreator[coord.type](data, newIndex, itemModel, layout, isHorizontalOrRadial, animationModel, true);
      }

      data.setItemGraphicEl(newIndex, el); // Add back

      group.add(el);
      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).remove(function (dataIndex) {
      var el = oldData.getItemGraphicEl(dataIndex);

      if (coord.type === 'cartesian2d') {
        el && removeRect(dataIndex, animationModel, el);
      } else {
        el && removeSector(dataIndex, animationModel, el);
      }
    }).execute();
    this._data = data;
  },
  remove: function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (el) {
          if (el.type === 'sector') {
            removeSector(el.dataIndex, ecModel, el);
          } else {
            removeRect(el.dataIndex, ecModel, el);
          }
        });
      }
    } else {
      group.removeAll();
    }
  }
});

var elementCreator = {
  cartesian2d: function (data, dataIndex, itemModel, layout, isHorizontal, animationModel, isUpdate) {
    var rect = new graphic.Rect({
      shape: zrUtil.extend({}, layout)
    }); // Animation

    if (animationModel) {
      var rectShape = rect.shape;
      var animateProperty = isHorizontal ? 'height' : 'width';
      var animateTarget = {};
      rectShape[animateProperty] = 0;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return rect;
  },
  polar: function (data, dataIndex, itemModel, layout, isRadial, animationModel, isUpdate) {
    var sector = new graphic.Sector({
      shape: zrUtil.extend({}, layout)
    }); // Animation

    if (animationModel) {
      var sectorShape = sector.shape;
      var animateProperty = isRadial ? 'r' : 'endAngle';
      var animateTarget = {};
      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return sector;
  }
};

function removeRect(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      width: 0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

function removeSector(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      r: el.shape.r0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

var getLayout = {
  cartesian2d: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    var fixedLineWidth = getLineWidth(itemModel, layout); // fix layout with lineWidth

    var signX = layout.width > 0 ? 1 : -1;
    var signY = layout.height > 0 ? 1 : -1;
    return {
      x: layout.x + signX * fixedLineWidth / 2,
      y: layout.y + signY * fixedLineWidth / 2,
      width: layout.width - signX * fixedLineWidth,
      height: layout.height - signY * fixedLineWidth
    };
  },
  polar: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    return {
      cx: layout.cx,
      cy: layout.cy,
      r0: layout.r0,
      r: layout.r,
      startAngle: layout.startAngle,
      endAngle: layout.endAngle
    };
  }
};

function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
  var color = data.getItemVisual(dataIndex, 'color');
  var opacity = data.getItemVisual(dataIndex, 'opacity');
  var itemStyleModel = itemModel.getModel('itemStyle.normal');
  var hoverStyle = itemModel.getModel('itemStyle.emphasis').getBarItemStyle();

  if (!isPolar) {
    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
  }

  el.useStyle(zrUtil.defaults({
    fill: color,
    opacity: opacity
  }, itemStyleModel.getBarItemStyle()));
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && el.attr('cursor', cursorStyle);
  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';

  if (!isPolar) {
    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
  }

  graphic.setHoverStyle(el, hoverStyle);
} // In case width or height are too small.


function getLineWidth(itemModel, rawLayout) {
  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
  return Math.min(lineWidth, Math.abs(rawLayout.width), Math.abs(rawLayout.height));
}

module.exports = _default;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var BaseBarSeries = __webpack_require__(442);

var PictorialBarSeries = BaseBarSeries.extend({
  type: 'series.pictorialBar',
  dependencies: ['grid'],
  defaultOption: {
    symbol: 'circle',
    // Customized bar shape
    symbolSize: null,
    // Can be ['100%', '100%'], null means auto.
    symbolRotate: null,
    symbolPosition: null,
    // 'start' or 'end' or 'center', null means auto.
    symbolOffset: null,
    symbolMargin: null,
    // start margin and end margin. Can be a number or a percent string.
    // Auto margin by defualt.
    symbolRepeat: false,
    // false/null/undefined, means no repeat.
    // Can be true, means auto calculate repeat times and cut by data.
    // Can be a number, specifies repeat times, and do not cut by data.
    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
    symbolRepeatDirection: 'end',
    // 'end' means from 'start' to 'end'.
    symbolClip: false,
    symbolBoundingData: null,
    // Can be 60 or -40 or [-40, 60]
    symbolPatternSize: 400,
    // 400 * 400 px
    barGap: '-100%',
    // In most case, overlap is needed.
    // z can be set in data item, which is z2 actually.
    // Disable progressive
    progressive: 0,
    hoverAnimation: false // Open only when needed.

  },
  getInitialData: function (option) {
    // Disable stack.
    option.stack = null;
    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
  }
});
var _default = PictorialBarSeries;
module.exports = _default;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var isNumeric = _number.isNumeric;

var _helper = __webpack_require__(443);

var setLabel = _helper.setLabel;
var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'normal', 'borderWidth']; // index: +isHorizontal

var LAYOUT_ATTRS = [{
  xy: 'x',
  wh: 'width',
  index: 0,
  posDesc: ['left', 'right']
}, {
  xy: 'y',
  wh: 'height',
  index: 1,
  posDesc: ['top', 'bottom']
}];
var pathForLineWidth = new graphic.Circle();
var BarView = echarts.extendChartView({
  type: 'pictorialBar',
  render: function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = !!baseAxis.isHorizontal();
    var coordSysRect = cartesian.grid.getRect();
    var opt = {
      ecSize: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      seriesModel: seriesModel,
      coordSys: cartesian,
      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
      isHorizontal: isHorizontal,
      valueDim: LAYOUT_ATTRS[+isHorizontal],
      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
    };
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = getItemModel(data, dataIndex);
      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
      var bar = createBar(data, opt, symbolMeta);
      data.setItemGraphicEl(dataIndex, bar);
      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).update(function (newIndex, oldIndex) {
      var bar = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(bar);
        return;
      }

      var itemModel = getItemModel(data, newIndex);
      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
      var pictorialShapeStr = getShapeStr(data, symbolMeta);

      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
        group.remove(bar);
        data.setItemGraphicEl(newIndex, null);
        bar = null;
      }

      if (bar) {
        updateBar(bar, opt, symbolMeta);
      } else {
        bar = createBar(data, opt, symbolMeta, true);
      }

      data.setItemGraphicEl(newIndex, bar);
      bar.__pictorialSymbolMeta = symbolMeta; // Add back

      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).remove(function (dataIndex) {
      var bar = oldData.getItemGraphicEl(dataIndex);
      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
    }).execute();
    this._data = data;
    return this.group;
  },
  dispose: zrUtil.noop,
  remove: function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (bar) {
          removeBar(data, bar.dataIndex, ecModel, bar);
        });
      }
    } else {
      group.removeAll();
    }
  }
}); // Set or calculate default value about symbol, and calculate layout info.

function getSymbolMeta(data, dataIndex, itemModel, opt) {
  var layout = data.getItemLayout(dataIndex);
  var symbolRepeat = itemModel.get('symbolRepeat');
  var symbolClip = itemModel.get('symbolClip');
  var symbolPosition = itemModel.get('symbolPosition') || 'start';
  var symbolRotate = itemModel.get('symbolRotate');
  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
  var isAnimationEnabled = itemModel.isAnimationEnabled();
  var symbolMeta = {
    dataIndex: dataIndex,
    layout: layout,
    itemModel: itemModel,
    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
    color: data.getItemVisual(dataIndex, 'color'),
    symbolClip: symbolClip,
    symbolRepeat: symbolRepeat,
    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
    symbolPatternSize: symbolPatternSize,
    rotation: rotation,
    animationModel: isAnimationEnabled ? itemModel : null,
    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
    z2: itemModel.getShallow('z', true) || 0
  };
  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
  var symbolSize = symbolMeta.symbolSize;
  var symbolOffset = itemModel.get('symbolOffset');

  if (zrUtil.isArray(symbolOffset)) {
    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
  }

  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
  return symbolMeta;
} // bar length can be negative.


function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
  var valueDim = opt.valueDim;
  var symbolBoundingData = itemModel.get('symbolBoundingData');
  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
  var boundingLength;

  if (zrUtil.isArray(symbolBoundingData)) {
    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
    boundingLength = symbolBoundingExtent[pxSignIdx];
  } else if (symbolBoundingData != null) {
    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
  } else if (symbolRepeat) {
    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
  } else {
    boundingLength = layout[valueDim.wh];
  }

  output.boundingLength = boundingLength;

  if (symbolRepeat) {
    output.repeatCutLength = layout[valueDim.wh];
  }

  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
}

function convertToCoordOnAxis(axis, value) {
  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
} // Support ['100%', '100%']


function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
  var valueDim = opt.valueDim;
  var categoryDim = opt.categoryDim;
  var categorySize = Math.abs(layout[categoryDim.wh]);
  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');

  if (zrUtil.isArray(symbolSize)) {
    symbolSize = symbolSize.slice();
  } else {
    if (symbolSize == null) {
      symbolSize = '100%';
    }

    symbolSize = [symbolSize, symbolSize];
  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
  // to complicated to calculate real percent value if considering scaled lineWidth.
  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
  // which can be tolerated in pictorial chart.


  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.

  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.

  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}

function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
  // In symbols are drawn with scale, so do not need to care about the case that width
  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
  // be calculated.
  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;

  if (valueLineWidth) {
    pathForLineWidth.attr({
      scale: symbolScale.slice(),
      rotation: rotation
    });
    pathForLineWidth.updateTransform();
    valueLineWidth /= pathForLineWidth.getLineScale();
    valueLineWidth *= symbolScale[opt.valueDim.index];
  }

  output.valueLineWidth = valueLineWidth;
}

function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
  var categoryDim = opt.categoryDim;
  var valueDim = opt.valueDim;
  var pxSign = output.pxSign;
  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
  // want symbols to rotate on its center, which should not be translated
  // when rotating.

  if (symbolRepeat) {
    var absBoundingLength = Math.abs(boundingLength);
    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
    var hasEndGap = false;

    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
      hasEndGap = true;
      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
    }

    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
    // to ensure that all of the symbols will not be overflow the given area.

    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
    // boundingLength.

    var repeatSpecified = isNumeric(symbolRepeat);
    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
    // entirely in the given layout area.

    var mDiff = absBoundingLength - repeatTimes * unitLength;
    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
    uLenWithMargin = unitLength + symbolMargin * 2;
    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.

    if (!repeatSpecified && symbolRepeat !== 'fixed') {
      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
    }

    pathLen = repeatTimes * uLenWithMargin - endFix;
    output.repeatTimes = repeatTimes;
    output.symbolMargin = symbolMargin;
  }

  var sizeFix = pxSign * (pathLen / 2);
  var pathPosition = output.pathPosition = [];
  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'

  if (symbolOffset) {
    pathPosition[0] += symbolOffset[0];
    pathPosition[1] += symbolOffset[1];
  }

  var bundlePosition = output.bundlePosition = [];
  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
  bundlePosition[valueDim.index] = layout[valueDim.xy];
  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.

  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
  clipShape[valueDim.xy] = 0;
  clipShape[valueDim.wh] = layout[valueDim.wh];
}

function createPath(symbolMeta) {
  var symbolPatternSize = symbolMeta.symbolPatternSize;
  var path = createSymbol( // Consider texture img, make a big size.
  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
  path.attr({
    culling: true
  });
  path.type !== 'image' && path.setStyle({
    strokeNoScale: true
  });
  return path;
}

function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var symbolSize = symbolMeta.symbolSize;
  var valueLineWidth = symbolMeta.valueLineWidth;
  var pathPosition = symbolMeta.pathPosition;
  var valueDim = opt.valueDim;
  var repeatTimes = symbolMeta.repeatTimes || 0;
  var index = 0;
  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
  eachPath(bar, function (path) {
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;

    if (index < repeatTimes) {
      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
    } else {
      updateAttr(path, null, {
        scale: [0, 0]
      }, symbolMeta, isUpdate, function () {
        bundle.remove(path);
      });
    }

    updateHoverAnimation(path, symbolMeta);
    index++;
  });

  for (; index < repeatTimes; index++) {
    var path = createPath(symbolMeta);
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;
    bundle.add(path);
    var target = makeTarget(index);
    updateAttr(path, {
      position: target.position,
      scale: [0, 0]
    }, {
      scale: target.scale,
      rotation: target.rotation
    }, symbolMeta, isUpdate); // FIXME
    // If all emphasis/normal through action.

    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
    updateHoverAnimation(path, symbolMeta);
  }

  function makeTarget(index) {
    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
    // Otherwise: i = index;

    var pxSign = symbolMeta.pxSign;
    var i = index;

    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
      i = repeatTimes - 1 - index;
    }

    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
    return {
      position: position,
      scale: symbolMeta.symbolScale.slice(),
      rotation: symbolMeta.rotation
    };
  }

  function onMouseOver() {
    eachPath(bar, function (path) {
      path.trigger('emphasis');
    });
  }

  function onMouseOut() {
    eachPath(bar, function (path) {
      path.trigger('normal');
    });
  }
}

function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var mainPath = bar.__pictorialMainPath;

  if (!mainPath) {
    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
    bundle.add(mainPath);
    updateAttr(mainPath, {
      position: symbolMeta.pathPosition.slice(),
      scale: [0, 0],
      rotation: symbolMeta.rotation
    }, {
      scale: symbolMeta.symbolScale.slice()
    }, symbolMeta, isUpdate);
    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
  } else {
    updateAttr(mainPath, null, {
      position: symbolMeta.pathPosition.slice(),
      scale: symbolMeta.symbolScale.slice(),
      rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
  }

  updateHoverAnimation(mainPath, symbolMeta);

  function onMouseOver() {
    this.trigger('emphasis');
  }

  function onMouseOut() {
    this.trigger('normal');
  }
} // bar rect is used for label.


function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
  var barRect = bar.__pictorialBarRect;

  if (!barRect) {
    barRect = bar.__pictorialBarRect = new graphic.Rect({
      z2: 2,
      shape: rectShape,
      silent: true,
      style: {
        stroke: 'transparent',
        fill: 'transparent',
        lineWidth: 0
      }
    });
    bar.add(barRect);
  } else {
    updateAttr(barRect, null, {
      shape: rectShape
    }, symbolMeta, isUpdate);
  }
}

function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
  // If not clip, symbol will be remove and rebuilt.
  if (symbolMeta.symbolClip) {
    var clipPath = bar.__pictorialClipPath;
    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
    var valueDim = opt.valueDim;
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;

    if (clipPath) {
      graphic.updateProps(clipPath, {
        shape: clipShape
      }, animationModel, dataIndex);
    } else {
      clipShape[valueDim.wh] = 0;
      clipPath = new graphic.Rect({
        shape: clipShape
      });

      bar.__pictorialBundle.setClipPath(clipPath);

      bar.__pictorialClipPath = clipPath;
      var target = {};
      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
        shape: target
      }, animationModel, dataIndex);
    }
  }
}

function getItemModel(data, dataIndex) {
  var itemModel = data.getItemModel(dataIndex);
  itemModel.getAnimationDelayParams = getAnimationDelayParams;
  itemModel.isAnimationEnabled = isAnimationEnabled;
  return itemModel;
}

function getAnimationDelayParams(path) {
  // The order is the same as the z-order, see `symbolRepeatDiretion`.
  return {
    index: path.__pictorialAnimationIndex,
    count: path.__pictorialRepeatTimes
  };
}

function isAnimationEnabled() {
  // `animation` prop can be set on itemModel in pictorial bar chart.
  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}

function updateHoverAnimation(path, symbolMeta) {
  path.off('emphasis').off('normal');
  var scale = symbolMeta.symbolScale.slice();
  symbolMeta.hoverAnimation && path.on('emphasis', function () {
    this.animateTo({
      scale: [scale[0] * 1.1, scale[1] * 1.1]
    }, 400, 'elasticOut');
  }).on('normal', function () {
    this.animateTo({
      scale: scale.slice()
    }, 400, 'elasticOut');
  });
}

function createBar(data, opt, symbolMeta, isUpdate) {
  // bar is the main element for each data.
  var bar = new graphic.Group(); // bundle is used for location and clip.

  var bundle = new graphic.Group();
  bar.add(bundle);
  bar.__pictorialBundle = bundle;
  bundle.attr('position', symbolMeta.bundlePosition.slice());

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
  }

  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
  bar.__pictorialSymbolMeta = symbolMeta;
  return bar;
}

function updateBar(bar, opt, symbolMeta) {
  var animationModel = symbolMeta.animationModel;
  var dataIndex = symbolMeta.dataIndex;
  var bundle = bar.__pictorialBundle;
  graphic.updateProps(bundle, {
    position: symbolMeta.bundlePosition.slice()
  }, animationModel, dataIndex);

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
  }

  createOrUpdateBarRect(bar, symbolMeta, true);
  createOrUpdateClip(bar, opt, symbolMeta, true);
}

function removeBar(data, dataIndex, animationModel, bar) {
  // Not show text when animating
  var labelRect = bar.__pictorialBarRect;
  labelRect && (labelRect.style.text = null);
  var pathes = [];
  eachPath(bar, function (path) {
    pathes.push(path);
  });
  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.

  bar.__pictorialClipPath && (animationModel = null);
  zrUtil.each(pathes, function (path) {
    graphic.updateProps(path, {
      scale: [0, 0]
    }, animationModel, dataIndex, function () {
      bar.parent && bar.parent.remove(bar);
    });
  });
  data.setItemGraphicEl(dataIndex, null);
}

function getShapeStr(data, symbolMeta) {
  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
}

function eachPath(bar, cb, context) {
  // Do not use Group#eachChild, because it do not support remove.
  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
    el !== bar.__pictorialBarRect && cb.call(context, el);
  });
}

function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.

  if (symbolMeta.symbolClip && !isUpdate) {
    animationAttrs && el.attr(animationAttrs);
  } else {
    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
  }
}

function updateCommon(bar, opt, symbolMeta) {
  var color = symbolMeta.color;
  var dataIndex = symbolMeta.dataIndex;
  var itemModel = symbolMeta.itemModel; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var normalStyle = itemModel.getModel('itemStyle.normal').getItemStyle(['color']);
  var hoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  eachPath(bar, function (path) {
    // PENDING setColor should be before setStyle!!!
    path.setColor(color);
    path.setStyle(zrUtil.defaults({
      fill: color,
      opacity: symbolMeta.opacity
    }, normalStyle));
    graphic.setHoverStyle(path, hoverStyle);
    cursorStyle && (path.cursor = cursorStyle);
    path.z2 = symbolMeta.z2;
  });
  var barRectHoverStyle = {};
  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
  var barRect = bar.__pictorialBarRect;
  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
  graphic.setHoverStyle(barRect, barRectHoverStyle);
}

function toIntTimes(times) {
  var roundedTimes = Math.round(times); // Escapse accurate error

  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}

var _default = BarView;
module.exports = _default;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(119);

var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getBarItemStyle: function (excludes) {
    var style = getBarItemStyle(this, excludes);

    if (this.getBorderLineDash) {
      var lineDash = this.getBorderLineDash();
      lineDash && (style.lineDash = lineDash);
    }

    return style;
  }
};
module.exports = _default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1374);

__webpack_require__(1375);

var boxplotVisual = __webpack_require__(1377);

var boxplotLayout = __webpack_require__(1376);

echarts.registerVisual(boxplotVisual);
echarts.registerLayout(boxplotLayout);

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var SeriesModel = __webpack_require__(35);

var _whiskerBoxCommon = __webpack_require__(188);

var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
var BoxplotSeries = SeriesModel.extend({
  type: 'series.boxplot',
  dependencies: ['xAxis', 'yAxis', 'grid'],
  // TODO
  // box width represents group size, so dimension should have 'size'.

  /**
   * @see <https://en.wikipedia.org/wiki/Box_plot>
   * The meanings of 'min' and 'max' depend on user,
   * and echarts do not need to know it.
   * @readOnly
   */
  defaultValueDimensions: ['min', 'Q1', 'median', 'Q3', 'max'],

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * @override
   */
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    // 'horizontal' or 'vertical'
    boxWidth: [7, 50],
    // [min, max] can be percent of band width.
    itemStyle: {
      normal: {
        color: '#fff',
        borderWidth: 1
      },
      emphasis: {
        borderWidth: 2,
        shadowBlur: 5,
        shadowOffsetX: 2,
        shadowOffsetY: 2,
        shadowColor: 'rgba(0,0,0,0.4)'
      }
    },
    animationEasing: 'elasticOut',
    animationDuration: 800
  }
});
zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
var _default = BoxplotSeries;
module.exports = _default;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ChartView = __webpack_require__(87);

var graphic = __webpack_require__(5);

var _whiskerBoxCommon = __webpack_require__(188);

var viewMixin = _whiskerBoxCommon.viewMixin;
var BoxplotView = ChartView.extend({
  type: 'boxplot',
  getStyleUpdater: function () {
    return updateStyle;
  },
  dispose: zrUtil.noop
});
zrUtil.mixin(BoxplotView, viewMixin, true); // Update common properties

var normalStyleAccessPath = ['itemStyle', 'normal'];
var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];

function updateStyle(itemGroup, data, idx) {
  var itemModel = data.getItemModel(idx);
  var normalItemStyleModel = itemModel.getModel(normalStyleAccessPath);
  var borderColor = data.getItemVisual(idx, 'color'); // Exclude borderColor.

  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
  var whiskerEl = itemGroup.childAt(itemGroup.whiskerIndex);
  whiskerEl.style.set(itemStyle);
  whiskerEl.style.stroke = borderColor;
  whiskerEl.dirty();
  var bodyEl = itemGroup.childAt(itemGroup.bodyIndex);
  bodyEl.style.set(itemStyle);
  bodyEl.style.stroke = borderColor;
  bodyEl.dirty();
  var hoverStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
  graphic.setHoverStyle(itemGroup, hoverStyle);
}

var _default = BoxplotView;
module.exports = _default;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var each = zrUtil.each;

function _default(ecModel) {
  var groupResult = groupSeriesByAxis(ecModel);
  each(groupResult, function (groupItem) {
    var seriesModels = groupItem.seriesModels;

    if (!seriesModels.length) {
      return;
    }

    calculateBase(groupItem);
    each(seriesModels, function (seriesModel, idx) {
      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
    });
  });
}
/**
 * Group series by axis.
 */


function groupSeriesByAxis(ecModel) {
  var result = [];
  var axisList = [];
  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
    var baseAxis = seriesModel.getBaseAxis();
    var idx = zrUtil.indexOf(axisList, baseAxis);

    if (idx < 0) {
      idx = axisList.length;
      axisList[idx] = baseAxis;
      result[idx] = {
        axis: baseAxis,
        seriesModels: []
      };
    }

    result[idx].seriesModels.push(seriesModel);
  });
  return result;
}
/**
 * Calculate offset and box width for each series.
 */


function calculateBase(groupItem) {
  var extent;
  var baseAxis = groupItem.axis;
  var seriesModels = groupItem.seriesModels;
  var seriesCount = seriesModels.length;
  var boxWidthList = groupItem.boxWidthList = [];
  var boxOffsetList = groupItem.boxOffsetList = [];
  var boundList = [];
  var bandWidth;

  if (baseAxis.type === 'category') {
    bandWidth = baseAxis.getBandWidth();
  } else {
    var maxDataCount = 0;
    each(seriesModels, function (seriesModel) {
      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
    });
    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
  }

  each(seriesModels, function (seriesModel) {
    var boxWidthBound = seriesModel.get('boxWidth');

    if (!zrUtil.isArray(boxWidthBound)) {
      boxWidthBound = [boxWidthBound, boxWidthBound];
    }

    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
  });
  var availableWidth = bandWidth * 0.8 - 2;
  var boxGap = availableWidth / seriesCount * 0.3;
  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
  var base = boxWidth / 2 - availableWidth / 2;
  each(seriesModels, function (seriesModel, idx) {
    boxOffsetList.push(base);
    base += boxGap + boxWidth;
    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
  });
}
/**
 * Calculate points location for each series.
 */


function layoutSingleSeries(seriesModel, offset, boxWidth) {
  var coordSys = seriesModel.coordinateSystem;
  var data = seriesModel.getData();
  var halfWidth = boxWidth / 2;
  var chartLayout = seriesModel.get('layout');
  var variableDim = chartLayout === 'horizontal' ? 0 : 1;
  var constDim = 1 - variableDim;
  var coordDims = ['x', 'y'];
  var vDims = [];
  var cDim;
  zrUtil.each(data.dimensions, function (dimName) {
    var dimInfo = data.getDimensionInfo(dimName);
    var coordDim = dimInfo.coordDim;

    if (coordDim === coordDims[constDim]) {
      vDims.push(dimName);
    } else if (coordDim === coordDims[variableDim]) {
      cDim = dimName;
    }
  });

  if (cDim == null || vDims.length < 5) {
    return;
  }

  data.each([cDim].concat(vDims), function () {
    var args = arguments;
    var axisDimVal = args[0];
    var idx = args[vDims.length + 1];
    var median = getPoint(args[3]);
    var end1 = getPoint(args[1]);
    var end5 = getPoint(args[5]);
    var whiskerEnds = [[end1, getPoint(args[2])], [end5, getPoint(args[4])]];
    layEndLine(end1);
    layEndLine(end5);
    layEndLine(median);
    var bodyEnds = [];
    addBodyEnd(whiskerEnds[0][1], 0);
    addBodyEnd(whiskerEnds[1][1], 1);
    data.setItemLayout(idx, {
      chartLayout: chartLayout,
      initBaseline: median[constDim],
      median: median,
      bodyEnds: bodyEnds,
      whiskerEnds: whiskerEnds
    });

    function getPoint(val) {
      var p = [];
      p[variableDim] = axisDimVal;
      p[constDim] = val;
      var point;

      if (isNaN(axisDimVal) || isNaN(val)) {
        point = [NaN, NaN];
      } else {
        point = coordSys.dataToPoint(p);
        point[variableDim] += offset;
      }

      return point;
    }

    function addBodyEnd(point, start) {
      var point1 = point.slice();
      var point2 = point.slice();
      point1[variableDim] += halfWidth;
      point2[variableDim] -= halfWidth;
      start ? bodyEnds.push(point1, point2) : bodyEnds.push(point2, point1);
    }

    function layEndLine(endCenter) {
      var line = [endCenter.slice(), endCenter.slice()];
      line[0][variableDim] -= halfWidth;
      line[1][variableDim] += halfWidth;
      whiskerEnds.push(line);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

var borderColorQuery = ['itemStyle', 'normal', 'borderColor'];

function _default(ecModel, api) {
  var globalColors = ecModel.get('color');
  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
    var data = seriesModel.getData();
    data.setVisual({
      legendSymbol: 'roundRect',
      // Use name 'color' but not 'borderColor' for legend usage and
      // visual coding from other component like dataRange.
      color: seriesModel.get(borderColorQuery) || defaulColor
    }); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        data.setItemVisual(idx, {
          color: itemModel.get(borderColorQuery, true)
        });
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1379);

__webpack_require__(1380);

var preprocessor = __webpack_require__(1383);

var candlestickVisual = __webpack_require__(1382);

var candlestickLayout = __webpack_require__(1381);

echarts.registerPreprocessor(preprocessor);
echarts.registerVisual(candlestickVisual);
echarts.registerLayout(candlestickLayout);

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var SeriesModel = __webpack_require__(35);

var _whiskerBoxCommon = __webpack_require__(188);

var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
var CandlestickSeries = SeriesModel.extend({
  type: 'series.candlestick',
  dependencies: ['xAxis', 'yAxis', 'grid'],

  /**
   * @readOnly
   */
  defaultValueDimensions: ['open', 'close', 'lowest', 'highest'],

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * @override
   */
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    // 'horizontal' or 'vertical'
    itemStyle: {
      normal: {
        color: '#c23531',
        // 阳线 positive
        color0: '#314656',
        // 阴线 negative     '#c23531', '#314656'
        borderWidth: 1,
        // FIXME
        // ec2中使用的是lineStyle.color 和 lineStyle.color0
        borderColor: '#c23531',
        borderColor0: '#314656'
      },
      emphasis: {
        borderWidth: 2
      }
    },
    barMaxWidth: null,
    barMinWidth: null,
    barWidth: null,
    animationUpdate: false,
    animationEasing: 'linear',
    animationDuration: 300
  },

  /**
   * Get dimension for shadow in dataZoom
   * @return {string} dimension name
   */
  getShadowDim: function () {
    return 'open';
  },
  brushSelector: function (dataIndex, data, selectors) {
    var itemLayout = data.getItemLayout(dataIndex);
    return selectors.rect(itemLayout.brushRect);
  }
});
zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
var _default = CandlestickSeries;
module.exports = _default;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ChartView = __webpack_require__(87);

var graphic = __webpack_require__(5);

var _whiskerBoxCommon = __webpack_require__(188);

var viewMixin = _whiskerBoxCommon.viewMixin;
var CandlestickView = ChartView.extend({
  type: 'candlestick',
  getStyleUpdater: function () {
    return updateStyle;
  },
  dispose: zrUtil.noop
});
zrUtil.mixin(CandlestickView, viewMixin, true); // Update common properties

var normalStyleAccessPath = ['itemStyle', 'normal'];
var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];

function updateStyle(itemGroup, data, idx) {
  var itemModel = data.getItemModel(idx);
  var normalItemStyleModel = itemModel.getModel(normalStyleAccessPath);
  var color = data.getItemVisual(idx, 'color');
  var borderColor = data.getItemVisual(idx, 'borderColor') || color; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var itemStyle = normalItemStyleModel.getItemStyle(['color', 'color0', 'borderColor', 'borderColor0']);
  var whiskerEl = itemGroup.childAt(itemGroup.whiskerIndex);
  whiskerEl.useStyle(itemStyle);
  whiskerEl.style.stroke = borderColor;
  var bodyEl = itemGroup.childAt(itemGroup.bodyIndex);
  bodyEl.useStyle(itemStyle);
  bodyEl.style.fill = color;
  bodyEl.style.stroke = borderColor;
  var hoverStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
  graphic.setHoverStyle(itemGroup, hoverStyle);
}

var _default = CandlestickView;
module.exports = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

var _graphic = __webpack_require__(5);

var subPixelOptimize = _graphic.subPixelOptimize;
var retrieve2 = zrUtil.retrieve2;

function _default(ecModel) {
  ecModel.eachSeriesByType('candlestick', function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var candleWidth = calculateCandleWidth(seriesModel, data);
    var chartLayout = seriesModel.get('layout');
    var variableDim = chartLayout === 'horizontal' ? 0 : 1;
    var constDim = 1 - variableDim;
    var coordDims = ['x', 'y'];
    var vDims = [];
    var cDim;
    zrUtil.each(data.dimensions, function (dimName) {
      var dimInfo = data.getDimensionInfo(dimName);
      var coordDim = dimInfo.coordDim;

      if (coordDim === coordDims[constDim]) {
        vDims.push(dimName);
      } else if (coordDim === coordDims[variableDim]) {
        cDim = dimName;
      }
    });

    if (cDim == null || vDims.length < 4) {
      return;
    }

    var dataIndex = 0;
    data.each([cDim].concat(vDims), function () {
      var args = arguments;
      var axisDimVal = args[0];
      var idx = args[vDims.length + 1];
      var openVal = args[1];
      var closeVal = args[2];
      var lowestVal = args[3];
      var highestVal = args[4];
      var ocLow = Math.min(openVal, closeVal);
      var ocHigh = Math.max(openVal, closeVal);
      var ocLowPoint = getPoint(ocLow);
      var ocHighPoint = getPoint(ocHigh);
      var lowestPoint = getPoint(lowestVal);
      var highestPoint = getPoint(highestVal);
      var whiskerEnds = [[subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint)], [subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint)]];
      var bodyEnds = [];
      addBodyEnd(ocHighPoint, 0);
      addBodyEnd(ocLowPoint, 1);
      var sign;

      if (openVal > closeVal) {
        sign = -1;
      } else if (openVal < closeVal) {
        sign = 1;
      } else {
        // If close === open, compare with close of last record
        if (dataIndex > 0) {
          sign = data.getItemModel(dataIndex - 1).get()[2] <= closeVal ? 1 : -1;
        } else {
          // No record of previous, set to be positive
          sign = 1;
        }
      }

      data.setItemLayout(idx, {
        chartLayout: chartLayout,
        sign: sign,
        initBaseline: openVal > closeVal ? ocHighPoint[constDim] : ocLowPoint[constDim],
        // open point.
        bodyEnds: bodyEnds,
        whiskerEnds: whiskerEnds,
        brushRect: makeBrushRect()
      });
      ++dataIndex;

      function getPoint(val) {
        var p = [];
        p[variableDim] = axisDimVal;
        p[constDim] = val;
        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
      }

      function addBodyEnd(point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[variableDim] = subPixelOptimize(point1[variableDim] + candleWidth / 2, 1, false);
        point2[variableDim] = subPixelOptimize(point2[variableDim] - candleWidth / 2, 1, true);
        start ? bodyEnds.push(point1, point2) : bodyEnds.push(point2, point1);
      }

      function makeBrushRect() {
        var pmin = getPoint(Math.min(openVal, closeVal, lowestVal, highestVal));
        var pmax = getPoint(Math.max(openVal, closeVal, lowestVal, highestVal));
        pmin[variableDim] -= candleWidth / 2;
        pmax[variableDim] -= candleWidth / 2;
        return {
          x: pmin[0],
          y: pmin[1],
          width: constDim ? candleWidth : pmax[0] - pmin[0],
          height: constDim ? pmax[1] - pmin[1] : candleWidth
        };
      }

      function subPixelOptimizePoint(point) {
        point[variableDim] = subPixelOptimize(point[variableDim], 1);
        return point;
      }
    }, true);
  });
}

function calculateCandleWidth(seriesModel, data) {
  var baseAxis = seriesModel.getBaseAxis();
  var extent;
  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
  var barWidth = seriesModel.get('barWidth');
  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}

module.exports = _default;

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

var positiveBorderColorQuery = ['itemStyle', 'normal', 'borderColor'];
var negativeBorderColorQuery = ['itemStyle', 'normal', 'borderColor0'];
var positiveColorQuery = ['itemStyle', 'normal', 'color'];
var negativeColorQuery = ['itemStyle', 'normal', 'color0'];

function _default(ecModel, api) {
  ecModel.eachRawSeriesByType('candlestick', function (seriesModel) {
    var data = seriesModel.getData();
    data.setVisual({
      legendSymbol: 'roundRect'
    }); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var sign = data.getItemLayout(idx).sign;
        data.setItemVisual(idx, {
          color: itemModel.get(sign > 0 ? positiveColorQuery : negativeColorQuery),
          borderColor: itemModel.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery)
        });
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function _default(option) {
  if (!option || !zrUtil.isArray(option.series)) {
    return;
  } // Translate 'k' to 'candlestick'.


  zrUtil.each(option.series, function (seriesItem) {
    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
      seriesItem.type = 'candlestick';
    }
  });
}

module.exports = _default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphicUtil = __webpack_require__(5);

var _labelHelper = __webpack_require__(449);

var findLabelValueDim = _labelHelper.findLabelValueDim;

var createListFromArray = __webpack_require__(84);

var barGrid = __webpack_require__(283);

var DataDiffer = __webpack_require__(117);

var prepareCartesian2d = __webpack_require__(1571);

var prepareGeo = __webpack_require__(1578);

var prepareSingleAxis = __webpack_require__(1596);

var preparePolar = __webpack_require__(1589);

var prepareCalendar = __webpack_require__(1566);

var ITEM_STYLE_NORMAL_PATH = ['itemStyle', 'normal'];
var ITEM_STYLE_EMPHASIS_PATH = ['itemStyle', 'emphasis'];
var LABEL_NORMAL = ['label', 'normal'];
var LABEL_EMPHASIS = ['label', 'emphasis']; // Use prefix to avoid index to be the same as el.name,
// which will cause weird udpate animation.

var GROUP_DIFF_PREFIX = 'e\0\0';
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */

var prepareCustoms = {
  cartesian2d: prepareCartesian2d,
  geo: prepareGeo,
  singleAxis: prepareSingleAxis,
  polar: preparePolar,
  calendar: prepareCalendar
}; // ------
// Model
// ------

echarts.extendSeriesModel({
  type: 'series.custom',
  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    // Can be set as 'none'
    zlevel: 0,
    z: 2,
    legendHoverLink: true // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // label: {}
    // itemStyle: {}

  },
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  }
}); // -----
// View
// -----

echarts.extendChartView({
  type: 'custom',

  /**
   * @private
   * @type {module:echarts/data/List}
   */
  _data: null,

  /**
   * @override
   */
  render: function (customSeries, ecModel, api) {
    var oldData = this._data;
    var data = customSeries.getData();
    var group = this.group;
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
    data.diff(oldData).add(function (newIdx) {
      data.hasValue(newIdx) && createOrUpdate(null, newIdx, renderItem(newIdx), customSeries, group, data);
    }).update(function (newIdx, oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      data.hasValue(newIdx) ? createOrUpdate(el, newIdx, renderItem(newIdx), customSeries, group, data) : el && group.remove(el);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  },

  /**
   * @override
   */
  dispose: zrUtil.noop
});

function createEl(elOption) {
  var graphicType = elOption.type;
  var el;

  if (graphicType === 'path') {
    var shape = elOption.shape;
    el = graphicUtil.makePath(shape.pathData, null, {
      x: shape.x || 0,
      y: shape.y || 0,
      width: shape.width || 0,
      height: shape.height || 0
    }, 'center');
    el.__customPathData = elOption.pathData;
  } else if (graphicType === 'image') {
    el = new graphicUtil.Image({});
    el.__customImagePath = elOption.style.image;
  } else if (graphicType === 'text') {
    el = new graphicUtil.Text({});
    el.__customText = elOption.style.text;
  } else {
    var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
    el = new Clz();
  }

  el.__customGraphicType = graphicType;
  el.name = elOption.name;
  return el;
}

function updateEl(el, dataIndex, elOption, animatableModel, data, isInit) {
  var targetProps = {};
  var elOptionStyle = elOption.style || {};
  elOption.shape && (targetProps.shape = zrUtil.clone(elOption.shape));
  elOption.position && (targetProps.position = elOption.position.slice());
  elOption.scale && (targetProps.scale = elOption.scale.slice());
  elOption.origin && (targetProps.origin = elOption.origin.slice());
  elOption.rotation && (targetProps.rotation = elOption.rotation);

  if (el.type === 'image' && elOption.style) {
    var targetStyle = targetProps.style = {};
    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
    });
  }

  if (el.type === 'text' && elOption.style) {
    var targetStyle = targetProps.style = {};
    zrUtil.each(['x', 'y'], function (prop) {
      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
    }); // Compatible with previous: both support
    // textFill and fill, textStroke and stroke in 'text' element.

    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
  }

  if (el.type !== 'group') {
    el.useStyle(elOptionStyle); // Init animation.

    if (isInit) {
      el.style.opacity = 0;
      var targetOpacity = elOptionStyle.opacity;
      targetOpacity == null && (targetOpacity = 1);
      graphicUtil.initProps(el, {
        style: {
          opacity: targetOpacity
        }
      }, animatableModel, dataIndex);
    }
  }

  if (isInit) {
    el.attr(targetProps);
  } else {
    graphicUtil.updateProps(el, targetProps, animatableModel, dataIndex);
  } // z2 must not be null/undefined, otherwise sort error may occur.


  el.attr({
    z2: elOption.z2 || 0,
    silent: elOption.silent
  });
  elOption.styleEmphasis !== false && graphicUtil.setHoverStyle(el, elOption.styleEmphasis);
}

function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
  if (elOptionStyle[prop] != null && !isInit) {
    targetStyle[prop] = elOptionStyle[prop];
    elOptionStyle[prop] = oldElStyle[prop];
  }
}

function makeRenderItem(customSeries, data, ecModel, api) {
  var renderItem = customSeries.get('renderItem');
  var coordSys = customSeries.coordinateSystem;
  var prepareResult = {};

  if (coordSys) {
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
  }

  var userAPI = zrUtil.defaults({
    getWidth: api.getWidth,
    getHeight: api.getHeight,
    getZr: api.getZr,
    getDevicePixelRatio: api.getDevicePixelRatio,
    value: value,
    style: style,
    styleEmphasis: styleEmphasis,
    visual: visual,
    barLayout: barLayout,
    currentSeriesIndices: currentSeriesIndices,
    font: font
  }, prepareResult.api || {});
  var userParams = {
    context: {},
    seriesId: customSeries.id,
    seriesName: customSeries.name,
    seriesIndex: customSeries.seriesIndex,
    coordSys: prepareResult.coordSys,
    dataInsideLength: data.count(),
    encode: wrapEncodeDef(customSeries.getData())
  }; // Do not support call `api` asynchronously without dataIndexInside input.

  var currDataIndexInside;
  var currDirty = true;
  var currItemModel;
  var currLabelNormalModel;
  var currLabelEmphasisModel;
  var currLabelValueDim;
  var currVisualColor;
  return function (dataIndexInside) {
    currDataIndexInside = dataIndexInside;
    currDirty = true;
    return renderItem && renderItem(zrUtil.defaults({
      dataIndexInside: dataIndexInside,
      dataIndex: data.getRawIndex(dataIndexInside)
    }, userParams), userAPI) || {};
  }; // Do not update cache until api called.

  function updateCache(dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);

    if (currDirty) {
      currItemModel = data.getItemModel(dataIndexInside);
      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
      currLabelValueDim = findLabelValueDim(data);
      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
      currDirty = false;
    }
  }
  /**
   * @public
   * @param {number|string} dim
   * @param {number} [dataIndexInside=currDataIndexInside]
   * @return {number|string} value
   */


  function value(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.get(data.getDimension(dim || 0), dataIndexInside);
  }
  /**
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function style(extra, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    updateCache(dataIndexInside);
    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
    currVisualColor != null && (itemStyle.fill = currVisualColor);
    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
    opacity != null && (itemStyle.opacity = opacity);

    if (currLabelValueDim != null) {
      graphicUtil.setTextStyle(itemStyle, currLabelNormalModel, null, {
        autoColor: currVisualColor,
        isRectText: true
      });
      itemStyle.text = currLabelNormalModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), data.get(currLabelValueDim, dataIndexInside)) : null;
    }

    extra && zrUtil.extend(itemStyle, extra);
    return itemStyle;
  }
  /**
   * @public
   * @param {Object} [extra]
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function styleEmphasis(extra, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    updateCache(dataIndexInside);
    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();

    if (currLabelValueDim != null) {
      graphicUtil.setTextStyle(itemStyle, currLabelEmphasisModel, null, {
        isRectText: true
      }, true);
      itemStyle.text = currLabelEmphasisModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), data.get(currLabelValueDim, dataIndexInside)) : null;
    }

    extra && zrUtil.extend(itemStyle, extra);
    return itemStyle;
  }
  /**
   * @public
   * @param {string} visualType
   * @param {number} [dataIndexInside=currDataIndexInside]
   */


  function visual(visualType, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.getItemVisual(dataIndexInside, visualType);
  }
  /**
   * @public
   * @param {number} opt.count Positive interger.
   * @param {number} [opt.barWidth]
   * @param {number} [opt.barMaxWidth]
   * @param {number} [opt.barGap]
   * @param {number} [opt.barCategoryGap]
   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
   */


  function barLayout(opt) {
    if (coordSys.getBaseAxis) {
      var baseAxis = coordSys.getBaseAxis();
      return barGrid.getLayoutOnAxis(zrUtil.defaults({
        axis: baseAxis
      }, opt), api);
    }
  }
  /**
   * @public
   * @return {Array.<number>}
   */


  function currentSeriesIndices() {
    return ecModel.getCurrentSeriesIndices();
  }
  /**
   * @public
   * @param {Object} opt
   * @param {string} [opt.fontStyle]
   * @param {number} [opt.fontWeight]
   * @param {number} [opt.fontSize]
   * @param {string} [opt.fontFamily]
   * @return {string} font string
   */


  function font(opt) {
    return graphicUtil.getFont(opt, ecModel);
  }
}

function wrapEncodeDef(data) {
  var encodeDef = {};
  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
    var dimInfo = data.getDimensionInfo(dimName);

    if (!dimInfo.isExtraCoord) {
      var coordDim = dimInfo.coordDim;
      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
    }
  });
  return encodeDef;
}

function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data);
  el && data.setItemGraphicEl(dataIndex, el);
}

function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
  var elOptionType = elOption.type;

  if (el && elOptionType !== el.__customGraphicType && (elOptionType !== 'path' || elOption.pathData !== el.__customPathData) && (elOptionType !== 'image' || elOption.style.image !== el.__customImagePath) && (elOptionType !== 'text' || elOption.style.text !== el.__customText)) {
    group.remove(el);
    el = null;
  } // `elOption.type` is undefined when `renderItem` returns nothing.


  if (elOptionType == null) {
    return;
  }

  var isInit = !el;
  !el && (el = createEl(elOption));
  updateEl(el, dataIndex, elOption, animatableModel, data, isInit);

  if (elOptionType === 'group') {
    var oldChildren = el.children() || [];
    var newChildren = elOption.children || [];

    if (elOption.diffChildrenByName) {
      // lower performance.
      diffGroupChildren({
        oldChildren: oldChildren,
        newChildren: newChildren,
        dataIndex: dataIndex,
        animatableModel: animatableModel,
        group: el,
        data: data
      });
    } else {
      // better performance.
      var index = 0;

      for (; index < newChildren.length; index++) {
        doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
      }

      for (; index < oldChildren.length; index++) {
        oldChildren[index] && el.remove(oldChildren[index]);
      }
    }
  }

  group.add(el);
  return el;
}

function diffGroupChildren(context) {
  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
}

function getKey(item, idx) {
  var name = item && item.name;
  return name != null ? name : GROUP_DIFF_PREFIX + idx;
}

function processAddUpdate(newIndex, oldIndex) {
  var context = this.context;
  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
}

function processRemove(oldIndex) {
  var context = this.context;
  var child = context.oldChildren[oldIndex];
  child && context.group.remove(child);
}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1386);

__webpack_require__(1387);

var visualSymbol = __webpack_require__(106);

var layoutPoints = __webpack_require__(284);

echarts.registerVisual(zrUtil.curry(visualSymbol, 'effectScatter', 'circle', null));
echarts.registerLayout(zrUtil.curry(layoutPoints, 'effectScatter'));

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var createListFromArray = __webpack_require__(84);

var SeriesModel = __webpack_require__(35);

var _default = SeriesModel.extend({
  type: 'series.effectScatter',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    var list = createListFromArray(option.data, this, ecModel);
    return list;
  },
  brushSelector: 'point',
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    effectType: 'ripple',
    progressive: 0,
    // When to show the effect, option: 'render'|'emphasis'
    showEffectOn: 'render',
    // Ripple effect config
    rippleEffect: {
      period: 4,
      // Scale of ripple
      scale: 2.5,
      // Brush type can be fill or stroke
      brushType: 'fill'
    },
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    // large: false,
    // Available when large is true
    // largeThreshold: 2000,
    // itemStyle: {
    //     normal: {
    //         opacity: 1
    //     }
    // }

  }
});

module.exports = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var SymbolDraw = __webpack_require__(139);

var EffectSymbol = __webpack_require__(1414);

var _default = echarts.extendChartView({
  type: 'effectScatter',
  init: function () {
    this._symbolDraw = new SymbolDraw(EffectSymbol);
  },
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var effectSymbolDraw = this._symbolDraw;
    effectSymbolDraw.updateData(data);
    this.group.add(effectSymbolDraw.group);
  },
  updateLayout: function () {
    this._symbolDraw.updateLayout();
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(api);
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1389);

__webpack_require__(1390);

var dataColor = __webpack_require__(287);

var funnelLayout = __webpack_require__(1391);

var dataFilter = __webpack_require__(194);

echarts.registerVisual(zrUtil.curry(dataColor, 'funnel'));
echarts.registerLayout(funnelLayout);
echarts.registerProcessor(zrUtil.curry(dataFilter, 'funnel'));

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var List = __webpack_require__(31);

var _model = __webpack_require__(15);

var defaultEmphasis = _model.defaultEmphasis;

var completeDimensions = __webpack_require__(58);

var FunnelSeries = echarts.extendSeriesModel({
  type: 'series.funnel',
  init: function (option) {
    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendDataProvider = function () {
      return this.getRawData();
    }; // Extend labelLine emphasis


    this._defaultLabelLine(option);
  },
  getInitialData: function (option, ecModel) {
    var dimensions = completeDimensions(['value'], option.data);
    var list = new List(dimensions, this);
    list.initData(option.data);
    return list;
  },
  _defaultLabelLine: function (option) {
    // Extend labelLine emphasis
    defaultEmphasis(option.labelLine, ['show']);
    var labelLineNormalOpt = option.labelLine.normal;
    var labelLineEmphasisOpt = option.labelLine.emphasis; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.normal.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.label.emphasis.show;
  },
  // Overwrite
  getDataParams: function (dataIndex) {
    var data = this.getData();
    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
    var sum = data.getSum('value'); // Percent is 0 if sum is 0

    params.percent = !sum ? 0 : +(data.get('value', dataIndex) / sum * 100).toFixed(2);
    params.$vars.push('percent');
    return params;
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    legendHoverLink: true,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    // 默认取数据最小最大值
    // min: 0,
    // max: 100,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    // 'ascending', 'descending'
    gap: 0,
    funnelAlign: 'center',
    label: {
      normal: {
        show: true,
        position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

      },
      emphasis: {
        show: true
      }
    },
    labelLine: {
      normal: {
        show: true,
        length: 20,
        lineStyle: {
          // color: 各异,
          width: 1,
          type: 'solid'
        }
      },
      emphasis: {}
    },
    itemStyle: {
      normal: {
        // color: 各异,
        borderColor: '#fff',
        borderWidth: 1
      },
      emphasis: {// color: 各异,
      }
    }
  }
});
var _default = FunnelSeries;
module.exports = _default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var zrUtil = __webpack_require__(0);

var ChartView = __webpack_require__(87);

/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */
function FunnelPiece(data, idx) {
  graphic.Group.call(this);
  var polygon = new graphic.Polygon();
  var labelLine = new graphic.Polyline();
  var text = new graphic.Text();
  this.add(polygon);
  this.add(labelLine);
  this.add(text);
  this.updateData(data, idx, true); // Hover to change label and labelLine

  function onEmphasis() {
    labelLine.ignore = labelLine.hoverIgnore;
    text.ignore = text.hoverIgnore;
  }

  function onNormal() {
    labelLine.ignore = labelLine.normalIgnore;
    text.ignore = text.normalIgnore;
  }

  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
}

var funnelPieceProto = FunnelPiece.prototype;
var opacityAccessPath = ['itemStyle', 'normal', 'opacity'];

funnelPieceProto.updateData = function (data, idx, firstCreate) {
  var polygon = this.childAt(0);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var opacity = data.getItemModel(idx).get(opacityAccessPath);
  opacity = opacity == null ? 1 : opacity; // Reset style

  polygon.useStyle({});

  if (firstCreate) {
    polygon.setShape({
      points: layout.points
    });
    polygon.setStyle({
      opacity: 0
    });
    graphic.initProps(polygon, {
      style: {
        opacity: opacity
      }
    }, seriesModel, idx);
  } else {
    graphic.updateProps(polygon, {
      style: {
        opacity: opacity
      },
      shape: {
        points: layout.points
      }
    }, seriesModel, idx);
  } // Update common style


  var itemStyleModel = itemModel.getModel('itemStyle');
  var visualColor = data.getItemVisual(idx, 'color');
  polygon.setStyle(zrUtil.defaults({
    lineJoin: 'round',
    fill: visualColor
  }, itemStyleModel.getModel('normal').getItemStyle(['opacity'])));
  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();

  this._updateLabel(data, idx);

  graphic.setHoverStyle(this);
};

funnelPieceProto._updateLabel = function (data, idx) {
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var labelLayout = layout.label;
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.updateProps(labelLine, {
    shape: {
      points: labelLayout.linePoints || labelLayout.linePoints
    }
  }, seriesModel, idx);
  graphic.updateProps(labelText, {
    style: {
      x: labelLayout.x,
      y: labelLayout.y
    }
  }, seriesModel, idx);
  labelText.attr({
    rotation: labelLayout.rotation,
    origin: [labelLayout.x, labelLayout.y],
    z2: 10
  });
  var labelModel = itemModel.getModel('label.normal');
  var labelHoverModel = itemModel.getModel('label.emphasis');
  var labelLineModel = itemModel.getModel('labelLine.normal');
  var labelLineHoverModel = itemModel.getModel('labelLine.emphasis');
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
    labelFetcher: data.hostModel,
    labelDataIndex: idx,
    defaultText: data.getName(idx),
    autoColor: visualColor,
    useInsideStyle: !!labelLayout.inside
  }, {
    textAlign: labelLayout.textAlign,
    textVerticalAlign: labelLayout.verticalAlign
  });
  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
  labelText.hoverIgnore = !labelHoverModel.get('show');
  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color

  labelLine.setStyle({
    stroke: visualColor
  });
  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
};

zrUtil.inherits(FunnelPiece, graphic.Group);
var FunnelView = ChartView.extend({
  type: 'funnel',
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    data.diff(oldData).add(function (idx) {
      var funnelPiece = new FunnelPiece(data, idx);
      data.setItemGraphicEl(idx, funnelPiece);
      group.add(funnelPiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx);
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      group.remove(piePiece);
    }).execute();
    this._data = data;
  },
  remove: function () {
    this.group.removeAll();
    this._data = null;
  },
  dispose: function () {}
});
var _default = FunnelView;
module.exports = _default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var layout = __webpack_require__(17);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var linearMap = _number.linearMap;

function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getSortedIndices(data, sort) {
  var valueArr = data.mapArray('value', function (val) {
    return val;
  });
  var indices = [];
  var isAscending = sort === 'ascending';

  for (var i = 0, len = data.count(); i < len; i++) {
    indices[i] = i;
  } // Add custom sortable function & none sortable opetion by "options.sort"


  if (typeof sort === 'function') {
    indices.sort(sort);
  } else if (sort !== 'none') {
    indices.sort(function (a, b) {
      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
  }

  return indices;
}

function labelLayout(data) {
  data.each(function (idx) {
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label.normal');
    var labelPosition = labelModel.get('position');
    var labelLineModel = itemModel.getModel('labelLine.normal');
    var layout = data.getItemLayout(idx);
    var points = layout.points;
    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center';
    var textAlign;
    var textX;
    var textY;
    var linePoints;

    if (isLabelInside) {
      textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
      textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
      textAlign = 'center';
      linePoints = [[textX, textY], [textX, textY]];
    } else {
      var x1;
      var y1;
      var x2;
      var labelLineLen = labelLineModel.get('length');

      if (labelPosition === 'left') {
        // Left side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        x2 = x1 - labelLineLen;
        textX = x2 - 5;
        textAlign = 'right';
      } else {
        // Right side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        x2 = x1 + labelLineLen;
        textX = x2 + 5;
        textAlign = 'left';
      }

      var y2 = y1;
      linePoints = [[x1, y1], [x2, y2]];
      textY = y2;
    }

    layout.label = {
      linePoints: linePoints,
      x: textX,
      y: textY,
      verticalAlign: 'middle',
      textAlign: textAlign,
      inside: isLabelInside
    };
  });
}

function _default(ecModel, api, payload) {
  ecModel.eachSeriesByType('funnel', function (seriesModel) {
    var data = seriesModel.getData();
    var sort = seriesModel.get('sort');
    var viewRect = getViewRect(seriesModel, api);
    var indices = getSortedIndices(data, sort);
    var sizeExtent = [parsePercent(seriesModel.get('minSize'), viewRect.width), parsePercent(seriesModel.get('maxSize'), viewRect.width)];
    var dataExtent = data.getDataExtent('value');
    var min = seriesModel.get('min');
    var max = seriesModel.get('max');

    if (min == null) {
      min = Math.min(dataExtent[0], 0);
    }

    if (max == null) {
      max = dataExtent[1];
    }

    var funnelAlign = seriesModel.get('funnelAlign');
    var gap = seriesModel.get('gap');
    var itemHeight = (viewRect.height - gap * (data.count() - 1)) / data.count();
    var y = viewRect.y;

    var getLinePoints = function (idx, offY) {
      // End point index is data.count() and we assign it 0
      var val = data.get('value', idx) || 0;
      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
      var x0;

      switch (funnelAlign) {
        case 'left':
          x0 = viewRect.x;
          break;

        case 'center':
          x0 = viewRect.x + (viewRect.width - itemWidth) / 2;
          break;

        case 'right':
          x0 = viewRect.x + viewRect.width - itemWidth;
          break;
      }

      return [[x0, offY], [x0 + itemWidth, offY]];
    };

    if (sort === 'ascending') {
      // From bottom to top
      itemHeight = -itemHeight;
      gap = -gap;
      y += viewRect.height;
      indices = indices.reverse();
    }

    for (var i = 0; i < indices.length; i++) {
      var idx = indices[i];
      var nextIdx = indices[i + 1];
      var start = getLinePoints(idx, y);
      var end = getLinePoints(nextIdx, y + itemHeight);
      y += itemHeight + gap;
      data.setItemLayout(idx, {
        points: start.concat(end.slice().reverse())
      });
    }

    labelLayout(data);
  });
}

module.exports = _default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1393);

__webpack_require__(1394);

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var List = __webpack_require__(31);

var SeriesModel = __webpack_require__(35);

var zrUtil = __webpack_require__(0);

var GaugeSeries = SeriesModel.extend({
  type: 'series.gauge',
  getInitialData: function (option, ecModel) {
    var list = new List(['value'], this);
    var dataOpt = option.data || [];

    if (!zrUtil.isArray(dataOpt)) {
      dataOpt = [dataOpt];
    } // Only use the first data item


    list.initData(dataOpt);
    return list;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    // 默认全局居中
    center: ['50%', '50%'],
    legendHoverLink: true,
    radius: '75%',
    startAngle: 225,
    endAngle: -45,
    clockwise: true,
    // 最小值
    min: 0,
    // 最大值
    max: 100,
    // 分割段数，默认为10
    splitNumber: 10,
    // 坐标轴线
    axisLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      lineStyle: {
        // 属性lineStyle控制线条样式
        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
        width: 30
      }
    },
    // 分隔线
    splitLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      // 属性length控制线长
      length: 30,
      // 属性lineStyle（详见lineStyle）控制线条样式
      lineStyle: {
        color: '#eee',
        width: 2,
        type: 'solid'
      }
    },
    // 坐标轴小标记
    axisTick: {
      // 属性show控制显示与否，默认不显示
      show: true,
      // 每份split细分多少段
      splitNumber: 5,
      // 属性length控制线长
      length: 8,
      // 属性lineStyle控制线条样式
      lineStyle: {
        color: '#eee',
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {
      show: true,
      distance: 5,
      // formatter: null,
      color: 'auto'
    },
    pointer: {
      show: true,
      length: '80%',
      width: 8
    },
    itemStyle: {
      normal: {
        color: 'auto'
      }
    },
    title: {
      show: true,
      // x, y，单位px
      offsetCenter: [0, '-40%'],
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#333',
      fontSize: 15
    },
    detail: {
      show: true,
      backgroundColor: 'rgba(0,0,0,0)',
      borderWidth: 0,
      borderColor: '#ccc',
      width: 100,
      height: null,
      // self-adaption
      padding: [5, 10],
      // x, y，单位px
      offsetCenter: [0, '40%'],
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: 'auto',
      fontSize: 30
    }
  }
});
var _default = GaugeSeries;
module.exports = _default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var PointerPath = __webpack_require__(1395);

var graphic = __webpack_require__(5);

var ChartView = __webpack_require__(87);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var round = _number.round;
var linearMap = _number.linearMap;

function parsePosition(seriesModel, api) {
  var center = seriesModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  var size = Math.min(width, height);
  var cx = parsePercent(center[0], api.getWidth());
  var cy = parsePercent(center[1], api.getHeight());
  var r = parsePercent(seriesModel.get('radius'), size / 2);
  return {
    cx: cx,
    cy: cy,
    r: r
  };
}

function formatLabel(label, labelFormatter) {
  if (labelFormatter) {
    if (typeof labelFormatter === 'string') {
      label = labelFormatter.replace('{value}', label != null ? label : '');
    } else if (typeof labelFormatter === 'function') {
      label = labelFormatter(label);
    }
  }

  return label;
}

var PI2 = Math.PI * 2;
var GaugeView = ChartView.extend({
  type: 'gauge',
  render: function (seriesModel, ecModel, api) {
    this.group.removeAll();
    var colorList = seriesModel.get('axisLine.lineStyle.color');
    var posInfo = parsePosition(seriesModel, api);

    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
  },
  dispose: function () {},
  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
    var group = this.group;
    var axisLineModel = seriesModel.getModel('axisLine');
    var lineStyleModel = axisLineModel.getModel('lineStyle');
    var clockwise = seriesModel.get('clockwise');
    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
    var angleRangeSpan = (endAngle - startAngle) % PI2;
    var prevEndAngle = startAngle;
    var axisLineWidth = lineStyleModel.get('width');

    for (var i = 0; i < colorList.length; i++) {
      // Clamp
      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
      var endAngle = startAngle + angleRangeSpan * percent;
      var sector = new graphic.Sector({
        shape: {
          startAngle: prevEndAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: posInfo.r - axisLineWidth,
          r: posInfo.r
        },
        silent: true
      });
      sector.setStyle({
        fill: colorList[i][1]
      });
      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
      // so the properties for stroking are useless
      ['color', 'borderWidth', 'borderColor']));
      group.add(sector);
      prevEndAngle = endAngle;
    }

    var getColor = function (percent) {
      // Less than 0
      if (percent <= 0) {
        return colorList[0][1];
      }

      for (var i = 0; i < colorList.length; i++) {
        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
          return colorList[i][1];
        }
      } // More than 1


      return colorList[i - 1][1];
    };

    if (!clockwise) {
      var tmp = startAngle;
      startAngle = endAngle;
      endAngle = tmp;
    }

    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);

    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);

    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);

    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
  },
  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
    var group = this.group;
    var cx = posInfo.cx;
    var cy = posInfo.cy;
    var r = posInfo.r;
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var splitLineModel = seriesModel.getModel('splitLine');
    var tickModel = seriesModel.getModel('axisTick');
    var labelModel = seriesModel.getModel('axisLabel');
    var splitNumber = seriesModel.get('splitNumber');
    var subSplitNumber = tickModel.get('splitNumber');
    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
    var tickLen = parsePercent(tickModel.get('length'), r);
    var angle = startAngle;
    var step = (endAngle - startAngle) / splitNumber;
    var subStep = step / subSplitNumber;
    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();

    for (var i = 0; i <= splitNumber; i++) {
      var unitX = Math.cos(angle);
      var unitY = Math.sin(angle); // Split line

      if (splitLineModel.get('show')) {
        var splitLine = new graphic.Line({
          shape: {
            x1: unitX * r + cx,
            y1: unitY * r + cy,
            x2: unitX * (r - splitLineLen) + cx,
            y2: unitY * (r - splitLineLen) + cy
          },
          style: splitLineStyle,
          silent: true
        });

        if (splitLineStyle.stroke === 'auto') {
          splitLine.setStyle({
            stroke: getColor(i / splitNumber)
          });
        }

        group.add(splitLine);
      } // Label


      if (labelModel.get('show')) {
        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
        var distance = labelModel.get('distance');
        var autoColor = getColor(i / splitNumber);
        group.add(new graphic.Text({
          style: graphic.setTextStyle({}, labelModel, {
            text: label,
            x: unitX * (r - splitLineLen - distance) + cx,
            y: unitY * (r - splitLineLen - distance) + cy,
            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
          }, {
            autoColor: autoColor
          }),
          silent: true
        }));
      } // Axis tick


      if (tickModel.get('show') && i !== splitNumber) {
        for (var j = 0; j <= subSplitNumber; j++) {
          var unitX = Math.cos(angle);
          var unitY = Math.sin(angle);
          var tickLine = new graphic.Line({
            shape: {
              x1: unitX * r + cx,
              y1: unitY * r + cy,
              x2: unitX * (r - tickLen) + cx,
              y2: unitY * (r - tickLen) + cy
            },
            silent: true,
            style: tickLineStyle
          });

          if (tickLineStyle.stroke === 'auto') {
            tickLine.setStyle({
              stroke: getColor((i + j / subSplitNumber) / splitNumber)
            });
          }

          group.add(tickLine);
          angle += subStep;
        }

        angle -= subStep;
      } else {
        angle += step;
      }
    }
  },
  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
    var group = this.group;
    var oldData = this._data;

    if (!seriesModel.get('pointer.show')) {
      // Remove old element
      oldData && oldData.eachItemGraphicEl(function (el) {
        group.remove(el);
      });
      return;
    }

    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
    var angleExtent = [startAngle, endAngle];
    var data = seriesModel.getData();
    data.diff(oldData).add(function (idx) {
      var pointer = new PointerPath({
        shape: {
          angle: startAngle
        }
      });
      graphic.initProps(pointer, {
        shape: {
          angle: linearMap(data.get('value', idx), valueExtent, angleExtent, true)
        }
      }, seriesModel);
      group.add(pointer);
      data.setItemGraphicEl(idx, pointer);
    }).update(function (newIdx, oldIdx) {
      var pointer = oldData.getItemGraphicEl(oldIdx);
      graphic.updateProps(pointer, {
        shape: {
          angle: linearMap(data.get('value', newIdx), valueExtent, angleExtent, true)
        }
      }, seriesModel);
      group.add(pointer);
      data.setItemGraphicEl(newIdx, pointer);
    }).remove(function (idx) {
      var pointer = oldData.getItemGraphicEl(idx);
      group.remove(pointer);
    }).execute();
    data.eachItemGraphicEl(function (pointer, idx) {
      var itemModel = data.getItemModel(idx);
      var pointerModel = itemModel.getModel('pointer');
      pointer.setShape({
        x: posInfo.cx,
        y: posInfo.cy,
        width: parsePercent(pointerModel.get('width'), posInfo.r),
        r: parsePercent(pointerModel.get('length'), posInfo.r)
      });
      pointer.useStyle(itemModel.getModel('itemStyle.normal').getItemStyle());

      if (pointer.style.fill === 'auto') {
        pointer.setStyle('fill', getColor(linearMap(data.get('value', idx), valueExtent, [0, 1], true)));
      }

      graphic.setHoverStyle(pointer, itemModel.getModel('itemStyle.emphasis').getItemStyle());
    });
    this._data = data;
  },
  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
    var titleModel = seriesModel.getModel('title');

    if (titleModel.get('show')) {
      var offsetCenter = titleModel.get('offsetCenter');
      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
      var minVal = +seriesModel.get('min');
      var maxVal = +seriesModel.get('max');
      var value = seriesModel.getData().get('value', 0);
      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
      this.group.add(new graphic.Text({
        silent: true,
        style: graphic.setTextStyle({}, titleModel, {
          x: x,
          y: y,
          // FIXME First data name ?
          text: seriesModel.getData().getName(0),
          textAlign: 'center',
          textVerticalAlign: 'middle'
        }, {
          autoColor: autoColor,
          forceRich: true
        })
      }));
    }
  },
  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
    var detailModel = seriesModel.getModel('detail');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');

    if (detailModel.get('show')) {
      var offsetCenter = detailModel.get('offsetCenter');
      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
      var width = parsePercent(detailModel.get('width'), posInfo.r);
      var height = parsePercent(detailModel.get('height'), posInfo.r);
      var value = seriesModel.getData().get('value', 0);
      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
      this.group.add(new graphic.Text({
        silent: true,
        style: graphic.setTextStyle({}, detailModel, {
          x: x,
          y: y,
          text: formatLabel( // FIXME First data name ?
          value, detailModel.get('formatter')),
          textWidth: isNaN(width) ? null : width,
          textHeight: isNaN(height) ? null : height,
          textAlign: 'center',
          textVerticalAlign: 'middle'
        }, {
          autoColor: autoColor,
          forceRich: true
        })
      }));
    }
  }
});
var _default = GaugeView;
module.exports = _default;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var _default = Path.extend({
  type: 'echartsGaugePointer',
  shape: {
    angle: 0,
    width: 10,
    r: 10,
    x: 0,
    y: 0
  },
  buildPath: function (ctx, shape) {
    var mathCos = Math.cos;
    var mathSin = Math.sin;
    var r = shape.r;
    var width = shape.width;
    var angle = shape.angle;
    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
    angle = shape.angle - Math.PI / 2;
    ctx.moveTo(x, y);
    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
    ctx.lineTo(x, y);
    return;
  }
});

module.exports = _default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1397);

__webpack_require__(1398);

__webpack_require__(1407);

var categoryFilter = __webpack_require__(1400);

var visualSymbol = __webpack_require__(106);

var categoryVisual = __webpack_require__(1401);

var edgeVisual = __webpack_require__(1404);

var simpleLayout = __webpack_require__(1408);

var circularLayout = __webpack_require__(1402);

var forceLayout = __webpack_require__(1406);

var createView = __webpack_require__(1403);

echarts.registerProcessor(categoryFilter);
echarts.registerVisual(zrUtil.curry(visualSymbol, 'graph', 'circle', null));
echarts.registerVisual(categoryVisual);
echarts.registerVisual(edgeVisual);
echarts.registerLayout(simpleLayout);
echarts.registerLayout(circularLayout);
echarts.registerLayout(forceLayout); // Graph view coordinate system

echarts.registerCoordinateSystem('graphView', {
  create: createView
});

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var List = __webpack_require__(31);

var zrUtil = __webpack_require__(0);

var _model = __webpack_require__(15);

var defaultEmphasis = _model.defaultEmphasis;

var Model = __webpack_require__(29);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;

var createGraphFromNodeEdge = __webpack_require__(448);

var GraphSeries = echarts.extendSeriesModel({
  type: 'series.graph',
  init: function (option) {
    GraphSeries.superApply(this, 'init', arguments); // Provide data for legend select

    this.legendDataProvider = function () {
      return this._categoriesData;
    };

    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  },
  mergeOption: function (option) {
    GraphSeries.superApply(this, 'mergeOption', arguments);
    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  },
  mergeDefaultAndTheme: function (option) {
    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
    defaultEmphasis(option.edgeLabel, ['show']);
  },
  getInitialData: function (option, ecModel) {
    var edges = option.edges || option.links || [];
    var nodes = option.data || option.nodes || [];
    var self = this;

    if (nodes && edges) {
      return createGraphFromNodeEdge(nodes, edges, this, true, beforeLink).data;
    }

    function beforeLink(nodeData, edgeData) {
      // Overwrite nodeData.getItemModel to
      nodeData.wrapMethod('getItemModel', function (model) {
        var categoriesModels = self._categoriesModels;
        var categoryIdx = model.getShallow('category');
        var categoryModel = categoriesModels[categoryIdx];

        if (categoryModel) {
          categoryModel.parentModel = model.parentModel;
          model.parentModel = categoryModel;
        }

        return model;
      });
      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.

      var fakeSeriesModel = new Model({
        label: edgeLabelModel.option
      }, edgeLabelModel.parentModel, ecModel);
      edgeData.wrapMethod('getItemModel', function (model) {
        model.customizeGetParent(edgeGetParent);
        return model;
      });

      function edgeGetParent(path) {
        path = this.parsePath(path);
        return path && path[0] === 'label' ? fakeSeriesModel : this.parentModel;
      }
    }
  },

  /**
   * @return {module:echarts/data/Graph}
   */
  getGraph: function () {
    return this.getData().graph;
  },

  /**
   * @return {module:echarts/data/List}
   */
  getEdgeData: function () {
    return this.getGraph().edgeData;
  },

  /**
   * @return {module:echarts/data/List}
   */
  getCategoriesData: function () {
    return this._categoriesData;
  },

  /**
   * @override
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    if (dataType === 'edge') {
      var nodeData = this.getData();
      var params = this.getDataParams(dataIndex, dataType);
      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
      var sourceName = nodeData.getName(edge.node1.dataIndex);
      var targetName = nodeData.getName(edge.node2.dataIndex);
      var html = [];
      sourceName != null && html.push(sourceName);
      targetName != null && html.push(targetName);
      html = encodeHTML(html.join(' > '));

      if (params.value) {
        html += ' : ' + encodeHTML(params.value);
      }

      return html;
    } else {
      // dataType === 'node' or empty
      return GraphSeries.superApply(this, 'formatTooltip', arguments);
    }
  },
  _updateCategoriesData: function () {
    var categories = zrUtil.map(this.option.categories || [], function (category) {
      // Data must has value
      return category.value != null ? category : zrUtil.extend({
        value: 0
      }, category);
    });
    var categoriesData = new List(['value'], this);
    categoriesData.initData(categories);
    this._categoriesData = categoriesData;
    this._categoriesModels = categoriesData.mapArray(function (idx) {
      return categoriesData.getItemModel(idx, true);
    });
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  },
  isAnimationEnabled: function () {
    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // Default option for all coordinate systems
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // geoIndex: 0,
    legendHoverLink: true,
    hoverAnimation: true,
    layout: null,
    focusNodeAdjacency: false,
    // Configuration of circular layout
    circular: {
      rotateLabel: false
    },
    // Configuration of force directed layout
    force: {
      initLayout: null,
      // Node repulsion. Can be an array to represent range.
      repulsion: [0, 50],
      gravity: 0.1,
      // Edge length. Can be an array to represent range.
      edgeLength: 30,
      layoutAnimation: true
    },
    left: 'center',
    top: 'center',
    // right: null,
    // bottom: null,
    // width: '80%',
    // height: '80%',
    symbol: 'circle',
    symbolSize: 10,
    edgeSymbol: ['none', 'none'],
    edgeSymbolSize: 10,
    edgeLabel: {
      normal: {
        position: 'middle'
      },
      emphasis: {}
    },
    draggable: false,
    roam: false,
    // Default on center of graph
    center: null,
    zoom: 1,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.6,
    // cursor: null,
    // categories: [],
    // data: []
    // Or
    // nodes: []
    //
    // links: []
    // Or
    // edges: []
    label: {
      normal: {
        show: false,
        formatter: '{b}'
      },
      emphasis: {
        show: true
      }
    },
    itemStyle: {
      normal: {},
      emphasis: {}
    },
    lineStyle: {
      normal: {
        color: '#aaa',
        width: 1,
        curveness: 0,
        opacity: 0.5
      },
      emphasis: {}
    }
  }
});
var _default = GraphSeries;
module.exports = _default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var SymbolDraw = __webpack_require__(139);

var LineDraw = __webpack_require__(272);

var RoamController = __webpack_require__(191);

var roamHelper = __webpack_require__(467);

var _cursorHelper = __webpack_require__(276);

var onIrrelevantElement = _cursorHelper.onIrrelevantElement;

var graphic = __webpack_require__(5);

var adjustEdge = __webpack_require__(1399);

var nodeOpacityPath = ['itemStyle', 'normal', 'opacity'];
var lineOpacityPath = ['lineStyle', 'normal', 'opacity'];

function getItemOpacity(item, opacityPath) {
  return item.getVisual('opacity') || item.getModel().get(opacityPath);
}

function fadeOutItem(item, opacityPath, opacityRatio) {
  var el = item.getGraphicEl();
  var opacity = getItemOpacity(item, opacityPath);

  if (opacityRatio != null) {
    opacity == null && (opacity = 1);
    opacity *= opacityRatio;
  }

  el.downplay && el.downplay();
  el.traverse(function (child) {
    if (child.type !== 'group') {
      child.setStyle('opacity', opacity);
    }
  });
}

function fadeInItem(item, opacityPath) {
  var opacity = getItemOpacity(item, opacityPath);
  var el = item.getGraphicEl();
  el.highlight && el.highlight();
  el.traverse(function (child) {
    if (child.type !== 'group') {
      child.setStyle('opacity', opacity);
    }
  });
}

var _default = echarts.extendChartView({
  type: 'graph',
  init: function (ecModel, api) {
    var symbolDraw = new SymbolDraw();
    var lineDraw = new LineDraw();
    var group = this.group;
    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: group
    };
    group.add(symbolDraw.group);
    group.add(lineDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineDraw = lineDraw;
    this._firstRender = true;
  },
  render: function (seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    this._model = seriesModel;
    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
    var symbolDraw = this._symbolDraw;
    var lineDraw = this._lineDraw;
    var group = this.group;

    if (coordSys.type === 'view') {
      var groupNewProp = {
        position: coordSys.position,
        scale: coordSys.scale
      };

      if (this._firstRender) {
        group.attr(groupNewProp);
      } else {
        graphic.updateProps(group, groupNewProp, seriesModel);
      }
    } // Fix edge contact point with node


    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
    var data = seriesModel.getData();
    symbolDraw.updateData(data);
    var edgeData = seriesModel.getEdgeData();
    lineDraw.updateData(edgeData);

    this._updateNodeAndLinkScale();

    this._updateController(seriesModel, ecModel, api);

    clearTimeout(this._layoutTimeout);
    var forceLayout = seriesModel.forceLayout;
    var layoutAnimation = seriesModel.get('force.layoutAnimation');

    if (forceLayout) {
      this._startForceLayoutIteration(forceLayout, layoutAnimation);
    }

    data.eachItemGraphicEl(function (el, idx) {
      var itemModel = data.getItemModel(idx); // Update draggable

      el.off('drag').off('dragend');
      var draggable = data.getItemModel(idx).get('draggable');

      if (draggable) {
        el.on('drag', function () {
          if (forceLayout) {
            forceLayout.warmUp();
            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
            forceLayout.setFixed(idx); // Write position back to layout

            data.setItemLayout(idx, el.position);
          }
        }, this).on('dragend', function () {
          if (forceLayout) {
            forceLayout.setUnfixed(idx);
          }
        }, this);
      }

      el.setDraggable(draggable && forceLayout);
      el.off('mouseover', el.__focusNodeAdjacency);
      el.off('mouseout', el.__unfocusNodeAdjacency);

      if (itemModel.get('focusNodeAdjacency')) {
        el.on('mouseover', el.__focusNodeAdjacency = function () {
          api.dispatchAction({
            type: 'focusNodeAdjacency',
            seriesId: seriesModel.id,
            dataIndex: el.dataIndex
          });
        });
        el.on('mouseout', el.__unfocusNodeAdjacency = function () {
          api.dispatchAction({
            type: 'unfocusNodeAdjacency',
            seriesId: seriesModel.id
          });
        });
      }
    }, this);
    data.graph.eachEdge(function (edge) {
      var el = edge.getGraphicEl();
      el.off('mouseover', el.__focusNodeAdjacency);
      el.off('mouseout', el.__unfocusNodeAdjacency);

      if (edge.getModel().get('focusNodeAdjacency')) {
        el.on('mouseover', el.__focusNodeAdjacency = function () {
          api.dispatchAction({
            type: 'focusNodeAdjacency',
            seriesId: seriesModel.id,
            edgeDataIndex: edge.dataIndex
          });
        });
        el.on('mouseout', el.__unfocusNodeAdjacency = function () {
          api.dispatchAction({
            type: 'unfocusNodeAdjacency',
            seriesId: seriesModel.id
          });
        });
      }
    });
    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
    var cx = data.getLayout('cx');
    var cy = data.getLayout('cy');
    data.eachItemGraphicEl(function (el, idx) {
      var symbolPath = el.getSymbolPath();

      if (circularRotateLabel) {
        var pos = data.getItemLayout(idx);
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);

        if (rad < 0) {
          rad = Math.PI * 2 + rad;
        }

        var isLeft = pos[0] < cx;

        if (isLeft) {
          rad = rad - Math.PI;
        }

        var textPosition = isLeft ? 'left' : 'right';
        symbolPath.setStyle({
          textRotation: -rad,
          textPosition: textPosition,
          textOrigin: 'center'
        });
        symbolPath.hoverStyle && (symbolPath.hoverStyle.textPosition = textPosition);
      } else {
        symbolPath.setStyle({
          textRotation: 0
        });
      }
    });
    this._firstRender = false;
  },
  dispose: function () {
    this._controller && this._controller.dispose();
    this._controllerHost = {};
  },
  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var data = this._model.getData();

    var graph = data.graph;
    var dataIndex = payload.dataIndex;
    var edgeDataIndex = payload.edgeDataIndex;
    var node = graph.getNodeByIndex(dataIndex);
    var edge = graph.getEdgeByIndex(edgeDataIndex);

    if (!node && !edge) {
      return;
    }

    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath, 0.1);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath, 0.1);
    });

    if (node) {
      fadeInItem(node, nodeOpacityPath);
      zrUtil.each(node.edges, function (adjacentEdge) {
        if (adjacentEdge.dataIndex < 0) {
          return;
        }

        fadeInItem(adjacentEdge, lineOpacityPath);
        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
      });
    }

    if (edge) {
      fadeInItem(edge, lineOpacityPath);
      fadeInItem(edge.node1, nodeOpacityPath);
      fadeInItem(edge.node2, nodeOpacityPath);
    }
  },
  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
    var graph = this._model.getData().graph;

    graph.eachNode(function (node) {
      fadeOutItem(node, nodeOpacityPath);
    });
    graph.eachEdge(function (edge) {
      fadeOutItem(edge, lineOpacityPath);
    });
  },
  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
    var self = this;

    (function step() {
      forceLayout.step(function (stopped) {
        self.updateLayout(self._model);
        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
      });
    })();
  },
  _updateController: function (seriesModel, ecModel, api) {
    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
    });

    if (seriesModel.coordinateSystem.type !== 'view') {
      controller.disable();
      return;
    }

    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (dx, dy) {
      roamHelper.updateViewOnPan(controllerHost, dx, dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        dx: dx,
        dy: dy
      });
    }).on('zoom', function (zoom, mouseX, mouseY) {
      roamHelper.updateViewOnZoom(controllerHost, zoom, mouseX, mouseY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        zoom: zoom,
        originX: mouseX,
        originY: mouseY
      });

      this._updateNodeAndLinkScale();

      adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));

      this._lineDraw.updateLayout();
    }, this);
  },
  _updateNodeAndLinkScale: function () {
    var seriesModel = this._model;
    var data = seriesModel.getData();

    var nodeScale = this._getNodeGlobalScale(seriesModel);

    var invScale = [nodeScale, nodeScale];
    data.eachItemGraphicEl(function (el, idx) {
      el.attr('scale', invScale);
    });
  },
  _getNodeGlobalScale: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type !== 'view') {
      return 1;
    }

    var nodeScaleRatio = this._nodeScaleRatio;
    var groupScale = coordSys.scale;
    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes

    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
  },
  updateLayout: function (seriesModel) {
    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));

    this._symbolDraw.updateLayout();

    this._lineDraw.updateLayout();
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove();
    this._lineDraw && this._lineDraw.remove();
  }
});

module.exports = _default;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var curveTool = __webpack_require__(88);

var vec2 = __webpack_require__(19);

var v1 = [];
var v2 = [];
var v3 = [];
var quadraticAt = curveTool.quadraticAt;
var v2DistSquare = vec2.distSquare;
var mathAbs = Math.abs;

function intersectCurveCircle(curvePoints, center, radius) {
  var p0 = curvePoints[0];
  var p1 = curvePoints[1];
  var p2 = curvePoints[2];
  var d = Infinity;
  var t;
  var radiusSquare = radius * radius;
  var interval = 0.1;

  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);

    if (diff < d) {
      d = diff;
      t = _t;
    }
  } // Assume the segment is monotone，Find root through Bisection method
  // At most 32 iteration


  for (var i = 0; i < 32; i++) {
    // var prev = t - interval;
    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);

    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
    var diff = v2DistSquare(v2, center) - radiusSquare;

    if (mathAbs(diff) < 1e-2) {
      break;
    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;


    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
    interval /= 2;

    if (diff < 0) {
      if (nextDiff >= 0) {
        t = t + interval;
      } else {
        t = t - interval;
      }
    } else {
      if (nextDiff >= 0) {
        t = t - interval;
      } else {
        t = t + interval;
      }
    }
  }

  return t;
} // Adjust edge to avoid


function _default(graph, scale) {
  var tmp0 = [];
  var quadraticSubdivide = curveTool.quadraticSubdivide;
  var pts = [[], [], []];
  var pts2 = [[], []];
  var v = [];
  scale /= 2;

  function getSymbolSize(node) {
    var symbolSize = node.getVisual('symbolSize');

    if (symbolSize instanceof Array) {
      symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    }

    return symbolSize;
  }

  graph.eachEdge(function (edge, idx) {
    var linePoints = edge.getLayout();
    var fromSymbol = edge.getVisual('fromSymbol');
    var toSymbol = edge.getVisual('toSymbol');

    if (!linePoints.__original) {
      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];

      if (linePoints[2]) {
        linePoints.__original.push(vec2.clone(linePoints[2]));
      }
    }

    var originalPoints = linePoints.__original; // Quadratic curve

    if (linePoints[2] != null) {
      vec2.copy(pts[0], originalPoints[0]);
      vec2.copy(pts[1], originalPoints[2]);
      vec2.copy(pts[2], originalPoints[1]);

      if (fromSymbol && fromSymbol != 'none') {
        var symbolSize = getSymbolSize(edge.node1);
        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[0][0] = tmp0[3];
        pts[1][0] = tmp0[4];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[0][1] = tmp0[3];
        pts[1][1] = tmp0[4];
      }

      if (toSymbol && toSymbol != 'none') {
        var symbolSize = getSymbolSize(edge.node2);
        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[1][0] = tmp0[1];
        pts[2][0] = tmp0[2];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[1][1] = tmp0[1];
        pts[2][1] = tmp0[2];
      } // Copy back to layout


      vec2.copy(linePoints[0], pts[0]);
      vec2.copy(linePoints[1], pts[2]);
      vec2.copy(linePoints[2], pts[1]);
    } // Line
    else {
        vec2.copy(pts2[0], originalPoints[0]);
        vec2.copy(pts2[1], originalPoints[1]);
        vec2.sub(v, pts2[1], pts2[0]);
        vec2.normalize(v, v);

        if (fromSymbol && fromSymbol != 'none') {
          var symbolSize = getSymbolSize(edge.node1);
          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
        }

        if (toSymbol && toSymbol != 'none') {
          var symbolSize = getSymbolSize(edge.node2);
          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
        }

        vec2.copy(linePoints[0], pts2[0]);
        vec2.copy(linePoints[1], pts2[1]);
      }
  });
}

module.exports = _default;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var categoriesData = graphSeries.getCategoriesData();
    var graph = graphSeries.getGraph();
    var data = graph.data;
    var categoryNames = categoriesData.mapArray(categoriesData.getName);
    data.filterSelf(function (idx) {
      var model = data.getItemModel(idx);
      var category = model.getShallow('category');

      if (category != null) {
        if (typeof category === 'number') {
          category = categoryNames[category];
        } // If in any legend component the status is not selected.


        for (var i = 0; i < legendModels.length; i++) {
          if (!legendModels[i].isSelected(category)) {
            return false;
          }
        }
      }

      return true;
    });
  }, this);
}

module.exports = _default;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

function _default(ecModel) {
  var paletteScope = {};
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var categoriesData = seriesModel.getCategoriesData();
    var data = seriesModel.getData();
    var categoryNameIdxMap = {};
    categoriesData.each(function (idx) {
      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.

      categoryNameIdxMap['ec-' + name] = idx;
      var itemModel = categoriesData.getItemModel(idx);
      var color = itemModel.get('itemStyle.normal.color') || seriesModel.getColorFromPalette(name, paletteScope);
      categoriesData.setItemVisual(idx, 'color', color);
    }); // Assign category color to visual

    if (categoriesData.count()) {
      data.each(function (idx) {
        var model = data.getItemModel(idx);
        var category = model.getShallow('category');

        if (category != null) {
          if (typeof category === 'string') {
            category = categoryNameIdxMap['ec-' + category];
          }

          if (!data.getItemVisual(idx, 'color', true)) {
            data.setItemVisual(idx, 'color', categoriesData.getItemVisual(category, 'color'));
          }
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var _circularLayoutHelper = __webpack_require__(444);

var circularLayout = _circularLayoutHelper.circularLayout;

function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    if (seriesModel.get('layout') === 'circular') {
      circularLayout(seriesModel);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var View = __webpack_require__(479);

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;

var bbox = __webpack_require__(320);

// FIXME Where to create the simple view coordinate system
function getViewRect(seriesModel, api, aspect) {
  var option = seriesModel.getBoxLayoutParams();
  option.aspect = aspect;
  return getLayoutRect(option, {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function _default(ecModel, api) {
  var viewList = [];
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var coordSysType = seriesModel.get('coordinateSystem');

    if (!coordSysType || coordSysType === 'view') {
      var data = seriesModel.getData();
      var positions = data.mapArray(function (idx) {
        var itemModel = data.getItemModel(idx);
        return [+itemModel.get('x'), +itemModel.get('y')];
      });
      var min = [];
      var max = [];
      bbox.fromPoints(positions, min, max); // If width or height is 0

      if (max[0] - min[0] === 0) {
        max[0] += 1;
        min[0] -= 1;
      }

      if (max[1] - min[1] === 0) {
        max[1] += 1;
        min[1] -= 1;
      }

      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?

      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead

      if (isNaN(aspect)) {
        min = [viewRect.x, viewRect.y];
        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
      }

      var bbWidth = max[0] - min[0];
      var bbHeight = max[1] - min[1];
      var viewWidth = viewRect.width;
      var viewHeight = viewRect.height;
      var viewCoordSys = seriesModel.coordinateSystem = new View();
      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info

      viewCoordSys.setCenter(seriesModel.get('center'));
      viewCoordSys.setZoom(seriesModel.get('zoom'));
      viewList.push(viewCoordSys);
    }
  });
  return viewList;
}

module.exports = _default;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var edgeData = seriesModel.getEdgeData();
    var symbolType = normalize(seriesModel.get('edgeSymbol'));
    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
    var colorQuery = 'lineStyle.normal.color'.split('.');
    var opacityQuery = 'lineStyle.normal.opacity'.split('.');
    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    edgeData.setVisual('color', seriesModel.get(colorQuery));
    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
    edgeData.each(function (idx) {
      var itemModel = edgeData.getItemModel(idx);
      var edge = graph.getEdgeByIndex(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual

      var color = itemModel.get(colorQuery);
      var opacity = itemModel.get(opacityQuery);

      switch (color) {
        case 'source':
          color = edge.node1.getVisual('color');
          break;

        case 'target':
          color = edge.node2.getVisual('color');
          break;
      }

      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
      edge.setVisual('color', color);
      edge.setVisual('opacity', opacity);
    });
  });
}

module.exports = _default;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(19);

var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
//     return e.n1 === n ? e.n2 : e.n1;
// }

function forceLayout(nodes, edges, opts) {
  var rect = opts.rect;
  var width = rect.width;
  var height = rect.height;
  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;

  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
  //     var e = edges[i];
  //     var n1 = e.n1;
  //     var n2 = e.n2;
  //     n1.edges = n1.edges || [];
  //     n2.edges = n2.edges || [];
  //     n1.edges.push(e);
  //     n2.edges.push(e);
  // }
  // Init position

  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];

    if (!n.p) {
      // Use the position from first adjecent node with defined position
      // Or use a random position
      // From d3
      // if (n.edges) {
      //     var j = -1;
      //     while (++j < n.edges.length) {
      //         var e = n.edges[j];
      //         var other = adjacentNode(n, e);
      //         if (other.p) {
      //             n.p = vec2.clone(other.p);
      //             break;
      //         }
      //     }
      // }
      // if (!n.p) {
      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]); // }
    }

    n.pp = vec2.clone(n.p);
    n.edges = null;
  } // Formula in 'Graph Drawing by Force-directed Placement'
  // var k = scale * Math.sqrt(width * height / nodes.length);
  // var k2 = k * k;


  var friction = 0.6;
  return {
    warmUp: function () {
      friction = 0.5;
    },
    setFixed: function (idx) {
      nodes[idx].fixed = true;
    },
    setUnfixed: function (idx) {
      nodes[idx].fixed = false;
    },
    step: function (cb) {
      var v12 = [];
      var nLen = nodes.length;

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];
        var n1 = e.n1;
        var n2 = e.n2;
        vec2.sub(v12, n2.p, n1.p);
        var d = vec2.len(v12) - e.d;
        var w = n2.w / (n1.w + n2.w);

        if (isNaN(w)) {
          w = 0;
        }

        vec2.normalize(v12, v12);
        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
      } // Gravity


      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
          // vec2.scale(v12, v12, 1 / d);
          // var gravityFactor = gravity;

          scaleAndAdd(n.p, n.p, v12, gravity * friction);
        }
      } // Repulsive
      // PENDING


      for (var i = 0; i < nLen; i++) {
        var n1 = nodes[i];

        for (var j = i + 1; j < nLen; j++) {
          var n2 = nodes[j];
          vec2.sub(v12, n2.p, n1.p);
          var d = vec2.len(v12);

          if (d === 0) {
            // Random repulse
            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
            d = 1;
          }

          var repFact = (n1.rep + n2.rep) / d / d;
          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
        }
      }

      var v = [];

      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          vec2.sub(v, n.p, n.pp);
          scaleAndAdd(n.p, n.p, v, friction);
          vec2.copy(n.pp, n.p);
        }
      }

      friction = friction * 0.992;
      cb && cb(nodes, edges, friction < 0.01);
    }
  };
}

exports.forceLayout = forceLayout;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

var _forceHelper = __webpack_require__(1405);

var forceLayout = _forceHelper.forceLayout;

var _simpleLayoutHelper = __webpack_require__(445);

var simpleLayout = _simpleLayoutHelper.simpleLayout;

var _circularLayoutHelper = __webpack_require__(444);

var circularLayout = _circularLayoutHelper.circularLayout;

var _number = __webpack_require__(8);

var linearMap = _number.linearMap;

var vec2 = __webpack_require__(19);

var zrUtil = __webpack_require__(0);

function _default(ecModel) {
  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var coordSys = graphSeries.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      return;
    }

    if (graphSeries.get('layout') === 'force') {
      var preservedPoints = graphSeries.preservedPoints || {};
      var graph = graphSeries.getGraph();
      var nodeData = graph.data;
      var edgeData = graph.edgeData;
      var forceModel = graphSeries.getModel('force');
      var initLayout = forceModel.get('initLayout');

      if (graphSeries.preservedPoints) {
        nodeData.each(function (idx) {
          var id = nodeData.getId(idx);
          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
        });
      } else if (!initLayout || initLayout === 'none') {
        simpleLayout(graphSeries);
      } else if (initLayout === 'circular') {
        circularLayout(graphSeries);
      }

      var nodeDataExtent = nodeData.getDataExtent('value');
      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');

      var repulsion = forceModel.get('repulsion');
      var edgeLength = forceModel.get('edgeLength');

      if (!zrUtil.isArray(repulsion)) {
        repulsion = [repulsion, repulsion];
      }

      if (!zrUtil.isArray(edgeLength)) {
        edgeLength = [edgeLength, edgeLength];
      } // Larger value has smaller length


      edgeLength = [edgeLength[1], edgeLength[0]];
      var nodes = nodeData.mapArray('value', function (value, idx) {
        var point = nodeData.getItemLayout(idx);
        var rep = linearMap(value, nodeDataExtent, repulsion);

        if (isNaN(rep)) {
          rep = (repulsion[0] + repulsion[1]) / 2;
        }

        return {
          w: rep,
          rep: rep,
          fixed: nodeData.getItemModel(idx).get('fixed'),
          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
        };
      });
      var edges = edgeData.mapArray('value', function (value, idx) {
        var edge = graph.getEdgeByIndex(idx);
        var d = linearMap(value, edgeDataExtent, edgeLength);

        if (isNaN(d)) {
          d = (edgeLength[0] + edgeLength[1]) / 2;
        }

        return {
          n1: nodes[edge.node1.dataIndex],
          n2: nodes[edge.node2.dataIndex],
          d: d,
          curveness: edge.getModel().get('lineStyle.normal.curveness') || 0
        };
      });
      var coordSys = graphSeries.coordinateSystem;
      var rect = coordSys.getBoundingRect();
      var forceInstance = forceLayout(nodes, edges, {
        rect: rect,
        gravity: forceModel.get('gravity')
      });
      var oldStep = forceInstance.step;

      forceInstance.step = function (cb) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (nodes[i].fixed) {
            // Write back to layout instance
            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
          }
        }

        oldStep(function (nodes, edges, stopped) {
          for (var i = 0, l = nodes.length; i < l; i++) {
            if (!nodes[i].fixed) {
              graph.getNodeByIndex(i).setLayout(nodes[i].p);
            }

            preservedPoints[nodeData.getId(i)] = nodes[i].p;
          }

          for (var i = 0, l = edges.length; i < l; i++) {
            var e = edges[i];
            var edge = graph.getEdgeByIndex(i);
            var p1 = e.n1.p;
            var p2 = e.n2.p;
            var points = edge.getLayout();
            points = points ? points.slice() : [];
            points[0] = points[0] || [];
            points[1] = points[1] || [];
            vec2.copy(points[0], p1);
            vec2.copy(points[1], p2);

            if (+e.curveness) {
              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
            }

            edge.setLayout(points);
          } // Update layout


          cb && cb(stopped);
        });
      };

      graphSeries.forceLayout = forceInstance;
      graphSeries.preservedPoints = preservedPoints; // Step to get the layout

      forceInstance.step();
    } else {
      // Remove prev injected forceLayout instance
      graphSeries.forceLayout = null;
    }
  });
}

module.exports = _default;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var _roamHelper = __webpack_require__(441);

var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
var actionInfo = {
  type: 'graphRoam',
  event: 'graphRoam',
  update: 'none'
};
/**
 * @payload
 * @property {string} name Series name
 * @property {number} [dx]
 * @property {number} [dy]
 * @property {number} [zoom]
 * @property {number} [originX]
 * @property {number} [originY]
 */

echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    query: payload
  }, function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var res = updateCenterAndZoom(coordSys, payload);
    seriesModel.setCenter && seriesModel.setCenter(res.center);
    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
  });
});
/**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 * @property {number} [dataIndex]
 */

echarts.registerAction({
  type: 'focusNodeAdjacency',
  event: 'focusNodeAdjacency',
  update: 'series.graph:focusNodeAdjacency'
}, function () {});
/**
 * @payload
 * @property {number} [seriesIndex]
 * @property {string} [seriesId]
 * @property {string} [seriesName]
 */

echarts.registerAction({
  type: 'unfocusNodeAdjacency',
  event: 'unfocusNodeAdjacency',
  update: 'series.graph:unfocusNodeAdjacency'
}, function () {});

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var _simpleLayoutHelper = __webpack_require__(445);

var simpleLayout = _simpleLayoutHelper.simpleLayout;
var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;

function _default(ecModel, api) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var layout = seriesModel.get('layout');
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      var data = seriesModel.getData();
      var dimensions = coordSys.dimensions;
      data.each(dimensions, function () {
        var hasValue;
        var args = arguments;
        var value = [];

        for (var i = 0; i < dimensions.length; i++) {
          if (!isNaN(args[i])) {
            hasValue = true;
          }

          value.push(args[i]);
        }

        var idx = args[args.length - 1];

        if (hasValue) {
          data.setItemLayout(idx, coordSys.dataToPoint(value));
        } else {
          // Also {Array.<number>}, not undefined to avoid if...else... statement
          data.setItemLayout(idx, [NaN, NaN]);
        }
      });
      simpleLayoutEdge(data.graph);
    } else if (!layout || layout === 'none') {
      simpleLayout(seriesModel);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1411);

__webpack_require__(1412);

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * @file defines echarts Heatmap Chart
 * @author Ovilia (me@zhangwenli.com)
 * Inspired by https://github.com/mourner/simpleheat
 *
 * @module
 */
var GRADIENT_LEVELS = 256;
/**
 * Heatmap Chart
 *
 * @class
 */

function Heatmap() {
  var canvas = zrUtil.createCanvas();
  this.canvas = canvas;
  this.blurSize = 30;
  this.pointSize = 20;
  this.maxOpacity = 1;
  this.minOpacity = 0;
  this._gradientPixels = {};
}

Heatmap.prototype = {
  /**
   * Renders Heatmap and returns the rendered canvas
   * @param {Array} data array of data, each has x, y, value
   * @param {number} width canvas width
   * @param {number} height canvas height
   */
  update: function (data, width, height, normalize, colorFunc, isInRange) {
    var brush = this._getBrush();

    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');

    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');

    var r = this.pointSize + this.blurSize;
    var canvas = this.canvas;
    var ctx = canvas.getContext('2d');
    var len = data.length;
    canvas.width = width;
    canvas.height = height;

    for (var i = 0; i < len; ++i) {
      var p = data[i];
      var x = p[0];
      var y = p[1];
      var value = p[2]; // calculate alpha using value

      var alpha = normalize(value); // draw with the circle brush with alpha

      ctx.globalAlpha = alpha;
      ctx.drawImage(brush, x - r, y - r);
    }

    if (!canvas.width || !canvas.height) {
      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
      // 'CanvasRenderingContext2D': The source height is 0."
      return canvas;
    } // colorize the canvas using alpha value and set with gradient


    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var offset = 0;
    var pixelLen = pixels.length;
    var minOpacity = this.minOpacity;
    var maxOpacity = this.maxOpacity;
    var diffOpacity = maxOpacity - minOpacity;

    while (offset < pixelLen) {
      var alpha = pixels[offset + 3] / 256;
      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data

      if (alpha > 0) {
        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]

        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
        pixels[offset++] = gradient[gradientOffset];
        pixels[offset++] = gradient[gradientOffset + 1];
        pixels[offset++] = gradient[gradientOffset + 2];
        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
      } else {
        offset += 4;
      }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  },

  /**
   * get canvas of a black circle brush used for canvas to draw later
   * @private
   * @returns {Object} circle brush canvas
   */
  _getBrush: function () {
    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size

    var r = this.pointSize + this.blurSize;
    var d = r * 2;
    brushCanvas.width = d;
    brushCanvas.height = d;
    var ctx = brushCanvas.getContext('2d');
    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
    // draw the distinct circle in an invisible place,
    // and use shadowOffset to draw shadow in the center of the canvas

    ctx.shadowOffsetX = d;
    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
    // color in color map

    ctx.shadowColor = '#000'; // draw circle in the left to the canvas

    ctx.beginPath();
    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
    return brushCanvas;
  },

  /**
   * get gradient color map
   * @private
   */
  _getGradient: function (data, colorFunc, state) {
    var gradientPixels = this._gradientPixels;
    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
    var color = [0, 0, 0, 0];
    var off = 0;

    for (var i = 0; i < 256; i++) {
      colorFunc[state](i / 255, true, color);
      pixelsSingleState[off++] = color[0];
      pixelsSingleState[off++] = color[1];
      pixelsSingleState[off++] = color[2];
      pixelsSingleState[off++] = color[3];
    }

    return pixelsSingleState;
  }
};
var _default = Heatmap;
module.exports = _default;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(35);

var createListFromArray = __webpack_require__(84);

var _default = SeriesModel.extend({
  type: 'series.heatmap',
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  defaultOption: {
    // Cartesian2D or geo
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Geo coordinate system
    geoIndex: 0,
    blurSize: 30,
    pointSize: 20,
    maxOpacity: 1,
    minOpacity: 0
  }
});

module.exports = _default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var graphic = __webpack_require__(5);

var HeatmapLayer = __webpack_require__(1410);

var zrUtil = __webpack_require__(0);

function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  pieceList = zrUtil.map(pieceList, function (piece) {
    return {
      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
    };
  });
  var len = pieceList.length;
  var lastIndex = 0;
  return function (val) {
    // Try to find in the location of the last found
    for (var i = lastIndex; i < len; i++) {
      var interval = pieceList[i].interval;

      if (interval[0] <= val && val <= interval[1]) {
        lastIndex = i;
        break;
      }
    }

    if (i === len) {
      // Not found, back interation
      for (var i = lastIndex - 1; i >= 0; i--) {
        var interval = pieceList[i].interval;

        if (interval[0] <= val && val <= interval[1]) {
          lastIndex = i;
          break;
        }
      }
    }

    return i >= 0 && i < len && selected[i];
  };
}

function getIsInContinuousRange(dataExtent, range) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
  return function (val) {
    return val >= range[0] && val <= range[1];
  };
}

function isGeoCoordSys(coordSys) {
  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended

  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}

var _default = echarts.extendChartView({
  type: 'heatmap',
  render: function (seriesModel, ecModel, api) {
    var visualMapOfThisSeries;
    ecModel.eachComponent('visualMap', function (visualMap) {
      visualMap.eachTargetSeries(function (targetSeries) {
        if (targetSeries === seriesModel) {
          visualMapOfThisSeries = visualMap;
        }
      });
    });
    this.group.removeAll();
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
      this._renderOnCartesianAndCalendar(coordSys, seriesModel, api);
    } else if (isGeoCoordSys(coordSys)) {
      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    }
  },
  dispose: function () {},
  _renderOnCartesianAndCalendar: function (coordSys, seriesModel, api) {
    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var width = xAxis.getBandWidth();
      var height = yAxis.getBandWidth();
    }

    var group = this.group;
    var data = seriesModel.getData();
    var itemStyleQuery = 'itemStyle.normal';
    var hoverItemStyleQuery = 'itemStyle.emphasis';
    var labelQuery = 'label.normal';
    var hoverLabelQuery = 'label.emphasis';
    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
    var labelModel = seriesModel.getModel('label.normal');
    var hoverLabelModel = seriesModel.getModel('label.emphasis');
    var coordSysType = coordSys.type;
    var dataDims = coordSysType === 'cartesian2d' ? [seriesModel.coordDimToDataDim('x')[0], seriesModel.coordDimToDataDim('y')[0], seriesModel.coordDimToDataDim('value')[0]] : [seriesModel.coordDimToDataDim('time')[0], seriesModel.coordDimToDataDim('value')[0]];
    data.each(function (idx) {
      var rect;

      if (coordSysType === 'cartesian2d') {
        // Ignore empty data
        if (isNaN(data.get(dataDims[2], idx))) {
          return;
        }

        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
        rect = new graphic.Rect({
          shape: {
            x: point[0] - width / 2,
            y: point[1] - height / 2,
            width: width,
            height: height
          },
          style: {
            fill: data.getItemVisual(idx, 'color'),
            opacity: data.getItemVisual(idx, 'opacity')
          }
        });
      } else {
        // Ignore empty data
        if (isNaN(data.get(dataDims[1], idx))) {
          return;
        }

        rect = new graphic.Rect({
          z2: 1,
          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
          style: {
            fill: data.getItemVisual(idx, 'color'),
            opacity: data.getItemVisual(idx, 'opacity')
          }
        });
      }

      var itemModel = data.getItemModel(idx); // Optimization for large datset

      if (data.hasItemOption) {
        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
        labelModel = itemModel.getModel(labelQuery);
        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
      }

      var rawValue = seriesModel.getRawValue(idx);
      var defaultText = '-';

      if (rawValue && rawValue[2] != null) {
        defaultText = rawValue[2];
      }

      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
        labelFetcher: seriesModel,
        labelDataIndex: idx,
        defaultText: defaultText,
        isRectText: true
      });
      rect.setStyle(style);
      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
      group.add(rect);
      data.setItemGraphicEl(idx, rect);
    });
  },
  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
    //     throw new Error('Data range must have color visuals');
    // }

    var data = seriesModel.getData();
    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
    hmLayer.blurSize = seriesModel.get('blurSize');
    hmLayer.pointSize = seriesModel.get('pointSize');
    hmLayer.minOpacity = seriesModel.get('minOpacity');
    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
    var rect = geo.getViewRect().clone();
    var roamTransform = geo.getRoamTransform().transform;
    rect.applyTransform(roamTransform); // Clamp on viewport

    var x = Math.max(rect.x, 0);
    var y = Math.max(rect.y, 0);
    var x2 = Math.min(rect.width + rect.x, api.getWidth());
    var y2 = Math.min(rect.height + rect.y, api.getHeight());
    var width = x2 - x;
    var height = y2 - y;
    var points = data.mapArray(['lng', 'lat', 'value'], function (lng, lat, value) {
      var pt = geo.dataToPoint([lng, lat]);
      pt[0] -= x;
      pt[1] -= y;
      pt.push(value);
      return pt;
    });
    var dataExtent = visualMapModel.getExtent();
    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
      inRange: inRangeVisuals.color.getColorMapper(),
      outOfRange: outOfRangeVisuals.color.getColorMapper()
    }, isInRange);
    var img = new graphic.Image({
      style: {
        width: width,
        height: height,
        x: x,
        y: y,
        image: hmLayer.canvas
      },
      silent: true
    });
    this.group.add(img);
  }
});

module.exports = _default;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var Polyline = __webpack_require__(447);

var zrUtil = __webpack_require__(0);

var EffectLine = __webpack_require__(446);

var vec2 = __webpack_require__(19);

/**
 * Provide effect for line
 * @module echarts/chart/helper/EffectLine
 */

/**
 * @constructor
 * @extends {module:echarts/chart/helper/EffectLine}
 * @alias {module:echarts/chart/helper/Polyline}
 */
function EffectPolyline(lineData, idx, seriesScope) {
  EffectLine.call(this, lineData, idx, seriesScope);
  this._lastFrame = 0;
  this._lastFramePercent = 0;
}

var effectPolylineProto = EffectPolyline.prototype; // Overwrite

effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
  return new Polyline(lineData, idx, seriesScope);
}; // Overwrite


effectPolylineProto.updateAnimationPoints = function (symbol, points) {
  this._points = points;
  var accLenArr = [0];
  var len = 0;

  for (var i = 1; i < points.length; i++) {
    var p1 = points[i - 1];
    var p2 = points[i];
    len += vec2.dist(p1, p2);
    accLenArr.push(len);
  }

  if (len === 0) {
    return;
  }

  for (var i = 0; i < accLenArr.length; i++) {
    accLenArr[i] /= len;
  }

  this._offsets = accLenArr;
  this._length = len;
}; // Overwrite


effectPolylineProto.getLineLength = function (symbol) {
  return this._length;
}; // Overwrite


effectPolylineProto.updateSymbolPosition = function (symbol) {
  var t = symbol.__t;
  var points = this._points;
  var offsets = this._offsets;
  var len = points.length;

  if (!offsets) {
    // Has length 0
    return;
  }

  var lastFrame = this._lastFrame;
  var frame;

  if (t < this._lastFramePercent) {
    // Start from the next frame
    // PENDING start from lastFrame ?
    var start = Math.min(lastFrame + 1, len - 1);

    for (frame = start; frame >= 0; frame--) {
      if (offsets[frame] <= t) {
        break;
      }
    } // PENDING really need to do this ?


    frame = Math.min(frame, len - 2);
  } else {
    for (var frame = lastFrame; frame < len; frame++) {
      if (offsets[frame] > t) {
        break;
      }
    }

    frame = Math.min(frame - 1, len - 2);
  }

  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
  var tx = points[frame + 1][0] - points[frame][0];
  var ty = points[frame + 1][1] - points[frame][1];
  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
  this._lastFrame = frame;
  this._lastFramePercent = t;
  symbol.ignore = false;
};

zrUtil.inherits(EffectPolyline, EffectLine);
var _default = EffectPolyline;
module.exports = _default;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var _graphic = __webpack_require__(5);

var Group = _graphic.Group;

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

var SymbolClz = __webpack_require__(187);

/**
 * Symbol with ripple effect
 * @module echarts/chart/helper/EffectSymbol
 */
var EFFECT_RIPPLE_NUMBER = 3;

function normalizeSymbolSize(symbolSize) {
  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return symbolSize;
}

function updateRipplePath(rippleGroup, effectCfg) {
  rippleGroup.eachChild(function (ripplePath) {
    ripplePath.attr({
      z: effectCfg.z,
      zlevel: effectCfg.zlevel,
      style: {
        stroke: effectCfg.brushType === 'stroke' ? effectCfg.color : null,
        fill: effectCfg.brushType === 'fill' ? effectCfg.color : null
      }
    });
  });
}
/**
 * @constructor
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */


function EffectSymbol(data, idx) {
  Group.call(this);
  var symbol = new SymbolClz(data, idx);
  var rippleGroup = new Group();
  this.add(symbol);
  this.add(rippleGroup);

  rippleGroup.beforeUpdate = function () {
    this.attr(symbol.getScale());
  };

  this.updateData(data, idx);
}

var effectSymbolProto = EffectSymbol.prototype;

effectSymbolProto.stopEffectAnimation = function () {
  this.childAt(1).removeAll();
};

effectSymbolProto.startEffectAnimation = function (effectCfg) {
  var symbolType = effectCfg.symbolType;
  var color = effectCfg.color;
  var rippleGroup = this.childAt(1);

  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
    // var ripplePath = createSymbol(
    //     symbolType, -0.5, -0.5, 1, 1, color
    // );
    // If width/height are set too small (e.g., set to 1) on ios10
    // and macOS Sierra, a circle stroke become a rect, no matter what
    // the scale is set. So we set width/height as 2. See #4136.
    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
    ripplePath.attr({
      style: {
        strokeNoScale: true
      },
      z2: 99,
      silent: true,
      scale: [0.5, 0.5]
    });
    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period

    ripplePath.animate('', true).when(effectCfg.period, {
      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
    }).delay(delay).start();
    ripplePath.animateStyle(true).when(effectCfg.period, {
      opacity: 0
    }).delay(delay).start();
    rippleGroup.add(ripplePath);
  }

  updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Update effect symbol
 */


effectSymbolProto.updateEffectAnimation = function (effectCfg) {
  var oldEffectCfg = this._effectCfg;
  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed

  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];

  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
    var propName = DIFFICULT_PROPS[i];

    if (oldEffectCfg[propName] !== effectCfg[propName]) {
      this.stopEffectAnimation();
      this.startEffectAnimation(effectCfg);
      return;
    }
  }

  updateRipplePath(rippleGroup, effectCfg);
};
/**
 * Highlight symbol
 */


effectSymbolProto.highlight = function () {
  this.trigger('emphasis');
};
/**
 * Downplay symbol
 */


effectSymbolProto.downplay = function () {
  this.trigger('normal');
};
/**
 * Update symbol properties
 * @param  {module:echarts/data/List} data
 * @param  {number} idx
 */


effectSymbolProto.updateData = function (data, idx) {
  var seriesModel = data.hostModel;
  this.childAt(0).updateData(data, idx);
  var rippleGroup = this.childAt(1);
  var itemModel = data.getItemModel(idx);
  var symbolType = data.getItemVisual(idx, 'symbol');
  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
  var color = data.getItemVisual(idx, 'color');
  rippleGroup.attr('scale', symbolSize);
  rippleGroup.traverse(function (ripplePath) {
    ripplePath.attr({
      fill: color
    });
  });
  var symbolOffset = itemModel.getShallow('symbolOffset');

  if (symbolOffset) {
    var pos = rippleGroup.position;
    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
  }

  rippleGroup.rotation = (itemModel.getShallow('symbolRotate') || 0) * Math.PI / 180 || 0;
  var effectCfg = {};
  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
  effectCfg.effectOffset = idx / data.count();
  effectCfg.z = itemModel.getShallow('z') || 0;
  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
  effectCfg.symbolType = symbolType;
  effectCfg.color = color;
  this.off('mouseover').off('mouseout').off('emphasis').off('normal');

  if (effectCfg.showEffectOn === 'render') {
    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
    this._effectCfg = effectCfg;
  } else {
    // Not keep old effect config
    this._effectCfg = null;
    this.stopEffectAnimation();
    var symbol = this.childAt(0);

    var onEmphasis = function () {
      symbol.highlight();

      if (effectCfg.showEffectOn !== 'render') {
        this.startEffectAnimation(effectCfg);
      }
    };

    var onNormal = function () {
      symbol.downplay();

      if (effectCfg.showEffectOn !== 'render') {
        this.stopEffectAnimation();
      }
    };

    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
  }

  this._effectCfg = effectCfg;
};

effectSymbolProto.fadeOut = function (cb) {
  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
  cb && cb();
};

zrUtil.inherits(EffectSymbol, Group);
var _default = EffectSymbol;
module.exports = _default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var lineContain = __webpack_require__(685);

var quadraticContain = __webpack_require__(687);

// TODO Batch by color
var LargeLineShape = graphic.extendShape({
  shape: {
    polyline: false,
    segs: []
  },
  buildPath: function (path, shape) {
    var segs = shape.segs;
    var isPolyline = shape.polyline;

    for (var i = 0; i < segs.length; i++) {
      var seg = segs[i];

      if (isPolyline) {
        path.moveTo(seg[0][0], seg[0][1]);

        for (var j = 1; j < seg.length; j++) {
          path.lineTo(seg[j][0], seg[j][1]);
        }
      } else {
        path.moveTo(seg[0][0], seg[0][1]);

        if (seg.length > 2) {
          path.quadraticCurveTo(seg[2][0], seg[2][1], seg[1][0], seg[1][1]);
        } else {
          path.lineTo(seg[1][0], seg[1][1]);
        }
      }
    }
  },
  findDataIndex: function (x, y) {
    var shape = this.shape;
    var segs = shape.segs;
    var isPolyline = shape.polyline;
    var lineWidth = Math.max(this.style.lineWidth, 1); // Not consider transform

    for (var i = 0; i < segs.length; i++) {
      var seg = segs[i];

      if (isPolyline) {
        for (var j = 1; j < seg.length; j++) {
          if (lineContain.containStroke(seg[j - 1][0], seg[j - 1][1], seg[j][0], seg[j][1], lineWidth, x, y)) {
            return i;
          }
        }
      } else {
        if (seg.length > 2) {
          if (quadraticContain.containStroke(seg[0][0], seg[0][1], seg[2][0], seg[2][1], seg[1][0], seg[1][1], lineWidth, x, y)) {
            return i;
          }
        } else {
          if (lineContain.containStroke(seg[0][0], seg[0][1], seg[1][0], seg[1][1], lineWidth, x, y)) {
            return i;
          }
        }
      }
    }

    return -1;
  }
});

function LargeLineDraw() {
  this.group = new graphic.Group();
  this._lineEl = new LargeLineShape();
}

var largeLineProto = LargeLineDraw.prototype;
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 */

largeLineProto.updateData = function (data) {
  this.group.removeAll();
  var lineEl = this._lineEl;
  var seriesModel = data.hostModel;
  lineEl.setShape({
    segs: data.mapArray(data.getItemLayout),
    polyline: seriesModel.get('polyline')
  });
  lineEl.useStyle(seriesModel.getModel('lineStyle.normal').getLineStyle());
  var visualColor = data.getVisual('color');

  if (visualColor) {
    lineEl.setStyle('stroke', visualColor);
  }

  lineEl.setStyle('fill'); // Enable tooltip
  // PENDING May have performance issue when path is extremely large

  lineEl.seriesIndex = seriesModel.seriesIndex;
  lineEl.on('mousemove', function (e) {
    lineEl.dataIndex = null;
    var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);

    if (dataIndex > 0) {
      // Provide dataIndex for tooltip
      lineEl.dataIndex = dataIndex;
    }
  }); // Add back

  this.group.add(lineEl);
};

largeLineProto.updateLayout = function (seriesModel) {
  var data = seriesModel.getData();

  this._lineEl.setShape({
    segs: data.mapArray(data.getItemLayout)
  });
};

largeLineProto.remove = function () {
  this.group.removeAll();
};

var _default = LargeLineDraw;
module.exports = _default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;
// TODO Batch by color
var LargeSymbolPath = graphic.extendShape({
  shape: {
    points: null,
    sizes: null
  },
  symbolProxy: null,
  buildPath: function (path, shape) {
    var points = shape.points;
    var sizes = shape.sizes;
    var symbolProxy = this.symbolProxy;
    var symbolProxyShape = symbolProxy.shape;

    for (var i = 0; i < points.length; i++) {
      var pt = points[i];

      if (isNaN(pt[0]) || isNaN(pt[1])) {
        continue;
      }

      var size = sizes[i];

      if (size[0] < 4) {
        // Optimize for small symbol
        path.rect(pt[0] - size[0] / 2, pt[1] - size[1] / 2, size[0], size[1]);
      } else {
        symbolProxyShape.x = pt[0] - size[0] / 2;
        symbolProxyShape.y = pt[1] - size[1] / 2;
        symbolProxyShape.width = size[0];
        symbolProxyShape.height = size[1];
        symbolProxy.buildPath(path, symbolProxyShape, true);
      }
    }
  },
  findDataIndex: function (x, y) {
    var shape = this.shape;
    var points = shape.points;
    var sizes = shape.sizes; // Not consider transform
    // Treat each element as a rect
    // top down traverse

    for (var i = points.length - 1; i >= 0; i--) {
      var pt = points[i];
      var size = sizes[i];
      var x0 = pt[0] - size[0] / 2;
      var y0 = pt[1] - size[1] / 2;

      if (x >= x0 && y >= y0 && x <= x0 + size[0] && y <= y0 + size[1]) {
        // i is dataIndex
        return i;
      }
    }

    return -1;
  }
});

function LargeSymbolDraw() {
  this.group = new graphic.Group();
  this._symbolEl = new LargeSymbolPath({// rectHover: true,
    // cursor: 'default'
  });
}

var largeSymbolProto = LargeSymbolDraw.prototype;
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 */

largeSymbolProto.updateData = function (data) {
  this.group.removeAll();
  var symbolEl = this._symbolEl;
  var seriesModel = data.hostModel;
  symbolEl.setShape({
    points: data.mapArray(data.getItemLayout),
    sizes: data.mapArray(function (idx) {
      var size = data.getItemVisual(idx, 'symbolSize');

      if (!(size instanceof Array)) {
        size = [size, size];
      }

      return size;
    })
  }); // Create symbolProxy to build path for each data

  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method

  symbolEl.setColor = symbolEl.symbolProxy.setColor;
  symbolEl.useStyle(seriesModel.getModel('itemStyle.normal').getItemStyle(['color']));
  var visualColor = data.getVisual('color');

  if (visualColor) {
    symbolEl.setColor(visualColor);
  } // Enable tooltip
  // PENDING May have performance issue when path is extremely large


  symbolEl.seriesIndex = seriesModel.seriesIndex;
  symbolEl.on('mousemove', function (e) {
    symbolEl.dataIndex = null;
    var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);

    if (dataIndex >= 0) {
      // Provide dataIndex for tooltip
      symbolEl.dataIndex = dataIndex;
    }
  }); // Add back

  this.group.add(symbolEl);
};

largeSymbolProto.updateLayout = function (seriesModel) {
  var data = seriesModel.getData();

  this._symbolEl.setShape({
    points: data.mapArray(data.getItemLayout)
  });
};

largeSymbolProto.remove = function () {
  this.group.removeAll();
};

var _default = LargeSymbolDraw;
module.exports = _default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var vec2 = __webpack_require__(19);

/**
 * Line path for bezier and straight line draw
 */
var straightLineProto = graphic.Line.prototype;
var bezierCurveProto = graphic.BezierCurve.prototype;

function isLine(shape) {
  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}

var _default = graphic.extendShape({
  type: 'ec-line',
  style: {
    stroke: '#000',
    fill: null
  },
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    percent: 1,
    cpx1: null,
    cpy1: null
  },
  buildPath: function (ctx, shape) {
    (isLine(shape) ? straightLineProto : bezierCurveProto).buildPath(ctx, shape);
  },
  pointAt: function (t) {
    return isLine(this.shape) ? straightLineProto.pointAt.call(this, t) : bezierCurveProto.pointAt.call(this, t);
  },
  tangentAt: function (t) {
    var shape = this.shape;
    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
    return vec2.normalize(p, p);
  }
});

module.exports = _default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var Path = __webpack_require__(34);

/**
 * @module echarts/chart/helper/Symbol
 */
var WhiskerPath = Path.extend({
  type: 'whiskerInBox',
  shape: {},
  buildPath: function (ctx, shape) {
    for (var i in shape) {
      if (shape.hasOwnProperty(i) && i.indexOf('ends') === 0) {
        var pts = shape[i];
        ctx.moveTo(pts[0][0], pts[0][1]);
        ctx.lineTo(pts[1][0], pts[1][1]);
      }
    }
  }
});
/**
 * @constructor
 * @alias {module:echarts/chart/helper/WhiskerBox}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Function} styleUpdater
 * @param {boolean} isInit
 * @extends {module:zrender/graphic/Group}
 */

function WhiskerBox(data, idx, styleUpdater, isInit) {
  graphic.Group.call(this);
  /**
   * @type {number}
   * @readOnly
   */

  this.bodyIndex;
  /**
   * @type {number}
   * @readOnly
   */

  this.whiskerIndex;
  /**
   * @type {Function}
   */

  this.styleUpdater = styleUpdater;

  this._createContent(data, idx, isInit);

  this.updateData(data, idx, isInit);
  /**
   * Last series model.
   * @type {module:echarts/model/Series}
   */

  this._seriesModel;
}

var whiskerBoxProto = WhiskerBox.prototype;

whiskerBoxProto._createContent = function (data, idx, isInit) {
  var itemLayout = data.getItemLayout(idx);
  var constDim = itemLayout.chartLayout === 'horizontal' ? 1 : 0;
  var count = 0; // Whisker element.

  this.add(new graphic.Polygon({
    shape: {
      points: isInit ? transInit(itemLayout.bodyEnds, constDim, itemLayout) : itemLayout.bodyEnds
    },
    style: {
      strokeNoScale: true
    },
    z2: 100
  }));
  this.bodyIndex = count++; // Box element.

  var whiskerEnds = zrUtil.map(itemLayout.whiskerEnds, function (ends) {
    return isInit ? transInit(ends, constDim, itemLayout) : ends;
  });
  this.add(new WhiskerPath({
    shape: makeWhiskerEndsShape(whiskerEnds),
    style: {
      strokeNoScale: true
    },
    z2: 100
  }));
  this.whiskerIndex = count++;
};

function transInit(points, dim, itemLayout) {
  return zrUtil.map(points, function (point) {
    point = point.slice();
    point[dim] = itemLayout.initBaseline;
    return point;
  });
}

function makeWhiskerEndsShape(whiskerEnds) {
  // zr animation only support 2-dim array.
  var shape = {};
  zrUtil.each(whiskerEnds, function (ends, i) {
    shape['ends' + i] = ends;
  });
  return shape;
}
/**
 * Update symbol properties
 * @param  {module:echarts/data/List} data
 * @param  {number} idx
 */


whiskerBoxProto.updateData = function (data, idx, isInit) {
  var seriesModel = this._seriesModel = data.hostModel;
  var itemLayout = data.getItemLayout(idx);
  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps']; // this.childAt(this.bodyIndex).stopAnimation(true);
  // this.childAt(this.whiskerIndex).stopAnimation(true);

  updateMethod(this.childAt(this.bodyIndex), {
    shape: {
      points: itemLayout.bodyEnds
    }
  }, seriesModel, idx);
  updateMethod(this.childAt(this.whiskerIndex), {
    shape: makeWhiskerEndsShape(itemLayout.whiskerEnds)
  }, seriesModel, idx);
  this.styleUpdater.call(null, this, data, idx);
};

zrUtil.inherits(WhiskerBox, graphic.Group);
/**
 * @constructor
 * @alias module:echarts/chart/helper/WhiskerBoxDraw
 */

function WhiskerBoxDraw(styleUpdater) {
  this.group = new graphic.Group();
  this.styleUpdater = styleUpdater;
}

var whiskerBoxDrawProto = WhiskerBoxDraw.prototype;
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 */

whiskerBoxDrawProto.updateData = function (data) {
  var group = this.group;
  var oldData = this._data;
  var styleUpdater = this.styleUpdater;
  data.diff(oldData).add(function (newIdx) {
    if (data.hasValue(newIdx)) {
      var symbolEl = new WhiskerBox(data, newIdx, styleUpdater, true);
      data.setItemGraphicEl(newIdx, symbolEl);
      group.add(symbolEl);
    }
  }).update(function (newIdx, oldIdx) {
    var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data

    if (!data.hasValue(newIdx)) {
      group.remove(symbolEl);
      return;
    }

    if (!symbolEl) {
      symbolEl = new WhiskerBox(data, newIdx, styleUpdater);
    } else {
      symbolEl.updateData(data, newIdx);
    } // Add back


    group.add(symbolEl);
    data.setItemGraphicEl(newIdx, symbolEl);
  }).remove(function (oldIdx) {
    var el = oldData.getItemGraphicEl(oldIdx);
    el && group.remove(el);
  }).execute();
  this._data = data;
};
/**
 * Remove symbols.
 * @param {module:echarts/data/List} data
 */


whiskerBoxDrawProto.remove = function () {
  var group = this.group;
  var data = this._data;
  this._data = null;
  data && data.eachItemGraphicEl(function (el) {
    el && group.remove(el);
  });
};

var _default = WhiskerBoxDraw;
module.exports = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1420);

__webpack_require__(1421);

var visualSymbol = __webpack_require__(106);

var layoutPoints = __webpack_require__(284);

var dataSample = __webpack_require__(1612);

__webpack_require__(144);

// In case developer forget to include grid component
echarts.registerVisual(zrUtil.curry(visualSymbol, 'line', 'circle', 'line'));
echarts.registerLayout(zrUtil.curry(layoutPoints, 'line')); // Down sample after filter

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, zrUtil.curry(dataSample, 'line'));

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var createListFromArray = __webpack_require__(84);

var SeriesModel = __webpack_require__(35);

var _default = SeriesModel.extend({
  type: 'series.line',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // stack: null
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // If clip the overflow value
    clipOverflow: true,
    // cursor: null,
    label: {
      normal: {
        position: 'top'
      }
    },
    // itemStyle: {
    //     normal: {},
    //     emphasis: {}
    // },
    lineStyle: {
      normal: {
        width: 2,
        type: 'solid'
      }
    },
    // areaStyle: {},
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    // 拐点图形类型
    symbol: 'emptyCircle',
    // 拐点图形大小
    symbolSize: 4,
    // 拐点图形旋转控制
    symbolRotate: null,
    // 是否显示 symbol, 只有在 tooltip hover 的时候显示
    showSymbol: true,
    // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
    showAllSymbol: false,
    // 是否连接断点
    connectNulls: false,
    // 数据过滤，'average', 'max', 'min', 'sum'
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity
  }
});

module.exports = _default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var SymbolDraw = __webpack_require__(139);

var SymbolClz = __webpack_require__(187);

var lineAnimationDiff = __webpack_require__(1422);

var graphic = __webpack_require__(5);

var modelUtil = __webpack_require__(15);

var _poly = __webpack_require__(450);

var Polyline = _poly.Polyline;
var Polygon = _poly.Polygon;

var ChartView = __webpack_require__(87);

// FIXME step not support polar
function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    var p1 = points1[i];
    var p2 = points2[i];

    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
      return;
    }
  }

  return true;
}

function getSmooth(smooth) {
  return typeof smooth === 'number' ? smooth : smooth ? 0.3 : 0;
}

function getAxisExtentWithGap(axis) {
  var extent = axis.getGlobalExtent();

  if (axis.onBand) {
    // Remove extra 1px to avoid line miter in clipped edge
    var halfBandWidth = axis.getBandWidth() / 2 - 1;
    var dir = extent[1] > extent[0] ? 1 : -1;
    extent[0] += dir * halfBandWidth;
    extent[1] -= dir * halfBandWidth;
  }

  return extent;
}

function sign(val) {
  return val >= 0 ? 1 : -1;
}
/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Array.<Array.<number>>} points
 * @private
 */


function getStackedOnPoints(coordSys, data) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = 0;

  if (!baseAxis.onZero) {
    var extent = valueAxis.scale.getExtent();

    if (extent[0] > 0) {
      // Both positive
      valueStart = extent[0];
    } else if (extent[1] < 0) {
      // Both negative
      valueStart = extent[1];
    } // If is one positive, and one negative, onZero shall be true

  }

  var valueDim = valueAxis.dim;
  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
  return data.mapArray([valueDim], function (val, idx) {
    var stackedOnSameSign;
    var stackedOn = data.stackedOn; // Find first stacked value with same sign

    while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
      stackedOnSameSign = stackedOn;
      break;
    }

    var stackedData = [];
    stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
    stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
    return coordSys.dataToPoint(stackedData);
  }, true);
}

function createGridClipShape(cartesian, hasAnimation, seriesModel) {
  var xExtent = getAxisExtentWithGap(cartesian.getAxis('x'));
  var yExtent = getAxisExtentWithGap(cartesian.getAxis('y'));
  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
  var x = Math.min(xExtent[0], xExtent[1]);
  var y = Math.min(yExtent[0], yExtent[1]);
  var width = Math.max(xExtent[0], xExtent[1]) - x;
  var height = Math.max(yExtent[0], yExtent[1]) - y;
  var lineWidth = seriesModel.get('lineStyle.normal.width') || 2; // Expand clip shape to avoid clipping when line value exceeds axis

  var expandSize = seriesModel.get('clipOverflow') ? lineWidth / 2 : Math.max(width, height);

  if (isHorizontal) {
    y -= expandSize;
    height += expandSize * 2;
  } else {
    x -= expandSize;
    width += expandSize * 2;
  }

  var clipPath = new graphic.Rect({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
    graphic.initProps(clipPath, {
      shape: {
        width: width,
        height: height
      }
    }, seriesModel);
  }

  return clipPath;
}

function createPolarClipShape(polar, hasAnimation, seriesModel) {
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis();
  var radiusExtent = radiusAxis.getExtent();
  var angleExtent = angleAxis.getExtent();
  var RADIAN = Math.PI / 180;
  var clipPath = new graphic.Sector({
    shape: {
      cx: polar.cx,
      cy: polar.cy,
      r0: radiusExtent[0],
      r: radiusExtent[1],
      startAngle: -angleExtent[0] * RADIAN,
      endAngle: -angleExtent[1] * RADIAN,
      clockwise: angleAxis.inverse
    }
  });

  if (hasAnimation) {
    clipPath.shape.endAngle = -angleExtent[0] * RADIAN;
    graphic.initProps(clipPath, {
      shape: {
        endAngle: -angleExtent[1] * RADIAN
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipShape(coordSys, hasAnimation, seriesModel) {
  return coordSys.type === 'polar' ? createPolarClipShape(coordSys, hasAnimation, seriesModel) : createGridClipShape(coordSys, hasAnimation, seriesModel);
}

function turnPointsIntoStep(points, coordSys, stepTurnAt) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];

  for (var i = 0; i < points.length - 1; i++) {
    var nextPt = points[i + 1];
    var pt = points[i];
    stepPoints.push(pt);
    var stepPt = [];

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
        break;

      case 'middle':
        // default is start
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt);
        stepPoints.push(stepPt2);
        break;

      default:
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
    }
  } // Last points


  points[i] && stepPoints.push(points[i]);
  return stepPoints;
}

function getVisualGradient(data, coordSys) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    // Can only be x or y
    if (visualMetaList[i].dimension < 2) {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta || coordSys.type !== 'cartesian2d') {
    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var dimension = visualMeta.dimension;
  var dimName = data.dimensions[dimension];
  var axis = coordSys.getAxis(dimName); // dataToCoor mapping may not be linear, but must be monotonic.

  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStops[0].coord - tinyExtent;
  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  zrUtil.each(colorStops, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStops.push({
    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStops.unshift({
    // notice colorStops.length have been changed.
    offset: stopLen ? colorStops[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  }); // zrUtil.each(colorStops, function (colorStop) {
  //     // Make sure each offset has rounded px to avoid not sharp edge
  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
  // });

  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
  gradient[dimName] = minCoord;
  gradient[dimName + '2'] = maxCoord;
  return gradient;
}

var _default = ChartView.extend({
  type: 'line',
  init: function () {
    var lineGroup = new graphic.Group();
    var symbolDraw = new SymbolDraw();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  },
  render: function (seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle.normal');
    var areaStyleModel = seriesModel.getModel('areaStyle.normal');
    var points = data.mapArray(data.getItemLayout, true);
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var stackedOnPoints = getStackedOnPoints(coordSys, data);
    var showSymbol = seriesModel.get('showSymbol');

    var isSymbolIgnore = showSymbol && !isCoordSysPolar && !seriesModel.get('showAllSymbol') && this._getSymbolIgnoreFunc(data, coordSys); // Remove temporary symbols


    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar && seriesModel.get('step'); // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, isSymbolIgnore);

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step);
        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
      }

      polyline = this._newPolyline(points, coordSys, hasAnimation);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      }

      lineGroup.setClipPath(createClipShape(coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // Update clipPath


      lineGroup.setClipPath(createClipShape(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
      // because points are not changed

      showSymbol && symbolDraw.updateData(data, isSymbolIgnore); // Stop symbol animation and sync with line points
      // FIXME performance?

      data.eachItemGraphicEl(function (el) {
        el.stopAnimation(true);
      }); // In the case data zoom triggerred refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._updateAnimation(data, stackedOnPoints, coordSys, api, step);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step);
            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    var smooth = seriesModel.get('smooth');
    smooth = getSmooth(seriesModel.get('smooth'));
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: seriesModel.get('smoothMonotone'),
      connectNulls: seriesModel.get('connectNulls')
    });

    if (polygon) {
      var stackedOn = data.stackedOn;
      var stackedOnSmooth = 0;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel'
      }));

      if (stackedOn) {
        var stackedOnSeries = stackedOn.hostModel;
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: seriesModel.get('smoothMonotone'),
        connectNulls: seriesModel.get('connectNulls')
      });
    }

    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
  },
  dispose: function () {},
  highlight: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var pt = data.getItemLayout(dataIndex);

        if (!pt) {
          // Null data
          return;
        }

        symbol = new SymbolClz(data, dataIndex);
        symbol.position = pt;
        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  },
  downplay: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolyline: function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new Polyline({
      shape: {
        points: points
      },
      silent: true,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolygon: function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new Polygon({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      silent: true
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  },

  /**
   * @private
   */
  _getSymbolIgnoreFunc: function (data, coordSys) {
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0]; // `getLabelInterval` is provided by echarts/component/axis

    if (categoryAxis && categoryAxis.isLabelIgnored) {
      return zrUtil.bind(categoryAxis.isLabelIgnored, categoryAxis);
    }
  },

  /**
   * @private
   */
  // FIXME Two value axis
  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
      next = turnPointsIntoStep(diff.next, coordSys, step);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
    } // `diff.current` is subset of `current` (which should be ensured by
    // turnPointsIntoStep), so points in `__points` can be updated when
    // points in `current` are update during animation.


    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    graphic.updateProps(polyline, {
      shape: {
        points: next
      }
    }, seriesModel);

    if (polygon) {
      polygon.setShape({
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      graphic.updateProps(polygon, {
        shape: {
          points: next,
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel);
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
        }
      });
    }
  },
  remove: function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
  }
});

module.exports = _default;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// var arrayDiff = require('zrender/src/core/arrayDiff');
// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
function sign(val) {
  return val >= 0 ? 1 : -1;
}

function getStackedOnPoint(coordSys, data, idx) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = baseAxis.onZero ? 0 : valueAxis.scale.getExtent()[0];
  var valueDim = valueAxis.dim;
  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
  var stackedOnSameSign;
  var stackedOn = data.stackedOn;
  var val = data.get(valueDim, idx); // Find first stacked value with same sign

  while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
    stackedOnSameSign = stackedOn;
    break;
  }

  var stackedData = [];
  stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
  stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
  return coordSys.dataToPoint(stackedData);
} // function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }


function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys) {
  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
  // var oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var dims = newCoordSys.dimensions;

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        var currentPt = oldData.getItemLayout(diffItem.idx);
        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly

        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
          currentPt = nextPt.slice();
        }

        currPoints.push(currentPt);
        nextPoints.push(nextPt);
        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var idx = diffItem.idx;
        currPoints.push(oldCoordSys.dataToPoint([newData.get(dims[0], idx, true), newData.get(dims[1], idx, true)]));
        nextPoints.push(newData.getItemLayout(idx).slice());
        currStackedPoints.push(getStackedOnPoint(oldCoordSys, newData, idx));
        nextStackedPoints.push(newStackedOnPoints[idx]);
        rawIndices.push(newData.getRawIndex(idx));
        break;

      case '-':
        var idx = diffItem.idx;
        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
        // FIXME FIXME FIXME

        if (rawIndex !== idx) {
          currPoints.push(oldData.getItemLayout(idx));
          nextPoints.push(newCoordSys.dataToPoint([oldData.get(dims[0], idx, true), oldData.get(dims[1], idx, true)]));
          currStackedPoints.push(oldStackedOnPoints[idx]);
          nextStackedPoints.push(getStackedOnPoint(newCoordSys, oldData, idx));
          rawIndices.push(rawIndex);
        } else {
          pointAdded = false;
        }

    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var sortedCurrPoints = [];
  var sortedNextPoints = [];
  var sortedCurrStackedPoints = [];
  var sortedNextStackedPoints = [];
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    sortedCurrPoints[i] = currPoints[idx];
    sortedNextPoints[i] = nextPoints[idx];
    sortedCurrStackedPoints[i] = currStackedPoints[idx];
    sortedNextStackedPoints[i] = nextStackedPoints[idx];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

module.exports = _default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1424);

__webpack_require__(1425);

var linesLayout = __webpack_require__(1426);

var linesVisual = __webpack_require__(1427);

echarts.registerLayout(linesLayout);
echarts.registerVisual(linesVisual);

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var SeriesModel = __webpack_require__(35);

var List = __webpack_require__(31);

var zrUtil = __webpack_require__(0);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;

var CoordinateSystem = __webpack_require__(66);

// Convert [ [{coord: []}, {coord: []}] ]
// to [ { coords: [[]] } ]
function preprocessOption(seriesOpt) {
  var data = seriesOpt.data;

  if (data && data[0] && data[0][0] && data[0][0].coord) {
    seriesOpt.data = zrUtil.map(data, function (itemOpt) {
      var coords = [itemOpt[0].coord, itemOpt[1].coord];
      var target = {
        coords: coords
      };

      if (itemOpt[0].name) {
        target.fromName = itemOpt[0].name;
      }

      if (itemOpt[1].name) {
        target.toName = itemOpt[1].name;
      }

      return zrUtil.mergeAll([target, itemOpt[0], itemOpt[1]]);
    });
  }
}

var LinesSeries = SeriesModel.extend({
  type: 'series.lines',
  dependencies: ['grid', 'polar'],
  visualColorAccessPath: 'lineStyle.normal.color',
  init: function (option) {
    // Not using preprocessor because mergeOption may not have series.type
    preprocessOption(option);
    LinesSeries.superApply(this, 'init', arguments);
  },
  mergeOption: function (option) {
    preprocessOption(option);
    LinesSeries.superApply(this, 'mergeOption', arguments);
  },
  getInitialData: function (option, ecModel) {
    var lineData = new List(['value'], this);
    lineData.hasItemOption = false;
    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
      // dataItem is simply coords
      if (dataItem instanceof Array) {
        return NaN;
      } else {
        lineData.hasItemOption = true;
        var value = dataItem.value;

        if (value != null) {
          return value instanceof Array ? value[dimIndex] : value;
        }
      }
    });
    return lineData;
  },
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var itemModel = data.getItemModel(dataIndex);
    var name = itemModel.get('name');

    if (name) {
      return name;
    }

    var fromName = itemModel.get('fromName');
    var toName = itemModel.get('toName');
    var html = [];
    fromName != null && html.push(fromName);
    toName != null && html.push(toName);
    return encodeHTML(html.join(' > '));
  },
  defaultOption: {
    coordinateSystem: 'geo',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // Cartesian coordinate system
    xAxisIndex: 0,
    yAxisIndex: 0,
    symbol: ['none', 'none'],
    symbolSize: [10, 10],
    // Geo coordinate system
    geoIndex: 0,
    effect: {
      show: false,
      period: 4,
      // Animation delay. support callback
      // delay: 0,
      // If move with constant speed px/sec
      // period will be ignored if this property is > 0,
      constantSpeed: 0,
      symbol: 'circle',
      symbolSize: 3,
      loop: true,
      // Length of trail, 0 - 1
      trailLength: 0.2 // Same with lineStyle.normal.color
      // color

    },
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // If lines are polyline
    // polyline not support curveness, label, animation
    polyline: false,
    label: {
      normal: {
        show: false,
        position: 'end' // distance: 5,
        // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

      }
    },
    lineStyle: {
      normal: {
        opacity: 0.5
      }
    }
  }
});
var _default = LinesSeries;
module.exports = _default;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var LineDraw = __webpack_require__(272);

var EffectLine = __webpack_require__(446);

var Line = __webpack_require__(271);

var Polyline = __webpack_require__(447);

var EffectPolyline = __webpack_require__(1413);

var LargeLineDraw = __webpack_require__(1415);

var _default = echarts.extendChartView({
  type: 'lines',
  init: function () {},
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var lineDraw = this._lineDraw;
    var hasEffect = seriesModel.get('effect.show');
    var isPolyline = seriesModel.get('polyline');
    var isLarge = seriesModel.get('large') && data.count() >= seriesModel.get('largeThreshold');

    if (hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLarge !== this._isLarge) {
      if (lineDraw) {
        lineDraw.remove();
      }

      lineDraw = this._lineDraw = isLarge ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
      this._hasEffet = hasEffect;
      this._isPolyline = isPolyline;
      this._isLarge = isLarge;
    }

    var zlevel = seriesModel.get('zlevel');
    var trailLength = seriesModel.get('effect.trailLength');
    var zr = api.getZr(); // Avoid the drag cause ghost shadow
    // FIXME Better way ?
    // SVG doesn't support

    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(zlevel).clear(true);
    } // Config layer with motion blur


    if (this._lastZlevel != null && !isSvg) {
      zr.configLayer(this._lastZlevel, {
        motionBlur: false
      });
    }

    if (hasEffect && trailLength) {
      if (!isSvg) {
        zr.configLayer(zlevel, {
          motionBlur: true,
          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
        });
      }
    }

    this.group.add(lineDraw.group);
    lineDraw.updateData(data);
    this._lastZlevel = zlevel;
  },
  updateLayout: function (seriesModel, ecModel, api) {
    this._lineDraw.updateLayout(seriesModel); // Not use motion when dragging or zooming


    var zr = api.getZr();
    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(this._lastZlevel).clear(true);
    }
  },
  remove: function (ecModel, api) {
    this._lineDraw && this._lineDraw.remove(api, true); // Clear motion when lineDraw is removed

    var zr = api.getZr();
    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(this._lastZlevel).clear(true);
    }
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

function _default(ecModel) {
  ecModel.eachSeriesByType('lines', function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var lineData = seriesModel.getData(); // FIXME Use data dimensions ?

    lineData.each(function (idx) {
      var itemModel = lineData.getItemModel(idx);
      var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.get('coords');
      var pts = [];

      if (seriesModel.get('polyline')) {
        for (var i = 0; i < coords.length; i++) {
          pts.push(coordSys.dataToPoint(coords[i]));
        }
      } else {
        pts[0] = coordSys.dataToPoint(coords[0]);
        pts[1] = coordSys.dataToPoint(coords[1]);
        var curveness = itemModel.get('lineStyle.normal.curveness');

        if (+curveness) {
          pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
        }
      }

      lineData.setItemLayout(idx, pts);
    });
  });
}

module.exports = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

function _default(ecModel) {
  ecModel.eachSeriesByType('lines', function (seriesModel) {
    var data = seriesModel.getData();
    var symbolType = normalize(seriesModel.get('symbol'));
    var symbolSize = normalize(seriesModel.get('symbolSize'));
    var opacityQuery = 'lineStyle.normal.opacity'.split('.');
    data.setVisual('fromSymbol', symbolType && symbolType[0]);
    data.setVisual('toSymbol', symbolType && symbolType[1]);
    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    data.setVisual('opacity', seriesModel.get(opacityQuery));
    data.each(function (idx) {
      var itemModel = data.getItemModel(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
      var opacity = itemModel.get(opacityQuery);
      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
      data.setItemVisual(idx, 'opacity', opacity);
    });
  });
}

module.exports = _default;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1429);

__webpack_require__(1430);

__webpack_require__(440);

__webpack_require__(193);

var mapSymbolLayout = __webpack_require__(1433);

var mapVisual = __webpack_require__(1434);

var mapDataStatistic = __webpack_require__(1432);

var backwardCompat = __webpack_require__(1431);

var createDataSelectAction = __webpack_require__(439);

echarts.registerLayout(mapSymbolLayout);
echarts.registerVisual(mapVisual);
echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
echarts.registerPreprocessor(backwardCompat);
createDataSelectAction('map', [{
  type: 'mapToggleSelect',
  event: 'mapselectchanged',
  method: 'toggleSelected'
}, {
  type: 'mapSelect',
  event: 'mapselected',
  method: 'select'
}, {
  type: 'mapUnSelect',
  event: 'mapunselected',
  method: 'unSelect'
}]);

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var List = __webpack_require__(31);

var SeriesModel = __webpack_require__(35);

var completeDimensions = __webpack_require__(58);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;

var dataSelectableMixin = __webpack_require__(277);

var geoCreator = __webpack_require__(193);

var MapSeries = SeriesModel.extend({
  type: 'series.map',
  dependencies: ['geo'],
  layoutMode: 'box',

  /**
   * Only first map series of same mapType will drawMap
   * @type {boolean}
   */
  needsDrawMap: false,

  /**
   * Group of all map series with same mapType
   * @type {boolean}
   */
  seriesGroup: [],
  init: function (option) {
    this._fillOption(option, this.getMapType()); // this.option = option;


    MapSeries.superApply(this, 'init', arguments);
    this.updateSelectedMap(option.data);
  },
  getInitialData: function (option) {
    var dimensions = completeDimensions(['value'], option.data || []);
    var list = new List(dimensions, this);
    list.initData(option.data);
    return list;
  },
  mergeOption: function (newOption) {
    this._fillOption(newOption, this.getMapType());

    MapSeries.superApply(this, 'mergeOption', arguments);
    this.updateSelectedMap(this.option.data);
  },

  /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */
  getHostGeoModel: function () {
    var geoIndex = this.option.geoIndex;
    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
  },
  getMapType: function () {
    return (this.getHostGeoModel() || this).option.map;
  },
  _fillOption: function (option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap); // return option;
  },
  getRawValue: function (dataIndex) {
    // Use value stored in data instead because it is calculated from multiple series
    // FIXME Provide all value of multiple series ?
    return this.getData().get('value', dataIndex);
  },

  /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */
  getRegionModel: function (regionName) {
    var data = this.getData();
    return data.getItemModel(data.indexOfName(regionName));
  },

  /**
   * Map tooltip formatter
   *
   * @param {number} dataIndex
   */
  formatTooltip: function (dataIndex) {
    // FIXME orignalData and data is a bit confusing
    var data = this.getData();
    var formattedValue = addCommas(this.getRawValue(dataIndex));
    var name = data.getName(dataIndex);
    var seriesGroup = this.seriesGroup;
    var seriesNames = [];

    for (var i = 0; i < seriesGroup.length; i++) {
      var otherIndex = seriesGroup[i].originalData.indexOfName(name);

      if (!isNaN(seriesGroup[i].originalData.get('value', otherIndex))) {
        seriesNames.push(encodeHTML(seriesGroup[i].name));
      }
    }

    return seriesNames.join(', ') + '<br />' + encodeHTML(name + ' : ' + formattedValue);
  },

  /**
   * @implement
   */
  getTooltipPosition: function (dataIndex) {
    if (dataIndex != null) {
      var name = this.getData().getName(dataIndex);
      var geo = this.coordinateSystem;
      var region = geo.getRegion(name);
      return region && geo.dataToPoint(region.center);
    }
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 2,
    coordinateSystem: 'geo',
    // map should be explicitly specified since ec3.
    map: '',
    // If `geoIndex` is not specified, a exclusive geo will be
    // created. Otherwise use the specified geo component, and
    // `map` and `mapType` are ignored.
    // geoIndex: 0,
    // 'center' | 'left' | 'right' | 'x%' | {number}
    left: 'center',
    // 'center' | 'top' | 'bottom' | 'x%' | {number}
    top: 'center',
    // right
    // bottom
    // width:
    // height
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    aspectScale: 0.75,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    // 数值合并方式，默认加和，可选为：
    // 'sum' | 'average' | 'max' | 'min'
    // mapValueCalculation: 'sum',
    // 地图数值计算结果小数精度
    // mapValuePrecision: 0,
    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
    showLegendSymbol: true,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    dataRangeHoverLink: true,
    // 是否开启缩放及漫游模式
    // roam: false,
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ],
    // higher priority than center and zoom
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    label: {
      normal: {
        show: false,
        color: '#000'
      },
      emphasis: {
        show: true,
        color: 'rgb(100,0,0)'
      }
    },
    // scaleLimit: null,
    itemStyle: {
      normal: {
        // color: 各异,
        borderWidth: 0.5,
        borderColor: '#444',
        areaColor: '#eee'
      },
      // 也是选中样式
      emphasis: {
        areaColor: 'rgba(255,215,0,0.8)'
      }
    }
  }
});
zrUtil.mixin(MapSeries, dataSelectableMixin);
var _default = MapSeries;
module.exports = _default;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var MapDraw = __webpack_require__(463);

var _default = echarts.extendChartView({
  type: 'map',
  render: function (mapModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
      return;
    }

    var group = this.group;
    group.removeAll();

    if (mapModel.getHostGeoModel()) {
      return;
    } // Not update map if it is an roam action from self


    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
      if (mapModel.needsDrawMap) {
        var mapDraw = this._mapDraw || new MapDraw(api, true);
        group.add(mapDraw.group);
        mapDraw.draw(mapModel, ecModel, api, this, payload);
        this._mapDraw = mapDraw;
      } else {
        // Remove drawed map
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
      }
    } else {
      var mapDraw = this._mapDraw;
      mapDraw && group.add(mapDraw.group);
    }

    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
  },
  remove: function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
    this.group.removeAll();
  },
  dispose: function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
  },
  _renderSymbols: function (mapModel, ecModel, api) {
    var originalData = mapModel.originalData;
    var group = this.group;
    originalData.each('value', function (value, idx) {
      if (isNaN(value)) {
        return;
      }

      var layout = originalData.getItemLayout(idx);

      if (!layout || !layout.point) {
        // Not exists in map
        return;
      }

      var point = layout.point;
      var offset = layout.offset;
      var circle = new graphic.Circle({
        style: {
          // Because the special of map draw.
          // Which needs statistic of multiple series and draw on one map.
          // And each series also need a symbol with legend color
          //
          // Layout and visual are put one the different data
          fill: mapModel.getData().getVisual('color')
        },
        shape: {
          cx: point[0] + offset * 9,
          cy: point[1],
          r: 3
        },
        silent: true,
        // Do not overlap the first series, on which labels are displayed.
        z2: !offset ? 10 : 8
      }); // First data on the same region

      if (!offset) {
        var fullData = mapModel.mainSeries.getData();
        var name = originalData.getName(idx);
        var fullIndex = fullData.indexOfName(name);
        var itemModel = originalData.getItemModel(idx);
        var labelModel = itemModel.getModel('label.normal');
        var hoverLabelModel = itemModel.getModel('label.emphasis');
        var polygonGroups = fullData.getItemGraphicEl(fullIndex);
        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(idx, 'normal'), name);
        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(idx, 'emphasis'), normalText);

        var onEmphasis = function () {
          var hoverStyle = graphic.setTextStyle({}, hoverLabelModel, {
            text: hoverLabelModel.get('show') ? emphasisText : null
          }, {
            isRectText: true,
            useInsideStyle: false
          }, true);
          circle.style.extendFrom(hoverStyle); // Make label upper than others if overlaps.

          circle.__mapOriginalZ2 = circle.z2;
          circle.z2 += 1;
        };

        var onNormal = function () {
          graphic.setTextStyle(circle.style, labelModel, {
            text: labelModel.get('show') ? normalText : null,
            textPosition: labelModel.getShallow('position') || 'bottom'
          }, {
            isRectText: true,
            useInsideStyle: false
          });

          if (circle.__mapOriginalZ2 != null) {
            circle.z2 = circle.__mapOriginalZ2;
            circle.__mapOriginalZ2 = null;
          }
        };

        polygonGroups.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
        onNormal();
      }

      group.add(circle);
    });
  }
});

module.exports = _default;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function _default(option) {
  // Save geoCoord
  var mapSeries = [];
  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'map') {
      mapSeries.push(seriesOpt);
      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level

      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

// FIXME 公用？

/**
 * @param {Array.<module:echarts/data/List>} datas
 * @param {string} statisticType 'average' 'sum'
 * @inner
 */
function dataStatistics(datas, statisticType) {
  var dataNameMap = {};
  var dims = ['value'];
  zrUtil.each(datas, function (data) {
    data.each(dims, function (value, idx) {
      // Add prefix to avoid conflict with Object.prototype.
      var mapKey = 'ec-' + data.getName(idx);
      dataNameMap[mapKey] = dataNameMap[mapKey] || [];

      if (!isNaN(value)) {
        dataNameMap[mapKey].push(value);
      }
    });
  });
  return datas[0].map(dims, function (value, idx) {
    var mapKey = 'ec-' + datas[0].getName(idx);
    var sum = 0;
    var min = Infinity;
    var max = -Infinity;
    var len = dataNameMap[mapKey].length;

    for (var i = 0; i < len; i++) {
      min = Math.min(min, dataNameMap[mapKey][i]);
      max = Math.max(max, dataNameMap[mapKey][i]);
      sum += dataNameMap[mapKey][i];
    }

    var result;

    if (statisticType === 'min') {
      result = min;
    } else if (statisticType === 'max') {
      result = max;
    } else if (statisticType === 'average') {
      result = sum / len;
    } else {
      result = sum;
    }

    return len === 0 ? NaN : result;
  });
}

function _default(ecModel) {
  var seriesGroups = {};
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var hostGeoModel = seriesModel.getHostGeoModel();
    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
  });
  zrUtil.each(seriesGroups, function (seriesList, key) {
    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
      return seriesModel.getData();
    }), seriesList[0].get('mapValueCalculation'));

    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].originalData = seriesList[i].getData();
    } // FIXME Put where?


    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].seriesGroup = seriesList;
      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
      seriesList[i].setData(data.cloneShallow());
      seriesList[i].mainSeries = seriesList[0];
    }
  });
}

module.exports = _default;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function _default(ecModel) {
  var processedMapType = {};
  ecModel.eachSeriesByType('map', function (mapSeries) {
    var mapType = mapSeries.getMapType();

    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
      return;
    }

    var mapSymbolOffsets = {};
    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
      var geo = subMapSeries.coordinateSystem;
      var data = subMapSeries.originalData;

      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
        data.each('value', function (value, idx) {
          var name = data.getName(idx);
          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
          // not be drawn. So here must validate if value is NaN.

          if (!region || isNaN(value)) {
            return;
          }

          var offset = mapSymbolOffsets[name] || 0;
          var point = geo.dataToPoint(region.center);
          mapSymbolOffsets[name] = offset + 1;
          data.setItemLayout(idx, {
            point: point,
            offset: offset
          });
        });
      }
    }); // Show label of those region not has legendSymbol(which is offset 0)

    var data = mapSeries.getData();
    data.each(function (idx) {
      var name = data.getName(idx);
      var layout = data.getItemLayout(idx) || {};
      layout.showLabel = !mapSymbolOffsets[name];
      data.setItemLayout(idx, layout);
    });
    processedMapType[mapType] = true;
  });
}

module.exports = _default;

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

function _default(ecModel) {
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var colorList = seriesModel.get('color');
    var itemStyleModel = seriesModel.getModel('itemStyle.normal');
    var areaColor = itemStyleModel.get('areaColor');
    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
    seriesModel.getData().setVisual({
      'areaColor': areaColor,
      'color': color
    });
  });
}

module.exports = _default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(470);

__webpack_require__(1436);

__webpack_require__(1437);

var parallelVisual = __webpack_require__(1438);

echarts.registerVisual(parallelVisual);

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

var List = __webpack_require__(31);

var zrUtil = __webpack_require__(0);

var SeriesModel = __webpack_require__(35);

var completeDimensions = __webpack_require__(58);

var _default = SeriesModel.extend({
  type: 'series.parallel',
  dependencies: ['parallel'],
  visualColorAccessPath: 'lineStyle.normal.color',
  getInitialData: function (option, ecModel) {
    var parallelModel = ecModel.getComponent('parallel', this.get('parallelIndex'));
    var parallelAxisIndices = parallelModel.parallelAxisIndex;
    var rawData = option.data;
    var modelDims = parallelModel.dimensions;
    var dataDims = generateDataDims(modelDims, rawData);
    var dataDimsInfo = zrUtil.map(dataDims, function (dim, dimIndex) {
      var modelDimsIndex = zrUtil.indexOf(modelDims, dim);
      var axisModel = modelDimsIndex >= 0 && ecModel.getComponent('parallelAxis', parallelAxisIndices[modelDimsIndex]);

      if (axisModel && axisModel.get('type') === 'category') {
        translateCategoryValue(axisModel, dim, rawData);
        return {
          name: dim,
          type: 'ordinal'
        };
      } else if (modelDimsIndex < 0) {
        return completeDimensions.guessOrdinal(rawData, dimIndex) ? {
          name: dim,
          type: 'ordinal'
        } : dim;
      } else {
        return dim;
      }
    });
    var list = new List(dataDimsInfo, this);
    list.initData(rawData); // Anication is forbiden in progressive data mode.

    if (this.option.progressive) {
      this.option.animation = false;
    }

    return list;
  },

  /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @public
   * @param {string} activeState 'active' or 'inactive' or 'normal'
   * @return {Array.<number>} Raw indices
   */
  getRawIndicesByActiveState: function (activeState) {
    var coordSys = this.coordinateSystem;
    var data = this.getData();
    var indices = [];
    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
      if (activeState === theActiveState) {
        indices.push(data.getRawIndex(dataIndex));
      }
    });
    return indices;
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'parallel',
    parallelIndex: 0,
    label: {
      normal: {
        show: false
      },
      emphasis: {
        show: false
      }
    },
    inactiveOpacity: 0.05,
    activeOpacity: 1,
    lineStyle: {
      normal: {
        width: 1,
        opacity: 0.45,
        type: 'solid'
      }
    },
    progressive: false,
    // 100
    smooth: false,
    animationEasing: 'linear'
  }
});

function translateCategoryValue(axisModel, dim, rawData) {
  var axisData = axisModel.get('data');
  var numberDim = convertDimNameToNumber(dim);

  if (axisData && axisData.length) {
    zrUtil.each(rawData, function (dataItem) {
      if (!dataItem) {
        return;
      } // FIXME
      // time consuming, should use hash?


      var index = zrUtil.indexOf(axisData, dataItem[numberDim]);
      dataItem[numberDim] = index >= 0 ? index : NaN;
    });
  } // FIXME
  // 如果没有设置axis data, 应自动算出，或者提示。

}

function convertDimNameToNumber(dimName) {
  return +dimName.replace('dim', '');
}

function generateDataDims(modelDims, rawData) {
  // parallelModel.dimension should not be regarded as data
  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
  // We detect max dim by parallelModel.dimensions and fist
  // item in rawData arbitrarily.
  var maxDimNum = 0;
  zrUtil.each(modelDims, function (dimName) {
    var numberDim = convertDimNameToNumber(dimName);
    numberDim > maxDimNum && (maxDimNum = numberDim);
  });
  var firstItem = rawData[0];

  if (firstItem && firstItem.length - 1 > maxDimNum) {
    maxDimNum = firstItem.length - 1;
  }

  var dataDims = [];

  for (var i = 0; i <= maxDimNum; i++) {
    dataDims.push('dim' + i);
  }

  return dataDims;
}

module.exports = _default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var zrUtil = __webpack_require__(0);

var ChartView = __webpack_require__(87);

var SMOOTH = 0.3;
var ParallelView = ChartView.extend({
  type: 'parallel',
  init: function () {
    /**
     * @type {module:zrender/container/Group}
     * @private
     */
    this._dataGroup = new graphic.Group();
    this.group.add(this._dataGroup);
    /**
     * @type {module:echarts/data/List}
     */

    this._data;
  },

  /**
   * @override
   */
  render: function (seriesModel, ecModel, api, payload) {
    this._renderForNormal(seriesModel, payload); // this[
    //     seriesModel.option.progressive
    //         ? '_renderForProgressive'
    //         : '_renderForNormal'
    // ](seriesModel);

  },
  dispose: function () {},

  /**
   * @private
   */
  _renderForNormal: function (seriesModel, payload) {
    var dataGroup = this._dataGroup;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var option = seriesModel.option;
    var smooth = option.smooth ? SMOOTH : null; // Consider switch between progressive and not.
    // oldData && oldData.__plProgressive && dataGroup.removeAll();

    data.diff(oldData).add(add).update(update).remove(remove).execute(); // Update style

    updateElCommon(data, smooth); // First create

    if (!this._data) {
      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
        // Callback will be invoked immediately if there is no animation
        setTimeout(function () {
          dataGroup.removeClipPath();
        });
      });
      dataGroup.setClipPath(clipPath);
    }

    this._data = data;

    function add(newDataIndex) {
      addEl(data, dataGroup, newDataIndex, dimensions, coordSys, null, smooth);
    }

    function update(newDataIndex, oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
      data.setItemGraphicEl(newDataIndex, line);
      var animationModel = payload && payload.animation === false ? null : seriesModel;
      graphic.updateProps(line, {
        shape: {
          points: points
        }
      }, animationModel, newDataIndex);
    }

    function remove(oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      dataGroup.remove(line);
    }
  },

  /**
   * @private
   */
  // _renderForProgressive: function (seriesModel) {
  //     var dataGroup = this._dataGroup;
  //     var data = seriesModel.getData();
  //     var oldData = this._data;
  //     var coordSys = seriesModel.coordinateSystem;
  //     var dimensions = coordSys.dimensions;
  //     var option = seriesModel.option;
  //     var progressive = option.progressive;
  //     var smooth = option.smooth ? SMOOTH : null;
  //     // In progressive animation is disabled, so use simple data diff,
  //     // which effects performance less.
  //     // (Typically performance for data with length 7000+ like:
  //     // simpleDiff: 60ms, addEl: 184ms,
  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
  //     if (simpleDiff(oldData, data, dimensions)) {
  //         dataGroup.removeAll();
  //         data.each(function (dataIndex) {
  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
  //         });
  //     }
  //     updateElCommon(data, progressive, smooth);
  //     // Consider switch between progressive and not.
  //     data.__plProgressive = true;
  //     this._data = data;
  // },

  /**
   * @override
   */
  remove: function () {
    this._dataGroup && this._dataGroup.removeAll();
    this._data = null;
  }
});

function createGridClipShape(coordSys, seriesModel, cb) {
  var parallelModel = coordSys.model;
  var rect = coordSys.getRect();
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    }
  });
  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
  rectEl.setShape(dim, 0);
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width,
      height: rect.height
    }
  }, seriesModel, cb);
  return rectEl;
}

function createLinePoints(data, dataIndex, dimensions, coordSys) {
  var points = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimName = dimensions[i];
    var value = data.get(dimName, dataIndex);

    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
      points.push(coordSys.dataToPoint(value, dimName));
    }
  }

  return points;
}

function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
  var line = new graphic.Polyline({
    shape: {
      points: points
    },
    silent: true,
    z2: 10
  });
  dataGroup.add(line);
  data.setItemGraphicEl(dataIndex, line);
}

function updateElCommon(data, smooth) {
  var seriesStyleModel = data.hostModel.getModel('lineStyle.normal');
  var lineStyle = seriesStyleModel.getLineStyle();
  data.eachItemGraphicEl(function (line, dataIndex) {
    if (data.hasItemOption) {
      var itemModel = data.getItemModel(dataIndex);
      var lineStyleModel = itemModel.getModel('lineStyle.normal', seriesStyleModel);
      lineStyle = lineStyleModel.getLineStyle(['color', 'stroke']);
    }

    line.useStyle(zrUtil.extend(lineStyle, {
      fill: null,
      // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
      stroke: data.getItemVisual(dataIndex, 'color'),
      // lineStyle.opacity have been set to itemVisual in parallelVisual.
      opacity: data.getItemVisual(dataIndex, 'opacity')
    }));
    line.shape.smooth = smooth;
  });
} // function simpleDiff(oldData, newData, dimensions) {
//     var oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     var dimLen = dimensions.length;
//     for (var i = 0; i < oldLen; i++) {
//         for (var j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME
// 公用方法?


function isEmptyValue(val, axisType) {
  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}

var _default = ParallelView;
module.exports = _default;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];

function _default(ecModel) {
  ecModel.eachSeriesByType('parallel', function (seriesModel) {
    var itemStyleModel = seriesModel.getModel('itemStyle.normal');
    var lineStyleModel = seriesModel.getModel('lineStyle.normal');
    var globalColors = ecModel.get('color');
    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
    var inactiveOpacity = seriesModel.get('inactiveOpacity');
    var activeOpacity = seriesModel.get('activeOpacity');
    var lineStyle = seriesModel.getModel('lineStyle.normal').getLineStyle();
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var opacityMap = {
      normal: lineStyle.opacity,
      active: activeOpacity,
      inactive: inactiveOpacity
    };
    coordSys.eachActiveState(data, function (activeState, dataIndex) {
      var itemModel = data.getItemModel(dataIndex);
      var opacity = opacityMap[activeState];

      if (activeState === 'normal') {
        var itemOpacity = itemModel.get(opacityAccessPath, true);
        itemOpacity != null && (opacity = itemOpacity);
      }

      data.setItemVisual(dataIndex, 'opacity', opacity);
    });
    data.setVisual('color', color);
  });
}

module.exports = _default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(281);

__webpack_require__(1370);

__webpack_require__(1371);

var barLayoutGrid = __webpack_require__(283);

var visualSymbol = __webpack_require__(106);

__webpack_require__(144);

// In case developer forget to include grid component
echarts.registerLayout(zrUtil.curry(barLayoutGrid, 'pictorialBar'));
echarts.registerVisual(zrUtil.curry(visualSymbol, 'pictorialBar', 'roundRect', null));

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1441);

__webpack_require__(1442);

var createDataSelectAction = __webpack_require__(439);

var dataColor = __webpack_require__(287);

var pieLayout = __webpack_require__(1444);

var dataFilter = __webpack_require__(194);

createDataSelectAction('pie', [{
  type: 'pieToggleSelect',
  event: 'pieselectchanged',
  method: 'toggleSelected'
}, {
  type: 'pieSelect',
  event: 'pieselected',
  method: 'select'
}, {
  type: 'pieUnSelect',
  event: 'pieunselected',
  method: 'unSelect'
}]);
echarts.registerVisual(zrUtil.curry(dataColor, 'pie'));
echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
echarts.registerProcessor(zrUtil.curry(dataFilter, 'pie'));

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var List = __webpack_require__(31);

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var _number = __webpack_require__(8);

var getPercentWithPrecision = _number.getPercentWithPrecision;

var completeDimensions = __webpack_require__(58);

var dataSelectableMixin = __webpack_require__(277);

var PieSeries = echarts.extendSeriesModel({
  type: 'series.pie',
  // Overwrite
  init: function (option) {
    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendDataProvider = function () {
      return this.getRawData();
    };

    this.updateSelectedMap(option.data);

    this._defaultLabelLine(option);
  },
  // Overwrite
  mergeOption: function (newOption) {
    PieSeries.superCall(this, 'mergeOption', newOption);
    this.updateSelectedMap(this.option.data);
  },
  getInitialData: function (option, ecModel) {
    var dimensions = completeDimensions(['value'], option.data);
    var list = new List(dimensions, this);
    list.initData(option.data);
    return list;
  },
  // Overwrite
  getDataParams: function (dataIndex) {
    var data = this.getData();
    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?

    var valueList = [];
    data.each('value', function (value) {
      valueList.push(value);
    });
    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
    params.$vars.push('percent');
    return params;
  },
  _defaultLabelLine: function (option) {
    // Extend labelLine emphasis
    modelUtil.defaultEmphasis(option.labelLine, ['show']);
    var labelLineNormalOpt = option.labelLine.normal;
    var labelLineEmphasisOpt = option.labelLine.emphasis; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.normal.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.label.emphasis.show;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // 选中时扇区偏移量
    selectedOffset: 10,
    // 高亮扇区偏移量
    hoverOffset: 10,
    // If use strategy to avoid label overlapping
    avoidLabelOverlap: true,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
    // roseType: null,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // cursor: null,
    label: {
      normal: {
        // If rotate around circle
        rotate: false,
        show: true,
        // 'outer', 'inside', 'center'
        position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        // 默认使用全局文本样式，详见TEXTSTYLE
        // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数

      },
      emphasis: {}
    },
    // Enabled when label.normal.position is 'outer'
    labelLine: {
      normal: {
        show: true,
        // 引导线两段中的第一段长度
        length: 15,
        // 引导线两段中的第二段长度
        length2: 15,
        smooth: false,
        lineStyle: {
          // color: 各异,
          width: 1,
          type: 'solid'
        }
      }
    },
    itemStyle: {
      normal: {
        borderWidth: 1
      },
      emphasis: {}
    },
    // Animation type canbe expansion, scale
    animationType: 'expansion',
    animationEasing: 'cubicOut',
    data: []
  }
});
zrUtil.mixin(PieSeries, dataSelectableMixin);
var _default = PieSeries;
module.exports = _default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var ChartView = __webpack_require__(87);

/**
 * @param {module:echarts/model/Series} seriesModel
 * @param {boolean} hasAnimation
 * @inner
 */
function updateDataSelected(uid, seriesModel, hasAnimation, api) {
  var data = seriesModel.getData();
  var dataIndex = this.dataIndex;
  var name = data.getName(dataIndex);
  var selectedOffset = seriesModel.get('selectedOffset');
  api.dispatchAction({
    type: 'pieToggleSelect',
    from: uid,
    name: name,
    seriesId: seriesModel.id
  });
  data.each(function (idx) {
    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
  });
}
/**
 * @param {module:zrender/graphic/Sector} el
 * @param {Object} layout
 * @param {boolean} isSelected
 * @param {number} selectedOffset
 * @param {boolean} hasAnimation
 * @inner
 */


function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
  var midAngle = (layout.startAngle + layout.endAngle) / 2;
  var dx = Math.cos(midAngle);
  var dy = Math.sin(midAngle);
  var offset = isSelected ? selectedOffset : 0;
  var position = [dx * offset, dy * offset];
  hasAnimation // animateTo will stop revious animation like update transition
  ? el.animate().when(200, {
    position: position
  }).start('bounceOut') : el.attr('position', position);
}
/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */


function PiePiece(data, idx) {
  graphic.Group.call(this);
  var sector = new graphic.Sector({
    z2: 2
  });
  var polyline = new graphic.Polyline();
  var text = new graphic.Text();
  this.add(sector);
  this.add(polyline);
  this.add(text);
  this.updateData(data, idx, true); // Hover to change label and labelLine

  function onEmphasis() {
    polyline.ignore = polyline.hoverIgnore;
    text.ignore = text.hoverIgnore;
  }

  function onNormal() {
    polyline.ignore = polyline.normalIgnore;
    text.ignore = text.normalIgnore;
  }

  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
}

var piePieceProto = PiePiece.prototype;

piePieceProto.updateData = function (data, idx, firstCreate) {
  var sector = this.childAt(0);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var sectorShape = zrUtil.extend({}, layout);
  sectorShape.label = null;

  if (firstCreate) {
    sector.setShape(sectorShape);
    var animationType = seriesModel.getShallow('animationType');

    if (animationType === 'scale') {
      sector.shape.r = layout.r0;
      graphic.initProps(sector, {
        shape: {
          r: layout.r
        }
      }, seriesModel, idx);
    } // Expansion
    else {
        sector.shape.endAngle = layout.startAngle;
        graphic.updateProps(sector, {
          shape: {
            endAngle: layout.endAngle
          }
        }, seriesModel, idx);
      }
  } else {
    graphic.updateProps(sector, {
      shape: sectorShape
    }, seriesModel, idx);
  } // Update common style


  var itemStyleModel = itemModel.getModel('itemStyle');
  var visualColor = data.getItemVisual(idx, 'color');
  sector.useStyle(zrUtil.defaults({
    lineJoin: 'bevel',
    fill: visualColor
  }, itemStyleModel.getModel('normal').getItemStyle()));
  sector.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected

  toggleItemSelected(this, data.getItemLayout(idx), itemModel.get('selected'), seriesModel.get('selectedOffset'), seriesModel.get('animation'));

  function onEmphasis() {
    // Sector may has animation of updating data. Force to move to the last frame
    // Or it may stopped on the wrong shape
    sector.stopAnimation(true);
    sector.animateTo({
      shape: {
        r: layout.r + seriesModel.get('hoverOffset')
      }
    }, 300, 'elasticOut');
  }

  function onNormal() {
    sector.stopAnimation(true);
    sector.animateTo({
      shape: {
        r: layout.r
      }
    }, 300, 'elasticOut');
  }

  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');

  if (itemModel.get('hoverAnimation') && seriesModel.isAnimationEnabled()) {
    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
  }

  this._updateLabel(data, idx);

  graphic.setHoverStyle(this);
};

piePieceProto._updateLabel = function (data, idx) {
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var labelLayout = layout.label;
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.updateProps(labelLine, {
    shape: {
      points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
    }
  }, seriesModel, idx);
  graphic.updateProps(labelText, {
    style: {
      x: labelLayout.x,
      y: labelLayout.y
    }
  }, seriesModel, idx);
  labelText.attr({
    rotation: labelLayout.rotation,
    origin: [labelLayout.x, labelLayout.y],
    z2: 10
  });
  var labelModel = itemModel.getModel('label.normal');
  var labelHoverModel = itemModel.getModel('label.emphasis');
  var labelLineModel = itemModel.getModel('labelLine.normal');
  var labelLineHoverModel = itemModel.getModel('labelLine.emphasis');
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
    labelFetcher: data.hostModel,
    labelDataIndex: idx,
    defaultText: data.getName(idx),
    autoColor: visualColor,
    useInsideStyle: !!labelLayout.inside
  }, {
    textAlign: labelLayout.textAlign,
    textVerticalAlign: labelLayout.verticalAlign,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
  labelText.hoverIgnore = !labelHoverModel.get('show');
  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color

  labelLine.setStyle({
    stroke: visualColor,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
  var smooth = labelLineModel.get('smooth');

  if (smooth && smooth === true) {
    smooth = 0.4;
  }

  labelLine.setShape({
    smooth: smooth
  });
};

zrUtil.inherits(PiePiece, graphic.Group); // Pie view

var PieView = ChartView.extend({
  type: 'pie',
  init: function () {
    var sectorGroup = new graphic.Group();
    this._sectorGroup = sectorGroup;
  },
  render: function (seriesModel, ecModel, api, payload) {
    if (payload && payload.from === this.uid) {
      return;
    }

    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var hasAnimation = ecModel.get('animation');
    var isFirstRender = !oldData;
    var animationType = seriesModel.get('animationType');
    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
    var selectedMode = seriesModel.get('selectedMode');
    data.diff(oldData).add(function (idx) {
      var piePiece = new PiePiece(data, idx); // Default expansion animation

      if (isFirstRender && animationType !== 'scale') {
        piePiece.eachChild(function (child) {
          child.stopAnimation(true);
        });
      }

      selectedMode && piePiece.on('click', onSectorClick);
      data.setItemGraphicEl(idx, piePiece);
      group.add(piePiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx);
      piePiece.off('click');
      selectedMode && piePiece.on('click', onSectorClick);
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      group.remove(piePiece);
    }).execute();

    if (hasAnimation && isFirstRender && data.count() > 0 // Default expansion animation
    && animationType !== 'scale') {
      var shape = data.getItemLayout(0);
      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel));
    }

    this._data = data;
  },
  dispose: function () {},
  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel) {
    var clipPath = new graphic.Sector({
      shape: {
        cx: cx,
        cy: cy,
        r0: 0,
        r: r,
        startAngle: startAngle,
        endAngle: startAngle,
        clockwise: clockwise
      }
    });
    graphic.initProps(clipPath, {
      shape: {
        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
      }
    }, seriesModel, cb);
    return clipPath;
  },

  /**
   * @implement
   */
  containPoint: function (point, seriesModel) {
    var data = seriesModel.getData();
    var itemLayout = data.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  }
});
var _default = PieView;
module.exports = _default;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var textContain = __webpack_require__(70);

// FIXME emphasis label position is not same with normal label position
function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight) {
  list.sort(function (a, b) {
    return a.y - b.y;
  }); // 压

  function shiftDown(start, end, delta, dir) {
    for (var j = start; j < end; j++) {
      list[j].y += delta;

      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
        shiftUp(j, delta / 2);
        return;
      }
    }

    shiftUp(end - 1, delta / 2);
  } // 弹


  function shiftUp(end, delta) {
    for (var j = end; j >= 0; j--) {
      list[j].y -= delta;

      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
        break;
      }
    }
  }

  function changeX(list, isDownList, cx, cy, r, dir) {
    var lastDeltaX = dir > 0 ? isDownList // 右侧
    ? Number.MAX_VALUE // 下
    : 0 // 上
    : isDownList // 左侧
    ? Number.MAX_VALUE // 下
    : 0; // 上

    for (var i = 0, l = list.length; i < l; i++) {
      // Not change x for center label
      if (list[i].position === 'center') {
        continue;
      }

      var deltaY = Math.abs(list[i].y - cy);
      var length = list[i].len;
      var length2 = list[i].len2;
      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);

      if (isDownList && deltaX >= lastDeltaX) {
        // 右下，左下
        deltaX = lastDeltaX - 10;
      }

      if (!isDownList && deltaX <= lastDeltaX) {
        // 右上，左上
        deltaX = lastDeltaX + 10;
      }

      list[i].x = cx + deltaX * dir;
      lastDeltaX = deltaX;
    }
  }

  var lastY = 0;
  var delta;
  var len = list.length;
  var upList = [];
  var downList = [];

  for (var i = 0; i < len; i++) {
    delta = list[i].y - lastY;

    if (delta < 0) {
      shiftDown(i, len, -delta, dir);
    }

    lastY = list[i].y + list[i].height;
  }

  if (viewHeight - lastY < 0) {
    shiftUp(len - 1, lastY - viewHeight);
  }

  for (var i = 0; i < len; i++) {
    if (list[i].y >= cy) {
      downList.push(list[i]);
    } else {
      upList.push(list[i]);
    }
  }

  changeX(upList, false, cx, cy, r, dir);
  changeX(downList, true, cx, cy, r, dir);
}

function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight) {
  var leftList = [];
  var rightList = [];

  for (var i = 0; i < labelLayoutList.length; i++) {
    if (labelLayoutList[i].x < cx) {
      leftList.push(labelLayoutList[i]);
    } else {
      rightList.push(labelLayoutList[i]);
    }
  }

  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight);
  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight);

  for (var i = 0; i < labelLayoutList.length; i++) {
    var linePoints = labelLayoutList[i].linePoints;

    if (linePoints) {
      var dist = linePoints[1][0] - linePoints[2][0];

      if (labelLayoutList[i].x < cx) {
        linePoints[2][0] = labelLayoutList[i].x + 3;
      } else {
        linePoints[2][0] = labelLayoutList[i].x - 3;
      }

      linePoints[1][1] = linePoints[2][1] = labelLayoutList[i].y;
      linePoints[1][0] = linePoints[2][0] + dist;
    }
  }
}

function _default(seriesModel, r, viewWidth, viewHeight) {
  var data = seriesModel.getData();
  var labelLayoutList = [];
  var cx;
  var cy;
  var hasLabelRotate = false;
  data.each(function (idx) {
    var layout = data.getItemLayout(idx);
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label.normal'); // Use position in normal or emphasis

    var labelPosition = labelModel.get('position') || itemModel.get('label.emphasis.position');
    var labelLineModel = itemModel.getModel('labelLine.normal');
    var labelLineLen = labelLineModel.get('length');
    var labelLineLen2 = labelLineModel.get('length2');
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var textX;
    var textY;
    var linePoints;
    var textAlign;
    cx = layout.cx;
    cy = layout.cy;
    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';

    if (labelPosition === 'center') {
      textX = layout.cx;
      textY = layout.cy;
      textAlign = 'center';
    } else {
      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
      textX = x1 + dx * 3;
      textY = y1 + dy * 3;

      if (!isLabelInside) {
        // For roseType
        var x2 = x1 + dx * (labelLineLen + r - layout.r);
        var y2 = y1 + dy * (labelLineLen + r - layout.r);
        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
        var y3 = y2;
        textX = x3 + (dx < 0 ? -5 : 5);
        textY = y3;
        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
      }

      textAlign = isLabelInside ? 'center' : dx > 0 ? 'left' : 'right';
    }

    var font = labelModel.getFont();
    var labelRotate = labelModel.get('rotate') ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
    hasLabelRotate = !!labelRotate;
    layout.label = {
      x: textX,
      y: textY,
      position: labelPosition,
      height: textRect.height,
      len: labelLineLen,
      len2: labelLineLen2,
      linePoints: linePoints,
      textAlign: textAlign,
      verticalAlign: 'middle',
      rotation: labelRotate,
      inside: isLabelInside
    }; // Not layout the inside label

    if (!isLabelInside) {
      labelLayoutList.push(layout.label);
    }
  });

  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight);
  }
}

module.exports = _default;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var linearMap = _number.linearMap;

var labelLayout = __webpack_require__(1443);

var zrUtil = __webpack_require__(0);

var PI2 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function _default(seriesType, ecModel, api, payload) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!zrUtil.isArray(radius)) {
      radius = [0, radius];
    }

    if (!zrUtil.isArray(center)) {
      center = [center, center];
    }

    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = parsePercent(center[0], width);
    var cy = parsePercent(center[1], height);
    var r0 = parsePercent(radius[0], size / 2);
    var r = parsePercent(radius[1], size / 2);
    var data = seriesModel.getData();
    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var validDataCount = 0;
    data.each('value', function (value) {
      !isNaN(value) && validDataCount++;
    });
    var sum = data.getSum('value'); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var clockwise = seriesModel.get('clockwise');
    var roseType = seriesModel.get('roseType');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]

    var extent = data.getDataExtent('value');
    extent[0] = 0; // In the case some sector angle is smaller than minAngle

    var restAngle = PI2;
    var valueSumLargerThanMinAngle = 0;
    var currentAngle = startAngle;
    var dir = clockwise ? 1 : -1;
    data.each('value', function (value, idx) {
      var angle;

      if (isNaN(value)) {
        data.setItemLayout(idx, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: r0,
          r: roseType ? NaN : r
        });
        return;
      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？


      if (roseType !== 'area') {
        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
      } else {
        angle = PI2 / validDataCount;
      }

      if (angle < minAngle) {
        angle = minAngle;
        restAngle -= minAngle;
      } else {
        valueSumLargerThanMinAngle += value;
      }

      var endAngle = currentAngle + dir * angle;
      data.setItemLayout(idx, {
        angle: angle,
        startAngle: currentAngle,
        endAngle: endAngle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: r0,
        r: roseType ? linearMap(value, extent, [r0, r]) : r
      });
      currentAngle = endAngle;
    }, true); // Some sector is constrained by minAngle
    // Rest sectors needs recalculate angle

    if (restAngle < PI2 && validDataCount) {
      // Average the angle if rest angle is not enough after all angles is
      // Constrained by minAngle
      if (restAngle <= 1e-3) {
        var angle = PI2 / validDataCount;
        data.each('value', function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            layout.angle = angle;
            layout.startAngle = startAngle + dir * idx * angle;
            layout.endAngle = startAngle + dir * (idx + 1) * angle;
          }
        });
      } else {
        unitRadian = restAngle / valueSumLargerThanMinAngle;
        currentAngle = startAngle;
        data.each('value', function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
            layout.startAngle = currentAngle;
            layout.endAngle = currentAngle + dir * angle;
            currentAngle += dir * angle;
          }
        });
      }
    }

    labelLayout(seriesModel, r, width, height);
  });
}

module.exports = _default;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1531);

__webpack_require__(1446);

__webpack_require__(1447);

var dataColor = __webpack_require__(287);

var visualSymbol = __webpack_require__(106);

var radarLayout = __webpack_require__(1449);

var dataFilter = __webpack_require__(194);

var backwardCompat = __webpack_require__(1448);

// Must use radar component
echarts.registerVisual(zrUtil.curry(dataColor, 'radar'));
echarts.registerVisual(zrUtil.curry(visualSymbol, 'radar', 'circle', null));
echarts.registerLayout(radarLayout);
echarts.registerProcessor(zrUtil.curry(dataFilter, 'radar'));
echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(35);

var List = __webpack_require__(31);

var completeDimensions = __webpack_require__(58);

var zrUtil = __webpack_require__(0);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;
var RadarSeries = SeriesModel.extend({
  type: 'series.radar',
  dependencies: ['radar'],
  // Overwrite
  init: function (option) {
    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendDataProvider = function () {
      return this.getRawData();
    };
  },
  getInitialData: function (option, ecModel) {
    var data = option.data || [];
    var dimensions = completeDimensions([], data, {
      extraPrefix: 'indicator_',
      extraFromZero: true
    });
    var list = new List(dimensions, this);
    list.initData(data);
    return list;
  },
  formatTooltip: function (dataIndex) {
    var value = this.getRawValue(dataIndex);
    var coordSys = this.coordinateSystem;
    var indicatorAxes = coordSys.getIndicatorAxes();
    var name = this.getData().getName(dataIndex);
    return encodeHTML(name === '' ? this.name : name) + '<br/>' + zrUtil.map(indicatorAxes, function (axis, idx) {
      return encodeHTML(axis.name + ' : ' + value[idx]);
    }).join('<br />');
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'radar',
    legendHoverLink: true,
    radarIndex: 0,
    lineStyle: {
      normal: {
        width: 2,
        type: 'solid'
      }
    },
    label: {
      normal: {
        position: 'top'
      }
    },
    // areaStyle: {
    // },
    // itemStyle: {}
    symbol: 'emptyCircle',
    symbolSize: 4 // symbolRotate: null

  }
});
var _default = RadarSeries;
module.exports = _default;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var graphic = __webpack_require__(5);

var zrUtil = __webpack_require__(0);

var symbolUtil = __webpack_require__(52);

function normalizeSymbolSize(symbolSize) {
  if (!zrUtil.isArray(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return symbolSize;
}

var _default = echarts.extendChartView({
  type: 'radar',
  render: function (seriesModel, ecModel, api) {
    var polar = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;

    function createSymbol(data, idx) {
      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
      var color = data.getItemVisual(idx, 'color');

      if (symbolType === 'none') {
        return;
      }

      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
      symbolPath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 100,
        scale: [symbolSize[0] / 2, symbolSize[1] / 2]
      });
      return symbolPath;
    }

    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
      // Simply rerender all
      symbolGroup.removeAll();

      for (var i = 0; i < newPoints.length - 1; i++) {
        var symbolPath = createSymbol(data, idx);

        if (symbolPath) {
          symbolPath.__dimIdx = i;

          if (oldPoints[i]) {
            symbolPath.attr('position', oldPoints[i]);
            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
              position: newPoints[i]
            }, seriesModel, idx);
          } else {
            symbolPath.attr('position', newPoints[i]);
          }

          symbolGroup.add(symbolPath);
        }
      }
    }

    function getInitialPoints(points) {
      return zrUtil.map(points, function (pt) {
        return [polar.cx, polar.cy];
      });
    }

    data.diff(oldData).add(function (idx) {
      var points = data.getItemLayout(idx);

      if (!points) {
        return;
      }

      var polygon = new graphic.Polygon();
      var polyline = new graphic.Polyline();
      var target = {
        shape: {
          points: points
        }
      };
      polygon.shape.points = getInitialPoints(points);
      polyline.shape.points = getInitialPoints(points);
      graphic.initProps(polygon, target, seriesModel, idx);
      graphic.initProps(polyline, target, seriesModel, idx);
      var itemGroup = new graphic.Group();
      var symbolGroup = new graphic.Group();
      itemGroup.add(polyline);
      itemGroup.add(polygon);
      itemGroup.add(symbolGroup);
      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
      data.setItemGraphicEl(idx, itemGroup);
    }).update(function (newIdx, oldIdx) {
      var itemGroup = oldData.getItemGraphicEl(oldIdx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var target = {
        shape: {
          points: data.getItemLayout(newIdx)
        }
      };

      if (!target.shape.points) {
        return;
      }

      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
      graphic.updateProps(polyline, target, seriesModel);
      graphic.updateProps(polygon, target, seriesModel);
      data.setItemGraphicEl(newIdx, itemGroup);
    }).remove(function (idx) {
      group.remove(oldData.getItemGraphicEl(idx));
    }).execute();
    data.eachItemGraphicEl(function (itemGroup, idx) {
      var itemModel = data.getItemModel(idx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var color = data.getItemVisual(idx, 'color');
      group.add(itemGroup);
      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle.normal').getLineStyle(), {
        fill: 'none',
        stroke: color
      }));
      polyline.hoverStyle = itemModel.getModel('lineStyle.emphasis').getLineStyle();
      var areaStyleModel = itemModel.getModel('areaStyle.normal');
      var hoverAreaStyleModel = itemModel.getModel('areaStyle.emphasis');
      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
      polygon.ignore = polygonIgnore;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: color,
        opacity: 0.7
      }));
      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
      var itemStyle = itemModel.getModel('itemStyle.normal').getItemStyle(['color']);
      var itemHoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
      var labelModel = itemModel.getModel('label.normal');
      var labelHoverModel = itemModel.getModel('label.emphasis');
      symbolGroup.eachChild(function (symbolPath) {
        symbolPath.setStyle(itemStyle);
        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
          labelFetcher: data.hostModel,
          labelDataIndex: idx,
          labelDimIndex: symbolPath.__dimIdx,
          defaultText: data.get(data.dimensions[symbolPath.__dimIdx], idx),
          autoColor: color,
          isRectText: true
        });
      });

      function onEmphasis() {
        polygon.attr('ignore', hoverPolygonIgnore);
      }

      function onNormal() {
        polygon.attr('ignore', polygonIgnore);
      }

      itemGroup.off('mouseover').off('mouseout').off('normal').off('emphasis');
      itemGroup.on('emphasis', onEmphasis).on('mouseover', onEmphasis).on('normal', onNormal).on('mouseout', onNormal);
      graphic.setHoverStyle(itemGroup);
    });
    this._data = data;
  },
  remove: function () {
    this.group.removeAll();
    this._data = null;
  },
  dispose: function () {}
});

module.exports = _default;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

// Backward compat for radar chart in 2
function _default(option) {
  var polarOptArr = option.polar;

  if (polarOptArr) {
    if (!zrUtil.isArray(polarOptArr)) {
      polarOptArr = [polarOptArr];
    }

    var polarNotRadar = [];
    zrUtil.each(polarOptArr, function (polarOpt, idx) {
      if (polarOpt.indicator) {
        if (polarOpt.type && !polarOpt.shape) {
          polarOpt.shape = polarOpt.type;
        }

        option.radar = option.radar || [];

        if (!zrUtil.isArray(option.radar)) {
          option.radar = [option.radar];
        }

        option.radar.push(polarOpt);
      } else {
        polarNotRadar.push(polarOpt);
      }
    });
    option.polar = polarNotRadar;
  }

  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
      seriesOpt.radarIndex = seriesOpt.polarIndex;
    }
  });
}

module.exports = _default;

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

function _default(ecModel) {
  ecModel.eachSeriesByType('radar', function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    function pointsConverter(val, idx) {
      points[idx] = points[idx] || [];
      points[idx][i] = coordSys.dataToPoint(val, i);
    }

    for (var i = 0; i < coordSys.getIndicatorAxes().length; i++) {
      var dim = data.dimensions[i];
      data.each(dim, pointsConverter);
    }

    data.each(function (idx) {
      // Close polygon
      points[idx][0] && points[idx].push(points[idx][0].slice());
      data.setItemLayout(idx, points[idx]);
    });
  });
}

module.exports = _default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1451);

__webpack_require__(1452);

var sankeyLayout = __webpack_require__(1453);

var sankeyVisual = __webpack_require__(1454);

echarts.registerLayout(sankeyLayout);
echarts.registerVisual(sankeyVisual);

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(35);

var createGraphFromNodeEdge = __webpack_require__(448);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;

/**
 * @file Get initial data and define sankey view's series model
 * @author Deqing Li(annong035@gmail.com)
 */
var SankeySeries = SeriesModel.extend({
  type: 'series.sankey',
  layoutInfo: null,

  /**
   * Init a graph data structure from data in option series
   *
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */
  getInitialData: function (option) {
    var links = option.edges || option.links;
    var nodes = option.data || option.nodes;

    if (nodes && links) {
      var graph = createGraphFromNodeEdge(nodes, links, this, true);
      return graph.data;
    }
  },

  /**
   * Return the graphic data structure
   *
   * @return {module:echarts/data/Graph} graphic data structure
   */
  getGraph: function () {
    return this.getData().graph;
  },

  /**
   * Get edge data of graphic data structure
   *
   * @return {module:echarts/data/List} data structure of list
   */
  getEdgeData: function () {
    return this.getGraph().edgeData;
  },

  /**
   * @override
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    // dataType === 'node' or empty do not show tooltip by default
    if (dataType === 'edge') {
      var params = this.getDataParams(dataIndex, dataType);
      var rawDataOpt = params.data;
      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;

      if (params.value) {
        html += ' : ' + params.value;
      }

      return encodeHTML(html);
    }

    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    layout: null,
    // the position of the whole view
    left: '5%',
    top: '5%',
    right: '20%',
    bottom: '5%',
    // the dx of the node
    nodeWidth: 20,
    // the vertical distance between two nodes
    nodeGap: 8,
    // the number of iterations to change the position of the node
    layoutIterations: 32,
    label: {
      normal: {
        show: true,
        position: 'right',
        color: '#000',
        fontSize: 12
      },
      emphasis: {
        show: true
      }
    },
    itemStyle: {
      normal: {
        borderWidth: 1,
        borderColor: '#333'
      }
    },
    lineStyle: {
      normal: {
        color: '#314656',
        opacity: 0.2,
        curveness: 0.5
      },
      emphasis: {
        opacity: 0.6
      }
    },
    animationEasing: 'linear',
    animationDuration: 1000
  }
});
var _default = SankeySeries;
module.exports = _default;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var echarts = __webpack_require__(4);

/**
 * @file  The file used to draw sankey view
 * @author  Deqing Li(annong035@gmail.com)
 */
var SankeyShape = graphic.extendShape({
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    cpx2: 0,
    cpy2: 0,
    extent: 0
  },
  buildPath: function (ctx, shape) {
    var halfExtent = shape.extent / 2;
    ctx.moveTo(shape.x1, shape.y1 - halfExtent);
    ctx.bezierCurveTo(shape.cpx1, shape.cpy1 - halfExtent, shape.cpx2, shape.cpy2 - halfExtent, shape.x2, shape.y2 - halfExtent);
    ctx.lineTo(shape.x2, shape.y2 + halfExtent);
    ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + halfExtent, shape.cpx1, shape.cpy1 + halfExtent, shape.x1, shape.y1 + halfExtent);
    ctx.closePath();
  }
});

var _default = echarts.extendChartView({
  type: 'sankey',

  /**
   * @private
   * @type {module:echarts/chart/sankey/SankeySeries}
   */
  _model: null,
  render: function (seriesModel, ecModel, api) {
    var graph = seriesModel.getGraph();
    var group = this.group;
    var layoutInfo = seriesModel.layoutInfo;
    var nodeData = seriesModel.getData();
    var edgeData = seriesModel.getData('edge');
    this._model = seriesModel;
    group.removeAll();
    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge

    graph.eachEdge(function (edge) {
      var curve = new SankeyShape();
      curve.dataIndex = edge.dataIndex;
      curve.seriesIndex = seriesModel.seriesIndex;
      curve.dataType = 'edge';
      var lineStyleModel = edge.getModel('lineStyle.normal');
      var curvature = lineStyleModel.get('curveness');
      var n1Layout = edge.node1.getLayout();
      var n2Layout = edge.node2.getLayout();
      var edgeLayout = edge.getLayout();
      curve.shape.extent = Math.max(1, edgeLayout.dy);
      var x1 = n1Layout.x + n1Layout.dx;
      var y1 = n1Layout.y + edgeLayout.sy + edgeLayout.dy / 2;
      var x2 = n2Layout.x;
      var y2 = n2Layout.y + edgeLayout.ty + edgeLayout.dy / 2;
      var cpx1 = x1 * (1 - curvature) + x2 * curvature;
      var cpy1 = y1;
      var cpx2 = x1 * curvature + x2 * (1 - curvature);
      var cpy2 = y2;
      curve.setShape({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
      });
      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color

      switch (curve.style.fill) {
        case 'source':
          curve.style.fill = edge.node1.getVisual('color');
          break;

        case 'target':
          curve.style.fill = edge.node2.getVisual('color');
          break;
      }

      graphic.setHoverStyle(curve, edge.getModel('lineStyle.emphasis').getItemStyle());
      group.add(curve);
      edgeData.setItemGraphicEl(edge.dataIndex, curve);
    }); // generate a rect  for each node

    graph.eachNode(function (node) {
      var layout = node.getLayout();
      var itemModel = node.getModel();
      var labelModel = itemModel.getModel('label.normal');
      var labelHoverModel = itemModel.getModel('label.emphasis');
      var rect = new graphic.Rect({
        shape: {
          x: layout.x,
          y: layout.y,
          width: node.getLayout().dx,
          height: node.getLayout().dy
        },
        style: itemModel.getModel('itemStyle.normal').getItemStyle()
      });
      var hoverStyle = node.getModel('itemStyle.emphasis').getItemStyle();
      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
        labelFetcher: seriesModel,
        labelDataIndex: node.dataIndex,
        defaultText: node.id,
        isRectText: true
      });
      rect.setStyle('fill', node.getVisual('color'));
      graphic.setHoverStyle(rect, hoverStyle);
      group.add(rect);
      nodeData.setItemGraphicEl(node.dataIndex, rect);
      rect.dataType = 'node';
    });

    if (!this._data && seriesModel.get('animation')) {
      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
        group.removeClipPath();
      }));
    }

    this._data = seriesModel.getData();
  },
  dispose: function () {}
}); // add animation to the view


function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width + 20,
      height: rect.height + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

module.exports = _default;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var layout = __webpack_require__(17);

var nest = __webpack_require__(490);

var zrUtil = __webpack_require__(0);

/**
 * @file The layout algorithm of sankey view
 * @author  Deqing Li(annong035@gmail.com)
 */
function _default(ecModel, api, payload) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var nodeWidth = seriesModel.get('nodeWidth');
    var nodeGap = seriesModel.get('nodeGap');
    var layoutInfo = getViewRect(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var width = layoutInfo.width;
    var height = layoutInfo.height;
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    var edges = graph.edges;
    computeNodeValues(nodes);
    var filteredNodes = zrUtil.filter(nodes, function (node) {
      return node.getLayout().value === 0;
    });
    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations);
  });
}
/**
 * Get the layout position of the whole view
 *
 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
 */


function getViewRect(seriesModel, api) {
  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations) {
  computeNodeBreadths(nodes, nodeWidth, width);
  computeNodeDepths(nodes, edges, height, nodeGap, iterations);
  computeEdgeDepths(nodes);
}
/**
 * Compute the value of each node by summing the associated edge's value
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */


function computeNodeValues(nodes) {
  zrUtil.each(nodes, function (node) {
    var value1 = sum(node.outEdges, getEdgeValue);
    var value2 = sum(node.inEdges, getEdgeValue);
    var value = Math.max(value1, value2);
    node.setLayout({
      value: value
    }, true);
  });
}
/**
 * Compute the x-position for each node
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param  {number} nodeWidth  the dx of the node
 * @param  {number} width  the whole width of the area to draw the view
 */


function computeNodeBreadths(nodes, nodeWidth, width) {
  var remainNodes = nodes;
  var nextNode = null;
  var x = 0;
  var kx = 0;

  while (remainNodes.length) {
    nextNode = [];

    for (var i = 0, len = remainNodes.length; i < len; i++) {
      var node = remainNodes[i];
      node.setLayout({
        x: x
      }, true);
      node.setLayout({
        dx: nodeWidth
      }, true);

      for (var j = 0, lenj = node.outEdges.length; j < lenj; j++) {
        nextNode.push(node.outEdges[j].node2);
      }
    }

    remainNodes = nextNode;
    ++x;
  }

  moveSinksRight(nodes, x);
  kx = (width - nodeWidth) / (x - 1);
  scaleNodeBreadths(nodes, kx);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {number} x  value (x-1) use to assign to node without outEdges
 *     as x-position
 */


function moveSinksRight(nodes, x) {
  zrUtil.each(nodes, function (node) {
    if (!node.outEdges.length) {
      node.setLayout({
        x: x - 1
      }, true);
    }
  });
}
/**
 * Scale node x-position to the width
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {number} kx   multiple used to scale nodes
 */


function scaleNodeBreadths(nodes, kx) {
  zrUtil.each(nodes, function (node) {
    var nodeX = node.getLayout().x * kx;
    node.setLayout({
      x: nodeX
    }, true);
  });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param {number} iterations  the number of iterations for the algorithm
 */


function computeNodeDepths(nodes, edges, height, nodeGap, iterations) {
  var nodesByBreadth = nest().key(function (d) {
    return d.getLayout().x;
  }).sortKeys(ascending).entries(nodes).map(function (d) {
    return d.values;
  });
  initializeNodeDepth(nodes, nodesByBreadth, edges, height, nodeGap);
  resolveCollisions(nodesByBreadth, nodeGap, height);

  for (var alpha = 1; iterations > 0; iterations--) {
    // 0.99 is a experience parameter, ensure that each iterations of
    // changes as small as possible.
    alpha *= 0.99;
    relaxRightToLeft(nodesByBreadth, alpha);
    resolveCollisions(nodesByBreadth, nodeGap, height);
    relaxLeftToRight(nodesByBreadth, alpha);
    resolveCollisions(nodesByBreadth, nodeGap, height);
  }
}
/**
 * Compute the original y-position for each node
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
 * @param {number} height  the whole height of the area to draw the view
 * @param {number} nodeGap  the vertical distance between two nodes
 */


function initializeNodeDepth(nodes, nodesByBreadth, edges, height, nodeGap) {
  var kyArray = [];
  zrUtil.each(nodesByBreadth, function (nodes) {
    var n = nodes.length;
    var sum = 0;
    zrUtil.each(nodes, function (node) {
      sum += node.getLayout().value;
    });
    var ky = (height - (n - 1) * nodeGap) / sum;
    kyArray.push(ky);
  });
  kyArray.sort(function (a, b) {
    return a - b;
  });
  var ky0 = kyArray[0];
  zrUtil.each(nodesByBreadth, function (nodes) {
    zrUtil.each(nodes, function (node, i) {
      node.setLayout({
        y: i
      }, true);
      var nodeDy = node.getLayout().value * ky0;
      node.setLayout({
        dy: nodeDy
      }, true);
    });
  });
  zrUtil.each(edges, function (edge) {
    var edgeDy = +edge.getValue() * ky0;
    edge.setLayout({
      dy: edgeDy
    }, true);
  });
}
/**
 * Resolve the collision of initialized depth (y-position)
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the nodes x-position.
 * @param {number} nodeGap  the vertical distance between two nodes
 * @param {number} height  the whole height of the area to draw the view
 */


function resolveCollisions(nodesByBreadth, nodeGap, height) {
  zrUtil.each(nodesByBreadth, function (nodes) {
    var node;
    var dy;
    var y0 = 0;
    var n = nodes.length;
    var i;
    nodes.sort(ascendingDepth);

    for (i = 0; i < n; i++) {
      node = nodes[i];
      dy = y0 - node.getLayout().y;

      if (dy > 0) {
        var nodeY = node.getLayout().y + dy;
        node.setLayout({
          y: nodeY
        }, true);
      }

      y0 = node.getLayout().y + node.getLayout().dy + nodeGap;
    } // if the bottommost node goes outside the bounds, push it back up


    dy = y0 - nodeGap - height;

    if (dy > 0) {
      var nodeY = node.getLayout().y - dy;
      node.setLayout({
        y: nodeY
      }, true);
      y0 = node.getLayout().y;

      for (i = n - 2; i >= 0; --i) {
        node = nodes[i];
        dy = node.getLayout().y + node.getLayout().dy + nodeGap - y0;

        if (dy > 0) {
          nodeY = node.getLayout().y - dy;
          node.setLayout({
            y: nodeY
          }, true);
        }

        y0 = node.getLayout().y;
      }
    }
  });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */


function relaxRightToLeft(nodesByBreadth, alpha) {
  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
    zrUtil.each(nodes, function (node) {
      if (node.outEdges.length) {
        var y = sum(node.outEdges, weightedTarget) / sum(node.outEdges, getEdgeValue);
        var nodeY = node.getLayout().y + (y - center(node)) * alpha;
        node.setLayout({
          y: nodeY
        }, true);
      }
    });
  });
}

function weightedTarget(edge) {
  return center(edge.node2) * edge.getValue();
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 *
 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
 *     group by the array of all sankey nodes based on the node x-position.
 * @param {number} alpha  parameter used to adjust the nodes y-position
 */


function relaxLeftToRight(nodesByBreadth, alpha) {
  zrUtil.each(nodesByBreadth, function (nodes) {
    zrUtil.each(nodes, function (node) {
      if (node.inEdges.length) {
        var y = sum(node.inEdges, weightedSource) / sum(node.inEdges, getEdgeValue);
        var nodeY = node.getLayout().y + (y - center(node)) * alpha;
        node.setLayout({
          y: nodeY
        }, true);
      }
    });
  });
}

function weightedSource(edge) {
  return center(edge.node1) * edge.getValue();
}
/**
 * Compute the depth(y-position) of each edge
 *
 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
 */


function computeEdgeDepths(nodes) {
  zrUtil.each(nodes, function (node) {
    node.outEdges.sort(ascendingTargetDepth);
    node.inEdges.sort(ascendingSourceDepth);
  });
  zrUtil.each(nodes, function (node) {
    var sy = 0;
    var ty = 0;
    zrUtil.each(node.outEdges, function (edge) {
      edge.setLayout({
        sy: sy
      }, true);
      sy += edge.getLayout().dy;
    });
    zrUtil.each(node.inEdges, function (edge) {
      edge.setLayout({
        ty: ty
      }, true);
      ty += edge.getLayout().dy;
    });
  });
}

function ascendingTargetDepth(a, b) {
  return a.node2.getLayout().y - b.node2.getLayout().y;
}

function ascendingSourceDepth(a, b) {
  return a.node1.getLayout().y - b.node1.getLayout().y;
}

function sum(array, f) {
  var sum = 0;
  var len = array.length;
  var i = -1;

  while (++i < len) {
    var value = +f.call(array, array[i], i);

    if (!isNaN(value)) {
      sum += value;
    }
  }

  return sum;
}

function center(node) {
  return node.getLayout().y + node.getLayout().dy / 2;
}

function ascendingDepth(a, b) {
  return a.getLayout().y - b.getLayout().y;
}

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a === b ? 0 : NaN;
}

function getEdgeValue(edge) {
  return edge.getValue();
}

module.exports = _default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var VisualMapping = __webpack_require__(105);

var zrUtil = __webpack_require__(0);

/**
 * @file Visual encoding for sankey view
 * @author  Deqing Li(annong035@gmail.com)
 */
function _default(ecModel, payload) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    nodes.sort(function (a, b) {
      return a.getLayout().value - b.getLayout().value;
    });
    var minValue = nodes[0].getLayout().value;
    var maxValue = nodes[nodes.length - 1].getLayout().value;
    zrUtil.each(nodes, function (node) {
      var mapping = new VisualMapping({
        type: 'color',
        mappingMethod: 'linear',
        dataExtent: [minValue, maxValue],
        visual: seriesModel.get('color')
      });
      var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
      node.setVisual('color', mapValueToColor); // If set itemStyle.normal.color

      var itemModel = node.getModel();
      var customColor = itemModel.get('itemStyle.normal.color');

      if (customColor != null) {
        node.setVisual('color', customColor);
      }
    });
  });
}

module.exports = _default;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1456);

__webpack_require__(1457);

var visualSymbol = __webpack_require__(106);

var layoutPoints = __webpack_require__(284);

__webpack_require__(144);

// In case developer forget to include grid component
echarts.registerVisual(zrUtil.curry(visualSymbol, 'scatter', 'circle', null));
echarts.registerLayout(zrUtil.curry(layoutPoints, 'scatter'));

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var createListFromArray = __webpack_require__(84);

var SeriesModel = __webpack_require__(35);

var _default = SeriesModel.extend({
  type: 'series.scatter',
  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  brushSelector: 'point',
  defaultOption: {
    coordinateSystem: 'cartesian2d',
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10,
    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // cursor: null,
    // label: {
    // normal: {
    // show: false
    // distance: 5,
    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
    //           'inside'|'left'|'right'|'top'|'bottom'
    // 默认使用全局文本样式，详见TEXTSTYLE
    //     }
    // },
    itemStyle: {
      normal: {
        opacity: 0.8 // color: 各异

      }
    }
  }
});

module.exports = _default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var SymbolDraw = __webpack_require__(139);

var LargeSymbolDraw = __webpack_require__(1416);

echarts.extendChartView({
  type: 'scatter',
  init: function () {
    this._normalSymbolDraw = new SymbolDraw();
    this._largeSymbolDraw = new LargeSymbolDraw();
  },
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var largeSymbolDraw = this._largeSymbolDraw;
    var normalSymbolDraw = this._normalSymbolDraw;
    var group = this.group;
    var symbolDraw = seriesModel.get('large') && data.count() > seriesModel.get('largeThreshold') ? largeSymbolDraw : normalSymbolDraw;
    this._symbolDraw = symbolDraw;
    symbolDraw.updateData(data);
    group.add(symbolDraw.group);
    group.remove(symbolDraw === largeSymbolDraw ? normalSymbolDraw.group : largeSymbolDraw.group);
  },
  updateLayout: function (seriesModel) {
    this._symbolDraw.updateLayout(seriesModel);
  },
  remove: function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(api, true);
  },
  dispose: function () {}
});

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(471);

__webpack_require__(1459);

__webpack_require__(1460);

var themeRiverLayout = __webpack_require__(1461);

var themeRiverVisual = __webpack_require__(1462);

var dataFilter = __webpack_require__(194);

echarts.registerLayout(themeRiverLayout);
echarts.registerVisual(themeRiverVisual);
echarts.registerProcessor(zrUtil.curry(dataFilter, 'themeRiver'));

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var completeDimensions = __webpack_require__(58);

var SeriesModel = __webpack_require__(35);

var List = __webpack_require__(31);

var zrUtil = __webpack_require__(0);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;

var nest = __webpack_require__(490);

/**
 * @file  Define the themeRiver view's series model
 * @author Deqing Li(annong035@gmail.com)
 */
var DATA_NAME_INDEX = 2;
var ThemeRiverSeries = SeriesModel.extend({
  type: 'series.themeRiver',
  dependencies: ['singleAxis'],

  /**
   * @readOnly
   * @type {module:zrender/core/util#HashMap}
   */
  nameMap: null,

  /**
   * @override
   */
  init: function (option) {
    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
    // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendDataProvider = function () {
      return this.getRawData();
    };
  },

  /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */
  fixData: function (data) {
    var rawDataLength = data.length; // grouped data by name

    var dataByName = nest().key(function (dataItem) {
      return dataItem[2];
    }).entries(data); // data group in each layer

    var layData = zrUtil.map(dataByName, function (d) {
      return {
        name: d.key,
        dataList: d.values
      };
    });
    var layerNum = layData.length;
    var largestLayer = -1;
    var index = -1;

    for (var i = 0; i < layerNum; ++i) {
      var len = layData[i].dataList.length;

      if (len > largestLayer) {
        largestLayer = len;
        index = i;
      }
    }

    for (var k = 0; k < layerNum; ++k) {
      if (k === index) {
        continue;
      }

      var name = layData[k].name;

      for (var j = 0; j < largestLayer; ++j) {
        var timeValue = layData[index].dataList[j][0];
        var length = layData[k].dataList.length;
        var keyIndex = -1;

        for (var l = 0; l < length; ++l) {
          var value = layData[k].dataList[l][0];

          if (value === timeValue) {
            keyIndex = l;
            break;
          }
        }

        if (keyIndex === -1) {
          data[rawDataLength] = [];
          data[rawDataLength][0] = timeValue;
          data[rawDataLength][1] = 0;
          data[rawDataLength][2] = name;
          rawDataLength++;
        }
      }
    }

    return data;
  },

  /**
   * @override
   * @param  {Object} option  the initial option that user gived
   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
   * @return {module:echarts/data/List}
   */
  getInitialData: function (option, ecModel) {
    var dimensions = [];
    var singleAxisModel = ecModel.queryComponents({
      mainType: 'singleAxis',
      index: this.get('singleAxisIndex'),
      id: this.get('singleAxisId')
    })[0];
    var axisType = singleAxisModel.get('type');
    dimensions = [{
      name: 'time',
      // FIXME common?
      type: axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float'
    }, {
      name: 'value',
      type: 'float'
    }, {
      name: 'name',
      type: 'ordinal'
    }]; // filter the data item with the value of label is undefined

    var filterData = zrUtil.filter(option.data, function (dataItem) {
      return dataItem[2] !== undefined;
    });
    var data = this.fixData(filterData || []);
    var nameList = [];
    var nameMap = this.nameMap = zrUtil.createHashMap();
    var count = 0;

    for (var i = 0; i < data.length; ++i) {
      nameList.push(data[i][DATA_NAME_INDEX]);

      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
        nameMap.set(data[i][DATA_NAME_INDEX], count);
        count++;
      }
    }

    dimensions = completeDimensions(dimensions, data);
    var list = new List(dimensions, this);
    list.initData(data, nameList);
    return list;
  },

  /**
   * Used by single coordinate
   *
   * @param {string} axisDim  the dimension for single coordinate
   * @return {Array.<string> } specified dimensions on the axis.
   */
  coordDimToDataDim: function (axisDim) {
    return ['time'];
  },

  /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   *
   * @return {Array.<Array.<number>>}
   */
  getLayerSeries: function () {
    var data = this.getData();
    var lenCount = data.count();
    var indexArr = [];

    for (var i = 0; i < lenCount; ++i) {
      indexArr[i] = i;
    } // data group by name


    var dataByName = nest().key(function (index) {
      return data.get('name', index);
    }).entries(indexArr);
    var layerSeries = zrUtil.map(dataByName, function (d) {
      return {
        name: d.key,
        indices: d.values
      };
    });

    for (var j = 0; j < layerSeries.length; ++j) {
      layerSeries[j].indices.sort(comparer);
    }

    function comparer(index1, index2) {
      return data.get('time', index1) - data.get('time', index2);
    }

    return layerSeries;
  },

  /**
   * Get data indices for show tooltip content
   *
   * @param {Array.<string>|string} dim  single coordinate dimension
   * @param {number} value axis value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
   *     the themeRiver.
   * @return {Object} {dataIndices, nestestValue}
   */
  getAxisTooltipData: function (dim, value, baseAxis) {
    if (!zrUtil.isArray(dim)) {
      dim = dim ? [dim] : [];
    }

    var data = this.getData();
    var layerSeries = this.getLayerSeries();
    var indices = [];
    var layerNum = layerSeries.length;
    var nestestValue;

    for (var i = 0; i < layerNum; ++i) {
      var minDist = Number.MAX_VALUE;
      var nearestIdx = -1;
      var pointNum = layerSeries[i].indices.length;

      for (var j = 0; j < pointNum; ++j) {
        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
        var dist = Math.abs(theValue - value);

        if (dist <= minDist) {
          nestestValue = theValue;
          minDist = dist;
          nearestIdx = layerSeries[i].indices[j];
        }
      }

      indices.push(nearestIdx);
    }

    return {
      dataIndices: indices,
      nestestValue: nestestValue
    };
  },

  /**
   * @override
   * @param {number} dataIndex  index of data
   */
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var htmlName = data.get('name', dataIndex);
    var htmlValue = data.get('value', dataIndex);

    if (isNaN(htmlValue) || htmlValue == null) {
      htmlValue = '-';
    }

    return encodeHTML(htmlName + ' : ' + htmlValue);
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'singleAxis',
    // gap in axis's orthogonal orientation
    boundaryGap: ['10%', '10%'],
    // legendHoverLink: true,
    singleAxisIndex: 0,
    animationEasing: 'linear',
    label: {
      normal: {
        margin: 4,
        textAlign: 'right',
        show: true,
        position: 'left',
        color: '#000',
        fontSize: 11
      },
      emphasis: {
        show: true
      }
    }
  }
});
var _default = ThemeRiverSeries;
module.exports = _default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var _poly = __webpack_require__(450);

var Polygon = _poly.Polygon;

var graphic = __webpack_require__(5);

var _util = __webpack_require__(0);

var bind = _util.bind;
var extend = _util.extend;

var DataDiffer = __webpack_require__(117);

/**
 * @file  The file used to draw themeRiver view
 * @author  Deqing Li(annong035@gmail.com)
 */
var _default = echarts.extendChartView({
  type: 'themeRiver',
  init: function () {
    this._layers = [];
  },
  render: function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var group = this.group;
    var layerSeries = seriesModel.getLayerSeries();
    var layoutInfo = data.getLayout('layoutInfo');
    var rect = layoutInfo.rect;
    var boundaryGap = layoutInfo.boundaryGap;
    group.attr('position', [0, rect.y + boundaryGap[0]]);

    function keyGetter(item) {
      return item.name;
    }

    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
    var newLayersGroups = {};
    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();

    function process(status, idx, oldIdx) {
      var oldLayersGroups = this._layers;

      if (status === 'remove') {
        group.remove(oldLayersGroups[idx]);
        return;
      }

      var points0 = [];
      var points1 = [];
      var color;
      var indices = layerSeries[idx].indices;

      for (var j = 0; j < indices.length; j++) {
        var layout = data.getItemLayout(indices[j]);
        var x = layout.x;
        var y0 = layout.y0;
        var y = layout.y;
        points0.push([x, y0]);
        points1.push([x, y0 + y]);
        color = data.getItemVisual(indices[j], 'color');
      }

      var polygon;
      var text;
      var textLayout = data.getItemLayout(indices[0]);
      var itemModel = data.getItemModel(indices[j - 1]);
      var labelModel = itemModel.getModel('label.normal');
      var margin = labelModel.get('margin');

      if (status === 'add') {
        var layerGroup = newLayersGroups[idx] = new graphic.Group();
        polygon = new Polygon({
          shape: {
            points: points0,
            stackedOnPoints: points1,
            smooth: 0.4,
            stackedOnSmooth: 0.4,
            smoothConstraint: false
          },
          z2: 0
        });
        text = new graphic.Text({
          style: {
            x: textLayout.x - margin,
            y: textLayout.y0 + textLayout.y / 2
          }
        });
        layerGroup.add(polygon);
        layerGroup.add(text);
        group.add(layerGroup);
        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
          polygon.removeClipPath();
        }));
      } else {
        var layerGroup = oldLayersGroups[oldIdx];
        polygon = layerGroup.childAt(0);
        text = layerGroup.childAt(1);
        group.add(layerGroup);
        newLayersGroups[idx] = layerGroup;
        graphic.updateProps(polygon, {
          shape: {
            points: points0,
            stackedOnPoints: points1
          }
        }, seriesModel);
        graphic.updateProps(text, {
          style: {
            x: textLayout.x - margin,
            y: textLayout.y0 + textLayout.y / 2
          }
        }, seriesModel);
      }

      var hoverItemStyleModel = itemModel.getModel('itemStyle.emphasis');
      var itemStyleModel = itemModel.getModel('itemStyle.normal');
      graphic.setTextStyle(text.style, labelModel, {
        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
        textVerticalAlign: 'middle'
      });
      polygon.setStyle(extend({
        fill: color
      }, itemStyleModel.getItemStyle(['color'])));
      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
    }

    this._layersSeries = layerSeries;
    this._layers = newLayersGroups;
  },
  dispose: function () {}
}); // add animation to the view


function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new graphic.Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  graphic.initProps(rectEl, {
    shape: {
      width: rect.width + 20,
      height: rect.height + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

module.exports = _default;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var numberUtil = __webpack_require__(8);

/**
 * @file  Using layout algorithm transform the raw data to layout information.
 * @author Deqing Li(annong035@gmail.com)
 */
function _default(ecModel, api) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var single = seriesModel.coordinateSystem;
    var layoutInfo = {}; // use the axis boundingRect for view

    var rect = single.getRect();
    layoutInfo.rect = rect;
    var boundaryGap = seriesModel.get('boundaryGap');
    var axis = single.getAxis();
    layoutInfo.boundaryGap = boundaryGap;

    if (axis.orient === 'horizontal') {
      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
      var height = rect.height - boundaryGap[0] - boundaryGap[1];
      themeRiverLayout(data, seriesModel, height);
    } else {
      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
      var width = rect.width - boundaryGap[0] - boundaryGap[1];
      themeRiverLayout(data, seriesModel, width);
    }

    data.setLayout('layoutInfo', layoutInfo);
  });
}
/**
 * The layout information about themeriver
 *
 * @param {module:echarts/data/List} data  data in the series
 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
 * @param {number} height  value used to compute every series height
 */


function themeRiverLayout(data, seriesModel, height) {
  if (!data.count()) {
    return;
  }

  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.

  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.

  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
    return zrUtil.map(singleLayer.indices, function (idx) {
      var pt = coordSys.dataToPoint(data.get('time', idx));
      pt[1] = data.get('value', idx);
      return pt;
    });
  });
  var base = computeBaseline(layerPoints);
  var baseLine = base.y0;
  var ky = height / base.max; // set layout information for each item.

  var n = layerSeries.length;
  var m = layerSeries[0].indices.length;
  var baseY0;

  for (var j = 0; j < m; ++j) {
    baseY0 = baseLine[j] * ky;
    data.setItemLayout(layerSeries[0].indices[j], {
      layerIndex: 0,
      x: layerPoints[0][j][0],
      y0: baseY0,
      y: layerPoints[0][j][1] * ky
    });

    for (var i = 1; i < n; ++i) {
      baseY0 += layerPoints[i - 1][j][1] * ky;
      data.setItemLayout(layerSeries[i].indices[j], {
        layerIndex: i,
        x: layerPoints[i][j][0],
        y0: baseY0,
        y: layerPoints[i][j][1] * ky
      });
    }
  }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  {Array.<Array>} data  the points in each layer
 * @return {Object}
 */


function computeBaseline(data) {
  var layerNum = data.length;
  var pointNum = data[0].length;
  var sums = [];
  var y0 = [];
  var max = 0;
  var temp;
  var base = {};

  for (var i = 0; i < pointNum; ++i) {
    for (var j = 0, temp = 0; j < layerNum; ++j) {
      temp += data[j][i][1];
    }

    if (temp > max) {
      max = temp;
    }

    sums.push(temp);
  }

  for (var k = 0; k < pointNum; ++k) {
    y0[k] = (max - sums[k]) / 2;
  }

  max = 0;

  for (var l = 0; l < pointNum; ++l) {
    var sum = sums[l] + y0[l];

    if (sum > max) {
      max = sum;
    }
  }

  base.y0 = y0;
  base.max = max;
  return base;
}

module.exports = _default;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(0);

var createHashMap = _util.createHashMap;

/**
 * @file Visual encoding for themeRiver view
 * @author  Deqing Li(annong035@gmail.com)
 */
function _default(ecModel) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var rawData = seriesModel.getRawData();
    var colorList = seriesModel.get('color');
    var idxMap = createHashMap();
    data.each(function (idx) {
      idxMap.set(data.getRawIndex(idx), idx);
    });
    rawData.each(function (rawIndex) {
      var name = rawData.getName(rawIndex);
      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
      rawData.setItemVisual(rawIndex, 'color', color);
      var idx = idxMap.get(rawIndex);

      if (idx != null) {
        data.setItemVisual(idx, 'color', color);
      }
    });
  });
}

module.exports = _default;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1464);

__webpack_require__(1465);

__webpack_require__(1469);

var visualSymbol = __webpack_require__(106);

var orthogonalLayout = __webpack_require__(1466);

var radialLayout = __webpack_require__(1467);

echarts.registerVisual(zrUtil.curry(visualSymbol, 'tree', 'circle', null));
echarts.registerLayout(orthogonalLayout);
echarts.registerLayout(radialLayout);

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(35);

var Tree = __webpack_require__(485);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;

/**
 * @file Create data struct and define tree view's series model
 */
var _default = SeriesModel.extend({
  type: 'series.tree',
  layoutInfo: null,
  // can support the position parameters 'left', 'top','right','bottom', 'width',
  // 'height' in the setOption() with 'merge' mode normal.
  layoutMode: 'box',

  /**
   * Init a tree data structure from data in option series
   * @param  {Object} option  the object used to config echarts view
   * @return {module:echarts/data/List} storage initial data
   */
  getInitialData: function (option) {
    //create an virtual root
    var root = {
      name: option.name,
      children: option.data
    };
    var leaves = option.leaves || {};
    var treeOption = {};
    treeOption.leaves = leaves;
    var tree = Tree.createTree(root, this, treeOption);
    var treeDepth = 0;
    tree.eachNode('preorder', function (node) {
      if (node.depth > treeDepth) {
        treeDepth = node.depth;
      }
    });
    var expandAndCollapse = option.expandAndCollapse;
    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
    tree.root.eachNode('preorder', function (node) {
      var item = node.hostTree.data.getRawDataItem(node.dataIndex);
      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
    });
    return tree.data;
  },

  /**
   * @override
   * @param {number} dataIndex
   */
  formatTooltip: function (dataIndex) {
    var tree = this.getData().tree;
    var realRoot = tree.root.children[0];
    var node = tree.getNodeByDataIndex(dataIndex);
    var value = node.getValue();
    var name = node.name;

    while (node && node !== realRoot) {
      name = node.parentNode.name + '.' + name;
      node = node.parentNode;
    }

    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    // the position of the whole view
    left: '12%',
    top: '12%',
    right: '12%',
    bottom: '12%',
    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
    layout: 'orthogonal',
    // the orient of orthoginal layout, can be setted to 'horizontal' or 'vertical'
    orient: 'horizontal',
    symbol: 'emptyCircle',
    symbolSize: 7,
    expandAndCollapse: true,
    initialTreeDepth: 2,
    lineStyle: {
      normal: {
        color: '#ccc',
        width: 1.5,
        curveness: 0.5
      }
    },
    itemStyle: {
      normal: {
        color: 'lightsteelblue',
        borderColor: '#c23531',
        borderWidth: 1.5
      }
    },
    label: {
      normal: {
        show: true,
        color: '#555'
      }
    },
    leaves: {
      label: {
        normal: {
          show: true
        }
      }
    },
    animationEasing: 'linear',
    animationDuration: 700,
    animationDurationUpdate: 1000
  }
});

module.exports = _default;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var SymbolClz = __webpack_require__(187);

var _layoutHelper = __webpack_require__(452);

var radialCoordinate = _layoutHelper.radialCoordinate;

var echarts = __webpack_require__(4);

/**
 * @file  This file used to draw tree view
 */
var _default = echarts.extendChartView({
  type: 'tree',

  /**
   * Init the chart
   * @override
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {
    /**
     * @private
     * @type {module:echarts/data/Tree}
     */
    this._oldTree;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this._mainGroup = new graphic.Group();
    this.group.add(this._mainGroup);
  },
  render: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var layoutInfo = seriesModel.layoutInfo;
    var group = this._mainGroup;
    var layout = seriesModel.get('layout');

    if (layout === 'radial') {
      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
    } else {
      group.attr('position', [layoutInfo.x, layoutInfo.y]);
    }

    var oldData = this._data;
    var seriesScope = {
      expandAndCollapse: seriesModel.get('expandAndCollapse'),
      layout: layout,
      orient: seriesModel.get('orient'),
      curvature: seriesModel.get('lineStyle.normal.curveness'),
      symbolRotate: seriesModel.get('symbolRotate'),
      symbolOffset: seriesModel.get('symbolOffset'),
      hoverAnimation: seriesModel.get('hoverAnimation'),
      useNameLabel: true,
      fadeIn: true
    };
    data.diff(oldData).add(function (newIdx) {
      if (symbolNeedsDraw(data, newIdx)) {
        // create node and edge
        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);

      if (!symbolNeedsDraw(data, newIdx)) {
        symbolEl && removeNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
        return;
      } // update  node and edge


      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
    }).remove(function (oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);
      removeNode(data, oldIdx, symbolEl, group, seriesModel, seriesScope);
    }).execute();

    if (seriesScope.expandAndCollapse === true) {
      data.eachItemGraphicEl(function (el, dataIndex) {
        el.off('click').on('click', function () {
          api.dispatchAction({
            type: 'treeExpandAndCollapse',
            seriesId: seriesModel.id,
            dataIndex: dataIndex
          });
        });
      });
    }

    this._data = data;
  },
  dispose: function () {},
  remove: function () {
    this._mainGroup.removeAll();

    this._data = null;
  }
});

function symbolNeedsDraw(data, dataIndex) {
  var layout = data.getItemLayout(dataIndex);
  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
}

function getTreeNodeStyle(node, itemModel, seriesScope) {
  seriesScope.itemModel = itemModel;
  seriesScope.itemStyle = itemModel.getModel('itemStyle.normal').getItemStyle();
  seriesScope.hoverItemStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
  seriesScope.lineStyle = itemModel.getModel('lineStyle.normal').getLineStyle();
  seriesScope.labelModel = itemModel.getModel('label.normal');
  seriesScope.hoverLabelModel = itemModel.getModel('label.emphasis');

  if (node.isExpand === false && node.children.length !== 0) {
    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
  } else {
    seriesScope.symbolInnerColor = '#fff';
  }

  return seriesScope;
}

function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
  var isInit = !symbolEl;
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var itemModel = node.getModel();
  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
  var virtualRoot = data.tree.root;
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceLayout = source.getLayout();
  var sourceOldLayout = sourceSymbolEl ? {
    x: sourceSymbolEl.position[0],
    y: sourceSymbolEl.position[1],
    rawX: sourceSymbolEl.__radialOldRawX,
    rawY: sourceSymbolEl.__radialOldRawY
  } : sourceLayout;
  var targetLayout = node.getLayout();

  if (isInit) {
    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
  } else {
    symbolEl.updateData(data, dataIndex, seriesScope);
  }

  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
  symbolEl.__radialRawX = targetLayout.rawX;
  symbolEl.__radialRawY = targetLayout.rawY;
  group.add(symbolEl);
  data.setItemGraphicEl(dataIndex, symbolEl);
  graphic.updateProps(symbolEl, {
    position: [targetLayout.x, targetLayout.y]
  }, seriesModel);
  var symbolPath = symbolEl.getSymbolPath();

  if (seriesScope.layout === 'radial') {
    var realRoot = virtualRoot.children[0];
    var rootLayout = realRoot.getLayout();
    var length = realRoot.children.length;
    var rad;
    var isLeft;

    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
      var center = {};
      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      isLeft = center.x < rootLayout.x;

      if (isLeft) {
        rad = rad - Math.PI;
      }
    } else {
      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
        isLeft = targetLayout.x < rootLayout.x;

        if (isLeft) {
          rad = rad - Math.PI;
        }
      } else {
        isLeft = targetLayout.x > rootLayout.x;

        if (!isLeft) {
          rad = rad - Math.PI;
        }
      }
    }

    var textPosition = isLeft ? 'left' : 'right';
    symbolPath.setStyle({
      textPosition: textPosition,
      textRotation: -rad,
      textOrigin: 'center',
      verticalAlign: 'middle'
    });
  }

  if (node.parentNode && node.parentNode !== virtualRoot) {
    var edge = symbolEl.__edge;

    if (!edge) {
      edge = symbolEl.__edge = new graphic.BezierCurve({
        shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
        style: zrUtil.defaults({
          opacity: 0
        }, seriesScope.lineStyle)
      });
    }

    graphic.updateProps(edge, {
      shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
      style: {
        opacity: 1
      }
    }, seriesModel);
    group.add(edge);
  }
}

function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var virtualRoot = data.tree.root;
  var itemModel = node.getModel();
  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceLayout;

  while (sourceLayout = source.getLayout(), sourceLayout == null) {
    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
  }

  graphic.updateProps(symbolEl, {
    position: [sourceLayout.x + 1, sourceLayout.y + 1]
  }, seriesModel, function () {
    group.remove(symbolEl);
    data.setItemGraphicEl(dataIndex, null);
  });
  symbolEl.fadeOut(null, {
    keepLabel: true
  });
  var edge = symbolEl.__edge;

  if (edge) {
    graphic.updateProps(edge, {
      shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
      style: {
        opacity: 0
      }
    }, seriesModel, function () {
      group.remove(edge);
    });
  }
}

function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
  var cpx1;
  var cpy1;
  var cpx2;
  var cpy2;
  var orient = seriesScope.orient;

  if (seriesScope.layout === 'radial') {
    var x1 = sourceLayout.rawX;
    var y1 = sourceLayout.rawY;
    var x2 = targetLayout.rawX;
    var y2 = targetLayout.rawY;
    var radialCoor1 = radialCoordinate(x1, y1);
    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
    var radialCoor4 = radialCoordinate(x2, y2);
    return {
      x1: radialCoor1.x,
      y1: radialCoor1.y,
      x2: radialCoor4.x,
      y2: radialCoor4.y,
      cpx1: radialCoor2.x,
      cpy1: radialCoor2.y,
      cpx2: radialCoor3.x,
      cpy2: radialCoor3.y
    };
  } else {
    var x1 = sourceLayout.x;
    var y1 = sourceLayout.y;
    var x2 = targetLayout.x;
    var y2 = targetLayout.y;

    if (orient === 'horizontal') {
      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
      cpy1 = y1;
      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
      cpy2 = y2;
    }

    if (orient === 'vertical') {
      cpx1 = x1;
      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
      cpx2 = x2;
      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
    }

    return {
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
      cpx1: cpx1,
      cpy1: cpy1,
      cpx2: cpx2,
      cpy2: cpy2
    };
  }
}

module.exports = _default;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

var commonLayout = __webpack_require__(451);

function _default(ecModel, api) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    commonLayout(seriesModel, api);
  });
}

module.exports = _default;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var commonLayout = __webpack_require__(451);

function _default(ecModel, api) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    commonLayout(seriesModel, api);
  });
}

module.exports = _default;

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

/**
 * Traverse the tree from bottom to top and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */
function eachAfter(root, callback, separation) {
  var nodes = [root];
  var next = [];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    next.push(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = 0; i < children.length; i++) {
          nodes.push(children[i]);
        }
      }
    }
  }

  while (node = next.pop()) {
    // jshint ignore:line
    callback(node, separation);
  }
}
/**
 * Traverse the tree from top to bottom and do something
 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
 * @param  {Function} callback
 */


function eachBefore(root, callback) {
  var nodes = [root];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    callback(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = children.length - 1; i >= 0; i--) {
          nodes.push(children[i]);
        }
      }
    }
  }
}

exports.eachAfter = eachAfter;
exports.eachBefore = eachBefore;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

echarts.registerAction({
  type: 'treeExpandAndCollapse',
  event: 'treeExpandAndCollapse',
  update: 'update'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'tree',
    query: payload
  }, function (seriesModel) {
    var dataIndex = payload.dataIndex;
    var tree = seriesModel.getData().tree;
    var node = tree.getNodeByDataIndex(dataIndex);
    node.isExpand = !node.isExpand;
  });
});

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1472);

__webpack_require__(1473);

__webpack_require__(1474);

var treemapVisual = __webpack_require__(1476);

var treemapLayout = __webpack_require__(1475);

echarts.registerVisual(treemapVisual);
echarts.registerLayout(treemapLayout);

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var layout = __webpack_require__(17);

var zrUtil = __webpack_require__(0);

var _helper = __webpack_require__(140);

var wrapTreePathInfo = _helper.wrapTreePathInfo;
var TEXT_PADDING = 8;
var ITEM_GAP = 8;
var ARRAY_LENGTH = 5;

function Breadcrumb(containerGroup) {
  /**
   * @private
   * @type {module:zrender/container/Group}
   */
  this.group = new graphic.Group();
  containerGroup.add(this.group);
}

Breadcrumb.prototype = {
  constructor: Breadcrumb,
  render: function (seriesModel, api, targetNode, onSelect) {
    var model = seriesModel.getModel('breadcrumb');
    var thisGroup = this.group;
    thisGroup.removeAll();

    if (!model.get('show') || !targetNode) {
      return;
    }

    var normalStyleModel = model.getModel('itemStyle.normal'); // var emphasisStyleModel = model.getModel('itemStyle.emphasis');

    var textStyleModel = normalStyleModel.getModel('textStyle');
    var layoutParam = {
      pos: {
        left: model.get('left'),
        right: model.get('right'),
        top: model.get('top'),
        bottom: model.get('bottom')
      },
      box: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      emptyItemWidth: model.get('emptyItemWidth'),
      totalWidth: 0,
      renderList: []
    };

    this._prepare(targetNode, layoutParam, textStyleModel);

    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);

    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
  },

  /**
   * Prepare render list and total width
   * @private
   */
  _prepare: function (targetNode, layoutParam, textStyleModel) {
    for (var node = targetNode; node; node = node.parentNode) {
      var text = node.getModel().get('name');
      var textRect = textStyleModel.getTextRect(text);
      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
      layoutParam.totalWidth += itemWidth + ITEM_GAP;
      layoutParam.renderList.push({
        node: node,
        text: text,
        width: itemWidth
      });
    }
  },

  /**
   * @private
   */
  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
    // Start rendering.
    var lastX = 0;
    var emptyItemWidth = layoutParam.emptyItemWidth;
    var height = seriesModel.get('breadcrumb.height');
    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
    var totalWidth = layoutParam.totalWidth;
    var renderList = layoutParam.renderList;

    for (var i = renderList.length - 1; i >= 0; i--) {
      var item = renderList[i];
      var itemNode = item.node;
      var itemWidth = item.width;
      var text = item.text; // Hdie text and shorten width if necessary.

      if (totalWidth > availableSize.width) {
        totalWidth -= itemWidth - emptyItemWidth;
        itemWidth = emptyItemWidth;
        text = null;
      }

      var el = new graphic.Polygon({
        shape: {
          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
        },
        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
          lineJoin: 'bevel',
          text: text,
          textFill: textStyleModel.getTextColor(),
          textFont: textStyleModel.getFont()
        }),
        z: 10,
        onclick: zrUtil.curry(onSelect, itemNode)
      });
      this.group.add(el);
      packEventData(el, seriesModel, itemNode);
      lastX += itemWidth + ITEM_GAP;
    }
  },

  /**
   * @override
   */
  remove: function () {
    this.group.removeAll();
  }
};

function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
  !head && points.push([x, y + itemHeight / 2]);
  return points;
} // Package custom mouse event.


function packEventData(el, seriesModel, itemNode) {
  el.eventData = {
    componentType: 'series',
    componentSubType: 'treemap',
    seriesIndex: seriesModel.componentIndex,
    seriesName: seriesModel.name,
    seriesType: 'treemap',
    selfType: 'breadcrumb',
    // Distinguish with click event on treemap node.
    nodeData: {
      dataIndex: itemNode && itemNode.dataIndex,
      name: itemNode && itemNode.name
    },
    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
  };
}

var _default = Breadcrumb;
module.exports = _default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var SeriesModel = __webpack_require__(35);

var Tree = __webpack_require__(485);

var Model = __webpack_require__(29);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;

var _helper = __webpack_require__(140);

var wrapTreePathInfo = _helper.wrapTreePathInfo;

var _default = SeriesModel.extend({
  type: 'series.treemap',
  layoutMode: 'box',
  dependencies: ['grid', 'polar'],

  /**
   * @type {module:echarts/data/Tree~Node}
   */
  _viewRoot: null,
  defaultOption: {
    // Disable progressive rendering
    progressive: 0,
    hoverLayerThreshold: Infinity,
    // center: ['50%', '50%'],          // not supported in ec3.
    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
    left: 'center',
    top: 'middle',
    right: null,
    bottom: null,
    width: '80%',
    height: '80%',
    sort: true,
    // Can be null or false or true
    // (order by desc default, asc not supported yet (strange effect))
    clipWindow: 'origin',
    // Size of clipped window when zooming. 'origin' or 'fullscreen'
    squareRatio: 0.5 * (1 + Math.sqrt(5)),
    // golden ratio
    leafDepth: null,
    // Nodes on depth from root are regarded as leaves.
    // Count from zero (zero represents only view root).
    drillDownIcon: '▶',
    // Use html character temporarily because it is complicated
    // to align specialized icon. ▷▶❒❐▼✚
    zoomToNodeRatio: 0.32 * 0.32,
    // Be effective when using zoomToNode. Specify the proportion of the
    // target node area in the view area.
    roam: true,
    // true, false, 'scale' or 'zoom', 'move'.
    nodeClick: 'zoomToNode',
    // Leaf node click behaviour: 'zoomToNode', 'link', false.
    // If leafDepth is set and clicking a node which has children but
    // be on left depth, the behaviour would be changing root. Otherwise
    // use behavious defined above.
    animation: true,
    animationDurationUpdate: 900,
    animationEasing: 'quinticInOut',
    breadcrumb: {
      show: true,
      height: 22,
      left: 'center',
      top: 'bottom',
      // right
      // bottom
      emptyItemWidth: 25,
      // Width of empty node.
      itemStyle: {
        normal: {
          color: 'rgba(0,0,0,0.7)',
          //'#5793f3',
          borderColor: 'rgba(255,255,255,0.7)',
          borderWidth: 1,
          shadowColor: 'rgba(150,150,150,1)',
          shadowBlur: 3,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          textStyle: {
            color: '#fff'
          }
        },
        emphasis: {
          textStyle: {}
        }
      }
    },
    label: {
      normal: {
        show: true,
        // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
        distance: 0,
        padding: 5,
        position: 'inside',
        // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
        // formatter: null,
        color: '#fff',
        ellipsis: true // align
        // verticalAlign

      }
    },
    upperLabel: {
      // Label when node is parent.
      normal: {
        show: false,
        position: [0, '50%'],
        height: 20,
        // formatter: null,
        color: '#fff',
        ellipsis: true,
        // align: null,
        verticalAlign: 'middle'
      },
      emphasis: {
        show: true,
        position: [0, '50%'],
        color: '#fff',
        ellipsis: true,
        verticalAlign: 'middle'
      }
    },
    itemStyle: {
      normal: {
        color: null,
        // Can be 'none' if not necessary.
        colorAlpha: null,
        // Can be 'none' if not necessary.
        colorSaturation: null,
        // Can be 'none' if not necessary.
        borderWidth: 0,
        gapWidth: 0,
        borderColor: '#fff',
        borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        // border color is evaluated by color of current node and
        // borderColorSaturation.

      },
      emphasis: {}
    },
    visualDimension: 0,
    // Can be 0, 1, 2, 3.
    visualMin: null,
    visualMax: null,
    color: [],
    // + treemapSeries.color should not be modified. Please only modified
    // level[n].color (if necessary).
    // + Specify color list of each level. level[0].color would be global
    // color list if not specified. (see method `setDefault`).
    // + But set as a empty array to forbid fetch color from global palette
    // when using nodeModel.get('color'), otherwise nodes on deep level
    // will always has color palette set and are not able to inherit color
    // from parent node.
    // + TreemapSeries.color can not be set as 'none', otherwise effect
    // legend color fetching (see seriesColor.js).
    colorAlpha: null,
    // Array. Specify color alpha range of each level, like [0.2, 0.8]
    colorSaturation: null,
    // Array. Specify color saturation of each level, like [0.2, 0.5]
    colorMappingBy: 'index',
    // 'value' or 'index' or 'id'.
    visibleMin: 10,
    // If area less than this threshold (unit: pixel^2), node will not
    // be rendered. Only works when sort is 'asc' or 'desc'.
    childrenVisibleMin: null,
    // If area of a node less than this threshold (unit: pixel^2),
    // grandchildren will not show.
    // Why grandchildren? If not grandchildren but children,
    // some siblings show children and some not,
    // the appearance may be mess and not consistent,
    levels: [] // Each item: {
    //     visibleMin, itemStyle, visualDimension, label
    // }
    // data: {
    //      value: [],
    //      children: [],
    //      link: 'http://xxx.xxx.xxx',
    //      target: 'blank' or 'self'
    // }

  },

  /**
   * @override
   */
  getInitialData: function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levels = option.levels || [];
    levels = option.levels = setDefault(levels, ecModel);
    var treeOption = {};
    treeOption.levels = levels; // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    return Tree.createTree(root, this, treeOption).data;
  },
  optionUpdated: function () {
    this.resetViewRoot();
  },

  /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */
  formatTooltip: function (dataIndex) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
    var name = data.getName(dataIndex);
    return encodeHTML(name + ': ' + formattedValue);
  },

  /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */
  getDataParams: function (dataIndex) {
    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treePathInfo = wrapTreePathInfo(node, this);
    return params;
  },

  /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */
  setLayoutInfo: function (layoutInfo) {
    /**
     * @readOnly
     * @type {Object}
     */
    this.layoutInfo = this.layoutInfo || {};
    zrUtil.extend(this.layoutInfo, layoutInfo);
  },

  /**
   * @param  {string} id
   * @return {number} index
   */
  mapIdToIndex: function (id) {
    // A feature is implemented:
    // index is monotone increasing with the sequence of
    // input id at the first time.
    // This feature can make sure that each data item and its
    // mapped color have the same index between data list and
    // color list at the beginning, which is useful for user
    // to adjust data-color mapping.

    /**
     * @private
     * @type {Object}
     */
    var idIndexMap = this._idIndexMap;

    if (!idIndexMap) {
      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
      /**
       * @private
       * @type {number}
       */

      this._idIndexMapCount = 0;
    }

    var index = idIndexMap.get(id);

    if (index == null) {
      idIndexMap.set(id, index = this._idIndexMapCount++);
    }

    return index;
  },
  getViewRoot: function () {
    return this._viewRoot;
  },

  /**
   * @param {module:echarts/data/Tree~Node} [viewRoot]
   */
  resetViewRoot: function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  }
});
/**
 * @param {Object} dataNode
 */


function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  zrUtil.each(dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value;
    zrUtil.isArray(childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (zrUtil.isArray(thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */


function setDefault(levels, ecModel) {
  var globalColorList = ecModel.get('color');

  if (!globalColorList) {
    return;
  }

  levels = levels || [];
  var hasColorDefine;
  zrUtil.each(levels, function (levelDefine) {
    var model = new Model(levelDefine);
    var modelColor = model.get('color');

    if (model.get('itemStyle.normal.color') || modelColor && modelColor !== 'none') {
      hasColorDefine = true;
    }
  });

  if (!hasColorDefine) {
    var level0 = levels[0] || (levels[0] = {});
    level0.color = globalColorList.slice();
  }

  return levels;
}

module.exports = _default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var DataDiffer = __webpack_require__(117);

var helper = __webpack_require__(140);

var Breadcrumb = __webpack_require__(1471);

var RoamController = __webpack_require__(191);

var BoundingRect = __webpack_require__(26);

var matrix = __webpack_require__(53);

var animationUtil = __webpack_require__(1616);

var makeStyleMapper = __webpack_require__(119);

var bind = zrUtil.bind;
var Group = graphic.Group;
var Rect = graphic.Rect;
var each = zrUtil.each;
var DRAG_THRESHOLD = 3;
var PATH_LABEL_NOAMAL = ['label', 'normal'];
var PATH_LABEL_EMPHASIS = ['label', 'emphasis'];
var PATH_UPPERLABEL_NORMAL = ['upperLabel', 'normal'];
var PATH_UPPERLABEL_EMPHASIS = ['upperLabel', 'emphasis'];
var Z_BASE = 10; // Should bigger than every z.

var Z_BG = 1;
var Z_CONTENT = 2;
var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
// so use `stroke` to indicate the stroke of the rect.
['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);

var getItemStyleNormal = function (model) {
  // Normal style props should include emphasis style props.
  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.

  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
  return itemStyle;
};

var _default = echarts.extendChartView({
  type: 'treemap',

  /**
   * @override
   */
  init: function (o, api) {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this._containerGroup;
    /**
     * @private
     * @type {Object.<string, Array.<module:zrender/container/Group>>}
     */

    this._storage = createStorage();
    /**
     * @private
     * @type {module:echarts/data/Tree}
     */

    this._oldTree;
    /**
     * @private
     * @type {module:echarts/chart/treemap/Breadcrumb}
     */

    this._breadcrumb;
    /**
     * @private
     * @type {module:echarts/component/helper/RoamController}
     */

    this._controller;
    /**
     * 'ready', 'animating'
     * @private
     */

    this._state = 'ready';
  },

  /**
   * @override
   */
  render: function (seriesModel, ecModel, api, payload) {
    var models = ecModel.findComponents({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    });

    if (zrUtil.indexOf(models, seriesModel) < 0) {
      return;
    }

    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var targetInfo = helper.retrieveTargetInfo(payload, seriesModel);
    var payloadType = payload && payload.type;
    var layoutInfo = seriesModel.layoutInfo;
    var isInit = !this._oldTree;
    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.

    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
      direction: payload.direction
    } : null;

    var containerGroup = this._giveContainerGroup(layoutInfo);

    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);

    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();

    this._resetController(api);

    this._renderBreadcrumb(seriesModel, api, targetInfo);
  },

  /**
   * @private
   */
  _giveContainerGroup: function (layoutInfo) {
    var containerGroup = this._containerGroup;

    if (!containerGroup) {
      // FIXME
      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
      containerGroup = this._containerGroup = new Group();

      this._initEvents(containerGroup);

      this.group.add(containerGroup);
    }

    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
    return containerGroup;
  },

  /**
   * @private
   */
  _doRender: function (containerGroup, seriesModel, reRoot) {
    var thisTree = seriesModel.getData().tree;
    var oldTree = this._oldTree; // Clear last shape records.

    var lastsForAnimation = createStorage();
    var thisStorage = createStorage();
    var oldStorage = this._storage;
    var willInvisibleEls = [];
    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
    // the oldTree is actually losted, so we can not find all of the old graphic
    // elements from tree. So we use this stragegy: make element storage, move
    // from old storage to new storage, clear old storage.

    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.

    var willDeleteEls = clearStorage(oldStorage);
    this._oldTree = thisTree;
    this._storage = thisStorage;
    return {
      lastsForAnimation: lastsForAnimation,
      willDeleteEls: willDeleteEls,
      renderFinally: renderFinally
    };

    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
      // When 'render' is triggered by action,
      // 'this' and 'old' may be the same tree,
      // we use rawIndex in that case.
      if (sameTree) {
        oldViewChildren = thisViewChildren;
        each(thisViewChildren, function (child, index) {
          !child.isRemoved() && processNode(index, index);
        });
      } // Diff hierarchically (diff only in each subtree, but not whole).
      // because, consistency of view is important.
      else {
          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
        }

      function getKey(node) {
        // Identify by name or raw index.
        return node.getId();
      }

      function processNode(newIndex, oldIndex) {
        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
      }
    }

    function clearStorage(storage) {
      var willDeleteEls = createStorage();
      storage && each(storage, function (store, storageName) {
        var delEls = willDeleteEls[storageName];
        each(store, function (el) {
          el && (delEls.push(el), el.__tmWillDelete = 1);
        });
      });
      return willDeleteEls;
    }

    function renderFinally() {
      each(willDeleteEls, function (els) {
        each(els, function (el) {
          el.parent && el.parent.remove(el);
        });
      });
      each(willInvisibleEls, function (el) {
        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
        // just mark as invisible.

        el.dirty();
      });
    }
  },

  /**
   * @private
   */
  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
    if (!seriesModel.get('animation')) {
      return;
    }

    var duration = seriesModel.get('animationDurationUpdate');
    var easing = seriesModel.get('animationEasing');
    var animationWrap = animationUtil.createWrap(); // Make delete animations.

    each(renderResult.willDeleteEls, function (store, storageName) {
      each(store, function (el, rawIndex) {
        if (el.invisible) {
          return;
        }

        var parent = el.parent; // Always has parent, and parent is nodeGroup.

        var target;

        if (reRoot && reRoot.direction === 'drillDown') {
          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
          // Only `content` will enter this branch, because
          // `background` and `nodeGroup` will not be deleted.
          ? {
            shape: {
              x: 0,
              y: 0,
              width: parent.__tmNodeWidth,
              height: parent.__tmNodeHeight
            },
            style: {
              opacity: 0
            } // Others.

          } : {
            style: {
              opacity: 0
            }
          };
        } else {
          var targetX = 0;
          var targetY = 0;

          if (!parent.__tmWillDelete) {
            // Let node animate to right-bottom corner, cooperating with fadeout,
            // which is appropriate for user understanding.
            // Divided by 2 for reRoot rolling up effect.
            targetX = parent.__tmNodeWidth / 2;
            targetY = parent.__tmNodeHeight / 2;
          }

          target = storageName === 'nodeGroup' ? {
            position: [targetX, targetY],
            style: {
              opacity: 0
            }
          } : {
            shape: {
              x: targetX,
              y: targetY,
              width: 0,
              height: 0
            },
            style: {
              opacity: 0
            }
          };
        }

        target && animationWrap.add(el, target, duration, easing);
      });
    }); // Make other animations

    each(this._storage, function (store, storageName) {
      each(store, function (el, rawIndex) {
        var last = renderResult.lastsForAnimation[storageName][rawIndex];
        var target = {};

        if (!last) {
          return;
        }

        if (storageName === 'nodeGroup') {
          if (last.old) {
            target.position = el.position.slice();
            el.attr('position', last.old);
          }
        } else {
          if (last.old) {
            target.shape = zrUtil.extend({}, el.shape);
            el.setShape(last.old);
          }

          if (last.fadein) {
            el.setStyle('opacity', 0);
            target.style = {
              opacity: 1
            };
          } // When animation is stopped for succedent animation starting,
          // el.style.opacity might not be 1
          else if (el.style.opacity !== 1) {
              target.style = {
                opacity: 1
              };
            }
        }

        animationWrap.add(el, target, duration, easing);
      });
    }, this);
    this._state = 'animating';
    animationWrap.done(bind(function () {
      this._state = 'ready';
      renderResult.renderFinally();
    }, this)).start();
  },

  /**
   * @private
   */
  _resetController: function (api) {
    var controller = this._controller; // Init controller.

    if (!controller) {
      controller = this._controller = new RoamController(api.getZr());
      controller.enable(this.seriesModel.get('roam'));
      controller.on('pan', bind(this._onPan, this));
      controller.on('zoom', bind(this._onZoom, this));
    }

    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
    controller.setPointerChecker(function (e, x, y) {
      return rect.contain(x, y);
    });
  },

  /**
   * @private
   */
  _clearController: function () {
    var controller = this._controller;

    if (controller) {
      controller.dispose();
      controller = null;
    }
  },

  /**
   * @private
   */
  _onPan: function (dx, dy) {
    if (this._state !== 'animating' && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      this.api.dispatchAction({
        type: 'treemapMove',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rootLayout.x + dx,
          y: rootLayout.y + dy,
          width: rootLayout.width,
          height: rootLayout.height
        }
      });
    }
  },

  /**
   * @private
   */
  _onZoom: function (scale, mouseX, mouseY) {
    if (this._state !== 'animating') {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.

      mouseX -= layoutInfo.x;
      mouseY -= layoutInfo.y; // Scale root bounding rect.

      var m = matrix.create();
      matrix.translate(m, m, [-mouseX, -mouseY]);
      matrix.scale(m, m, [scale, scale]);
      matrix.translate(m, m, [mouseX, mouseY]);
      rect.applyTransform(m);
      this.api.dispatchAction({
        type: 'treemapRender',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        }
      });
    }
  },

  /**
   * @private
   */
  _initEvents: function (containerGroup) {
    containerGroup.on('click', function (e) {
      if (this._state !== 'ready') {
        return;
      }

      var nodeClick = this.seriesModel.get('nodeClick', true);

      if (!nodeClick) {
        return;
      }

      var targetInfo = this.findTarget(e.offsetX, e.offsetY);

      if (!targetInfo) {
        return;
      }

      var node = targetInfo.node;

      if (node.getLayout().isLeafRoot) {
        this._rootToNode(targetInfo);
      } else {
        if (nodeClick === 'zoomToNode') {
          this._zoomToNode(targetInfo);
        } else if (nodeClick === 'link') {
          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
          var link = itemModel.get('link', true);
          var linkTarget = itemModel.get('target', true) || 'blank';
          link && window.open(link, linkTarget);
        }
      }
    }, this);
  },

  /**
   * @private
   */
  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
    if (!targetInfo) {
      targetInfo = seriesModel.get('leafDepth', true) != null ? {
        node: seriesModel.getViewRoot() // FIXME
        // better way?
        // Find breadcrumb tail on center of containerGroup.

      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);

      if (!targetInfo) {
        targetInfo = {
          node: seriesModel.getData().tree.root
        };
      }
    }

    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));

    function onSelect(node) {
      if (this._state !== 'animating') {
        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
          node: node
        }) : this._zoomToNode({
          node: node
        });
      }
    }
  },

  /**
   * @override
   */
  remove: function () {
    this._clearController();

    this._containerGroup && this._containerGroup.removeAll();
    this._storage = createStorage();
    this._state = 'ready';
    this._breadcrumb && this._breadcrumb.remove();
  },
  dispose: function () {
    this._clearController();
  },

  /**
   * @private
   */
  _zoomToNode: function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapZoomToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  },

  /**
   * @private
   */
  _rootToNode: function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapRootToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  },

  /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */
  findTarget: function (x, y) {
    var targetInfo;
    var viewRoot = this.seriesModel.getViewRoot();
    viewRoot.eachNode({
      attr: 'viewChildren',
      order: 'preorder'
    }, function (node) {
      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.


      if (bgEl) {
        var point = bgEl.transformCoordToLocal(x, y);
        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.

        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
          targetInfo = {
            node: node,
            offsetX: point[0],
            offsetY: point[1]
          };
        } else {
          return false; // Suppress visit subtree.
        }
      }
    }, this);
    return targetInfo;
  }
});
/**
 * @inner
 */


function createStorage() {
  return {
    nodeGroup: [],
    background: [],
    content: []
  };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */


function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
  // Whether under viewRoot.
  if (!thisNode) {
    // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
  } // -------------------------------------------------------------------
  // Start of closure variables available in "Procedures in renderNode".


  var thisLayout = thisNode.getLayout();

  if (!thisLayout || !thisLayout.isInView) {
    return;
  }

  var thisWidth = thisLayout.width;
  var thisHeight = thisLayout.height;
  var borderWidth = thisLayout.borderWidth;
  var thisInvisible = thisLayout.invisible;
  var thisRawIndex = thisNode.getRawIndex();
  var oldRawIndex = oldNode && oldNode.getRawIndex();
  var thisViewChildren = thisNode.viewChildren;
  var upperHeight = thisLayout.upperHeight;
  var isParent = thisViewChildren && thisViewChildren.length;
  var itemStyleNormalModel = thisNode.getModel('itemStyle.normal');
  var itemStyleEmphasisModel = thisNode.getModel('itemStyle.emphasis'); // End of closure ariables available in "Procedures in renderNode".
  // -----------------------------------------------------------------
  // Node group

  var group = giveGraphic('nodeGroup', Group);

  if (!group) {
    return;
  }

  parentGroup.add(group); // x,y are not set when el is above view root.

  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
  group.__tmNodeWidth = thisWidth;
  group.__tmNodeHeight = thisHeight;

  if (thisLayout.isAboveViewRoot) {
    return group;
  } // Background


  var bg = giveGraphic('background', Rect, depth, Z_BG);
  bg && renderBackground(group, bg, isParent && thisLayout.upperHeight); // No children, render content.

  if (!isParent) {
    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
    content && renderContent(group, content);
  }

  return group; // ----------------------------
  // | Procedures in renderNode |
  // ----------------------------

  function renderBackground(group, bg, useUpperLabel) {
    // For tooltip.
    bg.dataIndex = thisNode.dataIndex;
    bg.seriesIndex = seriesModel.seriesIndex;
    bg.setShape({
      x: 0,
      y: 0,
      width: thisWidth,
      height: thisHeight
    });
    var visualBorderColor = thisNode.getVisual('borderColor', true);
    var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
    updateStyle(bg, function () {
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualBorderColor;
      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
      emphasisStyle.fill = emphasisBorderColor;

      if (useUpperLabel) {
        var upperLabelWidth = thisWidth - 2 * borderWidth;
        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
          x: borderWidth,
          y: 0,
          width: upperLabelWidth,
          height: upperHeight
        });
      } // For old bg.
      else {
          normalStyle.text = emphasisStyle.text = null;
        }

      bg.setStyle(normalStyle);
      graphic.setHoverStyle(bg, emphasisStyle);
    });
    group.add(bg);
  }

  function renderContent(group, content) {
    // For tooltip.
    content.dataIndex = thisNode.dataIndex;
    content.seriesIndex = seriesModel.seriesIndex;
    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
    content.culling = true;
    content.setShape({
      x: borderWidth,
      y: borderWidth,
      width: contentWidth,
      height: contentHeight
    });
    var visualColor = thisNode.getVisual('color', true);
    updateStyle(content, function () {
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualColor;
      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
      content.setStyle(normalStyle);
      graphic.setHoverStyle(content, emphasisStyle);
    });
    group.add(content);
  }

  function updateStyle(element, cb) {
    if (!thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      cb();

      if (!element.__tmWillVisible) {
        element.invisible = false;
      }
    } else {
      // Delay invisible setting utill animation finished,
      // avoid element vanish suddenly before animation.
      !element.invisible && willInvisibleEls.push(element);
    }
  }

  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
    var nodeModel = thisNode.getModel();
    var text = zrUtil.retrieve(seriesModel.getFormattedLabel(thisNode.dataIndex, 'normal', null, null, upperLabelRect ? 'upperLabel' : 'label'), nodeModel.get('name'));

    if (!upperLabelRect && thisLayout.isLeafRoot) {
      var iconChar = seriesModel.get('drillDownIcon', true);
      text = iconChar ? iconChar + ' ' + text : text;
    }

    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
    var isShow = normalLabelModel.getShallow('show');
    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
      defaultText: isShow ? text : null,
      autoColor: visualColor,
      isRectText: true
    });
    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
      outerWidth: width,
      outerHeight: height,
      minChar: 2
    } : null;
  }

  function giveGraphic(storageName, Ctor, depth, z) {
    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
    var lasts = lastsForAnimation[storageName];

    if (element) {
      // Remove from oldStorage
      oldStorage[storageName][oldRawIndex] = null;
      prepareAnimationWhenHasOld(lasts, element, storageName);
    } // If invisible and no old element, do not create new element (for optimizing).
    else if (!thisInvisible) {
        element = new Ctor({
          z: calculateZ(depth, z)
        });
        element.__tmDepth = depth;
        element.__tmStorageName = storageName;
        prepareAnimationWhenNoOld(lasts, element, storageName);
      } // Set to thisStorage


    return thisStorage[storageName][thisRawIndex] = element;
  }

  function prepareAnimationWhenHasOld(lasts, element, storageName) {
    var lastCfg = lasts[thisRawIndex] = {};
    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
  } // If a element is new, we need to find the animation start point carefully,
  // otherwise it will looks strange when 'zoomToNode'.


  function prepareAnimationWhenNoOld(lasts, element, storageName) {
    var lastCfg = lasts[thisRawIndex] = {};
    var parentNode = thisNode.parentNode;

    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
      var parentOldX = 0;
      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
      // For convenience, get old bounding rect from background.

      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];

      if (!reRoot && parentOldBg && parentOldBg.old) {
        parentOldX = parentOldBg.old.width;
        parentOldY = parentOldBg.old.height;
      } // When no parent old shape found, its parent is new too,
      // so we can just use {x:0, y:0}.


      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
        x: parentOldX,
        y: parentOldY,
        width: 0,
        height: 0
      };
    } // Fade in, user can be aware that these nodes are new.


    lastCfg.fadein = storageName !== 'nodeGroup';
  }
} // We can not set all backgroud with the same z, Because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause that lowser background element overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.


function calculateZ(depth, zInLevel) {
  var zb = depth * Z_BASE + zInLevel;
  return (zb - 1) / zb;
}

module.exports = _default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var helper = __webpack_require__(140);

/**
 * @file Treemap action
 */
var noop = function () {};

var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];

for (var i = 0; i < actionTypes.length; i++) {
  echarts.registerAction({
    type: actionTypes[i],
    update: 'updateView'
  }, noop);
}

echarts.registerAction({
  type: 'treemapRootToNode',
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'series',
    subType: 'treemap',
    query: payload
  }, handleRootToNode);

  function handleRootToNode(model, index) {
    var targetInfo = helper.retrieveTargetInfo(payload, model);

    if (targetInfo) {
      var originViewRoot = model.getViewRoot();

      if (originViewRoot) {
        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
      }

      model.resetViewRoot(targetInfo.node);
    }
  }
});

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;
var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;

var layout = __webpack_require__(17);

var helper = __webpack_require__(140);

var mathMax = Math.max;
var mathMin = Math.min;
var retrieveValue = zrUtil.retrieve;
var each = zrUtil.each;
var PATH_BORDER_WIDTH = ['itemStyle', 'normal', 'borderWidth'];
var PATH_GAP_WIDTH = ['itemStyle', 'normal', 'gapWidth'];
var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'normal', 'show'];
var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'normal', 'height'];
/**
 * @public
 */

function _default(ecModel, api, payload) {
  // Layout result in each node:
  // {x, y, width, height, area, borderWidth}
  var condition = {
    mainType: 'series',
    subType: 'treemap',
    query: payload
  };
  ecModel.eachComponent(condition, function (seriesModel) {
    var ecWidth = api.getWidth();
    var ecHeight = api.getHeight();
    var seriesOption = seriesModel.option;
    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
    var size = seriesOption.size || []; // Compatible with ec2.

    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.

    var payloadType = payload && payload.type;
    var targetInfo = helper.retrieveTargetInfo(payload, seriesModel);
    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
    var viewRoot = seriesModel.getViewRoot();
    var viewAbovePath = helper.getPathToRoot(viewRoot);

    if (payloadType !== 'treemapMove') {
      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
      var sort = seriesOption.sort;

      if (sort && sort !== 'asc' && sort !== 'desc') {
        sort = 'desc';
      }

      var options = {
        squareRatio: seriesOption.squareRatio,
        sort: sort,
        leafDepth: seriesOption.leafDepth
      }; // layout should be cleared because using updateView but not update.

      viewRoot.hostTree.clearLayouts(); // TODO
      // optimize: if out of view clip, do not layout.
      // But take care that if do not render node out of view clip,
      // how to calculate start po

      var viewRootLayout = {
        x: 0,
        y: 0,
        width: rootSize[0],
        height: rootSize[1],
        area: rootSize[0] * rootSize[1]
      };
      viewRoot.setLayout(viewRootLayout);
      squarify(viewRoot, options, false, 0); // Supplement layout.

      var viewRootLayout = viewRoot.getLayout();
      each(viewAbovePath, function (node, index) {
        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
        node.setLayout(zrUtil.extend({
          dataExtent: [childValue, childValue],
          borderWidth: 0,
          upperHeight: 0
        }, viewRootLayout));
      });
    }

    var treeRoot = seriesModel.getData().tree.root;
    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
    seriesModel.setLayoutInfo(layoutInfo); // FIXME
    // 现在没有clip功能，暂时取ec高宽。

    prunning(treeRoot, // Transform to base element coordinate system.
    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
  });
}
/**
 * Layout treemap with squarify algorithm.
 * @see https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf
 * @see https://github.com/mbostock/d3/blob/master/src/layout/treemap.js
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */


function squarify(node, options, hideChildren, depth) {
  var width;
  var height;

  if (node.isRemoved()) {
    return;
  }

  var thisLayout = node.getLayout();
  width = thisLayout.width;
  height = thisLayout.height; // Considering border and gap

  var nodeModel = node.getModel();
  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
  var upperLabelHeight = getUpperLabelHeight(nodeModel);
  var upperHeight = Math.max(borderWidth, upperLabelHeight);
  var layoutOffset = borderWidth - halfGapWidth;
  var layoutOffsetUpper = upperHeight - halfGapWidth;
  var nodeModel = node.getModel();
  node.setLayout({
    borderWidth: borderWidth,
    upperHeight: upperHeight,
    upperLabelHeight: upperLabelHeight
  }, true);
  width = mathMax(width - 2 * layoutOffset, 0);
  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
  var totalArea = width * height;
  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);

  if (!viewChildren.length) {
    return;
  }

  var rect = {
    x: layoutOffset,
    y: layoutOffsetUpper,
    width: width,
    height: height
  };
  var rowFixedLength = mathMin(width, height);
  var best = Infinity; // the best row score so far

  var row = [];
  row.area = 0;

  for (var i = 0, len = viewChildren.length; i < len;) {
    var child = viewChildren[i];
    row.push(child);
    row.area += child.getLayout().area;
    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation

    if (score <= best) {
      i++;
      best = score;
    } // abort, and try a different orientation
    else {
        row.area -= row.pop().getLayout().area;
        position(row, rowFixedLength, rect, halfGapWidth, false);
        rowFixedLength = mathMin(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
  }

  if (row.length) {
    position(row, rowFixedLength, rect, halfGapWidth, true);
  }

  if (!hideChildren) {
    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');

    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
      hideChildren = true;
    }
  }

  for (var i = 0, len = viewChildren.length; i < len; i++) {
    squarify(viewChildren[i], options, hideChildren, depth + 1);
  }
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */


function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
  var viewChildren = node.children || [];
  var orderBy = options.sort;
  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.

  if (hideChildren && !overLeafDepth) {
    return node.viewChildren = [];
  } // Sort children, order by desc.


  viewChildren = zrUtil.filter(viewChildren, function (child) {
    return !child.isRemoved();
  });
  sort(viewChildren, orderBy);
  var info = statistic(nodeModel, viewChildren, orderBy);

  if (info.sum === 0) {
    return node.viewChildren = [];
  }

  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);

  if (info.sum === 0) {
    return node.viewChildren = [];
  } // Set area to each child.


  for (var i = 0, len = viewChildren.length; i < len; i++) {
    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.

    viewChildren[i].setLayout({
      area: area
    });
  }

  if (overLeafDepth) {
    viewChildren.length && node.setLayout({
      isLeafRoot: true
    }, true);
    viewChildren.length = 0;
  }

  node.viewChildren = viewChildren;
  node.setLayout({
    dataExtent: info.dataExtent
  }, true);
  return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */


function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
  // visibleMin is not supported yet when no option.sort.
  if (!orderBy) {
    return sum;
  }

  var visibleMin = nodeModel.get('visibleMin');
  var len = orderedChildren.length;
  var deletePoint = len; // Always travel from little value to big value.

  for (var i = len - 1; i >= 0; i--) {
    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();

    if (value / sum * totalArea < visibleMin) {
      deletePoint = i;
      sum -= value;
    }
  }

  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
  return sum;
}
/**
 * Sort
 */


function sort(viewChildren, orderBy) {
  if (orderBy) {
    viewChildren.sort(function (a, b) {
      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
  }

  return viewChildren;
}
/**
 * Statistic
 */


function statistic(nodeModel, children, orderBy) {
  // Calculate sum.
  var sum = 0;

  for (var i = 0, len = children.length; i < len; i++) {
    sum += children[i].getValue();
  } // Statistic data extent for latter visual coding.
  // Notice: data extent should be calculate based on raw children
  // but not filtered view children, otherwise visual mapping will not
  // be stable when zoom (where children is filtered by visibleMin).


  var dimension = nodeModel.get('visualDimension');
  var dataExtent; // The same as area dimension.

  if (!children || !children.length) {
    dataExtent = [NaN, NaN];
  } else if (dimension === 'value' && orderBy) {
    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
    orderBy === 'asc' && dataExtent.reverse();
  } // Other dimension.
  else {
      var dataExtent = [Infinity, -Infinity];
      each(children, function (child) {
        var value = child.getValue(dimension);
        value < dataExtent[0] && (dataExtent[0] = value);
        value > dataExtent[1] && (dataExtent[1] = value);
      });
    }

  return {
    sum: sum,
    dataExtent: dataExtent
  };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */


function worst(row, rowFixedLength, ratio) {
  var areaMax = 0;
  var areaMin = Infinity;

  for (var i = 0, area, len = row.length; i < len; i++) {
    area = row[i].getLayout().area;

    if (area) {
      area < areaMin && (areaMin = area);
      area > areaMax && (areaMax = area);
    }
  }

  var squareArea = row.area * row.area;
  var f = rowFixedLength * rowFixedLength * ratio;
  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */


function position(row, rowFixedLength, rect, halfGapWidth, flush) {
  // When rowFixedLength === rect.width,
  // it is horizontal subdivision,
  // rowFixedLength is the width of the subdivision,
  // rowOtherLength is the height of the subdivision,
  // and nodes will be positioned from left to right.
  // wh[idx0WhenH] means: when horizontal,
  //      wh[idx0WhenH] => wh[0] => 'width'.
  //      xy[idx1WhenH] => xy[1] => 'y'.
  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
  var idx1WhenH = 1 - idx0WhenH;
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  var last = rect[xy[idx0WhenH]];
  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;

  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
  }

  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
    var node = row[i];
    var nodeLayout = {};
    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.

    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
    var modWH = i === rowLen - 1 || remain < step ? remain : step;
    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
    last += modWH;
    node.setLayout(nodeLayout, true);
  }

  rect[xy[idx1WhenH]] += rowOtherLength;
  rect[wh[idx1WhenH]] -= rowOtherLength;
} // Return [containerWidth, containerHeight] as defualt.


function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
  // If targetInfo.node exists, we zoom to the node,
  // so estimate whold width and heigth by target node.
  var currNode = (targetInfo || {}).node;
  var defaultSize = [containerWidth, containerHeight];

  if (!currNode || currNode === viewRoot) {
    return defaultSize;
  }

  var parent;
  var viewArea = containerWidth * containerHeight;
  var area = viewArea * seriesModel.option.zoomToNodeRatio;

  while (parent = currNode.parentNode) {
    // jshint ignore:line
    var sum = 0;
    var siblings = parent.children;

    for (var i = 0, len = siblings.length; i < len; i++) {
      sum += siblings[i].getValue();
    }

    var currNodeValue = currNode.getValue();

    if (currNodeValue === 0) {
      return defaultSize;
    }

    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.

    var parentModel = parent.getModel();
    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
    currNode = parent;
  }

  area < viewArea && (area = viewArea);
  var scale = Math.pow(area / viewArea, 0.5);
  return [containerWidth * scale, containerHeight * scale];
} // Root postion base on coord of containerGroup


function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
  if (rootRect) {
    return {
      x: rootRect.x,
      y: rootRect.y
    };
  }

  var defaultPosition = {
    x: 0,
    y: 0
  };

  if (!targetInfo) {
    return defaultPosition;
  } // If targetInfo is fetched by 'retrieveTargetInfo',
  // old tree and new tree are the same tree,
  // so the node still exists and we can visit it.


  var targetNode = targetInfo.node;
  var layout = targetNode.getLayout();

  if (!layout) {
    return defaultPosition;
  } // Transform coord from local to container.


  var targetCenter = [layout.width / 2, layout.height / 2];
  var node = targetNode;

  while (node) {
    var nodeLayout = node.getLayout();
    targetCenter[0] += nodeLayout.x;
    targetCenter[1] += nodeLayout.y;
    node = node.parentNode;
  }

  return {
    x: layoutInfo.width / 2 - targetCenter[0],
    y: layoutInfo.height / 2 - targetCenter[1]
  };
} // Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.


function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
  var nodeLayout = node.getLayout();
  var nodeInViewAbovePath = viewAbovePath[depth];
  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;

  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
    return;
  }

  node.setLayout({
    // isInView means: viewRoot sub tree + viewAbovePath
    isInView: true,
    // invisible only means: outside view clip so that the node can not
    // see but still layout for animation preparation but not render.
    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
    isAboveViewRoot: isAboveViewRoot
  }, true); // Transform to child coordinate.

  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
  each(node.viewChildren || [], function (child) {
    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
  });
}

function getUpperLabelHeight(model) {
  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
}

module.exports = _default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var VisualMapping = __webpack_require__(105);

var zrColor = __webpack_require__(78);

var zrUtil = __webpack_require__(0);

var isArray = zrUtil.isArray;
var ITEM_STYLE_NORMAL = 'itemStyle.normal';

function _default(ecModel, api, payload) {
  var condition = {
    mainType: 'series',
    subType: 'treemap',
    query: payload
  };
  ecModel.eachComponent(condition, function (seriesModel) {
    var tree = seriesModel.getData().tree;
    var root = tree.root;
    var seriesItemStyleModel = seriesModel.getModel(ITEM_STYLE_NORMAL);

    if (root.isRemoved()) {
      return;
    }

    var levelItemStyles = zrUtil.map(tree.levelModels, function (levelModel) {
      return levelModel ? levelModel.get(ITEM_STYLE_NORMAL) : null;
    });
    travelTree(root, // Visual should calculate from tree root but not view root.
    {}, levelItemStyles, seriesItemStyleModel, seriesModel.getViewRoot().getAncestors(), seriesModel);
  });
}

function travelTree(node, designatedVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel) {
  var nodeModel = node.getModel();
  var nodeLayout = node.getLayout(); // Optimize

  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
    return;
  }

  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
  var levelItemStyle = levelItemStyles[node.depth];
  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel); // calculate border color

  var borderColor = nodeItemStyleModel.get('borderColor');
  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
  var thisNodeColor;

  if (borderColorSaturation != null) {
    // For performance, do not always execute 'calculateColor'.
    thisNodeColor = calculateColor(visuals, node);
    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
  }

  node.setVisual('borderColor', borderColor);
  var viewChildren = node.viewChildren;

  if (!viewChildren || !viewChildren.length) {
    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.

    node.setVisual('color', thisNodeColor);
  } else {
    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.

    zrUtil.each(viewChildren, function (child, index) {
      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
        travelTree(child, childVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel);
      }
    });
  }
}

function buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel) {
  var visuals = zrUtil.extend({}, designatedVisual);
  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
    var val = nodeItemStyleModel.get(visualName, true); // Ignore parent

    val == null && levelItemStyle && (val = levelItemStyle[visualName]);
    val == null && (val = designatedVisual[visualName]);
    val == null && (val = seriesItemStyleModel.get(visualName));
    val != null && (visuals[visualName] = val);
  });
  return visuals;
}

function calculateColor(visuals) {
  var color = getValueVisualDefine(visuals, 'color');

  if (color) {
    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');

    if (colorSaturation) {
      color = zrColor.modifyHSL(color, null, null, colorSaturation);
    }

    if (colorAlpha) {
      color = zrColor.modifyAlpha(color, colorAlpha);
    }

    return color;
  }
}

function calculateBorderColor(borderColorSaturation, thisNodeColor) {
  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
}

function getValueVisualDefine(visuals, name) {
  var value = visuals[name];

  if (value != null && value !== 'none') {
    return value;
  }
}

function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
  if (!viewChildren || !viewChildren.length) {
    return;
  }

  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));

  if (!rangeVisual) {
    return;
  }

  var visualMin = nodeModel.get('visualMin');
  var visualMax = nodeModel.get('visualMax');
  var dataExtent = nodeLayout.dataExtent.slice();
  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
  var colorMappingBy = nodeModel.get('colorMappingBy');
  var opt = {
    type: rangeVisual.name,
    dataExtent: dataExtent,
    visual: rangeVisual.range
  };

  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
    opt.mappingMethod = 'category';
    opt.loop = true; // categories is ordinal, so do not set opt.categories.
  } else {
    opt.mappingMethod = 'linear';
  }

  var mapping = new VisualMapping(opt);
  mapping.__drColorMappingBy = colorMappingBy;
  return mapping;
} // Notice: If we dont have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node dont have children, and its siblings has children,
// and colorRange is set on level-1, then the node can not be colored.
// So we separate 'colorRange' and 'color' to different attributes.


function getRangeVisual(nodeModel, name) {
  // 'colorRange', 'colorARange', 'colorSRange'.
  // If not exsits on this node, fetch from levels and series.
  var range = nodeModel.get(name);
  return isArray(range) && range.length ? {
    name: name,
    range: range
  } : null;
}

function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
  var childVisuals = zrUtil.extend({}, visuals);

  if (mapping) {
    var mappingType = mapping.type;
    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
    childVisuals[mappingType] = mapping.mapValueToVisual(value);
  }

  return childVisuals;
}

module.exports = _default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(282);

__webpack_require__(1479);

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(481);

__webpack_require__(1480);

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var Model = __webpack_require__(29);

var AxisView = __webpack_require__(103);

var elementList = ['axisLine', 'axisLabel', 'axisTick', 'splitLine', 'splitArea'];

function getAxisLineShape(polar, rExtent, angle) {
  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
  var start = polar.coordToPoint([rExtent[0], angle]);
  var end = polar.coordToPoint([rExtent[1], angle]);
  return {
    x1: start[0],
    y1: start[1],
    x2: end[0],
    y2: end[1]
  };
}

function getRadiusIdx(polar) {
  var radiusAxis = polar.getRadiusAxis();
  return radiusAxis.inverse ? 0 : 1;
}

var _default = AxisView.extend({
  type: 'angleAxis',
  axisPointerClass: 'PolarAxisPointer',
  render: function (angleAxisModel, ecModel) {
    this.group.removeAll();

    if (!angleAxisModel.get('show')) {
      return;
    }

    var angleAxis = angleAxisModel.axis;
    var polar = angleAxis.polar;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var ticksAngles = angleAxis.getTicksCoords();

    if (angleAxis.type !== 'category') {
      // Remove the last tick which will overlap the first tick
      ticksAngles.pop();
    }

    zrUtil.each(elementList, function (name) {
      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
        this['_' + name](angleAxisModel, polar, ticksAngles, radiusExtent);
      }
    }, this);
  },

  /**
   * @private
   */
  _axisLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle');
    var circle = new graphic.Circle({
      shape: {
        cx: polar.cx,
        cy: polar.cy,
        r: radiusExtent[getRadiusIdx(polar)]
      },
      style: lineStyleModel.getLineStyle(),
      z2: 1,
      silent: true
    });
    circle.style.fill = null;
    this.group.add(circle);
  },

  /**
   * @private
   */
  _axisTick: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
    var tickModel = angleAxisModel.getModel('axisTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = zrUtil.map(ticksAngles, function (tickAngle) {
      return new graphic.Line({
        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngle)
      });
    });
    this.group.add(graphic.mergePath(lines, {
      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
        stroke: angleAxisModel.get('axisLine.lineStyle.color')
      })
    }));
  },

  /**
   * @private
   */
  _axisLabel: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
    var axis = angleAxisModel.axis;
    var categoryData = angleAxisModel.get('data');
    var labelModel = angleAxisModel.getModel('axisLabel');
    var labels = angleAxisModel.getFormattedLabels();
    var labelMargin = labelModel.get('margin');
    var labelsAngles = axis.getLabelsCoords(); // Use length of ticksAngles because it may remove the last tick to avoid overlapping

    for (var i = 0; i < ticksAngles.length; i++) {
      var r = radiusExtent[getRadiusIdx(polar)];
      var p = polar.coordToPoint([r + labelMargin, labelsAngles[i]]);
      var cx = polar.cx;
      var cy = polar.cy;
      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';

      if (categoryData && categoryData[i] && categoryData[i].textStyle) {
        labelModel = new Model(categoryData[i].textStyle, labelModel, labelModel.ecModel);
      }

      var textEl = new graphic.Text({
        silent: true
      });
      this.group.add(textEl);
      graphic.setTextStyle(textEl.style, labelModel, {
        x: p[0],
        y: p[1],
        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
        text: labels[i],
        textAlign: labelTextAlign,
        textVerticalAlign: labelTextVerticalAlign
      });
    }
  },

  /**
   * @private
   */
  _splitLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
    var splitLineModel = angleAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Line({
        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i])
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: zrUtil.defaults({
          stroke: lineColors[i % lineColors.length]
        }, lineStyleModel.getLineStyle()),
        silent: true,
        z: angleAxisModel.get('z')
      }));
    }
  },

  /**
   * @private
   */
  _splitArea: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
    var splitAreaModel = angleAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var RADIAN = Math.PI / 180;
    var prevAngle = -ticksAngles[0] * RADIAN;
    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
    var clockwise = angleAxisModel.get('clockwise');

    for (var i = 1; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new graphic.Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: r0,
          r: r1,
          startAngle: prevAngle,
          endAngle: -ticksAngles[i] * RADIAN,
          clockwise: clockwise
        },
        silent: true
      }));
      prevAngle = -ticksAngles[i] * RADIAN;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      this.group.add(graphic.mergePath(splitAreas[i], {
        style: zrUtil.defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
});

module.exports = _default;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var AxisBuilder = __webpack_require__(102);

var AxisView = __webpack_require__(103);

var cartesianAxisHelper = __webpack_require__(453);

var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick;
var getInterval = AxisBuilder.getInterval;
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine']; // function getAlignWithLabel(model, axisModel) {
//     var alignWithLabel = model.get('alignWithLabel');
//     if (alignWithLabel === 'auto') {
//         alignWithLabel = axisModel.get('axisTick.alignWithLabel');
//     }
//     return alignWithLabel;
// }

var CartesianAxisView = AxisView.extend({
  type: 'cartesianAxis',
  axisPointerClass: 'CartesianAxisPointer',

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    zrUtil.each(selfBuilderAttrs, function (name) {
      if (axisModel.get(name + '.show')) {
        this['_' + name](axisModel, gridModel, layout.labelInterval);
      }
    }, this);
    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @param {number|Function} labelInterval
   * @private
   */
  _splitLine: function (axisModel, gridModel, labelInterval) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineInterval = getInterval(splitLineModel, labelInterval);
    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords();
    var ticks = axis.scale.getTicks();
    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
    var p1 = [];
    var p2 = []; // Simple optimization
    // Batching the lines if color are the same

    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      if (ifIgnoreOnTick(axis, i, lineInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
        continue;
      }

      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;

      this._axisGroup.add(new graphic.Line(graphic.subPixelOptimizeLine({
        anid: 'line_' + ticks[i],
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: zrUtil.defaults({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      })));
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @param {number|Function} labelInterval
   * @private
   */
  _splitArea: function (axisModel, gridModel, labelInterval) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords();
    var ticks = axis.scale.getTicks();
    var prevX = axis.toGlobalCoord(ticksCoords[0]);
    var prevY = axis.toGlobalCoord(ticksCoords[0]);
    var count = 0;
    var areaInterval = getInterval(splitAreaModel, labelInterval);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');

    for (var i = 1; i < ticksCoords.length; i++) {
      if (ifIgnoreOnTick(axis, i, areaInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
        continue;
      }

      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);
      var x;
      var y;
      var width;
      var height;

      if (axis.isHorizontal()) {
        x = prevX;
        y = gridRect.y;
        width = tickCoord - x;
        height = gridRect.height;
      } else {
        x = gridRect.x;
        y = prevY;
        width = gridRect.width;
        height = tickCoord - y;
      }

      var colorIndex = count++ % areaColors.length;

      this._axisGroup.add(new graphic.Rect({
        anid: 'area_' + ticks[i],
        shape: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        style: zrUtil.defaults({
          fill: areaColors[colorIndex]
        }, areaStyle),
        silent: true
      }));

      prevX = x + width;
      prevY = y + height;
    }
  }
});
CartesianAxisView.extend({
  type: 'xAxis'
});
CartesianAxisView.extend({
  type: 'yAxis'
});

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var AxisBuilder = __webpack_require__(102);

var BrushController = __webpack_require__(275);

var brushHelper = __webpack_require__(464);

var graphic = __webpack_require__(5);

var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
var AxisView = echarts.extendComponentView({
  type: 'parallelAxis',

  /**
   * @override
   */
  init: function (ecModel, api) {
    AxisView.superApply(this, 'init', arguments);
    /**
     * @type {module:echarts/component/helper/BrushController}
     */

    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
  },

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
      return;
    }

    this.axisModel = axisModel;
    this.api = api;
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var coordSysModel = getCoordSysModel(axisModel, ecModel);
    var coordSys = coordSysModel.coordinateSystem;
    var areaSelectStyle = axisModel.getAreaSelectStyle();
    var areaWidth = areaSelectStyle.width;
    var dim = axisModel.axis.dim;
    var axisLayout = coordSys.getAxisLayout(dim);
    var builderOpt = zrUtil.extend({
      strokeContainThreshold: areaWidth
    }, axisLayout);
    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
    zrUtil.each(elementList, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);

    var animationModel = payload && payload.animation === false ? null : axisModel;
    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
  },

  /**
   * @override
   */
  updateVisual: function (axisModel, ecModel, api, payload) {
    this._brushController && this._brushController.updateCovers(getCoverInfoList(axisModel));
  },
  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
    // After filtering, axis may change, select area needs to be update.
    var extent = axisModel.axis.getExtent();
    var extentLen = extent[1] - extent[0];
    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
    // width/height might be negative, which will be
    // normalized in BoundingRect.

    var rect = graphic.BoundingRect.create({
      x: extent[0],
      y: -areaWidth / 2,
      width: extentLen,
      height: areaWidth
    });
    rect.x -= extra;
    rect.width += 2 * extra;

    this._brushController.mount({
      enableGlobalPan: true,
      rotation: builderOpt.rotation,
      position: builderOpt.position
    }).setPanels([{
      panelId: 'pl',
      clipPath: brushHelper.makeRectPanelClipPath(rect),
      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
    }]).enableBrush({
      brushType: 'lineX',
      brushStyle: areaSelectStyle,
      removeOnClick: true
    }).updateCovers(getCoverInfoList(axisModel));
  },
  _onBrush: function (coverInfoList, opt) {
    // Do not cache these object, because the mey be changed.
    var axisModel = this.axisModel;
    var axis = axisModel.axis;
    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
    }); // If realtime is true, action is not dispatched on drag end, because
    // the drag end emits the same params with the last drag move event,
    // and may have some delay when using touch pad.

    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'axisAreaSelect',
        parallelAxisId: axisModel.id,
        intervals: intervals
      });
    }
  },

  /**
   * @override
   */
  dispose: function () {
    this._brushController.dispose();
  }
});

function fromAxisAreaSelect(axisModel, ecModel, payload) {
  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
    mainType: 'parallelAxis',
    query: payload
  })[0] === axisModel;
}

function getCoverInfoList(axisModel) {
  var axis = axisModel.axis;
  return zrUtil.map(axisModel.activeIntervals, function (interval) {
    return {
      brushType: 'lineX',
      panelId: 'pl',
      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
    };
  });
}

function getCoordSysModel(axisModel, ecModel) {
  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var AxisBuilder = __webpack_require__(102);

var AxisView = __webpack_require__(103);

var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitLine', 'splitArea'];

var _default = AxisView.extend({
  type: 'radiusAxis',
  axisPointerClass: 'PolarAxisPointer',
  render: function (radiusAxisModel, ecModel) {
    this.group.removeAll();

    if (!radiusAxisModel.get('show')) {
      return;
    }

    var radiusAxis = radiusAxisModel.axis;
    var polar = radiusAxis.polar;
    var angleAxis = polar.getAngleAxis();
    var ticksCoords = radiusAxis.getTicksCoords();
    var axisAngle = angleAxis.getExtent()[0];
    var radiusExtent = radiusAxis.getExtent();
    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
    this.group.add(axisBuilder.getGroup());
    zrUtil.each(selfBuilderAttrs, function (name) {
      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords);
      }
    }, this);
  },

  /**
   * @private
   */
  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    var splitLineModel = radiusAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Circle({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: ticksCoords[i]
        },
        silent: true
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: zrUtil.defaults({
          stroke: lineColors[i % lineColors.length],
          fill: null
        }, lineStyleModel.getLineStyle()),
        silent: true
      }));
    }
  },

  /**
   * @private
   */
  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    var splitAreaModel = radiusAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var prevRadius = ticksCoords[0];

    for (var i = 1; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new graphic.Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: prevRadius,
          r: ticksCoords[i],
          startAngle: 0,
          endAngle: Math.PI * 2
        },
        silent: true
      }));
      prevRadius = ticksCoords[i];
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      this.group.add(graphic.mergePath(splitAreas[i], {
        style: zrUtil.defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
});
/**
 * @inner
 */


function layoutAxis(polar, radiusAxisModel, axisAngle) {
  return {
    position: [polar.cx, polar.cy],
    rotation: axisAngle / 180 * Math.PI,
    labelDirection: -1,
    tickDirection: -1,
    nameDirection: 1,
    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
    // Over splitLine and splitArea
    z2: 1
  };
}

module.exports = _default;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var AxisBuilder = __webpack_require__(102);

var graphic = __webpack_require__(5);

var singleAxisHelper = __webpack_require__(454);

var AxisView = __webpack_require__(103);

var getInterval = AxisBuilder.getInterval;
var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick;
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttr = 'splitLine';
var SingleAxisView = AxisView.extend({
  type: 'singleAxis',
  axisPointerClass: 'SingleAxisPointer',
  render: function (axisModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();
    var layout = singleAxisHelper.layout(axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
    group.add(axisBuilder.getGroup());

    if (axisModel.get(selfBuilderAttr + '.show')) {
      this['_' + selfBuilderAttr](axisModel, layout.labelInterval);
    }

    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },
  _splitLine: function (axisModel, labelInterval) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineWidth = lineStyleModel.get('width');
    var lineColors = lineStyleModel.get('color');
    var lineInterval = getInterval(splitLineModel, labelInterval);
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var gridRect = axisModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var splitLines = [];
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords();
    var p1 = [];
    var p2 = [];
    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');

    for (var i = 0; i < ticksCoords.length; ++i) {
      if (ifIgnoreOnTick(axis, i, lineInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
        continue;
      }

      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new graphic.Line(graphic.subPixelOptimizeLine({
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: {
          lineWidth: lineWidth
        },
        silent: true
      })));
    }

    for (var i = 0; i < splitLines.length; ++i) {
      this.group.add(graphic.mergePath(splitLines[i], {
        style: {
          stroke: lineColors[i % lineColors.length],
          lineDash: lineStyleModel.getLineDash(lineWidth),
          lineWidth: lineWidth
        },
        silent: true
      }));
    }
  }
});
var _default = SingleAxisView;
module.exports = _default;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

/**
 * @payload
 * @property {string} parallelAxisId
 * @property {Array.<Array.<number>>} intervals
 */
var actionInfo = {
  type: 'axisAreaSelect',
  event: 'axisAreaSelected',
  update: 'updateVisual'
};
echarts.registerAction(actionInfo, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'parallelAxis',
    query: payload
  }, function (parallelAxisModel) {
    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
  });
});
/**
 * @payload
 */

echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'parallel',
    query: payload
  }, function (parallelModel) {
    parallelModel.setAxisExpand(payload);
  });
});

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var AxisPointerModel = echarts.extendComponentModel({
  type: 'axisPointer',
  coordSysAxesInfo: null,
  defaultOption: {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // 'click' | 'mousemove' | 'none'
    triggerOn: null,
    // set default in AxisPonterView.js
    zlevel: 0,
    z: 50,
    type: 'line',
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    // Init value depends on whether handle is used.
    // [group0, group1, ...]
    // Each group can be: {
    //      mapper: function () {},
    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
    //      xAxisId: ...,
    //      yAxisName: ...,
    //      angleAxisIndex: ...
    // }
    // mapper: can be ignored.
    //      input: {axisInfo, value}
    //      output: {axisInfo, value}
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#aaa',
      width: 1,
      type: 'solid'
    },
    shadowStyle: {
      color: 'rgba(150,150,150,0.3)'
    },
    label: {
      show: true,
      formatter: null,
      // string | Function
      precision: 'auto',
      // Or a number like 0, 1, 2 ...
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      // default: axis line color
      borderColor: null,
      borderWidth: 0,
      shadowBlur: 3,
      shadowColor: '#aaa' // Considering applicability, common style should
      // better not have shadowOffset.
      // shadowOffsetX: 0,
      // shadowOffsetY: 2

    },
    handle: {
      show: false,
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      // jshint ignore:line
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  }
});
var _default = AxisPointerModel;
module.exports = _default;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var globalListener = __webpack_require__(457);

var AxisPointerView = echarts.extendComponentView({
  type: 'axisPointer',
  render: function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    globalListener.unregister(api.getZr(), 'axisPointer');
    AxisPointerView.superApply(this._model, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    globalListener.unregister('axisPointer', api);
    AxisPointerView.superApply(this._model, 'dispose', arguments);
  }
});
var _default = AxisPointerView;
module.exports = _default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

var formatUtil = __webpack_require__(21);

var BaseAxisPointer = __webpack_require__(273);

var graphic = __webpack_require__(5);

var viewHelper = __webpack_require__(190);

var matrix = __webpack_require__(53);

var AxisBuilder = __webpack_require__(102);

var AxisView = __webpack_require__(103);

var PolarAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;

    if (axis.dim === 'angle') {
      this.animationThreshold = Math.PI / 18;
    }

    var polar = axis.polar;
    var otherAxis = polar.getOtherAxis(axis);
    var otherExtent = otherAxis.getExtent();
    var coordValue;
    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var labelMargin = axisPointerModel.get('label.margin');
    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
  } // Do not support handle, utill any user requires it.

});

function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
  var axis = axisModel.axis;
  var coord = axis.dataToCoord(value);
  var axisAngle = polar.getAngleAxis().getExtent()[0];
  axisAngle = axisAngle / 180 * Math.PI;
  var radiusExtent = polar.getRadiusAxis().getExtent();
  var position;
  var align;
  var verticalAlign;

  if (axis.dim === 'radius') {
    var transform = matrix.create();
    matrix.rotate(transform, transform, axisAngle);
    matrix.translate(transform, transform, [polar.cx, polar.cy]);
    position = graphic.applyTransform([coord, -labelMargin], transform);
    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
    align = labelLayout.textAlign;
    verticalAlign = labelLayout.textVerticalAlign;
  } else {
    // angle axis
    var r = radiusExtent[1];
    position = polar.coordToPoint([r + labelMargin, coord]);
    var cx = polar.cx;
    var cy = polar.cy;
    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
  }

  return {
    position: position,
    align: align,
    verticalAlign: verticalAlign
  };
}

var pointerShapeBuilder = {
  line: function (axis, polar, coordValue, otherExtent, elStyle) {
    return axis.dim === 'angle' ? {
      type: 'Line',
      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
    } : {
      type: 'Circle',
      shape: {
        cx: polar.cx,
        cy: polar.cy,
        r: coordValue
      }
    };
  },
  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
    var bandWidth = axis.getBandWidth();
    var radian = Math.PI / 180;
    return axis.dim === 'angle' ? {
      type: 'Sector',
      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
    } : {
      type: 'Sector',
      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
    };
  }
};
AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
var _default = PolarAxisPointer;
module.exports = _default;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(5);

var BaseAxisPointer = __webpack_require__(273);

var viewHelper = __webpack_require__(190);

var singleAxisHelper = __webpack_require__(454);

var AxisView = __webpack_require__(103);

var XY = ['x', 'y'];
var WH = ['width', 'height'];
var SingleAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
    var pixelValue = coordSys.dataToPoint(value)[0];
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = singleAxisHelper.layout(axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = singleAxisHelper.layout(axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var dimIndex = getPointDimIndex(axis);
    var axisExtent = getGlobalExtent(coordSys, dimIndex);
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: {
        verticalAlign: 'middle'
      }
    };
  }
});
var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent, elStyle) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
    graphic.subPixelOptimizeLine({
      shape: targetShape,
      style: elStyle
    });
    return {
      type: 'Line',
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent, elStyle) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
    };
  }
};

function getPointDimIndex(axis) {
  return axis.isHorizontal() ? 0 : 1;
}

function getGlobalExtent(coordSys, dimIndex) {
  var rect = coordSys.getRect();
  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
}

AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
var _default = SingleAxisPointer;
module.exports = _default;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var modelHelper = __webpack_require__(189);

var findPointFromSeries = __webpack_require__(456);

var each = zrUtil.each;
var curry = zrUtil.curry;
var get = modelUtil.makeGetter();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */

function _default(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = findPointFromSeries({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputFinder = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: curry(showPointer, showValueMap),
    showTooltip: curry(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  each(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  each(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
  });
  updateModelActually(showValueMap, axesInfo, outputFinder);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputFinder;
}

function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By defualt use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    zrUtil.extend(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!dontSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  each(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.coordDimToDataDim(dim);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      false, axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      each(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = modelHelper.makeKey(coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get('label.precision'),
      formatter: axisPointerModel.get('label.formatter')
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputFinder) {
  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = get(zr)[highDownKey] || {};
  var newHighlights = get(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  zrUtil.each(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  zrUtil.each(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

module.exports = _default;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var preprocessor = __webpack_require__(1494);

__webpack_require__(1496);

__webpack_require__(1491);

__webpack_require__(1492);

__webpack_require__(1493);

__webpack_require__(1547);

/**
 * Brush component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var visualSolution = __webpack_require__(197);

var Model = __webpack_require__(29);

var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
var BrushModel = echarts.extendComponentModel({
  type: 'brush',
  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],

  /**
   * @protected
   */
  defaultOption: {
    // inBrush: null,
    // outOfBrush: null,
    toolbox: null,
    // Default value see preprocessor.
    brushLink: null,
    // Series indices array, broadcast using dataIndex.
    // or 'all', which means all series. 'none' or null means no series.
    seriesIndex: 'all',
    // seriesIndex array, specify series controlled by this brush component.
    geoIndex: null,
    //
    xAxisIndex: null,
    yAxisIndex: null,
    brushType: 'rect',
    // Default brushType, see BrushController.
    brushMode: 'single',
    // Default brushMode, 'single' or 'multiple'
    transformable: true,
    // Default transformable.
    brushStyle: {
      // Default brushStyle
      borderWidth: 1,
      color: 'rgba(120,140,180,0.3)',
      borderColor: 'rgba(120,140,180,0.8)'
    },
    throttleType: 'fixRate',
    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
    // If null, no throttle. Valid only in the first brush component
    throttleDelay: 0,
    // Unit: ms, 0 means every event will be triggered.
    // FIXME
    // 试验效果
    removeOnClick: true,
    z: 10000
  },

  /**
   * @readOnly
   * @type {Array.<Object>}
   */
  areas: [],

  /**
   * Current activated brush type.
   * If null, brush is inactived.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {string}
   */
  brushType: null,

  /**
   * Current brush opt.
   * see module:echarts/component/helper/BrushController
   * @readOnly
   * @type {Object}
   */
  brushOption: {},

  /**
   * @readOnly
   * @type {Array.<Object>}
   */
  coordInfoList: [],
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
    thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.

    thisOption.outOfBrush = thisOption.outOfBrush || {
      color: DEFAULT_OUT_OF_BRUSH_COLOR
    };
  },

  /**
   * If ranges is null/undefined, range state remain.
   *
   * @param {Array.<Object>} [ranges]
   */
  setAreas: function (areas) {
    // If ranges is null/undefined, range state remain.
    // This helps user to dispatchAction({type: 'brush'}) with no areas
    // set but just want to get the current brush select info from a `brush` event.
    if (!areas) {
      return;
    }

    this.areas = zrUtil.map(areas, function (area) {
      return generateBrushOption(this.option, area);
    }, this);
  },

  /**
   * see module:echarts/component/helper/BrushController
   * @param {Object} brushOption
   */
  setBrushOption: function (brushOption) {
    this.brushOption = generateBrushOption(this.option, brushOption);
    this.brushType = this.brushOption.brushType;
  }
});

function generateBrushOption(option, brushOption) {
  return zrUtil.merge({
    brushType: option.brushType,
    brushMode: option.brushMode,
    transformable: option.transformable,
    brushStyle: new Model(option.brushStyle).getItemStyle(),
    removeOnClick: option.removeOnClick,
    z: option.z
  }, brushOption, true);
}

var _default = BrushModel;
module.exports = _default;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var BrushController = __webpack_require__(275);

var _default = echarts.extendComponentView({
  type: 'brush',
  init: function (ecModel, api) {
    /**
     * @readOnly
     * @type {module:echarts/model/Global}
     */
    this.ecModel = ecModel;
    /**
     * @readOnly
     * @type {module:echarts/ExtensionAPI}
     */

    this.api = api;
    /**
     * @readOnly
     * @type {module:echarts/component/brush/BrushModel}
     */

    this.model;
    /**
     * @private
     * @type {module:echarts/component/helper/BrushController}
     */

    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
  },

  /**
   * @override
   */
  render: function (brushModel) {
    this.model = brushModel;
    return updateController.apply(this, arguments);
  },

  /**
   * @override
   */
  updateView: updateController,

  /**
   * @override
   */
  updateLayout: updateController,

  /**
   * @override
   */
  updateVisual: updateController,

  /**
   * @override
   */
  dispose: function () {
    this._brushController.dispose();
  },

  /**
   * @private
   */
  _onBrush: function (areas, opt) {
    var modelId = this.model.id;
    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
    // emits the same params with the last drag move event, and
    // may have some delay when using touch pad, which makes
    // animation not smooth (when using debounce).

    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
      type: 'brush',
      brushId: modelId,
      areas: zrUtil.clone(areas),
      $from: modelId
    });
  }
});

function updateController(brushModel, ecModel, api, payload) {
  // Do not update controller when drawing.
  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
}

module.exports = _default;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

/**
 * payload: {
 *      brushIndex: number, or,
 *      brushId: string, or,
 *      brushName: string,
 *      globalRanges: Array
 * }
 */
echarts.registerAction({
  type: 'brush',
  event: 'brush',
  update: 'updateView'
}, function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'brush',
    query: payload
  }, function (brushModel) {
    brushModel.setAreas(payload.areas);
  });
});
/**
 * payload: {
 *      brushComponents: [
 *          {
 *              brushId,
 *              brushIndex,
 *              brushName,
 *              series: [
 *                  {
 *                      seriesId,
 *                      seriesIndex,
 *                      seriesName,
 *                      rawIndices: [21, 34, ...]
 *                  },
 *                  ...
 *              ]
 *          },
 *          ...
 *      ]
 * }
 */

echarts.registerAction({
  type: 'brushSelect',
  event: 'brushSelected',
  update: 'none'
}, function () {});

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];

function _default(option, isNew) {
  var brushComponents = option && option.brush;

  if (!zrUtil.isArray(brushComponents)) {
    brushComponents = brushComponents ? [brushComponents] : [];
  }

  if (!brushComponents.length) {
    return;
  }

  var brushComponentSpecifiedBtns = [];
  zrUtil.each(brushComponents, function (brushOpt) {
    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];

    if (tbs instanceof Array) {
      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    }
  });
  var toolbox = option && option.toolbox;

  if (zrUtil.isArray(toolbox)) {
    toolbox = toolbox[0];
  }

  if (!toolbox) {
    toolbox = {
      feature: {}
    };
    option.toolbox = [toolbox];
  }

  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
  removeDuplicate(brushTypes);

  if (isNew && !brushTypes.length) {
    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
  }
}

function removeDuplicate(arr) {
  var map = {};
  zrUtil.each(arr, function (val) {
    map[val] = 1;
  });
  arr.length = 0;
  zrUtil.each(map, function (flag, val) {
    arr.push(val);
  });
}

module.exports = _default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var polygonContain = __webpack_require__(686);

var BoundingRect = __webpack_require__(26);

// Key of the first level is brushType: `line`, `rect`, `polygon`.
// Key of the second level is chart element type: `point`, `rect`.
// See moudule:echarts/component/helper/BrushController
// function param:
//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
//      {Object} selectors {point: selector, rect: selector, ...}
//      {Object} area {range: [[], [], ..], boudingRect}
// function return:
//      {boolean} Whether in the given brush.
var selector = {
  lineX: getLineSelectors(0),
  lineY: getLineSelectors(1),
  rect: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.intersect(itemLayout);
    }
  },
  polygon: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      var points = area.range;

      if (!itemLayout || points.length <= 1) {
        return false;
      }

      var x = itemLayout.x;
      var y = itemLayout.y;
      var width = itemLayout.width;
      var height = itemLayout.height;
      var p = points[0];

      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || lineIntersectPolygon(x, y, x + width, y, points) || lineIntersectPolygon(x, y, x, y + height, points) || lineIntersectPolygon(x + width, y, x + width, y + height, points) || lineIntersectPolygon(x, y + height, x + width, y + height, points)) {
        return true;
      }
    }
  }
};

function getLineSelectors(xyIndex) {
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  return {
    point: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var p = itemLayout[xyIndex];
        return inLineRange(p, range);
      }
    },
    rect: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
      }
    }
  };
}

function inLineRange(p, range) {
  return range[0] <= p && p <= range[1];
}

function lineIntersectPolygon(lx, ly, l2x, l2y, points) {
  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
    var p = points[i];

    if (lineIntersect(lx, ly, l2x, l2y, p[0], p[1], p2[0], p2[1])) {
      return true;
    }

    p2 = p;
  }
} // Code from <http://blog.csdn.net/rickliuxiao/article/details/6259322> with some fix.
// See <https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection>


function lineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
  var delta = determinant(a2x - a1x, b1x - b2x, a2y - a1y, b1y - b2y);

  if (nearZero(delta)) {
    // parallel
    return false;
  }

  var namenda = determinant(b1x - a1x, b1x - b2x, b1y - a1y, b1y - b2y) / delta;

  if (namenda < 0 || namenda > 1) {
    return false;
  }

  var miu = determinant(a2x - a1x, b1x - a1x, a2y - a1y, b1y - a1y) / delta;

  if (miu < 0 || miu > 1) {
    return false;
  }

  return true;
}

function nearZero(val) {
  return val <= 1e-6 && val >= -1e-6;
}

function determinant(v1, v2, v3, v4) {
  return v1 * v4 - v2 * v3;
}

var _default = selector;
module.exports = _default;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var visualSolution = __webpack_require__(197);

var selector = __webpack_require__(1495);

var throttleUtil = __webpack_require__(104);

var BrushTargetManager = __webpack_require__(462);

var STATE_LIST = ['inBrush', 'outOfBrush'];
var DISPATCH_METHOD = '__ecBrushSelect';
var DISPATCH_FLAG = '__ecInBrushSelectEvent';
var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
/**
 * Layout for visual, the priority higher than other layout, and before brush visual.
 */

echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
      brushType: false
    });
    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
  });
});
/**
 * Register the visual encoding if this modules required.
 */

echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
  var brushSelected = [];
  var throttleType;
  var throttleDelay;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel, brushIndex) {
    var thisBrushSelected = {
      brushId: brushModel.id,
      brushIndex: brushIndex,
      brushName: brushModel.name,
      areas: zrUtil.clone(brushModel.areas),
      selected: []
    }; // Every brush component exists in event params, convenient
    // for user to find by index.

    brushSelected.push(thisBrushSelected);
    var brushOption = brushModel.option;
    var brushLink = brushOption.brushLink;
    var linkedSeriesMap = [];
    var selectedDataIndexForLink = [];
    var rangeInfoBySeries = [];
    var hasBrushExists = 0;

    if (!brushIndex) {
      // Only the first throttle setting works.
      throttleType = brushOption.throttleType;
      throttleDelay = brushOption.throttleDelay;
    } // Add boundingRect and selectors to range.


    var areas = zrUtil.map(brushModel.areas, function (area) {
      return bindSelector(zrUtil.defaults({
        boundingRect: boundingRectBuilders[area.brushType](area)
      }, area));
    });
    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
      mappingOption.mappingMethod = 'fixed';
    });
    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
      linkedSeriesMap[seriesIndex] = 1;
    });

    function linkOthers(seriesIndex) {
      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
    } // If no supported brush or no brush on the series,
    // all visuals should be in original state.


    function brushed(rangeInfoList) {
      return !!rangeInfoList.length;
    }
    /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */
    // Step A


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
    });

    function stepAParallel(seriesModel, seriesIndex) {
      var coordSys = seriesModel.coordinateSystem;
      hasBrushExists |= coordSys.hasAxisBrushed();
      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
      });
    }

    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);

      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
        return;
      }

      zrUtil.each(areas, function (area) {
        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
        hasBrushExists |= brushed(rangeInfoList);
      });

      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
        var data = seriesModel.getData();
        data.each(function (dataIndex) {
          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
            selectedDataIndexForLink[dataIndex] = 1;
          }
        });
      }
    } // Step B


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var seriesBrushSelected = {
        seriesId: seriesModel.id,
        seriesIndex: seriesIndex,
        seriesName: seriesModel.name,
        dataIndex: []
      }; // Every series exists in event params, convenient
      // for user to find series by seriesIndex.

      thisBrushSelected.selected.push(seriesBrushSelected);
      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
      var rangeInfoList = rangeInfoBySeries[seriesIndex];
      var data = seriesModel.getData();
      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      } : function (dataIndex) {
        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      }; // If no supported brush or no brush, all visuals are in original state.

      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
    });
  });
  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
});

function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
  // This event will not be triggered when `setOpion`, otherwise dead lock may
  // triggered when do `setOption` in event listener, which we do not find
  // satisfactory way to solve yet. Some considered resolutions:
  // (a) Diff with prevoius selected data ant only trigger event when changed.
  // But store previous data and diff precisely (i.e., not only by dataIndex, but
  // also detect value changes in selected data) might bring complexity or fragility.
  // (b) Use spectial param like `silent` to suppress event triggering.
  // But such kind of volatile param may be weird in `setOption`.
  if (!payload) {
    return;
  }

  var zr = api.getZr();

  if (zr[DISPATCH_FLAG]) {
    return;
  }

  if (!zr[DISPATCH_METHOD]) {
    zr[DISPATCH_METHOD] = doDispatch;
  }

  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
  fn(api, brushSelected);
}

function doDispatch(api, brushSelected) {
  if (!api.isDisposed()) {
    var zr = api.getZr();
    zr[DISPATCH_FLAG] = true;
    api.dispatchAction({
      type: 'brushSelect',
      batch: brushSelected
    });
    zr[DISPATCH_FLAG] = false;
  }
}

function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
    var area = rangeInfoList[i];

    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
      return true;
    }
  }
}

function getSelectorsByBrushType(seriesModel) {
  var brushSelector = seriesModel.brushSelector;

  if (zrUtil.isString(brushSelector)) {
    var sels = [];
    zrUtil.each(selector, function (selectorsByElementType, brushType) {
      sels[brushType] = function (dataIndex, data, selectors, area) {
        var itemLayout = data.getItemLayout(dataIndex);
        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
      };
    });
    return sels;
  } else if (zrUtil.isFunction(brushSelector)) {
    var bSelector = {};
    zrUtil.each(selector, function (sel, brushType) {
      bSelector[brushType] = brushSelector;
    });
    return bSelector;
  }

  return brushSelector;
}

function brushModelNotControll(brushModel, seriesIndex) {
  var seriesIndices = brushModel.option.seriesIndex;
  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}

function bindSelector(area) {
  var selectors = area.selectors = {};
  zrUtil.each(selector[area.brushType], function (selFn, elType) {
    // Do not use function binding or curry for performance.
    selectors[elType] = function (itemLayout) {
      return selFn(itemLayout, selectors, area);
    };
  });
  return area;
}

var boundingRectBuilders = {
  lineX: zrUtil.noop,
  lineY: zrUtil.noop,
  rect: function (area) {
    return getBoundingRectFromMinMax(area.range);
  },
  polygon: function (area) {
    var minMax;
    var range = area.range;

    for (var i = 0, len = range.length; i < len; i++) {
      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
      var rg = range[i];
      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
    }

    return minMax && getBoundingRectFromMinMax(minMax);
  }
};

function getBoundingRectFromMinMax(minMax) {
  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1564);

__webpack_require__(1565);

__webpack_require__(1498);

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var formatUtil = __webpack_require__(21);

var numberUtil = __webpack_require__(8);

var MONTH_TEXT = {
  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var WEEK_TEXT = {
  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  CN: ['日', '一', '二', '三', '四', '五', '六']
};

var _default = echarts.extendComponentView({
  type: 'calendar',

  /**
   * top/left line points
   *  @private
   */
  _tlpoints: null,

  /**
   * bottom/right line points
   *  @private
   */
  _blpoints: null,

  /**
   * first day of month
   *  @private
   */
  _firstDayOfMonth: null,

  /**
   * first day point of month
   *  @private
   */
  _firstDayPoints: null,
  render: function (calendarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();
    var coordSys = calendarModel.coordinateSystem; // range info

    var rangeData = coordSys.getRangeInfo();
    var orient = coordSys.getOrient();

    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function


    this._renderLines(calendarModel, rangeData, orient, group);

    this._renderYearText(calendarModel, rangeData, orient, group);

    this._renderMonthText(calendarModel, orient, group);

    this._renderWeekText(calendarModel, rangeData, orient, group);
  },
  // render day rect
  _renderDayRect: function (calendarModel, rangeData, group) {
    var coordSys = calendarModel.coordinateSystem;
    var itemRectStyleModel = calendarModel.getModel('itemStyle.normal').getItemStyle();
    var sw = coordSys.getCellWidth();
    var sh = coordSys.getCellHeight();

    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
      var point = coordSys.dataToRect([i], false).tl; // every rect

      var rect = new graphic.Rect({
        shape: {
          x: point[0],
          y: point[1],
          width: sw,
          height: sh
        },
        cursor: 'default',
        style: itemRectStyleModel
      });
      group.add(rect);
    }
  },
  // render separate line
  _renderLines: function (calendarModel, rangeData, orient, group) {
    var self = this;
    var coordSys = calendarModel.coordinateSystem;
    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
    var show = calendarModel.get('splitLine.show');
    var lineWidth = lineStyleModel.lineWidth;
    this._tlpoints = [];
    this._blpoints = [];
    this._firstDayOfMonth = [];
    this._firstDayPoints = [];
    var firstDay = rangeData.start;

    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
      addPoints(firstDay.formatedDate);

      if (i === 0) {
        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
      }

      var date = firstDay.date;
      date.setMonth(date.getMonth() + 1);
      firstDay = coordSys.getDateInfo(date);
    }

    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);

    function addPoints(date) {
      self._firstDayOfMonth.push(coordSys.getDateInfo(date));

      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);

      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);

      self._tlpoints.push(points[0]);

      self._blpoints.push(points[points.length - 1]);

      show && self._drawSplitline(points, lineStyleModel, group);
    } // render top/left line


    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line

    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
  },
  // get points at both ends
  _getEdgesPoints: function (points, lineWidth, orient) {
    var rs = [points[0].slice(), points[points.length - 1].slice()];
    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth

    rs[0][idx] = rs[0][idx] - lineWidth / 2;
    rs[1][idx] = rs[1][idx] + lineWidth / 2;
    return rs;
  },
  // render split line
  _drawSplitline: function (points, lineStyleModel, group) {
    var poyline = new graphic.Polyline({
      z2: 20,
      shape: {
        points: points
      },
      style: lineStyleModel
    });
    group.add(poyline);
  },
  // render month line of one week points
  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
    var coordSys = calendarModel.coordinateSystem;
    date = coordSys.getDateInfo(date);
    var points = [];

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(date.time, i);
      var point = coordSys.dataToRect([tmpD.time], false);
      points[2 * tmpD.day] = point.tl;
      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
    }

    return points;
  },
  _formatterLabel: function (formatter, params) {
    if (typeof formatter === 'string' && formatter) {
      return formatUtil.formatTplSimple(formatter, params);
    }

    if (typeof formatter === 'function') {
      return formatter(params);
    }

    return params.nameMap;
  },
  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
    point = point.slice();
    var aligns = ['center', 'bottom'];

    if (position === 'bottom') {
      point[1] += margin;
      aligns = ['center', 'top'];
    } else if (position === 'left') {
      point[0] -= margin;
    } else if (position === 'right') {
      point[0] += margin;
      aligns = ['center', 'top'];
    } else {
      // top
      point[1] -= margin;
    }

    var rotate = 0;

    if (position === 'left' || position === 'right') {
      rotate = Math.PI / 2;
    }

    return {
      rotation: rotate,
      position: point,
      style: {
        textAlign: aligns[0],
        textVerticalAlign: aligns[1]
      }
    };
  },
  // render year
  _renderYearText: function (calendarModel, rangeData, orient, group) {
    var yearLabel = calendarModel.getModel('yearLabel');

    if (!yearLabel.get('show')) {
      return;
    }

    var margin = yearLabel.get('margin');
    var pos = yearLabel.get('position');

    if (!pos) {
      pos = orient !== 'horizontal' ? 'top' : 'left';
    }

    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
    var xc = (points[0][0] + points[1][0]) / 2;
    var yc = (points[0][1] + points[1][1]) / 2;
    var idx = orient === 'horizontal' ? 0 : 1;
    var posPoints = {
      top: [xc, points[idx][1]],
      bottom: [xc, points[1 - idx][1]],
      left: [points[1 - idx][0], yc],
      right: [points[idx][0], yc]
    };
    var name = rangeData.start.y;

    if (+rangeData.end.y > +rangeData.start.y) {
      name = name + '-' + rangeData.end.y;
    }

    var formatter = yearLabel.get('formatter');
    var params = {
      start: rangeData.start.y,
      end: rangeData.end.y,
      nameMap: name
    };

    var content = this._formatterLabel(formatter, params);

    var yearText = new graphic.Text({
      z2: 30
    });
    graphic.setTextStyle(yearText.style, yearLabel, {
      text: content
    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
    group.add(yearText);
  },
  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
    var align = 'left';
    var vAlign = 'top';
    var x = point[0];
    var y = point[1];

    if (orient === 'horizontal') {
      y = y + margin;

      if (isCenter) {
        align = 'center';
      }

      if (position === 'start') {
        vAlign = 'bottom';
      }
    } else {
      x = x + margin;

      if (isCenter) {
        vAlign = 'middle';
      }

      if (position === 'start') {
        align = 'right';
      }
    }

    return {
      x: x,
      y: y,
      textAlign: align,
      textVerticalAlign: vAlign
    };
  },
  // render month and year text
  _renderMonthText: function (calendarModel, orient, group) {
    var monthLabel = calendarModel.getModel('monthLabel');

    if (!monthLabel.get('show')) {
      return;
    }

    var nameMap = monthLabel.get('nameMap');
    var margin = monthLabel.get('margin');
    var pos = monthLabel.get('position');
    var align = monthLabel.get('align');
    var termPoints = [this._tlpoints, this._blpoints];

    if (zrUtil.isString(nameMap)) {
      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
    }

    var idx = pos === 'start' ? 0 : 1;
    var axis = orient === 'horizontal' ? 0 : 1;
    margin = pos === 'start' ? -margin : margin;
    var isCenter = align === 'center';

    for (var i = 0; i < termPoints[idx].length - 1; i++) {
      var tmp = termPoints[idx][i].slice();
      var firstDay = this._firstDayOfMonth[i];

      if (isCenter) {
        var firstDayPoints = this._firstDayPoints[i];
        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
      }

      var formatter = monthLabel.get('formatter');
      var name = nameMap[+firstDay.m - 1];
      var params = {
        yyyy: firstDay.y,
        yy: (firstDay.y + '').slice(2),
        MM: firstDay.m,
        M: +firstDay.m,
        nameMap: name
      };

      var content = this._formatterLabel(formatter, params);

      var monthText = new graphic.Text({
        z2: 30
      });
      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
        text: content
      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
      group.add(monthText);
    }
  },
  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
    var align = 'center';
    var vAlign = 'middle';
    var x = point[0];
    var y = point[1];
    var isStart = position === 'start';

    if (orient === 'horizontal') {
      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
      align = isStart ? 'right' : 'left';
    } else {
      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
      vAlign = isStart ? 'bottom' : 'top';
    }

    return {
      x: x,
      y: y,
      textAlign: align,
      textVerticalAlign: vAlign
    };
  },
  // render weeks
  _renderWeekText: function (calendarModel, rangeData, orient, group) {
    var dayLabel = calendarModel.getModel('dayLabel');

    if (!dayLabel.get('show')) {
      return;
    }

    var coordSys = calendarModel.coordinateSystem;
    var pos = dayLabel.get('position');
    var nameMap = dayLabel.get('nameMap');
    var margin = dayLabel.get('margin');
    var firstDayOfWeek = coordSys.getFirstDayOfWeek();

    if (zrUtil.isString(nameMap)) {
      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
    }

    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);

    if (pos === 'start') {
      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
      margin = -margin;
    }

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(start, i);
      var point = coordSys.dataToRect([tmpD.time], false).center;
      var day = i;
      day = Math.abs((i + firstDayOfWeek) % 7);
      var weekText = new graphic.Text({
        z2: 30
      });
      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
        text: nameMap[day]
      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
      group.add(weekText);
    }
  }
});

module.exports = _default;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(461);

__webpack_require__(142);

__webpack_require__(143);

__webpack_require__(1505);

__webpack_require__(1506);

__webpack_require__(1501);

__webpack_require__(1502);

__webpack_require__(459);

__webpack_require__(458);

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var numberUtil = __webpack_require__(8);

var helper = __webpack_require__(274);

var each = zrUtil.each;
var asc = numberUtil.asc;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 *
 * @class
 */

var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
  /**
   * @private
   * @type {string}
   */
  this._dimName = dimName;
  /**
   * @private
   */

  this._axisIndex = axisIndex;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._valueWindow;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._percentWindow;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._dataExtent;
  /**
   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
   * @private
   * @type {Object}
   */

  this._minMaxSpan;
  /**
   * @readOnly
   * @type {module: echarts/model/Global}
   */

  this.ecModel = ecModel;
  /**
   * @private
   * @type {module: echarts/component/dataZoom/DataZoomModel}
   */

  this._dataZoomModel = dataZoomModel;
};

AxisProxy.prototype = {
  constructor: AxisProxy,

  /**
   * Whether the axisProxy is hosted by dataZoomModel.
   *
   * @public
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   * @return {boolean}
   */
  hostedBy: function (dataZoomModel) {
    return this._dataZoomModel === dataZoomModel;
  },

  /**
   * @return {Array.<number>} Value can only be NaN or finite value.
   */
  getDataValueWindow: function () {
    return this._valueWindow.slice();
  },

  /**
   * @return {Array.<number>}
   */
  getDataPercentWindow: function () {
    return this._percentWindow.slice();
  },

  /**
   * @public
   * @param {number} axisIndex
   * @return {Array} seriesModels
   */
  getTargetSeriesModels: function () {
    var seriesModels = [];
    var ecModel = this.ecModel;
    ecModel.eachSeries(function (seriesModel) {
      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
        var dimName = this._dimName;
        var axisModel = ecModel.queryComponents({
          mainType: dimName + 'Axis',
          index: seriesModel.get(dimName + 'AxisIndex'),
          id: seriesModel.get(dimName + 'AxisId')
        })[0];

        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
          seriesModels.push(seriesModel);
        }
      }
    }, this);
    return seriesModels;
  },
  getAxisModel: function () {
    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
  },
  getOtherAxisModel: function () {
    var axisDim = this._dimName;
    var ecModel = this.ecModel;
    var axisModel = this.getAxisModel();
    var isCartesian = axisDim === 'x' || axisDim === 'y';
    var otherAxisDim;
    var coordSysIndexName;

    if (isCartesian) {
      coordSysIndexName = 'gridIndex';
      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
    } else {
      coordSysIndexName = 'polarIndex';
      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
    }

    var foundOtherAxisModel;
    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
        foundOtherAxisModel = otherAxisModel;
      }
    });
    return foundOtherAxisModel;
  },
  getMinMaxSpan: function () {
    return zrUtil.clone(this._minMaxSpan);
  },

  /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   *
   * @param {Object} opt
   * @param {number} [opt.start]
   * @param {number} [opt.end]
   * @param {number} [opt.startValue]
   * @param {number} [opt.endValue]
   */
  calculateDataWindow: function (opt) {
    var dataExtent = this._dataExtent;
    var axisModel = this.getAxisModel();
    var scale = axisModel.axis.scale;

    var rangePropMode = this._dataZoomModel.getRangePropMode();

    var percentExtent = [0, 100];
    var percentWindow = [opt.start, opt.end];
    var valueWindow = [];
    each(['startValue', 'endValue'], function (prop) {
      valueWindow.push(opt[prop] != null ? scale.parse(opt[prop]) : null);
    }); // Normalize bound.

    each([0, 1], function (idx) {
      var boundValue = valueWindow[idx];
      var boundPercent = percentWindow[idx]; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
      // on `valueProp` ('startValue', 'endValue'). The former one is suitable
      // for cases that a dataZoom component controls multiple axes with different
      // unit or extent, and the latter one is suitable for accurate zoom by pixel
      // (e.g., in dataZoomSelect). `valueProp` can be calculated from `percentProp`,
      // but it is awkward that `percentProp` can not be obtained from `valueProp`
      // accurately (because all of values that are overflow the `dataExtent` will
      // be calculated to percent '100%'). So we have to use
      // `dataZoom.getRangePropMode()` to mark which prop is used.
      // `rangePropMode` is updated only when setOption or dispatchAction, otherwise
      // it remains its original value.

      if (rangePropMode[idx] === 'percent') {
        if (boundPercent == null) {
          boundPercent = percentExtent[idx];
        } // Use scale.parse to math round for category or time axis.


        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent, true));
      } else {
        // Calculating `percent` from `value` may be not accurate, because
        // This calculation can not be inversed, because all of values that
        // are overflow the `dataExtent` will be calculated to percent '100%'
        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent, true);
      } // valueWindow[idx] = round(boundValue);
      // percentWindow[idx] = round(boundPercent);


      valueWindow[idx] = boundValue;
      percentWindow[idx] = boundPercent;
    });
    return {
      valueWindow: asc(valueWindow),
      percentWindow: asc(percentWindow)
    };
  },

  /**
   * Notice: reset should not be called before series.restoreData() called,
   * so it is recommanded to be called in "process stage" but not "model init
   * stage".
   *
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  reset: function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    } // Culculate data window and data extent, and record them.


    this._dataExtent = calculateDataExtent(this, this._dimName, this.getTargetSeriesModels());
    var dataWindow = this.calculateDataWindow(dataZoomModel.option);
    this._valueWindow = dataWindow.valueWindow;
    this._percentWindow = dataWindow.percentWindow;
    setMinMaxSpan(this); // Update axis setting then.

    setAxisModel(this);
  },

  /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  restore: function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    this._valueWindow = this._percentWindow = null;
    setAxisModel(this, true);
  },

  /**
   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
   */
  filterData: function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var axisDim = this._dimName;
    var seriesModels = this.getTargetSeriesModels();
    var filterMode = dataZoomModel.get('filterMode');
    var valueWindow = this._valueWindow;

    if (filterMode === 'none') {
      return;
    } // FIXME
    // Toolbox may has dataZoom injected. And if there are stacked bar chart
    // with NaN data, NaN will be filtered and stack will be wrong.
    // So we need to force the mode to be set empty.
    // In fect, it is not a big deal that do not support filterMode-'filter'
    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
    // selection" some day, which might need "adapt to data extent on the
    // otherAxis", which is disabled by filterMode-'empty'.


    var otherAxisModel = this.getOtherAxisModel();

    if (dataZoomModel.get('$fromToolbox') && otherAxisModel && otherAxisModel.get('type') === 'category') {
      filterMode = 'empty';
    } // Process series data


    each(seriesModels, function (seriesModel) {
      var seriesData = seriesModel.getData();
      var dataDims = seriesModel.coordDimToDataDim(axisDim);

      if (filterMode === 'weakFilter') {
        seriesData && seriesData.filterSelf(function (dataIndex) {
          var leftOut;
          var rightOut;
          var hasValue;

          for (var i = 0; i < dataDims.length; i++) {
            var value = seriesData.get(dataDims[i], dataIndex);
            var thisHasValue = !isNaN(value);
            var thisLeftOut = value < valueWindow[0];
            var thisRightOut = value > valueWindow[1];

            if (thisHasValue && !thisLeftOut && !thisRightOut) {
              return true;
            }

            thisHasValue && (hasValue = true);
            thisLeftOut && (leftOut = true);
            thisRightOut && (rightOut = true);
          } // If both left out and right out, do not filter.


          return hasValue && leftOut && rightOut;
        });
      } else {
        seriesData && each(dataDims, function (dim) {
          if (filterMode === 'empty') {
            seriesModel.setData(seriesData.map(dim, function (value) {
              return !isInWindow(value) ? NaN : value;
            }));
          } else {
            seriesData.filterSelf(dim, isInWindow);
          }
        });
      }
    });

    function isInWindow(value) {
      return value >= valueWindow[0] && value <= valueWindow[1];
    }
  }
};

function calculateDataExtent(axisProxy, axisDim, seriesModels) {
  var dataExtent = [Infinity, -Infinity];
  each(seriesModels, function (seriesModel) {
    var seriesData = seriesModel.getData();

    if (seriesData) {
      each(seriesModel.coordDimToDataDim(axisDim), function (dim) {
        var seriesExtent = seriesData.getDataExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
      });
    }
  });

  if (dataExtent[1] < dataExtent[0]) {
    dataExtent = [NaN, NaN];
  } // It is important to get "consistent" extent when more then one axes is
  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
  // when zooming. But it is difficult to know what is "consistent", considering
  // axes have different type or even different meanings (For example, two
  // time axes are used to compare data of the same date in different years).
  // So basically dataZoom just obtains extent by series.data (in category axis
  // extent can be obtained from axis.data).
  // Nevertheless, user can set min/max/scale on axes to make extent of axes
  // consistent.


  fixExtentByAxis(axisProxy, dataExtent);
  return dataExtent;
}

function fixExtentByAxis(axisProxy, dataExtent) {
  var axisModel = axisProxy.getAxisModel();
  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
  // by axis.data by default.

  var isCategoryAxis = axisModel.get('type') === 'category';
  var axisDataLen = isCategoryAxis && (axisModel.get('data') || []).length;

  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
    dataExtent[0] = min;
  } else if (isCategoryAxis) {
    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
  }

  var max = axisModel.getMax(true);

  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
    dataExtent[1] = max;
  } else if (isCategoryAxis) {
    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
  }

  if (!axisModel.get('scale', true)) {
    dataExtent[0] > 0 && (dataExtent[0] = 0);
    dataExtent[1] < 0 && (dataExtent[1] = 0);
  } // For value axis, if min/max/scale are not set, we just use the extent obtained
  // by series data, which may be a little different from the extent calculated by
  // `axisHelper.getScaleExtent`. But the different just affects the experience a
  // little when zooming. So it will not be fixed until some users require it strongly.


  return dataExtent;
}

function setAxisModel(axisProxy, isRestore) {
  var axisModel = axisProxy.getAxisModel();
  var percentWindow = axisProxy._percentWindow;
  var valueWindow = axisProxy._valueWindow;

  if (!percentWindow) {
    return;
  } // [0, 500]: arbitrary value, guess axis extent.


  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
  precision = Math.min(precision, 20); // isRestore or isFull

  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
}

function setMinMaxSpan(axisProxy) {
  var minMaxSpan = axisProxy._minMaxSpan = {};
  var dataZoomModel = axisProxy._dataZoomModel;
  each(['min', 'max'], function (minMax) {
    minMaxSpan[minMax + 'Span'] = dataZoomModel.get(minMax + 'Span'); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan

    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');

    if (valueSpan != null) {
      minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
      valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan);

      if (valueSpan != null) {
        var dataExtent = axisProxy._dataExtent;
        minMaxSpan[minMax + 'Span'] = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
      }
    }
  });
}

var _default = AxisProxy;
module.exports = _default;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var DataZoomModel = __webpack_require__(142);

var _default = DataZoomModel.extend({
  type: 'dataZoom.inside',

  /**
   * @protected
   */
  defaultOption: {
    disabled: false,
    // Whether disable this inside zoom.
    zoomLock: false,
    // Whether disable zoom but only pan.
    zoomOnMouseWheel: true,
    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
    moveOnMouseMove: true,
    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
    preventDefaultMouseMove: true
  }
});

module.exports = _default;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var DataZoomView = __webpack_require__(143);

var sliderMove = __webpack_require__(145);

var roams = __webpack_require__(1507);

var bind = zrUtil.bind;
var InsideZoomView = DataZoomView.extend({
  type: 'dataZoom.inside',

  /**
   * @override
   */
  init: function (ecModel, api) {
    /**
     * 'throttle' is used in this.dispatchAction, so we save range
     * to avoid missing some 'pan' info.
     * @private
     * @type {Array.<number>}
     */
    this._range;
  },

  /**
   * @override
   */
  render: function (dataZoomModel, ecModel, api, payload) {
    InsideZoomView.superApply(this, 'render', arguments); // Notice: origin this._range should be maintained, and should not be re-fetched
    // from dataZoomModel when payload.type is 'dataZoom', otherwise 'pan' or 'zoom'
    // info will be missed because of 'throttle' of this.dispatchAction.

    if (roams.shouldRecordRange(payload, dataZoomModel.id)) {
      this._range = dataZoomModel.getPercentRange();
    } // Reset controllers.


    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
        return roams.generateCoordId(coordInfo.model);
      });
      zrUtil.each(coordInfoList, function (coordInfo) {
        var coordModel = coordInfo.model;
        var dataZoomOption = dataZoomModel.option;
        roams.register(api, {
          coordId: roams.generateCoordId(coordModel),
          allCoordIds: allCoordIds,
          containsPoint: function (e, x, y) {
            return coordModel.coordinateSystem.containPoint([x, y]);
          },
          dataZoomId: dataZoomModel.id,
          throttleRate: dataZoomModel.get('throttle', true),
          panGetRange: bind(this._onPan, this, coordInfo, coordSysName),
          zoomGetRange: bind(this._onZoom, this, coordInfo, coordSysName),
          zoomLock: dataZoomOption.zoomLock,
          disabled: dataZoomOption.disabled,
          roamControllerOpt: {
            zoomOnMouseWheel: dataZoomOption.zoomOnMouseWheel,
            moveOnMouseMove: dataZoomOption.moveOnMouseMove,
            preventDefaultMouseMove: dataZoomOption.preventDefaultMouseMove
          }
        });
      }, this);
    }, this);
  },

  /**
   * @override
   */
  dispose: function () {
    roams.unregister(this.api, this.dataZoomModel.id);
    InsideZoomView.superApply(this, 'dispose', arguments);
    this._range = null;
  },

  /**
   * @private
   */
  _onPan: function (coordInfo, coordSysName, controller, dx, dy, oldX, oldY, newX, newY) {
    var range = this._range.slice(); // Calculate transform by the first axis.


    var axisModel = coordInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var directionInfo = getDirectionInfo[coordSysName]([oldX, oldY], [newX, newY], axisModel, controller, coordInfo);
    var percentDelta = directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    sliderMove(percentDelta, range, [0, 100], 'all');
    return this._range = range;
  },

  /**
   * @private
   */
  _onZoom: function (coordInfo, coordSysName, controller, scale, mouseX, mouseY) {
    var range = this._range.slice(); // Calculate transform by the first axis.


    var axisModel = coordInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var directionInfo = getDirectionInfo[coordSysName](null, [mouseX, mouseY], axisModel, controller, coordInfo);
    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
    scale = Math.max(1 / scale, 0);
    range[0] = (range[0] - percentPoint) * scale + percentPoint;
    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.

    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
    return this._range = range;
  }
});
var getDirectionInfo = {
  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var rect = coordInfo.model.coordinateSystem.getRect();
    oldPoint = oldPoint || [0, 0];

    if (axis.dim === 'x') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // axis.dim === 'y'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var polar = coordInfo.model.coordinateSystem;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var angleExtent = polar.getAngleAxis().getExtent();
    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
    newPoint = polar.pointToCoord(newPoint);

    if (axisModel.mainType === 'radiusAxis') {
      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);

      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
      ret.pixelStart = radiusExtent[0];
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'angleAxis'
      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);

      ret.pixelLength = angleExtent[1] - angleExtent[0];
      ret.pixelStart = angleExtent[0];
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
    var axis = axisModel.axis;
    var rect = coordInfo.model.coordinateSystem.getRect();
    var ret = {};
    oldPoint = oldPoint || [0, 0];

    if (axis.orient === 'horizontal') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'vertical'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  }
};
var _default = InsideZoomView;
module.exports = _default;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var DataZoomModel = __webpack_require__(142);

var _default = DataZoomModel.extend({
  type: 'dataZoom.select'
});

module.exports = _default;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var DataZoomView = __webpack_require__(143);

var _default = DataZoomView.extend({
  type: 'dataZoom.select'
});

module.exports = _default;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

var DataZoomModel = __webpack_require__(142);

var SliderZoomModel = DataZoomModel.extend({
  type: 'dataZoom.slider',
  layoutMode: 'box',

  /**
   * @protected
   */
  defaultOption: {
    show: true,
    // ph => placeholder. Using placehoder here because
    // deault value can only be drived in view stage.
    right: 'ph',
    // Default align to grid rect.
    top: 'ph',
    // Default align to grid rect.
    width: 'ph',
    // Default align to grid rect.
    height: 'ph',
    // Default align to grid rect.
    left: null,
    // Default align to grid rect.
    bottom: null,
    // Default align to grid rect.
    backgroundColor: 'rgba(47,69,84,0)',
    // Background of slider zoom component.
    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
    // highest priority, remain for compatibility of
    // previous version, but not recommended any more.
    dataBackground: {
      lineStyle: {
        color: '#2f4554',
        width: 0.5,
        opacity: 0.3
      },
      areaStyle: {
        color: 'rgba(47,69,84,0.3)',
        opacity: 0.3
      }
    },
    borderColor: '#ddd',
    // border color of the box. For compatibility,
    // if dataBackgroundColor is set, borderColor
    // is ignored.
    fillerColor: 'rgba(167,183,204,0.4)',
    // Color of selected area.
    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
    // Percent of the slider height
    handleSize: '100%',
    handleStyle: {
      color: '#a7b7cc'
    },
    labelPrecision: null,
    labelFormatter: null,
    showDetail: true,
    showDataShadow: 'auto',
    // Default auto decision.
    realtime: true,
    zoomLock: false,
    // Whether disable zoom.
    textStyle: {
      color: '#333'
    }
  }
});
var _default = SliderZoomModel;
module.exports = _default;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var eventTool = __webpack_require__(77);

var graphic = __webpack_require__(5);

var throttle = __webpack_require__(104);

var DataZoomView = __webpack_require__(143);

var numberUtil = __webpack_require__(8);

var layout = __webpack_require__(17);

var sliderMove = __webpack_require__(145);

var Rect = graphic.Rect;
var linearMap = numberUtil.linearMap;
var asc = numberUtil.asc;
var bind = zrUtil.bind;
var each = zrUtil.each; // Constants

var DEFAULT_LOCATION_EDGE_GAP = 7;
var DEFAULT_FRAME_BORDER_WIDTH = 1;
var DEFAULT_FILLER_SIZE = 30;
var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';
var LABEL_GAP = 5;
var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
var SliderZoomView = DataZoomView.extend({
  type: 'dataZoom.slider',
  init: function (ecModel, api) {
    /**
     * @private
     * @type {Object}
     */
    this._displayables = {};
    /**
     * @private
     * @type {string}
     */

    this._orient;
    /**
     * [0, 100]
     * @private
     */

    this._range;
    /**
     * [coord of the first handle, coord of the second handle]
     * @private
     */

    this._handleEnds;
    /**
     * [length, thick]
     * @private
     * @type {Array.<number>}
     */

    this._size;
    /**
     * @private
     * @type {number}
     */

    this._handleWidth;
    /**
     * @private
     * @type {number}
     */

    this._handleHeight;
    /**
     * @private
     */

    this._location;
    /**
     * @private
     */

    this._dragging;
    /**
     * @private
     */

    this._dataShadowInfo;
    this.api = api;
  },

  /**
   * @override
   */
  render: function (dataZoomModel, ecModel, api, payload) {
    SliderZoomView.superApply(this, 'render', arguments);
    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
    this._orient = dataZoomModel.get('orient');

    if (this.dataZoomModel.get('show') === false) {
      this.group.removeAll();
      return;
    } // Notice: this._resetInterval() should not be executed when payload.type
    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,


    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
      this._buildView();
    }

    this._updateView();
  },

  /**
   * @override
   */
  remove: function () {
    SliderZoomView.superApply(this, 'remove', arguments);
    throttle.clear(this, '_dispatchZoomAction');
  },

  /**
   * @override
   */
  dispose: function () {
    SliderZoomView.superApply(this, 'dispose', arguments);
    throttle.clear(this, '_dispatchZoomAction');
  },
  _buildView: function () {
    var thisGroup = this.group;
    thisGroup.removeAll();

    this._resetLocation();

    this._resetInterval();

    var barGroup = this._displayables.barGroup = new graphic.Group();

    this._renderBackground();

    this._renderHandle();

    this._renderDataShadow();

    thisGroup.add(barGroup);

    this._positionGroup();
  },

  /**
   * @private
   */
  _resetLocation: function () {
    var dataZoomModel = this.dataZoomModel;
    var api = this.api; // If some of x/y/width/height are not specified,
    // auto-adapt according to target grid.

    var coordRect = this._findCoordRect();

    var ecSize = {
      width: api.getWidth(),
      height: api.getHeight()
    }; // Default align by coordinate system rect.

    var positionInfo = this._orient === HORIZONTAL ? {
      // Why using 'right', because right should be used in vertical,
      // and it is better to be consistent for dealing with position param merge.
      right: ecSize.width - coordRect.x - coordRect.width,
      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
      width: coordRect.width,
      height: DEFAULT_FILLER_SIZE
    } : {
      // vertical
      right: DEFAULT_LOCATION_EDGE_GAP,
      top: coordRect.y,
      width: DEFAULT_FILLER_SIZE,
      height: coordRect.height
    }; // Do not write back to option and replace value 'ph', because
    // the 'ph' value should be recalculated when resize.

    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.

    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
      if (layoutParams[name] === 'ph') {
        layoutParams[name] = positionInfo[name];
      }
    });
    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
    this._location = {
      x: layoutRect.x,
      y: layoutRect.y
    };
    this._size = [layoutRect.width, layoutRect.height];
    this._orient === VERTICAL && this._size.reverse();
  },

  /**
   * @private
   */
  _positionGroup: function () {
    var thisGroup = this.group;
    var location = this._location;
    var orient = this._orient; // Just use the first axis to determine mapping.

    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
    var inverse = targetAxisModel && targetAxisModel.get('inverse');
    var barGroup = this._displayables.barGroup;
    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.

    barGroup.attr(orient === HORIZONTAL && !inverse ? {
      scale: otherAxisInverse ? [1, 1] : [1, -1]
    } : orient === HORIZONTAL && inverse ? {
      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
    } : orient === VERTICAL && !inverse ? {
      scale: otherAxisInverse ? [1, -1] : [1, 1],
      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.

    } : {
      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
      rotation: Math.PI / 2
    }); // Position barGroup

    var rect = thisGroup.getBoundingRect([barGroup]);
    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
  },

  /**
   * @private
   */
  _getViewExtent: function () {
    return [0, this._size[0]];
  },
  _renderBackground: function () {
    var dataZoomModel = this.dataZoomModel;
    var size = this._size;
    var barGroup = this._displayables.barGroup;
    barGroup.add(new Rect({
      silent: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: dataZoomModel.get('backgroundColor')
      },
      z2: -40
    })); // Click panel, over shadow, below handles.

    barGroup.add(new Rect({
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: 'transparent'
      },
      z2: 0,
      onclick: zrUtil.bind(this._onClickPanelClick, this)
    }));
  },
  _renderDataShadow: function () {
    var info = this._dataShadowInfo = this._prepareDataShadowInfo();

    if (!info) {
      return;
    }

    var size = this._size;
    var seriesModel = info.series;
    var data = seriesModel.getRawData();
    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
    : info.otherDim;

    if (otherDim == null) {
      return;
    }

    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.

    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
    var otherShadowExtent = [0, size[1]];
    var thisShadowExtent = [0, size[0]];
    var areaPoints = [[size[0], 0], [0, 0]];
    var linePoints = [];
    var step = thisShadowExtent[1] / (data.count() - 1);
    var thisCoord = 0; // Optimize for large data shadow

    var stride = Math.round(data.count() / size[0]);
    var lastIsEmpty;
    data.each([otherDim], function (value, index) {
      if (stride > 0 && index % stride) {
        thisCoord += step;
        return;
      } // FIXME
      // Should consider axis.min/axis.max when drawing dataShadow.
      // FIXME
      // 应该使用统一的空判断？还是在list里进行空判断？


      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.

      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.

      if (isEmpty && !lastIsEmpty && index) {
        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
      } else if (!isEmpty && lastIsEmpty) {
        areaPoints.push([thisCoord, 0]);
        linePoints.push([thisCoord, 0]);
      }

      areaPoints.push([thisCoord, otherCoord]);
      linePoints.push([thisCoord, otherCoord]);
      thisCoord += step;
      lastIsEmpty = isEmpty;
    });
    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');

    this._displayables.barGroup.add(new graphic.Polygon({
      shape: {
        points: areaPoints
      },
      style: zrUtil.defaults({
        fill: dataZoomModel.get('dataBackgroundColor')
      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
      silent: true,
      z2: -20
    }));

    this._displayables.barGroup.add(new graphic.Polyline({
      shape: {
        points: linePoints
      },
      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
      silent: true,
      z2: -19
    }));
  },
  _prepareDataShadowInfo: function () {
    var dataZoomModel = this.dataZoomModel;
    var showDataShadow = dataZoomModel.get('showDataShadow');

    if (showDataShadow === false) {
      return;
    } // Find a representative series.


    var result;
    var ecModel = this.ecModel;
    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
      zrUtil.each(seriesModels, function (seriesModel) {
        if (result) {
          return;
        }

        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
          return;
        }

        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
        var otherDim = getOtherDim(dimNames.name);
        var otherAxisInverse;
        var coordSys = seriesModel.coordinateSystem;

        if (otherDim != null && coordSys.getOtherAxis) {
          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
        }

        result = {
          thisAxis: thisAxis,
          series: seriesModel,
          thisDim: dimNames.name,
          otherDim: otherDim,
          otherAxisInverse: otherAxisInverse
        };
      }, this);
    }, this);
    return result;
  },
  _renderHandle: function () {
    var displaybles = this._displayables;
    var handles = displaybles.handles = [];
    var handleLabels = displaybles.handleLabels = [];
    var barGroup = this._displayables.barGroup;
    var size = this._size;
    var dataZoomModel = this.dataZoomModel;
    barGroup.add(displaybles.filler = new Rect({
      draggable: true,
      cursor: getCursor(this._orient),
      drift: bind(this._onDragMove, this, 'all'),
      onmousemove: function (e) {
        // Fot mobile devicem, prevent screen slider on the button.
        eventTool.stop(e.event);
      },
      ondragstart: bind(this._showDataInfo, this, true),
      ondragend: bind(this._onDragEnd, this),
      onmouseover: bind(this._showDataInfo, this, true),
      onmouseout: bind(this._showDataInfo, this, false),
      style: {
        fill: dataZoomModel.get('fillerColor'),
        textPosition: 'inside'
      }
    })); // Frame border.

    barGroup.add(new Rect(graphic.subPixelOptimizeRect({
      silent: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
        fill: 'rgba(0,0,0,0)'
      }
    })));
    each([0, 1], function (handleIndex) {
      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
        cursor: getCursor(this._orient),
        draggable: true,
        drift: bind(this._onDragMove, this, handleIndex),
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          eventTool.stop(e.event);
        },
        ondragend: bind(this._onDragEnd, this),
        onmouseover: bind(this._showDataInfo, this, true),
        onmouseout: bind(this._showDataInfo, this, false)
      }, {
        x: -1,
        y: 0,
        width: 2,
        height: 2
      });
      var bRect = path.getBoundingRect();
      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version

      if (handleColor != null) {
        path.style.fill = handleColor;
      }

      barGroup.add(handles[handleIndex] = path);
      var textStyleModel = dataZoomModel.textStyleModel;
      this.group.add(handleLabels[handleIndex] = new graphic.Text({
        silent: true,
        invisible: true,
        style: {
          x: 0,
          y: 0,
          text: '',
          textVerticalAlign: 'middle',
          textAlign: 'center',
          textFill: textStyleModel.getTextColor(),
          textFont: textStyleModel.getFont()
        },
        z2: 10
      }));
    }, this);
  },

  /**
   * @private
   */
  _resetInterval: function () {
    var range = this._range = this.dataZoomModel.getPercentRange();

    var viewExtent = this._getViewExtent();

    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
  },

  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} delta
   */
  _updateInterval: function (handleIndex, delta) {
    var dataZoomModel = this.dataZoomModel;
    var handleEnds = this._handleEnds;

    var viewExtend = this._getViewExtent();

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    var percentExtent = [0, 100];
    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
    this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
  },

  /**
   * @private
   */
  _updateView: function (nonRealtime) {
    var displaybles = this._displayables;
    var handleEnds = this._handleEnds;
    var handleInterval = asc(handleEnds.slice());
    var size = this._size;
    each([0, 1], function (handleIndex) {
      // Handles
      var handle = displaybles.handles[handleIndex];
      var handleHeight = this._handleHeight;
      handle.attr({
        scale: [handleHeight / 2, handleHeight / 2],
        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
      });
    }, this); // Filler

    displaybles.filler.setShape({
      x: handleInterval[0],
      y: 0,
      width: handleInterval[1] - handleInterval[0],
      height: size[1]
    });

    this._updateDataInfo(nonRealtime);
  },

  /**
   * @private
   */
  _updateDataInfo: function (nonRealtime) {
    var dataZoomModel = this.dataZoomModel;
    var displaybles = this._displayables;
    var handleLabels = displaybles.handleLabels;
    var orient = this._orient;
    var labelTexts = ['', '']; // FIXME
    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）

    if (dataZoomModel.get('showDetail')) {
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var axis = axisProxy.getAxisModel().axis;
        var range = this._range;
        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
        ? axisProxy.calculateDataWindow({
          start: range[0],
          end: range[1]
        }).valueWindow : axisProxy.getDataValueWindow();
        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
      }
    }

    var orderedHandleEnds = asc(this._handleEnds.slice());
    setLabel.call(this, 0);
    setLabel.call(this, 1);

    function setLabel(handleIndex) {
      // Label
      // Text should not transform by barGroup.
      // Ignore handlers transform
      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
      var offset = this._handleWidth / 2 + LABEL_GAP;
      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
        textAlign: orient === HORIZONTAL ? direction : 'center',
        text: labelTexts[handleIndex]
      });
    }
  },

  /**
   * @private
   */
  _formatLabel: function (value, axis) {
    var dataZoomModel = this.dataZoomModel;
    var labelFormatter = dataZoomModel.get('labelFormatter');
    var labelPrecision = dataZoomModel.get('labelPrecision');

    if (labelPrecision == null || labelPrecision === 'auto') {
      labelPrecision = axis.getPixelPrecision();
    }

    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
    : value.toFixed(Math.min(labelPrecision, 20));
    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
  },

  /**
   * @private
   * @param {boolean} showOrHide true: show, false: hide
   */
  _showDataInfo: function (showOrHide) {
    // Always show when drgging.
    showOrHide = this._dragging || showOrHide;
    var handleLabels = this._displayables.handleLabels;
    handleLabels[0].attr('invisible', !showOrHide);
    handleLabels[1].attr('invisible', !showOrHide);
  },
  _onDragMove: function (handleIndex, dx, dy) {
    this._dragging = true; // Transform dx, dy to bar coordination.

    var barTransform = this._displayables.barGroup.getLocalTransform();

    var vertex = graphic.applyTransform([dx, dy], barTransform, true);

    this._updateInterval(handleIndex, vertex[0]);

    var realtime = this.dataZoomModel.get('realtime');

    this._updateView(!realtime);

    if (realtime) {
      realtime && this._dispatchZoomAction();
    }
  },
  _onDragEnd: function () {
    this._dragging = false;

    this._showDataInfo(false);

    this._dispatchZoomAction();
  },
  _onClickPanelClick: function (e) {
    var size = this._size;

    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);

    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
      return;
    }

    var handleEnds = this._handleEnds;
    var center = (handleEnds[0] + handleEnds[1]) / 2;

    this._updateInterval('all', localPoint[0] - center);

    this._updateView();

    this._dispatchZoomAction();
  },

  /**
   * This action will be throttled.
   * @private
   */
  _dispatchZoomAction: function () {
    var range = this._range;
    this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      dataZoomId: this.dataZoomModel.id,
      start: range[0],
      end: range[1]
    });
  },

  /**
   * @private
   */
  _findCoordRect: function () {
    // Find the grid coresponding to the first axis referred by dataZoom.
    var rect;
    each(this.getTargetCoordInfo(), function (coordInfoList) {
      if (!rect && coordInfoList.length) {
        var coordSys = coordInfoList[0].model.coordinateSystem;
        rect = coordSys.getRect && coordSys.getRect();
      }
    });

    if (!rect) {
      var width = this.api.getWidth();
      var height = this.api.getHeight();
      rect = {
        x: width * 0.2,
        y: height * 0.2,
        width: width * 0.6,
        height: height * 0.6
      };
    }

    return rect;
  }
});

function getOtherDim(thisDim) {
  // FIXME
  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
  var map = {
    x: 'y',
    y: 'x',
    radius: 'angle',
    angle: 'radius'
  };
  return map[thisDim];
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

var _default = SliderZoomView;
module.exports = _default;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var RoamController = __webpack_require__(191);

var throttleUtil = __webpack_require__(104);

// Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.
var curry = zrUtil.curry;
var ATTR = '\0_ec_dataZoom_roams';
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} dataZoomInfo
 * @param {string} dataZoomInfo.coordId
 * @param {Function} dataZoomInfo.containsPoint
 * @param {Array.<string>} dataZoomInfo.allCoordIds
 * @param {string} dataZoomInfo.dataZoomId
 * @param {number} dataZoomInfo.throttleRate
 * @param {Function} dataZoomInfo.panGetRange
 * @param {Function} dataZoomInfo.zoomGetRange
 * @param {boolean} [dataZoomInfo.zoomLock]
 * @param {boolean} [dataZoomInfo.disabled]
 */

function register(api, dataZoomInfo) {
  var store = giveStore(api);
  var theDataZoomId = dataZoomInfo.dataZoomId;
  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
  // Avoid memory leak, dispose all not-used-registered.

  zrUtil.each(store, function (record, coordId) {
    var dataZoomInfos = record.dataZoomInfos;

    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
      delete dataZoomInfos[theDataZoomId];
      record.count--;
    }
  });
  cleanStore(store);
  var record = store[theCoordId]; // Create if needed.

  if (!record) {
    record = store[theCoordId] = {
      coordId: theCoordId,
      dataZoomInfos: {},
      count: 0
    };
    record.controller = createController(api, record);
    record.dispatchAction = zrUtil.curry(dispatchAction, api);
  } // Update reference of dataZoom.


  !record.dataZoomInfos[theDataZoomId] && record.count++;
  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
  var controllerParams = mergeControllerParams(record.dataZoomInfos);
  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.

  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.

  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.throttleRate, 'fixRate');
}
/**
 * @public
 * @param {module:echarts/ExtensionAPI} api
 * @param {string} dataZoomId
 */


function unregister(api, dataZoomId) {
  var store = giveStore(api);
  zrUtil.each(store, function (record) {
    record.controller.dispose();
    var dataZoomInfos = record.dataZoomInfos;

    if (dataZoomInfos[dataZoomId]) {
      delete dataZoomInfos[dataZoomId];
      record.count--;
    }
  });
  cleanStore(store);
}
/**
 * @public
 */


function shouldRecordRange(payload, dataZoomId) {
  if (payload && payload.type === 'dataZoom' && payload.batch) {
    for (var i = 0, len = payload.batch.length; i < len; i++) {
      if (payload.batch[i].dataZoomId === dataZoomId) {
        return false;
      }
    }
  }

  return true;
}
/**
 * @public
 */


function generateCoordId(coordModel) {
  return coordModel.type + '\0_' + coordModel.id;
}
/**
 * Key: coordId, value: {dataZoomInfos: [], count, controller}
 * @type {Array.<Object>}
 */


function giveStore(api) {
  // Mount store on zrender instance, so that we do not
  // need to worry about dispose.
  var zr = api.getZr();
  return zr[ATTR] || (zr[ATTR] = {});
}

function createController(api, newRecord) {
  var controller = new RoamController(api.getZr());
  controller.on('pan', curry(onPan, newRecord));
  controller.on('zoom', curry(onZoom, newRecord));
  return controller;
}

function cleanStore(store) {
  zrUtil.each(store, function (record, coordId) {
    if (!record.count) {
      record.controller.dispose();
      delete store[coordId];
    }
  });
}

function onPan(record, dx, dy, oldX, oldY, newX, newY) {
  wrapAndDispatch(record, function (info) {
    return info.panGetRange(record.controller, dx, dy, oldX, oldY, newX, newY);
  });
}

function onZoom(record, scale, mouseX, mouseY) {
  wrapAndDispatch(record, function (info) {
    return info.zoomGetRange(record.controller, scale, mouseX, mouseY);
  });
}

function wrapAndDispatch(record, getRange) {
  var batch = [];
  zrUtil.each(record.dataZoomInfos, function (info) {
    var range = getRange(info);
    !info.disabled && range && batch.push({
      dataZoomId: info.dataZoomId,
      start: range[0],
      end: range[1]
    });
  });
  record.dispatchAction(batch);
}
/**
 * This action will be throttled.
 */


function dispatchAction(api, batch) {
  api.dispatchAction({
    type: 'dataZoom',
    batch: batch
  });
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */


function mergeControllerParams(dataZoomInfos) {
  var controlType;
  var opt = {};
  var typePriority = {
    'true': 2,
    'move': 1,
    'false': 0,
    'undefined': -1
  };
  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
    var oneType = dataZoomInfo.disabled ? false : dataZoomInfo.zoomLock ? 'move' : true;
    typePriority[oneType] > typePriority[controlType] && (controlType = oneType); // Do not support that different 'shift'/'ctrl'/'alt' setting used in one coord sys.

    zrUtil.extend(opt, dataZoomInfo.roamControllerOpt);
  });
  return {
    controlType: controlType,
    opt: opt
  };
}

exports.register = register;
exports.unregister = unregister;
exports.shouldRecordRange = shouldRecordRange;
exports.generateCoordId = generateCoordId;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(461);

__webpack_require__(142);

__webpack_require__(143);

__webpack_require__(1503);

__webpack_require__(1504);

__webpack_require__(459);

__webpack_require__(458);

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

__webpack_require__(1573);

__webpack_require__(193);

__webpack_require__(1510);

__webpack_require__(440);

function makeAction(method, actionInfo) {
  actionInfo.update = 'updateView';
  echarts.registerAction(actionInfo, function (payload, ecModel) {
    var selected = {};
    ecModel.eachComponent({
      mainType: 'geo',
      query: payload
    }, function (geoModel) {
      geoModel[method](payload.name);
      var geo = geoModel.coordinateSystem;
      zrUtil.each(geo.regions, function (region) {
        selected[region.name] = geoModel.isSelected(region.name) || false;
      });
    });
    return {
      selected: selected,
      name: payload.name
    };
  });
}

makeAction('toggleSelected', {
  type: 'geoToggleSelect',
  event: 'geoselectchanged'
});
makeAction('select', {
  type: 'geoSelect',
  event: 'geoselected'
});
makeAction('unSelect', {
  type: 'geoUnSelect',
  event: 'geounselected'
});

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var MapDraw = __webpack_require__(463);

var echarts = __webpack_require__(4);

var _default = echarts.extendComponentView({
  type: 'geo',
  init: function (ecModel, api) {
    var mapDraw = new MapDraw(api, true);
    this._mapDraw = mapDraw;
    this.group.add(mapDraw.group);
  },
  render: function (geoModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
      return;
    }

    var mapDraw = this._mapDraw;

    if (geoModel.get('show')) {
      mapDraw.draw(geoModel, ecModel, api, this, payload);
    } else {
      this._mapDraw.group.removeAll();
    }

    this.group.silent = geoModel.get('silent');
  },
  dispose: function () {
    this._mapDraw && this._mapDraw.remove();
  }
});

module.exports = _default;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var graphicUtil = __webpack_require__(5);

var layoutUtil = __webpack_require__(17);

// -------------
// Preprocessor
// -------------
echarts.registerPreprocessor(function (option) {
  var graphicOption = option.graphic; // Convert
  // {graphic: [{left: 10, type: 'circle'}, ...]}
  // or
  // {graphic: {left: 10, type: 'circle'}}
  // to
  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}

  if (zrUtil.isArray(graphicOption)) {
    if (!graphicOption[0] || !graphicOption[0].elements) {
      option.graphic = [{
        elements: graphicOption
      }];
    } else {
      // Only one graphic instance can be instantiated. (We dont
      // want that too many views are created in echarts._viewMap)
      option.graphic = [option.graphic[0]];
    }
  } else if (graphicOption && !graphicOption.elements) {
    option.graphic = [{
      elements: [graphicOption]
    }];
  }
}); // ------
// Model
// ------

var GraphicModel = echarts.extendComponentModel({
  type: 'graphic',
  defaultOption: {
    // Extra properties for each elements:
    //
    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
    //      This mechanism is useful when you want to position a group/element
    //      against the right side or the center of this container.
    //
    // width/height: (can only be pixel value, default 0)
    //      Only be used to specify contianer(group) size, if needed. And
    //      can not be percentage value (like '33%'). See the reason in the
    //      layout algorithm below.
    //
    // bounding: (enum: 'all' (default) | 'raw')
    //      Specify how to calculate boundingRect when locating.
    //      'all': Get uioned and transformed boundingRect
    //          from both itself and its descendants.
    //          This mode simplies confining a group of elements in the bounding
    //          of their ancester container (e.g., using 'right: 0').
    //      'raw': Only use the boundingRect of itself and before transformed.
    //          This mode is similar to css behavior, which is useful when you
    //          want an element to be able to overflow its container. (Consider
    //          a rotated circle needs to be located in a corner.)
    // Note: elements is always behind its ancestors in this elements array.
    elements: [],
    parentId: null
  },

  /**
   * Save el options for the sake of the performance (only update modified graphics).
   * The order is the same as those in option. (ancesters -> descendants)
   *
   * @private
   * @type {Array.<Object>}
   */
  _elOptionsToUpdate: null,

  /**
   * @override
   */
  mergeOption: function (option) {
    // Prevent default merge to elements
    var elements = this.option.elements;
    this.option.elements = null;
    GraphicModel.superApply(this, 'mergeOption', arguments);
    this.option.elements = elements;
  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    var thisOption = this.option;
    var newList = (isInit ? thisOption : newOption).elements;
    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
    var flattenedList = [];

    this._flatten(newList, flattenedList);

    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate

    var elOptionsToUpdate = this._elOptionsToUpdate = [];
    zrUtil.each(mappingResult, function (resultItem, index) {
      var newElOption = resultItem.option;

      if (!newElOption) {
        return;
      }

      elOptionsToUpdate.push(newElOption);
      setKeyInfoToNewElOption(resultItem, newElOption);
      mergeNewElOptionToExist(existList, index, newElOption);
      setLayoutInfoToExist(existList[index], newElOption);
    }, this); // Clean

    for (var i = existList.length - 1; i >= 0; i--) {
      if (existList[i] == null) {
        existList.splice(i, 1);
      } else {
        // $action should be volatile, otherwise option gotten from
        // `getOption` will contain unexpected $action.
        delete existList[i].$action;
      }
    }
  },

  /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   *
   * @private
   * @param {Array.<Object>} optionList option list
   * @param {Array.<Object>} result result of flatten
   * @param {Object} parentOption parent option
   */
  _flatten: function (optionList, result, parentOption) {
    zrUtil.each(optionList, function (option) {
      if (!option) {
        return;
      }

      if (parentOption) {
        option.parentOption = parentOption;
      }

      result.push(option);
      var children = option.children;

      if (option.type === 'group' && children) {
        this._flatten(children, result, option);
      } // Deleting for JSON output, and for not affecting group creation.


      delete option.children;
    }, this);
  },
  // FIXME
  // Pass to view using payload? setOption has a payload?
  useElOptionsToUpdate: function () {
    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.

    this._elOptionsToUpdate = null;
    return els;
  }
}); // -----
// View
// -----

echarts.extendComponentView({
  type: 'graphic',

  /**
   * @override
   */
  init: function (ecModel, api) {
    /**
     * @private
     * @type {module:zrender/core/util.HashMap}
     */
    this._elMap = zrUtil.createHashMap();
    /**
     * @private
     * @type {module:echarts/graphic/GraphicModel}
     */

    this._lastGraphicModel;
  },

  /**
   * @override
   */
  render: function (graphicModel, ecModel, api) {
    // Having leveraged between use cases and algorithm complexity, a very
    // simple layout mechanism is used:
    // The size(width/height) can be determined by itself or its parent (not
    // implemented yet), but can not by its children. (Top-down travel)
    // The location(x/y) can be determined by the bounding rect of itself
    // (can including its descendants or not) and the size of its parent.
    // (Bottom-up travel)
    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
    // view will be reused.
    if (graphicModel !== this._lastGraphicModel) {
      this._clear();
    }

    this._lastGraphicModel = graphicModel;

    this._updateElements(graphicModel, api);

    this._relocate(graphicModel, api);
  },

  /**
   * Update graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   * @param {module:echarts/ExtensionAPI} api extension API
   */
  _updateElements: function (graphicModel, api) {
    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();

    if (!elOptionsToUpdate) {
      return;
    }

    var elMap = this._elMap;
    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.

    zrUtil.each(elOptionsToUpdate, function (elOption) {
      var $action = elOption.$action;
      var id = elOption.id;
      var existEl = elMap.get(id);
      var parentId = elOption.parentId;
      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;

      if (elOption.type === 'text') {
        var elOptionStyle = elOption.style; // In top/bottom mode, textVerticalAlign should not be used, which cause
        // inaccurately locating.

        if (elOption.hv && elOption.hv[1]) {
          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
        } // Compatible with previous setting: both support fill and textFill,
        // stroke and textStroke.


        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
      } // Remove unnecessary props to avoid potential problems.


      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.

      if (!$action || $action === 'merge') {
        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
      } else if ($action === 'replace') {
        removeEl(existEl, elMap);
        createEl(id, targetElParent, elOptionCleaned, elMap);
      } else if ($action === 'remove') {
        removeEl(existEl, elMap);
      }

      var el = elMap.get(id);

      if (el) {
        el.__ecGraphicWidth = elOption.width;
        el.__ecGraphicHeight = elOption.height;
      }
    });
  },

  /**
   * Locate graphic elements.
   *
   * @private
   * @param {Object} graphicModel graphic model
   * @param {module:echarts/ExtensionAPI} api extension API
   */
  _relocate: function (graphicModel, api) {
    var elOptions = graphicModel.option.elements;
    var rootGroup = this.group;
    var elMap = this._elMap; // Bottom-up tranvese all elements (consider ec resize) to locate elements.

    for (var i = elOptions.length - 1; i >= 0; i--) {
      var elOption = elOptions[i];
      var el = elMap.get(elOption.id);

      if (!el) {
        continue;
      }

      var parentEl = el.parent;
      var containerInfo = parentEl === rootGroup ? {
        width: api.getWidth(),
        height: api.getHeight()
      } : {
        // Like 'position:absolut' in css, default 0.
        width: parentEl.__ecGraphicWidth || 0,
        height: parentEl.__ecGraphicHeight || 0
      };
      layoutUtil.positionElement(el, elOption, containerInfo, null, {
        hv: elOption.hv,
        boundingMode: elOption.bounding
      });
    }
  },

  /**
   * Clear all elements.
   *
   * @private
   */
  _clear: function () {
    var elMap = this._elMap;
    elMap.each(function (el) {
      removeEl(el, elMap);
    });
    this._elMap = zrUtil.createHashMap();
  },

  /**
   * @override
   */
  dispose: function () {
    this._clear();
  }
});

function createEl(id, targetElParent, elOption, elMap) {
  var graphicType = elOption.type;
  var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
  var el = new Clz(elOption);
  targetElParent.add(el);
  elMap.set(id, el);
  el.__ecGraphicId = id;
}

function removeEl(existEl, elMap) {
  var existElParent = existEl && existEl.parent;

  if (existElParent) {
    existEl.type === 'group' && existEl.traverse(function (el) {
      removeEl(el, elMap);
    });
    elMap.removeKey(existEl.__ecGraphicId);
    existElParent.remove(existEl);
  }
} // Remove unnecessary props to avoid potential problems.


function getCleanedElOption(elOption) {
  elOption = zrUtil.extend({}, elOption);
  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
    delete elOption[name];
  });
  return elOption;
}

function isSetLoc(obj, props) {
  var isSet;
  zrUtil.each(props, function (prop) {
    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
  });
  return isSet;
}

function setKeyInfoToNewElOption(resultItem, newElOption) {
  var existElOption = resultItem.exist; // Set id and type after id assigned.

  newElOption.id = resultItem.keyInfo.id;
  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified

  if (newElOption.parentId == null) {
    var newElParentOption = newElOption.parentOption;

    if (newElParentOption) {
      newElOption.parentId = newElParentOption.id;
    } else if (existElOption) {
      newElOption.parentId = existElOption.parentId;
    }
  } // Clear


  newElOption.parentOption = null;
}

function mergeNewElOptionToExist(existList, index, newElOption) {
  // Update existing options, for `getOption` feature.
  var newElOptCopy = zrUtil.extend({}, newElOption);
  var existElOption = existList[index];
  var $action = newElOption.$action || 'merge';

  if ($action === 'merge') {
    if (existElOption) {
      // We can ensure that newElOptCopy and existElOption are not
      // the same object, so `merge` will not change newElOptCopy.
      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.

      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
        ignoreSize: true
      }); // Will be used in render.

      layoutUtil.copyLayoutParams(newElOption, existElOption);
    } else {
      existList[index] = newElOptCopy;
    }
  } else if ($action === 'replace') {
    existList[index] = newElOptCopy;
  } else if ($action === 'remove') {
    // null will be cleaned later.
    existElOption && (existList[index] = null);
  }
}

function setLayoutInfoToExist(existItem, newElOption) {
  if (!existItem) {
    return;
  }

  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.

  if (existItem.type === 'group') {
    existItem.width == null && (existItem.width = newElOption.width = 0);
    existItem.height == null && (existItem.height = newElOption.height = 0);
  }
}

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);

__webpack_require__(455);

__webpack_require__(141);

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(468);

__webpack_require__(1516);

__webpack_require__(469);

var legendFilter = __webpack_require__(1517);

var Component = __webpack_require__(32);

// Do not contain scrollable legend, for sake of file size.
// Series Filter
echarts.registerProcessor(legendFilter);
Component.registerSubTypeDefaulter('legend', function () {
  // Default 'plain' when no type specified.
  return 'plain';
});

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var LegendModel = __webpack_require__(468);

var _layout = __webpack_require__(17);

var mergeLayoutParam = _layout.mergeLayoutParam;
var getLayoutParams = _layout.getLayoutParams;
var ScrollableLegendModel = LegendModel.extend({
  type: 'legend.scroll',

  /**
   * @param {number} scrollDataIndex
   */
  setScrollDataIndex: function (scrollDataIndex) {
    this.option.scrollDataIndex = scrollDataIndex;
  },
  defaultOption: {
    scrollDataIndex: 0,
    pageButtonItemGap: 5,
    pageButtonGap: null,
    pageButtonPosition: 'end',
    // 'start' or 'end'
    pageFormatter: '{current}/{total}',
    // If null/undefined, do not show page.
    pageIcons: {
      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
    },
    pageIconColor: '#2f4554',
    pageIconInactiveColor: '#aaa',
    pageIconSize: 15,
    // Can be [10, 3], which represents [width, height]
    pageTextStyle: {
      color: '#333'
    },
    animationDurationUpdate: 800
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel, extraOpt) {
    var inputPositionParams = getLayoutParams(option);
    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
  },

  /**
   * @override
   */
  mergeOption: function (option, extraOpt) {
    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
    mergeAndNormalizeLayoutParams(this, this.option, option);
  },
  getOrient: function () {
    return this.get('orient') === 'vertical' ? {
      index: 1,
      name: 'vertical'
    } : {
      index: 0,
      name: 'horizontal'
    };
  }
}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.

function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
  var orient = legendModel.getOrient();
  var ignoreSize = [1, 1];
  ignoreSize[orient.index] = 0;
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

var _default = ScrollableLegendModel;
module.exports = _default;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var layoutUtil = __webpack_require__(17);

var LegendView = __webpack_require__(469);

/**
 * Separate legend and scrollable legend to reduce package size.
 */
var Group = graphic.Group;
var WH = ['width', 'height'];
var XY = ['x', 'y'];
var ScrollableLegendView = LegendView.extend({
  type: 'legend.scroll',
  newlineDisabled: true,
  init: function () {
    ScrollableLegendView.superCall(this, 'init');
    /**
     * @private
     * @type {number} For `scroll`.
     */

    this._currentIndex = 0;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this.group.add(this._containerGroup = new Group());

    this._containerGroup.add(this.getContentGroup());
    /**
     * @private
     * @type {module:zrender/container/Group}
     */


    this.group.add(this._controllerGroup = new Group());
    /**
     *
     * @private
     */

    this._showController;
  },

  /**
   * @override
   */
  resetInner: function () {
    ScrollableLegendView.superCall(this, 'resetInner');

    this._controllerGroup.removeAll();

    this._containerGroup.removeClipPath();

    this._containerGroup.__rectSize = null;
  },

  /**
   * @override
   */
  renderInner: function (itemAlign, legendModel, ecModel, api) {
    var me = this; // Render content items.

    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api);
    var controllerGroup = this._controllerGroup;
    var pageIconSize = legendModel.get('pageIconSize', true);

    if (!zrUtil.isArray(pageIconSize)) {
      pageIconSize = [pageIconSize, pageIconSize];
    }

    createPageButton('pagePrev', 0);
    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
    controllerGroup.add(new graphic.Text({
      name: 'pageText',
      style: {
        textFill: pageTextStyleModel.getTextColor(),
        font: pageTextStyleModel.getFont(),
        textVerticalAlign: 'middle',
        textAlign: 'center'
      },
      silent: true
    }));
    createPageButton('pageNext', 1);

    function createPageButton(name, iconIdx) {
      var pageDataIndexName = name + 'DataIndex';
      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
        // Buttons will be created in each render, so we do not need
        // to worry about avoiding using legendModel kept in scope.
        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
      }, {
        x: -pageIconSize[0] / 2,
        y: -pageIconSize[1] / 2,
        width: pageIconSize[0],
        height: pageIconSize[1]
      });
      icon.name = name;
      controllerGroup.add(icon);
    }
  },

  /**
   * @override
   */
  layoutInner: function (legendModel, itemAlign, maxSize) {
    var contentGroup = this.getContentGroup();
    var containerGroup = this._containerGroup;
    var controllerGroup = this._controllerGroup;
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var hw = WH[1 - orientIdx];
    var yx = XY[1 - orientIdx]; // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
    layoutUtil.box( // Buttons in controller are layout always horizontally.
    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
    var contentRect = contentGroup.getBoundingRect();
    var controllerRect = controllerGroup.getBoundingRect();
    var showController = this._showController = contentRect[wh] > maxSize[wh];
    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.

    contentPos[orientIdx] = contentGroup.position[orientIdx]; // Layout container group based on 0.

    var containerPos = [0, 0];
    var controllerPos = [-controllerRect.x, -controllerRect.y];
    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.

    if (showController) {
      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.

      if (pageButtonPosition === 'end') {
        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
      } // controller is on the left / top.
      else {
          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
    } // Always align controller to content as 'middle'.


    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
    contentGroup.attr('position', contentPos);
    containerGroup.attr('position', containerPos);
    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
    // mainRect should not be calculated by `this.group.getBoundingRect()`
    // for sake of the overflow.

    var mainRect = this.group.getBoundingRect();
    var mainRect = {
      x: 0,
      y: 0
    }; // Consider content may be overflow (should be clipped).

    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.

    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
    containerGroup.__rectSize = maxSize[wh];

    if (showController) {
      var clipShape = {
        x: 0,
        y: 0
      };
      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
      clipShape[hw] = mainRect[hw];
      containerGroup.setClipPath(new graphic.Rect({
        shape: clipShape
      })); // Consider content may be larger than container, container rect
      // can not be obtained from `containerGroup.getBoundingRect()`.

      containerGroup.__rectSize = clipShape[wh];
    } else {
      // Do not remove or ignore controller. Keep them set as place holders.
      controllerGroup.eachChild(function (child) {
        child.attr({
          invisible: true,
          silent: true
        });
      });
    } // Content translate animation.


    var pageInfo = this._getPageInfo(legendModel);

    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
      position: pageInfo.contentPosition
    }, // When switch from "show controller" to "not show controller", view should be
    // updated immediately without animation, otherwise causes weird efffect.
    showController ? legendModel : false);

    this._updatePageInfoView(legendModel, pageInfo);

    return mainRect;
  },
  _pageGo: function (to, legendModel, api) {
    var scrollDataIndex = this._getPageInfo(legendModel)[to];

    scrollDataIndex != null && api.dispatchAction({
      type: 'legendScroll',
      scrollDataIndex: scrollDataIndex,
      legendId: legendModel.id
    });
  },
  _updatePageInfoView: function (legendModel, pageInfo) {
    var controllerGroup = this._controllerGroup;
    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
      var canJump = pageInfo[name + 'DataIndex'] != null;
      var icon = controllerGroup.childOfName(name);

      if (icon) {
        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
        icon.cursor = canJump ? 'pointer' : 'default';
      }
    });
    var pageText = controllerGroup.childOfName('pageText');
    var pageFormatter = legendModel.get('pageFormatter');
    var pageIndex = pageInfo.pageIndex;
    var current = pageIndex != null ? pageIndex + 1 : 0;
    var total = pageInfo.pageCount;
    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
      current: current,
      total: total
    }));
  },

  /**
   * @param {module:echarts/model/Model} legendModel
   * @return {Object} {
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no next page.
   *  pageNextDataIndex: number, null when no previous page.
   * }
   */
  _getPageInfo: function (legendModel) {
    // Align left or top by the current dataIndex.
    var currDataIndex = legendModel.get('scrollDataIndex', true);
    var contentGroup = this.getContentGroup();
    var contentRect = contentGroup.getBoundingRect();
    var containerRectSize = this._containerGroup.__rectSize;
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var hw = WH[1 - orientIdx];
    var xy = XY[orientIdx];
    var contentPos = contentGroup.position.slice();
    var pageIndex;
    var pagePrevDataIndex;
    var pageNextDataIndex;
    var targetItemGroup;

    if (this._showController) {
      contentGroup.eachChild(function (child) {
        if (child.__legendDataIndex === currDataIndex) {
          targetItemGroup = child;
        }
      });
    } else {
      targetItemGroup = contentGroup.childAt(0);
    }

    var pageCount = containerRectSize ? Math.ceil(contentRect[wh] / containerRectSize) : 0;

    if (targetItemGroup) {
      var itemRect = targetItemGroup.getBoundingRect();
      var itemLoc = targetItemGroup.position[orientIdx] + itemRect[xy];
      contentPos[orientIdx] = -itemLoc - contentRect[xy];
      pageIndex = Math.floor(pageCount * (itemLoc + itemRect[xy] + containerRectSize / 2) / contentRect[wh]);
      pageIndex = contentRect[wh] && pageCount ? Math.max(0, Math.min(pageCount - 1, pageIndex)) : -1;
      var winRect = {
        x: 0,
        y: 0
      };
      winRect[wh] = containerRectSize;
      winRect[hw] = contentRect[hw];
      winRect[xy] = -contentPos[orientIdx] - contentRect[xy];
      var startIdx;
      var children = contentGroup.children();
      contentGroup.eachChild(function (child, index) {
        var itemRect = getItemRect(child);

        if (itemRect.intersect(winRect)) {
          startIdx == null && (startIdx = index); // It is user-friendly that the last item shown in the
          // current window is shown at the begining of next window.

          pageNextDataIndex = child.__legendDataIndex;
        } // If the last item is shown entirely, no next page.


        if (index === children.length - 1 && itemRect[xy] + itemRect[wh] <= winRect[xy] + winRect[wh]) {
          pageNextDataIndex = null;
        }
      }); // Always align based on the left/top most item, so the left/top most
      // item in the previous window is needed to be found here.

      if (startIdx != null) {
        var startItem = children[startIdx];
        var startRect = getItemRect(startItem);
        winRect[xy] = startRect[xy] + startRect[wh] - winRect[wh]; // If the first item is shown entirely, no previous page.

        if (startIdx <= 0 && startRect[xy] >= winRect[xy]) {
          pagePrevDataIndex = null;
        } else {
          while (startIdx > 0 && getItemRect(children[startIdx - 1]).intersect(winRect)) {
            startIdx--;
          }

          pagePrevDataIndex = children[startIdx].__legendDataIndex;
        }
      }
    }

    return {
      contentPosition: contentPos,
      pageIndex: pageIndex,
      pageCount: pageCount,
      pagePrevDataIndex: pagePrevDataIndex,
      pageNextDataIndex: pageNextDataIndex
    };

    function getItemRect(el) {
      var itemRect = el.getBoundingRect().clone();
      itemRect[xy] += el.position[orientIdx];
      return itemRect;
    }
  }
});
var _default = ScrollableLegendView;
module.exports = _default;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    zrUtil.each(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return {
    name: payload.name,
    selected: selectedMap
  };
}
/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */


echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

module.exports = _default;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

/**
 * @event legendScroll
 * @type {Object}
 * @property {string} type 'legendScroll'
 * @property {string} scrollDataIndex
 */
echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
  var scrollDataIndex = payload.scrollDataIndex;
  scrollDataIndex != null && ecModel.eachComponent({
    mainType: 'legend',
    subType: 'scroll',
    query: payload
  }, function (legendModel) {
    legendModel.setScrollDataIndex(scrollDataIndex);
  });
});

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1513);

__webpack_require__(1514);

__webpack_require__(1515);

__webpack_require__(1518);

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1523);

__webpack_require__(1524);

echarts.registerPreprocessor(function (opt) {
  // Make sure markArea component is enabled
  opt.markArea = opt.markArea || {};
});

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1525);

__webpack_require__(1526);

echarts.registerPreprocessor(function (opt) {
  // Make sure markLine component is enabled
  opt.markLine = opt.markLine || {};
});

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1527);

__webpack_require__(1528);

// HINT Markpoint can't be used too much
echarts.registerPreprocessor(function (opt) {
  // Make sure markPoint component is enabled
  opt.markPoint = opt.markPoint || {};
});

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var MarkerModel = __webpack_require__(278);

var _default = MarkerModel.extend({
  type: 'markArea',
  defaultOption: {
    zlevel: 0,
    // PENDING
    z: 1,
    tooltip: {
      trigger: 'item'
    },
    // markArea should fixed on the coordinate system
    animation: false,
    label: {
      normal: {
        show: true,
        position: 'top'
      },
      emphasis: {
        show: true,
        position: 'top'
      }
    },
    itemStyle: {
      normal: {
        // color and borderColor default to use color from series
        // color: 'auto'
        // borderColor: 'auto'
        borderWidth: 0
      }
    }
  }
});

module.exports = _default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var colorUtil = __webpack_require__(78);

var List = __webpack_require__(31);

var numberUtil = __webpack_require__(8);

var graphic = __webpack_require__(5);

var markerHelper = __webpack_require__(280);

var MarkerView = __webpack_require__(279);

// TODO Better on polar
var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
  var lt = markerHelper.dataTransform(seriesModel, item[0]);
  var rb = markerHelper.dataTransform(seriesModel, item[1]);
  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb

  var ltCoord = lt.coord;
  var rbCoord = rb.coord;
  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
  rbCoord[0] = retrieve(rbCoord[0], Infinity);
  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one

  var result = zrUtil.mergeAll([{}, lt, rb]);
  result.coord = [lt.coord, rb.coord];
  result.x0 = lt.x;
  result.y0 = lt.y;
  result.x1 = rb.x;
  result.y1 = rb.y;
  return result;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
}

function markAreaFilter(coordSys, item) {
  var fromCoord = item.coord[0];
  var toCoord = item.coord[1];

  if (coordSys.type === 'cartesian2d') {
    // In case
    // {
    //  markArea: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }
    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return markerHelper.dataFilter(coordSys, {
    coord: fromCoord,
    x: item.x0,
    y: item.y0
  }) || markerHelper.dataFilter(coordSys, {
    coord: toCoord,
    x: item.x1,
    y: item.y1
  });
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']


function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
    } else {
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      point = coordSys.dataToPoint([x, y], true);
    }

    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);

      if (isInifinity(x)) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
      } else if (isInifinity(y)) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  return point;
}

var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
MarkerView.extend({
  type: 'markArea',
  updateLayout: function (markAreaModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var maModel = seriesModel.markAreaModel;

      if (maModel) {
        var areaData = maModel.getData();
        areaData.each(function (idx) {
          var points = zrUtil.map(dimPermutations, function (dim) {
            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
          }); // Layout

          areaData.setItemLayout(idx, points);
          var el = areaData.getItemGraphicEl(idx);
          el.setShape('points', points);
        });
      }
    }, this);
  },
  renderSeries: function (seriesModel, maModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesName = seriesModel.name;
    var seriesData = seriesModel.getData();
    var areaGroupMap = this.markerGroupMap;
    var polygonGroup = areaGroupMap.get(seriesName) || areaGroupMap.set(seriesName, {
      group: new graphic.Group()
    });
    this.group.add(polygonGroup.group);
    polygonGroup.__keep = true;
    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter

    maModel.setData(areaData); // Update visual and layout of line

    areaData.each(function (idx) {
      // Layout
      areaData.setItemLayout(idx, zrUtil.map(dimPermutations, function (dim) {
        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
      })); // Visual

      areaData.setItemVisual(idx, {
        color: seriesData.getVisual('color')
      });
    });
    areaData.diff(polygonGroup.__data).add(function (idx) {
      var polygon = new graphic.Polygon({
        shape: {
          points: areaData.getItemLayout(idx)
        }
      });
      areaData.setItemGraphicEl(idx, polygon);
      polygonGroup.group.add(polygon);
    }).update(function (newIdx, oldIdx) {
      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);

      graphic.updateProps(polygon, {
        shape: {
          points: areaData.getItemLayout(newIdx)
        }
      }, maModel, newIdx);
      polygonGroup.group.add(polygon);
      areaData.setItemGraphicEl(newIdx, polygon);
    }).remove(function (idx) {
      var polygon = polygonGroup.__data.getItemGraphicEl(idx);

      polygonGroup.group.remove(polygon);
    }).execute();
    areaData.eachItemGraphicEl(function (polygon, idx) {
      var itemModel = areaData.getItemModel(idx);
      var labelModel = itemModel.getModel('label.normal');
      var labelHoverModel = itemModel.getModel('label.emphasis');
      var color = areaData.getItemVisual(idx, 'color');
      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle.normal').getItemStyle(), {
        fill: colorUtil.modifyAlpha(color, 0.4),
        stroke: color
      }));
      polygon.hoverStyle = itemModel.getModel('itemStyle.emphasis').getItemStyle();
      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
        labelFetcher: maModel,
        labelDataIndex: idx,
        defaultText: areaData.getName(idx) || '',
        isRectText: true,
        autoColor: color
      });
      graphic.setHoverStyle(polygon, {});
      polygon.dataModel = maModel;
    });
    polygonGroup.__data = areaData;
    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */

function createList(coordSys, seriesModel, maModel) {
  var coordDimsInfos;
  var areaData;
  var dims = ['x0', 'y0', 'x1', 'y1'];

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      info.name = coordDim;
      return info;
    });
    areaData = new List(zrUtil.map(dims, function (dim, idx) {
      return {
        name: dim,
        type: coordDimsInfos[idx % 2].type
      };
    }), maModel);
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
    areaData = new List(coordDimsInfos, maModel);
  }

  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));

  if (coordSys) {
    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
  }

  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
  } : function (item) {
    return item.value;
  };
  areaData.initData(optData, null, dimValueGetter);
  areaData.hasItemOption = true;
  return areaData;
}

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var MarkerModel = __webpack_require__(278);

var _default = MarkerModel.extend({
  type: 'markLine',
  defaultOption: {
    zlevel: 0,
    z: 5,
    symbol: ['circle', 'arrow'],
    symbolSize: [8, 16],
    //symbolRotate: 0,
    precision: 2,
    tooltip: {
      trigger: 'item'
    },
    label: {
      normal: {
        show: true,
        position: 'end'
      },
      emphasis: {
        show: true
      }
    },
    lineStyle: {
      normal: {
        type: 'dashed'
      },
      emphasis: {
        width: 3
      }
    },
    animationEasing: 'linear'
  }
});

module.exports = _default;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var List = __webpack_require__(31);

var numberUtil = __webpack_require__(8);

var markerHelper = __webpack_require__(280);

var LineDraw = __webpack_require__(272);

var MarkerView = __webpack_require__(279);

var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average'

  var mlType = item.type;

  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' // In case
  // data: [{
  //   yAxis: 10
  // }]
  || item.xAxis != null || item.yAxis != null)) {
    var valueAxis;
    var valueDataDim;
    var value;

    if (item.yAxis != null || item.xAxis != null) {
      valueDataDim = item.yAxis != null ? 'y' : 'x';
      valueAxis = coordSys.getAxis(valueDataDim);
      value = zrUtil.retrieve(item.yAxis, item.xAxis);
    } else {
      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
      valueDataDim = axisInfo.valueDataDim;
      valueAxis = axisInfo.valueAxis;
      value = markerHelper.numCalculate(data, valueDataDim, mlType);
    }

    var valueIndex = valueDataDim === 'x' ? 0 : 1;
    var baseIndex = 1 - valueIndex;
    var mlFrom = zrUtil.clone(item);
    var mlTo = {};
    mlFrom.type = null;
    mlFrom.coord = [];
    mlTo.coord = [];
    mlFrom.coord[baseIndex] = -Infinity;
    mlTo.coord[baseIndex] = Infinity;
    var precision = mlModel.get('precision');

    if (precision >= 0 && typeof value === 'number') {
      value = +value.toFixed(Math.min(precision, 20));
    }

    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
    item = [mlFrom, mlTo, {
      // Extra option for tooltip and label
      type: mlType,
      valueIndex: item.valueIndex,
      // Force to use the value of calculated value.
      value: value
    }];
  }

  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type

  item[2].type = item[2].type || ''; // Merge from option and to option into line option

  zrUtil.merge(item[2], item[0]);
  zrUtil.merge(item[2], item[1]);
  return item;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  var dimName = coordSys.dimensions[dimIndex];
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}

function markLineFilter(coordSys, item) {
  if (coordSys.type === 'cartesian2d') {
    var fromCoord = item[0].coord;
    var toCoord = item[1].coord; // In case
    // {
    //  markLine: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }

    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
}

function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
    } else {
      var dims = coordSys.dimensions;
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      point = coordSys.dataToPoint([x, y]);
    } // Expand line to the edge of grid if value on one axis is Inifnity
    // In case
    //  markLine: {
    //    data: [{
    //      yAxis: 2
    //      // or
    //      type: 'average'
    //    }]
    //  }


    if (coordSys.type === 'cartesian2d') {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var dims = coordSys.dimensions;

      if (isInifinity(data.get(dims[0], idx))) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
      } else if (isInifinity(data.get(dims[1], idx))) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  data.setItemLayout(idx, point);
}

var _default = MarkerView.extend({
  type: 'markLine',
  updateLayout: function (markLineModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mlModel = seriesModel.markLineModel;

      if (mlModel) {
        var mlData = mlModel.getData();
        var fromData = mlModel.__from;
        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol

        fromData.each(function (idx) {
          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
        }); // Update layout of line

        mlData.each(function (idx) {
          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
        });
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  },
  renderSeries: function (seriesModel, mlModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var lineDrawMap = this.markerGroupMap;
    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
    this.group.add(lineDraw.group);
    var mlData = createList(coordSys, seriesModel, mlModel);
    var fromData = mlData.from;
    var toData = mlData.to;
    var lineData = mlData.line;
    mlModel.__from = fromData;
    mlModel.__to = toData; // Line data for tooltip and formatter

    mlModel.setData(lineData);
    var symbolType = mlModel.get('symbol');
    var symbolSize = mlModel.get('symbolSize');

    if (!zrUtil.isArray(symbolType)) {
      symbolType = [symbolType, symbolType];
    }

    if (typeof symbolSize === 'number') {
      symbolSize = [symbolSize, symbolSize];
    } // Update visual and layout of from symbol and to symbol


    mlData.from.each(function (idx) {
      updateDataVisualAndLayout(fromData, idx, true);
      updateDataVisualAndLayout(toData, idx, false);
    }); // Update visual and layout of line

    lineData.each(function (idx) {
      var lineColor = lineData.getItemModel(idx).get('lineStyle.normal.color');
      lineData.setItemVisual(idx, {
        color: lineColor || fromData.getItemVisual(idx, 'color')
      });
      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
      lineData.setItemVisual(idx, {
        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
        'toSymbol': toData.getItemVisual(idx, 'symbol')
      });
    });
    lineDraw.updateData(lineData); // Set host model for tooltip
    // FIXME

    mlData.line.eachItemGraphicEl(function (el, idx) {
      el.traverse(function (child) {
        child.dataModel = mlModel;
      });
    });

    function updateDataVisualAndLayout(data, idx, isFrom) {
      var itemModel = data.getItemModel(idx);
      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
      data.setItemVisual(idx, {
        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
        color: itemModel.get('itemStyle.normal.color') || seriesData.getVisual('color')
      });
    }

    lineDraw.__keep = true;
    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} coordSys
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */


function createList(coordSys, seriesModel, mlModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      info.name = coordDim;
      return info;
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var fromData = new List(coordDimsInfos, mlModel);
  var toData = new List(coordDimsInfos, mlModel); // No dimensions

  var lineData = new List([], mlModel);
  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));

  if (coordSys) {
    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
  }

  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
    return item.value;
  };
  fromData.initData(zrUtil.map(optData, function (item) {
    return item[0];
  }), null, dimValueGetter);
  toData.initData(zrUtil.map(optData, function (item) {
    return item[1];
  }), null, dimValueGetter);
  lineData.initData(zrUtil.map(optData, function (item) {
    return item[2];
  }));
  lineData.hasItemOption = true;
  return {
    from: fromData,
    to: toData,
    line: lineData
  };
}

module.exports = _default;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var MarkerModel = __webpack_require__(278);

var _default = MarkerModel.extend({
  type: 'markPoint',
  defaultOption: {
    zlevel: 0,
    z: 5,
    symbol: 'pin',
    symbolSize: 50,
    //symbolRotate: 0,
    //symbolOffset: [0, 0]
    tooltip: {
      trigger: 'item'
    },
    label: {
      normal: {
        show: true,
        position: 'inside'
      },
      emphasis: {
        show: true
      }
    },
    itemStyle: {
      normal: {
        borderWidth: 2
      }
    }
  }
});

module.exports = _default;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var SymbolDraw = __webpack_require__(139);

var numberUtil = __webpack_require__(8);

var List = __webpack_require__(31);

var markerHelper = __webpack_require__(280);

var MarkerView = __webpack_require__(279);

function updateMarkerLayout(mpData, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  mpData.each(function (idx) {
    var itemModel = mpData.getItemModel(idx);
    var point;
    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());

    if (!isNaN(xPx) && !isNaN(yPx)) {
      point = [xPx, yPx];
    } // Chart like bar may have there own marker positioning logic
    else if (seriesModel.getMarkerPosition) {
        // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
      } else if (coordSys) {
        var x = mpData.get(coordSys.dimensions[0], idx);
        var y = mpData.get(coordSys.dimensions[1], idx);
        point = coordSys.dataToPoint([x, y]);
      } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }

    mpData.setItemLayout(idx, point);
  });
}

var _default = MarkerView.extend({
  type: 'markPoint',
  updateLayout: function (markPointModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mpModel = seriesModel.markPointModel;

      if (mpModel) {
        updateMarkerLayout(mpModel.getData(), seriesModel, api);
        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
      }
    }, this);
  },
  renderSeries: function (seriesModel, mpModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var symbolDrawMap = this.markerGroupMap;
    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME

    mpModel.setData(mpData);
    updateMarkerLayout(mpModel.getData(), seriesModel, api);
    mpData.each(function (idx) {
      var itemModel = mpData.getItemModel(idx);
      var symbolSize = itemModel.getShallow('symbolSize');

      if (typeof symbolSize === 'function') {
        // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
        symbolSize = symbolSize(mpModel.getRawValue(idx), mpModel.getDataParams(idx));
      }

      mpData.setItemVisual(idx, {
        symbolSize: symbolSize,
        color: itemModel.get('itemStyle.normal.color') || seriesData.getVisual('color'),
        symbol: itemModel.getShallow('symbol')
      });
    }); // TODO Text are wrong

    symbolDraw.updateData(mpData);
    this.group.add(symbolDraw.group); // Set host model for tooltip
    // FIXME

    mpData.eachItemGraphicEl(function (el) {
      el.traverse(function (child) {
        child.dataModel = mpModel;
      });
    });
    symbolDraw.__keep = true;
    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
  }
});
/**
 * @inner
 * @param {module:echarts/coord/*} [coordSys]
 * @param {module:echarts/model/Series} seriesModel
 * @param {module:echarts/model/Model} mpModel
 */


function createList(coordSys, seriesModel, mpModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.coordDimToDataDim(coordDim)[0]) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      info.name = coordDim;
      return info;
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var mpData = new List(coordDimsInfos, mpModel);
  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));

  if (coordSys) {
    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
  }

  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
    return item.value;
  });
  return mpData;
}

module.exports = _default;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(484);

__webpack_require__(1484);

__webpack_require__(1481);

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var barPolar = __webpack_require__(1600);

__webpack_require__(282);

__webpack_require__(1477);

__webpack_require__(1533);

__webpack_require__(141);

__webpack_require__(1487);

// For reducing size of echarts.min, barLayoutPolar is required by polar.
echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view

echarts.extendComponentView({
  type: 'polar'
});

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1591);

__webpack_require__(1592);

__webpack_require__(1532);

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var AxisBuilder = __webpack_require__(102);

var graphic = __webpack_require__(5);

var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];

var _default = echarts.extendComponentView({
  type: 'radar',
  render: function (radarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();

    this._buildAxes(radarModel);

    this._buildSplitLineAndArea(radarModel);
  },
  _buildAxes: function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();
    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
        position: [radar.cx, radar.cy],
        rotation: indicatorAxis.angle,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1
      });
      return axisBuilder;
    });
    zrUtil.each(axisBuilders, function (axisBuilder) {
      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
      this.group.add(axisBuilder.getGroup());
    }, this);
  },
  _buildSplitLineAndArea: function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();

    if (!indicatorAxes.length) {
      return;
    }

    var shape = radarModel.get('shape');
    var splitLineModel = radarModel.getModel('splitLine');
    var splitAreaModel = radarModel.getModel('splitArea');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var showSplitLine = splitLineModel.get('show');
    var showSplitArea = splitAreaModel.get('show');
    var splitLineColors = lineStyleModel.get('color');
    var splitAreaColors = areaStyleModel.get('color');
    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
    var splitLines = [];
    var splitAreas = [];

    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
      var colorIndex = idx % areaOrLineColorList.length;
      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
      return colorIndex;
    }

    if (shape === 'circle') {
      var ticksRadius = indicatorAxes[0].getTicksCoords();
      var cx = radar.cx;
      var cy = radar.cy;

      for (var i = 0; i < ticksRadius.length; i++) {
        if (showSplitLine) {
          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
          splitLines[colorIndex].push(new graphic.Circle({
            shape: {
              cx: cx,
              cy: cy,
              r: ticksRadius[i]
            }
          }));
        }

        if (showSplitArea && i < ticksRadius.length - 1) {
          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
          splitAreas[colorIndex].push(new graphic.Ring({
            shape: {
              cx: cx,
              cy: cy,
              r0: ticksRadius[i],
              r: ticksRadius[i + 1]
            }
          }));
        }
      }
    } // Polyyon
    else {
        var realSplitNumber;
        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
          var ticksCoords = indicatorAxis.getTicksCoords();
          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
          return zrUtil.map(ticksCoords, function (tickCoord) {
            return radar.coordToPoint(tickCoord, idx);
          });
        });
        var prevPoints = [];

        for (var i = 0; i <= realSplitNumber; i++) {
          var points = [];

          for (var j = 0; j < indicatorAxes.length; j++) {
            points.push(axesTicksPoints[j][i]);
          } // Close


          if (points[0]) {
            points.push(points[0].slice());
          } else {}

          if (showSplitLine) {
            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
            splitLines[colorIndex].push(new graphic.Polyline({
              shape: {
                points: points
              }
            }));
          }

          if (showSplitArea && prevPoints) {
            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
            splitAreas[colorIndex].push(new graphic.Polygon({
              shape: {
                points: points.concat(prevPoints)
              }
            }));
          }

          prevPoints = points.slice().reverse();
        }
      }

    var lineStyle = lineStyleModel.getLineStyle();
    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine

    zrUtil.each(splitAreas, function (splitAreas, idx) {
      this.group.add(graphic.mergePath(splitAreas, {
        style: zrUtil.defaults({
          stroke: 'none',
          fill: splitAreaColors[idx % splitAreaColors.length]
        }, areaStyle),
        silent: true
      }));
    }, this);
    zrUtil.each(splitLines, function (splitLines, idx) {
      this.group.add(graphic.mergePath(splitLines, {
        style: zrUtil.defaults({
          fill: 'none',
          stroke: splitLineColors[idx % splitLineColors.length]
        }, lineStyle),
        silent: true
      }));
    }, this);
  }
});

module.exports = _default;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(282);

__webpack_require__(1482);

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var preprocessor = __webpack_require__(1540);

__webpack_require__(1542);

__webpack_require__(1541);

__webpack_require__(1535);

__webpack_require__(1536);

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var TimelineModel = __webpack_require__(1538);

var modelUtil = __webpack_require__(15);

var SliderTimelineModel = TimelineModel.extend({
  type: 'timeline.slider',

  /**
   * @protected
   */
  defaultOption: {
    backgroundColor: 'rgba(0,0,0,0)',
    // 时间轴背景颜色
    borderColor: '#ccc',
    // 时间轴边框颜色
    borderWidth: 0,
    // 时间轴边框线宽，单位px，默认为0（无边框）
    orient: 'horizontal',
    // 'vertical'
    inverse: false,
    tooltip: {
      // boolean or Object
      trigger: 'item' // data item may also have tootip attr.

    },
    symbol: 'emptyCircle',
    symbolSize: 10,
    lineStyle: {
      show: true,
      width: 2,
      color: '#304654'
    },
    label: {
      // 文本标签
      position: 'auto',
      // auto left right top bottom
      // When using number, label position is not
      // restricted by viewRect.
      // positive: right/bottom, negative: left/top
      normal: {
        show: true,
        interval: 'auto',
        rotate: 0,
        // formatter: null,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: '#304654'
      },
      emphasis: {
        show: true,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: '#c23531'
      }
    },
    itemStyle: {
      normal: {
        color: '#304654',
        borderWidth: 1
      },
      emphasis: {
        color: '#c23531'
      }
    },
    checkpointStyle: {
      symbol: 'circle',
      symbolSize: 13,
      color: '#c23531',
      borderWidth: 5,
      borderColor: 'rgba(194,53,49, 0.5)',
      animation: true,
      animationDuration: 300,
      animationEasing: 'quinticInOut'
    },
    controlStyle: {
      show: true,
      showPlayBtn: true,
      showPrevBtn: true,
      showNextBtn: true,
      itemSize: 22,
      itemGap: 12,
      position: 'left',
      // 'left' 'right' 'top' 'bottom'
      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
      // jshint ignore:line
      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
      // jshint ignore:line
      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
      // jshint ignore:line
      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
      // jshint ignore:line
      normal: {
        color: '#304654',
        borderColor: '#304654',
        borderWidth: 1
      },
      emphasis: {
        color: '#c23531',
        borderColor: '#c23531',
        borderWidth: 2
      }
    },
    data: []
  }
});
zrUtil.mixin(SliderTimelineModel, modelUtil.dataFormatMixin);
var _default = SliderTimelineModel;
module.exports = _default;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var matrix = __webpack_require__(53);

var graphic = __webpack_require__(5);

var layout = __webpack_require__(17);

var TimelineView = __webpack_require__(1539);

var TimelineAxis = __webpack_require__(1537);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var axisHelper = __webpack_require__(51);

var numberUtil = __webpack_require__(8);

var _format = __webpack_require__(21);

var encodeHTML = _format.encodeHTML;
var bind = zrUtil.bind;
var each = zrUtil.each;
var PI = Math.PI;

var _default = TimelineView.extend({
  type: 'timeline.slider',
  init: function (ecModel, api) {
    this.api = api;
    /**
     * @private
     * @type {module:echarts/component/timeline/TimelineAxis}
     */

    this._axis;
    /**
     * @private
     * @type {module:zrender/core/BoundingRect}
     */

    this._viewRect;
    /**
     * @type {number}
     */

    this._timer;
    /**
     * @type {module:zrender/Element}
     */

    this._currentPointer;
    /**
     * @type {module:zrender/container/Group}
     */

    this._mainGroup;
    /**
     * @type {module:zrender/container/Group}
     */

    this._labelGroup;
  },

  /**
   * @override
   */
  render: function (timelineModel, ecModel, api, payload) {
    this.model = timelineModel;
    this.api = api;
    this.ecModel = ecModel;
    this.group.removeAll();

    if (timelineModel.get('show', true)) {
      var layoutInfo = this._layout(timelineModel, api);

      var mainGroup = this._createGroup('mainGroup');

      var labelGroup = this._createGroup('labelGroup');
      /**
       * @private
       * @type {module:echarts/component/timeline/TimelineAxis}
       */


      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);

      timelineModel.formatTooltip = function (dataIndex) {
        return encodeHTML(axis.scale.getLabel(dataIndex));
      };

      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
      }, this);

      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);

      this._position(layoutInfo, timelineModel);
    }

    this._doPlayStop();
  },

  /**
   * @override
   */
  remove: function () {
    this._clearTimer();

    this.group.removeAll();
  },

  /**
   * @override
   */
  dispose: function () {
    this._clearTimer();
  },
  _layout: function (timelineModel, api) {
    var labelPosOpt = timelineModel.get('label.normal.position');
    var orient = timelineModel.get('orient');
    var viewRect = getViewRect(timelineModel, api); // Auto label offset.

    if (labelPosOpt == null || labelPosOpt === 'auto') {
      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
    } else if (isNaN(labelPosOpt)) {
      labelPosOpt = {
        horizontal: {
          top: '-',
          bottom: '+'
        },
        vertical: {
          left: '-',
          right: '+'
        }
      }[orient][labelPosOpt];
    }

    var labelAlignMap = {
      horizontal: 'center',
      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
    };
    var labelBaselineMap = {
      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
      vertical: 'middle'
    };
    var rotationMap = {
      horizontal: 0,
      vertical: PI / 2
    }; // Position

    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
    var controlModel = timelineModel.getModel('controlStyle');
    var showControl = controlModel.get('show');
    var controlSize = showControl ? controlModel.get('itemSize') : 0;
    var controlGap = showControl ? controlModel.get('itemGap') : 0;
    var sizePlusGap = controlSize + controlGap; // Special label rotate.

    var labelRotation = timelineModel.get('label.normal.rotate') || 0;
    labelRotation = labelRotation * PI / 180; // To radian.

    var playPosition;
    var prevBtnPosition;
    var nextBtnPosition;
    var axisExtent;
    var controlPosition = controlModel.get('position', true);
    var showControl = controlModel.get('show', true);
    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
    var xLeft = 0;
    var xRight = mainLength; // position[0] means left, position[1] means middle.

    if (controlPosition === 'left' || controlPosition === 'bottom') {
      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    } else {
      // 'top' 'right'
      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    }

    axisExtent = [xLeft, xRight];

    if (timelineModel.get('inverse')) {
      axisExtent.reverse();
    }

    return {
      viewRect: viewRect,
      mainLength: mainLength,
      orient: orient,
      rotation: rotationMap[orient],
      labelRotation: labelRotation,
      labelPosOpt: labelPosOpt,
      labelAlign: timelineModel.get('label.normal.align') || labelAlignMap[orient],
      labelBaseline: timelineModel.get('label.normal.verticalAlign') || timelineModel.get('label.normal.baseline') || labelBaselineMap[orient],
      // Based on mainGroup.
      playPosition: playPosition,
      prevBtnPosition: prevBtnPosition,
      nextBtnPosition: nextBtnPosition,
      axisExtent: axisExtent,
      controlSize: controlSize,
      controlGap: controlGap
    };
  },
  _position: function (layoutInfo, timelineModel) {
    // Position is be called finally, because bounding rect is needed for
    // adapt content to fill viewRect (auto adapt offset).
    // Timeline may be not all in the viewRect when 'offset' is specified
    // as a number, because it is more appropriate that label aligns at
    // 'offset' but not the other edge defined by viewRect.
    var mainGroup = this._mainGroup;
    var labelGroup = this._labelGroup;
    var viewRect = layoutInfo.viewRect;

    if (layoutInfo.orient === 'vertical') {
      // transfrom to horizontal, inverse rotate by left-top point.
      var m = matrix.create();
      var rotateOriginX = viewRect.x;
      var rotateOriginY = viewRect.y + viewRect.height;
      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
      matrix.rotate(m, m, -PI / 2);
      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
      viewRect = viewRect.clone();
      viewRect.applyTransform(m);
    }

    var viewBound = getBound(viewRect);
    var mainBound = getBound(mainGroup.getBoundingRect());
    var labelBound = getBound(labelGroup.getBoundingRect());
    var mainPosition = mainGroup.position;
    var labelsPosition = labelGroup.position;
    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
    var labelPosOpt = layoutInfo.labelPosOpt;

    if (isNaN(labelPosOpt)) {
      // '+' or '-'
      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
    } else {
      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      labelsPosition[1] = mainPosition[1] + labelPosOpt;
    }

    mainGroup.attr('position', mainPosition);
    labelGroup.attr('position', labelsPosition);
    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
    setOrigin(mainGroup);
    setOrigin(labelGroup);

    function setOrigin(targetGroup) {
      var pos = targetGroup.position;
      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
    }

    function getBound(rect) {
      // [[xmin, xmax], [ymin, ymax]]
      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
    }

    function toBound(fromPos, from, to, dimIdx, boundIdx) {
      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
    }
  },
  _createAxis: function (layoutInfo, timelineModel) {
    var data = timelineModel.getData();
    var axisType = timelineModel.get('axisType');
    var scale = axisHelper.createScaleByModel(timelineModel, axisType);
    var dataExtent = data.getDataExtent('value');
    scale.setExtent(dataExtent[0], dataExtent[1]);

    this._customizeScale(scale, data);

    scale.niceTicks();
    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
    axis.model = timelineModel;
    return axis;
  },
  _customizeScale: function (scale, data) {
    scale.getTicks = function () {
      return data.mapArray(['value'], function (value) {
        return value;
      });
    };

    scale.getTicksLabels = function () {
      return zrUtil.map(this.getTicks(), scale.getLabel, scale);
    };
  },
  _createGroup: function (name) {
    var newGroup = this['_' + name] = new graphic.Group();
    this.group.add(newGroup);
    return newGroup;
  },
  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
    var axisExtent = axis.getExtent();

    if (!timelineModel.get('lineStyle.show')) {
      return;
    }

    group.add(new graphic.Line({
      shape: {
        x1: axisExtent[0],
        y1: 0,
        x2: axisExtent[1],
        y2: 0
      },
      style: zrUtil.extend({
        lineCap: 'round'
      }, timelineModel.getModel('lineStyle').getLineStyle()),
      silent: true,
      z2: 1
    }));
  },

  /**
   * @private
   */
  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData();
    var ticks = axis.scale.getTicks();
    each(ticks, function (value, dataIndex) {
      var tickCoord = axis.dataToCoord(value);
      var itemModel = data.getItemModel(dataIndex);
      var itemStyleModel = itemModel.getModel('itemStyle.normal');
      var hoverStyleModel = itemModel.getModel('itemStyle.emphasis');
      var symbolOpt = {
        position: [tickCoord, 0],
        onclick: bind(this._changeTimeline, this, dataIndex)
      };
      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());

      if (itemModel.get('tooltip')) {
        el.dataIndex = dataIndex;
        el.dataModel = timelineModel;
      } else {
        el.dataIndex = el.dataModel = null;
      }
    }, this);
  },

  /**
   * @private
   */
  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
    var labelModel = timelineModel.getModel('label.normal');

    if (!labelModel.get('show')) {
      return;
    }

    var data = timelineModel.getData();
    var ticks = axis.scale.getTicks();
    var labels = axisHelper.getFormattedLabels(axis, labelModel.get('formatter'));
    var labelInterval = axis.getLabelInterval();
    each(ticks, function (tick, dataIndex) {
      if (axis.isLabelIgnored(dataIndex, labelInterval)) {
        return;
      }

      var itemModel = data.getItemModel(dataIndex);
      var normalLabelModel = itemModel.getModel('label.normal');
      var hoverLabelModel = itemModel.getModel('label.emphasis');
      var tickCoord = axis.dataToCoord(tick);
      var textEl = new graphic.Text({
        position: [tickCoord, 0],
        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
        onclick: bind(this._changeTimeline, this, dataIndex),
        silent: false
      });
      graphic.setTextStyle(textEl.style, normalLabelModel, {
        text: labels[dataIndex],
        textAlign: layoutInfo.labelAlign,
        textVerticalAlign: layoutInfo.labelBaseline
      });
      group.add(textEl);
      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
    }, this);
  },

  /**
   * @private
   */
  _renderControl: function (layoutInfo, group, axis, timelineModel) {
    var controlSize = layoutInfo.controlSize;
    var rotation = layoutInfo.rotation;
    var itemStyle = timelineModel.getModel('controlStyle.normal').getItemStyle();
    var hoverStyle = timelineModel.getModel('controlStyle.emphasis').getItemStyle();
    var rect = [0, -controlSize / 2, controlSize, controlSize];
    var playState = timelineModel.getPlayState();
    var inverse = timelineModel.get('inverse', true);
    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);

    function makeBtn(position, iconPath, onclick, willRotate) {
      if (!position) {
        return;
      }

      var opt = {
        position: position,
        origin: [controlSize / 2, 0],
        rotation: willRotate ? -rotation : 0,
        rectHover: true,
        style: itemStyle,
        onclick: onclick
      };
      var btn = makeIcon(timelineModel, iconPath, rect, opt);
      group.add(btn);
      graphic.setHoverStyle(btn, hoverStyle);
    }
  },
  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData();
    var currentIndex = timelineModel.getCurrentIndex();
    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
    var me = this;
    var callback = {
      onCreate: function (pointer) {
        pointer.draggable = true;
        pointer.drift = bind(me._handlePointerDrag, me);
        pointer.ondragend = bind(me._handlePointerDragend, me);
        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
      },
      onUpdate: function (pointer) {
        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
      }
    }; // Reuse when exists, for animation and drag.

    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
  },
  _handlePlayClick: function (nextState) {
    this._clearTimer();

    this.api.dispatchAction({
      type: 'timelinePlayChange',
      playState: nextState,
      from: this.uid
    });
  },
  _handlePointerDrag: function (dx, dy, e) {
    this._clearTimer();

    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
  },
  _handlePointerDragend: function (e) {
    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
  },
  _pointerChangeTimeline: function (mousePos, trigger) {
    var toCoord = this._toAxisCoord(mousePos)[0];

    var axis = this._axis;
    var axisExtent = numberUtil.asc(axis.getExtent().slice());
    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
    this._currentPointer.position[0] = toCoord;

    this._currentPointer.dirty();

    var targetDataIndex = this._findNearestTick(toCoord);

    var timelineModel = this.model;

    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
      this._changeTimeline(targetDataIndex);
    }
  },
  _doPlayStop: function () {
    this._clearTimer();

    if (this.model.getPlayState()) {
      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
    }

    function handleFrame() {
      // Do not cache
      var timelineModel = this.model;

      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
    }
  },
  _toAxisCoord: function (vertex) {
    var trans = this._mainGroup.getLocalTransform();

    return graphic.applyTransform(vertex, trans, true);
  },
  _findNearestTick: function (axisCoord) {
    var data = this.model.getData();
    var dist = Infinity;
    var targetDataIndex;
    var axis = this._axis;
    data.each(['value'], function (value, dataIndex) {
      var coord = axis.dataToCoord(value);
      var d = Math.abs(coord - axisCoord);

      if (d < dist) {
        dist = d;
        targetDataIndex = dataIndex;
      }
    });
    return targetDataIndex;
  },
  _clearTimer: function () {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  },
  _changeTimeline: function (nextIndex) {
    var currentIndex = this.model.getCurrentIndex();

    if (nextIndex === '+') {
      nextIndex = currentIndex + 1;
    } else if (nextIndex === '-') {
      nextIndex = currentIndex - 1;
    }

    this.api.dispatchAction({
      type: 'timelineChange',
      currentIndex: nextIndex,
      from: this.uid
    });
  }
});

function getViewRect(model, api) {
  return layout.getLayoutRect(model.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  }, model.get('padding'));
}

function makeIcon(timelineModel, objPath, rect, opts) {
  var icon = graphic.makePath(timelineModel.get(objPath).replace(/^path:\/\//, ''), zrUtil.clone(opts || {}), new BoundingRect(rect[0], rect[1], rect[2], rect[3]), 'center');
  return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */


function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
  var color = itemStyleModel.get('color');

  if (!symbol) {
    var symbolType = hostModel.get('symbol');
    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
    symbol.setStyle('strokeNoScale', true);
    group.add(symbol);
    callback && callback.onCreate(symbol);
  } else {
    symbol.setColor(color);
    group.add(symbol); // Group may be new, also need to add.

    callback && callback.onUpdate(symbol);
  } // Style


  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
  symbol.setStyle(itemStyle); // Transform and events.

  opt = zrUtil.merge({
    rectHover: true,
    z2: 100
  }, opt, true);
  var symbolSize = hostModel.get('symbolSize');
  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
  symbolSize[0] /= 2;
  symbolSize[1] /= 2;
  opt.scale = symbolSize;
  var symbolOffset = hostModel.get('symbolOffset');

  if (symbolOffset) {
    var pos = opt.position = opt.position || [0, 0];
    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
  }

  var symbolRotate = hostModel.get('symbolRotate');
  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  symbol.attr(opt); // FIXME
  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
  // getBoundingRect will return wrong result.
  // (This is supposed to be resolved in zrender, but it is a little difficult to
  // leverage performance and auto updateTransform)
  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.

  symbol.updateTransform();
  return symbol;
}

function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
  if (pointer.dragging) {
    return;
  }

  var pointerModel = timelineModel.getModel('checkpointStyle');
  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));

  if (noAnimation || !pointerModel.get('animation', true)) {
    pointer.attr({
      position: [toCoord, 0]
    });
  } else {
    pointer.stopAnimation(true);
    pointer.animateTo({
      position: [toCoord, 0]
    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
  }
}

module.exports = _default;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

var axisHelper = __webpack_require__(51);

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var TimelineAxis = function (dim, scale, coordExtent, axisType) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * @private
   * @type {number}
   */

  this._autoLabelInterval;
  /**
   * Axis model
   * @param {module:echarts/component/TimelineModel}
   */

  this.model = null;
};

TimelineAxis.prototype = {
  constructor: TimelineAxis,

  /**
   * @public
   * @return {number}
   */
  getLabelInterval: function () {
    var timelineModel = this.model;
    var labelModel = timelineModel.getModel('label.normal');
    var labelInterval = labelModel.get('interval');

    if (labelInterval != null && labelInterval != 'auto') {
      return labelInterval;
    }

    var labelInterval = this._autoLabelInterval;

    if (!labelInterval) {
      labelInterval = this._autoLabelInterval = axisHelper.getAxisLabelInterval(zrUtil.map(this.scale.getTicks(), this.dataToCoord, this), axisHelper.getFormattedLabels(this, labelModel.get('formatter')), labelModel.getFont(), timelineModel.get('orient') === 'horizontal' ? 0 : 90, labelModel.get('rotate'));
    }

    return labelInterval;
  },

  /**
   * If label is ignored.
   * Automatically used when axis is category and label can not be all shown
   * @public
   * @param  {number} idx
   * @return {boolean}
   */
  isLabelIgnored: function (idx) {
    if (this.type === 'category') {
      var labelInterval = this.getLabelInterval();
      return typeof labelInterval === 'function' && !labelInterval(idx, this.scale.getLabel(idx)) || idx % (labelInterval + 1);
    }
  }
};
zrUtil.inherits(TimelineAxis, Axis);
var _default = TimelineAxis;
module.exports = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var List = __webpack_require__(31);

var modelUtil = __webpack_require__(15);

var TimelineModel = ComponentModel.extend({
  type: 'timeline',
  layoutMode: 'box',

  /**
   * @protected
   */
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 4,
    // 二级层叠
    show: true,
    axisType: 'time',
    // 模式是时间类型，支持 value, category
    realtime: true,
    left: '20%',
    top: null,
    right: '20%',
    bottom: 0,
    width: null,
    height: 40,
    padding: 5,
    controlPosition: 'left',
    // 'left' 'right' 'top' 'bottom' 'none'
    autoPlay: false,
    rewind: false,
    // 反向播放
    loop: true,
    playInterval: 2000,
    // 播放时间间隔，单位ms
    currentIndex: 0,
    itemStyle: {
      normal: {},
      emphasis: {}
    },
    label: {
      normal: {
        color: '#000'
      },
      emphasis: {}
    },
    data: []
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel) {
    /**
     * @private
     * @type {module:echarts/data/List}
     */
    this._data;
    /**
     * @private
     * @type {Array.<string>}
     */

    this._names;
    this.mergeDefaultAndTheme(option, ecModel);

    this._initData();
  },

  /**
   * @override
   */
  mergeOption: function (option) {
    TimelineModel.superApply(this, 'mergeOption', arguments);

    this._initData();
  },

  /**
   * @param {number} [currentIndex]
   */
  setCurrentIndex: function (currentIndex) {
    if (currentIndex == null) {
      currentIndex = this.option.currentIndex;
    }

    var count = this._data.count();

    if (this.option.loop) {
      currentIndex = (currentIndex % count + count) % count;
    } else {
      currentIndex >= count && (currentIndex = count - 1);
      currentIndex < 0 && (currentIndex = 0);
    }

    this.option.currentIndex = currentIndex;
  },

  /**
   * @return {number} currentIndex
   */
  getCurrentIndex: function () {
    return this.option.currentIndex;
  },

  /**
   * @return {boolean}
   */
  isIndexMax: function () {
    return this.getCurrentIndex() >= this._data.count() - 1;
  },

  /**
   * @param {boolean} state true: play, false: stop
   */
  setPlayState: function (state) {
    this.option.autoPlay = !!state;
  },

  /**
   * @return {boolean} true: play, false: stop
   */
  getPlayState: function () {
    return !!this.option.autoPlay;
  },

  /**
   * @private
   */
  _initData: function () {
    var thisOption = this.option;
    var dataArr = thisOption.data || [];
    var axisType = thisOption.axisType;
    var names = this._names = [];

    if (axisType === 'category') {
      var idxArr = [];
      zrUtil.each(dataArr, function (item, index) {
        var value = modelUtil.getDataItemValue(item);
        var newItem;

        if (zrUtil.isObject(item)) {
          newItem = zrUtil.clone(item);
          newItem.value = index;
        } else {
          newItem = index;
        }

        idxArr.push(newItem);

        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
          value = '';
        }

        names.push(value + '');
      });
      dataArr = idxArr;
    }

    var dimType = {
      category: 'ordinal',
      time: 'time'
    }[axisType] || 'number';
    var data = this._data = new List([{
      name: 'value',
      type: dimType
    }], this);
    data.initData(dataArr, names);
  },
  getData: function () {
    return this._data;
  },

  /**
   * @public
   * @return {Array.<string>} categoreis
   */
  getCategories: function () {
    if (this.get('axisType') === 'category') {
      return this._names.slice();
    }
  }
});
var _default = TimelineModel;
module.exports = _default;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var ComponentView = __webpack_require__(286);

var _default = ComponentView.extend({
  type: 'timeline'
});

module.exports = _default;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function _default(option) {
  var timelineOpt = option && option.timeline;

  if (!zrUtil.isArray(timelineOpt)) {
    timelineOpt = timelineOpt ? [timelineOpt] : [];
  }

  zrUtil.each(timelineOpt, function (opt) {
    if (!opt) {
      return;
    }

    compatibleEC2(opt);
  });
}

function compatibleEC2(opt) {
  var type = opt.type;
  var ec2Types = {
    'number': 'value',
    'time': 'time'
  }; // Compatible with ec2

  if (ec2Types[type]) {
    opt.axisType = ec2Types[type];
    delete opt.type;
  }

  transferItem(opt);

  if (has(opt, 'controlPosition')) {
    var controlStyle = opt.controlStyle || (opt.controlStyle = {});

    if (!has(controlStyle, 'position')) {
      controlStyle.position = opt.controlPosition;
    }

    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
      controlStyle.show = false;
      delete controlStyle.position;
    }

    delete opt.controlPosition;
  }

  zrUtil.each(opt.data || [], function (dataItem) {
    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
        // In ec2, using name as value.
        dataItem.value = dataItem.name;
      }

      transferItem(dataItem);
    }
  });
}

function transferItem(opt) {
  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out

  var label = opt.label || opt.label || {};
  var labelNormal = label.normal || (label.normal = {});
  var excludeLabelAttr = {
    normal: 1,
    emphasis: 1
  };
  zrUtil.each(label, function (value, name) {
    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
      labelNormal[name] = value;
    }
  });

  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
    label.emphasis = itemStyleEmphasis.label;
    delete itemStyleEmphasis.label;
  }
}

function has(obj, attr) {
  return obj.hasOwnProperty(attr);
}

module.exports = _default;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

echarts.registerAction({
  type: 'timelineChange',
  event: 'timelineChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var timelineModel = ecModel.getComponent('timeline');

  if (timelineModel && payload.currentIndex != null) {
    timelineModel.setCurrentIndex(payload.currentIndex);

    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
      timelineModel.setPlayState(false);
    }
  } // Set normalized currentIndex to payload.


  ecModel.resetOption('timeline');
  return zrUtil.defaults({
    currentIndex: timelineModel.option.currentIndex
  }, payload);
});
echarts.registerAction({
  type: 'timelinePlayChange',
  event: 'timelinePlayChanged',
  update: 'update'
}, function (payload, ecModel) {
  var timelineModel = ecModel.getComponent('timeline');

  if (timelineModel && payload.playState != null) {
    timelineModel.setPlayState(payload.playState);
  }
});

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32);

Component.registerSubTypeDefaulter('timeline', function () {
  // Only slider now.
  return 'slider';
});

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var graphic = __webpack_require__(5);

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;
// Model
echarts.extendComponentModel({
  type: 'title',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 6,
    show: true,
    text: '',
    // 超链接跳转
    // link: null,
    // 仅支持self | blank
    target: 'blank',
    subtext: '',
    // 超链接跳转
    // sublink: null,
    // 仅支持self | blank
    subtarget: 'blank',
    // 'center' ¦ 'left' ¦ 'right'
    // ¦ {number}（x坐标，单位px）
    left: 0,
    // 'top' ¦ 'bottom' ¦ 'center'
    // ¦ {number}（y坐标，单位px）
    top: 0,
    // 水平对齐
    // 'auto' | 'left' | 'right' | 'center'
    // 默认根据 left 的位置判断是左对齐还是右对齐
    // textAlign: null
    //
    // 垂直对齐
    // 'auto' | 'top' | 'bottom' | 'middle'
    // 默认根据 top 位置判断是上对齐还是下对齐
    // textBaseline: null
    backgroundColor: 'rgba(0,0,0,0)',
    // 标题边框颜色
    borderColor: '#ccc',
    // 标题边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 标题内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 主副标题纵向间隔，单位px，默认为10，
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bolder',
      color: '#333'
    },
    subtextStyle: {
      color: '#aaa'
    }
  }
}); // View

echarts.extendComponentView({
  type: 'title',
  render: function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textBaseline = titleModel.get('textBaseline');
    var textEl = new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: titleModel.get('text'),
        textFill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new graphic.Text({
      style: graphic.setTextStyle({}, subtextStyleModel, {
        text: subText,
        textFill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        textVerticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    textEl.silent = !link;
    subTextEl.silent = !sublink;

    if (link) {
      textEl.on('click', function () {
        window.open(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        window.open(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = getLayoutRect(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right');

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textBaseline) {
      textBaseline = titleModel.get('top') || titleModel.get('bottom');

      if (textBaseline === 'center') {
        textBaseline = 'middle';
      }

      if (textBaseline === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textBaseline === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textBaseline = textBaseline || 'top';
    }

    group.attr('position', [layoutRect.x, layoutRect.y]);
    var alignStyle = {
      textAlign: textAlign,
      textVerticalAlign: textBaseline
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new graphic.Rect({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      silent: true
    });
    graphic.subPixelOptimizeRect(rect);
    group.add(rect);
  }
});

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1545);

__webpack_require__(1546);

__webpack_require__(1552);

__webpack_require__(1550);

__webpack_require__(1548);

__webpack_require__(1549);

__webpack_require__(1551);

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var featureManager = __webpack_require__(85);

var ToolboxModel = echarts.extendComponentModel({
  type: 'toolbox',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  mergeDefaultAndTheme: function (option) {
    ToolboxModel.superApply(this, 'mergeDefaultAndTheme', arguments);
    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
      var Feature = featureManager.get(featureName);
      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
    });
  },
  defaultOption: {
    show: true,
    z: 6,
    zlevel: 0,
    orient: 'horizontal',
    left: 'right',
    top: 'top',
    // right
    // bottom
    backgroundColor: 'transparent',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemSize: 15,
    itemGap: 8,
    showTitle: true,
    iconStyle: {
      normal: {
        borderColor: '#666',
        color: 'none'
      },
      emphasis: {
        borderColor: '#3E98C5'
      } // textStyle: {},
      // feature

    }
  }
});
var _default = ToolboxModel;
module.exports = _default;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var textContain = __webpack_require__(70);

var featureManager = __webpack_require__(85);

var graphic = __webpack_require__(5);

var Model = __webpack_require__(29);

var DataDiffer = __webpack_require__(117);

var listComponentHelper = __webpack_require__(466);

var _default = echarts.extendComponentView({
  type: 'toolbox',
  render: function (toolboxModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();

    if (!toolboxModel.get('show')) {
      return;
    }

    var itemSize = +toolboxModel.get('itemSize');
    var featureOpts = toolboxModel.get('feature') || {};
    var features = this._features || (this._features = {});
    var featureNames = [];
    zrUtil.each(featureOpts, function (opt, name) {
      featureNames.push(name);
    });
    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.

    this._featureNames = featureNames;

    function processFeature(newIndex, oldIndex) {
      var featureName = featureNames[newIndex];
      var oldName = featureNames[oldIndex];
      var featureOpt = featureOpts[featureName];
      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
      var feature;

      if (featureName && !oldName) {
        // Create
        if (isUserFeatureName(featureName)) {
          feature = {
            model: featureModel,
            onclick: featureModel.option.onclick,
            featureName: featureName
          };
        } else {
          var Feature = featureManager.get(featureName);

          if (!Feature) {
            return;
          }

          feature = new Feature(featureModel, ecModel, api);
        }

        features[featureName] = feature;
      } else {
        feature = features[oldName]; // If feature does not exsit.

        if (!feature) {
          return;
        }

        feature.model = featureModel;
        feature.ecModel = ecModel;
        feature.api = api;
      }

      if (!featureName && oldName) {
        feature.dispose && feature.dispose(ecModel, api);
        return;
      }

      if (!featureModel.get('show') || feature.unusable) {
        feature.remove && feature.remove(ecModel, api);
        return;
      }

      createIconPaths(featureModel, feature, featureName);

      featureModel.setIconStatus = function (iconName, status) {
        var option = this.option;
        var iconPaths = this.iconPaths;
        option.iconStatus = option.iconStatus || {};
        option.iconStatus[iconName] = status; // FIXME

        iconPaths[iconName] && iconPaths[iconName].trigger(status);
      };

      if (feature.render) {
        feature.render(featureModel, ecModel, api, payload);
      }
    }

    function createIconPaths(featureModel, feature, featureName) {
      var iconStyleModel = featureModel.getModel('iconStyle'); // If one feature has mutiple icon. they are orginaized as
      // {
      //     icon: {
      //         foo: '',
      //         bar: ''
      //     },
      //     title: {
      //         foo: '',
      //         bar: ''
      //     }
      // }

      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
      var titles = featureModel.get('title') || {};

      if (typeof icons === 'string') {
        var icon = icons;
        var title = titles;
        icons = {};
        titles = {};
        icons[featureName] = icon;
        titles[featureName] = title;
      }

      var iconPaths = featureModel.iconPaths = {};
      zrUtil.each(icons, function (iconStr, iconName) {
        var path = graphic.createIcon(iconStr, {}, {
          x: -itemSize / 2,
          y: -itemSize / 2,
          width: itemSize,
          height: itemSize
        });
        path.setStyle(iconStyleModel.getModel('normal').getItemStyle());
        path.hoverStyle = iconStyleModel.getModel('emphasis').getItemStyle();
        graphic.setHoverStyle(path);

        if (toolboxModel.get('showTitle')) {
          path.__title = titles[iconName];
          path.on('mouseover', function () {
            // Should not reuse above hoverStyle, which might be modified.
            var hoverStyle = iconStyleModel.getModel('emphasis').getItemStyle();
            path.setStyle({
              text: titles[iconName],
              textPosition: hoverStyle.textPosition || 'bottom',
              textFill: hoverStyle.fill || hoverStyle.stroke || '#000',
              textAlign: hoverStyle.textAlign || 'center'
            });
          }).on('mouseout', function () {
            path.setStyle({
              textFill: null
            });
          });
        }

        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
        group.add(path);
        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
        iconPaths[iconName] = path;
      });
    }

    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
    // FIXME

    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen

    group.eachChild(function (icon) {
      var titleText = icon.__title;
      var hoverStyle = icon.hoverStyle; // May be background element

      if (hoverStyle && titleText) {
        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
        var offsetX = icon.position[0] + group.position[0];
        var offsetY = icon.position[1] + group.position[1] + itemSize;
        var needPutOnTop = false;

        if (offsetY + rect.height > api.getHeight()) {
          hoverStyle.textPosition = 'top';
          needPutOnTop = true;
        }

        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;

        if (offsetX + rect.width / 2 > api.getWidth()) {
          hoverStyle.textPosition = ['100%', topOffset];
          hoverStyle.textAlign = 'right';
        } else if (offsetX - rect.width / 2 < 0) {
          hoverStyle.textPosition = [0, topOffset];
          hoverStyle.textAlign = 'left';
        }
      }
    });
  },
  updateView: function (toolboxModel, ecModel, api, payload) {
    zrUtil.each(this._features, function (feature) {
      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
    });
  },
  updateLayout: function (toolboxModel, ecModel, api, payload) {
    zrUtil.each(this._features, function (feature) {
      feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    });
  },
  remove: function (ecModel, api) {
    zrUtil.each(this._features, function (feature) {
      feature.remove && feature.remove(ecModel, api);
    });
    this.group.removeAll();
  },
  dispose: function (ecModel, api) {
    zrUtil.each(this._features, function (feature) {
      feature.dispose && feature.dispose(ecModel, api);
    });
  }
});

function isUserFeatureName(featureName) {
  return featureName.indexOf('my') === 0;
}

module.exports = _default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var featureManager = __webpack_require__(85);

var lang = __webpack_require__(118);

var brushLang = lang.toolbox.brush;

function Brush(model, ecModel, api) {
  this.model = model;
  this.ecModel = ecModel;
  this.api = api;
  /**
   * @private
   * @type {string}
   */

  this._brushType;
  /**
   * @private
   * @type {string}
   */

  this._brushMode;
}

Brush.defaultOption = {
  show: true,
  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
  icon: {
    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
    // jshint ignore:line
    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
    // jshint ignore:line
    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
    // jshint ignore:line
    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
    // jshint ignore:line
    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
    // jshint ignore:line
    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line

  },
  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
  title: zrUtil.clone(brushLang.title)
};
var proto = Brush.prototype;

proto.render = proto.updateView = proto.updateLayout = function (featureModel, ecModel, api) {
  var brushType;
  var brushMode;
  var isBrushed;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    brushType = brushModel.brushType;
    brushMode = brushModel.brushOption.brushMode || 'single';
    isBrushed |= brushModel.areas.length;
  });
  this._brushType = brushType;
  this._brushMode = brushMode;
  zrUtil.each(featureModel.get('type', true), function (type) {
    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
  });
};

proto.getIcons = function () {
  var model = this.model;
  var availableIcons = model.get('icon', true);
  var icons = {};
  zrUtil.each(model.get('type', true), function (type) {
    if (availableIcons[type]) {
      icons[type] = availableIcons[type];
    }
  });
  return icons;
};

proto.onclick = function (ecModel, api, type) {
  var brushType = this._brushType;
  var brushMode = this._brushMode;

  if (type === 'clear') {
    // Trigger parallel action firstly
    api.dispatchAction({
      type: 'axisAreaSelect',
      intervals: []
    });
    api.dispatchAction({
      type: 'brush',
      command: 'clear',
      // Clear all areas of all brush components.
      areas: []
    });
  } else {
    api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'brush',
      brushOption: {
        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
      }
    });
  }
};

featureManager.register('brush', Brush);
var _default = Brush;
module.exports = _default;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var eventTool = __webpack_require__(77);

var lang = __webpack_require__(118);

var featureManager = __webpack_require__(85);

var dataViewLang = lang.toolbox.dataView;
var BLOCK_SPLITER = new Array(60).join('-');
var ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 * @param {module:echarts/model/Global} ecModel
 * @return {Object}
 * @inner
 */

function groupSeries(ecModel) {
  var seriesGroupByCategoryAxis = {};
  var otherSeries = [];
  var meta = [];
  ecModel.eachRawSeries(function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
      var baseAxis = coordSys.getBaseAxis();

      if (baseAxis.type === 'category') {
        var key = baseAxis.dim + '_' + baseAxis.index;

        if (!seriesGroupByCategoryAxis[key]) {
          seriesGroupByCategoryAxis[key] = {
            categoryAxis: baseAxis,
            valueAxis: coordSys.getOtherAxis(baseAxis),
            series: []
          };
          meta.push({
            axisDim: baseAxis.dim,
            axisIndex: baseAxis.index
          });
        }

        seriesGroupByCategoryAxis[key].series.push(seriesModel);
      } else {
        otherSeries.push(seriesModel);
      }
    } else {
      otherSeries.push(seriesModel);
    }
  });
  return {
    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
    other: otherSeries,
    meta: meta
  };
}
/**
 * Assemble content of series on cateogory axis
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */


function assembleSeriesWithCategoryAxis(series) {
  var tables = [];
  zrUtil.each(series, function (group, key) {
    var categoryAxis = group.categoryAxis;
    var valueAxis = group.valueAxis;
    var valueAxisDim = valueAxis.dim;
    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
      return series.name;
    }));
    var columns = [categoryAxis.model.getCategories()];
    zrUtil.each(group.series, function (series) {
      columns.push(series.getRawData().mapArray(valueAxisDim, function (val) {
        return val;
      }));
    }); // Assemble table content

    var lines = [headers.join(ITEM_SPLITER)];

    for (var i = 0; i < columns[0].length; i++) {
      var items = [];

      for (var j = 0; j < columns.length; j++) {
        items.push(columns[j][i]);
      }

      lines.push(items.join(ITEM_SPLITER));
    }

    tables.push(lines.join('\n'));
  });
  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 * @param {Array.<module:echarts/model/Series>} series
 * @return {string}
 * @inner
 */


function assembleOtherSeries(series) {
  return zrUtil.map(series, function (series) {
    var data = series.getRawData();
    var lines = [series.name];
    var vals = [];
    data.each(data.dimensions, function () {
      var argLen = arguments.length;
      var dataIndex = arguments[argLen - 1];
      var name = data.getName(dataIndex);

      for (var i = 0; i < argLen - 1; i++) {
        vals[i] = arguments[i];
      }

      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
    });
    return lines.join('\n');
  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * @param {module:echarts/model/Global}
 * @return {Object}
 * @inner
 */


function getContentFromModel(ecModel) {
  var result = groupSeries(ecModel);
  return {
    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
      return str.replace(/[\n\t\s]/g, '');
    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
    meta: result.meta
  };
}

function trim(str) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */


function isTSVFormat(block) {
  // Simple method to find out if a block is tsv format
  var firstLine = block.slice(0, block.indexOf('\n'));

  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
    return true;
  }
}

var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */

function parseTSVContents(tsv) {
  var tsvLines = tsv.split(/\n+/g);
  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
  var categories = [];
  var series = zrUtil.map(headers, function (header) {
    return {
      name: header,
      data: []
    };
  });

  for (var i = 0; i < tsvLines.length; i++) {
    var items = trim(tsvLines[i]).split(itemSplitRegex);
    categories.push(items.shift());

    for (var j = 0; j < items.length; j++) {
      series[j] && (series[j].data[i] = items[j]);
    }
  }

  return {
    series: series,
    categories: categories
  };
}
/**
 * @param {string} str
 * @return {Array.<Object>}
 * @inner
 */


function parseListContents(str) {
  var lines = str.split(/\n+/g);
  var seriesName = trim(lines.shift());
  var data = [];

  for (var i = 0; i < lines.length; i++) {
    var items = trim(lines[i]).split(itemSplitRegex);
    var name = '';
    var value;
    var hasName = false;

    if (isNaN(items[0])) {
      // First item is name
      hasName = true;
      name = items[0];
      items = items.slice(1);
      data[i] = {
        name: name,
        value: []
      };
      value = data[i].value;
    } else {
      value = data[i] = [];
    }

    for (var j = 0; j < items.length; j++) {
      value.push(+items[j]);
    }

    if (value.length === 1) {
      hasName ? data[i].value = value[0] : data[i] = value[0];
    }
  }

  return {
    name: seriesName,
    data: data
  };
}
/**
 * @param {string} str
 * @param {Array.<Object>} blockMetaList
 * @return {Object}
 * @inner
 */


function parseContents(str, blockMetaList) {
  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
  var newOption = {
    series: []
  };
  zrUtil.each(blocks, function (block, idx) {
    if (isTSVFormat(block)) {
      var result = parseTSVContents(block);
      var blockMeta = blockMetaList[idx];
      var axisKey = blockMeta.axisDim + 'Axis';

      if (blockMeta) {
        newOption[axisKey] = newOption[axisKey] || [];
        newOption[axisKey][blockMeta.axisIndex] = {
          data: result.categories
        };
        newOption.series = newOption.series.concat(result.series);
      }
    } else {
      var result = parseListContents(block);
      newOption.series.push(result);
    }
  });
  return newOption;
}
/**
 * @alias {module:echarts/component/toolbox/feature/DataView}
 * @constructor
 * @param {module:echarts/model/Model} model
 */


function DataView(model) {
  this._dom = null;
  this.model = model;
}

DataView.defaultOption = {
  show: true,
  readOnly: false,
  optionToContent: null,
  contentToOption: null,
  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
  title: zrUtil.clone(dataViewLang.title),
  lang: zrUtil.clone(dataViewLang.lang),
  backgroundColor: '#fff',
  textColor: '#000',
  textareaColor: '#fff',
  textareaBorderColor: '#333',
  buttonColor: '#c23531',
  buttonTextColor: '#fff'
};

DataView.prototype.onclick = function (ecModel, api) {
  var container = api.getDom();
  var model = this.model;

  if (this._dom) {
    container.removeChild(this._dom);
  }

  var root = document.createElement('div');
  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements

  var header = document.createElement('h4');
  var lang = model.get('lang') || [];
  header.innerHTML = lang[0] || model.get('title');
  header.style.cssText = 'margin: 10px 20px;';
  header.style.color = model.get('textColor');
  var viewMain = document.createElement('div');
  var textarea = document.createElement('textarea');
  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
  var optionToContent = model.get('optionToContent');
  var contentToOption = model.get('contentToOption');
  var result = getContentFromModel(ecModel);

  if (typeof optionToContent === 'function') {
    var htmlOrDom = optionToContent(api.getOption());

    if (typeof htmlOrDom === 'string') {
      viewMain.innerHTML = htmlOrDom;
    } else if (zrUtil.isDom(htmlOrDom)) {
      viewMain.appendChild(htmlOrDom);
    }
  } else {
    // Use default textarea
    viewMain.appendChild(textarea);
    textarea.readOnly = model.get('readOnly');
    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
    textarea.style.color = model.get('textColor');
    textarea.style.borderColor = model.get('textareaBorderColor');
    textarea.style.backgroundColor = model.get('textareaColor');
    textarea.value = result.value;
  }

  var blockMetaList = result.meta;
  var buttonContainer = document.createElement('div');
  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
  var closeButton = document.createElement('div');
  var refreshButton = document.createElement('div');
  buttonStyle += ';background-color:' + model.get('buttonColor');
  buttonStyle += ';color:' + model.get('buttonTextColor');
  var self = this;

  function close() {
    container.removeChild(root);
    self._dom = null;
  }

  eventTool.addEventListener(closeButton, 'click', close);
  eventTool.addEventListener(refreshButton, 'click', function () {
    var newOption;

    try {
      if (typeof contentToOption === 'function') {
        newOption = contentToOption(viewMain, api.getOption());
      } else {
        newOption = parseContents(textarea.value, blockMetaList);
      }
    } catch (e) {
      close();
      throw new Error('Data view format error ' + e);
    }

    if (newOption) {
      api.dispatchAction({
        type: 'changeDataView',
        newOption: newOption
      });
    }

    close();
  });
  closeButton.innerHTML = lang[1];
  refreshButton.innerHTML = lang[2];
  refreshButton.style.cssText = buttonStyle;
  closeButton.style.cssText = buttonStyle;
  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
  buttonContainer.appendChild(closeButton); // http://stackoverflow.com/questions/6637341/use-tab-to-indent-in-textarea

  eventTool.addEventListener(textarea, 'keydown', function (e) {
    if ((e.keyCode || e.which) === 9) {
      // get caret position/selection
      var val = this.value;
      var start = this.selectionStart;
      var end = this.selectionEnd; // set textarea value to: text before caret + tab + text after caret

      this.value = val.substring(0, start) + ITEM_SPLITER + val.substring(end); // put caret at right position again

      this.selectionStart = this.selectionEnd = start + 1; // prevent the focus lose

      eventTool.stop(e);
    }
  });
  root.appendChild(header);
  root.appendChild(viewMain);
  root.appendChild(buttonContainer);
  viewMain.style.height = container.clientHeight - 80 + 'px';
  container.appendChild(root);
  this._dom = root;
};

DataView.prototype.remove = function (ecModel, api) {
  this._dom && api.getDom().removeChild(this._dom);
};

DataView.prototype.dispose = function (ecModel, api) {
  this.remove(ecModel, api);
};
/**
 * @inner
 */


function tryMergeDataOption(newData, originalData) {
  return zrUtil.map(newData, function (newVal, idx) {
    var original = originalData && originalData[idx];

    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
      if (zrUtil.isObject(newVal) && !zrUtil.isArray(newVal)) {
        newVal = newVal.value;
      } // Original data has option


      return zrUtil.defaults({
        value: newVal
      }, original);
    } else {
      return newVal;
    }
  });
}

featureManager.register('dataView', DataView);
echarts.registerAction({
  type: 'changeDataView',
  event: 'dataViewChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var newSeriesOptList = [];
  zrUtil.each(payload.newOption.series, function (seriesOpt) {
    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];

    if (!seriesModel) {
      // New created series
      // Geuss the series type
      newSeriesOptList.push(zrUtil.extend({
        // Default is scatter
        type: 'scatter'
      }, seriesOpt));
    } else {
      var originalData = seriesModel.get('data');
      newSeriesOptList.push({
        name: seriesOpt.name,
        data: tryMergeDataOption(seriesOpt.data, originalData)
      });
    }
  });
  ecModel.mergeOption(zrUtil.defaults({
    series: newSeriesOptList
  }, payload.newOption));
});
var _default = DataView;
module.exports = _default;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var BrushController = __webpack_require__(275);

var BrushTargetManager = __webpack_require__(462);

var history = __webpack_require__(460);

var sliderMove = __webpack_require__(145);

var lang = __webpack_require__(118);

var featureManager = __webpack_require__(85);

__webpack_require__(1508);

// Use dataZoomSelect
var dataZoomLang = lang.toolbox.dataZoom;
var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId

var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';

function DataZoom(model, ecModel, api) {
  /**
   * @private
   * @type {module:echarts/component/helper/BrushController}
   */
  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
  /**
   * @private
   * @type {boolean}
   */

  this._isZoomActive;
}

DataZoom.defaultOption = {
  show: true,
  // Icon group
  icon: {
    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
  },
  // `zoom`, `back`
  title: zrUtil.clone(dataZoomLang.title)
};
var proto = DataZoom.prototype;

proto.render = function (featureModel, ecModel, api, payload) {
  this.model = featureModel;
  this.ecModel = ecModel;
  this.api = api;
  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
  updateBackBtnStatus(featureModel, ecModel);
};

proto.onclick = function (ecModel, api, type) {
  handlers[type].call(this);
};

proto.remove = function (ecModel, api) {
  this._brushController.unmount();
};

proto.dispose = function (ecModel, api) {
  this._brushController.dispose();
};
/**
 * @private
 */


var handlers = {
  zoom: function () {
    var nextActive = !this._isZoomActive;
    this.api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'dataZoomSelect',
      dataZoomSelectActive: nextActive
    });
  },
  back: function () {
    this._dispatchZoomAction(history.pop(this.ecModel));
  }
};
/**
 * @private
 */

proto._onBrush = function (areas, opt) {
  if (!opt.isEnd || !areas.length) {
    return;
  }

  var snapshot = {};
  var ecModel = this.ecModel;

  this._brushController.updateCovers([]); // remove cover


  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
    include: ['grid']
  });
  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
    if (coordSys.type !== 'cartesian2d') {
      return;
    }

    var brushType = area.brushType;

    if (brushType === 'rect') {
      setBatch('x', coordSys, coordRange[0]);
      setBatch('y', coordSys, coordRange[1]);
    } else {
      setBatch({
        lineX: 'x',
        lineY: 'y'
      }[brushType], coordSys, coordRange);
    }
  });
  history.push(ecModel, snapshot);

  this._dispatchZoomAction(snapshot);

  function setBatch(dimName, coordSys, minMax) {
    var axis = coordSys.getAxis(dimName);
    var axisModel = axis.model;
    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();

    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
    }

    dataZoomModel && (snapshot[dataZoomModel.id] = {
      dataZoomId: dataZoomModel.id,
      startValue: minMax[0],
      endValue: minMax[1]
    });
  }

  function findDataZoom(dimName, axisModel, ecModel) {
    var found;
    ecModel.eachComponent({
      mainType: 'dataZoom',
      subType: 'select'
    }, function (dzModel) {
      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
      has && (found = dzModel);
    });
    return found;
  }
};
/**
 * @private
 */


proto._dispatchZoomAction = function (snapshot) {
  var batch = []; // Convert from hash map to array.

  each(snapshot, function (batchItem, dataZoomId) {
    batch.push(zrUtil.clone(batchItem));
  });
  batch.length && this.api.dispatchAction({
    type: 'dataZoom',
    from: this.uid,
    batch: batch
  });
};

function retrieveAxisSetting(option) {
  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.

  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
    setting[name] = option[name];
    setting[name] == null && (setting[name] = 'all');
    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
  });
  return setting;
}

function updateBackBtnStatus(featureModel, ecModel) {
  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
}

function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
  var zoomActive = view._isZoomActive;

  if (payload && payload.type === 'takeGlobalCursor') {
    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
  }

  view._isZoomActive = zoomActive;
  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
    include: ['grid']
  });

  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
  })).enableBrush(zoomActive ? {
    brushType: 'auto',
    brushStyle: {
      // FIXME user customized?
      lineWidth: 0,
      fill: 'rgba(0,0,0,0.2)'
    }
  } : false);
}

featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select

echarts.registerPreprocessor(function (option) {
  if (!option) {
    return;
  }

  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);

  if (!zrUtil.isArray(dataZoomOpts)) {
    option.dataZoom = dataZoomOpts = [dataZoomOpts];
  }

  var toolboxOpt = option.toolbox;

  if (toolboxOpt) {
    // Assume there is only one toolbox
    if (zrUtil.isArray(toolboxOpt)) {
      toolboxOpt = toolboxOpt[0];
    }

    if (toolboxOpt && toolboxOpt.feature) {
      var dataZoomOpt = toolboxOpt.feature.dataZoom;
      addForAxis('xAxis', dataZoomOpt);
      addForAxis('yAxis', dataZoomOpt);
    }
  }

  function addForAxis(axisName, dataZoomOpt) {
    if (!dataZoomOpt) {
      return;
    } // Try not to modify model, because it is not merged yet.


    var axisIndicesName = axisName + 'Index';
    var givenAxisIndices = dataZoomOpt[axisIndicesName];

    if (givenAxisIndices != null && givenAxisIndices != 'all' && !zrUtil.isArray(givenAxisIndices)) {
      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
    }

    forEachComponent(axisName, function (axisOpt, axisIndex) {
      if (givenAxisIndices != null && givenAxisIndices != 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
        return;
      }

      var newOpt = {
        type: 'select',
        $fromToolbox: true,
        // Id for merge mapping.
        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
      }; // FIXME
      // Only support one axis now.

      newOpt[axisIndicesName] = axisIndex;
      dataZoomOpts.push(newOpt);
    });
  }

  function forEachComponent(mainType, cb) {
    var opts = option[mainType];

    if (!zrUtil.isArray(opts)) {
      opts = opts ? [opts] : [];
    }

    each(opts, cb);
  }
});
var _default = DataZoom;
module.exports = _default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var lang = __webpack_require__(118);

var featureManager = __webpack_require__(85);

var magicTypeLang = lang.toolbox.magicType;

function MagicType(model) {
  this.model = model;
}

MagicType.defaultOption = {
  show: true,
  type: [],
  // Icon group
  icon: {
    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z',
    // jshint ignore:line
    tiled: 'M2.3,2.2h22.8V25H2.3V2.2z M35,2.2h22.8V25H35V2.2zM2.3,35h22.8v22.8H2.3V35z M35,35h22.8v22.8H35V35z'
  },
  // `line`, `bar`, `stack`, `tiled`
  title: zrUtil.clone(magicTypeLang.title),
  option: {},
  seriesIndex: {}
};
var proto = MagicType.prototype;

proto.getIcons = function () {
  var model = this.model;
  var availableIcons = model.get('icon');
  var icons = {};
  zrUtil.each(model.get('type'), function (type) {
    if (availableIcons[type]) {
      icons[type] = availableIcons[type];
    }
  });
  return icons;
};

var seriesOptGenreator = {
  'line': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'bar') {
      return zrUtil.merge({
        id: seriesId,
        type: 'line',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get('option.line') || {}, true);
    }
  },
  'bar': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line') {
      return zrUtil.merge({
        id: seriesId,
        type: 'bar',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get('option.bar') || {}, true);
    }
  },
  'stack': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line' || seriesType === 'bar') {
      return zrUtil.merge({
        id: seriesId,
        stack: '__ec_magicType_stack__'
      }, model.get('option.stack') || {}, true);
    }
  },
  'tiled': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line' || seriesType === 'bar') {
      return zrUtil.merge({
        id: seriesId,
        stack: ''
      }, model.get('option.tiled') || {}, true);
    }
  }
};
var radioTypes = [['line', 'bar'], ['stack', 'tiled']];

proto.onclick = function (ecModel, api, type) {
  var model = this.model;
  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType

  if (!seriesOptGenreator[type]) {
    return;
  }

  var newOption = {
    series: []
  };

  var generateNewSeriesTypes = function (seriesModel) {
    var seriesType = seriesModel.subType;
    var seriesId = seriesModel.id;
    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);

    if (newSeriesOpt) {
      // PENDING If merge original option?
      zrUtil.defaults(newSeriesOpt, seriesModel.option);
      newOption.series.push(newSeriesOpt);
    } // Modify boundaryGap


    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

      if (categoryAxis) {
        var axisDim = categoryAxis.dim;
        var axisType = axisDim + 'Axis';
        var axisModel = ecModel.queryComponents({
          mainType: axisType,
          index: seriesModel.get(name + 'Index'),
          id: seriesModel.get(name + 'Id')
        })[0];
        var axisIndex = axisModel.componentIndex;
        newOption[axisType] = newOption[axisType] || [];

        for (var i = 0; i <= axisIndex; i++) {
          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
        }

        newOption[axisType][axisIndex].boundaryGap = type === 'bar' ? true : false;
      }
    }
  };

  zrUtil.each(radioTypes, function (radio) {
    if (zrUtil.indexOf(radio, type) >= 0) {
      zrUtil.each(radio, function (item) {
        model.setIconStatus(item, 'normal');
      });
    }
  });
  model.setIconStatus(type, 'emphasis');
  ecModel.eachComponent({
    mainType: 'series',
    query: seriesIndex == null ? null : {
      seriesIndex: seriesIndex
    }
  }, generateNewSeriesTypes);
  api.dispatchAction({
    type: 'changeMagicType',
    currentType: type,
    newOption: newOption
  });
};

echarts.registerAction({
  type: 'changeMagicType',
  event: 'magicTypeChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.mergeOption(payload.newOption);
});
featureManager.register('magicType', MagicType);
var _default = MagicType;
module.exports = _default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var history = __webpack_require__(460);

var lang = __webpack_require__(118);

var featureManager = __webpack_require__(85);

var restoreLang = lang.toolbox.restore;

function Restore(model) {
  this.model = model;
}

Restore.defaultOption = {
  show: true,
  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
  title: restoreLang.title
};
var proto = Restore.prototype;

proto.onclick = function (ecModel, api, type) {
  history.clear(ecModel);
  api.dispatchAction({
    type: 'restore',
    from: this.uid
  });
};

featureManager.register('restore', Restore);
echarts.registerAction({
  type: 'restore',
  event: 'restore',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.resetOption('recreate');
});
var _default = Restore;
module.exports = _default;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(33);

var lang = __webpack_require__(118);

var featureManager = __webpack_require__(85);

var saveAsImageLang = lang.toolbox.saveAsImage;

function SaveAsImage(model) {
  this.model = model;
}

SaveAsImage.defaultOption = {
  show: true,
  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
  title: saveAsImageLang.title,
  type: 'png',
  // Default use option.backgroundColor
  // backgroundColor: '#fff',
  name: '',
  excludeComponents: ['toolbox'],
  pixelRatio: 1,
  lang: saveAsImageLang.lang.slice()
};
SaveAsImage.prototype.unusable = !env.canvasSupported;
var proto = SaveAsImage.prototype;

proto.onclick = function (ecModel, api) {
  var model = this.model;
  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
  var $a = document.createElement('a');
  var type = model.get('type', true) || 'png';
  $a.download = title + '.' + type;
  $a.target = '_blank';
  var url = api.getConnectedDataURL({
    type: type,
    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
    excludeComponents: model.get('excludeComponents'),
    pixelRatio: model.get('pixelRatio')
  });
  $a.href = url; // Chrome and Firefox

  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
    var evt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    $a.dispatchEvent(evt);
  } // IE
  else {
      if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(url.split(',')[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
      } else {
        var lang = model.get('lang');
        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
        var tab = window.open();
        tab.document.write(html);
      }
    }
};

featureManager.register('saveAsImage', SaveAsImage);
var _default = SaveAsImage;
module.exports = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(141);

__webpack_require__(1555);

__webpack_require__(1556);

// FIXME Better way to pack data in graphic element

/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */
echarts.registerAction({
  type: 'showTip',
  event: 'showTip',
  update: 'tooltip:manuallyShowTip'
}, // noop
function () {});
echarts.registerAction({
  type: 'hideTip',
  event: 'hideTip',
  update: 'tooltip:manuallyHideTip'
}, // noop
function () {});

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var zrColor = __webpack_require__(78);

var eventUtil = __webpack_require__(77);

var env = __webpack_require__(33);

var formatUtil = __webpack_require__(21);

var each = zrUtil.each;
var toCamelCase = formatUtil.toCamelCase;
var vendors = ['', '-webkit-', '-moz-', '-o-'];
var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
/**
 * @param {number} duration
 * @return {string}
 * @inner
 */

function assembleTransition(duration) {
  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
  return zrUtil.map(vendors, function (vendorPrefix) {
    return vendorPrefix + 'transition:' + transitionText;
  }).join(';');
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
  each(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}
/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */


function assembleCssText(tooltipModel) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.

  transitionDuration && cssText.push(assembleTransition(transitionDuration));

  if (backgroundColor) {
    if (env.canvasSupported) {
      cssText.push('background-Color:' + backgroundColor);
    } else {
      // for ie
      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
      cssText.push('filter:alpha(opacity=70)');
    }
  } // Border style


  each(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = toCamelCase(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
}
/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @constructor
 */


function TooltipContent(container, api) {
  var el = document.createElement('div');
  var zr = this._zr = api.getZr();
  this.el = el;
  this._x = api.getWidth() / 2;
  this._y = api.getHeight() / 2;
  container.appendChild(el);
  this._container = container;
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout;
  var self = this;

  el.onmouseenter = function () {
    // clear the timeout in hideLater and keep showing tooltip
    if (self._enterable) {
      clearTimeout(self._hideTimeout);
      self._show = true;
    }

    self._inContent = true;
  };

  el.onmousemove = function (e) {
    e = e || window.event;

    if (!self._enterable) {
      // Try trigger zrender event to avoid mouse
      // in and out shape too frequently
      var handler = zr.handler;
      eventUtil.normalizeEvent(container, e, true);
      handler.dispatch('mousemove', e);
    }
  };

  el.onmouseleave = function () {
    if (self._enterable) {
      if (self._show) {
        self.hideLater(self._hideDelay);
      }
    }

    self._inContent = false;
  };
}

TooltipContent.prototype = {
  constructor: TooltipContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function () {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
      domStyle.position = 'relative';
    } // Hide the tooltip
    // PENDING
    // this.hide();

  },
  show: function (tooltipModel) {
    clearTimeout(this._hideTimeout);
    var el = this.el;
    el.style.cssText = gCssText + assembleCssText(tooltipModel) // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
    + ';left:' + this._x + 'px;top:' + this._y + 'px;' + (tooltipModel.get('extraCssText') || '');
    el.style.display = el.innerHTML ? 'block' : 'none';
    this._show = true;
  },
  setContent: function (content) {
    this.el.innerHTML = content == null ? '' : content;
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var el = this.el;
    return [el.clientWidth, el.clientHeight];
  },
  moveTo: function (x, y) {
    // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.
    var zr = this._zr;
    var viewportRootOffset;

    if (zr && zr.painter && (viewportRootOffset = zr.painter.getViewportRootOffset())) {
      x += viewportRootOffset.offsetLeft;
      y += viewportRootOffset.offsetTop;
    }

    var style = this.el.style;
    style.left = x + 'px';
    style.top = y + 'px';
    this._x = x;
    this._y = y;
  },
  hide: function () {
    this.el.style.display = 'none';
    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  }
};
var _default = TooltipContent;
module.exports = _default;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var _default = echarts.extendComponentModel({
  type: 'tooltip',
  dependencies: ['axisPointer'],
  defaultOption: {
    zlevel: 0,
    z: 8,
    show: true,
    // tooltip主体内容
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    // 'single' | 'multipleByCoordSys'
    // 位置 {Array} | {Function}
    // position: null
    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
    // align: null,
    // verticalAlign: null,
    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
    confine: false,
    // 内容格式器：{string}（Template） ¦ {Function}
    // formatter: null
    showDelay: 0,
    // 隐藏延迟，单位ms
    hideDelay: 100,
    // 动画变换时间，单位s
    transitionDuration: 0.4,
    enterable: false,
    // 提示背景颜色，默认为透明度为0.7的黑色
    backgroundColor: 'rgba(50,50,50,0.7)',
    // 提示边框颜色
    borderColor: '#333',
    // 提示边框圆角，单位px，默认为4
    borderRadius: 4,
    // 提示边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 提示内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // Extra css text
    extraCssText: '',
    // 坐标轴指示器，坐标轴触发有效
    axisPointer: {
      // 默认为直线
      // 可选为：'line' | 'shadow' | 'cross'
      type: 'line',
      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // 默认 'auto'，会选择类型为 cateogry 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
      // 极坐标系会默认选择 angle 轴
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {} // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.

      }
    },
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  }
});

module.exports = _default;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var env = __webpack_require__(33);

var TooltipContent = __webpack_require__(1554);

var formatUtil = __webpack_require__(21);

var numberUtil = __webpack_require__(8);

var graphic = __webpack_require__(5);

var findPointFromSeries = __webpack_require__(456);

var layoutUtil = __webpack_require__(17);

var Model = __webpack_require__(29);

var globalListener = __webpack_require__(457);

var axisHelper = __webpack_require__(51);

var axisPointerViewHelper = __webpack_require__(190);

var bind = zrUtil.bind;
var each = zrUtil.each;
var parsePercent = numberUtil.parsePercent;
var proxyRect = new graphic.Rect({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var _default = echarts.extendComponentView({
  type: 'tooltip',
  init: function (ecModel, api) {
    if (env.node) {
      return;
    }

    var tooltipContent = new TooltipContent(api.getDom(), api);
    this._tooltipContent = tooltipContent;
  },
  render: function (tooltipModel, ecModel, api) {
    if (env.node) {
      return;
    } // Reset


    this.group.removeAll();
    /**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */

    this._tooltipModel = tooltipModel;
    /**
     * @private
     * @type {module:echarts/model/Global}
     */

    this._ecModel = ecModel;
    /**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */

    this._api = api;
    /**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */

    this._lastDataByCoordSys = null;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update();
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow();
  },
  _initGlobalListener: function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  },
  _keepShow: function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api; // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && tooltipModel.get('triggerOn') !== 'none') {
      var self = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        self.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self._lastX,
          y: self._lastY
        });
      });
    }
  },

  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */
  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || env.node) {
      return;
    }

    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;

    if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.position = [payload.x, payload.y];
      el.update();
      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        event: {},
        dataByCoordSys: payload.dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = findPointFromSeries(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          position: payload.position,
          target: pointInfo.el,
          event: {}
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target,
        event: {}
      }, dispatchAction);
    }
  },
  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction(payload, api));
    }
  },
  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.
  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex;
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);

    if (tooltipModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  },
  _tryShow: function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } // Always show item tooltip if mouse is on the element with dataIndex
    else if (el && el.dataIndex != null) {
        this._lastDataByCoordSys = null;

        this._showSeriesItemTooltip(e, el, dispatchAction);
      } // Tooltip provided directly. Like legend.
      else if (el && el.tooltip) {
          this._lastDataByCoordSys = null;

          this._showComponentItemTooltip(e, el, dispatchAction);
        } else {
          this._lastDataByCoordSys = null;

          this._hide(dispatchAction);
        }
  },
  _showOrMove: function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easyer to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = zrUtil.bind(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  },
  _showAxisTooltip: function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleDefaultHTML = [];
    var singleParamsList = [];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
    each(dataByCoordSys, function (itemCoordSys) {
      // var coordParamList = [];
      // var coordDefaultHTML = [];
      // var coordTooltipModel = buildTooltipModel([
      //     e.tooltipOption,
      //     itemCoordSys.tooltipOption,
      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
      //     globalTooltipModel
      // ]);
      // var displayMode = coordTooltipModel.get('displayMode');
      // var paramsList = displayMode === 'single' ? singleParamsList : [];
      each(itemCoordSys.dataByAxis, function (item) {
        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
        var axisValue = item.value;
        var seriesDefaultHTML = [];

        if (!axisModel || axisValue == null) {
          return;
        }

        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
        zrUtil.each(item.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var dataParams = series && series.getDataParams(dataIndex);
          dataParams.axisDim = item.axisDim;
          dataParams.axisIndex = item.axisIndex;
          dataParams.axisType = item.axisType;
          dataParams.axisId = item.axisId;
          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
          dataParams.axisValueLabel = valueLabel;

          if (dataParams) {
            singleParamsList.push(dataParams);
            seriesDefaultHTML.push(series.formatTooltip(dataIndex, true));
          }
        }); // Default tooltip content
        // FIXME
        // (1) shold be the first data which has name?
        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.

        var firstLine = valueLabel;
        singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + '<br />' : '') + seriesDefaultHTML.join('<br />'));
      });
    }, this); // In most case, the second axis is shown upper than the first one.

    singleDefaultHTML.reverse();
    singleDefaultHTML = singleDefaultHTML.join('<br /><br />');
    var positionExpr = e.position;

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  },
  _showSeriesItemTooltip: function (e, el, dispatchAction) {
    var ecModel = this._ecModel; // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = el.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = el.dataModel || seriesModel;
    var dataIndex = el.dataIndex;
    var dataType = el.dataType;
    var data = dataModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var defaultHtml = dataModel.formatTooltip(dataIndex, false, dataType);
    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  },
  _showComponentItemTooltip: function (e, el, dispatchAction) {
    var tooltipOpt = el.tooltip;

    if (typeof tooltipOpt === 'string') {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on cooridinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  },
  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    if (formatter && typeof formatter === 'string') {
      html = formatUtil.formatTpl(formatter, params, true);
    } else if (typeof formatter === 'function') {
      var callback = bind(function (cbTicket, html) {
        if (cbTicket === this._ticket) {
          tooltipContent.setContent(html);

          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        }
      }, this);
      this._ticket = asyncTicket;
      html = formatter(params, asyncTicket, callback);
    }

    tooltipContent.setContent(html);
    tooltipContent.show(tooltipModel);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  },

  /**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */
  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (typeof positionExpr === 'function') {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (zrUtil.isArray(positionExpr)) {
      x = parsePercent(positionExpr[0], viewWidth);
      y = parsePercent(positionExpr[1], viewHeight);
    } else if (zrUtil.isObject(positionExpr)) {
      positionExpr.width = contentSize[0];
      positionExpr.height = contentSize[1];
      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (typeof positionExpr === 'string' && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content.el, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (tooltipModel.get('confine')) {
      var pos = confineTooltipPosition(x, y, content.el, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  },
  // FIXME
  // Should we remove this but leave this to user?
  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
    var lastCoordSys = this._lastDataByCoordSys;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    return !!contentNotChanged;
  },
  _hide: function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  },
  dispose: function (ecModel, api) {
    if (env.node) {
      return;
    }

    this._tooltipContent.hide();

    globalListener.unregister('itemTooltip', api);
  }
});
/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade) {
  var resultModel = modelCascade.pop();

  while (modelCascade.length) {
    var tooltipOpt = modelCascade.pop();

    if (tooltipOpt) {
      if (tooltipOpt instanceof Model) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (typeof tooltipOpt === 'string') {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
    }
  }

  return resultModel;
}

function makeDispatchAction(payload, api) {
  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, el, viewWidth, viewHeight, gapH, gapV) {
  var size = getOuterSize(el);
  var width = size.width;
  var height = size.height;

  if (gapH != null) {
    if (x + width + gapH > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, el, viewWidth, viewHeight) {
  var size = getOuterSize(el);
  var width = size.width;
  var height = size.height;
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function getOuterSize(el) {
  var width = el.clientWidth;
  var height = el.clientHeight; // Consider browser compatibility.
  // IE8 does not support getComputedStyle.

  if (document.defaultView && document.defaultView.getComputedStyle) {
    var stl = document.defaultView.getComputedStyle(el);

    if (stl) {
      width += parseInt(stl.paddingLeft, 10) + parseInt(stl.paddingRight, 10) + parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
      height += parseInt(stl.paddingTop, 10) + parseInt(stl.paddingBottom, 10) + parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
    }
  }

  return {
    width: width,
    height: height
  };
}

function calcTooltipPosition(position, rect, contentSize) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var gap = 5;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - gap;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + gap;
      break;

    case 'left':
      x = rect.x - domWidth - gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}

module.exports = _default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1562);

__webpack_require__(1563);

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var VisualMapModel = __webpack_require__(472);

var numberUtil = __webpack_require__(8);

// Constant
var DEFAULT_BAR_BOUND = [20, 140];
var ContinuousModel = VisualMapModel.extend({
  type: 'visualMap.continuous',

  /**
   * @protected
   */
  defaultOption: {
    align: 'auto',
    // 'auto', 'left', 'right', 'top', 'bottom'
    calculable: false,
    // This prop effect default component type determine,
    // See echarts/component/visualMap/typeDefaulter.
    range: null,
    // selected range. In default case `range` is [min, max]
    // and can auto change along with modification of min max,
    // util use specifid a range.
    realtime: true,
    // Whether realtime update.
    itemHeight: null,
    // The length of the range control edge.
    itemWidth: null,
    // The length of the other side.
    hoverLink: true,
    // Enable hover highlight.
    hoverLinkDataSize: null,
    // The size of hovered data.
    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
    // If not specified, follow the value of `realtime`.

  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    ContinuousModel.superApply(this, 'optionUpdated', arguments);
    this.resetExtent();
    this.resetVisual(function (mappingOption) {
      mappingOption.mappingMethod = 'linear';
      mappingOption.dataExtent = this.getExtent();
    });

    this._resetRange();
  },

  /**
   * @protected
   * @override
   */
  resetItemSize: function () {
    ContinuousModel.superApply(this, 'resetItemSize', arguments);
    var itemSize = this.itemSize;
    this._orient === 'horizontal' && itemSize.reverse();
    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
  },

  /**
   * @private
   */
  _resetRange: function () {
    var dataExtent = this.getExtent();
    var range = this.option.range;

    if (!range || range.auto) {
      // `range` should always be array (so we dont use other
      // value like 'auto') for user-friend. (consider getOption).
      dataExtent.auto = 1;
      this.option.range = dataExtent;
    } else if (zrUtil.isArray(range)) {
      if (range[0] > range[1]) {
        range.reverse();
      }

      range[0] = Math.max(range[0], dataExtent[0]);
      range[1] = Math.min(range[1], dataExtent[1]);
    }
  },

  /**
   * @protected
   * @override
   */
  completeVisualOption: function () {
    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
    zrUtil.each(this.stateList, function (state) {
      var symbolSize = this.option.controller[state].symbolSize;

      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
        symbolSize[0] = 0; // For good looking.
      }
    }, this);
  },

  /**
   * @override
   */
  setSelected: function (selected) {
    this.option.range = selected.slice();

    this._resetRange();
  },

  /**
   * @public
   */
  getSelected: function () {
    var dataExtent = this.getExtent();
    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp

    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
    return dataInterval;
  },

  /**
   * @override
   */
  getValueState: function (value) {
    var range = this.option.range;
    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
    // range[1] is processed likewise.

    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
  },

  /**
   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */
  findTargetDataIndices: function (range) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimension(data), function (value, dataIndex) {
        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
      }, true, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  },

  /**
   * @implement
   */
  getVisualMeta: function (getColorVisual) {
    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
    var stops = [];

    function setStop(value, valueState) {
      stops.push({
        value: value,
        color: getColorVisual(value, valueState)
      });
    } // Format to: outOfRange -- inRange -- outOfRange.


    var iIdx = 0;
    var oIdx = 0;
    var iLen = iVals.length;
    var oLen = oVals.length;

    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
      if (oVals[oIdx] < iVals[iIdx]) {
        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
      // If range is full, value beyond min, max will be clamped.
      // make a singularity
      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
      setStop(iVals[iIdx], 'inRange');
    }

    for (var first = 1; oIdx < oLen; oIdx++) {
      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
        // make a singularity
        if (first) {
          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
          first = 0;
        }

        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    var stopsLen = stops.length;
    return {
      stops: stops,
      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
    };
  }
});

function getColorStopValues(visualMapModel, valueState, dataExtent) {
  if (dataExtent[0] === dataExtent[1]) {
    return dataExtent.slice();
  } // When using colorHue mapping, it is not linear color any more.
  // Moreover, canvas gradient seems not to be accurate linear.
  // FIXME
  // Should be arbitrary value 100? or based on pixel size?


  var count = 200;
  var step = (dataExtent[1] - dataExtent[0]) / count;
  var value = dataExtent[0];
  var stopValues = [];

  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
    stopValues.push(value);
    value += step;
  }

  stopValues.push(dataExtent[1]);
  return stopValues;
}

var _default = ContinuousModel;
module.exports = _default;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var LinearGradient = __webpack_require__(692);

var eventTool = __webpack_require__(77);

var VisualMapView = __webpack_require__(473);

var graphic = __webpack_require__(5);

var numberUtil = __webpack_require__(8);

var sliderMove = __webpack_require__(145);

var helper = __webpack_require__(474);

var modelUtil = __webpack_require__(15);

var linearMap = numberUtil.linearMap;
var each = zrUtil.each;
var mathMin = Math.min;
var mathMax = Math.max; // Arbitrary value

var HOVER_LINK_SIZE = 12;
var HOVER_LINK_OUT = 6; // Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.

var ContinuousView = VisualMapView.extend({
  type: 'visualMap.continuous',

  /**
   * @override
   */
  init: function () {
    ContinuousView.superApply(this, 'init', arguments);
    /**
     * @private
     */

    this._shapes = {};
    /**
     * @private
     */

    this._dataInterval = [];
    /**
     * @private
     */

    this._handleEnds = [];
    /**
     * @private
     */

    this._orient;
    /**
     * @private
     */

    this._useHandle;
    /**
     * @private
     */

    this._hoverLinkDataIndices = [];
    /**
     * @private
     */

    this._dragging;
    /**
     * @private
     */

    this._hovering;
  },

  /**
   * @protected
   * @override
   */
  doRender: function (visualMapModel, ecModel, api, payload) {
    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
      this._buildView();
    }
  },

  /**
   * @private
   */
  _buildView: function () {
    this.group.removeAll();
    var visualMapModel = this.visualMapModel;
    var thisGroup = this.group;
    this._orient = visualMapModel.get('orient');
    this._useHandle = visualMapModel.get('calculable');

    this._resetInterval();

    this._renderBar(thisGroup);

    var dataRangeText = visualMapModel.get('text');

    this._renderEndsText(thisGroup, dataRangeText, 0);

    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.


    this._updateView(true); // After updating view, inner shapes is built completely,
    // and then background can be rendered.


    this.renderBackground(thisGroup); // Real update view

    this._updateView();

    this._enableHoverLinkToSeries();

    this._enableHoverLinkFromSeries();

    this.positionGroup(thisGroup);
  },

  /**
   * @private
   */
  _renderEndsText: function (group, dataRangeText, endsIndex) {
    if (!dataRangeText) {
      return;
    } // Compatible with ec2, text[0] map to high value, text[1] map low value.


    var text = dataRangeText[1 - endsIndex];
    text = text != null ? text + '' : '';
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var itemSize = visualMapModel.itemSize;
    var barGroup = this._shapes.barGroup;

    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);

    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);

    var orient = this._orient;
    var textStyleModel = this.visualMapModel.textStyleModel;
    this.group.add(new graphic.Text({
      style: {
        x: position[0],
        y: position[1],
        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
        textAlign: orient === 'horizontal' ? align : 'center',
        text: text,
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    }));
  },

  /**
   * @private
   */
  _renderBar: function (targetGroup) {
    var visualMapModel = this.visualMapModel;
    var shapes = this._shapes;
    var itemSize = visualMapModel.itemSize;
    var orient = this._orient;
    var useHandle = this._useHandle;
    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);

    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar


    barGroup.add(shapes.outOfRange = createPolygon());
    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
    var textRect = visualMapModel.textStyleModel.getTextRect('国');
    var textSize = mathMax(textRect.width, textRect.height); // Handle

    if (useHandle) {
      shapes.handleThumbs = [];
      shapes.handleLabels = [];
      shapes.handleLabelPoints = [];

      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);

      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
    }

    this._createIndicator(barGroup, itemSize, textSize, orient);

    targetGroup.add(barGroup);
  },

  /**
   * @private
   */
  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
    handleThumb.position[0] = itemSize[0];
    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
    // transform (orient/inverse). So label is built separately but not
    // use zrender/graphic/helper/RectText, and is located based on view
    // group (according to handleLabelPoint) but not barGroup.

    var textStyleModel = this.visualMapModel.textStyleModel;
    var handleLabel = new graphic.Text({
      draggable: true,
      drift: onDrift,
      onmousemove: function (e) {
        // Fot mobile devicem, prevent screen slider on the button.
        eventTool.stop(e.event);
      },
      ondragend: onDragEnd,
      style: {
        x: 0,
        y: 0,
        text: '',
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    });
    this.group.add(handleLabel);
    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
    var shapes = this._shapes;
    shapes.handleThumbs[handleIndex] = handleThumb;
    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
    shapes.handleLabels[handleIndex] = handleLabel;
  },

  /**
   * @private
   */
  _createIndicator: function (barGroup, itemSize, textSize, orient) {
    var indicator = createPolygon([[0, 0]], 'move');
    indicator.position[0] = itemSize[0];
    indicator.attr({
      invisible: true,
      silent: true
    });
    barGroup.add(indicator);
    var textStyleModel = this.visualMapModel.textStyleModel;
    var indicatorLabel = new graphic.Text({
      silent: true,
      invisible: true,
      style: {
        x: 0,
        y: 0,
        text: '',
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    });
    this.group.add(indicatorLabel);
    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
    var shapes = this._shapes;
    shapes.indicator = indicator;
    shapes.indicatorLabel = indicatorLabel;
    shapes.indicatorLabelPoint = indicatorLabelPoint;
  },

  /**
   * @private
   */
  _dragHandle: function (handleIndex, isEnd, dx, dy) {
    if (!this._useHandle) {
      return;
    }

    this._dragging = !isEnd;

    if (!isEnd) {
      // Transform dx, dy to bar coordination.
      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);

      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
      // before dispatch action.


      this._updateView();
    } // dragEnd do not dispatch action when realtime.


    if (isEnd === !this.visualMapModel.get('realtime')) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'selectDataRange',
        from: this.uid,
        visualMapId: this.visualMapModel.id,
        selected: this._dataInterval.slice()
      });
    }

    if (isEnd) {
      !this._hovering && this._clearHoverLinkToSeries();
    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    }
  },

  /**
   * @private
   */
  _resetInterval: function () {
    var visualMapModel = this.visualMapModel;
    var dataInterval = this._dataInterval = visualMapModel.getSelected();
    var dataExtent = visualMapModel.getExtent();
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
  },

  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */
  _updateInterval: function (handleIndex, delta) {
    delta = delta || 0;
    var visualMapModel = this.visualMapModel;
    var handleEnds = this._handleEnds;
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
    0);
    var dataExtent = visualMapModel.getExtent(); // Update data interval.

    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
  },

  /**
   * @private
   */
  _updateView: function (forSketch) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var shapes = this._shapes;
    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;

    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');

    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');

    shapes.inRange.setStyle({
      fill: visualInRange.barColor,
      opacity: visualInRange.opacity
    }).setShape('points', visualInRange.barPoints);
    shapes.outOfRange.setStyle({
      fill: visualOutOfRange.barColor,
      opacity: visualOutOfRange.opacity
    }).setShape('points', visualOutOfRange.barPoints);

    this._updateHandle(inRangeHandleEnds, visualInRange);
  },

  /**
   * @private
   */
  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
    var opts = {
      forceState: forceState,
      convertOpacityToAlpha: true
    };

    var colorStops = this._makeColorGradient(dataInterval, opts);

    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];

    var barPoints = this._createBarPoints(handleEnds, symbolSizes);

    return {
      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
      barPoints: barPoints,
      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
    };
  },

  /**
   * @private
   */
  _makeColorGradient: function (dataInterval, opts) {
    // Considering colorHue, which is not linear, so we have to sample
    // to calculate gradient color stops, but not only caculate head
    // and tail.
    var sampleNumber = 100; // Arbitrary value.

    var colorStops = [];
    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
    colorStops.push({
      color: this.getControllerVisual(dataInterval[0], 'color', opts),
      offset: 0
    });

    for (var i = 1; i < sampleNumber; i++) {
      var currValue = dataInterval[0] + step * i;

      if (currValue > dataInterval[1]) {
        break;
      }

      colorStops.push({
        color: this.getControllerVisual(currValue, 'color', opts),
        offset: i / sampleNumber
      });
    }

    colorStops.push({
      color: this.getControllerVisual(dataInterval[1], 'color', opts),
      offset: 1
    });
    return colorStops;
  },

  /**
   * @private
   */
  _createBarPoints: function (handleEnds, symbolSizes) {
    var itemSize = this.visualMapModel.itemSize;
    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
  },

  /**
   * @private
   */
  _createBarGroup: function (itemAlign) {
    var orient = this._orient;
    var inverse = this.visualMapModel.get('inverse');
    return new graphic.Group(orient === 'horizontal' && !inverse ? {
      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
      rotation: Math.PI / 2
    } : orient === 'horizontal' && inverse ? {
      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
      rotation: -Math.PI / 2
    } : orient === 'vertical' && !inverse ? {
      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
    } : {
      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
    });
  },

  /**
   * @private
   */
  _updateHandle: function (handleEnds, visualInRange) {
    if (!this._useHandle) {
      return;
    }

    var shapes = this._shapes;
    var visualMapModel = this.visualMapModel;
    var handleThumbs = shapes.handleThumbs;
    var handleLabels = shapes.handleLabels;
    each([0, 1], function (handleIndex) {
      var handleThumb = handleThumbs[handleIndex];
      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.

      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
        textVerticalAlign: 'middle',
        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
      });
    }, this);
  },

  /**
   * @private
   * @param {number} cursorValue
   * @param {number} textValue
   * @param {string} [rangeSymbol]
   * @param {number} [halfHoverLinkSize]
   */
  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var itemSize = visualMapModel.itemSize;
    var sizeExtent = [0, itemSize[1]];
    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
    var shapes = this._shapes;
    var indicator = shapes.indicator;

    if (!indicator) {
      return;
    }

    indicator.position[1] = pos;
    indicator.attr('invisible', false);
    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
    var opts = {
      convertOpacityToAlpha: true
    };
    var color = this.getControllerVisual(cursorValue, 'color', opts);
    indicator.setStyle('fill', color); // Update handle label position.

    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
    var indicatorLabel = shapes.indicatorLabel;
    indicatorLabel.attr('invisible', false);

    var align = this._applyTransform('left', shapes.barGroup);

    var orient = this._orient;
    indicatorLabel.setStyle({
      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
      textAlign: orient === 'horizontal' ? 'center' : align,
      x: textPoint[0],
      y: textPoint[1]
    });
  },

  /**
   * @private
   */
  _enableHoverLinkToSeries: function () {
    var self = this;

    this._shapes.barGroup.on('mousemove', function (e) {
      self._hovering = true;

      if (!self._dragging) {
        var itemSize = self.visualMapModel.itemSize;

        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
        // below or upper than sizeExtent.


        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);

        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
      }
    }).on('mouseout', function () {
      // When mouse is out of handle, hoverLink still need
      // to be displayed when realtime is set as false.
      self._hovering = false;
      !self._dragging && self._clearHoverLinkToSeries();
    });
  },

  /**
   * @private
   */
  _enableHoverLinkFromSeries: function () {
    var zr = this.api.getZr();

    if (this.visualMapModel.option.hoverLink) {
      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
      zr.on('mouseout', this._hideIndicator, this);
    } else {
      this._clearHoverLinkFromSeries();
    }
  },

  /**
   * @private
   */
  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
    var visualMapModel = this.visualMapModel;
    var itemSize = visualMapModel.itemSize;

    if (!visualMapModel.option.hoverLink) {
      return;
    }

    var sizeExtent = [0, itemSize[1]];
    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.

    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
    // where china and india has very large population.

    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
    // otherwise labels overlap, especially when dragging.

    if (hoverOnBar) {
      if (valueRange[0] === -Infinity) {
        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
      } else if (valueRange[1] === Infinity) {
        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
      } else {
        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
      }
    } // When realtime is set as false, handles, which are in barGroup,
    // also trigger hoverLink, which help user to realize where they
    // focus on when dragging. (see test/heatmap-large.html)
    // When realtime is set as true, highlight will not show when hover
    // handle, because the label on handle, which displays a exact value
    // but not range, might mislead users.


    var oldBatch = this._hoverLinkDataIndices;
    var newBatch = [];

    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
    }

    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);

    this._dispatchHighDown('downplay', helper.convertDataIndex(resultBatches[0]));

    this._dispatchHighDown('highlight', helper.convertDataIndex(resultBatches[1]));
  },

  /**
   * @private
   */
  _hoverLinkFromSeriesMouseOver: function (e) {
    var el = e.target;
    var visualMapModel = this.visualMapModel;

    if (!el || el.dataIndex == null) {
      return;
    }

    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);

    if (!visualMapModel.isTargetSeries(dataModel)) {
      return;
    }

    var data = dataModel.getData(el.dataType);
    var dim = data.getDimension(visualMapModel.getDataDimension(data));
    var value = data.get(dim, el.dataIndex, true);

    if (!isNaN(value)) {
      this._showIndicator(value, value);
    }
  },

  /**
   * @private
   */
  _hideIndicator: function () {
    var shapes = this._shapes;
    shapes.indicator && shapes.indicator.attr('invisible', true);
    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
  },

  /**
   * @private
   */
  _clearHoverLinkToSeries: function () {
    this._hideIndicator();

    var indices = this._hoverLinkDataIndices;

    this._dispatchHighDown('downplay', helper.convertDataIndex(indices));

    indices.length = 0;
  },

  /**
   * @private
   */
  _clearHoverLinkFromSeries: function () {
    this._hideIndicator();

    var zr = this.api.getZr();
    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
    zr.off('mouseout', this._hideIndicator);
  },

  /**
   * @private
   */
  _applyTransform: function (vertex, element, inverse, global) {
    var transform = graphic.getTransform(element, global ? null : this.group);
    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
  },

  /**
   * @private
   */
  _dispatchHighDown: function (type, batch) {
    batch && batch.length && this.api.dispatchAction({
      type: type,
      batch: batch
    });
  },

  /**
   * @override
   */
  dispose: function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  },

  /**
   * @override
   */
  remove: function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  }
});

function createPolygon(points, cursor, onDrift, onDragEnd) {
  return new graphic.Polygon({
    shape: {
      points: points
    },
    draggable: !!onDrift,
    cursor: cursor,
    drift: onDrift,
    onmousemove: function (e) {
      // Fot mobile devicem, prevent screen slider on the button.
      eventTool.stop(e.event);
    },
    ondragend: onDragEnd
  });
}

function createHandlePoints(handleIndex, textSize) {
  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
}

function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
  return isRange ? [// indicate range
  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
  [0, 0], [5, -5], [5, 5]];
}

function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');

  if (hoverLinkDataSize) {
    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
  }

  return halfHoverLinkSize;
}

function useHoverLinkOnHandle(visualMapModel) {
  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

var _default = ContinuousView;
module.exports = _default;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var VisualMapModel = __webpack_require__(472);

var VisualMapping = __webpack_require__(105);

var visualDefault = __webpack_require__(491);

var _number = __webpack_require__(8);

var reformIntervals = _number.reformIntervals;
var PiecewiseModel = VisualMapModel.extend({
  type: 'visualMap.piecewise',

  /**
   * Order Rule:
   *
   * option.categories / option.pieces / option.text / option.selected:
   *     If !option.inverse,
   *     Order when vertical: ['top', ..., 'bottom'].
   *     Order when horizontal: ['left', ..., 'right'].
   *     If option.inverse, the meaning of
   *     the order should be reversed.
   *
   * this._pieceList:
   *     The order is always [low, ..., high].
   *
   * Mapping from location to low-high:
   *     If !option.inverse
   *     When vertical, top is high.
   *     When horizontal, right is high.
   *     If option.inverse, reverse.
   */

  /**
   * @protected
   */
  defaultOption: {
    selected: null,
    // Object. If not specified, means selected.
    // When pieces and splitNumber: {'0': true, '5': true}
    // When categories: {'cate1': false, 'cate3': true}
    // When selected === false, means all unselected.
    minOpen: false,
    // Whether include values that smaller than `min`.
    maxOpen: false,
    // Whether include values that bigger than `max`.
    align: 'auto',
    // 'auto', 'left', 'right'
    itemWidth: 20,
    // When put the controller vertically, it is the length of
    // horizontal side of each item. Otherwise, vertical side.
    itemHeight: 14,
    // When put the controller vertically, it is the length of
    // vertical side of each item. Otherwise, horizontal side.
    itemSymbol: 'roundRect',
    pieceList: null,
    // Each item is Object, with some of those attrs:
    // {min, max, lt, gt, lte, gte, value,
    // color, colorSaturation, colorAlpha, opacity,
    // symbol, symbolSize}, which customize the range or visual
    // coding of the certain piece. Besides, see "Order Rule".
    categories: null,
    // category names, like: ['some1', 'some2', 'some3'].
    // Attr min/max are ignored when categories set. See "Order Rule"
    splitNumber: 5,
    // If set to 5, auto split five pieces equally.
    // If set to 0 and component type not set, component type will be
    // determined as "continuous". (It is less reasonable but for ec2
    // compatibility, see echarts/component/visualMap/typeDefaulter)
    selectedMode: 'multiple',
    // Can be 'multiple' or 'single'.
    itemGap: 10,
    // The gap between two items, in px.
    hoverLink: true,
    // Enable hover highlight.
    showLabel: null // By default, when text is used, label will hide (the logic
    // is remained for compatibility reason)

  },

  /**
   * @override
   */
  optionUpdated: function (newOption, isInit) {
    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
    /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     * @private
     * @type {Array.<Object>}
     */

    this._pieceList = [];
    this.resetExtent();
    /**
     * 'pieces', 'categories', 'splitNumber'
     * @type {string}
     */

    var mode = this._mode = this._determineMode();

    resetMethods[this._mode].call(this);

    this._resetSelected(newOption, isInit);

    var categories = this.option.categories;
    this.resetVisual(function (mappingOption, state) {
      if (mode === 'categories') {
        mappingOption.mappingMethod = 'category';
        mappingOption.categories = zrUtil.clone(categories);
      } else {
        mappingOption.dataExtent = this.getExtent();
        mappingOption.mappingMethod = 'piecewise';
        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
          var piece = zrUtil.clone(piece);

          if (state !== 'inRange') {
            // FIXME
            // outOfRange do not support special visual in pieces.
            piece.visual = null;
          }

          return piece;
        });
      }
    });
  },

  /**
   * @protected
   * @override
   */
  completeVisualOption: function () {
    // Consider this case:
    // visualMap: {
    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
    // }
    // where no inRange/outOfRange set but only pieces. So we should make
    // default inRange/outOfRange for this case, otherwise visuals that only
    // appear in `pieces` will not be taken into account in visual encoding.
    var option = this.option;
    var visualTypesInPieces = {};
    var visualTypes = VisualMapping.listVisualTypes();
    var isCategory = this.isCategory();
    zrUtil.each(option.pieces, function (piece) {
      zrUtil.each(visualTypes, function (visualType) {
        if (piece.hasOwnProperty(visualType)) {
          visualTypesInPieces[visualType] = 1;
        }
      });
    });
    zrUtil.each(visualTypesInPieces, function (v, visualType) {
      var exists = 0;
      zrUtil.each(this.stateList, function (state) {
        exists |= has(option, state, visualType) || has(option.target, state, visualType);
      }, this);
      !exists && zrUtil.each(this.stateList, function (state) {
        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
      });
    }, this);

    function has(obj, state, visualType) {
      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
      );
    }

    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
  },
  _resetSelected: function (newOption, isInit) {
    var thisOption = this.option;
    var pieceList = this._pieceList; // Selected do not merge but all override.

    var selected = (isInit ? thisOption : newOption).selected || {};
    thisOption.selected = selected; // Consider 'not specified' means true.

    zrUtil.each(pieceList, function (piece, index) {
      var key = this.getSelectedMapKey(piece);

      if (!selected.hasOwnProperty(key)) {
        selected[key] = true;
      }
    }, this);

    if (thisOption.selectedMode === 'single') {
      // Ensure there is only one selected.
      var hasSel = false;
      zrUtil.each(pieceList, function (piece, index) {
        var key = this.getSelectedMapKey(piece);

        if (selected[key]) {
          hasSel ? selected[key] = false : hasSel = true;
        }
      }, this);
    } // thisOption.selectedMode === 'multiple', default: all selected.

  },

  /**
   * @public
   */
  getSelectedMapKey: function (piece) {
    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
  },

  /**
   * @public
   */
  getPieceList: function () {
    return this._pieceList;
  },

  /**
   * @private
   * @return {string}
   */
  _determineMode: function () {
    var option = this.option;
    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
  },

  /**
   * @public
   * @override
   */
  setSelected: function (selected) {
    this.option.selected = zrUtil.clone(selected);
  },

  /**
   * @public
   * @override
   */
  getValueState: function (value) {
    var index = VisualMapping.findPieceIndex(value, this._pieceList);
    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
  },

  /**
   * @public
   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
   */
  findTargetDataIndices: function (pieceIndex) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimension(data), function (value, dataIndex) {
        // Should always base on model pieceList, because it is order sensitive.
        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
        pIdx === pieceIndex && dataIndices.push(dataIndex);
      }, true, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  },

  /**
   * @private
   * @param {Object} piece piece.value or piece.interval is required.
   * @return {number} Can be Infinity or -Infinity
   */
  getRepresentValue: function (piece) {
    var representValue;

    if (this.isCategory()) {
      representValue = piece.value;
    } else {
      if (piece.value != null) {
        representValue = piece.value;
      } else {
        var pieceInterval = piece.interval || [];
        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
      }
    }

    return representValue;
  },
  getVisualMeta: function (getColorVisual) {
    // Do not support category. (category axis is ordinal, numerical)
    if (this.isCategory()) {
      return;
    }

    var stops = [];
    var outerColors = [];
    var visualMapModel = this;

    function setStop(interval, valueState) {
      var representValue = visualMapModel.getRepresentValue({
        interval: interval
      });

      if (!valueState) {
        valueState = visualMapModel.getValueState(representValue);
      }

      var color = getColorVisual(representValue, valueState);

      if (interval[0] === -Infinity) {
        outerColors[0] = color;
      } else if (interval[1] === Infinity) {
        outerColors[1] = color;
      } else {
        stops.push({
          value: interval[0],
          color: color
        }, {
          value: interval[1],
          color: color
        });
      }
    } // Suplement


    var pieceList = this._pieceList.slice();

    if (!pieceList.length) {
      pieceList.push({
        interval: [-Infinity, Infinity]
      });
    } else {
      var edge = pieceList[0].interval[0];
      edge !== -Infinity && pieceList.unshift({
        interval: [-Infinity, edge]
      });
      edge = pieceList[pieceList.length - 1].interval[1];
      edge !== Infinity && pieceList.push({
        interval: [edge, Infinity]
      });
    }

    var curr = -Infinity;
    zrUtil.each(pieceList, function (piece) {
      var interval = piece.interval;

      if (interval) {
        // Fulfill gap.
        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
        setStop(interval.slice());
        curr = interval[1];
      }
    }, this);
    return {
      stops: stops,
      outerColors: outerColors
    };
  }
});
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */

var resetMethods = {
  splitNumber: function () {
    var thisOption = this.option;
    var pieceList = this._pieceList;
    var precision = Math.min(thisOption.precision, 20);
    var dataExtent = this.getExtent();
    var splitNumber = thisOption.splitNumber;
    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
    thisOption.splitNumber = splitNumber;
    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption

    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
      precision++;
    }

    thisOption.precision = precision;
    splitStep = +splitStep.toFixed(precision);
    var index = 0;

    if (thisOption.minOpen) {
      pieceList.push({
        index: index++,
        interval: [-Infinity, dataExtent[0]],
        close: [0, 0]
      });
    }

    for (var curr = dataExtent[0], len = index + splitNumber; index < len; curr += splitStep) {
      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
      pieceList.push({
        index: index++,
        interval: [curr, max],
        close: [1, 1]
      });
    }

    if (thisOption.maxOpen) {
      pieceList.push({
        index: index++,
        interval: [dataExtent[1], Infinity],
        close: [0, 0]
      });
    }

    reformIntervals(pieceList);
    zrUtil.each(pieceList, function (piece) {
      piece.text = this.formatValueText(piece.interval);
    }, this);
  },
  categories: function () {
    var thisOption = this.option;
    zrUtil.each(thisOption.categories, function (cate) {
      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
      // 是否改一致。
      this._pieceList.push({
        text: this.formatValueText(cate, true),
        value: cate
      });
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, this._pieceList);
  },
  pieces: function () {
    var thisOption = this.option;
    var pieceList = this._pieceList;
    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
      if (!zrUtil.isObject(pieceListItem)) {
        pieceListItem = {
          value: pieceListItem
        };
      }

      var item = {
        text: '',
        index: index
      };

      if (pieceListItem.label != null) {
        item.text = pieceListItem.label;
      }

      if (pieceListItem.hasOwnProperty('value')) {
        var value = item.value = pieceListItem.value;
        item.interval = [value, value];
        item.close = [1, 1];
      } else {
        // `min` `max` is legacy option.
        // `lt` `gt` `lte` `gte` is recommanded.
        var interval = item.interval = [];
        var close = item.close = [0, 0];
        var closeList = [1, 0, 1];
        var infinityList = [-Infinity, Infinity];
        var useMinMax = [];

        for (var lg = 0; lg < 2; lg++) {
          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];

          for (var i = 0; i < 3 && interval[lg] == null; i++) {
            interval[lg] = pieceListItem[names[i]];
            close[lg] = closeList[i];
            useMinMax[lg] = i === 2;
          }

          interval[lg] == null && (interval[lg] = infinityList[lg]);
        }

        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);

        if (interval[0] === interval[1] && close[0] && close[1]) {
          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
          // we use value to lift the priority when min === max
          item.value = interval[0];
        }
      }

      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
      pieceList.push(item);
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, pieceList); // Only pieces

    reformIntervals(pieceList);
    zrUtil.each(pieceList, function (piece) {
      var close = piece.close;
      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
    }, this);
  }
};

function normalizeReverse(thisOption, pieceList) {
  var inverse = thisOption.inverse;

  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
    pieceList.reverse();
  }
}

var _default = PiecewiseModel;
module.exports = _default;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var VisualMapView = __webpack_require__(473);

var graphic = __webpack_require__(5);

var _symbol = __webpack_require__(52);

var createSymbol = _symbol.createSymbol;

var layout = __webpack_require__(17);

var helper = __webpack_require__(474);

var PiecewiseVisualMapView = VisualMapView.extend({
  type: 'visualMap.piecewise',

  /**
   * @protected
   * @override
   */
  doRender: function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var textStyleModel = visualMapModel.textStyleModel;
    var textFont = textStyleModel.getFont();
    var textFill = textStyleModel.getTextColor();

    var itemAlign = this._getItemAlign();

    var itemSize = visualMapModel.itemSize;

    var viewData = this._getViewData();

    var endsText = viewData.endsText;
    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
    zrUtil.each(viewData.viewPieceList, renderItem, this);
    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
    this.renderBackground(thisGroup);
    this.positionGroup(thisGroup);

    function renderItem(item) {
      var piece = item.piece;
      var itemGroup = new graphic.Group();
      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);

      this._enableHoverLink(itemGroup, item.indexInModelPieceList);

      var representValue = visualMapModel.getRepresentValue(piece);

      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);

      if (showLabel) {
        var visualState = this.visualMapModel.getValueState(representValue);
        itemGroup.add(new graphic.Text({
          style: {
            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
            y: itemSize[1] / 2,
            text: piece.text,
            textVerticalAlign: 'middle',
            textAlign: itemAlign,
            textFont: textFont,
            textFill: textFill,
            opacity: visualState === 'outOfRange' ? 0.5 : 1
          }
        }));
      }

      thisGroup.add(itemGroup);
    }
  },

  /**
   * @private
   */
  _enableHoverLink: function (itemGroup, pieceIndex) {
    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));

    function onHoverLink(method) {
      var visualMapModel = this.visualMapModel;
      visualMapModel.option.hoverLink && this.api.dispatchAction({
        type: method,
        batch: helper.convertDataIndex(visualMapModel.findTargetDataIndices(pieceIndex))
      });
    }
  },

  /**
   * @private
   */
  _getItemAlign: function () {
    var visualMapModel = this.visualMapModel;
    var modelOption = visualMapModel.option;

    if (modelOption.orient === 'vertical') {
      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
    } else {
      // horizontal, most case left unless specifying right.
      var align = modelOption.align;

      if (!align || align === 'auto') {
        align = 'left';
      }

      return align;
    }
  },

  /**
   * @private
   */
  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
    if (!text) {
      return;
    }

    var itemGroup = new graphic.Group();
    var textStyleModel = this.visualMapModel.textStyleModel;
    itemGroup.add(new graphic.Text({
      style: {
        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
        y: itemSize[1] / 2,
        textVerticalAlign: 'middle',
        textAlign: showLabel ? itemAlign : 'center',
        text: text,
        textFont: textStyleModel.getFont(),
        textFill: textStyleModel.getTextColor()
      }
    }));
    group.add(itemGroup);
  },

  /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */
  _getViewData: function () {
    var visualMapModel = this.visualMapModel;
    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
      return {
        piece: piece,
        indexInModelPieceList: index
      };
    });
    var endsText = visualMapModel.get('text'); // Consider orient and inverse.

    var orient = visualMapModel.get('orient');
    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]

    if (orient === 'horizontal' ? inverse : !inverse) {
      viewPieceList.reverse();
    } // Origin order of endsText is [high, low]
    else if (endsText) {
        endsText = endsText.slice().reverse();
      }

    return {
      viewPieceList: viewPieceList,
      endsText: endsText
    };
  },

  /**
   * @private
   */
  _createItemSymbol: function (group, representValue, shapeParam) {
    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
  },

  /**
   * @private
   */
  _onItemClick: function (piece) {
    var visualMapModel = this.visualMapModel;
    var option = visualMapModel.option;
    var selected = zrUtil.clone(option.selected);
    var newKey = visualMapModel.getSelectedMapKey(piece);

    if (option.selectedMode === 'single') {
      selected[newKey] = true;
      zrUtil.each(selected, function (o, key) {
        selected[key] = key === newKey;
      });
    } else {
      selected[newKey] = !selected[newKey];
    }

    this.api.dispatchAction({
      type: 'selectDataRange',
      from: this.uid,
      visualMapId: this.visualMapModel.id,
      selected: selected
    });
  }
});
var _default = PiecewiseVisualMapView;
module.exports = _default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var preprocessor = __webpack_require__(475);

__webpack_require__(476);

__webpack_require__(477);

__webpack_require__(1558);

__webpack_require__(1559);

__webpack_require__(478);

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var preprocessor = __webpack_require__(475);

__webpack_require__(476);

__webpack_require__(477);

__webpack_require__(1560);

__webpack_require__(1561);

__webpack_require__(478);

/**
 * DataZoom component entry
 */
echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var layout = __webpack_require__(17);

var numberUtil = __webpack_require__(8);

var CoordinateSystem = __webpack_require__(66);

// (24*60*60*1000)
var PROXIMATE_ONE_DAY = 86400000;
/**
 * Calendar
 *
 * @constructor
 *
 * @param {Object} calendarModel calendarModel
 * @param {Object} ecModel       ecModel
 * @param {Object} api           api
 */

function Calendar(calendarModel, ecModel, api) {
  this._model = calendarModel;
}

Calendar.prototype = {
  constructor: Calendar,
  type: 'calendar',
  dimensions: ['time', 'value'],
  // Required in createListFromData
  getDimensionsInfo: function () {
    return [{
      name: 'time',
      type: 'time'
    }];
  },
  getRangeInfo: function () {
    return this._rangeInfo;
  },
  getModel: function () {
    return this._model;
  },
  getRect: function () {
    return this._rect;
  },
  getCellWidth: function () {
    return this._sw;
  },
  getCellHeight: function () {
    return this._sh;
  },
  getOrient: function () {
    return this._orient;
  },

  /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */
  getFirstDayOfWeek: function () {
    return this._firstDayOfWeek;
  },

  /**
   * get date info
   *
   * @param  {string|number} date date
   * @return {Object}
   * {
   *      y: string, local full year, eg., '1940',
   *      m: string, local month, from '01' ot '12',
   *      d: string, local date, from '01' to '31' (if exists),
   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
   *      time: timestamp,
   *      formatedDate: string, yyyy-MM-dd,
   *      date: original date object.
   * }
   */
  getDateInfo: function (date) {
    date = numberUtil.parseDate(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    var day = date.getDay();
    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
    return {
      y: y,
      m: m,
      d: d,
      day: day,
      time: date.getTime(),
      formatedDate: y + '-' + m + '-' + d,
      date: date
    };
  },
  getNextNDay: function (date, n) {
    n = n || 0;

    if (n === 0) {
      return this.getDateInfo(date);
    }

    date = new Date(this.getDateInfo(date).time);
    date.setDate(date.getDate() + n);
    return this.getDateInfo(date);
  },
  update: function (ecModel, api) {
    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
    this._orient = this._model.get('orient');
    this._lineWidth = this._model.getModel('itemStyle.normal').getItemStyle().lineWidth || 0;
    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
    var weeks = this._rangeInfo.weeks || 1;
    var whNames = ['width', 'height'];

    var cellSize = this._model.get('cellSize').slice();

    var layoutParams = this._model.getBoxLayoutParams();

    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
    zrUtil.each([0, 1], function (idx) {
      if (cellSizeSpecified(cellSize, idx)) {
        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
      }
    });
    var whGlobal = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
    zrUtil.each([0, 1], function (idx) {
      if (!cellSizeSpecified(cellSize, idx)) {
        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
      }
    });

    function cellSizeSpecified(cellSize, idx) {
      return cellSize[idx] != null && cellSize[idx] !== 'auto';
    }

    this._sw = cellSize[0];
    this._sh = cellSize[1];
  },

  /**
   * Convert a time data(time, value) item to (x, y) point.
   *
   * @override
   * @param  {Array|number} data data
   * @param  {boolean} [clamp=true] out of range
   * @return {Array} point
   */
  dataToPoint: function (data, clamp) {
    zrUtil.isArray(data) && (data = data[0]);
    clamp == null && (clamp = true);
    var dayInfo = this.getDateInfo(data);
    var range = this._rangeInfo;
    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]

    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time <= range.end.time)) {
      return [NaN, NaN];
    }

    var week = dayInfo.day;

    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;

    if (this._orient === 'vertical') {
      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
    }

    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
  },

  /**
   * Convert a (x, y) point to time data
   *
   * @override
   * @param  {string} point point
   * @return {string}       data
   */
  pointToData: function (point) {
    var date = this.pointToDate(point);
    return date && date.time;
  },

  /**
   * Convert a time date item to (x, y) four point.
   *
   * @param  {Array} data  date[0] is date
   * @param  {boolean} [clamp=true]  out of range
   * @return {Object}       point
   */
  dataToRect: function (data, clamp) {
    var point = this.dataToPoint(data, clamp);
    return {
      contentShape: {
        x: point[0] - (this._sw - this._lineWidth) / 2,
        y: point[1] - (this._sh - this._lineWidth) / 2,
        width: this._sw - this._lineWidth,
        height: this._sh - this._lineWidth
      },
      center: point,
      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
    };
  },

  /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */
  pointToDate: function (point) {
    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
    var range = this._rangeInfo.range;

    if (this._orient === 'vertical') {
      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
    }

    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
  },

  /**
   * @inheritDoc
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @inheritDoc
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),

  /**
   * initRange
   *
   * @private
   * @return {Array} [start, end]
   */
  _initRangeOption: function () {
    var range = this._model.get('range');

    var rg = range;

    if (zrUtil.isArray(rg) && rg.length === 1) {
      rg = rg[0];
    }

    if (/^\d{4}$/.test(rg)) {
      range = [rg + '-01-01', rg + '-12-31'];
    }

    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
      var start = this.getDateInfo(rg);
      var firstDay = start.date;
      firstDay.setMonth(firstDay.getMonth() + 1);
      var end = this.getNextNDay(firstDay, -1);
      range = [start.formatedDate, end.formatedDate];
    }

    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
      range = [rg, rg];
    }

    var tmp = this._getRangeInfo(range);

    if (tmp.start.time > tmp.end.time) {
      range.reverse();
    }

    return range;
  },

  /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */
  _getRangeInfo: function (range) {
    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
    var reversed;

    if (range[0].time > range[1].time) {
      reversed = true;
      range.reverse();
    }

    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case:
    // Firstly set system timezone as "Time Zone: America/Toronto",
    // ```
    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
    // var second = new Date(1478412000000);
    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
    // ```
    // will get wrong result because of DST. So we should fix it.

    var date = new Date(range[0].time);
    var startDateNum = date.getDate();
    var endDateNum = range[1].date.getDate();
    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.

    if (date.getDate() !== endDateNum) {
      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;

      while (date.getDate() !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
        allDay -= sign;
        date.setDate(startDateNum + allDay - 1);
      }
    }

    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
    reversed && range.reverse();
    return {
      range: [range[0].formatedDate, range[1].formatedDate],
      start: range[0],
      end: range[1],
      allDay: allDay,
      weeks: weeks,
      // From 0.
      nthWeek: nthWeek,
      fweek: range[0].day,
      lweek: range[1].day
    };
  },

  /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */
  _getDateByWeeksAndDay: function (nthWeek, day, range) {
    var rangeInfo = this._getRangeInfo(range);

    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
      return false;
    }

    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
    var date = new Date(rangeInfo.start.time);
    date.setDate(rangeInfo.start.d + nthDay);
    return this.getDateInfo(date);
  }
};
Calendar.dimensions = Calendar.prototype.dimensions;
Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;

Calendar.create = function (ecModel, api) {
  var calendarList = [];
  ecModel.eachComponent('calendar', function (calendarModel) {
    var calendar = new Calendar(calendarModel, ecModel, api);
    calendarList.push(calendar);
    calendarModel.coordinateSystem = calendar;
  });
  ecModel.eachSeries(function (calendarSeries) {
    if (calendarSeries.get('coordinateSystem') === 'calendar') {
      // Inject coordinate system
      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
    }
  });
  return calendarList;
};

function doConvert(methodName, ecModel, finder, value) {
  var calendarModel = finder.calendarModel;
  var seriesModel = finder.seriesModel;
  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
  return coordSys === this ? coordSys[methodName](value) : null;
}

CoordinateSystem.register('calendar', Calendar);
var _default = Calendar;
module.exports = _default;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var _layout = __webpack_require__(17);

var getLayoutParams = _layout.getLayoutParams;
var sizeCalculable = _layout.sizeCalculable;
var mergeLayoutParam = _layout.mergeLayoutParam;
var CalendarModel = ComponentModel.extend({
  type: 'calendar',

  /**
   * @type {module:echarts/coord/calendar/Calendar}
   */
  coordinateSystem: null,
  defaultOption: {
    zlevel: 0,
    z: 2,
    left: 80,
    top: 60,
    cellSize: 20,
    // horizontal vertical
    orient: 'horizontal',
    // month separate line style
    splitLine: {
      show: true,
      lineStyle: {
        color: '#000',
        width: 1,
        type: 'solid'
      }
    },
    // rect style  temporarily unused emphasis
    itemStyle: {
      normal: {
        color: '#fff',
        borderWidth: 1,
        borderColor: '#ccc'
      }
    },
    // week text style
    dayLabel: {
      show: true,
      // a week first day
      firstDay: 0,
      // start end
      position: 'start',
      margin: '50%',
      // 50% of cellSize
      nameMap: 'en',
      color: '#000'
    },
    // month text style
    monthLabel: {
      show: true,
      // start end
      position: 'start',
      margin: 5,
      // center or left
      align: 'center',
      // cn en []
      nameMap: 'en',
      formatter: null,
      color: '#000'
    },
    // year text style
    yearLabel: {
      show: true,
      // top bottom left right
      position: null,
      margin: 30,
      formatter: null,
      color: '#ccc',
      fontFamily: 'sans-serif',
      fontWeight: 'bolder',
      fontSize: 20
    }
  },

  /**
   * @override
   */
  init: function (option, parentModel, ecModel, extraOpt) {
    var inputPositionParams = getLayoutParams(option);
    CalendarModel.superApply(this, 'init', arguments);
    mergeAndNormalizeLayoutParams(option, inputPositionParams);
  },

  /**
   * @override
   */
  mergeOption: function (option, extraOpt) {
    CalendarModel.superApply(this, 'mergeOption', arguments);
    mergeAndNormalizeLayoutParams(this.option, option);
  }
});

function mergeAndNormalizeLayoutParams(target, raw) {
  // Normalize cellSize
  var cellSize = target.cellSize;

  if (!zrUtil.isArray(cellSize)) {
    cellSize = target.cellSize = [cellSize, cellSize];
  } else if (cellSize.length === 1) {
    cellSize[1] = cellSize[0];
  }

  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
    // If user have set `width` or both `left` and `right`, cellSize
    // will be automatically set to 'auto', otherwise the default
    // setting of cellSize will make `width` setting not work.
    if (sizeCalculable(raw, hvIdx)) {
      cellSize[hvIdx] = 'auto';
    }

    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
  });
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

var _default = CalendarModel;
module.exports = _default;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function _default(coordSys) {
  var rect = coordSys.getRect();
  var rangeInfo = coordSys.getRangeInfo();
  return {
    coordSys: {
      type: 'calendar',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      cellWidth: coordSys.getCellWidth(),
      cellHeight: coordSys.getCellHeight(),
      rangeInfo: {
        start: rangeInfo.start,
        end: rangeInfo.end,
        weeks: rangeInfo.weeks,
        dayCount: rangeInfo.allDay
      }
    },
    api: {
      coord: zrUtil.bind(coordSys.dataToPoint, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var Axis2D = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */

  this.position = position || 'bottom';
};

Axis2D.prototype = {
  constructor: Axis2D,

  /**
   * Index of axis, can be used as key
   */
  index: 0,

  /**
   * If axis is on the zero position of the other axis
   * @type {boolean}
   */
  onZero: false,

  /**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */
  model: null,
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */
  getGlobalExtent: function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  },
  getOtherAxis: function () {
    this.grid.getOtherAxis();
  },

  /**
   * If label is ignored.
   * Automatically used when axis is category and label can not be all shown
   * @param  {number}  idx
   * @return {boolean}
   */
  isLabelIgnored: function (idx) {
    if (this.type === 'category') {
      var labelInterval = this.getLabelInterval();
      return typeof labelInterval === 'function' && !labelInterval(idx, this.scale.getLabel(idx)) || idx % (labelInterval + 1);
    }
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  },

  /**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toLocalCoord: null,

  /**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toGlobalCoord: null
};
zrUtil.inherits(Axis2D, Axis);
var _default = Axis2D;
module.exports = _default;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */
function dimAxisMapper(dim) {
  return this._axes[dim];
}
/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */


var Cartesian = function (name) {
  this._axes = {};
  this._dimList = [];
  /**
   * @type {string}
   */

  this.name = name || '';
};

Cartesian.prototype = {
  constructor: Cartesian,
  type: 'cartesian',

  /**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */
  getAxis: function (dim) {
    return this._axes[dim];
  },

  /**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */
  getAxes: function () {
    return zrUtil.map(this._dimList, dimAxisMapper, this);
  },

  /**
   * Get axes list by given scale type
   */
  getAxesByScale: function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return zrUtil.filter(this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  },

  /**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */
  addAxis: function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  },

  /**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  dataToCoord: function (val) {
    return this._dataCoordConvert(val, 'dataToCoord');
  },

  /**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  coordToData: function (val) {
    return this._dataCoordConvert(val, 'coordToData');
  },
  _dataCoordConvert: function (input, method) {
    var dimList = this._dimList;
    var output = input instanceof Array ? [] : {};

    for (var i = 0; i < dimList.length; i++) {
      var dim = dimList[i];
      var axis = this._axes[dim];
      output[dim] = axis[method](input[dim]);
    }

    return output;
  }
};
var _default = Cartesian;
module.exports = _default;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Cartesian = __webpack_require__(1568);

function Cartesian2D(name) {
  Cartesian.call(this, name);
}

Cartesian2D.prototype = {
  constructor: Cartesian2D,
  type: 'cartesian2d',

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  },

  /**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  },

  /**
   * @param {Array.<number>} data
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, clamp) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    return [xAxis.toGlobalCoord(xAxis.dataToCoord(data[0], clamp)), yAxis.toGlobalCoord(yAxis.dataToCoord(data[1], clamp))];
  },

  /**
   * @param {Array.<number>} point
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  pointToData: function (point, clamp) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    return [xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp), yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp)];
  },

  /**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */
  getOtherAxis: function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  }
};
zrUtil.inherits(Cartesian2D, Cartesian);
var _default = Cartesian2D;
module.exports = _default;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(481);

var ComponentModel = __webpack_require__(32);

// Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
var _default = ComponentModel.extend({
  type: 'grid',
  dependencies: ['xAxis', 'yAxis'],
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/cartesian/Grid}
   */
  coordinateSystem: null,
  defaultOption: {
    show: false,
    zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 60,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  }
});

module.exports = _default;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
    var axis = this.getAxis(dim);
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
  }, this);
}

function _default(coordSys) {
  var rect = coordSys.grid.getRect();
  return {
    coordSys: {
      // The name exposed to user is always 'cartesian2d' but not 'grid'.
      type: 'cartesian2d',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var BoundingRect = __webpack_require__(26);

var parseGeoJson = __webpack_require__(483);

var View = __webpack_require__(479);

var fixNanhai = __webpack_require__(1576);

var fixTextCoord = __webpack_require__(1577);

var fixGeoCoord = __webpack_require__(1575);

var fixDiaoyuIsland = __webpack_require__(1574);

// Geo fix functions
var geoFixFuncs = [fixNanhai, fixTextCoord, fixGeoCoord, fixDiaoyuIsland];
/**
 * [Geo description]
 * @param {string} name Geo name
 * @param {string} map Map type
 * @param {Object} geoJson
 * @param {Object} [specialAreas]
 *        Specify the positioned areas by left, top, width, height
 * @param {Object.<string, string>} [nameMap]
 *        Specify name alias
 */

function Geo(name, map, geoJson, specialAreas, nameMap) {
  View.call(this, name);
  /**
   * Map type
   * @type {string}
   */

  this.map = map;
  this._nameCoordMap = zrUtil.createHashMap();
  this.loadGeoJson(geoJson, specialAreas, nameMap);
}

Geo.prototype = {
  constructor: Geo,
  type: 'geo',

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['lng', 'lat'],

  /**
   * If contain given lng,lat coord
   * @param {Array.<number>}
   * @readOnly
   */
  containCoord: function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      if (regions[i].contain(coord)) {
        return true;
      }
    }

    return false;
  },

  /**
   * @param {Object} geoJson
   * @param {Object} [specialAreas]
   *        Specify the positioned areas by left, top, width, height
   * @param {Object.<string, string>} [nameMap]
   *        Specify name alias
   */
  loadGeoJson: function (geoJson, specialAreas, nameMap) {
    // https://jsperf.com/try-catch-performance-overhead
    try {
      this.regions = geoJson ? parseGeoJson(geoJson) : [];
    } catch (e) {
      throw 'Invalid geoJson format\n' + e.message;
    }

    specialAreas = specialAreas || {};
    nameMap = nameMap || {};
    var regions = this.regions;
    var regionsMap = zrUtil.createHashMap();

    for (var i = 0; i < regions.length; i++) {
      var regionName = regions[i].name; // Try use the alias in nameMap

      regionName = nameMap.hasOwnProperty(regionName) ? nameMap[regionName] : regionName;
      regions[i].name = regionName;
      regionsMap.set(regionName, regions[i]); // Add geoJson

      this.addGeoCoord(regionName, regions[i].center); // Some area like Alaska in USA map needs to be tansformed
      // to look better

      var specialArea = specialAreas[regionName];

      if (specialArea) {
        regions[i].transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
      }
    }

    this._regionsMap = regionsMap;
    this._rect = null;
    zrUtil.each(geoFixFuncs, function (fixFunc) {
      fixFunc(this);
    }, this);
  },
  // Overwrite
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    rect = rect.clone(); // Longitute is inverted

    rect.y = -rect.y - rect.height;
    var viewTransform = this._viewTransform;
    viewTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    viewTransform.decomposeTransform();
    var scale = viewTransform.scale;
    scale[1] = -scale[1];
    viewTransform.updateTransform();

    this._updateTransform();
  },

  /**
   * @param {string} name
   * @return {module:echarts/coord/geo/Region}
   */
  getRegion: function (name) {
    return this._regionsMap.get(name);
  },
  getRegionByCoord: function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      if (regions[i].contain(coord)) {
        return regions[i];
      }
    }
  },

  /**
   * Add geoCoord for indexing by name
   * @param {string} name
   * @param {Array.<number>} geoCoord
   */
  addGeoCoord: function (name, geoCoord) {
    this._nameCoordMap.set(name, geoCoord);
  },

  /**
   * Get geoCoord by name
   * @param {string} name
   * @return {Array.<number>}
   */
  getGeoCoord: function (name) {
    return this._nameCoordMap.get(name);
  },
  // Overwrite
  getBoundingRect: function () {
    if (this._rect) {
      return this._rect;
    }

    var rect;
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      var regionRect = regions[i].getBoundingRect();
      rect = rect || regionRect.clone();
      rect.union(regionRect);
    } // FIXME Always return new ?


    return this._rect = rect || new BoundingRect(0, 0, 0, 0);
  },

  /**
   * @param {string|Array.<number>} data
   * @return {Array.<number>}
   */
  dataToPoint: function (data) {
    if (typeof data === 'string') {
      // Map area name to geoCoord
      data = this.getGeoCoord(data);
    }

    if (data) {
      return View.prototype.dataToPoint.call(this, data);
    }
  },

  /**
   * @inheritDoc
   */
  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),

  /**
   * @inheritDoc
   */
  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
};
zrUtil.mixin(Geo, View);

function doConvert(methodName, ecModel, finder, value) {
  var geoModel = finder.geoModel;
  var seriesModel = finder.seriesModel;
  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
  return coordSys === this ? coordSys[methodName](value) : null;
}

var _default = Geo;
module.exports = _default;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var ComponentModel = __webpack_require__(32);

var Model = __webpack_require__(29);

var selectableMixin = __webpack_require__(277);

var geoCreator = __webpack_require__(193);

var GeoModel = ComponentModel.extend({
  type: 'geo',

  /**
   * @type {module:echarts/coord/geo/Geo}
   */
  coordinateSystem: null,
  layoutMode: 'box',
  init: function (option) {
    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option.label, ['show']);
  },
  optionUpdated: function () {
    var option = this.option;
    var self = this;
    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
      if (regionOpt.name) {
        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
      }

      return optionModelMap;
    }, zrUtil.createHashMap());
    this.updateSelectedMap(option.regions);
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    show: true,
    left: 'center',
    top: 'center',
    // width:,
    // height:,
    // right
    // bottom
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    aspectScale: 0.75,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    silent: false,
    // Map type
    map: '',
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ]
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    // selectedMode: false
    label: {
      normal: {
        show: false,
        color: '#000'
      },
      emphasis: {
        show: true,
        color: 'rgb(100,0,0)'
      }
    },
    itemStyle: {
      normal: {
        // color: 各异,
        borderWidth: 0.5,
        borderColor: '#444',
        color: '#eee'
      },
      emphasis: {
        // 也是选中样式
        color: 'rgba(255,215,0,0.8)'
      }
    },
    regions: []
  },

  /**
   * Get model of region
   * @param  {string} name
   * @return {module:echarts/model/Model}
   */
  getRegionModel: function (name) {
    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
  },

  /**
   * Format label
   * @param {string} name Region name
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @return {string}
   */
  getFormattedLabel: function (name, status) {
    var regionModel = this.getRegionModel(name);
    var formatter = regionModel.get('label.' + status + '.formatter');
    var params = {
      name: name
    };

    if (typeof formatter === 'function') {
      params.status = status;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      return formatter.replace('{a}', name != null ? name : '');
    }
  },
  setZoom: function (zoom) {
    this.option.zoom = zoom;
  },
  setCenter: function (center) {
    this.option.center = center;
  }
});
zrUtil.mixin(GeoModel, selectableMixin);
var _default = GeoModel;
module.exports = _default;

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

// Fix for 钓鱼岛
// var Region = require('../Region');
// var zrUtil = require('zrender/src/core/util');
// var geoCoord = [126, 25];
var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];

function _default(geo) {
  if (geo.map === 'china') {
    for (var i = 0, len = geo.regions.length; i < len; ++i) {
      if (geo.regions[i].name === '台湾') {
        geo.regions[i].geometries.push({
          type: 'polygon',
          exterior: points[0]
        });
      }
    }
  }
}

module.exports = _default;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var geoCoordMap = {
  'Russia': [100, 60],
  'United States': [-99, 38],
  'United States of America': [-99, 38]
};

function _default(geo) {
  zrUtil.each(geo.regions, function (region) {
    var geoCoord = geoCoordMap[region.name];

    if (geoCoord) {
      var cp = region.center;
      cp[0] = geoCoord[0];
      cp[1] = geoCoord[1];
    }
  });
}

module.exports = _default;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Region = __webpack_require__(482);

// Fix for 南海诸岛
var geoCoord = [126, 25];
var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];

for (var i = 0; i < points.length; i++) {
  for (var k = 0; k < points[i].length; k++) {
    points[i][k][0] /= 10.5;
    points[i][k][1] /= -10.5 / 0.75;
    points[i][k][0] += geoCoord[0];
    points[i][k][1] += geoCoord[1];
  }
}

function _default(geo) {
  if (geo.map === 'china') {
    geo.regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
      return {
        type: 'polygon',
        exterior: exterior
      };
    }), geoCoord));
  }
}

module.exports = _default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var coordsOffsetMap = {
  '南海诸岛': [32, 80],
  // 全国
  '广东': [0, -10],
  '香港': [10, 5],
  '澳门': [-10, 10],
  //'北京': [-10, 0],
  '天津': [5, 5]
};

function _default(geo) {
  zrUtil.each(geo.regions, function (region) {
    var coordFix = coordsOffsetMap[region.name];

    if (coordFix) {
      var cp = region.center;
      cp[0] += coordFix[0] / 10.5;
      cp[1] += -coordFix[1] / (10.5 / 0.75);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function dataToCoordSize(dataSize, dataItem) {
  dataItem = dataItem || [0, 0];
  return zrUtil.map([0, 1], function (dimIdx) {
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var p1 = [];
    var p2 = [];
    p1[dimIdx] = val - halfSize;
    p2[dimIdx] = val + halfSize;
    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
  }, this);
}

function _default(coordSys) {
  var rect = coordSys.getBoundingRect();
  return {
    coordSys: {
      type: 'geo',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var makeStyleMapper = __webpack_require__(119);

var axisModelCreator = __webpack_require__(192);

var numberUtil = __webpack_require__(8);

var axisModelCommonMixin = __webpack_require__(116);

var AxisModel = ComponentModel.extend({
  type: 'baseParallelAxis',

  /**
   * @type {module:echarts/coord/parallel/Axis}
   */
  axis: null,

  /**
   * @type {Array.<Array.<number>}
   * @readOnly
   */
  activeIntervals: [],

  /**
   * @return {Object}
   */
  getAreaSelectStyle: function () {
    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
  },

  /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param {Array.<Array<number>>} intervals interval.length === 0
   *                                          means set all active.
   * @public
   */
  setActiveIntervals: function (intervals) {
    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize

    if (activeIntervals) {
      for (var i = activeIntervals.length - 1; i >= 0; i--) {
        numberUtil.asc(activeIntervals[i]);
      }
    }
  },

  /**
   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
   *                         value can not be input.
   * @return {string} 'normal': no activeIntervals set,
   *                  'active',
   *                  'inactive'.
   * @public
   */
  getActiveState: function (value) {
    var activeIntervals = this.activeIntervals;

    if (!activeIntervals.length) {
      return 'normal';
    }

    if (value == null) {
      return 'inactive';
    }

    for (var i = 0, len = activeIntervals.length; i < len; i++) {
      if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
        return 'active';
      }
    }

    return 'inactive';
  }
});
var defaultOption = {
  type: 'value',

  /**
   * @type {Array.<number>}
   */
  dim: null,
  // 0, 1, 2, ...
  // parallelIndex: null,
  areaSelectStyle: {
    width: 20,
    borderWidth: 1,
    borderColor: 'rgba(160,197,232)',
    color: 'rgba(160,197,232)',
    opacity: 0.3
  },
  realtime: true,
  // Whether realtime update view when select.
  z: 10
};
zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);

function getAxisType(axisName, option) {
  return option.type || (option.data ? 'category' : 'value');
}

axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var matrix = __webpack_require__(53);

var layoutUtil = __webpack_require__(17);

var axisHelper = __webpack_require__(51);

var ParallelAxis = __webpack_require__(1581);

var graphic = __webpack_require__(5);

var numberUtil = __webpack_require__(8);

var sliderMove = __webpack_require__(145);

/**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */
var each = zrUtil.each;
var mathMin = Math.min;
var mathMax = Math.max;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var round = numberUtil.round;
var PI = Math.PI;

function Parallel(parallelModel, ecModel, api) {
  /**
   * key: dimension
   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
   * @private
   */
  this._axesMap = zrUtil.createHashMap();
  /**
   * key: dimension
   * value: {position: [], rotation, }
   * @type {Object.<string, Object>}
   * @private
   */

  this._axesLayout = {};
  /**
   * Always follow axis order.
   * @type {Array.<string>}
   * @readOnly
   */

  this.dimensions = parallelModel.dimensions;
  /**
   * @type {module:zrender/core/BoundingRect}
   */

  this._rect;
  /**
   * @type {module:echarts/coord/parallel/ParallelModel}
   */

  this._model = parallelModel;

  this._init(parallelModel, ecModel, api);
}

Parallel.prototype = {
  type: 'parallel',
  constructor: Parallel,

  /**
   * Initialize cartesian coordinate systems
   * @private
   */
  _init: function (parallelModel, ecModel, api) {
    var dimensions = parallelModel.dimensions;
    var parallelAxisIndex = parallelModel.parallelAxisIndex;
    each(dimensions, function (dim, idx) {
      var axisIndex = parallelAxisIndex[idx];
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);

      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));

      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Injection

      axisModel.axis = axis;
      axis.model = axisModel;
      axis.coordinateSystem = axisModel.coordinateSystem = this;
    }, this);
  },

  /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  update: function (ecModel, api) {
    this._updateAxesFromSeries(this._model, ecModel);
  },

  /**
   * @override
   */
  containPoint: function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var axisBase = layoutInfo.axisBase;
    var layoutBase = layoutInfo.layoutBase;
    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var pAxis = point[1 - pixelDimIndex];
    var pLayout = point[pixelDimIndex];
    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
  },
  getModel: function () {
    return this._model;
  },

  /**
   * Update properties from series
   * @private
   */
  _updateAxesFromSeries: function (parallelModel, ecModel) {
    ecModel.eachSeries(function (seriesModel) {
      if (!parallelModel.contains(seriesModel, ecModel)) {
        return;
      }

      var data = seriesModel.getData();
      each(this.dimensions, function (dim) {
        var axis = this._axesMap.get(dim);

        axis.scale.unionExtentFromData(data, dim);
        axisHelper.niceScaleExtent(axis.scale, axis.model);
      }, this);
    }, this);
  },

  /**
   * Resize the parallel coordinate system.
   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
   * @param {module:echarts/ExtensionAPI} api
   */
  resize: function (parallelModel, api) {
    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._layoutAxes();
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getRect: function () {
    return this._rect;
  },

  /**
   * @private
   */
  _makeLayoutInfo: function () {
    var parallelModel = this._model;
    var rect = this._rect;
    var xy = ['x', 'y'];
    var wh = ['width', 'height'];
    var layout = parallelModel.get('layout');
    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
    var layoutLength = rect[wh[pixelDimIndex]];
    var layoutExtent = [0, layoutLength];
    var axisCount = this.dimensions.length;
    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
    // where collapsed axes should be overlapped.

    var axisExpandWindow = parallelModel.get('axisExpandWindow');
    var winSize;

    if (!axisExpandWindow) {
      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    } else {
      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    }

    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.

    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].

    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.

    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
    return {
      layout: layout,
      pixelDimIndex: pixelDimIndex,
      layoutBase: rect[xy[pixelDimIndex]],
      layoutLength: layoutLength,
      axisBase: rect[xy[1 - pixelDimIndex]],
      axisLength: rect[wh[1 - pixelDimIndex]],
      axisExpandable: axisExpandable,
      axisExpandWidth: axisExpandWidth,
      axisCollapseWidth: axisCollapseWidth,
      axisExpandWindow: axisExpandWindow,
      axisCount: axisCount,
      winInnerIndices: winInnerIndices,
      axisExpandWindow0Pos: axisExpandWindow0Pos
    };
  },

  /**
   * @private
   */
  _layoutAxes: function () {
    var rect = this._rect;
    var axes = this._axesMap;
    var dimensions = this.dimensions;

    var layoutInfo = this._makeLayoutInfo();

    var layout = layoutInfo.layout;
    axes.each(function (axis) {
      var axisExtent = [0, layoutInfo.axisLength];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
    });
    each(dimensions, function (dim, idx) {
      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
      var positionTable = {
        horizontal: {
          x: posInfo.position,
          y: layoutInfo.axisLength
        },
        vertical: {
          x: 0,
          y: posInfo.position
        }
      };
      var rotationTable = {
        horizontal: PI / 2,
        vertical: 0
      };
      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
      var rotation = rotationTable[layout];
      var transform = matrix.create();
      matrix.rotate(transform, transform, rotation);
      matrix.translate(transform, transform, position); // TODO
      // tick等排布信息。
      // TODO
      // 根据axis order 更新 dimensions顺序。

      this._axesLayout[dim] = {
        position: position,
        rotation: rotation,
        transform: transform,
        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
        axisLabelShow: posInfo.axisLabelShow,
        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
        tickDirection: 1,
        labelDirection: 1,
        labelInterval: axes.get(dim).getLabelInterval()
      };
    }, this);
  },

  /**
   * Get axis by dim.
   * @param {string} dim
   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
   */
  getAxis: function (dim) {
    return this._axesMap.get(dim);
  },

  /**
   * Convert a dim value of a single item of series data to Point.
   * @param {*} value
   * @param {string} dim
   * @return {Array}
   */
  dataToPoint: function (value, dim) {
    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
  },

  /**
   * Travel data for one time, get activeState of each data item.
   * @param {module:echarts/data/List} data
   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
   *                            {number} dataIndex
   * @param {Object} context
   */
  eachActiveState: function (data, callback, context) {
    var dimensions = this.dimensions;
    var axesMap = this._axesMap;
    var hasActiveSet = this.hasAxisBrushed();

    for (var i = 0, len = data.count(); i < len; i++) {
      var values = data.getValues(dimensions, i);
      var activeState;

      if (!hasActiveSet) {
        activeState = 'normal';
      } else {
        activeState = 'active';

        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
          var dimName = dimensions[j];
          var state = axesMap.get(dimName).model.getActiveState(values[j], j);

          if (state === 'inactive') {
            activeState = 'inactive';
            break;
          }
        }
      }

      callback.call(context, activeState, i);
    }
  },

  /**
   * Whether has any activeSet.
   * @return {boolean}
   */
  hasAxisBrushed: function () {
    var dimensions = this.dimensions;
    var axesMap = this._axesMap;
    var hasActiveSet = false;

    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
        hasActiveSet = true;
      }
    }

    return hasActiveSet;
  },

  /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   * @param {Array.<number>} coords
   * @param {string} dim
   * @return {Array.<number>}
   */
  axisCoordToPoint: function (coord, dim) {
    var axisLayout = this._axesLayout[dim];
    return graphic.applyTransform([coord, 0], axisLayout.transform);
  },

  /**
   * Get axis layout.
   */
  getAxisLayout: function (dim) {
    return zrUtil.clone(this._axesLayout[dim]);
  },

  /**
   * @param {Array.<number>} point
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */
  getSlidedAxisExpandWindow: function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.

    if (!this.containPoint(point)) {
      return {
        behavior: 'none',
        axisExpandWindow: axisExpandWindow
      };
    } // Conver the point from global to expand coordinates.


    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
    // slided when mouse is the center area of the window.

    var delta;
    var behavior = 'slide';
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;

    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.


    var useJump = triggerArea[0] != null;

    if (axisCollapseWidth) {
      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
        behavior = 'jump';
        delta = pointCoord - winSize * triggerArea[2];
      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
        behavior = 'jump';
        delta = pointCoord - winSize * (1 - triggerArea[2]);
      } else {
        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
      }

      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
      : behavior = 'none';
    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
    else {
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var pos = extent[1] * pointCoord / winSize;
        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
      }

    return {
      axisExpandWindow: axisExpandWindow,
      behavior: behavior
    };
  }
};

function restrict(len, extent) {
  return mathMin(mathMax(len, extent[0]), extent[1]);
}

function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
  return {
    position: step * axisIndex,
    axisNameAvailableWidth: step,
    axisLabelShow: true
  };
}

function layoutAxisWithExpand(axisIndex, layoutInfo) {
  var layoutLength = layoutInfo.layoutLength;
  var axisExpandWidth = layoutInfo.axisExpandWidth;
  var axisCount = layoutInfo.axisCount;
  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
  var winInnerIndices = layoutInfo.winInnerIndices;
  var position;
  var axisNameAvailableWidth = axisCollapseWidth;
  var axisLabelShow = false;
  var nameTruncateMaxWidth;

  if (axisIndex < winInnerIndices[0]) {
    position = axisIndex * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  } else if (axisIndex <= winInnerIndices[1]) {
    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
    axisNameAvailableWidth = axisExpandWidth;
    axisLabelShow = true;
  } else {
    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  }

  return {
    position: position,
    axisNameAvailableWidth: axisNameAvailableWidth,
    axisLabelShow: axisLabelShow,
    nameTruncateMaxWidth: nameTruncateMaxWidth
  };
}

var _default = Parallel;
module.exports = _default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

/**
 * @constructor module:echarts/coord/parallel/ParallelAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 */
var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * @type {number}
   * @readOnly
   */

  this.axisIndex = axisIndex;
};

ParallelAxis.prototype = {
  constructor: ParallelAxis,

  /**
   * Axis model
   * @param {module:echarts/coord/parallel/AxisModel}
   */
  model: null,

  /**
   * @override
   */
  isHorizontal: function () {
    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
  }
};
zrUtil.inherits(ParallelAxis, Axis);
var _default = ParallelAxis;
module.exports = _default;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Component = __webpack_require__(32);

__webpack_require__(1579);

var _default = Component.extend({
  type: 'parallel',
  dependencies: ['parallelAxis'],

  /**
   * @type {module:echarts/coord/parallel/Parallel}
   */
  coordinateSystem: null,

  /**
   * Each item like: 'dim0', 'dim1', 'dim2', ...
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: null,

  /**
   * Coresponding to dimensions.
   * @type {Array.<number>}
   * @readOnly
   */
  parallelAxisIndex: null,
  layoutMode: 'box',
  defaultOption: {
    zlevel: 0,
    z: 0,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    layout: 'horizontal',
    // 'horizontal' or 'vertical'
    // FIXME
    // naming?
    axisExpandable: false,
    axisExpandCenter: null,
    axisExpandCount: 0,
    axisExpandWidth: 50,
    // FIXME '10%' ?
    axisExpandRate: 17,
    axisExpandDebounce: 50,
    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
    // Do not doc to user until necessary.
    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
    axisExpandTriggerOn: 'click',
    // 'mousemove' or 'click'
    parallelAxisDefault: null
  },

  /**
   * @override
   */
  init: function () {
    Component.prototype.init.apply(this, arguments);
    this.mergeOption({});
  },

  /**
   * @override
   */
  mergeOption: function (newOption) {
    var thisOption = this.option;
    newOption && zrUtil.merge(thisOption, newOption, true);

    this._initDimensions();
  },

  /**
   * Whether series or axis is in this coordinate system.
   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
   * @param {module:echarts/model/Global} ecModel
   */
  contains: function (model, ecModel) {
    var parallelIndex = model.get('parallelIndex');
    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
  },
  setAxisExpand: function (opt) {
    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
      if (opt.hasOwnProperty(name)) {
        this.option[name] = opt[name];
      }
    }, this);
  },

  /**
   * @private
   */
  _initDimensions: function () {
    var dimensions = this.dimensions = [];
    var parallelAxisIndex = this.parallelAxisIndex = [];
    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
      // Can not use this.contains here, because
      // initialization has not been completed yet.
      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
    }, this);
    zrUtil.each(axisModels, function (axisModel) {
      dimensions.push('dim' + axisModel.get('dim'));
      parallelAxisIndex.push(axisModel.componentIndex);
    });
  }
});

module.exports = _default;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

function _default(option) {
  createParallelIfNeeded(option);
  mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */


function createParallelIfNeeded(option) {
  if (option.parallel) {
    return;
  }

  var hasParallelSeries = false;
  zrUtil.each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'parallel') {
      hasParallelSeries = true;
    }
  });

  if (hasParallelSeries) {
    option.parallel = [{}];
  }
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */


function mergeAxisOptionFromParallel(option) {
  var axes = modelUtil.normalizeToArray(option.parallelAxis);
  zrUtil.each(axes, function (axisOption) {
    if (!zrUtil.isObject(axisOption)) {
      return;
    }

    var parallelIndex = axisOption.parallelIndex || 0;
    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];

    if (parallelOption && parallelOption.parallelAxisDefault) {
      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

function AngleAxis(scale, angleExtent) {
  angleExtent = angleExtent || [0, 360];
  Axis.call(this, 'angle', scale, angleExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'category';
}

AngleAxis.prototype = {
  constructor: AngleAxis,

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  },
  dataToAngle: Axis.prototype.dataToCoord,
  angleToData: Axis.prototype.coordToData
};
zrUtil.inherits(AngleAxis, Axis);
var _default = AngleAxis;
module.exports = _default;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var axisModelCreator = __webpack_require__(192);

var axisModelCommonMixin = __webpack_require__(116);

var PolarAxisModel = ComponentModel.extend({
  type: 'polarAxis',

  /**
   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  axis: null,

  /**
   * @override
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'polar',
      index: this.option.polarIndex,
      id: this.option.polarId
    })[0];
  }
});
zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
var polarAxisDefaultExtendedOption = {
  angle: {
    // polarIndex: 0,
    // polarId: '',
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
      rotate: false
    }
  },
  radius: {
    // polarIndex: 0,
    // polarId: '',
    splitNumber: 5
  }
};

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var RadiusAxis = __webpack_require__(1588);

var AngleAxis = __webpack_require__(1584);

/**
 * @module echarts/coord/polar/Polar
 */

/**
 * @alias {module:echarts/coord/polar/Polar}
 * @constructor
 * @param {string} name
 */
var Polar = function (name) {
  /**
   * @type {string}
   */
  this.name = name || '';
  /**
   * x of polar center
   * @type {number}
   */

  this.cx = 0;
  /**
   * y of polar center
   * @type {number}
   */

  this.cy = 0;
  /**
   * @type {module:echarts/coord/polar/RadiusAxis}
   * @private
   */

  this._radiusAxis = new RadiusAxis();
  /**
   * @type {module:echarts/coord/polar/AngleAxis}
   * @private
   */

  this._angleAxis = new AngleAxis();
  this._radiusAxis.polar = this._angleAxis.polar = this;
};

Polar.prototype = {
  type: 'polar',
  axisPointerEnabled: true,
  constructor: Polar,

  /**
   * @param {Array.<string>}
   * @readOnly
   */
  dimensions: ['radius', 'angle'],

  /**
   * @type {module:echarts/coord/PolarModel}
   */
  model: null,

  /**
   * If contain coord
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var coord = this.pointToCoord(point);
    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
  },

  /**
   * @param {string} dim
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  getAxis: function (dim) {
    return this['_' + dim + 'Axis'];
  },

  /**
   * @return {Array.<module:echarts/coord/Axis>}
   */
  getAxes: function () {
    return [this._radiusAxis, this._angleAxis];
  },

  /**
   * Get axes by type of scale
   * @param {string} scaleType
   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
   */
  getAxesByScale: function (scaleType) {
    var axes = [];
    var angleAxis = this._angleAxis;
    var radiusAxis = this._radiusAxis;
    angleAxis.scale.type === scaleType && axes.push(angleAxis);
    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
    return axes;
  },

  /**
   * @return {module:echarts/coord/polar/AngleAxis}
   */
  getAngleAxis: function () {
    return this._angleAxis;
  },

  /**
   * @return {module:echarts/coord/polar/RadiusAxis}
   */
  getRadiusAxis: function () {
    return this._radiusAxis;
  },

  /**
   * @param {module:echarts/coord/polar/Axis}
   * @return {module:echarts/coord/polar/Axis}
   */
  getOtherAxis: function (axis) {
    var angleAxis = this._angleAxis;
    return axis === angleAxis ? this._radiusAxis : angleAxis;
  },

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/polar/Axis}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
  },

  /**
   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
   * @return {Object} {baseAxes: [], otherAxes: []}
   */
  getTooltipAxes: function (dim) {
    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
    return {
      baseAxes: [baseAxis],
      otherAxes: [this.getOtherAxis(baseAxis)]
    };
  },

  /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   * @param {Array.<number>} data
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, clamp) {
    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
  },

  /**
   * Convert a (x, y) point to data
   * @param {Array.<number>} point
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  pointToData: function (point, clamp) {
    var coord = this.pointToCoord(point);
    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
  },

  /**
   * Convert a (x, y) point to (radius, angle) coord
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToCoord: function (point) {
    var dx = point[0] - this.cx;
    var dy = point[1] - this.cy;
    var angleAxis = this.getAngleAxis();
    var extent = angleAxis.getExtent();
    var minAngle = Math.min(extent[0], extent[1]);
    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
    // FIXME

    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent

    var dir = radian < minAngle ? 1 : -1;

    while (radian < minAngle || radian > maxAngle) {
      radian += dir * 360;
    }

    return [radius, radian];
  },

  /**
   * Convert a (radius, angle) coord to (x, y) point
   * @param {Array.<number>} coord
   * @return {Array.<number>}
   */
  coordToPoint: function (coord) {
    var radius = coord[0];
    var radian = coord[1] / 180 * Math.PI;
    var x = Math.cos(radian) * radius + this.cx; // Inverse the y

    var y = -Math.sin(radian) * radius + this.cy;
    return [x, y];
  }
};
var _default = Polar;
module.exports = _default;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

__webpack_require__(1585);

var _default = echarts.extendComponentModel({
  type: 'polar',
  dependencies: ['polarAxis', 'angleAxis'],

  /**
   * @type {module:echarts/coord/polar/Polar}
   */
  coordinateSystem: null,

  /**
   * @param {string} axisType
   * @return {module:echarts/coord/polar/AxisModel}
   */
  findAxisModel: function (axisType) {
    var foundAxisModel;
    var ecModel = this.ecModel;
    ecModel.eachComponent(axisType, function (axisModel) {
      if (axisModel.getCoordSysModel() === this) {
        foundAxisModel = axisModel;
      }
    }, this);
    return foundAxisModel;
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '80%'
  }
});

module.exports = _default;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

function RadiusAxis(scale, radiusExtent) {
  Axis.call(this, 'radius', scale, radiusExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'category';
}

RadiusAxis.prototype = {
  constructor: RadiusAxis,

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  },
  dataToRadius: Axis.prototype.dataToCoord,
  radiusToData: Axis.prototype.coordToData
};
zrUtil.inherits(RadiusAxis, Axis);
var _default = RadiusAxis;
module.exports = _default;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
    var axis = this['get' + dim + 'Axis']();
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var method = 'dataTo' + dim;
    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));

    if (dim === 'Angle') {
      result = result * Math.PI / 180;
    }

    return result;
  }, this);
}

function _default(coordSys) {
  var radiusAxis = coordSys.getRadiusAxis();
  var angleAxis = coordSys.getAngleAxis();
  var radius = radiusAxis.getExtent();
  radius[0] > radius[1] && radius.reverse();
  return {
    coordSys: {
      type: 'polar',
      cx: coordSys.cx,
      cy: coordSys.cy,
      r: radius[1],
      r0: radius[0]
    },
    api: {
      coord: zrUtil.bind(function (data) {
        var radius = radiusAxis.dataToRadius(data[0]);
        var angle = angleAxis.dataToAngle(data[1]);
        var coord = coordSys.coordToPoint([radius, angle]);
        coord.push(radius, angle * Math.PI / 180);
        return coord;
      }),
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

function IndicatorAxis(dim, scale, radiusExtent) {
  Axis.call(this, dim, scale, radiusExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = 'value';
  this.angle = 0;
  /**
   * Indicator name
   * @type {string}
   */

  this.name = '';
  /**
   * @type {module:echarts/model/Model}
   */

  this.model;
}

zrUtil.inherits(IndicatorAxis, Axis);
var _default = IndicatorAxis;
module.exports = _default;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var IndicatorAxis = __webpack_require__(1590);

var IntervalScale = __webpack_require__(195);

var numberUtil = __webpack_require__(8);

var _axisHelper = __webpack_require__(51);

var getScaleExtent = _axisHelper.getScaleExtent;
var niceScaleExtent = _axisHelper.niceScaleExtent;

var CoordinateSystem = __webpack_require__(66);

// TODO clockwise
function Radar(radarModel, ecModel, api) {
  this._model = radarModel;
  /**
   * Radar dimensions
   * @type {Array.<string>}
   */

  this.dimensions = [];
  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
    var dim = 'indicator_' + idx;
    var indicatorAxis = new IndicatorAxis(dim, new IntervalScale());
    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis

    indicatorAxis.model = indicatorModel;
    indicatorModel.axis = indicatorAxis;
    this.dimensions.push(dim);
    return indicatorAxis;
  }, this);
  this.resize(radarModel, api);
  /**
   * @type {number}
   * @readOnly
   */

  this.cx;
  /**
   * @type {number}
   * @readOnly
   */

  this.cy;
  /**
   * @type {number}
   * @readOnly
   */

  this.r;
  /**
   * @type {number}
   * @readOnly
   */

  this.startAngle;
}

Radar.prototype.getIndicatorAxes = function () {
  return this._indicatorAxes;
};

Radar.prototype.dataToPoint = function (value, indicatorIndex) {
  var indicatorAxis = this._indicatorAxes[indicatorIndex];
  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
};

Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
  var indicatorAxis = this._indicatorAxes[indicatorIndex];
  var angle = indicatorAxis.angle;
  var x = this.cx + coord * Math.cos(angle);
  var y = this.cy - coord * Math.sin(angle);
  return [x, y];
};

Radar.prototype.pointToData = function (pt) {
  var dx = pt[0] - this.cx;
  var dy = pt[1] - this.cy;
  var radius = Math.sqrt(dx * dx + dy * dy);
  dx /= radius;
  dy /= radius;
  var radian = Math.atan2(-dy, dx); // Find the closest angle
  // FIXME index can calculated directly

  var minRadianDiff = Infinity;
  var closestAxis;
  var closestAxisIdx = -1;

  for (var i = 0; i < this._indicatorAxes.length; i++) {
    var indicatorAxis = this._indicatorAxes[i];
    var diff = Math.abs(radian - indicatorAxis.angle);

    if (diff < minRadianDiff) {
      closestAxis = indicatorAxis;
      closestAxisIdx = i;
      minRadianDiff = diff;
    }
  }

  return [closestAxisIdx, +(closestAxis && closestAxis.coodToData(radius))];
};

Radar.prototype.resize = function (radarModel, api) {
  var center = radarModel.get('center');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var viewSize = Math.min(viewWidth, viewHeight) / 2;
  this.cx = numberUtil.parsePercent(center[0], viewWidth);
  this.cy = numberUtil.parsePercent(center[1], viewHeight);
  this.startAngle = radarModel.get('startAngle') * Math.PI / 180;
  this.r = numberUtil.parsePercent(radarModel.get('radius'), viewSize);
  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
    indicatorAxis.setExtent(0, this.r);
    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]

    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
    indicatorAxis.angle = angle;
  }, this);
};

Radar.prototype.update = function (ecModel, api) {
  var indicatorAxes = this._indicatorAxes;
  var radarModel = this._model;
  zrUtil.each(indicatorAxes, function (indicatorAxis) {
    indicatorAxis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
      return;
    }

    var data = radarSeries.getData();
    zrUtil.each(indicatorAxes, function (indicatorAxis) {
      indicatorAxis.scale.unionExtentFromData(data, indicatorAxis.dim);
    });
  }, this);
  var splitNumber = radarModel.get('splitNumber');

  function increaseInterval(interval) {
    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval

    var f = interval / exp10;

    if (f === 2) {
      f = 5;
    } else {
      // f is 2 or 5
      f *= 2;
    }

    return f * exp10;
  } // Force all the axis fixing the maxSplitNumber.


  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model);
    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
    var axisModel = indicatorAxis.model;
    var scale = indicatorAxis.scale;
    var fixedMin = axisModel.getMin();
    var fixedMax = axisModel.getMax();
    var interval = scale.getInterval();

    if (fixedMin != null && fixedMax != null) {
      // User set min, max, divide to get new interval
      scale.setExtent(+fixedMin, +fixedMax);
      scale.setInterval((fixedMax - fixedMin) / splitNumber);
    } else if (fixedMin != null) {
      var max; // User set min, expand extent on the other side

      do {
        max = fixedMin + interval * splitNumber;
        scale.setExtent(+fixedMin, max); // Interval must been set after extent
        // FIXME

        scale.setInterval(interval);
        interval = increaseInterval(interval);
      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
    } else if (fixedMax != null) {
      var min; // User set min, expand extent on the other side

      do {
        min = fixedMax - interval * splitNumber;
        scale.setExtent(min, +fixedMax);
        scale.setInterval(interval);
        interval = increaseInterval(interval);
      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
    } else {
      var nicedSplitNumber = scale.getTicks().length - 1;

      if (nicedSplitNumber > splitNumber) {
        interval = increaseInterval(interval);
      } // PENDING


      var center = Math.round((rawExtent[0] + rawExtent[1]) / 2 / interval) * interval;
      var halfSplitNumber = Math.round(splitNumber / 2);
      scale.setExtent(numberUtil.round(center - halfSplitNumber * interval), numberUtil.round(center + (splitNumber - halfSplitNumber) * interval));
      scale.setInterval(interval);
    }
  });
};
/**
 * Radar dimensions is based on the data
 * @type {Array}
 */


Radar.dimensions = [];

Radar.create = function (ecModel, api) {
  var radarList = [];
  ecModel.eachComponent('radar', function (radarModel) {
    var radar = new Radar(radarModel, ecModel, api);
    radarList.push(radar);
    radarModel.coordinateSystem = radar;
  });
  ecModel.eachSeriesByType('radar', function (radarSeries) {
    if (radarSeries.get('coordinateSystem') === 'radar') {
      // Inject coordinate system
      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
    }
  });
  return radarList;
};

CoordinateSystem.register('radar', Radar);
var _default = Radar;
module.exports = _default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(4);

var zrUtil = __webpack_require__(0);

var axisDefault = __webpack_require__(480);

var Model = __webpack_require__(29);

var axisModelCommonMixin = __webpack_require__(116);

var valueAxisDefault = axisDefault.valueAxis;

function defaultsShow(opt, show) {
  return zrUtil.defaults({
    show: show
  }, opt);
}

var RadarModel = echarts.extendComponentModel({
  type: 'radar',
  optionUpdated: function () {
    var boundaryGap = this.get('boundaryGap');
    var splitNumber = this.get('splitNumber');
    var scale = this.get('scale');
    var axisLine = this.get('axisLine');
    var axisTick = this.get('axisTick');
    var axisLabel = this.get('axisLabel');
    var nameTextStyle = this.get('name');
    var showName = this.get('name.show');
    var nameFormatter = this.get('name.formatter');
    var nameGap = this.get('nameGap');
    var triggerEvent = this.get('triggerEvent');
    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
      // PENDING
      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
        indicatorOpt.min = 0;
      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
        indicatorOpt.max = 0;
      }

      var iNameTextStyle = nameTextStyle;

      if (indicatorOpt.color != null) {
        iNameTextStyle = zrUtil.defaults({
          color: indicatorOpt.color
        }, nameTextStyle);
      } // Use same configuration


      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
        boundaryGap: boundaryGap,
        splitNumber: splitNumber,
        scale: scale,
        axisLine: axisLine,
        axisTick: axisTick,
        axisLabel: axisLabel,
        // Competitable with 2 and use text
        name: indicatorOpt.text,
        nameLocation: 'end',
        nameGap: nameGap,
        // min: 0,
        nameTextStyle: iNameTextStyle,
        triggerEvent: triggerEvent
      }, false);

      if (!showName) {
        indicatorOpt.name = '';
      }

      if (typeof nameFormatter === 'string') {
        var indName = indicatorOpt.name;
        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
      } else if (typeof nameFormatter === 'function') {
        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
      }

      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.

      model.mainType = 'radar';
      model.componentIndex = this.componentIndex;
      return model;
    }, this);

    this.getIndicatorModels = function () {
      return indicatorModels;
    };
  },
  defaultOption: {
    zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '75%',
    startAngle: 90,
    name: {
      show: true // formatter: null
      // textStyle: {}

    },
    boundaryGap: [0, 0],
    splitNumber: 5,
    nameGap: 15,
    scale: false,
    // Polygon or circle
    shape: 'polygon',
    axisLine: zrUtil.merge({
      lineStyle: {
        color: '#bbb'
      }
    }, valueAxisDefault.axisLine),
    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
    // {text, min, max}
    indicator: []
  }
});
var _default = RadarModel;
module.exports = _default;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var ComponentModel = __webpack_require__(32);

var axisModelCreator = __webpack_require__(192);

var axisModelCommonMixin = __webpack_require__(116);

var AxisModel = ComponentModel.extend({
  type: 'singleAxis',
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/single/SingleAxis}
   */
  axis: null,

  /**
   * @type {module:echarts/coord/single/Single}
   */
  coordinateSystem: null,

  /**
   * @override
   */
  getCoordSysModel: function () {
    return this;
  }
});
var defaultOption = {
  left: '5%',
  top: '5%',
  right: '5%',
  bottom: '5%',
  type: 'value',
  position: 'bottom',
  orient: 'horizontal',
  axisLine: {
    show: true,
    lineStyle: {
      width: 2,
      type: 'solid'
    }
  },
  // Single coordinate system and single axis is the,
  // which is used as the parent tooltip model.
  // same model, so we set default tooltip show as true.
  tooltip: {
    show: true
  },
  axisTick: {
    show: true,
    length: 6,
    lineStyle: {
      width: 2
    }
  },
  axisLabel: {
    show: true,
    interval: 'auto'
  },
  splitLine: {
    show: true,
    lineStyle: {
      type: 'dashed',
      opacity: 0.2
    }
  }
};

function getAxisType(axisName, option) {
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
axisModelCreator('single', AxisModel, getAxisType, defaultOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var SingleAxis = __webpack_require__(1595);

var axisHelper = __webpack_require__(51);

var _layout = __webpack_require__(17);

var getLayoutRect = _layout.getLayoutRect;

/**
 * Single coordinates system.
 */

/**
 * Create a single coordinates system.
 *
 * @param {module:echarts/coord/single/AxisModel} axisModel
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */
function Single(axisModel, ecModel, api) {
  /**
   * @type {string}
   * @readOnly
   */
  this.dimension = 'single';
  /**
   * Add it just for draw tooltip.
   *
   * @type {Array.<string>}
   * @readOnly
   */

  this.dimensions = ['single'];
  /**
   * @private
   * @type {module:echarts/coord/single/SingleAxis}.
   */

  this._axis = null;
  /**
   * @private
   * @type {module:zrender/core/BoundingRect}
   */

  this._rect;

  this._init(axisModel, ecModel, api);
  /**
   * @type {module:echarts/coord/single/AxisModel}
   */


  this.model = axisModel;
}

Single.prototype = {
  type: 'singleAxis',
  axisPointerEnabled: true,
  constructor: Single,

  /**
   * Initialize single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @private
   */
  _init: function (axisModel, ecModel, api) {
    var dim = this.dimension;
    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
    var isCategory = axis.type === 'category';
    axis.onBand = isCategory && axisModel.get('boundaryGap');
    axis.inverse = axisModel.get('inverse');
    axis.orient = axisModel.get('orient');
    axisModel.axis = axis;
    axis.model = axisModel;
    axis.coordinateSystem = this;
    this._axis = axis;
  },

  /**
   * Update axis scale after data processed
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  update: function (ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.coordinateSystem === this) {
        var data = seriesModel.getData();
        var dim = this.dimension;

        this._axis.scale.unionExtentFromData(data, seriesModel.coordDimToDataDim(dim));

        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
      }
    }, this);
  },

  /**
   * Resize the single coordinate system.
   *
   * @param  {module:echarts/coord/single/AxisModel} axisModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  resize: function (axisModel, api) {
    this._rect = getLayoutRect({
      left: axisModel.get('left'),
      top: axisModel.get('top'),
      right: axisModel.get('right'),
      bottom: axisModel.get('bottom'),
      width: axisModel.get('width'),
      height: axisModel.get('height')
    }, {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._adjustAxis();
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getRect: function () {
    return this._rect;
  },

  /**
   * @private
   */
  _adjustAxis: function () {
    var rect = this._rect;
    var axis = this._axis;
    var isHorizontal = axis.isHorizontal();
    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
    var idx = axis.reverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);

    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
  },

  /**
   * @param  {module:echarts/coord/single/SingleAxis} axis
   * @param  {number} coordBase
   */
  _updateAxisTransform: function (axis, coordBase) {
    var axisExtent = axis.getExtent();
    var extentSum = axisExtent[0] + axisExtent[1];
    var isHorizontal = axis.isHorizontal();
    axis.toGlobalCoord = isHorizontal ? function (coord) {
      return coord + coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
    axis.toLocalCoord = isHorizontal ? function (coord) {
      return coord - coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
  },

  /**
   * Get axis.
   *
   * @return {module:echarts/coord/single/SingleAxis}
   */
  getAxis: function () {
    return this._axis;
  },

  /**
   * Get axis, add it just for draw tooltip.
   *
   * @return {[type]} [description]
   */
  getBaseAxis: function () {
    return this._axis;
  },

  /**
   * @return {Array.<module:echarts/coord/Axis>}
   */
  getAxes: function () {
    return [this._axis];
  },

  /**
   * @return {Object} {baseAxes: [], otherAxes: []}
   */
  getTooltipAxes: function () {
    return {
      baseAxes: [this.getAxis()]
    };
  },

  /**
   * If contain point.
   *
   * @param  {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var rect = this.getRect();
    var axis = this.getAxis();
    var orient = axis.orient;

    if (orient === 'horizontal') {
      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
    } else {
      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    }
  },

  /**
   * @param {Array.<number>} point
   * @return {Array.<number>}
   */
  pointToData: function (point) {
    var axis = this.getAxis();
    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
  },

  /**
   * Convert the series data to concrete point.
   *
   * @param  {number|Array.<number>} val
   * @return {Array.<number>}
   */
  dataToPoint: function (val) {
    var axis = this.getAxis();
    var rect = this.getRect();
    var pt = [];
    var idx = axis.orient === 'horizontal' ? 0 : 1;

    if (val instanceof Array) {
      val = val[0];
    }

    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
    return pt;
  }
};
var _default = Single;
module.exports = _default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Axis = __webpack_require__(86);

/**
 * @constructor  module:echarts/coord/single/SingleAxis
 * @extends {module:echarts/coord/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   * - 'category'
   * - 'value'
   * - 'time'
   * - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   *  @type {string}
   */

  this.position = position || 'bottom';
  /**
   * Axis orient
   *  - 'horizontal'
   *  - 'vertical'
   * @type {[type]}
   */

  this.orient = null;
  /**
   * @type {number}
   */

  this._labelInterval = null;
};

SingleAxis.prototype = {
  constructor: SingleAxis,

  /**
   * Axis model
   * @type {module:echarts/coord/single/AxisModel}
   */
  model: null,

  /**
   * Judge the orient of the axis.
   * @return {boolean}
   */
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordinateSystem.pointToData(point, clamp)[0];
  },

  /**
   * Convert the local coord(processed by dataToCoord())
   * to global coord(concrete pixel coord).
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */
  toGlobalCoord: null,

  /**
   * Convert the global coord to local coord.
   * designated by module:echarts/coord/single/Single.
   * @type {Function}
   */
  toLocalCoord: null
};
zrUtil.inherits(SingleAxis, Axis);
var _default = SingleAxis;
module.exports = _default;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  var axis = this.getAxis();
  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}

function _default(coordSys) {
  var rect = coordSys.getRect();
  return {
    coordSys: {
      type: 'singleAxis',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: zrUtil.bind(coordSys.dataToPoint, coordSys),
      size: zrUtil.bind(dataToCoordSize, coordSys)
    }
  };
}

module.exports = _default;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var Single = __webpack_require__(1594);

var CoordinateSystem = __webpack_require__(66);

/**
 * Single coordinate system creator.
 */

/**
 * Create single coordinate system and inject it into seriesModel.
 *
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Array.<module:echarts/coord/single/Single>}
 */
function create(ecModel, api) {
  var singles = [];
  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
    var single = new Single(axisModel, ecModel, api);
    single.name = 'single_' + idx;
    single.resize(axisModel, api);
    axisModel.coordinateSystem = single;
    singles.push(single);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
      var singleAxisModel = ecModel.queryComponents({
        mainType: 'singleAxis',
        index: seriesModel.get('singleAxisIndex'),
        id: seriesModel.get('singleAxisId')
      })[0];
      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
    }
  });
  return singles;
}

CoordinateSystem.register('single', {
  create: create,
  dimensions: Single.prototype.dimensions
});

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

/**
 * Graph data structure
 *
 * @module echarts/data/Graph
 * @author Yi Shen(https://www.github.com/pissang)
 */
// id may be function name of Object, add a prefix to avoid this problem.
function generateNodeKey(id) {
  return '_EC_' + id;
}
/**
 * @alias module:echarts/data/Graph
 * @constructor
 * @param {boolean} directed
 */


var Graph = function (directed) {
  /**
   * 是否是有向图
   * @type {boolean}
   * @private
   */
  this._directed = directed || false;
  /**
   * @type {Array.<module:echarts/data/Graph.Node>}
   * @readOnly
   */

  this.nodes = [];
  /**
   * @type {Array.<module:echarts/data/Graph.Edge>}
   * @readOnly
   */

  this.edges = [];
  /**
   * @type {Object.<string, module:echarts/data/Graph.Node>}
   * @private
   */

  this._nodesMap = {};
  /**
   * @type {Object.<string, module:echarts/data/Graph.Edge>}
   * @private
   */

  this._edgesMap = {};
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.data;
  /**
   * @type {module:echarts/data/List}
   * @readOnly
   */

  this.edgeData;
};

var graphProto = Graph.prototype;
/**
 * @type {string}
 */

graphProto.type = 'graph';
/**
 * If is directed graph
 * @return {boolean}
 */

graphProto.isDirected = function () {
  return this._directed;
};
/**
 * Add a new node
 * @param {string} id
 * @param {number} [dataIndex]
 */


graphProto.addNode = function (id, dataIndex) {
  id = id || '' + dataIndex;
  var nodesMap = this._nodesMap;

  if (nodesMap[generateNodeKey(id)]) {
    return;
  }

  var node = new Node(id, dataIndex);
  node.hostGraph = this;
  this.nodes.push(node);
  nodesMap[generateNodeKey(id)] = node;
  return node;
};
/**
 * Get node by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */


graphProto.getNodeByIndex = function (dataIndex) {
  var rawIdx = this.data.getRawIndex(dataIndex);
  return this.nodes[rawIdx];
};
/**
 * Get node by id
 * @param  {string} id
 * @return {module:echarts/data/Graph.Node}
 */


graphProto.getNodeById = function (id) {
  return this._nodesMap[generateNodeKey(id)];
};
/**
 * Add a new edge
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 * @return {module:echarts/data/Graph.Edge}
 */


graphProto.addEdge = function (n1, n2, dataIndex) {
  var nodesMap = this._nodesMap;
  var edgesMap = this._edgesMap; // PNEDING

  if (typeof n1 === 'number') {
    n1 = this.nodes[n1];
  }

  if (typeof n2 === 'number') {
    n2 = this.nodes[n2];
  }

  if (!(n1 instanceof Node)) {
    n1 = nodesMap[generateNodeKey(n1)];
  }

  if (!(n2 instanceof Node)) {
    n2 = nodesMap[generateNodeKey(n2)];
  }

  if (!n1 || !n2) {
    return;
  }

  var key = n1.id + '-' + n2.id; // PENDING

  if (edgesMap[key]) {
    return;
  }

  var edge = new Edge(n1, n2, dataIndex);
  edge.hostGraph = this;

  if (this._directed) {
    n1.outEdges.push(edge);
    n2.inEdges.push(edge);
  }

  n1.edges.push(edge);

  if (n1 !== n2) {
    n2.edges.push(edge);
  }

  this.edges.push(edge);
  edgesMap[key] = edge;
  return edge;
};
/**
 * Get edge by data index
 * @param  {number} dataIndex
 * @return {module:echarts/data/Graph~Node}
 */


graphProto.getEdgeByIndex = function (dataIndex) {
  var rawIdx = this.edgeData.getRawIndex(dataIndex);
  return this.edges[rawIdx];
};
/**
 * Get edge by two linked nodes
 * @param  {module:echarts/data/Graph.Node|string} n1
 * @param  {module:echarts/data/Graph.Node|string} n2
 * @return {module:echarts/data/Graph.Edge}
 */


graphProto.getEdge = function (n1, n2) {
  if (n1 instanceof Node) {
    n1 = n1.id;
  }

  if (n2 instanceof Node) {
    n2 = n2.id;
  }

  var edgesMap = this._edgesMap;

  if (this._directed) {
    return edgesMap[n1 + '-' + n2];
  } else {
    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
  }
};
/**
 * Iterate all nodes
 * @param  {Function} cb
 * @param  {*} [context]
 */


graphProto.eachNode = function (cb, context) {
  var nodes = this.nodes;
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i].dataIndex >= 0) {
      cb.call(context, nodes[i], i);
    }
  }
};
/**
 * Iterate all edges
 * @param  {Function} cb
 * @param  {*} [context]
 */


graphProto.eachEdge = function (cb, context) {
  var edges = this.edges;
  var len = edges.length;

  for (var i = 0; i < len; i++) {
    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
      cb.call(context, edges[i], i);
    }
  }
};
/**
 * Breadth first traverse
 * @param {Function} cb
 * @param {module:echarts/data/Graph.Node} startNode
 * @param {string} [direction='none'] 'none'|'in'|'out'
 * @param {*} [context]
 */


graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
  if (!(startNode instanceof Node)) {
    startNode = this._nodesMap[generateNodeKey(startNode)];
  }

  if (!startNode) {
    return;
  }

  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';

  for (var i = 0; i < this.nodes.length; i++) {
    this.nodes[i].__visited = false;
  }

  if (cb.call(context, startNode, null)) {
    return;
  }

  var queue = [startNode];

  while (queue.length) {
    var currentNode = queue.shift();
    var edges = currentNode[edgeType];

    for (var i = 0; i < edges.length; i++) {
      var e = edges[i];
      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;

      if (!otherNode.__visited) {
        if (cb.call(context, otherNode, currentNode)) {
          // Stop traversing
          return;
        }

        queue.push(otherNode);
        otherNode.__visited = true;
      }
    }
  }
}; // TODO
// graphProto.depthFirstTraverse = function (
//     cb, startNode, direction, context
// ) {
// };
// Filter update


graphProto.update = function () {
  var data = this.data;
  var edgeData = this.edgeData;
  var nodes = this.nodes;
  var edges = this.edges;

  for (var i = 0, len = nodes.length; i < len; i++) {
    nodes[i].dataIndex = -1;
  }

  for (var i = 0, len = data.count(); i < len; i++) {
    nodes[data.getRawIndex(i)].dataIndex = i;
  }

  edgeData.filterSelf(function (idx) {
    var edge = edges[edgeData.getRawIndex(idx)];
    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
  }); // Update edge

  for (var i = 0, len = edges.length; i < len; i++) {
    edges[i].dataIndex = -1;
  }

  for (var i = 0, len = edgeData.count(); i < len; i++) {
    edges[edgeData.getRawIndex(i)].dataIndex = i;
  }
};
/**
 * @return {module:echarts/data/Graph}
 */


graphProto.clone = function () {
  var graph = new Graph(this._directed);
  var nodes = this.nodes;
  var edges = this.edges;

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(nodes[i].id, nodes[i].dataIndex);
  }

  for (var i = 0; i < edges.length; i++) {
    var e = edges[i];
    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
  }

  return graph;
};
/**
 * @alias module:echarts/data/Graph.Node
 */


function Node(id, dataIndex) {
  /**
  * @type {string}
  */
  this.id = id == null ? '' : id;
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.inEdges = [];
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.outEdges = [];
  /**
  * @type {Array.<module:echarts/data/Graph.Edge>}
  */

  this.edges = [];
  /**
   * @type {module:echarts/data/Graph}
   */

  this.hostGraph;
  /**
   * @type {number}
   */

  this.dataIndex = dataIndex == null ? -1 : dataIndex;
}

Node.prototype = {
  constructor: Node,

  /**
   * @return {number}
   */
  degree: function () {
    return this.edges.length;
  },

  /**
   * @return {number}
   */
  inDegree: function () {
    return this.inEdges.length;
  },

  /**
  * @return {number}
  */
  outDegree: function () {
    return this.outEdges.length;
  },

  /**
   * @param {string} [path]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  }
};
/**
 * 图边
 * @alias module:echarts/data/Graph.Edge
 * @param {module:echarts/data/Graph.Node} n1
 * @param {module:echarts/data/Graph.Node} n2
 * @param {number} [dataIndex=-1]
 */

function Edge(n1, n2, dataIndex) {
  /**
   * 节点1，如果是有向图则为源节点
   * @type {module:echarts/data/Graph.Node}
   */
  this.node1 = n1;
  /**
   * 节点2，如果是有向图则为目标节点
   * @type {module:echarts/data/Graph.Node}
   */

  this.node2 = n2;
  this.dataIndex = dataIndex == null ? -1 : dataIndex;
}
/**
 * @param {string} [path]
 * @return {module:echarts/model/Model}
 */


Edge.prototype.getModel = function (path) {
  if (this.dataIndex < 0) {
    return;
  }

  var graph = this.hostGraph;
  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
  return itemModel.getModel(path);
};

var createGraphDataProxyMixin = function (hostName, dataName) {
  return {
    /**
     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     * @return {number}
     */
    getValue: function (dimension) {
      var data = this[hostName][dataName];
      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
    },

    /**
     * @param {Object|string} key
     * @param {*} [value]
     */
    setVisual: function (key, value) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
    },

    /**
     * @param {string} key
     * @return {boolean}
     */
    getVisual: function (key, ignoreParent) {
      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
    },

    /**
     * @param {Object} layout
     * @return {boolean} [merge=false]
     */
    setLayout: function (layout, merge) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
    },

    /**
     * @return {Object}
     */
    getLayout: function () {
      return this[hostName][dataName].getItemLayout(this.dataIndex);
    },

    /**
     * @return {module:zrender/Element}
     */
    getGraphicEl: function () {
      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
    },

    /**
     * @return {number}
     */
    getRawIndex: function () {
      return this[hostName][dataName].getRawIndex(this.dataIndex);
    }
  };
};

zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
Graph.Node = Node;
Graph.Edge = Edge;
var _default = Graph;
module.exports = _default;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var createListFromArray = __webpack_require__(84);

var axisHelper = __webpack_require__(51);

var axisModelCommonMixin = __webpack_require__(116);

var Model = __webpack_require__(29);

var _completeDimensions = __webpack_require__(58);

exports.completeDimensions = _completeDimensions;

var _symbol = __webpack_require__(52);

exports.createSymbol = _symbol.createSymbol;

/**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */
function createList(seriesModel) {
  var data = seriesModel.get('data');
  return createListFromArray(data, seriesModel, seriesModel.ecModel);
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 */


/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */
function createScale(dataExtent, option) {
  var axisModel = option;

  if (!(option instanceof Model)) {
    axisModel = new Model(option);
    zrUtil.mixin(axisModel, axisModelCommonMixin);
  }

  var scale = axisHelper.createScaleByModel(axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  axisHelper.niceScaleExtent(scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */


function mixinAxisModelCommonMethods(Model) {
  zrUtil.mixin(Model, axisModelCommonMixin);
}

exports.createList = createList;
exports.createScale = createScale;
exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var _number = __webpack_require__(8);

var parsePercent = _number.parsePercent;

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim;
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */


function barLayoutPolar(seriesType, ecModel, api) {
  var width = api.getWidth();
  var height = api.getHeight();
  var lastStackCoords = {};
  var lastStackCoordsOrigin = {};
  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
  }));
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for polar only
    if (seriesModel.coordinateSystem.type !== 'polar') {
      return;
    }

    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var angleAxis = polar.getAngleAxis();
    var baseAxis = polar.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = polar.getOtherAxis(baseAxis);
    var center = seriesModel.get('center') || ['50%', '50%'];
    var cx = parsePercent(center[0], width);
    var cy = parsePercent(center[1], height);
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var barMinAngle = seriesModel.get('barMinAngle') || 0;
    var valueAxisStart = valueAxis.getExtent()[0];
    var valueMax = valueAxis.model.get('max');
    var valueMin = valueAxis.model.get('min');
    var coordDims = [seriesModel.coordDimToDataDim('radius')[0], seriesModel.coordDimToDataDim('angle')[0]];
    var coords = data.mapArray(coordDims, function (radius, angle) {
      return polar.dataToPoint([radius, angle]);
    }, true);
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243

    data.each(seriesModel.coordDimToDataDim(valueAxis.dim)[0], function (value, idx) {
      if (isNaN(value)) {
        return;
      }

      if (!lastStackCoords[stackId][idx]) {
        lastStackCoords[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
        lastStackCoordsOrigin[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
      }

      var sign = value >= 0 ? 'p' : 'n';
      var coord = polar.pointToCoord(coords[idx]);
      var lastCoordOrigin = lastStackCoordsOrigin[stackId][idx][sign];
      var r0;
      var r;
      var startAngle;
      var endAngle;

      if (valueAxis.dim === 'radius') {
        // radial sector
        r0 = lastCoordOrigin;
        r = coord[0];
        startAngle = (-coord[1] + columnOffset) * Math.PI / 180;
        endAngle = startAngle + columnWidth * Math.PI / 180;

        if (Math.abs(r) < barMinHeight) {
          r = r0 + (r < 0 ? -1 : 1) * barMinHeight;
        }

        lastStackCoordsOrigin[stackId][idx][sign] = r;
      } else {
        // tangential sector
        r0 = coord[0] + columnOffset;
        r = r0 + columnWidth; // clamp data if min or max is defined for valueAxis

        if (valueMax != null) {
          value = Math.min(value, valueMax);
        }

        if (valueMin != null) {
          value = Math.max(value, valueMin);
        }

        var angle = angleAxis.dataToAngle(value);

        if (Math.abs(angle - lastCoordOrigin) < barMinAngle) {
          angle = lastCoordOrigin - (value < 0 ? -1 : 1) * barMinAngle;
        }

        startAngle = -lastCoordOrigin * Math.PI / 180;
        endAngle = -angle * Math.PI / 180; // if the previous stack is at the end of the ring,
        // add a round to differentiate it from origin

        var extent = angleAxis.getExtent();
        var stackCoord = angle;

        if (stackCoord === extent[0] && value > 0) {
          stackCoord = extent[1];
        } else if (stackCoord === extent[1] && value < 0) {
          stackCoord = extent[0];
        }

        lastStackCoordsOrigin[stackId][idx][sign] = stackCoord;
      }

      data.setItemLayout(idx, {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle
      });
    }, true);
  }, this);
}
/**
 * Calculate bar width and offset for radial bar charts
 */


function calRadialBar(barSeries, api) {
  // Columns info on each category axis. Key is polar name
  var columnsMap = {};
  zrUtil.each(barSeries, function (seriesModel, idx) {
    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var columnsOnAxis = columnsMap[getAxisKey(baseAxis)] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[getAxisKey(baseAxis)] = columnsOnAxis;
    var stackId = getSeriesStackId(seriesModel);

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    };
    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');

    if (barWidth && !stacks[stackId].width) {
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      stacks[stackId].width = barWidth;
      columnsOnAxis.remainedWidth -= barWidth;
    }

    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    barGap != null && (columnsOnAxis.gap = barGap);
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

var _default = barLayoutPolar;
module.exports = _default;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var graphic = __webpack_require__(5);

var PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function _default(api, opts) {
  opts = opts || {};
  zrUtil.defaults(opts, {
    text: 'loading',
    color: '#c23531',
    textColor: '#000',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    zlevel: 0
  });
  var mask = new graphic.Rect({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  var arc = new graphic.Arc({
    shape: {
      startAngle: -PI / 2,
      endAngle: -PI / 2 + 0.1,
      r: 10
    },
    style: {
      stroke: opts.color,
      lineCap: 'round',
      lineWidth: 5
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  var labelRect = new graphic.Rect({
    style: {
      fill: 'none',
      text: opts.text,
      textPosition: 'right',
      textDistance: 10,
      textFill: opts.textColor
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  arc.animateShape(true).when(1000, {
    endAngle: PI * 3 / 2
  }).start('circularInOut');
  arc.animateShape(true).when(1000, {
    startAngle: PI * 3 / 2
  }).delay(300).start('circularInOut');
  var group = new graphic.Group();
  group.add(arc);
  group.add(labelRect);
  group.add(mask); // Inject resize

  group.resize = function () {
    var cx = api.getWidth() / 2;
    var cy = api.getHeight() / 2;
    arc.setShape({
      cx: cx,
      cy: cy
    });
    var r = arc.shape.r;
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

module.exports = _default;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(14);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var Model = __webpack_require__(29);

var ComponentModel = __webpack_require__(32);

var globalDefault = __webpack_require__(1604);

var colorPaletteMinin = __webpack_require__(488);

/**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 */

/**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */
var each = zrUtil.each;
var filter = zrUtil.filter;
var map = zrUtil.map;
var isArray = zrUtil.isArray;
var indexOf = zrUtil.indexOf;
var isObject = zrUtil.isObject;
var OPTION_INNER_KEY = '\0_ec_inner';
/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */

var GlobalModel = Model.extend({
  constructor: GlobalModel,
  init: function (option, parentModel, theme, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    /**
     * @type {module:echarts/model/Model}
     * @private
     */

    this._theme = new Model(theme);
    /**
     * @type {module:echarts/model/OptionManager}
     */

    this._optionManager = optionManager;
  },
  setOption: function (option, optionPreprocessorFuncs) {
    zrUtil.assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');

    this._optionManager.setOption(option, optionPreprocessorFuncs);

    this.resetOption(null);
  },

  /**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */
  resetOption: function (type) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (!this.option || type === 'recreate') {
        initBase.call(this, baseOption);
      } else {
        this.restoreData();
        this.mergeOption(baseOption);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    }

    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);
      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this, this._api);

      if (mediaOptions.length) {
        each(mediaOptions, function (mediaOption) {
          this.mergeOption(mediaOption, optionChanged = true);
        }, this);
      }
    }

    return optionChanged;
  },

  /**
   * @protected
   */
  mergeOption: function (newOption) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var newCptTypes = []; // 如果不存在对应的 component model 则直接 merge

    each(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!ComponentModel.hasClass(mainType)) {
        option[mainType] = option[mainType] == null ? zrUtil.clone(componentOption) : zrUtil.merge(option[mainType], componentOption, true);
      } else {
        newCptTypes.push(mainType);
      }
    }); // FIXME OPTION 同步是否要改回原来的

    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
    this._seriesIndices = this._seriesIndices || [];

    function visitComponent(mainType, dependencies) {
      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.

      each(mapResult, function (item, index) {
        var opt = item.option;

        if (isObject(opt)) {
          item.keyInfo.mainType = mainType;
          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
        }
      });
      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
      option[mainType] = [];
      componentsMap.set(mainType, []);
      each(mapResult, function (resultItem, index) {
        var componentModel = resultItem.exist;
        var newCptOption = resultItem.option;
        zrUtil.assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
        // see removeEdgeAndAdd in topologicalTravel and
        // ComponentModel.getAllClassMainTypes.

        if (!newCptOption) {
          componentModel.mergeOption({}, this);
          componentModel.optionUpdated({}, false);
        } else {
          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);

          if (componentModel && componentModel instanceof ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name;
            componentModel.mergeOption(newCptOption, this);
            componentModel.optionUpdated(newCptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = zrUtil.extend({
              dependentModels: dependentModels,
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
            zrUtil.extend(componentModel, extraOpt);
            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
            // newCptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        componentsMap.get(mainType)[index] = componentModel;
        option[mainType][index] = componentModel.option;
      }, this); // Backup series for filtering.

      if (mainType === 'series') {
        this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
      }
    }
  },

  /**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */
  getOption: function () {
    var option = zrUtil.clone(this.option);
    each(option, function (opts, mainType) {
      if (ComponentModel.hasClass(mainType)) {
        var opts = modelUtil.normalizeToArray(opts);

        for (var i = opts.length - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (modelUtil.isIdInner(opts[i])) {
            opts.splice(i, 1);
          }
        }

        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getTheme: function () {
    return this._theme;
  },

  /**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */
  getComponent: function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      return list[idx || 0];
    }
  },

  /**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */
  queryComponents: function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cpts = this._componentsMap.get(mainType);

    if (!cpts || !cpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      if (!isArray(index)) {
        index = [index];
      }

      result = filter(map(index, function (idx) {
        return cpts[idx];
      }), function (val) {
        return !!val;
      });
    } else if (id != null) {
      var isIdArray = isArray(id);
      result = filter(cpts, function (cpt) {
        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
      });
    } else if (name != null) {
      var isNameArray = isArray(name);
      result = filter(cpts, function (cpt) {
        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
      });
    } else {
      // Return all components with mainType
      result = cpts.slice();
    }

    return filterBySubType(result, condition);
  },

  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series'},
   *     function (model, index) {...}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */
  findComponents: function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? filter(res, condition.filter) : res;
    }
  },

  /**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */
  eachComponent: function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (typeof mainType === 'function') {
      context = cb;
      cb = mainType;
      componentsMap.each(function (components, componentType) {
        each(components, function (component, index) {
          cb.call(context, componentType, component, index);
        });
      });
    } else if (zrUtil.isString(mainType)) {
      each(componentsMap.get(mainType), cb, context);
    } else if (isObject(mainType)) {
      var queryResult = this.findComponents(mainType);
      each(queryResult, cb, context);
    }
  },

  /**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByName: function (name) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.name === name;
    });
  },

  /**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */
  getSeriesByIndex: function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  },

  /**
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByType: function (subType) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.subType === subType;
    });
  },

  /**
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeries: function () {
    return this._componentsMap.get('series').slice();
  },

  /**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachSeries: function (cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  },

  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeries: function (cb, context) {
    each(this._componentsMap.get('series'), cb, context);
  },

  /**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachSeriesByType: function (subType, cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  },

  /**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeriesByType: function (subType, cb, context) {
    return each(this.getSeriesByType(subType), cb, context);
  },

  /**
   * @param {module:echarts/model/Series} seriesModel
   */
  isSeriesFiltered: function (seriesModel) {
    assertSeriesInitialized(this);
    return zrUtil.indexOf(this._seriesIndices, seriesModel.componentIndex) < 0;
  },

  /**
   * @return {Array.<number>}
   */
  getCurrentSeriesIndices: function () {
    return (this._seriesIndices || []).slice();
  },

  /**
   * @param {Function} cb
   * @param {*} context
   */
  filterSeries: function (cb, context) {
    assertSeriesInitialized(this);
    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
    this._seriesIndices = createSeriesIndices(filteredSeries);
  },
  restoreData: function () {
    var componentsMap = this._componentsMap;
    this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      componentTypes.push(componentType);
    });
    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
      each(componentsMap.get(componentType), function (component) {
        component.restoreData();
      });
    });
  }
});
/**
 * @inner
 */

function mergeTheme(option, theme) {
  zrUtil.each(theme, function (themeItem, name) {
    // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
    if (!ComponentModel.hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? zrUtil.clone(themeItem) : zrUtil.merge(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function initBase(baseOption) {
  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.

  this.option = {};
  this.option[OPTION_INNER_KEY] = 1;
  /**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */

  this._componentsMap = zrUtil.createHashMap({
    series: []
  });
  /**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */

  this._seriesIndices = null;
  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property

  zrUtil.merge(baseOption, globalDefault, false);
  this.mergeOption(baseOption);
}
/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */


function getComponentsByTypes(componentsMap, types) {
  if (!zrUtil.isArray(types)) {
    types = types ? [types] : [];
  }

  var ret = {};
  each(types, function (type) {
    ret[type] = (componentsMap.get(type) || []).slice();
  });
  return ret;
}
/**
 * @inner
 */


function determineSubType(mainType, newCptOption, existComponent) {
  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * @inner
 */


function createSeriesIndices(seriesModels) {
  return map(seriesModels, function (series) {
    return series.componentIndex;
  }) || [];
}
/**
 * @inner
 */


function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
    return cpt.subType === condition.subType;
  }) : components;
}
/**
 * @inner
 */


function assertSeriesInitialized(ecModel) {}

zrUtil.mixin(GlobalModel, colorPaletteMinin);
var _default = GlobalModel;
module.exports = _default;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var ComponentModel = __webpack_require__(32);

/**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */
var each = zrUtil.each;
var clone = zrUtil.clone;
var map = zrUtil.map;
var merge = zrUtil.merge;
var QUERY_REG = /^(min|max)?(.+)$/;
/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */

function OptionManager(api) {
  /**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */
  this._api = api;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._timelineOptions = [];
  /**
   * @private
   * @type {Array.<Object>}
   */

  this._mediaList = [];
  /**
   * @private
   * @type {Object}
   */

  this._mediaDefault;
  /**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */

  this._currentMediaIndices = [];
  /**
   * @private
   * @type {Object}
   */

  this._optionBackup;
  /**
   * @private
   * @type {Object}
   */

  this._newBaseOption;
} // timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);


OptionManager.prototype = {
  constructor: OptionManager,

  /**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */
  setOption: function (rawOption, optionPreprocessorFuncs) {
    rawOption = clone(rawOption, true); // FIXME
    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。

    var oldOptionBackup = this._optionBackup;
    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (oldOptionBackup) {
      // Only baseOption can be merged.
      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline opitons will not be merged to the formers, but just substitude them.

      if (newParsedOption.timelineOptions.length) {
        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        oldOptionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  },

  /**
   * @param {boolean} isRecreate
   * @return {Object}
   */
  mountOption: function (isRecreate) {
    var optionBackup = this._optionBackup; // TODO
    // 如果没有reset功能则不clone。

    this._timelineOptions = map(optionBackup.timelineOptions, clone);
    this._mediaList = map(optionBackup.mediaList, clone);
    this._mediaDefault = clone(optionBackup.mediaDefault);
    this._currentMediaIndices = [];
    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */
  getTimelineOption: function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
      }
    }

    return option;
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */
  getMediaOption: function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = map(indices, function (index) {
        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  }
};

function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
  var timelineOptions = [];
  var mediaList = [];
  var mediaDefault;
  var baseOption; // Compatible with ec2.

  var timelineOpt = rawOption.timeline;

  if (rawOption.baseOption) {
    baseOption = rawOption.baseOption;
  } // For timeline


  if (timelineOpt || rawOption.options) {
    baseOption = baseOption || {};
    timelineOptions = (rawOption.options || []).slice();
  } // For media query


  if (rawOption.media) {
    baseOption = baseOption || {};
    var media = rawOption.media;
    each(media, function (singleMedia) {
      if (singleMedia && singleMedia.option) {
        if (singleMedia.query) {
          mediaList.push(singleMedia);
        } else if (!mediaDefault) {
          // Use the first media default.
          mediaDefault = singleMedia;
        }
      }
    });
  } // For normal option


  if (!baseOption) {
    baseOption = rawOption;
  } // Set timelineOpt to baseOption in ec3,
  // which is convenient for merge option.


  if (!baseOption.timeline) {
    baseOption.timeline = timelineOpt;
  } // Preprocess.


  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
    return media.option;
  })), function (option) {
    each(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  });
  return {
    baseOption: baseOption,
    timelineOptions: timelineOptions,
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lowser case for convenientce.

  };
  var applicatable = true;
  zrUtil.each(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicatable = false;
    }
  });
  return applicatable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */


function mergeOption(oldOption, newOption) {
  newOption = newOption || {};
  each(newOption, function (newCptOpt, mainType) {
    if (newCptOpt == null) {
      return;
    }

    var oldCptOpt = oldOption[mainType];

    if (!ComponentModel.hasClass(mainType)) {
      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
    } else {
      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
      oldOption[mainType] = map(mapResult, function (item) {
        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
      });
    }
  });
}

var _default = OptionManager;
module.exports = _default;

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  platform = navigator.platform || '';
}

var _default = {
  // 全图默认背景
  // backgroundColor: 'rgba(0,0,0,0)',
  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
  // 浅色
  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
  // 深色
  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
  // 默认需要 Grid 配置项
  // grid: {},
  // 主题，主题
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 300,
  animationEasing: 'exponentialOut',
  animationEasingUpdate: 'cubicOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
};
module.exports = _default;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(119);

var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
var _default = {
  getAreaStyle: function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  }
};
module.exports = _default;

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

var _default = {
  getBoxLayoutParams: function () {
    return {
      left: this.get('left'),
      top: this.get('top'),
      right: this.get('right'),
      bottom: this.get('bottom'),
      width: this.get('width'),
      height: this.get('height')
    };
  }
};
module.exports = _default;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(119);

var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
var _default = {
  getItemStyle: function (excludes, includes) {
    var style = getItemStyle(this, excludes, includes);
    var lineDash = this.getBorderLineDash();
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getBorderLineDash: function () {
    var lineType = this.get('borderType');
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
  }
};
module.exports = _default;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(119);

var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getLineStyle: function (excludes) {
    var style = getLineStyle(this, excludes);
    var lineDash = this.getLineDash(style.lineWidth);
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getLineDash: function (lineWidth) {
    if (lineWidth == null) {
      lineWidth = 1;
    }

    var lineType = this.get('type');
    var dotSize = Math.max(lineWidth, 2);
    var dashSize = lineWidth * 4;
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
  }
};
module.exports = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var textContain = __webpack_require__(70);

var graphicUtil = __webpack_require__(5);

var PATH_COLOR = ['textStyle', 'color'];
var _default = {
  /**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */
  getTextColor: function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  },

  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */
  getFont: function () {
    return graphicUtil.getFont({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  },
  getTextRect: function (text) {
    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('rich'), this.getShallow('truncateText'));
  }
};
module.exports = _default;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(0);

var each = _util.each;
var isArray = _util.isArray;
var isObject = _util.isObject;

var compatStyle = __webpack_require__(1611);

var _model = __webpack_require__(15);

var normalizeToArray = _model.normalizeToArray;

// Compatitable with 2.0
function get(opt, path) {
  path = path.split(',');
  var obj = opt;

  for (var i = 0; i < path.length; i++) {
    obj = obj && obj[path[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set(opt, path, val, overwrite) {
  path = path.split(',');
  var obj = opt;
  var key;

  for (var i = 0; i < path.length - 1; i++) {
    key = path[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[path[i]] == null) {
    obj[path[i]] = val;
  }
}

function compatLayoutProperties(option) {
  each(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
var COMPATITABLE_SERIES = ['bar', 'boxplot', 'candlestick', 'chord', 'effectScatter', 'funnel', 'gauge', 'lines', 'graph', 'heatmap', 'line', 'map', 'parallel', 'pie', 'radar', 'sankey', 'scatter', 'treemap'];

function _default(option, isTheme) {
  compatStyle(option, isTheme); // Make sure series array for model initialization.

  option.series = normalizeToArray(option.series);
  each(option.series, function (seriesOpt) {
    if (!isObject(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;
      }
    }

    if (seriesType === 'gauge') {
      var pointerColor = get(seriesOpt, 'pointer.color');
      pointerColor != null && set(seriesOpt, 'itemStyle.normal.color', pointerColor);
    }

    for (var i = 0; i < COMPATITABLE_SERIES.length; i++) {
      if (COMPATITABLE_SERIES[i] === seriesOpt.type) {
        compatLayoutProperties(seriesOpt);
        break;
      }
    }
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  each(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!isArray(options)) {
        options = [options];
      }

      each(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var modelUtil = __webpack_require__(15);

var each = zrUtil.each;
var isObject = zrUtil.isObject;
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function compatTextStyle(opt, propName) {
  var labelOptSingle = isObject(opt) && opt[propName];
  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];

      if (textStyle.hasOwnProperty(propName)) {
        labelOptSingle[propName] = textStyle[propName];
      }
    }
  }
}

function compatLabelTextStyle(labelOpt) {
  if (isObject(labelOpt)) {
    compatTextStyle(labelOpt, 'normal');
    compatTextStyle(labelOpt, 'emphasis');
  }
}

function processSeries(seriesOpt) {
  if (!isObject(seriesOpt)) {
    return;
  }

  compatItemStyle(seriesOpt);
  compatLabelTextStyle(seriesOpt.label); // treemap

  compatLabelTextStyle(seriesOpt.upperLabel); // graph

  compatLabelTextStyle(seriesOpt.edgeLabel);
  var markPoint = seriesOpt.markPoint;
  compatItemStyle(markPoint);
  compatLabelTextStyle(markPoint && markPoint.label);
  var markLine = seriesOpt.markLine;
  compatItemStyle(seriesOpt.markLine);
  compatLabelTextStyle(markLine && markLine.label);
  var markArea = seriesOpt.markArea;
  compatLabelTextStyle(markArea && markArea.label); // For gauge

  compatTextStyle(seriesOpt, 'axisLabel');
  compatTextStyle(seriesOpt, 'title');
  compatTextStyle(seriesOpt, 'detail');
  var data = seriesOpt.data;

  if (data) {
    for (var i = 0; i < data.length; i++) {
      compatItemStyle(data[i]);
      compatLabelTextStyle(data[i] && data[i].label);
    }
  } // mark point data


  var markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatItemStyle(mpData[i]);
      compatLabelTextStyle(mpData[i] && mpData[i].label);
    }
  } // mark line data


  var markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (zrUtil.isArray(mlData[i])) {
        compatItemStyle(mlData[i][0]);
        compatLabelTextStyle(mlData[i][0] && mlData[i][0].label);
        compatItemStyle(mlData[i][1]);
        compatLabelTextStyle(mlData[i][1] && mlData[i][1].label);
      } else {
        compatItemStyle(mlData[i]);
        compatLabelTextStyle(mlData[i] && mlData[i].label);
      }
    }
  }
}

function toArr(o) {
  return zrUtil.isArray(o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (zrUtil.isArray(o) ? o[0] : o) || {};
}

function _default(option, isTheme) {
  each(toArr(option.series), function (seriesOpt) {
    isObject(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each(axes, function (axisName) {
    each(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each(toArr(option.calendar), function (calendarOpt) {
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name');
  });
  each(toArr(option.geo), function (geoOpt) {
    if (isObject(geoOpt)) {
      compatLabelTextStyle(geoOpt.label);
      each(toArr(geoOpt.regions), function (regionObj) {
        compatLabelTextStyle(regionObj.label);
      });
    }
  });
  compatLabelTextStyle(toObj(option.timeline).label);
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
}

module.exports = _default;

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    }

    return max;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    }

    return min;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame, value) {
  return Math.round(frame.length / 2);
};

function _default(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var sampling = seriesModel.get('sampling');
    var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling

    if (coordSys.type === 'cartesian2d' && sampling) {
      var baseAxis = coordSys.getBaseAxis();
      var valueAxis = coordSys.getOtherAxis(baseAxis);
      var extent = baseAxis.getExtent(); // Coordinste system has been resized

      var size = extent[1] - extent[0];
      var rate = Math.round(data.count() / size);

      if (rate > 1) {
        var sampler;

        if (typeof sampling === 'string') {
          sampler = samplers[sampling];
        } else if (typeof sampling === 'function') {
          sampler = sampling;
        }

        if (sampler) {
          data = data.downSample(valueAxis.dim, 1 / rate, sampler, indexSampler);
          seriesModel.setData(data);
        }
      }
    }
  }, this);
}

module.exports = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Scale = __webpack_require__(196);

var numberUtil = __webpack_require__(8);

var IntervalScale = __webpack_require__(195);

/**
 * Log scale
 * @module echarts/scale/Log
 */
// Use some method of IntervalScale
var scaleProto = Scale.prototype;
var intervalScaleProto = IntervalScale.prototype;
var getPrecisionSafe = numberUtil.getPrecisionSafe;
var roundingErrorFix = numberUtil.round;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow = Math.pow;
var mathLog = Math.log;
var LogScale = Scale.extend({
  type: 'log',
  base: 10,
  $constructor: function () {
    Scale.apply(this, arguments);
    this._originalScale = new IntervalScale();
  },

  /**
   * @return {Array.<number>}
   */
  getTicks: function () {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    return zrUtil.map(intervalScaleProto.getTicks.call(this), function (val) {
      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158

      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return powVal;
    }, this);
  },

  /**
   * @param {number} val
   * @return {string}
   */
  getLabel: intervalScaleProto.getLabel,

  /**
   * @param  {number} val
   * @return {number}
   */
  scale: function (val) {
    val = scaleProto.scale.call(this, val);
    return mathPow(this.base, val);
  },

  /**
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var base = this.base;
    start = mathLog(start) / mathLog(base);
    end = mathLog(end) / mathLog(base);
    intervalScaleProto.setExtent.call(this, start, end);
  },

  /**
   * @return {number} end
   */
  getExtent: function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow(base, extent[0]);
    extent[1] = mathPow(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  },

  /**
   * @param  {Array.<number>} extent
   */
  unionExtent: function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getDataExtent(dim, true, function (val) {
      return val > 0;
    }));
  },

  /**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */
  niceTicks: function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = numberUtil.quantity(span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  },

  /**
   * Nice extent.
   * @override
   */
  niceExtent: function (opt) {
    intervalScaleProto.niceExtent.call(this, opt);
    var originalScale = this._originalScale;
    originalScale.__fixMin = opt.fixMin;
    originalScale.__fixMax = opt.fixMax;
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  LogScale.prototype[methodName] = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return scaleProto[methodName].call(this, val);
  };
});

LogScale.create = function () {
  return new LogScale();
};

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, getPrecisionSafe(originalVal));
}

var _default = LogScale;
module.exports = _default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Scale = __webpack_require__(196);

/**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */
// FIXME only one data
var scaleProto = Scale.prototype;
var OrdinalScale = Scale.extend({
  type: 'ordinal',
  init: function (data, extent) {
    this._data = data;
    this._extent = extent || [0, data.length - 1];
  },
  parse: function (val) {
    return typeof val === 'string' ? zrUtil.indexOf(this._data, val) // val might be float.
    : Math.round(val);
  },
  contain: function (rank) {
    rank = this.parse(rank);
    return scaleProto.contain.call(this, rank) && this._data[rank] != null;
  },

  /**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */
  normalize: function (val) {
    return scaleProto.normalize.call(this, this.parse(val));
  },
  scale: function (val) {
    return Math.round(scaleProto.scale.call(this, val));
  },

  /**
   * @return {Array}
   */
  getTicks: function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push(rank);
      rank++;
    }

    return ticks;
  },

  /**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */
  getLabel: function (n) {
    return this._data[n];
  },

  /**
   * @return {number}
   */
  count: function () {
    return this._extent[1] - this._extent[0] + 1;
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getDataExtent(dim, false));
  },
  niceTicks: zrUtil.noop,
  niceExtent: zrUtil.noop
});
/**
 * @return {module:echarts/scale/Time}
 */

OrdinalScale.create = function () {
  return new OrdinalScale();
};

var _default = OrdinalScale;
module.exports = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var numberUtil = __webpack_require__(8);

var formatUtil = __webpack_require__(21);

var scaleHelper = __webpack_require__(489);

var IntervalScale = __webpack_require__(195);

// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var intervalScaleProto = IntervalScale.prototype;
var mathCeil = Math.ceil;
var mathFloor = Math.floor;
var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};
/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */


var TimeScale = IntervalScale.extend({
  type: 'time',

  /**
   * @override
   */
  getLabel: function (val) {
    var stepLvl = this._stepLvl;
    var date = new Date(val);
    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
  },

  /**
   * @override
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= ONE_DAY;
      extent[1] += ONE_DAY;
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - ONE_DAY;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
    }
  },

  /**
   * @override
   */
  niceTicks: function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    var approxInterval = span / approxTickNum;

    if (minInterval != null && approxInterval < minInterval) {
      approxInterval = minInterval;
    }

    if (maxInterval != null && approxInterval > maxInterval) {
      approxInterval = maxInterval;
    }

    var scaleLevelsLen = scaleLevels.length;
    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
    var interval = level[1]; // Same with interval scale if span is much larger than 1 year

    if (level[0] === 'year') {
      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
      // var niceYearSpan = numberUtil.nice(yearSpan, false);

      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
      interval *= yearStep;
    }

    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
    scaleHelper.fixExtent(niceExtent, extent);
    this._stepLvl = level; // Interval will be used in getTicks

    this._interval = interval;
    this._niceExtent = niceExtent;
  },
  parse: function (val) {
    // val might be float.
    return +numberUtil.parseDate(val);
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  TimeScale.prototype[methodName] = function (val) {
    return intervalScaleProto[methodName].call(this, this.parse(val));
  };
}); // Steps from d3

var scaleLevels = [// Format              interval
['hh:mm:ss', ONE_SECOND], // 1s
['hh:mm:ss', ONE_SECOND * 5], // 5s
['hh:mm:ss', ONE_SECOND * 10], // 10s
['hh:mm:ss', ONE_SECOND * 15], // 15s
['hh:mm:ss', ONE_SECOND * 30], // 30s
['hh:mm\nMM-dd', ONE_MINUTE], // 1m
['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
['hh:mm\nMM-dd', ONE_HOUR], // 1h
['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
['MM-dd\nyyyy', ONE_DAY], // 1d
['MM-dd\nyyyy', ONE_DAY * 2], // 2d
['MM-dd\nyyyy', ONE_DAY * 3], // 3d
['MM-dd\nyyyy', ONE_DAY * 4], // 4d
['MM-dd\nyyyy', ONE_DAY * 5], // 5d
['MM-dd\nyyyy', ONE_DAY * 6], // 6d
['week', ONE_DAY * 7], // 7d
['MM-dd\nyyyy', ONE_DAY * 10], // 10d
['week', ONE_DAY * 14], // 2w
['week', ONE_DAY * 21], // 3w
['month', ONE_DAY * 31], // 1M
['week', ONE_DAY * 42], // 6w
['month', ONE_DAY * 62], // 2M
['week', ONE_DAY * 42], // 10w
['quarter', ONE_DAY * 380 / 4], // 3M
['month', ONE_DAY * 31 * 4], // 4M
['month', ONE_DAY * 31 * 5], // 5M
['half-year', ONE_DAY * 380 / 2], // 6M
['month', ONE_DAY * 31 * 8], // 8M
['month', ONE_DAY * 31 * 10], // 10M
['year', ONE_DAY * 380] // 1Y
];
/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */

TimeScale.create = function (model) {
  return new TimeScale({
    useUTC: model.ecModel.get('useUTC')
  });
};

var _default = TimeScale;
module.exports = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

/**
 * @param {number} [time=500] Time in ms
 * @param {string} [easing='linear']
 * @param {number} [delay=0]
 * @param {Function} [callback]
 *
 * @example
 *  // Animate position
 *  animation
 *      .createWrap()
 *      .add(el1, {position: [10, 10]})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */
function createWrap() {
  var storage = [];
  var elExistsMap = {};
  var doneCallback;
  return {
    /**
     * Caution: a el can only be added once, otherwise 'done'
     * might not be called. This method checks this (by el.id),
     * suppresses adding and returns false when existing el found.
     *
     * @param {modele:zrender/Element} el
     * @param {Object} target
     * @param {number} [time=500]
     * @param {number} [delay=0]
     * @param {string} [easing='linear']
     * @return {boolean} Whether adding succeeded.
     *
     * @example
     *     add(el, target, time, delay, easing);
     *     add(el, target, time, easing);
     *     add(el, target, time);
     *     add(el, target);
     */
    add: function (el, target, time, delay, easing) {
      if (zrUtil.isString(delay)) {
        easing = delay;
        delay = 0;
      }

      if (elExistsMap[el.id]) {
        return false;
      }

      elExistsMap[el.id] = 1;
      storage.push({
        el: el,
        target: target,
        time: time,
        delay: delay,
        easing: easing
      });
      return true;
    },

    /**
     * Only execute when animation finished. Will not execute when any
     * of 'stop' or 'stopAnimation' called.
     *
     * @param {Function} callback
     */
    done: function (callback) {
      doneCallback = callback;
      return this;
    },

    /**
     * Will stop exist animation firstly.
     */
    start: function () {
      var count = storage.length;

      for (var i = 0, len = storage.length; i < len; i++) {
        var item = storage[i];
        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
      }

      return this;

      function done() {
        count--;

        if (!count) {
          storage.length = 0;
          elExistsMap = {};
          doneCallback && doneCallback();
        }
      }
    }
  };
}

exports.createWrap = createWrap;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var Gradient = __webpack_require__(213);

function _default(ecModel) {
  function encodeColor(seriesModel) {
    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.normal.color').split('.');
    var data = seriesModel.getData();
    var color = seriesModel.get(colorAccessPath) // Set in itemStyle
    || seriesModel.getColorFromPalette(seriesModel.get('name')); // Default color
    // FIXME Set color function or use the platte color

    data.setVisual('color', color); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (typeof color === 'function' && !(color instanceof Gradient)) {
        data.each(function (idx) {
          data.setItemVisual(idx, 'color', color(seriesModel.getDataParams(idx)));
        });
      } // itemStyle in each data item


      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var color = itemModel.get(colorAccessPath, true);

        if (color != null) {
          data.setItemVisual(idx, 'color', color);
        }
      });
    }
  }

  ecModel.eachRawSeries(encodeColor);
}

module.exports = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.2+97478eb6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(2000);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69), __webpack_require__(38)))

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * FullCalendar v3.8.2
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(2), __webpack_require__(493));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["FullCalendar"] = factory(require("moment"), require("jquery"));
	else
		root["FullCalendar"] = factory(root["moment"], root["jQuery"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 236);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

/*
derived from:
https://github.com/Microsoft/tslib/blob/v1.6.0/tslib.js

only include the helpers we need, to keep down filesize
*/
var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p]; };
exports.__extends = function (d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
function compensateScroll(rowEls, scrollbarWidths) {
    if (scrollbarWidths.left) {
        rowEls.css({
            'border-left-width': 1,
            'margin-left': scrollbarWidths.left - 1
        });
    }
    if (scrollbarWidths.right) {
        rowEls.css({
            'border-right-width': 1,
            'margin-right': scrollbarWidths.right - 1
        });
    }
}
exports.compensateScroll = compensateScroll;
// Undoes compensateScroll and restores all borders/margins
function uncompensateScroll(rowEls) {
    rowEls.css({
        'margin-left': '',
        'margin-right': '',
        'border-left-width': '',
        'border-right-width': ''
    });
}
exports.uncompensateScroll = uncompensateScroll;
// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    $('body').addClass('fc-not-allowed');
}
exports.disableCursor = disableCursor;
// Returns the mouse cursor to its original look
function enableCursor() {
    $('body').removeClass('fc-not-allowed');
}
exports.enableCursor = enableCursor;
// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
// reduces the available height.
function distributeHeight(els, availableHeight, shouldRedistribute) {
    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
    var flexOffsets = []; // amount of vertical space it takes up
    var flexHeights = []; // actual css height
    var usedHeight = 0;
    undistributeHeight(els); // give all elements their natural height
    // find elements that are below the recommended height (expandable).
    // important to query for heights in a single first pass (to avoid reflow oscillation).
    els.each(function (i, el) {
        var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = $(el).outerHeight(true);
        if (naturalOffset < minOffset) {
            flexEls.push(el);
            flexOffsets.push(naturalOffset);
            flexHeights.push($(el).height());
        }
        else {
            // this element stretches past recommended height (non-expandable). mark the space as occupied.
            usedHeight += naturalOffset;
        }
    });
    // readjust the recommended height to only consider the height available to non-maxed-out rows.
    if (shouldRedistribute) {
        availableHeight -= usedHeight;
        minOffset1 = Math.floor(availableHeight / flexEls.length);
        minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
    }
    // assign heights to all expandable elements
    $(flexEls).each(function (i, el) {
        var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = flexOffsets[i];
        var naturalHeight = flexHeights[i];
        var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
        if (naturalOffset < minOffset) {
            $(el).height(newHeight);
        }
    });
}
exports.distributeHeight = distributeHeight;
// Undoes distrubuteHeight, restoring all els to their natural height
function undistributeHeight(els) {
    els.height('');
}
exports.undistributeHeight = undistributeHeight;
// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
// cells to be that width.
// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
function matchCellWidths(els) {
    var maxInnerWidth = 0;
    els.find('> *').each(function (i, innerEl) {
        var innerWidth = $(innerEl).outerWidth();
        if (innerWidth > maxInnerWidth) {
            maxInnerWidth = innerWidth;
        }
    });
    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
    els.width(maxInnerWidth);
    return maxInnerWidth;
}
exports.matchCellWidths = matchCellWidths;
// Given one element that resides inside another,
// Subtracts the height of the inner element from the outer element.
function subtractInnerElHeight(outerEl, innerEl) {
    var both = outerEl.add(innerEl);
    var diff;
    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
    both.css({
        position: 'relative',
        left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
    });
    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
    both.css({ position: '', left: '' }); // undo hack
    return diff;
}
exports.subtractInnerElHeight = subtractInnerElHeight;
/* Element Geom Utilities
----------------------------------------------------------------------------------------------------------------------*/
// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
function getScrollParent(el) {
    var position = el.css('position');
    var scrollParent = el.parents().filter(function () {
        var parent = $(this);
        return (/(auto|scroll)/).test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
    }).eq(0);
    return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
}
exports.getScrollParent = getScrollParent;
// Queries the outer bounding area of a jQuery element.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getOuterRect(el, origin) {
    var offset = el.offset();
    var left = offset.left - (origin ? origin.left : 0);
    var top = offset.top - (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el.outerWidth(),
        top: top,
        bottom: top + el.outerHeight()
    };
}
exports.getOuterRect = getOuterRect;
// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
// WARNING: given element can't have borders
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getClientRect(el, origin) {
    var offset = el.offset();
    var scrollbarWidths = getScrollbarWidths(el);
    var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el[0].clientWidth,
        top: top,
        bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
    };
}
exports.getClientRect = getClientRect;
// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getContentRect(el, origin) {
    var offset = el.offset(); // just outside of border, margin not included
    var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
        (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
        (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el.width(),
        top: top,
        bottom: top + el.height()
    };
}
exports.getContentRect = getContentRect;
// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
// WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getScrollbarWidths(el) {
    var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
    var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
    var widths;
    leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
    bottomWidth = sanitizeScrollbarWidth(bottomWidth);
    widths = { left: 0, right: 0, top: 0, bottom: bottomWidth };
    if (getIsLeftRtlScrollbars() && el.css('direction') === 'rtl') {
        widths.left = leftRightWidth;
    }
    else {
        widths.right = leftRightWidth;
    }
    return widths;
}
exports.getScrollbarWidths = getScrollbarWidths;
// The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
// retina displays, rounding, and IE11. Massage them into a usable value.
function sanitizeScrollbarWidth(width) {
    width = Math.max(0, width); // no negatives
    width = Math.round(width);
    return width;
}
// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
var _isLeftRtlScrollbars = null;
function getIsLeftRtlScrollbars() {
    if (_isLeftRtlScrollbars === null) {
        _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
    }
    return _isLeftRtlScrollbars;
}
function computeIsLeftRtlScrollbars() {
    var el = $('<div><div/></div>')
        .css({
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    })
        .appendTo('body');
    var innerEl = el.children();
    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
    el.remove();
    return res;
}
// Retrieves a jQuery element's computed CSS value as a floating-point number.
// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
function getCssFloat(el, prop) {
    return parseFloat(el.css(prop)) || 0;
}
/* Mouse / Touch Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.which === 1 && !ev.ctrlKey;
}
exports.isPrimaryMouseButton = isPrimaryMouseButton;
function getEvX(ev) {
    var touches = ev.originalEvent.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageX;
    }
    return ev.pageX;
}
exports.getEvX = getEvX;
function getEvY(ev) {
    var touches = ev.originalEvent.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageY;
    }
    return ev.pageY;
}
exports.getEvY = getEvY;
function getEvIsTouch(ev) {
    return /^touch/.test(ev.type);
}
exports.getEvIsTouch = getEvIsTouch;
function preventSelection(el) {
    el.addClass('fc-unselectable')
        .on('selectstart', preventDefault);
}
exports.preventSelection = preventSelection;
function allowSelection(el) {
    el.removeClass('fc-unselectable')
        .off('selectstart', preventDefault);
}
exports.allowSelection = allowSelection;
// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
exports.preventDefault = preventDefault;
/* General Geometry Utils
----------------------------------------------------------------------------------------------------------------------*/
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) {
        return res;
    }
    return false;
}
exports.intersectRects = intersectRects;
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
exports.constrainPoint = constrainPoint;
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
exports.getRectCenter = getRectCenter;
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
exports.diffPoints = diffPoints;
/* Object Ordering by Field
----------------------------------------------------------------------------------------------------------------------*/
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') {
        tokens = input.split(/\s*,\s*/);
    }
    else if (typeof input === 'function') {
        tokens = [input];
    }
    else if ($.isArray(input)) {
        tokens = input;
    }
    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        if (typeof token === 'string') {
            specs.push(token.charAt(0) === '-' ?
                { field: token.substring(1), order: -1 } :
                { field: token, order: 1 });
        }
        else if (typeof token === 'function') {
            specs.push({ func: token });
        }
    }
    return specs;
}
exports.parseFieldSpecs = parseFieldSpecs;
function compareByFieldSpecs(obj1, obj2, fieldSpecs, obj1fallback, obj2fallback) {
    var i;
    var cmp;
    for (i = 0; i < fieldSpecs.length; i++) {
        cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i], obj1fallback, obj2fallback);
        if (cmp) {
            return cmp;
        }
    }
    return 0;
}
exports.compareByFieldSpecs = compareByFieldSpecs;
function compareByFieldSpec(obj1, obj2, fieldSpec, obj1fallback, obj2fallback) {
    if (fieldSpec.func) {
        return fieldSpec.func(obj1, obj2);
    }
    var val1 = obj1[fieldSpec.field];
    var val2 = obj2[fieldSpec.field];
    if (val1 == null && obj1fallback) {
        val1 = obj1fallback[fieldSpec.field];
    }
    if (val2 == null && obj2fallback) {
        val2 = obj2fallback[fieldSpec.field];
    }
    return flexibleCompare(val1, val2) * (fieldSpec.order || 1);
}
exports.compareByFieldSpec = compareByFieldSpec;
function flexibleCompare(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (b == null) {
        return -1;
    }
    if (a == null) {
        return 1;
    }
    if ($.type(a) === 'string' || $.type(b) === 'string') {
        return String(a).localeCompare(String(b));
    }
    return a - b;
}
exports.flexibleCompare = flexibleCompare;
/* Date Utilities
----------------------------------------------------------------------------------------------------------------------*/
exports.dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
exports.unitsDesc = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond']; // descending
// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
// Moments will have their timezones normalized.
function diffDayTime(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
        ms: a.time() - b.time() // time-of-day from day start. disregards timezone
    });
}
exports.diffDayTime = diffDayTime;
// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
function diffDay(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
    });
}
exports.diffDay = diffDay;
// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
function diffByUnit(a, b, unit) {
    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
    unit);
}
exports.diffByUnit = diffByUnit;
// Computes the unit name of the largest whole-unit period of time.
// For example, 48 hours will be "days" whereas 49 hours will be "hours".
// Accepts start/end, a range object, or an original duration object.
function computeGreatestUnit(start, end) {
    var i;
    var unit;
    var val;
    for (i = 0; i < exports.unitsDesc.length; i++) {
        unit = exports.unitsDesc[i];
        val = computeRangeAs(unit, start, end);
        if (val >= 1 && isInt(val)) {
            break;
        }
    }
    return unit; // will be "milliseconds" if nothing else matches
}
exports.computeGreatestUnit = computeGreatestUnit;
// like computeGreatestUnit, but has special abilities to interpret the source input for clues
function computeDurationGreatestUnit(duration, durationInput) {
    var unit = computeGreatestUnit(duration);
    // prevent days:7 from being interpreted as a week
    if (unit === 'week' && typeof durationInput === 'object' && durationInput.days) {
        unit = 'day';
    }
    return unit;
}
exports.computeDurationGreatestUnit = computeDurationGreatestUnit;
// Computes the number of units (like "hours") in the given range.
// Range can be a {start,end} object, separate start/end args, or a Duration.
// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
// of month-diffing logic (which tends to vary from version to version).
function computeRangeAs(unit, start, end) {
    if (end != null) {
        return end.diff(start, unit, true);
    }
    else if (moment.isDuration(start)) {
        return start.as(unit);
    }
    else {
        return start.end.diff(start.start, unit, true);
    }
}
// Intelligently divides a range (specified by a start/end params) by a duration
function divideRangeByDuration(start, end, dur) {
    var months;
    if (durationHasTime(dur)) {
        return (end - start) / dur;
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
        return end.diff(start, 'months', true) / months;
    }
    return end.diff(start, 'days', true) / dur.asDays();
}
exports.divideRangeByDuration = divideRangeByDuration;
// Intelligently divides one duration by another
function divideDurationByDuration(dur1, dur2) {
    var months1;
    var months2;
    if (durationHasTime(dur1) || durationHasTime(dur2)) {
        return dur1 / dur2;
    }
    months1 = dur1.asMonths();
    months2 = dur2.asMonths();
    if (Math.abs(months1) >= 1 && isInt(months1) &&
        Math.abs(months2) >= 1 && isInt(months2)) {
        return months1 / months2;
    }
    return dur1.asDays() / dur2.asDays();
}
exports.divideDurationByDuration = divideDurationByDuration;
// Intelligently multiplies a duration by a number
function multiplyDuration(dur, n) {
    var months;
    if (durationHasTime(dur)) {
        return moment.duration(dur * n);
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
        return moment.duration({ months: months * n });
    }
    return moment.duration({ days: dur.asDays() * n });
}
exports.multiplyDuration = multiplyDuration;
// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
function durationHasTime(dur) {
    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
}
exports.durationHasTime = durationHasTime;
function isNativeDate(input) {
    return Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
}
exports.isNativeDate = isNativeDate;
// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
function isTimeString(str) {
    return typeof str === 'string' &&
        /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
}
exports.isTimeString = isTimeString;
/* Logging and Debug
----------------------------------------------------------------------------------------------------------------------*/
function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.log) {
        return console.log.apply(console, args);
    }
}
exports.log = log;
function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.warn) {
        return console.warn.apply(console, args);
    }
    else {
        return log.apply(null, args);
    }
}
exports.warn = warn;
/* General Utilities
----------------------------------------------------------------------------------------------------------------------*/
var hasOwnPropMethod = {}.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexProps) {
    var dest = {};
    var i;
    var name;
    var complexObjs;
    var j;
    var val;
    var props;
    if (complexProps) {
        for (i = 0; i < complexProps.length; i++) {
            name = complexProps[i];
            complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for (j = propObjs.length - 1; j >= 0; j--) {
                val = propObjs[j][name];
                if (typeof val === 'object') {
                    complexObjs.unshift(val);
                }
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) {
                dest[name] = mergeProps(complexObjs);
            }
        }
    }
    // copy values into the destination, going from last to first
    for (i = propObjs.length - 1; i >= 0; i--) {
        props = propObjs[i];
        for (name in props) {
            if (!(name in dest)) {
                dest[name] = props[name];
            }
        }
    }
    return dest;
}
exports.mergeProps = mergeProps;
function copyOwnProps(src, dest) {
    for (var name_1 in src) {
        if (hasOwnProp(src, name_1)) {
            dest[name_1] = src[name_1];
        }
    }
}
exports.copyOwnProps = copyOwnProps;
function hasOwnProp(obj, name) {
    return hasOwnPropMethod.call(obj, name);
}
exports.hasOwnProp = hasOwnProp;
function applyAll(functions, thisObj, args) {
    if ($.isFunction(functions)) {
        functions = [functions];
    }
    if (functions) {
        var i = void 0;
        var ret = void 0;
        for (i = 0; i < functions.length; i++) {
            ret = functions[i].apply(thisObj, args) || ret;
        }
        return ret;
    }
}
exports.applyAll = applyAll;
function removeMatching(array, testFunc) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (testFunc(array[i])) {
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeMatching = removeMatching;
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeExact = removeExact;
function isArraysEqual(a0, a1) {
    var len = a0.length;
    var i;
    if (len == null || len !== a1.length) {
        return false;
    }
    for (i = 0; i < len; i++) {
        if (a0[i] !== a1[i]) {
            return false;
        }
    }
    return true;
}
exports.isArraysEqual = isArraysEqual;
function firstDefined() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (args[i] !== undefined) {
            return args[i];
        }
    }
}
exports.firstDefined = firstDefined;
function htmlEscape(s) {
    return (s + '').replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#039;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br />');
}
exports.htmlEscape = htmlEscape;
function stripHtmlEntities(text) {
    return text.replace(/&.*?;/g, '');
}
exports.stripHtmlEntities = stripHtmlEntities;
// Given a hash of CSS properties, returns a string of CSS.
// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
function cssToStr(cssProps) {
    var statements = [];
    $.each(cssProps, function (name, val) {
        if (val != null) {
            statements.push(name + ':' + val);
        }
    });
    return statements.join(';');
}
exports.cssToStr = cssToStr;
// Given an object hash of HTML attribute names to values,
// generates a string that can be injected between < > in HTML
function attrsToStr(attrs) {
    var parts = [];
    $.each(attrs, function (name, val) {
        if (val != null) {
            parts.push(name + '="' + htmlEscape(val) + '"');
        }
    });
    return parts.join(' ');
}
exports.attrsToStr = attrsToStr;
function capitaliseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitaliseFirstLetter = capitaliseFirstLetter;
function compareNumbers(a, b) {
    return a - b;
}
exports.compareNumbers = compareNumbers;
function isInt(n) {
    return n % 1 === 0;
}
exports.isInt = isInt;
// Returns a method bound to the given object context.
// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
// different contexts as identical when binding/unbinding events.
function proxy(obj, methodName) {
    var method = obj[methodName];
    return function () {
        return method.apply(obj, arguments);
    };
}
exports.proxy = proxy;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
function debounce(func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    var args;
    var context;
    var timestamp;
    var result;
    var later = function () {
        var last = +new Date() - timestamp;
        if (last < wait) {
            timeout = setTimeout(later, wait - last);
        }
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    };
    return function () {
        context = this;
        args = arguments;
        timestamp = +new Date();
        var callNow = immediate && !timeout;
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}
exports.debounce = debounce;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var moment_ext_1 = __webpack_require__(10);
var UnzonedRange = /** @class */ (function () {
    function UnzonedRange(startInput, endInput) {
        // TODO: move these into footprint.
        // Especially, doesn't make sense for null startMs/endMs.
        this.isStart = true;
        this.isEnd = true;
        if (moment.isMoment(startInput)) {
            startInput = startInput.clone().stripZone();
        }
        if (moment.isMoment(endInput)) {
            endInput = endInput.clone().stripZone();
        }
        if (startInput) {
            this.startMs = startInput.valueOf();
        }
        if (endInput) {
            this.endMs = endInput.valueOf();
        }
    }
    /*
    SIDEEFFECT: will mutate eventRanges.
    Will return a new array result.
    Only works for non-open-ended ranges.
    */
    UnzonedRange.invertRanges = function (ranges, constraintRange) {
        var invertedRanges = [];
        var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range
        var i;
        var dateRange;
        // ranges need to be in order. required for our date-walking algorithm
        ranges.sort(compareUnzonedRanges);
        for (i = 0; i < ranges.length; i++) {
            dateRange = ranges[i];
            // add the span of time before the event (if there is any)
            if (dateRange.startMs > startMs) {
                invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
            }
            if (dateRange.endMs > startMs) {
                startMs = dateRange.endMs;
            }
        }
        // add the span of time after the last event (if there is any)
        if (startMs < constraintRange.endMs) {
            invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
        }
        return invertedRanges;
    };
    UnzonedRange.prototype.intersect = function (otherRange) {
        var startMs = this.startMs;
        var endMs = this.endMs;
        var newRange = null;
        if (otherRange.startMs != null) {
            if (startMs == null) {
                startMs = otherRange.startMs;
            }
            else {
                startMs = Math.max(startMs, otherRange.startMs);
            }
        }
        if (otherRange.endMs != null) {
            if (endMs == null) {
                endMs = otherRange.endMs;
            }
            else {
                endMs = Math.min(endMs, otherRange.endMs);
            }
        }
        if (startMs == null || endMs == null || startMs < endMs) {
            newRange = new UnzonedRange(startMs, endMs);
            newRange.isStart = this.isStart && startMs === this.startMs;
            newRange.isEnd = this.isEnd && endMs === this.endMs;
        }
        return newRange;
    };
    UnzonedRange.prototype.intersectsWith = function (otherRange) {
        return (this.endMs == null || otherRange.startMs == null || this.endMs > otherRange.startMs) &&
            (this.startMs == null || otherRange.endMs == null || this.startMs < otherRange.endMs);
    };
    UnzonedRange.prototype.containsRange = function (innerRange) {
        return (this.startMs == null || (innerRange.startMs != null && innerRange.startMs >= this.startMs)) &&
            (this.endMs == null || (innerRange.endMs != null && innerRange.endMs <= this.endMs));
    };
    // `date` can be a moment, a Date, or a millisecond time.
    UnzonedRange.prototype.containsDate = function (date) {
        var ms = date.valueOf();
        return (this.startMs == null || ms >= this.startMs) &&
            (this.endMs == null || ms < this.endMs);
    };
    // If the given date is not within the given range, move it inside.
    // (If it's past the end, make it one millisecond before the end).
    // `date` can be a moment, a Date, or a millisecond time.
    // Returns a MS-time.
    UnzonedRange.prototype.constrainDate = function (date) {
        var ms = date.valueOf();
        if (this.startMs != null && ms < this.startMs) {
            ms = this.startMs;
        }
        if (this.endMs != null && ms >= this.endMs) {
            ms = this.endMs - 1;
        }
        return ms;
    };
    UnzonedRange.prototype.equals = function (otherRange) {
        return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
    };
    UnzonedRange.prototype.clone = function () {
        var range = new UnzonedRange(this.startMs, this.endMs);
        range.isStart = this.isStart;
        range.isEnd = this.isEnd;
        return range;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getStart = function () {
        if (this.startMs != null) {
            return moment_ext_1.default.utc(this.startMs).stripZone();
        }
        return null;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getEnd = function () {
        if (this.endMs != null) {
            return moment_ext_1.default.utc(this.endMs).stripZone();
        }
        return null;
    };
    UnzonedRange.prototype.as = function (unit) {
        return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
    };
    return UnzonedRange;
}());
exports.default = UnzonedRange;
/*
Only works for non-open-ended ranges.
*/
function compareUnzonedRanges(range1, range2) {
    return range1.startMs - range2.startMs; // earlier ranges go first
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var ParsableModelMixin_1 = __webpack_require__(208);
var Class_1 = __webpack_require__(32);
var EventDefParser_1 = __webpack_require__(49);
var EventSource = /** @class */ (function (_super) {
    tslib_1.__extends(EventSource, _super);
    // can we do away with calendar? at least for the abstract?
    // useful for buildEventDef
    function EventSource(calendar) {
        var _this = _super.call(this) || this;
        _this.calendar = calendar;
        _this.className = [];
        _this.uid = String(EventSource.uuid++);
        return _this;
    }
    /*
    rawInput can be any data type!
    */
    EventSource.parse = function (rawInput, calendar) {
        var source = new this(calendar);
        if (typeof rawInput === 'object') {
            if (source.applyProps(rawInput)) {
                return source;
            }
        }
        return false;
    };
    EventSource.normalizeId = function (id) {
        if (id) {
            return String(id);
        }
        return null;
    };
    EventSource.prototype.fetch = function (start, end, timezone) {
        // subclasses must implement. must return a promise.
    };
    EventSource.prototype.removeEventDefsById = function (eventDefId) {
        // optional for subclasses to implement
    };
    EventSource.prototype.removeAllEventDefs = function () {
        // optional for subclasses to implement
    };
    /*
    For compairing/matching
    */
    EventSource.prototype.getPrimitive = function (otherSource) {
        // subclasses must implement
    };
    EventSource.prototype.parseEventDefs = function (rawEventDefs) {
        var i;
        var eventDef;
        var eventDefs = [];
        for (i = 0; i < rawEventDefs.length; i++) {
            eventDef = this.parseEventDef(rawEventDefs[i]);
            if (eventDef) {
                eventDefs.push(eventDef);
            }
        }
        return eventDefs;
    };
    EventSource.prototype.parseEventDef = function (rawInput) {
        var calendarTransform = this.calendar.opt('eventDataTransform');
        var sourceTransform = this.eventDataTransform;
        if (calendarTransform) {
            rawInput = calendarTransform(rawInput, this.calendar);
        }
        if (sourceTransform) {
            rawInput = sourceTransform(rawInput, this.calendar);
        }
        return EventDefParser_1.default.parse(rawInput, this);
    };
    EventSource.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventSource.normalizeId(rawProps.id);
        }
        // TODO: converge with EventDef
        if ($.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        else if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventSource.uuid = 0;
    EventSource.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventSource.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventSource;
}(Class_1.default));
exports.default = EventSource;
ParsableModelMixin_1.default.mixInto(EventSource);
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
EventSource.defineStandardProps({
    // manually process...
    id: false,
    className: false,
    // automatically transfer...
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    rendering: true,
    overlap: true,
    constraint: true,
    allDayDefault: true,
    eventDataTransform: true
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*
Utility methods for easily listening to events on another object,
and more importantly, easily unlistening from them.

USAGE:
  import { default as ListenerMixin, ListenerInterface } from './ListenerMixin'
in class:
  listenTo: ListenerInterface['listenTo']
  stopListeningTo: ListenerInterface['stopListeningTo']
after class:
  ListenerMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Mixin_1 = __webpack_require__(14);
var guid = 0;
var ListenerMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ListenerMixin, _super);
    function ListenerMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
    The `callback` will be called with the `this` context of the object that .listenTo is being called on.
    Can be called:
      .listenTo(other, eventName, callback)
    OR
      .listenTo(other, {
        eventName1: callback1,
        eventName2: callback2
      })
    */
    ListenerMixin.prototype.listenTo = function (other, arg, callback) {
        if (typeof arg === 'object') {
            for (var eventName in arg) {
                if (arg.hasOwnProperty(eventName)) {
                    this.listenTo(other, eventName, arg[eventName]);
                }
            }
        }
        else if (typeof arg === 'string') {
            other.on(arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
            $.proxy(callback, this) // always use `this` context
            // the usually-undesired jQuery guid behavior doesn't matter,
            // because we always unbind via namespace
            );
        }
    };
    /*
    Causes the current object to stop listening to events on the `other` object.
    `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
    */
    ListenerMixin.prototype.stopListeningTo = function (other, eventName) {
        other.off((eventName || '') + '.' + this.getListenerNamespace());
    };
    /*
    Returns a string, unique to this object, to be used for event namespacing
    */
    ListenerMixin.prototype.getListenerNamespace = function () {
        if (this.listenerId == null) {
            this.listenerId = guid++;
        }
        return '_listener' + this.listenerId;
    };
    return ListenerMixin;
}(Mixin_1.default));
exports.default = ListenerMixin;


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
var newMomentProto = moment.fn; // where we will attach our new methods
exports.newMomentProto = newMomentProto;
var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
exports.oldMomentProto = oldMomentProto;
// tell momentjs to transfer these properties upon clone
var momentProperties = moment.momentProperties;
momentProperties.push('_fullCalendar');
momentProperties.push('_ambigTime');
momentProperties.push('_ambigZone');
/*
Call this if you want Moment's original format method to be used
*/
function oldMomentFormat(mom, formatStr) {
    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
}
exports.oldMomentFormat = oldMomentFormat;
// Creating
// -------------------------------------------------------------------------------------------------
// Creates a new moment, similar to the vanilla moment(...) constructor, but with
// extra features (ambiguous time, enhanced formatting). When given an existing moment,
// it will function as a clone (and retain the zone of the moment). Anything else will
// result in a moment in the local zone.
var momentExt = function () {
    return makeMoment(arguments);
};
exports.default = momentExt;
// Sames as momentExt, but forces the resulting moment to be in the UTC timezone.
momentExt.utc = function () {
    var mom = makeMoment(arguments, true);
    // Force it into UTC because makeMoment doesn't guarantee it
    // (if given a pre-existing moment for example)
    if (mom.hasTime()) {
        mom.utc();
    }
    return mom;
};
// Same as momentExt, but when given an ISO8601 string, the timezone offset is preserved.
// ISO8601 strings with no timezone offset will become ambiguously zoned.
momentExt.parseZone = function () {
    return makeMoment(arguments, true, true);
};
// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
// native Date, or called with no arguments (the current time), the resulting moment will be local.
// Anything else needs to be "parsed" (a string or an array), and will be affected by:
//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
//    parseZone - if there is zone information, should we force the zone of the moment?
function makeMoment(args, parseAsUTC, parseZone) {
    if (parseAsUTC === void 0) { parseAsUTC = false; }
    if (parseZone === void 0) { parseZone = false; }
    var input = args[0];
    var isSingleString = args.length === 1 && typeof input === 'string';
    var isAmbigTime;
    var isAmbigZone;
    var ambigMatch;
    var mom;
    if (moment.isMoment(input) || util_1.isNativeDate(input) || input === undefined) {
        mom = moment.apply(null, args);
    }
    else {
        isAmbigTime = false;
        isAmbigZone = false;
        if (isSingleString) {
            if (ambigDateOfMonthRegex.test(input)) {
                // accept strings like '2014-05', but convert to the first of the month
                input += '-01';
                args = [input]; // for when we pass it on to moment's constructor
                isAmbigTime = true;
                isAmbigZone = true;
            }
            else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
                isAmbigTime = !ambigMatch[5]; // no time part?
                isAmbigZone = true;
            }
        }
        else if ($.isArray(input)) {
            // arrays have no timezone information, so assume ambiguous zone
            isAmbigZone = true;
        }
        // otherwise, probably a string with a format
        if (parseAsUTC || isAmbigTime) {
            mom = moment.utc.apply(moment, args);
        }
        else {
            mom = moment.apply(null, args);
        }
        if (isAmbigTime) {
            mom._ambigTime = true;
            mom._ambigZone = true; // ambiguous time always means ambiguous zone
        }
        else if (parseZone) {
            if (isAmbigZone) {
                mom._ambigZone = true;
            }
            else if (isSingleString) {
                mom.utcOffset(input); // if not a valid zone, will assign UTC
            }
        }
    }
    mom._fullCalendar = true; // flag for extended functionality
    return mom;
}
// Week Number
// -------------------------------------------------------------------------------------------------
// Returns the week number, considering the locale's custom week number calcuation
// `weeks` is an alias for `week`
newMomentProto.week = newMomentProto.weeks = function (input) {
    var weekCalc = this._locale._fullCalendar_weekCalc;
    if (input == null && typeof weekCalc === 'function') {
        return weekCalc(this);
    }
    else if (weekCalc === 'ISO') {
        return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
    }
    return oldMomentProto.week.apply(this, arguments); // local getter/setter
};
// Time-of-day
// -------------------------------------------------------------------------------------------------
// GETTER
// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
// If the moment has an ambiguous time, a duration of 00:00 will be returned.
//
// SETTER
// You can supply a Duration, a Moment, or a Duration-like argument.
// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
newMomentProto.time = function (time) {
    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
    if (!this._fullCalendar) {
        return oldMomentProto.time.apply(this, arguments);
    }
    if (time == null) {
        return moment.duration({
            hours: this.hours(),
            minutes: this.minutes(),
            seconds: this.seconds(),
            milliseconds: this.milliseconds()
        });
    }
    else {
        this._ambigTime = false; // mark that the moment now has a time
        if (!moment.isDuration(time) && !moment.isMoment(time)) {
            time = moment.duration(time);
        }
        // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
        // Only for Duration times, not Moment times.
        var dayHours = 0;
        if (moment.isDuration(time)) {
            dayHours = Math.floor(time.asDays()) * 24;
        }
        // We need to set the individual fields.
        // Can't use startOf('day') then add duration. In case of DST at start of day.
        return this.hours(dayHours + time.hours())
            .minutes(time.minutes())
            .seconds(time.seconds())
            .milliseconds(time.milliseconds());
    }
};
// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
// but preserving its YMD. A moment with a stripped time will display no time
// nor timezone offset when .format() is called.
newMomentProto.stripTime = function () {
    if (!this._ambigTime) {
        this.utc(true); // keepLocalTime=true (for keeping *date* value)
        // set time to zero
        this.set({
            hours: 0,
            minutes: 0,
            seconds: 0,
            ms: 0
        });
        // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears all ambig flags.
        this._ambigTime = true;
        this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
    }
    return this; // for chaining
};
// Returns if the moment has a non-ambiguous time (boolean)
newMomentProto.hasTime = function () {
    return !this._ambigTime;
};
// Timezone
// -------------------------------------------------------------------------------------------------
// Converts the moment to UTC, stripping out its timezone offset, but preserving its
// YMD and time-of-day. A moment with a stripped timezone offset will display no
// timezone offset when .format() is called.
newMomentProto.stripZone = function () {
    var wasAmbigTime;
    if (!this._ambigZone) {
        wasAmbigTime = this._ambigTime;
        this.utc(true); // keepLocalTime=true (for keeping date and time values)
        // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
        this._ambigTime = wasAmbigTime || false;
        // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears the ambig flags.
        this._ambigZone = true;
    }
    return this; // for chaining
};
// Returns of the moment has a non-ambiguous timezone offset (boolean)
newMomentProto.hasZone = function () {
    return !this._ambigZone;
};
// implicitly marks a zone
newMomentProto.local = function (keepLocalTime) {
    // for when converting from ambiguously-zoned to local,
    // keep the time values when converting from UTC -> local
    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this; // for chaining
};
// implicitly marks a zone
newMomentProto.utc = function (keepLocalTime) {
    oldMomentProto.utc.call(this, keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this;
};
// implicitly marks a zone (will probably get called upon .utc() and .local())
newMomentProto.utcOffset = function (tzo) {
    if (tzo != null) {
        // these assignments needs to happen before the original zone method is called.
        // I forget why, something to do with a browser crash.
        this._ambigTime = false;
        this._ambigZone = false;
    }
    return oldMomentProto.utcOffset.apply(this, arguments);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as EmitterMixin, EmitterInterface } from './EmitterMixin'
in class:
  on: EmitterInterface['on']
  one: EmitterInterface['one']
  off: EmitterInterface['off']
  trigger: EmitterInterface['trigger']
  triggerWith: EmitterInterface['triggerWith']
  hasHandlers: EmitterInterface['hasHandlers']
after class:
  EmitterMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Mixin_1 = __webpack_require__(14);
var EmitterMixin = /** @class */ (function (_super) {
    tslib_1.__extends(EmitterMixin, _super);
    function EmitterMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // jQuery-ification via $(this) allows a non-DOM object to have
    // the same event handling capabilities (including namespaces).
    EmitterMixin.prototype.on = function (types, handler) {
        $(this).on(types, this._prepareIntercept(handler));
        return this; // for chaining
    };
    EmitterMixin.prototype.one = function (types, handler) {
        $(this).one(types, this._prepareIntercept(handler));
        return this; // for chaining
    };
    EmitterMixin.prototype._prepareIntercept = function (handler) {
        // handlers are always called with an "event" object as their first param.
        // sneak the `this` context and arguments into the extra parameter object
        // and forward them on to the original handler.
        var intercept = function (ev, extra) {
            return handler.apply(extra.context || this, extra.args || []);
        };
        // mimick jQuery's internal "proxy" system (risky, I know)
        // causing all functions with the same .guid to appear to be the same.
        // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
        // this is needed for calling .off with the original non-intercept handler.
        if (!handler.guid) {
            handler.guid = $.guid++;
        }
        intercept.guid = handler.guid;
        return intercept;
    };
    EmitterMixin.prototype.off = function (types, handler) {
        $(this).off(types, handler);
        return this; // for chaining
    };
    EmitterMixin.prototype.trigger = function (types) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // pass in "extra" info to the intercept
        $(this).triggerHandler(types, { args: args });
        return this; // for chaining
    };
    EmitterMixin.prototype.triggerWith = function (types, context, args) {
        // `triggerHandler` is less reliant on the DOM compared to `trigger`.
        // pass in "extra" info to the intercept.
        $(this).triggerHandler(types, { context: context, args: args });
        return this; // for chaining
    };
    EmitterMixin.prototype.hasHandlers = function (type) {
        var hash = $._data(this, 'events'); // http://blog.jquery.com/2012/08/09/jquery-1-8-released/
        return hash && hash[type] && hash[type].length > 0;
    };
    return EmitterMixin;
}(Mixin_1.default));
exports.default = EmitterMixin;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
/*
Meant to be immutable
*/
var ComponentFootprint = /** @class */ (function () {
    function ComponentFootprint(unzonedRange, isAllDay) {
        this.isAllDay = false; // component can choose to ignore this
        this.unzonedRange = unzonedRange;
        this.isAllDay = isAllDay;
    }
    /*
    Only works for non-open-ended ranges.
    */
    ComponentFootprint.prototype.toLegacy = function (calendar) {
        return {
            start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
            end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
        };
    };
    return ComponentFootprint;
}());
exports.default = ComponentFootprint;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var EventDef_1 = __webpack_require__(33);
var EventInstance_1 = __webpack_require__(209);
var EventDateProfile_1 = __webpack_require__(17);
var SingleEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(SingleEventDef, _super);
    function SingleEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Will receive start/end params, but will be ignored.
    */
    SingleEventDef.prototype.buildInstances = function () {
        return [this.buildInstance()];
    };
    SingleEventDef.prototype.buildInstance = function () {
        return new EventInstance_1.default(this, // definition
        this.dateProfile);
    };
    SingleEventDef.prototype.isAllDay = function () {
        return this.dateProfile.isAllDay();
    };
    SingleEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        def.dateProfile = this.dateProfile;
        return def;
    };
    SingleEventDef.prototype.rezone = function () {
        var calendar = this.source.calendar;
        var dateProfile = this.dateProfile;
        this.dateProfile = new EventDateProfile_1.default(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
    };
    /*
    NOTE: if super-method fails, should still attempt to apply
    */
    SingleEventDef.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        var dateProfile = EventDateProfile_1.default.parse(rawProps, this.source); // returns null on failure
        if (dateProfile) {
            this.dateProfile = dateProfile;
            // make sure `date` shows up in the legacy event objects as-is
            if (rawProps.date != null) {
                this.miscProps.date = rawProps.date;
            }
            return superSuccess;
        }
        else {
            return false;
        }
    };
    return SingleEventDef;
}(EventDef_1.default));
exports.default = SingleEventDef;
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
SingleEventDef.defineStandardProps({
    start: false,
    date: false,
    end: false,
    allDay: false
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Mixin = /** @class */ (function () {
    function Mixin() {
    }
    Mixin.mixInto = function (destClass) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            if (!destClass.prototype[name]) {
                destClass.prototype[name] = _this.prototype[name];
            }
        });
    };
    /*
    will override existing methods
    TODO: remove! not used anymore
    */
    Mixin.mixOver = function (destClass) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            destClass.prototype[name] = _this.prototype[name];
        });
    };
    return Mixin;
}());
exports.default = Mixin;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Interaction = /** @class */ (function () {
    function Interaction(component) {
        this.view = component._getView();
        this.component = component;
    }
    Interaction.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    Interaction.prototype.end = function () {
        // subclasses can implement
    };
    return Interaction;
}());
exports.default = Interaction;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.version = '3.8.2';
// When introducing internal API incompatibilities (where fullcalendar plugins would break),
// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
// and the below integer should be incremented.
exports.internalApiVersion = 12;
var util_1 = __webpack_require__(4);
exports.applyAll = util_1.applyAll;
exports.debounce = util_1.debounce;
exports.isInt = util_1.isInt;
exports.htmlEscape = util_1.htmlEscape;
exports.cssToStr = util_1.cssToStr;
exports.proxy = util_1.proxy;
exports.capitaliseFirstLetter = util_1.capitaliseFirstLetter;
exports.getOuterRect = util_1.getOuterRect;
exports.getClientRect = util_1.getClientRect;
exports.getContentRect = util_1.getContentRect;
exports.getScrollbarWidths = util_1.getScrollbarWidths;
exports.preventDefault = util_1.preventDefault;
exports.parseFieldSpecs = util_1.parseFieldSpecs;
exports.compareByFieldSpecs = util_1.compareByFieldSpecs;
exports.compareByFieldSpec = util_1.compareByFieldSpec;
exports.flexibleCompare = util_1.flexibleCompare;
exports.computeGreatestUnit = util_1.computeGreatestUnit;
exports.divideRangeByDuration = util_1.divideRangeByDuration;
exports.divideDurationByDuration = util_1.divideDurationByDuration;
exports.multiplyDuration = util_1.multiplyDuration;
exports.durationHasTime = util_1.durationHasTime;
exports.log = util_1.log;
exports.warn = util_1.warn;
exports.removeExact = util_1.removeExact;
exports.intersectRects = util_1.intersectRects;
var date_formatting_1 = __webpack_require__(47);
exports.formatDate = date_formatting_1.formatDate;
exports.formatRange = date_formatting_1.formatRange;
exports.queryMostGranularFormatUnit = date_formatting_1.queryMostGranularFormatUnit;
var locale_1 = __webpack_require__(30);
exports.datepickerLocale = locale_1.datepickerLocale;
exports.locale = locale_1.locale;
var moment_ext_1 = __webpack_require__(10);
exports.moment = moment_ext_1.default;
var EmitterMixin_1 = __webpack_require__(11);
exports.EmitterMixin = EmitterMixin_1.default;
var ListenerMixin_1 = __webpack_require__(7);
exports.ListenerMixin = ListenerMixin_1.default;
var Model_1 = __webpack_require__(48);
exports.Model = Model_1.default;
var Constraints_1 = __webpack_require__(207);
exports.Constraints = Constraints_1.default;
var UnzonedRange_1 = __webpack_require__(5);
exports.UnzonedRange = UnzonedRange_1.default;
var ComponentFootprint_1 = __webpack_require__(12);
exports.ComponentFootprint = ComponentFootprint_1.default;
var BusinessHourGenerator_1 = __webpack_require__(212);
exports.BusinessHourGenerator = BusinessHourGenerator_1.default;
var EventDef_1 = __webpack_require__(33);
exports.EventDef = EventDef_1.default;
var EventDefMutation_1 = __webpack_require__(36);
exports.EventDefMutation = EventDefMutation_1.default;
var EventSourceParser_1 = __webpack_require__(37);
exports.EventSourceParser = EventSourceParser_1.default;
var EventSource_1 = __webpack_require__(6);
exports.EventSource = EventSource_1.default;
var ThemeRegistry_1 = __webpack_require__(51);
exports.defineThemeSystem = ThemeRegistry_1.defineThemeSystem;
var EventInstanceGroup_1 = __webpack_require__(18);
exports.EventInstanceGroup = EventInstanceGroup_1.default;
var ArrayEventSource_1 = __webpack_require__(52);
exports.ArrayEventSource = ArrayEventSource_1.default;
var FuncEventSource_1 = __webpack_require__(215);
exports.FuncEventSource = FuncEventSource_1.default;
var JsonFeedEventSource_1 = __webpack_require__(216);
exports.JsonFeedEventSource = JsonFeedEventSource_1.default;
var EventFootprint_1 = __webpack_require__(35);
exports.EventFootprint = EventFootprint_1.default;
var Class_1 = __webpack_require__(32);
exports.Class = Class_1.default;
var Mixin_1 = __webpack_require__(14);
exports.Mixin = Mixin_1.default;
var CoordCache_1 = __webpack_require__(53);
exports.CoordCache = CoordCache_1.default;
var DragListener_1 = __webpack_require__(54);
exports.DragListener = DragListener_1.default;
var Promise_1 = __webpack_require__(19);
exports.Promise = Promise_1.default;
var TaskQueue_1 = __webpack_require__(217);
exports.TaskQueue = TaskQueue_1.default;
var RenderQueue_1 = __webpack_require__(218);
exports.RenderQueue = RenderQueue_1.default;
var Scroller_1 = __webpack_require__(39);
exports.Scroller = Scroller_1.default;
var Theme_1 = __webpack_require__(38);
exports.Theme = Theme_1.default;
var DateComponent_1 = __webpack_require__(219);
exports.DateComponent = DateComponent_1.default;
var InteractiveDateComponent_1 = __webpack_require__(40);
exports.InteractiveDateComponent = InteractiveDateComponent_1.default;
var Calendar_1 = __webpack_require__(220);
exports.Calendar = Calendar_1.default;
var View_1 = __webpack_require__(41);
exports.View = View_1.default;
var ViewRegistry_1 = __webpack_require__(21);
exports.defineView = ViewRegistry_1.defineView;
exports.getViewConfig = ViewRegistry_1.getViewConfig;
var DayTableMixin_1 = __webpack_require__(55);
exports.DayTableMixin = DayTableMixin_1.default;
var BusinessHourRenderer_1 = __webpack_require__(56);
exports.BusinessHourRenderer = BusinessHourRenderer_1.default;
var EventRenderer_1 = __webpack_require__(42);
exports.EventRenderer = EventRenderer_1.default;
var FillRenderer_1 = __webpack_require__(57);
exports.FillRenderer = FillRenderer_1.default;
var HelperRenderer_1 = __webpack_require__(58);
exports.HelperRenderer = HelperRenderer_1.default;
var ExternalDropping_1 = __webpack_require__(222);
exports.ExternalDropping = ExternalDropping_1.default;
var EventResizing_1 = __webpack_require__(223);
exports.EventResizing = EventResizing_1.default;
var EventPointing_1 = __webpack_require__(59);
exports.EventPointing = EventPointing_1.default;
var EventDragging_1 = __webpack_require__(224);
exports.EventDragging = EventDragging_1.default;
var DateSelecting_1 = __webpack_require__(225);
exports.DateSelecting = DateSelecting_1.default;
var StandardInteractionsMixin_1 = __webpack_require__(60);
exports.StandardInteractionsMixin = StandardInteractionsMixin_1.default;
var AgendaView_1 = __webpack_require__(226);
exports.AgendaView = AgendaView_1.default;
var TimeGrid_1 = __webpack_require__(227);
exports.TimeGrid = TimeGrid_1.default;
var DayGrid_1 = __webpack_require__(61);
exports.DayGrid = DayGrid_1.default;
var BasicView_1 = __webpack_require__(62);
exports.BasicView = BasicView_1.default;
var MonthView_1 = __webpack_require__(229);
exports.MonthView = MonthView_1.default;
var ListView_1 = __webpack_require__(230);
exports.ListView = ListView_1.default;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
/*
Meant to be immutable
*/
var EventDateProfile = /** @class */ (function () {
    function EventDateProfile(start, end, calendar) {
        this.start = start;
        this.end = end || null;
        this.unzonedRange = this.buildUnzonedRange(calendar);
    }
    /*
    Needs an EventSource object
    */
    EventDateProfile.parse = function (rawProps, source) {
        var startInput = rawProps.start || rawProps.date;
        var endInput = rawProps.end;
        if (!startInput) {
            return false;
        }
        var calendar = source.calendar;
        var start = calendar.moment(startInput);
        var end = endInput ? calendar.moment(endInput) : null;
        var forcedAllDay = rawProps.allDay;
        var forceEventDuration = calendar.opt('forceEventDuration');
        if (!start.isValid()) {
            return false;
        }
        if (end && (!end.isValid() || !end.isAfter(start))) {
            end = null;
        }
        if (forcedAllDay == null) {
            forcedAllDay = source.allDayDefault;
            if (forcedAllDay == null) {
                forcedAllDay = calendar.opt('allDayDefault');
            }
        }
        if (forcedAllDay === true) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else if (forcedAllDay === false) {
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        if (!end && forceEventDuration) {
            end = calendar.getDefaultEventEnd(!start.hasTime(), start);
        }
        return new EventDateProfile(start, end, calendar);
    };
    EventDateProfile.isStandardProp = function (propName) {
        return propName === 'start' || propName === 'date' || propName === 'end' || propName === 'allDay';
    };
    EventDateProfile.prototype.isAllDay = function () {
        return !(this.start.hasTime() || (this.end && this.end.hasTime()));
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.buildUnzonedRange = function (calendar) {
        var startMs = this.start.clone().stripZone().valueOf();
        var endMs = this.getEnd(calendar).stripZone().valueOf();
        return new UnzonedRange_1.default(startMs, endMs);
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.getEnd = function (calendar) {
        return this.end ?
            this.end.clone() :
            // derive the end from the start and allDay. compute allDay if necessary
            calendar.getDefaultEventEnd(this.isAllDay(), this.start);
    };
    return EventDateProfile;
}());
exports.default = EventDateProfile;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
var util_1 = __webpack_require__(34);
var EventRange_1 = __webpack_require__(211);
/*
It's expected that there will be at least one EventInstance,
OR that an explicitEventDef is assigned.
*/
var EventInstanceGroup = /** @class */ (function () {
    function EventInstanceGroup(eventInstances) {
        this.eventInstances = eventInstances || [];
    }
    EventInstanceGroup.prototype.getAllEventRanges = function (constraintRange) {
        if (constraintRange) {
            return this.sliceNormalRenderRanges(constraintRange);
        }
        else {
            return this.eventInstances.map(util_1.eventInstanceToEventRange);
        }
    };
    EventInstanceGroup.prototype.sliceRenderRanges = function (constraintRange) {
        if (this.isInverse()) {
            return this.sliceInverseRenderRanges(constraintRange);
        }
        else {
            return this.sliceNormalRenderRanges(constraintRange);
        }
    };
    EventInstanceGroup.prototype.sliceNormalRenderRanges = function (constraintRange) {
        var eventInstances = this.eventInstances;
        var i;
        var eventInstance;
        var slicedRange;
        var slicedEventRanges = [];
        for (i = 0; i < eventInstances.length; i++) {
            eventInstance = eventInstances[i];
            slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);
            if (slicedRange) {
                slicedEventRanges.push(new EventRange_1.default(slicedRange, eventInstance.def, eventInstance));
            }
        }
        return slicedEventRanges;
    };
    EventInstanceGroup.prototype.sliceInverseRenderRanges = function (constraintRange) {
        var unzonedRanges = this.eventInstances.map(util_1.eventInstanceToUnzonedRange);
        var ownerDef = this.getEventDef();
        unzonedRanges = UnzonedRange_1.default.invertRanges(unzonedRanges, constraintRange);
        return unzonedRanges.map(function (unzonedRange) {
            return new EventRange_1.default(unzonedRange, ownerDef); // don't give an EventInstance
        });
    };
    EventInstanceGroup.prototype.isInverse = function () {
        return this.getEventDef().hasInverseRendering();
    };
    EventInstanceGroup.prototype.getEventDef = function () {
        return this.explicitEventDef || this.eventInstances[0].def;
    };
    return EventInstanceGroup;
}());
exports.default = EventInstanceGroup;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var PromiseStub = {
    construct: function (executor) {
        var deferred = $.Deferred();
        var promise = deferred.promise();
        if (typeof executor === 'function') {
            executor(function (val) {
                deferred.resolve(val);
                attachImmediatelyResolvingThen(promise, val);
            }, function () {
                deferred.reject();
                attachImmediatelyRejectingThen(promise);
            });
        }
        return promise;
    },
    resolve: function (val) {
        var deferred = $.Deferred().resolve(val);
        var promise = deferred.promise();
        attachImmediatelyResolvingThen(promise, val);
        return promise;
    },
    reject: function () {
        var deferred = $.Deferred().reject();
        var promise = deferred.promise();
        attachImmediatelyRejectingThen(promise);
        return promise;
    }
};
exports.default = PromiseStub;
function attachImmediatelyResolvingThen(promise, val) {
    promise.then = function (onResolve) {
        if (typeof onResolve === 'function') {
            return PromiseStub.resolve(onResolve(val));
        }
        return promise;
    };
}
function attachImmediatelyRejectingThen(promise) {
    promise.then = function (onResolve, onReject) {
        if (typeof onReject === 'function') {
            onReject();
        }
        return promise;
    };
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var exportHooks = __webpack_require__(16);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
exportHooks.touchMouseIgnoreWait = 500;
var globalEmitter = null;
var neededCount = 0;
/*
Listens to document and window-level user-interaction events, like touch events and mouse events,
and fires these events as-is to whoever is observing a GlobalEmitter.
Best when used as a singleton via GlobalEmitter.get()

Normalizes mouse/touch events. For examples:
- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
- compensates for various buggy scenarios where a touchend does not fire
*/
var GlobalEmitter = /** @class */ (function () {
    function GlobalEmitter() {
        this.isTouching = false;
        this.mouseIgnoreDepth = 0;
    }
    // gets the singleton
    GlobalEmitter.get = function () {
        if (!globalEmitter) {
            globalEmitter = new GlobalEmitter();
            globalEmitter.bind();
        }
        return globalEmitter;
    };
    // called when an object knows it will need a GlobalEmitter in the near future.
    GlobalEmitter.needed = function () {
        GlobalEmitter.get(); // ensures globalEmitter
        neededCount++;
    };
    // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
    GlobalEmitter.unneeded = function () {
        neededCount--;
        if (!neededCount) {
            globalEmitter.unbind();
            globalEmitter = null;
        }
    };
    GlobalEmitter.prototype.bind = function () {
        var _this = this;
        this.listenTo($(document), {
            touchstart: this.handleTouchStart,
            touchcancel: this.handleTouchCancel,
            touchend: this.handleTouchEnd,
            mousedown: this.handleMouseDown,
            mousemove: this.handleMouseMove,
            mouseup: this.handleMouseUp,
            click: this.handleClick,
            selectstart: this.handleSelectStart,
            contextmenu: this.handleContextMenu
        });
        // because we need to call preventDefault
        // because https://www.chromestatus.com/features/5093566007214080
        // TODO: investigate performance because this is a global handler
        window.addEventListener('touchmove', this.handleTouchMoveProxy = function (ev) {
            _this.handleTouchMove($.Event(ev));
        }, { passive: false } // allows preventDefault()
        );
        // attach a handler to get called when ANY scroll action happens on the page.
        // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
        // http://stackoverflow.com/a/32954565/96342
        window.addEventListener('scroll', this.handleScrollProxy = function (ev) {
            _this.handleScroll($.Event(ev));
        }, true // useCapture
        );
    };
    GlobalEmitter.prototype.unbind = function () {
        this.stopListeningTo($(document));
        window.removeEventListener('touchmove', this.handleTouchMoveProxy);
        window.removeEventListener('scroll', this.handleScrollProxy, true // useCapture
        );
    };
    // Touch Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleTouchStart = function (ev) {
        // if a previous touch interaction never ended with a touchend, then implicitly end it,
        // but since a new touch interaction is about to begin, don't start the mouse ignore period.
        this.stopTouch(ev, true); // skipMouseIgnore=true
        this.isTouching = true;
        this.trigger('touchstart', ev);
    };
    GlobalEmitter.prototype.handleTouchMove = function (ev) {
        if (this.isTouching) {
            this.trigger('touchmove', ev);
        }
    };
    GlobalEmitter.prototype.handleTouchCancel = function (ev) {
        if (this.isTouching) {
            this.trigger('touchcancel', ev);
            // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
            // If touchend fires later, it won't have any effect b/c isTouching will be false.
            this.stopTouch(ev);
        }
    };
    GlobalEmitter.prototype.handleTouchEnd = function (ev) {
        this.stopTouch(ev);
    };
    // Mouse Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleMouseDown = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousedown', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseMove = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousemove', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseUp = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mouseup', ev);
        }
    };
    GlobalEmitter.prototype.handleClick = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('click', ev);
        }
    };
    // Misc Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleSelectStart = function (ev) {
        this.trigger('selectstart', ev);
    };
    GlobalEmitter.prototype.handleContextMenu = function (ev) {
        this.trigger('contextmenu', ev);
    };
    GlobalEmitter.prototype.handleScroll = function (ev) {
        this.trigger('scroll', ev);
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.stopTouch = function (ev, skipMouseIgnore) {
        if (skipMouseIgnore === void 0) { skipMouseIgnore = false; }
        if (this.isTouching) {
            this.isTouching = false;
            this.trigger('touchend', ev);
            if (!skipMouseIgnore) {
                this.startTouchMouseIgnore();
            }
        }
    };
    GlobalEmitter.prototype.startTouchMouseIgnore = function () {
        var _this = this;
        var wait = exportHooks.touchMouseIgnoreWait;
        if (wait) {
            this.mouseIgnoreDepth++;
            setTimeout(function () {
                _this.mouseIgnoreDepth--;
            }, wait);
        }
    };
    GlobalEmitter.prototype.shouldIgnoreMouse = function () {
        return this.isTouching || Boolean(this.mouseIgnoreDepth);
    };
    return GlobalEmitter;
}());
exports.default = GlobalEmitter;
ListenerMixin_1.default.mixInto(GlobalEmitter);
EmitterMixin_1.default.mixInto(GlobalEmitter);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var exportHooks = __webpack_require__(16);
exports.viewHash = {};
exportHooks.views = exports.viewHash;
function defineView(viewName, viewConfig) {
    exports.viewHash[viewName] = viewConfig;
}
exports.defineView = defineView;
function getViewConfig(viewName) {
    return exports.viewHash[viewName];
}
exports.getViewConfig = getViewConfig;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var DragListener_1 = __webpack_require__(54);
/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
------------------------------------------------------------------------------------------------------------------------
options:
- subjectEl
- subjectCenter
*/
var HitDragListener = /** @class */ (function (_super) {
    tslib_1.__extends(HitDragListener, _super);
    function HitDragListener(component, options) {
        var _this = _super.call(this, options) || this;
        _this.component = component;
        return _this;
    }
    // Called when drag listening starts (but a real drag has not necessarily began).
    // ev might be undefined if dragging was started manually.
    HitDragListener.prototype.handleInteractionStart = function (ev) {
        var subjectEl = this.subjectEl;
        var subjectRect;
        var origPoint;
        var point;
        this.component.hitsNeeded();
        this.computeScrollBounds(); // for autoscroll
        if (ev) {
            origPoint = { left: util_1.getEvX(ev), top: util_1.getEvY(ev) };
            point = origPoint;
            // constrain the point to bounds of the element being dragged
            if (subjectEl) {
                subjectRect = util_1.getOuterRect(subjectEl); // used for centering as well
                point = util_1.constrainPoint(point, subjectRect);
            }
            this.origHit = this.queryHit(point.left, point.top);
            // treat the center of the subject as the collision point?
            if (subjectEl && this.options.subjectCenter) {
                // only consider the area the subject overlaps the hit. best for large subjects.
                // TODO: skip this if hit didn't supply left/right/top/bottom
                if (this.origHit) {
                    subjectRect = util_1.intersectRects(this.origHit, subjectRect) ||
                        subjectRect; // in case there is no intersection
                }
                point = util_1.getRectCenter(subjectRect);
            }
            this.coordAdjust = util_1.diffPoints(point, origPoint); // point - origPoint
        }
        else {
            this.origHit = null;
            this.coordAdjust = null;
        }
        // call the super-method. do it after origHit has been computed
        _super.prototype.handleInteractionStart.call(this, ev);
    };
    // Called when the actual drag has started
    HitDragListener.prototype.handleDragStart = function (ev) {
        var hit;
        _super.prototype.handleDragStart.call(this, ev);
        // might be different from this.origHit if the min-distance is large
        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
        // report the initial hit the mouse is over
        // especially important if no min-distance and drag starts immediately
        if (hit) {
            this.handleHitOver(hit);
        }
    };
    // Called when the drag moves
    HitDragListener.prototype.handleDrag = function (dx, dy, ev) {
        var hit;
        _super.prototype.handleDrag.call(this, dx, dy, ev);
        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
        if (!isHitsEqual(hit, this.hit)) {
            if (this.hit) {
                this.handleHitOut();
            }
            if (hit) {
                this.handleHitOver(hit);
            }
        }
    };
    // Called when dragging has been stopped
    HitDragListener.prototype.handleDragEnd = function (ev) {
        this.handleHitDone();
        _super.prototype.handleDragEnd.call(this, ev);
    };
    // Called when a the mouse has just moved over a new hit
    HitDragListener.prototype.handleHitOver = function (hit) {
        var isOrig = isHitsEqual(hit, this.origHit);
        this.hit = hit;
        this.trigger('hitOver', this.hit, isOrig, this.origHit);
    };
    // Called when the mouse has just moved out of a hit
    HitDragListener.prototype.handleHitOut = function () {
        if (this.hit) {
            this.trigger('hitOut', this.hit);
            this.handleHitDone();
            this.hit = null;
        }
    };
    // Called after a hitOut. Also called before a dragStop
    HitDragListener.prototype.handleHitDone = function () {
        if (this.hit) {
            this.trigger('hitDone', this.hit);
        }
    };
    // Called when the interaction ends, whether there was a real drag or not
    HitDragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        _super.prototype.handleInteractionEnd.call(this, ev, isCancelled);
        this.origHit = null;
        this.hit = null;
        this.component.hitsNotNeeded();
    };
    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    HitDragListener.prototype.handleScrollEnd = function () {
        _super.prototype.handleScrollEnd.call(this);
        // hits' absolute positions will be in new places after a user's scroll.
        // HACK for recomputing.
        if (this.isDragging) {
            this.component.releaseHits();
            this.component.prepareHits();
        }
    };
    // Gets the hit underneath the coordinates for the given mouse event
    HitDragListener.prototype.queryHit = function (left, top) {
        if (this.coordAdjust) {
            left += this.coordAdjust.left;
            top += this.coordAdjust.top;
        }
        return this.component.queryHit(left, top);
    };
    return HitDragListener;
}(DragListener_1.default));
exports.default = HitDragListener;
// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
// Two null values will be considered equal, as two "out of the component" states are the same.
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
        return true;
    }
    if (hit0 && hit1) {
        return hit0.component === hit1.component &&
            isHitPropsWithin(hit0, hit1) &&
            isHitPropsWithin(hit1, hit0); // ensures all props are identical
    }
    return false;
}
// Returns true if all of subHit's non-standard properties are within superHit
function isHitPropsWithin(subHit, superHit) {
    for (var propName in subHit) {
        if (!/^(component|left|right|top|bottom)$/.test(propName)) {
            if (subHit[propName] !== superHit[propName]) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var exportHooks = __webpack_require__(16);
var options_1 = __webpack_require__(31);
var util_1 = __webpack_require__(4);
exports.localeOptionHash = {};
exportHooks.locales = exports.localeOptionHash;
// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
// configs, so make sure there are English fallbacks for these in the defaults file.
var dpComputableOptions = {
    buttonText: function (dpOptions) {
        return {
            // the translations sometimes wrongly contain HTML entities
            prev: util_1.stripHtmlEntities(dpOptions.prevText),
            next: util_1.stripHtmlEntities(dpOptions.nextText),
            today: util_1.stripHtmlEntities(dpOptions.currentText)
        };
    },
    // Produces format strings like "MMMM YYYY" -> "September 2014"
    monthYearFormat: function (dpOptions) {
        return dpOptions.showMonthAfterYear ?
            'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
            'MMMM YYYY[' + dpOptions.yearSuffix + ']';
    }
};
var momComputableOptions = {
    // Produces format strings like "ddd M/D" -> "Fri 9/15"
    dayOfMonthFormat: function (momOptions, fcOptions) {
        var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
        // strip the year off the edge, as well as other misc non-whitespace chars
        format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
        if (fcOptions.isRTL) {
            format += ' ddd'; // for RTL, add day-of-week to end
        }
        else {
            format = 'ddd ' + format; // for LTR, add day-of-week to beginning
        }
        return format;
    },
    // Produces format strings like "h:mma" -> "6:00pm"
    mediumTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
    smallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
    extraSmallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
    },
    // Produces format strings like "ha" / "H" -> "6pm" / "18"
    hourFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '')
            .replace(/(\Wmm)$/, '') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
    noMeridiemTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, ''); // remove trailing AM/PM
    }
};
// options that should be computed off live calendar options (considers override options)
// TODO: best place for this? related to locale?
// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
var instanceComputableOptions = {
    // Produces format strings for results like "Mo 16"
    smallDayDateFormat: function (options) {
        return options.isRTL ?
            'D dd' :
            'dd D';
    },
    // Produces format strings for results like "Wk 5"
    weekFormat: function (options) {
        return options.isRTL ?
            'w[ ' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ' ]w';
    },
    // Produces format strings for results like "Wk5"
    smallWeekFormat: function (options) {
        return options.isRTL ?
            'w[' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ']w';
    }
};
// TODO: make these computable properties in optionsManager
function populateInstanceComputableOptions(options) {
    $.each(instanceComputableOptions, function (name, func) {
        if (options[name] == null) {
            options[name] = func(options);
        }
    });
}
exports.populateInstanceComputableOptions = populateInstanceComputableOptions;
// Initialize jQuery UI datepicker translations while using some of the translations
// Will set this as the default locales for datepicker.
function datepickerLocale(localeCode, dpLocaleCode, dpOptions) {
    // get the FullCalendar internal option hash for this locale. create if necessary
    var fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // transfer some simple options from datepicker to fc
    fcOptions.isRTL = dpOptions.isRTL;
    fcOptions.weekNumberTitle = dpOptions.weekHeader;
    // compute some more complex options from datepicker
    $.each(dpComputableOptions, function (name, func) {
        fcOptions[name] = func(dpOptions);
    });
    var jqDatePicker = $.datepicker;
    // is jQuery UI Datepicker is on the page?
    if (jqDatePicker) {
        // Register the locale data.
        // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
        // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
        // Make an alias so the locale can be referenced either way.
        jqDatePicker.regional[dpLocaleCode] =
            jqDatePicker.regional[localeCode] = // alias
                dpOptions;
        // Alias 'en' to the default locale data. Do this every time.
        jqDatePicker.regional.en = jqDatePicker.regional[''];
        // Set as Datepicker's global defaults.
        jqDatePicker.setDefaults(dpOptions);
    }
}
exports.datepickerLocale = datepickerLocale;
// Sets FullCalendar-specific translations. Will set the locales as the global default.
function locale(localeCode, newFcOptions) {
    var fcOptions;
    var momOptions;
    // get the FullCalendar internal option hash for this locale. create if necessary
    fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // provided new options for this locales? merge them in
    if (newFcOptions) {
        fcOptions = exports.localeOptionHash[localeCode] = options_1.mergeOptions([fcOptions, newFcOptions]);
    }
    // compute locale options that weren't defined.
    // always do this. newFcOptions can be undefined when initializing from i18n file,
    // so no way to tell if this is an initialization or a default-setting.
    momOptions = getMomentLocaleData(localeCode); // will fall back to en
    $.each(momComputableOptions, function (name, func) {
        if (fcOptions[name] == null) {
            fcOptions[name] = (func)(momOptions, fcOptions);
        }
    });
    // set it as the default locale for FullCalendar
    options_1.globalDefaults.locale = localeCode;
}
exports.locale = locale;
// Returns moment's internal locale data. If doesn't exist, returns English.
function getMomentLocaleData(localeCode) {
    return moment.localeData(localeCode) || moment.localeData('en');
}
exports.getMomentLocaleData = getMomentLocaleData;
// Initialize English by forcing computation of moment-derived options.
// Also, sets it as the default.
locale('en', options_1.englishDefaults);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
exports.globalDefaults = {
    titleRangeSeparator: ' \u2013 ',
    monthYearFormat: 'MMMM YYYY',
    defaultTimedEventDuration: '02:00:00',
    defaultAllDayEventDuration: { days: 1 },
    forceEventDuration: false,
    nextDayThreshold: '09:00:00',
    // display
    columnHeader: true,
    defaultView: 'month',
    aspectRatio: 1.35,
    header: {
        left: 'title',
        center: '',
        right: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberTitle: 'W',
    weekNumberCalculation: 'local',
    // editable: false,
    // nowIndicator: false,
    scrollTime: '06:00:00',
    minTime: '00:00:00',
    maxTime: '24:00:00',
    showNonCurrentDates: true,
    // event ajax
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timezoneParam: 'timezone',
    timezone: false,
    // allDayDefault: undefined,
    // locale
    locale: null,
    isRTL: false,
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day'
    },
    // buttonIcons: null,
    allDayText: 'all-day',
    // allows setting a min-height to the event segment to prevent short events overlapping each other
    agendaEventMinHeight: 0,
    // jquery-ui theming
    theme: false,
    // themeButtonIcons: null,
    // eventResizableFromStart: false,
    dragOpacity: .75,
    dragRevertDuration: 500,
    dragScroll: true,
    // selectable: false,
    unselectAuto: true,
    // selectMinDistance: 0,
    dropAccept: '*',
    eventOrder: 'title',
    // eventRenderWait: null,
    eventLimit: false,
    eventLimitText: 'more',
    eventLimitClick: 'popover',
    dayPopoverFormat: 'LL',
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000
};
exports.englishDefaults = {
    dayPopoverFormat: 'dddd, MMMM D'
};
exports.rtlDefaults = {
    header: {
        left: 'next,prev today',
        center: '',
        right: 'title'
    },
    buttonIcons: {
        prev: 'right-single-arrow',
        next: 'left-single-arrow',
        prevYear: 'right-double-arrow',
        nextYear: 'left-double-arrow'
    },
    themeButtonIcons: {
        prev: 'circle-triangle-e',
        next: 'circle-triangle-w',
        nextYear: 'seek-prev',
        prevYear: 'seek-next'
    }
};
var complexOptions = [
    'header',
    'footer',
    'buttonText',
    'buttonIcons',
    'themeButtonIcons'
];
// Merges an array of option objects into a single object
function mergeOptions(optionObjs) {
    return util_1.mergeProps(optionObjs, complexOptions);
}
exports.mergeOptions = mergeOptions;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
// Class that all other classes will inherit from
var Class = /** @class */ (function () {
    function Class() {
    }
    // Called on a class to create a subclass.
    // LIMITATION: cannot provide a constructor!
    Class.extend = function (members) {
        var SubClass = /** @class */ (function (_super) {
            tslib_1.__extends(SubClass, _super);
            function SubClass() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return SubClass;
        }(this));
        util_1.copyOwnProps(members, SubClass.prototype);
        return SubClass;
    };
    // Adds new member variables/methods to the class's prototype.
    // Can be called with another class, or a plain object hash containing new members.
    Class.mixin = function (members) {
        util_1.copyOwnProps(members, this.prototype);
    };
    return Class;
}());
exports.default = Class;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var ParsableModelMixin_1 = __webpack_require__(208);
var EventDef = /** @class */ (function () {
    function EventDef(source) {
        this.source = source;
        this.className = [];
        this.miscProps = {};
    }
    EventDef.parse = function (rawInput, source) {
        var def = new this(source);
        if (def.applyProps(rawInput)) {
            return def;
        }
        return false;
    };
    EventDef.normalizeId = function (id) {
        return String(id);
    };
    EventDef.generateId = function () {
        return '_fc' + (EventDef.uuid++);
    };
    EventDef.prototype.clone = function () {
        var copy = new this.constructor(this.source);
        copy.id = this.id;
        copy.rawId = this.rawId;
        copy.uid = this.uid; // not really unique anymore :(
        EventDef.copyVerbatimStandardProps(this, copy);
        copy.className = this.className.slice(); // copy
        copy.miscProps = $.extend({}, this.miscProps);
        return copy;
    };
    EventDef.prototype.hasInverseRendering = function () {
        return this.getRendering() === 'inverse-background';
    };
    EventDef.prototype.hasBgRendering = function () {
        var rendering = this.getRendering();
        return rendering === 'inverse-background' || rendering === 'background';
    };
    EventDef.prototype.getRendering = function () {
        if (this.rendering != null) {
            return this.rendering;
        }
        return this.source.rendering;
    };
    EventDef.prototype.getConstraint = function () {
        if (this.constraint != null) {
            return this.constraint;
        }
        if (this.source.constraint != null) {
            return this.source.constraint;
        }
        return this.source.calendar.opt('eventConstraint'); // what about View option?
    };
    EventDef.prototype.getOverlap = function () {
        if (this.overlap != null) {
            return this.overlap;
        }
        if (this.source.overlap != null) {
            return this.source.overlap;
        }
        return this.source.calendar.opt('eventOverlap'); // what about View option?
    };
    EventDef.prototype.isStartExplicitlyEditable = function () {
        if (this.startEditable != null) {
            return this.startEditable;
        }
        return this.source.startEditable;
    };
    EventDef.prototype.isDurationExplicitlyEditable = function () {
        if (this.durationEditable != null) {
            return this.durationEditable;
        }
        return this.source.durationEditable;
    };
    EventDef.prototype.isExplicitlyEditable = function () {
        if (this.editable != null) {
            return this.editable;
        }
        return this.source.editable;
    };
    EventDef.prototype.toLegacy = function () {
        var obj = $.extend({}, this.miscProps);
        obj._id = this.uid;
        obj.source = this.source;
        obj.className = this.className.slice(); // copy
        obj.allDay = this.isAllDay();
        if (this.rawId != null) {
            obj.id = this.rawId;
        }
        EventDef.copyVerbatimStandardProps(this, obj);
        return obj;
    };
    EventDef.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventDef.normalizeId((this.rawId = rawProps.id));
        }
        else {
            this.id = EventDef.generateId();
        }
        if (rawProps._id != null) {
            this.uid = String(rawProps._id);
        }
        else {
            this.uid = EventDef.generateId();
        }
        // TODO: converge with EventSource
        if ($.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventDef.prototype.applyMiscProps = function (rawProps) {
        $.extend(this.miscProps, rawProps);
    };
    EventDef.uuid = 0;
    EventDef.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventDef.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventDef;
}());
exports.default = EventDef;
ParsableModelMixin_1.default.mixInto(EventDef);
EventDef.defineStandardProps({
    // not automatically assigned (`false`)
    _id: false,
    id: false,
    className: false,
    source: false,
    // automatically assigned (`true`)
    title: true,
    url: true,
    rendering: true,
    constraint: true,
    overlap: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange_1 = __webpack_require__(211);
var EventFootprint_1 = __webpack_require__(35);
var ComponentFootprint_1 = __webpack_require__(12);
function eventDefsToEventInstances(eventDefs, unzonedRange) {
    var eventInstances = [];
    var i;
    for (i = 0; i < eventDefs.length; i++) {
        eventInstances.push.apply(eventInstances, // append
        eventDefs[i].buildInstances(unzonedRange));
    }
    return eventInstances;
}
exports.eventDefsToEventInstances = eventDefsToEventInstances;
function eventInstanceToEventRange(eventInstance) {
    return new EventRange_1.default(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
}
exports.eventInstanceToEventRange = eventInstanceToEventRange;
function eventRangeToEventFootprint(eventRange) {
    return new EventFootprint_1.default(new ComponentFootprint_1.default(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
    );
}
exports.eventRangeToEventFootprint = eventRangeToEventFootprint;
function eventInstanceToUnzonedRange(eventInstance) {
    return eventInstance.dateProfile.unzonedRange;
}
exports.eventInstanceToUnzonedRange = eventInstanceToUnzonedRange;
function eventFootprintToComponentFootprint(eventFootprint) {
    return eventFootprint.componentFootprint;
}
exports.eventFootprintToComponentFootprint = eventFootprintToComponentFootprint;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventFootprint = /** @class */ (function () {
    function EventFootprint(componentFootprint, eventDef, eventInstance) {
        this.componentFootprint = componentFootprint;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    EventFootprint.prototype.getEventLegacy = function () {
        return (this.eventInstance || this.eventDef).toLegacy();
    };
    return EventFootprint;
}());
exports.default = EventFootprint;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
var EventDateProfile_1 = __webpack_require__(17);
var EventDef_1 = __webpack_require__(33);
var EventDefDateMutation_1 = __webpack_require__(50);
var SingleEventDef_1 = __webpack_require__(13);
var EventDefMutation = /** @class */ (function () {
    function EventDefMutation() {
    }
    EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
        var eventDef = eventInstance.def;
        var dateProps = {};
        var standardProps = {};
        var miscProps = {};
        var verbatimStandardProps = {};
        var eventDefId = null;
        var className = null;
        var propName;
        var dateProfile;
        var dateMutation;
        var defMutation;
        for (propName in rawProps) {
            if (EventDateProfile_1.default.isStandardProp(propName)) {
                dateProps[propName] = rawProps[propName];
            }
            else if (eventDef.isStandardProp(propName)) {
                standardProps[propName] = rawProps[propName];
            }
            else if (eventDef.miscProps[propName] !== rawProps[propName]) {
                miscProps[propName] = rawProps[propName];
            }
        }
        dateProfile = EventDateProfile_1.default.parse(dateProps, eventDef.source);
        if (dateProfile) {
            dateMutation = EventDefDateMutation_1.default.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
        }
        if (standardProps.id !== eventDef.id) {
            eventDefId = standardProps.id; // only apply if there's a change
        }
        if (!util_1.isArraysEqual(standardProps.className, eventDef.className)) {
            className = standardProps.className; // only apply if there's a change
        }
        EventDef_1.default.copyVerbatimStandardProps(standardProps, // src
        verbatimStandardProps // dest
        );
        defMutation = new EventDefMutation();
        defMutation.eventDefId = eventDefId;
        defMutation.className = className;
        defMutation.verbatimStandardProps = verbatimStandardProps;
        defMutation.miscProps = miscProps;
        if (dateMutation) {
            defMutation.dateMutation = dateMutation;
        }
        return defMutation;
    };
    /*
    eventDef assumed to be a SingleEventDef.
    returns an undo function.
    */
    EventDefMutation.prototype.mutateSingle = function (eventDef) {
        var origDateProfile;
        if (this.dateMutation) {
            origDateProfile = eventDef.dateProfile;
            eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.eventDefId != null) {
            eventDef.id = EventDef_1.default.normalizeId((eventDef.rawId = this.eventDefId));
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.className) {
            eventDef.className = this.className;
        }
        // can't undo
        if (this.verbatimStandardProps) {
            SingleEventDef_1.default.copyVerbatimStandardProps(this.verbatimStandardProps, // src
            eventDef // dest
            );
        }
        // can't undo
        if (this.miscProps) {
            eventDef.applyMiscProps(this.miscProps);
        }
        if (origDateProfile) {
            return function () {
                eventDef.dateProfile = origDateProfile;
            };
        }
        else {
            return function () { };
        }
    };
    EventDefMutation.prototype.setDateMutation = function (dateMutation) {
        if (dateMutation && !dateMutation.isEmpty()) {
            this.dateMutation = dateMutation;
        }
        else {
            this.dateMutation = null;
        }
    };
    EventDefMutation.prototype.isEmpty = function () {
        return !this.dateMutation;
    };
    return EventDefMutation;
}());
exports.default = EventDefMutation;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sourceClasses: [],
    registerClass: function (EventSourceClass) {
        this.sourceClasses.unshift(EventSourceClass); // give highest priority
    },
    parse: function (rawInput, calendar) {
        var sourceClasses = this.sourceClasses;
        var i;
        var eventSource;
        for (i = 0; i < sourceClasses.length; i++) {
            eventSource = sourceClasses[i].parse(rawInput, calendar);
            if (eventSource) {
                return eventSource;
            }
        }
    }
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var Theme = /** @class */ (function () {
    function Theme(optionsManager) {
        this.optionsManager = optionsManager;
        this.processIconOverride();
    }
    Theme.prototype.processIconOverride = function () {
        if (this.iconOverrideOption) {
            this.setIconOverride(this.optionsManager.get(this.iconOverrideOption));
        }
    };
    Theme.prototype.setIconOverride = function (iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if ($.isPlainObject(iconOverrideHash)) {
            iconClassesCopy = $.extend({}, this.iconClasses);
            for (buttonName in iconOverrideHash) {
                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            }
            this.iconClasses = iconClassesCopy;
        }
        else if (iconOverrideHash === false) {
            this.iconClasses = {};
        }
    };
    Theme.prototype.applyIconOverridePrefix = function (className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) {
            className = prefix + className;
        }
        return className;
    };
    Theme.prototype.getClass = function (key) {
        return this.classes[key] || '';
    };
    Theme.prototype.getIconClass = function (buttonName) {
        var className = this.iconClasses[buttonName];
        if (className) {
            return this.baseIconClass + ' ' + className;
        }
        return '';
    };
    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) {
                return this.baseIconClass + ' ' + this.applyIconOverridePrefix(className);
            }
        }
        return '';
    };
    return Theme;
}());
exports.default = Theme;
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Class_1 = __webpack_require__(32);
/*
Embodies a div that has potential scrollbars
*/
var Scroller = /** @class */ (function (_super) {
    tslib_1.__extends(Scroller, _super);
    function Scroller(options) {
        var _this = _super.call(this) || this;
        options = options || {};
        _this.overflowX = options.overflowX || options.overflow || 'auto';
        _this.overflowY = options.overflowY || options.overflow || 'auto';
        return _this;
    }
    Scroller.prototype.render = function () {
        this.el = this.renderEl();
        this.applyOverflow();
    };
    Scroller.prototype.renderEl = function () {
        return (this.scrollEl = $('<div class="fc-scroller"></div>'));
    };
    // sets to natural height, unlocks overflow
    Scroller.prototype.clear = function () {
        this.setHeight('auto');
        this.applyOverflow();
    };
    Scroller.prototype.destroy = function () {
        this.el.remove();
    };
    // Overflow
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.applyOverflow = function () {
        this.scrollEl.css({
            'overflow-x': this.overflowX,
            'overflow-y': this.overflowY
        });
    };
    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
    // Useful for preserving scrollbar widths regardless of future resizes.
    // Can pass in scrollbarWidths for optimization.
    Scroller.prototype.lockOverflow = function (scrollbarWidths) {
        var overflowX = this.overflowX;
        var overflowY = this.overflowY;
        scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
        if (overflowX === 'auto') {
            overflowX = (scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
                // OR scrolling pane with massless scrollbars?
                this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth) ? 'scroll' : 'hidden';
        }
        if (overflowY === 'auto') {
            overflowY = (scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
                // OR scrolling pane with massless scrollbars?
                this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight) ? 'scroll' : 'hidden';
        }
        this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
    };
    // Getters / Setters
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.setHeight = function (height) {
        this.scrollEl.height(height);
    };
    Scroller.prototype.getScrollTop = function () {
        return this.scrollEl.scrollTop();
    };
    Scroller.prototype.setScrollTop = function (top) {
        this.scrollEl.scrollTop(top);
    };
    Scroller.prototype.getClientWidth = function () {
        return this.scrollEl[0].clientWidth;
    };
    Scroller.prototype.getClientHeight = function () {
        return this.scrollEl[0].clientHeight;
    };
    Scroller.prototype.getScrollbarWidths = function () {
        return util_1.getScrollbarWidths(this.scrollEl);
    };
    return Scroller;
}(Class_1.default));
exports.default = Scroller;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var DateComponent_1 = __webpack_require__(219);
var GlobalEmitter_1 = __webpack_require__(20);
var InteractiveDateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InteractiveDateComponent, _super);
    function InteractiveDateComponent(_view, _options) {
        var _this = _super.call(this, _view, _options) || this;
        // self-config, overridable by subclasses
        _this.segSelector = '.fc-event-container > *'; // what constitutes an event element?
        if (_this.dateSelectingClass) {
            _this.dateClicking = new _this.dateClickingClass(_this);
        }
        if (_this.dateSelectingClass) {
            _this.dateSelecting = new _this.dateSelectingClass(_this);
        }
        if (_this.eventPointingClass) {
            _this.eventPointing = new _this.eventPointingClass(_this);
        }
        if (_this.eventDraggingClass && _this.eventPointing) {
            _this.eventDragging = new _this.eventDraggingClass(_this, _this.eventPointing);
        }
        if (_this.eventResizingClass && _this.eventPointing) {
            _this.eventResizing = new _this.eventResizingClass(_this, _this.eventPointing);
        }
        if (_this.externalDroppingClass) {
            _this.externalDropping = new _this.externalDroppingClass(_this);
        }
        return _this;
    }
    // Sets the container element that the view should render inside of, does global DOM-related initializations,
    // and renders all the non-date-related content inside.
    InteractiveDateComponent.prototype.setElement = function (el) {
        _super.prototype.setElement.call(this, el);
        if (this.dateClicking) {
            this.dateClicking.bindToEl(el);
        }
        if (this.dateSelecting) {
            this.dateSelecting.bindToEl(el);
        }
        this.bindAllSegHandlersToEl(el);
    };
    InteractiveDateComponent.prototype.removeElement = function () {
        this.endInteractions();
        _super.prototype.removeElement.call(this);
    };
    InteractiveDateComponent.prototype.executeEventUnrender = function () {
        this.endInteractions();
        _super.prototype.executeEventUnrender.call(this);
    };
    InteractiveDateComponent.prototype.bindGlobalHandlers = function () {
        _super.prototype.bindGlobalHandlers.call(this);
        if (this.externalDropping) {
            this.externalDropping.bindToDocument();
        }
    };
    InteractiveDateComponent.prototype.unbindGlobalHandlers = function () {
        _super.prototype.unbindGlobalHandlers.call(this);
        if (this.externalDropping) {
            this.externalDropping.unbindFromDocument();
        }
    };
    InteractiveDateComponent.prototype.bindDateHandlerToEl = function (el, name, handler) {
        var _this = this;
        // attach a handler to the grid's root element.
        // jQuery will take care of unregistering them when removeElement gets called.
        this.el.on(name, function (ev) {
            if (!$(ev.target).is(_this.segSelector + ':not(.fc-helper),' + // directly on an event element
                _this.segSelector + ':not(.fc-helper) *,' + // within an event element
                '.fc-more,' + // a "more.." link
                'a[data-goto]' // a clickable nav link
            )) {
                return handler.call(_this, ev);
            }
        });
    };
    InteractiveDateComponent.prototype.bindAllSegHandlersToEl = function (el) {
        [
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (eventInteraction) {
            if (eventInteraction) {
                eventInteraction.bindToEl(el);
            }
        });
    };
    InteractiveDateComponent.prototype.bindSegHandlerToEl = function (el, name, handler) {
        var _this = this;
        el.on(name, this.segSelector, function (ev) {
            var segEl = $(ev.currentTarget);
            if (!segEl.is('.fc-helper')) {
                var seg = segEl.data('fc-seg'); // grab segment data. put there by View::renderEventsPayload
                if (seg && !_this.shouldIgnoreEventPointing()) {
                    return handler.call(_this, seg, ev); // context will be the Grid
                }
            }
        });
    };
    InteractiveDateComponent.prototype.shouldIgnoreMouse = function () {
        // HACK
        // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
        return GlobalEmitter_1.default.get().shouldIgnoreMouse();
    };
    InteractiveDateComponent.prototype.shouldIgnoreTouch = function () {
        var view = this._getView();
        // On iOS (and Android?) when a new selection is initiated overtop another selection,
        // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
        // HACK: simply don't allow this to happen.
        // ALSO: prevent selection when an *event* is already raised.
        return view.isSelected || view.selectedEvent;
    };
    InteractiveDateComponent.prototype.shouldIgnoreEventPointing = function () {
        // only call the handlers if there is not a drag/resize in progress
        return (this.eventDragging && this.eventDragging.isDragging) ||
            (this.eventResizing && this.eventResizing.isResizing);
    };
    InteractiveDateComponent.prototype.canStartSelection = function (seg, ev) {
        return util_1.getEvIsTouch(ev) &&
            !this.canStartResize(seg, ev) &&
            (this.isEventDefDraggable(seg.footprint.eventDef) ||
                this.isEventDefResizable(seg.footprint.eventDef));
    };
    InteractiveDateComponent.prototype.canStartDrag = function (seg, ev) {
        return !this.canStartResize(seg, ev) &&
            this.isEventDefDraggable(seg.footprint.eventDef);
    };
    InteractiveDateComponent.prototype.canStartResize = function (seg, ev) {
        var view = this._getView();
        var eventDef = seg.footprint.eventDef;
        return (!util_1.getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) &&
            this.isEventDefResizable(eventDef) &&
            $(ev.target).is('.fc-resizer');
    };
    // Kills all in-progress dragging.
    // Useful for when public API methods that result in re-rendering are invoked during a drag.
    // Also useful for when touch devices misbehave and don't fire their touchend.
    InteractiveDateComponent.prototype.endInteractions = function () {
        [
            this.dateClicking,
            this.dateSelecting,
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (interaction) {
            if (interaction) {
                interaction.end();
            }
        });
    };
    // Event Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be dragged by the user
    InteractiveDateComponent.prototype.isEventDefDraggable = function (eventDef) {
        return this.isEventDefStartEditable(eventDef);
    };
    InteractiveDateComponent.prototype.isEventDefStartEditable = function (eventDef) {
        var isEditable = eventDef.isStartExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('eventStartEditable');
            if (isEditable == null) {
                isEditable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isEditable;
    };
    InteractiveDateComponent.prototype.isEventDefGenerallyEditable = function (eventDef) {
        var isEditable = eventDef.isExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('editable');
        }
        return isEditable;
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be resized from its starting edge
    InteractiveDateComponent.prototype.isEventDefResizableFromStart = function (eventDef) {
        return this.opt('eventResizableFromStart') && this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized from its ending edge
    InteractiveDateComponent.prototype.isEventDefResizableFromEnd = function (eventDef) {
        return this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized by the user at all
    InteractiveDateComponent.prototype.isEventDefResizable = function (eventDef) {
        var isResizable = eventDef.isDurationExplicitlyEditable();
        if (isResizable == null) {
            isResizable = this.opt('eventDurationEditable');
            if (isResizable == null) {
                isResizable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isResizable;
    };
    // Event Mutation / Constraints
    // ---------------------------------------------------------------------------------------------------------------
    // Diffs the two dates, returning a duration, based on granularity of the grid
    // TODO: port isTimeScale into this system?
    InteractiveDateComponent.prototype.diffDates = function (a, b) {
        if (this.largeUnit) {
            return util_1.diffByUnit(a, b, this.largeUnit);
        }
        else {
            return util_1.diffDayTime(a, b);
        }
    };
    // is it allowed, in relation to the view's validRange?
    // NOTE: very similar to isExternalInstanceGroupAllowed
    InteractiveDateComponent.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            // TODO: just use getAllEventRanges directly
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        return view.calendar.constraints.isEventInstanceGroupAllowed(eventInstanceGroup);
    };
    // NOTE: very similar to isEventInstanceGroupAllowed
    // when it's a completely anonymous external drag, no event.
    InteractiveDateComponent.prototype.isExternalInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        for (i = 0; i < eventFootprints.length; i++) {
            // treat it as a selection
            // TODO: pass in eventInstanceGroup instead
            //  because we don't want calendar's constraint system to depend on a component's
            //  determination of footprints.
            if (!view.calendar.constraints.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
                return false;
            }
        }
        return true;
    };
    return InteractiveDateComponent;
}(DateComponent_1.default));
exports.default = InteractiveDateComponent;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var RenderQueue_1 = __webpack_require__(218);
var DateProfileGenerator_1 = __webpack_require__(221);
var InteractiveDateComponent_1 = __webpack_require__(40);
var GlobalEmitter_1 = __webpack_require__(20);
var UnzonedRange_1 = __webpack_require__(5);
/* An abstract class from which other views inherit from
----------------------------------------------------------------------------------------------------------------------*/
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View(calendar, viewSpec) {
        var _this = _super.call(this, null, viewSpec.options) || this;
        _this.batchRenderDepth = 0;
        _this.isSelected = false; // boolean whether a range of time is user-selected or not
        _this.calendar = calendar;
        _this.viewSpec = viewSpec;
        // shortcuts
        _this.type = viewSpec.type;
        // .name is deprecated
        _this.name = _this.type;
        _this.initRenderQueue();
        _this.initHiddenDays();
        _this.dateProfileGenerator = new _this.dateProfileGeneratorClass(_this);
        _this.bindBaseRenderHandlers();
        _this.eventOrderSpecs = util_1.parseFieldSpecs(_this.opt('eventOrder'));
        // legacy
        if (_this['initialize']) {
            _this['initialize']();
        }
        return _this;
    }
    View.prototype._getView = function () {
        return this;
    };
    // Retrieves an option with the given name
    View.prototype.opt = function (name) {
        return this.options[name];
    };
    /* Render Queue
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.initRenderQueue = function () {
        this.renderQueue = new RenderQueue_1.default({
            event: this.opt('eventRenderWait')
        });
        this.renderQueue.on('start', this.onRenderQueueStart.bind(this));
        this.renderQueue.on('stop', this.onRenderQueueStop.bind(this));
        this.on('before:change', this.startBatchRender);
        this.on('change', this.stopBatchRender);
    };
    View.prototype.onRenderQueueStart = function () {
        this.calendar.freezeContentHeight();
        this.addScroll(this.queryScroll());
    };
    View.prototype.onRenderQueueStop = function () {
        if (this.calendar.updateViewSize()) {
            this.popScroll();
        }
        this.calendar.thawContentHeight();
    };
    View.prototype.startBatchRender = function () {
        if (!(this.batchRenderDepth++)) {
            this.renderQueue.pause();
        }
    };
    View.prototype.stopBatchRender = function () {
        if (!(--this.batchRenderDepth)) {
            this.renderQueue.resume();
        }
    };
    View.prototype.requestRender = function (func, namespace, actionType) {
        this.renderQueue.queue(func, namespace, actionType);
    };
    // given func will auto-bind to `this`
    View.prototype.whenSizeUpdated = function (func) {
        if (this.renderQueue.isRunning) {
            this.renderQueue.one('stop', func.bind(this));
        }
        else {
            func.call(this);
        }
    };
    /* Title and Date Formatting
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes what the title at the top of the calendar should be for this view
    View.prototype.computeTitle = function (dateProfile) {
        var unzonedRange;
        // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
            unzonedRange = dateProfile.currentUnzonedRange;
        }
        else {
            unzonedRange = dateProfile.activeUnzonedRange;
        }
        return this.formatRange({
            start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
            end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
        }, dateProfile.isRangeAllDay, this.opt('titleFormat') || this.computeTitleFormat(dateProfile), this.opt('titleRangeSeparator'));
    };
    // Generates the format string that should be used to generate the title for the current date range.
    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
    View.prototype.computeTitleFormat = function (dateProfile) {
        var currentRangeUnit = dateProfile.currentRangeUnit;
        if (currentRangeUnit === 'year') {
            return 'YYYY';
        }
        else if (currentRangeUnit === 'month') {
            return this.opt('monthYearFormat'); // like "September 2014"
        }
        else if (dateProfile.currentUnzonedRange.as('days') > 1) {
            return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
        }
        else {
            return 'LL'; // one day. longer, like "September 9 2014"
        }
    };
    // Date Setting/Unsetting
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.setDate = function (date) {
        var currentDateProfile = this.get('dateProfile');
        var newDateProfile = this.dateProfileGenerator.build(date, undefined, true); // forceToValid=true
        if (!currentDateProfile ||
            !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
            this.set('dateProfile', newDateProfile);
        }
    };
    View.prototype.unsetDate = function () {
        this.unset('dateProfile');
    };
    // Event Data
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.fetchInitialEvents = function (dateProfile) {
        var calendar = this.calendar;
        var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
        return calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay));
    };
    View.prototype.bindEventChanges = function () {
        this.listenTo(this.calendar, 'eventsReset', this.resetEvents); // TODO: make this a real event
    };
    View.prototype.unbindEventChanges = function () {
        this.stopListeningTo(this.calendar, 'eventsReset');
    };
    View.prototype.setEvents = function (eventsPayload) {
        this.set('currentEvents', eventsPayload);
        this.set('hasEvents', true);
    };
    View.prototype.unsetEvents = function () {
        this.unset('currentEvents');
        this.unset('hasEvents');
    };
    View.prototype.resetEvents = function (eventsPayload) {
        this.startBatchRender();
        this.unsetEvents();
        this.setEvents(eventsPayload);
        this.stopBatchRender();
    };
    // Date High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestDateRender = function (dateProfile) {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateRender(dateProfile);
        }, 'date', 'init');
    };
    View.prototype.requestDateUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateUnrender();
        }, 'date', 'destroy');
    };
    // if dateProfile not specified, uses current
    View.prototype.executeDateRender = function (dateProfile) {
        _super.prototype.executeDateRender.call(this, dateProfile);
        if (this['render']) {
            this['render'](); // TODO: deprecate
        }
        this.trigger('datesRendered');
        this.addScroll({ isDateInit: true });
        this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
    };
    View.prototype.executeDateUnrender = function () {
        this.unselect();
        this.stopNowIndicator();
        this.trigger('before:datesUnrendered');
        if (this['destroy']) {
            this['destroy'](); // TODO: deprecate
        }
        _super.prototype.executeDateUnrender.call(this);
    };
    // "Base" rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.bindBaseRenderHandlers = function () {
        var _this = this;
        this.on('datesRendered', function () {
            _this.whenSizeUpdated(_this.triggerViewRender);
        });
        this.on('before:datesUnrendered', function () {
            _this.triggerViewDestroy();
        });
    };
    View.prototype.triggerViewRender = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerViewDestroy = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Event High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestEventsRender = function (eventsPayload) {
        var _this = this;
        this.requestRender(function () {
            _this.executeEventRender(eventsPayload);
            _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
        }, 'event', 'init');
    };
    View.prototype.requestEventsUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.triggerBeforeEventsDestroyed();
            _this.executeEventUnrender();
        }, 'event', 'destroy');
    };
    // Business Hour High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestBusinessHoursRender = function (businessHourGenerator) {
        var _this = this;
        this.requestRender(function () {
            _this.renderBusinessHours(businessHourGenerator);
        }, 'businessHours', 'init');
    };
    View.prototype.requestBusinessHoursUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.unrenderBusinessHours();
        }, 'businessHours', 'destroy');
    };
    // Misc view rendering utils
    // -----------------------------------------------------------------------------------------------------------------
    // Binds DOM handlers to elements that reside outside the view container, such as the document
    View.prototype.bindGlobalHandlers = function () {
        _super.prototype.bindGlobalHandlers.call(this);
        this.listenTo(GlobalEmitter_1.default.get(), {
            touchstart: this.processUnselect,
            mousedown: this.handleDocumentMousedown
        });
    };
    // Unbinds DOM handlers from elements that reside outside the view container
    View.prototype.unbindGlobalHandlers = function () {
        _super.prototype.unbindGlobalHandlers.call(this);
        this.stopListeningTo(GlobalEmitter_1.default.get());
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    // Immediately render the current time indicator and begins re-rendering it at an interval,
    // which is defined by this.getNowIndicatorUnit().
    // TODO: somehow do this for the current whole day's background too
    View.prototype.startNowIndicator = function () {
        var _this = this;
        var unit;
        var update;
        var delay; // ms wait value
        if (this.opt('nowIndicator')) {
            unit = this.getNowIndicatorUnit();
            if (unit) {
                update = util_1.proxy(this, 'updateNowIndicator'); // bind to `this`
                this.initialNowDate = this.calendar.getNow();
                this.initialNowQueriedMs = new Date().valueOf();
                // wait until the beginning of the next interval
                delay = this.initialNowDate.clone().startOf(unit).add(1, unit).valueOf() - this.initialNowDate.valueOf();
                this.nowIndicatorTimeoutID = setTimeout(function () {
                    _this.nowIndicatorTimeoutID = null;
                    update();
                    delay = +moment.duration(1, unit);
                    delay = Math.max(100, delay); // prevent too frequent
                    _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
                }, delay);
            }
            // rendering will be initiated in updateSize
        }
    };
    // rerenders the now indicator, computing the new current time from the amount of time that has passed
    // since the initial getNow call.
    View.prototype.updateNowIndicator = function () {
        if (this.isDatesRendered &&
            this.initialNowDate // activated before?
        ) {
            this.unrenderNowIndicator(); // won't unrender if unnecessary
            this.renderNowIndicator(this.initialNowDate.clone().add(new Date().valueOf() - this.initialNowQueriedMs) // add ms
            );
            this.isNowIndicatorRendered = true;
        }
    };
    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
    // Won't cause side effects if indicator isn't rendered.
    View.prototype.stopNowIndicator = function () {
        if (this.isNowIndicatorRendered) {
            if (this.nowIndicatorTimeoutID) {
                clearTimeout(this.nowIndicatorTimeoutID);
                this.nowIndicatorTimeoutID = null;
            }
            if (this.nowIndicatorIntervalID) {
                clearInterval(this.nowIndicatorIntervalID);
                this.nowIndicatorIntervalID = null;
            }
            this.unrenderNowIndicator();
            this.isNowIndicatorRendered = false;
        }
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        if (this['setHeight']) {
            this['setHeight'](totalHeight, isAuto);
        }
        else {
            _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        }
        this.updateNowIndicator();
    };
    /* Scroller
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.addScroll = function (scroll) {
        var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
        $.extend(queuedScroll, scroll);
    };
    View.prototype.popScroll = function () {
        this.applyQueuedScroll();
        this.queuedScroll = null;
    };
    View.prototype.applyQueuedScroll = function () {
        if (this.queuedScroll) {
            this.applyScroll(this.queuedScroll);
        }
    };
    View.prototype.queryScroll = function () {
        var scroll = {};
        if (this.isDatesRendered) {
            $.extend(scroll, this.queryDateScroll());
        }
        return scroll;
    };
    View.prototype.applyScroll = function (scroll) {
        if (scroll.isDateInit && this.isDatesRendered) {
            $.extend(scroll, this.computeInitialDateScroll());
        }
        if (this.isDatesRendered) {
            this.applyDateScroll(scroll);
        }
    };
    View.prototype.computeInitialDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.queryDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.applyDateScroll = function (scroll) {
        // subclasses must implement
    };
    /* Event Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.reportEventDrop = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        var dateMutation = eventMutation.dateMutation;
        // update the EventInstance, for handlers
        if (dateMutation) {
            eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        }
        this.triggerEventDrop(eventInstance, 
        // a drop doesn't necessarily mean a date mutation (ex: resource change)
        (dateMutation && dateMutation.dateDelta) || moment.duration(), undoFunc, el, ev);
    };
    // Triggers event-drop handlers that have subscribed via the API
    View.prototype.triggerEventDrop = function (eventInstance, dateDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventDrop', {
            context: el[0],
            args: [
                eventInstance.toLegacy(),
                dateDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* External Element Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
    // `meta` is the parsed data that has been embedded into the dragging event.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    View.prototype.reportExternalDrop = function (singleEventDef, isEvent, isSticky, el, ev, ui) {
        if (isEvent) {
            this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
        }
        this.triggerExternalDrop(singleEventDef, isEvent, el, ev, ui);
    };
    // Triggers external-drop handlers that have subscribed via the API
    View.prototype.triggerExternalDrop = function (singleEventDef, isEvent, el, ev, ui) {
        // trigger 'drop' regardless of whether element represents an event
        this.publiclyTrigger('drop', {
            context: el[0],
            args: [
                singleEventDef.dateProfile.start.clone(),
                ev,
                ui,
                this
            ]
        });
        if (isEvent) {
            // signal an external event landed
            this.publiclyTrigger('eventReceive', {
                context: this,
                args: [
                    singleEventDef.buildInstance().toLegacy(),
                    this
                ]
            });
        }
    };
    /* Event Resizing
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an event in the view has been resized to a new length
    View.prototype.reportEventResize = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        // update the EventInstance, for handlers
        eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        this.triggerEventResize(eventInstance, eventMutation.dateMutation.endDelta, undoFunc, el, ev);
    };
    // Triggers event-resize handlers that have subscribed via the API
    View.prototype.triggerEventResize = function (eventInstance, durationDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventResize', {
            context: el[0],
            args: [
                eventInstance.toLegacy(),
                durationDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* Selection (time range)
    ------------------------------------------------------------------------------------------------------------------*/
    // Selects a date span on the view. `start` and `end` are both Moments.
    // `ev` is the native mouse event that begin the interaction.
    View.prototype.select = function (footprint, ev) {
        this.unselect(ev);
        this.renderSelectionFootprint(footprint);
        this.reportSelection(footprint, ev);
    };
    View.prototype.renderSelectionFootprint = function (footprint) {
        if (this['renderSelection']) {
            this['renderSelection'](footprint.toLegacy(this.calendar));
        }
        else {
            _super.prototype.renderSelectionFootprint.call(this, footprint);
        }
    };
    // Called when a new selection is made. Updates internal state and triggers handlers.
    View.prototype.reportSelection = function (footprint, ev) {
        this.isSelected = true;
        this.triggerSelect(footprint, ev);
    };
    // Triggers handlers to 'select'
    View.prototype.triggerSelect = function (footprint, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('select', {
            context: this,
            args: [
                dateProfile.start,
                dateProfile.end,
                ev,
                this
            ]
        });
    };
    // Undoes a selection. updates in the internal state and triggers handlers.
    // `ev` is the native mouse event that began the interaction.
    View.prototype.unselect = function (ev) {
        if (this.isSelected) {
            this.isSelected = false;
            if (this['destroySelection']) {
                this['destroySelection'](); // TODO: deprecate
            }
            this.unrenderSelection();
            this.publiclyTrigger('unselect', {
                context: this,
                args: [ev, this]
            });
        }
    };
    /* Event Selection
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.selectEventInstance = function (eventInstance) {
        if (!this.selectedEventInstance ||
            this.selectedEventInstance !== eventInstance) {
            this.unselectEventInstance();
            this.getEventSegs().forEach(function (seg) {
                if (seg.footprint.eventInstance === eventInstance &&
                    seg.el // necessary?
                ) {
                    seg.el.addClass('fc-selected');
                }
            });
            this.selectedEventInstance = eventInstance;
        }
    };
    View.prototype.unselectEventInstance = function () {
        if (this.selectedEventInstance) {
            this.getEventSegs().forEach(function (seg) {
                if (seg.el) {
                    seg.el.removeClass('fc-selected');
                }
            });
            this.selectedEventInstance = null;
        }
    };
    View.prototype.isEventDefSelected = function (eventDef) {
        // event references might change on refetchEvents(), while selectedEventInstance doesn't,
        // so compare IDs
        return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
    };
    /* Mouse / Touch Unselecting (time range & event unselection)
    ------------------------------------------------------------------------------------------------------------------*/
    // TODO: move consistently to down/start or up/end?
    // TODO: don't kill previous selection if touch scrolling
    View.prototype.handleDocumentMousedown = function (ev) {
        if (util_1.isPrimaryMouseButton(ev)) {
            this.processUnselect(ev);
        }
    };
    View.prototype.processUnselect = function (ev) {
        this.processRangeUnselect(ev);
        this.processEventUnselect(ev);
    };
    View.prototype.processRangeUnselect = function (ev) {
        var ignore;
        // is there a time-range selection?
        if (this.isSelected && this.opt('unselectAuto')) {
            // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
            ignore = this.opt('unselectCancel');
            if (!ignore || !$(ev.target).closest(ignore).length) {
                this.unselect(ev);
            }
        }
    };
    View.prototype.processEventUnselect = function (ev) {
        if (this.selectedEventInstance) {
            if (!$(ev.target).closest('.fc-selected').length) {
                this.unselectEventInstance();
            }
        }
    };
    /* Triggers
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.triggerBaseRendered = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerBaseUnrendered = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Triggers handlers to 'dayClick'
    // Span has start/end of the clicked area. Only the start is useful.
    View.prototype.triggerDayClick = function (footprint, dayEl, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('dayClick', {
            context: dayEl,
            args: [dateProfile.start, ev, this]
        });
    };
    /* Date Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // For DateComponent::getDayClasses
    View.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return false;
    };
    // Arguments after name will be forwarded to a hypothetical function value
    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
    // Always clone your objects if you fear mutation.
    View.prototype.getUnzonedRangeOption = function (name) {
        var val = this.opt(name);
        if (typeof val === 'function') {
            val = val.apply(null, Array.prototype.slice.call(arguments, 1));
        }
        if (val) {
            return this.calendar.parseUnzonedRange(val);
        }
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    View.prototype.initHiddenDays = function () {
        var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.opt('weekends') === false) {
            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        }
        for (i = 0; i < 7; i++) {
            if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
                dayCnt++;
            }
        }
        if (!dayCnt) {
            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        }
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    View.prototype.trimHiddenDays = function (inputUnzonedRange) {
        var start = inputUnzonedRange.getStart();
        var end = inputUnzonedRange.getEnd();
        if (start) {
            start = this.skipHiddenDays(start);
        }
        if (end) {
            end = this.skipHiddenDays(end, -1, true);
        }
        if (start === null || end === null || start < end) {
            return new UnzonedRange_1.default(start, end);
        }
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Moment
    View.prototype.isHiddenDay = function (day) {
        if (moment.isMoment(day)) {
            day = day.day();
        }
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validUnzonedRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    View.prototype.skipHiddenDays = function (date, inc, isExclusive) {
        if (inc === void 0) { inc = 1; }
        if (isExclusive === void 0) { isExclusive = false; }
        var out = date.clone();
        while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
            out.add(inc, 'days');
        }
        return out;
    };
    return View;
}(InteractiveDateComponent_1.default));
exports.default = View;
View.prototype.usesMinMaxTime = false;
View.prototype.dateProfileGeneratorClass = DateProfileGenerator_1.default;
View.watch('displayingDates', ['isInDom', 'dateProfile'], function (deps) {
    this.requestDateRender(deps.dateProfile);
}, function () {
    this.requestDateUnrender();
});
View.watch('displayingBusinessHours', ['displayingDates', 'businessHourGenerator'], function (deps) {
    this.requestBusinessHoursRender(deps.businessHourGenerator);
}, function () {
    this.requestBusinessHoursUnrender();
});
View.watch('initialEvents', ['dateProfile'], function (deps) {
    return this.fetchInitialEvents(deps.dateProfile);
});
View.watch('bindingEvents', ['initialEvents'], function (deps) {
    this.setEvents(deps.initialEvents);
    this.bindEventChanges();
}, function () {
    this.unbindEventChanges();
    this.unsetEvents();
});
View.watch('displayingEvents', ['displayingDates', 'hasEvents'], function () {
    this.requestEventsRender(this.get('currentEvents'));
}, function () {
    this.requestEventsUnrender();
});
View.watch('title', ['dateProfile'], function (deps) {
    return (this.title = this.computeTitle(deps.dateProfile)); // assign to View for legacy reasons
});
View.watch('legacyDateProps', ['dateProfile'], function (deps) {
    var calendar = this.calendar;
    var dateProfile = deps.dateProfile;
    // DEPRECATED, but we need to keep it updated...
    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventRenderer = /** @class */ (function () {
    function EventRenderer(component, fillRenderer) {
        this.view = component._getView();
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    EventRenderer.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    // Updates values that rely on options and also relate to range
    EventRenderer.prototype.rangeUpdated = function () {
        var displayEventTime;
        var displayEventEnd;
        this.eventTimeFormat =
            this.opt('eventTimeFormat') ||
                this.opt('timeFormat') || // deprecated
                this.computeEventTimeFormat();
        displayEventTime = this.opt('displayEventTime');
        if (displayEventTime == null) {
            displayEventTime = this.computeDisplayEventTime(); // might be based off of range
        }
        displayEventEnd = this.opt('displayEventEnd');
        if (displayEventEnd == null) {
            displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
        }
        this.displayEventTime = displayEventTime;
        this.displayEventEnd = displayEventEnd;
    };
    EventRenderer.prototype.render = function (eventsPayload) {
        var dateProfile = this.component._getDateProfile();
        var eventDefId;
        var instanceGroup;
        var eventRanges;
        var bgRanges = [];
        var fgRanges = [];
        for (eventDefId in eventsPayload) {
            instanceGroup = eventsPayload[eventDefId];
            eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);
            if (instanceGroup.getEventDef().hasBgRendering()) {
                bgRanges.push.apply(bgRanges, eventRanges);
            }
            else {
                fgRanges.push.apply(fgRanges, eventRanges);
            }
        }
        this.renderBgRanges(bgRanges);
        this.renderFgRanges(fgRanges);
    };
    EventRenderer.prototype.unrender = function () {
        this.unrenderBgRanges();
        this.unrenderFgRanges();
    };
    EventRenderer.prototype.renderFgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        // render an `.el` on each seg
        // returns a subset of the segs. segs that were actually rendered
        segs = this.renderFgSegEls(segs);
        if (this.renderFgSegs(segs) !== false) {
            this.fgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderFgRanges = function () {
        this.unrenderFgSegs(this.fgSegs || []);
        this.fgSegs = null;
    };
    EventRenderer.prototype.renderBgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        if (this.renderBgSegs(segs) !== false) {
            this.bgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderBgRanges = function () {
        this.unrenderBgSegs();
        this.bgSegs = null;
    };
    EventRenderer.prototype.getSegs = function () {
        return (this.bgSegs || []).concat(this.fgSegs || []);
    };
    // Renders foreground event segments onto the grid
    EventRenderer.prototype.renderFgSegs = function (segs) {
        // subclasses must implement
        // segs already has rendered els, and has been filtered.
        return false; // signal failure if not implemented
    };
    // Unrenders all currently rendered foreground segments
    EventRenderer.prototype.unrenderFgSegs = function (segs) {
        // subclasses must implement
    };
    EventRenderer.prototype.renderBgSegs = function (segs) {
        var _this = this;
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('bgEvent', segs, {
                getClasses: function (seg) {
                    return _this.getBgClasses(seg.footprint.eventDef);
                },
                getCss: function (seg) {
                    return {
                        'background-color': _this.getBgColor(seg.footprint.eventDef)
                    };
                },
                filterEl: function (seg, el) {
                    return _this.filterEventRenderEl(seg.footprint, el);
                }
            });
        }
        else {
            return false; // signal failure if no fillRenderer
        }
    };
    EventRenderer.prototype.unrenderBgSegs = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('bgEvent');
        }
    };
    // Renders and assigns an `el` property for each foreground event segment.
    // Only returns segments that successfully rendered.
    EventRenderer.prototype.renderFgSegEls = function (segs, disableResizing) {
        var _this = this;
        if (disableResizing === void 0) { disableResizing = false; }
        var hasEventRenderHandlers = this.view.hasPublicHandlers('eventRender');
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) {
            // build a large concatenation of event segment HTML
            for (i = 0; i < segs.length; i++) {
                this.beforeFgSegHtml(segs[i]);
                html += this.fgSegHtml(segs[i], disableResizing);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
            $(html).each(function (i, node) {
                var seg = segs[i];
                var el = $(node);
                if (hasEventRenderHandlers) {
                    el = _this.filterEventRenderEl(seg.footprint, el);
                }
                if (el) {
                    el.data('fc-seg', seg); // used by handlers
                    seg.el = el;
                    renderedSegs.push(seg);
                }
            });
        }
        return renderedSegs;
    };
    EventRenderer.prototype.beforeFgSegHtml = function (seg) {
    };
    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
    EventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        // subclasses should implement
    };
    // Generic utility for generating the HTML classNames for an event segment's element
    EventRenderer.prototype.getSegClasses = function (seg, isDraggable, isResizable) {
        var classes = [
            'fc-event',
            seg.isStart ? 'fc-start' : 'fc-not-start',
            seg.isEnd ? 'fc-end' : 'fc-not-end'
        ].concat(this.getClasses(seg.footprint.eventDef));
        if (isDraggable) {
            classes.push('fc-draggable');
        }
        if (isResizable) {
            classes.push('fc-resizable');
        }
        // event is currently selected? attach a className.
        if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
            classes.push('fc-selected');
        }
        return classes;
    };
    // Given an event and the default element used for rendering, returns the element that should actually be used.
    // Basically runs events and elements through the eventRender hook.
    EventRenderer.prototype.filterEventRenderEl = function (eventFootprint, el) {
        var legacy = eventFootprint.getEventLegacy();
        var custom = this.view.publiclyTrigger('eventRender', {
            context: legacy,
            args: [legacy, el, this.view]
        });
        if (custom === false) {
            el = null;
        }
        else if (custom && custom !== true) {
            el = $(custom);
        }
        return el;
    };
    // Compute the text that should be displayed on an event's element.
    // `range` can be the Event object itself, or something range-like, with at least a `start`.
    // If event times are disabled, or the event has no time, will return a blank string.
    // If not specified, formatStr will default to the eventTimeFormat setting,
    // and displayEnd will default to the displayEventEnd setting.
    EventRenderer.prototype.getTimeText = function (eventFootprint, formatStr, displayEnd) {
        return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
    };
    EventRenderer.prototype._getTimeText = function (start, end, isAllDay, formatStr, displayEnd) {
        if (formatStr == null) {
            formatStr = this.eventTimeFormat;
        }
        if (displayEnd == null) {
            displayEnd = this.displayEventEnd;
        }
        if (this.displayEventTime && !isAllDay) {
            if (displayEnd && end) {
                return this.view.formatRange({ start: start, end: end }, false, // allDay
                formatStr);
            }
            else {
                return start.format(formatStr);
            }
        }
        return '';
    };
    EventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('smallTimeFormat');
    };
    EventRenderer.prototype.computeDisplayEventTime = function () {
        return true;
    };
    EventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    EventRenderer.prototype.getBgClasses = function (eventDef) {
        var classNames = this.getClasses(eventDef);
        classNames.push('fc-bgevent');
        return classNames;
    };
    EventRenderer.prototype.getClasses = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var classNames = [];
        for (i = 0; i < objs.length; i++) {
            classNames.push.apply(// append
            classNames, objs[i].eventClassName || objs[i].className || []);
        }
        return classNames;
    };
    // Utility for generating event skin-related CSS properties
    EventRenderer.prototype.getSkinCss = function (eventDef) {
        return {
            'background-color': this.getBgColor(eventDef),
            'border-color': this.getBorderColor(eventDef),
            color: this.getTextColor(eventDef)
        };
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBgColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBackgroundColor || objs[i].eventColor ||
                objs[i].backgroundColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBackgroundColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBorderColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBorderColor || objs[i].eventColor ||
                objs[i].borderColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBorderColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getTextColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventTextColor ||
                objs[i].textColor;
        }
        if (!val) {
            val = this.opt('eventTextColor');
        }
        return val;
    };
    EventRenderer.prototype.getStylingObjs = function (eventDef) {
        var objs = this.getFallbackStylingObjs(eventDef);
        objs.unshift(eventDef);
        return objs;
    };
    EventRenderer.prototype.getFallbackStylingObjs = function (eventDef) {
        return [eventDef.source];
    };
    EventRenderer.prototype.sortEventSegs = function (segs) {
        segs.sort(util_1.proxy(this, 'compareEventSegs'));
    };
    // A cmp function for determining which segments should take visual priority
    EventRenderer.prototype.compareEventSegs = function (seg1, seg2) {
        var f1 = seg1.footprint;
        var f2 = seg2.footprint;
        var cf1 = f1.componentFootprint;
        var cf2 = f2.componentFootprint;
        var r1 = cf1.unzonedRange;
        var r2 = cf2.unzonedRange;
        return r1.startMs - r2.startMs || // earlier events go first
            (r2.endMs - r2.startMs) - (r1.endMs - r1.startMs) || // tie? longer events go first
            cf2.isAllDay - cf1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
            util_1.compareByFieldSpecs(f1.eventDef, f2.eventDef, this.view.eventOrderSpecs, f1.eventDef.miscProps, f2.eventDef.miscProps);
    };
    return EventRenderer;
}());
exports.default = EventRenderer;


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment_ext_1 = __webpack_require__(10);
// Plugin
// -------------------------------------------------------------------------------------------------
moment_ext_1.newMomentProto.format = function () {
    if (this._fullCalendar && arguments[0]) {
        return formatDate(this, arguments[0]); // our extended formatting
    }
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) {
        // moment.format() doesn't ensure english, but we want to.
        return moment_ext_1.oldMomentFormat(englishMoment(this));
    }
    return moment_ext_1.oldMomentProto.format.apply(this, arguments);
};
moment_ext_1.newMomentProto.toISOString = function () {
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) {
        // depending on browser, moment might not output english. ensure english.
        // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
        return moment_ext_1.oldMomentProto.toISOString.apply(englishMoment(this), arguments);
    }
    return moment_ext_1.oldMomentProto.toISOString.apply(this, arguments);
};
function englishMoment(mom) {
    if (mom.locale() !== 'en') {
        return mom.clone().locale('en');
    }
    return mom;
}
// Config
// ---------------------------------------------------------------------------------------------------------------------
/*
Inserted between chunks in the fake ("intermediate") formatting string.
Important that it passes as whitespace (\s) because moment often identifies non-standalone months
via a regexp with an \s.
*/
var PART_SEPARATOR = '\u000b'; // vertical tab
/*
Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
but rather, a "special" token that has custom rendering (see specialTokens map).
*/
var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1
/*
Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
Handling of these markers is done in a post-processing step at the very end of text rendering.
*/
var MAYBE_MARKER = '\u001e'; // information separator 2
var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global
/*
Addition formatting tokens we want recognized
*/
var specialTokens = {
    t: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'a').charAt(0);
    },
    T: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'A').charAt(0);
    }
};
/*
The first characters of formatting tokens for units that are 1 day or larger.
`value` is for ranking relative size (lower means bigger).
`unit` is a normalized unit, used for comparing moments.
*/
var largeTokenMap = {
    Y: { value: 1, unit: 'year' },
    M: { value: 2, unit: 'month' },
    W: { value: 3, unit: 'week' },
    w: { value: 3, unit: 'week' },
    D: { value: 4, unit: 'day' },
    d: { value: 4, unit: 'day' } // day of week
};
// Single Date Formatting
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
*/
function formatDate(date, formatStr) {
    return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
}
exports.formatDate = formatDate;
// Date Range Formatting
// -------------------------------------------------------------------------------------------------
// TODO: make it work with timezone offset
/*
Using a formatting string meant for a single date, generate a range string, like
"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
If the dates are the same as far as the format string is concerned, just return a single
rendering of one date, without any separator.
*/
function formatRange(date1, date2, formatStr, separator, isRTL) {
    var localeData;
    date1 = moment_ext_1.default.parseZone(date1);
    date2 = moment_ext_1.default.parseZone(date2);
    localeData = date1.localeData();
    // Expand localized format strings, like "LL" -> "MMMM D YYYY".
    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
    // or non-zero areas in Moment's localized format strings.
    formatStr = localeData.longDateFormat(formatStr) || formatStr;
    return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || ' - ', isRTL);
}
exports.formatRange = formatRange;
/*
Renders a range with an already-parsed format string.
*/
function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
    var sameUnits = parsedFormat.sameUnits;
    var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
    var unzonedDate2 = date2.clone().stripZone(); // "
    var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
    var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
    var leftI;
    var leftStr = '';
    var rightI;
    var rightStr = '';
    var middleI;
    var middleStr1 = '';
    var middleStr2 = '';
    var middleStr = '';
    // Start at the leftmost side of the formatting string and continue until you hit a token
    // that is not the same between dates.
    for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
        leftStr += renderedParts1[leftI];
    }
    // Similarly, start at the rightmost side of the formatting string and move left
    for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
        // If current chunk is on the boundary of unique date-content, and is a special-case
        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
        // TODO: make configurable
        if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
            break;
        }
        rightStr = renderedParts1[rightI] + rightStr;
    }
    // The area in the middle is different for both of the dates.
    // Collect them distinctly so we can jam them together later.
    for (middleI = leftI; middleI <= rightI; middleI++) {
        middleStr1 += renderedParts1[middleI];
        middleStr2 += renderedParts2[middleI];
    }
    if (middleStr1 || middleStr2) {
        if (isRTL) {
            middleStr = middleStr2 + separator + middleStr1;
        }
        else {
            middleStr = middleStr1 + separator + middleStr2;
        }
    }
    return processMaybeMarkers(leftStr + middleStr + rightStr);
}
// Format String Parsing
// ---------------------------------------------------------------------------------------------------------------------
var parsedFormatStrCache = {};
/*
Returns a parsed format string, leveraging a cache.
*/
function getParsedFormatString(formatStr) {
    return parsedFormatStrCache[formatStr] ||
        (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
}
/*
Parses a format string into the following:
- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
  that indicates how similar a range's start & end must be in order to share the same formatted text.
  If not a token, then the value is null.
  Always a flat array (not nested liked "chunks").
*/
function parseFormatString(formatStr) {
    var chunks = chunkFormatString(formatStr);
    return {
        fakeFormatString: buildFakeFormatString(chunks),
        sameUnits: buildSameUnits(chunks)
    };
}
/*
Break the formatting string into an array of chunks.
A 'maybe' chunk will have nested chunks.
*/
function chunkFormatString(formatStr) {
    var chunks = [];
    var match;
    // TODO: more descrimination
    // \4 is a backreference to the first character of a multi-character set.
    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;
    while ((match = chunker.exec(formatStr))) {
        if (match[1]) {
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[1]));
        }
        else if (match[2]) {
            chunks.push({ maybe: chunkFormatString(match[2]) });
        }
        else if (match[3]) {
            chunks.push({ token: match[3] });
        }
        else if (match[5]) {
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[5]));
        }
    }
    return chunks;
}
/*
Potentially splits a literal-text string into multiple parts. For special cases.
*/
function splitStringLiteral(s) {
    if (s === '. ') {
        return ['.', ' ']; // for locales with periods bound to the end of each year/month/date
    }
    else {
        return [s];
    }
}
/*
Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
characters that will eventually be given to moment for formatting, and then post-processed.
*/
function buildFakeFormatString(chunks) {
    var parts = [];
    var i;
    var chunk;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (typeof chunk === 'string') {
            parts.push('[' + chunk + ']');
        }
        else if (chunk.token) {
            if (chunk.token in specialTokens) {
                parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
                    '[' + chunk.token + ']' // preserve as literal text
                );
            }
            else {
                parts.push(chunk.token); // unprotected text implies a format string
            }
        }
        else if (chunk.maybe) {
            parts.push(MAYBE_MARKER + // useful during post-processing
                buildFakeFormatString(chunk.maybe) +
                MAYBE_MARKER);
        }
    }
    return parts.join(PART_SEPARATOR);
}
/*
Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
in which regard two dates must be similar in order to share range formatting text.
The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
*/
function buildSameUnits(chunks) {
    var units = [];
    var i;
    var chunk;
    var tokenInfo;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            tokenInfo = largeTokenMap[chunk.token.charAt(0)];
            units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
        }
        else if (chunk.maybe) {
            units.push.apply(units, // append
            buildSameUnits(chunk.maybe));
        }
        else {
            units.push(null);
        }
    }
    return units;
}
// Rendering to text
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats a date with a fake format string, post-processes the control characters, then returns.
*/
function renderFakeFormatString(fakeFormatString, date) {
    return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(''));
}
/*
Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
*/
function renderFakeFormatStringParts(fakeFormatString, date) {
    var parts = [];
    var fakeRender = moment_ext_1.oldMomentFormat(date, fakeFormatString);
    var fakeParts = fakeRender.split(PART_SEPARATOR);
    var i;
    var fakePart;
    for (i = 0; i < fakeParts.length; i++) {
        fakePart = fakeParts[i];
        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
            parts.push(
            // the literal string IS the token's name.
            // call special token's registered function.
            specialTokens[fakePart.substring(1)](date));
        }
        else {
            parts.push(fakePart);
        }
    }
    return parts;
}
/*
Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
*/
function processMaybeMarkers(s) {
    return s.replace(MAYBE_REGEXP, function (m0, m1) {
        if (m1.match(/[1-9]/)) {
            return m1;
        }
        else {
            return '';
        }
    });
}
// Misc Utils
// -------------------------------------------------------------------------------------------------
/*
Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
*/
function queryMostGranularFormatUnit(formatStr) {
    var chunks = chunkFormatString(formatStr);
    var i;
    var chunk;
    var candidate;
    var best;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            candidate = largeTokenMap[chunk.token.charAt(0)];
            if (candidate) {
                if (!best || candidate.value > best.value) {
                    best = candidate;
                }
            }
        }
    }
    if (best) {
        return best.unit;
    }
    return null;
}
exports.queryMostGranularFormatUnit = queryMostGranularFormatUnit;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Class_1 = __webpack_require__(32);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var Model = /** @class */ (function (_super) {
    tslib_1.__extends(Model, _super);
    function Model() {
        var _this = _super.call(this) || this;
        _this._watchers = {};
        _this._props = {};
        _this.applyGlobalWatchers();
        _this.constructed();
        return _this;
    }
    Model.watch = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // subclasses should make a masked-copy of the superclass's map
        // TODO: write test
        if (!this.prototype.hasOwnProperty('_globalWatchArgs')) {
            this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
        }
        this.prototype._globalWatchArgs[name] = args;
    };
    Model.prototype.constructed = function () {
        // useful for monkeypatching. TODO: BaseClass?
    };
    Model.prototype.applyGlobalWatchers = function () {
        var map = this._globalWatchArgs;
        var name;
        for (name in map) {
            this.watch.apply(this, [name].concat(map[name]));
        }
    };
    Model.prototype.has = function (name) {
        return name in this._props;
    };
    Model.prototype.get = function (name) {
        if (name === undefined) {
            return this._props;
        }
        return this._props[name];
    };
    Model.prototype.set = function (name, val) {
        var newProps;
        if (typeof name === 'string') {
            newProps = {};
            newProps[name] = val === undefined ? null : val;
        }
        else {
            newProps = name;
        }
        this.setProps(newProps);
    };
    Model.prototype.reset = function (newProps) {
        var oldProps = this._props;
        var changeset = {}; // will have undefined's to signal unsets
        var name;
        for (name in oldProps) {
            changeset[name] = undefined;
        }
        for (name in newProps) {
            changeset[name] = newProps[name];
        }
        this.setProps(changeset);
    };
    Model.prototype.unset = function (name) {
        var newProps = {};
        var names;
        var i;
        if (typeof name === 'string') {
            names = [name];
        }
        else {
            names = name;
        }
        for (i = 0; i < names.length; i++) {
            newProps[names[i]] = undefined;
        }
        this.setProps(newProps);
    };
    Model.prototype.setProps = function (newProps) {
        var changedProps = {};
        var changedCnt = 0;
        var name;
        var val;
        for (name in newProps) {
            val = newProps[name];
            // a change in value?
            // if an object, don't check equality, because might have been mutated internally.
            // TODO: eventually enforce immutability.
            if (typeof val === 'object' ||
                val !== this._props[name]) {
                changedProps[name] = val;
                changedCnt++;
            }
        }
        if (changedCnt) {
            this.trigger('before:batchChange', changedProps);
            for (name in changedProps) {
                val = changedProps[name];
                this.trigger('before:change', name, val);
                this.trigger('before:change:' + name, val);
            }
            for (name in changedProps) {
                val = changedProps[name];
                if (val === undefined) {
                    delete this._props[name];
                }
                else {
                    this._props[name] = val;
                }
                this.trigger('change:' + name, val);
                this.trigger('change', name, val);
            }
            this.trigger('batchChange', changedProps);
        }
    };
    Model.prototype.watch = function (name, depList, startFunc, stopFunc) {
        var _this = this;
        this.unwatch(name);
        this._watchers[name] = this._watchDeps(depList, function (deps) {
            var res = startFunc.call(_this, deps);
            if (res && res.then) {
                _this.unset(name); // put in an unset state while resolving
                res.then(function (val) {
                    _this.set(name, val);
                });
            }
            else {
                _this.set(name, res);
            }
        }, function (deps) {
            _this.unset(name);
            if (stopFunc) {
                stopFunc.call(_this, deps);
            }
        });
    };
    Model.prototype.unwatch = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            delete this._watchers[name];
            watcher.teardown();
        }
    };
    Model.prototype._watchDeps = function (depList, startFunc, stopFunc) {
        var _this = this;
        var queuedChangeCnt = 0;
        var depCnt = depList.length;
        var satisfyCnt = 0;
        var values = {}; // what's passed as the `deps` arguments
        var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
        var isCallingStop = false;
        var onBeforeDepChange = function (depName, val, isOptional) {
            queuedChangeCnt++;
            if (queuedChangeCnt === 1) {
                if (satisfyCnt === depCnt) {
                    isCallingStop = true;
                    stopFunc(values);
                    isCallingStop = false;
                }
            }
        };
        var onDepChange = function (depName, val, isOptional) {
            if (val === undefined) {
                // required dependency that was previously set?
                if (!isOptional && values[depName] !== undefined) {
                    satisfyCnt--;
                }
                delete values[depName];
            }
            else {
                // required dependency that was previously unset?
                if (!isOptional && values[depName] === undefined) {
                    satisfyCnt++;
                }
                values[depName] = val;
            }
            queuedChangeCnt--;
            if (!queuedChangeCnt) {
                // now finally satisfied or satisfied all along?
                if (satisfyCnt === depCnt) {
                    // if the stopFunc initiated another value change, ignore it.
                    // it will be processed by another change event anyway.
                    if (!isCallingStop) {
                        startFunc(values);
                    }
                }
            }
        };
        // intercept for .on() that remembers handlers
        var bind = function (eventName, handler) {
            _this.on(eventName, handler);
            bindTuples.push([eventName, handler]);
        };
        // listen to dependency changes
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') {
                depName = depName.substring(1);
                isOptional = true;
            }
            bind('before:change:' + depName, function (val) {
                onBeforeDepChange(depName, val, isOptional);
            });
            bind('change:' + depName, function (val) {
                onDepChange(depName, val, isOptional);
            });
        });
        // process current dependency values
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') {
                depName = depName.substring(1);
                isOptional = true;
            }
            if (_this.has(depName)) {
                values[depName] = _this.get(depName);
                satisfyCnt++;
            }
            else if (isOptional) {
                satisfyCnt++;
            }
        });
        // initially satisfied
        if (satisfyCnt === depCnt) {
            startFunc(values);
        }
        return {
            teardown: function () {
                // remove all handlers
                for (var i = 0; i < bindTuples.length; i++) {
                    _this.off(bindTuples[i][0], bindTuples[i][1]);
                }
                bindTuples = null;
                // was satisfied, so call stopFunc
                if (satisfyCnt === depCnt) {
                    stopFunc();
                }
            },
            flash: function () {
                if (satisfyCnt === depCnt) {
                    stopFunc();
                    startFunc(values);
                }
            }
        };
    };
    Model.prototype.flash = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            watcher.flash();
        }
    };
    return Model;
}(Class_1.default));
exports.default = Model;
Model.prototype._globalWatchArgs = {}; // mutation protection in Model.watch
EmitterMixin_1.default.mixInto(Model);
ListenerMixin_1.default.mixInto(Model);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var SingleEventDef_1 = __webpack_require__(13);
var RecurringEventDef_1 = __webpack_require__(210);
exports.default = {
    parse: function (eventInput, source) {
        if (util_1.isTimeString(eventInput.start) || moment.isDuration(eventInput.start) ||
            util_1.isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
            return RecurringEventDef_1.default.parse(eventInput, source);
        }
        else {
            return SingleEventDef_1.default.parse(eventInput, source);
        }
    }
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
var EventDateProfile_1 = __webpack_require__(17);
var EventDefDateMutation = /** @class */ (function () {
    function EventDefDateMutation() {
        this.clearEnd = false;
        this.forceTimed = false;
        this.forceAllDay = false;
    }
    EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
        var clearEnd = dateProfile0.end && !dateProfile1.end;
        var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
        var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
        var dateDelta;
        var endDiff;
        var endDelta;
        var mutation;
        // subtracts the dates in the appropriate way, returning a duration
        function subtractDates(date1, date0) {
            if (largeUnit) {
                return util_1.diffByUnit(date1, date0, largeUnit); // poorly named
            }
            else if (dateProfile1.isAllDay()) {
                return util_1.diffDay(date1, date0); // poorly named
            }
            else {
                return util_1.diffDayTime(date1, date0); // poorly named
            }
        }
        dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);
        if (dateProfile1.end) {
            // use unzonedRanges because dateProfile0.end might be null
            endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
            endDelta = endDiff.subtract(dateDelta);
        }
        mutation = new EventDefDateMutation();
        mutation.clearEnd = clearEnd;
        mutation.forceTimed = forceTimed;
        mutation.forceAllDay = forceAllDay;
        mutation.setDateDelta(dateDelta);
        mutation.setEndDelta(endDelta);
        return mutation;
    };
    /*
    returns an undo function.
    */
    EventDefDateMutation.prototype.buildNewDateProfile = function (eventDateProfile, calendar) {
        var start = eventDateProfile.start.clone();
        var end = null;
        var shouldRezone = false;
        if (eventDateProfile.end && !this.clearEnd) {
            end = eventDateProfile.end.clone();
        }
        else if (this.endDelta && !end) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        if (this.forceTimed) {
            shouldRezone = true;
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        else if (this.forceAllDay) {
            if (start.hasTime()) {
                start.stripTime();
            }
            if (end && end.hasTime()) {
                end.stripTime();
            }
        }
        if (this.dateDelta) {
            shouldRezone = true;
            start.add(this.dateDelta);
            if (end) {
                end.add(this.dateDelta);
            }
        }
        // do this before adding startDelta to start, so we can work off of start
        if (this.endDelta) {
            shouldRezone = true;
            end.add(this.endDelta);
        }
        if (this.startDelta) {
            shouldRezone = true;
            start.add(this.startDelta);
        }
        if (shouldRezone) {
            start = calendar.applyTimezone(start);
            if (end) {
                end = calendar.applyTimezone(end);
            }
        }
        // TODO: okay to access calendar option?
        if (!end && calendar.opt('forceEventDuration')) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        return new EventDateProfile_1.default(start, end, calendar);
    };
    EventDefDateMutation.prototype.setDateDelta = function (dateDelta) {
        if (dateDelta && dateDelta.valueOf()) {
            this.dateDelta = dateDelta;
        }
        else {
            this.dateDelta = null;
        }
    };
    EventDefDateMutation.prototype.setStartDelta = function (startDelta) {
        if (startDelta && startDelta.valueOf()) {
            this.startDelta = startDelta;
        }
        else {
            this.startDelta = null;
        }
    };
    EventDefDateMutation.prototype.setEndDelta = function (endDelta) {
        if (endDelta && endDelta.valueOf()) {
            this.endDelta = endDelta;
        }
        else {
            this.endDelta = null;
        }
    };
    EventDefDateMutation.prototype.isEmpty = function () {
        return !this.clearEnd && !this.forceTimed && !this.forceAllDay &&
            !this.dateDelta && !this.startDelta && !this.endDelta;
    };
    return EventDefDateMutation;
}());
exports.default = EventDefDateMutation;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var StandardTheme_1 = __webpack_require__(213);
var JqueryUiTheme_1 = __webpack_require__(214);
var themeClassHash = {};
function defineThemeSystem(themeName, themeClass) {
    themeClassHash[themeName] = themeClass;
}
exports.defineThemeSystem = defineThemeSystem;
function getThemeSystemClass(themeSetting) {
    if (!themeSetting) {
        return StandardTheme_1.default;
    }
    else if (themeSetting === true) {
        return JqueryUiTheme_1.default;
    }
    else {
        return themeClassHash[themeSetting];
    }
}
exports.getThemeSystemClass = getThemeSystemClass;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var SingleEventDef_1 = __webpack_require__(13);
var ArrayEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayEventSource, _super);
    function ArrayEventSource(calendar) {
        var _this = _super.call(this, calendar) || this;
        _this.eventDefs = []; // for if setRawEventDefs is never called
        return _this;
    }
    ArrayEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if ($.isArray(rawInput.events)) {
            rawProps = rawInput;
        }
        else if ($.isArray(rawInput)) {
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    ArrayEventSource.prototype.setRawEventDefs = function (rawEventDefs) {
        this.rawEventDefs = rawEventDefs;
        this.eventDefs = this.parseEventDefs(rawEventDefs);
    };
    ArrayEventSource.prototype.fetch = function (start, end, timezone) {
        var eventDefs = this.eventDefs;
        var i;
        if (this.currentTimezone != null &&
            this.currentTimezone !== timezone) {
            for (i = 0; i < eventDefs.length; i++) {
                if (eventDefs[i] instanceof SingleEventDef_1.default) {
                    eventDefs[i].rezone();
                }
            }
        }
        this.currentTimezone = timezone;
        return Promise_1.default.resolve(eventDefs);
    };
    ArrayEventSource.prototype.addEventDef = function (eventDef) {
        this.eventDefs.push(eventDef);
    };
    /*
    eventDefId already normalized to a string
    */
    ArrayEventSource.prototype.removeEventDefsById = function (eventDefId) {
        return util_1.removeMatching(this.eventDefs, function (eventDef) {
            return eventDef.id === eventDefId;
        });
    };
    ArrayEventSource.prototype.removeAllEventDefs = function () {
        this.eventDefs = [];
    };
    ArrayEventSource.prototype.getPrimitive = function () {
        return this.rawEventDefs;
    };
    ArrayEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.setRawEventDefs(rawProps.events);
        return superSuccess;
    };
    return ArrayEventSource;
}(EventSource_1.default));
exports.default = ArrayEventSource;
ArrayEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
/*
A cache for the left/right/top/bottom/width/height values for one or more elements.
Works with both offset (from topleft document) and position (from offsetParent).

options:
- els
- isHorizontal
- isVertical
*/
var CoordCache = /** @class */ (function () {
    function CoordCache(options) {
        this.isHorizontal = false; // whether to query for left/right/width
        this.isVertical = false; // whether to query for top/bottom/height
        this.els = $(options.els);
        this.isHorizontal = options.isHorizontal;
        this.isVertical = options.isVertical;
        this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
    }
    // Queries the els for coordinates and stores them.
    // Call this method before using and of the get* methods below.
    CoordCache.prototype.build = function () {
        var offsetParentEl = this.forcedOffsetParentEl;
        if (!offsetParentEl && this.els.length > 0) {
            offsetParentEl = this.els.eq(0).offsetParent();
        }
        this.origin = offsetParentEl ?
            offsetParentEl.offset() :
            null;
        this.boundingRect = this.queryBoundingRect();
        if (this.isHorizontal) {
            this.buildElHorizontals();
        }
        if (this.isVertical) {
            this.buildElVerticals();
        }
    };
    // Destroys all internal data about coordinates, freeing memory
    CoordCache.prototype.clear = function () {
        this.origin = null;
        this.boundingRect = null;
        this.lefts = null;
        this.rights = null;
        this.tops = null;
        this.bottoms = null;
    };
    // When called, if coord caches aren't built, builds them
    CoordCache.prototype.ensureBuilt = function () {
        if (!this.origin) {
            this.build();
        }
    };
    // Populates the left/right internal coordinate arrays
    CoordCache.prototype.buildElHorizontals = function () {
        var lefts = [];
        var rights = [];
        this.els.each(function (i, node) {
            var el = $(node);
            var left = el.offset().left;
            var width = el.outerWidth();
            lefts.push(left);
            rights.push(left + width);
        });
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    CoordCache.prototype.buildElVerticals = function () {
        var tops = [];
        var bottoms = [];
        this.els.each(function (i, node) {
            var el = $(node);
            var top = el.offset().top;
            var height = el.outerHeight();
            tops.push(top);
            bottoms.push(top + height);
        });
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getHorizontalIndex = function (leftOffset) {
        this.ensureBuilt();
        var lefts = this.lefts;
        var rights = this.rights;
        var len = lefts.length;
        var i;
        for (i = 0; i < len; i++) {
            if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
                return i;
            }
        }
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getVerticalIndex = function (topOffset) {
        this.ensureBuilt();
        var tops = this.tops;
        var bottoms = this.bottoms;
        var len = tops.length;
        var i;
        for (i = 0; i < len; i++) {
            if (topOffset >= tops[i] && topOffset < bottoms[i]) {
                return i;
            }
        }
    };
    // Gets the left offset (from document left) of the element at the given index
    CoordCache.prototype.getLeftOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex];
    };
    // Gets the left position (from offsetParent left) of the element at the given index
    CoordCache.prototype.getLeftPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex] - this.origin.left;
    };
    // Gets the right offset (from document left) of the element at the given index.
    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex];
    };
    // Gets the right position (from offsetParent left) of the element at the given index.
    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.origin.left;
    };
    // Gets the width of the element at the given index
    CoordCache.prototype.getWidth = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the top offset (from document top) of the element at the given index
    CoordCache.prototype.getTopOffset = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex];
    };
    // Gets the top position (from offsetParent top) of the element at the given position
    CoordCache.prototype.getTopPosition = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex] - this.origin.top;
    };
    // Gets the bottom offset (from the document top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomOffset = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex];
    };
    // Gets the bottom position (from the offsetParent top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomPosition = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.origin.top;
    };
    // Gets the height of the element at the given index
    CoordCache.prototype.getHeight = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    // Bounding Rect
    // TODO: decouple this from CoordCache
    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
    // Returns null if there are no elements
    CoordCache.prototype.queryBoundingRect = function () {
        var scrollParentEl;
        if (this.els.length > 0) {
            scrollParentEl = util_1.getScrollParent(this.els.eq(0));
            if (!scrollParentEl.is(document)) {
                return util_1.getClientRect(scrollParentEl);
            }
        }
        return null;
    };
    CoordCache.prototype.isPointInBounds = function (leftOffset, topOffset) {
        return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
    };
    CoordCache.prototype.isLeftInBounds = function (leftOffset) {
        return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
    };
    CoordCache.prototype.isTopInBounds = function (topOffset) {
        return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
    };
    return CoordCache;
}());
exports.default = CoordCache;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
var GlobalEmitter_1 = __webpack_require__(20);
/* Tracks a drag's mouse movement, firing various handlers
----------------------------------------------------------------------------------------------------------------------*/
// TODO: use Emitter
var DragListener = /** @class */ (function () {
    function DragListener(options) {
        this.isInteracting = false;
        this.isDistanceSurpassed = false;
        this.isDelayEnded = false;
        this.isDragging = false;
        this.isTouch = false;
        this.isGeneric = false; // initiated by 'dragstart' (jqui)
        this.shouldCancelTouchScroll = true;
        this.scrollAlwaysKills = false;
        this.isAutoScroll = false;
        // defaults
        this.scrollSensitivity = 30; // pixels from edge for scrolling to start
        this.scrollSpeed = 200; // pixels per second, at maximum speed
        this.scrollIntervalMs = 50; // millisecond wait between scroll increment
        this.options = options || {};
    }
    // Interaction (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startInteraction = function (ev, extraOptions) {
        if (extraOptions === void 0) { extraOptions = {}; }
        if (ev.type === 'mousedown') {
            if (GlobalEmitter_1.default.get().shouldIgnoreMouse()) {
                return;
            }
            else if (!util_1.isPrimaryMouseButton(ev)) {
                return;
            }
            else {
                ev.preventDefault(); // prevents native selection in most browsers
            }
        }
        if (!this.isInteracting) {
            // process options
            this.delay = util_1.firstDefined(extraOptions.delay, this.options.delay, 0);
            this.minDistance = util_1.firstDefined(extraOptions.distance, this.options.distance, 0);
            this.subjectEl = this.options.subjectEl;
            util_1.preventSelection($('body'));
            this.isInteracting = true;
            this.isTouch = util_1.getEvIsTouch(ev);
            this.isGeneric = ev.type === 'dragstart';
            this.isDelayEnded = false;
            this.isDistanceSurpassed = false;
            this.originX = util_1.getEvX(ev);
            this.originY = util_1.getEvY(ev);
            this.scrollEl = util_1.getScrollParent($(ev.target));
            this.bindHandlers();
            this.initAutoScroll();
            this.handleInteractionStart(ev);
            this.startDelay(ev);
            if (!this.minDistance) {
                this.handleDistanceSurpassed(ev);
            }
        }
    };
    DragListener.prototype.handleInteractionStart = function (ev) {
        this.trigger('interactionStart', ev);
    };
    DragListener.prototype.endInteraction = function (ev, isCancelled) {
        if (this.isInteracting) {
            this.endDrag(ev);
            if (this.delayTimeoutId) {
                clearTimeout(this.delayTimeoutId);
                this.delayTimeoutId = null;
            }
            this.destroyAutoScroll();
            this.unbindHandlers();
            this.isInteracting = false;
            this.handleInteractionEnd(ev, isCancelled);
            util_1.allowSelection($('body'));
        }
    };
    DragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        this.trigger('interactionEnd', ev, isCancelled || false);
    };
    // Binding To DOM
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.bindHandlers = function () {
        // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
        // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
        var globalEmitter = GlobalEmitter_1.default.get();
        if (this.isGeneric) {
            this.listenTo($(document), {
                drag: this.handleMove,
                dragstop: this.endInteraction
            });
        }
        else if (this.isTouch) {
            this.listenTo(globalEmitter, {
                touchmove: this.handleTouchMove,
                touchend: this.endInteraction,
                scroll: this.handleTouchScroll
            });
        }
        else {
            this.listenTo(globalEmitter, {
                mousemove: this.handleMouseMove,
                mouseup: this.endInteraction
            });
        }
        this.listenTo(globalEmitter, {
            selectstart: util_1.preventDefault,
            contextmenu: util_1.preventDefault // long taps would open menu on Chrome dev tools
        });
    };
    DragListener.prototype.unbindHandlers = function () {
        this.stopListeningTo(GlobalEmitter_1.default.get());
        this.stopListeningTo($(document)); // for isGeneric
    };
    // Drag (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    // extraOptions ignored if drag already started
    DragListener.prototype.startDrag = function (ev, extraOptions) {
        this.startInteraction(ev, extraOptions); // ensure interaction began
        if (!this.isDragging) {
            this.isDragging = true;
            this.handleDragStart(ev);
        }
    };
    DragListener.prototype.handleDragStart = function (ev) {
        this.trigger('dragStart', ev);
    };
    DragListener.prototype.handleMove = function (ev) {
        var dx = util_1.getEvX(ev) - this.originX;
        var dy = util_1.getEvY(ev) - this.originY;
        var minDistance = this.minDistance;
        var distanceSq; // current distance from the origin, squared
        if (!this.isDistanceSurpassed) {
            distanceSq = dx * dx + dy * dy;
            if (distanceSq >= minDistance * minDistance) {
                this.handleDistanceSurpassed(ev);
            }
        }
        if (this.isDragging) {
            this.handleDrag(dx, dy, ev);
        }
    };
    // Called while the mouse is being moved and when we know a legitimate drag is taking place
    DragListener.prototype.handleDrag = function (dx, dy, ev) {
        this.trigger('drag', dx, dy, ev);
        this.updateAutoScroll(ev); // will possibly cause scrolling
    };
    DragListener.prototype.endDrag = function (ev) {
        if (this.isDragging) {
            this.isDragging = false;
            this.handleDragEnd(ev);
        }
    };
    DragListener.prototype.handleDragEnd = function (ev) {
        this.trigger('dragEnd', ev);
    };
    // Delay
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startDelay = function (initialEv) {
        var _this = this;
        if (this.delay) {
            this.delayTimeoutId = setTimeout(function () {
                _this.handleDelayEnd(initialEv);
            }, this.delay);
        }
        else {
            this.handleDelayEnd(initialEv);
        }
    };
    DragListener.prototype.handleDelayEnd = function (initialEv) {
        this.isDelayEnded = true;
        if (this.isDistanceSurpassed) {
            this.startDrag(initialEv);
        }
    };
    // Distance
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleDistanceSurpassed = function (ev) {
        this.isDistanceSurpassed = true;
        if (this.isDelayEnded) {
            this.startDrag(ev);
        }
    };
    // Mouse / Touch
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchMove = function (ev) {
        // prevent inertia and touchmove-scrolling while dragging
        if (this.isDragging && this.shouldCancelTouchScroll) {
            ev.preventDefault();
        }
        this.handleMove(ev);
    };
    DragListener.prototype.handleMouseMove = function (ev) {
        this.handleMove(ev);
    };
    // Scrolling (unrelated to auto-scroll)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchScroll = function (ev) {
        // if the drag is being initiated by touch, but a scroll happens before
        // the drag-initiating delay is over, cancel the drag
        if (!this.isDragging || this.scrollAlwaysKills) {
            this.endInteraction(ev, true); // isCancelled=true
        }
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    DragListener.prototype.trigger = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.options[name]) {
            this.options[name].apply(this, args);
        }
        // makes _methods callable by event name. TODO: kill this
        if (this['_' + name]) {
            this['_' + name].apply(this, args);
        }
    };
    // Auto-scroll
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.initAutoScroll = function () {
        var scrollEl = this.scrollEl;
        this.isAutoScroll =
            this.options.scroll &&
                scrollEl &&
                !scrollEl.is(window) &&
                !scrollEl.is(document);
        if (this.isAutoScroll) {
            // debounce makes sure rapid calls don't happen
            this.listenTo(scrollEl, 'scroll', util_1.debounce(this.handleDebouncedScroll, 100));
        }
    };
    DragListener.prototype.destroyAutoScroll = function () {
        this.endAutoScroll(); // kill any animation loop
        // remove the scroll handler if there is a scrollEl
        if (this.isAutoScroll) {
            this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
        }
    };
    // Computes and stores the bounding rectangle of scrollEl
    DragListener.prototype.computeScrollBounds = function () {
        if (this.isAutoScroll) {
            this.scrollBounds = util_1.getOuterRect(this.scrollEl);
            // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
        }
    };
    // Called when the dragging is in progress and scrolling should be updated
    DragListener.prototype.updateAutoScroll = function (ev) {
        var sensitivity = this.scrollSensitivity;
        var bounds = this.scrollBounds;
        var topCloseness;
        var bottomCloseness;
        var leftCloseness;
        var rightCloseness;
        var topVel = 0;
        var leftVel = 0;
        if (bounds) {
            // compute closeness to edges. valid range is from 0.0 - 1.0
            topCloseness = (sensitivity - (util_1.getEvY(ev) - bounds.top)) / sensitivity;
            bottomCloseness = (sensitivity - (bounds.bottom - util_1.getEvY(ev))) / sensitivity;
            leftCloseness = (sensitivity - (util_1.getEvX(ev) - bounds.left)) / sensitivity;
            rightCloseness = (sensitivity - (bounds.right - util_1.getEvX(ev))) / sensitivity;
            // translate vertical closeness into velocity.
            // mouse must be completely in bounds for velocity to happen.
            if (topCloseness >= 0 && topCloseness <= 1) {
                topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
            }
            else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
                topVel = bottomCloseness * this.scrollSpeed;
            }
            // translate horizontal closeness into velocity
            if (leftCloseness >= 0 && leftCloseness <= 1) {
                leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
            }
            else if (rightCloseness >= 0 && rightCloseness <= 1) {
                leftVel = rightCloseness * this.scrollSpeed;
            }
        }
        this.setScrollVel(topVel, leftVel);
    };
    // Sets the speed-of-scrolling for the scrollEl
    DragListener.prototype.setScrollVel = function (topVel, leftVel) {
        this.scrollTopVel = topVel;
        this.scrollLeftVel = leftVel;
        this.constrainScrollVel(); // massages into realistic values
        // if there is non-zero velocity, and an animation loop hasn't already started, then START
        if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
            this.scrollIntervalId = setInterval(util_1.proxy(this, 'scrollIntervalFunc'), // scope to `this`
            this.scrollIntervalMs);
        }
    };
    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
    DragListener.prototype.constrainScrollVel = function () {
        var el = this.scrollEl;
        if (this.scrollTopVel < 0) {
            if (el.scrollTop() <= 0) {
                this.scrollTopVel = 0;
            }
        }
        else if (this.scrollTopVel > 0) {
            if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) {
                this.scrollTopVel = 0;
            }
        }
        if (this.scrollLeftVel < 0) {
            if (el.scrollLeft() <= 0) {
                this.scrollLeftVel = 0;
            }
        }
        else if (this.scrollLeftVel > 0) {
            if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) {
                this.scrollLeftVel = 0;
            }
        }
    };
    // This function gets called during every iteration of the scrolling animation loop
    DragListener.prototype.scrollIntervalFunc = function () {
        var el = this.scrollEl;
        var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
        // change the value of scrollEl's scroll
        if (this.scrollTopVel) {
            el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
        }
        if (this.scrollLeftVel) {
            el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
        }
        this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
        // if scrolled all the way, which causes the vels to be zero, stop the animation loop
        if (!this.scrollTopVel && !this.scrollLeftVel) {
            this.endAutoScroll();
        }
    };
    // Kills any existing scrolling animation loop
    DragListener.prototype.endAutoScroll = function () {
        if (this.scrollIntervalId) {
            clearInterval(this.scrollIntervalId);
            this.scrollIntervalId = null;
            this.handleScrollEnd();
        }
    };
    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
    DragListener.prototype.handleDebouncedScroll = function () {
        // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
        if (!this.scrollIntervalId) {
            this.handleScrollEnd();
        }
    };
    DragListener.prototype.handleScrollEnd = function () {
        // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    };
    return DragListener;
}());
exports.default = DragListener;
ListenerMixin_1.default.mixInto(DragListener);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var Mixin_1 = __webpack_require__(14);
/*
A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
Prerequisite: the object being mixed into needs to be a *Grid*
*/
var DayTableMixin = /** @class */ (function (_super) {
    tslib_1.__extends(DayTableMixin, _super);
    function DayTableMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Populates internal variables used for date calculation and rendering
    DayTableMixin.prototype.updateDayTable = function () {
        var t = this;
        var view = t.view;
        var calendar = view.calendar;
        var date = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.startMs, true);
        var end = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.endMs, true);
        var dayIndex = -1;
        var dayIndices = [];
        var dayDates = [];
        var daysPerRow;
        var firstDay;
        var rowCnt;
        while (date.isBefore(end)) {
            if (view.isHiddenDay(date)) {
                dayIndices.push(dayIndex + 0.5); // mark that it's between indices
            }
            else {
                dayIndex++;
                dayIndices.push(dayIndex);
                dayDates.push(date.clone());
            }
            date.add(1, 'days');
        }
        if (this.breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dayDates[0].day();
            for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
                if (dayDates[daysPerRow].day() === firstDay) {
                    break;
                }
            }
            rowCnt = Math.ceil(dayDates.length / daysPerRow);
        }
        else {
            rowCnt = 1;
            daysPerRow = dayDates.length;
        }
        this.dayDates = dayDates;
        this.dayIndices = dayIndices;
        this.daysPerRow = daysPerRow;
        this.rowCnt = rowCnt;
        this.updateDayTableCols();
    };
    // Computes and assigned the colCnt property and updates any options that may be computed from it
    DayTableMixin.prototype.updateDayTableCols = function () {
        this.colCnt = this.computeColCnt();
        this.colHeadFormat =
            this.opt('columnHeaderFormat') ||
                this.opt('columnFormat') || // deprecated
                this.computeColHeadFormat();
    };
    // Determines how many columns there should be in the table
    DayTableMixin.prototype.computeColCnt = function () {
        return this.daysPerRow;
    };
    // Computes the ambiguously-timed moment for the given cell
    DayTableMixin.prototype.getCellDate = function (row, col) {
        return this.dayDates[this.getCellDayIndex(row, col)].clone();
    };
    // Computes the ambiguously-timed date range for the given cell
    DayTableMixin.prototype.getCellRange = function (row, col) {
        var start = this.getCellDate(row, col);
        var end = start.clone().add(1, 'days');
        return { start: start, end: end };
    };
    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
    DayTableMixin.prototype.getCellDayIndex = function (row, col) {
        return row * this.daysPerRow + this.getColDayIndex(col);
    };
    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
    DayTableMixin.prototype.getColDayIndex = function (col) {
        if (this.isRTL) {
            return this.colCnt - 1 - col;
        }
        else {
            return col;
        }
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DayTableMixin.prototype.getDateDayIndex = function (date) {
        var dayIndices = this.dayIndices;
        var dayOffset = date.diff(this.dayDates[0], 'days');
        if (dayOffset < 0) {
            return dayIndices[0] - 1;
        }
        else if (dayOffset >= dayIndices.length) {
            return dayIndices[dayIndices.length - 1] + 1;
        }
        else {
            return dayIndices[dayOffset];
        }
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes a default column header formatting string if `colFormat` is not explicitly defined
    DayTableMixin.prototype.computeColHeadFormat = function () {
        // if more than one week row, or if there are a lot of columns with not much space,
        // put just the day numbers will be in each cell
        if (this.rowCnt > 1 || this.colCnt > 10) {
            return 'ddd'; // "Sat"
        }
        else if (this.colCnt > 1) {
            return this.opt('dayOfMonthFormat'); // "Sat 12/10"
        }
        else {
            return 'dddd'; // "Saturday"
        }
    };
    /* Slicing
    ------------------------------------------------------------------------------------------------------------------*/
    // Slices up a date range into a segment for every week-row it intersects with
    DayTableMixin.prototype.sliceRangeByRow = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            // intersect segment's offset range with the row's
            segFirst = Math.max(rangeFirst, rowFirst);
            segLast = Math.min(rangeLast, rowLast);
            // deal with in-between indices
            segFirst = Math.ceil(segFirst); // in-between starts round to next cell
            segLast = Math.floor(segLast); // in-between ends round to prev cell
            if (segFirst <= segLast) {
                segs.push({
                    row: row,
                    // normalize to start of row
                    firstRowDayIndex: segFirst - rowFirst,
                    lastRowDayIndex: segLast - rowFirst,
                    // must be matching integers to be the segment's start/end
                    isStart: segFirst === rangeFirst,
                    isEnd: segLast === rangeLast
                });
            }
        }
        return segs;
    };
    // Slices up a date range into a segment for every day-cell it intersects with.
    // TODO: make more DRY with sliceRangeByRow somehow.
    DayTableMixin.prototype.sliceRangeByDay = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var i;
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            for (i = rowFirst; i <= rowLast; i++) {
                // intersect segment's offset range with the row's
                segFirst = Math.max(rangeFirst, i);
                segLast = Math.min(rangeLast, i);
                // deal with in-between indices
                segFirst = Math.ceil(segFirst); // in-between starts round to next cell
                segLast = Math.floor(segLast); // in-between ends round to prev cell
                if (segFirst <= segLast) {
                    segs.push({
                        row: row,
                        // normalize to start of row
                        firstRowDayIndex: segFirst - rowFirst,
                        lastRowDayIndex: segLast - rowFirst,
                        // must be matching integers to be the segment's start/end
                        isStart: segFirst === rangeFirst,
                        isEnd: segLast === rangeLast
                    });
                }
            }
        }
        return segs;
    };
    /* Header Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderHeadHtml = function () {
        var theme = this.view.calendar.theme;
        return '' +
            '<div class="fc-row ' + theme.getClass('headerRow') + '">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            '<thead>' +
            this.renderHeadTrHtml() +
            '</thead>' +
            '</table>' +
            '</div>';
    };
    DayTableMixin.prototype.renderHeadIntroHtml = function () {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderHeadTrHtml = function () {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderHeadIntroHtml()) +
            this.renderHeadDateCellsHtml() +
            (this.isRTL ? this.renderHeadIntroHtml() : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderHeadDateCellsHtml = function () {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(0, col);
            htmls.push(this.renderHeadDateCellHtml(date));
        }
        return htmls.join('');
    };
    // TODO: when internalApiVersion, accept an object for HTML attributes
    // (colspan should be no different)
    DayTableMixin.prototype.renderHeadDateCellHtml = function (date, colspan, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classNames = [
            'fc-day-header',
            view.calendar.theme.getClass('widgetHeader')
        ];
        var innerHtml;
        if (typeof t.opt('columnHeaderHtml') === 'function') {
            innerHtml = t.opt('columnHeaderHtml')(date);
        }
        else if (typeof t.opt('columnHeaderText') === 'function') {
            innerHtml = util_1.htmlEscape(t.opt('columnHeaderText')(date));
        }
        else {
            innerHtml = util_1.htmlEscape(date.format(t.colHeadFormat));
        }
        // if only one row of days, the classNames on the header can represent the specific days beneath
        if (t.rowCnt === 1) {
            classNames = classNames.concat(
            // includes the day-of-week class
            // noThemeHighlight=true (don't highlight the header)
            t.getDayClasses(date, true));
        }
        else {
            classNames.push('fc-' + util_1.dayIDs[date.day()]); // only add the day-of-week class
        }
        return '' +
            '<th class="' + classNames.join(' ') + '"' +
            ((isDateValid && t.rowCnt) === 1 ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' :
                '') +
            (colspan > 1 ?
                ' colspan="' + colspan + '"' :
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '>' +
            (isDateValid ?
                // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
                view.buildGotoAnchorHtml({ date: date, forceOff: t.rowCnt > 1 || t.colCnt === 1 }, innerHtml) :
                // if not valid, display text, but no link
                innerHtml) +
            '</th>';
    };
    /* Background Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderBgTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
            this.renderBgCellsHtml(row) +
            (this.isRTL ? this.renderBgIntroHtml(row) : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderBgIntroHtml = function (row) {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderBgCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderBgCellHtml(date));
        }
        return htmls.join('');
    };
    DayTableMixin.prototype.renderBgCellHtml = function (date, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classes = t.getDayClasses(date);
        classes.unshift('fc-day', view.calendar.theme.getClass('widgetContent'));
        return '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '></td>';
    };
    /* Generic
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderIntroHtml = function () {
        // Generates the default HTML intro for any row. User classes should override
    };
    // TODO: a generic method for dealing with <tr>, RTL, intro
    // when increment internalApiVersion
    // wrapTr (scheduler)
    /* Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // Applies the generic "intro" and "outro" HTML to the given cells.
    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
    DayTableMixin.prototype.bookendCells = function (trEl) {
        var introHtml = this.renderIntroHtml();
        if (introHtml) {
            if (this.isRTL) {
                trEl.append(introHtml);
            }
            else {
                trEl.prepend(introHtml);
            }
        }
    };
    return DayTableMixin;
}(Mixin_1.default));
exports.default = DayTableMixin;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var BusinessHourRenderer = /** @class */ (function () {
    /*
    component implements:
      - eventRangesToEventFootprints
      - eventFootprintsToSegs
    */
    function BusinessHourRenderer(component, fillRenderer) {
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    BusinessHourRenderer.prototype.render = function (businessHourGenerator) {
        var component = this.component;
        var unzonedRange = component._getDateProfile().activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
        var eventFootprints = eventInstanceGroup ?
            component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) :
            [];
        this.renderEventFootprints(eventFootprints);
    };
    BusinessHourRenderer.prototype.renderEventFootprints = function (eventFootprints) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        this.renderSegs(segs);
        this.segs = segs;
    };
    BusinessHourRenderer.prototype.renderSegs = function (segs) {
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('businessHours', segs, {
                getClasses: function (seg) {
                    return ['fc-nonbusiness', 'fc-bgevent'];
                }
            });
        }
    };
    BusinessHourRenderer.prototype.unrender = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('businessHours');
        }
        this.segs = null;
    };
    BusinessHourRenderer.prototype.getSegs = function () {
        return this.segs || [];
    };
    return BusinessHourRenderer;
}());
exports.default = BusinessHourRenderer;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var FillRenderer = /** @class */ (function () {
    function FillRenderer(component) {
        this.fillSegTag = 'div';
        this.component = component;
        this.elsByFill = {};
    }
    FillRenderer.prototype.renderFootprint = function (type, componentFootprint, props) {
        this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
    };
    FillRenderer.prototype.renderSegs = function (type, segs, props) {
        var els;
        segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs
        els = this.attachSegEls(type, segs);
        if (els) {
            this.reportEls(type, els);
        }
        return segs;
    };
    // Unrenders a specific type of fill that is currently rendered on the grid
    FillRenderer.prototype.unrender = function (type) {
        var el = this.elsByFill[type];
        if (el) {
            el.remove();
            delete this.elsByFill[type];
        }
    };
    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
    // Only returns segments that successfully rendered.
    FillRenderer.prototype.buildSegEls = function (type, segs, props) {
        var _this = this;
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) {
            // build a large concatenation of segment HTML
            for (i = 0; i < segs.length; i++) {
                html += this.buildSegHtml(type, segs[i], props);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment.
            $(html).each(function (i, node) {
                var seg = segs[i];
                var el = $(node);
                // allow custom filter methods per-type
                if (props.filterEl) {
                    el = props.filterEl(seg, el);
                }
                if (el) {
                    el = $(el); // allow custom filter to return raw DOM node
                    // correct element type? (would be bad if a non-TD were inserted into a table for example)
                    if (el.is(_this.fillSegTag)) {
                        seg.el = el;
                        renderedSegs.push(seg);
                    }
                }
            });
        }
        return renderedSegs;
    };
    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
    FillRenderer.prototype.buildSegHtml = function (type, seg, props) {
        // custom hooks per-type
        var classes = props.getClasses ? props.getClasses(seg) : [];
        var css = util_1.cssToStr(props.getCss ? props.getCss(seg) : {});
        return '<' + this.fillSegTag +
            (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
            (css ? ' style="' + css + '"' : '') +
            ' />';
    };
    // Should return wrapping DOM structure
    FillRenderer.prototype.attachSegEls = function (type, segs) {
        // subclasses must implement
    };
    FillRenderer.prototype.reportEls = function (type, nodes) {
        if (this.elsByFill[type]) {
            this.elsByFill[type] = this.elsByFill[type].add(nodes);
        }
        else {
            this.elsByFill[type] = $(nodes);
        }
    };
    return FillRenderer;
}());
exports.default = FillRenderer;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var SingleEventDef_1 = __webpack_require__(13);
var EventFootprint_1 = __webpack_require__(35);
var EventSource_1 = __webpack_require__(6);
var HelperRenderer = /** @class */ (function () {
    function HelperRenderer(component, eventRenderer) {
        this.view = component._getView();
        this.component = component;
        this.eventRenderer = eventRenderer;
    }
    HelperRenderer.prototype.renderComponentFootprint = function (componentFootprint) {
        this.renderEventFootprints([
            this.fabricateEventFootprint(componentFootprint)
        ]);
    };
    HelperRenderer.prototype.renderEventDraggingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-dragging', isTouch ? null : this.view.opt('dragOpacity'));
    };
    HelperRenderer.prototype.renderEventResizingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-resizing');
    };
    HelperRenderer.prototype.renderEventFootprints = function (eventFootprints, sourceSeg, extraClassNames, opacity) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        var classNames = 'fc-helper ' + (extraClassNames || '');
        var i;
        // assigns each seg's el and returns a subset of segs that were rendered
        segs = this.eventRenderer.renderFgSegEls(segs);
        for (i = 0; i < segs.length; i++) {
            segs[i].el.addClass(classNames);
        }
        if (opacity != null) {
            for (i = 0; i < segs.length; i++) {
                segs[i].el.css('opacity', opacity);
            }
        }
        this.helperEls = this.renderSegs(segs, sourceSeg);
    };
    /*
    Must return all mock event elements
    */
    HelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        // Subclasses must implement
    };
    HelperRenderer.prototype.unrender = function () {
        if (this.helperEls) {
            this.helperEls.remove();
            this.helperEls = null;
        }
    };
    HelperRenderer.prototype.fabricateEventFootprint = function (componentFootprint) {
        var calendar = this.view.calendar;
        var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
        var dummyEvent = new SingleEventDef_1.default(new EventSource_1.default(calendar));
        var dummyInstance;
        dummyEvent.dateProfile = eventDateProfile;
        dummyInstance = dummyEvent.buildInstance();
        return new EventFootprint_1.default(componentFootprint, dummyEvent, dummyInstance);
    };
    return HelperRenderer;
}());
exports.default = HelperRenderer;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var GlobalEmitter_1 = __webpack_require__(20);
var Interaction_1 = __webpack_require__(15);
var EventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(EventPointing, _super);
    function EventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    component must implement:
      - publiclyTrigger
    */
    EventPointing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'click', this.handleClick.bind(this));
        component.bindSegHandlerToEl(el, 'mouseenter', this.handleMouseover.bind(this));
        component.bindSegHandlerToEl(el, 'mouseleave', this.handleMouseout.bind(this));
    };
    EventPointing.prototype.handleClick = function (seg, ev) {
        var res = this.component.publiclyTrigger('eventClick', {
            context: seg.el[0],
            args: [seg.footprint.getEventLegacy(), ev, this.view]
        });
        if (res === false) {
            ev.preventDefault();
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused over
    EventPointing.prototype.handleMouseover = function (seg, ev) {
        if (!GlobalEmitter_1.default.get().shouldIgnoreMouse() &&
            !this.mousedOverSeg) {
            this.mousedOverSeg = seg;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.addClass('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseover', {
                context: seg.el[0],
                args: [seg.footprint.getEventLegacy(), ev, this.view]
            });
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused out.
    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
    EventPointing.prototype.handleMouseout = function (seg, ev) {
        if (this.mousedOverSeg) {
            this.mousedOverSeg = null;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.removeClass('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseout', {
                context: seg.el[0],
                args: [
                    seg.footprint.getEventLegacy(),
                    ev || {},
                    this.view
                ]
            });
        }
    };
    EventPointing.prototype.end = function () {
        if (this.mousedOverSeg) {
            this.handleMouseout(this.mousedOverSeg);
        }
    };
    return EventPointing;
}(Interaction_1.default));
exports.default = EventPointing;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Mixin_1 = __webpack_require__(14);
var DateClicking_1 = __webpack_require__(245);
var DateSelecting_1 = __webpack_require__(225);
var EventPointing_1 = __webpack_require__(59);
var EventDragging_1 = __webpack_require__(224);
var EventResizing_1 = __webpack_require__(223);
var ExternalDropping_1 = __webpack_require__(222);
var StandardInteractionsMixin = /** @class */ (function (_super) {
    tslib_1.__extends(StandardInteractionsMixin, _super);
    function StandardInteractionsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardInteractionsMixin;
}(Mixin_1.default));
exports.default = StandardInteractionsMixin;
StandardInteractionsMixin.prototype.dateClickingClass = DateClicking_1.default;
StandardInteractionsMixin.prototype.dateSelectingClass = DateSelecting_1.default;
StandardInteractionsMixin.prototype.eventPointingClass = EventPointing_1.default;
StandardInteractionsMixin.prototype.eventDraggingClass = EventDragging_1.default;
StandardInteractionsMixin.prototype.eventResizingClass = EventResizing_1.default;
StandardInteractionsMixin.prototype.externalDroppingClass = ExternalDropping_1.default;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var CoordCache_1 = __webpack_require__(53);
var Popover_1 = __webpack_require__(249);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventFootprint_1 = __webpack_require__(35);
var BusinessHourRenderer_1 = __webpack_require__(56);
var StandardInteractionsMixin_1 = __webpack_require__(60);
var InteractiveDateComponent_1 = __webpack_require__(40);
var DayTableMixin_1 = __webpack_require__(55);
var DayGridEventRenderer_1 = __webpack_require__(250);
var DayGridHelperRenderer_1 = __webpack_require__(251);
var DayGridFillRenderer_1 = __webpack_require__(252);
/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
----------------------------------------------------------------------------------------------------------------------*/
var DayGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DayGrid, _super);
    function DayGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.cellWeekNumbersVisible = false; // display week numbers in day cell?
        _this.bottomCoordPadding = 0; // hack for extending the hit area for the last row of the coordinate grid
        // isRigid determines whether the individual rows should ignore the contents and be a constant height.
        // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
        _this.isRigid = false;
        _this.hasAllDayBusinessHours = true;
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    DayGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (this.isRTL) {
                seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
                seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
            }
            else {
                seg.leftCol = seg.firstRowDayIndex;
                seg.rightCol = seg.lastRowDayIndex;
            }
        }
        return segs;
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderGrid();
    };
    DayGrid.prototype.unrenderDates = function () {
        this.removeSegPopover();
    };
    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
    DayGrid.prototype.renderGrid = function () {
        var view = this.view;
        var rowCnt = this.rowCnt;
        var colCnt = this.colCnt;
        var html = '';
        var row;
        var col;
        if (this.headContainerEl) {
            this.headContainerEl.html(this.renderHeadHtml());
        }
        for (row = 0; row < rowCnt; row++) {
            html += this.renderDayRowHtml(row, this.isRigid);
        }
        this.el.html(html);
        this.rowEls = this.el.find('.fc-row');
        this.cellEls = this.el.find('.fc-day, .fc-disabled-day');
        this.rowCoordCache = new CoordCache_1.default({
            els: this.rowEls,
            isVertical: true
        });
        this.colCoordCache = new CoordCache_1.default({
            els: this.cellEls.slice(0, this.colCnt),
            isHorizontal: true
        });
        // trigger dayRender with each cell's element
        for (row = 0; row < rowCnt; row++) {
            for (col = 0; col < colCnt; col++) {
                this.publiclyTrigger('dayRender', {
                    context: view,
                    args: [
                        this.getCellDate(row, col),
                        this.getCellEl(row, col),
                        view
                    ]
                });
            }
        }
    };
    // Generates the HTML for a single row, which is a div that wraps a table.
    // `row` is the row number.
    DayGrid.prototype.renderDayRowHtml = function (row, isRigid) {
        var theme = this.view.calendar.theme;
        var classes = ['fc-row', 'fc-week', theme.getClass('dayRow')];
        if (isRigid) {
            classes.push('fc-rigid');
        }
        return '' +
            '<div class="' + classes.join(' ') + '">' +
            '<div class="fc-bg">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderBgTrHtml(row) +
            '</table>' +
            '</div>' +
            '<div class="fc-content-skeleton">' +
            '<table>' +
            (this.getIsNumbersVisible() ?
                '<thead>' +
                    this.renderNumberTrHtml(row) +
                    '</thead>' :
                '') +
            '</table>' +
            '</div>' +
            '</div>';
    };
    DayGrid.prototype.getIsNumbersVisible = function () {
        return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
    };
    DayGrid.prototype.getIsDayNumbersVisible = function () {
        return this.rowCnt > 1;
    };
    /* Grid Number Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderNumberTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
            this.renderNumberCellsHtml(row) +
            (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
            '</tr>';
    };
    DayGrid.prototype.renderNumberIntroHtml = function (row) {
        return this.renderIntroHtml();
    };
    DayGrid.prototype.renderNumberCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderNumberCellHtml(date));
        }
        return htmls.join('');
    };
    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
    // The number row will only exist if either day numbers or week numbers are turned on.
    DayGrid.prototype.renderNumberCellHtml = function (date) {
        var view = this.view;
        var html = '';
        var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
        var classes;
        var weekCalcFirstDoW;
        if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
            // no numbers in day cell (week number must be along the side)
            return '<td/>'; //  will create an empty space above events :(
        }
        classes = this.getDayClasses(date);
        classes.unshift('fc-day-top');
        if (this.cellWeekNumbersVisible) {
            // To determine the day of week number change under ISO, we cannot
            // rely on moment.js methods such as firstDayOfWeek() or weekday(),
            // because they rely on the locale's dow (possibly overridden by
            // our firstDay option), which may not be Monday. We cannot change
            // dow, because that would affect the calendar start day as well.
            if (date._locale._fullCalendar_weekCalc === 'ISO') {
                weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
            }
            else {
                weekCalcFirstDoW = date._locale.firstDayOfWeek();
            }
        }
        html += '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format() + '"' :
                '') +
            '>';
        if (this.cellWeekNumbersVisible && (date.day() === weekCalcFirstDoW)) {
            html += view.buildGotoAnchorHtml({ date: date, type: 'week' }, { 'class': 'fc-week-number' }, date.format('w') // inner HTML
            );
        }
        if (isDayNumberVisible) {
            html += view.buildGotoAnchorHtml(date, { 'class': 'fc-day-number' }, date.format('D') // inner HTML
            );
        }
        html += '</td>';
        return html;
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.rowCoordCache.build();
        this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
    };
    DayGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        this.rowCoordCache.clear();
    };
    DayGrid.prototype.queryHit = function (leftOffset, topOffset) {
        if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
            var col = this.colCoordCache.getHorizontalIndex(leftOffset);
            var row = this.rowCoordCache.getVerticalIndex(topOffset);
            if (row != null && col != null) {
                return this.getCellHit(row, col);
            }
        }
    };
    DayGrid.prototype.getHitFootprint = function (hit) {
        var range = this.getCellRange(hit.row, hit.col);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(range.start, range.end), true // all-day?
        );
    };
    DayGrid.prototype.getHitEl = function (hit) {
        return this.getCellEl(hit.row, hit.col);
    };
    /* Cell System
    ------------------------------------------------------------------------------------------------------------------*/
    // FYI: the first column is the leftmost column, regardless of date
    DayGrid.prototype.getCellHit = function (row, col) {
        return {
            row: row,
            col: col,
            component: this,
            left: this.colCoordCache.getLeftOffset(col),
            right: this.colCoordCache.getRightOffset(col),
            top: this.rowCoordCache.getTopOffset(row),
            bottom: this.rowCoordCache.getBottomOffset(row)
        };
    };
    DayGrid.prototype.getCellEl = function (row, col) {
        return this.cellEls.eq(row * this.colCnt + col);
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    // Unrenders all events currently rendered on the grid
    DayGrid.prototype.executeEventUnrender = function () {
        this.removeSegPopover(); // removes the "more.." events popover
        _super.prototype.executeEventUnrender.call(this);
    };
    // Retrieves all rendered segment objects currently rendered on the grid
    DayGrid.prototype.getOwnEventSegs = function () {
        // append the segments from the "more..." popover
        return _super.prototype.getOwnEventSegs.call(this).concat(this.popoverSegs || []);
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event or external element being dragged.
    // `eventLocation` has zoned start and end (optional)
    DayGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        // render drags from OTHER components as helpers
        if (eventFootprints.length && seg && seg.component !== this) {
            this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
            return true; // signal helpers rendered
        }
    };
    // Unrenders any visual indication of a hovering event
    DayGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    DayGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders a visual indication of an event being resized
    DayGrid.prototype.unrenderEventResize = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* More+ Link Popover
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.removeSegPopover = function () {
        if (this.segPopover) {
            this.segPopover.hide(); // in handler, will call segPopover's removeElement
        }
    };
    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
    DayGrid.prototype.limitRows = function (levelLimit) {
        var rowStructs = this.eventRenderer.rowStructs || [];
        var row; // row #
        var rowLevelLimit;
        for (row = 0; row < rowStructs.length; row++) {
            this.unlimitRow(row);
            if (!levelLimit) {
                rowLevelLimit = false;
            }
            else if (typeof levelLimit === 'number') {
                rowLevelLimit = levelLimit;
            }
            else {
                rowLevelLimit = this.computeRowLevelLimit(row);
            }
            if (rowLevelLimit !== false) {
                this.limitRow(row, rowLevelLimit);
            }
        }
    };
    // Computes the number of levels a row will accomodate without going outside its bounds.
    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
    // `row` is the row number.
    DayGrid.prototype.computeRowLevelLimit = function (row) {
        var rowEl = this.rowEls.eq(row); // the containing "fake" row div
        var rowHeight = rowEl.height(); // TODO: cache somehow?
        var trEls = this.eventRenderer.rowStructs[row].tbodyEl.children();
        var i;
        var trEl;
        var trHeight;
        function iterInnerHeights(i, childNode) {
            trHeight = Math.max(trHeight, $(childNode).outerHeight());
        }
        // Reveal one level <tr> at a time and stop when we find one out of bounds
        for (i = 0; i < trEls.length; i++) {
            trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
            // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
            // so instead, find the tallest inner content element.
            trHeight = 0;
            trEl.find('> td > :first-child').each(iterInnerHeights);
            if (trEl.position().top + trHeight > rowHeight) {
                return i;
            }
        }
        return false; // should not limit at all
    };
    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
    // `row` is the row number.
    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
    DayGrid.prototype.limitRow = function (row, levelLimit) {
        var _this = this;
        var rowStruct = this.eventRenderer.rowStructs[row];
        var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
        var col = 0; // col #, left-to-right (not chronologically)
        var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
        var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
        var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
        var i;
        var seg;
        var segsBelow; // array of segment objects below `seg` in the current `col`
        var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
        var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
        var td;
        var rowspan;
        var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
        var j;
        var moreTd;
        var moreWrap;
        var moreLink;
        // Iterates through empty level cells and places "more" links inside if need be
        var emptyCellsUntil = function (endCol) {
            while (col < endCol) {
                segsBelow = _this.getCellSegs(row, col, levelLimit);
                if (segsBelow.length) {
                    td = cellMatrix[levelLimit - 1][col];
                    moreLink = _this.renderMoreLink(row, col, segsBelow);
                    moreWrap = $('<div/>').append(moreLink);
                    td.append(moreWrap);
                    moreNodes.push(moreWrap[0]);
                }
                col++;
            }
        };
        if (levelLimit && levelLimit < rowStruct.segLevels.length) {
            levelSegs = rowStruct.segLevels[levelLimit - 1];
            cellMatrix = rowStruct.cellMatrix;
            limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
                .addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
            // iterate though segments in the last allowable level
            for (i = 0; i < levelSegs.length; i++) {
                seg = levelSegs[i];
                emptyCellsUntil(seg.leftCol); // process empty cells before the segment
                // determine *all* segments below `seg` that occupy the same columns
                colSegsBelow = [];
                totalSegsBelow = 0;
                while (col <= seg.rightCol) {
                    segsBelow = this.getCellSegs(row, col, levelLimit);
                    colSegsBelow.push(segsBelow);
                    totalSegsBelow += segsBelow.length;
                    col++;
                }
                if (totalSegsBelow) {
                    td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
                    rowspan = td.attr('rowspan') || 1;
                    segMoreNodes = [];
                    // make a replacement <td> for each column the segment occupies. will be one for each colspan
                    for (j = 0; j < colSegsBelow.length; j++) {
                        moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
                        segsBelow = colSegsBelow[j];
                        moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
                        );
                        moreWrap = $('<div/>').append(moreLink);
                        moreTd.append(moreWrap);
                        segMoreNodes.push(moreTd[0]);
                        moreNodes.push(moreTd[0]);
                    }
                    td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
                    limitedNodes.push(td[0]);
                }
            }
            emptyCellsUntil(this.colCnt); // finish off the level
            rowStruct.moreEls = $(moreNodes); // for easy undoing later
            rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
        }
    };
    // Reveals all levels and removes all "more"-related elements for a grid's row.
    // `row` is a row number.
    DayGrid.prototype.unlimitRow = function (row) {
        var rowStruct = this.eventRenderer.rowStructs[row];
        if (rowStruct.moreEls) {
            rowStruct.moreEls.remove();
            rowStruct.moreEls = null;
        }
        if (rowStruct.limitedEls) {
            rowStruct.limitedEls.removeClass('fc-limited');
            rowStruct.limitedEls = null;
        }
    };
    // Renders an <a> element that represents hidden event element for a cell.
    // Responsible for attaching click handler as well.
    DayGrid.prototype.renderMoreLink = function (row, col, hiddenSegs) {
        var _this = this;
        var view = this.view;
        return $('<a class="fc-more"/>')
            .text(this.getMoreLinkText(hiddenSegs.length))
            .on('click', function (ev) {
            var clickOption = _this.opt('eventLimitClick');
            var date = _this.getCellDate(row, col);
            var moreEl = $(ev.currentTarget);
            var dayEl = _this.getCellEl(row, col);
            var allSegs = _this.getCellSegs(row, col);
            // rescope the segments to be within the cell's date
            var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
            var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
            if (typeof clickOption === 'function') {
                // the returned value can be an atomic option
                clickOption = _this.publiclyTrigger('eventLimitClick', {
                    context: view,
                    args: [
                        {
                            date: date.clone(),
                            dayEl: dayEl,
                            moreEl: moreEl,
                            segs: reslicedAllSegs,
                            hiddenSegs: reslicedHiddenSegs
                        },
                        ev,
                        view
                    ]
                });
            }
            if (clickOption === 'popover') {
                _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
            }
            else if (typeof clickOption === 'string') {
                view.calendar.zoomTo(date, clickOption);
            }
        });
    };
    // Reveals the popover that displays all events within a cell
    DayGrid.prototype.showSegPopover = function (row, col, moreLink, segs) {
        var _this = this;
        var view = this.view;
        var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
        var topEl; // the element we want to match the top coordinate of
        var options;
        if (this.rowCnt === 1) {
            topEl = view.el; // will cause the popover to cover any sort of header
        }
        else {
            topEl = this.rowEls.eq(row); // will align with top of row
        }
        options = {
            className: 'fc-more-popover ' + view.calendar.theme.getClass('popover'),
            content: this.renderSegPopoverContent(row, col, segs),
            parentEl: view.el,
            top: topEl.offset().top,
            autoHide: true,
            viewportConstrain: this.opt('popoverViewportConstrain'),
            hide: function () {
                // kill everything when the popover is hidden
                // notify events to be removed
                if (_this.popoverSegs) {
                    _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
                }
                _this.segPopover.removeElement();
                _this.segPopover = null;
                _this.popoverSegs = null;
            }
        };
        // Determine horizontal coordinate.
        // We use the moreWrap instead of the <td> to avoid border confusion.
        if (this.isRTL) {
            options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
        }
        else {
            options.left = moreWrap.offset().left - 1; // -1 to be over cell border
        }
        this.segPopover = new Popover_1.default(options);
        this.segPopover.show();
        // the popover doesn't live within the grid's container element, and thus won't get the event
        // delegated-handlers for free. attach event-related handlers to the popover.
        this.bindAllSegHandlersToEl(this.segPopover.el);
        this.triggerAfterEventSegsRendered(segs);
    };
    // Builds the inner DOM contents of the segment popover
    DayGrid.prototype.renderSegPopoverContent = function (row, col, segs) {
        var view = this.view;
        var theme = view.calendar.theme;
        var title = this.getCellDate(row, col).format(this.opt('dayPopoverFormat'));
        var content = $('<div class="fc-header ' + theme.getClass('popoverHeader') + '">' +
            '<span class="fc-close ' + theme.getIconClass('close') + '"></span>' +
            '<span class="fc-title">' +
            util_1.htmlEscape(title) +
            '</span>' +
            '<div class="fc-clear"/>' +
            '</div>' +
            '<div class="fc-body ' + theme.getClass('popoverContent') + '">' +
            '<div class="fc-event-container"></div>' +
            '</div>');
        var segContainer = content.find('.fc-event-container');
        var i;
        // render each seg's `el` and only return the visible segs
        segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true
        this.popoverSegs = segs;
        for (i = 0; i < segs.length; i++) {
            // because segments in the popover are not part of a grid coordinate system, provide a hint to any
            // grids that want to do drag-n-drop about which cell it came from
            this.hitsNeeded();
            segs[i].hit = this.getCellHit(row, col);
            this.hitsNotNeeded();
            segContainer.append(segs[i].el);
        }
        return content;
    };
    // Given the events within an array of segment objects, reslice them to be in a single day
    DayGrid.prototype.resliceDaySegs = function (segs, dayDate) {
        var dayStart = dayDate.clone();
        var dayEnd = dayStart.clone().add(1, 'days');
        var dayRange = new UnzonedRange_1.default(dayStart, dayEnd);
        var newSegs = [];
        var i;
        var seg;
        var slicedRange;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);
            if (slicedRange) {
                newSegs.push($.extend({}, seg, {
                    footprint: new EventFootprint_1.default(new ComponentFootprint_1.default(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
                    isStart: seg.isStart && slicedRange.isStart,
                    isEnd: seg.isEnd && slicedRange.isEnd
                }));
            }
        }
        // force an order because eventsToSegs doesn't guarantee one
        // TODO: research if still needed
        this.eventRenderer.sortEventSegs(newSegs);
        return newSegs;
    };
    // Generates the text that should be inside a "more" link, given the number of events it represents
    DayGrid.prototype.getMoreLinkText = function (num) {
        var opt = this.opt('eventLimitText');
        if (typeof opt === 'function') {
            return opt(num);
        }
        else {
            return '+' + num + ' ' + opt;
        }
    };
    // Returns segments within a given cell.
    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
    DayGrid.prototype.getCellSegs = function (row, col, startLevel) {
        var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
        var level = startLevel || 0;
        var segs = [];
        var seg;
        while (level < segMatrix.length) {
            seg = segMatrix[level][col];
            if (seg) {
                segs.push(seg);
            }
            level++;
        }
        return segs;
    };
    return DayGrid;
}(InteractiveDateComponent_1.default));
exports.default = DayGrid;
DayGrid.prototype.eventRendererClass = DayGridEventRenderer_1.default;
DayGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
DayGrid.prototype.helperRendererClass = DayGridHelperRenderer_1.default;
DayGrid.prototype.fillRendererClass = DayGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(DayGrid);
DayTableMixin_1.default.mixInto(DayGrid);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(39);
var View_1 = __webpack_require__(41);
var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
var DayGrid_1 = __webpack_require__(61);
/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var BasicView = /** @class */ (function (_super) {
    tslib_1.__extends(BasicView, _super);
    function BasicView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.dayGrid = _this.instantiateDayGrid();
        _this.dayGrid.isRigid = _this.hasRigidRows();
        if (_this.opt('weekNumbers')) {
            if (_this.opt('weekNumbersWithinDays')) {
                _this.dayGrid.cellWeekNumbersVisible = true;
                _this.dayGrid.colWeekNumbersVisible = false;
            }
            else {
                _this.dayGrid.cellWeekNumbersVisible = false;
                _this.dayGrid.colWeekNumbersVisible = true;
            }
        }
        _this.addChild(_this.dayGrid);
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
    BasicView.prototype.instantiateDayGrid = function () {
        // generate a subclass on the fly with BasicView-specific behavior
        // TODO: cache this subclass
        var subclass = makeDayGridSubclass(this.dayGridClass);
        return new subclass(this);
    };
    BasicView.prototype.executeDateRender = function (dateProfile) {
        this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
        _super.prototype.executeDateRender.call(this, dateProfile);
    };
    BasicView.prototype.renderSkeleton = function () {
        var dayGridContainerEl;
        var dayGridEl;
        this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
        this.scroller.render();
        dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
        dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
        this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
        this.dayGrid.headContainerEl = this.el.find('.fc-head-container');
        this.dayGrid.setElement(dayGridEl);
    };
    BasicView.prototype.unrenderSkeleton = function () {
        this.dayGrid.removeElement();
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid component will render inside of a container defined by this HTML.
    BasicView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '"></td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the week number column, if it is known
    BasicView.prototype.weekNumberStyleAttr = function () {
        if (this.weekNumberWidth != null) {
            return 'style="width:' + this.weekNumberWidth + 'px"';
        }
        return '';
    };
    // Determines whether each row should have a constant height
    BasicView.prototype.hasRigidRows = function () {
        var eventLimit = this.opt('eventLimit');
        return eventLimit && typeof eventLimit !== 'number';
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Refreshes the horizontal dimensions of the view
    BasicView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var eventLimit = this.opt('eventLimit');
        var headRowEl = this.dayGrid.headContainerEl.find('.fc-row');
        var scrollerHeight;
        var scrollbarWidths;
        // hack to give the view some height prior to dayGrid's columns being rendered
        // TODO: separate setting height from scroller VS dayGrid.
        if (!this.dayGrid.rowEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        if (this.dayGrid.colWeekNumbersVisible) {
            // Make sure all week number cells running down the side have the same width.
            // Record the width for cells created later.
            this.weekNumberWidth = util_1.matchCellWidths(this.el.find('.fc-week-number'));
        }
        // reset all heights to be natural
        this.scroller.clear();
        util_1.uncompensateScroll(headRowEl);
        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
        // is the event limit a constant level number?
        if (eventLimit && typeof eventLimit === 'number') {
            this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
        }
        // distribute the height to the rows
        // (totalHeight is a "recommended" value if isAuto)
        scrollerHeight = this.computeScrollerHeight(totalHeight);
        this.setGridHeight(scrollerHeight, isAuto);
        // is the event limit dynamically calculated?
        if (eventLimit && typeof eventLimit !== 'number') {
            this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
        }
        if (!isAuto) {
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) {
                util_1.compensateScroll(headRowEl, scrollbarWidths);
                // doing the scrollbar compensation might have created text overflow which created more height. redo
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    BasicView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    // Sets the height of just the DayGrid component in this view
    BasicView.prototype.setGridHeight = function (height, isAuto) {
        if (isAuto) {
            util_1.undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
        }
        else {
            util_1.distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
        }
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    BasicView.prototype.computeInitialDateScroll = function () {
        return { top: 0 };
    };
    BasicView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    BasicView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    return BasicView;
}(View_1.default));
exports.default = BasicView;
BasicView.prototype.dateProfileGeneratorClass = BasicViewDateProfileGenerator_1.default;
BasicView.prototype.dayGridClass = DayGrid_1.default;
// customize the rendering behavior of BasicView's dayGrid
function makeDayGridSubclass(SuperClass) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(SubClass, _super);
        function SubClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.colWeekNumbersVisible = false; // display week numbers along the side?
            return _this;
        }
        // Generates the HTML that will go before the day-of week header cells
        SubClass.prototype.renderHeadIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '' +
                    '<th class="fc-week-number ' + view.calendar.theme.getClass('widgetHeader') + '" ' + view.weekNumberStyleAttr() + '>' +
                    '<span>' + // needed for matchCellWidths
                    util_1.htmlEscape(this.opt('weekNumberTitle')) +
                    '</span>' +
                    '</th>';
            }
            return '';
        };
        // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
        SubClass.prototype.renderNumberIntroHtml = function (row) {
            var view = this.view;
            var weekStart = this.getCellDate(row, 0);
            if (this.colWeekNumbersVisible) {
                return '' +
                    '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
                    view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                    { date: weekStart, type: 'week', forceOff: this.colCnt === 1 }, weekStart.format('w') // inner HTML
                    ) +
                    '</td>';
            }
            return '';
        };
        // Generates the HTML that goes before the day bg cells for each day-row
        SubClass.prototype.renderBgIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '<td class="fc-week-number ' + view.calendar.theme.getClass('widgetContent') + '" ' +
                    view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        // Generates the HTML that goes before every other type of row generated by DayGrid.
        // Affects helper-skeleton and highlight-skeleton rows.
        SubClass.prototype.renderIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        SubClass.prototype.getIsNumbersVisible = function () {
            return DayGrid_1.default.prototype.getIsNumbersVisible.apply(this, arguments) || this.colWeekNumbersVisible;
        };
        return SubClass;
    }(SuperClass));
}


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventDefParser_1 = __webpack_require__(49);
var EventSource_1 = __webpack_require__(6);
var util_1 = __webpack_require__(34);
var Constraints = /** @class */ (function () {
    function Constraints(eventManager, _calendar) {
        this.eventManager = eventManager;
        this._calendar = _calendar;
    }
    Constraints.prototype.opt = function (name) {
        return this._calendar.opt(name);
    };
    /*
    determines if eventInstanceGroup is allowed,
    in relation to other EVENTS and business hours.
    */
    Constraints.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var eventDef = eventInstanceGroup.getEventDef();
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        var peerEventInstances = this.getPeerEventInstances(eventDef);
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var constraintVal = eventDef.getConstraint();
        var overlapVal = eventDef.getOverlap();
        var eventAllowFunc = this.opt('eventAllow');
        for (i = 0; i < eventFootprints.length; i++) {
            if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
                return false;
            }
        }
        if (eventAllowFunc) {
            for (i = 0; i < eventFootprints.length; i++) {
                if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this._calendar), eventFootprints[i].getEventLegacy()) === false) {
                    return false;
                }
            }
        }
        return true;
    };
    Constraints.prototype.getPeerEventInstances = function (eventDef) {
        return this.eventManager.getEventInstancesWithoutId(eventDef.id);
    };
    Constraints.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        var peerEventInstances = this.eventManager.getEventInstances();
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var selectAllowFunc;
        if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt('selectConstraint'), this.opt('selectOverlap'))) {
            selectAllowFunc = this.opt('selectAllow');
            if (selectAllowFunc) {
                return selectAllowFunc(componentFootprint.toLegacy(this._calendar)) !== false;
            }
            else {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
    ) {
        var constraintFootprints; // ComponentFootprint[]
        var overlapEventFootprints; // EventFootprint[]
        if (constraintVal != null) {
            constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);
            if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
                return false;
            }
        }
        overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);
        if (overlapVal === false) {
            if (overlapEventFootprints.length) {
                return false;
            }
        }
        else if (typeof overlapVal === 'function') {
            if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
                return false;
            }
        }
        if (subjectEventInstance) {
            if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
                return false;
            }
        }
        return true;
    };
    // Constraint
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
        var i;
        for (i = 0; i < constraintFootprints.length; i++) {
            if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
        var eventInstances;
        if (constraintVal === 'businessHours') {
            return this.buildCurrentBusinessFootprints(isAllDay);
        }
        else if (typeof constraintVal === 'object') {
            eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events
            if (!eventInstances) {
                return this.parseFootprints(constraintVal);
            }
            else {
                return this.eventInstancesToFootprints(eventInstances);
            }
        }
        else if (constraintVal != null) {
            eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
            return this.eventInstancesToFootprints(eventInstances);
        }
    };
    // returns ComponentFootprint[]
    // uses current view's range
    Constraints.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
        var view = this._calendar.view;
        var businessHourGenerator = view.get('businessHourGenerator');
        var unzonedRange = view.dateProfile.activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);
        if (eventInstanceGroup) {
            return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
        }
        else {
            return [];
        }
    };
    // conversion util
    Constraints.prototype.eventInstancesToFootprints = function (eventInstances) {
        var eventRanges = eventInstances.map(util_1.eventInstanceToEventRange);
        var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
        return eventFootprints.map(util_1.eventFootprintToComponentFootprint);
    };
    // Overlap
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
        var overlapEventFootprints = [];
        var i;
        for (i = 0; i < peerEventFootprints.length; i++) {
            if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
                overlapEventFootprints.push(peerEventFootprints[i]);
            }
        }
        return overlapEventFootprints;
    };
    // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
    // ------------------------------------------------------------------------------------------------
    // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
    // constraints whereas the Grid code is related to rendering. Each approach might want to convert
    // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
    // this more DRY.
    /*
    Returns false on invalid input.
    */
    Constraints.prototype.parseEventDefToInstances = function (eventInput) {
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, new EventSource_1.default(this._calendar));
        if (!eventDef) {
            return false;
        }
        return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
    };
    Constraints.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var i;
        var eventFootprints = [];
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// footprints
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    Constraints.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_1.eventRangeToEventFootprint(eventRange)];
    };
    /*
    Parses footprints directly.
    Very similar to EventDateProfile::parse :(
    */
    Constraints.prototype.parseFootprints = function (rawInput) {
        var start;
        var end;
        if (rawInput.start) {
            start = this._calendar.moment(rawInput.start);
            if (!start.isValid()) {
                start = null;
            }
        }
        if (rawInput.end) {
            end = this._calendar.moment(rawInput.end);
            if (!end.isValid()) {
                end = null;
            }
        }
        return [
            new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), (start && !start.hasTime()) || (end && !end.hasTime()) // isAllDay
            )
        ];
    };
    // Footprint Utils
    // ----------------------------------------------------------------------------------------
    Constraints.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
        return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
    };
    Constraints.prototype.footprintsIntersect = function (footprint0, footprint1) {
        return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
    };
    return Constraints;
}());
exports.default = Constraints;
// optional subjectEventInstance
function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
    var i;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
            return false;
        }
    }
    return true;
}
function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
    var subjectLegacyInstance = subjectEventInstance.toLegacy();
    var i;
    var overlapEventInstance;
    var overlapEventDef;
    var overlapVal;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        overlapEventInstance = overlapEventFootprints[i].eventInstance;
        overlapEventDef = overlapEventInstance.def;
        // don't need to pass in calendar, because don't want to consider global eventOverlap property,
        // because we already considered that earlier in the process.
        overlapVal = overlapEventDef.getOverlap();
        if (overlapVal === false) {
            return false;
        }
        else if (typeof overlapVal === 'function') {
            if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as ParsableModelMixin, ParsableModelInterface } from './ParsableModelMixin'
in class:
  applyProps: ParsableModelInterface['applyProps']
  applyManualStandardProps: ParsableModelInterface['applyManualStandardProps']
  applyMiscProps: ParsableModelInterface['applyMiscProps']
  isStandardProp: ParsableModelInterface['isStandardProp']
  static defineStandardProps = ParsableModelMixin.defineStandardProps
  static copyVerbatimStandardProps = ParsableModelMixin.copyVerbatimStandardProps
after class:
  ParsableModelMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var Mixin_1 = __webpack_require__(14);
var ParsableModelMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ParsableModelMixin, _super);
    function ParsableModelMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParsableModelMixin.defineStandardProps = function (propDefs) {
        var proto = this.prototype;
        if (!proto.hasOwnProperty('standardPropMap')) {
            proto.standardPropMap = Object.create(proto.standardPropMap);
        }
        util_1.copyOwnProps(propDefs, proto.standardPropMap);
    };
    ParsableModelMixin.copyVerbatimStandardProps = function (src, dest) {
        var map = this.prototype.standardPropMap;
        var propName;
        for (propName in map) {
            if (src[propName] != null && // in the src object?
                map[propName] === true // false means "copy verbatim"
            ) {
                dest[propName] = src[propName];
            }
        }
    };
    /*
    Returns true/false for success.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyProps = function (rawProps) {
        var standardPropMap = this.standardPropMap;
        var manualProps = {};
        var miscProps = {};
        var propName;
        for (propName in rawProps) {
            if (standardPropMap[propName] === true) {
                this[propName] = rawProps[propName];
            }
            else if (standardPropMap[propName] === false) {
                manualProps[propName] = rawProps[propName];
            }
            else {
                miscProps[propName] = rawProps[propName];
            }
        }
        this.applyMiscProps(miscProps);
        return this.applyManualStandardProps(manualProps);
    };
    /*
    If subclasses override, they must call this supermethod and return the boolean response.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyManualStandardProps = function (rawProps) {
        return true;
    };
    /*
    Can be called even after initial object creation.
    */
    ParsableModelMixin.prototype.applyMiscProps = function (rawProps) {
        // subclasses can implement
    };
    /*
    TODO: why is this a method when defineStandardProps is static
    */
    ParsableModelMixin.prototype.isStandardProp = function (propName) {
        return propName in this.standardPropMap;
    };
    return ParsableModelMixin;
}(Mixin_1.default));
exports.default = ParsableModelMixin;
ParsableModelMixin.prototype.standardPropMap = {}; // will be cloned by defineStandardProps


/***/ }),
/* 209 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventInstance = /** @class */ (function () {
    function EventInstance(def, dateProfile) {
        this.def = def;
        this.dateProfile = dateProfile;
    }
    EventInstance.prototype.toLegacy = function () {
        var dateProfile = this.dateProfile;
        var obj = this.def.toLegacy();
        obj.start = dateProfile.start.clone();
        obj.end = dateProfile.end ? dateProfile.end.clone() : null;
        return obj;
    };
    return EventInstance;
}());
exports.default = EventInstance;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var EventDef_1 = __webpack_require__(33);
var EventInstance_1 = __webpack_require__(209);
var EventDateProfile_1 = __webpack_require__(17);
var RecurringEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(RecurringEventDef, _super);
    function RecurringEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecurringEventDef.prototype.isAllDay = function () {
        return !this.startTime && !this.endTime;
    };
    RecurringEventDef.prototype.buildInstances = function (unzonedRange) {
        var calendar = this.source.calendar;
        var unzonedDate = unzonedRange.getStart();
        var unzonedEnd = unzonedRange.getEnd();
        var zonedDayStart;
        var instanceStart;
        var instanceEnd;
        var instances = [];
        while (unzonedDate.isBefore(unzonedEnd)) {
            // if everyday, or this particular day-of-week
            if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
                zonedDayStart = calendar.applyTimezone(unzonedDate);
                instanceStart = zonedDayStart.clone();
                instanceEnd = null;
                if (this.startTime) {
                    instanceStart.time(this.startTime);
                }
                else {
                    instanceStart.stripTime();
                }
                if (this.endTime) {
                    instanceEnd = zonedDayStart.clone().time(this.endTime);
                }
                instances.push(new EventInstance_1.default(this, // definition
                new EventDateProfile_1.default(instanceStart, instanceEnd, calendar)));
            }
            unzonedDate.add(1, 'days');
        }
        return instances;
    };
    RecurringEventDef.prototype.setDow = function (dowNumbers) {
        if (!this.dowHash) {
            this.dowHash = {};
        }
        for (var i = 0; i < dowNumbers.length; i++) {
            this.dowHash[dowNumbers[i]] = true;
        }
    };
    RecurringEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        if (def.startTime) {
            def.startTime = moment.duration(this.startTime);
        }
        if (def.endTime) {
            def.endTime = moment.duration(this.endTime);
        }
        if (this.dowHash) {
            def.dowHash = $.extend({}, this.dowHash);
        }
        return def;
    };
    return RecurringEventDef;
}(EventDef_1.default));
exports.default = RecurringEventDef;
/*
HACK to work with TypeScript mixins
NOTE: if super-method fails, should still attempt to apply
*/
RecurringEventDef.prototype.applyProps = function (rawProps) {
    var superSuccess = EventDef_1.default.prototype.applyProps.call(this, rawProps);
    if (rawProps.start) {
        this.startTime = moment.duration(rawProps.start);
    }
    if (rawProps.end) {
        this.endTime = moment.duration(rawProps.end);
    }
    if (rawProps.dow) {
        this.setDow(rawProps.dow);
    }
    return superSuccess;
};
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
RecurringEventDef.defineStandardProps({
    start: false,
    end: false,
    dow: false
});


/***/ }),
/* 211 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange = /** @class */ (function () {
    function EventRange(unzonedRange, eventDef, eventInstance) {
        this.unzonedRange = unzonedRange;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    return EventRange;
}());
exports.default = EventRange;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(34);
var EventInstanceGroup_1 = __webpack_require__(18);
var RecurringEventDef_1 = __webpack_require__(210);
var EventSource_1 = __webpack_require__(6);
var BUSINESS_HOUR_EVENT_DEFAULTS = {
    start: '09:00',
    end: '17:00',
    dow: [1, 2, 3, 4, 5],
    rendering: 'inverse-background'
    // classNames are defined in businessHoursSegClasses
};
var BusinessHourGenerator = /** @class */ (function () {
    function BusinessHourGenerator(rawComplexDef, calendar) {
        this.rawComplexDef = rawComplexDef;
        this.calendar = calendar;
    }
    BusinessHourGenerator.prototype.buildEventInstanceGroup = function (isAllDay, unzonedRange) {
        var eventDefs = this.buildEventDefs(isAllDay);
        var eventInstanceGroup;
        if (eventDefs.length) {
            eventInstanceGroup = new EventInstanceGroup_1.default(util_1.eventDefsToEventInstances(eventDefs, unzonedRange));
            // so that inverse-background rendering can happen even when no eventRanges in view
            eventInstanceGroup.explicitEventDef = eventDefs[0];
            return eventInstanceGroup;
        }
    };
    BusinessHourGenerator.prototype.buildEventDefs = function (isAllDay) {
        var rawComplexDef = this.rawComplexDef;
        var rawDefs = [];
        var requireDow = false;
        var i;
        var defs = [];
        if (rawComplexDef === true) {
            rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
        }
        else if ($.isPlainObject(rawComplexDef)) {
            rawDefs = [rawComplexDef];
        }
        else if ($.isArray(rawComplexDef)) {
            rawDefs = rawComplexDef;
            requireDow = true; // every sub-definition NEEDS a day-of-week
        }
        for (i = 0; i < rawDefs.length; i++) {
            if (!requireDow || rawDefs[i].dow) {
                defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
            }
        }
        return defs;
    };
    BusinessHourGenerator.prototype.buildEventDef = function (isAllDay, rawDef) {
        var fullRawDef = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);
        if (isAllDay) {
            fullRawDef.start = null;
            fullRawDef.end = null;
        }
        return RecurringEventDef_1.default.parse(fullRawDef, new EventSource_1.default(this.calendar) // dummy source
        );
    };
    return BusinessHourGenerator;
}());
exports.default = BusinessHourGenerator;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var StandardTheme = /** @class */ (function (_super) {
    tslib_1.__extends(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme_1.default));
exports.default = StandardTheme;
StandardTheme.prototype.classes = {
    widget: 'fc-unthemed',
    widgetHeader: 'fc-widget-header',
    widgetContent: 'fc-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'fc-button',
    cornerLeft: 'fc-corner-left',
    cornerRight: 'fc-corner-right',
    stateDefault: 'fc-state-default',
    stateActive: 'fc-state-active',
    stateDisabled: 'fc-state-disabled',
    stateHover: 'fc-state-hover',
    stateDown: 'fc-state-down',
    popoverHeader: 'fc-widget-header',
    popoverContent: 'fc-widget-content',
    // day grid
    headerRow: 'fc-widget-header',
    dayRow: 'fc-widget-content',
    // list view
    listView: 'fc-widget-content'
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-left-single-arrow',
    next: 'fc-icon-right-single-arrow',
    prevYear: 'fc-icon-left-double-arrow',
    nextYear: 'fc-icon-right-double-arrow'
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var JqueryUiTheme = /** @class */ (function (_super) {
    tslib_1.__extends(JqueryUiTheme, _super);
    function JqueryUiTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JqueryUiTheme;
}(Theme_1.default));
exports.default = JqueryUiTheme;
JqueryUiTheme.prototype.classes = {
    widget: 'ui-widget',
    widgetHeader: 'ui-widget-header',
    widgetContent: 'ui-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'ui-button',
    cornerLeft: 'ui-corner-left',
    cornerRight: 'ui-corner-right',
    stateDefault: 'ui-state-default',
    stateActive: 'ui-state-active',
    stateDisabled: 'ui-state-disabled',
    stateHover: 'ui-state-hover',
    stateDown: 'ui-state-down',
    today: 'ui-state-highlight',
    popoverHeader: 'ui-widget-header',
    popoverContent: 'ui-widget-content',
    // day grid
    headerRow: 'ui-widget-header',
    dayRow: 'ui-widget-content',
    // list view
    listView: 'ui-widget-content'
};
JqueryUiTheme.prototype.baseIconClass = 'ui-icon';
JqueryUiTheme.prototype.iconClasses = {
    close: 'ui-icon-closethick',
    prev: 'ui-icon-circle-triangle-w',
    next: 'ui-icon-circle-triangle-e',
    prevYear: 'ui-icon-seek-prev',
    nextYear: 'ui-icon-seek-next'
};
JqueryUiTheme.prototype.iconOverrideOption = 'themeButtonIcons';
JqueryUiTheme.prototype.iconOverrideCustomButtonOption = 'themeIcon';
JqueryUiTheme.prototype.iconOverridePrefix = 'ui-icon-';


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var FuncEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(FuncEventSource, _super);
    function FuncEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FuncEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if ($.isFunction(rawInput.events)) {
            rawProps = rawInput;
        }
        else if ($.isFunction(rawInput)) {
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    FuncEventSource.prototype.fetch = function (start, end, timezone) {
        var _this = this;
        this.calendar.pushLoading();
        return Promise_1.default.construct(function (onResolve) {
            _this.func.call(_this.calendar, start.clone(), end.clone(), timezone, function (rawEventDefs) {
                _this.calendar.popLoading();
                onResolve(_this.parseEventDefs(rawEventDefs));
            });
        });
    };
    FuncEventSource.prototype.getPrimitive = function () {
        return this.func;
    };
    FuncEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.func = rawProps.events;
        return superSuccess;
    };
    return FuncEventSource;
}(EventSource_1.default));
exports.default = FuncEventSource;
FuncEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var JsonFeedEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(JsonFeedEventSource, _super);
    function JsonFeedEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonFeedEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if (typeof rawInput.url === 'string') {
            rawProps = rawInput;
        }
        else if (typeof rawInput === 'string') {
            rawProps = { url: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    JsonFeedEventSource.prototype.fetch = function (start, end, timezone) {
        var _this = this;
        var ajaxSettings = this.ajaxSettings;
        var onSuccess = ajaxSettings.success;
        var onError = ajaxSettings.error;
        var requestParams = this.buildRequestParams(start, end, timezone);
        // todo: eventually handle the promise's then,
        // don't intercept success/error
        // tho will be a breaking API change
        this.calendar.pushLoading();
        return Promise_1.default.construct(function (onResolve, onReject) {
            $.ajax($.extend({}, // destination
            JsonFeedEventSource.AJAX_DEFAULTS, ajaxSettings, {
                url: _this.url,
                data: requestParams,
                success: function (rawEventDefs, status, xhr) {
                    var callbackRes;
                    _this.calendar.popLoading();
                    if (rawEventDefs) {
                        callbackRes = util_1.applyAll(onSuccess, _this, [rawEventDefs, status, xhr]); // redirect `this`
                        if ($.isArray(callbackRes)) {
                            rawEventDefs = callbackRes;
                        }
                        onResolve(_this.parseEventDefs(rawEventDefs));
                    }
                    else {
                        onReject();
                    }
                },
                error: function (xhr, statusText, errorThrown) {
                    _this.calendar.popLoading();
                    util_1.applyAll(onError, _this, [xhr, statusText, errorThrown]); // redirect `this`
                    onReject();
                }
            }));
        });
    };
    JsonFeedEventSource.prototype.buildRequestParams = function (start, end, timezone) {
        var calendar = this.calendar;
        var ajaxSettings = this.ajaxSettings;
        var startParam;
        var endParam;
        var timezoneParam;
        var customRequestParams;
        var params = {};
        startParam = this.startParam;
        if (startParam == null) {
            startParam = calendar.opt('startParam');
        }
        endParam = this.endParam;
        if (endParam == null) {
            endParam = calendar.opt('endParam');
        }
        timezoneParam = this.timezoneParam;
        if (timezoneParam == null) {
            timezoneParam = calendar.opt('timezoneParam');
        }
        // retrieve any outbound GET/POST $.ajax data from the options
        if ($.isFunction(ajaxSettings.data)) {
            // supplied as a function that returns a key/value object
            customRequestParams = ajaxSettings.data();
        }
        else {
            // probably supplied as a straight key/value object
            customRequestParams = ajaxSettings.data || {};
        }
        $.extend(params, customRequestParams);
        params[startParam] = start.format();
        params[endParam] = end.format();
        if (timezone && timezone !== 'local') {
            params[timezoneParam] = timezone;
        }
        return params;
    };
    JsonFeedEventSource.prototype.getPrimitive = function () {
        return this.url;
    };
    JsonFeedEventSource.prototype.applyMiscProps = function (rawProps) {
        this.ajaxSettings = rawProps;
    };
    JsonFeedEventSource.AJAX_DEFAULTS = {
        dataType: 'json',
        cache: false
    };
    return JsonFeedEventSource;
}(EventSource_1.default));
exports.default = JsonFeedEventSource;
JsonFeedEventSource.defineStandardProps({
    // automatically transfer (true)...
    url: true,
    startParam: true,
    endParam: true,
    timezoneParam: true
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EmitterMixin_1 = __webpack_require__(11);
var TaskQueue = /** @class */ (function () {
    function TaskQueue() {
        this.q = [];
        this.isPaused = false;
        this.isRunning = false;
    }
    TaskQueue.prototype.queue = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.q.push.apply(this.q, args); // append
        this.tryStart();
    };
    TaskQueue.prototype.pause = function () {
        this.isPaused = true;
    };
    TaskQueue.prototype.resume = function () {
        this.isPaused = false;
        this.tryStart();
    };
    TaskQueue.prototype.getIsIdle = function () {
        return !this.isRunning && !this.isPaused;
    };
    TaskQueue.prototype.tryStart = function () {
        if (!this.isRunning && this.canRunNext()) {
            this.isRunning = true;
            this.trigger('start');
            this.runRemaining();
        }
    };
    TaskQueue.prototype.canRunNext = function () {
        return !this.isPaused && this.q.length;
    };
    TaskQueue.prototype.runRemaining = function () {
        var _this = this;
        var task;
        var res;
        do {
            task = this.q.shift(); // always freshly reference q. might have been reassigned.
            res = this.runTask(task);
            if (res && res.then) {
                res.then(function () {
                    if (_this.canRunNext()) {
                        _this.runRemaining();
                    }
                });
                return; // prevent marking as stopped
            }
        } while (this.canRunNext());
        this.trigger('stop'); // not really a 'stop' ... more of a 'drained'
        this.isRunning = false;
        // if 'stop' handler added more tasks.... TODO: write test for this
        this.tryStart();
    };
    TaskQueue.prototype.runTask = function (task) {
        return task(); // task *is* the function, but subclasses can change the format of a task
    };
    return TaskQueue;
}());
exports.default = TaskQueue;
EmitterMixin_1.default.mixInto(TaskQueue);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var TaskQueue_1 = __webpack_require__(217);
var RenderQueue = /** @class */ (function (_super) {
    tslib_1.__extends(RenderQueue, _super);
    function RenderQueue(waitsByNamespace) {
        var _this = _super.call(this) || this;
        _this.waitsByNamespace = waitsByNamespace || {};
        return _this;
    }
    RenderQueue.prototype.queue = function (taskFunc, namespace, type) {
        var task = {
            func: taskFunc,
            namespace: namespace,
            type: type
        };
        var waitMs;
        if (namespace) {
            waitMs = this.waitsByNamespace[namespace];
        }
        if (this.waitNamespace) {
            if (namespace === this.waitNamespace && waitMs != null) {
                this.delayWait(waitMs);
            }
            else {
                this.clearWait();
                this.tryStart();
            }
        }
        if (this.compoundTask(task)) {
            if (!this.waitNamespace && waitMs != null) {
                this.startWait(namespace, waitMs);
            }
            else {
                this.tryStart();
            }
        }
    };
    RenderQueue.prototype.startWait = function (namespace, waitMs) {
        this.waitNamespace = namespace;
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.delayWait = function (waitMs) {
        clearTimeout(this.waitId);
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.spawnWait = function (waitMs) {
        var _this = this;
        this.waitId = setTimeout(function () {
            _this.waitNamespace = null;
            _this.tryStart();
        }, waitMs);
    };
    RenderQueue.prototype.clearWait = function () {
        if (this.waitNamespace) {
            clearTimeout(this.waitId);
            this.waitId = null;
            this.waitNamespace = null;
        }
    };
    RenderQueue.prototype.canRunNext = function () {
        if (!_super.prototype.canRunNext.call(this)) {
            return false;
        }
        // waiting for a certain namespace to stop receiving tasks?
        if (this.waitNamespace) {
            var q = this.q;
            // if there was a different namespace task in the meantime,
            // that forces all previously-waiting tasks to suddenly execute.
            // TODO: find a way to do this in constant time.
            for (var i = 0; i < q.length; i++) {
                if (q[i].namespace !== this.waitNamespace) {
                    return true; // allow execution
                }
            }
            return false;
        }
        return true;
    };
    RenderQueue.prototype.runTask = function (task) {
        task.func();
    };
    RenderQueue.prototype.compoundTask = function (newTask) {
        var q = this.q;
        var shouldAppend = true;
        var i;
        var task;
        if (newTask.namespace && newTask.type === 'destroy') {
            // remove all init/add/remove ops with same namespace, regardless of order
            for (i = q.length - 1; i >= 0; i--) {
                task = q[i];
                switch (task.type) {
                    case 'init':
                        shouldAppend = false;
                    // the latest destroy is cancelled out by not doing the init
                    /* falls through */
                    case 'add':
                    /* falls through */
                    case 'remove':
                        q.splice(i, 1); // remove task
                }
            }
        }
        if (shouldAppend) {
            q.push(newTask);
        }
        return shouldAppend;
    };
    return RenderQueue;
}(TaskQueue_1.default));
exports.default = RenderQueue;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var moment_ext_1 = __webpack_require__(10);
var date_formatting_1 = __webpack_require__(47);
var Component_1 = __webpack_require__(237);
var util_2 = __webpack_require__(34);
var DateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateComponent, _super);
    function DateComponent(_view, _options) {
        var _this = _super.call(this) || this;
        _this.isRTL = false; // frequently accessed options
        _this.hitsNeededDepth = 0; // necessary because multiple callers might need the same hits
        _this.hasAllDayBusinessHours = false; // TODO: unify with largeUnit and isTimeScale?
        _this.isDatesRendered = false;
        // hack to set options prior to the this.opt calls
        if (_view) {
            _this['view'] = _view;
        }
        if (_options) {
            _this['options'] = _options;
        }
        _this.uid = String(DateComponent.guid++);
        _this.childrenByUid = {};
        _this.nextDayThreshold = moment.duration(_this.opt('nextDayThreshold'));
        _this.isRTL = _this.opt('isRTL');
        if (_this.fillRendererClass) {
            _this.fillRenderer = new _this.fillRendererClass(_this);
        }
        if (_this.eventRendererClass) {
            _this.eventRenderer = new _this.eventRendererClass(_this, _this.fillRenderer);
        }
        if (_this.helperRendererClass && _this.eventRenderer) {
            _this.helperRenderer = new _this.helperRendererClass(_this, _this.eventRenderer);
        }
        if (_this.businessHourRendererClass && _this.fillRenderer) {
            _this.businessHourRenderer = new _this.businessHourRendererClass(_this, _this.fillRenderer);
        }
        return _this;
    }
    DateComponent.prototype.addChild = function (child) {
        if (!this.childrenByUid[child.uid]) {
            this.childrenByUid[child.uid] = child;
            return true;
        }
        return false;
    };
    DateComponent.prototype.removeChild = function (child) {
        if (this.childrenByUid[child.uid]) {
            delete this.childrenByUid[child.uid];
            return true;
        }
        return false;
    };
    // TODO: only do if isInDom?
    // TODO: make part of Component, along with children/batch-render system?
    DateComponent.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        this.callChildren('updateSize', arguments);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.opt = function (name) {
        return this._getView().opt(name); // default implementation
    };
    DateComponent.prototype.publiclyTrigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.publiclyTrigger.apply(calendar, args);
    };
    DateComponent.prototype.hasPublicHandlers = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.hasPublicHandlers.apply(calendar, args);
    };
    // Date
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeDateRender = function (dateProfile) {
        this.dateProfile = dateProfile; // for rendering
        this.renderDates(dateProfile);
        this.isDatesRendered = true;
        this.callChildren('executeDateRender', arguments);
    };
    DateComponent.prototype.executeDateUnrender = function () {
        this.callChildren('executeDateUnrender', arguments);
        this.dateProfile = null;
        this.unrenderDates();
        this.isDatesRendered = false;
    };
    // date-cell content only
    DateComponent.prototype.renderDates = function (dateProfile) {
        // subclasses should implement
    };
    // date-cell content only
    DateComponent.prototype.unrenderDates = function () {
        // subclasses should override
    };
    // Now-Indicator
    // -----------------------------------------------------------------------------------------------------------------
    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
    DateComponent.prototype.getNowIndicatorUnit = function () {
        // subclasses should implement
    };
    // Renders a current time indicator at the given datetime
    DateComponent.prototype.renderNowIndicator = function (date) {
        this.callChildren('renderNowIndicator', arguments);
    };
    // Undoes the rendering actions from renderNowIndicator
    DateComponent.prototype.unrenderNowIndicator = function () {
        this.callChildren('unrenderNowIndicator', arguments);
    };
    // Business Hours
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.renderBusinessHours = function (businessHourGenerator) {
        if (this.businessHourRenderer) {
            this.businessHourRenderer.render(businessHourGenerator);
        }
        this.callChildren('renderBusinessHours', arguments);
    };
    // Unrenders previously-rendered business-hours
    DateComponent.prototype.unrenderBusinessHours = function () {
        this.callChildren('unrenderBusinessHours', arguments);
        if (this.businessHourRenderer) {
            this.businessHourRenderer.unrender();
        }
    };
    // Event Displaying
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeEventRender = function (eventsPayload) {
        if (this.eventRenderer) {
            this.eventRenderer.rangeUpdated(); // poorly named now
            this.eventRenderer.render(eventsPayload);
        }
        else if (this['renderEvents']) {
            this['renderEvents'](convertEventsPayloadToLegacyArray(eventsPayload));
        }
        this.callChildren('executeEventRender', arguments);
    };
    DateComponent.prototype.executeEventUnrender = function () {
        this.callChildren('executeEventUnrender', arguments);
        if (this.eventRenderer) {
            this.eventRenderer.unrender();
        }
        else if (this['destroyEvents']) {
            this['destroyEvents']();
        }
    };
    DateComponent.prototype.getBusinessHourSegs = function () {
        var segs = this.getOwnBusinessHourSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getBusinessHourSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnBusinessHourSegs = function () {
        if (this.businessHourRenderer) {
            return this.businessHourRenderer.getSegs();
        }
        return [];
    };
    DateComponent.prototype.getEventSegs = function () {
        var segs = this.getOwnEventSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getEventSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnEventSegs = function () {
        if (this.eventRenderer) {
            return this.eventRenderer.getSegs();
        }
        return [];
    };
    // Event Rendering Triggering
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.triggerAfterEventsRendered = function () {
        this.triggerAfterEventSegsRendered(this.getEventSegs());
        this.publiclyTrigger('eventAfterAllRender', {
            context: this,
            args: [this]
        });
    };
    DateComponent.prototype.triggerAfterEventSegsRendered = function (segs) {
        var _this = this;
        // an optimization, because getEventLegacy is expensive
        if (this.hasPublicHandlers('eventAfterRender')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) {
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventAfterRender', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    DateComponent.prototype.triggerBeforeEventsDestroyed = function () {
        this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
    };
    DateComponent.prototype.triggerBeforeEventSegsDestroyed = function (segs) {
        var _this = this;
        if (this.hasPublicHandlers('eventDestroy')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) {
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventDestroy', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    // Event Rendering Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Hides all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.showEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.css('visibility', '');
            }
        });
        this.callChildren('showEventsWithId', arguments);
    };
    // Shows all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.hideEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.css('visibility', 'hidden');
            }
        });
        this.callChildren('hideEventsWithId', arguments);
    };
    // Drag-n-Drop Rendering (for both events and external elements)
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of a event or external-element drag over the given drop zone.
    // If an external-element, seg will be `null`.
    // Must return elements used for any mock events.
    DateComponent.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var renderedHelper = false;
        this.iterChildren(function (child) {
            if (child.renderDrag(eventFootprints, seg, isTouch)) {
                renderedHelper = true;
            }
        });
        return renderedHelper;
    };
    // Unrenders a visual indication of an event or external-element being dragged.
    DateComponent.prototype.unrenderDrag = function () {
        this.callChildren('unrenderDrag', arguments);
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of an event being resized.
    DateComponent.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.callChildren('renderEventResize', arguments);
    };
    // Unrenders a visual indication of an event being resized.
    DateComponent.prototype.unrenderEventResize = function () {
        this.callChildren('unrenderEventResize', arguments);
    };
    // Selection
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of the selection
    // TODO: rename to `renderSelection` after legacy is gone
    DateComponent.prototype.renderSelectionFootprint = function (componentFootprint) {
        this.renderHighlight(componentFootprint);
        this.callChildren('renderSelectionFootprint', arguments);
    };
    // Unrenders a visual indication of selection
    DateComponent.prototype.unrenderSelection = function () {
        this.unrenderHighlight();
        this.callChildren('unrenderSelection', arguments);
    };
    // Highlight
    // ---------------------------------------------------------------------------------------------------------------
    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
    DateComponent.prototype.renderHighlight = function (componentFootprint) {
        if (this.fillRenderer) {
            this.fillRenderer.renderFootprint('highlight', componentFootprint, {
                getClasses: function () {
                    return ['fc-highlight'];
                }
            });
        }
        this.callChildren('renderHighlight', arguments);
    };
    // Unrenders the emphasis on a date range
    DateComponent.prototype.unrenderHighlight = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('highlight');
        }
        this.callChildren('unrenderHighlight', arguments);
    };
    // Hit Areas
    // ---------------------------------------------------------------------------------------------------------------
    // just because all DateComponents support this interface
    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
    DateComponent.prototype.hitsNeeded = function () {
        if (!(this.hitsNeededDepth++)) {
            this.prepareHits();
        }
        this.callChildren('hitsNeeded', arguments);
    };
    DateComponent.prototype.hitsNotNeeded = function () {
        if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
            this.releaseHits();
        }
        this.callChildren('hitsNotNeeded', arguments);
    };
    DateComponent.prototype.prepareHits = function () {
        // subclasses can implement
    };
    DateComponent.prototype.releaseHits = function () {
        // subclasses can implement
    };
    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
    // The returned object will be processed by getHitFootprint and getHitEl.
    DateComponent.prototype.queryHit = function (leftOffset, topOffset) {
        var childrenByUid = this.childrenByUid;
        var uid;
        var hit;
        for (uid in childrenByUid) {
            hit = childrenByUid[uid].queryHit(leftOffset, topOffset);
            if (hit) {
                break;
            }
        }
        return hit;
    };
    DateComponent.prototype.getSafeHitFootprint = function (hit) {
        var footprint = this.getHitFootprint(hit);
        if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
            return null;
        }
        return footprint;
    };
    DateComponent.prototype.getHitFootprint = function (hit) {
        // what about being abstract!?
    };
    // Given position-level information about a date-related area within the grid,
    // should return a jQuery element that best represents it. passed to dayClick callback.
    DateComponent.prototype.getHitEl = function (hit) {
        // what about being abstract!?
    };
    /* Converting eventRange -> eventFootprint
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var eventFootprints = [];
        var i;
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// append
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    DateComponent.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_2.eventRangeToEventFootprint(eventRange)];
    };
    /* Converting componentFootprint/eventFootprint -> segs
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventFootprintsToSegs = function (eventFootprints) {
        var segs = [];
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
        }
        return segs;
    };
    // Given an event's span (unzoned start/end and other misc data), and the event itself,
    // slices into segments and attaches event-derived properties to them.
    // eventSpan - { start, end, isStart, isEnd, otherthings... }
    DateComponent.prototype.eventFootprintToSegs = function (eventFootprint) {
        var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
        var segs;
        var i;
        var seg;
        segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (!unzonedRange.isStart) {
                seg.isStart = false;
            }
            if (!unzonedRange.isEnd) {
                seg.isEnd = false;
            }
            seg.footprint = eventFootprint;
            // TODO: rename to seg.eventFootprint
        }
        return segs;
    };
    DateComponent.prototype.componentFootprintToSegs = function (componentFootprint) {
        return [];
    };
    // Utils
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.callChildren = function (methodName, args) {
        this.iterChildren(function (child) {
            child[methodName].apply(child, args);
        });
    };
    DateComponent.prototype.iterChildren = function (func) {
        var childrenByUid = this.childrenByUid;
        var uid;
        for (uid in childrenByUid) {
            func(childrenByUid[uid]);
        }
    };
    DateComponent.prototype._getCalendar = function () {
        var t = this;
        return t.calendar || t.view.calendar;
    };
    DateComponent.prototype._getView = function () {
        return this.view;
    };
    DateComponent.prototype._getDateProfile = function () {
        return this._getView().get('dateProfile');
    };
    // Generates HTML for an anchor to another view into the calendar.
    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
    // `gotoOptions` can either be a moment input, or an object with the form:
    // { date, type, forceOff }
    // `type` is a view-type like "day" or "week". default value is "day".
    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
    DateComponent.prototype.buildGotoAnchorHtml = function (gotoOptions, attrs, innerHtml) {
        var date;
        var type;
        var forceOff;
        var finalOptions;
        if ($.isPlainObject(gotoOptions)) {
            date = gotoOptions.date;
            type = gotoOptions.type;
            forceOff = gotoOptions.forceOff;
        }
        else {
            date = gotoOptions; // a single moment input
        }
        date = moment_ext_1.default(date); // if a string, parse it
        finalOptions = {
            date: date.format('YYYY-MM-DD'),
            type: type || 'day'
        };
        if (typeof attrs === 'string') {
            innerHtml = attrs;
            attrs = null;
        }
        attrs = attrs ? ' ' + util_1.attrsToStr(attrs) : ''; // will have a leading space
        innerHtml = innerHtml || '';
        if (!forceOff && this.opt('navLinks')) {
            return '<a' + attrs +
                ' data-goto="' + util_1.htmlEscape(JSON.stringify(finalOptions)) + '">' +
                innerHtml +
                '</a>';
        }
        else {
            return '<span' + attrs + '>' +
                innerHtml +
                '</span>';
        }
    };
    DateComponent.prototype.getAllDayHtml = function () {
        return this.opt('allDayHtml') || util_1.htmlEscape(this.opt('allDayText'));
    };
    // Computes HTML classNames for a single-day element
    DateComponent.prototype.getDayClasses = function (date, noThemeHighlight) {
        var view = this._getView();
        var classes = [];
        var today;
        if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
            classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
        }
        else {
            classes.push('fc-' + util_1.dayIDs[date.day()]);
            if (view.isDateInOtherMonth(date, this.dateProfile)) {
                classes.push('fc-other-month');
            }
            today = view.calendar.getNow();
            if (date.isSame(today, 'day')) {
                classes.push('fc-today');
                if (noThemeHighlight !== true) {
                    classes.push(view.calendar.theme.getClass('today'));
                }
            }
            else if (date < today) {
                classes.push('fc-past');
            }
            else {
                classes.push('fc-future');
            }
        }
        return classes;
    };
    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
    // The timezones of the dates within `range` will be respected.
    DateComponent.prototype.formatRange = function (range, isAllDay, formatStr, separator) {
        var end = range.end;
        if (isAllDay) {
            end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
        }
        return date_formatting_1.formatRange(range.start, end, formatStr, separator, this.isRTL);
    };
    // Compute the number of the give units in the "current" range.
    // Will return a floating-point number. Won't round.
    DateComponent.prototype.currentRangeAs = function (unit) {
        return this._getDateProfile().currentUnzonedRange.as(unit);
    };
    // Returns the date range of the full days the given range visually appears to occupy.
    // Returns a plain object with start/end, NOT an UnzonedRange!
    DateComponent.prototype.computeDayRange = function (unzonedRange) {
        var calendar = this._getCalendar();
        var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts
        var end = calendar.msToUtcMoment(unzonedRange.endMs);
        var endTimeMS = +end.time(); // # of milliseconds into `endDay`
        var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
            endDay.add(1, 'days');
        }
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay <= startDay) {
            endDay = startDay.clone().add(1, 'days');
        }
        return { start: startDay, end: endDay };
    };
    // Does the given range visually appear to occupy more than one day?
    DateComponent.prototype.isMultiDayRange = function (unzonedRange) {
        var dayRange = this.computeDayRange(unzonedRange);
        return dayRange.end.diff(dayRange.start, 'days') > 1;
    };
    DateComponent.guid = 0; // TODO: better system for this?
    return DateComponent;
}(Component_1.default));
exports.default = DateComponent;
// legacy
function convertEventsPayloadToLegacyArray(eventsPayload) {
    var eventDefId;
    var eventInstances;
    var legacyEvents = [];
    var i;
    for (eventDefId in eventsPayload) {
        eventInstances = eventsPayload[eventDefId].eventInstances;
        for (i = 0; i < eventInstances.length; i++) {
            legacyEvents.push(eventInstances[i].toLegacy());
        }
    }
    return legacyEvents;
}


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var Iterator_1 = __webpack_require__(238);
var GlobalEmitter_1 = __webpack_require__(20);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var Toolbar_1 = __webpack_require__(239);
var OptionsManager_1 = __webpack_require__(240);
var ViewSpecManager_1 = __webpack_require__(241);
var Constraints_1 = __webpack_require__(207);
var locale_1 = __webpack_require__(30);
var moment_ext_1 = __webpack_require__(10);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventDateProfile_1 = __webpack_require__(17);
var EventManager_1 = __webpack_require__(242);
var BusinessHourGenerator_1 = __webpack_require__(212);
var EventSourceParser_1 = __webpack_require__(37);
var EventDefParser_1 = __webpack_require__(49);
var SingleEventDef_1 = __webpack_require__(13);
var EventDefMutation_1 = __webpack_require__(36);
var EventSource_1 = __webpack_require__(6);
var ThemeRegistry_1 = __webpack_require__(51);
var Calendar = /** @class */ (function () {
    function Calendar(el, overrides) {
        this.loadingLevel = 0; // number of simultaneous loading tasks
        this.ignoreUpdateViewSize = 0;
        this.freezeContentHeightDepth = 0;
        // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
        // unneeded() is called in destroy.
        GlobalEmitter_1.default.needed();
        this.el = el;
        this.viewsByType = {};
        this.optionsManager = new OptionsManager_1.default(this, overrides);
        this.viewSpecManager = new ViewSpecManager_1.default(this.optionsManager, this);
        this.initMomentInternals(); // needs to happen after options hash initialized
        this.initCurrentDate();
        this.initEventManager();
        this.constraints = new Constraints_1.default(this.eventManager, this);
        this.constructed();
    }
    Calendar.prototype.constructed = function () {
        // useful for monkeypatching. used?
    };
    Calendar.prototype.getView = function () {
        return this.view;
    };
    Calendar.prototype.publiclyTrigger = function (name, triggerInfo) {
        var optHandler = this.opt(name);
        var context;
        var args;
        if ($.isPlainObject(triggerInfo)) {
            context = triggerInfo.context;
            args = triggerInfo.args;
        }
        else if ($.isArray(triggerInfo)) {
            args = triggerInfo;
        }
        if (context == null) {
            context = this.el[0]; // fallback context
        }
        if (!args) {
            args = [];
        }
        this.triggerWith(name, context, args); // Emitter's method
        if (optHandler) {
            return optHandler.apply(context, args);
        }
    };
    Calendar.prototype.hasPublicHandlers = function (name) {
        return this.hasHandlers(name) ||
            this.opt(name); // handler specified in options
    };
    // Options Public API
    // -----------------------------------------------------------------------------------------------------------------
    // public getter/setter
    Calendar.prototype.option = function (name, value) {
        var newOptionHash;
        if (typeof name === 'string') {
            if (value === undefined) {
                return this.optionsManager.get(name);
            }
            else {
                newOptionHash = {};
                newOptionHash[name] = value;
                this.optionsManager.add(newOptionHash);
            }
        }
        else if (typeof name === 'object') {
            this.optionsManager.add(name);
        }
    };
    // private getter
    Calendar.prototype.opt = function (name) {
        return this.optionsManager.get(name);
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
    Calendar.prototype.instantiateView = function (viewType) {
        var spec = this.viewSpecManager.getViewSpec(viewType);
        if (!spec) {
            throw new Error("View type \"" + viewType + "\" is not valid");
        }
        return new spec['class'](this, spec);
    };
    // Returns a boolean about whether the view is okay to instantiate at some point
    Calendar.prototype.isValidViewType = function (viewType) {
        return Boolean(this.viewSpecManager.getViewSpec(viewType));
    };
    Calendar.prototype.changeView = function (viewName, dateOrRange) {
        if (dateOrRange) {
            if (dateOrRange.start && dateOrRange.end) {
                this.optionsManager.recordOverrides({
                    visibleRange: dateOrRange
                });
            }
            else {
                this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
            }
        }
        this.renderView(viewName);
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    Calendar.prototype.zoomTo = function (newDate, viewType) {
        var spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = this.viewSpecManager.getViewSpec(viewType) ||
            this.viewSpecManager.getUnitViewSpec(viewType);
        this.currentDate = newDate.clone();
        this.renderView(spec ? spec.type : null);
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initCurrentDate = function () {
        var defaultDateInput = this.opt('defaultDate');
        // compute the initial ambig-timezone date
        if (defaultDateInput != null) {
            this.currentDate = this.moment(defaultDateInput).stripZone();
        }
        else {
            this.currentDate = this.getNow(); // getNow already returns unzoned
        }
    };
    Calendar.prototype.prev = function () {
        var view = this.view;
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        if (prevInfo.isValid) {
            this.currentDate = prevInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.next = function () {
        var view = this.view;
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        if (nextInfo.isValid) {
            this.currentDate = nextInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.prevYear = function () {
        this.currentDate.add(-1, 'years');
        this.renderView();
    };
    Calendar.prototype.nextYear = function () {
        this.currentDate.add(1, 'years');
        this.renderView();
    };
    Calendar.prototype.today = function () {
        this.currentDate = this.getNow(); // should deny like prev/next?
        this.renderView();
    };
    Calendar.prototype.gotoDate = function (zonedDateInput) {
        this.currentDate = this.moment(zonedDateInput).stripZone();
        this.renderView();
    };
    Calendar.prototype.incrementDate = function (delta) {
        this.currentDate.add(moment.duration(delta));
        this.renderView();
    };
    // for external API
    Calendar.prototype.getDate = function () {
        return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
    };
    // Loading Triggering
    // -----------------------------------------------------------------------------------------------------------------
    // Should be called when any type of async data fetching begins
    Calendar.prototype.pushLoading = function () {
        if (!(this.loadingLevel++)) {
            this.publiclyTrigger('loading', [true, this.view]);
        }
    };
    // Should be called when any type of async data fetching completes
    Calendar.prototype.popLoading = function () {
        if (!(--this.loadingLevel)) {
            this.publiclyTrigger('loading', [false, this.view]);
        }
    };
    // High-level Rendering
    // -----------------------------------------------------------------------------------
    Calendar.prototype.render = function () {
        if (!this.contentEl) {
            this.initialRender();
        }
        else if (this.elementVisible()) {
            // mainly for the public API
            this.calcSize();
            this.updateViewSize();
        }
    };
    Calendar.prototype.initialRender = function () {
        var _this = this;
        var el = this.el;
        el.addClass('fc');
        // event delegation for nav links
        el.on('click.fc', 'a[data-goto]', function (ev) {
            var anchorEl = $(ev.currentTarget);
            var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
            var date = _this.moment(gotoOptions.date);
            var viewType = gotoOptions.type;
            // property like "navLinkDayClick". might be a string or a function
            var customAction = _this.view.opt('navLink' + util_1.capitaliseFirstLetter(viewType) + 'Click');
            if (typeof customAction === 'function') {
                customAction(date, ev);
            }
            else {
                if (typeof customAction === 'string') {
                    viewType = customAction;
                }
                _this.zoomTo(date, viewType);
            }
        });
        // called immediately, and upon option change
        this.optionsManager.watch('settingTheme', ['?theme', '?themeSystem'], function (opts) {
            var themeClass = ThemeRegistry_1.getThemeSystemClass(opts.themeSystem || opts.theme);
            var theme = new themeClass(_this.optionsManager);
            var widgetClass = theme.getClass('widget');
            _this.theme = theme;
            if (widgetClass) {
                el.addClass(widgetClass);
            }
        }, function () {
            var widgetClass = _this.theme.getClass('widget');
            _this.theme = null;
            if (widgetClass) {
                el.removeClass(widgetClass);
            }
        });
        this.optionsManager.watch('settingBusinessHourGenerator', ['?businessHours'], function (deps) {
            _this.businessHourGenerator = new BusinessHourGenerator_1.default(deps.businessHours, _this);
            if (_this.view) {
                _this.view.set('businessHourGenerator', _this.businessHourGenerator);
            }
        }, function () {
            _this.businessHourGenerator = null;
        });
        // called immediately, and upon option change.
        // HACK: locale often affects isRTL, so we explicitly listen to that too.
        this.optionsManager.watch('applyingDirClasses', ['?isRTL', '?locale'], function (opts) {
            el.toggleClass('fc-ltr', !opts.isRTL);
            el.toggleClass('fc-rtl', opts.isRTL);
        });
        this.contentEl = $("<div class='fc-view-container'/>").prependTo(el);
        this.initToolbars();
        this.renderHeader();
        this.renderFooter();
        this.renderView(this.opt('defaultView'));
        if (this.opt('handleWindowResize')) {
            $(window).resize(this.windowResizeProxy = util_1.debounce(// prevents rapid calls
            this.windowResize.bind(this), this.opt('windowResizeDelay')));
        }
    };
    Calendar.prototype.destroy = function () {
        if (this.view) {
            this.clearView();
        }
        this.toolbarsManager.proxyCall('removeElement');
        this.contentEl.remove();
        this.el.removeClass('fc fc-ltr fc-rtl');
        // removes theme-related root className
        this.optionsManager.unwatch('settingTheme');
        this.optionsManager.unwatch('settingBusinessHourGenerator');
        this.el.off('.fc'); // unbind nav link handlers
        if (this.windowResizeProxy) {
            $(window).unbind('resize', this.windowResizeProxy);
            this.windowResizeProxy = null;
        }
        GlobalEmitter_1.default.unneeded();
    };
    Calendar.prototype.elementVisible = function () {
        return this.el.is(':visible');
    };
    // Render Queue
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.bindViewHandlers = function (view) {
        var _this = this;
        view.watch('titleForCalendar', ['title'], function (deps) {
            if (view === _this.view) {
                _this.setToolbarsTitle(deps.title);
            }
        });
        view.watch('dateProfileForCalendar', ['dateProfile'], function (deps) {
            if (view === _this.view) {
                _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates
                _this.updateToolbarButtons(deps.dateProfile);
            }
        });
    };
    Calendar.prototype.unbindViewHandlers = function (view) {
        view.unwatch('titleForCalendar');
        view.unwatch('dateProfileForCalendar');
    };
    // View Rendering
    // -----------------------------------------------------------------------------------
    // Renders a view because of a date change, view-type change, or for the first time.
    // If not given a viewType, keep the current view but render different dates.
    // Accepts an optional scroll state to restore to.
    Calendar.prototype.renderView = function (viewType) {
        var oldView = this.view;
        var newView;
        this.freezeContentHeight();
        if (oldView && viewType && oldView.type !== viewType) {
            this.clearView();
        }
        // if viewType changed, or the view was never created, create a fresh view
        if (!this.view && viewType) {
            newView = this.view =
                this.viewsByType[viewType] ||
                    (this.viewsByType[viewType] = this.instantiateView(viewType));
            this.bindViewHandlers(newView);
            newView.startBatchRender(); // so that setElement+setDate rendering are joined
            newView.setElement($("<div class='fc-view fc-" + viewType + "-view' />").appendTo(this.contentEl));
            this.toolbarsManager.proxyCall('activateButton', viewType);
        }
        if (this.view) {
            // prevent unnecessary change firing
            if (this.view.get('businessHourGenerator') !== this.businessHourGenerator) {
                this.view.set('businessHourGenerator', this.businessHourGenerator);
            }
            this.view.setDate(this.currentDate);
            if (newView) {
                newView.stopBatchRender();
            }
        }
        this.thawContentHeight();
    };
    // Unrenders the current view and reflects this change in the Header.
    // Unregsiters the `view`, but does not remove from viewByType hash.
    Calendar.prototype.clearView = function () {
        var currentView = this.view;
        this.toolbarsManager.proxyCall('deactivateButton', currentView.type);
        this.unbindViewHandlers(currentView);
        currentView.removeElement();
        currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time
        this.view = null;
    };
    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
    // Maintains the same scroll state.
    // TODO: maintain any other user-manipulated state.
    Calendar.prototype.reinitView = function () {
        var oldView = this.view;
        var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll
        this.freezeContentHeight();
        this.clearView();
        this.calcSize();
        this.renderView(oldView.type); // needs the type to freshly render
        this.view.applyScroll(scroll);
        this.thawContentHeight();
    };
    // Resizing
    // -----------------------------------------------------------------------------------
    Calendar.prototype.getSuggestedViewHeight = function () {
        if (this.suggestedViewHeight == null) {
            this.calcSize();
        }
        return this.suggestedViewHeight;
    };
    Calendar.prototype.isHeightAuto = function () {
        return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
    };
    Calendar.prototype.updateViewSize = function (isResize) {
        if (isResize === void 0) { isResize = false; }
        var view = this.view;
        var scroll;
        if (!this.ignoreUpdateViewSize && view) {
            if (isResize) {
                this.calcSize();
                scroll = view.queryScroll();
            }
            this.ignoreUpdateViewSize++;
            view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
            this.ignoreUpdateViewSize--;
            if (isResize) {
                view.applyScroll(scroll);
            }
            return true; // signal success
        }
    };
    Calendar.prototype.calcSize = function () {
        if (this.elementVisible()) {
            this._calcSize();
        }
    };
    Calendar.prototype._calcSize = function () {
        var contentHeightInput = this.opt('contentHeight');
        var heightInput = this.opt('height');
        if (typeof contentHeightInput === 'number') {
            this.suggestedViewHeight = contentHeightInput;
        }
        else if (typeof contentHeightInput === 'function') {
            this.suggestedViewHeight = contentHeightInput();
        }
        else if (typeof heightInput === 'number') {
            this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
        }
        else if (typeof heightInput === 'function') {
            this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
        }
        else if (heightInput === 'parent') {
            this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
        }
        else {
            this.suggestedViewHeight = Math.round(this.contentEl.width() /
                Math.max(this.opt('aspectRatio'), .5));
        }
    };
    Calendar.prototype.windowResize = function (ev) {
        if (
        // the purpose: so we don't process jqui "resize" events that have bubbled up
        // cast to any because .target, which is Element, can't be compared to window for some reason.
        ev.target === window &&
            this.view &&
            this.view.isDatesRendered) {
            if (this.updateViewSize(true)) {
                this.publiclyTrigger('windowResize', [this.view]);
            }
        }
    };
    /* Height "Freezing"
    -----------------------------------------------------------------------------*/
    Calendar.prototype.freezeContentHeight = function () {
        if (!(this.freezeContentHeightDepth++)) {
            this.forceFreezeContentHeight();
        }
    };
    Calendar.prototype.forceFreezeContentHeight = function () {
        this.contentEl.css({
            width: '100%',
            height: this.contentEl.height(),
            overflow: 'hidden'
        });
    };
    Calendar.prototype.thawContentHeight = function () {
        this.freezeContentHeightDepth--;
        // always bring back to natural height
        this.contentEl.css({
            width: '',
            height: '',
            overflow: ''
        });
        // but if there are future thaws, re-freeze
        if (this.freezeContentHeightDepth) {
            this.forceFreezeContentHeight();
        }
    };
    // Toolbar
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initToolbars = function () {
        this.header = new Toolbar_1.default(this, this.computeHeaderOptions());
        this.footer = new Toolbar_1.default(this, this.computeFooterOptions());
        this.toolbarsManager = new Iterator_1.default([this.header, this.footer]);
    };
    Calendar.prototype.computeHeaderOptions = function () {
        return {
            extraClasses: 'fc-header-toolbar',
            layout: this.opt('header')
        };
    };
    Calendar.prototype.computeFooterOptions = function () {
        return {
            extraClasses: 'fc-footer-toolbar',
            layout: this.opt('footer')
        };
    };
    // can be called repeatedly and Header will rerender
    Calendar.prototype.renderHeader = function () {
        var header = this.header;
        header.setToolbarOptions(this.computeHeaderOptions());
        header.render();
        if (header.el) {
            this.el.prepend(header.el);
        }
    };
    // can be called repeatedly and Footer will rerender
    Calendar.prototype.renderFooter = function () {
        var footer = this.footer;
        footer.setToolbarOptions(this.computeFooterOptions());
        footer.render();
        if (footer.el) {
            this.el.append(footer.el);
        }
    };
    Calendar.prototype.setToolbarsTitle = function (title) {
        this.toolbarsManager.proxyCall('updateTitle', title);
    };
    Calendar.prototype.updateToolbarButtons = function (dateProfile) {
        var now = this.getNow();
        var view = this.view;
        var todayInfo = view.dateProfileGenerator.build(now);
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        this.toolbarsManager.proxyCall((todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now)) ?
            'enableButton' :
            'disableButton', 'today');
        this.toolbarsManager.proxyCall(prevInfo.isValid ?
            'enableButton' :
            'disableButton', 'prev');
        this.toolbarsManager.proxyCall(nextInfo.isValid ?
            'enableButton' :
            'disableButton', 'next');
    };
    Calendar.prototype.queryToolbarsHeight = function () {
        return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
            var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
            return accumulator + toolbarHeight;
        }, 0);
    };
    // Selection
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    Calendar.prototype.select = function (zonedStartInput, zonedEndInput) {
        this.view.select(this.buildSelectFootprint.apply(this, arguments));
    };
    Calendar.prototype.unselect = function () {
        if (this.view) {
            this.view.unselect();
        }
    };
    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
    Calendar.prototype.buildSelectFootprint = function (zonedStartInput, zonedEndInput) {
        var start = this.moment(zonedStartInput).stripZone();
        var end;
        if (zonedEndInput) {
            end = this.moment(zonedEndInput).stripZone();
        }
        else if (start.hasTime()) {
            end = start.clone().add(this.defaultTimedEventDuration);
        }
        else {
            end = start.clone().add(this.defaultAllDayEventDuration);
        }
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), !start.hasTime());
    };
    // Date Utils
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initMomentInternals = function () {
        var _this = this;
        this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
        this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));
        // Called immediately, and when any of the options change.
        // Happens before any internal objects rebuild or rerender, because this is very core.
        this.optionsManager.watch('buildingMomentLocale', [
            '?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
            '?firstDay', '?weekNumberCalculation'
        ], function (opts) {
            var weekNumberCalculation = opts.weekNumberCalculation;
            var firstDay = opts.firstDay;
            var _week;
            // normalize
            if (weekNumberCalculation === 'iso') {
                weekNumberCalculation = 'ISO'; // normalize
            }
            var localeData = Object.create(// make a cheap copy
            locale_1.getMomentLocaleData(opts.locale) // will fall back to en
            );
            if (opts.monthNames) {
                localeData._months = opts.monthNames;
            }
            if (opts.monthNamesShort) {
                localeData._monthsShort = opts.monthNamesShort;
            }
            if (opts.dayNames) {
                localeData._weekdays = opts.dayNames;
            }
            if (opts.dayNamesShort) {
                localeData._weekdaysShort = opts.dayNamesShort;
            }
            if (firstDay == null && weekNumberCalculation === 'ISO') {
                firstDay = 1;
            }
            if (firstDay != null) {
                _week = Object.create(localeData._week); // _week: { dow: # }
                _week.dow = firstDay;
                localeData._week = _week;
            }
            if (weekNumberCalculation === 'ISO' ||
                weekNumberCalculation === 'local' ||
                typeof weekNumberCalculation === 'function') {
                localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
            }
            _this.localeData = localeData;
            // If the internal current date object already exists, move to new locale.
            // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
            if (_this.currentDate) {
                _this.localizeMoment(_this.currentDate); // sets to localeData
            }
        });
    };
    // Builds a moment using the settings of the current calendar: timezone and locale.
    // Accepts anything the vanilla moment() constructor accepts.
    Calendar.prototype.moment = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var mom;
        if (this.opt('timezone') === 'local') {
            mom = moment_ext_1.default.apply(null, args);
            // Force the moment to be local, because momentExt doesn't guarantee it.
            if (mom.hasTime()) {
                mom.local();
            }
        }
        else if (this.opt('timezone') === 'UTC') {
            mom = moment_ext_1.default.utc.apply(null, args); // process as UTC
        }
        else {
            mom = moment_ext_1.default.parseZone.apply(null, args); // let the input decide the zone
        }
        this.localizeMoment(mom); // TODO
        return mom;
    };
    Calendar.prototype.msToMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        else {
            mom = this.applyTimezone(mom); // may or may not apply locale
        }
        this.localizeMoment(mom);
        return mom;
    };
    Calendar.prototype.msToUtcMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        this.localizeMoment(mom);
        return mom;
    };
    // Updates the given moment's locale settings to the current calendar locale settings.
    Calendar.prototype.localizeMoment = function (mom) {
        mom._locale = this.localeData;
    };
    // Returns a boolean about whether or not the calendar knows how to calculate
    // the timezone offset of arbitrary dates in the current timezone.
    Calendar.prototype.getIsAmbigTimezone = function () {
        return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
    };
    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
    Calendar.prototype.applyTimezone = function (date) {
        if (!date.hasTime()) {
            return date.clone();
        }
        var zonedDate = this.moment(date.toArray());
        var timeAdjust = date.time().asMilliseconds() - zonedDate.time().asMilliseconds();
        var adjustedZonedDate;
        // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
        if (timeAdjust) {
            adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
            if (date.time().asMilliseconds() - adjustedZonedDate.time().asMilliseconds() === 0) {
                zonedDate = adjustedZonedDate;
            }
        }
        return zonedDate;
    };
    /*
    Assumes the footprint is non-open-ended.
    */
    Calendar.prototype.footprintToDateProfile = function (componentFootprint, ignoreEnd) {
        if (ignoreEnd === void 0) { ignoreEnd = false; }
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs);
        var end;
        if (!ignoreEnd) {
            end = moment_ext_1.default.utc(componentFootprint.unzonedRange.endMs);
        }
        if (componentFootprint.isAllDay) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else {
            start = this.applyTimezone(start);
            if (end) {
                end = this.applyTimezone(end);
            }
        }
        return new EventDateProfile_1.default(start, end, this);
    };
    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
    // Will return an moment with an ambiguous timezone.
    Calendar.prototype.getNow = function () {
        var now = this.opt('now');
        if (typeof now === 'function') {
            now = now();
        }
        return this.moment(now).stripZone();
    };
    // Produces a human-readable string for the given duration.
    // Side-effect: changes the locale of the given duration.
    Calendar.prototype.humanizeDuration = function (duration) {
        return duration.locale(this.opt('locale')).humanize();
    };
    // will return `null` if invalid range
    Calendar.prototype.parseUnzonedRange = function (rangeInput) {
        var start = null;
        var end = null;
        if (rangeInput.start) {
            start = this.moment(rangeInput.start).stripZone();
        }
        if (rangeInput.end) {
            end = this.moment(rangeInput.end).stripZone();
        }
        if (!start && !end) {
            return null;
        }
        if (start && end && end.isBefore(start)) {
            return null;
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Event-Date Utilities
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initEventManager = function () {
        var _this = this;
        var eventManager = new EventManager_1.default(this);
        var rawSources = this.opt('eventSources') || [];
        var singleRawSource = this.opt('events');
        this.eventManager = eventManager;
        if (singleRawSource) {
            rawSources.unshift(singleRawSource);
        }
        eventManager.on('release', function (eventsPayload) {
            _this.trigger('eventsReset', eventsPayload);
        });
        eventManager.freeze();
        rawSources.forEach(function (rawSource) {
            var source = EventSourceParser_1.default.parse(rawSource, _this);
            if (source) {
                eventManager.addSource(source);
            }
        });
        eventManager.thaw();
    };
    Calendar.prototype.requestEvents = function (start, end) {
        return this.eventManager.requestEvents(start, end, this.opt('timezone'), !this.opt('lazyFetching'));
    };
    // Get an event's normalized end date. If not present, calculate it from the defaults.
    Calendar.prototype.getEventEnd = function (event) {
        if (event.end) {
            return event.end.clone();
        }
        else {
            return this.getDefaultEventEnd(event.allDay, event.start);
        }
    };
    // Given an event's allDay status and start date, return what its fallback end date should be.
    // TODO: rename to computeDefaultEventEnd
    Calendar.prototype.getDefaultEventEnd = function (allDay, zonedStart) {
        var end = zonedStart.clone();
        if (allDay) {
            end.stripTime().add(this.defaultAllDayEventDuration);
        }
        else {
            end.add(this.defaultTimedEventDuration);
        }
        if (this.getIsAmbigTimezone()) {
            end.stripZone(); // we don't know what the tzo should be
        }
        return end;
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.rerenderEvents = function () {
        this.view.flash('displayingEvents');
    };
    Calendar.prototype.refetchEvents = function () {
        this.eventManager.refetchAllSources();
    };
    Calendar.prototype.renderEvents = function (eventInputs, isSticky) {
        this.eventManager.freeze();
        for (var i = 0; i < eventInputs.length; i++) {
            this.renderEvent(eventInputs[i], isSticky);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.renderEvent = function (eventInput, isSticky) {
        if (isSticky === void 0) { isSticky = false; }
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, eventInput.source || eventManager.stickySource);
        if (eventDef) {
            eventManager.addEventDef(eventDef, isSticky);
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.removeEvents = function (legacyQuery) {
        var eventManager = this.eventManager;
        var legacyInstances = [];
        var idMap = {};
        var eventDef;
        var i;
        if (legacyQuery == null) {
            eventManager.removeAllEventDefs(); // persist=true
        }
        else {
            eventManager.getEventInstances().forEach(function (eventInstance) {
                legacyInstances.push(eventInstance.toLegacy());
            });
            legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery);
            // compute unique IDs
            for (i = 0; i < legacyInstances.length; i++) {
                eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
                idMap[eventDef.id] = true;
            }
            eventManager.freeze();
            for (i in idMap) {
                eventManager.removeEventDefsById(i); // persist=true
            }
            eventManager.thaw();
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.clientEvents = function (legacyQuery) {
        var legacyEventInstances = [];
        this.eventManager.getEventInstances().forEach(function (eventInstance) {
            legacyEventInstances.push(eventInstance.toLegacy());
        });
        return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
    };
    Calendar.prototype.updateEvents = function (eventPropsArray) {
        this.eventManager.freeze();
        for (var i = 0; i < eventPropsArray.length; i++) {
            this.updateEvent(eventPropsArray[i]);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.updateEvent = function (eventProps) {
        var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
        var eventInstance;
        var eventDefMutation;
        if (eventDef instanceof SingleEventDef_1.default) {
            eventInstance = eventDef.buildInstance();
            eventDefMutation = EventDefMutation_1.default.createFromRawProps(eventInstance, eventProps, // raw props
            null // largeUnit -- who uses it?
            );
            this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
        }
    };
    // Public Event Sources API
    // ------------------------------------------------------------------------------------
    Calendar.prototype.getEventSources = function () {
        return this.eventManager.otherSources.slice(); // clone
    };
    Calendar.prototype.getEventSourceById = function (id) {
        return this.eventManager.getSourceById(EventSource_1.default.normalizeId(id));
    };
    Calendar.prototype.addEventSource = function (sourceInput) {
        var source = EventSourceParser_1.default.parse(sourceInput, this);
        if (source) {
            this.eventManager.addSource(source);
        }
    };
    Calendar.prototype.removeEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources;
        var i;
        if (sourceMultiQuery == null) {
            this.eventManager.removeAllSources();
        }
        else {
            sources = eventManager.multiQuerySources(sourceMultiQuery);
            eventManager.freeze();
            for (i = 0; i < sources.length; i++) {
                eventManager.removeSource(sources[i]);
            }
            eventManager.thaw();
        }
    };
    Calendar.prototype.removeEventSource = function (sourceQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.querySources(sourceQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.removeSource(sources[i]);
        }
        eventManager.thaw();
    };
    Calendar.prototype.refetchEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.multiQuerySources(sourceMultiQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.refetchSource(sources[i]);
        }
        eventManager.thaw();
    };
    // not for internal use. use options module directly instead.
    Calendar.defaults = options_1.globalDefaults;
    Calendar.englishDefaults = options_1.englishDefaults;
    Calendar.rtlDefaults = options_1.rtlDefaults;
    return Calendar;
}());
exports.default = Calendar;
EmitterMixin_1.default.mixInto(Calendar);
ListenerMixin_1.default.mixInto(Calendar);
function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
    if (legacyQuery == null) {
        return legacyEventInstances;
    }
    else if ($.isFunction(legacyQuery)) {
        return legacyEventInstances.filter(legacyQuery);
    }
    else {
        legacyQuery += ''; // normalize to string
        return legacyEventInstances.filter(function (legacyEventInstance) {
            // soft comparison because id not be normalized to string
            // tslint:disable-next-line
            return legacyEventInstance.id == legacyQuery ||
                legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
        });
    }
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var UnzonedRange_1 = __webpack_require__(5);
var DateProfileGenerator = /** @class */ (function () {
    function DateProfileGenerator(_view) {
        this._view = _view;
    }
    DateProfileGenerator.prototype.opt = function (name) {
        return this._view.opt(name);
    };
    DateProfileGenerator.prototype.trimHiddenDays = function (unzonedRange) {
        return this._view.trimHiddenDays(unzonedRange);
    };
    DateProfileGenerator.prototype.msToUtcMoment = function (ms, forceAllDay) {
        return this._view.calendar.msToUtcMoment(ms, forceAllDay);
    };
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile) {
        var prevDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .subtract(currentDateProfile.dateIncrement);
        return this.build(prevDate, -1);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function (currentDateProfile) {
        var nextDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .add(currentDateProfile.dateIncrement);
        return this.build(nextDate, 1);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function (date, direction, forceToValid) {
        if (forceToValid === void 0) { forceToValid = false; }
        var isDateAllDay = !date.hasTime();
        var validUnzonedRange;
        var minTime = null;
        var maxTime = null;
        var currentInfo;
        var isRangeAllDay;
        var renderUnzonedRange;
        var activeUnzonedRange;
        var isValid;
        validUnzonedRange = this.buildValidRange();
        validUnzonedRange = this.trimHiddenDays(validUnzonedRange);
        if (forceToValid) {
            date = this.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        currentInfo = this.buildCurrentRangeInfo(date, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
        renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
        activeUnzonedRange = renderUnzonedRange.clone();
        if (!this.opt('showNonCurrentDates')) {
            activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
        }
        minTime = moment.duration(this.opt('minTime'));
        maxTime = moment.duration(this.opt('maxTime'));
        activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
        activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null
        if (activeUnzonedRange) {
            date = this.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validUnzonedRange: validUnzonedRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentUnzonedRange: currentInfo.unzonedRange,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeUnzonedRange: activeUnzonedRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderUnzonedRange: renderUnzonedRange,
            // Duration object that denotes the first visible time of any given day
            minTime: minTime,
            // Duration object that denotes the exclusive visible end time of any given day
            maxTime: maxTime,
            isValid: isValid,
            date: date,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
            // pass a fallback (might be null) ^
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function () {
        return this._view.getUnzonedRangeOption('validRange', this._view.calendar.getNow()) ||
            new UnzonedRange_1.default(); // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
        var viewSpec = this._view.viewSpec;
        var duration = null;
        var unit = null;
        var unzonedRange = null;
        var dayCount;
        if (viewSpec.duration) {
            duration = viewSpec.duration;
            unit = viewSpec.durationUnit;
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        else if ((dayCount = this.opt('dayCount'))) {
            unit = 'day';
            unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
        }
        else if ((unzonedRange = this.buildCustomVisibleRange(date))) {
            unit = util_1.computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
        }
        else {
            duration = this.getFallbackDuration();
            unit = util_1.computeGreatestUnit(duration);
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return { duration: duration, unit: unit, unzonedRange: unzonedRange };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function () {
        return moment.duration({ days: 1 });
    };
    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
    // minTime or maxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function (unzonedRange, minTime, maxTime) {
        var start = unzonedRange.getStart();
        var end = unzonedRange.getEnd();
        if (this._view.usesMinMaxTime) {
            if (minTime < 0) {
                start.time(0).add(minTime);
            }
            if (maxTime > 24 * 60 * 60 * 1000) {
                end.time(maxTime - (24 * 60 * 60 * 1000));
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed computeGreatestUnit value of duration.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
        var alignment = this.opt('dateAlignment');
        var dateIncrementInput;
        var dateIncrementDuration;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!alignment) {
            dateIncrementInput = this.opt('dateIncrement');
            if (dateIncrementInput) {
                dateIncrementDuration = moment.duration(dateIncrementInput);
                // use the smaller of the two units
                if (dateIncrementDuration < duration) {
                    alignment = util_1.computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
                }
                else {
                    alignment = unit;
                }
            }
            else {
                alignment = unit;
            }
        }
        // if the view displays a single day or smaller
        if (duration.as('days') <= 1) {
            if (this._view.isHiddenDay(start)) {
                start = this._view.skipHiddenDays(start, direction);
                start.startOf('day');
            }
        }
        function computeRes() {
            start = date.clone().startOf(alignment);
            end = start.clone().add(duration);
            res = new UnzonedRange_1.default(start, end);
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this._view.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
        var customAlignment = this.opt('dateAlignment');
        var runningCount = 0;
        var start = date.clone();
        var end;
        if (customAlignment) {
            start.startOf(customAlignment);
        }
        start.startOf('day');
        start = this._view.skipHiddenDays(start, direction);
        end = start.clone();
        do {
            end.add(1, 'day');
            if (!this._view.isHiddenDay(end)) {
                runningCount++;
            }
        } while (runningCount < dayCount);
        return new UnzonedRange_1.default(start, end);
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
        var visibleUnzonedRange = this._view.getUnzonedRangeOption('visibleRange', this._view.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
        );
        if (visibleUnzonedRange && (visibleUnzonedRange.startMs == null || visibleUnzonedRange.endMs == null)) {
            return null;
        }
        return visibleUnzonedRange;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        return currentUnzonedRange.clone();
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
        var dateIncrementInput = this.opt('dateIncrement');
        var customAlignment;
        if (dateIncrementInput) {
            return moment.duration(dateIncrementInput);
        }
        else if ((customAlignment = this.opt('dateAlignment'))) {
            return moment.duration(1, customAlignment);
        }
        else if (fallback) {
            return fallback;
        }
        else {
            return moment.duration({ days: 1 });
        }
    };
    return DateProfileGenerator;
}());
exports.default = DateProfileGenerator;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var exportHooks = __webpack_require__(16);
var util_1 = __webpack_require__(4);
var moment_ext_1 = __webpack_require__(10);
var ListenerMixin_1 = __webpack_require__(7);
var HitDragListener_1 = __webpack_require__(22);
var SingleEventDef_1 = __webpack_require__(13);
var EventInstanceGroup_1 = __webpack_require__(18);
var EventSource_1 = __webpack_require__(6);
var Interaction_1 = __webpack_require__(15);
var ExternalDropping = /** @class */ (function (_super) {
    tslib_1.__extends(ExternalDropping, _super);
    function ExternalDropping() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDragging = false; // jqui-dragging an external element? boolean
        return _this;
    }
    /*
    component impements:
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - isExternalInstanceGroupAllowed
      - renderDrag
      - unrenderDrag
    */
    ExternalDropping.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    ExternalDropping.prototype.bindToDocument = function () {
        this.listenTo($(document), {
            dragstart: this.handleDragStart,
            sortstart: this.handleDragStart // jqui
        });
    };
    ExternalDropping.prototype.unbindFromDocument = function () {
        this.stopListeningTo($(document));
    };
    // Called when a jQuery UI drag is initiated anywhere in the DOM
    ExternalDropping.prototype.handleDragStart = function (ev, ui) {
        var el;
        var accept;
        if (this.opt('droppable')) {
            el = $((ui ? ui.item : null) || ev.target);
            // Test that the dragged element passes the dropAccept selector or filter function.
            // FYI, the default is "*" (matches all)
            accept = this.opt('dropAccept');
            if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
                if (!this.isDragging) {
                    this.listenToExternalDrag(el, ev, ui);
                }
            }
        }
    };
    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
    ExternalDropping.prototype.listenToExternalDrag = function (el, ev, ui) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
        var singleEventDef; // a null value signals an unsuccessful drag
        // listener that tracks mouse movement over date-associated pixel regions
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            interactionStart: function () {
                _this.isDragging = true;
            },
            hitOver: function (hit) {
                var isAllowed = true;
                var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid
                var mutatedEventInstanceGroup;
                if (hitFootprint) {
                    singleEventDef = _this.computeExternalDrop(hitFootprint, meta);
                    if (singleEventDef) {
                        mutatedEventInstanceGroup = new EventInstanceGroup_1.default(singleEventDef.buildInstances());
                        isAllowed = meta.eventProps ? // isEvent?
                            component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) :
                            component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    singleEventDef = null;
                    util_1.disableCursor();
                }
                if (singleEventDef) {
                    component.renderDrag(// called without a seg parameter
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
                }
            },
            hitOut: function () {
                singleEventDef = null; // signal unsuccessful
            },
            hitDone: function () {
                util_1.enableCursor();
                component.unrenderDrag();
            },
            interactionEnd: function (ev) {
                if (singleEventDef) {
                    view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
                    Boolean(meta.stick), // isSticky
                    el, ev, ui);
                }
                _this.isDragging = false;
                _this.dragListener = null;
            }
        });
        dragListener.startDrag(ev); // start listening immediately
    };
    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
    // Returning a null value signals an invalid drop hit.
    // DOES NOT consider overlap/constraint.
    // Assumes both footprints are non-open-ended.
    ExternalDropping.prototype.computeExternalDrop = function (componentFootprint, meta) {
        var calendar = this.view.calendar;
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs).stripZone();
        var end;
        var eventDef;
        if (componentFootprint.isAllDay) {
            // if dropped on an all-day span, and element's metadata specified a time, set it
            if (meta.startTime) {
                start.time(meta.startTime);
            }
            else {
                start.stripTime();
            }
        }
        if (meta.duration) {
            end = start.clone().add(meta.duration);
        }
        start = calendar.applyTimezone(start);
        if (end) {
            end = calendar.applyTimezone(end);
        }
        eventDef = SingleEventDef_1.default.parse($.extend({}, meta.eventProps, {
            start: start,
            end: end
        }), new EventSource_1.default(calendar));
        return eventDef;
    };
    return ExternalDropping;
}(Interaction_1.default));
exports.default = ExternalDropping;
ListenerMixin_1.default.mixInto(ExternalDropping);
/* External-Dragging-Element Data
----------------------------------------------------------------------------------------------------------------------*/
// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
exportHooks.dataAttrPrefix = '';
// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
// to be used for Event Object creation.
// A defined `.eventProps`, even when empty, indicates that an event should be created.
function getDraggedElMeta(el) {
    var prefix = exportHooks.dataAttrPrefix;
    var eventProps; // properties for creating the event, not related to date/time
    var startTime; // a Duration
    var duration;
    var stick;
    if (prefix) {
        prefix += '-';
    }
    eventProps = el.data(prefix + 'event') || null;
    if (eventProps) {
        if (typeof eventProps === 'object') {
            eventProps = $.extend({}, eventProps); // make a copy
        }
        else {
            eventProps = {};
        }
        // pluck special-cased date/time properties
        startTime = eventProps.start;
        if (startTime == null) {
            startTime = eventProps.time;
        } // accept 'time' as well
        duration = eventProps.duration;
        stick = eventProps.stick;
        delete eventProps.start;
        delete eventProps.time;
        delete eventProps.duration;
        delete eventProps.stick;
    }
    // fallback to standalone attribute values for each of the date/time properties
    if (startTime == null) {
        startTime = el.data(prefix + 'start');
    }
    if (startTime == null) {
        startTime = el.data(prefix + 'time');
    } // accept 'time' as well
    if (duration == null) {
        duration = el.data(prefix + 'duration');
    }
    if (stick == null) {
        stick = el.data(prefix + 'stick');
    }
    // massage into correct data types
    startTime = startTime != null ? moment.duration(startTime) : null;
    duration = duration != null ? moment.duration(duration) : null;
    stick = Boolean(stick);
    return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(36);
var EventDefDateMutation_1 = __webpack_require__(50);
var HitDragListener_1 = __webpack_require__(22);
var Interaction_1 = __webpack_require__(15);
var EventResizing = /** @class */ (function (_super) {
    tslib_1.__extends(EventResizing, _super);
    /*
    component impements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - getSafeHitFootprint
    */
    function EventResizing(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isResizing = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventResizing.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventResizing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMouseDown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventResizing.prototype.handleMouseDown = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
                .startInteraction(ev, { distance: 5 });
        }
    };
    EventResizing.prototype.handleTouchStart = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
                .startInteraction(ev);
        }
    };
    // Creates a listener that tracks the user as they resize an event segment.
    // Generic enough to work with any type of Grid.
    EventResizing.prototype.buildDragListener = function (seg, isStart) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance;
        var isDragging;
        var resizeMutation; // zoned event date properties. falsy if invalid resize
        // Tracks mouse movement over the *grid's* coordinate map
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            interactionStart: function () {
                isDragging = false;
            },
            dragStart: function (ev) {
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segResizeStart(seg, ev);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origHitFootprint = component.getSafeHitFootprint(origHit);
                var hitFootprint = component.getSafeHitFootprint(hit);
                var mutatedEventInstanceGroup;
                if (origHitFootprint && hitFootprint) {
                    resizeMutation = isStart ?
                        _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) :
                        _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);
                    if (resizeMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    resizeMutation = null;
                    util_1.disableCursor();
                }
                else if (resizeMutation.isEmpty()) {
                    // no change. (FYI, event dates might have zones)
                    resizeMutation = null;
                }
                if (resizeMutation) {
                    view.hideEventsWithId(seg.footprint.eventDef.id);
                    view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
                }
            },
            hitOut: function () {
                resizeMutation = null;
            },
            hitDone: function () {
                view.unrenderEventResize(seg);
                view.showEventsWithId(seg.footprint.eventDef.id);
                util_1.enableCursor();
            },
            interactionEnd: function (ev) {
                if (isDragging) {
                    _this.segResizeStop(seg, ev);
                }
                if (resizeMutation) {
                    // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                    view.reportEventResize(eventInstance, resizeMutation, el, ev);
                }
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment resizing starts
    EventResizing.prototype.segResizeStart = function (seg, ev) {
        this.isResizing = true;
        this.component.publiclyTrigger('eventResizeStart', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment resizing stops
    EventResizing.prototype.segResizeStop = function (seg, ev) {
        this.isResizing = false;
        this.component.publiclyTrigger('eventResizeStop', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Returns new date-information for an event segment being resized from its start
    EventResizing.prototype.computeEventStartResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setStartDelta(startDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    // Returns new date-information for an event segment being resized from its end
    EventResizing.prototype.computeEventEndResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setEndDelta(endDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    return EventResizing;
}(Interaction_1.default));
exports.default = EventResizing;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(36);
var EventDefDateMutation_1 = __webpack_require__(50);
var DragListener_1 = __webpack_require__(54);
var HitDragListener_1 = __webpack_require__(22);
var MouseFollower_1 = __webpack_require__(244);
var Interaction_1 = __webpack_require__(15);
var EventDragging = /** @class */ (function (_super) {
    tslib_1.__extends(EventDragging, _super);
    /*
    component implements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
    */
    function EventDragging(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isDragging = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventDragging.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventDragging.prototype.getSelectionDelay = function () {
        var delay = this.opt('eventLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    EventDragging.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMousedown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventDragging.prototype.handleMousedown = function (seg, ev) {
        if (!this.component.shouldIgnoreMouse() &&
            this.component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, { distance: 5 });
        }
    };
    EventDragging.prototype.handleTouchStart = function (seg, ev) {
        var component = this.component;
        var settings = {
            delay: this.view.isEventDefSelected(seg.footprint.eventDef) ? // already selected?
                0 : this.getSelectionDelay()
        };
        if (component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, settings);
        }
        else if (component.canStartSelection(seg, ev)) {
            this.buildSelectListener(seg).startInteraction(ev, settings);
        }
    };
    // seg isn't draggable, but let's use a generic DragListener
    // simply for the delay, so it can be selected.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildSelectListener = function (seg) {
        var _this = this;
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        if (this.dragListener) {
            return this.dragListener;
        }
        var dragListener = this.dragListener = new DragListener_1.default({
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
            },
            interactionEnd: function (ev) {
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Builds a listener that will track user-dragging on an event segment.
    // Generic enough to work with any type of Grid.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildDragListener = function (seg) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        var isDragging;
        var mouseFollower; // A clone of the original element that will move with the mouse
        var eventDefMutation;
        if (this.dragListener) {
            return this.dragListener;
        }
        // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
        // of the view.
        var dragListener = this.dragListener = new HitDragListener_1.default(view, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            subjectCenter: true,
            interactionStart: function (ev) {
                seg.component = component; // for renderDrag
                isDragging = false;
                mouseFollower = new MouseFollower_1.default(seg.el, {
                    additionalClass: 'fc-dragging',
                    parentEl: view.el,
                    opacity: dragListener.isTouch ? null : _this.opt('dragOpacity'),
                    revertDuration: _this.opt('dragRevertDuration'),
                    zIndex: 2 // one above the .fc-view
                });
                mouseFollower.hide(); // don't show until we know this is a real drag
                mouseFollower.start(ev);
            },
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segDragStart(seg, ev);
                view.hideEventsWithId(seg.footprint.eventDef.id);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origFootprint;
                var footprint;
                var mutatedEventInstanceGroup;
                // starting hit could be forced (DayGrid.limit)
                if (seg.hit) {
                    origHit = seg.hit;
                }
                // hit might not belong to this grid, so query origin grid
                origFootprint = origHit.component.getSafeHitFootprint(origHit);
                footprint = hit.component.getSafeHitFootprint(hit);
                if (origFootprint && footprint) {
                    eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);
                    if (eventDefMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    eventDefMutation = null;
                    util_1.disableCursor();
                }
                // if a valid drop location, have the subclass render a visual indication
                if (eventDefMutation &&
                    view.renderDrag(// truthy if rendered something
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
                    mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
                }
                else {
                    mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
                }
                if (isOrig) {
                    // needs to have moved hits to be a valid drop
                    eventDefMutation = null;
                }
            },
            hitOut: function () {
                view.unrenderDrag(seg); // unrender whatever was done in renderDrag
                mouseFollower.show(); // show in case we are moving out of all hits
                eventDefMutation = null;
            },
            hitDone: function () {
                util_1.enableCursor();
            },
            interactionEnd: function (ev) {
                delete seg.component; // prevent side effects
                // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
                mouseFollower.stop(!eventDefMutation, function () {
                    if (isDragging) {
                        view.unrenderDrag(seg);
                        _this.segDragStop(seg, ev);
                    }
                    view.showEventsWithId(seg.footprint.eventDef.id);
                    if (eventDefMutation) {
                        // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                        view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
                    }
                });
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment dragging starts
    EventDragging.prototype.segDragStart = function (seg, ev) {
        this.isDragging = true;
        this.component.publiclyTrigger('eventDragStart', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment dragging stops
    EventDragging.prototype.segDragStop = function (seg, ev) {
        this.isDragging = false;
        this.component.publiclyTrigger('eventDragStop', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // DOES NOT consider overlap/constraint
    EventDragging.prototype.computeEventDropMutation = function (startFootprint, endFootprint, eventDef) {
        var eventDefMutation = new EventDefMutation_1.default();
        eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
        return eventDefMutation;
    };
    EventDragging.prototype.computeEventDateMutation = function (startFootprint, endFootprint) {
        var date0 = startFootprint.unzonedRange.getStart();
        var date1 = endFootprint.unzonedRange.getStart();
        var clearEnd = false;
        var forceTimed = false;
        var forceAllDay = false;
        var dateDelta;
        var dateMutation;
        if (startFootprint.isAllDay !== endFootprint.isAllDay) {
            clearEnd = true;
            if (endFootprint.isAllDay) {
                forceAllDay = true;
                date0.stripTime();
            }
            else {
                forceTimed = true;
            }
        }
        dateDelta = this.component.diffDates(date1, date0);
        dateMutation = new EventDefDateMutation_1.default();
        dateMutation.clearEnd = clearEnd;
        dateMutation.forceTimed = forceTimed;
        dateMutation.forceAllDay = forceAllDay;
        dateMutation.setDateDelta(dateDelta);
        return dateMutation;
    };
    return EventDragging;
}(Interaction_1.default));
exports.default = EventDragging;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var HitDragListener_1 = __webpack_require__(22);
var ComponentFootprint_1 = __webpack_require__(12);
var UnzonedRange_1 = __webpack_require__(5);
var Interaction_1 = __webpack_require__(15);
var DateSelecting = /** @class */ (function (_super) {
    tslib_1.__extends(DateSelecting, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - renderHighlight
      - unrenderHighlight
    */
    function DateSelecting(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateSelecting.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateSelecting.prototype.getDelay = function () {
        var delay = this.opt('selectLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    DateSelecting.prototype.bindToEl = function (el) {
        var _this = this;
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev, {
                    distance: _this.opt('selectMinDistance')
                });
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev, {
                    delay: _this.getDelay()
                });
            }
        });
        util_1.preventSelection(el);
    };
    // Creates a listener that tracks the user's drag across day elements, for day selecting.
    DateSelecting.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var selectionFootprint; // null if invalid selection
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                selectionFootprint = null;
            },
            dragStart: function (ev) {
                _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one
            },
            hitOver: function (hit, isOrig, origHit) {
                var origHitFootprint;
                var hitFootprint;
                if (origHit) {
                    origHitFootprint = component.getSafeHitFootprint(origHit);
                    hitFootprint = component.getSafeHitFootprint(hit);
                    if (origHitFootprint && hitFootprint) {
                        selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
                    }
                    else {
                        selectionFootprint = null;
                    }
                    if (selectionFootprint) {
                        component.renderSelectionFootprint(selectionFootprint);
                    }
                    else if (selectionFootprint === false) {
                        util_1.disableCursor();
                    }
                }
            },
            hitOut: function () {
                selectionFootprint = null;
                component.unrenderSelection();
            },
            hitDone: function () {
                util_1.enableCursor();
            },
            interactionEnd: function (ev, isCancelled) {
                if (!isCancelled && selectionFootprint) {
                    // the selection will already have been rendered. just report it
                    _this.view.reportSelection(selectionFootprint, ev);
                }
            }
        });
        return dragListener;
    };
    // Given the first and last date-spans of a selection, returns another date-span object.
    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
    // Will return false if the selection is invalid and this should be indicated to the user.
    // Will return null/undefined if a selection invalid but no error should be reported.
    DateSelecting.prototype.computeSelection = function (footprint0, footprint1) {
        var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);
        if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
            return false;
        }
        return wholeFootprint;
    };
    // Given two spans, must return the combination of the two.
    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
    // Assumes both footprints are non-open-ended.
    DateSelecting.prototype.computeSelectionFootprint = function (footprint0, footprint1) {
        var ms = [
            footprint0.unzonedRange.startMs,
            footprint0.unzonedRange.endMs,
            footprint1.unzonedRange.startMs,
            footprint1.unzonedRange.endMs
        ];
        ms.sort(util_1.compareNumbers);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(ms[0], ms[3]), footprint0.isAllDay);
    };
    DateSelecting.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) &&
            this.view.calendar.constraints.isSelectionFootprintAllowed(componentFootprint);
    };
    return DateSelecting;
}(Interaction_1.default));
exports.default = DateSelecting;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(39);
var View_1 = __webpack_require__(41);
var TimeGrid_1 = __webpack_require__(227);
var DayGrid_1 = __webpack_require__(61);
var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
var agendaTimeGridMethods;
var agendaDayGridMethods;
/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
----------------------------------------------------------------------------------------------------------------------*/
// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
// Responsible for managing width/height.
var AgendaView = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaView, _super);
    function AgendaView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.usesMinMaxTime = true; // indicates that minTime/maxTime affects rendering
        _this.timeGrid = _this.instantiateTimeGrid();
        _this.addChild(_this.timeGrid);
        if (_this.opt('allDaySlot')) {
            _this.dayGrid = _this.instantiateDayGrid(); // the all-day subcomponent of this view
            _this.addChild(_this.dayGrid);
        }
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
    AgendaView.prototype.instantiateTimeGrid = function () {
        var timeGrid = new this.timeGridClass(this);
        util_1.copyOwnProps(agendaTimeGridMethods, timeGrid);
        return timeGrid;
    };
    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
    AgendaView.prototype.instantiateDayGrid = function () {
        var dayGrid = new this.dayGridClass(this);
        util_1.copyOwnProps(agendaDayGridMethods, dayGrid);
        return dayGrid;
    };
    /* Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.renderSkeleton = function () {
        var timeGridWrapEl;
        var timeGridEl;
        this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
        this.scroller.render();
        timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
        timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
        this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
        this.timeGrid.headContainerEl = this.el.find('.fc-head-container');
        this.timeGrid.setElement(timeGridEl);
        if (this.dayGrid) {
            this.dayGrid.setElement(this.el.find('.fc-day-grid'));
            // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
            this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
        }
    };
    AgendaView.prototype.unrenderSkeleton = function () {
        this.timeGrid.removeElement();
        if (this.dayGrid) {
            this.dayGrid.removeElement();
        }
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid and time-grid components will render inside containers defined by this HTML.
    AgendaView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '">' +
            (this.dayGrid ?
                '<div class="fc-day-grid"/>' +
                    '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '"/>' :
                '') +
            '</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the axis, if it is known
    AgendaView.prototype.axisStyleAttr = function () {
        if (this.axisWidth != null) {
            return 'style="width:' + this.axisWidth + 'px"';
        }
        return '';
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.getNowIndicatorUnit = function () {
        return this.timeGrid.getNowIndicatorUnit();
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Adjusts the vertical dimensions of the view to the specified values
    AgendaView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var eventLimit;
        var scrollerHeight;
        var scrollbarWidths;
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        // make all axis cells line up, and record the width so newly created axis cells will have it
        this.axisWidth = util_1.matchCellWidths(this.el.find('.fc-axis'));
        // hack to give the view some height prior to timeGrid's columns being rendered
        // TODO: separate setting height from scroller VS timeGrid.
        if (!this.timeGrid.colEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        // set of fake row elements that must compensate when scroller has scrollbars
        var noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)');
        // reset all dimensions back to the original state
        this.timeGrid.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
        this.scroller.clear(); // sets height to 'auto' and clears overflow
        util_1.uncompensateScroll(noScrollRowEls);
        // limit number of events in the all-day area
        if (this.dayGrid) {
            this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
            eventLimit = this.opt('eventLimit');
            if (eventLimit && typeof eventLimit !== 'number') {
                eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
            }
            if (eventLimit) {
                this.dayGrid.limitRows(eventLimit);
            }
        }
        if (!isAuto) {
            scrollerHeight = this.computeScrollerHeight(totalHeight);
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) {
                // make the all-day and header rows lines up
                util_1.compensateScroll(noScrollRowEls, scrollbarWidths);
                // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
                // and reapply the desired height to the scroller.
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
            // if there's any space below the slats, show the horizontal rule.
            // this won't cause any new overflow, because lockOverflow already called.
            if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
                this.timeGrid.bottomRuleEl.show();
            }
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    AgendaView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes the initial pre-configured scroll state prior to allowing the user to change it
    AgendaView.prototype.computeInitialDateScroll = function () {
        var scrollTime = moment.duration(this.opt('scrollTime'));
        var top = this.timeGrid.computeTimeTop(scrollTime);
        // zoom can give weird floating-point values. rather scroll a little bit further
        top = Math.ceil(top);
        if (top) {
            top++; // to overcome top border that slots beyond the first have. looks better
        }
        return { top: top };
    };
    AgendaView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    AgendaView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    /* Hit Areas
    ------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to the grids (dayGrid might not be defined)
    AgendaView.prototype.getHitFootprint = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitFootprint(hit);
    };
    AgendaView.prototype.getHitEl = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitEl(hit);
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.executeEventRender = function (eventsPayload) {
        var dayEventsPayload = {};
        var timedEventsPayload = {};
        var id;
        var eventInstanceGroup;
        // separate the events into all-day and timed
        for (id in eventsPayload) {
            eventInstanceGroup = eventsPayload[id];
            if (eventInstanceGroup.getEventDef().isAllDay()) {
                dayEventsPayload[id] = eventInstanceGroup;
            }
            else {
                timedEventsPayload[id] = eventInstanceGroup;
            }
        }
        this.timeGrid.executeEventRender(timedEventsPayload);
        if (this.dayGrid) {
            this.dayGrid.executeEventRender(dayEventsPayload);
        }
    };
    /* Dragging/Resizing Routing
    ------------------------------------------------------------------------------------------------------------------*/
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    AgendaView.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        var renderedHelper = false;
        renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
        }
        return renderedHelper;
    };
    AgendaView.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        this.timeGrid.renderEventResize(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
        }
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection
    AgendaView.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (!componentFootprint.isAllDay) {
            this.timeGrid.renderSelectionFootprint(componentFootprint);
        }
        else if (this.dayGrid) {
            this.dayGrid.renderSelectionFootprint(componentFootprint);
        }
    };
    return AgendaView;
}(View_1.default));
exports.default = AgendaView;
AgendaView.prototype.timeGridClass = TimeGrid_1.default;
AgendaView.prototype.dayGridClass = DayGrid_1.default;
// Will customize the rendering behavior of the AgendaView's timeGrid
agendaTimeGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function () {
        var view = this.view;
        var calendar = view.calendar;
        var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
        var weekText;
        if (this.opt('weekNumbers')) {
            weekText = weekStart.format(this.opt('smallWeekFormat'));
            return '' +
                '<th class="fc-axis fc-week-number ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '>' +
                view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                { date: weekStart, type: 'week', forceOff: this.colCnt > 1 }, util_1.htmlEscape(weekText) // inner HTML
                ) +
                '</th>';
        }
        else {
            return '<th class="fc-axis ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '></th>';
        }
    },
    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
    renderBgIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '></td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
// Will customize the rendering behavior of the AgendaView's dayGrid
agendaDayGridMethods = {
    // Generates the HTML that goes before the all-day cells
    renderBgIntroHtml: function () {
        var view = this.view;
        return '' +
            '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
            '<span>' + // needed for matchCellWidths
            view.getAllDayHtml() +
            '</span>' +
            '</td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
function groupEventFootprintsByAllDay(eventFootprints) {
    var allDay = [];
    var timed = [];
    var i;
    for (i = 0; i < eventFootprints.length; i++) {
        if (eventFootprints[i].componentFootprint.isAllDay) {
            allDay.push(eventFootprints[i]);
        }
        else {
            timed.push(eventFootprints[i]);
        }
    }
    return { allDay: allDay, timed: timed };
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var InteractiveDateComponent_1 = __webpack_require__(40);
var BusinessHourRenderer_1 = __webpack_require__(56);
var StandardInteractionsMixin_1 = __webpack_require__(60);
var DayTableMixin_1 = __webpack_require__(55);
var CoordCache_1 = __webpack_require__(53);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var TimeGridEventRenderer_1 = __webpack_require__(246);
var TimeGridHelperRenderer_1 = __webpack_require__(247);
var TimeGridFillRenderer_1 = __webpack_require__(248);
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
// We mixin DayTable, even though there is only a single row of days
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var AGENDA_STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 }
];
var TimeGrid = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGrid, _super);
    function TimeGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.processOptions();
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    TimeGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
        var i;
        for (i = 0; i < segs.length; i++) {
            if (this.isRTL) {
                segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
            }
            else {
                segs[i].col = segs[i].dayIndex;
            }
        }
        return segs;
    };
    /* Date Handling
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.sliceRangeByTimes = function (unzonedRange) {
        var segs = [];
        var segRange;
        var dayIndex;
        for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
            segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);
            if (segRange) {
                segs.push({
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                });
            }
        }
        return segs;
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Parses various options into properties of this object
    TimeGrid.prototype.processOptions = function () {
        var slotDuration = this.opt('slotDuration');
        var snapDuration = this.opt('snapDuration');
        var input;
        slotDuration = moment.duration(slotDuration);
        snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
        this.slotDuration = slotDuration;
        this.snapDuration = snapDuration;
        this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
        // might be an array value (for TimelineView).
        // if so, getting the most granular entry (the last one probably).
        input = this.opt('slotLabelFormat');
        if ($.isArray(input)) {
            input = input[input.length - 1];
        }
        this.labelFormat = input ||
            this.opt('smallTimeFormat'); // the computed default
        input = this.opt('slotLabelInterval');
        this.labelInterval = input ?
            moment.duration(input) :
            this.computeLabelInterval(slotDuration);
    };
    // Computes an automatic value for slotLabelInterval
    TimeGrid.prototype.computeLabelInterval = function (slotDuration) {
        var i;
        var labelInterval;
        var slotsPerLabel;
        // find the smallest stock label interval that results in more than one slots-per-label
        for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
            labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
            slotsPerLabel = util_1.divideDurationByDuration(labelInterval, slotDuration);
            if (util_1.isInt(slotsPerLabel) && slotsPerLabel > 1) {
                return labelInterval;
            }
        }
        return moment.duration(slotDuration); // fall back. clone
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderSlats();
        this.renderColumns();
    };
    TimeGrid.prototype.unrenderDates = function () {
        // this.unrenderSlats(); // don't need this because repeated .html() calls clear
        this.unrenderColumns();
    };
    TimeGrid.prototype.renderSkeleton = function () {
        var theme = this.view.calendar.theme;
        this.el.html('<div class="fc-bg"></div>' +
            '<div class="fc-slats"></div>' +
            '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" style="display:none" />');
        this.bottomRuleEl = this.el.find('hr');
    };
    TimeGrid.prototype.renderSlats = function () {
        var theme = this.view.calendar.theme;
        this.slatContainerEl = this.el.find('> .fc-slats')
            .html(// avoids needing ::unrenderSlats()
        '<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderSlatRowHtml() +
            '</table>');
        this.slatEls = this.slatContainerEl.find('tr');
        this.slatCoordCache = new CoordCache_1.default({
            els: this.slatEls,
            isVertical: true
        });
    };
    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
    TimeGrid.prototype.renderSlatRowHtml = function () {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var isRTL = this.isRTL;
        var dateProfile = this.dateProfile;
        var html = '';
        var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations
        var slotIterator = moment.duration(0);
        var slotDate; // will be on the view's first day, but we only care about its time
        var isLabeled;
        var axisHtml;
        // Calculate the time for each slot
        while (slotTime < dateProfile.maxTime) {
            slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
            isLabeled = util_1.isInt(util_1.divideDurationByDuration(slotIterator, this.labelInterval));
            axisHtml =
                '<td class="fc-axis fc-time ' + theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
                    (isLabeled ?
                        '<span>' + // for matchCellWidths
                            util_1.htmlEscape(slotDate.format(this.labelFormat)) +
                            '</span>' :
                        '') +
                    '</td>';
            html +=
                '<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
                    (isLabeled ? '' : ' class="fc-minor"') +
                    '>' +
                    (!isRTL ? axisHtml : '') +
                    '<td class="' + theme.getClass('widgetContent') + '"/>' +
                    (isRTL ? axisHtml : '') +
                    '</tr>';
            slotTime.add(this.slotDuration);
            slotIterator.add(this.slotDuration);
        }
        return html;
    };
    TimeGrid.prototype.renderColumns = function () {
        var dateProfile = this.dateProfile;
        var theme = this.view.calendar.theme;
        this.dayRanges = this.dayDates.map(function (dayDate) {
            return new UnzonedRange_1.default(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
        });
        if (this.headContainerEl) {
            this.headContainerEl.html(this.renderHeadHtml());
        }
        this.el.find('> .fc-bg').html('<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderBgTrHtml(0) + // row=0
            '</table>');
        this.colEls = this.el.find('.fc-day, .fc-disabled-day');
        this.colCoordCache = new CoordCache_1.default({
            els: this.colEls,
            isHorizontal: true
        });
        this.renderContentSkeleton();
    };
    TimeGrid.prototype.unrenderColumns = function () {
        this.unrenderContentSkeleton();
    };
    /* Content Skeleton
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders the DOM that the view's content will live in
    TimeGrid.prototype.renderContentSkeleton = function () {
        var cellHtml = '';
        var i;
        var skeletonEl;
        for (i = 0; i < this.colCnt; i++) {
            cellHtml +=
                '<td>' +
                    '<div class="fc-content-col">' +
                    '<div class="fc-event-container fc-helper-container"></div>' +
                    '<div class="fc-event-container"></div>' +
                    '<div class="fc-highlight-container"></div>' +
                    '<div class="fc-bgevent-container"></div>' +
                    '<div class="fc-business-container"></div>' +
                    '</div>' +
                    '</td>';
        }
        skeletonEl = this.contentSkeletonEl = $('<div class="fc-content-skeleton">' +
            '<table>' +
            '<tr>' + cellHtml + '</tr>' +
            '</table>' +
            '</div>');
        this.colContainerEls = skeletonEl.find('.fc-content-col');
        this.helperContainerEls = skeletonEl.find('.fc-helper-container');
        this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
        this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
        this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
        this.businessContainerEls = skeletonEl.find('.fc-business-container');
        this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
        this.el.append(skeletonEl);
    };
    TimeGrid.prototype.unrenderContentSkeleton = function () {
        if (this.contentSkeletonEl) {
            this.contentSkeletonEl.remove();
            this.contentSkeletonEl = null;
            this.colContainerEls = null;
            this.helperContainerEls = null;
            this.fgContainerEls = null;
            this.bgContainerEls = null;
            this.highlightContainerEls = null;
            this.businessContainerEls = null;
        }
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
    TimeGrid.prototype.groupSegsByCol = function (segs) {
        var segsByCol = [];
        var i;
        for (i = 0; i < this.colCnt; i++) {
            segsByCol.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segsByCol[segs[i].col].push(segs[i]);
        }
        return segsByCol;
    };
    // Given segments grouped by column, insert the segments' elements into a parallel array of container
    // elements, each living within a column.
    TimeGrid.prototype.attachSegsByCol = function (segsByCol, containerEls) {
        var col;
        var segs;
        var i;
        for (col = 0; col < this.colCnt; col++) {
            segs = segsByCol[col];
            for (i = 0; i < segs.length; i++) {
                containerEls.eq(col).append(segs[i].el);
            }
        }
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.getNowIndicatorUnit = function () {
        return 'minute'; // will refresh on the minute
    };
    TimeGrid.prototype.renderNowIndicator = function (date) {
        // HACK: if date columns not ready for some reason (scheduler)
        if (!this.colContainerEls) {
            return;
        }
        // seg system might be overkill, but it handles scenario where line needs to be rendered
        //  more than once because of columns with the same date (resources columns for example)
        var segs = this.componentFootprintToSegs(new ComponentFootprint_1.default(new UnzonedRange_1.default(date, date.valueOf() + 1), // protect against null range
        false // all-day
        ));
        var top = this.computeDateTop(date, date);
        var nodes = [];
        var i;
        // render lines within the columns
        for (i = 0; i < segs.length; i++) {
            nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
                .css('top', top)
                .appendTo(this.colContainerEls.eq(segs[i].col))[0]);
        }
        // render an arrow over the axis
        if (segs.length > 0) {
            nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
                .css('top', top)
                .appendTo(this.el.find('.fc-content-skeleton'))[0]);
        }
        this.nowIndicatorEls = $(nodes);
    };
    TimeGrid.prototype.unrenderNowIndicator = function () {
        if (this.nowIndicatorEls) {
            this.nowIndicatorEls.remove();
            this.nowIndicatorEls = null;
        }
    };
    /* Coordinates
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        this.slatCoordCache.build();
        if (isResize) {
            this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
        }
    };
    TimeGrid.prototype.getTotalSlatHeight = function () {
        return this.slatContainerEl.outerHeight();
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // `ms` can be a millisecond UTC time OR a UTC moment.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeGrid.prototype.computeDateTop = function (ms, startOfDayDate) {
        return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    TimeGrid.prototype.computeTimeTop = function (time) {
        var len = this.slatEls.length;
        var dateProfile = this.dateProfile;
        var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because minTime/maxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return this.slatCoordCache.getTopPosition(slatIndex) +
            this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
    };
    // Refreshes the CSS top/bottom coordinates for each segment element.
    // Works when called after initial render, after a window resize/zoom for example.
    TimeGrid.prototype.updateSegVerticals = function (segs) {
        this.computeSegVerticals(segs);
        this.assignSegVerticals(segs);
    };
    // For each segment in an array, computes and assigns its top and bottom properties
    TimeGrid.prototype.computeSegVerticals = function (segs) {
        var eventMinHeight = this.opt('agendaEventMinHeight');
        var i;
        var seg;
        var dayDate;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            dayDate = this.dayDates[seg.dayIndex];
            seg.top = this.computeDateTop(seg.startMs, dayDate);
            seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
        }
    };
    // Given segments that already have their top/bottom properties computed, applies those values to
    // the segments' elements.
    TimeGrid.prototype.assignSegVerticals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            seg.el.css(this.generateSegVerticalCss(seg));
        }
    };
    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
    TimeGrid.prototype.generateSegVerticalCss = function (seg) {
        return {
            top: seg.top,
            bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
        };
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.slatCoordCache.build();
    };
    TimeGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
    };
    TimeGrid.prototype.queryHit = function (leftOffset, topOffset) {
        var snapsPerSlot = this.snapsPerSlot;
        var colCoordCache = this.colCoordCache;
        var slatCoordCache = this.slatCoordCache;
        if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
            var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
            var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
            if (colIndex != null && slatIndex != null) {
                var slatTop = slatCoordCache.getTopOffset(slatIndex);
                var slatHeight = slatCoordCache.getHeight(slatIndex);
                var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
                var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
                var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
                var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
                var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
                return {
                    col: colIndex,
                    snap: snapIndex,
                    component: this,
                    left: colCoordCache.getLeftOffset(colIndex),
                    right: colCoordCache.getRightOffset(colIndex),
                    top: snapTop,
                    bottom: snapBottom
                };
            }
        }
    };
    TimeGrid.prototype.getHitFootprint = function (hit) {
        var start = this.getCellDate(0, hit.col); // row=0
        var time = this.computeSnapTime(hit.snap); // pass in the snap-index
        var end;
        start.time(time);
        end = start.clone().add(this.snapDuration);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), false // all-day?
        );
    };
    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
    TimeGrid.prototype.computeSnapTime = function (snapIndex) {
        return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
    };
    TimeGrid.prototype.getHitEl = function (hit) {
        return this.colEls.eq(hit.col);
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being dragged over the specified date(s).
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    TimeGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        if (seg) {
            if (eventFootprints.length) {
                this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
                // signal that a helper has been rendered
                return true;
            }
        }
        else {
            for (i = 0; i < eventFootprints.length; i++) {
                this.renderHighlight(eventFootprints[i].componentFootprint);
            }
        }
    };
    // Unrenders any visual indication of an event being dragged
    TimeGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    TimeGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders any visual indication of an event being resized
    TimeGrid.prototype.unrenderEventResize = function () {
        this.helperRenderer.unrender();
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
    TimeGrid.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (this.opt('selectHelper')) {
            this.helperRenderer.renderComponentFootprint(componentFootprint);
        }
        else {
            this.renderHighlight(componentFootprint);
        }
    };
    // Unrenders any visual indication of a selection
    TimeGrid.prototype.unrenderSelection = function () {
        this.helperRenderer.unrender();
        this.unrenderHighlight();
    };
    return TimeGrid;
}(InteractiveDateComponent_1.default));
exports.default = TimeGrid;
TimeGrid.prototype.eventRendererClass = TimeGridEventRenderer_1.default;
TimeGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
TimeGrid.prototype.helperRendererClass = TimeGridHelperRenderer_1.default;
TimeGrid.prototype.fillRendererClass = TimeGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(TimeGrid);
DayTableMixin_1.default.mixInto(TimeGrid);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var UnzonedRange_1 = __webpack_require__(5);
var DateProfileGenerator_1 = __webpack_require__(221);
var BasicViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(BasicViewDateProfileGenerator, _super);
    function BasicViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    BasicViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay); // an UnzonedRange
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start.startOf('week');
            // make end-of-week if not already
            if (end.weekday()) {
                end.add(1, 'week').startOf('week'); // exclusively move backwards
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    return BasicViewDateProfileGenerator;
}(DateProfileGenerator_1.default));
exports.default = BasicViewDateProfileGenerator;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var BasicView_1 = __webpack_require__(62);
var MonthViewDateProfileGenerator_1 = __webpack_require__(253);
/* A month view with day cells running in rows (one-per-week) and columns
----------------------------------------------------------------------------------------------------------------------*/
var MonthView = /** @class */ (function (_super) {
    tslib_1.__extends(MonthView, _super);
    function MonthView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Overrides the default BasicView behavior to have special multi-week auto-height logic
    MonthView.prototype.setGridHeight = function (height, isAuto) {
        // if auto, make the height of each row the height that it would be if there were 6 weeks
        if (isAuto) {
            height *= this.dayGrid.rowCnt / 6;
        }
        util_1.distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
    };
    MonthView.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
    };
    return MonthView;
}(BasicView_1.default));
exports.default = MonthView;
MonthView.prototype.dateProfileGeneratorClass = MonthViewDateProfileGenerator_1.default;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var UnzonedRange_1 = __webpack_require__(5);
var View_1 = __webpack_require__(41);
var Scroller_1 = __webpack_require__(39);
var ListEventRenderer_1 = __webpack_require__(254);
var ListEventPointing_1 = __webpack_require__(255);
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/
var ListView = /** @class */ (function (_super) {
    tslib_1.__extends(ListView, _super);
    function ListView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.segSelector = '.fc-list-item'; // which elements accept event actions
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    ListView.prototype.renderSkeleton = function () {
        this.el.addClass('fc-list-view ' +
            this.calendar.theme.getClass('listView'));
        this.scroller.render();
        this.scroller.el.appendTo(this.el);
        this.contentEl = this.scroller.scrollEl; // shortcut
    };
    ListView.prototype.unrenderSkeleton = function () {
        this.scroller.destroy(); // will remove the Grid too
    };
    ListView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
    };
    ListView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    ListView.prototype.renderDates = function (dateProfile) {
        var calendar = this.calendar;
        var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
        var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
        var dayDates = [];
        var dayRanges = [];
        while (dayStart < viewEnd) {
            dayDates.push(dayStart.clone());
            dayRanges.push(new UnzonedRange_1.default(dayStart, dayStart.clone().add(1, 'day')));
            dayStart.add(1, 'day');
        }
        this.dayDates = dayDates;
        this.dayRanges = dayRanges;
        // all real rendering happens in EventRenderer
    };
    // slices by day
    ListView.prototype.componentFootprintToSegs = function (footprint) {
        var dayRanges = this.dayRanges;
        var dayIndex;
        var segRange;
        var seg;
        var segs = [];
        for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
            segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when footprint won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !footprint.isAllDay &&
                    dayIndex + 1 < dayRanges.length &&
                    footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
                    seg.endMs = footprint.unzonedRange.endMs;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    };
    ListView.prototype.renderEmptyMessage = function () {
        this.contentEl.html('<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
            '<div class="fc-list-empty-wrap1">' +
            '<div class="fc-list-empty">' +
            util_1.htmlEscape(this.opt('noEventsMessage')) +
            '</div>' +
            '</div>' +
            '</div>');
    };
    // render the event segments in the view
    ListView.prototype.renderSegList = function (allSegs) {
        var segsByDay = this.groupSegsByDay(allSegs); // sparse array
        var dayIndex;
        var daySegs;
        var i;
        var tableEl = $('<table class="fc-list-table ' + this.calendar.theme.getClass('tableList') + '"><tbody/></table>');
        var tbodyEl = tableEl.find('tbody');
        for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
            daySegs = segsByDay[dayIndex];
            if (daySegs) {
                // append a day header
                tbodyEl.append(this.dayHeaderHtml(this.dayDates[dayIndex]));
                this.eventRenderer.sortEventSegs(daySegs);
                for (i = 0; i < daySegs.length; i++) {
                    tbodyEl.append(daySegs[i].el); // append event row
                }
            }
        }
        this.contentEl.empty().append(tableEl);
    };
    // Returns a sparse array of arrays, segs grouped by their dayIndex
    ListView.prototype.groupSegsByDay = function (segs) {
        var segsByDay = []; // sparse array
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
                .push(seg);
        }
        return segsByDay;
    };
    // generates the HTML for the day headers that live amongst the event rows
    ListView.prototype.dayHeaderHtml = function (dayDate) {
        var mainFormat = this.opt('listDayFormat');
        var altFormat = this.opt('listDayAltFormat');
        return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
            '<td class="' + this.calendar.theme.getClass('widgetHeader') + '" colspan="3">' +
            (mainFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-main' }, util_1.htmlEscape(dayDate.format(mainFormat)) // inner HTML
                ) :
                '') +
            (altFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-alt' }, util_1.htmlEscape(dayDate.format(altFormat)) // inner HTML
                ) :
                '') +
            '</td>' +
            '</tr>';
    };
    return ListView;
}(View_1.default));
exports.default = ListView;
ListView.prototype.eventRendererClass = ListEventRenderer_1.default;
ListView.prototype.eventPointingClass = ListEventPointing_1.default;


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var exportHooks = __webpack_require__(16);
var util_1 = __webpack_require__(4);
var Calendar_1 = __webpack_require__(220);
// for intentional side-effects
__webpack_require__(10);
__webpack_require__(47);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
$.fullCalendar = exportHooks;
$.fn.fullCalendar = function (options) {
    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
    var res = this; // what this function will return (this jQuery object by default)
    this.each(function (i, _element) {
        var element = $(_element);
        var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
        var singleRes; // the returned value of this single method call
        // a method call
        if (typeof options === 'string') {
            if (options === 'getCalendar') {
                if (!i) {
                    res = calendar;
                }
            }
            else if (options === 'destroy') {
                if (calendar) {
                    calendar.destroy();
                    element.removeData('fullCalendar');
                }
            }
            else if (!calendar) {
                util_1.warn('Attempting to call a FullCalendar method on an element with no calendar.');
            }
            else if ($.isFunction(calendar[options])) {
                singleRes = calendar[options].apply(calendar, args);
                if (!i) {
                    res = singleRes; // record the first method call result
                }
                if (options === 'destroy') {
                    element.removeData('fullCalendar');
                }
            }
            else {
                util_1.warn("'" + options + "' is an unknown FullCalendar method.");
            }
        }
        else if (!calendar) {
            calendar = new Calendar_1.default(element, options);
            element.data('fullCalendar', calendar);
            calendar.render();
        }
    });
    return res;
};
module.exports = exportHooks;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Model_1 = __webpack_require__(48);
var Component = /** @class */ (function (_super) {
    tslib_1.__extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.setElement = function (el) {
        this.el = el;
        this.bindGlobalHandlers();
        this.renderSkeleton();
        this.set('isInDom', true);
    };
    Component.prototype.removeElement = function () {
        this.unset('isInDom');
        this.unrenderSkeleton();
        this.unbindGlobalHandlers();
        this.el.remove();
        // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
        // We don't null-out the View's other jQuery element references upon destroy,
        //  so we shouldn't kill this.el either.
    };
    Component.prototype.bindGlobalHandlers = function () {
        // subclasses can override
    };
    Component.prototype.unbindGlobalHandlers = function () {
        // subclasses can override
    };
    /*
    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
    */
    // Renders the basic structure of the view before any content is rendered
    Component.prototype.renderSkeleton = function () {
        // subclasses should implement
    };
    // Unrenders the basic structure of the view
    Component.prototype.unrenderSkeleton = function () {
        // subclasses should implement
    };
    return Component;
}(Model_1.default));
exports.default = Component;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Iterator = /** @class */ (function () {
    function Iterator(items) {
        this.items = items || [];
    }
    /* Calls a method on every item passing the arguments through */
    Iterator.prototype.proxyCall = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var results = [];
        this.items.forEach(function (item) {
            results.push(item[methodName].apply(item, args));
        });
        return results;
    };
    return Iterator;
}());
exports.default = Iterator;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
/* Toolbar with buttons and title
----------------------------------------------------------------------------------------------------------------------*/
var Toolbar = /** @class */ (function () {
    function Toolbar(calendar, toolbarOptions) {
        this.el = null; // mirrors local `el`
        this.viewsWithButtons = [];
        this.calendar = calendar;
        this.toolbarOptions = toolbarOptions;
    }
    // method to update toolbar-specific options, not calendar-wide options
    Toolbar.prototype.setToolbarOptions = function (newToolbarOptions) {
        this.toolbarOptions = newToolbarOptions;
    };
    // can be called repeatedly and will rerender
    Toolbar.prototype.render = function () {
        var sections = this.toolbarOptions.layout;
        var el = this.el;
        if (sections) {
            if (!el) {
                el = this.el = $("<div class='fc-toolbar " + this.toolbarOptions.extraClasses + "'/>");
            }
            else {
                el.empty();
            }
            el.append(this.renderSection('left'))
                .append(this.renderSection('right'))
                .append(this.renderSection('center'))
                .append('<div class="fc-clear"/>');
        }
        else {
            this.removeElement();
        }
    };
    Toolbar.prototype.removeElement = function () {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    };
    Toolbar.prototype.renderSection = function (position) {
        var _this = this;
        var calendar = this.calendar;
        var theme = calendar.theme;
        var optionsManager = calendar.optionsManager;
        var viewSpecManager = calendar.viewSpecManager;
        var sectionEl = $('<div class="fc-' + position + '"/>');
        var buttonStr = this.toolbarOptions.layout[position];
        var calendarCustomButtons = optionsManager.get('customButtons') || {};
        var calendarButtonTextOverrides = optionsManager.overrides.buttonText || {};
        var calendarButtonText = optionsManager.get('buttonText') || {};
        if (buttonStr) {
            $.each(buttonStr.split(' '), function (i, buttonGroupStr) {
                var groupChildren = $();
                var isOnlyButtons = true;
                var groupEl;
                $.each(buttonGroupStr.split(','), function (j, buttonName) {
                    var customButtonProps;
                    var viewSpec;
                    var buttonClick;
                    var buttonIcon; // only one of these will be set
                    var buttonText; // "
                    var buttonInnerHtml;
                    var buttonClasses;
                    var buttonEl;
                    var buttonAriaAttr;
                    if (buttonName === 'title') {
                        groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
                        isOnlyButtons = false;
                    }
                    else {
                        if ((customButtonProps = calendarCustomButtons[buttonName])) {
                            buttonClick = function (ev) {
                                if (customButtonProps.click) {
                                    customButtonProps.click.call(buttonEl[0], ev);
                                }
                            };
                            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = customButtonProps.text);
                        }
                        else if ((viewSpec = viewSpecManager.getViewSpec(buttonName))) {
                            _this.viewsWithButtons.push(buttonName);
                            buttonClick = function () {
                                calendar.changeView(buttonName);
                            };
                            (buttonText = viewSpec.buttonTextOverride) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = viewSpec.buttonTextDefault);
                        }
                        else if (calendar[buttonName]) {
                            buttonClick = function () {
                                calendar[buttonName]();
                            };
                            (buttonText = calendarButtonTextOverrides[buttonName]) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = calendarButtonText[buttonName]);
                            //            ^ everything else is considered default
                        }
                        if (buttonClick) {
                            buttonClasses = [
                                'fc-' + buttonName + '-button',
                                theme.getClass('button'),
                                theme.getClass('stateDefault')
                            ];
                            if (buttonText) {
                                buttonInnerHtml = util_1.htmlEscape(buttonText);
                                buttonAriaAttr = '';
                            }
                            else if (buttonIcon) {
                                buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
                                buttonAriaAttr = ' aria-label="' + buttonName + '"';
                            }
                            buttonEl = $(// type="button" so that it doesn't submit a form
                            '<button type="button" class="' + buttonClasses.join(' ') + '"' +
                                buttonAriaAttr +
                                '>' + buttonInnerHtml + '</button>')
                                .click(function (ev) {
                                // don't process clicks for disabled buttons
                                if (!buttonEl.hasClass(theme.getClass('stateDisabled'))) {
                                    buttonClick(ev);
                                    // after the click action, if the button becomes the "active" tab, or disabled,
                                    // it should never have a hover class, so remove it now.
                                    if (buttonEl.hasClass(theme.getClass('stateActive')) ||
                                        buttonEl.hasClass(theme.getClass('stateDisabled'))) {
                                        buttonEl.removeClass(theme.getClass('stateHover'));
                                    }
                                }
                            })
                                .mousedown(function () {
                                // the *down* effect (mouse pressed in).
                                // only on buttons that are not the "active" tab, or disabled
                                buttonEl
                                    .not('.' + theme.getClass('stateActive'))
                                    .not('.' + theme.getClass('stateDisabled'))
                                    .addClass(theme.getClass('stateDown'));
                            })
                                .mouseup(function () {
                                // undo the *down* effect
                                buttonEl.removeClass(theme.getClass('stateDown'));
                            })
                                .hover(function () {
                                // the *hover* effect.
                                // only on buttons that are not the "active" tab, or disabled
                                buttonEl
                                    .not('.' + theme.getClass('stateActive'))
                                    .not('.' + theme.getClass('stateDisabled'))
                                    .addClass(theme.getClass('stateHover'));
                            }, function () {
                                // undo the *hover* effect
                                buttonEl
                                    .removeClass(theme.getClass('stateHover'))
                                    .removeClass(theme.getClass('stateDown')); // if mouseleave happens before mouseup
                            });
                            groupChildren = groupChildren.add(buttonEl);
                        }
                    }
                });
                if (isOnlyButtons) {
                    groupChildren
                        .first().addClass(theme.getClass('cornerLeft')).end()
                        .last().addClass(theme.getClass('cornerRight')).end();
                }
                if (groupChildren.length > 1) {
                    groupEl = $('<div/>');
                    if (isOnlyButtons) {
                        groupEl.addClass(theme.getClass('buttonGroup'));
                    }
                    groupEl.append(groupChildren);
                    sectionEl.append(groupEl);
                }
                else {
                    sectionEl.append(groupChildren); // 1 or 0 children
                }
            });
        }
        return sectionEl;
    };
    Toolbar.prototype.updateTitle = function (text) {
        if (this.el) {
            this.el.find('h2').text(text);
        }
    };
    Toolbar.prototype.activateButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .addClass(this.calendar.theme.getClass('stateActive'));
        }
    };
    Toolbar.prototype.deactivateButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .removeClass(this.calendar.theme.getClass('stateActive'));
        }
    };
    Toolbar.prototype.disableButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .prop('disabled', true)
                .addClass(this.calendar.theme.getClass('stateDisabled'));
        }
    };
    Toolbar.prototype.enableButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .prop('disabled', false)
                .removeClass(this.calendar.theme.getClass('stateDisabled'));
        }
    };
    Toolbar.prototype.getViewsWithButtons = function () {
        return this.viewsWithButtons;
    };
    return Toolbar;
}());
exports.default = Toolbar;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var locale_1 = __webpack_require__(30);
var Model_1 = __webpack_require__(48);
var OptionsManager = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsManager, _super);
    function OptionsManager(_calendar, overrides) {
        var _this = _super.call(this) || this;
        _this._calendar = _calendar;
        _this.overrides = $.extend({}, overrides); // make a copy
        _this.dynamicOverrides = {};
        _this.compute();
        return _this;
    }
    OptionsManager.prototype.add = function (newOptionHash) {
        var optionCnt = 0;
        var optionName;
        this.recordOverrides(newOptionHash); // will trigger this model's watchers
        for (optionName in newOptionHash) {
            optionCnt++;
        }
        // special-case handling of single option change.
        // if only one option change, `optionName` will be its name.
        if (optionCnt === 1) {
            if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
                this._calendar.updateViewSize(true); // isResize=true
                return;
            }
            else if (optionName === 'defaultDate') {
                return; // can't change date this way. use gotoDate instead
            }
            else if (optionName === 'businessHours') {
                return; // this model already reacts to this
            }
            else if (/^(event|select)(Overlap|Constraint|Allow)$/.test(optionName)) {
                return; // doesn't affect rendering. only interactions.
            }
            else if (optionName === 'timezone') {
                this._calendar.view.flash('initialEvents');
                return;
            }
        }
        // catch-all. rerender the header and footer and rebuild/rerender the current view
        this._calendar.renderHeader();
        this._calendar.renderFooter();
        // even non-current views will be affected by this option change. do before rerender
        // TODO: detangle
        this._calendar.viewsByType = {};
        this._calendar.reinitView();
    };
    // Computes the flattened options hash for the calendar and assigns to `this.options`.
    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
    OptionsManager.prototype.compute = function () {
        var locale;
        var localeDefaults;
        var isRTL;
        var dirDefaults;
        var rawOptions;
        locale = util_1.firstDefined(// explicit locale option given?
        this.dynamicOverrides.locale, this.overrides.locale);
        localeDefaults = locale_1.localeOptionHash[locale];
        if (!localeDefaults) {
            locale = options_1.globalDefaults.locale;
            localeDefaults = locale_1.localeOptionHash[locale] || {};
        }
        isRTL = util_1.firstDefined(// based on options computed so far, is direction RTL?
        this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, options_1.globalDefaults.isRTL);
        dirDefaults = isRTL ? options_1.rtlDefaults : {};
        this.dirDefaults = dirDefaults;
        this.localeDefaults = localeDefaults;
        rawOptions = options_1.mergeOptions([
            options_1.globalDefaults,
            dirDefaults,
            localeDefaults,
            this.overrides,
            this.dynamicOverrides
        ]);
        locale_1.populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options
        this.reset(rawOptions);
    };
    // stores the new options internally, but does not rerender anything.
    OptionsManager.prototype.recordOverrides = function (newOptionHash) {
        var optionName;
        for (optionName in newOptionHash) {
            this.dynamicOverrides[optionName] = newOptionHash[optionName];
        }
        this._calendar.viewSpecManager.clearCache(); // the dynamic override invalidates the options in this cache, so just clear it
        this.compute(); // this.options needs to be recomputed after the dynamic override
    };
    return OptionsManager;
}(Model_1.default));
exports.default = OptionsManager;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var ViewRegistry_1 = __webpack_require__(21);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var locale_1 = __webpack_require__(30);
var ViewSpecManager = /** @class */ (function () {
    function ViewSpecManager(optionsManager, _calendar) {
        this.optionsManager = optionsManager;
        this._calendar = _calendar;
        this.clearCache();
    }
    ViewSpecManager.prototype.clearCache = function () {
        this.viewSpecCache = {};
    };
    // Gets information about how to create a view. Will use a cache.
    ViewSpecManager.prototype.getViewSpec = function (viewType) {
        var cache = this.viewSpecCache;
        return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    ViewSpecManager.prototype.getUnitViewSpec = function (unit) {
        var viewTypes;
        var i;
        var spec;
        if ($.inArray(unit, util_1.unitsDesc) !== -1) {
            // put views that have buttons first. there will be duplicates, but oh well
            viewTypes = this._calendar.header.getViewsWithButtons(); // TODO: include footer as well?
            $.each(ViewRegistry_1.viewHash, function (viewType) {
                viewTypes.push(viewType);
            });
            for (i = 0; i < viewTypes.length; i++) {
                spec = this.getViewSpec(viewTypes[i]);
                if (spec) {
                    if (spec.singleUnit === unit) {
                        return spec;
                    }
                }
            }
        }
    };
    // Builds an object with information on how to create a given view
    ViewSpecManager.prototype.buildViewSpec = function (requestedViewType) {
        var viewOverrides = this.optionsManager.overrides.views || {};
        var specChain = []; // for the view. lowest to highest priority
        var defaultsChain = []; // for the view. lowest to highest priority
        var overridesChain = []; // for the view. lowest to highest priority
        var viewType = requestedViewType;
        var spec; // for the view
        var overrides; // for the view
        var durationInput;
        var duration;
        var unit;
        // iterate from the specific view definition to a more general one until we hit an actual View class
        while (viewType) {
            spec = ViewRegistry_1.viewHash[viewType];
            overrides = viewOverrides[viewType];
            viewType = null; // clear. might repopulate for another iteration
            if (typeof spec === 'function') {
                spec = { 'class': spec };
            }
            if (spec) {
                specChain.unshift(spec);
                defaultsChain.unshift(spec.defaults || {});
                durationInput = durationInput || spec.duration;
                viewType = viewType || spec.type;
            }
            if (overrides) {
                overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
                durationInput = durationInput || overrides.duration;
                viewType = viewType || overrides.type;
            }
        }
        spec = util_1.mergeProps(specChain);
        spec.type = requestedViewType;
        if (!spec['class']) {
            return false;
        }
        // fall back to top-level `duration` option
        durationInput = durationInput ||
            this.optionsManager.dynamicOverrides.duration ||
            this.optionsManager.overrides.duration;
        if (durationInput) {
            duration = moment.duration(durationInput);
            if (duration.valueOf()) {
                unit = util_1.computeDurationGreatestUnit(duration, durationInput);
                spec.duration = duration;
                spec.durationUnit = unit;
                // view is a single-unit duration, like "week" or "day"
                // incorporate options for this. lowest priority
                if (duration.as(unit) === 1) {
                    spec.singleUnit = unit;
                    overridesChain.unshift(viewOverrides[unit] || {});
                }
            }
        }
        spec.defaults = options_1.mergeOptions(defaultsChain);
        spec.overrides = options_1.mergeOptions(overridesChain);
        this.buildViewSpecOptions(spec);
        this.buildViewSpecButtonText(spec, requestedViewType);
        return spec;
    };
    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
    ViewSpecManager.prototype.buildViewSpecOptions = function (spec) {
        var optionsManager = this.optionsManager;
        spec.options = options_1.mergeOptions([
            options_1.globalDefaults,
            spec.defaults,
            optionsManager.dirDefaults,
            optionsManager.localeDefaults,
            optionsManager.overrides,
            spec.overrides,
            optionsManager.dynamicOverrides // dynamically set via setter. highest precedence
        ]);
        locale_1.populateInstanceComputableOptions(spec.options);
    };
    // Computes and assigns a view spec's buttonText-related options
    ViewSpecManager.prototype.buildViewSpecButtonText = function (spec, requestedViewType) {
        var optionsManager = this.optionsManager;
        // given an options object with a possible `buttonText` hash, lookup the buttonText for the
        // requested view, falling back to a generic unit entry like "week" or "day"
        function queryButtonText(options) {
            var buttonText = options.buttonText || {};
            return buttonText[requestedViewType] ||
                // view can decide to look up a certain key
                (spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
                // a key like "month"
                (spec.singleUnit ? buttonText[spec.singleUnit] : null);
        }
        // highest to lowest priority
        spec.buttonTextOverride =
            queryButtonText(optionsManager.dynamicOverrides) ||
                queryButtonText(optionsManager.overrides) || // constructor-specified buttonText lookup hash takes precedence
                spec.overrides.buttonText; // `buttonText` for view-specific options is a string
        // highest to lowest priority. mirrors buildViewSpecOptions
        spec.buttonTextDefault =
            queryButtonText(optionsManager.localeDefaults) ||
                queryButtonText(optionsManager.dirDefaults) ||
                spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
                queryButtonText(options_1.globalDefaults) ||
                (spec.duration ? this._calendar.humanizeDuration(spec.duration) : null) || // like "3 days"
                requestedViewType; // fall back to given view name
    };
    return ViewSpecManager;
}());
exports.default = ViewSpecManager;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventPeriod_1 = __webpack_require__(243);
var ArrayEventSource_1 = __webpack_require__(52);
var EventSource_1 = __webpack_require__(6);
var EventSourceParser_1 = __webpack_require__(37);
var SingleEventDef_1 = __webpack_require__(13);
var EventInstanceGroup_1 = __webpack_require__(18);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var EventManager = /** @class */ (function () {
    function EventManager(calendar) {
        this.calendar = calendar;
        this.stickySource = new ArrayEventSource_1.default(calendar);
        this.otherSources = [];
    }
    EventManager.prototype.requestEvents = function (start, end, timezone, force) {
        if (force ||
            !this.currentPeriod ||
            !this.currentPeriod.isWithinRange(start, end) ||
            timezone !== this.currentPeriod.timezone) {
            this.setPeriod(// will change this.currentPeriod
            new EventPeriod_1.default(start, end, timezone));
        }
        return this.currentPeriod.whenReleased();
    };
    // Source Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.addSource = function (eventSource) {
        this.otherSources.push(eventSource);
        if (this.currentPeriod) {
            this.currentPeriod.requestSource(eventSource); // might release
        }
    };
    EventManager.prototype.removeSource = function (doomedSource) {
        util_1.removeExact(this.otherSources, doomedSource);
        if (this.currentPeriod) {
            this.currentPeriod.purgeSource(doomedSource); // might release
        }
    };
    EventManager.prototype.removeAllSources = function () {
        this.otherSources = [];
        if (this.currentPeriod) {
            this.currentPeriod.purgeAllSources(); // might release
        }
    };
    // Source Refetching
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.refetchSource = function (eventSource) {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeSource(eventSource);
            currentPeriod.requestSource(eventSource);
            currentPeriod.thaw();
        }
    };
    EventManager.prototype.refetchAllSources = function () {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeAllSources();
            currentPeriod.requestSources(this.getSources());
            currentPeriod.thaw();
        }
    };
    // Source Querying
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getSources = function () {
        return [this.stickySource].concat(this.otherSources);
    };
    // like querySources, but accepts multple match criteria (like multiple IDs)
    EventManager.prototype.multiQuerySources = function (matchInputs) {
        // coerce into an array
        if (!matchInputs) {
            matchInputs = [];
        }
        else if (!$.isArray(matchInputs)) {
            matchInputs = [matchInputs];
        }
        var matchingSources = [];
        var i;
        // resolve raw inputs to real event source objects
        for (i = 0; i < matchInputs.length; i++) {
            matchingSources.push.apply(// append
            matchingSources, this.querySources(matchInputs[i]));
        }
        return matchingSources;
    };
    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
    // returns an array of matching source objects.
    EventManager.prototype.querySources = function (matchInput) {
        var sources = this.otherSources;
        var i;
        var source;
        // given a proper event source object
        for (i = 0; i < sources.length; i++) {
            source = sources[i];
            if (source === matchInput) {
                return [source];
            }
        }
        // an ID match
        source = this.getSourceById(EventSource_1.default.normalizeId(matchInput));
        if (source) {
            return [source];
        }
        // parse as an event source
        matchInput = EventSourceParser_1.default.parse(matchInput, this.calendar);
        if (matchInput) {
            return $.grep(sources, function (source) {
                return isSourcesEquivalent(matchInput, source);
            });
        }
    };
    /*
    ID assumed to already be normalized
    */
    EventManager.prototype.getSourceById = function (id) {
        return $.grep(this.otherSources, function (source) {
            return source.id && source.id === id;
        })[0];
    };
    // Event-Period
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.setPeriod = function (eventPeriod) {
        if (this.currentPeriod) {
            this.unbindPeriod(this.currentPeriod);
            this.currentPeriod = null;
        }
        this.currentPeriod = eventPeriod;
        this.bindPeriod(eventPeriod);
        eventPeriod.requestSources(this.getSources());
    };
    EventManager.prototype.bindPeriod = function (eventPeriod) {
        this.listenTo(eventPeriod, 'release', function (eventsPayload) {
            this.trigger('release', eventsPayload);
        });
    };
    EventManager.prototype.unbindPeriod = function (eventPeriod) {
        this.stopListeningTo(eventPeriod);
    };
    // Event Getting/Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getEventDefByUid = function (uid) {
        if (this.currentPeriod) {
            return this.currentPeriod.getEventDefByUid(uid);
        }
    };
    EventManager.prototype.addEventDef = function (eventDef, isSticky) {
        if (isSticky) {
            this.stickySource.addEventDef(eventDef);
        }
        if (this.currentPeriod) {
            this.currentPeriod.addEventDef(eventDef); // might release
        }
    };
    EventManager.prototype.removeEventDefsById = function (eventId) {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeEventDefsById(eventId);
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeEventDefsById(eventId); // might release
        }
    };
    EventManager.prototype.removeAllEventDefs = function () {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeAllEventDefs();
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeAllEventDefs();
        }
    };
    // Event Mutating
    // -----------------------------------------------------------------------------------------------------------------
    /*
    Returns an undo function.
    */
    EventManager.prototype.mutateEventsWithId = function (eventDefId, eventDefMutation) {
        var currentPeriod = this.currentPeriod;
        var eventDefs;
        var undoFuncs = [];
        if (currentPeriod) {
            currentPeriod.freeze();
            eventDefs = currentPeriod.getEventDefsById(eventDefId);
            eventDefs.forEach(function (eventDef) {
                // add/remove esp because id might change
                currentPeriod.removeEventDef(eventDef);
                undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
                currentPeriod.addEventDef(eventDef);
            });
            currentPeriod.thaw();
            return function () {
                currentPeriod.freeze();
                for (var i = 0; i < eventDefs.length; i++) {
                    currentPeriod.removeEventDef(eventDefs[i]);
                    undoFuncs[i]();
                    currentPeriod.addEventDef(eventDefs[i]);
                }
                currentPeriod.thaw();
            };
        }
        return function () { };
    };
    /*
    copies and then mutates
    */
    EventManager.prototype.buildMutatedEventInstanceGroup = function (eventDefId, eventDefMutation) {
        var eventDefs = this.getEventDefsById(eventDefId);
        var i;
        var defCopy;
        var allInstances = [];
        for (i = 0; i < eventDefs.length; i++) {
            defCopy = eventDefs[i].clone();
            if (defCopy instanceof SingleEventDef_1.default) {
                eventDefMutation.mutateSingle(defCopy);
                allInstances.push.apply(allInstances, // append
                defCopy.buildInstances());
            }
        }
        return new EventInstanceGroup_1.default(allInstances);
    };
    // Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.freeze = function () {
        if (this.currentPeriod) {
            this.currentPeriod.freeze();
        }
    };
    EventManager.prototype.thaw = function () {
        if (this.currentPeriod) {
            this.currentPeriod.thaw();
        }
    };
    // methods that simply forward to EventPeriod
    EventManager.prototype.getEventDefsById = function (eventDefId) {
        return this.currentPeriod.getEventDefsById(eventDefId);
    };
    EventManager.prototype.getEventInstances = function () {
        return this.currentPeriod.getEventInstances();
    };
    EventManager.prototype.getEventInstancesWithId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithId(eventDefId);
    };
    EventManager.prototype.getEventInstancesWithoutId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithoutId(eventDefId);
    };
    return EventManager;
}());
exports.default = EventManager;
EmitterMixin_1.default.mixInto(EventManager);
ListenerMixin_1.default.mixInto(EventManager);
function isSourcesEquivalent(source0, source1) {
    return source0.getPrimitive() === source1.getPrimitive();
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EmitterMixin_1 = __webpack_require__(11);
var UnzonedRange_1 = __webpack_require__(5);
var EventInstanceGroup_1 = __webpack_require__(18);
var EventPeriod = /** @class */ (function () {
    function EventPeriod(start, end, timezone) {
        this.pendingCnt = 0;
        this.freezeDepth = 0;
        this.stuntedReleaseCnt = 0;
        this.releaseCnt = 0;
        this.start = start;
        this.end = end;
        this.timezone = timezone;
        this.unzonedRange = new UnzonedRange_1.default(start.clone().stripZone(), end.clone().stripZone());
        this.requestsByUid = {};
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
    }
    EventPeriod.prototype.isWithinRange = function (start, end) {
        // TODO: use a range util function?
        return !start.isBefore(this.start) && !end.isAfter(this.end);
    };
    // Requesting and Purging
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.requestSources = function (sources) {
        this.freeze();
        for (var i = 0; i < sources.length; i++) {
            this.requestSource(sources[i]);
        }
        this.thaw();
    };
    EventPeriod.prototype.requestSource = function (source) {
        var _this = this;
        var request = { source: source, status: 'pending', eventDefs: null };
        this.requestsByUid[source.uid] = request;
        this.pendingCnt += 1;
        source.fetch(this.start, this.end, this.timezone).then(function (eventDefs) {
            if (request.status !== 'cancelled') {
                request.status = 'completed';
                request.eventDefs = eventDefs;
                _this.addEventDefs(eventDefs);
                _this.pendingCnt--;
                _this.tryRelease();
            }
        }, function () {
            if (request.status !== 'cancelled') {
                request.status = 'failed';
                _this.pendingCnt--;
                _this.tryRelease();
            }
        });
    };
    EventPeriod.prototype.purgeSource = function (source) {
        var request = this.requestsByUid[source.uid];
        if (request) {
            delete this.requestsByUid[source.uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
                this.pendingCnt--;
                this.tryRelease();
            }
            else if (request.status === 'completed') {
                request.eventDefs.forEach(this.removeEventDef.bind(this));
            }
        }
    };
    EventPeriod.prototype.purgeAllSources = function () {
        var requestsByUid = this.requestsByUid;
        var uid;
        var request;
        var completedCnt = 0;
        for (uid in requestsByUid) {
            request = requestsByUid[uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
            }
            else if (request.status === 'completed') {
                completedCnt++;
            }
        }
        this.requestsByUid = {};
        this.pendingCnt = 0;
        if (completedCnt) {
            this.removeAllEventDefs(); // might release
        }
    };
    // Event Definitions
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventDefByUid = function (eventDefUid) {
        return this.eventDefsByUid[eventDefUid];
    };
    EventPeriod.prototype.getEventDefsById = function (eventDefId) {
        var a = this.eventDefsById[eventDefId];
        if (a) {
            return a.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.addEventDefs = function (eventDefs) {
        for (var i = 0; i < eventDefs.length; i++) {
            this.addEventDef(eventDefs[i]);
        }
    };
    EventPeriod.prototype.addEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefId = eventDef.id;
        var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
        var eventInstances = eventDef.buildInstances(this.unzonedRange);
        var i;
        eventDefs.push(eventDef);
        this.eventDefsByUid[eventDef.uid] = eventDef;
        for (i = 0; i < eventInstances.length; i++) {
            this.addEventInstance(eventInstances[i], eventDefId);
        }
    };
    EventPeriod.prototype.removeEventDefsById = function (eventDefId) {
        var _this = this;
        this.getEventDefsById(eventDefId).forEach(function (eventDef) {
            _this.removeEventDef(eventDef);
        });
    };
    EventPeriod.prototype.removeAllEventDefs = function () {
        var isEmpty = $.isEmptyObject(this.eventDefsByUid);
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
        if (!isEmpty) {
            this.tryRelease();
        }
    };
    EventPeriod.prototype.removeEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefs = eventDefsById[eventDef.id];
        delete this.eventDefsByUid[eventDef.uid];
        if (eventDefs) {
            util_1.removeExact(eventDefs, eventDef);
            if (!eventDefs.length) {
                delete eventDefsById[eventDef.id];
            }
            this.removeEventInstancesForDef(eventDef);
        }
    };
    // Event Instances
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventInstances = function () {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            eventInstances.push.apply(eventInstances, // append
            eventInstanceGroupsById[id].eventInstances);
        }
        return eventInstances;
    };
    EventPeriod.prototype.getEventInstancesWithId = function (eventDefId) {
        var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];
        if (eventInstanceGroup) {
            return eventInstanceGroup.eventInstances.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.getEventInstancesWithoutId = function (eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var matchingInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            if (id !== eventDefId) {
                matchingInstances.push.apply(matchingInstances, // append
                eventInstanceGroupsById[id].eventInstances);
            }
        }
        return matchingInstances;
    };
    EventPeriod.prototype.addEventInstance = function (eventInstance, eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDefId] ||
            (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup_1.default());
        eventInstanceGroup.eventInstances.push(eventInstance);
        this.tryRelease();
    };
    EventPeriod.prototype.removeEventInstancesForDef = function (eventDef) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
        var removeCnt;
        if (eventInstanceGroup) {
            removeCnt = util_1.removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
                return currentEventInstance.def === eventDef;
            });
            if (!eventInstanceGroup.eventInstances.length) {
                delete eventInstanceGroupsById[eventDef.id];
            }
            if (removeCnt) {
                this.tryRelease();
            }
        }
    };
    // Releasing and Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.tryRelease = function () {
        if (!this.pendingCnt) {
            if (!this.freezeDepth) {
                this.release();
            }
            else {
                this.stuntedReleaseCnt++;
            }
        }
    };
    EventPeriod.prototype.release = function () {
        this.releaseCnt++;
        this.trigger('release', this.eventInstanceGroupsById);
    };
    EventPeriod.prototype.whenReleased = function () {
        var _this = this;
        if (this.releaseCnt) {
            return Promise_1.default.resolve(this.eventInstanceGroupsById);
        }
        else {
            return Promise_1.default.construct(function (onResolve) {
                _this.one('release', onResolve);
            });
        }
    };
    EventPeriod.prototype.freeze = function () {
        if (!(this.freezeDepth++)) {
            this.stuntedReleaseCnt = 0;
        }
    };
    EventPeriod.prototype.thaw = function () {
        if (!(--this.freezeDepth) && this.stuntedReleaseCnt && !this.pendingCnt) {
            this.release();
        }
    };
    return EventPeriod;
}());
exports.default = EventPeriod;
EmitterMixin_1.default.mixInto(EventPeriod);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
/* Creates a clone of an element and lets it track the mouse as it moves
----------------------------------------------------------------------------------------------------------------------*/
var MouseFollower = /** @class */ (function () {
    function MouseFollower(sourceEl, options) {
        this.isFollowing = false;
        this.isHidden = false;
        this.isAnimating = false; // doing the revert animation?
        this.options = options = options || {};
        this.sourceEl = sourceEl;
        this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
    }
    // Causes the element to start following the mouse
    MouseFollower.prototype.start = function (ev) {
        if (!this.isFollowing) {
            this.isFollowing = true;
            this.y0 = util_1.getEvY(ev);
            this.x0 = util_1.getEvX(ev);
            this.topDelta = 0;
            this.leftDelta = 0;
            if (!this.isHidden) {
                this.updatePosition();
            }
            if (util_1.getEvIsTouch(ev)) {
                this.listenTo($(document), 'touchmove', this.handleMove);
            }
            else {
                this.listenTo($(document), 'mousemove', this.handleMove);
            }
        }
    };
    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
    MouseFollower.prototype.stop = function (shouldRevert, callback) {
        var _this = this;
        var revertDuration = this.options.revertDuration;
        var complete = function () {
            _this.isAnimating = false;
            _this.removeElement();
            _this.top0 = _this.left0 = null; // reset state for future updatePosition calls
            if (callback) {
                callback();
            }
        };
        if (this.isFollowing && !this.isAnimating) {
            this.isFollowing = false;
            this.stopListeningTo($(document));
            if (shouldRevert && revertDuration && !this.isHidden) {
                this.isAnimating = true;
                this.el.animate({
                    top: this.top0,
                    left: this.left0
                }, {
                    duration: revertDuration,
                    complete: complete
                });
            }
            else {
                complete();
            }
        }
    };
    // Gets the tracking element. Create it if necessary
    MouseFollower.prototype.getEl = function () {
        var el = this.el;
        if (!el) {
            el = this.el = this.sourceEl.clone()
                .addClass(this.options.additionalClass || '')
                .css({
                position: 'absolute',
                visibility: '',
                display: this.isHidden ? 'none' : '',
                margin: 0,
                right: 'auto',
                bottom: 'auto',
                width: this.sourceEl.width(),
                height: this.sourceEl.height(),
                opacity: this.options.opacity || '',
                zIndex: this.options.zIndex
            });
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            el.addClass('fc-unselectable');
            el.appendTo(this.parentEl);
        }
        return el;
    };
    // Removes the tracking element if it has already been created
    MouseFollower.prototype.removeElement = function () {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    };
    // Update the CSS position of the tracking element
    MouseFollower.prototype.updatePosition = function () {
        var sourceOffset;
        var origin;
        this.getEl(); // ensure this.el
        // make sure origin info was computed
        if (this.top0 == null) {
            sourceOffset = this.sourceEl.offset();
            origin = this.el.offsetParent().offset();
            this.top0 = sourceOffset.top - origin.top;
            this.left0 = sourceOffset.left - origin.left;
        }
        this.el.css({
            top: this.top0 + this.topDelta,
            left: this.left0 + this.leftDelta
        });
    };
    // Gets called when the user moves the mouse
    MouseFollower.prototype.handleMove = function (ev) {
        this.topDelta = util_1.getEvY(ev) - this.y0;
        this.leftDelta = util_1.getEvX(ev) - this.x0;
        if (!this.isHidden) {
            this.updatePosition();
        }
    };
    // Temporarily makes the tracking element invisible. Can be called before following starts
    MouseFollower.prototype.hide = function () {
        if (!this.isHidden) {
            this.isHidden = true;
            if (this.el) {
                this.el.hide();
            }
        }
    };
    // Show the tracking element after it has been temporarily hidden
    MouseFollower.prototype.show = function () {
        if (this.isHidden) {
            this.isHidden = false;
            this.updatePosition();
            this.getEl().show();
        }
    };
    return MouseFollower;
}());
exports.default = MouseFollower;
ListenerMixin_1.default.mixInto(MouseFollower);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var HitDragListener_1 = __webpack_require__(22);
var Interaction_1 = __webpack_require__(15);
var DateClicking = /** @class */ (function (_super) {
    tslib_1.__extends(DateClicking, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - getHitEl
    */
    function DateClicking(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateClicking.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateClicking.prototype.bindToEl = function (el) {
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (!component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev);
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (!component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev);
            }
        });
    };
    // Creates a listener that tracks the user's drag across day elements, for day clicking.
    DateClicking.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var dayClickHit; // null if invalid dayClick
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                dayClickHit = dragListener.origHit;
            },
            hitOver: function (hit, isOrig, origHit) {
                // if user dragged to another cell at any point, it can no longer be a dayClick
                if (!isOrig) {
                    dayClickHit = null;
                }
            },
            hitOut: function () {
                dayClickHit = null;
            },
            interactionEnd: function (ev, isCancelled) {
                var componentFootprint;
                if (!isCancelled && dayClickHit) {
                    componentFootprint = component.getSafeHitFootprint(dayClickHit);
                    if (componentFootprint) {
                        _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
                    }
                }
            }
        });
        // because dragListener won't be called with any time delay, "dragging" will begin immediately,
        // which will kill any touchmoving/scrolling. Prevent this.
        dragListener.shouldCancelTouchScroll = false;
        dragListener.scrollAlwaysKills = true;
        return dragListener;
    };
    return DateClicking;
}(Interaction_1.default));
exports.default = DateClicking;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
/*
Only handles foreground segs.
Does not own rendering. Use for low-level util methods by TimeGrid.
*/
var TimeGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridEventRenderer, _super);
    function TimeGridEventRenderer(timeGrid, fillRenderer) {
        var _this = _super.call(this, timeGrid, fillRenderer) || this;
        _this.timeGrid = timeGrid;
        return _this;
    }
    TimeGridEventRenderer.prototype.renderFgSegs = function (segs) {
        this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
    };
    // Given an array of foreground segments, render a DOM element for each, computes position,
    // and attaches to the column inner-container elements.
    TimeGridEventRenderer.prototype.renderFgSegsIntoContainers = function (segs, containerEls) {
        var segsByCol;
        var col;
        segsByCol = this.timeGrid.groupSegsByCol(segs);
        for (col = 0; col < this.timeGrid.colCnt; col++) {
            this.updateFgSegCoords(segsByCol[col]);
        }
        this.timeGrid.attachSegsByCol(segsByCol, containerEls);
    };
    TimeGridEventRenderer.prototype.unrenderFgSegs = function () {
        if (this.fgSegs) {
            this.fgSegs.forEach(function (seg) {
                seg.el.remove();
            });
        }
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    TimeGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    TimeGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    // Renders the HTML for a single event segment's default rendering
    TimeGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var calendar = view.calendar;
        var componentFootprint = seg.footprint.componentFootprint;
        var isAllDay = componentFootprint.isAllDay;
        var eventDef = seg.footprint.eventDef;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
        var timeText;
        var fullTimeText; // more verbose time text. for the print stylesheet
        var startTimeText; // just the start time text
        classes.unshift('fc-time-grid-event', 'fc-v-event');
        // if the event appears to span more than one day...
        if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            // Don't display time text on segments that run entirely through a day.
            // That would appear as midnight-midnight and would look dumb.
            // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
            if (seg.isStart || seg.isEnd) {
                var zonedStart = calendar.msToMoment(seg.startMs);
                var zonedEnd = calendar.msToMoment(seg.endMs);
                timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
                fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, 'LT');
                startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeText = this.getTimeText(seg.footprint);
            fullTimeText = this.getTimeText(seg.footprint, 'LT');
            startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
        }
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (timeText ?
                '<div class="fc-time"' +
                    ' data-start="' + util_1.htmlEscape(startTimeText) + '"' +
                    ' data-full="' + util_1.htmlEscape(fullTimeText) + '"' +
                    '>' +
                    '<span>' + util_1.htmlEscape(timeText) + '</span>' +
                    '</div>' :
                '') +
            (eventDef.title ?
                '<div class="fc-title">' +
                    util_1.htmlEscape(eventDef.title) +
                    '</div>' :
                '') +
            '</div>' +
            '<div class="fc-bg"/>' +
            /* TODO: write CSS for this
            (isResizableFromStart ?
              '<div class="fc-resizer fc-start-resizer" />' :
              ''
              ) +
            */
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer" />' :
                '') +
            '</a>';
    };
    // Given segments that are assumed to all live in the *same column*,
    // compute their verical/horizontal coordinates and assign to their elements.
    TimeGridEventRenderer.prototype.updateFgSegCoords = function (segs) {
        this.timeGrid.computeSegVerticals(segs); // horizontals relies on this
        this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
        this.timeGrid.assignSegVerticals(segs);
        this.assignFgSegHorizontals(segs);
    };
    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
    // NOTE: Also reorders the given array by date!
    TimeGridEventRenderer.prototype.computeFgSegHorizontals = function (segs) {
        var levels;
        var level0;
        var i;
        this.sortEventSegs(segs); // order by certain criteria
        levels = buildSlotSegLevels(segs);
        computeForwardSlotSegs(levels);
        if ((level0 = levels[0])) {
            for (i = 0; i < level0.length; i++) {
                computeSlotSegPressures(level0[i]);
            }
            for (i = 0; i < level0.length; i++) {
                this.computeFgSegForwardBack(level0[i], 0, 0);
            }
        }
    };
    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
    //
    // The segment might be part of a "series", which means consecutive segments with the same pressure
    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
    // coordinate of the first segment in the series.
    TimeGridEventRenderer.prototype.computeFgSegForwardBack = function (seg, seriesBackwardPressure, seriesBackwardCoord) {
        var forwardSegs = seg.forwardSegs;
        var i;
        if (seg.forwardCoord === undefined) {
            if (!forwardSegs.length) {
                // if there are no forward segments, this segment should butt up against the edge
                seg.forwardCoord = 1;
            }
            else {
                // sort highest pressure first
                this.sortForwardSegs(forwardSegs);
                // this segment's forwardCoord will be calculated from the backwardCoord of the
                // highest-pressure forward segment.
                this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
                seg.forwardCoord = forwardSegs[0].backwardCoord;
            }
            // calculate the backwardCoord from the forwardCoord. consider the series
            seg.backwardCoord = seg.forwardCoord -
                (seg.forwardCoord - seriesBackwardCoord) / // available width for series
                    (seriesBackwardPressure + 1); // # of segments in the series
            // use this segment's coordinates to computed the coordinates of the less-pressurized
            // forward segments
            for (i = 0; i < forwardSegs.length; i++) {
                this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
            }
        }
    };
    TimeGridEventRenderer.prototype.sortForwardSegs = function (forwardSegs) {
        forwardSegs.sort(util_1.proxy(this, 'compareForwardSegs'));
    };
    // A cmp function for determining which forward segment to rely on more when computing coordinates.
    TimeGridEventRenderer.prototype.compareForwardSegs = function (seg1, seg2) {
        // put higher-pressure first
        return seg2.forwardPressure - seg1.forwardPressure ||
            // put segments that are closer to initial edge first (and favor ones with no coords yet)
            (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
            // do normal sorting...
            this.compareEventSegs(seg1, seg2);
    };
    // Given foreground event segments that have already had their position coordinates computed,
    // assigns position-related CSS values to their elements.
    TimeGridEventRenderer.prototype.assignFgSegHorizontals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            seg.el.css(this.generateFgSegHorizontalCss(seg));
            // if the height is short, add a className for alternate styling
            if (seg.bottom - seg.top < 30) {
                seg.el.addClass('fc-short');
            }
        }
    };
    // Generates an object with CSS properties/values that should be applied to an event segment element.
    // Contains important positioning-related properties that should be applied to any event element, customized or not.
    TimeGridEventRenderer.prototype.generateFgSegHorizontalCss = function (seg) {
        var shouldOverlap = this.opt('slotEventOverlap');
        var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
        var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
        var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first
        var isRTL = this.timeGrid.isRTL;
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) {
            // double the width, but don't go beyond the maximum forward coordinate (1.0)
            forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
        }
        if (isRTL) {
            left = 1 - forwardCoord;
            right = backwardCoord;
        }
        else {
            left = backwardCoord;
            right = 1 - forwardCoord;
        }
        props.zIndex = seg.level + 1; // convert from 0-base to 1-based
        props.left = left * 100 + '%';
        props.right = right * 100 + '%';
        if (shouldOverlap && seg.forwardPressure) {
            // add padding to the edge so that forward stacked events don't cover the resizer's icon
            props[isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
        }
        return props;
    };
    return TimeGridEventRenderer;
}(EventRenderer_1.default));
exports.default = TimeGridEventRenderer;
// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
function buildSlotSegLevels(segs) {
    var levels = [];
    var i;
    var seg;
    var j;
    for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        // go through all the levels and stop on the first level where there are no collisions
        for (j = 0; j < levels.length; j++) {
            if (!computeSlotSegCollisions(seg, levels[j]).length) {
                break;
            }
        }
        seg.level = j;
        (levels[j] || (levels[j] = [])).push(seg);
    }
    return levels;
}
// For every segment, figure out the other segments that are in subsequent
// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
function computeForwardSlotSegs(levels) {
    var i;
    var level;
    var j;
    var seg;
    var k;
    for (i = 0; i < levels.length; i++) {
        level = levels[i];
        for (j = 0; j < level.length; j++) {
            seg = level[j];
            seg.forwardSegs = [];
            for (k = i + 1; k < levels.length; k++) {
                computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
            }
        }
    }
}
// Figure out which path forward (via seg.forwardSegs) results in the longest path until
// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
function computeSlotSegPressures(seg) {
    var forwardSegs = seg.forwardSegs;
    var forwardPressure = 0;
    var i;
    var forwardSeg;
    if (seg.forwardPressure === undefined) {
        for (i = 0; i < forwardSegs.length; i++) {
            forwardSeg = forwardSegs[i];
            // figure out the child's maximum forward path
            computeSlotSegPressures(forwardSeg);
            // either use the existing maximum, or use the child's forward pressure
            // plus one (for the forwardSeg itself)
            forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
        }
        seg.forwardPressure = forwardPressure;
    }
}
// Find all the segments in `otherSegs` that vertically collide with `seg`.
// Append into an optionally-supplied `results` array and return.
function computeSlotSegCollisions(seg, otherSegs, results) {
    if (results === void 0) { results = []; }
    for (var i = 0; i < otherSegs.length; i++) {
        if (isSlotSegCollision(seg, otherSegs[i])) {
            results.push(otherSegs[i]);
        }
    }
    return results;
}
// Do these segments occupy the same vertical space?
function isSlotSegCollision(seg1, seg2) {
    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(58);
var TimeGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridHelperRenderer, _super);
    function TimeGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var i;
        var seg;
        var sourceEl;
        // TODO: not good to call eventRenderer this way
        this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls);
        // Try to make the segment that is in the same row as sourceSeg look the same
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (sourceSeg && sourceSeg.col === seg.col) {
                sourceEl = sourceSeg.el;
                seg.el.css({
                    left: sourceEl.css('left'),
                    right: sourceEl.css('right'),
                    'margin-left': sourceEl.css('margin-left'),
                    'margin-right': sourceEl.css('margin-right')
                });
            }
            helperNodes.push(seg.el[0]);
        }
        return $(helperNodes); // must return the elements rendered
    };
    return TimeGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = TimeGridHelperRenderer;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var FillRenderer_1 = __webpack_require__(57);
var TimeGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridFillRenderer, _super);
    function TimeGridFillRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var timeGrid = this.component;
        var containerEls;
        // TODO: more efficient lookup
        if (type === 'bgEvent') {
            containerEls = timeGrid.bgContainerEls;
        }
        else if (type === 'businessHours') {
            containerEls = timeGrid.businessContainerEls;
        }
        else if (type === 'highlight') {
            containerEls = timeGrid.highlightContainerEls;
        }
        timeGrid.updateSegVerticals(segs);
        timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
        return segs.map(function (seg) {
            return seg.el[0];
        });
    };
    return TimeGridFillRenderer;
}(FillRenderer_1.default));
exports.default = TimeGridFillRenderer;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/* A rectangular panel that is absolutely positioned over other content
------------------------------------------------------------------------------------------------------------------------
Options:
  - className (string)
  - content (HTML string or jQuery element set)
  - parentEl
  - top
  - left
  - right (the x coord of where the right edge should be. not a "CSS" right)
  - autoHide (boolean)
  - show (callback)
  - hide (callback)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
var Popover = /** @class */ (function () {
    function Popover(options) {
        this.isHidden = true;
        this.margin = 10; // the space required between the popover and the edges of the scroll container
        this.options = options || {};
    }
    // Shows the popover on the specified position. Renders it if not already
    Popover.prototype.show = function () {
        if (this.isHidden) {
            if (!this.el) {
                this.render();
            }
            this.el.show();
            this.position();
            this.isHidden = false;
            this.trigger('show');
        }
    };
    // Hides the popover, through CSS, but does not remove it from the DOM
    Popover.prototype.hide = function () {
        if (!this.isHidden) {
            this.el.hide();
            this.isHidden = true;
            this.trigger('hide');
        }
    };
    // Creates `this.el` and renders content inside of it
    Popover.prototype.render = function () {
        var _this = this;
        var options = this.options;
        this.el = $('<div class="fc-popover"/>')
            .addClass(options.className || '')
            .css({
            // position initially to the top left to avoid creating scrollbars
            top: 0,
            left: 0
        })
            .append(options.content)
            .appendTo(options.parentEl);
        // when a click happens on anything inside with a 'fc-close' className, hide the popover
        this.el.on('click', '.fc-close', function () {
            _this.hide();
        });
        if (options.autoHide) {
            this.listenTo($(document), 'mousedown', this.documentMousedown);
        }
    };
    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
    Popover.prototype.documentMousedown = function (ev) {
        // only hide the popover if the click happened outside the popover
        if (this.el && !$(ev.target).closest(this.el).length) {
            this.hide();
        }
    };
    // Hides and unregisters any handlers
    Popover.prototype.removeElement = function () {
        this.hide();
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
        this.stopListeningTo($(document), 'mousedown');
    };
    // Positions the popover optimally, using the top/left/right options
    Popover.prototype.position = function () {
        var options = this.options;
        var origin = this.el.offsetParent().offset();
        var width = this.el.outerWidth();
        var height = this.el.outerHeight();
        var windowEl = $(window);
        var viewportEl = util_1.getScrollParent(this.el);
        var viewportTop;
        var viewportLeft;
        var viewportOffset;
        var top; // the "position" (not "offset") values for the popover
        var left; //
        // compute top and left
        top = options.top || 0;
        if (options.left !== undefined) {
            left = options.left;
        }
        else if (options.right !== undefined) {
            left = options.right - width; // derive the left value from the right value
        }
        else {
            left = 0;
        }
        if (viewportEl.is(window) || viewportEl.is(document)) {
            viewportEl = windowEl;
            viewportTop = 0; // the window is always at the top left
            viewportLeft = 0; // (and .offset() won't work if called here)
        }
        else {
            viewportOffset = viewportEl.offset();
            viewportTop = viewportOffset.top;
            viewportLeft = viewportOffset.left;
        }
        // if the window is scrolled, it causes the visible area to be further down
        viewportTop += windowEl.scrollTop();
        viewportLeft += windowEl.scrollLeft();
        // constrain to the view port. if constrained by two edges, give precedence to top/left
        if (options.viewportConstrain !== false) {
            top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
            top = Math.max(top, viewportTop + this.margin);
            left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
            left = Math.max(left, viewportLeft + this.margin);
        }
        this.el.css({
            top: top - origin.top,
            left: left - origin.left
        });
    };
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    // TODO: better code reuse for this. Repeat code
    Popover.prototype.trigger = function (name) {
        if (this.options[name]) {
            this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    };
    return Popover;
}());
exports.default = Popover;
ListenerMixin_1.default.mixInto(Popover);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
/* Event-rendering methods for the DayGrid class
----------------------------------------------------------------------------------------------------------------------*/
var DayGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridEventRenderer, _super);
    function DayGridEventRenderer(dayGrid, fillRenderer) {
        var _this = _super.call(this, dayGrid, fillRenderer) || this;
        _this.dayGrid = dayGrid;
        return _this;
    }
    DayGridEventRenderer.prototype.renderBgRanges = function (eventRanges) {
        // don't render timed background events
        eventRanges = $.grep(eventRanges, function (eventRange) {
            return eventRange.eventDef.isAllDay();
        });
        _super.prototype.renderBgRanges.call(this, eventRanges);
    };
    // Renders the given foreground event segments onto the grid
    DayGridEventRenderer.prototype.renderFgSegs = function (segs) {
        var rowStructs = this.rowStructs = this.renderSegRows(segs);
        // append to each row's content skeleton
        this.dayGrid.rowEls.each(function (i, rowNode) {
            $(rowNode).find('.fc-content-skeleton > table').append(rowStructs[i].tbodyEl);
        });
    };
    // Unrenders all currently rendered foreground event segments
    DayGridEventRenderer.prototype.unrenderFgSegs = function () {
        var rowStructs = this.rowStructs || [];
        var rowStruct;
        while ((rowStruct = rowStructs.pop())) {
            rowStruct.tbodyEl.remove();
        }
        this.rowStructs = null;
    };
    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
    DayGridEventRenderer.prototype.renderSegRows = function (segs) {
        var rowStructs = [];
        var segRows;
        var row;
        segRows = this.groupSegRows(segs); // group into nested arrays
        // iterate each row of segment groupings
        for (row = 0; row < segRows.length; row++) {
            rowStructs.push(this.renderSegRow(row, segRows[row]));
        }
        return rowStructs;
    };
    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
    // the segments. Returns object with a bunch of internal data about how the render was calculated.
    // NOTE: modifies rowSegs
    DayGridEventRenderer.prototype.renderSegRow = function (row, rowSegs) {
        var colCnt = this.dayGrid.colCnt;
        var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
        var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
        var tbody = $('<tbody/>');
        var segMatrix = []; // lookup for which segments are rendered into which level+col cells
        var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
        var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
        var i;
        var levelSegs;
        var col;
        var tr;
        var j;
        var seg;
        var td;
        // populates empty cells from the current column (`col`) to `endCol`
        function emptyCellsUntil(endCol) {
            while (col < endCol) {
                // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
                td = (loneCellMatrix[i - 1] || [])[col];
                if (td) {
                    td.attr('rowspan', parseInt(td.attr('rowspan') || 1, 10) + 1);
                }
                else {
                    td = $('<td/>');
                    tr.append(td);
                }
                cellMatrix[i][col] = td;
                loneCellMatrix[i][col] = td;
                col++;
            }
        }
        for (i = 0; i < levelCnt; i++) {
            levelSegs = segLevels[i];
            col = 0;
            tr = $('<tr/>');
            segMatrix.push([]);
            cellMatrix.push([]);
            loneCellMatrix.push([]);
            // levelCnt might be 1 even though there are no actual levels. protect against this.
            // this single empty row is useful for styling.
            if (levelSegs) {
                for (j = 0; j < levelSegs.length; j++) {
                    seg = levelSegs[j];
                    emptyCellsUntil(seg.leftCol);
                    // create a container that occupies or more columns. append the event element.
                    td = $('<td class="fc-event-container"/>').append(seg.el);
                    if (seg.leftCol !== seg.rightCol) {
                        td.attr('colspan', seg.rightCol - seg.leftCol + 1);
                    }
                    else {
                        loneCellMatrix[i][col] = td;
                    }
                    while (col <= seg.rightCol) {
                        cellMatrix[i][col] = td;
                        segMatrix[i][col] = seg;
                        col++;
                    }
                    tr.append(td);
                }
            }
            emptyCellsUntil(colCnt); // finish off the row
            this.dayGrid.bookendCells(tr);
            tbody.append(tr);
        }
        return {
            row: row,
            tbodyEl: tbody,
            cellMatrix: cellMatrix,
            segMatrix: segMatrix,
            segLevels: segLevels,
            segs: rowSegs
        };
    };
    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
    // NOTE: modifies segs
    DayGridEventRenderer.prototype.buildSegLevels = function (segs) {
        var levels = [];
        var i;
        var seg;
        var j;
        // Give preference to elements with certain criteria, so they have
        // a chance to be closer to the top.
        this.sortEventSegs(segs);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
            for (j = 0; j < levels.length; j++) {
                if (!isDaySegCollision(seg, levels[j])) {
                    break;
                }
            }
            // `j` now holds the desired subrow index
            seg.level = j;
            // create new level array if needed and append segment
            (levels[j] || (levels[j] = [])).push(seg);
        }
        // order segments left-to-right. very important if calendar is RTL
        for (j = 0; j < levels.length; j++) {
            levels[j].sort(compareDaySegCols);
        }
        return levels;
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
    DayGridEventRenderer.prototype.groupSegRows = function (segs) {
        var segRows = [];
        var i;
        for (i = 0; i < this.dayGrid.rowCnt; i++) {
            segRows.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segRows[segs[i].row].push(segs[i]);
        }
        return segRows;
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    DayGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    DayGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
    };
    // Builds the HTML to be used for the default element for an individual segment
    DayGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var isAllDay = seg.footprint.componentFootprint.isAllDay;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && isAllDay &&
            seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && isAllDay &&
            seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
        var timeHtml = '';
        var timeText;
        var titleHtml;
        classes.unshift('fc-day-grid-event', 'fc-h-event');
        // Only display a timed events time if it is the starting segment
        if (seg.isStart) {
            timeText = this.getTimeText(seg.footprint);
            if (timeText) {
                timeHtml = '<span class="fc-time">' + util_1.htmlEscape(timeText) + '</span>';
            }
        }
        titleHtml =
            '<span class="fc-title">' +
                (util_1.htmlEscape(eventDef.title || '') || '&nbsp;') + // we always want one line of height
                '</span>';
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (this.dayGrid.isRTL ?
                titleHtml + ' ' + timeHtml : // put a natural space in between
                timeHtml + ' ' + titleHtml //
            ) +
            '</div>' +
            (isResizableFromStart ?
                '<div class="fc-resizer fc-start-resizer" />' :
                '') +
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer" />' :
                '') +
            '</a>';
    };
    return DayGridEventRenderer;
}(EventRenderer_1.default));
exports.default = DayGridEventRenderer;
// Computes whether two segments' columns collide. They are assumed to be in the same row.
function isDaySegCollision(seg, otherSegs) {
    var i;
    var otherSeg;
    for (i = 0; i < otherSegs.length; i++) {
        otherSeg = otherSegs[i];
        if (otherSeg.leftCol <= seg.rightCol &&
            otherSeg.rightCol >= seg.leftCol) {
            return true;
        }
    }
    return false;
}
// A cmp function for determining the leftmost event
function compareDaySegCols(a, b) {
    return a.leftCol - b.leftCol;
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(58);
var DayGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridHelperRenderer, _super);
    function DayGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
    DayGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var rowStructs;
        // TODO: not good to call eventRenderer this way
        rowStructs = this.eventRenderer.renderSegRows(segs);
        // inject each new event skeleton into each associated row
        this.component.rowEls.each(function (row, rowNode) {
            var rowEl = $(rowNode); // the .fc-row
            var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
            var skeletonTopEl;
            var skeletonTop;
            // If there is an original segment, match the top position. Otherwise, put it at the row's top level
            if (sourceSeg && sourceSeg.row === row) {
                skeletonTop = sourceSeg.el.position().top;
            }
            else {
                skeletonTopEl = rowEl.find('.fc-content-skeleton tbody');
                if (!skeletonTopEl.length) {
                    skeletonTopEl = rowEl.find('.fc-content-skeleton table');
                }
                skeletonTop = skeletonTopEl.position().top;
            }
            skeletonEl.css('top', skeletonTop)
                .find('table')
                .append(rowStructs[row].tbodyEl);
            rowEl.append(skeletonEl);
            helperNodes.push(skeletonEl[0]);
        });
        return $(helperNodes); // must return the elements rendered
    };
    return DayGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = DayGridHelperRenderer;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var FillRenderer_1 = __webpack_require__(57);
var DayGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridFillRenderer, _super);
    function DayGridFillRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fillSegTag = 'td'; // override the default tag name
        return _this;
    }
    DayGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var nodes = [];
        var i;
        var seg;
        var skeletonEl;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            skeletonEl = this.renderFillRow(type, seg);
            this.component.rowEls.eq(seg.row).append(skeletonEl);
            nodes.push(skeletonEl[0]);
        }
        return nodes;
    };
    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
    DayGridFillRenderer.prototype.renderFillRow = function (type, seg) {
        var colCnt = this.component.colCnt;
        var startCol = seg.leftCol;
        var endCol = seg.rightCol + 1;
        var className;
        var skeletonEl;
        var trEl;
        if (type === 'businessHours') {
            className = 'bgevent';
        }
        else {
            className = type.toLowerCase();
        }
        skeletonEl = $('<div class="fc-' + className + '-skeleton">' +
            '<table><tr/></table>' +
            '</div>');
        trEl = skeletonEl.find('tr');
        if (startCol > 0) {
            trEl.append('<td colspan="' + startCol + '"/>');
        }
        trEl.append(seg.el.attr('colspan', endCol - startCol));
        if (endCol < colCnt) {
            trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
        }
        this.component.bookendCells(trEl);
        return skeletonEl;
    };
    return DayGridFillRenderer;
}(FillRenderer_1.default));
exports.default = DayGridFillRenderer;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
var UnzonedRange_1 = __webpack_require__(5);
var MonthViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(MonthViewDateProfileGenerator, _super);
    function MonthViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    MonthViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay);
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        var rowCnt;
        // ensure 6 weeks
        if (this.opt('fixedWeekCount')) {
            rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
            end.diff(start, 'weeks', true) // dontRound=true
            );
            end.add(6 - rowCnt, 'weeks');
        }
        return new UnzonedRange_1.default(start, end);
    };
    return MonthViewDateProfileGenerator;
}(BasicViewDateProfileGenerator_1.default));
exports.default = MonthViewDateProfileGenerator;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
var ListEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventRenderer, _super);
    function ListEventRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListEventRenderer.prototype.renderFgSegs = function (segs) {
        if (!segs.length) {
            this.component.renderEmptyMessage();
        }
        else {
            this.component.renderSegList(segs);
        }
    };
    // generates the HTML for a single event row
    ListEventRenderer.prototype.fgSegHtml = function (seg) {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var eventFootprint = seg.footprint;
        var eventDef = eventFootprint.eventDef;
        var componentFootprint = eventFootprint.componentFootprint;
        var url = eventDef.url;
        var classes = ['fc-list-item'].concat(this.getClasses(eventDef));
        var bgColor = this.getBgColor(eventDef);
        var timeHtml;
        if (componentFootprint.isAllDay) {
            timeHtml = view.getAllDayHtml();
        }
        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            if (seg.isStart || seg.isEnd) {
                timeHtml = util_1.htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
            }
            else {
                timeHtml = view.getAllDayHtml();
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeHtml = util_1.htmlEscape(this.getTimeText(eventFootprint));
        }
        if (url) {
            classes.push('fc-has-url');
        }
        return '<tr class="' + classes.join(' ') + '">' +
            (this.displayEventTime ?
                '<td class="fc-list-item-time ' + theme.getClass('widgetContent') + '">' +
                    (timeHtml || '') +
                    '</td>' :
                '') +
            '<td class="fc-list-item-marker ' + theme.getClass('widgetContent') + '">' +
            '<span class="fc-event-dot"' +
            (bgColor ?
                ' style="background-color:' + bgColor + '"' :
                '') +
            '></span>' +
            '</td>' +
            '<td class="fc-list-item-title ' + theme.getClass('widgetContent') + '">' +
            '<a' + (url ? ' href="' + util_1.htmlEscape(url) + '"' : '') + '>' +
            util_1.htmlEscape(eventDef.title || '') +
            '</a>' +
            '</td>' +
            '</tr>';
    };
    // like "4:00am"
    ListEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('mediumTimeFormat');
    };
    return ListEventRenderer;
}(EventRenderer_1.default));
exports.default = ListEventRenderer;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var EventPointing_1 = __webpack_require__(59);
var ListEventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventPointing, _super);
    function ListEventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // for events with a url, the whole <tr> should be clickable,
    // but it's impossible to wrap with an <a> tag. simulate this.
    ListEventPointing.prototype.handleClick = function (seg, ev) {
        var url;
        _super.prototype.handleClick.call(this, seg, ev); // might prevent the default action
        // not clicking on or within an <a> with an href
        if (!$(ev.target).closest('a[href]').length) {
            url = seg.footprint.eventDef.url;
            if (url && !ev.isDefaultPrevented()) {
                window.location.href = url; // simulate link click
            }
        }
    };
    return ListEventPointing;
}(EventPointing_1.default));
exports.default = ListEventPointing;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventSourceParser_1 = __webpack_require__(37);
var ArrayEventSource_1 = __webpack_require__(52);
var FuncEventSource_1 = __webpack_require__(215);
var JsonFeedEventSource_1 = __webpack_require__(216);
EventSourceParser_1.default.registerClass(ArrayEventSource_1.default);
EventSourceParser_1.default.registerClass(FuncEventSource_1.default);
EventSourceParser_1.default.registerClass(JsonFeedEventSource_1.default);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ThemeRegistry_1 = __webpack_require__(51);
var StandardTheme_1 = __webpack_require__(213);
var JqueryUiTheme_1 = __webpack_require__(214);
var BootstrapTheme_1 = __webpack_require__(258);
ThemeRegistry_1.defineThemeSystem('standard', StandardTheme_1.default);
ThemeRegistry_1.defineThemeSystem('jquery-ui', JqueryUiTheme_1.default);
ThemeRegistry_1.defineThemeSystem('bootstrap3', BootstrapTheme_1.default);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var BootstrapTheme = /** @class */ (function (_super) {
    tslib_1.__extends(BootstrapTheme, _super);
    function BootstrapTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BootstrapTheme;
}(Theme_1.default));
exports.default = BootstrapTheme;
BootstrapTheme.prototype.classes = {
    widget: 'fc-bootstrap3',
    tableGrid: 'table-bordered',
    tableList: 'table table-striped',
    buttonGroup: 'btn-group',
    button: 'btn btn-default',
    stateActive: 'active',
    stateDisabled: 'disabled',
    today: 'alert alert-info',
    popover: 'panel panel-default',
    popoverHeader: 'panel-heading',
    popoverContent: 'panel-body',
    // day grid
    headerRow: 'panel-default',
    dayRow: 'panel-default',
    // list view
    listView: 'panel panel-default'
};
BootstrapTheme.prototype.baseIconClass = 'glyphicon';
BootstrapTheme.prototype.iconClasses = {
    close: 'glyphicon-remove',
    prev: 'glyphicon-chevron-left',
    next: 'glyphicon-chevron-right',
    prevYear: 'glyphicon-backward',
    nextYear: 'glyphicon-forward'
};
BootstrapTheme.prototype.iconOverrideOption = 'bootstrapGlyphicons';
BootstrapTheme.prototype.iconOverrideCustomButtonOption = 'bootstrapGlyphicon';
BootstrapTheme.prototype.iconOverridePrefix = 'glyphicon-';


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var BasicView_1 = __webpack_require__(62);
var MonthView_1 = __webpack_require__(229);
ViewRegistry_1.defineView('basic', {
    'class': BasicView_1.default
});
ViewRegistry_1.defineView('basicDay', {
    type: 'basic',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('basicWeek', {
    type: 'basic',
    duration: { weeks: 1 }
});
ViewRegistry_1.defineView('month', {
    'class': MonthView_1.default,
    duration: { months: 1 },
    defaults: {
        fixedWeekCount: true
    }
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var AgendaView_1 = __webpack_require__(226);
ViewRegistry_1.defineView('agenda', {
    'class': AgendaView_1.default,
    defaults: {
        allDaySlot: true,
        slotDuration: '00:30:00',
        slotEventOverlap: true // a bad name. confused with overlap/constraint system
    }
});
ViewRegistry_1.defineView('agendaDay', {
    type: 'agenda',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('agendaWeek', {
    type: 'agenda',
    duration: { weeks: 1 }
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var ListView_1 = __webpack_require__(230);
ViewRegistry_1.defineView('list', {
    'class': ListView_1.default,
    buttonTextKey: 'list',
    defaults: {
        buttonText: 'list',
        listDayFormat: 'LL',
        noEventsMessage: 'No events to display'
    }
});
ViewRegistry_1.defineView('listDay', {
    type: 'list',
    duration: { days: 1 },
    defaults: {
        listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
    }
});
ViewRegistry_1.defineView('listWeek', {
    type: 'list',
    duration: { weeks: 1 },
    defaults: {
        listDayFormat: 'dddd',
        listDayAltFormat: 'LL'
    }
});
ViewRegistry_1.defineView('listMonth', {
    type: 'list',
    duration: { month: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});
ViewRegistry_1.defineView('listYear', {
    type: 'list',
    duration: { year: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});


/***/ }),
/* 262 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });


/***/ })
/******/ ]);
});

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107),
    root = __webpack_require__(76);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1714),
    hashDelete = __webpack_require__(1715),
    hashGet = __webpack_require__(1716),
    hashHas = __webpack_require__(1717),
    hashSet = __webpack_require__(1718);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107),
    root = __webpack_require__(76);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107),
    root = __webpack_require__(76);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(289),
    setCacheAdd = __webpack_require__(1738),
    setCacheHas = __webpack_require__(1739);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(76);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(107),
    root = __webpack_require__(76);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1671 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1672 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 1673 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1698),
    isArguments = __webpack_require__(294),
    isArray = __webpack_require__(67),
    isBuffer = __webpack_require__(295),
    isIndex = __webpack_require__(290),
    isTypedArray = __webpack_require__(298);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1675 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1677 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(501),
    keys = __webpack_require__(149);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1683),
    createBaseEach = __webpack_require__(1704);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1680);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1705);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1682),
    keys = __webpack_require__(149);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1676),
    isArray = __webpack_require__(67);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(146),
    isObjectLike = __webpack_require__(148);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    equalArrays = __webpack_require__(503),
    equalByTag = __webpack_require__(1706),
    equalObjects = __webpack_require__(1707),
    getTag = __webpack_require__(505),
    isArray = __webpack_require__(67),
    isBuffer = __webpack_require__(295),
    isTypedArray = __webpack_require__(298);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(494),
    baseIsEqual = __webpack_require__(498);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(205),
    isMasked = __webpack_require__(1720),
    isObject = __webpack_require__(68),
    toSource = __webpack_require__(509);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(146),
    isLength = __webpack_require__(296),
    isObjectLike = __webpack_require__(148);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1692),
    baseMatchesProperty = __webpack_require__(1693),
    identity = __webpack_require__(293),
    isArray = __webpack_require__(67),
    property = __webpack_require__(1756);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1688),
    getMatchData = __webpack_require__(1709),
    matchesStrictComparable = __webpack_require__(508);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(498),
    get = __webpack_require__(1752),
    hasIn = __webpack_require__(1753),
    isKey = __webpack_require__(291),
    isStrictComparable = __webpack_require__(507),
    matchesStrictComparable = __webpack_require__(508),
    toKey = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(497);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(293),
    overRest = __webpack_require__(1737),
    setToString = __webpack_require__(1741);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1750),
    defineProperty = __webpack_require__(502),
    identity = __webpack_require__(293);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1698 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(199),
    arrayMap = __webpack_require__(1675),
    isArray = __webpack_require__(67),
    isSymbol = __webpack_require__(297);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1700 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1701 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(76);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(1696),
    isIterateeCall = __webpack_require__(506);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(147);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1705 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(199),
    Uint8Array = __webpack_require__(1669),
    eq = __webpack_require__(204),
    equalArrays = __webpack_require__(503),
    mapToArray = __webpack_require__(1731),
    setToArray = __webpack_require__(1740);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1708);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1684),
    getSymbols = __webpack_require__(1711),
    keys = __webpack_require__(149);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(507),
    keys = __webpack_require__(149);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(199);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1673),
    stubArray = __webpack_require__(1757);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1712 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(500),
    isArguments = __webpack_require__(294),
    isArray = __webpack_require__(67),
    isIndex = __webpack_require__(290),
    isLength = __webpack_require__(296),
    toKey = __webpack_require__(203);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(202);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1715 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(202);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(202);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(202);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1702);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1721 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(200);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(200);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(200);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(200);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1665),
    ListCache = __webpack_require__(198),
    Map = __webpack_require__(288);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(201);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(201);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(201);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(201);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1755);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1736);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(504);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module)))

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1736 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1671);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1738 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1739 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1740 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1697),
    shortOut = __webpack_require__(1742);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1742 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(198);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1745 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1746 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(198),
    Map = __webpack_require__(288),
    MapCache = __webpack_require__(289);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1732);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(495),
    copyObject = __webpack_require__(501),
    createAssigner = __webpack_require__(1703),
    isArrayLike = __webpack_require__(147),
    isPrototype = __webpack_require__(292),
    keys = __webpack_require__(149);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1750 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(1672),
    baseEvery = __webpack_require__(1681),
    baseIteratee = __webpack_require__(1691),
    isArray = __webpack_require__(67),
    isIterateeCall = __webpack_require__(506);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(497);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1685),
    hasPath = __webpack_require__(1713);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(499),
    getTag = __webpack_require__(505),
    isArguments = __webpack_require__(294),
    isArray = __webpack_require__(67),
    isArrayLike = __webpack_require__(147),
    isBuffer = __webpack_require__(295),
    isPrototype = __webpack_require__(292),
    isTypedArray = __webpack_require__(298);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(289);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1694),
    basePropertyDeep = __webpack_require__(1695),
    isKey = __webpack_require__(291),
    toKey = __webpack_require__(203);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1757 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1758 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1699);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports = {"version":"2017c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.14
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.14",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 510,
	"./af.js": 510,
	"./ar": 517,
	"./ar-dz": 511,
	"./ar-dz.js": 511,
	"./ar-kw": 512,
	"./ar-kw.js": 512,
	"./ar-ly": 513,
	"./ar-ly.js": 513,
	"./ar-ma": 514,
	"./ar-ma.js": 514,
	"./ar-sa": 515,
	"./ar-sa.js": 515,
	"./ar-tn": 516,
	"./ar-tn.js": 516,
	"./ar.js": 517,
	"./az": 518,
	"./az.js": 518,
	"./be": 519,
	"./be.js": 519,
	"./bg": 520,
	"./bg.js": 520,
	"./bm": 521,
	"./bm.js": 521,
	"./bn": 522,
	"./bn.js": 522,
	"./bo": 523,
	"./bo.js": 523,
	"./br": 524,
	"./br.js": 524,
	"./bs": 525,
	"./bs.js": 525,
	"./ca": 526,
	"./ca.js": 526,
	"./cs": 527,
	"./cs.js": 527,
	"./cv": 528,
	"./cv.js": 528,
	"./cy": 529,
	"./cy.js": 529,
	"./da": 530,
	"./da.js": 530,
	"./de": 533,
	"./de-at": 531,
	"./de-at.js": 531,
	"./de-ch": 532,
	"./de-ch.js": 532,
	"./de.js": 533,
	"./dv": 534,
	"./dv.js": 534,
	"./el": 535,
	"./el.js": 535,
	"./en-au": 536,
	"./en-au.js": 536,
	"./en-ca": 537,
	"./en-ca.js": 537,
	"./en-gb": 538,
	"./en-gb.js": 538,
	"./en-ie": 539,
	"./en-ie.js": 539,
	"./en-nz": 540,
	"./en-nz.js": 540,
	"./eo": 541,
	"./eo.js": 541,
	"./es": 544,
	"./es-do": 542,
	"./es-do.js": 542,
	"./es-us": 543,
	"./es-us.js": 543,
	"./es.js": 544,
	"./et": 545,
	"./et.js": 545,
	"./eu": 546,
	"./eu.js": 546,
	"./fa": 547,
	"./fa.js": 547,
	"./fi": 548,
	"./fi.js": 548,
	"./fo": 549,
	"./fo.js": 549,
	"./fr": 552,
	"./fr-ca": 550,
	"./fr-ca.js": 550,
	"./fr-ch": 551,
	"./fr-ch.js": 551,
	"./fr.js": 552,
	"./fy": 553,
	"./fy.js": 553,
	"./gd": 554,
	"./gd.js": 554,
	"./gl": 555,
	"./gl.js": 555,
	"./gom-latn": 556,
	"./gom-latn.js": 556,
	"./gu": 557,
	"./gu.js": 557,
	"./he": 558,
	"./he.js": 558,
	"./hi": 559,
	"./hi.js": 559,
	"./hr": 560,
	"./hr.js": 560,
	"./hu": 561,
	"./hu.js": 561,
	"./hy-am": 562,
	"./hy-am.js": 562,
	"./id": 563,
	"./id.js": 563,
	"./is": 564,
	"./is.js": 564,
	"./it": 565,
	"./it.js": 565,
	"./ja": 566,
	"./ja.js": 566,
	"./jv": 567,
	"./jv.js": 567,
	"./ka": 568,
	"./ka.js": 568,
	"./kk": 569,
	"./kk.js": 569,
	"./km": 570,
	"./km.js": 570,
	"./kn": 571,
	"./kn.js": 571,
	"./ko": 572,
	"./ko.js": 572,
	"./ky": 573,
	"./ky.js": 573,
	"./lb": 574,
	"./lb.js": 574,
	"./lo": 575,
	"./lo.js": 575,
	"./lt": 576,
	"./lt.js": 576,
	"./lv": 577,
	"./lv.js": 577,
	"./me": 578,
	"./me.js": 578,
	"./mi": 579,
	"./mi.js": 579,
	"./mk": 580,
	"./mk.js": 580,
	"./ml": 581,
	"./ml.js": 581,
	"./mr": 582,
	"./mr.js": 582,
	"./ms": 584,
	"./ms-my": 583,
	"./ms-my.js": 583,
	"./ms.js": 584,
	"./mt": 585,
	"./mt.js": 585,
	"./my": 586,
	"./my.js": 586,
	"./nb": 587,
	"./nb.js": 587,
	"./ne": 588,
	"./ne.js": 588,
	"./nl": 590,
	"./nl-be": 589,
	"./nl-be.js": 589,
	"./nl.js": 590,
	"./nn": 591,
	"./nn.js": 591,
	"./pa-in": 592,
	"./pa-in.js": 592,
	"./pl": 593,
	"./pl.js": 593,
	"./pt": 595,
	"./pt-br": 594,
	"./pt-br.js": 594,
	"./pt.js": 595,
	"./ro": 596,
	"./ro.js": 596,
	"./ru": 597,
	"./ru.js": 597,
	"./sd": 598,
	"./sd.js": 598,
	"./se": 599,
	"./se.js": 599,
	"./si": 600,
	"./si.js": 600,
	"./sk": 601,
	"./sk.js": 601,
	"./sl": 602,
	"./sl.js": 602,
	"./sq": 603,
	"./sq.js": 603,
	"./sr": 605,
	"./sr-cyrl": 604,
	"./sr-cyrl.js": 604,
	"./sr.js": 605,
	"./ss": 606,
	"./ss.js": 606,
	"./sv": 607,
	"./sv.js": 607,
	"./sw": 608,
	"./sw.js": 608,
	"./ta": 609,
	"./ta.js": 609,
	"./te": 610,
	"./te.js": 610,
	"./tet": 611,
	"./tet.js": 611,
	"./th": 612,
	"./th.js": 612,
	"./tl-ph": 613,
	"./tl-ph.js": 613,
	"./tlh": 614,
	"./tlh.js": 614,
	"./tr": 615,
	"./tr.js": 615,
	"./tzl": 616,
	"./tzl.js": 616,
	"./tzm": 618,
	"./tzm-latn": 617,
	"./tzm-latn.js": 617,
	"./tzm.js": 618,
	"./uk": 619,
	"./uk.js": 619,
	"./ur": 620,
	"./ur.js": 620,
	"./uz": 622,
	"./uz-latn": 621,
	"./uz-latn.js": 621,
	"./uz.js": 622,
	"./vi": 623,
	"./vi.js": 623,
	"./x-pseudo": 624,
	"./x-pseudo.js": 624,
	"./yo": 625,
	"./yo.js": 625,
	"./zh-cn": 626,
	"./zh-cn.js": 626,
	"./zh-hk": 627,
	"./zh-hk.js": 627,
	"./zh-tw": 628,
	"./zh-tw.js": 628
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1762;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module), __webpack_require__(38)))

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1768);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1768 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(109)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(69)))

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(1769).Buffer;

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return -1;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd'.repeat(p);
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd'.repeat(p + 1);
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd'.repeat(p + 2);
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character for each buffered byte of a (partial)
// character needs to be added to the output.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cs_bg.aea5ff0.png";

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA1CAMAAADLRm3ZAAABGlBMVEUAAADxqz7wqj72rT/v6jnv6Tnx6jn08TftlCju6TnxsTzv6Tnu6Tr2tzz/tjf//zDuojTwqz7v6Trv6TrwoTPu6Tnv2zrwqj7ulyvxzjvxqz3v6jru6TnumS7v6jnwqz3xmi7v6jjxqzvx7Tfy6zv0lSDxqz7v6jpNTU0yMzM0NTXv5Trxujzw3DrxrT3xsTzw0jvw1jrwwjzxvzzxtjzwqTzwyDvw6DlTUEuEbEfHk0HNlT3xvDygeTzv4Do7OjbTmUDxxjyRcDzwzjvwyzvw4jnupTlgV0pnXEmgfEWlfkDCjz+6ij/ppj7Ymz7wsz3xrj3v2Trv0jpMRTnvnTB2ZEjlpD+LbT2tgDyFaTxrWDtpVjpRSDntjyUlFC0UAAAAJnRSTlMAgPMc4r5HF/iXjoFpKg4I9u/r6tvVz724saabmZaPeW9gSTgnGCsvjhcAAAH1SURBVEjH7dbXdoJAEAZgkpiY3nuvC4YiomiMJTG92DU9ef/XiLO4ICIsuLnIhf+V6x6+Mww7KMdxh8gl8ydcgKy5Mfp6AGUGuWY8ALPpzjR3fCsjyD13/suZ9GD0n32/zALySHN5iJ5ZYIYRa0YGzID510zp6aXxVWZlnu8F4TQS+ei5GZUkqeqHuTwTMBO5cmwpmsxD5DidSQtt5qJ7R8rzJOoMhdHPCBPJdCkp3koo7M2UBJN5t3dF5DszSrkpt2piPCRWyBYMb7qv3lTg0lQcd1qFz0tznkyZPKmc7eskXKp1VjbmfW4ycG4czxuuFMkiAcwU5RQ/AvON7JGhMeYK2jNBYdLAXPRgaubqtrXaojAP+KbukC0qdLhKHr6Pm9KNFj8jZ4tv2otrHy2+FHq1OIrPcMEiQ5QJLxrMJ1mbFUDyWjZpjNYBhXk0mEb3eOcDDQNKY8Y54AmxU5mjMQ+YsR6V1R7ZVK6p7xudzFTRsaUZxm1d8vH2I8ybYwuPZFzx9S5+PW/lKZfLZRxbIpTC9AMTzyrGQNZZGChEruF7YmESPInCVE1FU/GxkRFTNfDLgIeThVFSopq9AUZiYSTSGRGxMNFkew5iNmZvKHAmV4HZsP5e95kJYMIca0ItZYVZOYZidpmZ8PYivMX/IEfT9vUv3QG5hlYPd90AAAAASUVORK5CYII="

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAfRJREFUSA1jPCIjf+Hvv/96DDQETIyMbxj//7Zl+fefQV9ano+GVjEwvH3xle3XLxZVJpragmY4SZYxcnAyiJbVMvD5BqEZQxyXJMuYBQQZ/v/+zcChb0Sc6WiqWND4OLnMgsIMwtmFDDxO7gz/f/1kYAL68mVrDcP/799x6kGXIM4yVlYGmVlLGFikZcD6Gdk5GLid3BhEf3xneNVSg24mTj5Rwcjr4gG3CNkkXlcvBgZGRmQhvGyiLGOVV8JuCNDHzCJi2OWwiBJlGSMTbmWM1PYZFkeSJYTbyWQZh18TQcsEkzIZeEAJAQcQb+5mYNfQxiGLKkzQMj4vPwYWcQlUXUg8Dl0DBnZ1TSQR3EyC+expdiIDq5Qs2ARQPhOramL4/eAew+vuFrDY////GH5cOo/bBiQZgpb9efmCAYTB4Pxphr8f3jP8+/KF4ceFM0jGEMckaBm6Md+OHEAXIprPAsz/r988/0ow7rh42Tm5eFi4kE3+/PHH55/f/v5CFsPG/vPv33/G/wwfgD77Y/P7N7MaNkXIYl/efUtjYOB04uJh5QaJf3z348OPH797//35fwFZHTY2yCKbZ4+OEF+wAU05KiO/mVeQw/HXzz+/fn7/M9X68cNabIZTTeyonPyiozJyZVQzEJ9BtxkY2PHJ45MDAA4Dgx0wJ4NUAAAAAElFTkSuQmCC"

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAeRJREFUSA3Nlc9LG0EUx78zO0k2v1asUUvroQb0pkUhUihILz1VEBR6KfTSSy8FexMEr956qvQf6FVB/AOKIAhiITcPFTxZC9uSNYImm81MJ60JmwnjTiQBB5bM+773vh/ekpklh1u5IufkKfq4KBW/BcFzVq9jOj8W7yMKOHf9WNUXk7SvFMW8Oxi1kc1vIDn6RrExC7uCUTYIiACx7JyZu1LFlFgbEgnKPllHYmgB4FUQOWX55CMEv9L2qAkzGGF4MLUDy87/75egxNArZIWP8o8Pqqc2NnqNtpymBQpZ2blFgMRCyu1bI5iVnNC4UND4Q02uUzaCgZDOzhuFQJ9Tm8xgatcd4/sFSz16j2RuWTuLM/kZLDOjzYcTkZPZw0ugicfhnrZ9LDOLuFNo03RB5Dnzjt/Kv/34v34aH8HAxKY802e4OFm58RSoXX7X+bfpkTDu/0LjaS4v8OSVJQHlg6Zk/BsJU518b0+VjGNmWXB/ujUrqsNJk2QmxVLhulI5uLyuyjsrYslvphCCeIzUMe9zrrsiWjalAO+4IC+dtJVuiH8uglKlEnyqBaTYKtJsGqBnr9198+MvjY62c7uDDnshp6ldV/iXwrK7pvHvjSyBX4+2h1d74xbhcvoNdkSJNv0XY3J+T/EnVEIAAAAASUVORK5CYII="

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAAaVBMVEVKqdNKqdIAAABJqNRGpdJJqdJJqdJJqdKCxOFJqdNJqNNJqNFJqNJJqNNIqdRKqNdHo9bl8/iaz+a13O3N6PNKq9OMyePG5PGm1eqZz+V8wd90vt5rudtftNhWsNZJqNO84O+Qy+T///+uru+6AAAAInRSTlP0zACZM8Dn4/fv69nWs1kmGf75+/xM+Pz6+ff29vX0jPv4OyDz4gAAAONJREFUKM+Fk9cagyAMhUMBce+92vr+D1kDbu2Xc0d+IBtem+KQc8kk52G8GzcuArYrEBcecXYWj45cSHaVFDsvjMlTLgC4yjPHYuVCH30HVjm+tgjDI/25BUdZ2kWkOV/w/QJHLjZ8vyBmHqBvuAtjCF4Q4z3ngTsIYggxMXgSphkCRqdW0zj0nV2mbWIDgJrJW3MsS9t/q2YyyjR3MQNAL/h0yvMpPXFEkuBs43WZJk/vjX+jYY6tzj5Vs/tf4r+oG9f4qfyp+hH1/98/pftH9J+aH2L+iPml5p/eH3r/qP39AZc/D5N7rMtrAAAAAElFTkSuQmCC"

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA8UlEQVRIid2X0Q2CMBCGPxvfZQQ2cARxE0fQCcQN2MAZ3KBugJuwwe9DhRjCg6VNevFLLiGXcvmg10KRhKRKktfvDJKaz71ZYrw4R0h8c8ol4ghUrOMOaGX0QDMWcpRjD3QWRCDIAOVFJhxwAq4FHXqg2kgagF1BEYCLMyABUJnqERPkELkBTwsiLeBTi/zV1OTAO+BV2gLCGxkixh+BzSwg9Mk8H9XA25jBhM9BM8u1n9w8X0dVVtyf2RJIahNrNFaa1cyq6a2IDFvCrnhIKOKJbcwFYlfNEikPMWFlamyJ+MIOD2A66XWJG9Jaekm1JN64/BLAJMA3QQAAAABJRU5ErkJggg=="

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBljZM7b/p+BxoCJxuaDjR8+lgAAZp0CL3j6cqoAAAAASUVORK5CYII="

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj1Fn24D8DjQETjc0HGz98LAEAP2ACuYjgnroAAAAASUVORK5CYII="

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj7D0k/5+BxoCJxuaDjR8+lgAA1asCdUTlWzEAAAAASUVORK5CYII="

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_dp@3x.78f453f.png";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_pr@3x.17e778f.png";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_ro@3x.adf8a1b.png";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_tm@3x.9fb3368.png";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_wt@3x.a1e780f.png";

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAFSUlEQVR4nO2dMUwbVxjH/+85+OCCQaQmVYSEG2eJK0WpKitTgKEdmiUVytKFVumUKVL3MDlSNypFGZgqFWVsisrQdqBDTCdEK6VIdhZojIpQ6mstm3L12bFfh1LqOwtC4T3uM/5+Ez6j7332z/fuvXd+n4VSCkF+366f64tGPobA+wK43vYPzJFRwA9Q+PqvWuPz12I9fwSfF0Ehbq2ZAXBXAAMnlWQ3ooAKgAd2VE63Ht8T4nrNIQgs8BlxsuyeMTdtS5YAQALA5ExOsIxwEMB1CCxMzuQEsHuGuLVmRgD3wk6um1HAfTsqp8VOtZEUAmthJ8QASuGShMDtsBNhdhG4LVyv8TOAK2HnwgAAVoXrNdonIkxoyLATYPywEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKcMd1AbtNFwanC9ZqmmzJOIm4hEe/F8ECPsTaMCHG9BuaWfsPK+jbcWueLCJIasXHrWhxvjtjaY2u/H1Jwqsh8tXEqRQR57+oQPhx7XWtMrdeQbpIBAN89LWF2cUtrTK1d1uziVpuM1IiNicuDiBvsd08C12sgt+kimy/7XmP2WRnpZD/SyZiWdrR1Wdl8GbPf+z8td965gPHUoI7wZHC9BjLzGyg43t6xeKwHDz66pCW+ti7rybOy7/HU2PlTJwMAbCuC6clR2NH/3jpnu46CU9USX5uQ/Ka797cdlbhx9Zyu0OSwrQhuvOV/fbmW138cjEwME8O9JsKSIhUY8uqaZ/FMnRgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBhGNuwUilVk5jdMhCaD6zWMxDWzg6rW9H3Xlzk83GURw8gZYkflqf/Ctes1fHtEdGFESGK4F9OToyZCkyG36eK+geskd1nEYCHE0CakdYtXoVg1Niykwsr6tu+xbel5K7UJad1R5Naa+PZpSVdochQrdWTz/j2V6Yt6duFqEzIR2OD5eNnB42VHV3gyFJwqZr751bc1OjViayu3obWSQ2Z+o21CGI/1IJ3sx1kroquZ0HherOLHX/5sO35vclRbmQ2tQlyvgbtfrHVNJQdA/158raMs24rg0w8uIhG3dIYli4nCCMaK8WfzZXy57MDZrpsIHxp2VCKdjOHWtbiRMk3Gfx2hWKmjqEGKU6n7Snck4ham9qnEk82XkW2pLDE1dh6J+PGXcs5aUkucgzBewGx4oEfLJykH/2AhnYzteyF1KnWfENdrGqltZYKOmakHR2/Dsf0lBysP7XTQJLVjhBQr/m7voHJPbwQGFSZWZU3ROUIC16GDuiDbirQt5XQKHSMkWG3oVbTej3FrzY5ZW+sIIcE38zA3v4Jzoecd0m0ZH2Udldb6U8HiYHZUvrI+VbBcUnB1luqoi+SvtM0ubvmGrSYYvzyIO+9eMNrGUSDXZc0tvTAuA/ineOXc0gvj7fxfyAmZSA0e6qJ9XOyobLtlQAGSXVbBqWJlvX2ZWyfpZL/xZZCjQFJIN0Ouy+p2WAgxWAgxWAgxWAgxWAgxWAgxWAgxWAgxpBA43ZsBOwghsCEBLISdCLPHgtipNpJCYC3sTBhAKVyStiXXhcDDsJPpdoTAQ9uS60IpBddrDgmBJwCuhJ1Yl7KqFCZsS5YkANiWLCmFCQCrISfWjezJAFqGvbYlS31ROS4EHoWXW3chBB71ReX4vzIAQCjVfn/Ke9l8Wyl8AuCmUhg4ySRPO0KgAmBBCHxmnZE/BZ//GydsuCCCbJCsAAAAAElFTkSuQmCC"

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAAXNSR0IArs4c6QAACOJJREFUeAHNXGuMFFUW/mp6ehgYRJihZ8QHM/ER5ZevTXxkRd1kjf5y3WjEbHbQaDBmo1ETE7P7w1EX1E1UjCZGEmEG8bFiXPSPj0TcXbMRNSomPuNCRARhcBhBZmC6u7r8Tk+3U1Tdqnur+la3J+lU3XPP63517qPu7W4HTaTdK7CwvYRl8HA53V7CT5eB+wnK/BsOXi/n8cLxa/CDgU7DIk7DFgwMjA7ibLThbwTkSjaw3UBFLeKhTP1XUMHK3vX4WC1kh5spMLtvRH/exWoP+IOdcGesMPBNpRxuP/5p7Jjh2rvLBBgC4exbjlv5dB9kqLPthRuydJhZeHdhBI+zIXRrj6wDM/YnzKvkMZJFlkQ1m43Y1FbC8p5ncTBKJinfKjDf34BCzsNrDOLcpIFYkP/QdXDFonXYZ8EWk90SfTeIno4c3mFCL0ll0t8R0kbl4Iuii4tOXI+xVDH4lNKG4DMB7LwGs2d1YTOZ5x9VEVUgCOVD/DDxy5yMvXJY0OHc1c7JvH0eP3NZbx7plqkJ/O6kjTgctmrOST91+nwQlMdZNAKl9CMwxWT3Sj4DilsBq3Rg+uPkgVkFID9fIRhmnV+L56ZwlTnH/DlE2By9Adey+7wQUf0LW4A4vAtwJ39hJb7JzeEUdwKTh0BpycGy3nX4p1YuQqAhYPavwLHlIr6i7b4I+1W2e4SgfKvuMnF6qjrpYrMXA7lOVe1RvL3tHTi9ew2Yd8mpLbnKjEZpCvewFAtKZQqY/MYOKOJZupjYE7sa6qvFpxFTV6fOmOp7T7G66mSCq8lzgYnt0eOJ09GJrkv/iDkXXI78wBK0HbMAlZ/GUfrmC0y++zom3n4ZXpHppiDpTl0ns1vlFJUzrMlyB/rTvF+lHnxzJa5sgUhQJLapPdGgzL3sOvTc/ghyPcfNNKN2N2vJbzD3ij/DHduDsdV34tCbz4dkZMwS+50cc2JoTi1OyexElKorcbZ1HA+DcZ5cTpYyq4TIcbDwrifQe/9zSlD88gKayIk8PfqrqvdiX/zEkcQp8cbJqOpSATO6HBfS2IDKYJ1XjNgc6L5lFeZd/Ze6mNFV5EVPRVF+fLIDtXh9LP1tKmCI/+/jTMsAWf4pLNF55m8xf/nd4QoDjuiJfpBkoShjWSxp4lXppgKGeXmxylidF7VW6b5lZV0k1VWpz37iylZWDOniVammAoaGzlIZq/NU/b69cAI6z15aF0l1FX2xEySVv4BMbLwB2WoxMTC1gSx2cV7hjBGk2eddFmSlKqvsqPwFjMfGG5CtFhMDgyH9CK/q8/mTTlX5T8zLLz4tpKPyFxRKOjMlByboUVVmFEGSxZwNUtpR+GvUVybAOAqr7vhoo7FW9d39e0N2VP5CQgkZiiYktKAQV739Tn3+gUIyOUtlR+UvueWjNZIDM6TfdG7rONqJlI58/F9UDu4PVyTgiP6Rre+ENFT+QkIJGYmB4ZpA26Nl3yRInlvGwX89FWQnKou+Vw5PeSp/QcMmcft1EgMjynSyw28keJ/jgYkqvcfXrURpF1+3U5DoiX6QxI/4iyNdvCrdVMDQ0FaVMT+vY4G/NH3vHZ7A3ruuhPtjxItUWKXKEXnRE/0gqfwEZVjWxhvUSQUM+9JbQUPBcr6bWaPY1Chu+xS7b16K4vbPgirKsshV5akXJLEvfnRkEm/QRipgyjm8GjQULMsU2rkoyJ0uy0bUrsFzMPboHSjt/FopJHypFzmRV5HYN5mqTeIN2mf3S0f7rscWPonzdNpTXHYUNac8+RNPQb7/DOQWFOCO70Npx5cofbct1nRHD08O+mJFqpVs4HuFYbMTDL81RbL7q6PvKw6e4CaQFhgJvn4UEmVNQNAB4dfNH2sGiuhInH5d0/tUXUmM9x7Ci7wodl3CrmX7UZ6wDRI7mu1Mv5vRWpx+ntF9amCcjSjSw1ojLxSSzJFjj7SLMdETfZPuU4+JXf3JWpx1lvE1NTDiwSnjIV7U2/iKEOSoteuU6UG5zfCdUuRkkBW96lGtwm4E6wCxXB1Rp2WnHnzrlnkS+RjXwrfVy0muMvbIJpPsp1S3DviIZfUoRyJttYWbaso38uHhgd4R/NVIViHUMDD7B7G43Ib/0zab8quhCZ4nDaQ5T6q3oKGuJEa61+NbPmjjsabuOMsrZ8snGwFFYmsYGDGSr2AVuxM7xq+CjsDFI41GYgUYyRqODc82GowVfQdrChvwfaO2rABTDSKHv/OqO+FpNF6dfqndxcM6IZN6a8D0Ps0BuMVZI2NdNXtNWq6RsQaM+OEsK+samXRbQS5HzH/YcmwVmJ51+JyByatCK2hD31pst+XYKjASVM7BfbaCS2DH4/bDAwnktaLWgZGs4arxFa1nuwIvFtZWv/Jmzap1YCQyr4J7rUVoYMj1cL+BWCKRTICRX4Z4jn6XL1GkEcKSnYtGYLZPGmFDxc4EGHHk8SVO5dA2L6vszAyY44axhSC8YRuIgL03svrdUmbASAMqwFCgIVaLWdrPFJha1vzHKho1Y1xFbq7Zz8K8nbfruMg4OA7F1aet4xO1PhP5Y2Hc2dPo9ZCsWWrR0/96hxH+pqJFB5l2JV+ctmcoeZPPlJqSMdIC0wM6XWs5trzfN6w/z9LZ0dU3K2PklXtIF4xhve3sU7ptWsYQGIdZ8xGjOEsZiRlzK49bz2HQNJctNS1jpDFszb0NNYc/V24GKBJj04ARZ5xJ5K17q9wnJv4QtNCPjYn1Uio0FRh52vzILl9iYratcoZkMd0caiow0qSFA9zh49NP2Lxtvf36310mtBkr3nRg5KnzQOy+2KiClXxTp15Tz62aDoy0mVnzEi/bgu2PKO8sTOKZiLrM2C0Bpvb0jVav1bFl+isnmYGgMtwSYCSQwgA28KLLmj3FCYyoAs+a1zJgJGv4M8cH4xooM1ijf0UQZz+urmXASFAL+7GWXWWzKkCC8h7HolTfn1PZS8prKTAyQ/HLg8sYtGyD+ukTzkFXNXsm8gfAB9N6YtY44yswr1RBZ0cZU/OHcYCBkd06+hmSvznHT660vgAAAABJRU5ErkJggg=="

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAADulJREFUeAHtnXtwVcUdx38JgYT3y4SkISEJFKxUWmAQn0gRLQ0P6x+2tM501D6FaaEqUKX+pYxUqMW2o3U6I+1Mp+J0Oh0BUZBBK/iglkIZoShCXmB4GB4Jz/Dq/i455CRclntzz967v93vzjA595x7z+757O/DfZzd32ZdUIVQQAAE4hLIjrsXO0EABGIEIAgCAQQ0BCCIBg4OgQAEQQyAgIYABNHAwSEQgCCIARDQEIAgGjg4BAIQBDEAAhoCEEQDB4dAAIIgBkBAQwCCaODgEAhAEMQACGgIQBANHBwCAQiCGAABDQEIooGDQyAAQRADIKAhAEE0cHAIBCAIYgAENAQgiAYODoEABEEMgICGAATRwMEhEIAgiAEQ0BCAIBo4OAQCEAQxAAIaAhBEAweHQACCIAZAQEMAgmjg4BAIQBDEAAhoCEAQDRwcAgEIghgAAQ0BCKKBg0MgAEEQAyCgIQBBNHBwCAQgCGIABDQEIIgGDg6BAARBDICAhgAE0cDBIRCAIIgBENAQgCAaODgEAhAEMQACGgIQRAMHh0AAgiAGQEBDAIJo4OAQCEAQxAAIaAhAEA0cHAIBCIIYAAENAQiigZPuQ3WHTtGcVz4m/otiB4GsC6rY0RS/W1F18CQtfK2Kmk6dpR65nWju5HIaUtDNbygWXD0EsaATPj1wgp5eWUUnm89dak3XLp3osSmQ5BKQDG1AkAyBD6r932fHafEb1W3kCI7ldc6mRyaV0fDiHsEu/E0zAQiSZuDh6rbtPUaLXq+m5rPnw7vbbHfJyaY534AkbaCk8QEESSPscFWbaxrpuTdrtXIEz8/JzqJZdw2i0WW9gl34myYCECRNoMPVbKpupCVraujc+cR/H+mkJJkNScIY07INQdKCubWS9z49Qi+sq0tKjuDVWVlEMyaU0i1f7BPswl/DBCCIYcDh07+78wg9v66WUvlhnSX5yddK6LahfcOnxrYhAhDEENj2p127vYGWrt+bkhzhcz54WzFNHN4/vAvbBghAEANQ259y7bYGeknJEXW5/9ZiuuvLkCRqruHzQZAwDQPbyzcfoGUb9xk488VTTh9bSNNGFhg7v+8nhiAGI8C0HEHT7x0zgO4ZPSB4iL8REoAgEcIMn+rljfW0YvPB8C6j21NH5tN3xhYZrcPHk0OQiHud72ws+0DJsSV9cgSXUDkin+67uYjUD10oERGAIBGB5NOwHEvf2Uv8i1WmysTr+tMD44ohSUQdAEEiAnle3dzgX6rWbT8U0Rk7fprx1/ajH9xeTNl80wQlJQIQJCV8F1/McvDdcb4RaEvhu+0PTSiBJCl2CARJEeBZNZ6K5XhfDSGxrYyt6E0zJ5YSD3ZE6RgBCNIxbrFXsRxLVtfQf9TIXFvLqEG9aPbXB0GSDnYQBOkguNNqDsdzakTultqmDp4hfS8bUdKTfq4kyVVzS1CSIwBBkuMVezbLwROdtqsJT1LKdWpWIk+8giTJ9RgESY4XnVDzxhcrOXbUH0/ylZl/+tDCbjS3spy6qfnuKIkRgCCJcYo9i+Xg5Aq7VJIFqWWwypTCySAgSWI9CEES40SNJ8/Sr1RanqrPTyb4CnufVto/jx6fUkG9uubY20hLWgZBEugIlmPBit1OJXQr6ZdH86dCkqt1PwS5CqFDx8/E5Kg/cvoqz5R3eEDvLvTEtMHUr3tneY1PU4shiAY0y/Hkq7tof2Oz5lmyDw3o1YV+qSTp3wOSxOtJCBKPitq3/2gzPbViFzUcO3OFZ7izm99B+J2E31FQ2hKAIG15xB6xHE8u30X8DuJLYUnmT6ugot65vlxyQtcJQdph4szq/IWcv5j7Vnrm5aiPWxXEX+BRLhKAIKFIqG24KAdnWPe1sCR8n6Tsmq6+Imhz3RCkBUe8DOttSHn0AJnlWzsbgigWO/efiK3NEV5+oBWRn1ssydzKMhpW2N1PAC1X7b0giWRY9zVCkFmeyGtBttY10bNqPodu+QFf5QiumyXhpNlfLe0Z7PLqr7eCdCTDuleREbpYnzPLeynIxt1H6fdrazuUYT0UN15tsiQz7yihGwf38eq6vRMkigzrXkVI6GJ9XH7BK0He3nGI/vjPPZFlWA/FjjebLMn3xw2kCV/q58U1eyOIqQzrXkRJnIv0ZfkFLwRZtfUg/eW9+jjdjF2pEPjuTUU05Sv5qZzC+tc6L0i6Mqxb39OGGuj68gtOC/K3D/fRPzYdMBQaOG1A4O5RBfTtGwqDh079dVaQdC8/4FRUdOBiXF1+wTlBOMP6nzfspTUfZS7Degfiy4mX3KnWTLxfrZ3oUqJTpwSxYfkBJyI9hYtwbfkFZwThDOt/eGsPbfjkcArdi5dGQcClzPJOJEaycfmBKAJN6jmCZSB4PXceoiK5iH8HkZBhXXKApNJ2FzLLixbkzLkLsQzrNi8/kEqAufBaluRnd5YSD5uXWMQKIjHDusQAiaLNkjPLixTk1JnztPgNWcsPRBFoks/Bkjyi1ijhqbySijhBXMiwLilAomyrxMzyogThdDzPrKoWvfxAlAEn8VwsCS/kIyWzvBhBXMywLjHAo2izpMzyIgThFKC8NgdnPURxgwBLMm9yufWZ5a0XxIcM626EfPJXwZnln7jb7uUXrBaEk0gvfG2308sPJB9Wbr2iQEny2OQKazPLWyuIjxnW3Qr9xK/G5uUXrBSEv2ssVN85Dnu0/EDi4eTmM/uq5Rd+ob6T2JZZ3jpBWI6nlu8mnzOsu6nA1a/KxuUXrBKEM6w/s6qKjp06d3WaeIaTBHrkqqTZ6p1kiLpfYkOxRhAsP2BDONjRBpuWX7BCEM6w/ms1torHWKGAABPIVaN/H1V33IerMVyZLFaMQV62cR/kyGQUWFg3j9bmuMh0sUIQHpszqH9eplmgfosIlKp44LjIdLHiIxZDwCjdTIeCPfXbNOrXincQ7ppuap4ALx7JcFD8JWCTHNwL1gjCjYEkTMHfYpsc3BPWfMQKhwWm04Zp+LHNMw4fnVRGeZ2t+j/brneQIBT4Jz7+gsbQUNwnEMxZt00OJm+XrqFYgCQhGA5vBnJwf9tYrPyIFQbFH7d++2Ytba5pDO/GtgMEeOXcWWoFXVvlYMTWC8KNRHI4puBWkZJUzs73tXaxkKPSV85WKWMYKop8AlLkYNIi3kGCkOB3El6++V9qGWcUmQTGlPemn6pMi/yfnoQiShAGikTVEsIqfhslZn0X8RErjDtbrUP80IQSYtgocghIlIPpihMk1ugWSW4d2ldOhHjcUqlycJeJ+4gVjjOsKBWmYed2bMUpXpZNxleOyyCKfAcJroKZPzCumLgTXCgcROOG9RUbTO374NJybELl4OsRv8JUIAlfzNrtchfu5JWYeEUm/jgyoqQnvbCujs6pX+2klktySL2AlnaL/ogVZs+h9PIH9bRyy8HwbhHbnTtlqUVmBtHostb7PJuqG9UIghriRYKklcoR+XTfzUVOrHbrjCBBEElbH51XXuKBmfHmXvNc/cWvVxMPt5FSXFsv3TlBOJCkSJJI9g5J2V5ck4NjyUlB+ML+/u/9sX+8bWPhJGmPT61IaC6+hGR694wuoHvHFNqIOqU2OSsIU1m++YAVmTHa9xDnop2v5Cjqk9v+0BUf1x89TQtUxknOdm9bmT62kKaNLLCtWZG0x2lBmJBtknDKf37nyO/ZJekO/LypmRassCvbvctycAc5Lwhf5Mr/HqS/vl/PmxktUSwawwm9ObG3DYsJuS4HB4sXgvCFrt3WQC+t38ubGSnl+V1pXmV5JGvz8XJ0i9SvW7tULuNMlQfV3fGJw924Qatj6I0gDCFTkgwr7E5zKstiWVt0nZHMMc4jxj8B76g/nszLInmuL3IwLK8E4QtOtyTXD+xBD6tsHSamlfL9kd+srqGtdU18aWkpPsnBQL0ThC/63Z1H6Pl1tXTB8E1qvjPOc65NTg7iSWS/U3P2P6wyO4mMx4n9eHxJbKwYM/SleCkId65pSdI5xJsnkb341h5a/8lhI3HLcsyYUOrlHBxvBTEpSSYG6vGb4VL1IwR/hIyy+CwHc/RaEAbAH004rVBUI2d5uMX0sZkbqBflMBseYTxDzd68aYi/sze9F4Ql4ZGzS9bUpCzJt24opG+Oyvwd5VfVCIJXUlxbg+WYrb4/hUcYMyvfCgRp6fFUJfneLV+gSddfY038rPmogf60oWP3fSBHazdCkFYWtKW2KfZO0pzE8HL+jP6j20vo9mvtmx//zseH6cW365L6tY5/ceNf3nx/5wjCAoIEJFr+8hwMvkudiCT8P+3MO0roxsH2fkbfqHKIcS6xRL5j6eamtMPkzUMIEqerE5GEg2mWSoA2UkC2x0TeGSFHnEBQuyBIfC6kW3mXJzo9rFKhxpsFeIXTZXz39s94JeEaOqmGqLQvkKM9kdbHEKSVxWVb8WbzdVcL3c+zaKH7yxqt2cHXs2hVNTWdOnvpWSz7PDVObKgaL4ZyOQEIcjmTNnvCkvTqmhOb6MTD1qUWHib/9MrddOTEWUpkyq/U64yq3RAkAZIsCQ/l4CXCBvROfqJTAlWk9Sn7jzbTs6ur6YfjB9IQLJqqZQ9BtHhw0HcCojMr+t55uH7zBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwAQgiuPPQdPMEIIh5xqhBMAEIIrjz0HTzBCCIecaoQTABCCK489B08wQgiHnGqEEwgf8DSLJz73vZGMMAAAAASUVORK5CYII="

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cs_bg.aea5ff0.png";

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAA9CAMAAADBPCTwAAABTVBMVEUAAADz8/Pk5OT////////CwsLMzMzDw8Pj4uLExMTExMSoqKjCwsLq7+/i4uLV1dXT09Pp6enz+vvj4+PY2Njg3t7u7u7m5ubT0tLZ2dnw+Pj7+/vExMTv+Pj0+fzw8PD////q6urj4uL09PT2+/zeJCXExMTp6Oj8/Pzh4eHn5+fk5OTT09PQ0ND+/v75+fnz8/Pb29v29vbu7u7i4uLZ2dnW1tbU1NR/f3///Pz39/f19fXw8PDf39/Ozs7Nzc2zs7OQkJB1dXXr6+v75OTd3d3Y2NjBwcH0tLSwsLDxoqN5eXnrdnfnXl7eKCn+9PT97u786er3yMjHx8f2wcG9vb25uLioqKijo6OUlJSLi4vthYbkUVLhPj/hOjv63d351tf40NH2xMTzra2rqqqfn5+enZ3wm5zujI2GhobpcXLpbGznY2TkT1DkTk+CNhXtAAAAIHRSTlMA8yaAQGD29vXAZUYhF/n49fTx6ubj1tO7ppuIem1ZVUUl4H0AAAIySURBVFjD7dRXU9tAEMBxmQQDAdJ79a1zqpYt23HFHRsXbCD0nt7L93/MOTY5ErTKSfeQmQz/55vf3K5upIx6dP2p/+4rp5uPRwIUf3zauBgJ1IVz4x8Zz9/0mpJG4YhSuilnNCnri5yxNjQ+S86ywowDyZ0eM+ODpPGdGR1J4ysz1iWNPjNeSBofmbEqZjzBTvUoXYmgPVB4l65ipzqUHuHG9OSJMDejxrBTryk9xI1n6szc6BJTKm68pHTgZahTDxlxT2WhRqHTa3oZrLvzSuh2GDcKh2ynm15G+BZMKKGoc2cDM15R1gA3Nm4C/DSi0dAN5ND60PiGGpenYWwMS+muh1aPmdFHhIQJwI1hxbjrv/Bg0F9zFfRFAG6clIj4qGTBWYO1oIsKRSa4G3wt3ukEADf4WvDiJQDEEF3LggWoIbaWhAbgZfBSyEB6GgA3hAZyLBAwsIH4sxQ3+HfWU2wy/iwxA63IFkBYiwk+hl/DLJNxORsCGemWRn5ltmP+jXQSyG9lakv+DMdIauTP2t2WuOFYWZO4ZOzUDEFDy5YJUqW+ZQgY6eySRtDM7r76N6OUtIF4lqnv2V6GY9h8l2hb+d0kapixnEkEMnbzXcPV0HKVFhEss5ffNs4Y6Ww1YxLx1PynNjdGq6zmLOIra6dRt7nhGBXbIL7L7TfeZ8eGZVfZkwiQVltefltmxrVYVeAS6GNp5LcnlHCFP4lAV2nMKldMIlX53ayiEdkm/yfjB4yc/1Ft/GhaAAAAAElFTkSuQmCC"

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA1CAMAAADLRm3ZAAABGlBMVEUAAADxqz7wqj72rT/v6jnv6Tnx6jn08TftlCju6TnxsTzv6Tnu6Tr2tzz/tjf//zDuojTwqz7v6Trv6TrwoTPu6Tnv2zrwqj7ulyvxzjvxqz3v6jru6TnumS7v6jnwqz3xmi7v6jjxqzvx7Tfy6zv0lSDxqz7v6jpNTU0yMzM0NTXv5Trxujzw3DrxrT3xsTzw0jvw1jrwwjzxvzzxtjzwqTzwyDvw6DlTUEuEbEfHk0HNlT3xvDygeTzv4Do7OjbTmUDxxjyRcDzwzjvwyzvw4jnupTlgV0pnXEmgfEWlfkDCjz+6ij/ppj7Ymz7wsz3xrj3v2Trv0jpMRTnvnTB2ZEjlpD+LbT2tgDyFaTxrWDtpVjpRSDntjyUlFC0UAAAAJnRSTlMAgPMc4r5HF/iXjoFpKg4I9u/r6tvVz724saabmZaPeW9gSTgnGCsvjhcAAAH1SURBVEjH7dbXdoJAEAZgkpiY3nuvC4YiomiMJTG92DU9ef/XiLO4ICIsuLnIhf+V6x6+Mww7KMdxh8gl8ydcgKy5Mfp6AGUGuWY8ALPpzjR3fCsjyD13/suZ9GD0n32/zALySHN5iJ5ZYIYRa0YGzID510zp6aXxVWZlnu8F4TQS+ei5GZUkqeqHuTwTMBO5cmwpmsxD5DidSQtt5qJ7R8rzJOoMhdHPCBPJdCkp3koo7M2UBJN5t3dF5DszSrkpt2piPCRWyBYMb7qv3lTg0lQcd1qFz0tznkyZPKmc7eskXKp1VjbmfW4ycG4czxuuFMkiAcwU5RQ/AvON7JGhMeYK2jNBYdLAXPRgaubqtrXaojAP+KbukC0qdLhKHr6Pm9KNFj8jZ4tv2otrHy2+FHq1OIrPcMEiQ5QJLxrMJ1mbFUDyWjZpjNYBhXk0mEb3eOcDDQNKY8Y54AmxU5mjMQ+YsR6V1R7ZVK6p7xudzFTRsaUZxm1d8vH2I8ybYwuPZFzx9S5+PW/lKZfLZRxbIpTC9AMTzyrGQNZZGChEruF7YmESPInCVE1FU/GxkRFTNfDLgIeThVFSopq9AUZiYSTSGRGxMNFkew5iNmZvKHAmV4HZsP5e95kJYMIca0ItZYVZOYZidpmZ8PYivMX/IEfT9vUv3QG5hlYPd90AAAAASUVORK5CYII="

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAfRJREFUSA1jPCIjf+Hvv/96DDQETIyMbxj//7Zl+fefQV9ano+GVjEwvH3xle3XLxZVJpragmY4SZYxcnAyiJbVMvD5BqEZQxyXJMuYBQQZ/v/+zcChb0Sc6WiqWND4OLnMgsIMwtmFDDxO7gz/f/1kYAL68mVrDcP/799x6kGXIM4yVlYGmVlLGFikZcD6Gdk5GLid3BhEf3xneNVSg24mTj5Rwcjr4gG3CNkkXlcvBgZGRmQhvGyiLGOVV8JuCNDHzCJi2OWwiBJlGSMTbmWM1PYZFkeSJYTbyWQZh18TQcsEkzIZeEAJAQcQb+5mYNfQxiGLKkzQMj4vPwYWcQlUXUg8Dl0DBnZ1TSQR3EyC+expdiIDq5Qs2ARQPhOramL4/eAew+vuFrDY////GH5cOo/bBiQZgpb9efmCAYTB4Pxphr8f3jP8+/KF4ceFM0jGEMckaBm6Md+OHEAXIprPAsz/r988/0ow7rh42Tm5eFi4kE3+/PHH55/f/v5CFsPG/vPv33/G/wwfgD77Y/P7N7MaNkXIYl/efUtjYOB04uJh5QaJf3z348OPH797//35fwFZHTY2yCKbZ4+OEF+wAU05KiO/mVeQw/HXzz+/fn7/M9X68cNabIZTTeyonPyiozJyZVQzEJ9BtxkY2PHJ45MDAA4Dgx0wJ4NUAAAAAElFTkSuQmCC"

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAYAAAAxSueLAAAAAXNSR0IArs4c6QAAAeRJREFUSA3Nlc9LG0EUx78zO0k2v1asUUvroQb0pkUhUihILz1VEBR6KfTSSy8FexMEr956qvQf6FVB/AOKIAhiITcPFTxZC9uSNYImm81MJ60JmwnjTiQBB5bM+773vh/ekpklh1u5IufkKfq4KBW/BcFzVq9jOj8W7yMKOHf9WNUXk7SvFMW8Oxi1kc1vIDn6RrExC7uCUTYIiACx7JyZu1LFlFgbEgnKPllHYmgB4FUQOWX55CMEv9L2qAkzGGF4MLUDy87/75egxNArZIWP8o8Pqqc2NnqNtpymBQpZ2blFgMRCyu1bI5iVnNC4UND4Q02uUzaCgZDOzhuFQJ9Tm8xgatcd4/sFSz16j2RuWTuLM/kZLDOjzYcTkZPZw0ugicfhnrZ9LDOLuFNo03RB5Dnzjt/Kv/34v34aH8HAxKY802e4OFm58RSoXX7X+bfpkTDu/0LjaS4v8OSVJQHlg6Zk/BsJU518b0+VjGNmWXB/ujUrqsNJk2QmxVLhulI5uLyuyjsrYslvphCCeIzUMe9zrrsiWjalAO+4IC+dtJVuiH8uglKlEnyqBaTYKtJsGqBnr9198+MvjY62c7uDDnshp6ldV/iXwrK7pvHvjSyBX4+2h1d74xbhcvoNdkSJNv0XY3J+T/EnVEIAAAAASUVORK5CYII="

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAAaVBMVEVKqdNKqdIAAABJqNRGpdJJqdJJqdJJqdKCxOFJqdNJqNNJqNFJqNJJqNNIqdRKqNdHo9bl8/iaz+a13O3N6PNKq9OMyePG5PGm1eqZz+V8wd90vt5rudtftNhWsNZJqNO84O+Qy+T///+uru+6AAAAInRSTlP0zACZM8Dn4/fv69nWs1kmGf75+/xM+Pz6+ff29vX0jPv4OyDz4gAAAONJREFUKM+Fk9cagyAMhUMBce+92vr+D1kDbu2Xc0d+IBtem+KQc8kk52G8GzcuArYrEBcecXYWj45cSHaVFDsvjMlTLgC4yjPHYuVCH30HVjm+tgjDI/25BUdZ2kWkOV/w/QJHLjZ8vyBmHqBvuAtjCF4Q4z3ngTsIYggxMXgSphkCRqdW0zj0nV2mbWIDgJrJW3MsS9t/q2YyyjR3MQNAL/h0yvMpPXFEkuBs43WZJk/vjX+jYY6tzj5Vs/tf4r+oG9f4qfyp+hH1/98/pftH9J+aH2L+iPml5p/eH3r/qP39AZc/D5N7rMtrAAAAAElFTkSuQmCC"

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA8UlEQVRIid2X0Q2CMBCGPxvfZQQ2cARxE0fQCcQN2MAZ3KBugJuwwe9DhRjCg6VNevFLLiGXcvmg10KRhKRKktfvDJKaz71ZYrw4R0h8c8ol4ghUrOMOaGX0QDMWcpRjD3QWRCDIAOVFJhxwAq4FHXqg2kgagF1BEYCLMyABUJnqERPkELkBTwsiLeBTi/zV1OTAO+BV2gLCGxkixh+BzSwg9Mk8H9XA25jBhM9BM8u1n9w8X0dVVtyf2RJIahNrNFaa1cyq6a2IDFvCrnhIKOKJbcwFYlfNEikPMWFlamyJ+MIOD2A66XWJG9Jaekm1JN64/BLAJMA3QQAAAABJRU5ErkJggg=="

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBljZM7b/p+BxoCJxuaDjR8+lgAAZp0CL3j6cqoAAAAASUVORK5CYII="

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj1Fn24D8DjQETjc0HGz98LAEAP2ACuYjgnroAAAAASUVORK5CYII="

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj7D0k/5+BxoCJxuaDjR8+lgAA1asCdUTlWzEAAAAASUVORK5CYII="

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-app01.0439ab5.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-flowsensor.a3013fa.png";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-guide-character.121101a.png";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-guide-character@2x.5b409d5.png";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-iotizr.68ba21b.png";

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_dp@3x.78f453f.png";

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_pr@3x.17e778f.png";

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_ro@3x.adf8a1b.png";

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_tm@3x.9fb3368.png";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inst_wt@3x.a1e780f.png";

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAACpZJREFUeAHtnVtz0zoURl0otECBUq59YPrA//9DfWMoFMr9fqeHzxzPpK6zozRu8klamvEkjZxke22t2JJsd21/f/+4oUAAAoMELgy+yosQgEBLAEFoCBAICCBIAIcqCCAIbQACAQEECeBQBQEEoQ1AICCAIAEcqiCAILQBCAQEECSAQxUEEIQ2AIGAAIIEcKiCAILQBiAQEECQAA5VEEAQ2gAEAgIIEsChCgIIQhuAQEAAQQI4VEEAQWgDEAgIIEgAhyoIIAhtAAIBAQQJ4FAFAQShDUAgIIAgARyqIIAgtAEIBAQQJIBDFQQQhDYAgYAAggRwqIIAgtAGIBAQQJAADlUQQBDaAAQCAggSwKEKAghCG4BAQABBAjhUQQBBaAMQCAggSACHKgggCG0AAgEBBAngUAUBBKENQCAggCABHKoggCC0AQgEBBAkgEMVBBCENgCBgACCBHCoggCC0AYgEBBAkAAOVRBAENoABAICCBLAoQoCCEIbgEBAAEECOFRBAEFoAxAICCBIAIcqCCAIbQACAQEECeBQBQEEoQ1AICCAIAEcqiCAILQBCAQEECSAQxUEEIQ2AIGAAIIEcKiCAILQBiAQEECQAA5VEEAQ2gAEAgIIEsChCgIIQhuAQEAAQQI4VEEAQWgDEAgIIEgAhyoIIAhtAAIBgfWgrtiqR48eNRcu8NuQmuCXL1827969S129qPVoJUWlk40ZmwCCjE2UzyuKAIIUlU42ZmwCCDI2UT6vKAJVdtKLyuASNmZzc7PZ3t5uLl682Pz586ddfvz40Xz//r19voQQVvYVCLIy9Pl88fXr1xstQ0WSfPz4sfnw4UPz+/fvoVWyfg1Bsk7f6oPf2NhotNy+fbuV5PXr10WJQh9k9W2siAjW1taamzdvNnt7e83W1lYR26SNQJBiUumxIeqn7O7uNjs7Ox4BLRhFlYKoo0k5XwI65Lp169b5fskSPr1KQY6Pj5eAlq+4c+dOc/Xq1axBVClIiaMtrq3w/v37jfonuRYEyTVzmcS9vr7ezqFkEu6pMKsU5OfPn6dA8ML5EdDoVq6lynmQX79+5ZqvpcetAY03b960s+Y6NNUo1eXLl9uh3CtXriTFc+nSpfY9mn3PrVQpiGZ/KWkEvn792rx9+/bEyl++fGmvD1EH/MGDB600J1YY+EMy5ShIlYdYCDLQgqe8FDVqifL8+fMp7zz5svYiOZYqBdGhAv2QtOaqPUhUJEnKvFKuI1lVCqKEz0p81Chqqvv27Vu4ueqTlHz5crWCfP78OUw8lU0jOWbNGaXOluc6MFKtIDo0YEY9/hmY9SOiU+BTBcm131etIDpuliSU6QR0ncdQ0SHVvXv32hGsofr+a2Kd6yFtlcO8XQJ1kc+1a9e6P3mcIKBGrSsJ1bnWYZak0HUfGtrVnmOefof2RLnurasWRInrJr8m2gZP/xKQAJrjGKP051HG+MxlfUa1h1gCrF+1Wm+ItqwGpr10rv0PMapaEAF4//590ji+1qXMR0AjV69evZrvTWZrVy+IDrEkCWVcAto7Hx4ezhwmHvdbx/+06gURUp2MlzIbPD7+Mj9Rcjx79qydR8l9CxHkbwYlh+7GQVmcgPbIT58+LWYIHUH+bxPqrOfcmVy8aS/+CRoVfPz4cbZzHkMEEGSCyosXL7Idr5/YjKU/1Q+LDqm0aA9SUql6HqSfSCVah1q62UBNRae067T1GzdutBdC6TLZWUUiaI+hYdxcZ8lnbaPqZ5NI+ZSC1tGkli7uqWWGXR1qyaEfB/2jHC26YlCz5nrUhKEW9dO0SCYttRyOIsiA3GowDx8+bBvIQHVRL+mwst/YOwmK2tAzbgx9kAFw+qUs8Xi6v6k6nJx2QmJ/3Vr/RpApmdcVhxqulCwlFh1Kav6HEhNAkICPDj1KlERD2rmfAhKkbdQqBJmBU1fVHRwcNLleEdffPO011BGnpBFAkARO2pM8efLkVGc24a02q2i0Sh1yzhiYLyUIkshLexBJkmOnVrFrL6g5C8p8BBjmnYNXN2egS3Xv3r0711V1c3zNqKt++vSpOTo6Km6Ge1RIwYchSABnWpV+iSWJrst2nVDUTLfEkCCUsxNAkDOy02GL5kokiE5N0ayzQ9FeTqNUnMI/TjYQZEGOOh9Ji85j0i1wViWKxNCFX5rfKGXEbcHUjPJ2BBkFY9N2gHXopT2Kbve/rEMvTWhKDH13aWfSjpSahT4GQRbCd/rN3R5Ft+TU7XEkik5+HPPetJJC36MRtVm3Bj0dIa/MQwBB5qE1x7r6NVdfQIvOhtU9prpFh2E6pTxFGn1Od/KgZNCp5dx4e45ELLgqgiwIMOXtOp9Lo179OzlKku7mz5JFS3ful8RQX6L7O+V7WGd8AggyPtPkT5QAdKiTca1kRWbSV4KdL82FQBZ7kL29vfaYPReoxDmbgPacusGDe8lCEJ19uru7m8WpHe4Jd4hP/apczijOQhB1bvVrs7Oz007IpYz+ODQEYjhJQJOZmq/RLH8ufa+1/f3945Ob4f2Xhkw1v7C1tTX6/IL3lucZnaTQ0LTOCdO8TW6jclnsQSabhgBr5liL9iT6fxWaiNOiO3Gwd5mktfznEkLXz0gKLdr767VcS3aCTIIW+G7mWq9LDk3CaUJOj92Scp+nyc/leRoBHSZ1k5h61ESmHnMWor/lWQvS35ju16t/GxsdlkkW/a9uLRJm8jl7nT7Jf3+LpyTQzL2WyecSIbfDpeGtjF8tSpBpm6pE6tdt2nlLms3W0s1s61FC6QzdGoo6zmrwEqCbwdejltpLFYLMSnLXGNRIJov6NFpKLvrR0LXqlGECzKQPc2lf1S1/1McptWhkSRd9UaYTYA8ynU17iKEGpL2IhpY1UqZDL/Vpciw61NReUqNLGnLt99Vy3KbzjhlBEgirIdGYEkAVuEqeP4UFJoJN8iSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAghikgjC8CSAIJ55ISoTAv8BcYRDfd4Z0oAAAAAASUVORK5CYII="

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo03.be88623.png";

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ng1.b3eadd2.png";

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ng2.1a327e9.png";

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ok1.d26810a.png";

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAFSUlEQVR4nO2dMUwbVxjH/+85+OCCQaQmVYSEG2eJK0WpKitTgKEdmiUVytKFVumUKVL3MDlSNypFGZgqFWVsisrQdqBDTCdEK6VIdhZojIpQ6mstm3L12bFfh1LqOwtC4T3uM/5+Ez6j7332z/fuvXd+n4VSCkF+366f64tGPobA+wK43vYPzJFRwA9Q+PqvWuPz12I9fwSfF0Ehbq2ZAXBXAAMnlWQ3ooAKgAd2VE63Ht8T4nrNIQgs8BlxsuyeMTdtS5YAQALA5ExOsIxwEMB1CCxMzuQEsHuGuLVmRgD3wk6um1HAfTsqp8VOtZEUAmthJ8QASuGShMDtsBNhdhG4LVyv8TOAK2HnwgAAVoXrNdonIkxoyLATYPywEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKwEGKcMd1AbtNFwanC9ZqmmzJOIm4hEe/F8ECPsTaMCHG9BuaWfsPK+jbcWueLCJIasXHrWhxvjtjaY2u/H1Jwqsh8tXEqRQR57+oQPhx7XWtMrdeQbpIBAN89LWF2cUtrTK1d1uziVpuM1IiNicuDiBvsd08C12sgt+kimy/7XmP2WRnpZD/SyZiWdrR1Wdl8GbPf+z8td965gPHUoI7wZHC9BjLzGyg43t6xeKwHDz66pCW+ti7rybOy7/HU2PlTJwMAbCuC6clR2NH/3jpnu46CU9USX5uQ/Ka797cdlbhx9Zyu0OSwrQhuvOV/fbmW138cjEwME8O9JsKSIhUY8uqaZ/FMnRgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBgshBhGNuwUilVk5jdMhCaD6zWMxDWzg6rW9H3Xlzk83GURw8gZYkflqf/Ctes1fHtEdGFESGK4F9OToyZCkyG36eK+geskd1nEYCHE0CakdYtXoVg1Niykwsr6tu+xbel5K7UJad1R5Naa+PZpSVdochQrdWTz/j2V6Yt6duFqEzIR2OD5eNnB42VHV3gyFJwqZr751bc1OjViayu3obWSQ2Z+o21CGI/1IJ3sx1kroquZ0HherOLHX/5sO35vclRbmQ2tQlyvgbtfrHVNJQdA/158raMs24rg0w8uIhG3dIYli4nCCMaK8WfzZXy57MDZrpsIHxp2VCKdjOHWtbiRMk3Gfx2hWKmjqEGKU6n7Snck4ham9qnEk82XkW2pLDE1dh6J+PGXcs5aUkucgzBewGx4oEfLJykH/2AhnYzteyF1KnWfENdrGqltZYKOmakHR2/Dsf0lBysP7XTQJLVjhBQr/m7voHJPbwQGFSZWZU3ROUIC16GDuiDbirQt5XQKHSMkWG3oVbTej3FrzY5ZW+sIIcE38zA3v4Jzoecd0m0ZH2Udldb6U8HiYHZUvrI+VbBcUnB1luqoi+SvtM0ubvmGrSYYvzyIO+9eMNrGUSDXZc0tvTAuA/ineOXc0gvj7fxfyAmZSA0e6qJ9XOyobLtlQAGSXVbBqWJlvX2ZWyfpZL/xZZCjQFJIN0Ouy+p2WAgxWAgxWAgxWAgxWAgxWAgxWAgxWAgxpBA43ZsBOwghsCEBLISdCLPHgtipNpJCYC3sTBhAKVyStiXXhcDDsJPpdoTAQ9uS60IpBddrDgmBJwCuhJ1Yl7KqFCZsS5YkANiWLCmFCQCrISfWjezJAFqGvbYlS31ROS4EHoWXW3chBB71ReX4vzIAQCjVfn/Ke9l8Wyl8AuCmUhg4ySRPO0KgAmBBCHxmnZE/BZ//GydsuCCCbJCsAAAAAElFTkSuQmCC"

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAGyNJREFUeAHtXXl33DiOZ3zb5duxE+eYJN0z83rmk+5n2g+x/+32zHZvJ53DZ9ku367ykcWPjhK5LFGUREpgEXivXlVJlESC+IkEAQJP/us//vOrEhIOCAcyOTCWeVQOCgeEA5oDAhARBOGAgQMCEANz5JRwQAAiMiAcMHBAAGJgjpwSDghARAaEAwYOCEAMzJFTwgEBiMiAcMDAAQGIgTlySjggABEZEA4YOCAAMTBHTgkHBCAiA8IBAwcEIAbmyCnhgABEZEA4YOCAAMTAHDklHBCAiAwIBwwcEIAYmCOnhAMTwoJmOXB7c6sG55dqcNlX11cDddMfqNvrG4Xjd7d3DyrzZOyJGp8YV+OTE2pialJNTE+pqdlpNTU3oyZnph6UlT9+OCAA8cPX73f9+vWrujw+V5cnZ+rq9EKD4vvJgh9f776qm8GN/vTPrx6UBnCm5+fU3FJHzS7NaxA9KCB/nHBAAOKEjY9vAjCcHfTURe/s0cjwuHT5IxhxLnqn+oOrZxbm1PzakuqsLKgnYzJzLs/R7CsEINl8qXQUb/yzw2N1sntYaqSo9LChiwBIfA4/7aqFp8tqcWNVjU9J9w6xqfRf4WBplmVcQNOo0+6xOt7p6ulQRonGDkGPOSaAnuwdqYX1ZbX0fE2mXzW4LwCpwTxcenlyrt/aULg5EXQfgOTs4FiDZPHZqnry5AmnKgZRFwFIxW66Ix3g8PMuCeBJxTs0cxlGlKMv++r88EStvXmupjuzzTx4RJ4i2lyFjsSo8eV/3rMHR7ppWFbe+fefqrfdVUpCBaZZY/wtI4iRPY9PQsB6WyRkARLNunTd+6TMr//0Uo3RUrGQmQMygpj58/3s17s7tf/Hl2DB8b0h9OOSALL16wdaaeunD8vvDA4IQDKYMnwI8/id3z6p86PT4VPB/r8ZXKvtf/2p+meXwbahiYoLQAq4DIMc5u6jKEj3wP+o7ScFbIj2tADE0PUQoD0aOaDgjirBuLn7+6eRfAG46DMBSA4XYUfY+7/Pqn/x0Acqp3jQhxOQiE7yuBsFII95oo8c/LkT1dQDo+Xub5+1V3EOS6I8LADJ6PbEAp1xaqQPQXHHSp3YSX50swDkBy/0rwFNqY4+7w0djecvHB61MTGeJhtbKgBJsQdz8f33Wwr6R8wEp8s+beoSUkoAkpICvDm5OR2mqtfYT7wfuh+2o39RgOECkG9id01LuSe7B40JIfcH4UWBfS2xkwDkmwQckt4R+czqERaOaUTFfvmYSQBCvQ/vXHyEHnLgjnSy2BV2AQjJRG9r/6FkyL/vHDijnZJY/o2VogfI1dkFrdiMvrW8qoDrnYkR6yLRA0QU0WLonHV7XiKzFD+5/RJRAwQK6OXxWfu9wLwG0EXOKVpLjBQ1QBDQQFau7MQevIqRot5yezFCG6AQsGRqlkKSzk7pEKVj4/fvPngHYKSEyz6s4/hfhaCnIUwqwp/GRNECBCszobuyAwRzFEmxs7ygIysWRVSEwo3lbOgUmFqWHT0RJRLhg2KiaAGCeLmh0uT0pFqkgHDzq4ulwowiLtYcxfHFB5ZyOGVelNDBEF9YABKq1JSs99VpeACZIGCsvFjX8XcpClzJFj8sjujwG399peNlHXzcsVqluqL96xiFYgpAF+0Igs4OhZAGYZlGjMVnazRi1APGcJs7NAohncLO/34sdCuB/jIgXWR6Pp7gc1GuYt1SSoFQfIxmSBhf/POdWtp86hwcCVgwmiAqvA31L8J5sdi0p6hMlCPI4NLOco4o6VCCT/ePdBqDIma6PI/8H8s0nUIA6iYI6ROwk7KIRjmARVbbowSI7Z4PvFlnFylBDX1u+tc6tcE52QOu6bcvAjAWNlZ0+oJkqdbXs9L3xTTLhm6YBem2qXOdMlECxNb5Lr3mDwV5maY5+GBbrk5eQytAg4v6IYGgb89QtqjOKiXA0StTbvUMGwFBijcAEsEbTOTz5WB6blvnogSIrf6RlwcQb1t8MAVClHc4PAI0AAtC5yBtmmnb7tjEmJqauc81CIV3ZqGjcxG2JQTJc/ESKAK8Le+Se4b+HSdASKhtCMkziwgBoOfIUIdPmiBIiOebfiOj7PjEhDdlO/38Kr/v21s8IiLaJKaCMVCxBIwgF+5uiwGCaU8dHcAGXNxYayv0AL5ScQAkymVem7hPRW4b3ITbTX3sdJ/0qOjmuXzvEiVA7t+AfDulrZpZW8jLOnG11SAHz40SIE++ebqa+FfV69V0T+7nbF8cMY2ucQLEwo8Jq1CmlSjuwl6lfndatyi+0rW7S/ET2ysRJUDGxu0UTCzhxkS27bVV5keBd1ECxLaDr2mDUExk017oKTLFGnGpGCersQ3F5FaBpe/b6+IRE8bEmCjKEQQbjmxoEFGSy+tLu9FSAGIjOYGXmZydtmoBUgHEQnCXsSG4yMREUY4gUwQQi4Us7Zdkq7iGLjS2OyxtXy6h8yOpf5QAgZJp29GXAW7NTTrX9hv2D9sdljHtJgT/ogQIGg73chs6PzixKRZ0GeR/tzGMwr9sMrKwP/EChDZB2RAiecB7dZTJNmoiNo7FRtECZJa2mNpYhOF2hDhSo0oIBnd5Yqegzy4JQEZVDh61C3oI4kPZEPZq20xBbO7FrUxvxy6rFl4mtvzi1sY69Yl2BAHTOiuLVrzD5qfTERxFsPXYVsfChrCYLOiJYEQNkNnleeudcUhHZrPRKmFsCN9HX5B2zi5W78LTpRCa5LyOUQMEfkXzlmF1oKgffRmdTFQwgp4fnloJFPbmY998jBQ1QNDhi+sr1qE0T/d7qh9QRMY8gYbdA+FGbSm2eLxpvkQPEKztz5eYPuy//6IjmaSZGNrvg4+71vngJ6aIP2txTq/Qr9EDBExYfm4f1hMhfboftnFZkIREOGWS4eiQpzZ+OUFyo7jSAhDi0Ti9JZdK5L1AyoDDT7vF3GVWArlBDv60n1rBZ20h4tED3ScA+SbESxQ9HdMJW4JtBCtboRAC2+3/8cV61QrtWn39TFl5dYbChAr1FIB8YxrW+Nf+8rwUC4+2uurY0tBW6saOCyP12u5vnx4EsSt6BPQOBLSOnQQgKQmYJct6GYUdl2LpV0+37MwJqac18xOp1naR+6OEPxlG0tXXG81UkPlTBCBDHbRG0wrbHYfJpZhu7f5WnIAmKd/INwG2R1PA3d8/K6RxtiXo40/fvaCoknaBLWzvG2o5AchQz2GqtfHzKzVWMpPTJRnetn59zyLvOlxIANgeTQHL0vLLdeutAGXvHWJ5AUhGr2EzFd6iZQlBD/DGhjLcRhR0uI0c7x6orf/+QwGwZQlJQZcozZvQDw7YL9v8uCaKX3DOW321oQ4pE2xZwgYkzP0XNlb18jGiunslAsbZ4YleMLBNDjRcHyjka283hw9H/18AYhABuFjAQbG3becSnr4V5v1Y4TrdOyTFf1lbo22zOKXvY/qNUeqcgIEUcXUS20x3ZvS00jo2r6lSI3ZOAFLQoUiSA1tAlfk8bg2gQInHB4Y35DycJcc/CGUVG0OywenymEYpMvxZOuPmtnK6M6ue/e11rVQPuTcfgRMCEItORNo15Ao5oulWHYFEAkx8eqqrFwGmSDjhKYt93kiBhqDaY7RIAODAoRCjF6KqDCgvIILYIfkoXF1cEXYIbvz0Msp9HrY8FIBYcmqR9AkIMfywXOTHwMgCl/O2Ym8tUqLQ1VewlFsyINJisopVouOhuG/+8ka/9Utcxqoots4+JWX83o2EVdVYVkYAUrJbJimy4It/vG0sf3nJ6hmLT82h7u+idl83MijjpEyxMphSdCjx2+rQiNKljUfIoc6ZMGpAj9IeyxG7rlfpIwFIFa59u2aG4kS9/OdPtEJ1qD17y7h01HhsqUs7tGq2QvYc6E9C5TkgACnPswdX4O0MV/kFsnXAin1Ky7kcgIIVqhVaonZte3nQ+Aj+CEAcdTKs5SsvNzRYsHcdYYKannphKRqhjLBCZRt72FHzR/Y2AhDHXQsvWIwo+OjIIUcn6oJcT8q4m5epEqzfcBPpkB8VVtnq5HYv89xYygpAPPY0BFf7ONFGLGxa0nYPysMxOL+qDBhM6WCRn6bg2wjAPbuIEKqyGOmrGwUgvjg7dF+4dOCzpO69ZeFHBcdCTMNub2705+7m7sFVAAPyKSLyCpTsCbK46+jqYtx7wCeffwQgPrlruDeEHh+1YCgkp1rngIzNrXeBVIAzBwQgnHtH6tY6BwQgrXeBVIAzBwQgnHtH6tY6BwQgrXeBVIAzBwQgnHtH6tY6BwQgrXeBVIAzB6Kyg1xf9bVx7t5AN9DW7PutrXc6Zi0cDhcoX4hvwvO7f27rbbW2z4JrPSKtN0HIHYJYvnBbgZUexkptpMT2YP2ZbqIaLJ4x0gCBtfqid/p9a2uRPxTKNgEQRCEpm4gHFneEEWrC16rIdwyASdxo4P+lDZ4sxNl9JUYPIBRV4bx3Rskpjynqx1mpIAtXlD0Kwdd8hr/B/RGqpyxhHzzymfsGMEa3ohcJziP2Fz6ISzy7OK86FOy6Qzkfq0RqKcuLJsuPDEASwUNKgqoxopDqGY6E0/Oz3voAAeWKBDDv4Rh5fAOk7MiGKC/Il4JPb3pSTwPhWezzJZPHHx/HRwIgiA91SPPmqsBIM/aKvG19AqRMdqd0vfB7cDnQ00VMb3wRvI6rEviPqC94Sa2SB/Ms7bgMnYJexYKOgTi4yH3hAhzoTJ9heDByYASpQxhFfFIdgCT1Ql+gT9qKUZzUw8V3sCMIBHn//ZbzINF9GkG04uIhuAF0CExJ6tAF6Vd4MfhQjBGoDoHtXBF0FIzI6+9eBpuMJ8gRBDFvfeXjwH7yPi1x+qA606ukPtC1zmg7rw/qk/7lmnTEe0rFEEImrqy2hwUQevsiCSWyOtV9E2cxIzlWVlFNrjN967CjF27eztjvrmqORFl1dTG9yrov+gp9phOIeqh31jNdHQsHIMTY7octHQzBVePz7uNDD3ExeiT1RXzeCwpe7Zp8vBjSdQSw0Yc+wJ1+jsvfwQAE1l3kwGiCMG923YnXjqdtWLlzTb5GkHQ90YcHH8PJMx8EQHSeDU/z7nTnJb9hlEMkdZe0QrkPYYF2QVDQESnRJV2Tcu4iKLdNnU67x8HoJOwBgjcl5q9Nkx5FHD4UkUie/f0vtUECAxxSFrhexbqqYf+owib0qY9RsEpdTNewBgiWM/Wc1dQCT+d86CEuQIIwoj4MmU1Mr4a7quthmX74GXX/swYIPF6xTNgGuR5BkjbUAQmSbCJqog/yraBn1RmGU/QxZ2ILEHjWXh67V0RtOwMxqlwazdLPrQISXLP25nn6Ns5+I4sVnBTbIPQx+porsQQI9mjAS7Rt6ldIpWxb5zIggYv7xs/+UqW1Mb1K8wl9jT7nSCwBckLBn13m4qvKeF/TrKQ+CUiK9nggZzs2LPmiphX04Xagr088+5gNP9P2PzuAwJXiZPfQtv5ey/lQ1IcrDJCYYusiG+7cEu2z8Eht6B/DzTnZPdJ7cYaPt/2fHUDOaI0cq1ccCEqk77n5zYBi8xraCz0ILw1vRLceNLzEm9UW8AB9z40YAsSPI15VxvseRYre3skmrqr1L7oOBlEOCX9QT19OmEU8MJ1nBRC8rX150pqYYDp3deZ3Jc1GQfapC9k838Qfl+fQ975H7LL1ZQUQ7JfgRlen1XfY2bTFRkCLRhmb5+SV8XnvvGeajnOTAVYAadPukddpmBvf9P3YCPT0ycKJMZYRBH3ATQbYAMSHg2Ce0Jc97ksPQewpG/37njdu9pKk264XIWh7LCfSOhE5i3IhNgDBVlcbYWmDcb4AcnVObvWWpLcCW5a1LcZteoV6QwZ88duWL+lyfABiMdVIV7zJ376mOP0ze5d6TMdcU78EQF0/23Q/11sNTM8qOscGIL7m+UUMsDkPSy/sFa7JRkFHnsKnbzfV4rNV148vHd3ReQVybshJFtgAhNvy3nDfuR72iwyEeP4kBWLb/OWtmqeohc6J5jLcltSTNnKSBTYAMVmTE8a1+e0aIEXzf7iXbP7jrU757KPdfQog4WPa5qKunGSBTVysprZ7Vu1A10py3vQK4biwndZ3JPe851flj8vrOMmCAMSyZxEt8JZ0kfEpNyzLGkGwZx2eu8aQndDVHeRJF4DYdTybKZZdddst5crtBHsfhldq4LWLKVUeODAdwu47V+F+sgDaLnd5Pt3N65Bn25zXCukROqv1FWYox2mbz8L6slqlqCd5EdGRG2Tvj8+U1Kavgz4gJ0cd0t4BHlbl6tSJ67VsAIJNQ5zmnlkd5kpRT97eWMJdoyjoplUqBLtGDOKEN8m1WfWzPebiHrbPqlKuaANZlXtWvYYNQKo2oMnrsPyIt2/dkDuY/2MJd/3nV/mrVKRr9Lb36XPwoIl6aRbDT43g2pz1jweNZfCHjQ4yNu4mqJpvnroYRcYnJoxLuPCR2v394yNwoG3awbFmBPa2t9gW9REnWWADkBovxCJ+Oz3vwu0E0UnyhABv9+1f31NQtXw/rTojAHYnwkmSM3GSBT4AIR0kBPI5fz/ZO1I7//5YGLCiTh20B7EHvy6XffeEkSyw0UHyVnBcMt7FvbBHHFMgV3F2UScs+3YprYNtcs86I0gdcLngn809OMkCm9e2KbKHDVObLOMyXhYU/+1/fbAGB9oJoyWCvVWhOuCq8rwq13CSBTYAGaOE9aGQCz0EbUWKMoADyTnLUlVBD2EE4SQLbKZYLtwnygpZ1fJ1AQJF+ejLHsX/qp6QM7GLlGkDPIhvDCGGytzLa1kHrjSu6scGIHmrOq4a6vI+sGhjijNWId8H7CjI/gqrfBWCEQ37Q6pY06uOOlXqWecaTrLABiAhjSDofNgSykY8xPQGLiNVI9ZPz82odcoNMkFGxioUwvRKt0tGkMfdy2ne+bh2j49AUS8LkN52tzI4ivy1Htfw8ZFgRhBG+iibEQR+SSFRFYt6/6L8tGoM/lpvNslJcrEWe7QFnrmBMGkgJ1lgBJBwVrHQkUl4GlvHOiznIudIGUJga0ypJmeyI7sjr+AklbEh2xBDNvfyXUaWeTM4zOmtkVG9R4fgL1hmyjIoOXrAw3fzlzeZ4MAqGLL+7pGyb0tlQgzZ3tNXOU6GQj4jCCcHHMuexzQrb4PT8C3653b+T9oFnvaGzD9dHr6F/o+9IVgFg1cvWAaw2AhUMAo6tZLTy5INQEJT0iGtV6cIbL2On4VkM9poF3iaUk3RalUWIVVZ98P2970hGMUwdcNUrIhsnl90j6bOc5IFNgCps7+hqY4bfs6949+dMQEOrrn3oDWHDu2sLGhlPEunwfU9Spt8nJFYCHpIEUAw6lRdWh5ucyP/Gc0m2AAkSzAa6YwaD8EbHFOXmcWO8S73CjIVziBMj1ZerVP22uzAcAgUsf8+37A4uOor89PL6UoZVWz8ECdZYAMQm3l04z1l8UC4nRQBJG96M0ERUrBKNd2ZzXzS5cm50rnEDY6JGEGKqK5rTNH9XZ/nJAt8AMLIOFSmw23sIVkK+uxSR62/fZHtrkKDTW+nq3pb3cKq2KSqzgNo4c1bKsBpmZcRQMIyFCayA+GHEc608pLOAYjp9fKLdbX0fC25xYNv7DXp0pTKtKMwfQH0C+wnyRMqnLMZZdL3bPu3iZdN140PQBgpZmU6AQo03tAzC3OZl8GpEfs3QOOT42r93cvcsve+Wl90YIjMm+UchLs84mplkQZwtvqTVZzFMZliZXQDp22WGdUzHtJ6SA5AkukNALROURPzIqIc7x7olSoo/mXpmhT1fICUd28p+3zX5TnJgowgDnpX6yGb2TeCQW95c40+ZC/JmEXe3dKUimwbF72z7BtYHDXpISEZCJOmygiScCL1zWlpL1Utq58YJfIs2gtkEc8bNTD9wRIu9Ig6ZLo+GcHq3L/pa8VQmMnxjNdrZjl+B7WnLAn79Pzj5do8cJzuH6nDT3saWHVaBOs7wghlkQ50Z1gizrqGxTFG+iibKVbIIwiECm4nWQAZFjhslT34uE1BGk6HT5X+D6X/2d9e50ZYCXH0ABM4yQIbgIAxmHtiqhIiYQttUVhr6ApwNMSbvS5BiJ799TXtLsx2hcf9QwQIo8FDdxGrTRic1r/LCrBOsFMA7uOdAyfgwIsEFvg8p8ak7kEq6MwMxswAwqo6iZxZfd+RsVAHljaUvg+2MG8oYXcK9ylys8dUDsu/oVGewbOtdrCSSE7Le1U6pMjtBO3b+OmVmq+xfXb19YbV9tv7lbUqrWj3Gm4ywAognJSzKmJilceQFuuekg9WFZAsPV/N9fodrm+I+gfawE0GWAEky5A23PGc/+tYVzZrDAAJWdURqcSWsAV35eWGbfEgFXTdOGar/awAwilgmLUkpgpi3j+cezB1+tFPZJeyAQk8f/NsHY9u+u1AiAo6qs5NBlgBhNsSX57wmY4X6SHD1wIkeZ69KAsfqw1asSozN4dyXiU06XDd2vjPbABRvADCbImvioBU2Zy08jLb/R3hfjbI1lF2ZSfU0QP85uSoiPrwAsgIDCFVAIKOAEjwSQguKjAEVslDEqqCjraXGSkTXvn85gWQERhBEBwOe9CrEKZaAAkMpnAhqRqDt2pg7Cp1dn1N2dHS9fOH78fL1SSw8KPDzEz+Q0CLrNxJ2eFvgAQBHKp6FcB93oUry3C9mvpftd2+6sdrBBmBKRY6ysoeYujROkISsv4BlsgUyyAY3IxEhqoaT5VdyTLerOTJkPUPNJWbDLAaQej1UVIceBZH4IW2AiWEDhBuMsAKINzeHnXg14qiTFb8rBBDddrR9LXcZIAVQLjNP+sIx9UZ4vY2S4iyGKqBMOEUNxngBZARWOZNOroNPSR0BR2847bMywwgo6GDoKMRLLrp5dbg9Q8AhJkeygsgzJgDQa9DdZd7yz57JADCzBbGCiCcwr2UFc6s8k1Os3QERwd73bPa0eQxbjLACiDclvjqCkZVv6wqzx2F0UO3m9ksghVAuC3xVRHU9DU3lNvDFNQtXbbu71aWletWOuN6bjLAyhdr1EYQ9P/R1h4l4vyRIg2+Uiq16xDR19PBUO7//yiAoHQPQiFR4Tu65jtRUSzt3t3cfD8U9A9mIwgrgHB7e7gQtPsAcfWDxLmoSwj34CYDrKZY3Jb4QhCoUasjNxngBRBmS3yjJnwhtKeOJ7OP9jEDCKvq+OC33LOAA2JJNzCI2/BqqKqc8sQBbjLA7pXNTUnzJAdy2wwOcOx7dgDJ4JscEg60xoH/B0O0+aQmDMInAAAAAElFTkSuQmCC"

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(669);
var bytesToUuid = __webpack_require__(668);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(669);
var bytesToUuid = __webpack_require__(668);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function mergeDefaults(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, mergeDefaults);
  return apply(mergeWith, undefined, args);
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with seven arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = defaultsDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(150)(module)))

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1638)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1054),
  /* template */
  __webpack_require__(1925),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1646)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1055),
  /* template */
  __webpack_require__(1934),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1626)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(1910),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1637)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1057),
  /* template */
  __webpack_require__(1924),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1650)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1058),
  /* template */
  __webpack_require__(1940),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1623)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(1906),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1635)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1922),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1920),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1653)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1063),
  /* template */
  __webpack_require__(1943),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1652)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(1942),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1655)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(1946),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1066),
  /* template */
  __webpack_require__(1930),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1645)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1067),
  /* template */
  __webpack_require__(1933),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1631)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1068),
  /* template */
  __webpack_require__(1915),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1643)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1070),
  /* template */
  __webpack_require__(1931),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1648)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1071),
  /* template */
  __webpack_require__(1938),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1630)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1072),
  /* template */
  __webpack_require__(1914),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1649)
}
var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(1939),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(1937),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1657)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1075),
  /* template */
  __webpack_require__(1949),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1627)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1076),
  /* template */
  __webpack_require__(1911),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d65085c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1077),
  /* template */
  __webpack_require__(1947),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1656)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1078),
  /* template */
  __webpack_require__(1948),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1651)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1080),
  /* template */
  __webpack_require__(1941),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1081),
  /* template */
  __webpack_require__(1936),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1647)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1082),
  /* template */
  __webpack_require__(1935),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1632)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1083),
  /* template */
  __webpack_require__(1917),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1633)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1084),
  /* template */
  __webpack_require__(1918),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1625)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1085),
  /* template */
  __webpack_require__(1908),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1620)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1086),
  /* template */
  __webpack_require__(1904),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1629)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1088),
  /* template */
  __webpack_require__(1913),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1658)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1089),
  /* template */
  __webpack_require__(1950),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1628)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1092),
  /* template */
  __webpack_require__(1912),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1621)
  __webpack_require__(1622)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1093),
  /* template */
  __webpack_require__(1905),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09cb96ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1094),
  /* template */
  __webpack_require__(1945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1642)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1095),
  /* template */
  __webpack_require__(1929),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1619)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1097),
  /* template */
  __webpack_require__(1903),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1909),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1640)
  __webpack_require__(1641)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(1927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4977bc2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(1101),
  /* template */
  __webpack_require__(1951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-middle"
  }, [_c('div', {
    staticClass: "text-center text-center"
  }, [_c('h1', {
    staticClass: "error-number mb-2"
  }, [_vm._v("404")]), _vm._v(" "), _c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Sorry but we couldn't find this page")]), _vm._v(" "), _c('p', [_vm._v("This page you are looking for does not exist")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mid_center"
  }, [_c('h3', {
    staticClass: "mt-5"
  }, [_vm._v("Search")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "col-xs-12 form-group pull-right top_search"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for..."
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "dark": ""
    }
  }, [_vm._v("Go!")])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('small', [_vm._v(_vm._s(_vm.copyright))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-5"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Report this?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(206),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticStyle: {
      "border-bottom": "1px #CDD2E0 solid !important"
    },
    attrs: {
      "color": "white",
      "app": "",
      "fixed": "",
      "dense": "",
      "prominent": "",
      "flat": "",
      "extension-height": "25px"
    }
  }, [_c('v-toolbar-title', [(_vm.topnav.flag == 1) ? _c('span', {
    class: _vm.topnav.class
  }, [_vm._v("\n        " + _vm._s(_vm.topnav.text) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.topnav.flag == 2) ? _c('img', {
    attrs: {
      "src": __webpack_require__(310),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "caption hidden-xs-only grey--text"
  }, [_vm._v(_vm._s(_vm.user.organizationName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text hidden-md-and-up"
  }, [_vm._v("language")]), _vm._v(" "), _c('div', {
    staticClass: "grey--text hidden-sm-and-down"
  }, [_vm._v("\n          language  (" + _vm._s(_vm.$t("params.label")) + ")  \n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])], 1), _vm._v(" "), _vm._l((_vm.supportLanguage), function(label, key) {
    return _c('v-list', {
      key: key
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.changeLanguage(key)
        }
      }
    }, [_c('span', {
      staticClass: "body-1"
    }, [_vm._v(_vm._s(label))])])], 1)
  })], 2), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")]), _vm._v("  \n        "), _c('div', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("\n          " + _vm._s(_vm.user.username) + "  \n          "), _c('role-label', {
    attrs: {
      "role": _vm.user.roles[0]['name']
    }
  }), _vm._v("   \n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })], 1)], 1), _vm._v(" "), _c('v-list', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Profile")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Usage Report'
      }
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Usage Report")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    staticClass: "body-1",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out"
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "justify-center",
    attrs: {
      "slot": "extension",
      "id": "nav-menu"
    },
    slot: "extension"
  }, _vm._l((_vm.topMenus), function(menu) {
    return _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.show),
        expression: "menu.show"
      }],
      key: menu.to,
      attrs: {
        "flat": "",
        "to": menu.to
      }
    }, [_c('div', [_vm._v("\n       " + _vm._s(menu.label) + "\n     ")])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-container reset-pass-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'activate')),
      expression: "(state == 'activate')"
    }],
    staticClass: "m-box signup"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('activate.title')))]), _vm._v(" "), _c('p', {
    staticClass: "mb-3 body-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('activate.detail')) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cognitoErrorMsg),
      expression: "cognitoErrorMsg"
    }]
  }, [_c('div', {
    staticClass: "orange--text",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    }
  }), _vm._v("\n              " + _vm._s(_vm.cognitoErrorMsg) + "\n            ")])]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.activationFormValid),
      callback: function($$v) {
        _vm.activationFormValid = $$v
      },
      expression: "activationFormValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.temp_password'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordVisible = !_vm.passwordVisible); },
      "type": _vm.passwordVisible ? 'text' : 'password'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.newpassword'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.newPasswordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.newPasswordVisible = !_vm.newPasswordVisible); },
      "type": _vm.newPasswordVisible ? 'text' : 'password'
    },
    on: {
      "keyup": _vm.passwordReinputValidate
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "passwordReinput",
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.passwordreinput'),
      "rules": _vm.passwordReinputRules,
      "required": "",
      "append-icon": _vm.passwordReinputVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordReinputVisible = !_vm.passwordReinputVisible); },
      "type": _vm.passwordReinputVisible ? 'text' : 'password'
    },
    model: {
      value: (_vm.passwordReinput),
      callback: function($$v) {
        _vm.passwordReinput = $$v
      },
      expression: "passwordReinput"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 "
  }, [_c('v-card', {
    staticClass: "ma-1 pa-3 body-2 grey black--text",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "EULA"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('activate.agreement_msg'))
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "body-1 ml-1 mt-3"
  }, [_c('v-checkbox', {
    staticClass: "body-1 activate-agree-checkbox",
    attrs: {
      "label": _vm.$t('activate.agree'),
      "required": "",
      "rules": _vm.checkboxRules
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    class: !_vm.activationFormValid || _vm.submitted ? 'grey lighten-1' : 'blue',
    attrs: {
      "disabled": !_vm.activationFormValid || _vm.submitted
    },
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("activate.submit")) + "\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'complete')),
      expression: "(state == 'complete')"
    }]
  }, [_c('p', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("activate.complete")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.login")))])], 1)]), _vm._v(" "), _c('login-footer')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "delete-organization"
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "disabled": !_vm.showForm
    },
    on: {
      "click": function($event) {
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("account.delete-organization")) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.showForm) ? _c('v-form', {
    ref: "editOrganizationForm",
    staticClass: "organization-form",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('div', {
    staticClass: "ma-3 mb-5"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.basic-information")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.editNameLabel,
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }],
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.contact")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": _vm.updateOrganization
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("account.edit")) + "\n      ")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-title')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-org-remove-text'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.edit.name)), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteOrganization($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.delete')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [(_vm.userRole !== _vm.rootRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-btn', {
    staticClass: "teal lighten-1 white--text",
    attrs: {
      "small": "",
      "depressed": "",
      "id": "viewer-permission-edit-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startDialog($event)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('viewable-locations.button-add-viewable-locations')) + "\n  ")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "viewerPermissionForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "px-0 py-2",
    attrs: {
      "xs9": ""
    }
  }, [_c('v-subheader', {}, [_vm._v(_vm._s(_vm.$t("viewable-locations.label-viewing-target-locations")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('viewable-locations.label-viewing-target-locations'),
      "items": _vm.locations,
      "item-text": "locationName",
      "item-value": "locationId",
      "multiple": "",
      "max-height": "300",
      "hint": _vm.$t('viewable-locations.hint-viewing-target-locations'),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.accountGroupResourceIds.viewLocation),
      callback: function($$v) {
        _vm.$set(_vm.edit.accountGroupResourceIds, "viewLocation", $$v)
      },
      expression: "edit.accountGroupResourceIds.viewLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('viewable-locations.button-cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setVisibleLocations($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('viewable-locations.button-set')) + "\n            ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-1 pl-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.lastTemperatureLabel))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lastTemperatureDataFixed + ' ' + _vm.temperatureUnit) + " ")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "ma-3"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showPeriodMessagePeriodJump,
      "content-class": "tooltipMessagePeriodJump"
    },
    model: {
      value: (_vm.showPeriodMessagePeriodJump),
      callback: function($$v) {
        _vm.showPeriodMessagePeriodJump = $$v
      },
      expression: "showPeriodMessagePeriodJump"
    }
  }, [_c('v-select', {
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.change-period'),
      "items": _vm.items,
      "id": "period",
      "hide-details": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices
    },
    slot: "activator",
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.messagePeriodJump))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.jumpToRecent
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.myChartId
    }
  })])], 1), _vm._v(" "), _c('graph-date-select', {
    ref: "graphDateSelect",
    attrs: {
      "locale": _vm.locale,
      "timezone": _vm.timezone,
      "earliestLogInfo": _vm.earliestLogInfo,
      "messagePeriodJump": _vm.messagePeriodJump,
      "messageNoData": _vm.messageNoData,
      "showJumpMessagePeriodJumpProp": _vm.showJumpMessagePeriodJump
    },
    on: {
      "changeDatetime": _vm.changeDatetime,
      "jumpToDatetime": _vm.jumpToDatetime,
      "jumpToRecent": _vm.jumpToRecent
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-container reset-pass-container dark"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'reset_password')),
      expression: "(state == 'reset_password')"
    }],
    staticClass: "m-box"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$t("resetpassword.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("resetpassword.detail")))]), _vm._v(" "), _c('v-form', {
    staticClass: "mb-2",
    model: {
      value: (_vm.resetpassword_valid),
      callback: function($$v) {
        _vm.resetpassword_valid = $$v
      },
      expression: "resetpassword_valid"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-3 white--text",
    class: _vm.resetpassword_valid ? 'blue' : 'grey',
    attrs: {
      "disabled": !_vm.resetpassword_valid || _vm.submitted
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("login.next")) + "\n            ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'confirm')),
      expression: "(state == 'confirm')"
    }],
    staticClass: "m-box"
  }, [_c('div', {
    staticClass: "confirm-box login-content"
  }, [_c('p', {
    staticClass: "confirm-lead"
  }, [_vm._v(_vm._s(_vm.$t("resetpassword.entercode")))]), _vm._v(" "), _c('p', {
    staticClass: "confirm-msg"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("resetpassword.codedetail")) + "\n        ")]), _vm._v(" "), _c('v-form', {
    staticClass: "mb-2",
    model: {
      value: (_vm.confirm_valid),
      callback: function($$v) {
        _vm.confirm_valid = $$v
      },
      expression: "confirm_valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('resetpassword.entercode'),
      "rules": _vm.codeRules,
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirmationCode),
      callback: function($$v) {
        _vm.confirmationCode = $$v
      },
      expression: "confirmationCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('resetpassword.newpassword'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordVisible = !_vm.passwordVisible); },
      "type": _vm.passwordVisible ? 'text' : 'password',
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-3",
    class: _vm.confirm_valid ? 'blue' : 'grey',
    attrs: {
      "color": "blue",
      "dark": "",
      "disabled": !_vm.confirm_valid || _vm.submitted
    },
    on: {
      "click": _vm.confirmResetPassword
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("resetpassword.confirm")) + "\n            ")])], 1), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resendConfirmationCode
    }
  }, [_vm._v(_vm._s(_vm.$t("resetpassword.resendcode")))])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }]
  }, [_c('div', {
    staticClass: "alert alert-danger alert-dismissible fade in",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearErrorMessage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")])]), _vm._v(" "), _c('login-footer')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [_c('v-btn', {
    staticClass: "teal lighten-1 white--text",
    attrs: {
      "small": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startDialog($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "caption"
  }, [_vm._v("add")]), _vm._v("  \n      " + _vm._s(_vm.$t('organizations.button-add-pc')) + "\n  ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "id": "organization-add",
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.showAddDialog),
      callback: function($$v) {
        _vm.showAddDialog = $$v
      },
      expression: "showAddDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "addOrganizationPcForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('div', {
    staticClass: "ma-3 mb-5"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.label-organization")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.organization'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }]
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('aplix-use-only.customer-category'),
      "items": _vm.customerCategories,
      "item-text": "name",
      "item-value": "customerCategoryId",
      "rules": [function (v) { return !!v || _vm.$t('validate.select'); }],
      "required": "",
      "auto": ""
    },
    model: {
      value: (_vm.edit.customerCategoryId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "customerCategoryId", $$v)
      },
      expression: "edit.customerCategoryId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("organizations.limit-settings")))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('organizations.no-limit')
    },
    model: {
      value: (_vm.edit.createNoLimit),
      callback: function($$v) {
        _vm.$set(_vm.edit, "createNoLimit", $$v)
      },
      expression: "edit.createNoLimit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.label-account")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "required": "",
      "label": _vm.$t('account.username'),
      "rules": [function (v) { return !!v || _vm.$t('account.vali-username-must'); }]
    },
    model: {
      value: (_vm.edit.username),
      callback: function($$v) {
        _vm.$set(_vm.edit, "username", $$v)
      },
      expression: "edit.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "required": "",
      "label": _vm.$t('account.useremail'),
      "rules": _vm.useremailRules
    },
    model: {
      value: (_vm.edit.useremail),
      callback: function($$v) {
        _vm.$set(_vm.edit, "useremail", $$v)
      },
      expression: "edit.useremail"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [(_vm.userRole !== _vm.rootRoleName) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.close')) + "\n        ")]), _vm._v(" "), (_vm.userRole === _vm.rootRoleName) ? _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": _vm.addOrganizationPc
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("account.create")) + "\n        ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('form', {
    staticClass: "form-horizontal form-label-left"
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('profile.profile')))]), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.role')) + ":")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.roleName))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.organization')) + ":")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.organizationName))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-2": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.$t('profile.email')) + ":"), (!_vm.emailVerified) ? _c('span', {
    staticClass: "label label-warning",
    staticStyle: {
      "margin-left": "10px",
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.not-verified')))]) : _vm._e()]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "profile-title"
  }, [_vm._v(_vm._s(_vm.edit.email))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-flex', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [((!_vm.emailVerified)) ? _c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openVerifyForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.verify')))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openMailForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.change-email')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'change_email')),
      expression: "(state == 'change_email')"
    }],
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    class: {
      'is-error-field': _vm.errors.newEmail()
    },
    attrs: {
      "type": "email",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.new-email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.newEmail),
      callback: function($$v) {
        _vm.newEmail = $$v
      },
      expression: "newEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "disabled": _vm.hasError
    },
    on: {
      "click": _vm.changeEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.continue')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'change_password')),
      expression: "(state == 'change_password')"
    }],
    ref: "form",
    staticClass: "form-horizontal form-label-left",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(this.$t('profile.change-password-title')))]), _vm._v(" "), _c('v-card', [(_vm.passerror) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.passerror),
      callback: function($$v) {
        _vm.passerror = $$v
      },
      expression: "passerror"
    }
  }, [_vm._v(_vm._s(_vm.passerror))]) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.old-password'),
      "rules": _vm.oldpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.old),
      callback: function($$v) {
        _vm.$set(_vm.password, "old", $$v)
      },
      expression: "password.old"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "id": "passwordNew",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.new-password'),
      "rules": _vm.newpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.new),
      callback: function($$v) {
        _vm.$set(_vm.password, "new", $$v)
      },
      expression: "password.new"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "type": "password",
      "id": "passwordConfirm",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.confirm-new-password'),
      "rules": _vm.newconfirmpassRules,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password.confirm),
      callback: function($$v) {
        _vm.$set(_vm.password, "confirm", $$v)
      },
      expression: "password.confirm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-flex', [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "disabled": _vm.hasError
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.submit')))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == '')),
      expression: "(state == '')"
    }],
    staticClass: "form-group"
  }, [_c('v-flex', {
    staticClass: "text-xs-center text-md-center text-lg-center"
  }, [_c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPasswordForm
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.change-password')))])], 1)], 1)]), _vm._v(" "), ((!_vm.emailVerified)) ? _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'confirm')),
      expression: "(state == 'confirm')"
    }],
    attrs: {
      "md8": "",
      "lg6": "",
      "offset-lg3": "",
      "offset-md2": "",
      "mt-4": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('profile.code-confirm-title')))]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('profile.code-confirm-text1')) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('profile.code-confirm-text2')) + "\n      ")]), _vm._v(" "), (_vm.mailerror) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.mailerror),
      callback: function($$v) {
        _vm.mailerror = $$v
      },
      expression: "mailerror"
    }
  }, [_vm._v(_vm._s(_vm.mailerror))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    class: {
      'is-error-field': _vm.errors.confirminationCode()
    },
    attrs: {
      "type": "email",
      "two-line": "",
      "required": "",
      "label": _vm.$t('profile.code-confirm-input'),
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.confirminationCode),
      callback: function($$v) {
        _vm.confirminationCode = $$v
      },
      expression: "confirminationCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resendConfirmationCode
    }
  }, [_vm._v(_vm._s(_vm.$t('profile.resend')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn primary",
    attrs: {
      "type": "button",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.confirmEmail
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('profile.confirm')) + "\n          "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarMessage) + "\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-main",
    class: _vm.showMap,
    on: {
      "mouseup": _vm.onMouseUp
    }
  }, [_c('div', {
    staticClass: "l-submain",
    class: _vm.currentSize,
    on: {
      "mousemove": _vm.l_submain_onMouseMove,
      "mouseleave": _vm.l_submain_onMouseLeave
    }
  }, [_c('div', {
    staticClass: "l-table-wrap"
  }, [_c('div', {
    staticClass: "l-table-bar "
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 white",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("watersystem.list")) + ":\n            ")]), _vm._v(" "), _c('v-btn', {
    class: [_vm.isCustomerFormat ? 'blue lighten-5 blue--text' : 'grey--text'],
    attrs: {
      "round": "",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": _vm.getLocations
    }
  }, [_c('v-icon', {
    staticClass: "body-1"
  }, [_vm._v("place")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("watersystem.customer")))])], 1), _vm._v(" "), _c('v-btn', {
    class: [_vm.isCustomerFormat ? 'grey--text' : 'blue lighten-5 blue--text'],
    attrs: {
      "round": "",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": _vm.getAllFiltrationSystems
    }
  }, [_c('v-icon', {
    staticClass: "caption"
  }, [_vm._v("smartphone")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("watersystem.device")))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCustomerFormat),
      expression: "isCustomerFormat"
    }]
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "pt-2 pb-2 caption elevation-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'status',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.status")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('status', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'mapinfo',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.mapinfo")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('mapinfo', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'locationName',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.customer-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('locationName', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'organizationName',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.organization-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('organizationName', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'services',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.service")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('services', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'devices',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.device")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('devices', _vm.ordersLocations)))])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCustomerFormat),
      expression: "!isCustomerFormat"
    }]
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "pa-2 caption elevation-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'status',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.status")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('status', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'filtrationSystemName',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.device-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('filtrationSystemName', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'locationName',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.customer-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('locationName', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'dispServices',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.service")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('dispServices', _vm.ordersDevices)))])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    class: ['l-table', _vm.isCustomerFormat ? 'locations' : '']
  }, [(_vm.isCustomerFormat && _vm.locations.length != 0) ? _c('div', [_c('v-expansion-panel', {
    attrs: {
      "expand": "",
      "id": "locations_table"
    }
  }, _vm._l((_vm.locations), function(location, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      ref: "customerExpands",
      refInFor: true,
      staticClass: "grey lighten-4",
      staticStyle: {
        "border-bottom": "1px solid #CCC !important"
      }
    }, [_c('v-layout', {
      attrs: {
        "slot": "header",
        "id": "expansion_row"
      },
      on: {
        "click": function($event) {
          _vm.getEachFiltrationSystems(location.locationId, i, $event)
        }
      },
      slot: "header"
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(location.locationStatus) ? _c('v-icon', {
      staticClass: "body-2",
      class: location.locationStatus == 1 ? 'orange--text' : 'red--text'
    }, [_vm._v("\n                    fiber_manual_record\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(location.latitude != null && location.longitude != null) ? _c('v-btn', {
      staticClass: "d-inline-block map_btn ma-0 white",
      attrs: {
        "small": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.centerMapLocation(location.latitude, location.longitude)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(location.locationName))]), _vm._v(" "), _c('v-flex', {
      staticClass: "grey--text",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(location.organizationName))]), _vm._v(" "), _c('v-flex', {
      staticClass: "service-header",
      attrs: {
        "xs3": ""
      }
    }, _vm._l((location.services), function(serviceId, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.shortServiceNames[serviceId]) + "\n                  ")])
    })), _vm._v(" "), _c('v-flex', {
      class: location.activeDevices == 0 ? 'grey--text text--lighten-2' : '',
      attrs: {
        "xs1": ""
      }
    }, [_vm._v(_vm._s(location.activeDevices))])], 1), _vm._v(" "), (!location.filtrationSystems) ? _c('v-card', [_c('v-progress-linear', {
      attrs: {
        "height": "2",
        "indeterminate": true
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-list', [_vm._l((location.filtrationSystems), function(filtrationSystem) {
      return [_c('v-list-tile', {
        key: filtrationSystem.filtrationSystemId,
        staticClass: "ma-0 pa-0",
        class: filtrationSystem.filtrationSystemId == _vm.selectedFiltrationSystemId ? 'blue lighten-4' : 'white',
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showFiltrationSystem(filtrationSystem.filtrationSystemId)
          }
        }
      }, [_c('v-layout', {
        staticClass: "body-2 grey--text text--darken-2",
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        staticClass: "text-xs-center",
        attrs: {
          "xs1": ""
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.statusCheck(filtrationSystem)) + "\n                          "), (filtrationSystem.status !== 0) ? _c('v-icon', {
        staticClass: "body-2",
        class: filtrationSystem.statusCssClass
      }, [_vm._v("\n                            fiber_manual_record\n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": "",
          "offset-xs1": ""
        }
      }, [_vm._v(_vm._s(filtrationSystem.filtrationSystemName))]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs2": ""
        }
      }, _vm._l((filtrationSystem.dispServices), function(service, index) {
        return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.shortServiceNames[service.serviceId]) + "\n                          ")])
      })), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs1": ""
        }
      }, [_vm._v(_vm._s(filtrationSystem.jm1UniqueId))])], 1), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
        ref: "waterSystemMenu",
        refInFor: true,
        attrs: {
          "left": "",
          "offset-y": ""
        }
      }, [_c('v-btn', {
        attrs: {
          "slot": "activator",
          "small": "",
          "flat": "",
          "icon": ""
        },
        on: {
          "click": _vm.showWaterSystemSettingsMenu
        },
        slot: "activator"
      }, [_c('v-icon', {
        staticClass: "caption grey--text"
      }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showWaterSystemDeleteDialog(filtrationSystem)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.$t('btn.delete')) + "\n                          ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider')]
    })], 2)], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.isCustomerFormat && _vm.locations.length == 0) ? _c('div', [(_vm.message) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + " "), _c('router-link', {
    attrs: {
      "to": "/customer_list"
    }
  }, [_vm._v("here")]), _vm._v(".\n          ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isCustomerFormat && _vm.devices.length != 0) ? _c('div', [_c('v-list', {
    staticClass: "pb-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.devices), function(device) {
    return [_c('v-list-tile', {
      class: device.filtrationSystemId == _vm.selectedFiltrationSystemId ? 'blue lighten-4' : 'white',
      attrs: {
        "row": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFiltrationSystem(device.filtrationSystemId)
        }
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.statusCheck(device)) + "\n                  "), (device.status !== 0) ? _c('v-icon', {
      staticClass: "body-2 pl-2",
      class: device.statusCssClass
    }, [_vm._v("\n                    fiber_manual_record\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_vm._v(_vm._s(device.filtrationSystemName) + " "), _c('span', {
      staticClass: "grey--text"
    }, [_vm._v("(" + _vm._s(device.jm1UniqueId) + ")")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(device.locationName))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, _vm._l((device.dispServices), function(service, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.shortServiceNames[service.serviceId]) + "\n                    ")])
    })), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
      ref: "waterSystemMenu",
      refInFor: true,
      attrs: {
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "small": "",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": _vm.showWaterSystemSettingsMenu
      },
      slot: "activator"
    }, [_c('v-icon', {
      staticClass: "caption grey--text"
    }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showWaterSystemDeleteDialog(device)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('btn.delete')) + "\n                        ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider')]
  })], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.isCustomerFormat && _vm.devices.length == 0) ? _c('div', [(_vm.message) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + "\n          ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "l-detail-wrap"
  }, [_c('div', {
    staticClass: "l_detail_bar lighten-1",
    on: {
      "mousedown": _vm.l_detail_bar_onMouseDown
    }
  }, [_c('v-layout', {
    staticClass: "white--text "
  }, [_c('v-flex', {
    staticClass: "pt-2 pl-2"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("watersystem.deviceinfo")))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('v-icon', {
    staticClass: "white--text mr-4 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('max')
      }
    }
  }, [_vm._v("vertical_align_top")]), _vm._v(" "), _c('v-icon', {
    staticClass: "white--text mr-4 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('mid')
      }
    }
  }, [_vm._v("vertical_align_center")]), _vm._v(" "), _c('v-icon', {
    staticClass: "white--text mr-5 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('min')
      }
    }
  }, [_vm._v("vertical_align_bottom")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-detail"
  }, [_c('water-system', {
    ref: "filtrationSystem",
    on: {
      "child-action": _vm.centerMapLocation,
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "l-map"
  }, [_c('v-btn', {
    staticClass: "map_float_btn map_btn elevation-5",
    attrs: {
      "dark": "",
      "small": "",
      "color": "grey",
      "absolute": ""
    },
    on: {
      "click": _vm.mapToggle
    }
  }, [(_vm.active) ? _c('v-icon', [_vm._v("keyboard_arrow_right")]) : _c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "min-height": "90vh",
      "border-left": "3px solid #AAA"
    },
    attrs: {
      "id": _vm.mapName
    }
  })], 1), _vm._v(" "), _c('water-system-delete-dialog', {
    ref: "waterSystemDeleteDialog",
    on: {
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-flex', {
    attrs: {
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-card', [(_vm.errorMessage) ? _c('div', {
    staticClass: "red--text no-print"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    staticClass: "no-print",
    attrs: {
      "pt-2": "",
      "pr-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.userRole == _vm.rootRoleName) ? _c('v-btn', {
    staticClass: "primary lighten-1 white--text",
    on: {
      "click": _vm.createDownloadZip
    }
  }, [_c('v-icon', [_vm._v("cloud_download")]), _vm._v("\n            " + _vm._s(_vm.$t('aplix-use-only.usage-report.button-csv-download')) + "\n          ")], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "grey grey--text text--darken-3",
    attrs: {
      "disabled": _vm.isIOS(),
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.printDiv()
      }
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n              " + _vm._s(_vm.$t('usage-report.print')) + "\n            ")], 1), _vm._v(" "), (_vm.isIOS()) ? _c('div', [_vm._v("\n              " + _vm._s(_vm.$t('usage-report.can-not-print-ios')) + "\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "no-print",
    attrs: {
      "pt-2": "",
      "pr-3": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "where-select-box",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dateList,
      "item-text": "label",
      "item-value": "value",
      "label": _vm.$t('usage-report.date'),
      "disabled": !_vm.dispFlag
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1), _vm._v(" "), (_vm.userRole == _vm.rootRoleName) ? _c('v-flex', {
    staticClass: "where-select-box",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.summariesPcList,
      "item-text": "organizationName",
      "item-value": "organizationId",
      "label": _vm.$t('aplix-use-only.usage-report.pc-organization'),
      "rules": [function (v) { return !!v || _vm.$t('validate.select'); }],
      "error": _vm.summariesPcListError
    },
    model: {
      value: (_vm.selectPcOrg),
      callback: function($$v) {
        _vm.selectPcOrg = $$v
      },
      expression: "selectPcOrg"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "id": "usage-report"
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": "",
      "offset-md1": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md7": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.organization-name')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.usageSummaries.organizationName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "offset-md2": "",
      "align-self-center": "true"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.date')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.dispDate))])])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "md7": "",
      "offset-md1": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('usage-report.total-device-count')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "offset-md2": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.usageSummaries.totalCount) + _vm._s(_vm.$t('usage-report.units')))])])], 1), _vm._v(" "), _c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.location-count-title')))])]), _vm._v(" "), _c('v-card-actions', [_c('v-data-table', {
    staticClass: "usage-report-table",
    attrs: {
      "headers": _vm.locationListHeaders,
      "items": _vm.locationListTable,
      "no-data-text": _vm.$t('usage-report.no-data-text'),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.organizationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.deviceCount))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.$t('usage-report.device-count-title')))])]), _vm._v(" "), _c('v-card-actions', [_c('v-data-table', {
    staticClass: "usage-report-table",
    attrs: {
      "headers": _vm.deviceListHeaders,
      "items": _vm.deviceListTable,
      "no-data-text": _vm.$t('usage-report.no-data-text'),
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.organizationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.filtrationSystemName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.uniqueId))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length !== 0),
      expression: "leakageLog.length!==0"
    }]
  }, [_vm._v(_vm._s(_vm.$t("watersystem.detection-history")))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length === 0),
      expression: "leakageLog.length===0"
    }]
  }, [_vm._v(_vm._s(_vm.$t('watersystem.no-water-leak-history')))]), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length !== 0),
      expression: "leakageLog.length!==0"
    }],
    staticClass: "mt-3 leakage-log-table"
  }, _vm._l((_vm.leakageLog), function(log) {
    return _c('tr', {
      class: _vm.getClassName(log.state)
    }, [(log.state == 1) ? _c('td', [_vm._v(_vm._s(_vm.$t('watersystem.leakage-alert')))]) : _vm._e(), _vm._v(" "), (log.state == 0) ? _c('td', [_vm._v(_vm._s(_vm.$t('watersystem.return-to-normal')))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.timestamp))])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('v-layout', {
    staticClass: "pl-5 pr-5 pb-4",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showPeriodMessagePeriodJump,
      "content-class": "tooltipMessagePeriodJump"
    },
    model: {
      value: (_vm.showPeriodMessagePeriodJump),
      callback: function($$v) {
        _vm.showPeriodMessagePeriodJump = $$v
      },
      expression: "showPeriodMessagePeriodJump"
    }
  }, [_c('v-select', {
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.change-period'),
      "items": _vm.items,
      "id": "period",
      "hide-details": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices
    },
    slot: "activator",
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.messagePeriodJump))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.jumpToRecent
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.myChartId
    }
  })])], 1), _vm._v(" "), _c('graph-date-select', {
    ref: "graphDateSelect",
    attrs: {
      "locale": _vm.locale,
      "timezone": _vm.timezone,
      "earliestLogInfo": _vm.earliestLogInfo,
      "messagePeriodJump": _vm.messagePeriodJump,
      "messageNoData": _vm.messageNoData,
      "showJumpMessagePeriodJumpProp": _vm.showJumpMessagePeriodJump
    },
    on: {
      "changeDatetime": _vm.changeDatetime,
      "jumpToDatetime": _vm.jumpToDatetime,
      "jumpToRecent": _vm.jumpToRecent
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label",
    class: _vm.roleLabel(this.role)
  }, [_vm._v(_vm._s(this.role))])
},staticRenderFns: []}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "plugins"
    }
  }, [_c('v-toolbar', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "dark": "",
      "tabs": "",
      "extended": "",
      "flat": "",
      "height": "70px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text--darken-4 mt-4"
  }, [_c('h2', [_c('v-icon', {
    staticClass: "grey--text text--darken-4"
  }, [_vm._v("\n          track_changes\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t("settings.available-sensor")) + "\n      ")], 1)]), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "slider-color": "grey",
      "color": "blue-grey lighten-5"
    },
    slot: "extension",
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    key: "flowsensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#flowsensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.flow")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "tdssensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#tdssensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.tds")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "pressuresensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#pressuresensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.pressure")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "leakagesensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#leakagesensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.leakage")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "temperaturesensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#temperaturesensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.temperature")) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    key: "flowsensor",
    attrs: {
      "id": "flowsensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFlowsensor),
      callback: function($$v) {
        _vm.searchFlowsensor = $$v
      },
      expression: "searchFlowsensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersFlowsensor,
      "hide-actions": "",
      "items": _vm.flowsensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchFlowsensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "tdssensor",
    attrs: {
      "id": "tdssensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchTdssensor),
      callback: function($$v) {
        _vm.searchTdssensor = $$v
      },
      expression: "searchTdssensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersTdssensor,
      "hide-actions": "",
      "items": _vm.tdssensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchTdssensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "pressuresensor",
    attrs: {
      "id": "pressuresensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchPressuresensor),
      callback: function($$v) {
        _vm.searchPressuresensor = $$v
      },
      expression: "searchPressuresensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersPressuresensor,
      "hide-actions": "",
      "items": _vm.pressuresensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchPressuresensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "leakagesensor",
    attrs: {
      "id": "leakagesensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchLeakagesensor),
      callback: function($$v) {
        _vm.searchLeakagesensor = $$v
      },
      expression: "searchLeakagesensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersLeakagesensor,
      "hide-actions": "",
      "items": _vm.leakagesensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchLeakagesensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "temperaturesensor",
    attrs: {
      "id": "temperaturesensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchTemperaturesensor),
      callback: function($$v) {
        _vm.searchTemperaturesensor = $$v
      },
      expression: "searchTemperaturesensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersTemperturesensor,
      "hide-actions": "",
      "items": _vm.temperaturesensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchTemperaturesensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left_col scroll-view"
  }, [_c('div', {
    staticClass: "hidden-sm-and-down left_col_wrapper white"
  }, [_c('dl', {
    staticClass: "ml-3 mt-4 setting-menu"
  }, [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-4",
    class: {
      'current-page': _vm.$route.path === '/display'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/display"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.display-setting")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.available-sensor")))]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#flowsensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#tdssensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#pressuresensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#leakagesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#temperaturesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.life-and-notification")))]), _vm._v(" "), _c('dd', {
    staticClass: "mb-4 grey--text",
    class: {
      'current-page': _vm.$route.path === ''
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))]), _vm._v(" "), _c('dd', {
    staticClass: "mb-3",
    class: {
      'current_page': _vm.$route.path === '/settings/notifications_mail'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/notifications_mail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-mail")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.organization-user")))]), _vm._v(" "), (_vm.userRole === _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/pc_list'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/pc_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.pc-management")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/organizations_detail'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/organizations_detail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/user_list'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-4",
    class: {
      'current-page': _vm.$route.path === '/user_invite'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_invite"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))])], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    attrs: {
      "id": 'organization' + _vm.organization.organizationId
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectOrganization(_vm.organization.organizationId)
      }
    }
  }, [_vm._v(" \n    "), (_vm.hasChild) ? _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [(_vm.open) ? _c('v-icon', {
    staticClass: "body-2 grey--text"
  }, [_vm._v("indeterminate_check_box")]) : _c('v-icon', {
    staticClass: "body-2 grey--text"
  }, [_vm._v("add_box")])], 1) : _c('span', [_vm._v("    ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "body-2 blue-grey--text text--lighten-2"
  }, [_vm._v("folder")]), _vm._v(" "), _c('span', [_vm._v("\n      " + _vm._s(_vm.organization.name) + "\n      ")])], 1), _vm._v(" "), (_vm.hasChild) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, _vm._l((_vm.organization.children), function(organization, index) {
    return _c('tree-view', {
      key: index,
      attrs: {
        "organization": organization
      },
      on: {
        "child-action": _vm.selectOrganization
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-form', {
    ref: "inviteForm",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-btn', {
    class: !_vm.formValid ? 'grey lighten-1' : _vm.userRole == _vm.rootRoleName ? 'red darken-3' : 'primary',
    attrs: {
      "disabled": !_vm.formValid,
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.registAccount($event)
      }
    }
  }, [(_vm.userRole == _vm.rootRoleName) ? _c('span', [_vm._v("P/C ルートアカウントの発行 (メールの送信)")]) : _c('span', [_vm._v(_vm._s(_vm.$t("account.invite-btn")))])]), _vm._v(" "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('account.csv-import')) + "\n        ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.edit.username),
      callback: function($$v) {
        _vm.$set(_vm.edit, "username", $$v)
      },
      expression: "edit.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm5": "",
      "lg3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-role'),
      "items": _vm.roles,
      "item-text": "name",
      "item-value": "id",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-role'); }],
      "required": "",
      "disabled": _vm.userRole == _vm.rootRoleName,
      "hint": _vm.userRole == _vm.rootRoleName ? 'root account can only make admin role' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.roleId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "roleId", $$v)
      },
      expression: "edit.roleId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": "",
      "sm5": "",
      "lg3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-belongto'),
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "organizationId",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-select'); }],
      "required": "",
      "auto": "",
      "hint": _vm.userRole == _vm.rootRoleName ? 'root account can make accounts under the child organization only.' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.edit.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "organizationId", $$v)
      },
      expression: "edit.organizationId"
    }
  }), _vm._v(" "), (_vm.edit.roleId === 8 && _vm.edit.organizationId) ? _c('visible-locations-set', {
    attrs: {
      "editProp": _vm.edit
    },
    on: {
      "child-action": _vm.setViewerPermission
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 5000,
      "absolute": "",
      "top": "",
      "right": "",
      "color": "teal lighten-2",
      "multi-line": ""
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t('account.success-dialog')) + " "), _c('br'), _vm._v("\n  " + _vm._s(_vm.successMessage) + "\n  ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 white",
    attrs: {
      "fill-height": ""
    }
  }, [(_vm.filtrationSystem.filtrationSystemId) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "grey lighten-4",
    attrs: {
      "xs12": "",
      "sm3": "",
      "id": "sidebar"
    }
  }, [_c('v-container', [(_vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_vm._v("  " + _vm._s(_vm.location.locationName))]), _vm._v(" "), _c('div', {
    staticClass: "device-setting-btn"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "icon": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.openDeviceEditDialog(_vm.filtrationSystem.filtrationSystemId)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('device-edit-dialog', {
    ref: "deviceEditDialog",
    on: {
      "child-action": _vm.getFiltrationSystem
    }
  }), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "icon": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterSystemDeleteDialog(_vm.filtrationSystem)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('water-system-delete-dialog', {
    ref: "waterSystemDeleteDialog",
    on: {
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "id": "device-name"
    }
  }, [_vm._v(_vm._s(_vm.filtrationSystem.filtrationSystemName))]), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2 pa-1 caption"
  }, [_vm._v("UID:" + _vm._s(_vm.filtrationSystem.jm1UniqueId))]), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2 pa-1 caption"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.last-update')) + ":" + _vm._s(_vm.unixToDatetime(_vm.filtrationSystem.modifiedTime)))]), _vm._v(" "), _vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return _c('div', [(service.serviceId == 1) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.flowAndTimeMeta.timeColor === 'blue' ? '' : _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_c('v-icon', {
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.elapsed-time')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.flowAndTimeMeta.fromNowMonth) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("\n                /" + _vm._s(_vm.flowAndTimeMeta.maxLifeMonth) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n              ")])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), (service.serviceId == 1) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.flowAndTimeMeta.flowColor === 'blue' ? '' : _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_c('v-icon', {
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.total-flow')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.flowAndTimeMeta.leftFlowFormated) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("\n                /" + _vm._s(_vm.flowAndTimeMeta.maxFlowFormated) + " " + _vm._s(_vm.unit) + "\n              ")])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), (service.serviceId == 2) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.getClassNameServiceStatus(service).replace('blue--text', '')
    }, [_c('v-icon', {
      class: _vm.getClassNameServiceStatus(service)
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.RoMembrane-short')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [(_vm.getServiceStatus(service) == 2) ? _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-alert')))]) : (_vm.getServiceStatus(service) == 1) ? _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-caution')))]) : _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-good')))])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 3) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.temperature-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")]) : _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 4) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.leakage-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('watersystem.leakage-alert')))]) : _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('watersystem.leakage-normal')))])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 5) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.Pressure-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))]) : (_vm.getPluginStatus(detail) == 1) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))]) : _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3",
    attrs: {
      "id": "location"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('watersystem.customer-info')))]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "address"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.locationAddress))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "phone"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.locationPhone))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "contact"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.organizationContact))])])])], 2), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('csv-download-dialog', {
    attrs: {
      "earliestLogInfo": _vm.earliestLogInfo,
      "locale": _vm.locale,
      "timezone": _vm.selectedTimezone,
      "filtrationSystemProp": _vm.filtrationSystem,
      "filterProp": _vm.filter
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "white",
      "height": "30px",
      "id": "watersystem-tab"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return _c('v-tab', {
      key: _vm.serviceCodes[service.serviceId],
      attrs: {
        "href": '#' + _vm.serviceCodes[service.serviceId],
        "active-class": "white"
      }
    }, [_c('v-icon', {
      class: _vm.getClassNameServiceStatus(service)
    }, [_vm._v("\n             fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.serviceNames[service.serviceId]) + "\n          ")], 1)
  }), _vm._v(" "), _c('v-tab', {
    class: _vm.activeTab == 'HISTORY' ? 'white' : 'grey lighten-3',
    attrs: {
      "href": "#HISTORY",
      "active-class": "white"
    },
    on: {
      "click": _vm.getHistory
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("watersystem.history")) + "\n          ")]), _vm._v(" "), _vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return [(service.serviceId === 1) ? _c('v-tab-item', {
      attrs: {
        "id": "FLOW",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', [_c('v-layout', {
      staticClass: "pl-3"
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('h6', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('customer.undefined')))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('h6', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.$t("watersystem.column-nexttime")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.nextReplacement(_vm.filter.nextReplacementTime)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.frowSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                      "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-layout', {
      staticClass: "pl-3 pr-3",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_c('v-icon', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n                          fa-tint\n                        ")]), _vm._v("\n                        " + _vm._s(_vm.$t('watersystem.rest-flow')) + "\n                      ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('span', {
      staticClass: "title",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.flowLifePercent) + "%\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "grey--text caption"
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.flowLifeLeft) + "\n                        ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "ma-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-progress-linear', {
      staticClass: "ma-0",
      attrs: {
        "value": _vm.flowAndTimeMeta.flowLifePercent,
        "height": "20",
        "color": _vm.flowAndTimeMeta.flowColor
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-layout', {
      staticClass: "pl-3 pr-3",
      attrs: {
        "row": "",
        "wrap": "",
        "align-baseline": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_c('v-icon', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n                          fa-hourglass-half\n                        ")]), _vm._v("\n                         " + _vm._s(_vm.$t('watersystem.elapsed-time')) + "\n                      ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('span', {
      staticClass: "title",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.fromNowMonth) + "\n                          " + _vm._s(_vm.$t("watersystem.period-month")) + "\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "grey--text caption"
    }, [_vm._v("\n                          /" + _vm._s(_vm.flowAndTimeMeta.maxLifeMonth) + "\n                          " + _vm._s(_vm.$t("watersystem.period-month")) + "\n                        ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-progress-linear', {
      staticClass: "ma-0",
      attrs: {
        "value": _vm.flowAndTimeMeta.timePercent,
        "height": "20",
        "color": _vm.flowAndTimeMeta.timeColor
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('flow-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.filter.configId,
        "timezone": _vm.selectedTimezone,
        "unit": _vm.unit,
        "slot-num": _vm.filter.slotNumber,
        "currentTab": _vm.currentTab,
        "activeTab": _vm.activeTab,
        "label-flow": _vm.$t('chart.graph-label-fromlastchange'),
        "label-flow-diff": _vm.$t('chart.graph-label-diff'),
        "label-flow-sum": _vm.$t('chart.graph-label-sum'),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outline": "",
        "disabled": !_vm.showForm || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.showResetDialog = true
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t("watersystem.filter-reset")) + "\n                      ")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.$t('watersystem.flow-life')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertMaxLifeSpanFlow(service.filters[0].maxLifeSpanFlow) + ' ' + _vm.unit) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertMaxLifeSpanFlow(service.filters[0].warningLifeSpanFlow) + ' ' + _vm.unit) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.$t('watersystem.time-life')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertSecondToMonth(service.filters[0].maxLifeSpanTime)) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertSecondToMonth(service.filters[0].warningLifeSpanTime)) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n                            ")])])])])])], 1)], 1), _vm._v(" "), (_vm.frowSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 2) ? _c('v-tab-item', {
      attrs: {
        "id": "RO",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.roSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: " body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('ro-rate-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':1',
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("watersystem.impurities-removal-rate")) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(service.alertRate) + " %\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(service.warningRate) + " %\n                      ")])])])]), _vm._v(" "), (_vm.roSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 3) ? _c('v-tab-item', {
      attrs: {
        "id": "TEMPERA",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.temperature") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('p', [_c('span', {
        staticClass: "orange--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.temperature") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 1)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("watersystem.temperature-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectTemperatureEditPort),
        callback: function($$v) {
          _vm.selectTemperatureEditPort = $$v
        },
        expression: "selectTemperatureEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'TEMPERA' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    })), _vm._v(" "), _c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.temperatureSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('temperature-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectTemperatureEditPort,
        "selectEditPort": _vm.selectTemperatureEditPort,
        "details": service.details,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _vm._l((service.details), function(detail) {
      return _c('tr', [(detail.portNumber == _vm.selectTemperatureEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("service.temperature")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 1) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].alertRate.min) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-min")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].alertRate.max) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-max")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 1) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].warningRate.min) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-min")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].warningRate.max) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-max")) + "\n                      ")]) : _vm._e()])
    })], 2)]), _vm._v(" "), (_vm.temperatureSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 4) ? _c('v-tab-item', {
      attrs: {
        "id": "LEAK",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.leakage") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("watersystem.leakage-all-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectLeakageEditPort),
        callback: function($$v) {
          _vm.selectLeakageEditPort = $$v
        },
        expression: "selectLeakageEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'LEAK' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    }))], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('leakage-log', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectLeakageEditPort,
        "selectEditPort": _vm.selectLeakageEditPort,
        "details": service.details,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', '')
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    })], 2)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 5) ? _c('v-tab-item', {
      attrs: {
        "id": "PRESS",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.pressure") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('p', [_c('span', {
        staticClass: "orange--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.pressure") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 1)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.headline-press-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectEditPort),
        callback: function($$v) {
          _vm.selectEditPort = $$v
        },
        expression: "selectEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'PRESS' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    })), _vm._v(" "), _c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.pressSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('water-pressure-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectEditPort,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _vm._l((service.details), function(detail) {
      return _c('tr', [(detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("service.pressure")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertPressureUnit(detail.alertRate) + ' ' + _vm.pressureUnit) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertPressureUnit(detail.warningRate) + ' ' + _vm.pressureUnit) + "\n                      ")]) : _vm._e()])
    })], 2)]), _vm._v(" "), (_vm.pressSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 2)], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "HISTORY",
      "reverse-transition": "false",
      "transition": "false"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-3"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("watersystem.history")))])]), _vm._v(" "), _vm._l((_vm.history), function(hist) {
    return _c('v-layout', {
      key: hist.index
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('p', [_c('i', {
      staticClass: "fa",
      class: _vm.historyIcon(hist.type)
    }), _vm._v("\n                      " + _vm._s(_vm.unixToDatetime(hist.eventTime)) + "\n                    ")])]), _vm._v(" "), _c('v-flex', [_c('p', [_vm._v(_vm._s(_vm.historyTitle(hist.type)))])])], 1)
  })], 2)], 1)], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showResetDialog),
      callback: function($$v) {
        _vm.showResetDialog = $$v
      },
      expression: "showResetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n              " + _vm._s(_vm.$t('watersystem.filter-reset-title')) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n              " + _vm._s(_vm.$t('watersystem.filter-reset-text')) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isRoot,
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilter($event)
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResetDialog = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filterResetDoBtnName) + "\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResetDialog = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('watersystem.filter-reset-cancel')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('service-setting-dialog', {
    ref: "childSettingDialog"
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.failMessage) ? _c('v-flex', [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.failMessage))])]) : _c('v-flex', {
    staticClass: "white text-xs-center pt-5",
    attrs: {
      "xs12": "",
      "id": "before-select",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1",
    attrs: {
      "size": "70px"
    }
  }, [_vm._v("find_in_page")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('watersystem.please-select')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-wrapper"
  }, [_c('v-card', {
    staticClass: "organization-name"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticClass: "pa-2"
  }, [(_vm.accounts[0]) ? _c('h2', [_vm._v(_vm._s(_vm.accounts[0].organizationName))]) : _vm._e()])]), _vm._v(" "), (_vm.status == 'SELECTED') ? _c('v-flex', {
    staticClass: "pa-2 search",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.status == 'SELECTED') ? _c('div', [_c('v-data-table', {
    staticClass: "elevation-1 user-list",
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.accounts,
      "pagination": _vm.pagination,
      "item-key": "username",
      "rows-per-page-items": [10],
      "search": _vm.listSearch
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.roleName))]), _vm._v(" "), _c('td', [(_vm.checkEditableRole(props.item.roleId, _vm.$store.getters.user.roles[0]['id'])) ? _c('div', [_c('v-menu', {
          attrs: {
            "left": "",
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("build")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              _vm.openEditDialog(props.item)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.edit')) + "\n                  ")]), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              _vm.deleteTarget = props.item;
              _vm.showDeleteDialog = true
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.delete')) + "\n                  ")]), _vm._v(" "), (props.item.user_status === 2) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              _vm.resendMail(props.item.id)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.resend')) + "\n                  ")]) : _vm._e()], 1)], 1)], 1) : _vm._e()])])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.status == 'UNSELECTED') ? _c('div', {
    staticClass: "pa-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user.unselected')))])]) : _vm._e(), _vm._v(" "), (_vm.status == 'NODATA') ? _c('div', {
    staticClass: "pa-3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user.nodata')))])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "450px"
    },
    model: {
      value: (_vm.showEditDialog),
      callback: function($$v) {
        _vm.showEditDialog = $$v
      },
      expression: "showEditDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v(_vm._s(_vm.$t('user.edit-setting')))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.can-edit-message')) + "\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "accountForm",
    staticClass: "pr-4 pl-4"
  }, [_c('div', {
    staticClass: "caption pa-2 blue lighten-5"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('user-params.username')) + ": " + _vm._s(_vm.edit.username)), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('user-params.email')) + ": " + _vm._s(_vm.edit.email) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 pa-2"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-role'),
      "items": _vm.roles,
      "item-text": "name",
      "item-value": "id",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-role'); }],
      "required": ""
    },
    model: {
      value: (_vm.edit.roleId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "roleId", $$v)
      },
      expression: "edit.roleId"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-belongto'),
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "organizationId",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-select'); }],
      "required": "",
      "auto": ""
    },
    model: {
      value: (_vm.edit.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "organizationId", $$v)
      },
      expression: "edit.organizationId"
    }
  }), _vm._v(" "), (_vm.edit.roleId === 8 && _vm.edit.organizationId) ? _c('visible-locations-set', {
    attrs: {
      "editProp": _vm.edit
    },
    on: {
      "child-action": _vm.setViewerPermission
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editAccount($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.edit')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEditDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.cancel')) + "\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-title')) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-user-remove-text'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.deleteTarget.username)), _c('br'), _vm._v("\n        (" + _vm._s(_vm.deleteTarget.email) + ")"), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteAccount($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.delete')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "calc(100% - 220px)"
    }
  }, [_c('v-layout', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "id": "pc-sort-box",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2 search",
    attrs: {
      "xs5": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm7": ""
    }
  }, [_c('organization-pc-add-btn', {
    ref: "organizationAdd",
    on: {
      "reload": _vm.getOrganizationPcs
    }
  })], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "id": "pc-list-main",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm5": "",
      "id": "pc-list"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.filteredPcs,
      "select-all": "",
      "disable-initial-sort": "",
      "hide-headers": "",
      "item-key": "locationId"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              _vm.selectOrganization(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left body-1"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right caption grey--text text--darken-2"
        }, [_vm._v("\n                " + _vm._s(props.item.created) + "\n            ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "grey lighten-3",
    attrs: {
      "xs12": "",
      "sm7": "",
      "id": "pc-detail"
    }
  }, [_c('v-card', {
    staticClass: "ma-2 pl-3"
  }, [_c('div', {
    staticClass: "setting"
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": "",
      "disabled": _vm.settingBtnDisabled
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "caption grey--text"
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.editOrganization()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('btn.edit')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "align-baseline pa-0"
  }, [_c('h2', {
    attrs: {
      "id": "pc-name"
    }
  }, [_vm._v(_vm._s(_vm.pc.name))]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.pc.description))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.incharge')))]), _vm._v("\n                " + _vm._s(_vm.pc.contact) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.tel')))]), _vm._v("\n                " + _vm._s(_vm.pc.phone) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.email')))]), _vm._v("\n                " + _vm._s(_vm.pc.email) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('aplix-use-only.customer-category')))]), _vm._v("\n                " + _vm._s(_vm.pc.customerCategoryName) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 account-list",
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.accountList,
      "item-key": "username"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', [(props.item.user_status === 2) ? _c('div', [_c('v-menu', {
          attrs: {
            "left": "",
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("build")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              _vm.resendMail(props.item.id)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$t('btn.resend')) + "\n                      ")])], 1)], 1)], 1) : _vm._e()])])]
      }
    }])
  })], 1), _vm._v(" "), _c('organization-edit-btn', {
    ref: "organizationEditDialog",
    on: {
      "child-action": _vm.getOrganizationPcs
    }
  })], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n  ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "settings-header pt-3 pl-3 grey lighten-4",
    attrs: {
      "id": "account-header"
    }
  }, [_c('h1', {
    attrs: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "mr-3 icon icon-organization"
  }), _vm._v("\n      " + _vm._s(_vm.$t('account.header-title')) + "\n    ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": "",
      "height": "35px"
    }
  }, [_c('v-toolbar-items', [(_vm.userRole === _vm.rootRoleName) ? _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/pc_list'
    },
    attrs: {
      "flat": "",
      "to": "/settings/pc_list"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('account.header-pc')))])]) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.rootRoleName) ? _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/organizations_detail'
    },
    attrs: {
      "flat": "",
      "to": "/settings/organizations_detail"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('account.header-org')))])]) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.rootRoleName) ? _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/user_list'
    },
    attrs: {
      "flat": "",
      "to": "/settings/user_list"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('account.header-user')))])]) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.rootRoleName) ? _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/user_invite'
    },
    attrs: {
      "flat": "",
      "to": "/settings/user_invite"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('account.header-invite')))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "dateSelectedForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "datePickerDialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "content-class": "datepicker-dialog",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices,
      "return-value": _vm.toDate
    },
    on: {
      "update:returnValue": function($event) {
        _vm.toDate = $event
      }
    },
    model: {
      value: (_vm.showDatepicker),
      callback: function($$v) {
        _vm.showDatepicker = $$v
      },
      expression: "showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "datepicker-field",
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.label-date'),
      "prepend-icon": "event",
      "readonly": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices
    },
    slot: "activator",
    model: {
      value: (_vm.formatToDate),
      callback: function($$v) {
        _vm.formatToDate = $$v
      },
      expression: "formatToDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.toDateMin,
      "max": _vm.toDateMax,
      "scrollable": "",
      "title-date-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric',
        day: 'numeric'
      }); },
      "header-date-format": function (date) { return this$1.formatDateCommon(date, {
        year: 'numeric',
        month: 'numeric'
      }); },
      "month-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric'
      }); },
      "first-day-of-week": this.firstDayOfWeek(),
      "locale": this.locale
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDatepicker = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("chart.button-cancel")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.datePickerDialog.save(_vm.toDate)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("chart.button-ok")))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('chart.label-time'),
      "items": _vm.toTimes,
      "required": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices,
      "auto": ""
    },
    model: {
      value: (_vm.toTime),
      callback: function($$v) {
        _vm.toTime = $$v
      },
      expression: "toTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": "",
      "disabled": !_vm.showJumpMessagePeriodJump,
      "content-class": "tooltipMessagePeriodJump"
    },
    model: {
      value: (_vm.showJumpMessagePeriodJump),
      callback: function($$v) {
        _vm.showJumpMessagePeriodJump = $$v
      },
      expression: "showJumpMessagePeriodJump"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button",
      "color": _vm.jumpButtonColor,
      "disabled": _vm.disableJump
    },
    on: {
      "click": _vm.jumpToDate
    },
    slot: "activator"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-date-jump")) + "\n        ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.messagePeriodJump))])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": _vm.jumpToRecent
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("chart.button-date-recent")) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.messageNoData) ? _c('span', [_vm._v(_vm._s(_vm.messageNoData))]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container",
    class: _vm.lang
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('signup.signup')))]), _vm._v(" "), (_vm.message) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.resetResponse
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.message) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearError
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.error) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "signupForm"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.username'),
      "rules": _vm.validate.usernameRules(_vm.$t),
      "color": "white",
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.validate.emailRules(_vm.$t),
      "color": "white",
      "required": "",
      "autocomplete": "email"
    },
    model: {
      value: (_vm.useremail),
      callback: function($$v) {
        _vm.useremail = $$v
      },
      expression: "useremail"
    }
  }), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4 ma-1 pa-3 body-2 grey black--text",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "EULA"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.agreement_msg'))
    }
  })]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "agree_checkbox mt-3",
    attrs: {
      "label": _vm.$t('activate.agree'),
      "rules": _vm.checkboxRules
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }), _vm._v(" "), _c('v-btn', {
    class: !_vm.agree || _vm.done ? 'grey lighten-1' : 'blue',
    attrs: {
      "color": "blue",
      "dark": "",
      "disabled": !_vm.agree || _vm.done
    },
    on: {
      "click": _vm.checkCreds
    }
  }, [_vm._v("\n            " + _vm._s(_vm.done ? _vm.$t('signup.btn_check_email') : _vm.$t('signup.register')) + "\n        ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:%68%61%72%70%73%2d%73%75%70%70%6f%72%74%40%61%70%6c%69%78%2e%63%6f%2e%6a%70"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('signup.buy_iotizr')) + "\n        ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v(_vm._s(_vm.$t("signup.signupConfirmDialogText")))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmDialog = false;
        _vm.window.grecaptcha.execute();
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "350"
    },
    model: {
      value: (_vm.okDialog),
      callback: function($$v) {
        _vm.okDialog = $$v
      },
      expression: "okDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    attrs: {
      "id": "OKDIALOG"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.signupSuccessDialogText'))
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.signUpCompleted()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "350"
    },
    model: {
      value: (_vm.errorDialog),
      callback: function($$v) {
        _vm.errorDialog = $$v
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorDialogMessage)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.errorDialog = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-size": "invisible"
    }
  })], 1), _vm._v(" "), _c('login-footer')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('small', [_vm._v(_vm._s(_vm.copyright))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "./login"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(206),
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('h1', {
    staticClass: "mb-5"
  }, [_vm._v(_vm._s(_vm.$t('login.login')))]), _vm._v(" "), (_vm.message) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.resetResponse
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.message) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', [_c('div', {
    staticClass: "alert"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearError
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" " + _vm._s(_vm.error) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    staticClass: "mb-2"
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.password'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordVisible = !_vm.passwordVisible); },
      "type": _vm.passwordVisible ? 'text' : 'password',
      "autocomplete": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": _vm.checkCreds
    }
  }, [_vm._v(_vm._s(_vm.$t('login.login')))])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "reset_pass",
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.lost")))]), _c('br'), _vm._v(" "), (_vm.isHarps4) ? _c('div', [_c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "reset_pass",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.link_to_signup")))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('login-footer')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade delete-confirm-modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h4'), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to delete this?")]), _vm._v(" "), (_vm.deleteTarget != null) ? _c('p', [_vm._v(_vm._s(_vm.deleteTarget.name))]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "~click": function($event) {
        _vm.unregist($event)
      }
    }
  }, [_vm._v("Delete")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel2"
    }
  }, [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "red"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" This operation cannot be undone.")])
}]}

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700px"
    },
    model: {
      value: (_vm.showThresholdHelpDialog),
      callback: function($$v) {
        _vm.showThresholdHelpDialog = $$v
      },
      expression: "showThresholdHelpDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', [(_vm.selectEditServiceId == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.flow-and-time')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.ro-membrane')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.temperature')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('service.pressure')) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.$t('watersystem.differential-pressure')) + "  ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showThresholdHelpDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-flow-and-time-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-ro-membrane-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-temperature-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-pressure-text')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', {
    staticClass: "help-dialog-text"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.about-differential-pressure-text')) + " ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-dialog-header"
  }, [_vm._v("■" + _vm._s(_vm.$t('watersystem.need-sensor')))]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.flow')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.tds')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.temperature')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('sensor.pressure')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.differential-pressure-need-sensor')))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "help-dialog-header"
  }, [_vm._v("■" + _vm._s(_vm.$t('watersystem.about-threshold-setting')))]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-flow-and-time-text').replace('[UNIT]', this.unit)))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-ro-membrane-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-temperature-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 0) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-pressure-text')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5 && _vm.validationType == 1) ? _c('v-card-text', [_vm._v(_vm._s(_vm.$t('watersystem.about-setting-differential-pressure-text')))]) : _vm._e()], 1), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.flow')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(304),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.time-elapsed')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(121),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(122),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": __webpack_require__(309),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(303),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.entrance-impurity-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.exit-impurity-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(121),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(122),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": __webpack_require__(307),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.temperature-content')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(121),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(122),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": __webpack_require__(308),
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(123),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.validationType == 0) ? _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.pressure')))]) : _vm._e(), _vm._v(" "), (_vm.validationType == 1) ? _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.differential-pressure-value')))]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(121),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.alert')))]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-div-icon",
    attrs: {
      "xs1": ""
    }
  }, [_c('img', {
    staticClass: "setting-dialog-threshold-icon",
    attrs: {
      "src": __webpack_require__(122),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "setting-dialog-threshold-icon-title",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('watersystem.warning')))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validationType == 0) ? _c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": __webpack_require__(306),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validationType == 1) ? _c('img', {
    staticClass: "setting-dialog-threshold-drawing",
    attrs: {
      "src": __webpack_require__(305),
      "alt": ""
    }
  }) : _vm._e()])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mapModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "data-backdrop": "static"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "map",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "google-map",
    attrs: {
      "id": _vm.mapName
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.getAddress
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('customer.get-address')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "deviceEditForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('device.name'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('device.vali-device-name'); }]
    },
    model: {
      value: (_vm.edit.filtrationSystemName),
      callback: function($$v) {
        _vm.$set(_vm.edit, "filtrationSystemName", $$v)
      },
      expression: "edit.filtrationSystemName"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": (!_vm.validated || _vm.isRoot)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateDevice($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editBtnName) + "\n            ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "ma-0 grey darken-3 add-organization-btn",
    attrs: {
      "block": "",
      "disabled": _vm.addBtnDisabled
    },
    on: {
      "click": _vm.startDialog
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(302),
      "width": "16"
    }
  }), _vm._v("  \n    "), _c('span', [_vm._v(_vm._s(_vm.$t("settings.add-organization")))])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "id": "organization-add",
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.showAddDialog),
      callback: function($$v) {
        _vm.showAddDialog = $$v
      },
      expression: "showAddDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-form', {
    ref: "addOrganizationForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('div', {
    staticClass: "ma-3 mb-5"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.basic-information")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.organization'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }]
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('account.label-parent'),
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "organizationId",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-select'); }],
      "required": "",
      "auto": ""
    },
    model: {
      value: (_vm.edit.parOrganization),
      callback: function($$v) {
        _vm.$set(_vm.edit, "parOrganization", $$v)
      },
      expression: "edit.parOrganization"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.contact")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('account.cancel')) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": _vm.addOrganization
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("account.create")) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "setting-display grey lighten-4"
  }, [_c('div', {
    staticClass: "setting-display-wrapper"
  }, [(_vm.userRole === _vm.staffRoleName || _vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "setting-display-innner",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(311),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mb-2 pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.display-setting")))])]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.unit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['gal', 'liter'],
      "label": _vm.unit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.pressureUnit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['PSI', 'MPa'],
      "label": _vm.pressureUnit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.pressureUnit),
      callback: function($$v) {
        _vm.pressureUnit = $$v
      },
      expression: "pressureUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.temperatureUnit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['°C', '°F'],
      "label": _vm.temperatureUnit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.temperatureUnit),
      callback: function($$v) {
        _vm.temperatureUnit = $$v
      },
      expression: "temperatureUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.timezone")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectItemsTimezone,
      "item-text": "text",
      "item-value": "value",
      "label": _vm.timezone,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.timezone),
      callback: function($$v) {
        _vm.timezone = $$v
      },
      expression: "timezone"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "offset-sm1": "",
      "offset-md1": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(312),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.available-sensor")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#flowsensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#tdssensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#pressuresensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#leakagesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#temperaturesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))])], 1)])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.life-and-notification")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4 grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/notifications_mail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-mail")))])], 1)])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "offset-sm1": "",
      "offset-md1": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(314),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.organization-user")))])]), _vm._v(" "), (_vm.userRole === _vm.rootRoleName) ? _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/pc_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.pc-management")))])], 1)]) : _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/organizations_detail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))])], 1), _vm._v(" "), _c('li', [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_invite"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))])], 1)])])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 settings_container"
  }, [_c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "right_col_content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("notifications.title-mail")))]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": ("" + _vm.mailTitle)
    },
    model: {
      value: (_vm.emailNotification),
      callback: function($$v) {
        _vm.emailNotification = $$v
      },
      expression: "emailNotification"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("notifications.title-langage")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.items,
      "label": _vm.emailLanguage,
      "item-text": "disp",
      "item-value": "code",
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.emailLanguage),
      callback: function($$v) {
        _vm.emailLanguage = $$v
      },
      expression: "emailLanguage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": "",
      "fluid": "",
      "id": "home"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm3": "",
      "id": "home-notifications"
    }
  }, [_c('div', {
    staticClass: "text-xs-center pt-2 pb-1 grey lighten-4"
  }, [_c('h2', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v(_vm._s(_vm.now))]), _vm._v(" "), _c('p', {
    staticClass: "grey--text ma-0"
  }, [_vm._v(_vm._s(_vm.user.organizationName))])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("\n              " + _vm._s(_vm.$t("home.notification")) + " (" + _vm._s(_vm.notifications.length) + ")\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, _vm._l((_vm.notifications), function(notfctn) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: 'watersystem_list/' + notfctn.id
        }
      }
    }, [_c('v-alert', {
      staticClass: "ma-2 pa-1 lighten-5",
      class: notfctn.type == 'error' ? 'red' : 'orange',
      attrs: {
        "outline": "",
        "color": notfctn.type,
        "icon": notfctn.type,
        "value": true
      }
    }, [_c('span', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(notfctn.title))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "body-2"
    }, [_vm._v("[ " + _vm._s(notfctn.service) + " ]")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(notfctn.message))])])], 1)], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "  grey lighten-5 pt-2 pr-4 pl-4",
    attrs: {
      "xs12": "",
      "sm9": "",
      "id": "home-main"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.information))])]), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-card', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "infomation-text"
  }, [_vm._v(_vm._s(this.mailDate) + " - " + _vm._s(_vm.$t("home.mail-notification-top")))]), _vm._v(" "), _c('div', {
    staticClass: "infomation-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.mail-notification-under', ['./settings/notifications_mail']))
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "mt-4"
  }, [_c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("home.quick-link")))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    },
    on: {
      "click": function($event) {
        _vm.quickLink('customer')
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "size": "40px",
      "tile": ""
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(316),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('span', {
    staticClass: "blue--text caption"
  }, [_vm._v(_vm._s(_vm.$t("global-menu.watersystem")))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("watersystem.customer")) + " (" + _vm._s(_vm.locationCount) + ")")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    },
    on: {
      "click": function($event) {
        _vm.quickLink('device')
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "size": "40px",
      "tile": ""
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(315),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('span', {
    staticClass: "blue--text caption"
  }, [_vm._v(_vm._s(_vm.$t("global-menu.watersystem")))])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("watersystem.device")) + " (" + _vm._s(_vm.filtrationSystemCount) + ")")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "mt-4"
  }, [_c('v-expansion-panel-content', {
    staticClass: "grey lighten-2",
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("home.calendar")))])]), _vm._v(" "), _c('v-card', {
    staticClass: "white pa-2"
  }, [_c('full-calendar', {
    attrs: {
      "events": _vm.calendarEvents,
      "config": _vm.calendarConfig
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "settings-header pt-3 pl-3 grey lighten-4",
    attrs: {
      "id": "notifications-header"
    }
  }, [_c('h1', {
    attrs: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "mr-3 icon icon-bell"
  }), _vm._v("\n      " + _vm._s(_vm.$t('notifications.header-title')) + "\n    ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": "",
      "height": "35px"
    }
  }, [_c('v-toolbar-items', [_c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/XXXXXXX'
    },
    attrs: {
      "flat": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('notifications.header-preset')))])]), _vm._v(" "), _c('v-btn', {
    class: {
      'current_page': _vm.$route.path === '/settings/notifications_mail'
    },
    attrs: {
      "flat": "",
      "to": "/settings/notifications_mail"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('notifications.header-mail')))])])], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-wrapper"
  }, [_c('v-container', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    staticClass: "organization",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "organization-list-left",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('organization-add-btn', {
    on: {
      "child-action": _vm.showMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-3 pt-2",
    attrs: {
      "id": "organization-list"
    }
  }, [_c('ul', [_c('tree-view', {
    attrs: {
      "organization": _vm.treeData
    },
    on: {
      "child-action": _vm.selectOrganization
    }
  })], 1)])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "organization-detail-right",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('router-view', {
    ref: "child",
    attrs: {
      "selectedOrganizationId": _vm.selectedOrganizationId,
      "roles": _vm.roles,
      "organizations": _vm.organizations
    },
    on: {
      "child-action": _vm.showMessage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.showSettingDialog),
      callback: function($$v) {
        _vm.showSettingDialog = $$v
      },
      expression: "showSettingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', [(_vm.selectEditServiceId == 1) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.flow-and-time')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.ro-membrane')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.temperature')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.locationName) + " > " + _vm._s(_vm.filtrationSystemName) + " > " + _vm._s(_vm.$t('service.pressure')) + " " + _vm._s(_vm.$t('settings.title')) + " ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSettingDialog(false)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('h4', {
    staticClass: "setting-dialog-threshold-h"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.threshold')))]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.openHelpDialog()
      }
    }
  }, [_c('v-icon', {
    staticClass: "body-1",
    attrs: {
      "large": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-flow-and-time')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-ro-membrane')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-temperature')))]) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('span', [_vm._v(_vm._s(_vm.$t('watersystem.about-pressure')))]) : _vm._e()], 1), _vm._v(" "), _c('help-dialog', {
    ref: "childHelpDialog"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.presetRadio),
      callback: function($$v) {
        _vm.presetRadio = $$v
      },
      expression: "presetRadio"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('watersystem.custom'),
      "value": "0"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('watersystem.use-preset'),
      "value": "1",
      "disabled": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "settingForm",
    model: {
      value: (_vm.settingDialogValid),
      callback: function($$v) {
        _vm.settingDialogValid = $$v
      },
      expression: "settingDialogValid"
    }
  }, [(_vm.selectEditServiceId == 1) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t("watersystem.flow-life")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.alert")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.unit,
      "rules": _vm.lifespanFrowRateAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.maxFlowLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "maxFlowLifeSpan", $$v)
      },
      expression: "flowEditData.maxFlowLifeSpan"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.warning")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.unit,
      "rules": _vm.lifespanFrowRateWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.warningFlowLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "warningFlowLifeSpan", $$v)
      },
      expression: "flowEditData.warningFlowLifeSpan"
    }
  })], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("watersystem.time-life")))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.alert")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.$t("watersystem.period-month"),
      "rules": _vm.lifespanMonthAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.maxUptimeLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "maxUptimeLifeSpan", $$v)
      },
      expression: "flowEditData.maxUptimeLifeSpan"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                      fiber_manual_record\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("watersystem.warning")) + "\n                    "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.$t("watersystem.period-month"),
      "rules": _vm.lifespanMonthWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.flowEditData.warningUptimeLifeSpan),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "warningUptimeLifeSpan", $$v)
      },
      expression: "flowEditData.warningUptimeLifeSpan"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 2) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": "%",
      "rules": _vm.roRateAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.roEditData.alertRate),
      callback: function($$v) {
        _vm.$set(_vm.roEditData, "alertRate", $$v)
      },
      expression: "roEditData.alertRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": "%",
      "rules": _vm.roRateWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.roEditData.warningRate),
      callback: function($$v) {
        _vm.$set(_vm.roEditData, "warningRate", $$v)
      },
      expression: "roEditData.warningRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('watersystem.temperature-select-label')) + "\n                "), _c('v-select', {
    attrs: {
      "items": _vm.items,
      "rules": _vm.tempretureSelectRules,
      "item-text": "label",
      "item-value": "value",
      "label": _vm.selectTempretureItem,
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.validationType),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData, "validationType", $$v)
      },
      expression: "temperatureEditData.validationType"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 3) ? _c('v-layout', [(_vm.temperatureEditData.validationType == 1) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMin,
      "rules": _vm.tempretureAlertRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.alertRate.min),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.alertRate, "min", $$v)
      },
      expression: "temperatureEditData.alertRate.min"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 2) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMax,
      "rules": _vm.tempretureAlertRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.alertRate.max),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.alertRate, "max", $$v)
      },
      expression: "temperatureEditData.alertRate.max"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 1) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMin,
      "rules": _vm.tempretureWarningRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.warningRate.min),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.warningRate, "min", $$v)
      },
      expression: "temperatureEditData.warningRate.min"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.temperatureEditData.validationType == 2) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "suffix": _vm.temperatureUnitMax,
      "rules": _vm.tempretureWarningRules
    },
    on: {
      "click": _vm.settingFormValidate,
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.temperatureEditData.warningRate.max),
      callback: function($$v) {
        _vm.$set(_vm.temperatureEditData.warningRate, "max", $$v)
      },
      expression: "temperatureEditData.warningRate.max"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 5) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('watersystem.differential-pressure')
    },
    on: {
      "change": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.isDifferentialPressure),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "isDifferentialPressure", $$v)
      },
      expression: "pressEditData.isDifferentialPressure"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.alert")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.pressureUnit,
      "rules": _vm.pressureAlertRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.alertRate),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "alertRate", $$v)
      },
      expression: "pressEditData.alertRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-icon', {
    staticClass: "orange--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.warning")) + "\n                "), _c('v-text-field', {
    attrs: {
      "suffix": _vm.pressureUnit,
      "rules": _vm.pressureWarningRules
    },
    on: {
      "keyup": _vm.settingFormValidate
    },
    model: {
      value: (_vm.pressEditData.warningRate),
      callback: function($$v) {
        _vm.$set(_vm.pressEditData, "warningRate", $$v)
      },
      expression: "pressEditData.warningRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectEditServiceId == 1) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("\n                  fiber_manual_record\n                ")]), _vm._v("\n                " + _vm._s(_vm.$t("watersystem.use-flow")) + "\n                "), _c('v-select', {
    attrs: {
      "items": _vm.flowsensors,
      "item-text": "name",
      "item-value": "id",
      "required": ""
    },
    model: {
      value: (_vm.flowEditData.pluginInfoId),
      callback: function($$v) {
        _vm.$set(_vm.flowEditData, "pluginInfoId", $$v)
      },
      expression: "flowEditData.pluginInfoId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": (!_vm.settingDialogValid || _vm.isRoot)
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateConfig()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.execBtnName) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "nomal"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSettingDialog(false)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.cancel')) + "\n            ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [(_vm.userRole !== _vm.rootRoleName) ? _c('div', [_c('v-btn', {
    staticClass: "teal lighten-1 white--text",
    attrs: {
      "small": "",
      "depressed": "",
      "id": "cutomer-add-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startDialog($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "caption"
  }, [_vm._v("add")]), _vm._v("  \n      " + _vm._s(_vm.$t('customer.add')) + "\n  ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "customerForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('customer.name'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-location-name'); }]
    },
    model: {
      value: (_vm.edit.locationName),
      callback: function($$v) {
        _vm.$set(_vm.edit, "locationName", $$v)
      },
      expression: "edit.locationName"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('customer.organization'),
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "organizationId",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-select'); }],
      "required": "",
      "auto": "",
      "disabled": _vm.mode == 'EDIT'
    },
    model: {
      value: (_vm.edit.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "organizationId", $$v)
      },
      expression: "edit.organizationId"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('customer.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.locationPhone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "locationPhone", $$v)
      },
      expression: "edit.locationPhone"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs9": "",
      "id": "locationAddress"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "label": _vm.$t('customer.address')
    },
    model: {
      value: (_vm.edit.locationAddress),
      callback: function($$v) {
        _vm.$set(_vm.edit, "locationAddress", $$v)
      },
      expression: "edit.locationAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.getLatLng
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('customer.search')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('customer.latitude')
    },
    model: {
      value: (_vm.edit.latitude),
      callback: function($$v) {
        _vm.$set(_vm.edit, "latitude", $$v)
      },
      expression: "edit.latitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('customer.longitude')
    },
    model: {
      value: (_vm.edit.longitude),
      callback: function($$v) {
        _vm.$set(_vm.edit, "longitude", $$v)
      },
      expression: "edit.longitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    class: _vm.showMap ? '' : '',
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showMap = !_vm.showMap
      }
    }
  }, [(_vm.showMap == false) ? _c('span', [_c('v-icon', [_vm._v("expand_more")]), _vm._v(" " + _vm._s(_vm.$t('customer.open-map')))], 1) : _vm._e(), _vm._v(" "), (_vm.showMap == true) ? _c('span', [_c('v-icon', [_vm._v("expand_less")]), _vm._v(" " + _vm._s(_vm.$t('customer.close-map')))], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', [(_vm.showMap) ? _c('map-modal', {
    ref: "mapmodal",
    attrs: {
      "edit": _vm.edit
    },
    on: {
      "selectLocation": _vm.selectLocation
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.cancel')) + "\n            ")]), _vm._v(" "), (_vm.mode == 'ADD') ? _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.registLocation($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.save')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'EDIT') ? _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateLocation($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.save')) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [(_vm.userRole !== _vm.viewerRoleName && !_vm.forbiddenBrowser) ? _c('div', [_c('v-btn', {
    staticClass: "primary lighten-1 white--text",
    attrs: {
      "slot": "activator",
      "small": "",
      "depressed": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices,
      "id": "cutomer-add-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startDialog($event)
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("cloud_download")]), _vm._v("  \n          " + _vm._s(_vm.$t('csv-download.button-csv-download')) + "\n    ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "csvDownloadForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('csv-download.start-datetime')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "datePickerStartDialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "content-class": "datepicker-dialog",
      "return-value": _vm.dateStart
    },
    on: {
      "update:returnValue": function($event) {
        _vm.dateStart = $event
      }
    },
    model: {
      value: (_vm.showDatepickerStart),
      callback: function($$v) {
        _vm.showDatepickerStart = $$v
      },
      expression: "showDatepickerStart"
    }
  }, [_c('v-text-field', {
    staticClass: "datepicker-field",
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.label-date'),
      "prepend-icon": "event",
      "readonly": "",
      "rules": _vm.startDateEndDateRules
    },
    slot: "activator",
    model: {
      value: (_vm.formatDateStart),
      callback: function($$v) {
        _vm.formatDateStart = $$v
      },
      expression: "formatDateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.dateRangeMin,
      "max": _vm.dateRangeMax,
      "scrollable": "",
      "title-date-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric',
        day: 'numeric'
      }); },
      "header-date-format": function (date) { return this$1.formatDateCommon(date, {
        year: 'numeric',
        month: 'numeric'
      }); },
      "month-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric'
      }); },
      "first-day-of-week": _vm.firstDayOfWeek(),
      "locale": _vm.locale
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDatepickerStart = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.cancel")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.datePickerStartDialog.save(_vm.dateStart)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.ok")))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('chart.label-time'),
      "items": _vm.selectTimes,
      "required": "",
      "auto": "",
      "rules": _vm.startTimeEndTimeRules
    },
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('csv-download.end-datetime')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "datePickerEndDialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "content-class": "datepicker-dialog",
      "return-value": _vm.dateEnd
    },
    on: {
      "update:returnValue": function($event) {
        _vm.dateEnd = $event
      }
    },
    model: {
      value: (_vm.showDatepickerEnd),
      callback: function($$v) {
        _vm.showDatepickerEnd = $$v
      },
      expression: "showDatepickerEnd"
    }
  }, [_c('v-text-field', {
    staticClass: "datepicker-field",
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.label-date'),
      "prepend-icon": "event",
      "readonly": "",
      "rules": _vm.startDateEndDateRules
    },
    slot: "activator",
    model: {
      value: (_vm.formatDateEnd),
      callback: function($$v) {
        _vm.formatDateEnd = $$v
      },
      expression: "formatDateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.dateRangeMin,
      "max": _vm.dateRangeMax,
      "scrollable": "",
      "title-date-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric',
        day: 'numeric'
      }); },
      "header-date-format": function (date) { return this$1.formatDateCommon(date, {
        year: 'numeric',
        month: 'numeric'
      }); },
      "month-format": function (date) { return this$1.formatDateCommon(date, {
        month: 'numeric'
      }); },
      "first-day-of-week": _vm.firstDayOfWeek(),
      "locale": _vm.locale
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDatepickerEnd = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.cancel")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.datePickerEndDialog.save(_vm.dateEnd)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.ok")))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('chart.label-time'),
      "items": _vm.selectTimes,
      "required": "",
      "auto": "",
      "rules": _vm.startTimeEndTimeRules
    },
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createDownloadZip($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "caption"
  }, [_vm._v("cloud_download")]), _vm._v("  \n              " + _vm._s(_vm.$t('csv-download.button-download')) + "\n            ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.showErrorMessage),
      callback: function($$v) {
        _vm.showErrorMessage = $$v
      },
      expression: "showErrorMessage"
    }
  }, [_c('v-card', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.showErrorMessage = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.ok')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "confirm-message"
  }, [_vm._v(_vm._s(_vm.confirmMessage))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.btnDisable,
      "tabindex": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('btn.cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "disabled": _vm.isRoot,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFiltrationSystem($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deleteBtnName) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showResultDialog),
      callback: function($$v) {
        _vm.showResultDialog = $$v
      },
      expression: "showResultDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "result-message"
  }, [_vm._v(_vm._s(_vm.resultMessage))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "tabindex": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResultDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('btn.ok')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    staticClass: "top-nav"
  }, [_c('topnav')], 1), _vm._v(" "), _c('v-content', {
    staticClass: "grey lighten-3"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customer-list-wrapper"
    }
  }, [_c('v-layout', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "id": "customer-sort-box",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-4 mt-3",
    attrs: {
      "hide-details": "",
      "indeterminate": _vm.checkboxIndeterminate
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "naive", undefined, $event.key)) { return null; }
        _vm.toggleAll($event)
      }
    },
    model: {
      value: (this.locations.length > 0 && this.selectedLocations.length === this.locations.length),
      callback: function($$v) {
        _vm.$set(this.locations.length > 0 && this.selectedLocations.length === this.locations, "length", $$v)
      },
      expression: "this.locations.length > 0 && this.selectedLocations.length===this.locations.length"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2 search",
    attrs: {
      "xs5": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm7": ""
    }
  }, [(_vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('customer-add-btn', {
    ref: "customerDialog",
    on: {
      "child-action": _vm.showMessage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "id": "customer-list-main",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm5": "",
      "id": "customer-list"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.filteredLocations,
      "select-all": "",
      "disable-initial-sort": "",
      "hide-headers": "",
      "pagination": _vm.pagination,
      "item-key": "locationId"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left body-1"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right caption grey--text text--darken-2"
        }, [_vm._v("\n                " + _vm._s(props.item.organizationName) + "\n            ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedLocations),
      callback: function($$v) {
        _vm.selectedLocations = $$v
      },
      expression: "selectedLocations"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "grey lighten-3",
    attrs: {
      "xs12": "",
      "sm7": "",
      "id": "customer-detail"
    }
  }, [((_vm.selectedLocations.length > 0 || _vm.initDisplayLocations.length > 0)) ? _c('v-tabs', {
    staticClass: "white mt-3",
    attrs: {
      "fixed-tabs": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    staticClass: "white",
    attrs: {
      "href": "#customer-info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customer.info')) + "\n        ")]), _vm._v(" "), _c('v-tab-item', {
    staticClass: "white",
    attrs: {
      "id": "customer-info"
    }
  }, _vm._l((_vm.initOrSelectedLocations), function(location) {
    return _c('v-card', {
      key: location.locationId,
      staticClass: "ma-2 pl-3"
    }, [_c('v-card-title', {
      staticClass: "align-baseline pa-0"
    }, [_c('h2', [_vm._v(_vm._s(location.locationName) + "    ")]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(" " + _vm._s(location.organizationName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userRole !== _vm.rootRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "small": "",
        "flat": "",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      staticClass: "caption grey--text"
    }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.editCustomer(location)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.edit')) + "\n                  ")]), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.deleteTarget = location;
          _vm.showDeleteDialog = true
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.delete')) + "\n                  ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer.active-device')) + ":\n                " + _vm._s(location.activeDevices) + "\n              ")]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.address')))]), _vm._v("\n                  " + _vm._s(location.locationAddress) + "\n                ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.contact')))]), _vm._v(" "), _c('div', [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("local_phone")]), _vm._v("\n                    " + _vm._s(location.locationPhone) + "\n                  ")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("mail_outline")]), _vm._v("\n                    " + _vm._s(location.locationEmail) + "\n                  ")], 1)]), _vm._v(" "), _c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('customer.others')))]), _vm._v("\n                  " + _vm._s(_vm.$t('customer.geo-location')) + ": \n                  "), (location.latitude) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('customer.defined')) + "\n                  ")]) : _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('customer.undefined')) + "\n                  ")])])], 1)], 1)], 1)
  }))], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-title')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-location-remove-text'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.deleteTarget.locationName) + "\n        (" + _vm._s(_vm.deleteTarget.organizationName) + ")"), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteCustomer($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.delete')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "relative": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    attrs: {
      "src": _vm.accountImage(this.role),
      "alt": this.role
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('v-layout', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showPeriodMessagePeriodJump,
      "content-class": "tooltipMessagePeriodJump"
    },
    model: {
      value: (_vm.showPeriodMessagePeriodJump),
      callback: function($$v) {
        _vm.showPeriodMessagePeriodJump = $$v
      },
      expression: "showPeriodMessagePeriodJump"
    }
  }, [_c('v-select', {
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.change-period'),
      "items": _vm.items,
      "id": "period",
      "hide-details": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices
    },
    slot: "activator",
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.messagePeriodJump))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.jumpToRecent
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.myChartId
    }
  }), _vm._v(" "), _c('graph-date-select', {
    ref: "graphDateSelect",
    attrs: {
      "locale": _vm.locale,
      "timezone": _vm.timezone,
      "earliestLogInfo": _vm.earliestLogInfo,
      "messagePeriodJump": _vm.messagePeriodJump,
      "messageNoData": _vm.messageNoData,
      "showJumpMessagePeriodJumpProp": _vm.showJumpMessagePeriodJump
    },
    on: {
      "changeDatetime": _vm.changeDatetime,
      "jumpToDatetime": _vm.jumpToDatetime,
      "jumpToRecent": _vm.jumpToRecent
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-5 pl-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.lastRoRateLabel))]), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "size": 130,
      "width": 15,
      "value": Number(_vm.lastRoDataFixed),
      "color": _vm.color
    }
  }, [(_vm.color === 'red') ? _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-alert')))]) : (_vm.color === 'orange') ? _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-caution')))]) : _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-good')))]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.lastRoDataFixed) + " %")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "organizationEditForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.organization'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }]
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('aplix-use-only.customer-category'),
      "items": _vm.customerCategories,
      "item-text": "name",
      "item-value": "customerCategoryId",
      "rules": [function (v) { return !!v || _vm.$t('validate.select'); }],
      "required": "",
      "auto": ""
    },
    model: {
      value: (_vm.edit.customerCategoryId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "customerCategoryId", $$v)
      },
      expression: "edit.customerCategoryId"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("organizations.limit-settings")))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('organizations.no-limit')
    },
    model: {
      value: (_vm.edit.createNoLimit),
      callback: function($$v) {
        _vm.$set(_vm.edit, "createNoLimit", $$v)
      },
      expression: "edit.createNoLimit"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateOrganization($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.save')) + "\n            ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-1 pl-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.lastPressureLabel))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lastPressDataFixed + ' ' + _vm.pressureUnit) + " ")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "ma-3"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showPeriodMessagePeriodJump,
      "content-class": "tooltipMessagePeriodJump"
    },
    model: {
      value: (_vm.showPeriodMessagePeriodJump),
      callback: function($$v) {
        _vm.showPeriodMessagePeriodJump = $$v
      },
      expression: "showPeriodMessagePeriodJump"
    }
  }, [_c('v-select', {
    attrs: {
      "slot": "activator",
      "label": _vm.$t('chart.change-period'),
      "items": _vm.items,
      "id": "period",
      "hide-details": "",
      "disabled": !_vm.earliestLogInfo.existsLogAllServices
    },
    slot: "activator",
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.messagePeriodJump))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.jumpToRecent
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.myChartId
    }
  })])], 1), _vm._v(" "), _c('graph-date-select', {
    ref: "graphDateSelect",
    attrs: {
      "locale": _vm.locale,
      "timezone": _vm.timezone,
      "earliestLogInfo": _vm.earliestLogInfo,
      "messagePeriodJump": _vm.messagePeriodJump,
      "messageNoData": _vm.messageNoData,
      "showJumpMessagePeriodJumpProp": _vm.showJumpMessagePeriodJump
    },
    on: {
      "changeDatetime": _vm.changeDatetime,
      "jumpToDatetime": _vm.jumpToDatetime,
      "jumpToRecent": _vm.jumpToRecent
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "calendar",
    attrs: {
      "id": "calendar"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, create;

  create = __webpack_require__(46);

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing attribute name of element " + parent.name);
      }
      if (value == null) {
        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return create(XMLAttribute.prototype, this);
    };

    XMLAttribute.prototype.toString = function(options, level) {
      return ' ' + this.name + '="' + this.value + '"';
    };

    return XMLAttribute;

  })();

}).call(this);


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, XMLDeclaration, XMLDocType, XMLElement, XMLStringifier;

  XMLStringifier = __webpack_require__(1961);

  XMLDeclaration = __webpack_require__(677);

  XMLDocType = __webpack_require__(678);

  XMLElement = __webpack_require__(679);

  module.exports = XMLBuilder = (function() {
    function XMLBuilder(name, options) {
      var root, temp;
      if (name == null) {
        throw new Error("Root element needs a name");
      }
      if (options == null) {
        options = {};
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      temp = new XMLElement(this, 'doc');
      root = temp.element(name);
      root.isRoot = true;
      root.documentObject = this;
      this.rootObject = root;
      if (!options.headless) {
        root.declaration(options);
        if ((options.pubID != null) || (options.sysID != null)) {
          root.doctype(options);
        }
      }
    }

    XMLBuilder.prototype.root = function() {
      return this.rootObject;
    };

    XMLBuilder.prototype.end = function(options) {
      return this.toString(options);
    };

    XMLBuilder.prototype.toString = function(options) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      r = '';
      if (this.xmldec != null) {
        r += this.xmldec.toString(options);
      }
      if (this.doctype != null) {
        r += this.doctype.toString(options);
      }
      r += this.rootObject.toString(options);
      if (pretty && r.slice(-newline.length) === newline) {
        r = r.slice(0, -newline.length);
      }
      return r;
    };

    return XMLBuilder;

  })();

}).call(this);


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDAttList, create;

  create = __webpack_require__(46);

  module.exports = XMLDTDAttList = (function() {
    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      this.stringify = parent.stringify;
      if (elementName == null) {
        throw new Error("Missing DTD element name");
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name");
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type");
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default");
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT");
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ATTLIST ' + this.elementName + ' ' + this.attributeName + ' ' + this.attributeType;
      if (this.defaultValueType !== '#DEFAULT') {
        r += ' ' + this.defaultValueType;
      }
      if (this.defaultValue) {
        r += ' "' + this.defaultValue + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDAttList;

  })();

}).call(this);


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDElement, create;

  create = __webpack_require__(46);

  module.exports = XMLDTDElement = (function() {
    function XMLDTDElement(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing DTD element name");
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ELEMENT ' + this.name + ' ' + this.value + '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDElement;

  })();

}).call(this);


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDEntity, create, isObject;

  create = __webpack_require__(46);

  isObject = __webpack_require__(68);

  module.exports = XMLDTDEntity = (function() {
    function XMLDTDEntity(parent, pe, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing entity name");
      }
      if (value == null) {
        throw new Error("Missing entity value");
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity");
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity");
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity");
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ENTITY';
      if (this.pe) {
        r += ' %';
      }
      r += ' ' + this.name;
      if (this.value) {
        r += ' "' + this.value + '"';
      } else {
        if (this.pubID && this.sysID) {
          r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
        } else if (this.sysID) {
          r += ' SYSTEM "' + this.sysID + '"';
        }
        if (this.nData) {
          r += ' NDATA ' + this.nData;
        }
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDEntity;

  })();

}).call(this);


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDNotation, create;

  create = __webpack_require__(46);

  module.exports = XMLDTDNotation = (function() {
    function XMLDTDNotation(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing notation name");
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity");
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!NOTATION ' + this.name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.pubID) {
        r += ' PUBLIC "' + this.pubID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDNotation;

  })();

}).call(this);


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLRaw, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  XMLNode = __webpack_require__(124);

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text");
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return create(XMLRaw.prototype, this);
    };

    XMLRaw.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1961 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
      this.noDoubleEncoding = options != null ? options.noDoubleEncoding : void 0;
      ref = (options != null ? options.stringify : void 0) || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      if (val.match(/]]>/)) {
        throw new Error("Invalid CDATA text: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var chars, chr;
      if (this.allowSurrogateChars) {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
      } else {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
      }
      chr = str.match(chars);
      if (chr) {
        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    };

    return XMLStringifier;

  })();

}).call(this);


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLText, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(46);

  XMLNode = __webpack_require__(124);

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text");
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return create(XMLText.prototype, this);
    };

    XMLText.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLText;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0);

var vec2 = __webpack_require__(19);

var Draggable = __webpack_require__(1990);

var Eventful = __webpack_require__(108);

/**
 * Handler
 * @module zrender/Handler
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *         pissang (shenyi.914@gmail.com)
 */
var SILENT = 'silent';

function makeEventPacket(eveType, targetInfo, event) {
  return {
    type: eveType,
    event: event,
    // target can only be an element that is not silent.
    target: targetInfo.target,
    // topTarget can be a silent element.
    topTarget: targetInfo.topTarget,
    cancelBubble: false,
    offsetX: event.zrX,
    offsetY: event.zrY,
    gestureEvent: event.gestureEvent,
    pinchX: event.pinchX,
    pinchY: event.pinchY,
    pinchScale: event.pinchScale,
    wheelDelta: event.zrDelta,
    zrByTouch: event.zrByTouch,
    which: event.which
  };
}

function EmptyProxy() {}

EmptyProxy.prototype.dispose = function () {};

var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */

var Handler = function (storage, painter, proxy, painterRoot) {
  Eventful.call(this);
  this.storage = storage;
  this.painter = painter;
  this.painterRoot = painterRoot;
  proxy = proxy || new EmptyProxy();
  /**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */

  this.proxy = proxy; // Attach handler

  proxy.handler = this;
  /**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */

  this._hovered = {};
  /**
   * @private
   * @type {Date}
   */

  this._lastTouchMoment;
  /**
   * @private
   * @type {number}
   */

  this._lastX;
  /**
   * @private
   * @type {number}
   */

  this._lastY;
  Draggable.call(this);
  util.each(handlerNames, function (name) {
    proxy.on && proxy.on(name, this[name], this);
  }, this);
};

Handler.prototype = {
  constructor: Handler,
  mousemove: function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var lastHovered = this._hovered;
    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
    // See #6198.

    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
      lastHoveredTarget = lastHovered.target;
    }

    var hovered = this._hovered = this.findHover(x, y);
    var hoveredTarget = hovered.target;
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element

    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(lastHovered, 'mouseout', event);
    } // Mouse moving on one element


    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element

    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(hovered, 'mouseover', event);
    }
  },
  mouseout: function (event) {
    this.dispatchToElement(this._hovered, 'mouseout', event); // There might be some doms created by upper layer application
    // at the same level of painter.getViewportRoot() (e.g., tooltip
    // dom created by echarts), where 'globalout' event should not
    // be triggered when mouse enters these doms. (But 'mouseout'
    // should be triggered at the original hovered element as usual).

    var element = event.toElement || event.relatedTarget;
    var innerDom;

    do {
      element = element && element.parentNode;
    } while (element && element.nodeType != 9 && !(innerDom = element === this.painterRoot));

    !innerDom && this.trigger('globalout', {
      event: event
    });
  },

  /**
   * Resize
   */
  resize: function (event) {
    this._hovered = {};
  },

  /**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */
  dispatch: function (eventName, eventArgs) {
    var handler = this[eventName];
    handler && handler.call(this, eventArgs);
  },

  /**
   * Dispose
   */
  dispose: function () {
    this.proxy.dispose();
    this.storage = this.proxy = this.painter = null;
  },

  /**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(cursorStyle);
  },

  /**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */
  dispatchToElement: function (targetInfo, eventName, event) {
    targetInfo = targetInfo || {};
    var el = targetInfo.target;

    if (el && el.silent) {
      return;
    }

    var eventHandler = 'on' + eventName;
    var eventPacket = makeEventPacket(eventName, targetInfo, event);

    while (el) {
      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
      el.trigger(eventName, eventPacket);
      el = el.parent;

      if (eventPacket.cancelBubble) {
        break;
      }
    }

    if (!eventPacket.cancelBubble) {
      // 冒泡到顶级 zrender 对象
      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在

      this.painter && this.painter.eachOtherLayer(function (layer) {
        if (typeof layer[eventHandler] == 'function') {
          layer[eventHandler].call(layer, eventPacket);
        }

        if (layer.trigger) {
          layer.trigger(eventName, eventPacket);
        }
      });
    }
  },

  /**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */
  findHover: function (x, y, exclude) {
    var list = this.storage.getDisplayList();
    var out = {
      x: x,
      y: y
    };

    for (var i = list.length - 1; i >= 0; i--) {
      var hoverCheckResult;

      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
        !out.topTarget && (out.topTarget = list[i]);

        if (hoverCheckResult !== SILENT) {
          out.target = list[i];
          break;
        }
      }
    }

    return out;
  }
}; // Common handlers

util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  Handler.prototype[name] = function (event) {
    // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
    var hovered = this.findHover(event.zrX, event.zrY);
    var hoveredTarget = hovered.target;

    if (name === 'mousedown') {
      this._downEl = hoveredTarget;
      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup

      this._upEl = hoveredTarget;
    } else if (name === 'mosueup') {
      this._upEl = hoveredTarget;
    } else if (name === 'click') {
      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
      // including the case that `mousedown` - `mousemove` - `mouseup`,
      // which should be filtered, otherwise it will bring trouble to
      // pan and zoom.
      || !this._downPoint // Arbitrary value
      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
        return;
      }

      this._downPoint = null;
    }

    this.dispatchToElement(hovered, name, event);
  };
});

function isHover(displayable, x, y) {
  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
    var el = displayable;
    var isSilent;

    while (el) {
      // If clipped by ancestor.
      // FIXME: If clipPath has neither stroke nor fill,
      // el.clipPath.contain(x, y) will always return false.
      if (el.clipPath && !el.clipPath.contain(x, y)) {
        return false;
      }

      if (el.silent) {
        isSilent = true;
      }

      el = el.parent;
    }

    return isSilent ? SILENT : true;
  }

  return false;
}

util.mixin(Handler, Eventful);
util.mixin(Handler, Draggable);
var _default = Handler;
module.exports = _default;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0);

var _config = __webpack_require__(210);

var devicePixelRatio = _config.devicePixelRatio;

var Style = __webpack_require__(694);

var Pattern = __webpack_require__(693);

/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */
function returnFalse() {
  return false;
}
/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */


function createDom(id, painter, dpr) {
  var newDom = util.createCanvas();
  var width = painter.getWidth();
  var height = painter.getHeight();
  var newDomStyle = newDom.style; // 没append呢，请原谅我这样写，清晰~

  newDomStyle.position = 'absolute';
  newDomStyle.left = 0;
  newDomStyle.top = 0;
  newDomStyle.width = width + 'px';
  newDomStyle.height = height + 'px';
  newDom.width = width * dpr;
  newDom.height = height * dpr; // id不作为索引用，避免可能造成的重名，定义为私有属性

  newDom.setAttribute('data-zr-dom-id', id);
  return newDom;
}
/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */


var Layer = function (id, painter, dpr) {
  var dom;
  dpr = dpr || devicePixelRatio;

  if (typeof id === 'string') {
    dom = createDom(id, painter, dpr);
  } // Not using isDom because in node it will return false
  else if (util.isObject(id)) {
      dom = id;
      id = dom.id;
    }

  this.id = id;
  this.dom = dom;
  var domStyle = dom.style;

  if (domStyle) {
    // Not in node
    dom.onselectstart = returnFalse; // 避免页面选中的尴尬

    domStyle['-webkit-user-select'] = 'none';
    domStyle['user-select'] = 'none';
    domStyle['-webkit-touch-callout'] = 'none';
    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
    domStyle['padding'] = 0;
    domStyle['margin'] = 0;
    domStyle['border-width'] = 0;
  }

  this.domBack = null;
  this.ctxBack = null;
  this.painter = painter;
  this.config = null; // Configs

  /**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */

  this.clearColor = 0;
  /**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */

  this.motionBlur = false;
  /**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */

  this.lastFrameAlpha = 0.7;
  /**
   * Layer dpr
   * @type {number}
   */

  this.dpr = dpr;
};

Layer.prototype = {
  constructor: Layer,
  elCount: 0,
  __dirty: true,
  initContext: function () {
    this.ctx = this.dom.getContext('2d');
    this.ctx.__currentValues = {};
    this.ctx.dpr = this.dpr;
  },
  createBackBuffer: function () {
    var dpr = this.dpr;
    this.domBack = createDom('back-' + this.id, this.painter, dpr);
    this.ctxBack = this.domBack.getContext('2d');
    this.ctxBack.__currentValues = {};

    if (dpr != 1) {
      this.ctxBack.scale(dpr, dpr);
    }
  },

  /**
   * @param  {number} width
   * @param  {number} height
   */
  resize: function (width, height) {
    var dpr = this.dpr;
    var dom = this.dom;
    var domStyle = dom.style;
    var domBack = this.domBack;
    domStyle.width = width + 'px';
    domStyle.height = height + 'px';
    dom.width = width * dpr;
    dom.height = height * dpr;

    if (domBack) {
      domBack.width = width * dpr;
      domBack.height = height * dpr;

      if (dpr != 1) {
        this.ctxBack.scale(dpr, dpr);
      }
    }
  },

  /**
   * 清空该层画布
   * @param {boolean} clearAll Clear all with out motion blur
   */
  clear: function (clearAll) {
    var dom = this.dom;
    var ctx = this.ctx;
    var width = dom.width;
    var height = dom.height;
    var clearColor = this.clearColor;
    var haveMotionBLur = this.motionBlur && !clearAll;
    var lastFrameAlpha = this.lastFrameAlpha;
    var dpr = this.dpr;

    if (haveMotionBLur) {
      if (!this.domBack) {
        this.createBackBuffer();
      }

      this.ctxBack.globalCompositeOperation = 'copy';
      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
    }

    ctx.clearRect(0, 0, width, height);

    if (clearColor) {
      var clearColorGradientOrPattern; // Gradient

      if (clearColor.colorStops) {
        // Cache canvas gradient
        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
          x: 0,
          y: 0,
          width: width,
          height: height
        });
        clearColor.__canvasGradient = clearColorGradientOrPattern;
      } // Pattern
      else if (clearColor.image) {
          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
        }

      ctx.save();
      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    }

    if (haveMotionBLur) {
      var domBack = this.domBack;
      ctx.save();
      ctx.globalAlpha = lastFrameAlpha;
      ctx.drawImage(domBack, 0, 0, width, height);
      ctx.restore();
    }
  }
};
var _default = Layer;
module.exports = _default;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(210);

var devicePixelRatio = _config.devicePixelRatio;

var util = __webpack_require__(0);

var log = __webpack_require__(151);

var BoundingRect = __webpack_require__(26);

var timsort = __webpack_require__(321);

var Layer = __webpack_require__(1964);

var requestAnimationFrame = __webpack_require__(684);

var Image = __webpack_require__(152);

/**
 * Default canvas painter
 * @module zrender/Painter
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
// PENDIGN
// Layer exceeds MAX_PROGRESSIVE_LAYER_NUMBER may have some problem when flush directly second time.
//
// Maximum progressive layer. When exceeding this number. All elements will be drawed in the last layer.
var MAX_PROGRESSIVE_LAYER_NUMBER = 5;

function parseInt10(val) {
  return parseInt(val, 10);
}

function isLayerValid(layer) {
  if (!layer) {
    return false;
  }

  if (layer.__builtin__) {
    return true;
  }

  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
    return false;
  }

  return true;
}

function preProcessLayer(layer) {
  layer.__unusedCount++;
}

function postProcessLayer(layer) {
  if (layer.__unusedCount == 1) {
    layer.clear();
  }
}

var tmpRect = new BoundingRect(0, 0, 0, 0);
var viewRect = new BoundingRect(0, 0, 0, 0);

function isDisplayableCulled(el, width, height) {
  tmpRect.copy(el.getBoundingRect());

  if (el.transform) {
    tmpRect.applyTransform(el.transform);
  }

  viewRect.width = width;
  viewRect.height = height;
  return !tmpRect.intersect(viewRect);
}

function isClipPathChanged(clipPaths, prevClipPaths) {
  if (clipPaths == prevClipPaths) {
    // Can both be null or undefined
    return false;
  }

  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
    return true;
  }

  for (var i = 0; i < clipPaths.length; i++) {
    if (clipPaths[i] !== prevClipPaths[i]) {
      return true;
    }
  }
}

function doClip(clipPaths, ctx) {
  for (var i = 0; i < clipPaths.length; i++) {
    var clipPath = clipPaths[i];
    clipPath.setTransform(ctx);
    ctx.beginPath();
    clipPath.buildPath(ctx, clipPath.shape);
    ctx.clip(); // Transform back

    clipPath.restoreTransform(ctx);
  }
}

function createRoot(width, height) {
  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // 避免页面选中的尴尬

  domRoot.style.cssText = ['position:relative', 'overflow:hidden', 'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
  return domRoot;
}
/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var Painter = function (root, storage, opts) {
  this.type = 'canvas'; // In node environment using node-canvas

  var singleCanvas = !root.nodeName // In node ?
  || root.nodeName.toUpperCase() === 'CANVAS';
  this._opts = opts = util.extend({}, opts || {});
  /**
   * @type {number}
   */

  this.dpr = opts.devicePixelRatio || devicePixelRatio;
  /**
   * @type {boolean}
   * @private
   */

  this._singleCanvas = singleCanvas;
  /**
   * 绘图容器
   * @type {HTMLElement}
   */

  this.root = root;
  var rootStyle = root.style;

  if (rootStyle) {
    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
    root.innerHTML = '';
  }
  /**
   * @type {module:zrender/Storage}
   */


  this.storage = storage;
  /**
   * @type {Array.<number>}
   * @private
   */

  var zlevelList = this._zlevelList = [];
  /**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */

  var layers = this._layers = {};
  /**
   * @type {Object.<string, Object>}
   * @type {private}
   */

  this._layerConfig = {};

  if (!singleCanvas) {
    this._width = this._getSize(0);
    this._height = this._getSize(1);
    var domRoot = this._domRoot = createRoot(this._width, this._height);
    root.appendChild(domRoot);
  } else {
    if (opts.width != null) {
      root.width = opts.width;
    }

    if (opts.height != null) {
      root.height = opts.height;
    } // Use canvas width and height directly


    var width = root.width;
    var height = root.height;
    this._width = width;
    this._height = height; // Create layer if only one given canvas
    // Device pixel ratio is fixed to 1 because given canvas has its specified width and height

    var mainLayer = new Layer(root, this, 1);
    mainLayer.initContext(); // FIXME Use canvas width and height
    // mainLayer.resize(width, height);

    layers[0] = mainLayer;
    zlevelList.push(0);
    this._domRoot = root;
  } // Layers for progressive rendering


  this._progressiveLayers = [];
  /**
   * @type {module:zrender/Layer}
   * @private
   */

  this._hoverlayer;
  this._hoverElements = [];
};

Painter.prototype = {
  constructor: Painter,
  getType: function () {
    return 'canvas';
  },

  /**
   * If painter use a single canvas
   * @return {boolean}
   */
  isSingleCanvas: function () {
    return this._singleCanvas;
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._domRoot;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */
  refresh: function (paintAll) {
    var list = this.storage.getDisplayList(true);
    var zlevelList = this._zlevelList;

    this._paintList(list, paintAll); // Paint custum layers


    for (var i = 0; i < zlevelList.length; i++) {
      var z = zlevelList[i];
      var layer = this._layers[z];

      if (!layer.__builtin__ && layer.refresh) {
        layer.refresh();
      }
    }

    this.refreshHover();

    if (this._progressiveLayers.length) {
      this._startProgessive();
    }

    return this;
  },
  addHover: function (el, hoverStyle) {
    if (el.__hoverMir) {
      return;
    }

    var elMirror = new el.constructor({
      style: el.style,
      shape: el.shape
    });
    elMirror.__from = el;
    el.__hoverMir = elMirror;
    elMirror.setStyle(hoverStyle);

    this._hoverElements.push(elMirror);
  },
  removeHover: function (el) {
    var elMirror = el.__hoverMir;
    var hoverElements = this._hoverElements;
    var idx = util.indexOf(hoverElements, elMirror);

    if (idx >= 0) {
      hoverElements.splice(idx, 1);
    }

    el.__hoverMir = null;
  },
  clearHover: function (el) {
    var hoverElements = this._hoverElements;

    for (var i = 0; i < hoverElements.length; i++) {
      var from = hoverElements[i].__from;

      if (from) {
        from.__hoverMir = null;
      }
    }

    hoverElements.length = 0;
  },
  refreshHover: function () {
    var hoverElements = this._hoverElements;
    var len = hoverElements.length;
    var hoverLayer = this._hoverlayer;
    hoverLayer && hoverLayer.clear();

    if (!len) {
      return;
    }

    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
    // FIXME?

    if (!hoverLayer) {
      hoverLayer = this._hoverlayer = this.getLayer(1e5);
    }

    var scope = {};
    hoverLayer.ctx.save();

    for (var i = 0; i < len;) {
      var el = hoverElements[i];
      var originalEl = el.__from; // Original el is removed
      // PENDING

      if (!(originalEl && originalEl.__zr)) {
        hoverElements.splice(i, 1);
        originalEl.__hoverMir = null;
        len--;
        continue;
      }

      i++; // Use transform
      // FIXME style and shape ?

      if (!originalEl.invisible) {
        el.transform = originalEl.transform;
        el.invTransform = originalEl.invTransform;
        el.__clipPaths = originalEl.__clipPaths; // el.

        this._doPaintEl(el, hoverLayer, true, scope);
      }
    }

    hoverLayer.ctx.restore();
  },
  _startProgessive: function () {
    var self = this;

    if (!self._furtherProgressive) {
      return;
    } // Use a token to stop progress steps triggered by
    // previous zr.refresh calling.


    var token = self._progressiveToken = +new Date();
    self._progress++;
    requestAnimationFrame(step);

    function step() {
      // In case refreshed or disposed
      if (token === self._progressiveToken && self.storage) {
        self._doPaintList(self.storage.getDisplayList());

        if (self._furtherProgressive) {
          self._progress++;
          requestAnimationFrame(step);
        } else {
          self._progressiveToken = -1;
        }
      }
    }
  },
  _clearProgressive: function () {
    this._progressiveToken = -1;
    this._progress = 0;
    util.each(this._progressiveLayers, function (layer) {
      layer.__dirty && layer.clear();
    });
  },
  _paintList: function (list, paintAll) {
    if (paintAll == null) {
      paintAll = false;
    }

    this._updateLayerStatus(list);

    this._clearProgressive();

    this.eachBuiltinLayer(preProcessLayer);

    this._doPaintList(list, paintAll);

    this.eachBuiltinLayer(postProcessLayer);
  },
  _doPaintList: function (list, paintAll) {
    var currentLayer;
    var currentZLevel;
    var ctx; // var invTransform = [];

    var scope;
    var progressiveLayerIdx = 0;
    var currentProgressiveLayer;
    var width = this._width;
    var height = this._height;
    var layerProgress;
    var frame = this._progress;

    function flushProgressiveLayer(layer) {
      var dpr = ctx.dpr || 1;
      ctx.save();
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0; // Avoid layer don't clear in next progressive frame

      currentLayer.__dirty = true;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(layer.dom, 0, 0, width * dpr, height * dpr);
      ctx.restore();
    }

    for (var i = 0, l = list.length; i < l; i++) {
      var el = list[i];
      var elZLevel = this._singleCanvas ? 0 : el.zlevel;
      var elFrame = el.__frame; // Flush at current context
      // PENDING

      if (elFrame < 0 && currentProgressiveLayer) {
        flushProgressiveLayer(currentProgressiveLayer);
        currentProgressiveLayer = null;
      } // Change draw layer


      if (currentZLevel !== elZLevel) {
        if (ctx) {
          ctx.restore();
        } // Reset scope


        scope = {}; // Only 0 zlevel if only has one canvas

        currentZLevel = elZLevel;
        currentLayer = this.getLayer(currentZLevel);

        if (!currentLayer.__builtin__) {
          log('ZLevel ' + currentZLevel + ' has been used by unkown layer ' + currentLayer.id);
        }

        ctx = currentLayer.ctx;
        ctx.save(); // Reset the count

        currentLayer.__unusedCount = 0;

        if (currentLayer.__dirty || paintAll) {
          currentLayer.clear();
        }
      }

      if (!(currentLayer.__dirty || paintAll)) {
        continue;
      }

      if (elFrame >= 0) {
        // Progressive layer changed
        if (!currentProgressiveLayer) {
          currentProgressiveLayer = this._progressiveLayers[Math.min(progressiveLayerIdx++, MAX_PROGRESSIVE_LAYER_NUMBER - 1)];
          currentProgressiveLayer.ctx.save();
          currentProgressiveLayer.renderScope = {};

          if (currentProgressiveLayer && currentProgressiveLayer.__progress > currentProgressiveLayer.__maxProgress) {
            // flushProgressiveLayer(currentProgressiveLayer);
            // Quick jump all progressive elements
            // All progressive element are not dirty, jump over and flush directly
            i = currentProgressiveLayer.__nextIdxNotProg - 1; // currentProgressiveLayer = null;

            continue;
          }

          layerProgress = currentProgressiveLayer.__progress;

          if (!currentProgressiveLayer.__dirty) {
            // Keep rendering
            frame = layerProgress;
          }

          currentProgressiveLayer.__progress = frame + 1;
        }

        if (elFrame === frame) {
          this._doPaintEl(el, currentProgressiveLayer, true, currentProgressiveLayer.renderScope);
        }
      } else {
        this._doPaintEl(el, currentLayer, paintAll, scope);
      }

      el.__dirty = false;
    }

    if (currentProgressiveLayer) {
      flushProgressiveLayer(currentProgressiveLayer);
    } // Restore the lastLayer ctx


    ctx && ctx.restore(); // If still has clipping state
    // if (scope.prevElClipPaths) {
    //     ctx.restore();
    // }

    this._furtherProgressive = false;
    util.each(this._progressiveLayers, function (layer) {
      if (layer.__maxProgress >= layer.__progress) {
        this._furtherProgressive = true;
      }
    }, this);
  },
  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
    var ctx = currentLayer.ctx;
    var m = el.transform;

    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
    !el.invisible // Ignore transparent element
    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
    // Draw a scale 0 element can cause all following draw wrong
    // And setTransform with scale 0 will cause set back transform failed.
    && !(m && !m[0] && !m[3]) // Ignore culled element
    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
      var clipPaths = el.__clipPaths; // Optimize when clipping on group with several elements

      if (scope.prevClipLayer !== currentLayer || isClipPathChanged(clipPaths, scope.prevElClipPaths)) {
        // If has previous clipping state, restore from it
        if (scope.prevElClipPaths) {
          scope.prevClipLayer.ctx.restore();
          scope.prevClipLayer = scope.prevElClipPaths = null; // Reset prevEl since context has been restored

          scope.prevEl = null;
        } // New clipping state


        if (clipPaths) {
          ctx.save();
          doClip(clipPaths, ctx);
          scope.prevClipLayer = currentLayer;
          scope.prevElClipPaths = clipPaths;
        }
      }

      el.beforeBrush && el.beforeBrush(ctx);
      el.brush(ctx, scope.prevEl || null);
      scope.prevEl = el;
      el.afterBrush && el.afterBrush(ctx);
    }
  },

  /**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @return {module:zrender/Layer}
   */
  getLayer: function (zlevel) {
    if (this._singleCanvas) {
      return this._layers[0];
    }

    var layer = this._layers[zlevel];

    if (!layer) {
      // Create a new layer
      layer = new Layer('zr_' + zlevel, this, this.dpr);
      layer.__builtin__ = true;

      if (this._layerConfig[zlevel]) {
        util.merge(layer, this._layerConfig[zlevel], true);
      }

      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
      // Or excanvas will get 0px clientWidth and clientHeight

      layer.initContext();
    }

    return layer;
  },
  insertLayer: function (zlevel, layer) {
    var layersMap = this._layers;
    var zlevelList = this._zlevelList;
    var len = zlevelList.length;
    var prevLayer = null;
    var i = -1;
    var domRoot = this._domRoot;

    if (layersMap[zlevel]) {
      log('ZLevel ' + zlevel + ' has been used already');
      return;
    } // Check if is a valid layer


    if (!isLayerValid(layer)) {
      log('Layer of zlevel ' + zlevel + ' is not valid');
      return;
    }

    if (len > 0 && zlevel > zlevelList[0]) {
      for (i = 0; i < len - 1; i++) {
        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
          break;
        }
      }

      prevLayer = layersMap[zlevelList[i]];
    }

    zlevelList.splice(i + 1, 0, zlevel);
    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
    // (It can be a WebGL layer and assigned to a ZImage element)
    // But it still under management of zrender.

    if (!layer.virtual) {
      if (prevLayer) {
        var prevDom = prevLayer.dom;

        if (prevDom.nextSibling) {
          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
        } else {
          domRoot.appendChild(layer.dom);
        }
      } else {
        if (domRoot.firstChild) {
          domRoot.insertBefore(layer.dom, domRoot.firstChild);
        } else {
          domRoot.appendChild(layer.dom);
        }
      }
    }
  },
  // Iterate each layer
  eachLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      cb.call(context, this._layers[z], z);
    }
  },
  // Iterate each buildin layer
  eachBuiltinLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },
  // Iterate each other layer except buildin layer
  eachOtherLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (!layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },

  /**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */
  getLayers: function () {
    return this._layers;
  },
  _updateLayerStatus: function (list) {
    var layers = this._layers;
    var progressiveLayers = this._progressiveLayers;
    var elCountsLastFrame = {};
    var progressiveElCountsLastFrame = {};
    this.eachBuiltinLayer(function (layer, z) {
      elCountsLastFrame[z] = layer.elCount;
      layer.elCount = 0;
      layer.__dirty = false;
    });
    util.each(progressiveLayers, function (layer, idx) {
      progressiveElCountsLastFrame[idx] = layer.elCount;
      layer.elCount = 0;
      layer.__dirty = false;
    });
    var progressiveLayerCount = 0;
    var currentProgressiveLayer;
    var lastProgressiveKey;
    var frameCount = 0;

    for (var i = 0, l = list.length; i < l; i++) {
      var el = list[i];
      var zlevel = this._singleCanvas ? 0 : el.zlevel;
      var layer = layers[zlevel];
      var elProgress = el.progressive;

      if (layer) {
        layer.elCount++;
        layer.__dirty = layer.__dirty || el.__dirty;
      } /////// Update progressive


      if (elProgress >= 0) {
        // Fix wrong progressive sequence problem.
        if (lastProgressiveKey !== elProgress) {
          lastProgressiveKey = elProgress;
          frameCount++;
        }

        var elFrame = el.__frame = frameCount - 1;

        if (!currentProgressiveLayer) {
          var idx = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER - 1);
          currentProgressiveLayer = progressiveLayers[idx];

          if (!currentProgressiveLayer) {
            currentProgressiveLayer = progressiveLayers[idx] = new Layer('progressive', this, this.dpr);
            currentProgressiveLayer.initContext();
          }

          currentProgressiveLayer.__maxProgress = 0;
        }

        currentProgressiveLayer.__dirty = currentProgressiveLayer.__dirty || el.__dirty;
        currentProgressiveLayer.elCount++;
        currentProgressiveLayer.__maxProgress = Math.max(currentProgressiveLayer.__maxProgress, elFrame);

        if (currentProgressiveLayer.__maxProgress >= currentProgressiveLayer.__progress) {
          // Should keep rendering this  layer because progressive rendering is not finished yet
          layer.__dirty = true;
        }
      } else {
        el.__frame = -1;

        if (currentProgressiveLayer) {
          currentProgressiveLayer.__nextIdxNotProg = i;
          progressiveLayerCount++;
          currentProgressiveLayer = null;
        }
      }
    }

    if (currentProgressiveLayer) {
      progressiveLayerCount++;
      currentProgressiveLayer.__nextIdxNotProg = i;
    } // 层中的元素数量有发生变化


    this.eachBuiltinLayer(function (layer, z) {
      if (elCountsLastFrame[z] !== layer.elCount) {
        layer.__dirty = true;
      }
    });
    progressiveLayers.length = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER);
    util.each(progressiveLayers, function (layer, idx) {
      if (progressiveElCountsLastFrame[idx] !== layer.elCount) {
        el.__dirty = true;
      }

      if (layer.__dirty) {
        layer.__progress = 0;
      }
    });
  },

  /**
   * 清除hover层外所有内容
   */
  clear: function () {
    this.eachBuiltinLayer(this._clearLayer);
    return this;
  },
  _clearLayer: function (layer) {
    layer.clear();
  },

  /**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */
  configLayer: function (zlevel, config) {
    if (config) {
      var layerConfig = this._layerConfig;

      if (!layerConfig[zlevel]) {
        layerConfig[zlevel] = config;
      } else {
        util.merge(layerConfig[zlevel], config, true);
      }

      var layer = this._layers[zlevel];

      if (layer) {
        util.merge(layer, layerConfig[zlevel], true);
      }
    }
  },

  /**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */
  delLayer: function (zlevel) {
    var layers = this._layers;
    var zlevelList = this._zlevelList;
    var layer = layers[zlevel];

    if (!layer) {
      return;
    }

    layer.dom.parentNode.removeChild(layer.dom);
    delete layers[zlevel];
    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
  },

  /**
   * 区域大小变化后重绘
   */
  resize: function (width, height) {
    var domRoot = this._domRoot; // FIXME Why ?

    domRoot.style.display = 'none'; // Save input w/h

    var opts = this._opts;
    width != null && (opts.width = width);
    height != null && (opts.height = height);
    width = this._getSize(0);
    height = this._getSize(1);
    domRoot.style.display = ''; // 优化没有实际改变的resize

    if (this._width != width || height != this._height) {
      domRoot.style.width = width + 'px';
      domRoot.style.height = height + 'px';

      for (var id in this._layers) {
        if (this._layers.hasOwnProperty(id)) {
          this._layers[id].resize(width, height);
        }
      }

      util.each(this._progressiveLayers, function (layer) {
        layer.resize(width, height);
      });
      this.refresh(true);
    }

    this._width = width;
    this._height = height;
    return this;
  },

  /**
   * 清除单独的一个层
   * @param {number} zlevel
   */
  clearLayer: function (zlevel) {
    var layer = this._layers[zlevel];

    if (layer) {
      layer.clear();
    }
  },

  /**
   * 释放
   */
  dispose: function () {
    this.root.innerHTML = '';
    this.root = this.storage = this._domRoot = this._layers = null;
  },

  /**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */
  getRenderedCanvas: function (opts) {
    opts = opts || {};

    if (this._singleCanvas) {
      return this._layers[0].dom;
    }

    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
    imageLayer.initContext();
    imageLayer.clearColor = opts.backgroundColor;
    imageLayer.clear();
    var displayList = this.storage.getDisplayList(true);
    var scope = {};
    var zlevel;
    var self = this;

    function findAndDrawOtherLayer(smaller, larger) {
      var zlevelList = self._zlevelList;

      if (smaller == null) {
        smaller = -Infinity;
      }

      var intermediateLayer;

      for (var i = 0; i < zlevelList.length; i++) {
        var z = zlevelList[i];
        var layer = self._layers[z];

        if (!layer.__builtin__ && z > smaller && z < larger) {
          intermediateLayer = layer;
          break;
        }
      }

      if (intermediateLayer && intermediateLayer.renderToCanvas) {
        imageLayer.ctx.save();
        intermediateLayer.renderToCanvas(imageLayer.ctx);
        imageLayer.ctx.restore();
      }
    }

    for (var i = 0; i < displayList.length; i++) {
      var el = displayList[i];

      if (el.zlevel !== zlevel) {
        findAndDrawOtherLayer(zlevel, el.zlevel);
        zlevel = el.zlevel;
      }

      this._doPaintEl(el, imageLayer, true, scope);
    }

    findAndDrawOtherLayer(zlevel, Infinity);
    return imageLayer.dom;
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  pathToImage: function (path, dpr) {
    dpr = dpr || this.dpr;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var rect = path.getBoundingRect();
    var style = path.style;
    var shadowBlurSize = style.shadowBlur;
    var shadowOffsetX = style.shadowOffsetX;
    var shadowOffsetY = style.shadowOffsetY;
    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
    var width = rect.width + leftMargin + rightMargin;
    var height = rect.height + topMargin + bottomMargin;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);
    ctx.dpr = dpr;
    var pathTransform = {
      position: path.position,
      rotation: path.rotation,
      scale: path.scale
    };
    path.position = [leftMargin - rect.x, topMargin - rect.y];
    path.rotation = 0;
    path.scale = [1, 1];
    path.updateTransform();

    if (path) {
      path.brush(ctx);
    }

    var ImageShape = Image;
    var imgShape = new ImageShape({
      style: {
        x: 0,
        y: 0,
        image: canvas
      }
    });

    if (pathTransform.position != null) {
      imgShape.position = path.position = pathTransform.position;
    }

    if (pathTransform.rotation != null) {
      imgShape.rotation = path.rotation = pathTransform.rotation;
    }

    if (pathTransform.scale != null) {
      imgShape.scale = path.scale = pathTransform.scale;
    }

    return imgShape;
  }
};
var _default = Painter;
module.exports = _default;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0);

var env = __webpack_require__(33);

var Group = __webpack_require__(211);

var timsort = __webpack_require__(321);

/**
 * Storage内容仓库模块
 * @module zrender/Storage
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 * @author errorrik (errorrik@gmail.com)
 * @author pissang (https://github.com/pissang/)
 */
// Use timsort because in most case elements are partially sorted
// https://jsfiddle.net/pissang/jr4x7mdm/8/
function shapeCompareFunc(a, b) {
  if (a.zlevel === b.zlevel) {
    if (a.z === b.z) {
      // if (a.z2 === b.z2) {
      //     // FIXME Slow has renderidx compare
      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
      //     return a.__renderidx - b.__renderidx;
      // }
      return a.z2 - b.z2;
    }

    return a.z - b.z;
  }

  return a.zlevel - b.zlevel;
}
/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */


var Storage = function () {
  // jshint ignore:line
  this._roots = [];
  this._displayList = [];
  this._displayListLen = 0;
};

Storage.prototype = {
  constructor: Storage,

  /**
   * @param  {Function} cb
   *
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._roots.length; i++) {
      this._roots[i].traverse(cb, context);
    }
  },

  /**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */
  getDisplayList: function (update, includeIgnore) {
    includeIgnore = includeIgnore || false;

    if (update) {
      this.updateDisplayList(includeIgnore);
    }

    return this._displayList;
  },

  /**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */
  updateDisplayList: function (includeIgnore) {
    this._displayListLen = 0;
    var roots = this._roots;
    var displayList = this._displayList;

    for (var i = 0, len = roots.length; i < len; i++) {
      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
    }

    displayList.length = this._displayListLen; // for (var i = 0, len = displayList.length; i < len; i++) {
    //     displayList[i].__renderidx = i;
    // }
    // displayList.sort(shapeCompareFunc);

    env.canvasSupported && timsort(displayList, shapeCompareFunc);
  },
  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
    if (el.ignore && !includeIgnore) {
      return;
    }

    el.beforeUpdate();

    if (el.__dirty) {
      el.update();
    }

    el.afterUpdate();
    var userSetClipPath = el.clipPath;

    if (userSetClipPath) {
      // FIXME 效率影响
      if (clipPaths) {
        clipPaths = clipPaths.slice();
      } else {
        clipPaths = [];
      }

      var currentClipPath = userSetClipPath;
      var parentClipPath = el; // Recursively add clip path

      while (currentClipPath) {
        // clipPath 的变换是基于使用这个 clipPath 的元素
        currentClipPath.parent = parentClipPath;
        currentClipPath.updateTransform();
        clipPaths.push(currentClipPath);
        parentClipPath = currentClipPath;
        currentClipPath = currentClipPath.clipPath;
      }
    }

    if (el.isGroup) {
      var children = el._children;

      for (var i = 0; i < children.length; i++) {
        var child = children[i]; // Force to mark as dirty if group is dirty
        // FIXME __dirtyPath ?

        if (el.__dirty) {
          child.__dirty = true;
        }

        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
      } // Mark group clean here


      el.__dirty = false;
    } else {
      el.__clipPaths = clipPaths;
      this._displayList[this._displayListLen++] = el;
    }
  },

  /**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */
  addRoot: function (el) {
    if (el.__storage === this) {
      return;
    }

    if (el instanceof Group) {
      el.addChildrenToStorage(this);
    }

    this.addToStorage(el);

    this._roots.push(el);
  },

  /**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */
  delRoot: function (el) {
    if (el == null) {
      // 不指定el清空
      for (var i = 0; i < this._roots.length; i++) {
        var root = this._roots[i];

        if (root instanceof Group) {
          root.delChildrenFromStorage(this);
        }
      }

      this._roots = [];
      this._displayList = [];
      this._displayListLen = 0;
      return;
    }

    if (el instanceof Array) {
      for (var i = 0, l = el.length; i < l; i++) {
        this.delRoot(el[i]);
      }

      return;
    }

    var idx = util.indexOf(this._roots, el);

    if (idx >= 0) {
      this.delFromStorage(el);

      this._roots.splice(idx, 1);

      if (el instanceof Group) {
        el.delChildrenFromStorage(this);
      }
    }
  },
  addToStorage: function (el) {
    el.__storage = this;
    el.dirty(false);
    return this;
  },
  delFromStorage: function (el) {
    if (el) {
      el.__storage = null;
    }

    return this;
  },

  /**
   * 清空并且释放Storage
   */
  dispose: function () {
    this._renderList = this._roots = null;
  },
  displayableSortFunc: shapeCompareFunc
};
var _default = Storage;
module.exports = _default;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0);

var _event = __webpack_require__(77);

var Dispatcher = _event.Dispatcher;

var requestAnimationFrame = __webpack_require__(684);

var Animator = __webpack_require__(683);

/**
 * 动画主类, 调度和管理所有动画控制器
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */
// TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236

/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 */

/**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */
var Animation = function (options) {
  options = options || {};
  this.stage = options.stage || {};

  this.onframe = options.onframe || function () {}; // private properties


  this._clips = [];
  this._running = false;
  this._time;
  this._pausedTime;
  this._pauseStart;
  this._paused = false;
  Dispatcher.call(this);
};

Animation.prototype = {
  constructor: Animation,

  /**
   * 添加 clip
   * @param {module:zrender/animation/Clip} clip
   */
  addClip: function (clip) {
    this._clips.push(clip);
  },

  /**
   * 添加 animator
   * @param {module:zrender/animation/Animator} animator
   */
  addAnimator: function (animator) {
    animator.animation = this;
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.addClip(clips[i]);
    }
  },

  /**
   * 删除动画片段
   * @param {module:zrender/animation/Clip} clip
   */
  removeClip: function (clip) {
    var idx = util.indexOf(this._clips, clip);

    if (idx >= 0) {
      this._clips.splice(idx, 1);
    }
  },

  /**
   * 删除动画片段
   * @param {module:zrender/animation/Animator} animator
   */
  removeAnimator: function (animator) {
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.removeClip(clips[i]);
    }

    animator.animation = null;
  },
  _update: function () {
    var time = new Date().getTime() - this._pausedTime;

    var delta = time - this._time;
    var clips = this._clips;
    var len = clips.length;
    var deferredEvents = [];
    var deferredClips = [];

    for (var i = 0; i < len; i++) {
      var clip = clips[i];
      var e = clip.step(time, delta); // Throw out the events need to be called after
      // stage.update, like destroy

      if (e) {
        deferredEvents.push(e);
        deferredClips.push(clip);
      }
    } // Remove the finished clip


    for (var i = 0; i < len;) {
      if (clips[i]._needsRemove) {
        clips[i] = clips[len - 1];
        clips.pop();
        len--;
      } else {
        i++;
      }
    }

    len = deferredEvents.length;

    for (var i = 0; i < len; i++) {
      deferredClips[i].fire(deferredEvents[i]);
    }

    this._time = time;
    this.onframe(delta);
    this.trigger('frame', delta);

    if (this.stage.update) {
      this.stage.update();
    }
  },
  _startLoop: function () {
    var self = this;
    this._running = true;

    function step() {
      if (self._running) {
        requestAnimationFrame(step);
        !self._paused && self._update();
      }
    }

    requestAnimationFrame(step);
  },

  /**
   * 开始运行动画
   */
  start: function () {
    this._time = new Date().getTime();
    this._pausedTime = 0;

    this._startLoop();
  },

  /**
   * 停止运行动画
   */
  stop: function () {
    this._running = false;
  },

  /**
   * Pause
   */
  pause: function () {
    if (!this._paused) {
      this._pauseStart = new Date().getTime();
      this._paused = true;
    }
  },

  /**
   * Resume
   */
  resume: function () {
    if (this._paused) {
      this._pausedTime += new Date().getTime() - this._pauseStart;
      this._paused = false;
    }
  },

  /**
   * 清除所有动画片段
   */
  clear: function () {
    this._clips = [];
  },

  /**
   * 对一个目标创建一个animator对象，可以指定目标中的属性使用动画
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] 是否循环播放动画
   * @param  {Function} [options.getter=null]
   *         如果指定getter函数，会通过getter函数取属性值
   * @param  {Function} [options.setter=null]
   *         如果指定setter函数，会通过setter函数设置属性值
   * @return {module:zrender/animation/Animation~Animator}
   */
  // TODO Gap
  animate: function (target, options) {
    options = options || {};
    var animator = new Animator(target, options.loop, options.getter, options.setter);
    this.addAnimator(animator);
    return animator;
  }
};
util.mixin(Animation, Dispatcher);
var _default = Animation;
module.exports = _default;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

var easingFuncs = __webpack_require__(1969);

/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */
function Clip(options) {
  this._target = options.target; // 生命周期

  this._life = options.life || 1000; // 延时

  this._delay = options.delay || 0; // 开始时间
  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒

  this._initialized = false; // 是否循环

  this.loop = options.loop == null ? false : options.loop;
  this.gap = options.gap || 0;
  this.easing = options.easing || 'Linear';
  this.onframe = options.onframe;
  this.ondestroy = options.ondestroy;
  this.onrestart = options.onrestart;
  this._pausedTime = 0;
  this._paused = false;
}

Clip.prototype = {
  constructor: Clip,
  step: function (globalTime, deltaTime) {
    // Set startTime on first step, or _startTime may has milleseconds different between clips
    // PENDING
    if (!this._initialized) {
      this._startTime = globalTime + this._delay;
      this._initialized = true;
    }

    if (this._paused) {
      this._pausedTime += deltaTime;
      return;
    }

    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始

    if (percent < 0) {
      return;
    }

    percent = Math.min(percent, 1);
    var easing = this.easing;
    var easingFunc = typeof easing == 'string' ? easingFuncs[easing] : easing;
    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
    this.fire('frame', schedule); // 结束

    if (percent == 1) {
      if (this.loop) {
        this.restart(globalTime); // 重新开始周期
        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件

        return 'restart';
      } // 动画完成将这个控制器标识为待删除
      // 在Animation.update中进行批量删除


      this._needsRemove = true;
      return 'destroy';
    }

    return null;
  },
  restart: function (globalTime) {
    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
    this._startTime = globalTime - remainder + this.gap;
    this._pausedTime = 0;
    this._needsRemove = false;
  },
  fire: function (eventType, arg) {
    eventType = 'on' + eventType;

    if (this[eventType]) {
      this[eventType](this._target, arg);
    }
  },
  pause: function () {
    this._paused = true;
  },
  resume: function () {
    this._paused = false;
  }
};
var _default = Clip;
module.exports = _default;

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */
var easing = {
  /**
  * @param {number} k
  * @return {number}
  */
  linear: function (k) {
    return k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticIn: function (k) {
    return k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticOut: function (k) {
    return k * (2 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  },
  // 三次方的缓动（t^3）

  /**
  * @param {number} k
  * @return {number}
  */
  cubicIn: function (k) {
    return k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicOut: function (k) {
    return --k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k + 2);
  },
  // 四次方的缓动（t^4）

  /**
  * @param {number} k
  * @return {number}
  */
  quarticIn: function (k) {
    return k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticOut: function (k) {
    return 1 - --k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k;
    }

    return -0.5 * ((k -= 2) * k * k * k - 2);
  },
  // 五次方的缓动（t^5）

  /**
  * @param {number} k
  * @return {number}
  */
  quinticIn: function (k) {
    return k * k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticOut: function (k) {
    return --k * k * k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },
  // 正弦曲线的缓动（sin(t)）

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalIn: function (k) {
    return 1 - Math.cos(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalOut: function (k) {
    return Math.sin(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalInOut: function (k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  },
  // 指数曲线的缓动（2^t）

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialIn: function (k) {
    return k === 0 ? 0 : Math.pow(1024, k - 1);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialOut: function (k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialInOut: function (k) {
    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }

    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },
  // 圆形曲线的缓动（sqrt(1-t^2)）

  /**
  * @param {number} k
  * @return {number}
  */
  circularIn: function (k) {
    return 1 - Math.sqrt(1 - k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularOut: function (k) {
    return Math.sqrt(1 - --k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularInOut: function (k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }

    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },
  // 创建类似于弹簧在停止前来回振荡的动画

  /**
  * @param {number} k
  * @return {number}
  */
  elasticIn: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticInOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    if ((k *= 2) < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    }

    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
  },
  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动

  /**
  * @param {number} k
  * @return {number}
  */
  backIn: function (k) {
    var s = 1.70158;
    return k * k * ((s + 1) * k - s);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backOut: function (k) {
    var s = 1.70158;
    return --k * k * ((s + 1) * k + s) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backInOut: function (k) {
    var s = 1.70158 * 1.525;

    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }

    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },
  // 创建弹跳效果

  /**
  * @param {number} k
  * @return {number}
  */
  bounceIn: function (k) {
    return 1 - easing.bounceOut(1 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceOut: function (k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    }
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceInOut: function (k) {
    if (k < 0.5) {
      return easing.bounceIn(k * 2) * 0.5;
    }

    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};
var _default = easing;
module.exports = _default;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(688);

var normalizeRadian = _util.normalizeRadian;
var PI2 = Math.PI * 2;
/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */

function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);

  if (d - _l > r || d + _l < r) {
    return false;
  }

  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
    // Is a circle
    return true;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2;
  }

  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
}

exports.containStroke = containStroke;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(88);

/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
    return false;
  }

  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(125);

var line = __webpack_require__(685);

var cubic = __webpack_require__(1971);

var quadratic = __webpack_require__(687);

var arc = __webpack_require__(1970);

var _util = __webpack_require__(688);

var normalizeRadian = _util.normalizeRadian;

var curve = __webpack_require__(88);

var windingLine = __webpack_require__(689);

var CMD = PathProxy.CMD;
var PI2 = Math.PI * 2;
var EPSILON = 1e-4;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
} // 临时数组


var roots = [-1, -1, -1];
var extrema = [-1, -1];

function swapExtrema() {
  var tmp = extrema[0];
  extrema[0] = extrema[1];
  extrema[1] = tmp;
}

function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
    return 0;
  }

  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var w = 0;
    var nExtrema = -1;
    var y0_, y1_;

    for (var i = 0; i < nRoots; i++) {
      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon

      var unit = t === 0 || t === 1 ? 0.5 : 1;
      var x_ = curve.cubicAt(x0, x1, x2, x3, t);

      if (x_ < x) {
        // Quick reject
        continue;
      }

      if (nExtrema < 0) {
        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);

        if (extrema[1] < extrema[0] && nExtrema > 1) {
          swapExtrema();
        }

        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);

        if (nExtrema > 1) {
          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
        }
      }

      if (nExtrema == 2) {
        // 分成三段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else if (t < extrema[1]) {
          w += y1_ < y0_ ? unit : -unit;
        } else {
          w += y3 < y1_ ? unit : -unit;
        }
      } else {
        // 分成两段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else {
          w += y3 < y0_ ? unit : -unit;
        }
      }
    }

    return w;
  }
}

function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
    return 0;
  }

  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var t = curve.quadraticExtremum(y0, y1, y2);

    if (t >= 0 && t <= 1) {
      var w = 0;
      var y_ = curve.quadraticAt(y0, y1, y2, t);

      for (var i = 0; i < nRoots; i++) {
        // Remove one endpoint.
        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);

        if (x_ < x) {
          // Quick reject
          continue;
        }

        if (roots[i] < t) {
          w += y_ < y0 ? unit : -unit;
        } else {
          w += y2 < y_ ? unit : -unit;
        }
      }

      return w;
    } else {
      // Remove one endpoint.
      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);

      if (x_ < x) {
        // Quick reject
        return 0;
      }

      return y2 < y0 ? unit : -unit;
    }
  }
} // TODO
// Arc 旋转


function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
  y -= cy;

  if (y > r || y < -r) {
    return 0;
  }

  var tmp = Math.sqrt(r * r - y * y);
  roots[0] = -tmp;
  roots[1] = tmp;
  var diff = Math.abs(startAngle - endAngle);

  if (diff < 1e-4) {
    return 0;
  }

  if (diff % PI2 < 1e-4) {
    // Is a circle
    startAngle = 0;
    endAngle = PI2;
    var dir = anticlockwise ? 1 : -1;

    if (x >= roots[0] + cx && x <= roots[1] + cx) {
      return dir;
    } else {
      return 0;
    }
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var w = 0;

  for (var i = 0; i < 2; i++) {
    var x_ = roots[i];

    if (x_ + cx > x) {
      var angle = Math.atan2(y, x_);
      var dir = anticlockwise ? 1 : -1;

      if (angle < 0) {
        angle = PI2 + angle;
      }

      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
          dir = -dir;
        }

        w += dir;
      }
    }
  }

  return w;
}

function containPath(data, lineWidth, isStroke, x, y) {
  var w = 0;
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++]; // Begin a new subpath

    if (cmd === CMD.M && i > 1) {
      // Close previous subpath
      if (!isStroke) {
        w += windingLine(xi, yi, x0, y0, x, y);
      } // 如果被任何一个 subpath 包含
      // if (w !== 0) {
      //     return true;
      // }

    }

    if (i == 1) {
      // 如果第一个命令是 L, C, Q
      // 则 previous point 同绘制命令的第一个 point
      //
      // 第一个命令为 Arc 的情况下会在后面特殊处理
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    switch (cmd) {
      case CMD.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD.L:
        if (isStroke) {
          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.C:
        if (isStroke) {
          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.Q:
        if (isStroke) {
          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        var psi = data[i++];
        var anticlockwise = 1 - data[i++];
        var x1 = Math.cos(theta) * rx + cx;
        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i > 1) {
          w += windingLine(xi, yi, x1, y1, x, y);
        } else {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        if (isStroke) {
          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
            return true;
          }
        } else {
          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
        }

        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        var x1 = x0 + width;
        var y1 = y0 + height;

        if (isStroke) {
          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // FIXME Clockwise ?
          w += windingLine(x1, y0, x1, y1, x, y);
          w += windingLine(x0, y1, x0, y0, x, y);
        }

        break;

      case CMD.Z:
        if (isStroke) {
          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // Close a subpath
          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
          // FIXME subpaths may overlap
          // if (w !== 0) {
          //     return true;
          // }
        }

        xi = x0;
        yi = y0;
        break;
    }
  }

  if (!isStroke && !isAroundEqual(yi, y0)) {
    w += windingLine(xi, yi, x0, y0, x, y) || 0;
  }

  return w !== 0;
}

function contain(pathData, x, y) {
  return containPath(pathData, 0, false, x, y);
}

function containStroke(pathData, lineWidth, x, y) {
  return containPath(pathData, lineWidth, true, x, y);
}

exports.contain = contain;
exports.containStroke = containStroke;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

var eventUtil = __webpack_require__(77);

/**
 * Only implements needed gestures for mobile.
 */
var GestureMgr = function () {
  /**
   * @private
   * @type {Array.<Object>}
   */
  this._track = [];
};

GestureMgr.prototype = {
  constructor: GestureMgr,
  recognize: function (event, target, root) {
    this._doTrack(event, target, root);

    return this._recognize(event);
  },
  clear: function () {
    this._track.length = 0;
    return this;
  },
  _doTrack: function (event, target, root) {
    var touches = event.touches;

    if (!touches) {
      return;
    }

    var trackItem = {
      points: [],
      touches: [],
      target: target,
      event: event
    };

    for (var i = 0, len = touches.length; i < len; i++) {
      var touch = touches[i];
      var pos = eventUtil.clientToLocal(root, touch, {});
      trackItem.points.push([pos.zrX, pos.zrY]);
      trackItem.touches.push(touch);
    }

    this._track.push(trackItem);
  },
  _recognize: function (event) {
    for (var eventName in recognizers) {
      if (recognizers.hasOwnProperty(eventName)) {
        var gestureInfo = recognizers[eventName](this._track, event);

        if (gestureInfo) {
          return gestureInfo;
        }
      }
    }
  }
};

function dist(pointPair) {
  var dx = pointPair[1][0] - pointPair[0][0];
  var dy = pointPair[1][1] - pointPair[0][1];
  return Math.sqrt(dx * dx + dy * dy);
}

function center(pointPair) {
  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
}

var recognizers = {
  pinch: function (track, event) {
    var trackLen = track.length;

    if (!trackLen) {
      return;
    }

    var pinchEnd = (track[trackLen - 1] || {}).points;
    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;

    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
      var pinchScale = dist(pinchEnd) / dist(pinchPre);
      !isFinite(pinchScale) && (pinchScale = 1);
      event.pinchScale = pinchScale;
      var pinchCenter = center(pinchEnd);
      event.pinchX = pinchCenter[0];
      event.pinchY = pinchCenter[1];
      return {
        type: 'pinch',
        target: track[0].target,
        event: event
      };
    }
  } // Only pinch currently.

};
var _default = GestureMgr;
module.exports = _default;

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

// Myers' Diff Algorithm
// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
function Diff() {}

Diff.prototype = {
  diff: function (oldArr, newArr, equals) {
    if (!equals) {
      equals = function (a, b) {
        return a === b;
      };
    }

    this.equals = equals;
    var self = this;
    oldArr = oldArr.slice();
    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running

    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [{
      newPos: -1,
      components: []
    }]; // Seed editLength = 0, i.e. the content starts with the same values

    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);

    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
      var indices = [];

      for (var i = 0; i < newArr.length; i++) {
        indices.push(i);
      } // Identity per the equality and tokenizer


      return [{
        indices: indices,
        count: newArr.length
      }];
    } // Main worker method. checks all permutations of a given edit length for acceptance.


    function execEditLength() {
      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
        var basePath;
        var addPath = bestPath[diagonalPath - 1];
        var removePath = bestPath[diagonalPath + 1];
        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;

        if (addPath) {
          // No one else is going to attempt to use this value, clear it
          bestPath[diagonalPath - 1] = undefined;
        }

        var canAdd = addPath && addPath.newPos + 1 < newLen;
        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;

        if (!canAdd && !canRemove) {
          // If this path is a terminal then prune
          bestPath[diagonalPath] = undefined;
          continue;
        } // Select the diagonal that we want to branch from. We select the prior
        // path whose position in the new string is the farthest from the origin
        // and does not pass the bounds of the diff graph


        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
          basePath = clonePath(removePath);
          self.pushComponent(basePath.components, undefined, true);
        } else {
          basePath = addPath; // No need to clone, we've pulled it from the list

          basePath.newPos++;
          self.pushComponent(basePath.components, true, undefined);
        }

        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done

        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
          return buildValues(self, basePath.components, newArr, oldArr);
        } else {
          // Otherwise track this path as a potential candidate and continue.
          bestPath[diagonalPath] = basePath;
        }
      }

      editLength++;
    }

    while (editLength <= maxEditLength) {
      var ret = execEditLength();

      if (ret) {
        return ret;
      }
    }
  },
  pushComponent: function (components, added, removed) {
    var last = components[components.length - 1];

    if (last && last.added === added && last.removed === removed) {
      // We need to clone here as the component clone operation is just
      // as shallow array clone
      components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed
      };
    } else {
      components.push({
        count: 1,
        added: added,
        removed: removed
      });
    }
  },
  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var newPos = basePath.newPos;
    var oldPos = newPos - diagonalPath;
    var commonCount = 0;

    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
      newPos++;
      oldPos++;
      commonCount++;
    }

    if (commonCount) {
      basePath.components.push({
        count: commonCount
      });
    }

    basePath.newPos = newPos;
    return oldPos;
  },
  tokenize: function (value) {
    return value.slice();
  },
  join: function (value) {
    return value.slice();
  }
};

function buildValues(diff, components, newArr, oldArr) {
  var componentPos = 0;
  var componentLen = components.length;
  var newPos = 0;
  var oldPos = 0;

  for (; componentPos < componentLen; componentPos++) {
    var component = components[componentPos];

    if (!component.removed) {
      var indices = [];

      for (var i = newPos; i < newPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      newPos += component.count; // Common case

      if (!component.added) {
        oldPos += component.count;
      }
    } else {
      var indices = [];

      for (var i = oldPos; i < oldPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      oldPos += component.count;
    }
  }

  return components;
}

function clonePath(path) {
  return {
    newPos: path.newPos,
    components: path.components.slice(0)
  };
}

var arrayDiff = new Diff();

function _default(oldArr, newArr, callback) {
  return arrayDiff.diff(oldArr, newArr, callback);
}

module.exports = _default;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

var _event = __webpack_require__(77);

var addEventListener = _event.addEventListener;
var removeEventListener = _event.removeEventListener;
var normalizeEvent = _event.normalizeEvent;

var zrUtil = __webpack_require__(0);

var Eventful = __webpack_require__(108);

var env = __webpack_require__(33);

var GestureMgr = __webpack_require__(1973);

var TOUCH_CLICK_DELAY = 300;
var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
var pointerEventNames = {
  pointerdown: 1,
  pointerup: 1,
  pointermove: 1,
  pointerout: 1
};
var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
  var nm = name.replace('mouse', 'pointer');
  return pointerEventNames[nm] ? nm : name;
});

function eventNameFix(name) {
  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
}

function processGesture(proxy, event, stage) {
  var gestureMgr = proxy._gestureMgr;
  stage === 'start' && gestureMgr.clear();
  var gestureInfo = gestureMgr.recognize(event, proxy.handler.findHover(event.zrX, event.zrY, null).target, proxy.dom);
  stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.

  if (gestureInfo) {
    var type = gestureInfo.type;
    event.gestureEvent = type;
    proxy.handler.dispatchToElement({
      target: gestureInfo.target
    }, type, gestureInfo.event);
  }
} // function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }

/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 */


function setTouchTimer(instance) {
  instance._touching = true;
  clearTimeout(instance._touchTimer);
  instance._touchTimer = setTimeout(function () {
    instance._touching = false;
  }, 700);
}

var domHandlers = {
  /**
   * Mouse move handler
   * @inner
   * @param {Event} event
   */
  mousemove: function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger('mousemove', event);
  },

  /**
   * Mouse out handler
   * @inner
   * @param {Event} event
   */
  mouseout: function (event) {
    event = normalizeEvent(this.dom, event);
    var element = event.toElement || event.relatedTarget;

    if (element != this.dom) {
      while (element && element.nodeType != 9) {
        // 忽略包含在root中的dom引起的mouseOut
        if (element === this.dom) {
          return;
        }

        element = element.parentNode;
      }
    }

    this.trigger('mouseout', event);
  },

  /**
   * Touch开始响应函数
   * @inner
   * @param {Event} event
   */
  touchstart: function (event) {
    // Default mouse behaviour should not be disabled here.
    // For example, page may needs to be slided.
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    this._lastTouchMoment = new Date();
    processGesture(this, event, 'start'); // In touch device, trigger `mousemove`(`mouseover`) should
    // be triggered, and must before `mousedown` triggered.

    domHandlers.mousemove.call(this, event);
    domHandlers.mousedown.call(this, event);
    setTouchTimer(this);
  },

  /**
   * Touch移动响应函数
   * @inner
   * @param {Event} event
   */
  touchmove: function (event) {
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    processGesture(this, event, 'change'); // Mouse move should always be triggered no matter whether
    // there is gestrue event, because mouse move and pinch may
    // be used at the same time.

    domHandlers.mousemove.call(this, event);
    setTouchTimer(this);
  },

  /**
   * Touch结束响应函数
   * @inner
   * @param {Event} event
   */
  touchend: function (event) {
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    processGesture(this, event, 'end');
    domHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
    // we can conveniently implement "hover style" in both PC and touch device just
    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
    // to remove "hover style" on an element, without any additional code for
    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
    // style" will remain for user view)
    // click event should always be triggered no matter whether
    // there is gestrue event. System click can not be prevented.

    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
      domHandlers.click.call(this, event);
    }

    setTouchTimer(this);
  },
  pointerdown: function (event) {
    domHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
    //     this._msGesture.addPointer(event.pointerId);
    // }
  },
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      domHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    domHandlers.mouseup.call(this, event);
  },
  pointerout: function (event) {
    // pointerout will be triggered when tap on touch screen
    // (IE11+/Edge on MS Surface) after click event triggered,
    // which is inconsistent with the mousout behavior we defined
    // in touchend. So we unify them.
    // (check domHandlers.touchend for detailed explanation)
    if (!isPointerFromTouch(event)) {
      domHandlers.mouseout.call(this, event);
    }
  }
};

function isPointerFromTouch(event) {
  var pointerType = event.pointerType;
  return pointerType === 'pen' || pointerType === 'touch';
} // function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// Common handlers


zrUtil.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  domHandlers[name] = function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger(name, event);
  };
});
/**
 * 为控制类实例初始化dom 事件处理函数
 *
 * @inner
 * @param {module:zrender/Handler} instance 控制类实例
 */

function initDomHandler(instance) {
  zrUtil.each(touchHandlerNames, function (name) {
    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
  });
  zrUtil.each(pointerHandlerNames, function (name) {
    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
  });
  zrUtil.each(mouseHandlerNames, function (name) {
    instance._handlers[name] = makeMouseHandler(domHandlers[name], instance);
  });

  function makeMouseHandler(fn, instance) {
    return function () {
      if (instance._touching) {
        return;
      }

      return fn.apply(instance, arguments);
    };
  }
}

function HandlerDomProxy(dom) {
  Eventful.call(this);
  this.dom = dom;
  /**
   * @private
   * @type {boolean}
   */

  this._touching = false;
  /**
   * @private
   * @type {number}
   */

  this._touchTimer;
  /**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */

  this._gestureMgr = new GestureMgr();
  this._handlers = {};
  initDomHandler(this);

  if (env.pointerEventsSupported) {
    // Only IE11+/Edge
    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
    // at the same time.
    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
    // screen, which do not occurs in pointer event.
    // So we use pointer event to both detect touch gesture and mouse behavior.
    mountHandlers(pointerHandlerNames, this); // FIXME
    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
    // which does not prevent defuault behavior occasionally (which may cause view port
    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
    // touch screen. And we only support click behavior on MS touch screen now.
    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
    // We dont support touch on IE on win7.
    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
    // if (typeof MSGesture === 'function') {
    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
    // }
  } else {
    if (env.touchEventsSupported) {
      mountHandlers(touchHandlerNames, this); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
      // addEventListener(root, 'mouseout', this._mouseoutHandler);
    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
    // mouse event can not be handle in those devices.
    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
    // mouseevent after touch event triggered, see `setTouchTimer`.


    mountHandlers(mouseHandlerNames, this);
  }

  function mountHandlers(handlerNames, instance) {
    zrUtil.each(handlerNames, function (name) {
      addEventListener(dom, eventNameFix(name), instance._handlers[name]);
    }, instance);
  }
}

var handlerDomProxyProto = HandlerDomProxy.prototype;

handlerDomProxyProto.dispose = function () {
  var handlerNames = mouseHandlerNames.concat(touchHandlerNames);

  for (var i = 0; i < handlerNames.length; i++) {
    var name = handlerNames[i];
    removeEventListener(this.dom, eventNameFix(name), this._handlers[name]);
  }
};

handlerDomProxyProto.setCursor = function (cursorStyle) {
  this.dom.style.cursor = cursorStyle || 'default';
};

zrUtil.mixin(HandlerDomProxy, Eventful);
var _default = HandlerDomProxy;
module.exports = _default;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

// CompoundPath to improve performance
var _default = Path.extend({
  type: 'compound',
  shape: {
    paths: null
  },
  _updatePathDirty: function () {
    var dirtyPath = this.__dirtyPath;
    var paths = this.shape.paths;

    for (var i = 0; i < paths.length; i++) {
      // Mark as dirty if any subpath is dirty
      dirtyPath = dirtyPath || paths[i].__dirtyPath;
    }

    this.__dirtyPath = dirtyPath;
    this.__dirty = this.__dirty || dirtyPath;
  },
  beforeBrush: function () {
    this._updatePathDirty();

    var paths = this.shape.paths || [];
    var scale = this.getGlobalScale(); // Update path scale

    for (var i = 0; i < paths.length; i++) {
      if (!paths[i].path) {
        paths[i].createPathProxy();
      }

      paths[i].path.setScale(scale[0], scale[1]);
    }
  },
  buildPath: function (ctx, shape) {
    var paths = shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].buildPath(ctx, paths[i].shape, true);
    }
  },
  afterBrush: function () {
    var paths = this.shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].__dirtyPath = false;
    }
  },
  getBoundingRect: function () {
    this._updatePathDirty();

    return Path.prototype.getBoundingRect.call(this);
  }
});

module.exports = _default;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(0);

var Gradient = __webpack_require__(213);

/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */
var RadialGradient = function (x, y, r, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'radial', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0.5 : x;
  this.y = y == null ? 0.5 : y;
  this.r = r == null ? 0.5 : r; // Can be cloned

  this.type = 'radial'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

RadialGradient.prototype = {
  constructor: RadialGradient
};
zrUtil.inherits(RadialGradient, Gradient);
var _default = RadialGradient;
module.exports = _default;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(19);

var v2Min = _vector.min;
var v2Max = _vector.max;
var v2Scale = _vector.scale;
var v2Distance = _vector.distance;
var v2Add = _vector.add;
var v2Clone = _vector.clone;
var v2Sub = _vector.sub;

/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */
function _default(points, smooth, isLoop, constraint) {
  var cps = [];
  var v = [];
  var v1 = [];
  var v2 = [];
  var prevPoint;
  var nextPoint;
  var min, max;

  if (constraint) {
    min = [Infinity, Infinity];
    max = [-Infinity, -Infinity];

    for (var i = 0, len = points.length; i < len; i++) {
      v2Min(min, min, points[i]);
      v2Max(max, max, points[i]);
    } // 与指定的包围盒做并集


    v2Min(min, min, constraint[0]);
    v2Max(max, max, constraint[1]);
  }

  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];

    if (isLoop) {
      prevPoint = points[i ? i - 1 : len - 1];
      nextPoint = points[(i + 1) % len];
    } else {
      if (i === 0 || i === len - 1) {
        cps.push(v2Clone(points[i]));
        continue;
      } else {
        prevPoint = points[i - 1];
        nextPoint = points[i + 1];
      }
    }

    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length

    v2Scale(v, v, smooth);
    var d0 = v2Distance(point, prevPoint);
    var d1 = v2Distance(point, nextPoint);
    var sum = d0 + d1;

    if (sum !== 0) {
      d0 /= sum;
      d1 /= sum;
    }

    v2Scale(v1, v, -d0);
    v2Scale(v2, v, d1);
    var cp0 = v2Add([], point, v1);
    var cp1 = v2Add([], point, v2);

    if (constraint) {
      v2Max(cp0, cp0, min);
      v2Min(cp0, cp0, max);
      v2Max(cp1, cp1, min);
      v2Min(cp1, cp1, max);
    }

    cps.push(cp0);
    cps.push(cp1);
  }

  if (isLoop) {
    cps.push(cps.shift());
  }

  return cps;
}

module.exports = _default;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(19);

var v2Distance = _vector.distance;

/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * @inner
 */
function interpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */


function _default(points, isLoop) {
  var len = points.length;
  var ret = [];
  var distance = 0;

  for (var i = 1; i < len; i++) {
    distance += v2Distance(points[i - 1], points[i]);
  }

  var segs = distance / 2;
  segs = segs < len ? len : segs;

  for (var i = 0; i < segs; i++) {
    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
    var idx = Math.floor(pos);
    var w = pos - idx;
    var p0;
    var p1 = points[idx % len];
    var p2;
    var p3;

    if (!isLoop) {
      p0 = points[idx === 0 ? idx : idx - 1];
      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
    } else {
      p0 = points[(idx - 1 + len) % len];
      p2 = points[(idx + 1) % len];
      p3 = points[(idx + 2) % len];
    }

    var w2 = w * w;
    var w3 = w * w2;
    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
  }

  return ret;
}

module.exports = _default;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */
var _default = Path.extend({
  type: 'arc',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
  }
});

module.exports = _default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var vec2 = __webpack_require__(19);

var _curve = __webpack_require__(88);

var quadraticSubdivide = _curve.quadraticSubdivide;
var cubicSubdivide = _curve.cubicSubdivide;
var quadraticAt = _curve.quadraticAt;
var cubicAt = _curve.cubicAt;
var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
var cubicDerivativeAt = _curve.cubicDerivativeAt;

/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */
var out = [];

function someVectorAt(shape, t, isTangent) {
  var cpx2 = shape.cpx2;
  var cpy2 = shape.cpy2;

  if (cpx2 === null || cpy2 === null) {
    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
  } else {
    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
  }
}

var _default = Path.extend({
  type: 'bezier-curve',
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    // cpx2: 0,
    // cpy2: 0
    // Curve show percent, for animating
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var cpx1 = shape.cpx1;
    var cpy1 = shape.cpy1;
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (cpx2 == null || cpy2 == null) {
      if (percent < 1) {
        quadraticSubdivide(x1, cpx1, x2, percent, out);
        cpx1 = out[1];
        x2 = out[2];
        quadraticSubdivide(y1, cpy1, y2, percent, out);
        cpy1 = out[1];
        y2 = out[2];
      }

      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
    } else {
      if (percent < 1) {
        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
        cpx1 = out[1];
        cpx2 = out[2];
        x2 = out[3];
        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
        cpy1 = out[1];
        cpy2 = out[2];
        y2 = out[3];
      }

      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
    }
  },

  /**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  pointAt: function (t) {
    return someVectorAt(this.shape, t, false);
  },

  /**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  tangentAt: function (t) {
    var p = someVectorAt(this.shape, t, true);
    return vec2.normalize(p, p);
  }
});

module.exports = _default;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

/**
 * 圆形
 * @module zrender/shape/Circle
 */
var _default = Path.extend({
  type: 'circle',
  shape: {
    cx: 0,
    cy: 0,
    r: 0
  },
  buildPath: function (ctx, shape, inBundle) {
    // Better stroking in ShapeBundle
    // Always do it may have performence issue ( fill may be 2x more cost)
    if (inBundle) {
      ctx.moveTo(shape.cx + shape.r, shape.cy);
    } // else {
    //     if (ctx.allocate && !ctx.data.length) {
    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
    //     }
    // }
    // Better stroking in ShapeBundle
    // ctx.moveTo(shape.cx + shape.r, shape.cy);


    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
  }
});

module.exports = _default;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

/**
 * 直线
 * @module zrender/graphic/shape/Line
 */
var _default = Path.extend({
  type: 'line',
  shape: {
    // Start point
    x1: 0,
    y1: 0,
    // End point
    x2: 0,
    y2: 0,
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (percent < 1) {
      x2 = x1 * (1 - percent) + x2 * percent;
      y2 = y1 * (1 - percent) + y2 * percent;
    }

    ctx.lineTo(x2, y2);
  },

  /**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */
  pointAt: function (p) {
    var shape = this.shape;
    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
  }
});

module.exports = _default;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var polyHelper = __webpack_require__(696);

/**
 * 多边形
 * @module zrender/shape/Polygon
 */
var _default = Path.extend({
  type: 'polygon',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, true);
  }
});

module.exports = _default;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var polyHelper = __webpack_require__(696);

/**
 * @module zrender/graphic/shape/Polyline
 */
var _default = Path.extend({
  type: 'polyline',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, false);
  }
});

module.exports = _default;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var roundRectHelper = __webpack_require__(697);

/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */
var _default = Path.extend({
  type: 'rect',
  shape: {
    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
    // r缩写为1         相当于 [1, 1, 1, 1]
    // r缩写为[1]       相当于 [1, 1, 1, 1]
    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
    r: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;

    if (!shape.r) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, shape);
    }

    ctx.closePath();
    return;
  }
});

module.exports = _default;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */
var _default = Path.extend({
  type: 'ring',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    r0: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var PI2 = Math.PI * 2;
    ctx.moveTo(x + shape.r, y);
    ctx.arc(x, y, shape.r, 0, PI2, false);
    ctx.moveTo(x + shape.r0, y);
    ctx.arc(x, y, shape.r0, 0, PI2, true);
  }
});

module.exports = _default;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var fixClipWithShadow = __webpack_require__(695);

/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */
var _default = Path.extend({
  type: 'sector',
  shape: {
    cx: 0,
    cy: 0,
    r0: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
    ctx.lineTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);

    if (r0 !== 0) {
      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
    }

    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

var Animator = __webpack_require__(683);

var log = __webpack_require__(151);

var _util = __webpack_require__(0);

var isString = _util.isString;
var isFunction = _util.isFunction;
var isObject = _util.isObject;
var isArrayLike = _util.isArrayLike;
var indexOf = _util.indexOf;

/**
 * @alias modue:zrender/mixin/Animatable
 * @constructor
 */
var Animatable = function () {
  /**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */
  this.animators = [];
};

Animatable.prototype = {
  constructor: Animatable,

  /**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */
  animate: function (path, loop) {
    var target;
    var animatingShape = false;
    var el = this;
    var zr = this.__zr;

    if (path) {
      var pathSplitted = path.split('.');
      var prop = el; // If animating shape

      animatingShape = pathSplitted[0] === 'shape';

      for (var i = 0, l = pathSplitted.length; i < l; i++) {
        if (!prop) {
          continue;
        }

        prop = prop[pathSplitted[i]];
      }

      if (prop) {
        target = prop;
      }
    } else {
      target = el;
    }

    if (!target) {
      log('Property "' + path + '" is not existed in element ' + el.id);
      return;
    }

    var animators = el.animators;
    var animator = new Animator(target, loop);
    animator.during(function (target) {
      el.dirty(animatingShape);
    }).done(function () {
      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
      animators.splice(indexOf(animators, animator), 1);
    });
    animators.push(animator); // If animate after added to the zrender

    if (zr) {
      zr.animation.addAnimator(animator);
    }

    return animator;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stopAnimation: function (forwardToLast) {
    var animators = this.animators;
    var len = animators.length;

    for (var i = 0; i < len; i++) {
      animators[i].stop(forwardToLast);
    }

    animators.length = 0;
    return this;
  },

  /**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */
  // TODO Return animation key
  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
    // animateTo(target, time, easing, callback);
    if (isString(delay)) {
      callback = easing;
      easing = delay;
      delay = 0;
    } // animateTo(target, time, delay, callback);
    else if (isFunction(easing)) {
        callback = easing;
        easing = 'linear';
        delay = 0;
      } // animateTo(target, time, callback);
      else if (isFunction(delay)) {
          callback = delay;
          delay = 0;
        } // animateTo(target, callback)
        else if (isFunction(time)) {
            callback = time;
            time = 500;
          } // animateTo(target)
          else if (!time) {
              time = 500;
            } // Stop all previous animations


    this.stopAnimation();

    this._animateToShallow('', this, target, time, delay); // Animators may be removed immediately after start
    // if there is nothing to animate


    var animators = this.animators.slice();
    var count = animators.length;

    function done() {
      count--;

      if (!count) {
        callback && callback();
      }
    } // No animators. This should be checked before animators[i].start(),
    // because 'done' may be executed immediately if no need to animate.


    if (!count) {
      callback && callback();
    } // Start after all animators created
    // Incase any animator is done immediately when all animation properties are not changed


    for (var i = 0; i < animators.length; i++) {
      animators[i].done(done).start(easing, forceAnimate);
    }
  },

  /**
   * @private
   * @param {string} path=''
   * @param {Object} source=this
   * @param {Object} target
   * @param {number} [time=500]
   * @param {number} [delay=0]
   *
   * @example
   *  // Animate position
   *  el._animateToShallow({
   *      position: [10, 10]
   *  })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms
   *  el._animateToShallow({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100)
   */
  _animateToShallow: function (path, source, target, time, delay) {
    var objShallow = {};
    var propertyCount = 0;

    for (var name in target) {
      if (!target.hasOwnProperty(name)) {
        continue;
      }

      if (source[name] != null) {
        if (isObject(target[name]) && !isArrayLike(target[name])) {
          this._animateToShallow(path ? path + '.' + name : name, source[name], target[name], time, delay);
        } else {
          objShallow[name] = target[name];
          propertyCount++;
        }
      } else if (target[name] != null) {
        // Attr directly if not has property
        // FIXME, if some property not needed for element ?
        if (!path) {
          this.attr(name, target[name]);
        } else {
          // Shape or style
          var props = {};
          props[path] = {};
          props[path][name] = target[name];
          this.attr(props);
        }
      }
    }

    if (propertyCount > 0) {
      this.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
    }

    return this;
  }
};
var _default = Animatable;
module.exports = _default;

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function Draggable() {
  this.on('mousedown', this._dragStart, this);
  this.on('mousemove', this._drag, this);
  this.on('mouseup', this._dragEnd, this);
  this.on('globalout', this._dragEnd, this); // this._dropTarget = null;
  // this._draggingTarget = null;
  // this._x = 0;
  // this._y = 0;
}

Draggable.prototype = {
  constructor: Draggable,
  _dragStart: function (e) {
    var draggingTarget = e.target;

    if (draggingTarget && draggingTarget.draggable) {
      this._draggingTarget = draggingTarget;
      draggingTarget.dragging = true;
      this._x = e.offsetX;
      this._y = e.offsetY;
      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
    }
  },
  _drag: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      var x = e.offsetX;
      var y = e.offsetY;
      var dx = x - this._x;
      var dy = y - this._y;
      this._x = x;
      this._y = y;
      draggingTarget.drift(dx, dy, e);
      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
      var dropTarget = this.findHover(x, y, draggingTarget).target;
      var lastDropTarget = this._dropTarget;
      this._dropTarget = dropTarget;

      if (draggingTarget !== dropTarget) {
        if (lastDropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
        }

        if (dropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
        }
      }
    }
  },
  _dragEnd: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      draggingTarget.dragging = false;
    }

    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);

    if (this._dropTarget) {
      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
    }

    this._draggingTarget = null;
    this._dropTarget = null;
  }
};

function param(target, e) {
  return {
    target: target,
    topTarget: e && e.topTarget
  };
}

var _default = Draggable;
module.exports = _default;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(324);

var createElement = _core.createElement;

var util = __webpack_require__(0);

var each = util.each;

var zrLog = __webpack_require__(151);

var Path = __webpack_require__(34);

var ZImage = __webpack_require__(152);

var ZText = __webpack_require__(153);

var arrayDiff = __webpack_require__(1974);

var GradientManager = __webpack_require__(1993);

var ClippathManager = __webpack_require__(1992);

var _graphic = __webpack_require__(325);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * SVG Painter
 * @module zrender/svg/Painter
 */
function parseInt10(val) {
  return parseInt(val, 10);
}

function getSvgProxy(el) {
  if (el instanceof Path) {
    return svgPath;
  } else if (el instanceof ZImage) {
    return svgImage;
  } else if (el instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
}

function checkParentAvailable(parent, child) {
  return child && parent && child.parentNode !== parent;
}

function insertAfter(parent, child, prevSibling) {
  if (checkParentAvailable(parent, child) && prevSibling) {
    var nextSibling = prevSibling.nextSibling;
    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
  }
}

function prepend(parent, child) {
  if (checkParentAvailable(parent, child)) {
    var firstChild = parent.firstChild;
    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
  }
}

function append(parent, child) {
  if (checkParentAvailable(parent, child)) {
    parent.appendChild(child);
  }
}

function remove(parent, child) {
  if (child && parent && child.parentNode === parent) {
    parent.removeChild(child);
  }
}

function getTextSvgElement(displayable) {
  return displayable.__textSvgEl;
}

function getSvgElement(displayable) {
  return displayable.__svgEl;
}
/**
 * @alias module:zrender/svg/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var SVGPainter = function (root, storage, opts) {
  this.root = root;
  this.storage = storage;
  this._opts = opts = util.extend({}, opts || {});
  var svgRoot = createElement('svg');
  svgRoot.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svgRoot.setAttribute('version', '1.1');
  svgRoot.setAttribute('baseProfile', 'full');
  svgRoot.style['user-select'] = 'none';
  svgRoot.style.cssText = 'position:absolute;left:0;top:0;';
  this.gradientManager = new GradientManager(svgRoot);
  this.clipPathManager = new ClippathManager(svgRoot);
  var viewport = document.createElement('div');
  viewport.style.cssText = 'overflow:hidden;position:relative';
  this._svgRoot = svgRoot;
  this._viewport = viewport;
  root.appendChild(viewport);
  viewport.appendChild(svgRoot);
  this.resize(opts.width, opts.height);
  this._visibleList = [];
};

SVGPainter.prototype = {
  constructor: SVGPainter,
  getType: function () {
    return 'svg';
  },
  getViewportRoot: function () {
    return this._viewport;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },
  refresh: function () {
    var list = this.storage.getDisplayList(true);

    this._paintList(list);
  },
  _paintList: function (list) {
    this.gradientManager.markAllUnused();
    this.clipPathManager.markAllUnused();
    var svgRoot = this._svgRoot;
    var visibleList = this._visibleList;
    var listLen = list.length;
    var newVisibleList = [];
    var i;

    for (i = 0; i < listLen; i++) {
      var displayable = list[i];
      var svgProxy = getSvgProxy(displayable);

      if (!displayable.invisible) {
        if (displayable.__dirty) {
          svgProxy && svgProxy.brush(displayable); // Update clipPath

          this.clipPathManager.update(displayable); // Update gradient

          if (displayable.style) {
            this.gradientManager.update(displayable.style.fill);
            this.gradientManager.update(displayable.style.stroke);
          }

          displayable.__dirty = false;
        }

        newVisibleList.push(displayable);
      }
    }

    var diff = arrayDiff(visibleList, newVisibleList);
    var prevSvgElement; // First do remove, in case element moved to the head and do remove
    // after add

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = visibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          remove(svgRoot, svgElement);
          remove(svgRoot, textSvgElement);
        }
      }
    }

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.added) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);

          if (svgElement) {
            insertAfter(svgRoot, textSvgElement, svgElement);
          } else if (prevSvgElement) {
            insertAfter(svgRoot, textSvgElement, prevSvgElement);
          } else {
            prepend(svgRoot, textSvgElement);
          } // Insert text


          insertAfter(svgRoot, textSvgElement, svgElement);
          prevSvgElement = textSvgElement || svgElement || prevSvgElement;
          this.gradientManager.addWithoutUpdate(svgElement, displayable);
          this.clipPathManager.markUsed(displayable);
        }
      } else if (!item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          prevSvgElement = svgElement = getTextSvgElement(displayable) || getSvgElement(displayable) || prevSvgElement;
          this.gradientManager.markUsed(displayable);
          this.gradientManager.addWithoutUpdate(svgElement, displayable);
          this.clipPathManager.markUsed(displayable);
        }
      }
    }

    this.gradientManager.removeUnused();
    this.clipPathManager.removeUnused();
    this._visibleList = newVisibleList;
  },
  _getDefs: function (isForceCreating) {
    var svgRoot = this._svgRoot;

    var defs = this._svgRoot.getElementsByTagName('defs');

    if (defs.length === 0) {
      // Not exist
      if (isForceCreating) {
        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
        svgRoot.firstChild // Insert in the front of svg
        );

        if (!defs.contains) {
          // IE doesn't support contains method
          defs.contains = function (el) {
            var children = defs.children;

            if (!children) {
              return false;
            }

            for (var i = children.length - 1; i >= 0; --i) {
              if (children[i] === el) {
                return true;
              }
            }

            return false;
          };
        }

        return defs;
      } else {
        return null;
      }
    } else {
      return defs[0];
    }
  },
  resize: function (width, height) {
    var viewport = this._viewport; // FIXME Why ?

    viewport.style.display = 'none'; // Save input w/h

    var opts = this._opts;
    width != null && (opts.width = width);
    height != null && (opts.height = height);
    width = this._getSize(0);
    height = this._getSize(1);
    viewport.style.display = '';

    if (this._width !== width && this._height !== height) {
      this._width = width;
      this._height = height;
      var viewportStyle = viewport.style;
      viewportStyle.width = width + 'px';
      viewportStyle.height = height + 'px';
      var svgRoot = this._svgRoot; // Set width by 'svgRoot.width = width' is invalid

      svgRoot.setAttribute('width', width);
      svgRoot.setAttribute('height', height);
    }
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  dispose: function () {
    this.root.innerHTML = '';
    this._svgRoot = this._viewport = this.storage = null;
  },
  clear: function () {
    if (this._viewport) {
      this.root.removeChild(this._viewport);
    }
  },
  pathToSvg: function () {
    this.refresh();
    var html = this._svgRoot.outerHTML;
    return 'data:img/svg+xml;utf-8,' + unescape(html);
  }
}; // Not supported methods

function createMethodNotSupport(method) {
  return function () {
    zrLog('In SVG mode painter not support method "' + method + '"');
  };
} // Unsuppoted methods


each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
  SVGPainter.prototype[name] = createMethodNotSupport(name);
});
var _default = SVGPainter;
module.exports = _default;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(699);

var zrUtil = __webpack_require__(0);

var matrix = __webpack_require__(53);

/**
 * @file Manages SVG clipPath elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG clipPath elements.
 *
 * @class
 * @extends Definable
 * @param   {SVGElement} svgRoot root of SVG document
 */
function ClippathManager(svgRoot) {
  Definable.call(this, svgRoot, 'clipPath', '__clippath_in_use__');
}

zrUtil.inherits(ClippathManager, Definable);
/**
 * Update clipPath.
 *
 * @param {Displayable} displayable displayable element
 */

ClippathManager.prototype.update = function (displayable) {
  var svgEl = this.getSvgElement(displayable);

  if (svgEl) {
    this.updateDom(svgEl, displayable.__clipPaths, false);
  }

  var textEl = this.getTextSvgElement(displayable);

  if (textEl) {
    // Make another clipPath for text, since it's transform
    // matrix is not the same with svgElement
    this.updateDom(textEl, displayable.__clipPaths, true);
  }

  this.markUsed(displayable);
};
/**
 * Create an SVGElement of displayable and create a <clipPath> of its
 * clipPath
 *
 * @param {Displayable} parentEl  parent element
 * @param {ClipPath[]}  clipPaths clipPaths of parent element
 * @param {boolean}     isText    if parent element is Text
 */


ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
  if (clipPaths && clipPaths.length > 0) {
    // Has clipPath, create <clipPath> with the first clipPath
    var defs = this.getDefs(true);
    var clipPath = clipPaths[0];
    var clipPathEl;
    var id;
    var dom = isText ? '_textDom' : '_dom';

    if (clipPath[dom]) {
      // Use a dom that is already in <defs>
      id = clipPath[dom].getAttribute('id');
      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>

      if (!defs.contains(clipPathEl)) {
        // This happens when set old clipPath that has
        // been previously removed
        defs.appendChild(clipPathEl);
      }
    } else {
      // New <clipPath>
      id = 'zr-clip-' + this.nextId;
      ++this.nextId;
      clipPathEl = this.createElement('clipPath');
      clipPathEl.setAttribute('id', id);
      defs.appendChild(clipPathEl);
      clipPath[dom] = clipPathEl;
    } // Build path and add to <clipPath>


    var svgProxy = this.getSvgProxy(clipPath);

    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
      /**
       * If a clipPath has a parent with transform, the transform
       * of parent should not be considered when setting transform
       * of clipPath. So we need to transform back from parent's
       * transform, which is done by multiplying parent's inverse
       * transform.
       */
      // Store old transform
      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path

      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
      svgProxy.brush(clipPath); // Set back transform of clipPath

      clipPath.transform = transform;
    } else {
      svgProxy.brush(clipPath);
    }

    var pathEl = this.getSvgElement(clipPath);
    /**
     * Use `cloneNode()` here to appendChild to multiple parents,
     * which may happend when Text and other shapes are using the same
     * clipPath. Since Text will create an extra clipPath DOM due to
     * different transform rules.
     */

    clipPathEl.appendChild(pathEl.cloneNode());
    parentEl.setAttribute('clip-path', 'url(#' + id + ')');

    if (clipPaths.length > 1) {
      // Make the other clipPaths recursively
      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
    }
  } else {
    // No clipPath
    if (parentEl) {
      parentEl.setAttribute('clip-path', 'none');
    }
  }
};
/**
 * Mark a single clipPath to be used
 *
 * @param {Displayable} displayable displayable element
 */


ClippathManager.prototype.markUsed = function (displayable) {
  var that = this;

  if (displayable.__clipPaths && displayable.__clipPaths.length > 0) {
    zrUtil.each(displayable.__clipPaths, function (clipPath) {
      if (clipPath._dom) {
        Definable.prototype.markUsed.call(that, clipPath._dom);
      }

      if (clipPath._textDom) {
        Definable.prototype.markUsed.call(that, clipPath._textDom);
      }
    });
  }
};

var _default = ClippathManager;
module.exports = _default;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(699);

var zrUtil = __webpack_require__(0);

var zrLog = __webpack_require__(151);

/**
 * @file Manages SVG gradient elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG gradient elements.
 *
 * @class
 * @extends Definable
 * @param   {SVGElement} svgRoot root of SVG document
 */
function GradientManager(svgRoot) {
  Definable.call(this, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
}

zrUtil.inherits(GradientManager, Definable);
/**
 * Create new gradient DOM for fill or stroke if not exist,
 * but will not update gradient if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */

GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
  if (displayable && displayable.style) {
    var that = this;
    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
        var gradient = displayable.style[fillOrStroke];
        var defs = that.getDefs(true); // Create dom in <defs> if not exists

        var dom;

        if (gradient._dom) {
          // Gradient exists
          dom = gradient._dom;

          if (!defs.contains(gradient._dom)) {
            // _dom is no longer in defs, recreate
            that.addDom(dom);
          }
        } else {
          // New dom
          dom = that.add(gradient);
        }

        that.markUsed(displayable);
        var id = dom.getAttribute('id');
        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
      }
    });
  }
};
/**
 * Add a new gradient tag in <defs>
 *
 * @param   {Gradient} gradient zr gradient instance
 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
 *                            created DOM
 */


GradientManager.prototype.add = function (gradient) {
  var dom;

  if (gradient.type === 'linear') {
    dom = this.createElement('linearGradient');
  } else if (gradient.type === 'radial') {
    dom = this.createElement('radialGradient');
  } else {
    zrLog('Illegal gradient type.');
    return null;
  } // Set dom id with gradient id, since each gradient instance
  // will have no more than one dom element.
  // id may exists before for those dirty elements, in which case
  // id should remain the same, and other attributes should be
  // updated.


  gradient.id = gradient.id || this.nextId++;
  dom.setAttribute('id', 'zr-gradient-' + gradient.id);
  this.updateDom(gradient, dom);
  this.addDom(dom);
  return dom;
};
/**
 * Update gradient.
 *
 * @param {Gradient} gradient zr gradient instance
 */


GradientManager.prototype.update = function (gradient) {
  var that = this;
  Definable.prototype.update.call(this, gradient, function () {
    var type = gradient.type;
    var tagName = gradient._dom.tagName;

    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
      // Gradient type is not changed, update gradient
      that.updateDom(gradient, gradient._dom);
    } else {
      // Remove and re-create if type is changed
      that.removeDom(gradient);
      that.add(gradient);
    }
  });
};
/**
 * Update gradient dom
 *
 * @param {Gradient} gradient zr gradient instance
 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
 *                            DOM to update
 */


GradientManager.prototype.updateDom = function (gradient, dom) {
  if (gradient.type === 'linear') {
    dom.setAttribute('x1', gradient.x);
    dom.setAttribute('y1', gradient.y);
    dom.setAttribute('x2', gradient.x2);
    dom.setAttribute('y2', gradient.y2);
  } else if (gradient.type === 'radial') {
    dom.setAttribute('cx', gradient.x);
    dom.setAttribute('cy', gradient.y);
    dom.setAttribute('r', gradient.r);
  } else {
    zrLog('Illegal gradient type.');
    return;
  }

  if (gradient.global) {
    // x1, x2, y1, y2 in range of 0 to canvas width or height
    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
  } else {
    // x1, x2, y1, y2 in range of 0 to 1
    dom.setAttribute('gradientUnits', 'objectBoundingBox');
  } // Remove color stops if exists


  dom.innerHTML = ''; // Add color stops

  var colors = gradient.colorStops;

  for (var i = 0, len = colors.length; i < len; ++i) {
    var stop = this.createElement('stop');
    stop.setAttribute('offset', colors[i].offset * 100 + '%');
    stop.setAttribute('stop-color', colors[i].color);
    dom.appendChild(stop);
  } // Store dom element in gradient, to avoid creating multiple
  // dom instances for the same gradient element


  gradient._dom = dom;
};
/**
 * Mark a single gradient to be used
 *
 * @param {Displayable} displayable displayable element
 */


GradientManager.prototype.markUsed = function (displayable) {
  if (displayable.style) {
    var gradient = displayable.style.fill;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }

    gradient = displayable.style.stroke;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }
  }
};

var _default = GradientManager;
module.exports = _default;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325);

var _zrender = __webpack_require__(215);

var registerPainter = _zrender.registerPainter;

var Painter = __webpack_require__(1991);

registerPainter('svg', Painter);

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(34);

var PathProxy = __webpack_require__(125);

var transformPath = __webpack_require__(1996);

// command chars
var cc = ['m', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z', 'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'];
var mathSqrt = Math.sqrt;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;

var vMag = function (v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};

var vRatio = function (u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
};

var vAngle = function (u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
};

function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
  var psi = psiDeg * (PI / 180.0);
  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);

  if (lambda > 1) {
    rx *= mathSqrt(lambda);
    ry *= mathSqrt(lambda);
  }

  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
  var cxp = f * rx * yp / ry;
  var cyp = f * -ry * xp / rx;
  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
  var dTheta = vAngle(u, v);

  if (vRatio(u, v) <= -1) {
    dTheta = PI;
  }

  if (vRatio(u, v) >= 1) {
    dTheta = 0;
  }

  if (fs === 0 && dTheta > 0) {
    dTheta = dTheta - 2 * PI;
  }

  if (fs === 1 && dTheta < 0) {
    dTheta = dTheta + 2 * PI;
  }

  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}

function createPathProxyFromString(data) {
  if (!data) {
    return [];
  } // command string


  var cs = data.replace(/-/g, ' -').replace(/  /g, ' ').replace(/ /g, ',').replace(/,,/g, ',');
  var n; // create pipes so that we can split the data

  for (n = 0; n < cc.length; n++) {
    cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
  } // create array


  var arr = cs.split('|'); // init context point

  var cpx = 0;
  var cpy = 0;
  var path = new PathProxy();
  var CMD = PathProxy.CMD;
  var prevCmd;

  for (n = 1; n < arr.length; n++) {
    var str = arr[n];
    var c = str.charAt(0);
    var off = 0;
    var p = str.slice(1).replace(/e,-/g, 'e-').split(',');
    var cmd;

    if (p.length > 0 && p[0] === '') {
      p.shift();
    }

    for (var i = 0; i < p.length; i++) {
      p[i] = parseFloat(p[i]);
    }

    while (off < p.length && !isNaN(p[off])) {
      if (isNaN(p[0])) {
        break;
      }

      var ctlPtx;
      var ctlPty;
      var rx;
      var ry;
      var psi;
      var fa;
      var fs;
      var x1 = cpx;
      var y1 = cpy; // convert l, H, h, V, and v to L

      switch (c) {
        case 'l':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'L':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'm':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          c = 'l';
          break;

        case 'M':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          c = 'L';
          break;

        case 'h':
          cpx += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'H':
          cpx = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'v':
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'V':
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'C':
          cmd = CMD.C;
          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
          cpx = p[off - 2];
          cpy = p[off - 1];
          break;

        case 'c':
          cmd = CMD.C;
          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
          cpx += p[off - 2];
          cpy += p[off - 1];
          break;

        case 'S':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 's':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = cpx + p[off++];
          y1 = cpy + p[off++];
          cpx += p[off++];
          cpy += p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 'Q':
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'q':
          x1 = p[off++] + cpx;
          y1 = p[off++] + cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'T':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 't':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 'A':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;

        case 'a':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;
      }
    }

    if (c === 'z' || c === 'Z') {
      cmd = CMD.Z;
      path.addData(cmd);
    }

    prevCmd = cmd;
  }

  path.toStatic();
  return path;
} // TODO Optimize double memory cost problem


function createPathOptions(str, opts) {
  var pathProxy = createPathProxyFromString(str);
  opts = opts || {};

  opts.buildPath = function (path) {
    if (path.setData) {
      path.setData(pathProxy.data); // Svg and vml renderer don't have context

      var ctx = path.getContext();

      if (ctx) {
        path.rebuildPath(ctx);
      }
    } else {
      var ctx = path;
      pathProxy.rebuildPath(ctx);
    }
  };

  opts.applyTransform = function (m) {
    transformPath(pathProxy, m);
    this.dirty(true);
  };

  return opts;
}
/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */


function createFromString(str, opts) {
  return new Path(createPathOptions(str, opts));
}
/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */


function extendFromString(str, opts) {
  return Path.extend(createPathOptions(str, opts));
}
/**
 * Merge multiple paths
 */
// TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem


function mergePath(pathEls, opts) {
  var pathList = [];
  var len = pathEls.length;

  for (var i = 0; i < len; i++) {
    var pathEl = pathEls[i];

    if (!pathEl.path) {
      pathEl.createPathProxy();
    }

    if (pathEl.__dirtyPath) {
      pathEl.buildPath(pathEl.path, pathEl.shape, true);
    }

    pathList.push(pathEl.path);
  }

  var pathBundle = new Path(opts); // Need path proxy.

  pathBundle.createPathProxy();

  pathBundle.buildPath = function (path) {
    path.appendPath(pathList); // Svg and vml renderer don't have context

    var ctx = path.getContext();

    if (ctx) {
      path.rebuildPath(ctx);
    }
  };

  return pathBundle;
}

exports.createFromString = createFromString;
exports.extendFromString = extendFromString;
exports.mergePath = mergePath;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(125);

var _vector = __webpack_require__(19);

var v2ApplyTransform = _vector.applyTransform;
var CMD = PathProxy.CMD;
var points = [[], [], []];
var mathSqrt = Math.sqrt;
var mathAtan2 = Math.atan2;

function _default(path, m) {
  var data = path.data;
  var cmd;
  var nPoint;
  var i;
  var j;
  var k;
  var p;
  var M = CMD.M;
  var C = CMD.C;
  var L = CMD.L;
  var R = CMD.R;
  var A = CMD.A;
  var Q = CMD.Q;

  for (i = 0, j = 0; i < data.length;) {
    cmd = data[i++];
    j = i;
    nPoint = 0;

    switch (cmd) {
      case M:
        nPoint = 1;
        break;

      case L:
        nPoint = 1;
        break;

      case C:
        nPoint = 3;
        break;

      case Q:
        nPoint = 2;
        break;

      case A:
        var x = m[4];
        var y = m[5];
        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx

        data[i] *= sx;
        data[i++] += x; // cy

        data[i] *= sy;
        data[i++] += y; // Scale rx and ry
        // FIXME Assume psi is 0 here

        data[i++] *= sx;
        data[i++] *= sy; // Start angle

        data[i++] += angle; // end angle

        data[i++] += angle; // FIXME psi

        i += 2;
        j = i;
        break;

      case R:
        // x0, y0
        p[0] = data[i++];
        p[1] = data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1]; // x1, y1

        p[0] += data[i++];
        p[1] += data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1];
    }

    for (k = 0; k < nPoint; k++) {
      var p = points[k];
      p[0] = data[i++];
      p[1] = data[i++];
      v2ApplyTransform(p, p, m); // Write back

      data[j++] = p[0];
      data[j++] = p[1];
    }
  }
}

module.exports = _default;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

var zrLog = __webpack_require__(151);

var vmlCore = __webpack_require__(700);

var _util = __webpack_require__(0);

var each = _util.each;

/**
 * VML Painter.
 *
 * @module zrender/vml/Painter
 */
function parseInt10(val) {
  return parseInt(val, 10);
}
/**
 * @alias module:zrender/vml/Painter
 */


function VMLPainter(root, storage) {
  vmlCore.initVML();
  this.root = root;
  this.storage = storage;
  var vmlViewport = document.createElement('div');
  var vmlRoot = document.createElement('div');
  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
  root.appendChild(vmlViewport);
  this._vmlRoot = vmlRoot;
  this._vmlViewport = vmlViewport;
  this.resize(); // Modify storage

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);

    if (el) {
      el.onRemove && el.onRemove(vmlRoot);
    }
  };

  storage.addToStorage = function (el) {
    // Displayable already has a vml node
    el.onAdd && el.onAdd(vmlRoot);
    oldAddToStorage.call(storage, el);
  };

  this._firstPaint = true;
}

VMLPainter.prototype = {
  constructor: VMLPainter,
  getType: function () {
    return 'vml';
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._vmlViewport;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   */
  refresh: function () {
    var list = this.storage.getDisplayList(true, true);

    this._paintList(list);
  },
  _paintList: function (list) {
    var vmlRoot = this._vmlRoot;

    for (var i = 0; i < list.length; i++) {
      var el = list[i];

      if (el.invisible || el.ignore) {
        if (!el.__alreadyNotVisible) {
          el.onRemove(vmlRoot);
        } // Set as already invisible


        el.__alreadyNotVisible = true;
      } else {
        if (el.__alreadyNotVisible) {
          el.onAdd(vmlRoot);
        }

        el.__alreadyNotVisible = false;

        if (el.__dirty) {
          el.beforeBrush && el.beforeBrush();
          (el.brushVML || el.brush).call(el, vmlRoot);
          el.afterBrush && el.afterBrush();
        }
      }

      el.__dirty = false;
    }

    if (this._firstPaint) {
      // Detached from document at first time
      // to avoid page refreshing too many times
      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
      this._vmlViewport.appendChild(vmlRoot);

      this._firstPaint = false;
    }
  },
  resize: function (width, height) {
    var width = width == null ? this._getWidth() : width;
    var height = height == null ? this._getHeight() : height;

    if (this._width != width || this._height != height) {
      this._width = width;
      this._height = height;
      var vmlViewportStyle = this._vmlViewport.style;
      vmlViewportStyle.width = width + 'px';
      vmlViewportStyle.height = height + 'px';
    }
  },
  dispose: function () {
    this.root.innerHTML = '';
    this._vmlRoot = this._vmlViewport = this.storage = null;
  },
  getWidth: function () {
    return this._width;
  },
  getHeight: function () {
    return this._height;
  },
  clear: function () {
    if (this._vmlViewport) {
      this.root.removeChild(this._vmlViewport);
    }
  },
  _getWidth: function () {
    var root = this.root;
    var stl = root.currentStyle;
    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
  },
  _getHeight: function () {
    var root = this.root;
    var stl = root.currentStyle;
    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
  }
}; // Not supported methods

function createMethodNotSupport(method) {
  return function () {
    zrLog('In IE8.0 VML mode painter not support method "' + method + '"');
  };
} // Unsupported methods


each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
  VMLPainter.prototype[name] = createMethodNotSupport(name);
});
var _default = VMLPainter;
module.exports = _default;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(33);

var _vector = __webpack_require__(19);

var applyTransform = _vector.applyTransform;

var BoundingRect = __webpack_require__(26);

var colorTool = __webpack_require__(78);

var textContain = __webpack_require__(70);

var textHelper = __webpack_require__(214);

var RectText = __webpack_require__(698);

var Displayable = __webpack_require__(212);

var ZImage = __webpack_require__(152);

var Text = __webpack_require__(153);

var Path = __webpack_require__(34);

var PathProxy = __webpack_require__(125);

var Gradient = __webpack_require__(213);

var vmlCore = __webpack_require__(700);

// http://www.w3.org/TR/NOTE-VML
// TODO Use proxy like svg instead of overwrite brush methods
var CMD = PathProxy.CMD;
var round = Math.round;
var sqrt = Math.sqrt;
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var mathMax = Math.max;

if (!env.canvasSupported) {
  var comma = ',';
  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
  var Z = 21600;
  var Z2 = Z / 2;
  var ZLEVEL_BASE = 100000;
  var Z_BASE = 1000;

  var initRootElStyle = function (el) {
    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
    el.coordsize = Z + ',' + Z;
    el.coordorigin = '0,0';
  };

  var encodeHtmlAttribute = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  };

  var rgb2Str = function (r, g, b) {
    return 'rgb(' + [r, g, b].join(',') + ')';
  };

  var append = function (parent, child) {
    if (child && parent && child.parentNode !== parent) {
      parent.appendChild(child);
    }
  };

  var remove = function (parent, child) {
    if (child && parent && child.parentNode === parent) {
      parent.removeChild(child);
    }
  };

  var getZIndex = function (zlevel, z, z2) {
    // z 的取值范围为 [0, 1000]
    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
  };

  var parsePercent = function (value, maxValue) {
    if (typeof value === 'string') {
      if (value.lastIndexOf('%') >= 0) {
        return parseFloat(value) / 100 * maxValue;
      }

      return parseFloat(value);
    }

    return value;
  };
  /***************************************************
   * PATH
   **************************************************/


  var setColorAndOpacity = function (el, color, opacity) {
    var colorArr = colorTool.parse(color);
    opacity = +opacity;

    if (isNaN(opacity)) {
      opacity = 1;
    }

    if (colorArr) {
      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
      el.opacity = opacity * colorArr[3];
    }
  };

  var getColorAndAlpha = function (color) {
    var colorArr = colorTool.parse(color);
    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
  };

  var updateFillNode = function (el, style, zrEl) {
    // TODO pattern
    var fill = style.fill;

    if (fill != null) {
      // Modified from excanvas
      if (fill instanceof Gradient) {
        var gradientType;
        var angle = 0;
        var focus = [0, 0]; // additional offset

        var shift = 0; // scale factor for offset

        var expansion = 1;
        var rect = zrEl.getBoundingRect();
        var rectWidth = rect.width;
        var rectHeight = rect.height;

        if (fill.type === 'linear') {
          gradientType = 'gradient';
          var transform = zrEl.transform;
          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];

          if (transform) {
            applyTransform(p0, p0, transform);
            applyTransform(p1, p1, transform);
          }

          var dx = p1[0] - p0[0];
          var dy = p1[1] - p0[1];
          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.

          if (angle < 0) {
            angle += 360;
          } // Very small angles produce an unexpected result because they are
          // converted to a scientific notation string.


          if (angle < 1e-6) {
            angle = 0;
          }
        } else {
          gradientType = 'gradientradial';
          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
          var transform = zrEl.transform;
          var scale = zrEl.scale;
          var width = rectWidth;
          var height = rectHeight;
          focus = [// Percent in bounding rect
          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];

          if (transform) {
            applyTransform(p0, p0, transform);
          }

          width /= scale[0] * Z;
          height /= scale[1] * Z;
          var dimension = mathMax(width, height);
          shift = 2 * 0 / dimension;
          expansion = 2 * fill.r / dimension - shift;
        } // We need to sort the color stops in ascending order by offset,
        // otherwise IE won't interpret it correctly.


        var stops = fill.colorStops.slice();
        stops.sort(function (cs1, cs2) {
          return cs1.offset - cs2.offset;
        });
        var length = stops.length; // Color and alpha list of first and last stop

        var colorAndAlphaList = [];
        var colors = [];

        for (var i = 0; i < length; i++) {
          var stop = stops[i];
          var colorAndAlpha = getColorAndAlpha(stop.color);
          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);

          if (i === 0 || i === length - 1) {
            colorAndAlphaList.push(colorAndAlpha);
          }
        }

        if (length >= 2) {
          var color1 = colorAndAlphaList[0][0];
          var color2 = colorAndAlphaList[1][0];
          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
          el.type = gradientType;
          el.method = 'none';
          el.focus = '100%';
          el.angle = angle;
          el.color = color1;
          el.color2 = color2;
          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
          // are reversed.

          el.opacity = opacity2; // FIXME g_o_:opacity ?

          el.opacity2 = opacity1;
        }

        if (gradientType === 'radial') {
          el.focusposition = focus.join(',');
        }
      } else {
        // FIXME Change from Gradient fill to color fill
        setColorAndOpacity(el, fill, style.opacity);
      }
    }
  };

  var updateStrokeNode = function (el, style) {
    // if (style.lineJoin != null) {
    //     el.joinstyle = style.lineJoin;
    // }
    // if (style.miterLimit != null) {
    //     el.miterlimit = style.miterLimit * Z;
    // }
    // if (style.lineCap != null) {
    //     el.endcap = style.lineCap;
    // }
    if (style.lineDash != null) {
      el.dashstyle = style.lineDash.join(' ');
    }

    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
      setColorAndOpacity(el, style.stroke, style.opacity);
    }
  };

  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
    var isFill = type == 'fill';
    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth

    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error

      if (style[type] instanceof Gradient) {
        remove(vmlEl, el);
      }

      if (!el) {
        el = vmlCore.createNode(type);
      }

      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
      append(vmlEl, el);
    } else {
      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
      remove(vmlEl, el);
    }
  };

  var points = [[], [], []];

  var pathDataToString = function (path, m) {
    var M = CMD.M;
    var C = CMD.C;
    var L = CMD.L;
    var A = CMD.A;
    var Q = CMD.Q;
    var str = [];
    var nPoint;
    var cmdStr;
    var cmd;
    var i;
    var xi;
    var yi;
    var data = path.data;
    var dataLength = path.len();

    for (i = 0; i < dataLength;) {
      cmd = data[i++];
      cmdStr = '';
      nPoint = 0;

      switch (cmd) {
        case M:
          cmdStr = ' m ';
          nPoint = 1;
          xi = data[i++];
          yi = data[i++];
          points[0][0] = xi;
          points[0][1] = yi;
          break;

        case L:
          cmdStr = ' l ';
          nPoint = 1;
          xi = data[i++];
          yi = data[i++];
          points[0][0] = xi;
          points[0][1] = yi;
          break;

        case Q:
        case C:
          cmdStr = ' c ';
          nPoint = 3;
          var x1 = data[i++];
          var y1 = data[i++];
          var x2 = data[i++];
          var y2 = data[i++];
          var x3;
          var y3;

          if (cmd === Q) {
            // Convert quadratic to cubic using degree elevation
            x3 = x2;
            y3 = y2;
            x2 = (x2 + 2 * x1) / 3;
            y2 = (y2 + 2 * y1) / 3;
            x1 = (xi + 2 * x1) / 3;
            y1 = (yi + 2 * y1) / 3;
          } else {
            x3 = data[i++];
            y3 = data[i++];
          }

          points[0][0] = x1;
          points[0][1] = y1;
          points[1][0] = x2;
          points[1][1] = y2;
          points[2][0] = x3;
          points[2][1] = y3;
          xi = x3;
          yi = y3;
          break;

        case A:
          var x = 0;
          var y = 0;
          var sx = 1;
          var sy = 1;
          var angle = 0;

          if (m) {
            // Extract SRT from matrix
            x = m[4];
            y = m[5];
            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
            angle = Math.atan2(-m[1] / sy, m[0] / sx);
          }

          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++] + angle;
          var endAngle = data[i++] + startAngle + angle; // FIXME
          // var psi = data[i++];

          i++;
          var clockwise = data[i++];
          var x0 = cx + cos(startAngle) * rx;
          var y0 = cy + sin(startAngle) * ry;
          var x1 = cx + cos(endAngle) * rx;
          var y1 = cy + sin(endAngle) * ry;
          var type = clockwise ? ' wa ' : ' at ';

          if (Math.abs(x0 - x1) < 1e-4) {
            // IE won't render arches drawn counter clockwise if x0 == x1.
            if (Math.abs(endAngle - startAngle) > 1e-2) {
              // Offset x0 by 1/80 of a pixel. Use something
              // that can be represented in binary
              if (clockwise) {
                x0 += 270 / Z;
              }
            } else {
              // Avoid case draw full circle
              if (Math.abs(y0 - cy) < 1e-4) {
                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
                  y1 -= 270 / Z;
                } else {
                  y1 += 270 / Z;
                }
              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
                x1 += 270 / Z;
              } else {
                x1 -= 270 / Z;
              }
            }
          }

          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
          xi = x1;
          yi = y1;
          break;

        case CMD.R:
          var p0 = points[0];
          var p1 = points[1]; // x0, y0

          p0[0] = data[i++];
          p0[1] = data[i++]; // x1, y1

          p1[0] = p0[0] + data[i++];
          p1[1] = p0[1] + data[i++];

          if (m) {
            applyTransform(p0, p0, m);
            applyTransform(p1, p1, m);
          }

          p0[0] = round(p0[0] * Z - Z2);
          p1[0] = round(p1[0] * Z - Z2);
          p0[1] = round(p0[1] * Z - Z2);
          p1[1] = round(p1[1] * Z - Z2);
          str.push( // x0, y0
          ' m ', p0[0], comma, p0[1], // x1, y0
          ' l ', p1[0], comma, p0[1], // x1, y1
          ' l ', p1[0], comma, p1[1], // x0, y1
          ' l ', p0[0], comma, p1[1]);
          break;

        case CMD.Z:
          // FIXME Update xi, yi
          str.push(' x ');
      }

      if (nPoint > 0) {
        str.push(cmdStr);

        for (var k = 0; k < nPoint; k++) {
          var p = points[k];
          m && applyTransform(p, p, m); // 不 round 会非常慢

          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
        }
      }
    }

    return str.join('');
  }; // Rewrite the original path method


  Path.prototype.brushVML = function (vmlRoot) {
    var style = this.style;
    var vmlEl = this._vmlEl;

    if (!vmlEl) {
      vmlEl = vmlCore.createNode('shape');
      initRootElStyle(vmlEl);
      this._vmlEl = vmlEl;
    }

    updateFillAndStroke(vmlEl, 'fill', style, this);
    updateFillAndStroke(vmlEl, 'stroke', style, this);
    var m = this.transform;
    var needTransform = m != null;
    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];

    if (strokeEl) {
      var lineWidth = style.lineWidth; // Get the line scale.
      // Determinant of this.m_ means how much the area is enlarged by the
      // transformation. So its square root can be used as a scale factor
      // for width.

      if (needTransform && !style.strokeNoScale) {
        var det = m[0] * m[3] - m[1] * m[2];
        lineWidth *= sqrt(abs(det));
      }

      strokeEl.weight = lineWidth + 'px';
    }

    var path = this.path || (this.path = new PathProxy());

    if (this.__dirtyPath) {
      path.beginPath();
      this.buildPath(path, this.shape);
      path.toStatic();
      this.__dirtyPath = false;
    }

    vmlEl.path = pathDataToString(path, this.transform);
    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root

    append(vmlRoot, vmlEl); // Text

    if (style.text != null) {
      this.drawRectText(vmlRoot, this.getBoundingRect());
    } else {
      this.removeRectText(vmlRoot);
    }
  };

  Path.prototype.onRemove = function (vmlRoot) {
    remove(vmlRoot, this._vmlEl);
    this.removeRectText(vmlRoot);
  };

  Path.prototype.onAdd = function (vmlRoot) {
    append(vmlRoot, this._vmlEl);
    this.appendRectText(vmlRoot);
  };
  /***************************************************
   * IMAGE
   **************************************************/


  var isImage = function (img) {
    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
  }; // Rewrite the original path method


  ZImage.prototype.brushVML = function (vmlRoot) {
    var style = this.style;
    var image = style.image; // Image original width, height

    var ow;
    var oh;

    if (isImage(image)) {
      var src = image.src;

      if (src === this._imageSrc) {
        ow = this._imageWidth;
        oh = this._imageHeight;
      } else {
        var imageRuntimeStyle = image.runtimeStyle;
        var oldRuntimeWidth = imageRuntimeStyle.width;
        var oldRuntimeHeight = imageRuntimeStyle.height;
        imageRuntimeStyle.width = 'auto';
        imageRuntimeStyle.height = 'auto'; // get the original size

        ow = image.width;
        oh = image.height; // and remove overides

        imageRuntimeStyle.width = oldRuntimeWidth;
        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src

        this._imageSrc = src;
        this._imageWidth = ow;
        this._imageHeight = oh;
      }

      image = src;
    } else {
      if (image === this._imageSrc) {
        ow = this._imageWidth;
        oh = this._imageHeight;
      }
    }

    if (!image) {
      return;
    }

    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var sw = style.sWidth;
    var sh = style.sHeight;
    var sx = style.sx || 0;
    var sy = style.sy || 0;
    var hasCrop = sw && sh;
    var vmlEl = this._vmlEl;

    if (!vmlEl) {
      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
      // vmlEl = vmlCore.createNode('group');
      vmlEl = vmlCore.doc.createElement('div');
      initRootElStyle(vmlEl);
      this._vmlEl = vmlEl;
    }

    var vmlElStyle = vmlEl.style;
    var hasRotation = false;
    var m;
    var scaleX = 1;
    var scaleY = 1;

    if (this.transform) {
      m = this.transform;
      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
      hasRotation = m[1] || m[2];
    }

    if (hasRotation) {
      // If filters are necessary (rotation exists), create them
      // filters are bog-slow, so only create them if abbsolutely necessary
      // The following check doesn't account for skews (which don't exist
      // in the canvas spec (yet) anyway.
      // From excanvas
      var p0 = [x, y];
      var p1 = [x + dw, y];
      var p2 = [x, y + dh];
      var p3 = [x + dw, y + dh];
      applyTransform(p0, p0, m);
      applyTransform(p1, p1, m);
      applyTransform(p2, p2, m);
      applyTransform(p3, p3, m);
      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
      var transformFilter = [];
      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用

      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
    } else {
      if (m) {
        x = x * scaleX + m[4];
        y = y * scaleY + m[5];
      }

      vmlElStyle.filter = '';
      vmlElStyle.left = round(x) + 'px';
      vmlElStyle.top = round(y) + 'px';
    }

    var imageEl = this._imageEl;
    var cropEl = this._cropEl;

    if (!imageEl) {
      imageEl = vmlCore.doc.createElement('div');
      this._imageEl = imageEl;
    }

    var imageELStyle = imageEl.style;

    if (hasCrop) {
      // Needs know image original width and height
      if (!(ow && oh)) {
        var tmpImage = new Image();
        var self = this;

        tmpImage.onload = function () {
          tmpImage.onload = null;
          ow = tmpImage.width;
          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize

          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src

          self._imageWidth = ow;
          self._imageHeight = oh;
          self._imageSrc = image;
        };

        tmpImage.src = image;
      } else {
        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
      }

      if (!cropEl) {
        cropEl = vmlCore.doc.createElement('div');
        cropEl.style.overflow = 'hidden';
        this._cropEl = cropEl;
      }

      var cropElStyle = cropEl.style;
      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';

      if (!cropEl.parentNode) {
        vmlEl.appendChild(cropEl);
      }

      if (imageEl.parentNode != cropEl) {
        cropEl.appendChild(imageEl);
      }
    } else {
      imageELStyle.width = round(scaleX * dw) + 'px';
      imageELStyle.height = round(scaleY * dh) + 'px';
      vmlEl.appendChild(imageEl);

      if (cropEl && cropEl.parentNode) {
        vmlEl.removeChild(cropEl);
        this._cropEl = null;
      }
    }

    var filterStr = '';
    var alpha = style.opacity;

    if (alpha < 1) {
      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
    }

    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
    imageELStyle.filter = filterStr;
    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root

    append(vmlRoot, vmlEl); // Text

    if (style.text != null) {
      this.drawRectText(vmlRoot, this.getBoundingRect());
    }
  };

  ZImage.prototype.onRemove = function (vmlRoot) {
    remove(vmlRoot, this._vmlEl);
    this._vmlEl = null;
    this._cropEl = null;
    this._imageEl = null;
    this.removeRectText(vmlRoot);
  };

  ZImage.prototype.onAdd = function (vmlRoot) {
    append(vmlRoot, this._vmlEl);
    this.appendRectText(vmlRoot);
  };
  /***************************************************
   * TEXT
   **************************************************/


  var DEFAULT_STYLE_NORMAL = 'normal';
  var fontStyleCache = {};
  var fontStyleCacheCount = 0;
  var MAX_FONT_CACHE_SIZE = 100;
  var fontEl = document.createElement('div');

  var getFontStyle = function (fontString) {
    var fontStyle = fontStyleCache[fontString];

    if (!fontStyle) {
      // Clear cache
      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
        fontStyleCacheCount = 0;
        fontStyleCache = {};
      }

      var style = fontEl.style;
      var fontFamily;

      try {
        style.font = fontString;
        fontFamily = style.fontFamily.split(',')[0];
      } catch (e) {}

      fontStyle = {
        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
        size: parseFloat(style.fontSize || 12) | 0,
        family: fontFamily || 'Microsoft YaHei'
      };
      fontStyleCache[fontString] = fontStyle;
      fontStyleCacheCount++;
    }

    return fontStyle;
  };

  var textMeasureEl; // Overwrite measure text method

  textContain.$override('measureText', function (text, textFont) {
    var doc = vmlCore.doc;

    if (!textMeasureEl) {
      textMeasureEl = doc.createElement('div');
      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
      vmlCore.doc.body.appendChild(textMeasureEl);
    }

    try {
      textMeasureEl.style.font = textFont;
    } catch (ex) {// Ignore failures to set to invalid font.
    }

    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.

    textMeasureEl.appendChild(doc.createTextNode(text));
    return {
      width: textMeasureEl.offsetWidth
    };
  });
  var tmpRect = new BoundingRect();

  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!text) {
      return;
    } // Convert rich text to plain text. Rich text is not supported in
    // IE8-, but tags in rich text template will be removed.


    if (style.rich) {
      var contentBlock = textContain.parseRichText(text, style);
      text = [];

      for (var i = 0; i < contentBlock.lines.length; i++) {
        var tokens = contentBlock.lines[i].tokens;
        var textLine = [];

        for (var j = 0; j < tokens.length; j++) {
          textLine.push(tokens[j].text);
        }

        text.push(textLine.join(''));
      }

      text = text.join('\n');
    }

    var x;
    var y;
    var align = style.textAlign;
    var verticalAlign = style.textVerticalAlign;
    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?

    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign); // Transform rect to view space

    var m = this.transform; // Ignore transform for text in other element

    if (m && !fromTextEl) {
      tmpRect.copy(rect);
      tmpRect.applyTransform(m);
      rect = tmpRect;
    }

    if (!fromTextEl) {
      var textPosition = style.textPosition;
      var distance = style.textDistance; // Text position represented by coord

      if (textPosition instanceof Array) {
        x = rect.x + parsePercent(textPosition[0], rect.width);
        y = rect.y + parsePercent(textPosition[1], rect.height);
        align = align || 'left';
      } else {
        var res = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
        x = res.x;
        y = res.y; // Default align and baseline when has textPosition

        align = align || res.textAlign;
        verticalAlign = verticalAlign || res.textVerticalAlign;
      }
    } else {
      x = rect.x;
      y = rect.y;
    }

    x = textContain.adjustTextX(x, textRect.width, align);
    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'

    y += textRect.height / 2; // var fontSize = fontStyle.size;
    // 1.75 is an arbitrary number, as there is no info about the text baseline
    // switch (baseline) {
    // case 'hanging':
    // case 'top':
    //     y += fontSize / 1.75;
    //     break;
    //     case 'middle':
    //         break;
    //     default:
    //     // case null:
    //     // case 'alphabetic':
    //     // case 'ideographic':
    //     // case 'bottom':
    //         y -= fontSize / 2.25;
    //         break;
    // }
    // switch (align) {
    //     case 'left':
    //         break;
    //     case 'center':
    //         x -= textRect.width / 2;
    //         break;
    //     case 'right':
    //         x -= textRect.width;
    //         break;
    // case 'end':
    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
    // break;
    // case 'start':
    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
    // break;
    // default:
    //     align = 'left';
    // }

    var createNode = vmlCore.createNode;
    var textVmlEl = this._textVmlEl;
    var pathEl;
    var textPathEl;
    var skewEl;

    if (!textVmlEl) {
      textVmlEl = createNode('line');
      pathEl = createNode('path');
      textPathEl = createNode('textpath');
      skewEl = createNode('skew'); // FIXME Why here is not cammel case
      // Align 'center' seems wrong

      textPathEl.style['v-text-align'] = 'left';
      initRootElStyle(textVmlEl);
      pathEl.textpathok = true;
      textPathEl.on = true;
      textVmlEl.from = '0 0';
      textVmlEl.to = '1000 0.05';
      append(textVmlEl, skewEl);
      append(textVmlEl, pathEl);
      append(textVmlEl, textPathEl);
      this._textVmlEl = textVmlEl;
    } else {
      // 这里是在前面 appendChild 保证顺序的前提下
      skewEl = textVmlEl.firstChild;
      pathEl = skewEl.nextSibling;
      textPathEl = pathEl.nextSibling;
    }

    var coords = [x, y];
    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element

    if (m && fromTextEl) {
      applyTransform(coords, coords, m);
      skewEl.on = true;
      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position

      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin

      skewEl.origin = '0 0';
      textVmlElStyle.left = '0px';
      textVmlElStyle.top = '0px';
    } else {
      skewEl.on = false;
      textVmlElStyle.left = round(x) + 'px';
      textVmlElStyle.top = round(y) + 'px';
    }

    textPathEl.string = encodeHtmlAttribute(text); // TODO

    try {
      textPathEl.style.font = font;
    } // Error font format
    catch (e) {}

    updateFillAndStroke(textVmlEl, 'fill', {
      fill: style.textFill,
      opacity: style.opacity
    }, this);
    updateFillAndStroke(textVmlEl, 'stroke', {
      stroke: style.textStroke,
      opacity: style.opacity,
      lineDash: style.lineDash
    }, this);
    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root

    append(vmlRoot, textVmlEl);
  };

  var removeRectText = function (vmlRoot) {
    remove(vmlRoot, this._textVmlEl);
    this._textVmlEl = null;
  };

  var appendRectText = function (vmlRoot) {
    append(vmlRoot, this._textVmlEl);
  };

  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText

  for (var i = 0; i < list.length; i++) {
    var proto = list[i].prototype;
    proto.drawRectText = drawRectText;
    proto.removeRectText = removeRectText;
    proto.appendRectText = appendRectText;
  }

  Text.prototype.brushVML = function (vmlRoot) {
    var style = this.style;

    if (style.text != null) {
      this.drawRectText(vmlRoot, {
        x: style.x || 0,
        y: style.y || 0,
        width: 0,
        height: 0
      }, this.getBoundingRect(), true);
    } else {
      this.removeRectText(vmlRoot);
    }
  };

  Text.prototype.onRemove = function (vmlRoot) {
    this.removeRectText(vmlRoot);
  };

  Text.prototype.onAdd = function (vmlRoot) {
    this.appendRectText(vmlRoot);
  };
}

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1998);

var _zrender = __webpack_require__(215);

var registerPainter = _zrender.registerPainter;

var Painter = __webpack_require__(1997);

registerPainter('vml', Painter);

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[1048]);


// WEBPACK FOOTER //
// static/js/app.0f397532426602b7a02a.js